/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 370);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var core = __webpack_require__(46);
var hide = __webpack_require__(30);
var redefine = __webpack_require__(31);
var ctx = __webpack_require__(40);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(579);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(594)();
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DatePickerIOS", function() { return DatePickerIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DrawerLayoutAndroid", function() { return DrawerLayoutAndroid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImageEditor", function() { return ImageEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImageStore", function() { return ImageStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputAccessoryView", function() { return InputAccessoryView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaskedViewIOS", function() { return MaskedViewIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavigatorIOS", function() { return NavigatorIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PickerIOS", function() { return PickerIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressBarAndroid", function() { return ProgressBarAndroid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressViewIOS", function() { return ProgressViewIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SegmentedControlIOS", function() { return SegmentedControlIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SnapshotViewIOS", function() { return SnapshotViewIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TabBarIOS", function() { return TabBarIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ToastAndroid", function() { return ToastAndroid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ToolbarAndroid", function() { return ToolbarAndroid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewPagerAndroid", function() { return ViewPagerAndroid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WebView", function() { return WebView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActionSheetIOS", function() { return ActionSheetIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlertIOS", function() { return AlertIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CameraRoll", function() { return CameraRoll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DatePickerAndroid", function() { return DatePickerAndroid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImagePickerIOS", function() { return ImagePickerIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PermissionsAndroid", function() { return PermissionsAndroid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PushNotificationIOS", function() { return PushNotificationIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Settings", function() { return Settings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StatusBarIOS", function() { return StatusBarIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Systrace", function() { return Systrace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimePickerAndroid", function() { return TimePickerAndroid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TVEventHandler", function() { return TVEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VibrationIOS", function() { return VibrationIOS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports_createElement__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exports_findNodeHandle__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__exports_processColor__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__exports_render__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exports_unmountComponentAtNode__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__exports_NativeModules__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__exports_TextPropTypes__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__exports_ViewPropTypes__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__exports_AccessibilityInfo__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__exports_Alert__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__exports_Animated__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__exports_AppRegistry__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__exports_AppState__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__exports_AsyncStorage__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__exports_BackHandler__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__exports_Clipboard__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__exports_DeviceInfo__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__exports_Dimensions__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__exports_Easing__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__exports_I18nManager__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__exports_Keyboard__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__exports_InteractionManager__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__exports_LayoutAnimation__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__exports_Linking__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__exports_NativeEventEmitter__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__exports_NetInfo__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__exports_PanResponder__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__exports_PixelRatio__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__exports_Platform__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__exports_Share__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__exports_StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__exports_UIManager__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__exports_Vibration__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__exports_ActivityIndicator__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__exports_ART__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__exports_Button__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__exports_CheckBox__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__exports_FlatList__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__exports_Image__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__exports_ImageBackground__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__exports_KeyboardAvoidingView__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__exports_ListView__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__exports_Modal__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__exports_Picker__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__exports_ProgressBar__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__exports_RefreshControl__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__exports_SafeAreaView__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__exports_ScrollView__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__exports_SectionList__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__exports_Slider__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__exports_StatusBar__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__exports_SwipeableFlatList__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__exports_SwipeableListView__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__exports_Switch__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__exports_Text__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__exports_TextInput__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__exports_Touchable__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__exports_TouchableHighlight__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__exports_TouchableNativeFeedback__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__exports_TouchableOpacity__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__exports_TouchableWithoutFeedback__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__exports_View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__exports_VirtualizedList__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__exports_YellowBox__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__exports_ColorPropType__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__exports_EdgeInsetsPropType__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__exports_PointPropType__ = __webpack_require__(738);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return __WEBPACK_IMPORTED_MODULE_1__exports_createElement__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findNodeHandle", function() { return __WEBPACK_IMPORTED_MODULE_2__exports_findNodeHandle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return __WEBPACK_IMPORTED_MODULE_4__exports_render__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return __WEBPACK_IMPORTED_MODULE_5__exports_unmountComponentAtNode__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "processColor", function() { return __WEBPACK_IMPORTED_MODULE_3__exports_processColor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NativeModules", function() { return __WEBPACK_IMPORTED_MODULE_6__exports_NativeModules__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TextPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_7__exports_TextPropTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ViewPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_8__exports_ViewPropTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccessibilityInfo", function() { return __WEBPACK_IMPORTED_MODULE_9__exports_AccessibilityInfo__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return __WEBPACK_IMPORTED_MODULE_10__exports_Alert__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Animated", function() { return __WEBPACK_IMPORTED_MODULE_11__exports_Animated__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AppRegistry", function() { return __WEBPACK_IMPORTED_MODULE_12__exports_AppRegistry__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AppState", function() { return __WEBPACK_IMPORTED_MODULE_13__exports_AppState__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncStorage", function() { return __WEBPACK_IMPORTED_MODULE_14__exports_AsyncStorage__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BackHandler", function() { return __WEBPACK_IMPORTED_MODULE_15__exports_BackHandler__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Clipboard", function() { return __WEBPACK_IMPORTED_MODULE_16__exports_Clipboard__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DeviceInfo", function() { return __WEBPACK_IMPORTED_MODULE_17__exports_DeviceInfo__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Dimensions", function() { return __WEBPACK_IMPORTED_MODULE_18__exports_Dimensions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Easing", function() { return __WEBPACK_IMPORTED_MODULE_19__exports_Easing__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I18nManager", function() { return __WEBPACK_IMPORTED_MODULE_20__exports_I18nManager__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionManager", function() { return __WEBPACK_IMPORTED_MODULE_22__exports_InteractionManager__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Keyboard", function() { return __WEBPACK_IMPORTED_MODULE_21__exports_Keyboard__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LayoutAnimation", function() { return __WEBPACK_IMPORTED_MODULE_23__exports_LayoutAnimation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Linking", function() { return __WEBPACK_IMPORTED_MODULE_24__exports_Linking__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NativeEventEmitter", function() { return __WEBPACK_IMPORTED_MODULE_25__exports_NativeEventEmitter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NetInfo", function() { return __WEBPACK_IMPORTED_MODULE_26__exports_NetInfo__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PanResponder", function() { return __WEBPACK_IMPORTED_MODULE_27__exports_PanResponder__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PixelRatio", function() { return __WEBPACK_IMPORTED_MODULE_28__exports_PixelRatio__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Platform", function() { return __WEBPACK_IMPORTED_MODULE_29__exports_Platform__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Share", function() { return __WEBPACK_IMPORTED_MODULE_30__exports_Share__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StyleSheet", function() { return __WEBPACK_IMPORTED_MODULE_31__exports_StyleSheet__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UIManager", function() { return __WEBPACK_IMPORTED_MODULE_32__exports_UIManager__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Vibration", function() { return __WEBPACK_IMPORTED_MODULE_33__exports_Vibration__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ActivityIndicator", function() { return __WEBPACK_IMPORTED_MODULE_34__exports_ActivityIndicator__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ART", function() { return __WEBPACK_IMPORTED_MODULE_35__exports_ART__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_36__exports_Button__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CheckBox", function() { return __WEBPACK_IMPORTED_MODULE_37__exports_CheckBox__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FlatList", function() { return __WEBPACK_IMPORTED_MODULE_38__exports_FlatList__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return __WEBPACK_IMPORTED_MODULE_39__exports_Image__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ImageBackground", function() { return __WEBPACK_IMPORTED_MODULE_40__exports_ImageBackground__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "KeyboardAvoidingView", function() { return __WEBPACK_IMPORTED_MODULE_41__exports_KeyboardAvoidingView__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListView", function() { return __WEBPACK_IMPORTED_MODULE_42__exports_ListView__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return __WEBPACK_IMPORTED_MODULE_43__exports_Modal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Picker", function() { return __WEBPACK_IMPORTED_MODULE_44__exports_Picker__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressBar", function() { return __WEBPACK_IMPORTED_MODULE_45__exports_ProgressBar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RefreshControl", function() { return __WEBPACK_IMPORTED_MODULE_46__exports_RefreshControl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SafeAreaView", function() { return __WEBPACK_IMPORTED_MODULE_47__exports_SafeAreaView__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollView", function() { return __WEBPACK_IMPORTED_MODULE_48__exports_ScrollView__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SectionList", function() { return __WEBPACK_IMPORTED_MODULE_49__exports_SectionList__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return __WEBPACK_IMPORTED_MODULE_50__exports_Slider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StatusBar", function() { return __WEBPACK_IMPORTED_MODULE_51__exports_StatusBar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SwipeableFlatList", function() { return __WEBPACK_IMPORTED_MODULE_52__exports_SwipeableFlatList__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SwipeableListView", function() { return __WEBPACK_IMPORTED_MODULE_53__exports_SwipeableListView__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_54__exports_Switch__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Text", function() { return __WEBPACK_IMPORTED_MODULE_55__exports_Text__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TextInput", function() { return __WEBPACK_IMPORTED_MODULE_56__exports_TextInput__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touchable", function() { return __WEBPACK_IMPORTED_MODULE_57__exports_Touchable__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TouchableHighlight", function() { return __WEBPACK_IMPORTED_MODULE_58__exports_TouchableHighlight__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TouchableNativeFeedback", function() { return __WEBPACK_IMPORTED_MODULE_59__exports_TouchableNativeFeedback__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TouchableOpacity", function() { return __WEBPACK_IMPORTED_MODULE_60__exports_TouchableOpacity__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TouchableWithoutFeedback", function() { return __WEBPACK_IMPORTED_MODULE_61__exports_TouchableWithoutFeedback__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "View", function() { return __WEBPACK_IMPORTED_MODULE_62__exports_View__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VirtualizedList", function() { return __WEBPACK_IMPORTED_MODULE_63__exports_VirtualizedList__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "YellowBox", function() { return __WEBPACK_IMPORTED_MODULE_64__exports_YellowBox__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ColorPropType", function() { return __WEBPACK_IMPORTED_MODULE_65__exports_ColorPropType__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EdgeInsetsPropType", function() { return __WEBPACK_IMPORTED_MODULE_66__exports_EdgeInsetsPropType__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PointPropType", function() { return __WEBPACK_IMPORTED_MODULE_67__exports_PointPropType__["a"]; });











// APIs


























// components
































// propTypes




var emptyObject = {};
// compat (components)
var DatePickerIOS = __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */];
var DrawerLayoutAndroid = __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */];
var ImageEditor = __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */];
var ImageStore = __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */];
var InputAccessoryView = __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */];
var MaskedViewIOS = __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */];
var NavigatorIOS = __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */];
var PickerIOS = __WEBPACK_IMPORTED_MODULE_44__exports_Picker__["a" /* default */];
var ProgressBarAndroid = __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */];
var ProgressViewIOS = __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */];
var SegmentedControlIOS = __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */];
var SnapshotViewIOS = __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */];
var TabBarIOS = __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */];
var ToastAndroid = __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */];
var ToolbarAndroid = __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */];
var ViewPagerAndroid = __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */];
var WebView = __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */];
// compat (apis)
var ActionSheetIOS = emptyObject;
var AlertIOS = emptyObject;
var CameraRoll = emptyObject;
var DatePickerAndroid = emptyObject;
var ImagePickerIOS = emptyObject;
var PermissionsAndroid = emptyObject;
var PushNotificationIOS = emptyObject;
var Settings = emptyObject;
var StatusBarIOS = emptyObject;
var Systrace = emptyObject;
var TimePickerAndroid = emptyObject;
var TVEventHandler = emptyObject;
var VibrationIOS = emptyObject;



var ReactNative = {
  // top-level API
  createElement: __WEBPACK_IMPORTED_MODULE_1__exports_createElement__["a" /* default */],
  findNodeHandle: __WEBPACK_IMPORTED_MODULE_2__exports_findNodeHandle__["a" /* default */],
  render: __WEBPACK_IMPORTED_MODULE_4__exports_render__["a" /* default */],
  unmountComponentAtNode: __WEBPACK_IMPORTED_MODULE_5__exports_unmountComponentAtNode__["a" /* default */],
  // modules
  processColor: __WEBPACK_IMPORTED_MODULE_3__exports_processColor__["a" /* default */],
  NativeModules: __WEBPACK_IMPORTED_MODULE_6__exports_NativeModules__["a" /* default */],
  TextPropTypes: __WEBPACK_IMPORTED_MODULE_7__exports_TextPropTypes__["a" /* default */],
  ViewPropTypes: __WEBPACK_IMPORTED_MODULE_8__exports_ViewPropTypes__["a" /* default */],
  // APIs
  AccessibilityInfo: __WEBPACK_IMPORTED_MODULE_9__exports_AccessibilityInfo__["a" /* default */],
  Alert: __WEBPACK_IMPORTED_MODULE_10__exports_Alert__["a" /* default */],
  Animated: __WEBPACK_IMPORTED_MODULE_11__exports_Animated__["a" /* default */],
  AppRegistry: __WEBPACK_IMPORTED_MODULE_12__exports_AppRegistry__["a" /* default */],
  AppState: __WEBPACK_IMPORTED_MODULE_13__exports_AppState__["a" /* default */],
  AsyncStorage: __WEBPACK_IMPORTED_MODULE_14__exports_AsyncStorage__["a" /* default */],
  BackHandler: __WEBPACK_IMPORTED_MODULE_15__exports_BackHandler__["a" /* default */],
  Clipboard: __WEBPACK_IMPORTED_MODULE_16__exports_Clipboard__["a" /* default */],
  DeviceInfo: __WEBPACK_IMPORTED_MODULE_17__exports_DeviceInfo__["a" /* default */],
  Dimensions: __WEBPACK_IMPORTED_MODULE_18__exports_Dimensions__["a" /* default */],
  Easing: __WEBPACK_IMPORTED_MODULE_19__exports_Easing__["a" /* default */],
  I18nManager: __WEBPACK_IMPORTED_MODULE_20__exports_I18nManager__["a" /* default */],
  InteractionManager: __WEBPACK_IMPORTED_MODULE_22__exports_InteractionManager__["a" /* default */],
  Keyboard: __WEBPACK_IMPORTED_MODULE_21__exports_Keyboard__["a" /* default */],
  LayoutAnimation: __WEBPACK_IMPORTED_MODULE_23__exports_LayoutAnimation__["a" /* default */],
  Linking: __WEBPACK_IMPORTED_MODULE_24__exports_Linking__["a" /* default */],
  NativeEventEmitter: __WEBPACK_IMPORTED_MODULE_25__exports_NativeEventEmitter__["a" /* default */],
  NetInfo: __WEBPACK_IMPORTED_MODULE_26__exports_NetInfo__["a" /* default */],
  PanResponder: __WEBPACK_IMPORTED_MODULE_27__exports_PanResponder__["a" /* default */],
  PixelRatio: __WEBPACK_IMPORTED_MODULE_28__exports_PixelRatio__["a" /* default */],
  Platform: __WEBPACK_IMPORTED_MODULE_29__exports_Platform__["a" /* default */],
  Share: __WEBPACK_IMPORTED_MODULE_30__exports_Share__["a" /* default */],
  StyleSheet: __WEBPACK_IMPORTED_MODULE_31__exports_StyleSheet__["a" /* default */],
  UIManager: __WEBPACK_IMPORTED_MODULE_32__exports_UIManager__["a" /* default */],
  Vibration: __WEBPACK_IMPORTED_MODULE_33__exports_Vibration__["a" /* default */],
  // components
  ActivityIndicator: __WEBPACK_IMPORTED_MODULE_34__exports_ActivityIndicator__["a" /* default */],
  ART: __WEBPACK_IMPORTED_MODULE_35__exports_ART__["a" /* default */],
  Button: __WEBPACK_IMPORTED_MODULE_36__exports_Button__["a" /* default */],
  CheckBox: __WEBPACK_IMPORTED_MODULE_37__exports_CheckBox__["a" /* default */],
  FlatList: __WEBPACK_IMPORTED_MODULE_38__exports_FlatList__["a" /* default */],
  Image: __WEBPACK_IMPORTED_MODULE_39__exports_Image__["a" /* default */],
  ImageBackground: __WEBPACK_IMPORTED_MODULE_40__exports_ImageBackground__["a" /* default */],
  KeyboardAvoidingView: __WEBPACK_IMPORTED_MODULE_41__exports_KeyboardAvoidingView__["a" /* default */],
  ListView: __WEBPACK_IMPORTED_MODULE_42__exports_ListView__["a" /* default */],
  Modal: __WEBPACK_IMPORTED_MODULE_43__exports_Modal__["a" /* default */],
  Picker: __WEBPACK_IMPORTED_MODULE_44__exports_Picker__["a" /* default */],
  ProgressBar: __WEBPACK_IMPORTED_MODULE_45__exports_ProgressBar__["a" /* default */],
  RefreshControl: __WEBPACK_IMPORTED_MODULE_46__exports_RefreshControl__["a" /* default */],
  SafeAreaView: __WEBPACK_IMPORTED_MODULE_47__exports_SafeAreaView__["a" /* default */],
  ScrollView: __WEBPACK_IMPORTED_MODULE_48__exports_ScrollView__["a" /* default */],
  SectionList: __WEBPACK_IMPORTED_MODULE_49__exports_SectionList__["a" /* default */],
  Slider: __WEBPACK_IMPORTED_MODULE_50__exports_Slider__["a" /* default */],
  StatusBar: __WEBPACK_IMPORTED_MODULE_51__exports_StatusBar__["a" /* default */],
  SwipeableFlatList: __WEBPACK_IMPORTED_MODULE_52__exports_SwipeableFlatList__["a" /* default */],
  SwipeableListView: __WEBPACK_IMPORTED_MODULE_53__exports_SwipeableListView__["a" /* default */],
  Switch: __WEBPACK_IMPORTED_MODULE_54__exports_Switch__["a" /* default */],
  Text: __WEBPACK_IMPORTED_MODULE_55__exports_Text__["a" /* default */],
  TextInput: __WEBPACK_IMPORTED_MODULE_56__exports_TextInput__["a" /* default */],
  Touchable: __WEBPACK_IMPORTED_MODULE_57__exports_Touchable__["a" /* default */],
  TouchableHighlight: __WEBPACK_IMPORTED_MODULE_58__exports_TouchableHighlight__["a" /* default */],
  TouchableNativeFeedback: __WEBPACK_IMPORTED_MODULE_59__exports_TouchableNativeFeedback__["a" /* default */],
  TouchableOpacity: __WEBPACK_IMPORTED_MODULE_60__exports_TouchableOpacity__["a" /* default */],
  TouchableWithoutFeedback: __WEBPACK_IMPORTED_MODULE_61__exports_TouchableWithoutFeedback__["a" /* default */],
  View: __WEBPACK_IMPORTED_MODULE_62__exports_View__["a" /* default */],
  VirtualizedList: __WEBPACK_IMPORTED_MODULE_63__exports_VirtualizedList__["a" /* default */],
  YellowBox: __WEBPACK_IMPORTED_MODULE_64__exports_YellowBox__["a" /* default */],
  // propTypes
  ColorPropType: __WEBPACK_IMPORTED_MODULE_65__exports_ColorPropType__["a" /* default */],
  EdgeInsetsPropType: __WEBPACK_IMPORTED_MODULE_66__exports_EdgeInsetsPropType__["a" /* default */],
  PointPropType: __WEBPACK_IMPORTED_MODULE_67__exports_PointPropType__["a" /* default */],
  // compat (components)
  DatePickerIOS: DatePickerIOS,
  DrawerLayoutAndroid: DrawerLayoutAndroid,
  ImageEditor: ImageEditor,
  ImageStore: ImageStore,
  InputAccessoryView: InputAccessoryView,
  MaskedViewIOS: MaskedViewIOS,
  NavigatorIOS: NavigatorIOS,
  PickerIOS: PickerIOS,
  ProgressBarAndroid: ProgressBarAndroid,
  ProgressViewIOS: ProgressViewIOS,
  SegmentedControlIOS: SegmentedControlIOS,
  SnapshotViewIOS: SnapshotViewIOS,
  TabBarIOS: TabBarIOS,
  ToastAndroid: ToastAndroid,
  ToolbarAndroid: ToolbarAndroid,
  ViewPagerAndroid: ViewPagerAndroid,
  WebView: WebView,
  // compat (apis)
  ActionSheetIOS: ActionSheetIOS,
  AlertIOS: AlertIOS,
  CameraRoll: CameraRoll,
  DatePickerAndroid: DatePickerAndroid,
  ImagePickerIOS: ImagePickerIOS,
  PermissionsAndroid: PermissionsAndroid,
  PushNotificationIOS: PushNotificationIOS,
  Settings: Settings,
  StatusBarIOS: StatusBarIOS,
  Systrace: Systrace,
  TimePickerAndroid: TimePickerAndroid,
  TVEventHandler: TVEventHandler,
  VibrationIOS: VibrationIOS
};

/* harmony default export */ __webpack_exports__["default"] = (ReactNative);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.5';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Gets the value at `key`, unless `key` is "__proto__".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function safeGet(object, key) {
    return key == '__proto__'
      ? undefined
      : object[key];
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(96)(module)))

/***/ }),
/* 10 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(113)('wks');
var uid = __webpack_require__(68);
var Symbol = __webpack_require__(6).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyleSheet__ = __webpack_require__(592);



// allow component styles to be editable in React Dev Tools
if (false) {
  if (canUseDOM && window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__.resolveRNStyle = StyleSheet.flatten;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__StyleSheet__["a" /* default */]);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_applyLayout__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_applyNativeMethods__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createElement__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filterSupportedProps__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_fbjs_lib_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ViewPropTypes__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * 
 */











var calculateHitSlopStyle = function calculateHitSlopStyle(hitSlop) {
  var hitStyle = {};
  for (var prop in hitSlop) {
    if (hitSlop.hasOwnProperty(prop)) {
      var value = hitSlop[prop];
      hitStyle[prop] = value > 0 ? -1 * value : 0;
    }
  }
  return hitStyle;
};

var View = function (_Component) {
  _inherits(View, _Component);

  function View() {
    _classCallCheck(this, View);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  View.prototype.render = function render() {
    var hitSlop = this.props.hitSlop;
    var supportedProps = Object(__WEBPACK_IMPORTED_MODULE_4__filterSupportedProps__["a" /* default */])(this.props);

    if (false) {
      React.Children.toArray(this.props.children).forEach(function (item) {
        invariant(typeof item !== 'string', 'Unexpected text node: ' + item + '. A text node cannot be a child of a <View>.');
      });
    }

    var isInAParentText = this.context.isInAParentText;


    supportedProps.style = __WEBPACK_IMPORTED_MODULE_6__StyleSheet__["a" /* default */].compose(styles.initial, __WEBPACK_IMPORTED_MODULE_6__StyleSheet__["a" /* default */].compose(isInAParentText && styles.inline, this.props.style));

    if (hitSlop) {
      var hitSlopStyle = calculateHitSlopStyle(hitSlop);
      var hitSlopChild = Object(__WEBPACK_IMPORTED_MODULE_3__createElement__["a" /* default */])('span', { style: [styles.hitSlop, hitSlopStyle] });
      supportedProps.children = __WEBPACK_IMPORTED_MODULE_8_react___default.a.Children.toArray([hitSlopChild, supportedProps.children]);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_3__createElement__["a" /* default */])('div', supportedProps);
  };

  return View;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

View.displayName = 'View';
View.contextTypes = {
  isInAParentText: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"]
};
View.propTypes =  false ? ViewPropTypes : {};


var styles = __WEBPACK_IMPORTED_MODULE_6__StyleSheet__["a" /* default */].create({
  // https://github.com/facebook/css-layout#default-values
  initial: {
    alignItems: 'stretch',
    borderWidth: 0,
    borderStyle: 'solid',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: 0,
    position: 'relative',
    zIndex: 0,
    // fix flexbox bugs
    minHeight: 0,
    minWidth: 0
  },
  inline: {
    display: 'inline-flex'
  },
  // this zIndex-ordering positions the hitSlop above the View but behind
  // its children
  hitSlop: Object.assign({}, __WEBPACK_IMPORTED_MODULE_6__StyleSheet__["a" /* default */].absoluteFillObject, {
    zIndex: -1
  })
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__modules_applyLayout__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__modules_applyNativeMethods__["a" /* default */])(View)));

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function(mixins){
	var proto = {};
	for (var i = 0, l = arguments.length; i < l; i++){
		var mixin = arguments[i];
		if (typeof mixin == 'function') mixin = mixin.prototype;
		for (var key in mixin) proto[key] = mixin[key];
	}
	if (!proto.initialize) proto.initialize = function(){};
	proto.constructor = function(a,b,c,d,e,f,g,h){
		return new proto.initialize(a,b,c,d,e,f,g,h);
	};
	proto.constructor.prototype = proto.initialize.prototype = proto;
	return proto.constructor;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(7)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(5);
var IE8_DOM_DEFINE = __webpack_require__(226);
var toPrimitive = __webpack_require__(47);
var dP = Object.defineProperty;

exports.f = __webpack_require__(15) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(49);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_this=this;var _reactNative=__webpack_require__(3);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);
var _axios=__webpack_require__(942);var _axios2=_interopRequireDefault(_axios);
var _querystring=__webpack_require__(962);var _querystring2=_interopRequireDefault(_querystring);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var

APIClient=(_temp=_class=function(){function APIClient(){_classCallCheck(this,APIClient);}_createClass(APIClient,null,[{key:'updateCredential',value:function updateCredential(



















credential){
if(APIClient.credential==credential){
return;
}


APIClient.credential=credential;
}}]);return APIClient;}(),_class.generateBaseURL=function(){return global.__APP_MODE__==='local'?_reactNative.Platform.OS==='android'?'http://10.0.2.2:5001':'http://localhost:5001':global.__APP_MODE__==='dev'?_reactNative.Platform.OS==='web'?'https://magicud-app-api-kidsup.herokuapp.com':'http://dev.api.kidsup.net':'https://api.kidsup.net';},_class.






updateToken=function(token){
APIClient.token=token;
},_class.






parseErrorMessage=function(_ref)


{var error=_ref.error,defaultMessage=_ref.defaultMessage;
if(!_lodash2.default.isNil(error)&&
!_lodash2.default.isNil(error.response)&&
!_lodash2.default.isNil(error.response.data)&&
!_lodash2.default.isNil(error.response.data.error)&&
!_lodash2.default.isNil(error.response.data.error.message)){
return error.response.data.error.message;
}
return defaultMessage;
},_class.

GET=function _callee(path,params,cancelToken){return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return regeneratorRuntime.awrap(
APIClient.request('GET',path,null,params,null,
cancelToken));case 2:return _context.abrupt('return',_context.sent);case 3:case'end':return _context.stop();}}},null,_this);},_class.


POST=function _callee2(path,data,cancelToken){return regeneratorRuntime.async(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return regeneratorRuntime.awrap(
APIClient.request('POST',path,null,null,data,cancelToken));case 2:return _context2.abrupt('return',_context2.sent);case 3:case'end':return _context2.stop();}}},null,_this);},_class.


PUT=function _callee3(path,data,cancelToken){return regeneratorRuntime.async(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return regeneratorRuntime.awrap(
APIClient.request('PUT',path,null,null,data,cancelToken));case 2:return _context3.abrupt('return',_context3.sent);case 3:case'end':return _context3.stop();}}},null,_this);},_class.


DELETE=function _callee4(path,data,cancelToken){return regeneratorRuntime.async(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return regeneratorRuntime.awrap(
APIClient.request('DELETE',path,null,null,data,
cancelToken));case 2:return _context4.abrupt('return',_context4.sent);case 3:case'end':return _context4.stop();}}},null,_this);},_class.


paramsPOST=function _callee5(path,params,data,cancelToken){return regeneratorRuntime.async(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return regeneratorRuntime.awrap(
APIClient.request('POST',path,null,params,data,
cancelToken));case 2:return _context5.abrupt('return',_context5.sent);case 3:case'end':return _context5.stop();}}},null,_this);},_class.


jsonPOST=function _callee6(path,data,cancelToken){var headers;return regeneratorRuntime.async(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:
headers={
'Content-Type':'application/json;charset=UTF-8'};_context6.next=3;return regeneratorRuntime.awrap(

APIClient.request('post',path,headers,null,data,
cancelToken));case 3:return _context6.abrupt('return',_context6.sent);case 4:case'end':return _context6.stop();}}},null,_this);},_class.


jsonPUT=function _callee7(path,data,cancelToken){var headers;return regeneratorRuntime.async(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:
headers={
'Content-Type':'application/json;charset=UTF-8'};_context7.next=3;return regeneratorRuntime.awrap(

APIClient.request('put',path,headers,null,data,
cancelToken));case 3:return _context7.abrupt('return',_context7.sent);case 4:case'end':return _context7.stop();}}},null,_this);},_class.


request=function _callee8(method,path,headers,params,data,cancelToken){var baseURL,url,contentType,rawResponse,response;return regeneratorRuntime.async(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.prev=0;

baseURL=APIClient.generateBaseURL();
url=baseURL+path;
if(_lodash2.default.isNil(params)){
params={};
}

if(_lodash2.default.isNil(headers)){
headers={};
}
headers['Accept']='application/json';
if(!_lodash2.default.isEmpty(_this._token)&&_lodash2.default.isNil(headers['Authorization'])){
headers['Authorization']=_this._token;
}
if(method==='GET'){
}else if(!_lodash2.default.isNil(data)){
if(data instanceof FormData){
headers['Content-Type']='multipart/form-data';
}else{
contentType=headers['Content-Type'];
if(contentType==='application/json;charset=UTF-8'){

}else{

headers['Content-Type']='application/x-www-form-urlencoded;charset=UTF-8';
data=_querystring2.default.stringify(data);
}
}
}
if(false){
console.log('method: '+method);
console.log('headers: '+JSON.stringify(headers));
console.log('auth: ',JSON.stringify(APIClient.credential));
console.log('path: '+path);
console.log('url: '+url);
console.log('params: '+JSON.stringify(params));
console.log('data: '+data);
console.log('cancel token: '+(cancelToken?'not null':'null'));
}_context8.next=11;return regeneratorRuntime.awrap(
(0,_axios2.default)({
url:url,
method:method,
headers:headers,
auth:APIClient.credential,
params:params,
data:data,
cancelToken:cancelToken}));case 11:rawResponse=_context8.sent;

if(false){
console.log('request url: ',rawResponse.request._url);
}
response=rawResponse.data;return _context8.abrupt('return',
{
response:response});case 17:_context8.prev=17;_context8.t0=_context8['catch'](0);return _context8.abrupt('return',





{
error:_context8.t0});case 20:case'end':return _context8.stop();}}},null,_this,[[0,17]]);},_temp);exports.default=APIClient;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var _reactNative=__webpack_require__(3);
var _reactModal=__webpack_require__(763);var _reactModal2=_interopRequireDefault(_reactModal);
var _Entypo=__webpack_require__(770);var _Entypo2=_interopRequireDefault(_Entypo);
var _EvilIcons=__webpack_require__(877);var _EvilIcons2=_interopRequireDefault(_EvilIcons);
var _Feather=__webpack_require__(879);var _Feather2=_interopRequireDefault(_Feather);
var _FontAwesome=__webpack_require__(881);var _FontAwesome2=_interopRequireDefault(_FontAwesome);
var _Foundation=__webpack_require__(883);var _Foundation2=_interopRequireDefault(_Foundation);
var _Ionicons=__webpack_require__(885);var _Ionicons2=_interopRequireDefault(_Ionicons);
var _MaterialCommunityIcons=__webpack_require__(887);var _MaterialCommunityIcons2=_interopRequireDefault(_MaterialCommunityIcons);

var _MaterialIcons=__webpack_require__(889);var _MaterialIcons2=_interopRequireDefault(_MaterialIcons);
var _Octicons=__webpack_require__(891);var _Octicons2=_interopRequireDefault(_Octicons);
var _SimpleLineIcons=__webpack_require__(893);var _SimpleLineIcons2=_interopRequireDefault(_SimpleLineIcons);

var _Zocial=__webpack_require__(895);var _Zocial2=_interopRequireDefault(_Zocial);

var _FlatList=__webpack_require__(897);var _FlatList2=_interopRequireDefault(_FlatList);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

module.exports={
KeyboardAwareScrollView:_reactNative.ScrollView,
NavigationActions:{},
EntypoIcon:_Entypo2.default,
EvilIconsIcon:_EvilIcons2.default,
FeatherIcon:_Feather2.default,
FontAwesomeIcon:_FontAwesome2.default,
FoundationIcon:_Foundation2.default,
IoniconsIcon:_Ionicons2.default,
MaterialCommunityIconsIcon:_MaterialCommunityIcons2.default,
MaterialIconsIcon:_MaterialIcons2.default,
OcticonsIcon:_Octicons2.default,
SimpleLineIconsIcon:_SimpleLineIcons2.default,
ZocialIcon:_Zocial2.default,
Modal:_reactModal2.default,
FlatList:_FlatList2.default,
Keyboard:{},
codePush:{},
Toast:{},
ToastDuration:{}};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/btn.cfe223ed.png";

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(48);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _base=__webpack_require__(937);var _base2=_interopRequireDefault(_base);
var _numeral=__webpack_require__(938);var _numeral2=_interopRequireDefault(_numeral);
var _moment=__webpack_require__(360);var _moment2=_interopRequireDefault(_moment);
__webpack_require__(939);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);
var _emailValidator=__webpack_require__(940);var _emailValidator2=_interopRequireDefault(_emailValidator);
var _googleLibphonenumber=__webpack_require__(941);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}

_moment2.default.locale('vi');var

Utils=(_temp=_class=function(){function Utils(){_classCallCheck(this,Utils);}_createClass(Utils,null,[{key:'isEmailValid',value:function isEmailValid(
email){
return _emailValidator2.default.validate(email);
}},{key:'isPhoneValid',value:function isPhoneValid(

phone){
var phoneUtil=_googleLibphonenumber.PhoneNumberUtil.getInstance();
var phoneValid=false;
try{
var phoneNumber=phoneUtil.parse(phone,'VN');
phoneValid=phoneUtil.isValidNumber(phoneNumber);
}catch(error){
phoneValid=false;
}
return phoneValid;
}},{key:'createHeaders',value:function createHeaders()

{
var headers={
'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'};

return headers;
}},{key:'createBasicAuthHeaders',value:function createBasicAuthHeaders(

credential){
if(_lodash2.default.isEmpty(credential)){
return Utils.createHeaders();
}var

username=credential.username,password=credential.password;
if(_lodash2.default.isEmpty(username)||_lodash2.default.isEmpty(password)){
return Utils.createHeaders();
}

var credentialString=credential.username+':'+credential.password;
var headers={
'Authorization':'Basic '+_base2.default.encode(credentialString),
'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'};

return headers;
}},{key:'createBodyParams',value:function createBodyParams(

params){
return Object.keys(params).map(function(key){
return encodeURIComponent(key)+'='+encodeURIComponent(params[key]);
}).join('&');
}},{key:'priceToString',value:function priceToString(

price,currency){
if(typeof price!=='number'&&typeof price!=='string'){
return price;
}

if(!currency){
currency='đ';
}

if(typeof price==='string'){
if(price.indexOf(currency)!==-1){
return price;
}
return price+currency;
}

return(0,_numeral2.default)(price).format('0,0')+currency;
}},{key:'parseSuccessMessage',value:function parseSuccessMessage(




response,defaultMessage){
if(response&&response.response){
return response.response.message;
}
return defaultMessage;
}},{key:'parseErrorMessage',value:function parseErrorMessage(




response,error,defaultMessage){
if(error){
return error.message;
}
if(response&&response.error){
return response.error.message;
}
return defaultMessage;
}}]);return Utils;}(),_class.

dateToString=function(date){var format=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'Do MMMM YYYY, h:mm:ss a';
return(0,_moment2.default)(date).format(format);
},_temp);exports.default=Utils;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_normalizeColor__ = __webpack_require__(173);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */



var colorPropType = function colorPropType(isRequired, props, propName, componentName, location, propFullName) {
  var color = props[propName];
  if (color === undefined || color === null) {
    if (isRequired) {
      return new Error('Required ' + location + ' `' + (propFullName || propName) + '` was not specified in `' + componentName + '`.');
    }
    return;
  }

  if (typeof color === 'number') {
    // Developers should not use a number, but we are using the prop type
    // both for user provided colors and for transformed ones. This isn't ideal
    // and should be fixed but will do for now...
    return;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__modules_normalizeColor__["a" /* default */])(color) === null) {
    return new Error('Invalid ' + location + ' `' + (propFullName || propName) + '` supplied to `' + componentName + '`: ' + color + '\n' + 'Valid color formats are\n  - \'#f0f\' (#rgb)\n  - \'#f0fc\' (#rgba)\n  - \'#ff00ff\' (#rrggbb)\n  - \'#ff00ff00\' (#rrggbbaa)\n  - \'rgb(255, 255, 255)\'\n  - \'rgba(255, 255, 255, 1.0)\'\n  - \'hsl(360, 100%, 100%)\'\n  - \'hsla(360, 100%, 100%, 1.0)\'\n  - \'transparent\'\n  - \'red\'\n  - 0xff00ff00 (0xrrggbbaa)\n');
  }
};

var ColorPropType = void 0;

if (false) {
  ColorPropType = colorPropType.bind(null, false /* isRequired */);
  ColorPropType.isRequired = colorPropType.bind(null, true /* isRequired */);
} else {
  ColorPropType = function ColorPropType() {};
}

/* harmony default export */ __webpack_exports__["a"] = (ColorPropType);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__View_ViewPropTypes__ = __webpack_require__(286);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__View_ViewPropTypes__["a" /* default */]);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(741);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 29 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16);
var createDesc = __webpack_require__(67);
module.exports = __webpack_require__(15) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var hide = __webpack_require__(30);
var has = __webpack_require__(29);
var SRC = __webpack_require__(68)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(46).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(7);
var defined = __webpack_require__(48);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NativeAnimatedHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_invariant__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





// Note(vjeux): this would be better as an interface but flow doesn't
// support them yet

var AnimatedNode = function () {
  function AnimatedNode() {
    _classCallCheck(this, AnimatedNode);
  }

  AnimatedNode.prototype.__attach = function __attach() {};

  AnimatedNode.prototype.__detach = function __detach() {
    if (this.__isNative && this.__nativeTag != null) {
      __WEBPACK_IMPORTED_MODULE_0__NativeAnimatedHelper__["a" /* default */].API.dropAnimatedNode(this.__nativeTag);
      this.__nativeTag = undefined;
    }
  };

  AnimatedNode.prototype.__getValue = function __getValue() {};

  AnimatedNode.prototype.__getAnimatedValue = function __getAnimatedValue() {
    return this.__getValue();
  };

  AnimatedNode.prototype.__addChild = function __addChild(child) {};

  AnimatedNode.prototype.__removeChild = function __removeChild(child) {};

  AnimatedNode.prototype.__getChildren = function __getChildren() {
    return [];
  };

  /* Methods and props used by native Animated impl */


  AnimatedNode.prototype.__makeNative = function __makeNative() {
    if (!this.__isNative) {
      throw new Error('This node cannot be made a "native" animated node');
    }
  };

  AnimatedNode.prototype.__getNativeTag = function __getNativeTag() {
    __WEBPACK_IMPORTED_MODULE_0__NativeAnimatedHelper__["a" /* default */].assertNativeAnimatedModule();
    __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_invariant___default()(this.__isNative, 'Attempt to get native tag from node not marked as "native"');
    if (this.__nativeTag == null) {
      var nativeTag = __WEBPACK_IMPORTED_MODULE_0__NativeAnimatedHelper__["a" /* default */].generateNewNodeTag();
      __WEBPACK_IMPORTED_MODULE_0__NativeAnimatedHelper__["a" /* default */].API.createAnimatedNode(nativeTag, this.__getNativeConfig());
      this.__nativeTag = nativeTag;
    }
    return this.__nativeTag;
  };

  AnimatedNode.prototype.__getNativeConfig = function __getNativeConfig() {
    throw new Error('This JS animated node type cannot be used as native animated node');
  };

  AnimatedNode.prototype.toJSON = function toJSON() {
    return this.__getValue();
  };

  return AnimatedNode;
}();

/* harmony default export */ __webpack_exports__["a"] = (AnimatedNode);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API */
/* unused harmony export addWhitelistedStyleProp */
/* unused harmony export addWhitelistedTransformProp */
/* unused harmony export addWhitelistedInterpolationParam */
/* unused harmony export validateStyles */
/* unused harmony export validateTransform */
/* unused harmony export validateInterpolation */
/* unused harmony export generateNewNodeTag */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateNewAnimationId; });
/* unused harmony export assertNativeAnimatedModule */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return shouldUseNativeDriver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports_NativeModules__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NativeEventEmitter__ = __webpack_require__(290);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */






var NativeAnimatedModule = __WEBPACK_IMPORTED_MODULE_1__exports_NativeModules__["a" /* default */].NativeAnimatedModule;

var __nativeAnimatedNodeTagCount = 1; /* used for animated nodes */
var __nativeAnimationIdCount = 1; /* used for started animations */

var nativeEventEmitter = void 0;

/**
 * Simple wrappers around NativeAnimatedModule to provide flow and autocmplete support for
 * the native module methods
 */
var API = {
  createAnimatedNode: function createAnimatedNode(tag, config) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.createAnimatedNode(tag, config);
  },
  startListeningToAnimatedNodeValue: function startListeningToAnimatedNodeValue(tag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.startListeningToAnimatedNodeValue(tag);
  },
  stopListeningToAnimatedNodeValue: function stopListeningToAnimatedNodeValue(tag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.stopListeningToAnimatedNodeValue(tag);
  },
  connectAnimatedNodes: function connectAnimatedNodes(parentTag, childTag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.connectAnimatedNodes(parentTag, childTag);
  },
  disconnectAnimatedNodes: function disconnectAnimatedNodes(parentTag, childTag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.disconnectAnimatedNodes(parentTag, childTag);
  },
  startAnimatingNode: function startAnimatingNode(animationId, nodeTag, config, endCallback) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.startAnimatingNode(animationId, nodeTag, config, endCallback);
  },
  stopAnimation: function stopAnimation(animationId) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.stopAnimation(animationId);
  },
  setAnimatedNodeValue: function setAnimatedNodeValue(nodeTag, value) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.setAnimatedNodeValue(nodeTag, value);
  },
  setAnimatedNodeOffset: function setAnimatedNodeOffset(nodeTag, offset) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.setAnimatedNodeOffset(nodeTag, offset);
  },
  flattenAnimatedNodeOffset: function flattenAnimatedNodeOffset(nodeTag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.flattenAnimatedNodeOffset(nodeTag);
  },
  extractAnimatedNodeOffset: function extractAnimatedNodeOffset(nodeTag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.extractAnimatedNodeOffset(nodeTag);
  },
  connectAnimatedNodeToView: function connectAnimatedNodeToView(nodeTag, viewTag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.connectAnimatedNodeToView(nodeTag, viewTag);
  },
  disconnectAnimatedNodeFromView: function disconnectAnimatedNodeFromView(nodeTag, viewTag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.disconnectAnimatedNodeFromView(nodeTag, viewTag);
  },
  dropAnimatedNode: function dropAnimatedNode(tag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.dropAnimatedNode(tag);
  },
  addAnimatedEventToView: function addAnimatedEventToView(viewTag, eventName, eventMapping) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.addAnimatedEventToView(viewTag, eventName, eventMapping);
  },
  removeAnimatedEventFromView: function removeAnimatedEventFromView(viewTag, eventName, animatedNodeTag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.removeAnimatedEventFromView(viewTag, eventName, animatedNodeTag);
  }
};

/**
 * Styles allowed by the native animated implementation.
 *
 * In general native animated implementation should support any numeric property that doesn't need
 * to be updated through the shadow view hierarchy (all non-layout properties).
 */
var STYLES_WHITELIST = {
  opacity: true,
  transform: true,
  /* ios styles */
  shadowOpacity: true,
  shadowRadius: true,
  /* legacy android transform properties */
  scaleX: true,
  scaleY: true,
  translateX: true,
  translateY: true
};

var TRANSFORM_WHITELIST = {
  translateX: true,
  translateY: true,
  scale: true,
  scaleX: true,
  scaleY: true,
  rotate: true,
  rotateX: true,
  rotateY: true,
  perspective: true
};

var SUPPORTED_INTERPOLATION_PARAMS = {
  inputRange: true,
  outputRange: true,
  extrapolate: true,
  extrapolateRight: true,
  extrapolateLeft: true
};

function addWhitelistedStyleProp(prop) {
  STYLES_WHITELIST[prop] = true;
}

function addWhitelistedTransformProp(prop) {
  TRANSFORM_WHITELIST[prop] = true;
}

function addWhitelistedInterpolationParam(param) {
  SUPPORTED_INTERPOLATION_PARAMS[param] = true;
}

function validateTransform(configs) {
  configs.forEach(function (config) {
    if (!TRANSFORM_WHITELIST.hasOwnProperty(config.property)) {
      throw new Error('Property \'' + config.property + '\' is not supported by native animated module');
    }
  });
}

function validateStyles(styles) {
  for (var key in styles) {
    if (!STYLES_WHITELIST.hasOwnProperty(key)) {
      throw new Error('Style property \'' + key + '\' is not supported by native animated module');
    }
  }
}

function validateInterpolation(config) {
  for (var key in config) {
    if (!SUPPORTED_INTERPOLATION_PARAMS.hasOwnProperty(key)) {
      throw new Error('Interpolation property \'' + key + '\' is not supported by native animated module');
    }
  }
}

function generateNewNodeTag() {
  return __nativeAnimatedNodeTagCount++;
}

function generateNewAnimationId() {
  return __nativeAnimationIdCount++;
}

function assertNativeAnimatedModule() {
  __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(NativeAnimatedModule, 'Native animated module is not available');
}

var _warnedMissingNativeAnimated = false;

function shouldUseNativeDriver(config) {
  if (config.useNativeDriver && !NativeAnimatedModule) {
    if (!_warnedMissingNativeAnimated) {
      console.warn('Animated: `useNativeDriver` is not supported because the native ' + 'animated module is missing. Falling back to JS-based animation. To ' + 'resolve this, add `RCTAnimation` module to this app, or remove ' + '`useNativeDriver`. ' + 'More info: https://github.com/facebook/react-native/issues/11094#issuecomment-263240420');
      _warnedMissingNativeAnimated = true;
    }
    return false;
  }

  return config.useNativeDriver || false;
}

var NativeAnimatedHelper = {
  API: API,
  addWhitelistedStyleProp: addWhitelistedStyleProp,
  addWhitelistedTransformProp: addWhitelistedTransformProp,
  addWhitelistedInterpolationParam: addWhitelistedInterpolationParam,
  validateStyles: validateStyles,
  validateTransform: validateTransform,
  validateInterpolation: validateInterpolation,
  generateNewNodeTag: generateNewNodeTag,
  generateNewAnimationId: generateNewAnimationId,
  assertNativeAnimatedModule: assertNativeAnimatedModule,
  shouldUseNativeDriver: shouldUseNativeDriver,
  get nativeEventEmitter() {
    if (!nativeEventEmitter) {
      nativeEventEmitter = new __WEBPACK_IMPORTED_MODULE_2__NativeEventEmitter__["a" /* default */](NativeAnimatedModule);
    }
    return nativeEventEmitter;
  }
};



/* harmony default export */ __webpack_exports__["a"] = (NativeAnimatedHelper);

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(100);
var defined = __webpack_require__(48);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(101);
var createDesc = __webpack_require__(67);
var toIObject = __webpack_require__(35);
var toPrimitive = __webpack_require__(47);
var has = __webpack_require__(29);
var IE8_DOM_DEFINE = __webpack_require__(226);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(15) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(29);
var toObject = __webpack_require__(21);
var IE_PROTO = __webpack_require__(145)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(361);
var isBuffer = __webpack_require__(944);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(25);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_dom__["findDOMNode"]);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NativeMethodsMixin__ = __webpack_require__(589);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */



var applyNativeMethods = function applyNativeMethods(Component) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_0__NativeMethodsMixin__["a" /* default */]).forEach(function (method) {
    if (!Component.prototype[method]) {
      Component.prototype[method] = __WEBPACK_IMPORTED_MODULE_0__NativeMethodsMixin__["a" /* default */][method];
    }
  });
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (applyNativeMethods);

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='./lib/create-icon-set.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=createIconSet;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);var _reactNative=__webpack_require__(134);var _iconButton=__webpack_require__(771);var _iconButton2=_interopRequireDefault(_iconButton);var _tabBarItemIos=__webpack_require__(863);var _tabBarItemIos2=_interopRequireDefault(_tabBarItemIos);var _toolbarAndroid=__webpack_require__(875);var _toolbarAndroid2=_interopRequireDefault(_toolbarAndroid);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NativeIconAPI=_reactNative.NativeModules.RNVectorIconsManager||_reactNative.NativeModules.RNVectorIconsModule;var DEFAULT_ICON_SIZE=12;var DEFAULT_ICON_COLOR='black';function createIconSet(glyphMap,fontFamily,fontFile){var fontReference=fontFamily;if(_reactNative.Platform.OS==='android'&&fontFile){fontReference=fontFile.replace(/\.(otf|ttf)$/,'');}if(_reactNative.Platform.OS==='windows'&&fontFile){fontReference='Assets/'+fontFile+'#'+fontFamily;}var IconNamePropType=_propTypes2.default.oneOf(Object.keys(glyphMap));var Icon=function(_PureComponent){_inherits(Icon,_PureComponent);function Icon(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Icon);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Icon.__proto__||Object.getPrototypeOf(Icon)).call.apply(_ref,[this].concat(args))),_this),_this.root=null,_this.handleRef=function(ref){_this.root=ref;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Icon,[{key:'setNativeProps',value:function setNativeProps(nativeProps){if(this.root){this.root.setNativeProps(nativeProps);}}},{key:'render',value:function render(){var _props=this.props,name=_props.name,size=_props.size,color=_props.color,style=_props.style,props=_objectWithoutProperties(_props,['name','size','color','style']);var glyph=name?glyphMap[name]||'?':'';if(typeof glyph==='number'){glyph=String.fromCharCode(glyph);}var styleDefaults={fontSize:size,color:color};var styleOverrides={fontFamily:fontReference,fontWeight:'normal',fontStyle:'normal'};props.style=[styleDefaults,style,styleOverrides];props.ref=this.handleRef;return _react2.default.createElement(_reactNative.Text,_extends({},props,{__source:{fileName:_jsxFileName,lineNumber:82}}),glyph,this.props.children);}}]);return Icon;}(_react.PureComponent);Icon.propTypes={name:IconNamePropType,size:_propTypes2.default.number,color:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number]),children:_propTypes2.default.node,style:_propTypes2.default.any};Icon.defaultProps={size:DEFAULT_ICON_SIZE,allowFontScaling:false};var imageSourceCache={};function ensureNativeModuleAvailable(){if(!NativeIconAPI){if(_reactNative.Platform.OS==='android'){throw new Error('RNVectorIconsModule not available, did you properly integrate the module? Try running `react-native link react-native-vector-icons` and recompiling.');}throw new Error('RNVectorIconsManager not available, did you add the library to your project and link with libRNVectorIcons.a? Try running `react-native link react-native-vector-icons` and recompiling.');}}function getImageSource(name){var size=arguments.length>1&&arguments[1]!==undefined?arguments[1]:DEFAULT_ICON_SIZE;var color=arguments.length>2&&arguments[2]!==undefined?arguments[2]:DEFAULT_ICON_COLOR;ensureNativeModuleAvailable();var glyph=glyphMap[name]||'?';if(typeof glyph==='number'){glyph=String.fromCharCode(glyph);}var processedColor=(0,_reactNative.processColor)(color);var cacheKey=glyph+':'+size+':'+processedColor;var scale=_reactNative.PixelRatio.get();return new Promise(function(resolve,reject){var cached=imageSourceCache[cacheKey];if(typeof cached!=='undefined'){if(!cached||cached instanceof Error){reject(cached);}else{resolve({uri:cached,scale:scale});}}else{NativeIconAPI.getImageForFont(fontReference,glyph,size,processedColor,function(err,image){var error=typeof err==='string'?new Error(err):err;imageSourceCache[cacheKey]=image||error||false;if(!error&&image){resolve({uri:image,scale:scale});}else{reject(error);}});}});}function loadFont(){var file=arguments.length>0&&arguments[0]!==undefined?arguments[0]:fontFile;if(_reactNative.Platform.OS==='ios'){ensureNativeModuleAvailable();if(!file){return Promise.reject(new Error('Unable to load font, because no file was specified. '));}return NativeIconAPI.loadFontWithFileName.apply(NativeIconAPI,_toConsumableArray(file.split('.')));}return Promise.resolve();}Icon.Button=(0,_iconButton2.default)(Icon);Icon.TabBarItem=(0,_tabBarItemIos2.default)(IconNamePropType,getImageSource);Icon.TabBarItemIOS=Icon.TabBarItem;Icon.ToolbarAndroid=(0,_toolbarAndroid2.default)(IconNamePropType,getImageSource);Icon.getImageSource=getImageSource;Icon.loadFont=loadFont;return Icon;}

/***/ }),
/* 46 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(8);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(46);
var fails = __webpack_require__(7);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(40);
var IObject = __webpack_require__(100);
var toObject = __webpack_require__(21);
var toLength = __webpack_require__(17);
var asc = __webpack_require__(162);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_react_dom_setValueForStyles__ = __webpack_require__(624);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */



var getRect = function getRect(node) {
  var height = node.offsetHeight;
  var width = node.offsetWidth;
  var left = node.offsetLeft;
  var top = node.offsetTop;
  node = node.offsetParent;

  while (node && node.nodeType === 1 /* Node.ELEMENT_NODE */) {
    left += node.offsetLeft - node.scrollLeft;
    top += node.offsetTop - node.scrollTop;
    node = node.offsetParent;
  }
  return { height: height, left: left, top: top, width: width };
};

var _measureLayout = function _measureLayout(node, relativeToNativeNode, callback) {
  var relativeNode = relativeToNativeNode || node && node.parentNode;
  if (node && relativeNode) {
    setTimeout(function () {
      var relativeRect = getRect(relativeNode);

      var _getRect = getRect(node),
          height = _getRect.height,
          left = _getRect.left,
          top = _getRect.top,
          width = _getRect.width;

      var x = left - relativeRect.left;
      var y = top - relativeRect.top;
      callback(x, y, width, height, left, top);
    }, 0);
  }
};

var UIManager = {
  blur: function blur(node) {
    try {
      node.blur();
    } catch (err) {}
  },
  focus: function focus(node) {
    try {
      node.focus();
    } catch (err) {}
  },
  measure: function measure(node, callback) {
    _measureLayout(node, null, callback);
  },
  measureInWindow: function measureInWindow(node, callback) {
    if (node) {
      setTimeout(function () {
        var _getRect2 = getRect(node),
            height = _getRect2.height,
            left = _getRect2.left,
            top = _getRect2.top,
            width = _getRect2.width;

        callback(left, top, width, height);
      }, 0);
    }
  },
  measureLayout: function measureLayout(node, relativeToNativeNode, onFail, onSuccess) {
    _measureLayout(node, relativeToNativeNode, onSuccess);
  },
  updateView: function updateView(node, props, component /* only needed to surpress React errors in development */) {
    for (var prop in props) {
      if (!Object.prototype.hasOwnProperty.call(props, prop)) {
        continue;
      }

      var value = props[prop];
      switch (prop) {
        case 'style':
          {
            Object(__WEBPACK_IMPORTED_MODULE_0__vendor_react_dom_setValueForStyles__["a" /* default */])(node, value, component._reactInternalInstance);
            break;
          }
        case 'class':
        case 'className':
          {
            node.setAttribute('class', value);
            break;
          }
        case 'text':
        case 'value':
          // native platforms use `text` prop to replace text input value
          node.value = value;
          break;
        default:
          node.setAttribute(prop, value);
      }
    }
  },
  configureNextLayoutAnimation: function configureNextLayoutAnimation(config, onAnimationDidEnd) {
    onAnimationDidEnd();
  },


  // mocks
  setLayoutAnimationEnabledExperimental: function setLayoutAnimationEnabledExperimental() {}
};

/* harmony default export */ __webpack_exports__["a"] = (UIManager);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimatedNode__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NativeAnimatedHelper__ = __webpack_require__(34);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AnimatedWithChildren = function (_AnimatedNode) {
  _inherits(AnimatedWithChildren, _AnimatedNode);

  function AnimatedWithChildren() {
    _classCallCheck(this, AnimatedWithChildren);

    var _this = _possibleConstructorReturn(this, _AnimatedNode.call(this));

    _this._children = [];
    return _this;
  }

  AnimatedWithChildren.prototype.__makeNative = function __makeNative() {
    if (!this.__isNative) {
      this.__isNative = true;
      for (var _iterator = this._children, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var child = _ref;

        child.__makeNative();
        __WEBPACK_IMPORTED_MODULE_1__NativeAnimatedHelper__["a" /* default */].API.connectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
      }
    }
  };

  AnimatedWithChildren.prototype.__addChild = function __addChild(child) {
    if (this._children.length === 0) {
      this.__attach();
    }
    this._children.push(child);
    if (this.__isNative) {
      // Only accept "native" animated nodes as children
      child.__makeNative();
      __WEBPACK_IMPORTED_MODULE_1__NativeAnimatedHelper__["a" /* default */].API.connectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
    }
  };

  AnimatedWithChildren.prototype.__removeChild = function __removeChild(child) {
    var index = this._children.indexOf(child);
    if (index === -1) {
      console.warn("Trying to remove a child that doesn't exist");
      return;
    }
    if (this.__isNative && child.__isNative) {
      __WEBPACK_IMPORTED_MODULE_1__NativeAnimatedHelper__["a" /* default */].API.disconnectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
    }
    this._children.splice(index, 1);
    if (this._children.length === 0) {
      this.__detach();
    }
  };

  AnimatedWithChildren.prototype.__getChildren = function __getChildren() {
    return this._children;
  };

  return AnimatedWithChildren;
}(__WEBPACK_IMPORTED_MODULE_0__AnimatedNode__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AnimatedWithChildren);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(327);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(15)) {
  var LIBRARY = __webpack_require__(69);
  var global = __webpack_require__(6);
  var fails = __webpack_require__(7);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(123);
  var $buffer = __webpack_require__(168);
  var ctx = __webpack_require__(40);
  var anInstance = __webpack_require__(75);
  var propertyDesc = __webpack_require__(67);
  var hide = __webpack_require__(30);
  var redefineAll = __webpack_require__(77);
  var toInteger = __webpack_require__(49);
  var toLength = __webpack_require__(17);
  var toIndex = __webpack_require__(252);
  var toAbsoluteIndex = __webpack_require__(71);
  var toPrimitive = __webpack_require__(47);
  var has = __webpack_require__(29);
  var classof = __webpack_require__(102);
  var isObject = __webpack_require__(8);
  var toObject = __webpack_require__(21);
  var isArrayIter = __webpack_require__(159);
  var create = __webpack_require__(72);
  var getPrototypeOf = __webpack_require__(37);
  var gOPN = __webpack_require__(73).f;
  var getIterFn = __webpack_require__(161);
  var uid = __webpack_require__(68);
  var wks = __webpack_require__(11);
  var createArrayMethod = __webpack_require__(51);
  var createArrayIncludes = __webpack_require__(114);
  var speciesConstructor = __webpack_require__(121);
  var ArrayIterators = __webpack_require__(164);
  var Iterators = __webpack_require__(88);
  var $iterDetect = __webpack_require__(118);
  var setSpecies = __webpack_require__(74);
  var arrayFill = __webpack_require__(163);
  var arrayCopyWithin = __webpack_require__(242);
  var $DP = __webpack_require__(16);
  var $GOPD = __webpack_require__(36);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(247);
var $export = __webpack_require__(0);
var shared = __webpack_require__(113)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(250))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_AccessibilityUtil__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_createDOMProps__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_normalizeNativeEvent__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_ResponderEventPlugin__ = __webpack_require__(627);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */








var EventPluginHub = __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.EventPluginHub;


EventPluginHub.injection.injectEventPluginsByName({
  ResponderEventPlugin: __WEBPACK_IMPORTED_MODULE_5__modules_ResponderEventPlugin__["a" /* default */]
});

var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * Ensure event handlers receive an event of the expected shape. The 'button'
 * role – for accessibility reasons and functional equivalence to the native
 * button element – must also support synthetic keyboard activation of onclick,
 * and remove event handlers when disabled.
 */
var eventHandlerNames = {
  onBlur: true,
  onClick: true,
  onClickCapture: true,
  onContextMenu: true,
  onFocus: true,
  onResponderRelease: true,
  onTouchCancel: true,
  onTouchCancelCapture: true,
  onTouchEnd: true,
  onTouchEndCapture: true,
  onTouchMove: true,
  onTouchMoveCapture: true,
  onTouchStart: true,
  onTouchStartCapture: true
};
var adjustProps = function adjustProps(domProps) {
  var onClick = domProps.onClick,
      onResponderRelease = domProps.onResponderRelease,
      role = domProps.role;


  var isButtonRole = role === 'button';
  var isDisabled = __WEBPACK_IMPORTED_MODULE_0__modules_AccessibilityUtil__["a" /* default */].isDisabled(domProps);
  var isLinkRole = role === 'link';

  Object.keys(domProps).forEach(function (propName) {
    var prop = domProps[propName];
    var isEventHandler = typeof prop === 'function' && eventHandlerNames[propName];
    if (isEventHandler) {
      if (isButtonRole && isDisabled) {
        domProps[propName] = undefined;
      } else {
        // TODO: move this out of the render path
        domProps[propName] = function (e) {
          e.nativeEvent = Object(__WEBPACK_IMPORTED_MODULE_2__modules_normalizeNativeEvent__["a" /* default */])(e.nativeEvent);
          return prop(e);
        };
      }
    }
  });

  // Cancel click events if the responder system is being used on a link
  // element. Click events are not an expected part of the React Native API,
  // and browsers dispatch click events that cannot otherwise be cancelled from
  // preceding mouse events in the responder system.
  if (isLinkRole && onResponderRelease) {
    domProps.onClick = function (e) {
      if (!e.isDefaultPrevented() && !isModifiedEvent(e.nativeEvent) && !domProps.target) {
        e.preventDefault();
      }
    };
  }

  // Button role should trigger 'onClick' if SPACE or ENTER keys are pressed.
  if (isButtonRole && !isDisabled) {
    domProps.onKeyPress = function (e) {
      if (!e.isDefaultPrevented() && (e.which === 13 || e.which === 32)) {
        e.preventDefault();
        if (onClick) {
          onClick(e);
        }
      }
    };
  }
};

var createElement = function createElement(component, props) {
  for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  // use equivalent platform elements where possible
  var accessibilityComponent = void 0;
  if (component && component.constructor === String) {
    accessibilityComponent = __WEBPACK_IMPORTED_MODULE_0__modules_AccessibilityUtil__["a" /* default */].propsToAccessibilityComponent(props);
  }
  var Component = accessibilityComponent || component;
  var domProps = Object(__WEBPACK_IMPORTED_MODULE_1__modules_createDOMProps__["a" /* default */])(Component, props);
  adjustProps(domProps);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement.apply(__WEBPACK_IMPORTED_MODULE_3_react___default.a, [Component, domProps].concat(children));
};

/* harmony default export */ __webpack_exports__["a"] = (createElement);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimatedInterpolation__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimatedNode__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnimatedWithChildren__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__exports_InteractionManager__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NativeAnimatedHelper__ = __webpack_require__(34);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var NativeAnimatedAPI = __WEBPACK_IMPORTED_MODULE_4__NativeAnimatedHelper__["a" /* default */].API;

var _uniqueId = 1;

/**
 * Animated works by building a directed acyclic graph of dependencies
 * transparently when you render your Animated components.
 *
 *               new Animated.Value(0)
 *     .interpolate()        .interpolate()    new Animated.Value(1)
 *         opacity               translateY      scale
 *          style                         transform
 *         View#234                         style
 *                                         View#123
 *
 * A) Top Down phase
 * When an Animated.Value is updated, we recursively go down through this
 * graph in order to find leaf nodes: the views that we flag as needing
 * an update.
 *
 * B) Bottom Up phase
 * When a view is flagged as needing an update, we recursively go back up
 * in order to build the new value that it needs. The reason why we need
 * this two-phases process is to deal with composite props such as
 * transform which can receive values from multiple parents.
 */
function _flush(rootNode) {
  var animatedStyles = new Set();
  function findAnimatedStyles(node) {
    if (typeof node.update === 'function') {
      animatedStyles.add(node);
    } else {
      node.__getChildren().forEach(findAnimatedStyles);
    }
  }
  findAnimatedStyles(rootNode);
  /* $FlowFixMe */
  animatedStyles.forEach(function (animatedStyle) {
    return animatedStyle.update();
  });
}

/**
 * Standard value for driving animations.  One `Animated.Value` can drive
 * multiple properties in a synchronized fashion, but can only be driven by one
 * mechanism at a time.  Using a new mechanism (e.g. starting a new animation,
 * or calling `setValue`) will stop any previous ones.
 *
 * See http://facebook.github.io/react-native/docs/animatedvalue.html
 */

var AnimatedValue = function (_AnimatedWithChildren) {
  _inherits(AnimatedValue, _AnimatedWithChildren);

  function AnimatedValue(value) {
    _classCallCheck(this, AnimatedValue);

    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));

    _this._startingValue = _this._value = value;
    _this._offset = 0;
    _this._animation = null;
    _this._listeners = {};
    return _this;
  }

  AnimatedValue.prototype.__detach = function __detach() {
    this.stopAnimation();
    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  AnimatedValue.prototype.__getValue = function __getValue() {
    return this._value + this._offset;
  };

  AnimatedValue.prototype.__makeNative = function __makeNative() {
    _AnimatedWithChildren.prototype.__makeNative.call(this);

    if (Object.keys(this._listeners).length) {
      this._startListeningToNativeValueUpdates();
    }
  };

  /**
   * Directly set the value.  This will stop any animations running on the value
   * and update all the bound properties.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#setvalue
   */


  AnimatedValue.prototype.setValue = function setValue(value) {
    if (this._animation) {
      this._animation.stop();
      this._animation = null;
    }
    this._updateValue(value, !this.__isNative /* don't perform a flush for natively driven values */
    );
    if (this.__isNative) {
      NativeAnimatedAPI.setAnimatedNodeValue(this.__getNativeTag(), value);
    }
  };

  /**
   * Sets an offset that is applied on top of whatever value is set, whether via
   * `setValue`, an animation, or `Animated.event`.  Useful for compensating
   * things like the start of a pan gesture.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#setoffset
   */


  AnimatedValue.prototype.setOffset = function setOffset(offset) {
    this._offset = offset;
    if (this.__isNative) {
      NativeAnimatedAPI.setAnimatedNodeOffset(this.__getNativeTag(), offset);
    }
  };

  /**
   * Merges the offset value into the base value and resets the offset to zero.
   * The final output of the value is unchanged.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#flattenoffset
   */


  AnimatedValue.prototype.flattenOffset = function flattenOffset() {
    this._value += this._offset;
    this._offset = 0;
    if (this.__isNative) {
      NativeAnimatedAPI.flattenAnimatedNodeOffset(this.__getNativeTag());
    }
  };

  /**
   * Sets the offset value to the base value, and resets the base value to zero.
   * The final output of the value is unchanged.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#extractoffset
   */


  AnimatedValue.prototype.extractOffset = function extractOffset() {
    this._offset += this._value;
    this._value = 0;
    if (this.__isNative) {
      NativeAnimatedAPI.extractAnimatedNodeOffset(this.__getNativeTag());
    }
  };

  /**
   * Adds an asynchronous listener to the value so you can observe updates from
   * animations.  This is useful because there is no way to
   * synchronously read the value because it might be driven natively.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#addlistener
   */


  AnimatedValue.prototype.addListener = function addListener(callback) {
    var id = String(_uniqueId++);
    this._listeners[id] = callback;
    if (this.__isNative) {
      this._startListeningToNativeValueUpdates();
    }
    return id;
  };

  /**
   * Unregister a listener. The `id` param shall match the identifier
   * previously returned by `addListener()`.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#removelistener
   */


  AnimatedValue.prototype.removeListener = function removeListener(id) {
    delete this._listeners[id];
    if (this.__isNative && Object.keys(this._listeners).length === 0) {
      this._stopListeningForNativeValueUpdates();
    }
  };

  /**
   * Remove all registered listeners.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#removealllisteners
   */


  AnimatedValue.prototype.removeAllListeners = function removeAllListeners() {
    this._listeners = {};
    if (this.__isNative) {
      this._stopListeningForNativeValueUpdates();
    }
  };

  AnimatedValue.prototype._startListeningToNativeValueUpdates = function _startListeningToNativeValueUpdates() {
    var _this2 = this;

    if (this.__nativeAnimatedValueListener) {
      return;
    }

    NativeAnimatedAPI.startListeningToAnimatedNodeValue(this.__getNativeTag());
    this.__nativeAnimatedValueListener = __WEBPACK_IMPORTED_MODULE_4__NativeAnimatedHelper__["a" /* default */].nativeEventEmitter.addListener('onAnimatedValueUpdate', function (data) {
      if (data.tag !== _this2.__getNativeTag()) {
        return;
      }
      _this2._updateValue(data.value, false /* flush */);
    });
  };

  AnimatedValue.prototype._stopListeningForNativeValueUpdates = function _stopListeningForNativeValueUpdates() {
    if (!this.__nativeAnimatedValueListener) {
      return;
    }

    this.__nativeAnimatedValueListener.remove();
    this.__nativeAnimatedValueListener = null;
    NativeAnimatedAPI.stopListeningToAnimatedNodeValue(this.__getNativeTag());
  };

  /**
   * Stops any running animation or tracking. `callback` is invoked with the
   * final value after stopping the animation, which is useful for updating
   * state to match the animation position with layout.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#stopanimation
   */


  AnimatedValue.prototype.stopAnimation = function stopAnimation(callback) {
    this.stopTracking();
    this._animation && this._animation.stop();
    this._animation = null;
    callback && callback(this.__getValue());
  };

  /**
   * Stops any animation and resets the value to its original.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#resetanimation
   */


  AnimatedValue.prototype.resetAnimation = function resetAnimation(callback) {
    this.stopAnimation(callback);
    this._value = this._startingValue;
  };

  /**
   * Interpolates the value before updating the property, e.g. mapping 0-1 to
   * 0-10.
   */


  AnimatedValue.prototype.interpolate = function interpolate(config) {
    return new __WEBPACK_IMPORTED_MODULE_0__AnimatedInterpolation__["a" /* default */](this, config);
  };

  /**
   * Typically only used internally, but could be used by a custom Animation
   * class.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#animate
   */


  AnimatedValue.prototype.animate = function animate(animation, callback) {
    var _this3 = this;

    var handle = null;
    if (animation.__isInteraction) {
      handle = __WEBPACK_IMPORTED_MODULE_3__exports_InteractionManager__["a" /* default */].createInteractionHandle();
    }
    var previousAnimation = this._animation;
    this._animation && this._animation.stop();
    this._animation = animation;
    animation.start(this._value, function (value) {
      // Natively driven animations will never call into that callback, therefore we can always
      // pass flush = true to allow the updated value to propagate to native with setNativeProps
      _this3._updateValue(value, true /* flush */);
    }, function (result) {
      _this3._animation = null;
      if (handle !== null) {
        __WEBPACK_IMPORTED_MODULE_3__exports_InteractionManager__["a" /* default */].clearInteractionHandle(handle);
      }
      callback && callback(result);
    }, previousAnimation, this);
  };

  /**
   * Typically only used internally.
   */


  AnimatedValue.prototype.stopTracking = function stopTracking() {
    this._tracking && this._tracking.__detach();
    this._tracking = null;
  };

  /**
   * Typically only used internally.
   */


  AnimatedValue.prototype.track = function track(tracking) {
    this.stopTracking();
    this._tracking = tracking;
  };

  AnimatedValue.prototype._updateValue = function _updateValue(value, flush) {
    this._value = value;
    if (flush) {
      _flush(this);
    }
    for (var _key in this._listeners) {
      this._listeners[_key]({ value: this.__getValue() });
    }
  };

  AnimatedValue.prototype.__getNativeConfig = function __getNativeConfig() {
    return {
      type: 'value',
      value: this._value,
      offset: this._offset
    };
  };

  return AnimatedValue;
}(__WEBPACK_IMPORTED_MODULE_2__AnimatedWithChildren__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AnimatedValue);

/***/ }),
/* 61 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _class,_temp;var _reactNative=__webpack_require__(3);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var

AlertUtils=(_temp=_class=function AlertUtils(){_classCallCheck(this,AlertUtils);},_class.









confirm=function(_ref)



{var _ref$title=_ref.title,title=_ref$title===undefined?global.__APP_NAME__:_ref$title,message=_ref.message,actions=_ref.actions;
if(_reactNative.Platform.OS==='web'){
return window.confirm(message);
}else{
_reactNative.Alert.alert(
title,
message,
actions);

}
return false;
},_class.









alert=function(_ref2)





{var _ref2$title=_ref2.title,title=_ref2$title===undefined?global.__APP_NAME__:_ref2$title,message=_ref2.message,_ref2$buttonText=_ref2.buttonText,buttonText=_ref2$buttonText===undefined?'OK':_ref2$buttonText,actions=_ref2.actions,options=_ref2.options;
if(_reactNative.Platform.OS==='web'){
window.alert(message);
}else{
_reactNative.Alert.alert(
title,
message,
_lodash2.default.isEmpty(actions)?
[
{text:buttonText,style:'cancel'}]:

actions,
options);

}
},_temp);exports.default=AlertUtils;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(68)('meta');
var isObject = __webpack_require__(8);
var has = __webpack_require__(29);
var setDesc = __webpack_require__(16).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(7)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(11)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(30)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(580);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _reactNative=__webpack_require__(3);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);

var _modules=__webpack_require__(19);var modules=_interopRequireWildcard(_modules);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}

var ADMIN_ROLE='admin';
var AGENCY_ROLE='agency';
var PARTNER_ROLE='partner';
var SALESMAN_ROLE='salesman';
var MARKETER_ROLE='marketer';var

UserUtils=(_temp=_class=function(){function UserUtils(){_classCallCheck(this,UserUtils);}_createClass(UserUtils,null,[{key:'isSignedIn',value:function isSignedIn(

user){
if(!user){
return;
}var
credential=user.credential,info=user.info;
return!_lodash2.default.isEmpty(credential)&&
!_lodash2.default.isEmpty(credential.username)&&
!_lodash2.default.isEmpty(credential.password)&&
!_lodash2.default.isEmpty(info);
}},{key:'updateFCMToken',value:function updateFCMToken(






































credential,fcmToken){
if(_reactNative.Platform.OS==='web'){
return;
}

if(!UserUtils.isValidCredential(credential)||
_lodash2.default.isEmpty(fcmToken)){
return;
}

UserUtils._doUpdateFCMToken(1,credential,fcmToken);
}},{key:'signOut',value:function signOut(







credential,fcmToken){
UserUtils._doSignOut(1,credential,fcmToken);
}},{key:'resetNotificationCount',value:function resetNotificationCount(






credential){
if(_reactNative.Platform.OS==='web'){
return;
}

if(!UserUtils.isValidCredential(credential)){
return;
}
UserUtils._doResetNotificationCount(1,credential);
}},{key:'_doUpdateFCMToken',value:function _doUpdateFCMToken(




attempts,credential,token){
if(attempts>3){
console.log('too much attempts to update fcm token');
return;
}

console.log('try to update fcm token to server');
var url=_APIClient2.default.BASE_API_URL+'/user/updateFCMToken';
console.log('url: '+url);
var headers=_Utils2.default.createBasicAuthHeaders(credential);
var params={
token:token};

fetch(url,{
method:'POST',
headers:headers,
body:_Utils2.default.createBodyParams(params)}).
then(function(response){return response.json();}).then(function(json){
UserUtils._handleFCMTokenNetworkResponse(attempts,credential,token,
json,null);
}).catch(function(error){
UserUtils._handleFCMTokenNetworkResponse(attempts,credential,token,
null,error);
});
}},{key:'_handleFCMTokenNetworkResponse',value:function _handleFCMTokenNetworkResponse(


attempts,credential,token,response,error){
if(response&&response.response){

console.log('update fcm token to server successfully');
}else{

this._doUpdateFCMToken(attempts+1,credential,token);
}
}},{key:'_doSignOut',value:function _doSignOut(







attempts,credential,fcmToken){
if(attempts>3){
return;
}

console.log('try to sign out with attempts: '+attempts);
var url=_APIClient2.default.BASE_API_URL+'/user/signOut';
console.log('url: '+url);
var headers=_Utils2.default.createBasicAuthHeaders(credential);
var params={
fcm_token:fcmToken};

fetch(url,{
method:'POST',
headers:headers,
body:_Utils2.default.createBodyParams(params)}).
then(function(response){return response.json();}).then(function(json){
UserUtils._handleSignOutNetworkResponse(attempts,credential,fcmToken,
json,null);
}).catch(function(error){
UserUtils._handleSignOutNetworkResponse(attempts,credential,fcmToken,
null,error);
});
}},{key:'_handleSignOutNetworkResponse',value:function _handleSignOutNetworkResponse(


attempts,credential,token,response,error){







if(response&&response.response){
console.log('sign out successfully');
}else{
UserUtils._doSignOut(attempts+1,credential,token);
}
}},{key:'_doResetNotificationCount',value:function _doResetNotificationCount(







attempts,credential){
if(attempts>3){
return;
}

console.log('try to reset notification count with attempts: '+attempts);
var url=_APIClient2.default.BASE_API_URL+'/user/updateNotificationCount';
console.log('url: '+url);
var headers=_Utils2.default.createBasicAuthHeaders(credential);
var params={
notification_count:0};

fetch(url,{
method:'POST',
headers:headers,
body:_Utils2.default.createBodyParams(params)}).
then(function(response){return response.json();}).then(function(json){
UserUtils._handleResetNotificationCountNetworkResponse(attempts,
credential,json,null);
}).catch(function(error){
UserUtils._handleResetNotificationCountNetworkResponse(attempts,
credential,null,error);
});
}},{key:'_handleResetNotificationCountNetworkResponse',value:function _handleResetNotificationCountNetworkResponse(


attempts,credential,response,error){







if(response&&response.response){
console.log('reset notification count successfully');
modules.FCM.setBadgeNumber(0);
}else{
UserUtils._doResetNotificationCount(attempts+1,credential);
}
}}]);return UserUtils;}(),_class.isAdmin=function(user){return user&&user.info&&user.info.role===ADMIN_ROLE;},_class.isAgency=function(user){return user&&user.info&&user.info.role===AGENCY_ROLE;},_class.isPartner=function(user){return user&&user.info&&user.info.role===PARTNER_ROLE;},_class.isSeller=function(user){return user&&user.info&&(user.info.role===AGENCY_ROLE||user.info.role===PARTNER_ROLE);},_class.isSalesman=function(user){return user&&user.info&&user.info.role===SALESMAN_ROLE;},_class.isMarketer=function(user){return user&&user.info&&user.info.role===MARKETER_ROLE;},_class.isValidCredential=function(credential){return credential&&!_lodash2.default.isEmpty(credential.username)&&!_lodash2.default.isEmpty(credential.password);},_temp);exports.default=UserUtils;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(228);
var enumBugKeys = __webpack_require__(146);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(49);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(5);
var dPs = __webpack_require__(229);
var enumBugKeys = __webpack_require__(146);
var IE_PROTO = __webpack_require__(145)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(143)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(147).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(228);
var hiddenKeys = __webpack_require__(146).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(6);
var dP = __webpack_require__(16);
var DESCRIPTORS = __webpack_require__(15);
var SPECIES = __webpack_require__(11)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(40);
var call = __webpack_require__(240);
var isArrayIter = __webpack_require__(159);
var anObject = __webpack_require__(5);
var toLength = __webpack_require__(17);
var getIterFn = __webpack_require__(161);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(31);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




/**
 * Common implementation for a simple stubbed view.
 */
/* eslint-disable react/prop-types */

var UnimplementedView = function (_Component) {
  _inherits(UnimplementedView, _Component);

  function UnimplementedView() {
    _classCallCheck(this, UnimplementedView);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  UnimplementedView.prototype.setNativeProps = function setNativeProps() {
    // Do nothing.
    // This method is required in order to use this view as a Touchable* child.
    // See ensureComponentIsNative.js for more info
  };

  UnimplementedView.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0__exports_View__["a" /* default */],
      { style: [unimplementedViewStyles, this.props.style] },
      this.props.children
    );
  };

  return UnimplementedView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var unimplementedViewStyles =  false ? {
  alignSelf: 'flex-start',
  borderColor: 'red',
  borderWidth: 1
} : {};

/* harmony default export */ __webpack_exports__["a"] = (UnimplementedView);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(58);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimatedNode__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimatedWithChildren__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NativeAnimatedHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_normalize_css_color__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_normalize_css_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_normalize_css_color__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */
/* eslint no-bitwise: 0 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var linear = function linear(t) {
  return t;
};

/**
 * Very handy helper to map input ranges to output ranges with an easing
 * function and custom behavior outside of the ranges.
 */
function createInterpolation(config) {
  if (config.outputRange && typeof config.outputRange[0] === 'string') {
    return createInterpolationFromStringOutputRange(config);
  }

  var outputRange = config.outputRange;
  checkInfiniteRange('outputRange', outputRange);

  var inputRange = config.inputRange;
  checkInfiniteRange('inputRange', inputRange);
  checkValidInputRange(inputRange);

  __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(inputRange.length === outputRange.length, 'inputRange (' + inputRange.length + ') and outputRange (' + outputRange.length + ') must have the same length');

  var easing = config.easing || linear;

  var extrapolateLeft = 'extend';
  if (config.extrapolateLeft !== undefined) {
    extrapolateLeft = config.extrapolateLeft;
  } else if (config.extrapolate !== undefined) {
    extrapolateLeft = config.extrapolate;
  }

  var extrapolateRight = 'extend';
  if (config.extrapolateRight !== undefined) {
    extrapolateRight = config.extrapolateRight;
  } else if (config.extrapolate !== undefined) {
    extrapolateRight = config.extrapolate;
  }

  return function (input) {
    __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(typeof input === 'number', 'Cannot interpolation an input which is not a number');

    var range = findRange(input, inputRange);
    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight);
  };
}

function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight) {
  var result = input;

  // Extrapolate
  if (result < inputMin) {
    if (extrapolateLeft === 'identity') {
      return result;
    } else if (extrapolateLeft === 'clamp') {
      result = inputMin;
    } else if (extrapolateLeft === 'extend') {
      // noop
    }
  }

  if (result > inputMax) {
    if (extrapolateRight === 'identity') {
      return result;
    } else if (extrapolateRight === 'clamp') {
      result = inputMax;
    } else if (extrapolateRight === 'extend') {
      // noop
    }
  }

  if (outputMin === outputMax) {
    return outputMin;
  }

  if (inputMin === inputMax) {
    if (input <= inputMin) {
      return outputMin;
    }
    return outputMax;
  }

  // Input Range
  if (inputMin === -Infinity) {
    result = -result;
  } else if (inputMax === Infinity) {
    result = result - inputMin;
  } else {
    result = (result - inputMin) / (inputMax - inputMin);
  }

  // Easing
  result = easing(result);

  // Output Range
  if (outputMin === -Infinity) {
    result = -result;
  } else if (outputMax === Infinity) {
    result = result + outputMin;
  } else {
    result = result * (outputMax - outputMin) + outputMin;
  }

  return result;
}

function colorToRgba(input) {
  var int32Color = __WEBPACK_IMPORTED_MODULE_4_normalize_css_color___default()(input);
  if (int32Color === null) {
    return input;
  }

  int32Color = int32Color || 0;

  var r = (int32Color & 0xff000000) >>> 24;
  var g = (int32Color & 0x00ff0000) >>> 16;
  var b = (int32Color & 0x0000ff00) >>> 8;
  var a = (int32Color & 0x000000ff) / 255;

  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + a + ')';
}

var stringShapeRegex = /[0-9\.-]+/g;

/**
 * Supports string shapes by extracting numbers so new values can be computed,
 * and recombines those values into new strings of the same shape.  Supports
 * things like:
 *
 *   rgba(123, 42, 99, 0.36) // colors
 *   -45deg                  // values with units
 */
function createInterpolationFromStringOutputRange(config) {
  var outputRange = config.outputRange;
  __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(outputRange.length >= 2, 'Bad output range');
  outputRange = outputRange.map(colorToRgba);
  checkPattern(outputRange);

  // ['rgba(0, 100, 200, 0)', 'rgba(50, 150, 250, 0.5)']
  // ->
  // [
  //   [0, 50],
  //   [100, 150],
  //   [200, 250],
  //   [0, 0.5],
  // ]
  /* $FlowFixMe(>=0.18.0): `outputRange[0].match()` can return `null`. Need to
   * guard against this possibility.
   */
  var outputRanges = outputRange[0].match(stringShapeRegex).map(function () {
    return [];
  });
  outputRange.forEach(function (value) {
    /* $FlowFixMe(>=0.18.0): `value.match()` can return `null`. Need to guard
     * against this possibility.
     */
    value.match(stringShapeRegex).forEach(function (number, i) {
      outputRanges[i].push(+number);
    });
  });

  /* $FlowFixMe(>=0.18.0): `outputRange[0].match()` can return `null`. Need to
   * guard against this possibility.
   */
  var interpolations = outputRange[0].match(stringShapeRegex).map(function (value, i) {
    return createInterpolation(Object.assign({}, config, {
      outputRange: outputRanges[i]
    }));
  });

  // rgba requires that the r,g,b are integers.... so we want to round them, but we *dont* want to
  // round the opacity (4th column).
  var shouldRound = isRgbOrRgba(outputRange[0]);

  return function (input) {
    var i = 0;
    // 'rgba(0, 100, 200, 0)'
    // ->
    // 'rgba(${interpolations[0](input)}, ${interpolations[1](input)}, ...'
    return outputRange[0].replace(stringShapeRegex, function () {
      var val = +interpolations[i++](input);
      var rounded = shouldRound && i < 4 ? Math.round(val) : Math.round(val * 1000) / 1000;
      return String(rounded);
    });
  };
}

function isRgbOrRgba(range) {
  return typeof range === 'string' && range.startsWith('rgb');
}

function checkPattern(arr) {
  var pattern = arr[0].replace(stringShapeRegex, '');
  for (var i = 1; i < arr.length; ++i) {
    __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(pattern === arr[i].replace(stringShapeRegex, ''), 'invalid pattern ' + arr[0] + ' and ' + arr[i]);
  }
}

function findRange(input, inputRange) {
  var i = void 0;
  for (i = 1; i < inputRange.length - 1; ++i) {
    if (inputRange[i] >= input) {
      break;
    }
  }
  return i - 1;
}

function checkValidInputRange(arr) {
  __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(arr.length >= 2, 'inputRange must have at least 2 elements');
  for (var i = 1; i < arr.length; ++i) {
    __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(arr[i] >= arr[i - 1],
    /* $FlowFixMe(>=0.13.0) - In the addition expression below this comment,
     * one or both of the operands may be something that doesn't cleanly
     * convert to a string, like undefined, null, and object, etc. If you really
     * mean this implicit string conversion, you can do something like
     * String(myThing)
     */
    'inputRange must be monotonically increasing ' + arr);
  }
}

function checkInfiniteRange(name, arr) {
  __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(arr.length >= 2, name + ' must have at least 2 elements');
  __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(arr.length !== 2 || arr[0] !== -Infinity || arr[1] !== Infinity,
  /* $FlowFixMe(>=0.13.0) - In the addition expression below this comment,
   * one or both of the operands may be something that doesn't cleanly convert
   * to a string, like undefined, null, and object, etc. If you really mean
   * this implicit string conversion, you can do something like
   * String(myThing)
   */
  name + 'cannot be ]-infinity;+infinity[ ' + arr);
}

var AnimatedInterpolation = function (_AnimatedWithChildren) {
  _inherits(AnimatedInterpolation, _AnimatedWithChildren);

  // Export for testing.
  function AnimatedInterpolation(parent, config) {
    _classCallCheck(this, AnimatedInterpolation);

    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));

    _this._parent = parent;
    _this._config = config;
    _this._interpolation = createInterpolation(config);
    return _this;
  }

  AnimatedInterpolation.prototype.__makeNative = function __makeNative() {
    this._parent.__makeNative();
    _AnimatedWithChildren.prototype.__makeNative.call(this);
  };

  AnimatedInterpolation.prototype.__getValue = function __getValue() {
    var parentValue = this._parent.__getValue();
    __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(typeof parentValue === 'number', 'Cannot interpolate an input which is not a number.');
    return this._interpolation(parentValue);
  };

  AnimatedInterpolation.prototype.interpolate = function interpolate(config) {
    return new AnimatedInterpolation(this, config);
  };

  AnimatedInterpolation.prototype.__attach = function __attach() {
    this._parent.__addChild(this);
  };

  AnimatedInterpolation.prototype.__detach = function __detach() {
    this._parent.__removeChild(this);
    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  AnimatedInterpolation.prototype.__transformDataType = function __transformDataType(range) {
    // Change the string array type to number array
    // So we can reuse the same logic in iOS and Android platform
    return range.map(function (value) {
      if (typeof value !== 'string') {
        return value;
      }
      if (/deg$/.test(value)) {
        var degrees = parseFloat(value) || 0;
        var radians = degrees * Math.PI / 180.0;
        return radians;
      } else {
        // Assume radians
        return parseFloat(value) || 0;
      }
    });
  };

  AnimatedInterpolation.prototype.__getNativeConfig = function __getNativeConfig() {
    if (false) {
      NativeAnimatedHelper.validateInterpolation(this._config);
    }

    return {
      inputRange: this._config.inputRange,
      // Only the `outputRange` can contain strings so we don't need to transform `inputRange` here
      outputRange: this.__transformDataType(this._config.outputRange),
      extrapolateLeft: this._config.extrapolateLeft || this._config.extrapolate || 'extend',
      extrapolateRight: this._config.extrapolateRight || this._config.extrapolate || 'extend',
      type: 'interpolation'
    };
  };

  return AnimatedInterpolation;
}(__WEBPACK_IMPORTED_MODULE_1__AnimatedWithChildren__["a" /* default */]);

AnimatedInterpolation.__createInterpolation = createInterpolation;


/* harmony default export */ __webpack_exports__["a"] = (AnimatedInterpolation);

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);

function Transform(xx, yx, xy, yy, x, y){
	if (xx && typeof xx == 'object'){
		yx = xx.yx; yy = xx.yy; y = xx.y;
		xy = xx.xy; x = xx.x; xx = xx.xx;
	}
	this.xx = xx == null ? 1 : xx;
	this.yx = yx || 0;
	this.xy = xy || 0;
	this.yy = yy == null ? 1 : yy;
	this.x = (x == null ? this.x : x) || 0;
	this.y = (y == null ? this.y : y) || 0;
	this._transform();
	return this;
};

module.exports = Class({

	initialize: Transform,

	_transform: function(){},

	xx: 1, yx: 0, x: 0,
	xy: 0, yy: 1, y: 0,

	transform: function(xx, yx, xy, yy, x, y){
		var m = this;
		if (xx && typeof xx == 'object'){
			yx = xx.yx; yy = xx.yy; y = xx.y;
			xy = xx.xy; x = xx.x; xx = xx.xx;
		}
		if (!x) x = 0;
		if (!y) y = 0;
		return this.transformTo(
			m.xx * xx + m.xy * yx,
			m.yx * xx + m.yy * yx,
			m.xx * xy + m.xy * yy,
			m.yx * xy + m.yy * yy,
			m.xx * x + m.xy * y + m.x,
			m.yx * x + m.yy * y + m.y
		);
	},

	transformTo: Transform,

	translate: function(x, y){
		return this.transform(1, 0, 0, 1, x, y);
	},

	move: function(x, y){
		this.x += x || 0;
		this.y += y || 0;
		this._transform();
		return this;
	},

	scale: function(x, y){
		if (y == null) y = x;
		return this.transform(x, 0, 0, y, 0, 0);
	},

	rotate: function(deg, x, y){
		if (x == null || y == null){
			x = (this.left || 0) + (this.width || 0) / 2;
			y = (this.top || 0) + (this.height || 0) / 2;
		}

		var rad = deg * Math.PI / 180, sin = Math.sin(rad), cos = Math.cos(rad);

		this.transform(1, 0, 0, 1, x, y);
		var m = this;

		return this.transformTo(
			cos * m.xx - sin * m.yx,
			sin * m.xx + cos * m.yx,
			cos * m.xy - sin * m.yy,
			sin * m.xy + cos * m.yy,
			m.x,
			m.y
		).transform(1, 0, 0, 1, -x, -y);
	},

	moveTo: function(x, y){
		var m = this;
		return this.transformTo(m.xx, m.yx, m.xy, m.yy, x, y);
	},

	rotateTo: function(deg, x, y){
		var m = this;
		var flip = m.yx / m.xx > m.yy / m.xy ? -1 : 1;
		if (m.xx < 0 ? m.xy >= 0 : m.xy < 0) flip = -flip;
		return this.rotate(deg - Math.atan2(flip * m.yx, flip * m.xx) * 180 / Math.PI, x, y);
	},

	scaleTo: function(x, y){
		// Normalize
		var m = this;

		var h = Math.sqrt(m.xx * m.xx + m.yx * m.yx);
		m.xx /= h; m.yx /= h;

		h = Math.sqrt(m.yy * m.yy + m.xy * m.xy);
		m.yy /= h; m.xy /= h;

		return this.scale(x, y);
	},

	resizeTo: function(width, height){
		var w = this.width, h = this.height;
		if (!w || !h) return this;
		return this.scaleTo(width / w, height / h);
	},

	/*
	inverse: function(){
		var a = this.xx, b = this.yx,
			c = this.xy, d = this.yy,
			e = this.x, f = this.y;
		if (a * d - b * c == 0) return null;
		return new Transform(
			d/(a * d-b * c), b/(b * c-a * d),
			c/(b * c-a * d), a/(a * d-b * c),
			(d * e-c * f)/(b * c-a * d), (b * e-a * f)/(a * d-b * c)
		);
	},
	*/

	inversePoint: function(x, y){
		var a = this.xx, b = this.yx,
			c = this.xy, d = this.yy,
			e = this.x, f = this.y;
		var det = b * c - a * d;
		if (det == 0) return null;
		return {
			x: (d * (e - x) + c * (y - f)) / det,
			y: (a * (f - y) + b * (x - e)) / det
		};
	},

	point: function(x, y){
		var m = this;
		return {
			x: m.xx * x + m.xy * y + m.x,
			y: m.yx * x + m.yy * y + m.y
		};
	}	

});


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(94),
    getRawTag = __webpack_require__(773),
    objectToString = __webpack_require__(774);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(787),
    getValue = __webpack_require__(790);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KEY_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FLUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REHYDRATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAUSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PERSIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PURGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REGISTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_VERSION; });
var KEY_PREFIX = 'persist:';
var FLUSH = 'persist/FLUSH';
var REHYDRATE = 'persist/REHYDRATE';
var PAUSE = 'persist/PAUSE';
var PERSIST = 'persist/PERSIST';
var PURGE = 'persist/PURGE';
var REGISTER = 'persist/REGISTER';
var DEFAULT_VERSION = -1;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);
var _modules=__webpack_require__(19);












var _FontUtils=__webpack_require__(367);var _FontUtils2=_interopRequireDefault(_FontUtils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Icon=function(_Component){_inherits(Icon,_Component);

function Icon(props){_classCallCheck(this,Icon);var _this=_possibleConstructorReturn(this,(Icon.__proto__||Object.getPrototypeOf(Icon)).call(this,
props));

_this.state={};return _this;
}_createClass(Icon,[{key:'componentWillMount',value:function componentWillMount()

{
if(_reactNative.Platform.OS!=='web'){
return;
}var

type=this.props.type;
switch(type){
case'Entypo':{
_FontUtils2.default.importEntypo();
}
case'EvilIcons':{
_FontUtils2.default.importEvilIcons();
}
case'Feather':{
_FontUtils2.default.importFeather();
}
case'FontAwesome':{
_FontUtils2.default.importFontAwesome();
}
case'Foundation':{
_FontUtils2.default.importFoundation();
}
case'Ionicons':{
_FontUtils2.default.importIonicons();
}
case'MaterialCommunityIcons':{
_FontUtils2.default.importMaterialCommunityIcons();
}
case'MaterialIcons':{
_FontUtils2.default.importMaterialIcons();
}
case'Octicons':{
_FontUtils2.default.importOcticons();
}
case'SimpleLineIcons':{
_FontUtils2.default.importSimpleLineIcons();
}
case'Zocial':{
_FontUtils2.default.importZocial();
}}

}},{key:'componentDidMount',value:function componentDidMount()

{
}},{key:'componentWillUnmount',value:function componentWillUnmount()

{
}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(

nextProps){
}},{key:'render',value:function render()

{var
type=this.props.type;
switch(type){
case'Entypo':{
return(
_react2.default.createElement(_modules.EntypoIcon,
this.props));

}
case'EvilIcons':{
return(
_react2.default.createElement(_modules.EvilIconsIcon,
this.props));

}
case'Feather':{
return(
_react2.default.createElement(_modules.FeatherIcon,
this.props));

}
case'FontAwesome':{
return(
_react2.default.createElement(_modules.FontAwesomeIcon,
this.props));

}
case'Foundation':{
return(
_react2.default.createElement(_modules.FoundationIcon,
this.props));

}
case'Ionicons':{
return(
_react2.default.createElement(_modules.IoniconsIcon,
this.props));

}
case'MaterialCommunityIcons':{
return(
_react2.default.createElement(_modules.MaterialCommunityIconsIcon,
this.props));

}
case'MaterialIcons':{
return(
_react2.default.createElement(_modules.MaterialIconsIcon,
this.props));

}
case'Octicons':{
return(
_react2.default.createElement(_modules.OcticonsIcon,
this.props));

}
case'SimpleLineIcons':{
return(
_react2.default.createElement(_modules.SimpleLineIconsIcon,
this.props));

}
case'Zocial':{
return(
_react2.default.createElement(_modules.ZocialIcon,
this.props));

}
default:{
return null;
}}

}}]);return Icon;}(_react.Component);exports.default=


Icon;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(16).f;
var has = __webpack_require__(29);
var TAG = __webpack_require__(11)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(48);
var fails = __webpack_require__(7);
var spaces = __webpack_require__(149);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(1);
var factory = __webpack_require__(658);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);

module.exports = Class({

	grab: function(){
		for (var i = 0; i < arguments.length; i++) arguments[i].inject(this);
		return this;
	},

	empty: function(){
		var node;
		while (node = this.firstChild) node.eject();
		return this;
	}

});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

var VMLCSS = 'behavior:url(#default#VML);display:inline-block;position:absolute;left:0px;top:0px;';

var styleSheet, styledTags = {}, styleTag = function(tag){
	if (styleSheet) styledTags[tag] = styleSheet.addRule('av\\:' + tag, VMLCSS);
};

exports.init = function(document){

	var namespaces;
	try { // IE9 workaround: sometimes it throws here
		namespaces = document.namespaces;
	} catch (e) {
	}
	if (!namespaces) return false;

	namespaces.add('av', 'urn:schemas-microsoft-com:vml');
	namespaces.add('ao', 'urn:schemas-microsoft-com:office:office');

	styleSheet = document.createStyleSheet();
	styleSheet.addRule('vml', 'display:inline-block;position:relative;overflow:hidden;');
/*	styleTag('skew');
	styleTag('fill');
	styleTag('stroke');
	styleTag('path');
	styleTag('textpath');
	styleTag('group');*/

	styleTag('vml');

	return true;

};

exports.createElement = function(tag){
	if (!(tag in styledTags)) styleTag(tag);
	return document.createElement('av:' + tag);
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(54);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 95 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(55),
    isKey = __webpack_require__(836),
    stringToPath = __webpack_require__(837),
    toString = __webpack_require__(840);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Empty=function(_Component){_inherits(Empty,_Component);

function Empty(props){_classCallCheck(this,Empty);var _this=_possibleConstructorReturn(this,(Empty.__proto__||Object.getPrototypeOf(Empty)).call(this,
props));_this.













_handleClick=function(){var
onClick=_this.props.onClick;
if(onClick){
onClick();
}
};_this.state={};return _this;}_createClass(Empty,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'render',value:function render()

{var _props=
this.props,text=_props.text,style=_props.style;
return(
_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
onPress:this._handleClick,
style:[styles.empty,style]},
_react2.default.createElement(_reactNative.Text,{
style:styles.emptyText},
text)));



}}]);return Empty;}(_react.Component);


var styles=_reactNative.StyleSheet.create({
empty:{
position:'absolute',
top:0,left:0,bottom:0,right:0,
justifyContent:'center',
alignItems:'center',
backgroundColor:'#f6efdb'},

emptyText:{
margin:12,
color:'#ff0000',
fontSize:17,
fontWeight:'500',
backgroundColor:'transparent'}});exports.default=



Empty;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

LoadingIndicator=function(_Component){_inherits(LoadingIndicator,_Component);

function LoadingIndicator(props){_classCallCheck(this,LoadingIndicator);var _this=_possibleConstructorReturn(this,(LoadingIndicator.__proto__||Object.getPrototypeOf(LoadingIndicator)).call(this,
props));

_this.state={};return _this;
}_createClass(LoadingIndicator,[{key:'componentDidMount',value:function componentDidMount()

{
}},{key:'componentWillUnmount',value:function componentWillUnmount()

{
}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(

nextProps){
}},{key:'render',value:function render()

{
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#6b7adc',
size:'large',
style:styles.indicator})));


}}]);return LoadingIndicator;}(_react.Component);


var styles=_reactNative.StyleSheet.create({
container:{
position:'absolute',
top:0,left:0,bottom:0,right:0,
justifyContent:'center',
alignItems:'center'},

indicator:{}});exports.default=


LoadingIndicator;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(41);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(41);
var TAG = __webpack_require__(11)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_AnimationPropTypes__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_BorderPropTypes__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColorPropType__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_InteractionPropTypes__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_LayoutPropTypes__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_ShadowPropTypes__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_TransformPropTypes__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */










var overscrollBehaviorType = Object(__WEBPACK_IMPORTED_MODULE_7_prop_types__["oneOf"])(['auto', 'contain', 'none']);

var ViewStylePropTypes = Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__modules_AnimationPropTypes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__modules_BorderPropTypes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__modules_InteractionPropTypes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__modules_LayoutPropTypes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__modules_ShadowPropTypes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__modules_TransformPropTypes__["a" /* default */], {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_2__ColorPropType__["a" /* default */],
  opacity: __WEBPACK_IMPORTED_MODULE_7_prop_types__["number"],
  /**
   * @platform unsupported
   */
  elevation: __WEBPACK_IMPORTED_MODULE_7_prop_types__["number"],
  /**
   * @platform web
   */
  backgroundAttachment: __WEBPACK_IMPORTED_MODULE_7_prop_types__["string"],
  backgroundBlendMode: __WEBPACK_IMPORTED_MODULE_7_prop_types__["string"],
  backgroundClip: __WEBPACK_IMPORTED_MODULE_7_prop_types__["string"],
  backgroundImage: __WEBPACK_IMPORTED_MODULE_7_prop_types__["string"],
  backgroundOrigin: Object(__WEBPACK_IMPORTED_MODULE_7_prop_types__["oneOf"])(['border-box', 'content-box', 'padding-box']),
  backgroundPosition: __WEBPACK_IMPORTED_MODULE_7_prop_types__["string"],
  backgroundRepeat: __WEBPACK_IMPORTED_MODULE_7_prop_types__["string"],
  backgroundSize: __WEBPACK_IMPORTED_MODULE_7_prop_types__["string"],
  boxShadow: __WEBPACK_IMPORTED_MODULE_7_prop_types__["string"],
  clip: __WEBPACK_IMPORTED_MODULE_7_prop_types__["string"],
  filter: __WEBPACK_IMPORTED_MODULE_7_prop_types__["string"],
  outline: __WEBPACK_IMPORTED_MODULE_7_prop_types__["string"],
  outlineColor: __WEBPACK_IMPORTED_MODULE_2__ColorPropType__["a" /* default */],
  overscrollBehavior: overscrollBehaviorType,
  overscrollBehaviorX: overscrollBehaviorType,
  overscrollBehaviorY: overscrollBehaviorType,
  WebkitMaskImage: __WEBPACK_IMPORTED_MODULE_7_prop_types__["string"],
  WebkitOverflowScrolling: Object(__WEBPACK_IMPORTED_MODULE_7_prop_types__["oneOf"])(['auto', 'touch'])
});

/* harmony default export */ __webpack_exports__["a"] = (ViewStylePropTypes);

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStrictShapeTypeChecker__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports_StyleSheet__ = __webpack_require__(12);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




function StyleSheetPropType(shape) {
  var shapePropType = Object(__WEBPACK_IMPORTED_MODULE_0__createStrictShapeTypeChecker__["a" /* default */])(shape);
  return function (props, propName, componentName, location) {
    var newProps = props;
    if (props[propName]) {
      // Just make a dummy prop object with only the flattened style
      newProps = {};
      var flatStyle = __WEBPACK_IMPORTED_MODULE_1__exports_StyleSheet__["a" /* default */].flatten(props[propName]);
      // Remove custom properties from check
      var nextStyle = Object.keys(flatStyle).reduce(function (acc, curr) {
        if (curr.indexOf('--') !== 0) {
          acc[curr] = flatStyle[curr];
        }
        return acc;
      }, {});
      newProps[propName] = nextStyle;
    }

    for (var _len = arguments.length, rest = Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
      rest[_key - 4] = arguments[_key];
    }

    return shapePropType.apply(undefined, [newProps, propName, componentName, location].concat(rest));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (StyleSheetPropType);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var Platform = {
  OS: 'web',
  select: function select(obj) {
    return 'web' in obj ? obj.web : obj.default;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Platform);

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_dismissKeyboard__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__findNodeHandle__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_ScrollResponder__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ScrollViewBase__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ViewPropTypes__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */













var emptyObject = {};

/* eslint-disable react/prefer-es6-class, react/prop-types */
var ScrollView = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'ScrollView',

  propTypes: Object.assign({}, __WEBPACK_IMPORTED_MODULE_8__ViewPropTypes__["a" /* default */], {
    contentContainerStyle: __WEBPACK_IMPORTED_MODULE_8__ViewPropTypes__["a" /* default */].style,
    horizontal: __WEBPACK_IMPORTED_MODULE_10_prop_types__["bool"],
    keyboardDismissMode: Object(__WEBPACK_IMPORTED_MODULE_10_prop_types__["oneOf"])(['none', 'interactive', 'on-drag']),
    onContentSizeChange: __WEBPACK_IMPORTED_MODULE_10_prop_types__["func"],
    onScroll: __WEBPACK_IMPORTED_MODULE_10_prop_types__["func"],
    pagingEnabled: __WEBPACK_IMPORTED_MODULE_10_prop_types__["bool"],
    refreshControl: __WEBPACK_IMPORTED_MODULE_10_prop_types__["element"],
    scrollEnabled: __WEBPACK_IMPORTED_MODULE_10_prop_types__["bool"],
    scrollEventThrottle: __WEBPACK_IMPORTED_MODULE_10_prop_types__["number"],
    stickyHeaderIndices: Object(__WEBPACK_IMPORTED_MODULE_10_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_10_prop_types__["number"]),
    style: __WEBPACK_IMPORTED_MODULE_8__ViewPropTypes__["a" /* default */].style
  }),

  mixins: [__WEBPACK_IMPORTED_MODULE_4__modules_ScrollResponder__["a" /* default */].Mixin],

  getInitialState: function getInitialState() {
    return this.scrollResponderMixinGetInitialState();
  },
  flashScrollIndicators: function flashScrollIndicators() {
    this.scrollResponderFlashScrollIndicators();
  },
  setNativeProps: function setNativeProps(props) {
    if (this._scrollViewRef) {
      this._scrollViewRef.setNativeProps(props);
    }
  },


  /**
   * Returns a reference to the underlying scroll responder, which supports
   * operations like `scrollTo`. All ScrollView-like components should
   * implement this method so that they can be composed while providing access
   * to the underlying scroll responder's methods.
   */
  getScrollResponder: function getScrollResponder() {
    return this;
  },
  getScrollableNode: function getScrollableNode() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__findNodeHandle__["a" /* default */])(this._scrollViewRef);
  },
  getInnerViewNode: function getInnerViewNode() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__findNodeHandle__["a" /* default */])(this._innerViewRef);
  },


  /**
   * Scrolls to a given x, y offset, either immediately or with a smooth animation.
   * Syntax:
   *
   * scrollTo(options: {x: number = 0; y: number = 0; animated: boolean = true})
   *
   * Note: The weird argument signature is due to the fact that, for historical reasons,
   * the function also accepts separate arguments as as alternative to the options object.
   * This is deprecated due to ambiguity (y before x), and SHOULD NOT BE USED.
   */
  scrollTo: function scrollTo(y, x, animated) {
    if (typeof y === 'number') {
      console.warn('`scrollTo(y, x, animated)` is deprecated. Use `scrollTo({x: 5, y: 5, animated: true})` instead.');
    } else {
      var _ref = y || emptyObject;

      x = _ref.x;
      y = _ref.y;
      animated = _ref.animated;
    }

    this.getScrollResponder().scrollResponderScrollTo({
      x: x || 0,
      y: y || 0,
      animated: animated !== false
    });
  },


  /**
   * If this is a vertical ScrollView scrolls to the bottom.
   * If this is a horizontal ScrollView scrolls to the right.
   *
   * Use `scrollToEnd({ animated: true })` for smooth animated scrolling,
   * `scrollToEnd({ animated: false })` for immediate scrolling.
   * If no options are passed, `animated` defaults to true.
   */
  scrollToEnd: function scrollToEnd(options) {
    // Default to true
    var animated = (options && options.animated) !== false;
    var horizontal = this.props.horizontal;

    var scrollResponder = this.getScrollResponder();
    var scrollResponderNode = scrollResponder.scrollResponderGetScrollableNode();
    var x = horizontal ? scrollResponderNode.scrollWidth : 0;
    var y = horizontal ? 0 : scrollResponderNode.scrollHeight;
    scrollResponder.scrollResponderScrollTo({ x: x, y: y, animated: animated });
  },


  /**
   * Deprecated, do not use.
   */
  scrollWithoutAnimationTo: function scrollWithoutAnimationTo() {
    var y = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    console.warn('`scrollWithoutAnimationTo` is deprecated. Use `scrollTo` instead');
    this.scrollTo({ x: x, y: y, animated: false });
  },
  render: function render() {
    var _props = this.props,
        contentContainerStyle = _props.contentContainerStyle,
        horizontal = _props.horizontal,
        onContentSizeChange = _props.onContentSizeChange,
        refreshControl = _props.refreshControl,
        stickyHeaderIndices = _props.stickyHeaderIndices,
        keyboardDismissMode = _props.keyboardDismissMode,
        onScroll = _props.onScroll,
        pagingEnabled = _props.pagingEnabled,
        other = _objectWithoutProperties(_props, ['contentContainerStyle', 'horizontal', 'onContentSizeChange', 'refreshControl', 'stickyHeaderIndices', 'keyboardDismissMode', 'onScroll', 'pagingEnabled']);

    if (false) {
      var style = StyleSheet.flatten(this.props.style);
      var childLayoutProps = ['alignItems', 'justifyContent'].filter(function (prop) {
        return style && style[prop] !== undefined;
      });
      invariant(childLayoutProps.length === 0, 'ScrollView child layout (' + JSON.stringify(childLayoutProps) + ') ' + 'must be applied through the contentContainerStyle prop.');
    }

    var contentSizeChangeProps = {};
    if (onContentSizeChange) {
      contentSizeChangeProps = {
        onLayout: this._handleContentOnLayout
      };
    }

    var children = !horizontal && Array.isArray(stickyHeaderIndices) ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.Children.map(this.props.children, function (child, i) {
      if (stickyHeaderIndices.indexOf(i) > -1) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.cloneElement(child, { style: [child.props.style, styles.stickyHeader] });
      } else {
        return child;
      }
    }) : this.props.children;

    var contentContainer = __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__View__["a" /* default */], _extends({}, contentSizeChangeProps, {
      children: children,
      collapsable: false,
      ref: this._setInnerViewRef,
      style: [horizontal && styles.contentContainerHorizontal, contentContainerStyle]
    }));

    var baseStyle = horizontal ? styles.baseHorizontal : styles.baseVertical;

    var props = Object.assign({}, other, {
      style: [baseStyle, this.props.style],
      onTouchStart: this.scrollResponderHandleTouchStart,
      onTouchMove: this.scrollResponderHandleTouchMove,
      onTouchEnd: this.scrollResponderHandleTouchEnd,
      onScrollBeginDrag: this.scrollResponderHandleScrollBeginDrag,
      onScrollEndDrag: this.scrollResponderHandleScrollEndDrag,
      onMomentumScrollBegin: this.scrollResponderHandleMomentumScrollBegin,
      onMomentumScrollEnd: this.scrollResponderHandleMomentumScrollEnd,
      onStartShouldSetResponder: this.scrollResponderHandleStartShouldSetResponder,
      onStartShouldSetResponderCapture: this.scrollResponderHandleStartShouldSetResponderCapture,
      onScrollShouldSetResponder: this.scrollResponderHandleScrollShouldSetResponder,
      onScroll: this._handleScroll,
      onResponderGrant: this.scrollResponderHandleResponderGrant,
      onResponderTerminationRequest: this.scrollResponderHandleTerminationRequest,
      onResponderTerminate: this.scrollResponderHandleTerminate,
      onResponderRelease: this.scrollResponderHandleResponderRelease,
      onResponderReject: this.scrollResponderHandleResponderReject
    });

    var ScrollViewClass = __WEBPACK_IMPORTED_MODULE_5__ScrollViewBase__["a" /* default */];

    __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(ScrollViewClass !== undefined, 'ScrollViewClass must not be undefined');

    if (refreshControl) {
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.cloneElement(refreshControl, { style: props.style }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        ScrollViewClass,
        _extends({}, props, { ref: this._setScrollViewRef, style: baseStyle }),
        contentContainer
      ));
    }

    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      ScrollViewClass,
      _extends({}, props, { ref: this._setScrollViewRef, style: props.style }),
      contentContainer
    );
  },
  _handleContentOnLayout: function _handleContentOnLayout(e) {
    var _e$nativeEvent$layout = e.nativeEvent.layout,
        width = _e$nativeEvent$layout.width,
        height = _e$nativeEvent$layout.height;

    this.props.onContentSizeChange(width, height);
  },
  _handleScroll: function _handleScroll(e) {
    if (false) {
      if (this.props.onScroll && !this.props.scrollEventThrottle) {
        console.log('You specified `onScroll` on a <ScrollView> but not ' + '`scrollEventThrottle`. You will only receive one event. ' + 'Using `16` you get all the events but be aware that it may ' + "cause frame drops, use a bigger number if you don't need as " + 'much precision.');
      }
    }

    if (this.props.keyboardDismissMode === 'on-drag') {
      Object(__WEBPACK_IMPORTED_MODULE_1__modules_dismissKeyboard__["a" /* default */])();
    }

    this.scrollResponderHandleScroll(e);
  },
  _setInnerViewRef: function _setInnerViewRef(component) {
    this._innerViewRef = component;
  },
  _setScrollViewRef: function _setScrollViewRef(component) {
    this._scrollViewRef = component;
  }
});

var commonStyle = {
  flexGrow: 1,
  flexShrink: 1,
  // Enable hardware compositing in modern browsers.
  // Creates a new layer with its own backing surface that can significantly
  // improve scroll performance.
  transform: [{ translateZ: 0 }],
  // iOS native scrolling
  WebkitOverflowScrolling: 'touch'
};

var styles = __WEBPACK_IMPORTED_MODULE_6__StyleSheet__["a" /* default */].create({
  baseVertical: Object.assign({}, commonStyle, {
    flexDirection: 'column',
    overflowX: 'hidden',
    overflowY: 'auto',
    touchAction: 'pan-y'
  }),
  baseHorizontal: Object.assign({}, commonStyle, {
    flexDirection: 'row',
    overflowX: 'auto',
    overflowY: 'hidden',
    touchAction: 'pan-x'
  }),
  contentContainerHorizontal: {
    flexDirection: 'row'
  },
  stickyHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 10
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ScrollView);

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(201),
    baseAssignValue = __webpack_require__(332);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 111 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var updateCredential=exports.updateCredential=function updateCredential(credential){
return{
type:'updateCredential',
credential:credential};

};

var updateInfo=exports.updateInfo=function updateInfo(info){
return{
type:'updateInfo',
info:info};

};

var updatePromoCode=exports.updatePromoCode=function updatePromoCode(promoCode){
return{
type:'updatePromoCode',
promoCode:promoCode};

};

var signOut=exports.signOut=function signOut(){
return{
type:'signOut'};

};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}

var ADMIN_ROLE='admin';
var AGENCY_ROLE='agency';
var PARTNER_ROLE='partner';
var SALESMAN_ROLE='salesman';
var MARKETER_ROLE='marketer';var

UserManager=function(){function UserManager(){var _this=this;_classCallCheck(this,UserManager);this.









initialize=function(user){
_this._user=user;
};this.

updateUser=function(user){
_this._user=user;
};this.












isAdmin=function(){
return _this._user&&_this._user.info&&_this._user.info.role===ADMIN_ROLE;
};this.

isAgency=function(user){
return _this._user&&_this._user.info&&_this._user.info.role===
AGENCY_ROLE;
};this.

isPartner=function(){
return _this._user&&_this._user.info&&_this._user.info.role===
PARTNER_ROLE;
};this.

isSeller=function(){
return _this._user&&_this._user.info&&(
_this._user.info.role===AGENCY_ROLE||
_this._user.info.role===PARTNER_ROLE);
};this.

isSalesman=function(){
return _this._user&&_this._user.info&&_this._user.info.role===
SALESMAN_ROLE;
};this.

isMarketer=function(){
return _this._user&&_this._user.info&&_this._user.info.role===
MARKETER_ROLE;
};}_createClass(UserManager,[{key:'isSignedIn',value:function isSignedIn(){if(_lodash2.default.isEmpty(this._user)){return;}var _user=this._user,credential=_user.credential,info=_user.info;return!_lodash2.default.isEmpty(credential)&&!_lodash2.default.isEmpty(credential.username)&&!_lodash2.default.isEmpty(credential.password)&&!_lodash2.default.isEmpty(info);}}],[{key:'getInstance',value:function getInstance(){if(!UserManager.sharedInstance){var sharedInstance=new UserManager();UserManager.sharedInstance=sharedInstance;}return UserManager.sharedInstance;}}]);return UserManager;}();exports.default=UserManager;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(35);
var toLength = __webpack_require__(17);
var toAbsoluteIndex = __webpack_require__(71);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 115 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(41);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(8);
var cof = __webpack_require__(41);
var MATCH = __webpack_require__(11)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(11)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(5);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(30);
var redefine = __webpack_require__(31);
var fails = __webpack_require__(7);
var defined = __webpack_require__(48);
var wks = __webpack_require__(11);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(5);
var aFunction = __webpack_require__(25);
var SPECIES = __webpack_require__(11)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(6);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(31);
var redefineAll = __webpack_require__(77);
var meta = __webpack_require__(63);
var forOf = __webpack_require__(76);
var anInstance = __webpack_require__(75);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(7);
var $iterDetect = __webpack_require__(118);
var setToStringTag = __webpack_require__(86);
var inheritIfRequired = __webpack_require__(150);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var hide = __webpack_require__(30);
var uid = __webpack_require__(68);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(69) || !__webpack_require__(7)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(6)[K];
});


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(25);
var ctx = __webpack_require__(40);
var forOf = __webpack_require__(76);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var doLeftAndRightSwapInRTL = true;
var isPreferredLanguageRTL = false;
var isRTLAllowed = true;
var isRTLForced = false;

var isRTL = function isRTL() {
  if (isRTLForced) {
    return true;
  }
  return isRTLAllowed && isPreferredLanguageRTL;
};

var onDirectionChange = function onDirectionChange() {
  if (__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment___default.a.canUseDOM) {
    if (document.documentElement && document.documentElement.setAttribute) {
      document.documentElement.setAttribute('dir', isRTL() ? 'rtl' : 'ltr');
    }
  }
};

var I18nManager = {
  allowRTL: function allowRTL(bool) {
    isRTLAllowed = bool;
    onDirectionChange();
  },
  forceRTL: function forceRTL(bool) {
    isRTLForced = bool;
    onDirectionChange();
  },
  setPreferredLanguageRTL: function setPreferredLanguageRTL(bool) {
    isPreferredLanguageRTL = bool;
    onDirectionChange();
  },
  swapLeftAndRightInRTL: function swapLeftAndRightInRTL(bool) {
    doLeftAndRightSwapInRTL = bool;
  },

  get doLeftAndRightSwapInRTL() {
    return doLeftAndRightSwapInRTL;
  },
  get isRTL() {
    return isRTL();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (I18nManager);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_requestIdleCallback__ = __webpack_require__(639);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var InteractionManager = {
  Events: {
    interactionStart: 'interactionStart',
    interactionComplete: 'interactionComplete'
  },

  /**
   * Schedule a function to run after all interactions have completed.
   */
  runAfterInteractions: function runAfterInteractions(task) {
    var handle = void 0;

    var promise = new Promise(function (resolve) {
      handle = Object(__WEBPACK_IMPORTED_MODULE_1__modules_requestIdleCallback__["b" /* default */])(function () {
        if (task) {
          resolve(task());
        }
      });
    });
    return {
      then: promise.then.bind(promise),
      done: promise.then.bind(promise),
      cancel: function cancel() {
        Object(__WEBPACK_IMPORTED_MODULE_1__modules_requestIdleCallback__["a" /* cancelIdleCallback */])(handle);
      }
    };
  },


  /**
   * Notify manager that an interaction has started.
   */
  createInteractionHandle: function createInteractionHandle() {
    return 1;
  },


  /**
   * Notify manager that an interaction has completed.
   */
  clearInteractionHandle: function clearInteractionHandle(handle) {
    __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(!!handle, 'Must provide a handle to clear.');
  },


  addListener: function addListener() {}
};

/* harmony default export */ __webpack_exports__["a"] = (InteractionManager);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debounce__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





var win = __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__["canUseDOM"] ? window : {
  devicePixelRatio: undefined,
  innerHeight: undefined,
  innerWidth: undefined,
  screen: {
    height: undefined,
    width: undefined
  }
};

var dimensions = {};
var listeners = {};

var Dimensions = function () {
  function Dimensions() {
    _classCallCheck(this, Dimensions);
  }

  Dimensions.get = function get(dimension) {
    __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(dimensions[dimension], 'No dimension set for key ' + dimension);
    return dimensions[dimension];
  };

  Dimensions.set = function set(initialDimensions) {
    if (initialDimensions) {
      if (__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__["canUseDOM"]) {
        __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(false, 'Dimensions cannot be set in the browser');
      } else {
        dimensions.screen = initialDimensions.screen;
        dimensions.window = initialDimensions.window;
      }
    }
  };

  Dimensions._update = function _update() {
    dimensions.window = {
      fontScale: 1,
      height: win.innerHeight,
      scale: win.devicePixelRatio || 1,
      width: win.innerWidth
    };

    dimensions.screen = {
      fontScale: 1,
      height: win.screen.height,
      scale: win.devicePixelRatio || 1,
      width: win.screen.width
    };

    if (Array.isArray(listeners['change'])) {
      listeners['change'].forEach(function (handler) {
        return handler(dimensions);
      });
    }
  };

  Dimensions.addEventListener = function addEventListener(type, handler) {
    listeners[type] = listeners[type] || [];
    listeners[type].push(handler);
  };

  Dimensions.removeEventListener = function removeEventListener(type, handler) {
    if (Array.isArray(listeners[type])) {
      listeners[type] = listeners[type].filter(function (_handler) {
        return _handler !== handler;
      });
    }
  };

  return Dimensions;
}();

/* harmony default export */ __webpack_exports__["a"] = (Dimensions);


Dimensions._update();

if (__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__["canUseDOM"]) {
  window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_1_debounce___default()(Dimensions._update, 16), false);
}

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_AccessibilityUtil__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BoundingDimensions__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__findNodeHandle__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalize_css_color__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalize_css_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_normalize_css_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Position__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fbjs_lib_TouchEventUtils__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fbjs_lib_TouchEventUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_fbjs_lib_TouchEventUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UIManager__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__View__ = __webpack_require__(13);
/* eslint-disable react/prop-types */

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */











/**
 * `Touchable`: Taps done right.
 *
 * You hook your `ResponderEventPlugin` events into `Touchable`. `Touchable`
 * will measure time/geometry and tells you when to give feedback to the user.
 *
 * ====================== Touchable Tutorial ===============================
 * The `Touchable` mixin helps you handle the "press" interaction. It analyzes
 * the geometry of elements, and observes when another responder (scroll view
 * etc) has stolen the touch lock. It notifies your component when it should
 * give feedback to the user. (bouncing/highlighting/unhighlighting).
 *
 * - When a touch was activated (typically you highlight)
 * - When a touch was deactivated (typically you unhighlight)
 * - When a touch was "pressed" - a touch ended while still within the geometry
 *   of the element, and no other element (like scroller) has "stolen" touch
 *   lock ("responder") (Typically you bounce the element).
 *
 * A good tap interaction isn't as simple as you might think. There should be a
 * slight delay before showing a highlight when starting a touch. If a
 * subsequent touch move exceeds the boundary of the element, it should
 * unhighlight, but if that same touch is brought back within the boundary, it
 * should rehighlight again. A touch can move in and out of that boundary
 * several times, each time toggling highlighting, but a "press" is only
 * triggered if that touch ends while within the element's boundary and no
 * scroller (or anything else) has stolen the lock on touches.
 *
 * To create a new type of component that handles interaction using the
 * `Touchable` mixin, do the following:
 *
 * - Initialize the `Touchable` state.
 *
 *   getInitialState: function() {
 *     return merge(this.touchableGetInitialState(), yourComponentState);
 *   }
 *
 * - Choose the rendered component who's touches should start the interactive
 *   sequence. On that rendered node, forward all `Touchable` responder
 *   handlers. You can choose any rendered node you like. Choose a node whose
 *   hit target you'd like to instigate the interaction sequence:
 *
 *   // In render function:
 *   return (
 *     <View
 *       onStartShouldSetResponder={this.touchableHandleStartShouldSetResponder}
 *       onResponderTerminationRequest={this.touchableHandleResponderTerminationRequest}
 *       onResponderGrant={this.touchableHandleResponderGrant}
 *       onResponderMove={this.touchableHandleResponderMove}
 *       onResponderRelease={this.touchableHandleResponderRelease}
 *       onResponderTerminate={this.touchableHandleResponderTerminate}>
 *       <View>
 *         Even though the hit detection/interactions are triggered by the
 *         wrapping (typically larger) node, we usually end up implementing
 *         custom logic that highlights this inner one.
 *       </View>
 *     </View>
 *   );
 *
 * - You may set up your own handlers for each of these events, so long as you
 *   also invoke the `touchable*` handlers inside of your custom handler.
 *
 * - Implement the handlers on your component class in order to provide
 *   feedback to the user. See documentation for each of these class methods
 *   that you should implement.
 *
 *   touchableHandlePress: function() {
 *      this.performBounceAnimation();  // or whatever you want to do.
 *   },
 *   touchableHandleActivePressIn: function() {
 *     this.beginHighlighting(...);  // Whatever you like to convey activation
 *   },
 *   touchableHandleActivePressOut: function() {
 *     this.endHighlighting(...);  // Whatever you like to convey deactivation
 *   },
 *
 * - There are more advanced methods you can implement (see documentation below):
 *   touchableGetHighlightDelayMS: function() {
 *     return 20;
 *   }
 *   // In practice, *always* use a predeclared constant (conserve memory).
 *   touchableGetPressRectOffset: function() {
 *     return {top: 20, left: 20, right: 20, bottom: 100};
 *   }
 */

/**
 * Touchable states.
 */
var States = {
  NOT_RESPONDER: 'NOT_RESPONDER', // Not the responder
  RESPONDER_INACTIVE_PRESS_IN: 'RESPONDER_INACTIVE_PRESS_IN', // Responder, inactive, in the `PressRect`
  RESPONDER_INACTIVE_PRESS_OUT: 'RESPONDER_INACTIVE_PRESS_OUT', // Responder, inactive, out of `PressRect`
  RESPONDER_ACTIVE_PRESS_IN: 'RESPONDER_ACTIVE_PRESS_IN', // Responder, active, in the `PressRect`
  RESPONDER_ACTIVE_PRESS_OUT: 'RESPONDER_ACTIVE_PRESS_OUT', // Responder, active, out of `PressRect`
  RESPONDER_ACTIVE_LONG_PRESS_IN: 'RESPONDER_ACTIVE_LONG_PRESS_IN', // Responder, active, in the `PressRect`, after long press threshold
  RESPONDER_ACTIVE_LONG_PRESS_OUT: 'RESPONDER_ACTIVE_LONG_PRESS_OUT', // Responder, active, out of `PressRect`, after long press threshold
  ERROR: 'ERROR'
};

/**
 * Quick lookup map for states that are considered to be "active"
 */
var IsActive = {
  RESPONDER_ACTIVE_PRESS_OUT: true,
  RESPONDER_ACTIVE_PRESS_IN: true
};

/**
 * Quick lookup for states that are considered to be "pressing" and are
 * therefore eligible to result in a "selection" if the press stops.
 */
var IsPressingIn = {
  RESPONDER_INACTIVE_PRESS_IN: true,
  RESPONDER_ACTIVE_PRESS_IN: true,
  RESPONDER_ACTIVE_LONG_PRESS_IN: true
};

var IsLongPressingIn = {
  RESPONDER_ACTIVE_LONG_PRESS_IN: true
};

/**
 * Inputs to the state machine.
 */
var Signals = {
  DELAY: 'DELAY',
  RESPONDER_GRANT: 'RESPONDER_GRANT',
  RESPONDER_RELEASE: 'RESPONDER_RELEASE',
  RESPONDER_TERMINATED: 'RESPONDER_TERMINATED',
  ENTER_PRESS_RECT: 'ENTER_PRESS_RECT',
  LEAVE_PRESS_RECT: 'LEAVE_PRESS_RECT',
  LONG_PRESS_DETECTED: 'LONG_PRESS_DETECTED'
};

/**
 * Mapping from States x Signals => States
 */
var Transitions = {
  NOT_RESPONDER: {
    DELAY: States.ERROR,
    RESPONDER_GRANT: States.RESPONDER_INACTIVE_PRESS_IN,
    RESPONDER_RELEASE: States.ERROR,
    RESPONDER_TERMINATED: States.ERROR,
    ENTER_PRESS_RECT: States.ERROR,
    LEAVE_PRESS_RECT: States.ERROR,
    LONG_PRESS_DETECTED: States.ERROR
  },
  RESPONDER_INACTIVE_PRESS_IN: {
    DELAY: States.RESPONDER_ACTIVE_PRESS_IN,
    RESPONDER_GRANT: States.ERROR,
    RESPONDER_RELEASE: States.NOT_RESPONDER,
    RESPONDER_TERMINATED: States.NOT_RESPONDER,
    ENTER_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_IN,
    LEAVE_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_OUT,
    LONG_PRESS_DETECTED: States.ERROR
  },
  RESPONDER_INACTIVE_PRESS_OUT: {
    DELAY: States.RESPONDER_ACTIVE_PRESS_OUT,
    RESPONDER_GRANT: States.ERROR,
    RESPONDER_RELEASE: States.NOT_RESPONDER,
    RESPONDER_TERMINATED: States.NOT_RESPONDER,
    ENTER_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_IN,
    LEAVE_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_OUT,
    LONG_PRESS_DETECTED: States.ERROR
  },
  RESPONDER_ACTIVE_PRESS_IN: {
    DELAY: States.ERROR,
    RESPONDER_GRANT: States.ERROR,
    RESPONDER_RELEASE: States.NOT_RESPONDER,
    RESPONDER_TERMINATED: States.NOT_RESPONDER,
    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_IN,
    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_OUT,
    LONG_PRESS_DETECTED: States.RESPONDER_ACTIVE_LONG_PRESS_IN
  },
  RESPONDER_ACTIVE_PRESS_OUT: {
    DELAY: States.ERROR,
    RESPONDER_GRANT: States.ERROR,
    RESPONDER_RELEASE: States.NOT_RESPONDER,
    RESPONDER_TERMINATED: States.NOT_RESPONDER,
    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_IN,
    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_OUT,
    LONG_PRESS_DETECTED: States.ERROR
  },
  RESPONDER_ACTIVE_LONG_PRESS_IN: {
    DELAY: States.ERROR,
    RESPONDER_GRANT: States.ERROR,
    RESPONDER_RELEASE: States.NOT_RESPONDER,
    RESPONDER_TERMINATED: States.NOT_RESPONDER,
    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_IN,
    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_OUT,
    LONG_PRESS_DETECTED: States.RESPONDER_ACTIVE_LONG_PRESS_IN
  },
  RESPONDER_ACTIVE_LONG_PRESS_OUT: {
    DELAY: States.ERROR,
    RESPONDER_GRANT: States.ERROR,
    RESPONDER_RELEASE: States.NOT_RESPONDER,
    RESPONDER_TERMINATED: States.NOT_RESPONDER,
    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_IN,
    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_OUT,
    LONG_PRESS_DETECTED: States.ERROR
  },
  error: {
    DELAY: States.NOT_RESPONDER,
    RESPONDER_GRANT: States.RESPONDER_INACTIVE_PRESS_IN,
    RESPONDER_RELEASE: States.NOT_RESPONDER,
    RESPONDER_TERMINATED: States.NOT_RESPONDER,
    ENTER_PRESS_RECT: States.NOT_RESPONDER,
    LEAVE_PRESS_RECT: States.NOT_RESPONDER,
    LONG_PRESS_DETECTED: States.NOT_RESPONDER
  }
};

// ==== Typical Constants for integrating into UI components ====
// var HIT_EXPAND_PX = 20;
// var HIT_VERT_OFFSET_PX = 10;
var HIGHLIGHT_DELAY_MS = 130;

var PRESS_EXPAND_PX = 20;

var LONG_PRESS_THRESHOLD = 500;

var LONG_PRESS_DELAY_MS = LONG_PRESS_THRESHOLD - HIGHLIGHT_DELAY_MS;

var LONG_PRESS_ALLOWED_MOVEMENT = 10;

// Default amount "active" region protrudes beyond box

/**
 * By convention, methods prefixed with underscores are meant to be @private,
 * and not @protected. Mixers shouldn't access them - not even to provide them
 * as callback handlers.
 *
 *
 * ========== Geometry =========
 * `Touchable` only assumes that there exists a `HitRect` node. The `PressRect`
 * is an abstract box that is extended beyond the `HitRect`.
 *
 *  +--------------------------+
 *  |                          | - "Start" events in `HitRect` cause `HitRect`
 *  |  +--------------------+  |   to become the responder.
 *  |  |  +--------------+  |  | - `HitRect` is typically expanded around
 *  |  |  |              |  |  |   the `VisualRect`, but shifted downward.
 *  |  |  |  VisualRect  |  |  | - After pressing down, after some delay,
 *  |  |  |              |  |  |   and before letting up, the Visual React
 *  |  |  +--------------+  |  |   will become "active". This makes it eligible
 *  |  |     HitRect        |  |   for being highlighted (so long as the
 *  |  +--------------------+  |   press remains in the `PressRect`).
 *  |        PressRect     o   |
 *  +----------------------|---+
 *           Out Region    |
 *                         +-----+ This gap between the `HitRect` and
 *                                 `PressRect` allows a touch to move far away
 *                                 from the original hit rect, and remain
 *                                 highlighted, and eligible for a "Press".
 *                                 Customize this via
 *                                 `touchableGetPressRectOffset()`.
 *
 *
 *
 * ======= State Machine =======
 *
 * +-------------+ <---+ RESPONDER_RELEASE
 * |NOT_RESPONDER|
 * +-------------+ <---+ RESPONDER_TERMINATED
 *     +
 *     | RESPONDER_GRANT (HitRect)
 *     v
 * +---------------------------+  DELAY   +-------------------------+  T + DELAY     +------------------------------+
 * |RESPONDER_INACTIVE_PRESS_IN|+-------->|RESPONDER_ACTIVE_PRESS_IN| +------------> |RESPONDER_ACTIVE_LONG_PRESS_IN|
 * +---------------------------+          +-------------------------+                +------------------------------+
 *     +            ^                         +           ^                                 +           ^
 *     |LEAVE_      |ENTER_                   |LEAVE_     |ENTER_                           |LEAVE_     |ENTER_
 *     |PRESS_RECT  |PRESS_RECT               |PRESS_RECT |PRESS_RECT                       |PRESS_RECT |PRESS_RECT
 *     |            |                         |           |                                 |           |
 *     v            +                         v           +                                 v           +
 * +----------------------------+  DELAY  +--------------------------+               +-------------------------------+
 * |RESPONDER_INACTIVE_PRESS_OUT|+------->|RESPONDER_ACTIVE_PRESS_OUT|               |RESPONDER_ACTIVE_LONG_PRESS_OUT|
 * +----------------------------+         +--------------------------+               +-------------------------------+
 *
 * T + DELAY => LONG_PRESS_DELAY_MS + DELAY
 *
 * Not drawn are the side effects of each transition. The most important side
 * effect is the `touchableHandlePress` abstract method invocation that occurs
 * when a responder is released while in either of the "Press" states.
 *
 * The other important side effects are the highlight abstract method
 * invocations (internal callbacks) to be implemented by the mixer.
 *
 *
 * @lends Touchable.prototype
 */
var TouchableMixin = {
  // HACK (part 1): basic support for touchable interactions using a keyboard
  componentDidMount: function componentDidMount() {
    var _this = this;

    this._touchableNode = Object(__WEBPACK_IMPORTED_MODULE_2__findNodeHandle__["a" /* default */])(this);
    if (this._touchableNode && this._touchableNode.addEventListener) {
      this._touchableBlurListener = function (e) {
        if (_this._isTouchableKeyboardActive) {
          if (_this.state.touchable.touchState && _this.state.touchable.touchState !== States.NOT_RESPONDER) {
            _this.touchableHandleResponderTerminate({ nativeEvent: e });
          }
          _this._isTouchableKeyboardActive = false;
        }
      };
      this._touchableNode.addEventListener('blur', this._touchableBlurListener);
    }
  },

  /**
   * Clear all timeouts on unmount
   */
  componentWillUnmount: function componentWillUnmount() {
    if (this._touchableNode && this._touchableNode.addEventListener) {
      this._touchableNode.removeEventListener('blur', this._touchableBlurListener);
    }
    this.touchableDelayTimeout && clearTimeout(this.touchableDelayTimeout);
    this.longPressDelayTimeout && clearTimeout(this.longPressDelayTimeout);
    this.pressOutDelayTimeout && clearTimeout(this.pressOutDelayTimeout);
  },

  /**
   * It's prefer that mixins determine state in this way, having the class
   * explicitly mix the state in the one and only `getInitialState` method.
   *
   * @return {object} State object to be placed inside of
   * `this.state.touchable`.
   */
  touchableGetInitialState: function touchableGetInitialState() {
    return {
      touchable: { touchState: undefined, responderID: null }
    };
  },

  // ==== Hooks to Gesture Responder system ====
  /**
   * Must return true if embedded in a native platform scroll view.
   */
  touchableHandleResponderTerminationRequest: function touchableHandleResponderTerminationRequest() {
    return !this.props.rejectResponderTermination;
  },

  /**
   * Must return true to start the process of `Touchable`.
   */
  touchableHandleStartShouldSetResponder: function touchableHandleStartShouldSetResponder() {
    return !this.props.disabled;
  },

  /**
   * Return true to cancel press on long press.
   */
  touchableLongPressCancelsPress: function touchableLongPressCancelsPress() {
    return true;
  },

  /**
   * Place as callback for a DOM element's `onResponderGrant` event.
   */
  touchableHandleResponderGrant: function touchableHandleResponderGrant(e) {
    var dispatchID = e.currentTarget;
    // Since e is used in a callback invoked on another event loop
    // (as in setTimeout etc), we need to call e.persist() on the
    // event to make sure it doesn't get reused in the event object pool.
    e.persist();
    this.pressOutDelayTimeout && clearTimeout(this.pressOutDelayTimeout);
    this.pressOutDelayTimeout = null;

    this.state.touchable.touchState = States.NOT_RESPONDER;
    this.state.touchable.responderID = dispatchID;
    this._receiveSignal(Signals.RESPONDER_GRANT, e);
    var delayMS = this.touchableGetHighlightDelayMS !== undefined ? Math.max(this.touchableGetHighlightDelayMS(), 0) : HIGHLIGHT_DELAY_MS;
    delayMS = isNaN(delayMS) ? HIGHLIGHT_DELAY_MS : delayMS;
    if (delayMS !== 0) {
      this.touchableDelayTimeout = setTimeout(this._handleDelay.bind(this, e), delayMS);
    } else {
      this.state.touchable.positionOnActivate = null;
      this._handleDelay(e);
    }

    var longDelayMS = this.touchableGetLongPressDelayMS !== undefined ? Math.max(this.touchableGetLongPressDelayMS(), 10) : LONG_PRESS_DELAY_MS;
    longDelayMS = isNaN(longDelayMS) ? LONG_PRESS_DELAY_MS : longDelayMS;
    this.longPressDelayTimeout = setTimeout(this._handleLongDelay.bind(this, e), longDelayMS + delayMS);
  },

  /**
   * Place as callback for a DOM element's `onResponderRelease` event.
   */
  touchableHandleResponderRelease: function touchableHandleResponderRelease(e) {
    this._receiveSignal(Signals.RESPONDER_RELEASE, e);
  },

  /**
   * Place as callback for a DOM element's `onResponderTerminate` event.
   */
  touchableHandleResponderTerminate: function touchableHandleResponderTerminate(e) {
    this._receiveSignal(Signals.RESPONDER_TERMINATED, e);
  },

  /**
   * Place as callback for a DOM element's `onResponderMove` event.
   */
  touchableHandleResponderMove: function touchableHandleResponderMove(e) {
    // Not enough time elapsed yet, wait for highlight -
    // this is just a perf optimization.
    if (this.state.touchable.touchState === States.RESPONDER_INACTIVE_PRESS_IN) {
      return;
    }

    // Measurement may not have returned yet.
    if (!this.state.touchable.positionOnActivate) {
      return;
    }

    var positionOnActivate = this.state.touchable.positionOnActivate;
    var dimensionsOnActivate = this.state.touchable.dimensionsOnActivate;
    var pressRectOffset = this.touchableGetPressRectOffset ? this.touchableGetPressRectOffset() : {
      left: PRESS_EXPAND_PX,
      right: PRESS_EXPAND_PX,
      top: PRESS_EXPAND_PX,
      bottom: PRESS_EXPAND_PX
    };

    var pressExpandLeft = pressRectOffset.left;
    var pressExpandTop = pressRectOffset.top;
    var pressExpandRight = pressRectOffset.right;
    var pressExpandBottom = pressRectOffset.bottom;

    var hitSlop = this.touchableGetHitSlop ? this.touchableGetHitSlop() : null;

    if (hitSlop) {
      pressExpandLeft += hitSlop.left;
      pressExpandTop += hitSlop.top;
      pressExpandRight += hitSlop.right;
      pressExpandBottom += hitSlop.bottom;
    }

    var touch = __WEBPACK_IMPORTED_MODULE_6_fbjs_lib_TouchEventUtils___default.a.extractSingleTouch(e.nativeEvent);
    var pageX = touch && touch.pageX;
    var pageY = touch && touch.pageY;

    if (this.pressInLocation) {
      var movedDistance = this._getDistanceBetweenPoints(pageX, pageY, this.pressInLocation.pageX, this.pressInLocation.pageY);
      if (movedDistance > LONG_PRESS_ALLOWED_MOVEMENT) {
        this._cancelLongPressDelayTimeout();
      }
    }

    var isTouchWithinActive = pageX > positionOnActivate.left - pressExpandLeft && pageY > positionOnActivate.top - pressExpandTop && pageX < positionOnActivate.left + dimensionsOnActivate.width + pressExpandRight && pageY < positionOnActivate.top + dimensionsOnActivate.height + pressExpandBottom;
    if (isTouchWithinActive) {
      this._receiveSignal(Signals.ENTER_PRESS_RECT, e);
      var curState = this.state.touchable.touchState;
      if (curState === States.RESPONDER_INACTIVE_PRESS_IN) {
        // fix for t7967420
        this._cancelLongPressDelayTimeout();
      }
    } else {
      this._cancelLongPressDelayTimeout();
      this._receiveSignal(Signals.LEAVE_PRESS_RECT, e);
    }
  },

  // ==== Abstract Application Callbacks ====

  /**
   * Invoked when the item should be highlighted. Mixers should implement this
   * to visually distinguish the `VisualRect` so that the user knows that
   * releasing a touch will result in a "selection" (analog to click).
   *
   * @abstract
   * touchableHandleActivePressIn: function,
   */

  /**
   * Invoked when the item is "active" (in that it is still eligible to become
   * a "select") but the touch has left the `PressRect`. Usually the mixer will
   * want to unhighlight the `VisualRect`. If the user (while pressing) moves
   * back into the `PressRect` `touchableHandleActivePressIn` will be invoked
   * again and the mixer should probably highlight the `VisualRect` again. This
   * event will not fire on an `touchEnd/mouseUp` event, only move events while
   * the user is depressing the mouse/touch.
   *
   * @abstract
   * touchableHandleActivePressOut: function
   */

  /**
   * Invoked when the item is "selected" - meaning the interaction ended by
   * letting up while the item was either in the state
   * `RESPONDER_ACTIVE_PRESS_IN` or `RESPONDER_INACTIVE_PRESS_IN`.
   *
   * @abstract
   * touchableHandlePress: function
   */

  /**
   * Invoked when the item is long pressed - meaning the interaction ended by
   * letting up while the item was in `RESPONDER_ACTIVE_LONG_PRESS_IN`. If
   * `touchableHandleLongPress` is *not* provided, `touchableHandlePress` will
   * be called as it normally is. If `touchableHandleLongPress` is provided, by
   * default any `touchableHandlePress` callback will not be invoked. To
   * override this default behavior, override `touchableLongPressCancelsPress`
   * to return false. As a result, `touchableHandlePress` will be called when
   * lifting up, even if `touchableHandleLongPress` has also been called.
   *
   * @abstract
   * touchableHandleLongPress: function
   */

  /**
   * Returns the number of millis to wait before triggering a highlight.
   *
   * @abstract
   * touchableGetHighlightDelayMS: function
   */

  /**
   * Returns the amount to extend the `HitRect` into the `PressRect`. Positive
   * numbers mean the size expands outwards.
   *
   * @abstract
   * touchableGetPressRectOffset: function
   */

  // ==== Internal Logic ====

  /**
   * Measures the `HitRect` node on activation. The Bounding rectangle is with
   * respect to viewport - not page, so adding the `pageXOffset/pageYOffset`
   * should result in points that are in the same coordinate system as an
   * event's `globalX/globalY` data values.
   *
   * - Consider caching this for the lifetime of the component, or possibly
   *   being able to share this cache between any `ScrollMap` view.
   *
   * @sideeffects
   * @private
   */
  _remeasureMetricsOnActivation: function _remeasureMetricsOnActivation() {
    var tag = this.state.touchable.responderID;
    if (tag == null) {
      return;
    }

    __WEBPACK_IMPORTED_MODULE_7__UIManager__["a" /* default */].measure(tag, this._handleQueryLayout);
  },

  _handleQueryLayout: function _handleQueryLayout(x, y, width, height, globalX, globalY) {
    // don't do anything if UIManager failed to measure node
    if (!x && !y && !width && !height && !globalX && !globalY) {
      return;
    }
    this.state.touchable.positionOnActivate && __WEBPACK_IMPORTED_MODULE_4__Position__["a" /* default */].release(this.state.touchable.positionOnActivate);
    this.state.touchable.dimensionsOnActivate &&
    // $FlowFixMe
    __WEBPACK_IMPORTED_MODULE_1__BoundingDimensions__["a" /* default */].release(this.state.touchable.dimensionsOnActivate);
    this.state.touchable.positionOnActivate = __WEBPACK_IMPORTED_MODULE_4__Position__["a" /* default */].getPooled(globalX, globalY);
    // $FlowFixMe
    this.state.touchable.dimensionsOnActivate = __WEBPACK_IMPORTED_MODULE_1__BoundingDimensions__["a" /* default */].getPooled(width, height);
  },

  _handleDelay: function _handleDelay(e) {
    this.touchableDelayTimeout = null;
    this._receiveSignal(Signals.DELAY, e);
  },

  _handleLongDelay: function _handleLongDelay(e) {
    this.longPressDelayTimeout = null;
    var curState = this.state.touchable.touchState;
    if (curState !== States.RESPONDER_ACTIVE_PRESS_IN && curState !== States.RESPONDER_ACTIVE_LONG_PRESS_IN) {
      console.error('Attempted to transition from state `' + curState + '` to `' + States.RESPONDER_ACTIVE_LONG_PRESS_IN + '`, which is not supported. This is ' + 'most likely due to `Touchable.longPressDelayTimeout` not being cancelled.');
    } else {
      this._receiveSignal(Signals.LONG_PRESS_DETECTED, e);
    }
  },

  /**
   * Receives a state machine signal, performs side effects of the transition
   * and stores the new state. Validates the transition as well.
   *
   * @param {Signals} signal State machine signal.
   * @throws Error if invalid state transition or unrecognized signal.
   * @sideeffects
   */
  _receiveSignal: function _receiveSignal(signal, e) {
    var responderID = this.state.touchable.responderID;
    var curState = this.state.touchable.touchState;
    var nextState = Transitions[curState] && Transitions[curState][signal];
    if (!responderID && signal === Signals.RESPONDER_RELEASE) {
      return;
    }
    if (!nextState) {
      throw new Error('Unrecognized signal `' + signal + '` or state `' + curState + '` for Touchable responder `' + responderID + '`');
    }
    if (nextState === States.ERROR) {
      throw new Error('Touchable cannot transition from `' + curState + '` to `' + signal + '` for responder `' + responderID + '`');
    }
    if (curState !== nextState) {
      this._performSideEffectsForTransition(curState, nextState, signal, e);
      this.state.touchable.touchState = nextState;
    }
  },

  _cancelLongPressDelayTimeout: function _cancelLongPressDelayTimeout() {
    this.longPressDelayTimeout && clearTimeout(this.longPressDelayTimeout);
    this.longPressDelayTimeout = null;
  },

  _isHighlight: function _isHighlight(state) {
    return state === States.RESPONDER_ACTIVE_PRESS_IN || state === States.RESPONDER_ACTIVE_LONG_PRESS_IN;
  },

  _savePressInLocation: function _savePressInLocation(e) {
    var touch = __WEBPACK_IMPORTED_MODULE_6_fbjs_lib_TouchEventUtils___default.a.extractSingleTouch(e.nativeEvent);
    var pageX = touch && touch.pageX;
    var pageY = touch && touch.pageY;
    var locationX = touch && touch.locationX;
    var locationY = touch && touch.locationY;
    this.pressInLocation = { pageX: pageX, pageY: pageY, locationX: locationX, locationY: locationY };
  },

  _getDistanceBetweenPoints: function _getDistanceBetweenPoints(aX, aY, bX, bY) {
    var deltaX = aX - bX;
    var deltaY = aY - bY;
    return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
  },

  /**
   * Will perform a transition between touchable states, and identify any
   * highlighting or unhighlighting that must be performed for this particular
   * transition.
   *
   * @param {States} curState Current Touchable state.
   * @param {States} nextState Next Touchable state.
   * @param {Signal} signal Signal that triggered the transition.
   * @param {Event} e Native event.
   * @sideeffects
   */
  _performSideEffectsForTransition: function _performSideEffectsForTransition(curState, nextState, signal, e) {
    var curIsHighlight = this._isHighlight(curState);
    var newIsHighlight = this._isHighlight(nextState);

    var isFinalSignal = signal === Signals.RESPONDER_TERMINATED || signal === Signals.RESPONDER_RELEASE;

    if (isFinalSignal) {
      this._cancelLongPressDelayTimeout();
    }

    if (!IsActive[curState] && IsActive[nextState]) {
      this._remeasureMetricsOnActivation();
    }

    if (IsPressingIn[curState] && signal === Signals.LONG_PRESS_DETECTED) {
      this.touchableHandleLongPress && this.touchableHandleLongPress(e);
    }

    if (newIsHighlight && !curIsHighlight) {
      this._startHighlight(e);
    } else if (!newIsHighlight && curIsHighlight) {
      this._endHighlight(e);
    }

    if (IsPressingIn[curState] && signal === Signals.RESPONDER_RELEASE) {
      var hasLongPressHandler = !!this.props.onLongPress;
      var pressIsLongButStillCallOnPress = IsLongPressingIn[curState] && ( // We *are* long pressing..
      !hasLongPressHandler || // But either has no long handler
      !this.touchableLongPressCancelsPress()); // or we're told to ignore it.

      var shouldInvokePress = !IsLongPressingIn[curState] || pressIsLongButStillCallOnPress;
      if (shouldInvokePress && this.touchableHandlePress) {
        if (!newIsHighlight && !curIsHighlight) {
          // we never highlighted because of delay, but we should highlight now
          this._startHighlight(e);
          this._endHighlight(e);
        }
        this.touchableHandlePress(e);
      }
    }

    this.touchableDelayTimeout && clearTimeout(this.touchableDelayTimeout);
    this.touchableDelayTimeout = null;
  },

  _startHighlight: function _startHighlight(e) {
    this._savePressInLocation(e);
    this.touchableHandleActivePressIn && this.touchableHandleActivePressIn(e);
  },

  _endHighlight: function _endHighlight(e) {
    var _this2 = this;

    if (this.touchableHandleActivePressOut) {
      if (this.touchableGetPressOutDelayMS && this.touchableGetPressOutDelayMS()) {
        this.pressOutDelayTimeout = setTimeout(function () {
          _this2.touchableHandleActivePressOut(e);
        }, this.touchableGetPressOutDelayMS());
      } else {
        this.touchableHandleActivePressOut(e);
      }
    }
  },

  // HACK (part 2): basic support for touchable interactions using a keyboard (including
  // delays and longPress)
  touchableHandleKeyEvent: function touchableHandleKeyEvent(e) {
    var ENTER = 13;
    var SPACE = 32;
    var type = e.type,
        which = e.which;

    if (which === ENTER || which === SPACE) {
      if (type === 'keydown') {
        if (!this._isTouchableKeyboardActive) {
          if (!this.state.touchable.touchState || this.state.touchable.touchState === States.NOT_RESPONDER) {
            this.touchableHandleResponderGrant(e);
            this._isTouchableKeyboardActive = true;
          }
        }
      } else if (type === 'keyup') {
        if (this._isTouchableKeyboardActive) {
          if (this.state.touchable.touchState && this.state.touchable.touchState !== States.NOT_RESPONDER) {
            this.touchableHandleResponderRelease(e);
            this._isTouchableKeyboardActive = false;
          }
        }
      }
      e.stopPropagation();
      // prevent the default behaviour unless the Touchable functions as a link
      // and Enter is pressed
      if (!(which === ENTER && __WEBPACK_IMPORTED_MODULE_0__modules_AccessibilityUtil__["a" /* default */].propsToAriaRole(this.props) === 'link')) {
        e.preventDefault();
      }
    }
  }
};

var Touchable = {
  Mixin: TouchableMixin,
  TOUCH_TARGET_DEBUG: false, // Highlights all touchable targets. Toggle with Inspector.
  /**
   * Renders a debugging overlay to visualize touch target with hitSlop (might not work on Android).
   */
  renderDebugView: function renderDebugView(_ref) {
    var color = _ref.color,
        hitSlop = _ref.hitSlop;

    if (false) {
      if (!Touchable.TOUCH_TARGET_DEBUG) {
        return null;
      }
      var debugHitSlopStyle = {};
      hitSlop = hitSlop || { top: 0, bottom: 0, left: 0, right: 0 };
      for (var key in hitSlop) {
        debugHitSlopStyle[key] = -hitSlop[key];
      }
      var hexColor = '#' + ('00000000' + normalizeColor(color).toString(16)).substr(-8);
      return React.createElement(View, {
        pointerEvents: 'none',
        style: Object.assign({
          position: 'absolute',
          borderColor: hexColor.slice(0, -2) + '55', // More opaque
          borderWidth: 1,
          borderStyle: 'dashed',
          backgroundColor: hexColor.slice(0, -2) + '0F' }, debugHitSlopStyle)
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Touchable);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*
 *  Copyright (c) 2015-present, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var GLOBAL = typeof window === 'undefined' ? global : window;

var setter = function(_setter, _clearer, array) {
  return function(callback, delta) {
    var id = _setter(function() {
      _clearer.call(this, id);
      callback.apply(this, arguments);
    }.bind(this), delta);

    if (!this[array]) {
      this[array] = [id];
    } else {
      this[array].push(id);
    }
    return id;
  };
};

var clearer = function(_clearer, array) {
  return function(id) {
    if (this[array]) {
      var index = this[array].indexOf(id);
      if (index !== -1) {
        this[array].splice(index, 1);
      }
    }
    _clearer(id);
  };
};

var _timeouts = 'TimerMixin_timeouts';
var _clearTimeout = clearer(GLOBAL.clearTimeout, _timeouts);
var _setTimeout = setter(GLOBAL.setTimeout, _clearTimeout, _timeouts);

var _intervals = 'TimerMixin_intervals';
var _clearInterval = clearer(GLOBAL.clearInterval, _intervals);
var _setInterval = setter(GLOBAL.setInterval, function() {/* noop */}, _intervals);

var _immediates = 'TimerMixin_immediates';
var _clearImmediate = clearer(GLOBAL.clearImmediate, _immediates);
var _setImmediate = setter(GLOBAL.setImmediate, _clearImmediate, _immediates);

var _rafs = 'TimerMixin_rafs';
var _cancelAnimationFrame = clearer(GLOBAL.cancelAnimationFrame, _rafs);
var _requestAnimationFrame = setter(GLOBAL.requestAnimationFrame, _cancelAnimationFrame, _rafs);

var TimerMixin = {
  componentWillUnmount: function() {
    this[_timeouts] && this[_timeouts].forEach(function(id) {
      GLOBAL.clearTimeout(id);
    });
    this[_timeouts] = null;
    this[_intervals] && this[_intervals].forEach(function(id) {
      GLOBAL.clearInterval(id);
    });
    this[_intervals] = null;
    this[_immediates] && this[_immediates].forEach(function(id) {
      GLOBAL.clearImmediate(id);
    });
    this[_immediates] = null;
    this[_rafs] && this[_rafs].forEach(function(id) {
      GLOBAL.cancelAnimationFrame(id);
    });
    this[_rafs] = null;
  },

  setTimeout: _setTimeout,
  clearTimeout: _clearTimeout,

  setInterval: _setInterval,
  clearInterval: _clearInterval,

  setImmediate: _setImmediate,
  clearImmediate: _clearImmediate,

  requestAnimationFrame: _requestAnimationFrame,
  cancelAnimationFrame: _cancelAnimationFrame,
};

module.exports = TimerMixin;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(320);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _reactNative=__webpack_require__(3);Object.keys(_reactNative).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _reactNative[key];}});});

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(777),
    listCacheDelete = __webpack_require__(778),
    listCacheGet = __webpack_require__(779),
    listCacheHas = __webpack_require__(780),
    listCacheSet = __webpack_require__(781);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(198);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(83);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(799);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(819),
    Map = __webpack_require__(199),
    Promise = __webpack_require__(820),
    Set = __webpack_require__(821),
    WeakMap = __webpack_require__(822),
    baseGetTag = __webpack_require__(82),
    toSource = __webpack_require__(331);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(214);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(110);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

SearchInput=function(_Component){_inherits(SearchInput,_Component);

function SearchInput(props){_classCallCheck(this,SearchInput);var _this=_possibleConstructorReturn(this,(SearchInput.__proto__||Object.getPrototypeOf(SearchInput)).call(this,
props));_this.
























_updateQuery=function(text){
_this.setState({
query:text});var

onUpdateQuery=_this.props.onUpdateQuery;
if(onUpdateQuery){
onUpdateQuery(text);
}
};_this.

_submit=function(){var
onSubmit=_this.props.onSubmit;
if(onSubmit){
onSubmit();
}
};var query=_this.props.query;if(!query){query='';}_this.state={query:query};return _this;}_createClass(SearchInput,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.query!==this.state.query){this.setState({query:nextProps.query});}}},{key:'render',value:function render()

{var
placeholder=this.props.placeholder;var
query=this.state.query;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.header},
_react2.default.createElement(_reactNative.View,{
style:styles.search},
_react2.default.createElement(_reactNative.View,{
style:styles.searchBackground}),
_react2.default.createElement(_reactNative.TextInput,{
ref:'queryTextInput',
value:query,
placeholder:placeholder,
placeholderTextColor:'#454c53bf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
autoCapitalize:'none',
returnKeyType:'search',
onChangeText:this._updateQuery,
onSubmitEditing:this._submit,
style:styles.searchTextInput}))));



}}]);return SearchInput;}(_react.Component);


var styles=_reactNative.StyleSheet.create({
header:_extends({
flexDirection:'row',
alignItems:'center'},
_reactNative.Platform.select({
web:{
height:56}})),



search:{
flex:1,
flexDirection:'row',
alignItems:'center'},

searchBackground:{
position:'absolute',
top:0,left:0,bottom:0,right:0,
borderRadius:18,
borderWidth:1,
borderColor:'#e2d7ba',
backgroundColor:'#ffffff'},

searchTextInput:_extends({
flex:1,
height:36,
padding:0,
marginLeft:12,
marginRight:12,
color:'#51585e',
fontSize:17,
fontWeight:'300',
backgroundColor:'transparent',
zIndex:1},
_reactNative.Platform.select({
web:{
outline:'transparent'}}))});exports.default=





SearchInput;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var document = __webpack_require__(6).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var core = __webpack_require__(46);
var LIBRARY = __webpack_require__(69);
var wksExt = __webpack_require__(227);
var defineProperty = __webpack_require__(16).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(113)('keys');
var uid = __webpack_require__(68);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 146 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(6).document;
module.exports = document && document.documentElement;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(8);
var anObject = __webpack_require__(5);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(40)(Function.call, __webpack_require__(36).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var setPrototypeOf = __webpack_require__(148).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(49);
var defined = __webpack_require__(48);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 152 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 153 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(49);
var defined = __webpack_require__(48);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(69);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(31);
var hide = __webpack_require__(30);
var has = __webpack_require__(29);
var Iterators = __webpack_require__(88);
var $iterCreate = __webpack_require__(156);
var setToStringTag = __webpack_require__(86);
var getPrototypeOf = __webpack_require__(37);
var ITERATOR = __webpack_require__(11)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(72);
var descriptor = __webpack_require__(67);
var setToStringTag = __webpack_require__(86);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(30)(IteratorPrototype, __webpack_require__(11)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(117);
var defined = __webpack_require__(48);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(11)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(88);
var ITERATOR = __webpack_require__(11)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(16);
var createDesc = __webpack_require__(67);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(102);
var ITERATOR = __webpack_require__(11)('iterator');
var Iterators = __webpack_require__(88);
module.exports = __webpack_require__(46).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(463);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(21);
var toAbsoluteIndex = __webpack_require__(71);
var toLength = __webpack_require__(17);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(64);
var step = __webpack_require__(243);
var Iterators = __webpack_require__(88);
var toIObject = __webpack_require__(35);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(155)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(40);
var invoke = __webpack_require__(233);
var html = __webpack_require__(147);
var cel = __webpack_require__(143);
var global = __webpack_require__(6);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(41)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var macrotask = __webpack_require__(165).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(41)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(25);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(6);
var DESCRIPTORS = __webpack_require__(15);
var LIBRARY = __webpack_require__(69);
var $typed = __webpack_require__(123);
var hide = __webpack_require__(30);
var redefineAll = __webpack_require__(77);
var fails = __webpack_require__(7);
var anInstance = __webpack_require__(75);
var toInteger = __webpack_require__(49);
var toLength = __webpack_require__(17);
var toIndex = __webpack_require__(252);
var gOPN = __webpack_require__(73).f;
var dP = __webpack_require__(16).f;
var arrayFill = __webpack_require__(163);
var setToStringTag = __webpack_require__(86);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debounce__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exports_findNodeHandle__ = __webpack_require__(43);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */





var emptyObject = {};
var registry = {};

var id = 1;
var guid = function guid() {
  return 'r-' + id++;
};

var resizeObserver = void 0;
if (__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__["canUseDOM"]) {
  if (typeof window.ResizeObserver !== 'undefined') {
    resizeObserver = new window.ResizeObserver(function (entries) {
      entries.forEach(function (_ref) {
        var target = _ref.target;

        var instance = registry[target._layoutId];
        instance && instance._handleLayout();
      });
    });
  } else {
    if (false) {
      console.warn('onLayout relies on ResizeObserver which is not supported by your browser. ' + 'Please include a polyfill, e.g., https://github.com/que-etc/resize-observer-polyfill. ' + 'Falling back to window.onresize.');
    }

    var triggerAll = function triggerAll() {
      Object.keys(registry).forEach(function (key) {
        var instance = registry[key];
        instance._handleLayout();
      });
    };

    window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_1_debounce___default()(triggerAll, 16), false);
  }
}

var observe = function observe(instance) {
  var id = guid();
  registry[id] = instance;

  if (resizeObserver) {
    var node = Object(__WEBPACK_IMPORTED_MODULE_2__exports_findNodeHandle__["a" /* default */])(instance);
    if (node) {
      node._layoutId = id;
      resizeObserver.observe(node);
    }
  } else {
    instance._layoutId = id;
    instance._handleLayout();
  }
};

var unobserve = function unobserve(instance) {
  delete registry[instance._layoutId];
  if (resizeObserver) {
    var node = Object(__WEBPACK_IMPORTED_MODULE_2__exports_findNodeHandle__["a" /* default */])(instance);
    if (node) {
      delete node._layoutId;
      resizeObserver.unobserve(node);
    }
  } else {
    delete instance._layoutId;
  }
};

var safeOverride = function safeOverride(original, next) {
  if (original) {
    return function prototypeOverride() {
      /* eslint-disable prefer-rest-params */
      original.call(this, arguments);
      next.call(this, arguments);
      /* eslint-enable prefer-rest-params */
    };
  }
  return next;
};

var applyLayout = function applyLayout(Component) {
  var componentDidMount = Component.prototype.componentDidMount;
  var componentDidUpdate = Component.prototype.componentDidUpdate;
  var componentWillUnmount = Component.prototype.componentWillUnmount;

  Component.prototype.componentDidMount = safeOverride(componentDidMount, function componentDidMount() {
    this._layoutState = emptyObject;
    this._isMounted = true;
    observe(this);
  });

  Component.prototype.componentDidUpdate = safeOverride(componentDidUpdate, function componentDidUpdate(prevProps) {
    if (this.props.onLayout && !prevProps.onLayout) {
      observe(this);
    } else if (!this.props.onLayout && prevProps.onLayout) {
      unobserve(this);
    }
  });

  Component.prototype.componentWillUnmount = safeOverride(componentWillUnmount, function componentWillUnmount() {
    this._isMounted = false;
    unobserve(this);
  });

  Component.prototype._handleLayout = function () {
    var _this = this;

    var layout = this._layoutState;
    var onLayout = this.props.onLayout;


    if (onLayout) {
      this.measure(function (x, y, width, height) {
        if (_this._isMounted) {
          if (layout.x !== x || layout.y !== y || layout.width !== width || layout.height !== height) {
            _this._layoutState = { x: x, y: y, width: width, height: height };
            var nativeEvent = {
              layout: _this._layoutState
            };
            Object.defineProperty(nativeEvent, 'target', {
              enumerable: true,
              get: function get() {
                return Object(__WEBPACK_IMPORTED_MODULE_2__exports_findNodeHandle__["a" /* default */])(_this);
              }
            });
            onLayout({ nativeEvent: nativeEvent, timeStamp: Date.now() });
          }
        }
      });
    }
  };
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (applyLayout);

/***/ }),
/* 171 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */

module.exports = function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isDisabled__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__propsToAccessibilityComponent__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__propsToAriaRole__ = __webpack_require__(263);
/**
 * Copyright (c) 2017-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





var AccessibilityUtil = {
  isDisabled: __WEBPACK_IMPORTED_MODULE_0__isDisabled__["a" /* default */],
  propsToAccessibilityComponent: __WEBPACK_IMPORTED_MODULE_1__propsToAccessibilityComponent__["a" /* default */],
  propsToAriaRole: __WEBPACK_IMPORTED_MODULE_2__propsToAriaRole__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (AccessibilityUtil);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isWebColor__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports_processColor__ = __webpack_require__(267);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var normalizeColor = function normalizeColor(color) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (color == null) return;

  if (typeof color === 'string' && Object(__WEBPACK_IMPORTED_MODULE_0__isWebColor__["a" /* default */])(color)) {
    return color;
  }

  var colorInt = Object(__WEBPACK_IMPORTED_MODULE_1__exports_processColor__["a" /* default */])(color);
  if (colorInt != null) {
    var r = colorInt >> 16 & 255;
    var g = colorInt >> 8 & 255;
    var b = colorInt & 255;
    var a = (colorInt >> 24 & 255) / 255;
    var alpha = (a * opacity).toFixed(2);
    return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
  }
};

/* harmony default export */ __webpack_exports__["a"] = (normalizeColor);

/***/ }),
/* 174 */
/***/ (function(module, exports) {

/*
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

function normalizeColor(color) {
  var match;

  if (typeof color === 'number') {
    if (color >>> 0 === color && color >= 0 && color <= 0xffffffff) {
      return color;
    }
    return null;
  }

  // Ordered based on occurrences on Facebook codebase
  if ((match = matchers.hex6.exec(color))) {
    return parseInt(match[1] + 'ff', 16) >>> 0;
  }

  if (names.hasOwnProperty(color)) {
    return names[color];
  }

  if ((match = matchers.rgb.exec(color))) {
    return (
        parse255(match[1]) << 24 | // r
        parse255(match[2]) << 16 | // g
        parse255(match[3]) << 8 | // b
        0x000000ff // a
      ) >>> 0;
  }

  if ((match = matchers.rgba.exec(color))) {
    return (
        parse255(match[1]) << 24 | // r
        parse255(match[2]) << 16 | // g
        parse255(match[3]) << 8 | // b
        parse1(match[4]) // a
      ) >>> 0;
  }

  if ((match = matchers.hex3.exec(color))) {
    return parseInt(
        match[1] + match[1] + // r
        match[2] + match[2] + // g
        match[3] + match[3] + // b
        'ff', // a
        16
      ) >>> 0;
  }

  // https://drafts.csswg.org/css-color-4/#hex-notation
  if ((match = matchers.hex8.exec(color))) {
    return parseInt(match[1], 16) >>> 0;
  }

  if ((match = matchers.hex4.exec(color))) {
    return parseInt(
        match[1] + match[1] + // r
        match[2] + match[2] + // g
        match[3] + match[3] + // b
        match[4] + match[4], // a
        16
      ) >>> 0;
  }

  if ((match = matchers.hsl.exec(color))) {
    return (
        hslToRgb(
          parse360(match[1]), // h
          parsePercentage(match[2]), // s
          parsePercentage(match[3]) // l
        ) |
        0x000000ff // a
      ) >>> 0;
  }

  if ((match = matchers.hsla.exec(color))) {
    return (
        hslToRgb(
          parse360(match[1]), // h
          parsePercentage(match[2]), // s
          parsePercentage(match[3]) // l
        ) |
        parse1(match[4]) // a
      ) >>> 0;
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) {
    t += 1;
  }
  if (t > 1) {
    t -= 1;
  }
  if (t < 1 / 6) {
    return p + (q - p) * 6 * t;
  }
  if (t < 1 / 2) {
    return q;
  }
  if (t < 2 / 3) {
    return p + (q - p) * (2 / 3 - t) * 6;
  }
  return p;
}

function hslToRgb(h, s, l) {
  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  var p = 2 * l - q;
  var r = hue2rgb(p, q, h + 1 / 3);
  var g = hue2rgb(p, q, h);
  var b = hue2rgb(p, q, h - 1 / 3);

  return (
    Math.round(r * 255) << 24 |
    Math.round(g * 255) << 16 |
    Math.round(b * 255) << 8
  );
}

// var INTEGER = '[-+]?\\d+';
var NUMBER = '[-+]?\\d*\\.?\\d+';
var PERCENTAGE = NUMBER + '%';

function toArray(arrayLike) {
  return Array.prototype.slice.call(arrayLike, 0);
}

function call() {
  return '\\(\\s*(' + toArray(arguments).join(')\\s*,\\s*(') + ')\\s*\\)';
}

var matchers = {
  rgb: new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER)),
  rgba: new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER)),
  hsl: new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE)),
  hsla: new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER)),
  hex3: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex4: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#([0-9a-fA-F]{6})$/,
  hex8: /^#([0-9a-fA-F]{8})$/,
};

function parse255(str) {
  var int = parseInt(str, 10);
  if (int < 0) {
    return 0;
  }
  if (int > 255) {
    return 255;
  }
  return int;
}

function parse360(str) {
  var int = parseFloat(str);
  return (((int % 360) + 360) % 360) / 360;
}

function parse1(str) {
  var num = parseFloat(str);
  if (num < 0) {
    return 0;
  }
  if (num > 1) {
    return 255;
  }
  return Math.round(num * 255);
}

function parsePercentage(str) {
  // parseFloat conveniently ignores the final %
  var int = parseFloat(str, 10);
  if (int < 0) {
    return 0;
  }
  if (int > 100) {
    return 1;
  }
  return int / 100;
}

var names = {
  transparent: 0x00000000,

  // http://www.w3.org/TR/css3-color/#svg-color
  aliceblue: 0xf0f8ffff,
  antiquewhite: 0xfaebd7ff,
  aqua: 0x00ffffff,
  aquamarine: 0x7fffd4ff,
  azure: 0xf0ffffff,
  beige: 0xf5f5dcff,
  bisque: 0xffe4c4ff,
  black: 0x000000ff,
  blanchedalmond: 0xffebcdff,
  blue: 0x0000ffff,
  blueviolet: 0x8a2be2ff,
  brown: 0xa52a2aff,
  burlywood: 0xdeb887ff,
  burntsienna: 0xea7e5dff,
  cadetblue: 0x5f9ea0ff,
  chartreuse: 0x7fff00ff,
  chocolate: 0xd2691eff,
  coral: 0xff7f50ff,
  cornflowerblue: 0x6495edff,
  cornsilk: 0xfff8dcff,
  crimson: 0xdc143cff,
  cyan: 0x00ffffff,
  darkblue: 0x00008bff,
  darkcyan: 0x008b8bff,
  darkgoldenrod: 0xb8860bff,
  darkgray: 0xa9a9a9ff,
  darkgreen: 0x006400ff,
  darkgrey: 0xa9a9a9ff,
  darkkhaki: 0xbdb76bff,
  darkmagenta: 0x8b008bff,
  darkolivegreen: 0x556b2fff,
  darkorange: 0xff8c00ff,
  darkorchid: 0x9932ccff,
  darkred: 0x8b0000ff,
  darksalmon: 0xe9967aff,
  darkseagreen: 0x8fbc8fff,
  darkslateblue: 0x483d8bff,
  darkslategray: 0x2f4f4fff,
  darkslategrey: 0x2f4f4fff,
  darkturquoise: 0x00ced1ff,
  darkviolet: 0x9400d3ff,
  deeppink: 0xff1493ff,
  deepskyblue: 0x00bfffff,
  dimgray: 0x696969ff,
  dimgrey: 0x696969ff,
  dodgerblue: 0x1e90ffff,
  firebrick: 0xb22222ff,
  floralwhite: 0xfffaf0ff,
  forestgreen: 0x228b22ff,
  fuchsia: 0xff00ffff,
  gainsboro: 0xdcdcdcff,
  ghostwhite: 0xf8f8ffff,
  gold: 0xffd700ff,
  goldenrod: 0xdaa520ff,
  gray: 0x808080ff,
  green: 0x008000ff,
  greenyellow: 0xadff2fff,
  grey: 0x808080ff,
  honeydew: 0xf0fff0ff,
  hotpink: 0xff69b4ff,
  indianred: 0xcd5c5cff,
  indigo: 0x4b0082ff,
  ivory: 0xfffff0ff,
  khaki: 0xf0e68cff,
  lavender: 0xe6e6faff,
  lavenderblush: 0xfff0f5ff,
  lawngreen: 0x7cfc00ff,
  lemonchiffon: 0xfffacdff,
  lightblue: 0xadd8e6ff,
  lightcoral: 0xf08080ff,
  lightcyan: 0xe0ffffff,
  lightgoldenrodyellow: 0xfafad2ff,
  lightgray: 0xd3d3d3ff,
  lightgreen: 0x90ee90ff,
  lightgrey: 0xd3d3d3ff,
  lightpink: 0xffb6c1ff,
  lightsalmon: 0xffa07aff,
  lightseagreen: 0x20b2aaff,
  lightskyblue: 0x87cefaff,
  lightslategray: 0x778899ff,
  lightslategrey: 0x778899ff,
  lightsteelblue: 0xb0c4deff,
  lightyellow: 0xffffe0ff,
  lime: 0x00ff00ff,
  limegreen: 0x32cd32ff,
  linen: 0xfaf0e6ff,
  magenta: 0xff00ffff,
  maroon: 0x800000ff,
  mediumaquamarine: 0x66cdaaff,
  mediumblue: 0x0000cdff,
  mediumorchid: 0xba55d3ff,
  mediumpurple: 0x9370dbff,
  mediumseagreen: 0x3cb371ff,
  mediumslateblue: 0x7b68eeff,
  mediumspringgreen: 0x00fa9aff,
  mediumturquoise: 0x48d1ccff,
  mediumvioletred: 0xc71585ff,
  midnightblue: 0x191970ff,
  mintcream: 0xf5fffaff,
  mistyrose: 0xffe4e1ff,
  moccasin: 0xffe4b5ff,
  navajowhite: 0xffdeadff,
  navy: 0x000080ff,
  oldlace: 0xfdf5e6ff,
  olive: 0x808000ff,
  olivedrab: 0x6b8e23ff,
  orange: 0xffa500ff,
  orangered: 0xff4500ff,
  orchid: 0xda70d6ff,
  palegoldenrod: 0xeee8aaff,
  palegreen: 0x98fb98ff,
  paleturquoise: 0xafeeeeff,
  palevioletred: 0xdb7093ff,
  papayawhip: 0xffefd5ff,
  peachpuff: 0xffdab9ff,
  peru: 0xcd853fff,
  pink: 0xffc0cbff,
  plum: 0xdda0ddff,
  powderblue: 0xb0e0e6ff,
  purple: 0x800080ff,
  rebeccapurple: 0x663399ff,
  red: 0xff0000ff,
  rosybrown: 0xbc8f8fff,
  royalblue: 0x4169e1ff,
  saddlebrown: 0x8b4513ff,
  salmon: 0xfa8072ff,
  sandybrown: 0xf4a460ff,
  seagreen: 0x2e8b57ff,
  seashell: 0xfff5eeff,
  sienna: 0xa0522dff,
  silver: 0xc0c0c0ff,
  skyblue: 0x87ceebff,
  slateblue: 0x6a5acdff,
  slategray: 0x708090ff,
  slategrey: 0x708090ff,
  snow: 0xfffafaff,
  springgreen: 0x00ff7fff,
  steelblue: 0x4682b4ff,
  tan: 0xd2b48cff,
  teal: 0x008080ff,
  thistle: 0xd8bfd8ff,
  tomato: 0xff6347ff,
  turquoise: 0x40e0d0ff,
  violet: 0xee82eeff,
  wheat: 0xf5deb3ff,
  white: 0xffffffff,
  whitesmoke: 0xf5f5f5ff,
  yellow: 0xffff00ff,
  yellowgreen: 0x9acd32ff,
};

function rgba(colorInt) {
  var r = Math.round(((colorInt & 0xff000000) >>> 24));
  var g = Math.round(((colorInt & 0x00ff0000) >>> 16));
  var b = Math.round(((colorInt & 0x0000ff00) >>> 8));
  var a = ((colorInt & 0x000000ff) >>> 0) / 255;
  return {
    r: r,
    g: g,
    b: b,
    a: a,
  };
};

normalizeColor.rgba = rgba;

module.exports = normalizeColor;


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColorPropType__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__View_ViewStylePropTypes__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





var numberOrString = Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]]);

var TextStylePropTypes = Object.assign({}, __WEBPACK_IMPORTED_MODULE_1__View_ViewStylePropTypes__["a" /* default */], {
  color: __WEBPACK_IMPORTED_MODULE_0__ColorPropType__["a" /* default */],
  fontFamily: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
  fontFeatureSettings: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
  fontSize: numberOrString,
  fontStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
  fontWeight: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
  fontVariant: __WEBPACK_IMPORTED_MODULE_2_prop_types__["array"],
  letterSpacing: numberOrString,
  lineHeight: numberOrString,
  textAlign: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOf"])(['center', 'end', 'inherit', 'justify', 'justify-all', 'left', 'right', 'start']),
  textAlignVertical: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
  textDecorationColor: __WEBPACK_IMPORTED_MODULE_0__ColorPropType__["a" /* default */],
  textDecorationLine: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
  textDecorationStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
  textShadowColor: __WEBPACK_IMPORTED_MODULE_0__ColorPropType__["a" /* default */],
  textShadowOffset: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["shape"])({ width: __WEBPACK_IMPORTED_MODULE_2_prop_types__["number"], height: __WEBPACK_IMPORTED_MODULE_2_prop_types__["number"] }),
  textShadowRadius: __WEBPACK_IMPORTED_MODULE_2_prop_types__["number"],
  writingDirection: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOf"])(['auto', 'ltr', 'rtl']),
  /* @platform web */
  textIndent: numberOrString,
  textOverflow: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
  textRendering: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOf"])(['auto', 'geometricPrecision', 'optimizeLegibility', 'optimizeSpeed']),
  textTransform: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOf"])(['capitalize', 'lowercase', 'none', 'uppercase']),
  unicodeBidi: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOf"])(['normal', 'bidi-override', 'embed', 'isolate', 'isolate-override', 'plaintext']),
  whiteSpace: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
  wordWrap: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
  MozOsxFontSmoothing: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
  WebkitFontSmoothing: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]
});

/* harmony default export */ __webpack_exports__["a"] = (TextStylePropTypes);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReactNativeStyleResolver__ = __webpack_require__(597);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var styleResolver = new __WEBPACK_IMPORTED_MODULE_0__ReactNativeStyleResolver__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = (styleResolver);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_unitlessNumbers__ = __webpack_require__(277);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */



var normalizeValue = function normalizeValue(property, value) {
  if (!__WEBPACK_IMPORTED_MODULE_0__modules_unitlessNumbers__["a" /* default */][property] && typeof value === 'number') {
    value = value + 'px';
  }
  return value;
};

/* harmony default export */ __webpack_exports__["a"] = (normalizeValue);

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_createStrictShapeTypeChecker__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var EdgeInsetsPropType = Object(__WEBPACK_IMPORTED_MODULE_0__modules_createStrictShapeTypeChecker__["a" /* default */])({
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"]
});

/* harmony default export */ __webpack_exports__["a"] = (EdgeInsetsPropType);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function createStrictShapeTypeChecker(shapeTypes) {
  function checkType(isRequired, props, propName, componentName, location) {
    if (!props[propName]) {
      if (isRequired) {
        __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(false, 'Required object `' + propName + '` was not specified in `' + componentName + '`.');
      }
      return;
    }
    var propValue = props[propName];
    var propType = typeof propValue;
    var locationName = location || '(unknown)';
    if (propType !== 'object') {
      __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(false, 'Invalid ' + locationName + ' `' + propName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
    }
    // We need to check all keys in case some are required but missing from
    // props.
    var allKeys = Object.assign({}, props[propName], shapeTypes);

    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    for (var _key2 in allKeys) {
      var checker = shapeTypes[_key2];
      if (!checker) {
        __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(false, 'Invalid props.' + propName + ' key `' + _key2 + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
      }
      var error = checker.apply(undefined, [propValue, _key2, componentName, location].concat(rest));
      if (error) {
        __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(false, error.message + '\nBad object: ' + JSON.stringify(props[propName], null, '  '));
      }
    }
  }
  function chainedCheckType(props, propName, componentName, location) {
    for (var _len2 = arguments.length, rest = Array(_len2 > 4 ? _len2 - 4 : 0), _key3 = 4; _key3 < _len2; _key3++) {
      rest[_key3 - 4] = arguments[_key3];
    }

    return checkType.apply(undefined, [false, props, propName, componentName, location].concat(rest));
  }
  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
}

/* harmony default export */ __webpack_exports__["a"] = (createStrictShapeTypeChecker);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UIManager__ = __webpack_require__(52);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */



// NativeModules shim
var NativeModules = {
  UIManager: __WEBPACK_IMPORTED_MODULE_0__UIManager__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (NativeModules);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_StyleSheetPropType__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TextStylePropTypes__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





var TextPropTypes = {
  accessibilityComponentType: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
  accessibilityLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
  accessibilityLiveRegion: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOf"])(['assertive', 'none', 'polite']),
  accessibilityRole: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOf"])(['button', 'heading', 'label', 'link', 'listitem']),
  accessibilityTraits: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["array"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]]),
  accessible: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"],
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types__["any"],
  importantForAccessibility: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOf"])(['auto', 'no', 'no-hide-descendants', 'yes']),
  numberOfLines: __WEBPACK_IMPORTED_MODULE_2_prop_types__["number"],
  onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
  onContextMenu: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
  onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
  onLayout: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
  onPress: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
  selectable: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"],
  style: Object(__WEBPACK_IMPORTED_MODULE_0__modules_StyleSheetPropType__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__TextStylePropTypes__["a" /* default */]),
  testID: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]
};

/* harmony default export */ __webpack_exports__["a"] = (TextPropTypes);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimatedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return attachNativeEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nodes_AnimatedValue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NativeAnimatedHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exports_findNodeHandle__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var shouldUseNativeDriver = __WEBPACK_IMPORTED_MODULE_1__NativeAnimatedHelper__["a" /* default */].shouldUseNativeDriver;


function attachNativeEvent(viewRef, eventName, argMapping) {
  // Find animated values in `argMapping` and create an array representing their
  // key path inside the `nativeEvent` object. Ex.: ['contentOffset', 'x'].
  var eventMappings = [];

  var traverse = function traverse(value, path) {
    if (value instanceof __WEBPACK_IMPORTED_MODULE_0__nodes_AnimatedValue__["a" /* default */]) {
      value.__makeNative();

      eventMappings.push({
        nativeEventPath: path,
        animatedValueTag: value.__getNativeTag()
      });
    } else if (typeof value === 'object') {
      for (var _key in value) {
        traverse(value[_key], path.concat(_key));
      }
    }
  };

  __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(argMapping[0] && argMapping[0].nativeEvent, 'Native driven events only support animated values contained inside `nativeEvent`.');

  // Assume that the event containing `nativeEvent` is always the first argument.
  traverse(argMapping[0].nativeEvent, []);

  var viewTag = Object(__WEBPACK_IMPORTED_MODULE_2__exports_findNodeHandle__["a" /* default */])(viewRef);

  eventMappings.forEach(function (mapping) {
    __WEBPACK_IMPORTED_MODULE_1__NativeAnimatedHelper__["a" /* default */].API.addAnimatedEventToView(viewTag, eventName, mapping);
  });

  return {
    detach: function detach() {
      eventMappings.forEach(function (mapping) {
        __WEBPACK_IMPORTED_MODULE_1__NativeAnimatedHelper__["a" /* default */].API.removeAnimatedEventFromView(viewTag, eventName, mapping.animatedValueTag);
      });
    }
  };
}

var AnimatedEvent = function () {
  function AnimatedEvent(argMapping) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, AnimatedEvent);

    this._listeners = [];

    this._argMapping = argMapping;
    if (config.listener) {
      this.__addListener(config.listener);
    }
    this._callListeners = this._callListeners.bind(this);
    this._attachedEvent = null;
    this.__isNative = shouldUseNativeDriver(config);

    if (false) {
      this._validateMapping();
    }
  }

  AnimatedEvent.prototype.__addListener = function __addListener(callback) {
    this._listeners.push(callback);
  };

  AnimatedEvent.prototype.__removeListener = function __removeListener(callback) {
    this._listeners = this._listeners.filter(function (listener) {
      return listener !== callback;
    });
  };

  AnimatedEvent.prototype.__attach = function __attach(viewRef, eventName) {
    __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(this.__isNative, 'Only native driven events need to be attached.');

    this._attachedEvent = attachNativeEvent(viewRef, eventName, this._argMapping);
  };

  AnimatedEvent.prototype.__detach = function __detach(viewTag, eventName) {
    __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(this.__isNative, 'Only native driven events need to be detached.');

    this._attachedEvent && this._attachedEvent.detach();
  };

  AnimatedEvent.prototype.__getHandler = function __getHandler() {
    var _this = this;

    if (this.__isNative) {
      return this._callListeners;
    }

    return function () {
      for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var traverse = function traverse(recMapping, recEvt, key) {
        if (typeof recEvt === 'number' && recMapping instanceof __WEBPACK_IMPORTED_MODULE_0__nodes_AnimatedValue__["a" /* default */]) {
          recMapping.setValue(recEvt);
        } else if (typeof recMapping === 'object') {
          for (var mappingKey in recMapping) {
            /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
             * comment suppresses an error when upgrading Flow's support for
             * React. To see the error delete this comment and run Flow. */
            traverse(recMapping[mappingKey], recEvt[mappingKey], mappingKey);
          }
        }
      };

      if (!_this.__isNative) {
        _this._argMapping.forEach(function (mapping, idx) {
          traverse(mapping, args[idx], 'arg' + idx);
        });
      }
      _this._callListeners.apply(_this, args);
    };
  };

  AnimatedEvent.prototype._callListeners = function _callListeners() {
    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
      args[_key3] = arguments[_key3];
    }

    this._listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  AnimatedEvent.prototype._validateMapping = function _validateMapping() {
    var traverse = function traverse(recMapping, recEvt, key) {
      if (typeof recEvt === 'number') {
        __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(recMapping instanceof __WEBPACK_IMPORTED_MODULE_0__nodes_AnimatedValue__["a" /* default */], 'Bad mapping of type ' + typeof recMapping + ' for key ' + key + ', event value must map to AnimatedValue');
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(typeof recMapping === 'object', 'Bad mapping of type ' + typeof recMapping + ' for key ' + key);
      __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(typeof recEvt === 'object', 'Bad event of type ' + typeof recEvt + ' for key ' + key);
      for (var mappingKey in recMapping) {
        traverse(recMapping[mappingKey], recEvt[mappingKey], mappingKey);
      }
    };
  };

  return AnimatedEvent;
}();


/* unused harmony default export */ var _unused_webpack_default_export = ({ AnimatedEvent: AnimatedEvent, attachNativeEvent: attachNativeEvent });

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimatedValue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimatedWithChildren__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var _uniqueId = 1;

/**
 * 2D Value for driving 2D animations, such as pan gestures. Almost identical
 * API to normal `Animated.Value`, but multiplexed.
 *
 * See http://facebook.github.io/react-native/docs/animatedvaluexy.html
 */

var AnimatedValueXY = function (_AnimatedWithChildren) {
  _inherits(AnimatedValueXY, _AnimatedWithChildren);

  function AnimatedValueXY(valueIn) {
    _classCallCheck(this, AnimatedValueXY);

    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));

    var value = valueIn || { x: 0, y: 0 }; // fixme: shouldn't need `: any`
    if (typeof value.x === 'number' && typeof value.y === 'number') {
      _this.x = new __WEBPACK_IMPORTED_MODULE_0__AnimatedValue__["a" /* default */](value.x);
      _this.y = new __WEBPACK_IMPORTED_MODULE_0__AnimatedValue__["a" /* default */](value.y);
    } else {
      __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(value.x instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedValue__["a" /* default */] && value.y instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedValue__["a" /* default */], 'AnimatedValueXY must be initialized with an object of numbers or ' + 'AnimatedValues.');
      _this.x = value.x;
      _this.y = value.y;
    }
    _this._listeners = {};
    return _this;
  }

  /**
   * Directly set the value. This will stop any animations running on the value
   * and update all the bound properties.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#setvalue
   */


  AnimatedValueXY.prototype.setValue = function setValue(value) {
    this.x.setValue(value.x);
    this.y.setValue(value.y);
  };

  /**
   * Sets an offset that is applied on top of whatever value is set, whether
   * via `setValue`, an animation, or `Animated.event`. Useful for compensating
   * things like the start of a pan gesture.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#setoffset
   */


  AnimatedValueXY.prototype.setOffset = function setOffset(offset) {
    this.x.setOffset(offset.x);
    this.y.setOffset(offset.y);
  };

  /**
   * Merges the offset value into the base value and resets the offset to zero.
   * The final output of the value is unchanged.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#flattenoffset
   */


  AnimatedValueXY.prototype.flattenOffset = function flattenOffset() {
    this.x.flattenOffset();
    this.y.flattenOffset();
  };

  /**
   * Sets the offset value to the base value, and resets the base value to
   * zero. The final output of the value is unchanged.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#extractoffset
   */


  AnimatedValueXY.prototype.extractOffset = function extractOffset() {
    this.x.extractOffset();
    this.y.extractOffset();
  };

  AnimatedValueXY.prototype.__getValue = function __getValue() {
    return {
      x: this.x.__getValue(),
      y: this.y.__getValue()
    };
  };

  /**
   * Stops any animation and resets the value to its original.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#resetanimation
   */


  AnimatedValueXY.prototype.resetAnimation = function resetAnimation(callback) {
    this.x.resetAnimation();
    this.y.resetAnimation();
    callback && callback(this.__getValue());
  };

  /**
   * Stops any running animation or tracking. `callback` is invoked with the
   * final value after stopping the animation, which is useful for updating
   * state to match the animation position with layout.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#stopanimation
   */


  AnimatedValueXY.prototype.stopAnimation = function stopAnimation(callback) {
    this.x.stopAnimation();
    this.y.stopAnimation();
    callback && callback(this.__getValue());
  };

  /**
   * Adds an asynchronous listener to the value so you can observe updates from
   * animations.  This is useful because there is no way to synchronously read
   * the value because it might be driven natively.
   *
   * Returns a string that serves as an identifier for the listener.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#addlistener
   */


  AnimatedValueXY.prototype.addListener = function addListener(callback) {
    var _this2 = this;

    var id = String(_uniqueId++);
    var jointCallback = function jointCallback(_ref) {
      var number = _ref.value;

      callback(_this2.__getValue());
    };
    this._listeners[id] = {
      x: this.x.addListener(jointCallback),
      y: this.y.addListener(jointCallback)
    };
    return id;
  };

  /**
   * Unregister a listener. The `id` param shall match the identifier
   * previously returned by `addListener()`.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#removelistener
   */


  AnimatedValueXY.prototype.removeListener = function removeListener(id) {
    this.x.removeListener(this._listeners[id].x);
    this.y.removeListener(this._listeners[id].y);
    delete this._listeners[id];
  };

  /**
   * Remove all registered listeners.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#removealllisteners
   */


  AnimatedValueXY.prototype.removeAllListeners = function removeAllListeners() {
    this.x.removeAllListeners();
    this.y.removeAllListeners();
    this._listeners = {};
  };

  /**
   * Converts `{x, y}` into `{left, top}` for use in style.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#getlayout
   */


  AnimatedValueXY.prototype.getLayout = function getLayout() {
    return {
      left: this.x,
      top: this.y
    };
  };

  /**
   * Converts `{x, y}` into a useable translation transform.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#gettranslatetransform
   */


  AnimatedValueXY.prototype.getTranslateTransform = function getTranslateTransform() {
    return [{ translateX: this.x }, { translateY: this.y }];
  };

  return AnimatedValueXY;
}(__WEBPACK_IMPORTED_MODULE_1__AnimatedWithChildren__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AnimatedValueXY);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NativeAnimatedHelper__ = __webpack_require__(34);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// Important note: start() and stop() will only be called at most once.
// Once an animation has been stopped or finished its course, it will
// not be reused.
var Animation = function () {
  function Animation() {
    _classCallCheck(this, Animation);
  }

  Animation.prototype.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {};

  Animation.prototype.stop = function stop() {
    if (this.__nativeId) {
      __WEBPACK_IMPORTED_MODULE_0__NativeAnimatedHelper__["a" /* default */].API.stopAnimation(this.__nativeId);
    }
  };

  Animation.prototype.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
    // Subclasses that have corresponding animation implementation done in native
    // should override this method
    throw new Error('This animation type cannot be offloaded to native');
  };
  // Helper function for subclasses to make sure onEnd is only called once.


  Animation.prototype.__debouncedOnEnd = function __debouncedOnEnd(result) {
    var onEnd = this.__onEnd;
    this.__onEnd = null;
    onEnd && onEnd(result);
  };

  Animation.prototype.__startNativeAnimation = function __startNativeAnimation(animatedValue) {
    animatedValue.__makeNative();
    this.__nativeId = __WEBPACK_IMPORTED_MODULE_0__NativeAnimatedHelper__["a" /* default */].generateNewAnimationId();
    __WEBPACK_IMPORTED_MODULE_0__NativeAnimatedHelper__["a" /* default */].API.startAnimatingNode(this.__nativeId, animatedValue.__getNativeTag(), this.__getNativeAnimationConfig(), this.__debouncedOnEnd.bind(this));
  };

  return Animation;
}();

/* harmony default export */ __webpack_exports__["a"] = (Animation);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_applyNativeMethods__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createElement__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_AssetRegistry__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StyleSheet_resolveShadowValue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_ImageLoader__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ImageResizeMode__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ImageSourcePropType__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ImageStylePropTypes__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ImageUriCache__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_StyleSheetPropType__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ViewPropTypes__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

















var emptyObject = {};

var STATUS_ERRORED = 'ERRORED';
var STATUS_LOADED = 'LOADED';
var STATUS_LOADING = 'LOADING';
var STATUS_PENDING = 'PENDING';
var STATUS_IDLE = 'IDLE';

var getImageState = function getImageState(uri, shouldDisplaySource) {
  return shouldDisplaySource ? STATUS_LOADED : uri ? STATUS_PENDING : STATUS_IDLE;
};

var resolveAssetDimensions = function resolveAssetDimensions(source) {
  if (typeof source === 'number') {
    var _getAssetByID = Object(__WEBPACK_IMPORTED_MODULE_2__modules_AssetRegistry__["a" /* getAssetByID */])(source),
        height = _getAssetByID.height,
        width = _getAssetByID.width;

    return { height: height, width: width };
  } else if (typeof source === 'object') {
    var _height = source.height,
        _width = source.width;

    return { height: _height, width: _width };
  }
};

var svgDataUriPattern = /^(data:image\/svg\+xml;utf8,)(.*)/;
var resolveAssetUri = function resolveAssetUri(source) {
  var uri = '';
  if (typeof source === 'number') {
    // get the URI from the packager
    var asset = Object(__WEBPACK_IMPORTED_MODULE_2__modules_AssetRegistry__["a" /* getAssetByID */])(source);
    var scale = asset.scales[0];
    var scaleSuffix = scale !== 1 ? '@' + scale + 'x' : '';
    uri = asset ? asset.httpServerLocation + '/' + asset.name + scaleSuffix + '.' + asset.type : '';
  } else if (typeof source === 'string') {
    uri = source;
  } else if (source && typeof source.uri === 'string') {
    uri = source.uri;
  }

  if (uri) {
    var match = uri.match(svgDataUriPattern);
    // inline SVG markup may contain characters (e.g., #, ") that need to be escaped
    if (match) {
      var prefix = match[1],
          svg = match[2];

      var encodedSvg = encodeURIComponent(svg);
      return '' + prefix + encodedSvg;
    }
  }

  return uri;
};

var filterId = 0;

var createTintColorSVG = function createTintColorSVG(tintColor, id) {
  return tintColor && id != null ? __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
    'svg',
    { style: { position: 'absolute', height: 0, visibility: 'hidden', width: 0 } },
    __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
      'defs',
      null,
      __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
        'filter',
        { id: 'tint-' + id },
        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('feFlood', { floodColor: '' + tintColor }),
        __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('feComposite', { in2: 'SourceAlpha', operator: 'atop' })
      )
    )
  ) : null;
};

var Image = function (_Component) {
  _inherits(Image, _Component);

  Image.getSize = function getSize(uri, success, failure) {
    __WEBPACK_IMPORTED_MODULE_4__modules_ImageLoader__["a" /* default */].getSize(uri, success, failure);
  };

  Image.prefetch = function prefetch(uri) {
    return __WEBPACK_IMPORTED_MODULE_4__modules_ImageLoader__["a" /* default */].prefetch(uri);
  };

  function Image(props, context) {
    _classCallCheck(this, Image);

    // If an image has been loaded before, render it immediately
    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this._filterId = 0;
    _this._imageRef = null;
    _this._imageRequestId = null;
    _this._imageState = null;
    _this._isMounted = false;

    _this._createLayoutHandler = function (resizeMode) {
      var onLayout = _this.props.onLayout;

      if (resizeMode === 'center' || resizeMode === 'repeat' || onLayout) {
        return function (e) {
          var layout = e.nativeEvent.layout;

          onLayout && onLayout(e);
          _this.setState(function () {
            return { layout: layout };
          });
        };
      }
    };

    _this._getBackgroundSize = function (resizeMode) {
      if (_this._imageRef && (resizeMode === 'center' || resizeMode === 'repeat')) {
        var _this$_imageRef = _this._imageRef,
            naturalHeight = _this$_imageRef.naturalHeight,
            naturalWidth = _this$_imageRef.naturalWidth;
        var _this$state$layout = _this.state.layout,
            height = _this$state$layout.height,
            width = _this$state$layout.width;

        if (naturalHeight && naturalWidth && height && width) {
          var scaleFactor = Math.min(1, width / naturalWidth, height / naturalHeight);
          var x = Math.ceil(scaleFactor * naturalWidth);
          var y = Math.ceil(scaleFactor * naturalHeight);
          return {
            backgroundSize: x + 'px ' + y + 'px'
          };
        }
      }
    };

    _this._onError = function () {
      var _this$props = _this.props,
          onError = _this$props.onError,
          source = _this$props.source;

      _this._updateImageState(STATUS_ERRORED);
      if (onError) {
        onError({
          nativeEvent: {
            error: 'Failed to load resource ' + resolveAssetUri(source) + ' (404)'
          }
        });
      }
      _this._onLoadEnd();
    };

    _this._onLoad = function (e) {
      var _this$props2 = _this.props,
          onLoad = _this$props2.onLoad,
          source = _this$props2.source;

      var event = { nativeEvent: e };
      __WEBPACK_IMPORTED_MODULE_8__ImageUriCache__["a" /* default */].add(resolveAssetUri(source));
      _this._updateImageState(STATUS_LOADED);
      if (onLoad) {
        onLoad(event);
      }
      _this._onLoadEnd();
    };

    _this._setImageRef = function (ref) {
      _this._imageRef = ref;
    };

    var uri = resolveAssetUri(props.source);
    var shouldDisplaySource = __WEBPACK_IMPORTED_MODULE_8__ImageUriCache__["a" /* default */].has(uri);
    _this.state = { layout: {}, shouldDisplaySource: shouldDisplaySource };
    _this._imageState = getImageState(uri, shouldDisplaySource);
    _this._filterId = filterId;
    filterId++;
    return _this;
  }

  Image.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    if (this._imageState === STATUS_PENDING) {
      this._createImageLoader();
    } else if (this._imageState === STATUS_LOADED) {
      this._onLoad({ target: this._imageRef });
    }
  };

  Image.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevUri = resolveAssetUri(prevProps.source);
    var uri = resolveAssetUri(this.props.source);
    if (prevUri !== uri) {
      __WEBPACK_IMPORTED_MODULE_8__ImageUriCache__["a" /* default */].remove(prevUri);
      var isPreviouslyLoaded = __WEBPACK_IMPORTED_MODULE_8__ImageUriCache__["a" /* default */].has(uri);
      isPreviouslyLoaded && __WEBPACK_IMPORTED_MODULE_8__ImageUriCache__["a" /* default */].add(uri);
      this._updateImageState(getImageState(uri, isPreviouslyLoaded));
    }
    if (this._imageState === STATUS_PENDING) {
      this._createImageLoader();
    }
  };

  Image.prototype.componentWillUnmount = function componentWillUnmount() {
    var uri = resolveAssetUri(this.props.source);
    __WEBPACK_IMPORTED_MODULE_8__ImageUriCache__["a" /* default */].remove(uri);
    this._destroyImageLoader();
    this._isMounted = false;
  };

  Image.prototype.render = function render() {
    var shouldDisplaySource = this.state.shouldDisplaySource;

    var _props = this.props,
        accessibilityLabel = _props.accessibilityLabel,
        accessible = _props.accessible,
        blurRadius = _props.blurRadius,
        defaultSource = _props.defaultSource,
        draggable = _props.draggable,
        source = _props.source,
        testID = _props.testID,
        capInsets = _props.capInsets,
        onError = _props.onError,
        onLayout = _props.onLayout,
        onLoad = _props.onLoad,
        onLoadEnd = _props.onLoadEnd,
        onLoadStart = _props.onLoadStart,
        resizeMethod = _props.resizeMethod,
        resizeMode = _props.resizeMode,
        other = _objectWithoutProperties(_props, ['accessibilityLabel', 'accessible', 'blurRadius', 'defaultSource', 'draggable', 'source', 'testID', 'capInsets', 'onError', 'onLayout', 'onLoad', 'onLoadEnd', 'onLoadStart', 'resizeMethod', 'resizeMode']);

    if (false) {
      if (this.props.src) {
        console.warn('The <Image> component requires a `source` property rather than `src`.');
      }

      if (this.props.children) {
        throw new Error('The <Image> component cannot contain children. If you want to render content on top of the image, consider using the <ImageBackground> component or absolute positioning.');
      }
    }

    var selectedSource = shouldDisplaySource ? source : defaultSource;
    var displayImageUri = resolveAssetUri(selectedSource);
    var imageSizeStyle = resolveAssetDimensions(selectedSource);
    var backgroundImage = displayImageUri ? 'url("' + displayImageUri + '")' : null;
    var flatStyle = Object.assign({}, __WEBPACK_IMPORTED_MODULE_9__StyleSheet__["a" /* default */].flatten(this.props.style));
    var finalResizeMode = resizeMode || flatStyle.resizeMode || __WEBPACK_IMPORTED_MODULE_5__ImageResizeMode__["a" /* default */].cover;

    // CSS filters
    var filters = [];
    var tintColor = flatStyle.tintColor;
    if (flatStyle.filter) {
      filters.push(flatStyle.filter);
    }
    if (blurRadius) {
      filters.push('blur(' + blurRadius + 'px)');
    }
    if (flatStyle.shadowOffset) {
      var shadowString = Object(__WEBPACK_IMPORTED_MODULE_3__StyleSheet_resolveShadowValue__["a" /* default */])(flatStyle);
      if (shadowString) {
        filters.push('drop-shadow(' + shadowString + ')');
      }
    }
    if (flatStyle.tintColor) {
      filters.push('url(#tint-' + this._filterId + ')');
    }

    // these styles were converted to filters
    delete flatStyle.shadowColor;
    delete flatStyle.shadowOpacity;
    delete flatStyle.shadowOffset;
    delete flatStyle.shadowRadius;
    delete flatStyle.tintColor;
    // these styles are not supported on View
    delete flatStyle.overlayColor;
    delete flatStyle.resizeMode;

    // Accessibility image allows users to trigger the browser's image context menu
    var hiddenImage = displayImageUri ? Object(__WEBPACK_IMPORTED_MODULE_1__createElement__["a" /* default */])('img', {
      alt: accessibilityLabel || '',
      draggable: draggable || false,
      ref: this._setImageRef,
      src: displayImageUri,
      style: styles.accessibilityImage
    }) : null;

    return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__View__["a" /* default */],
      _extends({}, other, {
        accessibilityLabel: accessibilityLabel,
        accessible: accessible,
        onLayout: this._createLayoutHandler(finalResizeMode),
        style: [styles.root, this.context.isInAParentText && styles.inline, imageSizeStyle, flatStyle],
        testID: testID
      }),
      __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__View__["a" /* default */], {
        style: [styles.image, resizeModeStyles[finalResizeMode], this._getBackgroundSize(finalResizeMode), backgroundImage && { backgroundImage: backgroundImage }, filters.length > 0 && { filter: filters.join(' ') }]
      }),
      hiddenImage,
      createTintColorSVG(tintColor, this._filterId)
    );
  };

  Image.prototype._createImageLoader = function _createImageLoader() {
    var source = this.props.source;

    this._destroyImageLoader();
    var uri = resolveAssetUri(source);
    this._imageRequestId = __WEBPACK_IMPORTED_MODULE_4__modules_ImageLoader__["a" /* default */].load(uri, this._onLoad, this._onError);
    this._onLoadStart();
  };

  Image.prototype._destroyImageLoader = function _destroyImageLoader() {
    if (this._imageRequestId) {
      __WEBPACK_IMPORTED_MODULE_4__modules_ImageLoader__["a" /* default */].abort(this._imageRequestId);
      this._imageRequestId = null;
    }
  };

  Image.prototype._onLoadEnd = function _onLoadEnd() {
    var onLoadEnd = this.props.onLoadEnd;

    if (onLoadEnd) {
      onLoadEnd();
    }
  };

  Image.prototype._onLoadStart = function _onLoadStart() {
    var onLoadStart = this.props.onLoadStart;

    this._updateImageState(STATUS_LOADING);
    if (onLoadStart) {
      onLoadStart();
    }
  };

  Image.prototype._updateImageState = function _updateImageState(status) {
    this._imageState = status;
    var shouldDisplaySource = this._imageState === STATUS_LOADED || this._imageState === STATUS_LOADING;
    // only triggers a re-render when the image is loading (to support PJEG), loaded, or failed
    if (shouldDisplaySource !== this.state.shouldDisplaySource) {
      if (this._isMounted) {
        this.setState(function () {
          return { shouldDisplaySource: shouldDisplaySource };
        });
      }
    }
  };

  return Image;
}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);

Image.displayName = 'Image';
Image.contextTypes = {
  isInAParentText: __WEBPACK_IMPORTED_MODULE_13_prop_types__["bool"]
};
Image.defaultProps = {
  style: emptyObject
};
Image.resizeMode = __WEBPACK_IMPORTED_MODULE_5__ImageResizeMode__["a" /* default */];
Image.propTypes =  false ? Object.assign({}, ViewPropTypes, {
  blurRadius: number,
  defaultSource: ImageSourcePropType,
  draggable: bool,
  onError: func,
  onLayout: func,
  onLoad: func,
  onLoadEnd: func,
  onLoadStart: func,
  resizeMode: oneOf(Object.keys(ImageResizeMode)),
  source: ImageSourcePropType,
  style: StyleSheetPropType(ImageStylePropTypes),
  // compatibility with React Native
  /* eslint-disable react/sort-prop-types */
  capInsets: shape({ top: number, left: number, bottom: number, right: number }),
  resizeMethod: oneOf(['auto', 'resize', 'scale'])
  /* eslint-enable react/sort-prop-types */
}) : {};


var styles = __WEBPACK_IMPORTED_MODULE_9__StyleSheet__["a" /* default */].create({
  root: {
    flexBasis: 'auto',
    overflow: 'hidden',
    zIndex: 0
  },
  inline: {
    display: 'inline-flex'
  },
  image: Object.assign({}, __WEBPACK_IMPORTED_MODULE_9__StyleSheet__["a" /* default */].absoluteFillObject, {
    backgroundColor: 'transparent',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    height: '100%',
    width: '100%',
    zIndex: -1
  }),
  accessibilityImage: Object.assign({}, __WEBPACK_IMPORTED_MODULE_9__StyleSheet__["a" /* default */].absoluteFillObject, {
    height: '100%',
    opacity: 0,
    width: '100%',
    zIndex: -1
  })
});

var resizeModeStyles = __WEBPACK_IMPORTED_MODULE_9__StyleSheet__["a" /* default */].create({
  center: {
    backgroundSize: 'auto'
  },
  contain: {
    backgroundSize: 'contain'
  },
  cover: {
    backgroundSize: 'cover'
  },
  none: {
    backgroundPosition: '0 0',
    backgroundSize: 'auto'
  },
  repeat: {
    backgroundPosition: '0 0',
    backgroundRepeat: 'repeat',
    backgroundSize: 'auto'
  },
  stretch: {
    backgroundSize: '100% 100%'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__modules_applyNativeMethods__["a" /* default */])(Image));

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_UIManager__ = __webpack_require__(52);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * This class is responsible for coordinating the "focused"
 * state for TextInputs. All calls relating to the keyboard
 * should be funneled through here
 */
var TextInputState = {
  /**
   * Internal state
   */
  _currentlyFocusedNode: null,

  /**
   * Returns the ID of the currently focused text field, if one exists
   * If no text field is focused it returns null
   */
  currentlyFocusedField: function currentlyFocusedField() {
    if (document.activeElement !== this._currentlyFocusedNode) {
      this._currentlyFocusedNode = null;
    }
    return this._currentlyFocusedNode;
  },


  /**
   * @param {Object} TextInputID id of the text field to focus
   * Focuses the specified text field
   * noop if the text field was already focused
   */
  focusTextInput: function focusTextInput(textFieldNode) {
    if (textFieldNode !== null) {
      this._currentlyFocusedNode = textFieldNode;
      if (document.activeElement !== textFieldNode) {
        __WEBPACK_IMPORTED_MODULE_0__exports_UIManager__["a" /* default */].focus(textFieldNode);
      }
    }
  },


  /**
   * @param {Object} textFieldNode id of the text field to focus
   * Unfocuses the specified text field
   * noop if it wasn't focused
   */
  blurTextInput: function blurTextInput(textFieldNode) {
    if (textFieldNode !== null) {
      this._currentlyFocusedNode = null;
      if (document.activeElement === textFieldNode) {
        __WEBPACK_IMPORTED_MODULE_0__exports_UIManager__["a" /* default */].blur(textFieldNode);
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TextInputState);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_applyLayout__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_applyNativeMethods__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createElement__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TextPropTypes__ = __webpack_require__(182);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */









var Text = function (_Component) {
  _inherits(Text, _Component);

  function Text() {
    _classCallCheck(this, Text);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Text.prototype.getChildContext = function getChildContext() {
    return { isInAParentText: true };
  };

  Text.prototype.render = function render() {
    var _props = this.props,
        dir = _props.dir,
        numberOfLines = _props.numberOfLines,
        onPress = _props.onPress,
        selectable = _props.selectable,
        style = _props.style,
        adjustsFontSizeToFit = _props.adjustsFontSizeToFit,
        allowFontScaling = _props.allowFontScaling,
        ellipsizeMode = _props.ellipsizeMode,
        lineBreakMode = _props.lineBreakMode,
        minimumFontScale = _props.minimumFontScale,
        onLayout = _props.onLayout,
        onLongPress = _props.onLongPress,
        pressRetentionOffset = _props.pressRetentionOffset,
        selectionColor = _props.selectionColor,
        suppressHighlighting = _props.suppressHighlighting,
        textBreakStrategy = _props.textBreakStrategy,
        tvParallaxProperties = _props.tvParallaxProperties,
        otherProps = _objectWithoutProperties(_props, ['dir', 'numberOfLines', 'onPress', 'selectable', 'style', 'adjustsFontSizeToFit', 'allowFontScaling', 'ellipsizeMode', 'lineBreakMode', 'minimumFontScale', 'onLayout', 'onLongPress', 'pressRetentionOffset', 'selectionColor', 'suppressHighlighting', 'textBreakStrategy', 'tvParallaxProperties']);

    var isInAParentText = this.context.isInAParentText;


    if (onPress) {
      otherProps.accessible = true;
      otherProps.onClick = this._createPressHandler(onPress);
      otherProps.onKeyDown = this._createEnterHandler(onPress);
    }

    // allow browsers to automatically infer the language writing direction
    otherProps.dir = dir !== undefined ? dir : 'auto';
    otherProps.style = [styles.initial, this.context.isInAParentText === true && styles.isInAParentText, style, selectable === false && styles.notSelectable, numberOfLines === 1 && styles.singleLineStyle, onPress && styles.pressable];

    var component = isInAParentText ? 'span' : 'div';

    return Object(__WEBPACK_IMPORTED_MODULE_4__createElement__["a" /* default */])(component, otherProps);
  };

  Text.prototype._createEnterHandler = function _createEnterHandler(fn) {
    return function (e) {
      if (e.keyCode === 13) {
        fn && fn(e);
      }
    };
  };

  Text.prototype._createPressHandler = function _createPressHandler(fn) {
    return function (e) {
      e.stopPropagation();
      fn && fn(e);
    };
  };

  return Text;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Text.displayName = 'Text';
Text.childContextTypes = {
  isInAParentText: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"]
};
Text.contextTypes = {
  isInAParentText: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"]
};
Text.propTypes =  false ? TextPropTypes : {};


var styles = __WEBPACK_IMPORTED_MODULE_5__StyleSheet__["a" /* default */].create({
  initial: {
    borderWidth: 0,
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'inline',
    fontFamily: 'System',
    fontSize: 14,
    fontStyle: 'inherit',
    fontVariant: ['inherit'],
    fontWeight: 'inherit',
    lineHeight: 'inherit',
    margin: 0,
    padding: 0,
    textDecorationLine: 'none',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word'
  },
  isInAParentText: {
    // inherit parent font styles
    fontFamily: 'inherit',
    fontSize: 'inherit',
    whiteSpace: 'inherit'
  },
  notSelectable: {
    userSelect: 'none'
  },
  pressable: {
    cursor: 'pointer'
  },
  singleLineStyle: {
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__modules_applyLayout__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__modules_applyNativeMethods__["a" /* default */])(Text)));

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);

function elementFrom(node){
	if (node.toElement) return node.toElement();
	if (node.getDOMNode) return node.getDOMNode();
	if (node.getNode) return node.getNode();
	return node;
}

module.exports = Class({

	// conventions

	toElement: function(){
		return this.element;
	},

	getDOMNode: function(){
		return this.toElement();
	},

	getNode: function(){
		return this.toElement();
	},

	// placement

	inject: function(container){
		(container.containerElement || elementFrom(container))
			.appendChild(this.element);
		return this;
	},

	injectBefore: function(sibling){
		var element = elementFrom(sibling);
		element.parentNode.insertBefore(this.element, element);
		return this;
	},

	eject: function(){
		var element = this.element, parent = element.parentNode;
		if (parent) parent.removeChild(element); // TODO: VML Nodes are dead after being ejected
		return this;
	},

	// events

	subscribe: function(type, fn, bind){
		if (typeof type != 'string'){ // listen type / fn with object
			var subscriptions = [];
			for (var t in type) subscriptions.push(this.subscribe(t, type[t]));
			return function(){ // unsubscribe
				for (var i = 0, l = subscriptions.length; i < l; i++)
					subscriptions[i]();
				return this;
			};
		} else { // listen to one
			if (!bind) bind = this;
			var bound;
			if (typeof fn === 'function'){
				bound = fn.bind ? fn.bind(bind)
					: function(){ return fn.apply(bind, arguments); };
			} else {
				bound = fn;
			}
			var element = this.element;
			if (element.addEventListener){
				element.addEventListener(type, bound, false);
				return function(){ // unsubscribe
					element.removeEventListener(type, bound, false);
					return this;
				};
			} else {
				element.attachEvent('on' + type, bound);
				return function(){ // unsubscribe
					element.detachEvent('on' + type, bound);
					return this;
				};
			}
		}
	}

});


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Transform = __webpack_require__(81);
var Element = __webpack_require__(301);

var CanvasNode = Class(Transform, Element, {
	
	invalidate: function(){
		if (this.parentNode) this.parentNode.invalidate();
		if (this._layer) this._layerCache = null;
		return this;
	},

	_place: function(){
		this.invalidate();
	},
	
	_transform: function(){
		this.invalidate();
	},
	
	blend: function(opacity){
		if (opacity >= 1 && this._layer) this._layer = null;
		this._opacity = opacity;
		if (this.parentNode) this.parentNode.invalidate();
		return this;
	},
	
	// visibility
	
	hide: function(){
		this._invisible = true;
		if (this.parentNode) this.parentNode.invalidate();
		return this;
	},
	
	show: function(){
		this._invisible = false;
		if (this.parentNode) this.parentNode.invalidate();
		return this;
	},
	
	// interaction
	
	indicate: function(cursor, tooltip){
		this._cursor = cursor;
		this._tooltip = tooltip;
		return this.invalidate();
	},

	hitTest: function(x, y){
		if (this._invisible) return null;
		var point = this.inversePoint(x, y);
		if (!point) return null;
		return this.localHitTest(point.x, point.y);
	},

	// rendering

	renderTo: function(context, xx, yx, xy, yy, x, y){
		var opacity = this._opacity;
		if (opacity == null || opacity >= 1){
			return this.renderLayerTo(context, xx, yx, xy, yy, x, y);
		}

		// Render to a compositing layer and cache it

		var layer = this._layer, canvas, isDirty = true,
			w = context.canvas.width, h = context.canvas.height;
		if (layer){
			layer.setTransform(1, 0, 0, 1, 0, 0);
			canvas = layer.canvas;
			if (canvas.width < w || canvas.height < h){
				canvas.width = w;
				canvas.height = h;
			} else {
				var c = this._layerCache;
				if (c && c.xx === xx && c.yx === yx && c.xy === xy
					&& c.yy === yy && c.x === x && c.y === y){
					isDirty = false;
				} else {
					layer.clearRect(0, 0, w, h);
				}
			}
		} else {
			canvas = document.createElement('canvas');
			canvas.width = w;
			canvas.height = h;
			this._layer = layer = canvas.getContext('2d');
		}

		if (isDirty){
			this.renderLayerTo(layer, xx, yx, xy, yy, x, y);
			this._layerCache = {
				xx: xx,
				yx: yx,
				xy: xy,
				yy: yy,
				x: x,
				y: y
			};
		}

		context.globalAlpha = opacity;
		context.setTransform(1, 0, 0, 1, 0, 0);
		context.drawImage(
			canvas,
			0, 0, w, h,
			0, 0, w, h
		);
		context.globalAlpha = 1;
	}

});

module.exports = CanvasNode;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Path = __webpack_require__(298);

var precision = 100;

var round = Math.round;

var VMLPath = Class(Path, {

	initialize: function(path){
		this.reset();
		if (path instanceof VMLPath){
			this.path = [Array.prototype.join.call(path.path, ' ')];
		} else if (path){
			if (path.applyToPath)
				path.applyToPath(this);
			else
				this.push(path);
		}
	},

	onReset: function(){
		this.path = [];
	},

	onMove: function(sx, sy, x, y){
		this.path.push('m', round(x * precision), round(y * precision));
	},

	onLine: function(sx, sy, x, y){
		this.path.push('l', round(x * precision), round(y * precision));
	},

	onBezierCurve: function(sx, sy, p1x, p1y, p2x, p2y, x, y){
		this.path.push('c',
			round(p1x * precision), round(p1y * precision),
			round(p2x * precision), round(p2y * precision),
			round(x * precision), round(y * precision)
		);
	},

	_arcToBezier: Path.prototype.onArc,

	onArc: function(sx, sy, ex, ey, cx, cy, rx, ry, sa, ea, ccw, rotation){
		if (rx != ry || rotation) return this._arcToBezier(sx, sy, ex, ey, cx, cy, rx, ry, sa, ea, ccw, rotation);
		cx *= precision;
		cy *= precision;
		rx *= precision;
		this.path.push(ccw ? 'at' : 'wa',
			round(cx - rx), round(cy - rx),
			round(cx + rx), round(cy + rx),
			round(sx * precision), round(sy * precision),
			round(ex * precision), round(ey * precision)
		);
	},

	onClose: function(){
		this.path.push('x');
	},

	toVML: function(){
		return this.path.join(' ');
	}

});

VMLPath.prototype.toString = VMLPath.prototype.toVML;

module.exports = VMLPath;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Transform = __webpack_require__(81);
var Element = __webpack_require__(695);
var DOM = __webpack_require__(93);

module.exports = Class(Element, Transform, {

	initialize: function(tag){
		//this.uid = uniqueID();
		var element = this.element = DOM.createElement(tag);
		//element.setAttribute('id', 'e' + this.uid);
	},

	_place: function(){
		if (this.parentNode){
			this._transform();
		}
	},

	// visibility

	hide: function(){
		this.element.style.display = 'none';
		return this;
	},

	show: function(){
		this.element.style.display = '';
		return this;
	},

	// interaction

	indicate: function(cursor, tooltip){
		if (cursor) this.element.style.cursor = cursor;
		if (tooltip) this.element.title = tooltip;
		return this;
	}

});


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ensurePositiveDelayProps = function ensurePositiveDelayProps(props) {
  __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(!(props.delayPressIn < 0 || props.delayPressOut < 0 || props.delayLongPress < 0), 'Touchable components cannot have negative delay properties');
};

/* harmony default export */ __webpack_exports__["a"] = (ensurePositiveDelayProps);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EdgeInsetsPropType__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Touchable_ensurePositiveDelayProps__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_timer_mixin__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_timer_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_timer_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Touchable__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ViewPropTypes__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fbjs_lib_warning__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fbjs_lib_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_fbjs_lib_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */












var PRESS_RETENTION_OFFSET = { top: 20, left: 20, right: 20, bottom: 30 };

/**
 * Do not use unless you have a very good reason. All elements that
 * respond to press should have a visual feedback when touched.
 *
 * TouchableWithoutFeedback supports only one child.
 * If you wish to have several child components, wrap them in a View.
 */

/* eslint-disable react/prefer-es6-class, react/prop-types */
var TouchableWithoutFeedback = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'TouchableWithoutFeedback',
  mixins: [__WEBPACK_IMPORTED_MODULE_5_react_timer_mixin___default.a, __WEBPACK_IMPORTED_MODULE_6__Touchable__["a" /* default */].Mixin],

  propTypes: {
    accessibilityComponentType: __WEBPACK_IMPORTED_MODULE_7__ViewPropTypes__["a" /* default */].accessibilityComponentType,
    accessibilityLabel: __WEBPACK_IMPORTED_MODULE_9_prop_types__["string"],
    accessibilityRole: __WEBPACK_IMPORTED_MODULE_7__ViewPropTypes__["a" /* default */].accessibilityRole,
    accessibilityTraits: __WEBPACK_IMPORTED_MODULE_7__ViewPropTypes__["a" /* default */].accessibilityTraits,
    accessible: __WEBPACK_IMPORTED_MODULE_9_prop_types__["bool"],
    children: __WEBPACK_IMPORTED_MODULE_9_prop_types__["any"],
    /**
     * Delay in ms, from onPressIn, before onLongPress is called.
     */
    delayLongPress: __WEBPACK_IMPORTED_MODULE_9_prop_types__["number"],
    /**
     * Delay in ms, from the start of the touch, before onPressIn is called.
     */
    delayPressIn: __WEBPACK_IMPORTED_MODULE_9_prop_types__["number"],
    /**
     * Delay in ms, from the release of the touch, before onPressOut is called.
     */
    delayPressOut: __WEBPACK_IMPORTED_MODULE_9_prop_types__["number"],
    /**
     * If true, disable all interactions for this component.
     */
    disabled: __WEBPACK_IMPORTED_MODULE_9_prop_types__["bool"],
    /**
     * This defines how far your touch can start away from the button. This is
     * added to `pressRetentionOffset` when moving off of the button.
     */
    // $FlowFixMe(>=0.41.0)
    hitSlop: __WEBPACK_IMPORTED_MODULE_1__EdgeInsetsPropType__["a" /* default */],
    /**
     * Invoked on mount and layout changes with
     *
     *   `{nativeEvent: {layout: {x, y, width, height}}}`
     */
    onLayout: __WEBPACK_IMPORTED_MODULE_9_prop_types__["func"],
    onLongPress: __WEBPACK_IMPORTED_MODULE_9_prop_types__["func"],
    /**
     * Called when the touch is released, but not if cancelled (e.g. by a scroll
     * that steals the responder lock).
     */
    onPress: __WEBPACK_IMPORTED_MODULE_9_prop_types__["func"],
    onPressIn: __WEBPACK_IMPORTED_MODULE_9_prop_types__["func"],
    onPressOut: __WEBPACK_IMPORTED_MODULE_9_prop_types__["func"],
    /**
     * When the scroll view is disabled, this defines how far your touch may
     * move off of the button, before deactivating the button. Once deactivated,
     * try moving it back and you'll see that the button is once again
     * reactivated! Move it back and forth several times while the scroll view
     * is disabled. Ensure you pass in a constant to reduce memory allocations.
     */
    // $FlowFixMe
    pressRetentionOffset: __WEBPACK_IMPORTED_MODULE_1__EdgeInsetsPropType__["a" /* default */],
    testID: __WEBPACK_IMPORTED_MODULE_9_prop_types__["string"]
  },

  getInitialState: function getInitialState() {
    return this.touchableGetInitialState();
  },

  componentDidMount: function componentDidMount() {
    Object(__WEBPACK_IMPORTED_MODULE_2__Touchable_ensurePositiveDelayProps__["a" /* default */])(this.props);
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    Object(__WEBPACK_IMPORTED_MODULE_2__Touchable_ensurePositiveDelayProps__["a" /* default */])(nextProps);
  },

  /**
   * `Touchable.Mixin` self callbacks. The mixin will invoke these if they are
   * defined on your component.
   */
  touchableHandlePress: function touchableHandlePress(e) {
    this.props.onPress && this.props.onPress(e);
  },

  touchableHandleActivePressIn: function touchableHandleActivePressIn(e) {
    this.props.onPressIn && this.props.onPressIn(e);
  },

  touchableHandleActivePressOut: function touchableHandleActivePressOut(e) {
    this.props.onPressOut && this.props.onPressOut(e);
  },

  touchableHandleLongPress: function touchableHandleLongPress(e) {
    this.props.onLongPress && this.props.onLongPress(e);
  },

  touchableGetPressRectOffset: function touchableGetPressRectOffset() {
    return this.props.pressRetentionOffset || PRESS_RETENTION_OFFSET;
  },

  touchableGetHitSlop: function touchableGetHitSlop() {
    return this.props.hitSlop;
  },

  touchableGetHighlightDelayMS: function touchableGetHighlightDelayMS() {
    return this.props.delayPressIn || 0;
  },

  touchableGetLongPressDelayMS: function touchableGetLongPressDelayMS() {
    return this.props.delayLongPress === 0 ? 0 : this.props.delayLongPress || 500;
  },

  touchableGetPressOutDelayMS: function touchableGetPressOutDelayMS() {
    return this.props.delayPressOut || 0;
  },

  render: function render() {
    var _props = this.props,
        delayLongPress = _props.delayLongPress,
        delayPressIn = _props.delayPressIn,
        delayPressOut = _props.delayPressOut,
        onLongPress = _props.onLongPress,
        onPress = _props.onPress,
        onPressIn = _props.onPressIn,
        onPressOut = _props.onPressOut,
        pressRetentionOffset = _props.pressRetentionOffset,
        other = _objectWithoutProperties(_props, ['delayLongPress', 'delayPressIn', 'delayPressOut', 'onLongPress', 'onPress', 'onPressIn', 'onPressOut', 'pressRetentionOffset']);

    // Note(avik): remove dynamic typecast once Flow has been upgraded
    // $FlowFixMe


    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(this.props.children);
    var children = child.props.children;
    __WEBPACK_IMPORTED_MODULE_8_fbjs_lib_warning___default()(!child.type || child.type.displayName !== 'Text', 'TouchableWithoutFeedback does not work well with Text children. Wrap children in a View instead. See ' + (child._owner && child._owner.getName && child._owner.getName() || '<unknown>'));
    if (false) {
      children = React.Children.toArray(children);
      children.push(Touchable.renderDebugView({ color: 'red', hitSlop: this.props.hitSlop }));
    }
    var style = __WEBPACK_IMPORTED_MODULE_6__Touchable__["a" /* default */].TOUCH_TARGET_DEBUG && child.type && child.type.displayName === 'Text' ? [!this.props.disabled && styles.actionable, child.props.style, { color: 'red' }] : [!this.props.disabled && styles.actionable, child.props.style];
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, Object.assign({}, other, {
      accessible: this.props.accessible !== false,
      children: children,
      onKeyDown: this.touchableHandleKeyEvent,
      onKeyUp: this.touchableHandleKeyEvent,
      onResponderGrant: this.touchableHandleResponderGrant,
      onResponderMove: this.touchableHandleResponderMove,
      onResponderRelease: this.touchableHandleResponderRelease,
      onResponderTerminate: this.touchableHandleResponderTerminate,
      onResponderTerminationRequest: this.touchableHandleResponderTerminationRequest,
      onStartShouldSetResponder: this.touchableHandleStartShouldSetResponder,
      style: style
    }));
  }
});

var styles = __WEBPACK_IMPORTED_MODULE_4__StyleSheet__["a" /* default */].create({
  actionable: {
    cursor: 'pointer',
    touchAction: 'manipulation'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (TouchableWithoutFeedback);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Batchinator__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FillRateHelper__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__exports_RefreshControl__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exports_ScrollView__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__exports_StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__exports_UIManager__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__exports_View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ViewabilityHelper__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__VirtualizeUtils__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__exports_findNodeHandle__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__infoLog__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_fbjs_lib_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_fbjs_lib_warning__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_fbjs_lib_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_fbjs_lib_warning__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 * @format
 */
















var flattenStyle = __WEBPACK_IMPORTED_MODULE_6__exports_StyleSheet__["a" /* default */].flatten;
var __DEV__ = "production" !== 'production';
/* $FlowFixMe - this Props seems to be missing a bunch of stuff. Remove this
 * comment to see the errors */


var _usedIndexForKey = false;

/**
 * Base implementation for the more convenient [`<FlatList>`](/react-native/docs/flatlist.html)
 * and [`<SectionList>`](/react-native/docs/sectionlist.html) components, which are also better
 * documented. In general, this should only really be used if you need more flexibility than
 * `FlatList` provides, e.g. for use with immutable data instead of plain arrays.
 *
 * Virtualization massively improves memory consumption and performance of large lists by
 * maintaining a finite render window of active items and replacing all items outside of the render
 * window with appropriately sized blank space. The window adapts to scrolling behavior, and items
 * are rendered incrementally with low-pri (after any running interactions) if they are far from the
 * visible area, or with hi-pri otherwise to minimize the potential of seeing blank space.
 *
 * Some caveats:
 *
 * - Internal state is not preserved when content scrolls out of the render window. Make sure all
 *   your data is captured in the item data or external stores like Flux, Redux, or Relay.
 * - This is a `PureComponent` which means that it will not re-render if `props` remain shallow-
 *   equal. Make sure that everything your `renderItem` function depends on is passed as a prop
 *   (e.g. `extraData`) that is not `===` after updates, otherwise your UI may not update on
 *   changes. This includes the `data` prop and parent component state.
 * - In order to constrain memory and enable smooth scrolling, content is rendered asynchronously
 *   offscreen. This means it's possible to scroll faster than the fill rate ands momentarily see
 *   blank content. This is a tradeoff that can be adjusted to suit the needs of each application,
 *   and we are working on improving it behind the scenes.
 * - By default, the list looks for a `key` prop on each item and uses that for the React key.
 *   Alternatively, you can provide a custom `keyExtractor` prop.
 *
 */
var VirtualizedList = function (_React$PureComponent) {
  _inherits(VirtualizedList, _React$PureComponent);

  // scrollToEnd may be janky without getItemLayout prop
  VirtualizedList.prototype.scrollToEnd = function scrollToEnd(params) {
    var animated = params ? params.animated : true;
    var veryLast = this.props.getItemCount(this.props.data) - 1;
    var frame = this._getFrameMetricsApprox(veryLast);
    var offset = Math.max(0, frame.offset + frame.length + this._footerLength - this._scrollMetrics.visibleLength);
    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
     * suppresses an error when upgrading Flow's support for React. To see the
     * error delete this comment and run Flow. */
    this._scrollRef.scrollTo(
    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
     * comment suppresses an error when upgrading Flow's support for React.
     * To see the error delete this comment and run Flow. */
    this.props.horizontal ? { x: offset, animated: animated } : { y: offset, animated: animated });
  };

  // scrollToIndex may be janky without getItemLayout prop


  VirtualizedList.prototype.scrollToIndex = function scrollToIndex(params) {
    var _props = this.props,
        data = _props.data,
        horizontal = _props.horizontal,
        getItemCount = _props.getItemCount,
        getItemLayout = _props.getItemLayout,
        onScrollToIndexFailed = _props.onScrollToIndexFailed;
    var animated = params.animated,
        index = params.index,
        viewOffset = params.viewOffset,
        viewPosition = params.viewPosition;

    __WEBPACK_IMPORTED_MODULE_13_fbjs_lib_invariant___default()(index >= 0 && index < getItemCount(data), 'scrollToIndex out of range: ' + index + ' vs ' + (getItemCount(data) - 1));
    if (!getItemLayout && index > this._highestMeasuredFrameIndex) {
      __WEBPACK_IMPORTED_MODULE_13_fbjs_lib_invariant___default()(!!onScrollToIndexFailed, 'scrollToIndex should be used in conjunction with getItemLayout or onScrollToIndexFailed, ' + 'otherwise there is no way to know the location of offscreen indices or handle failures.');
      onScrollToIndexFailed({
        averageItemLength: this._averageCellLength,
        highestMeasuredFrameIndex: this._highestMeasuredFrameIndex,
        index: index
      });
      return;
    }
    var frame = this._getFrameMetricsApprox(index);
    var offset = Math.max(0, frame.offset - (viewPosition || 0) * (this._scrollMetrics.visibleLength - frame.length)) - (viewOffset || 0);
    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
     * suppresses an error when upgrading Flow's support for React. To see the
     * error delete this comment and run Flow. */
    this._scrollRef.scrollTo(
    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
     * comment suppresses an error when upgrading Flow's support for React.
     * To see the error delete this comment and run Flow. */
    horizontal ? { x: offset, animated: animated } : { y: offset, animated: animated });
  };

  // scrollToItem may be janky without getItemLayout prop. Required linear scan through items -
  // use scrollToIndex instead if possible.


  VirtualizedList.prototype.scrollToItem = function scrollToItem(params) {
    var item = params.item;
    var _props2 = this.props,
        data = _props2.data,
        getItem = _props2.getItem,
        getItemCount = _props2.getItemCount;

    var itemCount = getItemCount(data);
    for (var _index = 0; _index < itemCount; _index++) {
      if (getItem(data, _index) === item) {
        this.scrollToIndex(Object.assign({}, params, { index: _index }));
        break;
      }
    }
  };

  /**
   * Scroll to a specific content pixel offset in the list.
   *
   * Param `offset` expects the offset to scroll to.
   * In case of `horizontal` is true, the offset is the x-value,
   * in any other case the offset is the y-value.
   *
   * Param `animated` (`true` by default) defines whether the list
   * should do an animation while scrolling.
   */


  VirtualizedList.prototype.scrollToOffset = function scrollToOffset(params) {
    var animated = params.animated,
        offset = params.offset;
    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
     * suppresses an error when upgrading Flow's support for React. To see the
     * error delete this comment and run Flow. */

    this._scrollRef.scrollTo(
    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
     * comment suppresses an error when upgrading Flow's support for React.
     * To see the error delete this comment and run Flow. */
    this.props.horizontal ? { x: offset, animated: animated } : { y: offset, animated: animated });
  };

  VirtualizedList.prototype.recordInteraction = function recordInteraction() {
    this._nestedChildLists.forEach(function (childList) {
      childList.ref && childList.ref.recordInteraction();
    });
    this._viewabilityTuples.forEach(function (t) {
      t.viewabilityHelper.recordInteraction();
    });
    this._updateViewableItems(this.props.data);
  };

  VirtualizedList.prototype.flashScrollIndicators = function flashScrollIndicators() {
    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
     * suppresses an error when upgrading Flow's support for React. To see the
     * error delete this comment and run Flow. */
    this._scrollRef.flashScrollIndicators();
  };

  /**
   * Provides a handle to the underlying scroll responder.
   * Note that `this._scrollRef` might not be a `ScrollView`, so we
   * need to check that it responds to `getScrollResponder` before calling it.
   */


  VirtualizedList.prototype.getScrollResponder = function getScrollResponder() {
    if (this._scrollRef && this._scrollRef.getScrollResponder) {
      return this._scrollRef.getScrollResponder();
    }
  };

  VirtualizedList.prototype.getScrollableNode = function getScrollableNode() {
    if (this._scrollRef && this._scrollRef.getScrollableNode) {
      return this._scrollRef.getScrollableNode();
    } else {
      return Object(__WEBPACK_IMPORTED_MODULE_11__exports_findNodeHandle__["a" /* default */])(this._scrollRef);
    }
  };

  VirtualizedList.prototype.setNativeProps = function setNativeProps(props) {
    if (this._scrollRef) {
      this._scrollRef.setNativeProps(props);
    }
  };

  VirtualizedList.prototype.getChildContext = function getChildContext() {
    return {
      virtualizedList: {
        getScrollMetrics: this._getScrollMetrics,
        horizontal: this.props.horizontal,
        getOutermostParentListRef: this._getOutermostParentListRef,
        getNestedChildState: this._getNestedChildState,
        registerAsNestedChild: this._registerAsNestedChild,
        unregisterAsNestedChild: this._unregisterAsNestedChild
      }
    };
  };

  VirtualizedList.prototype._getCellKey = function _getCellKey() {
    return this.context.virtualizedCell && this.context.virtualizedCell.cellKey || 'rootList';
  };

  VirtualizedList.prototype.hasMore = function hasMore() {
    return this._hasMore;
  };

  function VirtualizedList(props, context) {
    _classCallCheck(this, VirtualizedList);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));

    _initialiseProps.call(_this);

    __WEBPACK_IMPORTED_MODULE_13_fbjs_lib_invariant___default()(!props.onScroll || !props.onScroll.__isNative, 'Components based on VirtualizedList must be wrapped with Animated.createAnimatedComponent ' + 'to support native onScroll events with useNativeDriver');

    __WEBPACK_IMPORTED_MODULE_13_fbjs_lib_invariant___default()(props.windowSize > 0, 'VirtualizedList: The windowSize prop must be present and set to a value greater than 0.');

    _this._fillRateHelper = new __WEBPACK_IMPORTED_MODULE_1__FillRateHelper__["a" /* default */](_this._getFrameMetrics);
    _this._updateCellsToRenderBatcher = new __WEBPACK_IMPORTED_MODULE_0__Batchinator__["a" /* default */](_this._updateCellsToRender, _this.props.updateCellsBatchingPeriod);

    if (_this.props.viewabilityConfigCallbackPairs) {
      _this._viewabilityTuples = _this.props.viewabilityConfigCallbackPairs.map(function (pair) {
        return {
          viewabilityHelper: new __WEBPACK_IMPORTED_MODULE_9__ViewabilityHelper__["a" /* default */](pair.viewabilityConfig),
          onViewableItemsChanged: pair.onViewableItemsChanged
        };
      });
    } else if (_this.props.onViewableItemsChanged) {
      _this._viewabilityTuples.push({
        viewabilityHelper: new __WEBPACK_IMPORTED_MODULE_9__ViewabilityHelper__["a" /* default */](_this.props.viewabilityConfig),
        onViewableItemsChanged: _this.props.onViewableItemsChanged
      });
    }

    var initialState = {
      first: _this.props.initialScrollIndex || 0,
      last: Math.min(_this.props.getItemCount(_this.props.data), (_this.props.initialScrollIndex || 0) + _this.props.initialNumToRender) - 1
    };

    if (_this._isNestedWithSameOrientation()) {
      var storedState = _this.context.virtualizedList.getNestedChildState(_this.props.listKey || _this._getCellKey());
      if (storedState) {
        initialState = storedState;
        _this.state = storedState;
        _this._frames = storedState.frames;
      }
    }

    _this.state = initialState;
    return _this;
  }

  VirtualizedList.prototype.componentDidMount = function componentDidMount() {
    if (this._isNestedWithSameOrientation()) {
      this.context.virtualizedList.registerAsNestedChild({
        cellKey: this._getCellKey(),
        key: this.props.listKey || this._getCellKey(),
        ref: this
      });
    }
  };

  VirtualizedList.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this._isNestedWithSameOrientation()) {
      this.context.virtualizedList.unregisterAsNestedChild({
        key: this.props.listKey || this._getCellKey(),
        state: {
          first: this.state.first,
          last: this.state.last,
          frames: this._frames
        }
      });
    }
    this._updateViewableItems(null);
    this._updateCellsToRenderBatcher.dispose({ abort: true });
    this._viewabilityTuples.forEach(function (tuple) {
      tuple.viewabilityHelper.dispose();
    });
    this._fillRateHelper.deactivateAndFlush();
  };

  VirtualizedList.getDerivedStateFromProps = function getDerivedStateFromProps(newProps, prevState) {
    var data = newProps.data,
        extraData = newProps.extraData,
        getItemCount = newProps.getItemCount,
        maxToRenderPerBatch = newProps.maxToRenderPerBatch;
    // first and last could be stale (e.g. if a new, shorter items props is passed in), so we make
    // sure we're rendering a reasonable range here.

    return {
      first: Math.max(0, Math.min(prevState.first, getItemCount(data) - 1 - maxToRenderPerBatch)),
      last: Math.max(0, Math.min(prevState.last, getItemCount(data) - 1))
    };
  };

  VirtualizedList.prototype._pushCells = function _pushCells(cells, stickyHeaderIndices, stickyIndicesFromProps, first, last, inversionStyle) {
    var _this2 = this;

    var _props3 = this.props,
        CellRendererComponent = _props3.CellRendererComponent,
        ItemSeparatorComponent = _props3.ItemSeparatorComponent,
        data = _props3.data,
        getItem = _props3.getItem,
        getItemCount = _props3.getItemCount,
        horizontal = _props3.horizontal,
        keyExtractor = _props3.keyExtractor;

    var stickyOffset = this.props.ListHeaderComponent ? 1 : 0;
    var end = getItemCount(data) - 1;
    var prevCellKey = void 0;
    last = Math.min(end, last);

    var _loop = function _loop(ii) {
      var item = getItem(data, ii);
      var key = keyExtractor(item, ii);
      _this2._indicesToKeys.set(ii, key);
      if (stickyIndicesFromProps.has(ii + stickyOffset)) {
        stickyHeaderIndices.push(cells.length);
      }
      cells.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(CellRenderer, {
        CellRendererComponent: CellRendererComponent,
        ItemSeparatorComponent: ii < end ? ItemSeparatorComponent : undefined,
        cellKey: key,
        fillRateHelper: _this2._fillRateHelper,
        horizontal: horizontal,
        index: ii,
        inversionStyle: inversionStyle,
        item: item,
        key: key,
        prevCellKey: prevCellKey,
        onUpdateSeparators: _this2._onUpdateSeparators,
        onLayout: function onLayout(e) {
          return _this2._onCellLayout(e, key, ii);
        },
        onUnmount: _this2._onCellUnmount,
        parentProps: _this2.props,
        ref: function (_ref) {
          function ref(_x) {
            return _ref.apply(this, arguments);
          }

          ref.toString = function () {
            return _ref.toString();
          };

          return ref;
        }(function (ref) {
          _this2._cellRefs[key] = ref;
        })
      }));
      prevCellKey = key;
    };

    for (var ii = first; ii <= last; ii++) {
      _loop(ii);
    }
  };

  VirtualizedList.prototype._isVirtualizationDisabled = function _isVirtualizationDisabled() {
    return this.props.disableVirtualization;
  };

  VirtualizedList.prototype._isNestedWithSameOrientation = function _isNestedWithSameOrientation() {
    var nestedContext = this.context.virtualizedList;
    return !!(nestedContext && !!nestedContext.horizontal === !!this.props.horizontal);
  };

  VirtualizedList.prototype.render = function render() {
    if (__DEV__) {
      var flatStyles = flattenStyle(this.props.contentContainerStyle);
      __WEBPACK_IMPORTED_MODULE_14_fbjs_lib_warning___default()(flatStyles == null || flatStyles.flexWrap !== 'wrap', '`flexWrap: `wrap`` is not supported with the `VirtualizedList` components.' + 'Consider using `numColumns` with `FlatList` instead.');
    }
    var _props4 = this.props,
        ListEmptyComponent = _props4.ListEmptyComponent,
        ListFooterComponent = _props4.ListFooterComponent,
        ListHeaderComponent = _props4.ListHeaderComponent;
    var _props5 = this.props,
        data = _props5.data,
        horizontal = _props5.horizontal;

    var isVirtualizationDisabled = this._isVirtualizationDisabled();
    var inversionStyle = this.props.inverted ? this.props.horizontal ? styles.horizontallyInverted : styles.verticallyInverted : null;
    var cells = [];
    var stickyIndicesFromProps = new Set(this.props.stickyHeaderIndices);
    var stickyHeaderIndices = [];
    if (ListHeaderComponent) {
      if (stickyIndicesFromProps.has(0)) {
        stickyHeaderIndices.push(0);
      }
      var element = __WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(ListHeaderComponent) ? ListHeaderComponent :
      // $FlowFixMe
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ListHeaderComponent, null);
      cells.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        VirtualizedCellWrapper,
        {
          cellKey: this._getCellKey() + '-header',
          key: '$header' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__exports_View__["a" /* default */],
          { onLayout: this._onLayoutHeader, style: inversionStyle },
          element
        )
      ));
    }
    var itemCount = this.props.getItemCount(data);
    if (itemCount > 0) {
      _usedIndexForKey = false;
      var spacerKey = !horizontal ? 'height' : 'width';
      var lastInitialIndex = this.props.initialScrollIndex ? -1 : this.props.initialNumToRender - 1;
      var _state = this.state,
          _first = _state.first,
          _last = _state.last;

      this._pushCells(cells, stickyHeaderIndices, stickyIndicesFromProps, 0, lastInitialIndex, inversionStyle);
      var firstAfterInitial = Math.max(lastInitialIndex + 1, _first);
      if (!isVirtualizationDisabled && _first > lastInitialIndex + 1) {
        var insertedStickySpacer = false;
        if (stickyIndicesFromProps.size > 0) {
          var stickyOffset = ListHeaderComponent ? 1 : 0;
          // See if there are any sticky headers in the virtualized space that we need to render.
          for (var ii = firstAfterInitial - 1; ii > lastInitialIndex; ii--) {
            if (stickyIndicesFromProps.has(ii + stickyOffset)) {
              var _ref2, _ref3;

              var initBlock = this._getFrameMetricsApprox(lastInitialIndex);
              var stickyBlock = this._getFrameMetricsApprox(ii);
              var leadSpace = stickyBlock.offset - (initBlock.offset + initBlock.length);
              cells.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__exports_View__["a" /* default */], { key: '$sticky_lead', style: (_ref2 = {}, _ref2[spacerKey] = leadSpace, _ref2) }));
              this._pushCells(cells, stickyHeaderIndices, stickyIndicesFromProps, ii, ii, inversionStyle);
              var trailSpace = this._getFrameMetricsApprox(_first).offset - (stickyBlock.offset + stickyBlock.length);
              cells.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__exports_View__["a" /* default */], { key: '$sticky_trail', style: (_ref3 = {}, _ref3[spacerKey] = trailSpace, _ref3) }));
              insertedStickySpacer = true;
              break;
            }
          }
        }
        if (!insertedStickySpacer) {
          var _ref4;

          var _initBlock = this._getFrameMetricsApprox(lastInitialIndex);
          var firstSpace = this._getFrameMetricsApprox(_first).offset - (_initBlock.offset + _initBlock.length);
          cells.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__exports_View__["a" /* default */], { key: '$lead_spacer', style: (_ref4 = {}, _ref4[spacerKey] = firstSpace, _ref4) }));
        }
      }
      this._pushCells(cells, stickyHeaderIndices, stickyIndicesFromProps, firstAfterInitial, _last, inversionStyle);
      if (!this._hasWarned.keys && _usedIndexForKey) {
        console.warn('VirtualizedList: missing keys for items, make sure to specify a key property on each ' + 'item or provide a custom keyExtractor.');
        this._hasWarned.keys = true;
      }
      if (!isVirtualizationDisabled && _last < itemCount - 1) {
        var _ref5;

        var lastFrame = this._getFrameMetricsApprox(_last);
        // Without getItemLayout, we limit our tail spacer to the _highestMeasuredFrameIndex to
        // prevent the user for hyperscrolling into un-measured area because otherwise content will
        // likely jump around as it renders in above the viewport.
        var end = this.props.getItemLayout ? itemCount - 1 : Math.min(itemCount - 1, this._highestMeasuredFrameIndex);
        var endFrame = this._getFrameMetricsApprox(end);
        var tailSpacerLength = endFrame.offset + endFrame.length - (lastFrame.offset + lastFrame.length);
        cells.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__exports_View__["a" /* default */], { key: '$tail_spacer', style: (_ref5 = {}, _ref5[spacerKey] = tailSpacerLength, _ref5) }));
      }
    } else if (ListEmptyComponent) {
      var _element = __WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(ListEmptyComponent) ? ListEmptyComponent :
      // $FlowFixMe
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ListEmptyComponent, null);
      cells.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__exports_View__["a" /* default */],
        {
          key: '$empty',
          onLayout: this._onLayoutEmpty,
          style: inversionStyle },
        _element
      ));
    }
    if (ListFooterComponent) {
      var _element2 = __WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(ListFooterComponent) ? ListFooterComponent :
      // $FlowFixMe
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ListFooterComponent, null);
      cells.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        VirtualizedCellWrapper,
        {
          cellKey: this._getCellKey() + '-footer',
          key: '$footer' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__exports_View__["a" /* default */],
          { onLayout: this._onLayoutFooter, style: inversionStyle },
          _element2
        )
      ));
    }
    var scrollProps = Object.assign({}, this.props, {
      onContentSizeChange: this._onContentSizeChange,
      onLayout: this._onLayout,
      onScroll: this._onScroll,
      onScrollBeginDrag: this._onScrollBeginDrag,
      onScrollEndDrag: this._onScrollEndDrag,
      onMomentumScrollEnd: this._onMomentumScrollEnd,
      scrollEventThrottle: this.props.scrollEventThrottle, // TODO: Android support
      invertStickyHeaders: this.props.invertStickyHeaders !== undefined ? this.props.invertStickyHeaders : this.props.inverted,
      stickyHeaderIndices: stickyHeaderIndices
    });
    if (inversionStyle) {
      scrollProps.style = [inversionStyle, this.props.style];
    }

    this._hasMore = this.state.last < this.props.getItemCount(this.props.data) - 1;

    var ret = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement((this.props.renderScrollComponent || this._defaultRenderScrollComponent)(scrollProps), {
      ref: this._captureScrollRef
    }, cells);
    if (this.props.debug) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__exports_View__["a" /* default */],
        { style: { flex: 1 } },
        ret,
        this._renderDebugOverlay()
      );
    } else {
      return ret;
    }
  };

  VirtualizedList.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _props6 = this.props,
        data = _props6.data,
        extraData = _props6.extraData;

    if (data !== prevProps.data || extraData !== prevProps.extraData) {
      this._hasDataChangedSinceEndReached = true;

      // clear the viewableIndices cache to also trigger
      // the onViewableItemsChanged callback with the new data
      this._viewabilityTuples.forEach(function (tuple) {
        tuple.viewabilityHelper.resetViewableIndices();
      });
    }
    this._scheduleCellsToRenderUpdate();
  };
  // Maps a cell key to the set of keys for all outermost child lists within that cell


  VirtualizedList.prototype._computeBlankness = function _computeBlankness() {
    this._fillRateHelper.computeBlankness(this.props, this.state, this._scrollMetrics);
  };

  VirtualizedList.prototype._onCellLayout = function _onCellLayout(e, cellKey, index) {
    var layout = e.nativeEvent.layout;
    var next = {
      offset: this._selectOffset(layout),
      length: this._selectLength(layout),
      index: index,
      inLayout: true
    };
    var curr = this._frames[cellKey];
    if (!curr || next.offset !== curr.offset || next.length !== curr.length || index !== curr.index) {
      this._totalCellLength += next.length - (curr ? curr.length : 0);
      this._totalCellsMeasured += curr ? 0 : 1;
      this._averageCellLength = this._totalCellLength / this._totalCellsMeasured;
      this._frames[cellKey] = next;
      this._highestMeasuredFrameIndex = Math.max(this._highestMeasuredFrameIndex, index);
      this._scheduleCellsToRenderUpdate();
    } else {
      this._frames[cellKey].inLayout = true;
    }
    this._computeBlankness();
  };

  VirtualizedList.prototype._measureLayoutRelativeToContainingList = function _measureLayoutRelativeToContainingList() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_7__exports_UIManager__["a" /* default */].measureLayout(Object(__WEBPACK_IMPORTED_MODULE_11__exports_findNodeHandle__["a" /* default */])(this), Object(__WEBPACK_IMPORTED_MODULE_11__exports_findNodeHandle__["a" /* default */])(this.context.virtualizedList.getOutermostParentListRef()), function (error) {
      console.warn("VirtualizedList: Encountered an error while measuring a list's" + ' offset from its containing VirtualizedList.');
    }, function (x, y, width, height) {
      _this3._offsetFromParentVirtualizedList = _this3._selectOffset({ x: x, y: y });
      _this3._scrollMetrics.contentLength = _this3._selectLength({ width: width, height: height });

      var scrollMetrics = _this3._convertParentScrollMetrics(_this3.context.virtualizedList.getScrollMetrics());
      _this3._scrollMetrics.visibleLength = scrollMetrics.visibleLength;
      _this3._scrollMetrics.offset = scrollMetrics.offset;
    });
  };

  VirtualizedList.prototype._renderDebugOverlay = function _renderDebugOverlay() {
    var normalize = this._scrollMetrics.visibleLength / this._scrollMetrics.contentLength;
    var framesInLayout = [];
    var itemCount = this.props.getItemCount(this.props.data);
    for (var ii = 0; ii < itemCount; ii++) {
      var frame = this._getFrameMetricsApprox(ii);
      if (frame.inLayout) {
        framesInLayout.push(frame);
      }
    }
    var windowTop = this._getFrameMetricsApprox(this.state.first).offset;
    var frameLast = this._getFrameMetricsApprox(this.state.last);
    var windowLen = frameLast.offset + frameLast.length - windowTop;
    var visTop = this._scrollMetrics.offset;
    var visLen = this._scrollMetrics.visibleLength;
    var baseStyle = { position: 'absolute', top: 0, right: 0 };
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__exports_View__["a" /* default */],
      {
        style: Object.assign({}, baseStyle, {
          bottom: 0,
          width: 20,
          borderColor: 'blue',
          borderWidth: 1
        }) },
      framesInLayout.map(function (f, ii) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__exports_View__["a" /* default */], {
          key: 'f' + ii,
          style: Object.assign({}, baseStyle, {
            left: 0,
            top: f.offset * normalize,
            height: f.length * normalize,
            backgroundColor: 'orange'
          })
        });
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__exports_View__["a" /* default */], {
        style: Object.assign({}, baseStyle, {
          left: 0,
          top: windowTop * normalize,
          height: windowLen * normalize,
          borderColor: 'green',
          borderWidth: 2
        })
      }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__exports_View__["a" /* default */], {
        style: Object.assign({}, baseStyle, {
          left: 0,
          top: visTop * normalize,
          height: visLen * normalize,
          borderColor: 'red',
          borderWidth: 2
        })
      })
    );
  };

  VirtualizedList.prototype._selectLength = function _selectLength(metrics) {
    return !this.props.horizontal ? metrics.height : metrics.width;
  };

  VirtualizedList.prototype._selectOffset = function _selectOffset(metrics) {
    return !this.props.horizontal ? metrics.y : metrics.x;
  };

  VirtualizedList.prototype._maybeCallOnEndReached = function _maybeCallOnEndReached() {
    var _props7 = this.props,
        data = _props7.data,
        getItemCount = _props7.getItemCount,
        onEndReached = _props7.onEndReached,
        onEndReachedThreshold = _props7.onEndReachedThreshold;
    var _scrollMetrics = this._scrollMetrics,
        contentLength = _scrollMetrics.contentLength,
        visibleLength = _scrollMetrics.visibleLength,
        offset = _scrollMetrics.offset;

    var distanceFromEnd = contentLength - visibleLength - offset;
    if (onEndReached && this.state.last === getItemCount(data) - 1 &&
    /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
     * error found when Flow v0.63 was deployed. To see the error delete this
     * comment and run Flow. */
    distanceFromEnd < onEndReachedThreshold * visibleLength && (this._hasDataChangedSinceEndReached || this._scrollMetrics.contentLength !== this._sentEndForContentLength)) {
      // Only call onEndReached once for a given dataset + content length.
      this._hasDataChangedSinceEndReached = false;
      this._sentEndForContentLength = this._scrollMetrics.contentLength;
      onEndReached({ distanceFromEnd: distanceFromEnd });
    }
  };

  /* Translates metrics from a scroll event in a parent VirtualizedList into
   * coordinates relative to the child list.
   */


  VirtualizedList.prototype._scheduleCellsToRenderUpdate = function _scheduleCellsToRenderUpdate() {
    var _state2 = this.state,
        first = _state2.first,
        last = _state2.last;
    var _scrollMetrics2 = this._scrollMetrics,
        offset = _scrollMetrics2.offset,
        visibleLength = _scrollMetrics2.visibleLength,
        velocity = _scrollMetrics2.velocity;

    var itemCount = this.props.getItemCount(this.props.data);
    var hiPri = false;
    if (first > 0 || last < itemCount - 1) {
      var distTop = offset - this._getFrameMetricsApprox(first).offset;
      var distBottom = this._getFrameMetricsApprox(last).offset - (offset + visibleLength);
      var scrollingThreshold =
      /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
       * error found when Flow v0.63 was deployed. To see the error delete
       * this comment and run Flow. */
      this.props.onEndReachedThreshold * visibleLength / 2;
      hiPri = Math.min(distTop, distBottom) < 0 || velocity < -2 && distTop < scrollingThreshold || velocity > 2 && distBottom < scrollingThreshold;
    }
    // Only trigger high-priority updates if we've actually rendered cells,
    // and with that size estimate, accurately compute how many cells we should render.
    // Otherwise, it would just render as many cells as it can (of zero dimension),
    // each time through attempting to render more (limited by maxToRenderPerBatch),
    // starving the renderer from actually laying out the objects and computing _averageCellLength.
    if (hiPri && this._averageCellLength) {
      // Don't worry about interactions when scrolling quickly; focus on filling content as fast
      // as possible.
      this._updateCellsToRenderBatcher.dispose({ abort: true });
      this._updateCellsToRender();
      return;
    } else {
      this._updateCellsToRenderBatcher.schedule();
    }
  };

  VirtualizedList.prototype._updateViewableItems = function _updateViewableItems(data) {
    var _this4 = this;

    var getItemCount = this.props.getItemCount;


    this._viewabilityTuples.forEach(function (tuple) {
      tuple.viewabilityHelper.onUpdate(getItemCount(data), _this4._scrollMetrics.offset, _this4._scrollMetrics.visibleLength, _this4._getFrameMetrics, _this4._createViewToken, tuple.onViewableItemsChanged, _this4.state);
    });
  };

  return VirtualizedList;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.PureComponent);

VirtualizedList.defaultProps = {
  disableVirtualization: false,
  horizontal: false,
  initialNumToRender: 10,
  keyExtractor: function keyExtractor(item, index) {
    if (item.key != null) {
      return item.key;
    }
    _usedIndexForKey = true;
    return String(index);
  },
  maxToRenderPerBatch: 10,
  onEndReachedThreshold: 2, // multiples of length
  scrollEventThrottle: 50,
  updateCellsBatchingPeriod: 50,
  windowSize: 21 // multiples of length
};
VirtualizedList.contextTypes = {
  virtualizedCell: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    cellKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  }),
  virtualizedList: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    getScrollMetrics: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    horizontal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    getOutermostParentListRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    getNestedChildState: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    registerAsNestedChild: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    unregisterAsNestedChild: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  })
};
VirtualizedList.childContextTypes = {
  virtualizedList: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    getScrollMetrics: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    horizontal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    getOutermostParentListRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    getNestedChildState: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    registerAsNestedChild: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    unregisterAsNestedChild: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this._getScrollMetrics = function () {
    return _this7._scrollMetrics;
  };

  this._getOutermostParentListRef = function () {
    if (_this7._isNestedWithSameOrientation()) {
      return _this7.context.virtualizedList.getOutermostParentListRef();
    } else {
      return _this7;
    }
  };

  this._getNestedChildState = function (key) {
    var existingChildData = _this7._nestedChildLists.get(key);
    return existingChildData && existingChildData.state;
  };

  this._registerAsNestedChild = function (childList) {
    // Register the mapping between this child key and the cellKey for its cell
    var childListsInCell = _this7._cellKeysToChildListKeys.get(childList.cellKey) || new Set();
    childListsInCell.add(childList.key);
    _this7._cellKeysToChildListKeys.set(childList.cellKey, childListsInCell);

    var existingChildData = _this7._nestedChildLists.get(childList.key);
    __WEBPACK_IMPORTED_MODULE_13_fbjs_lib_invariant___default()(!(existingChildData && existingChildData.ref !== null), 'A VirtualizedList contains a cell which itself contains ' + 'more than one VirtualizedList of the same orientation as the parent ' + 'list. You must pass a unique listKey prop to each sibling list.');
    _this7._nestedChildLists.set(childList.key, {
      ref: childList.ref,
      state: null
    });

    if (_this7._hasInteracted) {
      childList.ref.recordInteraction();
    }
  };

  this._unregisterAsNestedChild = function (childList) {
    _this7._nestedChildLists.set(childList.key, {
      ref: null,
      state: childList.state
    });
  };

  this._onUpdateSeparators = function (keys, newProps) {
    keys.forEach(function (key) {
      var ref = key != null && _this7._cellRefs[key];
      ref && ref.updateSeparatorProps(newProps);
    });
  };

  this._averageCellLength = 0;
  this._cellKeysToChildListKeys = new Map();
  this._cellRefs = {};
  this._frames = {};
  this._footerLength = 0;
  this._hasDataChangedSinceEndReached = true;
  this._hasInteracted = false;
  this._hasMore = false;
  this._hasWarned = {};
  this._highestMeasuredFrameIndex = 0;
  this._headerLength = 0;
  this._indicesToKeys = new Map();
  this._hasDoneInitialScroll = false;
  this._nestedChildLists = new Map();
  this._offsetFromParentVirtualizedList = 0;
  this._prevParentOffset = 0;
  this._scrollMetrics = {
    contentLength: 0,
    dOffset: 0,
    dt: 10,
    offset: 0,
    timestamp: 0,
    velocity: 0,
    visibleLength: 0
  };
  this._scrollRef = null;
  this._sentEndForContentLength = 0;
  this._totalCellLength = 0;
  this._totalCellsMeasured = 0;
  this._viewabilityTuples = [];

  this._captureScrollRef = function (ref) {
    _this7._scrollRef = ref;
  };

  this._defaultRenderScrollComponent = function (props) {
    if (_this7._isNestedWithSameOrientation()) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__exports_View__["a" /* default */], props);
    } else if (props.onRefresh) {
      __WEBPACK_IMPORTED_MODULE_13_fbjs_lib_invariant___default()(typeof props.refreshing === 'boolean', '`refreshing` prop must be set as a boolean in order to use `onRefresh`, but got `' + JSON.stringify(props.refreshing) + '`');
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__exports_ScrollView__["a" /* default */], _extends({}, props, {
        refreshControl:
        /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
         * comment suppresses an error when upgrading Flow's support for
         * React. To see the error delete this comment and run Flow. */
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__exports_RefreshControl__["a" /* default */], {
          refreshing: props.refreshing,
          onRefresh: props.onRefresh,
          progressViewOffset: props.progressViewOffset
        })
      }));
    } else {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__exports_ScrollView__["a" /* default */], props);
    }
  };

  this._onCellUnmount = function (cellKey) {
    var curr = _this7._frames[cellKey];
    if (curr) {
      _this7._frames[cellKey] = Object.assign({}, curr, { inLayout: false });
    }
  };

  this._onLayout = function (e) {
    if (_this7._isNestedWithSameOrientation()) {
      // Need to adjust our scroll metrics to be relative to our containing
      // VirtualizedList before we can make claims about list item viewability
      _this7._measureLayoutRelativeToContainingList();
    } else {
      _this7._scrollMetrics.visibleLength = _this7._selectLength(e.nativeEvent.layout);
    }
    _this7.props.onLayout && _this7.props.onLayout(e);
    _this7._scheduleCellsToRenderUpdate();
    _this7._maybeCallOnEndReached();
  };

  this._onLayoutEmpty = function (e) {
    _this7.props.onLayout && _this7.props.onLayout(e);
  };

  this._onLayoutFooter = function (e) {
    _this7._footerLength = _this7._selectLength(e.nativeEvent.layout);
  };

  this._onLayoutHeader = function (e) {
    _this7._headerLength = _this7._selectLength(e.nativeEvent.layout);
  };

  this._onContentSizeChange = function (width, height) {
    if (width > 0 && height > 0 && _this7.props.initialScrollIndex != null && _this7.props.initialScrollIndex > 0 && !_this7._hasDoneInitialScroll) {
      _this7.scrollToIndex({
        animated: false,
        index: _this7.props.initialScrollIndex
      });
      _this7._hasDoneInitialScroll = true;
    }
    if (_this7.props.onContentSizeChange) {
      _this7.props.onContentSizeChange(width, height);
    }
    _this7._scrollMetrics.contentLength = _this7._selectLength({ height: height, width: width });
    _this7._scheduleCellsToRenderUpdate();
    _this7._maybeCallOnEndReached();
  };

  this._convertParentScrollMetrics = function (metrics) {
    // Offset of the top of the nested list relative to the top of its parent's viewport
    var offset = metrics.offset - _this7._offsetFromParentVirtualizedList;
    // Child's visible length is the same as its parent's
    var visibleLength = metrics.visibleLength;
    var dOffset = offset - _this7._scrollMetrics.offset;
    var contentLength = _this7._scrollMetrics.contentLength;

    return {
      visibleLength: visibleLength,
      contentLength: contentLength,
      offset: offset,
      dOffset: dOffset
    };
  };

  this._onScroll = function (e) {
    _this7._nestedChildLists.forEach(function (childList) {
      childList.ref && childList.ref._onScroll(e);
    });
    if (_this7.props.onScroll) {
      _this7.props.onScroll(e);
    }
    var timestamp = e.timeStamp;
    var visibleLength = _this7._selectLength(e.nativeEvent.layoutMeasurement);
    var contentLength = _this7._selectLength(e.nativeEvent.contentSize);
    var offset = _this7._selectOffset(e.nativeEvent.contentOffset);
    var dOffset = offset - _this7._scrollMetrics.offset;

    if (_this7._isNestedWithSameOrientation()) {
      if (_this7._scrollMetrics.contentLength === 0) {
        // Ignore scroll events until onLayout has been called and we
        // know our offset from our offset from our parent
        return;
      }

      var _convertParentScrollM = _this7._convertParentScrollMetrics({
        visibleLength: visibleLength,
        offset: offset
      });

      visibleLength = _convertParentScrollM.visibleLength;
      contentLength = _convertParentScrollM.contentLength;
      offset = _convertParentScrollM.offset;
      dOffset = _convertParentScrollM.dOffset;
    }

    var dt = _this7._scrollMetrics.timestamp ? Math.max(1, timestamp - _this7._scrollMetrics.timestamp) : 1;
    var velocity = dOffset / dt;

    if (dt > 500 && _this7._scrollMetrics.dt > 500 && contentLength > 5 * visibleLength && !_this7._hasWarned.perf) {
      Object(__WEBPACK_IMPORTED_MODULE_12__infoLog__["a" /* default */])('VirtualizedList: You have a large list that is slow to update - make sure your ' + 'renderItem function renders components that follow React performance best practices ' + 'like PureComponent, shouldComponentUpdate, etc.', { dt: dt, prevDt: _this7._scrollMetrics.dt, contentLength: contentLength });
      _this7._hasWarned.perf = true;
    }
    _this7._scrollMetrics = {
      contentLength: contentLength,
      dt: dt,
      dOffset: dOffset,
      offset: offset,
      timestamp: timestamp,
      velocity: velocity,
      visibleLength: visibleLength
    };
    _this7._updateViewableItems(_this7.props.data);
    if (!_this7.props) {
      return;
    }
    _this7._maybeCallOnEndReached();
    if (velocity !== 0) {
      _this7._fillRateHelper.activate();
    }
    _this7._computeBlankness();
    _this7._scheduleCellsToRenderUpdate();
  };

  this._onScrollBeginDrag = function (e) {
    _this7._nestedChildLists.forEach(function (childList) {
      childList.ref && childList.ref._onScrollBeginDrag(e);
    });
    _this7._viewabilityTuples.forEach(function (tuple) {
      tuple.viewabilityHelper.recordInteraction();
    });
    _this7._hasInteracted = true;
    _this7.props.onScrollBeginDrag && _this7.props.onScrollBeginDrag(e);
  };

  this._onScrollEndDrag = function (e) {
    var velocity = e.nativeEvent.velocity;

    if (velocity) {
      _this7._scrollMetrics.velocity = _this7._selectOffset(velocity);
    }
    _this7._computeBlankness();
    _this7.props.onScrollEndDrag && _this7.props.onScrollEndDrag(e);
  };

  this._onMomentumScrollEnd = function (e) {
    _this7._scrollMetrics.velocity = 0;
    _this7._computeBlankness();
    _this7.props.onMomentumScrollEnd && _this7.props.onMomentumScrollEnd(e);
  };

  this._updateCellsToRender = function () {
    var _props9 = _this7.props,
        data = _props9.data,
        getItemCount = _props9.getItemCount,
        onEndReachedThreshold = _props9.onEndReachedThreshold;

    var isVirtualizationDisabled = _this7._isVirtualizationDisabled();
    _this7._updateViewableItems(data);
    if (!data) {
      return;
    }
    _this7.setState(function (state) {
      var newState = void 0;
      if (!isVirtualizationDisabled) {
        // If we run this with bogus data, we'll force-render window {first: 0, last: 0},
        // and wipe out the initialNumToRender rendered elements.
        // So let's wait until the scroll view metrics have been set up. And until then,
        // we will trust the initialNumToRender suggestion
        if (_this7._scrollMetrics.visibleLength) {
          // If we have a non-zero initialScrollIndex and run this before we've scrolled,
          // we'll wipe out the initialNumToRender rendered elements starting at initialScrollIndex.
          // So let's wait until we've scrolled the view to the right place. And until then,
          // we will trust the initialScrollIndex suggestion.
          if (!_this7.props.initialScrollIndex || _this7._scrollMetrics.offset) {
            newState = Object(__WEBPACK_IMPORTED_MODULE_10__VirtualizeUtils__["a" /* computeWindowedRenderLimits */])(_this7.props, state, _this7._getFrameMetricsApprox, _this7._scrollMetrics);
          }
        }
      } else {
        var _scrollMetrics3 = _this7._scrollMetrics,
            contentLength = _scrollMetrics3.contentLength,
            _offset = _scrollMetrics3.offset,
            visibleLength = _scrollMetrics3.visibleLength;

        var _distanceFromEnd = contentLength - visibleLength - _offset;
        var renderAhead =
        /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses
         * an error found when Flow v0.63 was deployed. To see the error
         * delete this comment and run Flow. */
        _distanceFromEnd < onEndReachedThreshold * visibleLength ? _this7.props.maxToRenderPerBatch : 0;
        newState = {
          first: 0,
          last: Math.min(state.last + renderAhead, getItemCount(data) - 1)
        };
      }
      if (newState && _this7._nestedChildLists.size > 0) {
        var newFirst = newState.first;
        var newLast = newState.last;
        // If some cell in the new state has a child list in it, we should only render
        // up through that item, so that we give that list a chance to render.
        // Otherwise there's churn from multiple child lists mounting and un-mounting
        // their items.
        for (var ii = newFirst; ii <= newLast; ii++) {
          var cellKeyForIndex = _this7._indicesToKeys.get(ii);
          var childListKeys = cellKeyForIndex && _this7._cellKeysToChildListKeys.get(cellKeyForIndex);
          if (!childListKeys) {
            continue;
          }
          var someChildHasMore = false;
          // For each cell, need to check whether any child list in it has more elements to render
          for (var _iterator = childListKeys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref6;

            if (_isArray) {
              if (_i >= _iterator.length) break;
              _ref6 = _iterator[_i++];
            } else {
              _i = _iterator.next();
              if (_i.done) break;
              _ref6 = _i.value;
            }

            var childKey = _ref6;

            var childList = _this7._nestedChildLists.get(childKey);
            if (childList && childList.ref && childList.ref.hasMore()) {
              someChildHasMore = true;
              break;
            }
          }
          if (someChildHasMore) {
            newState.last = ii;
            break;
          }
        }
      }
      return newState;
    });
  };

  this._createViewToken = function (index, isViewable) {
    var _props10 = _this7.props,
        data = _props10.data,
        getItem = _props10.getItem,
        keyExtractor = _props10.keyExtractor;

    var item = getItem(data, index);
    return { index: index, item: item, key: keyExtractor(item, index), isViewable: isViewable };
  };

  this._getFrameMetricsApprox = function (index) {
    var frame = _this7._getFrameMetrics(index);
    if (frame && frame.index === index) {
      // check for invalid frames due to row re-ordering
      return frame;
    } else {
      var _getItemLayout = _this7.props.getItemLayout;

      __WEBPACK_IMPORTED_MODULE_13_fbjs_lib_invariant___default()(!_getItemLayout, 'Should not have to estimate frames when a measurement metrics function is provided');
      return {
        length: _this7._averageCellLength,
        offset: _this7._averageCellLength * index
      };
    }
  };

  this._getFrameMetrics = function (index) {
    var _props11 = _this7.props,
        data = _props11.data,
        getItem = _props11.getItem,
        getItemCount = _props11.getItemCount,
        getItemLayout = _props11.getItemLayout,
        keyExtractor = _props11.keyExtractor;

    __WEBPACK_IMPORTED_MODULE_13_fbjs_lib_invariant___default()(getItemCount(data) > index, 'Tried to get frame for out of range index ' + index);
    var item = getItem(data, index);
    var frame = item && _this7._frames[keyExtractor(item, index)];
    if (!frame || frame.index !== index) {
      if (getItemLayout) {
        frame = getItemLayout(data, index);
        if (__DEV__) {
          var frameType = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
            length: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
            offset: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
            index: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired
          }).isRequired;
          __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.checkPropTypes({ frame: frameType }, { frame: frame }, 'frame', 'VirtualizedList.getItemLayout');
        }
      }
    }
    /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
     * error found when Flow v0.63 was deployed. To see the error delete this
     * comment and run Flow. */
    return frame;
  };
};

var CellRenderer = function (_React$Component) {
  _inherits(CellRenderer, _React$Component);

  function CellRenderer() {
    var _temp, _this5, _ret2;

    _classCallCheck(this, CellRenderer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret2 = (_temp = (_this5 = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this5), _this5.state = {
      separatorProps: {
        highlighted: false,
        leadingItem: _this5.props.item
      }
    }, _this5._separators = {
      highlight: function highlight() {
        var _this5$props = _this5.props,
            cellKey = _this5$props.cellKey,
            prevCellKey = _this5$props.prevCellKey;

        _this5.props.onUpdateSeparators([cellKey, prevCellKey], {
          highlighted: true
        });
      },
      unhighlight: function unhighlight() {
        var _this5$props2 = _this5.props,
            cellKey = _this5$props2.cellKey,
            prevCellKey = _this5$props2.prevCellKey;

        _this5.props.onUpdateSeparators([cellKey, prevCellKey], {
          highlighted: false
        });
      },
      updateProps: function updateProps(select, newProps) {
        var _this5$props3 = _this5.props,
            cellKey = _this5$props3.cellKey,
            prevCellKey = _this5$props3.prevCellKey;

        _this5.props.onUpdateSeparators([select === 'leading' ? prevCellKey : cellKey], newProps);
      }
    }, _temp), _possibleConstructorReturn(_this5, _ret2);
  }

  CellRenderer.prototype.getChildContext = function getChildContext() {
    return {
      virtualizedCell: {
        cellKey: this.props.cellKey
      }
    };
  };

  // TODO: consider factoring separator stuff out of VirtualizedList into FlatList since it's not
  // reused by SectionList and we can keep VirtualizedList simpler.


  CellRenderer.prototype.updateSeparatorProps = function updateSeparatorProps(newProps) {
    this.setState(function (state) {
      return {
        separatorProps: Object.assign({}, state.separatorProps, newProps)
      };
    });
  };

  CellRenderer.prototype.componentWillUnmount = function componentWillUnmount() {
    this.props.onUnmount(this.props.cellKey);
  };

  CellRenderer.prototype.render = function render() {
    var _props8 = this.props,
        CellRendererComponent = _props8.CellRendererComponent,
        ItemSeparatorComponent = _props8.ItemSeparatorComponent,
        fillRateHelper = _props8.fillRateHelper,
        horizontal = _props8.horizontal,
        item = _props8.item,
        index = _props8.index,
        inversionStyle = _props8.inversionStyle,
        parentProps = _props8.parentProps;
    var renderItem = parentProps.renderItem,
        getItemLayout = parentProps.getItemLayout;

    __WEBPACK_IMPORTED_MODULE_13_fbjs_lib_invariant___default()(renderItem, 'no renderItem!');
    var element = renderItem({
      item: item,
      index: index,
      separators: this._separators
    });
    var onLayout = getItemLayout && !parentProps.debug && !fillRateHelper.enabled() ? undefined : this.props.onLayout;
    // NOTE: that when this is a sticky header, `onLayout` will get automatically extracted and
    // called explicitly by `ScrollViewStickyHeader`.
    var itemSeparator = ItemSeparatorComponent && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ItemSeparatorComponent, this.state.separatorProps);
    var cellStyle = inversionStyle ? horizontal ? [{ flexDirection: 'row-reverse' }, inversionStyle] : [{ flexDirection: 'column-reverse' }, inversionStyle] : horizontal ? [{ flexDirection: 'row' }, inversionStyle] : inversionStyle;
    if (!CellRendererComponent) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__exports_View__["a" /* default */],
        { style: cellStyle, onLayout: onLayout },
        element,
        itemSeparator
      );
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      CellRendererComponent,
      _extends({}, this.props, {
        style: cellStyle,
        onLayout: onLayout }),
      element,
      itemSeparator
    );
  };

  return CellRenderer;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

CellRenderer.childContextTypes = {
  virtualizedCell: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    cellKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  })
};

var VirtualizedCellWrapper = function (_React$Component2) {
  _inherits(VirtualizedCellWrapper, _React$Component2);

  function VirtualizedCellWrapper() {
    _classCallCheck(this, VirtualizedCellWrapper);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  VirtualizedCellWrapper.prototype.getChildContext = function getChildContext() {
    return {
      virtualizedCell: {
        cellKey: this.props.cellKey
      }
    };
  };

  VirtualizedCellWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return VirtualizedCellWrapper;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

VirtualizedCellWrapper.childContextTypes = {
  virtualizedCell: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    cellKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  })
};


var styles = __WEBPACK_IMPORTED_MODULE_6__exports_StyleSheet__["a" /* default */].create({
  verticallyInverted: {
    transform: [{ scaleY: -1 }]
  },
  horizontallyInverted: {
    transform: [{ scaleX: -1 }]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (VirtualizedList);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(751);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 198 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(83),
    root = __webpack_require__(54);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(791),
    mapCacheDelete = __webpack_require__(798),
    mapCacheGet = __webpack_require__(800),
    mapCacheHas = __webpack_require__(801),
    mapCacheSet = __webpack_require__(802);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(332),
    eq = __webpack_require__(198);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(334),
    baseKeys = __webpack_require__(809),
    isArrayLike = __webpack_require__(337);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(806),
    isObjectLike = __webpack_require__(61);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(54),
    stubFalse = __webpack_require__(807);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 205 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 206 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 207 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(327);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 209 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(817),
    stubArray = __webpack_require__(339);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 211 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(336);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(344);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(82),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(857),
    flatRest = __webpack_require__(346);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stateReconciler_autoMergeLevel1__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createPersistoid__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getStoredState__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__purgeStoredState__ = __webpack_require__(351);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var DEFAULT_TIMEOUT = 5000;
/*
  @TODO add validation / handling for:
  - persisting a reducer which has nested _persist
  - handling actions that fire before reydrate is called
*/
function persistReducer(config, baseReducer) {
  if (false) {
    if (!config) throw new Error('config is required for persistReducer');
    if (!config.key) throw new Error('key is required in persistor config');
    if (!config.storage) throw new Error("redux-persist: config.storage is required. Try using one of the provided storage engines `import storageLocal from 'redux-persist/es/storage/local'");
  }

  var version = config.version !== undefined ? config.version : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEFAULT_VERSION */];
  var debug = config.debug || false;
  var stateReconciler = config.stateReconciler === undefined ? __WEBPACK_IMPORTED_MODULE_1__stateReconciler_autoMergeLevel1__["a" /* default */] : config.stateReconciler;
  var getStoredState = config.getStoredState || __WEBPACK_IMPORTED_MODULE_3__getStoredState__["a" /* default */];
  var timeout = config.timeout !== undefined ? config.timeout : DEFAULT_TIMEOUT;
  var _persistoid = null;
  var _purge = false;
  var _paused = true;
  var conditionalUpdate = function conditionalUpdate(state) {
    // update the persistoid only if we are rehydrated and not paused
    state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
    return state;
  };

  return function (state, action) {
    var _ref = state || {},
        _persist = _ref._persist,
        rest = _objectWithoutProperties(_ref, ['_persist']);

    var restState = rest;

    if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PERSIST */]) {
      var _sealed = false;
      var _rehydrate = function _rehydrate(payload, err) {
        // dev warning if we are already sealed
        if (false) console.error('redux-persist: rehydrate for "' + config.key + '" called after timeout.', payload, err);

        // only rehydrate if we are not already sealed
        if (!_sealed) {
          action.rehydrate(config.key, payload, err);
          _sealed = true;
        }
      };
      timeout && setTimeout(function () {
        !_sealed && _rehydrate(undefined, new Error('redux-persist: persist timed out for persist key "' + config.key + '"'));
      }, timeout);

      // @NOTE PERSIST resumes if paused.
      _paused = false;

      // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
      if (!_persistoid) _persistoid = Object(__WEBPACK_IMPORTED_MODULE_2__createPersistoid__["a" /* default */])(config);

      // @NOTE PERSIST can be called multiple times, noop after the first
      if (_persist) return state;
      if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');

      action.register(config.key);

      getStoredState(config).then(function (restoredState) {
        var migrate = config.migrate || function (s, v) {
          return Promise.resolve(s);
        };
        migrate(restoredState, version).then(function (migratedState) {
          _rehydrate(migratedState);
        }, function (migrateErr) {
          if (false) console.error('redux-persist: migration error', migrateErr);
          _rehydrate(undefined, migrateErr);
        });
      }, function (err) {
        _rehydrate(undefined, err);
      });

      return _extends({}, baseReducer(restState, action), {
        _persist: { version: version, rehydrated: false }
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PURGE */]) {
      _purge = true;
      action.result(Object(__WEBPACK_IMPORTED_MODULE_4__purgeStoredState__["a" /* default */])(config));
      return _extends({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FLUSH */]) {
      action.result(_persistoid && _persistoid.flush());
      return _extends({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PAUSE */]) {
      _paused = true;
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* REHYDRATE */]) {
      // noop on restState if purging
      if (_purge) return _extends({}, restState, {
        _persist: _extends({}, _persist, { rehydrated: true })

        // @NOTE if key does not match, will continue to default else below
      });if (action.key === config.key) {
        var reducedState = baseReducer(restState, action);
        var inboundState = action.payload;
        // only reconcile state if stateReconciler and inboundState are both defined
        var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;

        var _newState = _extends({}, reconciledRest, {
          _persist: _extends({}, _persist, { rehydrated: true })
        });
        return conditionalUpdate(_newState);
      }
    }

    // if we have not already handled PERSIST, straight passthrough
    if (!_persist) return baseReducer(state, action);

    // run base reducer:
    // is state modified ? return original : return updated
    var newState = baseReducer(restState, action);
    if (newState === restState) return state;else {
      newState._persist = _persist;
      return conditionalUpdate(newState);
    }
  };
}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(353);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(354);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(109);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(220);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(39);
var normalizeHeaderName = __webpack_require__(947);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(362);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(362);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(946)))

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

OrderHeader=function(_Component){_inherits(OrderHeader,_Component);

function OrderHeader(props){_classCallCheck(this,OrderHeader);var _this=_possibleConstructorReturn(this,(OrderHeader.__proto__||Object.getPrototypeOf(OrderHeader)).call(this,
props));

_this.state={};return _this;
}_createClass(OrderHeader,[{key:'componentDidMount',value:function componentDidMount()

{
}},{key:'componentWillUnmount',value:function componentWillUnmount()

{
}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(

nextProps){
}},{key:'render',value:function render()

{var
simple=this.props.simple;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.header},
_react2.default.createElement(_reactNative.View,{
style:[
styles.column,{
flex:2}]},

_react2.default.createElement(_reactNative.Text,{
style:styles.columnText},'Email')),




_react2.default.createElement(_reactNative.View,{
style:styles.column},
_react2.default.createElement(_reactNative.Text,{
style:styles.columnText},'\u0110i\u1EC7n tho\u1EA1i')),




_react2.default.createElement(_reactNative.View,{
style:styles.column},
_react2.default.createElement(_reactNative.Text,{
style:styles.columnText},'Tr\u1EA1ng th\xE1i')),




_react2.default.createElement(_reactNative.View,{
style:styles.column},
_react2.default.createElement(_reactNative.Text,{
style:styles.columnText},'Hoa h\u1ED3ng')),



!simple&&_reactNative.Platform.OS==='web'&&
_react2.default.createElement(_reactNative.View,{
style:styles.column},
_react2.default.createElement(_reactNative.Text,{
style:styles.columnText},'V\u1EADn \u0111\u01A1n')),



!simple&&_reactNative.Platform.OS==='web'&&
_react2.default.createElement(_reactNative.View,{
style:styles.column},
_react2.default.createElement(_reactNative.Text,{
style:styles.columnText},'M\xE3 k\xEDch ho\u1EA1t'))));







}}]);return OrderHeader;}(_react.Component);


var styles=_reactNative.StyleSheet.create({
header:{
height:56,
flexDirection:'row',
backgroundColor:'#6b7adc'},

column:{
flex:1,
marginLeft:8,
flexDirection:'row',
alignItems:'center'},

columnText:{
padding:0,
color:'#ffffff',
fontSize:16,
fontWeight:'bold',
backgroundColor:'transparent'}});exports.default=



OrderHeader;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);







var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);

var _Constants=__webpack_require__(368);var _Constants2=_interopRequireDefault(_Constants);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

OrderItem=function(_PureComponent){_inherits(OrderItem,_PureComponent);function OrderItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OrderItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OrderItem.__proto__||Object.getPrototypeOf(OrderItem)).call.apply(_ref,[this].concat(args))),_this),_this.

_handleClick=function(){var _this$props=
_this.props,data=_this$props.data,onClick=_this$props.onClick;
if(onClick){
onClick(data);
}
},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OrderItem,[{key:'render',value:function render()

{var _props=
this.props,simple=_props.simple,data=_props.data;var
email=data.email,phone=data.phone,status=data.status,commission=data.commission,shippingCode=data.shippingCode,activateCode=data.activateCode,paymentMethod=data.paymentMethod;
email=_lodash2.default.isEmpty(email)?'N/A':email;
phone=_lodash2.default.isEmpty(phone)?'N/A':phone;
return(
_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
style:styles.item,
onPress:this._handleClick},
_react2.default.createElement(_reactNative.View,{
style:[
styles.column,{
flex:2}]},

_react2.default.createElement(_reactNative.Text,{
style:styles.columnText},
email)),



_react2.default.createElement(_reactNative.View,{
style:styles.column},
_react2.default.createElement(_reactNative.Text,{
style:styles.columnText},
phone)),



_react2.default.createElement(_reactNative.View,{
style:styles.column},
_react2.default.createElement(_reactNative.Text,{
style:styles.columnText},
!simple&&_reactNative.Platform.OS==='web'&&paymentMethod!==null&&
typeof paymentMethod!=='undefined'?
'['+paymentMethod.toUpperCase()+'] ':
'',_Constants2.default.STATUS_LOOKUP.get(status))),



_react2.default.createElement(_reactNative.View,{
style:styles.column},
_react2.default.createElement(_reactNative.Text,{
style:styles.columnText},
_Utils2.default.priceToString(commission))),


!simple&&_reactNative.Platform.OS==='web'&&
_react2.default.createElement(_reactNative.View,{
style:styles.column},
_react2.default.createElement(_reactNative.Text,{
style:styles.columnText},
shippingCode)),



!simple&&_reactNative.Platform.OS==='web'&&
_react2.default.createElement(_reactNative.View,{
style:styles.column},
_react2.default.createElement(_reactNative.Text,{
style:styles.columnText},
activateCode)),



_react2.default.createElement(_reactNative.View,{
style:styles.divider})));


}}]);return OrderItem;}(_react.PureComponent);


var styles=_reactNative.StyleSheet.create({
item:{
height:48,
flexDirection:'row',
backgroundColor:'#efefef'},

column:{
flex:1,
marginLeft:8,
flexDirection:'row',
alignItems:'center'},

columnText:{
color:'#454c53',
fontSize:12,
fontWeight:'100',
backgroundColor:'transparent'},

divider:{
position:'absolute',
left:0,bottom:0,right:0,
height:1/_reactNative.PixelRatio.get(),
backgroundColor:'#6b7adc'}});exports.default=



OrderItem;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(15) && !__webpack_require__(7)(function () {
  return Object.defineProperty(__webpack_require__(143)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(11);


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(29);
var toIObject = __webpack_require__(35);
var arrayIndexOf = __webpack_require__(114)(false);
var IE_PROTO = __webpack_require__(145)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16);
var anObject = __webpack_require__(5);
var getKeys = __webpack_require__(70);

module.exports = __webpack_require__(15) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(35);
var gOPN = __webpack_require__(73).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(70);
var gOPS = __webpack_require__(115);
var pIE = __webpack_require__(101);
var toObject = __webpack_require__(21);
var IObject = __webpack_require__(100);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(7)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(25);
var isObject = __webpack_require__(8);
var invoke = __webpack_require__(233);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(6).parseInt;
var $trim = __webpack_require__(87).trim;
var ws = __webpack_require__(149);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(6).parseFloat;
var $trim = __webpack_require__(87).trim;

module.exports = 1 / $parseFloat(__webpack_require__(149) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(41);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(8);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 238 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(152);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(5);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(25);
var toObject = __webpack_require__(21);
var IObject = __webpack_require__(100);
var toLength = __webpack_require__(17);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(21);
var toAbsoluteIndex = __webpack_require__(71);
var toLength = __webpack_require__(17);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(15) && /./g.flags != 'g') __webpack_require__(16).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(119)
});


/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(5);
var isObject = __webpack_require__(8);
var newPromiseCapability = __webpack_require__(167);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(248);
var validate = __webpack_require__(89);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(122)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(16).f;
var create = __webpack_require__(72);
var redefineAll = __webpack_require__(77);
var ctx = __webpack_require__(40);
var anInstance = __webpack_require__(75);
var forOf = __webpack_require__(76);
var $iterDefine = __webpack_require__(155);
var step = __webpack_require__(243);
var setSpecies = __webpack_require__(74);
var DESCRIPTORS = __webpack_require__(15);
var fastKey = __webpack_require__(63).fastKey;
var validate = __webpack_require__(89);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(248);
var validate = __webpack_require__(89);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(122)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(51)(0);
var redefine = __webpack_require__(31);
var meta = __webpack_require__(63);
var assign = __webpack_require__(231);
var weak = __webpack_require__(251);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(7);
var validate = __webpack_require__(89);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(122)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(77);
var getWeak = __webpack_require__(63).getWeak;
var anObject = __webpack_require__(5);
var isObject = __webpack_require__(8);
var anInstance = __webpack_require__(75);
var forOf = __webpack_require__(76);
var createArrayMethod = __webpack_require__(51);
var $has = __webpack_require__(29);
var validate = __webpack_require__(89);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(49);
var toLength = __webpack_require__(17);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(73);
var gOPS = __webpack_require__(115);
var anObject = __webpack_require__(5);
var Reflect = __webpack_require__(6).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(116);
var isObject = __webpack_require__(8);
var toLength = __webpack_require__(17);
var ctx = __webpack_require__(40);
var IS_CONCAT_SPREADABLE = __webpack_require__(11)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(17);
var repeat = __webpack_require__(151);
var defined = __webpack_require__(48);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(70);
var toIObject = __webpack_require__(35);
var isEnum = __webpack_require__(101).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(102);
var from = __webpack_require__(258);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(76);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 259 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(575);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccessibilityUtil__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports_StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exports_StyleSheet_styleResolver__ = __webpack_require__(176);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */





var emptyObject = {};

var resetStyles = __WEBPACK_IMPORTED_MODULE_1__exports_StyleSheet__["a" /* default */].create({
  ariaButton: {
    cursor: 'pointer'
  },
  button: {
    appearance: 'none',
    backgroundColor: 'transparent',
    color: 'inherit',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontStyle: 'inherit',
    fontVariant: ['inherit'],
    fontWeight: 'inherit',
    lineHeight: 'inherit',
    textAlign: 'inherit'
  },
  heading: {
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontStyle: 'inherit',
    fontVariant: ['inherit'],
    fontWeight: 'inherit',
    lineHeight: 'inherit'
  },
  link: {
    backgroundColor: 'transparent',
    color: 'inherit',
    textDecorationLine: 'none'
  },
  list: {
    listStyle: 'none'
  }
});

var pointerEventsStyles = __WEBPACK_IMPORTED_MODULE_1__exports_StyleSheet__["a" /* default */].create({
  auto: {
    pointerEvents: 'auto'
  },
  'box-none': {
    pointerEvents: 'box-none'
  },
  'box-only': {
    pointerEvents: 'box-only'
  },
  none: {
    pointerEvents: 'none'
  }
});

var defaultStyleResolver = function defaultStyleResolver(style) {
  return __WEBPACK_IMPORTED_MODULE_2__exports_StyleSheet_styleResolver__["a" /* default */].resolve(style);
};

var createDOMProps = function createDOMProps(component, props, styleResolver) {
  if (!styleResolver) {
    styleResolver = defaultStyleResolver;
  }

  if (!props) {
    props = emptyObject;
  }

  var _props = props,
      accessibilityLabel = _props.accessibilityLabel,
      accessibilityLiveRegion = _props.accessibilityLiveRegion,
      importantForAccessibility = _props.importantForAccessibility,
      placeholderTextColor = _props.placeholderTextColor,
      pointerEvents = _props.pointerEvents,
      providedStyle = _props.style,
      testID = _props.testID,
      accessible = _props.accessible,
      accessibilityComponentType = _props.accessibilityComponentType,
      accessibilityRole = _props.accessibilityRole,
      accessibilityTraits = _props.accessibilityTraits,
      domProps = _objectWithoutProperties(_props, ['accessibilityLabel', 'accessibilityLiveRegion', 'importantForAccessibility', 'placeholderTextColor', 'pointerEvents', 'style', 'testID', 'accessible', 'accessibilityComponentType', 'accessibilityRole', 'accessibilityTraits']);

  var disabled = __WEBPACK_IMPORTED_MODULE_0__AccessibilityUtil__["a" /* default */].isDisabled(props);
  var role = __WEBPACK_IMPORTED_MODULE_0__AccessibilityUtil__["a" /* default */].propsToAriaRole(props);

  // GENERAL ACCESSIBILITY
  if (importantForAccessibility === 'no-hide-descendants') {
    domProps['aria-hidden'] = true;
  }
  if (accessibilityLabel && accessibilityLabel.constructor === String) {
    domProps['aria-label'] = accessibilityLabel;
  }
  if (accessibilityLiveRegion && accessibilityLiveRegion.constructor === String) {
    domProps['aria-live'] = accessibilityLiveRegion === 'none' ? 'off' : accessibilityLiveRegion;
  }
  if (role && role.constructor === String && role !== 'label') {
    domProps.role = role;
  }

  // DISABLED
  if (disabled) {
    domProps['aria-disabled'] = disabled;
    domProps.disabled = disabled;
  }

  // FOCUS
  // Assume that 'link' is focusable by default (uses <a>).
  // Assume that 'button' is not (uses <div role='button'>) but must be treated as such.
  var focusable = !disabled && importantForAccessibility !== 'no' && importantForAccessibility !== 'no-hide-descendants';
  if (role === 'link' || component === 'input' || component === 'select' || component === 'textarea') {
    if (accessible === false || !focusable) {
      domProps.tabIndex = '-1';
    } else {
      domProps['data-focusable'] = true;
    }
  } else if (role === 'button' || role === 'textbox') {
    if (accessible !== false && focusable) {
      domProps['data-focusable'] = true;
      domProps.tabIndex = '0';
    }
  } else {
    if (accessible === true && focusable) {
      domProps['data-focusable'] = true;
      domProps.tabIndex = '0';
    }
  }

  // STYLE
  // Resolve React Native styles to optimized browser equivalent
  var reactNativeStyle = [component === 'a' && resetStyles.link, component === 'button' && resetStyles.button, role === 'heading' && resetStyles.heading, component === 'ul' && resetStyles.list, role === 'button' && !disabled && resetStyles.ariaButton, pointerEvents && pointerEventsStyles[pointerEvents], providedStyle, placeholderTextColor && { placeholderTextColor: placeholderTextColor }];

  var _styleResolver = styleResolver(reactNativeStyle),
      className = _styleResolver.className,
      style = _styleResolver.style;

  if (className && className.constructor === String) {
    domProps.className = props.className ? props.className + ' ' + className : className;
  }
  if (style) {
    domProps.style = style;
  }

  // OTHER
  // Link security and automation test ids
  if (component === 'a' && domProps.target === '_blank') {
    domProps.rel = (domProps.rel || '') + ' noopener noreferrer';
  }
  if (testID && testID.constructor === String) {
    domProps['data-testid'] = testID;
  }

  return domProps;
};

/* harmony default export */ __webpack_exports__["a"] = (createDOMProps);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2017-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var accessibilityComponentTypeToRole = {
  button: 'button',
  none: 'presentation'
};

var accessibilityTraitsToRole = {
  adjustable: 'slider',
  button: 'button',
  header: 'heading',
  image: 'img',
  link: 'link',
  none: 'presentation',
  search: 'search',
  summary: 'region'
};

/**
 * Provides compatibility with React Native's "accessibilityTraits" (iOS) and
 * "accessibilityComponentType" (Android), converting them to equivalent ARIA
 * roles.
 */
var propsToAriaRole = function propsToAriaRole(_ref) {
  var accessibilityComponentType = _ref.accessibilityComponentType,
      accessibilityRole = _ref.accessibilityRole,
      accessibilityTraits = _ref.accessibilityTraits;

  if (accessibilityRole) {
    return accessibilityRole;
  }
  if (accessibilityTraits) {
    var trait = Array.isArray(accessibilityTraits) ? accessibilityTraits[0] : accessibilityTraits;
    return accessibilityTraitsToRole[trait];
  }
  if (accessibilityComponentType) {
    return accessibilityComponentTypeToRole[accessibilityComponentType];
  }
};

/* harmony default export */ __webpack_exports__["a"] = (propsToAriaRole);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_AnimationPropTypes__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_BorderPropTypes__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColorPropType__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ImageResizeMode__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_InteractionPropTypes__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_LayoutPropTypes__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_ShadowPropTypes__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_TransformPropTypes__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);










var ImageStylePropTypes = Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__modules_AnimationPropTypes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__modules_BorderPropTypes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__modules_InteractionPropTypes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__modules_LayoutPropTypes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__modules_ShadowPropTypes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__modules_TransformPropTypes__["a" /* default */], {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_2__ColorPropType__["a" /* default */],
  opacity: __WEBPACK_IMPORTED_MODULE_8_prop_types__["number"],
  resizeMode: Object(__WEBPACK_IMPORTED_MODULE_8_prop_types__["oneOf"])(Object.keys(__WEBPACK_IMPORTED_MODULE_3__ImageResizeMode__["a" /* default */])),
  tintColor: __WEBPACK_IMPORTED_MODULE_2__ColorPropType__["a" /* default */],
  /**
   * @platform unsupported
   */
  overlayColor: __WEBPACK_IMPORTED_MODULE_8_prop_types__["string"],
  /**
   * @platform web
   */
  boxShadow: __WEBPACK_IMPORTED_MODULE_8_prop_types__["string"],
  filter: __WEBPACK_IMPORTED_MODULE_8_prop_types__["string"]
});

/* harmony default export */ __webpack_exports__["a"] = (ImageStylePropTypes);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/**
 * Copyright (c) 2017-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var AnimationPropTypes = {
  animationDelay: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  animationDirection: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOf"])(['alternate', 'alternate-reverse', 'normal', 'reverse']),
  animationDuration: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  animationFillMode: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOf"])(['none', 'forwards', 'backwards', 'both']),
  animationIterationCount: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOf"])(['infinite'])]),
  animationName: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]))]),
  animationPlayState: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOf"])(['paused', 'running']),
  animationTimingFunction: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  transitionDelay: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  transitionDuration: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  transitionProperty: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  transitionTimingFunction: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
};

/* harmony default export */ __webpack_exports__["a"] = (AnimationPropTypes);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_ColorPropType__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var numberOrString = Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]);
var BorderStylePropType = Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOf"])(['solid', 'dotted', 'dashed']);

var BorderPropTypes = {
  borderColor: __WEBPACK_IMPORTED_MODULE_0__exports_ColorPropType__["a" /* default */],
  borderBottomColor: __WEBPACK_IMPORTED_MODULE_0__exports_ColorPropType__["a" /* default */],
  borderEndColor: __WEBPACK_IMPORTED_MODULE_0__exports_ColorPropType__["a" /* default */],
  borderLeftColor: __WEBPACK_IMPORTED_MODULE_0__exports_ColorPropType__["a" /* default */],
  borderRightColor: __WEBPACK_IMPORTED_MODULE_0__exports_ColorPropType__["a" /* default */],
  borderStartColor: __WEBPACK_IMPORTED_MODULE_0__exports_ColorPropType__["a" /* default */],
  borderTopColor: __WEBPACK_IMPORTED_MODULE_0__exports_ColorPropType__["a" /* default */],
  borderRadius: numberOrString,
  borderBottomEndRadius: numberOrString,
  borderBottomLeftRadius: numberOrString,
  borderBottomRightRadius: numberOrString,
  borderBottomStartRadius: numberOrString,
  borderTopEndRadius: numberOrString,
  borderTopLeftRadius: numberOrString,
  borderTopRightRadius: numberOrString,
  borderTopStartRadius: numberOrString,
  borderStyle: BorderStylePropType,
  borderBottomStyle: BorderStylePropType,
  borderEndStyle: BorderStylePropType,
  borderLeftStyle: BorderStylePropType,
  borderRightStyle: BorderStylePropType,
  borderStartStyle: BorderStylePropType,
  borderTopStyle: BorderStylePropType
};

/* harmony default export */ __webpack_exports__["a"] = (BorderPropTypes);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css_color__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_normalize_css_color__);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var processColor = function processColor(color) {
  if (color === undefined || color === null) {
    return color;
  }

  // convert number and hex
  var int32Color = __WEBPACK_IMPORTED_MODULE_0_normalize_css_color___default()(color);
  if (int32Color === undefined || int32Color === null) {
    return undefined;
  }

  int32Color = (int32Color << 24 | int32Color >>> 8) >>> 0;

  return int32Color;
};

/* harmony default export */ __webpack_exports__["a"] = (processColor);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ImageResizeMode = {
  center: 'center',
  contain: 'contain',
  cover: 'cover',
  none: 'none',
  repeat: 'repeat',
  stretch: 'stretch'
};

/* harmony default export */ __webpack_exports__["a"] = (ImageResizeMode);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/**
 * Copyright (c) 2017-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var InteractionPropTypes = {
  cursor: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  touchAction: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOf"])(['auto', 'inherit', 'manipulation', 'none', 'pan-down', 'pan-left', 'pan-right', 'pan-up', 'pan-x', 'pan-y', 'pinch-zoom']),
  userSelect: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  willChange: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
};

/* harmony default export */ __webpack_exports__["a"] = (InteractionPropTypes);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var OverflowPropType = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOf"])(['auto', 'hidden', 'scroll', 'visible']);
var hiddenOrVisible = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOf"])(['hidden', 'visible']);
var numberOrString = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]);

var LayoutPropTypes = {
  alignContent: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOf"])(['center', 'flex-end', 'flex-start', 'space-around', 'space-between', 'stretch']),
  alignItems: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOf"])(['baseline', 'center', 'flex-end', 'flex-start', 'stretch']),
  alignSelf: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOf"])(['auto', 'baseline', 'center', 'flex-end', 'flex-start', 'stretch']),
  backfaceVisibility: hiddenOrVisible,
  borderWidth: numberOrString,
  borderBottomWidth: numberOrString,
  borderEndWidth: numberOrString,
  borderLeftWidth: numberOrString,
  borderRightWidth: numberOrString,
  borderStartWidth: numberOrString,
  borderTopWidth: numberOrString,
  bottom: numberOrString,
  boxSizing: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  direction: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOf"])(['inherit', 'ltr', 'rtl']),
  display: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  end: numberOrString,
  flex: __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
  flexBasis: numberOrString,
  flexDirection: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOf"])(['column', 'column-reverse', 'row', 'row-reverse']),
  flexGrow: __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
  flexShrink: __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
  flexWrap: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOf"])(['nowrap', 'wrap', 'wrap-reverse']),
  height: numberOrString,
  justifyContent: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOf"])(['center', 'flex-end', 'flex-start', 'space-around', 'space-between', 'space-evenly']),
  left: numberOrString,
  margin: numberOrString,
  marginBottom: numberOrString,
  marginHorizontal: numberOrString,
  marginEnd: numberOrString,
  marginLeft: numberOrString,
  marginRight: numberOrString,
  marginStart: numberOrString,
  marginTop: numberOrString,
  marginVertical: numberOrString,
  maxHeight: numberOrString,
  maxWidth: numberOrString,
  minHeight: numberOrString,
  minWidth: numberOrString,
  order: __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
  overflow: OverflowPropType,
  overflowX: OverflowPropType,
  overflowY: OverflowPropType,
  padding: numberOrString,
  paddingBottom: numberOrString,
  paddingHorizontal: numberOrString,
  paddingEnd: numberOrString,
  paddingLeft: numberOrString,
  paddingRight: numberOrString,
  paddingStart: numberOrString,
  paddingTop: numberOrString,
  paddingVertical: numberOrString,
  position: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOf"])(['absolute', 'fixed', 'relative', 'static', 'sticky']),
  right: numberOrString,
  start: numberOrString,
  top: numberOrString,
  visibility: hiddenOrVisible,
  width: numberOrString,
  zIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
  /**
   * @platform unsupported
   */
  aspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
  /**
   * @platform web
   */
  gridAutoColumns: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  gridAutoFlow: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  gridAutoRows: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  gridColumnEnd: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  gridColumnGap: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  gridColumnStart: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  gridRowEnd: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  gridRowGap: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  gridRowStart: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  gridTemplateColumns: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  gridTemplateRows: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  gridTemplateAreas: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
};

/* harmony default export */ __webpack_exports__["a"] = (LayoutPropTypes);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_ColorPropType__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var numberOrString = Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]);

var ShadowPropTypes = {
  shadowColor: __WEBPACK_IMPORTED_MODULE_0__exports_ColorPropType__["a" /* default */],
  shadowOffset: Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["shape"])({
    width: numberOrString,
    height: numberOrString
  }),
  shadowOpacity: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
  shadowRadius: numberOrString,
  shadowSpread: numberOrString
};

/* harmony default export */ __webpack_exports__["a"] = (ShadowPropTypes);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var numberOrString = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]);

var TransformPropTypes = {
  perspective: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
  perspectiveOrigin: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  transform: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({ perspective: numberOrString }), Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({ rotate: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"] }), Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({ rotateX: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"] }), Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({ rotateY: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"] }), Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({ rotateZ: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"] }), Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({ scale: __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"] }), Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({ scaleX: __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"] }), Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({ scaleY: __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"] }), Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({ skewX: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"] }), Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({ skewY: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"] }), Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({ translateX: numberOrString }), Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({ translateY: numberOrString }), Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({ translateZ: numberOrString }), Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({ translate3d: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"] })])),
  transformOrigin: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
  transformStyle: Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOf"])(['flat', 'preserve-3d'])
};

/* harmony default export */ __webpack_exports__["a"] = (TransformPropTypes);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Text_TextStylePropTypes__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var TextInputStylePropTypes = Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__Text_TextStylePropTypes__["a" /* default */], {
  /* @platform web */
  resize: Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOf"])(['none', 'vertical', 'horizontal', 'both'])
});

/* harmony default export */ __webpack_exports__["a"] = (TextInputStylePropTypes);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var emptyObject = {};
var objects = {};
var prefix = 'r';
var uniqueID = 1;

var createKey = function createKey(id) {
  return prefix + '-' + id;
};

var ReactNativePropRegistry = function () {
  function ReactNativePropRegistry() {
    _classCallCheck(this, ReactNativePropRegistry);
  }

  ReactNativePropRegistry.register = function register(object) {
    var id = uniqueID++;
    if (false) {
      Object.freeze(object);
    }
    var key = createKey(id);
    objects[key] = object;
    return id;
  };

  ReactNativePropRegistry.getByID = function getByID(id) {
    if (!id) {
      // Used in the style={[condition && id]} pattern,
      // we want it to be a no-op when the value is false or null
      return emptyObject;
    }
    var key = createKey(id);
    var object = objects[key];
    if (!object) {
      console.warn('Invalid style with id `' + id + '`. Skipping ...');
      return emptyObject;
    }
    return object;
  };

  return ReactNativePropRegistry;
}();

/* harmony default export */ __webpack_exports__["a"] = (ReactNativePropRegistry);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_ReactNativePropRegistry__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_invariant__);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




function getStyle(style) {
  if (typeof style === 'number') {
    return __WEBPACK_IMPORTED_MODULE_0__modules_ReactNativePropRegistry__["a" /* default */].getByID(style);
  }
  return style;
}

function flattenStyle(style) {
  if (!style) {
    return undefined;
  }

  if (false) {
    invariant(style !== true, 'style may be false but not true');
  }

  if (!Array.isArray(style)) {
    // $FlowFixMe
    return getStyle(style);
  }

  var result = {};
  for (var i = 0, styleLength = style.length; i < styleLength; ++i) {
    var computedStyle = flattenStyle(style[i]);
    if (computedStyle) {
      for (var key in computedStyle) {
        var value = computedStyle[key];
        result[key] = value;
      }
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (flattenStyle);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_normalizeColor__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normalizeValue__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resolveShadowValue__ = __webpack_require__(278);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */





/**
 * The browser implements the CSS cascade, where the order of properties is a
 * factor in determining which styles to paint. React Native is different. It
 * gives giving precedence to the more specific style property. For example,
 * the value of `paddingTop` takes precedence over that of `padding`.
 *
 * This module creates mutally exclusive style declarations by expanding all of
 * React Native's supported shortform properties (e.g. `padding`) to their
 * longfrom equivalents.
 */

var emptyObject = {};
var styleShortFormProperties = {
  borderColor: ['borderTopColor', 'borderRightColor', 'borderBottomColor', 'borderLeftColor'],
  borderRadius: ['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius'],
  borderStyle: ['borderTopStyle', 'borderRightStyle', 'borderBottomStyle', 'borderLeftStyle'],
  borderWidth: ['borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth'],
  margin: ['marginTop', 'marginRight', 'marginBottom', 'marginLeft'],
  marginHorizontal: ['marginRight', 'marginLeft'],
  marginVertical: ['marginTop', 'marginBottom'],
  overflow: ['overflowX', 'overflowY'],
  overscrollBehavior: ['overscrollBehaviorX', 'overscrollBehaviorY'],
  padding: ['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'],
  paddingHorizontal: ['paddingRight', 'paddingLeft'],
  paddingVertical: ['paddingTop', 'paddingBottom'],
  writingDirection: ['direction']
};

var colorProps = {
  backgroundColor: true,
  borderColor: true,
  borderTopColor: true,
  borderRightColor: true,
  borderBottomColor: true,
  borderLeftColor: true,
  color: true
};

var borderWidthProps = {
  borderWidth: true,
  borderTopWidth: true,
  borderRightWidth: true,
  borderBottomWidth: true,
  borderLeftWidth: true
};

var monospaceFontStack = 'monospace, monospace';
var systemFontStack = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, "Helvetica Neue", sans-serif';

var alphaSortProps = function alphaSortProps(propsArray) {
  return propsArray.sort(function (a, b) {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  });
};

var defaultOffset = { height: 0, width: 0 };

/**
 * Shadow
 */

var resolveShadow = function resolveShadow(resolvedStyle, style) {
  var boxShadow = style.boxShadow;

  var shadow = Object(__WEBPACK_IMPORTED_MODULE_2__resolveShadowValue__["a" /* default */])(style);
  resolvedStyle.boxShadow = boxShadow ? boxShadow + ', ' + shadow : shadow;
};

/**
 * Text Decoration
 */

var resolveTextDecoration = function resolveTextDecoration(resolvedStyle, style) {
  var textDecorationColor = style.textDecorationColor,
      textDecorationLine = style.textDecorationLine,
      textDecorationStyle = style.textDecorationStyle;

  var color = Object(__WEBPACK_IMPORTED_MODULE_0__modules_normalizeColor__["a" /* default */])(textDecorationColor) || '';
  var lineStyle = textDecorationStyle || '';
  if (textDecorationLine) {
    resolvedStyle.textDecoration = (textDecorationLine + ' ' + lineStyle + ' ' + color).trim();
  }
};

/**
 * Text Shadow
 */

var resolveTextShadow = function resolveTextShadow(resolvedStyle, style) {
  var textShadowColor = style.textShadowColor,
      textShadowOffset = style.textShadowOffset,
      textShadowRadius = style.textShadowRadius;

  var _ref = textShadowOffset || defaultOffset,
      height = _ref.height,
      width = _ref.width;

  var offsetX = Object(__WEBPACK_IMPORTED_MODULE_1__normalizeValue__["a" /* default */])(null, width);
  var offsetY = Object(__WEBPACK_IMPORTED_MODULE_1__normalizeValue__["a" /* default */])(null, height);
  var blurRadius = Object(__WEBPACK_IMPORTED_MODULE_1__normalizeValue__["a" /* default */])(null, textShadowRadius || 0);
  var color = Object(__WEBPACK_IMPORTED_MODULE_0__modules_normalizeColor__["a" /* default */])(textShadowColor);

  if (color && (height !== 0 || width !== 0)) {
    resolvedStyle.textShadow = offsetX + ' ' + offsetY + ' ' + blurRadius + ' ' + color;
  }
};

/**
 * Transform
 */

// { scale: 2 } => 'scale(2)'
// { translateX: 20 } => 'translateX(20px)'
var mapTransform = function mapTransform(transform) {
  var type = Object.keys(transform)[0];
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__normalizeValue__["a" /* default */])(type, transform[type]);
  return type + '(' + value + ')';
};

// [1,2,3,4,5,6] => 'matrix3d(1,2,3,4,5,6)'
var convertTransformMatrix = function convertTransformMatrix(transformMatrix) {
  var matrix = transformMatrix.join(',');
  return 'matrix3d(' + matrix + ')';
};

var resolveTransform = function resolveTransform(resolvedStyle, style) {
  var transform = style.transform;
  if (Array.isArray(style.transform)) {
    transform = style.transform.map(mapTransform).join(' ');
  } else if (style.transformMatrix) {
    transform = convertTransformMatrix(style.transformMatrix);
  }
  resolvedStyle.transform = transform;
};

/**
 * Reducer
 */

var createReducer = function createReducer(style, styleProps) {
  var hasResolvedShadow = false;
  var hasResolvedTextDecoration = false;
  var hasResolvedTextShadow = false;

  return function (resolvedStyle, prop) {
    var value = Object(__WEBPACK_IMPORTED_MODULE_1__normalizeValue__["a" /* default */])(prop, style[prop]);

    // Make sure the default border width is explicitly set to '0' to avoid
    // falling back to any unwanted user-agent styles.
    if (borderWidthProps[prop]) {
      value = value == null ? Object(__WEBPACK_IMPORTED_MODULE_1__normalizeValue__["a" /* default */])(null, 0) : value;
    }

    // Normalize color values
    if (colorProps[prop]) {
      value = Object(__WEBPACK_IMPORTED_MODULE_0__modules_normalizeColor__["a" /* default */])(value);
    }

    // Ignore everything else with a null value
    if (value == null) {
      return resolvedStyle;
    }

    switch (prop) {
      // Ignore some React Native styles
      case 'aspectRatio':
      case 'elevation':
      case 'overlayColor':
      case 'resizeMode':
      case 'tintColor':
        {
          break;
        }

      // TODO: remove once this issue is fixed
      // https://github.com/rofrischmann/inline-style-prefixer/issues/159
      case 'backgroundClip':
        {
          if (value === 'text') {
            resolvedStyle.backgroundClip = value;
            resolvedStyle.WebkitBackgroundClip = value;
          }
          break;
        }

      case 'display':
        {
          resolvedStyle.display = value;
          // A flex container in React Native has these defaults which should be
          // set only if there is no otherwise supplied flex style.
          if (style.display === 'flex' && style.flex == null) {
            if (style.flexShrink == null) {
              resolvedStyle.flexShrink = 0;
            }
            if (style.flexBasis == null) {
              resolvedStyle.flexBasis = 'auto';
            }
          }
          break;
        }

      // The 'flex' property value in React Native must be a positive integer,
      // 0, or -1.
      case 'flex':
        {
          if (value > 0) {
            resolvedStyle.flexGrow = value;
            resolvedStyle.flexShrink = 1;
            resolvedStyle.flexBasis = '0%';
          } else if (value === 0) {
            resolvedStyle.flexGrow = 0;
            resolvedStyle.flexShrink = 0;
            resolvedStyle.flexBasis = '0%';
          } else if (value === -1) {
            resolvedStyle.flexGrow = 0;
            resolvedStyle.flexShrink = 1;
            resolvedStyle.flexBasis = 'auto';
          }
          break;
        }

      case 'fontFamily':
        {
          if (value.indexOf('System') > -1) {
            var stack = value.split(/\s*,\s*/);
            stack[stack.indexOf('System')] = systemFontStack;
            resolvedStyle.fontFamily = stack.join(', ');
          } else if (value === 'monospace') {
            resolvedStyle.fontFamily = monospaceFontStack;
          } else {
            resolvedStyle.fontFamily = value;
          }
          break;
        }

      case 'fontVariant':
        {
          if (Array.isArray(value) && value.length > 0) {
            resolvedStyle.fontVariant = value.join(' ');
          }
          break;
        }

      case 'shadowColor':
      case 'shadowOffset':
      case 'shadowOpacity':
      case 'shadowRadius':
        {
          if (!hasResolvedShadow) {
            resolveShadow(resolvedStyle, style);
          }
          hasResolvedShadow = true;
          break;
        }

      case 'textAlignVertical':
        {
          resolvedStyle.verticalAlign = value === 'center' ? 'middle' : value;
          break;
        }

      case 'textDecorationColor':
      case 'textDecorationLine':
      case 'textDecorationStyle':
        {
          if (!hasResolvedTextDecoration) {
            resolveTextDecoration(resolvedStyle, style);
          }
          hasResolvedTextDecoration = true;
          break;
        }

      case 'textShadowColor':
      case 'textShadowOffset':
      case 'textShadowRadius':
        {
          if (!hasResolvedTextShadow) {
            resolveTextShadow(resolvedStyle, style);
          }
          hasResolvedTextShadow = true;
          break;
        }

      case 'transform':
      case 'transformMatrix':
        {
          resolveTransform(resolvedStyle, style);
          break;
        }

      default:
        {
          var longFormProperties = styleShortFormProperties[prop];
          if (longFormProperties) {
            longFormProperties.forEach(function (longForm, i) {
              // The value of any longform property in the original styles takes
              // precedence over the shortform's value.
              if (styleProps.indexOf(longForm) === -1) {
                resolvedStyle[longForm] = value;
              }
            });
          } else {
            resolvedStyle[prop] = value;
          }
        }
    }

    return resolvedStyle;
  };
};

var createReactDOMStyle = function createReactDOMStyle(style) {
  if (!style) {
    return emptyObject;
  }
  var styleProps = Object.keys(style);
  var sortedStyleProps = alphaSortProps(styleProps);
  var reducer = createReducer(style, styleProps);
  var resolvedStyle = sortedStyleProps.reduce(reducer, {});
  return resolvedStyle;
};

/* harmony default export */ __webpack_exports__["a"] = (createReactDOMStyle);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessNumbers = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexOrder: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  fontWeight: true,
  gridRow: true,
  gridColumn: true,
  lineClamp: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true,
  // transform types
  scale: true,
  scaleX: true,
  scaleY: true,
  scaleZ: true,
  // RN properties
  shadowOpacity: true
};

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['ms', 'Moz', 'O', 'Webkit'];
var prefixKey = function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
};
Object.keys(unitlessNumbers).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    unitlessNumbers[prefixKey(prefix, prop)] = unitlessNumbers[prop];
  });
});

/* harmony default export */ __webpack_exports__["a"] = (unitlessNumbers);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_normalizeColor__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__normalizeValue__ = __webpack_require__(177);
/**
 * Copyright (c) 2018-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var defaultOffset = { height: 0, width: 0 };

var resolveShadowValue = function resolveShadowValue(style) {
  var shadowColor = style.shadowColor,
      shadowOffset = style.shadowOffset,
      shadowOpacity = style.shadowOpacity,
      shadowRadius = style.shadowRadius;

  var _ref = shadowOffset || defaultOffset,
      height = _ref.height,
      width = _ref.width;

  var offsetX = Object(__WEBPACK_IMPORTED_MODULE_1__normalizeValue__["a" /* default */])(null, width);
  var offsetY = Object(__WEBPACK_IMPORTED_MODULE_1__normalizeValue__["a" /* default */])(null, height);
  var blurRadius = Object(__WEBPACK_IMPORTED_MODULE_1__normalizeValue__["a" /* default */])(null, shadowRadius || 0);
  var color = Object(__WEBPACK_IMPORTED_MODULE_0__modules_normalizeColor__["a" /* default */])(shadowColor || 'black', shadowOpacity);
  if (color) {
    return offsetX + ' ' + offsetY + ' ' + blurRadius + ' ' + color;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (resolveShadowValue);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__I18nManager__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_multiplyStyleLengthValue__ = __webpack_require__(280);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */




var emptyObject = {};

var borderTopLeftRadius = 'borderTopLeftRadius';
var borderTopRightRadius = 'borderTopRightRadius';
var borderBottomLeftRadius = 'borderBottomLeftRadius';
var borderBottomRightRadius = 'borderBottomRightRadius';
var borderLeftColor = 'borderLeftColor';
var borderLeftStyle = 'borderLeftStyle';
var borderLeftWidth = 'borderLeftWidth';
var borderRightColor = 'borderRightColor';
var borderRightStyle = 'borderRightStyle';
var borderRightWidth = 'borderRightWidth';
var right = 'right';
var marginLeft = 'marginLeft';
var marginRight = 'marginRight';
var paddingLeft = 'paddingLeft';
var paddingRight = 'paddingRight';
var left = 'left';

// Map of LTR property names to their BiDi equivalent.
var PROPERTIES_FLIP = {
  borderTopLeftRadius: borderTopRightRadius,
  borderTopRightRadius: borderTopLeftRadius,
  borderBottomLeftRadius: borderBottomRightRadius,
  borderBottomRightRadius: borderBottomLeftRadius,
  borderLeftColor: borderRightColor,
  borderLeftStyle: borderRightStyle,
  borderLeftWidth: borderRightWidth,
  borderRightColor: borderLeftColor,
  borderRightStyle: borderLeftStyle,
  borderRightWidth: borderLeftWidth,
  left: right,
  marginLeft: marginRight,
  marginRight: marginLeft,
  paddingLeft: paddingRight,
  paddingRight: paddingLeft,
  right: left
};

// Map of I18N property names to their LTR equivalent.
var PROPERTIES_I18N = {
  borderTopStartRadius: borderTopLeftRadius,
  borderTopEndRadius: borderTopRightRadius,
  borderBottomStartRadius: borderBottomLeftRadius,
  borderBottomEndRadius: borderBottomRightRadius,
  borderStartColor: borderLeftColor,
  borderStartStyle: borderLeftStyle,
  borderStartWidth: borderLeftWidth,
  borderEndColor: borderRightColor,
  borderEndStyle: borderRightStyle,
  borderEndWidth: borderRightWidth,
  end: right,
  marginStart: marginLeft,
  marginEnd: marginRight,
  paddingStart: paddingLeft,
  paddingEnd: paddingRight,
  start: left
};

var PROPERTIES_VALUE = {
  clear: true,
  float: true,
  textAlign: true
};

// Invert the sign of a numeric-like value
var additiveInverse = function additiveInverse(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__modules_multiplyStyleLengthValue__["a" /* default */])(value, -1);
};

var i18nStyle = function i18nStyle(originalStyle) {
  var doLeftAndRightSwapInRTL = __WEBPACK_IMPORTED_MODULE_0__I18nManager__["a" /* default */].doLeftAndRightSwapInRTL,
      isRTL = __WEBPACK_IMPORTED_MODULE_0__I18nManager__["a" /* default */].isRTL;

  var style = originalStyle || emptyObject;
  var frozenProps = {};
  var nextStyle = {};

  for (var originalProp in style) {
    if (!Object.prototype.hasOwnProperty.call(style, originalProp)) {
      continue;
    }
    var originalValue = style[originalProp];
    var prop = originalProp;
    var value = originalValue;

    // BiDi flip properties
    if (PROPERTIES_I18N.hasOwnProperty(originalProp)) {
      // convert start/end
      var convertedProp = PROPERTIES_I18N[originalProp];
      prop = isRTL ? PROPERTIES_FLIP[convertedProp] : convertedProp;
    } else if (isRTL && doLeftAndRightSwapInRTL && PROPERTIES_FLIP[originalProp]) {
      prop = PROPERTIES_FLIP[originalProp];
    }

    // BiDi flip values
    if (PROPERTIES_VALUE.hasOwnProperty(originalProp)) {
      if (originalValue === 'start') {
        value = isRTL ? 'right' : 'left';
      } else if (originalValue === 'end') {
        value = isRTL ? 'left' : 'right';
      } else if (isRTL && doLeftAndRightSwapInRTL) {
        if (originalValue === 'left') {
          value = 'right';
        } else if (originalValue === 'right') {
          value = 'left';
        }
      }
    }

    if (isRTL && prop === 'textShadowOffset') {
      nextStyle[prop] = value;
      nextStyle[prop].width = additiveInverse(value.width);
    } else if (!frozenProps[prop]) {
      nextStyle[prop] = value;
    }

    if (PROPERTIES_I18N[originalProp]) {
      frozenProps[prop] = true;
    }
  }

  return nextStyle;
};

/* harmony default export */ __webpack_exports__["a"] = (i18nStyle);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */

var CSS_UNIT_RE = /^[+-]?\d*(?:\.\d+)?(?:[Ee][+-]?\d+)?(%|\w*)/;

var getUnit = function getUnit(str) {
  return str.match(CSS_UNIT_RE)[1];
};

var isNumeric = function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

var multiplyStyleLengthValue = function multiplyStyleLengthValue(value, multiple) {
  if (typeof value === 'string') {
    var number = parseFloat(value) * multiple;
    var unit = getUnit(value);
    return '' + number + unit;
  } else if (isNumeric(value)) {
    return value * multiple;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (multiplyStyleLengthValue);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixInlineStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inline_style_prefixer_static_createPrefixer__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inline_style_prefixer_static_createPrefixer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_inline_style_prefixer_static_createPrefixer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static__ = __webpack_require__(604);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var prefixAll = __WEBPACK_IMPORTED_MODULE_0_inline_style_prefixer_static_createPrefixer___default()(__WEBPACK_IMPORTED_MODULE_1__static__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (prefixAll);

var prefixInlineStyles = function prefixInlineStyles(style) {
  var prefixedStyles = prefixAll(style);

  // React@15 removed undocumented support for fallback values in
  // inline-styles. Revert array values to the standard CSS value
  Object.keys(prefixedStyles).forEach(function (prop) {
    var value = prefixedStyles[prop];
    if (Array.isArray(value)) {
      prefixedStyles[prop] = value[value.length - 1];
    }
  });

  return prefixedStyles;
};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_mapKeyValue__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__normalizeValue__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_prefixStyles__ = __webpack_require__(281);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */






var createDeclarationString = function createDeclarationString(prop, val) {
  var name = __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name___default()(prop);
  var value = Object(__WEBPACK_IMPORTED_MODULE_2__normalizeValue__["a" /* default */])(prop, val);
  if (Array.isArray(val)) {
    return val.map(function (v) {
      return name + ':' + v;
    }).join(';');
  }
  return name + ':' + value;
};

/**
 * Generates valid CSS rule body from a JS object
 *
 * createRuleBlock({ width: 20, color: 'blue' });
 * // => 'color:blue;width:20px'
 */
var createRuleBlock = function createRuleBlock(style) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__modules_mapKeyValue__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__modules_prefixStyles__["a" /* default */])(style), createDeclarationString).sort().join(';');
};

/* harmony default export */ __webpack_exports__["a"] = (createRuleBlock);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */

/**
 * JS Implementation of MurmurHash2
 *
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/murmurhash-js
 * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
 * @see http://sites.google.com/site/murmurhash/
 *
 * @param {string} str ASCII only
 * @param {number} seed Positive integer only
 * @return {number} 32-bit positive integer hash
 */

function murmurhash2_32_gc(str, seed) {
  var l = str.length,
      h = seed ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

var hash = function hash(str) {
  return murmurhash2_32_gc(str, 1).toString(36);
};

/* harmony default export */ __webpack_exports__["a"] = (hash);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var emptyArray = [];
var emptyFunction = function emptyFunction() {};

var getRect = function getRect(node) {
  if (node) {
    var isElement = node.nodeType === 1 /* Node.ELEMENT_NODE */;
    if (isElement && typeof node.getBoundingClientRect === 'function') {
      return node.getBoundingClientRect();
    }
  }
};

// Mobile Safari re-uses touch objects, so we copy the properties we want and normalize the identifier
var normalizeTouches = function normalizeTouches(touches) {
  if (!touches) {
    return emptyArray;
  }

  return Array.prototype.slice.call(touches).map(function (touch) {
    var identifier = touch.identifier > 20 ? touch.identifier % 20 : touch.identifier;
    var rect = void 0;

    return {
      _normalized: true,
      clientX: touch.clientX,
      clientY: touch.clientY,
      force: touch.force,
      get locationX() {
        rect = rect || getRect(touch.target);
        if (rect) {
          return touch.pageX - rect.left;
        }
      },
      get locationY() {
        rect = rect || getRect(touch.target);
        if (rect) {
          return touch.pageY - rect.top;
        }
      },
      identifier: identifier,
      pageX: touch.pageX,
      pageY: touch.pageY,
      radiusX: touch.radiusX,
      radiusY: touch.radiusY,
      rotationAngle: touch.rotationAngle,
      screenX: touch.screenX,
      screenY: touch.screenY,
      target: touch.target,
      // normalize the timestamp
      // https://stackoverflow.com/questions/26177087/ios-8-mobile-safari-wrong-timestamp-on-touch-events
      timestamp: Date.now()
    };
  });
};

function normalizeTouchEvent(nativeEvent) {
  var changedTouches = normalizeTouches(nativeEvent.changedTouches);
  var touches = normalizeTouches(nativeEvent.touches);

  var preventDefault = typeof nativeEvent.preventDefault === 'function' ? nativeEvent.preventDefault.bind(nativeEvent) : emptyFunction;
  var stopImmediatePropagation = typeof nativeEvent.stopImmediatePropagation === 'function' ? nativeEvent.stopImmediatePropagation.bind(nativeEvent) : emptyFunction;
  var stopPropagation = typeof nativeEvent.stopPropagation === 'function' ? nativeEvent.stopPropagation.bind(nativeEvent) : emptyFunction;

  var event = {
    _normalized: true,
    bubbles: nativeEvent.bubbles,
    cancelable: nativeEvent.cancelable,
    changedTouches: changedTouches,
    defaultPrevented: nativeEvent.defaultPrevented,
    identifier: undefined,
    locationX: undefined,
    locationY: undefined,
    pageX: nativeEvent.pageX,
    pageY: nativeEvent.pageY,
    preventDefault: preventDefault,
    stopImmediatePropagation: stopImmediatePropagation,
    stopPropagation: stopPropagation,
    target: nativeEvent.target,
    // normalize the timestamp
    // https://stackoverflow.com/questions/26177087/ios-8-mobile-safari-wrong-timestamp-on-touch-events
    timestamp: Date.now(),
    touches: touches,
    type: nativeEvent.type,
    which: nativeEvent.which
  };

  if (changedTouches[0]) {
    event.identifier = changedTouches[0].identifier;
    event.pageX = changedTouches[0].pageX;
    event.pageY = changedTouches[0].pageY;
    event.locationX = changedTouches[0].locationX;
    event.locationY = changedTouches[0].locationY;
  }

  return event;
}

function normalizeMouseEvent(nativeEvent) {
  var rect = void 0;

  var touches = [{
    _normalized: true,
    clientX: nativeEvent.clientX,
    clientY: nativeEvent.clientY,
    force: nativeEvent.force,
    identifier: 0,
    get locationX() {
      rect = rect || getRect(nativeEvent.target);
      if (rect) {
        return nativeEvent.pageX - rect.left;
      }
    },
    get locationY() {
      rect = rect || getRect(nativeEvent.target);
      if (rect) {
        return nativeEvent.pageY - rect.top;
      }
    },
    pageX: nativeEvent.pageX,
    pageY: nativeEvent.pageY,
    screenX: nativeEvent.screenX,
    screenY: nativeEvent.screenY,
    target: nativeEvent.target,
    timestamp: Date.now()
  }];

  var preventDefault = typeof nativeEvent.preventDefault === 'function' ? nativeEvent.preventDefault.bind(nativeEvent) : emptyFunction;
  var stopImmediatePropagation = typeof nativeEvent.stopImmediatePropagation === 'function' ? nativeEvent.stopImmediatePropagation.bind(nativeEvent) : emptyFunction;
  var stopPropagation = typeof nativeEvent.stopPropagation === 'function' ? nativeEvent.stopPropagation.bind(nativeEvent) : emptyFunction;

  return {
    _normalized: true,
    bubbles: nativeEvent.bubbles,
    cancelable: nativeEvent.cancelable,
    changedTouches: touches,
    defaultPrevented: nativeEvent.defaultPrevented,
    identifier: touches[0].identifier,
    locationX: touches[0].locationX,
    locationY: touches[0].locationY,
    pageX: nativeEvent.pageX,
    pageY: nativeEvent.pageY,
    preventDefault: preventDefault,
    stopImmediatePropagation: stopImmediatePropagation,
    stopPropagation: stopPropagation,
    target: nativeEvent.target,
    timestamp: touches[0].timestamp,
    touches: nativeEvent.type === 'mouseup' ? emptyArray : touches,
    type: nativeEvent.type,
    which: nativeEvent.which
  };
}

// TODO: how to best handle keyboard events?
function normalizeNativeEvent(nativeEvent) {
  if (!nativeEvent || nativeEvent._normalized) {
    return nativeEvent;
  }
  var eventType = nativeEvent.type || '';
  var mouse = eventType.indexOf('mouse') >= 0;
  if (mouse) {
    return normalizeMouseEvent(nativeEvent);
  } else {
    return normalizeTouchEvent(nativeEvent);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (normalizeNativeEvent);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EdgeInsetsPropType__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_StyleSheetPropType__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ViewStylePropTypes__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */






var stylePropType = Object(__WEBPACK_IMPORTED_MODULE_1__modules_StyleSheetPropType__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__ViewStylePropTypes__["a" /* default */]);

var ViewPropTypes = {
  accessibilityComponentType: __WEBPACK_IMPORTED_MODULE_3_prop_types__["string"],
  accessibilityLabel: __WEBPACK_IMPORTED_MODULE_3_prop_types__["string"],
  accessibilityLiveRegion: Object(__WEBPACK_IMPORTED_MODULE_3_prop_types__["oneOf"])(['assertive', 'none', 'polite']),
  accessibilityRole: __WEBPACK_IMPORTED_MODULE_3_prop_types__["string"],
  accessibilityTraits: Object(__WEBPACK_IMPORTED_MODULE_3_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_3_prop_types__["array"], __WEBPACK_IMPORTED_MODULE_3_prop_types__["string"]]),
  accessible: __WEBPACK_IMPORTED_MODULE_3_prop_types__["bool"],
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types__["any"],
  hitSlop: __WEBPACK_IMPORTED_MODULE_0__EdgeInsetsPropType__["a" /* default */],
  importantForAccessibility: Object(__WEBPACK_IMPORTED_MODULE_3_prop_types__["oneOf"])(['auto', 'no', 'no-hide-descendants', 'yes']),
  onBlur: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onClickCapture: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onContextMenu: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onFocus: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onLayout: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onMoveShouldSetResponder: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onMoveShouldSetResponderCapture: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onResponderGrant: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onResponderMove: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onResponderReject: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onResponderRelease: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onResponderTerminate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onResponderTerminationRequest: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onStartShouldSetResponder: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onStartShouldSetResponderCapture: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onTouchCancel: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onTouchCancelCapture: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onTouchEnd: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onTouchEndCapture: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onTouchMove: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onTouchMoveCapture: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onTouchStart: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onTouchStartCapture: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  pointerEvents: Object(__WEBPACK_IMPORTED_MODULE_3_prop_types__["oneOf"])(['auto', 'box-none', 'box-only', 'none']),
  style: stylePropType,
  testID: __WEBPACK_IMPORTED_MODULE_3_prop_types__["string"],
  // compatibility with React Native
  accessibilityViewIsModal: __WEBPACK_IMPORTED_MODULE_3_prop_types__["bool"],
  collapsable: __WEBPACK_IMPORTED_MODULE_3_prop_types__["bool"],
  needsOffscreenAlphaCompositing: __WEBPACK_IMPORTED_MODULE_3_prop_types__["bool"],
  onAccessibilityTap: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onMagicTap: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  removeClippedSubviews: __WEBPACK_IMPORTED_MODULE_3_prop_types__["bool"],
  renderToHardwareTextureAndroid: __WEBPACK_IMPORTED_MODULE_3_prop_types__["bool"],
  shouldRasterizeIOS: __WEBPACK_IMPORTED_MODULE_3_prop_types__["bool"],
  tvParallaxProperties: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]
};

/* harmony default export */ __webpack_exports__["a"] = (ViewPropTypes);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_dom__["render"]);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_dom__["unmountComponentAtNode"]);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_Animated_AnimatedImplementation__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Image__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScrollView__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Text__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__View__ = __webpack_require__(13);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */







var Animated = Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_Animated_AnimatedImplementation__["a" /* default */], {
  Image: __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_Animated_AnimatedImplementation__["a" /* default */].createAnimatedComponent(__WEBPACK_IMPORTED_MODULE_1__Image__["a" /* default */]),
  ScrollView: __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_Animated_AnimatedImplementation__["a" /* default */].createAnimatedComponent(__WEBPACK_IMPORTED_MODULE_2__ScrollView__["a" /* default */]),
  View: __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_Animated_AnimatedImplementation__["a" /* default */].createAnimatedComponent(__WEBPACK_IMPORTED_MODULE_4__View__["a" /* default */]),
  Text: __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_Animated_AnimatedImplementation__["a" /* default */].createAnimatedComponent(__WEBPACK_IMPORTED_MODULE_3__Text__["a" /* default */])
});

/* harmony default export */ __webpack_exports__["a"] = (Animated);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emitter_EventEmitter__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports_Platform__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule NativeEventEmitter
 * 
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * Abstract base class for implementing event-emitting modules. This implements
 * a subset of the standard EventEmitter node module API.
 */
var NativeEventEmitter = function (_EventEmitter) {
  _inherits(NativeEventEmitter, _EventEmitter);

  function NativeEventEmitter(nativeModule) {
    _classCallCheck(this, NativeEventEmitter);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    if (__WEBPACK_IMPORTED_MODULE_1__exports_Platform__["a" /* default */].OS === 'ios') {
      __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(nativeModule, 'Native module cannot be null.');
      _this._nativeModule = nativeModule;
    }
    return _this;
  }

  NativeEventEmitter.prototype.addListener = function addListener(eventType, listener, context) {
    if (this._nativeModule != null) {
      this._nativeModule.addListener(eventType);
    }
    return _EventEmitter.prototype.addListener.call(this, eventType, listener, context);
  };

  NativeEventEmitter.prototype.removeAllListeners = function removeAllListeners(eventType) {
    __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(eventType, 'eventType argument is required.');
    var count = this.listeners(eventType).length;
    if (this._nativeModule != null) {
      this._nativeModule.removeListeners(count);
    }
    _EventEmitter.prototype.removeAllListeners.call(this, eventType);
  };

  NativeEventEmitter.prototype.removeSubscription = function removeSubscription(subscription) {
    if (this._nativeModule != null) {
      this._nativeModule.removeListeners(1);
    }
    _EventEmitter.prototype.removeSubscription.call(this, subscription);
  };

  return NativeEventEmitter;
}(__WEBPACK_IMPORTED_MODULE_0__emitter_EventEmitter__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (NativeEventEmitter);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimatedEvent__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimatedNode__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnimatedStyle__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NativeAnimatedHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__exports_findNodeHandle__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_fbjs_lib_invariant__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var AnimatedProps = function (_AnimatedNode) {
  _inherits(AnimatedProps, _AnimatedNode);

  function AnimatedProps(props, callback) {
    _classCallCheck(this, AnimatedProps);

    var _this = _possibleConstructorReturn(this, _AnimatedNode.call(this));

    if (props.style) {
      props = Object.assign({}, props, {
        style: new __WEBPACK_IMPORTED_MODULE_2__AnimatedStyle__["a" /* default */](props.style)
      });
    }
    _this._props = props;
    _this._callback = callback;
    _this.__attach();
    return _this;
  }

  AnimatedProps.prototype.__getValue = function __getValue() {
    var props = {};
    for (var key in this._props) {
      var value = this._props[key];
      if (value instanceof __WEBPACK_IMPORTED_MODULE_1__AnimatedNode__["a" /* default */]) {
        if (!value.__isNative || value instanceof __WEBPACK_IMPORTED_MODULE_2__AnimatedStyle__["a" /* default */]) {
          // We cannot use value of natively driven nodes this way as the value we have access from
          // JS may not be up to date.
          props[key] = value.__getValue();
        }
      } else if (value instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedEvent__["a" /* AnimatedEvent */]) {
        props[key] = value.__getHandler();
      } else {
        props[key] = value;
      }
    }
    return props;
  };

  AnimatedProps.prototype.__getAnimatedValue = function __getAnimatedValue() {
    var props = {};
    for (var key in this._props) {
      var value = this._props[key];
      if (value instanceof __WEBPACK_IMPORTED_MODULE_1__AnimatedNode__["a" /* default */]) {
        props[key] = value.__getAnimatedValue();
      }
    }
    return props;
  };

  AnimatedProps.prototype.__attach = function __attach() {
    for (var key in this._props) {
      var value = this._props[key];
      if (value instanceof __WEBPACK_IMPORTED_MODULE_1__AnimatedNode__["a" /* default */]) {
        value.__addChild(this);
      }
    }
  };

  AnimatedProps.prototype.__detach = function __detach() {
    if (this.__isNative && this._animatedView) {
      this.__disconnectAnimatedView();
    }
    for (var key in this._props) {
      var value = this._props[key];
      if (value instanceof __WEBPACK_IMPORTED_MODULE_1__AnimatedNode__["a" /* default */]) {
        value.__removeChild(this);
      }
    }
    _AnimatedNode.prototype.__detach.call(this);
  };

  AnimatedProps.prototype.update = function update() {
    this._callback();
  };

  AnimatedProps.prototype.__makeNative = function __makeNative() {
    if (!this.__isNative) {
      this.__isNative = true;
      for (var key in this._props) {
        var value = this._props[key];
        if (value instanceof __WEBPACK_IMPORTED_MODULE_1__AnimatedNode__["a" /* default */]) {
          value.__makeNative();
        }
      }
      if (this._animatedView) {
        this.__connectAnimatedView();
      }
    }
  };

  AnimatedProps.prototype.setNativeView = function setNativeView(animatedView) {
    if (this._animatedView === animatedView) {
      return;
    }
    this._animatedView = animatedView;
    if (this.__isNative) {
      this.__connectAnimatedView();
    }
  };

  AnimatedProps.prototype.__connectAnimatedView = function __connectAnimatedView() {
    __WEBPACK_IMPORTED_MODULE_5_fbjs_lib_invariant___default()(this.__isNative, 'Expected node to be marked as "native"');
    var nativeViewTag = Object(__WEBPACK_IMPORTED_MODULE_4__exports_findNodeHandle__["a" /* default */])(this._animatedView);
    __WEBPACK_IMPORTED_MODULE_5_fbjs_lib_invariant___default()(nativeViewTag != null, 'Unable to locate attached view in the native tree');
    __WEBPACK_IMPORTED_MODULE_3__NativeAnimatedHelper__["a" /* default */].API.connectAnimatedNodeToView(this.__getNativeTag(), nativeViewTag);
  };

  AnimatedProps.prototype.__disconnectAnimatedView = function __disconnectAnimatedView() {
    __WEBPACK_IMPORTED_MODULE_5_fbjs_lib_invariant___default()(this.__isNative, 'Expected node to be marked as "native"');
    var nativeViewTag = Object(__WEBPACK_IMPORTED_MODULE_4__exports_findNodeHandle__["a" /* default */])(this._animatedView);
    __WEBPACK_IMPORTED_MODULE_5_fbjs_lib_invariant___default()(nativeViewTag != null, 'Unable to locate attached view in the native tree');
    __WEBPACK_IMPORTED_MODULE_3__NativeAnimatedHelper__["a" /* default */].API.disconnectAnimatedNodeFromView(this.__getNativeTag(), nativeViewTag);
  };

  AnimatedProps.prototype.__getNativeConfig = function __getNativeConfig() {
    var propsConfig = {};
    for (var propKey in this._props) {
      var value = this._props[propKey];
      if (value instanceof __WEBPACK_IMPORTED_MODULE_1__AnimatedNode__["a" /* default */]) {
        propsConfig[propKey] = value.__getNativeTag();
      }
    }
    return {
      type: 'props',
      props: propsConfig
    };
  };

  return AnimatedProps;
}(__WEBPACK_IMPORTED_MODULE_1__AnimatedNode__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AnimatedProps);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bezier__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bezier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__bezier__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var _ease = void 0;

/**
 * The `Easing` module implements common easing functions. This module is used
 * by [Animate.timing()](docs/animate.html#timing) to convey physically
 * believable motion in animations.
 *
 * You can find a visualization of some common easing functions at
 * http://easings.net/
 *
 * ### Predefined animations
 *
 * The `Easing` module provides several predefined animations through the
 * following methods:
 *
 * - [`back`](docs/easing.html#back) provides a simple animation where the
 *   object goes slightly back before moving forward
 * - [`bounce`](docs/easing.html#bounce) provides a bouncing animation
 * - [`ease`](docs/easing.html#ease) provides a simple inertial animation
 * - [`elastic`](docs/easing.html#elastic) provides a simple spring interaction
 *
 * ### Standard functions
 *
 * Three standard easing functions are provided:
 *
 * - [`linear`](docs/easing.html#linear)
 * - [`quad`](docs/easing.html#quad)
 * - [`cubic`](docs/easing.html#cubic)
 *
 * The [`poly`](docs/easing.html#poly) function can be used to implement
 * quartic, quintic, and other higher power functions.
 *
 * ### Additional functions
 *
 * Additional mathematical functions are provided by the following methods:
 *
 * - [`bezier`](docs/easing.html#bezier) provides a cubic bezier curve
 * - [`circle`](docs/easing.html#circle) provides a circular function
 * - [`sin`](docs/easing.html#sin) provides a sinusoidal function
 * - [`exp`](docs/easing.html#exp) provides an exponential function
 *
 * The following helpers are used to modify other easing functions.
 *
 * - [`in`](docs/easing.html#in) runs an easing function forwards
 * - [`inOut`](docs/easing.html#inout) makes any easing function symmetrical
 * - [`out`](docs/easing.html#out) runs an easing function backwards
 */

var Easing = function () {
  function Easing() {
    _classCallCheck(this, Easing);
  }

  /**
   * A stepping function, returns 1 for any positive value of `n`.
   */
  Easing.step0 = function step0(n) {
    return n > 0 ? 1 : 0;
  };

  /**
   * A stepping function, returns 1 if `n` is greater than or equal to 1.
   */


  Easing.step1 = function step1(n) {
    return n >= 1 ? 1 : 0;
  };

  /**
   * A linear function, `f(t) = t`. Position correlates to elapsed time one to
   * one.
   *
   * http://cubic-bezier.com/#0,0,1,1
   */


  Easing.linear = function linear(t) {
    return t;
  };

  /**
   * A simple inertial interaction, similar to an object slowly accelerating to
   * speed.
   *
   * http://cubic-bezier.com/#.42,0,1,1
   */


  Easing.ease = function ease(t) {
    if (!_ease) {
      _ease = Easing.bezier(0.42, 0, 1, 1);
    }
    return _ease(t);
  };

  /**
   * A quadratic function, `f(t) = t * t`. Position equals the square of elapsed
   * time.
   *
   * http://easings.net/#easeInQuad
   */


  Easing.quad = function quad(t) {
    return t * t;
  };

  /**
   * A cubic function, `f(t) = t * t * t`. Position equals the cube of elapsed
   * time.
   *
   * http://easings.net/#easeInCubic
   */


  Easing.cubic = function cubic(t) {
    return t * t * t;
  };

  /**
   * A power function. Position is equal to the Nth power of elapsed time.
   *
   * n = 4: http://easings.net/#easeInQuart
   * n = 5: http://easings.net/#easeInQuint
   */


  Easing.poly = function poly(n) {
    return function (t) {
      return Math.pow(t, n);
    };
  };

  /**
   * A sinusoidal function.
   *
   * http://easings.net/#easeInSine
   */


  Easing.sin = function sin(t) {
    return 1 - Math.cos(t * Math.PI / 2);
  };

  /**
   * A circular function.
   *
   * http://easings.net/#easeInCirc
   */


  Easing.circle = function circle(t) {
    return 1 - Math.sqrt(1 - t * t);
  };

  /**
   * An exponential function.
   *
   * http://easings.net/#easeInExpo
   */


  Easing.exp = function exp(t) {
    return Math.pow(2, 10 * (t - 1));
  };

  /**
   * A simple elastic interaction, similar to a spring oscillating back and
   * forth.
   *
   * Default bounciness is 1, which overshoots a little bit once. 0 bounciness
   * doesn't overshoot at all, and bounciness of N > 1 will overshoot about N
   * times.
   *
   * http://easings.net/#easeInElastic
   */


  Easing.elastic = function elastic() {
    var bounciness = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    var p = bounciness * Math.PI;
    return function (t) {
      return 1 - Math.pow(Math.cos(t * Math.PI / 2), 3) * Math.cos(t * p);
    };
  };

  /**
   * Use with `Animated.parallel()` to create a simple effect where the object
   * animates back slightly as the animation starts.
   *
   * Wolfram Plot:
   *
   * - http://tiny.cc/back_default (s = 1.70158, default)
   */


  Easing.back = function back(s) {
    if (s === undefined) {
      s = 1.70158;
    }
    return function (t) {
      return t * t * ((s + 1) * t - s);
    };
  };

  /**
   * Provides a simple bouncing effect.
   *
   * http://easings.net/#easeInBounce
   */


  Easing.bounce = function bounce(t) {
    if (t < 1 / 2.75) {
      return 7.5625 * t * t;
    }

    if (t < 2 / 2.75) {
      t -= 1.5 / 2.75;
      return 7.5625 * t * t + 0.75;
    }

    if (t < 2.5 / 2.75) {
      t -= 2.25 / 2.75;
      return 7.5625 * t * t + 0.9375;
    }

    t -= 2.625 / 2.75;
    return 7.5625 * t * t + 0.984375;
  };

  /**
   * Provides a cubic bezier curve, equivalent to CSS Transitions'
   * `transition-timing-function`.
   *
   * A useful tool to visualize cubic bezier curves can be found at
   * http://cubic-bezier.com/
   */


  Easing.bezier = function bezier(x1, y1, x2, y2) {
    return __WEBPACK_IMPORTED_MODULE_0__bezier___default()(x1, y1, x2, y2);
  };

  /**
   * Runs an easing function forwards.
   */


  Easing.in = function _in(easing) {
    return easing;
  };

  /**
   * Runs an easing function backwards.
   */


  Easing.out = function out(easing) {
    return function (t) {
      return 1 - easing(1 - t);
    };
  };

  /**
   * Makes any easing function symmetrical. The easing function will run
   * forwards for half of the duration, then backwards for the rest of the
   * duration.
   */


  Easing.inOut = function inOut(easing) {
    return function (t) {
      if (t < 0.5) {
        return easing(t * 2) / 2;
      }
      return 1 - easing((1 - t) * 2) / 2;
    };
  };

  return Easing;
}();

/* harmony default export */ __webpack_exports__["a"] = (Easing);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextInputState__ = __webpack_require__(187);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var dismissKeyboard = function dismissKeyboard() {
  __WEBPACK_IMPORTED_MODULE_0__TextInputState__["a" /* default */].blurTextInput(__WEBPACK_IMPORTED_MODULE_0__TextInputState__["a" /* default */].currentlyFocusedField());
};

/* harmony default export */ __webpack_exports__["a"] = (dismissKeyboard);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_Dimensions__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports_findNodeHandle__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__exports_Platform__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TextInputState__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exports_UIManager__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fbjs_lib_warning__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fbjs_lib_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_fbjs_lib_warning__);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */









/**
 * Mixin that can be integrated in order to handle scrolling that plays well
 * with `ResponderEventPlugin`. Integrate with your platform specific scroll
 * views, or even your custom built (every-frame animating) scroll views so that
 * all of these systems play well with the `ResponderEventPlugin`.
 *
 * iOS scroll event timing nuances:
 * ===============================
 *
 *
 * Scrolling without bouncing, if you touch down:
 * -------------------------------
 *
 * 1. `onMomentumScrollBegin` (when animation begins after letting up)
 *    ... physical touch starts ...
 * 2. `onTouchStartCapture`   (when you press down to stop the scroll)
 * 3. `onTouchStart`          (same, but bubble phase)
 * 4. `onResponderRelease`    (when lifting up - you could pause forever before * lifting)
 * 5. `onMomentumScrollEnd`
 *
 *
 * Scrolling with bouncing, if you touch down:
 * -------------------------------
 *
 * 1. `onMomentumScrollBegin` (when animation begins after letting up)
 *    ... bounce begins ...
 *    ... some time elapses ...
 *    ... physical touch during bounce ...
 * 2. `onMomentumScrollEnd`   (Makes no sense why this occurs first during bounce)
 * 3. `onTouchStartCapture`   (immediately after `onMomentumScrollEnd`)
 * 4. `onTouchStart`          (same, but bubble phase)
 * 5. `onTouchEnd`            (You could hold the touch start for a long time)
 * 6. `onMomentumScrollBegin` (When releasing the view starts bouncing back)
 *
 * So when we receive an `onTouchStart`, how can we tell if we are touching
 * *during* an animation (which then causes the animation to stop)? The only way
 * to tell is if the `touchStart` occurred immediately after the
 * `onMomentumScrollEnd`.
 *
 * This is abstracted out for you, so you can just call this.scrollResponderIsAnimating() if
 * necessary
 *
 * `ScrollResponder` also includes logic for blurring a currently focused input
 * if one is focused while scrolling. The `ScrollResponder` is a natural place
 * to put this logic since it can support not dismissing the keyboard while
 * scrolling, unless a recognized "tap"-like gesture has occurred.
 *
 * The public lifecycle API includes events for keyboard interaction, responder
 * interaction, and scrolling (among others). The keyboard callbacks
 * `onKeyboardWill/Did/*` are *global* events, but are invoked on scroll
 * responder's props so that you can guarantee that the scroll responder's
 * internal state has been updated accordingly (and deterministically) by
 * the time the props callbacks are invoke. Otherwise, you would always wonder
 * if the scroll responder is currently in a state where it recognizes new
 * keyboard positions etc. If coordinating scrolling with keyboard movement,
 * *always* use these hooks instead of listening to your own global keyboard
 * events.
 *
 * Public keyboard lifecycle API: (props callbacks)
 *
 * Standard Keyboard Appearance Sequence:
 *
 *   this.props.onKeyboardWillShow
 *   this.props.onKeyboardDidShow
 *
 * `onScrollResponderKeyboardDismissed` will be invoked if an appropriate
 * tap inside the scroll responder's scrollable region was responsible
 * for the dismissal of the keyboard. There are other reasons why the
 * keyboard could be dismissed.
 *
 *   this.props.onScrollResponderKeyboardDismissed
 *
 * Standard Keyboard Hide Sequence:
 *
 *   this.props.onKeyboardWillHide
 *   this.props.onKeyboardDidHide
 */

var emptyObject = {};

var IS_ANIMATING_TOUCH_START_THRESHOLD_MS = 16;

var ScrollResponderMixin = {
  // mixins: [Subscribable.Mixin],
  scrollResponderMixinGetInitialState: function scrollResponderMixinGetInitialState() {
    return {
      isTouching: false,
      lastMomentumScrollBeginTime: 0,
      lastMomentumScrollEndTime: 0,

      // Reset to false every time becomes responder. This is used to:
      // - Determine if the scroll view has been scrolled and therefore should
      // refuse to give up its responder lock.
      // - Determine if releasing should dismiss the keyboard when we are in
      // tap-to-dismiss mode (!this.props.keyboardShouldPersistTaps).
      observedScrollSinceBecomingResponder: false,
      becameResponderWhileAnimating: false
    };
  },

  /**
   * Invoke this from an `onScroll` event.
   */
  scrollResponderHandleScrollShouldSetResponder: function scrollResponderHandleScrollShouldSetResponder() {
    return this.state.isTouching;
  },

  /**
   * Merely touch starting is not sufficient for a scroll view to become the
   * responder. Being the "responder" means that the very next touch move/end
   * event will result in an action/movement.
   *
   * Invoke this from an `onStartShouldSetResponder` event.
   *
   * `onStartShouldSetResponder` is used when the next move/end will trigger
   * some UI movement/action, but when you want to yield priority to views
   * nested inside of the view.
   *
   * There may be some cases where scroll views actually should return `true`
   * from `onStartShouldSetResponder`: Any time we are detecting a standard tap
   * that gives priority to nested views.
   *
   * - If a single tap on the scroll view triggers an action such as
   *   recentering a map style view yet wants to give priority to interaction
   *   views inside (such as dropped pins or labels), then we would return true
   *   from this method when there is a single touch.
   *
   * - Similar to the previous case, if a two finger "tap" should trigger a
   *   zoom, we would check the `touches` count, and if `>= 2`, we would return
   *   true.
   *
   */
  scrollResponderHandleStartShouldSetResponder: function scrollResponderHandleStartShouldSetResponder() {
    return false;
  },

  /**
   * There are times when the scroll view wants to become the responder
   * (meaning respond to the next immediate `touchStart/touchEnd`), in a way
   * that *doesn't* give priority to nested views (hence the capture phase):
   *
   * - Currently animating.
   * - Tapping anywhere that is not the focused input, while the keyboard is
   *   up (which should dismiss the keyboard).
   *
   * Invoke this from an `onStartShouldSetResponderCapture` event.
   */
  scrollResponderHandleStartShouldSetResponderCapture: function scrollResponderHandleStartShouldSetResponderCapture(e) {
    // First see if we want to eat taps while the keyboard is up
    // var currentlyFocusedTextInput = TextInputState.currentlyFocusedField();
    // if (!this.props.keyboardShouldPersistTaps &&
    //   currentlyFocusedTextInput != null &&
    //   e.target !== currentlyFocusedTextInput) {
    //   return true;
    // }
    return this.scrollResponderIsAnimating();
  },

  /**
   * Invoke this from an `onResponderReject` event.
   *
   * Some other element is not yielding its role as responder. Normally, we'd
   * just disable the `UIScrollView`, but a touch has already began on it, the
   * `UIScrollView` will not accept being disabled after that. The easiest
   * solution for now is to accept the limitation of disallowing this
   * altogether. To improve this, find a way to disable the `UIScrollView` after
   * a touch has already started.
   */
  scrollResponderHandleResponderReject: function scrollResponderHandleResponderReject() {
    __WEBPACK_IMPORTED_MODULE_6_fbjs_lib_warning___default()(false, "ScrollView doesn't take rejection well - scrolls anyway");
  },

  /**
   * We will allow the scroll view to give up its lock iff it acquired the lock
   * during an animation. This is a very useful default that happens to satisfy
   * many common user experiences.
   *
   * - Stop a scroll on the left edge, then turn that into an outer view's
   *   backswipe.
   * - Stop a scroll mid-bounce at the top, continue pulling to have the outer
   *   view dismiss.
   * - However, without catching the scroll view mid-bounce (while it is
   *   motionless), if you drag far enough for the scroll view to become
   *   responder (and therefore drag the scroll view a bit), any backswipe
   *   navigation of a swipe gesture higher in the view hierarchy, should be
   *   rejected.
   */
  scrollResponderHandleTerminationRequest: function scrollResponderHandleTerminationRequest() {
    return !this.state.observedScrollSinceBecomingResponder;
  },

  /**
   * Invoke this from an `onTouchEnd` event.
   *
   * @param {SyntheticEvent} e Event.
   */
  scrollResponderHandleTouchEnd: function scrollResponderHandleTouchEnd(e) {
    var nativeEvent = e.nativeEvent;
    this.state.isTouching = nativeEvent.touches.length !== 0;
    this.props.onTouchEnd && this.props.onTouchEnd(e);
  },

  /**
   * Invoke this from an `onResponderRelease` event.
   */
  scrollResponderHandleResponderRelease: function scrollResponderHandleResponderRelease(e) {
    this.props.onResponderRelease && this.props.onResponderRelease(e);

    // By default scroll views will unfocus a textField
    // if another touch occurs outside of it
    var currentlyFocusedTextInput = __WEBPACK_IMPORTED_MODULE_4__TextInputState__["a" /* default */].currentlyFocusedField();
    if (!this.props.keyboardShouldPersistTaps && currentlyFocusedTextInput != null && e.target !== currentlyFocusedTextInput && !this.state.observedScrollSinceBecomingResponder && !this.state.becameResponderWhileAnimating) {
      this.props.onScrollResponderKeyboardDismissed && this.props.onScrollResponderKeyboardDismissed(e);
      __WEBPACK_IMPORTED_MODULE_4__TextInputState__["a" /* default */].blurTextInput(currentlyFocusedTextInput);
    }
  },

  scrollResponderHandleScroll: function scrollResponderHandleScroll(e) {
    this.state.observedScrollSinceBecomingResponder = true;
    this.props.onScroll && this.props.onScroll(e);
  },

  /**
   * Invoke this from an `onResponderGrant` event.
   */
  scrollResponderHandleResponderGrant: function scrollResponderHandleResponderGrant(e) {
    this.state.observedScrollSinceBecomingResponder = false;
    this.props.onResponderGrant && this.props.onResponderGrant(e);
    this.state.becameResponderWhileAnimating = this.scrollResponderIsAnimating();
  },

  /**
   * Unfortunately, `onScrollBeginDrag` also fires when *stopping* the scroll
   * animation, and there's not an easy way to distinguish a drag vs. stopping
   * momentum.
   *
   * Invoke this from an `onScrollBeginDrag` event.
   */
  scrollResponderHandleScrollBeginDrag: function scrollResponderHandleScrollBeginDrag(e) {
    this.props.onScrollBeginDrag && this.props.onScrollBeginDrag(e);
  },

  /**
   * Invoke this from an `onScrollEndDrag` event.
   */
  scrollResponderHandleScrollEndDrag: function scrollResponderHandleScrollEndDrag(e) {
    this.props.onScrollEndDrag && this.props.onScrollEndDrag(e);
  },

  /**
   * Invoke this from an `onMomentumScrollBegin` event.
   */
  scrollResponderHandleMomentumScrollBegin: function scrollResponderHandleMomentumScrollBegin(e) {
    this.state.lastMomentumScrollBeginTime = Date.now();
    this.props.onMomentumScrollBegin && this.props.onMomentumScrollBegin(e);
  },

  /**
   * Invoke this from an `onMomentumScrollEnd` event.
   */
  scrollResponderHandleMomentumScrollEnd: function scrollResponderHandleMomentumScrollEnd(e) {
    this.state.lastMomentumScrollEndTime = Date.now();
    this.props.onMomentumScrollEnd && this.props.onMomentumScrollEnd(e);
  },

  /**
   * Invoke this from an `onTouchStart` event.
   *
   * Since we know that the `SimpleEventPlugin` occurs later in the plugin
   * order, after `ResponderEventPlugin`, we can detect that we were *not*
   * permitted to be the responder (presumably because a contained view became
   * responder). The `onResponderReject` won't fire in that case - it only
   * fires when a *current* responder rejects our request.
   *
   * @param {SyntheticEvent} e Touch Start event.
   */
  scrollResponderHandleTouchStart: function scrollResponderHandleTouchStart(e) {
    this.state.isTouching = true;
    this.props.onTouchStart && this.props.onTouchStart(e);
  },

  /**
   * Invoke this from an `onTouchMove` event.
   *
   * Since we know that the `SimpleEventPlugin` occurs later in the plugin
   * order, after `ResponderEventPlugin`, we can detect that we were *not*
   * permitted to be the responder (presumably because a contained view became
   * responder). The `onResponderReject` won't fire in that case - it only
   * fires when a *current* responder rejects our request.
   *
   * @param {SyntheticEvent} e Touch Start event.
   */
  scrollResponderHandleTouchMove: function scrollResponderHandleTouchMove(e) {
    this.props.onTouchMove && this.props.onTouchMove(e);
  },

  /**
   * A helper function for this class that lets us quickly determine if the
   * view is currently animating. This is particularly useful to know when
   * a touch has just started or ended.
   */
  scrollResponderIsAnimating: function scrollResponderIsAnimating() {
    var now = Date.now();
    var timeSinceLastMomentumScrollEnd = now - this.state.lastMomentumScrollEndTime;
    var isAnimating = timeSinceLastMomentumScrollEnd < IS_ANIMATING_TOUCH_START_THRESHOLD_MS || this.state.lastMomentumScrollEndTime < this.state.lastMomentumScrollBeginTime;
    return isAnimating;
  },

  /**
   * Returns the node that represents native view that can be scrolled.
   * Components can pass what node to use by defining a `getScrollableNode`
   * function otherwise `this` is used.
   */
  scrollResponderGetScrollableNode: function scrollResponderGetScrollableNode() {
    return this.getScrollableNode ? this.getScrollableNode() : Object(__WEBPACK_IMPORTED_MODULE_1__exports_findNodeHandle__["a" /* default */])(this);
  },

  /**
   * A helper function to scroll to a specific point in the scrollview.
   * This is currently used to help focus on child textviews, but can also
   * be used to quickly scroll to any element we want to focus. Syntax:
   *
   * scrollResponderScrollTo(options: {x: number = 0; y: number = 0; animated: boolean = true})
   *
   * Note: The weird argument signature is due to the fact that, for historical reasons,
   * the function also accepts separate arguments as as alternative to the options object.
   * This is deprecated due to ambiguity (y before x), and SHOULD NOT BE USED.
   */
  scrollResponderScrollTo: function scrollResponderScrollTo(x, y, animated) {
    if (typeof x === 'number') {
      console.warn('`scrollResponderScrollTo(x, y, animated)` is deprecated. Use `scrollResponderScrollTo({x: 5, y: 5, animated: true})` instead.');
    } else {
      var _ref = x || emptyObject;

      x = _ref.x;
      y = _ref.y;
      animated = _ref.animated;
    }
    var node = this.scrollResponderGetScrollableNode();
    __WEBPACK_IMPORTED_MODULE_5__exports_UIManager__["a" /* default */].updateView(node, { style: { scrollBehavior: !animated ? 'auto' : 'smooth' } }, this);
    node.scrollLeft = x || 0;
    node.scrollTop = y || 0;
  },

  /**
   * Deprecated, do not use.
   */
  scrollResponderScrollWithoutAnimationTo: function scrollResponderScrollWithoutAnimationTo(offsetX, offsetY) {
    console.warn('`scrollResponderScrollWithoutAnimationTo` is deprecated. Use `scrollResponderScrollTo` instead');
    this.scrollResponderScrollTo({ x: offsetX, y: offsetY, animated: false });
  },

  /**
   * A helper function to zoom to a specific rect in the scrollview. The argument has the shape
   * {x: number; y: number; width: number; height: number; animated: boolean = true}
   *
   * @platform ios
   */
  scrollResponderZoomTo: function scrollResponderZoomTo(rect, animated // deprecated, put this inside the rect argument instead
  ) {
    if (__WEBPACK_IMPORTED_MODULE_3__exports_Platform__["a" /* default */].OS !== 'ios') {
      __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()('zoomToRect is not implemented');
    }
  },

  /**
   * Displays the scroll indicators momentarily.
   */
  scrollResponderFlashScrollIndicators: function scrollResponderFlashScrollIndicators() {},

  /**
   * This method should be used as the callback to onFocus in a TextInputs'
   * parent view. Note that any module using this mixin needs to return
   * the parent view's ref in getScrollViewRef() in order to use this method.
   * @param {any} nodeHandle The TextInput node handle
   * @param {number} additionalOffset The scroll view's top "contentInset".
   *        Default is 0.
   * @param {bool} preventNegativeScrolling Whether to allow pulling the content
   *        down to make it meet the keyboard's top. Default is false.
   */
  scrollResponderScrollNativeHandleToKeyboard: function scrollResponderScrollNativeHandleToKeyboard(nodeHandle, additionalOffset, preventNegativeScrollOffset) {
    this.additionalScrollOffset = additionalOffset || 0;
    this.preventNegativeScrollOffset = !!preventNegativeScrollOffset;
    __WEBPACK_IMPORTED_MODULE_5__exports_UIManager__["a" /* default */].measureLayout(nodeHandle, Object(__WEBPACK_IMPORTED_MODULE_1__exports_findNodeHandle__["a" /* default */])(this.getInnerViewNode()), this.scrollResponderTextInputFocusError, this.scrollResponderInputMeasureAndScrollToKeyboard);
  },

  /**
   * The calculations performed here assume the scroll view takes up the entire
   * screen - even if has some content inset. We then measure the offsets of the
   * keyboard, and compensate both for the scroll view's "contentInset".
   *
   * @param {number} left Position of input w.r.t. table view.
   * @param {number} top Position of input w.r.t. table view.
   * @param {number} width Width of the text input.
   * @param {number} height Height of the text input.
   */
  scrollResponderInputMeasureAndScrollToKeyboard: function scrollResponderInputMeasureAndScrollToKeyboard(left, top, width, height) {
    var keyboardScreenY = __WEBPACK_IMPORTED_MODULE_0__exports_Dimensions__["a" /* default */].get('window').height;
    if (this.keyboardWillOpenTo) {
      keyboardScreenY = this.keyboardWillOpenTo.endCoordinates.screenY;
    }
    var scrollOffsetY = top - keyboardScreenY + height + this.additionalScrollOffset;

    // By default, this can scroll with negative offset, pulling the content
    // down so that the target component's bottom meets the keyboard's top.
    // If requested otherwise, cap the offset at 0 minimum to avoid content
    // shifting down.
    if (this.preventNegativeScrollOffset) {
      scrollOffsetY = Math.max(0, scrollOffsetY);
    }
    this.scrollResponderScrollTo({ x: 0, y: scrollOffsetY, animated: true });

    this.additionalOffset = 0;
    this.preventNegativeScrollOffset = false;
  },

  scrollResponderTextInputFocusError: function scrollResponderTextInputFocusError(e) {
    console.error('Error measuring text field: ', e);
  },

  /**
   * `componentWillMount` is the closest thing to a  standard "constructor" for
   * React components.
   *
   * The `keyboardWillShow` is called before input focus.
   */
  componentWillMount: function componentWillMount() {
    this.keyboardWillOpenTo = null;
    this.additionalScrollOffset = 0;
    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardWillShow', this.scrollResponderKeyboardWillShow);
    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardWillHide', this.scrollResponderKeyboardWillHide);
    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardDidShow', this.scrollResponderKeyboardDidShow);
    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardDidHide', this.scrollResponderKeyboardDidHide);
  },

  /**
   * Warning, this may be called several times for a single keyboard opening.
   * It's best to store the information in this method and then take any action
   * at a later point (either in `keyboardDidShow` or other).
   *
   * Here's the order that events occur in:
   * - focus
   * - willShow {startCoordinates, endCoordinates} several times
   * - didShow several times
   * - blur
   * - willHide {startCoordinates, endCoordinates} several times
   * - didHide several times
   *
   * The `ScrollResponder` providesModule callbacks for each of these events.
   * Even though any user could have easily listened to keyboard events
   * themselves, using these `props` callbacks ensures that ordering of events
   * is consistent - and not dependent on the order that the keyboard events are
   * subscribed to. This matters when telling the scroll view to scroll to where
   * the keyboard is headed - the scroll responder better have been notified of
   * the keyboard destination before being instructed to scroll to where the
   * keyboard will be. Stick to the `ScrollResponder` callbacks, and everything
   * will work.
   *
   * WARNING: These callbacks will fire even if a keyboard is displayed in a
   * different navigation pane. Filter out the events to determine if they are
   * relevant to you. (For example, only if you receive these callbacks after
   * you had explicitly focused a node etc).
   */
  scrollResponderKeyboardWillShow: function scrollResponderKeyboardWillShow(e) {
    this.keyboardWillOpenTo = e;
    this.props.onKeyboardWillShow && this.props.onKeyboardWillShow(e);
  },

  scrollResponderKeyboardWillHide: function scrollResponderKeyboardWillHide(e) {
    this.keyboardWillOpenTo = null;
    this.props.onKeyboardWillHide && this.props.onKeyboardWillHide(e);
  },

  scrollResponderKeyboardDidShow: function scrollResponderKeyboardDidShow(e) {
    // TODO(7693961): The event for DidShow is not available on iOS yet.
    // Use the one from WillShow and do not assign.
    if (e) {
      this.keyboardWillOpenTo = e;
    }
    this.props.onKeyboardDidShow && this.props.onKeyboardDidShow(e);
  },

  scrollResponderKeyboardDidHide: function scrollResponderKeyboardDidHide(e) {
    this.keyboardWillOpenTo = null;
    this.props.onKeyboardDidHide && this.props.onKeyboardDidHide(e);
  }
};

var ScrollResponder = {
  Mixin: ScrollResponderMixin
};

/* harmony default export */ __webpack_exports__["a"] = (ScrollResponder);

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (arr, predicate, ctx) {
	if (typeof Array.prototype.findIndex === 'function') {
		return arr.findIndex(predicate, ctx);
	}

	if (typeof predicate !== 'function') {
		throw new TypeError('predicate must be a function');
	}

	var list = Object(arr);
	var len = list.length;

	if (len === 0) {
		return -1;
	}

	for (var i = 0; i < len; i++) {
		if (predicate.call(ctx, list[i], i, list)) {
			return i;
		}
	}

	return -1;
};


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_PanResponder__ = __webpack_require__(678);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__vendor_react_native_PanResponder__["a" /* default */]);

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Path = __webpack_require__(298);

var CanvasPath = Class(Path, {

	initialize: function(path){
		this.reset();
		if (path instanceof CanvasPath){
			this.path = path.path.slice(0);
		} else if (path){
			if (path.applyToPath)
				path.applyToPath(this);
			else
				this.push(path);
		}
	},

	onReset: function(){
		this.path = [];
	},

	onMove: function(sx, sy, x, y){
		this.path.push(function(context){
			context.moveTo(x, y);
		});
	},

	onLine: function(sx, sy, x, y){
		this.path.push(function(context){
			context.lineTo(x, y);
		});
	},

	onBezierCurve: function(sx, sy, p1x, p1y, p2x, p2y, x, y){
		this.path.push(function(context){
			context.bezierCurveTo(p1x, p1y, p2x, p2y, x, y);
		});
	},

	_arcToBezier: Path.prototype.onArc,

	onArc: function(sx, sy, ex, ey, cx, cy, rx, ry, sa, ea, ccw, rotation){
		if (rx != ry || rotation) return this._arcToBezier(sx, sy, ex, ey, cx, cy, rx, ry, sa, ea, ccw, rotation);
		this.path.push(function(context){
			context.arc(cx, cy, rx, sa, ea, ccw);
		});
	},

	onClose: function(){
		this.path.push(function(context){
			context.closePath();
		});
	},

	toCommands: function(){
		return this.path.slice(0);
	}

});

module.exports = CanvasPath;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);

module.exports = Class({
	
	initialize: function(path){
		this.reset().push(path);
	},

	/* parser */
	
	push: function(){
		var p = Array.prototype.join.call(arguments, ' ')
			.match(/[a-df-z]|[\-+]?(?:[\d\.]e[\-+]?|[^\s\-+,a-z])+/ig);
		if (!p) return this;

		var last, cmd = p[0], i = 1;
		while (cmd){
			switch (cmd){
				case 'm': this.move(p[i++], p[i++]); break;
				case 'l': this.line(p[i++], p[i++]); break;
				case 'c': this.curve(p[i++], p[i++], p[i++], p[i++], p[i++], p[i++]); break;
				case 's': this.curve(p[i++], p[i++], null, null, p[i++], p[i++]); break;
				case 'q': this.curve(p[i++], p[i++], p[i++], p[i++]); break;
				case 't': this.curve(p[i++], p[i++]); break;
				case 'a': this.arc(p[i+5], p[i+6], p[i], p[i+1], p[i+3], !+p[i+4], p[i+2]); i += 7; break;
				case 'h': this.line(p[i++], 0); break;
				case 'v': this.line(0, p[i++]); break;

				case 'M': this.moveTo(p[i++], p[i++]); break;
				case 'L': this.lineTo(p[i++], p[i++]); break;
				case 'C': this.curveTo(p[i++], p[i++], p[i++], p[i++], p[i++], p[i++]); break;
				case 'S': this.curveTo(p[i++], p[i++], null, null, p[i++], p[i++]); break;
				case 'Q': this.curveTo(p[i++], p[i++], p[i++], p[i++]); break;
				case 'T': this.curveTo(p[i++], p[i++]); break;
				case 'A': this.arcTo(p[i+5], p[i+6], p[i], p[i+1], p[i+3], !+p[i+4], p[i+2]); i += 7; break;
				case 'H': this.lineTo(p[i++], this.penY); break;
				case 'V': this.lineTo(this.penX, p[i++]); break;
				
				case 'Z': case 'z': this.close(); break;
				default: cmd = last; i--; continue;
			}

			last = cmd;
			if (last == 'm') last = 'l';
			else if (last == 'M') last = 'L';
			cmd = p[i++];
		}
		return this;
	},

	/* utility methods */

	reset: function(){
		this.penX = this.penY = 0;
		this.penDownX = this.penDownY = null;
		this._pivotX = this._pivotY = 0;
		this.onReset();
		return this;
	},
	
	move: function(x,y){
		this.onMove(this.penX, this.penY, this._pivotX = this.penX += (+x), this._pivotY = this.penY += (+y));
		return this;
	},
	moveTo: function(x,y){
		this.onMove(this.penX, this.penY, this._pivotX = this.penX = (+x), this._pivotY = this.penY = (+y));
		return this;
	},

	line: function(x,y){
		return this.lineTo(this.penX + (+x), this.penY + (+y));
	},
	lineTo: function(x,y){
		if (this.penDownX == null){ this.penDownX = this.penX; this.penDownY = this.penY; }
		this.onLine(this.penX, this.penY, this._pivotX = this.penX = (+x), this._pivotY = this.penY = (+y));
		return this;
	},
	
	curve: function(c1x, c1y, c2x, c2y, ex, ey){
		var x = this.penX, y = this.penY;
		return this.curveTo(
			x + (+c1x), y + (+c1y),
			c2x == null ? null : x + (+c2x),
			c2y == null ? null : y + (+c2y),
			ex == null ? null : x + (+ex),
			ey == null ? null : y + (+ey)
		);
	},
	curveTo: function(c1x, c1y, c2x, c2y, ex, ey){
		var x = this.penX, y = this.penY;
		if (c2x == null){
			c2x = +c1x; c2y = +c1y;
			c1x = (x * 2) - (this._pivotX || 0); c1y = (y * 2) - (this._pivotY || 0);
		}
		if (ex == null){
			this._pivotX = +c1x; this._pivotY = +c1y;
			ex = +c2x; ey = +c2y;
			c2x = (ex + (+c1x) * 2) / 3; c2y = (ey + (+c1y) * 2) / 3;
			c1x = (x + (+c1x) * 2) / 3; c1y = (y + (+c1y) * 2) / 3;
		} else {
			this._pivotX = +c2x; this._pivotY = +c2y;
		}
		if (this.penDownX == null){ this.penDownX = x; this.penDownY = y; }
		this.onBezierCurve(x, y, +c1x, +c1y, +c2x, +c2y, this.penX = +ex, this.penY = +ey);
		return this;
	},
	
	arc: function(x, y, rx, ry, outer, counterClockwise, rotation){
		return this.arcTo(this.penX + (+x), this.penY + (+y), rx, ry, outer, counterClockwise, rotation);
	},
	arcTo: function(x, y, rx, ry, outer, counterClockwise, rotation){
		ry = Math.abs(+ry || +rx || (+y - this.penY));
		rx = Math.abs(+rx || (+x - this.penX));

		if (!rx || !ry || (x == this.penX && y == this.penY)) return this.lineTo(x, y);

		var tX = this.penX, tY = this.penY, clockwise = !+counterClockwise, large = !!+outer;

		var rad = rotation ? rotation * Math.PI / 180 : 0, cos = Math.cos(rad), sin = Math.sin(rad);
		x -= tX; y -= tY;
		
		// Ellipse Center
		var cx = cos * x / 2 + sin * y / 2,
			cy = -sin * x / 2 + cos * y / 2,
			rxry = rx * rx * ry * ry,
			rycx = ry * ry * cx * cx,
			rxcy = rx * rx * cy * cy,
			a = rxry - rxcy - rycx;

		if (a < 0){
			a = Math.sqrt(1 - a / rxry);
			rx *= a; ry *= a;
			cx = x / 2; cy = y / 2;
		} else {
			a = Math.sqrt(a / (rxcy + rycx));
			if (large == clockwise) a = -a;
			var cxd = -a * cy * rx / ry,
			    cyd =  a * cx * ry / rx;
			cx = cos * cxd - sin * cyd + x / 2;
			cy = sin * cxd + cos * cyd + y / 2;
		}

		// Rotation + Scale Transform
		var xx =  cos / rx, yx = sin / rx,
		    xy = -sin / ry, yy = cos / ry;

		// Start and End Angle
		var sa = Math.atan2(xy * -cx + yy * -cy, xx * -cx + yx * -cy),
		    ea = Math.atan2(xy * (x - cx) + yy * (y - cy), xx * (x - cx) + yx * (y - cy));

		cx += tX; cy += tY;
		x += tX; y += tY;

		// Circular Arc
		if (this.penDownX == null){ this.penDownX = this.penX; this.penDownY = this.penY; }
		this.onArc(
			tX, tY, this._pivotX = this.penX = x, this._pivotY = this.penY = y,
			cx, cy, rx, ry, sa, ea, !clockwise, rotation
		);
		return this;
	},

	counterArc: function(x, y, rx, ry, outer){
		return this.arc(x, y, rx, ry, outer, true);
	},
	counterArcTo: function(x, y, rx, ry, outer){
		return this.arcTo(x, y, rx, ry, outer, true);
	},

	close: function(){
		if (this.penDownX != null){
			this.onClose(this.penX, this.penY, this.penX = this.penDownX, this.penY = this.penDownY);
			this.penDownX = null;
		}
		return this;
	},

	/* overridable handlers */
	
	onReset: function(){
	},

	onMove: function(sx, sy, ex, ey){
	},

	onLine: function(sx, sy, ex, ey){
		this.onBezierCurve(sx, sy, sx, sy, ex, ey, ex, ey);
	},

	onBezierCurve: function(sx, sy, c1x, c1y, c2x, c2y, ex, ey){
		var gx = ex - sx, gy = ey - sy,
			g = gx * gx + gy * gy,
			v1, v2, cx, cy, u;

		cx = c1x - sx; cy = c1y - sy;
		u = cx * gx + cy * gy;

		if (u > g){
			cx -= gx;
			cy -= gy;
		} else if (u > 0 && g != 0){
			cx -= u/g * gx;
			cy -= u/g * gy;
		}

		v1 = cx * cx + cy * cy;

		cx = c2x - sx; cy = c2y - sy;
		u = cx * gx + cy * gy;

		if (u > g){
			cx -= gx;
			cy -= gy;
		} else if (u > 0 && g != 0){
			cx -= u/g * gx;
			cy -= u/g * gy;
		}

		v2 = cx * cx + cy * cy;

		if (v1 < 0.01 && v2 < 0.01){
			this.onLine(sx, sy, ex, ey);
			return;
		}

		// Avoid infinite recursion
		if (isNaN(v1) || isNaN(v2)){
			throw new Error('Bad input');
		}

		// Split curve
		var s1x =   (c1x + c2x) * 0.5,   s1y =   (c1y + c2y) * 0.5,
		    l1x =   (c1x + sx)  * 0.5,   l1y =   (c1y + sy)  * 0.5,
		    l2x =   (l1x + s1x) * 0.5,   l2y =   (l1y + s1y) * 0.5,
		    r2x =   (ex + c2x)  * 0.5,   r2y =   (ey + c2y)  * 0.5,
		    r1x =   (r2x + s1x) * 0.5,   r1y =   (r2y + s1y) * 0.5,
		    l2r1x = (l2x + r1x) * 0.5,   l2r1y = (l2y + r1y) * 0.5;

		// TODO: Manual stack if necessary. Currently recursive without tail optimization.
		this.onBezierCurve(sx, sy, l1x, l1y, l2x, l2y, l2r1x, l2r1y);
		this.onBezierCurve(l2r1x, l2r1y, r1x, r1y, r2x, r2y, ex, ey);
	},

	onArc: function(sx, sy, ex, ey, cx, cy, rx, ry, sa, ea, ccw, rotation){
		// Inverse Rotation + Scale Transform
		var rad = rotation ? rotation * Math.PI / 180 : 0, cos = Math.cos(rad), sin = Math.sin(rad),
			xx = cos * rx, yx = -sin * ry,
		    xy = sin * rx, yy =  cos * ry;

		// Bezier Curve Approximation
		var arc = ea - sa;
		if (arc < 0 && !ccw) arc += Math.PI * 2;
		else if (arc > 0 && ccw) arc -= Math.PI * 2;

		var n = Math.ceil(Math.abs(arc / (Math.PI / 2))),
		    step = arc / n,
		    k = (4 / 3) * Math.tan(step / 4);

		var x = Math.cos(sa), y = Math.sin(sa);

		for (var i = 0; i < n; i++){
			var cp1x = x - k * y, cp1y = y + k * x;

			sa += step;
			x = Math.cos(sa); y = Math.sin(sa);

			var cp2x = x + k * y, cp2y = y - k * x;

			this.onBezierCurve(
				sx, sy,
				cx + xx * cp1x + yx * cp1y, cy + xy * cp1x + yy * cp1y,
				cx + xx * cp2x + yx * cp2y, cy + xy * cp2x + yy * cp2y,
				(sx = (cx + xx * x + yx * y)), (sy = (cy + xy * x + yy * y))
			);
		}
	},

	onClose: function(sx, sy, ex, ey){
		this.onLine(sx, sy, ex, ey);
	}

});

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Color = __webpack_require__(300);
var Transform = __webpack_require__(81);
var Node = __webpack_require__(190);

var genericCanvas = typeof document !== 'undefined' && document.createElement('canvas'),
    genericContext = genericCanvas && genericCanvas.getContext && genericCanvas.getContext('2d');

function recolorImage(img, color1, color2){
	// TODO: Fix this experimental implementation
	color1 = Color.detach(color1);
	color2 = Color.detach(color2);
	var canvas = document.createElement('canvas'),
		context = canvas.getContext('2d');
	canvas.width = img.width;
	canvas.height = img.height;
	context.fillStyle = color2[0];
	context.fillRect(0, 0, img.width, img.height);
	context.globalCompositeOperation = 'lighter';
	context.drawImage(img, 0, 0);
	return canvas;
}

var Base = Class(Node, {

	initialize: function(){
		this._fill = null;
		this._pendingFill = null;
		this._fillTransform = null;
		this._stroke = null;
		this._strokeCap = null;
		this._strokeDash = null;
		this._strokeJoin = null;
		this._strokeWidth = null;
	},

	/* styles */

	_addColors: function(gradient, stops){
		// Enumerate stops, assumes offsets are enumerated in order
		// TODO: Sort. Chrome doesn't always enumerate in expected order but requires stops to be specified in order.
		if ('length' in stops) for (var i = 0, l = stops.length - 1; i <= l; i++)
			gradient.addColorStop(i / l, new Color(stops[i]).toString());
		else for (var offset in stops)
			gradient.addColorStop(offset, new Color(stops[offset]).toString());
		return gradient;
	},


	fill: function(color){
		if (arguments.length > 1) return this.fillLinear(arguments);
		if (this._pendingFill) this._pendingFill();
		this._fill = color ? new Color(color).toString() : null;
		return this.invalidate();
	},

	fillRadial: function(stops, focusX, focusY, radiusX, radiusY, centerX, centerY){
		if (focusX == null) focusX = (this.left || 0) + (this.width || 0) * 0.5;
		if (focusY == null) focusY = (this.top || 0) + (this.height || 0) * 0.5;
		if (radiusY == null) radiusY = radiusX || (this.height * 0.5) || 0;
		if (radiusX == null) radiusX = (this.width || 0) * 0.5;
		if (centerX == null) centerX = focusX;
		if (centerY == null) centerY = focusY;

		centerX += centerX - focusX;
		centerY += centerY - focusY;

		if (radiusX === 0 || radiusX === '0') return this.fillLinear(stops);
		var ys = radiusY / radiusX;

		if (this._pendingFill) this._pendingFill();

		var gradient = genericContext.createRadialGradient(focusX, focusY / ys, 0, centerX, centerY / ys, radiusX * 2);

		// Double fill radius to simulate repeating gradient
		if ('length' in stops) for (var i = 0, l = stops.length - 1; i <= l; i++){
			gradient.addColorStop(i / l / 2, new Color(stops[i]).toString());
			gradient.addColorStop(1 - i / l / 2, new Color(stops[i]).toString());
		} else for (var offset in stops){
			gradient.addColorStop(offset / 2, new Color(stops[offset]).toString());
			gradient.addColorStop(1- offset / 2, new Color(stops[offset]).toString());
		}

		this._fill = gradient;
		this._fillTransform = new Transform(1, 0, 0, ys);
		return this.invalidate();
	},

	fillLinear: function(stops, x1, y1, x2, y2){
		if (arguments.length < 5){
			var angle = ((x1 == null) ? 270 : x1) * Math.PI / 180;

			var x = Math.cos(angle), y = -Math.sin(angle),
				l = (Math.abs(x) + Math.abs(y)) / 2,
				w = this.width || 1, h = this.height || 1;

			x *= l; y *= l;

			x1 = 0.5 - x;
			x2 = 0.5 + x;
			y1 = 0.5 - y;
			y2 = 0.5 + y;
			this._fillTransform = new Transform(w, 0, 0, h);
		} else {
			this._fillTransform = null;
		}
		if (this._pendingFill) this._pendingFill();
		var gradient = genericContext.createLinearGradient(x1, y1, x2, y2);
		this._addColors(gradient, stops);
		this._fill = gradient;
		return this.invalidate();
	},

	fillImage: function(url, width, height, left, top, color1, color2){
		if (this._pendingFill) this._pendingFill();
		var img = url;
		if (!(img instanceof Image)){
			img = new Image();
			img.src = url;
		}
		if (img.width && img.height){
			return this._fillImage(img, width, height, left || 0, top || 0, color1, color2);
		}

		// Not yet loaded
		this._fill = null;
		var self = this,
			callback = function(){
				cancel();
				self._fillImage(img, width, height, left || 0, top || 0, color1, color2);
			},
			cancel = function(){
				img.removeEventListener('load', callback, false);
				self._pendingFill = null;
			};
		this._pendingFill = cancel;
		img.addEventListener('load', callback, false);
		return this;
	},

	_fillImage: function(img, width, height, left, top, color1, color2){
		var w = width ? width / img.width : 1,
			h = height ? height / img.height : 1;
		if (color1 != null) img = recolorImage(img, color1, color2);
		this._fill = genericContext.createPattern(img, 'repeat');
		this._fillTransform = new Transform(w, 0, 0, h, left || 0, top || 0);
		return this.invalidate();
	},

	stroke: function(color, width, cap, join, dash){
		this._stroke = color ? new Color(color).toString() : null;
		this._strokeWidth = (width != null) ? width : 1;
		this._strokeCap = (cap != null) ? cap : 'round';
		this._strokeJoin = (join != null) ? join : 'round';
		this._strokeDash = dash;
		return this.invalidate();
	},

	// Rendering

	element_renderTo: Node.prototype.renderTo,

	renderTo: function(context, xx, yx, xy, yy, x, y){
		var opacity = this._opacity;
		if (opacity == null || opacity >= 1){
			return this.renderLayerTo(context, xx, yx, xy, yy, x, y);
		}
		if (this._fill && this._stroke){
			return this.element_renderTo(context, xx, yx, xy, yy, x, y);
		}
		context.globalAlpha = opacity;
		var r = this.renderLayerTo(context, xx, yx, xy, yy, x, y);
		context.globalAlpha = 1;
		return r;
	},

	renderLayerTo: function(context, xx, yx, xy, yy, x, y){
		context.setTransform(xx, yx, xy, yy, x, y);
		this.renderShapeTo(context);
	}

});

Base._genericContext = genericContext;

module.exports = Base;


/***/ }),
/* 300 */
/***/ (function(module, exports) {

var colors = {
	maroon: '#800000', red: '#ff0000', orange: '#ffA500', yellow: '#ffff00', olive: '#808000',
	purple: '#800080', fuchsia: "#ff00ff", white: '#ffffff', lime: '#00ff00', green: '#008000',
	navy: '#000080', blue: '#0000ff', aqua: '#00ffff', teal: '#008080',
	black: '#000000', silver: '#c0c0c0', gray: '#808080'
};

var map = function(array, fn){
	var results = [];
	for (var i = 0, l = array.length; i < l; i++)
		results[i] = fn(array[i], i);
	return results;
};

var Color = function(color, type){
	
	if (color.isColor){
		
		this.red = color.red;
		this.green = color.green;
		this.blue = color.blue;
		this.alpha = color.alpha;

	} else {
		
		var namedColor = colors[color];
		if (namedColor){
			color = namedColor;
			type = 'hex';
		}

		switch (typeof color){
			case 'string': if (!type) type = (type = color.match(/^rgb|^hsb|^hsl/)) ? type[0] : 'hex'; break;
			case 'object': type = type || 'rgb'; color = color.toString(); break;
			case 'number': type = 'hex'; color = color.toString(16); break;
		}

		color = Color['parse' + type.toUpperCase()](color);
		this.red = color[0];
		this.green = color[1];
		this.blue = color[2];
		this.alpha = color[3];
	}
	
	this.isColor = true;

};

var limit = function(number, min, max){
	return Math.min(max, Math.max(min, number));
};

var listMatch = /([-.\d]+\%?)\s*,\s*([-.\d]+\%?)\s*,\s*([-.\d]+\%?)\s*,?\s*([-.\d]*\%?)/;
var hexMatch = /^#?([a-f0-9]{1,2})([a-f0-9]{1,2})([a-f0-9]{1,2})([a-f0-9]{0,2})$/i;

Color.parseRGB = function(color){
	return map(color.match(listMatch).slice(1), function(bit, i){
		if (bit) bit = parseFloat(bit) * (bit[bit.length - 1] == '%' ? 2.55 : 1);
		return (i < 3) ? Math.round(((bit %= 256) < 0) ? bit + 256 : bit) : limit(((bit === '') ? 1 : Number(bit)), 0, 1);
	});
};
	
Color.parseHEX = function(color){
	if (color.length == 1) color = color + color + color;
	return map(color.match(hexMatch).slice(1), function(bit, i){
		if (i == 3) return (bit) ? parseInt(bit, 16) / 255 : 1;
		return parseInt((bit.length == 1) ? bit + bit : bit, 16);
	});
};
	
Color.parseHSB = function(color){
	var hsb = map(color.match(listMatch).slice(1), function(bit, i){
		if (bit) bit = parseFloat(bit);
		if (i === 0) return Math.round(((bit %= 360) < 0) ? (bit + 360) : bit);
		else if (i < 3) return limit(Math.round(bit), 0, 100);
		else return limit(((bit === '') ? 1 : Number(bit)), 0, 1);
	});
	
	var a = hsb[3];
	var br = Math.round(hsb[2] / 100 * 255);
	if (hsb[1] == 0) return [br, br, br, a];
		
	var hue = hsb[0];
	var f = hue % 60;
	var p = Math.round((hsb[2] * (100 - hsb[1])) / 10000 * 255);
	var q = Math.round((hsb[2] * (6000 - hsb[1] * f)) / 600000 * 255);
	var t = Math.round((hsb[2] * (6000 - hsb[1] * (60 - f))) / 600000 * 255);

	switch (Math.floor(hue / 60)){
		case 0: return [br, t, p, a];
		case 1: return [q, br, p, a];
		case 2: return [p, br, t, a];
		case 3: return [p, q, br, a];
		case 4: return [t, p, br, a];
		default: return [br, p, q, a];
	}
};

Color.parseHSL = function(color){
	var hsb = map(color.match(listMatch).slice(1), function(bit, i){
		if (bit) bit = parseFloat(bit);
		if (i === 0) return Math.round(((bit %= 360) < 0) ? (bit + 360) : bit);
		else if (i < 3) return limit(Math.round(bit), 0, 100);
		else return limit(((bit === '') ? 1 : Number(bit)), 0, 1);
	});

	var h = hsb[0] / 60;
	var s = hsb[1] / 100;
	var l = hsb[2] / 100;
	var a = hsb[3];
	
	var c = (1 - Math.abs(2 * l - 1)) * s;
	var x = c * (1 - Math.abs(h % 2 - 1));
	var m = l - c / 2;
	
	var p = Math.round((c + m) * 255);
	var q = Math.round((x + m) * 255);
	var t = Math.round((m) * 255);

	switch (Math.floor(h)){
		case 0: return [p, q, t, a];
		case 1: return [q, p, t, a];
		case 2: return [t, p, q, a];
		case 3: return [t, q, p, a];
		case 4: return [q, t, p, a];
		default: return [p, t, q, a];
	}
};

var toString = function(type, array){
	if (array[3] != 1) type += 'a';
	else array.pop();
	return type + '(' + array.join(', ') + ')';
};

Color.prototype = {

	toHSB: function(array){
		var red = this.red, green = this.green, blue = this.blue, alpha = this.alpha;

		var max = Math.max(red, green, blue), min = Math.min(red, green, blue), delta = max - min;
		var hue = 0, saturation = (delta != 0) ? delta / max : 0, brightness = max / 255;
		if (saturation){
			var rr = (max - red) / delta, gr = (max - green) / delta, br = (max - blue) / delta;
			hue = (red == max) ? br - gr : (green == max) ? 2 + rr - br : 4 + gr - rr;
			if ((hue /= 6) < 0) hue++;
		}

		var hsb = [Math.round(hue * 360), Math.round(saturation * 100), Math.round(brightness * 100), alpha];

		return (array) ? hsb : toString('hsb', hsb);
	},

	toHSL: function(array){
		var red = this.red, green = this.green, blue = this.blue, alpha = this.alpha;

		var max = Math.max(red, green, blue), min = Math.min(red, green, blue), delta = max - min;
		var hue = 0, saturation = (delta != 0) ? delta / (255 - Math.abs((max + min) - 255)) : 0, lightness = (max + min) / 512;
		if (saturation){
			var rr = (max - red) / delta, gr = (max - green) / delta, br = (max - blue) / delta;
			hue = (red == max) ? br - gr : (green == max) ? 2 + rr - br : 4 + gr - rr;
			if ((hue /= 6) < 0) hue++;
		}

		var hsl = [Math.round(hue * 360), Math.round(saturation * 100), Math.round(lightness * 100), alpha];

		return (array) ? hsl : toString('hsl', hsl);
	},

	toHEX: function(array){

		var a = this.alpha;
		var alpha = ((a = Math.round((a * 255)).toString(16)).length == 1) ? a + a : a;
		
		var hex = map([this.red, this.green, this.blue], function(bit){
			bit = bit.toString(16);
			return (bit.length == 1) ? '0' + bit : bit;
		});
		
		return (array) ? hex.concat(alpha) : '#' + hex.join('') + ((alpha == 'ff') ? '' : alpha);
	},
	
	toRGB: function(array){
		var rgb = [this.red, this.green, this.blue, this.alpha];
		return (array) ? rgb : toString('rgb', rgb);
	}

};

Color.prototype.toString = Color.prototype.toRGB;

Color.hex = function(hex){
	return new Color(hex, 'hex');
};

if (this.hex == null) this.hex = Color.hex;

Color.hsb = function(h, s, b, a){
	return new Color([h || 0, s || 0, b || 0, (a == null) ? 1 : a], 'hsb');
};

if (this.hsb == null) this.hsb = Color.hsb;

Color.hsl = function(h, s, l, a){
	return new Color([h || 0, s || 0, l || 0, (a == null) ? 1 : a], 'hsl');
};

if (this.hsl == null) this.hsl = Color.hsl;

Color.rgb = function(r, g, b, a){
	return new Color([r || 0, g || 0, b || 0, (a == null) ? 1 : a], 'rgb');
};

if (this.rgb == null) this.rgb = Color.rgb;

Color.detach = function(color){
	color = new Color(color);
	return [Color.rgb(color.red, color.green, color.blue).toString(), color.alpha];
};

module.exports = Color;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);

module.exports = Class({

	// placement

	_resetPlacement: function(){
		var container = this.parentNode;
		if (container){
			var previous = this.previousSibling, next = this.nextSibling;
			if (previous){
				previous.nextSibling = next;
			} else {
				container.firstChild = next;
			}
			if (next){
				next.previousSibling = previous;
			} else {
				container.lastChild = this.previousSibling;
			}
		}
		this.previousSibling = null;
		this.nextSibling = null;
		this.parentNode = null;
		return this;
	},

	inject: function(container){
		this._resetPlacement();
		var last = container.lastChild;
		if (last){
			last.nextSibling = this;
			this.previousSibling = last;
		} else {
			container.firstChild = this;
		}
		container.lastChild = this;
		this.parentNode = container;
		this._place();
		return this;
	},

	injectBefore: function(sibling){
		this._resetPlacement();
		var container = sibling.parentNode;
		if (!container) return this;
		var previous = sibling.previousSibling;
		if (previous){
			previous.nextSibling = this;
			this.previousSibling = previous;
		} else {
			container.firstChild = this;
		}
		sibling.previousSibling = this;
		this.nextSibling = sibling;
		this.parentNode = container;
		this._place();
		return this;
	},

	eject: function(){
		this._resetPlacement();
		this._place();
		return this;
	},

	_place: function(){},

	// events

	dispatch: function(event){
		var events = this._events,
			listeners = events && events[event.type];
		if (listeners){
			listeners = listeners.slice(0);
			for (var i = 0, l = listeners.length; i < l; i++){
				var fn = listeners[i], result;
				if (typeof fn == 'function')
					result = fn.call(this, event);
				else
					result = fn.handleEvent(event);
				if (result === false) event.preventDefault();
			}
		}
		if (this.parentNode && this.parentNode.dispatch){
			this.parentNode.dispatch(event);
		}
	},

	subscribe: function(type, fn, bind){
		if (typeof type != 'string'){ // listen type / fn with object
			var subscriptions = [];
			for (var t in type) subscriptions.push(this.subscribe(t, type[t]));
			return function(){ // unsubscribe
				for (var i = 0, l = subscriptions.length; i < l; i++)
					subscriptions[i]();
				return this;
			};
		} else { // listen to one
			var bound = typeof fn === 'function' ? fn.bind(bind || this) : fn,
				events = this._events || (this._events = {}),
				listeners = events[type] || (events[type] = []);
			listeners.push(bound);
			return function(){
				// unsubscribe
				for (var i = 0, l = listeners.length; i < l; i++){
					if (listeners[i] === bound){
						listeners.splice(i, 1);
						break;
					}
				}
			}
		}
	}

});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Container = __webpack_require__(92);
var Element = __webpack_require__(189);
var DOM = __webpack_require__(93);

var precision = 100;

var VMLSurface = Class(Element, Container, {
	
	initialize: function VMLSurface(width, height, existingElement){
		this.element = existingElement || document.createElement('vml');
		this.containerElement = DOM.createElement('group');
		this.element.appendChild(this.containerElement);
		if (width != null && height != null) this.resize(width, height);
	},

	resize: function(width, height){
		this.width = width;
		this.height = height;
		
		var style = this.element.style;
		style.pixelWidth = width;
		style.pixelHeight = height;
		
		style = this.containerElement.style;
		style.width = width;
		style.height = height;
		
		var halfPixel = (0.5 * precision);
		
		this.containerElement.coordorigin = halfPixel + ',' + halfPixel;
		this.containerElement.coordsize = (width * precision) + ',' + (height * precision);

		return this;
	}
	
});

VMLSurface.tagName = 'av:vml';

module.exports = VMLSurface;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Transform = __webpack_require__(81);
var Color = __webpack_require__(300);
var Node = __webpack_require__(192);
var DOM = __webpack_require__(93);

var precision = 100;

var defaultBox = { left: 0, top: 0, width: 500, height: 500 };

module.exports = Class(Node, {

	element_initialize: Node.prototype.initialize,

	initialize: function(tag){
		this.element_initialize(tag);
		var element = this.element;
		
		var skew = this.skewElement = DOM.createElement('skew');
		skew.on = true;
		element.appendChild(skew);

		var fill = this.fillElement = DOM.createElement('fill');
		fill.on = false;
		element.appendChild(fill);
		
		var stroke = this.strokeElement = DOM.createElement('stroke');
		stroke.on = false;
		element.appendChild(stroke);
	},
	
	/* transform */
	
	_transform: function(){
		var container = this.parentNode;
		
		// Active Transformation Matrix
		var m = container ? new Transform(container._activeTransform).transform(this) : this;
		
		// Box in shape user space
		
		var box = this._boxCoords || this._size || defaultBox;
		
		var originX = box.left || 0,
			originY = box.top || 0,
			width = box.width || 1,
			height = box.height || 1;
				
		// Flipped
	    var flip = m.yx / m.xx > m.yy / m.xy;
		if (m.xx < 0 ? m.xy >= 0 : m.xy < 0) flip = !flip;
		flip = flip ? -1 : 1;
		
		m = new Transform().scale(flip, 1).transform(m);
		
		// Rotation is approximated based on the transform
		var rotation = Math.atan2(-m.xy, m.yy) * 180 / Math.PI;
		
		// Reverse the rotation, leaving the final transform in box space
		var rad = rotation * Math.PI / 180, sin = Math.sin(rad), cos = Math.cos(rad);
		
		var transform = new Transform(
			(m.xx * cos - m.xy * sin),
			(m.yx * cos - m.yy * sin) * flip,
			(m.xy * cos + m.xx * sin) * flip,
			(m.yy * cos + m.yx * sin)
		);

		var rotationTransform = new Transform().rotate(rotation, 0, 0);

		var shapeToBox = new Transform().rotate(-rotation, 0, 0).transform(m).moveTo(0,0);

		// Scale box after reversing rotation
		width *= Math.abs(shapeToBox.xx);
		height *= Math.abs(shapeToBox.yy);
		
		// Place box
		var left = m.x, top = m.y;
		
		// Compensate for offset by center origin rotation
		var vx = -width / 2, vy = -height / 2;
		var point = rotationTransform.point(vx, vy);
		left -= point.x - vx;
		top -= point.y - vy;
		
		// Adjust box position based on offset
		var rsm = new Transform(m).moveTo(0,0);
		point = rsm.point(originX, originY);
		left += point.x;
		top += point.y;
		
		if (flip < 0) left = -left - width;
		
		// Place transformation origin
		var point0 = rsm.point(-originX, -originY);
		var point1 = rotationTransform.point(width, height);
		var point2 = rotationTransform.point(width, 0);
		var point3 = rotationTransform.point(0, height);
		
		var minX = Math.min(0, point1.x, point2.x, point3.x),
		    maxX = Math.max(0, point1.x, point2.x, point3.x),
		    minY = Math.min(0, point1.y, point2.y, point3.y),
		    maxY = Math.max(0, point1.y, point2.y, point3.y);
		
		var transformOriginX = (point0.x - point1.x / 2) / (maxX - minX) * flip,
		    transformOriginY = (point0.y - point1.y / 2) / (maxY - minY);
		
		// Adjust the origin
		point = shapeToBox.point(originX, originY);
		originX = point.x;
		originY = point.y;
		
		// Scale stroke
		var strokeWidth = this._strokeWidth;
		if (strokeWidth){
			// Scale is the hypothenus between the two vectors
			// TODO: Use area calculation instead
			var vx = m.xx + m.xy, vy = m.yy + m.yx;
			strokeWidth *= Math.sqrt(vx * vx + vy * vy) / Math.sqrt(2);
		}
		
		// convert to multiplied precision space
		originX *= precision;
		originY *= precision;
		left *= precision;
		top *= precision;
		width *= precision;
		height *= precision;
		
		// Set box
		var element = this.element;
		element.coordorigin = originX + ',' + originY;
		element.coordsize = width + ',' + height;
		element.style.left = left + 'px';
		element.style.top = top + 'px';
		element.style.width = width;
		element.style.height = height;
		element.style.rotation = rotation.toFixed(8);
		element.style.flip = flip < 0 ? 'x' : '';
		
		// Set transform
		var skew = this.skewElement;
		skew.matrix = [transform.xx.toFixed(4), transform.xy.toFixed(4), transform.yx.toFixed(4), transform.yy.toFixed(4), 0, 0];
		skew.origin = transformOriginX + ',' + transformOriginY;

		// Set stroke
		this.strokeElement.weight = strokeWidth + 'px';
	},
	
	/* styles */

	_createGradient: function(style, stops){
		var fill = this.fillElement;

		// Temporarily eject the fill from the DOM
		this.element.removeChild(fill);

		fill.type = style;
		fill.method = 'none';
		fill.rotate = true;

		var colors = [], color1, color2;

		var addColor = function(offset, color){
			color = Color.detach(color);
			if (color1 == null) color1 = color2 = color;
			else color2 = color;
			colors.push(offset + ' ' + color[0]);
		};

		// Enumerate stops, assumes offsets are enumerated in order
		if ('length' in stops) for (var i = 0, l = stops.length - 1; i <= l; i++) addColor(i / l, stops[i]);
		else for (var offset in stops) addColor(offset, stops[offset]);
		
		fill.color = color1[0];
		fill.color2 = color2[0];
		
		//if (fill.colors) fill.colors.value = colors; else
		fill.colors = colors;

		// Opacity order gets flipped when color stops are specified
		fill.opacity = color2[1];
		fill['ao:opacity2'] = color1[1];

		fill.on = true;
		this.element.appendChild(fill);
		return fill;
	},
	
	_setColor: function(type, color){
		var element = type == 'fill' ? this.fillElement : this.strokeElement;
		if (color == null){
			element.on = false;
		} else {
			color = Color.detach(color);
			element.color = color[0];
			element.opacity = color[1];
			element.on = true;
		}
	},
	
	fill: function(color){
		if (arguments.length > 1){
			this.fillLinear(arguments);
		} else {
			this._boxCoords = defaultBox;
			var fill = this.fillElement;
			fill.type = 'solid';
			fill.color2 = '';
			fill['ao:opacity2'] = '';
			if (fill.colors) fill.colors.value = '';
			this._setColor('fill', color);
		}
		return this;
	},

	fillRadial: function(stops, focusX, focusY, radiusX, radiusY, centerX, centerY){
		var fill = this._createGradient('gradientradial', stops);
		if (focusX == null) focusX = this.left + this.width * 0.5;
		if (focusY == null) focusY = this.top + this.height * 0.5;
		if (radiusY == null) radiusY = radiusX || (this.height * 0.5);
		if (radiusX == null) radiusX = this.width * 0.5;
		if (centerX == null) centerX = focusX;
		if (centerY == null) centerY = focusY;
		
		centerX += centerX - focusX;
		centerY += centerY - focusY;
		
		var box = this._boxCoords = {
			left: centerX - radiusX * 2,
			top: centerY - radiusY * 2,
			width: radiusX * 4,
			height: radiusY * 4
		};
		focusX -= box.left;
		focusY -= box.top;
		focusX /= box.width;
		focusY /= box.height;

		fill.focussize = '0 0';
		fill.focusposition = focusX + ',' + focusY;
		fill.focus = '50%';
		
		this._transform();
		
		return this;
	},

	fillLinear: function(stops, x1, y1, x2, y2){
		var fill = this._createGradient('gradient', stops);
		fill.focus = '100%';
		if (arguments.length == 5){
			var w = Math.abs(x2 - x1), h = Math.abs(y2 - y1);
			this._boxCoords = {
				left: Math.min(x1, x2),
				top: Math.min(y1, y2),
				width: w < 1 ? h : w,
				height: h < 1 ? w : h
			};
			fill.angle = (360 + Math.atan2((x2 - x1) / h, (y2 - y1) / w) * 180 / Math.PI) % 360;
		} else {
			this._boxCoords = null;
			fill.angle = (x1 == null) ? 0 : (90 + x1) % 360;
		}
		this._transform();
		return this;
	},

	fillImage: function(url, width, height, left, top, color1, color2){
		var fill = this.fillElement;
		if (color1 != null){
			color1 = Color.detach(color1);
			if (color2 != null) color2 = Color.detach(color2);
			fill.type = 'pattern';
			fill.color = color1[0];
			fill.color2 = color2 == null ? color1[0] : color2[0];
			fill.opacity = color2 == null ? 0 : color2[1];
			fill['ao:opacity2'] = color1[1];
		} else {
			fill.type = 'tile';
			fill.color = '';
			fill.color2 = '';
			fill.opacity = 1;
			fill['ao:opacity2'] = 1;
		}
		if (fill.colors) fill.colors.value = '';
		fill.rotate = true;
		fill.src = url;
		
		fill.size = '1,1';
		fill.position = '0,0';
		fill.origin = '0,0';
		fill.aspect = 'ignore'; // ignore, atleast, atmost
		fill.on = true;

		if (!left) left = 0;
		if (!top) top = 0;
		this._boxCoords = width ? { left: left + 0.5, top: top + 0.5, width: width, height: height } : null;
		this._transform();
		return this;
	},

	/* stroke */
	
	stroke: function(color, width, cap, join){
		var stroke = this.strokeElement;
		this._strokeWidth = (width != null) ? width : 1;
		stroke.weight = (width != null) ? width + 'px' : 1;
		stroke.endcap = (cap != null) ? ((cap == 'butt') ? 'flat' : cap) : 'round';
		stroke.joinstyle = (join != null) ? join : 'round';

		this._setColor('stroke', color);
		return this;
	}

});

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Transform = __webpack_require__(81);
var Container = __webpack_require__(92);
var Node = __webpack_require__(192);

module.exports = Class(Node, Container, {
	
	element_initialize: Node.prototype.initialize,
	
	initialize: function(width, height){
		this.element_initialize('group');
		this.width = width;
		this.height = height;
	},

	_transform: function(){
		var element = this.element;
		element.coordorigin = '0,0';
		element.coordsize = '1000,1000';
		element.style.left = 0;
		element.style.top = 0;
		element.style.width = 1000;
		element.style.height = 1000;
		element.style.rotation = 0;
		
		var container = this.parentNode;
		this._activeTransform = container ? new Transform(container._activeTransform).transform(this) : this;
		var node = this.firstChild;
		while (node){
			node._transform();
			node = node.nextSibling;
		}
	}

});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_applyNativeMethods__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Touchable_ensurePositiveDelayProps__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Touchable__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TouchableWithoutFeedback__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__View__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */











var flattenStyle = __WEBPACK_IMPORTED_MODULE_5__StyleSheet__["a" /* default */].flatten;

var PRESS_RETENTION_OFFSET = { top: 20, left: 20, right: 20, bottom: 30 };

/**
 * A wrapper for making views respond properly to touches.
 * On press down, the opacity of the wrapped view is decreased, dimming it.
 *
 * Opacity is controlled by wrapping the children in a View, which is
 * added to the view hiearchy. Be aware that this can affect layout.
 *
 * Example:
 *
 * ```
 * renderButton: function() {
 *   return (
 *     <TouchableOpacity onPress={this._onPressButton}>
 *       <Image
 *         style={styles.button}
 *         source={require('./myButton.png')}
 *       />
 *     </TouchableOpacity>
 *   );
 * },
 * ```
 */

/* eslint-disable react/prefer-es6-class */
var TouchableOpacity = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'TouchableOpacity',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__Touchable__["a" /* default */].Mixin],

  propTypes: Object.assign({}, __WEBPACK_IMPORTED_MODULE_7__TouchableWithoutFeedback__["a" /* default */].propTypes, {
    /**
     * Determines what the opacity of the wrapped view should be when touch is
     * active.
     */
    activeOpacity: __WEBPACK_IMPORTED_MODULE_3_prop_types__["number"],
    focusedOpacity: __WEBPACK_IMPORTED_MODULE_3_prop_types__["number"]
  }),

  getDefaultProps: function getDefaultProps() {
    return {
      activeOpacity: 0.2,
      focusedOpacity: 0.7
    };
  },

  getInitialState: function getInitialState() {
    return this.touchableGetInitialState();
  },

  componentDidMount: function componentDidMount() {
    Object(__WEBPACK_IMPORTED_MODULE_2__Touchable_ensurePositiveDelayProps__["a" /* default */])(this.props);
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    Object(__WEBPACK_IMPORTED_MODULE_2__Touchable_ensurePositiveDelayProps__["a" /* default */])(nextProps);
  },

  /**
   * Animate the touchable to a new opacity.
   */
  setOpacityTo: function setOpacityTo(value, duration) {
    this.setNativeProps({
      style: {
        opacity: value,
        transitionDuration: duration ? duration / 1000 + 's' : '0s'
      }
    });
  },

  /**
   * `Touchable.Mixin` self callbacks. The mixin will invoke these if they are
   * defined on your component.
   */
  touchableHandleActivePressIn: function touchableHandleActivePressIn(e) {
    if (e.dispatchConfig.registrationName === 'onResponderGrant') {
      this._opacityActive(0);
    } else {
      this._opacityActive(150);
    }
    this.props.onPressIn && this.props.onPressIn(e);
  },

  touchableHandleActivePressOut: function touchableHandleActivePressOut(e) {
    this._opacityInactive(250);
    this.props.onPressOut && this.props.onPressOut(e);
  },

  touchableHandlePress: function touchableHandlePress(e) {
    this.props.onPress && this.props.onPress(e);
  },

  touchableHandleLongPress: function touchableHandleLongPress(e) {
    this.props.onLongPress && this.props.onLongPress(e);
  },

  touchableGetPressRectOffset: function touchableGetPressRectOffset() {
    return this.props.pressRetentionOffset || PRESS_RETENTION_OFFSET;
  },

  touchableGetHitSlop: function touchableGetHitSlop() {
    return this.props.hitSlop;
  },

  touchableGetHighlightDelayMS: function touchableGetHighlightDelayMS() {
    return this.props.delayPressIn || 0;
  },

  touchableGetLongPressDelayMS: function touchableGetLongPressDelayMS() {
    return this.props.delayLongPress === 0 ? 0 : this.props.delayLongPress || 500;
  },

  touchableGetPressOutDelayMS: function touchableGetPressOutDelayMS() {
    return this.props.delayPressOut;
  },

  _opacityActive: function _opacityActive(duration) {
    this.setOpacityTo(this.props.activeOpacity, duration);
  },

  _opacityInactive: function _opacityInactive(duration) {
    this.setOpacityTo(this._getChildStyleOpacityWithDefault(), duration);
  },

  _opacityFocused: function _opacityFocused() {
    this.setOpacityTo(this.props.focusedOpacity);
  },

  _getChildStyleOpacityWithDefault: function _getChildStyleOpacityWithDefault() {
    var childStyle = flattenStyle(this.props.style) || {};
    return childStyle.opacity === undefined ? 1 : childStyle.opacity;
  },

  render: function render() {
    var _props = this.props,
        activeOpacity = _props.activeOpacity,
        focusedOpacity = _props.focusedOpacity,
        delayLongPress = _props.delayLongPress,
        delayPressIn = _props.delayPressIn,
        delayPressOut = _props.delayPressOut,
        onLongPress = _props.onLongPress,
        onPress = _props.onPress,
        onPressIn = _props.onPressIn,
        onPressOut = _props.onPressOut,
        pressRetentionOffset = _props.pressRetentionOffset,
        other = _objectWithoutProperties(_props, ['activeOpacity', 'focusedOpacity', 'delayLongPress', 'delayPressIn', 'delayPressOut', 'onLongPress', 'onPress', 'onPressIn', 'onPressOut', 'pressRetentionOffset']);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__View__["a" /* default */],
      _extends({}, other, {
        accessible: this.props.accessible !== false,
        onKeyDown: this.touchableHandleKeyEvent,
        onKeyUp: this.touchableHandleKeyEvent,
        onResponderGrant: this.touchableHandleResponderGrant,
        onResponderMove: this.touchableHandleResponderMove,
        onResponderRelease: this.touchableHandleResponderRelease,
        onResponderTerminate: this.touchableHandleResponderTerminate,
        onResponderTerminationRequest: this.touchableHandleResponderTerminationRequest,
        onStartShouldSetResponder: this.touchableHandleStartShouldSetResponder,
        style: [styles.root, !this.props.disabled && styles.actionable, this.props.style]
      }),
      this.props.children,
      __WEBPACK_IMPORTED_MODULE_6__Touchable__["a" /* default */].renderDebugView({ color: 'blue', hitSlop: this.props.hitSlop })
    );
  }
});

var styles = __WEBPACK_IMPORTED_MODULE_5__StyleSheet__["a" /* default */].create({
  root: {
    transitionProperty: 'opacity',
    transitionDuration: '0.15s',
    userSelect: 'none'
  },
  actionable: {
    cursor: 'pointer',
    touchAction: 'manipulation'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__modules_applyNativeMethods__["a" /* default */])(TouchableOpacity));

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__);
/* eslint-disable */

/**
 * Copyright 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * From React 16.0.0
 */



var twoArgumentPooler = function twoArgumentPooler(a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var standardReleaser = function standardReleaser(instance) {
  var Klass = this;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = twoArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  twoArgumentPooler: twoArgumentPooler
};

/* harmony default export */ __webpack_exports__["a"] = (PooledClass);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exports_View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VirtualizedList__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 * @format
 */








var defaultProps = Object.assign({}, __WEBPACK_IMPORTED_MODULE_3__VirtualizedList__["a" /* default */].defaultProps, {
  numColumns: 1
});

/**
 * A performant interface for rendering simple, flat lists, supporting the most handy features:
 *
 *  - Fully cross-platform.
 *  - Optional horizontal mode.
 *  - Configurable viewability callbacks.
 *  - Header support.
 *  - Footer support.
 *  - Separator support.
 *  - Pull to Refresh.
 *  - Scroll loading.
 *  - ScrollToIndex support.
 *
 * If you need section support, use [`<SectionList>`](docs/sectionlist.html).
 *
 * Minimal Example:
 *
 *     <FlatList
 *       data={[{key: 'a'}, {key: 'b'}]}
 *       renderItem={({item}) => <Text>{item.key}</Text>}
 *     />
 *
 * More complex, multi-select example demonstrating `PureComponent` usage for perf optimization and avoiding bugs.
 *
 * - By binding the `onPressItem` handler, the props will remain `===` and `PureComponent` will
 *   prevent wasteful re-renders unless the actual `id`, `selected`, or `title` props change, even
 *   if the components rendered in `MyListItem` did not have such optimizations.
 * - By passing `extraData={this.state}` to `FlatList` we make sure `FlatList` itself will re-render
 *   when the `state.selected` changes. Without setting this prop, `FlatList` would not know it
 *   needs to re-render any items because it is also a `PureComponent` and the prop comparison will
 *   not show any changes.
 * - `keyExtractor` tells the list to use the `id`s for the react keys instead of the default `key` property.
 *
 *
 *     class MyListItem extends React.PureComponent {
 *       _onPress = () => {
 *         this.props.onPressItem(this.props.id);
 *       };
 *
 *       render() {
 *         const textColor = this.props.selected ? "red" : "black";
 *         return (
 *           <TouchableOpacity onPress={this._onPress}>
 *             <View>
 *               <Text style={{ color: textColor }}>
 *                 {this.props.title}
 *               </Text>
 *             </View>
 *           </TouchableOpacity>
 *         );
 *       }
 *     }
 *
 *     class MultiSelectList extends React.PureComponent {
 *       state = {selected: (new Map(): Map<string, boolean>)};
 *
 *       _keyExtractor = (item, index) => item.id;
 *
 *       _onPressItem = (id: string) => {
 *         // updater functions are preferred for transactional updates
 *         this.setState((state) => {
 *           // copy the map rather than modifying state.
 *           const selected = new Map(state.selected);
 *           selected.set(id, !selected.get(id)); // toggle
 *           return {selected};
 *         });
 *       };
 *
 *       _renderItem = ({item}) => (
 *         <MyListItem
 *           id={item.id}
 *           onPressItem={this._onPressItem}
 *           selected={!!this.state.selected.get(item.id)}
 *           title={item.title}
 *         />
 *       );
 *
 *       render() {
 *         return (
 *           <FlatList
 *             data={this.props.data}
 *             extraData={this.state}
 *             keyExtractor={this._keyExtractor}
 *             renderItem={this._renderItem}
 *           />
 *         );
 *       }
 *     }
 *
 * This is a convenience wrapper around [`<VirtualizedList>`](docs/virtualizedlist.html),
 * and thus inherits its props (as well as those of `ScrollView`) that aren't explicitly listed
 * here, along with the following caveats:
 *
 * - Internal state is not preserved when content scrolls out of the render window. Make sure all
 *   your data is captured in the item data or external stores like Flux, Redux, or Relay.
 * - This is a `PureComponent` which means that it will not re-render if `props` remain shallow-
 *   equal. Make sure that everything your `renderItem` function depends on is passed as a prop
 *   (e.g. `extraData`) that is not `===` after updates, otherwise your UI may not update on
 *   changes. This includes the `data` prop and parent component state.
 * - In order to constrain memory and enable smooth scrolling, content is rendered asynchronously
 *   offscreen. This means it's possible to scroll faster than the fill rate ands momentarily see
 *   blank content. This is a tradeoff that can be adjusted to suit the needs of each application,
 *   and we are working on improving it behind the scenes.
 * - By default, the list looks for a `key` prop on each item and uses that for the React key.
 *   Alternatively, you can provide a custom `keyExtractor` prop.
 *
 * Also inherits [ScrollView Props](docs/scrollview.html#props), unless it is nested in another FlatList of same orientation.
 */
var FlatList = function (_React$PureComponent) {
  _inherits(FlatList, _React$PureComponent);

  /**
   * Scrolls to the end of the content. May be janky without `getItemLayout` prop.
   */
  FlatList.prototype.scrollToEnd = function scrollToEnd(params) {
    if (this._listRef) {
      this._listRef.scrollToEnd(params);
    }
  };

  /**
   * Scrolls to the item at the specified index such that it is positioned in the viewable area
   * such that `viewPosition` 0 places it at the top, 1 at the bottom, and 0.5 centered in the
   * middle. `viewOffset` is a fixed number of pixels to offset the final target position.
   *
   * Note: cannot scroll to locations outside the render window without specifying the
   * `getItemLayout` prop.
   */


  FlatList.prototype.scrollToIndex = function scrollToIndex(params) {
    if (this._listRef) {
      this._listRef.scrollToIndex(params);
    }
  };

  /**
   * Requires linear scan through data - use `scrollToIndex` instead if possible.
   *
   * Note: cannot scroll to locations outside the render window without specifying the
   * `getItemLayout` prop.
   */


  FlatList.prototype.scrollToItem = function scrollToItem(params) {
    if (this._listRef) {
      this._listRef.scrollToItem(params);
    }
  };

  /**
   * Scroll to a specific content pixel offset in the list.
   *
   * Check out [scrollToOffset](docs/virtualizedlist.html#scrolltooffset) of VirtualizedList
   */


  FlatList.prototype.scrollToOffset = function scrollToOffset(params) {
    if (this._listRef) {
      this._listRef.scrollToOffset(params);
    }
  };

  /**
   * Tells the list an interaction has occurred, which should trigger viewability calculations, e.g.
   * if `waitForInteractions` is true and the user has not scrolled. This is typically called by
   * taps on items or by navigation actions.
   */


  FlatList.prototype.recordInteraction = function recordInteraction() {
    if (this._listRef) {
      this._listRef.recordInteraction();
    }
  };

  /**
   * Displays the scroll indicators momentarily.
   *
   * @platform ios
   */


  FlatList.prototype.flashScrollIndicators = function flashScrollIndicators() {
    if (this._listRef) {
      this._listRef.flashScrollIndicators();
    }
  };

  /**
   * Provides a handle to the underlying scroll responder.
   */


  FlatList.prototype.getScrollResponder = function getScrollResponder() {
    if (this._listRef) {
      return this._listRef.getScrollResponder();
    }
  };

  FlatList.prototype.getScrollableNode = function getScrollableNode() {
    if (this._listRef) {
      return this._listRef.getScrollableNode();
    }
  };

  FlatList.prototype.setNativeProps = function setNativeProps(props) {
    if (this._listRef) {
      this._listRef.setNativeProps(props);
    }
  };

  FlatList.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
    this._checkProps(this.props);
  };

  FlatList.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(nextProps.numColumns === this.props.numColumns, 'Changing numColumns on the fly is not supported. Change the key prop on FlatList when ' + 'changing the number of columns to force a fresh render of the component.');
    __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(nextProps.onViewableItemsChanged === this.props.onViewableItemsChanged, 'Changing onViewableItemsChanged on the fly is not supported');
    __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(nextProps.viewabilityConfig === this.props.viewabilityConfig, 'Changing viewabilityConfig on the fly is not supported');
    __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(nextProps.viewabilityConfigCallbackPairs === this.props.viewabilityConfigCallbackPairs, 'Changing viewabilityConfigCallbackPairs on the fly is not supported');

    this._checkProps(nextProps);
  };

  function FlatList(props) {
    _classCallCheck(this, FlatList);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this._hasWarnedLegacy = false;
    _this._virtualizedListPairs = [];

    _this._captureRef = function (ref) {
      _this._listRef = ref;
    };

    _this._getItem = function (data, index) {
      var numColumns = _this.props.numColumns;

      if (numColumns > 1) {
        var ret = [];
        for (var kk = 0; kk < numColumns; kk++) {
          var _item = data[index * numColumns + kk];
          _item && ret.push(_item);
        }
        return ret;
      } else {
        return data[index];
      }
    };

    _this._getItemCount = function (data) {
      return data ? Math.ceil(data.length / _this.props.numColumns) : 0;
    };

    _this._keyExtractor = function (items, index) {
      var _this$props = _this.props,
          keyExtractor = _this$props.keyExtractor,
          numColumns = _this$props.numColumns;

      if (numColumns > 1) {
        __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(Array.isArray(items), 'FlatList: Encountered internal consistency error, expected each item to consist of an ' + 'array with 1-%s columns; instead, received a single item.', numColumns);
        return items.map(function (it, kk) {
          return keyExtractor(it, index * numColumns + kk);
        }).join(':');
      } else {
        /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
         * error found when Flow v0.63 was deployed. To see the error delete this
         * comment and run Flow. */
        return keyExtractor(items, index);
      }
    };

    _this._renderItem = function (info) {
      var _this$props2 = _this.props,
          renderItem = _this$props2.renderItem,
          numColumns = _this$props2.numColumns,
          columnWrapperStyle = _this$props2.columnWrapperStyle;

      if (numColumns > 1) {
        var _item2 = info.item,
            _index = info.index;

        __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(Array.isArray(_item2), 'Expected array of items with numColumns > 1');
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__exports_View__["a" /* default */],
          { style: [{ flexDirection: 'row' }, columnWrapperStyle] },
          _item2.map(function (it, kk) {
            var element = renderItem({
              item: it,
              index: _index * numColumns + kk,
              separators: info.separators
            });
            return element && __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(element, { key: kk });
          })
        );
      } else {
        return renderItem(info);
      }
    };

    if (_this.props.viewabilityConfigCallbackPairs) {
      _this._virtualizedListPairs = _this.props.viewabilityConfigCallbackPairs.map(function (pair) {
        return {
          viewabilityConfig: pair.viewabilityConfig,
          onViewableItemsChanged: _this._createOnViewableItemsChanged(pair.onViewableItemsChanged)
        };
      });
    } else if (_this.props.onViewableItemsChanged) {
      /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
       * error found when Flow v0.63 was deployed. To see the error delete this
       * comment and run Flow. */
      _this._virtualizedListPairs.push({
        viewabilityConfig: _this.props.viewabilityConfig,
        onViewableItemsChanged: _this._createOnViewableItemsChanged(_this.props.onViewableItemsChanged)
      });
    }
    return _this;
  }

  FlatList.prototype._checkProps = function _checkProps(props) {
    var getItem = props.getItem,
        getItemCount = props.getItemCount,
        horizontal = props.horizontal,
        legacyImplementation = props.legacyImplementation,
        numColumns = props.numColumns,
        columnWrapperStyle = props.columnWrapperStyle,
        onViewableItemsChanged = props.onViewableItemsChanged,
        viewabilityConfigCallbackPairs = props.viewabilityConfigCallbackPairs;

    __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(!getItem && !getItemCount, 'FlatList does not support custom data formats.');
    if (numColumns > 1) {
      __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(!horizontal, 'numColumns does not support horizontal.');
    } else {
      __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(!columnWrapperStyle, 'columnWrapperStyle not supported for single column lists');
    }
    if (legacyImplementation) {
      __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(numColumns === 1, 'Legacy list does not support multiple columns.');
      // Warning: may not have full feature parity and is meant more for debugging and performance
      // comparison.
      if (!this._hasWarnedLegacy) {
        console.warn('FlatList: Using legacyImplementation - some features not supported and performance ' + 'may suffer');
        this._hasWarnedLegacy = true;
      }
    }
    __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(!(onViewableItemsChanged && viewabilityConfigCallbackPairs), 'FlatList does not support setting both onViewableItemsChanged and ' + 'viewabilityConfigCallbackPairs.');
  };

  FlatList.prototype._pushMultiColumnViewable = function _pushMultiColumnViewable(arr, v) {
    var _props = this.props,
        numColumns = _props.numColumns,
        keyExtractor = _props.keyExtractor;

    v.item.forEach(function (item, ii) {
      __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(v.index != null, 'Missing index!');
      var index = v.index * numColumns + ii;
      arr.push(Object.assign({}, v, { item: item, key: keyExtractor(item, index), index: index }));
    });
  };

  FlatList.prototype._createOnViewableItemsChanged = function _createOnViewableItemsChanged(onViewableItemsChanged) {
    var _this2 = this;

    return function (info) {
      var numColumns = _this2.props.numColumns;

      if (onViewableItemsChanged) {
        if (numColumns > 1) {
          var _changed = [];
          var _viewableItems = [];
          info.viewableItems.forEach(function (v) {
            return _this2._pushMultiColumnViewable(_viewableItems, v);
          });
          info.changed.forEach(function (v) {
            return _this2._pushMultiColumnViewable(_changed, v);
          });
          onViewableItemsChanged({ viewableItems: _viewableItems, changed: _changed });
        } else {
          onViewableItemsChanged(info);
        }
      }
    };
  };

  FlatList.prototype.render = function render() {
    if (this.props.legacyImplementation) {
      return (
        /* $FlowFixMe(>=0.66.0 site=react_native_fb) This comment suppresses an
         * error found when Flow v0.66 was deployed. To see the error delete
         * this comment and run Flow. */
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */], _extends({}, this.props, {
          /* $FlowFixMe(>=0.66.0 site=react_native_fb) This comment suppresses
           * an error found when Flow v0.66 was deployed. To see the error
           * delete this comment and run Flow. */
          items: this.props.data,
          ref: this._captureRef
        }))
      );
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__VirtualizedList__["a" /* default */], _extends({}, this.props, {
        renderItem: this._renderItem,
        getItem: this._getItem,
        getItemCount: this._getItemCount,
        keyExtractor: this._keyExtractor,
        ref: this._captureRef,
        viewabilityConfigCallbackPairs: this._virtualizedListPairs
      }));
    }
  };

  return FlatList;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);

FlatList.defaultProps = defaultProps;


/* harmony default export */ __webpack_exports__["a"] = (FlatList);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColorPropType__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ViewPropTypes__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2017-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */







var RefreshControl = function (_Component) {
  _inherits(RefreshControl, _Component);

  function RefreshControl() {
    _classCallCheck(this, RefreshControl);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  RefreshControl.prototype.render = function render() {
    var _props = this.props,
        colors = _props.colors,
        enabled = _props.enabled,
        onRefresh = _props.onRefresh,
        progressBackgroundColor = _props.progressBackgroundColor,
        progressViewOffset = _props.progressViewOffset,
        refreshing = _props.refreshing,
        size = _props.size,
        tintColor = _props.tintColor,
        title = _props.title,
        titleColor = _props.titleColor,
        rest = _objectWithoutProperties(_props, ['colors', 'enabled', 'onRefresh', 'progressBackgroundColor', 'progressViewOffset', 'refreshing', 'size', 'tintColor', 'title', 'titleColor']);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__View__["a" /* default */], rest);
  };

  return RefreshControl;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

RefreshControl.propTypes =  false ? Object.assign({}, ViewPropTypes, {
  colors: arrayOf(ColorPropType),
  enabled: bool,
  onRefresh: func,
  progressBackgroundColor: ColorPropType,
  progressViewOffset: number,
  refreshing: bool.isRequired,
  size: oneOf([0, 1]),
  tintColor: ColorPropType,
  title: string,
  titleColor: ColorPropType
}) : {};


/* harmony default export */ __webpack_exports__["a"] = (RefreshControl);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ensureComponentIsNative = function ensureComponentIsNative(component) {
  __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(component && typeof component.setNativeProps === 'function', 'Touchable child must either be native or forward setNativeProps to a native component');
};

/* harmony default export */ __webpack_exports__["a"] = (ensureComponentIsNative);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListViewDataSource__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports_Platform__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__exports_findNodeHandle__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exports_NativeModules__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__exports_ScrollView__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_ScrollResponder__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StaticRenderer__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_timer_mixin__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_timer_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_timer_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__exports_View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cloneReferencedElement__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_create_react_class__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__isEmpty__ = __webpack_require__(312);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule ListView
 * 
 * @format
 */


function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

















var merge = function merge() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return Object.assign.apply(Object, [{}].concat(args));
};
var RCTScrollViewManager = __WEBPACK_IMPORTED_MODULE_5__exports_NativeModules__["a" /* default */].ScrollViewManager;

var DEFAULT_PAGE_SIZE = 1;
var DEFAULT_INITIAL_ROWS = 10;
var DEFAULT_SCROLL_RENDER_AHEAD = 1000;
var DEFAULT_END_REACHED_THRESHOLD = 1000;
var DEFAULT_SCROLL_CALLBACK_THROTTLE = 50;

/**
 * DEPRECATED - use one of the new list components, such as [`FlatList`](docs/flatlist.html)
 * or [`SectionList`](docs/sectionlist.html) for bounded memory use, fewer bugs,
 * better performance, an easier to use API, and more features. Check out this
 * [blog post](https://facebook.github.io/react-native/blog/2017/03/13/better-list-views.html)
 * for more details.
 *
 * ListView - A core component designed for efficient display of vertically
 * scrolling lists of changing data. The minimal API is to create a
 * [`ListView.DataSource`](docs/listviewdatasource.html), populate it with a simple
 * array of data blobs, and instantiate a `ListView` component with that data
 * source and a `renderRow` callback which takes a blob from the data array and
 * returns a renderable component.
 *
 * Minimal example:
 *
 * ```
 * class MyComponent extends Component {
 *   constructor() {
 *     super();
 *     const ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
 *     this.state = {
 *       dataSource: ds.cloneWithRows(['row 1', 'row 2']),
 *     };
 *   }
 *
 *   render() {
 *     return (
 *       <ListView
 *         dataSource={this.state.dataSource}
 *         renderRow={(rowData) => <Text>{rowData}</Text>}
 *       />
 *     );
 *   }
 * }
 * ```
 *
 * ListView also supports more advanced features, including sections with sticky
 * section headers, header and footer support, callbacks on reaching the end of
 * the available data (`onEndReached`) and on the set of rows that are visible
 * in the device viewport change (`onChangeVisibleRows`), and several
 * performance optimizations.
 *
 * There are a few performance operations designed to make ListView scroll
 * smoothly while dynamically loading potentially very large (or conceptually
 * infinite) data sets:
 *
 *  * Only re-render changed rows - the rowHasChanged function provided to the
 *    data source tells the ListView if it needs to re-render a row because the
 *    source data has changed - see ListViewDataSource for more details.
 *
 *  * Rate-limited row rendering - By default, only one row is rendered per
 *    event-loop (customizable with the `pageSize` prop). This breaks up the
 *    work into smaller chunks to reduce the chance of dropping frames while
 *    rendering rows.
 */

var ListView = __WEBPACK_IMPORTED_MODULE_12_create_react_class___default()({
  displayName: 'ListView',
  _childFrames: [],
  _sentEndForContentLength: null,
  _scrollComponent: null,
  _prevRenderedRowsCount: 0,
  _visibleRows: {},
  scrollProperties: {},

  mixins: [__WEBPACK_IMPORTED_MODULE_7__modules_ScrollResponder__["a" /* default */].Mixin, __WEBPACK_IMPORTED_MODULE_9_react_timer_mixin___default.a],

  statics: {
    DataSource: __WEBPACK_IMPORTED_MODULE_0__ListViewDataSource__["a" /* default */]
  },

  /**
   * You must provide a renderRow function. If you omit any of the other render
   * functions, ListView will simply skip rendering them.
   *
   * - renderRow(rowData, sectionID, rowID, highlightRow);
   * - renderSectionHeader(sectionData, sectionID);
   */
  propTypes: Object.assign({}, __WEBPACK_IMPORTED_MODULE_6__exports_ScrollView__["a" /* default */].propTypes, {
    /**
     * An instance of [ListView.DataSource](docs/listviewdatasource.html) to use
     */
    dataSource: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_0__ListViewDataSource__["a" /* default */]).isRequired,
    /**
     * (sectionID, rowID, adjacentRowHighlighted) => renderable
     *
     * If provided, a renderable component to be rendered as the separator
     * below each row but not the last row if there is a section header below.
     * Take a sectionID and rowID of the row above and whether its adjacent row
     * is highlighted.
     */
    renderSeparator: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    /**
     * (rowData, sectionID, rowID, highlightRow) => renderable
     *
     * Takes a data entry from the data source and its ids and should return
     * a renderable component to be rendered as the row. By default the data
     * is exactly what was put into the data source, but it's also possible to
     * provide custom extractors. ListView can be notified when a row is
     * being highlighted by calling `highlightRow(sectionID, rowID)`. This
     * sets a boolean value of adjacentRowHighlighted in renderSeparator, allowing you
     * to control the separators above and below the highlighted row. The highlighted
     * state of a row can be reset by calling highlightRow(null).
     */
    renderRow: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    /**
     * How many rows to render on initial component mount. Use this to make
     * it so that the first screen worth of data appears at one time instead of
     * over the course of multiple frames.
     */
    initialListSize: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    /**
     * Called when all rows have been rendered and the list has been scrolled
     * to within onEndReachedThreshold of the bottom. The native scroll
     * event is provided.
     */
    onEndReached: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    /**
     * Threshold in pixels (virtual, not physical) for calling onEndReached.
     */
    onEndReachedThreshold: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    /**
     * Number of rows to render per event loop. Note: if your 'rows' are actually
     * cells, i.e. they don't span the full width of your view (as in the
     * ListViewGridLayoutExample), you should set the pageSize to be a multiple
     * of the number of cells per row, otherwise you're likely to see gaps at
     * the edge of the ListView as new pages are loaded.
     */
    pageSize: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    /**
     * () => renderable
     *
     * The header and footer are always rendered (if these props are provided)
     * on every render pass. If they are expensive to re-render, wrap them
     * in StaticContainer or other mechanism as appropriate. Footer is always
     * at the bottom of the list, and header at the top, on every render pass.
     * In a horizontal ListView, the header is rendered on the left and the
     * footer on the right.
     */
    renderFooter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    renderHeader: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    /**
     * (sectionData, sectionID) => renderable
     *
     * If provided, a header is rendered for this section.
     */
    renderSectionHeader: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    /**
     * (props) => renderable
     *
     * A function that returns the scrollable component in which the list rows
     * are rendered. Defaults to returning a ScrollView with the given props.
     */
    renderScrollComponent: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    /**
     * How early to start rendering rows before they come on screen, in
     * pixels.
     */
    scrollRenderAheadDistance: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    /**
     * (visibleRows, changedRows) => void
     *
     * Called when the set of visible rows changes. `visibleRows` maps
     * { sectionID: { rowID: true }} for all the visible rows, and
     * `changedRows` maps { sectionID: { rowID: true | false }} for the rows
     * that have changed their visibility, with true indicating visible, and
     * false indicating the view has moved out of view.
     */
    onChangeVisibleRows: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    /**
     * A performance optimization for improving scroll perf of
     * large lists, used in conjunction with overflow: 'hidden' on the row
     * containers. This is enabled by default.
     */
    removeClippedSubviews: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    /**
     * Makes the sections headers sticky. The sticky behavior means that it
     * will scroll with the content at the top of the section until it reaches
     * the top of the screen, at which point it will stick to the top until it
     * is pushed off the screen by the next section header. This property is
     * not supported in conjunction with `horizontal={true}`. Only enabled by
     * default on iOS because of typical platform standards.
     */
    stickySectionHeadersEnabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    /**
     * An array of child indices determining which children get docked to the
     * top of the screen when scrolling. For example, passing
     * `stickyHeaderIndices={[0]}` will cause the first child to be fixed to the
     * top of the scroll view. This property is not supported in conjunction
     * with `horizontal={true}`.
     */
    stickyHeaderIndices: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number).isRequired,
    /**
     * Flag indicating whether empty section headers should be rendered. In the future release
     * empty section headers will be rendered by default, and the flag will be deprecated.
     * If empty sections are not desired to be rendered their indices should be excluded from sectionID object.
     */
    enableEmptySections: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
  }),

  /**
   * Exports some data, e.g. for perf investigations or analytics.
   */
  getMetrics: function getMetrics() {
    return {
      contentLength: this.scrollProperties.contentLength,
      totalRows: this.props.enableEmptySections ? this.props.dataSource.getRowAndSectionCount() : this.props.dataSource.getRowCount(),
      renderedRows: this.state.curRenderedRowsCount,
      visibleRows: Object.keys(this._visibleRows).length
    };
  },

  /**
   * Provides a handle to the underlying scroll responder.
   * Note that `this._scrollComponent` might not be a `ScrollView`, so we
   * need to check that it responds to `getScrollResponder` before calling it.
   */
  getScrollResponder: function getScrollResponder() {
    if (this._scrollComponent && this._scrollComponent.getScrollResponder) {
      return this._scrollComponent.getScrollResponder();
    }
  },

  getScrollableNode: function getScrollableNode() {
    if (this._scrollComponent && this._scrollComponent.getScrollableNode) {
      return this._scrollComponent.getScrollableNode();
    } else {
      return Object(__WEBPACK_IMPORTED_MODULE_4__exports_findNodeHandle__["a" /* default */])(this._scrollComponent);
    }
  },

  /**
   * Scrolls to a given x, y offset, either immediately or with a smooth animation.
   *
   * See `ScrollView#scrollTo`.
   */
  scrollTo: function scrollTo() {
    if (this._scrollComponent && this._scrollComponent.scrollTo) {
      var _scrollComponent;

      (_scrollComponent = this._scrollComponent).scrollTo.apply(_scrollComponent, arguments);
    }
  },

  /**
   * If this is a vertical ListView scrolls to the bottom.
   * If this is a horizontal ListView scrolls to the right.
   *
   * Use `scrollToEnd({animated: true})` for smooth animated scrolling,
   * `scrollToEnd({animated: false})` for immediate scrolling.
   * If no options are passed, `animated` defaults to true.
   *
   * See `ScrollView#scrollToEnd`.
   */
  scrollToEnd: function scrollToEnd(options) {
    if (this._scrollComponent) {
      if (this._scrollComponent.scrollToEnd) {
        this._scrollComponent.scrollToEnd(options);
      } else {
        console.warn('The scroll component used by the ListView does not support ' + 'scrollToEnd. Check the renderScrollComponent prop of your ListView.');
      }
    }
  },

  /**
   * Displays the scroll indicators momentarily.
   *
   * @platform ios
   */
  flashScrollIndicators: function flashScrollIndicators() {
    if (this._scrollComponent && this._scrollComponent.flashScrollIndicators) {
      this._scrollComponent.flashScrollIndicators();
    }
  },

  setNativeProps: function setNativeProps(props) {
    if (this._scrollComponent) {
      this._scrollComponent.setNativeProps(props);
    }
  },

  /**
   * React life cycle hooks.
   */

  getDefaultProps: function getDefaultProps() {
    return {
      initialListSize: DEFAULT_INITIAL_ROWS,
      pageSize: DEFAULT_PAGE_SIZE,
      renderScrollComponent: function renderScrollComponent(props) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__exports_ScrollView__["a" /* default */], props);
      },
      scrollRenderAheadDistance: DEFAULT_SCROLL_RENDER_AHEAD,
      onEndReachedThreshold: DEFAULT_END_REACHED_THRESHOLD,
      stickySectionHeadersEnabled: __WEBPACK_IMPORTED_MODULE_1__exports_Platform__["a" /* default */].OS === 'ios' || __WEBPACK_IMPORTED_MODULE_1__exports_Platform__["a" /* default */].OS === 'web',
      stickyHeaderIndices: []
    };
  },

  getInitialState: function getInitialState() {
    return {
      curRenderedRowsCount: this.props.initialListSize,
      highlightedRow: {}
    };
  },

  getInnerViewNode: function getInnerViewNode() {
    return this._scrollComponent.getInnerViewNode();
  },

  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    // this data should never trigger a render pass, so don't put in state
    this.scrollProperties = {
      visibleLength: null,
      contentLength: null,
      offset: 0
    };
    this._childFrames = [];
    this._visibleRows = {};
    this._prevRenderedRowsCount = 0;
    this._sentEndForContentLength = null;
  },

  componentDidMount: function componentDidMount() {
    var _this = this;

    // do this in animation frame until componentDidMount actually runs after
    // the component is laid out
    this.requestAnimationFrame(function () {
      _this._measureAndUpdateScrollProps();
    });
  },

  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var _this2 = this;

    if (this.props.dataSource !== nextProps.dataSource || this.props.initialListSize !== nextProps.initialListSize) {
      this.setState(function (state, props) {
        _this2._prevRenderedRowsCount = 0;
        return {
          curRenderedRowsCount: Math.min(Math.max(state.curRenderedRowsCount, props.initialListSize), props.enableEmptySections ? props.dataSource.getRowAndSectionCount() : props.dataSource.getRowCount())
        };
      }, function () {
        return _this2._renderMoreRowsIfNeeded();
      });
    }
  },

  componentDidUpdate: function componentDidUpdate() {
    var _this3 = this;

    this.requestAnimationFrame(function () {
      _this3._measureAndUpdateScrollProps();
    });
  },

  _onRowHighlighted: function _onRowHighlighted(sectionID, rowID) {
    this.setState({ highlightedRow: { sectionID: sectionID, rowID: rowID } });
  },

  render: function render() {
    var bodyComponents = [];

    var dataSource = this.props.dataSource;
    var allRowIDs = dataSource.rowIdentities;
    var rowCount = 0;
    var stickySectionHeaderIndices = [];

    var renderSectionHeader = this.props.renderSectionHeader;


    var header = this.props.renderHeader && this.props.renderHeader();
    var footer = this.props.renderFooter && this.props.renderFooter();
    var totalIndex = header ? 1 : 0;

    for (var sectionIdx = 0; sectionIdx < allRowIDs.length; sectionIdx++) {
      var sectionID = dataSource.sectionIdentities[sectionIdx];
      var rowIDs = allRowIDs[sectionIdx];
      if (rowIDs.length === 0) {
        if (this.props.enableEmptySections === undefined) {
          /* $FlowFixMe(>=0.54.0 site=react_native_oss) This comment suppresses
           * an error found when Flow v0.54 was deployed. To see the error
           * delete this comment and run Flow. */
          var warning = __webpack_require__(79);
          warning(false, 'In next release empty section headers will be rendered.' + " In this release you can use 'enableEmptySections' flag to render empty section headers.");
          continue;
        } else {
          var invariant = __webpack_require__(4);
          invariant(this.props.enableEmptySections, "In next release 'enableEmptySections' flag will be deprecated, empty section headers will always be rendered." + ' If empty section headers are not desirable their indices should be excluded from sectionIDs object.' + " In this release 'enableEmptySections' may only have value 'true' to allow empty section headers rendering.");
        }
      }

      if (renderSectionHeader) {
        var element = renderSectionHeader(dataSource.getSectionHeaderData(sectionIdx), sectionID);
        if (element) {
          bodyComponents.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(element, { key: 's_' + sectionID }));
          if (this.props.stickySectionHeadersEnabled) {
            stickySectionHeaderIndices.push(totalIndex);
          }
          totalIndex++;
        }
      }

      for (var rowIdx = 0; rowIdx < rowIDs.length; rowIdx++) {
        var rowID = rowIDs[rowIdx];
        var comboID = sectionID + '_' + rowID;
        var shouldUpdateRow = rowCount >= this._prevRenderedRowsCount && dataSource.rowShouldUpdate(sectionIdx, rowIdx);
        var row = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StaticRenderer__["a" /* default */], {
          key: 'r_' + comboID,
          shouldUpdate: !!shouldUpdateRow,
          render: this.props.renderRow.bind(null, dataSource.getRowData(sectionIdx, rowIdx), sectionID, rowID, this._onRowHighlighted)
        });
        bodyComponents.push(row);
        totalIndex++;

        if (this.props.renderSeparator && (rowIdx !== rowIDs.length - 1 || sectionIdx === allRowIDs.length - 1)) {
          var adjacentRowHighlighted = this.state.highlightedRow.sectionID === sectionID && (this.state.highlightedRow.rowID === rowID || this.state.highlightedRow.rowID === rowIDs[rowIdx + 1]);
          var separator = this.props.renderSeparator(sectionID, rowID, adjacentRowHighlighted);
          if (separator) {
            bodyComponents.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__exports_View__["a" /* default */],
              { key: 's_' + comboID },
              separator
            ));
            totalIndex++;
          }
        }
        if (++rowCount === this.state.curRenderedRowsCount) {
          break;
        }
      }
      if (rowCount >= this.state.curRenderedRowsCount) {
        break;
      }
    }

    var _props = this.props,
        renderScrollComponent = _props.renderScrollComponent,
        props = _objectWithoutProperties(_props, ['renderScrollComponent']);

    if (!props.scrollEventThrottle) {
      props.scrollEventThrottle = DEFAULT_SCROLL_CALLBACK_THROTTLE;
    }
    if (props.removeClippedSubviews === undefined) {
      props.removeClippedSubviews = true;
    }
    Object.assign(props, {
      onScroll: this._onScroll,
      stickyHeaderIndices: this.props.stickyHeaderIndices.concat(stickySectionHeaderIndices),

      // Do not pass these events downstream to ScrollView since they will be
      // registered in ListView's own ScrollResponder.Mixin
      onKeyboardWillShow: undefined,
      onKeyboardWillHide: undefined,
      onKeyboardDidShow: undefined,
      onKeyboardDidHide: undefined
    });

    return Object(__WEBPACK_IMPORTED_MODULE_11__cloneReferencedElement__["a" /* default */])(renderScrollComponent(props), {
      ref: this._setScrollComponentRef,
      onContentSizeChange: this._onContentSizeChange,
      onLayout: this._onLayout,
      DEPRECATED_sendUpdatedChildFrames: typeof props.onChangeVisibleRows !== undefined
    }, header, bodyComponents, footer);
  },

  /**
   * Private methods
   */

  _measureAndUpdateScrollProps: function _measureAndUpdateScrollProps() {
    var scrollComponent = this.getScrollResponder();
    if (!scrollComponent || !scrollComponent.getInnerViewNode) {
      return;
    }

    // RCTScrollViewManager.calculateChildFrames is not available on
    // every platform
    RCTScrollViewManager && RCTScrollViewManager.calculateChildFrames && RCTScrollViewManager.calculateChildFrames(Object(__WEBPACK_IMPORTED_MODULE_4__exports_findNodeHandle__["a" /* default */])(scrollComponent), this._updateVisibleRows);
  },

  _setScrollComponentRef: function _setScrollComponentRef(scrollComponent) {
    this._scrollComponent = scrollComponent;
  },

  _onContentSizeChange: function _onContentSizeChange(width, height) {
    var contentLength = !this.props.horizontal ? height : width;
    if (contentLength !== this.scrollProperties.contentLength) {
      this.scrollProperties.contentLength = contentLength;
      this._updateVisibleRows();
      this._renderMoreRowsIfNeeded();
    }
    this.props.onContentSizeChange && this.props.onContentSizeChange(width, height);
  },

  _onLayout: function _onLayout(event) {
    var _event$nativeEvent$la = event.nativeEvent.layout,
        width = _event$nativeEvent$la.width,
        height = _event$nativeEvent$la.height;

    var visibleLength = !this.props.horizontal ? height : width;
    if (visibleLength !== this.scrollProperties.visibleLength) {
      this.scrollProperties.visibleLength = visibleLength;
      this._updateVisibleRows();
      this._renderMoreRowsIfNeeded();
    }
    this.props.onLayout && this.props.onLayout(event);
  },

  _maybeCallOnEndReached: function _maybeCallOnEndReached(event) {
    if (this.props.onEndReached && this.scrollProperties.contentLength !== this._sentEndForContentLength && this._getDistanceFromEnd(this.scrollProperties) < this.props.onEndReachedThreshold && this.state.curRenderedRowsCount === (this.props.enableEmptySections ? this.props.dataSource.getRowAndSectionCount() : this.props.dataSource.getRowCount())) {
      this._sentEndForContentLength = this.scrollProperties.contentLength;
      this.props.onEndReached(event);
      return true;
    }
    return false;
  },

  _renderMoreRowsIfNeeded: function _renderMoreRowsIfNeeded() {
    if (this.scrollProperties.contentLength === null || this.scrollProperties.visibleLength === null || this.state.curRenderedRowsCount === (this.props.enableEmptySections ? this.props.dataSource.getRowAndSectionCount() : this.props.dataSource.getRowCount())) {
      this._maybeCallOnEndReached();
      return;
    }

    var distanceFromEnd = this._getDistanceFromEnd(this.scrollProperties);
    if (distanceFromEnd < this.props.scrollRenderAheadDistance) {
      this._pageInNewRows();
    }
  },

  _pageInNewRows: function _pageInNewRows() {
    var _this4 = this;

    this.setState(function (state, props) {
      var rowsToRender = Math.min(state.curRenderedRowsCount + props.pageSize, props.enableEmptySections ? props.dataSource.getRowAndSectionCount() : props.dataSource.getRowCount());
      _this4._prevRenderedRowsCount = state.curRenderedRowsCount;
      return {
        curRenderedRowsCount: rowsToRender
      };
    }, function () {
      _this4._measureAndUpdateScrollProps();
      _this4._prevRenderedRowsCount = _this4.state.curRenderedRowsCount;
    });
  },

  _getDistanceFromEnd: function _getDistanceFromEnd(scrollProperties) {
    return scrollProperties.contentLength - scrollProperties.visibleLength - scrollProperties.offset;
  },

  _updateVisibleRows: function _updateVisibleRows(updatedFrames) {
    var _this5 = this;

    if (!this.props.onChangeVisibleRows) {
      return; // No need to compute visible rows if there is no callback
    }
    if (updatedFrames) {
      updatedFrames.forEach(function (newFrame) {
        _this5._childFrames[newFrame.index] = merge(newFrame);
      });
    }
    var isVertical = !this.props.horizontal;
    var dataSource = this.props.dataSource;
    var visibleMin = this.scrollProperties.offset;
    var visibleMax = visibleMin + this.scrollProperties.visibleLength;
    var allRowIDs = dataSource.rowIdentities;

    var header = this.props.renderHeader && this.props.renderHeader();
    var totalIndex = header ? 1 : 0;
    var visibilityChanged = false;
    var changedRows = {};
    for (var sectionIdx = 0; sectionIdx < allRowIDs.length; sectionIdx++) {
      var rowIDs = allRowIDs[sectionIdx];
      if (rowIDs.length === 0) {
        continue;
      }
      var sectionID = dataSource.sectionIdentities[sectionIdx];
      if (this.props.renderSectionHeader) {
        totalIndex++;
      }
      var visibleSection = this._visibleRows[sectionID];
      if (!visibleSection) {
        visibleSection = {};
      }
      for (var rowIdx = 0; rowIdx < rowIDs.length; rowIdx++) {
        var rowID = rowIDs[rowIdx];
        var frame = this._childFrames[totalIndex];
        totalIndex++;
        if (this.props.renderSeparator && (rowIdx !== rowIDs.length - 1 || sectionIdx === allRowIDs.length - 1)) {
          totalIndex++;
        }
        if (!frame) {
          break;
        }
        var rowVisible = visibleSection[rowID];
        var min = isVertical ? frame.y : frame.x;
        var max = min + (isVertical ? frame.height : frame.width);
        if (!min && !max || min === max) {
          break;
        }
        if (min > visibleMax || max < visibleMin) {
          if (rowVisible) {
            visibilityChanged = true;
            delete visibleSection[rowID];
            if (!changedRows[sectionID]) {
              changedRows[sectionID] = {};
            }
            changedRows[sectionID][rowID] = false;
          }
        } else if (!rowVisible) {
          visibilityChanged = true;
          visibleSection[rowID] = true;
          if (!changedRows[sectionID]) {
            changedRows[sectionID] = {};
          }
          changedRows[sectionID][rowID] = true;
        }
      }
      if (!Object(__WEBPACK_IMPORTED_MODULE_13__isEmpty__["a" /* default */])(visibleSection)) {
        this._visibleRows[sectionID] = visibleSection;
      } else if (this._visibleRows[sectionID]) {
        delete this._visibleRows[sectionID];
      }
    }
    visibilityChanged && this.props.onChangeVisibleRows(this._visibleRows, changedRows);
  },

  _onScroll: function _onScroll(e) {
    var isVertical = !this.props.horizontal;
    this.scrollProperties.visibleLength = e.nativeEvent.layoutMeasurement[isVertical ? 'height' : 'width'];
    this.scrollProperties.contentLength = e.nativeEvent.contentSize[isVertical ? 'height' : 'width'];
    this.scrollProperties.offset = e.nativeEvent.contentOffset[isVertical ? 'y' : 'x'];
    this._updateVisibleRows(e.nativeEvent.updatedChildFrames);
    if (!this._maybeCallOnEndReached(e)) {
      this._renderMoreRowsIfNeeded();
    }

    if (this.props.onEndReached && this._getDistanceFromEnd(this.scrollProperties) > this.props.onEndReachedThreshold) {
      // Scrolled out of the end zone, so it should be able to trigger again.
      this._sentEndForContentLength = null;
    }

    this.props.onScroll && this.props.onScroll(e);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ListView);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isEmpty__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_warning__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fbjs_lib_warning__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule ListViewDataSource
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





function defaultGetRowData(dataBlob, sectionID, rowID) {
  return dataBlob[sectionID][rowID];
}

function defaultGetSectionHeaderData(dataBlob, sectionID) {
  return dataBlob[sectionID];
}

/**
 * Provides efficient data processing and access to the
 * `ListView` component.  A `ListViewDataSource` is created with functions for
 * extracting data from the input blob, and comparing elements (with default
 * implementations for convenience).  The input blob can be as simple as an
 * array of strings, or an object with rows nested inside section objects.
 *
 * To update the data in the datasource, use `cloneWithRows` (or
 * `cloneWithRowsAndSections` if you care about sections).  The data in the
 * data source is immutable, so you can't modify it directly.  The clone methods
 * suck in the new data and compute a diff for each row so ListView knows
 * whether to re-render it or not.
 *
 * In this example, a component receives data in chunks, handled by
 * `_onDataArrived`, which concats the new data onto the old data and updates the
 * data source.  We use `concat` to create a new array - mutating `this._data`,
 * e.g. with `this._data.push(newRowData)`, would be an error. `_rowHasChanged`
 * understands the shape of the row data and knows how to efficiently compare
 * it.
 *
 * ```
 * getInitialState: function() {
 *   var ds = new ListView.DataSource({rowHasChanged: this._rowHasChanged});
 *   return {ds};
 * },
 * _onDataArrived(newData) {
 *   this._data = this._data.concat(newData);
 *   this.setState({
 *     ds: this.state.ds.cloneWithRows(this._data)
 *   });
 * }
 * ```
 */

var ListViewDataSource = function () {
  /**
   * You can provide custom extraction and `hasChanged` functions for section
   * headers and rows.  If absent, data will be extracted with the
   * `defaultGetRowData` and `defaultGetSectionHeaderData` functions.
   *
   * The default extractor expects data of one of the following forms:
   *
   *      { sectionID_1: { rowID_1: <rowData1>, ... }, ... }
   *
   *    or
   *
   *      { sectionID_1: [ <rowData1>, <rowData2>, ... ], ... }
   *
   *    or
   *
   *      [ [ <rowData1>, <rowData2>, ... ], ... ]
   *
   * The constructor takes in a params argument that can contain any of the
   * following:
   *
   * - getRowData(dataBlob, sectionID, rowID);
   * - getSectionHeaderData(dataBlob, sectionID);
   * - rowHasChanged(prevRowData, nextRowData);
   * - sectionHeaderHasChanged(prevSectionData, nextSectionData);
   */
  function ListViewDataSource(params) {
    _classCallCheck(this, ListViewDataSource);

    __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(params && typeof params.rowHasChanged === 'function', 'Must provide a rowHasChanged function.');
    this._rowHasChanged = params.rowHasChanged;
    this._getRowData = params.getRowData || defaultGetRowData;
    this._sectionHeaderHasChanged = params.sectionHeaderHasChanged;
    this._getSectionHeaderData = params.getSectionHeaderData || defaultGetSectionHeaderData;

    this._dataBlob = null;
    this._dirtyRows = [];
    this._dirtySections = [];
    this._cachedRowCount = 0;

    // These two private variables are accessed by outsiders because ListView
    // uses them to iterate over the data in this class.
    this.rowIdentities = [];
    this.sectionIdentities = [];
  }

  /**
   * Clones this `ListViewDataSource` with the specified `dataBlob` and
   * `rowIdentities`. The `dataBlob` is just an arbitrary blob of data. At
   * construction an extractor to get the interesting information was defined
   * (or the default was used).
   *
   * The `rowIdentities` is a 2D array of identifiers for rows.
   * ie. [['a1', 'a2'], ['b1', 'b2', 'b3'], ...].  If not provided, it's
   * assumed that the keys of the section data are the row identities.
   *
   * Note: This function does NOT clone the data in this data source. It simply
   * passes the functions defined at construction to a new data source with
   * the data specified. If you wish to maintain the existing data you must
   * handle merging of old and new data separately and then pass that into
   * this function as the `dataBlob`.
   */


  ListViewDataSource.prototype.cloneWithRows = function cloneWithRows(dataBlob, rowIdentities) {
    var rowIds = rowIdentities ? [[].concat(rowIdentities)] : null;
    if (!this._sectionHeaderHasChanged) {
      this._sectionHeaderHasChanged = function () {
        return false;
      };
    }
    return this.cloneWithRowsAndSections({ s1: dataBlob }, ['s1'], rowIds);
  };

  /**
   * This performs the same function as the `cloneWithRows` function but here
   * you also specify what your `sectionIdentities` are. If you don't care
   * about sections you should safely be able to use `cloneWithRows`.
   *
   * `sectionIdentities` is an array of identifiers for sections.
   * ie. ['s1', 's2', ...].  The identifiers should correspond to the keys or array indexes
   * of the data you wish to include.  If not provided, it's assumed that the
   * keys of dataBlob are the section identities.
   *
   * Note: this returns a new object!
   *
   * ```
   * const dataSource = ds.cloneWithRowsAndSections({
   *   addresses: ['row 1', 'row 2'],
   *   phone_numbers: ['data 1', 'data 2'],
   * }, ['phone_numbers']);
   * ```
   */


  ListViewDataSource.prototype.cloneWithRowsAndSections = function cloneWithRowsAndSections(dataBlob, sectionIdentities, rowIdentities) {
    __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(typeof this._sectionHeaderHasChanged === 'function', 'Must provide a sectionHeaderHasChanged function with section data.');
    __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(!sectionIdentities || !rowIdentities || sectionIdentities.length === rowIdentities.length, 'row and section ids lengths must be the same');

    var newSource = new ListViewDataSource({
      getRowData: this._getRowData,
      getSectionHeaderData: this._getSectionHeaderData,
      rowHasChanged: this._rowHasChanged,
      sectionHeaderHasChanged: this._sectionHeaderHasChanged
    });
    newSource._dataBlob = dataBlob;
    if (sectionIdentities) {
      newSource.sectionIdentities = sectionIdentities;
    } else {
      newSource.sectionIdentities = Object.keys(dataBlob);
    }
    if (rowIdentities) {
      newSource.rowIdentities = rowIdentities;
    } else {
      newSource.rowIdentities = [];
      newSource.sectionIdentities.forEach(function (sectionID) {
        newSource.rowIdentities.push(Object.keys(dataBlob[sectionID]));
      });
    }
    newSource._cachedRowCount = countRows(newSource.rowIdentities);

    newSource._calculateDirtyArrays(this._dataBlob, this.sectionIdentities, this.rowIdentities);

    return newSource;
  };

  /**
   * Returns the total number of rows in the data source.
   *
   * If you are specifying the rowIdentities or sectionIdentities, then `getRowCount` will return the number of rows in the filtered data source.
   */


  ListViewDataSource.prototype.getRowCount = function getRowCount() {
    return this._cachedRowCount;
  };

  /**
   * Returns the total number of rows in the data source (see `getRowCount` for how this is calculated) plus the number of sections in the data.
   *
   * If you are specifying the rowIdentities or sectionIdentities, then `getRowAndSectionCount` will return the number of rows & sections in the filtered data source.
   */


  ListViewDataSource.prototype.getRowAndSectionCount = function getRowAndSectionCount() {
    return this._cachedRowCount + this.sectionIdentities.length;
  };

  /**
   * Returns if the row is dirtied and needs to be rerendered
   */


  ListViewDataSource.prototype.rowShouldUpdate = function rowShouldUpdate(sectionIndex, rowIndex) {
    var needsUpdate = this._dirtyRows[sectionIndex][rowIndex];
    __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_warning___default()(needsUpdate !== undefined, 'missing dirtyBit for section, row: ' + sectionIndex + ', ' + rowIndex);
    return needsUpdate;
  };

  /**
   * Gets the data required to render the row.
   */


  ListViewDataSource.prototype.getRowData = function getRowData(sectionIndex, rowIndex) {
    var sectionID = this.sectionIdentities[sectionIndex];
    var rowID = this.rowIdentities[sectionIndex][rowIndex];
    __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_warning___default()(sectionID !== undefined && rowID !== undefined, 'rendering invalid section, row: ' + sectionIndex + ', ' + rowIndex);
    return this._getRowData(this._dataBlob, sectionID, rowID);
  };

  /**
   * Gets the rowID at index provided if the dataSource arrays were flattened,
   * or null of out of range indexes.
   */


  ListViewDataSource.prototype.getRowIDForFlatIndex = function getRowIDForFlatIndex(index) {
    var accessIndex = index;
    for (var ii = 0; ii < this.sectionIdentities.length; ii++) {
      if (accessIndex >= this.rowIdentities[ii].length) {
        accessIndex -= this.rowIdentities[ii].length;
      } else {
        return this.rowIdentities[ii][accessIndex];
      }
    }
    return null;
  };

  /**
   * Gets the sectionID at index provided if the dataSource arrays were flattened,
   * or null for out of range indexes.
   */


  ListViewDataSource.prototype.getSectionIDForFlatIndex = function getSectionIDForFlatIndex(index) {
    var accessIndex = index;
    for (var ii = 0; ii < this.sectionIdentities.length; ii++) {
      if (accessIndex >= this.rowIdentities[ii].length) {
        accessIndex -= this.rowIdentities[ii].length;
      } else {
        return this.sectionIdentities[ii];
      }
    }
    return null;
  };

  /**
   * Returns an array containing the number of rows in each section
   */


  ListViewDataSource.prototype.getSectionLengths = function getSectionLengths() {
    var results = [];
    for (var ii = 0; ii < this.sectionIdentities.length; ii++) {
      results.push(this.rowIdentities[ii].length);
    }
    return results;
  };

  /**
   * Returns if the section header is dirtied and needs to be rerendered
   */


  ListViewDataSource.prototype.sectionHeaderShouldUpdate = function sectionHeaderShouldUpdate(sectionIndex) {
    var needsUpdate = this._dirtySections[sectionIndex];
    __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_warning___default()(needsUpdate !== undefined, 'missing dirtyBit for section: ' + sectionIndex);
    return needsUpdate;
  };

  /**
   * Gets the data required to render the section header
   */


  ListViewDataSource.prototype.getSectionHeaderData = function getSectionHeaderData(sectionIndex) {
    if (!this._getSectionHeaderData) {
      return null;
    }
    var sectionID = this.sectionIdentities[sectionIndex];
    __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_warning___default()(sectionID !== undefined, 'renderSection called on invalid section: ' + sectionIndex);
    return this._getSectionHeaderData(this._dataBlob, sectionID);
  };

  /**
   * Private members and methods.
   */

  // These two 'protected' variables are accessed by ListView to iterate over
  // the data in this class.


  ListViewDataSource.prototype._calculateDirtyArrays = function _calculateDirtyArrays(prevDataBlob, prevSectionIDs, prevRowIDs) {
    // construct a hashmap of the existing (old) id arrays
    var prevSectionsHash = keyedDictionaryFromArray(prevSectionIDs);
    var prevRowsHash = {};
    for (var ii = 0; ii < prevRowIDs.length; ii++) {
      var sectionID = prevSectionIDs[ii];
      __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_warning___default()(!prevRowsHash[sectionID], 'SectionID appears more than once: ' + sectionID);
      prevRowsHash[sectionID] = keyedDictionaryFromArray(prevRowIDs[ii]);
    }

    // compare the 2 identity array and get the dirtied rows
    this._dirtySections = [];
    this._dirtyRows = [];

    var dirty;
    for (var sIndex = 0; sIndex < this.sectionIdentities.length; sIndex++) {
      var sectionID = this.sectionIdentities[sIndex];
      // dirty if the sectionHeader is new or _sectionHasChanged is true
      dirty = !prevSectionsHash[sectionID];
      var sectionHeaderHasChanged = this._sectionHeaderHasChanged;
      if (!dirty && sectionHeaderHasChanged) {
        dirty = sectionHeaderHasChanged(this._getSectionHeaderData(prevDataBlob, sectionID), this._getSectionHeaderData(this._dataBlob, sectionID));
      }
      this._dirtySections.push(!!dirty);

      this._dirtyRows[sIndex] = [];
      for (var rIndex = 0; rIndex < this.rowIdentities[sIndex].length; rIndex++) {
        var rowID = this.rowIdentities[sIndex][rIndex];
        // dirty if the section is new, row is new or _rowHasChanged is true
        dirty = !prevSectionsHash[sectionID] || !prevRowsHash[sectionID][rowID] || this._rowHasChanged(this._getRowData(prevDataBlob, sectionID, rowID), this._getRowData(this._dataBlob, sectionID, rowID));
        this._dirtyRows[sIndex].push(!!dirty);
      }
    }
  };

  return ListViewDataSource;
}();

function countRows(allRowIDs) {
  var totalRows = 0;
  for (var sectionIdx = 0; sectionIdx < allRowIDs.length; sectionIdx++) {
    var rowIDs = allRowIDs[sectionIdx];
    totalRows += rowIDs.length;
  }
  return totalRows;
}

function keyedDictionaryFromArray(arr) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isEmpty__["a" /* default */])(arr)) {
    return {};
  }
  var result = {};
  for (var ii = 0; ii < arr.length; ii++) {
    var key = arr[ii];
    __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_warning___default()(!result[key], 'Value appears more than once in array: ' + key);
    result[key] = true;
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (ListViewDataSource);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule isEmpty
 */


/**
 * Mimics empty from PHP.
 */

function isEmpty(obj) {
  if (Array.isArray(obj)) {
    return obj.length === 0;
  } else if (typeof obj === 'object') {
    for (var i in obj) {
      return false;
    }
    return true;
  } else {
    return !obj;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (isEmpty);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_applyNativeMethods__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createElement__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PickerItem__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PickerItemPropType__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PickerStylePropTypes__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_StyleSheetPropType__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Text_TextPropTypes__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2017-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */












var pickerStyleType = Object(__WEBPACK_IMPORTED_MODULE_6__modules_StyleSheetPropType__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__PickerStylePropTypes__["a" /* default */]);

var Picker = function (_Component) {
  _inherits(Picker, _Component);

  function Picker() {
    var _temp, _this, _ret;

    _classCallCheck(this, Picker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._handleChange = function (e) {
      var onValueChange = _this.props.onValueChange;
      var _e$target = e.target,
          selectedIndex = _e$target.selectedIndex,
          value = _e$target.value;

      if (onValueChange) {
        onValueChange(value, selectedIndex);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Picker.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        enabled = _props.enabled,
        selectedValue = _props.selectedValue,
        style = _props.style,
        testID = _props.testID,
        itemStyle = _props.itemStyle,
        mode = _props.mode,
        prompt = _props.prompt;


    return Object(__WEBPACK_IMPORTED_MODULE_2__createElement__["a" /* default */])('select', {
      children: children,
      disabled: enabled === false ? true : undefined,
      onChange: this._handleChange,
      style: [styles.initial, style],
      testID: testID,
      value: selectedValue
    });
  };

  return Picker;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Picker.Item = __WEBPACK_IMPORTED_MODULE_3__PickerItem__["a" /* default */];
Picker.propTypes =  false ? {
  children: oneOfType([PickerItemPropType, arrayOf(PickerItemPropType)]),
  enabled: bool,
  onValueChange: func,
  selectedValue: oneOfType([number, string]),
  style: pickerStyleType,
  testID: string
} : {};


var styles = __WEBPACK_IMPORTED_MODULE_7__StyleSheet__["a" /* default */].create({
  initial: {
    fontFamily: 'System',
    fontSize: 'inherit',
    margin: 0
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__modules_applyNativeMethods__["a" /* default */])(Picker));

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_Animated__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports_I18nManager__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exports_PanResponder__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exports_StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_timer_mixin__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_timer_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_timer_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__exports_View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_create_react_class__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_fbjs_lib_emptyFunction__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_fbjs_lib_emptyFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_fbjs_lib_emptyFunction__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule SwipeableRow
 * @noflow
 */








/* $FlowFixMe(>=0.54.0 site=react_native_oss) This comment suppresses an error
 * found when Flow v0.54 was deployed. To see the error delete this comment and
 * run Flow. */






var isRTL = function isRTL() {
  return __WEBPACK_IMPORTED_MODULE_1__exports_I18nManager__["a" /* default */].isRTL;
};

// NOTE: Eventually convert these consts to an input object of configurations

// Position of the left of the swipable item when closed
var CLOSED_LEFT_POSITION = 0;
// Minimum swipe distance before we recognize it as such
var HORIZONTAL_SWIPE_DISTANCE_THRESHOLD = 10;
// Minimum swipe speed before we fully animate the user's action (open/close)
var HORIZONTAL_FULL_SWIPE_SPEED_THRESHOLD = 0.3;
// Factor to divide by to get slow speed; i.e. 4 means 1/4 of full speed
var SLOW_SPEED_SWIPE_FACTOR = 4;
// Time, in milliseconds, of how long the animated swipe should be
var SWIPE_DURATION = 300;

/**
 * On SwipeableListView mount, the 1st item will bounce to show users it's
 * possible to swipe
 */
var ON_MOUNT_BOUNCE_DELAY = 700;
var ON_MOUNT_BOUNCE_DURATION = 400;

// Distance left of closed position to bounce back when right-swiping from closed
var RIGHT_SWIPE_BOUNCE_BACK_DISTANCE = 30;
var RIGHT_SWIPE_BOUNCE_BACK_DURATION = 300;
/**
 * Max distance of right swipe to allow (right swipes do functionally nothing).
 * Must be multiplied by SLOW_SPEED_SWIPE_FACTOR because gestureState.dx tracks
 * how far the finger swipes, and not the actual animation distance.
*/
var RIGHT_SWIPE_THRESHOLD = 30 * SLOW_SPEED_SWIPE_FACTOR;

/**
 * Creates a swipable row that allows taps on the main item and a custom View
 * on the item hidden behind the row. Typically this should be used in
 * conjunction with SwipeableListView for additional functionality, but can be
 * used in a normal ListView. See the renderRow for SwipeableListView to see how
 * to use this component separately.
 */
var SwipeableRow = __WEBPACK_IMPORTED_MODULE_8_create_react_class___default()({
  displayName: 'SwipeableRow',
  _panResponder: {},
  _previousLeft: CLOSED_LEFT_POSITION,

  mixins: [__WEBPACK_IMPORTED_MODULE_6_react_timer_mixin___default.a],

  propTypes: {
    children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    isOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    preventSwipeRight: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    maxSwipeDistance: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
    onOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    onClose: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    onSwipeEnd: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    onSwipeStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    // Should bounce the row on mount
    shouldBounceOnMount: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    /**
     * A ReactElement that is unveiled when the user swipes
     */
    slideoutView: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node.isRequired,
    /**
     * The minimum swipe distance required before fully animating the swipe. If
     * the user swipes less than this distance, the item will return to its
     * previous (open/close) position.
     */
    swipeThreshold: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      currentLeft: new __WEBPACK_IMPORTED_MODULE_0__exports_Animated__["a" /* default */].Value(this._previousLeft),
      /**
       * In order to render component A beneath component B, A must be rendered
       * before B. However, this will cause "flickering", aka we see A briefly
       * then B. To counter this, _isSwipeableViewRendered flag is used to set
       * component A to be transparent until component B is loaded.
       */
      isSwipeableViewRendered: false,
      rowHeight: null
    };
  },
  getDefaultProps: function getDefaultProps() {
    return {
      isOpen: false,
      preventSwipeRight: false,
      maxSwipeDistance: 0,
      onOpen: __WEBPACK_IMPORTED_MODULE_9_fbjs_lib_emptyFunction___default.a,
      onClose: __WEBPACK_IMPORTED_MODULE_9_fbjs_lib_emptyFunction___default.a,
      onSwipeEnd: __WEBPACK_IMPORTED_MODULE_9_fbjs_lib_emptyFunction___default.a,
      onSwipeStart: __WEBPACK_IMPORTED_MODULE_9_fbjs_lib_emptyFunction___default.a,
      swipeThreshold: 30
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    this._panResponder = __WEBPACK_IMPORTED_MODULE_2__exports_PanResponder__["a" /* default */].create({
      onMoveShouldSetPanResponderCapture: this._handleMoveShouldSetPanResponderCapture,
      onPanResponderGrant: this._handlePanResponderGrant,
      onPanResponderMove: this._handlePanResponderMove,
      onPanResponderRelease: this._handlePanResponderEnd,
      onPanResponderTerminationRequest: this._onPanResponderTerminationRequest,
      onPanResponderTerminate: this._handlePanResponderEnd,
      onShouldBlockNativeResponder: function onShouldBlockNativeResponder(event, gestureState) {
        return false;
      }
    });
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    if (this.props.shouldBounceOnMount) {
      /**
       * Do the on mount bounce after a delay because if we animate when other
       * components are loading, the animation will be laggy
       */
      this.setTimeout(function () {
        _this._animateBounceBack(ON_MOUNT_BOUNCE_DURATION);
      }, ON_MOUNT_BOUNCE_DELAY);
    }
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    /**
     * We do not need an "animateOpen(noCallback)" because this animation is
     * handled internally by this component.
     */
    if (this.props.isOpen && !nextProps.isOpen) {
      this._animateToClosedPosition();
    }
  },
  render: function render() {
    // The view hidden behind the main view
    var slideOutView = void 0;
    if (this.state.isSwipeableViewRendered && this.state.rowHeight) {
      slideOutView = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__exports_View__["a" /* default */],
        { style: [styles.slideOutContainer, { height: this.state.rowHeight }] },
        this.props.slideoutView
      );
    }

    // The swipeable item
    var swipeableView = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0__exports_Animated__["a" /* default */].View,
      {
        onLayout: this._onSwipeableViewLayout,
        style: { transform: [{ translateX: this.state.currentLeft }] } },
      this.props.children
    );

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__exports_View__["a" /* default */],
      this._panResponder.panHandlers,
      slideOutView,
      swipeableView
    );
  },
  close: function close() {
    this.props.onClose();
    this._animateToClosedPosition();
  },
  _onSwipeableViewLayout: function _onSwipeableViewLayout(event) {
    this.setState({
      isSwipeableViewRendered: true,
      rowHeight: event.nativeEvent.layout.height
    });
  },
  _handleMoveShouldSetPanResponderCapture: function _handleMoveShouldSetPanResponderCapture(event, gestureState) {
    // Decides whether a swipe is responded to by this component or its child
    return gestureState.dy < 10 && this._isValidSwipe(gestureState);
  },
  _handlePanResponderGrant: function _handlePanResponderGrant(event, gestureState) {},
  _handlePanResponderMove: function _handlePanResponderMove(event, gestureState) {
    if (this._isSwipingExcessivelyRightFromClosedPosition(gestureState)) {
      return;
    }

    this.props.onSwipeStart();

    if (this._isSwipingRightFromClosed(gestureState)) {
      this._swipeSlowSpeed(gestureState);
    } else {
      this._swipeFullSpeed(gestureState);
    }
  },
  _isSwipingRightFromClosed: function _isSwipingRightFromClosed(gestureState) {
    var gestureStateDx = isRTL() ? -gestureState.dx : gestureState.dx;
    return this._previousLeft === CLOSED_LEFT_POSITION && gestureStateDx > 0;
  },
  _swipeFullSpeed: function _swipeFullSpeed(gestureState) {
    this.state.currentLeft.setValue(this._previousLeft + gestureState.dx);
  },
  _swipeSlowSpeed: function _swipeSlowSpeed(gestureState) {
    this.state.currentLeft.setValue(this._previousLeft + gestureState.dx / SLOW_SPEED_SWIPE_FACTOR);
  },
  _isSwipingExcessivelyRightFromClosedPosition: function _isSwipingExcessivelyRightFromClosedPosition(gestureState) {
    /**
     * We want to allow a BIT of right swipe, to allow users to know that
     * swiping is available, but swiping right does not do anything
     * functionally.
     */
    var gestureStateDx = isRTL() ? -gestureState.dx : gestureState.dx;
    return this._isSwipingRightFromClosed(gestureState) && gestureStateDx > RIGHT_SWIPE_THRESHOLD;
  },
  _onPanResponderTerminationRequest: function _onPanResponderTerminationRequest(event, gestureState) {
    return false;
  },
  _animateTo: function _animateTo(toValue) {
    var _this2 = this;

    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SWIPE_DURATION;
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_9_fbjs_lib_emptyFunction___default.a;

    __WEBPACK_IMPORTED_MODULE_0__exports_Animated__["a" /* default */].timing(this.state.currentLeft, {
      duration: duration,
      toValue: toValue,
      useNativeDriver: true
    }).start(function () {
      _this2._previousLeft = toValue;
      callback();
    });
  },
  _animateToOpenPosition: function _animateToOpenPosition() {
    var maxSwipeDistance = isRTL() ? -this.props.maxSwipeDistance : this.props.maxSwipeDistance;
    this._animateTo(-maxSwipeDistance);
  },
  _animateToOpenPositionWith: function _animateToOpenPositionWith(speed, distMoved) {
    /**
     * Ensure the speed is at least the set speed threshold to prevent a slow
     * swiping animation
     */
    speed = speed > HORIZONTAL_FULL_SWIPE_SPEED_THRESHOLD ? speed : HORIZONTAL_FULL_SWIPE_SPEED_THRESHOLD;
    /**
     * Calculate the duration the row should take to swipe the remaining distance
     * at the same speed the user swiped (or the speed threshold)
     */
    var duration = Math.abs((this.props.maxSwipeDistance - Math.abs(distMoved)) / speed);
    var maxSwipeDistance = isRTL() ? -this.props.maxSwipeDistance : this.props.maxSwipeDistance;
    this._animateTo(-maxSwipeDistance, duration);
  },
  _animateToClosedPosition: function _animateToClosedPosition() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SWIPE_DURATION;

    this._animateTo(CLOSED_LEFT_POSITION, duration);
  },
  _animateToClosedPositionDuringBounce: function _animateToClosedPositionDuringBounce() {
    this._animateToClosedPosition(RIGHT_SWIPE_BOUNCE_BACK_DURATION);
  },
  _animateBounceBack: function _animateBounceBack(duration) {
    /**
     * When swiping right, we want to bounce back past closed position on release
     * so users know they should swipe right to get content.
     */
    var swipeBounceBackDistance = isRTL() ? -RIGHT_SWIPE_BOUNCE_BACK_DISTANCE : RIGHT_SWIPE_BOUNCE_BACK_DISTANCE;
    this._animateTo(-swipeBounceBackDistance, duration, this._animateToClosedPositionDuringBounce);
  },


  // Ignore swipes due to user's finger moving slightly when tapping
  _isValidSwipe: function _isValidSwipe(gestureState) {
    if (this.props.preventSwipeRight && this._previousLeft === CLOSED_LEFT_POSITION && gestureState.dx > 0) {
      return false;
    }

    return Math.abs(gestureState.dx) > HORIZONTAL_SWIPE_DISTANCE_THRESHOLD;
  },
  _shouldAnimateRemainder: function _shouldAnimateRemainder(gestureState) {
    /**
     * If user has swiped past a certain distance, animate the rest of the way
     * if they let go
     */
    return Math.abs(gestureState.dx) > this.props.swipeThreshold || gestureState.vx > HORIZONTAL_FULL_SWIPE_SPEED_THRESHOLD;
  },
  _handlePanResponderEnd: function _handlePanResponderEnd(event, gestureState) {
    var horizontalDistance = isRTL() ? -gestureState.dx : gestureState.dx;
    if (this._isSwipingRightFromClosed(gestureState)) {
      this.props.onOpen();
      this._animateBounceBack(RIGHT_SWIPE_BOUNCE_BACK_DURATION);
    } else if (this._shouldAnimateRemainder(gestureState)) {
      if (horizontalDistance < 0) {
        // Swiped left
        this.props.onOpen();
        this._animateToOpenPositionWith(gestureState.vx, horizontalDistance);
      } else {
        // Swiped right
        this.props.onClose();
        this._animateToClosedPosition();
      }
    } else {
      if (this._previousLeft === CLOSED_LEFT_POSITION) {
        this._animateToClosedPosition();
      } else {
        this._animateToOpenPosition();
      }
    }

    this.props.onSwipeEnd();
  }
});

var styles = __WEBPACK_IMPORTED_MODULE_5__exports_StyleSheet__["a" /* default */].create({
  slideOutContainer: {
    bottom: 0,
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SwipeableRow);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(315);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(752);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(745);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(323);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(196);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string") {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(769);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 328 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(135),
    stackClear = __webpack_require__(782),
    stackDelete = __webpack_require__(783),
    stackGet = __webpack_require__(784),
    stackHas = __webpack_require__(785),
    stackSet = __webpack_require__(786);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(82),
    isObject = __webpack_require__(95);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(333);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(83);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(805),
    isArguments = __webpack_require__(203),
    isArray = __webpack_require__(55),
    isBuffer = __webpack_require__(204),
    isIndex = __webpack_require__(205),
    isTypedArray = __webpack_require__(335);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(808),
    baseUnary = __webpack_require__(207),
    nodeUtil = __webpack_require__(208);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 336 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(330),
    isLength = __webpack_require__(206);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(334),
    baseKeysIn = __webpack_require__(812),
    isArrayLike = __webpack_require__(337);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 339 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(211),
    getPrototype = __webpack_require__(212),
    getSymbols = __webpack_require__(210),
    stubArray = __webpack_require__(339);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(342),
    getSymbols = __webpack_require__(210),
    keys = __webpack_require__(202);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(211),
    isArray = __webpack_require__(55);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(342),
    getSymbolsIn = __webpack_require__(340),
    keysIn = __webpack_require__(338);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(54);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(97),
    toKey = __webpack_require__(140);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(847),
    overRest = __webpack_require__(850),
    setToString = __webpack_require__(852);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(864);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(866),
    arraySome = __webpack_require__(869),
    cacheHas = __webpack_require__(870);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPersistoid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(84);


// @TODO remove once flow < 0.63 support is no longer required.

function createPersistoid(config) {
  // defaults
  var blacklist = config.blacklist || null;
  var whitelist = config.whitelist || null;
  var transforms = config.transforms || [];
  var throttle = config.throttle || 0;
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  var storage = config.storage;
  var serialize = config.serialize === false ? function (x) {
    return x;
  } : defaultSerialize;

  // initialize stateful values
  var lastState = {};
  var stagedState = {};
  var keysToProcess = [];
  var timeIterator = null;
  var writePromise = null;

  var update = function update(state) {
    // add any changed keys to the queue
    Object.keys(state).forEach(function (key) {
      var subState = state[key];
      if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
      if (lastState[key] === state[key]) return; // value unchanged? noop
      if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
      keysToProcess.push(key); // add key to queue
    });

    // start the time iterator if not running (read: throttle)
    if (timeIterator === null) {
      timeIterator = setInterval(processNextKey, throttle);
    }

    lastState = state;
  };

  function processNextKey() {
    if (keysToProcess.length === 0) {
      if (timeIterator) clearInterval(timeIterator);
      timeIterator = null;
      return;
    }

    var key = keysToProcess.shift();
    var endState = transforms.reduce(function (subState, transformer) {
      return transformer.in(subState, key, lastState);
    }, lastState[key]);
    if (typeof endState !== 'undefined') stagedWrite(key, endState);
  }

  function stagedWrite(key, endState) {
    try {
      stagedState[key] = serialize(endState);
    } catch (err) {
      console.error('redux-persist/createPersistoid: error serializing state', err);
    }
    if (keysToProcess.length === 0) {
      // cleanup any removed keys just before write.
      Object.keys(stagedState).forEach(function (key) {
        if (lastState[key] === undefined) {
          delete stagedState[key];
        }
      });

      writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
    if (blacklist && blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function onWriteFail(err) {
    // @TODO add fail handlers (typically storage full)
    if (err && "production" !== 'production') {
      console.error('Error storing data', err);
    }
  }

  var flush = function flush() {
    while (keysToProcess.length !== 0) {
      processNextKey();
    }
    return writePromise || Promise.resolve();
  };

  // return `persistoid`
  return {
    update: update,
    flush: flush
  };
}

// @NOTE in the future this may be exposed via config
function defaultSerialize(data) {
  return JSON.stringify(data);
}

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(84);




function getStoredState(config) {
  var transforms = config.transforms || [];
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  var storage = config.storage;
  var debug = config.debug;
  var deserialize = config.serialize === false ? function (x) {
    return x;
  } : defaultDeserialize;
  return storage.getItem(storageKey).then(function (serialized) {
    if (!serialized) return undefined;else {
      try {
        var state = {};
        var rawState = deserialize(serialized);
        Object.keys(rawState).forEach(function (key) {
          state[key] = transforms.reduceRight(function (subState, transformer) {
            return transformer.out(subState, key, rawState);
          }, deserialize(rawState[key]));
        });
        return state;
      } catch (err) {
        if (false) console.log('redux-persist/getStoredState: Error restoring data ' + serialized, err);
        throw err;
      }
    }
  });
}

function defaultDeserialize(serial) {
  return JSON.parse(serial);
}

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = purgeStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(84);




function purgeStoredState(config) {
  var storage = config.storage;
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  return storage.removeItem(storageKey, warnIfRemoveError);
}

function warnIfRemoveError(err) {
  if (err && "production" !== 'production') {
    console.error('redux-persist/purgeStoredState: Error purging data stored state', err);
  }
}

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(912);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(914);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(356);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(916);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(919);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(922);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(924);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(357);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(219);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(930);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(932);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(934);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_11__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(935);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(358);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(221);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return globalLocale;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
        else {
            if ((typeof console !==  'undefined') && console.warn) {
                //warn user if arguments are passed but the locale could not be set
                console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
            }
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var locale, parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                locale = loadLocale(config.parentLocale);
                if (locale != null) {
                    parentConfig = locale._config;
                } else {
                    if (!localeFamilies[config.parentLocale]) {
                        localeFamilies[config.parentLocale] = [];
                    }
                    localeFamilies[config.parentLocale].push({
                        name: name,
                        config: config
                    });
                    return null;
                }
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, expectedWeekday, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString(keepOffset) {
    if (!this.isValid()) {
        return null;
    }
    var utc = keepOffset !== true;
    var m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
            return this.toDate().toISOString();
        } else {
            return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
    }
    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports

hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.21.0';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

// currently HTML5 input type only supports 24-hour formats
hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',                             // <input type="date" />
    TIME: 'HH:mm',                                  // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
    MONTH: 'YYYY-MM'                                // <input type="month" />
};

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(39);
var settle = __webpack_require__(948);
var buildURL = __webpack_require__(950);
var parseHeaders = __webpack_require__(951);
var isURLSameOrigin = __webpack_require__(952);
var createError = __webpack_require__(363);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(953);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(954);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(949);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports = function(data, filename, mime) {
    var blob = new Blob([data], {type: mime || 'application/octet-stream'});
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were 
        // revoked by closing the blob for which they were created. 
        // These URLs will no longer resolve as the data backing 
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    }
    else {
        var blobURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', filename); 
        
        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking 
        // is enabled.
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
        }
        
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
    }
}


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _class,_temp;var _reactNative=__webpack_require__(3);
var _Entypo=__webpack_require__(966);var _Entypo2=_interopRequireDefault(_Entypo);
var _EvilIcons=__webpack_require__(967);var _EvilIcons2=_interopRequireDefault(_EvilIcons);
var _Feather=__webpack_require__(968);var _Feather2=_interopRequireDefault(_Feather);
var _FontAwesome=__webpack_require__(969);var _FontAwesome2=_interopRequireDefault(_FontAwesome);
var _Foundation=__webpack_require__(970);var _Foundation2=_interopRequireDefault(_Foundation);
var _Ionicons=__webpack_require__(971);var _Ionicons2=_interopRequireDefault(_Ionicons);
var _MaterialCommunityIcons=__webpack_require__(972);var _MaterialCommunityIcons2=_interopRequireDefault(_MaterialCommunityIcons);

var _MaterialIcons=__webpack_require__(973);var _MaterialIcons2=_interopRequireDefault(_MaterialIcons);

var _Octicons=__webpack_require__(974);var _Octicons2=_interopRequireDefault(_Octicons);
var _SimpleLineIcons=__webpack_require__(975);var _SimpleLineIcons2=_interopRequireDefault(_SimpleLineIcons);

var _Zocial=__webpack_require__(976);var _Zocial2=_interopRequireDefault(_Zocial);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var

FontUtils=(_temp=_class=function FontUtils(){_classCallCheck(this,FontUtils);},_class.

importEntypo=function(){
FontUtils.importIconFont(_Entypo2.default,'Entypo');
},_class.

importEvilIcons=function(){
FontUtils.importIconFont(_EvilIcons2.default,'EvilIcons');
},_class.

importFeather=function(){
FontUtils.importIconFont(_Feather2.default,'Feather');
},_class.

importFontAwesome=function(){
FontUtils.importIconFont(_FontAwesome2.default,'FontAwesome');
},_class.

importFoundation=function(){
FontUtils.importIconFont(_Foundation2.default,'Foundation');
},_class.

importIonicons=function(){
FontUtils.importIconFont(_Ionicons2.default,'Ionicons');
},_class.

importMaterialCommunityIcons=function(){
FontUtils.importIconFont(_MaterialCommunityIcons2.default,
'MaterialCommunityIcons');
},_class.

importMaterialIcons=function(){
FontUtils.importIconFont(_MaterialIcons2.default,'MaterialIcons');
},_class.

importOcticons=function(){
FontUtils.importIconFont(_Octicons2.default,'Octicons');
},_class.

importSimpleLineIcons=function(){
FontUtils.importIconFont(_SimpleLineIcons2.default,'SimpleLineIcons');
},_class.

importZocial=function(){
FontUtils.importIconFont(_Zocial2.default,'Zocial');
},_class.

importIconFont=function(iconFont,fontFamily){
if(_reactNative.Platform.OS!=='web'){
return;
}

var innerText='@font-face {\n      src: url('+
iconFont+');\n      font-family: '+
fontFamily+';\n    }';

for(var _iterator=document.head.childNodes,_isArray=Array.isArray(_iterator),_i=0,_iterator=_isArray?_iterator:_iterator[typeof Symbol==='function'?Symbol.iterator:'@@iterator']();;){var _ref;if(_isArray){if(_i>=_iterator.length)break;_ref=_iterator[_i++];}else{_i=_iterator.next();if(_i.done)break;_ref=_i.value;}var childNode=_ref;
if(childNode.nodeName!=='STYLE'){
continue;
}
if(childNode.innerText===innerText){

return;
}
}

var style=document.createElement('style');
style.type='text/css';
if(style.styleSheet){
style.styleSheet.cssText=innerText;
}else{
style.appendChild(document.createTextNode(innerText));
}
document.head.appendChild(style);
},_temp);exports.default=FontUtils;

/***/ }),
/* 368 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var Constants={
PAYMENT_METHOD_LOOKUP:new Map([
['bank','Chuyển khoản'],
['cod','Tiền mặt'],
['partner','Đại diện'],
['gift','Quà tặng'],
['prepaid','Thanh toán trước'],
['award','Thưởng']]),

STATUS_LOOKUP:new Map([
['placed','Đặt hàng'],
['confirmed','Đã chốt'],
['shipping','Đang vận chuyển'],
['paid','Đã thanh toán'],
['given','Miễn phí'],
['gift','Quà tặng'],
['prepaid','Thanh toán trước'],
['award','Thưởng'],
['cancel','Đã huỷ']])};exports.default=



Constants;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.RightButton=exports.LeftButton=exports.ButtonList=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);
var _modules=__webpack_require__(19);
var _FontUtils=__webpack_require__(367);var _FontUtils2=_interopRequireDefault(_FontUtils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

ButtonList=exports.ButtonList=function(_Component){_inherits(ButtonList,_Component);
function ButtonList(props){_classCallCheck(this,ButtonList);return _possibleConstructorReturn(this,(ButtonList.__proto__||Object.getPrototypeOf(ButtonList)).call(this,
props));
}_createClass(ButtonList,[{key:'componentWillMount',value:function componentWillMount()

{
_FontUtils2.default.importFontAwesome();
}},{key:'render',value:function render()

{var
children=this.props.children;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.buttonList},
children));


}}]);return ButtonList;}(_react.Component);var


LeftButton=exports.LeftButton=function(_Component2){_inherits(LeftButton,_Component2);

function LeftButton(props){_classCallCheck(this,LeftButton);return _possibleConstructorReturn(this,(LeftButton.__proto__||Object.getPrototypeOf(LeftButton)).call(this,
props));
}_createClass(LeftButton,[{key:'componentWillMount',value:function componentWillMount()

{
_FontUtils2.default.importFontAwesome();
}},{key:'render',value:function render()

{var _props=
this.props,title=_props.title,image=_props.image,icon=_props.icon,component=_props.component,disabled=_props.disabled,style=_props.style,onClick=_props.onClick;
return(
_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
disabled:disabled,
style:[{marginLeft:10},style],
onPress:onClick},
title&&_react2.default.createElement(_reactNative.Text,{style:styles.titleText},
title),

image&&_react2.default.createElement(_reactNative.Image,{source:image}),
icon&&_react2.default.createElement(_modules.FontAwesomeIcon,{
name:icon.name,
size:icon.size,
color:icon.color}),
component));


}}]);return LeftButton;}(_react.Component);var


RightButton=exports.RightButton=function(_Component3){_inherits(RightButton,_Component3);

function RightButton(props){_classCallCheck(this,RightButton);return _possibleConstructorReturn(this,(RightButton.__proto__||Object.getPrototypeOf(RightButton)).call(this,
props));
}_createClass(RightButton,[{key:'componentWillMount',value:function componentWillMount()

{
_FontUtils2.default.importFontAwesome();
}},{key:'render',value:function render()

{var _props2=
this.props,title=_props2.title,image=_props2.image,icon=_props2.icon,component=_props2.component,disabled=_props2.disabled,style=_props2.style,onClick=_props2.onClick;
return(
_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
disabled:disabled,
style:[{marginRight:10},style],
onPress:onClick},
title&&_react2.default.createElement(_reactNative.Text,{style:styles.titleText},
title),

image&&_react2.default.createElement(_reactNative.Image,{source:image}),
icon&&_react2.default.createElement(_modules.FontAwesomeIcon,{
name:icon.name,
size:icon.size,
color:icon.color}),
component));


}}]);return RightButton;}(_react.Component);


var styles=_reactNative.StyleSheet.create({
buttonList:{
flexDirection:'row',
alignItems:'center'},

titleText:{
color:'#ffffff',
fontSize:14,
fontWeight:'400',
backgroundColor:'transparent'}});

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(371);
__webpack_require__(573);
module.exports = __webpack_require__(578);


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(372);

__webpack_require__(569);

__webpack_require__(570);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(373);
__webpack_require__(375);
__webpack_require__(376);
__webpack_require__(377);
__webpack_require__(378);
__webpack_require__(379);
__webpack_require__(380);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(164);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(244);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(247);
__webpack_require__(249);
__webpack_require__(250);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(542);
__webpack_require__(543);
__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(547);
__webpack_require__(548);
__webpack_require__(549);
__webpack_require__(550);
__webpack_require__(551);
__webpack_require__(552);
__webpack_require__(553);
__webpack_require__(554);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(559);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(562);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(565);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(568);
module.exports = __webpack_require__(46);


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(6);
var has = __webpack_require__(29);
var DESCRIPTORS = __webpack_require__(15);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(31);
var META = __webpack_require__(63).KEY;
var $fails = __webpack_require__(7);
var shared = __webpack_require__(113);
var setToStringTag = __webpack_require__(86);
var uid = __webpack_require__(68);
var wks = __webpack_require__(11);
var wksExt = __webpack_require__(227);
var wksDefine = __webpack_require__(144);
var enumKeys = __webpack_require__(374);
var isArray = __webpack_require__(116);
var anObject = __webpack_require__(5);
var isObject = __webpack_require__(8);
var toIObject = __webpack_require__(35);
var toPrimitive = __webpack_require__(47);
var createDesc = __webpack_require__(67);
var _create = __webpack_require__(72);
var gOPNExt = __webpack_require__(230);
var $GOPD = __webpack_require__(36);
var $DP = __webpack_require__(16);
var $keys = __webpack_require__(70);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(73).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(101).f = $propertyIsEnumerable;
  __webpack_require__(115).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(69)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(30)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(70);
var gOPS = __webpack_require__(115);
var pIE = __webpack_require__(101);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(72) });


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(15), 'Object', { defineProperty: __webpack_require__(16).f });


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(15), 'Object', { defineProperties: __webpack_require__(229) });


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(35);
var $getOwnPropertyDescriptor = __webpack_require__(36).f;

__webpack_require__(50)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(21);
var $getPrototypeOf = __webpack_require__(37);

__webpack_require__(50)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(21);
var $keys = __webpack_require__(70);

__webpack_require__(50)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(50)('getOwnPropertyNames', function () {
  return __webpack_require__(230).f;
});


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(63).onFreeze;

__webpack_require__(50)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(63).onFreeze;

__webpack_require__(50)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(63).onFreeze;

__webpack_require__(50)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(8);

__webpack_require__(50)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(8);

__webpack_require__(50)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(8);

__webpack_require__(50)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(231) });


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(390) });


/***/ }),
/* 390 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(148).set });


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(102);
var test = {};
test[__webpack_require__(11)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(31)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(232) });


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(15) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(37);
var HAS_INSTANCE = __webpack_require__(11)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(16).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(234);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(235);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(6);
var has = __webpack_require__(29);
var cof = __webpack_require__(41);
var inheritIfRequired = __webpack_require__(150);
var toPrimitive = __webpack_require__(47);
var fails = __webpack_require__(7);
var gOPN = __webpack_require__(73).f;
var gOPD = __webpack_require__(36).f;
var dP = __webpack_require__(16).f;
var $trim = __webpack_require__(87).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(72)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(15) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(31)(global, NUMBER, $Number);
}


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(49);
var aNumberValue = __webpack_require__(236);
var repeat = __webpack_require__(151);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(7)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(7);
var aNumberValue = __webpack_require__(236);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(6).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(237) });


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(237);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(235);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(234);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(238);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(152);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(153);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(239) });


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(7)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(238) });


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(152) });


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(153);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(7)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(153);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(71);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(35);
var toLength = __webpack_require__(17);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(87)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(154)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(155)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(154)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(17);
var context = __webpack_require__(157);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(158)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(157);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(158)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(151)
});


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(17);
var context = __webpack_require__(157);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(158)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(32)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(32)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(32)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(32)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(32)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(32)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(32)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(32)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(32)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(32)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(32)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(32)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(32)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(21);
var toPrimitive = __webpack_require__(47);

$export($export.P + $export.F * __webpack_require__(7)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(452);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(7);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(31)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(11)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(30)(proto, TO_PRIMITIVE, __webpack_require__(455));


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(5);
var toPrimitive = __webpack_require__(47);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(116) });


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(40);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(21);
var call = __webpack_require__(240);
var isArrayIter = __webpack_require__(159);
var toLength = __webpack_require__(17);
var createProperty = __webpack_require__(160);
var getIterFn = __webpack_require__(161);

$export($export.S + $export.F * !__webpack_require__(118)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(160);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(7)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(35);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(100) != Object || !__webpack_require__(42)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(147);
var cof = __webpack_require__(41);
var toAbsoluteIndex = __webpack_require__(71);
var toLength = __webpack_require__(17);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(7)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(25);
var toObject = __webpack_require__(21);
var fails = __webpack_require__(7);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(42)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(51)(0);
var STRICT = __webpack_require__(42)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var isArray = __webpack_require__(116);
var SPECIES = __webpack_require__(11)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(51)(1);

$export($export.P + $export.F * !__webpack_require__(42)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(51)(2);

$export($export.P + $export.F * !__webpack_require__(42)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(51)(3);

$export($export.P + $export.F * !__webpack_require__(42)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(51)(4);

$export($export.P + $export.F * !__webpack_require__(42)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(241);

$export($export.P + $export.F * !__webpack_require__(42)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(241);

$export($export.P + $export.F * !__webpack_require__(42)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(114)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(42)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(35);
var toInteger = __webpack_require__(49);
var toLength = __webpack_require__(17);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(42)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(242) });

__webpack_require__(64)('copyWithin');


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(163) });

__webpack_require__(64)('fill');


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(51)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(64)(KEY);


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(51)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(64)(KEY);


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Array');


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var inheritIfRequired = __webpack_require__(150);
var dP = __webpack_require__(16).f;
var gOPN = __webpack_require__(73).f;
var isRegExp = __webpack_require__(117);
var $flags = __webpack_require__(119);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(15) && (!CORRECT_NEW || __webpack_require__(7)(function () {
  re2[__webpack_require__(11)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(31)(global, 'RegExp', $RegExp);
}

__webpack_require__(74)('RegExp');


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(244);
var anObject = __webpack_require__(5);
var $flags = __webpack_require__(119);
var DESCRIPTORS = __webpack_require__(15);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(31)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(7)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(120)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(120)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(120)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(120)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(117);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(69);
var global = __webpack_require__(6);
var ctx = __webpack_require__(40);
var classof = __webpack_require__(102);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(8);
var aFunction = __webpack_require__(25);
var anInstance = __webpack_require__(75);
var forOf = __webpack_require__(76);
var speciesConstructor = __webpack_require__(121);
var task = __webpack_require__(165).set;
var microtask = __webpack_require__(166)();
var newPromiseCapabilityModule = __webpack_require__(167);
var perform = __webpack_require__(245);
var promiseResolve = __webpack_require__(246);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(11)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(77)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(86)($Promise, PROMISE);
__webpack_require__(74)(PROMISE);
Wrapper = __webpack_require__(46)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(118)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(251);
var validate = __webpack_require__(89);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(122)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(123);
var buffer = __webpack_require__(168);
var anObject = __webpack_require__(5);
var toAbsoluteIndex = __webpack_require__(71);
var toLength = __webpack_require__(17);
var isObject = __webpack_require__(8);
var ArrayBuffer = __webpack_require__(6).ArrayBuffer;
var speciesConstructor = __webpack_require__(121);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(7)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(74)(ARRAY_BUFFER);


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(123).ABV, {
  DataView: __webpack_require__(168).DataView
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(25);
var anObject = __webpack_require__(5);
var rApply = (__webpack_require__(6).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(7)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(72);
var aFunction = __webpack_require__(25);
var anObject = __webpack_require__(5);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(7);
var bind = __webpack_require__(232);
var rConstruct = (__webpack_require__(6).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(16);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(5);
var toPrimitive = __webpack_require__(47);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(7)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(36).f;
var anObject = __webpack_require__(5);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(5);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(156)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(36);
var getPrototypeOf = __webpack_require__(37);
var has = __webpack_require__(29);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(8);
var anObject = __webpack_require__(5);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(36);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(5);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(37);
var anObject = __webpack_require__(5);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(5);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(253) });


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(5);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(16);
var gOPD = __webpack_require__(36);
var getPrototypeOf = __webpack_require__(37);
var has = __webpack_require__(29);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(67);
var anObject = __webpack_require__(5);
var isObject = __webpack_require__(8);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(148);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(114)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(64)('includes');


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(254);
var toObject = __webpack_require__(21);
var toLength = __webpack_require__(17);
var aFunction = __webpack_require__(25);
var arraySpeciesCreate = __webpack_require__(162);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(64)('flatMap');


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(254);
var toObject = __webpack_require__(21);
var toLength = __webpack_require__(17);
var toInteger = __webpack_require__(49);
var arraySpeciesCreate = __webpack_require__(162);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(64)('flatten');


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(154)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(255);
var userAgent = __webpack_require__(169);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(255);
var userAgent = __webpack_require__(169);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(87)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(87)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(48);
var toLength = __webpack_require__(17);
var isRegExp = __webpack_require__(117);
var getFlags = __webpack_require__(119);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(156)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(144)('asyncIterator');


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(144)('observable');


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(253);
var toIObject = __webpack_require__(35);
var gOPD = __webpack_require__(36);
var createProperty = __webpack_require__(160);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(256)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(256)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(21);
var aFunction = __webpack_require__(25);
var $defineProperty = __webpack_require__(16);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(15) && $export($export.P + __webpack_require__(124), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(21);
var aFunction = __webpack_require__(25);
var $defineProperty = __webpack_require__(16);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(15) && $export($export.P + __webpack_require__(124), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(21);
var toPrimitive = __webpack_require__(47);
var getPrototypeOf = __webpack_require__(37);
var getOwnPropertyDescriptor = __webpack_require__(36).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(15) && $export($export.P + __webpack_require__(124), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(21);
var toPrimitive = __webpack_require__(47);
var getPrototypeOf = __webpack_require__(37);
var getOwnPropertyDescriptor = __webpack_require__(36).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(15) && $export($export.P + __webpack_require__(124), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(257)('Map') });


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(257)('Set') });


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(125)('Map');


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(125)('Set');


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(125)('WeakMap');


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(125)('WeakSet');


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(126)('Map');


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(126)('Set');


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(126)('WeakMap');


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(126)('WeakSet');


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(6) });


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(6) });


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(41);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(259);
var fround = __webpack_require__(239);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(259) });


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(46);
var global = __webpack_require__(6);
var speciesConstructor = __webpack_require__(121);
var promiseResolve = __webpack_require__(246);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(167);
var perform = __webpack_require__(245);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(57);
var anObject = __webpack_require__(5);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(57);
var anObject = __webpack_require__(5);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(57);
var anObject = __webpack_require__(5);
var getPrototypeOf = __webpack_require__(37);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(249);
var from = __webpack_require__(258);
var metadata = __webpack_require__(57);
var anObject = __webpack_require__(5);
var getPrototypeOf = __webpack_require__(37);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(57);
var anObject = __webpack_require__(5);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(57);
var anObject = __webpack_require__(5);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(57);
var anObject = __webpack_require__(5);
var getPrototypeOf = __webpack_require__(37);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(57);
var anObject = __webpack_require__(5);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(57);
var anObject = __webpack_require__(5);
var aFunction = __webpack_require__(25);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(166)();
var process = __webpack_require__(6).process;
var isNode = __webpack_require__(41)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(6);
var core = __webpack_require__(46);
var microtask = __webpack_require__(166)();
var OBSERVABLE = __webpack_require__(11)('observable');
var aFunction = __webpack_require__(25);
var anObject = __webpack_require__(5);
var anInstance = __webpack_require__(75);
var redefineAll = __webpack_require__(77);
var hide = __webpack_require__(30);
var forOf = __webpack_require__(76);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(74)('Observable');


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(6);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(169);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(165);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(164);
var getKeys = __webpack_require__(70);
var redefine = __webpack_require__(31);
var global = __webpack_require__(6);
var hide = __webpack_require__(30);
var Iterators = __webpack_require__(88);
var wks = __webpack_require__(11);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(571);
module.exports = __webpack_require__(46).RegExp.escape;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(572)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(574).enable();
  window.Promise = __webpack_require__(576);
}

// fetch() polyfill for making API calls.
__webpack_require__(577);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(90);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(260);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(260);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 577 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactDom=__webpack_require__(65);var _reactDom2=_interopRequireDefault(_reactDom);
__webpack_require__(587);
var _App=__webpack_require__(588);var _App2=_interopRequireDefault(_App);
var _modules=__webpack_require__(19);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}



global.__APP_NAME__='Kids UP for Parents';

global.__APP_MODE__=

 false?
'local':

window.location.hostname.startsWith('dev')||
window.location.hostname.includes('firebaseapp')?
'dev':
'prod';


_modules.Modal.setAppElement('#root');

_reactDom2.default.render(_react2.default.createElement(_App2.default,null),document.getElementById('root'));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(90),n=__webpack_require__(127),p=__webpack_require__(58),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(1),l=__webpack_require__(24),B=__webpack_require__(90),C=__webpack_require__(58),ba=__webpack_require__(581),da=__webpack_require__(582),ea=__webpack_require__(261),fa=__webpack_require__(583),ia=__webpack_require__(586),D=__webpack_require__(127);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(58);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(584);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(585);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);
var _reactRedux=__webpack_require__(28);
var _react3=__webpack_require__(762);

var _modules=__webpack_require__(19);
var _store=__webpack_require__(898);var _store2=_interopRequireDefault(_store);
var _MainIndex=__webpack_require__(911);var _MainIndex2=_interopRequireDefault(_MainIndex);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

console.disableYellowBox=true;var _configureStore=

(0,_store2.default)(),persistor=_configureStore.persistor,store=_configureStore.store;var

App=function(_Component){_inherits(App,_Component);

function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this));

}_createClass(App,[{key:'render',value:function render()

{
return(
_react2.default.createElement(_reactRedux.Provider,{
store:store},
_react2.default.createElement(_react3.PersistGate,{
persistor:persistor},
_react2.default.createElement(_MainIndex2.default,null))));



}}]);return App;}(_react.Component);


if(_reactNative.Platform.OS==='web'){

}else{
console.log('add code push to app');
var codePushOptions={
checkFrequency:_modules.codePush.CheckFrequency.ON_APP_RESUME,
installMode:_modules.codePush.InstallMode.IMMEDIATE};

App=(0,_modules.codePush)(codePushOptions)(App);
}exports.default=

App;

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createDOMProps__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports_findNodeHandle__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exports_StyleSheet_styleResolver__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__exports_UIManager__ = __webpack_require__(52);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */






var NativeMethodsMixin = {
  /**
   * Removes focus from an input or view. This is the opposite of `focus()`.
   */
  blur: function blur() {
    __WEBPACK_IMPORTED_MODULE_3__exports_UIManager__["a" /* default */].blur(Object(__WEBPACK_IMPORTED_MODULE_1__exports_findNodeHandle__["a" /* default */])(this));
  },


  /**
   * Requests focus for the given input or view.
   * The exact behavior triggered will depend the type of view.
   */
  focus: function focus() {
    __WEBPACK_IMPORTED_MODULE_3__exports_UIManager__["a" /* default */].focus(Object(__WEBPACK_IMPORTED_MODULE_1__exports_findNodeHandle__["a" /* default */])(this));
  },


  /**
   * Determines the position and dimensions of the view
   */
  measure: function measure(callback) {
    __WEBPACK_IMPORTED_MODULE_3__exports_UIManager__["a" /* default */].measure(Object(__WEBPACK_IMPORTED_MODULE_1__exports_findNodeHandle__["a" /* default */])(this), callback);
  },


  /**
   * Determines the location of the given view in the window and returns the
   * values via an async callback. If the React root view is embedded in
   * another native view, this will give you the absolute coordinates. If
   * successful, the callback will be called be called with the following
   * arguments:
   *
   *  - x
   *  - y
   *  - width
   *  - height
   *
   * Note that these measurements are not available until after the rendering
   * has been completed.
   */
  measureInWindow: function measureInWindow(callback) {
    __WEBPACK_IMPORTED_MODULE_3__exports_UIManager__["a" /* default */].measureInWindow(Object(__WEBPACK_IMPORTED_MODULE_1__exports_findNodeHandle__["a" /* default */])(this), callback);
  },


  /**
   * Measures the view relative to another view (usually an ancestor)
   */
  measureLayout: function measureLayout(relativeToNativeNode, onSuccess, onFail) {
    __WEBPACK_IMPORTED_MODULE_3__exports_UIManager__["a" /* default */].measureLayout(Object(__WEBPACK_IMPORTED_MODULE_1__exports_findNodeHandle__["a" /* default */])(this), relativeToNativeNode, onFail, onSuccess);
  },


  /**
   * This function sends props straight to the underlying DOM node.
   * This works as if all styles were set as inline styles. Since a DOM node
   * may aleady be styled with class names and inline styles, we need to get
   * the initial styles from the DOM node and merge them with incoming props.
   */
  setNativeProps: function setNativeProps(nativeProps) {
    if (!nativeProps) {
      return;
    }
    var node = Object(__WEBPACK_IMPORTED_MODULE_1__exports_findNodeHandle__["a" /* default */])(this);
    // Next state is determined by comparison to existing state (in the DOM).
    // Existing state has already gone through i18n transform
    var domProps = Object(__WEBPACK_IMPORTED_MODULE_0__createDOMProps__["a" /* default */])(null, nativeProps, function (style) {
      return __WEBPACK_IMPORTED_MODULE_2__exports_StyleSheet_styleResolver__["a" /* default */].resolveWithNode(style, node);
    });
    __WEBPACK_IMPORTED_MODULE_3__exports_UIManager__["a" /* default */].updateView(node, domProps, this);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (NativeMethodsMixin);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2017-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isDisabled = function isDisabled(props) {
  return props.disabled || props['aria-disabled'];
};

/* harmony default export */ __webpack_exports__["a"] = (isDisabled);

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__propsToAriaRole__ = __webpack_require__(263);
/**
 * Copyright (c) 2017-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var roleComponents = {
  article: 'article',
  banner: 'header',
  complementary: 'aside',
  contentinfo: 'footer',
  form: 'form',
  label: 'label',
  link: 'a',
  list: 'ul',
  listitem: 'li',
  main: 'main',
  navigation: 'nav',
  region: 'section'
};

var emptyObject = {};

var propsToAccessibilityComponent = function propsToAccessibilityComponent() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyObject;

  var role = Object(__WEBPACK_IMPORTED_MODULE_0__propsToAriaRole__["a" /* default */])(props);
  if (role) {
    if (role === 'heading') {
      var level = props['aria-level'] || 1;
      return 'h' + level;
    }
    return roleComponents[role];
  }
};

/* harmony default export */ __webpack_exports__["a"] = (propsToAccessibilityComponent);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StyleSheetValidation__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_ReactNativePropRegistry__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flattenStyle__ = __webpack_require__(275);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */





var absoluteFillObject = {
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0
};
var absoluteFill = __WEBPACK_IMPORTED_MODULE_1__modules_ReactNativePropRegistry__["a" /* default */].register(absoluteFillObject);

var StyleSheet = {
  absoluteFill: absoluteFill,
  absoluteFillObject: absoluteFillObject,
  compose: function compose(style1, style2) {
    if (style1 && style2) {
      return [style1, style2];
    } else {
      return style1 || style2;
    }
  },
  create: function create(styles) {
    var result = {};
    Object.keys(styles).forEach(function (key) {
      if (false) {
        StyleSheetValidation.validateStyle(key, styles);
      }
      var id = styles[key] && __WEBPACK_IMPORTED_MODULE_1__modules_ReactNativePropRegistry__["a" /* default */].register(styles[key]);
      result[key] = id;
    });
    return result;
  },

  flatten: __WEBPACK_IMPORTED_MODULE_2__flattenStyle__["a" /* default */],
  hairlineWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (StyleSheet);

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Image_ImageStylePropTypes__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TextInput_TextInputStylePropTypes__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Text_TextStylePropTypes__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__View_ViewStylePropTypes__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_warning__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_fbjs_lib_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */








// Hardcoded because this is a legit case but we don't want to load it from
// a private API. We might likely want to unify style sheet creation with how it
// is done in the DOM so this might move into React. I know what I'm doing so
// plz don't fire me.
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var StyleSheetValidation = function () {
  function StyleSheetValidation() {
    _classCallCheck(this, StyleSheetValidation);
  }

  StyleSheetValidation.validateStyleProp = function validateStyleProp(prop, style, caller) {
    if (false) {
      var value = style[prop];

      var isCustomProperty = prop.indexOf('--') === 0;
      if (isCustomProperty) return;

      if (allStylePropTypes[prop] === undefined) {
        var message1 = '"' + prop + '" is not a valid style property.';
        var message2 = '\nValid style props: ' + JSON.stringify(Object.keys(allStylePropTypes).sort(), null, '  ');
        styleError(message1, style, caller, message2);
      } else if (typeof value === 'string' && value.indexOf('!important') > -1) {
        styleError('Invalid value of "' + value + '" set on prop "' + prop + '". Values cannot include "!important"', style, caller);
      } else {
        var error = allStylePropTypes[prop](style, prop, caller, 'prop', null, ReactPropTypesSecret);
        if (error) {
          styleError(error.message, style, caller);
        }
      }
    }
  };

  StyleSheetValidation.validateStyle = function validateStyle(name, styles) {
    if (false) {
      for (var prop in styles[name]) {
        StyleSheetValidation.validateStyleProp(prop, styles[name], 'StyleSheet ' + name);
      }
    }
  };

  StyleSheetValidation.addValidStylePropTypes = function addValidStylePropTypes(stylePropTypes) {
    for (var key in stylePropTypes) {
      allStylePropTypes[key] = stylePropTypes[key];
    }
  };

  return StyleSheetValidation;
}();

var styleError = function styleError(message1, style, caller, message2) {
  __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_warning___default()(false, message1 + '\n' + (caller || '<<unknown>>') + ': ' + JSON.stringify(style, null, '  ') + (message2 || ''));
};

var allStylePropTypes = {};

StyleSheetValidation.addValidStylePropTypes(__WEBPACK_IMPORTED_MODULE_0__Image_ImageStylePropTypes__["a" /* default */]);
StyleSheetValidation.addValidStylePropTypes(__WEBPACK_IMPORTED_MODULE_2__Text_TextStylePropTypes__["a" /* default */]);
StyleSheetValidation.addValidStylePropTypes(__WEBPACK_IMPORTED_MODULE_1__TextInput_TextInputStylePropTypes__["a" /* default */]);
StyleSheetValidation.addValidStylePropTypes(__WEBPACK_IMPORTED_MODULE_3__View_ViewStylePropTypes__["a" /* default */]);

StyleSheetValidation.addValidStylePropTypes({
  appearance: __WEBPACK_IMPORTED_MODULE_5_prop_types__["string"],
  borderCollapse: __WEBPACK_IMPORTED_MODULE_5_prop_types__["string"],
  borderSpacing: Object(__WEBPACK_IMPORTED_MODULE_5_prop_types__["oneOf"])([__WEBPACK_IMPORTED_MODULE_5_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_5_prop_types__["string"]]),
  clear: __WEBPACK_IMPORTED_MODULE_5_prop_types__["string"],
  cursor: __WEBPACK_IMPORTED_MODULE_5_prop_types__["string"],
  fill: __WEBPACK_IMPORTED_MODULE_5_prop_types__["string"],
  float: Object(__WEBPACK_IMPORTED_MODULE_5_prop_types__["oneOf"])(['end', 'left', 'none', 'right', 'start']),
  listStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types__["string"],
  pointerEvents: __WEBPACK_IMPORTED_MODULE_5_prop_types__["string"],
  tableLayout: __WEBPACK_IMPORTED_MODULE_5_prop_types__["string"],
  /* @private */
  MozAppearance: __WEBPACK_IMPORTED_MODULE_5_prop_types__["string"],
  WebkitAppearance: __WEBPACK_IMPORTED_MODULE_5_prop_types__["string"]
});

/* unused harmony default export */ var _unused_webpack_default_export = (StyleSheetValidation);

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(58);
var invariant = __webpack_require__(4);
var ReactPropTypesSecret = __webpack_require__(595);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isWebColor = function isWebColor(color) {
  return color === 'currentcolor' || color === 'currentColor' || color === 'inherit' || color.indexOf('var(') === 0;
};

/* harmony default export */ __webpack_exports__["a"] = (isWebColor);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createReactDOMStyle__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_flattenArray__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flattenStyle__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__I18nManager__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18nStyle__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_prefixStyles__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StyleSheetManager__ = __webpack_require__(617);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */

/**
 * WARNING: changes to this file in particular can cause significant changes to
 * the results of render performance benchmarks.
 */










var emptyObject = {};

var ReactNativeStyleResolver = function () {
  ReactNativeStyleResolver.prototype._init = function _init() {
    this.cache = { ltr: {}, rtl: {}, rtlNoSwap: {} };
    this.injectedCache = { ltr: {}, rtl: {}, rtlNoSwap: {} };
    this.styleSheetManager = new __WEBPACK_IMPORTED_MODULE_7__StyleSheetManager__["a" /* default */]();
  };

  function ReactNativeStyleResolver() {
    _classCallCheck(this, ReactNativeStyleResolver);

    this._init();
  }

  ReactNativeStyleResolver.prototype.getStyleSheet = function getStyleSheet() {
    // reset state on the server so critical css is always the result
    var sheet = this.styleSheetManager.getStyleSheet();
    if (!__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__["canUseDOM"]) {
      this._init();
    }
    return sheet;
  };

  ReactNativeStyleResolver.prototype._injectRegisteredStyle = function _injectRegisteredStyle(id) {
    var _this = this;

    var doLeftAndRightSwapInRTL = __WEBPACK_IMPORTED_MODULE_4__I18nManager__["a" /* default */].doLeftAndRightSwapInRTL,
        isRTL = __WEBPACK_IMPORTED_MODULE_4__I18nManager__["a" /* default */].isRTL;

    var dir = isRTL ? doLeftAndRightSwapInRTL ? 'rtl' : 'rtlNoSwap' : 'ltr';
    if (!this.injectedCache[dir][id]) {
      var style = Object(__WEBPACK_IMPORTED_MODULE_3__flattenStyle__["a" /* default */])(id);
      var domStyle = Object(__WEBPACK_IMPORTED_MODULE_1__createReactDOMStyle__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__i18nStyle__["a" /* default */])(style));
      Object.keys(domStyle).forEach(function (styleProp) {
        var value = domStyle[styleProp];
        if (value != null) {
          _this.styleSheetManager.injectDeclaration(styleProp, value);
        }
      });
      this.injectedCache[dir][id] = true;
    }
  };

  /**
   * Resolves a React Native style object to DOM attributes
   */


  ReactNativeStyleResolver.prototype.resolve = function resolve(style) {
    if (!style) {
      return emptyObject;
    }

    // fast and cachable
    if (typeof style === 'number') {
      this._injectRegisteredStyle(style);
      var _key = createCacheKey(style);
      return this._resolveStyleIfNeeded(style, _key);
    }

    // resolve a plain RN style object
    if (!Array.isArray(style)) {
      return this._resolveStyleIfNeeded(style);
    }

    // flatten the style array
    // cache resolved props when all styles are registered
    // otherwise fallback to resolving
    var flatArray = Object(__WEBPACK_IMPORTED_MODULE_2__modules_flattenArray__["a" /* default */])(style);
    var isArrayOfNumbers = true;
    for (var i = 0; i < flatArray.length; i++) {
      var id = flatArray[i];
      if (typeof id !== 'number') {
        isArrayOfNumbers = false;
      } else {
        this._injectRegisteredStyle(id);
      }
    }
    var key = isArrayOfNumbers ? createCacheKey(flatArray.join('-')) : null;
    return this._resolveStyleIfNeeded(flatArray, key);
  };

  /**
   * Resolves a React Native style object to DOM attributes, accounting for
   * the existing styles applied to the DOM node.
   *
   * To determine the next style, some of the existing DOM state must be
   * converted back into React Native styles.
   */


  ReactNativeStyleResolver.prototype.resolveWithNode = function resolveWithNode(rnStyleNext, node) {
    var _this2 = this;

    var _getDOMStyleInfo = getDOMStyleInfo(node),
        rdomClassList = _getDOMStyleInfo.classList,
        rdomStyle = _getDOMStyleInfo.style;
    // Convert the DOM classList back into a React Native form
    // Preserves unrecognized class names.


    var _rdomClassList$reduce = rdomClassList.reduce(function (styleProps, className) {
      var _styleSheetManager$ge = _this2.styleSheetManager.getDeclaration(className),
          prop = _styleSheetManager$ge.prop,
          value = _styleSheetManager$ge.value;

      if (prop) {
        styleProps.style[prop] = value;
      } else {
        styleProps.classList.push(className);
      }
      return styleProps;
    }, { classList: [], style: {} }),
        rnClassList = _rdomClassList$reduce.classList,
        rnStyle = _rdomClassList$reduce.style;

    // Create next DOM style props from current and next RN styles


    var _resolve = this.resolve([Object(__WEBPACK_IMPORTED_MODULE_5__i18nStyle__["a" /* default */])(rnStyle), rnStyleNext]),
        rdomClassListNext = _resolve.classList,
        rdomStyleNext = _resolve.style;

    // Final className
    // Add the current class names not managed by React Native


    var className = classListToString(rdomClassListNext.concat(rnClassList));

    // Final style
    // Next class names take priority over current inline styles
    var style = Object.assign({}, rdomStyle);
    rdomClassListNext.forEach(function (className) {
      var _styleSheetManager$ge2 = _this2.styleSheetManager.getDeclaration(className),
          prop = _styleSheetManager$ge2.prop;

      if (style[prop]) {
        style[prop] = '';
      }
    });
    // Next inline styles take priority over current inline styles
    Object.assign(style, rdomStyleNext);

    return { className: className, style: style };
  };

  /**
   * Resolves a React Native style object
   */


  ReactNativeStyleResolver.prototype._resolveStyle = function _resolveStyle(style) {
    var _this3 = this;

    var flatStyle = Object(__WEBPACK_IMPORTED_MODULE_3__flattenStyle__["a" /* default */])(style);
    var domStyle = Object(__WEBPACK_IMPORTED_MODULE_1__createReactDOMStyle__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__i18nStyle__["a" /* default */])(flatStyle));

    var props = Object.keys(domStyle).reduce(function (props, styleProp) {
      var value = domStyle[styleProp];
      if (value != null) {
        var className = _this3.styleSheetManager.getClassName(styleProp, value);
        if (className) {
          props.classList.push(className);
        } else {
          // Certain properties and values are not transformed by 'createReactDOMStyle' as they
          // require more complex transforms into multiple CSS rules. Here we assume that StyleManager
          // can bind these styles to a className, and prevent them becoming invalid inline-styles.
          if (styleProp === 'pointerEvents' || styleProp === 'placeholderTextColor' || styleProp === 'animationName') {
            var _className = _this3.styleSheetManager.injectDeclaration(styleProp, value);
            if (_className) {
              props.classList.push(_className);
            }
          } else {
            if (!props.style) {
              props.style = {};
            }
            // 4x slower render
            props.style[styleProp] = value;
          }
        }
      }
      return props;
    }, { classList: [] });

    props.className = classListToString(props.classList);
    if (props.style) {
      props.style = Object(__WEBPACK_IMPORTED_MODULE_6__modules_prefixStyles__["b" /* prefixInlineStyles */])(props.style);
    }
    return props;
  };

  /**
   * Caching layer over 'resolveStyle'
   */


  ReactNativeStyleResolver.prototype._resolveStyleIfNeeded = function _resolveStyleIfNeeded(style, key) {
    if (key) {
      var doLeftAndRightSwapInRTL = __WEBPACK_IMPORTED_MODULE_4__I18nManager__["a" /* default */].doLeftAndRightSwapInRTL,
          isRTL = __WEBPACK_IMPORTED_MODULE_4__I18nManager__["a" /* default */].isRTL;

      var dir = isRTL ? doLeftAndRightSwapInRTL ? 'rtl' : 'rtlNoSwap' : 'ltr';
      if (!this.cache[dir][key]) {
        // slow: convert style object to props and cache
        this.cache[dir][key] = this._resolveStyle(style);
      }
      return this.cache[dir][key];
    }
    return this._resolveStyle(style);
  };

  return ReactNativeStyleResolver;
}();

/**
 * Misc helpers
 */


/* harmony default export */ __webpack_exports__["a"] = (ReactNativeStyleResolver);
var createCacheKey = function createCacheKey(id) {
  var prefix = 'rn';
  return prefix + '-' + id;
};

var classListToString = function classListToString(list) {
  return list.join(' ').trim();
};

/**
 * Copies classList and style data from a DOM node
 */
var hyphenPattern = /-([a-z])/g;
var toCamelCase = function toCamelCase(str) {
  return str.replace(hyphenPattern, function (m) {
    return m[1].toUpperCase();
  });
};

var getDOMStyleInfo = function getDOMStyleInfo(node) {
  var nodeStyle = node.style;
  var classList = Array.prototype.slice.call(node.classList);
  var style = {};
  // DOM style is a CSSStyleDeclaration
  // https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleDeclaration
  for (var i = 0; i < nodeStyle.length; i += 1) {
    var property = nodeStyle.item(i);
    if (property) {
      // DOM style uses hyphenated prop names and may include vendor prefixes
      // Transform back into React DOM style.
      style[toCamelCase(property)] = nodeStyle.getPropertyValue(property);
    }
  }
  return { classList: classList, style: style };
};

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function flattenArray(array) {
  function flattenDown(array, result) {
    for (var i = 0; i < array.length; i++) {
      var value = array[i];

      if (Array.isArray(value)) {
        flattenDown(value, result);
      } else if (value != null && value !== false) {
        result.push(value);
      }
    }

    return result;
  }
  return flattenDown(array, []);
}

/* harmony default export */ __webpack_exports__["a"] = (flattenArray);

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrefixer;

var _prefixProperty = __webpack_require__(600);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(601);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _addNewValuesOnly = __webpack_require__(602);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(603);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  function prefixAll(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefixAll(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        style = (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  }

  return prefixAll;
}
module.exports = exports['default'];

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(282);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var newStyle = {};
    var requiredPrefixes = prefixProperties[property];
    var capitalizedProperty = (0, _capitalizeString2.default)(property);
    var keys = Object.keys(style);
    for (var i = 0; i < keys.length; i++) {
      var styleProperty = keys[i];
      if (styleProperty === property) {
        for (var j = 0; j < requiredPrefixes.length; j++) {
          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
        }
      }
      newStyle[styleProperty] = style[styleProperty];
    }
    return newStyle;
  }
  return style;
}
module.exports = exports['default'];

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
module.exports = exports["default"];

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
module.exports = exports["default"];

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inline_style_prefixer_static_plugins_crossFade__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inline_style_prefixer_static_plugins_crossFade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_inline_style_prefixer_static_plugins_crossFade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_inline_style_prefixer_static_plugins_cursor__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_inline_style_prefixer_static_plugins_cursor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_inline_style_prefixer_static_plugins_cursor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_inline_style_prefixer_static_plugins_filter__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_inline_style_prefixer_static_plugins_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_inline_style_prefixer_static_plugins_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_inline_style_prefixer_static_plugins_flex__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_inline_style_prefixer_static_plugins_flex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_inline_style_prefixer_static_plugins_flex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_inline_style_prefixer_static_plugins_flexboxIE__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_inline_style_prefixer_static_plugins_flexboxIE___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_inline_style_prefixer_static_plugins_flexboxIE__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_inline_style_prefixer_static_plugins_flexboxOld__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_inline_style_prefixer_static_plugins_flexboxOld___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_inline_style_prefixer_static_plugins_flexboxOld__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_inline_style_prefixer_static_plugins_gradient__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_inline_style_prefixer_static_plugins_gradient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_inline_style_prefixer_static_plugins_gradient__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_inline_style_prefixer_static_plugins_imageSet__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_inline_style_prefixer_static_plugins_imageSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_inline_style_prefixer_static_plugins_imageSet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_inline_style_prefixer_static_plugins_position__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_inline_style_prefixer_static_plugins_position___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_inline_style_prefixer_static_plugins_position__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_inline_style_prefixer_static_plugins_sizing__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_inline_style_prefixer_static_plugins_sizing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_inline_style_prefixer_static_plugins_sizing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_inline_style_prefixer_static_plugins_transition__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_inline_style_prefixer_static_plugins_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_inline_style_prefixer_static_plugins_transition__);











var w = ['Webkit'];
var m = ['Moz'];
var ms = ['ms'];
var wm = ['Webkit', 'Moz'];
var wms = ['Webkit', 'ms'];
var wmms = ['Webkit', 'Moz', 'ms'];

/* harmony default export */ __webpack_exports__["a"] = ({
  plugins: [__WEBPACK_IMPORTED_MODULE_0_inline_style_prefixer_static_plugins_crossFade___default.a, __WEBPACK_IMPORTED_MODULE_1_inline_style_prefixer_static_plugins_cursor___default.a, __WEBPACK_IMPORTED_MODULE_2_inline_style_prefixer_static_plugins_filter___default.a, __WEBPACK_IMPORTED_MODULE_3_inline_style_prefixer_static_plugins_flex___default.a, __WEBPACK_IMPORTED_MODULE_4_inline_style_prefixer_static_plugins_flexboxIE___default.a, __WEBPACK_IMPORTED_MODULE_5_inline_style_prefixer_static_plugins_flexboxOld___default.a, __WEBPACK_IMPORTED_MODULE_6_inline_style_prefixer_static_plugins_gradient___default.a, __WEBPACK_IMPORTED_MODULE_7_inline_style_prefixer_static_plugins_imageSet___default.a, __WEBPACK_IMPORTED_MODULE_8_inline_style_prefixer_static_plugins_position___default.a, __WEBPACK_IMPORTED_MODULE_9_inline_style_prefixer_static_plugins_sizing___default.a, __WEBPACK_IMPORTED_MODULE_10_inline_style_prefixer_static_plugins_transition___default.a],
  prefixMap: {
    animation: w,
    animationDelay: w,
    animationDirection: w,
    animationFillMode: w,
    animationDuration: w,
    animationIterationCount: w,
    animationName: w,
    animationPlayState: w,
    animationTimingFunction: w,
    appearance: wm,
    userSelect: wmms,
    textEmphasisPosition: w,
    textEmphasis: w,
    textEmphasisStyle: w,
    textEmphasisColor: w,
    boxDecorationBreak: w,
    clipPath: w,
    maskImage: w,
    maskMode: w,
    maskRepeat: w,
    maskPosition: w,
    maskClip: w,
    maskOrigin: w,
    maskSize: w,
    maskComposite: w,
    mask: w,
    maskBorderSource: w,
    maskBorderMode: w,
    maskBorderSlice: w,
    maskBorderWidth: w,
    maskBorderOutset: w,
    maskBorderRepeat: w,
    maskBorder: w,
    maskType: w,
    textDecorationStyle: w,
    textDecorationSkip: w,
    textDecorationLine: w,
    textDecorationColor: w,
    filter: w,
    fontFeatureSettings: w,
    breakAfter: wmms,
    breakBefore: wmms,
    breakInside: wmms,
    columnCount: wm,
    columnFill: wm,
    columnGap: wm,
    columnRule: wm,
    columnRuleColor: wm,
    columnRuleStyle: wm,
    columnRuleWidth: wm,
    columns: wm,
    columnSpan: wm,
    columnWidth: wm,
    writingMode: wms,
    flex: wms,
    flexBasis: w,
    flexDirection: wms,
    flexGrow: w,
    flexFlow: wms,
    flexShrink: w,
    flexWrap: wms,
    alignContent: w,
    alignItems: w,
    alignSelf: w,
    justifyContent: w,
    order: w,
    transform: w,
    transformOrigin: w,
    transformOriginX: w,
    transformOriginY: w,
    backfaceVisibility: w,
    perspective: w,
    perspectiveOrigin: w,
    transformStyle: w,
    transformOriginZ: w,
    backdropFilter: w,
    fontKerning: w,
    scrollSnapType: wms,
    scrollSnapPointsX: wms,
    scrollSnapPointsY: wms,
    scrollSnapDestination: wms,
    scrollSnapCoordinate: wms,
    shapeImageThreshold: w,
    shapeImageMargin: w,
    shapeImageOutside: w,
    hyphens: wmms,
    flowInto: wms,
    flowFrom: wms,
    regionFragment: wms,
    textAlignLast: m,
    tabSize: m,
    wrapFlow: ms,
    wrapThrough: ms,
    wrapMargin: ms,
    touchAction: ms,
    gridTemplateColumns: ms,
    gridTemplateRows: ms,
    gridTemplateAreas: ms,
    gridTemplate: ms,
    gridAutoColumns: ms,
    gridAutoRows: ms,
    gridAutoFlow: ms,
    grid: ms,
    gridRowStart: ms,
    gridColumnStart: ms,
    gridRowEnd: ms,
    gridRow: ms,
    gridColumn: ms,
    gridColumnEnd: ms,
    gridColumnGap: ms,
    gridRowGap: ms,
    gridArea: ms,
    gridGap: ms,
    textSizeAdjust: wms,
    borderImage: w,
    borderImageOutset: w,
    borderImageRepeat: w,
    borderImageSlice: w,
    borderImageSource: w,
    borderImageWidth: w,
    transitionDelay: w,
    transitionDuration: w,
    transitionProperty: w,
    transitionTimingFunction: w
  }
});

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;

var _isPrefixedValue = __webpack_require__(104);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#search=cross-fade
var prefixes = ['-webkit-', ''];
function crossFade(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;

var _isPrefixedValue = __webpack_require__(104);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-filter-function
var prefixes = ['-webkit-', ''];
function filter(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports['default'];

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;
var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style) {
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple',
  flex: 'box',
  'inline-flex': 'inline-box'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines',
  flexGrow: 'WebkitBoxFlex'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(104);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return value.replace(values, function (grad) {
        return prefix + grad;
      });
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;

var _isPrefixedValue = __webpack_require__(104);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ['-webkit-', ''];
function imageSet(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}
module.exports = exports['default'];

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(616);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(104);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(282);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports['default'];

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(178);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAtomicRules__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vendor_hash__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__initialRules__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WebStyleSheet__ = __webpack_require__(622);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */






var emptyObject = {};
var STYLE_ELEMENT_ID = 'react-native-stylesheet';

var createClassName = function createClassName(prop, value) {
  var hashed = Object(__WEBPACK_IMPORTED_MODULE_1__vendor_hash__["a" /* default */])(prop + normalizeValue(value));
  return  false ? 'rn-' + prop + '-' + hashed : 'rn-' + hashed;
};

var normalizeValue = function normalizeValue(value) {
  return typeof value === 'object' ? JSON.stringify(value) : value;
};

var StyleSheetManager = function () {
  function StyleSheetManager() {
    var _this = this;

    _classCallCheck(this, StyleSheetManager);

    this._cache = {
      byClassName: {},
      byProp: {}
    };

    this._sheet = new __WEBPACK_IMPORTED_MODULE_3__WebStyleSheet__["a" /* default */](STYLE_ELEMENT_ID);
    __WEBPACK_IMPORTED_MODULE_2__initialRules__["a" /* default */].forEach(function (rule) {
      _this._sheet.insertRuleOnce(rule);
    });
  }

  StyleSheetManager.prototype.getClassName = function getClassName(prop, value) {
    var val = normalizeValue(value);
    var cache = this._cache.byProp;
    return cache[prop] && cache[prop].hasOwnProperty(val) && cache[prop][val];
  };

  StyleSheetManager.prototype.getDeclaration = function getDeclaration(className) {
    var cache = this._cache.byClassName;
    return cache[className] || emptyObject;
  };

  StyleSheetManager.prototype.getStyleSheet = function getStyleSheet() {
    var cssText = this._sheet.cssText;


    return {
      id: STYLE_ELEMENT_ID,
      textContent: cssText
    };
  };

  StyleSheetManager.prototype.injectDeclaration = function injectDeclaration(prop, value) {
    var _this2 = this;

    var val = normalizeValue(value);
    var className = this.getClassName(prop, val);
    if (!className) {
      className = createClassName(prop, val);
      this._addToCache(className, prop, val);
      var rules = Object(__WEBPACK_IMPORTED_MODULE_0__createAtomicRules__["a" /* default */])('.' + className, prop, value);
      rules.forEach(function (rule) {
        _this2._sheet.insertRuleOnce(rule);
      });
    }
    return className;
  };

  StyleSheetManager.prototype._addToCache = function _addToCache(className, prop, value) {
    var cache = this._cache;
    if (!cache.byProp[prop]) {
      cache.byProp[prop] = {};
    }
    cache.byProp[prop][value] = className;
    cache.byClassName[className] = { prop: prop, value: value };
  };

  return StyleSheetManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (StyleSheetManager);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createKeyframesRules__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRuleBlock__ = __webpack_require__(283);



var createAtomicRules = function createAtomicRules(selector, prop, value) {
  var rules = [];

  // Handle custom properties and custom values that require additional rules
  // to be created.
  switch (prop) {
    // See #513
    case 'pointerEvents':
      {
        var _createRuleBlock3;

        var val = value;
        if (value === 'auto' || value === 'box-only') {
          val = 'auto !important';
          if (value === 'box-only') {
            var _createRuleBlock;

            var _block = Object(__WEBPACK_IMPORTED_MODULE_1__createRuleBlock__["a" /* default */])((_createRuleBlock = {}, _createRuleBlock[prop] = 'none', _createRuleBlock));
            rules.push(selector + ' > *{' + _block + '}');
          }
        } else if (value === 'none' || value === 'box-none') {
          val = 'none !important';
          if (value === 'box-none') {
            var _createRuleBlock2;

            var _block2 = Object(__WEBPACK_IMPORTED_MODULE_1__createRuleBlock__["a" /* default */])((_createRuleBlock2 = {}, _createRuleBlock2[prop] = 'auto', _createRuleBlock2));
            rules.push(selector + ' > *{' + _block2 + '}');
          }
        }
        var block = Object(__WEBPACK_IMPORTED_MODULE_1__createRuleBlock__["a" /* default */])((_createRuleBlock3 = {}, _createRuleBlock3[prop] = val, _createRuleBlock3));
        rules.push(selector + '{' + block + '}');
        break;
      }

    case 'placeholderTextColor':
      {
        var _block3 = Object(__WEBPACK_IMPORTED_MODULE_1__createRuleBlock__["a" /* default */])({ color: value, opacity: 1 });
        rules.push('@media all {' + (selector + '::-webkit-input-placeholder{' + _block3 + '}') + (selector + '::-moz-placeholder{' + _block3 + '}') + (selector + ':-ms-input-placeholder{' + _block3 + '}') + (selector + '::placeholder{' + _block3 + '}') + '}');
        break;
      }

    case 'animationName':
      {
        if (typeof value === 'string') {
          var _createRuleBlock4;

          // add a className referencing the animation
          var _block4 = Object(__WEBPACK_IMPORTED_MODULE_1__createRuleBlock__["a" /* default */])((_createRuleBlock4 = {}, _createRuleBlock4[prop] = value, _createRuleBlock4));
          rules.push(selector + '{' + _block4 + '}');
        } else {
          var _createRuleBlock5;

          var animationNames = [];

          // add the keyframes needed to implement each value
          value.forEach(function (keyframes) {
            if (typeof keyframes === 'string') {
              animationNames.push(keyframes);
            } else {
              var _createKeyframesRules = Object(__WEBPACK_IMPORTED_MODULE_0__createKeyframesRules__["a" /* default */])(keyframes),
                  identifier = _createKeyframesRules.identifier,
                  keyframesRules = _createKeyframesRules.rules;

              keyframesRules.forEach(function (rule) {
                rules.push(rule);
              });
              animationNames.push(identifier);
            }
          });

          // add a className referencing the animation identifiers
          var _block5 = Object(__WEBPACK_IMPORTED_MODULE_1__createRuleBlock__["a" /* default */])((_createRuleBlock5 = {}, _createRuleBlock5[prop] = animationNames.join(','), _createRuleBlock5));
          rules.push(selector + '{' + _block5 + '}');
        }

        break;
      }

    default:
      {
        var _createRuleBlock6;

        var _block6 = Object(__WEBPACK_IMPORTED_MODULE_1__createRuleBlock__["a" /* default */])((_createRuleBlock6 = {}, _createRuleBlock6[prop] = value, _createRuleBlock6));
        rules.push(selector + '{' + _block6 + '}');
      }
  }

  return rules;
};

/* harmony default export */ __webpack_exports__["a"] = (createAtomicRules);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createRuleBlock__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createReactDOMStyle__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18nStyle__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_hash__ = __webpack_require__(284);





var hashObject = function hashObject(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__vendor_hash__["a" /* default */])(JSON.stringify(obj));
};

var createIdentifier = function createIdentifier(obj) {
  var hashed = hashObject(obj);
  return  false ? 'rn-anim-' + hashed : 'rn-' + hashed;
};

var prefixes = ['-webkit-', ''];

var makeBlock = function makeBlock(rule) {
  var domStyle = Object(__WEBPACK_IMPORTED_MODULE_1__createReactDOMStyle__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__i18nStyle__["a" /* default */])(rule));
  return Object(__WEBPACK_IMPORTED_MODULE_0__createRuleBlock__["a" /* default */])(domStyle);
};

var makeSteps = function makeSteps(keyframes) {
  return Object.keys(keyframes).map(function (stepName) {
    var rule = keyframes[stepName];
    var block = makeBlock(rule);
    return stepName + '{' + block + '}';
  }).join('');
};

var createKeyframesRules = function createKeyframesRules(keyframes) {
  var identifier = createIdentifier(keyframes);
  var rules = prefixes.map(function (prefix) {
    return '@media all {@' + prefix + 'keyframes ' + identifier + '{' + makeSteps(keyframes) + '}}';
  });
  return { identifier: identifier, rules: rules };
};

/* harmony default export */ __webpack_exports__["a"] = (createKeyframesRules);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var hasOwnProperty = Object.prototype.hasOwnProperty;

var mapKeyValue = function mapKeyValue(obj, fn) {
  var result = [];
  for (var key in obj) {
    if (hasOwnProperty.call(obj, key)) {
      var r = fn(key, obj[key]);
      r && result.push(r);
    }
  }
  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (mapKeyValue);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

// Prevent browsers throwing parse errors, e.g., on vendor-prefixed pseudo-elements
var safeRule = function safeRule(rule) {
  return '@media all{\n' + rule + '\n}';
};

var resets = [
// minimal top-level reset
'html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:rgba(0,0,0,0);}', 'body{margin:0;}',
// minimal form pseudo-element reset
'button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0;}', 'input::-webkit-inner-spin-button,input::-webkit-outer-spin-button,' + 'input::-webkit-search-cancel-button,input::-webkit-search-decoration,' + 'input::-webkit-search-results-button,input::-webkit-search-results-decoration{display:none;}'];

var reset = [safeRule(resets.join('\n'))];

/* harmony default export */ __webpack_exports__["a"] = (reset);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modality__ = __webpack_require__(623);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var WebStyleSheet = function () {
  function WebStyleSheet(id) {
    _classCallCheck(this, WebStyleSheet);

    this._cssRules = [];
    this._sheet = null;
    this._textContent = '';

    var domStyleElement = void 0;

    // on the client we check for an existing style sheet before injecting
    if (__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__["canUseDOM"]) {
      domStyleElement = document.getElementById(id);
      if (!domStyleElement) {
        var html = '<style id="' + id + '"></style>';
        if (document.head) {
          document.head.insertAdjacentHTML('afterbegin', html);
          domStyleElement = document.getElementById(id);
        }
      }

      if (domStyleElement) {
        Object(__WEBPACK_IMPORTED_MODULE_1__modality__["a" /* default */])(domStyleElement);
        // $FlowFixMe
        this._sheet = domStyleElement.sheet;
        this._textContent = domStyleElement.textContent;
      }
    }
  }

  WebStyleSheet.prototype.containsRule = function containsRule(rule) {
    return this._cssRules.indexOf(rule) > -1;
  };

  WebStyleSheet.prototype.insertRuleOnce = function insertRuleOnce(rule, position) {
    // Reduce chance of duplicate rules
    if (!this.containsRule(rule)) {
      this._cssRules.push(rule);

      // Check whether a rule was part of any prerendered styles (textContent
      // doesn't include styles injected via 'insertRule')
      if (this._textContent.indexOf(rule) === -1 && this._sheet) {
        var pos = position || this._sheet.cssRules.length;
        this._sheet.insertRule(rule, pos);
      }
    }
  };

  _createClass(WebStyleSheet, [{
    key: 'cssText',
    get: function get() {
      return this._cssRules.join('\n');
    }
  }]);

  return WebStyleSheet;
}();

/* harmony default export */ __webpack_exports__["a"] = (WebStyleSheet);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__);
/**
 * Adapts focus styles based on the user's active input modality (i.e., how
 * they are interacting with the UI right now).
 *
 * Focus styles are only relevant when using the keyboard to interact with the
 * page. If we only show the focus ring when relevant, we can avoid user
 * confusion without compromising accessibility.
 *
 * The script uses two heuristics to determine whether the keyboard is being used:
 *
 * 1. a keydown event occurred immediately before a focus event;
 * 2. a focus event happened on an element which requires keyboard interaction (e.g., a text field);
 *
 * Based on https://github.com/WICG/focus-ring
 *
 * @noflow
 */



var rule = ':focus { outline: none; }';
var ruleExists = false;

var modality = function modality(styleElement) {
  if (!__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__["canUseDOM"]) {
    return;
  }

  var hadKeyboardEvent = false;
  var keyboardThrottleTimeoutID = 0;

  var proto = window.Element.prototype;
  var matches = proto.matches || proto.mozMatchesSelector || proto.msMatchesSelector || proto.webkitMatchesSelector;

  // These elements should always have a focus ring drawn, because they are
  // associated with switching to a keyboard modality.
  var keyboardModalityWhitelist = ['input:not([type])', 'input[type=text]', 'input[type=search]', 'input[type=url]', 'input[type=tel]', 'input[type=email]', 'input[type=password]', 'input[type=number]', 'input[type=date]', 'input[type=month]', 'input[type=week]', 'input[type=time]', 'input[type=datetime]', 'input[type=datetime-local]', 'textarea', '[role=textbox]'].join(',');

  /**
   * Computes whether the given element should automatically trigger the
   * `focus-ring`.
   */
  var focusTriggersKeyboardModality = function focusTriggersKeyboardModality(el) {
    if (matches) {
      return matches.call(el, keyboardModalityWhitelist) && matches.call(el, ':not([readonly])');
    } else {
      return false;
    }
  };

  /**
   * Add the focus ring style
   */
  var addFocusRing = function addFocusRing() {
    if (styleElement && ruleExists) {
      styleElement.sheet.deleteRule(0);
      ruleExists = false;
    }
  };

  /**
   * Remove the focus ring style
   */
  var removeFocusRing = function removeFocusRing() {
    if (styleElement && !ruleExists) {
      styleElement.sheet.insertRule(rule, 0);
      ruleExists = true;
    }
  };

  /**
   * On `keydown`, set `hadKeyboardEvent`, to be removed 100ms later if there
   * are no further keyboard events. The 100ms throttle handles cases where
   * focus is redirected programmatically after a keyboard event, such as
   * opening a menu or dialog.
   */
  var handleKeyDown = function handleKeyDown(e) {
    hadKeyboardEvent = true;
    if (keyboardThrottleTimeoutID !== 0) {
      clearTimeout(keyboardThrottleTimeoutID);
    }
    keyboardThrottleTimeoutID = setTimeout(function () {
      hadKeyboardEvent = false;
      keyboardThrottleTimeoutID = 0;
    }, 100);
  };

  /**
   * Display the focus-ring when the keyboard was used to focus
   */
  var handleFocus = function handleFocus(e) {
    if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
      addFocusRing();
    }
  };

  /**
   * Remove the focus-ring when the keyboard was used to focus
   */
  var handleBlur = function handleBlur() {
    if (!hadKeyboardEvent) {
      removeFocusRing();
    }
  };

  if (document.body && document.body.addEventListener) {
    removeFocusRing();
    document.body.addEventListener('keydown', handleKeyDown, true);
    document.body.addEventListener('focus', handleFocus, true);
    document.body.addEventListener('blur', handleBlur, true);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (modality);

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dangerousStyleValue__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hyphenate_style_name__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hyphenate_style_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hyphenate_style_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__warnValidStyle__ = __webpack_require__(626);
/* eslint-disable */

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on React 16.3.0
 */





/**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */
function setValueForStyles(node, styles, getStack) {
  var style = node.style;
  for (var styleName in styles) {
    if (!styles.hasOwnProperty(styleName)) {
      continue;
    }
    var isCustomProperty = styleName.indexOf('--') === 0;
    var isImportant = typeof styles[styleName] === 'string' && styles[styleName].indexOf('!important') > -1;
    if (false) {
      if (!isCustomProperty) {
        warnValidStyle(styleName, styles[styleName], getStack);
      }
    }
    var styleValue = Object(__WEBPACK_IMPORTED_MODULE_0__dangerousStyleValue__["a" /* default */])(styleName, styles[styleName], isCustomProperty);
    if (styleName === 'float') {
      styleName = 'cssFloat';
    }
    if (isCustomProperty || isImportant) {
      var name = isCustomProperty ? styleName : __WEBPACK_IMPORTED_MODULE_1_hyphenate_style_name___default()(styleName);
      if (isImportant) {
        var _styleValue$split = styleValue.split('!'),
            value = _styleValue$split[0],
            priority = _styleValue$split[1];

        style.setProperty(name, value, priority);
      } else {
        style.setProperty(name, styleValue);
      }
    } else {
      style[styleName] = styleValue;
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (setValueForStyles);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_unitlessNumbers__ = __webpack_require__(277);
/* eslint-disable */

/**
 * Copyright 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * From React 16.0.0
 */



/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(__WEBPACK_IMPORTED_MODULE_0__modules_unitlessNumbers__["a" /* default */].hasOwnProperty(name) && __WEBPACK_IMPORTED_MODULE_0__modules_unitlessNumbers__["a" /* default */][name])) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return ('' + value).trim();
}

/* harmony default export */ __webpack_exports__["a"] = (dangerousStyleValue);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */

/**
 * Copyright 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on React 16.3.0
 */

var emptyFunction = __webpack_require__(58);

var warnValidStyle = emptyFunction;

if (false) {
  var getComponentName = function getComponentName(instanceOrFiber) {
    if (typeof instanceOrFiber.getName === 'function') {
      // Stack reconciler
      var instance = instanceOrFiber;
      return instance.getName();
    }
    if (typeof instanceOrFiber.tag === 'number') {
      // Fiber reconciler
      var fiber = instanceOrFiber;
      var type = fiber.type;

      if (typeof type === 'string') {
        return type;
      }
      if (typeof type === 'function') {
        return type.displayName || type.name;
      }
    }
    return null;
  };

  // 'msTransform' is correct, but the other prefixes should be capitalized


  var camelizeStyleName = require('fbjs/lib/camelizeStyleName');
  var warning = require('fbjs/lib/warning');

  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;
  var warnedForInfinityValue = false;

  var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner));
  };

  var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner));
  };

  var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, ''));
  };

  var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner));
  };

  var warnStyleValueIsInfinity = function warnStyleValueIsInfinity(name, value, owner) {
    if (warnedForInfinityValue) {
      return;
    }

    warnedForInfinityValue = true;
    warning(false, '`Infinity` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner));
  };

  var checkRenderMessage = function checkRenderMessage(owner) {
    var ownerName;
    if (owner != null) {
      // Stack passes the owner manually all the way to CSSPropertyOperations.
      ownerName = getComponentName(owner);
    } else {
      // Fiber doesn't pass it but uses ReactDebugCurrentFiber to track it.
      // It is only enabled in development and tracks host components too.
      // var {getCurrentFiberOwnerName} = require('ReactDebugCurrentFiber');
      //  ownerName = getCurrentFiberOwnerName();
      // TODO: also report the stack.
    }
    if (ownerName) {
      return '\n\nCheck the render method of `' + ownerName + '`.';
    }
    return '';
  };

  warnValidStyle = function warnValidStyle(name, value, component) {
    var owner;
    if (component) {
      // TODO: this only works with Stack. Seems like we need to add unit tests?
      // owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number') {
      if (isNaN(value)) {
        warnStyleValueIsNaN(name, value, owner);
      } else if (!isFinite(value)) {
        warnStyleValueIsInfinity(name, value, owner);
      }
    }
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (warnValidStyle);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__normalizeNativeEvent__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_unstable_native_dependencies__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_unstable_native_dependencies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom_unstable_native_dependencies__);
// based on https://github.com/facebook/react/pull/4303/files




var ResponderEventPlugin = __WEBPACK_IMPORTED_MODULE_1_react_dom_unstable_native_dependencies___default.a.ResponderEventPlugin,
    ResponderTouchHistoryStore = __WEBPACK_IMPORTED_MODULE_1_react_dom_unstable_native_dependencies___default.a.ResponderTouchHistoryStore;

// On older versions of React (< 16.4) we have to inject the dependencies in
// order for the plugin to work properly in the browser. This version still
// uses `top*` strings to identify the internal event names.
// https://github.com/facebook/react/pull/12629

if (!ResponderEventPlugin.eventTypes.responderMove.dependencies) {
  var topMouseDown = 'topMouseDown';
  var topMouseMove = 'topMouseMove';
  var topMouseUp = 'topMouseUp';
  var topScroll = 'topScroll';
  var topSelectionChange = 'topSelectionChange';
  var topTouchCancel = 'topTouchCancel';
  var topTouchEnd = 'topTouchEnd';
  var topTouchMove = 'topTouchMove';
  var topTouchStart = 'topTouchStart';

  var endDependencies = [topTouchCancel, topTouchEnd, topMouseUp];
  var moveDependencies = [topTouchMove, topMouseMove];
  var startDependencies = [topTouchStart, topMouseDown];

  /**
   * Setup ResponderEventPlugin dependencies
   */
  ResponderEventPlugin.eventTypes.responderMove.dependencies = moveDependencies;
  ResponderEventPlugin.eventTypes.responderEnd.dependencies = endDependencies;
  ResponderEventPlugin.eventTypes.responderStart.dependencies = startDependencies;
  ResponderEventPlugin.eventTypes.responderRelease.dependencies = endDependencies;
  ResponderEventPlugin.eventTypes.responderTerminationRequest.dependencies = [];
  ResponderEventPlugin.eventTypes.responderGrant.dependencies = [];
  ResponderEventPlugin.eventTypes.responderReject.dependencies = [];
  ResponderEventPlugin.eventTypes.responderTerminate.dependencies = [];
  ResponderEventPlugin.eventTypes.moveShouldSetResponder.dependencies = moveDependencies;
  ResponderEventPlugin.eventTypes.selectionChangeShouldSetResponder.dependencies = [topSelectionChange];
  ResponderEventPlugin.eventTypes.scrollShouldSetResponder.dependencies = [topScroll];
  ResponderEventPlugin.eventTypes.startShouldSetResponder.dependencies = startDependencies;
}

var lastActiveTouchTimestamp = null;

var originalExtractEvents = ResponderEventPlugin.extractEvents;
ResponderEventPlugin.extractEvents = function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var hasActiveTouches = ResponderTouchHistoryStore.touchHistory.numberActiveTouches > 0;
  var eventType = nativeEvent.type;

  var shouldSkipMouseAfterTouch = false;
  if (eventType.indexOf('touch') > -1) {
    lastActiveTouchTimestamp = Date.now();
  } else if (lastActiveTouchTimestamp && eventType.indexOf('mouse') > -1) {
    var now = Date.now();
    shouldSkipMouseAfterTouch = now - lastActiveTouchTimestamp < 250;
  }

  if (
  // Filter out mousemove and mouseup events when a touch hasn't started yet
  (eventType === 'mousemove' || eventType === 'mouseup') && !hasActiveTouches ||
  // Filter out events from wheel/middle and right click.
  nativeEvent.button === 1 || nativeEvent.button === 2 ||
  // Filter out mouse events that browsers dispatch immediately after touch events end
  // Prevents the REP from calling handlers twice for touch interactions.
  // See #802 and #932.
  shouldSkipMouseAfterTouch) {
    return;
  }

  var normalizedEvent = Object(__WEBPACK_IMPORTED_MODULE_0__normalizeNativeEvent__["a" /* default */])(nativeEvent);

  return originalExtractEvents.call(ResponderEventPlugin, topLevelType, targetInst, normalizedEvent, nativeEventTarget);
};

/* harmony default export */ __webpack_exports__["a"] = (ResponderEventPlugin);

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(629);
} else {
  module.exports = require('./cjs/react-dom-unstable-native-dependencies.development.js');
}


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom-unstable-native-dependencies.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(65),k=__webpack_require__(90),l=__webpack_require__(58);
function n(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,f=0;f<b;f++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[f+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}var p=null,q=null,t=null;
function u(a){return"topMouseUp"===a||"topTouchEnd"===a||"topTouchCancel"===a}function v(a){return"topMouseMove"===a||"topTouchMove"===a}function w(a){return"topMouseDown"===a||"topTouchStart"===a}function x(a){var b=a._dispatchListeners,c=a._dispatchInstances;Array.isArray(b)?n("103"):void 0;a.currentTarget=b?t(c):null;b=b?b(a):null;a.currentTarget=null;a._dispatchListeners=null;a._dispatchInstances=null;return b}function y(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}
function z(a,b,c){for(var f=[];a;)f.push(a),a=y(a);for(a=f.length;0<a--;)b(f[a],"captured",c);for(a=0;a<f.length;a++)b(f[a],"bubbled",c)}function A(a,b){null==b?n("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function B(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}
function C(a,b){var c=a.stateNode;if(!c)return null;var f=p(c);if(!f)return null;c=f[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(f=!f.disabled)||(a=a.type,f=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!f;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?n("231",b,typeof c):void 0;
return c}function D(a,b,c){if(b=C(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=A(c._dispatchListeners,b),c._dispatchInstances=A(c._dispatchInstances,a)}function E(a){a&&a.dispatchConfig.phasedRegistrationNames&&z(a._targetInst,D,a)}function aa(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?y(b):null;z(b,D,a)}}
function F(a){if(a&&a.dispatchConfig.registrationName){var b=a._targetInst;if(b&&a&&a.dispatchConfig.registrationName){var c=C(b,a.dispatchConfig.registrationName);c&&(a._dispatchListeners=A(a._dispatchListeners,c),a._dispatchInstances=A(a._dispatchInstances,b))}}}
var G="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),ba={type:null,target:null,currentTarget:l.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,f){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var d in a)a.hasOwnProperty(d)&&((b=a[d])?this[d]=b(c):"target"===d?this.target=f:this[d]=c[d]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?l.thatReturnsTrue:l.thatReturnsFalse;this.isPropagationStopped=l.thatReturnsFalse;return this}
k(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=l.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=l.thatReturnsTrue)},persist:function(){this.isPersistent=l.thatReturnsTrue},isPersistent:l.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<G.length;a++)this[G[a]]=null}});H.Interface=ba;H.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var f=new c;k(f,a.prototype);a.prototype=f;a.prototype.constructor=a;a.Interface=k({},this.Interface,b);a.augmentClass=this.augmentClass;I(a)};I(H);function ca(a,b,c,f){if(this.eventPool.length){var d=this.eventPool.pop();this.call(d,a,b,c,f);return d}return new this(a,b,c,f)}
function da(a){a instanceof this?void 0:n("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function I(a){a.eventPool=[];a.getPooled=ca;a.release=da}function J(a,b,c,f){return H.call(this,a,b,c,f)}H.augmentClass(J,{touchHistory:function(){return null}});var L=[],M={touchBank:L,numberActiveTouches:0,indexOfSingleActiveTouch:-1,mostRecentTimeStamp:0};function N(a){return a.timeStamp||a.timestamp}function O(a){a=a.identifier;null==a?n("138"):void 0;return a}
function ea(a){var b=O(a),c=L[b];c?(c.touchActive=!0,c.startPageX=a.pageX,c.startPageY=a.pageY,c.startTimeStamp=N(a),c.currentPageX=a.pageX,c.currentPageY=a.pageY,c.currentTimeStamp=N(a),c.previousPageX=a.pageX,c.previousPageY=a.pageY,c.previousTimeStamp=N(a)):(c={touchActive:!0,startPageX:a.pageX,startPageY:a.pageY,startTimeStamp:N(a),currentPageX:a.pageX,currentPageY:a.pageY,currentTimeStamp:N(a),previousPageX:a.pageX,previousPageY:a.pageY,previousTimeStamp:N(a)},L[b]=c);M.mostRecentTimeStamp=N(a)}
function fa(a){var b=L[O(a)];b?(b.touchActive=!0,b.previousPageX=b.currentPageX,b.previousPageY=b.currentPageY,b.previousTimeStamp=b.currentTimeStamp,b.currentPageX=a.pageX,b.currentPageY=a.pageY,b.currentTimeStamp=N(a),M.mostRecentTimeStamp=N(a)):console.error("Cannot record touch move without a touch start.\nTouch Move: %s\n","Touch Bank: %s",P(a),Q())}
function ha(a){var b=L[O(a)];b?(b.touchActive=!1,b.previousPageX=b.currentPageX,b.previousPageY=b.currentPageY,b.previousTimeStamp=b.currentTimeStamp,b.currentPageX=a.pageX,b.currentPageY=a.pageY,b.currentTimeStamp=N(a),M.mostRecentTimeStamp=N(a)):console.error("Cannot record touch end without a touch start.\nTouch End: %s\n","Touch Bank: %s",P(a),Q())}function P(a){return JSON.stringify({identifier:a.identifier,pageX:a.pageX,pageY:a.pageY,timestamp:N(a)})}
function Q(){var a=JSON.stringify(L.slice(0,20));20<L.length&&(a+=" (original size: "+L.length+")");return a}
var R={recordTouchTrack:function(a,b){if(v(a))b.changedTouches.forEach(fa);else if(w(a))b.changedTouches.forEach(ea),M.numberActiveTouches=b.touches.length,1===M.numberActiveTouches&&(M.indexOfSingleActiveTouch=b.touches[0].identifier);else if(u(a)&&(b.changedTouches.forEach(ha),M.numberActiveTouches=b.touches.length,1===M.numberActiveTouches))for(a=0;a<L.length;a++)if(b=L[a],null!=b&&b.touchActive){M.indexOfSingleActiveTouch=a;break}},touchHistory:M};
function S(a,b){null==b?n("29"):void 0;return null==a?b:Array.isArray(a)?a.concat(b):Array.isArray(b)?[a].concat(b):[a,b]}var T=null,U=0,V=0;function W(a,b){var c=T;T=a;if(null!==X.GlobalResponderHandler)X.GlobalResponderHandler.onChange(c,a,b)}
var Y={startShouldSetResponder:{phasedRegistrationNames:{bubbled:"onStartShouldSetResponder",captured:"onStartShouldSetResponderCapture"}},scrollShouldSetResponder:{phasedRegistrationNames:{bubbled:"onScrollShouldSetResponder",captured:"onScrollShouldSetResponderCapture"}},selectionChangeShouldSetResponder:{phasedRegistrationNames:{bubbled:"onSelectionChangeShouldSetResponder",captured:"onSelectionChangeShouldSetResponderCapture"}},moveShouldSetResponder:{phasedRegistrationNames:{bubbled:"onMoveShouldSetResponder",
captured:"onMoveShouldSetResponderCapture"}},responderStart:{registrationName:"onResponderStart"},responderMove:{registrationName:"onResponderMove"},responderEnd:{registrationName:"onResponderEnd"},responderRelease:{registrationName:"onResponderRelease"},responderTerminationRequest:{registrationName:"onResponderTerminationRequest"},responderGrant:{registrationName:"onResponderGrant"},responderReject:{registrationName:"onResponderReject"},responderTerminate:{registrationName:"onResponderTerminate"}},
X={_getResponder:function(){return T},eventTypes:Y,extractEvents:function(a,b,c,f){if(w(a))U+=1;else if(u(a))if(0<=U)--U;else return console.error("Ended a touch event which was not counted in `trackedTouchCount`."),null;R.recordTouchTrack(a,c);if(b&&("topScroll"===a&&!c.responderIgnoreScroll||0<U&&"topSelectionChange"===a||w(a)||v(a))){var d=w(a)?Y.startShouldSetResponder:v(a)?Y.moveShouldSetResponder:"topSelectionChange"===a?Y.selectionChangeShouldSetResponder:Y.scrollShouldSetResponder;if(T)b:{var e=
T;for(var g=0,r=e;r;r=y(r))g++;r=0;for(var K=b;K;K=y(K))r++;for(;0<g-r;)e=y(e),g--;for(;0<r-g;)b=y(b),r--;for(;g--;){if(e===b||e===b.alternate)break b;e=y(e);b=y(b)}e=null}else e=b;b=e===T;e=J.getPooled(d,e,c,f);e.touchHistory=R.touchHistory;b?B(e,aa):B(e,E);b:{d=e._dispatchListeners;b=e._dispatchInstances;if(Array.isArray(d))for(g=0;g<d.length&&!e.isPropagationStopped();g++){if(d[g](e,b[g])){d=b[g];break b}}else if(d&&d(e,b)){d=b;break b}d=null}e._dispatchInstances=null;e._dispatchListeners=null;
e.isPersistent()||e.constructor.release(e);if(d&&d!==T)if(e=J.getPooled(Y.responderGrant,d,c,f),e.touchHistory=R.touchHistory,B(e,F),b=!0===x(e),T)if(g=J.getPooled(Y.responderTerminationRequest,T,c,f),g.touchHistory=R.touchHistory,B(g,F),r=!g._dispatchListeners||x(g),g.isPersistent()||g.constructor.release(g),r){g=J.getPooled(Y.responderTerminate,T,c,f);g.touchHistory=R.touchHistory;B(g,F);var m=S(m,[e,g]);W(d,b)}else d=J.getPooled(Y.responderReject,d,c,f),d.touchHistory=R.touchHistory,B(d,F),m=S(m,
d);else m=S(m,e),W(d,b);else m=null}else m=null;d=T&&w(a);e=T&&v(a);b=T&&u(a);if(d=d?Y.responderStart:e?Y.responderMove:b?Y.responderEnd:null)d=J.getPooled(d,T,c,f),d.touchHistory=R.touchHistory,B(d,F),m=S(m,d);d=T&&"topTouchCancel"===a;if(a=T&&!d&&u(a))a:{if((a=c.touches)&&0!==a.length)for(e=0;e<a.length;e++)if(b=a[e].target,null!==b&&void 0!==b&&0!==b){g=q(b);b:{for(b=T;g;){if(b===g||b===g.alternate){b=!0;break b}g=y(g)}b=!1}if(b){a=!1;break a}}a=!0}if(a=d?Y.responderTerminate:a?Y.responderRelease:
null)c=J.getPooled(a,T,c,f),c.touchHistory=R.touchHistory,B(c,F),m=S(m,c),W(null);c=R.touchHistory.numberActiveTouches;if(X.GlobalInteractionHandler&&c!==V)X.GlobalInteractionHandler.onChange(c);V=c;return m},GlobalResponderHandler:null,GlobalInteractionHandler:null,injection:{injectGlobalResponderHandler:function(a){X.GlobalResponderHandler=a},injectGlobalInteractionHandler:function(a){X.GlobalInteractionHandler=a}}};
function Z(a){p=a.getFiberCurrentPropsFromNode;q=a.getInstanceFromNode;t=a.getNodeFromInstance}Z(h.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactDOMComponentTree);var ia=Object.freeze({injectComponentTree:Z,ResponderEventPlugin:X,ResponderTouchHistoryStore:R});module.exports=ia;


/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var whitelist = {
  accessibilityComponentType: true,
  accessibilityLabel: true,
  accessibilityLiveRegion: true,
  accessibilityRole: true,
  accessibilityTraits: true,
  accessible: true,
  children: true,
  disabled: true,
  importantForAccessibility: true,
  onBlur: true,
  onContextMenu: true,
  onFocus: true,
  onMoveShouldSetResponder: true,
  onMoveShouldSetResponderCapture: true,
  onResponderEnd: true,
  onResponderGrant: true,
  onResponderMove: true,
  onResponderReject: true,
  onResponderRelease: true,
  onResponderStart: true,
  onResponderTerminate: true,
  onResponderTerminationRequest: true,
  onScrollShouldSetResponder: true,
  onScrollShouldSetResponderCapture: true,
  onSelectionChangeShouldSetResponder: true,
  onSelectionChangeShouldSetResponderCapture: true,
  onStartShouldSetResponder: true,
  onStartShouldSetResponderCapture: true,
  onTouchCancel: true,
  onTouchCancelCapture: true,
  onTouchEnd: true,
  onTouchEndCapture: true,
  onTouchMove: true,
  onTouchMoveCapture: true,
  onTouchStart: true,
  onTouchStartCapture: true,
  pointerEvents: true,
  style: true,
  testID: true,
  /* @platform web */
  onScroll: true,
  onWheel: true,
  // keyboard events
  onKeyDown: true,
  onKeyPress: true,
  onKeyUp: true,
  // mouse events (e.g, hover effects)
  onMouseDown: true,
  onMouseEnter: true,
  onMouseLeave: true,
  onMouseMove: true,
  onMouseOver: true,
  onMouseOut: true,
  onMouseUp: true,
  // unstable escape-hatches for web
  className: true,
  href: true,
  onClick: true,
  onClickCapture: true,
  rel: true,
  target: true
};

var filterSupportedProps = function filterSupportedProps(props) {
  var safeProps = {};
  for (var prop in props) {
    if (props.hasOwnProperty(prop)) {
      if (whitelist[prop] || prop.indexOf('aria-') === 0 || prop.indexOf('data-') === 0) {
        safeProps[prop] = props[prop];
      }
    }
  }
  return safeProps;
};

/* harmony default export */ __webpack_exports__["a"] = (filterSupportedProps);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Text_TextPropTypes__ = __webpack_require__(182);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Text_TextPropTypes__["a" /* default */]);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function emptyFunction() {}

var AccessibilityInfo = {
  /**
   * Query whether a screen reader is currently enabled.
   *
   * Returns a promise which resolves to a boolean.
   * The result is `true` when a screen reader is enabled and `false` otherwise.
   */
  fetch: function fetch() {
    return new Promise(function (resolve, reject) {
      resolve(true);
    });
  },

  /**
   * Add an event handler. Supported events:
   */
  addEventListener: function addEventListener(eventName, handler) {
    return {
      remove: emptyFunction
    };
  },

  /**
   * Set accessibility focus to a react component.
   */
  setAccessibilityFocus: function setAccessibilityFocus(reactTag) {},

  /**
   * Post a string to be announced by the screen reader.
   */
  announceForAccessibility: function announceForAccessibility(announcement) {},

  /**
   * Remove an event handler.
   */
  removeEventListener: function removeEventListener(eventName, handler) {
    return;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (AccessibilityInfo);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var Alert = function () {
  function Alert() {
    _classCallCheck(this, Alert);
  }

  Alert.alert = function alert() {};

  return Alert;
}();

/* harmony default export */ __webpack_exports__["a"] = (Alert);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimatedEvent__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nodes_AnimatedAddition__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodes_AnimatedDiffClamp__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nodes_AnimatedDivision__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nodes_AnimatedInterpolation__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nodes_AnimatedModulo__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nodes_AnimatedMultiplication__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__nodes_AnimatedNode__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__nodes_AnimatedProps__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__nodes_AnimatedTracking__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__nodes_AnimatedValue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__nodes_AnimatedValueXY__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__animations_DecayAnimation__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__animations_SpringAnimation__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__animations_TimingAnimation__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__createAnimatedComponent__ = __webpack_require__(653);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @preventMunge
 */




















var add = function add(a, b) {
  return new __WEBPACK_IMPORTED_MODULE_1__nodes_AnimatedAddition__["a" /* default */](a, b);
};

var divide = function divide(a, b) {
  return new __WEBPACK_IMPORTED_MODULE_3__nodes_AnimatedDivision__["a" /* default */](a, b);
};

var multiply = function multiply(a, b) {
  return new __WEBPACK_IMPORTED_MODULE_6__nodes_AnimatedMultiplication__["a" /* default */](a, b);
};

var modulo = function modulo(a, modulus) {
  return new __WEBPACK_IMPORTED_MODULE_5__nodes_AnimatedModulo__["a" /* default */](a, modulus);
};

var diffClamp = function diffClamp(a, min, max) {
  return new __WEBPACK_IMPORTED_MODULE_2__nodes_AnimatedDiffClamp__["a" /* default */](a, min, max);
};

var _combineCallbacks = function _combineCallbacks(callback, config) {
  if (callback && config.onComplete) {
    return function () {
      config.onComplete && config.onComplete.apply(config, arguments);
      callback && callback.apply(undefined, arguments);
    };
  } else {
    return callback || config.onComplete;
  }
};

var maybeVectorAnim = function maybeVectorAnim(value, config, anim) {
  if (value instanceof __WEBPACK_IMPORTED_MODULE_11__nodes_AnimatedValueXY__["a" /* default */]) {
    var configX = Object.assign({}, config);
    var configY = Object.assign({}, config);
    for (var key in config) {
      var _config$key = config[key],
          x = _config$key.x,
          y = _config$key.y;

      if (x !== undefined && y !== undefined) {
        configX[key] = x;
        configY[key] = y;
      }
    }
    var aX = anim(value.x, configX);
    var aY = anim(value.y, configY);
    // We use `stopTogether: false` here because otherwise tracking will break
    // because the second animation will get stopped before it can update.
    return parallel([aX, aY], { stopTogether: false });
  }
  return null;
};

var spring = function spring(value, config) {
  var start = function start(animatedValue, configuration, callback) {
    callback = _combineCallbacks(callback, configuration);
    var singleValue = animatedValue;
    var singleConfig = configuration;
    singleValue.stopTracking();
    if (configuration.toValue instanceof __WEBPACK_IMPORTED_MODULE_7__nodes_AnimatedNode__["a" /* default */]) {
      singleValue.track(new __WEBPACK_IMPORTED_MODULE_9__nodes_AnimatedTracking__["a" /* default */](singleValue, configuration.toValue, __WEBPACK_IMPORTED_MODULE_13__animations_SpringAnimation__["a" /* default */], singleConfig, callback));
    } else {
      singleValue.animate(new __WEBPACK_IMPORTED_MODULE_13__animations_SpringAnimation__["a" /* default */](singleConfig), callback);
    }
  };
  return maybeVectorAnim(value, config, spring) || {
    start: function (_start) {
      function start(_x) {
        return _start.apply(this, arguments);
      }

      start.toString = function () {
        return _start.toString();
      };

      return start;
    }(function (callback) {
      start(value, config, callback);
    }),

    stop: function stop() {
      value.stopAnimation();
    },

    reset: function reset() {
      value.resetAnimation();
    },

    _startNativeLoop: function _startNativeLoop(iterations) {
      var singleConfig = Object.assign({}, config, { iterations: iterations });
      start(value, singleConfig);
    },

    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return config.useNativeDriver || false;
    }
  };
};

var timing = function timing(value, config) {
  var start = function start(animatedValue, configuration, callback) {
    callback = _combineCallbacks(callback, configuration);
    var singleValue = animatedValue;
    var singleConfig = configuration;
    singleValue.stopTracking();
    if (configuration.toValue instanceof __WEBPACK_IMPORTED_MODULE_7__nodes_AnimatedNode__["a" /* default */]) {
      singleValue.track(new __WEBPACK_IMPORTED_MODULE_9__nodes_AnimatedTracking__["a" /* default */](singleValue, configuration.toValue, __WEBPACK_IMPORTED_MODULE_14__animations_TimingAnimation__["a" /* default */], singleConfig, callback));
    } else {
      singleValue.animate(new __WEBPACK_IMPORTED_MODULE_14__animations_TimingAnimation__["a" /* default */](singleConfig), callback);
    }
  };

  return maybeVectorAnim(value, config, timing) || {
    start: function (_start2) {
      function start(_x2) {
        return _start2.apply(this, arguments);
      }

      start.toString = function () {
        return _start2.toString();
      };

      return start;
    }(function (callback) {
      start(value, config, callback);
    }),

    stop: function stop() {
      value.stopAnimation();
    },

    reset: function reset() {
      value.resetAnimation();
    },

    _startNativeLoop: function _startNativeLoop(iterations) {
      var singleConfig = Object.assign({}, config, { iterations: iterations });
      start(value, singleConfig);
    },

    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return config.useNativeDriver || false;
    }
  };
};

var decay = function decay(value, config) {
  var start = function start(animatedValue, configuration, callback) {
    callback = _combineCallbacks(callback, configuration);
    var singleValue = animatedValue;
    var singleConfig = configuration;
    singleValue.stopTracking();
    singleValue.animate(new __WEBPACK_IMPORTED_MODULE_12__animations_DecayAnimation__["a" /* default */](singleConfig), callback);
  };

  return maybeVectorAnim(value, config, decay) || {
    start: function (_start3) {
      function start(_x3) {
        return _start3.apply(this, arguments);
      }

      start.toString = function () {
        return _start3.toString();
      };

      return start;
    }(function (callback) {
      start(value, config, callback);
    }),

    stop: function stop() {
      value.stopAnimation();
    },

    reset: function reset() {
      value.resetAnimation();
    },

    _startNativeLoop: function _startNativeLoop(iterations) {
      var singleConfig = Object.assign({}, config, { iterations: iterations });
      start(value, singleConfig);
    },

    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return config.useNativeDriver || false;
    }
  };
};

var sequence = function sequence(animations) {
  var current = 0;
  return {
    start: function start(callback) {
      var onComplete = function onComplete(result) {
        if (!result.finished) {
          callback && callback(result);
          return;
        }

        current++;

        if (current === animations.length) {
          callback && callback(result);
          return;
        }

        animations[current].start(onComplete);
      };

      if (animations.length === 0) {
        callback && callback({ finished: true });
      } else {
        animations[current].start(onComplete);
      }
    },

    stop: function stop() {
      if (current < animations.length) {
        animations[current].stop();
      }
    },

    reset: function reset() {
      animations.forEach(function (animation, idx) {
        if (idx <= current) {
          animation.reset();
        }
      });
      current = 0;
    },

    _startNativeLoop: function _startNativeLoop() {
      throw new Error('Loops run using the native driver cannot contain Animated.sequence animations');
    },

    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return false;
    }
  };
};

var parallel = function parallel(animations, config) {
  var doneCount = 0;
  // Make sure we only call stop() at most once for each animation
  var hasEnded = {};
  var stopTogether = !(config && config.stopTogether === false);

  var result = {
    start: function start(callback) {
      if (doneCount === animations.length) {
        callback && callback({ finished: true });
        return;
      }

      animations.forEach(function (animation, idx) {
        var cb = function cb(endResult) {
          hasEnded[idx] = true;
          doneCount++;
          if (doneCount === animations.length) {
            doneCount = 0;
            callback && callback(endResult);
            return;
          }

          if (!endResult.finished && stopTogether) {
            result.stop();
          }
        };

        if (!animation) {
          cb({ finished: true });
        } else {
          animation.start(cb);
        }
      });
    },

    stop: function stop() {
      animations.forEach(function (animation, idx) {
        !hasEnded[idx] && animation.stop();
        hasEnded[idx] = true;
      });
    },

    reset: function reset() {
      animations.forEach(function (animation, idx) {
        animation.reset();
        hasEnded[idx] = false;
        doneCount = 0;
      });
    },

    _startNativeLoop: function _startNativeLoop() {
      throw new Error('Loops run using the native driver cannot contain Animated.parallel animations');
    },

    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return false;
    }
  };

  return result;
};

var delay = function delay(time) {
  // Would be nice to make a specialized implementation
  return timing(new __WEBPACK_IMPORTED_MODULE_10__nodes_AnimatedValue__["a" /* default */](0), { toValue: 0, delay: time, duration: 0 });
};

var stagger = function stagger(time, animations) {
  return parallel(animations.map(function (animation, i) {
    return sequence([delay(time * i), animation]);
  }));
};

var loop = function loop(animation) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$iterations = _ref.iterations,
      iterations = _ref$iterations === undefined ? -1 : _ref$iterations;

  var isFinished = false;
  var iterationsSoFar = 0;
  return {
    start: function start(callback) {
      var restart = function restart() {
        var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { finished: true };

        if (isFinished || iterationsSoFar === iterations || result.finished === false) {
          callback && callback(result);
        } else {
          iterationsSoFar++;
          animation.reset();
          animation.start(restart);
        }
      };
      if (!animation || iterations === 0) {
        callback && callback({ finished: true });
      } else {
        if (animation._isUsingNativeDriver()) {
          animation._startNativeLoop(iterations);
        } else {
          restart(); // Start looping recursively on the js thread
        }
      }
    },

    stop: function stop() {
      isFinished = true;
      animation.stop();
    },

    reset: function reset() {
      iterationsSoFar = 0;
      isFinished = false;
      animation.reset();
    },

    _startNativeLoop: function _startNativeLoop() {
      throw new Error('Loops run using the native driver cannot contain Animated.loop animations');
    },

    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return animation._isUsingNativeDriver();
    }
  };
};

function forkEvent(event, listener) {
  if (!event) {
    return listener;
  } else if (event instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedEvent__["a" /* AnimatedEvent */]) {
    event.__addListener(listener);
    return event;
  } else {
    return function () {
      typeof event === 'function' && event.apply(undefined, arguments);
      listener.apply(undefined, arguments);
    };
  }
}

function unforkEvent(event, listener) {
  if (event && event instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedEvent__["a" /* AnimatedEvent */]) {
    event.__removeListener(listener);
  }
}

var event = function event(argMapping, config) {
  var animatedEvent = new __WEBPACK_IMPORTED_MODULE_0__AnimatedEvent__["a" /* AnimatedEvent */](argMapping, config);
  if (animatedEvent.__isNative) {
    return animatedEvent;
  } else {
    return animatedEvent.__getHandler();
  }
};

/**
 * The `Animated` library is designed to make animations fluid, powerful, and
 * easy to build and maintain. `Animated` focuses on declarative relationships
 * between inputs and outputs, with configurable transforms in between, and
 * simple `start`/`stop` methods to control time-based animation execution.
 *
 * See http://facebook.github.io/react-native/docs/animated.html
 */
var AnimatedImplementation = {
  /**
   * Standard value class for driving animations.  Typically initialized with
   * `new Animated.Value(0);`
   *
   * See http://facebook.github.io/react-native/docs/animated.html#value
   */
  Value: __WEBPACK_IMPORTED_MODULE_10__nodes_AnimatedValue__["a" /* default */],
  /**
   * 2D value class for driving 2D animations, such as pan gestures.
   *
   * See https://facebook.github.io/react-native/releases/next/docs/animatedvaluexy.html
   */
  ValueXY: __WEBPACK_IMPORTED_MODULE_11__nodes_AnimatedValueXY__["a" /* default */],
  /**
   * Exported to use the Interpolation type in flow.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#interpolation
   */
  Interpolation: __WEBPACK_IMPORTED_MODULE_4__nodes_AnimatedInterpolation__["a" /* default */],
  /**
   * Exported for ease of type checking. All animated values derive from this
   * class.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#node
   */
  Node: __WEBPACK_IMPORTED_MODULE_7__nodes_AnimatedNode__["a" /* default */],

  /**
   * Animates a value from an initial velocity to zero based on a decay
   * coefficient.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#decay
   */
  decay: decay,
  /**
   * Animates a value along a timed easing curve. The Easing module has tons of
   * predefined curves, or you can use your own function.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#timing
   */
  timing: timing,
  /**
   * Animates a value according to an analytical spring model based on
   * damped harmonic oscillation.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#spring
   */
  spring: spring,

  /**
   * Creates a new Animated value composed from two Animated values added
   * together.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#add
   */
  add: add,

  /**
   * Creates a new Animated value composed by dividing the first Animated value
   * by the second Animated value.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#divide
   */
  divide: divide,

  /**
   * Creates a new Animated value composed from two Animated values multiplied
   * together.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#multiply
   */
  multiply: multiply,

  /**
   * Creates a new Animated value that is the (non-negative) modulo of the
   * provided Animated value.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#modulo
   */
  modulo: modulo,

  /**
   * Create a new Animated value that is limited between 2 values. It uses the
   * difference between the last value so even if the value is far from the
   * bounds it will start changing when the value starts getting closer again.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#diffclamp
   */
  diffClamp: diffClamp,

  /**
   * Starts an animation after the given delay.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#delay
   */
  delay: delay,
  /**
   * Starts an array of animations in order, waiting for each to complete
   * before starting the next. If the current running animation is stopped, no
   * following animations will be started.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#sequence
   */
  sequence: sequence,
  /**
   * Starts an array of animations all at the same time. By default, if one
   * of the animations is stopped, they will all be stopped. You can override
   * this with the `stopTogether` flag.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#parallel
   */
  parallel: parallel,
  /**
   * Array of animations may run in parallel (overlap), but are started in
   * sequence with successive delays.  Nice for doing trailing effects.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#stagger
   */
  stagger: stagger,
  /**
   * Loops a given animation continuously, so that each time it reaches the
   * end, it resets and begins again from the start.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#loop
   */
  loop: loop,

  /**
   * Takes an array of mappings and extracts values from each arg accordingly,
   * then calls `setValue` on the mapped outputs.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#event
   */
  event: event,

  /**
   * Make any React component Animatable.  Used to create `Animated.View`, etc.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#createanimatedcomponent
   */
  createAnimatedComponent: __WEBPACK_IMPORTED_MODULE_15__createAnimatedComponent__["a" /* default */],

  /**
   * Imperative API to attach an animated value to an event on a view. Prefer
   * using `Animated.event` with `useNativeDrive: true` if possible.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#attachnativeevent
   */
  attachNativeEvent: __WEBPACK_IMPORTED_MODULE_0__AnimatedEvent__["b" /* attachNativeEvent */],

  /**
   * Advanced imperative API for snooping on animated events that are passed in
   * through props. Use values directly where possible.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#forkevent
   */
  forkEvent: forkEvent,
  unforkEvent: unforkEvent,

  __PropsOnlyForTests: __WEBPACK_IMPORTED_MODULE_8__nodes_AnimatedProps__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (AnimatedImplementation);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EmitterSubscription__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventSubscriptionVendor__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_emptyFunction__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_emptyFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fbjs_lib_emptyFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule EventEmitter
 * @noflow
 * @typecheck
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







/**
 * @class EventEmitter
 * @description
 * An EventEmitter is responsible for managing a set of listeners and publishing
 * events to them when it is told that such events happened. In addition to the
 * data for the given event it also sends a event control object which allows
 * the listeners/handlers to prevent the default behavior of the given event.
 *
 * The emitter is designed to be generic enough to support all the different
 * contexts in which one might want to emit events. It is a simple multicast
 * mechanism on top of which extra functionality can be composed. For example, a
 * more advanced emitter may use an EventHolder and EventFactory.
 */

var EventEmitter = function () {

  /**
   * @constructor
   *
   * @param {EventSubscriptionVendor} subscriber - Optional subscriber instance
   *   to use. If omitted, a new subscriber will be created for the emitter.
   */
  function EventEmitter(subscriber) {
    _classCallCheck(this, EventEmitter);

    this._subscriber = subscriber || new __WEBPACK_IMPORTED_MODULE_1__EventSubscriptionVendor__["a" /* default */]();
  }

  /**
   * Adds a listener to be invoked when events of the specified type are
   * emitted. An optional calling context may be provided. The data arguments
   * emitted will be passed to the listener function.
   *
   * TODO: Annotate the listener arg's type. This is tricky because listeners
   *       can be invoked with varargs.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */


  EventEmitter.prototype.addListener = function addListener(eventType, listener, context) {

    return this._subscriber.addSubscription(eventType, new __WEBPACK_IMPORTED_MODULE_0__EmitterSubscription__["a" /* default */](this, this._subscriber, listener, context));
  };

  /**
   * Similar to addListener, except that the listener is removed after it is
   * invoked once.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke only once when the
   *   specified event is emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */


  EventEmitter.prototype.once = function once(eventType, listener, context) {
    var _this = this;

    return this.addListener(eventType, function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this.removeCurrentListener();
      listener.apply(context, args);
    });
  };

  /**
   * Removes all of the registered listeners, including those registered as
   * listener maps.
   *
   * @param {?string} eventType - Optional name of the event whose registered
   *   listeners to remove
   */


  EventEmitter.prototype.removeAllListeners = function removeAllListeners(eventType) {
    this._subscriber.removeAllSubscriptions(eventType);
  };

  /**
   * Provides an API that can be called during an eventing cycle to remove the
   * last listener that was invoked. This allows a developer to provide an event
   * object that can remove the listener (or listener map) during the
   * invocation.
   *
   * If it is called when not inside of an emitting cycle it will throw.
   *
   * @throws {Error} When called not during an eventing cycle
   *
   * @example
   *   var subscription = emitter.addListenerMap({
   *     someEvent: function(data, event) {
   *       console.log(data);
   *       emitter.removeCurrentListener();
   *     }
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   *   emitter.emit('someEvent', 'def'); // does not log anything
   */


  EventEmitter.prototype.removeCurrentListener = function removeCurrentListener() {
    __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(!!this._currentSubscription, 'Not in an emitting cycle; there is no current subscription');
    this.removeSubscription(this._currentSubscription);
  };

  /**
   * Removes a specific subscription. Called by the `remove()` method of the
   * subscription itself to ensure any necessary cleanup is performed.
   */


  EventEmitter.prototype.removeSubscription = function removeSubscription(subscription) {
    __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(subscription.emitter === this, 'Subscription does not belong to this emitter.');
    this._subscriber.removeSubscription(subscription);
  };

  /**
   * Returns an array of listeners that are currently registered for the given
   * event.
   *
   * @param {string} eventType - Name of the event to query
   * @returns {array}
   */


  EventEmitter.prototype.listeners = function listeners(eventType) {
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    return subscriptions ? subscriptions.filter(__WEBPACK_IMPORTED_MODULE_2_fbjs_lib_emptyFunction___default.a.thatReturnsTrue).map(function (subscription) {
      return subscription.listener;
    }) : [];
  };

  /**
   * Emits an event of the given type with the given data. All handlers of that
   * particular type will be notified.
   *
   * @param {string} eventType - Name of the event to emit
   * @param {...*} Arbitrary arguments to be passed to each registered listener
   *
   * @example
   *   emitter.addListener('someEvent', function(message) {
   *     console.log(message);
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   */


  EventEmitter.prototype.emit = function emit(eventType) {
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    if (subscriptions) {
      for (var i = 0, l = subscriptions.length; i < l; i++) {
        var subscription = subscriptions[i];

        // The subscription may have been removed during this event loop.
        if (subscription) {
          this._currentSubscription = subscription;
          subscription.listener.apply(subscription.context, Array.prototype.slice.call(arguments, 1));
        }
      }
      this._currentSubscription = null;
    }
  };

  /**
   * Removes the given listener for event of specific type.
   *
   * @param {string} eventType - Name of the event to emit
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   *
   * @example
   *   emitter.removeListener('someEvent', function(message) {
   *     console.log(message);
   *   }); // removes the listener if already registered
   *
   */


  EventEmitter.prototype.removeListener = function removeListener(eventType, listener) {
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    if (subscriptions) {
      for (var i = 0, l = subscriptions.length; i < l; i++) {
        var subscription = subscriptions[i];

        // The subscription may have been removed during this event loop.
        // its listener matches the listener in method parameters
        if (subscription && subscription.listener === listener) {
          subscription.remove();
        }
      }
    }
  };

  return EventEmitter;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventEmitter);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventSubscription__ = __webpack_require__(637);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule EmitterSubscription
 * 
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



/**
 * EmitterSubscription represents a subscription with listener and context data.
 */
var EmitterSubscription = function (_EventSubscription) {
  _inherits(EmitterSubscription, _EventSubscription);

  /**
   * @param {EventEmitter} emitter - The event emitter that registered this
   *   subscription
   * @param {EventSubscriptionVendor} subscriber - The subscriber that controls
   *   this subscription
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */
  function EmitterSubscription(emitter, subscriber, listener, context) {
    _classCallCheck(this, EmitterSubscription);

    var _this = _possibleConstructorReturn(this, _EventSubscription.call(this, subscriber));

    _this.emitter = emitter;
    _this.listener = listener;
    _this.context = context;
    return _this;
  }

  /**
   * Removes this subscription from the emitter that registered it.
   * Note: we're overriding the `remove()` method of EventSubscription here
   * but deliberately not calling `super.remove()` as the responsibility
   * for removing the subscription lies with the EventEmitter.
   */


  EmitterSubscription.prototype.remove = function remove() {
    this.emitter.removeSubscription(this);
  };

  return EmitterSubscription;
}(__WEBPACK_IMPORTED_MODULE_0__EventSubscription__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (EmitterSubscription);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule EventSubscription
 * 
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * EventSubscription represents a subscription to a particular event. It can
 * remove its own subscription.
 */
var EventSubscription = function () {

  /**
   * @param {EventSubscriptionVendor} subscriber the subscriber that controls
   *   this subscription.
   */
  function EventSubscription(subscriber) {
    _classCallCheck(this, EventSubscription);

    this.subscriber = subscriber;
  }

  /**
   * Removes this subscription from the subscriber that controls it.
   */


  EventSubscription.prototype.remove = function remove() {
    this.subscriber.removeSubscription(this);
  };

  return EventSubscription;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventSubscription);

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule EventSubscriptionVendor
 * 
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * EventSubscriptionVendor stores a set of EventSubscriptions that are
 * subscribed to a particular event type.
 */
var EventSubscriptionVendor = function () {
  function EventSubscriptionVendor() {
    _classCallCheck(this, EventSubscriptionVendor);

    this._subscriptionsForType = {};
    this._currentSubscription = null;
  }

  /**
   * Adds a subscription keyed by an event type.
   *
   * @param {string} eventType
   * @param {EventSubscription} subscription
   */


  EventSubscriptionVendor.prototype.addSubscription = function addSubscription(eventType, subscription) {
    __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(subscription.subscriber === this, 'The subscriber of the subscription is incorrectly set.');
    if (!this._subscriptionsForType[eventType]) {
      this._subscriptionsForType[eventType] = [];
    }
    var key = this._subscriptionsForType[eventType].length;
    this._subscriptionsForType[eventType].push(subscription);
    subscription.eventType = eventType;
    subscription.key = key;
    return subscription;
  };

  /**
   * Removes a bulk set of the subscriptions.
   *
   * @param {?string} eventType - Optional name of the event type whose
   *   registered supscriptions to remove, if null remove all subscriptions.
   */


  EventSubscriptionVendor.prototype.removeAllSubscriptions = function removeAllSubscriptions(eventType) {
    if (eventType === undefined) {
      this._subscriptionsForType = {};
    } else {
      delete this._subscriptionsForType[eventType];
    }
  };

  /**
   * Removes a specific subscription. Instead of calling this function, call
   * `subscription.remove()` directly.
   *
   * @param {object} subscription
   */


  EventSubscriptionVendor.prototype.removeSubscription = function removeSubscription(subscription) {
    var eventType = subscription.eventType;
    var key = subscription.key;

    var subscriptionsForType = this._subscriptionsForType[eventType];
    if (subscriptionsForType) {
      delete subscriptionsForType[key];
    }
  };

  /**
   * Returns the array of subscriptions that are currently registered for the
   * given event type.
   *
   * Note: This array can be potentially sparse as subscriptions are deleted
   * from it when they are removed.
   *
   * TODO: This returns a nullable array. wat?
   *
   * @param {string} eventType
   * @returns {?array}
   */


  EventSubscriptionVendor.prototype.getSubscriptionsForType = function getSubscriptionsForType(eventType) {
    return this._subscriptionsForType[eventType];
  };

  return EventSubscriptionVendor;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventSubscriptionVendor);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cancelIdleCallback; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _requestIdleCallback = function _requestIdleCallback(cb, options) {
  return setTimeout(function () {
    var start = Date.now();
    cb({
      didTimeout: false,
      timeRemaining: function timeRemaining() {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }, 1);
};

// $FlowFixMe (TimeoutID type is not recognized by eslint)
var _cancelIdleCallback = function _cancelIdleCallback(id) {
  clearTimeout(id);
};

var isSupported = __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__["canUseDOM"] && typeof window.requestIdleCallback !== 'undefined';

var requestIdleCallback = isSupported ? window.requestIdleCallback : _requestIdleCallback;
var cancelIdleCallback = isSupported ? window.cancelIdleCallback : _cancelIdleCallback;

/* harmony default export */ __webpack_exports__["b"] = (requestIdleCallback);


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimatedInterpolation__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimatedNode__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnimatedValue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnimatedWithChildren__ = __webpack_require__(53);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AnimatedAddition = function (_AnimatedWithChildren) {
  _inherits(AnimatedAddition, _AnimatedWithChildren);

  function AnimatedAddition(a, b) {
    _classCallCheck(this, AnimatedAddition);

    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));

    _this._a = typeof a === 'number' ? new __WEBPACK_IMPORTED_MODULE_2__AnimatedValue__["a" /* default */](a) : a;
    _this._b = typeof b === 'number' ? new __WEBPACK_IMPORTED_MODULE_2__AnimatedValue__["a" /* default */](b) : b;
    return _this;
  }

  AnimatedAddition.prototype.__makeNative = function __makeNative() {
    this._a.__makeNative();
    this._b.__makeNative();
    _AnimatedWithChildren.prototype.__makeNative.call(this);
  };

  AnimatedAddition.prototype.__getValue = function __getValue() {
    return this._a.__getValue() + this._b.__getValue();
  };

  AnimatedAddition.prototype.interpolate = function interpolate(config) {
    return new __WEBPACK_IMPORTED_MODULE_0__AnimatedInterpolation__["a" /* default */](this, config);
  };

  AnimatedAddition.prototype.__attach = function __attach() {
    this._a.__addChild(this);
    this._b.__addChild(this);
  };

  AnimatedAddition.prototype.__detach = function __detach() {
    this._a.__removeChild(this);
    this._b.__removeChild(this);
    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  AnimatedAddition.prototype.__getNativeConfig = function __getNativeConfig() {
    return {
      type: 'addition',
      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
    };
  };

  return AnimatedAddition;
}(__WEBPACK_IMPORTED_MODULE_3__AnimatedWithChildren__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AnimatedAddition);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimatedInterpolation__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimatedNode__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnimatedWithChildren__ = __webpack_require__(53);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var AnimatedDiffClamp = function (_AnimatedWithChildren) {
  _inherits(AnimatedDiffClamp, _AnimatedWithChildren);

  function AnimatedDiffClamp(a, min, max) {
    _classCallCheck(this, AnimatedDiffClamp);

    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));

    _this._a = a;
    _this._min = min;
    _this._max = max;
    _this._value = _this._lastValue = _this._a.__getValue();
    return _this;
  }

  AnimatedDiffClamp.prototype.__makeNative = function __makeNative() {
    this._a.__makeNative();
    _AnimatedWithChildren.prototype.__makeNative.call(this);
  };

  AnimatedDiffClamp.prototype.interpolate = function interpolate(config) {
    return new __WEBPACK_IMPORTED_MODULE_0__AnimatedInterpolation__["a" /* default */](this, config);
  };

  AnimatedDiffClamp.prototype.__getValue = function __getValue() {
    var value = this._a.__getValue();
    var diff = value - this._lastValue;
    this._lastValue = value;
    this._value = Math.min(Math.max(this._value + diff, this._min), this._max);
    return this._value;
  };

  AnimatedDiffClamp.prototype.__attach = function __attach() {
    this._a.__addChild(this);
  };

  AnimatedDiffClamp.prototype.__detach = function __detach() {
    this._a.__removeChild(this);
    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  AnimatedDiffClamp.prototype.__getNativeConfig = function __getNativeConfig() {
    return {
      type: 'diffclamp',
      input: this._a.__getNativeTag(),
      min: this._min,
      max: this._max
    };
  };

  return AnimatedDiffClamp;
}(__WEBPACK_IMPORTED_MODULE_2__AnimatedWithChildren__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AnimatedDiffClamp);

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimatedInterpolation__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimatedNode__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnimatedValue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnimatedWithChildren__ = __webpack_require__(53);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AnimatedDivision = function (_AnimatedWithChildren) {
  _inherits(AnimatedDivision, _AnimatedWithChildren);

  function AnimatedDivision(a, b) {
    _classCallCheck(this, AnimatedDivision);

    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));

    _this._a = typeof a === 'number' ? new __WEBPACK_IMPORTED_MODULE_2__AnimatedValue__["a" /* default */](a) : a;
    _this._b = typeof b === 'number' ? new __WEBPACK_IMPORTED_MODULE_2__AnimatedValue__["a" /* default */](b) : b;
    return _this;
  }

  AnimatedDivision.prototype.__makeNative = function __makeNative() {
    this._a.__makeNative();
    this._b.__makeNative();
    _AnimatedWithChildren.prototype.__makeNative.call(this);
  };

  AnimatedDivision.prototype.__getValue = function __getValue() {
    var a = this._a.__getValue();
    var b = this._b.__getValue();
    if (b === 0) {
      console.error('Detected division by zero in AnimatedDivision');
    }
    return a / b;
  };

  AnimatedDivision.prototype.interpolate = function interpolate(config) {
    return new __WEBPACK_IMPORTED_MODULE_0__AnimatedInterpolation__["a" /* default */](this, config);
  };

  AnimatedDivision.prototype.__attach = function __attach() {
    this._a.__addChild(this);
    this._b.__addChild(this);
  };

  AnimatedDivision.prototype.__detach = function __detach() {
    this._a.__removeChild(this);
    this._b.__removeChild(this);
    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  AnimatedDivision.prototype.__getNativeConfig = function __getNativeConfig() {
    return {
      type: 'division',
      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
    };
  };

  return AnimatedDivision;
}(__WEBPACK_IMPORTED_MODULE_3__AnimatedWithChildren__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AnimatedDivision);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimatedInterpolation__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimatedNode__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnimatedWithChildren__ = __webpack_require__(53);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var AnimatedModulo = function (_AnimatedWithChildren) {
  _inherits(AnimatedModulo, _AnimatedWithChildren);

  function AnimatedModulo(a, modulus) {
    _classCallCheck(this, AnimatedModulo);

    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));

    _this._a = a;
    _this._modulus = modulus;
    return _this;
  }

  AnimatedModulo.prototype.__makeNative = function __makeNative() {
    this._a.__makeNative();
    _AnimatedWithChildren.prototype.__makeNative.call(this);
  };

  AnimatedModulo.prototype.__getValue = function __getValue() {
    return (this._a.__getValue() % this._modulus + this._modulus) % this._modulus;
  };

  AnimatedModulo.prototype.interpolate = function interpolate(config) {
    return new __WEBPACK_IMPORTED_MODULE_0__AnimatedInterpolation__["a" /* default */](this, config);
  };

  AnimatedModulo.prototype.__attach = function __attach() {
    this._a.__addChild(this);
  };

  AnimatedModulo.prototype.__detach = function __detach() {
    this._a.__removeChild(this);
    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  AnimatedModulo.prototype.__getNativeConfig = function __getNativeConfig() {
    return {
      type: 'modulus',
      input: this._a.__getNativeTag(),
      modulus: this._modulus
    };
  };

  return AnimatedModulo;
}(__WEBPACK_IMPORTED_MODULE_2__AnimatedWithChildren__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AnimatedModulo);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimatedInterpolation__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimatedNode__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnimatedValue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnimatedWithChildren__ = __webpack_require__(53);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AnimatedMultiplication = function (_AnimatedWithChildren) {
  _inherits(AnimatedMultiplication, _AnimatedWithChildren);

  function AnimatedMultiplication(a, b) {
    _classCallCheck(this, AnimatedMultiplication);

    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));

    _this._a = typeof a === 'number' ? new __WEBPACK_IMPORTED_MODULE_2__AnimatedValue__["a" /* default */](a) : a;
    _this._b = typeof b === 'number' ? new __WEBPACK_IMPORTED_MODULE_2__AnimatedValue__["a" /* default */](b) : b;
    return _this;
  }

  AnimatedMultiplication.prototype.__makeNative = function __makeNative() {
    this._a.__makeNative();
    this._b.__makeNative();
    _AnimatedWithChildren.prototype.__makeNative.call(this);
  };

  AnimatedMultiplication.prototype.__getValue = function __getValue() {
    return this._a.__getValue() * this._b.__getValue();
  };

  AnimatedMultiplication.prototype.interpolate = function interpolate(config) {
    return new __WEBPACK_IMPORTED_MODULE_0__AnimatedInterpolation__["a" /* default */](this, config);
  };

  AnimatedMultiplication.prototype.__attach = function __attach() {
    this._a.__addChild(this);
    this._b.__addChild(this);
  };

  AnimatedMultiplication.prototype.__detach = function __detach() {
    this._a.__removeChild(this);
    this._b.__removeChild(this);
    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  AnimatedMultiplication.prototype.__getNativeConfig = function __getNativeConfig() {
    return {
      type: 'multiplication',
      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
    };
  };

  return AnimatedMultiplication;
}(__WEBPACK_IMPORTED_MODULE_3__AnimatedWithChildren__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AnimatedMultiplication);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimatedNode__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimatedTransform__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnimatedWithChildren__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NativeAnimatedHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__exports_StyleSheet__ = __webpack_require__(12);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var flattenStyle = __WEBPACK_IMPORTED_MODULE_4__exports_StyleSheet__["a" /* default */].flatten;

var AnimatedStyle = function (_AnimatedWithChildren) {
  _inherits(AnimatedStyle, _AnimatedWithChildren);

  function AnimatedStyle(style) {
    _classCallCheck(this, AnimatedStyle);

    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));

    style = flattenStyle(style) || {};
    if (style.transform) {
      style = Object.assign({}, style, {
        transform: new __WEBPACK_IMPORTED_MODULE_1__AnimatedTransform__["a" /* default */](style.transform)
      });
    }
    _this._style = style;
    return _this;
  }

  // Recursively get values for nested styles (like iOS's shadowOffset)


  AnimatedStyle.prototype._walkStyleAndGetValues = function _walkStyleAndGetValues(style) {
    var updatedStyle = {};
    for (var key in style) {
      var value = style[key];
      if (value instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedNode__["a" /* default */]) {
        if (!value.__isNative) {
          // We cannot use value of natively driven nodes this way as the value we have access from
          // JS may not be up to date.
          updatedStyle[key] = value.__getValue();
        }
      } else if (value && !Array.isArray(value) && typeof value === 'object') {
        // Support animating nested values (for example: shadowOffset.height)
        updatedStyle[key] = this._walkStyleAndGetValues(value);
      } else {
        updatedStyle[key] = value;
      }
    }
    return updatedStyle;
  };

  AnimatedStyle.prototype.__getValue = function __getValue() {
    return this._walkStyleAndGetValues(this._style);
  };

  // Recursively get animated values for nested styles (like iOS's shadowOffset)


  AnimatedStyle.prototype._walkStyleAndGetAnimatedValues = function _walkStyleAndGetAnimatedValues(style) {
    var updatedStyle = {};
    for (var key in style) {
      var value = style[key];
      if (value instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedNode__["a" /* default */]) {
        updatedStyle[key] = value.__getAnimatedValue();
      } else if (value && !Array.isArray(value) && typeof value === 'object') {
        // Support animating nested values (for example: shadowOffset.height)
        updatedStyle[key] = this._walkStyleAndGetAnimatedValues(value);
      }
    }
    return updatedStyle;
  };

  AnimatedStyle.prototype.__getAnimatedValue = function __getAnimatedValue() {
    return this._walkStyleAndGetAnimatedValues(this._style);
  };

  AnimatedStyle.prototype.__attach = function __attach() {
    for (var key in this._style) {
      var value = this._style[key];
      if (value instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedNode__["a" /* default */]) {
        value.__addChild(this);
      }
    }
  };

  AnimatedStyle.prototype.__detach = function __detach() {
    for (var key in this._style) {
      var value = this._style[key];
      if (value instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedNode__["a" /* default */]) {
        value.__removeChild(this);
      }
    }
    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  AnimatedStyle.prototype.__makeNative = function __makeNative() {
    _AnimatedWithChildren.prototype.__makeNative.call(this);
    for (var key in this._style) {
      var value = this._style[key];
      if (value instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedNode__["a" /* default */]) {
        value.__makeNative();
      }
    }
  };

  AnimatedStyle.prototype.__getNativeConfig = function __getNativeConfig() {
    var styleConfig = {};
    for (var styleKey in this._style) {
      if (this._style[styleKey] instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedNode__["a" /* default */]) {
        styleConfig[styleKey] = this._style[styleKey].__getNativeTag();
      }
      // Non-animated styles are set using `setNativeProps`, no need
      // to pass those as a part of the node config
    }
    __WEBPACK_IMPORTED_MODULE_3__NativeAnimatedHelper__["a" /* default */].validateStyles(styleConfig);
    return {
      type: 'style',
      style: styleConfig
    };
  };

  return AnimatedStyle;
}(__WEBPACK_IMPORTED_MODULE_2__AnimatedWithChildren__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AnimatedStyle);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimatedNode__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimatedWithChildren__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NativeAnimatedHelper__ = __webpack_require__(34);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var AnimatedTransform = function (_AnimatedWithChildren) {
  _inherits(AnimatedTransform, _AnimatedWithChildren);

  function AnimatedTransform(transforms) {
    _classCallCheck(this, AnimatedTransform);

    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));

    _this._transforms = transforms;
    return _this;
  }

  AnimatedTransform.prototype.__makeNative = function __makeNative() {
    _AnimatedWithChildren.prototype.__makeNative.call(this);
    this._transforms.forEach(function (transform) {
      for (var key in transform) {
        var value = transform[key];
        if (value instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedNode__["a" /* default */]) {
          value.__makeNative();
        }
      }
    });
  };

  AnimatedTransform.prototype.__getValue = function __getValue() {
    return this._transforms.map(function (transform) {
      var result = {};
      for (var key in transform) {
        var value = transform[key];
        if (value instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedNode__["a" /* default */]) {
          result[key] = value.__getValue();
        } else {
          result[key] = value;
        }
      }
      return result;
    });
  };

  AnimatedTransform.prototype.__getAnimatedValue = function __getAnimatedValue() {
    return this._transforms.map(function (transform) {
      var result = {};
      for (var key in transform) {
        var value = transform[key];
        if (value instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedNode__["a" /* default */]) {
          result[key] = value.__getAnimatedValue();
        } else {
          // All transform components needed to recompose matrix
          result[key] = value;
        }
      }
      return result;
    });
  };

  AnimatedTransform.prototype.__attach = function __attach() {
    var _this2 = this;

    this._transforms.forEach(function (transform) {
      for (var key in transform) {
        var value = transform[key];
        if (value instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedNode__["a" /* default */]) {
          value.__addChild(_this2);
        }
      }
    });
  };

  AnimatedTransform.prototype.__detach = function __detach() {
    var _this3 = this;

    this._transforms.forEach(function (transform) {
      for (var key in transform) {
        var value = transform[key];
        if (value instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedNode__["a" /* default */]) {
          value.__removeChild(_this3);
        }
      }
    });
    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  AnimatedTransform.prototype.__getNativeConfig = function __getNativeConfig() {
    var transConfigs = [];

    this._transforms.forEach(function (transform) {
      for (var key in transform) {
        var value = transform[key];
        if (value instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedNode__["a" /* default */]) {
          transConfigs.push({
            type: 'animated',
            property: key,
            nodeTag: value.__getNativeTag()
          });
        } else {
          transConfigs.push({
            type: 'static',
            property: key,
            value: value
          });
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_2__NativeAnimatedHelper__["a" /* default */].validateTransform(transConfigs);
    return {
      type: 'transform',
      transforms: transConfigs
    };
  };

  return AnimatedTransform;
}(__WEBPACK_IMPORTED_MODULE_1__AnimatedWithChildren__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AnimatedTransform);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimatedValue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimatedNode__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NativeAnimatedHelper__ = __webpack_require__(34);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var AnimatedTracking = function (_AnimatedNode) {
  _inherits(AnimatedTracking, _AnimatedNode);

  function AnimatedTracking(value, parent, animationClass, animationConfig, callback) {
    _classCallCheck(this, AnimatedTracking);

    var _this = _possibleConstructorReturn(this, _AnimatedNode.call(this));

    _this._value = value;
    _this._parent = parent;
    _this._animationClass = animationClass;
    _this._animationConfig = animationConfig;
    _this._useNativeDriver = Object(__WEBPACK_IMPORTED_MODULE_2__NativeAnimatedHelper__["c" /* shouldUseNativeDriver */])(animationConfig);
    _this._callback = callback;
    _this.__attach();
    return _this;
  }

  AnimatedTracking.prototype.__makeNative = function __makeNative() {
    this.__isNative = true;
    this._parent.__makeNative();
    _AnimatedNode.prototype.__makeNative.call(this);
    this._value.__makeNative();
  };

  AnimatedTracking.prototype.__getValue = function __getValue() {
    return this._parent.__getValue();
  };

  AnimatedTracking.prototype.__attach = function __attach() {
    this._parent.__addChild(this);
    if (this._useNativeDriver) {
      // when the tracking starts we need to convert this node to a "native node"
      // so that the parent node will be made "native" too. This is necessary as
      // if we don't do this `update` method will get called. At that point it
      // may be too late as it would mean the JS driver has already started
      // updating node values
      this.__makeNative();
    }
  };

  AnimatedTracking.prototype.__detach = function __detach() {
    this._parent.__removeChild(this);
    _AnimatedNode.prototype.__detach.call(this);
  };

  AnimatedTracking.prototype.update = function update() {
    this._value.animate(new this._animationClass(Object.assign({}, this._animationConfig, {
      toValue: this._animationConfig.toValue.__getValue()
    })), this._callback);
  };

  AnimatedTracking.prototype.__getNativeConfig = function __getNativeConfig() {
    var animation = new this._animationClass(Object.assign({}, this._animationConfig, {
      // remove toValue from the config as it's a ref to Animated.Value
      toValue: undefined
    }));
    var animationConfig = animation.__getNativeAnimationConfig();
    return {
      type: 'tracking',
      animationId: Object(__WEBPACK_IMPORTED_MODULE_2__NativeAnimatedHelper__["b" /* generateNewAnimationId */])(),
      animationConfig: animationConfig,
      toValue: this._parent.__getNativeTag(),
      value: this._value.__getNativeTag()
    };
  };

  return AnimatedTracking;
}(__WEBPACK_IMPORTED_MODULE_1__AnimatedNode__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AnimatedTracking);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Animation__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NativeAnimatedHelper__ = __webpack_require__(34);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DecayAnimation = function (_Animation) {
  _inherits(DecayAnimation, _Animation);

  function DecayAnimation(config) {
    _classCallCheck(this, DecayAnimation);

    var _this = _possibleConstructorReturn(this, _Animation.call(this));

    _this._deceleration = config.deceleration !== undefined ? config.deceleration : 0.998;
    _this._velocity = config.velocity;
    _this._useNativeDriver = Object(__WEBPACK_IMPORTED_MODULE_1__NativeAnimatedHelper__["c" /* shouldUseNativeDriver */])(config);
    _this.__isInteraction = config.isInteraction !== undefined ? config.isInteraction : true;
    _this.__iterations = config.iterations !== undefined ? config.iterations : 1;
    return _this;
  }

  DecayAnimation.prototype.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
    return {
      type: 'decay',
      deceleration: this._deceleration,
      velocity: this._velocity,
      iterations: this.__iterations
    };
  };

  DecayAnimation.prototype.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
    this.__active = true;
    this._lastValue = fromValue;
    this._fromValue = fromValue;
    this._onUpdate = onUpdate;
    this.__onEnd = onEnd;
    this._startTime = Date.now();
    if (this._useNativeDriver) {
      this.__startNativeAnimation(animatedValue);
    } else {
      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
    }
  };

  DecayAnimation.prototype.onUpdate = function onUpdate() {
    var now = Date.now();

    var value = this._fromValue + this._velocity / (1 - this._deceleration) * (1 - Math.exp(-(1 - this._deceleration) * (now - this._startTime)));

    this._onUpdate(value);

    if (Math.abs(this._lastValue - value) < 0.1) {
      this.__debouncedOnEnd({ finished: true });
      return;
    }

    this._lastValue = value;
    if (this.__active) {
      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
    }
  };

  DecayAnimation.prototype.stop = function stop() {
    _Animation.prototype.stop.call(this);
    this.__active = false;
    global.cancelAnimationFrame(this._animationFrame);
    this.__debouncedOnEnd({ finished: false });
  };

  return DecayAnimation;
}(__WEBPACK_IMPORTED_MODULE_0__Animation__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (DecayAnimation);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nodes_AnimatedValue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nodes_AnimatedValueXY__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Animation__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SpringConfig__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NativeAnimatedHelper__ = __webpack_require__(34);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









function withDefault(value, defaultValue) {
  if (value === undefined || value === null) {
    return defaultValue;
  }
  return value;
}

var SpringAnimation = function (_Animation) {
  _inherits(SpringAnimation, _Animation);

  function SpringAnimation(config) {
    _classCallCheck(this, SpringAnimation);

    var _this = _possibleConstructorReturn(this, _Animation.call(this));

    _this._overshootClamping = withDefault(config.overshootClamping, false);
    _this._restDisplacementThreshold = withDefault(config.restDisplacementThreshold, 0.001);
    _this._restSpeedThreshold = withDefault(config.restSpeedThreshold, 0.001);
    _this._initialVelocity = withDefault(config.velocity, 0);
    _this._lastVelocity = withDefault(config.velocity, 0);
    _this._toValue = config.toValue;
    _this._delay = withDefault(config.delay, 0);
    _this._useNativeDriver = Object(__WEBPACK_IMPORTED_MODULE_5__NativeAnimatedHelper__["c" /* shouldUseNativeDriver */])(config);
    _this.__isInteraction = config.isInteraction !== undefined ? config.isInteraction : true;
    _this.__iterations = config.iterations !== undefined ? config.iterations : 1;

    if (config.stiffness !== undefined || config.damping !== undefined || config.mass !== undefined) {
      __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(config.bounciness === undefined && config.speed === undefined && config.tension === undefined && config.friction === undefined, 'You can define one of bounciness/speed, tension/friction, or stiffness/damping/mass, but not more than one');
      _this._stiffness = withDefault(config.stiffness, 100);
      _this._damping = withDefault(config.damping, 10);
      _this._mass = withDefault(config.mass, 1);
    } else if (config.bounciness !== undefined || config.speed !== undefined) {
      // Convert the origami bounciness/speed values to stiffness/damping
      // We assume mass is 1.
      __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(config.tension === undefined && config.friction === undefined && config.stiffness === undefined && config.damping === undefined && config.mass === undefined, 'You can define one of bounciness/speed, tension/friction, or stiffness/damping/mass, but not more than one');
      var springConfig = __WEBPACK_IMPORTED_MODULE_3__SpringConfig__["a" /* default */].fromBouncinessAndSpeed(withDefault(config.bounciness, 8), withDefault(config.speed, 12));
      _this._stiffness = springConfig.stiffness;
      _this._damping = springConfig.damping;
      _this._mass = 1;
    } else {
      // Convert the origami tension/friction values to stiffness/damping
      // We assume mass is 1.
      var _springConfig = __WEBPACK_IMPORTED_MODULE_3__SpringConfig__["a" /* default */].fromOrigamiTensionAndFriction(withDefault(config.tension, 40), withDefault(config.friction, 7));
      _this._stiffness = _springConfig.stiffness;
      _this._damping = _springConfig.damping;
      _this._mass = 1;
    }

    __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(_this._stiffness > 0, 'Stiffness value must be greater than 0');
    __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(_this._damping > 0, 'Damping value must be greater than 0');
    __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(_this._mass > 0, 'Mass value must be greater than 0');
    return _this;
  }

  SpringAnimation.prototype.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
    return {
      type: 'spring',
      overshootClamping: this._overshootClamping,
      restDisplacementThreshold: this._restDisplacementThreshold,
      restSpeedThreshold: this._restSpeedThreshold,
      stiffness: this._stiffness,
      damping: this._damping,
      mass: this._mass,
      initialVelocity: withDefault(this._initialVelocity, this._lastVelocity),
      toValue: this._toValue,
      iterations: this.__iterations
    };
  };

  SpringAnimation.prototype.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
    var _this2 = this;

    this.__active = true;
    this._startPosition = fromValue;
    this._lastPosition = this._startPosition;

    this._onUpdate = onUpdate;
    this.__onEnd = onEnd;
    this._lastTime = Date.now();
    this._frameTime = 0.0;

    if (previousAnimation instanceof SpringAnimation) {
      var internalState = previousAnimation.getInternalState();
      this._lastPosition = internalState.lastPosition;
      this._lastVelocity = internalState.lastVelocity;
      // Set the initial velocity to the last velocity
      this._initialVelocity = this._lastVelocity;
      this._lastTime = internalState.lastTime;
    }

    var start = function start() {
      if (_this2._useNativeDriver) {
        _this2.__startNativeAnimation(animatedValue);
      } else {
        _this2.onUpdate();
      }
    };

    //  If this._delay is more than 0, we start after the timeout.
    if (this._delay) {
      this._timeout = setTimeout(start, this._delay);
    } else {
      start();
    }
  };

  SpringAnimation.prototype.getInternalState = function getInternalState() {
    return {
      lastPosition: this._lastPosition,
      lastVelocity: this._lastVelocity,
      lastTime: this._lastTime
    };
  };

  /**
   * This spring model is based off of a damped harmonic oscillator
   * (https://en.wikipedia.org/wiki/Harmonic_oscillator#Damped_harmonic_oscillator).
   *
   * We use the closed form of the second order differential equation:
   *
   * x'' + (2ζ⍵_0)x' + ⍵^2x = 0
   *
   * where
   *    ⍵_0 = √(k / m) (undamped angular frequency of the oscillator),
   *    ζ = c / 2√mk (damping ratio),
   *    c = damping constant
   *    k = stiffness
   *    m = mass
   *
   * The derivation of the closed form is described in detail here:
   * http://planetmath.org/sites/default/files/texpdf/39745.pdf
   *
   * This algorithm happens to match the algorithm used by CASpringAnimation,
   * a QuartzCore (iOS) API that creates spring animations.
   */


  SpringAnimation.prototype.onUpdate = function onUpdate() {
    // If for some reason we lost a lot of frames (e.g. process large payload or
    // stopped in the debugger), we only advance by 4 frames worth of
    // computation and will continue on the next frame. It's better to have it
    // running at faster speed than jumping to the end.
    var MAX_STEPS = 64;
    var now = Date.now();
    if (now > this._lastTime + MAX_STEPS) {
      now = this._lastTime + MAX_STEPS;
    }

    var deltaTime = (now - this._lastTime) / 1000;
    this._frameTime += deltaTime;

    var c = this._damping;
    var m = this._mass;
    var k = this._stiffness;
    var v0 = -this._initialVelocity;

    var zeta = c / (2 * Math.sqrt(k * m)); // damping ratio
    var omega0 = Math.sqrt(k / m); // undamped angular frequency of the oscillator (rad/ms)
    var omega1 = omega0 * Math.sqrt(1.0 - zeta * zeta); // exponential decay
    var x0 = this._toValue - this._startPosition; // calculate the oscillation from x0 = 1 to x = 0

    var position = 0.0;
    var velocity = 0.0;
    var t = this._frameTime;
    if (zeta < 1) {
      // Under damped
      var envelope = Math.exp(-zeta * omega0 * t);
      position = this._toValue - envelope * ((v0 + zeta * omega0 * x0) / omega1 * Math.sin(omega1 * t) + x0 * Math.cos(omega1 * t));
      // This looks crazy -- it's actually just the derivative of the
      // oscillation function
      velocity = zeta * omega0 * envelope * (Math.sin(omega1 * t) * (v0 + zeta * omega0 * x0) / omega1 + x0 * Math.cos(omega1 * t)) - envelope * (Math.cos(omega1 * t) * (v0 + zeta * omega0 * x0) - omega1 * x0 * Math.sin(omega1 * t));
    } else {
      // Critically damped
      var _envelope = Math.exp(-omega0 * t);
      position = this._toValue - _envelope * (x0 + (v0 + omega0 * x0) * t);
      velocity = _envelope * (v0 * (t * omega0 - 1) + t * x0 * (omega0 * omega0));
    }

    this._lastTime = now;
    this._lastPosition = position;
    this._lastVelocity = velocity;

    this._onUpdate(position);
    if (!this.__active) {
      // a listener might have stopped us in _onUpdate
      return;
    }

    // Conditions for stopping the spring animation
    var isOvershooting = false;
    if (this._overshootClamping && this._stiffness !== 0) {
      if (this._startPosition < this._toValue) {
        isOvershooting = position > this._toValue;
      } else {
        isOvershooting = position < this._toValue;
      }
    }
    var isVelocity = Math.abs(velocity) <= this._restSpeedThreshold;
    var isDisplacement = true;
    if (this._stiffness !== 0) {
      isDisplacement = Math.abs(this._toValue - position) <= this._restDisplacementThreshold;
    }

    if (isOvershooting || isVelocity && isDisplacement) {
      if (this._stiffness !== 0) {
        // Ensure that we end up with a round value
        this._lastPosition = this._toValue;
        this._lastVelocity = 0;
        this._onUpdate(this._toValue);
      }

      this.__debouncedOnEnd({ finished: true });
      return;
    }
    this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
  };

  SpringAnimation.prototype.stop = function stop() {
    _Animation.prototype.stop.call(this);
    this.__active = false;
    clearTimeout(this._timeout);
    global.cancelAnimationFrame(this._animationFrame);
    this.__debouncedOnEnd({ finished: false });
  };

  return SpringAnimation;
}(__WEBPACK_IMPORTED_MODULE_2__Animation__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SpringAnimation);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fromOrigamiTensionAndFriction */
/* unused harmony export fromBouncinessAndSpeed */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function stiffnessFromOrigamiValue(oValue) {
  return (oValue - 30) * 3.62 + 194;
}

function dampingFromOrigamiValue(oValue) {
  return (oValue - 8) * 3 + 25;
}

function fromOrigamiTensionAndFriction(tension, friction) {
  return {
    stiffness: stiffnessFromOrigamiValue(tension),
    damping: dampingFromOrigamiValue(friction)
  };
}

function fromBouncinessAndSpeed(bounciness, speed) {
  function normalize(value, startValue, endValue) {
    return (value - startValue) / (endValue - startValue);
  }

  function projectNormal(n, start, end) {
    return start + n * (end - start);
  }

  function linearInterpolation(t, start, end) {
    return t * end + (1 - t) * start;
  }

  function quadraticOutInterpolation(t, start, end) {
    return linearInterpolation(2 * t - t * t, start, end);
  }

  function b3Friction1(x) {
    return 0.0007 * Math.pow(x, 3) - 0.031 * Math.pow(x, 2) + 0.64 * x + 1.28;
  }

  function b3Friction2(x) {
    return 0.000044 * Math.pow(x, 3) - 0.006 * Math.pow(x, 2) + 0.36 * x + 2;
  }

  function b3Friction3(x) {
    return 0.00000045 * Math.pow(x, 3) - 0.000332 * Math.pow(x, 2) + 0.1078 * x + 5.84;
  }

  function b3Nobounce(tension) {
    if (tension <= 18) {
      return b3Friction1(tension);
    } else if (tension > 18 && tension <= 44) {
      return b3Friction2(tension);
    } else {
      return b3Friction3(tension);
    }
  }

  var b = normalize(bounciness / 1.7, 0, 20);
  b = projectNormal(b, 0, 0.8);
  var s = normalize(speed / 1.7, 0, 20);
  var bouncyTension = projectNormal(s, 0.5, 200);
  var bouncyFriction = quadraticOutInterpolation(b, b3Nobounce(bouncyTension), 0.01);

  return {
    stiffness: stiffnessFromOrigamiValue(bouncyTension),
    damping: dampingFromOrigamiValue(bouncyFriction)
  };
}


/* harmony default export */ __webpack_exports__["a"] = ({ fromOrigamiTensionAndFriction: fromOrigamiTensionAndFriction, fromBouncinessAndSpeed: fromBouncinessAndSpeed });

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nodes_AnimatedValue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nodes_AnimatedValueXY__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Animation__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Easing__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NativeAnimatedHelper__ = __webpack_require__(34);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var _easeInOut = void 0;
function easeInOut() {
  if (!_easeInOut) {
    _easeInOut = __WEBPACK_IMPORTED_MODULE_3__Easing__["a" /* default */].inOut(__WEBPACK_IMPORTED_MODULE_3__Easing__["a" /* default */].ease);
  }
  return _easeInOut;
}

var TimingAnimation = function (_Animation) {
  _inherits(TimingAnimation, _Animation);

  function TimingAnimation(config) {
    _classCallCheck(this, TimingAnimation);

    var _this = _possibleConstructorReturn(this, _Animation.call(this));

    _this._toValue = config.toValue;
    _this._easing = config.easing !== undefined ? config.easing : easeInOut();
    _this._duration = config.duration !== undefined ? config.duration : 500;
    _this._delay = config.delay !== undefined ? config.delay : 0;
    _this.__iterations = config.iterations !== undefined ? config.iterations : 1;
    _this.__isInteraction = config.isInteraction !== undefined ? config.isInteraction : true;
    _this._useNativeDriver = Object(__WEBPACK_IMPORTED_MODULE_4__NativeAnimatedHelper__["c" /* shouldUseNativeDriver */])(config);
    return _this;
  }

  TimingAnimation.prototype.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
    var frameDuration = 1000.0 / 60.0;
    var frames = [];
    for (var dt = 0.0; dt < this._duration; dt += frameDuration) {
      frames.push(this._easing(dt / this._duration));
    }
    frames.push(this._easing(1));
    return {
      type: 'frames',
      frames: frames,
      toValue: this._toValue,
      iterations: this.__iterations
    };
  };

  TimingAnimation.prototype.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
    var _this2 = this;

    this.__active = true;
    this._fromValue = fromValue;
    this._onUpdate = onUpdate;
    this.__onEnd = onEnd;

    var start = function start() {
      // Animations that sometimes have 0 duration and sometimes do not
      // still need to use the native driver when duration is 0 so as to
      // not cause intermixed JS and native animations.
      if (_this2._duration === 0 && !_this2._useNativeDriver) {
        _this2._onUpdate(_this2._toValue);
        _this2.__debouncedOnEnd({ finished: true });
      } else {
        _this2._startTime = Date.now();
        if (_this2._useNativeDriver) {
          _this2.__startNativeAnimation(animatedValue);
        } else {
          _this2._animationFrame = requestAnimationFrame(_this2.onUpdate.bind(_this2));
        }
      }
    };
    if (this._delay) {
      this._timeout = setTimeout(start, this._delay);
    } else {
      start();
    }
  };

  TimingAnimation.prototype.onUpdate = function onUpdate() {
    var now = Date.now();
    if (now >= this._startTime + this._duration) {
      if (this._duration === 0) {
        this._onUpdate(this._toValue);
      } else {
        this._onUpdate(this._fromValue + this._easing(1) * (this._toValue - this._fromValue));
      }
      this.__debouncedOnEnd({ finished: true });
      return;
    }

    this._onUpdate(this._fromValue + this._easing((now - this._startTime) / this._duration) * (this._toValue - this._fromValue));
    if (this.__active) {
      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
    }
  };

  TimingAnimation.prototype.stop = function stop() {
    _Animation.prototype.stop.call(this);
    this.__active = false;
    clearTimeout(this._timeout);
    global.cancelAnimationFrame(this._animationFrame);
    this.__debouncedOnEnd({ finished: false });
  };

  return TimingAnimation;
}(__WEBPACK_IMPORTED_MODULE_2__Animation__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TimingAnimation);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * BezierEasing - use bezier curve for transition easing function
 * https://github.com/gre/bezier-easing
 *
 * @copyright 2014-2015 Gaëtan Renaudeau. MIT License.
 * @noflow
 */


// These values are established by empiricism with tests (tradeoff: performance VS precision)

var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;

var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

var float32ArraySupported = typeof Float32Array === 'function';

function A(aA1, aA2) {
  return 1.0 - 3.0 * aA2 + 3.0 * aA1;
}
function B(aA1, aA2) {
  return 3.0 * aA2 - 6.0 * aA1;
}
function C(aA1) {
  return 3.0 * aA1;
}

// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function calcBezier(aT, aA1, aA2) {
  return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
}

// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function getSlope(aT, aA1, aA2) {
  return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
}

function binarySubdivide(aX, aA, aB, mX1, mX2) {
  var currentX,
      currentT,
      i = 0;
  do {
    currentT = aA + (aB - aA) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - aX;
    if (currentX > 0.0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
  return currentT;
}

function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
  for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
    var currentSlope = getSlope(aGuessT, mX1, mX2);
    if (currentSlope === 0.0) {
      return aGuessT;
    }
    var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
    aGuessT -= currentX / currentSlope;
  }
  return aGuessT;
}

module.exports = function bezier(mX1, mY1, mX2, mY2) {
  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
    // eslint-disable-line yoda
    throw new Error('bezier x values must be in [0, 1] range');
  }

  // Precompute samples table
  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
  if (mX1 !== mY1 || mX2 !== mY2) {
    for (var i = 0; i < kSplineTableSize; ++i) {
      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
  }

  function getTForX(aX) {
    var intervalStart = 0.0;
    var currentSample = 1;
    var lastSample = kSplineTableSize - 1;

    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }
    --currentSample;

    // Interpolate to provide an initial guess for t
    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    var guessForT = intervalStart + dist * kSampleStepSize;

    var initialSlope = getSlope(guessForT, mX1, mX2);
    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0.0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }

  return function BezierEasing(x) {
    if (mX1 === mY1 && mX2 === mY2) {
      return x; // linear
    }
    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
    if (x === 0) {
      return 0;
    }
    if (x === 1) {
      return 1;
    }
    return calcBezier(getTForX(x), mY1, mY2);
  };
};

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimatedEvent__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nodes_AnimatedProps__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__exports_View_ViewStylePropTypes__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







function createAnimatedComponent(Component) {
  __WEBPACK_IMPORTED_MODULE_4_fbjs_lib_invariant___default()(typeof Component === 'string' || Component.prototype && Component.prototype.isReactComponent, '`createAnimatedComponent` does not support stateless functional components; ' + 'use a class component instead.');

  var AnimatedComponent = function (_React$Component) {
    _inherits(AnimatedComponent, _React$Component);

    function AnimatedComponent(props) {
      _classCallCheck(this, AnimatedComponent);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

      _this._invokeAnimatedPropsCallbackOnMount = false;
      _this._eventDetachers = [];

      _this._animatedPropsCallback = function () {
        if (_this._component == null) {
          // AnimatedProps is created in will-mount because it's used in render.
          // But this callback may be invoked before mount in async mode,
          // In which case we should defer the setNativeProps() call.
          // React may throw away uncommitted work in async mode,
          // So a deferred call won't always be invoked.
          _this._invokeAnimatedPropsCallbackOnMount = true;
        } else if (AnimatedComponent.__skipSetNativeProps_FOR_TESTS_ONLY || typeof _this._component.setNativeProps !== 'function') {
          _this.forceUpdate();
        } else if (!_this._propsAnimated.__isNative) {
          _this._component.setNativeProps(_this._propsAnimated.__getAnimatedValue());
        } else {
          throw new Error('Attempting to run JS driven animation on animated ' + 'node that has been moved to "native" earlier by starting an ' + 'animation with `useNativeDriver: true`');
        }
      };

      _this._setComponentRef = _this._setComponentRef.bind(_this);
      return _this;
    }

    AnimatedComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this._propsAnimated && this._propsAnimated.__detach();
      this._detachNativeEvents();
    };

    AnimatedComponent.prototype.setNativeProps = function setNativeProps(props) {
      this._component.setNativeProps(props);
    };

    AnimatedComponent.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
      this._attachProps(this.props);
    };

    AnimatedComponent.prototype.componentDidMount = function componentDidMount() {
      if (this._invokeAnimatedPropsCallbackOnMount) {
        this._invokeAnimatedPropsCallbackOnMount = false;
        this._animatedPropsCallback();
      }

      this._propsAnimated.setNativeView(this._component);
      this._attachNativeEvents();
    };

    AnimatedComponent.prototype._attachNativeEvents = function _attachNativeEvents() {
      var _this2 = this;

      // Make sure to get the scrollable node for components that implement
      // `ScrollResponder.Mixin`.
      var scrollableNode = this._component.getScrollableNode ? this._component.getScrollableNode() : this._component;

      var _loop = function _loop(key) {
        var prop = _this2.props[key];
        if (prop instanceof __WEBPACK_IMPORTED_MODULE_0__AnimatedEvent__["a" /* AnimatedEvent */] && prop.__isNative) {
          prop.__attach(scrollableNode, key);
          _this2._eventDetachers.push(function () {
            return prop.__detach(scrollableNode, key);
          });
        }
      };

      for (var key in this.props) {
        _loop(key);
      }
    };

    AnimatedComponent.prototype._detachNativeEvents = function _detachNativeEvents() {
      this._eventDetachers.forEach(function (remove) {
        return remove();
      });
      this._eventDetachers = [];
    };

    // The system is best designed when setNativeProps is implemented. It is
    // able to avoid re-rendering and directly set the attributes that changed.
    // However, setNativeProps can only be implemented on leaf native
    // components. If you want to animate a composite component, you need to
    // re-render it. In this case, we have a fallback that uses forceUpdate.


    AnimatedComponent.prototype._attachProps = function _attachProps(nextProps) {
      var oldPropsAnimated = this._propsAnimated;

      this._propsAnimated = new __WEBPACK_IMPORTED_MODULE_1__nodes_AnimatedProps__["a" /* default */](nextProps, this._animatedPropsCallback);

      // When you call detach, it removes the element from the parent list
      // of children. If it goes to 0, then the parent also detaches itself
      // and so on.
      // An optimization is to attach the new elements and THEN detach the old
      // ones instead of detaching and THEN attaching.
      // This way the intermediate state isn't to go to 0 and trigger
      // this expensive recursive detaching to then re-attach everything on
      // the very next operation.
      oldPropsAnimated && oldPropsAnimated.__detach();
    };

    AnimatedComponent.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(newProps) {
      this._attachProps(newProps);
    };

    AnimatedComponent.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
      if (this._component !== this._prevComponent) {
        this._propsAnimated.setNativeView(this._component);
      }
      if (this._component !== this._prevComponent || prevProps !== this.props) {
        this._detachNativeEvents();
        this._attachNativeEvents();
      }
    };

    AnimatedComponent.prototype.render = function render() {
      var props = this._propsAnimated.__getValue();
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, _extends({}, props, {
        ref: this._setComponentRef
        // The native driver updates views directly through the UI thread so we
        // have to make sure the view doesn't get optimized away because it cannot
        // go through the NativeViewHierarchyManager since it operates on the shadow
        // thread.
        , collapsable: this._propsAnimated.__isNative ? false : props.collapsable
      }));
    };

    AnimatedComponent.prototype._setComponentRef = function _setComponentRef(c) {
      this._prevComponent = this._component;
      this._component = c;
    };

    // A third party library can use getNode()
    // to get the node reference of the decorated component


    AnimatedComponent.prototype.getNode = function getNode() {
      return this._component;
    };

    return AnimatedComponent;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  AnimatedComponent.__skipSetNativeProps_FOR_TESTS_ONLY = false;


  var propTypes = Component.propTypes;

  AnimatedComponent.propTypes =  false ? {
    style: function style(props, propName, componentName) {
      if (!propTypes) {
        return;
      }

      for (var key in ViewStylePropTypes) {
        if (!propTypes[key] && props[key] !== undefined) {
          console.warn('You are setting the style `{ ' + key + ': ... }` as a prop. You ' + 'should nest it in a style object. ' + 'E.g. `{ style: { ' + key + ': ... } }`');
        }
      }
    }
  } : {};

  return AnimatedComponent;
}

/* harmony default export */ __webpack_exports__["a"] = (createAnimatedComponent);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export registerAsset */
/* harmony export (immutable) */ __webpack_exports__["a"] = getAssetByID;


var assets = []; /**
                  * Copyright (c) 2015-present, Facebook, Inc.
                  *
                  * This source code is licensed under the MIT license found in the
                  * LICENSE file in the root directory of this source tree.
                  *
                  * 
                  */

function registerAsset(asset) {
  // `push` returns new array length, so the first asset will
  // get id 1 (not 0) to make the value truthy
  return assets.push(asset);
}

function getAssetByID(assetId) {
  return assets[assetId - 1];
}

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */

var id = 0;
var requests = {};

var ImageLoader = {
  abort: function abort(requestId) {
    var image = requests['' + requestId];
    if (image) {
      image.onerror = image.onload = image = null;
      delete requests['' + requestId];
    }
  },
  getSize: function getSize(uri, success, failure) {
    var complete = false;
    var interval = setInterval(callback, 16);
    var requestId = ImageLoader.load(uri, callback, errorCallback);

    function callback() {
      var image = requests['' + requestId];
      if (image) {
        var naturalHeight = image.naturalHeight,
            naturalWidth = image.naturalWidth;

        if (naturalHeight && naturalWidth) {
          success(naturalWidth, naturalHeight);
          complete = true;
        }
      }
      if (complete) {
        ImageLoader.abort(requestId);
        clearInterval(interval);
      }
    }

    function errorCallback() {
      if (typeof failure === 'function') {
        failure();
      }
      ImageLoader.abort(requestId);
      clearInterval(interval);
    }
  },
  load: function load(uri, onLoad, onError) {
    id += 1;
    var image = new window.Image();
    image.onerror = onError;
    image.onload = function (e) {
      // avoid blocking the main thread
      if (typeof image.decode === 'function') {
        image.decode().then(function () {
          onLoad(e);
        });
      } else {
        setTimeout(function () {
          onLoad(e);
        }, 0);
      }
    };
    image.src = uri;
    requests['' + id] = image;
    return id;
  },
  prefetch: function prefetch(uri) {
    return new Promise(function (resolve, reject) {
      ImageLoader.load(uri, resolve, reject);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ImageLoader);

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */




var ImageURISourcePropType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  /**
   * `uri` is a string representing the resource identifier for the image, which
   * could be an http address, a local file path, or the name of a static image
   * resource (which should be wrapped in the `require('./path/to/image.png')`
   * function).
   */
  uri: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  /**
   * `bundle` is the iOS asset bundle which the image is included in. This
   * will default to [NSBundle mainBundle] if not set.
   * @platform ios
   */
  bundle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  /**
   * `method` is the HTTP Method to use. Defaults to GET if not specified.
   */
  method: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  /**
   * `headers` is an object representing the HTTP headers to send along with the
   * request for a remote image.
   */
  headers: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
  /**
   * `body` is the HTTP body to send with the request. This must be a valid
   * UTF-8 string, and will be sent exactly as specified, with no
   * additional encoding (e.g. URL-escaping or base64) applied.
   */
  body: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  /**
   * `cache` determines how the requests handles potentially cached
   * responses.
   *
   * - `default`: Use the native platforms default strategy. `useProtocolCachePolicy` on iOS.
   *
   * - `reload`: The data for the URL will be loaded from the originating source.
   * No existing cache data should be used to satisfy a URL load request.
   *
   * - `force-cache`: The existing cached data will be used to satisfy the request,
   * regardless of its age or expiration date. If there is no existing data in the cache
   * corresponding the request, the data is loaded from the originating source.
   *
   * - `only-if-cached`: The existing cache data will be used to satisfy a request, regardless of
   * its age or expiration date. If there is no existing data in the cache corresponding
   * to a URL load request, no attempt is made to load the data from the originating source,
   * and the load is considered to have failed.
   *
   * @platform ios
   */
  cache: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['default', 'reload', 'force-cache', 'only-if-cached']),
  /**
   * `width` and `height` can be specified if known at build time, in which case
   * these will be used to set the default `<Image/>` component dimensions.
   */
  width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  /**
   * `scale` is used to indicate the scale factor of the image. Defaults to 1.0 if
   * unspecified, meaning that one image pixel equates to one display point / DIP.
   */
  scale: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
});

var ImageSourcePropType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([ImageURISourcePropType,
// Opaque type returned by require('./image.jpg')
__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
// Multiple sources
__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(ImageURISourcePropType)]);

/* unused harmony default export */ var _unused_webpack_default_export = (ImageSourcePropType);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var dataUriPattern = /^data:/;

var ImageUriCache = function () {
  function ImageUriCache() {
    _classCallCheck(this, ImageUriCache);
  }

  ImageUriCache.has = function has(uri) {
    var entries = ImageUriCache._entries;
    var isDataUri = dataUriPattern.test(uri);
    return isDataUri || Boolean(entries[uri]);
  };

  ImageUriCache.add = function add(uri) {
    var entries = ImageUriCache._entries;
    var lastUsedTimestamp = Date.now();
    if (entries[uri]) {
      entries[uri].lastUsedTimestamp = lastUsedTimestamp;
      entries[uri].refCount += 1;
    } else {
      entries[uri] = {
        lastUsedTimestamp: lastUsedTimestamp,
        refCount: 1
      };
    }
  };

  ImageUriCache.remove = function remove(uri) {
    var entries = ImageUriCache._entries;
    if (entries[uri]) {
      entries[uri].refCount -= 1;
    }
    // Free up entries when the cache is "full"
    ImageUriCache._cleanUpIfNeeded();
  };

  ImageUriCache._cleanUpIfNeeded = function _cleanUpIfNeeded() {
    var entries = ImageUriCache._entries;
    var imageUris = Object.keys(entries);

    if (imageUris.length + 1 > ImageUriCache._maximumEntries) {
      var leastRecentlyUsedKey = void 0;
      var leastRecentlyUsedEntry = void 0;

      imageUris.forEach(function (uri) {
        var entry = entries[uri];
        if ((!leastRecentlyUsedEntry || entry.lastUsedTimestamp < leastRecentlyUsedEntry.lastUsedTimestamp) && entry.refCount === 0) {
          leastRecentlyUsedKey = uri;
          leastRecentlyUsedEntry = entry;
        }
      });

      if (leastRecentlyUsedKey) {
        delete entries[leastRecentlyUsedKey];
      }
    }
  };

  return ImageUriCache;
}();

ImageUriCache._maximumEntries = 256;
ImageUriCache._entries = {};
/* harmony default export */ __webpack_exports__["a"] = (ImageUriCache);

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(90);

var emptyObject = __webpack_require__(127);
var _invariant = __webpack_require__(4);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debounce__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewPropTypes__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */








var normalizeScrollEvent = function normalizeScrollEvent(e) {
  return {
    nativeEvent: {
      contentOffset: {
        get x() {
          return e.target.scrollLeft;
        },
        get y() {
          return e.target.scrollTop;
        }
      },
      contentSize: {
        get height() {
          return e.target.scrollHeight;
        },
        get width() {
          return e.target.scrollWidth;
        }
      },
      layoutMeasurement: {
        get height() {
          return e.target.offsetHeight;
        },
        get width() {
          return e.target.offsetWidth;
        }
      }
    },
    timeStamp: Date.now()
  };
};

/**
 * Encapsulates the Web-specific scroll throttling and disabling logic
 */

var ScrollViewBase = function (_Component) {
  _inherits(ScrollViewBase, _Component);

  function ScrollViewBase() {
    var _temp, _this, _ret;

    _classCallCheck(this, ScrollViewBase);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._debouncedOnScrollEnd = __WEBPACK_IMPORTED_MODULE_0_debounce___default()(_this._handleScrollEnd, 100), _this._state = { isScrolling: false, scrollLastTick: 0 }, _this._createPreventableScrollHandler = function (handler) {
      return function (e) {
        if (_this.props.scrollEnabled) {
          if (handler) {
            handler(e);
          }
        } else {
          // To disable scrolling in all browsers except Chrome
          e.preventDefault();
        }
      };
    }, _this._handleScroll = function (e) {
      e.persist();
      e.stopPropagation();
      var scrollEventThrottle = _this.props.scrollEventThrottle;
      // A scroll happened, so the scroll bumps the debounce.

      _this._debouncedOnScrollEnd(e);
      if (_this._state.isScrolling) {
        // Scroll last tick may have changed, check if we need to notify
        if (_this._shouldEmitScrollEvent(_this._state.scrollLastTick, scrollEventThrottle)) {
          _this._handleScrollTick(e);
        }
      } else {
        // Weren't scrolling, so we must have just started
        _this._handleScrollStart(e);
      }
    }, _this._setViewRef = function (element) {
      _this._viewRef = element;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ScrollViewBase.prototype.setNativeProps = function setNativeProps(props) {
    if (this._viewRef) {
      this._viewRef.setNativeProps(props);
    }
  };

  ScrollViewBase.prototype.render = function render() {
    var _props = this.props,
        scrollEnabled = _props.scrollEnabled,
        style = _props.style,
        alwaysBounceHorizontal = _props.alwaysBounceHorizontal,
        alwaysBounceVertical = _props.alwaysBounceVertical,
        automaticallyAdjustContentInsets = _props.automaticallyAdjustContentInsets,
        bounces = _props.bounces,
        bouncesZoom = _props.bouncesZoom,
        canCancelContentTouches = _props.canCancelContentTouches,
        centerContent = _props.centerContent,
        contentInset = _props.contentInset,
        contentInsetAdjustmentBehavior = _props.contentInsetAdjustmentBehavior,
        contentOffset = _props.contentOffset,
        decelerationRate = _props.decelerationRate,
        directionalLockEnabled = _props.directionalLockEnabled,
        endFillColor = _props.endFillColor,
        indicatorStyle = _props.indicatorStyle,
        keyboardShouldPersistTaps = _props.keyboardShouldPersistTaps,
        maximumZoomScale = _props.maximumZoomScale,
        minimumZoomScale = _props.minimumZoomScale,
        onMomentumScrollBegin = _props.onMomentumScrollBegin,
        onMomentumScrollEnd = _props.onMomentumScrollEnd,
        onScrollBeginDrag = _props.onScrollBeginDrag,
        onScrollEndDrag = _props.onScrollEndDrag,
        overScrollMode = _props.overScrollMode,
        pinchGestureEnabled = _props.pinchGestureEnabled,
        removeClippedSubviews = _props.removeClippedSubviews,
        scrollEventThrottle = _props.scrollEventThrottle,
        scrollIndicatorInsets = _props.scrollIndicatorInsets,
        scrollPerfTag = _props.scrollPerfTag,
        scrollsToTop = _props.scrollsToTop,
        showsHorizontalScrollIndicator = _props.showsHorizontalScrollIndicator,
        showsVerticalScrollIndicator = _props.showsVerticalScrollIndicator,
        snapToInterval = _props.snapToInterval,
        snapToAlignment = _props.snapToAlignment,
        zoomScale = _props.zoomScale,
        other = _objectWithoutProperties(_props, ['scrollEnabled', 'style', 'alwaysBounceHorizontal', 'alwaysBounceVertical', 'automaticallyAdjustContentInsets', 'bounces', 'bouncesZoom', 'canCancelContentTouches', 'centerContent', 'contentInset', 'contentInsetAdjustmentBehavior', 'contentOffset', 'decelerationRate', 'directionalLockEnabled', 'endFillColor', 'indicatorStyle', 'keyboardShouldPersistTaps', 'maximumZoomScale', 'minimumZoomScale', 'onMomentumScrollBegin', 'onMomentumScrollEnd', 'onScrollBeginDrag', 'onScrollEndDrag', 'overScrollMode', 'pinchGestureEnabled', 'removeClippedSubviews', 'scrollEventThrottle', 'scrollIndicatorInsets', 'scrollPerfTag', 'scrollsToTop', 'showsHorizontalScrollIndicator', 'showsVerticalScrollIndicator', 'snapToInterval', 'snapToAlignment', 'zoomScale']);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__View__["a" /* default */], _extends({}, other, {
      onScroll: this._handleScroll,
      onTouchMove: this._createPreventableScrollHandler(this.props.onTouchMove),
      onWheel: this._createPreventableScrollHandler(this.props.onWheel),
      ref: this._setViewRef,
      style: __WEBPACK_IMPORTED_MODULE_1__StyleSheet__["a" /* default */].compose(style, !scrollEnabled && styles.scrollDisabled)
    }));
  };

  ScrollViewBase.prototype._handleScrollStart = function _handleScrollStart(e) {
    this._state.isScrolling = true;
    this._state.scrollLastTick = Date.now();
  };

  ScrollViewBase.prototype._handleScrollTick = function _handleScrollTick(e) {
    var onScroll = this.props.onScroll;

    this._state.scrollLastTick = Date.now();
    if (onScroll) {
      onScroll(normalizeScrollEvent(e));
    }
  };

  ScrollViewBase.prototype._handleScrollEnd = function _handleScrollEnd(e) {
    var onScroll = this.props.onScroll;

    this._state.isScrolling = false;
    if (onScroll) {
      onScroll(normalizeScrollEvent(e));
    }
  };

  ScrollViewBase.prototype._shouldEmitScrollEvent = function _shouldEmitScrollEvent(lastTick, eventThrottle) {
    var timeSinceLastTick = Date.now() - lastTick;
    return eventThrottle > 0 && timeSinceLastTick >= eventThrottle;
  };

  return ScrollViewBase;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

// Chrome doesn't support e.preventDefault in this case; touch-action must be
// used to disable scrolling.
// https://developers.google.com/web/updates/2017/01/scrolling-intervention


ScrollViewBase.defaultProps = {
  scrollEnabled: true,
  scrollEventThrottle: 0
};
/* harmony default export */ __webpack_exports__["a"] = (ScrollViewBase);
ScrollViewBase.propTypes =  false ? Object.assign({}, ViewPropTypes, {
  onMomentumScrollBegin: func,
  onMomentumScrollEnd: func,
  onScroll: func,
  onScrollBeginDrag: func,
  onScrollEndDrag: func,
  onTouchMove: func,
  onWheel: func,
  removeClippedSubviews: bool,
  scrollEnabled: bool,
  scrollEventThrottle: number,
  showsHorizontalScrollIndicator: bool,
  showsVerticalScrollIndicator: bool
}) : {};
var styles = __WEBPACK_IMPORTED_MODULE_1__StyleSheet__["a" /* default */].create({
  scrollDisabled: {
    touchAction: 'none'
  }
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unmountComponentAtNode__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__renderApplication__ = __webpack_require__(661);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */






var emptyObject = {};
var runnables = {};

var componentProviderInstrumentationHook = function componentProviderInstrumentationHook(component) {
  return component();
};
var wrapperComponentProvider = void 0;

/**
 * `AppRegistry` is the JS entry point to running all React Native apps.
 */
var AppRegistry = function () {
  function AppRegistry() {
    _classCallCheck(this, AppRegistry);
  }

  AppRegistry.getAppKeys = function getAppKeys() {
    return Object.keys(runnables);
  };

  AppRegistry.getApplication = function getApplication(appKey, appParameters) {
    __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(runnables[appKey] && runnables[appKey].getApplication, 'Application ' + appKey + ' has not been registered. ' + 'This is either due to an import error during initialization or failure to call AppRegistry.registerComponent.');

    return runnables[appKey].getApplication(appParameters);
  };

  AppRegistry.registerComponent = function registerComponent(appKey, componentProvider) {
    runnables[appKey] = {
      getApplication: function getApplication(appParameters) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__renderApplication__["b" /* getApplication */])(componentProviderInstrumentationHook(componentProvider), appParameters ? appParameters.initialProps : emptyObject, wrapperComponentProvider && wrapperComponentProvider(appParameters));
      },
      run: function run(appParameters) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__renderApplication__["a" /* default */])(componentProviderInstrumentationHook(componentProvider), appParameters.initialProps || emptyObject, appParameters.rootTag, wrapperComponentProvider && wrapperComponentProvider(appParameters), appParameters.callback);
      }
    };
    return appKey;
  };

  AppRegistry.registerConfig = function registerConfig(config) {
    config.forEach(function (_ref) {
      var appKey = _ref.appKey,
          component = _ref.component,
          run = _ref.run;

      if (run) {
        AppRegistry.registerRunnable(appKey, run);
      } else {
        __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(component, 'No component provider passed in');
        AppRegistry.registerComponent(appKey, component);
      }
    });
  };

  // TODO: fix style sheet creation when using this method


  AppRegistry.registerRunnable = function registerRunnable(appKey, run) {
    runnables[appKey] = { run: run };
    return appKey;
  };

  AppRegistry.runApplication = function runApplication(appKey, appParameters) {
    var isDevelopment = "production" !== 'production';
    if (isDevelopment) {
      var params = Object.assign({}, appParameters);
      params.rootTag = '#' + params.rootTag.id;

      console.log('Running application "' + appKey + '" with appParams: ' + JSON.stringify(params) + '.\n' + ('Development-level warnings: ' + (isDevelopment ? 'ON' : 'OFF') + '.\n') + ('Performance optimizations: ' + (isDevelopment ? 'OFF' : 'ON') + '.'));
    }

    __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(runnables[appKey] && runnables[appKey].run, 'Application "' + appKey + '" has not been registered. ' + 'This is either due to an import error during initialization or failure to call AppRegistry.registerComponent.');

    runnables[appKey].run(appParameters);
  };

  AppRegistry.setComponentProviderInstrumentationHook = function setComponentProviderInstrumentationHook(hook) {
    componentProviderInstrumentationHook = hook;
  };

  AppRegistry.setWrapperComponentProvider = function setWrapperComponentProvider(provider) {
    wrapperComponentProvider = provider;
  };

  AppRegistry.unmountApplicationComponentAtRootTag = function unmountApplicationComponentAtRootTag(rootTag) {
    Object(__WEBPACK_IMPORTED_MODULE_1__unmountComponentAtNode__["a" /* default */])(rootTag);
  };

  return AppRegistry;
}();

/* harmony default export */ __webpack_exports__["a"] = (AppRegistry);

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = renderApplication;
/* harmony export (immutable) */ __webpack_exports__["b"] = getApplication;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppContainer__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_hydrate__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__render__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyleSheet_styleResolver__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */








var renderFn =  false ? render : __WEBPACK_IMPORTED_MODULE_2__modules_hydrate__["a" /* default */];

function renderApplication(RootComponent, initialProps, rootTag, WrapperComponent, callback) {
  __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_invariant___default()(rootTag, 'Expect to have a valid rootTag, instead got ', rootTag);

  renderFn(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0__AppContainer__["a" /* default */],
    { WrapperComponent: WrapperComponent, rootTag: rootTag },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RootComponent, initialProps)
  ), rootTag, callback);
}

function getApplication(RootComponent, initialProps, WrapperComponent) {
  var element = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0__AppContainer__["a" /* default */],
    { WrapperComponent: WrapperComponent, rootTag: {} },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RootComponent, initialProps)
  );
  // Don't escape CSS text
  var getStyleElement = function getStyleElement(props) {
    var sheet = __WEBPACK_IMPORTED_MODULE_4__StyleSheet_styleResolver__["a" /* default */].getStyleSheet();
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: sheet.textContent }, id: sheet.id }));
  };
  return { element: element, getStyleElement: getStyleElement };
}

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */






var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    var _temp, _this, _ret;

    _classCallCheck(this, AppContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { mainKey: 1 }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  AppContainer.prototype.getChildContext = function getChildContext() {
    return {
      rootTag: this.props.rootTag
    };
  };

  AppContainer.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        WrapperComponent = _props.WrapperComponent;

    var innerView = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__View__["a" /* default */], {
      children: children,
      key: this.state.mainKey,
      pointerEvents: 'box-none',
      style: styles.appContainer
    });

    if (WrapperComponent) {
      innerView = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        WrapperComponent,
        null,
        innerView
      );
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__View__["a" /* default */],
      { pointerEvents: 'box-none', style: styles.appContainer },
      innerView
    );
  };

  return AppContainer;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

AppContainer.childContextTypes = {
  rootTag: __WEBPACK_IMPORTED_MODULE_2_prop_types__["any"]
};
/* harmony default export */ __webpack_exports__["a"] = (AppContainer);
AppContainer.propTypes =  false ? {
  WrapperComponent: any,
  children: node,
  rootTag: any.isRequired
} : {};


var styles = __WEBPACK_IMPORTED_MODULE_0__StyleSheet__["a" /* default */].create({
  appContainer: {
    flex: 1
  }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_dom__["hydrate"]);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_array_find_index__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */





// Android 4.4 browser
var isPrefixed = __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__["canUseDOM"] && !document.hasOwnProperty('hidden') && document.hasOwnProperty('webkitHidden');

var EVENT_TYPES = ['change', 'memoryWarning'];
var VISIBILITY_CHANGE_EVENT = isPrefixed ? 'webkitvisibilitychange' : 'visibilitychange';
var VISIBILITY_STATE_PROPERTY = isPrefixed ? 'webkitVisibilityState' : 'visibilityState';

var AppStates = {
  BACKGROUND: 'background',
  ACTIVE: 'active'
};

var listeners = [];

var AppState = function () {
  function AppState() {
    _classCallCheck(this, AppState);
  }

  AppState.addEventListener = function addEventListener(type, handler) {
    if (AppState.isAvailable) {
      __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(EVENT_TYPES.indexOf(type) !== -1, 'Trying to subscribe to unknown event: "%s"', type);
      if (type === 'change') {
        var callback = function callback() {
          return handler(AppState.currentState);
        };
        listeners.push([handler, callback]);
        document.addEventListener(VISIBILITY_CHANGE_EVENT, callback, false);
      }
    }
  };

  AppState.removeEventListener = function removeEventListener(type, handler) {
    if (AppState.isAvailable) {
      __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(EVENT_TYPES.indexOf(type) !== -1, 'Trying to remove listener for unknown event: "%s"', type);
      if (type === 'change') {
        var listenerIndex = __WEBPACK_IMPORTED_MODULE_1_array_find_index___default()(listeners, function (pair) {
          return pair[0] === handler;
        });
        __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(listenerIndex !== -1, 'Trying to remove AppState listener for unregistered handler');
        var callback = listeners[listenerIndex][1];
        document.removeEventListener(VISIBILITY_CHANGE_EVENT, callback, false);
        listeners.splice(listenerIndex, 1);
      }
    }
  };

  _createClass(AppState, null, [{
    key: 'currentState',
    get: function get() {
      if (!AppState.isAvailable) {
        return AppStates.ACTIVE;
      }

      switch (document[VISIBILITY_STATE_PROPERTY]) {
        case 'hidden':
        case 'prerender':
        case 'unloaded':
          return AppStates.BACKGROUND;
        default:
          return AppStates.ACTIVE;
      }
    }
  }]);

  return AppState;
}();

AppState.isAvailable = __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__["canUseDOM"] && document[VISIBILITY_STATE_PROPERTY];
/* harmony default export */ __webpack_exports__["a"] = (AppState);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deep_assign__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deep_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_deep_assign__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var mergeLocalStorageItem = function mergeLocalStorageItem(key, value) {
  var oldValue = window.localStorage.getItem(key);
  var oldObject = JSON.parse(oldValue);
  var newObject = JSON.parse(value);
  var nextValue = JSON.stringify(__WEBPACK_IMPORTED_MODULE_0_deep_assign___default()({}, oldObject, newObject));
  window.localStorage.setItem(key, nextValue);
};

var createPromise = function createPromise(getValue, callback) {
  return new Promise(function (resolve, reject) {
    try {
      var value = getValue();
      if (callback) {
        callback(null, value);
      }
      resolve(value);
    } catch (err) {
      if (callback) {
        callback(err);
      }
      reject(err);
    }
  });
};

var createPromiseAll = function createPromiseAll(promises, callback, processResult) {
  return Promise.all(promises).then(function (result) {
    var value = processResult ? processResult(result) : null;
    callback && callback(null, value);
    return Promise.resolve(value);
  }, function (errors) {
    callback && callback(errors);
    return Promise.reject(errors);
  });
};

var AsyncStorage = function () {
  function AsyncStorage() {
    _classCallCheck(this, AsyncStorage);
  }

  /**
   * Erases *all* AsyncStorage for the domain.
   */
  AsyncStorage.clear = function clear(callback) {
    return createPromise(function () {
      window.localStorage.clear();
    }, callback);
  };

  /**
   * (stub) Flushes any pending requests using a single batch call to get the data.
   */


  AsyncStorage.flushGetRequests = function flushGetRequests() {};

  /**
   * Gets *all* keys known to the app, for all callers, libraries, etc.
   */


  AsyncStorage.getAllKeys = function getAllKeys(callback) {
    return createPromise(function () {
      var numberOfKeys = window.localStorage.length;
      var keys = [];
      for (var i = 0; i < numberOfKeys; i += 1) {
        var key = window.localStorage.key(i);
        keys.push(key);
      }
      return keys;
    }, callback);
  };

  /**
   * Fetches `key` value.
   */


  AsyncStorage.getItem = function getItem(key, callback) {
    return createPromise(function () {
      return window.localStorage.getItem(key);
    }, callback);
  };

  /**
   * multiGet resolves to an array of key-value pair arrays that matches the
   * input format of multiSet.
   *
   *   multiGet(['k1', 'k2']) -> [['k1', 'val1'], ['k2', 'val2']]
   */


  AsyncStorage.multiGet = function multiGet(keys, callback) {
    var promises = keys.map(function (key) {
      return AsyncStorage.getItem(key);
    });
    var processResult = function processResult(result) {
      return result.map(function (value, i) {
        return [keys[i], value];
      });
    };
    return createPromiseAll(promises, callback, processResult);
  };

  /**
   * Sets `value` for `key`.
   */


  AsyncStorage.setItem = function setItem(key, value, callback) {
    return createPromise(function () {
      window.localStorage.setItem(key, value);
    }, callback);
  };

  /**
   * Takes an array of key-value array pairs.
   *   multiSet([['k1', 'val1'], ['k2', 'val2']])
   */


  AsyncStorage.multiSet = function multiSet(keyValuePairs, callback) {
    var promises = keyValuePairs.map(function (item) {
      return AsyncStorage.setItem(item[0], item[1]);
    });
    return createPromiseAll(promises, callback);
  };

  /**
   * Merges existing value with input value, assuming they are stringified JSON.
   */


  AsyncStorage.mergeItem = function mergeItem(key, value, callback) {
    return createPromise(function () {
      mergeLocalStorageItem(key, value);
    }, callback);
  };

  /**
   * Takes an array of key-value array pairs and merges them with existing
   * values, assuming they are stringified JSON.
   *
   *   multiMerge([['k1', 'val1'], ['k2', 'val2']])
   */


  AsyncStorage.multiMerge = function multiMerge(keyValuePairs, callback) {
    var promises = keyValuePairs.map(function (item) {
      return AsyncStorage.mergeItem(item[0], item[1]);
    });
    return createPromiseAll(promises, callback);
  };

  /**
   * Removes a `key`
   */


  AsyncStorage.removeItem = function removeItem(key, callback) {
    return createPromise(function () {
      return window.localStorage.removeItem(key);
    }, callback);
  };

  /**
   * Delete all the keys in the `keys` array.
   */


  AsyncStorage.multiRemove = function multiRemove(keys, callback) {
    var promises = keys.map(function (key) {
      return AsyncStorage.removeItem(key);
    });
    return createPromiseAll(promises, callback);
  };

  return AsyncStorage;
}();

/* harmony default export */ __webpack_exports__["a"] = (AsyncStorage);

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObj = __webpack_require__(667);
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Sources cannot be null or undefined');
	}

	return Object(val);
}

function assignKey(to, from, key) {
	var val = from[key];

	if (val === undefined || val === null) {
		return;
	}

	if (hasOwnProperty.call(to, key)) {
		if (to[key] === undefined || to[key] === null) {
			throw new TypeError('Cannot convert undefined or null to object (' + key + ')');
		}
	}

	if (!hasOwnProperty.call(to, key) || !isObj(val)) {
		to[key] = val;
	} else {
		to[key] = assign(Object(to[key]), from[key]);
	}
}

function assign(to, from) {
	if (to === from) {
		return to;
	}

	from = Object(from);

	for (var key in from) {
		if (hasOwnProperty.call(from, key)) {
			assignKey(to, from, key);
		}
	}

	if (Object.getOwnPropertySymbols) {
		var symbols = Object.getOwnPropertySymbols(from);

		for (var i = 0; i < symbols.length; i++) {
			if (propIsEnumerable.call(from, symbols[i])) {
				assignKey(to, from, symbols[i]);
			}
		}
	}

	return to;
}

module.exports = function deepAssign(target) {
	target = toObject(target);

	for (var s = 1; s < arguments.length; s++) {
		assign(target, arguments[s]);
	}

	return target;
};


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (x) {
	var type = typeof x;
	return x !== null && (type === 'object' || type === 'function');
};


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function emptyFunction() {}

var BackHandler = {
  exitApp: emptyFunction,
  addEventListener: function addEventListener() {
    return {
      remove: emptyFunction
    };
  },

  removeEventListener: emptyFunction
};

/* harmony default export */ __webpack_exports__["a"] = (BackHandler);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var Clipboard = function () {
  function Clipboard() {
    _classCallCheck(this, Clipboard);
  }

  Clipboard.isAvailable = function isAvailable() {
    return typeof document.queryCommandSupported === 'function' && document.queryCommandSupported('copy');
  };

  Clipboard.getString = function getString() {
    return Promise.resolve('');
  };

  Clipboard.setString = function setString(text) {
    var success = false;
    var body = document.body;

    if (body) {
      // add the text to a hidden node
      var node = document.createElement('span');
      node.textContent = text;
      node.style.opacity = '0';
      node.style.position = 'absolute';
      node.style.whiteSpace = 'pre-wrap';
      body.appendChild(node);

      // select the text
      var selection = window.getSelection();
      selection.removeAllRanges();
      var range = document.createRange();
      range.selectNodeContents(node);
      selection.addRange(range);

      // attempt to copy
      try {
        document.execCommand('copy');
        success = true;
      } catch (e) {}

      // remove selection and node
      selection.removeAllRanges();
      body.removeChild(node);
    }

    return success;
  };

  return Clipboard;
}();

/* harmony default export */ __webpack_exports__["a"] = (Clipboard);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dimensions__ = __webpack_require__(130);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var DeviceInfo = {
  Dimensions: {
    get windowPhysicalPixels() {
      var _Dimensions$get = __WEBPACK_IMPORTED_MODULE_1__Dimensions__["a" /* default */].get('window'),
          width = _Dimensions$get.width,
          height = _Dimensions$get.height,
          fontScale = _Dimensions$get.fontScale,
          scale = _Dimensions$get.scale;

      return {
        width: width * scale,
        height: height * scale,
        scale: scale,
        fontScale: fontScale
      };
    },
    get screenPhysicalPixels() {
      var _Dimensions$get2 = __WEBPACK_IMPORTED_MODULE_1__Dimensions__["a" /* default */].get('screen'),
          width = _Dimensions$get2.width,
          height = _Dimensions$get2.height,
          fontScale = _Dimensions$get2.fontScale,
          scale = _Dimensions$get2.scale;

      return {
        width: width * scale,
        height: height * scale,
        scale: scale,
        fontScale: fontScale
      };
    }
  },

  get locale() {
    if (__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__["canUseDOM"]) {
      if (window.navigator.languages) {
        return window.navigator.languages[0];
      } else {
        return window.navigator.language;
      }
    }
  },

  get totalMemory() {
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__["canUseDOM"] ? window.navigator.deviceMemory : undefined;
  },

  get userAgent() {
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__["canUseDOM"] ? window.navigator.userAgent : '';
  }
};

/* harmony default export */ __webpack_exports__["a"] = (DeviceInfo);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_Animated_Easing__ = __webpack_require__(292);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__vendor_react_native_Animated_Easing__["a" /* default */]);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_dismissKeyboard__ = __webpack_require__(293);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var Keyboard = {
  addListener: function addListener() {
    return { remove: function remove() {} };
  },
  dismiss: function dismiss() {
    Object(__WEBPACK_IMPORTED_MODULE_0__modules_dismissKeyboard__["a" /* default */])();
  },
  removeAllListeners: function removeAllListeners() {},
  removeListener: function removeListener() {}
};

/* harmony default export */ __webpack_exports__["a"] = (Keyboard);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_LayoutAnimation__ = __webpack_require__(674);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__vendor_react_native_LayoutAnimation__["a" /* default */]);

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports_UIManager__ = __webpack_require__(52);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 * @format
 */




var __DEV__ = Object({"NODE_ENV":"production","PUBLIC_URL":""}).NODE !== 'production';
var checkPropTypes = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes;


var Types = {
  spring: 'spring',
  linear: 'linear',
  easeInEaseOut: 'easeInEaseOut',
  easeIn: 'easeIn',
  easeOut: 'easeOut',
  keyboard: 'keyboard'
};

var Properties = {
  opacity: 'opacity',
  scaleX: 'scaleX',
  scaleY: 'scaleY',
  scaleXY: 'scaleXY'
};

var animType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  duration: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  delay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  springDamping: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  initialVelocity: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(Object.keys(Types)).isRequired,
  property: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(
  // Only applies to create/delete
  Object.keys(Properties))
});

var configType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  duration: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  create: animType,
  update: animType,
  delete: animType
});

function checkConfig(config, location, name) {
  checkPropTypes({ config: configType }, { config: config }, location, name);
}

function configureNext(config, onAnimationDidEnd) {
  if (__DEV__) {
    checkConfig(config, 'config', 'LayoutAnimation.configureNext');
  }
  __WEBPACK_IMPORTED_MODULE_1__exports_UIManager__["a" /* default */].configureNextLayoutAnimation(config, onAnimationDidEnd || function () {}, function () {
    /* unused */
  });
}

function create(duration, type, creationProp) {
  return {
    duration: duration,
    create: {
      type: type,
      property: creationProp
    },
    update: {
      type: type
    },
    delete: {
      type: type,
      property: creationProp
    }
  };
}

var Presets = {
  easeInEaseOut: create(300, Types.easeInEaseOut, Properties.opacity),
  linear: create(500, Types.linear, Properties.opacity),
  spring: {
    duration: 700,
    create: {
      type: Types.linear,
      property: Properties.opacity
    },
    update: {
      type: Types.spring,
      springDamping: 0.4
    },
    delete: {
      type: Types.linear,
      property: Properties.opacity
    }
  }
};

/**
 * Automatically animates views to their new positions when the
 * next layout happens.
 *
 * A common way to use this API is to call it before calling `setState`.
 *
 * Note that in order to get this to work on **Android** you need to set the following flags via `UIManager`:
 *
 *     UIManager.setLayoutAnimationEnabledExperimental && UIManager.setLayoutAnimationEnabledExperimental(true);
 */
var LayoutAnimation = {
  /**
   * Schedules an animation to happen on the next layout.
   *
   * @param config Specifies animation properties:
   *
   *   - `duration` in milliseconds
   *   - `create`, config for animating in new views (see `Anim` type)
   *   - `update`, config for animating views that have been updated
   * (see `Anim` type)
   *
   * @param onAnimationDidEnd Called when the animation finished.
   * Only supported on iOS.
   * @param onError Called on error. Only supported on iOS.
   */
  configureNext: configureNext,
  /**
   * Helper for creating a config for `configureNext`.
   */
  create: create,
  Types: Types,
  Properties: Properties,
  checkConfig: checkConfig,
  Presets: Presets,
  easeInEaseOut: configureNext.bind(null, Presets.easeInEaseOut),
  linear: configureNext.bind(null, Presets.linear),
  spring: configureNext.bind(null, Presets.spring)
};

/* harmony default export */ __webpack_exports__["a"] = (LayoutAnimation);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_invariant__);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var initialURL = __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__["canUseDOM"] ? window.location.href : '';

var Linking = {
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  canOpenURL: function canOpenURL() {
    return Promise.resolve(true);
  },
  getInitialURL: function getInitialURL() {
    return Promise.resolve(initialURL);
  },
  openURL: function openURL(url) {
    try {
      open(url);
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },
  _validateURL: function _validateURL(url) {
    __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_invariant___default()(typeof url === 'string', 'Invalid URL: should be a string. Was: ' + url);
    __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_invariant___default()(url, 'Invalid URL: cannot be empty');
  }
};

var open = function open(url) {
  if (__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__["canUseDOM"]) {
    window.location = new URL(url, window.location).toString();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Linking);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_NativeEventEmitter__ = __webpack_require__(290);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__vendor_react_native_NativeEventEmitter__["a" /* default */]);

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_array_find_index__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant__);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





var connection = __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_ExecutionEnvironment___default.a.canUseDOM && (window.navigator.connection || window.navigator.mozConnection || window.navigator.webkitConnection);

// Prevent the underlying event handlers from leaking and include additional
// properties available in browsers
var getConnectionInfoObject = function getConnectionInfoObject() {
  var result = {
    effectiveType: 'unknown',
    type: 'unknown'
  };
  if (!connection) {
    return result;
  }
  for (var prop in connection) {
    var value = connection[prop];
    if (typeof value !== 'function' && value != null) {
      result[prop] = value;
    }
  }
  return result;
};

// Map React Native events to browser equivalents
var eventTypesMap = {
  change: 'change',
  connectionChange: 'change'
};
var eventTypes = Object.keys(eventTypesMap);

var connectionListeners = [];
var netInfoListeners = [];

/**
 * Navigator online: https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine/onLine
 * Network Connection API: https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation
 */
var NetInfo = {
  addEventListener: function addEventListener(type, handler) {
    __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(eventTypes.indexOf(type) !== -1, 'Trying to subscribe to unknown event: "%s"', type);
    if (type === 'change') {
      console.warn('Listening to event `change` is deprecated. Use `connectionChange` instead.');
    }
    if (!connection) {
      console.error('Network Connection API is not supported. Not listening for connection type changes.');
      return {
        remove: function remove() {}
      };
    }

    var wrappedHandler = function wrappedHandler() {
      return handler(getConnectionInfoObject());
    };
    netInfoListeners.push([handler, wrappedHandler]);
    connection.addEventListener(eventTypesMap[type], wrappedHandler);
    return {
      remove: function remove() {
        return NetInfo.removeEventListener(eventTypesMap[type], handler);
      }
    };
  },
  removeEventListener: function removeEventListener(type, handler) {
    __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(eventTypes.indexOf(type) !== -1, 'Trying to unsubscribe from unknown event: "%s"', type);
    if (type === 'change') {
      console.warn('Listening to event `change` is deprecated. Use `connectionChange` instead.');
    }

    var listenerIndex = __WEBPACK_IMPORTED_MODULE_1_array_find_index___default()(netInfoListeners, function (pair) {
      return pair[0] === handler;
    });
    __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(listenerIndex !== -1, 'Trying to remove NetInfo listener for unregistered handler');
    var _netInfoListeners$lis = netInfoListeners[listenerIndex],
        wrappedHandler = _netInfoListeners$lis[1];

    connection.removeEventListener(eventTypesMap[type], wrappedHandler);
    netInfoListeners.splice(listenerIndex, 1);
  },
  fetch: function fetch() {
    console.warn('`fetch` is deprecated. Use `getConnectionInfo` instead.');
    return new Promise(function (resolve, reject) {
      try {
        resolve(connection.type);
      } catch (err) {
        resolve('unknown');
      }
    });
  },
  getConnectionInfo: function getConnectionInfo() {
    return new Promise(function (resolve, reject) {
      resolve(getConnectionInfoObject());
    });
  },


  isConnected: {
    addEventListener: function addEventListener(type, handler) {
      __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(eventTypes.indexOf(type) !== -1, 'Trying to subscribe to unknown event: "%s"', type);
      if (type === 'change') {
        console.warn('Listening to event `change` is deprecated. Use `connectionChange` instead.');
      }

      var onlineCallback = function onlineCallback() {
        return handler(true);
      };
      var offlineCallback = function offlineCallback() {
        return handler(false);
      };
      connectionListeners.push([handler, onlineCallback, offlineCallback]);

      window.addEventListener('online', onlineCallback, false);
      window.addEventListener('offline', offlineCallback, false);

      return {
        remove: function remove() {
          return NetInfo.isConnected.removeEventListener(eventTypesMap[type], handler);
        }
      };
    },
    removeEventListener: function removeEventListener(type, handler) {
      __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(eventTypes.indexOf(type) !== -1, 'Trying to subscribe to unknown event: "%s"', type);
      if (type === 'change') {
        console.warn('Listening to event `change` is deprecated. Use `connectionChange` instead.');
      }

      var listenerIndex = __WEBPACK_IMPORTED_MODULE_1_array_find_index___default()(connectionListeners, function (pair) {
        return pair[0] === handler;
      });
      __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(listenerIndex !== -1, 'Trying to remove NetInfo connection listener for unregistered handler');
      var _connectionListeners$ = connectionListeners[listenerIndex],
          onlineCallback = _connectionListeners$[1],
          offlineCallback = _connectionListeners$[2];


      window.removeEventListener('online', onlineCallback, false);
      window.removeEventListener('offline', offlineCallback, false);

      connectionListeners.splice(listenerIndex, 1);
    },
    fetch: function fetch() {
      return new Promise(function (resolve, reject) {
        try {
          resolve(window.navigator.onLine);
        } catch (err) {
          resolve(true);
        }
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (NetInfo);

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_InteractionManager__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TouchHistoryMath__ = __webpack_require__(679);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */




var currentCentroidXOfTouchesChangedAfter = __WEBPACK_IMPORTED_MODULE_1__TouchHistoryMath__["a" /* default */].currentCentroidXOfTouchesChangedAfter;
var currentCentroidYOfTouchesChangedAfter = __WEBPACK_IMPORTED_MODULE_1__TouchHistoryMath__["a" /* default */].currentCentroidYOfTouchesChangedAfter;
var previousCentroidXOfTouchesChangedAfter = __WEBPACK_IMPORTED_MODULE_1__TouchHistoryMath__["a" /* default */].previousCentroidXOfTouchesChangedAfter;
var previousCentroidYOfTouchesChangedAfter = __WEBPACK_IMPORTED_MODULE_1__TouchHistoryMath__["a" /* default */].previousCentroidYOfTouchesChangedAfter;
var currentCentroidX = __WEBPACK_IMPORTED_MODULE_1__TouchHistoryMath__["a" /* default */].currentCentroidX;
var currentCentroidY = __WEBPACK_IMPORTED_MODULE_1__TouchHistoryMath__["a" /* default */].currentCentroidY;

/**
 * `PanResponder` reconciles several touches into a single gesture. It makes
 * single-touch gestures resilient to extra touches, and can be used to
 * recognize simple multi-touch gestures.
 *
 * By default, `PanResponder` holds an `InteractionManager` handle to block
 * long-running JS events from interrupting active gestures.
 *
 * It provides a predictable wrapper of the responder handlers provided by the
 * [gesture responder system](docs/gesture-responder-system.html).
 * For each handler, it provides a new `gestureState` object alongside the
 * native event object:
 *
 * ```
 * onPanResponderMove: (event, gestureState) => {}
 * ```
 *
 * A native event is a synthetic touch event with the following form:
 *
 *  - `nativeEvent`
 *      + `changedTouches` - Array of all touch events that have changed since the last event
 *      + `identifier` - The ID of the touch
 *      + `locationX` - The X position of the touch, relative to the element
 *      + `locationY` - The Y position of the touch, relative to the element
 *      + `pageX` - The X position of the touch, relative to the root element
 *      + `pageY` - The Y position of the touch, relative to the root element
 *      + `target` - The node id of the element receiving the touch event
 *      + `timestamp` - A time identifier for the touch, useful for velocity calculation
 *      + `touches` - Array of all current touches on the screen
 *
 * A `gestureState` object has the following:
 *
 *  - `stateID` - ID of the gestureState- persisted as long as there at least
 *     one touch on screen
 *  - `moveX` - the latest screen coordinates of the recently-moved touch
 *  - `moveY` - the latest screen coordinates of the recently-moved touch
 *  - `x0` - the screen coordinates of the responder grant
 *  - `y0` - the screen coordinates of the responder grant
 *  - `dx` - accumulated distance of the gesture since the touch started
 *  - `dy` - accumulated distance of the gesture since the touch started
 *  - `vx` - current velocity of the gesture
 *  - `vy` - current velocity of the gesture
 *  - `numberActiveTouches` - Number of touches currently on screen
 *
 * ### Basic Usage
 *
 * ```
 *   componentWillMount: function() {
 *     this._panResponder = PanResponder.create({
 *       // Ask to be the responder:
 *       onStartShouldSetPanResponder: (evt, gestureState) => true,
 *       onStartShouldSetPanResponderCapture: (evt, gestureState) => true,
 *       onMoveShouldSetPanResponder: (evt, gestureState) => true,
 *       onMoveShouldSetPanResponderCapture: (evt, gestureState) => true,
 *
 *       onPanResponderGrant: (evt, gestureState) => {
 *         // The gesture has started. Show visual feedback so the user knows
 *         // what is happening!
 *
 *         // gestureState.d{x,y} will be set to zero now
 *       },
 *       onPanResponderMove: (evt, gestureState) => {
 *         // The most recent move distance is gestureState.move{X,Y}
 *
 *         // The accumulated gesture distance since becoming responder is
 *         // gestureState.d{x,y}
 *       },
 *       onPanResponderTerminationRequest: (evt, gestureState) => true,
 *       onPanResponderRelease: (evt, gestureState) => {
 *         // The user has released all touches while this view is the
 *         // responder. This typically means a gesture has succeeded
 *       },
 *       onPanResponderTerminate: (evt, gestureState) => {
 *         // Another component has become the responder, so this gesture
 *         // should be cancelled
 *       },
 *       onShouldBlockNativeResponder: (evt, gestureState) => {
 *         // Returns whether this component should block native components from becoming the JS
 *         // responder. Returns true by default. Is currently only supported on android.
 *         return true;
 *       },
 *     });
 *   },
 *
 *   render: function() {
 *     return (
 *       <View {...this._panResponder.panHandlers} />
 *     );
 *   },
 *
 * ```
 *
 * ### Working Example
 *
 * To see it in action, try the
 * [PanResponder example in RNTester](https://github.com/facebook/react-native/blob/master/RNTester/js/PanResponderExample.js)
 */

var PanResponder = {

  /**
   *
   * A graphical explanation of the touch data flow:
   *
   * +----------------------------+             +--------------------------------+
   * | ResponderTouchHistoryStore |             |TouchHistoryMath                |
   * +----------------------------+             +----------+---------------------+
   * |Global store of touchHistory|             |Allocation-less math util       |
   * |including activeness, start |             |on touch history (centroids     |
   * |position, prev/cur position.|             |and multitouch movement etc)    |
   * |                            |             |                                |
   * +----^-----------------------+             +----^---------------------------+
   *      |                                          |
   *      | (records relevant history                |
   *      |  of touches relevant for                 |
   *      |  implementing higher level               |
   *      |  gestures)                               |
   *      |                                          |
   * +----+-----------------------+             +----|---------------------------+
   * | ResponderEventPlugin       |             |    |   Your App/Component      |
   * +----------------------------+             +----|---------------------------+
   * |Negotiates which view gets  | Low level   |    |             High level    |
   * |onResponderMove events.     | events w/   |  +-+-------+     events w/     |
   * |Also records history into   | touchHistory|  |   Pan   |     multitouch +  |
   * |ResponderTouchHistoryStore. +---------------->Responder+-----> accumulative|
   * +----------------------------+ attached to |  |         |     distance and  |
   *                                 each event |  +---------+     velocity.     |
   *                                            |                                |
   *                                            |                                |
   *                                            +--------------------------------+
   *
   *
   *
   * Gesture that calculates cumulative movement over time in a way that just
   * "does the right thing" for multiple touches. The "right thing" is very
   * nuanced. When moving two touches in opposite directions, the cumulative
   * distance is zero in each dimension. When two touches move in parallel five
   * pixels in the same direction, the cumulative distance is five, not ten. If
   * two touches start, one moves five in a direction, then stops and the other
   * touch moves fives in the same direction, the cumulative distance is ten.
   *
   * This logic requires a kind of processing of time "clusters" of touch events
   * so that two touch moves that essentially occur in parallel but move every
   * other frame respectively, are considered part of the same movement.
   *
   * Explanation of some of the non-obvious fields:
   *
   * - moveX/moveY: If no move event has been observed, then `(moveX, moveY)` is
   *   invalid. If a move event has been observed, `(moveX, moveY)` is the
   *   centroid of the most recently moved "cluster" of active touches.
   *   (Currently all move have the same timeStamp, but later we should add some
   *   threshold for what is considered to be "moving"). If a palm is
   *   accidentally counted as a touch, but a finger is moving greatly, the palm
   *   will move slightly, but we only want to count the single moving touch.
   * - x0/y0: Centroid location (non-cumulative) at the time of becoming
   *   responder.
   * - dx/dy: Cumulative touch distance - not the same thing as sum of each touch
   *   distance. Accounts for touch moves that are clustered together in time,
   *   moving the same direction. Only valid when currently responder (otherwise,
   *   it only represents the drag distance below the threshold).
   * - vx/vy: Velocity.
   */

  _initializeGestureState: function _initializeGestureState(gestureState) {
    gestureState.moveX = 0;
    gestureState.moveY = 0;
    gestureState.x0 = 0;
    gestureState.y0 = 0;
    gestureState.dx = 0;
    gestureState.dy = 0;
    gestureState.vx = 0;
    gestureState.vy = 0;
    gestureState.numberActiveTouches = 0;
    // All `gestureState` accounts for timeStamps up until:
    gestureState._accountsForMovesUpTo = 0;
  },

  /**
   * This is nuanced and is necessary. It is incorrect to continuously take all
   * active *and* recently moved touches, find the centroid, and track how that
   * result changes over time. Instead, we must take all recently moved
   * touches, and calculate how the centroid has changed just for those
   * recently moved touches, and append that change to an accumulator. This is
   * to (at least) handle the case where the user is moving three fingers, and
   * then one of the fingers stops but the other two continue.
   *
   * This is very different than taking all of the recently moved touches and
   * storing their centroid as `dx/dy`. For correctness, we must *accumulate
   * changes* in the centroid of recently moved touches.
   *
   * There is also some nuance with how we handle multiple moved touches in a
   * single event. With the way `ReactNativeEventEmitter` dispatches touches as
   * individual events, multiple touches generate two 'move' events, each of
   * them triggering `onResponderMove`. But with the way `PanResponder` works,
   * all of the gesture inference is performed on the first dispatch, since it
   * looks at all of the touches (even the ones for which there hasn't been a
   * native dispatch yet). Therefore, `PanResponder` does not call
   * `onResponderMove` passed the first dispatch. This diverges from the
   * typical responder callback pattern (without using `PanResponder`), but
   * avoids more dispatches than necessary.
   */
  _updateGestureStateOnMove: function _updateGestureStateOnMove(gestureState, touchHistory) {
    gestureState.numberActiveTouches = touchHistory.numberActiveTouches;
    gestureState.moveX = currentCentroidXOfTouchesChangedAfter(touchHistory, gestureState._accountsForMovesUpTo);
    gestureState.moveY = currentCentroidYOfTouchesChangedAfter(touchHistory, gestureState._accountsForMovesUpTo);
    var movedAfter = gestureState._accountsForMovesUpTo;
    var prevX = previousCentroidXOfTouchesChangedAfter(touchHistory, movedAfter);
    var x = currentCentroidXOfTouchesChangedAfter(touchHistory, movedAfter);
    var prevY = previousCentroidYOfTouchesChangedAfter(touchHistory, movedAfter);
    var y = currentCentroidYOfTouchesChangedAfter(touchHistory, movedAfter);
    var nextDX = gestureState.dx + (x - prevX);
    var nextDY = gestureState.dy + (y - prevY);

    // TODO: This must be filtered intelligently.
    var dt = touchHistory.mostRecentTimeStamp - gestureState._accountsForMovesUpTo;
    gestureState.vx = (nextDX - gestureState.dx) / dt;
    gestureState.vy = (nextDY - gestureState.dy) / dt;

    gestureState.dx = nextDX;
    gestureState.dy = nextDY;
    gestureState._accountsForMovesUpTo = touchHistory.mostRecentTimeStamp;
  },

  /**
   * @param {object} config Enhanced versions of all of the responder callbacks
   * that provide not only the typical `ResponderSyntheticEvent`, but also the
   * `PanResponder` gesture state.  Simply replace the word `Responder` with
   * `PanResponder` in each of the typical `onResponder*` callbacks. For
   * example, the `config` object would look like:
   *
   *  - `onMoveShouldSetPanResponder: (e, gestureState) => {...}`
   *  - `onMoveShouldSetPanResponderCapture: (e, gestureState) => {...}`
   *  - `onStartShouldSetPanResponder: (e, gestureState) => {...}`
   *  - `onStartShouldSetPanResponderCapture: (e, gestureState) => {...}`
   *  - `onPanResponderReject: (e, gestureState) => {...}`
   *  - `onPanResponderGrant: (e, gestureState) => {...}`
   *  - `onPanResponderStart: (e, gestureState) => {...}`
   *  - `onPanResponderEnd: (e, gestureState) => {...}`
   *  - `onPanResponderRelease: (e, gestureState) => {...}`
   *  - `onPanResponderMove: (e, gestureState) => {...}`
   *  - `onPanResponderTerminate: (e, gestureState) => {...}`
   *  - `onPanResponderTerminationRequest: (e, gestureState) => {...}`
   *  - `onShouldBlockNativeResponder: (e, gestureState) => {...}`
   *
   *  In general, for events that have capture equivalents, we update the
   *  gestureState once in the capture phase and can use it in the bubble phase
   *  as well.
   *
   *  Be careful with onStartShould* callbacks. They only reflect updated
   *  `gestureState` for start/end events that bubble/capture to the Node.
   *  Once the node is the responder, you can rely on every start/end event
   *  being processed by the gesture and `gestureState` being updated
   *  accordingly. (numberActiveTouches) may not be totally accurate unless you
   *  are the responder.
   */
  create: function create(config) {
    var interactionState = {
      handle: null
    };
    var gestureState = {
      // Useful for debugging
      stateID: Math.random()
    };
    PanResponder._initializeGestureState(gestureState);
    var panHandlers = {
      onStartShouldSetResponder: function onStartShouldSetResponder(e) {
        return config.onStartShouldSetPanResponder === undefined ? false : config.onStartShouldSetPanResponder(e, gestureState);
      },
      onMoveShouldSetResponder: function onMoveShouldSetResponder(e) {
        return config.onMoveShouldSetPanResponder === undefined ? false : config.onMoveShouldSetPanResponder(e, gestureState);
      },
      onStartShouldSetResponderCapture: function onStartShouldSetResponderCapture(e) {
        // TODO: Actually, we should reinitialize the state any time
        // touches.length increases from 0 active to > 0 active.
        if (e.nativeEvent.touches.length === 1) {
          PanResponder._initializeGestureState(gestureState);
        }
        gestureState.numberActiveTouches = e.touchHistory.numberActiveTouches;
        return config.onStartShouldSetPanResponderCapture !== undefined ? config.onStartShouldSetPanResponderCapture(e, gestureState) : false;
      },

      onMoveShouldSetResponderCapture: function onMoveShouldSetResponderCapture(e) {
        var touchHistory = e.touchHistory;
        // Responder system incorrectly dispatches should* to current responder
        // Filter out any touch moves past the first one - we would have
        // already processed multi-touch geometry during the first event.
        if (gestureState._accountsForMovesUpTo === touchHistory.mostRecentTimeStamp) {
          return false;
        }
        PanResponder._updateGestureStateOnMove(gestureState, touchHistory);
        return config.onMoveShouldSetPanResponderCapture ? config.onMoveShouldSetPanResponderCapture(e, gestureState) : false;
      },

      onResponderGrant: function onResponderGrant(e) {
        if (!interactionState.handle) {
          interactionState.handle = __WEBPACK_IMPORTED_MODULE_0__exports_InteractionManager__["a" /* default */].createInteractionHandle();
        }
        gestureState.x0 = currentCentroidX(e.touchHistory);
        gestureState.y0 = currentCentroidY(e.touchHistory);
        gestureState.dx = 0;
        gestureState.dy = 0;
        if (config.onPanResponderGrant) {
          config.onPanResponderGrant(e, gestureState);
        }
        // TODO: t7467124 investigate if this can be removed
        return config.onShouldBlockNativeResponder === undefined ? true : config.onShouldBlockNativeResponder();
      },

      onResponderReject: function onResponderReject(e) {
        clearInteractionHandle(interactionState, config.onPanResponderReject, e, gestureState);
      },

      onResponderRelease: function onResponderRelease(e) {
        clearInteractionHandle(interactionState, config.onPanResponderRelease, e, gestureState);
        PanResponder._initializeGestureState(gestureState);
      },

      onResponderStart: function onResponderStart(e) {
        var touchHistory = e.touchHistory;
        gestureState.numberActiveTouches = touchHistory.numberActiveTouches;
        if (config.onPanResponderStart) {
          config.onPanResponderStart(e, gestureState);
        }
      },

      onResponderMove: function onResponderMove(e) {
        var touchHistory = e.touchHistory;
        // Guard against the dispatch of two touch moves when there are two
        // simultaneously changed touches.
        if (gestureState._accountsForMovesUpTo === touchHistory.mostRecentTimeStamp) {
          return;
        }
        // Filter out any touch moves past the first one - we would have
        // already processed multi-touch geometry during the first event.
        PanResponder._updateGestureStateOnMove(gestureState, touchHistory);
        if (config.onPanResponderMove) {
          config.onPanResponderMove(e, gestureState);
        }
      },

      onResponderEnd: function onResponderEnd(e) {
        var touchHistory = e.touchHistory;
        gestureState.numberActiveTouches = touchHistory.numberActiveTouches;
        clearInteractionHandle(interactionState, config.onPanResponderEnd, e, gestureState);
      },

      onResponderTerminate: function onResponderTerminate(e) {
        clearInteractionHandle(interactionState, config.onPanResponderTerminate, e, gestureState);
        PanResponder._initializeGestureState(gestureState);
      },

      onResponderTerminationRequest: function onResponderTerminationRequest(e) {
        return config.onPanResponderTerminationRequest === undefined ? true : config.onPanResponderTerminationRequest(e, gestureState);
      }
    };
    return {
      panHandlers: panHandlers,
      getInteractionHandle: function getInteractionHandle() {
        return interactionState.handle;
      }
    };
  }
};

function clearInteractionHandle(interactionState, callback, event, gestureState) {
  if (interactionState.handle) {
    __WEBPACK_IMPORTED_MODULE_0__exports_InteractionManager__["a" /* default */].clearInteractionHandle(interactionState.handle);
    interactionState.handle = null;
  }
  if (callback) {
    callback(event, gestureState);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (PanResponder);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TouchHistoryMath = {
  /**
   * This code is optimized and not intended to look beautiful. This allows
   * computing of touch centroids that have moved after `touchesChangedAfter`
   * timeStamp. You can compute the current centroid involving all touches
   * moves after `touchesChangedAfter`, or you can compute the previous
   * centroid of all touches that were moved after `touchesChangedAfter`.
   *
   * @param {TouchHistoryMath} touchHistory Standard Responder touch track
   * data.
   * @param {number} touchesChangedAfter timeStamp after which moved touches
   * are considered "actively moving" - not just "active".
   * @param {boolean} isXAxis Consider `x` dimension vs. `y` dimension.
   * @param {boolean} ofCurrent Compute current centroid for actively moving
   * touches vs. previous centroid of now actively moving touches.
   * @return {number} value of centroid in specified dimension.
   */
  centroidDimension: function centroidDimension(touchHistory, touchesChangedAfter, isXAxis, ofCurrent) {
    var touchBank = touchHistory.touchBank;
    var total = 0;
    var count = 0;

    var oneTouchData = touchHistory.numberActiveTouches === 1 ? touchHistory.touchBank[touchHistory.indexOfSingleActiveTouch] : null;

    if (oneTouchData !== null) {
      if (oneTouchData.touchActive && oneTouchData.currentTimeStamp > touchesChangedAfter) {
        total += ofCurrent && isXAxis ? oneTouchData.currentPageX : ofCurrent && !isXAxis ? oneTouchData.currentPageY : !ofCurrent && isXAxis ? oneTouchData.previousPageX : oneTouchData.previousPageY;
        count = 1;
      }
    } else {
      for (var i = 0; i < touchBank.length; i++) {
        var touchTrack = touchBank[i];
        if (touchTrack !== null && touchTrack !== undefined && touchTrack.touchActive && touchTrack.currentTimeStamp >= touchesChangedAfter) {
          var toAdd = void 0; // Yuck, program temporarily in invalid state.
          if (ofCurrent && isXAxis) {
            toAdd = touchTrack.currentPageX;
          } else if (ofCurrent && !isXAxis) {
            toAdd = touchTrack.currentPageY;
          } else if (!ofCurrent && isXAxis) {
            toAdd = touchTrack.previousPageX;
          } else {
            toAdd = touchTrack.previousPageY;
          }
          total += toAdd;
          count++;
        }
      }
    }
    return count > 0 ? total / count : TouchHistoryMath.noCentroid;
  },

  currentCentroidXOfTouchesChangedAfter: function currentCentroidXOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, true, // isXAxis
    true);
  },

  currentCentroidYOfTouchesChangedAfter: function currentCentroidYOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, false, // isXAxis
    true);
  },

  previousCentroidXOfTouchesChangedAfter: function previousCentroidXOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, true, // isXAxis
    false);
  },

  previousCentroidYOfTouchesChangedAfter: function previousCentroidYOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, false, // isXAxis
    false);
  },

  currentCentroidX: function currentCentroidX(touchHistory) {
    return TouchHistoryMath.centroidDimension(touchHistory, 0, // touchesChangedAfter
    true, // isXAxis
    true);
  },

  currentCentroidY: function currentCentroidY(touchHistory) {
    return TouchHistoryMath.centroidDimension(touchHistory, 0, // touchesChangedAfter
    false, // isXAxis
    true);
  },

  noCentroid: -1
};

/* harmony default export */ __webpack_exports__["a"] = (TouchHistoryMath);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dimensions__ = __webpack_require__(130);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * PixelRatio gives access to the device pixel density.
 */

var PixelRatio = function () {
  function PixelRatio() {
    _classCallCheck(this, PixelRatio);
  }

  /**
   * Returns the device pixel density.
   */
  PixelRatio.get = function get() {
    return __WEBPACK_IMPORTED_MODULE_0__Dimensions__["a" /* default */].get('window').scale;
  };

  /**
   * No equivalent for Web
   */


  PixelRatio.getFontScale = function getFontScale() {
    return __WEBPACK_IMPORTED_MODULE_0__Dimensions__["a" /* default */].get('window').fontScale || PixelRatio.get();
  };

  /**
   * Converts a layout size (dp) to pixel size (px).
   * Guaranteed to return an integer number.
   */


  PixelRatio.getPixelSizeForLayoutSize = function getPixelSizeForLayoutSize(layoutSize) {
    return Math.round(layoutSize * PixelRatio.get());
  };

  /**
   * Rounds a layout size (dp) to the nearest layout size that corresponds to
   * an integer number of pixels. For example, on a device with a PixelRatio
   * of 3, `PixelRatio.roundToNearestPixel(8.4) = 8.33`, which corresponds to
   * exactly (8.33 * 3) = 25 pixels.
   */


  PixelRatio.roundToNearestPixel = function roundToNearestPixel(layoutSize) {
    var ratio = PixelRatio.get();
    return Math.round(layoutSize * ratio) / ratio;
  };

  return PixelRatio;
}();

/* harmony default export */ __webpack_exports__["a"] = (PixelRatio);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2018-present, Nicolas Gallagher.
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var Share = function () {
  function Share() {
    _classCallCheck(this, Share);
  }

  Share.share = function share(content) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(typeof content === 'object' && content !== null, 'Content to share must be a valid object');
    __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(typeof content.url === 'string' || typeof content.message === 'string', 'At least one of URL and message is required');
    __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(typeof options === 'object' && options !== null, 'Options must be a valid object');
    __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(!content.title || typeof content.title === 'string', 'Invalid title: title should be a string.');

    if (window.navigator.share !== undefined) {
      return window.navigator.share({
        title: content.title,
        text: content.message,
        url: content.url
      });
    } else {
      return Promise.reject(new Error('Share is not supported in this browser'));
    }
  };

  /**
   * The content was successfully shared.
   */


  _createClass(Share, null, [{
    key: 'sharedAction',
    get: function get() {
      return 'sharedAction';
    }

    /**
     * The dialog has been dismissed.
     * @platform ios
     */

  }, {
    key: 'dismissedAction',
    get: function get() {
      return 'dismissedAction';
    }
  }]);

  return Share;
}();

/* harmony default export */ __webpack_exports__["a"] = (Share);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var _vibrate = function _vibrate(pattern) {
  if ('vibrate' in window.navigator) {
    window.navigator.vibrate(pattern);
  }
}; /**
    * Copyright (c) 2016-present, Nicolas Gallagher.
    * Copyright (c) 2015-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    *
    * 
    */

var Vibration = {
  cancel: function cancel() {
    _vibrate(0);
  },
  vibrate: function vibrate() {
    var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 400;

    _vibrate(pattern);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Vibration);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_applyNativeMethods__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewPropTypes__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */








var createSvgCircle = function createSvgCircle(style) {
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('circle', { cx: '16', cy: '16', fill: 'none', r: '14', strokeWidth: '4', style: style });
};

var ActivityIndicator = function (_Component) {
  _inherits(ActivityIndicator, _Component);

  function ActivityIndicator() {
    _classCallCheck(this, ActivityIndicator);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ActivityIndicator.prototype.render = function render() {
    var _props = this.props,
        animating = _props.animating,
        color = _props.color,
        hidesWhenStopped = _props.hidesWhenStopped,
        size = _props.size,
        style = _props.style,
        other = _objectWithoutProperties(_props, ['animating', 'color', 'hidesWhenStopped', 'size', 'style']);

    var svg = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'svg',
      { height: '100%', viewBox: '0 0 32 32', width: '100%' },
      createSvgCircle({
        stroke: color,
        opacity: 0.2
      }),
      createSvgCircle({
        stroke: color,
        strokeDasharray: 80,
        strokeDashoffset: 60
      })
    );

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__View__["a" /* default */],
      _extends({}, other, {
        accessibilityRole: 'progressbar',
        'aria-valuemax': '1',
        'aria-valuemin': '0',
        style: [styles.container, style]
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__View__["a" /* default */], {
        children: svg,
        style: [typeof size === 'number' ? { height: size, width: size } : indicatorSizes[size], styles.animation, !animating && styles.animationPause, !animating && hidesWhenStopped && styles.hidesWhenStopped]
      })
    );
  };

  return ActivityIndicator;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

ActivityIndicator.displayName = 'ActivityIndicator';
ActivityIndicator.defaultProps = {
  animating: true,
  color: '#1976D2',
  hidesWhenStopped: true,
  size: 'small'
};
ActivityIndicator.propTypes =  false ? Object.assign({}, ViewPropTypes, {
  animating: bool,
  color: string,
  hidesWhenStopped: bool,
  size: oneOfType([oneOf(['small', 'large']), number])
}) : {};


var styles = __WEBPACK_IMPORTED_MODULE_1__StyleSheet__["a" /* default */].create({
  container: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  hidesWhenStopped: {
    visibility: 'hidden'
  },
  animation: {
    animationDuration: '0.75s',
    animationName: [{
      '0%': { transform: [{ rotate: '0deg' }] },
      '100%': { transform: [{ rotate: '360deg' }] }
    }],
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite'
  },
  animationPause: {
    animationPlayState: 'paused'
  }
});

var indicatorSizes = __WEBPACK_IMPORTED_MODULE_1__StyleSheet__["a" /* default */].create({
  small: {
    width: 20,
    height: 20
  },
  large: {
    width: 36,
    height: 36
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__modules_applyNativeMethods__["a" /* default */])(ActivityIndicator));

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_art__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_art___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_art__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_art___default.a);

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(686);
} else {
  module.exports = require('./cjs/react-art.development.js');
}


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.1
 * react-art.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var aa=__webpack_require__(90),ba=__webpack_require__(1),ca=__webpack_require__(4),m=__webpack_require__(127),da=__webpack_require__(24),ea=__webpack_require__(81),n=__webpack_require__(687),fa=__webpack_require__(261),ha=__webpack_require__(688);
function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}
var ia=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,y="function"===typeof Symbol&&Symbol.for,ja=y?Symbol.for("react.element"):60103,ka=y?Symbol.for("react.portal"):60106,z=y?Symbol.for("react.fragment"):60107,ma=y?Symbol.for("react.strict_mode"):60108,na=y?Symbol.for("react.profiler"):60114,oa=y?Symbol.for("react.provider"):60109,pa=y?Symbol.for("react.context"):60110,qa=y?Symbol.for("react.async_mode"):60111,ra=y?Symbol.for("react.forward_ref"):60112,sa=y?Symbol.for("react.timeout"):
60113,ta="function"===typeof Symbol&&Symbol.iterator;function ua(a){if(null===a||"undefined"===typeof a)return null;a=ta&&a[ta]||a["@@iterator"];return"function"===typeof a?a:null}
function va(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case qa:return"AsyncMode";case pa:return"Context.Consumer";case z:return"ReactFragment";case ka:return"ReactPortal";case na:return"Profiler("+a.pendingProps.id+")";case oa:return"Context.Provider";case ma:return"StrictMode";case sa:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case ra:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function wa(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}var xa="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,ya=Date,za=setTimeout,Ba=clearTimeout,A=void 0;if("object"===typeof performance&&"function"===typeof performance.now){var Ca=performance;A=function(){return Ca.now()}}else A=function(){return ya.now()};
var Da=void 0,Ea=void 0;
if(da.canUseDOM){var Fa="function"===typeof xa?xa:function(){x("276")},B=null,Ga=null,Ha=-1,Ia=!1,Ja=!1,Ka=0,La=33,Ma=33,Na={didTimeout:!1,timeRemaining:function(){var a=Ka-A();return 0<a?a:0}},Pa=function(a,b){var c=a.scheduledCallback,d=!1;try{c(b),d=!0}finally{Ea(a),d||(Ia=!0,window.postMessage(Oa,"*"))}},Oa="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Oa&&(Ia=!1,null!==B)){if(null!==B){var b=A();if(!(-1===
Ha||Ha>b)){a=-1;for(var c=[],d=B;null!==d;){var e=d.timeoutTime;-1!==e&&e<=b?c.push(d):-1!==e&&(-1===a||e<a)&&(a=e);d=d.next}if(0<c.length)for(Na.didTimeout=!0,b=0,d=c.length;b<d;b++)Pa(c[b],Na);Ha=a}}for(a=A();0<Ka-a&&null!==B;)a=B,Na.didTimeout=!1,Pa(a,Na),a=A();null===B||Ja||(Ja=!0,Fa(Qa))}},!1);var Qa=function(a){Ja=!1;var b=a-Ka+Ma;b<Ma&&La<Ma?(8>b&&(b=8),Ma=b<La?La:b):La=b;Ka=a+Ma;Ia||(Ia=!0,window.postMessage(Oa,"*"))};Da=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=A()+
b.timeout);if(-1===Ha||-1!==c&&c<Ha)Ha=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===B?B=a:(b=a.prev=Ga,null!==b&&(b.next=a));Ga=a;Ja||(Ja=!0,Fa(Qa));return a};Ea=function(a){if(null!==a.prev||B===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,B=b):null!==c?(c.next=null,Ga=c):Ga=B=null}}}else{var Ra=new Map;Da=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=za(function(){a({timeRemaining:function(){return Infinity},
didTimeout:!1})});Ra.set(a,c);return b};Ea=function(a){var b=Ra.get(a.scheduledCallback);Ra.delete(a);Ba(b)}}var C={CLIPPING_RECTANGLE:"ClippingRectangle",GROUP:"Group",SHAPE:"Shape",TEXT:"Text"},Sa={onClick:"click",onMouseMove:"mousemove",onMouseOver:"mouseover",onMouseOut:"mouseout",onMouseUp:"mouseup",onMouseDown:"mousedown"};function Ta(a){return a?"string"===typeof a?a:a.length?a.join(""):"":""}var D=new ea,Ua={};
function Va(a){return function(b){var c=a._listeners[b.type];c&&("function"===typeof c?c.call(a,b):c.handleEvent&&c.handleEvent(b))}}function Wa(a){if(a._subscriptions)for(var b in a._subscriptions)a._subscriptions[b]();a._subscriptions=null;a._listeners=null}function Xa(a,b){Ya(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:{});a.width=b.width;a.height=b.height}function $a(a,b){Ya(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:{});a.width=b.width;a.height=b.height}
function Ya(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};var d=null!=b.scaleX?b.scaleX:null!=b.scale?b.scale:1;var e=null!=b.scaleY?b.scaleY:null!=b.scale?b.scale:1;D.transformTo(1,0,0,1,0,0).move(b.x||0,b.y||0).rotate(b.rotation||0,b.originX,b.originY).scale(d,e,b.originX,b.originY);null!=b.transform&&D.transform(b.transform);a.xx===D.xx&&a.yx===D.yx&&a.xy===D.xy&&a.yy===D.yy&&a.x===D.x&&a.y===D.y||a.transformTo(D);b.cursor===c.cursor&&b.title===c.title||a.indicate(b.cursor,
b.title);a.blend&&b.opacity!==c.opacity&&a.blend(null==b.opacity?1:b.opacity);b.visible!==c.visible&&(null==b.visible||b.visible?a.show():a.hide());for(var f in Sa)c=a,d=Sa[f],e=b[f],c._listeners||(c._listeners={},c._subscriptions={}),(c._listeners[d]=e)?c._subscriptions[d]||(c._subscriptions[d]=c.subscribe(d,Va(c),c)):c._subscriptions[d]&&(c._subscriptions[d](),delete c._subscriptions[d])}
function ab(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};Ya(a,b,c);c.fill!==b.fill&&(b.fill&&b.fill.applyFill?b.fill.applyFill(a):a.fill(b.fill));c.stroke===b.stroke&&c.strokeWidth===b.strokeWidth&&c.strokeCap===b.strokeCap&&c.strokeJoin===b.strokeJoin&&c.strokeDash===b.strokeDash||a.stroke(b.stroke,b.strokeWidth,b.strokeCap,b.strokeJoin,b.strokeDash)}
function bb(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};ab(a,b,c);var d=b.d||Ta(b.children),e=a._prevDelta;if(d!==a._prevPath||d.delta!==e||c.height!==b.height||c.width!==b.width)a.draw(d,b.width,b.height),a._prevDelta=d.delta,a._prevPath=d}
function cb(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};ab(a,b,c);var d=b.children,e;if(!(e=a._currentString!==d)){e=b.font;var f=c.font;e=e===f?!0:"string"===typeof f||"string"===typeof e?!1:f.fontSize===e.fontSize&&f.fontStyle===e.fontStyle&&f.fontVariant===e.fontVariant&&f.fontWeight===e.fontWeight&&f.fontFamily===e.fontFamily;e=!e}if(e||b.alignment!==c.alignment||b.path!==c.path)a.draw(d,b.font,b.alignment,b.path),a._currentString=d}var db=Da,eb=Ea;
function fb(a,b){return"string"===typeof b.children||"number"===typeof b.children}var gb=A;function hb(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=va(a);var f=null;c&&(f=va(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}new Set;var ib=[],jb=-1;function E(a){return{current:a}}
function F(a){0>jb||(a.current=ib[jb],ib[jb]=null,jb--)}function G(a,b){jb++;ib[jb]=a.current;a.current=b}var H=E(m),I=E(!1),kb=m;function lb(a){return mb(a)?kb:H.current}
function nb(a,b){var c=a.type.contextTypes;if(!c)return m;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function mb(a){return 2===a.tag&&null!=a.type.childContextTypes}function ob(a){mb(a)&&(F(I,a),F(H,a))}function pb(a){F(I,a);F(H,a)}
function qb(a,b,c){H.current!==m?x("168"):void 0;G(H,b,a);G(I,c,a)}function rb(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:x("108",va(a)||"Unknown",e);return aa({},b,c)}function sb(a){if(!mb(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||m;kb=H.current;G(H,b,a);G(I,I.current,a);return!0}
function tb(a,b){var c=a.stateNode;c?void 0:x("169");if(b){var d=rb(a,kb);c.__reactInternalMemoizedMergedChildContext=d;F(I,a);F(H,a);G(H,d,a)}else F(I,a);G(I,b,a)}
function J(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function ub(a,b,c){var d=a.alternate;null===d?(d=new J(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function vb(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case z:return wb(a.children,b,c,e);case qa:f=11;b|=3;break;case ma:f=11;b|=2;break;case na:return d=new J(15,a,e,b|4),d.type=na,d.expirationTime=c,d;case sa:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case oa:f=13;break a;case pa:f=12;break a;case ra:f=14;break a;default:x("130",null==d?d:
typeof d,"")}f=void 0}}b=new J(f,a,e,b);b.type=d;b.expirationTime=c;return b}function wb(a,b,c,d){a=new J(10,a,d,b);a.expirationTime=c;return a}function xb(a,b,c){a=new J(6,a,null,b);a.expirationTime=c;return a}function yb(a,b,c){b=new J(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var K=!1;
function zb(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ab(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Bb(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cb(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function M(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=zb(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=zb(a.memoizedState),f=d.updateQueue=zb(d.memoizedState)):e=a.updateQueue=Ab(f):null===f&&(f=d.updateQueue=Ab(e));null===f||e===f?Cb(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Cb(e,b,c),Cb(f,b,c)):(Cb(e,b,c),f.lastUpdate=b)}
function Db(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=zb(a.memoizedState):Eb(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Eb(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ab(b));return b}
function Fb(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return aa({},d,e);case 2:K=!0}return d}
function Gb(a,b,c,d,e){K=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Eb(a,b);for(var f=b.baseState,g=null,l=0,h=b.firstUpdate,k=f;null!==h;){var p=h.expirationTime;if(p>e){if(null===g&&(g=h,f=k),0===l||l>p)l=p}else k=Fb(a,b,h,k,c,d),null!==h.callback&&(a.effectTag|=32,h.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=h:(b.lastEffect.nextEffect=h,b.lastEffect=h));h=h.next}p=null;for(h=b.firstCapturedUpdate;null!==h;){var w=h.expirationTime;if(w>e){if(null===p&&(p=h,null===g&&
(f=k)),0===l||l>w)l=w}else k=Fb(a,b,h,k,c,d),null!==h.callback&&(a.effectTag|=32,h.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=h:(b.lastCapturedEffect.nextEffect=h,b.lastCapturedEffect=h));h=h.next}null===g&&(b.lastUpdate=null);null===p?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===p&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=p;b.expirationTime=l;a.memoizedState=k}}
function Hb(a,b){"function"!==typeof a?x("191",a):void 0;a.call(b)}
function Ib(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Hb(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Hb(b,c)),a=a.nextEffect}
function Jb(a,b){return{value:a,source:b,stack:hb(b)}}var Kb=E(null),Lb=E(null),Mb=E(0);function Nb(a){var b=a.type._context;G(Mb,b._changedBits2,a);G(Lb,b._currentValue2,a);G(Kb,a,a);b._currentValue2=a.pendingProps.value;b._changedBits2=a.stateNode}function Ob(a){var b=Mb.current,c=Lb.current;F(Kb,a);F(Lb,a);F(Mb,a);a=a.type._context;a._currentValue2=c;a._changedBits2=b}var Pb={},N=E(Pb),Qb=E(Pb),Rb=E(Pb);function O(a){a===Pb?x("174"):void 0;return a}
function Sb(a,b){G(Rb,b,a);G(Qb,a,a);G(N,Pb,a);F(N,a);G(N,m,a)}function Tb(a){F(N,a);F(Qb,a);F(Rb,a)}function Ub(a){Qb.current===a&&(F(N,a),F(Qb,a))}function Vb(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:aa({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var Zb={isMounted:function(a){return(a=a._reactInternalFiber)?2===wa(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Wb();d=Xb(d,a);var e=Bb(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);M(a,e,d);Yb(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Wb();d=Xb(d,a);var e=Bb(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);M(a,e,d);Yb(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Wb();c=Xb(c,a);var d=Bb(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);M(a,d,c);Yb(a,c)}};function $b(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!fa(b,c)||!fa(d,e):!0}
function ac(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Zb.enqueueReplaceState(b,b.state,null)}
function bc(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=lb(a);d.props=e;d.state=a.memoizedState;d.refs=m;d.context=nb(a,f);f=a.updateQueue;null!==f&&(Gb(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(Vb(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&Zb.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Gb(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var cc=Array.isArray;
function dc(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?x("110"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(b){var a=d.refs===m?d.refs={}:d.refs;null===b?delete a[e]:a[e]=b};b._stringRef=e;return b}"string"!==typeof a?x("148"):void 0;c._owner?void 0:x("254",a)}return a}
function ec(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function fc(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(b,a){for(b=new Map;null!==a;)null!==a.key?b.set(a.key,a):b.set(a.index,a),a=a.sibling;return b}function e(b,a,c){b=ub(b,a,c);b.index=0;b.sibling=null;return b}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function l(b,a,c,d){if(null===a||6!==a.tag)return a=xb(c,b.mode,d),a.return=b,a;a=e(a,c,d);a.return=b;return a}function h(b,a,c,d){if(null!==a&&a.type===c.type)return d=e(a,c.props,d),d.ref=dc(b,a,c),d.return=b,d;d=vb(c,b.mode,d);d.ref=dc(b,a,c);d.return=b;return d}function k(b,a,c,d){if(null===a||4!==a.tag||a.stateNode.containerInfo!==c.containerInfo||a.stateNode.implementation!==c.implementation)return a=
yb(c,b.mode,d),a.return=b,a;a=e(a,c.children||[],d);a.return=b;return a}function p(b,a,c,d,f){if(null===a||10!==a.tag)return a=wb(c,b.mode,d,f),a.return=b,a;a=e(a,c,d);a.return=b;return a}function w(b,a,c){if("string"===typeof a||"number"===typeof a)return a=xb(""+a,b.mode,c),a.return=b,a;if("object"===typeof a&&null!==a){switch(a.$$typeof){case ja:return c=vb(a,b.mode,c),c.ref=dc(b,null,a),c.return=b,c;case ka:return a=yb(a,b.mode,c),a.return=b,a}if(cc(a)||ua(a))return a=wb(a,b.mode,c,null),a.return=
b,a;ec(b,a)}return null}function L(b,a,c,d){var e=null!==a?a.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:l(b,a,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case ja:return c.key===e?c.type===z?p(b,a,c.props.children,d,e):h(b,a,c,d):null;case ka:return c.key===e?k(b,a,c,d):null}if(cc(c)||ua(c))return null!==e?null:p(b,a,c,d,null);ec(b,c)}return null}function W(b,a,c,d,e){if("string"===typeof d||"number"===typeof d)return b=b.get(c)||null,l(a,b,""+d,e);if("object"===
typeof d&&null!==d){switch(d.$$typeof){case ja:return b=b.get(null===d.key?c:d.key)||null,d.type===z?p(a,b,d.props.children,e,d.key):h(a,b,d,e);case ka:return b=b.get(null===d.key?c:d.key)||null,k(a,b,d,e)}if(cc(d)||ua(d))return b=b.get(c)||null,p(a,b,d,e,null);ec(a,d)}return null}function la(e,g,h,l){for(var v=null,u=null,q=g,k=g=0,p=null;null!==q&&k<h.length;k++){q.index>k?(p=q,q=null):p=q.sibling;var t=L(e,q,h[k],l);if(null===t){null===q&&(q=p);break}a&&q&&null===t.alternate&&b(e,q);g=f(t,g,k);
null===u?v=t:u.sibling=t;u=t;q=p}if(k===h.length)return c(e,q),v;if(null===q){for(;k<h.length;k++)if(q=w(e,h[k],l))g=f(q,g,k),null===u?v=q:u.sibling=q,u=q;return v}for(q=d(e,q);k<h.length;k++)if(p=W(q,e,k,h[k],l))a&&null!==p.alternate&&q.delete(null===p.key?k:p.key),g=f(p,g,k),null===u?v=p:u.sibling=p,u=p;a&&q.forEach(function(a){return b(e,a)});return v}function r(e,g,h,l){var q=ua(h);"function"!==typeof q?x("150"):void 0;h=q.call(h);null==h?x("151"):void 0;for(var v=q=null,u=g,k=g=0,p=null,t=h.next();null!==
u&&!t.done;k++,t=h.next()){u.index>k?(p=u,u=null):p=u.sibling;var r=L(e,u,t.value,l);if(null===r){u||(u=p);break}a&&u&&null===r.alternate&&b(e,u);g=f(r,g,k);null===v?q=r:v.sibling=r;v=r;u=p}if(t.done)return c(e,u),q;if(null===u){for(;!t.done;k++,t=h.next())t=w(e,t.value,l),null!==t&&(g=f(t,g,k),null===v?q=t:v.sibling=t,v=t);return q}for(u=d(e,u);!t.done;k++,t=h.next())t=W(u,e,k,t.value,l),null!==t&&(a&&null!==t.alternate&&u.delete(null===t.key?k:t.key),g=f(t,g,k),null===v?q=t:v.sibling=t,v=t);a&&
u.forEach(function(a){return b(e,a)});return q}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===z&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case ja:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(10===k.tag?f.type===z:k.type===f.type){c(a,k.sibling);d=e(k,f.type===z?f.props.children:f.props,h);d.ref=dc(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===z?(d=wb(f.props.children,a.mode,h,f.key),
d.return=a,a=d):(h=vb(f,a.mode,h),h.ref=dc(a,d,f),h.return=a,a=h)}return g(a);case ka:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=yb(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,
d),d=xb(f,a.mode,h),d.return=a,a=d),g(a);if(cc(f))return la(a,d,f,h);if(ua(f))return r(a,d,f,h);l&&ec(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 1:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var gc=fc(!0),hc=fc(!1),ic=null,jc=null,kc=!1;function lc(a){switch(a.tag){case 5:return x("272"),a.stateNode=void 0,!0;case 6:return x("272"),a.stateNode=void 0,!0;default:return!1}}
function mc(a){if(kc){var b=jc;if(b){var c=b;if(!lc(a,b)){x("272");b=void 0;if(!b||!lc(a,b)){a.effectTag|=2;kc=!1;ic=a;return}b=ic;var d=new J(5,null,null,0);d.type="DELETED";d.stateNode=c;d.return=b;d.effectTag=8;null!==b.lastEffect?(b.lastEffect.nextEffect=d,b.lastEffect=d):b.firstEffect=b.lastEffect=d}ic=a;x("272");jc=void 0}else a.effectTag|=2,kc=!1,ic=a}}function P(a,b,c){nc(a,b,c,b.expirationTime)}function nc(a,b,c,d){b.child=null===a?hc(b,null,c,d):gc(b,a.child,c,d)}
function oc(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function pc(a,b,c,d,e){oc(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&tb(b,!1),Q(a,b);c=b.stateNode;ia.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(nc(a,b,null,e),b.child=null);nc(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&tb(b,!0);return b.child}
function qc(a){var b=a.stateNode;b.pendingContext?qb(a,b.pendingContext,b.pendingContext!==b.context):b.context&&qb(a,b.context,!1);Sb(a,b.containerInfo)}
function rc(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function sc(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(I.current)g=!1;else if(f===e)return b.stateNode=0,Nb(b),Q(a,b);var l=e.value;b.memoizedProps=e;if(null===f)l=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,Nb(b),Q(a,b);l=0}else{var h=f.value;if(h===l&&(0!==h||1/h===1/l)||h!==h&&l!==l){if(f.children===e.children&&g)return b.stateNode=0,Nb(b),Q(a,b);l=0}else if(l="function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,
l):1073741823,l|=0,0===l){if(f.children===e.children&&g)return b.stateNode=0,Nb(b),Q(a,b)}else rc(b,d,l,c)}b.stateNode=l;Nb(b);P(a,b,e.children);return b.child}function Q(a,b){null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;var c=ub(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ub(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function tc(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:qc(b);break;case 2:sb(b);break;case 4:Sb(b,b.stateNode.containerInfo);break;case 13:Nb(b)}return null}switch(b.tag){case 0:null!==a?x("155"):void 0;var d=b.type,e=b.pendingProps,f=lb(b);f=nb(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&Vb(b,f,e),e=sb(b),d.updater=Zb,b.stateNode=d,d._reactInternalFiber=b,bc(b,c),a=pc(a,b,!0,e,c)):(b.tag=1,P(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,I.current||b.memoizedProps!==c?(d=lb(b),d=nb(b,d),e=e(c,d),b.effectTag|=1,P(a,b,e),b.memoizedProps=c,a=b.child):a=Q(a,b),a;case 2:e=sb(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,l=b.type;d=lb(b);var h=2===b.tag&&null!=b.type.contextTypes;f=h?nb(b,d):m;g=new l(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=Zb;b.stateNode=g;g._reactInternalFiber=b;h&&(h=b.stateNode,h.__reactInternalMemoizedUnmaskedChildContext=d,h.__reactInternalMemoizedMaskedChildContext=f);bc(b,c);d=!0}else{l=b.type;d=b.stateNode;h=b.memoizedProps;f=b.pendingProps;d.props=h;var k=d.context;g=lb(b);g=nb(b,g);var p=l.getDerivedStateFromProps;(l="function"===typeof p||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(h!==f||k!==g)&&ac(b,d,f,g);K=!1;var w=b.memoizedState;k=d.state=w;var L=b.updateQueue;null!==L&&(Gb(b,L,f,d,c),k=b.memoizedState);h!==f||w!==k||I.current||K?("function"===typeof p&&(Vb(b,p,f),k=b.memoizedState),(h=K||$b(b,h,f,w,k,g))?(l||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=k),d.props=f,d.state=k,d.context=g,d=h):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else l=b.type,d=b.stateNode,f=b.memoizedProps,h=b.pendingProps,d.props=f,k=d.context,g=lb(b),g=nb(b,g),p=l.getDerivedStateFromProps,(l="function"===typeof p||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==h||k!==g)&&ac(b,d,h,g),K=!1,k=b.memoizedState,w=d.state=k,L=b.updateQueue,null!==L&&(Gb(b,L,h,d,c),w=b.memoizedState),f!==h||k!==w||I.current||K?("function"===typeof p&&(Vb(b,p,h),w=b.memoizedState),(p=K||$b(b,f,h,k,w,g))?(l||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(h,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(h,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=h,b.memoizedState=w),d.props=h,d.state=w,d.context=g,d=p):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return pc(a,b,d,e,c);case 3:return qc(b),e=b.updateQueue,null!==e?(d=b.memoizedState,d=null!==d?d.element:null,Gb(b,e,b.pendingProps,null,c),c=b.memoizedState.element,c===d?a=Q(a,b):(P(a,b,c),a=b.child)):a=Q(a,b),a;case 5:return O(Rb.current),O(N.current)!==m&&(G(Qb,b,b),G(N,m,b)),null===a&&mc(b),c=b.type,f=b.memoizedProps,e=b.pendingProps,d=null!==a?a.memoizedProps:null,I.current||f!==e?(f=e.children,fb(c,e)?f=null:d&&fb(c,d)&&(b.effectTag|=
16),oc(a,b),P(a,b,f),b.memoizedProps=e,a=b.child):a=Q(a,b),a;case 6:return null===a&&mc(b),b.memoizedProps=b.pendingProps,null;case 16:return null;case 4:return Sb(b,b.stateNode.containerInfo),e=b.pendingProps,I.current||b.memoizedProps!==e?(null===a?b.child=gc(b,null,e,c):P(a,b,e),b.memoizedProps=e,a=b.child):a=Q(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,I.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),P(a,b,e),b.memoizedProps=c,a=b.child):a=Q(a,b),a;case 10:return c=
b.pendingProps,I.current||b.memoizedProps!==c?(P(a,b,c),b.memoizedProps=c,a=b.child):a=Q(a,b),a;case 11:return c=b.pendingProps.children,I.current||null!==c&&b.memoizedProps!==c?(P(a,b,c),b.memoizedProps=c,a=b.child):a=Q(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=Q(a,b):(P(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return sc(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,h=b.memoizedProps,e=d._currentValue2,g=d._changedBits2,I.current||0!==g||h!==f){b.memoizedProps=f;
l=f.unstable_observedBits;if(void 0===l||null===l)l=1073741823;b.stateNode=l;if(0!==(g&l))rc(b,d,g,c);else if(h===f){a=Q(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;P(a,b,c);a=b.child}else a=Q(a,b);return a;default:x("156")}}var uc=void 0,yc=void 0,zc=void 0;uc=function(){};yc=function(a,b,c){if(b.updateQueue=c)b.effectTag|=4};zc=function(a,b,c,d){c!==d&&(b.effectTag|=4)};
function Ac(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return ob(b),null;case 3:Tb(b);pb(b);c=b.stateNode;c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null);if(null===a||null===a.child)b.effectTag&=-3;uc(b);return null;case 5:Ub(b);var d=O(Rb.current),e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=O(N.current);yc(a,b,Ua,e,f,c,d,g);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?x("166"):void 0,null;O(N.current);a=void 0;
switch(e){case C.CLIPPING_RECTANGLE:a=n.ClippingRectangle();a._applyProps=Xa;break;case C.GROUP:a=n.Group();a._applyProps=$a;break;case C.SHAPE:a=n.Shape();a._applyProps=bb;break;case C.TEXT:a=n.Text(c.children,c.font,c.alignment,c.path),a._applyProps=cb}a?void 0:x("217",e);a._applyProps(a,c);a:for(c=b.child;null!==c;){if(5===c.tag||6===c.tag)e=a,d=c.stateNode,"string"===typeof d?x("216"):d.inject(e);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===
c.sibling;){if(null===c.return||c.return===b)break a;c=c.return}c.sibling.return=c.return;c=c.sibling}b.stateNode=a;null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)zc(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?x("166"):void 0,null;O(Rb.current);O(N.current);b.stateNode=c}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return Tb(b),uc(b),null;case 13:return Ob(b),null;
case 12:return null;case 0:x("167");default:x("156")}}function Bc(a,b){var c=b.source;null===b.stack&&null!==c&&hb(c);null!==c&&va(c);b=b.value;null!==a&&2===a.tag&&va(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Cc(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Dc(a,c)}else b.current=null}
function Ec(a){switch(a.tag){case 2:Cc(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Dc(a,c)}break;case 5:Cc(a);break;case 4:Fc(a)}}function Gc(a){return 5===a.tag||3===a.tag||4===a.tag}
function Hc(a){a:{for(var b=a.return;null!==b;){if(Gc(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Gc(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===
c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=e.stateNode,g=c;f===g?x("218"):void 0;f.injectBefore(g)}else f=e.stateNode,g=c,f===g?x("218"):void 0,f.injectBefore(g);else f=b,g=e.stateNode,g.parentNode===f&&g.eject(),g.inject(f);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=
e.return;e=e.sibling}}
function Fc(a){for(var b=a,c=!1,d=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=!1;break a;case 3:d=!0;break a;case 4:d=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var e=b,f=e;;)if(Ec(f),null!==f.child&&4!==f.tag)f.child.return=f,f=f.child;else{if(f===e)break;for(;null===f.sibling;){if(null===f.return||f.return===e)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}e=b.stateNode,Wa(e),e.eject()}else if(4!==b.tag&&Ec(b),null!==b.child){b.child.return=
b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}function Ic(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.updateQueue;b.updateQueue=null;null!==e&&c._applyProps(c,d,a)}break;case 6:null===b.stateNode?x("162"):void 0;break;case 3:break;case 15:break;case 16:break;default:x("163")}}
function Jc(a,b,c){c=Bb(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Kc(d);Bc(a,b)};return c}function Lc(a,b,c){c=Bb(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===R?R=new Set([this]):R.add(this);var c=b.value,d=b.stack;Bc(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function Mc(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Jb(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=Jc(a,d,f);Db(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===R||!R.has(c))){a.effectTag|=1024;d=Lc(a,b,f);Db(a,d,f);return}}a=a.return}while(null!==a)}
function Nc(a){switch(a.tag){case 2:ob(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return Tb(a),pb(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return Ub(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return Tb(a),null;case 13:return Ob(a),null;default:return null}}var Oc=gb(),Pc=2,Qc=Oc,S=!1,T=null,Rc=null,U=0,Sc=-1,Tc=!1,V=null,Uc=!1,Vc=!1,R=null;
function Wc(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 2:ob(b);break;case 3:Tb(b);pb(b);break;case 5:Ub(b);break;case 4:Tb(b);break;case 13:Ob(b)}a=a.return}Rc=null;U=0;Sc=-1;Tc=!1;T=null;Vc=!1}
function Xc(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Ac(b,a,U);var e=a;if(1073741823===U||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{Vc=!0;break}}else{a=Nc(a,Tc,U);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function Yc(a){var b=tc(a.alternate,a,U);null===b&&(b=Xc(a));ia.current=null;return b}
function Zc(a,b,c){S?x("243"):void 0;S=!0;if(b!==U||a!==Rc||null===T)Wc(),Rc=a,U=b,Sc=-1,T=ub(Rc.current,null,U),a.pendingCommitExpirationTime=0;var d=!1;Tc=!c||U<=Pc;do{try{if(c)for(;null!==T&&!$c();)T=Yc(T);else for(;null!==T;)T=Yc(T)}catch(f){if(null===T)d=!0,Kc(f);else{null===T?x("271"):void 0;c=T;var e=c.return;if(null===e){d=!0;Kc(f);break}Mc(a,e,c,f,Tc,U,Qc);T=Xc(c)}}break}while(1);S=!1;if(d)return null;if(null===T){if(Vc)return a.pendingCommitExpirationTime=b,a.current.alternate;Tc?x("262"):
void 0;0<=Sc&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&ad(a,b)},Sc);bd(a.current.expirationTime)}return null}
function Dc(a,b){var c;a:{S&&!Uc?x("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===R||!R.has(d))){a=Jb(b,a);a=Lc(c,a,1);M(c,a,1);Yb(c,1);c=void 0;break a}break;case 3:a=Jb(b,a);a=Jc(c,a,1);M(c,a,1);Yb(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Jb(b,a),c=Jc(a,c,1),M(a,c,1),Yb(a,1));c=void 0}return c}
function Xb(a,b){return S?Uc?1:U:b.mode&1?cd?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1}function Yb(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!S&&0!==U&&b<U&&Wc();var d=c.current.expirationTime;S&&!Uc&&Rc===c||ad(c,d);dd>ed&&x("185")}else break;a=a.return}}
function Wb(){Qc=gb()-Oc;return Pc=(Qc/10|0)+2}var fd=null,X=null,gd=0,hd=void 0,id=!1,Y=null,Z=0,jd=!1,kd=!1,ld=null,md=null,nd=!1,od=!1,cd=!1,rd=null,ed=1E3,dd=0,sd=1;function td(a){if(0!==gd){if(a>gd)return;null!==hd&&eb(hd)}var b=gb()-Oc;gd=a;hd=db(ud,{timeout:10*(a-2)-b})}
function ad(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===X?(fd=X=a,a.nextScheduledRoot=a):(X=X.nextScheduledRoot=a,X.nextScheduledRoot=fd);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}id||(nd?od&&(Y=a,Z=1,vd(a,1,!1)):1===b?wd(1,!1,null):td(b))}
function xd(){var a=0,b=null;if(null!==X)for(var c=X,d=fd;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===X?x("244"):void 0;if(d===d.nextScheduledRoot){fd=X=d.nextScheduledRoot=null;break}else if(d===fd)fd=e=d.nextScheduledRoot,X.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===X){X=c;X.nextScheduledRoot=fd;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===X)break;
c=d;d=d.nextScheduledRoot}}c=Y;null!==c&&c===b&&1===a?dd++:dd=0;Y=b;Z=a}function ud(a){wd(0,!0,a)}function wd(a,b,c){md=c;xd();if(b)for(;null!==Y&&0!==Z&&(0===a||a>=Z)&&(!jd||Wb()>=Z);)Wb(),vd(Y,Z,!jd),xd();else for(;null!==Y&&0!==Z&&(0===a||a>=Z);)vd(Y,Z,!1),xd();null!==md&&(gd=0,hd=null);0!==Z&&td(Z);md=null;jd=!1;dd=0;if(null!==rd)for(a=rd,rd=null,b=0;b<a.length;b++){c=a[b];try{c._onComplete()}catch(d){kd||(kd=!0,ld=d)}}if(kd)throw a=ld,ld=null,kd=!1,a;}
function vd(a,b,c){id?x("245"):void 0;id=!0;c?(c=a.finishedWork,null!==c?yd(a,c,b):(c=Zc(a,b,!0),null!==c&&($c()?a.finishedWork=c:yd(a,c,b)))):(c=a.finishedWork,null!==c?yd(a,c,b):(c=Zc(a,b,!1),null!==c&&yd(a,c,b)));id=!1}
function yd(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===rd?rd=[d]:rd.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;Uc=S=!0;c=b.stateNode;c.current===b?x("177"):void 0;d=c.pendingCommitExpirationTime;0===d?x("261"):void 0;c.pendingCommitExpirationTime=0;Wb();ia.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;for(V=e;null!==V;){var f=!1,g=void 0;try{for(;null!==
V;){if(V.effectTag&256){var l=V.alternate,h=V;switch(h.tag){case 2:if(h.effectTag&256&&null!==l){var k=l.memoizedProps,p=l.memoizedState,w=h.stateNode;w.props=h.memoizedProps;w.state=h.memoizedState;var L=w.getSnapshotBeforeUpdate(k,p);w.__reactInternalSnapshotBeforeUpdate=L}break;case 3:case 5:case 6:case 4:break;default:x("163")}}V=V.nextEffect}}catch(Aa){f=!0,g=Aa}f&&(null===V?x("178"):void 0,Dc(V,g),null!==V&&(V=V.nextEffect))}for(V=e;null!==V;){l=!1;k=void 0;try{for(;null!==V;){var W=V.effectTag;
if(W&128){var la=V.alternate;if(null!==la){var r=la.ref;null!==r&&("function"===typeof r?r(null):r.current=null)}}switch(W&14){case 2:Hc(V);V.effectTag&=-3;break;case 6:Hc(V);V.effectTag&=-3;Ic(V.alternate,V);break;case 4:Ic(V.alternate,V);break;case 8:p=V,Fc(p),p.return=null,p.child=null,p.alternate&&(p.alternate.child=null,p.alternate.return=null)}V=V.nextEffect}}catch(Aa){l=!0,k=Aa}l&&(null===V?x("178"):void 0,Dc(V,k),null!==V&&(V=V.nextEffect))}c.current=b;for(V=e;null!==V;){b=!1;W=void 0;try{for(la=
d;null!==V;){var q=V.effectTag;if(q&36){var u=V.alternate;r=V;e=la;switch(r.tag){case 2:var v=r.stateNode;if(r.effectTag&4)if(null===u)v.props=r.memoizedProps,v.state=r.memoizedState,v.componentDidMount();else{var pd=u.memoizedProps,qd=u.memoizedState;v.props=r.memoizedProps;v.state=r.memoizedState;v.componentDidUpdate(pd,qd,v.__reactInternalSnapshotBeforeUpdate)}var vc=r.updateQueue;null!==vc&&(v.props=r.memoizedProps,v.state=r.memoizedState,Ib(r,vc,v,e));break;case 3:var wc=r.updateQueue;if(null!==
wc){l=null;if(null!==r.child)switch(r.child.tag){case 5:l=r.child.stateNode;break;case 2:l=r.child.stateNode}Ib(r,wc,l,e)}break;case 5:break;case 6:break;case 4:break;case 15:break;case 16:break;default:x("163")}}if(q&128){r=void 0;var Za=V.ref;if(null!==Za){var xc=V.stateNode;switch(V.tag){case 5:r=xc;break;default:r=xc}"function"===typeof Za?Za(r):Za.current=r}}var t=V.nextEffect;V.nextEffect=null;V=t}}catch(Aa){b=!0,W=Aa}b&&(null===V?x("178"):void 0,Dc(V,W),null!==V&&(V=V.nextEffect))}S=Uc=!1;
q=c.current.expirationTime;0===q&&(R=null);a.remainingExpirationTime=q}function $c(){return null===md||md.timeRemaining()>sd?!1:jd=!0}function Kc(a){null===Y?x("246"):void 0;Y.remainingExpirationTime=0;kd||(kd=!0,ld=a)}function bd(a){null===Y?x("246"):void 0;Y.remainingExpirationTime=a}
function zd(a,b,c,d){var e=b.current,f=Wb();e=Xb(f,e);f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===wa(c)&&2===c.tag?void 0:x("170");for(g=c;3!==g.tag;){if(mb(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:x("171")}g=g.stateNode.context}c=mb(c)?rb(c,g):g}else c=m;null===b.context?b.context=c:b.pendingContext=c;b=d;d=Bb(e);d.payload={element:a};b=void 0===b?null:b;null!==b&&(d.callback=b);M(f,d,e);Yb(f,e);return e}
var Ad=aa||function(a){for(var b=1;b<arguments.length;b++){var c=arguments[b],d;for(d in c)Object.prototype.hasOwnProperty.call(c,d)&&(a[d]=c[d])}return a};function Bd(a,b){if(!a)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!b||"object"!==typeof b&&"function"!==typeof b?a:b}
function Cd(a,b){if("function"!==typeof b&&null!==b)throw new TypeError("Super expression must either be null or a function, not "+typeof b);a.prototype=Object.create(b&&b.prototype,{constructor:{value:a,enumerable:!1,writable:!0,configurable:!0}});b&&(Object.setPrototypeOf?Object.setPrototypeOf(a,b):a.__proto__=b)}function Dd(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function");}n.setCurrent(ha);
var Ed=Array.prototype.slice,Fd=function(){function a(b,c,d,e,f){Dd(this,a);this._args=Ed.call(arguments)}a.prototype.applyFill=function(a){a.fillLinear.apply(a,this._args)};return a}(),Gd=function(){function a(b,c,d,e,f,g,l){Dd(this,a);this._args=Ed.call(arguments)}a.prototype.applyFill=function(a){a.fillRadial.apply(a,this._args)};return a}(),Hd=function(){function a(b,c,d,e,f){Dd(this,a);this._args=Ed.call(arguments)}a.prototype.applyFill=function(a){a.fillImage.apply(a,this._args)};return a}(),
Id=function(a){function b(){Dd(this,b);return Bd(this,a.apply(this,arguments))}Cd(b,a);b.prototype.componentDidMount=function(){var a=this.props,b=this._surface=n.Surface(+a.width,+a.height,this._tagRef);a=new J(3,null,null,0);b={current:a,containerInfo:b,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:void 0,remainingExpirationTime:0,
firstBatch:null,nextScheduledRoot:null};this._mountNode=a.stateNode=b;zd(this.props.children,this._mountNode,this)};b.prototype.componentDidUpdate=function(a){var b=this.props;b.height===a.height&&b.width===a.width||this._surface.resize(+b.width,+b.height);zd(this.props.children,this._mountNode,this);this._surface.render&&this._surface.render()};b.prototype.componentWillUnmount=function(){zd(null,this._mountNode,this)};b.prototype.render=function(){var a=this,b=this.props;return ba.createElement(n.Surface.tagName,
{ref:function(b){return a._tagRef=b},accessKey:b.accessKey,className:b.className,draggable:b.draggable,role:b.role,style:b.style,tabIndex:b.tabIndex,title:b.title})};return b}(ba.Component),Jd=function(a){function b(c){Dd(this,b);var d=Bd(this,a.call(this,c));["height","width","x","y"].forEach(function(a){Object.defineProperty(d,a,{get:function(){return this._text?this._text[a]:void 0}})});return d}Cd(b,a);b.prototype.render=function(){var a=this;return ba.createElement(C.TEXT,Ad({},this.props,{ref:function(b){return a._text=
b}}),Ta(this.props.children))};return b}(ba.Component);module.exports={ClippingRectangle:C.CLIPPING_RECTANGLE,Group:C.GROUP,Shape:C.SHAPE,Path:n.Path,LinearGradient:Fd,Pattern:Hd,RadialGradient:Gd,Surface:Id,Text:Jd,Transform:ea};


/***/ }),
/* 687 */
/***/ (function(module, exports) {

function warning(){
	throw new Error('You must require a mode before requiring anything else.');
}

exports.Surface = warning;
exports.Path = warning;
exports.Shape = warning;
exports.Group = warning;
exports.ClippingRectangle = warning;
exports.Text = warning;

exports.setCurrent = function(mode){
	for (var key in mode){
		exports[key] = mode[key];
	}
};


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var hasCanvas = function(){

  var canvas = typeof window !== 'undefined' && window.document && window.document.createElement && document.createElement('canvas');
  return canvas && !!canvas.getContext;

};

if (hasCanvas()) {
  exports.Surface = __webpack_require__(689);
  exports.Path = __webpack_require__(297);
  exports.Shape = __webpack_require__(690);
  exports.Group = __webpack_require__(691);
  exports.ClippingRectangle = __webpack_require__(692);
  exports.Text = __webpack_require__(693);
} else {
  exports.Surface = __webpack_require__(302);
  exports.Path = __webpack_require__(191);
  exports.Shape = __webpack_require__(694);
  exports.Group = __webpack_require__(304);
  exports.ClippingRectangle = __webpack_require__(696);
  exports.Text = __webpack_require__(697);

  var DOM = __webpack_require__(93);
  if (typeof document !== 'undefined') DOM.init(document);
}


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Container = __webpack_require__(92);
var Element = __webpack_require__(189);

var fps = 1000 / 60, invalids = [], renderTimer, renderInvalids = function(){
	clearTimeout(renderTimer);
	renderTimer = null;
	var canvases = invalids;
	invalids = [];
	for (var i = 0, l = canvases.length; i < l; i++){
		var c = canvases[i];
		c._valid = true;
		c.render();
	}
};

var resolution = typeof window !== 'undefined' && window.devicePixelRatio || 1;

var previousHit = null, previousHitSurface = null;

var CanvasSurface = Class(Element, Container, {

	initialize: function(width, height, existingElement){
		var element = this.element = existingElement || document.createElement('canvas');
		var context = this.context = element.getContext('2d');
		this._valid = true;
		if (width != null && height != null) this.resize(width, height);

		element.addEventListener('mousemove', this, false);
		element.addEventListener('mouseout', this, false);
		element.addEventListener('mouseover', this, false);
		element.addEventListener('mouseup', this, false);
		element.addEventListener('mousedown', this, false);
		element.addEventListener('click', this, false);
	},

	handleEvent: function(event){
		if (event.clientX == null) return;
		var element = this.element,
			rect = element.getBoundingClientRect(),
			x = event.clientX - rect.left - element.clientLeft,
			y = event.clientY - rect.top - element.clientTop,
			hit = this.hitTest(x, y);

		if (hit !== previousHit){
			if (previousHit){
				previousHit.dispatch({
					type: 'mouseout',
					target: previousHit,
					relatedTarget: hit,
					sourceEvent: event
				});
			}
			if (hit){
				hit.dispatch({
					type: 'mouseover',
					target: hit,
					relatedTarget: previousHit,
					sourceEvent: event
				});
			}
			previousHit = hit;
			previousHitSurface = this;
			this.refreshCursor();
		}

		if (hit) hit.dispatch(event);
	},

	refreshCursor: function(){
		if (previousHitSurface !== this) return;
		var hit = previousHit, hitCursor = '', hitTooltip = '';
		while (hit){
			if (!hitCursor && hit._cursor){
				hitCursor = hit._cursor;
				if (hitTooltip) break;
			}
			if (!hitTooltip && hit._tooltip){
				hitTooltip = hit._tooltip;
				if (hitCursor) break;
			}
			hit = hit.parentNode;
		}
		// TODO: No way to set cursor/title on the surface
		this.element.style.cursor = hitCursor;
		this.element.title = hitTooltip;
	},

	resize: function(width, height){
		var element = this.element;
		element.setAttribute('width', width * resolution);
		element.setAttribute('height', height * resolution);
		element.style.width = width + 'px';
		element.style.height = height + 'px';
		this.width = width;
		this.height = height;
		return this;
	},

	invalidate: function(left, top, width, height){
		if (this._valid){
			this._valid = false;
			invalids.push(this);
			if (!renderTimer){
				if (window.mozRequestAnimationFrame){
					renderTimer = true;
					window.mozRequestAnimationFrame(renderInvalids);
				} else {
					renderTimer = setTimeout(renderInvalids, fps);
				}
			}
		}
		return this;
	},

	hitTest: function(x, y){
		if (x < 0 || y < 0 || x > this.width || y > this.height) return null;
		var node = this.lastChild;
		while (node){
			var hit = node.hitTest(x, y);
			if (hit) return hit;
			node = node.previousSibling;
		}
		return null;
	},

	render: function(){
		var node = this.firstChild, context = this.context;
		context.setTransform(resolution, 0, 0, resolution, 0, 0);
		context.clearRect(0, 0, this.width, this.height);
		while (node){
			node.renderTo(context, resolution, 0, 0, resolution, 0, 0);
			node = node.nextSibling;
		}
		this.refreshCursor();
	}

});

CanvasSurface.tagName = 'canvas';

module.exports = CanvasSurface;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Base = __webpack_require__(299);
var Path = __webpack_require__(297);

module.exports = Class(Base, {

	base_initialize: Base.prototype.initialize,

	initialize: function(path, width, height){
		this.base_initialize();
		this.width = width;
		this.height = height;
		if (path != null) this.draw(path);
	},

	draw: function(path, width, height){
		if (!(path instanceof Path)) path = new Path(path);
		this.path = path;
		this._commands = path.toCommands();
		if (width != null) this.width = width;
		if (height != null) this.height = height;
		return this.invalidate();
	},

	localHitTest: function(x, y){
		if (!this._fill) return null;
		if (this.width == null || this.height == null){
			var context = Base._genericContext, commands = this._commands;
			if (!commands) return null;
			context.beginPath();
			for (var i = 0, l = commands.length; i < l; i++)
				commands[i](context);
			return context.isPointInPath(x, y) ? this : null;
		}
		if (x > 0 && y > 0 && x < this.width && y < this.height){
			return this;
		}
		return null;
	},

	renderShapeTo: function(context){
		if (this._invisible || !this._commands || (!this._fill && !this._stroke)) {
			return null;
		}
		context.transform(this.xx, this.yx, this.xy, this.yy, this.x, this.y);
		var commands = this._commands,
		    fill = this._fill,
		    stroke = this._stroke,
		    dash = this._strokeDash;

		context.beginPath();

		if (dash) {
			if (context.setLineDash) {
				context.setLineDash(dash);
			} else {
				// TODO: Remove when FF supports setLineDash.
				context.mozDash = dash;
			}
			// TODO: Create fallback to other browsers.
		} else {
			if (context.setLineDash) {
				context.setLineDash([]);
			} else {
				context.mozDash = null;
			}
		}

		for (var i = 0, l = commands.length; i < l; i++)
			commands[i](context);

		if (fill){
			var m = this._fillTransform;
			if (m){
				context.save(); // TODO: Optimize away this by restoring the transform before stroking
				context.transform(m.xx, m.yx, m.xy, m.yy, m.x, m.y);
				context.fillStyle = fill;
				context.fill();
				context.restore();
			} else {
				context.fillStyle = fill;
				context.fill();
			}
		}
		if (stroke){
			context.strokeStyle = stroke;
			context.lineWidth = this._strokeWidth;
			context.lineCap = this._strokeCap;
			context.lineJoin = this._strokeJoin;
			context.stroke();
		}
	}

});


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Container = __webpack_require__(92);
var Node = __webpack_require__(190);

module.exports = Class(Node, Container, {
	
	initialize: function(width, height){
		this.width = width;
		this.height = height;
	},

	localHitTest: function(x, y){
		var node = this.lastChild;
		while (node){
			var hit = node.hitTest(x, y);
			if (hit) return hit;
			node = node.previousSibling;
		}
		return null;
	},

	renderLayerTo: function(context, xx, yx, xy, yy, x, y){
		if (this._invisible) return;

		x = xx * this.x + xy * this.y + x;
		y = yx * this.x + yy * this.y + y;

		var t = xx;
		xx = t * this.xx + xy * this.yx;
		xy = t * this.xy + xy * this.yy;
		t = yx;
		yx = t * this.xx + yy * this.yx;
		yy = t * this.xy + yy * this.yy;

		var node = this.firstChild;
		while (node){
			node.renderTo(context, xx, yx, xy, yy, x, y);
			node = node.nextSibling;
		}
	}

});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Container = __webpack_require__(92);
var Node = __webpack_require__(190);

module.exports = Class(Node, Container, {

	initialize: function(width, height){
		this.width = width;
		this.height = height;
	},

	localHitTest: function(x, y) {
		var node = this.lastChild;
		while (node){
			var hit = node.hitTest(x, y);
			if (hit) return hit;
			node = node.previousSibling;
		}
		return null;
	},

	renderLayerTo: function(context, xx, yx, xy, yy, x, y) {
		context.setTransform(xx, yx, xy, yy, x, y);
		context.save();
		// Need beginPath to fix Firefox bug. See 3354054.
		context.beginPath();
		context.rect(this.x, this.y, this.width, this.height);
		context.clip();

		var node = this.firstChild;
		while(node) {
			node.renderTo(context, xx, yx, xy, yy, x, y);
			node = node.nextSibling;
		}
		context.restore();
	}
});


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Base = __webpack_require__(299);

var fontAnchors = { middle: 'center' };

module.exports = Class(Base, {

	base_initialize: Base.prototype.initialize,

	initialize: function(text, font, alignment, path){
		this.base_initialize();
		this.draw.apply(this, arguments);
	},

	draw: function(text, font, alignment, path){
		var em;
		if (typeof font == 'string'){
			em = Number(/(\d+)/.exec(font)[0]);
		} else if (font){
			em = parseFloat(font.fontSize || font['font-size'] || '12');
			font = (font.fontStyle || font['font-style'] || '') + ' ' +
				(font.fontVariant || font['font-variant'] || '') + ' ' +
				(font.fontWeight || font['font-weight'] || '') + ' ' +
				em + 'px ' +
				(font.fontFamily || font['font-family'] || 'Arial');
		} else {
			font = this._font;
		}

		var lines = text && text.split(/\r?\n/);
		this._font = font;
		this._fontSize = em;
		this._text = lines;
		this._alignment = fontAnchors[alignment] || alignment || 'left';

		var context = Base._genericContext;

		context.font = this._font;
		context.textAlign = this._alignment;
		context.textBaseline = 'middle';

		lines = this._text;
		var l = lines.length, width = 0;
		for (var i = 0; i < l; i++){
			var w = context.measureText(lines[i]).width;
			if (w > width) width = w;
		}
		this.width = width;
		this.height = l ? l * 1.1 * em : 0;
		return this.invalidate();
	},

	// Interaction

	localHitTest: function(x, y){
		if (!this._fill) return null;
		if (x > 0 && y > 0 && x < this.width && y < this.height){
			return this;
		}
		return null;
	},

	// Rendering

	renderShapeTo: function(context){
		if (this._invisible || !this._text || (!this._fill && !this._stroke)) {
			return null;
		}
		context.transform(this.xx, this.yx, this.xy, this.yy, this.x, this.y);
		var fill = this._fill,
		    stroke = this._stroke,
		    text = this._text,
		    dash = this._strokeDash;

		context.font = this._font;
		context.textAlign = this._alignment;
		context.textBaseline = 'middle';

		var em = this._fontSize,
		    y = em / 2,
		    lineHeight = 1.1 * em,
		    lines = text,
		    l = lines.length;

		if (fill){
			context.fillStyle = fill;
			for (var i = 0; i < l; i++)
				context.fillText(lines[i], 0, y + i * lineHeight);
		}
		if (stroke){
			if (dash) {
				if (context.setLineDash) {
					context.setLineDash(dash);
				} else {
					// TODO: Remove when FF supports setLineDash.
					context.mozDash = dash;
				}
				// TODO: Create fallback to other browsers.
			} else {
				if (context.setLineDash) {
					context.setLineDash([]);
				} else {
					context.mozDash = null;
				}
			}

			context.strokeStyle = stroke;
			context.lineWidth = this._strokeWidth;
			context.lineCap = this._strokeCap;
			context.lineJoin = this._strokeJoin;
			for (i = 0; i < l; i++)
				context.strokeText(lines[i], 0, y + i * lineHeight);
		}
	}

});


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Base = __webpack_require__(303);
var Path = __webpack_require__(191);
var DOM = __webpack_require__(93);

var precision = 100;

module.exports = Class(Base, {

	base_initialize: Base.prototype.initialize,
	
	initialize: function(path, width, height){
		this.base_initialize('shape');

		var p = this.pathElement = DOM.createElement('path');
		p.gradientshapeok = true;
		this.element.appendChild(p);
		
		this.width = width;
		this.height = height;
		
		if (path != null) this.draw(path);
	},
	
	// SVG to VML
	
	draw: function(path, width, height){
		
		if (!(path instanceof Path)) path = new Path(path);
		this._vml = path.toVML();
		//this._size = path.measure();
		
		if (width != null) this.width = width;
		if (height != null) this.height = height;
		
		if (!this._boxCoords) this._transform();
		this._redraw(this._prefix, this._suffix);
		
		return this;
	},
	
	// radial gradient workaround

	_redraw: function(prefix, suffix){
		var vml = this._vml || '';

		this._prefix = prefix;
		this._suffix = suffix
		if (prefix){
			vml = [
				prefix, vml, suffix,
				// Don't stroke the path with the extra ellipse, redraw the stroked path separately
				'ns e', vml, 'nf'
			].join(' ');
		}

		this.element.path = vml + 'e';
	},

	fillRadial: function(stops, focusX, focusY, radiusX, radiusY, centerX, centerY){
		var fill = this._createGradient('gradientradial', stops);
		if (focusX == null) focusX = (this.left || 0) + (this.width || 0) * 0.5;
		if (focusY == null) focusY = (this.top || 0) + (this.height || 0) * 0.5;
		if (radiusY == null) radiusY = radiusX || (this.height * 0.5) || 0;
		if (radiusX == null) radiusX = (this.width || 0) * 0.5;
		if (centerX == null) centerX = focusX;
		if (centerY == null) centerY = focusY;

		centerX += centerX - focusX;
		centerY += centerY - focusY;
		
		var cx = Math.round(centerX * precision),
			cy = Math.round(centerY * precision),

			rx = Math.round(radiusX * 2 * precision),
			ry = Math.round(radiusY * 2 * precision),

			arc = ['wa', cx - rx, cy - ry, cx + rx, cy + ry].join(' ');

		this._redraw(
			// Resolve rendering bug
			['m', cx, cy - ry, 'l', cx, cy - ry].join(' '),
			// Draw an ellipse around the path to force an elliptical gradient on any shape
			[
				'm', cx, cy - ry,
				arc, cx, cy - ry, cx, cy + ry, arc, cx, cy + ry, cx, cy - ry,
				arc, cx, cy - ry, cx, cy + ry, arc, cx, cy + ry, cx, cy - ry
			].join(' ')
		);

		this._boxCoords = { left: focusX - 2, top: focusY - 2, width: 4, height: 4 };
		
		fill.focusposition = '0.5,0.5';
		fill.focussize = '0 0';
		fill.focus = '50%';
		
		this._transform();
		
		return this;
	}

});

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Dummy = __webpack_require__(301);
var Native = __webpack_require__(189);

module.exports = Class(Dummy, Native, {

	dummy_inject: Dummy.prototype.inject,
	dummy_injectBefore: Dummy.prototype.injectBefore,
	dummy_eject: Dummy.prototype.eject,
	native_inject: Native.prototype.inject,
	native_injectBefore: Native.prototype.injectBefore,
	native_eject: Native.prototype.eject,

	inject: function(container){
		this.dummy_inject(container);
		this.native_inject(container);
		return this;
	},

	injectBefore: function(sibling){
		this.dummy_injectBefore(sibling);
		this.native_injectBefore(sibling);
		return this;
	},

	eject: function(){
		this.dummy_eject();
		this.native_eject();
		return this;
	}

});


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Transform = __webpack_require__(81);
var Container = __webpack_require__(92);
var Node = __webpack_require__(192);

module.exports = Class(Node, Container, {

  element_initialize: Node.prototype.initialize,

  initialize: function(width, height){
    this.element_initialize('clippingrectangle');
    this.width = width;
    this.height = height;
  },

  _transform: function(){
    var element = this.element;
    element.clip = true;
    element.coordorigin = -this.x + ',' + (-1 * this.y);
    element.coordsize = this.width + ',' + this.height;
    // IE8 doesn't like clipBottom.  Don't ask me why.
    // element.style.clipBottom = this.height + this.y;
    element.style.clipLeft = this.x;
    element.style.clipRight = this.width + this.x;
    element.style.clipTop = this.y;
    element.style.left = -this.x;
    element.style.top = -this.y;
    element.style.width = this.width + this.x;
    element.style.height = this.height + this.y;
    element.style.rotation = 0;

    var container = this.parentNode;
    this._activeTransform = container ? new Transform(container._activeTransform).transform(this) : this;
    var node = this.firstChild;
    while (node){
      node._transform();
      node = node.nextSibling;
    }
  }

});


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var Class = __webpack_require__(14);
var Base = __webpack_require__(303);
var Path = __webpack_require__(191);
var Surface = __webpack_require__(302);
var Group = __webpack_require__(304);
var DOM = __webpack_require__(93);

var fontAnchors = { start: 'left', middle: 'center', end: 'right' };

module.exports = Class(Base, {

	base_initialize: Base.prototype.initialize,

	initialize: function(text, font, alignment, path){
		this.base_initialize('shape');
		
		var p = this.pathElement = DOM.createElement('path');
		p.textpathok = true;
		this.element.appendChild(p);
		
		p = this.textPathElement = DOM.createElement("textpath");
		p.on = true;
		p.style['v-text-align'] = 'left';
		this.element.appendChild(p);
		
		this.draw.apply(this, arguments);
	},
	
	draw: function(text, font, alignment, path){
		var element = this.element,
		    textPath = this.textPathElement,
		    style = textPath.style;
		
		textPath.string = text;
		
		if (font){
			if (typeof font == 'string'){
				style.font = font;
			} else {
				for (var key in font){
					var ckey = key.camelCase ? key.camelCase() : key;
					if (ckey == 'fontFamily') style[ckey] = "'" + font[key] + "'";
					// NOT UNIVERSALLY SUPPORTED OPTIONS
					// else if (ckey == 'kerning') style['v-text-kern'] = !!font[key];
					// else if (ckey == 'rotateGlyphs') style['v-rotate-letters'] = !!font[key];
					// else if (ckey == 'letterSpacing') style['v-text-spacing'] = Number(font[key]) + '';
					else style[ckey] = font[key];
				}
			}
		}
		
		if (alignment) style['v-text-align'] = fontAnchors[alignment] || alignment;
		
		if (path){
			this.currentPath = path = new Path(path);
			this.element.path = path.toVML();
		} else if (!this.currentPath){
			var i = -1, offsetRows = '\n';
			while ((i = text.indexOf('\n', i + 1)) > -1) offsetRows += '\n';
			textPath.string = offsetRows + textPath.string;
			this.element.path = 'm0,0l1,0';
		}
		
		// Measuring the bounding box is currently necessary for gradients etc.
		
		// Clone element because the element is dead once it has been in the DOM
		element = element.cloneNode(true);
		style = element.style;
		
		// Reset coordinates while measuring
		element.coordorigin = '0,0';
		element.coordsize = '10000,10000';
		style.left = '0px';
		style.top = '0px';
		style.width = '10000px';
		style.height = '10000px';
		style.rotation = 0;
		element.removeChild(element.firstChild); // Remove skew
		
		// Inject the clone into the document
		
		var canvas = new Surface(1, 1),
		    group = new Group(), // Wrapping it in a group seems to alleviate some client rect weirdness
		    body = element.ownerDocument.body;
		
		canvas.inject(body);
		group.element.appendChild(element);
		group.inject(canvas);
		
		var ebb = element.getBoundingClientRect(),
		    cbb = canvas.toElement().getBoundingClientRect();
		
		canvas.eject();
		
		this.left = ebb.left - cbb.left;
		this.top = ebb.top - cbb.top;
		this.width = ebb.right - ebb.left;
		this.height = ebb.bottom - ebb.top;
		this.right = ebb.right - cbb.left;
		this.bottom = ebb.bottom - cbb.top;
		
		this._transform();

		//this._size = { left: this.left, top: this.top, width: this.width, height: this.height};
		return this;
	}

});


/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColorPropType__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TouchableOpacity__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Text__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */








var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Button.prototype.render = function render() {
    var _props = this.props,
        accessibilityLabel = _props.accessibilityLabel,
        color = _props.color,
        disabled = _props.disabled,
        onPress = _props.onPress,
        testID = _props.testID,
        title = _props.title;


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__TouchableOpacity__["a" /* default */],
      {
        accessibilityLabel: accessibilityLabel,
        accessibilityRole: 'button',
        disabled: disabled,
        onPress: onPress,
        style: [styles.button, color && { backgroundColor: color }, disabled && styles.buttonDisabled],
        testID: testID
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__Text__["a" /* default */],
        { style: [styles.text, disabled && styles.textDisabled] },
        title
      )
    );
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Button.propTypes =  false ? {
  accessibilityLabel: string,
  color: ColorPropType,
  disabled: bool,
  onPress: func.isRequired,
  testID: string,
  title: string.isRequired
} : {};


var styles = __WEBPACK_IMPORTED_MODULE_1__StyleSheet__["a" /* default */].create({
  button: {
    backgroundColor: '#2196F3',
    borderRadius: 2
  },
  text: {
    color: '#fff',
    fontWeight: '500',
    padding: 8,
    textAlign: 'center',
    textTransform: 'uppercase'
  },
  buttonDisabled: {
    backgroundColor: '#dfdfdf'
  },
  textDisabled: {
    color: '#a1a1a1'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_PooledClass__ = __webpack_require__(306);
/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var twoArgumentPooler = __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_PooledClass__["a" /* default */].twoArgumentPooler;

/**
 * PooledClass representing the bounding rectangle of a region.
 */
function BoundingDimensions(width, height) {
  this.width = width;
  this.height = height;
}

BoundingDimensions.prototype.destructor = function () {
  this.width = null;
  this.height = null;
};

BoundingDimensions.getPooledFromElement = function (element) {
  return BoundingDimensions.getPooled(element.offsetWidth, element.offsetHeight);
};

__WEBPACK_IMPORTED_MODULE_0__vendor_react_native_PooledClass__["a" /* default */].addPoolingTo(BoundingDimensions, twoArgumentPooler);

/* harmony default export */ __webpack_exports__["a"] = (BoundingDimensions);

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_PooledClass__ = __webpack_require__(306);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */



var twoArgumentPooler = __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_PooledClass__["a" /* default */].twoArgumentPooler;

function Position(left, top) {
  this.left = left;
  this.top = top;
}

Position.prototype.destructor = function () {
  this.left = null;
  this.top = null;
};

__WEBPACK_IMPORTED_MODULE_0__vendor_react_native_PooledClass__["a" /* default */].addPoolingTo(Position, twoArgumentPooler);

/* harmony default export */ __webpack_exports__["a"] = (Position);

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var TouchEventUtils = {
  /**
   * Utility function for common case of extracting out the primary touch from a
   * touch event.
   * - `touchEnd` events usually do not have the `touches` property.
   *   http://stackoverflow.com/questions/3666929/
   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
   *
   * @param {Event} nativeEvent Native event that may or may not be a touch.
   * @return {TouchesObject?} an object with pageX and pageY or null.
   */
  extractSingleTouch: function extractSingleTouch(nativeEvent) {
    var touches = nativeEvent.touches;
    var changedTouches = nativeEvent.changedTouches;
    var hasTouches = touches && touches.length > 0;
    var hasChangedTouches = changedTouches && changedTouches.length > 0;

    return !hasTouches && hasChangedTouches ? changedTouches[0] : hasTouches ? touches[0] : nativeEvent;
  }
};

module.exports = TouchEventUtils;

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_applyNativeMethods__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColorPropType__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createElement__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UIManager__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ViewPropTypes__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2017-present, Nicolas Gallagher.
 * Copyright (c) 2017-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */











var CheckBox = function (_Component) {
  _inherits(CheckBox, _Component);

  function CheckBox() {
    var _temp, _this, _ret;

    _classCallCheck(this, CheckBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onValueChange = _this$props.onValueChange;

      var value = event.nativeEvent.target.checked;
      event.nativeEvent.value = value;
      onChange && onChange(event);
      onValueChange && onValueChange(value);
    }, _this._setCheckboxRef = function (element) {
      _this._checkboxElement = element;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CheckBox.prototype.blur = function blur() {
    __WEBPACK_IMPORTED_MODULE_4__UIManager__["a" /* default */].blur(this._checkboxElement);
  };

  CheckBox.prototype.focus = function focus() {
    __WEBPACK_IMPORTED_MODULE_4__UIManager__["a" /* default */].focus(this._checkboxElement);
  };

  CheckBox.prototype.render = function render() {
    var _props = this.props,
        color = _props.color,
        disabled = _props.disabled,
        onChange = _props.onChange,
        onValueChange = _props.onValueChange,
        style = _props.style,
        value = _props.value,
        other = _objectWithoutProperties(_props, ['color', 'disabled', 'onChange', 'onValueChange', 'style', 'value']);

    var fakeControl = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__View__["a" /* default */], {
      style: [styles.fakeControl, value && styles.fakeControlChecked,
      // custom color
      value && color && { backgroundColor: color, borderColor: color }, disabled && styles.fakeControlDisabled, value && disabled && styles.fakeControlCheckedAndDisabled]
    });

    var nativeControl = Object(__WEBPACK_IMPORTED_MODULE_2__createElement__["a" /* default */])('input', {
      checked: value,
      disabled: disabled,
      onChange: this._handleChange,
      ref: this._setCheckboxRef,
      style: [styles.nativeControl, styles.cursorInherit],
      type: 'checkbox'
    });

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__View__["a" /* default */],
      _extends({}, other, { style: [styles.root, style, disabled && styles.cursorDefault] }),
      fakeControl,
      nativeControl
    );
  };

  return CheckBox;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

CheckBox.displayName = 'CheckBox';
CheckBox.defaultProps = {
  disabled: false,
  value: false
};
CheckBox.propTypes =  false ? Object.assign({}, ViewPropTypes, {
  color: ColorPropType,
  disabled: bool,
  onChange: func,
  onValueChange: func,
  value: bool
}) : {};


var styles = __WEBPACK_IMPORTED_MODULE_3__StyleSheet__["a" /* default */].create({
  root: {
    cursor: 'pointer',
    height: 16,
    userSelect: 'none',
    width: 16
  },
  cursorDefault: {
    cursor: 'default'
  },
  cursorInherit: {
    cursor: 'inherit'
  },
  fakeControl: {
    alignItems: 'center',
    backgroundColor: '#fff',
    borderColor: '#657786',
    borderRadius: 2,
    borderStyle: 'solid',
    borderWidth: 2,
    height: '100%',
    justifyContent: 'center',
    width: '100%'
  },
  fakeControlChecked: {
    backgroundColor: '#009688',
    backgroundImage: 'url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmVyc2lvbj0iMS4xIgogICB2aWV3Qm94PSIwIDAgMSAxIgogICBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWluWU1pbiBtZWV0Ij4KICA8cGF0aAogICAgIGQ9Ik0gMC4wNDAzODA1OSwwLjYyNjc3NjcgMC4xNDY0NDY2MSwwLjUyMDcxMDY4IDAuNDI5Mjg5MzIsMC44MDM1NTMzOSAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IE0gMC4yMTcxNTcyOSwwLjgwMzU1MzM5IDAuODUzNTUzMzksMC4xNjcxNTcyOSAwLjk1OTYxOTQxLDAuMjczMjIzMyAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IgogICAgIGlkPSJyZWN0Mzc4MCIKICAgICBzdHlsZT0iZmlsbDojZmZmZmZmO2ZpbGwtb3BhY2l0eToxO3N0cm9rZTpub25lIiAvPgo8L3N2Zz4K")',
    backgroundRepeat: 'no-repeat',
    borderColor: '#009688'
  },
  fakeControlDisabled: {
    borderColor: '#CCD6DD'
  },
  fakeControlCheckedAndDisabled: {
    backgroundColor: '#AAB8C2',
    borderColor: '#AAB8C2'
  },
  nativeControl: Object.assign({}, __WEBPACK_IMPORTED_MODULE_3__StyleSheet__["a" /* default */].absoluteFillObject, {
    height: '100%',
    margin: 0,
    opacity: 0,
    padding: 0,
    width: '100%'
  })
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__modules_applyNativeMethods__["a" /* default */])(CheckBox));

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_FlatList__ = __webpack_require__(307);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__vendor_react_native_FlatList__["a" /* default */]);

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports_InteractionManager__ = __webpack_require__(129);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * A simple class for batching up invocations of a low-pri callback. A timeout is set to run the
 * callback once after a delay, no matter how many times it's scheduled. Once the delay is reached,
 * InteractionManager.runAfterInteractions is used to invoke the callback after any hi-pri
 * interactions are done running.
 *
 * Make sure to cleanup with dispose().  Example:
 *
 *   class Widget extends React.Component {
 *     _batchedSave: new Batchinator(() => this._saveState, 1000);
 *     _saveSate() {
 *       // save this.state to disk
 *     }
 *     componentDidUpdate() {
 *       this._batchedSave.schedule();
 *     }
 *     componentWillUnmount() {
 *       this._batchedSave.dispose();
 *     }
 *     ...
 *   }
 */

var Batchinator = function () {
  function Batchinator(callback, delayMS) {
    _classCallCheck(this, Batchinator);

    this._delay = delayMS;
    this._callback = callback;
  }
  /*
   * Cleanup any pending tasks.
   *
   * By default, if there is a pending task the callback is run immediately. Set the option abort to
   * true to not call the callback if it was pending.
   */


  Batchinator.prototype.dispose = function dispose() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { abort: false };

    if (this._taskHandle) {
      this._taskHandle.cancel();
      if (!options.abort) {
        this._callback();
      }
      this._taskHandle = null;
    }
  };

  Batchinator.prototype.schedule = function schedule() {
    var _this = this;

    if (this._taskHandle) {
      return;
    }
    var timeoutHandle = setTimeout(function () {
      _this._taskHandle = __WEBPACK_IMPORTED_MODULE_0__exports_InteractionManager__["a" /* default */].runAfterInteractions(function () {
        // Note that we clear the handle before invoking the callback so that if the callback calls
        // schedule again, it will actually schedule another task.
        _this._taskHandle = null;
        _this._callback();
      });
    }, this._delay);
    this._taskHandle = { cancel: function cancel() {
        return clearTimeout(timeoutHandle);
      } };
  };

  return Batchinator;
}();

/* harmony default export */ __webpack_exports__["a"] = (Batchinator);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_performanceNow__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_performanceNow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_performanceNow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_warning__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_warning__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */




var Info = function Info() {
  _classCallCheck(this, Info);

  this.any_blank_count = 0;
  this.any_blank_ms = 0;
  this.any_blank_speed_sum = 0;
  this.mostly_blank_count = 0;
  this.mostly_blank_ms = 0;
  this.pixels_blank = 0;
  this.pixels_sampled = 0;
  this.pixels_scrolled = 0;
  this.total_time_spent = 0;
  this.sample_count = 0;
};

var DEBUG = false;

var _listeners = [];
var _minSampleCount = 10;
var _sampleRate = DEBUG ? 1 : null;

/**
 * A helper class for detecting when the maximem fill rate of `VirtualizedList` is exceeded.
 * By default the sampling rate is set to zero and this will do nothing. If you want to collect
 * samples (e.g. to log them), make sure to call `FillRateHelper.setSampleRate(0.0-1.0)`.
 *
 * Listeners and sample rate are global for all `VirtualizedList`s - typical usage will combine with
 * `SceneTracker.getActiveScene` to determine the context of the events.
 */

var FillRateHelper = function () {
  FillRateHelper.addListener = function addListener(callback) {
    __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_warning___default()(_sampleRate !== null, 'Call `FillRateHelper.setSampleRate` before `addListener`.');
    _listeners.push(callback);
    return {
      remove: function remove() {
        _listeners = _listeners.filter(function (listener) {
          return callback !== listener;
        });
      }
    };
  };

  FillRateHelper.setSampleRate = function setSampleRate(sampleRate) {
    _sampleRate = sampleRate;
  };

  FillRateHelper.setMinSampleCount = function setMinSampleCount(minSampleCount) {
    _minSampleCount = minSampleCount;
  };

  function FillRateHelper(getFrameMetrics) {
    _classCallCheck(this, FillRateHelper);

    this._anyBlankStartTime = null;
    this._enabled = false;
    this._info = new Info();
    this._mostlyBlankStartTime = null;
    this._samplesStartTime = null;

    this._getFrameMetrics = getFrameMetrics;
    this._enabled = (_sampleRate || 0) > Math.random();
    this._resetData();
  }

  FillRateHelper.prototype.activate = function activate() {
    if (this._enabled && this._samplesStartTime == null) {
      DEBUG && console.debug('FillRateHelper: activate');
      this._samplesStartTime = __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_performanceNow___default()();
    }
  };

  FillRateHelper.prototype.deactivateAndFlush = function deactivateAndFlush() {
    if (!this._enabled) {
      return;
    }
    var start = this._samplesStartTime; // const for flow
    if (start == null) {
      DEBUG && console.debug('FillRateHelper: bail on deactivate with no start time');
      return;
    }
    if (this._info.sample_count < _minSampleCount) {
      // Don't bother with under-sampled events.
      this._resetData();
      return;
    }
    var total_time_spent = __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_performanceNow___default()() - start;
    var info = Object.assign({}, this._info, {
      total_time_spent: total_time_spent
    });
    if (DEBUG) {
      var derived = {
        avg_blankness: this._info.pixels_blank / this._info.pixels_sampled,
        avg_speed: this._info.pixels_scrolled / (total_time_spent / 1000),
        avg_speed_when_any_blank: this._info.any_blank_speed_sum / this._info.any_blank_count,
        any_blank_per_min: this._info.any_blank_count / (total_time_spent / 1000 / 60),
        any_blank_time_frac: this._info.any_blank_ms / total_time_spent,
        mostly_blank_per_min: this._info.mostly_blank_count / (total_time_spent / 1000 / 60),
        mostly_blank_time_frac: this._info.mostly_blank_ms / total_time_spent
      };
      for (var key in derived) {
        derived[key] = Math.round(1000 * derived[key]) / 1000;
      }
      console.debug('FillRateHelper deactivateAndFlush: ', { derived: derived, info: info });
    }
    _listeners.forEach(function (listener) {
      return listener(info);
    });
    this._resetData();
  };

  FillRateHelper.prototype.computeBlankness = function computeBlankness(props, state, scrollMetrics) {
    if (!this._enabled || props.getItemCount(props.data) === 0 || this._samplesStartTime == null) {
      return 0;
    }
    var dOffset = scrollMetrics.dOffset,
        offset = scrollMetrics.offset,
        velocity = scrollMetrics.velocity,
        visibleLength = scrollMetrics.visibleLength;

    // Denominator metrics that we track for all events - most of the time there is no blankness and
    // we want to capture that.

    this._info.sample_count++;
    this._info.pixels_sampled += Math.round(visibleLength);
    this._info.pixels_scrolled += Math.round(Math.abs(dOffset));
    var scrollSpeed = Math.round(Math.abs(velocity) * 1000); // px / sec

    // Whether blank now or not, record the elapsed time blank if we were blank last time.
    var now = __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_performanceNow___default()();
    if (this._anyBlankStartTime != null) {
      this._info.any_blank_ms += now - this._anyBlankStartTime;
    }
    this._anyBlankStartTime = null;
    if (this._mostlyBlankStartTime != null) {
      this._info.mostly_blank_ms += now - this._mostlyBlankStartTime;
    }
    this._mostlyBlankStartTime = null;

    var blankTop = 0;
    var first = state.first;
    var firstFrame = this._getFrameMetrics(first);
    while (first <= state.last && (!firstFrame || !firstFrame.inLayout)) {
      firstFrame = this._getFrameMetrics(first);
      first++;
    }
    // Only count blankTop if we aren't rendering the first item, otherwise we will count the header
    // as blank.
    if (firstFrame && first > 0) {
      blankTop = Math.min(visibleLength, Math.max(0, firstFrame.offset - offset));
    }
    var blankBottom = 0;
    var last = state.last;
    var lastFrame = this._getFrameMetrics(last);
    while (last >= state.first && (!lastFrame || !lastFrame.inLayout)) {
      lastFrame = this._getFrameMetrics(last);
      last--;
    }
    // Only count blankBottom if we aren't rendering the last item, otherwise we will count the
    // footer as blank.
    if (lastFrame && last < props.getItemCount(props.data) - 1) {
      var bottomEdge = lastFrame.offset + lastFrame.length;
      blankBottom = Math.min(visibleLength, Math.max(0, offset + visibleLength - bottomEdge));
    }
    var pixels_blank = Math.round(blankTop + blankBottom);
    var blankness = pixels_blank / visibleLength;
    if (blankness > 0) {
      this._anyBlankStartTime = now;
      this._info.any_blank_speed_sum += scrollSpeed;
      this._info.any_blank_count++;
      this._info.pixels_blank += pixels_blank;
      if (blankness > 0.5) {
        this._mostlyBlankStartTime = now;
        this._info.mostly_blank_count++;
      }
    } else if (scrollSpeed < 0.01 || Math.abs(dOffset) < 1) {
      this.deactivateAndFlush();
    }
    return blankness;
  };

  FillRateHelper.prototype.enabled = function enabled() {
    return this._enabled;
  };

  FillRateHelper.prototype._resetData = function _resetData() {
    this._anyBlankStartTime = null;
    this._info = new Info();
    this._mostlyBlankStartTime = null;
    this._samplesStartTime = null;
  };

  return FillRateHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (FillRateHelper);

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var performance = __webpack_require__(707);

var performanceNow;

/**
 * Detect if we can use `window.performance.now()` and gracefully fallback to
 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
 * because of Facebook's testing infrastructure.
 */
if (performance.now) {
  performanceNow = function performanceNow() {
    return performance.now();
  };
} else {
  performanceNow = function performanceNow() {
    return Date.now();
  };
}

module.exports = performanceNow;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var ExecutionEnvironment = __webpack_require__(24);

var performance;

if (ExecutionEnvironment.canUseDOM) {
  performance = window.performance || window.msPerformance || window.webkitPerformance;
}

module.exports = performance || {};

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 * @format
 */



/**
 * A Utility class for calculating viewable items based on current metrics like scroll position and
 * layout.
 *
 * An item is said to be in a "viewable" state when any of the following
 * is true for longer than `minimumViewTime` milliseconds (after an interaction if `waitForInteraction`
 * is true):
 *
 * - Occupying >= `viewAreaCoveragePercentThreshold` of the view area XOR fraction of the item
 *   visible in the view area >= `itemVisiblePercentThreshold`.
 * - Entirely visible on screen
 */
var ViewabilityHelper = function () {
  function ViewabilityHelper() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { viewAreaCoveragePercentThreshold: 0 };

    _classCallCheck(this, ViewabilityHelper);

    this._hasInteracted = false;
    this._timers = new Set();
    this._viewableIndices = [];
    this._viewableItems = new Map();

    this._config = config;
  }

  /**
   * Cleanup, e.g. on unmount. Clears any pending timers.
   */

  /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an error
   * found when Flow v0.63 was deployed. To see the error delete this comment
   * and run Flow. */


  ViewabilityHelper.prototype.dispose = function dispose() {
    this._timers.forEach(clearTimeout);
  };

  /**
   * Determines which items are viewable based on the current metrics and config.
   */


  ViewabilityHelper.prototype.computeViewableItems = function computeViewableItems(itemCount, scrollOffset, viewportHeight, getFrameMetrics, renderRange) {
    var _config = this._config,
        itemVisiblePercentThreshold = _config.itemVisiblePercentThreshold,
        viewAreaCoveragePercentThreshold = _config.viewAreaCoveragePercentThreshold;

    var viewAreaMode = viewAreaCoveragePercentThreshold != null;
    var viewablePercentThreshold = viewAreaMode ? viewAreaCoveragePercentThreshold : itemVisiblePercentThreshold;
    __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(viewablePercentThreshold != null && itemVisiblePercentThreshold != null !== (viewAreaCoveragePercentThreshold != null), 'Must set exactly one of itemVisiblePercentThreshold or viewAreaCoveragePercentThreshold');
    var viewableIndices = [];
    if (itemCount === 0) {
      return viewableIndices;
    }
    var firstVisible = -1;

    var _ref = renderRange || { first: 0, last: itemCount - 1 },
        first = _ref.first,
        last = _ref.last;

    __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(last < itemCount, 'Invalid render range ' + JSON.stringify({ renderRange: renderRange, itemCount: itemCount }));
    for (var idx = first; idx <= last; idx++) {
      var metrics = getFrameMetrics(idx);
      if (!metrics) {
        continue;
      }
      var top = metrics.offset - scrollOffset;
      var bottom = top + metrics.length;
      if (top < viewportHeight && bottom > 0) {
        firstVisible = idx;
        if (_isViewable(viewAreaMode, viewablePercentThreshold, top, bottom, viewportHeight, metrics.length)) {
          viewableIndices.push(idx);
        }
      } else if (firstVisible >= 0) {
        break;
      }
    }
    return viewableIndices;
  };

  /**
   * Figures out which items are viewable and how that has changed from before and calls
   * `onViewableItemsChanged` as appropriate.
   */


  ViewabilityHelper.prototype.onUpdate = function onUpdate(itemCount, scrollOffset, viewportHeight, getFrameMetrics, createViewToken, onViewableItemsChanged, renderRange) {
    var _this = this;

    if (this._config.waitForInteraction && !this._hasInteracted || itemCount === 0 || !getFrameMetrics(0)) {
      return;
    }
    var viewableIndices = [];
    if (itemCount) {
      viewableIndices = this.computeViewableItems(itemCount, scrollOffset, viewportHeight, getFrameMetrics, renderRange);
    }
    if (this._viewableIndices.length === viewableIndices.length && this._viewableIndices.every(function (v, ii) {
      return v === viewableIndices[ii];
    })) {
      // We might get a lot of scroll events where visibility doesn't change and we don't want to do
      // extra work in those cases.
      return;
    }
    this._viewableIndices = viewableIndices;
    if (this._config.minimumViewTime) {
      var handle = setTimeout(function () {
        _this._timers.delete(handle);
        _this._onUpdateSync(viewableIndices, onViewableItemsChanged, createViewToken);
      }, this._config.minimumViewTime);
      this._timers.add(handle);
    } else {
      this._onUpdateSync(viewableIndices, onViewableItemsChanged, createViewToken);
    }
  };

  /**
   * clean-up cached _viewableIndices to evaluate changed items on next update
   */


  ViewabilityHelper.prototype.resetViewableIndices = function resetViewableIndices() {
    this._viewableIndices = [];
  };

  /**
   * Records that an interaction has happened even if there has been no scroll.
   */


  ViewabilityHelper.prototype.recordInteraction = function recordInteraction() {
    this._hasInteracted = true;
  };

  ViewabilityHelper.prototype._onUpdateSync = function _onUpdateSync(viewableIndicesToCheck, onViewableItemsChanged, createViewToken) {
    var _this2 = this;

    // Filter out indices that have gone out of view since this call was scheduled.
    viewableIndicesToCheck = viewableIndicesToCheck.filter(function (ii) {
      return _this2._viewableIndices.includes(ii);
    });
    var prevItems = this._viewableItems;
    var nextItems = new Map(viewableIndicesToCheck.map(function (ii) {
      var viewable = createViewToken(ii, true);
      return [viewable.key, viewable];
    }));

    var changed = [];
    for (var _iterator = nextItems, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref3 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref3 = _i.value;
      }

      var _ref2 = _ref3;
      var _key = _ref2[0];
      var viewable = _ref2[1];

      if (!prevItems.has(_key)) {
        changed.push(viewable);
      }
    }
    for (var _iterator2 = prevItems, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref5 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref5 = _i2.value;
      }

      var _ref4 = _ref5;
      var _key2 = _ref4[0];
      var _viewable = _ref4[1];

      if (!nextItems.has(_key2)) {
        changed.push(Object.assign({}, _viewable, { isViewable: false }));
      }
    }
    if (changed.length > 0) {
      this._viewableItems = nextItems;
      onViewableItemsChanged({
        viewableItems: Array.from(nextItems.values()),
        changed: changed,
        viewabilityConfig: this._config
      });
    }
  };

  return ViewabilityHelper;
}();

function _isViewable(viewAreaMode, viewablePercentThreshold, top, bottom, viewportHeight, itemLength) {
  if (_isEntirelyVisible(top, bottom, viewportHeight)) {
    return true;
  } else {
    var pixels = _getPixelsVisible(top, bottom, viewportHeight);
    var percent = 100 * (viewAreaMode ? pixels / viewportHeight : pixels / itemLength);
    return percent >= viewablePercentThreshold;
  }
}

function _getPixelsVisible(top, bottom, viewportHeight) {
  var visibleHeight = Math.min(bottom, viewportHeight) - Math.max(top, 0);
  return Math.max(0, visibleHeight);
}

function _isEntirelyVisible(top, bottom, viewportHeight) {
  return top >= 0 && bottom <= viewportHeight && bottom > top;
}

/* harmony default export */ __webpack_exports__["a"] = (ViewabilityHelper);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return computeWindowedRenderLimits; });
/* unused harmony export elementsThatOverlapOffsets */
/* unused harmony export newRangeCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



/**
 * Used to find the indices of the frames that overlap the given offsets. Useful for finding the
 * items that bound different windows of content, such as the visible area or the buffered overscan
 * area.
 */
function elementsThatOverlapOffsets(offsets, itemCount, getFrameMetrics) {
  var out = [];
  var outLength = 0;
  for (var ii = 0; ii < itemCount; ii++) {
    var frame = getFrameMetrics(ii);
    var trailingOffset = frame.offset + frame.length;
    for (var kk = 0; kk < offsets.length; kk++) {
      if (out[kk] == null && trailingOffset >= offsets[kk]) {
        out[kk] = ii;
        outLength++;
        if (kk === offsets.length - 1) {
          __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_invariant___default()(outLength === offsets.length, 'bad offsets input, should be in increasing order: %s', JSON.stringify(offsets));
          return out;
        }
      }
    }
  }
  return out;
}

/**
 * Computes the number of elements in the `next` range that are new compared to the `prev` range.
 * Handy for calculating how many new items will be rendered when the render window changes so we
 * can restrict the number of new items render at once so that content can appear on the screen
 * faster.
 */
function newRangeCount(prev, next) {
  return next.last - next.first + 1 - Math.max(0, 1 + Math.min(next.last, prev.last) - Math.max(next.first, prev.first));
}

/**
 * Custom logic for determining which items should be rendered given the current frame and scroll
 * metrics, as well as the previous render state. The algorithm may evolve over time, but generally
 * prioritizes the visible area first, then expands that with overscan regions ahead and behind,
 * biased in the direction of scroll.
 */
function computeWindowedRenderLimits(props, prev, getFrameMetricsApprox, scrollMetrics) {
  var data = props.data,
      getItemCount = props.getItemCount,
      maxToRenderPerBatch = props.maxToRenderPerBatch,
      windowSize = props.windowSize;

  var itemCount = getItemCount(data);
  if (itemCount === 0) {
    return prev;
  }
  var offset = scrollMetrics.offset,
      velocity = scrollMetrics.velocity,
      visibleLength = scrollMetrics.visibleLength;

  // Start with visible area, then compute maximum overscan region by expanding from there, biased
  // in the direction of scroll. Total overscan area is capped, which should cap memory consumption
  // too.

  var visibleBegin = Math.max(0, offset);
  var visibleEnd = visibleBegin + visibleLength;
  var overscanLength = (windowSize - 1) * visibleLength;

  // Considering velocity seems to introduce more churn than it's worth.
  var leadFactor = 0.5; // Math.max(0, Math.min(1, velocity / 25 + 0.5));

  var fillPreference = velocity > 1 ? 'after' : velocity < -1 ? 'before' : 'none';

  var overscanBegin = Math.max(0, visibleBegin - (1 - leadFactor) * overscanLength);
  var overscanEnd = Math.max(0, visibleEnd + leadFactor * overscanLength);

  var lastItemOffset = getFrameMetricsApprox(itemCount - 1).offset;
  if (lastItemOffset < overscanBegin) {
    // Entire list is before our overscan window
    return {
      first: Math.max(0, itemCount - 1 - maxToRenderPerBatch),
      last: itemCount - 1
    };
  }

  // Find the indices that correspond to the items at the render boundaries we're targeting.

  var _elementsThatOverlapO = elementsThatOverlapOffsets([overscanBegin, visibleBegin, visibleEnd, overscanEnd], props.getItemCount(props.data), getFrameMetricsApprox),
      overscanFirst = _elementsThatOverlapO[0],
      first = _elementsThatOverlapO[1],
      last = _elementsThatOverlapO[2],
      overscanLast = _elementsThatOverlapO[3];

  overscanFirst = overscanFirst == null ? 0 : overscanFirst;
  first = first == null ? Math.max(0, overscanFirst) : first;
  overscanLast = overscanLast == null ? itemCount - 1 : overscanLast;
  last = last == null ? Math.min(overscanLast, first + maxToRenderPerBatch - 1) : last;
  var visible = { first: first, last: last };

  // We want to limit the number of new cells we're rendering per batch so that we can fill the
  // content on the screen quickly. If we rendered the entire overscan window at once, the user
  // could be staring at white space for a long time waiting for a bunch of offscreen content to
  // render.
  var newCellCount = newRangeCount(prev, visible);

  while (true) {
    if (first <= overscanFirst && last >= overscanLast) {
      // If we fill the entire overscan range, we're done.
      break;
    }
    var maxNewCells = newCellCount >= maxToRenderPerBatch;
    var firstWillAddMore = first <= prev.first || first > prev.last;
    var firstShouldIncrement = first > overscanFirst && (!maxNewCells || !firstWillAddMore);
    var lastWillAddMore = last >= prev.last || last < prev.first;
    var lastShouldIncrement = last < overscanLast && (!maxNewCells || !lastWillAddMore);
    if (maxNewCells && !firstShouldIncrement && !lastShouldIncrement) {
      // We only want to stop if we've hit maxNewCells AND we cannot increment first or last
      // without rendering new items. This let's us preserve as many already rendered items as
      // possible, reducing render churn and keeping the rendered overscan range as large as
      // possible.
      break;
    }
    if (firstShouldIncrement && !(fillPreference === 'after' && lastShouldIncrement && lastWillAddMore)) {
      if (firstWillAddMore) {
        newCellCount++;
      }
      first--;
    }
    if (lastShouldIncrement && !(fillPreference === 'before' && firstShouldIncrement && firstWillAddMore)) {
      if (lastWillAddMore) {
        newCellCount++;
      }
      last++;
    }
  }
  if (!(last >= first && first >= 0 && last < itemCount && first >= overscanFirst && last <= overscanLast && first <= visible.first && last >= visible.last)) {
    throw new Error('Bad window calculation ' + JSON.stringify({
      first: first,
      last: last,
      itemCount: itemCount,
      overscanFirst: overscanFirst,
      overscanLast: overscanLast,
      visible: visible
    }));
  }
  return { first: first, last: last };
}



var VirtualizeUtils = {
  computeWindowedRenderLimits: computeWindowedRenderLimits,
  elementsThatOverlapOffsets: elementsThatOverlapOffsets,
  newRangeCount: newRangeCount
};

/* unused harmony default export */ var _unused_webpack_default_export = (VirtualizeUtils);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


/**
 * Intentional info-level logging for clear separation from ad-hoc console debug logging.
 */

function infoLog() {
  var _console;

  return (_console = console).log.apply(_console, arguments);
}

/* harmony default export */ __webpack_exports__["a"] = (infoLog);

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_ensureComponentIsNative__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Image__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewPropTypes__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */







var emptyObject = {};

/**
 * Very simple drop-in replacement for <Image> which supports nesting views.
 */

var ImageBackground = function (_Component) {
  _inherits(ImageBackground, _Component);

  function ImageBackground() {
    var _temp, _this, _ret;

    _classCallCheck(this, ImageBackground);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._viewRef = null, _this._captureRef = function (ref) {
      _this._viewRef = ref;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ImageBackground.prototype.setNativeProps = function setNativeProps(props) {
    // Work-around flow
    var viewRef = this._viewRef;
    if (viewRef) {
      Object(__WEBPACK_IMPORTED_MODULE_0__modules_ensureComponentIsNative__["a" /* default */])(viewRef);
      viewRef.setNativeProps(props);
    }
  };

  ImageBackground.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        style = _props.style,
        imageStyle = _props.imageStyle,
        imageRef = _props.imageRef,
        props = _objectWithoutProperties(_props, ['children', 'style', 'imageStyle', 'imageRef']);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__View__["a" /* default */],
      { ref: this._captureRef, style: style },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Image__["a" /* default */], _extends({}, props, {
        ref: imageRef,
        style: [__WEBPACK_IMPORTED_MODULE_2__StyleSheet__["a" /* default */].absoluteFill, {
          // Temporary Workaround:
          // Current (imperfect yet) implementation of <Image> overwrites width and height styles
          // (which is not quite correct), and these styles conflict with explicitly set styles
          // of <ImageBackground> and with our internal layout model here.
          // So, we have to proxy/reapply these styles explicitly for actual <Image> component.
          // This workaround should be removed after implementing proper support of
          // intrinsic content size of the <Image>.
          width: style.width,
          height: style.height,
          zIndex: -1
        }, imageStyle]
      })),
      children
    );
  };

  return ImageBackground;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

ImageBackground.defaultProps = {
  style: emptyObject
};
ImageBackground.propTypes =  false ? Object.assign({}, Image.propTypes, {
  imageStyle: Image.propTypes.style,
  style: ViewPropTypes.style
}) : {};


/* harmony default export */ __webpack_exports__["a"] = (ImageBackground);

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewPropTypes__ = __webpack_require__(27);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2017-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */






var KeyboardAvoidingView = function (_Component) {
  _inherits(KeyboardAvoidingView, _Component);

  function KeyboardAvoidingView() {
    var _temp, _this, _ret;

    _classCallCheck(this, KeyboardAvoidingView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.frame = null, _this.onLayout = function (event) {
      _this.frame = event.nativeEvent.layout;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  KeyboardAvoidingView.prototype.relativeKeyboardHeight = function relativeKeyboardHeight(keyboardFrame) {
    var frame = this.frame;
    if (!frame || !keyboardFrame) {
      return 0;
    }
    var keyboardY = keyboardFrame.screenY - this.props.keyboardVerticalOffset;
    return Math.max(frame.y + frame.height - keyboardY, 0);
  };

  KeyboardAvoidingView.prototype.onKeyboardChange = function onKeyboardChange(event) {};

  KeyboardAvoidingView.prototype.render = function render() {
    var _props = this.props,
        behavior = _props.behavior,
        contentContainerStyle = _props.contentContainerStyle,
        keyboardVerticalOffset = _props.keyboardVerticalOffset,
        rest = _objectWithoutProperties(_props, ['behavior', 'contentContainerStyle', 'keyboardVerticalOffset']);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__View__["a" /* default */], _extends({ onLayout: this.onLayout }, rest));
  };

  return KeyboardAvoidingView;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

KeyboardAvoidingView.defaultProps = {
  keyboardVerticalOffset: 0
};
KeyboardAvoidingView.propTypes =  false ? Object.assign({}, ViewPropTypes, {
  behavior: oneOf(['height', 'padding', 'position']),
  contentContainerStyle: ViewPropTypes.style,
  keyboardVerticalOffset: number.isRequired
}) : {};


/* harmony default export */ __webpack_exports__["a"] = (KeyboardAvoidingView);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_ListView__ = __webpack_require__(310);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__vendor_react_native_ListView__["a" /* default */]);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




/**
 * Renders static content efficiently by allowing React to short-circuit the
 * reconciliation process. This component should be used when you know that a
 * subtree of components will never need to be updated.
 *
 *   const someValue = ...; // We know for certain this value will never change.
 *   return (
 *     <StaticRenderer render={() => <MyComponent value={someValue} />} />
 *   );
 *
 * Typically, you will not need to use this component and should opt for normal
 * React reconciliation.
 */

var StaticRenderer = function (_Component) {
  _inherits(StaticRenderer, _Component);

  function StaticRenderer() {
    _classCallCheck(this, StaticRenderer);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StaticRenderer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.shouldUpdate;
  };

  StaticRenderer.prototype.render = function render() {
    return this.props.render();
  };

  return StaticRenderer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaticRenderer);
StaticRenderer.propTypes =  false ? {
  render: func.isRequired,
  shouldUpdate: bool.isRequired
} : {};

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);




var __DEV__ = "production" !== 'production';

function cloneReferencedElement(element, config) {
  var cloneRef = config.ref;
  var originalRef = element.ref;

  for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  if (originalRef == null || cloneRef == null) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement.apply(__WEBPACK_IMPORTED_MODULE_0_react___default.a, [element, config].concat(children));
  }

  if (typeof originalRef !== 'function') {
    if (__DEV__) {
      console.warn('Cloning an element with a ref that will be overwritten because it ' + 'is not a function. Use a composable callback-style ref instead. ' + 'Ignoring ref: ' + originalRef);
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement.apply(__WEBPACK_IMPORTED_MODULE_0_react___default.a, [element, config].concat(children));
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement.apply(__WEBPACK_IMPORTED_MODULE_0_react___default.a, [element, Object.assign({}, config, {
    ref: function ref(component) {
      cloneRef(component);
      originalRef(component);
    }
  })].concat(children));
}

/* harmony default export */ __webpack_exports__["a"] = (cloneReferencedElement);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__ = __webpack_require__(78);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */]);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColorPropType__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createElement__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var PickerItem = function (_Component) {
  _inherits(PickerItem, _Component);

  function PickerItem() {
    _classCallCheck(this, PickerItem);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  PickerItem.prototype.render = function render() {
    var _props = this.props,
        color = _props.color,
        label = _props.label,
        testID = _props.testID,
        value = _props.value;

    var style = { color: color };
    return Object(__WEBPACK_IMPORTED_MODULE_2__createElement__["a" /* default */])('option', { style: style, testID: testID, value: value }, label);
  };

  return PickerItem;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PickerItem);
PickerItem.propTypes =  false ? {
  color: ColorPropType,
  label: string.isRequired,
  testID: string,
  value: oneOfType([number, string])
} : {};

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(313);
/**
 * Copyright (c) 2017-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var PickerItemPropType = function PickerItemPropType(props, propName, componentName) {
  var prop = props[propName];
  var error = null;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(prop, function (child) {
    if (child.type !== __WEBPACK_IMPORTED_MODULE_1____["a" /* default */].Item) {
      error = new Error('`Picker` children must be of type `Picker.Item`.');
    }
  });
  return error;
};

/* unused harmony default export */ var _unused_webpack_default_export = (PickerItemPropType);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColorPropType__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__View_ViewStylePropTypes__ = __webpack_require__(103);
/**
 * Copyright (c) 2017-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var PickerStylePropTypes = Object.assign({}, __WEBPACK_IMPORTED_MODULE_1__View_ViewStylePropTypes__["a" /* default */], {
  color: __WEBPACK_IMPORTED_MODULE_0__ColorPropType__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (PickerStylePropTypes);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_applyNativeMethods__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColorPropType__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewPropTypes__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */









var ProgressBar = function (_Component) {
  _inherits(ProgressBar, _Component);

  function ProgressBar() {
    var _temp, _this, _ret;

    _classCallCheck(this, ProgressBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._setProgressRef = function (element) {
      _this._progressElement = element;
    }, _this._updateProgressWidth = function () {
      var _this$props = _this.props,
          indeterminate = _this$props.indeterminate,
          progress = _this$props.progress;

      var percentageProgress = indeterminate ? 50 : progress * 100;
      var width = indeterminate ? '25%' : percentageProgress + '%';
      if (_this._progressElement) {
        _this._progressElement.setNativeProps({
          style: { width: width }
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ProgressBar.prototype.componentDidMount = function componentDidMount() {
    this._updateProgressWidth();
  };

  ProgressBar.prototype.componentDidUpdate = function componentDidUpdate() {
    this._updateProgressWidth();
  };

  ProgressBar.prototype.render = function render() {
    var _props = this.props,
        color = _props.color,
        indeterminate = _props.indeterminate,
        progress = _props.progress,
        trackColor = _props.trackColor,
        style = _props.style,
        other = _objectWithoutProperties(_props, ['color', 'indeterminate', 'progress', 'trackColor', 'style']);

    var percentageProgress = progress * 100;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__View__["a" /* default */],
      _extends({}, other, {
        accessibilityRole: 'progressbar',
        'aria-valuemax': '100',
        'aria-valuemin': '0',
        'aria-valuenow': indeterminate ? null : percentageProgress,
        style: [styles.track, style, { backgroundColor: trackColor }]
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__View__["a" /* default */], {
        ref: this._setProgressRef,
        style: [styles.progress, indeterminate && styles.animation, { backgroundColor: color }]
      })
    );
  };

  return ProgressBar;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

ProgressBar.displayName = 'ProgressBar';
ProgressBar.defaultProps = {
  color: '#1976D2',
  indeterminate: false,
  progress: 0,
  trackColor: 'transparent'
};
ProgressBar.propTypes =  false ? Object.assign({}, ViewPropTypes, {
  color: ColorPropType,
  indeterminate: bool,
  progress: number,
  trackColor: ColorPropType
}) : {};


var styles = __WEBPACK_IMPORTED_MODULE_2__StyleSheet__["a" /* default */].create({
  track: {
    height: 5,
    overflow: 'hidden',
    userSelect: 'none',
    zIndex: 0
  },
  progress: {
    height: '100%',
    zIndex: -1
  },
  animation: {
    animationDuration: '1s',
    animationName: [{
      '0%': { transform: [{ translateX: '-100%' }] },
      '100%': { transform: [{ translateX: '400%' }] }
    }],
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__modules_applyNativeMethods__["a" /* default */])(ProgressBar));

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewPropTypes__ = __webpack_require__(27);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */






var SafeAreaView = function (_React$Component) {
  _inherits(SafeAreaView, _React$Component);

  function SafeAreaView() {
    _classCallCheck(this, SafeAreaView);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  SafeAreaView.prototype.render = function render() {
    var _props = this.props,
        style = _props.style,
        rest = _objectWithoutProperties(_props, ['style']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__View__["a" /* default */], _extends({}, rest, { style: __WEBPACK_IMPORTED_MODULE_1__StyleSheet__["a" /* default */].compose(styles.root, style) }));
  };

  return SafeAreaView;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SafeAreaView.displayName = 'SafeAreaView';
SafeAreaView.propTypes =  false ? Object.assign({}, ViewPropTypes) : {};


var styles = __WEBPACK_IMPORTED_MODULE_1__StyleSheet__["a" /* default */].create({
  root: {
    paddingTop: 'env(safe-area-inset-top)',
    paddingRight: 'env(safe-area-inset-right)',
    paddingBottom: 'env(safe-area-inset-bottom)',
    paddingLeft: 'env(safe-area-inset-left)'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SafeAreaView);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_SectionList__ = __webpack_require__(723);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__vendor_react_native_SectionList__["a" /* default */]);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports_Platform__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__exports_ScrollView__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VirtualizedSectionList__ = __webpack_require__(724);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 * @format
 */







var defaultProps = Object.assign({}, __WEBPACK_IMPORTED_MODULE_4__VirtualizedSectionList__["a" /* default */].defaultProps, {
  stickySectionHeadersEnabled: __WEBPACK_IMPORTED_MODULE_1__exports_Platform__["a" /* default */].OS === 'ios'
});

/**
 * A performant interface for rendering sectioned lists, supporting the most handy features:
 *
 *  - Fully cross-platform.
 *  - Configurable viewability callbacks.
 *  - List header support.
 *  - List footer support.
 *  - Item separator support.
 *  - Section header support.
 *  - Section separator support.
 *  - Heterogeneous data and item rendering support.
 *  - Pull to Refresh.
 *  - Scroll loading.
 *
 * If you don't need section support and want a simpler interface, use
 * [`<FlatList>`](/react-native/docs/flatlist.html).
 *
 * Simple Examples:
 *
 *     <SectionList
 *       renderItem={({item}) => <ListItem title={item} />}
 *       renderSectionHeader={({section}) => <Header title={section.title} />}
 *       sections={[ // homogeneous rendering between sections
 *         {data: [...], title: ...},
 *         {data: [...], title: ...},
 *         {data: [...], title: ...},
 *       ]}
 *     />
 *
 *     <SectionList
 *       sections={[ // heterogeneous rendering between sections
 *         {data: [...], renderItem: ...},
 *         {data: [...], renderItem: ...},
 *         {data: [...], renderItem: ...},
 *       ]}
 *     />
 *
 * This is a convenience wrapper around [`<VirtualizedList>`](docs/virtualizedlist.html),
 * and thus inherits its props (as well as those of `ScrollView`) that aren't explicitly listed
 * here, along with the following caveats:
 *
 * - Internal state is not preserved when content scrolls out of the render window. Make sure all
 *   your data is captured in the item data or external stores like Flux, Redux, or Relay.
 * - This is a `PureComponent` which means that it will not re-render if `props` remain shallow-
 *   equal. Make sure that everything your `renderItem` function depends on is passed as a prop
 *   (e.g. `extraData`) that is not `===` after updates, otherwise your UI may not update on
 *   changes. This includes the `data` prop and parent component state.
 * - In order to constrain memory and enable smooth scrolling, content is rendered asynchronously
 *   offscreen. This means it's possible to scroll faster than the fill rate and momentarily see
 *   blank content. This is a tradeoff that can be adjusted to suit the needs of each application,
 *   and we are working on improving it behind the scenes.
 * - By default, the list looks for a `key` prop on each item and uses that for the React key.
 *   Alternatively, you can provide a custom `keyExtractor` prop.
 *
 */
var SectionList = function (_React$PureComponent) {
  _inherits(SectionList, _React$PureComponent);

  function SectionList() {
    var _temp, _this, _ret;

    _classCallCheck(this, SectionList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._captureRef = function (ref) {
      /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
       * suppresses an error when upgrading Flow's support for React. To see the
       * error delete this comment and run Flow. */
      _this._wrapperListRef = ref;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Scrolls to the item at the specified `sectionIndex` and `itemIndex` (within the section)
   * positioned in the viewable area such that `viewPosition` 0 places it at the top (and may be
   * covered by a sticky header), 1 at the bottom, and 0.5 centered in the middle. `viewOffset` is a
   * fixed number of pixels to offset the final target position, e.g. to compensate for sticky
   * headers.
   *
   * Note: cannot scroll to locations outside the render window without specifying the
   * `getItemLayout` prop.
   */
  SectionList.prototype.scrollToLocation = function scrollToLocation(params) {
    this._wrapperListRef.scrollToLocation(params);
  };

  /**
   * Tells the list an interaction has occurred, which should trigger viewability calculations, e.g.
   * if `waitForInteractions` is true and the user has not scrolled. This is typically called by
   * taps on items or by navigation actions.
   */


  SectionList.prototype.recordInteraction = function recordInteraction() {
    var listRef = this._wrapperListRef && this._wrapperListRef.getListRef();
    listRef && listRef.recordInteraction();
  };

  /**
   * Displays the scroll indicators momentarily.
   *
   * @platform ios
   */


  SectionList.prototype.flashScrollIndicators = function flashScrollIndicators() {
    var listRef = this._wrapperListRef && this._wrapperListRef.getListRef();
    listRef && listRef.flashScrollIndicators();
  };

  /**
   * Provides a handle to the underlying scroll responder.
   */


  SectionList.prototype.getScrollResponder = function getScrollResponder() {
    var listRef = this._wrapperListRef && this._wrapperListRef.getListRef();
    if (listRef) {
      return listRef.getScrollResponder();
    }
  };

  SectionList.prototype.getScrollableNode = function getScrollableNode() {
    var listRef = this._wrapperListRef && this._wrapperListRef.getListRef();
    if (listRef) {
      return listRef.getScrollableNode();
    }
  };

  SectionList.prototype.setNativeProps = function setNativeProps(props) {
    var listRef = this._wrapperListRef && this._wrapperListRef.getListRef();
    if (listRef) {
      listRef.setNativeProps(props);
    }
  };

  SectionList.prototype.render = function render() {
    var List = this.props.legacyImplementation ? __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_4__VirtualizedSectionList__["a" /* default */];
    /* $FlowFixMe(>=0.66.0 site=react_native_fb) This comment suppresses an
     * error found when Flow v0.66 was deployed. To see the error delete this
     * comment and run Flow. */
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(List, _extends({}, this.props, { ref: this._captureRef }));
  };

  return SectionList;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.PureComponent);

SectionList.defaultProps = defaultProps;


/* harmony default export */ __webpack_exports__["a"] = (SectionList);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports_View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualizedList__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 * @format
 */






/**
 * Right now this just flattens everything into one list and uses VirtualizedList under the
 * hood. The only operation that might not scale well is concatting the data arrays of all the
 * sections when new props are received, which should be plenty fast for up to ~10,000 items.
 */
var VirtualizedSectionList = function (_React$PureComponent) {
  _inherits(VirtualizedSectionList, _React$PureComponent);

  VirtualizedSectionList.prototype.scrollToLocation = function scrollToLocation(params) {
    var index = params.itemIndex + 1;
    for (var ii = 0; ii < params.sectionIndex; ii++) {
      index += this.props.sections[ii].data.length + 2;
    }
    var toIndexParams = Object.assign({}, params, {
      index: index
    });
    this._listRef.scrollToIndex(toIndexParams);
  };

  VirtualizedSectionList.prototype.getListRef = function getListRef() {
    return this._listRef;
  };

  VirtualizedSectionList.prototype._subExtractor = function _subExtractor(index) {
    var itemIndex = index;
    var defaultKeyExtractor = this.props.keyExtractor;
    for (var ii = 0; ii < this.props.sections.length; ii++) {
      var _section = this.props.sections[ii];
      var _key = _section.key || String(ii);
      itemIndex -= 1; // The section adds an item for the header
      if (itemIndex >= _section.data.length + 1) {
        itemIndex -= _section.data.length + 1; // The section adds an item for the footer.
      } else if (itemIndex === -1) {
        return {
          section: _section,
          key: _key + ':header',
          index: null,
          header: true,
          trailingSection: this.props.sections[ii + 1]
        };
      } else if (itemIndex === _section.data.length) {
        return {
          section: _section,
          key: _key + ':footer',
          index: null,
          header: false,
          trailingSection: this.props.sections[ii + 1]
        };
      } else {
        var _keyExtractor = _section.keyExtractor || defaultKeyExtractor;
        return {
          section: _section,
          key: _key + ':' + _keyExtractor(_section.data[itemIndex], itemIndex),
          index: itemIndex,
          leadingItem: _section.data[itemIndex - 1],
          leadingSection: this.props.sections[ii - 1],
          trailingItem: _section.data[itemIndex + 1],
          trailingSection: this.props.sections[ii + 1]
        };
      }
    }
  };

  VirtualizedSectionList.prototype._getSeparatorComponent = function _getSeparatorComponent(index, info) {
    info = info || this._subExtractor(index);
    if (!info) {
      return null;
    }
    var ItemSeparatorComponent = info.section.ItemSeparatorComponent || this.props.ItemSeparatorComponent;
    var SectionSeparatorComponent = this.props.SectionSeparatorComponent;

    var isLastItemInList = index === this.state.childProps.getItemCount() - 1;
    var isLastItemInSection = info.index === info.section.data.length - 1;
    if (SectionSeparatorComponent && isLastItemInSection) {
      return SectionSeparatorComponent;
    }
    if (ItemSeparatorComponent && !isLastItemInSection && !isLastItemInList) {
      return ItemSeparatorComponent;
    }
    return null;
  };

  VirtualizedSectionList.prototype._computeState = function _computeState(props) {
    var offset = props.ListHeaderComponent ? 1 : 0;
    var stickyHeaderIndices = [];
    var itemCount = props.sections.reduce(function (v, section) {
      stickyHeaderIndices.push(v + offset);
      return v + section.data.length + 2; // Add two for the section header and footer.
    }, 0);

    return {
      childProps: Object.assign({}, props, {
        renderItem: this._renderItem,
        ItemSeparatorComponent: undefined, // Rendered with renderItem
        data: props.sections,
        getItemCount: function getItemCount() {
          return itemCount;
        },
        getItem: getItem,
        keyExtractor: this._keyExtractor,
        onViewableItemsChanged: props.onViewableItemsChanged ? this._onViewableItemsChanged : undefined,
        stickyHeaderIndices: props.stickySectionHeadersEnabled ? stickyHeaderIndices : undefined
      })
    };
  };

  function VirtualizedSectionList(props, context) {
    _classCallCheck(this, VirtualizedSectionList);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));

    _this._keyExtractor = function (item, index) {
      var info = _this._subExtractor(index);
      return info && info.key || String(index);
    };

    _this._convertViewable = function (viewable) {
      __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(viewable.index != null, 'Received a broken ViewToken');
      var info = _this._subExtractor(viewable.index);
      if (!info) {
        return null;
      }
      var keyExtractor = info.section.keyExtractor || _this.props.keyExtractor;
      return Object.assign({}, viewable, {
        index: info.index,
        /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
         * error found when Flow v0.63 was deployed. To see the error delete this
         * comment and run Flow. */
        key: keyExtractor(viewable.item, info.index),
        section: info.section
      });
    };

    _this._onViewableItemsChanged = function (_ref) {
      var viewableItems = _ref.viewableItems,
          changed = _ref.changed;

      if (_this.props.onViewableItemsChanged) {
        _this.props.onViewableItemsChanged({
          viewableItems: viewableItems.map(_this._convertViewable, _this).filter(Boolean),
          changed: changed.map(_this._convertViewable, _this).filter(Boolean)
        });
      }
    };

    _this._renderItem = function (_ref2) {
      var item = _ref2.item,
          index = _ref2.index;

      var info = _this._subExtractor(index);
      if (!info) {
        return null;
      }
      var infoIndex = info.index;
      if (infoIndex == null) {
        var _section2 = info.section;

        if (info.header === true) {
          var _renderSectionHeader = _this.props.renderSectionHeader;

          return _renderSectionHeader ? _renderSectionHeader({ section: _section2 }) : null;
        } else {
          var _renderSectionFooter = _this.props.renderSectionFooter;

          return _renderSectionFooter ? _renderSectionFooter({ section: _section2 }) : null;
        }
      } else {
        var _renderItem = info.section.renderItem || _this.props.renderItem;
        var _SeparatorComponent = _this._getSeparatorComponent(index, info);
        __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default()(_renderItem, 'no renderItem!');
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemWithSeparator, {
          SeparatorComponent: _SeparatorComponent,
          LeadingSeparatorComponent: infoIndex === 0 ? _this.props.SectionSeparatorComponent : undefined,
          cellKey: info.key,
          index: infoIndex,
          item: item,
          leadingItem: info.leadingItem,
          leadingSection: info.leadingSection,
          onUpdateSeparator: _this._onUpdateSeparator,
          prevCellKey: (_this._subExtractor(index - 1) || {}).key,
          ref: function ref(_ref3) {
            _this._cellRefs[info.key] = _ref3;
          },
          renderItem: _renderItem,
          section: info.section,
          trailingItem: info.trailingItem,
          trailingSection: info.trailingSection
        });
      }
    };

    _this._onUpdateSeparator = function (key, newProps) {
      var ref = _this._cellRefs[key];
      ref && ref.updateSeparatorProps(newProps);
    };

    _this._cellRefs = {};

    _this._captureRef = function (ref) {
      /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
       * suppresses an error when upgrading Flow's support for React. To see the
       * error delete this comment and run Flow. */
      _this._listRef = ref;
    };

    _this.state = _this._computeState(props);
    return _this;
  }

  VirtualizedSectionList.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(this._computeState(nextProps));
  };

  VirtualizedSectionList.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__VirtualizedList__["a" /* default */], _extends({}, this.state.childProps, { ref: this._captureRef }));
  };

  return VirtualizedSectionList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

VirtualizedSectionList.defaultProps = Object.assign({}, __WEBPACK_IMPORTED_MODULE_2__VirtualizedList__["a" /* default */].defaultProps, {
  data: []
});

var ItemWithSeparator = function (_React$Component) {
  _inherits(ItemWithSeparator, _React$Component);

  function ItemWithSeparator() {
    var _temp, _this2, _ret;

    _classCallCheck(this, ItemWithSeparator);

    for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this2), _this2.state = {
      separatorProps: {
        highlighted: false,
        leadingItem: _this2.props.item,
        leadingSection: _this2.props.leadingSection,
        section: _this2.props.section,
        trailingItem: _this2.props.trailingItem,
        trailingSection: _this2.props.trailingSection
      },
      leadingSeparatorProps: {
        highlighted: false,
        leadingItem: _this2.props.leadingItem,
        leadingSection: _this2.props.leadingSection,
        section: _this2.props.section,
        trailingItem: _this2.props.item,
        trailingSection: _this2.props.trailingSection
      }
    }, _this2._separators = {
      highlight: function highlight() {
        ['leading', 'trailing'].forEach(function (s) {
          return _this2._separators.updateProps(s, { highlighted: true });
        });
      },
      unhighlight: function unhighlight() {
        ['leading', 'trailing'].forEach(function (s) {
          return _this2._separators.updateProps(s, { highlighted: false });
        });
      },
      updateProps: function updateProps(select, newProps) {
        var _this2$props = _this2.props,
            LeadingSeparatorComponent = _this2$props.LeadingSeparatorComponent,
            cellKey = _this2$props.cellKey,
            prevCellKey = _this2$props.prevCellKey;

        if (select === 'leading' && LeadingSeparatorComponent) {
          _this2.setState(function (state) {
            return {
              leadingSeparatorProps: Object.assign({}, state.leadingSeparatorProps, newProps)
            };
          });
        } else {
          _this2.props.onUpdateSeparator(select === 'leading' && prevCellKey || cellKey, newProps);
        }
      }
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  ItemWithSeparator.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(props) {
    var _this3 = this;

    this.setState(function (state) {
      return {
        separatorProps: Object.assign({}, _this3.state.separatorProps, {
          leadingItem: props.item,
          leadingSection: props.leadingSection,
          section: props.section,
          trailingItem: props.trailingItem,
          trailingSection: props.trailingSection
        }),
        leadingSeparatorProps: Object.assign({}, _this3.state.leadingSeparatorProps, {
          leadingItem: props.leadingItem,
          leadingSection: props.leadingSection,
          section: props.section,
          trailingItem: props.item,
          trailingSection: props.trailingSection
        })
      };
    });
  };

  ItemWithSeparator.prototype.updateSeparatorProps = function updateSeparatorProps(newProps) {
    this.setState(function (state) {
      return {
        separatorProps: Object.assign({}, state.separatorProps, newProps)
      };
    });
  };

  ItemWithSeparator.prototype.render = function render() {
    var _props = this.props,
        LeadingSeparatorComponent = _props.LeadingSeparatorComponent,
        SeparatorComponent = _props.SeparatorComponent,
        item = _props.item,
        index = _props.index,
        section = _props.section;

    var element = this.props.renderItem({
      item: item,
      index: index,
      section: section,
      separators: this._separators
    });
    var leadingSeparator = LeadingSeparatorComponent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LeadingSeparatorComponent, this.state.leadingSeparatorProps);
    var separator = SeparatorComponent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SeparatorComponent, this.state.separatorProps);
    return leadingSeparator || separator ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__exports_View__["a" /* default */],
      null,
      leadingSeparator,
      element,
      separator
    ) : element;
  };

  return ItemWithSeparator;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

function getItem(sections, index) {
  if (!sections) {
    return null;
  }
  var itemIdx = index - 1;
  for (var ii = 0; ii < sections.length; ii++) {
    if (itemIdx === -1 || itemIdx === sections[ii].data.length) {
      // We intend for there to be overflow by one on both ends of the list.
      // This will be for headers and footers. When returning a header or footer
      // item the section itself is the item.
      return sections[ii];
    } else if (itemIdx < sections[ii].data.length) {
      // If we are in the bounds of the list's data then return the item.
      return sections[ii].data[itemIdx];
    } else {
      itemIdx -= sections[ii].data.length + 2; // Add two for the header and footer
    }
  }
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (VirtualizedSectionList);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__ = __webpack_require__(78);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */]);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var StatusBar = function (_Component) {
  _inherits(StatusBar, _Component);

  function StatusBar() {
    _classCallCheck(this, StatusBar);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StatusBar.setBackgroundColor = function setBackgroundColor() {};

  StatusBar.setBarStyle = function setBarStyle() {};

  StatusBar.setHidden = function setHidden() {};

  StatusBar.setNetworkActivityIndicatorVisible = function setNetworkActivityIndicatorVisible() {};

  StatusBar.setTranslucent = function setTranslucent() {};

  StatusBar.prototype.render = function render() {
    return null;
  };

  return StatusBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StatusBar);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_SwipeableFlatList__ = __webpack_require__(728);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__vendor_react_native_SwipeableFlatList__["a" /* default */]);

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SwipeableRow__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FlatList__ = __webpack_require__(307);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule SwipeableFlatList
 * @noflow
 * @format
 */


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * A container component that renders multiple SwipeableRow's in a FlatList
 * implementation. This is designed to be a drop-in replacement for the
 * standard React Native `FlatList`, so use it as if it were a FlatList, but
 * with extra props, i.e.
 *
 * <SwipeableListView renderRow={..} renderQuickActions={..} {..FlatList props} />
 *
 * SwipeableRow can be used independently of this component, but the main
 * benefit of using this component is
 *
 * - It ensures that at most 1 row is swiped open (auto closes others)
 * - It can bounce the 1st row of the list so users know it's swipeable
 * - Increase performance on iOS by locking list swiping when row swiping is occurring
 * - More to come
 */

var SwipeableFlatList = function (_React$Component) {
  _inherits(SwipeableFlatList, _React$Component);

  function SwipeableFlatList(props, context) {
    _classCallCheck(this, SwipeableFlatList);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this._flatListRef = null;
    _this._shouldBounceFirstRowOnMount = false;

    _this._onScroll = function (e) {
      // Close any opens rows on ListView scroll
      if (_this.state.openRowKey) {
        _this.setState({
          openRowKey: null
        });
      }

      _this.props.onScroll && _this.props.onScroll(e);
    };

    _this._renderItem = function (info) {
      var slideoutView = _this.props.renderQuickActions(info);
      var key = _this.props.keyExtractor(info.item, info.index);

      // If renderQuickActions is unspecified or returns falsey, don't allow swipe
      if (!slideoutView) {
        return _this.props.renderItem(info);
      }

      var shouldBounceOnMount = false;
      if (_this._shouldBounceFirstRowOnMount) {
        _this._shouldBounceFirstRowOnMount = false;
        shouldBounceOnMount = true;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__SwipeableRow__["a" /* default */],
        {
          slideoutView: slideoutView,
          isOpen: key === _this.state.openRowKey,
          maxSwipeDistance: _this._getMaxSwipeDistance(info),
          onOpen: function onOpen() {
            return _this._onOpen(key);
          },
          onClose: function onClose() {
            return _this._onClose(key);
          },
          shouldBounceOnMount: shouldBounceOnMount,
          onSwipeEnd: _this._setListViewScrollable,
          onSwipeStart: _this._setListViewNotScrollable },
        _this.props.renderItem(info)
      );
    };

    _this._setListViewScrollable = function () {
      _this._setListViewScrollableTo(true);
    };

    _this._setListViewNotScrollable = function () {
      _this._setListViewScrollableTo(false);
    };

    _this.state = {
      openRowKey: null
    };

    _this._shouldBounceFirstRowOnMount = _this.props.bounceFirstRowOnMount;
    return _this;
  }

  SwipeableFlatList.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FlatList__["a" /* default */], _extends({}, this.props, {
      ref: function ref(_ref) {
        _this2._flatListRef = _ref;
      },
      onScroll: this._onScroll,
      renderItem: this._renderItem
    }));
  };

  // This enables rows having variable width slideoutView.
  SwipeableFlatList.prototype._getMaxSwipeDistance = function _getMaxSwipeDistance(info) {
    if (typeof this.props.maxSwipeDistance === 'function') {
      return this.props.maxSwipeDistance(info);
    }

    return this.props.maxSwipeDistance;
  };

  SwipeableFlatList.prototype._setListViewScrollableTo = function _setListViewScrollableTo(value) {
    if (this._flatListRef) {
      this._flatListRef.setNativeProps({
        scrollEnabled: value
      });
    }
  };

  SwipeableFlatList.prototype._onOpen = function _onOpen(key) {
    this.setState({
      openRowKey: key
    });
  };

  SwipeableFlatList.prototype._onClose = function _onClose(key) {
    this.setState({
      openRowKey: null
    });
  };

  return SwipeableFlatList;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

SwipeableFlatList.defaultProps = Object.assign({}, __WEBPACK_IMPORTED_MODULE_3__FlatList__["a" /* default */].defaultProps, {
  bounceFirstRowOnMount: true,
  renderQuickActions: function renderQuickActions() {
    return null;
  }
});
SwipeableFlatList.propTypes =  false ? Object.assign({}, FlatList.propTypes, {

  /**
   * To alert the user that swiping is possible, the first row can bounce
   * on component mount.
   */
  bounceFirstRowOnMount: PropTypes.bool.isRequired,

  // Maximum distance to open to after a swipe
  maxSwipeDistance: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,

  // Callback method to render the view that will be unveiled on swipe
  renderQuickActions: PropTypes.func.isRequired
}) : {};


/* harmony default export */ __webpack_exports__["a"] = (SwipeableFlatList);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_SwipeableListView__ = __webpack_require__(730);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__vendor_react_native_SwipeableListView__["a" /* default */]);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListView__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SwipeableListViewDataSource__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SwipeableRow__ = __webpack_require__(314);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule SwipeableListView
 * @noflow
 */


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * A container component that renders multiple SwipeableRow's in a ListView
 * implementation. This is designed to be a drop-in replacement for the
 * standard React Native `ListView`, so use it as if it were a ListView, but
 * with extra props, i.e.
 *
 * let ds = SwipeableListView.getNewDataSource();
 * ds.cloneWithRowsAndSections(dataBlob, ?sectionIDs, ?rowIDs);
 * // ..
 * <SwipeableListView renderRow={..} renderQuickActions={..} {..ListView props} />
 *
 * SwipeableRow can be used independently of this component, but the main
 * benefit of using this component is
 *
 * - It ensures that at most 1 row is swiped open (auto closes others)
 * - It can bounce the 1st row of the list so users know it's swipeable
 * - More to come
 */
var SwipeableListView = function (_React$Component) {
  _inherits(SwipeableListView, _React$Component);

  SwipeableListView.getNewDataSource = function getNewDataSource() {
    return new __WEBPACK_IMPORTED_MODULE_3__SwipeableListViewDataSource__["a" /* default */]({
      getRowData: function getRowData(data, sectionID, rowID) {
        return data[sectionID][rowID];
      },
      getSectionHeaderData: function getSectionHeaderData(data, sectionID) {
        return data[sectionID];
      },
      rowHasChanged: function rowHasChanged(row1, row2) {
        return row1 !== row2;
      },
      sectionHeaderHasChanged: function sectionHeaderHasChanged(s1, s2) {
        return s1 !== s2;
      }
    });
  };

  function SwipeableListView(props, context) {
    _classCallCheck(this, SwipeableListView);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this._listViewRef = null;
    _this._shouldBounceFirstRowOnMount = false;

    _this._onScroll = function (e) {
      // Close any opens rows on ListView scroll
      if (_this.props.dataSource.getOpenRowID()) {
        _this.setState({
          dataSource: _this.state.dataSource.setOpenRowID(null)
        });
      }
      _this.props.onScroll && _this.props.onScroll(e);
    };

    _this._renderRow = function (rowData, sectionID, rowID) {
      var slideoutView = _this.props.renderQuickActions(rowData, sectionID, rowID);

      // If renderQuickActions is unspecified or returns falsey, don't allow swipe
      if (!slideoutView) {
        return _this.props.renderRow(rowData, sectionID, rowID);
      }

      var shouldBounceOnMount = false;
      if (_this._shouldBounceFirstRowOnMount) {
        _this._shouldBounceFirstRowOnMount = false;
        shouldBounceOnMount = rowID === _this.props.dataSource.getFirstRowID();
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__SwipeableRow__["a" /* default */],
        {
          slideoutView: slideoutView,
          isOpen: rowData.id === _this.props.dataSource.getOpenRowID(),
          maxSwipeDistance: _this._getMaxSwipeDistance(rowData, sectionID, rowID),
          key: rowID,
          onOpen: function onOpen() {
            return _this._onOpen(rowData.id);
          },
          onClose: function onClose() {
            return _this._onClose(rowData.id);
          },
          onSwipeEnd: function onSwipeEnd() {
            return _this._setListViewScrollable(true);
          },
          onSwipeStart: function onSwipeStart() {
            return _this._setListViewScrollable(false);
          },
          shouldBounceOnMount: shouldBounceOnMount },
        _this.props.renderRow(rowData, sectionID, rowID)
      );
    };

    _this._shouldBounceFirstRowOnMount = _this.props.bounceFirstRowOnMount;
    _this.state = {
      dataSource: _this.props.dataSource
    };
    return _this;
  }

  SwipeableListView.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.dataSource.getDataSource() !== nextProps.dataSource.getDataSource()) {
      this.setState({
        dataSource: nextProps.dataSource
      });
    }
  };

  SwipeableListView.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__ListView__["a" /* default */], _extends({}, this.props, {
      ref: function ref(_ref) {
        _this2._listViewRef = _ref;
      },
      dataSource: this.state.dataSource.getDataSource(),
      onScroll: this._onScroll,
      renderRow: this._renderRow
    }));
  };

  /**
   * This is a work-around to lock vertical `ListView` scrolling on iOS and
   * mimic Android behaviour. Locking vertical scrolling when horizontal
   * scrolling is active allows us to significantly improve framerates
   * (from high 20s to almost consistently 60 fps)
   */
  SwipeableListView.prototype._setListViewScrollable = function _setListViewScrollable(value) {
    if (this._listViewRef && typeof this._listViewRef.setNativeProps === 'function') {
      this._listViewRef.setNativeProps({
        scrollEnabled: value
      });
    }
  };

  // Passing through ListView's getScrollResponder() function


  SwipeableListView.prototype.getScrollResponder = function getScrollResponder() {
    if (this._listViewRef && typeof this._listViewRef.getScrollResponder === 'function') {
      return this._listViewRef.getScrollResponder();
    }
  };

  // This enables rows having variable width slideoutView.


  SwipeableListView.prototype._getMaxSwipeDistance = function _getMaxSwipeDistance(rowData, sectionID, rowID) {
    if (typeof this.props.maxSwipeDistance === 'function') {
      return this.props.maxSwipeDistance(rowData, sectionID, rowID);
    }

    return this.props.maxSwipeDistance;
  };

  SwipeableListView.prototype._onOpen = function _onOpen(rowID) {
    this.setState({
      dataSource: this.state.dataSource.setOpenRowID(rowID)
    });
  };

  SwipeableListView.prototype._onClose = function _onClose(rowID) {
    this.setState({
      dataSource: this.state.dataSource.setOpenRowID(null)
    });
  };

  return SwipeableListView;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

SwipeableListView.defaultProps = {
  bounceFirstRowOnMount: false,
  renderQuickActions: function renderQuickActions() {
    return null;
  }
};
SwipeableListView.propTypes =  false ? {
  /**
   * To alert the user that swiping is possible, the first row can bounce
   * on component mount.
   */
  bounceFirstRowOnMount: PropTypes.bool.isRequired,
  /**
   * Use `SwipeableListView.getNewDataSource()` to get a data source to use,
   * then use it just like you would a normal ListView data source
   */
  dataSource: PropTypes.instanceOf(SwipeableListViewDataSource).isRequired,
  // Maximum distance to open to after a swipe
  maxSwipeDistance: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,
  // Callback method to render the swipeable view
  renderRow: PropTypes.func.isRequired,
  // Callback method to render the view that will be unveiled on swipe
  renderQuickActions: PropTypes.func.isRequired
} : {};


/* harmony default export */ __webpack_exports__["a"] = (SwipeableListView);

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListView_ListViewDataSource__ = __webpack_require__(311);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule SwipeableListViewDataSource
 */


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * Data source wrapper around ListViewDataSource to allow for tracking of
 * which row is swiped open and close opened row(s) when another row is swiped
 * open.
 *
 * See https://github.com/facebook/react-native/pull/5602 for why
 * ListViewDataSource is not subclassed.
 */

var SwipeableListViewDataSource = function () {
  function SwipeableListViewDataSource(params) {
    var _this = this;

    _classCallCheck(this, SwipeableListViewDataSource);

    this._dataSource = new __WEBPACK_IMPORTED_MODULE_0__ListView_ListViewDataSource__["a" /* default */]({
      getRowData: params.getRowData,
      getSectionHeaderData: params.getSectionHeaderData,
      rowHasChanged: function rowHasChanged(row1, row2) {
        /**
         * Row needs to be re-rendered if its swiped open/close status is
         * changed, or its data blob changed.
         */
        return row1.id !== _this._previousOpenRowID && row2.id === _this._openRowID || row1.id === _this._previousOpenRowID && row2.id !== _this._openRowID || params.rowHasChanged(row1, row2);
      },
      sectionHeaderHasChanged: params.sectionHeaderHasChanged
    });
  }

  SwipeableListViewDataSource.prototype.cloneWithRowsAndSections = function cloneWithRowsAndSections(dataBlob, sectionIdentities, rowIdentities) {
    this._dataSource = this._dataSource.cloneWithRowsAndSections(dataBlob, sectionIdentities, rowIdentities);

    this._dataBlob = dataBlob;
    this.rowIdentities = this._dataSource.rowIdentities;
    this.sectionIdentities = this._dataSource.sectionIdentities;

    return this;
  };

  // For the actual ListView to use


  SwipeableListViewDataSource.prototype.getDataSource = function getDataSource() {
    return this._dataSource;
  };

  SwipeableListViewDataSource.prototype.getOpenRowID = function getOpenRowID() {
    return this._openRowID;
  };

  SwipeableListViewDataSource.prototype.getFirstRowID = function getFirstRowID() {
    /**
     * If rowIdentities is specified, find the first data row from there since
     * we don't want to attempt to bounce section headers. If unspecified, find
     * the first data row from _dataBlob.
     */
    if (this.rowIdentities) {
      return this.rowIdentities[0] && this.rowIdentities[0][0];
    }
    return Object.keys(this._dataBlob)[0];
  };

  SwipeableListViewDataSource.prototype.getLastRowID = function getLastRowID() {
    if (this.rowIdentities && this.rowIdentities.length) {
      var lastSection = this.rowIdentities[this.rowIdentities.length - 1];
      if (lastSection && lastSection.length) {
        return lastSection[lastSection.length - 1];
      }
    }
    return Object.keys(this._dataBlob)[this._dataBlob.length - 1];
  };

  SwipeableListViewDataSource.prototype.setOpenRowID = function setOpenRowID(rowID) {
    this._previousOpenRowID = this._openRowID;
    this._openRowID = rowID;

    this._dataSource = this._dataSource.cloneWithRowsAndSections(this._dataBlob, this.sectionIdentities, this.rowIdentities);

    return this;
  };

  return SwipeableListViewDataSource;
}();

/* harmony default export */ __webpack_exports__["a"] = (SwipeableListViewDataSource);

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_applyNativeMethods__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColorPropType__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createElement__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_multiplyStyleLengthValue__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UIManager__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ViewPropTypes__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */












var emptyObject = {};
var thumbDefaultBoxShadow = '0px 1px 3px rgba(0,0,0,0.5)';
var thumbFocusedBoxShadow = thumbDefaultBoxShadow + ', 0 0 0 10px rgba(0,0,0,0.1)';

var Switch = function (_Component) {
  _inherits(Switch, _Component);

  function Switch() {
    var _temp, _this, _ret;

    _classCallCheck(this, Switch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._handleChange = function (event) {
      var onValueChange = _this.props.onValueChange;

      onValueChange && onValueChange(event.nativeEvent.target.checked);
    }, _this._handleFocusState = function (event) {
      var isFocused = event.nativeEvent.type === 'focus';
      var boxShadow = isFocused ? thumbFocusedBoxShadow : thumbDefaultBoxShadow;
      if (_this._thumbElement) {
        _this._thumbElement.setNativeProps({ style: { boxShadow: boxShadow } });
      }
    }, _this._setCheckboxRef = function (element) {
      _this._checkboxElement = element;
    }, _this._setThumbRef = function (element) {
      _this._thumbElement = element;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Switch.prototype.blur = function blur() {
    __WEBPACK_IMPORTED_MODULE_5__UIManager__["a" /* default */].blur(this._checkboxElement);
  };

  Switch.prototype.focus = function focus() {
    __WEBPACK_IMPORTED_MODULE_5__UIManager__["a" /* default */].focus(this._checkboxElement);
  };

  Switch.prototype.render = function render() {
    var _props = this.props,
        activeThumbColor = _props.activeThumbColor,
        activeTrackColor = _props.activeTrackColor,
        disabled = _props.disabled,
        onValueChange = _props.onValueChange,
        style = _props.style,
        thumbColor = _props.thumbColor,
        trackColor = _props.trackColor,
        value = _props.value,
        onTintColor = _props.onTintColor,
        thumbTintColor = _props.thumbTintColor,
        tintColor = _props.tintColor,
        other = _objectWithoutProperties(_props, ['activeThumbColor', 'activeTrackColor', 'disabled', 'onValueChange', 'style', 'thumbColor', 'trackColor', 'value', 'onTintColor', 'thumbTintColor', 'tintColor']);

    var _StyleSheet$flatten = __WEBPACK_IMPORTED_MODULE_4__StyleSheet__["a" /* default */].flatten(style),
        styleHeight = _StyleSheet$flatten.height,
        styleWidth = _StyleSheet$flatten.width;

    var height = styleHeight || 20;
    var minWidth = Object(__WEBPACK_IMPORTED_MODULE_3__modules_multiplyStyleLengthValue__["a" /* default */])(height, 2);
    var width = styleWidth > minWidth ? styleWidth : minWidth;
    var trackBorderRadius = Object(__WEBPACK_IMPORTED_MODULE_3__modules_multiplyStyleLengthValue__["a" /* default */])(height, 0.5);
    var trackCurrentColor = value ? onTintColor || activeTrackColor : tintColor || trackColor;
    var thumbCurrentColor = value ? activeThumbColor : thumbTintColor || thumbColor;
    var thumbHeight = height;
    var thumbWidth = thumbHeight;

    var rootStyle = [styles.root, style, { height: height, width: width }, disabled && styles.cursorDefault];

    var trackStyle = [styles.track, {
      backgroundColor: trackCurrentColor,
      borderRadius: trackBorderRadius
    }, disabled && styles.disabledTrack];

    var thumbStyle = [styles.thumb, {
      backgroundColor: thumbCurrentColor,
      height: thumbHeight,
      width: thumbWidth
    }, disabled && styles.disabledThumb];

    var nativeControl = Object(__WEBPACK_IMPORTED_MODULE_2__createElement__["a" /* default */])('input', {
      checked: value,
      disabled: disabled,
      onBlur: this._handleFocusState,
      onChange: this._handleChange,
      onFocus: this._handleFocusState,
      ref: this._setCheckboxRef,
      style: [styles.nativeControl, styles.cursorInherit],
      type: 'checkbox'
    });

    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__View__["a" /* default */],
      _extends({}, other, { style: rootStyle }),
      __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__View__["a" /* default */], { style: trackStyle }),
      __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__View__["a" /* default */], {
        ref: this._setThumbRef,
        style: [thumbStyle, value && styles.thumbOn, {
          marginStart: value ? Object(__WEBPACK_IMPORTED_MODULE_3__modules_multiplyStyleLengthValue__["a" /* default */])(thumbWidth, -1) : 0
        }]
      }),
      nativeControl
    );
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Switch.displayName = 'Switch';
Switch.defaultProps = {
  activeThumbColor: '#009688',
  activeTrackColor: '#A3D3CF',
  disabled: false,
  style: emptyObject,
  thumbColor: '#FAFAFA',
  trackColor: '#939393',
  value: false
};
Switch.propTypes =  false ? Object.assign({}, ViewPropTypes, {
  activeThumbColor: ColorPropType,
  activeTrackColor: ColorPropType,
  disabled: bool,
  onValueChange: func,
  thumbColor: ColorPropType,
  trackColor: ColorPropType,
  value: bool,

  /* eslint-disable react/sort-prop-types */
  // Equivalent of 'activeTrackColor'
  onTintColor: ColorPropType,
  // Equivalent of 'thumbColor'
  thumbTintColor: ColorPropType,
  // Equivalent of 'trackColor'
  tintColor: ColorPropType
}) : {};


var styles = __WEBPACK_IMPORTED_MODULE_4__StyleSheet__["a" /* default */].create({
  root: {
    cursor: 'pointer',
    userSelect: 'none'
  },
  cursorDefault: {
    cursor: 'default'
  },
  cursorInherit: {
    cursor: 'inherit'
  },
  track: Object.assign({}, __WEBPACK_IMPORTED_MODULE_4__StyleSheet__["a" /* default */].absoluteFillObject, {
    height: '70%',
    margin: 'auto',
    transitionDuration: '0.1s',
    width: '100%'
  }),
  disabledTrack: {
    backgroundColor: '#D5D5D5'
  },
  thumb: {
    alignSelf: 'flex-start',
    borderRadius: '100%',
    boxShadow: thumbDefaultBoxShadow,
    start: '0%',
    transform: [{ translateZ: 0 }],
    transitionDuration: '0.1s'
  },
  thumbOn: {
    start: '100%'
  },
  disabledThumb: {
    backgroundColor: '#BDBDBD'
  },
  nativeControl: Object.assign({}, __WEBPACK_IMPORTED_MODULE_4__StyleSheet__["a" /* default */].absoluteFillObject, {
    height: '100%',
    margin: 0,
    opacity: 0,
    padding: 0,
    width: '100%'
  })
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__modules_applyNativeMethods__["a" /* default */])(Switch));

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_applyLayout__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_applyNativeMethods__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_ExecutionEnvironment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_ExecutionEnvironment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fbjs_lib_ExecutionEnvironment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColorPropType__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createElement__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__findNodeHandle__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_StyleSheetPropType__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TextInputStylePropTypes__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_TextInputState__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ViewPropTypes__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */















var isAndroid = __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_ExecutionEnvironment__["canUseDOM"] && /Android/i.test(navigator && navigator.userAgent);
var emptyObject = {};

/**
 * React Native events differ from W3C events.
 */
var normalizeEventHandler = function normalizeEventHandler(handler) {
  return function (e) {
    if (handler) {
      e.nativeEvent.text = e.target.value;
      return handler(e);
    }
  };
};

/**
 * Determines whether a 'selection' prop differs from a node's existing
 * selection state.
 */
var isSelectionStale = function isSelectionStale(node, selection) {
  if (node && selection) {
    var selectionEnd = node.selectionEnd,
        selectionStart = node.selectionStart;
    var start = selection.start,
        end = selection.end;

    return start !== selectionStart || end !== selectionEnd;
  }
  return false;
};

/**
 * Certain input types do no support 'selectSelectionRange' and will throw an
 * error.
 */
var setSelection = function setSelection(node, selection) {
  try {
    if (isSelectionStale(node, selection)) {
      var start = selection.start,
          end = selection.end;
      // workaround for Blink on Android: see https://github.com/text-mask/text-mask/issues/300

      if (isAndroid) {
        setTimeout(function () {
          return node.setSelectionRange(start, end || start);
        }, 10);
      } else {
        node.setSelectionRange(start, end || start);
      }
    }
  } catch (e) {}
};

var TextInput = function (_Component) {
  _inherits(TextInput, _Component);

  function TextInput() {
    var _temp, _this, _ret;

    _classCallCheck(this, TextInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._handleBlur = function (e) {
      var onBlur = _this.props.onBlur;

      __WEBPACK_IMPORTED_MODULE_10__modules_TextInputState__["a" /* default */]._currentlyFocusedNode = null;
      if (onBlur) {
        onBlur(e);
      }
    }, _this._handleChange = function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onChangeText = _this$props.onChangeText;
      var text = e.nativeEvent.text;

      if (onChange) {
        onChange(e);
      }
      if (onChangeText) {
        onChangeText(text);
      }
      _this._handleSelectionChange(e);
    }, _this._handleFocus = function (e) {
      var _this$props2 = _this.props,
          clearTextOnFocus = _this$props2.clearTextOnFocus,
          onFocus = _this$props2.onFocus,
          selectTextOnFocus = _this$props2.selectTextOnFocus;

      var node = _this._node;
      __WEBPACK_IMPORTED_MODULE_10__modules_TextInputState__["a" /* default */]._currentlyFocusedNode = _this._node;
      if (onFocus) {
        onFocus(e);
      }
      if (clearTextOnFocus) {
        _this.clear();
      }
      if (selectTextOnFocus) {
        node && node.select();
      }
    }, _this._handleKeyDown = function (e) {
      // Prevent key events bubbling (see #612)
      e.stopPropagation();

      // Backspace, Tab, Cmd+Enter, and Arrow keys only fire 'keydown' DOM events
      if (e.which === 8 || e.which === 9 || e.which === 13 && e.metaKey || e.which === 37 || e.which === 38 || e.which === 39 || e.which === 40) {
        _this._handleKeyPress(e);
      }
    }, _this._handleKeyPress = function (e) {
      var _this$props3 = _this.props,
          blurOnSubmit = _this$props3.blurOnSubmit,
          multiline = _this$props3.multiline,
          onKeyPress = _this$props3.onKeyPress,
          onSubmitEditing = _this$props3.onSubmitEditing;

      var blurOnSubmitDefault = !multiline;
      var shouldBlurOnSubmit = blurOnSubmit == null ? blurOnSubmitDefault : blurOnSubmit;

      if (onKeyPress) {
        var keyValue = void 0;
        switch (e.which) {
          case 8:
            keyValue = 'Backspace';
            break;
          case 9:
            keyValue = 'Tab';
            break;
          case 13:
            keyValue = 'Enter';
            break;
          case 32:
            keyValue = ' ';
            break;
          case 37:
            keyValue = 'ArrowLeft';
            break;
          case 38:
            keyValue = 'ArrowUp';
            break;
          case 39:
            keyValue = 'ArrowRight';
            break;
          case 40:
            keyValue = 'ArrowDown';
            break;
          default:
            {
              // Trim to only care about the keys that have a textual representation
              if (e.shiftKey) {
                keyValue = String.fromCharCode(e.which).trim();
              } else {
                keyValue = String.fromCharCode(e.which).toLowerCase().trim();
              }
            }
        }

        if (keyValue) {
          e.nativeEvent = {
            altKey: e.altKey,
            ctrlKey: e.ctrlKey,
            key: keyValue,
            metaKey: e.metaKey,
            shiftKey: e.shiftKey,
            target: e.target
          };
          onKeyPress(e);
        }
      }

      if (!e.isDefaultPrevented() && e.which === 13 && !e.shiftKey) {
        if ((blurOnSubmit || !multiline) && onSubmitEditing) {
          // prevent "Enter" from inserting a newline
          e.preventDefault();
          e.nativeEvent = { target: e.target, text: e.target.value };
          onSubmitEditing(e);
        }
        if (shouldBlurOnSubmit) {
          _this.blur();
        }
      }
    }, _this._handleSelectionChange = function (e) {
      var _this$props4 = _this.props,
          onSelectionChange = _this$props4.onSelectionChange,
          _this$props4$selectio = _this$props4.selection,
          selection = _this$props4$selectio === undefined ? emptyObject : _this$props4$selectio;

      if (onSelectionChange) {
        try {
          var node = e.target;
          if (isSelectionStale(node, selection)) {
            var selectionStart = node.selectionStart,
                selectionEnd = node.selectionEnd;

            e.nativeEvent.selection = {
              start: selectionStart,
              end: selectionEnd
            };
            onSelectionChange(e);
          }
        } catch (e) {}
      }
    }, _this._setNode = function (component) {
      _this._node = Object(__WEBPACK_IMPORTED_MODULE_6__findNodeHandle__["a" /* default */])(component);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  TextInput.prototype.clear = function clear() {
    this._node.value = '';
  };

  TextInput.prototype.isFocused = function isFocused() {
    return __WEBPACK_IMPORTED_MODULE_10__modules_TextInputState__["a" /* default */].currentlyFocusedField() === this._node;
  };

  TextInput.prototype.componentDidMount = function componentDidMount() {
    setSelection(this._node, this.props.selection);
    if (document.activeElement === this._node) {
      __WEBPACK_IMPORTED_MODULE_10__modules_TextInputState__["a" /* default */]._currentlyFocusedNode = this._node;
    }
  };

  TextInput.prototype.componentDidUpdate = function componentDidUpdate() {
    setSelection(this._node, this.props.selection);
  };

  TextInput.prototype.render = function render() {
    var _props = this.props,
        autoCorrect = _props.autoCorrect,
        editable = _props.editable,
        keyboardType = _props.keyboardType,
        multiline = _props.multiline,
        numberOfLines = _props.numberOfLines,
        secureTextEntry = _props.secureTextEntry,
        style = _props.style,
        blurOnSubmit = _props.blurOnSubmit,
        clearTextOnFocus = _props.clearTextOnFocus,
        onChangeText = _props.onChangeText,
        onLayout = _props.onLayout,
        onSelectionChange = _props.onSelectionChange,
        onSubmitEditing = _props.onSubmitEditing,
        selection = _props.selection,
        selectTextOnFocus = _props.selectTextOnFocus,
        spellCheck = _props.spellCheck,
        caretHidden = _props.caretHidden,
        clearButtonMode = _props.clearButtonMode,
        dataDetectorTypes = _props.dataDetectorTypes,
        disableFullscreenUI = _props.disableFullscreenUI,
        enablesReturnKeyAutomatically = _props.enablesReturnKeyAutomatically,
        inlineImageLeft = _props.inlineImageLeft,
        inlineImagePadding = _props.inlineImagePadding,
        keyboardAppearance = _props.keyboardAppearance,
        onContentSizeChange = _props.onContentSizeChange,
        onEndEditing = _props.onEndEditing,
        onScroll = _props.onScroll,
        returnKeyLabel = _props.returnKeyLabel,
        returnKeyType = _props.returnKeyType,
        selectionColor = _props.selectionColor,
        selectionState = _props.selectionState,
        textBreakStrategy = _props.textBreakStrategy,
        underlineColorAndroid = _props.underlineColorAndroid,
        otherProps = _objectWithoutProperties(_props, ['autoCorrect', 'editable', 'keyboardType', 'multiline', 'numberOfLines', 'secureTextEntry', 'style', 'blurOnSubmit', 'clearTextOnFocus', 'onChangeText', 'onLayout', 'onSelectionChange', 'onSubmitEditing', 'selection', 'selectTextOnFocus', 'spellCheck', 'caretHidden', 'clearButtonMode', 'dataDetectorTypes', 'disableFullscreenUI', 'enablesReturnKeyAutomatically', 'inlineImageLeft', 'inlineImagePadding', 'keyboardAppearance', 'onContentSizeChange', 'onEndEditing', 'onScroll', 'returnKeyLabel', 'returnKeyType', 'selectionColor', 'selectionState', 'textBreakStrategy', 'underlineColorAndroid']);

    var type = void 0;

    switch (keyboardType) {
      case 'email-address':
        type = 'email';
        break;
      case 'number-pad':
      case 'numeric':
        type = 'number';
        break;
      case 'phone-pad':
        type = 'tel';
        break;
      case 'search':
      case 'web-search':
        type = 'search';
        break;
      case 'url':
        type = 'url';
        break;
      default:
        type = 'text';
    }

    if (secureTextEntry) {
      type = 'password';
    }

    var component = multiline ? 'textarea' : 'input';

    Object.assign(otherProps, {
      autoCorrect: autoCorrect ? 'on' : 'off',
      dir: 'auto',
      onBlur: normalizeEventHandler(this._handleBlur),
      onChange: normalizeEventHandler(this._handleChange),
      onFocus: normalizeEventHandler(this._handleFocus),
      onKeyDown: this._handleKeyDown,
      onKeyPress: this._handleKeyPress,
      onSelect: normalizeEventHandler(this._handleSelectionChange),
      readOnly: !editable,
      ref: this._setNode,
      spellCheck: spellCheck != null ? spellCheck : autoCorrect,
      style: [styles.initial, style]
    });

    if (multiline) {
      otherProps.rows = numberOfLines;
    } else {
      otherProps.type = type;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_5__createElement__["a" /* default */])(component, otherProps);
  };

  return TextInput;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

TextInput.displayName = 'TextInput';
TextInput.defaultProps = {
  autoCapitalize: 'sentences',
  autoComplete: 'on',
  autoCorrect: true,
  editable: true,
  keyboardType: 'default',
  multiline: false,
  numberOfLines: 2,
  secureTextEntry: false,
  style: emptyObject
};
TextInput.State = __WEBPACK_IMPORTED_MODULE_10__modules_TextInputState__["a" /* default */];
TextInput.propTypes =  false ? Object.assign({}, ViewPropTypes, {
  autoCapitalize: oneOf(['characters', 'none', 'sentences', 'words']),
  autoComplete: string,
  autoCorrect: bool,
  autoFocus: bool,
  blurOnSubmit: bool,
  clearTextOnFocus: bool,
  defaultValue: string,
  editable: bool,
  keyboardType: oneOf(['default', 'email-address', 'number-pad', 'numbers-and-punctuation', 'numeric', 'phone-pad', 'search', 'url', 'web-search']),
  maxLength: number,
  multiline: bool,
  numberOfLines: number,
  onBlur: func,
  onChange: func,
  onChangeText: func,
  onFocus: func,
  onKeyPress: func,
  onSelectionChange: func,
  onSubmitEditing: func,
  placeholder: string,
  placeholderTextColor: ColorPropType,
  secureTextEntry: bool,
  selectTextOnFocus: bool,
  selection: shape({
    start: number.isRequired,
    end: number
  }),
  spellCheck: bool,
  style: StyleSheetPropType(TextInputStylePropTypes),
  value: string,
  /* react-native compat */
  /* eslint-disable */
  caretHidden: bool,
  clearButtonMode: string,
  dataDetectorTypes: string,
  disableFullscreenUI: bool,
  enablesReturnKeyAutomatically: bool,
  keyboardAppearance: string,
  inlineImageLeft: string,
  inlineImagePadding: number,
  onContentSizeChange: func,
  onEndEditing: func,
  onScroll: func,
  returnKeyLabel: string,
  returnKeyType: string,
  selectionColor: ColorPropType,
  selectionState: any,
  textBreakStrategy: string,
  underlineColorAndroid: ColorPropType
  /* eslint-enable */
}) : {};


var styles = __WEBPACK_IMPORTED_MODULE_7__StyleSheet__["a" /* default */].create({
  initial: {
    MozAppearance: 'textfield',
    WebkitAppearance: 'none',
    backgroundColor: 'transparent',
    borderColor: 'black',
    borderRadius: 0,
    borderStyle: 'solid',
    borderWidth: 0,
    boxSizing: 'border-box',
    fontFamily: 'System',
    fontSize: 14,
    padding: 0,
    resize: 'none'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__modules_applyLayout__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__modules_applyNativeMethods__["a" /* default */])(TextInput)));

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_applyNativeMethods__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColorPropType__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_ensureComponentIsNative__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Touchable_ensurePositiveDelayProps__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StyleSheet__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_timer_mixin__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_timer_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_timer_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Touchable__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TouchableWithoutFeedback__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__View__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ViewPropTypes__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @noflow
 */















var DEFAULT_PROPS = {
  activeOpacity: 0.85,
  underlayColor: 'black'
};

var PRESS_RETENTION_OFFSET = { top: 20, left: 20, right: 20, bottom: 30 };

/**
 * A wrapper for making views respond properly to touches.
 * On press down, the opacity of the wrapped view is decreased, which allows
 * the underlay color to show through, darkening or tinting the view.
 *
 * The underlay comes from wrapping the child in a new View, which can affect
 * layout, and sometimes cause unwanted visual artifacts if not used correctly,
 * for example if the backgroundColor of the wrapped view isn't explicitly set
 * to an opaque color.
 *
 * TouchableHighlight must have one child (not zero or more than one).
 * If you wish to have several child components, wrap them in a View.
 *
 * Example:
 *
 * ```
 * renderButton: function() {
 *   return (
 *     <TouchableHighlight onPress={this._onPressButton}>
 *       <Image
 *         style={styles.button}
 *         source={require('./myButton.png')}
 *       />
 *     </TouchableHighlight>
 *   );
 * },
 * ```
 */

/* eslint-disable react/prefer-es6-class */
var TouchableHighlight = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'TouchableHighlight',
  propTypes: Object.assign({}, __WEBPACK_IMPORTED_MODULE_9__TouchableWithoutFeedback__["a" /* default */].propTypes, {
    /**
     * Determines what the opacity of the wrapped view should be when touch is
     * active.
     */
    activeOpacity: __WEBPACK_IMPORTED_MODULE_12_prop_types__["number"],
    /**
     * Called immediately after the underlay is hidden
     */
    onHideUnderlay: __WEBPACK_IMPORTED_MODULE_12_prop_types__["func"],
    /**
     * Called immediately after the underlay is shown
     */
    onShowUnderlay: __WEBPACK_IMPORTED_MODULE_12_prop_types__["func"],
    style: __WEBPACK_IMPORTED_MODULE_11__ViewPropTypes__["a" /* default */].style,
    /**
     * The color of the underlay that will show through when the touch is
     * active.
     */
    underlayColor: __WEBPACK_IMPORTED_MODULE_1__ColorPropType__["a" /* default */]
  }),

  mixins: [__WEBPACK_IMPORTED_MODULE_7_react_timer_mixin___default.a, __WEBPACK_IMPORTED_MODULE_8__Touchable__["a" /* default */].Mixin],

  getDefaultProps: function getDefaultProps() {
    return DEFAULT_PROPS;
  },

  // Performance optimization to avoid constantly re-generating these objects.
  _computeSyntheticState: function _computeSyntheticState(props) {
    return {
      activeProps: {
        style: {
          opacity: props.activeOpacity
        }
      },
      activeUnderlayProps: {
        style: {
          backgroundColor: props.underlayColor
        }
      },
      underlayStyle: [INACTIVE_UNDERLAY_PROPS.style, props.style]
    };
  },

  getInitialState: function getInitialState() {
    this._isMounted = false;
    return Object.assign({}, this.touchableGetInitialState(), this._computeSyntheticState(this.props));
  },

  componentDidMount: function componentDidMount() {
    this._isMounted = true;
    Object(__WEBPACK_IMPORTED_MODULE_4__Touchable_ensurePositiveDelayProps__["a" /* default */])(this.props);
    Object(__WEBPACK_IMPORTED_MODULE_3__modules_ensureComponentIsNative__["a" /* default */])(this._childRef);
  },

  componentWillUnmount: function componentWillUnmount() {
    this._isMounted = false;
  },

  componentDidUpdate: function componentDidUpdate() {
    Object(__WEBPACK_IMPORTED_MODULE_3__modules_ensureComponentIsNative__["a" /* default */])(this._childRef);
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    Object(__WEBPACK_IMPORTED_MODULE_4__Touchable_ensurePositiveDelayProps__["a" /* default */])(nextProps);
    if (nextProps.activeOpacity !== this.props.activeOpacity || nextProps.underlayColor !== this.props.underlayColor || nextProps.style !== this.props.style) {
      this.setState(this._computeSyntheticState(nextProps));
    }
  },

  /**
   * `Touchable.Mixin` self callbacks. The mixin will invoke these if they are
   * defined on your component.
   */
  touchableHandleActivePressIn: function touchableHandleActivePressIn(e) {
    this.clearTimeout(this._hideTimeout);
    this._hideTimeout = null;
    this._showUnderlay();
    this.props.onPressIn && this.props.onPressIn(e);
  },

  touchableHandleActivePressOut: function touchableHandleActivePressOut(e) {
    if (!this._hideTimeout) {
      this._hideUnderlay();
    }
    this.props.onPressOut && this.props.onPressOut(e);
  },

  touchableHandlePress: function touchableHandlePress(e) {
    this.clearTimeout(this._hideTimeout);
    this._showUnderlay();
    this._hideTimeout = this.setTimeout(this._hideUnderlay, this.props.delayPressOut || 100);
    this.props.onPress && this.props.onPress(e);
  },

  touchableHandleLongPress: function touchableHandleLongPress(e) {
    this.props.onLongPress && this.props.onLongPress(e);
  },

  touchableGetPressRectOffset: function touchableGetPressRectOffset() {
    return this.props.pressRetentionOffset || PRESS_RETENTION_OFFSET;
  },

  touchableGetHitSlop: function touchableGetHitSlop() {
    return this.props.hitSlop;
  },

  touchableGetHighlightDelayMS: function touchableGetHighlightDelayMS() {
    return this.props.delayPressIn;
  },

  touchableGetLongPressDelayMS: function touchableGetLongPressDelayMS() {
    return this.props.delayLongPress;
  },

  touchableGetPressOutDelayMS: function touchableGetPressOutDelayMS() {
    return this.props.delayPressOut;
  },

  _showUnderlay: function _showUnderlay() {
    if (!this._isMounted || !this._hasPressHandler()) {
      return;
    }

    this._underlayRef.setNativeProps(this.state.activeUnderlayProps);
    this._childRef.setNativeProps(this.state.activeProps);
    this.props.onShowUnderlay && this.props.onShowUnderlay();
  },

  _hideUnderlay: function _hideUnderlay() {
    this.clearTimeout(this._hideTimeout);
    this._hideTimeout = null;
    if (this._hasPressHandler() && this._underlayRef) {
      this._childRef.setNativeProps(INACTIVE_CHILD_PROPS);
      this._underlayRef.setNativeProps(Object.assign({}, INACTIVE_UNDERLAY_PROPS, {
        style: this.state.underlayStyle
      }));
      this.props.onHideUnderlay && this.props.onHideUnderlay();
    }
  },

  _hasPressHandler: function _hasPressHandler() {
    return !!(this.props.onPress || this.props.onPressIn || this.props.onPressOut || this.props.onLongPress);
  },

  _setChildRef: function _setChildRef(node) {
    this._childRef = node;
  },
  _setUnderlayRef: function _setUnderlayRef(node) {
    this._underlayRef = node;
  },


  render: function render() {
    var _props = this.props,
        activeOpacity = _props.activeOpacity,
        onHideUnderlay = _props.onHideUnderlay,
        onShowUnderlay = _props.onShowUnderlay,
        underlayColor = _props.underlayColor,
        delayLongPress = _props.delayLongPress,
        delayPressIn = _props.delayPressIn,
        delayPressOut = _props.delayPressOut,
        onLongPress = _props.onLongPress,
        onPress = _props.onPress,
        onPressIn = _props.onPressIn,
        onPressOut = _props.onPressOut,
        pressRetentionOffset = _props.pressRetentionOffset,
        other = _objectWithoutProperties(_props, ['activeOpacity', 'onHideUnderlay', 'onShowUnderlay', 'underlayColor', 'delayLongPress', 'delayPressIn', 'delayPressOut', 'onLongPress', 'onPress', 'onPressIn', 'onPressOut', 'pressRetentionOffset']);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__View__["a" /* default */],
      _extends({}, other, {
        accessible: this.props.accessible !== false,
        onKeyDown: this.touchableHandleKeyEvent,
        onKeyUp: this.touchableHandleKeyEvent,
        onResponderGrant: this.touchableHandleResponderGrant,
        onResponderMove: this.touchableHandleResponderMove,
        onResponderRelease: this.touchableHandleResponderRelease,
        onResponderTerminate: this.touchableHandleResponderTerminate,
        onResponderTerminationRequest: this.touchableHandleResponderTerminationRequest,
        onStartShouldSetResponder: this.touchableHandleStartShouldSetResponder,
        ref: this._setUnderlayRef,
        style: [styles.root, !this.props.disabled && styles.actionable, this.state.underlayStyle]
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.only(this.props.children), {
        ref: this._setChildRef
      }),
      __WEBPACK_IMPORTED_MODULE_8__Touchable__["a" /* default */].renderDebugView({ color: 'green', hitSlop: this.props.hitSlop })
    );
  }
});

var INACTIVE_CHILD_PROPS = {
  style: __WEBPACK_IMPORTED_MODULE_6__StyleSheet__["a" /* default */].create({ x: { opacity: 1.0 } }).x
};
var INACTIVE_UNDERLAY_PROPS = {
  style: __WEBPACK_IMPORTED_MODULE_6__StyleSheet__["a" /* default */].create({ x: { backgroundColor: 'transparent' } }).x
};

var styles = __WEBPACK_IMPORTED_MODULE_6__StyleSheet__["a" /* default */].create({
  root: {
    userSelect: 'none'
  },
  actionable: {
    cursor: 'pointer',
    touchAction: 'manipulation'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__modules_applyNativeMethods__["a" /* default */])(TouchableHighlight));

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__ = __webpack_require__(78);
/**
 * Copyright 2017-present, Nicolas Gallagher
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modules_UnimplementedView__["a" /* default */]);

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_react_native_VirtualizedList__ = __webpack_require__(195);
/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__vendor_react_native_VirtualizedList__["a" /* default */]);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_UnimplementedView__ = __webpack_require__(78);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var YellowBox = function (_React$Component) {
  _inherits(YellowBox, _React$Component);

  function YellowBox() {
    _classCallCheck(this, YellowBox);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  YellowBox.ignoreWarnings = function ignoreWarnings() {};

  YellowBox.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__modules_UnimplementedView__["a" /* default */], this.props);
  };

  return YellowBox;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (YellowBox);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_createStrictShapeTypeChecker__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var PointPropType = Object(__WEBPACK_IMPORTED_MODULE_0__modules_createStrictShapeTypeChecker__["a" /* default */])({
  x: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
  y: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"]
});

/* harmony default export */ __webpack_exports__["a"] = (PointPropType);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(196);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(760);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(322);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(748);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(746);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(319);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(750);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(754);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10), __webpack_require__(753)(module)))

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(320);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(321);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(322);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(323);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(761);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(196);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PersistGate", function() { return PersistGate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

 // eslint-disable-line import/no-unresolved
// eslint-disable-line import/no-unresolved


var PersistGate = function (_PureComponent) {
  _inherits(PersistGate, _PureComponent);

  function PersistGate() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PersistGate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PersistGate.__proto__ || Object.getPrototypeOf(PersistGate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      bootstrapped: false
    }, _this.handlePersistorState = function () {
      var persistor = _this.props.persistor;

      var _persistor$getState = persistor.getState(),
          bootstrapped = _persistor$getState.bootstrapped;

      if (bootstrapped) {
        if (_this.props.onBeforeLift) {
          Promise.resolve(_this.props.onBeforeLift()).then(function () {
            return _this.setState({ bootstrapped: true });
          }).catch(function () {
            return _this.setState({ bootstrapped: true });
          });
        } else {
          _this.setState({ bootstrapped: true });
        }
        _this._unsubscribe && _this._unsubscribe();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PersistGate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
      this.handlePersistorState();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unsubscribe && this._unsubscribe();
    }
  }, {
    key: 'render',
    value: function render() {
      if (false) {
        if (typeof this.props.children === 'function' && this.props.loading) console.error('redux-persist: PersistGate expects either a function child or loading prop, but not both. The loading prop will be ignored.');
      }
      if (typeof this.props.children === 'function') {
        return this.props.children(this.state.bootstrapped);
      }

      return this.state.bootstrapped ? this.props.children : this.props.loading;
    }
  }]);

  return PersistGate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
PersistGate.defaultProps = {
  loading: null
};

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(764);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(65);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(765);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(325);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(326);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;
var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (!_safeHTMLElement.canUseDOM) return;
      var isOpen = newProps.isOpen;
      // Stop unnecessary renders if modal is remaining closed

      if (!this.props.isOpen && !isOpen) return;

      var currentParent = getParentElement(this.props.parentSelector);
      var newParent = getParentElement(newProps.parentSelector);

      if (newParent !== currentParent) {
        currentParent.removeChild(this.node);
        newParent.appendChild(this.node);
      }

      !isReact16 && this.renderPortal(newProps);
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(newProps) {
      if (!_safeHTMLElement.canUseDOM) return;
      if (newProps.portalClassName !== this.props.portalClassName) {
        this.node.className = newProps.portalClassName;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
exports.default = Modal;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(766);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(767);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(325);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(768);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(326);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setFocusAfterRender = function (focus) {
      _this.focusAfterRender = _this.props.shouldFocusAfterRender && focus;
    };

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
      _this.moveFromContentToOverlay = null;
    };

    _this.handleOverlayOnMouseUp = function () {
      if (_this.moveFromContentToOverlay === null) {
        _this.shouldClose = false;
      }
      if (_this.props.shouldCloseOnOverlayClick) {
        _this.shouldClose = true;
      }
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
      _this.moveFromContentToOverlay = false;
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
      _this.moveFromContentToOverlay = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.ariaAttributes = function (items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc["aria-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Focus needs to be set when mounting and already open
      if (this.props.isOpen) {
        this.setFocusAfterRender(true);
        this.open();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (false) {
        if (newProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (newProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }
      // Focus only needs to be set once when the modal is being opened
      if (!this.props.isOpen && newProps.isOpen) {
        this.setFocusAfterRender(true);
        this.open();
      } else if (this.props.isOpen && !newProps.isOpen) {
        this.close();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.focusAfterRender) {
        this.focusContent();
        this.setFocusAfterRender(false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.afterClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown,
          onMouseUp: this.handleOverlayOnMouseUp,
          "aria-modal": "true"
        },
        _react2.default.createElement(
          "div",
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.ariaAttributes(this.props.aria || {})),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  }
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(324);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(324);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prune, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(45);var _createIconSet2=_interopRequireDefault(_createIconSet);var _Entypo=__webpack_require__(876);var _Entypo2=_interopRequireDefault(_Entypo);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_Entypo2.default,'Entypo','Entypo.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='./lib/icon-button.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=createIconButtonComponent;var _isString=__webpack_require__(772);var _isString2=_interopRequireDefault(_isString);var _omit=__webpack_require__(775);var _omit2=_interopRequireDefault(_omit);var _pick=__webpack_require__(215);var _pick2=_interopRequireDefault(_pick);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);var _reactNative=__webpack_require__(134);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=_reactNative.StyleSheet.create({container:{flexDirection:'row',justifyContent:'flex-start',alignItems:'center',padding:8},touchable:{overflow:'hidden'},icon:{marginRight:10},text:{fontWeight:'600',backgroundColor:'transparent'}});var IOS7_BLUE='#007AFF';function createIconButtonComponent(Icon){var _class,_temp;return _temp=_class=function(_PureComponent){_inherits(IconButton,_PureComponent);function IconButton(){_classCallCheck(this,IconButton);return _possibleConstructorReturn(this,(IconButton.__proto__||Object.getPrototypeOf(IconButton)).apply(this,arguments));}_createClass(IconButton,[{key:'render',value:function render(){var _props=this.props,style=_props.style,iconStyle=_props.iconStyle,children=_props.children,restProps=_objectWithoutProperties(_props,['style','iconStyle','children']);var iconProps=(0,_pick2.default)(restProps,Object.keys(_reactNative.Text.propTypes),'style','name','size','color');var touchableProps=(0,_pick2.default)(restProps,Object.keys(_reactNative.TouchableHighlight.propTypes));var props=(0,_omit2.default)(restProps,Object.keys(iconProps),Object.keys(touchableProps),'iconStyle','borderRadius','backgroundColor');iconProps.style=iconStyle?[styles.icon,iconStyle]:styles.icon;var colorStyle=(0,_pick2.default)(this.props,'color');var blockStyle=(0,_pick2.default)(this.props,'backgroundColor','borderRadius');return _react2.default.createElement(_reactNative.TouchableHighlight,_extends({style:[styles.touchable,blockStyle]},touchableProps,{__source:{fileName:_jsxFileName,lineNumber:80}}),_react2.default.createElement(_reactNative.View,_extends({style:[styles.container,blockStyle,style]},props,{__source:{fileName:_jsxFileName,lineNumber:84}}),_react2.default.createElement(Icon,_extends({},iconProps,{__source:{fileName:_jsxFileName,lineNumber:85}})),(0,_isString2.default)(children)?_react2.default.createElement(_reactNative.Text,{style:[styles.text,colorStyle],__source:{fileName:_jsxFileName,lineNumber:87}},children):children));}}]);return IconButton;}(_react.PureComponent),_class.propTypes={backgroundColor:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number]),borderRadius:_propTypes2.default.number,color:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number]),size:_propTypes2.default.number,iconStyle:_propTypes2.default.any,style:_propTypes2.default.any,children:_propTypes2.default.node},_class.defaultProps={backgroundColor:IOS7_BLUE,borderRadius:5,color:'white',size:20},_temp;}

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(82),
    isArray = __webpack_require__(55),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(94);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 774 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(328),
    baseClone = __webpack_require__(776),
    baseUnset = __webpack_require__(835),
    castPath = __webpack_require__(97),
    copyObject = __webpack_require__(108),
    customOmitClone = __webpack_require__(845),
    flatRest = __webpack_require__(346),
    getAllKeysIn = __webpack_require__(343);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(329),
    arrayEach = __webpack_require__(803),
    assignValue = __webpack_require__(201),
    baseAssign = __webpack_require__(804),
    baseAssignIn = __webpack_require__(811),
    cloneBuffer = __webpack_require__(814),
    copyArray = __webpack_require__(815),
    copySymbols = __webpack_require__(816),
    copySymbolsIn = __webpack_require__(818),
    getAllKeys = __webpack_require__(341),
    getAllKeysIn = __webpack_require__(343),
    getTag = __webpack_require__(139),
    initCloneArray = __webpack_require__(823),
    initCloneByTag = __webpack_require__(824),
    initCloneObject = __webpack_require__(829),
    isArray = __webpack_require__(55),
    isBuffer = __webpack_require__(204),
    isMap = __webpack_require__(831),
    isObject = __webpack_require__(95),
    isSet = __webpack_require__(833),
    keys = __webpack_require__(202);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 777 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(136);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(136);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(136);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(136);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(135);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 783 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 784 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 785 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(135),
    Map = __webpack_require__(199),
    MapCache = __webpack_require__(200);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(330),
    isMasked = __webpack_require__(788),
    isObject = __webpack_require__(95),
    toSource = __webpack_require__(331);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(789);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(54);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 790 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(792),
    ListCache = __webpack_require__(135),
    Map = __webpack_require__(199);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(793),
    hashDelete = __webpack_require__(794),
    hashGet = __webpack_require__(795),
    hashHas = __webpack_require__(796),
    hashSet = __webpack_require__(797);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(137);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 794 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(137);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(137);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(137);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(138);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 799 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(138);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(138);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(138);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 803 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(108),
    keys = __webpack_require__(202);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 805 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(82),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 807 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(82),
    isLength = __webpack_require__(206),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(209),
    nativeKeys = __webpack_require__(810);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(336);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(108),
    keysIn = __webpack_require__(338);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(95),
    isPrototype = __webpack_require__(209),
    nativeKeysIn = __webpack_require__(813);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 813 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(54);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 815 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(108),
    getSymbols = __webpack_require__(210);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 817 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(108),
    getSymbolsIn = __webpack_require__(340);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(83),
    root = __webpack_require__(54);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(83),
    root = __webpack_require__(54);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(83),
    root = __webpack_require__(54);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(83),
    root = __webpack_require__(54);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 823 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(213),
    cloneDataView = __webpack_require__(825),
    cloneRegExp = __webpack_require__(826),
    cloneSymbol = __webpack_require__(827),
    cloneTypedArray = __webpack_require__(828);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(213);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 826 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(94);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(213);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(830),
    getPrototype = __webpack_require__(212),
    isPrototype = __webpack_require__(209);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(95);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(832),
    baseUnary = __webpack_require__(207),
    nodeUtil = __webpack_require__(208);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(139),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(834),
    baseUnary = __webpack_require__(207),
    nodeUtil = __webpack_require__(208);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(139),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(97),
    last = __webpack_require__(842),
    parent = __webpack_require__(843),
    toKey = __webpack_require__(140);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(55),
    isSymbol = __webpack_require__(214);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(838);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(839);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(200);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(841);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(94),
    arrayMap = __webpack_require__(328),
    isArray = __webpack_require__(55),
    isSymbol = __webpack_require__(214);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 842 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(345),
    baseSlice = __webpack_require__(844);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 844 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(846);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(82),
    getPrototype = __webpack_require__(212),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(848);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(211),
    isFlattenable = __webpack_require__(849);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(94),
    isArguments = __webpack_require__(203),
    isArray = __webpack_require__(55);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(851);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 851 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(853),
    shortOut = __webpack_require__(856);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(854),
    defineProperty = __webpack_require__(333),
    identity = __webpack_require__(855);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 854 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 855 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 856 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(858),
    hasIn = __webpack_require__(860);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(345),
    baseSet = __webpack_require__(859),
    castPath = __webpack_require__(97);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(201),
    castPath = __webpack_require__(97),
    isIndex = __webpack_require__(205),
    isObject = __webpack_require__(95),
    toKey = __webpack_require__(140);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(861),
    hasPath = __webpack_require__(862);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 861 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(97),
    isArguments = __webpack_require__(203),
    isArray = __webpack_require__(55),
    isIndex = __webpack_require__(205),
    isLength = __webpack_require__(206),
    toKey = __webpack_require__(140);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='./lib/tab-bar-item-ios.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=createTabBarItemIOSComponent;var _isEqual=__webpack_require__(347);var _isEqual2=_interopRequireDefault(_isEqual);var _pick=__webpack_require__(215);var _pick2=_interopRequireDefault(_pick);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);var _reactNative=__webpack_require__(134);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function createTabBarItemIOSComponent(IconNamePropType,getImageSource){var _class,_temp;return _temp=_class=function(_PureComponent){_inherits(TabBarItemIOS,_PureComponent);function TabBarItemIOS(){_classCallCheck(this,TabBarItemIOS);return _possibleConstructorReturn(this,(TabBarItemIOS.__proto__||Object.getPrototypeOf(TabBarItemIOS)).apply(this,arguments));}_createClass(TabBarItemIOS,[{key:'componentWillMount',value:function componentWillMount(){this.updateIconSources(this.props);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var keys=Object.keys(TabBarItemIOS.propTypes);if(!(0,_isEqual2.default)((0,_pick2.default)(nextProps,keys),(0,_pick2.default)(this.props,keys))){this.updateIconSources(nextProps);}}},{key:'updateIconSources',value:function updateIconSources(props){var _this2=this;if(props.iconName){getImageSource(props.iconName,props.iconSize,props.iconColor).then(function(icon){return _this2.setState({icon:icon});});}if(props.selectedIconName||props.selectedIconColor){var selectedIconName=props.selectedIconName||props.iconName;var selectedIconColor=props.selectedIconColor||props.iconColor;getImageSource(selectedIconName,props.iconSize,selectedIconColor).then(function(selectedIcon){return _this2.setState({selectedIcon:selectedIcon});});}}},{key:'render',value:function render(){return _react2.default.createElement(_reactNative.TabBarIOS.Item,_extends({},this.props,this.state,{__source:{fileName:_jsxFileName,lineNumber:59}}));}}]);return TabBarItemIOS;}(_react.PureComponent),_class.propTypes={iconName:IconNamePropType.isRequired,selectedIconName:IconNamePropType,iconSize:_propTypes2.default.number,iconColor:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number]),selectedIconColor:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number])},_class.defaultProps={iconSize:30},_temp;}

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(865),
    isObjectLike = __webpack_require__(61);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(329),
    equalArrays = __webpack_require__(348),
    equalByTag = __webpack_require__(871),
    equalObjects = __webpack_require__(874),
    getTag = __webpack_require__(139),
    isArray = __webpack_require__(55),
    isBuffer = __webpack_require__(204),
    isTypedArray = __webpack_require__(335);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(200),
    setCacheAdd = __webpack_require__(867),
    setCacheHas = __webpack_require__(868);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 867 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 868 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 869 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 870 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(94),
    Uint8Array = __webpack_require__(344),
    eq = __webpack_require__(198),
    equalArrays = __webpack_require__(348),
    mapToArray = __webpack_require__(872),
    setToArray = __webpack_require__(873);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 872 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 873 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(341);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='./lib/toolbar-android.js';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=createToolbarAndroidComponent;var _isEqual=__webpack_require__(347);var _isEqual2=_interopRequireDefault(_isEqual);var _pick=__webpack_require__(215);var _pick2=_interopRequireDefault(_pick);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(2);var _propTypes2=_interopRequireDefault(_propTypes);var _reactNative=__webpack_require__(134);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function createToolbarAndroidComponent(IconNamePropType,getImageSource){var _class,_temp;return _temp=_class=function(_PureComponent){_inherits(IconToolbarAndroid,_PureComponent);function IconToolbarAndroid(){_classCallCheck(this,IconToolbarAndroid);return _possibleConstructorReturn(this,(IconToolbarAndroid.__proto__||Object.getPrototypeOf(IconToolbarAndroid)).apply(this,arguments));}_createClass(IconToolbarAndroid,[{key:'componentWillMount',value:function componentWillMount(){this.updateIconSources(this.props);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;var keys=Object.keys(IconToolbarAndroid.propTypes);if(!(0,_isEqual2.default)((0,_pick2.default)(nextProps,keys),(0,_pick2.default)(this.props,keys))){var stateToEvict={};if(!nextProps.logoName){stateToEvict.logo=undefined;}if(!nextProps.navIconName){stateToEvict.navIcon=undefined;}if(!nextProps.overflowIconName){stateToEvict.overflowIcon=undefined;}if(this.state&&Object.keys(stateToEvict).length){this.setState(stateToEvict,function(){return _this2.updateIconSources(nextProps);});}else{this.updateIconSources(nextProps);}}}},{key:'updateIconSources',value:function updateIconSources(props){var _this3=this;var size=props.iconSize;var color=props.iconColor||props.titleColor;if(props.logoName){getImageSource(props.logoName,size,color).then(function(logo){return _this3.setState({logo:logo});});}if(props.navIconName){getImageSource(props.navIconName,size,color).then(function(navIcon){return _this3.setState({navIcon:navIcon});});}if(props.overflowIconName){getImageSource(props.overflowIconName,size,color).then(function(overflowIcon){return _this3.setState({overflowIcon:overflowIcon});});}Promise.all((props.actions||[]).map(function(action){if(action.iconName){return getImageSource(action.iconName,action.iconSize||size,action.iconColor||color).then(function(icon){return _extends({},action,{icon:icon});});}return Promise.resolve(action);})).then(function(actions){return _this3.setState({actions:actions});});}},{key:'render',value:function render(){return _react2.default.createElement(_reactNative.ToolbarAndroid,_extends({},this.props,this.state,{__source:{fileName:_jsxFileName,lineNumber:94}}));}}]);return IconToolbarAndroid;}(_react.PureComponent),_class.propTypes={logoName:IconNamePropType,navIconName:IconNamePropType,overflowIconName:IconNamePropType,actions:_propTypes2.default.arrayOf(_propTypes2.default.shape({title:_propTypes2.default.string.isRequired,iconName:IconNamePropType,iconSize:_propTypes2.default.number,iconColor:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number]),show:_propTypes2.default.oneOf(['always','ifRoom','never']),showWithText:_propTypes2.default.bool})),iconSize:_propTypes2.default.number,iconColor:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number])},_class.defaultProps={iconSize:24},_temp;}

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports = {"500px":61696,"500px-with-circle":61697,"add-to-list":61698,"add-user":61699,"address":61700,"adjust":61701,"air":61702,"aircraft":61703,"aircraft-landing":61704,"aircraft-take-off":61705,"align-bottom":61706,"align-horizontal-middle":61707,"align-left":61708,"align-right":61709,"align-top":61710,"align-vertical-middle":61711,"app-store":61712,"archive":61713,"area-graph":61714,"arrow-bold-down":61715,"arrow-bold-left":61716,"arrow-bold-right":61717,"arrow-bold-up":61718,"arrow-down":61719,"arrow-left":61720,"arrow-long-down":61721,"arrow-long-left":61722,"arrow-long-right":61723,"arrow-long-up":61724,"arrow-right":61725,"arrow-up":61726,"arrow-with-circle-down":61727,"arrow-with-circle-left":61728,"arrow-with-circle-right":61729,"arrow-with-circle-up":61730,"attachment":61731,"awareness-ribbon":61732,"back":61733,"back-in-time":61734,"baidu":61735,"bar-graph":61736,"basecamp":61737,"battery":61738,"beamed-note":61739,"behance":61740,"bell":61741,"blackboard":61742,"block":61743,"book":61744,"bookmark":61745,"bookmarks":61746,"bowl":61747,"box":61748,"briefcase":61749,"browser":61750,"brush":61751,"bucket":61752,"bug":61753,"cake":61754,"calculator":61755,"calendar":61756,"camera":61757,"ccw":61758,"chat":61759,"check":61760,"chevron-down":61761,"chevron-left":61762,"chevron-right":61763,"chevron-small-down":61764,"chevron-small-left":61765,"chevron-small-right":61766,"chevron-small-up":61767,"chevron-thin-down":61768,"chevron-thin-left":61769,"chevron-thin-right":61770,"chevron-thin-up":61771,"chevron-up":61772,"chevron-with-circle-down":61773,"chevron-with-circle-left":61774,"chevron-with-circle-right":61775,"chevron-with-circle-up":61776,"circle":61777,"circle-with-cross":61778,"circle-with-minus":61779,"circle-with-plus":61780,"circular-graph":61781,"clapperboard":61782,"classic-computer":61783,"clipboard":61784,"clock":61785,"cloud":61786,"code":61787,"cog":61788,"colours":61789,"compass":61790,"controller-fast-backward":61791,"controller-fast-forward":61792,"controller-jump-to-start":61793,"controller-next":61794,"controller-paus":61795,"controller-play":61796,"controller-record":61797,"controller-stop":61798,"controller-volume":61799,"copy":61800,"creative-cloud":61801,"creative-commons":61802,"creative-commons-attribution":61803,"creative-commons-noderivs":61804,"creative-commons-noncommercial-eu":61805,"creative-commons-noncommercial-us":61806,"creative-commons-public-domain":61807,"creative-commons-remix":61808,"creative-commons-share":61809,"creative-commons-sharealike":61810,"credit":61811,"credit-card":61812,"crop":61813,"cross":61814,"cup":61815,"cw":61816,"cycle":61817,"database":61818,"dial-pad":61819,"direction":61820,"document":61821,"document-landscape":61822,"documents":61823,"dot-single":61824,"dots-three-horizontal":61825,"dots-three-vertical":61826,"dots-two-horizontal":61827,"dots-two-vertical":61828,"download":61829,"dribbble":61830,"dribbble-with-circle":61831,"drink":61832,"drive":61833,"drop":61834,"dropbox":61835,"edit":61836,"email":61837,"emoji-flirt":61838,"emoji-happy":61839,"emoji-neutral":61840,"emoji-sad":61841,"erase":61842,"eraser":61843,"evernote":61844,"export":61845,"eye":61846,"eye-with-line":61847,"facebook":61848,"facebook-with-circle":61849,"feather":61850,"fingerprint":61851,"flag":61852,"flash":61853,"flashlight":61854,"flat-brush":61855,"flattr":61856,"flickr":61857,"flickr-with-circle":61858,"flow-branch":61859,"flow-cascade":61860,"flow-line":61861,"flow-parallel":61862,"flow-tree":61863,"flower":61864,"folder":61865,"folder-images":61866,"folder-music":61867,"folder-video":61868,"forward":61869,"foursquare":61870,"funnel":61871,"game-controller":61872,"gauge":61873,"github":61874,"github-with-circle":61875,"globe":61876,"google-":61877,"google--with-circle":61878,"google-drive":61879,"google-hangouts":61880,"google-play":61881,"graduation-cap":61882,"grid":61883,"grooveshark":61884,"hair-cross":61885,"hand":61886,"heart":61887,"heart-outlined":61888,"help":61889,"help-with-circle":61890,"home":61891,"hour-glass":61892,"houzz":61893,"icloud":61894,"image":61895,"image-inverted":61896,"images":61897,"inbox":61898,"infinity":61899,"info":61900,"info-with-circle":61901,"instagram":61902,"instagram-with-circle":61903,"install":61904,"key":61905,"keyboard":61906,"lab-flask":61907,"landline":61908,"language":61909,"laptop":61910,"lastfm":61911,"lastfm-with-circle":61912,"layers":61913,"leaf":61914,"level-down":61915,"level-up":61916,"lifebuoy":61917,"light-bulb":61918,"light-down":61919,"light-up":61920,"line-graph":61921,"link":61922,"linkedin":61923,"linkedin-with-circle":61924,"list":61925,"location":61926,"location-pin":61927,"lock":61928,"lock-open":61929,"log-out":61930,"login":61931,"loop":61932,"magnet":61933,"magnifying-glass":61934,"mail":61935,"mail-with-circle":61936,"man":61937,"map":61938,"mask":61939,"medal":61940,"medium":61941,"medium-with-circle":61942,"megaphone":61943,"menu":61944,"merge":61945,"message":61946,"mic":61947,"minus":61948,"mixi":61949,"mobile":61950,"modern-mic":61951,"moon":61952,"mouse":61953,"mouse-pointer":61954,"music":61955,"network":61956,"new":61957,"new-message":61958,"news":61959,"newsletter":61960,"note":61961,"notification":61962,"notifications-off":61963,"old-mobile":61964,"old-phone":61965,"onedrive":61966,"open-book":61967,"palette":61968,"paper-plane":61969,"paypal":61970,"pencil":61971,"phone":61972,"picasa":61973,"pie-chart":61974,"pin":61975,"pinterest":61976,"pinterest-with-circle":61977,"plus":61978,"popup":61979,"power-plug":61980,"price-ribbon":61981,"price-tag":61982,"print":61983,"progress-empty":61984,"progress-full":61985,"progress-one":61986,"progress-two":61987,"publish":61988,"qq":61989,"qq-with-circle":61990,"quote":61991,"radio":61992,"raft":61993,"raft-with-circle":61994,"rainbow":61995,"rdio":61996,"rdio-with-circle":61997,"remove-user":61998,"renren":61999,"reply":62000,"reply-all":62001,"resize-100-":62002,"resize-full-screen":62003,"retweet":62004,"rocket":62005,"round-brush":62006,"rss":62007,"ruler":62008,"save":62009,"scissors":62010,"scribd":62011,"select-arrows":62012,"share":62013,"share-alternative":62014,"shareable":62015,"shield":62016,"shop":62017,"shopping-bag":62018,"shopping-basket":62019,"shopping-cart":62020,"shuffle":62021,"signal":62022,"sina-weibo":62023,"skype":62024,"skype-with-circle":62025,"slideshare":62026,"smashing":62027,"sound":62028,"sound-mix":62029,"sound-mute":62030,"soundcloud":62031,"sports-club":62032,"spotify":62033,"spotify-with-circle":62034,"spreadsheet":62035,"squared-cross":62036,"squared-minus":62037,"squared-plus":62038,"star":62039,"star-outlined":62040,"stopwatch":62041,"stumbleupon":62042,"stumbleupon-with-circle":62043,"suitcase":62044,"swap":62045,"swarm":62046,"sweden":62047,"switch":62048,"tablet":62049,"tablet-mobile-combo":62050,"tag":62051,"text":62052,"text-document":62053,"text-document-inverted":62054,"thermometer":62055,"thumbs-down":62056,"thumbs-up":62057,"thunder-cloud":62058,"ticket":62059,"time-slot":62060,"tools":62061,"traffic-cone":62062,"trash":62063,"tree":62064,"triangle-down":62065,"triangle-left":62066,"triangle-right":62067,"triangle-up":62068,"tripadvisor":62069,"trophy":62070,"tumblr":62071,"tumblr-with-circle":62072,"tv":62073,"twitter":62074,"twitter-with-circle":62075,"typing":62076,"uninstall":62077,"unread":62078,"untag":62079,"upload":62080,"upload-to-cloud":62081,"user":62082,"users":62083,"v-card":62084,"video":62085,"video-camera":62086,"vimeo":62087,"vimeo-with-circle":62088,"vine":62089,"vine-with-circle":62090,"vinyl":62091,"vk":62092,"vk-alternitive":62093,"vk-with-circle":62094,"voicemail":62095,"wallet":62096,"warning":62097,"water":62098,"windows-store":62099,"xing":62100,"xing-with-circle":62101,"yelp":62102,"youko":62103,"youko-with-circle":62104,"youtube":62105,"youtube-with-circle":62106}

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(45);var _createIconSet2=_interopRequireDefault(_createIconSet);var _EvilIcons=__webpack_require__(878);var _EvilIcons2=_interopRequireDefault(_EvilIcons);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_EvilIcons2.default,'EvilIcons','EvilIcons.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports = {"archive":61696,"arrow-down":61697,"arrow-left":61698,"arrow-right":61699,"arrow-up":61700,"bell":61701,"calendar":61702,"camera":61703,"cart":61704,"chart":61705,"check":61706,"chevron-down":61707,"chevron-left":61708,"chevron-right":61709,"chevron-up":61710,"clock":61711,"close":61712,"close-o":61713,"comment":61714,"credit-card":61715,"envelope":61716,"exclamation":61717,"external-link":61718,"eye":61719,"gear":61720,"heart":61721,"image":61722,"like":61723,"link":61724,"location":61725,"lock":61726,"minus":61727,"navicon":61728,"paperclip":61729,"pencil":61730,"play":61731,"plus":61732,"pointer":61733,"question":61734,"redo":61735,"refresh":61736,"retweet":61737,"sc-facebook":61738,"sc-github":61739,"sc-google-plus":61740,"sc-instagram":61741,"sc-linkedin":61742,"sc-odnoklassniki":61743,"sc-pinterest":61744,"sc-skype":61745,"sc-soundcloud":61746,"sc-telegram":61747,"sc-tumblr":61748,"sc-twitter":61749,"sc-vimeo":61750,"sc-vk":61751,"sc-youtube":61752,"search":61753,"share-apple":61754,"share-google":61755,"spinner":61756,"spinner-2":61757,"spinner-3":61758,"star":61759,"tag":61760,"trash":61761,"trophy":61762,"undo":61763,"unlock":61764,"user":61765}

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(45);var _createIconSet2=_interopRequireDefault(_createIconSet);var _Feather=__webpack_require__(880);var _Feather2=_interopRequireDefault(_Feather);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_Feather2.default,'Feather','Feather.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports = {"activity":59648,"airplay":59649,"alert-circle":59650,"alert-octagon":59651,"alert-triangle":59652,"align-center":59653,"align-justify":59654,"align-left":59655,"align-right":59656,"anchor":59657,"aperture":59658,"arrow-down":59659,"arrow-down-left":59660,"arrow-down-right":59661,"arrow-left":59662,"arrow-right":59663,"arrow-up":59664,"arrow-up-left":59665,"arrow-up-right":59666,"at-sign":59667,"award":59668,"bar-chart":59669,"bar-chart-2":59670,"battery":59671,"battery-charging":59672,"bell":59673,"bell-off":59674,"bluetooth":59675,"bold":59676,"book":59677,"bookmark":59678,"box":59679,"briefcase":59680,"calendar":59681,"camera":59682,"camera-off":59683,"cast":59684,"check":59685,"check-circle":59686,"check-square":59687,"chevron-down":59688,"chevron-left":59689,"chevron-right":59690,"chevron-up":59691,"chevrons-down":59692,"chevrons-left":59693,"chevrons-right":59694,"chevrons-up":59695,"chrome":59696,"circle":59697,"clipboard":59698,"clock":59699,"cloud":59700,"cloud-drizzle":59701,"cloud-lightning":59702,"cloud-off":59703,"cloud-rain":59704,"cloud-snow":59705,"codepen":59706,"command":59707,"compass":59708,"copy":59709,"corner-down-left":59710,"corner-down-right":59711,"corner-left-down":59712,"corner-left-up":59713,"corner-right-down":59714,"corner-right-up":59715,"corner-up-left":59716,"corner-up-right":59717,"cpu":59718,"credit-card":59719,"crop":59720,"crosshair":59721,"delete":59722,"disc":59723,"download":59724,"download-cloud":59725,"droplet":59726,"edit":59727,"edit-2":59728,"edit-3":59729,"external-link":59730,"eye":59731,"eye-off":59732,"facebook":59733,"fast-forward":59734,"feather":59735,"file":59736,"file-minus":59737,"file-plus":59738,"file-text":59739,"film":59740,"filter":59741,"flag":59742,"folder":59743,"github":59744,"gitlab":59745,"globe":59746,"grid":59747,"hash":59748,"headphones":59749,"heart":59750,"help-circle":59751,"home":59752,"image":59753,"inbox":59754,"info":59755,"instagram":59756,"italic":59757,"layers":59758,"layout":59759,"life-buoy":59760,"link":59761,"link-2":59762,"list":59763,"loader":59764,"lock":59765,"log-in":59766,"log-out":59767,"mail":59768,"map":59769,"map-pin":59770,"maximize":59771,"maximize-2":59772,"menu":59773,"message-circle":59774,"message-square":59775,"mic":59776,"mic-off":59777,"minimize":59778,"minimize-2":59779,"minus":59780,"minus-circle":59781,"minus-square":59782,"monitor":59783,"moon":59784,"more-horizontal":59785,"more-vertical":59786,"move":59787,"music":59788,"navigation":59789,"navigation-2":59790,"octagon":59791,"package":59792,"paperclip":59793,"pause":59794,"pause-circle":59795,"percent":59796,"phone":59797,"phone-call":59798,"phone-forwarded":59799,"phone-incoming":59800,"phone-missed":59801,"phone-off":59802,"phone-outgoing":59803,"pie-chart":59804,"play":59805,"play-circle":59806,"plus":59807,"plus-circle":59808,"plus-square":59809,"pocket":59810,"power":59811,"printer":59812,"radio":59813,"refresh-ccw":59814,"refresh-cw":59815,"repeat":59816,"rewind":59817,"rotate-ccw":59818,"rotate-cw":59819,"save":59820,"scissors":59821,"search":59822,"server":59823,"settings":59824,"share":59825,"share-2":59826,"shield":59827,"shopping-cart":59828,"shuffle":59829,"sidebar":59830,"skip-back":59831,"skip-forward":59832,"slack":59833,"slash":59834,"sliders":59835,"smartphone":59836,"speaker":59837,"square":59838,"star":59839,"stop-circle":59840,"sun":59841,"sunrise":59842,"sunset":59843,"tablet":59844,"tag":59845,"target":59846,"thermometer":59847,"thumbs-down":59848,"thumbs-up":59849,"toggle-left":59850,"toggle-right":59851,"trash":59852,"trash-2":59853,"trending-down":59854,"trending-up":59855,"triangle":59856,"tv":59857,"twitter":59858,"type":59859,"umbrella":59860,"underline":59861,"unlock":59862,"upload":59863,"upload-cloud":59864,"user":59865,"user-check":59866,"user-minus":59867,"user-plus":59868,"user-x":59869,"users":59870,"video":59871,"video-off":59872,"voicemail":59873,"volume":59874,"volume-1":59875,"volume-2":59876,"volume-x":59877,"watch":59878,"wifi":59879,"wifi-off":59880,"wind":59881,"x":59882,"x-circle":59883,"x-square":59884,"zap":59885,"zoom-in":59886,"zoom-out":59887}

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(45);var _createIconSet2=_interopRequireDefault(_createIconSet);var _FontAwesome=__webpack_require__(882);var _FontAwesome2=_interopRequireDefault(_FontAwesome);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_FontAwesome2.default,'FontAwesome','FontAwesome.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports = {"glass":61440,"music":61441,"search":61442,"envelope-o":61443,"heart":61444,"star":61445,"star-o":61446,"user":61447,"film":61448,"th-large":61449,"th":61450,"th-list":61451,"check":61452,"remove":61453,"close":61453,"times":61453,"search-plus":61454,"search-minus":61456,"power-off":61457,"signal":61458,"gear":61459,"cog":61459,"trash-o":61460,"home":61461,"file-o":61462,"clock-o":61463,"road":61464,"download":61465,"arrow-circle-o-down":61466,"arrow-circle-o-up":61467,"inbox":61468,"play-circle-o":61469,"rotate-right":61470,"repeat":61470,"refresh":61473,"list-alt":61474,"lock":61475,"flag":61476,"headphones":61477,"volume-off":61478,"volume-down":61479,"volume-up":61480,"qrcode":61481,"barcode":61482,"tag":61483,"tags":61484,"book":61485,"bookmark":61486,"print":61487,"camera":61488,"font":61489,"bold":61490,"italic":61491,"text-height":61492,"text-width":61493,"align-left":61494,"align-center":61495,"align-right":61496,"align-justify":61497,"list":61498,"dedent":61499,"outdent":61499,"indent":61500,"video-camera":61501,"photo":61502,"image":61502,"picture-o":61502,"pencil":61504,"map-marker":61505,"adjust":61506,"tint":61507,"edit":61508,"pencil-square-o":61508,"share-square-o":61509,"check-square-o":61510,"arrows":61511,"step-backward":61512,"fast-backward":61513,"backward":61514,"play":61515,"pause":61516,"stop":61517,"forward":61518,"fast-forward":61520,"step-forward":61521,"eject":61522,"chevron-left":61523,"chevron-right":61524,"plus-circle":61525,"minus-circle":61526,"times-circle":61527,"check-circle":61528,"question-circle":61529,"info-circle":61530,"crosshairs":61531,"times-circle-o":61532,"check-circle-o":61533,"ban":61534,"arrow-left":61536,"arrow-right":61537,"arrow-up":61538,"arrow-down":61539,"mail-forward":61540,"share":61540,"expand":61541,"compress":61542,"plus":61543,"minus":61544,"asterisk":61545,"exclamation-circle":61546,"gift":61547,"leaf":61548,"fire":61549,"eye":61550,"eye-slash":61552,"warning":61553,"exclamation-triangle":61553,"plane":61554,"calendar":61555,"random":61556,"comment":61557,"magnet":61558,"chevron-up":61559,"chevron-down":61560,"retweet":61561,"shopping-cart":61562,"folder":61563,"folder-open":61564,"arrows-v":61565,"arrows-h":61566,"bar-chart-o":61568,"bar-chart":61568,"twitter-square":61569,"facebook-square":61570,"camera-retro":61571,"key":61572,"gears":61573,"cogs":61573,"comments":61574,"thumbs-o-up":61575,"thumbs-o-down":61576,"star-half":61577,"heart-o":61578,"sign-out":61579,"linkedin-square":61580,"thumb-tack":61581,"external-link":61582,"sign-in":61584,"trophy":61585,"github-square":61586,"upload":61587,"lemon-o":61588,"phone":61589,"square-o":61590,"bookmark-o":61591,"phone-square":61592,"twitter":61593,"facebook-f":61594,"facebook":61594,"github":61595,"unlock":61596,"credit-card":61597,"feed":61598,"rss":61598,"hdd-o":61600,"bullhorn":61601,"bell":61683,"certificate":61603,"hand-o-right":61604,"hand-o-left":61605,"hand-o-up":61606,"hand-o-down":61607,"arrow-circle-left":61608,"arrow-circle-right":61609,"arrow-circle-up":61610,"arrow-circle-down":61611,"globe":61612,"wrench":61613,"tasks":61614,"filter":61616,"briefcase":61617,"arrows-alt":61618,"group":61632,"users":61632,"chain":61633,"link":61633,"cloud":61634,"flask":61635,"cut":61636,"scissors":61636,"copy":61637,"files-o":61637,"paperclip":61638,"save":61639,"floppy-o":61639,"square":61640,"navicon":61641,"reorder":61641,"bars":61641,"list-ul":61642,"list-ol":61643,"strikethrough":61644,"underline":61645,"table":61646,"magic":61648,"truck":61649,"pinterest":61650,"pinterest-square":61651,"google-plus-square":61652,"google-plus":61653,"money":61654,"caret-down":61655,"caret-up":61656,"caret-left":61657,"caret-right":61658,"columns":61659,"unsorted":61660,"sort":61660,"sort-down":61661,"sort-desc":61661,"sort-up":61662,"sort-asc":61662,"envelope":61664,"linkedin":61665,"rotate-left":61666,"undo":61666,"legal":61667,"gavel":61667,"dashboard":61668,"tachometer":61668,"comment-o":61669,"comments-o":61670,"flash":61671,"bolt":61671,"sitemap":61672,"umbrella":61673,"paste":61674,"clipboard":61674,"lightbulb-o":61675,"exchange":61676,"cloud-download":61677,"cloud-upload":61678,"user-md":61680,"stethoscope":61681,"suitcase":61682,"bell-o":61602,"coffee":61684,"cutlery":61685,"file-text-o":61686,"building-o":61687,"hospital-o":61688,"ambulance":61689,"medkit":61690,"fighter-jet":61691,"beer":61692,"h-square":61693,"plus-square":61694,"angle-double-left":61696,"angle-double-right":61697,"angle-double-up":61698,"angle-double-down":61699,"angle-left":61700,"angle-right":61701,"angle-up":61702,"angle-down":61703,"desktop":61704,"laptop":61705,"tablet":61706,"mobile-phone":61707,"mobile":61707,"circle-o":61708,"quote-left":61709,"quote-right":61710,"spinner":61712,"circle":61713,"mail-reply":61714,"reply":61714,"github-alt":61715,"folder-o":61716,"folder-open-o":61717,"smile-o":61720,"frown-o":61721,"meh-o":61722,"gamepad":61723,"keyboard-o":61724,"flag-o":61725,"flag-checkered":61726,"terminal":61728,"code":61729,"mail-reply-all":61730,"reply-all":61730,"star-half-empty":61731,"star-half-full":61731,"star-half-o":61731,"location-arrow":61732,"crop":61733,"code-fork":61734,"unlink":61735,"chain-broken":61735,"question":61736,"info":61737,"exclamation":61738,"superscript":61739,"subscript":61740,"eraser":61741,"puzzle-piece":61742,"microphone":61744,"microphone-slash":61745,"shield":61746,"calendar-o":61747,"fire-extinguisher":61748,"rocket":61749,"maxcdn":61750,"chevron-circle-left":61751,"chevron-circle-right":61752,"chevron-circle-up":61753,"chevron-circle-down":61754,"html5":61755,"css3":61756,"anchor":61757,"unlock-alt":61758,"bullseye":61760,"ellipsis-h":61761,"ellipsis-v":61762,"rss-square":61763,"play-circle":61764,"ticket":61765,"minus-square":61766,"minus-square-o":61767,"level-up":61768,"level-down":61769,"check-square":61770,"pencil-square":61771,"external-link-square":61772,"share-square":61773,"compass":61774,"toggle-down":61776,"caret-square-o-down":61776,"toggle-up":61777,"caret-square-o-up":61777,"toggle-right":61778,"caret-square-o-right":61778,"euro":61779,"eur":61779,"gbp":61780,"dollar":61781,"usd":61781,"rupee":61782,"inr":61782,"cny":61783,"rmb":61783,"yen":61783,"jpy":61783,"ruble":61784,"rouble":61784,"rub":61784,"won":61785,"krw":61785,"bitcoin":61786,"btc":61786,"file":61787,"file-text":61788,"sort-alpha-asc":61789,"sort-alpha-desc":61790,"sort-amount-asc":61792,"sort-amount-desc":61793,"sort-numeric-asc":61794,"sort-numeric-desc":61795,"thumbs-up":61796,"thumbs-down":61797,"youtube-square":61798,"youtube":61799,"xing":61800,"xing-square":61801,"youtube-play":61802,"dropbox":61803,"stack-overflow":61804,"instagram":61805,"flickr":61806,"adn":61808,"bitbucket":61809,"bitbucket-square":61810,"tumblr":61811,"tumblr-square":61812,"long-arrow-down":61813,"long-arrow-up":61814,"long-arrow-left":61815,"long-arrow-right":61816,"apple":61817,"windows":61818,"android":61819,"linux":61820,"dribbble":61821,"skype":61822,"foursquare":61824,"trello":61825,"female":61826,"male":61827,"gittip":61828,"gratipay":61828,"sun-o":61829,"moon-o":61830,"archive":61831,"bug":61832,"vk":61833,"weibo":61834,"renren":61835,"pagelines":61836,"stack-exchange":61837,"arrow-circle-o-right":61838,"arrow-circle-o-left":61840,"toggle-left":61841,"caret-square-o-left":61841,"dot-circle-o":61842,"wheelchair":61843,"vimeo-square":61844,"turkish-lira":61845,"try":61845,"plus-square-o":61846,"space-shuttle":61847,"slack":61848,"envelope-square":61849,"wordpress":61850,"openid":61851,"institution":61852,"bank":61852,"university":61852,"mortar-board":61853,"graduation-cap":61853,"yahoo":61854,"google":61856,"reddit":61857,"reddit-square":61858,"stumbleupon-circle":61859,"stumbleupon":61860,"delicious":61861,"digg":61862,"pied-piper-pp":61863,"pied-piper-alt":61864,"drupal":61865,"joomla":61866,"language":61867,"fax":61868,"building":61869,"child":61870,"paw":61872,"spoon":61873,"cube":61874,"cubes":61875,"behance":61876,"behance-square":61877,"steam":61878,"steam-square":61879,"recycle":61880,"automobile":61881,"car":61881,"cab":61882,"taxi":61882,"tree":61883,"spotify":61884,"deviantart":61885,"soundcloud":61886,"database":61888,"file-pdf-o":61889,"file-word-o":61890,"file-excel-o":61891,"file-powerpoint-o":61892,"file-photo-o":61893,"file-picture-o":61893,"file-image-o":61893,"file-zip-o":61894,"file-archive-o":61894,"file-sound-o":61895,"file-audio-o":61895,"file-movie-o":61896,"file-video-o":61896,"file-code-o":61897,"vine":61898,"codepen":61899,"jsfiddle":61900,"life-bouy":61901,"life-buoy":61901,"life-saver":61901,"support":61901,"life-ring":61901,"circle-o-notch":61902,"ra":61904,"resistance":61904,"rebel":61904,"ge":61905,"empire":61905,"git-square":61906,"git":61907,"y-combinator-square":61908,"yc-square":61908,"hacker-news":61908,"tencent-weibo":61909,"qq":61910,"wechat":61911,"weixin":61911,"send":61912,"paper-plane":61912,"send-o":61913,"paper-plane-o":61913,"history":61914,"circle-thin":61915,"header":61916,"paragraph":61917,"sliders":61918,"share-alt":61920,"share-alt-square":61921,"bomb":61922,"soccer-ball-o":61923,"futbol-o":61923,"tty":61924,"binoculars":61925,"plug":61926,"slideshare":61927,"twitch":61928,"yelp":61929,"newspaper-o":61930,"wifi":61931,"calculator":61932,"paypal":61933,"google-wallet":61934,"cc-visa":61936,"cc-mastercard":61937,"cc-discover":61938,"cc-amex":61939,"cc-paypal":61940,"cc-stripe":61941,"bell-slash":61942,"bell-slash-o":61943,"trash":61944,"copyright":61945,"at":61946,"eyedropper":61947,"paint-brush":61948,"birthday-cake":61949,"area-chart":61950,"pie-chart":61952,"line-chart":61953,"lastfm":61954,"lastfm-square":61955,"toggle-off":61956,"toggle-on":61957,"bicycle":61958,"bus":61959,"ioxhost":61960,"angellist":61961,"cc":61962,"shekel":61963,"sheqel":61963,"ils":61963,"meanpath":61964,"buysellads":61965,"connectdevelop":61966,"dashcube":61968,"forumbee":61969,"leanpub":61970,"sellsy":61971,"shirtsinbulk":61972,"simplybuilt":61973,"skyatlas":61974,"cart-plus":61975,"cart-arrow-down":61976,"diamond":61977,"ship":61978,"user-secret":61979,"motorcycle":61980,"street-view":61981,"heartbeat":61982,"venus":61985,"mars":61986,"mercury":61987,"intersex":61988,"transgender":61988,"transgender-alt":61989,"venus-double":61990,"mars-double":61991,"venus-mars":61992,"mars-stroke":61993,"mars-stroke-v":61994,"mars-stroke-h":61995,"neuter":61996,"genderless":61997,"facebook-official":62000,"pinterest-p":62001,"whatsapp":62002,"server":62003,"user-plus":62004,"user-times":62005,"hotel":62006,"bed":62006,"viacoin":62007,"train":62008,"subway":62009,"medium":62010,"yc":62011,"y-combinator":62011,"optin-monster":62012,"opencart":62013,"expeditedssl":62014,"battery-4":62016,"battery":62016,"battery-full":62016,"battery-3":62017,"battery-three-quarters":62017,"battery-2":62018,"battery-half":62018,"battery-1":62019,"battery-quarter":62019,"battery-0":62020,"battery-empty":62020,"mouse-pointer":62021,"i-cursor":62022,"object-group":62023,"object-ungroup":62024,"sticky-note":62025,"sticky-note-o":62026,"cc-jcb":62027,"cc-diners-club":62028,"clone":62029,"balance-scale":62030,"hourglass-o":62032,"hourglass-1":62033,"hourglass-start":62033,"hourglass-2":62034,"hourglass-half":62034,"hourglass-3":62035,"hourglass-end":62035,"hourglass":62036,"hand-grab-o":62037,"hand-rock-o":62037,"hand-stop-o":62038,"hand-paper-o":62038,"hand-scissors-o":62039,"hand-lizard-o":62040,"hand-spock-o":62041,"hand-pointer-o":62042,"hand-peace-o":62043,"trademark":62044,"registered":62045,"creative-commons":62046,"gg":62048,"gg-circle":62049,"tripadvisor":62050,"odnoklassniki":62051,"odnoklassniki-square":62052,"get-pocket":62053,"wikipedia-w":62054,"safari":62055,"chrome":62056,"firefox":62057,"opera":62058,"internet-explorer":62059,"tv":62060,"television":62060,"contao":62061,"500px":62062,"amazon":62064,"calendar-plus-o":62065,"calendar-minus-o":62066,"calendar-times-o":62067,"calendar-check-o":62068,"industry":62069,"map-pin":62070,"map-signs":62071,"map-o":62072,"map":62073,"commenting":62074,"commenting-o":62075,"houzz":62076,"vimeo":62077,"black-tie":62078,"fonticons":62080,"reddit-alien":62081,"edge":62082,"credit-card-alt":62083,"codiepie":62084,"modx":62085,"fort-awesome":62086,"usb":62087,"product-hunt":62088,"mixcloud":62089,"scribd":62090,"pause-circle":62091,"pause-circle-o":62092,"stop-circle":62093,"stop-circle-o":62094,"shopping-bag":62096,"shopping-basket":62097,"hashtag":62098,"bluetooth":62099,"bluetooth-b":62100,"percent":62101,"gitlab":62102,"wpbeginner":62103,"wpforms":62104,"envira":62105,"universal-access":62106,"wheelchair-alt":62107,"question-circle-o":62108,"blind":62109,"audio-description":62110,"volume-control-phone":62112,"braille":62113,"assistive-listening-systems":62114,"asl-interpreting":62115,"american-sign-language-interpreting":62115,"deafness":62116,"hard-of-hearing":62116,"deaf":62116,"glide":62117,"glide-g":62118,"signing":62119,"sign-language":62119,"low-vision":62120,"viadeo":62121,"viadeo-square":62122,"snapchat":62123,"snapchat-ghost":62124,"snapchat-square":62125,"pied-piper":62126,"first-order":62128,"yoast":62129,"themeisle":62130,"google-plus-circle":62131,"google-plus-official":62131,"fa":62132,"font-awesome":62132,"handshake-o":62133,"envelope-open":62134,"envelope-open-o":62135,"linode":62136,"address-book":62137,"address-book-o":62138,"vcard":62139,"address-card":62139,"vcard-o":62140,"address-card-o":62140,"user-circle":62141,"user-circle-o":62142,"user-o":62144,"id-badge":62145,"drivers-license":62146,"id-card":62146,"drivers-license-o":62147,"id-card-o":62147,"quora":62148,"free-code-camp":62149,"telegram":62150,"thermometer-4":62151,"thermometer":62151,"thermometer-full":62151,"thermometer-3":62152,"thermometer-three-quarters":62152,"thermometer-2":62153,"thermometer-half":62153,"thermometer-1":62154,"thermometer-quarter":62154,"thermometer-0":62155,"thermometer-empty":62155,"shower":62156,"bathtub":62157,"s15":62157,"bath":62157,"podcast":62158,"window-maximize":62160,"window-minimize":62161,"window-restore":62162,"times-rectangle":62163,"window-close":62163,"times-rectangle-o":62164,"window-close-o":62164,"bandcamp":62165,"grav":62166,"etsy":62167,"imdb":62168,"ravelry":62169,"eercast":62170,"microchip":62171,"snowflake-o":62172,"superpowers":62173,"wpexplorer":62174,"meetup":62176}

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(45);var _createIconSet2=_interopRequireDefault(_createIconSet);var _Foundation=__webpack_require__(884);var _Foundation2=_interopRequireDefault(_Foundation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_Foundation2.default,'fontcustom','Foundation.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports = {"address-book":61696,"alert":61697,"align-center":61698,"align-justify":61699,"align-left":61700,"align-right":61701,"anchor":61702,"annotate":61703,"archive":61704,"arrow-down":61705,"arrow-left":61706,"arrow-right":61707,"arrow-up":61708,"arrows-compress":61709,"arrows-expand":61710,"arrows-in":61711,"arrows-out":61712,"asl":61713,"asterisk":61714,"at-sign":61715,"background-color":61716,"battery-empty":61717,"battery-full":61718,"battery-half":61719,"bitcoin-circle":61720,"bitcoin":61721,"blind":61722,"bluetooth":61723,"bold":61724,"book-bookmark":61725,"book":61726,"bookmark":61727,"braille":61728,"burst-new":61729,"burst-sale":61730,"burst":61731,"calendar":61732,"camera":61733,"check":61734,"checkbox":61735,"clipboard-notes":61736,"clipboard-pencil":61737,"clipboard":61738,"clock":61739,"closed-caption":61740,"cloud":61741,"comment-minus":61742,"comment-quotes":61743,"comment-video":61744,"comment":61745,"comments":61746,"compass":61747,"contrast":61748,"credit-card":61749,"crop":61750,"crown":61751,"css3":61752,"database":61753,"die-five":61754,"die-four":61755,"die-one":61756,"die-six":61757,"die-three":61758,"die-two":61759,"dislike":61760,"dollar-bill":61761,"dollar":61762,"download":61763,"eject":61764,"elevator":61765,"euro":61766,"eye":61767,"fast-forward":61768,"female-symbol":61769,"female":61770,"filter":61771,"first-aid":61772,"flag":61773,"folder-add":61774,"folder-lock":61775,"folder":61776,"foot":61777,"foundation":61778,"graph-bar":61779,"graph-horizontal":61780,"graph-pie":61781,"graph-trend":61782,"guide-dog":61783,"hearing-aid":61784,"heart":61785,"home":61786,"html5":61787,"indent-less":61788,"indent-more":61789,"info":61790,"italic":61791,"key":61792,"laptop":61793,"layout":61794,"lightbulb":61795,"like":61796,"link":61797,"list-bullet":61798,"list-number":61799,"list-thumbnails":61800,"list":61801,"lock":61802,"loop":61803,"magnifying-glass":61804,"mail":61805,"male-female":61806,"male-symbol":61807,"male":61808,"map":61809,"marker":61810,"megaphone":61811,"microphone":61812,"minus-circle":61813,"minus":61814,"mobile-signal":61815,"mobile":61816,"monitor":61817,"mountains":61818,"music":61819,"next":61820,"no-dogs":61821,"no-smoking":61822,"page-add":61823,"page-copy":61824,"page-csv":61825,"page-delete":61826,"page-doc":61827,"page-edit":61828,"page-export-csv":61829,"page-export-doc":61830,"page-export-pdf":61831,"page-export":61832,"page-filled":61833,"page-multiple":61834,"page-pdf":61835,"page-remove":61836,"page-search":61837,"page":61838,"paint-bucket":61839,"paperclip":61840,"pause":61841,"paw":61842,"paypal":61843,"pencil":61844,"photo":61845,"play-circle":61846,"play-video":61847,"play":61848,"plus":61849,"pound":61850,"power":61851,"previous":61852,"price-tag":61853,"pricetag-multiple":61854,"print":61855,"prohibited":61856,"projection-screen":61857,"puzzle":61858,"quote":61859,"record":61860,"refresh":61861,"results-demographics":61862,"results":61863,"rewind-ten":61864,"rewind":61865,"rss":61866,"safety-cone":61867,"save":61868,"share":61869,"sheriff-badge":61870,"shield":61871,"shopping-bag":61872,"shopping-cart":61873,"shuffle":61874,"skull":61875,"social-500px":61876,"social-adobe":61877,"social-amazon":61878,"social-android":61879,"social-apple":61880,"social-behance":61881,"social-bing":61882,"social-blogger":61883,"social-delicious":61884,"social-designer-news":61885,"social-deviant-art":61886,"social-digg":61887,"social-dribbble":61888,"social-drive":61889,"social-dropbox":61890,"social-evernote":61891,"social-facebook":61892,"social-flickr":61893,"social-forrst":61894,"social-foursquare":61895,"social-game-center":61896,"social-github":61897,"social-google-plus":61898,"social-hacker-news":61899,"social-hi5":61900,"social-instagram":61901,"social-joomla":61902,"social-lastfm":61903,"social-linkedin":61904,"social-medium":61905,"social-myspace":61906,"social-orkut":61907,"social-path":61908,"social-picasa":61909,"social-pinterest":61910,"social-rdio":61911,"social-reddit":61912,"social-skillshare":61913,"social-skype":61914,"social-smashing-mag":61915,"social-snapchat":61916,"social-spotify":61917,"social-squidoo":61918,"social-stack-overflow":61919,"social-steam":61920,"social-stumbleupon":61921,"social-treehouse":61922,"social-tumblr":61923,"social-twitter":61924,"social-vimeo":61925,"social-windows":61926,"social-xbox":61927,"social-yahoo":61928,"social-yelp":61929,"social-youtube":61930,"social-zerply":61931,"social-zurb":61932,"sound":61933,"star":61934,"stop":61935,"strikethrough":61936,"subscript":61937,"superscript":61938,"tablet-landscape":61939,"tablet-portrait":61940,"target-two":61941,"target":61942,"telephone-accessible":61943,"telephone":61944,"text-color":61945,"thumbnails":61946,"ticket":61947,"torso-business":61948,"torso-female":61949,"torso":61950,"torsos-all-female":61951,"torsos-all":61952,"torsos-female-male":61953,"torsos-male-female":61954,"torsos":61955,"trash":61956,"trees":61957,"trophy":61958,"underline":61959,"universal-access":61960,"unlink":61961,"unlock":61962,"upload-cloud":61963,"upload":61964,"usb":61965,"video":61966,"volume-none":61967,"volume-strike":61968,"volume":61969,"web":61970,"wheelchair":61971,"widget":61972,"wrench":61973,"x-circle":61974,"x":61975,"yen":61976,"zoom-in":61977,"zoom-out":61978}

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(45);var _createIconSet2=_interopRequireDefault(_createIconSet);var _Ionicons=__webpack_require__(886);var _Ionicons2=_interopRequireDefault(_Ionicons);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_Ionicons2.default,'Ionicons','Ionicons.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports = {"ios-add":61698,"ios-add-circle":61697,"ios-add-circle-outline":61696,"ios-add-outline":61698,"ios-alarm":62408,"ios-alarm-outline":62407,"ios-albums":62410,"ios-albums-outline":62409,"ios-alert":61700,"ios-alert-outline":61699,"ios-american-football":61702,"ios-american-football-outline":61701,"ios-analytics":62414,"ios-analytics-outline":62413,"ios-aperture":61704,"ios-aperture-outline":61703,"ios-apps":61706,"ios-apps-outline":61705,"ios-appstore":61708,"ios-appstore-outline":61707,"ios-archive":61710,"ios-archive-outline":61709,"ios-arrow-back":62415,"ios-arrow-back-outline":62415,"ios-arrow-down":62416,"ios-arrow-down-outline":62416,"ios-arrow-dropdown":61712,"ios-arrow-dropdown-circle":61711,"ios-arrow-dropdown-circle-outline":61711,"ios-arrow-dropdown-outline":61712,"ios-arrow-dropleft":61714,"ios-arrow-dropleft-circle":61713,"ios-arrow-dropleft-circle-outline":61713,"ios-arrow-dropleft-outline":61714,"ios-arrow-dropright":61716,"ios-arrow-dropright-circle":61715,"ios-arrow-dropright-circle-outline":61715,"ios-arrow-dropright-outline":61716,"ios-arrow-dropup":61718,"ios-arrow-dropup-circle":61717,"ios-arrow-dropup-circle-outline":61717,"ios-arrow-dropup-outline":61718,"ios-arrow-forward":62417,"ios-arrow-forward-outline":62417,"ios-arrow-round-back":61719,"ios-arrow-round-back-outline":61719,"ios-arrow-round-down":61720,"ios-arrow-round-down-outline":61720,"ios-arrow-round-forward":61721,"ios-arrow-round-forward-outline":61721,"ios-arrow-round-up":61722,"ios-arrow-round-up-outline":61722,"ios-arrow-up":62424,"ios-arrow-up-outline":62424,"ios-at":62426,"ios-at-outline":62425,"ios-attach":61723,"ios-attach-outline":61723,"ios-backspace":61725,"ios-backspace-outline":61724,"ios-barcode":62428,"ios-barcode-outline":62427,"ios-baseball":62430,"ios-baseball-outline":62429,"ios-basket":61727,"ios-basket-outline":61726,"ios-basketball":62432,"ios-basketball-outline":62431,"ios-battery-charging":61728,"ios-battery-charging-outline":61728,"ios-battery-dead":61729,"ios-battery-dead-outline":61729,"ios-battery-full":61730,"ios-battery-full-outline":61730,"ios-beaker":61732,"ios-beaker-outline":61731,"ios-beer":61734,"ios-beer-outline":61733,"ios-bicycle":61735,"ios-bicycle-outline":61735,"ios-bluetooth":61736,"ios-bluetooth-outline":61736,"ios-boat":61738,"ios-boat-outline":61737,"ios-body":62436,"ios-body-outline":62435,"ios-bonfire":61740,"ios-bonfire-outline":61739,"ios-book":62440,"ios-book-outline":62439,"ios-bookmark":61742,"ios-bookmark-outline":61741,"ios-bookmarks":62442,"ios-bookmarks-outline":62441,"ios-bowtie":61744,"ios-bowtie-outline":61743,"ios-briefcase":62446,"ios-briefcase-outline":62445,"ios-browsers":62448,"ios-browsers-outline":62447,"ios-brush":61746,"ios-brush-outline":61745,"ios-bug":61748,"ios-bug-outline":61747,"ios-build":61750,"ios-build-outline":61749,"ios-bulb":61752,"ios-bulb-outline":61751,"ios-bus":61754,"ios-bus-outline":61753,"ios-cafe":61756,"ios-cafe-outline":61755,"ios-calculator":62450,"ios-calculator-outline":62449,"ios-calendar":62452,"ios-calendar-outline":62451,"ios-call":61758,"ios-call-outline":61757,"ios-camera":62454,"ios-camera-outline":62453,"ios-car":61760,"ios-car-outline":61759,"ios-card":61762,"ios-card-outline":61761,"ios-cart":62456,"ios-cart-outline":62455,"ios-cash":61764,"ios-cash-outline":61763,"ios-chatboxes":62458,"ios-chatboxes-outline":62457,"ios-chatbubbles":61766,"ios-chatbubbles-outline":61765,"ios-checkbox":61768,"ios-checkbox-outline":61767,"ios-checkmark":62463,"ios-checkmark-circle":61770,"ios-checkmark-circle-outline":61769,"ios-checkmark-outline":62463,"ios-clipboard":61772,"ios-clipboard-outline":61771,"ios-clock":62467,"ios-clock-outline":62466,"ios-close":62470,"ios-close-circle":61774,"ios-close-circle-outline":61773,"ios-close-outline":62470,"ios-closed-captioning":61776,"ios-closed-captioning-outline":61775,"ios-cloud":62476,"ios-cloud-circle":61778,"ios-cloud-circle-outline":61777,"ios-cloud-done":61780,"ios-cloud-done-outline":61779,"ios-cloud-download":62472,"ios-cloud-download-outline":62471,"ios-cloud-outline":62473,"ios-cloud-upload":62475,"ios-cloud-upload-outline":62474,"ios-cloudy":62480,"ios-cloudy-night":62478,"ios-cloudy-night-outline":62477,"ios-cloudy-outline":62479,"ios-code":61783,"ios-code-download":61781,"ios-code-download-outline":61781,"ios-code-outline":61783,"ios-code-working":61782,"ios-code-working-outline":61782,"ios-cog":62482,"ios-cog-outline":62481,"ios-color-fill":61785,"ios-color-fill-outline":61784,"ios-color-filter":62484,"ios-color-filter-outline":62483,"ios-color-palette":61787,"ios-color-palette-outline":61786,"ios-color-wand":62486,"ios-color-wand-outline":62485,"ios-compass":61789,"ios-compass-outline":61788,"ios-construct":61791,"ios-construct-outline":61790,"ios-contact":62490,"ios-contact-outline":62489,"ios-contacts":61793,"ios-contacts-outline":61792,"ios-contract":61794,"ios-contract-outline":61794,"ios-contrast":61795,"ios-contrast-outline":61795,"ios-copy":62492,"ios-copy-outline":62491,"ios-create":61797,"ios-create-outline":61796,"ios-crop":62494,"ios-crop-outline":61798,"ios-cube":61800,"ios-cube-outline":61799,"ios-cut":61802,"ios-cut-outline":61801,"ios-desktop":61804,"ios-desktop-outline":61803,"ios-disc":61806,"ios-disc-outline":61805,"ios-document":61808,"ios-document-outline":61807,"ios-done-all":61809,"ios-done-all-outline":61809,"ios-download":62496,"ios-download-outline":62495,"ios-easel":61811,"ios-easel-outline":61810,"ios-egg":61813,"ios-egg-outline":61812,"ios-exit":61815,"ios-exit-outline":61814,"ios-expand":61816,"ios-expand-outline":61816,"ios-eye":62501,"ios-eye-off":61818,"ios-eye-off-outline":61817,"ios-eye-outline":62500,"ios-fastforward":62503,"ios-fastforward-outline":62502,"ios-female":61819,"ios-female-outline":61819,"ios-filing":62505,"ios-filing-outline":62504,"ios-film":62507,"ios-film-outline":62506,"ios-finger-print":61820,"ios-finger-print-outline":61820,"ios-flag":62509,"ios-flag-outline":62508,"ios-flame":62511,"ios-flame-outline":62510,"ios-flash":61822,"ios-flash-outline":61821,"ios-flask":62513,"ios-flask-outline":62512,"ios-flower":62515,"ios-flower-outline":62514,"ios-folder":62517,"ios-folder-open":61824,"ios-folder-open-outline":61823,"ios-folder-outline":62516,"ios-football":62519,"ios-football-outline":62518,"ios-funnel":61826,"ios-funnel-outline":61825,"ios-game-controller-a":62521,"ios-game-controller-a-outline":62520,"ios-game-controller-b":62523,"ios-game-controller-b-outline":62522,"ios-git-branch":61827,"ios-git-branch-outline":61827,"ios-git-commit":61828,"ios-git-commit-outline":61828,"ios-git-compare":61829,"ios-git-compare-outline":61829,"ios-git-merge":61830,"ios-git-merge-outline":61830,"ios-git-network":61831,"ios-git-network-outline":61831,"ios-git-pull-request":61832,"ios-git-pull-request-outline":61832,"ios-glasses":62527,"ios-glasses-outline":62526,"ios-globe":61834,"ios-globe-outline":61833,"ios-grid":61836,"ios-grid-outline":61835,"ios-hammer":61838,"ios-hammer-outline":61837,"ios-hand":61840,"ios-hand-outline":61839,"ios-happy":61842,"ios-happy-outline":61841,"ios-headset":61844,"ios-headset-outline":61843,"ios-heart":62531,"ios-heart-outline":62530,"ios-help":62534,"ios-help-buoy":61846,"ios-help-buoy-outline":61845,"ios-help-circle":61848,"ios-help-circle-outline":61847,"ios-help-outline":62534,"ios-home":62536,"ios-home-outline":62535,"ios-ice-cream":61850,"ios-ice-cream-outline":61849,"ios-image":61852,"ios-image-outline":61851,"ios-images":61854,"ios-images-outline":61853,"ios-infinite":62538,"ios-infinite-outline":62537,"ios-information":62541,"ios-information-circle":61856,"ios-information-circle-outline":61855,"ios-information-outline":62541,"ios-ionic":61857,"ios-ionic-outline":62542,"ios-ionitron":61859,"ios-ionitron-outline":61858,"ios-jet":61861,"ios-jet-outline":61860,"ios-key":61863,"ios-key-outline":61862,"ios-keypad":62544,"ios-keypad-outline":62543,"ios-laptop":61864,"ios-laptop-outline":61864,"ios-leaf":61866,"ios-leaf-outline":61865,"ios-link":61994,"ios-link-outline":61898,"ios-list":62548,"ios-list-box":61868,"ios-list-box-outline":61867,"ios-list-outline":62548,"ios-locate":61870,"ios-locate-outline":61869,"ios-lock":61872,"ios-lock-outline":61871,"ios-log-in":61873,"ios-log-in-outline":61873,"ios-log-out":61874,"ios-log-out-outline":61874,"ios-magnet":61876,"ios-magnet-outline":61875,"ios-mail":61880,"ios-mail-open":61878,"ios-mail-open-outline":61877,"ios-mail-outline":61879,"ios-male":61881,"ios-male-outline":61881,"ios-man":61883,"ios-man-outline":61882,"ios-map":61885,"ios-map-outline":61884,"ios-medal":61887,"ios-medal-outline":61886,"ios-medical":62556,"ios-medical-outline":62555,"ios-medkit":62558,"ios-medkit-outline":62557,"ios-megaphone":61889,"ios-megaphone-outline":61888,"ios-menu":61891,"ios-menu-outline":61890,"ios-mic":62561,"ios-mic-off":62559,"ios-mic-off-outline":61892,"ios-mic-outline":62560,"ios-microphone":61894,"ios-microphone-outline":61893,"ios-moon":62568,"ios-moon-outline":62567,"ios-more":61896,"ios-more-outline":61895,"ios-move":61899,"ios-move-outline":61899,"ios-musical-note":62571,"ios-musical-note-outline":61900,"ios-musical-notes":62572,"ios-musical-notes-outline":61901,"ios-navigate":62574,"ios-navigate-outline":62573,"ios-no-smoking":61903,"ios-no-smoking-outline":61902,"ios-notifications":61907,"ios-notifications-off":61905,"ios-notifications-off-outline":61904,"ios-notifications-outline":61906,"ios-nuclear":61909,"ios-nuclear-outline":61908,"ios-nutrition":62576,"ios-nutrition-outline":62575,"ios-open":61911,"ios-open-outline":61910,"ios-options":61913,"ios-options-outline":61912,"ios-outlet":61915,"ios-outlet-outline":61914,"ios-paper":62578,"ios-paper-outline":62577,"ios-paper-plane":61917,"ios-paper-plane-outline":61916,"ios-partly-sunny":61919,"ios-partly-sunny-outline":61918,"ios-pause":62584,"ios-pause-outline":62583,"ios-paw":62586,"ios-paw-outline":62585,"ios-people":62588,"ios-people-outline":62587,"ios-person":62590,"ios-person-add":61921,"ios-person-add-outline":61920,"ios-person-outline":62589,"ios-phone-landscape":61922,"ios-phone-landscape-outline":61922,"ios-phone-portrait":61923,"ios-phone-portrait-outline":61923,"ios-photos":62594,"ios-photos-outline":62593,"ios-pie":62596,"ios-pie-outline":62595,"ios-pin":61925,"ios-pin-outline":61924,"ios-pint":62598,"ios-pint-outline":62597,"ios-pizza":61927,"ios-pizza-outline":61926,"ios-plane":61929,"ios-plane-outline":61928,"ios-planet":61931,"ios-planet-outline":61930,"ios-play":62600,"ios-play-outline":62599,"ios-podium":61933,"ios-podium-outline":61932,"ios-power":61935,"ios-power-outline":61934,"ios-pricetag":62605,"ios-pricetag-outline":62604,"ios-pricetags":62607,"ios-pricetags-outline":62606,"ios-print":61937,"ios-print-outline":61936,"ios-pulse":62611,"ios-pulse-outline":61938,"ios-qr-scanner":61939,"ios-qr-scanner-outline":61939,"ios-quote":61941,"ios-quote-outline":61940,"ios-radio":61945,"ios-radio-button-off":61942,"ios-radio-button-off-outline":61942,"ios-radio-button-on":61943,"ios-radio-button-on-outline":61943,"ios-radio-outline":61944,"ios-rainy":62613,"ios-rainy-outline":62612,"ios-recording":62615,"ios-recording-outline":62614,"ios-redo":62617,"ios-redo-outline":62616,"ios-refresh":62620,"ios-refresh-circle":61990,"ios-refresh-circle-outline":61988,"ios-refresh-outline":62620,"ios-remove":61948,"ios-remove-circle":61947,"ios-remove-circle-outline":61946,"ios-remove-outline":61948,"ios-reorder":61949,"ios-reorder-outline":61949,"ios-repeat":61950,"ios-repeat-outline":61950,"ios-resize":61951,"ios-resize-outline":61951,"ios-restaurant":61953,"ios-restaurant-outline":61952,"ios-return-left":61954,"ios-return-left-outline":61954,"ios-return-right":61955,"ios-return-right-outline":61955,"ios-reverse-camera":62623,"ios-reverse-camera-outline":62622,"ios-rewind":62625,"ios-rewind-outline":62624,"ios-ribbon":61957,"ios-ribbon-outline":61956,"ios-rose":62627,"ios-rose-outline":62626,"ios-sad":61959,"ios-sad-outline":61958,"ios-school":61961,"ios-school-outline":61960,"ios-search":62629,"ios-search-outline":61962,"ios-send":61964,"ios-send-outline":61963,"ios-settings":62631,"ios-settings-outline":61965,"ios-share":61969,"ios-share-alt":61967,"ios-share-alt-outline":61966,"ios-share-outline":61968,"ios-shirt":61971,"ios-shirt-outline":61970,"ios-shuffle":62633,"ios-shuffle-outline":62633,"ios-skip-backward":61973,"ios-skip-backward-outline":61972,"ios-skip-forward":61975,"ios-skip-forward-outline":61974,"ios-snow":61976,"ios-snow-outline":61996,"ios-speedometer":62640,"ios-speedometer-outline":62639,"ios-square":61978,"ios-square-outline":61977,"ios-star":62643,"ios-star-half":62641,"ios-star-half-outline":62641,"ios-star-outline":62642,"ios-stats":61980,"ios-stats-outline":61979,"ios-stopwatch":62645,"ios-stopwatch-outline":62644,"ios-subway":61982,"ios-subway-outline":61981,"ios-sunny":62647,"ios-sunny-outline":62646,"ios-swap":61983,"ios-swap-outline":61983,"ios-switch":61985,"ios-switch-outline":61984,"ios-sync":61986,"ios-sync-outline":61986,"ios-tablet-landscape":61987,"ios-tablet-landscape-outline":61987,"ios-tablet-portrait":62030,"ios-tablet-portrait-outline":62030,"ios-tennisball":62651,"ios-tennisball-outline":62650,"ios-text":62032,"ios-text-outline":62031,"ios-thermometer":62034,"ios-thermometer-outline":62033,"ios-thumbs-down":62036,"ios-thumbs-down-outline":62035,"ios-thumbs-up":62038,"ios-thumbs-up-outline":62037,"ios-thunderstorm":62653,"ios-thunderstorm-outline":62652,"ios-time":62655,"ios-time-outline":62654,"ios-timer":62657,"ios-timer-outline":62656,"ios-train":62040,"ios-train-outline":62039,"ios-transgender":62041,"ios-transgender-outline":62041,"ios-trash":62661,"ios-trash-outline":62660,"ios-trending-down":62042,"ios-trending-down-outline":62042,"ios-trending-up":62043,"ios-trending-up-outline":62043,"ios-trophy":62045,"ios-trophy-outline":62044,"ios-umbrella":62047,"ios-umbrella-outline":62046,"ios-undo":62663,"ios-undo-outline":62662,"ios-unlock":62049,"ios-unlock-outline":62048,"ios-videocam":62669,"ios-videocam-outline":62668,"ios-volume-down":62050,"ios-volume-down-outline":62050,"ios-volume-mute":62051,"ios-volume-mute-outline":62051,"ios-volume-off":62052,"ios-volume-off-outline":62052,"ios-volume-up":62053,"ios-volume-up-outline":62053,"ios-walk":62054,"ios-walk-outline":62054,"ios-warning":62056,"ios-warning-outline":62055,"ios-watch":62057,"ios-watch-outline":62057,"ios-water":62059,"ios-water-outline":62058,"ios-wifi":62061,"ios-wifi-outline":62060,"ios-wine":62063,"ios-wine-outline":62062,"ios-woman":62065,"ios-woman-outline":62064,"logo-android":61989,"logo-angular":61991,"logo-apple":61993,"logo-bitcoin":61995,"logo-buffer":61997,"logo-chrome":61999,"logo-codepen":62000,"logo-css3":62001,"logo-designernews":62002,"logo-dribbble":62003,"logo-dropbox":62004,"logo-euro":62005,"logo-facebook":62006,"logo-foursquare":62007,"logo-freebsd-devil":62008,"logo-github":62009,"logo-google":62010,"logo-googleplus":62011,"logo-hackernews":62012,"logo-html5":62013,"logo-instagram":62014,"logo-javascript":62015,"logo-linkedin":62016,"logo-markdown":62017,"logo-nodejs":62018,"logo-octocat":62019,"logo-pinterest":62020,"logo-playstation":62021,"logo-python":62022,"logo-reddit":62023,"logo-rss":62024,"logo-sass":62025,"logo-skype":62026,"logo-snapchat":62027,"logo-steam":62028,"logo-tumblr":62029,"logo-tux":62126,"logo-twitch":62127,"logo-twitter":62128,"logo-usd":62129,"logo-vimeo":62148,"logo-whatsapp":62149,"logo-windows":62255,"logo-wordpress":62256,"logo-xbox":62284,"logo-yahoo":62285,"logo-yen":62286,"logo-youtube":62287,"md-add":62067,"md-add-circle":62066,"md-alarm":62068,"md-albums":62069,"md-alert":62070,"md-american-football":62071,"md-analytics":62072,"md-aperture":62073,"md-apps":62074,"md-appstore":62075,"md-archive":62076,"md-arrow-back":62077,"md-arrow-down":62078,"md-arrow-dropdown":62080,"md-arrow-dropdown-circle":62079,"md-arrow-dropleft":62082,"md-arrow-dropleft-circle":62081,"md-arrow-dropright":62084,"md-arrow-dropright-circle":62083,"md-arrow-dropup":62086,"md-arrow-dropup-circle":62085,"md-arrow-forward":62087,"md-arrow-round-back":62088,"md-arrow-round-down":62089,"md-arrow-round-forward":62090,"md-arrow-round-up":62091,"md-arrow-up":62092,"md-at":62093,"md-attach":62094,"md-backspace":62095,"md-barcode":62096,"md-baseball":62097,"md-basket":62098,"md-basketball":62099,"md-battery-charging":62100,"md-battery-dead":62101,"md-battery-full":62102,"md-beaker":62103,"md-beer":62104,"md-bicycle":62105,"md-bluetooth":62106,"md-boat":62107,"md-body":62108,"md-bonfire":62109,"md-book":62110,"md-bookmark":62111,"md-bookmarks":62112,"md-bowtie":62113,"md-briefcase":62114,"md-browsers":62115,"md-brush":62116,"md-bug":62117,"md-build":62118,"md-bulb":62119,"md-bus":62120,"md-cafe":62121,"md-calculator":62122,"md-calendar":62123,"md-call":62124,"md-camera":62125,"md-car":62130,"md-card":62131,"md-cart":62132,"md-cash":62133,"md-chatboxes":62134,"md-chatbubbles":62135,"md-checkbox":62137,"md-checkbox-outline":62136,"md-checkmark":62140,"md-checkmark-circle":62139,"md-checkmark-circle-outline":62138,"md-clipboard":62141,"md-clock":62142,"md-close":62144,"md-close-circle":62143,"md-closed-captioning":62145,"md-cloud":62153,"md-cloud-circle":62146,"md-cloud-done":62147,"md-cloud-download":62150,"md-cloud-outline":62151,"md-cloud-upload":62152,"md-cloudy":62155,"md-cloudy-night":62154,"md-code":62158,"md-code-download":62156,"md-code-working":62157,"md-cog":62159,"md-color-fill":62160,"md-color-filter":62161,"md-color-palette":62162,"md-color-wand":62163,"md-compass":62164,"md-construct":62165,"md-contact":62166,"md-contacts":62167,"md-contract":62168,"md-contrast":62169,"md-copy":62170,"md-create":62171,"md-crop":62172,"md-cube":62173,"md-cut":62174,"md-desktop":62175,"md-disc":62176,"md-document":62177,"md-done-all":62178,"md-download":62179,"md-easel":62180,"md-egg":62181,"md-exit":62182,"md-expand":62183,"md-eye":62185,"md-eye-off":62184,"md-fastforward":62186,"md-female":62187,"md-filing":62188,"md-film":62189,"md-finger-print":62190,"md-flag":62191,"md-flame":62192,"md-flash":62193,"md-flask":62194,"md-flower":62195,"md-folder":62197,"md-folder-open":62196,"md-football":62198,"md-funnel":62199,"md-game-controller-a":62200,"md-game-controller-b":62201,"md-git-branch":62202,"md-git-commit":62203,"md-git-compare":62204,"md-git-merge":62205,"md-git-network":62206,"md-git-pull-request":62207,"md-glasses":62208,"md-globe":62209,"md-grid":62210,"md-hammer":62211,"md-hand":62212,"md-happy":62213,"md-headset":62214,"md-heart":62216,"md-heart-outline":62215,"md-help":62219,"md-help-buoy":62217,"md-help-circle":62218,"md-home":62220,"md-ice-cream":62221,"md-image":62222,"md-images":62223,"md-infinite":62224,"md-information":62226,"md-information-circle":62225,"md-ionic":62227,"md-ionitron":62228,"md-jet":62229,"md-key":62230,"md-keypad":62231,"md-laptop":62232,"md-leaf":62233,"md-link":61998,"md-list":62235,"md-list-box":62234,"md-locate":62236,"md-lock":62237,"md-log-in":62238,"md-log-out":62239,"md-magnet":62240,"md-mail":62242,"md-mail-open":62241,"md-male":62243,"md-man":62244,"md-map":62245,"md-medal":62246,"md-medical":62247,"md-medkit":62248,"md-megaphone":62249,"md-menu":62250,"md-mic":62252,"md-mic-off":62251,"md-microphone":62253,"md-moon":62254,"md-more":61897,"md-move":62257,"md-musical-note":62258,"md-musical-notes":62259,"md-navigate":62260,"md-no-smoking":62261,"md-notifications":62264,"md-notifications-off":62262,"md-notifications-outline":62263,"md-nuclear":62265,"md-nutrition":62266,"md-open":62267,"md-options":62268,"md-outlet":62269,"md-paper":62271,"md-paper-plane":62270,"md-partly-sunny":62272,"md-pause":62273,"md-paw":62274,"md-people":62275,"md-person":62277,"md-person-add":62276,"md-phone-landscape":62278,"md-phone-portrait":62279,"md-photos":62280,"md-pie":62281,"md-pin":62282,"md-pint":62283,"md-pizza":62292,"md-plane":62293,"md-planet":62294,"md-play":62295,"md-podium":62296,"md-power":62297,"md-pricetag":62298,"md-pricetags":62299,"md-print":62300,"md-pulse":62301,"md-qr-scanner":62302,"md-quote":62303,"md-radio":62306,"md-radio-button-off":62304,"md-radio-button-on":62305,"md-rainy":62307,"md-recording":62308,"md-redo":62309,"md-refresh":62310,"md-refresh-circle":61992,"md-remove":62312,"md-remove-circle":62311,"md-reorder":62313,"md-repeat":62314,"md-resize":62315,"md-restaurant":62316,"md-return-left":62317,"md-return-right":62318,"md-reverse-camera":62319,"md-rewind":62320,"md-ribbon":62321,"md-rose":62322,"md-sad":62323,"md-school":62324,"md-search":62325,"md-send":62326,"md-settings":62327,"md-share":62329,"md-share-alt":62328,"md-shirt":62330,"md-shuffle":62331,"md-skip-backward":62332,"md-skip-forward":62333,"md-snow":62334,"md-speedometer":62335,"md-square":62337,"md-square-outline":62336,"md-star":62340,"md-star-half":62338,"md-star-outline":62339,"md-stats":62341,"md-stopwatch":62342,"md-subway":62343,"md-sunny":62344,"md-swap":62345,"md-switch":62346,"md-sync":62347,"md-tablet-landscape":62348,"md-tablet-portrait":62349,"md-tennisball":62350,"md-text":62351,"md-thermometer":62352,"md-thumbs-down":62353,"md-thumbs-up":62354,"md-thunderstorm":62355,"md-time":62356,"md-timer":62357,"md-train":62358,"md-transgender":62359,"md-trash":62360,"md-trending-down":62361,"md-trending-up":62362,"md-trophy":62363,"md-umbrella":62364,"md-undo":62365,"md-unlock":62366,"md-videocam":62367,"md-volume-down":62368,"md-volume-mute":62369,"md-volume-off":62370,"md-volume-up":62371,"md-walk":62372,"md-warning":62373,"md-watch":62374,"md-water":62375,"md-wifi":62376,"md-wine":62377,"md-woman":62378}

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(45);var _createIconSet2=_interopRequireDefault(_createIconSet);var _MaterialCommunityIcons=__webpack_require__(888);var _MaterialCommunityIcons2=_interopRequireDefault(_MaterialCommunityIcons);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_MaterialCommunityIcons2.default,'Material Design Icons','MaterialCommunityIcons.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports = {"access-point":61442,"access-point-network":61443,"account":61444,"account-alert":61445,"account-box":61446,"account-box-outline":61447,"account-card-details":62930,"account-check":61448,"account-circle":61449,"account-convert":61450,"account-edit":63163,"account-key":61451,"account-location":61452,"account-minus":61453,"account-multiple":61454,"account-multiple-minus":62931,"account-multiple-outline":61455,"account-multiple-plus":61456,"account-multiple-plus-outline":63487,"account-network":61457,"account-off":61458,"account-outline":61459,"account-plus":61460,"account-plus-outline":63488,"account-remove":61461,"account-search":61462,"account-settings":63024,"account-settings-variant":63025,"account-star":61463,"account-switch":61465,"adjust":61466,"air-conditioner":61467,"airballoon":61468,"airplane":61469,"airplane-landing":62932,"airplane-off":61470,"airplane-takeoff":62933,"airplay":61471,"alarm":61472,"alarm-bell":63373,"alarm-check":61473,"alarm-light":63374,"alarm-multiple":61474,"alarm-off":61475,"alarm-plus":61476,"alarm-snooze":63117,"album":61477,"alert":61478,"alert-box":61479,"alert-circle":61480,"alert-circle-outline":62934,"alert-decagram":63164,"alert-octagon":61481,"alert-octagram":63334,"alert-outline":61482,"all-inclusive":63165,"allo":63489,"alpha":61483,"alphabetical":61484,"altimeter":62935,"amazon":61485,"amazon-clouddrive":61486,"ambulance":61487,"amplifier":61488,"anchor":61489,"android":61490,"android-debug-bridge":61491,"android-head":63375,"android-studio":61492,"angular":63153,"angularjs":63166,"animation":62936,"apple":61493,"apple-finder":61494,"apple-ios":61495,"apple-keyboard-caps":63026,"apple-keyboard-command":63027,"apple-keyboard-control":63028,"apple-keyboard-option":63029,"apple-keyboard-shift":63030,"apple-mobileme":61496,"apple-safari":61497,"application":62996,"approval":63376,"apps":61499,"archive":61500,"arrange-bring-forward":61501,"arrange-bring-to-front":61502,"arrange-send-backward":61503,"arrange-send-to-back":61504,"arrow-all":61505,"arrow-bottom-left":61506,"arrow-bottom-right":61507,"arrow-collapse":62997,"arrow-collapse-all":61508,"arrow-collapse-down":63377,"arrow-collapse-left":63378,"arrow-collapse-right":63379,"arrow-collapse-up":63380,"arrow-down":61509,"arrow-down-bold":63277,"arrow-down-bold-box":63278,"arrow-down-bold-box-outline":63279,"arrow-down-bold-circle":61511,"arrow-down-bold-circle-outline":61512,"arrow-down-bold-hexagon-outline":61513,"arrow-down-box":63167,"arrow-down-drop-circle":61514,"arrow-down-drop-circle-outline":61515,"arrow-down-thick":61510,"arrow-expand":62998,"arrow-expand-all":61516,"arrow-expand-down":63381,"arrow-expand-left":63382,"arrow-expand-right":63383,"arrow-expand-up":63384,"arrow-left":61517,"arrow-left-bold":63280,"arrow-left-bold-box":63281,"arrow-left-bold-box-outline":63282,"arrow-left-bold-circle":61519,"arrow-left-bold-circle-outline":61520,"arrow-left-bold-hexagon-outline":61521,"arrow-left-box":63168,"arrow-left-drop-circle":61522,"arrow-left-drop-circle-outline":61523,"arrow-left-thick":61518,"arrow-right":61524,"arrow-right-bold":63283,"arrow-right-bold-box":63284,"arrow-right-bold-box-outline":63285,"arrow-right-bold-circle":61526,"arrow-right-bold-circle-outline":61527,"arrow-right-bold-hexagon-outline":61528,"arrow-right-box":63169,"arrow-right-drop-circle":61529,"arrow-right-drop-circle-outline":61530,"arrow-right-thick":61525,"arrow-top-left":61531,"arrow-top-right":61532,"arrow-up":61533,"arrow-up-bold":63286,"arrow-up-bold-box":63287,"arrow-up-bold-box-outline":63288,"arrow-up-bold-circle":61535,"arrow-up-bold-circle-outline":61536,"arrow-up-bold-hexagon-outline":61537,"arrow-up-box":63170,"arrow-up-drop-circle":61538,"arrow-up-drop-circle-outline":61539,"arrow-up-thick":61534,"artist":63490,"assistant":61540,"asterisk":63171,"at":61541,"atlassian":63491,"atom":63335,"attachment":61542,"audiobook":61543,"auto-fix":61544,"auto-upload":61545,"autorenew":61546,"av-timer":61547,"azure":63492,"baby":61548,"baby-buggy":63118,"backburger":61549,"backspace":61550,"backup-restore":61551,"bandcamp":63092,"bank":61552,"barcode":61553,"barcode-scan":61554,"barley":61555,"barrel":61556,"basecamp":61557,"basket":61558,"basket-fill":61559,"basket-unfill":61560,"basketball":63493,"battery":61561,"battery-10":61562,"battery-20":61563,"battery-30":61564,"battery-40":61565,"battery-50":61566,"battery-60":61567,"battery-70":61568,"battery-80":61569,"battery-90":61570,"battery-alert":61571,"battery-charging":61572,"battery-charging-100":61573,"battery-charging-20":61574,"battery-charging-30":61575,"battery-charging-40":61576,"battery-charging-60":61577,"battery-charging-80":61578,"battery-charging-90":61579,"battery-charging-wireless":63494,"battery-charging-wireless-10":63495,"battery-charging-wireless-20":63496,"battery-charging-wireless-30":63497,"battery-charging-wireless-40":63498,"battery-charging-wireless-50":63499,"battery-charging-wireless-60":63500,"battery-charging-wireless-70":63501,"battery-charging-wireless-80":63502,"battery-charging-wireless-90":63503,"battery-charging-wireless-alert":63504,"battery-charging-wireless-outline":63505,"battery-minus":61580,"battery-negative":61581,"battery-outline":61582,"battery-plus":61583,"battery-positive":61584,"battery-unknown":61585,"beach":61586,"beaker":63119,"beats":61591,"beer":61592,"behance":61593,"bell":61594,"bell-off":61595,"bell-outline":61596,"bell-plus":61597,"bell-ring":61598,"bell-ring-outline":61599,"bell-sleep":61600,"beta":61601,"bible":61602,"bike":61603,"bing":61604,"binoculars":61605,"bio":61606,"biohazard":61607,"bitbucket":61608,"bitcoin":63506,"black-mesa":61609,"blackberry":61610,"blender":61611,"blinds":61612,"block-helper":61613,"blogger":61614,"bluetooth":61615,"bluetooth-audio":61616,"bluetooth-connect":61617,"bluetooth-off":61618,"bluetooth-settings":61619,"bluetooth-transfer":61620,"blur":61621,"blur-linear":61622,"blur-off":61623,"blur-radial":61624,"bomb":63120,"bomb-off":63172,"bone":61625,"book":61626,"book-minus":62937,"book-multiple":61627,"book-multiple-variant":61628,"book-open":61629,"book-open-page-variant":62938,"book-open-variant":61630,"book-plus":62939,"book-secure":63385,"book-unsecure":63386,"book-variant":61631,"bookmark":61632,"bookmark-check":61633,"bookmark-music":61634,"bookmark-outline":61635,"bookmark-plus":61637,"bookmark-plus-outline":61636,"bookmark-remove":61638,"boombox":62940,"bootstrap":63173,"border-all":61639,"border-bottom":61640,"border-color":61641,"border-horizontal":61642,"border-inside":61643,"border-left":61644,"border-none":61645,"border-outside":61646,"border-right":61647,"border-style":61648,"border-top":61649,"border-vertical":61650,"bow-tie":63095,"bowl":62999,"bowling":61651,"box":61652,"box-cutter":61653,"box-shadow":63031,"bridge":63000,"briefcase":61654,"briefcase-check":61655,"briefcase-download":61656,"briefcase-outline":63507,"briefcase-upload":61657,"brightness-1":61658,"brightness-2":61659,"brightness-3":61660,"brightness-4":61661,"brightness-5":61662,"brightness-6":61663,"brightness-7":61664,"brightness-auto":61665,"broom":61666,"brush":61667,"buffer":63001,"bug":61668,"bulletin-board":61669,"bullhorn":61670,"bullseye":62941,"bus":61671,"bus-articulated-end":63387,"bus-articulated-front":63388,"bus-double-decker":63389,"bus-school":63390,"bus-side":63391,"cached":61672,"cake":61673,"cake-layered":61674,"cake-variant":61675,"calculator":61676,"calendar":61677,"calendar-blank":61678,"calendar-check":61679,"calendar-clock":61680,"calendar-multiple":61681,"calendar-multiple-check":61682,"calendar-plus":61683,"calendar-question":63121,"calendar-range":63096,"calendar-remove":61684,"calendar-text":61685,"calendar-today":61686,"call-made":61687,"call-merge":61688,"call-missed":61689,"call-received":61690,"call-split":61691,"camcorder":61692,"camcorder-box":61693,"camcorder-box-off":61694,"camcorder-off":61695,"camera":61696,"camera-burst":63122,"camera-enhance":61697,"camera-front":61698,"camera-front-variant":61699,"camera-gopro":63392,"camera-iris":61700,"camera-metering-center":63393,"camera-metering-matrix":63394,"camera-metering-partial":63395,"camera-metering-spot":63396,"camera-off":62943,"camera-party-mode":61701,"camera-rear":61702,"camera-rear-variant":61703,"camera-switch":61704,"camera-timer":61705,"cancel":63289,"candle":62946,"candycane":61706,"cannabis":63397,"car":61707,"car-battery":61708,"car-connected":61709,"car-convertible":63398,"car-estate":63399,"car-hatchback":63400,"car-pickup":63401,"car-side":63402,"car-sports":63403,"car-wash":61710,"caravan":63404,"cards":63032,"cards-outline":63033,"cards-playing-outline":63034,"cards-variant":63174,"carrot":61711,"cart":61712,"cart-off":63083,"cart-outline":61713,"cart-plus":61714,"case-sensitive-alt":61715,"cash":61716,"cash-100":61717,"cash-multiple":61718,"cash-usd":61719,"cast":61720,"cast-connected":61721,"cast-off":63369,"castle":61722,"cat":61723,"cctv":63405,"ceiling-light":63336,"cellphone":61724,"cellphone-android":61725,"cellphone-basic":61726,"cellphone-dock":61727,"cellphone-iphone":61728,"cellphone-link":61729,"cellphone-link-off":61730,"cellphone-settings":61731,"cellphone-wireless":63508,"certificate":61732,"chair-school":61733,"chart-arc":61734,"chart-areaspline":61735,"chart-bar":61736,"chart-bar-stacked":63337,"chart-bubble":62947,"chart-donut":63406,"chart-donut-variant":63407,"chart-gantt":63084,"chart-histogram":61737,"chart-line":61738,"chart-line-stacked":63338,"chart-line-variant":63408,"chart-pie":61739,"chart-scatterplot-hexbin":63085,"chart-timeline":63086,"check":61740,"check-all":61741,"check-circle":62944,"check-circle-outline":62945,"checkbox-blank":61742,"checkbox-blank-circle":61743,"checkbox-blank-circle-outline":61744,"checkbox-blank-outline":61745,"checkbox-marked":61746,"checkbox-marked-circle":61747,"checkbox-marked-circle-outline":61748,"checkbox-marked-outline":61749,"checkbox-multiple-blank":61750,"checkbox-multiple-blank-circle":63035,"checkbox-multiple-blank-circle-outline":63036,"checkbox-multiple-blank-outline":61751,"checkbox-multiple-marked":61752,"checkbox-multiple-marked-circle":63037,"checkbox-multiple-marked-circle-outline":63038,"checkbox-multiple-marked-outline":61753,"checkerboard":61754,"chemical-weapon":61755,"chevron-double-down":61756,"chevron-double-left":61757,"chevron-double-right":61758,"chevron-double-up":61759,"chevron-down":61760,"chevron-left":61761,"chevron-right":61762,"chevron-up":61763,"chili-hot":63409,"chili-medium":63410,"chili-mild":63411,"chip":63002,"church":61764,"circle":63332,"circle-outline":63333,"cisco-webex":61765,"city":61766,"clipboard":61767,"clipboard-account":61768,"clipboard-alert":61769,"clipboard-arrow-down":61770,"clipboard-arrow-left":61771,"clipboard-check":61772,"clipboard-flow":63175,"clipboard-outline":61773,"clipboard-plus":63312,"clipboard-text":61774,"clippy":61775,"clock":61776,"clock-alert":62926,"clock-end":61777,"clock-fast":61778,"clock-in":61779,"clock-out":61780,"clock-start":61781,"close":61782,"close-box":61783,"close-box-outline":61784,"close-circle":61785,"close-circle-outline":61786,"close-network":61787,"close-octagon":61788,"close-octagon-outline":61789,"close-outline":63176,"closed-caption":61790,"cloud":61791,"cloud-braces":63412,"cloud-check":61792,"cloud-circle":61793,"cloud-download":61794,"cloud-off-outline":61796,"cloud-outline":61795,"cloud-print":61797,"cloud-print-outline":61798,"cloud-sync":63039,"cloud-tags":63413,"cloud-upload":61799,"clover":63509,"code-array":61800,"code-braces":61801,"code-brackets":61802,"code-equal":61803,"code-greater-than":61804,"code-greater-than-or-equal":61805,"code-less-than":61806,"code-less-than-or-equal":61807,"code-not-equal":61808,"code-not-equal-variant":61809,"code-parentheses":61810,"code-string":61811,"code-tags":61812,"code-tags-check":63123,"codepen":61813,"coffee":61814,"coffee-outline":63177,"coffee-to-go":61815,"coin":61816,"coins":63124,"collage":63040,"color-helper":61817,"comment":61818,"comment-account":61819,"comment-account-outline":61820,"comment-alert":61821,"comment-alert-outline":61822,"comment-check":61823,"comment-check-outline":61824,"comment-multiple-outline":61825,"comment-outline":61826,"comment-plus-outline":61827,"comment-processing":61828,"comment-processing-outline":61829,"comment-question":63510,"comment-question-outline":61830,"comment-remove":62942,"comment-remove-outline":61831,"comment-text":61832,"comment-text-outline":61833,"compare":61834,"compass":61835,"compass-outline":61836,"console":61837,"console-line":63414,"contact-mail":61838,"contacts":63178,"content-copy":61839,"content-cut":61840,"content-duplicate":61841,"content-paste":61842,"content-save":61843,"content-save-all":61844,"content-save-outline":63511,"content-save-settings":63003,"contrast":61845,"contrast-box":61846,"contrast-circle":61847,"cookie":61848,"copyright":62950,"corn":63415,"counter":61849,"cow":61850,"creation":61897,"credit-card":61851,"credit-card-multiple":61852,"credit-card-off":62948,"credit-card-plus":63093,"credit-card-scan":61853,"crop":61854,"crop-free":61855,"crop-landscape":61856,"crop-portrait":61857,"crop-rotate":63125,"crop-square":61858,"crosshairs":61859,"crosshairs-gps":61860,"crown":61861,"cube":61862,"cube-outline":61863,"cube-send":61864,"cube-unfolded":61865,"cup":61866,"cup-off":62949,"cup-water":61867,"currency-btc":61868,"currency-chf":63416,"currency-cny":63417,"currency-eth":63418,"currency-eur":61869,"currency-gbp":61870,"currency-inr":61871,"currency-jpy":63419,"currency-krw":63420,"currency-ngn":61872,"currency-rub":61873,"currency-sign":63421,"currency-try":61874,"currency-twd":63422,"currency-usd":61875,"currency-usd-off":63097,"cursor-default":61876,"cursor-default-outline":61877,"cursor-move":61878,"cursor-pointer":61879,"cursor-text":62951,"database":61880,"database-minus":61881,"database-plus":61882,"debug-step-into":61883,"debug-step-out":61884,"debug-step-over":61885,"decagram":63339,"decagram-outline":63340,"decimal-decrease":61886,"decimal-increase":61887,"delete":61888,"delete-circle":63106,"delete-empty":63179,"delete-forever":62952,"delete-restore":63512,"delete-sweep":62953,"delete-variant":61889,"delta":61890,"deskphone":61891,"desktop-classic":63423,"desktop-mac":61892,"desktop-tower":61893,"details":61894,"developer-board":63126,"deviantart":61895,"dialpad":63004,"diamond":61896,"dice-1":61898,"dice-2":61899,"dice-3":61900,"dice-4":61901,"dice-5":61902,"dice-6":61903,"dice-d10":63342,"dice-d20":62954,"dice-d4":62955,"dice-d6":62956,"dice-d8":62957,"dice-multiple":63341,"dictionary":63005,"dip-switch":63424,"directions":61904,"directions-fork":63041,"discord":63087,"disk":62958,"disk-alert":61905,"disqus":61906,"disqus-outline":61907,"division":61908,"division-box":61909,"dna":63107,"dns":61910,"do-not-disturb":63127,"do-not-disturb-off":63128,"dolby":63154,"domain":61911,"donkey":63425,"door":63513,"door-closed":63514,"door-open":63515,"dots-horizontal":61912,"dots-horizontal-circle":63426,"dots-vertical":61913,"dots-vertical-circle":63427,"douban":63129,"download":61914,"download-network":63219,"drag":61915,"drag-horizontal":61916,"drag-vertical":61917,"drawing":61918,"drawing-box":61919,"dribbble":61920,"dribbble-box":61921,"drone":61922,"dropbox":61923,"drupal":61924,"duck":61925,"dumbbell":61926,"ear-hearing":63428,"earth":61927,"earth-box":63180,"earth-box-off":63181,"earth-off":61928,"edge":61929,"eject":61930,"elephant":63429,"elevation-decline":61931,"elevation-rise":61932,"elevator":61933,"email":61934,"email-alert":63182,"email-open":61935,"email-open-outline":62959,"email-outline":61936,"email-secure":61937,"email-variant":62960,"emby":63155,"emoticon":61938,"emoticon-cool":61939,"emoticon-dead":63130,"emoticon-devil":61940,"emoticon-excited":63131,"emoticon-happy":61941,"emoticon-neutral":61942,"emoticon-poop":61943,"emoticon-sad":61944,"emoticon-tongue":61945,"engine":61946,"engine-outline":61947,"equal":61948,"equal-box":61949,"eraser":61950,"eraser-variant":63042,"escalator":61951,"ethernet":61952,"ethernet-cable":61953,"ethernet-cable-off":61954,"etsy":61955,"ev-station":62961,"eventbrite":63430,"evernote":61956,"exclamation":61957,"exit-to-app":61958,"export":61959,"eye":61960,"eye-off":61961,"eye-off-outline":63184,"eye-outline":63183,"eyedropper":61962,"eyedropper-variant":61963,"face":63043,"face-profile":63044,"facebook":61964,"facebook-box":61965,"facebook-messenger":61966,"factory":61967,"fan":61968,"fan-off":63516,"fast-forward":61969,"fast-forward-outline":63185,"fax":61970,"feather":63186,"ferry":61971,"file":61972,"file-account":63290,"file-chart":61973,"file-check":61974,"file-cloud":61975,"file-delimited":61976,"file-document":61977,"file-document-box":61978,"file-excel":61979,"file-excel-box":61980,"file-export":61981,"file-find":61982,"file-hidden":62995,"file-image":61983,"file-import":61984,"file-lock":61985,"file-multiple":61986,"file-music":61987,"file-outline":61988,"file-pdf":61989,"file-pdf-box":61990,"file-percent":63517,"file-plus":63313,"file-powerpoint":61991,"file-powerpoint-box":61992,"file-presentation-box":61993,"file-restore":63088,"file-send":61994,"file-tree":63045,"file-video":61995,"file-word":61996,"file-word-box":61997,"file-xml":61998,"film":61999,"filmstrip":62000,"filmstrip-off":62001,"filter":62002,"filter-outline":62003,"filter-remove":62004,"filter-remove-outline":62005,"filter-variant":62006,"finance":63518,"find-replace":63187,"fingerprint":62007,"fire":62008,"firefox":62009,"fish":62010,"flag":62011,"flag-checkered":62012,"flag-outline":62013,"flag-triangle":62015,"flag-variant":62016,"flag-variant-outline":62014,"flash":62017,"flash-auto":62018,"flash-circle":63519,"flash-off":62019,"flash-outline":63188,"flash-red-eye":63098,"flashlight":62020,"flashlight-off":62021,"flask":61587,"flask-empty":61588,"flask-empty-outline":61589,"flask-outline":61590,"flattr":62022,"flip-to-back":62023,"flip-to-front":62024,"floor-plan":63520,"floppy":62025,"flower":62026,"folder":62027,"folder-account":62028,"folder-download":62029,"folder-google-drive":62030,"folder-image":62031,"folder-lock":62032,"folder-lock-open":62033,"folder-move":62034,"folder-multiple":62035,"folder-multiple-image":62036,"folder-multiple-outline":62037,"folder-open":63343,"folder-outline":62038,"folder-plus":62039,"folder-remove":62040,"folder-star":63132,"folder-upload":62041,"font-awesome":61498,"food":62042,"food-apple":62043,"food-croissant":63431,"food-fork-drink":62962,"food-off":62963,"food-variant":62044,"football":62045,"football-australian":62046,"football-helmet":62047,"forklift":63432,"format-align-bottom":63314,"format-align-center":62048,"format-align-justify":62049,"format-align-left":62050,"format-align-middle":63315,"format-align-right":62051,"format-align-top":63316,"format-annotation-plus":63046,"format-bold":62052,"format-clear":62053,"format-color-fill":62054,"format-color-text":63133,"format-float-center":62055,"format-float-left":62056,"format-float-none":62057,"format-float-right":62058,"format-font":63189,"format-header-1":62059,"format-header-2":62060,"format-header-3":62061,"format-header-4":62062,"format-header-5":62063,"format-header-6":62064,"format-header-decrease":62065,"format-header-equal":62066,"format-header-increase":62067,"format-header-pound":62068,"format-horizontal-align-center":63006,"format-horizontal-align-left":63007,"format-horizontal-align-right":63008,"format-indent-decrease":62069,"format-indent-increase":62070,"format-italic":62071,"format-line-spacing":62072,"format-line-style":62920,"format-line-weight":62921,"format-list-bulleted":62073,"format-list-bulleted-type":62074,"format-list-checks":63317,"format-list-numbers":62075,"format-page-break":63190,"format-paint":62076,"format-paragraph":62077,"format-pilcrow":63191,"format-quote-close":62078,"format-quote-open":63318,"format-rotate-90":63145,"format-section":63134,"format-size":62079,"format-strikethrough":62080,"format-strikethrough-variant":62081,"format-subscript":62082,"format-superscript":62083,"format-text":62084,"format-textdirection-l-to-r":62085,"format-textdirection-r-to-l":62086,"format-title":62964,"format-underline":62087,"format-vertical-align-bottom":63009,"format-vertical-align-center":63010,"format-vertical-align-top":63011,"format-wrap-inline":62088,"format-wrap-square":62089,"format-wrap-tight":62090,"format-wrap-top-bottom":62091,"forum":62092,"forum-outline":63521,"forward":62093,"foursquare":62094,"fridge":62095,"fridge-filled":62096,"fridge-filled-bottom":62097,"fridge-filled-top":62098,"fuel":63433,"fullscreen":62099,"fullscreen-exit":62100,"function":62101,"gamepad":62102,"gamepad-variant":62103,"garage":63192,"garage-open":63193,"gas-cylinder":63047,"gas-station":62104,"gate":62105,"gauge":62106,"gavel":62107,"gender-female":62108,"gender-male":62109,"gender-male-female":62110,"gender-transgender":62111,"gesture":63434,"gesture-double-tap":63291,"gesture-swipe-down":63292,"gesture-swipe-left":63293,"gesture-swipe-right":63294,"gesture-swipe-up":63295,"gesture-tap":63296,"gesture-two-double-tap":63297,"gesture-two-tap":63298,"ghost":62112,"gift":62113,"git":62114,"github-box":62115,"github-circle":62116,"github-face":63194,"glass-flute":62117,"glass-mug":62118,"glass-stange":62119,"glass-tulip":62120,"glassdoor":62121,"glasses":62122,"gmail":62123,"gnome":62124,"golf":63522,"gondola":63109,"google":62125,"google-analytics":63435,"google-assistant":63436,"google-cardboard":62126,"google-chrome":62127,"google-circles":62128,"google-circles-communities":62129,"google-circles-extended":62130,"google-circles-group":62131,"google-controller":62132,"google-controller-off":62133,"google-drive":62134,"google-earth":62135,"google-glass":62136,"google-home":63523,"google-keep":63195,"google-maps":62965,"google-nearby":62137,"google-pages":62138,"google-photos":63196,"google-physical-web":62139,"google-play":62140,"google-plus":62141,"google-plus-box":62142,"google-translate":62143,"google-wallet":62144,"gradient":63135,"grease-pencil":63048,"grid":62145,"grid-large":63319,"grid-off":62146,"group":62147,"guitar-acoustic":63344,"guitar-electric":62148,"guitar-pick":62149,"guitar-pick-outline":62150,"guy-fawkes-mask":63524,"hackernews":63012,"hamburger":63108,"hand-pointing-right":62151,"hanger":62152,"hangouts":62153,"harddisk":62154,"headphones":62155,"headphones-box":62156,"headphones-off":63437,"headphones-settings":62157,"headset":62158,"headset-dock":62159,"headset-off":62160,"heart":62161,"heart-box":62162,"heart-box-outline":62163,"heart-broken":62164,"heart-half":63198,"heart-half-full":63197,"heart-half-outline":63199,"heart-off":63320,"heart-outline":62165,"heart-pulse":62966,"help":62166,"help-box":63370,"help-circle":62167,"help-circle-outline":63013,"help-network":63220,"hexagon":62168,"hexagon-multiple":63200,"hexagon-outline":62169,"high-definition":63438,"highway":62967,"history":62170,"hololens":62171,"home":62172,"home-account":63525,"home-assistant":63439,"home-automation":63440,"home-circle":63441,"home-heart":63526,"home-map-marker":62968,"home-modern":62173,"home-outline":63136,"home-variant":62174,"hook":63201,"hook-off":63202,"hops":62175,"hospital":62176,"hospital-building":62177,"hospital-marker":62178,"hot-tub":63527,"hotel":62179,"houzz":62180,"houzz-box":62181,"hulu":63528,"human":62182,"human-child":62183,"human-female":63049,"human-greeting":63050,"human-handsdown":63051,"human-handsup":63052,"human-male":63053,"human-male-female":62184,"human-pregnant":62927,"humble-bundle":63299,"ice-cream":63529,"image":62185,"image-album":62186,"image-area":62187,"image-area-close":62188,"image-broken":62189,"image-broken-variant":62190,"image-filter":62191,"image-filter-black-white":62192,"image-filter-center-focus":62193,"image-filter-center-focus-weak":62194,"image-filter-drama":62195,"image-filter-frames":62196,"image-filter-hdr":62197,"image-filter-none":62198,"image-filter-tilt-shift":62199,"image-filter-vintage":62200,"image-multiple":62201,"image-off":63530,"import":62202,"inbox":63110,"inbox-arrow-down":62203,"inbox-arrow-up":62417,"incognito":62969,"infinity":63203,"information":62204,"information-outline":62205,"information-variant":63054,"instagram":62206,"instapaper":62207,"internet-explorer":62208,"invert-colors":62209,"itunes":63094,"jeepney":62210,"jira":62211,"jsfiddle":62212,"json":63014,"karate":63531,"keg":62213,"kettle":62970,"key":62214,"key-change":62215,"key-minus":62216,"key-plus":62217,"key-remove":62218,"key-variant":62219,"keyboard":62220,"keyboard-backspace":62221,"keyboard-caps":62222,"keyboard-close":62223,"keyboard-off":62224,"keyboard-return":62225,"keyboard-tab":62226,"keyboard-variant":62227,"kickstarter":63300,"kodi":62228,"label":62229,"label-outline":62230,"ladybug":63532,"lambda":63015,"lamp":63156,"lan":62231,"lan-connect":62232,"lan-disconnect":62233,"lan-pending":62234,"language-c":63089,"language-cpp":63090,"language-csharp":62235,"language-css3":62236,"language-go":63442,"language-html5":62237,"language-javascript":62238,"language-php":62239,"language-python":62240,"language-python-text":62241,"language-r":63443,"language-swift":63204,"language-typescript":63205,"laptop":62242,"laptop-chromebook":62243,"laptop-mac":62244,"laptop-off":63206,"laptop-windows":62245,"lastfm":62246,"lastpass":62534,"launch":62247,"lava-lamp":63444,"layers":62248,"layers-off":62249,"lead-pencil":63055,"leaf":62250,"led-off":62251,"led-on":62252,"led-outline":62253,"led-strip":63445,"led-variant-off":62254,"led-variant-on":62255,"led-variant-outline":62256,"library":62257,"library-books":62258,"library-music":62259,"library-plus":62260,"lightbulb":62261,"lightbulb-on":63207,"lightbulb-on-outline":63208,"lightbulb-outline":62262,"link":62263,"link-off":62264,"link-variant":62265,"link-variant-off":62266,"linkedin":62267,"linkedin-box":62268,"linux":62269,"loading":63345,"lock":62270,"lock-open":62271,"lock-open-outline":62272,"lock-outline":62273,"lock-pattern":63209,"lock-plus":62971,"lock-reset":63346,"locker":63446,"locker-multiple":63447,"login":62274,"login-variant":62972,"logout":62275,"logout-variant":62973,"looks":62276,"loop":63210,"loupe":62277,"lumx":62278,"magnet":62279,"magnet-on":62280,"magnify":62281,"magnify-minus":62282,"magnify-minus-outline":63211,"magnify-plus":62283,"magnify-plus-outline":63212,"mail-ru":62284,"mailbox":63213,"map":62285,"map-marker":62286,"map-marker-circle":62287,"map-marker-minus":63056,"map-marker-multiple":62288,"map-marker-off":62289,"map-marker-outline":63448,"map-marker-plus":63057,"map-marker-radius":62290,"margin":62291,"markdown":62292,"marker":63058,"marker-check":62293,"martini":62294,"material-ui":62295,"math-compass":62296,"matrix":63016,"maxcdn":62297,"medical-bag":63214,"medium":62298,"memory":62299,"menu":62300,"menu-down":62301,"menu-down-outline":63157,"menu-left":62302,"menu-right":62303,"menu-up":62304,"menu-up-outline":63158,"message":62305,"message-alert":62306,"message-bulleted":63137,"message-bulleted-off":63138,"message-draw":62307,"message-image":62308,"message-outline":62309,"message-plus":63059,"message-processing":62310,"message-reply":62311,"message-reply-text":62312,"message-settings":63215,"message-settings-variant":63216,"message-text":62313,"message-text-outline":62314,"message-video":62315,"meteor":63017,"metronome":63449,"metronome-tick":63450,"micro-sd":63451,"microphone":62316,"microphone-off":62317,"microphone-outline":62318,"microphone-settings":62319,"microphone-variant":62320,"microphone-variant-off":62321,"microscope":63060,"microsoft":62322,"minecraft":62323,"minus":62324,"minus-box":62325,"minus-box-outline":63217,"minus-circle":62326,"minus-circle-outline":62327,"minus-network":62328,"mixcloud":63018,"mixer":63452,"monitor":62329,"monitor-multiple":62330,"more":62331,"motorbike":62332,"mouse":62333,"mouse-off":62334,"mouse-variant":62335,"mouse-variant-off":62336,"move-resize":63061,"move-resize-variant":63062,"movie":62337,"movie-roll":63453,"multiplication":62338,"multiplication-box":62339,"mushroom":63454,"mushroom-outline":63455,"music":63321,"music-box":62340,"music-box-outline":62341,"music-circle":62342,"music-note":62343,"music-note-bluetooth":62974,"music-note-bluetooth-off":62975,"music-note-eighth":62344,"music-note-half":62345,"music-note-off":62346,"music-note-quarter":62347,"music-note-sixteenth":62348,"music-note-whole":62349,"music-off":63322,"nature":62350,"nature-people":62351,"navigation":62352,"near-me":62925,"needle":62353,"nest-protect":62354,"nest-thermostat":62355,"netflix":63301,"network":63218,"new-box":62356,"newspaper":62357,"nfc":62358,"nfc-tap":62359,"nfc-variant":62360,"ninja":63347,"nintendo-switch":63456,"nodejs":62361,"note":62362,"note-multiple":63159,"note-multiple-outline":63160,"note-outline":62363,"note-plus":62364,"note-plus-outline":62365,"note-text":62366,"notebook":63533,"notification-clear-all":62367,"npm":63222,"nuke":63139,"null":63457,"numeric":62368,"numeric-0-box":62369,"numeric-0-box-multiple-outline":62370,"numeric-0-box-outline":62371,"numeric-1-box":62372,"numeric-1-box-multiple-outline":62373,"numeric-1-box-outline":62374,"numeric-2-box":62375,"numeric-2-box-multiple-outline":62376,"numeric-2-box-outline":62377,"numeric-3-box":62378,"numeric-3-box-multiple-outline":62379,"numeric-3-box-outline":62380,"numeric-4-box":62381,"numeric-4-box-multiple-outline":62382,"numeric-4-box-outline":62383,"numeric-5-box":62384,"numeric-5-box-multiple-outline":62385,"numeric-5-box-outline":62386,"numeric-6-box":62387,"numeric-6-box-multiple-outline":62388,"numeric-6-box-outline":62389,"numeric-7-box":62390,"numeric-7-box-multiple-outline":62391,"numeric-7-box-outline":62392,"numeric-8-box":62393,"numeric-8-box-multiple-outline":62394,"numeric-8-box-outline":62395,"numeric-9-box":62396,"numeric-9-box-multiple-outline":62397,"numeric-9-box-outline":62398,"numeric-9-plus-box":62399,"numeric-9-plus-box-multiple-outline":62400,"numeric-9-plus-box-outline":62401,"nut":63223,"nutrition":62402,"oar":63099,"octagon":62403,"octagon-outline":62404,"octagram":63224,"octagram-outline":63348,"odnoklassniki":62405,"office":62406,"oil":62407,"oil-temperature":62408,"omega":62409,"onedrive":62410,"onenote":63302,"opacity":62924,"open-in-app":62411,"open-in-new":62412,"openid":62413,"opera":62414,"orbit":61464,"ornament":62415,"ornament-variant":62416,"owl":62418,"package":62419,"package-down":62420,"package-up":62421,"package-variant":62422,"package-variant-closed":62423,"page-first":62976,"page-last":62977,"page-layout-body":63225,"page-layout-footer":63226,"page-layout-header":63227,"page-layout-sidebar-left":63228,"page-layout-sidebar-right":63229,"palette":62424,"palette-advanced":62425,"panda":62426,"pandora":62427,"panorama":62428,"panorama-fisheye":62429,"panorama-horizontal":62430,"panorama-vertical":62431,"panorama-wide-angle":62432,"paper-cut-vertical":62433,"paperclip":62434,"parking":62435,"passport":63458,"pause":62436,"pause-circle":62437,"pause-circle-outline":62438,"pause-octagon":62439,"pause-octagon-outline":62440,"paw":62441,"paw-off":63063,"pen":62442,"pencil":62443,"pencil-box":62444,"pencil-box-outline":62445,"pencil-circle":63230,"pencil-circle-outline":63349,"pencil-lock":62446,"pencil-off":62447,"pentagon":63231,"pentagon-outline":63232,"percent":62448,"periodic-table-co2":63459,"periscope":63303,"pharmacy":62449,"phone":62450,"phone-bluetooth":62451,"phone-classic":62978,"phone-forward":62452,"phone-hangup":62453,"phone-in-talk":62454,"phone-incoming":62455,"phone-locked":62456,"phone-log":62457,"phone-minus":63064,"phone-missed":62458,"phone-outgoing":62459,"phone-paused":62460,"phone-plus":63065,"phone-return":63534,"phone-settings":62461,"phone-voip":62462,"pi":62463,"pi-box":62464,"piano":63100,"pig":62465,"pill":62466,"pillar":63233,"pin":62467,"pin-off":62468,"pine-tree":62469,"pine-tree-box":62470,"pinterest":62471,"pinterest-box":62472,"pipe":63460,"pipe-disconnected":63461,"pistol":63234,"pizza":62473,"plane-shield":63162,"play":62474,"play-box-outline":62475,"play-circle":62476,"play-circle-outline":62477,"play-pause":62478,"play-protected-content":62479,"playlist-check":62919,"playlist-minus":62480,"playlist-play":62481,"playlist-plus":62482,"playlist-remove":62483,"playstation":62484,"plex":63161,"plus":62485,"plus-box":62486,"plus-box-outline":63235,"plus-circle":62487,"plus-circle-multiple-outline":62488,"plus-circle-outline":62489,"plus-network":62490,"plus-one":62491,"plus-outline":63236,"pocket":62492,"pokeball":62493,"poker-chip":63535,"polaroid":62494,"poll":62495,"poll-box":62496,"polymer":62497,"pool":62982,"popcorn":62498,"pot":63066,"pot-mix":63067,"pound":62499,"pound-box":62500,"power":62501,"power-plug":63140,"power-plug-off":63141,"power-settings":62502,"power-socket":62503,"power-socket-eu":63462,"power-socket-uk":63463,"power-socket-us":63464,"prescription":63237,"presentation":62504,"presentation-play":62505,"printer":62506,"printer-3d":62507,"printer-alert":62508,"printer-settings":63238,"priority-high":62979,"priority-low":62980,"professional-hexagon":62509,"projector":62510,"projector-screen":62511,"publish":63142,"pulse":62512,"puzzle":62513,"qqchat":62981,"qrcode":62514,"qrcode-scan":62515,"quadcopter":62516,"quality-high":62517,"quicktime":62518,"radar":62519,"radiator":62520,"radio":62521,"radio-handheld":62522,"radio-tower":62523,"radioactive":62524,"radiobox-blank":62525,"radiobox-marked":62526,"raspberrypi":62527,"ray-end":62528,"ray-end-arrow":62529,"ray-start":62530,"ray-start-arrow":62531,"ray-start-end":62532,"ray-vertex":62533,"react":63239,"read":62535,"receipt":62537,"record":62538,"record-rec":62539,"recycle":62540,"reddit":62541,"redo":62542,"redo-variant":62543,"refresh":62544,"regex":62545,"relative-scale":62546,"reload":62547,"remote":62548,"rename-box":62549,"reorder-horizontal":63111,"reorder-vertical":63112,"repeat":62550,"repeat-off":62551,"repeat-once":62552,"replay":62553,"reply":62554,"reply-all":62555,"reproduction":62556,"resize-bottom-right":62557,"responsive":62558,"restart":63240,"restore":63143,"rewind":62559,"rewind-outline":63241,"rhombus":63242,"rhombus-outline":63243,"ribbon":62560,"rice":63465,"ring":63466,"road":62561,"road-variant":62562,"robot":63144,"rocket":62563,"roomba":63244,"rotate-3d":62564,"rotate-left":62565,"rotate-left-variant":62566,"rotate-right":62567,"rotate-right-variant":62568,"rounded-corner":62983,"router-wireless":62569,"routes":62570,"rowing":62984,"rss":62571,"rss-box":62572,"ruler":62573,"run":63245,"run-fast":62574,"sale":62575,"sass":63467,"satellite":62576,"satellite-variant":62577,"saxophone":62985,"scale":62578,"scale-balance":62929,"scale-bathroom":62579,"scanner":63146,"school":62580,"screen-rotation":62581,"screen-rotation-lock":62582,"screwdriver":62583,"script":62584,"sd":62585,"seal":62586,"search-web":63246,"seat-flat":62587,"seat-flat-angled":62588,"seat-individual-suite":62589,"seat-legroom-extra":62590,"seat-legroom-normal":62591,"seat-legroom-reduced":62592,"seat-recline-extra":62593,"seat-recline-normal":62594,"security":62595,"security-home":63113,"security-network":62596,"select":62597,"select-all":62598,"select-inverse":62599,"select-off":62600,"selection":62601,"selection-off":63350,"send":62602,"send-secure":63468,"serial-port":63068,"server":62603,"server-minus":62604,"server-network":62605,"server-network-off":62606,"server-off":62607,"server-plus":62608,"server-remove":62609,"server-security":62610,"set-all":63351,"set-center":63352,"set-center-right":63353,"set-left":63354,"set-left-center":63355,"set-left-right":63356,"set-none":63357,"set-right":63358,"settings":62611,"settings-box":62612,"shape":63536,"shape-circle-plus":63069,"shape-outline":63537,"shape-plus":62613,"shape-polygon-plus":63070,"shape-rectangle-plus":63071,"shape-square-plus":63072,"share":62614,"share-variant":62615,"shield":62616,"shield-half-full":63359,"shield-outline":62617,"ship-wheel":63538,"shopping":62618,"shopping-music":62619,"shovel":63247,"shovel-off":63248,"shredder":62620,"shuffle":62621,"shuffle-disabled":62622,"shuffle-variant":62623,"sigma":62624,"sigma-lower":63019,"sign-caution":62625,"sign-direction":63360,"sign-text":63361,"signal":62626,"signal-2g":63249,"signal-3g":63250,"signal-4g":63251,"signal-hspa":63252,"signal-hspa-plus":63253,"signal-off":63362,"signal-variant":62986,"silverware":62627,"silverware-fork":62628,"silverware-spoon":62629,"silverware-variant":62630,"sim":62631,"sim-alert":62632,"sim-off":62633,"sitemap":62634,"skip-backward":62635,"skip-forward":62636,"skip-next":62637,"skip-next-circle":63073,"skip-next-circle-outline":63074,"skip-previous":62638,"skip-previous-circle":63075,"skip-previous-circle-outline":63076,"skull":63115,"skype":62639,"skype-business":62640,"slack":62641,"sleep":62642,"sleep-off":62643,"smoking":62644,"smoking-off":62645,"snapchat":62646,"snowflake":63254,"snowman":62647,"soccer":62648,"soccer-field":63539,"sofa":62649,"solid":63116,"sort":62650,"sort-alphabetical":62651,"sort-ascending":62652,"sort-descending":62653,"sort-numeric":62654,"sort-variant":62655,"soundcloud":62656,"source-branch":63020,"source-commit":63255,"source-commit-end":63256,"source-commit-end-local":63257,"source-commit-local":63258,"source-commit-next-local":63259,"source-commit-start":63260,"source-commit-start-next-local":63261,"source-fork":62657,"source-merge":63021,"source-pull":62658,"soy-sauce":63469,"speaker":62659,"speaker-off":62660,"speaker-wireless":63262,"speedometer":62661,"spellcheck":62662,"spotify":62663,"spotlight":62664,"spotlight-beam":62665,"spray":63077,"square":63331,"square-inc":62666,"square-inc-cash":62667,"square-outline":63330,"square-root":63363,"stack-overflow":62668,"stackexchange":62987,"stadium":63263,"stairs":62669,"standard-definition":63470,"star":62670,"star-circle":62671,"star-half":62672,"star-off":62673,"star-outline":62674,"steam":62675,"steering":62676,"step-backward":62677,"step-backward-2":62678,"step-forward":62679,"step-forward-2":62680,"stethoscope":62681,"sticker":62928,"sticker-emoji":63364,"stocking":62682,"stop":62683,"stop-circle":63078,"stop-circle-outline":63079,"store":62684,"store-24-hour":62685,"stove":62686,"subdirectory-arrow-left":62988,"subdirectory-arrow-right":62989,"subway":63147,"subway-variant":62687,"summit":63365,"sunglasses":62688,"surround-sound":62917,"surround-sound-2-0":63471,"surround-sound-3-1":63472,"surround-sound-5-1":63473,"surround-sound-7-1":63474,"svg":63264,"swap-horizontal":62689,"swap-vertical":62690,"swim":62691,"switch":62692,"sword":62693,"sword-cross":63366,"sync":62694,"sync-alert":62695,"sync-off":62696,"tab":62697,"tab-plus":63323,"tab-unselected":62698,"table":62699,"table-column":63540,"table-column-plus-after":62700,"table-column-plus-before":62701,"table-column-remove":62702,"table-column-width":62703,"table-edit":62704,"table-large":62705,"table-of-contents":63541,"table-row":63542,"table-row-height":62706,"table-row-plus-after":62707,"table-row-plus-before":62708,"table-row-remove":62709,"table-settings":63543,"tablet":62710,"tablet-android":62711,"tablet-ipad":62712,"taco":63329,"tag":62713,"tag-faces":62714,"tag-heart":63114,"tag-multiple":62715,"tag-outline":62716,"tag-plus":63265,"tag-remove":63266,"tag-text-outline":62717,"target":62718,"taxi":62719,"teamviewer":62720,"telegram":62721,"television":62722,"television-box":63544,"television-classic":63475,"television-classic-off":63545,"television-guide":62723,"television-off":63546,"temperature-celsius":62724,"temperature-fahrenheit":62725,"temperature-kelvin":62726,"tennis":62727,"tent":62728,"terrain":62729,"test-tube":63080,"text-shadow":63081,"text-to-speech":62730,"text-to-speech-off":62731,"textbox":62990,"textbox-password":63476,"texture":62732,"theater":62733,"theme-light-dark":62734,"thermometer":62735,"thermometer-lines":62736,"thought-bubble":63477,"thought-bubble-outline":63478,"thumb-down":62737,"thumb-down-outline":62738,"thumb-up":62739,"thumb-up-outline":62740,"thumbs-up-down":62741,"ticket":62742,"ticket-account":62743,"ticket-confirmation":62744,"ticket-percent":63267,"tie":62745,"tilde":63268,"timelapse":62746,"timer":62747,"timer-10":62748,"timer-3":62749,"timer-off":62750,"timer-sand":62751,"timer-sand-empty":63148,"timer-sand-full":63371,"timetable":62752,"toggle-switch":62753,"toggle-switch-off":62754,"tooltip":62755,"tooltip-edit":62756,"tooltip-image":62757,"tooltip-outline":62758,"tooltip-outline-plus":62759,"tooltip-text":62760,"tooth":62761,"tor":62762,"tower-beach":63104,"tower-fire":63105,"towing":63547,"trackpad":63479,"traffic-light":62763,"train":62764,"tram":62765,"transcribe":62766,"transcribe-close":62767,"transfer":62768,"transit-transfer":63149,"translate":62922,"treasure-chest":63269,"tree":62769,"trello":62770,"trending-down":62771,"trending-neutral":62772,"trending-up":62773,"triangle":62774,"triangle-outline":62775,"trophy":62776,"trophy-award":62777,"trophy-outline":62778,"trophy-variant":62779,"trophy-variant-outline":62780,"truck":62781,"truck-delivery":62782,"truck-fast":63367,"truck-trailer":63270,"tshirt-crew":62783,"tshirt-v":62784,"tumblr":62785,"tumblr-reblog":62786,"tune":63022,"tune-vertical":63082,"twitch":62787,"twitter":62788,"twitter-box":62789,"twitter-circle":62790,"twitter-retweet":62791,"uber":63304,"ubuntu":62792,"ultra-high-definition":63480,"umbraco":62793,"umbrella":62794,"umbrella-outline":62795,"undo":62796,"undo-variant":62797,"unfold-less-horizontal":62798,"unfold-less-vertical":63327,"unfold-more-horizontal":62799,"unfold-more-vertical":63328,"ungroup":62800,"unity":63150,"untappd":62801,"update":63151,"upload":62802,"upload-multiple":63548,"upload-network":63221,"usb":62803,"van-passenger":63481,"van-utility":63482,"vanish":63483,"vector-arrange-above":62804,"vector-arrange-below":62805,"vector-circle":62806,"vector-circle-variant":62807,"vector-combine":62808,"vector-curve":62809,"vector-difference":62810,"vector-difference-ab":62811,"vector-difference-ba":62812,"vector-intersection":62813,"vector-line":62814,"vector-point":62815,"vector-polygon":62816,"vector-polyline":62817,"vector-radius":63305,"vector-rectangle":62918,"vector-selection":62818,"vector-square":61441,"vector-triangle":62819,"vector-union":62820,"venmo":62840,"verified":62821,"vibrate":62822,"video":62823,"video-3d":63484,"video-4k-box":63549,"video-input-antenna":63550,"video-input-component":63551,"video-input-hdmi":63552,"video-input-svideo":63553,"video-off":62824,"video-switch":62825,"view-agenda":62826,"view-array":62827,"view-carousel":62828,"view-column":62829,"view-dashboard":62830,"view-dashboard-variant":63554,"view-day":62831,"view-grid":62832,"view-headline":62833,"view-list":62834,"view-module":62835,"view-parallel":63271,"view-quilt":62836,"view-sequential":63272,"view-stream":62837,"view-week":62838,"vimeo":62839,"violin":62991,"visualstudio":62992,"vk":62841,"vk-box":62842,"vk-circle":62843,"vlc":62844,"voice":62923,"voicemail":62845,"volume-high":62846,"volume-low":62847,"volume-medium":62848,"volume-minus":63325,"volume-mute":63326,"volume-off":62849,"volume-plus":63324,"vpn":62850,"vuejs":63555,"walk":62851,"wall":63485,"wallet":62852,"wallet-giftcard":62853,"wallet-membership":62854,"wallet-travel":62855,"wan":62856,"washing-machine":63273,"watch":62857,"watch-export":62858,"watch-import":62859,"watch-vibrate":63152,"water":62860,"water-off":62861,"water-percent":62862,"water-pump":62863,"watermark":62994,"waves":63372,"weather-cloudy":62864,"weather-fog":62865,"weather-hail":62866,"weather-lightning":62867,"weather-lightning-rainy":63101,"weather-night":62868,"weather-partlycloudy":62869,"weather-pouring":62870,"weather-rainy":62871,"weather-snowy":62872,"weather-snowy-rainy":63102,"weather-sunny":62873,"weather-sunset":62874,"weather-sunset-down":62875,"weather-sunset-up":62876,"weather-windy":62877,"weather-windy-variant":62878,"web":62879,"webcam":62880,"webhook":63023,"webpack":63274,"wechat":62993,"weight":62881,"weight-kilogram":62882,"whatsapp":62883,"wheelchair-accessibility":62884,"white-balance-auto":62885,"white-balance-incandescent":62886,"white-balance-iridescent":62887,"white-balance-sunny":62888,"widgets":63275,"wifi":62889,"wifi-off":62890,"wii":62891,"wiiu":63276,"wikipedia":62892,"window-close":62893,"window-closed":62894,"window-maximize":62895,"window-minimize":62896,"window-open":62897,"window-restore":62898,"windows":62899,"wordpress":62900,"worker":62901,"wrap":62902,"wrench":62903,"wunderlist":62904,"xamarin":63556,"xamarin-outline":63557,"xaml":63091,"xbox":62905,"xbox-controller":62906,"xbox-controller-battery-alert":63306,"xbox-controller-battery-empty":63307,"xbox-controller-battery-full":63308,"xbox-controller-battery-low":63309,"xbox-controller-battery-medium":63310,"xbox-controller-battery-unknown":63311,"xbox-controller-off":62907,"xda":62908,"xing":62909,"xing-box":62910,"xing-circle":62911,"xml":62912,"xmpp":63486,"yammer":63368,"yeast":62913,"yelp":62914,"yin-yang":63103,"youtube-creator-studio":63558,"youtube-gaming":63559,"youtube-play":62915,"youtube-tv":62536,"zip-box":62916,"blank":63116}

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(45);var _createIconSet2=_interopRequireDefault(_createIconSet);var _MaterialIcons=__webpack_require__(890);var _MaterialIcons2=_interopRequireDefault(_MaterialIcons);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_MaterialIcons2.default,'Material Icons','MaterialIcons.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports = {"3d-rotation":59469,"ac-unit":60219,"access-alarm":57744,"access-alarms":57745,"access-time":57746,"accessibility":59470,"accessible":59668,"account-balance":59471,"account-balance-wallet":59472,"account-box":59473,"account-circle":59475,"adb":58894,"add":57669,"add-a-photo":58425,"add-alarm":57747,"add-alert":57347,"add-box":57670,"add-circle":57671,"add-circle-outline":57672,"add-location":58727,"add-shopping-cart":59476,"add-to-photos":58269,"add-to-queue":57436,"adjust":58270,"airline-seat-flat":58928,"airline-seat-flat-angled":58929,"airline-seat-individual-suite":58930,"airline-seat-legroom-extra":58931,"airline-seat-legroom-normal":58932,"airline-seat-legroom-reduced":58933,"airline-seat-recline-extra":58934,"airline-seat-recline-normal":58935,"airplanemode-active":57749,"airplanemode-inactive":57748,"airplay":57429,"airport-shuttle":60220,"alarm":59477,"alarm-add":59478,"alarm-off":59479,"alarm-on":59480,"album":57369,"all-inclusive":60221,"all-out":59659,"android":59481,"announcement":59482,"apps":58819,"archive":57673,"arrow-back":58820,"arrow-downward":58843,"arrow-drop-down":58821,"arrow-drop-down-circle":58822,"arrow-drop-up":58823,"arrow-forward":58824,"arrow-upward":58840,"art-track":57440,"aspect-ratio":59483,"assessment":59484,"assignment":59485,"assignment-ind":59486,"assignment-late":59487,"assignment-return":59488,"assignment-returned":59489,"assignment-turned-in":59490,"assistant":58271,"assistant-photo":58272,"attach-file":57894,"attach-money":57895,"attachment":58044,"audiotrack":58273,"autorenew":59491,"av-timer":57371,"backspace":57674,"backup":59492,"battery-alert":57756,"battery-charging-full":57763,"battery-full":57764,"battery-std":57765,"battery-unknown":57766,"beach-access":60222,"beenhere":58669,"block":57675,"bluetooth":57767,"bluetooth-audio":58895,"bluetooth-connected":57768,"bluetooth-disabled":57769,"bluetooth-searching":57770,"blur-circular":58274,"blur-linear":58275,"blur-off":58276,"blur-on":58277,"book":59493,"bookmark":59494,"bookmark-border":59495,"border-all":57896,"border-bottom":57897,"border-clear":57898,"border-color":57899,"border-horizontal":57900,"border-inner":57901,"border-left":57902,"border-outer":57903,"border-right":57904,"border-style":57905,"border-top":57906,"border-vertical":57907,"branding-watermark":57451,"brightness-1":58278,"brightness-2":58279,"brightness-3":58280,"brightness-4":58281,"brightness-5":58282,"brightness-6":58283,"brightness-7":58284,"brightness-auto":57771,"brightness-high":57772,"brightness-low":57773,"brightness-medium":57774,"broken-image":58285,"brush":58286,"bubble-chart":59101,"bug-report":59496,"build":59497,"burst-mode":58428,"business":57519,"business-center":60223,"cached":59498,"cake":59369,"call":57520,"call-end":57521,"call-made":57522,"call-merge":57523,"call-missed":57524,"call-missed-outgoing":57572,"call-received":57525,"call-split":57526,"call-to-action":57452,"camera":58287,"camera-alt":58288,"camera-enhance":59644,"camera-front":58289,"camera-rear":58290,"camera-roll":58291,"cancel":58825,"card-giftcard":59638,"card-membership":59639,"card-travel":59640,"casino":60224,"cast":58119,"cast-connected":58120,"center-focus-strong":58292,"center-focus-weak":58293,"change-history":59499,"chat":57527,"chat-bubble":57546,"chat-bubble-outline":57547,"check":58826,"check-box":59444,"check-box-outline-blank":59445,"check-circle":59500,"chevron-left":58827,"chevron-right":58828,"child-care":60225,"child-friendly":60226,"chrome-reader-mode":59501,"class":59502,"clear":57676,"clear-all":57528,"close":58829,"closed-caption":57372,"cloud":58045,"cloud-circle":58046,"cloud-done":58047,"cloud-download":58048,"cloud-off":58049,"cloud-queue":58050,"cloud-upload":58051,"code":59503,"collections":58294,"collections-bookmark":58417,"color-lens":58295,"colorize":58296,"comment":57529,"compare":58297,"compare-arrows":59669,"computer":58122,"confirmation-number":58936,"contact-mail":57552,"contact-phone":57551,"contacts":57530,"content-copy":57677,"content-cut":57678,"content-paste":57679,"control-point":58298,"control-point-duplicate":58299,"copyright":59660,"create":57680,"create-new-folder":58060,"credit-card":59504,"crop":58302,"crop-16-9":58300,"crop-3-2":58301,"crop-5-4":58303,"crop-7-5":58304,"crop-din":58305,"crop-free":58306,"crop-landscape":58307,"crop-original":58308,"crop-portrait":58309,"crop-rotate":58423,"crop-square":58310,"dashboard":59505,"data-usage":57775,"date-range":59670,"dehaze":58311,"delete":59506,"delete-forever":59691,"delete-sweep":57708,"description":59507,"desktop-mac":58123,"desktop-windows":58124,"details":58312,"developer-board":58125,"developer-mode":57776,"device-hub":58165,"devices":57777,"devices-other":58167,"dialer-sip":57531,"dialpad":57532,"directions":58670,"directions-bike":58671,"directions-boat":58674,"directions-bus":58672,"directions-car":58673,"directions-railway":58676,"directions-run":58726,"directions-subway":58675,"directions-transit":58677,"directions-walk":58678,"disc-full":58896,"dns":59509,"do-not-disturb":58898,"do-not-disturb-alt":58897,"do-not-disturb-off":58947,"do-not-disturb-on":58948,"dock":58126,"domain":59374,"done":59510,"done-all":59511,"donut-large":59671,"donut-small":59672,"drafts":57681,"drag-handle":57949,"drive-eta":58899,"dvr":57778,"edit":58313,"edit-location":58728,"eject":59643,"email":57534,"enhanced-encryption":58943,"equalizer":57373,"error":57344,"error-outline":57345,"euro-symbol":59686,"ev-station":58733,"event":59512,"event-available":58900,"event-busy":58901,"event-note":58902,"event-seat":59651,"exit-to-app":59513,"expand-less":58830,"expand-more":58831,"explicit":57374,"explore":59514,"exposure":58314,"exposure-neg-1":58315,"exposure-neg-2":58316,"exposure-plus-1":58317,"exposure-plus-2":58318,"exposure-zero":58319,"extension":59515,"face":59516,"fast-forward":57375,"fast-rewind":57376,"favorite":59517,"favorite-border":59518,"featured-play-list":57453,"featured-video":57454,"feedback":59519,"fiber-dvr":57437,"fiber-manual-record":57441,"fiber-new":57438,"fiber-pin":57450,"fiber-smart-record":57442,"file-download":58052,"file-upload":58054,"filter":58323,"filter-1":58320,"filter-2":58321,"filter-3":58322,"filter-4":58324,"filter-5":58325,"filter-6":58326,"filter-7":58327,"filter-8":58328,"filter-9":58329,"filter-9-plus":58330,"filter-b-and-w":58331,"filter-center-focus":58332,"filter-drama":58333,"filter-frames":58334,"filter-hdr":58335,"filter-list":57682,"filter-none":58336,"filter-tilt-shift":58338,"filter-vintage":58339,"find-in-page":59520,"find-replace":59521,"fingerprint":59661,"first-page":58844,"fitness-center":60227,"flag":57683,"flare":58340,"flash-auto":58341,"flash-off":58342,"flash-on":58343,"flight":58681,"flight-land":59652,"flight-takeoff":59653,"flip":58344,"flip-to-back":59522,"flip-to-front":59523,"folder":58055,"folder-open":58056,"folder-shared":58057,"folder-special":58903,"font-download":57703,"format-align-center":57908,"format-align-justify":57909,"format-align-left":57910,"format-align-right":57911,"format-bold":57912,"format-clear":57913,"format-color-fill":57914,"format-color-reset":57915,"format-color-text":57916,"format-indent-decrease":57917,"format-indent-increase":57918,"format-italic":57919,"format-line-spacing":57920,"format-list-bulleted":57921,"format-list-numbered":57922,"format-paint":57923,"format-quote":57924,"format-shapes":57950,"format-size":57925,"format-strikethrough":57926,"format-textdirection-l-to-r":57927,"format-textdirection-r-to-l":57928,"format-underlined":57929,"forum":57535,"forward":57684,"forward-10":57430,"forward-30":57431,"forward-5":57432,"free-breakfast":60228,"fullscreen":58832,"fullscreen-exit":58833,"functions":57930,"g-translate":59687,"gamepad":58127,"games":57377,"gavel":59662,"gesture":57685,"get-app":59524,"gif":59656,"golf-course":60229,"gps-fixed":57779,"gps-not-fixed":57780,"gps-off":57781,"grade":59525,"gradient":58345,"grain":58346,"graphic-eq":57784,"grid-off":58347,"grid-on":58348,"group":59375,"group-add":59376,"group-work":59526,"hd":57426,"hdr-off":58349,"hdr-on":58350,"hdr-strong":58353,"hdr-weak":58354,"headset":58128,"headset-mic":58129,"healing":58355,"hearing":57379,"help":59527,"help-outline":59645,"high-quality":57380,"highlight":57951,"highlight-off":59528,"history":59529,"home":59530,"hot-tub":60230,"hotel":58682,"hourglass-empty":59531,"hourglass-full":59532,"http":59650,"https":59533,"image":58356,"image-aspect-ratio":58357,"import-contacts":57568,"import-export":57539,"important-devices":59666,"inbox":57686,"indeterminate-check-box":59657,"info":59534,"info-outline":59535,"input":59536,"insert-chart":57931,"insert-comment":57932,"insert-drive-file":57933,"insert-emoticon":57934,"insert-invitation":57935,"insert-link":57936,"insert-photo":57937,"invert-colors":59537,"invert-colors-off":57540,"iso":58358,"keyboard":58130,"keyboard-arrow-down":58131,"keyboard-arrow-left":58132,"keyboard-arrow-right":58133,"keyboard-arrow-up":58134,"keyboard-backspace":58135,"keyboard-capslock":58136,"keyboard-hide":58138,"keyboard-return":58139,"keyboard-tab":58140,"keyboard-voice":58141,"kitchen":60231,"label":59538,"label-outline":59539,"landscape":58359,"language":59540,"laptop":58142,"laptop-chromebook":58143,"laptop-mac":58144,"laptop-windows":58145,"last-page":58845,"launch":59541,"layers":58683,"layers-clear":58684,"leak-add":58360,"leak-remove":58361,"lens":58362,"library-add":57390,"library-books":57391,"library-music":57392,"lightbulb-outline":59663,"line-style":59673,"line-weight":59674,"linear-scale":57952,"link":57687,"linked-camera":58424,"list":59542,"live-help":57542,"live-tv":58937,"local-activity":58687,"local-airport":58685,"local-atm":58686,"local-bar":58688,"local-cafe":58689,"local-car-wash":58690,"local-convenience-store":58691,"local-dining":58710,"local-drink":58692,"local-florist":58693,"local-gas-station":58694,"local-grocery-store":58695,"local-hospital":58696,"local-hotel":58697,"local-laundry-service":58698,"local-library":58699,"local-mall":58700,"local-movies":58701,"local-offer":58702,"local-parking":58703,"local-pharmacy":58704,"local-phone":58705,"local-pizza":58706,"local-play":58707,"local-post-office":58708,"local-printshop":58709,"local-see":58711,"local-shipping":58712,"local-taxi":58713,"location-city":59377,"location-disabled":57782,"location-off":57543,"location-on":57544,"location-searching":57783,"lock":59543,"lock-open":59544,"lock-outline":59545,"looks":58364,"looks-3":58363,"looks-4":58365,"looks-5":58366,"looks-6":58367,"looks-one":58368,"looks-two":58369,"loop":57384,"loupe":58370,"low-priority":57709,"loyalty":59546,"mail":57688,"mail-outline":57569,"map":58715,"markunread":57689,"markunread-mailbox":59547,"memory":58146,"menu":58834,"merge-type":57938,"message":57545,"mic":57385,"mic-none":57386,"mic-off":57387,"mms":58904,"mode-comment":57939,"mode-edit":57940,"monetization-on":57955,"money-off":57948,"monochrome-photos":58371,"mood":59378,"mood-bad":59379,"more":58905,"more-horiz":58835,"more-vert":58836,"motorcycle":59675,"mouse":58147,"move-to-inbox":57704,"movie":57388,"movie-creation":58372,"movie-filter":58426,"multiline-chart":59103,"music-note":58373,"music-video":57443,"my-location":58716,"nature":58374,"nature-people":58375,"navigate-before":58376,"navigate-next":58377,"navigation":58717,"near-me":58729,"network-cell":57785,"network-check":58944,"network-locked":58906,"network-wifi":57786,"new-releases":57393,"next-week":57706,"nfc":57787,"no-encryption":58945,"no-sim":57548,"not-interested":57395,"note":57455,"note-add":59548,"notifications":59380,"notifications-active":59383,"notifications-none":59381,"notifications-off":59382,"notifications-paused":59384,"offline-pin":59658,"ondemand-video":58938,"opacity":59676,"open-in-browser":59549,"open-in-new":59550,"open-with":59551,"pages":59385,"pageview":59552,"palette":58378,"pan-tool":59685,"panorama":58379,"panorama-fish-eye":58380,"panorama-horizontal":58381,"panorama-vertical":58382,"panorama-wide-angle":58383,"party-mode":59386,"pause":57396,"pause-circle-filled":57397,"pause-circle-outline":57398,"payment":59553,"people":59387,"people-outline":59388,"perm-camera-mic":59554,"perm-contact-calendar":59555,"perm-data-setting":59556,"perm-device-information":59557,"perm-identity":59558,"perm-media":59559,"perm-phone-msg":59560,"perm-scan-wifi":59561,"person":59389,"person-add":59390,"person-outline":59391,"person-pin":58714,"person-pin-circle":58730,"personal-video":58939,"pets":59677,"phone":57549,"phone-android":58148,"phone-bluetooth-speaker":58907,"phone-forwarded":58908,"phone-in-talk":58909,"phone-iphone":58149,"phone-locked":58910,"phone-missed":58911,"phone-paused":58912,"phonelink":58150,"phonelink-erase":57563,"phonelink-lock":57564,"phonelink-off":58151,"phonelink-ring":57565,"phonelink-setup":57566,"photo":58384,"photo-album":58385,"photo-camera":58386,"photo-filter":58427,"photo-library":58387,"photo-size-select-actual":58418,"photo-size-select-large":58419,"photo-size-select-small":58420,"picture-as-pdf":58389,"picture-in-picture":59562,"picture-in-picture-alt":59665,"pie-chart":59076,"pie-chart-outlined":59077,"pin-drop":58718,"place":58719,"play-arrow":57399,"play-circle-filled":57400,"play-circle-outline":57401,"play-for-work":59654,"playlist-add":57403,"playlist-add-check":57445,"playlist-play":57439,"plus-one":59392,"poll":59393,"polymer":59563,"pool":60232,"portable-wifi-off":57550,"portrait":58390,"power":58940,"power-input":58166,"power-settings-new":59564,"pregnant-woman":59678,"present-to-all":57567,"print":59565,"priority-high":58949,"public":59403,"publish":57941,"query-builder":59566,"question-answer":59567,"queue":57404,"queue-music":57405,"queue-play-next":57446,"radio":57406,"radio-button-checked":59447,"radio-button-unchecked":59446,"rate-review":58720,"receipt":59568,"recent-actors":57407,"record-voice-over":59679,"redeem":59569,"redo":57690,"refresh":58837,"remove":57691,"remove-circle":57692,"remove-circle-outline":57693,"remove-from-queue":57447,"remove-red-eye":58391,"remove-shopping-cart":59688,"reorder":59646,"repeat":57408,"repeat-one":57409,"replay":57410,"replay-10":57433,"replay-30":57434,"replay-5":57435,"reply":57694,"reply-all":57695,"report":57696,"report-problem":59570,"restaurant":58732,"restaurant-menu":58721,"restore":59571,"restore-page":59689,"ring-volume":57553,"room":59572,"room-service":60233,"rotate-90-degrees-ccw":58392,"rotate-left":58393,"rotate-right":58394,"rounded-corner":59680,"router":58152,"rowing":59681,"rss-feed":57573,"rv-hookup":58946,"satellite":58722,"save":57697,"scanner":58153,"schedule":59573,"school":59404,"screen-lock-landscape":57790,"screen-lock-portrait":57791,"screen-lock-rotation":57792,"screen-rotation":57793,"screen-share":57570,"sd-card":58915,"sd-storage":57794,"search":59574,"security":58154,"select-all":57698,"send":57699,"sentiment-dissatisfied":59409,"sentiment-neutral":59410,"sentiment-satisfied":59411,"sentiment-very-dissatisfied":59412,"sentiment-very-satisfied":59413,"settings":59576,"settings-applications":59577,"settings-backup-restore":59578,"settings-bluetooth":59579,"settings-brightness":59581,"settings-cell":59580,"settings-ethernet":59582,"settings-input-antenna":59583,"settings-input-component":59584,"settings-input-composite":59585,"settings-input-hdmi":59586,"settings-input-svideo":59587,"settings-overscan":59588,"settings-phone":59589,"settings-power":59590,"settings-remote":59591,"settings-system-daydream":57795,"settings-voice":59592,"share":59405,"shop":59593,"shop-two":59594,"shopping-basket":59595,"shopping-cart":59596,"short-text":57953,"show-chart":59105,"shuffle":57411,"signal-cellular-4-bar":57800,"signal-cellular-connected-no-internet-4-bar":57805,"signal-cellular-no-sim":57806,"signal-cellular-null":57807,"signal-cellular-off":57808,"signal-wifi-4-bar":57816,"signal-wifi-4-bar-lock":57817,"signal-wifi-off":57818,"sim-card":58155,"sim-card-alert":58916,"skip-next":57412,"skip-previous":57413,"slideshow":58395,"slow-motion-video":57448,"smartphone":58156,"smoke-free":60234,"smoking-rooms":60235,"sms":58917,"sms-failed":58918,"snooze":57414,"sort":57700,"sort-by-alpha":57427,"spa":60236,"space-bar":57942,"speaker":58157,"speaker-group":58158,"speaker-notes":59597,"speaker-notes-off":59690,"speaker-phone":57554,"spellcheck":59598,"star":59448,"star-border":59450,"star-half":59449,"stars":59600,"stay-current-landscape":57555,"stay-current-portrait":57556,"stay-primary-landscape":57557,"stay-primary-portrait":57558,"stop":57415,"stop-screen-share":57571,"storage":57819,"store":59601,"store-mall-directory":58723,"straighten":58396,"streetview":58734,"strikethrough-s":57943,"style":58397,"subdirectory-arrow-left":58841,"subdirectory-arrow-right":58842,"subject":59602,"subscriptions":57444,"subtitles":57416,"subway":58735,"supervisor-account":59603,"surround-sound":57417,"swap-calls":57559,"swap-horiz":59604,"swap-vert":59605,"swap-vertical-circle":59606,"switch-camera":58398,"switch-video":58399,"sync":58919,"sync-disabled":58920,"sync-problem":58921,"system-update":58922,"system-update-alt":59607,"tab":59608,"tab-unselected":59609,"tablet":58159,"tablet-android":58160,"tablet-mac":58161,"tag-faces":58400,"tap-and-play":58923,"terrain":58724,"text-fields":57954,"text-format":57701,"textsms":57560,"texture":58401,"theaters":59610,"thumb-down":59611,"thumb-up":59612,"thumbs-up-down":59613,"time-to-leave":58924,"timelapse":58402,"timeline":59682,"timer":58405,"timer-10":58403,"timer-3":58404,"timer-off":58406,"title":57956,"toc":59614,"today":59615,"toll":59616,"tonality":58407,"touch-app":59667,"toys":58162,"track-changes":59617,"traffic":58725,"train":58736,"tram":58737,"transfer-within-a-station":58738,"transform":58408,"translate":59618,"trending-down":59619,"trending-flat":59620,"trending-up":59621,"tune":58409,"turned-in":59622,"turned-in-not":59623,"tv":58163,"unarchive":57705,"undo":57702,"unfold-less":58838,"unfold-more":58839,"update":59683,"usb":57824,"verified-user":59624,"vertical-align-bottom":57944,"vertical-align-center":57945,"vertical-align-top":57946,"vibration":58925,"video-call":57456,"video-label":57457,"video-library":57418,"videocam":57419,"videocam-off":57420,"videogame-asset":58168,"view-agenda":59625,"view-array":59626,"view-carousel":59627,"view-column":59628,"view-comfy":58410,"view-compact":58411,"view-day":59629,"view-headline":59630,"view-list":59631,"view-module":59632,"view-quilt":59633,"view-stream":59634,"view-week":59635,"vignette":58421,"visibility":59636,"visibility-off":59637,"voice-chat":58926,"voicemail":57561,"volume-down":57421,"volume-mute":57422,"volume-off":57423,"volume-up":57424,"vpn-key":57562,"vpn-lock":58927,"wallpaper":57788,"warning":57346,"watch":58164,"watch-later":59684,"wb-auto":58412,"wb-cloudy":58413,"wb-incandescent":58414,"wb-iridescent":58422,"wb-sunny":58416,"wc":58941,"web":57425,"web-asset":57449,"weekend":57707,"whatshot":59406,"widgets":57789,"wifi":58942,"wifi-lock":57825,"wifi-tethering":57826,"work":59641,"wrap-text":57947,"youtube-searched-for":59642,"zoom-in":59647,"zoom-out":59648,"zoom-out-map":58731}

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(45);var _createIconSet2=_interopRequireDefault(_createIconSet);var _Octicons=__webpack_require__(892);var _Octicons2=_interopRequireDefault(_Octicons);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_Octicons2.default,'Octicons','Octicons.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = {"alert":61696,"arrow-down":61697,"arrow-left":61698,"arrow-right":61699,"arrow-small-down":61700,"arrow-small-left":61701,"arrow-small-right":61702,"arrow-small-up":61703,"arrow-up":61704,"beaker":61705,"bell":61706,"bold":61707,"book":61708,"bookmark":61709,"briefcase":61710,"broadcast":61711,"browser":61712,"bug":61713,"calendar":61714,"check":61715,"checklist":61716,"chevron-down":61717,"chevron-left":61718,"chevron-right":61719,"chevron-up":61720,"circle-slash":61721,"circuit-board":61722,"clippy":61723,"clock":61724,"cloud-download":61725,"cloud-upload":61726,"code":61727,"comment":61728,"comment-discussion":61729,"credit-card":61730,"dash":61731,"dashboard":61732,"database":61733,"desktop-download":61734,"device-camera":61735,"device-camera-video":61736,"device-desktop":61737,"device-mobile":61738,"diff":61739,"diff-added":61740,"diff-ignored":61741,"diff-modified":61742,"diff-removed":61743,"diff-renamed":61744,"ellipsis":61745,"eye":61746,"file":61747,"file-binary":61748,"file-code":61749,"file-directory":61750,"file-media":61751,"file-pdf":61752,"file-submodule":61753,"file-symlink-directory":61754,"file-symlink-file":61755,"file-text":61756,"file-zip":61757,"flame":61758,"fold":61759,"gear":61760,"gift":61761,"gist":61762,"gist-secret":61763,"git-branch":61764,"git-commit":61765,"git-compare":61766,"git-merge":61767,"git-pull-request":61768,"globe":61769,"grabber":61770,"graph":61771,"heart":61772,"history":61773,"home":61774,"horizontal-rule":61775,"hubot":61776,"inbox":61777,"info":61778,"issue-closed":61779,"issue-opened":61780,"issue-reopened":61781,"italic":61782,"jersey":61783,"kebab-horizontal":61784,"kebab-vertical":61785,"key":61786,"keyboard":61787,"law":61788,"light-bulb":61789,"link":61790,"link-external":61791,"list-ordered":61792,"list-unordered":61793,"location":61794,"lock":61795,"logo-gist":61796,"logo-github":61797,"mail":61798,"mail-read":61799,"mail-reply":61800,"mark-github":61801,"markdown":61802,"megaphone":61803,"mention":61804,"milestone":61805,"mirror":61806,"mortar-board":61807,"mute":61808,"no-newline":61809,"note":61810,"octoface":61811,"organization":61812,"package":61813,"paintcan":61814,"pencil":61815,"person":61816,"pin":61817,"plug":61818,"plus":61819,"plus-small":61820,"primitive-dot":61821,"primitive-square":61822,"project":61823,"pulse":61824,"question":61825,"quote":61826,"radio-tower":61827,"reply":61828,"repo":61829,"repo-clone":61830,"repo-force-push":61831,"repo-forked":61832,"repo-pull":61833,"repo-push":61834,"rocket":61835,"rss":61836,"ruby":61837,"screen-full":61838,"screen-normal":61839,"search":61840,"server":61841,"settings":61842,"shield":61843,"sign-in":61844,"sign-out":61845,"smiley":61846,"squirrel":61847,"star":61848,"stop":61849,"sync":61850,"tag":61851,"tasklist":61852,"telescope":61853,"terminal":61854,"text-size":61855,"three-bars":61856,"thumbsdown":61857,"thumbsup":61858,"tools":61859,"trashcan":61860,"triangle-down":61861,"triangle-left":61862,"triangle-right":61863,"triangle-up":61864,"unfold":61865,"unmute":61866,"unverified":61867,"verified":61868,"versions":61869,"watch":61870,"x":61871,"zap":61872}

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(45);var _createIconSet2=_interopRequireDefault(_createIconSet);var _SimpleLineIcons=__webpack_require__(894);var _SimpleLineIcons2=_interopRequireDefault(_SimpleLineIcons);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_SimpleLineIcons2.default,'simple-line-icons','SimpleLineIcons.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports = {"user":57349,"people":57345,"user-female":57344,"user-follow":57346,"user-following":57347,"user-unfollow":57348,"login":57446,"logout":57445,"emotsmile":57377,"phone":58880,"call-end":57416,"call-in":57415,"call-out":57414,"map":57395,"location-pin":57494,"direction":57410,"directions":57409,"compass":57413,"layers":57396,"menu":58881,"list":57447,"options-vertical":58882,"options":58883,"arrow-down":58884,"arrow-left":58885,"arrow-right":58886,"arrow-up":58887,"arrow-up-circle":57464,"arrow-left-circle":57466,"arrow-right-circle":57465,"arrow-down-circle":57467,"check":57472,"clock":57473,"plus":57493,"minus":58901,"close":57474,"event":58905,"exclamation":58903,"organization":58902,"trophy":57350,"screen-smartphone":57360,"screen-desktop":57361,"plane":57362,"notebook":57363,"mustache":57364,"mouse":57365,"magnet":57366,"energy":57376,"disc":57378,"cursor":57454,"cursor-move":57379,"crop":57380,"chemistry":57382,"speedometer":57351,"shield":57358,"screen-tablet":57359,"magic-wand":57367,"hourglass":57368,"graduation":57369,"ghost":57370,"game-controller":57371,"fire":57372,"eyeglass":57373,"envelope-open":57374,"envelope-letter":57375,"bell":57383,"badge":57384,"anchor":57385,"wallet":57386,"vector":57387,"speech":57388,"puzzle":57389,"printer":57390,"present":57391,"playlist":57392,"pin":57393,"picture":57394,"handbag":57397,"globe-alt":57398,"globe":57399,"folder-alt":57401,"folder":57481,"film":57402,"feed":57403,"drop":57406,"drawer":57407,"docs":57408,"doc":57477,"diamond":57411,"cup":57412,"calculator":57417,"bubbles":57418,"briefcase":57419,"book-open":57420,"basket-loaded":57421,"basket":57422,"bag":57423,"action-undo":57424,"action-redo":57425,"wrench":57426,"umbrella":57427,"trash":57428,"tag":57429,"support":57430,"frame":57400,"size-fullscreen":57431,"size-actual":57432,"shuffle":57433,"share-alt":57434,"share":57435,"rocket":57436,"question":57437,"pie-chart":57438,"pencil":57439,"note":57440,"loop":57444,"home":57449,"grid":57450,"graph":57451,"microphone":57443,"music-tone-alt":57441,"music-tone":57442,"earphones-alt":57404,"earphones":57405,"equalizer":57452,"like":57448,"dislike":57453,"control-start":57455,"control-rewind":57456,"control-play":57457,"control-pause":57458,"control-forward":57459,"control-end":57460,"volume-1":57503,"volume-2":57504,"volume-off":57505,"calendar":57461,"bulb":57462,"chart":57463,"ban":57468,"bubble":57469,"camrecorder":57470,"camera":57471,"cloud-download":57475,"cloud-upload":57476,"envelope":57478,"eye":57479,"flag":57480,"heart":57482,"info":57483,"key":57484,"link":57485,"lock":57486,"lock-open":57487,"magnifier":57488,"magnifier-add":57489,"magnifier-remove":57490,"paper-clip":57491,"paper-plane":57492,"power":57495,"refresh":57496,"reload":57497,"settings":57498,"star":57499,"symbol-female":57500,"symbol-male":57501,"target":57502,"credit-card":57381,"paypal":58888,"social-tumblr":57354,"social-twitter":57353,"social-facebook":57355,"social-instagram":58889,"social-linkedin":58890,"social-pinterest":58891,"social-github":58892,"social-google":58893,"social-reddit":58894,"social-skype":58895,"social-dribbble":57357,"social-behance":58896,"social-foursqare":58897,"social-soundcloud":58898,"social-spotify":58899,"social-stumbleupon":58900,"social-youtube":57352,"social-dropbox":57356,"social-vkontakte":58904,"social-steam":58912}

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.getImageSource=exports.ToolbarAndroid=exports.TabBarItemIOS=exports.TabBarItem=exports.Button=undefined;var _createIconSet=__webpack_require__(45);var _createIconSet2=_interopRequireDefault(_createIconSet);var _Zocial=__webpack_require__(896);var _Zocial2=_interopRequireDefault(_Zocial);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var iconSet=(0,_createIconSet2.default)(_Zocial2.default,'zocial','Zocial.ttf');exports.default=iconSet;var Button=exports.Button=iconSet.Button;var TabBarItem=exports.TabBarItem=iconSet.TabBarItem;var TabBarItemIOS=exports.TabBarItemIOS=iconSet.TabBarItemIOS;var ToolbarAndroid=exports.ToolbarAndroid=iconSet.ToolbarAndroid;var getImageSource=exports.getImageSource=iconSet.getImageSource;

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports = {"acrobat":61696,"amazon":61697,"android":61698,"angellist":61699,"aol":61700,"appnet":61701,"appstore":61702,"bitbucket":61703,"bitcoin":61704,"blogger":61705,"buffer":61706,"cal":61707,"call":61708,"cart":61709,"chrome":61710,"cloudapp":61711,"creativecommons":61712,"delicious":61713,"digg":61714,"disqus":61715,"dribbble":61716,"dropbox":61717,"drupal":61718,"dwolla":61720,"email":61721,"eventasaurus":61722,"eventbrite":61723,"eventful":61724,"evernote":61725,"facebook":61726,"fivehundredpx":61727,"flattr":61728,"flickr":61729,"forrst":61730,"foursquare":61731,"github":61732,"gmail":61733,"google":61734,"googleplay":61735,"googleplus":61736,"gowalla":61737,"grooveshark":61738,"guest":61739,"html5":61740,"ie":61741,"instagram":61742,"instapaper":61743,"intensedebate":61744,"itunes":61745,"klout":61746,"lanyrd":61747,"lastfm":61748,"lego":61749,"linkedin":61750,"lkdto":61751,"logmein":61752,"macstore":61753,"meetup":61754,"myspace":61755,"ninetyninedesigns":61756,"openid":61757,"opentable":61758,"paypal":61759,"persona":61796,"pinboard":61760,"pinterest":61761,"plancast":61762,"plurk":61763,"pocket":61764,"podcast":61765,"posterous":61766,"print":61767,"quora":61768,"reddit":61769,"rss":61770,"scribd":61771,"skype":61772,"smashing":61773,"songkick":61774,"soundcloud":61775,"spotify":61776,"stackoverflow":61777,"statusnet":61778,"steam":61779,"stripe":61780,"stumbleupon":61781,"tumblr":61782,"twitter":61783,"viadeo":61784,"vimeo":61785,"vk":61786,"weibo":61787,"wikipedia":61788,"windows":61789,"wordpress":61790,"xing":61791,"yahoo":61792,"ycombinator":61793,"yelp":61794,"youtube":61795}

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});

var _react=__webpack_require__(1);var React=_interopRequireWildcard(_react);

var _reactNativeWeb=__webpack_require__(3);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}













var FlatList=function FlatList(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:









{},ItemSeparatorComponent=_ref.ItemSeparatorComponent,ListFooterComponent=_ref.ListFooterComponent,ListHeaderComponent=_ref.ListHeaderComponent,_ref$contentContainer=_ref.contentContainerStyle,contentContainerStyle=_ref$contentContainer===undefined?{}:_ref$contentContainer,_ref$data=_ref.data,data=_ref$data===undefined?[]:_ref$data,_ref$horizontal=_ref.horizontal,horizontal=_ref$horizontal===undefined?false:_ref$horizontal,keyExtractor=_ref.keyExtractor,renderItem=_ref.renderItem,_ref$style=_ref.style,style=_ref$style===undefined?{}:_ref$style;return(
React.createElement(_reactNativeWeb.ScrollView,{
contentContainerStyle:contentContainerStyle,
horizontal:horizontal,
style:style},


ListHeaderComponent&&
React.createElement(ListHeaderComponent,null),


data.map(function(item,index){return(
React.createElement(_reactNativeWeb.View,{
key:keyExtractor?keyExtractor(item):index},


renderItem({index:index,item:item}),

ItemSeparatorComponent&&index<data.length-1&&
React.createElement(ItemSeparatorComponent,null)));}),





ListFooterComponent&&
React.createElement(ListFooterComponent,null)));};exports.default=





FlatList;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.default=
















configureStore;var _redux=__webpack_require__(133);var _reduxPersist=__webpack_require__(899);var _storage=__webpack_require__(906);var _storage2=_interopRequireDefault(_storage);var _user=__webpack_require__(909);var _user2=_interopRequireDefault(_user);var _device=__webpack_require__(910);var _device2=_interopRequireDefault(_device);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var config={key:'root',storage:_storage2.default};var reducer=(0,_reduxPersist.persistCombineReducers)(config,{user:_user2.default,device:_device2.default});function configureStore(){
var store=(0,_redux.createStore)(reducer);
var persistor=(0,_reduxPersist.persistStore)(store);

return{persistor:persistor,store:store};
}

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__persistReducer__ = __webpack_require__(216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "persistReducer", function() { return __WEBPACK_IMPORTED_MODULE_0__persistReducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistCombineReducers__ = __webpack_require__(901);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "persistCombineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__persistCombineReducers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__persistStore__ = __webpack_require__(903);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "persistStore", function() { return __WEBPACK_IMPORTED_MODULE_2__persistStore__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createMigrate__ = __webpack_require__(904);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMigrate", function() { return __WEBPACK_IMPORTED_MODULE_3__createMigrate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransform__ = __webpack_require__(905);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createTransform", function() { return __WEBPACK_IMPORTED_MODULE_4__createTransform__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getStoredState__ = __webpack_require__(350);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getStoredState", function() { return __WEBPACK_IMPORTED_MODULE_5__getStoredState__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createPersistoid__ = __webpack_require__(349);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createPersistoid", function() { return __WEBPACK_IMPORTED_MODULE_6__createPersistoid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__purgeStoredState__ = __webpack_require__(351);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "purgeStoredState", function() { return __WEBPACK_IMPORTED_MODULE_7__purgeStoredState__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(84);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "KEY_PREFIX", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FLUSH", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "REHYDRATE", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PAUSE", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PERSIST", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PURGE", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "REGISTER", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_VERSION", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["a"]; });











/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoMergeLevel1;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function autoMergeLevel1(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _extends({}, reducedState);
  // only rehydrate if inboundState exists and is an object
  if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : _typeof(inboundState)) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (false) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      }
      // otherwise hard set the new value
      newState[key] = inboundState[key];
    });
  }

  if (false) console.log('redux-persist/stateReconciler: rehydrated keys \'' + Object.keys(inboundState).join(', ') + '\'');

  return newState;
}

/*
  autoMergeLevel1: 
    - merges 1 level of substate
    - skips substate if already modified
*/

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistCombineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistReducer__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stateReconciler_autoMergeLevel2__ = __webpack_require__(902);




// combineReducers + persistReducer with stateReconciler defaulted to autoMergeLevel2
function persistCombineReducers(config, reducers) {
  config.stateReconciler = config.stateReconciler === undefined ? __WEBPACK_IMPORTED_MODULE_2__stateReconciler_autoMergeLevel2__["a" /* default */] : config.stateReconciler;
  return Object(__WEBPACK_IMPORTED_MODULE_1__persistReducer__["a" /* default */])(config, Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])(reducers));
}

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoMergeLevel2;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function autoMergeLevel2(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _extends({}, reducedState);
  // only rehydrate if inboundState exists and is an object
  if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : _typeof(inboundState)) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (false) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      }
      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = _extends({}, newState[key], inboundState[key]);
        return;
      }
      // otherwise hard set
      newState[key] = inboundState[key];
    });
  }

  if (false) console.log('redux-persist/stateReconciler: rehydrated keys \'' + Object.keys(inboundState).join(', ') + '\'');

  return newState;
}

/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/

function isPlainEnoughObject(o) {
  return o !== null && !Array.isArray(o) && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object';
}

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistReducer__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(84);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var initialState = {
  registry: [],
  bootstrapped: false
};

var persistorReducer = function persistorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REGISTER */]:
      return _extends({}, state, { registry: [].concat(_toConsumableArray(state.registry), [action.key]) });
    case __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* REHYDRATE */]:
      var firstIndex = state.registry.indexOf(action.key);
      var registry = [].concat(_toConsumableArray(state.registry));
      registry.splice(firstIndex, 1);
      return _extends({}, state, { registry: registry, bootstrapped: registry.length === 0 });
    default:
      return state;
  }
};

function persistStore(store, options, cb) {
  // help catch incorrect usage of passing PersistConfig in as PersistorOptions
  if (false) {
    var optionsToTest = options || {};
    var bannedKeys = ['blacklist', 'whitelist', 'transforms', 'storage', 'keyPrefix', 'migrate'];
    bannedKeys.forEach(function (k) {
      if (!!optionsToTest[k]) console.error('redux-persist: invalid option passed to persistStore: "' + k + '". You may be incorrectly passing persistConfig into persistStore, whereas it should be passed into persistReducer.');
    });
  }
  var boostrappedCb = cb || false;

  var _pStore = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(persistorReducer, initialState, options ? options.enhancer : undefined);
  var register = function register(key) {
    _pStore.dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REGISTER */],
      key: key
    });
  };

  var rehydrate = function rehydrate(key, payload, err) {
    var rehydrateAction = {
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* REHYDRATE */],
      payload: payload,
      err: err,
      key: key
      // dispatch to `store` to rehydrate and `persistor` to track result
    };store.dispatch(rehydrateAction);
    _pStore.dispatch(rehydrateAction);
    if (boostrappedCb && persistor.getState().bootstrapped) {
      boostrappedCb();
      boostrappedCb = false;
    }
  };

  var persistor = _extends({}, _pStore, {
    purge: function purge() {
      var results = [];
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* PURGE */],
        result: function result(purgeResult) {
          results.push(purgeResult);
        }
      });
      return Promise.all(results);
    },
    flush: function flush() {
      var results = [];
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* FLUSH */],
        result: function result(flushResult) {
          results.push(flushResult);
        }
      });
      return Promise.all(results);
    },
    pause: function pause() {
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* PAUSE */]
      });
    },
    persist: function persist() {
      store.dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* PERSIST */], register: register, rehydrate: rehydrate });
    }
  });

  persistor.persist();

  return persistor;
}

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMigrate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(84);


function createMigrate(migrations, config) {
  var _ref = config || {},
      debug = _ref.debug;

  return function (state, currentVersion) {
    if (!state) {
      if (false) console.log('redux-persist: no inbound state, skipping migration');
      return Promise.resolve(undefined);
    }

    var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEFAULT_VERSION */];
    if (inboundVersion === currentVersion) {
      if (false) console.log('redux-persist: versions match, noop migration');
      return Promise.resolve(state);
    }
    if (inboundVersion > currentVersion) {
      if (false) console.error('redux-persist: downgrading version is not supported');
      return Promise.resolve(state);
    }

    var migrationKeys = Object.keys(migrations).map(function (ver) {
      return parseInt(ver);
    }).filter(function (key) {
      return currentVersion >= key && key > inboundVersion;
    }).sort(function (a, b) {
      return a - b;
    });

    if (false) console.log('redux-persist: migrationKeys', migrationKeys);
    try {
      var migratedState = migrationKeys.reduce(function (state, versionKey) {
        if (false) console.log('redux-persist: running migration for versionKey', versionKey);
        return migrations[versionKey](state);
      }, state);
      return Promise.resolve(migratedState);
    } catch (err) {
      return Promise.reject(err);
    }
  };
}

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransform;


function createTransform(
// @NOTE inbound: transform state coming from redux on its way to being serialized and stored
inbound,
// @NOTE outbound: transform state coming from storage, on its way to be rehydrated into redux
outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
    },
    out: function out(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
    }
  };
}

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createWebStorage__ = __webpack_require__(907);


/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createWebStorage__["a" /* default */])('local'));

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createWebStorage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getStorage__ = __webpack_require__(908);


function createWebStorage(type) {
  var storage = Object(__WEBPACK_IMPORTED_MODULE_0__getStorage__["a" /* default */])(type);
  return {
    getItem: function getItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.getItem(key));
      });
    },
    setItem: function setItem(key, item) {
      return new Promise(function (resolve, reject) {
        resolve(storage.setItem(key, item));
      });
    },
    removeItem: function removeItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.removeItem(key));
      });
    }
  };
}

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStorage;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function noop() {}

var noopStorage = {
  getItem: noop,
  setItem: noop,
  removeItem: noop
};

function hasStorage(storageType) {
  if ((typeof self === 'undefined' ? 'undefined' : _typeof(self)) !== 'object' || !(storageType in self)) {
    return false;
  }

  try {
    var storage = self[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function getStorage(type) {
  var storageType = type + 'Storage';
  if (hasStorage(storageType)) return self[storageType];else {
    if (false) {
      console.error('redux-persist failed to create sync storage. falling back to memory storage.');
    }
    return noopStorage;
  }
}

/***/ }),
/* 909 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var initialState={};

var configureUser=function configureUser(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];
switch(action.type){
case'updateCredential':{
return _extends({},
state,{
credential:action.credential});

}
case'updateInfo':{
return _extends({},
state,{
info:action.info});

}
case'updatePromoCode':{
var info=_extends({},
state.info,{
promoCode:action.promoCode});

return _extends({},
state,{
info:info});

}
case'signOut':{var
credential=state.credential;
credential=_extends({},
credential,{
password:undefined});

return _extends({},
state,{
credential:credential,
info:undefined});

}
default:{
return state;
}}

};exports.default=

configureUser;

/***/ }),
/* 910 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var initialState={};

var configureDevice=function configureDevice(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];
switch(action.type){
case'updateFCMToken':{
return _extends({},
state,{
fcmToken:action.token});

}
case'updateWhitelist':{
return _extends({},
state,{
whitelist:action.whitelist});

}
default:{
return state;
}}

};exports.default=

configureDevice;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactRouterDom=__webpack_require__(352);
var _reactNative=__webpack_require__(3);
var _reactRedux=__webpack_require__(28);

var _user=__webpack_require__(111);
var _UserUtils=__webpack_require__(66);var _UserUtils2=_interopRequireDefault(_UserUtils);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);

var _MenuList=__webpack_require__(965);var _MenuList2=_interopRequireDefault(_MenuList);
var _LoginScreen=__webpack_require__(977);var _LoginScreen2=_interopRequireDefault(_LoginScreen);
var _ProfileScreen=__webpack_require__(980);var _ProfileScreen2=_interopRequireDefault(_ProfileScreen);
var _UpdatePasswordScreen=__webpack_require__(983);var _UpdatePasswordScreen2=_interopRequireDefault(_UpdatePasswordScreen);
var _UpdatePromoCodeScreen=__webpack_require__(984);var _UpdatePromoCodeScreen2=_interopRequireDefault(_UpdatePromoCodeScreen);
var _OrderListScreen=__webpack_require__(985);var _OrderListScreen2=_interopRequireDefault(_OrderListScreen);
var _OrderScreen=__webpack_require__(988);var _OrderScreen2=_interopRequireDefault(_OrderScreen);
var _AgencyListScreen=__webpack_require__(993);var _AgencyListScreen2=_interopRequireDefault(_AgencyListScreen);
var _AgencyScreen=__webpack_require__(994);var _AgencyScreen2=_interopRequireDefault(_AgencyScreen);
var _NotificationListScreen=__webpack_require__(995);var _NotificationListScreen2=_interopRequireDefault(_NotificationListScreen);
var _PartnerListScreen=__webpack_require__(997);var _PartnerListScreen2=_interopRequireDefault(_PartnerListScreen);
var _PartnerScreen=__webpack_require__(998);var _PartnerScreen2=_interopRequireDefault(_PartnerScreen);
var _CreateAgencyScreen=__webpack_require__(999);var _CreateAgencyScreen2=_interopRequireDefault(_CreateAgencyScreen);
var _SellerScreen=__webpack_require__(1000);var _SellerScreen2=_interopRequireDefault(_SellerScreen);
var _SellerPriceScreen=__webpack_require__(1001);var _SellerPriceScreen2=_interopRequireDefault(_SellerPriceScreen);
var _PaymentScreen=__webpack_require__(1002);var _PaymentScreen2=_interopRequireDefault(_PaymentScreen);
var _PrepayScreen=__webpack_require__(1003);var _PrepayScreen2=_interopRequireDefault(_PrepayScreen);
var _SellerOrderListScreen=__webpack_require__(1004);var _SellerOrderListScreen2=_interopRequireDefault(_SellerOrderListScreen);
var _EditOrderScreen=__webpack_require__(1005);var _EditOrderScreen2=_interopRequireDefault(_EditOrderScreen);
var _ConfirmedOrderListScreen=__webpack_require__(1006);var _ConfirmedOrderListScreen2=_interopRequireDefault(_ConfirmedOrderListScreen);
var _UserManager=__webpack_require__(112);var _UserManager2=_interopRequireDefault(_UserManager);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

MainIndex=function(_Component){_inherits(MainIndex,_Component);

function MainIndex(props){var _this2=this;_classCallCheck(this,MainIndex);var _this=_possibleConstructorReturn(this,(MainIndex.__proto__||Object.getPrototypeOf(MainIndex)).call(this,
props));_this.






















_updateUserInfo=function _callee(){var i,_ref,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(
_UserManager2.default.getInstance().isSignedIn()){_context.next=2;break;}return _context.abrupt('return');case 2:



i=0;case 3:if(!(i<3)){_context.next=15;break;}_context.next=6;return regeneratorRuntime.awrap(
_APIClient2.default.GET('/user'));case 6:_ref=_context.sent;response=_ref.response;error=_ref.error;if(!(







response&&response.response)){_context.next=12;break;}
_this.props.updateInfo(response.response);return _context.abrupt('break',15);case 12:i++;_context.next=3;break;case 15:case'end':return _context.stop();}}},null,_this2);};_this.





_handleClickMenu=function(item){
_this._router.history.push(item.path);
};var _this$props=_this.props,credential=_this$props.credential,user=_this$props.user;_UserManager2.default.getInstance().initialize(user);_APIClient2.default.updateCredential(credential);return _this;}_createClass(MainIndex,[{key:'componentDidMount',value:function componentDidMount(){this._updateUserInfo();}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.user){_UserManager2.default.getInstance().updateUser(nextProps.user);}if(nextProps.credential){_APIClient2.default.updateCredential(nextProps.credential);}}},{key:'render',value:function render()

{var _this3=this;var
user=this.props.user;
var isSignedIn=_UserUtils2.default.isSignedIn(user);
var isAdmin=_UserUtils2.default.isAdmin(user);
if(!isSignedIn){
return _react2.default.createElement(_LoginScreen2.default,null);
}

return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
_react2.default.createElement(_MenuList2.default,{
onClick:this._handleClickMenu}),
_react2.default.createElement(_reactNative.View,{
style:styles.content},
_react2.default.createElement(_reactRouterDom.BrowserRouter,{
ref:function ref(_ref2){return _this3._router=_ref2;}},
_react2.default.createElement(_reactRouterDom.Switch,null,
_react2.default.createElement(_reactRouterDom.Route,{exact:true,path:'/',component:_OrderListScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/order/:id',component:_OrderScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{exact:true,path:'/agencies',component:_AgencyListScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/agencies/:id',component:_AgencyListScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/agency/:id',component:_AgencyScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/notifications',component:_NotificationListScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/me',component:_ProfileScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/password',component:_UpdatePasswordScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/promo-code',component:_UpdatePromoCodeScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/partners',component:_PartnerListScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/partner/:id',component:_PartnerScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/create-agency',component:_CreateAgencyScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/seller/price/:id',component:_SellerPriceScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/seller/:id',component:_SellerScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/payment',component:_PaymentScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/prepay',component:_PrepayScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/orders/seller/:id',
component:_SellerOrderListScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/edit-order/:id',component:_EditOrderScreen2.default}),
_react2.default.createElement(_reactRouterDom.Route,{path:'/orders/confirmed',
component:_ConfirmedOrderListScreen2.default}))))));





}}]);return MainIndex;}(_react.Component);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
display:'flex',
backgroundColor:'#f6efdb'},

content:{
flex:1,
backgroundColor:'#ffffff'}});



var mapStateToProps=function mapStateToProps(state){
return{
credential:state.user.credential,
user:state.user};

};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{
updateInfo:function updateInfo(info){return dispatch((0,_user.updateInfo)(info));}};

};exports.default=

(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(MainIndex);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(219);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(217);

var _PathUtils = __webpack_require__(109);

var _createTransitionManager = __webpack_require__(218);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(355);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(219);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(217);

var _PathUtils = __webpack_require__(109);

var _createTransitionManager = __webpack_require__(218);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(355);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(917);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(220);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(109);

var _LocationUtils = __webpack_require__(217);

var _createTransitionManager = __webpack_require__(218);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(356);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(921)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(923);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(925);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(926);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(927);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(928);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(929);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(110);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(359);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(359);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(222);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(931);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(220);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(933);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(221);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(221);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(936);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(358);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`.
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code, and use
	// it as `root`.
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var InvalidCharacterError = function(message) {
		this.message = message;
	};
	InvalidCharacterError.prototype = new Error;
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';

	var error = function(message) {
		// Note: the error messages used throughout this file match those used by
		// the native `atob`/`btoa` implementation in Chromium.
		throw new InvalidCharacterError(message);
	};

	var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	// http://whatwg.org/html/common-microsyntaxes.html#space-character
	var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;

	// `decode` is designed to be fully compatible with `atob` as described in the
	// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
	// The optimized base64-decoding algorithm used is based on @atk’s excellent
	// implementation. https://gist.github.com/atk/1020396
	var decode = function(input) {
		input = String(input)
			.replace(REGEX_SPACE_CHARACTERS, '');
		var length = input.length;
		if (length % 4 == 0) {
			input = input.replace(/==?$/, '');
			length = input.length;
		}
		if (
			length % 4 == 1 ||
			// http://whatwg.org/C#alphanumeric-ascii-characters
			/[^+a-zA-Z0-9/]/.test(input)
		) {
			error(
				'Invalid character: the string to be decoded is not correctly encoded.'
			);
		}
		var bitCounter = 0;
		var bitStorage;
		var buffer;
		var output = '';
		var position = -1;
		while (++position < length) {
			buffer = TABLE.indexOf(input.charAt(position));
			bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
			// Unless this is the first of a group of 4 characters…
			if (bitCounter++ % 4) {
				// …convert the first 8 bits to a single ASCII character.
				output += String.fromCharCode(
					0xFF & bitStorage >> (-2 * bitCounter & 6)
				);
			}
		}
		return output;
	};

	// `encode` is designed to be fully compatible with `btoa` as described in the
	// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
	var encode = function(input) {
		input = String(input);
		if (/[^\0-\xFF]/.test(input)) {
			// Note: no need to special-case astral symbols here, as surrogates are
			// matched, and the input is supposed to only contain ASCII anyway.
			error(
				'The string to be encoded contains characters outside of the ' +
				'Latin1 range.'
			);
		}
		var padding = input.length % 3;
		var output = '';
		var position = -1;
		var a;
		var b;
		var c;
		var d;
		var buffer;
		// Make sure any padding is handled outside of the loop.
		var length = input.length - padding;

		while (++position < length) {
			// Read three bytes, i.e. 24 bits.
			a = input.charCodeAt(position) << 16;
			b = input.charCodeAt(++position) << 8;
			c = input.charCodeAt(++position);
			buffer = a + b + c;
			// Turn the 24 bits into four chunks of 6 bits each, and append the
			// matching character for each of them to the output.
			output += (
				TABLE.charAt(buffer >> 18 & 0x3F) +
				TABLE.charAt(buffer >> 12 & 0x3F) +
				TABLE.charAt(buffer >> 6 & 0x3F) +
				TABLE.charAt(buffer & 0x3F)
			);
		}

		if (padding == 2) {
			a = input.charCodeAt(position) << 8;
			b = input.charCodeAt(++position);
			buffer = a + b;
			output += (
				TABLE.charAt(buffer >> 10) +
				TABLE.charAt((buffer >> 4) & 0x3F) +
				TABLE.charAt((buffer << 2) & 0x3F) +
				'='
			);
		} else if (padding == 1) {
			buffer = input.charCodeAt(position);
			output += (
				TABLE.charAt(buffer >> 2) +
				TABLE.charAt((buffer << 4) & 0x3F) +
				'=='
			);
		}

		return output;
	};

	var base64 = {
		'encode': encode,
		'decode': decode,
		'version': '0.1.0'
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return base64;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = base64;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (var key in base64) {
				base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.base64 = base64;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module), __webpack_require__(10)))

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(360)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        ss : '%d giây' ,
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
// Thanks to:
// http://fightingforalostcause.net/misc/2006/compare-email-regex.php
// http://thedailywtf.com/Articles/Validating_Email_Addresses.aspx
// http://stackoverflow.com/questions/201323/what-is-the-best-regular-expression-for-validating-email-addresses/201378#201378
exports.validate = function(email)
{
	if (!email)
		return false;
		
	if(email.length>254)
		return false;

	var valid = tester.test(email);
	if(!valid)
		return false;

	// Further checking of some things regex can't handle
	var parts = email.split("@");
	if(parts[0].length>64)
		return false;

	var domainParts = parts[1].split(".");
	if(domainParts.some(function(part) { return part.length>63; }))
		return false;

	return true;
}


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.libphonenumber = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var COMPILED = !0, goog = goog || {};
goog.global = this;
goog.isDef = function(a) {
  return void 0 !== a;
};
goog.isString = function(a) {
  return "string" == typeof a;
};
goog.isBoolean = function(a) {
  return "boolean" == typeof a;
};
goog.isNumber = function(a) {
  return "number" == typeof a;
};
goog.exportPath_ = function(a, b, c) {
  a = a.split(".");
  c = c || goog.global;
  a[0] in c || !c.execScript || c.execScript("var " + a[0]);
  for (var d; a.length && (d = a.shift());) {
    !a.length && goog.isDef(b) ? c[d] = b : c = c[d] && c[d] !== Object.prototype[d] ? c[d] : c[d] = {};
  }
};
goog.define = function(a, b) {
  var c = b;
  if (!COMPILED) {
    var d = goog.global.CLOSURE_UNCOMPILED_DEFINES, e = goog.global.CLOSURE_DEFINES;
    d && void 0 === d.nodeType && Object.prototype.hasOwnProperty.call(d, a) ? c = d[a] : e && void 0 === e.nodeType && Object.prototype.hasOwnProperty.call(e, a) && (c = e[a]);
  }
  goog.exportPath_(a, c);
};
goog.DEBUG = !0;
goog.LOCALE = "en";
goog.TRUSTED_SITE = !0;
goog.STRICT_MODE_COMPATIBLE = !1;
goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG;
goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1;
goog.provide = function(a) {
  if (goog.isInModuleLoader_()) {
    throw Error("goog.provide can not be used within a goog.module.");
  }
  if (!COMPILED && goog.isProvided_(a)) {
    throw Error('Namespace "' + a + '" already declared.');
  }
  goog.constructNamespace_(a);
};
goog.constructNamespace_ = function(a, b) {
  if (!COMPILED) {
    delete goog.implicitNamespaces_[a];
    for (var c = a; (c = c.substring(0, c.lastIndexOf("."))) && !goog.getObjectByName(c);) {
      goog.implicitNamespaces_[c] = !0;
    }
  }
  goog.exportPath_(a, b);
};
goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
goog.module = function(a) {
  if (!goog.isString(a) || !a || -1 == a.search(goog.VALID_MODULE_RE_)) {
    throw Error("Invalid module identifier");
  }
  if (!goog.isInModuleLoader_()) {
    throw Error("Module " + a + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
  }
  if (goog.moduleLoaderState_.moduleName) {
    throw Error("goog.module may only be called once per module.");
  }
  goog.moduleLoaderState_.moduleName = a;
  if (!COMPILED) {
    if (goog.isProvided_(a)) {
      throw Error('Namespace "' + a + '" already declared.');
    }
    delete goog.implicitNamespaces_[a];
  }
};
goog.module.get = function(a) {
  return goog.module.getInternal_(a);
};
goog.module.getInternal_ = function(a) {
  if (!COMPILED) {
    if (a in goog.loadedModules_) {
      return goog.loadedModules_[a];
    }
    if (!goog.implicitNamespaces_[a]) {
      return a = goog.getObjectByName(a), null != a ? a : null;
    }
  }
  return null;
};
goog.moduleLoaderState_ = null;
goog.isInModuleLoader_ = function() {
  return null != goog.moduleLoaderState_;
};
goog.module.declareLegacyNamespace = function() {
  if (!COMPILED && !goog.isInModuleLoader_()) {
    throw Error("goog.module.declareLegacyNamespace must be called from within a goog.module");
  }
  if (!COMPILED && !goog.moduleLoaderState_.moduleName) {
    throw Error("goog.module must be called prior to goog.module.declareLegacyNamespace.");
  }
  goog.moduleLoaderState_.declareLegacyNamespace = !0;
};
goog.setTestOnly = function(a) {
  if (goog.DISALLOW_TEST_ONLY_CODE) {
    throw a = a || "", Error("Importing test-only code into non-debug environment" + (a ? ": " + a : "."));
  }
};
goog.forwardDeclare = function(a) {
};
COMPILED || (goog.isProvided_ = function(a) {
  return a in goog.loadedModules_ || !goog.implicitNamespaces_[a] && goog.isDefAndNotNull(goog.getObjectByName(a));
}, goog.implicitNamespaces_ = {"goog.module":!0});
goog.getObjectByName = function(a, b) {
  for (var c = a.split("."), d = b || goog.global, e = 0; e < c.length; e++) {
    if (d = d[c[e]], !goog.isDefAndNotNull(d)) {
      return null;
    }
  }
  return d;
};
goog.globalize = function(a, b) {
  var c = b || goog.global, d;
  for (d in a) {
    c[d] = a[d];
  }
};
goog.addDependency = function(a, b, c, d) {
  if (goog.DEPENDENCIES_ENABLED) {
    var e = goog.getLoader_();
    e && e.addDependency(a, b, c, d);
  }
};
goog.ENABLE_DEBUG_LOADER = !0;
goog.logToConsole_ = function(a) {
  goog.global.console && goog.global.console.error(a);
};
goog.require = function(a) {
  goog.ENABLE_DEBUG_LOADER && goog.debugLoader_ && goog.getLoader_().earlyProcessLoad(a);
  if (!COMPILED) {
    if (goog.isProvided_(a)) {
      if (goog.isInModuleLoader_()) {
        return goog.module.getInternal_(a);
      }
    } else {
      if (goog.ENABLE_DEBUG_LOADER) {
        var b = goog.moduleLoaderState_;
        goog.moduleLoaderState_ = null;
        try {
          var c = goog.getLoader_();
          c ? c.load(a) : goog.logToConsole_("Could not load " + a + " because there is no debug loader.");
        } finally {
          goog.moduleLoaderState_ = b;
        }
      }
    }
    return null;
  }
};
goog.basePath = "";
goog.nullFunction = function() {
};
goog.abstractMethod = function() {
  throw Error("unimplemented abstract method");
};
goog.addSingletonGetter = function(a) {
  a.instance_ = void 0;
  a.getInstance = function() {
    if (a.instance_) {
      return a.instance_;
    }
    goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = a);
    return a.instance_ = new a;
  };
};
goog.instantiatedSingletons_ = [];
goog.LOAD_MODULE_USING_EVAL = !0;
goog.SEAL_MODULE_EXPORTS = goog.DEBUG;
goog.loadedModules_ = {};
goog.DEPENDENCIES_ENABLED = !COMPILED && goog.ENABLE_DEBUG_LOADER;
goog.TRANSPILE = "detect";
goog.TRANSPILER = "transpile.js";
goog.DEBUG_LOADER = "";
goog.hasBadLetScoping = null;
goog.useSafari10Workaround = function() {
  if (null == goog.hasBadLetScoping) {
    try {
      var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
    } catch (b) {
      a = !1;
    }
    goog.hasBadLetScoping = a;
  }
  return goog.hasBadLetScoping;
};
goog.workaroundSafari10EvalBug = function(a) {
  return "(function(){" + a + "\n;})();\n";
};
goog.loadModule = function(a) {
  var b = goog.moduleLoaderState_;
  try {
    goog.moduleLoaderState_ = {moduleName:"", declareLegacyNamespace:!1};
    if (goog.isFunction(a)) {
      var c = a.call(void 0, {});
    } else {
      if (goog.isString(a)) {
        goog.useSafari10Workaround() && (a = goog.workaroundSafari10EvalBug(a)), c = goog.loadModuleFromSource_.call(void 0, a);
      } else {
        throw Error("Invalid module definition");
      }
    }
    var d = goog.moduleLoaderState_.moduleName;
    if (goog.isString(d) && d) {
      goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(d, c) : goog.SEAL_MODULE_EXPORTS && Object.seal && "object" == typeof c && null != c && Object.seal(c), goog.loadedModules_[d] = c;
    } else {
      throw Error('Invalid module name "' + d + '"');
    }
  } finally {
    goog.moduleLoaderState_ = b;
  }
};
goog.loadModuleFromSource_ = function(a) {
  eval(a);
  return {};
};
goog.normalizePath_ = function(a) {
  a = a.split("/");
  for (var b = 0; b < a.length;) {
    "." == a[b] ? a.splice(b, 1) : b && ".." == a[b] && a[b - 1] && ".." != a[b - 1] ? a.splice(--b, 2) : b++;
  }
  return a.join("/");
};
goog.loadFileSync_ = function(a) {
  if (goog.global.CLOSURE_LOAD_FILE_SYNC) {
    return goog.global.CLOSURE_LOAD_FILE_SYNC(a);
  }
  try {
    var b = new goog.global.XMLHttpRequest;
    b.open("get", a, !1);
    b.send();
    return 0 == b.status || 200 == b.status ? b.responseText : null;
  } catch (c) {
    return null;
  }
};
goog.transpile_ = function(a, b) {
  var c = goog.global.$jscomp;
  c || (goog.global.$jscomp = c = {});
  var d = c.transpile;
  if (!d) {
    var e = goog.basePath + goog.TRANSPILER, f = goog.loadFileSync_(e);
    if (f) {
      (function() {
        eval(f + "\n//# sourceURL=" + e);
      }).call(goog.global);
      if (goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) {
        throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
      }
      goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile;
      c = goog.global.$jscomp;
      d = c.transpile;
    }
  }
  d || (d = c.transpile = function(a, b) {
    goog.logToConsole_(b + " requires transpilation but no transpiler was found.");
    return a;
  });
  return d(a, b);
};
goog.typeOf = function(a) {
  var b = typeof a;
  if ("object" == b) {
    if (a) {
      if (a instanceof Array) {
        return "array";
      }
      if (a instanceof Object) {
        return b;
      }
      var c = Object.prototype.toString.call(a);
      if ("[object Window]" == c) {
        return "object";
      }
      if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) {
        return "array";
      }
      if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) {
        return "function";
      }
    } else {
      return "null";
    }
  } else {
    if ("function" == b && "undefined" == typeof a.call) {
      return "object";
    }
  }
  return b;
};
goog.isNull = function(a) {
  return null === a;
};
goog.isDefAndNotNull = function(a) {
  return null != a;
};
goog.isArray = function(a) {
  return "array" == goog.typeOf(a);
};
goog.isArrayLike = function(a) {
  var b = goog.typeOf(a);
  return "array" == b || "object" == b && "number" == typeof a.length;
};
goog.isDateLike = function(a) {
  return goog.isObject(a) && "function" == typeof a.getFullYear;
};
goog.isFunction = function(a) {
  return "function" == goog.typeOf(a);
};
goog.isObject = function(a) {
  var b = typeof a;
  return "object" == b && null != a || "function" == b;
};
goog.getUid = function(a) {
  return a[goog.UID_PROPERTY_] || (a[goog.UID_PROPERTY_] = ++goog.uidCounter_);
};
goog.hasUid = function(a) {
  return !!a[goog.UID_PROPERTY_];
};
goog.removeUid = function(a) {
  null !== a && "removeAttribute" in a && a.removeAttribute(goog.UID_PROPERTY_);
  try {
    delete a[goog.UID_PROPERTY_];
  } catch (b) {
  }
};
goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0);
goog.uidCounter_ = 0;
goog.getHashCode = goog.getUid;
goog.removeHashCode = goog.removeUid;
goog.cloneObject = function(a) {
  var b = goog.typeOf(a);
  if ("object" == b || "array" == b) {
    if (a.clone) {
      return a.clone();
    }
    b = "array" == b ? [] : {};
    for (var c in a) {
      b[c] = goog.cloneObject(a[c]);
    }
    return b;
  }
  return a;
};
goog.bindNative_ = function(a, b, c) {
  return a.call.apply(a.bind, arguments);
};
goog.bindJs_ = function(a, b, c) {
  if (!a) {
    throw Error();
  }
  if (2 < arguments.length) {
    var d = Array.prototype.slice.call(arguments, 2);
    return function() {
      var c = Array.prototype.slice.call(arguments);
      Array.prototype.unshift.apply(c, d);
      return a.apply(b, c);
    };
  }
  return function() {
    return a.apply(b, arguments);
  };
};
goog.bind = function(a, b, c) {
  Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_;
  return goog.bind.apply(null, arguments);
};
goog.partial = function(a, b) {
  var c = Array.prototype.slice.call(arguments, 1);
  return function() {
    var b = c.slice();
    b.push.apply(b, arguments);
    return a.apply(this, b);
  };
};
goog.mixin = function(a, b) {
  for (var c in b) {
    a[c] = b[c];
  }
};
goog.now = goog.TRUSTED_SITE && Date.now || function() {
  return +new Date;
};
goog.globalEval = function(a) {
  if (goog.global.execScript) {
    goog.global.execScript(a, "JavaScript");
  } else {
    if (goog.global.eval) {
      if (null == goog.evalWorksForGlobals_) {
        try {
          goog.global.eval("var _evalTest_ = 1;");
        } catch (d) {
        }
        if ("undefined" != typeof goog.global._evalTest_) {
          try {
            delete goog.global._evalTest_;
          } catch (d) {
          }
          goog.evalWorksForGlobals_ = !0;
        } else {
          goog.evalWorksForGlobals_ = !1;
        }
      }
      if (goog.evalWorksForGlobals_) {
        goog.global.eval(a);
      } else {
        var b = goog.global.document, c = b.createElement("SCRIPT");
        c.type = "text/javascript";
        c.defer = !1;
        c.appendChild(b.createTextNode(a));
        b.head.appendChild(c);
        b.head.removeChild(c);
      }
    } else {
      throw Error("goog.globalEval not available");
    }
  }
};
goog.evalWorksForGlobals_ = null;
goog.getCssName = function(a, b) {
  if ("." == String(a).charAt(0)) {
    throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + a);
  }
  var c = function(a) {
    return goog.cssNameMapping_[a] || a;
  }, d = function(a) {
    a = a.split("-");
    for (var b = [], d = 0; d < a.length; d++) {
      b.push(c(a[d]));
    }
    return b.join("-");
  };
  d = goog.cssNameMapping_ ? "BY_WHOLE" == goog.cssNameMappingStyle_ ? c : d : function(a) {
    return a;
  };
  d = b ? a + "-" + d(b) : d(a);
  return goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(d) : d;
};
goog.setCssNameMapping = function(a, b) {
  goog.cssNameMapping_ = a;
  goog.cssNameMappingStyle_ = b;
};
!COMPILED && goog.global.CLOSURE_CSS_NAME_MAPPING && (goog.cssNameMapping_ = goog.global.CLOSURE_CSS_NAME_MAPPING);
goog.getMsg = function(a, b) {
  b && (a = a.replace(/\{\$([^}]+)}/g, function(a, d) {
    return null != b && d in b ? b[d] : a;
  }));
  return a;
};
goog.getMsgWithFallback = function(a, b) {
  return a;
};
goog.exportSymbol = function(a, b, c) {
  goog.exportPath_(a, b, c);
};
goog.exportProperty = function(a, b, c) {
  a[b] = c;
};
goog.inherits = function(a, b) {
  function c() {
  }
  c.prototype = b.prototype;
  a.superClass_ = b.prototype;
  a.prototype = new c;
  a.prototype.constructor = a;
  a.base = function(a, c, f) {
    for (var d = Array(arguments.length - 2), e = 2; e < arguments.length; e++) {
      d[e - 2] = arguments[e];
    }
    return b.prototype[c].apply(a, d);
  };
};
goog.base = function(a, b, c) {
  var d = arguments.callee.caller;
  if (goog.STRICT_MODE_COMPATIBLE || goog.DEBUG && !d) {
    throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");
  }
  if (d.superClass_) {
    for (var e = Array(arguments.length - 1), f = 1; f < arguments.length; f++) {
      e[f - 1] = arguments[f];
    }
    return d.superClass_.constructor.apply(a, e);
  }
  e = Array(arguments.length - 2);
  for (f = 2; f < arguments.length; f++) {
    e[f - 2] = arguments[f];
  }
  f = !1;
  for (var g = a.constructor; g; g = g.superClass_ && g.superClass_.constructor) {
    if (g.prototype[b] === d) {
      f = !0;
    } else {
      if (f) {
        return g.prototype[b].apply(a, e);
      }
    }
  }
  if (a[b] === d) {
    return a.constructor.prototype[b].apply(a, e);
  }
  throw Error("goog.base called from a method of one name to a method of a different name");
};
goog.scope = function(a) {
  if (goog.isInModuleLoader_()) {
    throw Error("goog.scope is not supported within a goog.module.");
  }
  a.call(goog.global);
};
COMPILED || (goog.global.COMPILED = COMPILED);
goog.defineClass = function(a, b) {
  var c = b.constructor, d = b.statics;
  c && c != Object.prototype.constructor || (c = function() {
    throw Error("cannot instantiate an interface (no constructor defined).");
  });
  c = goog.defineClass.createSealingConstructor_(c, a);
  a && goog.inherits(c, a);
  delete b.constructor;
  delete b.statics;
  goog.defineClass.applyProperties_(c.prototype, b);
  null != d && (d instanceof Function ? d(c) : goog.defineClass.applyProperties_(c, d));
  return c;
};
goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG;
goog.defineClass.createSealingConstructor_ = function(a, b) {
  if (!goog.defineClass.SEAL_CLASS_INSTANCES) {
    return a;
  }
  var c = !goog.defineClass.isUnsealable_(b), d = function() {
    var b = a.apply(this, arguments) || this;
    b[goog.UID_PROPERTY_] = b[goog.UID_PROPERTY_];
    this.constructor === d && c && Object.seal instanceof Function && Object.seal(b);
    return b;
  };
  return d;
};
goog.defineClass.isUnsealable_ = function(a) {
  return a && a.prototype && a.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];
};
goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
goog.defineClass.applyProperties_ = function(a, b) {
  for (var c in b) {
    Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
  }
  for (var d = 0; d < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; d++) {
    c = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d], Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
  }
};
goog.tagUnsealableClass = function(a) {
  !COMPILED && goog.defineClass.SEAL_CLASS_INSTANCES && (a.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_] = !0);
};
goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_ = "goog_defineClass_legacy_unsealable";
goog.DEPENDENCIES_ENABLED && (goog.inHtmlDocument_ = function() {
  var a = goog.global.document;
  return null != a && "write" in a;
}, goog.findBasePath_ = function() {
  if (goog.isDef(goog.global.CLOSURE_BASE_PATH) && goog.isString(goog.global.CLOSURE_BASE_PATH)) {
    goog.basePath = goog.global.CLOSURE_BASE_PATH;
  } else {
    if (goog.inHtmlDocument_()) {
      var a = goog.global.document, b = a.currentScript;
      a = b ? [b] : a.getElementsByTagName("SCRIPT");
      for (b = a.length - 1; 0 <= b; --b) {
        var c = a[b].src, d = c.lastIndexOf("?");
        d = -1 == d ? c.length : d;
        if ("base.js" == c.substr(d - 7, 7)) {
          goog.basePath = c.substr(0, d - 7);
          break;
        }
      }
    }
  }
}, goog.findBasePath_(), goog.Transpiler = function() {
  this.requiresTranspilation_ = null;
}, goog.Transpiler.prototype.createRequiresTranspilation_ = function() {
  function a(a, b) {
    d ? c[a] = !0 : b() ? c[a] = !1 : d = c[a] = !0;
  }
  function b(a) {
    try {
      return !!eval(a);
    } catch (g) {
      return !1;
    }
  }
  var c = {es3:!1}, d = !1, e = goog.global.navigator && goog.global.navigator.userAgent ? goog.global.navigator.userAgent : "";
  a("es5", function() {
    return b("[1,].length==1");
  });
  a("es6", function() {
    var a = e.match(/Edge\/(\d+)(\.\d)*/i);
    return a && 15 > Number(a[1]) ? !1 : b('(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()');
  });
  a("es6-impl", function() {
    return !0;
  });
  a("es7", function() {
    return b("2 ** 2 == 4");
  });
  a("es8", function() {
    return b("async () => 1, true");
  });
  a("es_next", function() {
    return b("({...rest} = {}), true");
  });
  return c;
}, goog.Transpiler.prototype.needsTranspile = function(a) {
  if ("always" == goog.TRANSPILE) {
    return !0;
  }
  if ("never" == goog.TRANSPILE) {
    return !1;
  }
  this.requiresTranspilation_ || (this.requiresTranspilation_ = this.createRequiresTranspilation_());
  if (a in this.requiresTranspilation_) {
    return this.requiresTranspilation_[a];
  }
  throw Error("Unknown language mode: " + a);
}, goog.Transpiler.prototype.transpile = function(a, b) {
  return goog.transpile_(a, b);
}, goog.transpiler_ = new goog.Transpiler, goog.DebugLoader = function() {
  this.dependencies_ = {loadFlags:{}, nameToPath:{}, requires:{}, visited:{}, written:{}, deferred:{}};
  this.oldIeWaiting_ = !1;
  this.queuedModules_ = [];
  this.lastNonModuleScriptIndex_ = 0;
}, goog.DebugLoader.IS_OLD_IE_ = !(goog.global.atob || !goog.global.document || !goog.global.document.all), goog.DebugLoader.prototype.earlyProcessLoad = function(a) {
  goog.DebugLoader.IS_OLD_IE_ && this.maybeProcessDeferredDep_(a);
}, goog.DebugLoader.prototype.load = function(a) {
  var b = this.getPathFromDeps_(a);
  if (b) {
    var c = [], d = {}, e = this.dependencies_, f = this, g = function(a) {
      if (!(a in e.written || a in e.visited)) {
        e.visited[a] = !0;
        if (a in e.requires) {
          for (var b in e.requires[a]) {
            if (!f.isProvided(b)) {
              if (b in e.nameToPath) {
                g(e.nameToPath[b]);
              } else {
                throw Error("Undefined nameToPath for " + b);
              }
            }
          }
        }
        a in d || (d[a] = !0, c.push(a));
      }
    };
    g(b);
    for (a = 0; a < c.length; a++) {
      b = c[a], this.dependencies_.written[b] = !0;
    }
    for (a = 0; a < c.length; a++) {
      if (b = c[a]) {
        var h = e.loadFlags[b] || {}, k = h.lang || "es3";
        k = this.getTranspiler().needsTranspile(k);
        "goog" == h.module || k ? this.importProcessedScript_(goog.basePath + b, "goog" == h.module, k) : this.importScript_(goog.basePath + b);
      } else {
        throw Error("Undefined script input");
      }
    }
  } else {
    throw a = "goog.require could not find: " + a, this.logToConsole(a), Error(a);
  }
}, goog.DebugLoader.prototype.addDependency = function(a, b, c, d) {
  var e;
  a = a.replace(/\\/g, "/");
  var f = this.dependencies_;
  d && "boolean" !== typeof d || (d = d ? {module:"goog"} : {});
  for (var g = 0; e = b[g]; g++) {
    f.nameToPath[e] = a, f.loadFlags[a] = d;
  }
  for (d = 0; b = c[d]; d++) {
    a in f.requires || (f.requires[a] = {}), f.requires[a][b] = !0;
  }
}, goog.DebugLoader.prototype.importScript_ = function(a, b) {
  (goog.global.CLOSURE_IMPORT_SCRIPT || goog.bind(this.writeScriptTag_, this))(a, b) && (this.dependencies_.written[a] = !0);
}, goog.DebugLoader.prototype.importProcessedScript_ = function(a, b, c) {
  this.importScript_("", 'goog.debugLoader_.retrieveAndExec_("' + a + '", ' + b + ", " + c + ");");
}, goog.DebugLoader.prototype.retrieveAndExec_ = function(a, b, c) {
  if (!COMPILED) {
    var d = a;
    a = this.normalizePath(a);
    var e = goog.global.CLOSURE_IMPORT_SCRIPT || goog.bind(this.writeScriptTag_, this), f = this.loadFileSync(a);
    if (null == f) {
      throw Error('Load of "' + a + '" failed');
    }
    c && (f = this.getTranspiler().transpile(f, a));
    f = b ? this.wrapModule_(a, f) : f + ("\n//# sourceURL=" + a);
    goog.DebugLoader.IS_OLD_IE_ && this.oldIeWaiting_ ? (this.dependencies_.deferred[d] = f, this.queuedModules_.push(d)) : e(a, f);
  }
}, goog.DebugLoader.prototype.wrapModule_ = function(a, b) {
  return goog.LOAD_MODULE_USING_EVAL && goog.isDef(goog.global.JSON) ? "goog.loadModule(" + goog.global.JSON.stringify(b + "\n//# sourceURL=" + a + "\n") + ");" : 'goog.loadModule(function(exports) {"use strict";' + b + "\n;return exports});\n//# sourceURL=" + a + "\n";
}, goog.DebugLoader.prototype.loadQueuedModules_ = function() {
  var a = this.queuedModules_.length;
  if (0 < a) {
    var b = this.queuedModules_;
    this.queuedModules_ = [];
    for (var c = 0; c < a; c++) {
      this.maybeProcessDeferredPath_(b[c]);
    }
  }
  this.oldIeWaiting_ = !1;
}, goog.DebugLoader.prototype.maybeProcessDeferredDep_ = function(a) {
  this.isDeferredModule_(a) && this.allDepsAreAvailable_(a) && (a = this.getPathFromDeps_(a), this.maybeProcessDeferredPath_(goog.basePath + a));
}, goog.DebugLoader.prototype.isDeferredModule_ = function(a) {
  var b = (a = this.getPathFromDeps_(a)) && this.dependencies_.loadFlags[a] || {}, c = b.lang || "es3";
  return a && ("goog" == b.module || this.getTranspiler().needsTranspile(c)) ? goog.basePath + a in this.dependencies_.deferred : !1;
}, goog.DebugLoader.prototype.allDepsAreAvailable_ = function(a) {
  if ((a = this.getPathFromDeps_(a)) && a in this.dependencies_.requires) {
    for (var b in this.dependencies_.requires[a]) {
      if (!this.isProvided(b) && !this.isDeferredModule_(b)) {
        return !1;
      }
    }
  }
  return !0;
}, goog.DebugLoader.prototype.maybeProcessDeferredPath_ = function(a) {
  if (a in this.dependencies_.deferred) {
    var b = this.dependencies_.deferred[a];
    delete this.dependencies_.deferred[a];
    goog.globalEval(b);
  }
}, goog.DebugLoader.prototype.writeScriptSrcNode_ = function(a) {
  goog.global.document.write('<script type="text/javascript" src="' + a + '">\x3c/script>');
}, goog.DebugLoader.prototype.appendScriptSrcNode_ = function(a) {
  var b = goog.global.document, c = b.createElement("script");
  c.type = "text/javascript";
  c.src = a;
  c.defer = !1;
  c.async = !1;
  b.head.appendChild(c);
}, goog.DebugLoader.prototype.writeScriptTag_ = function(a, b) {
  if (this.inHtmlDocument()) {
    var c = goog.global.document;
    if (!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING && "complete" == c.readyState) {
      if (/\bdeps.js$/.test(a)) {
        return !1;
      }
      throw Error('Cannot write "' + a + '" after document load');
    }
    if (void 0 === b) {
      if (goog.DebugLoader.IS_OLD_IE_) {
        this.oldIeWaiting_ = !0;
        var d = " onreadystatechange='goog.debugLoader_.onScriptLoad_(this, " + ++this.lastNonModuleScriptIndex_ + ")' ";
        c.write('<script type="text/javascript" src="' + a + '"' + d + ">\x3c/script>");
      } else {
        goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING ? this.appendScriptSrcNode_(a) : this.writeScriptSrcNode_(a);
      }
    } else {
      c.write('<script type="text/javascript">' + this.protectScriptTag_(b) + "\x3c/script>");
    }
    return !0;
  }
  return !1;
}, goog.DebugLoader.prototype.protectScriptTag_ = function(a) {
  return a.replace(/<\/(SCRIPT)/ig, "\\x3c/$1");
}, goog.DebugLoader.prototype.onScriptLoad_ = function(a, b) {
  "complete" == a.readyState && this.lastNonModuleScriptIndex_ == b && this.loadQueuedModules_();
  return !0;
}, goog.DebugLoader.prototype.getPathFromDeps_ = function(a) {
  return a in this.dependencies_.nameToPath ? this.dependencies_.nameToPath[a] : null;
}, goog.DebugLoader.prototype.getTranspiler = function() {
  return goog.transpiler_;
}, goog.DebugLoader.prototype.isProvided = function(a) {
  return goog.isProvided_(a);
}, goog.DebugLoader.prototype.inHtmlDocument = function() {
  return goog.inHtmlDocument_();
}, goog.DebugLoader.prototype.logToConsole = function(a) {
  goog.logToConsole_(a);
}, goog.DebugLoader.prototype.loadFileSync = function(a) {
  return goog.loadFileSync_(a);
}, goog.DebugLoader.prototype.normalizePath = function(a) {
  return goog.normalizePath_(a);
}, goog.debugLoader_ = null, goog.registerDebugLoader = function(a) {
  if (goog.debugLoader_) {
    throw Error("Debug loader already registered!");
  }
  if (!(a instanceof goog.DebugLoader)) {
    throw Error("Not a goog.DebugLoader.");
  }
  goog.debugLoader_ = a;
}, goog.getLoader_ = function() {
  if (!goog.debugLoader_ && goog.DEBUG_LOADER) {
    throw Error("Loaded debug loader file but no loader was registered!");
  }
  goog.debugLoader_ || (goog.debugLoader_ = new goog.DebugLoader);
  return goog.debugLoader_;
}, function() {
  if (goog.DEBUG_LOADER) {
    var a = new goog.DebugLoader;
    a.importScript_(goog.basePath + goog.DEBUG_LOADER);
  }
  goog.global.CLOSURE_NO_DEPS || (a = a || new goog.DebugLoader, goog.DEBUG_LOADER || goog.registerDebugLoader(a), a.importScript_(goog.basePath + "deps.js"));
}());
goog.string = {};
goog.string.StringBuffer = function(a, b) {
  null != a && this.append.apply(this, arguments);
};
goog.string.StringBuffer.prototype.buffer_ = "";
goog.string.StringBuffer.prototype.set = function(a) {
  this.buffer_ = "" + a;
};
goog.string.StringBuffer.prototype.append = function(a, b, c) {
  this.buffer_ += String(a);
  if (null != b) {
    for (var d = 1; d < arguments.length; d++) {
      this.buffer_ += arguments[d];
    }
  }
  return this;
};
goog.string.StringBuffer.prototype.clear = function() {
  this.buffer_ = "";
};
goog.string.StringBuffer.prototype.getLength = function() {
  return this.buffer_.length;
};
goog.string.StringBuffer.prototype.toString = function() {
  return this.buffer_;
};
goog.debug = {};
goog.debug.Error = function(a) {
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, goog.debug.Error);
  } else {
    var b = Error().stack;
    b && (this.stack = b);
  }
  a && (this.message = String(a));
  this.reportErrorToServer = !0;
};
goog.inherits(goog.debug.Error, Error);
goog.debug.Error.prototype.name = "CustomError";
goog.dom = {};
goog.dom.NodeType = {ELEMENT:1, ATTRIBUTE:2, TEXT:3, CDATA_SECTION:4, ENTITY_REFERENCE:5, ENTITY:6, PROCESSING_INSTRUCTION:7, COMMENT:8, DOCUMENT:9, DOCUMENT_TYPE:10, DOCUMENT_FRAGMENT:11, NOTATION:12};
goog.asserts = {};
goog.asserts.ENABLE_ASSERTS = goog.DEBUG;
goog.asserts.AssertionError = function(a, b) {
  goog.debug.Error.call(this, goog.asserts.subs_(a, b));
  this.messagePattern = a;
};
goog.inherits(goog.asserts.AssertionError, goog.debug.Error);
goog.asserts.AssertionError.prototype.name = "AssertionError";
goog.asserts.DEFAULT_ERROR_HANDLER = function(a) {
  throw a;
};
goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER;
goog.asserts.subs_ = function(a, b) {
  for (var c = a.split("%s"), d = "", e = c.length - 1, f = 0; f < e; f++) {
    d += c[f] + (f < b.length ? b[f] : "%s");
  }
  return d + c[e];
};
goog.asserts.doAssertFailure_ = function(a, b, c, d) {
  var e = "Assertion failed";
  if (c) {
    e += ": " + c;
    var f = d;
  } else {
    a && (e += ": " + a, f = b);
  }
  a = new goog.asserts.AssertionError("" + e, f || []);
  goog.asserts.errorHandler_(a);
};
goog.asserts.setErrorHandler = function(a) {
  goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = a);
};
goog.asserts.assert = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !a && goog.asserts.doAssertFailure_("", null, b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.fail = function(a, b) {
  goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1)));
};
goog.asserts.assertNumber = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !goog.isNumber(a) && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertString = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !goog.isString(a) && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertFunction = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !goog.isFunction(a) && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertObject = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !goog.isObject(a) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertArray = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !goog.isArray(a) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertBoolean = function(a, b, c) {
  goog.asserts.ENABLE_ASSERTS && !goog.isBoolean(a) && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertElement = function(a, b, c) {
  !goog.asserts.ENABLE_ASSERTS || goog.isObject(a) && a.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertInstanceof = function(a, b, c, d) {
  !goog.asserts.ENABLE_ASSERTS || a instanceof b || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [goog.asserts.getType_(b), goog.asserts.getType_(a)], c, Array.prototype.slice.call(arguments, 3));
  return a;
};
goog.asserts.assertFinite = function(a, b, c) {
  !goog.asserts.ENABLE_ASSERTS || "number" == typeof a && isFinite(a) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [a], b, Array.prototype.slice.call(arguments, 2));
  return a;
};
goog.asserts.assertObjectPrototypeIsIntact = function() {
  for (var a in Object.prototype) {
    goog.asserts.fail(a + " should not be enumerable in Object.prototype.");
  }
};
goog.asserts.getType_ = function(a) {
  return a instanceof Function ? a.displayName || a.name || "unknown type name" : a instanceof Object ? a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a) : null === a ? "null" : typeof a;
};
goog.array = {};
goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
goog.array.ASSUME_NATIVE_FUNCTIONS = !1;
goog.array.peek = function(a) {
  return a[a.length - 1];
};
goog.array.last = goog.array.peek;
goog.array.indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.indexOf.call(a, b, c);
} : function(a, b, c) {
  c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;
  if (goog.isString(a)) {
    return goog.isString(b) && 1 == b.length ? a.indexOf(b, c) : -1;
  }
  for (; c < a.length; c++) {
    if (c in a && a[c] === b) {
      return c;
    }
  }
  return -1;
};
goog.array.lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.lastIndexOf.call(a, b, null == c ? a.length - 1 : c);
} : function(a, b, c) {
  c = null == c ? a.length - 1 : c;
  0 > c && (c = Math.max(0, a.length + c));
  if (goog.isString(a)) {
    return goog.isString(b) && 1 == b.length ? a.lastIndexOf(b, c) : -1;
  }
  for (; 0 <= c; c--) {
    if (c in a && a[c] === b) {
      return c;
    }
  }
  return -1;
};
goog.array.forEach = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  Array.prototype.forEach.call(a, b, c);
} : function(a, b, c) {
  for (var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++) {
    f in e && b.call(c, e[f], f, a);
  }
};
goog.array.forEachRight = function(a, b, c) {
  var d = a.length, e = goog.isString(a) ? a.split("") : a;
  for (--d; 0 <= d; --d) {
    d in e && b.call(c, e[d], d, a);
  }
};
goog.array.filter = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.filter.call(a, b, c);
} : function(a, b, c) {
  for (var d = a.length, e = [], f = 0, g = goog.isString(a) ? a.split("") : a, h = 0; h < d; h++) {
    if (h in g) {
      var k = g[h];
      b.call(c, k, h, a) && (e[f++] = k);
    }
  }
  return e;
};
goog.array.map = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.map.call(a, b, c);
} : function(a, b, c) {
  for (var d = a.length, e = Array(d), f = goog.isString(a) ? a.split("") : a, g = 0; g < d; g++) {
    g in f && (e[g] = b.call(c, f[g], g, a));
  }
  return e;
};
goog.array.reduce = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(a, b, c, d) {
  goog.asserts.assert(null != a.length);
  d && (b = goog.bind(b, d));
  return Array.prototype.reduce.call(a, b, c);
} : function(a, b, c, d) {
  var e = c;
  goog.array.forEach(a, function(c, g) {
    e = b.call(d, e, c, g, a);
  });
  return e;
};
goog.array.reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(a, b, c, d) {
  goog.asserts.assert(null != a.length);
  goog.asserts.assert(null != b);
  d && (b = goog.bind(b, d));
  return Array.prototype.reduceRight.call(a, b, c);
} : function(a, b, c, d) {
  var e = c;
  goog.array.forEachRight(a, function(c, g) {
    e = b.call(d, e, c, g, a);
  });
  return e;
};
goog.array.some = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.some.call(a, b, c);
} : function(a, b, c) {
  for (var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++) {
    if (f in e && b.call(c, e[f], f, a)) {
      return !0;
    }
  }
  return !1;
};
goog.array.every = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.every.call(a, b, c);
} : function(a, b, c) {
  for (var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++) {
    if (f in e && !b.call(c, e[f], f, a)) {
      return !1;
    }
  }
  return !0;
};
goog.array.count = function(a, b, c) {
  var d = 0;
  goog.array.forEach(a, function(a, f, g) {
    b.call(c, a, f, g) && ++d;
  }, c);
  return d;
};
goog.array.find = function(a, b, c) {
  b = goog.array.findIndex(a, b, c);
  return 0 > b ? null : goog.isString(a) ? a.charAt(b) : a[b];
};
goog.array.findIndex = function(a, b, c) {
  for (var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++) {
    if (f in e && b.call(c, e[f], f, a)) {
      return f;
    }
  }
  return -1;
};
goog.array.findRight = function(a, b, c) {
  b = goog.array.findIndexRight(a, b, c);
  return 0 > b ? null : goog.isString(a) ? a.charAt(b) : a[b];
};
goog.array.findIndexRight = function(a, b, c) {
  var d = a.length, e = goog.isString(a) ? a.split("") : a;
  for (--d; 0 <= d; d--) {
    if (d in e && b.call(c, e[d], d, a)) {
      return d;
    }
  }
  return -1;
};
goog.array.contains = function(a, b) {
  return 0 <= goog.array.indexOf(a, b);
};
goog.array.isEmpty = function(a) {
  return 0 == a.length;
};
goog.array.clear = function(a) {
  if (!goog.isArray(a)) {
    for (var b = a.length - 1; 0 <= b; b--) {
      delete a[b];
    }
  }
  a.length = 0;
};
goog.array.insert = function(a, b) {
  goog.array.contains(a, b) || a.push(b);
};
goog.array.insertAt = function(a, b, c) {
  goog.array.splice(a, c, 0, b);
};
goog.array.insertArrayAt = function(a, b, c) {
  goog.partial(goog.array.splice, a, c, 0).apply(null, b);
};
goog.array.insertBefore = function(a, b, c) {
  var d;
  2 == arguments.length || 0 > (d = goog.array.indexOf(a, c)) ? a.push(b) : goog.array.insertAt(a, b, d);
};
goog.array.remove = function(a, b) {
  var c = goog.array.indexOf(a, b), d;
  (d = 0 <= c) && goog.array.removeAt(a, c);
  return d;
};
goog.array.removeLast = function(a, b) {
  var c = goog.array.lastIndexOf(a, b);
  return 0 <= c ? (goog.array.removeAt(a, c), !0) : !1;
};
goog.array.removeAt = function(a, b) {
  goog.asserts.assert(null != a.length);
  return 1 == Array.prototype.splice.call(a, b, 1).length;
};
goog.array.removeIf = function(a, b, c) {
  b = goog.array.findIndex(a, b, c);
  return 0 <= b ? (goog.array.removeAt(a, b), !0) : !1;
};
goog.array.removeAllIf = function(a, b, c) {
  var d = 0;
  goog.array.forEachRight(a, function(e, f) {
    b.call(c, e, f, a) && goog.array.removeAt(a, f) && d++;
  });
  return d;
};
goog.array.concat = function(a) {
  return Array.prototype.concat.apply([], arguments);
};
goog.array.join = function(a) {
  return Array.prototype.concat.apply([], arguments);
};
goog.array.toArray = function(a) {
  var b = a.length;
  if (0 < b) {
    for (var c = Array(b), d = 0; d < b; d++) {
      c[d] = a[d];
    }
    return c;
  }
  return [];
};
goog.array.clone = goog.array.toArray;
goog.array.extend = function(a, b) {
  for (var c = 1; c < arguments.length; c++) {
    var d = arguments[c];
    if (goog.isArrayLike(d)) {
      var e = a.length || 0, f = d.length || 0;
      a.length = e + f;
      for (var g = 0; g < f; g++) {
        a[e + g] = d[g];
      }
    } else {
      a.push(d);
    }
  }
};
goog.array.splice = function(a, b, c, d) {
  goog.asserts.assert(null != a.length);
  return Array.prototype.splice.apply(a, goog.array.slice(arguments, 1));
};
goog.array.slice = function(a, b, c) {
  goog.asserts.assert(null != a.length);
  return 2 >= arguments.length ? Array.prototype.slice.call(a, b) : Array.prototype.slice.call(a, b, c);
};
goog.array.removeDuplicates = function(a, b, c) {
  b = b || a;
  var d = function(a) {
    return goog.isObject(a) ? "o" + goog.getUid(a) : (typeof a).charAt(0) + a;
  };
  c = c || d;
  d = {};
  for (var e = 0, f = 0; f < a.length;) {
    var g = a[f++], h = c(g);
    Object.prototype.hasOwnProperty.call(d, h) || (d[h] = !0, b[e++] = g);
  }
  b.length = e;
};
goog.array.binarySearch = function(a, b, c) {
  return goog.array.binarySearch_(a, c || goog.array.defaultCompare, !1, b);
};
goog.array.binarySelect = function(a, b, c) {
  return goog.array.binarySearch_(a, b, !0, void 0, c);
};
goog.array.binarySearch_ = function(a, b, c, d, e) {
  for (var f = 0, g = a.length, h; f < g;) {
    var k = f + g >> 1;
    var l = c ? b.call(e, a[k], k, a) : b(d, a[k]);
    0 < l ? f = k + 1 : (g = k, h = !l);
  }
  return h ? f : ~f;
};
goog.array.sort = function(a, b) {
  a.sort(b || goog.array.defaultCompare);
};
goog.array.stableSort = function(a, b) {
  for (var c = Array(a.length), d = 0; d < a.length; d++) {
    c[d] = {index:d, value:a[d]};
  }
  var e = b || goog.array.defaultCompare;
  goog.array.sort(c, function(a, b) {
    return e(a.value, b.value) || a.index - b.index;
  });
  for (d = 0; d < a.length; d++) {
    a[d] = c[d].value;
  }
};
goog.array.sortByKey = function(a, b, c) {
  var d = c || goog.array.defaultCompare;
  goog.array.sort(a, function(a, c) {
    return d(b(a), b(c));
  });
};
goog.array.sortObjectsByKey = function(a, b, c) {
  goog.array.sortByKey(a, function(a) {
    return a[b];
  }, c);
};
goog.array.isSorted = function(a, b, c) {
  b = b || goog.array.defaultCompare;
  for (var d = 1; d < a.length; d++) {
    var e = b(a[d - 1], a[d]);
    if (0 < e || 0 == e && c) {
      return !1;
    }
  }
  return !0;
};
goog.array.equals = function(a, b, c) {
  if (!goog.isArrayLike(a) || !goog.isArrayLike(b) || a.length != b.length) {
    return !1;
  }
  var d = a.length;
  c = c || goog.array.defaultCompareEquality;
  for (var e = 0; e < d; e++) {
    if (!c(a[e], b[e])) {
      return !1;
    }
  }
  return !0;
};
goog.array.compare3 = function(a, b, c) {
  c = c || goog.array.defaultCompare;
  for (var d = Math.min(a.length, b.length), e = 0; e < d; e++) {
    var f = c(a[e], b[e]);
    if (0 != f) {
      return f;
    }
  }
  return goog.array.defaultCompare(a.length, b.length);
};
goog.array.defaultCompare = function(a, b) {
  return a > b ? 1 : a < b ? -1 : 0;
};
goog.array.inverseDefaultCompare = function(a, b) {
  return -goog.array.defaultCompare(a, b);
};
goog.array.defaultCompareEquality = function(a, b) {
  return a === b;
};
goog.array.binaryInsert = function(a, b, c) {
  c = goog.array.binarySearch(a, b, c);
  return 0 > c ? (goog.array.insertAt(a, b, -(c + 1)), !0) : !1;
};
goog.array.binaryRemove = function(a, b, c) {
  b = goog.array.binarySearch(a, b, c);
  return 0 <= b ? goog.array.removeAt(a, b) : !1;
};
goog.array.bucket = function(a, b, c) {
  for (var d = {}, e = 0; e < a.length; e++) {
    var f = a[e], g = b.call(c, f, e, a);
    goog.isDef(g) && (d[g] || (d[g] = [])).push(f);
  }
  return d;
};
goog.array.toObject = function(a, b, c) {
  var d = {};
  goog.array.forEach(a, function(e, f) {
    d[b.call(c, e, f, a)] = e;
  });
  return d;
};
goog.array.range = function(a, b, c) {
  var d = [], e = 0, f = a;
  c = c || 1;
  void 0 !== b && (e = a, f = b);
  if (0 > c * (f - e)) {
    return [];
  }
  if (0 < c) {
    for (a = e; a < f; a += c) {
      d.push(a);
    }
  } else {
    for (a = e; a > f; a += c) {
      d.push(a);
    }
  }
  return d;
};
goog.array.repeat = function(a, b) {
  for (var c = [], d = 0; d < b; d++) {
    c[d] = a;
  }
  return c;
};
goog.array.flatten = function(a) {
  for (var b = [], c = 0; c < arguments.length; c++) {
    var d = arguments[c];
    if (goog.isArray(d)) {
      for (var e = 0; e < d.length; e += 8192) {
        var f = goog.array.slice(d, e, e + 8192);
        f = goog.array.flatten.apply(null, f);
        for (var g = 0; g < f.length; g++) {
          b.push(f[g]);
        }
      }
    } else {
      b.push(d);
    }
  }
  return b;
};
goog.array.rotate = function(a, b) {
  goog.asserts.assert(null != a.length);
  a.length && (b %= a.length, 0 < b ? Array.prototype.unshift.apply(a, a.splice(-b, b)) : 0 > b && Array.prototype.push.apply(a, a.splice(0, -b)));
  return a;
};
goog.array.moveItem = function(a, b, c) {
  goog.asserts.assert(0 <= b && b < a.length);
  goog.asserts.assert(0 <= c && c < a.length);
  b = Array.prototype.splice.call(a, b, 1);
  Array.prototype.splice.call(a, c, 0, b[0]);
};
goog.array.zip = function(a) {
  if (!arguments.length) {
    return [];
  }
  for (var b = [], c = arguments[0].length, d = 1; d < arguments.length; d++) {
    arguments[d].length < c && (c = arguments[d].length);
  }
  for (d = 0; d < c; d++) {
    for (var e = [], f = 0; f < arguments.length; f++) {
      e.push(arguments[f][d]);
    }
    b.push(e);
  }
  return b;
};
goog.array.shuffle = function(a, b) {
  for (var c = b || Math.random, d = a.length - 1; 0 < d; d--) {
    var e = Math.floor(c() * (d + 1)), f = a[d];
    a[d] = a[e];
    a[e] = f;
  }
};
goog.array.copyByIndex = function(a, b) {
  var c = [];
  goog.array.forEach(b, function(b) {
    c.push(a[b]);
  });
  return c;
};
goog.array.concatMap = function(a, b, c) {
  return goog.array.concat.apply([], goog.array.map(a, b, c));
};
goog.object = {};
goog.object.is = function(a, b) {
  return a === b ? 0 !== a || 1 / a === 1 / b : a !== a && b !== b;
};
goog.object.forEach = function(a, b, c) {
  for (var d in a) {
    b.call(c, a[d], d, a);
  }
};
goog.object.filter = function(a, b, c) {
  var d = {}, e;
  for (e in a) {
    b.call(c, a[e], e, a) && (d[e] = a[e]);
  }
  return d;
};
goog.object.map = function(a, b, c) {
  var d = {}, e;
  for (e in a) {
    d[e] = b.call(c, a[e], e, a);
  }
  return d;
};
goog.object.some = function(a, b, c) {
  for (var d in a) {
    if (b.call(c, a[d], d, a)) {
      return !0;
    }
  }
  return !1;
};
goog.object.every = function(a, b, c) {
  for (var d in a) {
    if (!b.call(c, a[d], d, a)) {
      return !1;
    }
  }
  return !0;
};
goog.object.getCount = function(a) {
  var b = 0, c;
  for (c in a) {
    b++;
  }
  return b;
};
goog.object.getAnyKey = function(a) {
  for (var b in a) {
    return b;
  }
};
goog.object.getAnyValue = function(a) {
  for (var b in a) {
    return a[b];
  }
};
goog.object.contains = function(a, b) {
  return goog.object.containsValue(a, b);
};
goog.object.getValues = function(a) {
  var b = [], c = 0, d;
  for (d in a) {
    b[c++] = a[d];
  }
  return b;
};
goog.object.getKeys = function(a) {
  var b = [], c = 0, d;
  for (d in a) {
    b[c++] = d;
  }
  return b;
};
goog.object.getValueByKeys = function(a, b) {
  var c = goog.isArrayLike(b), d = c ? b : arguments;
  for (c = c ? 0 : 1; c < d.length; c++) {
    if (null == a) {
      return;
    }
    a = a[d[c]];
  }
  return a;
};
goog.object.containsKey = function(a, b) {
  return null !== a && b in a;
};
goog.object.containsValue = function(a, b) {
  for (var c in a) {
    if (a[c] == b) {
      return !0;
    }
  }
  return !1;
};
goog.object.findKey = function(a, b, c) {
  for (var d in a) {
    if (b.call(c, a[d], d, a)) {
      return d;
    }
  }
};
goog.object.findValue = function(a, b, c) {
  return (b = goog.object.findKey(a, b, c)) && a[b];
};
goog.object.isEmpty = function(a) {
  for (var b in a) {
    return !1;
  }
  return !0;
};
goog.object.clear = function(a) {
  for (var b in a) {
    delete a[b];
  }
};
goog.object.remove = function(a, b) {
  var c;
  (c = b in a) && delete a[b];
  return c;
};
goog.object.add = function(a, b, c) {
  if (null !== a && b in a) {
    throw Error('The object already contains the key "' + b + '"');
  }
  goog.object.set(a, b, c);
};
goog.object.get = function(a, b, c) {
  return null !== a && b in a ? a[b] : c;
};
goog.object.set = function(a, b, c) {
  a[b] = c;
};
goog.object.setIfUndefined = function(a, b, c) {
  return b in a ? a[b] : a[b] = c;
};
goog.object.setWithReturnValueIfNotSet = function(a, b, c) {
  if (b in a) {
    return a[b];
  }
  c = c();
  return a[b] = c;
};
goog.object.equals = function(a, b) {
  for (var c in a) {
    if (!(c in b) || a[c] !== b[c]) {
      return !1;
    }
  }
  for (c in b) {
    if (!(c in a)) {
      return !1;
    }
  }
  return !0;
};
goog.object.clone = function(a) {
  var b = {}, c;
  for (c in a) {
    b[c] = a[c];
  }
  return b;
};
goog.object.unsafeClone = function(a) {
  var b = goog.typeOf(a);
  if ("object" == b || "array" == b) {
    if (goog.isFunction(a.clone)) {
      return a.clone();
    }
    b = "array" == b ? [] : {};
    for (var c in a) {
      b[c] = goog.object.unsafeClone(a[c]);
    }
    return b;
  }
  return a;
};
goog.object.transpose = function(a) {
  var b = {}, c;
  for (c in a) {
    b[a[c]] = c;
  }
  return b;
};
goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
goog.object.extend = function(a, b) {
  for (var c, d, e = 1; e < arguments.length; e++) {
    d = arguments[e];
    for (c in d) {
      a[c] = d[c];
    }
    for (var f = 0; f < goog.object.PROTOTYPE_FIELDS_.length; f++) {
      c = goog.object.PROTOTYPE_FIELDS_[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
  }
};
goog.object.create = function(a) {
  var b = arguments.length;
  if (1 == b && goog.isArray(arguments[0])) {
    return goog.object.create.apply(null, arguments[0]);
  }
  if (b % 2) {
    throw Error("Uneven number of arguments");
  }
  for (var c = {}, d = 0; d < b; d += 2) {
    c[arguments[d]] = arguments[d + 1];
  }
  return c;
};
goog.object.createSet = function(a) {
  var b = arguments.length;
  if (1 == b && goog.isArray(arguments[0])) {
    return goog.object.createSet.apply(null, arguments[0]);
  }
  for (var c = {}, d = 0; d < b; d++) {
    c[arguments[d]] = !0;
  }
  return c;
};
goog.object.createImmutableView = function(a) {
  var b = a;
  Object.isFrozen && !Object.isFrozen(a) && (b = Object.create(a), Object.freeze(b));
  return b;
};
goog.object.isImmutableView = function(a) {
  return !!Object.isFrozen && Object.isFrozen(a);
};
goog.object.getAllPropertyNames = function(a, b, c) {
  if (!a) {
    return [];
  }
  if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) {
    return goog.object.getKeys(a);
  }
  for (var d = {}; a && (a !== Object.prototype || b) && (a !== Function.prototype || c);) {
    for (var e = Object.getOwnPropertyNames(a), f = 0; f < e.length; f++) {
      d[e[f]] = !0;
    }
    a = Object.getPrototypeOf(a);
  }
  return goog.object.getKeys(d);
};
goog.string.DETECT_DOUBLE_ESCAPING = !1;
goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1;
goog.string.Unicode = {NBSP:"\u00a0"};
goog.string.startsWith = function(a, b) {
  return 0 == a.lastIndexOf(b, 0);
};
goog.string.endsWith = function(a, b) {
  var c = a.length - b.length;
  return 0 <= c && a.indexOf(b, c) == c;
};
goog.string.caseInsensitiveStartsWith = function(a, b) {
  return 0 == goog.string.caseInsensitiveCompare(b, a.substr(0, b.length));
};
goog.string.caseInsensitiveEndsWith = function(a, b) {
  return 0 == goog.string.caseInsensitiveCompare(b, a.substr(a.length - b.length, b.length));
};
goog.string.caseInsensitiveEquals = function(a, b) {
  return a.toLowerCase() == b.toLowerCase();
};
goog.string.subs = function(a, b) {
  for (var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;) {
    d += c.shift() + e.shift();
  }
  return d + c.join("%s");
};
goog.string.collapseWhitespace = function(a) {
  return a.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
};
goog.string.isEmptyOrWhitespace = function(a) {
  return /^[\s\xa0]*$/.test(a);
};
goog.string.isEmptyString = function(a) {
  return 0 == a.length;
};
goog.string.isEmpty = goog.string.isEmptyOrWhitespace;
goog.string.isEmptyOrWhitespaceSafe = function(a) {
  return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a));
};
goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe;
goog.string.isBreakingWhitespace = function(a) {
  return !/[^\t\n\r ]/.test(a);
};
goog.string.isAlpha = function(a) {
  return !/[^a-zA-Z]/.test(a);
};
goog.string.isNumeric = function(a) {
  return !/[^0-9]/.test(a);
};
goog.string.isAlphaNumeric = function(a) {
  return !/[^a-zA-Z0-9]/.test(a);
};
goog.string.isSpace = function(a) {
  return " " == a;
};
goog.string.isUnicodeChar = function(a) {
  return 1 == a.length && " " <= a && "~" >= a || "\u0080" <= a && "\ufffd" >= a;
};
goog.string.stripNewlines = function(a) {
  return a.replace(/(\r\n|\r|\n)+/g, " ");
};
goog.string.canonicalizeNewlines = function(a) {
  return a.replace(/(\r\n|\r|\n)/g, "\n");
};
goog.string.normalizeWhitespace = function(a) {
  return a.replace(/\xa0|\s/g, " ");
};
goog.string.normalizeSpaces = function(a) {
  return a.replace(/\xa0|[ \t]+/g, " ");
};
goog.string.collapseBreakingSpaces = function(a) {
  return a.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
};
goog.string.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(a) {
  return a.trim();
} : function(a) {
  return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
};
goog.string.trimLeft = function(a) {
  return a.replace(/^[\s\xa0]+/, "");
};
goog.string.trimRight = function(a) {
  return a.replace(/[\s\xa0]+$/, "");
};
goog.string.caseInsensitiveCompare = function(a, b) {
  var c = String(a).toLowerCase(), d = String(b).toLowerCase();
  return c < d ? -1 : c == d ? 0 : 1;
};
goog.string.numberAwareCompare_ = function(a, b, c) {
  if (a == b) {
    return 0;
  }
  if (!a) {
    return -1;
  }
  if (!b) {
    return 1;
  }
  for (var d = a.toLowerCase().match(c), e = b.toLowerCase().match(c), f = Math.min(d.length, e.length), g = 0; g < f; g++) {
    c = d[g];
    var h = e[g];
    if (c != h) {
      return a = parseInt(c, 10), !isNaN(a) && (b = parseInt(h, 10), !isNaN(b) && a - b) ? a - b : c < h ? -1 : 1;
    }
  }
  return d.length != e.length ? d.length - e.length : a < b ? -1 : 1;
};
goog.string.intAwareCompare = function(a, b) {
  return goog.string.numberAwareCompare_(a, b, /\d+|\D+/g);
};
goog.string.floatAwareCompare = function(a, b) {
  return goog.string.numberAwareCompare_(a, b, /\d+|\.\d+|\D+/g);
};
goog.string.numerateCompare = goog.string.floatAwareCompare;
goog.string.urlEncode = function(a) {
  return encodeURIComponent(String(a));
};
goog.string.urlDecode = function(a) {
  return decodeURIComponent(a.replace(/\+/g, " "));
};
goog.string.newLineToBr = function(a, b) {
  return a.replace(/(\r\n|\r|\n)/g, b ? "<br />" : "<br>");
};
goog.string.htmlEscape = function(a, b) {
  if (b) {
    a = a.replace(goog.string.AMP_RE_, "&amp;").replace(goog.string.LT_RE_, "&lt;").replace(goog.string.GT_RE_, "&gt;").replace(goog.string.QUOT_RE_, "&quot;").replace(goog.string.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.NULL_RE_, "&#0;"), goog.string.DETECT_DOUBLE_ESCAPING && (a = a.replace(goog.string.E_RE_, "&#101;"));
  } else {
    if (!goog.string.ALL_RE_.test(a)) {
      return a;
    }
    -1 != a.indexOf("&") && (a = a.replace(goog.string.AMP_RE_, "&amp;"));
    -1 != a.indexOf("<") && (a = a.replace(goog.string.LT_RE_, "&lt;"));
    -1 != a.indexOf(">") && (a = a.replace(goog.string.GT_RE_, "&gt;"));
    -1 != a.indexOf('"') && (a = a.replace(goog.string.QUOT_RE_, "&quot;"));
    -1 != a.indexOf("'") && (a = a.replace(goog.string.SINGLE_QUOTE_RE_, "&#39;"));
    -1 != a.indexOf("\x00") && (a = a.replace(goog.string.NULL_RE_, "&#0;"));
    goog.string.DETECT_DOUBLE_ESCAPING && -1 != a.indexOf("e") && (a = a.replace(goog.string.E_RE_, "&#101;"));
  }
  return a;
};
goog.string.AMP_RE_ = /&/g;
goog.string.LT_RE_ = /</g;
goog.string.GT_RE_ = />/g;
goog.string.QUOT_RE_ = /"/g;
goog.string.SINGLE_QUOTE_RE_ = /'/g;
goog.string.NULL_RE_ = /\x00/g;
goog.string.E_RE_ = /e/g;
goog.string.ALL_RE_ = goog.string.DETECT_DOUBLE_ESCAPING ? /[\x00&<>"'e]/ : /[\x00&<>"']/;
goog.string.unescapeEntities = function(a) {
  return goog.string.contains(a, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(a) : goog.string.unescapePureXmlEntities_(a) : a;
};
goog.string.unescapeEntitiesWithDocument = function(a, b) {
  return goog.string.contains(a, "&") ? goog.string.unescapeEntitiesUsingDom_(a, b) : a;
};
goog.string.unescapeEntitiesUsingDom_ = function(a, b) {
  var c = {"&amp;":"&", "&lt;":"<", "&gt;":">", "&quot;":'"'};
  var d = b ? b.createElement("div") : goog.global.document.createElement("div");
  return a.replace(goog.string.HTML_ENTITY_PATTERN_, function(a, b) {
    var e = c[a];
    if (e) {
      return e;
    }
    if ("#" == b.charAt(0)) {
      var f = Number("0" + b.substr(1));
      isNaN(f) || (e = String.fromCharCode(f));
    }
    e || (d.innerHTML = a + " ", e = d.firstChild.nodeValue.slice(0, -1));
    return c[a] = e;
  });
};
goog.string.unescapePureXmlEntities_ = function(a) {
  return a.replace(/&([^;]+);/g, function(a, c) {
    switch(c) {
      case "amp":
        return "&";
      case "lt":
        return "<";
      case "gt":
        return ">";
      case "quot":
        return '"';
      default:
        if ("#" == c.charAt(0)) {
          var b = Number("0" + c.substr(1));
          if (!isNaN(b)) {
            return String.fromCharCode(b);
          }
        }
        return a;
    }
  });
};
goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g;
goog.string.whitespaceEscape = function(a, b) {
  return goog.string.newLineToBr(a.replace(/  /g, " &#160;"), b);
};
goog.string.preserveSpaces = function(a) {
  return a.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
};
goog.string.stripQuotes = function(a, b) {
  for (var c = b.length, d = 0; d < c; d++) {
    var e = 1 == c ? b : b.charAt(d);
    if (a.charAt(0) == e && a.charAt(a.length - 1) == e) {
      return a.substring(1, a.length - 1);
    }
  }
  return a;
};
goog.string.truncate = function(a, b, c) {
  c && (a = goog.string.unescapeEntities(a));
  a.length > b && (a = a.substring(0, b - 3) + "...");
  c && (a = goog.string.htmlEscape(a));
  return a;
};
goog.string.truncateMiddle = function(a, b, c, d) {
  c && (a = goog.string.unescapeEntities(a));
  if (d && a.length > b) {
    d > b && (d = b);
    var e = a.length - d;
    a = a.substring(0, b - d) + "..." + a.substring(e);
  } else {
    a.length > b && (d = Math.floor(b / 2), e = a.length - d, a = a.substring(0, d + b % 2) + "..." + a.substring(e));
  }
  c && (a = goog.string.htmlEscape(a));
  return a;
};
goog.string.specialEscapeChars_ = {"\x00":"\\0", "\b":"\\b", "\f":"\\f", "\n":"\\n", "\r":"\\r", "\t":"\\t", "\x0B":"\\x0B", '"':'\\"', "\\":"\\\\", "<":"<"};
goog.string.jsEscapeCache_ = {"'":"\\'"};
goog.string.quote = function(a) {
  a = String(a);
  for (var b = ['"'], c = 0; c < a.length; c++) {
    var d = a.charAt(c), e = d.charCodeAt(0);
    b[c + 1] = goog.string.specialEscapeChars_[d] || (31 < e && 127 > e ? d : goog.string.escapeChar(d));
  }
  b.push('"');
  return b.join("");
};
goog.string.escapeString = function(a) {
  for (var b = [], c = 0; c < a.length; c++) {
    b[c] = goog.string.escapeChar(a.charAt(c));
  }
  return b.join("");
};
goog.string.escapeChar = function(a) {
  if (a in goog.string.jsEscapeCache_) {
    return goog.string.jsEscapeCache_[a];
  }
  if (a in goog.string.specialEscapeChars_) {
    return goog.string.jsEscapeCache_[a] = goog.string.specialEscapeChars_[a];
  }
  var b = a.charCodeAt(0);
  if (31 < b && 127 > b) {
    var c = a;
  } else {
    if (256 > b) {
      if (c = "\\x", 16 > b || 256 < b) {
        c += "0";
      }
    } else {
      c = "\\u", 4096 > b && (c += "0");
    }
    c += b.toString(16).toUpperCase();
  }
  return goog.string.jsEscapeCache_[a] = c;
};
goog.string.contains = function(a, b) {
  return -1 != a.indexOf(b);
};
goog.string.caseInsensitiveContains = function(a, b) {
  return goog.string.contains(a.toLowerCase(), b.toLowerCase());
};
goog.string.countOf = function(a, b) {
  return a && b ? a.split(b).length - 1 : 0;
};
goog.string.removeAt = function(a, b, c) {
  var d = a;
  0 <= b && b < a.length && 0 < c && (d = a.substr(0, b) + a.substr(b + c, a.length - b - c));
  return d;
};
goog.string.remove = function(a, b) {
  return a.replace(b, "");
};
goog.string.removeAll = function(a, b) {
  var c = new RegExp(goog.string.regExpEscape(b), "g");
  return a.replace(c, "");
};
goog.string.replaceAll = function(a, b, c) {
  b = new RegExp(goog.string.regExpEscape(b), "g");
  return a.replace(b, c.replace(/\$/g, "$$$$"));
};
goog.string.regExpEscape = function(a) {
  return String(a).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
};
goog.string.repeat = String.prototype.repeat ? function(a, b) {
  return a.repeat(b);
} : function(a, b) {
  return Array(b + 1).join(a);
};
goog.string.padNumber = function(a, b, c) {
  a = goog.isDef(c) ? a.toFixed(c) : String(a);
  c = a.indexOf(".");
  -1 == c && (c = a.length);
  return goog.string.repeat("0", Math.max(0, b - c)) + a;
};
goog.string.makeSafe = function(a) {
  return null == a ? "" : String(a);
};
goog.string.buildString = function(a) {
  return Array.prototype.join.call(arguments, "");
};
goog.string.getRandomString = function() {
  return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
};
goog.string.compareVersions = function(a, b) {
  for (var c = 0, d = goog.string.trim(String(a)).split("."), e = goog.string.trim(String(b)).split("."), f = Math.max(d.length, e.length), g = 0; 0 == c && g < f; g++) {
    var h = d[g] || "", k = e[g] || "";
    do {
      h = /(\d*)(\D*)(.*)/.exec(h) || ["", "", "", ""];
      k = /(\d*)(\D*)(.*)/.exec(k) || ["", "", "", ""];
      if (0 == h[0].length && 0 == k[0].length) {
        break;
      }
      c = 0 == h[1].length ? 0 : parseInt(h[1], 10);
      var l = 0 == k[1].length ? 0 : parseInt(k[1], 10);
      c = goog.string.compareElements_(c, l) || goog.string.compareElements_(0 == h[2].length, 0 == k[2].length) || goog.string.compareElements_(h[2], k[2]);
      h = h[3];
      k = k[3];
    } while (0 == c);
  }
  return c;
};
goog.string.compareElements_ = function(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
};
goog.string.hashCode = function(a) {
  for (var b = 0, c = 0; c < a.length; ++c) {
    b = 31 * b + a.charCodeAt(c) >>> 0;
  }
  return b;
};
goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0;
goog.string.createUniqueString = function() {
  return "goog_" + goog.string.uniqueStringCounter_++;
};
goog.string.toNumber = function(a) {
  var b = Number(a);
  return 0 == b && goog.string.isEmptyOrWhitespace(a) ? NaN : b;
};
goog.string.isLowerCamelCase = function(a) {
  return /^[a-z]+([A-Z][a-z]*)*$/.test(a);
};
goog.string.isUpperCamelCase = function(a) {
  return /^([A-Z][a-z]*)+$/.test(a);
};
goog.string.toCamelCase = function(a) {
  return String(a).replace(/\-([a-z])/g, function(a, c) {
    return c.toUpperCase();
  });
};
goog.string.toSelectorCase = function(a) {
  return String(a).replace(/([A-Z])/g, "-$1").toLowerCase();
};
goog.string.toTitleCase = function(a, b) {
  var c = goog.isString(b) ? goog.string.regExpEscape(b) : "\\s";
  return a.replace(new RegExp("(^" + (c ? "|[" + c + "]+" : "") + ")([a-z])", "g"), function(a, b, c) {
    return b + c.toUpperCase();
  });
};
goog.string.capitalize = function(a) {
  return String(a.charAt(0)).toUpperCase() + String(a.substr(1)).toLowerCase();
};
goog.string.parseInt = function(a) {
  isFinite(a) && (a = String(a));
  return goog.isString(a) ? /^\s*-?0x/i.test(a) ? parseInt(a, 16) : parseInt(a, 10) : NaN;
};
goog.string.splitLimit = function(a, b, c) {
  a = a.split(b);
  for (var d = []; 0 < c && a.length;) {
    d.push(a.shift()), c--;
  }
  a.length && d.push(a.join(b));
  return d;
};
goog.string.lastComponent = function(a, b) {
  if (b) {
    "string" == typeof b && (b = [b]);
  } else {
    return a;
  }
  for (var c = -1, d = 0; d < b.length; d++) {
    if ("" != b[d]) {
      var e = a.lastIndexOf(b[d]);
      e > c && (c = e);
    }
  }
  return -1 == c ? a : a.slice(c + 1);
};
goog.string.editDistance = function(a, b) {
  var c = [], d = [];
  if (a == b) {
    return 0;
  }
  if (!a.length || !b.length) {
    return Math.max(a.length, b.length);
  }
  for (var e = 0; e < b.length + 1; e++) {
    c[e] = e;
  }
  for (e = 0; e < a.length; e++) {
    d[0] = e + 1;
    for (var f = 0; f < b.length; f++) {
      d[f + 1] = Math.min(d[f] + 1, c[f + 1] + 1, c[f] + Number(a[e] != b[f]));
    }
    for (f = 0; f < c.length; f++) {
      c[f] = d[f];
    }
  }
  return d[b.length];
};
goog.proto2 = {};
goog.proto2.Descriptor = function(a, b, c) {
  this.messageType_ = a;
  this.name_ = b.name || null;
  this.fullName_ = b.fullName || null;
  this.containingType_ = b.containingType;
  this.fields_ = {};
  for (a = 0; a < c.length; a++) {
    b = c[a], this.fields_[b.getTag()] = b;
  }
};
goog.proto2.Descriptor.prototype.getName = function() {
  return this.name_;
};
goog.proto2.Descriptor.prototype.getFullName = function() {
  return this.fullName_;
};
goog.proto2.Descriptor.prototype.getContainingType = function() {
  return this.containingType_ ? this.containingType_.getDescriptor() : null;
};
goog.proto2.Descriptor.prototype.getFields = function() {
  var a = goog.object.getValues(this.fields_);
  goog.array.sort(a, function(a, c) {
    return a.getTag() - c.getTag();
  });
  return a;
};
goog.proto2.Descriptor.prototype.getFieldsMap = function() {
  return this.fields_;
};
goog.proto2.Descriptor.prototype.findFieldByName = function(a) {
  return goog.object.findValue(this.fields_, function(b, c, d) {
    return b.getName() == a;
  }) || null;
};
goog.proto2.Descriptor.prototype.findFieldByTag = function(a) {
  goog.asserts.assert(goog.string.isNumeric(a));
  return this.fields_[parseInt(a, 10)] || null;
};
goog.proto2.Descriptor.prototype.createMessageInstance = function() {
  return new this.messageType_;
};
goog.proto2.FieldDescriptor = function(a, b, c) {
  this.parent_ = a;
  goog.asserts.assert(goog.string.isNumeric(b));
  this.tag_ = b;
  this.name_ = c.name;
  this.isPacked_ = !!c.packed;
  this.isRepeated_ = !!c.repeated;
  this.isRequired_ = !!c.required;
  this.fieldType_ = c.fieldType;
  this.nativeType_ = c.type;
  this.deserializationConversionPermitted_ = !1;
  switch(this.fieldType_) {
    case goog.proto2.FieldDescriptor.FieldType.INT64:
    case goog.proto2.FieldDescriptor.FieldType.UINT64:
    case goog.proto2.FieldDescriptor.FieldType.FIXED64:
    case goog.proto2.FieldDescriptor.FieldType.SFIXED64:
    case goog.proto2.FieldDescriptor.FieldType.SINT64:
    case goog.proto2.FieldDescriptor.FieldType.FLOAT:
    case goog.proto2.FieldDescriptor.FieldType.DOUBLE:
      this.deserializationConversionPermitted_ = !0;
  }
  this.defaultValue_ = c.defaultValue;
};
goog.proto2.FieldDescriptor.FieldType = {DOUBLE:1, FLOAT:2, INT64:3, UINT64:4, INT32:5, FIXED64:6, FIXED32:7, BOOL:8, STRING:9, GROUP:10, MESSAGE:11, BYTES:12, UINT32:13, ENUM:14, SFIXED32:15, SFIXED64:16, SINT32:17, SINT64:18};
goog.proto2.FieldDescriptor.prototype.getTag = function() {
  return this.tag_;
};
goog.proto2.FieldDescriptor.prototype.getContainingType = function() {
  return this.parent_.prototype.getDescriptor();
};
goog.proto2.FieldDescriptor.prototype.getName = function() {
  return this.name_;
};
goog.proto2.FieldDescriptor.prototype.getDefaultValue = function() {
  if (void 0 === this.defaultValue_) {
    var a = this.nativeType_;
    if (a === Boolean) {
      this.defaultValue_ = !1;
    } else {
      if (a === Number) {
        this.defaultValue_ = 0;
      } else {
        if (a === String) {
          this.defaultValue_ = this.deserializationConversionPermitted_ ? "0" : "";
        } else {
          return new a;
        }
      }
    }
  }
  return this.defaultValue_;
};
goog.proto2.FieldDescriptor.prototype.getFieldType = function() {
  return this.fieldType_;
};
goog.proto2.FieldDescriptor.prototype.getNativeType = function() {
  return this.nativeType_;
};
goog.proto2.FieldDescriptor.prototype.deserializationConversionPermitted = function() {
  return this.deserializationConversionPermitted_;
};
goog.proto2.FieldDescriptor.prototype.getFieldMessageType = function() {
  return this.nativeType_.prototype.getDescriptor();
};
goog.proto2.FieldDescriptor.prototype.isCompositeType = function() {
  return this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.MESSAGE || this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.GROUP;
};
goog.proto2.FieldDescriptor.prototype.isPacked = function() {
  return this.isPacked_;
};
goog.proto2.FieldDescriptor.prototype.isRepeated = function() {
  return this.isRepeated_;
};
goog.proto2.FieldDescriptor.prototype.isRequired = function() {
  return this.isRequired_;
};
goog.proto2.FieldDescriptor.prototype.isOptional = function() {
  return !this.isRepeated_ && !this.isRequired_;
};
goog.proto2.Message = function() {
  this.values_ = {};
  this.fields_ = this.getDescriptor().getFieldsMap();
  this.deserializedFields_ = this.lazyDeserializer_ = null;
};
goog.proto2.Message.FieldType = {DOUBLE:1, FLOAT:2, INT64:3, UINT64:4, INT32:5, FIXED64:6, FIXED32:7, BOOL:8, STRING:9, GROUP:10, MESSAGE:11, BYTES:12, UINT32:13, ENUM:14, SFIXED32:15, SFIXED64:16, SINT32:17, SINT64:18};
goog.proto2.Message.prototype.initializeForLazyDeserializer = function(a, b) {
  this.lazyDeserializer_ = a;
  this.values_ = b;
  this.deserializedFields_ = {};
};
goog.proto2.Message.prototype.setUnknown = function(a, b) {
  goog.asserts.assert(!this.fields_[a], "Field is not unknown in this message");
  goog.asserts.assert(1 <= a, "Tag " + a + ' has value "' + b + '" in descriptor ' + this.getDescriptor().getName());
  goog.asserts.assert(null !== b, "Value cannot be null");
  this.values_[a] = b;
  this.deserializedFields_ && delete this.deserializedFields_[a];
};
goog.proto2.Message.prototype.forEachUnknown = function(a, b) {
  var c = b || this, d;
  for (d in this.values_) {
    var e = Number(d);
    this.fields_[e] || a.call(c, e, this.values_[d]);
  }
};
goog.proto2.Message.prototype.getDescriptor = goog.abstractMethod;
goog.proto2.Message.prototype.has = function(a) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  return this.has$Value(a.getTag());
};
goog.proto2.Message.prototype.arrayOf = function(a) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  return this.array$Values(a.getTag());
};
goog.proto2.Message.prototype.countOf = function(a) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  return this.count$Values(a.getTag());
};
goog.proto2.Message.prototype.get = function(a, b) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  return this.get$Value(a.getTag(), b);
};
goog.proto2.Message.prototype.getOrDefault = function(a, b) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  return this.get$ValueOrDefault(a.getTag(), b);
};
goog.proto2.Message.prototype.set = function(a, b) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  this.set$Value(a.getTag(), b);
};
goog.proto2.Message.prototype.add = function(a, b) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  this.add$Value(a.getTag(), b);
};
goog.proto2.Message.prototype.clear = function(a) {
  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
  this.clear$Field(a.getTag());
};
goog.proto2.Message.prototype.equals = function(a) {
  if (!a || this.constructor != a.constructor) {
    return !1;
  }
  for (var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++) {
    var d = b[c], e = d.getTag();
    if (this.has$Value(e) != a.has$Value(e)) {
      return !1;
    }
    if (this.has$Value(e)) {
      var f = d.isCompositeType(), g = this.getValueForTag_(e);
      e = a.getValueForTag_(e);
      if (d.isRepeated()) {
        if (g.length != e.length) {
          return !1;
        }
        for (d = 0; d < g.length; d++) {
          var h = g[d], k = e[d];
          if (f ? !h.equals(k) : h != k) {
            return !1;
          }
        }
      } else {
        if (f ? !g.equals(e) : g != e) {
          return !1;
        }
      }
    }
  }
  return !0;
};
goog.proto2.Message.prototype.copyFrom = function(a) {
  goog.asserts.assert(this.constructor == a.constructor, "The source message must have the same type.");
  this != a && (this.values_ = {}, this.deserializedFields_ && (this.deserializedFields_ = {}), this.mergeFrom(a));
};
goog.proto2.Message.prototype.mergeFrom = function(a) {
  goog.asserts.assert(this.constructor == a.constructor, "The source message must have the same type.");
  for (var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++) {
    var d = b[c], e = d.getTag();
    if (a.has$Value(e)) {
      this.deserializedFields_ && delete this.deserializedFields_[d.getTag()];
      var f = d.isCompositeType();
      if (d.isRepeated()) {
        d = a.array$Values(e);
        for (var g = 0; g < d.length; g++) {
          this.add$Value(e, f ? d[g].clone() : d[g]);
        }
      } else {
        d = a.getValueForTag_(e), f ? (f = this.getValueForTag_(e)) ? f.mergeFrom(d) : this.set$Value(e, d.clone()) : this.set$Value(e, d);
      }
    }
  }
};
goog.proto2.Message.prototype.clone = function() {
  var a = new this.constructor;
  a.copyFrom(this);
  return a;
};
goog.proto2.Message.prototype.initDefaults = function(a) {
  for (var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++) {
    var d = b[c], e = d.getTag(), f = d.isCompositeType();
    this.has$Value(e) || d.isRepeated() || (f ? this.values_[e] = new (d.getNativeType()) : a && (this.values_[e] = d.getDefaultValue()));
    if (f) {
      if (d.isRepeated()) {
        for (d = this.array$Values(e), e = 0; e < d.length; e++) {
          d[e].initDefaults(a);
        }
      } else {
        this.get$Value(e).initDefaults(a);
      }
    }
  }
};
goog.proto2.Message.prototype.has$Value = function(a) {
  return null != this.values_[a];
};
goog.proto2.Message.prototype.getValueForTag_ = function(a) {
  var b = this.values_[a];
  return goog.isDefAndNotNull(b) ? this.lazyDeserializer_ ? a in this.deserializedFields_ ? this.deserializedFields_[a] : (b = this.lazyDeserializer_.deserializeField(this, this.fields_[a], b), this.deserializedFields_[a] = b) : b : null;
};
goog.proto2.Message.prototype.get$Value = function(a, b) {
  var c = this.getValueForTag_(a);
  if (this.fields_[a].isRepeated()) {
    var d = b || 0;
    goog.asserts.assert(0 <= d && d < c.length, "Given index %s is out of bounds.  Repeated field length: %s", d, c.length);
    return c[d];
  }
  return c;
};
goog.proto2.Message.prototype.get$ValueOrDefault = function(a, b) {
  return this.has$Value(a) ? this.get$Value(a, b) : this.fields_[a].getDefaultValue();
};
goog.proto2.Message.prototype.array$Values = function(a) {
  return this.getValueForTag_(a) || [];
};
goog.proto2.Message.prototype.count$Values = function(a) {
  return this.fields_[a].isRepeated() ? this.has$Value(a) ? this.values_[a].length : 0 : this.has$Value(a) ? 1 : 0;
};
goog.proto2.Message.prototype.set$Value = function(a, b) {
  goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a], b);
  this.values_[a] = b;
  this.deserializedFields_ && (this.deserializedFields_[a] = b);
};
goog.proto2.Message.prototype.add$Value = function(a, b) {
  goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a], b);
  this.values_[a] || (this.values_[a] = []);
  this.values_[a].push(b);
  this.deserializedFields_ && delete this.deserializedFields_[a];
};
goog.proto2.Message.prototype.checkFieldType_ = function(a, b) {
  a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM ? goog.asserts.assertNumber(b) : goog.asserts.assert(Object(b).constructor == a.getNativeType());
};
goog.proto2.Message.prototype.clear$Field = function(a) {
  delete this.values_[a];
  this.deserializedFields_ && delete this.deserializedFields_[a];
};
goog.proto2.Message.createDescriptor = function(a, b) {
  var c = [], d = b[0], e;
  for (e in b) {
    0 != e && c.push(new goog.proto2.FieldDescriptor(a, e, b[e]));
  }
  return new goog.proto2.Descriptor(a, d, c);
};
goog.proto2.Serializer = function() {
};
goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS = !1;
goog.proto2.Serializer.prototype.serialize = goog.abstractMethod;
goog.proto2.Serializer.prototype.getSerializedValue = function(a, b) {
  return a.isCompositeType() ? this.serialize(b) : goog.isNumber(b) && !isFinite(b) ? b.toString() : b;
};
goog.proto2.Serializer.prototype.deserialize = function(a, b) {
  var c = a.createMessageInstance();
  this.deserializeTo(c, b);
  goog.asserts.assert(c instanceof goog.proto2.Message);
  return c;
};
goog.proto2.Serializer.prototype.deserializeTo = goog.abstractMethod;
goog.proto2.Serializer.prototype.getDeserializedValue = function(a, b) {
  if (a.isCompositeType()) {
    return b instanceof goog.proto2.Message ? b : this.deserialize(a.getFieldMessageType(), b);
  }
  if (a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM) {
    if (goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS && goog.isString(b)) {
      var c = a.getNativeType();
      if (c.hasOwnProperty(b)) {
        return c[b];
      }
    }
    return goog.isString(b) && goog.proto2.Serializer.INTEGER_REGEX.test(b) && (c = Number(b), 0 < c) ? c : b;
  }
  if (!a.deserializationConversionPermitted()) {
    return b;
  }
  c = a.getNativeType();
  if (c === String) {
    if (goog.isNumber(b)) {
      return String(b);
    }
  } else {
    if (c === Number && goog.isString(b) && ("Infinity" === b || "-Infinity" === b || "NaN" === b || goog.proto2.Serializer.INTEGER_REGEX.test(b))) {
      return Number(b);
    }
  }
  return b;
};
goog.proto2.Serializer.INTEGER_REGEX = /^-?[0-9]+$/;
goog.proto2.LazyDeserializer = function() {
};
goog.inherits(goog.proto2.LazyDeserializer, goog.proto2.Serializer);
goog.proto2.LazyDeserializer.prototype.deserialize = function(a, b) {
  var c = a.createMessageInstance();
  c.initializeForLazyDeserializer(this, b);
  goog.asserts.assert(c instanceof goog.proto2.Message);
  return c;
};
goog.proto2.LazyDeserializer.prototype.deserializeTo = function(a, b) {
  throw Error("Unimplemented");
};
goog.proto2.LazyDeserializer.prototype.deserializeField = goog.abstractMethod;
goog.proto2.PbLiteSerializer = function() {
};
goog.inherits(goog.proto2.PbLiteSerializer, goog.proto2.LazyDeserializer);
goog.proto2.PbLiteSerializer.prototype.zeroIndexing_ = !1;
goog.proto2.PbLiteSerializer.prototype.setZeroIndexed = function(a) {
  this.zeroIndexing_ = a;
};
goog.proto2.PbLiteSerializer.prototype.serialize = function(a) {
  for (var b = a.getDescriptor().getFields(), c = [], d = this.zeroIndexing_, e = 0; e < b.length; e++) {
    var f = b[e];
    if (a.has(f)) {
      var g = f.getTag();
      g = d ? g - 1 : g;
      if (f.isRepeated()) {
        c[g] = [];
        for (var h = 0; h < a.countOf(f); h++) {
          c[g][h] = this.getSerializedValue(f, a.get(f, h));
        }
      } else {
        c[g] = this.getSerializedValue(f, a.get(f));
      }
    }
  }
  a.forEachUnknown(function(a, b) {
    c[d ? a - 1 : a] = b;
  });
  return c;
};
goog.proto2.PbLiteSerializer.prototype.deserializeField = function(a, b, c) {
  if (null == c) {
    return c;
  }
  if (b.isRepeated()) {
    a = [];
    goog.asserts.assert(goog.isArray(c), "Value must be array: %s", c);
    for (var d = 0; d < c.length; d++) {
      a[d] = this.getDeserializedValue(b, c[d]);
    }
    return a;
  }
  return this.getDeserializedValue(b, c);
};
goog.proto2.PbLiteSerializer.prototype.getSerializedValue = function(a, b) {
  return a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? b ? 1 : 0 : goog.proto2.Serializer.prototype.getSerializedValue.apply(this, arguments);
};
goog.proto2.PbLiteSerializer.prototype.getDeserializedValue = function(a, b) {
  return a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? (goog.asserts.assert(goog.isNumber(b) || goog.isBoolean(b), "Value is expected to be a number or boolean"), !!b) : goog.proto2.Serializer.prototype.getDeserializedValue.apply(this, arguments);
};
goog.proto2.PbLiteSerializer.prototype.deserialize = function(a, b) {
  var c = b;
  if (this.zeroIndexing_) {
    c = [];
    for (var d in b) {
      c[parseInt(d, 10) + 1] = b[d];
    }
  }
  return goog.proto2.PbLiteSerializer.superClass_.deserialize.call(this, a, c);
};
/*

 Protocol Buffer 2 Copyright 2008 Google Inc.
 All other code copyright its respective owners.
 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
var i18n = {phonenumbers:{}};
i18n.phonenumbers.NumberFormat = function() {
  goog.proto2.Message.call(this);
};
goog.inherits(i18n.phonenumbers.NumberFormat, goog.proto2.Message);
i18n.phonenumbers.NumberFormat.descriptor_ = null;
i18n.phonenumbers.NumberFormat.prototype.getPattern = function() {
  return this.get$Value(1);
};
i18n.phonenumbers.NumberFormat.prototype.getPatternOrDefault = function() {
  return this.get$ValueOrDefault(1);
};
i18n.phonenumbers.NumberFormat.prototype.setPattern = function(a) {
  this.set$Value(1, a);
};
i18n.phonenumbers.NumberFormat.prototype.hasPattern = function() {
  return this.has$Value(1);
};
i18n.phonenumbers.NumberFormat.prototype.patternCount = function() {
  return this.count$Values(1);
};
i18n.phonenumbers.NumberFormat.prototype.clearPattern = function() {
  this.clear$Field(1);
};
i18n.phonenumbers.NumberFormat.prototype.getFormat = function() {
  return this.get$Value(2);
};
i18n.phonenumbers.NumberFormat.prototype.getFormatOrDefault = function() {
  return this.get$ValueOrDefault(2);
};
i18n.phonenumbers.NumberFormat.prototype.setFormat = function(a) {
  this.set$Value(2, a);
};
i18n.phonenumbers.NumberFormat.prototype.hasFormat = function() {
  return this.has$Value(2);
};
i18n.phonenumbers.NumberFormat.prototype.formatCount = function() {
  return this.count$Values(2);
};
i18n.phonenumbers.NumberFormat.prototype.clearFormat = function() {
  this.clear$Field(2);
};
i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPattern = function(a) {
  return this.get$Value(3, a);
};
i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPatternOrDefault = function(a) {
  return this.get$ValueOrDefault(3, a);
};
i18n.phonenumbers.NumberFormat.prototype.addLeadingDigitsPattern = function(a) {
  this.add$Value(3, a);
};
i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternArray = function() {
  return this.array$Values(3);
};
i18n.phonenumbers.NumberFormat.prototype.hasLeadingDigitsPattern = function() {
  return this.has$Value(3);
};
i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternCount = function() {
  return this.count$Values(3);
};
i18n.phonenumbers.NumberFormat.prototype.clearLeadingDigitsPattern = function() {
  this.clear$Field(3);
};
i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRule = function() {
  return this.get$Value(4);
};
i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRuleOrDefault = function() {
  return this.get$ValueOrDefault(4);
};
i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixFormattingRule = function(a) {
  this.set$Value(4, a);
};
i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixFormattingRule = function() {
  return this.has$Value(4);
};
i18n.phonenumbers.NumberFormat.prototype.nationalPrefixFormattingRuleCount = function() {
  return this.count$Values(4);
};
i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixFormattingRule = function() {
  this.clear$Field(4);
};
i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormatting = function() {
  return this.get$Value(6);
};
i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormattingOrDefault = function() {
  return this.get$ValueOrDefault(6);
};
i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixOptionalWhenFormatting = function(a) {
  this.set$Value(6, a);
};
i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixOptionalWhenFormatting = function() {
  return this.has$Value(6);
};
i18n.phonenumbers.NumberFormat.prototype.nationalPrefixOptionalWhenFormattingCount = function() {
  return this.count$Values(6);
};
i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixOptionalWhenFormatting = function() {
  this.clear$Field(6);
};
i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRule = function() {
  return this.get$Value(5);
};
i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRuleOrDefault = function() {
  return this.get$ValueOrDefault(5);
};
i18n.phonenumbers.NumberFormat.prototype.setDomesticCarrierCodeFormattingRule = function(a) {
  this.set$Value(5, a);
};
i18n.phonenumbers.NumberFormat.prototype.hasDomesticCarrierCodeFormattingRule = function() {
  return this.has$Value(5);
};
i18n.phonenumbers.NumberFormat.prototype.domesticCarrierCodeFormattingRuleCount = function() {
  return this.count$Values(5);
};
i18n.phonenumbers.NumberFormat.prototype.clearDomesticCarrierCodeFormattingRule = function() {
  this.clear$Field(5);
};
i18n.phonenumbers.PhoneNumberDesc = function() {
  goog.proto2.Message.call(this);
};
goog.inherits(i18n.phonenumbers.PhoneNumberDesc, goog.proto2.Message);
i18n.phonenumbers.PhoneNumberDesc.descriptor_ = null;
i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPattern = function() {
  return this.get$Value(2);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPatternOrDefault = function() {
  return this.get$ValueOrDefault(2);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.setNationalNumberPattern = function(a) {
  this.set$Value(2, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasNationalNumberPattern = function() {
  return this.has$Value(2);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.nationalNumberPatternCount = function() {
  return this.count$Values(2);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.clearNationalNumberPattern = function() {
  this.clear$Field(2);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLength = function(a) {
  return this.get$Value(9, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthOrDefault = function(a) {
  return this.get$ValueOrDefault(9, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLength = function(a) {
  this.add$Value(9, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthArray = function() {
  return this.array$Values(9);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLength = function() {
  return this.has$Value(9);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthCount = function() {
  return this.count$Values(9);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLength = function() {
  this.clear$Field(9);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnly = function(a) {
  return this.get$Value(10, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnlyOrDefault = function(a) {
  return this.get$ValueOrDefault(10, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLengthLocalOnly = function(a) {
  this.add$Value(10, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyArray = function() {
  return this.array$Values(10);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLengthLocalOnly = function() {
  return this.has$Value(10);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyCount = function() {
  return this.count$Values(10);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLengthLocalOnly = function() {
  this.clear$Field(10);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumber = function() {
  return this.get$Value(6);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumberOrDefault = function() {
  return this.get$ValueOrDefault(6);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.setExampleNumber = function(a) {
  this.set$Value(6, a);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasExampleNumber = function() {
  return this.has$Value(6);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.exampleNumberCount = function() {
  return this.count$Values(6);
};
i18n.phonenumbers.PhoneNumberDesc.prototype.clearExampleNumber = function() {
  this.clear$Field(6);
};
i18n.phonenumbers.PhoneMetadata = function() {
  goog.proto2.Message.call(this);
};
goog.inherits(i18n.phonenumbers.PhoneMetadata, goog.proto2.Message);
i18n.phonenumbers.PhoneMetadata.descriptor_ = null;
i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDesc = function() {
  return this.get$Value(1);
};
i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDescOrDefault = function() {
  return this.get$ValueOrDefault(1);
};
i18n.phonenumbers.PhoneMetadata.prototype.setGeneralDesc = function(a) {
  this.set$Value(1, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasGeneralDesc = function() {
  return this.has$Value(1);
};
i18n.phonenumbers.PhoneMetadata.prototype.generalDescCount = function() {
  return this.count$Values(1);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearGeneralDesc = function() {
  this.clear$Field(1);
};
i18n.phonenumbers.PhoneMetadata.prototype.getFixedLine = function() {
  return this.get$Value(2);
};
i18n.phonenumbers.PhoneMetadata.prototype.getFixedLineOrDefault = function() {
  return this.get$ValueOrDefault(2);
};
i18n.phonenumbers.PhoneMetadata.prototype.setFixedLine = function(a) {
  this.set$Value(2, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasFixedLine = function() {
  return this.has$Value(2);
};
i18n.phonenumbers.PhoneMetadata.prototype.fixedLineCount = function() {
  return this.count$Values(2);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearFixedLine = function() {
  this.clear$Field(2);
};
i18n.phonenumbers.PhoneMetadata.prototype.getMobile = function() {
  return this.get$Value(3);
};
i18n.phonenumbers.PhoneMetadata.prototype.getMobileOrDefault = function() {
  return this.get$ValueOrDefault(3);
};
i18n.phonenumbers.PhoneMetadata.prototype.setMobile = function(a) {
  this.set$Value(3, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasMobile = function() {
  return this.has$Value(3);
};
i18n.phonenumbers.PhoneMetadata.prototype.mobileCount = function() {
  return this.count$Values(3);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearMobile = function() {
  this.clear$Field(3);
};
i18n.phonenumbers.PhoneMetadata.prototype.getTollFree = function() {
  return this.get$Value(4);
};
i18n.phonenumbers.PhoneMetadata.prototype.getTollFreeOrDefault = function() {
  return this.get$ValueOrDefault(4);
};
i18n.phonenumbers.PhoneMetadata.prototype.setTollFree = function(a) {
  this.set$Value(4, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasTollFree = function() {
  return this.has$Value(4);
};
i18n.phonenumbers.PhoneMetadata.prototype.tollFreeCount = function() {
  return this.count$Values(4);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearTollFree = function() {
  this.clear$Field(4);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRate = function() {
  return this.get$Value(5);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRateOrDefault = function() {
  return this.get$ValueOrDefault(5);
};
i18n.phonenumbers.PhoneMetadata.prototype.setPremiumRate = function(a) {
  this.set$Value(5, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasPremiumRate = function() {
  return this.has$Value(5);
};
i18n.phonenumbers.PhoneMetadata.prototype.premiumRateCount = function() {
  return this.count$Values(5);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearPremiumRate = function() {
  this.clear$Field(5);
};
i18n.phonenumbers.PhoneMetadata.prototype.getSharedCost = function() {
  return this.get$Value(6);
};
i18n.phonenumbers.PhoneMetadata.prototype.getSharedCostOrDefault = function() {
  return this.get$ValueOrDefault(6);
};
i18n.phonenumbers.PhoneMetadata.prototype.setSharedCost = function(a) {
  this.set$Value(6, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasSharedCost = function() {
  return this.has$Value(6);
};
i18n.phonenumbers.PhoneMetadata.prototype.sharedCostCount = function() {
  return this.count$Values(6);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearSharedCost = function() {
  this.clear$Field(6);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumber = function() {
  return this.get$Value(7);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumberOrDefault = function() {
  return this.get$ValueOrDefault(7);
};
i18n.phonenumbers.PhoneMetadata.prototype.setPersonalNumber = function(a) {
  this.set$Value(7, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasPersonalNumber = function() {
  return this.has$Value(7);
};
i18n.phonenumbers.PhoneMetadata.prototype.personalNumberCount = function() {
  return this.count$Values(7);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearPersonalNumber = function() {
  this.clear$Field(7);
};
i18n.phonenumbers.PhoneMetadata.prototype.getVoip = function() {
  return this.get$Value(8);
};
i18n.phonenumbers.PhoneMetadata.prototype.getVoipOrDefault = function() {
  return this.get$ValueOrDefault(8);
};
i18n.phonenumbers.PhoneMetadata.prototype.setVoip = function(a) {
  this.set$Value(8, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasVoip = function() {
  return this.has$Value(8);
};
i18n.phonenumbers.PhoneMetadata.prototype.voipCount = function() {
  return this.count$Values(8);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearVoip = function() {
  this.clear$Field(8);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPager = function() {
  return this.get$Value(21);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPagerOrDefault = function() {
  return this.get$ValueOrDefault(21);
};
i18n.phonenumbers.PhoneMetadata.prototype.setPager = function(a) {
  this.set$Value(21, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasPager = function() {
  return this.has$Value(21);
};
i18n.phonenumbers.PhoneMetadata.prototype.pagerCount = function() {
  return this.count$Values(21);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearPager = function() {
  this.clear$Field(21);
};
i18n.phonenumbers.PhoneMetadata.prototype.getUan = function() {
  return this.get$Value(25);
};
i18n.phonenumbers.PhoneMetadata.prototype.getUanOrDefault = function() {
  return this.get$ValueOrDefault(25);
};
i18n.phonenumbers.PhoneMetadata.prototype.setUan = function(a) {
  this.set$Value(25, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasUan = function() {
  return this.has$Value(25);
};
i18n.phonenumbers.PhoneMetadata.prototype.uanCount = function() {
  return this.count$Values(25);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearUan = function() {
  this.clear$Field(25);
};
i18n.phonenumbers.PhoneMetadata.prototype.getEmergency = function() {
  return this.get$Value(27);
};
i18n.phonenumbers.PhoneMetadata.prototype.getEmergencyOrDefault = function() {
  return this.get$ValueOrDefault(27);
};
i18n.phonenumbers.PhoneMetadata.prototype.setEmergency = function(a) {
  this.set$Value(27, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasEmergency = function() {
  return this.has$Value(27);
};
i18n.phonenumbers.PhoneMetadata.prototype.emergencyCount = function() {
  return this.count$Values(27);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearEmergency = function() {
  this.clear$Field(27);
};
i18n.phonenumbers.PhoneMetadata.prototype.getVoicemail = function() {
  return this.get$Value(28);
};
i18n.phonenumbers.PhoneMetadata.prototype.getVoicemailOrDefault = function() {
  return this.get$ValueOrDefault(28);
};
i18n.phonenumbers.PhoneMetadata.prototype.setVoicemail = function(a) {
  this.set$Value(28, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasVoicemail = function() {
  return this.has$Value(28);
};
i18n.phonenumbers.PhoneMetadata.prototype.voicemailCount = function() {
  return this.count$Values(28);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearVoicemail = function() {
  this.clear$Field(28);
};
i18n.phonenumbers.PhoneMetadata.prototype.getShortCode = function() {
  return this.get$Value(29);
};
i18n.phonenumbers.PhoneMetadata.prototype.getShortCodeOrDefault = function() {
  return this.get$ValueOrDefault(29);
};
i18n.phonenumbers.PhoneMetadata.prototype.setShortCode = function(a) {
  this.set$Value(29, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasShortCode = function() {
  return this.has$Value(29);
};
i18n.phonenumbers.PhoneMetadata.prototype.shortCodeCount = function() {
  return this.count$Values(29);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearShortCode = function() {
  this.clear$Field(29);
};
i18n.phonenumbers.PhoneMetadata.prototype.getStandardRate = function() {
  return this.get$Value(30);
};
i18n.phonenumbers.PhoneMetadata.prototype.getStandardRateOrDefault = function() {
  return this.get$ValueOrDefault(30);
};
i18n.phonenumbers.PhoneMetadata.prototype.setStandardRate = function(a) {
  this.set$Value(30, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasStandardRate = function() {
  return this.has$Value(30);
};
i18n.phonenumbers.PhoneMetadata.prototype.standardRateCount = function() {
  return this.count$Values(30);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearStandardRate = function() {
  this.clear$Field(30);
};
i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecific = function() {
  return this.get$Value(31);
};
i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecificOrDefault = function() {
  return this.get$ValueOrDefault(31);
};
i18n.phonenumbers.PhoneMetadata.prototype.setCarrierSpecific = function(a) {
  this.set$Value(31, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasCarrierSpecific = function() {
  return this.has$Value(31);
};
i18n.phonenumbers.PhoneMetadata.prototype.carrierSpecificCount = function() {
  return this.count$Values(31);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearCarrierSpecific = function() {
  this.clear$Field(31);
};
i18n.phonenumbers.PhoneMetadata.prototype.getSmsServices = function() {
  return this.get$Value(33);
};
i18n.phonenumbers.PhoneMetadata.prototype.getSmsServicesOrDefault = function() {
  return this.get$ValueOrDefault(33);
};
i18n.phonenumbers.PhoneMetadata.prototype.setSmsServices = function(a) {
  this.set$Value(33, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasSmsServices = function() {
  return this.has$Value(33);
};
i18n.phonenumbers.PhoneMetadata.prototype.smsServicesCount = function() {
  return this.count$Values(33);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearSmsServices = function() {
  this.clear$Field(33);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDialling = function() {
  return this.get$Value(24);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDiallingOrDefault = function() {
  return this.get$ValueOrDefault(24);
};
i18n.phonenumbers.PhoneMetadata.prototype.setNoInternationalDialling = function(a) {
  this.set$Value(24, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasNoInternationalDialling = function() {
  return this.has$Value(24);
};
i18n.phonenumbers.PhoneMetadata.prototype.noInternationalDiallingCount = function() {
  return this.count$Values(24);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearNoInternationalDialling = function() {
  this.clear$Field(24);
};
i18n.phonenumbers.PhoneMetadata.prototype.getId = function() {
  return this.get$Value(9);
};
i18n.phonenumbers.PhoneMetadata.prototype.getIdOrDefault = function() {
  return this.get$ValueOrDefault(9);
};
i18n.phonenumbers.PhoneMetadata.prototype.setId = function(a) {
  this.set$Value(9, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasId = function() {
  return this.has$Value(9);
};
i18n.phonenumbers.PhoneMetadata.prototype.idCount = function() {
  return this.count$Values(9);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearId = function() {
  this.clear$Field(9);
};
i18n.phonenumbers.PhoneMetadata.prototype.getCountryCode = function() {
  return this.get$Value(10);
};
i18n.phonenumbers.PhoneMetadata.prototype.getCountryCodeOrDefault = function() {
  return this.get$ValueOrDefault(10);
};
i18n.phonenumbers.PhoneMetadata.prototype.setCountryCode = function(a) {
  this.set$Value(10, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasCountryCode = function() {
  return this.has$Value(10);
};
i18n.phonenumbers.PhoneMetadata.prototype.countryCodeCount = function() {
  return this.count$Values(10);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearCountryCode = function() {
  this.clear$Field(10);
};
i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefix = function() {
  return this.get$Value(11);
};
i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefixOrDefault = function() {
  return this.get$ValueOrDefault(11);
};
i18n.phonenumbers.PhoneMetadata.prototype.setInternationalPrefix = function(a) {
  this.set$Value(11, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasInternationalPrefix = function() {
  return this.has$Value(11);
};
i18n.phonenumbers.PhoneMetadata.prototype.internationalPrefixCount = function() {
  return this.count$Values(11);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearInternationalPrefix = function() {
  this.clear$Field(11);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefix = function() {
  return this.get$Value(17);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefixOrDefault = function() {
  return this.get$ValueOrDefault(17);
};
i18n.phonenumbers.PhoneMetadata.prototype.setPreferredInternationalPrefix = function(a) {
  this.set$Value(17, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredInternationalPrefix = function() {
  return this.has$Value(17);
};
i18n.phonenumbers.PhoneMetadata.prototype.preferredInternationalPrefixCount = function() {
  return this.count$Values(17);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredInternationalPrefix = function() {
  this.clear$Field(17);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefix = function() {
  return this.get$Value(12);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixOrDefault = function() {
  return this.get$ValueOrDefault(12);
};
i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefix = function(a) {
  this.set$Value(12, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefix = function() {
  return this.has$Value(12);
};
i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixCount = function() {
  return this.count$Values(12);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefix = function() {
  this.clear$Field(12);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefix = function() {
  return this.get$Value(13);
};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefixOrDefault = function() {
  return this.get$ValueOrDefault(13);
};
i18n.phonenumbers.PhoneMetadata.prototype.setPreferredExtnPrefix = function(a) {
  this.set$Value(13, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredExtnPrefix = function() {
  return this.has$Value(13);
};
i18n.phonenumbers.PhoneMetadata.prototype.preferredExtnPrefixCount = function() {
  return this.count$Values(13);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredExtnPrefix = function() {
  this.clear$Field(13);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsing = function() {
  return this.get$Value(15);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsingOrDefault = function() {
  return this.get$ValueOrDefault(15);
};
i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixForParsing = function(a) {
  this.set$Value(15, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixForParsing = function() {
  return this.has$Value(15);
};
i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixForParsingCount = function() {
  return this.count$Values(15);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixForParsing = function() {
  this.clear$Field(15);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRule = function() {
  return this.get$Value(16);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRuleOrDefault = function() {
  return this.get$ValueOrDefault(16);
};
i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixTransformRule = function(a) {
  this.set$Value(16, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixTransformRule = function() {
  return this.has$Value(16);
};
i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixTransformRuleCount = function() {
  return this.count$Values(16);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixTransformRule = function() {
  this.clear$Field(16);
};
i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePattern = function() {
  return this.get$Value(18);
};
i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePatternOrDefault = function() {
  return this.get$ValueOrDefault(18);
};
i18n.phonenumbers.PhoneMetadata.prototype.setSameMobileAndFixedLinePattern = function(a) {
  this.set$Value(18, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasSameMobileAndFixedLinePattern = function() {
  return this.has$Value(18);
};
i18n.phonenumbers.PhoneMetadata.prototype.sameMobileAndFixedLinePatternCount = function() {
  return this.count$Values(18);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearSameMobileAndFixedLinePattern = function() {
  this.clear$Field(18);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormat = function(a) {
  return this.get$Value(19, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormatOrDefault = function(a) {
  return this.get$ValueOrDefault(19, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.addNumberFormat = function(a) {
  this.add$Value(19, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.numberFormatArray = function() {
  return this.array$Values(19);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasNumberFormat = function() {
  return this.has$Value(19);
};
i18n.phonenumbers.PhoneMetadata.prototype.numberFormatCount = function() {
  return this.count$Values(19);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearNumberFormat = function() {
  this.clear$Field(19);
};
i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormat = function(a) {
  return this.get$Value(20, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormatOrDefault = function(a) {
  return this.get$ValueOrDefault(20, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.addIntlNumberFormat = function(a) {
  this.add$Value(20, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatArray = function() {
  return this.array$Values(20);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasIntlNumberFormat = function() {
  return this.has$Value(20);
};
i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatCount = function() {
  return this.count$Values(20);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearIntlNumberFormat = function() {
  this.clear$Field(20);
};
i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCode = function() {
  return this.get$Value(22);
};
i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCodeOrDefault = function() {
  return this.get$ValueOrDefault(22);
};
i18n.phonenumbers.PhoneMetadata.prototype.setMainCountryForCode = function(a) {
  this.set$Value(22, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasMainCountryForCode = function() {
  return this.has$Value(22);
};
i18n.phonenumbers.PhoneMetadata.prototype.mainCountryForCodeCount = function() {
  return this.count$Values(22);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearMainCountryForCode = function() {
  this.clear$Field(22);
};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigits = function() {
  return this.get$Value(23);
};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigitsOrDefault = function() {
  return this.get$ValueOrDefault(23);
};
i18n.phonenumbers.PhoneMetadata.prototype.setLeadingDigits = function(a) {
  this.set$Value(23, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingDigits = function() {
  return this.has$Value(23);
};
i18n.phonenumbers.PhoneMetadata.prototype.leadingDigitsCount = function() {
  return this.count$Values(23);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingDigits = function() {
  this.clear$Field(23);
};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingZeroPossible = function() {
  return this.get$Value(26);
};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingZeroPossibleOrDefault = function() {
  return this.get$ValueOrDefault(26);
};
i18n.phonenumbers.PhoneMetadata.prototype.setLeadingZeroPossible = function(a) {
  this.set$Value(26, a);
};
i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingZeroPossible = function() {
  return this.has$Value(26);
};
i18n.phonenumbers.PhoneMetadata.prototype.leadingZeroPossibleCount = function() {
  return this.count$Values(26);
};
i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingZeroPossible = function() {
  this.clear$Field(26);
};
i18n.phonenumbers.PhoneMetadataCollection = function() {
  goog.proto2.Message.call(this);
};
goog.inherits(i18n.phonenumbers.PhoneMetadataCollection, goog.proto2.Message);
i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = null;
i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadata = function(a) {
  return this.get$Value(1, a);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadataOrDefault = function(a) {
  return this.get$ValueOrDefault(1, a);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.addMetadata = function(a) {
  this.add$Value(1, a);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataArray = function() {
  return this.array$Values(1);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.hasMetadata = function() {
  return this.has$Value(1);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataCount = function() {
  return this.count$Values(1);
};
i18n.phonenumbers.PhoneMetadataCollection.prototype.clearMetadata = function() {
  this.clear$Field(1);
};
i18n.phonenumbers.NumberFormat.prototype.getDescriptor = function() {
  var a = i18n.phonenumbers.NumberFormat.descriptor_;
  a || (i18n.phonenumbers.NumberFormat.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.NumberFormat, {0:{name:"NumberFormat", fullName:"i18n.phonenumbers.NumberFormat"}, 1:{name:"pattern", required:!0, fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 2:{name:"format", required:!0, fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 3:{name:"leading_digits_pattern", repeated:!0, fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 4:{name:"national_prefix_formatting_rule", 
  fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 6:{name:"national_prefix_optional_when_formatting", fieldType:goog.proto2.Message.FieldType.BOOL, defaultValue:!1, type:Boolean}, 5:{name:"domestic_carrier_code_formatting_rule", fieldType:goog.proto2.Message.FieldType.STRING, type:String}}));
  return a;
};
i18n.phonenumbers.NumberFormat.getDescriptor = i18n.phonenumbers.NumberFormat.prototype.getDescriptor;
i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor = function() {
  var a = i18n.phonenumbers.PhoneNumberDesc.descriptor_;
  a || (i18n.phonenumbers.PhoneNumberDesc.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumberDesc, {0:{name:"PhoneNumberDesc", fullName:"i18n.phonenumbers.PhoneNumberDesc"}, 2:{name:"national_number_pattern", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 9:{name:"possible_length", repeated:!0, fieldType:goog.proto2.Message.FieldType.INT32, type:Number}, 10:{name:"possible_length_local_only", repeated:!0, fieldType:goog.proto2.Message.FieldType.INT32, 
  type:Number}, 6:{name:"example_number", fieldType:goog.proto2.Message.FieldType.STRING, type:String}}));
  return a;
};
i18n.phonenumbers.PhoneNumberDesc.getDescriptor = i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor;
i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor = function() {
  var a = i18n.phonenumbers.PhoneMetadata.descriptor_;
  a || (i18n.phonenumbers.PhoneMetadata.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadata, {0:{name:"PhoneMetadata", fullName:"i18n.phonenumbers.PhoneMetadata"}, 1:{name:"general_desc", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 2:{name:"fixed_line", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 3:{name:"mobile", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 
  4:{name:"toll_free", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 5:{name:"premium_rate", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 6:{name:"shared_cost", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 7:{name:"personal_number", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 8:{name:"voip", fieldType:goog.proto2.Message.FieldType.MESSAGE, 
  type:i18n.phonenumbers.PhoneNumberDesc}, 21:{name:"pager", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 25:{name:"uan", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 27:{name:"emergency", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 28:{name:"voicemail", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 29:{name:"short_code", 
  fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 30:{name:"standard_rate", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 31:{name:"carrier_specific", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 33:{name:"sms_services", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 24:{name:"no_international_dialling", fieldType:goog.proto2.Message.FieldType.MESSAGE, 
  type:i18n.phonenumbers.PhoneNumberDesc}, 9:{name:"id", required:!0, fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 10:{name:"country_code", fieldType:goog.proto2.Message.FieldType.INT32, type:Number}, 11:{name:"international_prefix", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 17:{name:"preferred_international_prefix", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 12:{name:"national_prefix", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 
  13:{name:"preferred_extn_prefix", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 15:{name:"national_prefix_for_parsing", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 16:{name:"national_prefix_transform_rule", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 18:{name:"same_mobile_and_fixed_line_pattern", fieldType:goog.proto2.Message.FieldType.BOOL, defaultValue:!1, type:Boolean}, 19:{name:"number_format", repeated:!0, fieldType:goog.proto2.Message.FieldType.MESSAGE, 
  type:i18n.phonenumbers.NumberFormat}, 20:{name:"intl_number_format", repeated:!0, fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.NumberFormat}, 22:{name:"main_country_for_code", fieldType:goog.proto2.Message.FieldType.BOOL, defaultValue:!1, type:Boolean}, 23:{name:"leading_digits", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 26:{name:"leading_zero_possible", fieldType:goog.proto2.Message.FieldType.BOOL, defaultValue:!1, type:Boolean}}));
  return a;
};
i18n.phonenumbers.PhoneMetadata.getDescriptor = i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor;
i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor = function() {
  var a = i18n.phonenumbers.PhoneMetadataCollection.descriptor_;
  a || (i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadataCollection, {0:{name:"PhoneMetadataCollection", fullName:"i18n.phonenumbers.PhoneMetadataCollection"}, 1:{name:"metadata", repeated:!0, fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneMetadata}}));
  return a;
};
i18n.phonenumbers.PhoneMetadataCollection.getDescriptor = i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor;
i18n.phonenumbers.PhoneNumber = function() {
  goog.proto2.Message.call(this);
};
goog.inherits(i18n.phonenumbers.PhoneNumber, goog.proto2.Message);
i18n.phonenumbers.PhoneNumber.descriptor_ = null;
i18n.phonenumbers.PhoneNumber.prototype.getCountryCode = function() {
  return this.get$Value(1);
};
i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeOrDefault = function() {
  return this.get$ValueOrDefault(1);
};
i18n.phonenumbers.PhoneNumber.prototype.setCountryCode = function(a) {
  this.set$Value(1, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasCountryCode = function() {
  return this.has$Value(1);
};
i18n.phonenumbers.PhoneNumber.prototype.countryCodeCount = function() {
  return this.count$Values(1);
};
i18n.phonenumbers.PhoneNumber.prototype.clearCountryCode = function() {
  this.clear$Field(1);
};
i18n.phonenumbers.PhoneNumber.prototype.getNationalNumber = function() {
  return this.get$Value(2);
};
i18n.phonenumbers.PhoneNumber.prototype.getNationalNumberOrDefault = function() {
  return this.get$ValueOrDefault(2);
};
i18n.phonenumbers.PhoneNumber.prototype.setNationalNumber = function(a) {
  this.set$Value(2, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasNationalNumber = function() {
  return this.has$Value(2);
};
i18n.phonenumbers.PhoneNumber.prototype.nationalNumberCount = function() {
  return this.count$Values(2);
};
i18n.phonenumbers.PhoneNumber.prototype.clearNationalNumber = function() {
  this.clear$Field(2);
};
i18n.phonenumbers.PhoneNumber.prototype.getExtension = function() {
  return this.get$Value(3);
};
i18n.phonenumbers.PhoneNumber.prototype.getExtensionOrDefault = function() {
  return this.get$ValueOrDefault(3);
};
i18n.phonenumbers.PhoneNumber.prototype.setExtension = function(a) {
  this.set$Value(3, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasExtension = function() {
  return this.has$Value(3);
};
i18n.phonenumbers.PhoneNumber.prototype.extensionCount = function() {
  return this.count$Values(3);
};
i18n.phonenumbers.PhoneNumber.prototype.clearExtension = function() {
  this.clear$Field(3);
};
i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZero = function() {
  return this.get$Value(4);
};
i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZeroOrDefault = function() {
  return this.get$ValueOrDefault(4);
};
i18n.phonenumbers.PhoneNumber.prototype.setItalianLeadingZero = function(a) {
  this.set$Value(4, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasItalianLeadingZero = function() {
  return this.has$Value(4);
};
i18n.phonenumbers.PhoneNumber.prototype.italianLeadingZeroCount = function() {
  return this.count$Values(4);
};
i18n.phonenumbers.PhoneNumber.prototype.clearItalianLeadingZero = function() {
  this.clear$Field(4);
};
i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZeros = function() {
  return this.get$Value(8);
};
i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZerosOrDefault = function() {
  return this.get$ValueOrDefault(8);
};
i18n.phonenumbers.PhoneNumber.prototype.setNumberOfLeadingZeros = function(a) {
  this.set$Value(8, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasNumberOfLeadingZeros = function() {
  return this.has$Value(8);
};
i18n.phonenumbers.PhoneNumber.prototype.numberOfLeadingZerosCount = function() {
  return this.count$Values(8);
};
i18n.phonenumbers.PhoneNumber.prototype.clearNumberOfLeadingZeros = function() {
  this.clear$Field(8);
};
i18n.phonenumbers.PhoneNumber.prototype.getRawInput = function() {
  return this.get$Value(5);
};
i18n.phonenumbers.PhoneNumber.prototype.getRawInputOrDefault = function() {
  return this.get$ValueOrDefault(5);
};
i18n.phonenumbers.PhoneNumber.prototype.setRawInput = function(a) {
  this.set$Value(5, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasRawInput = function() {
  return this.has$Value(5);
};
i18n.phonenumbers.PhoneNumber.prototype.rawInputCount = function() {
  return this.count$Values(5);
};
i18n.phonenumbers.PhoneNumber.prototype.clearRawInput = function() {
  this.clear$Field(5);
};
i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSource = function() {
  return this.get$Value(6);
};
i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSourceOrDefault = function() {
  return this.get$ValueOrDefault(6);
};
i18n.phonenumbers.PhoneNumber.prototype.setCountryCodeSource = function(a) {
  this.set$Value(6, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasCountryCodeSource = function() {
  return this.has$Value(6);
};
i18n.phonenumbers.PhoneNumber.prototype.countryCodeSourceCount = function() {
  return this.count$Values(6);
};
i18n.phonenumbers.PhoneNumber.prototype.clearCountryCodeSource = function() {
  this.clear$Field(6);
};
i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCode = function() {
  return this.get$Value(7);
};
i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCodeOrDefault = function() {
  return this.get$ValueOrDefault(7);
};
i18n.phonenumbers.PhoneNumber.prototype.setPreferredDomesticCarrierCode = function(a) {
  this.set$Value(7, a);
};
i18n.phonenumbers.PhoneNumber.prototype.hasPreferredDomesticCarrierCode = function() {
  return this.has$Value(7);
};
i18n.phonenumbers.PhoneNumber.prototype.preferredDomesticCarrierCodeCount = function() {
  return this.count$Values(7);
};
i18n.phonenumbers.PhoneNumber.prototype.clearPreferredDomesticCarrierCode = function() {
  this.clear$Field(7);
};
i18n.phonenumbers.PhoneNumber.CountryCodeSource = {UNSPECIFIED:0, FROM_NUMBER_WITH_PLUS_SIGN:1, FROM_NUMBER_WITH_IDD:5, FROM_NUMBER_WITHOUT_PLUS_SIGN:10, FROM_DEFAULT_COUNTRY:20};
i18n.phonenumbers.PhoneNumber.prototype.getDescriptor = function() {
  var a = i18n.phonenumbers.PhoneNumber.descriptor_;
  a || (i18n.phonenumbers.PhoneNumber.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumber, {0:{name:"PhoneNumber", fullName:"i18n.phonenumbers.PhoneNumber"}, 1:{name:"country_code", required:!0, fieldType:goog.proto2.Message.FieldType.INT32, type:Number}, 2:{name:"national_number", required:!0, fieldType:goog.proto2.Message.FieldType.UINT64, type:Number}, 3:{name:"extension", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 4:{name:"italian_leading_zero", 
  fieldType:goog.proto2.Message.FieldType.BOOL, type:Boolean}, 8:{name:"number_of_leading_zeros", fieldType:goog.proto2.Message.FieldType.INT32, defaultValue:1, type:Number}, 5:{name:"raw_input", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 6:{name:"country_code_source", fieldType:goog.proto2.Message.FieldType.ENUM, defaultValue:i18n.phonenumbers.PhoneNumber.CountryCodeSource.UNSPECIFIED, type:i18n.phonenumbers.PhoneNumber.CountryCodeSource}, 7:{name:"preferred_domestic_carrier_code", 
  fieldType:goog.proto2.Message.FieldType.STRING, type:String}}));
  return a;
};
i18n.phonenumbers.PhoneNumber.ctor = i18n.phonenumbers.PhoneNumber;
i18n.phonenumbers.PhoneNumber.ctor.getDescriptor = i18n.phonenumbers.PhoneNumber.prototype.getDescriptor;
/*

 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.metadata = {};
i18n.phonenumbers.metadata.countryCodeToRegionCodeMap = {1:"US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "), 7:["RU", "KZ"], 20:["EG"], 27:["ZA"], 30:["GR"], 31:["NL"], 32:["BE"], 33:["FR"], 34:["ES"], 36:["HU"], 39:["IT", "VA"], 40:["RO"], 41:["CH"], 43:["AT"], 44:["GB", "GG", "IM", "JE"], 45:["DK"], 46:["SE"], 47:["NO", "SJ"], 48:["PL"], 49:["DE"], 51:["PE"], 52:["MX"], 53:["CU"], 54:["AR"], 55:["BR"], 56:["CL"], 57:["CO"], 58:["VE"], 60:["MY"], 61:["AU", 
"CC", "CX"], 62:["ID"], 63:["PH"], 64:["NZ"], 65:["SG"], 66:["TH"], 81:["JP"], 82:["KR"], 84:["VN"], 86:["CN"], 90:["TR"], 91:["IN"], 92:["PK"], 93:["AF"], 94:["LK"], 95:["MM"], 98:["IR"], 211:["SS"], 212:["MA", "EH"], 213:["DZ"], 216:["TN"], 218:["LY"], 220:["GM"], 221:["SN"], 222:["MR"], 223:["ML"], 224:["GN"], 225:["CI"], 226:["BF"], 227:["NE"], 228:["TG"], 229:["BJ"], 230:["MU"], 231:["LR"], 232:["SL"], 233:["GH"], 234:["NG"], 235:["TD"], 236:["CF"], 237:["CM"], 238:["CV"], 239:["ST"], 240:["GQ"], 
241:["GA"], 242:["CG"], 243:["CD"], 244:["AO"], 245:["GW"], 246:["IO"], 247:["AC"], 248:["SC"], 249:["SD"], 250:["RW"], 251:["ET"], 252:["SO"], 253:["DJ"], 254:["KE"], 255:["TZ"], 256:["UG"], 257:["BI"], 258:["MZ"], 260:["ZM"], 261:["MG"], 262:["RE", "YT"], 263:["ZW"], 264:["NA"], 265:["MW"], 266:["LS"], 267:["BW"], 268:["SZ"], 269:["KM"], 290:["SH", "TA"], 291:["ER"], 297:["AW"], 298:["FO"], 299:["GL"], 350:["GI"], 351:["PT"], 352:["LU"], 353:["IE"], 354:["IS"], 355:["AL"], 356:["MT"], 357:["CY"], 
358:["FI", "AX"], 359:["BG"], 370:["LT"], 371:["LV"], 372:["EE"], 373:["MD"], 374:["AM"], 375:["BY"], 376:["AD"], 377:["MC"], 378:["SM"], 380:["UA"], 381:["RS"], 382:["ME"], 383:["XK"], 385:["HR"], 386:["SI"], 387:["BA"], 389:["MK"], 420:["CZ"], 421:["SK"], 423:["LI"], 500:["FK"], 501:["BZ"], 502:["GT"], 503:["SV"], 504:["HN"], 505:["NI"], 506:["CR"], 507:["PA"], 508:["PM"], 509:["HT"], 590:["GP", "BL", "MF"], 591:["BO"], 592:["GY"], 593:["EC"], 594:["GF"], 595:["PY"], 596:["MQ"], 597:["SR"], 598:["UY"], 
599:["CW", "BQ"], 670:["TL"], 672:["NF"], 673:["BN"], 674:["NR"], 675:["PG"], 676:["TO"], 677:["SB"], 678:["VU"], 679:["FJ"], 680:["PW"], 681:["WF"], 682:["CK"], 683:["NU"], 685:["WS"], 686:["KI"], 687:["NC"], 688:["TV"], 689:["PF"], 690:["TK"], 691:["FM"], 692:["MH"], 800:["001"], 808:["001"], 850:["KP"], 852:["HK"], 853:["MO"], 855:["KH"], 856:["LA"], 870:["001"], 878:["001"], 880:["BD"], 881:["001"], 882:["001"], 883:["001"], 886:["TW"], 888:["001"], 960:["MV"], 961:["LB"], 962:["JO"], 963:["SY"], 
964:["IQ"], 965:["KW"], 966:["SA"], 967:["YE"], 968:["OM"], 970:["PS"], 971:["AE"], 972:["IL"], 973:["BH"], 974:["QA"], 975:["BT"], 976:["MN"], 977:["NP"], 979:["001"], 992:["TJ"], 993:["TM"], 994:["AZ"], 995:["GE"], 996:["KG"], 998:["UZ"]};
i18n.phonenumbers.metadata.countryToMetadata = {AC:[, [, , "[46]\\d{4}|[01589]\\d{5}", , , , , , , [5, 6]], [, , "6[2-467]\\d{3}", , , , "62889", , , [5]], [, , "4\\d{4}", , , , "40123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AC", 247, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[01589]\\d{5}", , , , "542011", , , [6]], , , [, , , , , , , , , [-1]]], AD:[, 
[, , "[16]\\d{5,8}|[37-9]\\d{5}", , , , , , , [6, 8, 9]], [, , "[78]\\d{5}", , , , "712345", , , [6]], [, , "(?:3\\d|6(?:[0-8]|90\\d{2}))\\d{4}", , , , "312345", , , [6, 9]], [, , "180[02]\\d{4}", , , , "18001234", , , [8]], [, , "[19]\\d{5}", , , , "912345", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AD", 376, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[137-9]|6[0-8]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["180", "180[02]"]], [, "(\\d{3})(\\d{3})(\\d{3})", 
"$1 $2 $3", ["690"]]], , [, , , , , , , , , [-1]], , , [, , "1800\\d{4}", , , , "18000000", , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AE:[, [, , "[2-79]\\d{7,8}|800\\d{2,9}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]], [, , "[2-4679][2-8]\\d{6}", , , , "22345678", , , [8], [7]], [, , "5[024-68]\\d{7}", , , , "501234567", , , [9]], [, , "400\\d{6}|800\\d{2,9}", , , , "800123456"], [, , "900[02]\\d{5}", , , , "900234567", , , [9]], [, , "700[05]\\d{5}", , , , "700012345", , , 
[9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AE", 971, "00", "0", , , "0", , , , [[, "([2-4679])(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-4679][2-8]"], "0$1"], [, "(5\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "([479]00)(\\d)(\\d{5})", "$1 $2 $3", ["[479]00"], "$1"], [, "([68]00)(\\d{2,9})", "$1 $2", ["[68]00"], "$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "600[25]\\d{5}", , , , "600212345", , , [9]], , , [, , , , , , , , , [-1]]], AF:[, [, , "[2-7]\\d{8}", 
, , , , , , [9], [7]], [, , "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}", , , , "234567890", , , , [7]], [, , "7(?:[014-9]\\d|2[89]|30)\\d{6}", , , , "701234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AF", 93, "00", "0", , , "0", , , , [[, "([2-7]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , 
[-1]]], AG:[, [, , "[2589]\\d{9}", , , , , , , [10], [7]], [, , "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}", , , , "2684601234", , , , [7]], [, , "268(?:464|7(?:1[3-9]|2\\d|3[246]|64|7[0-689]|8[02-68]))\\d{4}", , , , "2684641234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , "26848[01]\\d{4}", , , , "2684801234", , , , 
[7]], "AG", 1, "011", "1", , , "1", , , , , , [, , "26840[69]\\d{4}", , , , "2684061234", , , , [7]], , "268", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AI:[, [, , "[2589]\\d{9}", , , , , , , [10], [7]], [, , "2644(?:6[12]|9[78])\\d{4}", , , , "2644612345", , , , [7]], [, , "264(?:235|476|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}", , , , "2642351234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], 
[, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AI", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "264", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AL:[, [, , "[2-57]\\d{7}|6\\d{8}|8\\d{5,7}|9\\d{5}", , , , , , , [6, 7, 8, 9], [5]], [, , "(?:[2358](?:[16-9]\\d[2-9]|[2-5][2-9]\\d)|4(?:[2-57-9][2-9]\\d|6\\d{2}))\\d{4}", , , , "22345678", , , [8], [5, 6, 7]], [, 
, "6(?:[689][2-9]|7[2-6])\\d{6}", , , , "662123456", , , [9]], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , "900[1-9]\\d{2}", , , , "900123", , , [6]], [, , "808[1-9]\\d{2}", , , , "808123", , , [6]], [, , "700[2-9]\\d{4}", , , , "70021234", , , [8]], [, , , , , , , , , [-1]], "AL", 355, "00", "0", , , "0", , , , [[, "(4)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[0-6]"], "0$1"], [, "(6\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4[7-9]"], 
"0$1"], [, "(\\d{3})(\\d{3,5})", "$1 $2", ["[235][16-9]|[79]|8[016-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AM:[, [, , "[1-9]\\d{7}", , , , , , , [8], [5, 6]], [, , "(?:1[0-2]\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2|47\\d)\\d{5}", , , , "10123456", , , , [5, 6]], [, , "(?:4[1349]|55|77|88|9[1-9])\\d{6}", , , , "77123456"], [, , "800\\d{5}", , , , "80012345"], [, , "90[016]\\d{5}", , , , "90012345"], 
[, , "80[1-4]\\d{5}", , , , "80112345"], [, , , , , , , , , [-1]], [, , "60(?:2[078]|[3-7]\\d|8[0-5])\\d{4}", , , , "60271234"], "AM", 374, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["4[1349]|[5-7]|88|9[1-9]"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[23]"], "(0$1)"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8|90"], "0 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , 
, , , , [-1]]], AO:[, [, , "[29]\\d{8}", , , , , , , [9]], [, , "2\\d(?:[26-9]\\d|\\d[26-9])\\d{5}", , , , "222123456"], [, , "9[1-49]\\d{7}", , , , "923123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AO", 244, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AR:[, [, , "11\\d{8}|[2368]\\d{9}|9\\d{10}", 
, , , , , , [10, 11], [6, 7, 8]], [, , "11\\d{8}|(?:2(?:2(?:[013]\\d|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[067]\\d)|4(?:7[3-8]|9\\d)|6(?:[01346]\\d|2[24-6]|5[15-8])|80\\d|9(?:[0124789]\\d|3[1-6]|5[234]|6[2-46]))|3(?:3(?:2[79]|6\\d|8[2578])|4(?:[78]\\d|0[0124-9]|[1-35]\\d|4[24-7]|6[02-9]|9[123678])|5(?:[138]\\d|2[1245]|4[1-9]|6[2-4]|7[1-6])|6[24]\\d|7(?:[0469]\\d|1[1568]|2[013-9]|3[145]|5[14-8]|7[2-57]|8[0-24-9])|8(?:[013578]\\d|2[15-7]|4[13-6]|6[1-357-9]|9[124]))|670\\d)\\d{6}", 
, , , "1123456789", , , [10], [6, 7, 8]], [, , "675\\d{7}|9(?:11[2-9]\\d{7}|(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[12358]|5[138]|6[24]|7[069]|8[013578]))[2-9]\\d{6}|\\d{4}[2-9]\\d{5})", , , , "91123456789", , , , [6, 7, 8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "60[04579]\\d{7}", , , , "6001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AR", 54, "00", "0", , , "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))?15)?", 
"9$1", , , [[, "([68]\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d{2})(\\d{4})", "$1-$2", ["[2-9]"], "$1"], [, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"], "$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["[2-9]"], "$1"], [, "(9)(11)(\\d{4})(\\d{4})", "$2 15-$3-$4", ["911"], "0$1"], [, "(9)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-4689]|3[3-8])", "9(?:2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578]))", "9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))", 
"9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"], "0$1"], [, "(9)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9[23]"], "0$1"], [, "(11)(\\d{4})(\\d{4})", "$1 $2-$3", ["11"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578])", "2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))", 
"2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"], "0$1", , 1], [, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1], [, "(\\d{3})", "$1", ["1[0-2]|911"], "$1"]], [[, "([68]\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(9)(11)(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["911"]], [, "(9)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3-$4", ["9(?:2[2-4689]|3[3-8])", 
"9(?:2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578]))", "9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))", "9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"]], [, "(9)(\\d{4})(\\d{2})(\\d{4})", 
"$1 $2 $3-$4", ["9[23]"]], [, "(11)(\\d{4})(\\d{4})", "$1 $2-$3", ["11"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578])", "2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))", "2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"], 
"0$1", , 1], [, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "810\\d{7}", , , , "8101234567", , , [10]], [, , "810\\d{7}", , , , "8101234567", , , [10]], , , [, , , , , , , , , [-1]]], AS:[, [, , "[5689]\\d{9}", , , , , , , [10], [7]], [, , "6846(?:22|33|44|55|77|88|9[19])\\d{4}", , , , "6846221234", , , , [7]], [, , "684(?:2(?:5[2468]|72)|7(?:3[13]|70))\\d{4}", , , , "6847331234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , 
"8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AS", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "684", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AT:[, [, , "[1-9]\\d{3,12}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [3]], [, , "1\\d{3,12}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-8]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|63|7[1368]|8[2457])|5(?:12|2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[1-35-8]|5[468]|62)|7(?:2[1-8]|3[25]|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{3,10}", 
, , , "1234567890", , , , [3]], [, , "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", , , , "664123456", , , [7, 8, 9, 10, 11, 12, 13]], [, , "800\\d{6,10}", , , , "800123456", , , [9, 10, 11, 12, 13]], [, , "9(?:0[01]|3[019])\\d{6,10}", , , , "900123456", , , [9, 10, 11, 12, 13]], [, , "8(?:10\\d|2(?:[01]\\d|8\\d?))\\d{5,9}", , , , "810123456", , , [8, 9, 10, 11, 12, 13]], [, , , , , , , , , [-1]], [, , "780\\d{6,10}", , , , "780123456", , , [9, 10, 11, 12, 13]], "AT", 43, "00", "0", , , "0", , , , 
[[, "(116\\d{3})", "$1", ["116"], "$1"], [, "(1)(\\d{3,12})", "$1 $2", ["1"], "0$1"], [, "(5\\d)(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], [, "(5\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5[079]"], "0$1"], [, "(5\\d)(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5[079]"], "0$1"], [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:[28]0|32)|[89]"], "0$1"], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["2|3(?:1[1-578]|[3-8])|4[2378]|5[2-6]|6(?:[12]|4[1-9]|5[468])|7(?:[24][1-8]|35|[5-79])"], "0$1"]], , 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "5(?:(?:0[1-9]|17)\\d{2,10}|[79]\\d{3,11})|720\\d{6,10}", , , , "50123", , , [5, 6, 7, 8, 9, 10, 11, 12, 13]], , , [, , , , , , , , , [-1]]], AU:[, [, , "1\\d{4,9}|[2-578]\\d{8}", , , , , , , [5, 6, 7, 8, 9, 10]], [, , "[237]\\d{8}|8(?:51(?:0(?:0[03-9]|[1247]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-6])|1(?:1[69]|[23]\\d|4[0-4]))|[6-8]\\d{4}|9(?:[02-9]\\d{3}|1(?:[0-57-9]\\d{2}|6[0135-9]\\d)))\\d{3}", , , , "212345678", , , [9], [8]], [, , "14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12457-9]|9[017-9])\\d{6}", 
, , , "412345678", , , [9]], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "19(?:0[0126]\\d|[679])\\d{5}", , , , "1900123456", , , [8, 10]], [, , "13(?:00\\d{3}|45[0-4]|\\d)\\d{3}", , , , "1300123456", , , [6, 8, 10]], [, , "500\\d{6}", , , , "500123456", , , [9]], [, , "550\\d{6}", , , , "550123456", , , [9]], "AU", 61, "(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011)|001[14-689]", "0", , , "0", , "0011", , [[, "([2378])(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], [, 
"(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|[45]"], "0$1"], [, "(16)(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(16)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(1[389]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[389]0", "1(?:[38]0|9)0"]], [, "(180)(2\\d{3})", "$1 $2", ["180", "1802"]], [, "(19\\d)(\\d{3})", "$1 $2", ["19[13]"]], [, "(19\\d{2})(\\d{4})", "$1 $2", ["19[679]"]], [, "(13)(\\d{2})(\\d{2})", "$1 $2 $3", ["13[1-9]"]]], , [, , "16\\d{3,7}", , , , "1612345", , , [5, 6, 7, 8, 9]], 1, 
, [, , "1(?:3(?:00\\d{3}|45[0-4]|\\d)\\d{3}|80(?:0\\d{6}|2\\d{3}))", , , , "1300123456", , , [6, 7, 8, 10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AW:[, [, , "[25-9]\\d{6}", , , , , , , [7]], [, , "5(?:2\\d|8[1-9])\\d{4}", , , , "5212345"], [, , "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}", , , , "5601234"], [, , "800\\d{4}", , , , "8001234"], [, , "900\\d{4}", , , , "9001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, 
, "28\\d{5}|501\\d{4}", , , , "5011234"], "AW", 297, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AX:[, [, , "1\\d{5,11}|[35]\\d{5,9}|2\\d{4,9}|4\\d{5,10}|6\\d{7,9}|7\\d{4,9}|8\\d{6,9}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]], [, , "18[1-8]\\d{3,9}", , , , "181234567", , , [6, 7, 8, 9, 10, 11, 12]], [, , "4\\d{5,10}|50\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10, 11]], 
[, , "800\\d{4,7}", , , , "8001234567", , , [7, 8, 9, 10]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AX", 358, "00|99(?:[02469]|5(?:11|33|5[59]|88|9[09]))", "0", , , "0", , "00", , , , [, , , , , , , , , [-1]], , , [, , "[13]00\\d{3,7}|2(?:0(?:0\\d{3,7}|2[023]\\d{1,6}|9[89]\\d{1,6}))|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{3,7})", , , , "1001234", , , [5, 6, 7, 8, 9, 10]], [, , "[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})", 
, , , "10112345", , , [5, 6, 7, 8, 9, 10]], , , [, , , , , , , , , [-1]]], AZ:[, [, , "[1-9]\\d{8}", , , , , , , [9], [7]], [, , "(?:1[28]\\d{3}|2(?:02|1[24]|2[2-4]|33|[45]2|6[23])\\d{2}|365(?:[0-46-9]\\d|5[0-35-9]))\\d{4}", , , , "123123456", , , , [7]], [, , "(?:36554|(?:4[04]|5[015]|60|7[07])\\d{3})\\d{4}", , , , "401234567"], [, , "88\\d{7}", , , , "881234567"], [, , "900200\\d{3}", , , , "900200123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AZ", 994, "00", 
"0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2(?:[0-36]|[45]2)|365"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[4-8]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BA:[, [, , "[3-9]\\d{7,8}", , , , , , , [8, 9], [6]], [, , "(?:3(?:[05679][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", 
, , , "30212345", , , [8], [6]], [, , "6(?:0(?:3\\d|40)|[1-356]\\d|44[0-6]|71[137])\\d{5}", , , , "61123456"], [, , "8[08]\\d{6}", , , , "80123456", , , [8]], [, , "9[0246]\\d{6}", , , , "90123456", , , [8]], [, , "8[12]\\d{6}", , , , "82123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BA", 387, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-356]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", 
"$1 $2 $3 $4", ["6[047]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "70(?:3[0146]|[56]0)\\d{4}", , , , "70341234", , , [8]], , , [, , , , , , , , , [-1]]], BB:[, [, , "[2589]\\d{9}", , , , , , , [10], [7]], [, , "246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7(?:37|57)|9(?:1[89]|63))\\d{4}", , , , "2464123456", , , , [7]], [, , "246(?:2(?:[356]\\d|4[0-57-9]|8[0-79])|45\\d|69[5-7]|8(?:[2-5]\\d|83))\\d{4}", , , , "2462501234", 
, , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900\\d{7}|246976\\d{4}", , , , "9002123456", , , , [7]], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , "24631\\d{5}", , , , "2463101234", , , , [7]], "BB", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "246", [, , , , , , , , , [-1]], [, , "246(?:292|367|4(?:1[7-9]|3[01]|44|67)|736)\\d{4}", , , , "2464301234", , , , [7]], , , [, , , , , 
, , , , [-1]]], BD:[, [, , "[2-79]\\d{5,9}|1\\d{9}|8[0-7]\\d{4,8}", , , , , , , [6, 7, 8, 9, 10]], [, , "2(?:[45]\\d{3}|7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|[139][1-6]|2[0157-9]|41|6[1-35]|7[1-5]|8[1-8]|90)|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0167]|7[15]|8[0146-9]))\\d{4}|3(?:12?[5-7]\\d{2}|0(?:2(?:[025-79]\\d|[348]\\d{1,2})|3(?:[2-4]\\d|[56]\\d?))|2(?:1\\d{2}|2(?:[12]\\d|[35]\\d{1,2}|4\\d?))|3(?:1\\d{2}|2(?:[2356]\\d|4\\d{1,2}))|4(?:1\\d{2}|2(?:2\\d{1,2}|[47]|5\\d{2}))|5(?:1\\d{2}|29)|[67]1\\d{2}|8(?:1\\d{2}|2(?:2\\d{2}|3|4\\d)))\\d{3}|4(?:0(?:2(?:[09]\\d|7)|33\\d{2})|1\\d{3}|2(?:1\\d{2}|2(?:[25]\\d?|[348]\\d|[67]\\d{1,2}))|3(?:1\\d{2}(?:\\d{2})?|2(?:[045]\\d|[236-9]\\d{1,2})|32\\d{2})|4(?:[18]\\d{2}|2(?:[2-46]\\d{2}|3)|5[25]\\d{2})|5(?:1\\d{2}|2(?:3\\d|5))|6(?:[18]\\d{2}|2(?:3(?:\\d{2})?|[46]\\d{1,2}|5\\d{2}|7\\d)|5(?:3\\d?|4\\d|[57]\\d{1,2}|6\\d{2}|8))|71\\d{2}|8(?:[18]\\d{2}|23\\d{2}|54\\d{2})|9(?:[18]\\d{2}|2[2-5]\\d{2}|53\\d{1,2}))\\d{3}|5(?:02[03489]\\d{2}|1\\d{2}|2(?:1\\d{2}|2(?:2(?:\\d{2})?|[457]\\d{2}))|3(?:1\\d{2}|2(?:[37](?:\\d{2})?|[569]\\d{2}))|4(?:1\\d{2}|2[46]\\d{2})|5(?:1\\d{2}|26\\d{1,2})|6(?:[18]\\d{2}|2|53\\d{2})|7(?:1|24)\\d{2}|8(?:1|26)\\d{2}|91\\d{2})\\d{3}|6(?:0(?:1\\d{2}|2(?:3\\d{2}|4\\d{1,2}))|2(?:2[2-5]\\d{2}|5(?:[3-5]\\d{2}|7)|8\\d{2})|3(?:1|2[3478])\\d{2}|4(?:1|2[34])\\d{2}|5(?:1|2[47])\\d{2}|6(?:[18]\\d{2}|6(?:2(?:2\\d|[34]\\d{2})|5(?:[24]\\d{2}|3\\d|5\\d{1,2})))|72[2-5]\\d{2}|8(?:1\\d{2}|2[2-5]\\d{2})|9(?:1\\d{2}|2[2-6]\\d{2}))\\d{3}|7(?:(?:02|[3-589]1|6[12]|72[24])\\d{2}|21\\d{3}|32)\\d{3}|8(?:(?:4[12]|[5-7]2|1\\d?)|(?:0|3[12]|[5-7]1|217)\\d)\\d{4}|9(?:[35]1|(?:[024]2|81)\\d|(?:1|[24]1)\\d{2})\\d{3}", 
, , , "27111234", , , [6, 7, 8, 9]], [, , "(?:1[13-9]\\d|(?:3[78]|44)[02-9]|6(?:44|6[02-9]))\\d{7}", , , , "1812345678", , , [10]], [, , "80[03]\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "96(?:0[469]|1[0-4]|3[389]|6[69]|7[78])\\d{6}", , , , "9604123456", , , [10]], "BD", 880, "00", "0", , , "0", , , , [[, "(2)(\\d{7,8})", "$1-$2", ["2"], "0$1"], [, "(\\d{2})(\\d{4,6})", "$1-$2", ["[3-79]1"], "0$1"], [, "(\\d{4})(\\d{3,6})", 
"$1-$2", ["1|3(?:0|[2-58]2)|4(?:0|[25]2|3[23]|[4689][25])|5(?:[02-578]2|6[25])|6(?:[0347-9]2|[26][25])|7[02-9]2|8(?:[023][23]|[4-7]2)|9(?:[02][23]|[458]2|6[01367])"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1-$2", ["[3-79][2-9]|8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BE:[, [, , "[1-9]\\d{7,8}", , , , , , , [8, 9]], [, , "(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}|80[2-8]\\d{5}", , , , "12345678", 
, , [8]], [, , "4(?:56|6[0135-8]|[79]\\d|8[3-9])\\d{6}", , , , "470123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "(?:70[2-467]|90[0-79])\\d{5}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BE", 32, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4[5-9]"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[23]|4[23]|9[2-4]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4", ["[156]|7[018]|8(?:0[1-9]|[1-79])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "78\\d{6}", , , , "78123456", , , [8]], , , [, , , , , , , , , [-1]]], BF:[, [, , "[25-7]\\d{7}", , , , , , , [8]], [, , "2(?:0(?:49|5[23]|6[56]|9[016-9])|4(?:4[569]|5[4-6]|6[56]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}", , , , "20491234"], [, , "(?:5[15-8]|[67]\\d)\\d{6}", , , , "70123456"], [, , , , , , , , , 
[-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BF", 226, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BG:[, [, , "[23567]\\d{5,7}|[489]\\d{6,8}", , , , , , , [6, 7, 8, 9], [4, 5]], [, , "2\\d{5,7}|(?:[36]\\d|5[1-9]|8[1-6]|9[1-7])\\d{5,6}|(?:4(?:[124-7]\\d|3[1-6])|7(?:0[1-9]|[1-9]\\d))\\d{4,5}", 
, , , "2123456", , , [6, 7, 8], [4, 5]], [, , "(?:8[7-9]\\d|9(?:8\\d|9[69]))\\d{6}|4(?:3[0789]|8\\d)\\d{5}", , , , "48123456", , , [8, 9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90\\d{6}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , "700\\d{5}", , , , "70012345", , , [8]], [, , , , , , , , , [-1]], "BG", 359, "00", "0", , , "0", , , , [[, "(2)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [, "(2)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{4})", 
"$1 $2", ["43[124-7]|70[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[124-7]|70[1-9]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[78]00"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["99[69]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["48|8[7-9]|9[08]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , 
, , , , , , , [-1]]], BH:[, [, , "[136-9]\\d{7}", , , , , , , [8]], [, , "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9])|9[69][69])|7(?:1(?:11|78)|7\\d{2}))\\d{4}", , , , "17001234"], [, , "(?:3(?:[1-4679]\\d|5[013-69]|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:[69]\\d|3[03-9]|7[0-6])))\\d{4}", , , , "36001234"], [, , "80\\d{6}", , , , "80123456"], [, , "(?:87|9[014578])\\d{6}", , , , "90123456"], [, , "84\\d{6}", , , , "84123456"], [, , , , , , , , , [-1]], [, , , , , , , 
, , [-1]], "BH", 973, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BI:[, [, , "[267]\\d{7}", , , , , , , [8]], [, , "22\\d{6}", , , , "22201234"], [, , "(?:29|6[189]|7[124-9])\\d{6}", , , , "79561234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BI", 257, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BJ:[, [, , "[2689]\\d{7}", , , , , , , [8]], [, , "2(?:02|1[037]|2[45]|3[68])\\d{5}", , , , "20211234"], [, , "(?:6\\d|9[03-9])\\d{6}", , , , "90011234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "857[58]\\d{4}", , , , "85751234"], "BJ", 229, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4", ["[2689]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "81\\d{6}", , , , "81123456"], , , [, , , , , , , , , [-1]]], BL:[, [, , "[56]\\d{8}", , , , , , , [9]], [, , "590(?:2[7-9]|5[12]|87)\\d{4}", , , , "590271234"], [, , "69(?:0\\d{2}|1(?:2[29]|3[0-5]))\\d{4}", , , , "690001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BL", 590, "00", "0", , , "0", , , , , , [, , , , , 
, , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BM:[, [, , "[4589]\\d{9}", , , , , , , [10], [7]], [, , "441(?:2(?:02|23|61|[3479]\\d)|[46]\\d{2}|5(?:4\\d|60|89)|824)\\d{4}", , , , "4412345678", , , , [7]], [, , "441(?:[37]\\d|5[0-39])\\d{5}", , , , "4413701234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", 
, , , "5002345678"], [, , , , , , , , , [-1]], "BM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "441", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BN:[, [, , "[2-578]\\d{6}", , , , , , , [7]], [, , "2(?:[013-9]\\d|2[0-7])\\d{4}|[3-5]\\d{6}", , , , "2345678"], [, , "22[89]\\d{4}|[78]\\d{6}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BN", 
673, "00", , , , , , , , [[, "([2-578]\\d{2})(\\d{4})", "$1 $2", ["[2-578]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BO:[, [, , "[23467]\\d{7}|8\\d{8}", , , , , , , [8, 9], [7]], [, , "(?:2(?:2\\d{2}|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d{2}|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:2\\d|3[234]|4[248]|5[24]|6[2-6]|7\\d))|4(?:4\\d{2}|6(?:11|[24689]\\d|72)))\\d{4}", , , , "22123456", , , 
[8], [7]], [, , "[67]\\d{7}", , , , "71234567", , , [8]], [, , "80017\\d{4}", , , , "800171234", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BO", 591, "00(1\\d)?", "0", , , "0(1\\d)?", , , , [[, "([234])(\\d{7})", "$1 $2", ["[2-4]"], , "0$CC $1"], [, "([67]\\d{7})", "$1", ["[67]"], , "0$CC $1"], [, "(800)(\\d{2})(\\d{4})", "$1 $2 $3", ["800"], , "0$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , 
, , , , [-1]], , , [, , , , , , , , , [-1]]], BQ:[, [, , "[347]\\d{6}", , , , , , , [7]], [, , "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|50)\\d)\\d{3}", , , , "7151234"], [, , "(?:31(?:8[14-8]|9[14578])|416[145-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}", , , , "3181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BQ", 599, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , 
, , , , , [-1]], , , [, , , , , , , , , [-1]]], BR:[, [, , "[1-46-9]\\d{7,10}|5(?:[0-4]\\d{7,9}|5(?:[2-8]\\d{7}|9\\d{7,8}))", , , , , , , [8, 9, 10, 11]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", , , , "1123456789", , , [10], [8]], [, , "(?:[189][1-9]|2[12478])(?:7|9\\d)\\d{7}|(?:3[1-578]|[46][1-9]|5[13-5]|7[13-579])(?:[6-8]|9\\d?)\\d{7}", , , , "11961234567", , , [10, 11], [8]], [, , "800\\d{6,7}", , , , "800123456", , , [9, 10]], [, , "(?:300|[59]00\\d?)\\d{6}", , 
, , "300123456", , , [9, 10]], [, , "(?:300\\d(?:\\d{2})?|40(?:0\\d|20))\\d{4}", , , , "40041234", , , [8, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BR", 55, "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "0", , , "0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["300|40[02]", "300|40(?:0|20)"]], [, "([3589]00)(\\d{2,3})(\\d{4})", "$1 $2 $3", ["[3589]00"], "0$1"], [, "(\\d{3,5})", "$1", ["1[125689]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[2-9](?:0[1-9]|[1-9])"]], 
[, "(\\d{5})(\\d{4})", "$1-$2", ["9(?:0[1-9]|[1-9])"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["[1-9][1-9]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[1-9][1-9]9"], "($1)", "0 $CC ($1)"]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["300|40[02]", "300|40(?:0|20)"]], [, "([3589]00)(\\d{2,3})(\\d{4})", "$1 $2 $3", ["[3589]00"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["[1-9][1-9]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[1-9][1-9]9"], 
"($1)", "0 $CC ($1)"]], [, , , , , , , , , [-1]], , , [, , "(?:300\\d|40(?:0\\d|20))\\d{4}", , , , "40041234", , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BS:[, [, , "[2589]\\d{9}", , , , , , , [10], [7]], [, , "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-4]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}", , , , "2423456789", , , , [7]], [, , "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}", 
, , , "2423591234", , , , [7]], [, , "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , , [7]], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "BS", 1, "011?", "1", , , "1", , "011", , , , [, , , , , , , , , [-1]], , "242", [, , , , , , , , , [-1]], [, , "242225[0-46-9]\\d{3}", , , , "2422250123"], , , [, , , , , , , , , [-1]]], BT:[, [, , "[1-8]\\d{6,7}", 
, , , , , , [7, 8], [6]], [, , "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", , , , "2345678", , , [7], [6]], [, , "(?:1[67]|77)\\d{6}", , , , "17123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BT", 975, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1|77"]], [, "([2-8])(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]]], , [, , , , , , , , , [-1]], , , [, 
, , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BW:[, [, , "[2-79]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[01])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[0389]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}", , , , "2401234", , , [7]], [, , "7(?:[1-6]\\d|7[014-8])\\d{5}", , , , "71123456", , , [8]], [, , , , , , , , , [-1]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , 
, , , , [-1]], [, , "79[12][01]\\d{4}", , , , "79101234", , , [8]], "BW", 267, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-6]"]], [, "(7\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], [, "(90)(\\d{5})", "$1 $2", ["90"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BY:[, [, , "[1-4]\\d{8}|8(?:0(?:0\\d{3,7}|[13]\\d{7})|(?:10|20\\d)\\d{7})|9\\d{9,10}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [, , "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d{2})|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", 
, , , "152450911", , , [9], [5, 6, 7]], [, , "(?:2(?:5[5679]|9[1-9])|33\\d|44\\d)\\d{6}", , , , "294911911", , , [9]], [, , "8(?:0[13]|20\\d)\\d{7}|800\\d{3,7}", , , , "8011234567"], [, , "(?:810|902)\\d{7}", , , , "9021234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "249\\d{6}", , , , "249123456", , , [9]], "BY", 375, "810", "8", , , "8?0?", , "8~10", , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["17[0-3589]|2[4-9]|[34]", "17(?:[02358]|1[0-2]|9[0189])|2[4-9]|[34]"], 
"8 0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])", "1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])"], "8 0$1"], [, "(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], [, "([89]\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8[01]|9"], "8 $1"], [, "(82\\d)(\\d{4})(\\d{4})", 
"$1 $2 $3", ["82"], "8 $1"], [, "(800)(\\d{3})", "$1 $2", ["800"], "8 $1"], [, "(800)(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , "8(?:0[13]|10|20\\d)\\d{7}|800\\d{3,7}|902\\d{7}", , , , "82012345678"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BZ:[, [, , "[2-8]\\d{6}|0\\d{10}", , , , , , , [7, 11]], [, , "(?:2(?:[02]\\d|36)|[3-58][02]\\d|7(?:[02]\\d|32))\\d{4}", , , , "2221234", , , [7]], [, , "6[0-35-7]\\d{5}", , , , "6221234", , , [7]], 
[, , "0800\\d{7}", , , , "08001234123", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BZ", 501, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [, "(0)(800)(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["080", "0800"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CA:[, [, , "[2-9]\\d{9}", , , , , , , [10], [7]], [, , "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", 
, , , "5062345678", , , , [7]], [, , "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", , , , "2042345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "CA", 1, "011", "1", 
, , "1", , , 1, , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CC:[, [, , "[1458]\\d{5,9}", , , , , , , [6, 7, 8, 9, 10]], [, , "8(?:51(?:0(?:02|31|60)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:08|22|68)|4[29]8|62\\d|70[23]|959))\\d{3}", , , , "891621234", , , [9], [8]], [, , "14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12547-9]|9[017-9])\\d{6}", , , , "412345678", , , [9]], [, , "180(?:0\\d{3}|2)\\d{3}", 
, , , "1800123456", , , [7, 10]], [, , "19(?:0[0126]\\d|[679])\\d{5}", , , , "1900123456", , , [8, 10]], [, , "13(?:00\\d{2})?\\d{4}", , , , "1300123456", , , [6, 10]], [, , "500\\d{6}", , , , "500123456", , , [9]], [, , "550\\d{6}", , , , "550123456", , , [9]], "CC", 61, "(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]", "0", , , "0", , "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CD:[, [, , "[2-6]\\d{6}|[18]\\d{6,8}|9\\d{8}", 
, , , , , , [7, 9]], [, , "1(?:2\\d{7}|\\d{6})|[2-6]\\d{6}", , , , "1234567"], [, , "8(?:[0-2459]\\d{2}|8)\\d{5}|9[017-9]\\d{7}", , , , "991234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CD", 243, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["12"], "0$1"], [, "([89]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[0-2459]|9"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], 
[, "(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CF:[, [, , "[278]\\d{7}", , , , , , , [8]], [, , "2[12]\\d{6}", , , , "21612345"], [, , "7[0257]\\d{6}", , , , "70012345"], [, , , , , , , , , [-1]], [, , "8776\\d{4}", , , , "87761234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CF", 236, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CG:[, [, , "[028]\\d{8}", , , , , , , [9]], [, , "222[1-589]\\d{5}", , , , "222123456"], [, , "0[14-6]\\d{7}", , , , "061234567"], [, , , , , , , , , [-1]], [, , "80(?:0\\d{2}|11[01])\\d{4}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CG", 242, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", 
["801"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["800"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CH:[, [, , "[2-9]\\d{8}|860\\d{9}", , , , , , , [9, 12]], [, , "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", , , , "212345678", , , [9]], [, , "7[5-9]\\d{7}", , , , "781234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[016]\\d{6}", , , 
, "900123456", , , [9]], [, , "84[0248]\\d{6}", , , , "840123456", , , [9]], [, , "878\\d{6}", , , , "878123456", , , [9]], [, , , , , , , , , [-1]], "CH", 41, "00", "0", , , "0", , , , [[, "([2-9]\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]|[89]1"], "0$1"], [, "([89]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["860"], "0$1"]], , [, , "74[0248]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], 
[, , "5[18]\\d{7}", , , , "581234567", , , [9]], , , [, , "860\\d{9}", , , , "860123456789", , , [12]]], CI:[, [, , "[02-8]\\d{7}", , , , , , , [8]], [, , "(?:2(?:0[023]|1[02357]|[23][045]|4[03-5])|3(?:0[06]|1[069]|[2-4][07]|5[09]|6[08]))\\d{5}", , , , "21234567"], [, , "(?:0[1-9]|[45]\\d|6[014-9]|7[124-9]|8[4-9])\\d{6}", , , , "01234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CI", 225, "00", , , , , , , 
, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CK:[, [, , "[2-8]\\d{4}", , , , , , , [5]], [, , "(?:2\\d|3[13-7]|4[1-5])\\d{3}", , , , "21234"], [, , "[5-8]\\d{4}", , , , "71234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CK", 682, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2"]], 
, [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CL:[, [, , "1230\\d{7}|[2-46-9]\\d{8,10}|5[1-3578]\\d{7}", , , , , , , [9, 10, 11]], [, , "2(?:1962\\d{4}|2\\d{7}|32[0-467]\\d{5})|(?:3[2-5]\\d|[47][1-35]\\d|5[1-3578]\\d|6[13-57]\\d|8(?:0[1-9]|[1-9]\\d)|9[3-9]\\d)\\d{6}", , , , "221234567", , , [9]], [, , "2(?:1962\\d{4}|2\\d{7}|32[0-467]\\d{5})|(?:3[2-5]\\d|[47][1-35]\\d|5[1-3578]\\d|6[13-57]\\d|8(?:0[1-9]|[1-9]\\d)|9[3-9]\\d)\\d{6}", 
, , , "961234567", , , [9]], [, , "800\\d{6}|1230\\d{7}", , , , "800123456", , , [9, 11]], [, , , , , , , , , [-1]], [, , "600\\d{7,8}", , , , "6001234567", , , [10, 11]], [, , , , , , , , , [-1]], [, , "44\\d{7}", , , , "441234567", , , [9]], "CL", 56, "(?:0|1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))0", , , , , , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[23]"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[357]|4[1-35]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], [, "(9)(\\d{4})(\\d{4})", 
"$1 $2 $3", ["9"]], [, "(44)(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "([68]00)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[68]00"]], [, "(600)(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["600"]], [, "(1230)(\\d{3})(\\d{4})", "$1 $2 $3", ["123", "1230"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["219"], "($1)"], [, "(\\d{4,5})", "$1", ["[1-9]"], "$1"]], [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[23]"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[357]|4[1-35]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], [, "(9)(\\d{4})(\\d{4})", 
"$1 $2 $3", ["9"]], [, "(44)(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "([68]00)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[68]00"]], [, "(600)(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["600"]], [, "(1230)(\\d{3})(\\d{4})", "$1 $2 $3", ["123", "1230"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["219"], "($1)"]], [, , , , , , , , , [-1]], , , [, , "600\\d{7,8}", , , , "6001234567", , , [10, 11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CM:[, [, , "[2368]\\d{7,8}", , , , , , , [8, 9]], [, , "2(?:22|33|4[23])\\d{6}", 
, , , "222123456", , , [9]], [, , "6[5-9]\\d{7}", , , , "671234567", , , [9]], [, , "88\\d{6}", , , , "88012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CM", 237, "00", , , , , , , , [[, "([26])(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[23]|88"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , 
, , , , [-1]]], CN:[, [, , "[1-7]\\d{6,11}|8[0-357-9]\\d{6,9}|9\\d{7,10}", , , , , , , [7, 8, 9, 10, 11, 12], [5, 6]], [, , "21(?:100\\d{2}|95\\d{3,4}|\\d{8,10})|(?:10|2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:[57]1|98))(?:100\\d{2}|95\\d{3,4}|\\d{8})|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[3-9]|5[2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-4689]|6[2368]|9[02-9])|8(?:078|1[236-8]|2[5-7]|3\\d|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100\\d{2}|95\\d{3,4}|\\d{7})", 
, , , "1012345678", , , , [5, 6]], [, , "1(?:[38]\\d{3}|4[57]\\d{2}|5[0-35-9]\\d{2}|66\\d{2}|7(?:[0-35-8]\\d{2}|40[0-5])|9[89]\\d{2})\\d{6}", , , , "13123456789", , , [11]], [, , "(?:10)?800\\d{7}", , , , "8001234567", , , [10, 12]], [, , "16[08]\\d{5}", , , , "16812345", , , [8]], [, , "400\\d{7}|950\\d{7,8}|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[4789]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[3678]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", 
, , , "4001234567", , , [7, 8, 9, 10, 11], [5, 6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CN", 86, "(1(?:[12]\\d{3}|79\\d{2}|9[0-7]\\d{2}))?00", "0", , , "(1(?:[12]\\d{3}|79\\d{2}|9[0-7]\\d{2}))|0", , "00", , [[, "([48]00)(\\d{3})(\\d{4})", "$1 $2 $3", ["[48]00"]], [, "(\\d{5,6})", "$1", ["100|95"]], [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2\\d)[19]", "(?:10|2\\d)(?:10|9[56])", "(?:10|2\\d)(?:100|9[56])"], "0$1", "$CC $1"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[3-9]", "[3-9]\\d\\d[19]", 
"[3-9]\\d\\d(?:10|9[56])"], "0$1", "$CC $1"], [, "(\\d{3,4})(\\d{4})", "$1 $2", ["[2-9]"]], [, "(21)(\\d{4})(\\d{4,6})", "$1 $2 $3", ["21"], "0$1", "$CC $1", 1], [, "([12]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["10[1-9]|2[02-9]", "10[1-9]|2[02-9]", "10(?:[1-79]|8(?:0[1-9]|[1-9]))|2[02-9]"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[47-9]|7|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"], 
"0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[457]|6[09])|8(?:[57]1|98)"], "0$1", "$CC $1", 1], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["807", "8078"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1(?:[3-57-9]|66)"], , "$CC $1"], [, "(10800)(\\d{3})(\\d{4})", "$1 $2 $3", ["108", "1080", "10800"]], [, "(\\d{3})(\\d{7,8})", "$1 $2", ["950"]]], [[, "([48]00)(\\d{3})(\\d{4})", 
"$1 $2 $3", ["[48]00"]], [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2\\d)[19]", "(?:10|2\\d)(?:10|9[56])", "(?:10|2\\d)(?:100|9[56])"], "0$1", "$CC $1"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[3-9]", "[3-9]\\d\\d[19]", "[3-9]\\d\\d(?:10|9[56])"], "0$1", "$CC $1"], [, "(21)(\\d{4})(\\d{4,6})", "$1 $2 $3", ["21"], "0$1", "$CC $1", 1], [, "([12]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["10[1-9]|2[02-9]", "10[1-9]|2[02-9]", "10(?:[1-79]|8(?:0[1-9]|[1-9]))|2[02-9]"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{3})(\\d{4})", 
"$1 $2 $3", ["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[47-9]|7|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[457]|6[09])|8(?:[57]1|98)"], "0$1", 
"$CC $1", 1], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["807", "8078"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1(?:[3-57-9]|66)"], , "$CC $1"], [, "(10800)(\\d{3})(\\d{4})", "$1 $2 $3", ["108", "1080", "10800"]], [, "(\\d{3})(\\d{7,8})", "$1 $2", ["950"]]], [, , , , , , , , , [-1]], , , [, , "(?:4|(?:10)?8)00\\d{7}|950\\d{7,8}", , , , "4001234567", , , [10, 11, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CO:[, [, , "(?:[13]\\d{0,3}|[24-8])\\d{7}", , 
, , , , , [8, 10, 11], [7]], [, , "[124-8][2-9]\\d{6}", , , , "12345678", , , [8], [7]], [, , "3(?:0[0-5]|1\\d|2[0-3]|5[01])\\d{7}", , , , "3211234567", , , [10]], [, , "1800\\d{7}", , , , "18001234567", , , [11]], [, , "19(?:0[01]|4[78])\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CO", 57, "00(?:4(?:[14]4|56)|[579])", "0", , , "0([3579]|4(?:44|56))?", , , , [[, "(\\d)(\\d{7})", "$1 $2", ["1(?:[2-7]|8[2-9]|9[0-3])|[24-8]", 
"1(?:[2-7]|8[2-9]|9(?:09|[1-3]))|[24-8]"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], , "0$CC $1"], [, "(1)(\\d{3})(\\d{7})", "$1-$2-$3", ["1(?:80|9[04])", "1(?:800|9(?:0[01]|4[78]))"], "0$1"]], [[, "(\\d)(\\d{7})", "$1 $2", ["1(?:[2-7]|8[2-9]|9[0-3])|[24-8]", "1(?:[2-7]|8[2-9]|9(?:09|[1-3]))|[24-8]"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], , "0$CC $1"], [, "(1)(\\d{3})(\\d{7})", "$1 $2 $3", ["1(?:80|9[04])", "1(?:800|9(?:0[01]|4[78]))"]]], [, , , , , , , , , [-1]], 
, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CR:[, [, , "[24-9]\\d{7,9}", , , , , , , [8, 10]], [, , "2(?:[024-7]\\d{2}|1(?:0[7-9]|[1-9]\\d))\\d{4}", , , , "22123456", , , [8]], [, , "5(?:0[01]|7[0-3])\\d{5}|6(?:[0-4]\\d{3}|500[01])\\d{3}|(?:7[0-3]|8[3-9])\\d{6}", , , , "83123456", , , [8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "90[059]\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "210[0-6]\\d{4}|4\\d{7}|5100\\d{4}", 
, , , "40001234", , , [8]], "CR", 506, "00", , , , "(19(?:0[012468]|1[09]|20|66|77|99))", , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[24-7]|8[3-9]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]0"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CU:[, [, , "[2-57]\\d{5,7}", , , , , , , [6, 7, 8], [4, 5]], [, , "2[1-4]\\d{5,6}|3(?:1\\d{6}|[23]\\d{4,6})|4(?:[125]\\d{5,6}|[36]\\d{6}|[78]\\d{4,6})|7\\d{6,7}", 
, , , "71234567", , , , [4, 5]], [, , "5\\d{7}", , , , "51234567", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CU", 53, "119", "0", , , "0", , , , [[, "(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], [, "(\\d{2})(\\d{4,6})", "$1 $2", ["[2-4]"], "(0$1)"], [, "(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 
CV:[, [, , "[2-59]\\d{6}", , , , , , , [7]], [, , "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}", , , , "2211234"], [, , "(?:[34][36]|5[1-389]|9\\d)\\d{5}", , , , "9911234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CV", 238, "0", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , 
[-1]]], CW:[, [, , "[134679]\\d{6,7}", , , , , , , [7, 8]], [, , "9(?:[48]\\d{2}|50\\d|7(?:2[0-24]|[34]\\d|6[35-7]|77|8[7-9]))\\d{4}", , , , "94151234", , , [8]], [, , "9(?:5(?:[12467]\\d|3[01])|6(?:[15-9]\\d|3[01]))\\d{4}", , , , "95181234", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "60[0-2]\\d{4}", , , , "6001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CW", 599, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[13-7]"]], [, "(9)(\\d{3})(\\d{4})", 
"$1 $2 $3", ["9"]]], , [, , "955\\d{5}", , , , "95581234", , , [8]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CX:[, [, , "[1458]\\d{5,9}", , , , , , , [6, 7, 8, 9, 10]], [, , "8(?:51(?:0(?:01|30|59)|117)|91(?:00[6-9]|1(?:21|49|78|81)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", , , , "891641234", , , [9], [8]], [, , "14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12547-9]|9[017-9])\\d{6}", , , , "412345678", 
, , [9]], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "19(?:0[0126]\\d|[679])\\d{5}", , , , "1900123456", , , [8, 10]], [, , "13(?:00\\d{2})?\\d{4}", , , , "1300123456", , , [6, 8, 10]], [, , "500\\d{6}", , , , "500123456", , , [9]], [, , "550\\d{6}", , , , "550123456", , , [9]], "CX", 61, "(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]", "0", , , "0", , "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , 
, , , [-1]]], CY:[, [, , "[257-9]\\d{7}", , , , , , , [8]], [, , "2[2-6]\\d{6}", , , , "22345678"], [, , "9[4-79]\\d{6}", , , , "96123456"], [, , "800\\d{5}", , , , "80001234"], [, , "90[09]\\d{5}", , , , "90012345"], [, , "80[1-9]\\d{5}", , , , "80112345"], [, , "700\\d{5}", , , , "70012345"], [, , , , , , , , , [-1]], "CY", 357, "00", , , , , , , , [[, "(\\d{2})(\\d{6})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:50|77)\\d{6}", , , , "77123456"], , , [, , , , 
, , , , , [-1]]], CZ:[, [, , "[2-8]\\d{8}|9\\d{8,11}", , , , , , , [9, 10, 11, 12]], [, , "2\\d{8}|(?:3[1257-9]|4[16-9]|5[13-9])\\d{7}", , , , "212345678", , , [9]], [, , "(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}", , , , "601123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:0[05689]|76)\\d{6}", , , , "900123456", , , [9]], [, , "8[134]\\d{7}", , , , "811234567", , , [9]], [, , "70[01]\\d{6}", , , , "700123456", , , [9]], [, , "9[17]0\\d{6}", , , , "910123456", , , [9]], "CZ", 
420, "00", , , , , , , , [[, "([2-9]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], [, "(96\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["96"]], [, "(9\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9[36]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "9(?:5\\d|7[234])\\d{6}", , , , "972123456", , , [9]], , , [, , "9(?:3\\d{9}|6\\d{7,10})", , , , "93123456789"]], DE:[, [, , "[1-35-9]\\d{3,14}|4(?:[0-8]\\d{3,12}|9(?:[0-37]\\d|4(?:[1-35-8]|4\\d?)|5\\d{1,2}|6[1-8]\\d?)\\d{2,8})", 
, , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [3]], [, , "2\\d{5,13}|3(?:0\\d{3,13}|2\\d{9}|[3-9]\\d{4,13})|4(?:0\\d{3,12}|[1-8]\\d{4,12}|9(?:[0-37]\\d|4(?:[1-35-8]|4\\d?)|5\\d{1,2}|6[1-8]\\d?)\\d{2,8})|5(?:0[2-8]|[1256]\\d|[38][0-8]|4\\d{0,2}|[79][0-7])\\d{3,11}|6(?:\\d{5,13}|9\\d{3,12})|7(?:0[2-8]|[1-9]\\d)\\d{3,10}|8(?:0[2-9]|[1-8]\\d|9\\d?)\\d{3,10}|9(?:0[6-9]\\d{3,10}|1\\d{4,12}|[2-9]\\d{4,11})", , , , "30123456", , , [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [3, 4]], [, , "1(?:5[0-25-9]\\d{8}|6[023]\\d{7,8}|7\\d{8,9})", 
, , , "15123456789", , , [10, 11]], [, , "800\\d{7,12}", , , , "8001234567890", , , [10, 11, 12, 13, 14, 15]], [, , "137[7-9]\\d{6}|900(?:[135]\\d{6}|9\\d{7})", , , , "9001234567", , , [10, 11]], [, , "1(?:3(?:7[1-6]\\d{6}|8\\d{4})|80\\d{5,11})", , , , "18012345", , , [7, 8, 9, 10, 11, 12, 13, 14]], [, , "700\\d{8}", , , , "70012345678", , , [11]], [, , , , , , , , , [-1]], "DE", 49, "00", "0", , , "0", , , , [[, "(1\\d{2})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], [, "(15\\d{3})(\\d{6})", "$1 $2", 
["15[0568]"], "0$1"], [, "(1\\d{3})(\\d{7})", "$1 $2", ["15"], "0$1"], [, "(\\d{2})(\\d{3,11})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], [, "(\\d{3})(\\d{3,11})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14]|[4-9]1)|3(?:[35-9][15]|4[015])|[4-8][1-9]1|9(?:06|[1-9]1)"], "0$1"], [, "(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|[7-9](?:0[1-9]|[1-9])", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|[49][1246]|6[1-4]|7[13468]|8[13568])|6(?:0[356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6[0135-9]|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|[7-9](?:0[1-9]|[1-9])"], 
"0$1"], [, "(3\\d{4})(\\d{1,10})", "$1 $2", ["3"], "0$1"], [, "(800)(\\d{7,12})", "$1 $2", ["800"], "0$1"], [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:37|80)|900", "1(?:37|80)|900[1359]"], "0$1"], [, "(1\\d{2})(\\d{5,11})", "$1 $2", ["181"], "0$1"], [, "(18\\d{3})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], [, "(18\\d{2})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], [, "(18\\d)(\\d{8})", "$1 $2", ["18[2-579]"], "0$1"], [, "(700)(\\d{4})(\\d{4})", "$1 $2 $3", ["700"], "0$1"], [, "(138)(\\d{4})", 
"$1 $2", ["138"], "0$1"], [, "(15[013-68])(\\d{2})(\\d{8})", "$1 $2 $3", ["15[013-68]"], "0$1"], [, "(15[279]\\d)(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], [, "(1[67]\\d)(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"]], , [, , "16(?:4\\d{1,10}|[89]\\d{1,11})", , , , "16412345", , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]], [, , "18(?:1\\d{5,11}|[2-9]\\d{8})", , , , "18500123456", , , [8, 9, 10, 11, 12, 13, 14]], , , [, , "1(?:5(?:(?:2\\d55|7\\d99|9\\d33)\\d{7}|(?:[034568]00|113)\\d{8})|6(?:013|255|399)\\d{7,8}|7(?:[015]13|[234]55|[69]33|[78]99)\\d{7,8})", 
, , , "177991234567", , , [12, 13]]], DJ:[, [, , "[27]\\d{7}", , , , , , , [8]], [, , "2(?:1[2-5]|7[45])\\d{5}", , , , "21360003"], [, , "77\\d{6}", , , , "77831001"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DJ", 253, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 
DK:[, [, , "[2-9]\\d{7}", , , , , , , [8]], [, , "(?:[2-7]\\d|8[126-9]|9[1-36-9])\\d{6}", , , , "32123456"], [, , "(?:[2-7]\\d|8[126-9]|9[1-36-9])\\d{6}", , , , "20123456"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DK", 45, "00", , , , , , , 1, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, 
, , , , , , , , [-1]]], DM:[, [, , "[57-9]\\d{9}", , , , , , , [10], [7]], [, , "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4]|70[1-3])\\d{4}", , , , "7674201234", , , , [7]], [, , "767(?:2(?:[234689]5|7[5-7])|31[5-7]|61[1-7])\\d{4}", , , , "7672251234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], 
"DM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "767", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], DO:[, [, , "[589]\\d{9}", , , , , , , [10], [7]], [, , "8(?:[04]9[2-9]\\d{6}|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d{2}|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9]))\\d{4})", 
, , , "8092345678", , , , [7]], [, , "8[024]9[2-9]\\d{6}", , , , "8092345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "DO", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "8[024]9", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], DZ:[, [, 
, "(?:[1-4]|[5-9]\\d)\\d{7}", , , , , , , [8, 9]], [, , "(?:1\\d|2[013-79]|3[0-8]|4[0135689])\\d{6}|9619\\d{5}", , , , "12345678"], [, , "(?:5[4-6]|7[7-9])\\d{7}|6(?:[569]\\d|7[0-6])\\d{6}", , , , "551234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "80[3-689]1\\d{5}", , , , "808123456", , , [9]], [, , "80[12]1\\d{5}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , "98[23]\\d{6}", , , , "983123456", , , [9]], "DZ", 213, "00", "0", , , "0", , , , [[, "([1-4]\\d)(\\d{2})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4", ["[1-4]"], "0$1"], [, "([5-8]\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"], [, "(9\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EC:[, [, , "1\\d{9,10}|[2-8]\\d{7}|9\\d{8}", , , , , , , [8, 9, 10, 11], [7]], [, , "[2-7][2-7]\\d{6}", , , , "22123456", , , [8], [7]], [, , "9(?:(?:39|[45][89]|7[7-9]|[89]\\d)\\d{2}|6(?:[017-9]\\d{2}|2(?:[0-47-9]\\d|5[1-9]|60)|30\\d))\\d{4}", 
, , , "991234567", , , [9]], [, , "1800\\d{6,7}", , , , "18001234567", , , [10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[2-7]890\\d{4}", , , , "28901234", , , [8]], "EC", 593, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[247]|[356][2-8]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(1800)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["180", "1800"], "$1"]], [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[247]|[356][2-8]"]], 
[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(1800)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["180", "1800"], "$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EE:[, [, , "[3-9]\\d{6,7}|800\\d{6,7}", , , , , , , [7, 8, 10]], [, , "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", , , , "3212345", , , [7]], [, , "(?:5\\d|8[1-5])\\d{6}|5(?:[02]\\d{2}|1(?:[0-8]\\d|95)|5[0-478]\\d|64[0-4]|65[1-589])\\d{3}", , , , "51234567", , , 
[7, 8]], [, , "800(?:0\\d{3}|1\\d|[2-9])\\d{3}", , , , "80012345"], [, , "(?:40\\d{2}|900)\\d{4}", , , , "9001234", , , [7, 8]], [, , , , , , , , , [-1]], [, , "70[0-2]\\d{5}", , , , "70012345", , , [8]], [, , , , , , , , , [-1]], "EE", 372, "00", , , , , , , , [[, "([3-79]\\d{2})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"]], [, "(70)(\\d{2})(\\d{4})", "$1 $2 $3", ["70"]], [, "(8000)(\\d{3})(\\d{3})", 
"$1 $2 $3", ["800", "8000"]], [, "([458]\\d{3})(\\d{3,4})", "$1 $2", ["40|5|8(?:00|[1-5])", "40|5|8(?:00[1-9]|[1-5])"]]], , [, , , , , , , , , [-1]], , , [, , "800[2-9]\\d{3}", , , , "8002123", , , [7]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EG:[, [, , "1\\d{4,9}|[24-6]\\d{8}|3\\d{7}|[89]\\d{8,9}", , , , , , , [8, 9, 10], [7]], [, , "(?:1(?:3[23]\\d|5(?:[23]|9\\d))|2[2-4]\\d{2}|3\\d{2}|4(?:0[2-5]|[578][23]|64)\\d|5(?:0[2-7]|5\\d|7[23])\\d|6[24-689]3\\d|8(?:2[2-57]|4[26]|6[237]|8[2-4])\\d|9(?:2[27]|3[24]|52|6[2356]|7[2-4])\\d)\\d{5}", 
, , , "234567890", , , [8, 9], [7]], [, , "1[0125]\\d{8}", , , , "1001234567", , , [10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "EG", 20, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], [, "(\\d{2})(\\d{6,7})", "$1 $2", ["1(?:3|5[239])|[4-6]|[89][2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1[0-25]|[89]00"], "0$1"]], 
, [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EH:[, [, , "[5-9]\\d{8}", , , , , , , [9]], [, , "528[89]\\d{5}", , , , "528812345"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[067]|6[1267]|7[07]))\\d{6}", , , , "650123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5924[01]\\d{4}", , , , "592401234"], "EH", 212, "00", "0", , , "0", , , , , , 
[, , , , , , , , , [-1]], , "528[89]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ER:[, [, , "[178]\\d{6}", , , , , , , [7], [6]], [, , "1(?:1[12568]|20|40|55|6[146])\\d{4}|8\\d{6}", , , , "8370362", , , , [6]], [, , "17[1-3]\\d{4}|7\\d{6}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ER", 291, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", 
, "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ES:[, [, , "[5-9]\\d{8}", , , , , , , [9]], [, , "8(?:[1356]\\d|[28][0-8]|[47][1-9])\\d{6}|9(?:[135]\\d{7}|[28][0-8]\\d{6}|4[1-9]\\d{6}|6(?:[0-8]\\d{6}|9(?:0(?:[0-57-9]\\d{4}|6(?:0[0-8]|1[1-9]|[2-9]\\d)\\d{2})|[1-9]\\d{5}))|7(?:[124-9]\\d{2}|3(?:[0-8]\\d|9[1-9]))\\d{4})", , , , "810123456"], [, , "(?:6\\d{6}|7[1-48]\\d{5}|9(?:6906(?:09|10)|7390\\d{2}))\\d{2}", , , , "612345678"], 
[, , "[89]00\\d{6}", , , , "800123456"], [, , "80[367]\\d{6}", , , , "803123456"], [, , "90[12]\\d{6}", , , , "901123456"], [, , "70\\d{7}", , , , "701234567"], [, , , , , , , , , [-1]], "ES", 34, "00", , , , , , , , [[, "([89]00)(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "([5-9]\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[568]|[79][0-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "51\\d{7}", , , , "511234567"], , , [, , , , , , , , , [-1]]], ET:[, [, , "[1-59]\\d{8}", 
, , , , , , [9], [7]], [, , "(?:11(?:1(?:1[124]|2[2-57]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:18|2[69]|39|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|22[0-6]|33[0134689]|44[04]|55[0-6]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:11[1-9]|22[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}", 
, , , "111112345", , , , [7]], [, , "9\\d{8}", , , , "911234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ET", 251, "00", "0", , , "0", , , , [[, "([1-59]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-59]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FI:[, [, , "1\\d{4,11}|[2-9]\\d{4,10}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]], [, 
, "1(?:[3569][1-8]\\d{3,9}|[47]\\d{5,10})|2[1-8]\\d{3,9}|3(?:[1-8]\\d{3,9}|9\\d{4,8})|[5689][1-8]\\d{3,9}", , , , "1312345678"], [, , "4(?:[0-8]\\d{4,9}|9\\d{3,8})|50\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10, 11]], [, , "800\\d{4,7}", , , , "8001234567", , , [7, 8, 9, 10]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FI", 358, "00|99(?:[02469]|5(?:11|33|5[59]|88|9[09]))", "0", , , "0", , "00", , [[, 
"(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[6-8])0"], "0$1"], [, "(75\\d{3})", "$1", ["75[12]"], "0$1"], [, "(116\\d{3})", "$1", ["116"], "$1"], [, "(\\d{2})(\\d{4,10})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], [, "(\\d)(\\d{4,11})", "$1 $2", ["[25689][1-8]|3"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , "[13]00\\d{3,7}|2(?:0(?:0\\d{3,7}|2[023]\\d{1,6}|9[89]\\d{1,6}))|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{3,7})", , , , "100123", , , [5, 6, 7, 8, 9, 10]], [, , "[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{3,7})", 
, , , "10112345", , , [5, 6, 7, 8, 9, 10]], , , [, , , , , , , , , [-1]]], FJ:[, [, , "[2-9]\\d{6}|0\\d{10}", , , , , , , [7, 11]], [, , "(?:3[0-5]\\d|6(?:03|[25-7]\\d)|8[58]\\d)\\d{4}", , , , "3212345", , , [7]], [, , "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", , , , "7012345", , , [7]], [, , "0800\\d{7}", , , , "08001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FJ", 679, "0(?:0|52)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", 
"$1 $2", ["[2-9]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FK:[, [, , "[2-7]\\d{4}", , , , , , , [5]], [, , "[2-47]\\d{4}", , , , "31234"], [, , "[56]\\d{4}", , , , "51234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FK", 500, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, 
, , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FM:[, [, , "[39]\\d{6}", , , , , , , [7]], [, , "3[2357]0[1-9]\\d{3}|9[2-6]\\d{5}", , , , "3201234"], [, , "3[2357]0[1-9]\\d{3}|9[2-7]\\d{5}", , , , "3501234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FM", 691, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , 
, , , , , , [-1]], , , [, , , , , , , , , [-1]]], FO:[, [, , "[2-9]\\d{5}", , , , , , , [6]], [, , "(?:20|[3-4]\\d|8[19])\\d{4}", , , , "201234"], [, , "(?:[27][1-9]|5\\d)\\d{4}", , , , "211234"], [, , "80[257-9]\\d{3}", , , , "802123"], [, , "90(?:[1345][15-7]|2[125-7]|99)\\d{2}", , , , "901123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:6[0-36]|88)\\d{4}", , , , "601234"], "FO", 298, "00", , , , "(10(?:01|[12]0|88))", , , , [[, "(\\d{6})", "$1", , , "$CC $1"]], , [, , , , , 
, , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FR:[, [, , "[1-9]\\d{8}", , , , , , , [9]], [, , "[1-5]\\d{8}", , , , "123456789"], [, , "(?:6\\d|7[3-9])\\d{7}", , , , "612345678"], [, , "80[0-5]\\d{6}", , , , "801234567"], [, , "89[1-357-9]\\d{6}", , , , "891123456"], [, , "8(?:1[0-29]|2[0156]|84|90)\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "9\\d{8}", , , , "912345678"], "FR", 33, "00", "0", , , "0", , , , [[, "([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4 $5", ["[1-79]"], "0$1"], [, "(1\\d{2})(\\d{3})", "$1 $2", ["11"], "$1"], [, "(8\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"]], [[, "([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"], [, "(8\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "80[6-9]\\d{6}", , , , "806123456"], , , [, , , , , , , , , [-1]]], GA:[, [, , "0?\\d{7}", , , , , , , [7, 8]], [, , "01\\d{6}", 
, , , "01441234", , , [8]], [, , "0?[2-7]\\d{6}", , , , "06031234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GA", 241, "00", , , , , , , , [[, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GB:[, [, , "\\d{7,10}", 
, , , , , , [7, 9, 10], [4, 5, 6, 8]], [, , "2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{7}|1(?:1(?:3[0-48]|[46][0-4]|5[0-26-9]|[78][0-49])|21[0-7]|31[0-8]|[4-69]1\\d)\\d{6}|1(?:2(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)|3(?:0\\d|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[28][02-57-9]|[37]\\d|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|2[024-9]|3[015689]|4[02-9]|5[03-9]|6\\d|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0124578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|8\\d|9[2-57]))\\d{6}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[345])))|3(?:638[2-5]|647[23]|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[123]))|5(?:24(?:3[2-79]|6\\d)|276\\d|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[567]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|955[0-4])|7(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|84(?:3[2-58]))|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}|176888[2-46-8]\\d{2}|16977[23]\\d{3}", 
, , , "1212345678", , , [9, 10], [4, 5, 6, 7, 8]], [, , "7(?:[1-3]\\d{3}|4(?:[0-46-9]\\d{2}|5(?:[0-689]\\d|7[0-57-9]))|5(?:0[0-8]|[13-9]\\d|2[0-35-9])\\d|7(?:0(?:0[01]|[1-9]\\d)|[1-7]\\d{2}|8[02-9]\\d|9[0-689]\\d)|8(?:[014-9]\\d|[23][0-8])\\d|9(?:[024-9]\\d{2}|1(?:[02-9]\\d|1[028])|3[0-689]\\d))\\d{5}", , , , "7400123456", , , [10]], [, , "80(?:0(?:1111|\\d{6,7})|8\\d{7})", , , , "8001234567"], [, , "(?:87[123]|9(?:[01]\\d|8[2349]))\\d{7}", , , , "9012345678", , , [10]], [, , "8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})", 
, , , "8431234567", , , [7, 10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , "56\\d{8}", , , , "5612345678", , , [10]], "GB", 44, "00", "0", " x", , "0", , , , [[, "(7\\d{3})(\\d{6})", "$1 $2", ["7(?:[1-57-9]|62)", "7(?:[1-57-9]|624)"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2|5[56]|7[06]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:[02-9]1|1)|3|9[018]"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", 
"1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], [, "(1\\d{3})(\\d{5,6})", "$1 $2", ["1"], "0$1"], [, "(800)(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], [, "(845)(46)(4\\d)", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], [, "(8\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8(?:4[2-5]|7[0-3])"], "0$1"], [, "(80\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1"], [, "(800)(\\d{6})", "$1 $2", ["800"], "0$1"]], , [, , "76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}", 
, , , "7640123456", , , [10]], 1, , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]], GD:[, [, , "[4589]\\d{9}", , , , , , , [10], [7]], [, , "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|68|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}", , , , "4732691234", , , , [7]], [, , "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}", , , , "4734031234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", 
, , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "GD", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "473", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GE:[, [, , "[34578]\\d{8}", , , , , , , [9], [6]], [, , "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}", , , 
, "322123456", , , , [6]], [, , "5(?:[14]4|5[0157-9]|68|7[0147-9]|9[0-35-9])\\d{6}", , , , "555123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "706\\d{6}", , , , "706123456"], "GE", 995, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5"]]], , [, , , , 
, , , , , [-1]], , , [, , "706\\d{6}", , , , "706123456"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GF:[, [, , "[56]\\d{8}", , , , , , , [9]], [, , "594(?:[023]\\d|1[01]|4[03-9]|5[6-9]|6[0-3]|80|9[014])\\d{4}", , , , "594101234"], [, , "694(?:[0-249]\\d|3[0-48])\\d{4}", , , , "694201234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GF", 594, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4", , "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GG:[, [, , "[135789]\\d{6,9}", , , , , , , [7, 9, 10], [6]], [, , "1481[25-9]\\d{5}", , , , "1481256789", , , [10], [6]], [, , "7(?:781\\d|839\\d|911[17])\\d{5}", , , , "7781123456", , , [10]], [, , "80(?:0(?:1111|\\d{6,7})|8\\d{7})", , , , "8001234567"], [, , "(?:87[123]|9(?:[01]\\d|8[0-3]))\\d{7}", , , , "9012345678", , , [10]], [, , "8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})", 
, , , "8431234567", , , [7, 10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , "56\\d{8}", , , , "5612345678", , , [10]], "GG", 44, "00", "0", , , "0", , , , , , [, , "76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}", , , , "7640123456", , , [10]], , , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]], GH:[, [, , "[235]\\d{8}|8\\d{7}", , , , , , , [8, 9], [7]], [, , "3(?:0(?:[237]\\d|80)|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", 
, , , "302345678", , , [9], [7]], [, , "(?:2[034678]\\d|5(?:[0457]\\d|6[01]))\\d{6}", , , , "231234567", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GH", 233, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "800\\d{5}", , , , "80012345", , , [8]], [, , , , , 
, , , , [-1]], , , [, , , , , , , , , [-1]]], GI:[, [, , "[256]\\d{7}", , , , , , , [8]], [, , "2(?:00\\d{2}|1(?:6[24-7]\\d|90[0-2])|2(?:2[2457]\\d|50[0-2]))\\d{3}", , , , "20012345"], [, , "(?:5[46-8]|62)\\d{6}", , , , "57123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GI", 350, "00", , , , , , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , 
, , , , , , [-1]], , , [, , , , , , , , , [-1]]], GL:[, [, , "[1-689]\\d{5}", , , , , , , [6]], [, , "(?:19|3[1-7]|6[14689]|8[14-79]|9\\d)\\d{4}", , , , "321000"], [, , "(?:[25][1-9]|4[2-9])\\d{4}", , , , "221234"], [, , "80\\d{4}", , , , "801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3[89]\\d{4}", , , , "381234"], "GL", 299, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GM:[, [, , "[2-9]\\d{6}", , , , , , , [7]], [, , "(?:4(?:[23]\\d{2}|4(?:1[024679]|[6-9]\\d))|5(?:54[0-7]|6(?:[67]\\d)|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}", , , , "5661234"], [, , "[23679]\\d{6}", , , , "3012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GM", 220, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , 
, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GN:[, [, , "[367]\\d{7,8}", , , , , , , [8, 9]], [, , "30(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])\\d{4}", , , , "30241234", , , [8]], [, , "6[02356]\\d{7}", , , , "601123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "722\\d{6}", , , , "722123456", , , [9]], "GN", 224, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4", ["3"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GP:[, [, , "[56]\\d{8}", , , , , , , [9]], [, , "590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}", , , , "590201234"], [, , "69(?:0\\d{2}|1(?:2[29]|3[0-5]))\\d{4}", , , , "690001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , 
, [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GP", 590, "00", "0", , , "0", , , , [[, "([56]\\d{2})(\\d{2})(\\d{4})", "$1 $2-$3", ["590|69[01]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GQ:[, [, , "[23589]\\d{8}", , , , , , , [9]], [, , "3(?:3(?:3\\d[7-9]|[0-24-9]\\d[46])|5\\d{2}[7-9])\\d{4}", , , , "333091234"], [, , "(?:222|55[15])\\d{6}", , , , "222123456"], [, , "80\\d[1-9]\\d{5}", , , , "800123456"], 
[, , "90\\d[1-9]\\d{5}", , , , "900123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GQ", 240, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GR:[, [, , "[26-9]\\d{9}", , , , , , , [10]], [, , "2(?:1\\d{2}|2(?:2[1-46-9]|3[1-8]|4[1-7]|5[1-4]|6[1-8]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|3[1245]|4[1-7]|5[13-9]|[269][1-6]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", 
, , , "2123456789"], [, , "6(?:8[57-9]|9\\d)\\d{7}", , , , "6912345678"], [, , "800\\d{7}", , , , "8001234567"], [, , "90[19]\\d{7}", , , , "9091234567"], [, , "8(?:0[16]|12|25)\\d{7}", , , , "8011234567"], [, , "70\\d{8}", , , , "7012345678"], [, , , , , , , , , [-1]], "GR", 30, "00", , , , , , , , [[, "([27]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[2-9]1|[689]"]], [, "(2\\d{3})(\\d{6})", "$1 $2", ["2[2-9][02-9]"]]], , [, , , , , , , , , [-1]], 
, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GT:[, [, , "[2-7]\\d{7}|1[89]\\d{9}", , , , , , , [8, 11]], [, , "[267][2-9]\\d{6}", , , , "22456789", , , [8]], [, , "[345]\\d{7}", , , , "51234567", , , [8]], [, , "18[01]\\d{8}", , , , "18001112222", , , [11]], [, , "19\\d{9}", , , , "19001112222", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GT", 502, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], 
[, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GU:[, [, , "[5689]\\d{9}", , , , , , , [10], [7]], [, , "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[079]7|2[0167]|3[45]|47|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", , , , "6713001234", , , , [7]], [, , "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[079]7|2[0167]|3[45]|47|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", 
, , , "6713001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "GU", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "671", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GW:[, [, , "(?:4(?:0\\d{5}|4\\d{7})|9\\d{8})", , , , , , , [7, 9]], [, 
, "443\\d{6}", , , , "443201234", , , [9]], [, , "9(?:5\\d|6[569]|77)\\d{6}", , , , "955012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "40\\d{5}", , , , "4012345", , , [7]], "GW", 245, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["44|9[5-7]"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["40"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 
GY:[, [, , "[2-46-9]\\d{6}", , , , , , , [7]], [, , "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}", , , , "2201234"], [, , "6\\d{6}", , , , "6091234"], [, , "(?:289|862)\\d{4}", , , , "2891234"], [, , "9008\\d{3}", , , , "9008123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GY", 592, "001", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], HK:[, [, , "[2-7]\\d{7}|8[0-3]\\d{6,7}|9\\d{4,10}", , , , , , , [5, 6, 7, 8, 9, 11]], [, , "(?:2(?:[13-8]\\d|2[013-9]|9[0-24-9])\\d|3(?:[1569][0-24-9]\\d|4[0-246-9]\\d|7[0-24-69]\\d|8(?:40|9\\d))|58(?:0[1-8]|1[2-9]))\\d{4}", , , , "21234567", , , [8]], [, , "(?:46(?:0[0-6]|4[07-9])|5(?:[1-59][0-46-9]\\d|6[0-4689]\\d|7(?:[0-2469]\\d|30))|6(?:0[1-9]\\d|[1459]\\d{2}|2(?:[0-57-9]\\d|6[01])|[368][0-57-9]\\d|7[0-79]\\d)|9(?:0[1-9]\\d|1[02-9]\\d|2(?:[0-8]\\d|9[03-9])|[358][0-8]\\d|[467]\\d{2}))\\d{4}", 
, , , "51234567", , , [8]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "900(?:[0-24-9]\\d{7}|3\\d{1,4})", , , , "90012345678", , , [5, 6, 7, 8, 11]], [, , , , , , , , , [-1]], [, , "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", , , , "81123456", , , [8]], [, , , , , , , , , [-1]], "HK", 852, "00(?:[126-9]|30|5[09])?", , , , , , "00", , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|[89](?:0[1-9]|[1-9])"]], [, "(800)(\\d{3})(\\d{3})", "$1 $2 $3", ["800"]], [, "(900)(\\d{2})(\\d{3})(\\d{3})", 
"$1 $2 $3 $4", ["900"]], [, "(900)(\\d{2,5})", "$1 $2", ["900"]]], , [, , "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", , , , "71123456", , , [8]], , , [, , , , , , , , , [-1]], [, , "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", , , , "30161234", , , [8]], , , [, , , , , , , , , [-1]]], HN:[, 
[, , "[237-9]\\d{7}", , , , , , , [8]], [, , "2(?:2(?:0[019]|1[1-36]|[23]\\d|4[04-6]|5[57]|7[013689]|8[0146-9]|9[012])|4(?:07|2[3-59]|3[13-689]|4[0-68]|5[1-35])|5(?:16|4[03-5]|5\\d|6[4-6]|74)|6(?:[056]\\d|17|3[04]|4[0-378]|[78][0-8]|9[01])|7(?:6[46-9]|7[02-9]|8[034])|8(?:79|8[0-35789]|9[1-57-9]))\\d{4}", , , , "22123456"], [, , "[37-9]\\d{7}", , , , "91234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "HN", 
504, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1-$2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], HR:[, [, , "[1-7]\\d{5,8}|[89]\\d{6,8}", , , , , , , [6, 7, 8, 9]], [, , "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", , , , "12345678", , , [8, 9], [6, 7]], [, , "9(?:01\\d|[1259]\\d{2}|7(?:[0679]\\d|51)|8\\d{1,2})\\d{5}", , , , "921234567", , , [8, 9]], [, , "80[01]\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, 
, "6(?:[01]\\d{0,2}|[459]\\d{2})\\d{4}", , , , "611234", , , [6, 7, 8]], [, , , , , , , , , [-1]], [, , "7[45]\\d{6}", , , , "74123456", , , [8]], [, , , , , , , , , [-1]], "HR", 385, "00", "0", , , "0", , , , [[, "(1)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], [, "([2-5]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], [, "(9\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(6[01])(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], [, "([67]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], 
"0$1"], [, "(80[01])(\\d{2})(\\d{2,3})", "$1 $2 $3", ["80[01]"], "0$1"], [, "(80[01])(\\d{3})(\\d{3})", "$1 $2 $3", ["80[01]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:62\\d?|72)\\d{6}", , , , "62123456", , , [8, 9]], , , [, , , , , , , , , [-1]]], HT:[, [, , "[2-489]\\d{7}", , , , , , , [8]], [, , "2(?:2\\d|5[1-5]|81|9[149])\\d{5}", , , , "22453300"], [, , "[34]\\d{7}", , , , "34101234"], [, , "8\\d{7}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , 
, , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:9(?:[67][0-4]|8[0-3589]|9\\d))\\d{5}", , , , "98901234"], "HT", 509, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], HU:[, [, , "[1-9]\\d{7,8}", , , , , , , [8, 9], [6]], [, , "(?:1\\d|2[2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|7[2-9]|8[2-57-9]|9[2-69])\\d{6}", , , , "12345678", , , [8], [6]], [, , "(?:[257]0|3[01])\\d{7}", 
, , , "201234567", , , [9]], [, , "[48]0\\d{6}", , , , "80123456", , , [8]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "21\\d{7}", , , , "211234567", , , [9]], "HU", 36, "00", "06", , , "06", , , , [[, "(1)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "($1)"]], , [, , , , , , , , , [-1]], , , [, , "[48]0\\d{6}", , , , "80123456", , , [8]], [, , "38\\d{7}", , , , "381234567", , , 
[9]], , , [, , , , , , , , , [-1]]], ID:[, [, , "(?:[1-79]\\d{6,10}|8\\d{7,11})", , , , , , , [7, 8, 9, 10, 11, 12], [5, 6]], [, , "2(?:1(?:14\\d{3}|500\\d{3}|\\d{7,8})|2\\d{6,8}|4\\d{7,8})|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:19?|[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", 
, , , "612345678", , , [7, 8, 9, 10, 11], [5, 6]], [, , "(?:2(?:1(?:3[145]|4[01]|5[1-469]|60|8[0359])|2(?:88|9[1256])|3[1-4]9|4(?:36|91)|5(?:1[349]|[2-4]9)|6[0-7]9|7(?:[1-36]9|4[39])|8[1-5]9|9[1-48]9)|3(?:19[1-3]|2[12]9|3[13]9|4(?:1[69]|39)|5[14]9|6(?:1[69]|2[89])|709)|4[13]19|5(?:1(?:19|8[39])|4[129]9|6[12]9)|6(?:19[12]|2(?:[23]9|77))|7(?:1[13]9|2[15]9|419|5(?:1[89]|29)|6[15]9|7[178]9))\\d{5,6}|8[1-35-9]\\d{7,10}", , , , "812345678", , , [9, 10, 11, 12]], [, , "177\\d{6,8}|800\\d{5,7}", , , , "8001234567", 
, , [8, 9, 10, 11]], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , "804\\d{7}", , , , "8041234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ID", 62, "0(?:0[1789]|10(?:00|1[67]))", "0", , , "0", , , , [[, "(\\d{2})(\\d{5,8})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [, "(\\d{3})(\\d{5,8})", "$1 $2", ["2[035-9]|[36][02-9]|[4579]"], "(0$1)"], [, "(8\\d{2})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(8\\d{2})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8[1-35-9]"], 
"0$1"], [, "(1)(500)(\\d{3})", "$1 $2 $3", ["150", "1500"], "$1"], [, "(177)(\\d{6,8})", "$1 $2", ["177"], "0$1"], [, "(800)(\\d{5,7})", "$1 $2", ["800"], "0$1"], [, "(804)(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(80\\d)(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80[79]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "8071\\d{6}", , , , "8071123456", , , [10]], [, , "1500\\d{3}|8071\\d{6}", , , , "8071123456", , , [7, 10]], , , [, , , , , , , , , [-1]]], IE:[, [, , "[124-9]\\d{6,9}", , , 
, , , , [7, 8, 9, 10], [5, 6]], [, , "1\\d{7,8}|2(?:1\\d{6,7}|3\\d{7}|[24-9]\\d{5})|4(?:0[24]\\d{5}|[1-469]\\d{7}|5\\d{6}|7\\d{5}|8[0-46-9]\\d{7})|5(?:0[45]\\d{5}|1\\d{6}|[23679]\\d{7}|8\\d{5})|6(?:1\\d{6}|[237-9]\\d{5}|[4-6]\\d{7})|7[14]\\d{7}|9(?:1\\d{6}|[04]\\d{7}|[35-9]\\d{5})", , , , "2212345", , , , [5, 6]], [, , "8(?:22\\d{6}|[35-9]\\d{7})", , , , "850123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , "15(?:1[2-8]|[2-8]0|9[089])\\d{6}", , , , "1520123456", , , [10]], 
[, , "18[59]0\\d{6}", , , , "1850123456", , , [10]], [, , "700\\d{6}", , , , "700123456", , , [9]], [, , "76\\d{7}", , , , "761234567", , , [9]], "IE", 353, "00", "0", , , "0", , , , [[, "(1)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], [, "(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["40[24]|50[45]"], "(0$1)"], [, "(48)(\\d{4})(\\d{4})", "$1 $2 $3", ["48"], "(0$1)"], [, "(818)(\\d{3})(\\d{3})", "$1 $2 $3", ["818"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", 
"$1 $2 $3", ["[24-69]|7[14]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["76|8[35-9]"], "0$1"], [, "(8\\d)(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8[35-9]5"], "0$1"], [, "(700)(\\d{3})(\\d{3})", "$1 $2 $3", ["700"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:5|8[059])", "1(?:5|8[059]0)"], "$1"]], , [, , , , , , , , , [-1]], , , [, , "18[59]0\\d{6}", , , , "1850123456", , , [10]], [, , "818\\d{6}", , , , "818123456", , , [9]], , , [, , "8[35-9]5\\d{7}", , , , "8551234567", 
, , [10]]], IL:[, [, , "1\\d{6,11}|[2-589]\\d{3}(?:\\d{3,6})?|6\\d{3}|7\\d{6,9}", , , , , , , [4, 7, 8, 9, 10, 11, 12]], [, , "(?:153\\d{1,2}|[2-489])\\d{7}", , , , "21234567", , , [8, 11, 12], [7]], [, , "5(?:[0-47-9]\\d{2}|5(?:01|2[23]|3[2-4]|4[45]|5[5689]|6[6-8]|7[0178]|8[6-9]|9[2-9])|6[2-9]\\d)\\d{5}", , , , "501234567", , , [9]], [, , "1(?:80[019]\\d{3}|255)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "1(?:212|(?:9(?:0[01]|19)|200)\\d{2})\\d{4}", , , , "1919123456", , , [8, 9, 10]], [, , 
"1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , "7(?:18\\d|2[23]\\d|3[237]\\d|47\\d|6[58]\\d|7\\d{2}|8(?:2\\d|33|55|77|81)|9[2579]\\d)\\d{5}", , , , "771234567", , , [9]], "IL", 972, "0(?:0|1[2-9])", "0", , , "0", , , , [[, "([2-489])(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], [, "([57]\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], [, "(153)(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["153"]], [, "(1)([7-9]\\d{2})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], 
[, "(1255)(\\d{3})", "$1-$2", ["125", "1255"]], [, "(1200)(\\d{3})(\\d{3})", "$1-$2-$3", ["120", "1200"]], [, "(1212)(\\d{2})(\\d{2})", "$1-$2-$3", ["121", "1212"]], [, "(1599)(\\d{6})", "$1-$2", ["159", "1599"]], [, "(151)(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["151"]], [, "(\\d{4})", "*$1", ["[2-689]"]]], , [, , , , , , , , , [-1]], , , [, , "1700\\d{6}|[2-689]\\d{3}", , , , "1700123456", , , [4, 10]], [, , "[2-689]\\d{3}|1599\\d{6}", , , , "1599123456", , , [4, 10]], , , [, , "151\\d{8,9}", 
, , , "15112340000", , , [11, 12]]], IM:[, [, , "[135789]\\d{6,9}", , , , , , , [10], [6]], [, , "1624[5-8]\\d{5}", , , , "1624756789", , , , [6]], [, , "7(?:4576|[59]24\\d|624[0-4689])\\d{5}", , , , "7924123456"], [, , "808162\\d{4}", , , , "8081624567"], [, , "(?:872299|90[0167]624)\\d{4}", , , , "9016247890"], [, , "8(?:4(?:40[49]06|5624\\d)|70624\\d)\\d{3}", , , , "8456247890"], [, , "70\\d{8}", , , , "7012345678"], [, , "56\\d{8}", , , , "5612345678"], "IM", 44, "00", "0", , , "0", , , , , , 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "3(?:08162\\d|3\\d{5}|4(?:40[49]06|5624\\d)|7(?:0624\\d|2299\\d))\\d{3}|55\\d{8}", , , , "5512345678"], , , [, , , , , , , , , [-1]]], IN:[, [, , "008\\d{9}|1\\d{7,12}|[2-9]\\d{9,10}", , , , , , , [8, 9, 10, 11, 12, 13], [6, 7]], [, , "(?:11|2[02]|33|4[04]|79|80)[2-7]\\d{7}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|[36][25]|22|4[28]|5[12]|[78]1|9[15])|6(?:12|[2345]1|57|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[13-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1-5]|4[25-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|[57][2-689]|6[24-578]|8[1-6])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d|7(?:(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|9\\d)\\d|8(?:2[0-6]|[013-8]\\d)))[2-7]\\d{5}", 
, , , "1123456789", , , [10], [6, 7, 8]], [, , "(?:6(?:00[0-35]\\d|1279|2(?:0[0-3]|3[59]|6[0-2]|8[0-2]|9[045])\\d|3(?:0[0-29]\\d|5(?:0[0-6]|[1-3]\\d)|6[01]\\d|7[015]\\d|8[0-2]\\d|9[023-69]\\d)|900\\d)|7(?:0\\d{3}|19[0-5]\\d|2(?:[0235679]\\d{2}|[14][017-9]\\d|8(?:[0-59]\\d|[678][089]))|3(?:[05-8]\\d{2}|1(?:[089]\\d|11|7[5-8])|2(?:[0-49][089]|[5-8]\\d)|3[017-9]\\d|4(?:[07-9]\\d|11)|9(?:[016-9]\\d|[2-5][089]))|4(?:0\\d{2}|1(?:[015-9]\\d|[23][089]|4[089])|2(?:0[089]|[1-7][089]|[89]\\d)|3(?:[0-8][089]|9\\d)|4(?:[089]\\d|11|7[02-8])|[56]\\d[089]|7(?:[089]\\d|11|7[02-8])|8(?:[0-24-7][089]|[389]\\d)|9(?:[0-6][089]|7[089]|[89]\\d))|5(?:[0346-8]\\d{2}|1(?:[07-9]\\d|11)|2(?:[04-9]\\d|[123][089])|5[017-9]\\d|9(?:[0-6][089]|[7-9]\\d))|6(?:0(?:[0-47]\\d|[5689][089])|(?:1[0-257-9]|[6-9]\\d)\\d|2(?:[0-4]\\d|[5-9][089])|3(?:[02-8][089]|[19]\\d)|4\\d[089]|5(?:[0-367][089]|[4589]\\d))|7(?:0(?:0[02-9]|[13-7][089]|[289]\\d)|[1-9]\\d{2})|8(?:[0-79]\\d{2}|8(?:[089]\\d|11|7[02-9]))|9(?:[089]\\d{2}|313|7(?:[02-8]\\d|9[07-9])))|8(?:0(?:[01589]\\d{2}|6[67]\\d|7(?:[02-8]\\d|9[04-9]))|1(?:[02-57-9]\\d{2}|1(?:[0-35-9]\\d|4[0-46-9])|6(?:[089]\\d|7[02-8]))|2(?:0(?:[089]\\d|7[02-8])|[14](?:[089]\\d|7[02-8])|[235-9]\\d{2})|3(?:[0357-9]\\d{2}|1(?:[089]\\d|7[02-7])|2(?:[09]\\d|7[02-8]|8[0-689])|4\\d{2}|6(?:[089]\\d|7[02-7]))|[45]\\d{3}|6(?:[02457-9]\\d{2}|1(?:[089]\\d|7[02-8])|3(?:[089]\\d|7[02-8])|6(?:[08]\\d|7[02-8]|9\\d))|7(?:0[07-9]\\d|[1-69]\\d{2}|[78](?:[089]\\d|7[02-8]))|8(?:[0-25-9]\\d{2}|3(?:[089]\\d|7[02-8])|4(?:[0489]\\d|7[02-8]))|9(?:[02-9]\\d{2}|1(?:[0289]\\d|7[02-8])))|9\\d{4})\\d{5}", 
, , , "8123456789", , , [10]], [, , "00800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))", , , , "1800123456"], [, , "186[12]\\d{9}", , , , "1861123456789", , , [13]], [, , "1860\\d{7}", , , , "18603451234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IN", 91, "00", "0", , , "0", , , , [[, "(\\d{8})", "$1", ["561", "5616", "56161"], "$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["6(?:[09]0|12|2[03689]|3[05-9])|7(?:[02-8]|19|9[037-9])|8(?:0[015-9]|[1-9])|9", "6(?:[09]0|127|2(?:0[013]|3[59]|[68][0-2]|9[04])|3(?:0[0-29]|5[0-3]|6[01]|7[015]|8[12]|9[02-69]))|7(?:[07]|19[0-5]|2(?:[0235-9]|[14][017-9])|3(?:[025-9]|[134][017-9])|4(?:[0-35689]|[47][017-9])|5(?:[02-46-9]|[15][017-9])|6(?:[02-9]|1[0-257-9])|8(?:[0-79]|8[0189])|9(?:[089]|31|7[02-9]))|8(?:0(?:[01589]|6[67]|7[02-9])|1(?:[0-57-9]|6[07-9])|2(?:[014][07-9]|[235-9])|3(?:[03-57-9]|[126][07-9])|[45]|6(?:[02457-9]|[136][07-9])|7(?:[078][07-9]|[1-69])|8(?:[0-25-9]|3[07-9]|4[047-9])|9(?:[02-9]|1[027-9]))|9", 
"6(?:[09]0|1279|2(?:0[013]|3[59]|[68][0-2]|9[04])|3(?:0[0-29]|5[0-3]|6[01]|7[015]|8[12]|9[02-69]))|7(?:0|19[0-5]|2(?:[0235-79]|[14][017-9]|8(?:[0-69]|[78][089]))|3(?:[05-8]|1(?:[0189]|7[5-9])|2(?:[0-49][089]|[5-8])|3[017-9]|4(?:[07-9]|11)|9(?:[01689]|[2-5][089]|7[0189]))|4(?:[056]|1(?:[0135-9]|[24][089])|[29](?:[0-7][089]|[89])|3(?:[0-8][089]|9)|[47](?:[089]|11|7[02-8])|8(?:[0-24-7][089]|[389]))|5(?:[0346-9]|[15][017-9]|2(?:[03-9]|[12][089]))|6(?:[0346-9]|1[0-257-9]|2(?:[0-4]|[5-9][089])|5(?:[0-367][089]|[4589]))|7(?:0(?:[02-9]|1[089])|[1-9])|8(?:[0-79]|8(?:0[0189]|11|8[013-9]|9))|9(?:[089]|313|7(?:[02-8]|9[07-9])))|8(?:0(?:[01589]|6[67]|7(?:[02-8]|9[04-9]))|1(?:[02-57-9]|1(?:[0-35-9]|4[0-46-9])|6(?:[089]|7[02-8]))|2(?:[014](?:[089]|7[02-8])|[235-9])|3(?:[03-57-9]|[16](?:[089]|7[02-7])|2(?:[09]|7[02-8]|8[0-689]))|[45]|6(?:[02457-9]|[136](?:[089]|7[02-8]))|7(?:0[07-9]|[1-69]|[78](?:[089]|7[02-8]))|8(?:[0-25-9]|3(?:[089]|7[02-8])|4(?:[0489]|7[02-8]))|9(?:[02-9]|1(?:[0289]|7[02-8])))|9"], 
"0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-9]|80[2-46]"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[59][14]|[68][1-9]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1|9[15])|6(?:12|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)"], 
"0$1", , 1], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[23579]|[468][1-9])|[2-8]"], "0$1", , 1], [, "(\\d{2})(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3 $4", ["008"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], "$1", , 1], [, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["160", "1600"], "$1", , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], "$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["180", "1800"], "$1", , 1], [, "(\\d{4})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["186", 
"1860"], "$1", , 1], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18[06]"], "$1", , 1]], , [, , , , , , , , , [-1]], , , [, , "00800\\d{7}|1(?:600\\d{6}|8(?:0(?:0\\d{4,9}|3\\d{9})|6(?:0\\d{7}|[12]\\d{9})))", , , , "1800123456"], [, , "140\\d{7}", , , , "1409305260", , , [10]], , , [, , , , , , , , , [-1]]], IO:[, [, , "3\\d{6}", , , , , , , [7]], [, , "37\\d{5}", , , , "3709100"], [, , "38\\d{5}", , , , "3801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , 
[-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IO", 246, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], IQ:[, [, , "[1-7]\\d{7,9}", , , , , , , [8, 9, 10], [6, 7]], [, , "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", , , , "12345678", , , [8, 9], [6, 7]], [, , "7[3-9]\\d{8}", , , , "7912345678", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , 
[-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IQ", 964, "00", "0", , , "0", , , , [[, "(1)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "([2-6]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], [, "(7\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], IR:[, [, , "[1-8]\\d{5,9}|9(?:[0-4]\\d{8}|9\\d{8})", , , , , , , [6, 7, 10], [4, 5, 
8]], [, , "(?:(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:\\d{8}|(?:[16]|[289]\\d?)\\d{3}))|94(?:000|11[0-7]|2\\d{2}|30[01]|440)\\d{5}", , , , "2123456789", , , , [4, 5, 8]], [, , "9(?:0(?:[1-35]\\d{2}|44\\d)|[13]\\d{3}|2[0-2]\\d{2}|9(?:[01]\\d{2}|44\\d|810|9(?:0[013]|1[134]|21|9[89])))\\d{5}", , , , "9123456789", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:[2-6]0\\d|993)\\d{7}", , , , "9932123456", 
, , [10]], "IR", 98, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"], [, "(\\d{2})(\\d{4,5})", "$1 $2", ["[1-8]"], "0$1"], [, "(\\d{4,5})", "$1", ["96"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "(?:9411[1-7]|94440)\\d{5}", , , , "9411110000", , , [10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], IS:[, [, , "[4-9]\\d{6}|38\\d{7}", , , , , , , [7, 9]], [, , "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-245]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-79]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|87[23])\\d{4}", 
, , , "4101234", , , [7]], [, , "38[589]\\d{6}|(?:6(?:1[1-8]|2[0-6]|3[027-9]|4[014679]|5[0159]|[67][0-69]|8[06-8]|9\\d)|7(?:5[057]|[6-8]\\d)|8(?:2[0-59]|[3469]\\d|5[1-9]|88))\\d{4}", , , , "6111234"], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , "90\\d{5}", , , , "9011234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "49\\d{5}", , , , "4921234", , , [7]], "IS", 354, "1(?:0(?:01|10|20)|100)|00", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], [, "(3\\d{2})(\\d{3})(\\d{3})", 
"$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "809\\d{4}", , , , "8091234", , , [7]], , , [, , "(?:6(?:2[78]|8[1-59])|8(?:7[0189]|80)|95[48])\\d{4}", , , , "6271234", , , [7]]], IT:[, [, , "[01589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9})", , , , , , , [6, 7, 8, 9, 10, 11]], [, , "0(?:[26]\\d{4,9}|(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2346]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[34578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7})", 
, , , "0212345678"], [, , "3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})", , , , "3123456789", , , [9, 10, 11]], [, , "80(?:0\\d{6}|3\\d{3})", , , , "800123456", , , [6, 9]], [, , "0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{6}|[17]\\d{3})", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], 
"IT", 39, "00", , , , , , , , [[, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|55"]], [, "(0[26])(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [, "(0[26])(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(0\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[245])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]], [, "(0\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["0[13-57-9][2-46-8]"]], [, "(0\\d{3})(\\d{2,6})", "$1 $2", ["0[13-57-9][2-46-8]"]], 
[, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13]|8(?:00|4[08]|9[59])", "[13]|8(?:00|4[08]|9(?:5[5-9]|9))"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["894", "894[5-9]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], 1, , [, , "848\\d{6}", , , , "848123456", , , [9]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], JE:[, [, , "[135789]\\d{6,9}", , , , , , , [10], [6]], [, , "1534[0-24-8]\\d{5}", , , , "1534456789", , , , [6]], [, , "7(?:509\\d|7(?:00[378]|97[7-9])|829\\d|937\\d)\\d{5}", 
, , , "7797712345"], [, , "80(?:07(?:35|81)|8901)\\d{4}", , , , "8007354567"], [, , "(?:871206|90(?:066[59]|1810|71(?:07|55)))\\d{4}", , , , "9018105678"], [, , "8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|70002)\\d{4}", , , , "8447034567"], [, , "701511\\d{4}", , , , "7015115678"], [, , "56\\d{8}", , , , "5612345678"], "JE", 44, "00", "0", , , "0", , , , , , [, , "76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}", , , , "7640123456"], , , [, , , , , , , , , [-1]], [, , "3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))\\d{4}|55\\d{8}", 
, , , "5512345678"], , , [, , , , , , , , , [-1]]], JM:[, [, , "[589]\\d{9}", , , , , , , [10], [7]], [, , "876(?:5(?:0[12]|1[0-468]|2[35]|63)|6(?:0[1-3579]|1[0237-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468]))\\d{4}", , , , "8765123456", , , , [7]], [, , "876(?:2[14-9]\\d|[348]\\d{2}|5(?:0[3-9]|[2-57-9]\\d|6[0-24-9])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579]))\\d{4}", , , , "8762101234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", 
, , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "JM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "876", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], JO:[, [, , "[235-9]\\d{7,8}", , , , , , , [8, 9]], [, , "(?:2(?:6(?:2[0-35-9]|3[0-57-8]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[57][023]|6[03])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2[50]0|3(?:00|33)|4(?:0[0125]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[17-8]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[02-39]))|87(?:[02]0|7[08]|90))\\d{4}", 
, , , "62001234", , , [8]], [, , "7(?:55[0-49]|7[025-9]\\d|8[0-25-9]\\d|9[0-25-9]\\d)\\d{5}", , , , "790123456", , , [9]], [, , "80\\d{6}", , , , "80012345", , , [8]], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , "85\\d{6}", , , , "85012345", , , [8]], [, , "70\\d{7}", , , , "700123456", , , [9]], [, , , , , , , , , [-1]], "JO", 962, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], [, "(7)(\\d{4})(\\d{4})", "$1 $2 $3", ["7[457-9]"], "0$1"], [, "(\\d{2})(\\d{7})", 
"$1 $2", ["70"], "0$1"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["8[0158]|9"], "0$1"]], , [, , "74(?:66|77)\\d{5}", , , , "746612345", , , [9]], , , [, , , , , , , , , [-1]], [, , "8(?:10|8\\d)\\d{5}", , , , "88101234", , , [8]], , , [, , , , , , , , , [-1]]], JP:[, [, , "[1-9]\\d{8,9}|00(?:[36]\\d{7,14}|7\\d{5,7}|8\\d{7})", , , , , , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|2[2-9]\\d|[36][1-9]\\d|4(?:6[02-8]|[2-578]\\d|9[2-59])|5(?:6[1-9]|7[2-8]|[2-589]\\d)|7(?:3[4-9]|4[02-9]|[25-9]\\d)|8(?:3[2-9]|4[5-9]|5[1-9]|8[03-9]|[2679]\\d)|9(?:[679][1-9]|[2-58]\\d))\\d{6}", 
, , , "312345678", , , [9]], [, , "[7-9]0[1-9]\\d{7}", , , , "9012345678", , , [10]], [, , "120\\d{6}|800\\d{7}|00(?:37\\d{6,13}|66\\d{6,13}|777(?:[01]\\d{2}|5\\d{3}|8\\d{4})|882[1245]\\d{4})", , , , "120123456"], [, , "990\\d{6}", , , , "990123456", , , [9]], [, , , , , , , , , [-1]], [, , "60\\d{7}", , , , "601234567", , , [9]], [, , "50[1-9]\\d{7}", , , , "5012345678", , , [10]], "JP", 81, "010", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", 
"$1-$2-$3", ["800"], "0$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["007", "0077"], "$1"], [, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["007", "0077"], "$1"], [, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["008", "0088"], "$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["00[36]", "00(?:37|66)"], "$1"], [, "(\\d{4})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["00[36]", "00(?:37|66)"], "$1"], [, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["00[36]", "00(?:37|66)"], "$1"], [, "(\\d{4})(\\d{6})(\\d{6,7})", "$1-$2-$3", 
["00[36]", "00(?:37|66)"], "$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[2579]0|80[1-9]"], "0$1"], [, "(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])", "1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))", "1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[2-57-9])|9(?:496|802|9(?:1[23]|69))"], 
"0$1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])", "1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:[3-6][2-9]|7[2-6]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|4[2-69]|[5-7]))", 
"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6[56]))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))", 
"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6(?:5[25]|60)))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"], 
"0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93)", "1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])", "1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93(?:31|4))"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{4})", 
"$1-$2-$3", ["2(?:[34]7|[56]9|74|9[14-79])|82|993"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2479][1-9]"], "0$1"]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[2579]0|80[1-9]"], "0$1"], [, "(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])", 
"1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))", "1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[2-57-9])|9(?:496|802|9(?:1[23]|69))"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])", 
"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:[3-6][2-9]|7[2-6]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|4[2-69]|[5-7]))", 
"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6[56]))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))", 
"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6(?:5[25]|60)))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"], 
"0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93)", "1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])", "1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93(?:31|4))"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{4})", 
"$1-$2-$3", ["2(?:[34]7|[56]9|74|9[14-79])|82|993"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2479][1-9]"], "0$1"]], [, , "20\\d{8}", , , , "2012345678", , , [10]], , , [, , "00(?:37\\d{6,13}|66\\d{6,13}|777(?:[01]\\d{2}|5\\d{3}|8\\d{4})|882[1245]\\d{4})", , , , "00777012"], [, , "570\\d{6}", , , , "570123456", , , [9]], , , [, , , , , , , , , [-1]]], KE:[, [, , "20\\d{6,7}|[4-9]\\d{6,9}", , , , , , , [7, 
8, 9, 10]], [, , "20\\d{6,7}|4(?:0\\d{6,7}|[136]\\d{7}|[245]\\d{5,7})|5(?:[08]\\d{7}|[1-79]\\d{5,7})|6(?:[01457-9]\\d{5,7}|2\\d{7}|6\\d{6,7})", , , , "202012345", , , [7, 8, 9]], [, , "7(?:[0-3679]\\d|4[0-46-9]|5[0-6]|8[0-25-9])\\d{6}", , , , "712123456", , , [9]], [, , "800[24-8]\\d{5,6}", , , , "800223456", , , [9, 10]], [, , "900[02-9]\\d{5}", , , , "900223456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KE", 254, "000", "0", , , "005|0", , , , [[, 
"(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KG:[, [, , "[235-8]\\d{8,9}", , , , , , , [9, 10], [5, 6]], [, , "(?:3(?:1(?:[256]\\d|3[1-9]|47)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", 
, , , "312123456", , , [9], [5, 6]], [, , "(?:20[0-35]|5[0-24-7]\\d|7(?:[07]\\d|55))\\d{6}", , , , "700123456", , , [9]], [, , "800\\d{6,7}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KG", 996, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[25-7]|31[25]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[36]|[2-9])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d)(\\d{3})", "$1 $2 $3 $4", ["8"], "0$1"]], 
, [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KH:[, [, , "[1-9]\\d{7,9}", , , , , , , [8, 9, 10], [6, 7]], [, , "(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:[237-9]|4[56]|5\\d|6\\d?)\\d{5}|23(?:4[234]|8\\d{2})\\d{4}", , , , "23756789", , , [8, 9], [6, 7]], [, , "(?:1(?:[013-79]\\d|[28]\\d{1,2})|2[3-6]48|3(?:[18]\\d{2}|[2-6]48)|4[2-4]48|5[2-5]48|6(?:[016-9]\\d|[2-5]48)|7(?:[07-9]\\d|[16]\\d{2}|[2-5]48)|8(?:[013-79]\\d|8\\d{2})|9(?:6\\d{2}|7\\d{1,2}|[0-589]\\d))\\d{5}", 
, , , "91234567", , , [8, 9]], [, , "1800(?:1\\d|2[019])\\d{4}", , , , "1800123456", , , [10]], [, , "1900(?:1\\d|2[09])\\d{4}", , , , "1900123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KH", 855, "00[14-9]", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1\\d[1-9]|[2-9]"], "0$1"], [, "(1[89]00)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[89]0", "1[89]00"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , 
[-1]], , , [, , , , , , , , , [-1]]], KI:[, [, , "[2458]\\d{4}|3\\d{4,7}|[67]\\d{7}", , , , , , , [5, 8]], [, , "(?:[24]\\d|3[1-9]|50|8[0-5])\\d{3}|(?:65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d{2}|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500)))\\d{3}", , , , "31234"], [, , "(?:6(?:200[01]|30[01]\\d)|7(?:200[01]|3(?:0[0-5]\\d|140)))\\d{3}", , , , "72001234", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "30(?:0[01]\\d{2}|12(?:11|20))\\d{2}", 
, , , "30010000", , , [8]], "KI", 686, "00", , , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KM:[, [, , "[3478]\\d{6}", , , , , , , [7]], [, , "7[4-7]\\d{5}", , , , "7712345"], [, , "[34]\\d{6}", , , , "3212345"], [, , , , , , , , , [-1]], [, , "8\\d{6}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KM", 269, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", 
"$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KN:[, [, , "[589]\\d{9}", , , , , , , [10], [7]], [, , "869(?:2(?:29|36)|302|4(?:6[015-9]|70))\\d{4}", , , , "8692361234", , , , [7]], [, , "869(?:5(?:5[6-8]|6[5-7])|66\\d|76[02-7])\\d{4}", , , , "8697652917", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", 
, , , "5002345678"], [, , , , , , , , , [-1]], "KN", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "869", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KP:[, [, , "1\\d{9}|[28]\\d{7}", , , , , , , [8, 10], [6, 7]], [, , "2\\d{7}|85\\d{6}", , , , "21234567", , , [8], [6, 7]], [, , "19[123]\\d{7}", , , , "1921234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , 
, , [-1]], "KP", 850, "00|99", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "2(?:[0-24-9]\\d{2}|3(?:[0-79]\\d|8[02-9]))\\d{4}", , , , "23821234", , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KR:[, [, , "00(?:3\\d{8,9}|7\\d{9,11})|[1-7]\\d{4,9}|8\\d{8}", , , , , , , [5, 6, 8, 9, 10, 11, 12, 13, 
14], [3, 7]], [, , "2[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])(?:1\\d{2,3}|[1-9]\\d{6,7})", , , , "22123456", , , [5, 6, 8, 9, 10], [3, 7]], [, , "1[0-26-9]\\d{7,8}", , , , "1000000000", , , [9, 10]], [, , "(?:00(?:3(?:08|68\\d)|798\\d{1,3})|80\\d)\\d{6}", , , , "801234567", , , [9, 11, 12, 13, 14]], [, , "60[2-9]\\d{6}", , , , "602345678", , , [9]], [, , , , , , , , , [-1]], [, , "50\\d{8}", , , , "5012345678", , , [10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "KR", 82, "00(?:[1259]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", 
"0", , , "0(8[1-46-8]|85\\d{2})?", , , , [[, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1(?:5[246-9]|6[046-8]|8[03579])", "1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))"], "$1", "0$CC-$1"], [, "(\\d{5})", "$1", ["1[016-9]1", "1[016-9]11", "1[016-9]114"], "0$1", "0$CC-$1"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2[1-9]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60[2-9]|80"], 
"0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["1[0-25-9]|(?:3[1-3]|[46][1-4]|5[1-5])[1-9]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]0"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3})(\\d{3})", "$1 $2 $3", ["003", "0030", "00308"], "$1", "0$CC-$1"], [, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["00[37]", "00(?:36|79)", "00(?:36|79)8"], "$1", "0$CC-$1"], [, "(\\d{5})(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["007", "0079", "00798"], "$1", "0$CC-$1"]], [[, "(\\d{2})(\\d{3,4})", 
"$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1(?:5[246-9]|6[046-8]|8[03579])", "1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))"], "$1", "0$CC-$1"], [, "(\\d{5})", "$1", ["1[016-9]1", "1[016-9]11", "1[016-9]114"], "0$1", "0$CC-$1"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2[1-9]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60[2-9]|80"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", 
["1[0-25-9]|(?:3[1-3]|[46][1-4]|5[1-5])[1-9]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]0"], "0$1", "0$CC-$1"]], [, , "15\\d{7,8}", , , , "1523456789", , , [9, 10]], , , [, , "00(?:3(?:08|68\\d)|798\\d{1,3})\\d{6}", , , , "007981234567", , , [11, 12, 13, 14]], [, , "1(?:5(?:22|44|66|77|88|99)|6(?:00|44|6[16]|70|88)|8(?:00|33|55|77|99))\\d{4}", , , , "15441234", , , [8]], , , [, , , , , , , , , [-1]]], KW:[, [, , "[12569]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:18\\d|2(?:[23]\\d{2}|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7])))\\d{4}", 
, , , "22345678"], [, , "(?:5(?:[05]\\d{2}|1[0-7]\\d|2(?:22|5[25])|6[56]\\d)|6(?:0[034679]\\d|222|5[015-9]\\d|6\\d{2}|7(?:0[013-9]|[67]\\d)|9(?:[069]\\d|3[039]))|9(?:0[09]\\d|11[01]|22\\d|4[01479]\\d|55\\d|6[0679]\\d|7(?:02|[1-9]\\d)|8[057-9]\\d|9\\d{2}))\\d{4}", , , , "50012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KW", 965, "00", , , , , , , , [[, "(\\d{4})(\\d{3,4})", "$1 $2", ["[16]|2(?:[0-35-9]|4[0-35-9])|52[25]|9[0-24-9]"]], 
[, "(\\d{3})(\\d{5})", "$1 $2", ["244|5(?:[015]|6[56])"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KY:[, [, , "[3589]\\d{9}", , , , , , , [10], [7]], [, , "345(?:2(?:22|44)|444|6(?:23|38|40)|7(?:4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}", , , , "3452221234", , , , [7]], [, , "345(?:32[1-9]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|9(?:1[67]|2[2-9]|3[689]))\\d{4}", , , , "3453231234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", 
, , , "8002345678"], [, , "900[2-9]\\d{6}|345976\\d{4}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "KY", 1, "011", "1", , , "1", , , , , , [, , "345849\\d{4}", , , , "3458491234"], , "345", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KZ:[, [, , "(?:33\\d|7\\d{2}|80[089])\\d{7}", , , , , , , [10]], [, , "33622\\d{5}|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[234]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[234]\\d|5[139])|4(?:2\\d|3[1235-9]|59)|5(?:[23]\\d|4[01246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59)))\\d{5}", 
, , , "7123456789"], [, , "7(?:0[012578]|47|6[02-4]|7[15-8]|85)\\d{7}", , , , "7710009998"], [, , "800\\d{7}", , , , "8001234567"], [, , "809\\d{7}", , , , "8091234567"], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567"], [, , "751\\d{7}", , , , "7511234567"], "KZ", 7, "810", "8", , , "8", , "8~10", , , , [, , , , , , , , , [-1]], , , [, , "751\\d{7}", , , , "7511234567"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LA:[, [, , "[2-8]\\d{7,9}", , , , , , , [8, 9, 10], [6]], 
[, , "(?:2[13]|3(?:0\\d|[14])|[5-7][14]|41|8[1468])\\d{6}", , , , "21212862", , , [8, 9], [6]], [, , "20(?:2[2389]|5[24-689]|7[6-8]|9[125-9])\\d{6}", , , , "2023123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LA", 856, "00", "0", , , "0", , , , [[, "(20)(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["20"], "0$1"], [, "([2-8]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], [, "(30)(\\d{2})(\\d{2})(\\d{3})", 
"$1 $2 $3 $4", ["30"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LB:[, [, , "[13-9]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:[14-6]\\d{2}|7(?:[2-57]\\d|62|8[0-7]|9[04-9])|8[02-9]\\d|9\\d{2})\\d{4}", , , , "1123456", , , [7]], [, , "(?:3\\d|7(?:[01]\\d|6[013-9]|8[89]|9[1-3])|81\\d)\\d{5}", , , , "71123456"], [, , , , , , , , , [-1]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , "80\\d{6}", , , , "80123456", , 
, [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LB", 961, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], [, "([7-9]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["7(?:[01]|6[013-9]|8[89]|9[1-3])|[89][01]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LC:[, [, , "[5789]\\d{9}", , , , , , , [10], [7]], [, , "758(?:4(?:30|5[0-9]|6[2-9]|8[0-2])|57[0-2]|638)\\d{4}", 
, , , "7584305678", , , , [7]], [, , "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[01]))\\d{4}", , , , "7582845678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "LC", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "758", [, , , , , , , , , [-1]], [, , , 
, , , , , , [-1]], , , [, , , , , , , , , [-1]]], LI:[, [, , "6\\d{8}|[23789]\\d{6}", , , , , , , [7, 9]], [, , "(?:2(?:01|1[27]|3\\d|6[02-578]|96)|3(?:7[0135-7]|8[048]|9[0269]))\\d{4}", , , , "2345678", , , [7]], [, , "6(?:5(?:09|1\\d|20)|6(?:0[0-6]|10|2[06-9]|39))\\d{5}|7(?:[37-9]\\d|42|56)\\d{4}", , , , "660234567"], [, , "80(?:02[28]|9\\d{2})\\d{2}", , , , "8002222", , , [7]], [, , "90(?:02[258]|1(?:23|3[14])|66[136])\\d{2}", , , , "9002222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , 
, , [-1]], [, , , , , , , , , [-1]], "LI", 423, "00", "0", , , "0|10(?:01|20|66)", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[237-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[56]"]], [, "(69)(7\\d{2})(\\d{4})", "$1 $2 $3", ["697"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "870(?:28|87)\\d{2}", , , , "8702812", , , [7]], , , [, , "697(?:42|56|[78]\\d)\\d{4}", , , , "697861234", , , [9]]], LK:[, [, , "[1-9]\\d{8}", , , , , , , [9], [7]], [, , "1(?:1[2-57]\\d{6}|973\\d{5})|(?:2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7]|[89]1)[2-57]\\d{6}", 
, , , "112345678", , , , [7]], [, , "7[0125-8]\\d{7}", , , , "712345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LK", 94, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LR:[, [, , "2\\d{7,8}|[378]\\d{8}|4\\d{6}|5\\d{6,8}", 
, , , , , , [7, 8, 9]], [, , "(?:2\\d{3}|33333)\\d{4}", , , , "21234567", , , [8, 9]], [, , "(?:20\\d{2}|330\\d|4[67]|5(?:55)?\\d|77\\d{2}|88\\d{2})\\d{5}", , , , "770123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "332(?:02|[2-5]\\d)\\d{4}", , , , "332021234", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LR", 231, "00", "0", , , "0", , , , [[, "(2\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "([4-5])(\\d{3})(\\d{3})", "$1 $2 $3", ["[45]"], 
"0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LS:[, [, , "[2568]\\d{7}", , , , , , , [8]], [, , "2\\d{7}", , , , "22123456"], [, , "[56]\\d{7}", , , , "50123456"], [, , "800[256]\\d{4}", , , , "80021234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LS", 266, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", 
"$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LT:[, [, , "[3-9]\\d{7}", , , , , , , [8]], [, , "(?:3[1478]|4[124-6]|52)\\d{6}", , , , "31234567"], [, , "6\\d{7}", , , , "61234567"], [, , "800\\d{5}", , , , "80012345"], [, , "9(?:0[0239]|10)\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [, , "700\\d{5}", , , , "70012345"], [, , , , , , , , , [-1]], "LT", 370, "00", "8", , , "[08]", , , , [[, "([34]\\d)(\\d{6})", 
"$1 $2", ["37|4(?:1|5[45]|6[2-4])"], "(8-$1)", , 1], [, "([3-6]\\d{2})(\\d{5})", "$1 $2", ["3[148]|4(?:[24]|6[09])|528|6"], "(8-$1)", , 1], [, "([7-9]\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", , 1], [, "(5)(2\\d{2})(\\d{4})", "$1 $2 $3", ["52[0-79]"], "(8-$1)", , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "70[67]\\d{5}", , , , "70712345"], , , [, , , , , , , , , [-1]]], LU:[, [, , "[24-9]\\d{3,10}|3(?:[0-46-9]\\d{2,9}|5[013-9]\\d{1,8})", , , , , , , [4, 5, 6, 
7, 8, 9, 10, 11]], [, , "(?:2[2-9]\\d{2,9}|(?:3(?:[0-46-9]\\d|5[013-9])|[457]\\d{2}|8(?:0[2-9]|[13-9]\\d)|9(?:0[89]|[2-579]\\d))\\d{1,8})", , , , "27123456"], [, , "6[25-79][18]\\d{6}", , , , "628123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90[015]\\d{5}", , , , "90012345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , , , , , , , , [-1]], [, , "20(?:1\\d{5}|[2-689]\\d{1,7})", , , , "20201234", , , [4, 5, 6, 7, 8, 9, 10]], "LU", 352, "00", , , , "(15(?:0[06]|1[12]|35|4[04]|55|6[26]|77|88|99)\\d)", 
, , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"], 
, "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,4})", "$1 $2 $3 $4", ["2(?:[12589]|4[12])|[3-5]|7[1-9]|8(?:0[2-9]|[1-9])|9(?:0[2-46-9]|[1-9])"], , "$CC $1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["70|80[01]|90[015]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LV:[, [, , "[2689]\\d{7}", , , , , , , [8]], [, , "6\\d{7}", , , , "63123456"], [, , 
"2\\d{7}", , , , "21234567"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , "81\\d{6}", , , , "81123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LV", 371, "00", , , , , , , , [[, "([2689]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2689]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LY:[, [, , "[25679]\\d{8}", , , , , , , [9], [7]], [, , "(?:2[1345]|5[1347]|6[123479]|71)\\d{7}", , , , 
"212345678", , , , [7]], [, , "9[1-6]\\d{7}", , , , "912345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LY", 218, "00", "0", , , "0", , , , [[, "([25-79]\\d)(\\d{7})", "$1-$2", ["[25-79]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MA:[, [, , "[5-9]\\d{8}", , , , , , , [9]], [, , "5(?:2(?:[015-79]\\d|2[02-9]|3[2-57]|4[2-8]|8[235-7])\\d|3(?:[0-48]\\d|[57][2-9]|6[2-8]|9[3-9])\\d|4[067]\\d{2}|5[03]\\d{2})\\d{4}", 
, , , "520123456"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[067]|6[1267]|7[07]))\\d{6}", , , , "650123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5924[01]\\d{4}", , , , "592401234"], "MA", 212, "00", "0", , , "0", , , , [[, "([5-7]\\d{2})(\\d{6})", "$1-$2", ["5(?:2[015-7]|3[0-4])|[67]"], "0$1"], [, "([58]\\d{3})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|92)|892", "5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"], 
"0$1"], [, "(5\\d{4})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29|38)[89]"], "0$1"], [, "([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:4[067]|5[03])"], "0$1"], [, "(8[09])(\\d{7})", "$1-$2", ["8(?:0|9[013-9])"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MC:[, [, , "[34689]\\d{7,8}", , , , , , , [8, 9]], [, , "870\\d{5}|9[2-47-9]\\d{6}", , , , "99123456", , , [8]], [, , "3\\d{7}|4(?:4\\d|5[1-9])\\d{5}|6\\d{8}", 
, , , "612345678"], [, , "90\\d{6}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MC", 377, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[39]"], "$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(6)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["8"], "$1"]], , [, , , , , , , , , [-1]], , , 
[, , "870\\d{5}", , , , "87012345", , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MD:[, [, , "[235-9]\\d{7}", , , , , , , [8]], [, , "(?:2[1-9]\\d|3[1-79]\\d|5(?:33|5[257]))\\d{5}", , , , "22212345"], [, , "(?:562|6\\d{2}|7(?:[189]\\d|6[07]|7[457-9]))\\d{5}", , , , "62112345"], [, , "800\\d{5}", , , , "80012345"], [, , "90[056]\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [, , , , , , , , , [-1]], [, , "3[08]\\d{6}", , , , "30123456"], "MD", 373, "00", "0", 
, , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], [, "([25-7]\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["2[13-9]|[5-7]"], "0$1"], [, "([89]\\d{2})(\\d{5})", "$1 $2", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "803\\d{5}", , , , "80312345"], , , [, , , , , , , , , [-1]]], ME:[, [, , "[2-9]\\d{7,8}", , , , , , , [8], [6]], [, , "(?:20[2-8]|3(?:0[2-7]|[12][235-7]|3[24-7])|4(?:0[2-467]|1[267])|5(?:0[2467]|1[267]|2[2367]))\\d{5}", , , , "30234567", 
, , , [6]], [, , "6(?:00\\d|3[024]\\d|6[0-25]\\d|[7-9]\\d{2})\\d{4}", , , , "67622901"], [, , "80[0-258]\\d{5}", , , , "80080002"], [, , "(?:9(?:4[1568]|5[178]))\\d{5}", , , , "94515151"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "78[1-49]\\d{5}", , , , "78108780"], "ME", 382, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]|6[036-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "77[1-9]\\d{5}", , , , "77273012"], , , [, 
, , , , , , , , [-1]]], MF:[, [, , "[56]\\d{8}", , , , , , , [9]], [, , "590(?:0[079]|13|2[79]|30|43|5[0-268]|7[79]|87)\\d{4}", , , , "590271234"], [, , "69(?:0\\d{2}|1(?:2[29]|3[0-5]))\\d{4}", , , , "690001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MF", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MG:[, 
[, , "[23]\\d{8}", , , , , , , [9], [7]], [, , "20(?:2\\d{2}|4[47]\\d|5[3467]\\d|6[279]\\d|7(?:2[29]|[35]\\d)|8[268]\\d|9[245]\\d)\\d{4}", , , , "202123456", , , , [7]], [, , "3[2-49]\\d{7}", , , , "321234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "22\\d{7}", , , , "221234567"], "MG", 261, "00", "0", , , "0", , , , [[, "([23]\\d)(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , 
, , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MH:[, [, , "[2-6]\\d{6}", , , , , , , [7]], [, , "(?:247|528|625)\\d{4}", , , , "2471234"], [, , "(?:235|329|45[56]|545)\\d{4}", , , , "2351234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "635\\d{4}", , , , "6351234"], "MH", 692, "011", "1", , , "1", , , , [[, "(\\d{3})(\\d{4})", "$1-$2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , 
, , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MK:[, [, , "[2-578]\\d{7}", , , , , , , [8], [6, 7]], [, , "(?:2(?:[23]\\d|5[0-24578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}", , , , "22012345", , , , [6, 7]], [, , "7(?:[0-25-8]\\d{2}|3[2-4]\\d|421|9[23]\\d)\\d{4}", , , , "72345678"], [, , "800\\d{5}", , , , "80012345"], [, , "5[02-9]\\d{6}", , , , "50012345"], [, , "8(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "80123456"], [, , , , , , 
, , , [-1]], [, , , , , , , , , [-1]], "MK", 389, "00", "0", , , "0", , , , [[, "(2)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "([347]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], [, "([58]\\d{2})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ML:[, [, , "[246-9]\\d{7}", , , , , , , [8]], [, , "(?:2(?:0(?:2\\d|7[0-8])|1(?:2[5-7]|[3-689]\\d))|44[1239]\\d)\\d{4}", 
, , , "20212345"], [, , "(?:2(?:079|17\\d)|[679]\\d{3}|8[239]\\d{2})\\d{4}", , , , "65012345"], [, , "80\\d{6}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ML", 223, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[246-9]"]], [, "(\\d{4})", "$1", ["67|74"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[246-9]"]]], [, , , , , , , , , [-1]], , , [, , "80\\d{6}", , , , "80012345"], 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MM:[, [, , "[178]\\d{5,7}|[24-6]\\d{5,8}|9(?:[279]\\d{0,2}|5|[34]\\d{1,2}|6(?:\\d{1,2})?|8(?:\\d{2})?)\\d{6}", , , , , , , [6, 7, 8, 9, 10], [5]], [, , "1(?:2\\d{1,2}|[35]\\d|4(?:\\d|2[236]|39)|6\\d?|[89][0-6]\\d)\\d{4}|2(?:2(?:000\\d{3}|\\d{4})|3\\d{4}|4(?:0\\d{5}|26\\d{4}|39\\d{4}|\\d{4})|5(?:1\\d{3,6}|[02-9]\\d{3,5})|[6-9]\\d{4})|4(?:2[245-8]|3(?:2(?:02)?|[346]|56?)|[46][2-6]|5[3-5])\\d{4}|5(?:2(?:2(?:\\d{1,2})?|[3-8])|3[2-68]|4(?:21?|[4-8])|5[23]|6[2-4]|7[2-8]|8[24-7]|9[2-7])\\d{4}|6(?:0[23]|1(?:2(?:0|4\\d)?|[356])|2[2-6]|3[24-6]|4(?:2(?:4\\d)?|[3-6])|5[2-4]|6[2-8]|7(?:[2367]|4(?:\\d|39)|5\\d?|8[145]\\d)|8[245]|9(?:20?|4))\\d{4}|7(?:[04][24-8]|1(?:20?|[3-7])|22|3[2-4]|5[2-7])\\d{4}|8(?:1(?:2\\d{1,2}|[3-689]\\d)|2(?:2\\d|3(?:\\d|20)|[4-8]\\d)|3[24]\\d|4[24-7]\\d|5[245]\\d|6[23]\\d)\\d{3}", 
, , , "1234567", , , [6, 7, 8, 9], [5]], [, , "17[01]\\d{4}|9(?:2(?:[0-4]|5\\d{2}|6[0-5]\\d)|3(?:[0-36]|4[069])\\d|4(?:0[0-4]\\d|[1379]\\d|2\\d{2}|4[0-589]\\d|5\\d{2}|88)|5[0-6]|6(?:1\\d|9\\d{2}|\\d)|7(?:3|5[0-2]|[6-9]\\d)\\d|8(?:\\d|9\\d{2})|9(?:1\\d|[5-7]\\d{2}|[089]))\\d{5}", , , , "92123456", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1333\\d{4}", , , , "13331234", , , [8]], "MM", 95, "00", "0", , , "0", , 
, , [[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1|2[245]"], "0$1"], [, "(2)(\\d{4})(\\d{4})", "$1 $2 $3", ["251"], "0$1"], [, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["432|67|81"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3,4})", "$1 $2 $3", ["[4-8]"], "0$1"], [, "(9)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], [, "(9)([34]\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:3[0-36]|4[0-57-9])"], "0$1"], [, "(9)(\\d{3})(\\d{3})(\\d{3})", 
"$1 $2 $3 $4", ["92[56]"], "0$1"], [, "(9)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["93"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MN:[, [, , "[12]\\d{7,9}|[57-9]\\d{7}", , , , , , , [8, 9, 10], [6, 7]], [, , "[12](?:1\\d|2(?:[1-3]\\d?|7\\d)|3[2-8]\\d{1,2}|4[2-68]\\d{1,2}|5[1-4689]\\d{1,2})\\d{5}|5[0568]\\d{6}", , , , "50123456", , , , [6, 7]], [, , "(?:8(?:[05689]\\d|3[01])|9[013-9]\\d)\\d{5}", , , , "88123456", 
, , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "7[05-8]\\d{6}", , , , "75123456", , , [8]], "MN", 976, "001", "0", , , "0", , , , [[, "([12]\\d)(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], [, "([12]2\\d)(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], [, "([12]\\d{3})(\\d{5})", "$1 $2", ["[12](?:27|[3-5])", "[12](?:27|[3-5]\\d)2"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[57-9]"], "$1"], [, "([12]\\d{4})(\\d{4,5})", "$1 $2", 
["[12](?:27|[3-5])", "[12](?:27|[3-5]\\d)[4-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MO:[, [, , "[268]\\d{7}", , , , , , , [8]], [, , "(?:28[2-57-9]|8(?:11|[2-57-9]\\d))\\d{5}", , , , "28212345"], [, , "6(?:[2356]\\d|8[158])\\d{5}", , , , "66123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MO", 853, "00", , , , , , , , 
[[, "([268]\\d{3})(\\d{4})", "$1 $2", ["[268]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MP:[, [, , "[5689]\\d{9}", , , , , , , [10], [7]], [, , "670(?:2(?:3[3-7]|56|8[5-8])|32[1238]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "670(?:2(?:3[3-7]|56|8[5-8])|32[1238]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", 
, , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "MP", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "670", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MQ:[, [, , "[56]\\d{8}", , , , , , , [9]], [, , "596(?:0[0-7]|10|2[7-9]|3[05-9]|4[0-46-8]|[5-7]\\d|8[09]|9[4-8])\\d{4}", 
, , , "596301234"], [, , "69(?:6(?:[0-47-9]\\d|5[0-6]|6[0-4])|727)\\d{4}", , , , "696201234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MQ", 596, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", , "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MR:[, [, , "[2-48]\\d{7}", , , , , , , [8]], [, , "25[08]\\d{5}|35\\d{6}|45[1-7]\\d{5}", 
, , , "35123456"], [, , "[234][0-46-9]\\d{6}", , , , "22123456"], [, , "800\\d{5}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MR", 222, "00", , , , , , , , [[, "([2-48]\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MS:[, [, , "[5689]\\d{9}", , , , , , , [10], [7]], [, , "664491\\d{4}", , , 
, "6644912345", , , , [7]], [, , "66449[2-6]\\d{4}", , , , "6644923456", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "MS", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "664", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MT:[, [, , "[2357-9]\\d{7}", 
, , , , , , [8]], [, , "2(?:0(?:[169]\\d|3[1-4])|[1-357]\\d{2})\\d{4}", , , , "21001234"], [, , "(?:7(?:210|[79]\\d{2})|9(?:2(?:1[01]|31)|69[67]|8(?:1[1-3]|89|97)|9\\d{2}))\\d{4}", , , , "96961234"], [, , "800[3467]\\d{4}", , , , "80071234"], [, , "5(?:0(?:0(?:37|43)|6\\d{2}|70\\d|9[0168]\\d)|[12]\\d0[1-5])\\d{3}", , , , "50037123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3550\\d{4}", , , , "35501234"], "MT", 356, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2"]], , [, , "7117\\d{4}", 
, , , "71171234"], , , [, , , , , , , , , [-1]], [, , "501\\d{5}", , , , "50112345"], , , [, , , , , , , , , [-1]]], MU:[, [, , "[2-9]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:2(?:[03478]\\d|1[0-7]|6[1-69])|4(?:[013568]\\d|2[4-7])|5(?:44\\d|471)|6\\d{2}|8(?:14|3[129]))\\d{4}", , , , "2012345"], [, , "5(?:2[589]\\d|4(?:2[1-389]|[489]\\d|7[1-9])|7\\d{2}|8(?:[0-689]\\d|7[15-8])|9[0-8]\\d)\\d{4}", , , , "52512345", , , [8]], [, , "80[012]\\d{4}", , , , "8001234", , , [7]], [, , "30\\d{5}", , , , "3012345", 
, , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3(?:20|9\\d)\\d{4}", , , , "3201234", , , [7]], "MU", 230, "0(?:0|[2-7]0|33)", , , , , , "020", , [[, "([2-46-9]\\d{2})(\\d{4})", "$1 $2", ["[2-46-9]"]], [, "(5\\d{3})(\\d{4})", "$1 $2", ["5"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MV:[, [, , "[346-8]\\d{6,9}|9(?:00\\d{7}|\\d{6})", , , , , , , [7, 10]], [, , "(?:3(?:0[0-3]|3[0-59])|6(?:[57][02468]|6[024568]|8[024689]))\\d{4}", 
, , , "6701234", , , [7]], [, , "(?:46[46]|7[2-9]\\d|9[15-9]\\d)\\d{4}", , , , "7712345", , , [7]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MV", 960, "0(?:0|19)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[3467]|9(?:0[1-9]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]00"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , 
"4[05]0\\d{4}", , , , "4001234", , , [7]], , , [, , , , , , , , , [-1]]], MW:[, [, , "(?:1(?:\\d{2})?|[2789]\\d{2}|31\\d)\\d{6}", , , , , , , [7, 9]], [, , "(?:1[2-9]|21\\d{2})\\d{5}", , , , "1234567"], [, , "(?:111|77\\d|88\\d|99\\d)\\d{6}", , , , "991234567", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "31\\d{7}", , , , "310123456", , , [9]], "MW", 265, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1"], 
"0$1"], [, "(2\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[17-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["31"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MX:[, [, , "[1-9]\\d{9,10}", , , , , , , [10, 11], [7, 8]], [, , "(?:33|55|81)\\d{8}|(?:2(?:0[01]|2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-6][1-9]|[37][1-8]|8[1-35-9]|9[2-689])|5(?:88|9[1-79])|6(?:1[2-68]|[234][1-9]|5[1-3689]|6[12457-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2[1-8]|5[13-9]|8[1-69]|9[17])|8(?:2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}", 
, , , "2221234567", , , [10], [7, 8]], [, , "1(?:(?:33|55|81)\\d{8}|(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-6][1-9]|[37][1-8]|8[1-35-9]|9[2-689])|5(?:88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[12457-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2[1-8]|5[13-9]|8[1-69]|9[17])|8(?:2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7})", , , , "12221234567", 
, , [11]], [, , "8(?:00|88)\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , "300\\d{7}", , , , "3001234567", , , [10]], [, , "500\\d{7}", , , , "5001234567", , , [10]], [, , , , , , , , , [-1]], "MX", 52, "0[09]", "01", , , "0[12]|04[45](\\d{10})", "1$1", , , [[, "([358]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["33|55|81"], "01 $1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"], "01 $1", , 1], [, "(1)([358]\\d)(\\d{4})(\\d{4})", 
"044 $2 $3 $4", ["1(?:33|55|81)"], "$1", , 1], [, "(1)(\\d{3})(\\d{3})(\\d{4})", "044 $2 $3 $4", ["1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"], "$1", , 1]], [[, "([358]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["33|55|81"], "01 $1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"], "01 $1", , 1], [, "(1)([358]\\d)(\\d{4})(\\d{4})", "$1 $2 $3 $4", ["1(?:33|55|81)"]], [, "(1)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"]]], 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MY:[, [, , "[13-9]\\d{7,9}", , , , , , , [8, 9, 10], [6, 7]], [, , "(?:3(?:2(?:0(?:11|2[0-8]|3[0-24-79]|[579]\\d|8[0-57-9])|1(?:0[6-9]|1[03-9]|[467]\\d|8[0-2]|9[13])|2(?:0[1-3]|2[2-4]|4[0-25-7]|6[0-8]|7[02-689]|8\\d|9[5-9])|3(?:0[0-3]|3[0-36]|8[0-35-9]|9[1-3])|6(?:0[0-5]|[139]\\d|8[15-8])|7(?:1\\d|2[0-7]|3[0-3]|42|7[0-356]|8[0-35-8])|8(?:00|4[78]|5[6-9])|93[58])|3(?:0(?:0[0-35-9]|10|5[01]|8[0-6]|9[39])|1(?:0[1-39]|10|2[02-469]|3[245]|4[0-3589]|6[0-35-9]|7[067]|8[0-57]|9[0-278])|2(?:1[3467]|2[45]|4[1-3]|5[0689]|6[04589]|7[0-3579]|8[0-489]|9[0-27])|3(?:1[7-9]|2[1-6]|4[1-689]|5[89]|6[1-3]|7\\d|8[125]|9[236])|6(?:[12]0|3[01]|5[0-256]|6[08]|8[45]))|4(?:0(?:09|[14]\\d|2[0-8]|3[12]|5[01]|65)|1(?:0[0-8]|31|4\\d|6[12])|2(?:17|5[0-35-9]|6[024-6]|7[0189]|8[057-9]|9\\d)|770|8(?:0[0-2]|1[0-3569]|2[01]))|5(?:0(?:2[0-2]|3[0-35-9])|1(?:0[1-3]|1[05]|2[0-6]|31|6[1-7]|9[1258])|270|48[0-5]|5(?:1\\d|2[0-6]|4[0-589]|6[125-9]|9[01])|6(?:1[1-4]|2[0-589]|3\\d|5[0-3])|7(?:21|40)|8(?:7[06-9]|8[025-9]|9[12]))|6(?:0(?:2[0-28]|3[24-9]|4[246-9]|5[57]|6[13-6]|7[358]|8[1247]|9[0-59])|1(?:[04][0-58]|15|2[02-8]|3[015-9]|5[016-8]|7[7-9]|8[14-9]|9[1-356])|2(?:[05]\\d|11|[46][1-3]|7[02-79]|8[015-7])|303|4(?:1[129]|2[01]|3[36]|6[0-2])|690|7(?:3\\d|89))|7(?:118|2(?:0[02]|6[01])|4(?:[59]\\d|8[01])|6(?:1[01]|2\\d|5[0-2]|6[0-69])|7(?:1[0-37-9]|[28]\\d|3[1-5]|7[0-3])|8(?:[04]\\d|3[129]|59|6[1-356]|7[02-79]|8[02-7]|90)|9(?:10|3[1-3]|4[016-9]|[56]\\d|7[12]|8\\d))|8(?:0(?:0[08]|11|2[0-7]|5[12]|6\\d|7[013-69]|8[0-24]|9[0-5])|100|21[0-36]|3(?:08|1\\d|2[0-589]|31)|408|5(?:2[0-35-79]|88)|6(?:0[0-259]|5[5-79]|6[01]|8[46-9]|9[019])|7(?:0[35-8]|2[3-7]|3\\d|4[0149]|5[0-2]|6[016-9]|7[5-9]|8[037]|90)|8(?:00|61|7[0-3]|8\\d|9[0-4])|9(?:1[1-3]|[2-5]\\d|6[1-4689]|8[89]|9[0-689]))|9(?:0(?:1[0-289]|2[15]|5[014-9]|7[04-68]|8[0-256])|1(?:0[0-356]|3[0-49]|4[015]|7[0-59]|9[15])|2(?:0[0-25-7]|12|2[1-6]|3[1256]|7[14]|8\\d)|3[68]8|41[01]|5(?:14|2[01]|4[03-9]|6[5-79]|7[0-2569])))\\d|4(?:2(?:0[01]|1[07-9]|2[02-46-9]|38|4[0-28]|5[0-589]|6[0-47-9]|8[0-389]|9[0-38])\\d|3(?:0[5-9]|[12][034]|3[0-37]|47|5[168]|6[7-9]|7[0135-8]|8\\d|9[0-27-9])\\d|4(?:[02-9]\\d{2}|1(?:[02-9]\\d|10))|5(?:[07]\\d{2}|1[0-358]\\d|2[1246]\\d|3[06-9]\\d|4[0589]\\d|5[12457-9]\\d|6[0-689]\\d|8(?:[0-57-9]\\d|60)|9(?:[2-57-9]\\d|60))|6(?:0[79]|1[0-689]|2[0135-9]|[3-5]\\d|6[07-9]|7[23]|8[03-9]|99)\\d|7(?:0[0-59]\\d|1[04679]\\d|2(?:[02-9]\\d|10)|[37]\\d{2}|4(?:[0178]\\d|5[0-6])|5(?:[0-57-9]\\d|60)|6[024-689]\\d|8[0-79]\\d|9(?:[0479]\\d|3[01]))|8(?:1[0189]\\d|2[046-9]\\d|3[058]\\d|5[029]\\d|6(?:[0689]\\d|40)|8[14568]\\d|9[0-389]\\d)|9(?:0[1368]\\d|1[13-9]\\d|[27]\\d{2}|3(?:[0-368]\\d|7[0-3])|4[013-79]\\d|5[0-35689]\\d|6[0-46-9]\\d|8[0-24-9]\\d|97\\d))|5(?:2(?:0[13589]\\d|1[0-2]\\d|2[056]\\d|3(?:[067]\\d|2[01])|4[0-69]\\d|5[3-6]\\d|8[0-25-9]\\d|9[0-469]\\d)|3(?:[12][0-38]|3[0-37]|4[89]|5[01346-9]|[67]\\d|8[01589]|95)\\d|4(?:0[1346]\\d|1[02-35-9]\\d|2[1379]\\d|3[0-46-9]\\d|4[013689]\\d|[59]\\d{2}|6(?:[15-9]\\d|20)|7[036-9]\\d|8[015-8]\\d)|5(?:0[167]\\d|17\\d|2[025-9]\\d|3[035-7]\\d|4[0-35-9]\\d|8[13]\\d|9(?:[124-9]\\d|31))|6(?:0[89]\\d|1[02-46-8]\\d|2[0-69]\\d|3(?:[1-367]\\d|40)|4[0-689]\\d|5(?:[0-24-9]\\d|30)|6[1457-9]\\d|7\\d{2}|8[0-57-9]\\d|9[0-389]\\d)|7(?:1(?:[024679]\\d|80)|2[0-35-8]\\d|3[23]\\d|4[34]\\d|5[0-36-9]\\d|6[356-9]\\d|7\\d{2}|8(?:[23]\\d|[01]1)|9(?:[1-689]\\d|70))|8(?:0[145-9]\\d|1[0-2]\\d|2[09]\\d|3(?:[058]\\d|0[017])|4[016-9]\\d|5[02-9]\\d|7(?:10|2\\d)|8[013589]\\d|9[0-57-9]\\d)|9[23]0\\d)|6(?:2(?:2[1246-9]\\d|3[0-5]\\d|4[02]\\d|5[1-3]\\d|[68]\\d{2}|7(?:[04-8]\\d|10)|9[2-5]\\d)|3(?:1(?:[125-9]\\d|3[01])|3[0-7]\\d|5[0-478]\\d|79\\d|8[3-578]\\d|9[018]\\d)|4(?:1[015]|[2-689]\\d|7[1-79])\\d|5(?:09\\d|1(?:10|[2479]\\d)|2[1-579]\\d|3(?:[0-467]\\d|50)|4[0-24-9]\\d|5\\d{2}|60\\d)|6(?:0[13]\\d|1[0-57]\\d|2[03]\\d|3[0-478]\\d|4[0-8]\\d|5[013-689]\\d|6[0-467]\\d|[78]\\d{2}|9(?:[13-9]\\d|20))|7(?:01|2[06-9]|3[367]|5[7-9]|6\\d|7[0156]|8[12]|9[0-47-9])\\d|85[0-26]\\d|9(?:0[167]|10|[57]\\d|6[02-9]|8[013-9])\\d)|7(?:2(?:0[7-9]|1[016-9]|2[0-8]|[39]\\d|4[014]|5[0-79]|6[125-8]|7[1246-9]|8[37-9])\\d|3(?:0[0-5]|[35]\\d|40|5[0-478]|6[0-5]|8[0-26-8])\\d|4(?:0[07-9]|[1-35]\\d|6[7-9]|7[57]|8[1-68])\\d|5(?:0[04-9]|1[0-68]|2[0-378]|3[0-3]|5\\d|6[0-2]|7[018]|8[5-7]|9[05-9])\\d|6(?:5[0-24-9]|6[0-3568]|7[0457-9]|8[02-9]|9\\d)\\d|7(?:0[25-8]\\d|1(?:[01]\\d|20)|2[0-2]\\d|3[489]\\d|[457-9]\\d{2}|6(?:[0-8]\\d|90))|8(?:01[01]|10\\d|[289]\\d{2}|3(?:[028]\\d|10)|50\\d|6[0-357-9]\\d|7(?:[0235-9]\\d|[14]0))|9(?:0(?:[0246-8]\\d|10)|[1-4]\\d{2}|50\\d|6[014589]\\d|[7-9]0\\d))|8(?:2(?:2(?:[013-5]\\d|[28][0-8]|6[016]|7[0-589]|9[0-49])|3(?:[02][0-689]|1[1-59]|[3-7]\\d|8[0-389]|9[13])|4(?:0[1-3]|[1-8]\\d|9[1-359])|5(?:0[1-7]|[17]\\d|20|3[0-26-9]|4[1-9]|5[0-35]|8[0-689]|9[02367])|6(?:[147]\\d|2[0-25-9]|39|5[014-9]|6[1-9]|8[1-8]|9[089])|7(?:0[017-9]|1[1-356]|20|3[01457-9]|4[15]|5[0-25]|6[0-6]|70|8[0-2]|9[01378])|8(?:0[3-57-9]|[15]0|2[124-9]|3[01]|4[02-6]|6[02-578]|7\\d|8[25-8]|9[04-689]))|3(?:220|3(?:0[089]|10|2[0-7]|3[7-9]|4[0-48])|4(?:0[68]|1[0-478]|2[5-79]|3[024-9]|50|6\\d|7[0-57]|8[05]|96)|5(?:4[4578]|55|6[2-9]|70|8[459]|92))|4(?:2(?:[15]\\d|2[0-489]|3[124-9])|3(?:0[1-8]|[1-4]\\d|5[0-3]|6[1-7]|7[56]|8[0-4]|9[1-578])|4(?:05|80)|555|6(?:1[0-3]|20|3[1-4]|4[0-24-7]|5\\d|6[0-2]|71|8[0-47-9]|9[0-689])|7(02|1[79]|21|3[0-2468]|5[0-5]|6[0256]|7[0-8]|8[01589]|9[026-9])|8(?:0[1-9]|1[0-3568]|2[0138]|3[0-4]|4[046-9]|5[06]|6\\d|7[0-579]|80|9[0-8]))|5(?:2(?:0[0-26]|1\\d|2[0-5]|3[18]|4[0-2]|6[3-68]|70|8[025-9]|9[05-9])|3(?:10|2\\d|31|95)|4(?:0[1-7]|[1-4]\\d|5[02-6]|6[0-3]|7[0-245]|8[125]|9[1-6])|5(?:40|55)|6(?:0[1459]|1[0-8]|2[0-36-8]|3[0-35-8]|[45]\\d|6[0-8]|80)|7(?:1[07-9]|20|3[3-9]|4[02-4]|5[05689]|6[015-9]|7\\d|8[045]|9[0-6]))|6(?:2(?:01|3[12]|5[1-7]|60|8[1-6]|9[0-8])|3(?:0[0137]|[134]\\d|2[0-8]|[59][01]|60|[78]1)|4(?:2[2-4]|49|5[17]|6\\d|7[0-46-9]|8[0-689])|5(?:0[6-8]|55|8[0149]|90)|8(?:5\\d|[68]0)|9(?:5[12]|81))|7(?:2(?:0[189]|[12][1-9]|3[0-47]|50)|3(?:[01][1-9]|3\\d|4[0-245]|6[4-9]|7[237-9]|9[12])|4(?:[0-2]\\d|3[167-9]|[45][0-3]|6[0-8]|7[25-9]|8[0-6]|90)|5(?:0[1-9]|[89]\\d)|7(?:1[89]|[27]\\d|3[013-9]|4[0-8]|50|6[01568]|82)|8(?:[03][1-3]|1[0-28]|2[0-38]|48|5[0-4]|6[1-3]|7[124]|8[013-57-9]|9[07]))|8(?:2(?:0[13-7]|[1-9]\\d)|3(?:0[1-47-9]|[128]\\d|3[0-4]|4[1-9]|5[0-35-7]|6[0-46-9]|9[3-7])|4(?:0[1-58]|1[1-5]|[2-57-9]\\d|69)|5(?:1[1-35-9]|2\\d|3[2-8]|52)|6(?:0[2-9]|1[1-8]|[23]\\d|41|5[12367]|6[1-9]|7[14-9]|8[02-8]|9[05])|7(?:0[1-589]|[1-35-8]\\d|4[0-7]|9[0-46-9])|8(?:01|30|5[0-48]|6[13]|7\\d|8[013-689]|9[24-9])|9(?:0[2-4689]|1\\d|2[08]|3[18]|4[03]|59|6[0-36-9]|7[0-35-79]|8[1235]))|9(?:2(?:[057][1-9]|[1-3]\\d|4[0-8]|6[1-5]|8[015-9]|9[04-6])|300|4(?:01|36|6[1-6]|[89][12])|5(?:0[25689]|1\\d|2[0134]|3[1-8]|5[17]|6[0-35-9]|7[0-7]|91)|6(?:1[1-9]|2[23]|3[0-4]|6[03-9]|7[0-7])|7(?:0[1-68]|1[1-8]|2[25-9]|3[056]|4[4-9]|[5-8]\\d|9[0-46-9])|8(?:0[1-7]|[189]\\d|2[1-46]|4[1-689]|5[0-79]|6[1-9]|71)|9(?:0[1-3]|1\\d|2[0-35-7]|3[67]|4[12]|5[0-249]|6[5-9]|75|8[1-6])))|9(?:2(?:0[458]\\d|1[2-57]\\d|2[0-589]\\d|[39]\\d{2}|4(?:[02-9]\\d|10)|5(?:[024-6]\\d|[7-9]0)|6(?:[03-9]\\d|20)|7[0-26-9]\\d|8(?:[0-24-68]\\d|7[01]))|3(?:0[0-2689]\\d|1(?:[0235]\\d|1[0-2]|4[01])|2(?:0[01]|[1-57-9]\\d|6[0-2])|3(?:00|1[0-4]|2\\d)|4[05]\\d|5[0-3568]\\d|6(?:[1-357-9]\\d|60)|[78]0\\d)|4(?:0[24578]\\d|1[02-57-9]\\d|2\\d{2}|3(?:[0278]\\d|1[01]|60)|4[013579]\\d|5[0-8]\\d|6[0678]\\d|7[013-9]\\d|8[01569]\\d)|5(0(?:[589]\\d|7[01])|1\\d{2}|2[0159]\\d|3[14689]\\d|4[0-46-9]\\d|5[0-35-9]\\d|6[0156-8]\\d|7[0-35]\\d|8[0-7]\\d|9[0-3589]\\d)|6(?:0[269]\\d|[12]\\d{2}|3[0-57-9]\\d|44[0-2]|5[01379]\\d|6[02-9]\\d|7[69]\\d|8(?:[0-24-8]\\d|30)|9(?:[0-24-9]\\d|3[01]))|7(?:0[0136-8]|1[02-4]|2[156]|3[258]|[489]\\d|5[0-589]|6[024-9]|7[0-689])\\d|8(?:0(?:0[01]|1\\d)|1[3-9]\\d|[23]\\d{2}|4[0-24-689]\\d|5[0-689]\\d|6[02-9]\\d|7(?:[01]0|[2-4]\\d)|888)|9(?:00\\d|1[2-57-9]\\d|2(?:00|1[01]|[238]\\d)|3(?:[2-467]\\d|50)|4[4-9]\\d|5(?:[0-2457-9]\\d|60)|6[0156]\\d|7[04-9]\\d|8[01]\\d)))\\d{3}", 
, , , "323856789", , , [8, 9], [6, 7]], [, , "1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])\\d|1(?:[1-5]\\d{2}|6(?:0[5-9]|[1-9]\\d))\\d|[23679][2-9]\\d{2}|4(?:[235-9]\\d{2}|400)|59\\d{3}|8(?:1[23]\\d|[236]\\d{2}|4(?:[06]\\d|7[0-4])|5[7-9]\\d|7[016-9]\\d|8(?:[01]\\d|[27][0-4])|9[0-8]\\d))\\d{4}", , , , "123456789", , , [9, 10]], [, , "1[378]00\\d{6}", , , , "1300123456", , , [10]], [, , "1600\\d{6}", , , , "1600123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "154(?:6(?:0\\d|1[0-3])|8(?:[25]1|4[0189]|7[0-4679]))\\d{4}", 
, , , "1546012345", , , [10]], "MY", 60, "00", "0", , , "0", , , , [[, "([4-79])(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], [, "(3)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], [, "([18]\\d)(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1[02-46-9][1-9]|8"], "0$1"], [, "(1)([36-8]00)(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1[36-8]0", "1[36-8]00"]], [, "(11)(\\d{4})(\\d{4})", "$1-$2 $3", ["11"], "0$1"], [, "(15[49])(\\d{3})(\\d{4})", "$1-$2 $3", ["15[49]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , 
, , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MZ:[, [, , "[28]\\d{7,8}", , , , , , , [8, 9]], [, , "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", , , , "21123456", , , [8]], [, , "8[2-7]\\d{7}", , , , "821234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MZ", 258, "00", , , , , , , , [[, "([28]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-7]"]], [, "(80\\d)(\\d{3})(\\d{3})", 
"$1 $2 $3", ["80"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NA:[, [, , "[68]\\d{7,8}", , , , , , , [8, 9]], [, , "6(?:1(?:17|2(?:[0189]\\d|[2-6]|7\\d?)|3(?:[01378]|2\\d)|4(?:[024]|10?|3[15]?)|69|7[014])|2(?:17|5(?:[0-36-8]|4\\d?)|69|70)|3(?:17|2(?:[0237]\\d?|[14-689])|34|6[289]|7[01]|81)|4(?:17|2(?:[012]|7\\d?)|4(?:[06]|1\\d?)|5(?:[01357]|[25]\\d?)|69|7[01])|5(?:17|2(?:[0459]|[23678]\\d?)|69|7[01])|6(?:17|2(?:5|6\\d?)|38|42|69|7[01])|7(?:17|2(?:[569]|[234]\\d?)|3(?:0\\d?|[13])|6[89]|7[01]))\\d{4}", 
, , , "61221234"], [, , "(?:60|8[125])\\d{7}", , , , "811234567", , , [9]], [, , , , , , , , , [-1]], [, , "8701\\d{5}", , , , "870123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8(?:3\\d{2}|86)\\d{5}", , , , "88612345"], "NA", 264, "00", "0", , , "0", , , , [[, "(8\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["8[1-35]"], "0$1"], [, "(6\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], [, "(88)(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(870)(\\d{3})(\\d{3})", "$1 $2 $3", 
["870"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NC:[, [, , "[2-57-9]\\d{5}", , , , , , , [6]], [, , "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}", , , , "201234"], [, , "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}", , , , "751234"], [, , , , , , , , , [-1]], [, , "36\\d{4}", , , , "366711"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NC", 687, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", 
["[2-46-9]|5[0-4]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NE:[, [, , "[0289]\\d{7}", , , , , , , [8]], [, , "2(?:0(?:20|3[1-7]|4[134]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}", , , , "20201234"], [, , "(?:8[089]|9\\d)\\d{6}", , , , "93123456"], [, , "08\\d{6}", , , , "08123456"], [, , "09\\d{6}", , , , "09123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
"NE", 227, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["09|[289]"]], [, "(08)(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NF:[, [, , "[13]\\d{5}", , , , , , , [6], [5]], [, , "(?:1(?:06|17|28|39)|3[012]\\d)\\d{3}", , , , "106609", , , , [5]], [, , "3[58]\\d{4}", , , , "381234", , , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , 
, , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NF", 672, "00", , , , , , , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["1"]], [, "(\\d)(\\d{5})", "$1 $2", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NG:[, [, , "[1-6]\\d{5,8}|9\\d{5,9}|[78]\\d{5,13}", , , , , , , [7, 8, 10, 11, 12, 13, 14], [5, 6]], [, , "[12]\\d{6,7}|9(?:0[3-9]|[1-9]\\d)\\d{5}|(?:3\\d|4[023568]|5[02368]|6[02-469]|7[4-69]|8[2-9])\\d{6}|(?:4[47]|5[14579]|6[1578]|7[0-357])\\d{5,6}|(?:78|41)\\d{5}", 
, , , "12345678", , , [7, 8], [5, 6]], [, , "(?:1(?:7[34]\\d|8(?:04|[124579]\\d|8[0-3])|95\\d)|287[0-7]|3(?:18[1-8]|88[0-7]|9(?:8[5-9]|6[1-5]))|4(?:28[0-2]|6(?:7[1-9]|8[02-47])|88[0-2])|5(?:2(?:7[7-9]|8\\d)|38[1-79]|48[0-7]|68[4-7])|6(?:2(?:7[7-9]|8\\d)|4(?:3[7-9]|[68][129]|7[04-69]|9[1-8])|58[0-2]|98[7-9])|7(?:38[0-7]|69[1-8]|78[2-4])|8(?:28[3-9]|38[0-2]|4(?:2[12]|3[147-9]|5[346]|7[4-9]|8[014-689]|90)|58[1-8]|78[2-9]|88[5-7])|98[07]\\d)\\d{4}|(?:70(?:[1-689]\\d|7[0-3])|8(?:0(?:1[01]|[2-9]\\d)|1(?:[0-8]\\d|9[01]))|90[235-9]\\d)\\d{6}", 
, , , "8021234567", , , [8, 10]], [, , "800\\d{7,11}", , , , "80017591759", , , [10, 11, 12, 13, 14]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NG", 234, "009", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-6]|7(?:0[1-9]|[1-79])|8[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["70|8[01]|90[235-9]"], "0$1"], [, "([78]00)(\\d{4})(\\d{4,5})", 
"$1 $2 $3", ["[78]00"], "0$1"], [, "([78]00)(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]00"], "0$1"], [, "(78)(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "700\\d{7,11}", , , , "7001234567", , , [10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]]], NI:[, [, , "[125-8]\\d{7}", , , , , , , [8]], [, , "2\\d{7}", , , , "21234567"], [, , "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|7[5-8]\\d|8\\d{2})\\d{5}", , , , "81234567"], 
[, , "1800\\d{4}", , , , "18001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NI", 505, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NL:[, [, , "1\\d{4,8}|[2-7]\\d{8}|[89]\\d{6,9}", , , , , , , [5, 6, 7, 8, 9, 10]], [, , "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d{2}|8[478]\\d)\\d{6}", 
, , , "101234567", , , [9]], [, , "6[1-58]\\d{7}", , , , "612345678", , , [9]], [, , "800\\d{4,7}", , , , "8001234", , , [7, 8, 9, 10]], [, , "90[069]\\d{4,7}", , , , "9061234", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:6760|85\\d{2})\\d{5}", , , , "851234567", , , [9]], "NL", 31, "00", "0", , , "0", , , , [[, "([1-578]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1[035]|2[0346]|3[03568]|4[0356]|5[0358]|7|8[4578]"], "0$1"], [, "([1-5]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", 
["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], [, "(6)(\\d{8})", "$1 $2", ["6[0-57-9]"], "0$1"], [, "(66)(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(14)(\\d{3,4})", "$1 $2", ["14"], "$1"], [, "([89]0\\d)(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"]], , [, , "66\\d{7}", , , , "662345678", , , [9]], , , [, , "140(?:1(?:[035]|[16-8]\\d)|2(?:[0346]|[259]\\d)|3(?:[03568]|[124]\\d)|4(?:[0356]|[17-9]\\d)|5(?:[0358]|[124679]\\d)|7\\d|8[458])", , , , "14023", , , [5, 6]], [, , "140(?:1(?:[035]|[16-8]\\d)|2(?:[0346]|[259]\\d)|3(?:[03568]|[124]\\d)|4(?:[0356]|[17-9]\\d)|5(?:[0358]|[124679]\\d)|7\\d|8[458])", 
, , , "14020", , , [5, 6]], , , [, , , , , , , , , [-1]]], NO:[, [, , "0\\d{4}|[2-9]\\d{7}", , , , , , , [5, 8]], [, , "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", , , , "21234567", , , [8]], [, , "(?:4[015-8]|5[89]|87|9\\d)\\d{6}", , , , "40612345", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", 
, , , "85012345", , , [8]], "NO", 47, "00", , , , , , , , [[, "([489]\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]"]], [, "([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , "0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}", , , , "01234"], , , [, , "81[23]\\d{5}", , , , "81212345", , , [8]]], NP:[, [, , "[1-8]\\d{7}|9(?:[1-69]\\d{6,8}|7[2-6]\\d{5,7}|8\\d{8})", , , , , , , [8, 10], [6, 7]], [, , "(?:1[0-6]\\d|2[13-79][2-6]|3[135-8][2-6]|4[146-9][2-6]|5[135-7][2-6]|6[13-9][2-6]|7[15-9][2-6]|8[1-46-9][2-6]|9[1-79][2-6])\\d{5}", 
, , , "14567890", , , [8], [6, 7]], [, , "9(?:6[0-3]|7[245]|8[0-24-68])\\d{7}", , , , "9841234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NP", 977, "00", "0", , , "0", , , , [[, "(1)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [, "(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-69]|7[15-9])"], "0$1"], [, "(9\\d{2})(\\d{7})", "$1-$2", ["9(?:6[013]|7[245]|8)"], "$1"]], , [, , , , , , , , , [-1]], , , 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NR:[, [, , "[458]\\d{6}", , , , , , , [7]], [, , "(?:444|888)\\d{4}", , , , "4441234"], [, , "55[4-9]\\d{4}", , , , "5551234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NR", 674, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , 
, , , , , , [-1]]], NU:[, [, , "[1-5]\\d{3}", , , , , , , [4]], [, , "[34]\\d{3}", , , , "4002"], [, , "[125]\\d{3}", , , , "1234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NU", 683, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NZ:[, [, , "6[235-9]\\d{6}|[2-57-9]\\d{7,9}", , , , , , , [8, 9, 10], [7]], [, , "(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}|24099\\d{3}", 
, , , "32345678", , , [8], [7]], [, , "2(?:[028]\\d{7,8}|1\\d{6,8}|[79]\\d{7})", , , , "211234567"], [, , "508\\d{6,7}|80\\d{6,8}", , , , "800123456"], [, , "90\\d{6,7}", , , , "900123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , "70\\d{7}", , , , "701234567", , , [9]], [, , , , , , , , , [-1]], "NZ", 64, "0(?:0|161)", "0", , , "0", , "00", , [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["240|[346]|7[2-57-9]|9[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,5})", 
"$1 $2 $3", ["2(?:1[1-9]|[69]|7[0-35-9])|70|86"], "0$1"], [, "(2\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["2[028]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["90"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|5|[89]0"], "0$1"]], , [, , "[28]6\\d{6,7}", , , , "26123456", , , [8, 9]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], OM:[, [, , "(?:5|[279]\\d)\\d{6}|800\\d{5,6}", , , , , , , [7, 8, 9]], [, , "2[2-6]\\d{6}", , , , "23123456", 
, , [8]], [, , "7[19]\\d{6}|9(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "92123456", , , [8]], [, , "8007\\d{4,5}|500\\d{4}", , , , "80071234"], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "OM", 968, "00", , , , , , , , [[, "(2\\d)(\\d{6})", "$1 $2", ["2"]], [, "([79]\\d{3})(\\d{4})", "$1 $2", ["[79]"]], [, "([58]00)(\\d{4,6})", "$1 $2", ["[58]00"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , 
[-1]], , , [, , , , , , , , , [-1]]], PA:[, [, , "[1-9]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:1(?:0[0-8]|1[49]|2[37]|3[0137]|4[147]|5[05]|6[58]|7[0167]|8[58]|9[139])|2(?:[0235679]\\d|1[0-7]|4[04-9]|8[028])|3(?:[089]\\d|1[014-7]|2[0-35]|3[03]|4[0-579]|55|6[068]|7[06-8])|4(?:3[013-69]|4\\d|7[0-589])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-267]|3[06]|[469]0|5[06-9]|7[0-24-79]|8[7-9])|8(?:09|[34]\\d|5[0134]|8[02])|9(?:0[6-9]|1[016-8]|2[036-8]|3[3679]|40|5[0489]|6[06-9]|7[046-9]|8[36-8]|9[1-9]))\\d{4}", 
, , , "2001234", , , [7]], [, , "(?:1[16]1|21[89]|8(?:1[01]|7[23]))\\d{4}|6(?:[024-9]\\d|1[0-5]|3[0-24-9])\\d{5}", , , , "61234567"], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , "(?:8(?:55|60|7[78])|9(?:00|81))\\d{4}", , , , "8601234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PA", 507, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["6"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , 
[-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PE:[, [, , "[14-9]\\d{7,8}", , , , , , , [8, 9], [6, 7]], [, , "(?:1\\d|4[1-4]|5[1-46]|6[1-7]|7[2-46]|8[2-4])\\d{6}", , , , "11234567", , , [8], [6, 7]], [, , "9\\d{8}", , , , "912345678", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "805\\d{5}", , , , "80512345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , "80[24]\\d{5}", , , , "80212345", , , [8]], [, , , , , , , , , [-1]], "PE", 51, "19(?:1[124]|77|90)00", 
"0", " Anexo ", , "0", , , , [[, "(1)(\\d{7})", "$1 $2", ["1"], "(0$1)"], [, "([4-8]\\d)(\\d{6})", "$1 $2", ["[4-7]|8[2-4]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], [, "(9\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PF:[, [, , "4\\d{5,7}|8\\d{7}", , , , , , , [6, 8]], [, , "4(?:[09][45689]\\d|4)\\d{4}", , , , "40412345"], [, , "8[79]\\d{6}", , , , "87123456", 
, , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PF", 689, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4[09]|8[79]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]]], , [, , , , , , , , , [-1]], , , [, , "44\\d{4}", , , , "441234", , , [6]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PG:[, [, , "[1-9]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:3[0-2]\\d|4[257]\\d|5[34]\\d|64[1-9]|77(?:[0-24]\\d|30)|85[02-46-9]|9[78]\\d)\\d{4}", 
, , , "3123456", , , [7]], [, , "7(?:[0-689]\\d|75)\\d{5}", , , , "70123456", , , [8]], [, , "180\\d{4}", , , , "1801234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "2(?:0[0-47]|7[568])\\d{4}", , , , "2751234", , , [7]], "PG", 675, "140[1-3]|00", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[13-689]|27"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["20|7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, 
, , , , , , , , [-1]]], PH:[, [, , "1\\d{10,12}|2\\d{5,7}|[3-7]\\d{8}|8\\d{7,9}|9\\d{9}", , , , , , , [6, 8, 9, 10, 11, 12, 13], [5, 7]], [, , "2\\d{5}(?:\\d{2})?|(?:3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578]|8[2-8])\\d{7}|88(?:22\\d{6}|42\\d{4})", , , , "21234567", , , [6, 8, 9, 10], [5, 7]], [, , "(?:81[37]|9(?:0[5-9]|1[024-9]|2[0-35-9]|3[02-9]|4[235-9]|5[056]|6[5-7]|7[34-79]|89|9[4-9]))\\d{7}", , , , "9051234567", , , [10]], [, , "1800\\d{7,9}", , , , "180012345678", , , [11, 12, 13]], [, , , , , 
, , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PH", 63, "00", "0", , , "0", , , , [[, "(2)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [, "(2)(\\d{5})", "$1 $2", ["2"], "(0$1)"], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], [, "(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", 
"3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], [, "([3-8]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["81|9"], "0$1"], [, "(1800)(\\d{3})(\\d{4})", "$1 $2 $3", ["180", "1800"]], [, "(1800)(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["180", "1800"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PK:[, [, , "1\\d{8}|[2-8]\\d{5,11}|9(?:[013-9]\\d{4,10}|2\\d(?:111\\d{6}|\\d{3,7}))", 
, , , , , , [8, 9, 10, 11, 12], [6, 7]], [, , "(?:21|42)[2-9]\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}|58[126]\\d{7}", , , , "2123456789", , , [9, 10], [6, 7, 8]], [, , "3(?:[014]\\d|2[0-5]|3[0-7]|55|64)\\d{7}", , , , "3012345678", , , [10]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "900\\d{5}", , , , 
"90012345", , , [8]], [, , , , , , , , , [-1]], [, , "122\\d{6}", , , , "122044444", , , [9]], [, , , , , , , , , [-1]], "PK", 92, "00", "0", , , "0", , , , [[, "([89]00)(\\d{3})(\\d{2})", "$1 $2 $3", ["[89]00"], "0$1"], [, "(1\\d{3})(\\d{5})", "$1 $2", ["1"], "$1"], [, "(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], [, "(\\d{3})(\\d{6,7})", "$1 $2", ["2[349]|45|54|60|72|8[2-5]|9[2-469]", "(?:2[349]|45|54|60|72|8[2-5]|9[2-469])\\d[2-9]"], "(0$1)"], 
[, "(58\\d{3})(\\d{5})", "$1 $2", ["58[126]"], "(0$1)"], [, "(3\\d{2})(\\d{7})", "$1 $2", ["3"], "0$1"], [, "(\\d{2})(111)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)1", "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)11", "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)111"], "(0$1)"], [, "(\\d{3})(111)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[349]|45|54|60|72|8[2-5]|9[2-9]", "(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d1", "(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d11", 
"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d111"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:[1-8]|0[468])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", , , , "21111825888", , , [11, 12]], , , [, , , , , , , , , [-1]]], PL:[, [, , "[1-57-9]\\d{6,8}|6\\d{5,8}", , , , , , , [6, 7, 8, 9]], [, , "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:\\d{7}|19\\d{3})", 
, , , "123456789", , , [7, 9]], [, , "(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", , , , "512345678", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "70[01346-8]\\d{6}", , , , "701234567", , , [9]], [, , "801\\d{6}", , , , "801234567", , , [9]], [, , , , , , , , , [-1]], [, , "39\\d{7}", , , , "391234567", , , [9]], "PL", 48, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["11[68]|64"]], [, "(\\d{5})", "$1", ["19"]], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]], 
[, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["26|39|45|5[0137]|6[0469]|7[02389]|8[08]"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[14]|2[0-57-9]|3[2-4]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]]], , [, , "64\\d{4,7}", , , , "641234567"], , , [, , , , , , , , , [-1]], [, , "804\\d{6}", , , , "804123456", , , [9]], , , [, , , , , , , , , [-1]]], PM:[, [, , "[45]\\d{5}", , , , , , , [6]], [, , "(?:4[1-3]|50)\\d{4}", , , , "411234"], 
[, , "(?:4[02-4]|5[05])\\d{4}", , , , "551234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PM", 508, "00", "0", , , "0", , , , [[, "([45]\\d)(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PR:[, [, , "[5789]\\d{9}", , , , , , , [10], [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , 
, [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "PR", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "787|939", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PS:[, [, , "1\\d{9}|[24589]\\d{7,8}", 
, , , , , , [8, 9, 10], [7]], [, , "(?:22[234789]|42[45]|82[01458]|92[369])\\d{5}", , , , "22234567", , , [8], [7]], [, , "5[69]\\d{7}", , , , "599123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , , , , , , , , [-1]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PS", 970, "00", "0", , , "0", , , , [[, "([2489])(2\\d{2})(\\d{4})", "$1 $2 $3", ["[2489]2"], "0$1"], [, "(5[69]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["5[69]"], 
"0$1"], [, "(1[78]00)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[78]0", "1[78]00"], "$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PT:[, [, , "[2-46-9]\\d{8}", , , , , , , [9]], [, , "2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}", , , , "212345678"], [, , "9(?:[1236]\\d{2}|480)\\d{5}", , , , "912345678"], [, , "80[02]\\d{6}", , , , "800123456"], [, , "6(?:0[178]|4[68])\\d{6}|76(?:0[1-57]|1[2-47]|2[237])\\d{5}", 
, , , "760123456"], [, , "80(?:8\\d|9[1579])\\d{5}", , , , "808123456"], [, , "884[0-4689]\\d{5}", , , , "884123456"], [, , "30\\d{7}", , , , "301234567"], "PT", 351, "00", , , , , , , , [[, "(2\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], [, "([2-46-9]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[3-9]|[346-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7(?:0(?:7\\d|8[17]))\\d{5}", , , , "707123456"], , , [, , "600\\d{6}", , , , "600110000"]], PW:[, [, , "[2-9]\\d{6}", , , , 
, , , [7]], [, , "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}", , , , "2771234"], [, , "(?:6[234689]0|77\\d|88[0-4])\\d{4}", , , , "6201234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PW", 680, "01[12]", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PY:[, 
[, , "5[0-5]\\d{4,7}|[2-46-9]\\d{5,8}", , , , , , , [6, 7, 8, 9], [5]], [, , "(?:[26]1|3[289]|4[124678]|7[123]|8[1236])\\d{5,7}|(?:2(?:2[4568]|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51)|4(?:18|2[45]|3[12]|5[13]|64|71|9[1-47])|5(?:[1-4]\\d|5[0234])|6(?:3[1-3]|44|7[1-4678])|7(?:17|4[0-4]|6[1-578]|75|8[0-8])|858)\\d{5,6}", , , , "212345678", , , [7, 8, 9], [5, 6]], [, , "9(?:6[12]|[78][1-6]|9[1-5])\\d{6}", , , , "961456789", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , 
, [-1]], [, , , , , , , , , [-1]], [, , "8700[0-4]\\d{4}", , , , "870012345", , , [9]], "PY", 595, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["9[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["870", "8700"]], [, "(\\d{3})(\\d{4,5})", 
"$1 $2", ["[2-8][1-9]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8][1-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[2-9]0\\d{4,7}", , , , "201234567"], , , [, , , , , , , , , [-1]]], QA:[, [, , "[2-8]\\d{6,7}", , , , , , , [7, 8]], [, , "4[04]\\d{6}", , , , "44123456", , , [8]], [, , "[3567]\\d{7}", , , , "33123456", , , [8]], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], "QA", 974, "00", , , , , , , , [[, "([28]\\d{2})(\\d{4})", "$1 $2", ["[28]"]], [, "([3-7]\\d{3})(\\d{4})", "$1 $2", ["[3-7]"]]], , [, , "2(?:[12]\\d|61)\\d{4}", , , , "2123456", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], RE:[, [, , "[268]\\d{8}", , , , , , , [9]], [, , "262\\d{6}", , , , "262161234"], [, , "69(?:2\\d{2}|3(?:0[0-46]|1[013]|2[0-2]|3[0139]|4[0-7]|5[05]|6[0-26]|7[0-27]|8[0-38]|9[0-479]))\\d{4}", , , , "692123456"], 
[, , "80\\d{7}", , , , "801234567"], [, , "89[1-37-9]\\d{6}", , , , "891123456"], [, , "8(?:1[019]|2[0156]|84|90)\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RE", 262, "00", "0", , , "0", , , , [[, "([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[268]"], "0$1"]], , [, , , , , , , , , [-1]], 1, "262|69|8", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], RO:[, [, , "[23]\\d{5,8}|[7-9]\\d{8}", , , , , , , [6, 9]], [, , 
"2(?:1(?:\\d{7}|9\\d{3})|[3-6](?:\\d{7}|\\d9\\d{2}))|3(?:1\\d{4}(?:\\d{3})?|[3-6]\\d{7})", , , , "211234567"], [, , "7(?:[02-7]\\d{2}|1(?:[01]\\d|20)|8[03-8]\\d|99\\d)\\d{5}", , , , "712034567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[036]\\d{6}", , , , "900123456", , , [9]], [, , "801\\d{6}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RO", 40, "00", "0", " int ", , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], 
[, "(\\d{2})(\\d{4})", "$1 $2", ["[23]1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23][3-7]|[7-9]"], "0$1"], [, "(2\\d{2})(\\d{3})", "$1 $2", ["2[3-6]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "37\\d{7}", , , , "372123456", , , [9]], , , [, , , , , , , , , [-1]]], RS:[, [, , "[126-9]\\d{4,11}|3(?:[0-79]\\d{3,10}|8[2-9]\\d{2,9})", , , , , , , [6, 7, 8, 9, 10, 11, 12], [5]], [, , "(?:1(?:[02-9][2-9]|1[1-9])\\d|2(?:[0-24-7][2-9]\\d|[389](?:0[2-9]|[2-9]\\d))|3(?:[0-8][2-9]\\d|9(?:[2-9]\\d|0[2-9])))\\d{3,8}", 
, , , "10234567", , , [7, 8, 9, 10, 11, 12], [5, 6]], [, , "6(?:[0-689]|7\\d)\\d{6,7}", , , , "601234567", , , [8, 9, 10]], [, , "800\\d{3,9}", , , , "80012345"], [, , "(?:90[0169]|78\\d)\\d{3,7}", , , , "90012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RS", 381, "00", "0", , , "0", , , , [[, "([23]\\d{2})(\\d{4,9})", "$1 $2", ["(?:2[389]|39)0"], "0$1"], [, "([1-3]\\d)(\\d{5,10})", "$1 $2", ["1|2(?:[0-24-7]|[389][1-9])|3(?:[0-8]|9[1-9])"], "0$1"], [, "(6\\d)(\\d{6,8})", 
"$1 $2", ["6"], "0$1"], [, "([89]\\d{2})(\\d{3,9})", "$1 $2", ["[89]"], "0$1"], [, "(7[26])(\\d{4,9})", "$1 $2", ["7[26]"], "0$1"], [, "(7[08]\\d)(\\d{4,9})", "$1 $2", ["7[08]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7[06]\\d{4,10}", , , , "700123456"], , , [, , , , , , , , , [-1]]], RU:[, [, , "[347-9]\\d{9}", , , , , , , [10]], [, , "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", 
, , , "3011234567"], [, , "9\\d{9}", , , , "9123456789"], [, , "80[04]\\d{7}", , , , "8001234567"], [, , "80[39]\\d{7}", , , , "8091234567"], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567"], [, , , , , , , , , [-1]], "RU", 7, "810", "8", , , "8", , "8~10", , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1-$2-$3", ["[1-79]"], "$1", , 1], [, "([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[3489]"], "8 ($1)", , 1], [, "(7\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1]], [[, 
"([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[3489]"], "8 ($1)", , 1], [, "(7\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], RW:[, [, , "[027-9]\\d{7,8}", , , , , , , [8, 9]], [, , "2[258]\\d{7}|06\\d{6}", , , , "250123456"], [, , "7[238]\\d{7}", , , , "720123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "900\\d{6}", , , , "900123456", 
, , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RW", 250, "00", "0", , , "0", , , , [[, "(2\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], [, "([7-9]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], [, "(0\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SA:[, [, , "[15]\\d{8}|8\\d{9}|92\\d{7}", , , , , , , [9, 10], [7]], [, , "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", 
, , , "112345678", , , [9], [7]], [, , "(?:5(?:[013-689]\\d|7[0-36-8])|811\\d)\\d{6}", , , , "512345678"], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , "92[05]\\d{6}", , , , "920012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SA", 966, "00", "0", , , "0", , , , [[, "(1\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1[1-467]"], "0$1"], [, "(5\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "(92\\d{2})(\\d{5})", "$1 $2", ["92"], "$1"], [, "(800)(\\d{3})(\\d{4})", 
"$1 $2 $3", ["800"], "$1"], [, "(811)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["811"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SB:[, [, , "[1-9]\\d{4,6}", , , , , , , [5, 7]], [, , "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", , , , "40123", , , [5]], [, , "48\\d{3}|7(?:30|[46-8]\\d|5[025-9]|9[0-5])\\d{4}|8[4-9]\\d{5}|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8])\\d{4}", , , , "7421234"], [, , 
"1[38]\\d{3}", , , , "18123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5[12]\\d{3}", , , , "51123", , , [5]], "SB", 677, "0[01]", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["[7-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SC:[, [, , "[24689]\\d{5,6}", , , , , , , [7]], [, , "4[2-46]\\d{5}", , , , "4217123"], [, , "2[5-8]\\d{5}", , , , "2510123"], [, , "8000\\d{3}", 
, , , "8000000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:64\\d|971)\\d{4}", , , , "6412345"], "SC", 248, "0(?:[02]|10?)", , , , , , "00", , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SD:[, [, , "[19]\\d{8}", , , , , , , [9]], [, , "1(?:[0-25]\\d|8[3567])\\d{6}", , , , "121231234"], [, , "9[0-3569]\\d{7}", , , , "911231234"], 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SD", 249, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", , "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SE:[, [, , "[1-35-9]\\d{5,11}|4\\d{6,8}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "1(?:0[1-8]\\d{6}|[136]\\d{5,7}|(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)\\d{5,6})|2(?:[136]\\d{5,7}|(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])\\d{5,6})|3(?:[356]\\d{5,7}|(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])\\d{5,6})|4(?:[0246]\\d{5,7}|(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])\\d{5,6})|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])\\d{5,6}|6(?:[03]\\d{5,7}|(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])\\d{5,6})|8\\d{6,8}|9(?:0[1-9]\\d{4,6}|(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8])\\d{5,6})", 
, , , "8123456", , , [7, 8, 9]], [, , "7[02369]\\d{7}", , , , "701234567", , , [9]], [, , "20\\d{4,7}", , , , "20123456", , , [6, 7, 8, 9]], [, , "649\\d{6}|9(?:00|39|44)[1-8]\\d{3,6}", , , , "9001234567", , , [7, 8, 9, 10]], [, , "77(?:0\\d{3}(?:\\d{3})?|[1-7]\\d{6})", , , , "771234567", , , [6, 9]], [, , "75[1-8]\\d{6}", , , , "751234567", , , [9]], [, , , , , , , , , [-1]], "SE", 46, "00", "0", , , "0", , , , [[, "(8)(\\d{2,3})(\\d{2,3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [, "([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})", 
"$1-$2 $3 $4", ["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"], "0$1"], [, "([1-469]\\d)(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"], 
"0$1"], [, "(7\\d)(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["7"], "0$1"], [, "(77)(\\d{2})(\\d{2})", "$1-$2$3", ["77"], "0$1"], [, "(20)(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"], [, "(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9[034]"], "0$1"], [, "(9[034]\\d)(\\d{4})", "$1-$2", ["9[034]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["25[245]|67[3-6]"], "0$1"]], [[, "(8)(\\d{2,3})(\\d{2,3})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4", ["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"]], [, "([1-469]\\d)(\\d{3})(\\d{2})", "$1 $2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"]], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"]], [, "(7\\d)(\\d{3})(\\d{2})(\\d{2})", 
"$1 $2 $3 $4", ["7"]], [, "(77)(\\d{2})(\\d{2})", "$1 $2 $3", ["77"]], [, "(20)(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]], [, "(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9[034]"]], [, "(9[034]\\d)(\\d{4})", "$1 $2", ["9[034]"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["25[245]|67[3-6]"]]], [, , "74[02-9]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "(?:25[245]|67[3-6])\\d{9}", , , , "254123456789", , , [12]]], 
SG:[, [, , "[36]\\d{7}|[17-9]\\d{7,10}", , , , , , , [8, 10, 11]], [, , "6[1-9]\\d{6}", , , , "61234567", , , [8]], [, , "(?:8[1-8]|9[0-8])\\d{6}", , , , "81234567", , , [8]], [, , "1?800\\d{7}", , , , "18001234567", , , [10, 11]], [, , "1900\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3[12]\\d{6}", , , , "31234567", , , [8]], "SG", 65, "0[0-3]\\d", , , , , , , , [[, "([3689]\\d{3})(\\d{4})", "$1 $2", ["[369]|8[1-9]"]], [, "(1[89]00)(\\d{3})(\\d{4})", 
"$1 $2 $3", ["1[89]0", "1[89]00"]], [, "(7000)(\\d{4})(\\d{3})", "$1 $2 $3", ["700", "7000"]], [, "(800)(\\d{3})(\\d{4})", "$1 $2 $3", ["800"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7000\\d{7}", , , , "70001234567", , , [11]], , , [, , , , , , , , , [-1]]], SH:[, [, , "[256]\\d{4}|8\\d{3}", , , , , , , [4, 5]], [, , "2(?:[0-57-9]\\d|6[4-9])\\d{2}", , , , "22158"], [, , "[56]\\d{4}", , , , "51234", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , 
, , , , [-1]], [, , , , , , , , , [-1]], [, , "262\\d{2}", , , , "26212", , , [5]], "SH", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SI:[, [, , "[1-7]\\d{6,7}|[89]\\d{4,7}", , , , , , , [5, 6, 7, 8]], [, , "(?:1\\d|[25][2-8]|3[24-8]|4[24-8]|7[3-8])\\d{6}", , , , "11234567", , , [8], [7]], [, , "(?:[37][01]\\d|4[0139]\\d|51\\d|6(?:[48]\\d|5[15-7]|9[69]))\\d{5}", , , , "31234567", , , [8]], [, , "80\\d{4,6}", 
, , , "80123456", , , [6, 7, 8]], [, , "90\\d{4,6}|89[1-3]\\d{2,5}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:59|8[1-3])\\d{6}", , , , "59012345", , , [8]], "SI", 386, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[12]|[34][24-8]|5[2-8]|7[3-8]"], "(0$1)"], [, "([3-7]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], [, "([89][09])(\\d{3,6})", "$1 $2", ["[89][09]"], "0$1"], [, "([58]\\d{2})(\\d{5})", "$1 $2", 
["59|8[1-3]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SJ:[, [, , "0\\d{4}|[45789]\\d{7}", , , , , , , [5, 8]], [, , "79\\d{6}", , , , "79123456", , , [8]], [, , "(?:4[015-8]|5[89]|9\\d)\\d{6}", , , , "41234567", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", 
, , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "SJ", 47, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}", , , , "01234"], , , [, , "81[23]\\d{5}", , , , "81212345", , , [8]]], SK:[, [, , "(?:[2-68]\\d{5,8}|9\\d{6,8})", , , , , , , [6, 7, 9]], [, , "2(?:1(?:6\\d{3,4}|7\\d{3})|[2-9]\\d{7})|[3-5][1-8](?:1(?:6\\d{2,3}|7\\d{3})|\\d{7})", , , , "221234567"], [, , "9(?:0(?:[1-8]\\d|9[1-9])|(?:1[0-24-9]|[45]\\d)\\d)\\d{5}", 
, , , "912123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:[78]\\d{7}|00\\d{6})", , , , "900123456", , , [9]], [, , "8[5-9]\\d{7}", , , , "850123456", , , [9]], [, , , , , , , , , [-1]], [, , "6(?:02|5[0-4]|9[0-6])\\d{6}", , , , "690123456", , , [9]], "SK", 421, "00", "0", , , "0", , , , [[, "(2)(1[67])(\\d{3,4})", "$1 $2 $3", ["21[67]"], "0$1"], [, "([3-5]\\d)(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5]"], "0$1"], [, "(2)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], 
[, "([3-5]\\d)(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"], [, "([689]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(9090)(\\d{3})", "$1 $2", ["909", "9090"], "0$1"]], , [, , "9090\\d{3}", , , , "9090123", , , [7]], , , [, , "(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}|9090\\d{3}", , , , "800123456", , , [7, 9]], [, , "96\\d{7}", , , , "961234567", , , [9]], , , [, , , , , , , , , [-1]]], SL:[, [, , "[2-9]\\d{7}", , , , , , , [8], [6]], [, , "[235]2[2-4][2-9]\\d{4}", 
, , , "22221234", , , , [6]], [, , "(?:2[15]|3[03-5]|4[04]|5[05]|66|7[5-9]|8[08]|99)\\d{6}", , , , "25123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SL", 232, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", , "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SM:[, [, , "[05-7]\\d{7,9}", , , , , , , [8, 10], [6]], [, , 
"0549(?:8[0157-9]|9\\d)\\d{4}", , , , "0549886377", , , [10], [6]], [, , "6[16]\\d{6}", , , , "66661212", , , [8]], [, , , , , , , , , [-1]], [, , "7[178]\\d{6}", , , , "71123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5[158]\\d{6}", , , , "58001110", , , [8]], "SM", 378, "00", , , , "([89]\\d{5})", "0549$1", , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(0549)(\\d{6})", "$1 $2", ["054", "0549"]], [, "(\\d{6})", "0549 $1", ["[89]"]]], [[, 
"(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(0549)(\\d{6})", "($1) $2", ["054", "0549"]], [, "(\\d{6})", "(0549) $1", ["[89]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SN:[, [, , "[3789]\\d{8}", , , , , , , [9]], [, , "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}", , , , "301012345"], [, , "7(?:[06-8]\\d|21|90)\\d{6}", , , , "701234567"], [, , "800\\d{6}", , , , "800123456"], [, , "88[4689]\\d{6}", 
, , , "884123456"], [, , "81[02468]\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "39[01]\\d{6}|3392\\d{5}|93330\\d{4}", , , , "933301234"], "SN", 221, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SO:[, [, , "[1-9]\\d{5,8}", , , , , , , [6, 7, 8, 9]], [, , "(?:1\\d{1,2}|2[0-79]\\d|3[0-46-8]?\\d|4[0-7]?\\d|59\\d|8[125])\\d{4}", 
, , , "4012345", , , [6, 7]], [, , "(?:15\\d|2(?:4\\d|8)|3[59]\\d{2}|4[89]\\d{2}|6[1-9]?\\d{2}|7(?:[1-8]\\d|9\\d{1,2})|8[08]\\d{2}|9(?:0[67]|[2-9])\\d)\\d{5}", , , , "71123456", , , [7, 8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SO", 252, "00", "0", , , "0", , , , [[, "(\\d{6})", "$1", ["[134]"]], [, "(\\d)(\\d{6})", "$1 $2", ["[13-5]|2[0-79]"]], [, "(\\d)(\\d{7})", "$1 $2", ["24|[67]"]], [, "(\\d{2})(\\d{4})", 
"$1 $2", ["8[125]"]], [, "(\\d{2})(\\d{5,7})", "$1 $2", ["15|28|6[1-35-9]|799|9[2-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3[59]|4[89]|6[24-6]|79|8[08]|90"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SR:[, [, , "[2-8]\\d{5,6}", , , , , , , [6, 7]], [, , "(?:2[1-3]|3[0-7]|4\\d|5[2-58]|68\\d)\\d{4}", , , , "211234"], [, , "(?:7[124-7]|8[125-9])\\d{5}", , , , "7412345", , , [7]], [, , , , , , , , , [-1]], [, , , , 
, , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "56\\d{4}", , , , "561234", , , [6]], "SR", 597, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1-$2", ["[2-4]|5[2-58]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SS:[, [, , "[19]\\d{8}", , , , , , , [9]], [, , "18\\d{7}", , , , "181234567"], [, , "(?:12|9[1257])\\d{7}", 
, , , "977123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SS", 211, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", , "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ST:[, [, , "[29]\\d{6}", , , , , , , [7]], [, , "22\\d{5}", , , , "2221234"], [, , "9(?:0(?:0[5-9]|[1-9]\\d)|[89]\\d{2})\\d{3}", , , , "9812345"], 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ST", 239, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SV:[, [, , "[267]\\d{7}|[89]\\d{6}(?:\\d{4})?", , , , , , , [7, 8, 11]], [, , "2[1-6]\\d{6}", , , , "21234567", , , [8]], [, , "[67]\\d{7}", , , , "70123456", , , [8]], [, , "800\\d{4}(?:\\d{4})?", 
, , , "8001234", , , [7, 11]], [, , "900\\d{4}(?:\\d{4})?", , , , "9001234", , , [7, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SV", 503, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SX:[, [, , "[5789]\\d{9}", , , , , , , [10], 
[7]], [, , "7215(?:4[2-8]|8[239]|9[056])\\d{4}", , , , "7215425678", , , , [7]], [, , "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", , , , "7215205678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "SX", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "721", [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SY:[, [, , "[1-59]\\d{7,8}", , , , , , , [8, 9], [6, 7]], [, , "(?:1(?:1\\d?|4\\d|[2356])|2(?:1\\d?|[235])|3(?:[13]\\d|4)|4[13]|5[1-3])\\d{6}", , , , "112345678", , , , [6, 7]], [, , "9(?:22|[3-589]\\d|6[024-9])\\d{6}", , , , "944567890", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SY", 963, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", 
"$1 $2 $3", ["[1-5]"], "0$1", , 1], [, "(9\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SZ:[, [, , "[027]\\d{7}", , , , , , , [8]], [, , "2[2-9]\\d{6}", , , , "22171234"], [, , "7[6-9]\\d{6}", , , , "76123456"], [, , "0800\\d{4}", , , , "08001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SZ", 268, "00", , 
, , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[027]"]]], , [, , , , , , , , , [-1]], , , [, , "0800\\d{4}", , , , "08001234"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TA:[, [, , "8\\d{3}", , , , , , , [4]], [, , "8\\d{3}", , , , "8999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TA", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TC:[, [, , "[5689]\\d{9}", , , , , , , [10], [7]], [, , "649(?:712|9(?:4\\d|50))\\d{4}", , , , "6497121234", , , , [7]], [, , "649(?:2(?:3[129]|4[1-7])|3(?:3[1-389]|4[1-8])|4[34][1-3])\\d{4}", , , , "6492311234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , "64971[01]\\d{4}", 
, , , "6497101234", , , , [7]], "TC", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "649", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TD:[, [, , "[2679]\\d{7}", , , , , , , [8]], [, , "22(?:[3789]0|5[0-5]|6[89])\\d{4}", , , , "22501234"], [, , "(?:6[023568]\\d|77\\d|9\\d{2})\\d{5}", , , , "63012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TD", 235, "00|16", 
, , , , , "00", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TG:[, [, , "[279]\\d{7}", , , , , , , [8]], [, , "2(?:2[2-7]|3[23]|44|55|66|77)\\d{5}", , , , "22212345"], [, , "(?:7[09]|9[0-36-9])\\d{6}", , , , "90112345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TG", 228, "00", , , 
, , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TH:[, [, , "1\\d{8,9}|[2-9]\\d{7,8}", , , , , , , [8, 9, 10]], [, , "(?:2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", , , , "21234567", , , [8]], [, , "(?:14|6[1-6]|[89]\\d)\\d{7}", , , , "812345678", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , "1900\\d{6}", , , , "1900123456", , , [10]], [, 
, , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "6[08]\\d{7}", , , , "601234567", , , [9]], "TH", 66, "00", "0", , , "0", , , , [[, "(2)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "([13-9]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["14|[3-9]"], "0$1"], [, "(1[89]00)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[89]0", "1[89]00"], "$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TJ:[, [, , "[3-57-9]\\d{8}", , , , , , , [9], [3, 5, 
7]], [, , "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}", , , , "372123456", , , , [3, 5, 7]], [, , "(?:41[18]|(?:5[05]|77|88|9[0-35-9])\\d)\\d{6}", , , , "917123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TJ", 992, "810", "8", , , "8", , "8~10", , [[, "([349]\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"], , , 1], [, "([457-9]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[148]|[578]|9(?:[0235-9]|1[59])"], 
, , 1], [, "(331700)(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317", "33170", "331700"], , , 1], [, "(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]", "3(?:[1245]|3(?:[02-9]|1[0-589]))"], , , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TK:[, [, , "[2-47]\\d{3,6}", , , , , , , [4, 5, 6, 7]], [, , "(?:2[2-4]|[34]\\d)\\d{2,5}", , , , "3101"], [, , "7[2-4]\\d{2,5}", , , , "7290"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TK", 690, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TL:[, [, , "[2-489]\\d{6}|7\\d{6,7}", , , , , , , [7, 8]], [, , "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", , , , "2112345", , , [7]], [, , "7[3-8]\\d{6}", , , , "77212345", , , [8]], [, , "80\\d{5}", , , , "8012345", , , [7]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , 
, [-1]], [, , "70\\d{5}", , , , "7012345", , , [7]], [, , , , , , , , , [-1]], "TL", 670, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["7[3-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TM:[, [, , "[1-6]\\d{7}", , , , , , , [8]], [, , "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}", , , , "12345678"], 
[, , "6[1-9]\\d{6}", , , , "66123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TM", 993, "810", "8", , , "8", , "8~10", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["13|[2-5]"], "(8 $1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , 
[, , , , , , , , , [-1]]], TN:[, [, , "[2-57-9]\\d{7}", , , , , , , [8]], [, , "3(?:[012]\\d|6[0-4]|91)\\d{5}|7\\d{7}|81200\\d{3}", , , , "71234567"], [, , "(?:[259]\\d|4[0-6])\\d{6}", , , , "20123456"], [, , "8010\\d{4}", , , , "80101234"], [, , "88\\d{6}", , , , "88123456"], [, , "8[12]10\\d{4}", , , , "81101234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TN", 216, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TO:[, [, , "[02-8]\\d{4,6}", , , , , , , [5, 7]], [, , "(?:2\\d|3[1-8]|4[1-4]|[56]0|7[0149]|8[05])\\d{3}", , , , "20123", , , [5]], [, , "(?:7[578]|8[47-9])\\d{5}", , , , "7715123", , , [7]], [, , "0800\\d{3}", , , , "0800222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TO", 676, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1-$2", ["[1-6]|7[0-4]|8[05]"]], [, "(\\d{3})(\\d{4})", 
"$1 $2", ["7[5-9]|8[47-9]"]], [, "(\\d{4})(\\d{3})", "$1 $2", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TR:[, [, , "[2-589]\\d{9}|444\\d{4}", , , , , , , [7, 10]], [, , "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", , , , "2123456789", , , [10]], [, , "5(?:(?:0[1-7]|22|[34]\\d|5[1-59]|9[246])\\d{2}|1616|6161)\\d{5}", , , , "5012345678", 
, , [10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TR", 90, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[23]|4(?:[0-35-9]|4[0-35-9])"], "(0$1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[02-69]|16)"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["51|[89]"], "0$1", , 1], [, "(444)(\\d{1})(\\d{3})", 
"$1 $2 $3", ["444"], , , 1]], , [, , "512\\d{7}", , , , "5123456789", , , [10]], , , [, , "444\\d{4}", , , , "4441444", , , [7]], [, , "444\\d{4}|850\\d{7}", , , , "4441444"], , , [, , , , , , , , , [-1]]], TT:[, [, , "[589]\\d{9}", , , , , , , [10], [7]], [, , "868(?:2(?:01|[23]\\d)|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}", , , , "8682211234", , , , [7]], [, , "868(?:2(?:6[6-9]|[789]\\d)|3(?:0[1-9]|1[02-9]|[2-9]\\d)|4[6-9]\\d|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}", 
, , , "8682911234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "TT", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "868", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "868619\\d{4}", , , , "8686191234", , , , [7]]], TV:[, [, , "[279]\\d{4,6}", , , , , , , [5, 6, 
7]], [, , "2[02-9]\\d{3}", , , , "20123", , , [5]], [, , "(?:70\\d|90)\\d{4}", , , , "901234", , , [6, 7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TV", 688, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TW:[, [, , "2\\d{6,8}|[3-689]\\d{7,8}|7\\d{7,9}", , , , , , , [7, 8, 9, 10]], [, , "(?:2(?:[235-8]\\d{3}|4\\d{2,3})|3[2-9]\\d{2}|4(?:[239]\\d|[78])\\d{2}|5[2-8]\\d{2}|6[235-79]\\d{2}|7[1-9]\\d{2}|8(?:2(?:3\\d|66)|[7-9]\\d{2}))\\d{4}", 
, , , "221234567", , , [8, 9]], [, , "9[0-8]\\d{7}", , , , "912345678", , , [9]], [, , "80[0-79]\\d{6}", , , , "800123456", , , [9]], [, , "20(?:2|[013-9]\\d{2})\\d{4}", , , , "203123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "99\\d{7}", , , , "990123456", , , [9]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "TW", 886, "0(?:0[25679]|19)", "0", "#", , "0", , , , [[, "(20)(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], [, "([258]0)(\\d{3})(\\d{4})", "$1 $2 $3", ["20[013-9]|50[0-46-9]|80[0-79]"], 
"0$1"], [, "([2-8])(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[25][2-8]|[346]|[78][1-9]"], "0$1"], [, "(9\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], [, "(70)(\\d{4})(\\d{4})", "$1 $2 $3", ["70"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "50[0-46-9]\\d{6}", , , , "500123456", , , [9]], , , [, , , , , , , , , [-1]]], TZ:[, [, , "\\d{9}", , , , , , , [7, 9]], [, , "2[2-8]\\d{7}", , , , "222345678"], [, , "(?:6[2-9]|7[13-9])\\d{7}", , , , "621234567", , , [9]], [, , "80[08]\\d{6}", 
, , , "800123456", , , [9]], [, , "90\\d{7}", , , , "900123456", , , [9]], [, , "8(?:40|6[01])\\d{6}", , , , "840123456", , , [9]], [, , , , , , , , , [-1]], [, , "41\\d{7}", , , , "412345678", , , [9]], "TZ", 255, "00[056]", "0", , , "0", , , , [[, "([24]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], [, "([67]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"], [, "([89]\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "(?:8(?:[04]0|6[01])|90\\d)\\d{6}", 
, , , "800123456", , , [9]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UA:[, [, , "[3-9]\\d{8}", , , , , , , [9], [5, 6, 7]], [, , "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", , , , "311234567", , , , [5, 6, 7]], [, , "(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}", , , , "391234567"], [, , "800\\d{6}", , , , "800123456"], [, , "900[2-49]\\d{5}", , , , "900212345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "89[1-579]\\d{6}", , , , "891234567"], "UA", 380, "00", "0", , , "0", 
, "0~0", , [[, "([3-9]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[38]9|4(?:[45][0-5]|87)|5(?:0|[67][37])|6[36-8]|7|9[1-9]", "[38]9|4(?:[45][0-5]|87)|5(?:0|6(?:3[14-7]|7)|7[37])|6[36-8]|7|9[1-9]"], "0$1"], [, "([3-689]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["(?:3[1-8]|4[136-8])2|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90", "3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90"], "0$1"], [, "([3-6]\\d{3})(\\d{5})", "$1 $2", ["3(?:[1-46-8]|5[013-9])|4(?:[137][013-9]|[45][6-9]|6|8[4-6])|5(?:[1245][013-9]|3|6[0135689]|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])", 
"3(?:[1-46-8](?:[013-9]|22)|5[013-9])|4(?:[137][013-9]|[45][6-9]|6(?:[013-9]|22)|8[4-6])|5(?:[1245][013-9]|3|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UG:[, [, , "\\d{9}", , , , , , , [9], [5, 6, 7]], [, , "20(?:[0147]\\d{3}|2(?:40|[5-9]\\d)\\d|3(?:0[0-4]|[2367]\\d)\\d|5[0-4]\\d{2}|6(?:00[0-2]|30[0-4]|[5-9]\\d{2})|8[0-2]\\d{2})\\d{3}|[34]\\d{8}", 
, , , "312345678", , , , [5, 6, 7]], [, , "7(?:0[0-7]\\d|[1578]\\d{2}|2(?:[03]\\d|60)|30\\d|4[0-4]\\d|9(?:[0-6]\\d|74))\\d{5}", , , , "712345678"], [, , "800[123]\\d{5}", , , , "800123456"], [, , "90[123]\\d{6}", , , , "901123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UG", 256, "00[057]", "0", , , "0", , , , [[, "(\\d{3})(\\d{6})", "$1 $2", ["20[0-8]|4(?:6[45]|[7-9])|[7-9]", "20(?:[013-8]|2[5-9])|4(?:6[45]|[7-9])|[7-9]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", 
["3|4(?:[1-5]|6[0-36-9])"], "0$1"], [, "(2024)(\\d{5})", "$1 $2", ["202", "2024"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], US:[, [, , "[2-9]\\d{9}", , , , , , , [10], [7]], [, , "(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[012])|7(?:0[1-46-8]|1[02-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-258]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[014678]|4[0179]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}", 
, , , "2015550123", , , , [7]], [, , "(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[012])|7(?:0[1-46-8]|1[02-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-258]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[014678]|4[0179]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}", 
, , , "2015550123", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "US", 1, "011", "1", , , "1", , , 1, [[, "(\\d{3})(\\d{4})", "$1-$2", , , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", , , , 1]], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3"]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , 
, [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UY:[, [, , "[2489]\\d{6,7}", , , , , , , [7, 8]], [, , "2\\d{7}|4[2-7]\\d{6}", , , , "21231234", , , [8], [7]], [, , "9[1-9]\\d{6}", , , , "94231234", , , [8]], [, , "80[05]\\d{4}", , , , "8001234", , , [7]], [, , "90[0-8]\\d{4}", , , , "9001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UY", 598, "0(?:1[3-9]\\d|0)", "0", " int. ", , "0", , "00", , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[24]"]], 
[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9[1-9]"], "0$1"], [, "(\\d{3})(\\d{4})", "$1 $2", ["[89]0"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UZ:[, [, , "[679]\\d{8}", , , , , , , [9], [7]], [, , "(?:6(?:1(?:22|3[124]|4[1-4]|5[123578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d{2}|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[12456]|9[135-8])|1[12]\\d|2(?:22|3[1345789]|4[123579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}", 
, , , "662345678", , , , [7]], [, , "6(?:1(?:2(?:98|2[01])|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:11\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4])|7\\d{2})|5(?:19[01]|2(?:27|9[26])|30\\d|59\\d|7\\d{2})|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|3[79]\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79])|9[0-3]\\d)|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|5\\d|3[01]|7[0-4])|5[67]\\d|6(?:2[0-26]|8\\d)|7\\d{2}))\\d{4}|7(?:0\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|33\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078])|9[4-6]\\d)|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0127]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[05629]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07])))\\d{4}|9[0-57-9]\\d{7}", 
, , , "912345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UZ", 998, "810", "8", , , "8", , "8~10", , [[, "([679]\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[679]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VA:[, [, , "(?:0(?:878\\d{5}|6698\\d{5})|[1589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9}))", , , , , , , [6, 8, 9, 
10, 11]], [, , "06698\\d{5}", , , , "0669812345", , , [10]], [, , "3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})", , , , "3123456789", , , [9, 10, 11]], [, , "80(?:0\\d{6}|3\\d{3})", , , , "800123456", , , [6, 9]], [, , "0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{6}|[17]\\d{3})", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, 
, "55\\d{8}", , , , "5512345678", , , [10]], "VA", 39, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , "848\\d{6}", , , , "848123456", , , [9]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VC:[, [, , "[5789]\\d{9}", , , , , , , [10], [7]], [, , "784(?:266|3(?:6[6-9]|7\\d|8[0-24-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}", , , , "7842661234", , , , [7]], [, , "784(?:4(?:3[0-5]|5[45]|89|9[0-58])|5(?:2[6-9]|3[0-4]))\\d{4}", , , , "7844301234", , , , [7]], [, 
, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VC", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "784", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VE:[, [, , "[24589]\\d{9}", , , , , , , [10], [7]], [, , "(?:2(?:12|3[457-9]|[58][1-9]|[467]\\d|9[1-6])|50[01])\\d{7}", 
, , , "2121234567", , , , [7]], [, , "4(?:1[24-8]|2[46])\\d{7}", , , , "4121234567"], [, , "800\\d{7}", , , , "8001234567"], [, , "900\\d{7}", , , , "9001234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "VE", 58, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{7})", "$1-$2", , "0$1", "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VG:[, [, , "[2589]\\d{9}", , , , , , , [10], [7]], [, 
, "284(?:(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}|496[0-5]\\d{3})", , , , "2842291234", , , , [7]], [, , "284(?:(?:3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|99)|54[0-57])\\d{4}|496[6-9]\\d{3})", , , , "2843001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VG", 1, "011", "1", , , "1", 
, , , , , [, , , , , , , , , [-1]], , "284", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VI:[, [, , "[3589]\\d{9}", , , , , , , [10], [7]], [, , "340(?:2(?:01|2[0678]|44|77)|3(?:32|44)|4(?:22|7[34])|5(?:1[34]|55)|6(?:26|4[23]|77|9[023])|7(?:1[2-589]|27|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], [, , "340(?:2(?:01|2[0678]|44|77)|3(?:32|44)|4(?:22|7[34])|5(?:1[34]|55)|6(?:26|4[23]|77|9[023])|7(?:1[2-589]|27|7\\d)|884|998)\\d{4}", , , , "3406421234", 
, , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VI", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "340", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VN:[, [, , "1\\d{6,9}|2\\d{9}|6\\d{6,7}|7\\d{6}|8\\d{6,8}|9\\d{8}", , , , , , , [7, 8, 9, 10]], 
[, , "2(?:0[3-9]|1[0-689]|2[0-25-9]|3[2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|8[2-7]|9[0-4679])\\d{7}", , , , "2101234567", , , [10]], [, , "(?:9\\d|1(?:2\\d|6[2-9]|8[68]|99))\\d{7}|8(?:6[89]|8\\d|9[89])\\d{6}", , , , "912345678", , , [9, 10]], [, , "1800\\d{4,6}", , , , "1800123456", , , [8, 9, 10]], [, , "1900\\d{4,6}", , , , "1900123456", , , [8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "VN", 84, "00", "0", , , "0", , , , [[, "([17]99)(\\d{4})", "$1 $2", 
["[17]99"], "0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", , 1], [, "(80)(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(69\\d)(\\d{4,5})", "$1 $2", ["69"], "0$1", , 1], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2[0-35-79]"], "0$1", , 1], [, "([89]\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8(?:8|9[89])|9"], "0$1", , 1], [, "(1[2689]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:[26]|8[68]|99)"], "0$1", , 1], [, "(86[89])(\\d{3})(\\d{3})", "$1 $2 $3", ["86[89]"], "0$1", 
, 1], [, "(1[89]00)(\\d{4,6})", "$1 $2", ["1[89]0", "1[89]00"], "$1", , 1]], , [, , , , , , , , , [-1]], , , [, , "[17]99\\d{4}|69\\d{5,6}", , , , "1992000", , , [7, 8]], [, , "[17]99\\d{4}|69\\d{5,6}|80\\d{5}", , , , "1992000", , , [7, 8]], , , [, , , , , , , , , [-1]]], VU:[, [, , "[2-57-9]\\d{4,6}", , , , , , , [5, 7]], [, , "(?:2[02-9]\\d|3(?:[5-7]\\d|8[0-8])|48[4-9]|88\\d)\\d{2}", , , , "22123", , , [5]], [, , "(?:5(?:7[2-5]|[0-689]\\d)|7[013-7]\\d)\\d{4}", , , , "5912345", , , [7]], [, , , 
, , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "VU", 678, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[579]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "3[03]\\d{3}|900\\d{4}", , , , "30123"], , , [, , , , , , , , , [-1]]], WF:[, [, , "[4-8]\\d{5}", , , , , , , [6]], [, , "(?:50|68|72)\\d{4}", , , , "501234"], [, , "(?:50|68|72|8[23])\\d{4}", , , , "501234"], [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WF", 681, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "[48]0\\d{4}", , , , "401234"]], WS:[, [, , "[2-8]\\d{4,6}", , , , , , , [5, 6, 7]], [, , "(?:[2-5]\\d|6[1-9]|84\\d{2})\\d{3}", , , , "22123", , , [5, 7]], [, , "(?:60|7[25-7]\\d)\\d{4}", , , , "601234", , , [6, 7]], [, , "800\\d{3}", 
, , , "800123", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WS", 685, "0", , , , , , , , [[, "(8\\d{2})(\\d{3,4})", "$1 $2", ["8"]], [, "(7\\d)(\\d{5})", "$1 $2", ["7"]], [, "(\\d{5})", "$1", ["[2-6]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], XK:[, [, , "[23][89]\\d{6,7}|4[3-79]\\d{6}|[89]00\\d{5}", , , , , , , [8, 9]], [, , "(?:2[89]0?|3(?:8|90?))\\d{6}", 
, , , "28012345"], [, , "4[3-79]\\d{6}", , , , "43201234", , , [8]], [, , "800\\d{5}", , , , "80001234", , , [8]], [, , "900\\d{5}", , , , "90001234", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "XK", 383, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23][89]|4[3-79]"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[89]00"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", , "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , 
, , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], YE:[, [, , "[1-7]\\d{6,8}", , , , , , , [7, 8, 9], [6]], [, , "(?:1(?:7\\d|[2-68])|2[2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-68])\\d{5}", , , , "1234567", , , [7, 8], [6]], [, , "7[0137]\\d{7}", , , , "712345678", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "YE", 967, "00", "0", , , "0", , , , [[, "([1-7])(\\d{3})(\\d{3,4})", "$1 $2 $3", 
["[1-6]|7[24-68]"], "0$1"], [, "(7\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["7[0137]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], YT:[, [, , "[268]\\d{8}", , , , , , , [9]], [, , "269(?:0[67]|5[01]|6\\d|[78]0)\\d{4}", , , , "269601234"], [, , "639(?:0[0-79]|1[019]|[26]\\d|3[09]|[45]0|7[06-9]|9[04-79])\\d{4}", , , , "639012345"], [, , "80\\d{7}", , , , "801234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], [, , , , , , , , , [-1]], "YT", 262, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , "269|63", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ZA:[, [, , "[1-79]\\d{8}|8\\d{4,8}", , , , , , , [5, 6, 7, 8, 9]], [, , "(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", , , , "101234567", , , [9]], [, , "(?:6\\d|7[0-46-9])\\d{7}|8(?:[1-4]\\d{1,5}|5\\d{5})\\d{2}", , , , "711234567"], [, , "80\\d{7}", , , , "801234567", , , [9]], [, , 
"86[2-9]\\d{6}|9[0-2]\\d{7}", , , , "862345678", , , [9]], [, , "860\\d{6}", , , , "860123456", , , [9]], [, , , , , , , , , [-1]], [, , "87\\d{7}", , , , "871234567", , , [9]], "ZA", 27, "00", "0", , , "0", , , , [[, "(860)(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], [, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-79]|8(?:[0-57]|6[1-9])"], "0$1"]], , [, , , , , , , , , [-1]], 
, , [, , , , , , , , , [-1]], [, , "861\\d{6}", , , , "861123456", , , [9]], , , [, , , , , , , , , [-1]]], ZM:[, [, , "[289]\\d{8}", , , , , , , [9], [6, 7]], [, , "21[1-8]\\d{6}", , , , "211234567", , , , [6, 7]], [, , "9[4-9]\\d{7}", , , , "955123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ZM", 260, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4})", "$1 $2", , "$1"], [, "([1-8])(\\d{2})(\\d{4})", 
"$1 $2 $3", ["[1-8]"], "$1"], [, "([29]\\d)(\\d{7})", "$1 $2", ["[29]"], "0$1"], [, "(800)(\\d{3})(\\d{3})", "$1 $2 $3", ["800"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ZW:[, [, , "2(?:[0-57-9]\\d{3,8}|6(?:[14]\\d{7}|\\d{4}))|[13-69]\\d{4,9}|7\\d{8}|8[06]\\d{5,8}", , , , , , , [5, 6, 7, 8, 9, 10], [3, 4]], [, , "(?:2(?:0(?:4\\d|5\\d{2})|2[278]\\d|48\\d|7(?:[1-7]\\d|[089]\\d{2})|8(?:[2-57-9]|[146]\\d{2})|98)|3(?:08|17|3[78]|7(?:[19]|[56]\\d)|8[37]|98)|5[15][78]|6(?:28\\d{2}|37|6[78]|75\\d|98|8(?:7\\d|8)))\\d{3}|(?:2(?:1[39]|2[0157]|31|[56][14]|7[35]|84)|329)\\d{7}|(?:1(?:3\\d{2}|[4-8]|9\\d)|2(?:0\\d{2}|12|292|[569]\\d)|3(?:[26]|[013459]\\d)|5(?:0|1[2-4]|26|[37]2|5\\d{2}|[689]\\d)|6(?:[39]|[01246]\\d|[78]\\d{2}))\\d{3}|(?:29\\d|39|54)\\d{6}|(?:(?:25|54)83\\d|2582\\d{2}|65[2-8])\\d{2}|(?:4\\d{6,7}|9[2-9]\\d{4,5})", 
, , , "1312345", , , , [3, 4]], [, , "(?:7(?:1[2-8]|3[2-9]|7[1-9]|8[2-5])|8644)\\d{6}", , , , "712345678", , , [9, 10]], [, , "80(?:[01]\\d|20|8[0-8])\\d{3}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "86(?:1[12]|30|55|77|8[368])\\d{6}", , , , "8686123456", , , [10]], "ZW", 263, "00", "0", , , "0", , , , [[, "([49])(\\d{3})(\\d{2,4})", "$1 $2 $3", ["4|9[2-9]"], "0$1"], [, "(7\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [, "(86\\d{2})(\\d{3})(\\d{3})", 
"$1 $2 $3", ["86[24]"], "0$1"], [, "([2356]\\d{2})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8|[78])|3(?:[09]8|17|3[78]|7[1569]|8[37])|5[15][78]|6(?:[29]8|37|[68][78]|75)"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|31|[56][14]|7[35]|84)|329"], "0$1"], [, "([1-356]\\d)(\\d{3,5})", "$1 $2", ["1[3-9]|2[02569]|3[0-69]|5[05689]|6"], "0$1"], [, "([235]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[23]9|54"], "0$1"], [, "([25]\\d{3})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258[23]|5483"], 
"0$1"], [, "(8\\d{3})(\\d{6})", "$1 $2", ["86"], "0$1"], [, "(80\\d)(\\d{4})", "$1 $2", ["80"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 800:[, [, , "\\d{8}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "\\d{8}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 800, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", 
"$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 808:[, [, , "\\d{8}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "\\d{8}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 808, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
, , [, , , , , , , , , [-1]]], 870:[, [, , "[35-7]\\d{8}", , , , , , , [9]], [, , , , , , , , , [-1]], [, , "(?:[356]\\d|7[6-8])\\d{7}", , , , "301234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 870, , , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 878:[, [, , "1\\d{11}", , 
, , , , , [12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "10\\d{10}", , , , "101234567890"], "001", 878, , , , , , , , 1, [[, "(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 881:[, [, , "[67]\\d{8}", , , , , , , [9]], [, , , , , , , , , [-1]], [, , "[67]\\d{8}", , , , "612345678"], 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 881, , , , , , , , , [[, "(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[67]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 882:[, [, , "[13]\\d{6,11}", , , , , , , [7, 8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , "3(?:2\\d{3}|37\\d{2}|4(?:2|7\\d{3}))\\d{4}", , , , "3421234", , , [7, 9, 10]], 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15678]|9[0689])\\d{4}|6\\d{5,10})|3(?:45|9\\d{3})\\d{7}", , , , "390123456789"], "001", 882, , , , , , , , , [[, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["34[57]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["348"]], [, "(\\d{2})(\\d{2})(\\d{4})", 
"$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], [, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["16|39"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "348[57]\\d{7}", , , , "34851234567", , , [11]]], 883:[, [, , "51\\d{7}(?:\\d{3})?", , , , , , , [9, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "51(?:00\\d{5}(?:\\d{3})?|[13]0\\d{8})", 
, , , "510012345"], "001", 883, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["510"]], [, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 888:[, [, , "\\d{11}", , , , , , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , 
, [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 888, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "\\d{11}", , , , "12345678901"], , , [, , , , , , , , , [-1]]], 979:[, [, , "\\d{9}", , , , , , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "\\d{9}", , , , "123456789"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 
979, , , , , , , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]]};
/*

 Copyright (C) 2010 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.PhoneNumberUtil = function() {
  this.regionToMetadataMap = {};
};
goog.addSingletonGetter(i18n.phonenumbers.PhoneNumberUtil);
i18n.phonenumbers.Error = {INVALID_COUNTRY_CODE:"Invalid country calling code", NOT_A_NUMBER:"The string supplied did not seem to be a phone number", TOO_SHORT_AFTER_IDD:"Phone number too short after IDD", TOO_SHORT_NSN:"The string supplied is too short to be a phone number", TOO_LONG:"The string supplied is too long to be a phone number"};
i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ = 1;
i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ = 2;
i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_ = 17;
i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ = 3;
i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_ = 250;
i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ = "ZZ";
i18n.phonenumbers.PhoneNumberUtil.COLOMBIA_MOBILE_TO_FIXED_LINE_PREFIX_ = "3";
i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_ = {52:"1", 54:"9"};
i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_ = [52, 54, 55];
i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN = "+";
i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ = "*";
i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ = ";ext=";
i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ = "tel:";
i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_ = ";phone-context=";
i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_ = ";isub=";
i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS = {0:"0", 1:"1", 2:"2", 3:"3", 4:"4", 5:"5", 6:"6", 7:"7", 8:"8", 9:"9", "\uff10":"0", "\uff11":"1", "\uff12":"2", "\uff13":"3", "\uff14":"4", "\uff15":"5", "\uff16":"6", "\uff17":"7", "\uff18":"8", "\uff19":"9", "\u0660":"0", "\u0661":"1", "\u0662":"2", "\u0663":"3", "\u0664":"4", "\u0665":"5", "\u0666":"6", "\u0667":"7", "\u0668":"8", "\u0669":"9", "\u06f0":"0", "\u06f1":"1", "\u06f2":"2", "\u06f3":"3", "\u06f4":"4", "\u06f5":"5", "\u06f6":"6", "\u06f7":"7", 
"\u06f8":"8", "\u06f9":"9"};
i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_ = {0:"0", 1:"1", 2:"2", 3:"3", 4:"4", 5:"5", 6:"6", 7:"7", 8:"8", 9:"9", "+":i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN, "*":"*", "#":"#"};
i18n.phonenumbers.PhoneNumberUtil.ALPHA_MAPPINGS_ = {A:"2", B:"2", C:"2", D:"3", E:"3", F:"3", G:"4", H:"4", I:"4", J:"5", K:"5", L:"5", M:"6", N:"6", O:"6", P:"7", Q:"7", R:"7", S:"7", T:"8", U:"8", V:"8", W:"9", X:"9", Y:"9", Z:"9"};
i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_ = {0:"0", 1:"1", 2:"2", 3:"3", 4:"4", 5:"5", 6:"6", 7:"7", 8:"8", 9:"9", "\uff10":"0", "\uff11":"1", "\uff12":"2", "\uff13":"3", "\uff14":"4", "\uff15":"5", "\uff16":"6", "\uff17":"7", "\uff18":"8", "\uff19":"9", "\u0660":"0", "\u0661":"1", "\u0662":"2", "\u0663":"3", "\u0664":"4", "\u0665":"5", "\u0666":"6", "\u0667":"7", "\u0668":"8", "\u0669":"9", "\u06f0":"0", "\u06f1":"1", "\u06f2":"2", "\u06f3":"3", "\u06f4":"4", "\u06f5":"5", "\u06f6":"6", 
"\u06f7":"7", "\u06f8":"8", "\u06f9":"9", A:"2", B:"2", C:"2", D:"3", E:"3", F:"3", G:"4", H:"4", I:"4", J:"5", K:"5", L:"5", M:"6", N:"6", O:"6", P:"7", Q:"7", R:"7", S:"7", T:"8", U:"8", V:"8", W:"9", X:"9", Y:"9", Z:"9"};
i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_ = {0:"0", 1:"1", 2:"2", 3:"3", 4:"4", 5:"5", 6:"6", 7:"7", 8:"8", 9:"9", A:"A", B:"B", C:"C", D:"D", E:"E", F:"F", G:"G", H:"H", I:"I", J:"J", K:"K", L:"L", M:"M", N:"N", O:"O", P:"P", Q:"Q", R:"R", S:"S", T:"T", U:"U", V:"V", W:"W", X:"X", Y:"Y", Z:"Z", a:"A", b:"B", c:"C", d:"D", e:"E", f:"F", g:"G", h:"H", i:"I", j:"J", k:"K", l:"L", m:"M", n:"N", o:"O", p:"P", q:"Q", r:"R", s:"S", t:"T", u:"U", v:"V", w:"W", x:"X", y:"Y", z:"Z", 
"-":"-", "\uff0d":"-", "\u2010":"-", "\u2011":"-", "\u2012":"-", "\u2013":"-", "\u2014":"-", "\u2015":"-", "\u2212":"-", "/":"/", "\uff0f":"/", " ":" ", "\u3000":" ", "\u2060":" ", ".":".", "\uff0e":"."};
i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_ = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/;
i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION = "-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e";
i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ = "0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9";
i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ = "A-Za-z";
i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ = "+\uff0b";
i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+");
i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+");
i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]+";
i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN = new RegExp("([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "])");
i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_ = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]");
i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_ = /[\\\/] *x/;
i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_ = new RegExp("[^" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + "#]+$");
i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_ = /(?:.*?[A-Za-z]){3}.*/;
i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ + "}";
i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ = "[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]*(?:[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + "]*[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]){3,}[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]*";
i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ = " ext. ";
i18n.phonenumbers.PhoneNumberUtil.CAPTURING_EXTN_DIGITS_ = "([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{1,7})";
i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERNS_FOR_PARSING_ = i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.CAPTURING_EXTN_DIGITS_ + "|[ \u00a0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\u00f3))?n?|\uff45?\uff58\uff54\uff4e?|[;,x\uff58#\uff03~\uff5e]|int|anexo|\uff49\uff4e\uff54)[:\\.\uff0e]?[ \u00a0\\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.CAPTURING_EXTN_DIGITS_ + "#?|[- ]+([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{1,5})#";
i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_ = new RegExp("(?:" + i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERNS_FOR_PARSING_ + ")$", "i");
i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_ = new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ + "$|^" + i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ + "(?:" + i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERNS_FOR_PARSING_ + ")?$", "i");
i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_ = /\D+/;
i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_ = /(\$\d)/;
i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_ = /\$NP/;
i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_ = /\$FG/;
i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_ = /\$CC/;
i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_ = /^\(?\$1\)?$/;
i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY = "001";
i18n.phonenumbers.PhoneNumberFormat = {E164:0, INTERNATIONAL:1, NATIONAL:2, RFC3966:3};
i18n.phonenumbers.PhoneNumberType = {FIXED_LINE:0, MOBILE:1, FIXED_LINE_OR_MOBILE:2, TOLL_FREE:3, PREMIUM_RATE:4, SHARED_COST:5, VOIP:6, PERSONAL_NUMBER:7, PAGER:8, UAN:9, VOICEMAIL:10, UNKNOWN:-1};
i18n.phonenumbers.PhoneNumberUtil.MatchType = {NOT_A_NUMBER:0, NO_MATCH:1, SHORT_NSN_MATCH:2, NSN_MATCH:3, EXACT_MATCH:4};
i18n.phonenumbers.PhoneNumberUtil.ValidationResult = {IS_POSSIBLE:0, IS_POSSIBLE_LOCAL_ONLY:4, INVALID_COUNTRY_CODE:1, TOO_SHORT:2, INVALID_LENGTH:5, TOO_LONG:3};
i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber = function(a) {
  var b = a.search(i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_);
  0 <= b ? (a = a.substring(b), a = a.replace(i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_, ""), b = a.search(i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_), 0 <= b && (a = a.substring(0, b))) : a = "";
  return a;
};
i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber = function(a) {
  return a.length < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_, a);
};
i18n.phonenumbers.PhoneNumberUtil.normalize = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a) ? i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !0) : i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);
};
i18n.phonenumbers.PhoneNumberUtil.normalizeSB_ = function(a) {
  var b = i18n.phonenumbers.PhoneNumberUtil.normalize(a.toString());
  a.clear();
  a.append(b);
};
i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS, !0);
};
i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_, !0);
};
i18n.phonenumbers.PhoneNumberUtil.convertAlphaCharactersInNumber = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !1);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfGeographicalAreaCode = function(a) {
  var b = this.getMetadataForRegion(this.getRegionCodeForNumber(a));
  return null != b && (b.hasNationalPrefix() || a.hasItalianLeadingZero()) && this.isNumberGeographical(a) ? this.getLengthOfNationalDestinationCode(a) : 0;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfNationalDestinationCode = function(a) {
  if (a.hasExtension()) {
    var b = a.clone();
    b.clearExtension();
  } else {
    b = a;
  }
  b = this.format(b, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).split(i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_);
  0 == b[0].length && b.shift();
  return 2 >= b.length ? 0 : this.getNumberType(a) == i18n.phonenumbers.PhoneNumberType.MOBILE && (a = i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken(a.getCountryCodeOrDefault()), "" != a) ? b[2].length + a.length : b[1].length;
};
i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_[a] || "";
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedRegions = function() {
  return goog.array.filter(Object.keys(i18n.phonenumbers.metadata.countryToMetadata), function(a) {
    return isNaN(a);
  });
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedGlobalNetworkCallingCodes = function() {
  var a = goog.array.filter(Object.keys(i18n.phonenumbers.metadata.countryToMetadata), function(a) {
    return !isNaN(a);
  });
  return goog.array.map(a, function(a) {
    return parseInt(a, 10);
  });
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedCallingCodes = function() {
  var a = Object.keys(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap);
  return goog.array.join(this.getSupportedGlobalNetworkCallingCodes(), goog.array.map(a, function(a) {
    return parseInt(a, 10);
  }));
};
i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_ = function(a) {
  return null != a && (1 != a.possibleLengthCount() || -1 != a.possibleLengthArray()[0]);
};
i18n.phonenumbers.PhoneNumberUtil.descHasData_ = function(a) {
  return null != a && (a.hasExampleNumber() || i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(a) || a.hasNationalNumberPattern());
};
i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_ = function(a) {
  var b = [];
  goog.object.forEach(i18n.phonenumbers.PhoneNumberType, function(c) {
    if (c != i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE && c != i18n.phonenumbers.PhoneNumberType.UNKNOWN) {
      var d = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(a, c);
      i18n.phonenumbers.PhoneNumberUtil.descHasData_(d) && b.push(c);
    }
  });
  return b;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForRegion = function(a) {
  return this.isValidRegionCode_(a) ? i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(this.getMetadataForRegion(a)) : [];
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForNonGeoEntity = function(a) {
  a = this.getMetadataForNonGeographicalRegion(a);
  return null == a ? [] : i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(a);
};
i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_ = function(a, b, c) {
  for (var d = new goog.string.StringBuffer, e, f, g = a.length, h = 0; h < g; ++h) {
    e = a.charAt(h), f = b[e.toUpperCase()], null != f ? d.append(f) : c || d.append(e);
  }
  return d.toString();
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formattingRuleHasFirstGroupOnly = function(a) {
  return 0 == a.length || i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_.test(a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberGeographical = function(a) {
  var b = this.getNumberType(a);
  return b == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || b == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE || goog.array.contains(i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_, a.getCountryCodeOrDefault()) && b == i18n.phonenumbers.PhoneNumberType.MOBILE;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isValidRegionCode_ = function(a) {
  return null != a && isNaN(a) && a.toUpperCase() in i18n.phonenumbers.metadata.countryToMetadata;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.hasValidCountryCallingCode_ = function(a) {
  return a in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.format = function(a, b) {
  if (0 == a.getNationalNumber() && a.hasRawInput()) {
    var c = a.getRawInputOrDefault();
    if (0 < c.length) {
      return c;
    }
  }
  c = a.getCountryCodeOrDefault();
  var d = this.getNationalSignificantNumber(a);
  if (b == i18n.phonenumbers.PhoneNumberFormat.E164) {
    return this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.E164, d, "");
  }
  if (!this.hasValidCountryCallingCode_(c)) {
    return d;
  }
  var e = this.getRegionCodeForCountryCode(c), f = this.getMetadataForRegionOrCallingCode_(c, e);
  e = this.maybeGetFormattedExtension_(a, f, b);
  d = this.formatNsn_(d, f, b);
  return this.prefixNumberWithCountryCallingCode_(c, b, d, e);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatByPattern = function(a, b, c) {
  var d = a.getCountryCodeOrDefault(), e = this.getNationalSignificantNumber(a);
  if (!this.hasValidCountryCallingCode_(d)) {
    return e;
  }
  var f = this.getRegionCodeForCountryCode(d);
  f = this.getMetadataForRegionOrCallingCode_(d, f);
  var g = this.chooseFormattingPatternForNumber_(c, e);
  if (null != g) {
    c = g.clone();
    g = g.getNationalPrefixFormattingRuleOrDefault();
    if (0 < g.length) {
      var h = f.getNationalPrefixOrDefault();
      0 < h.length ? (g = g.replace(i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_, h).replace(i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_, "$1"), c.setNationalPrefixFormattingRule(g)) : c.clearNationalPrefixFormattingRule();
    }
    e = this.formatNsnUsingPattern_(e, c, b);
  }
  a = this.maybeGetFormattedExtension_(a, f, b);
  return this.prefixNumberWithCountryCallingCode_(d, b, e, a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithCarrierCode = function(a, b) {
  var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
  if (!this.hasValidCountryCallingCode_(c)) {
    return d;
  }
  var e = this.getRegionCodeForCountryCode(c), f = this.getMetadataForRegionOrCallingCode_(c, e);
  e = this.maybeGetFormattedExtension_(a, f, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
  d = this.formatNsn_(d, f, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, b);
  return this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, d, e);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegionOrCallingCode_ = function(a, b) {
  return i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == b ? this.getMetadataForNonGeographicalRegion(a) : this.getMetadataForRegion(b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithPreferredCarrierCode = function(a, b) {
  return this.formatNationalNumberWithCarrierCode(a, 0 < a.getPreferredDomesticCarrierCodeOrDefault().length ? a.getPreferredDomesticCarrierCodeOrDefault() : b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNumberForMobileDialing = function(a, b, c) {
  var d = a.getCountryCodeOrDefault();
  if (!this.hasValidCountryCallingCode_(d)) {
    return a.hasRawInput() ? a.getRawInputOrDefault() : "";
  }
  var e = "";
  a = a.clone();
  a.clearExtension();
  var f = this.getRegionCodeForCountryCode(d), g = this.getNumberType(a), h = g != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
  if (b == f) {
    e = g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || g == i18n.phonenumbers.PhoneNumberType.MOBILE || g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE, "CO" == f && g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE ? e = this.formatNationalNumberWithCarrierCode(a, i18n.phonenumbers.PhoneNumberUtil.COLOMBIA_MOBILE_TO_FIXED_LINE_PREFIX_) : "BR" == f && e ? e = 0 < a.getPreferredDomesticCarrierCodeOrDefault().length ? this.formatNationalNumberWithPreferredCarrierCode(a, "") : "" : 
    h && "HU" == f ? e = this.getNddPrefixForRegion(f, !0) + " " + this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL) : d == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ ? (b = this.getMetadataForRegion(b), e = this.canBeInternationallyDialled(a) && this.testNumberLength_(this.getNationalSignificantNumber(a), b) != i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL)) : 
    e = (f == i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY || ("MX" == f || "CL" == f) && e) && this.canBeInternationallyDialled(a) ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
  } else {
    if (h && this.canBeInternationallyDialled(a)) {
      return c ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.E164);
    }
  }
  return c ? e : i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(e);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryCallingNumber = function(a, b) {
  if (!this.isValidRegionCode_(b)) {
    return this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
  }
  var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
  if (!this.hasValidCountryCallingCode_(c)) {
    return d;
  }
  if (c == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
    if (this.isNANPACountry(b)) {
      return c + " " + this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
    }
  } else {
    if (c == this.getCountryCodeForValidRegion_(b)) {
      return this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
    }
  }
  var e = this.getMetadataForRegion(b), f = e.getInternationalPrefixOrDefault(), g = "";
  i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, f) ? g = f : e.hasPreferredInternationalPrefix() && (g = e.getPreferredInternationalPrefixOrDefault());
  e = this.getRegionCodeForCountryCode(c);
  e = this.getMetadataForRegionOrCallingCode_(c, e);
  d = this.formatNsn_(d, e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
  e = this.maybeGetFormattedExtension_(a, e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
  return 0 < g.length ? g + " " + c + " " + d + e : this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, d, e);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatInOriginalFormat = function(a, b) {
  if (a.hasRawInput() && !this.hasFormattingPatternForNumber_(a)) {
    return a.getRawInputOrDefault();
  }
  if (!a.hasCountryCodeSource()) {
    return this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
  }
  switch(a.getCountryCodeSource()) {
    case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN:
      var c = this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
      break;
    case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:
      c = this.formatOutOfCountryCallingNumber(a, b);
      break;
    case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN:
      c = this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).substring(1);
      break;
    default:
      var d = this.getRegionCodeForCountryCode(a.getCountryCodeOrDefault()), e = this.getNddPrefixForRegion(d, !0);
      c = this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
      if (null != e && 0 != e.length && !this.rawInputContainsNationalPrefix_(a.getRawInputOrDefault(), e, d) && (d = this.getMetadataForRegion(d), e = this.getNationalSignificantNumber(a), d = this.chooseFormattingPatternForNumber_(d.numberFormatArray(), e), null != d)) {
        e = d.getNationalPrefixFormattingRuleOrDefault();
        var f = e.indexOf("$1");
        0 >= f || (e = e.substring(0, f), e = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(e), 0 != e.length && (c = d.clone(), c.clearNationalPrefixFormattingRule(), c = this.formatByPattern(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, [c])));
      }
  }
  d = a.getRawInputOrDefault();
  null != c && 0 < d.length && (e = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(c), f = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(d), e != f && (c = d));
  return c;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.rawInputContainsNationalPrefix_ = function(a, b, c) {
  a = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);
  if (goog.string.startsWith(a, b)) {
    try {
      return this.isValidNumber(this.parse(a.substring(b.length), c));
    } catch (d) {
    }
  }
  return !1;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.hasFormattingPatternForNumber_ = function(a) {
  var b = a.getCountryCodeOrDefault(), c = this.getRegionCodeForCountryCode(b);
  b = this.getMetadataForRegionOrCallingCode_(b, c);
  if (null == b) {
    return !1;
  }
  a = this.getNationalSignificantNumber(a);
  return null != this.chooseFormattingPatternForNumber_(b.numberFormatArray(), a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryKeepingAlphaChars = function(a, b) {
  var c = a.getRawInputOrDefault();
  if (0 == c.length) {
    return this.formatOutOfCountryCallingNumber(a, b);
  }
  var d = a.getCountryCodeOrDefault();
  if (!this.hasValidCountryCallingCode_(d)) {
    return c;
  }
  c = i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(c, i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_, !0);
  var e = this.getNationalSignificantNumber(a);
  if (3 < e.length) {
    var f = c.indexOf(e.substring(0, 3));
    -1 != f && (c = c.substring(f));
  }
  f = this.getMetadataForRegion(b);
  if (d == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
    if (this.isNANPACountry(b)) {
      return d + " " + c;
    }
  } else {
    if (null != f && d == this.getCountryCodeForValidRegion_(b)) {
      d = this.chooseFormattingPatternForNumber_(f.numberFormatArray(), e);
      if (null == d) {
        return c;
      }
      d = d.clone();
      d.setPattern("(\\d+)(.*)");
      d.setFormat("$1$2");
      return this.formatNsnUsingPattern_(c, d, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
    }
  }
  e = "";
  null != f && (e = f.getInternationalPrefixOrDefault(), e = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, e) ? e : f.getPreferredInternationalPrefixOrDefault());
  f = this.getRegionCodeForCountryCode(d);
  f = this.getMetadataForRegionOrCallingCode_(d, f);
  f = this.maybeGetFormattedExtension_(a, f, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
  return 0 < e.length ? e + " " + d + " " + c + f : this.prefixNumberWithCountryCallingCode_(d, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, c, f);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNationalSignificantNumber = function(a) {
  if (!a.hasNationalNumber()) {
    return "";
  }
  var b = "" + a.getNationalNumber();
  return a.hasItalianLeadingZero() && a.getItalianLeadingZero() && 0 < a.getNumberOfLeadingZerosOrDefault() ? Array(a.getNumberOfLeadingZerosOrDefault() + 1).join("0") + b : b;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.prefixNumberWithCountryCallingCode_ = function(a, b, c, d) {
  switch(b) {
    case i18n.phonenumbers.PhoneNumberFormat.E164:
      return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + c + d;
    case i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL:
      return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + " " + c + d;
    case i18n.phonenumbers.PhoneNumberFormat.RFC3966:
      return i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + "-" + c + d;
    default:
      return c + d;
  }
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsn_ = function(a, b, c, d) {
  b = 0 == b.intlNumberFormatArray().length || c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL ? b.numberFormatArray() : b.intlNumberFormatArray();
  b = this.chooseFormattingPatternForNumber_(b, a);
  return null == b ? a : this.formatNsnUsingPattern_(a, b, c, d);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.chooseFormattingPatternForNumber_ = function(a, b) {
  for (var c, d = a.length, e = 0; e < d; ++e) {
    c = a[e];
    var f = c.leadingDigitsPatternCount();
    if (0 == f || 0 == b.search(c.getLeadingDigitsPattern(f - 1))) {
      if (f = new RegExp(c.getPattern()), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, b)) {
        return c;
      }
    }
  }
  return null;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsnUsingPattern_ = function(a, b, c, d) {
  var e = b.getFormatOrDefault(), f = new RegExp(b.getPattern()), g = b.getDomesticCarrierCodeFormattingRuleOrDefault();
  c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && null != d && 0 < d.length && 0 < g.length ? (b = g.replace(i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_, d), e = e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b), a = a.replace(f, e)) : (b = b.getNationalPrefixFormattingRuleOrDefault(), a = c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && null != b && 0 < b.length ? a.replace(f, e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b)) : a.replace(f, e));
  c == i18n.phonenumbers.PhoneNumberFormat.RFC3966 && (a = a.replace(new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_), ""), a = a.replace(new RegExp(i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_, "g"), "-"));
  return a;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumber = function(a) {
  return this.getExampleNumberForType(a, i18n.phonenumbers.PhoneNumberType.FIXED_LINE);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForType = function(a, b) {
  if (!this.isValidRegionCode_(a)) {
    return null;
  }
  var c = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(this.getMetadataForRegion(a), b);
  try {
    if (c.hasExampleNumber()) {
      return this.parse(c.getExampleNumber(), a);
    }
  } catch (d) {
  }
  return null;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForNonGeoEntity = function(a) {
  var b = this.getMetadataForNonGeographicalRegion(a);
  if (null != b && (b = goog.array.find([b.getMobile(), b.getTollFree(), b.getSharedCost(), b.getVoip(), b.getVoicemail(), b.getUan(), b.getPremiumRate()], function(a, b) {
    return a.hasExampleNumber();
  }), null != b)) {
    try {
      return this.parse("+" + a + b.getExampleNumber(), "ZZ");
    } catch (c) {
    }
  }
  return null;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeGetFormattedExtension_ = function(a, b, c) {
  return a.hasExtension() && 0 != a.getExtension().length ? c == i18n.phonenumbers.PhoneNumberFormat.RFC3966 ? i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + a.getExtension() : b.hasPreferredExtnPrefix() ? b.getPreferredExtnPrefix() + a.getExtensionOrDefault() : i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ + a.getExtensionOrDefault() : "";
};
i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_ = function(a, b) {
  switch(b) {
    case i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:
      return a.getPremiumRate();
    case i18n.phonenumbers.PhoneNumberType.TOLL_FREE:
      return a.getTollFree();
    case i18n.phonenumbers.PhoneNumberType.MOBILE:
      return a.getMobile();
    case i18n.phonenumbers.PhoneNumberType.FIXED_LINE:
    case i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:
      return a.getFixedLine();
    case i18n.phonenumbers.PhoneNumberType.SHARED_COST:
      return a.getSharedCost();
    case i18n.phonenumbers.PhoneNumberType.VOIP:
      return a.getVoip();
    case i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:
      return a.getPersonalNumber();
    case i18n.phonenumbers.PhoneNumberType.PAGER:
      return a.getPager();
    case i18n.phonenumbers.PhoneNumberType.UAN:
      return a.getUan();
    case i18n.phonenumbers.PhoneNumberType.VOICEMAIL:
      return a.getVoicemail();
    default:
      return a.getGeneralDesc();
  }
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberType = function(a) {
  var b = this.getRegionCodeForNumber(a);
  b = this.getMetadataForRegionOrCallingCode_(a.getCountryCodeOrDefault(), b);
  if (null == b) {
    return i18n.phonenumbers.PhoneNumberType.UNKNOWN;
  }
  a = this.getNationalSignificantNumber(a);
  return this.getNumberTypeHelper_(a, b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberTypeHelper_ = function(a, b) {
  return this.isNumberMatchingDesc_(a, b.getGeneralDesc()) ? this.isNumberMatchingDesc_(a, b.getPremiumRate()) ? i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE : this.isNumberMatchingDesc_(a, b.getTollFree()) ? i18n.phonenumbers.PhoneNumberType.TOLL_FREE : this.isNumberMatchingDesc_(a, b.getSharedCost()) ? i18n.phonenumbers.PhoneNumberType.SHARED_COST : this.isNumberMatchingDesc_(a, b.getVoip()) ? i18n.phonenumbers.PhoneNumberType.VOIP : this.isNumberMatchingDesc_(a, b.getPersonalNumber()) ? i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER : 
  this.isNumberMatchingDesc_(a, b.getPager()) ? i18n.phonenumbers.PhoneNumberType.PAGER : this.isNumberMatchingDesc_(a, b.getUan()) ? i18n.phonenumbers.PhoneNumberType.UAN : this.isNumberMatchingDesc_(a, b.getVoicemail()) ? i18n.phonenumbers.PhoneNumberType.VOICEMAIL : this.isNumberMatchingDesc_(a, b.getFixedLine()) ? b.getSameMobileAndFixedLinePattern() || this.isNumberMatchingDesc_(a, b.getMobile()) ? i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE : i18n.phonenumbers.PhoneNumberType.FIXED_LINE : 
  !b.getSameMobileAndFixedLinePattern() && this.isNumberMatchingDesc_(a, b.getMobile()) ? i18n.phonenumbers.PhoneNumberType.MOBILE : i18n.phonenumbers.PhoneNumberType.UNKNOWN : i18n.phonenumbers.PhoneNumberType.UNKNOWN;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegion = function(a) {
  if (null == a) {
    return null;
  }
  a = a.toUpperCase();
  var b = this.regionToMetadataMap[a];
  if (null == b) {
    b = new goog.proto2.PbLiteSerializer;
    var c = i18n.phonenumbers.metadata.countryToMetadata[a];
    if (null == c) {
      return null;
    }
    b = b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), c);
    this.regionToMetadataMap[a] = b;
  }
  return b;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForNonGeographicalRegion = function(a) {
  return this.getMetadataForRegion("" + a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatchingDesc_ = function(a, b) {
  var c = a.length;
  return 0 < b.possibleLengthCount() && -1 == goog.array.indexOf(b.possibleLengthArray(), c) ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(), a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumber = function(a) {
  var b = this.getRegionCodeForNumber(a);
  return this.isValidNumberForRegion(a, b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumberForRegion = function(a, b) {
  var c = a.getCountryCodeOrDefault(), d = this.getMetadataForRegionOrCallingCode_(c, b);
  if (null == d || i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY != b && c != this.getCountryCodeForValidRegion_(b)) {
    return !1;
  }
  c = this.getNationalSignificantNumber(a);
  return this.getNumberTypeHelper_(c, d) != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumber = function(a) {
  if (null == a) {
    return null;
  }
  var b = a.getCountryCodeOrDefault();
  b = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[b];
  return null == b ? null : 1 == b.length ? b[0] : this.getRegionCodeForNumberFromRegionList_(a, b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumberFromRegionList_ = function(a, b) {
  for (var c = this.getNationalSignificantNumber(a), d, e = b.length, f = 0; f < e; f++) {
    d = b[f];
    var g = this.getMetadataForRegion(d);
    if (g.hasLeadingDigits()) {
      if (0 == c.search(g.getLeadingDigits())) {
        return d;
      }
    } else {
      if (this.getNumberTypeHelper_(c, g) != i18n.phonenumbers.PhoneNumberType.UNKNOWN) {
        return d;
      }
    }
  }
  return null;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForCountryCode = function(a) {
  a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];
  return null == a ? i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ : a[0];
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodesForCountryCode = function(a) {
  a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];
  return null == a ? [] : a;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForRegion = function(a) {
  return this.isValidRegionCode_(a) ? this.getCountryCodeForValidRegion_(a) : 0;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForValidRegion_ = function(a) {
  var b = this.getMetadataForRegion(a);
  if (null == b) {
    throw Error("Invalid region code: " + a);
  }
  return b.getCountryCodeOrDefault();
};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNddPrefixForRegion = function(a, b) {
  var c = this.getMetadataForRegion(a);
  if (null == c) {
    return null;
  }
  c = c.getNationalPrefixOrDefault();
  if (0 == c.length) {
    return null;
  }
  b && (c = c.replace("~", ""));
  return c;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNANPACountry = function(a) {
  return null != a && goog.array.contains(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_], a.toUpperCase());
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isAlphaNumber = function(a) {
  if (!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(a)) {
    return !1;
  }
  a = new goog.string.StringBuffer(a);
  this.maybeStripExtension(a);
  return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a.toString());
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumber = function(a) {
  a = this.isPossibleNumberWithReason(a);
  return a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForType = function(a, b) {
  var c = this.isPossibleNumberForTypeWithReason(a, b);
  return c == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || c == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLength_ = function(a, b) {
  return this.testNumberLengthForType_(a, b, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLengthForType_ = function(a, b, c) {
  var d = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, c), e = 0 == d.possibleLengthCount() ? b.getGeneralDesc().possibleLengthArray() : d.possibleLengthArray();
  d = d.possibleLengthLocalOnlyArray();
  if (c == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE) {
    if (i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, i18n.phonenumbers.PhoneNumberType.FIXED_LINE))) {
      c = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, i18n.phonenumbers.PhoneNumberType.MOBILE), i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(c) && (e = e.concat(0 == c.possibleLengthCount() ? b.getGeneralDesc().possibleLengthArray() : c.possibleLengthArray()), goog.array.sort(e), 0 == d.length ? d = c.possibleLengthLocalOnlyArray() : (d = d.concat(c.possibleLengthLocalOnlyArray()), goog.array.sort(d)));
    } else {
      return this.testNumberLengthForType_(a, b, i18n.phonenumbers.PhoneNumberType.MOBILE);
    }
  }
  if (-1 == e[0]) {
    return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
  }
  a = a.length;
  if (-1 < goog.array.indexOf(d, a)) {
    return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
  }
  b = e[0];
  return b == a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : b > a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT : e[e.length - 1] < a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG : -1 < goog.array.indexOf(e, a, 1) ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberWithReason = function(a) {
  return this.isPossibleNumberForTypeWithReason(a, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForTypeWithReason = function(a, b) {
  var c = this.getNationalSignificantNumber(a), d = a.getCountryCodeOrDefault();
  if (!this.hasValidCountryCallingCode_(d)) {
    return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_COUNTRY_CODE;
  }
  var e = this.getRegionCodeForCountryCode(d);
  d = this.getMetadataForRegionOrCallingCode_(d, e);
  return this.testNumberLengthForType_(c, d, b);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberString = function(a, b) {
  try {
    return this.isPossibleNumber(this.parse(a, b));
  } catch (c) {
    return !1;
  }
};
i18n.phonenumbers.PhoneNumberUtil.prototype.truncateTooLongNumber = function(a) {
  if (this.isValidNumber(a)) {
    return !0;
  }
  var b = a.clone(), c = a.getNationalNumberOrDefault();
  do {
    if (c = Math.floor(c / 10), b.setNationalNumber(c), 0 == c || this.isPossibleNumberWithReason(b) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT) {
      return !1;
    }
  } while (!this.isValidNumber(b));
  a.setNationalNumber(c);
  return !0;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.extractCountryCode = function(a, b) {
  var c = a.toString();
  if (0 == c.length || "0" == c.charAt(0)) {
    return 0;
  }
  for (var d, e = c.length, f = 1; f <= i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ && f <= e; ++f) {
    if (d = parseInt(c.substring(0, f), 10), d in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap) {
      return b.append(c.substring(f)), d;
    }
  }
  return 0;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeExtractCountryCode = function(a, b, c, d, e) {
  if (0 == a.length) {
    return 0;
  }
  a = new goog.string.StringBuffer(a);
  var f;
  null != b && (f = b.getInternationalPrefix());
  null == f && (f = "NonMatch");
  f = this.maybeStripInternationalPrefixAndNormalize(a, f);
  d && e.setCountryCodeSource(f);
  if (f != i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY) {
    if (a.getLength() <= i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) {
      throw Error(i18n.phonenumbers.Error.TOO_SHORT_AFTER_IDD);
    }
    b = this.extractCountryCode(a, c);
    if (0 != b) {
      return e.setCountryCode(b), b;
    }
    throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
  }
  if (null != b) {
    f = b.getCountryCodeOrDefault();
    var g = "" + f, h = a.toString();
    if (goog.string.startsWith(h, g) && (g = new goog.string.StringBuffer(h.substring(g.length)), h = b.getGeneralDesc(), h = new RegExp(h.getNationalNumberPatternOrDefault()), this.maybeStripNationalPrefixAndCarrierCode(g, b, null), g = g.toString(), !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h, a.toString()) && i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h, g) || this.testNumberLength_(a.toString(), b) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG)) {
      return c.append(g), d && e.setCountryCodeSource(i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN), e.setCountryCode(f), f;
    }
  }
  e.setCountryCode(0);
  return 0;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.parsePrefixAsIdd_ = function(a, b) {
  var c = b.toString();
  if (0 == c.search(a)) {
    var d = c.match(a)[0].length, e = c.substring(d).match(i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN);
    if (e && null != e[1] && 0 < e[1].length && "0" == i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(e[1])) {
      return !1;
    }
    b.clear();
    b.append(c.substring(d));
    return !0;
  }
  return !1;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripInternationalPrefixAndNormalize = function(a, b) {
  var c = a.toString();
  if (0 == c.length) {
    return i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;
  }
  if (i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(c)) {
    return c = c.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ""), a.clear(), a.append(i18n.phonenumbers.PhoneNumberUtil.normalize(c)), i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN;
  }
  c = new RegExp(b);
  i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(a);
  return this.parsePrefixAsIdd_(c, a) ? i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD : i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripNationalPrefixAndCarrierCode = function(a, b, c) {
  var d = a.toString(), e = d.length, f = b.getNationalPrefixForParsing();
  if (0 == e || null == f || 0 == f.length) {
    return !1;
  }
  var g = new RegExp("^(?:" + f + ")");
  if (e = g.exec(d)) {
    f = new RegExp(b.getGeneralDesc().getNationalNumberPatternOrDefault());
    var h = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d), k = e.length - 1;
    b = b.getNationalPrefixTransformRule();
    if (null == b || 0 == b.length || null == e[k] || 0 == e[k].length) {
      if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d.substring(e[0].length))) {
        return !1;
      }
      null != c && 0 < k && null != e[k] && c.append(e[1]);
      a.set(d.substring(e[0].length));
    } else {
      d = d.replace(g, b);
      if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d)) {
        return !1;
      }
      null != c && 0 < k && c.append(e[1]);
      a.set(d);
    }
    return !0;
  }
  return !1;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripExtension = function(a) {
  var b = a.toString(), c = b.search(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_);
  if (0 <= c && i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(b.substring(0, c))) {
    for (var d = b.match(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_), e = d.length, f = 1; f < e; ++f) {
      if (null != d[f] && 0 < d[f].length) {
        return a.clear(), a.append(b.substring(0, c)), d[f];
      }
    }
  }
  return "";
};
i18n.phonenumbers.PhoneNumberUtil.prototype.checkRegionForParsing_ = function(a, b) {
  return this.isValidRegionCode_(b) || null != a && 0 < a.length && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(a);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.parse = function(a, b) {
  return this.parseHelper_(a, b, !1, !0);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.parseAndKeepRawInput = function(a, b) {
  if (!this.isValidRegionCode_(b) && 0 < a.length && a.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
    throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
  }
  return this.parseHelper_(a, b, !0, !0);
};
i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_ = function(a, b) {
  if (1 < a.length && "0" == a.charAt(0)) {
    b.setItalianLeadingZero(!0);
    for (var c = 1; c < a.length - 1 && "0" == a.charAt(c);) {
      c++;
    }
    1 != c && b.setNumberOfLeadingZeros(c);
  }
};
i18n.phonenumbers.PhoneNumberUtil.prototype.parseHelper_ = function(a, b, c, d) {
  if (null == a) {
    throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
  }
  if (a.length > i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_) {
    throw Error(i18n.phonenumbers.Error.TOO_LONG);
  }
  var e = new goog.string.StringBuffer;
  this.buildNationalNumberForParsing_(a, e);
  if (!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(e.toString())) {
    throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
  }
  if (d && !this.checkRegionForParsing_(e.toString(), b)) {
    throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
  }
  d = new i18n.phonenumbers.PhoneNumber;
  c && d.setRawInput(a);
  a = this.maybeStripExtension(e);
  0 < a.length && d.setExtension(a);
  var f = this.getMetadataForRegion(b);
  a = new goog.string.StringBuffer;
  var g = 0, h = e.toString();
  try {
    g = this.maybeExtractCountryCode(h, f, a, c, d);
  } catch (k) {
    if (k.message == i18n.phonenumbers.Error.INVALID_COUNTRY_CODE && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(h)) {
      if (h = h.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ""), g = this.maybeExtractCountryCode(h, f, a, c, d), 0 == g) {
        throw k;
      }
    } else {
      throw k;
    }
  }
  0 != g ? (e = this.getRegionCodeForCountryCode(g), e != b && (f = this.getMetadataForRegionOrCallingCode_(g, e))) : (i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(e), a.append(e.toString()), null != b ? (g = f.getCountryCodeOrDefault(), d.setCountryCode(g)) : c && d.clearCountryCodeSource());
  if (a.getLength() < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) {
    throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
  }
  null != f && (b = new goog.string.StringBuffer, e = new goog.string.StringBuffer(a.toString()), this.maybeStripNationalPrefixAndCarrierCode(e, f, b), f = this.testNumberLength_(e.toString(), f), g = i18n.phonenumbers.PhoneNumberUtil.ValidationResult, f != g.TOO_SHORT && f != g.IS_POSSIBLE_LOCAL_ONLY && f != g.INVALID_LENGTH && (a = e, c && 0 < b.toString().length && d.setPreferredDomesticCarrierCode(b.toString())));
  c = a.toString();
  a = c.length;
  if (a < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) {
    throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
  }
  if (a > i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_) {
    throw Error(i18n.phonenumbers.Error.TOO_LONG);
  }
  i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_(c, d);
  d.setNationalNumber(parseInt(c, 10));
  return d;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.buildNationalNumberForParsing_ = function(a, b) {
  var c = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
  if (0 <= c) {
    var d = c + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_.length;
    if (a.charAt(d) == i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
      var e = a.indexOf(";", d);
      0 < e ? b.append(a.substring(d, e)) : b.append(a.substring(d));
    }
    d = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_);
    b.append(a.substring(0 <= d ? d + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_.length : 0, c));
  } else {
    b.append(i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a));
  }
  c = b.toString();
  d = c.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_);
  0 < d && (b.clear(), b.append(c.substring(0, d)));
};
i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_ = function(a) {
  var b = new i18n.phonenumbers.PhoneNumber;
  b.setCountryCode(a.getCountryCodeOrDefault());
  b.setNationalNumber(a.getNationalNumberOrDefault());
  0 < a.getExtensionOrDefault().length && b.setExtension(a.getExtensionOrDefault());
  a.getItalianLeadingZero() && (b.setItalianLeadingZero(!0), b.setNumberOfLeadingZeros(a.getNumberOfLeadingZerosOrDefault()));
  return b;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatch = function(a, b) {
  if ("string" == typeof a) {
    try {
      var c = this.parse(a, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_);
    } catch (g) {
      if (g.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE) {
        return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
      }
      if ("string" != typeof b) {
        var d = this.getRegionCodeForCountryCode(b.getCountryCodeOrDefault());
        if (d != i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_) {
          try {
            c = this.parse(a, d);
          } catch (h) {
            return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
          }
          c = this.isNumberMatch(c, b);
          return c == i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : c;
        }
      }
      try {
        c = this.parseHelper_(a, null, !1, !1);
      } catch (h) {
        return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
      }
    }
  } else {
    c = a.clone();
  }
  if ("string" == typeof b) {
    try {
      var e = this.parse(b, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_);
      return this.isNumberMatch(a, e);
    } catch (g) {
      return g.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER : this.isNumberMatch(b, c);
    }
  } else {
    e = b.clone();
  }
  c = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(c);
  e = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(e);
  if (c.hasExtension() && e.hasExtension() && c.getExtension() != e.getExtension()) {
    return i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
  }
  d = c.getCountryCodeOrDefault();
  var f = e.getCountryCodeOrDefault();
  if (0 != d && 0 != f) {
    return c.equals(e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH : d == f && this.isNationalNumberSuffixOfTheOther_(c, e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
  }
  c.setCountryCode(0);
  e.setCountryCode(0);
  return c.equals(e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : this.isNationalNumberSuffixOfTheOther_(c, e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNationalNumberSuffixOfTheOther_ = function(a, b) {
  var c = "" + a.getNationalNumber(), d = "" + b.getNationalNumber();
  return goog.string.endsWith(c, d) || goog.string.endsWith(d, c);
};
i18n.phonenumbers.PhoneNumberUtil.prototype.canBeInternationallyDialled = function(a) {
  var b = this.getMetadataForRegion(this.getRegionCodeForNumber(a));
  if (null == b) {
    return !0;
  }
  a = this.getNationalSignificantNumber(a);
  return !this.isNumberMatchingDesc_(a, b.getNoInternationalDialling());
};
i18n.phonenumbers.PhoneNumberUtil.matchesEntirely = function(a, b) {
  var c = "string" == typeof a ? b.match("^(?:" + a + ")$") : b.match(a);
  return c && c[0].length == b.length ? !0 : !1;
};
i18n.phonenumbers.PhoneNumberUtil.matchesPrefix = function(a, b) {
  var c = "string" == typeof a ? b.match("^(?:" + a + ")") : b.match(a);
  return c && goog.string.startsWith(b, c[0]) ? !0 : !1;
};
i18n.phonenumbers.AsYouTypeFormatter = function(a) {
  this.DIGIT_PLACEHOLDER_ = "\u2008";
  this.DIGIT_PATTERN_ = new RegExp(this.DIGIT_PLACEHOLDER_);
  this.currentOutput_ = "";
  this.formattingTemplate_ = new goog.string.StringBuffer;
  this.currentFormattingPattern_ = "";
  this.accruedInput_ = new goog.string.StringBuffer;
  this.accruedInputWithoutFormatting_ = new goog.string.StringBuffer;
  this.ableToFormat_ = !0;
  this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = this.inputHasFormatting_ = !1;
  this.phoneUtil_ = i18n.phonenumbers.PhoneNumberUtil.getInstance();
  this.positionToRemember_ = this.originalPosition_ = this.lastMatchPosition_ = 0;
  this.prefixBeforeNationalNumber_ = new goog.string.StringBuffer;
  this.shouldAddSpaceAfterNationalPrefix_ = !1;
  this.extractedNationalPrefix_ = "";
  this.nationalNumber_ = new goog.string.StringBuffer;
  this.possibleFormats_ = [];
  this.defaultCountry_ = a;
  this.defaultMetadata_ = this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_);
};
i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ = " ";
i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_ = new i18n.phonenumbers.PhoneMetadata;
i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_.setInternationalPrefix("NA");
i18n.phonenumbers.AsYouTypeFormatter.CHARACTER_CLASS_PATTERN_ = /\[([^\[\]])*\]/g;
i18n.phonenumbers.AsYouTypeFormatter.STANDALONE_DIGIT_PATTERN_ = /\d(?=[^,}][^,}])/g;
i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_ = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*(\\$\\d[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*)+$");
i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_ = /[- ]/;
i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ = 3;
i18n.phonenumbers.AsYouTypeFormatter.prototype.getMetadataForRegion_ = function(a) {
  a = this.phoneUtil_.getCountryCodeForRegion(a);
  a = this.phoneUtil_.getRegionCodeForCountryCode(a);
  a = this.phoneUtil_.getMetadataForRegion(a);
  return null != a ? a : i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.maybeCreateNewTemplate_ = function() {
  for (var a = this.possibleFormats_.length, b = 0; b < a; ++b) {
    var c = this.possibleFormats_[b], d = c.getPatternOrDefault();
    if (this.currentFormattingPattern_ == d) {
      return !1;
    }
    if (this.createFormattingTemplate_(c)) {
      return this.currentFormattingPattern_ = d, this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(c.getNationalPrefixFormattingRule()), this.lastMatchPosition_ = 0, !0;
    }
  }
  return this.ableToFormat_ = !1;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getAvailableFormats_ = function(a) {
  for (var b = this.isCompleteNumber_ && 0 < this.currentMetadata_.intlNumberFormatCount() ? this.currentMetadata_.intlNumberFormatArray() : this.currentMetadata_.numberFormatArray(), c = b.length, d = 0; d < c; ++d) {
    var e = b[d];
    (!this.currentMetadata_.hasNationalPrefix() || this.isCompleteNumber_ || e.getNationalPrefixOptionalWhenFormatting() || this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault())) && this.isFormatEligible_(e.getFormatOrDefault()) && this.possibleFormats_.push(e);
  }
  this.narrowDownPossibleFormats_(a);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.isFormatEligible_ = function(a) {
  return i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_.test(a);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.narrowDownPossibleFormats_ = function(a) {
  for (var b = [], c = a.length - i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_, d = this.possibleFormats_.length, e = 0; e < d; ++e) {
    var f = this.possibleFormats_[e];
    if (0 == f.leadingDigitsPatternCount()) {
      b.push(this.possibleFormats_[e]);
    } else {
      var g = Math.min(c, f.leadingDigitsPatternCount() - 1);
      f = f.getLeadingDigitsPattern(g);
      0 == a.search(f) && b.push(this.possibleFormats_[e]);
    }
  }
  this.possibleFormats_ = b;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.createFormattingTemplate_ = function(a) {
  var b = a.getPatternOrDefault();
  if (-1 != b.indexOf("|")) {
    return !1;
  }
  b = b.replace(i18n.phonenumbers.AsYouTypeFormatter.CHARACTER_CLASS_PATTERN_, "\\d");
  b = b.replace(i18n.phonenumbers.AsYouTypeFormatter.STANDALONE_DIGIT_PATTERN_, "\\d");
  this.formattingTemplate_.clear();
  a = this.getFormattingTemplate_(b, a.getFormatOrDefault());
  return 0 < a.length ? (this.formattingTemplate_.append(a), !0) : !1;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getFormattingTemplate_ = function(a, b) {
  var c = "999999999999999".match(a)[0];
  if (c.length < this.nationalNumber_.getLength()) {
    return "";
  }
  c = c.replace(new RegExp(a, "g"), b);
  return c = c.replace(RegExp("9", "g"), this.DIGIT_PLACEHOLDER_);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.clear = function() {
  this.currentOutput_ = "";
  this.accruedInput_.clear();
  this.accruedInputWithoutFormatting_.clear();
  this.formattingTemplate_.clear();
  this.lastMatchPosition_ = 0;
  this.currentFormattingPattern_ = "";
  this.prefixBeforeNationalNumber_.clear();
  this.extractedNationalPrefix_ = "";
  this.nationalNumber_.clear();
  this.ableToFormat_ = !0;
  this.inputHasFormatting_ = !1;
  this.originalPosition_ = this.positionToRemember_ = 0;
  this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = !1;
  this.possibleFormats_ = [];
  this.shouldAddSpaceAfterNationalPrefix_ = !1;
  this.currentMetadata_ != this.defaultMetadata_ && (this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_));
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigit = function(a) {
  return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a, !1);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitAndRememberPosition = function(a) {
  return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a, !0);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitWithOptionToRememberPosition_ = function(a, b) {
  this.accruedInput_.append(a);
  b && (this.originalPosition_ = this.accruedInput_.getLength());
  this.isDigitOrLeadingPlusSign_(a) ? a = this.normalizeAndAccrueDigitsAndPlusSign_(a, b) : (this.ableToFormat_ = !1, this.inputHasFormatting_ = !0);
  if (!this.ableToFormat_) {
    if (!this.inputHasFormatting_) {
      if (this.attemptToExtractIdd_()) {
        if (this.attemptToExtractCountryCallingCode_()) {
          return this.attemptToChoosePatternWithPrefixExtracted_();
        }
      } else {
        if (this.ableToExtractLongerNdd_()) {
          return this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.attemptToChoosePatternWithPrefixExtracted_();
        }
      }
    }
    return this.accruedInput_.toString();
  }
  switch(this.accruedInputWithoutFormatting_.getLength()) {
    case 0:
    case 1:
    case 2:
      return this.accruedInput_.toString();
    case 3:
      if (this.attemptToExtractIdd_()) {
        this.isExpectingCountryCallingCode_ = !0;
      } else {
        return this.extractedNationalPrefix_ = this.removeNationalPrefixFromNationalNumber_(), this.attemptToChooseFormattingPattern_();
      }
    default:
      if (this.isExpectingCountryCallingCode_) {
        return this.attemptToExtractCountryCallingCode_() && (this.isExpectingCountryCallingCode_ = !1), this.prefixBeforeNationalNumber_.toString() + this.nationalNumber_.toString();
      }
      if (0 < this.possibleFormats_.length) {
        var c = this.inputDigitHelper_(a), d = this.attemptToFormatAccruedDigits_();
        if (0 < d.length) {
          return d;
        }
        this.narrowDownPossibleFormats_(this.nationalNumber_.toString());
        return this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.ableToFormat_ ? this.appendNationalNumber_(c) : this.accruedInput_.toString();
      }
      return this.attemptToChooseFormattingPattern_();
  }
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChoosePatternWithPrefixExtracted_ = function() {
  this.ableToFormat_ = !0;
  this.isExpectingCountryCallingCode_ = !1;
  this.possibleFormats_ = [];
  this.lastMatchPosition_ = 0;
  this.formattingTemplate_.clear();
  this.currentFormattingPattern_ = "";
  return this.attemptToChooseFormattingPattern_();
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getExtractedNationalPrefix_ = function() {
  return this.extractedNationalPrefix_;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.ableToExtractLongerNdd_ = function() {
  if (0 < this.extractedNationalPrefix_.length) {
    var a = this.nationalNumber_.toString();
    this.nationalNumber_.clear();
    this.nationalNumber_.append(this.extractedNationalPrefix_);
    this.nationalNumber_.append(a);
    a = this.prefixBeforeNationalNumber_.toString();
    var b = a.lastIndexOf(this.extractedNationalPrefix_);
    this.prefixBeforeNationalNumber_.clear();
    this.prefixBeforeNationalNumber_.append(a.substring(0, b));
  }
  return this.extractedNationalPrefix_ != this.removeNationalPrefixFromNationalNumber_();
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.isDigitOrLeadingPlusSign_ = function(a) {
  return i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN.test(a) || 1 == this.accruedInput_.getLength() && i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN.test(a);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToFormatAccruedDigits_ = function() {
  for (var a = this.nationalNumber_.toString(), b = this.possibleFormats_.length, c = 0; c < b; ++c) {
    var d = this.possibleFormats_[c], e = d.getPatternOrDefault();
    if ((new RegExp("^(?:" + e + ")$")).test(a)) {
      return this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(d.getNationalPrefixFormattingRule()), a = a.replace(new RegExp(e, "g"), d.getFormat()), this.appendNationalNumber_(a);
    }
  }
  return "";
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.appendNationalNumber_ = function(a) {
  var b = this.prefixBeforeNationalNumber_.getLength();
  return this.shouldAddSpaceAfterNationalPrefix_ && 0 < b && this.prefixBeforeNationalNumber_.toString().charAt(b - 1) != i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ ? this.prefixBeforeNationalNumber_ + i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ + a : this.prefixBeforeNationalNumber_ + a;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getRememberedPosition = function() {
  if (!this.ableToFormat_) {
    return this.originalPosition_;
  }
  for (var a = 0, b = 0, c = this.accruedInputWithoutFormatting_.toString(), d = this.currentOutput_.toString(); a < this.positionToRemember_ && b < d.length;) {
    c.charAt(a) == d.charAt(b) && a++, b++;
  }
  return b;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChooseFormattingPattern_ = function() {
  var a = this.nationalNumber_.toString();
  return a.length >= i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ ? (this.getAvailableFormats_(a), a = this.attemptToFormatAccruedDigits_(), 0 < a.length ? a : this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.accruedInput_.toString()) : this.appendNationalNumber_(a);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputAccruedNationalNumber_ = function() {
  var a = this.nationalNumber_.toString(), b = a.length;
  if (0 < b) {
    for (var c = "", d = 0; d < b; d++) {
      c = this.inputDigitHelper_(a.charAt(d));
    }
    return this.ableToFormat_ ? this.appendNationalNumber_(c) : this.accruedInput_.toString();
  }
  return this.prefixBeforeNationalNumber_.toString();
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.isNanpaNumberWithNationalPrefix_ = function() {
  if (1 != this.currentMetadata_.getCountryCode()) {
    return !1;
  }
  var a = this.nationalNumber_.toString();
  return "1" == a.charAt(0) && "0" != a.charAt(1) && "1" != a.charAt(1);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.removeNationalPrefixFromNationalNumber_ = function() {
  var a = this.nationalNumber_.toString(), b = 0;
  if (this.isNanpaNumberWithNationalPrefix_()) {
    b = 1, this.prefixBeforeNationalNumber_.append("1").append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.isCompleteNumber_ = !0;
  } else {
    if (this.currentMetadata_.hasNationalPrefixForParsing()) {
      var c = new RegExp("^(?:" + this.currentMetadata_.getNationalPrefixForParsing() + ")");
      c = a.match(c);
      null != c && null != c[0] && 0 < c[0].length && (this.isCompleteNumber_ = !0, b = c[0].length, this.prefixBeforeNationalNumber_.append(a.substring(0, b)));
    }
  }
  this.nationalNumber_.clear();
  this.nationalNumber_.append(a.substring(b));
  return a.substring(0, b);
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractIdd_ = function() {
  var a = this.accruedInputWithoutFormatting_.toString(), b = new RegExp("^(?:\\" + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + "|" + this.currentMetadata_.getInternationalPrefix() + ")");
  b = a.match(b);
  return null != b && null != b[0] && 0 < b[0].length ? (this.isCompleteNumber_ = !0, b = b[0].length, this.nationalNumber_.clear(), this.nationalNumber_.append(a.substring(b)), this.prefixBeforeNationalNumber_.clear(), this.prefixBeforeNationalNumber_.append(a.substring(0, b)), a.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), !0) : !1;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractCountryCallingCode_ = function() {
  if (0 == this.nationalNumber_.getLength()) {
    return !1;
  }
  var a = new goog.string.StringBuffer, b = this.phoneUtil_.extractCountryCode(this.nationalNumber_, a);
  if (0 == b) {
    return !1;
  }
  this.nationalNumber_.clear();
  this.nationalNumber_.append(a.toString());
  a = this.phoneUtil_.getRegionCodeForCountryCode(b);
  i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == a ? this.currentMetadata_ = this.phoneUtil_.getMetadataForNonGeographicalRegion(b) : a != this.defaultCountry_ && (this.currentMetadata_ = this.getMetadataForRegion_(a));
  this.prefixBeforeNationalNumber_.append("" + b).append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_);
  this.extractedNationalPrefix_ = "";
  return !0;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.normalizeAndAccrueDigitsAndPlusSign_ = function(a, b) {
  if (a == i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
    var c = a;
    this.accruedInputWithoutFormatting_.append(a);
  } else {
    c = i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS[a], this.accruedInputWithoutFormatting_.append(c), this.nationalNumber_.append(c);
  }
  b && (this.positionToRemember_ = this.accruedInputWithoutFormatting_.getLength());
  return c;
};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitHelper_ = function(a) {
  var b = this.formattingTemplate_.toString();
  if (0 <= b.substring(this.lastMatchPosition_).search(this.DIGIT_PATTERN_)) {
    var c = b.search(this.DIGIT_PATTERN_);
    a = b.replace(this.DIGIT_PATTERN_, a);
    this.formattingTemplate_.clear();
    this.formattingTemplate_.append(a);
    this.lastMatchPosition_ = c;
    return a.substring(0, this.lastMatchPosition_ + 1);
  }
  1 == this.possibleFormats_.length && (this.ableToFormat_ = !1);
  this.currentFormattingPattern_ = "";
  return this.accruedInput_.toString();
};
i18n.phonenumbers.shortnumbermetadata = {};
i18n.phonenumbers.shortnumbermetadata.countryCodeToRegionCodeMap = {0:"AC AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PS PR PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR ST SV SX SY SZ TC TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW".split(" ")};
i18n.phonenumbers.shortnumbermetadata.countryToMetadata = {AC:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "AC", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], AD:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "AD", , , , , , , , , , , , , , , , , , [, , "11[0268]", , , , 
"112"], , [, , "11[0268]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], AE:[, [, , "[149]\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "AE", , , , , , , , , , , , , , , , , , [, , "112|99[789]", , , , "112", , , [3]], , [, , "112|445[16]|99[789]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "445[16]", , , , "4451", , , [4]]], AF:[, [, , "[14]\\d{2,4}", , , , , , , [3, 5]], 
, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "AF", , , , , , , , , , , , , , , , , , [, , "1(?:02|19)", , , , "119", , , [3]], , [, , "1(?:02|19)|40404", , , , "119"], [, , , , , , , , , [-1]], [, , "40404", , , , "40404", , , [5]], , [, , "40404", , , , "40404", , , [5]]], AG:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "AG", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "176|9(?:11|99)", , , , 
"911"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]], AI:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "AI", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]], AL:[, [, , "[15]\\d{2,5}", , , , , , , [3, 5, 6]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "AL", , , , , , , , 
, , , , , , , , , , [, , "1(?:12|2[789])", , , , "129", , , [3]], , [, , "1(?:1(?:2|6(?:000|1(?:06|11|23)))|2[5-9])|5\\d{4}", , , , "129"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "5\\d{4}", , , , "51234", , , [5]]], AM:[, [, , "[148]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "AM", , , , , , , , , , , , , , , , , , [, , "10[123]", , , , "102", , , [3]], , [, , "1\\d{2}|40404|8[1-7]\\d{2}", , , , "8711"], [, , , , , , , , , [-1]], 
[, , "40404", , , , "40404", , , [5]], , [, , "40404", , , , "40404", , , [5]]], AO:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "AO", , , , , , , , , , , , , , , , , , [, , "11[235]", , , , "113"], , [, , "11[235]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], AR:[, [, , "[01389]\\d{1,4}", , , , , , , [2, 3, 4, 5]], , , [, , "[09]\\d{2}|1(?:[02-9]\\d?|1[0-24-9]?)", , , , "111", , , [2, 3]], [, 
, , , , , , , , [-1]], , , , "AR", , , , , , , , , , , , , , , , , , [, , "10[017]|911", , , , "101", , , [3]], , [, , "000|1(?:0[0-35-7]|1[02-5]|2[15]|9)|3372|89338|911", , , , "121"], [, , , , , , , , , [-1]], [, , "89338|911", , , , "89338", , , [3, 5]], , [, , "3372|89338", , , , "3372", , , [4, 5]]], AS:[, [, , "[49]\\d{2,4}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "AS", , , , , , , , , , , , , , , , , , [, , "911", , , , "911", , , [3]], , [, , "40404|911", 
, , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "40404", , , , "40404", , , [5]]], AT:[, [, , "1\\d{2,5}", , , , , , , [3, 6]], , , [, , "116(?:00[06]|1(?:17|23))", , , , "116000", , , [6]], [, , , , , , , , , [-1]], , , , "AT", , , , , , , , , , , , , , , , , , [, , "1(?:[12]2|33|44)", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:00[06]|1(?:17|23)))|22|33|44)", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], AU:[, [, , "[027]\\d{2}|1\\d{2,7}", 
, , , , , , [3, 4, 5, 6, 7, 8]], , , [, , "1(?:258885|555)|733", , , , "733", , , [3, 4, 7]], [, , "1(?:2(?:34|456)|9\\d{4})", , , , "191123", , , [4, 5, 6]], , , , "AU", , , , , , , , , , , , , , , , , , [, , "000|1(?:06|12)", , , , "112", , , [3]], , [, , "000|1(?:06|1(?:00|2|9[46])|2(?:[23]\\d|4\\d{2,3}|5\\d{3,4}|8(?:2|[013-9]\\d))|555|9[13-5]\\d{3})|225|7(?:33|67)", , , , "112"], [, , "1(?:1\\d{2}|24733)|225|767", , , , "225", , , [3, 4, 6]], [, , "1(?:258885|555)", , , , "1555", , , [4, 7]], 
, [, , "19\\d{4,6}", , , , "191123", , , [6, 7, 8]]], AW:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "AW", , , , , , , , , , , , , , , , , , [, , "100|911", , , , "911"], , [, , "1(?:00|76)|911", , , , "911"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]], AX:[, [, , "1\\d{2}|75[12]\\d{2}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "AX", , , , , , , , , , , , , , , 
, , , [, , "112", , , , "112", , , [3]], , [, , "112|75[12]\\d{2}", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], AZ:[, [, , "[148]\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "AZ", , , , , , , , , , , , , , , , , , [, , "1(?:0[123]|12)", , , , "101", , , [3]], , [, , "1(?:0[123]|12)|4040|8800", , , , "101"], [, , , , , , , , , [-1]], [, , "4040|8800", , , , "4040", , , [4]], , [, , "4040|8800", , , 
, "4040", , , [4]]], BA:[, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "116\\d{3}", , , , "116000", , , [6]], [, , , , , , , , , [-1]], , , , "BA", , , , , , , , , , , , , , , , , , [, , "12[2-4]", , , , "122", , , [3]], , [, , "1(?:1(?:6(?:00[06]|1(?:1[17]|23))|8\\d{1,2})|2(?:0[0-7]|[2-5]|6[0-26]|[78]\\d{1,2})|[3-5]\\d{2}|7\\d{3})", , , , "122"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BB:[, [, , "[2-689]\\d{2}", , , , , , , [3]], , , [, , , , , 
, , , , [-1]], [, , , , , , , , , [-1]], , , , "BB", , , , , , , , , , , , , , , , , , [, , "[2359]11", , , , "211"], , [, , "[2-689]11", , , , "211"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BD:[, [, , "[19]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "BD", , , , , , , , , , , , , , , , , , [, , "10[0-2]|999", , , , "999", , , [3]], , [, , "1(?:0(?:[0-39]|5(?:0\\d|[1-4])|6\\d{2}|7[0-4]|8[0-29])|1[6-9]|2(?:2[0-5]|[34])|3(?:1\\d?|3\\d|6[3-6])|4(?:0\\d|1\\d{2})|5[2-9])|9(?:594|99)", 
, , , "103"], [, , , , , , , , , [-1]], [, , "9594", , , , "9594", , , [4]], , [, , "9594", , , , "9594", , , [4]]], BE:[, [, , "1\\d{2,5}|[2-9]\\d{3}", , , , , , , [3, 4, 6]], , , [, , "1(?:0[25-8]|1(?:0|6\\d{3})|7(?:12|77)|813)|8\\d{3}", , , , "116000"], [, , "1(?:2(?:12|34)|3(?:07|13)|414|\\d04)|[2-79]\\d{3}", , , , "7212", , , [4]], , , , "BE", , , , , , , , , , , , , , , , , , [, , "1(?:0[01]|12)", , , , "112", , , [3]], , [, , "1(?:0[0-8]|1(?:[027]|6(?:000|117))|2(?:0[47]|12|3[0-24]|99)|3(?:0[47]|13|99)|4(?:0[47]|14|50|99)|7(?:00|1[27-9]|33|65|7[17]|89)|81[39])|[2-9]\\d{3}", 
, , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "[2-9]\\d{3}", , , , "2787", , , [4]]], BF:[, [, , "1\\d", , , , , , , [2]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "BF", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BG:[, [, , "1\\d{2,5}", , , , , , , [3, 6]], , , [, , "116(?:000|111)", , , , "116000", , , [6]], [, , , , , , , 
, , [-1]], , , , "BG", , , , , , , , , , , , , , , , , , [, , "1(?:12|50|6[06])", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111))|50|6[06])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BH:[, [, , "[0189]\\d{2,4}", , , , , , , [3, 5]], , , [, , "(?:0[167]|81)\\d{3}", , , , "07123", , , [5]], [, , "9[148]\\d{3}", , , , "94123", , , [5]], , , , "BH", , , , , , , , , , , , , , , , , , [, , "[19]99", , , , "999", , , [3]], , [, , "0[167]\\d{3}|1(?:[02]\\d|12|4[01]|51|8[18]|9[169])|8[158]\\d{3}|9(?:[148]\\d{3}|9[02489])", 
, , , "999"], [, , , , , , , , , [-1]], [, , "0[67]\\d{3}|88000|98555", , , , "88000", , , [5]], , [, , "88000|98555", , , , "88000", , , [5]]], BI:[, [, , "[16-9]\\d{2,3}", , , , , , , [3, 4]], , , [, , "611", , , , "611", , , [3]], [, , , , , , , , , [-1]], , , , "BI", , , , , , , , , , , , , , , , , , [, , "11[237]", , , , "117", , , [3]], , [, , "1(?:1\\d|5[2-9]|6[0-256])|611|7(?:10|77|979)|8[28]8|900", , , , "117"], [, , , , , , , , , [-1]], [, , "611|7(?:10|77)|888|900", , , , "611", , , [3]], 
, [, , "710|900", , , , "900", , , [3]]], BJ:[, [, , "[17]\\d{2,3}", , , , , , , [3, 4]], , , [, , "7[3-5]\\d{2}", , , , "7312", , , [4]], [, , , , , , , , , [-1]], , , , "BJ", , , , , , , , , , , , , , , , , , [, , "11[78]", , , , "117", , , [3]], , [, , "1(?:1[78]|2[02-5]|60)|7[0-5]\\d{2}", , , , "117"], [, , , , , , , , , [-1]], [, , "12\\d", , , , "122", , , [3]], , [, , , , , , , , , [-1]]], BL:[, [, , "1\\d", , , , , , , [2]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "BL", 
, , , , , , , , , , , , , , , , , [, , "18", , , , "18"], , [, , "18", , , , "18"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BM:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "BM", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "176|911", , , , "911"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]], BN:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , 
, , , , , [-1]], [, , , , , , , , , [-1]], , , , "BN", , , , , , , , , , , , , , , , , , [, , "99[135]", , , , "991"], , [, , "99[135]", , , , "991"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BO:[, [, , "[14]\\d{2,4}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "BO", , , , , , , , , , , , , , , , , , [, , "11[089]", , , , "110", , , [3]], , [, , "11[089]|40404", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , 
, [-1]], , [, , "40404", , , , "40404", , , [5]]], BQ:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "BQ", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112"], , [, , "1(?:12|76)|911", , , , "112"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]], BR:[, [, , "[12469]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:00|[89]\\d)|4(?:57|828)", , , , "181", , , [3, 4]], [, , , , , , , , , [-1]], , , , 
"BR", , , , , , , , , , , , , , , , , , [, , "1(?:12|28|9[023])|911", , , , "190", , , [3]], , [, , "1(?:0(?:[02]|3(?:1[2-579]|2[13-9]|3[124-9]|4[1-3578]|5[1-468]|6[139]|8[149]|9[168])|5[0-35-9]|6(?:0|1[0-35-8]?|2[0145]|3[0137]?|4[37-9]?|5[0-35]|6[016]?|7[137]?|8[5-8]|9[1359]))|1[25-8]|2[35789]|3(?:[024568]|3[12])|4[12568]|5\\d|6[0-8]|8[015]|9[0-4789])|2(?:7(?:330|878)|85959?)|4(?:0404?|11[12]|57|828)|55555|6(?:0\\d{4}|10000)|911", , , , "168"], [, , "102|27330", , , , "27330", , , [3, 5]], [, , 
"151|27878|4(?:0404?|11[12]|57)|55555", , , , "27878", , , [3, 4, 5]], , [, , "2(?:7(?:330|878)|85959?)|4(?:0404|828)|6(?:0\\d{4}|10000)", , , , "27878", , , [4, 5, 6]]], BS:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "BS", , , , , , , , , , , , , , , , , , [, , "91[19]", , , , "911"], , [, , "91[19]", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BT:[, [, , "[14]\\d{2,4}", , , , , , , [3, 5]], 
, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "BT", , , , , , , , , , , , , , , , , , [, , "11[023]", , , , "113", , , [3]], , [, , "11[0-6]|40404", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "40404", , , , "40404", , , [5]]], BW:[, [, , "[19]\\d{2,4}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "BW", , , , , , , , , , , , , , , , , , [, , "99[789]", , , , "999", , , [3]], , [, , "13123|99[789]", , , , "999"], [, 
, , , , , , , , [-1]], [, , "13123", , , , "13123", , , [5]], , [, , "13123", , , , "13123", , , [5]]], BY:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "BY", , , , , , , , , , , , , , , , , , [, , "1(?:0[123]|12)", , , , "112"], , [, , "1(?:0[1-79]|1[246]|35|5[1235]|6[89]|7[5-7]|8[58]|9[1-7])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], BZ:[, [, , "9\\d{1,2}", , , , , , , [2, 3]], , , [, , , 
, , , , , , [-1]], [, , , , , , , , , [-1]], , , , "BZ", , , , , , , , , , , , , , , , , , [, , "9(?:0|11)", , , , "911"], , [, , "9(?:0|11)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CA:[, [, , "[124-9]\\d{2,5}|3(?:\\d{2,5}|\\d{7})", , , , , , , [3, 5, 6, 8]], , , [, , "211", , , , "211", , , [3]], [, , , , , , , , , [-1]], , , , "CA", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "911", , , [3]], , [, , "1(?:12|\\d{4,5})|[25-9](?:11|\\d{4,5})|3(?:\\d{4,5}|0000\\d{3}|11)|411", 
, , , "12345"], [, , , , , , , , , [-1]], [, , "[23567]11", , , , "611", , , [3]], , [, , "[125-9]\\d{4,5}|3(?:\\d{4,5}|0000\\d{3})", , , , "30001", , , [5, 6, 8]]], CC:[, [, , "[01]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "CC", , , , , , , , , , , , , , , , , , [, , "000|112", , , , "112"], , [, , "000|112", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CD:[, [, , "[14]\\d{2,4}", , , , , , , [3, 5]], 
, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "CD", , , , , , , , , , , , , , , , , , [, , "1(?:1[348]|77|88)", , , , "113", , , [3]], , [, , "1(?:1[348]|23|77|88)|40404", , , , "40404"], [, , , , , , , , , [-1]], [, , "40404", , , , "40404", , , [5]], , [, , "40404", , , , "40404", , , [5]]], CF:[, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "CF", , , , , , , , , , , , , , , , , , [, , "1(?:1[78]|220)", , , , "1220"], , [, 
, "1(?:1[478]|220)", , , , "117"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CG:[, [, , "11\\d", , , , , , , [3]], , , [, , "111", , , , "111"], [, , , , , , , , , [-1]], , , , "CG", , , , , , , , , , , , , , , , , , [, , "11[78]", , , , "117"], , [, , "11[12678]", , , , "117"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CH:[, [, , "[1-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:16\\d{3}|47)|5200", , , , "116000", 
, , [3, 4, 6]], [, , "1(?:145|8\\d{2})|543|83111", , , , "543", , , [3, 4, 5]], , , , "CH", , , , , , , , , , , , , , , , , , [, , "1(?:1[278]|44)", , , , "112", , , [3]], , [, , "1(?:0[78]\\d{2}|1(?:[278]|45|6(?:000|111))|4(?:[03457]|1[45])|6(?:00|[1-46])|8(?:02|1[189]|50|7|8[08]|99))|[2-9]\\d{2,4}", , , , "147"], [, , "1(?:4(?:[035]|1\\d)|6\\d{1,2})", , , , "1600", , , [3, 4]], [, , "5(?:200|35)", , , , "535", , , [3, 4]], , [, , "[2-9]\\d{2,4}", , , , "600", , , [3, 4, 5]]], CI:[, [, , "[14]\\d{2,3}", 
, , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "CI", , , , , , , , , , , , , , , , , , [, , "1(?:1[01]|[78]0)", , , , "110", , , [3]], , [, , "1(?:1[01]|[78]0)|4443", , , , "110"], [, , , , , , , , , [-1]], [, , "4443", , , , "4443", , , [4]], , [, , "4443", , , , "4443", , , [4]]], CK:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "CK", , , , , , , , , , , , , , , , , , [, , "99[689]", , , , "998"], , [, , "99[689]", 
, , , "998"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CL:[, [, , "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1213|4342", , , , "4342", , , [4]], [, , "1(?:060|211|3(?:13|[348]0|5[01])|417|560|818|9(?:19|80))|2(?:0122|22[47]|323|777|882)|3(?:0(?:51|99)|132|3(?:29|77|90)|665)|4(?:142|243|3656|4(?:02|15|77)|554)|5(?:004|4154|5(?:66|77)|995)|6(?:0700|131|222|3(?:00|66)|500|699)|7878|8(?:011|11[28]|482|889)|9(?:011|[12]00|330)", , , , "2224", , , [4, 5]], 
, , , "CL", , , , , , , , , , , , , , , , , , [, , "13[123]|911", , , , "133", , , [3]], , [, , "1(?:06?0|21[13]|3(?:[02679]|13?|[348]0?|5[01]?)|4(?:0[02-6]|17|[379])|560|818|9(?:19|80))|2(?:0(?:01|122)|22[47]|323|777|882)|3(?:0(?:51|99)|132|3(?:29|37|77|90)|665)|4(?:142|243|3(?:42|656)|4(?:02|15|77)|554)|5(?:004|4154|5(?:66|77)|995)|6(?:0700|131|222|3(?:00|66)|500|699)|7878|8(?:011|11[28]|482|889)|9(?:011|1(?:1|00)|200|330)", , , , "139"], [, , "2001|3337", , , , "3337", , , [4]], [, , , , , , , 
, , [-1]], , [, , "(?:[137-9]|[2456]\\d?)\\d{3}", , , , "5577", , , [4, 5]]], CM:[, [, , "[18]\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "CM", , , , , , , , , , , , , , , , , , [, , "1?1[37]", , , , "113", , , [2, 3]], , [, , "1?1[37]|8711", , , , "113"], [, , , , , , , , , [-1]], [, , "8711", , , , "8711", , , [4]], , [, , "8711", , , , "8711", , , [4]]], CN:[, [, , "[19]\\d{2,5}", , , , , , , [3, 5, 6]], , , [, , , , , , , , , [-1]], [, , , 
, , , , , , [-1]], , , , "CN", , , , , , , , , , , , , , , , , , [, , "1(?:1[09]|20)", , , , "119", , , [3]], , [, , "1(?:00\\d{2}|1[09]|20)|95\\d{3,4}", , , , "119"], [, , "100\\d{2}|95\\d{3,4}", , , , "95566", , , [5, 6]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CO:[, [, , "[148]\\d{2,4}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "CO", , , , , , , , , , , , , , , , , , [, , "1(?:1[29]|23|32|56)", , , , "112", , , [3]], , [, , "1(?:06|1[2569]|2[357]|3[27]|4[467]|5[36]|6[45]|95)|40404|85432", 
, , , "112"], [, , , , , , , , , [-1]], [, , "40404|85432", , , , "40404", , , [5]], , [, , "40404|85432", , , , "40404", , , [5]]], CR:[, [, , "[1359]\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "CR", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "911", , , [3]], , [, , "1(?:0(?:00|15|2[2-4679])|1(?:1[0-35-9]|2|37|[46]6|7[57]|8[79]|9[0-379])|2(?:00|[12]2|34|55)|3(?:21|33)|4(?:0[06]|1[4-6])|5(?:15|5[15])|693|7(?:00|1[789]|2[02]|[67]7)|975)|3855|5(?:0(?:30|49)|510)|911", 
, , , "1022"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "3855|5(?:0(?:30|49)|510)", , , , "3855", , , [4]]], CU:[, [, , "1\\d{2,5}", , , , , , , [3, 6]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "CU", , , , , , , , , , , , , , , , , , [, , "10[456]", , , , "106", , , [3]], , [, , "1(?:0[456]|1(?:6111|8)|40)", , , , "140"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CV:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , 
, , , [-1]], [, , , , , , , , , [-1]], , , , "CV", , , , , , , , , , , , , , , , , , [, , "13[012]", , , , "132"], , [, , "13[012]", , , , "132"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CW:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "CW", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112"], , [, , "1(?:12|76)|911", , , , "112"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , 
"176", , , , "176"]], CX:[, [, , "[01]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "CX", , , , , , , , , , , , , , , , , , [, , "000|112", , , , "112"], , [, , "000|112", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CY:[, [, , "1\\d{2,5}", , , , , , , [3, 6]], , , [, , "116(?:000|111)", , , , "116000", , , [6]], [, , , , , , , , , [-1]], , , , "CY", , , , , , , , , , , , , , , , , , [, , "1(?:12|99)", , 
, , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111))|99)", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], CZ:[, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "116(?:00[06]|111|123)", , , , "116000", , , [6]], [, , , , , , , , , [-1]], , , , "CZ", , , , , , , , , , , , , , , , , , [, , "1(?:12|5[0568])", , , , "112", , , [3]], , [, , "1(?:1(?:2|6\\d{3}|8\\d)|2\\d{2,3}|3\\d{3,4}|4\\d{3}|5[0568]|99)", , , , "116123"], [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], DE:[, [, , "1\\d{2,5}", , , , , , , [3, 6]], , , [, , "116\\d{3}", , , , "116000", , , [6]], [, , , , , , , , , [-1]], , , , "DE", , , , , , , , , , , , , , , , , , [, , "11[02]", , , , "112", , , [3]], , [, , "11(?:[025]|6(?:00[06]|1(?:1[17]|23)))", , , , "115"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], DJ:[, [, , "1\\d", , , , , , , [2]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "DJ", 
, , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], DK:[, [, , "1\\d{2,5}", , , , , , , [3, 4, 6]], , , [, , "116(?:00[06]|111)", , , , "116000", , , [6]], [, , , , , , , , , [-1]], , , , "DK", , , , , , , , , , , , , , , , , , [, , "11[24]", , , , "112", , , [3]], , [, , "1(?:1(?:[2-48]|6(?:00[06]|111))|8(?:01|1[0238]|28|30|5[13]|81))", , , , "112"], [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], , [, , , , , , , , , [-1]]], DM:[, [, , "[39]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "DM", , , , , , , , , , , , , , , , , , [, , "333|9(?:11|99)", , , , "999"], , [, , "333|9(?:11|99)", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], DO:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "DO", , , , , , , , , , , , , , , , , , [, 
, "112|911", , , , "112"], , [, , "112|911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], DZ:[, [, , "[17]\\d{1,2}", , , , , , , [2, 3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "DZ", , , , , , , , , , , , , , , , , , [, , "1[47]", , , , "17", , , [2]], , [, , "1[47]|730", , , , "17"], [, , , , , , , , , [-1]], [, , "730", , , , "730", , , [3]], , [, , "730", , , , "730", , , [3]]], EC:[, [, , "[19]\\d{2}", , , , , , , [3]], 
, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "EC", , , , , , , , , , , , , , , , , , [, , "1(?:0[12]|12)|911", , , , "911"], , [, , "1(?:0[12]|12)|911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], EE:[, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:[02]|6(?:000|111))|2(?:0(?:16|5)|28|55[47])|3(?:014|24|3(?:21|5)|660)|492|5(?:1[03]|410|501|977)|6(?:112|333|644)|7(?:012|127|89)|8(?:10|8[57])|9(?:0(?:[134]|90)|14))", 
, , , "116000"], [, , "1(?:18(?:[12458]|00)|2(?:0(?:[02-46-8]|1[0-36])|1(?:[0-4]|6[06])|2(?:[0-4]|5[25])|[367]|4(?:0[04]|[12]|4[24]|54)55[12457])|3(?:0(?:[02]|1[13578]|3[356])|1[1347]|2[02-5]|3(?:[01347]|2[023]|88)|4(?:[35]|4[34])|5(?:3[134]|5[035])|666)|4(?:2(?:00|4)|4(?:0[01358]|1[024]|50|7)|900)|5(?:0[0-35]|1(?:[1267]|5[0-7]|82)|2(?:[014-6]|22)|330|4(?:[35]|44)|5(?:00|[1-69])|9(?:[159]|[38]0|77))|6(?:1(?:00|1[19]|[356-9])|2(?:2[26]|[68])|3(?:22|36|6[36])|5|6(?:[0-359]|6[0-26])|7(?:00|55|7|8[89])|9(?:00|1|69))|7(?:0(?:[023]|1[0578])|1(?:00|2[034]|[4-9])|2(?:[07]|20|44)|7(?:[0-57]|9[79])|8(?:0[08]|2|8[0178])|9(?:00|97))|8(?:1[127]|8[1268]|9[269])|9(?:0(?:[02]|69|9[0269])|1[123689]|21))", 
, , , "1182", , , [3, 4, 5]], , , , "EE", , , , , , , , , , , , , , , , , , [, , "11[02]", , , , "112", , , [3]], , [, , "1(?:1(?:[02-579]|6(?:000|111)|8(?:[09]\\d|[1-8]))|2(?:[0-245]\\d{1,2}|[36-9])|3(?:[0-6]\\d{1,2}|[7-9])|4(?:[1-489]\\d{1,2}|[05-7])|5(?:[0-59]\\d{1,2}|[6-8])|6(?:[05]|[1-46-9]\\d{1,2})|7(?:[0-27-9]\\d{1,2}|[3-6])|8(?:[02-7]|[189]\\d{1,2})|9(?:[0-2]\\d{1,2}|[3-9]))", , , , "115"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "1(?:18[1258]2(?:0(?:1[036]|[46])|166|21|4(?:0[04]|1|5[47])|[67])|3(?:0(?:1[13-578]|2|3[56])|1[15]|2[045]|3(?:[13]|2[13])|43|5(?:00|3[34]|53))|44(?:0[0135]|14|50|7)|5(?:05|1(?:[12]|5[1246]|8[12])|2(?:[01]|22)|3(?:00|3[03])|4(?:15|5)|500|9(?:5|77|80))|6(?:1[35-8]|226|3(?:22|3[36]|66)|644|7(?:00|7|89)|9(?:00|69))|7(?:01[258]|1(?:00|[15])|2(?:44|7)|8(?:00|87|9))|8(?:1[128]|8[56]|9(?:[26]|77))|90(?:2|69|92))", 
, , , "13500", , , [4, 5]]], EG:[, [, , "[13]\\d{2,4}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "EG", , , , , , , , , , , , , , , , , , [, , "1(?:2[23]|80)", , , , "122", , , [3]], , [, , "1(?:2[23]|[69]\\d{3}|80)|34400", , , , "122"], [, , , , , , , , , [-1]], [, , "34400", , , , "34400", , , [5]], , [, , "34400", , , , "34400", , , [5]]], EH:[, [, , "1\\d{1,2}", , , , , , , [2, 3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "EH", , 
, , , , , , , , , , , , , , , , [, , "1(?:[59]|77)", , , , "15"], , [, , "1(?:[59]|77)", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ER:[, [, , "[12]\\d{2,5}", , , , , , , [3, 6]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "ER", , , , , , , , , , , , , , , , , , [, , "1(?:1[2-46]|2(?:4422|7799))|2(?:0(?:1(?:606|917)|2(?:099|914)))", , , , "113"], , [, , "1(?:1[2-6]|2(?:4422|7799))|2(?:0(?:1(?:606|917)|2(?:099|914)))", , , , "114"], 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ES:[, [, , "[0-379]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "0(?:16|6[57]|88)|1(?:006|16\\d{3}|[3-7]\\d{2})|20\\d{4}", , , , "116111", , , [3, 4, 6]], [, , "1(?:18\\d{2}|2\\d{1,4})|2(?:2\\d{1,4}|[3-9]\\d{3,4})|9(?:0(?:5[124578]|7)|\\d{4,5})|[37]\\d{4,5}", , , , "23456"], , , , "ES", , , , , , , , , , , , , , , , , , [, , "08[58]|112", , , , "112", , , [3]], , [, , "0(?:1[0-26]|6[0-257]|8[058]|9[12])|1(?:0[03-57]\\d{1,3}|1(?:2|6(?:000|111)|8\\d{2})|2\\d{1,4}|3(?:[34]|\\d{2})|7(?:7|\\d{2})|[4-689]\\d{2})|2(?:[01]\\d{4}|2\\d{1,4}|[357]\\d{3}|80\\d{2})|3[357]\\d{3}|79[57]\\d{3}|9(?:0(?:5[124578]|7)|9[57]\\d{3})", 
, , , "010"], [, , "0(?:[16][0-2]|80|9[12])|21\\d{4}", , , , "211234", , , [3, 6]], [, , "1(?:2\\d{1,4}|3[34]|77)|22\\d{1,4}", , , , "123"], , [, , "[2379]\\d{4,5}", , , , "23456", , , [5, 6]]], ET:[, [, , "9\\d{1,2}", , , , , , , [2, 3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "ET", , , , , , , , , , , , , , , , , , [, , "9(?:11?|[23]|9[17])", , , , "991"], , [, , "9(?:11?|[23]|9[17])", , , , "991"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , 
[-1]]], FI:[, [, , "1\\d{2,5}|75[12]\\d{2}", , , , , , , [3, 5, 6]], , , [, , "116111", , , , "116111", , , [6]], [, , , , , , , , , [-1]], , , , "FI", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "11(?:2|6111)|75[12]\\d{2}", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], FJ:[, [, , "[0-579]\\d{1,4}", , , , , , , [2, 3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "FJ", , , , , , , , , , , , , , , 
, , , [, , "91[17]", , , , "911", , , [3]], , [, , "0(?:1[34]|8[1-4])|1(?:0[1-3]|[25]9)|2[289]|30|4(?:0404|4)|54|75|91[137]", , , , "22"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "40404", , , , "40404", , , [5]]], FK:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "FK", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "1\\d{2}|999", , , , "123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , 
, , , , , , [-1]]], FM:[, [, , "3\\d{5}|9\\d{2}", , , , , , , [3, 6]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "FM", , , , , , , , , , , , , , , , , , [, , "320221|911", , , , "911"], , [, , "320221|911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], FO:[, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "FO", , , , , , , , , , , , , , , , , , [, , "11[24]", , , , "112", , , 
[3]], , [, , "1(?:1[248]|4[124]\\d|71\\d|8[7-9]\\d)", , , , "114"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], FR:[, [, , "1\\d{1,5}|[267]\\d{2,4}|3\\d{3,4}|[458]\\d{4}", , , , , , , [2, 3, 4, 5, 6]], , , [, , "1(?:0(?:07|13)|1(?:[0459]|6\\d{3}|871[03])|9[167])|224|3(?:[01]\\d{2}|3700)|740", , , , "3010", , , [3, 4, 5, 6]], [, , "118(?:[0-68]\\d{2}|7(?:0\\d|1[1-9]|[2-9]\\d))|36665|[4-8]\\d{4}", , , , "42000", , , [5, 6]], , , , "FR", , , , , , , , , , , , , , 
, , , , [, , "1(?:[578]|12)", , , , "112", , , [2, 3]], , [, , "1(?:0\\d{2}|1(?:[02459]|6(?:000|111)|8\\d{3})|9[167]|[578])|2(?:0(?:000|20)|24)|3\\d{3,4}|6(?:1[14]|34|\\d{4})|7(?:0[06]|22|40|\\d{4})|[458]\\d{4}", , , , "1010"], [, , "10(?:14|2[23]|34|6[14]|99)|2020|3(?:646|9[07]0)|6(?:1[14]|34)|70[06]", , , , "1023", , , [3, 4]], [, , "118777|2(?:0(?:000|20)|24)|6(?:1[14]|34)|7\\d{2}", , , , "118777", , , [3, 4, 5, 6]], , [, , "(?:114|[3-8]\\d{4})", , , , "33700", , , [3, 5]]], GA:[, [, , "1\\d{1,3}", 
, , , , , , [2, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GA", , , , , , , , , , , , , , , , , , [, , "1(?:730|8|3\\d{2})", , , , "1730"], , [, , "1(?:730|8|3\\d{2})", , , , "1730"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GB:[, [, , "[1-467-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:05|16\\d{3}|7[56]0|8000)|2(?:202|48)|4444", , , , "116000"], [, , , , , , , , , [-1]], , , , "GB", , , , , , , , , , , , , , , , , , [, , 
"112|999", , , , "112", , , [3]], , [, , "1(?:0[015]|1(?:[12]|6(?:000|1(?:11|23))|8\\d{3})|2(?:[123]|50)|33|4(?:1|7\\d)|5(?:\\d|71)|7(?:0\\d|[56]0)|800\\d|9[15])|2(?:02(?:02)?|1300|2(?:02|11|2)|3(?:02|336|45)|4(?:25|8))|3[13]3|4(?:0[02]|35[01]|44[45]|5\\d)|6(?:50|\\d{4})|7(?:0\\d{3}|8(?:9|\\d{3})|9\\d{3})|8\\d{4}|9(?:01|99)", , , , "150"], [, , , , , , , , , [-1]], [, , "1(?:250|571|7[56]0)|2(?:02(?:02)?|1300|3336|48)|4444|901", , , , "1571", , , [3, 4, 5]], , [, , "1250|2(?:0202|1300)|7\\d{4}|8[01]\\d{3}", 
, , , "20202", , , [4, 5]]], GD:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GD", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]], GE:[, [, , "[041]\\d{2,4}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GE", , , , , , , , , , , , , , , , , , [, , "0(?:11|22|33)|1(?:1[123]|22)", , , 
, "112", , , [3]], , [, , "0(?:11|22|33)|1(?:1[123]|22)|40404", , , , "112"], [, , , , , , , , , [-1]], [, , "40404", , , , "40404", , , [5]], , [, , "40404", , , , "40404", , , [5]]], GF:[, [, , "1\\d", , , , , , , [2]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GG:[, [, , "[19]\\d{2,5}", , , , , , , 
[3, 4, 5, 6]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GG", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "999", , , [3]], , [, , "1(?:0[01]|1(?:[12]|[68]\\d{3})|23|4(?:1|7\\d)|55|800\\d|9[05])|999", , , , "155"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GH:[, [, , "[14589]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GH", , , , , , , , , , , , , , , , , , [, , "19[123]|999", 
, , , "999", , , [3]], , [, , "19[123]|40404|(?:54|83)00|999", , , , "999"], [, , , , , , , , , [-1]], [, , "40404|(?:54|83)00", , , , "5400", , , [4, 5]], , [, , "40404|(?:54|83)00", , , , "5400", , , [4, 5]]], GI:[, [, , "[158]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:00|16\\d{3}|23|4(?:1|7\\d)|5[15]|9[2-4])|555|80\\d{2}", , , , "100", , , [3, 4, 6]], [, , "8[1-69]\\d{2}", , , , "8112", , , [4]], , , , "GI", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[09])", , , , "112", , , [3]], 
, [, , "1(?:00|1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d{2})|23|4(?:1|7[014])|5[015]|9[02349])|555|8(?:0(?:0|\\d{2})|[1-35-79]\\d{2}|4(?:[0-2]|\\d{2})|8[1-589])", , , , "116000"], [, , "150|87\\d{2}", , , , "150", , , [3, 4]], [, , "1(?:18\\d{2}|23|51|9[2-4])|555|8(?:00|88)", , , , "123", , , [3, 5]], , [, , , , , , , , , [-1]]], GL:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GL", , , , , , , , , , , , , , , , , , [, , "112", , , , "112"], , [, , 
"112", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GM:[, [, , "1\\d{1,2}", , , , , , , [2, 3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GM", , , , , , , , , , , , , , , , , , [, , "1?1[678]", , , , "117"], , [, , "1?1[678]", , , , "117"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GN:[, [, , "4\\d{4}", , , , , , , [5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GN", 
, , , , , , , , , , , , , , , , , [, , , , , , , , , [-1]], , [, , "40404", , , , "40404"], [, , , , , , , , , [-1]], [, , "40404", , , , "40404"], , [, , "40404", , , , "40404"]], GP:[, [, , "1\\d", , , , , , , [2]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GP", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "18"], , [, , "1[578]", , , , "18"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GR:[, [, , "1\\d{2,5}", , , , , , , [3, 6]], 
, , [, , "116\\d{3}", , , , "116000", , , [6]], [, , , , , , , , , [-1]], , , , "GR", , , , , , , , , , , , , , , , , , [, , "1(?:00|12|66|99)", , , , "112", , , [3]], , [, , "1(?:00|1(?:2|6(?:000|1(?:11|23)))|66|99)", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GT:[, [, , "[14]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GT", , , , , , , , , , , , , , , , , , [, , "1(?:10|2[03])", , , , "110", 
, , [3]], , [, , "1(?:10|2\\d|[57]\\d{2})|40404", , , , "123"], [, , , , , , , , , [-1]], [, , "40404", , , , "40404", , , [5]], , [, , "40404", , , , "40404", , , [5]]], GU:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GU", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GW:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , 
, , , , , [-1]], [, , , , , , , , , [-1]], , , , "GW", , , , , , , , , , , , , , , , , , [, , "11[378]", , , , "113"], , [, , "11[378]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], GY:[, [, , "[019]\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GY", , , , , , , , , , , , , , , , , , [, , "91[123]", , , , "911", , , [3]], , [, , "0(?:02|171|444|7(?:[67]7|9)|801|9(?:0[78]|[2-47]))|1(?:443|5[568])|91[123]", 
, , , "0801"], [, , , , , , , , , [-1]], [, , "1443", , , , "1443", , , [4]], , [, , "1443", , , , "1443", , , [4]]], HK:[, [, , "[19]\\d{2,6}", , , , , , , [3, 4, 5, 6, 7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "HK", , , , , , , , , , , , , , , , , , [, , "112|99[29]", , , , "999", , , [3]], , [, , "1(?:0(?:[0136]\\d{0,4}|2[14]\\d{0,3}|8[138]|9)|12|2(?:[0-3]\\d{0,4}|58\\d{0,3}|8[13]\\d{0,3})|7(?:[135-9]\\d{0,4}|21[89]\\d{0,2}|421\\d{0,2})|8(?:0(?:[13]\\d|60\\d{2}|8)|1(?:0\\d|[2-8])|2(?:182|3|8[128])|3\\d{4}|4(?:1[1-5]|[23]1|6[12])|50[138]|6(?:000|1(?:[13]1|86)|8)|7(?:13|2[1-389]|8[0235-9]|93)\\d{2}|8\\d))|99[29]", 
, , , "999"], [, , , , , , , , , [-1]], [, , "1(?:0(?:8\\d|9)|850\\d)", , , , "1088", , , [3, 4, 5]], , [, , , , , , , , , [-1]]], HN:[, [, , "[14]\\d{2,4}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "HN", , , , , , , , , , , , , , , , , , [, , "199", , , , "199", , , [3]], , [, , "199|40404", , , , "199"], [, , , , , , , , , [-1]], [, , "40404", , , , "40404", , , [5]], , [, , "40404", , , , "40404", , , [5]]], HR:[, [, , "[19]\\d{1,5}", , , , , , , [2, 3, 
4, 5, 6]], , , [, , "1(?:16\\d{3}|3977)", , , , "116000", , , [5, 6]], [, , "118\\d{2}", , , , "11812", , , [5]], , , , "HR", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[2-4])|9[34]", , , , "112", , , [2, 3]], , [, , "1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d{2})|3977|9(?:[2-5]|87))|9[34]", , , , "112"], [, , , , , , , , , [-1]], [, , "13977", , , , "13977", , , [5]], , [, , "13977", , , , "13977", , , [5]]], HT:[, [, , "[14]\\d{2,4}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , 
, , , , , , [-1]], , , , "HT", , , , , , , , , , , , , , , , , , [, , "11[48]", , , , "118", , , [3]], , [, , "11[48]|40404", , , , "114"], [, , , , , , , , , [-1]], [, , "40404", , , , "40404", , , [5]], , [, , "40404", , , , "40404", , , [5]]], HU:[, [, , "1\\d{2,5}", , , , , , , [3, 6]], , , [, , "116(?:000|1(?:11|23))", , , , "116000", , , [6]], [, , , , , , , , , [-1]], , , , "HU", , , , , , , , , , , , , , , , , , [, , "1(?:0[457]|12)", , , , "112", , , [3]], , [, , "1(?:0[457]|1(?:2|6(?:000|1(?:11|23))))", 
, , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ID:[, [, , "[178]\\d{2,4}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "ID", , , , , , , , , , , , , , , , , , [, , "11[02389]", , , , "112", , , [3]], , [, , "1(?:1[02389]|40\\d{2})|71400|89887", , , , "112"], [, , , , , , , , , [-1]], [, , "71400|89887", , , , "71400", , , [5]], , [, , "71400", , , , "71400", , , [5]]], IE:[, [, , "[159]\\d{2,5}", , , , , , , [3, 
4, 5, 6]], , , [, , "116\\d{3}", , , , "116000", , , [6]], [, , "5[37]\\d{3}", , , , "53012", , , [5]], , , , "IE", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d{2})|9\\d{2})|5[0137]\\d{3}|999", , , , "112"], [, , "51\\d{3}", , , , "51012", , , [5]], [, , "51210", , , , "51210", , , [5]], , [, , "118\\d{2}|5(?:[037]\\d{3}|1210)", , , , "51210", , , [5]]], IL:[, [, , "1\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , , , , , , 
, , [-1]], [, , , , , , , , , [-1]], , , , "IL", , , , , , , , , , , , , , , , , , [, , "1(?:0[012]|12)", , , , "112", , , [3]], , [, , "1(?:0(?:[012]|400)|1(?:[013-9]\\d|2)|[2-9]\\d{2})", , , , "1455"], [, , , , , , , , , [-1]], [, , "10400", , , , "10400", , , [5]], , [, , "10400", , , , "10400", , , [5]]], IM:[, [, , "[189]\\d{2,5}", , , , , , , [3, 5, 6]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "IM", , , , , , , , , , , , , , , , , , [, , "999", , , , "999", , , [3]], , 
[, , "1\\d{2}(?:\\d{3})?|8(?:6444|9887)|999", , , , "150"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "8(?:6444|9887)", , , , "86444", , , [5]]], IN:[, [, , "[125]\\d{2,7}", , , , , , , [3, 4, 5, 6, 7, 8]], , , [, , "1\\d{2,5}", , , , "105010", , , [3, 4, 5, 6]], [, , "11[67][0-2]\\d{3}|56161561", , , , "1160530", , , [7, 8]], , , , "IN", , , , , , , , , , , , , , , , , , [, , "1(?:0[0128]|12|298)|2611", , , , "108", , , [3, 4]], , [, , "1(?:0(?:[01248]|5(?:010|6|902)|7(?:[07]|80)|9[0157])|1(?:[289]|[67][0-2]\\d{3})|2(?:1|98)|39|4[01]|55[23]\\d{2}|7000|9(?:0[019]|47|50|6[1347]|[89]))|2611|5(?:14(?:2[5-9]|[34]\\d)|3000|6161(?:17[89]|561)|757555)", 
, , , "108"], [, , "5(?:14(?:2[5-9]|[34]\\d)|757555)", , , , "5757555", , , [5, 7]], [, , "1(?:1(?:[67][0-2]\\d{3}|[89])|21|4[01]|55330|7\\d{3}|9(?:[89]|09))|5(?:3000|6161(?:17[89]|561))", , , , "53000"], , [, , "1(?:39|90[019])|5(?:14(?:2[5-9]|[34]\\d)|6161(?:17[89]|561)|757555)", , , , "51431", , , [3, 4, 5, 7, 8]]], IQ:[, [, , "[1479]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "IQ", , , , , , , , , , , , , , , , , , [, , "1(?:0[04]|15|22)", 
, , , "122", , , [3]], , [, , "1(?:0[04]|15|22)|4432|71117|9988", , , , "4432"], [, , , , , , , , , [-1]], [, , "4432|71117|9988", , , , "4432", , , [4, 5]], , [, , "4432|71117|9988", , , , "4432", , , [4, 5]]], IR:[, [, , "[0-29]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1[129]\\d", , , , "123", , , [3]], [, , , , , , , , , [-1]], , , , "IR", , , , , , , , , , , , , , , , , , [, , "1(?:1[025]|25)|911", , , , "112", , , [3]], , [, , "096(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])|1(?:1[0-68]|2[0-59]|3[346-8]|4(?:[0147]|[289]0)|5(?:0[14]|1[02479]|2[0-3]|39|[49]0|65)|6(?:[16]6|[27]|90)|8(?:03|1[18]|22|3[37]|4[28]|88|99)|9[0-579])|20(?:00|1(?:[038]|1[079]|26|9[69])|2[01]|90)|9(?:11|9(?:90|0009))", 
, , , "112"], [, , "(?:096|1[58])\\d{2}", , , , "09612", , , [4, 5]], [, , "1[58]\\d{2}|99(?:90|0009)", , , , "9990", , , [4, 6]], , [, , "990009", , , , "990009", , , [6]]], IS:[, [, , "1\\d{2,5}", , , , , , , [3, 4, 6]], , , [, , "1717", , , , "1717", , , [4]], [, , , , , , , , , [-1]], , , , "IS", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "1(?:1(?:[28]|6(?:1(?:23|16)))|4(?:00|1[145]|4[0146])|55|7(?:00|17|7[07-9])|8(?:[02]0|1[16-9]|88)|900)", , , , "112"], [, , 
, , , , , , , [-1]], [, , "14(?:00|41)", , , , "1441", , , [4]], , [, , "1(?:415|900)", , , , "1415", , , [4]]], IT:[, [, , "[14]\\d{2,6}", , , , , , , [3, 4, 5, 6, 7]], , , [, , "1(?:16\\d{3}|87)", , , , "187", , , [3, 6]], [, , "(?:12|4(?:[478]\\d{1,3}|55))\\d{2}", , , , "1254", , , [4, 5, 6, 7]], , , , "IT", , , , , , , , , , , , , , , , , , [, , "11[2358]", , , , "112", , , [3]], , [, , "1(?:0\\d{2,3}|1(?:[2-5789]|6(?:000|111))|2\\d{2}|3[39]|4(?:82|9\\d{1,3})|5(?:00|1[58]|2[25]|3[03]|44|[59])|60|8[67]|9(?:[01]|2(?:[01]\\d{2}|[2-9])|4\\d|696))|4(?:2323|3(?:[01]|[45]\\d{2})\\d{2}|[478](?:[0-4]|[5-9]\\d{2})\\d{2}|5(?:045|5\\d{2}))", 
, , , "114"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "4[3-578]\\d{3,5}", , , , "43000", , , [5, 6, 7]]], JE:[, [, , "[129]\\d{2,5}", , , , , , , [3, 4, 6]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "JE", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "999", , , [3]], , [, , "1(?:00|1(?:2|8\\d{3})|23|4(?:[14]|28|7\\d)|5\\d|7(?:0[12]|[128]|35?)|808|9[0135])|23[234]|999", , , , "150"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , 
, , , , [-1]]], JM:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "JM", , , , , , , , , , , , , , , , , , [, , "11[029]|911", , , , "112"], , [, , "1(?:1[029]|76)|911", , , , "911"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]], JO:[, [, , "[19]\\d{2,4}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "JO", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[127])|911", , , , 
"112", , , [3]], , [, , "1(?:09|1[0-2]|9[0-24-79])|9(?:0903|11|8788)", , , , "111"], [, , , , , , , , , [-1]], [, , "9(?:0903|8788)", , , , "90903", , , [5]], , [, , "9(?:0903|8788)", , , , "90903", , , [5]]], JP:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "JP", , , , , , , , , , , , , , , , , , [, , "11[09]", , , , "110"], , [, , "11[09]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KE:[, [, 
, "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:1(?:6|9\\d)|5(?:01|2[127]|6(?:29|6[67])))", , , , "1501", , , [4, 5]], [, , "909\\d{2}", , , , "90912", , , [5]], , , , "KE", , , , , , , , , , , , , , , , , , [, , "112|114|999", , , , "999", , , [3]], , [, , "1(?:0(?:[07-9]|1[0-25]|400)|1(?:[02456]|9[0-579])|2[123]|3[01]|4[14]|5(?:[01][01]|2[0-24-79]|33|4[05]|5[59]|6(?:00|29|6[67]))|6[035]\\d{2}|[78]\\d|9(?:[02-9]\\d{2}|19))|(?:2[0-79]|3[0-29]|4[0-4])\\d{3}|5(?:[0-7]\\d|99)\\d{2}|(?:6[2357]|7[0-29])\\d{3}|8(?:[0-9]\\d{3}|988)|9(?:09\\d{2}|99)", 
, , , "116"], [, , , , , , , , , [-1]], [, , "1(?:0400|3[01]|4[14]|5(?:1[01]|2[25])|6[35]\\d{2})|(?:2[0-79]|3[0-29]|4[0-4])\\d{3}|5(?:[0-7]\\d|99)\\d{2}|(?:6[2357]|7[0-29])\\d{3}|8(?:988|[0-9]\\d{3})|909\\d{2}", , , , "90912"], , [, , "1(?:0400|4[14]|5(?:01|55|6(?:29|6[67]))|6[035]\\d{2})|40404|8988|909\\d{2}", , , , "8988"]], KG:[, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "KG", , , , , , , , , , , , , , , , , , [, , "10[123]", , , , 
"101", , , [3]], , [, , "10[123]|4040", , , , "101"], [, , , , , , , , , [-1]], [, , "4040", , , , "4040", , , [4]], , [, , "4040", , , , "4040", , , [4]]], KH:[, [, , "[146]\\d{2,4}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "KH", , , , , , , , , , , , , , , , , , [, , "11[789]|666", , , , "117", , , [3]], , [, , "11[789]|40404|666", , , , "117"], [, , , , , , , , , [-1]], [, , "40404", , , , "40404", , , [5]], , [, , "40404", , , , "40404", , , [5]]], KI:[, 
[, , "[179]\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "KI", , , , , , , , , , , , , , , , , , [, , "19[2-5]|99[2349]", , , , "192", , , [3]], , [, , "1(?:0(?:[0-8]|5[01259])|88|9[2-5])|777|99[2349]", , , , "100"], [, , "103", , , , "103", , , [3]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KM:[, [, , "1\\d", , , , , , , [2]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "KM", , , , , , , , , , , , , , , , , , [, , "1[78]", 
, , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KN:[, [, , "[39]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "KN", , , , , , , , , , , , , , , , , , [, , "333|9(?:11|99)", , , , "999"], , [, , "333|9(?:11|99)", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KP:[, [, , "[18]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], , , , "KP", , , , , , , , , , , , , , , , , , [, , "1(?:12|19)|819", , , , "112"], , [, , "1(?:12|19)|819", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KR:[, [, , "1\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:1[78]|28|330|82)", , , , "118", , , [3, 4]], [, , , , , , , , , [-1]], , , , "KR", , , , , , , , , , , , , , , , , , [, , "11[29]", , , , "112", , , [3]], , [, , "1(?:0(?:[01]|114)|1(?:[0247-9]|114)|2[01389]|3(?:2|3[039]|45|66|88|9[18])|[679]114|8(?:114|2))", 
, , , "112"], [, , , , , , , , , [-1]], [, , "1(?:0(?:[01]|114)|1(?:114|4)|[6-9]114)", , , , "100", , , [3, 5]], , [, , , , , , , , , [-1]]], KW:[, [, , "[18]\\d{2,4}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "KW", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "1[0-7]\\d|89887", , , , "177"], [, , , , , , , , , [-1]], [, , "89887", , , , "89887", , , [5]], , [, , , , , , , , , [-1]]], KY:[, [, , "9\\d{2}", , , , , , , [3]], 
, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "KY", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], KZ:[, [, , "[134]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "KZ", , , , , , , , , , , , , , , , , , [, , "1(?:0[123]|12)", , , , "112", , , [3]], , [, , "1(?:0[1-4]|12)|30400|4040", , , , "112"], [, , , , , , , 
, , [-1]], [, , "30400|4040", , , , "30400", , , [4, 5]], , [, , "30400|4040", , , , "30400", , , [4, 5]]], LA:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "LA", , , , , , , , , , , , , , , , , , [, , "19[015]", , , , "190"], , [, , "19[015]", , , , "190"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LB:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "LB", 
, , , , , , , , , , , , , , , , , [, , "1(?:12|40|75)|999", , , , "112"], , [, , "1(?:12|40|75)|999", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LC:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "LC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LI:[, [, , "1\\d{2,3}", 
, , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "LI", , , , , , , , , , , , , , , , , , [, , "1(?:1[278]|44)", , , , "112", , , [3]], , [, , "1(?:1(?:[278]|45)|4[3-57]|50|75|81[18])", , , , "1145"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LK:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "LK", , , , , , , , , , , , , , , , , , [, , "11[02689]", , , , "119"], , [, , "11[024-9]", 
, , , "119"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LR:[, [, , "[3489]\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "LR", , , , , , , , , , , , , , , , , , [, , "355|911", , , , "911", , , [3]], , [, , "355|4040|8(?:400|933)|911", , , , "911"], [, , , , , , , , , [-1]], [, , "4040|8(?:400|933)", , , , "8400", , , [4]], , [, , "4040|8(?:400|933)", , , , "8400", , , [4]]], LS:[, [, , "1\\d{2}", , , , , , , [3]], 
, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "LS", , , , , , , , , , , , , , , , , , [, , "11[257]", , , , "112"], , [, , "11[257]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LT:[, [, , "[01]\\d{1,5}", , , , , , , [2, 3, 6]], , , [, , "116\\d{3}", , , , "116000", , , [6]], [, , , , , , , , , [-1]], , , , "LT", , , , , , , , , , , , , , , , , , [, , "0(?:11?|22?|33?)|1(?:0[123]|12)", , , , "112", , , [2, 3]], , [, , "0(?:11?|22?|33?)|1(?:0[123]|1(?:2|6(?:000|1(?:11|23))))", 
, , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LU:[, [, , "1\\d{2,5}", , , , , , , [3, 5, 6]], , , [, , "116\\d{3}", , , , "116000", , , [6]], [, , , , , , , , , [-1]], , , , "LU", , , , , , , , , , , , , , , , , , [, , "11[23]", , , , "112", , , [3]], , [, , "1(?:1(?:[23]|6(?:000|111))|2\\d{3})", , , , "12123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], LV:[, [, , "0\\d|1\\d{2,6}|8\\d{3,4}", , , , , , , [2, 3, 
4, 5, 6]], , , [, , "116\\d{3}", , , , "116000", , , [6]], [, , "1180|8(?:2\\d{3}|[89]\\d{2})", , , , "1180", , , [4, 5]], , , , "LV", , , , , , , , , , , , , , , , , , [, , "0[123]|11[023]", , , , "112", , , [2, 3]], , [, , "0[1-4]|1(?:1(?:[02-4]|6(?:000|111)|8[0189])|55|655|77)|821[57]4", , , , "112"], [, , "1181", , , , "1181", , , [4]], [, , "16\\d{2}", , , , "1655", , , [4]], , [, , , , , , , , , [-1]]], LY:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , 
[-1]], , , , "LY", , , , , , , , , , , , , , , , , , [, , "19[013]", , , , "193"], , [, , "19[013]", , , , "193"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MA:[, [, , "1\\d{1,2}", , , , , , , [2, 3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "MA", , , , , , , , , , , , , , , , , , [, , "1(?:[59]|77)", , , , "15"], , [, , "1(?:[59]|77)", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MC:[, [, 
, "1\\d{1,2}", , , , , , , [2, 3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "MC", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "112"], , [, , "1(?:12|41|[578])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MD:[, [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "116\\d{3}", , , , "116000", , , [6]], [, , , , , , , , , [-1]], , , , "MD", , , , , , , , , , , , , , , , , , [, , "112|90[1-3]", , , , "112", 
, , [3]], , [, , "1(?:1(?:2|6(?:000|1(?:11|23))|8\\d{1,2}|99)|4\\d{3}|6[0-389]\\d|9(?:0[04-9]|[1-4]\\d))|90[1-3]", , , , "116000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ME:[, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "ME", , , , , , , , , , , , , , , , , , [, , "1(?:12|2[234])", , , , "112", , , [3]], , [, , "1(?:[035]\\d{2}|1(?:[013-57-9]\\d|2|6\\d{3})|2\\d{1,2}|4\\d{2,3}|9\\d{3})", , , , 
"1011"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MF:[, [, , "1\\d", , , , , , , [2]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "MF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "18"], , [, , "1[578]", , , , "18"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MG:[, [, , "1\\d{1,2}", , , , , , , [2, 3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "MG", , , , , , , , , , , 
, , , , , , , [, , "11?[78]", , , , "117"], , [, , "11?[78]", , , , "117"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MH:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "MH", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MK:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , , , "MK", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[234])", , , , "112"], , [, , "1(?:12|9[234])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ML:[, [, , "[13678]\\d{1,4}", , , , , , , [2, 3, 4, 5]], , , [, , "35200|67(?:00|77)|74(?:02|44)|8000[12]", , , , "35200", , , [4, 5]], [, , "122[13]|3(?:52(?:11|2[02]|3[04-6]|99)|7574)|8002[12]", , , , "35211", , , [4, 5]], , , , "ML", , , , , , , , , , , , , , , , , , [, 
, "1[578]", , , , "17", , , [2]], , [, , "1(?:1(?:2|[013-9]\\d)|2(?:1[02-469]|2[13])|[578])|3(?:5(?:0(?:35|57)|2\\d{2})|[67]\\d{3})|67(?:0[09]|59|77|8[89]|99)|74(?:0[02]|44|55)|800[012][12]", , , , "1210"], [, , "37(?:433|575)|7400|8001[12]", , , , "7400", , , [4, 5]], [, , "3(?:5035|[67]\\d{3})|800[012][12]", , , , "35035", , , [5]], , [, , "3(?:6\\d{3}|7(?:4(?:0[24-9]|[1-9]\\d)|5\\d{2}))|7400", , , , "37575", , , [4, 5]]], MM:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, 
, , , , , , , , [-1]], , , , "MM", , , , , , , , , , , , , , , , , , [, , "199", , , , "199"], , [, , "199", , , , "199"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MN:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "MN", , , , , , , , , , , , , , , , , , [, , "10[0-3]", , , , "102"], , [, , "10[0-3]", , , , "102"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MO:[, [, , "9\\d{2}", 
, , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "MO", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MP:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "MP", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
, [, , , , , , , , , [-1]]], MQ:[, [, , "1\\d{1,2}", , , , , , , [2, 3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "MQ", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15"], , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MR:[, [, , "1\\d", , , , , , , [2]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "MR", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , 
"1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MS:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "MS", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MT:[, [, , "1\\d{2,5}", , , , , , , [3, 6]], , , [, , "116(?:000|1(?:11|23))", , , , "116000", , , [6]], [, 
, , , , , , , , [-1]], , , , "MT", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "11(?:2|6(?:000|1(?:11|23)))", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MU:[, [, , "[189]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "MU", , , , , , , , , , , , , , , , , , [, , "11[45]|99[59]", , , , "999", , , [3]], , [, , "1\\d{2,4}|8\\d{3}|99\\d", , , , "995"], [, , , , , , , , 
, [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MV:[, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "MV", , , , , , , , , , , , , , , , , , [, , "1(?:02|1[89])", , , , "102", , , [3]], , [, , "1(?:[0-37-9]\\d|[45](?:1|\\d{2})|6\\d{2})|4040", , , , "123"], [, , , , , , , , , [-1]], [, , "1[45]1", , , , "141", , , [3]], , [, , , , , , , , , [-1]]], MW:[, [, , "[189]\\d{2,4}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , , , "MW", , , , , , , , , , , , , , , , , , [, , "199|99[789]", , , , "997", , , [3]], , [, , "199|80400|99[789]", , , , "997"], [, , , , , , , , , [-1]], [, , "80400", , , , "80400", , , [5]], , [, , "80400", , , , "80400", , , [5]]], MX:[, [, , "[0579]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , , , , , , , , [-1]], [, , "53053|7766", , , , "7766", , , [4, 5]], , , , "MX", , , , , , , , , , , , , , , , , , [, , "0(?:6[0568]|80)|911", , , , "066", , , [3]], , [, , "0(?:[249]0|3[01]|5[015]|6[01568]|7[0-578]|8[089])|53053|7766|911", 
, , , "030"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], MY:[, [, , "[139]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "MY", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "999", , , [3]], , [, , "1(?:0(?:[01348]|[569]\\d)|1(?:[02]|1[128]|311)|2(?:0[125]|[13-6]|2\\d{0,2})|3(?:09\\d|[1-39]\\d{1,2}|6|[5-7]\\d{0,2})|5(?:[12]\\d|454|5\\d{1,2}|77|888|999?)|7(?:[136-9]\\d|[45]\\d{1,2})|8(?:18?|2|8[18])|9(?:[03]\\d|[124]\\d?|68|71|9[0679]))|3[23679]\\d{3}|99[1-469]", 
, , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "3[23679]\\d{3}", , , , "36000", , , [5]]], MZ:[, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "MZ", , , , , , , , , , , , , , , , , , [, , "1(?:1[79]|9[78])", , , , "119", , , [3]], , [, , "1(?:[02-5]\\d{2}|1[79]|9[78])", , , , "1011"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NA:[, [, , "[19]\\d{2,4}", , , , , , , [3, 4, 5]], , 
, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "NA", , , , , , , , , , , , , , , , , , [, , "10111", , , , "10111", , , [5]], , [, , "1(?:0111|\\d{3})|9(?:3111|\\d{2})", , , , "93111"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NC:[, [, , "1\\d{1,3}|3\\d{3}|5\\d{2}", , , , , , , [2, 3, 4]], , , [, , "10(?:00|1[23]|3[0-2]|88)|3631|577", , , , "1000", , , [3, 4]], [, , , , , , , , , [-1]], , , , "NC", , , , , , , , , , , , , , , , , , [, , "1[5-8]", 
, , , "15", , , [2]], , [, , "1(?:0(?:0[06]|1[02-46]|20|3[0125]|42|5[058]|77|88)|[5-8])|3631|5[6-8]\\d", , , , "1000"], [, , "5(?:67|88)", , , , "567", , , [3]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NE:[, [, , "[1-358]\\d{1,2}|723141", , , , , , , [2, 3, 6]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "NE", , , , , , , , , , , , , , , , , , [, , "1[578]|723141", , , , "17", , , [2, 6]], , [, , "1(?:0[01]|1[12]|2[034]|3[013]|40|55?|60|7|8)|222|333|555|723141|888", 
, , , "112"], [, , , , , , , , , [-1]], [, , "1(?:0[01]|1[12]|2[034]|3[013]|40|55|60)|222|333|555|888", , , , "100", , , [3]], , [, , , , , , , , , [-1]]], NF:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "NF", , , , , , , , , , , , , , , , , , [, , "9(?:11|55|77)", , , , "911"], , [, , "9(?:11|55|77)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NG:[, [, , "[14]\\d{2,4}", , , , , , , [3, 5]], 
, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "NG", , , , , , , , , , , , , , , , , , [, , "199", , , , "199", , , [3]], , [, , "199|40700", , , , "199"], [, , , , , , , , , [-1]], [, , "40700", , , , "40700", , , [5]], , [, , "40700", , , , "40700", , , [5]]], NI:[, [, , "[12467]\\d{2,3}", , , , , , , [3, 4]], , , [, , "7373", , , , "7373", , , [4]], [, , , , , , , , , [-1]], , , , "NI", , , , , , , , , , , , , , , , , , [, , "1(?:1[58]|2[08])", , , , "118", , , [3]], , [, , "1(?:1[58]|2(?:[158]|00?)|900)|2100|4878|6100|7(?:010|100|373)", 
, , , "118"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NL:[, [, , "[1349]\\d{2,5}", , , , , , , [3, 4, 6]], , , [, , "116(?:00[06]|1(?:11|23))", , , , "116000", , , [6]], [, , , , , , , , , [-1]], , , , "NL", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|2(?:0[0-4]|3[34]|44)|3[03-9]\\d|400|8(?:[02-9]\\d|1[0-79]))|[34]000|911", , , , "1833"], [, , , , , , , , , [-1]], [, , "120[0-4]", , , , 
"1202", , , [4]], , [, , "[34]000", , , , "4000", , , [4]]], NO:[, [, , "1\\d{2,5}", , , , , , , [3, 4, 6]], , , [, , "1161(?:1[17]|23)", , , , "116117", , , [6]], [, , , , , , , , , [-1]], , , , "NO", , , , , , , , , , , , , , , , , , [, , "11[023]", , , , "112", , , [3]], , [, , "1(?:1(?:[0239]|61(?:1[17]|23))|2[048]|4(?:12|[59])|7[57]|90)", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NP:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , 
, [-1]], [, , , , , , , , , [-1]], , , , "NP", , , , , , , , , , , , , , , , , , [, , "1(?:0[0-3]|12)", , , , "112"], , [, , "1(?:0[0-3]|12)", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NR:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "NR", , , , , , , , , , , , , , , , , , [, , "11[0-2]", , , , "110"], , [, , "1(?:1[0-2]|23|92)", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
, [, , , , , , , , , [-1]]], NU:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "NU", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], NZ:[, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "NZ", , , , , , , , , , , , , , , , , , [, , "111", , , , "111", , , [3]], , [, , "111|4098", 
, , , "111"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "4098", , , , "4098", , , [4]]], OM:[, [, , "9\\d{3}", , , , , , , [4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "OM", , , , , , , , , , , , , , , , , , [, , "9999", , , , "9999"], , [, , "9999", , , , "9999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PA:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "PA", , , 
, , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "10[2-4]|911", , , , "102"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PE:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "PE", , , , , , , , , , , , , , , , , , [, , "1(?:05|1[67])", , , , "105"], , [, , "1(?:05|1[67])", , , , "105"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PF:[, [, , "1\\d", , , , , , , 
[2]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "PF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PG:[, [, , "0\\d{2}|1\\d{2,6}", , , , , , , [3, 4, 5, 6, 7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "PG", , , , , , , , , , , , , , , , , , [, , "000|11[01]", , , , "000", , , [3]], , [, , "000|1(?:1[01]|5\\d{2}|6\\d{2,5})", , , , 
"000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "16\\d{2,5}", , , , "1612", , , [4, 5, 6, 7]]], PH:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "PH", , , , , , , , , , , , , , , , , , [, , "11[27]|911", , , , "117"], , [, , "11[27]|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PK:[, [, , "1\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , 
, , [-1]], , , , "PK", , , , , , , , , , , , , , , , , , [, , "1(?:1(?:22?|5)|[56])", , , , "112"], , [, , "1(?:1(?:22?|5)|[56])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PL:[, [, , "1\\d{2}(?:\\d{2,3})?|9\\d{2}", , , , , , , [3, 5, 6]], , , [, , "116\\d{3}", , , , "116000", , , [6]], [, , , , , , , , , [-1]], , , , "PL", , , , , , , , , , , , , , , , , , [, , "112|99[789]", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|1(?:11|23))|8(?:000|91[23]))|9\\d{3})|9(?:8[4-7]|9[1-9])", 
, , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PM:[, [, , "1\\d", , , , , , , [2]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "PM", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "17"], , [, , "1[578]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PS:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , "166", , , , "166"], [, , , , , , , , , [-1]], , , , "PS", , , , , , , , , , , 
, , , , , , , [, , "10[0-2]", , , , "100"], , [, , "1(?:0[0-2]|44|66|99)", , , , "199"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PR:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "PR", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PT:[, [, , "1\\d{2,5}", , , , , , , [3, 6]], , , [, , 
"116(?:000|111)", , , , "116000", , , [6]], [, , , , , , , , , [-1]], , , , "PT", , , , , , , , , , , , , , , , , , [, , "11[25]", , , , "112", , , [3]], , [, , "11(?:[2578]|6(?:000|111))", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PW:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "PW", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], PY:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "PY", , , , , , , , , , , , , , , , , , [, , "128|911", , , , "911"], , [, , "1[1-4]\\d|911", , , , "123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], QA:[, [, , "[129]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "QA", , , , , , , , , , , , , , , , , 
, [, , "999", , , , "999", , , [3]], , [, , "(?:1|20|9[27]\\d)\\d{2}|999", , , , "2012"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], RE:[, [, , "1\\d{1,2}", , , , , , , [2, 3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "RE", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15"], , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], RO:[, [, , "[18]\\d{2,5}", , , 
, , , , [3, 4, 6]], , , [, , "116(?:000|111)", , , , "116000", , , [6]], [, , "(?:1(?:18(?:300|932)|[24]\\d{2})|8[48]\\d{2})", , , , "8844", , , [4, 6]], , , , "RO", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111)|8(?:300|932))|[24]\\d{2}|9(?:21|3[02]|5[178]))|8[48]\\d{2}", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "(?:1[24]|8[48])\\d{2}", , , , "8844", , , [4]]], RS:[, [, , "[19]\\d{1,5}", , , , , , , [2, 3, 4, 5, 
6]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "RS", , , , , , , , , , , , , , , , , , [, , "112|9[234]", , , , "112", , , [2, 3]], , [, , "1[189]\\d{1,4}|9[234]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], RU:[, [, , "[01]\\d{1,2}", , , , , , , [2, 3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "RU", , , , , , , , , , , , , , , , , , [, , "0[1-3]|1(?:0[1-3]|12)", , , , "112"], , [, , "0[1-4]|1(?:0[1-4]|12)", 
, , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], RW:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "RW", , , , , , , , , , , , , , , , , , [, , "112", , , , "112"], , [, , "112", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SA:[, [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "116111|937|998", , , , "116111", , , [3, 6]], [, , , , , , , , , 
[-1]], , , , "SA", , , , , , , , , , , , , , , , , , [, , "112|9(?:11|9[79])", , , , "999", , , [3]], , [, , "1(?:1(?:00|2|6111)|410|9(?:00|1[89]|9(?:099|22|91)))|9(?:0[24-79]|11|3[379]|40|66|8[5-9]|9[02-9])", , , , "937"], [, , "1410", , , , "1410", , , [4]], [, , "1(?:100|410)|90[24679]", , , , "902", , , [3, 4]], , [, , , , , , , , , [-1]]], SB:[, [, , "[127-9]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "SB", , , , , , , , , , , , , , , , , , [, , "999", 
, , , "999"], , [, , "1(?:[02]\\d|1[12]|[35][01]|[49][1-9]|6[2-9]|7[7-9]|8[0-8])|269|777|835|9(?:[01]1|22|33|55|77|88|99)", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SC:[, [, , "[19]\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "SC", , , , , , , , , , , , , , , , , , [, , "999", , , , "999", , , [3]], , [, , "1(?:0\\d|1[027]|2[0-8]|3[13]|4[0-2]|[59][15]|6[1-9]|7[124-6]|8[158])|9(?:6\\d{2}|99)", , 
, , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SD:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "SD", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SE:[, [, , "[1-37-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "116\\d{3}", , , , "116000", , , [6]], [, , "11811[89]|72\\d{3}", 
, , , "118118", , , [5, 6]], , , , "SE", , , , , , , , , , , , , , , , , , [, , "112|90000", , , , "112", , , [3, 5]], , [, , "11(?:[25]|313|4\\d{2}|6(?:00[06]|11[17]|123)|7[0-8]|8(?:1(?:[02-9]\\d|1[013-9])|[02-46-9]\\d{2}))|2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|7\\d{4}|8(?:22|88)|9(?:0(?:000|1(?:[02-9]\\d|1[013-9])|[2-4]\\d{2}|510)|12)", , , , "11313"], [, , , , , , , , , [-1]], [, , "2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|912", , , , "222", , , [3]], , [, , "7\\d{4}", , , , "72123", 
, , [5]]], SG:[, [, , "[179]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "SG", , , , , , , , , , , , , , , , , , [, , "99[359]", , , , "999", , , [3]], , [, , "1(?:[0136]\\d{2}|[89](?:[1-9]\\d|0[1-9])|[57]\\d{2,3})|77222|99[02-9]", , , , "1312"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "77222", , , , "77222", , , [5]]], SH:[, [, , "[19]\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , 
, "SH", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "999", , , [3]], , [, , "1\\d{2,3}|9(?:11|99)", , , , "1234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SI:[, [, , "1\\d{2,5}", , , , , , , [3, 6]], , , [, , "116(?:000|1(?:11|23))", , , , "116000", , , [6]], [, , , , , , , , , [-1]], , , , "SI", , , , , , , , , , , , , , , , , , [, , "11[23]", , , , "112", , , [3]], , [, , "11(?:[23]|6(?:000|1(?:11|23)))", , , , "112"], [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SJ:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "SJ", , , , , , , , , , , , , , , , , , [, , "11[023]", , , , "112"], , [, , "11[023]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SK:[, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "116\\d{3}", , , , "116000", , , [6]], [, , , , , , , , , [-1]], , , , "SK", , , , , , , , , , , , , 
, , , , , [, , "1(?:12|5[058])", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111)|8[0-8])|[24]\\d{3}|5[0589]|8\\d{3})", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SL:[, [, , "[069]\\d{2,4}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "SL", , , , , , , , , , , , , , , , , , [, , "(?:01|99)9", , , , "999", , , [3]], , [, , "(?:01|99)9|60400", , , , "999"], [, , , , , , , , , [-1]], [, , "60400", , , , "60400", 
, , [5]], , [, , "60400", , , , "60400", , , [5]]], SM:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "SM", , , , , , , , , , , , , , , , , , [, , "11[358]", , , , "113"], , [, , "11[358]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SN:[, [, , "[12]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [, , "1515|2(?:00|1)\\d{3}", , , , "200133", , , [4, 5, 6]], [, , "2(?:0[246]|[468])\\d{3}", , , , "202222", 
, , [5, 6]], , , , "SN", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17", , , [2]], , [, , "1(?:1[69]|2(?:\\d{2})?|[46]\\d{2}|51\\d|[78])|2(?:0[0-246]|[12468])\\d{3}", , , , "17"], [, , "2(?:01|2)\\d{3}", , , , "201202", , , [5, 6]], [, , "1[46]\\d{2}", , , , "1415", , , [4]], , [, , "2[468]\\d{3}", , , , "24123", , , [5]]], SO:[, [, , "[5789]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "SO", , , , , , , , , , , , , , , , , , [, , "555|888|999", 
, , , "555"], , [, , "555|777|888|999", , , , "777"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SR:[, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "SR", , , , , , , , , , , , , , , , , , [, , "115", , , , "115", , , [3]], , [, , "1\\d{2,3}", , , , "1234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ST:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , , , "ST", , , , , , , , , , , , , , , , , , [, , "112", , , , "112"], , [, , "112", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SV:[, [, , "[49]\\d{2,4}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "SV", , , , , , , , , , , , , , , , , , [, , "911", , , , "911", , , [3]], , [, , "40404|911", , , , "911"], [, , , , , , , , , [-1]], [, , "40404", , , , "40404", , , [5]], , [, , "40404", 
, , , "40404", , , [5]]], SX:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "SX", , , , , , , , , , , , , , , , , , [, , "919", , , , "919"], , [, , "919", , , , "919"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SY:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "SY", , , , , , , , , , , , , , , , , , [, , "11[023]", , , , "112"], , [, , "11[023]", , , , "112"], 
[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], SZ:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "SZ", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TC:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "TC", , , , , , , , , , , , , , , , , , [, 
, "9(?:11|99)", , , , "911"], , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TD:[, [, , "1\\d", , , , , , , [2]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "TD", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TG:[, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , 
, , , , , , , [-1]], , , , "TG", , , , , , , , , , , , , , , , , , [, , "1(?:1[78]|7[127])", , , , "117", , , [3]], , [, , "1(?:011|1[078]|7[127])", , , , "117"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TH:[, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1(?:00|2[03]|3[3479]|55|7[67]|9[0246])|5(?:55|78)|6(?:44|6[79]|88|9[16])|888)", , , , "1669", , , [4]], [, , "1(?:113|2(?:22|3[89])|5(?:09|56))", , , , "1509", , , [4]], , , , "TH", , , , , , , , , 
, , , , , , , , , [, , "1(?:669|9[19])", , , , "191"], , [, , "1(?:0[0-2]|1(?:0[03]|1[1-35]|2[0358]|3[03-79]|4[02-489]|5[04-9]|6[04-79]|7[03-9]|8[027-9]|9[02-79])|2(?:22|3[89])|3(?:18|2[23]|3[013]|5[56]|6[45]|73)|477|5(?:0\\d|4[0-37-9]|5[1-8]|6[01679]|7[12568]|8[0-24589]|9[013589])|6(?:0[0-29]|20|4[3-6]|6[1-9]|7[0257-9]|8[0158]|9[014-9])|7(?:19|7[27]|90)|888|9[19])", , , , "191"], [, , "1(?:1(?:03|1[15]|2[58]|3[056]|4[02-49]|5[046-9]|6[04-79]|7[03-589]|8[02789]|9[579])|3(?:18|2[23]|3[013]|5[4-6])|5(?:0[0-8]|4[0-378]|5[1-478]|6[01679]|7[156]|8[0-24589]|9[013589])|6(?:0[0-29]|20|4[356]|6[1-68]|7[05789]|8[015]|9[0457-9])|7(?:19|7[27]))", 
, , , "1149", , , [4]], [, , "114[89]", , , , "1148", , , [4]], , [, , , , , , , , , [-1]]], TJ:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "TJ", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "112"], , [, , "1(?:0[1-3]|12)", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TL:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "TL", , 
, , , , , , , , , , , , , , , , [, , "11[25]", , , , "112"], , [, , "1(?:0[02]|1[25]|2[0138]|72|9[07])", , , , "102"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TM:[, [, , "0\\d", , , , , , , [2]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "TM", , , , , , , , , , , , , , , , , , [, , "0[1-3]", , , , "03"], , [, , "0[1-3]", , , , "03"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TN:[, [, , "1\\d{2}", , 
, , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "TN", , , , , , , , , , , , , , , , , , [, , "19[078]", , , , "197"], , [, , "19[078]", , , , "197"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TO:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "TO", , , , , , , , , , , , , , , , , , [, , "9(?:11|22|33|99)", , , , "911"], , [, , "9(?:11|22|33|99)", , , , "911"], [, , , , , , , , , 
[-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TR:[, [, , "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:44|58|83)", , , , "183", , , [3]], [, , , , , , , , , [-1]], , , , "TR", , , , , , , , , , , , , , , , , , [, , "1(?:1[02]|55)", , , , "112", , , [3]], , [, , "1(?:1(?:[0239]|811)|2[16]|3(?:37?|[58]6|65)|4(?:[14]|71)|5(?:[3568]|07|78)|6(?:[02]6|[389]|99)|7[0-79]|8(?:\\d|63|95))|2(?:077|268|4(?:17|23)|5(?:7[26]|82)|6[14]4|8\\d{2}|9(?:30|89))|3(?:0(?:05|72)|353|4(?:06|30|64)|502|674|747|851|9(?:1[29]|60))|4(?:0(?:25|3[12]|[47]2)|3(?:3[13]|[89]1)|439|5(?:43|55)|717|832)|5(?:145|290|[4-6]\\d{2}|772|833|9(?:[06]1|92))|6(?:236|6(?:12|39|8[59])|769)|7890|8(?:688|7(?:28|65)|85[06])|9(?:159|290)", 
, , , "112"], [, , "2850|5420", , , , "5420", , , [4]], [, , , , , , , , , [-1]], , [, , "1(?:3(?:37|[58]6|65)|4(?:4|71)|5(?:07|78)|6(?:[02]6|99)|8(?:3|63|95))|2(?:077|268|4(?:17|23)|5(?:7[26]|82)|6[14]4|8\\d{2}|9(?:30|89))|3(?:0(?:05|72)|353|4(?:06|30|64)|502|674|747|851|9(?:1[29]|60))|4(?:0(?:25|3[12]|[47]2)|3(?:3[13]|[89]1)|439|5(?:43|55)|717|832)|5(?:145|290|[4-6]\\d{2}|772|833|9(?:[06]1|92))|6(?:236|6(?:12|39|8[59])|769)|7890|8(?:688|7(?:28|65)|85[06])|9(?:159|290)", , , , "5420", , , [3, 4]]], 
TT:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "TT", , , , , , , , , , , , , , , , , , [, , "99[09]", , , , "999"], , [, , "99[09]", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TV:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "TV", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "1\\d{2}|911", , , , "911"], [, , , , , 
, , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TW:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "TW", , , , , , , , , , , , , , , , , , [, , "11[029]", , , , "110"], , [, , "11[029]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], TZ:[, [, , "[149]\\d{2,4}", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "TZ", , , , , , , , , , , , , , , , 
, , [, , "11[12]|999", , , , "111", , , [3]], , [, , "11[12]|46400|999", , , , "111"], [, , , , , , , , , [-1]], [, , "46400", , , , "46400", , , [5]], , [, , "46400", , , , "46400", , , [5]]], UA:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "UA", , , , , , , , , , , , , , , , , , [, , "1(?:0[123]|12)", , , , "112"], , [, , "1(?:0[123]|12)", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], UG:[, [, 
, "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "UG", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], US:[, [, , "[1-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "611", , , , "611", , , [3]], [, , "2(?:4280|5209|7(?:449|663))|3(?:2340|3786|5564|8(?:135|254))|4(?:1(?:366|463)|3355|6(?:157|327)|7553|8(?:221|277))|5(?:2944|4892|5928|9(?:187|342))|69388|7(?:2(?:078|087)|3(?:288|909)|6426)|8(?:6234|9616)|9(?:5297|6(?:040|835)|7(?:294|688)|9(?:689|796))", 
, , , "24280", , , [5]], , , , "US", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "911", , , [3]], , [, , "1(?:1(?:2|5[1-47]|[68]\\d|7[0-57]|98))|[2-9](?:11|\\d{3,5})", , , , "911"], [, , "2(?:3333|42242|56447|6688|75622|9002)|3(?:1010|2665|7404)|40404|560560|6(?:0060|22639|5246|7622)|7(?:0701|3822|4666)|8(?:38255|4816|72265)|99099", , , , "73822", , , [5, 6]], [, , "[2-9]\\d{3}|33669|[2356]11", , , , "33669", , , [3, 4, 5]], , [, , "[2-9]\\d{4,5}", , , , "20566", , , [5, 6]]], UY:[, [, 
, "[19]\\d{2,3}", , , , , , , [3, 4]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "UY", , , , , , , , , , , , , , , , , , [, , "128|911", , , , "911", , , [3]], , [, , "1(?:0[4-9]|1[2368]|2[0-3568]|787)|911", , , , "104"], [, , "1787", , , , "1787", , , [4]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], UZ:[, [, , "[04]\\d{1,4}", , , , , , , [2, 3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "UZ", , , , , , , , , , , , , , , , , , [, , "0(?:0[123]|[123]|50)", 
, , , "01", , , [2, 3]], , [, , "0(?:0[123]|[123]|50)|45400", , , , "01"], [, , , , , , , , , [-1]], [, , "45400", , , , "45400", , , [5]], , [, , "45400", , , , "45400", , , [5]]], VA:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "VA", , , , , , , , , , , , , , , , , , [, , "11[2358]", , , , "113"], , [, , "11[2358]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VC:[, [, , "9\\d{2}", , , , , , 
, [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "VC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VE:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "VE", , , , , , , , , , , , , , , , , , [, , "1(?:12|71)|911", , , , "171"], , [, , "1(?:12|71)|911", , , , "171"], [, , , , , , , , , [-1]], 
[, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VG:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "VG", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VI:[, [, , "9\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "VI", , , , , , , , , , , , , , , , , , [, , "911", , 
, , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VN:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "VN", , , , , , , , , , , , , , , , , , [, , "11[345]", , , , "113"], , [, , "11[345]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], VU:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
, , , "VU", , , , , , , , , , , , , , , , , , [, , "112", , , , "112"], , [, , "112", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], WF:[, [, , "1\\d", , , , , , , [2]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "WF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], WS:[, [, , "9\\d{2}", , , , , , , [3]], , 
, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "WS", , , , , , , , , , , , , , , , , , [, , "99[4-6]", , , , "994"], , [, , "99[4-6]", , , , "994"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], XK:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "XK", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[2-4])", , , , "112"], , [, , "1(?:12|9[2-4])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , 
, , [-1]], , [, , , , , , , , , [-1]]], YE:[, [, , "1\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "YE", , , , , , , , , , , , , , , , , , [, , "19[1459]", , , , "191"], , [, , "19[1459]", , , , "191"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], YT:[, [, , "1\\d{1,2}", , , , , , , [2, 3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "YT", , , , , , , , , , , , , , , , , , [, , "1(?:12|5)", , , , "15"], 
, [, , "1(?:12|5)", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ZA:[, [, , "[134]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , , , , , , , , [-1]], [, , "41(?:348|851)", , , , "41851", , , [5]], , , , "ZA", , , , , , , , , , , , , , , , , , [, , "1(?:0(?:1(?:11|77)|7)|12)", , , , "10111", , , [3, 5]], , [, , "1(?:0(?:1(?:11|77)|20|7)|1[12]|77(?:3[237]|[45]7|6[279]|9[26]))|[34]\\d{4}", , , , "10111"], [, , "3(?:078[23]|7(?:064|567)|8126)|4(?:2699|3(?:699|94[16])|7751|8837)", 
, , , "47751", , , [5]], [, , "1(?:07|11)", , , , "111", , , [3]], , [, , "[34]\\d{4}", , , , "47751", , , [5]]], ZM:[, [, , "[19]\\d{2}", , , , , , , [3]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "ZM", , , , , , , , , , , , , , , , , , [, , "(?:112|99[139])", , , , "999"], , [, , "(?:112|99[139])", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]], ZW:[, [, , "[139]\\d{2,4}", , , , , , , [3, 5]], , , [, , "9(?:5[023]|61)", , , , "961", 
, , [3]], [, , "3\\d{4}", , , , "30123", , , [5]], , , , "ZW", , , , , , , , , , , , , , , , , , [, , "(?:11[24]|99[3-59])", , , , "999", , , [3]], , [, , "11[2469]|9(?:5[023]|6[0-25]|9[3-59])", , , , "999"], [, , , , , , , , , [-1]], [, , "(?:114|9(?:5[023]|6[0-25]))", , , , "114", , , [3]], , [, , , , , , , , , [-1]]]};
/*

 Copyright (C) 2018 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.ShortNumberInfo = function() {
  this.regionToMetadataMap = {};
};
goog.addSingletonGetter(i18n.phonenumbers.ShortNumberInfo);
i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_ = ["BR", "CL", "NI"];
i18n.phonenumbers.ShortNumberInfo.ShortNumberCost = {TOLL_FREE:0, STANDARD_RATE:1, PREMIUM_RATE:2, UNKNOWN_COST:3};
i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodesForCountryCode_ = function(a) {
  return (a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a]) ? a : [];
};
i18n.phonenumbers.ShortNumberInfo.prototype.regionDialingFromMatchesNumber_ = function(a, b) {
  var c = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
  return goog.array.contains(c, b);
};
i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumberForRegion = function(a, b) {
  if (!this.regionDialingFromMatchesNumber_(a, b)) {
    return !1;
  }
  var c = this.getMetadataForRegion_(b);
  if (!c) {
    return !1;
  }
  var d = this.getNationalSignificantNumber_(a).length;
  return goog.array.contains(c.getGeneralDesc().possibleLengthArray(), d);
};
i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumber = function(a) {
  var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
  a = this.getNationalSignificantNumber_(a).length;
  for (var c = 0; c < b.length; c++) {
    var d = this.getMetadataForRegion_(b[c]);
    if (d && (d = d.getGeneralDesc().possibleLengthArray(), goog.array.contains(d, a))) {
      return !0;
    }
  }
  return !1;
};
i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumberForRegion = function(a, b) {
  if (!this.regionDialingFromMatchesNumber_(a, b)) {
    return !1;
  }
  var c = this.getMetadataForRegion_(b);
  if (!c) {
    return !1;
  }
  var d = this.getNationalSignificantNumber_(a), e = c.getGeneralDesc();
  if (!this.matchesPossibleNumberAndNationalNumber_(d, e)) {
    return !1;
  }
  c = c.getShortCode();
  return this.matchesPossibleNumberAndNationalNumber_(d, c);
};
i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumber = function(a) {
  var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault()), c = this.getRegionCodeForShortNumberFromRegionList_(a, b);
  return 1 < b.length && null != c ? !0 : this.isValidShortNumberForRegion(a, c);
};
i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCostForRegion = function(a, b) {
  var c = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost;
  if (!this.regionDialingFromMatchesNumber_(a, b)) {
    return c.UNKNOWN_COST;
  }
  var d = this.getMetadataForRegion_(b);
  if (!d) {
    return c.UNKNOWN_COST;
  }
  var e = this.getNationalSignificantNumber_(a);
  return goog.array.contains(d.getGeneralDesc().possibleLengthArray(), e.length) ? this.matchesPossibleNumberAndNationalNumber_(e, d.getPremiumRate()) ? c.PREMIUM_RATE : this.matchesPossibleNumberAndNationalNumber_(e, d.getStandardRate()) ? c.STANDARD_RATE : this.matchesPossibleNumberAndNationalNumber_(e, d.getTollFree()) || this.isEmergencyNumber(e, b) ? c.TOLL_FREE : c.UNKNOWN_COST : c.UNKNOWN_COST;
};
i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCost = function(a) {
  var b = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, c = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
  if (0 === c.length) {
    return b.UNKNOWN_COST;
  }
  if (1 === c.length) {
    return this.getExpectedCostForRegion(a, c[0]);
  }
  for (var d = b.TOLL_FREE, e = 0; e < c.length; e++) {
    var f = this.getExpectedCostForRegion(a, c[e]);
    switch(f) {
      case b.PREMIUM_RATE:
        return b.PREMIUM_RATE;
      case b.UNKNOWN_COST:
        d = b.UNKNOWN_COST;
        break;
      case b.STANDARD_RATE:
        d !== b.UNKNOWN_COST && (d = b.STANDARD_RATE);
        break;
      case b.TOLL_FREE:
        break;
      default:
        throw Error("Unrecognized cost for region: " + f);
    }
  }
  return d;
};
i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodeForShortNumberFromRegionList_ = function(a, b) {
  if (0 === b.length) {
    return null;
  }
  if (1 === b.length) {
    return b[0];
  }
  for (var c = this.getNationalSignificantNumber_(a), d = 0; d < b.length; d++) {
    var e = b[d], f = this.getMetadataForRegion_(e);
    if (f && this.matchesPossibleNumberAndNationalNumber_(c, f.getShortCode())) {
      return e;
    }
  }
  return null;
};
i18n.phonenumbers.ShortNumberInfo.prototype.getSupportedRegions = function() {
  return goog.array.filter(Object.keys(i18n.phonenumbers.shortnumbermetadata.countryToMetadata), function(a) {
    return isNaN(a);
  });
};
i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumber = function(a) {
  a = this.getMetadataForRegion_(a);
  if (!a) {
    return "";
  }
  a = a.getShortCode();
  return a.hasExampleNumber() ? a.getExampleNumber() || "" : "";
};
i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumberForCost = function(a, b) {
  var c = this.getMetadataForRegion_(a);
  if (!c) {
    return "";
  }
  var d = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, e = null;
  switch(b) {
    case d.TOLL_FREE:
      e = c.getTollFree();
      break;
    case d.STANDARD_RATE:
      e = c.getStandardRate();
      break;
    case d.PREMIUM_RATE:
      e = c.getPremiumRate();
  }
  return e && e.hasExampleNumber() ? e.getExampleNumber() || "" : "";
};
i18n.phonenumbers.ShortNumberInfo.prototype.connectsToEmergencyNumber = function(a, b) {
  return this.matchesEmergencyNumberHelper_(a, b, !0);
};
i18n.phonenumbers.ShortNumberInfo.prototype.isEmergencyNumber = function(a, b) {
  return this.matchesEmergencyNumberHelper_(a, b, !1);
};
i18n.phonenumbers.ShortNumberInfo.prototype.getMetadataForRegion_ = function(a) {
  if (!a) {
    return null;
  }
  a = a.toUpperCase();
  var b = this.regionToMetadataMap[a];
  if (null == b) {
    b = new goog.proto2.PbLiteSerializer;
    var c = i18n.phonenumbers.shortnumbermetadata.countryToMetadata[a];
    if (null == c) {
      return null;
    }
    b = b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), c);
    this.regionToMetadataMap[a] = b;
  }
  return b;
};
i18n.phonenumbers.ShortNumberInfo.prototype.matchesEmergencyNumberHelper_ = function(a, b, c) {
  var d = i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a);
  if (i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(d)) {
    return !1;
  }
  a = this.getMetadataForRegion_(b);
  if (null == a || !a.hasEmergency()) {
    return !1;
  }
  d = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d);
  b = c && !goog.array.contains(i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_, b);
  c = a.getEmergency().getNationalNumberPatternOrDefault();
  return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(c, d) || b && i18n.phonenumbers.PhoneNumberUtil.matchesPrefix(c, d);
};
i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecific = function(a) {
  var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
  b = this.getRegionCodeForShortNumberFromRegionList_(a, b);
  a = this.getNationalSignificantNumber_(a);
  b = this.getMetadataForRegion_(b);
  return !!b && this.matchesPossibleNumberAndNationalNumber_(a, b.getCarrierSpecific());
};
i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecificForRegion = function(a, b) {
  if (!this.regionDialingFromMatchesNumber_(a, b)) {
    return !1;
  }
  var c = this.getNationalSignificantNumber_(a), d = this.getMetadataForRegion_(b);
  return !!d && this.matchesPossibleNumberAndNationalNumber_(c, d.getCarrierSpecific());
};
i18n.phonenumbers.ShortNumberInfo.prototype.isSmsServiceForRegion = function(a, b) {
  if (!this.regionDialingFromMatchesNumber_(a, b)) {
    return !1;
  }
  var c = this.getMetadataForRegion_(b), d = this.getNationalSignificantNumber_(a);
  return !!c && this.matchesPossibleNumberAndNationalNumber_(d, c.getSmsServices());
};
i18n.phonenumbers.ShortNumberInfo.prototype.getNationalSignificantNumber_ = function(a) {
  if (!a.hasNationalNumber()) {
    return "";
  }
  var b = "" + a.getNationalNumber();
  return a.hasItalianLeadingZero() && a.getItalianLeadingZero() && 0 < a.getNumberOfLeadingZerosOrDefault() ? Array(a.getNumberOfLeadingZerosOrDefault() + 1).join("0") + b : b;
};
i18n.phonenumbers.ShortNumberInfo.prototype.matchesPossibleNumberAndNationalNumber_ = function(a, b) {
  return 0 < b.possibleLengthArray().length && !goog.array.contains(b.possibleLengthArray(), a.length) ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(), a.toString());
};
Object.defineProperty(exports, "__esModule", {value:!0});
exports["default"] = i18n.phonenumbers;
module.exports = exports["default"];


},{}]},{},[1])(1)
});

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(943);

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(39);
var bind = __webpack_require__(361);
var Axios = __webpack_require__(945);
var defaults = __webpack_require__(223);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(365);
axios.CancelToken = __webpack_require__(960);
axios.isCancel = __webpack_require__(364);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(961);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 944 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(223);
var utils = __webpack_require__(39);
var InterceptorManager = __webpack_require__(955);
var dispatchRequest = __webpack_require__(956);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 946 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(39);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(363);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(39);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(39);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(39);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(39);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(39);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(39);
var transformData = __webpack_require__(957);
var isCancel = __webpack_require__(364);
var defaults = __webpack_require__(223);
var isAbsoluteURL = __webpack_require__(958);
var combineURLs = __webpack_require__(959);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(39);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(365);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(963);
exports.encode = exports.stringify = __webpack_require__(964);


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);






var _reactRedux=__webpack_require__(28);
var _reactRouterDom=__webpack_require__(352);
var _jsFileDownload=__webpack_require__(366);var _jsFileDownload2=_interopRequireDefault(_jsFileDownload);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);

var _Icon=__webpack_require__(85);var _Icon2=_interopRequireDefault(_Icon);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);
var _UserManager=__webpack_require__(112);var _UserManager2=_interopRequireDefault(_UserManager);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

MenuList=function(_Component){_inherits(MenuList,_Component);

function MenuList(props){var _this2=this;_classCallCheck(this,MenuList);var _this=_possibleConstructorReturn(this,(MenuList.__proto__||Object.getPrototypeOf(MenuList)).call(this,
props));_this.













































































































































































_handleWindowResize=function(){
_this.setState({windowWidth:_reactNative.Dimensions.get('window').width});
};_this.

_handleClick=function(data){var
id=data.id;
if(id==='raw'){
_this._generateRawFile();
return;
}var

onClick=_this.props.onClick;
if(onClick){
onClick(data);
}
};_this.

_generateRawFile=function _callee(){var _ref,response,error,filename;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return regeneratorRuntime.awrap(
_APIClient2.default.GET('/admin/raw',null));case 2:_ref=_context.sent;response=_ref.response;error=_ref.error;
if(response){

filename='report-'+_Utils2.default.dateToString(new Date(),
'DD-MM-YYYY HH:mm')+'.csv';
(0,_jsFileDownload2.default)('\uFEFF'+response,filename);
}
if(error){
console.log('generate raw file error: ',error);
}case 7:case'end':return _context.stop();}}},null,_this2);};var menuList=[];var homeMenu={id:'home',title:'Trang chủ',icon:{type:'FontAwesome',name:'home',size:28,color:'#ffffff'},submenuList:[{id:'orders',path:'/',title:'Toàn bộ đơn',icon:{type:'FontAwesome',name:'files-o',size:24,color:'#ffffff'}}]};menuList.push(homeMenu);var usersMenu={id:'users',title:'Người dùng',icon:{type:'FontAwesome',name:'users',size:24,color:'#ffffff'},submenuList:[]};var manager=_UserManager2.default.getInstance();if(manager.isAdmin()){homeMenu.submenuList.push({id:'confirmedOrders',path:'/orders/confirmed',title:'Danh sách đơn chốt',icon:{type:'FontAwesome',name:'files-o',size:24,color:'#ffffff'}});usersMenu.submenuList.push({id:'partners',path:'/partners',title:'Danh sách đối tác',icon:{type:'FontAwesome',name:'users',size:24,color:'#ffffff'}});}if(manager.isAdmin()||manager.isPartner()){usersMenu.submenuList.push({id:'agencies',path:'/agencies',title:'Danh sách đại lý',icon:{type:'FontAwesome',name:'users',size:24,color:'#ffffff'}});}if(manager.isPartner()){usersMenu.submenuList.push({id:'create-agency',path:'/create-agency',title:'Đăng kí đại lý',icon:{type:'FontAwesome',name:'plus-circle',size:24,color:'#ffffff'}});}if(!_lodash2.default.isEmpty(usersMenu.submenuList)){menuList.push(usersMenu);}if(manager.isAdmin()){var adminMenu={id:'admin',title:'Admin',icon:{type:'FontAwesome',name:'user-plus',size:24,color:'#ffffff'},submenuList:[{id:'prepay',path:'/prepay',title:'Sinh mã trả trước',icon:{type:'FontAwesome',name:'money',size:30,color:'#ffffff'}},{id:'raw',title:'Sinh file raw',icon:{type:'Ionicons',name:'md-download',size:24,color:'#ffffff'}}]};menuList.push(adminMenu);}menuList.push({id:'notifications',path:'/notifications',title:'Thông báo',icon:{type:'FontAwesome',name:'bell',size:24,color:'#ffffff'}});menuList.push({id:'me',path:'/me',title:'Tài khoản',icon:{type:'FontAwesome',name:'user',size:26,color:'#ffffff'}});_this.state={menuList:menuList};return _this;}_createClass(MenuList,[{key:'componentWillMount',value:function componentWillMount(){}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this._handleWindowResize);}},{key:'componentDidMount',value:function componentDidMount(){this._handleWindowResize();window.addEventListener('resize',this._handleWindowResize);}},{key:'render',value:function render()


{var _this3=this;var _state=
this.state,menuList=_state.menuList,windowWidth=_state.windowWidth;
return(
_react2.default.createElement(_reactNative.View,{
className:'top-menu',
style:styles.container},
menuList.map(function(data,index){return(
_react2.default.createElement(MenuItem,{
key:index,
data:data,
menuLevel:1,
windowWidth:windowWidth,
onClick:_this3._handleClick}));})));



}}]);return MenuList;}(_react.Component);var


MenuItem=function(_Component2){_inherits(MenuItem,_Component2);

function MenuItem(props){_classCallCheck(this,MenuItem);var _this4=_possibleConstructorReturn(this,(MenuItem.__proto__||Object.getPrototypeOf(MenuItem)).call(this,
props));_this4.















_handleWindowClick=function(e){
if(_this4.state.submenuExpaned!==true){
return;
}
var node=e.target;
while(node!=null){
if('classList'in node&&'contains'in node.classList&&
node.classList.contains('sub-menu')){
return;
}
node=node.parentNode;
}
_this4._triggerSubmenu(false);
};_this4.

_handleClick=function(data){
_this4._triggerSubmenu(
!_lodash2.default.isEmpty(data.submenuList)&&!_this4.state.submenuExpaned);var

onClick=_this4.props.onClick;
if(_lodash2.default.isEmpty(data.submenuList)&&onClick){
onClick(data);
}
};_this4.

_triggerSubmenu=function(value){
if(!_lodash2.default.isEmpty(_this4.props.data.submenuList)){
_this4.setState({
submenuExpaned:value});

}
};_this4.

_getStyle=function(){var
menuLevel=_this4.props.menuLevel;
return{
top:menuLevel==1?45:0,
left:200*(menuLevel-1),
backgroundColor:'#4caf50',
minWidth:250,
position:'absolute',
boxShadow:'0px 8px 16px 0px rgba(0,0,0,0.2)',
zIndex:menuLevel+1000};

};_this4.state={submenu:undefined,submenuExpaned:false};return _this4;}_createClass(MenuItem,[{key:'componentWillUnmount',value:function componentWillUnmount(){document.addEventListener('mousedown',this._handleWindowClick,false);}},{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('mousedown',this._handleWindowClick,false);}},{key:'render',value:function render()

{var _this5=this;var _props=
this.props,data=_props.data,menuLevel=_props.menuLevel,windowWidth=_props.windowWidth;var
submenuExpaned=this.state.submenuExpaned;var
title=data.title,icon=data.icon,submenuList=data.submenuList;
return _react2.default.createElement(_reactNative.View,null,
_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
onPress:function onPress(){return _this5._handleClick(data);},
style:styles.item},
_react2.default.createElement(_Icon2.default,_extends({},
icon,{
style:styles.itemIcon})),
(windowWidth>600&&menuLevel<2||menuLevel>1)&&
_react2.default.createElement(_reactNative.Text,{
style:styles.itemText},
title)),




submenuExpaned&&_react2.default.createElement(_reactNative.View,{style:this._getStyle(),className:'sub-menu'},
submenuList.map(function(data,index){return(
_react2.default.createElement(MenuItem,{
key:index,
data:data,
windowWidth:windowWidth,
menuLevel:menuLevel+1,
onClick:function onClick(){return _this5._handleClick(data);}}));})));




}}]);return MenuItem;}(_react.Component);


var styles=_reactNative.StyleSheet.create({
container:{
height:45,
flexDirection:'row',
backgroundColor:'#4CAF50',
borderBottomColor:'#eeeeee',
borderBottomWidth:2,
zIndex:1000},

item:{
flexDirection:'row',
height:44,
paddingHorizontal:10,
alignItems:'center',
borderRightColor:'#ffffff',
borderRightWidth:1},

itemIcon:{},
itemText:{
marginLeft:5,
color:'#fff',
fontSize:16,
fontWeight:'300',
marginRight:5},


submenuBackground:{
top:0,
left:0,
position:'fixed',
width:'100%',
zIndex:2,
height:1000},

menuBox:{
top:45,
left:0,
position:'absolute',
backgroundColor:'#4caf50',
minWidth:300,
boxShadow:'0px 8px 16px 0px rgba(0,0,0,0.2)',
zIndex:1000}});



var mapStateToProps=function mapStateToProps(state){
return{
user:state.user};

};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{};
};exports.default=

(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(MenuList);

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Entypo.744ce600.ttf";

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/EvilIcons.5221f356.ttf";

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Feather.517bb9a1.ttf";

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/FontAwesome.b06871f2.ttf";

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Foundation.e20945d7.ttf";

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Ionicons.74c65267.ttf";

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/MaterialCommunityIcons.1eccbc4c.ttf";

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/MaterialIcons.a37b0c01.ttf";

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Octicons.9e9dbe78.ttf";

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/SimpleLineIcons.d2285965.ttf";

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Zocial.5cdf883b.ttf";

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);












var _reactRedux=__webpack_require__(28);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);
var _modules=__webpack_require__(19);





var _user=__webpack_require__(111);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);
var _UserUtils=__webpack_require__(66);var _UserUtils2=_interopRequireDefault(_UserUtils);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var windowWidth=_reactNative.Dimensions.get('window').width;
var logoRatio=2208.0/3264;
var logoWidth=Math.min(windowWidth,340);
var logoHeight=logoWidth*logoRatio;
var logoImageSize=logoWidth*2/3;
var formWidth=Math.min(windowWidth-40,300);
;var

LoginScreen=(_temp=_class=function(_Component){_inherits(LoginScreen,_Component);








function LoginScreen(props){_classCallCheck(this,LoginScreen);var _this=_possibleConstructorReturn(this,(LoginScreen.__proto__||Object.getPrototypeOf(LoginScreen)).call(this,
props));_initialiseProps.call(_this);var

credential=_this.props.credential;var _ref=
credential?credential:{},username=_ref.username,password=_ref.password;
_this.state={
username:username?username:'',
password:password?password:'',
submitting:false};return _this;

}_createClass(LoginScreen,[{key:'componentDidMount',value:function componentDidMount()

{
}},{key:'componentWillUnmount',value:function componentWillUnmount()

{
}},{key:'_updateInputValue',value:function _updateInputValue(

name,value){
this.setState(_defineProperty({},
name,value));

}},{key:'_focusTextInput',value:function _focusTextInput(

name){
var textInput=this.refs[name];
if(textInput){
textInput.focus();
}
}},{key:'_handleNetworkResponse',value:function _handleNetworkResponse(













































credential,response,error){







this.setState({
submitting:false});


if(response&&response.response){var _props=
this.props,device=_props.device,_updateCredential=_props.updateCredential,_updateInfo=_props.updateInfo;
_UserUtils2.default.updateFCMToken(credential,device.fcmToken);
_updateCredential(credential);
_updateInfo(response.response);
}else{
var message=_Utils2.default.parseErrorMessage(response,error,
'Đăng nhập thất bại, vui lòng thử lại sau');
if(_reactNative.Platform.OS==='web'){
alert(message);
}else{
_reactNative.Alert.alert(
global.__APP_NAME__,
message);

}
}
}},{key:'render',value:function render()



































{var _this2=this;var _state=
this.state,username=_state.username,password=_state.password,submitting=_state.submitting;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},

_react2.default.createElement(_modules.KeyboardAwareScrollView,{
automaticallyAdjustContentInsets:false,
keyboardDismissMode:_reactNative.Platform.OS==='ios'?'on-drag':'none',
keyboardShouldPersistTaps:'never',
containerContentStyle:styles.contentContainer,
style:styles.content},
_react2.default.createElement(_reactNative.View,{
style:styles.logo},
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(978),
style:styles.logoBackground}),
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(979),
style:styles.logoImage})),


_react2.default.createElement(_reactNative.View,{
style:[
styles.input,{
marginTop:40}]},

_react2.default.createElement(_reactNative.TextInput,{
ref:'emailTextInput',
value:username,
placeholder:'\u0110\u1ECBa ch\u1EC9 email',
placeholderTextColor:'#51585ebf',
keyboardType:'email-address',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
autoCapitalize:'none',
autoFocus:true,
returnKeyType:'next',
onChangeText:function onChangeText(text){return _this2._updateInputValue('username',text);},
onSubmitEditing:function onSubmitEditing(){return _this2._focusTextInput('passwordTextInput');},
style:styles.textInput})),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'passwordTextInput',
value:password,
placeholder:'M\u1EADt kh\u1EA9u',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
secureTextEntry:true,
returnKeyType:'done',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this2._updateInputValue('password',text);},
onSubmitEditing:this._doLogin})),


_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
style:styles.submit,
onPress:this._login},
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.submitImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.submitText},'\u0110\u0102NG NH\u1EACP'),


submitting&&_react2.default.createElement(_reactNative.View,{
style:styles.submitting},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#ffffff',
style:styles.submittingIndicator}))),



_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
style:[
styles.submit,{
marginTop:12}],

onPress:this._register},
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.submitImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.submitText},'\u0110\u0102NG K\xCD'))),

















_reactNative.Platform.OS!=='web'&&_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
style:styles.close,
onPress:this._close},
_react2.default.createElement(_modules.FontAwesomeIcon,{
name:'times-circle',
size:36,
color:'#fd5c5c',
style:styles.closeIcon}))));



}}]);return LoginScreen;}(_react.Component),_class.navigationOptions=function(_ref2){var navigation=_ref2.navigation;var params=navigation.state.params;return{header:null};},_initialiseProps=function _initialiseProps(){var _this3=this;this._login=function _callee(){var submitting,_state2,username,password,errorMessage,inputRefName,credential,_ref3,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:submitting=_this3.state.submitting;if(!submitting){_context.next=3;break;}return _context.abrupt('return');case 3:_state2=_this3.state,username=_state2.username,password=_state2.password;errorMessage=void 0,inputRefName=void 0;if(_lodash2.default.isEmpty(username)){errorMessage='Vui lòng điền địa chỉ email';inputRefName='emailTextInput';}else if(_lodash2.default.isEmpty(password)){errorMessage='Vui lòng điền mật khẩu';inputRefName='passwordTextInput';}if(!errorMessage){_context.next=9;break;}if(_reactNative.Platform.OS==='web'){alert(errorMessage);}else{_reactNative.Alert.alert(global.__APP_NAME__,errorMessage,[{text:'OK',onPress:function onPress(){return _this3._focusTextInput(inputRefName);}}]);}return _context.abrupt('return');case 9:_this3.setState({submitting:true});credential={username:username,password:password};_APIClient2.default.updateCredential(credential);_context.next=14;return regeneratorRuntime.awrap(_APIClient2.default.POST('/user/signIn'));case 14:_ref3=_context.sent;response=_ref3.response;error=_ref3.error;_this3._handleNetworkResponse(credential,response,error);case 18:case'end':return _context.stop();}}},null,_this3);};this._register=function(){if(_reactNative.Platform.OS!=='web'){_this3.props.navigation.navigate('Registration',{onSubmmit:_this3._handleRegistration});}};this._handleRegistration=function(data){var email=data.email;_this3.setState({username:email});if(_reactNative.Platform.OS!=='web'){_this3.props.updateCredential({username:email});_this3.props.navigation.dispatch(_modules.NavigationActions.back());}};this._forgetPassword=function(){if(_reactNative.Platform.OS!=='web'){_this3.props.navigation.navigate('Password',{});}};this._close=function(){if(_reactNative.Platform.OS!=='web'){var backAction=_modules.NavigationActions.back();_this3.props.navigation.dispatch(backAction);}};},_temp);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},

content:{
flex:1},

contentContainer:{},

logo:{
height:logoHeight,
justifyContent:'center',
alignItems:'center',
flexWrap:'wrap',
overflow:'hidden'},

logoBackground:{
position:'absolute',
top:0,left:0,right:0,
height:logoHeight,
resizeMode:'cover'},

logoImage:{
width:logoImageSize,
height:logoImageSize,
resizeMode:'contain'},


input:{
width:formWidth,
height:44,
alignSelf:'center',
justifyContent:'center',
marginTop:20,
borderRadius:16,
borderWidth:1,
borderColor:'#e2d7ba',
backgroundColor:'#ffffff'},

textInput:_extends({
marginLeft:12,
padding:0,
color:'#51585e',
fontSize:17,
fontWeight:'300',
backgroundColor:'transparent'},
_reactNative.Platform.select({
web:{
outline:'transparent'}})),




submit:{
width:formWidth,
height:56,
marginTop:24,
alignSelf:'center',
justifyContent:'center',
alignItems:'center',
backgroundColor:'transparent'},

submitImage:{
position:'absolute',
top:0,left:0,
width:formWidth,
height:56,
resizeMode:'stretch'},

submitText:{
color:'#ffffff',
fontSize:20,
fontWeight:'bold',
backgroundColor:'transparent',
zIndex:1},

submitting:{
position:'absolute',
top:0,bottom:0,right:12,
justifyContent:'center',
alignItems:'center',
zIndex:2},

submittingIndicator:{},

passwordDivider:{
marginLeft:12,
marginRight:12,
height:1/_reactNative.PixelRatio.get(),
backgroundColor:'#d7cba9'},

password:{
height:56,
justifyContent:'center',
alignItems:'center'},

passwordText:{
color:'#128500',
fontSize:20,
fontWeight:'300',
backgroundColor:'transparent'},


close:{
position:'absolute',
top:20,right:20,
width:44,
height:44,
justifyContent:'center',
alignItems:'center'},

closeIcon:{
backgroundColor:'transparent'}});



var mapStateToProps=function mapStateToProps(state){
return{
credential:state.user.credential,
device:state.device};

};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{
updateCredential:function updateCredential(credential){return dispatch((0,_user.updateCredential)(credential));},
updateInfo:function updateInfo(info){return dispatch((0,_user.updateInfo)(info));}};

};exports.default=

(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(LoginScreen);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg.6bd0d43b.png";

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.f1924fba.png";

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);











var _reactRedux=__webpack_require__(28);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);
var _modules=__webpack_require__(19);
var _user=__webpack_require__(111);
var _UserUtils=__webpack_require__(66);var _UserUtils2=_interopRequireDefault(_UserUtils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var contentWidth=Math.min(_reactNative.Dimensions.get('window').width-40,300);var

ProfileScreen=(_temp=_class=function(_Component){_inherits(ProfileScreen,_Component);



















function ProfileScreen(props){_classCallCheck(this,ProfileScreen);var _this=_possibleConstructorReturn(this,(ProfileScreen.__proto__||Object.getPrototypeOf(ProfileScreen)).call(this,
props));_this.













































_logout=function(){
var message='Bạn có chắc là muốn đăng xuất khỏi tài khoản hiện tại';
if(_reactNative.Platform.OS==='web'){
var result=window.confirm(message);
if(result){
_this._doLogout();
}
}else{
_reactNative.Alert.alert(
global.__APP_NAME__,
message,
[
{text:'Bỏ qua',style:'cancel'},
{text:'Đăng xuất',onPress:function onPress(){return _this._doLogout();}}]);


}
};_this.









_updatePromoCode=function(){
if(_reactNative.Platform.OS==='web'){
_this.props.history.push('/promo-code');
}else{
_this.props.navigation.navigate('UpdatePromoCode',{});
}
};_this.

_updatePayment=function(){
if(_reactNative.Platform.OS==='web'){
_this.props.history.push('/payment');
}else{
_this.props.navigation.navigate('Payment',{});
}
};_this.

_updatePassword=function(){
if(_reactNative.Platform.OS==='web'){
_this.props.history.push('/password');
}else{
_this.props.navigation.navigate('UpdatePassword',{});
}
};var user=_this.props.user;var info=user.info;_this.state={user:user,email:_lodash2.default.isEmpty(info.email)?'':info.email,phone:_lodash2.default.isEmpty(info.phone)?'':info.phone,name:_lodash2.default.isEmpty(info.name)?'':info.name,promoCode:info.promoCode};return _this;}_createClass(ProfileScreen,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var user=nextProps.user;if(this.state.user!=user){var info=user.info;this.setState({user:user,email:info.email,phone:info.phone,name:info.name,promoCode:info.promoCode});}}},{key:'_updateInputValue',value:function _updateInputValue(name,value){this.setState(_defineProperty({},name,value));}},{key:'_focusTextInput',value:function _focusTextInput(name){var textInput=this.refs[name];if(textInput){textInput.focus();}}},{key:'_doLogout',value:function _doLogout(){var _props=this.props,credential=_props.credential,fcmToken=_props.fcmToken;_UserUtils2.default.signOut(credential,fcmToken);var signOut=this.props.signOut;signOut();}},{key:'render',value:function render()

{var _this2=this;var
user=this.props.user;
var isAdmin=_UserUtils2.default.isAdmin(user);
var isSalesman=_UserUtils2.default.isSalesman(user);
var isSeller=_UserUtils2.default.isSeller(user);var _state=
this.state,email=_state.email,phone=_state.phone,name=_state.name,promoCode=_state.promoCode;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
_react2.default.createElement(_modules.KeyboardAwareScrollView,{
automaticallyAdjustContentInsets:false,
keyboardDismissMode:_reactNative.Platform.OS==='ios'?'on-drag':'none',
keyboardShouldPersistTaps:'always',
containerContentStyle:styles.contentContainer,
style:styles.content},

_react2.default.createElement(_reactNative.Text,{
style:[
styles.inputTitleText,{
marginTop:24}]},'\u0110\u1ECBa ch\u1EC9 email'),



_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'emailTextInput',
value:email,
placeholder:'\u0110\u1ECBa ch\u1EC9 email',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
keyboardType:'email-address',
autoCapitalize:'none',
returnKeyType:'next',
editable:false,
style:styles.textInput,
onChangeText:function onChangeText(text){return _this2._updateInputValue('email',text);},
onSubmitEditing:function onSubmitEditing(){return _this2._focusTextInput('phoneTextInput');}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'phoneTextInput',
value:phone,
placeholder:'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
keyboardType:'numeric',
autoCapitalize:'none',
returnKeyType:'next',
editable:false,
style:styles.textInput,
onChangeText:function onChangeText(text){return _this2._updateInputValue('phone',text);},
onSubmitEditing:function onSubmitEditing(){return _this2._focusTextInput('nameTextInput');}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'H\u1ECD v\xE0 t\xEAn'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'nameTextInput',
value:name,
placeholder:'H\u1ECD v\xE0 t\xEAn',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
autoCapitalize:'words',
returnKeyType:'next',
editable:false,
style:styles.textInput,
onChangeText:function onChangeText(text){return _this2._updateInputValue('name',text);},
onSubmitEditing:function onSubmitEditing(){return _this2._focusTextInput(
'promoCodeTextInput');}})),


isSeller&&_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'M\xE3 gi\u1EDBi thi\u1EC7u'),


isSeller&&_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'promoCodeTextInput',
value:promoCode,
placeholder:'M\xE3 gi\u1EDBi thi\u1EC7u',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
autoCapitalize:'characters',
returnKeyType:'done',
editable:false,
style:styles.textInput,
onChangeText:function onChangeText(text){return _this2._updateInputValue('promoCode',text);},
onSubmitEditing:function onSubmitEditing(){return _this2._focusTextInput(
'passwordTextInput');}})),


isSeller&&_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
style:[
styles.submit,{
marginTop:24}],

onPress:this._updatePromoCode},
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.submitImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.submitText},'\u0110\u1ED4I M\xC3 GI\u1EDAI THI\u1EC6U')),




isSeller&&_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
style:styles.submit,
onPress:this._updatePayment},
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(981),
style:styles.submitImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.submitText},'TH\xD4NG TIN THANH TO\xC1N')),




_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
style:styles.submit,
onPress:this._updatePassword},
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(982),
style:styles.submitImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.submitText},'\u0110\u1ED4I M\u1EACT KH\u1EA8U'))),






_react2.default.createElement(_reactNative.View,{
style:styles.logoutDivider}),
_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
style:styles.logout,
onPress:this._logout},
_react2.default.createElement(_reactNative.Text,{
style:styles.logoutText},'\u0110\u0103ng xu\u1EA5t'))));





}}]);return ProfileScreen;}(_react.Component),_class.navigationOptions=function(_ref){var navigation=_ref.navigation;var _navigation$state=navigation.state,routes=_navigation$state.routes,params=_navigation$state.params;return{tabBarIcon:function tabBarIcon(_ref2){var focused=_ref2.focused,tintColor=_ref2.tintColor;return _react2.default.createElement(_modules.FontAwesomeIcon,{name:'user',size:28,color:tintColor});},tabBarVisible:!routes||routes.length<=1,title:'Trang cá nhân',headerBackTitle:null};},_temp);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},

content:{
flex:1},

contentContainer:{},

inputTitleText:{
width:contentWidth,
marginTop:16,
alignSelf:'center',
color:'#000000',
fontSize:16,
fontWeight:'300',
backgroundColor:'transparent'},

input:{
width:contentWidth,
height:44,
marginTop:5,
alignSelf:'center',
justifyContent:'center',
borderRadius:16,
borderWidth:1,
borderColor:'#e2d7ba',
backgroundColor:'#ffffff'},

textInput:_extends({
marginLeft:12,
padding:0,
color:'#51585e',
fontSize:17,
fontWeight:'300',
backgroundColor:'transparent'},
_reactNative.Platform.select({
web:{
outline:'transparent'}})),




submit:{
width:contentWidth,
height:56,
marginTop:12,
alignSelf:'center',
justifyContent:'center',
alignItems:'center',
backgroundColor:'transparent'},

submitImage:{
position:'absolute',
top:0,left:0,
width:contentWidth,
height:56,
resizeMode:'stretch'},

submitText:{
color:'#ffffff',
fontSize:20,
fontWeight:'bold',
backgroundColor:'transparent',
zIndex:1},

submitting:{
position:'absolute',
top:0,bottom:0,right:12,
justifyContent:'center',
alignItems:'center'},

submittingIndicator:{},

logoutDivider:{
marginLeft:12,
marginRight:12,
height:1/_reactNative.PixelRatio.get(),
backgroundColor:'#d7cba9'},

logout:{
height:56,
justifyContent:'center',
alignItems:'center'},

logoutText:{
color:'#ff0000',
fontSize:20,
fontWeight:'bold',
backgroundColor:'transparent'}});



var mapStateToProps=function mapStateToProps(state){
return{
credential:state.user.credential,
user:state.user,
fcmToken:state.device.fcmToken};

};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{
signOut:function signOut(){return dispatch((0,_user.signOut)());}};

};exports.default=

(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ProfileScreen);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABFcAAACzCAYAAABMxPN6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA25pVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo2MWViMmJkMy1kOTNlLTUzNDUtOThlOS1mMjI1YjdiNDFkNDQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDFERDcxM0VFMTNFMTFFNzg0NDlDRkJBOENCQzkzMEMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDFERDcxM0RFMTNFMTFFNzg0NDlDRkJBOENCQzkzMEMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MzQ2NEYyQzhFMDc5MTFFN0FEMUE5RjEyRjIzQzc2RTciIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MzQ2NEYyQzlFMDc5MTFFN0FEMUE5RjEyRjIzQzc2RTciLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6XWK3MAAAi1klEQVR42uzdebglaV0f8N+5S3dPd8/GIjAzbGNAH8IQHFBkkUgwrGoEWWKCMT7iIyHRGFRIfBJgwsQElRCNuygaITFhBjGKCC4Ik3E0IAMMQxSF2fdhlt77LqdS76mqe+rUrTrn3K373tufz/P8uurUqapT53T/09/n975vL8uyAAAAAGB9ZvwEAAAAAOsnXAEAAADYAOEKAAAAwAYIVwAAAAA2QLgCAAAAsAHCFQAAAIANEK4AAAAAbIBwBQAAAGADhCsAAAAAGzDnJzg1enf7DQAAADiT/2Nc1kxtv7dzHj87t/s94QoAAACw9bKy+rVjM7Xq7dyvtuvDld7dcV6+eUpefyuvi/N6bF4X5PXQsg6Uv8PZ/qUDAADAmh3Oaymvo3l9uazb87opry/l9Td5fTavB1Zd2Y9h2LKDg5ZelmW75m+zd3fsyTdPz+uZeX1DXpfm9Wj/zgEAAOC0uyWvT+V1VV7X5PXJvBZaz5yNYdCyTYwbFrTjw5Xe3fGIfPMteb0orxeEDhQAAADYCY7k9Yd5fTCv38nrrlVnVAHL7Ol/2F0Xrpx/d5x3OItXLke8On/5jdvjZwYAAADWKf8vfnwsr9/M63/l9eDIu2mYUJrQ4zR2smTndb/XOoppmwUuK8+45674usWI1+W7r4xirhQAAABgd0lzt7wvr1/M689G3jmNIUsVrvR6q6OU7RiujDzTqx6MmfefiG9bjnhD/vJZrResY6KbXTTVDAAAAOxWf5rXO/L6QNTXGUrhSgpZTuHEtzslXBl5lsuORu9tR+JlyxFvyV9eUnyBLf6hBC4AAACwHV2X11vz+q0oFnQupIDlFE0UshPClZHnmL8zvnEp4ify3adNClTWG7hM+oqCFgAAANh2/iKvH87rT1aOnKIuluz8Yrtdw5WVZ9h/V1x0PIu358/5HZ0n96Y7NvYHyaY7Nu44AAAAcNqkiW/fGMXyzoX52NK5WLZruLLy2a+6P2auPBGv70f8h/wZVy2l3HzuSa8n/iDZ2l53HQMAAABOm8N5/WhePxfVfCxpiNAWdbFsx3Bl5XPPujMedyKL38if7dkjJ4wJUDYSrowLUtYTugAAAACn1dV5fWdeNwxepe6V1MWyyQHLdgtXVj5z7o54zXLEz+TPdc7ICb3R7bT7Xce6QpJpjgtYAAAAYNs7lNc/z+s9RTAQmz5MaNuFK4+/O/beuBz/Nd9/7aTQZNyxtXSwtAUmXSFK830BCwAAAOwI78rrX+R1cvAqBSybtJrQdgpXevvvHExae2W+/7XTBCfjApVJIctaOlOm3bbdFwAAANg2PpHXy/O6dfBqkwKW7RKu9PbcEU9dzOJ38/0Lpg1W1hO2rP4+q/fbtgIWAAAA2BVuz+uleX168GoTApbsIcX2tIYr87fHi5Yi3pfvHuwKViaFK2sJWka/T/e2K1QZd6x+HAAAANiWjuT1irw+PHi1wYDltIcrc7fHy5cj/ke+u6d4kOqBhttx+9OGLc39ro6VcfvTnNe8NwAAALAtLeT1HXm9f/AqpRLrnOT2tIYrvdvjH+Wb/xZlPtQMQtqClGmPNe/RvH/xXYbbtiBl2mPNe9TvDQAAAGxby3n9k7z+++DVOgOWceHK3FY+fe+2wQQyo8FKVj1Mmexkw/2q2o71ojtsqW/r+1l5n5VtjAYibcdWfrSsfNas+OysuR/D7wIAAABsWymTSNlEWkHoykEvy57oaDdZny3rXOndFi/ONx8oH7k4NmE40MzM+P20HdfF0qWrO2WtVb9H/b4AAADAtpdilW/L60ODzpU9a7s4e2ixPWXDgnq3xiX55uq8zl451jIcqGv4T1uYMq7q92+bc6UeiPT70wUp6bz6+fX7CFcAAABgR0qT3D4rr+sG/Szz01+YPazYtoUrM5v9lL1b46J883tRC1ZG3u+tft0WljSDlfR6mqrOTds96Vhv9XvN89s6YLrmdGm+BwAAAOwYB6PILC4azMSyvDk33dQ5V3q3DJpq3j94yHHn1eZbqV53zrMSRUCy6nWve8Wg9KWW89f78u3D8u1d+b1P5Pv98iP7tY6TdK/663peUp93pZpvZeR47TsAAAAAO0LKLFJ28Q2xECcH4cEGmyc2e0Lbn8vra6c9edzQoHrHyrj9+rWpDSeFJU/Nt1/OiuFTfzuvY/n+F/L6Yr8IpXr5icv90edIqolvm/sVw4AAAABgV0jZxc/m9drBTCx7N3azTQtXerfEa/LN97S+N2EYTVfI0hamtA3lSYFKGir1pLyORoqeimOpW+WJ6Uvm+7dmEdfk20/3Ix5IwUotYGk+XzNkAQAAAHadlGH8SfTjPbEUG0pINiVc6d0Sj4si8Zl8bq97taCuiWqbwcpI6JKfc2EUo3P+fhQhyzPySstPPxjFxC/n5dXPz72oV3zhT+R1f5qodqaYsLb+WfXlm6tjiZAFAAAAdp2UZVwdi3HDIFBY5/CgDYcrvZsH+cZ78jpnTdeV86zU95tzr8z0uudfSduqa+c55Yf/vbzSykjp+Pnle6l7JU3+m36j5+V1T37dF3tF8FK/b7TsJ1ltvpWsMf/KyNwrAAAAwE6T4oTfyOu5sRD9tS7PXNmM1YJen9ez13PhNHOudA0RSmHJw/P6+ihClbRQ9WPyemQUXSszZe2PIlxJ+wfyujS//rxe96S4axnCBAAAAOx4KdN4/WCS1v76brChcKV3czw63/zYVOf2ul93hSzN1yvDgqIIUb46r+/I68nl/sHyC3VlH6nJ5FF57a+1qLQtwzzuOQEAAIBdJ2Ubj47F9V280c6Vd0QxrUmnthClK7CY1L1STV6bxjKlbpVvzOv5UQwFmi1rnPT+/pUPG//Z0xK4AAAAwI6Xso13DDpXltd+8brnXOndNFiU5xUbefLmHCuRjVavZc6VFJCkLpUXRtGFMh9rm28mTQB8KCsnrq3dN8taPr/j+EhFmHcFAAAAdr5XRlqAeDGuWmsryro6V3o3DXKHd8a659Ftn9ukq1ulfl5Kg16d1yV5XbzGB0gB1K153dubfOG0HSlWEQIAAIBd453Rj95au1fWOyzoZXk97VR9syromM23T8m33xrD+VXWIuUgV+V1X0xuNhGaAAAAwBknZR0vGwx7WYM1hyu9mwbXvHUjT9o1ue2klXpS10rq0TkQ6xvPtJDXn8T0w6cELAAAAHDGuSz6MbOWlYPWnlEsLX9rzM5esqHHLEOLas6Van6V1m15fi+vi/N6UW/yxLVtUqDyB3ldl1d/0jwqHZWVP2y1HZl3BQAAANgNnhzLg+zjA7FnugvWPixodvaHT8c3S4HK10VttZ81OJ7Xobz+Z14L5WS2zerSfK96rasFAAAAdqmUfaShQVP+339NnSu9v1l6ZszOPXu9z1bvVBmob1u6RHozw+1Z+bFLY+0z6KaOlfvz+qO8/iK6u1bS5zRrVdeKlYIAAADgTPDsWF56ZizNXTNNcjJ150ovF7Nz37uRJ5um26OtkyQFKmkC2wt6a18d6K+jGAp0RV6LHV0rulAAAACAESkDuWi6tYSn71y59v5zI4tXbcoDVkNryq6Ulc6RGL4e6SjJd+fzrzOX7yz3JidC6fwjeaWhUalj5ea8Pp/fZznr7k5pO77yumseltp3AQAAAHaVV8W1978h+vHApE6PqTpXBl0rB895dRQL9Wy6tnlNmh0lS/n+4ShqXJ6xGEXHypfy+lgU4cpVWXF9v7/63l1dLLpZAAAA4Ix2YJCFXDC5e2UNc670Xr1ZXRorHSuDF8Nts3ulep3qWF635a8fl7+3P/9ae2M4RCgtsTxfnndz+fqTUYQqX8yvOZQVc62k+60ELI39ZsdKc7sq8DGcCAAAAHa5Xmo0+aVJZ00MVwZdK5+851H5znM38/GycrnleqdI9brZQbLcL1b8uT7fXpyfsy89eL49K4qQ5WheX45iXpbP5ed/Ot/elNfV/eH19fs2O1im6WRpPjsAAACwy6UsJGUij+rdEVl3GjBd58rBc78litWQN1UVqFT7zYCj2k9O5tvPLEc8ND//+EzE2VGsBJSk1ZFuzeuevG7Iz/tov3jYxapjpSVQqV63BS31zwUAAADOWLNx8Nxvzre/PO6kseHKoGsljb6ZmXvxVk3cWh8iVF9+efBxveE2DfX5q7SbH7h3NuIRM8XcKg+U97k3r89kxaS392XFdf1sTMdKf/x2ZKLbliFBI1sAAABgd5qZe0n+57tSRJJ1dK9M7lz58XfviV7veZv1TPXHqA8Dar5fbVMgMjNTbNPcKZ/Kt/fm2wtTIJNff3vZ/ZI6VW6phSrVPbJsuiFBXUODxj0/AAAAsMulTCRlI2/87pOdp7QdTEHMStfKZw49K/affdX6n2F0v6tSgDLu2Mh+mm8lr3NniqAl6xUp0eLK8w+346oetLSFLtWx5r3qnwEAAADscscOPzf+zjlXx3DdnRGTO1fm9z57I59fn1el63hXl0jVtVLtV+FKClOOprlXsiIdSq+XG/eu37f+elLnSlvXSmZlIAAAADhzze99Vv7n1V1vTwpXetGbfeZmzy2ysjJQf/AJI/vNSkN8ZmZWHx9ERWU40wxvmt0l03avdAYs1fwr9d9B2AIAAABnhpSNlP0dbW+3hisrQ4IGk9nOXLqZz9PsZJmmI6TetVKv5nLOzXtOOzyoa86V5v5anhkAAADYJYpspMpKkpFkYGbMpb244uqHRK/36M16lkkhxTThRwpa6rW8vPpYVW3nTxOstD2fQAUAAADOUCkbSRlJx9y1beHKsGvl8V91yWY8Q1eIUt/PJqzw0xWYtAUobcFL817r6WJp+y4AAADAGaDISOqTlqwYN+dKL+b3PmGr5lup7w8Ci/LRmq9XHrc210qvN+y/6Zost7k/TaDTtl/srL4vAAAAcAaZ3/vV+Z8fb3urK1wp51uZe+xWPVM9WGnOm1J/3RXG1I913b/5fltw0jUsyJLLAAAAwIrZ+cfHsA1kJC1oC1dWekbmZ2afsLhJzzAuJOmamLbt+mnOrV/Ttq32JwUqhgMBAAAAyXxv5vGLo+NsVpKCZrhSH2TTm5/pXbi4RQ+10YBl8IC97vPG7Y8LTwQrAAAAQNP8TO+CxUZuEmXAMrZzpRe9h27mnCttyzCPDViqTpeoXVe/fsrPrG+79ruGAQlWAAAAgF70HhZTdq4Mr8lrKXoP2eyHGRewjDxARxdL8/pxn9P1etrllgUrAAAAQFJmJKtWCkrahgWtVD96+7figboClmq/qRm0jAtYJk1w2/a6K8QBAAAASPrROysauUm0DAtqLHocM1kWM1v1UG0By8qDNLtWGkHKNHOzbOYxAAAA4MyWxSAjSVXvXhkELJOGBe3d0gfr6EAZG7RMed+1HJ/0HgAAAHBmKzOStQ8LOhUP1wxSxr1fnbOWZZg3eg4AAABAaeKwoNUnn+LwoS1ImXTORu4PAAAAsAYTO1eaHSu90/3EXWHIpNWChCgAAADAFmjOV9s558opHRa0HsITAAAA4DRozUxmam+2bQEAAAAotI346c10nFjfAgAAADDU2rnSdpJwBQAAAGBoqgltR5nbBAAAAKDLYELbmZaD235CWwAAAIDToDU3mfG7AAAAAKyfcAUAAABgA8aFK4YFAQAAAAy1ZiVzYy8xoS0AAADAWOOWYgYAAABg1KrMxJwrAAAAABsgXAEAAADYAHOuAAAAAGyAzhUAAACADRCuAAAAAGyAcAUAAABgA8y5AgAAALABOlcAAAAANkC4AgAAALABhgUBAAAAbMD4cKXnBwIAAAAYZ27iGbpXAAAAgDPdmAYUc64AAAAAbIBwBQAAAGADxocr5lwBAAAA2MCwIOEKAAAAwNiMZPJSzCa0BQAAAM50Y/IRnSsAAAAAk6x7WJCuFQAAAIANdK4AAAAAMNb4cGXZDwQAAAAQ/e63xocrS6G3BQAAADizpWxkcfzb3RZDuAIAAACc2TYSrsydzE5OWKwZAAAAYHebKzOSDl3hymAO3GwpM+sKAAAAcMarZSSr1g0a27kys5SdGEzY0vMjAgAAAGeglIn0y4ykw7hBP1lvafneODn7kJiPsWOLAAAAAHallJycjBhkJC1dK9UpnZZP5hcuxBNjfxQrBwEAAACcSVLDydEyI+kwPlxZWLg7Tp5VDB7K/J4AAADAGSZlIifLjKRDM1zJRmrhxM2xeG4xJCglNbpXAAAAgDNFSk0Wy1o4cUs0c5PaaZXVvSnHDt0SS4+IOJ7vHwjzrgAAAABnjpSaHI2i2eTEkZtbzsiq06LjzSzuu+NL8egn5DfIX50XgzYYw4MAAACAXS+tEpRG8aRMJDWb3Hvbl6LRsVJpW4o5W9n+2W/9v0E6k2ohJszQAgAAALBLpAwkZSFVLpIyknpmUtOr7c+UNVfWnkFdufipOHfuUXF+/ursKNphAAAAAHazND3K4bzuz+vBpdvj2+efFkXcUo9c+qnaelFGJ2c5ceyzcdY5j4pjUQwNSlcs+40BAACAXWq2rJSFpCjlxLHromMy26Q+LKh5QrF/9P5PDsYW9cub7vUbAwAAALtYyj5SBpKykJSJpGykLTMpX8903GZ40q1/+YmVmx2JonNlxu8MAAAA7ELVhCkpA6maTW77q3q4MnFC22xVvfuHro1+/8hgpaBqZNE+vzUAAACwC6XMo8o/UhbS7x+NX33Dp6ItMylN6lzpxy3XL8bxI386uGk6ciiKBGfW7w0AAADsIinrSJlHyj5SBpKykONHrh5kI0UPy8TOlea4of7K9v47/niwlxKb41G0xeheAQAAAHaTlHWkzCNlHykDSVnI/Xf8UdQzktVzr0wcFjRYUig+/t6P5K+W40R59MEo0px5vzsAAACwC6SMI2UdKfNI2UeRgSzHx9/7B1HlI+scFlTU+952V5w48n8HKzinBKdaiiglOj2/PwAAALCDpWyjmmslZR4p+0gZSMpCUiYyZhnmpC1cWd25kureW39ncOR4+c595YdbmhkAAADYyVK2kTKO+yNGso+UhdSzkY6ApW1YUH1/GLBccflvR5YdH6Q4Kb1JY49SmrMnTG4LAAAA7Ewp00jZRso40lCglHkMFvXJjg+ykNXBSmXssKD2zpWr3vtgHL7vg4Ojx2LYvZLePSsMDwIAAAB2lpRlpEwjZRsp46hnHikDSVnIOjpXKm0T2y7HF6557+Ddqnsl1QPlXaweBAAAAOwkKctImUbKNqqcY6F8r8hAlmPMRLaVtn6TXlnp9tUKz2nO3D2Des/R/x1793/N4Mg55RWPimJ80onaQwAAAABsVynlSOFKmvbkjvLYoSgmsz157Np4zYFvjSLlWIjhFLfNsGVgruX29bWa+6vqps/+fDzx639pcNuF8mHuyevCGLbSLPs7AgAAALap1EpSZRj3lMeqCCVJ2UdbJtLRvdI1U0q9e2Uu6t0rB87bF79850difu8TB++eV555MK+Hlx91NFqaZAAAAABOs5RhHIgi8UjBypEoMow0NChlGosnvxDf+8gXxNEHqvE5VdfKUrRPbNs+50qWi7ZJbVMdfWApbvzMOwfvpA6VKkg5XFa64/4wwS0AAACwvaSsImUWKbuocoyUaaRsY7ncT5lHyj6m7FqpbrtKylZ6ufL92bLmo+pemd+3N959/+/m2ycPLji3fCedfUEU86+kxzjm7w0AAADYJlKwksbmpHlWbo8iJkl9KQ+W7y+euD6++/yX5tt0RtW1kmo5hvHLqnBlZoqPHq4WVNXiiaX43B+/beWMI7Xb3xVFsJIe9ix/bwAAAMA2kDKKlFWkzCJlF1WOcaR2zvUffdsg86hnIMOulU6dnSuDN4vulZkYrhw07F5J9Sv3/UIcOP/Fg5NTt8rZ5Q3SuxeWV6V857i/QwAAAOA0ScFKSjNSTHJbDFc6TsOCTpb7R+//UHzPQ14XoysEVV0rg6FBaRqVIioZNW3nSlXLI/Whn748sv7RwVnpYU6UV6RHqFKg+dDBAgAAAJweVbBSjbapgpWUYVTBStY/Nsg4mrnHmHlW6saGK2Mmtk0fsBRXvPWWuOMLP7lywdEo2muSY+VDR/klTHILAAAAnCrV5LXz5euUUVRzw6bs4mjt3JRtpIxjdCjQyES2WTXMp+OjVqmfX5vYthoeVC3LXAwP2n/uvvj5294Xew9cOrggnZEmuJ0tb5CGCj2i3F8uv4hlmgEAAICtUgUrVTaRgpXD5X7KJtIEtv3y9cljn4p/dsEr49iD9aWXq+WXVwKWKlxZ17CgWvdKP1ZPbruUf/hCfOin3xBZv5gCph/DpYyi3L+zfJ2+1IHalwMAAADYTPXsIWURKZOogpWs3K+ClZRlfORn3zDINoowpTmJbbG9MVv/sKAW9WFBw/rNH70hbrj2spUBRCnfOVR7lPTgt5ev0yfW23IAAAAANkM1LUnKHlIGkbKIqgEkvU5ZxWIMJ0BJWcZ733hDrJ5rpco/pjJVuNIx98qweyVtf/TpV8She963ctFCjHawpOFAt5Znpw6as8oyDwsAAACwEc2cIWUPKYOo5lipGj8WatccuueKQZZRzzZGg5UiB5nQtZKstXOlHrBUHz6sy5//5jhx7HMrZ52MYcCSKo1eujmGqwqlRMkwIQAAAGC9qmFA1QiZevZQ5RHVkssr+cSxz8Xlz/930cw1RocETT1j7NThSm1W3GbAMgxZbrnuWHzg8tfF8tKdKxemhz9Uu1E6M82/+2DtCVLLzr7QxQIAAABMJ2UIKUuohgElKWtImcNS7bwqWKmkzCJlFynDWB2qjAYrU3StRKyxc6Uxue3ossxV/fZ/vDU+9quvHawRXUltN4dimPlUa0vfWd4h/SB7okia5vz7AAAAAMZI2UHKEFKWkDKFlC2kjCFlDfXsIWUR9WAl6x8fZBYpu1jdsTIasEwZrCQz6/waXd0rxVJF7/q+6+P6j/5A9LPFkSFCD5RnVsdSonRjXsdrT7M/RpdLAgAAAEhSVlDlBlWikTKFG6PIGKq8IWUPKYOoDwVKGcX1H/3+QWZRzzBWrxCUrfWxWgfiZBPCmV6xqHNVs2XNlZVGOe0ZbN981Uviq57zU1GPStKXPydWd6icn9fDYjTuWSp/iL5/PwAAAHDGSlnB3hjNElJWcG9e9zfOTVlCtYLx0HJ84eofjMue88EoQpWFGIYr9YClcxLb7LHFtohERq0rXClvVoUrM2VVAcv8SF32Zy+Pr3zG26MesKSrUvvOvsZN0xVfkdfZLT/MQvk1AQAAgDNDShJS+0azQSPNo3J3FPFIXZrE9mg0e0+W44t//qZ4y9e/v7yiXqvnW+kYDrSV4Up1jypcaQ9Y/t3HXxJPfM5/zi+aH7lJSp0OtjxFau9JIUszfFmuffXMvzEAAADYdVJGUCULzSlDUniSQpVjjeMpIzgSo/OrDI5ni/GF//ND8bbnVh0rbcFKfUhQnNJwpbxhdf1MreZidIhQUW/68PPiyd/009Gb2T9yk/RDHYzhkkl1qYMlDRXa2/KjVaOjdLMAAADAzpfygZQNpDShmVak0CQNATrcct1SebyZD6SFdj73hz8Qb3/hR2N1qFJVfcGesasDbVm4Ut60Pv/K+IDlte96SnzDd/1izM59xaobnRVFx0rbE6WQ5SHlOaseNkZHSOloAQAAgO2vmsW1Sg/a8oA0We190R6qpP//H4vhIjl1y0t3x1W//n3xrtd+NiYHK53zrIx83JaGKzflfzxuVcDSNsltkT+99Ecuim9/68/Fnv1PXnWzdGWai2Vvx4elcOW8KMKWrnWOlmP1AkoAAADA6TXTSAy6VglO/49PYUpa7ed4xzmpk+Vox//5F459Lq586+vjgz9RLbfcDFZWrw40xbLLWx+uJNMFLMX2MU85EG/68Fvi3Ee+ovWm6cwDsXrCmvpfyDll7Z/07WO0ySeL9sWVdLwAAADA2vUa+1UqUB/fMtOVQNSkLpRD0bbSz1CKRlKostjx/oN3Xhlvf+Fb4+bPVmfVl1xed7AyiA22NFy5ufbisRMDlnrIMheX/fnL4uKnvzl6Mwdbb55mBD4Q3WlWlHc6WNaB6O5oAQAAALaPFG+kCORIWUtjzk1xSApfTna8n/WPxJc+eXm85RlXxjBIaQ4DWh2s3DR9AJI9pthufbiSPLZzDpa2Lpa5ePllj4uX/NCPx94Dl3Z+SBomdFa0T3rb/Db7Yjh/y74prgEAAAC2Xoo60mo/1TwpaT+b4pp07skx55w8em383jt+JN7/lhujPVhZjrY5VtYQrCSnNlxJ2gOWrmFCc7Hv7Pl4y59+Z1z4pB+M3syBzg9LV6TAZG9MbieqzJbn74nRBaKrp6k/JQAAALA29ak3qt6Q+hSyC1GEI9Ou9puV55+I7uE/g/P6R+O2z/+XuOxZvxEnDtfDlK5hQOsOVgYfd8rDlaQ9YGnrYhnWS374ovjmf/1v4uBDXzD+Q6MITFLNx/RBCwAAALD9pBgiRSIny5oUSxz58h/E7/6nH4vf+8lq0tpmNbtVNhSsDB5xK8OVcRrLNDfnYWkGLLMr23/5/mfGJS98U+zZ/6SJH5LuuCeGnSk6UAAAAGD7S9HDQq2mWe134djn47oPvz1+6uXXxDBAqbbNbpXR+VUGccfGA49THq6UH9qrfVa9g6UtZBkGLHN75+KNH35BfOUzvj/m9z1h6g8crkk0vCMAAABwelURSH0Nn2ktnvjr+OKf/0z8+As/HEsn64FKPVhphir1jpXINinsOC3hSvnB9YClOQ9LfajQbDRDln1nz8W/+u0XxOO/9rtj38Gnrv3DG3dvLgNVLwAAAGBtskbVY40q6liKyUN92pw48um44RPvjnf+g4/EicNtoUr9E6pPHB0GFJsXrAxihtMVrpQf3gxY2ia7bQYs9ZqJ173na+JJ3/QP45yHvyh6M/v8CwYAAIBdJuufiEP3/H58/g9/M37hNdfGaExTD1Oax5qhyqYHK8nU4cqa/Poan/G7Vg0TGheyrA5Y0vaSF50br7j8xfGIJ7w09p399PybmWkFAAAAdqos68eJw5+Mu/76g3HFv/1QXPf7D8YwMFmeUPVQZWUYUPz6JneOfFd3hHLqw5XigcZ1sdSHC7WHK/Vz/+73PDye933Pj4df/Jw4cP6zxi7lDAAAAGwPWf9YHHvgmrj7ix+Pj/7iH8XHfuWeWD2oqC1caQ7/WdWtsunBSrLtwpXhg7XNxdI2J0tbuLJ6BpWHX7w3vv3fXxKP+ZqnxnmPfFrsPfikmNvzSP9iAQAA4DRbWrgzTh75fDxw51/Ezdd+Oq5883Vxz5eqhZe7QpV6uNI2p8rI3CpbEqpUtjRc+bUNPvc/HQlYknrAUl++eWbCfvO6oi79tnPjmf/4q+Nhj31cHHzoBbHv7Atjbu9XxOz8eTE7d95g7pZebz7fnuVfOgAAAKxRmiMlyxYG2+WlB2J58YFYOnl3nDh8Wxz58u1x7003xjXv/cv41AfSUJ/m1LddwUrXfvO6iCpY+bUtDFaK/KLzrdMfrgwfsm2oUNuQoWlqdcgyuiZQb8z3t24QAAAATJaNOVbftq0n1AxVpqm2e219qFLZ0nBl800KWephSzN4aXtvPQELAAAAsDZrDVbaApYsuof9jIYq61vceUts52ChLQRphizNwKVt21VtnwEAAACs3TTByriApRmkrJ6kdhuGKpWdECr0GvvT1KSOlV7HvQEAAIC1yVr2s5iug2WaavucbWWnBQpd3Sz1/bWEKuZcAQAAgPVZy5wr9f1xw3y2fZdKm50aJLR1nEwKUXSrAAAAwNaapotl3LG2+2x7uyVc6E3Y7+pUEa4AAADA5sk6Xk8KULKd/KV3a7gwTYgiWAEAAIDNl01xLNtNX/hMCxgEKgAAAHDqZH4CAAAAAAAAAADYKv9fgAEA9H8CBOiVJzoAAAAASUVORK5CYII="

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/btn2.55b63402.png";

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);











var _reactRedux=__webpack_require__(28);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);

var _modules=__webpack_require__(19);

var _user=__webpack_require__(111);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var contentWidth=Math.min(_reactNative.Dimensions.get('window').width-40,300);var

UpdatePasswordScreen=(_temp=_class=function(_Component){_inherits(UpdatePasswordScreen,_Component);









function UpdatePasswordScreen(props){var _this2=this;_classCallCheck(this,UpdatePasswordScreen);var _this=_possibleConstructorReturn(this,(UpdatePasswordScreen.__proto__||Object.getPrototypeOf(UpdatePasswordScreen)).call(this,
props));_this.























_submit=function _callee(){var submitting,_this$state,password,repeatPassword,errorMessage,textInputRef,data,_ref,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:
submitting=_this.state.submitting;if(!
submitting){_context.next=3;break;}return _context.abrupt('return');case 3:_this$state=



_this.state,password=_this$state.password,repeatPassword=_this$state.repeatPassword;

if(_lodash2.default.isEmpty(password)){
errorMessage='Vui lòng nhập mật khẩu';
textInputRef='passwordTextInput';
}else if(_lodash2.default.isEmpty(repeatPassword)){
errorMessage='Vui lòng nhập lại mật khẩu xác nhận';
textInputRef='repeatPasswordTextInput';
}else if(password!==repeatPassword){
errorMessage='Mật khẩu không trùng nhau, vui lòng nhập lại';
textInputRef='passwordTextInput';
}if(!
errorMessage){_context.next=8;break;}
if(_reactNative.Platform.OS==='web'){
alert(errorMessage);
}else{
_reactNative.Alert.alert(
global.__APP_NAME__,
errorMessage,
[
{text:'OK',onPress:function onPress(){return _this._focusTextInput(textInputRef);}}]);


}return _context.abrupt('return');case 8:



_this.setState({
submitting:true});


data={
password:password};_context.next=12;return regeneratorRuntime.awrap(

_APIClient2.default.POST('/user/updatePassword',
data));case 12:_ref=_context.sent;response=_ref.response;error=_ref.error;
_this._handleNetworkResponse(response,error);case 16:case'end':return _context.stop();}}},null,_this2);};_this.state={};return _this;}_createClass(UpdatePasswordScreen,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'_updateInputValue',value:function _updateInputValue(name,value){this.setState(_defineProperty({},name,value));}},{key:'_focusTextInput',value:function _focusTextInput(name){var textInput=this.refs[name];if(textInput){textInput.focus();}}},{key:'_handleNetworkResponse',value:function _handleNetworkResponse(


response,error){var _this3=this;







this.setState({
submitting:false});


if(response&&response.response){var
password=this.state.password;
var credential=_extends({},
_APIClient2.default.credential,{
password:password});

this.props.updateCredential(credential);
var message='Cập nhật mật khẩu thành công';
if(_reactNative.Platform.OS==='web'){
alert(message);
}else{
_reactNative.Alert.alert(
global.__APP_NAME__,
message,
[
{text:'OK',onPress:function onPress(){return _this3.props.navigation.goBack();}}]);


}
}else{
var _message=_Utils2.default.parseErrorMessage(response,error,
'Đăng kí thất bại, vui lòng thử lại sau');
if(_reactNative.Platform.OS==='web'){
alert(_message);
}else{
_reactNative.Alert.alert(
global.__APP_NAME__,
_message);

}
}
}},{key:'render',value:function render()

{var _this4=this;var _state=
this.state,password=_state.password,repeatPassword=_state.repeatPassword,submitting=_state.submitting;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
_react2.default.createElement(_modules.KeyboardAwareScrollView,{
automaticallyAdjustContentInsets:false,
keyboardDismissMode:_reactNative.Platform.OS==='ios'?'on-drag':'none',
keyboardShouldPersistTaps:'never',
containerContentStyle:styles.contentContainer,
style:styles.content},

_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'M\u1EADt kh\u1EA9u m\u1EDBi'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'passwordTextInput',
value:password,
placeholder:'M\u1EADt kh\u1EA9u',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
autoCapitalize:'none',
returnKeyType:'next',
secureTextEntry:true,
style:styles.textInput,
onChangeText:function onChangeText(text){return _this4._updateInputValue('password',text);},
onSubmitEditing:function onSubmitEditing(){return _this4._focusTextInput(
'repeatPasswordTextInput');}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'Nh\u1EADp l\u1EA1i m\u1EADt kh\u1EA9u m\u1EDBi'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'repeatPasswordTextInput',
value:repeatPassword,
placeholder:'Nh\u1EADp l\u1EA1i m\u1EADt kh\u1EA9u',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
autoCapitalize:'none',
returnKeyType:'send',
secureTextEntry:true,
style:styles.textInput,
onChangeText:function onChangeText(text){return _this4._updateInputValue('repeatPassword',
text);},
onSubmitEditing:function onSubmitEditing(){return _this4._submit();}})),


_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
style:styles.submit,
onPress:function onPress(){return _this4._submit();}},
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.submitImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.submitText},'THAY \u0110\u1ED4I M\u1EACT KH\u1EA8U'),


submitting&&_react2.default.createElement(_reactNative.View,{
style:styles.submitting},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#ffffff',
style:styles.submittingIndicator}))))));






}}]);return UpdatePasswordScreen;}(_react.Component),_class.navigationOptions=function(_ref2){var navigation=_ref2.navigation;var params=navigation.state.params;return{headerBackTitle:null,headerTitle:'Cập nhật mật khẩu'};},_temp);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},

content:{
flex:1},

contentContainer:{},

inputTitleText:{
width:contentWidth,
marginTop:16,
alignSelf:'center',
color:'#000000',
fontSize:16,
fontWeight:'300',
backgroundColor:'transparent'},

input:{
width:contentWidth,
height:44,
marginTop:5,
alignSelf:'center',
justifyContent:'center',
borderRadius:16,
borderWidth:1,
borderColor:'#e2d7ba',
backgroundColor:'#ffffff'},

textInput:_extends({
marginLeft:12,
padding:0,
color:'#51585e',
fontSize:17,
fontWeight:'300',
backgroundColor:'transparent'},
_reactNative.Platform.select({
web:{
outline:'transparent'}})),




submit:{
width:contentWidth,
height:56,
marginTop:12,
marginBottom:12,
alignSelf:'center',
justifyContent:'center',
alignItems:'center',
backgroundColor:'transparent'},

submitImage:{
position:'absolute',
top:0,left:0,
width:contentWidth,
height:56,
resizeMode:'stretch'},

submitText:{
color:'#ffffff',
fontSize:20,
fontWeight:'bold',
backgroundColor:'transparent',
zIndex:1},

submitting:{
position:'absolute',
top:0,bottom:0,right:12,
justifyContent:'center',
alignItems:'center'},

submittingIndicator:{}});


var mapStateToProps=function mapStateToProps(state){
return{
credential:state.user.credential};

};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{
updateCredential:function updateCredential(credential){return dispatch((0,_user.updateCredential)(credential));}};

};exports.default=

(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(
UpdatePasswordScreen);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);











var _reactRedux=__webpack_require__(28);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);

var _modules=__webpack_require__(19);

var _user=__webpack_require__(111);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);
var _AlertUtils=__webpack_require__(62);var _AlertUtils2=_interopRequireDefault(_AlertUtils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var contentWidth=Math.min(_reactNative.Dimensions.get('window').width-40,300);var

UpdatePromoCodeScreen=(_temp=_class=function(_Component){_inherits(UpdatePromoCodeScreen,_Component);









function UpdatePromoCodeScreen(props){var _this2=this;_classCallCheck(this,UpdatePromoCodeScreen);var _this=_possibleConstructorReturn(this,(UpdatePromoCodeScreen.__proto__||Object.getPrototypeOf(UpdatePromoCodeScreen)).call(this,
props));_this.

























_submit=function _callee(){var submitting,user,promoCode,errorMessage,textInputRef,data,_ref,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:
submitting=_this.state.submitting;if(!
submitting){_context.next=3;break;}return _context.abrupt('return');case 3:



user=_this.props.user;
promoCode=_this.state.promoCode;
errorMessage=void 0,textInputRef=void 0;
if(_lodash2.default.isEmpty(promoCode)){
errorMessage='Vui lòng nhập mã giới thiệu mới';
textInputRef='promoCodeTextInput';
}else if(promoCode===user.info.promoCode){
errorMessage='Vui lòng nhập mã giới thiệu khác với mã giới thiệu hiện tại';
textInputRef='promoCodeTextInput';
}if(!
errorMessage){_context.next=11;break;}
_AlertUtils2.default.alert({
message:errorMessage,
actions:[
{text:'OK',onPress:function onPress(){return _this._focusTextInput(textInputRef);}}]});


if(_reactNative.Platform.OS==='web'){
_this._focusTextInput(textInputRef);
}return _context.abrupt('return');case 11:



_this.setState({
submitting:true});


data={
promo_code:promoCode};_context.next=15;return regeneratorRuntime.awrap(

_APIClient2.default.PUT('/seller',data));case 15:_ref=_context.sent;response=_ref.response;error=_ref.error;
_this._handleNetworkResponse(promoCode,response,error);case 19:case'end':return _context.stop();}}},null,_this2);};_this.state={promoCode:''};return _this;}_createClass(UpdatePromoCodeScreen,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'_updateInputValue',value:function _updateInputValue(name,value){this.setState(_defineProperty({},name,value));}},{key:'_focusTextInput',value:function _focusTextInput(name){var textInput=this.refs[name];if(textInput){textInput.focus();}}},{key:'_handleNetworkResponse',value:function _handleNetworkResponse(


promoCode,response,error){var _this3=this;







this.setState({
submitting:false});


if(response&&response.response){
this.props.updatePromoCode(_lodash2.default.toUpper(promoCode));
var message='Cập nhật mã giới thiệu thành công';
if(_reactNative.Platform.OS==='web'){
alert(message);
}else{
_reactNative.Alert.alert(
global.__APP_NAME__,
message,
[
{text:'OK',onPress:function onPress(){return _this3.props.navigation.goBack();}}]);


}
}else{
var _message=_Utils2.default.parseErrorMessage(response,error,
'Cập nhật mã giới thiệu không thành công, vui lòng thử lại sau');
if(_reactNative.Platform.OS==='web'){
alert(_message);
}else{
_reactNative.Alert.alert(
global.__APP_NAME__,
_message);

}
}
}},{key:'render',value:function render()

{var _this4=this;var
user=this.props.user;var _state=
this.state,promoCode=_state.promoCode,submitting=_state.submitting;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
_react2.default.createElement(_modules.KeyboardAwareScrollView,{
automaticallyAdjustContentInsets:false,
keyboardDismissMode:_reactNative.Platform.OS==='ios'?'on-drag':'none',
keyboardShouldPersistTaps:'never',
containerContentStyle:styles.contentContainer,
style:styles.content},

_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'M\xE3 gi\u1EDBi thi\u1EC7u hi\u1EC7n t\u1EA1i'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'currentPromoCodeTextInput',
value:_lodash2.default.isEmpty(user.info.promoCode)?'':user.info.promoCode,
placeholder:'M\xE3 gi\u1EDBi thi\u1EC7u hi\u1EC7n t\u1EA1i',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
returnKeyType:'next',
editable:false,
style:styles.textInput,
onSubmitEditing:function onSubmitEditing(){return _this4._focusTextInput(
'promoCodeTextInput');}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'M\xE3 gi\u1EDBi thi\u1EC7u m\u1EDBi'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'promoCodeTextInput',
value:promoCode,
placeholder:'M\xE3 gi\u1EDBi thi\u1EC7u m\u1EDBi',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
autoCapitalize:'characters',
returnKeyType:'send',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this4._updateInputValue('promoCode',text);},
onSubmitEditing:function onSubmitEditing(){return _this4._submit();}})),


_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
style:styles.submit,
onPress:function onPress(){return _this4._submit();}},
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.submitImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.submitText},'C\u1EACP NH\u1EACT M\xC3 GI\u1EDAI THI\u1EC6U'),


submitting&&_react2.default.createElement(_reactNative.View,{
style:styles.submitting},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#ffffff',
style:styles.submittingIndicator}))))));






}}]);return UpdatePromoCodeScreen;}(_react.Component),_class.navigationOptions=function(_ref2){var navigation=_ref2.navigation;var params=navigation.state.params;return{headerBackTitle:null,headerTitle:'Đổi mã giới thiệu'};},_temp);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},

content:{
flex:1},

contentContainer:{},

inputTitleText:{
width:contentWidth,
marginTop:16,
alignSelf:'center',
color:'#000000',
fontSize:16,
fontWeight:'300',
backgroundColor:'transparent'},

input:{
width:contentWidth,
height:44,
marginTop:5,
alignSelf:'center',
justifyContent:'center',
borderRadius:16,
borderWidth:1,
borderColor:'#e2d7ba',
backgroundColor:'#ffffff'},

textInput:_extends({
marginLeft:12,
padding:0,
color:'#51585e',
fontSize:17,
fontWeight:'300',
backgroundColor:'transparent'},
_reactNative.Platform.select({
web:{
outline:'transparent'}})),




submit:{
width:contentWidth,
height:56,
marginTop:12,
marginBottom:12,
alignSelf:'center',
justifyContent:'center',
alignItems:'center',
backgroundColor:'transparent'},

submitImage:{
position:'absolute',
top:0,left:0,
width:contentWidth,
height:56,
resizeMode:'stretch'},

submitText:{
color:'#ffffff',
fontSize:20,
fontWeight:'bold',
backgroundColor:'transparent',
zIndex:1},

submitting:{
position:'absolute',
top:0,bottom:0,right:12,
justifyContent:'center',
alignItems:'center'},

submittingIndicator:{}});


var mapStateToProps=function mapStateToProps(state){
return{
user:state.user};

};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{
updatePromoCode:function updatePromoCode(promoCode){return dispatch((0,_user.updatePromoCode)(promoCode));}};

};exports.default=

(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(
UpdatePromoCodeScreen);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);








var _reactRedux=__webpack_require__(28);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);

var _modules=__webpack_require__(19);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);
var _UserUtils=__webpack_require__(66);var _UserUtils2=_interopRequireDefault(_UserUtils);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);
var _FilterList=__webpack_require__(986);var _FilterList2=_interopRequireDefault(_FilterList);
var _Empty=__webpack_require__(98);var _Empty2=_interopRequireDefault(_Empty);
var _SearchInput=__webpack_require__(142);var _SearchInput2=_interopRequireDefault(_SearchInput);
var _Icon=__webpack_require__(85);var _Icon2=_interopRequireDefault(_Icon);
var _FilterUtils=__webpack_require__(987);var _FilterUtils2=_interopRequireDefault(_FilterUtils);
var _OrderHeader=__webpack_require__(224);var _OrderHeader2=_interopRequireDefault(_OrderHeader);
var _OrderItem=__webpack_require__(225);var _OrderItem2=_interopRequireDefault(_OrderItem);
var _UserManager=__webpack_require__(112);var _UserManager2=_interopRequireDefault(_UserManager);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

OrderListScreen=(_temp=_class=function(_Component){_inherits(OrderListScreen,_Component);





























function OrderListScreen(props){_classCallCheck(this,OrderListScreen);var _this=_possibleConstructorReturn(this,(OrderListScreen.__proto__||Object.getPrototypeOf(OrderListScreen)).call(this,
props));_initialiseProps.call(_this);var

user=_this.props.user;
var isAdmin=_UserUtils2.default.isAdmin(user);
var isSeller=_UserUtils2.default.isSeller(user);

_this._filter=_FilterList.filterItemList[0];
_this._query='';
_this._page=-1;
_this._loading=false;
var items=[];
_this.state={
isAdmin:isAdmin,
isSeller:isSeller,
filter:_this._filter,
query:_this._query,
refreshing:false,
showingFilterList:false,
items:items,
noitem:false};return _this;

}_createClass(OrderListScreen,[{key:'componentDidMount',value:function componentDidMount()

{var _this2=this;
if(_reactNative.Platform.OS==='web'){
if(this.props.location.state!==null&&this.props.location.state!==
undefined){
this._filter=this.props.location.state.filter;
this._query=this.props.location.state.query;
this.setState({
filter:this.props.location.state.filter,
query:this.props.location.state.query});

}
}else{var _props=
this.props,navigation=_props.navigation,user=_props.user;

var isAdmin=_UserUtils2.default.isAdmin(user);var
query=this.state.query;
navigation.setParams({
isAdmin:isAdmin,
query:query,
updateQuery:this._updateQuery,
search:this._search});

}

_reactNative.InteractionManager.runAfterInteractions(function(){
_this2._refreshData(false);
});
}},{key:'componentWillUnmount',value:function componentWillUnmount()

{
}},{key:'_resetData',value:function _resetData(


























































































refreshing){
this._loading=false;
this._page=1;
var items=[];
this.setState({
revenue:null,
refreshing:refreshing,
items:items,
noitem:false});

}},{key:'_handleRevenueNetworkResponse',value:function _handleRevenueNetworkResponse(








response,error){







if(response){
this.setState({
revenue:response.response});

}
}},{key:'_handleNetworkResponse',value:function _handleNetworkResponse(



























response,error){var _state=







this.state,items=_state.items,noitem=_state.noitem;
if(response&&response.response){
var newItems=response.response;
if(newItems.length>0){
items=items.concat(newItems);
this._page++;
this.setState({
items:items});

}else{
this._page=-1;
}
noitem=items.length===0;
}else{
noitem=_lodash2.default.isEmpty(items);
}

this._loading=false;
this.setState({
refreshing:false,
noitem:noitem});

}},{key:'render',value:function render()








































{var _this3=this;var _state2=
this.state,isAdmin=_state2.isAdmin,isSeller=_state2.isSeller,filter=_state2.filter,refreshing=_state2.refreshing,revenue=_state2.revenue,items=_state2.items,noitem=_state2.noitem,showingFilterList=_state2.showingFilterList,query=_state2.query;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},

_reactNative.Platform.OS==='web'&&_react2.default.createElement(_SearchInput2.default,{
placeholder:'ID / Emai / s\u1ED1 \u0111i\u1EC7n tho\u1EA1i kh\xE1ch h\xE0ng',
query:query,
onUpdateQuery:this._updateQuery,
onSubmit:this._search}),

_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
onPress:this._openFilterList,
style:styles.filter},
_react2.default.createElement(_reactNative.Text,{
style:styles.filterTitleText},'B\u1ED9 l\u1ECDc'),


_react2.default.createElement(_reactNative.Text,{
style:styles.filterValueText},
filter.title),

_reactNative.Platform.OS!=='web'&&_react2.default.createElement(_modules.FontAwesomeIcon,{
name:'arrow-right',
size:16,
color:'#ffffff',
style:styles.filterArrowIcon})),


(isAdmin||isSeller)&&_react2.default.createElement(_reactNative.View,{
style:styles.revenue},
_react2.default.createElement(_reactNative.Text,{
style:styles.revenueText},
_Utils2.default.priceToString(revenue))),



_react2.default.createElement(_OrderHeader2.default,{
simple:!_UserManager2.default.getInstance().isAdmin()}),

_react2.default.createElement(_reactNative.FlatList,{
refreshing:refreshing,
extraData:this.state,
data:items,
keyExtractor:this._keyExtractor,
onRefresh:this._onRefresh,
onEndReached:this._onEndReached,
onEndReachedThreshold:0.5,
renderItem:this._renderItem,
style:styles.list}),

noitem&&_react2.default.createElement(_Empty2.default,{
text:'Kh\xF4ng c\xF3 \u0111\u01A1n h\xE0ng, b\u1EA5m \u0111\u1EC3 th\u1EED l\u1EA1i',
onClick:function onClick(){return _this3._refreshData(false);},
style:styles.empty}),

_reactNative.Platform.OS!=='web'&&_react2.default.createElement(_modules.Modal,{
animationType:'fade',
transparent:true,
visible:showingFilterList,
onRequestClose:this._closeFilterList},
_react2.default.createElement(_FilterList2.default,{
filter:filter,
onClose:this._closeFilterList,
onSelectFilter:this._updateFilter})),


_reactNative.Platform.OS==='web'&&_react2.default.createElement(_modules.Modal,{
isOpen:showingFilterList,
onRequestClose:this._closeFilterList,
style:webModalStyles},
_react2.default.createElement(_FilterList2.default,{
filter:filter,
onClose:this._closeFilterList,
onSelectFilter:this._updateFilter}))));



}}]);return OrderListScreen;}(_react.Component),_class.navigationOptions=function(_ref){var navigation=_ref.navigation;var _navigation$state=navigation.state,routes=_navigation$state.routes,params=_navigation$state.params;var _ref2=params?params:{},query=_ref2.query,isAdmin=_ref2.isAdmin,updateQuery=_ref2.updateQuery,search=_ref2.search;return{tabBarIcon:function tabBarIcon(_ref3){var focused=_ref3.focused,tintColor=_ref3.tintColor;return _react2.default.createElement(_Icon2.default,{type:'FontAwesome',name:'home',size:30,color:tintColor});},tabBarVisible:!routes||routes.length<=1,headerBackTitle:null,headerTitle:_react2.default.createElement(_SearchInput2.default,{placeholder:'ID / Emai / s\u1ED1 \u0111i\u1EC7n tho\u1EA1i kh\xE1ch h\xE0ng',query:query,onUpdateQuery:updateQuery,onSubmit:search}),headerLeft:null,headerRight:null};},_initialiseProps=function _initialiseProps(){var _this4=this;this.componentWillReceiveProps=function(nextProps){if(_reactNative.Platform.OS==='web'){if(nextProps.location.state!==null&&nextProps.location.state!==undefined){var _nextProps$location$s=nextProps.location.state,query=_nextProps$location$s.query,filter=_nextProps$location$s.filter;_this4._filter=filter;_this4._query=query;_this4.setState({filter:filter,query:query});}_this4._refreshData(false);}};this._updateFilter=function(filter){_this4._closeFilterList();if(_this4.state.filter==filter){return;}_this4._filter=filter;_this4.setState({filter:filter});if(_reactNative.Platform.OS==='web'){_this4.props.history.push({pathname:'/',state:{query:_this4._query,filter:_this4._filter}});}else _this4._refreshData(false);};this._updateQuery=function(query){if(_this4._query===query){return;}_this4._query=query;_this4.setState({query:query});if(_reactNative.Platform.OS!=='web'){_this4.props.navigation.setParams({query:query});}};this._search=function(){_this4._loading=false;_this4._page=1;_this4.setState({refreshing:false,items:[]});if(_reactNative.Platform.OS==='web'){_this4.props.history.push({pathname:'/',state:{query:_this4._query,filter:_this4._filter}});}else _this4._loadData();};this._refreshData=function(refreshing){if(_this4._loading){return;}_this4._resetData(refreshing);_this4._loadData();var _state3=_this4.state,isAdmin=_state3.isAdmin,isSeller=_state3.isSeller;if(isAdmin||isSeller){_this4._loadRevenue();}};this._loadRevenue=function _callee(){var params,_ref4,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:params=_FilterUtils2.default.parseTime(_this4._filter.key);_context.next=3;return regeneratorRuntime.awrap(_APIClient2.default.GET('/user/revenue',params));case 3:_ref4=_context.sent;response=_ref4.response;error=_ref4.error;_this4._handleRevenueNetworkResponse(response,error);case 7:case'end':return _context.stop();}}},null,_this4);};this._loadData=function _callee2(){var time,params,_ref5,response,error;return regeneratorRuntime.async(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!(_this4._loading||_this4._page<=0)){_context2.next=2;break;}return _context2.abrupt('return');case 2:_this4._loading=true;time=_FilterUtils2.default.parseTime(_this4._filter.key);params=_extends({},time,{page:_this4._page,limit:30});if(!_lodash2.default.isEmpty(_this4._query)){params.query=_this4._query;}if(_this4._filter.key.startsWith('@')){params.query=params.query===undefined||params.query===null?_this4._filter.key.trim():(params.query+' '+_this4._filter.key).trim();}_context2.next=9;return regeneratorRuntime.awrap(_APIClient2.default.GET('/orders',params));case 9:_ref5=_context2.sent;response=_ref5.response;error=_ref5.error;_this4._handleNetworkResponse(response,error);case 13:case'end':return _context2.stop();}}},null,_this4);};this._openFilterList=function(){_this4.setState({showingFilterList:true});};this._closeFilterList=function(){_this4.setState({showingFilterList:false});};this._keyExtractor=function(item){return''+item.id;};this._onRefresh=function(){return _this4._refreshData(true);};this._onEndReached=function(){return _this4._loadData();};this._renderItem=function(_ref6){var item=_ref6.item,index=_ref6.index;return _react2.default.createElement(_OrderItem2.default,{simple:!_UserManager2.default.getInstance().isAdmin(),data:item,onClick:_this4._handleClickItem});};this._handleClickItem=function(item){if(_reactNative.Platform.OS==='web'){var path='/order/'+item.id;_this4.props.history.push(path);}else{var navigation=_this4.props.navigation;navigation.navigate('Order',{id:item.id});}};},_temp);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},


filter:{
height:44,
flexDirection:'row',
alignItems:'center',
backgroundColor:'#6b7adc'},

filterTitleText:{
flex:1,
marginLeft:10,
color:'#ffffff',
fontSize:17,
fontWeight:'100',
backgroundColor:'transparent'},

filterValueText:{
marginRight:10,
color:'#ffffff',
fontSize:17,
fontWeight:'300',
backgroundColor:'transparent'},

filterArrowIcon:{
marginRight:10},


revenue:{
height:64,
justifyContent:'center',
alignItems:'center'},

revenueText:{
color:'#ff4f4f',
fontSize:32,
fontWeight:'bold',
backgroundColor:'transparent'},


list:{
flex:1},


empty:_extends({},
_reactNative.Platform.select({
web:{
top:100},

ios:{
top:44},

android:{
top:44}}))});





var webModalStyles={
content:{
top:'50%',
left:'50%',
right:'auto',
bottom:'auto',
marginRight:'-50%',
transform:'translate(-50%, -50%)'}};



var mapStateToProps=function mapStateToProps(state){
return{
user:state.user};

};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{};
};exports.default=

(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(OrderListScreen);

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.filterItemList=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);









var _Icon=__webpack_require__(85);var _Icon2=_interopRequireDefault(_Icon);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var filterItemList=exports.filterItemList=[
{
key:'today',
title:'Hôm nay'},

{
key:'yesterday',
title:'Hôm qua'},

{
key:'this-week',
title:'Tuần này'},

{
key:'this-month',
title:'Tháng này'},

{
key:'all',
title:'Tất cả'},

{
key:'@cod',
title:'COD'},

{
key:'@confirmed',
title:'Đã chốt'},

{
key:'@placed',
title:'Đặt hàng'},

{
key:'@shipping',
title:'Đang vận chuyển'}];var



FilterList=function(_Component){_inherits(FilterList,_Component);

function FilterList(props){_classCallCheck(this,FilterList);var _this=_possibleConstructorReturn(this,(FilterList.__proto__||Object.getPrototypeOf(FilterList)).call(this,
props));_this.















_renderItem=function(_ref){var item=_ref.item,index=_ref.index;
var selected=item==_this.state.filter;
return(
_react2.default.createElement(FilterItem,{
item:item,
selected:selected,
onClick:_this._handleClickItem}));

};_this.

_handleClickItem=function(item){var
onSelectFilter=_this.props.onSelectFilter;
if(onSelectFilter){
onSelectFilter(item);
}
};var filter=_this.props.filter;_this.state={filter:filter};return _this;}_createClass(FilterList,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.state.filter!==nextProps.filter){this.setState({filter:nextProps.filter});}}},{key:'_close',value:function _close()

{var
onClose=this.props.onClose;
if(onClose){
onClose();
}
}},{key:'render',value:function render()

{var _this2=this;var
dataProvider=this.state.dataProvider;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
_react2.default.createElement(_reactNative.View,{
style:styles.content},
_react2.default.createElement(_reactNative.View,{
style:styles.title},
_react2.default.createElement(_reactNative.Text,{
style:styles.titleText},'B\u1ED9 l\u1ECDc'),


_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
style:styles.close,
onPress:function onPress(){return _this2._close();}},
_react2.default.createElement(_reactNative.Text,{
style:styles.closeText},'\u0110\xF3ng'))),




_react2.default.createElement(_reactNative.FlatList,{
extraData:this.state,
data:filterItemList,
renderItem:this._renderItem,
style:styles.list}))));



}}]);return FilterList;}(_react.Component);var


FilterItem=function(_React$PureComponent){_inherits(FilterItem,_React$PureComponent);function FilterItem(){var _ref2;var _temp,_this3,_ret;_classCallCheck(this,FilterItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this3=_possibleConstructorReturn(this,(_ref2=FilterItem.__proto__||Object.getPrototypeOf(FilterItem)).call.apply(_ref2,[this].concat(args))),_this3),_this3.

_handleClick=function(){var _this3$props=
_this3.props,item=_this3$props.item,onClick=_this3$props.onClick;
if(onClick){
onClick(item);
}
},_temp),_possibleConstructorReturn(_this3,_ret);}_createClass(FilterItem,[{key:'render',value:function render()

{var _props=
this.props,item=_props.item,selected=_props.selected;
return(
_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
style:styles.item,
onPress:this._handleClick},
_react2.default.createElement(_reactNative.Text,{
style:[
styles.itemText,{
color:selected?'#6b7adc':'#000000'}]},

item.title),

selected&&_react2.default.createElement(_Icon2.default,{
type:'FontAwesome',
name:'check',
color:'#6b7adc',
size:16,
style:styles.itemIcon}),
_react2.default.createElement(_reactNative.View,{
style:styles.itemDivider})));


}}]);return FilterItem;}(_react2.default.PureComponent);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#000000bf',
justifyContent:'center',
alignItems:'center'},

content:{
width:_reactNative.Dimensions.get('window').width*3/4,
height:_reactNative.Dimensions.get('window').height*2/3,
backgroundColor:'#ffffff'},

title:{
height:44,
justifyContent:'center',
alignItems:'center',
backgroundColor:'#1c9938'},

titleText:{
color:'#ffffff',
fontSize:17,
fontWeight:'300',
backgroundColor:'transparent'},

close:{
position:'absolute',
top:0,right:10,bottom:0,
flexDirection:'row',
alignItems:'center'},

closeText:{
color:'#ffffff',
fontSize:14,
fontWeight:'300',
backgroundColor:'transparent'},

list:{
flex:1,
backgroundColor:'#ffffff'},

item:{
height:44,
flexDirection:'row',
alignItems:'center'},

itemText:{
flex:1,
marginLeft:8,
marginRight:8,
fontSize:15,
fontWeight:'300',
backgroundColor:'transparent'},

itemIcon:{
marginRight:8},

itemDivider:{
position:'absolute',
left:0,bottom:0,right:0,
height:1/_reactNative.PixelRatio.get(),
backgroundColor:'#e0e0e0'}});exports.default=



FilterList;

/***/ }),
/* 987 */
/***/ (function(module, exports) {

Object.defineProperty(exports,"__esModule",{value:true});var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var FilterUtils=(_temp=_class=function FilterUtils(){_classCallCheck(this,FilterUtils);},_class.






parseTime=function(id){
var now=new Date();
var from=void 0,to=void 0;
from=to=0;
if(id==='today'){
var fromString=now.getFullYear()+'-'+FilterUtils.formatMonth(
now.getMonth())+'-'+FilterUtils.formatDate(
now.getDate())+'T00:00:00+07:00';
from=Date.parse(fromString);
}else if(id==='yesterday'){
var _toString=now.getFullYear()+'-'+FilterUtils.formatMonth(
now.getMonth())+'-'+FilterUtils.formatDate(
now.getDate())+'T00:00:00+07:00';

to=Date.parse(_toString);
from=to-24*60*60*1000;
}else if(id==='this-week'){
var _fromString=now.getFullYear()+'-'+FilterUtils.formatMonth(
now.getMonth())+'-'+FilterUtils.formatDate(
now.getDate())+'T00:00:00+07:00';

from=Date.parse(_fromString);

var day=now.getDay();
day=day===6?day:day-1;
from-=day*24*60*60*1000;
}else if(id==='this-month'){
var _fromString2=now.getFullYear()+'-'+FilterUtils.formatMonth(
now.getMonth())+'-'+FilterUtils.formatDate(
now.getDate())+'T00:00:00+07:00';

from=Date.parse(_fromString2);

from-=(now.getDate()-1)*24*60*60*1000;
}else{

}

var time={};
if(from>0){
time.from=from;
}
if(to>0){
time.to=to;
}
return time;
},_class.




formatMonth=function(month){
month+=1;
return month<10?'0'+month:''+month;
},_class.




formatDate=function(date){
return date<10?'0'+date:''+date;
},_temp);exports.default=FilterUtils;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);














var _reactRedux=__webpack_require__(28);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);

var _modules=__webpack_require__(19);
var _Constants=__webpack_require__(368);var _Constants2=_interopRequireDefault(_Constants);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);
var _UserUtils=__webpack_require__(66);var _UserUtils2=_interopRequireDefault(_UserUtils);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);
var _LoadingIndicator=__webpack_require__(99);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);
var _AlertUtils=__webpack_require__(62);var _AlertUtils2=_interopRequireDefault(_AlertUtils);
var _PhoneUtils=__webpack_require__(989);var _PhoneUtils2=_interopRequireDefault(_PhoneUtils);
var _DeviceUtils=__webpack_require__(990);var _DeviceUtils2=_interopRequireDefault(_DeviceUtils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var contentWidth=Math.min(_reactNative.Dimensions.get('window').width-40,300);
var TOAST_REF='toast';var

OrderScreen=(_temp=_class=function(_Component){_inherits(OrderScreen,_Component);









function OrderScreen(props){_classCallCheck(this,OrderScreen);var _this=_possibleConstructorReturn(this,(OrderScreen.__proto__||Object.getPrototypeOf(OrderScreen)).call(this,
props));_initialiseProps.call(_this);

_this.state={
loading:false,
canEdit:false,
logs:[],
log:''};


var id=void 0;
if(_reactNative.Platform.OS==='web'){
id=_this.props.match.params.id;
}else{var
params=_this.props.navigation.state.params;
id=params?params.data?params.data.id:params.id:null;
}
_this._id=id;return _this;
}_createClass(OrderScreen,[{key:'componentDidMount',value:function componentDidMount()

{var _this2=this;
if(_reactNative.Platform.OS==='web'){
this._loadData();
}else{var
params=this.props.navigation.state.params;
if(params&&params.data){
this._updateData(params.data);
}else{
_reactNative.InteractionManager.runAfterInteractions(function(){
_this2._loadOrder();
});
}
_reactNative.InteractionManager.runAfterInteractions(function(){
_this2._loadLogs();
});
}
}},{key:'componentWillUnmount',value:function componentWillUnmount()

{
}},{key:'_openUrl',value:function _openUrl(
















































































































































































































































































































































































































url){
console.log('open url: '+url);
_reactNative.Linking.openURL(url).catch(function(error){return console.log('error: ',error);});
}},{key:'render',value:function render()




















































































































































































































































































































































































































{var _this3=this;var _state=
this.state,loading=_state.loading,items=_state.items,logs=_state.logs,log=_state.log,canEdit=_state.canEdit,canAddLog=_state.canAddLog,editing=_state.editing,logging=_state.logging;
var actions=[];
if(_reactNative.Platform.OS==='web'){
actions=this._generateActions();
}
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
_react2.default.createElement(_modules.KeyboardAwareScrollView,{
automaticallyAdjustContentInsets:false,
keyboardDismissMode:_reactNative.Platform.OS==='ios'?'on-drag':'none',
keyboardShouldPersistTaps:'always',
style:styles.content},
!_lodash2.default.isEmpty(items)&&_react2.default.createElement(_reactNative.View,{
style:styles.contentContainer},
_react2.default.createElement(_reactNative.View,{
style:styles.info},
items.map(function(item,index){return _this3._renderItem(item,index,true);}),

_reactNative.Platform.OS==='web'&&canEdit&&!_lodash2.default.isEmpty(actions)&&
_react2.default.createElement(_reactNative.View,{
style:styles.actionList},
actions.map(this._renderAction))),


!_lodash2.default.isEmpty(logs)&&_react2.default.createElement(_reactNative.View,{
style:styles.logs},
logs.map(
function(item,index){return _this3._renderItem(item,index,index%3!==
0);}),
canAddLog&&_react2.default.createElement(_reactNative.View,{
style:[
styles.input,{
width:null,
alignSelf:'stretch'}]},

_react2.default.createElement(_reactNative.TextInput,{
ref:'logTextInput',
value:log,
placeholder:'Ghi ch\xFA',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
autoCapitalize:'none',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this3._updateInputValue('log',text);}})),


canAddLog&&_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
onPress:this._addLog,
style:[
styles.actionButton,{
alignSelf:'center'}]},

_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.actionButtonImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.actionButtonText},'TH\xCAM GHI CH\xDA'),


logging&&_react2.default.createElement(_reactNative.View,{
style:styles.actionActivity},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#ffffff',
style:styles.actionActivityIndicator})))))),






_reactNative.Platform.OS!=='web'&&canEdit&&_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
onPress:this._edit,
style:[
styles.actionButton,{
marginTop:20,
marginBottom:20,
alignSelf:'center'}]},

_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.actionButtonImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.actionButtonText},'CH\u1EC8NH S\u1EECA \u0110\u01A0N H\xC0NG'),


editing&&_react2.default.createElement(_reactNative.View,{
style:styles.actionActivity},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#ffffff',
style:styles.actionActivityIndicator}))),



loading&&_react2.default.createElement(_LoadingIndicator2.default,null),

_reactNative.Platform.OS!=='web'&&_react2.default.createElement(_modules.Toast,{
ref:TOAST_REF,
position:'center'})));


}}]);return OrderScreen;}(_react.Component),_class.navigationOptions=function(_ref){var navigation=_ref.navigation;var params=navigation.state.params;return{headerBackTitle:null,headerTitle:'Chi tiết đơn hàng'};},_initialiseProps=function _initialiseProps(){var _this4=this;this._updateInputValue=function(name,value){_this4.setState(_defineProperty({},name,value));};this._loadData=function(){_this4._loadOrder();_this4._loadLogs();};this._loadOrder=function _callee(){var loading,path,_ref2,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:loading=_this4.state.loading;if(!loading){_context.next=3;break;}return _context.abrupt('return');case 3:_this4.setState({loading:true});path='/order/'+_this4._id;_context.next=7;return regeneratorRuntime.awrap(_APIClient2.default.GET(path));case 7:_ref2=_context.sent;response=_ref2.response;error=_ref2.error;_this4._handleNetworkResponse(response,error);case 11:case'end':return _context.stop();}}},null,_this4);};this._handleNetworkResponse=function(response,error){if(response&&response.response){_this4._updateData(response.response);}else{var message='Có lỗi xảy ra, vui lòng thử lại sau';_AlertUtils2.default.alert({message:message});}_this4.setState({loading:false});};this._updateData=function(data){var user=_this4.props.user;var order=data.order,customer=data.customer,seller=data.seller;var items=[];items.push({title:'Đơn hàng',section:true});items.push({title:'ID',value:order.id});if(order.purchase){items.push({title:'Gói mua',value:order.purchase.title.vi});items.push({title:'Giá gói',value:_Utils2.default.priceToString(order.purchase.oldPrice)});}else{items.push({title:'Gói mua',value:order.purchaseId});}items.push({title:'Giá đơn hàng (đã giảm giá)',value:_Utils2.default.priceToString(order.price)});items.push({title:'Phí vận chuyển',value:_Utils2.default.priceToString(order.fee)});items.push({title:'Phương thức thanh toán',value:_Constants2.default.PAYMENT_METHOD_LOOKUP.get(order.paymentMethod)});if(!_lodash2.default.isEmpty(order.activateCode)){items.push({title:'Mã kích hoạt',value:order.activateCode,type:'activateCode',selectable:_reactNative.Platform.OS!=='web'});}if(!_lodash2.default.isEmpty(order.shippingCode)){items.push({title:'Mã vận đơn',value:order.shippingCode,type:'shippingCode',selectable:_reactNative.Platform.OS!=='web'});}items.push({title:'Trạng thái',value:_Constants2.default.STATUS_LOOKUP.get(order.status)});if(_UserUtils2.default.isAdmin(user)){items.push({title:'Hoa hồng',value:_Utils2.default.priceToString(order.totalCommission)});}else{items.push({title:'Hoa hồng',value:_Utils2.default.priceToString(order.commission)});}items.push({title:'Ngày đăng kí',value:order.createdAt>0?_Utils2.default.dateToString(order.createdAt):'N/A'});items.push({title:'Ngày thanh toán',value:order.paidAt>0?_Utils2.default.dateToString(order.paidAt):'N/A'});if(_UserUtils2.default.isAdmin(user)){items.push({title:'Ngày hết hạn',value:order.expiresAt?_Utils2.default.dateToString(order.expiresAt):''});}var devices=order.devices;if(_UserUtils2.default.isAdmin(user)&&!_lodash2.default.isEmpty(devices)){items.push({title:'Danh sách thiết bị',section:true});for(var i=0;i<devices.length;i++){var device=devices[i];var id=device.id,active=device.active;var title=_DeviceUtils2.default.findDeviceName(id);if(active){items.push({title:title,value:'Đang sử dụng',type:'device',selectable:true,data:device});}else{items.push({title:title,value:'Không sử dụng'});}}}if(customer){items.push({title:'Người dùng',section:true});items.push({title:'ID',value:customer.id});items.push({title:'Họ và tên',value:customer.name?customer.name:'N/A'});items.push({title:'Địa chỉ email',value:customer.email?customer.email:'N/A',type:'email',selectable:!_lodash2.default.isEmpty(customer.email)});items.push({title:'Nhà mạng',value:customer.phone?_PhoneUtils2.default.findTelco(customer.phone):'N/A',type:'telco'});items.push({title:'Số điện thoại',value:customer.phone?customer.phone:'N/A',type:'phone',selectable:!_lodash2.default.isEmpty(customer.phone)});items.push({title:'Địa chỉ',value:!_lodash2.default.isEmpty(customer.address)?customer.address:'N/A'});items.push({title:'Ngày đăng kí',value:customer.createdAt>0?_Utils2.default.dateToString(customer.createdAt):'N/A'});}if(seller){items.push({title:'Người bán',section:true});items.push({title:'ID',value:seller.id,type:seller.role,selectable:true});items.push({title:'Họ và tên',value:!_lodash2.default.isEmpty(seller.name)?seller.name:'N/A'});items.push({title:'Địa chỉ email',value:!_lodash2.default.isEmpty(seller.email)?seller.email:'N/A'});items.push({title:'Số điện thoại',value:!_lodash2.default.isEmpty(seller.phone)?seller.phone:'N/A'});items.push({title:'Mã giảm giá',value:!_lodash2.default.isEmpty(seller.promoCode)?seller.promoCode:'N/A'});items.push({title:'Giảm giá',value:seller.saleOff!==undefined?seller.saleOff+'%':'N/A'});}var paymentMethod=order.paymentMethod,status=order.status;var canEdit=_UserUtils2.default.isAdmin(user)&&!_lodash2.default.isNil(data)&&!_lodash2.default.isNil(order);var canAddLog=(_UserUtils2.default.isAdmin(user)||_UserUtils2.default.isSalesman(user))&&!_lodash2.default.isNil(data)&&!_lodash2.default.isNil(order);_this4.setState({data:data,items:items,canEdit:canEdit,canAddLog:canAddLog});};this._loadLogs=function _callee2(){var user,isSeller,path,_ref3,response,error,logs,_iterator,_isArray,_i,_ref4,data,items;return regeneratorRuntime.async(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:user=_this4.props.user;isSeller=_UserUtils2.default.isSeller(user);if(!isSeller){_context2.next=4;break;}return _context2.abrupt('return');case 4:if(!_lodash2.default.isNil(_this4._id)){_context2.next=6;break;}return _context2.abrupt('return');case 6:_this4.setState({logs:[{title:'Lịch sử đơn hàng',section:true}]});path='/logs/order/'+_this4._id;_context2.next=10;return regeneratorRuntime.awrap(_APIClient2.default.GET(path));case 10:_ref3=_context2.sent;response=_ref3.response;error=_ref3.error;if(response){console.log('order logs response: ',response);}if(error){console.warn('order logs error: ',error);}if(!(_lodash2.default.isNil(response)||_lodash2.default.isEmpty(response.response))){_context2.next=17;break;}return _context2.abrupt('return');case 17:logs=_this4.state.logs;_iterator=response.response,_isArray=Array.isArray(_iterator),_i=0,_iterator=_isArray?_iterator:_iterator[typeof Symbol==='function'?typeof Symbol==='function'?Symbol.iterator:'@@iterator':'@@iterator']();case 19:if(!_isArray){_context2.next=25;break;}if(!(_i>=_iterator.length)){_context2.next=22;break;}return _context2.abrupt('break',34);case 22:_ref4=_iterator[_i++];_context2.next=29;break;case 25:_i=_iterator.next();if(!_i.done){_context2.next=28;break;}return _context2.abrupt('break',34);case 28:_ref4=_i.value;case 29:data=_ref4;items=_this4._parseLog(data);logs=logs.concat(items);case 32:_context2.next=19;break;case 34:_this4.setState({logs:logs});case 35:case'end':return _context2.stop();}}},null,_this4);};this._parseLog=function(data){var items=[];var username=data.username,content=data.content,updatedAt=data.updatedAt;items.push({title:'Người tạo',value:username});items.push({title:'Nội dung',value:content});items.push({title:'Thời gian',value:_Utils2.default.dateToString(updatedAt)});return items;};this._renderItem=function(item,index,dividerHidden){var section=item.section,title=item.title,value=item.value,selectable=item.selectable;selectable=selectable||_reactNative.Platform.OS!=='web';return _react2.default.createElement(_reactNative.View,{key:index,style:[styles.item,{paddingTop:section?20:8,paddingBottom:section?0:8}]},_react2.default.createElement(_reactNative.Text,{style:section?styles.itemSectionText:styles.itemTitleText},title),!section&&_react2.default.createElement(_reactNative.Text,{onPress:function onPress(){return _this4._handleClickItem(item);},style:[styles.itemValueText,{color:selectable?'#0000ff':'#6b7adc',textDecorationLine:selectable?'underline':'none'}]},value),!section&&!dividerHidden&&_react2.default.createElement(_reactNative.View,{style:styles.itemDivider}));};this._handleClickItem=function(item){var title=item.title,type=item.type,value=item.value,data=item.data;if(type==='agency'){_this4._openAgency(value);}else if(type==='partner'){_this4._openPartner(value);}else if(type==='email'){if(_reactNative.Platform.OS==='web'){var url='mailto:'+value;_this4._openUrl(url);}else{_this4._copyToClipboard(value);}}else if(type==='phone'){if(_reactNative.Platform.OS==='web'){var _url='tel://'+value;_this4._openUrl(_url);}else{_this4._copyToClipboard(value);}}else if(type==='device'){_this4._deactiveDevice(title,data);}else if(type==='shippingCode'){_reactNative.Linking.openURL('https://www.viettelpost.com.vn/Tracking?KEY='+value);}else{_this4._copyToClipboard(value);}};this._copyToClipboard=function(value){if(_reactNative.Platform.OS==='web'){return;}_reactNative.Clipboard.setString(value);var ref=_this4.refs[TOAST_REF];ref.show('Copied',_modules.ToastDuration.LENGTH_SHORT);};this._openAgency=function(id){if(_reactNative.Platform.OS==='web'){var path='/agency/'+id;_this4.props.history.push(path);}else{_this4.props.navigation.navigate('Agency',{id:id});}};this._openPartner=function(id){if(_reactNative.Platform.OS==='web'){var path='/partner/'+id;_this4.props.history.push(path);}else{_this4.props.navigation.navigate('Partner',{id:id});}};this._deactiveDevice=function(title,data){var id=data.id,active=data.active;if(!active){return;}var message='B\u1EA1n c\xF3 ch\u1EAFc l\xE0 mu\u1ED1n b\u1ECF k\xEDch ho\u1EA1t tr\xEAn m\xE1y "'+title+'" n\xE0y';var confirmed=_AlertUtils2.default.confirm({message:message,actions:[{text:'Bỏ qua',style:'cancel'},{text:'Bỏ kích hoạt',onPress:function onPress(){return _this4._doDeactiveDevice(data);}}]});if(confirmed){_this4._doDeactiveDevice(data);}};this._doDeactiveDevice=function _callee3(device){var order,path,_ref5,response,error;return regeneratorRuntime.async(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:order=_this4.state.data.order;path='/device/'+order.id+'/unlink/'+device.id;_context3.next=4;return regeneratorRuntime.awrap(_APIClient2.default.POST(path));case 4:_ref5=_context3.sent;response=_ref5.response;error=_ref5.error;_this4._handleDeactiveDeviceNetworkResponse(device,response,error);case 8:case'end':return _context3.stop();}}},null,_this4);};this._handleDeactiveDeviceNetworkResponse=function(device,response,error){if(response&&response.response&&response.response.status){var items=_this4.state.items;items=items.map(function(item){if(item.type!=='device'||item.data.id!==device.id){return item;}return{title:item.title,value:'Không sử dụng'};});_this4.setState({items:items});_this4._loadLogs();}else{var message=error?error.message:'Bỏ kích hoạt không thành công';if(_reactNative.Platform.OS==='web'){alert(message);}else{_reactNative.Alert.alert(global.__APP_NAME__,message);}}};this._edit=function(){if(_reactNative.Platform.OS==='web'){return;}var user=_this4.props.user;if(!_UserUtils2.default.isAdmin(user)){return;}var editing=_this4.state.editing;if(editing){return;}var actions=_this4._generateActions();actions.push({text:'Bỏ qua',style:'cancel'});_reactNative.Alert.alert(global.__APP_NAME__,'Chỉnh sửa đơn hàng',actions);};this._generateActions=function(){var data=_this4.state.data;if(!data){return[];}var order=data.order;var paymentMethod=order.paymentMethod,status=order.status;var user=_this4.props.user;var actions=[];var canEditOrder=(_UserUtils2.default.isAdmin(user)||_UserUtils2.default.isMarketer(user))&&data&&order&&(status==='placed'||status==='confirmed'||status==='shipping');if(canEditOrder){actions.push({action:'editOrder',text:'Chỉnh sửa đơn hàng',onPress:_this4._editOrder});}var canConfirmOrder=_UserUtils2.default.isAdmin(user)&&data&&order&&paymentMethod==='cod'&&status==='placed';if(canConfirmOrder){actions.push({action:'confirm',text:'Chốt đơn',onPress:function onPress(){return _this4._makeAction({action:'confirm',text:'Chốt đơn hàng',message:'Bạn thực sự có muốn chốt đơn hàng này?',success:'Chốt đơn thành công',failure:'Chốt đơn không thành công'});}});}var canActivateOrder=_UserUtils2.default.isAdmin(user)&&data&&order&&(paymentMethod==='bank'&&status==='placed'||paymentMethod==='cod'&&status==='shipping');if(canActivateOrder){actions.push({action:'activate',text:'Kích hoạt đơn hàng',onPress:function onPress(){return _this4._makeAction({action:'activate',text:'Kích hoạt đơn hàng',message:'Bạn thực sự có muốn kích hoạt đơn hàng này?',success:'Kích hoạt thành công',failure:'Kích hoạt không thành công'});}});actions.push({action:'give',text:'Tặng quà',onPress:function onPress(){return _this4._makeAction({action:'give',text:'Tặng quà',message:'Bạn thực sự có muốn kích hoạt đơn hàng này như là quà tặng?',success:'Tặng quà thành công',failure:'Tặng quà không thành công'});}});}var canShip=_UserUtils2.default.isAdmin(user)&&data&&order&&paymentMethod==='cod'&&(status==='placed'||status==='confirmed');if(canShip){actions.push({action:'ship',text:'Sinh mã kích hoạt',onPress:function onPress(){return _this4._makeAction({action:'ship',text:'Sinh mã kích hoạt',message:'Bạn thực sự có muốn sinh mã kích hoạt cho đơn hàng COD này?',success:'Sinh mã kích hoạt thành công',failure:'Sinh mã kích hoạt không thành công'});}});}var canCancel=_UserUtils2.default.isAdmin(user)&&data&&order&&(status==='placed'||status==='shipping');if(canCancel){actions.push({action:'cancel',text:'Huỷ đơn hàng',onPress:function onPress(){return _this4._makeAction({action:'cancel',text:'Huỷ đơn hàng',message:'Bạn thực sự có muốn huỷ đơn hàng này?',success:'Huỷ đơn hàng thành công',failure:'Huỷ đơn hàng không thành công'});}});}var canRestore=_UserUtils2.default.isAdmin(user)&&data&&order&&status==='cancel';if(canRestore){actions.push({action:'Khôi phục đơn hàng',onPress:function onPress(){return _this4._makeAction({action:'restore',message:'Bạn thực sự có muốn khôi phục đơn hàng này?',success:'Khôi phục đơn hàng thành công',failure:'Khôi phục đơn hàng không thành công'});}});}var canSendEmail=_UserUtils2.default.isAdmin(user)&&data&&order&&status!=='shipping'&&status!=='cancel';if(canSendEmail){actions.push({action:'sendEmail',text:'Gửi lại email',onPress:function onPress(){return _this4._makeAction({action:'sendEmail',text:'Gửi lại email',message:'Bạn thực sự có muốn gửi lại email cho khách hàng?',success:'Gửi email cho khách thành công',failure:'Gửi email cho khách không thành công'});}});}return actions;};this._editOrder=function(){var data=_this4.state.data;if(!data){return[];}var order=data.order;if(_reactNative.Platform.OS==='web'){var path='/edit-order/'+order.id;_this4.props.history.push(path);}else{_this4.props.navigation.push('EditOrder',{id:order.id});}};this._makeAction=function(data){var editing=_this4.state.editing;if(editing){return;}var text=data.text,message=data.message;var confirm=_AlertUtils2.default.confirm({message:message,actions:[{text:'Bỏ qua',style:'cancel'},{text:text,onPress:function onPress(){return _this4._doMakeAction(data);}}]});if(confirm){_this4._doMakeAction(data);}};this._doMakeAction=function _callee4(data){var action,success,failure,path,_ref6,response,error;return regeneratorRuntime.async(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:action=data.action,success=data.success,failure=data.failure;_this4.setState({editing:true,editingAction:action});path='/order/'+_this4._id+'/'+action;_context4.next=5;return regeneratorRuntime.awrap(_APIClient2.default.POST(path));case 5:_ref6=_context4.sent;response=_ref6.response;error=_ref6.error;_this4._handleActionNetworkResponse(response,error,success,failure);case 9:case'end':return _context4.stop();}}},null,_this4);};this._handleActionNetworkResponse=function(response,error,success,failure){if(response&&response.response){console.log('1');var order=response.response;if(!_lodash2.default.isEmpty(order)&&order.id>0){var data=_this4.state.data;data=_extends({},data,{order:order});_this4._updateData(data);_this4._loadLogs();}_AlertUtils2.default.alert({message:success});}else{var message=_Utils2.default.parseErrorMessage(response,error,failure);_AlertUtils2.default.alert({message:message});}_this4.setState({editing:false,editingAction:''});};this._renderAction=function(data,index){var action=data.action,text=data.text,onPress=data.onPress;var editingAction=_this4.state.editingAction;return _react2.default.createElement(_reactNative.TouchableOpacity,{key:index,activeOpacity:0.75,onPress:onPress,style:styles.actionButton},_react2.default.createElement(_reactNative.Image,{source:__webpack_require__(20),style:styles.actionButtonImage}),_react2.default.createElement(_reactNative.Text,{style:styles.actionButtonText},text),action===editingAction&&_react2.default.createElement(_reactNative.View,{style:styles.actionActivity},_react2.default.createElement(_reactNative.ActivityIndicator,{animating:true,color:'#ffffff',style:styles.actionActivityIndicator})));};this._addLog=function _callee5(){var logging,log,path,data,_ref7,response,error,message,items,logs,_logs;return regeneratorRuntime.async(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:logging=_this4.state.logging;if(!logging){_context5.next=3;break;}return _context5.abrupt('return');case 3:log=_this4.state.log;if(!_lodash2.default.isEmpty(log)){_context5.next=8;break;}_AlertUtils2.default.alert({message:'Vui lòng điền ghi chú',actions:[{text:'OK',onPress:function onPress(){return _this4.refs['logTextInput'].focus();}}]});if(_reactNative.Platform.OS==='web'){_this4.refs['logTextInput'].focus();}return _context5.abrupt('return');case 8:path='/log/order/'+_this4._id;data={content:log};_context5.next=12;return regeneratorRuntime.awrap(_APIClient2.default.POST(path,data));case 12:_ref7=_context5.sent;response=_ref7.response;error=_ref7.error;if(response){console.log('add log response: ',response);}if(error){console.log('add log error: ',error);}if(!(error||_lodash2.default.isNil(response)||_lodash2.default.isEmpty(response.response))){_context5.next=21;break;}message=error?error.message:'Thêm ghi chú thất bại';_AlertUtils2.default.alert({message:message});return _context5.abrupt('return');case 21:items=_this4._parseLog(response.response);logs=_this4.state.logs;if(_lodash2.default.isEmpty(logs)){logs=items;}else{(_logs=logs).splice.apply(_logs,[1,0].concat(_toConsumableArray(items)));logs=logs.slice();}_this4.setState({logs:logs,log:''});case 25:case'end':return _context5.stop();}}},null,_this4);};},_temp);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},

content:{
flex:1,
backgroundColor:'#f6efdb'},

contentContainer:{
flex:1,
flexDirection:_reactNative.Dimensions.get('window').width<600?'column':'row',
backgroundColor:'#f6efdb'},

info:{
flex:1},

logs:{
flex:1,
borderLeftWidth:1,
borderLeftColor:'#f6efdb'},


item:{
flexDirection:'row'},

itemSectionText:{
marginLeft:10,
color:'#000000',
fontSize:17,
fontWeight:'bold',
backgroundColor:'transparent'},

itemTitleText:_extends({
marginLeft:20,
color:'#000000',
fontSize:17,
fontWeight:'100',
backgroundColor:'transparent'},
_reactNative.Platform.select({
ios:{
flex:1},

android:{
flex:1}})),



itemValueText:{
flex:1,
marginLeft:10,
marginRight:10,
color:'#6b7adc',
fontSize:17,
fontWeight:'300',
textAlign:'right',
backgroundColor:'transparent'},

itemDivider:{
position:'absolute',
left:20,bottom:0,right:10,
height:1,
backgroundColor:'#6b7adc'},


input:{
height:44,
marginTop:10,
marginLeft:10,
marginRight:10,
alignSelf:'center',
justifyContent:'center',
borderRadius:16,
borderWidth:1,
borderColor:'#e2d7ba',
backgroundColor:'#ffffff'},

textInput:_extends({
marginLeft:12,
padding:0,
color:'#51585e',
fontSize:17,
fontWeight:'300',
backgroundColor:'transparent'},
_reactNative.Platform.select({
web:{
outline:'transparent'}})),




actionList:{
width:contentWidth,
alignSelf:'center'},

actionButton:{
width:contentWidth,
height:56,
marginTop:10,
justifyContent:'center',
alignItems:'center',
backgroundColor:'transparent'},

actionButtonImage:{
position:'absolute',
top:0,left:0,
width:contentWidth,
height:56,
resizeMode:'stretch'},

actionButtonText:{
color:'#ffffff',
fontSize:20,
fontWeight:'bold',
backgroundColor:'transparent',
zIndex:1},

actionActivity:{
position:'absolute',
top:0,bottom:0,right:12,
justifyContent:'center',
alignItems:'center',
zIndex:2},

actionActivityIndicator:{}});


var mapStateToProps=function mapStateToProps(state){
return{
user:state.user};

};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{};
};exports.default=

(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(OrderScreen);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _class,_temp;var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}

var TELCO_PHONE_LOOKUP=new Map([
[
'Viettel',
[
'0162',
'0163',
'0164',
'0165',
'0166',
'0167',
'0168',
'0169',
'086',
'096',
'097',
'098',
'032',
'033',
'034',
'035',
'036',
'037',
'038',
'039']],

[
'Mobifone',
[
'0120',
'0121',
'0122',
'0126',
'0128',
'090',
'093',
'089',
'070',
'079',
'077',
'076',
'078']],

[
'Vinaphone',
[
'0123',
'0124',
'0125',
'0127',
'0129',
'091',
'094',
'088',
'083',
'084',
'085',
'081',
'082']],

[
'Vietnamobile',
['0186','0188','092','056','058']],

[
'Beeline',
['0199','099','159']]]);var



PhoneUtils=(_temp=_class=function PhoneUtils(){_classCallCheck(this,PhoneUtils);},_class.

findTelco=function(phone){
if(_lodash2.default.isEmpty(phone)){
return;
}

for(var _iterator=TELCO_PHONE_LOOKUP.entries(),_isArray=Array.isArray(_iterator),_i=0,_iterator=_isArray?_iterator:_iterator[typeof Symbol==='function'?Symbol.iterator:'@@iterator']();;){var _ref;if(_isArray){if(_i>=_iterator.length)break;_ref=_iterator[_i++];}else{_i=_iterator.next();if(_i.done)break;_ref=_i.value;}var entry=_ref;
var prefixes=entry[1];
var index=_lodash2.default.findIndex(prefixes,
function(prefix){return _lodash2.default.startsWith(phone,prefix);});
if(index>=0){
return entry[0];
}
}
},_temp);exports.default=PhoneUtils;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _class,_temp;var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);
var _androidDevices=__webpack_require__(991);var _androidDevices2=_interopRequireDefault(_androidDevices);
var _iosDevices=__webpack_require__(992);var _iosDevices2=_interopRequireDefault(_iosDevices);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}

var DEVICE_MODEL_PATTERN=/(android|ios|windows)_(.*)_[a-z0-9]+$/;var

DeviceUtils=(_temp=_class=function DeviceUtils(){_classCallCheck(this,DeviceUtils);},_class.

findDeviceName=function(id){

var match=DEVICE_MODEL_PATTERN.exec(id);

if(match){
var os=match[1];
var model=match[2];

var devices=[];
if(os==='ios'){
devices=_iosDevices2.default;
}else if(os==='android'){
devices=_androidDevices2.default;
}
model=_lodash2.default.replace(model,'_','-');
var device=devices.find(function(item){return item.model===model;});

if(!_lodash2.default.isNil(device)){var
manufacturer=device.manufacturer,codename=device.codename,market_name=device.market_name;
var name=manufacturer;
name=(_lodash2.default.isEmpty(name)?'':name+' ')+market_name;
if(_lodash2.default.isEmpty(name)){
name=codename;
}
return name;
}
}
return id;
},_temp);exports.default=DeviceUtils;

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports = [{"manufacturer":"","market_name":"","codename":"AD681H","model":"Smartfren Andromax AD681H"},{"manufacturer":"","market_name":"","codename":"FJL21","model":"FJL21"},{"manufacturer":"","market_name":"","codename":"hws7721g","model":"MediaPad 7 Youth 2"},{"manufacturer":"10.or","market_name":"D","codename":"10or_D","model":"D"},{"manufacturer":"10.or","market_name":"E","codename":"E","model":"E"},{"manufacturer":"10.or","market_name":"G","codename":"G","model":"G"},{"manufacturer":"3Q","market_name":"OC1020A","codename":"OC1020A","model":"OC1020A"},{"manufacturer":"4good","market_name":"4GOOD Light B100","codename":"4GOOD_Light_B100","model":"Light B100"},{"manufacturer":"4good","market_name":"A103","codename":"4GOOD_Light_A103","model":"Light A103"},{"manufacturer":"7Eleven","market_name":"IN265","codename":"IN265","model":"IN265"},{"manufacturer":"7mobile","market_name":"DRENA","codename":"DRENA","model":"DRENA"},{"manufacturer":"7mobile","market_name":"KAMBA","codename":"KAMBA","model":"KAMBA"},{"manufacturer":"7mobile","market_name":"SWEGUE","codename":"SWEGUE","model":"SWEGUE"},{"manufacturer":"A.O.I. ELECTRONICS FACTORY","market_name":"A.O.I.","codename":"TR10CS1_11","model":"TR10CS1"},{"manufacturer":"AG Mobile","market_name":"AG BOOST 2","codename":"BOOST2","model":"E4010"},{"manufacturer":"AG Mobile","market_name":"AG Flair","codename":"AG_Flair","model":"Flair"},{"manufacturer":"AG Mobile","market_name":"AG Go Tab Access 2","codename":"AG_Go_Tab_Access_2","model":"AG_Go_Tab_Access_2"},{"manufacturer":"AG Mobile","market_name":"AG Ultra2","codename":"AG_Ultra2","model":"Ultra 2"},{"manufacturer":"AG Mobile","market_name":"AG_Go-Tab_Access","codename":"md789hwag","model":"AG Go-Tab Access"},{"manufacturer":"AG Mobile","market_name":"AG_Tab_7_0","codename":"AG_Tab_7_0","model":"AG_Tab_7_0"},{"manufacturer":"AG Mobile","market_name":"Boost","codename":"Boost","model":"Boost"},{"manufacturer":"AG Mobile","market_name":"Chacer","codename":"Chacer","model":"Chacer"},{"manufacturer":"AG Mobile","market_name":"Freedom Access","codename":"Freedom_Access","model":"Freedom Access"},{"manufacturer":"AG Mobile","market_name":"Freedom E","codename":"Freedom_E","model":"Freedom E"},{"manufacturer":"AG Mobile","market_name":"Freedom Plus LTE","codename":"Freedom_Plus_LTE","model":"Freedom Plus LTE"},{"manufacturer":"AG Mobile","market_name":"Ghost","codename":"Ghost","model":"Ghost"},{"manufacturer":"AG Mobile","market_name":"Glow","codename":"Glow","model":"Glow"},{"manufacturer":"AG Mobile","market_name":"HASHTAG","codename":"Hashtag","model":"Hashtag"},{"manufacturer":"AG Mobile","market_name":"Hype","codename":"Hype","model":"Hype"},{"manufacturer":"AG Mobile","market_name":"Neon","codename":"Neon","model":"Neon"},{"manufacturer":"AG Mobile","market_name":"Quest","codename":"Quest","model":"Quest"},{"manufacturer":"AG Mobile","market_name":"Rage","codename":"Rage","model":"Rage"},{"manufacturer":"AG Mobile","market_name":"STYLE PLUS","codename":"STYLE_PLUS","model":"STYLE_PLUS"},{"manufacturer":"AG Mobile","market_name":"Shine","codename":"Shine","model":"Shine"},{"manufacturer":"AG Mobile","market_name":"Status","codename":"Status","model":"Status"},{"manufacturer":"AG Mobile","market_name":"Style","codename":"Style","model":"Style"},{"manufacturer":"AG Mobile","market_name":"Style_2","codename":"Style_2","model":"Style 2"},{"manufacturer":"AG Mobile","market_name":"Swift","codename":"Swift","model":"Swift"},{"manufacturer":"AG Mobile","market_name":"Swift_Plus","codename":"Swift_Plus","model":"Swift_Plus"},{"manufacturer":"AG Mobile","market_name":"ULTRA","codename":"Ultra","model":"Ultra"},{"manufacturer":"AG Mobile","market_name":"Zenith","codename":"Zenith","model":"Zenith"},{"manufacturer":"AG Mobile","market_name":"Zone","codename":"Zone","model":"Zone"},{"manufacturer":"AG Mobile","market_name":"Zoom","codename":"Zoom","model":"Zoom"},{"manufacturer":"AMTC","market_name":"MD1001 Tablet","codename":"MD1001","model":"MD1001"},{"manufacturer":"AMTC","market_name":"MD7008","codename":"MD7008A","model":"MD7008"},{"manufacturer":"AMTC","market_name":"MD7081","codename":"MD7081A","model":"MD7081"},{"manufacturer":"ANEE","market_name":"A1 Neo","codename":"A1_Neo","model":"A1_Neo"},{"manufacturer":"ANS","market_name":"Trailblazer","codename":"rugged-smartphone","model":"H450R"},{"manufacturer":"ANS","market_name":"UL40","codename":"UL40","model":"UL40"},{"manufacturer":"AOC","market_name":"A110_E","codename":"A110_E","model":"A110_E"},{"manufacturer":"AOC","market_name":"A731","codename":"A731-N1","model":"A731-N1"},{"manufacturer":"AOC","market_name":"A731-N2","codename":"A731-N2","model":"A731-N2"},{"manufacturer":"AOC","market_name":"A741","codename":"A741","model":"A741"},{"manufacturer":"AOC","market_name":"A941","codename":"A941","model":"A941"},{"manufacturer":"AOC","market_name":"AOC","codename":"A731","model":"A731"},{"manufacturer":"AOC","market_name":"AOC","codename":"A731-H1","model":"A731-H1"},{"manufacturer":"AOC","market_name":"AOC","codename":"A732G","model":"A732G"},{"manufacturer":"AOC","market_name":"AOC","codename":"AOC_A831L-D","model":"A831L-D"},{"manufacturer":"AOpen","market_name":"\"RK3288 10\"\" Chromebase\"","codename":"tiger_cheets","model":"AOpen Chromebase Mini"},{"manufacturer":"AOpen","market_name":"RK3288 Mini Chromebox","codename":"fievel_cheets","model":"AOpen Chromebox Mini"},{"manufacturer":"ASTCA","market_name":"AA 787 S","codename":"SURGE_AA_787_S","model":"AA 787 S"},{"manufacturer":"AT&T","market_name":"9020A","codename":"tint8_att","model":"9020A"},{"manufacturer":"AURII","market_name":"AURII_AMUSE_4G","codename":"AURII_AMUSE_4G","model":"AURII_AMUSE_4G"},{"manufacturer":"AURII","market_name":"AURII_FAME","codename":"AURII_FAME","model":"AURII_FAME"},{"manufacturer":"AV","market_name":"AV10","codename":"RCT6203W46","model":"AV10"},{"manufacturer":"AV","market_name":"AV7","codename":"RCT6773W22","model":"AV7"},{"manufacturer":"AVH San Luis S.A.","market_name":"ActionKids3.0","codename":"ActionKids3_0","model":"ActionKids3.0"},{"manufacturer":"AVH San Luis S.A.","market_name":"ExcerG5.6","codename":"ExcerG5_6","model":"ExcerG5.6"},{"manufacturer":"AVH San Luis S.A.","market_name":"Vortech3.0","codename":"Vortech3_0","model":"Vortech3.0"},{"manufacturer":"AXXA","market_name":"AXXA S45","codename":"AXXA_S45","model":"AXXA_S45"},{"manufacturer":"AZBox","market_name":"AZDroid","codename":"AZDroid","model":"AZDroid"},{"manufacturer":"AZPEN","market_name":"A720","codename":"wing-inet","model":"A720"},{"manufacturer":"AZPEN","market_name":"A920","codename":"wing-ibt","model":"A920"},{"manufacturer":"Aamra WE","market_name":"E2","codename":"E2","model":"WE E2"},{"manufacturer":"Abocom","market_name":"A08SM","codename":"A08","model":"A08S"},{"manufacturer":"Accent","market_name":"FAST7 3G","codename":"FAST7_3G","model":"FAST7 3G"},{"manufacturer":"Accent","market_name":"Pearl A4 PLUS","codename":"PEARL_A4_PLUS","model":"PEARL A4 PLUS"},{"manufacturer":"Accent","market_name":"Pearl_A4","codename":"Pearl_A4","model":"Pearl A4"},{"manufacturer":"Accent","market_name":"SPEED S8","codename":"SPEED_S8","model":"SPEED_S8"},{"manufacturer":"Acegame S.A.","market_name":"PROTON_JADE_2_PRO","codename":"PROTON_JADE_2_PRO","model":"PROTON_JADE_2_PRO"},{"manufacturer":"Acer","market_name":"","codename":"C6","model":"Acer E320"},{"manufacturer":"Acer","market_name":"","codename":"C6","model":"Acer E320-orange"},{"manufacturer":"Acer","market_name":"","codename":"C7","model":"E330"},{"manufacturer":"Acer","market_name":"","codename":"C8n","model":"E350"},{"manufacturer":"Acer","market_name":"","codename":"K3","model":"E130"},{"manufacturer":"Acer","market_name":"","codename":"T2","model":"AT390"},{"manufacturer":"Acer","market_name":"","codename":"T603T","model":"TD600"},{"manufacturer":"Acer","market_name":"","codename":"a3","model":"Stream"},{"manufacturer":"Acer","market_name":"","codename":"a5","model":"S300"},{"manufacturer":"Acer","market_name":"","codename":"c4","model":"E310"},{"manufacturer":"Acer","market_name":"","codename":"k4","model":"E140"},{"manufacturer":"Acer","market_name":"","codename":"k5","model":"E210"},{"manufacturer":"Acer","market_name":"A1-713","codename":"acer_aprilia","model":"A1-713"},{"manufacturer":"Acer","market_name":"A1-734","codename":"acer_barricade","model":"A1-734"},{"manufacturer":"Acer","market_name":"A1-810","codename":"mango","model":"A1-810"},{"manufacturer":"Acer","market_name":"A1-811","codename":"mango","model":"A1-811"},{"manufacturer":"Acer","market_name":"A1-830","codename":"ducati","model":"A1-830"},{"manufacturer":"Acer","market_name":"A100","codename":"vangogh","model":"A100"},{"manufacturer":"Acer","market_name":"A101","codename":"vangogh","model":"A101"},{"manufacturer":"Acer","market_name":"A110","codename":"a110","model":"A110"},{"manufacturer":"Acer","market_name":"A3-A10","codename":"zara","model":"A3-A10"},{"manufacturer":"Acer","market_name":"A3-A11","codename":"zara","model":"A3-A11"},{"manufacturer":"Acer","market_name":"A3-A20","codename":"acer_harley","model":"A3-A20"},{"manufacturer":"Acer","market_name":"A3-A20FHD","codename":"acer_harleyfhd","model":"A3-A20FHD"},{"manufacturer":"Acer","market_name":"A3-A30","codename":"omega","model":"A3-A30"},{"manufacturer":"Acer","market_name":"A3-A40","codename":"acer_jetfirefhd","model":"A3-A40"},{"manufacturer":"Acer","market_name":"AK330s","codename":"C8n","model":"AK330S"},{"manufacturer":"Acer","market_name":"Acer Chromebook 11 (C740)","codename":"paine_cheets","model":"Acer Chromebook 11 (C740)"},{"manufacturer":"Acer","market_name":"Acer Chromebook R13","codename":"elm_cheets","model":"Acer Chromebook R13 (CB5-312T)"},{"manufacturer":"Acer","market_name":"Acer Holo360","codename":"acer_c01","model":"C01"},{"manufacturer":"Acer","market_name":"Aspire A3","codename":"aa3-600","model":"AA3-600"},{"manufacturer":"Acer","market_name":"B1-710","codename":"B1-710","model":"B1-710"},{"manufacturer":"Acer","market_name":"B1-711","codename":"B1-711","model":"B1-711"},{"manufacturer":"Acer","market_name":"B1-720","codename":"b1-720","model":"b1-720"},{"manufacturer":"Acer","market_name":"B1-721","codename":"b1-721","model":"b1-721"},{"manufacturer":"Acer","market_name":"B1-723","codename":"oban","model":"B1-723"},{"manufacturer":"Acer","market_name":"B1-730","codename":"vespatn","model":"B1-730"},{"manufacturer":"Acer","market_name":"B1-730HD","codename":"vespa","model":"B1-730HD"},{"manufacturer":"Acer","market_name":"B1-733","codename":"acer_barricade_3G","model":"B1-733"},{"manufacturer":"Acer","market_name":"B1-780","codename":"acer_barricadewifi","model":"B1-780"},{"manufacturer":"Acer","market_name":"B1-790","codename":"acer_barricadewifi","model":"B1-790"},{"manufacturer":"Acer","market_name":"B1-820","codename":"citizen","model":"B1-820"},{"manufacturer":"Acer","market_name":"B1-850","codename":"Frenzy","model":"B1-850"},{"manufacturer":"Acer","market_name":"B1-A71","codename":"B1-A71","model":"B1-A71"},{"manufacturer":"Acer","market_name":"B3-A30","codename":"acer_jetfirehd","model":"B3-A30"},{"manufacturer":"Acer","market_name":"B3-A32","codename":"acer_jetfirelte","model":"B3-A32"},{"manufacturer":"Acer","market_name":"B3-A40","codename":"acer_asgard","model":"B3-A40"},{"manufacturer":"Acer","market_name":"B3-A40FHD","codename":"acer_asgardfhd","model":"B3-A40FHD"},{"manufacturer":"Acer","market_name":"C01","codename":"acer_c01","model":"C01"},{"manufacturer":"Acer","market_name":"C01 (PA)","codename":"acer_c01","model":"C01"},{"manufacturer":"Acer","market_name":"CW01","codename":"acer_cw01","model":"CW01"},{"manufacturer":"Acer","market_name":"Chromebook 14 for work","codename":"lars_cheets","model":"Chromebook 14 for work (CP5-471)"},{"manufacturer":"Acer","market_name":"Chromebook 15 (CB3-532)","codename":"banon_cheets","model":"Acer Chromebook 15 (CB3-532)"},{"manufacturer":"Acer","market_name":"Chromebook 15 (CB5-571)","codename":"yuna_cheets","model":"Acer Chromebook 15 (CB5-571)"},{"manufacturer":"Acer","market_name":"Chromebook 15 CB515-1HT/1H","codename":"sand_cheets","model":"Chromebook 15 CB515-1HT/1H"},{"manufacturer":"Acer","market_name":"Chromebook 15 CB515-1HT/1H","codename":"sand_cheets","model":"sand"},{"manufacturer":"Acer","market_name":"Chromebook R11 (C738T)","codename":"cyan_cheets","model":"Acer Chromebook R11"},{"manufacturer":"Acer","market_name":"Chromebook R11 (C738T)","codename":"cyan_cheets","model":"Acer Chromebook R11 (CB5-132T / C738T)"},{"manufacturer":"Acer","market_name":"CloudMobile S500","codename":"a9","model":"S500"},{"manufacturer":"Acer","market_name":"DA220HQL","codename":"DA220HQL","model":"DA220HQL"},{"manufacturer":"Acer","market_name":"DA221HQL","codename":"da1","model":"DA221HQL"},{"manufacturer":"Acer","market_name":"DA222HQL","codename":"da2","model":"DA222HQL"},{"manufacturer":"Acer","market_name":"DA222HQLA","codename":"da2","model":"DA222HQLA"},{"manufacturer":"Acer","market_name":"DA222HQLA","codename":"da222hqla","model":"DA222HQLA"},{"manufacturer":"Acer","market_name":"DA223HQL","codename":"da3","model":"DA223HQL"},{"manufacturer":"Acer","market_name":"DA226HQ","codename":"da6","model":"DA226HQ"},{"manufacturer":"Acer","market_name":"DA241HL","codename":"DA241HL","model":"DA241HL"},{"manufacturer":"Acer","market_name":"DA245HQL","codename":"da245hql","model":"DA245HQL"},{"manufacturer":"Acer","market_name":"E380","codename":"acer_e3n","model":"E380"},{"manufacturer":"Acer","market_name":"G1-715","codename":"G1-715","model":"G1-715"},{"manufacturer":"Acer","market_name":"G100W","codename":"maya","model":"G100W"},{"manufacturer":"Acer","market_name":"GT-810","codename":"rolex","model":"GT-810"},{"manufacturer":"Acer","market_name":"I110","codename":"I1","model":"I110"},{"manufacturer":"Acer","market_name":"Icona One 7","codename":"vespa","model":"B1-730HD"},{"manufacturer":"Acer","market_name":"Iconia One 10","codename":"acer_jetfirelte","model":"B3-A32"},{"manufacturer":"Acer","market_name":"Iconia One 10","codename":"corona","model":"B3-A20"},{"manufacturer":"Acer","market_name":"Iconia One 10","codename":"corona","model":"B3-A20B"},{"manufacturer":"Acer","market_name":"Iconia One 7","codename":"G1-725","model":"G1-725"},{"manufacturer":"Acer","market_name":"Iconia One 7","codename":"acer_Vulcan","model":"B1-7A0"},{"manufacturer":"Acer","market_name":"Iconia One 7","codename":"vespa","model":"B1-730HD"},{"manufacturer":"Acer","market_name":"Iconia One 7","codename":"vespa2","model":"B1-750"},{"manufacturer":"Acer","market_name":"Iconia One 7","codename":"vespatn","model":"B1-730"},{"manufacturer":"Acer","market_name":"Iconia One 8","codename":"acer_FrenzyRefresh","model":"B1-860A"},{"manufacturer":"Acer","market_name":"Iconia One 8","codename":"acer_Zipp","model":"B1-870"},{"manufacturer":"Acer","market_name":"Iconia One 8","codename":"vespa8","model":"A1-850"},{"manufacturer":"Acer","market_name":"Iconia One 8","codename":"vespa8","model":"B1-810"},{"manufacturer":"Acer","market_name":"Iconia Tab 10","codename":"acer_Titan","model":"A3-A50"},{"manufacturer":"Acer","market_name":"Iconia Tab 10","codename":"acer_asgard","model":"B3-A40"},{"manufacturer":"Acer","market_name":"Iconia Tab 10","codename":"acer_asgardfhd","model":"B3-A40FHD"},{"manufacturer":"Acer","market_name":"Iconia Tab 10","codename":"acer_harley","model":"A3-A20"},{"manufacturer":"Acer","market_name":"Iconia Tab 10","codename":"acer_harleyfhd","model":"A3-A20FHD"},{"manufacturer":"Acer","market_name":"Iconia Tab 10 (AsgardLTE)","codename":"acer_asgardlte","model":"B3-A42"},{"manufacturer":"Acer","market_name":"Iconia Tab 7","codename":"acer_aprilia","model":"A1-713"},{"manufacturer":"Acer","market_name":"Iconia Tab 7","codename":"acer_apriliahd","model":"A1-713HD"},{"manufacturer":"Acer","market_name":"Iconia Tab 8","codename":"ducati2fhd","model":"A1-840FHD"},{"manufacturer":"Acer","market_name":"Iconia Tab 8","codename":"ducati2hd","model":"A1-840"},{"manufacturer":"Acer","market_name":"Iconia Tab 8","codename":"ducati2hd3g","model":"A1-841"},{"manufacturer":"Acer","market_name":"Iconia Tab A100 (VanGogh)","codename":"vangogh","model":"A100"},{"manufacturer":"Acer","market_name":"Iconia Tab A100 (VanGogh)","codename":"vangogh","model":"A101"},{"manufacturer":"Acer","market_name":"Iconia Tab A200","codename":"picasso_e","model":"A200"},{"manufacturer":"Acer","market_name":"Iconia Tab A210","codename":"picasso_e2","model":"A210"},{"manufacturer":"Acer","market_name":"Iconia Tab A211","codename":"picasso_e2","model":"A211"},{"manufacturer":"Acer","market_name":"Iconia Tab A500","codename":"picasso","model":"A500"},{"manufacturer":"Acer","market_name":"Iconia Tab A501","codename":"picasso","model":"A501"},{"manufacturer":"Acer","market_name":"Iconia Tab A510","codename":"picasso_m","model":"A510"},{"manufacturer":"Acer","market_name":"Iconia Tab A511","codename":"picasso_m","model":"A511"},{"manufacturer":"Acer","market_name":"Iconia Tab A700","codename":"picasso_mf","model":"A700"},{"manufacturer":"Acer","market_name":"Iconia Tab A701","codename":"picasso_mf","model":"A701"},{"manufacturer":"Acer","market_name":"Iconia TalkTab 7","codename":"acer_a1_724","model":"A1-724"},{"manufacturer":"Acer","market_name":"J73G","codename":"J73G","model":"J73G"},{"manufacturer":"Acer","market_name":"Liquid","codename":"a1","model":"Acer Liquid"},{"manufacturer":"Acer","market_name":"Liquid","codename":"a1","model":"Acer S100"},{"manufacturer":"Acer","market_name":"Liquid","codename":"a1","model":"Liquid"},{"manufacturer":"Acer","market_name":"Liquid 200","codename":"acer_z200","model":"Z200"},{"manufacturer":"Acer","market_name":"Liquid C1","codename":"I1","model":"I110"},{"manufacturer":"Acer","market_name":"Liquid E1","codename":"C10","model":"V360"},{"manufacturer":"Acer","market_name":"Liquid E2","codename":"C11","model":"V370"},{"manufacturer":"Acer","market_name":"Liquid E3","codename":"acer_e3","model":"E380"},{"manufacturer":"Acer","market_name":"Liquid E3","codename":"acer_e3n","model":"E380"},{"manufacturer":"Acer","market_name":"Liquid E3S","codename":"acer_ZXR","model":"Z130"},{"manufacturer":"Acer","market_name":"Liquid E600","codename":"e600","model":"E600"},{"manufacturer":"Acer","market_name":"Liquid E700","codename":"acer_e39","model":"E39"},{"manufacturer":"Acer","market_name":"Liquid Gallant E350","codename":"C8","model":"AK330"},{"manufacturer":"Acer","market_name":"Liquid Gallant E350","codename":"C8","model":"E350"},{"manufacturer":"Acer","market_name":"Liquid Jade","codename":"acer_S55","model":"S55"},{"manufacturer":"Acer","market_name":"Liquid Jade 2","codename":"acer_s58a","model":"S58A"},{"manufacturer":"Acer","market_name":"Liquid Jade S","codename":"acer_S56","model":"S56"},{"manufacturer":"Acer","market_name":"Liquid Jade Z","codename":"acer_S57","model":"S57"},{"manufacturer":"Acer","market_name":"Liquid Mini","codename":"C4R","model":"E310"},{"manufacturer":"Acer","market_name":"Liquid S1","codename":"a10","model":"S510"},{"manufacturer":"Acer","market_name":"Liquid S2","codename":"a12","model":"S520"},{"manufacturer":"Acer","market_name":"Liquid S3","codename":"s3","model":"S53"},{"manufacturer":"Acer","market_name":"Liquid T2","codename":"acer_T02","model":"T02"},{"manufacturer":"Acer","market_name":"Liquid X1","codename":"s3","model":"S53"},{"manufacturer":"Acer","market_name":"Liquid X2","codename":"acer_S59","model":"S59"},{"manufacturer":"Acer","market_name":"Liquid Z200","codename":"acer_z200","model":"Z200"},{"manufacturer":"Acer","market_name":"Liquid Z205","codename":"acer_z205","model":"Z205"},{"manufacturer":"Acer","market_name":"Liquid Z205","codename":"acer_z205p","model":"Z205"},{"manufacturer":"Acer","market_name":"Liquid Z205","codename":"acer_z205p","model":"Z205P"},{"manufacturer":"Acer","market_name":"Liquid Z220","codename":"z220","model":"Z220"},{"manufacturer":"Acer","market_name":"Liquid Z3","codename":"ZX","model":"Z130"},{"manufacturer":"Acer","market_name":"Liquid Z3","codename":"acer_ZXR","model":"Z130"},{"manufacturer":"Acer","market_name":"Liquid Z320","codename":"T012","model":"T012"},{"manufacturer":"Acer","market_name":"Liquid Z330","codename":"T01","model":"T01"},{"manufacturer":"Acer","market_name":"Liquid Z4","codename":"acer_Z6","model":"Z160"},{"manufacturer":"Acer","market_name":"Liquid Z410","codename":"acer_z410","model":"Z410"},{"manufacturer":"Acer","market_name":"Liquid Z5","codename":"acer_ZXL","model":"Z150"},{"manufacturer":"Acer","market_name":"Liquid Z500","codename":"acer_Z500","model":"Z500"},{"manufacturer":"Acer","market_name":"Liquid Z520","codename":"acer_z520","model":"Z520"},{"manufacturer":"Acer","market_name":"Liquid Z530","codename":"acer_T02","model":"T02"},{"manufacturer":"Acer","market_name":"Liquid Z530S","codename":"acer_t05","model":"T05"},{"manufacturer":"Acer","market_name":"Liquid Z6","codename":"acer_t09","model":"T09"},{"manufacturer":"Acer","market_name":"Liquid Z6 Plus","codename":"acer_t11","model":"T11"},{"manufacturer":"Acer","market_name":"Liquid Z630","codename":"acer_t03","model":"T03"},{"manufacturer":"Acer","market_name":"Liquid Z630S","codename":"acer_t04","model":"T04"},{"manufacturer":"Acer","market_name":"Liquid Z6E","codename":"acer_t10","model":"T10"},{"manufacturer":"Acer","market_name":"Liquid Zest","codename":"acer_t06","model":"T06"},{"manufacturer":"Acer","market_name":"Liquid Zest 4G","codename":"acer_t07","model":"T07"},{"manufacturer":"Acer","market_name":"Liquid Zest Plus","codename":"acer_t08","model":"T08"},{"manufacturer":"Acer","market_name":"LiquidMT","codename":"a4","model":"Acer Liquid Metal"},{"manufacturer":"Acer","market_name":"LiquidMT","codename":"a4","model":"Liquid MT"},{"manufacturer":"Acer","market_name":"LiquidMT","codename":"a4","model":"Liquid Metal"},{"manufacturer":"Acer","market_name":"M3-2200","codename":"da2","model":"M3-2200"},{"manufacturer":"Acer","market_name":"MWND1","codename":"MW1","model":"MWND1"},{"manufacturer":"Acer","market_name":"N3-2200","codename":"da2","model":"N3-2200"},{"manufacturer":"Acer","market_name":"Picasso","codename":"picasso","model":"A501"},{"manufacturer":"Acer","market_name":"Picasso","codename":"ventana","model":"A500"},{"manufacturer":"Acer","market_name":"Picasso","codename":"ventana","model":"G100W"},{"manufacturer":"Acer","market_name":"Picasso","codename":"ventana","model":"TPA60W"},{"manufacturer":"Acer","market_name":"TA2","codename":"ta2","model":"TA272HUL"},{"manufacturer":"Acer","market_name":"TA272HUL","codename":"ta2","model":"TA272HUL"},{"manufacturer":"Acer","market_name":"TPA60W","codename":"maya","model":"TPA60W"},{"manufacturer":"Acer","market_name":"Tab 7","codename":"td070va1","model":"TD070VA1"},{"manufacturer":"Acer","market_name":"Z110","codename":"Z1","model":"Z110"},{"manufacturer":"Acer","market_name":"Z120","codename":"Z2","model":"Z120"},{"manufacturer":"Adart","market_name":"ALIGATOR RX510","codename":"RX510","model":"ALIGATOR RX510"},{"manufacturer":"Adart","market_name":"ALIGATOR S4080 Duo","codename":"ALIGATOR_S4080","model":"ALIGATOR S4080"},{"manufacturer":"Adart","market_name":"ALIGATOR S4082 Duo","codename":"S4082Duo","model":"S4082 Duo"},{"manufacturer":"Adart","market_name":"ALIGATOR S5062 Duo","codename":"S5062Duo","model":"S5062 Duo"},{"manufacturer":"Adart","market_name":"ALIGATOR S5510 Duo","codename":"Aligator_S5510","model":"Aligator S5510"},{"manufacturer":"Adart","market_name":"RX550","codename":"ALIGATOR_RX550","model":"RX550"},{"manufacturer":"Adart","market_name":"S5060 Duo","codename":"ALIGATOR_S5060","model":"ALIGATOR S5060"},{"manufacturer":"Admiral Overseas Corporation","market_name":"A2272PW4T","codename":"AOC_WW","model":"G3SMNTA22"},{"manufacturer":"Admiral Overseas Corporation","market_name":"A2272PW4T","codename":"AOC_WW","model":"G3SMNTA24"},{"manufacturer":"Admiral Overseas Corporation","market_name":"A2272PWHT","codename":"AOC_WW","model":"G2SMNT"},{"manufacturer":"Admiral Overseas Corporation","market_name":"A2472PW4T","codename":"G3SMNTA24","model":"G3SMNTA24"},{"manufacturer":"Admiral Overseas Corporation","market_name":"A7","codename":"A7","model":"A7"},{"manufacturer":"Admiral Overseas Corporation","market_name":"C7","codename":"C7","model":"C7"},{"manufacturer":"Admiral Overseas Corporation","market_name":"Fire","codename":"Fire","model":"Fire"},{"manufacturer":"Admiral Overseas Corporation","market_name":"O7","codename":"O7","model":"O7"},{"manufacturer":"Admiral Overseas Corporation","market_name":"One","codename":"One","model":"One"},{"manufacturer":"Advan digital","market_name":"5041","codename":"ADVAN_5041","model":"5041"},{"manufacturer":"Advan digital","market_name":"5059","codename":"ADVAN_5059","model":"5059"},{"manufacturer":"Advan digital","market_name":"5060","codename":"ADVAN_5060","model":"5060"},{"manufacturer":"Advan digital","market_name":"5061","codename":"ADVAN_5061","model":"5061"},{"manufacturer":"Advan digital","market_name":"A8","codename":"ADVAN_A8","model":"A8"},{"manufacturer":"Advan digital","market_name":"E1C","codename":"ADVAN_E1C_3G","model":"E1C_3G"},{"manufacturer":"Advan digital","market_name":"E1C NXT","codename":"ADVAN_E1C_NXT","model":"S7D"},{"manufacturer":"Advan digital","market_name":"G1","codename":"G1","model":"G1"},{"manufacturer":"Advan digital","market_name":"G1 PRO","codename":"ADVAN_G1_Pro","model":"i5K"},{"manufacturer":"Advan digital","market_name":"G2","codename":"ADVAN_G2","model":"i55C"},{"manufacturer":"Advan digital","market_name":"G3","codename":"ADVAN_G3","model":"6001"},{"manufacturer":"Advan digital","market_name":"I Tab","codename":"ADVAN_i_Tab","model":"i7_Plus"},{"manufacturer":"Advan digital","market_name":"I55A","codename":"I55A","model":"I55A"},{"manufacturer":"Advan digital","market_name":"I5E","codename":"ADVAN_I5E","model":"I5E"},{"manufacturer":"Advan digital","market_name":"I5E","codename":"ADVAN_I5Es","model":"i5E"},{"manufacturer":"Advan digital","market_name":"I7D","codename":"ADVAN_I7D","model":"I7D"},{"manufacturer":"Advan digital","market_name":"M4","codename":"ADVAN_M4","model":"ADVAN M4"},{"manufacturer":"Advan digital","market_name":"S40","codename":"ADVAN_S40","model":"ADVAN S40"},{"manufacturer":"Advan digital","market_name":"S40 LTE","codename":"ADVAN_i4U","model":"i4U"},{"manufacturer":"Advan digital","market_name":"S45E","codename":"ADVAN_S45E","model":"S45E"},{"manufacturer":"Advan digital","market_name":"S4T","codename":"S4T","model":"S4T"},{"manufacturer":"Advan digital","market_name":"S4Z","codename":"ADVAN_S4Z","model":"S4Z"},{"manufacturer":"Advan digital","market_name":"S5E FULL VIEW","codename":"ADVAN_S5E_FULL_VIEW","model":"5062"},{"manufacturer":"Advan digital","market_name":"S5E_NXT","codename":"ADVAN_S5E_NXT","model":"S5E_NXT"},{"manufacturer":"Advan digital","market_name":"S7A","codename":"S7A","model":"S7A"},{"manufacturer":"Advan digital","market_name":"S7C","codename":"ADVAN_S7C","model":"S7C"},{"manufacturer":"Advan digital","market_name":"T2J","codename":"T2J","model":"T2J"},{"manufacturer":"Advan digital","market_name":"T2K","codename":"T2K","model":"T2K"},{"manufacturer":"Advan digital","market_name":"X7 Pro","codename":"ADVAN_7008","model":"7008"},{"manufacturer":"Advan digital","market_name":"i10","codename":"i10","model":"i10"},{"manufacturer":"Advan digital","market_name":"i55D","codename":"ADVAN_i55D","model":"i55D"},{"manufacturer":"Advan digital","market_name":"i55K","codename":"ADVAN_i55K","model":"i55K"},{"manufacturer":"Advan digital","market_name":"i5C","codename":"i5C","model":"i5C"},{"manufacturer":"Advan digital","market_name":"i5C plus","codename":"ADVAN_i5C_Plus","model":"5058"},{"manufacturer":"Advan digital","market_name":"i5D","codename":"ADVAN_i5D","model":"i5D"},{"manufacturer":"Advan digital","market_name":"i7","codename":"ADVAN_i7","model":"i7"},{"manufacturer":"Advan digital","market_name":"i7A","codename":"ADVAN_i7A","model":"i7A"},{"manufacturer":"Advan digital","market_name":"i7U","codename":"ADVAN_i_Lite","model":"i7U"},{"manufacturer":"Advance","market_name":"Pr5747","codename":"Pr5747","model":"Pr5747"},{"manufacturer":"Advance","market_name":"Pr6146","codename":"Pr6146","model":"Pr6146"},{"manufacturer":"Advance","market_name":"Pr6150","codename":"Pr6150","model":"Pr6150"},{"manufacturer":"Advantage","market_name":"I101MTK","codename":"I101MTK","model":"I101MTK"},{"manufacturer":"Aelion","market_name":"i8","codename":"Aelion_i8","model":"i8"},{"manufacturer":"Affix","market_name":"T737","codename":"AFFIX_T737","model":"AFFIX T737"},{"manufacturer":"Aikun","market_name":"EDSTAR LC-TS08A","codename":"LC-TS08A","model":"LC-TS08A"},{"manufacturer":"Aikun","market_name":"EDSTAR LC-TS08S","codename":"LC-TS08S","model":"LC-TS08S"},{"manufacturer":"Aikun","market_name":"RX300","codename":"X300","model":"X300"},{"manufacturer":"Aikun","market_name":"Solely Tab S7","codename":"HV1A","model":"S7"},{"manufacturer":"Aikun","market_name":"Solely Tab S8","codename":"HV1A","model":"S8"},{"manufacturer":"Aimson","market_name":"Q88","codename":"Q88","model":"Q88"},{"manufacturer":"Airtab","market_name":"AT8-N","codename":"AT8-N","model":"AT8-N"},{"manufacturer":"Airtel","market_name":"SH960S-AT","codename":"ganesa","model":"SH960S-AT"},{"manufacturer":"Aiuto","market_name":"AT1001","codename":"AT1001","model":"AT1001"},{"manufacturer":"Aiuto","market_name":"AT701","codename":"AT701","model":"AT701"},{"manufacturer":"Aiwa","market_name":"AW790","codename":"AW790","model":"AW790"},{"manufacturer":"Aiwa","market_name":"Z9","codename":"AIWA_Z9","model":"Z9"},{"manufacturer":"Aiwa","market_name":"Z9 PLUS","codename":"AIWA_Z9_PLUS","model":"Z9 PLUS"},{"manufacturer":"Alba","market_name":"ALBA 7 TABLET","codename":"ac70plv6","model":"ALBA 7 TABLET"},{"manufacturer":"Alba","market_name":"Alba 4G Plus","codename":"ac57crs","model":"Alba 4G Plus"},{"manufacturer":"Alba","market_name":"Alba 6","codename":"ac60crs","model":"Alba 6"},{"manufacturer":"Alba","market_name":"Alba_8in","codename":"Alba_8in","model":"Alba_8in"},{"manufacturer":"Alcor","market_name":"Alcor","codename":"Access_Q784C","model":"Access_Q784C"},{"manufacturer":"Alcor","market_name":"Alcor","codename":"Zest_Q108I","model":"Zest_Q108I"},{"manufacturer":"Alcor","market_name":"Alcor","codename":"Zest_Q708I","model":"Zest_Q708I"},{"manufacturer":"Aligator","market_name":"S5065","codename":"ALIGATORS5065","model":"ALIGATOR S5065"},{"manufacturer":"AllCall","market_name":"AllCall_Madrid","codename":"AllCall_Madrid","model":"AllCall_Madrid"},{"manufacturer":"AllCall","market_name":"MIX2","codename":"MIX2","model":"MIX2"},{"manufacturer":"AllCall","market_name":"Tab_1_3G","codename":"Tab_1_3G","model":"Tab_1_3G"},{"manufacturer":"AllCall","market_name":"Tab_2_3G","codename":"Tab_2_3G","model":"Tab_2_3G"},{"manufacturer":"AllView","market_name":"A5 Easy","codename":"A5_Easy","model":"A5_Easy"},{"manufacturer":"AllView","market_name":"A5 Easy","codename":"A5_Easy","model":"A5_Easy_TM"},{"manufacturer":"AllView","market_name":"A5 Lite","codename":"A5_Lite","model":"A5_Lite"},{"manufacturer":"AllView","market_name":"A5 Quad Plus","codename":"A5_Quad_Plus","model":"A5_Quad_Plus"},{"manufacturer":"AllView","market_name":"A5 Quad Plus","codename":"A5_Quad_Plus","model":"A5_Quad_Plus_TM"},{"manufacturer":"AllView","market_name":"A5 Ready","codename":"A5_Ready","model":"A5_Ready"},{"manufacturer":"AllView","market_name":"A5 Ready","codename":"A5_Ready","model":"A5_Ready_TM"},{"manufacturer":"AllView","market_name":"A6 Duo","codename":"A6_Duo","model":"A6_Duo"},{"manufacturer":"AllView","market_name":"A6 Lite","codename":"A6_Lite","model":"A6_Lite"},{"manufacturer":"AllView","market_name":"A7 Lite","codename":"A7_Lite","model":"A7_Lite"},{"manufacturer":"AllView","market_name":"A8 Lite","codename":"A8_Lite","model":"A8_Lite"},{"manufacturer":"AllView","market_name":"A8 Lite TM","codename":"A8_Lite","model":"A8_Lite_TM"},{"manufacturer":"AllView","market_name":"A9  Plus","codename":"A9_Plus","model":"A9_Plus"},{"manufacturer":"AllView","market_name":"A9 Lite","codename":"A9_Lite","model":"A9_Lite"},{"manufacturer":"AllView","market_name":"AX4 Nano Plus","codename":"AX4Nano_plus","model":"AX4Nano_plus"},{"manufacturer":"AllView","market_name":"AX501Q","codename":"AX501Q","model":"AX501Q"},{"manufacturer":"AllView","market_name":"AX502","codename":"AX502","model":"AX502"},{"manufacturer":"AllView","market_name":"C6 Duo","codename":"C6_Duo","model":"C6_Duo"},{"manufacturer":"AllView","market_name":"C6 Quad 4G","codename":"C6_Quad_4G","model":"C6Quad_4G"},{"manufacturer":"AllView","market_name":"E2 Jump","codename":"ALLVIEW_E2_Jump","model":"E2_Jump"},{"manufacturer":"AllView","market_name":"E3 Jump","codename":"E3_Jump","model":"E3_Jump"},{"manufacturer":"AllView","market_name":"E3 Living","codename":"E3_Living","model":"E3_Living"},{"manufacturer":"AllView","market_name":"E3 Sign","codename":"E3_Sign","model":"E3_Sign"},{"manufacturer":"AllView","market_name":"E4","codename":"E4","model":"E4"},{"manufacturer":"AllView","market_name":"E4 Lite","codename":"E4_Lite","model":"E4_Lite"},{"manufacturer":"AllView","market_name":"P4 Pro","codename":"P4_Pro","model":"P4_Pro"},{"manufacturer":"AllView","market_name":"P4 Quad","codename":"P4_Quad","model":"P4_Quad"},{"manufacturer":"AllView","market_name":"P4 eMagic","codename":"P4_eMagic","model":"P4_eMagic"},{"manufacturer":"AllView","market_name":"P4 eMagic","codename":"P4_eMagic","model":"P4_eMagic_TM"},{"manufacturer":"AllView","market_name":"P41 eMagic","codename":"P41_eMagic","model":"P41_eMagic"},{"manufacturer":"AllView","market_name":"P41 eMagic","codename":"P41_eMagic","model":"P41_eMagic_TM"},{"manufacturer":"AllView","market_name":"P42","codename":"P42","model":"P42"},{"manufacturer":"AllView","market_name":"P43 Easy","codename":"P43_Easy","model":"P43_Easy"},{"manufacturer":"AllView","market_name":"P5 Energy","codename":"P5_Energy","model":"P5_Energy"},{"manufacturer":"AllView","market_name":"P5 Life","codename":"P5Life","model":"P5Life_TM"},{"manufacturer":"AllView","market_name":"P5 Lite","codename":"P5_Lite","model":"P5_Lite"},{"manufacturer":"AllView","market_name":"P5 Pro","codename":"P5_Pro","model":"P5_Pro"},{"manufacturer":"AllView","market_name":"P5 eMagic","codename":"P5_eMagic","model":"P5_eMagic"},{"manufacturer":"AllView","market_name":"P5 eMagic","codename":"P5_eMagic","model":"P5_eMagic_TM"},{"manufacturer":"AllView","market_name":"P5Life","codename":"P5Life","model":"P5Life"},{"manufacturer":"AllView","market_name":"P5_Pro","codename":"P5_Pro","model":"P5_Pro_TM"},{"manufacturer":"AllView","market_name":"P6  Plus","codename":"P6_plus","model":"P6_plus"},{"manufacturer":"AllView","market_name":"P6 Energy","codename":"P6_Energy","model":"P6_Energy_TM"},{"manufacturer":"AllView","market_name":"P6 Energy Lite","codename":"P6_Energy_Lite","model":"P6_Energy_Lite"},{"manufacturer":"AllView","market_name":"P6 Energy Lite","codename":"P6_Energy_Lite","model":"P6_Energy_Lite_TM"},{"manufacturer":"AllView","market_name":"P6 Energy mini","codename":"P6_Energy_mini","model":"P6_Energy_mini"},{"manufacturer":"AllView","market_name":"P6 Life","codename":"P6_Life","model":"P6_Life"},{"manufacturer":"AllView","market_name":"P6 Lite","codename":"P6_lite","model":"P6_lite"},{"manufacturer":"AllView","market_name":"P6 Lite","codename":"P6_lite","model":"P6_lite_TM"},{"manufacturer":"AllView","market_name":"P6 Lite","codename":"P6_lite","model":"P6_lite_mTEL"},{"manufacturer":"AllView","market_name":"P6 Pro","codename":"P6_Pro","model":"P6_Pro"},{"manufacturer":"AllView","market_name":"P6 Qmax","codename":"P6_Qmax","model":"P6_Qmax"},{"manufacturer":"AllView","market_name":"P6 eMagic","codename":"P6_eMagic","model":"P6_eMagic"},{"manufacturer":"AllView","market_name":"P6_Energy","codename":"P6_Energy","model":"P6_Energy"},{"manufacturer":"AllView","market_name":"P7 Lite","codename":"P7_Lite","model":"P7_Lite"},{"manufacturer":"AllView","market_name":"P7 Lite","codename":"P7_Lite","model":"P7_Lite_TM"},{"manufacturer":"AllView","market_name":"P7 PRO","codename":"P7_PRO","model":"P7_PRO"},{"manufacturer":"AllView","market_name":"P7 PRO_TM","codename":"P7_PRO","model":"P7_PRO_TM"},{"manufacturer":"AllView","market_name":"P8 Energy","codename":"P8_Energy","model":"P8_Energy"},{"manufacturer":"AllView","market_name":"P8 Energy Pro","codename":"P8_Energy_PRO","model":"P8_Energy_PRO"},{"manufacturer":"AllView","market_name":"P8 Energy mini","codename":"P8_Energy_mini","model":"P8_Energy_mini"},{"manufacturer":"AllView","market_name":"P8 Energy mini","codename":"P8_Energy_mini","model":"P8_Energy_mini_TM"},{"manufacturer":"AllView","market_name":"P8 Life","codename":"P8_Life","model":"P8_Life"},{"manufacturer":"AllView","market_name":"P8 Pro","codename":"P8_PRO","model":"P8_PRO"},{"manufacturer":"AllView","market_name":"P8 eMagic","codename":"P8_eMagic","model":"P8_eMagic"},{"manufacturer":"AllView","market_name":"P8 eMagic","codename":"P8_eMagic","model":"P8_eMagic_TM"},{"manufacturer":"AllView","market_name":"P9 Energy","codename":"P9_Energy","model":"P9_Energy"},{"manufacturer":"AllView","market_name":"P9 Energy Lite","codename":"P9_Energy_Lite","model":"P9_Energy_Lite"},{"manufacturer":"AllView","market_name":"P9 Energy Lite 2017","codename":"P9_Energy_Lite_2017","model":"P9_Energy_Lite_2017"},{"manufacturer":"AllView","market_name":"P9 Energy Mini","codename":"P9_Energy_mini","model":"P9_Energy_mini_TM"},{"manufacturer":"AllView","market_name":"P9 Energy S","codename":"P9_Energy_S","model":"P9_Energy_S"},{"manufacturer":"AllView","market_name":"P9 Energy mini","codename":"P9_Energy_mini","model":"P9_Energy_mini"},{"manufacturer":"AllView","market_name":"P9 Life","codename":"P9_Life","model":"P9_Life"},{"manufacturer":"AllView","market_name":"P9_Life_TM","codename":"P9_Life","model":"P9_Life_TM"},{"manufacturer":"AllView","market_name":"V1 Viper E","codename":"V1_Viper_E","model":"V1_Viper_E"},{"manufacturer":"AllView","market_name":"V1 Viper I4G","codename":"V1_Viper_I4G","model":"V1_Viper_I4G"},{"manufacturer":"AllView","market_name":"V1 Viper I4G","codename":"V1_Viper_I4G","model":"V1_Viper_I4G_PL"},{"manufacturer":"AllView","market_name":"V1 Viper I4G","codename":"V1_Viper_I4G","model":"V1_Viper_I4G_TM"},{"manufacturer":"AllView","market_name":"V1 Viper I4G","codename":"V1_Viper_I4G_PL","model":"V1_Viper_I4G_PL"},{"manufacturer":"AllView","market_name":"V1 Viper L","codename":"V1_Viper_L","model":"V1_Viper_L"},{"manufacturer":"AllView","market_name":"V1 Viper S4G","codename":"V1_Viper_S4G","model":"V1_Viper_S4G"},{"manufacturer":"AllView","market_name":"V2 Viper","codename":"V2_Viper","model":"V2_Viper"},{"manufacturer":"AllView","market_name":"V2 Viper E","codename":"V2_Viper_E","model":"V2_Viper_E"},{"manufacturer":"AllView","market_name":"V2 Viper I","codename":"V2_Viper_I","model":"V2_Viper_I"},{"manufacturer":"AllView","market_name":"V2 Viper I","codename":"V2_Viper_I","model":"V2_Viper_I_TM"},{"manufacturer":"AllView","market_name":"V2 Viper I4G","codename":"V2_Viper_I4G","model":"V2_Viper_I4G"},{"manufacturer":"AllView","market_name":"V2 Viper S","codename":"V2_Viper_S","model":"V2_Viper_S"},{"manufacturer":"AllView","market_name":"V2 Viper X","codename":"V2_Viper_X","model":"V2_Viper_X"},{"manufacturer":"AllView","market_name":"V2 Viper X plus","codename":"V2_Viper_X_plus","model":"V2_Viper_X_plus"},{"manufacturer":"AllView","market_name":"V2 Viper Xe","codename":"V2_Viper_Xe","model":"V2_Viper_Xe"},{"manufacturer":"AllView","market_name":"V3 Viper","codename":"V3_Viper","model":"V3_Viper"},{"manufacturer":"AllView","market_name":"Viva 1001G","codename":"Viva_1001G","model":"Viva_1001G"},{"manufacturer":"AllView","market_name":"Viva C701","codename":"Viva_C701","model":"Viva_C701"},{"manufacturer":"AllView","market_name":"Viva C702","codename":"Viva_C702","model":"Viva_C702"},{"manufacturer":"AllView","market_name":"Viva H10 LTE","codename":"Allview_VivaH10LTE_KK","model":"VivaH10LTE"},{"manufacturer":"AllView","market_name":"Viva H1001 LTE","codename":"Viva_H1001_LTE","model":"Viva_H1001_LTE"},{"manufacturer":"AllView","market_name":"Viva H1002 LTE","codename":"Viva_H1002_LTE","model":"Viva_H1002_LTE"},{"manufacturer":"AllView","market_name":"Viva H7 LTE","codename":"Allview_VivaH7LTE_KK","model":"VivaH7LTE"},{"manufacturer":"AllView","market_name":"Viva H8 LTE","codename":"Allview_VivaH8LTE_KK","model":"VivaH8LTE"},{"manufacturer":"AllView","market_name":"Viva H8 Life","codename":"H8_Life","model":"H8_Life"},{"manufacturer":"AllView","market_name":"Viva H801","codename":"Viva_H801","model":"Viva_H801"},{"manufacturer":"AllView","market_name":"Viva H801 LTE","codename":"Viva_H801_LTE","model":"Viva_H801_LTE"},{"manufacturer":"AllView","market_name":"Viva H802 LTE","codename":"Viva_H802_LTE","model":"Viva_H802_LTE"},{"manufacturer":"AllView","market_name":"Viva H802 LTE","codename":"Viva_H802_LTE","model":"Viva_H802_LTE_TM"},{"manufacturer":"AllView","market_name":"Viva i10HD","codename":"Viva_i10HD","model":"Viva_i10HD"},{"manufacturer":"AllView","market_name":"Viva i701G","codename":"Viva_H701_LTE","model":"Viva_H701_LTE_CZ"},{"manufacturer":"AllView","market_name":"Viva i701G","codename":"Viva_i701G","model":"Viva_i701G"},{"manufacturer":"AllView","market_name":"Viva i701G","codename":"Viva_i701G","model":"Viva_i701G_TM"},{"manufacturer":"AllView","market_name":"Viva i7G","codename":"Viva_i7G","model":"Viva_i7G"},{"manufacturer":"AllView","market_name":"Viva_H701_LTE","codename":"Viva_H701_LTE","model":"Viva_H701_LTE"},{"manufacturer":"AllView","market_name":"X2 Soul Lite","codename":"X2_Soul_Lite","model":"X2_Soul_Lite"},{"manufacturer":"AllView","market_name":"X2 Soul Lite","codename":"X2_Soul_Lite","model":"X2_Soul_Lite_TM"},{"manufacturer":"AllView","market_name":"X2 Soul Mini","codename":"X2_Soul_Mini","model":"X2_Soul_Mini"},{"manufacturer":"AllView","market_name":"X2 Soul PRO","codename":"X2_Soul_PRO","model":"X2_Soul_PRO"},{"manufacturer":"AllView","market_name":"X2 Soul Style","codename":"X2_Soul_Style","model":"X2_Soul_Style"},{"manufacturer":"AllView","market_name":"X2 Soul Style","codename":"X2_Soul_Style","model":"X2_Soul_Style_TM"},{"manufacturer":"AllView","market_name":"X2 Soul Style+","codename":"X2_Soul_Style_Plus","model":"X2_Soul_Style_Plus"},{"manufacturer":"AllView","market_name":"X2 Soul Xtreme","codename":"X2_Soul_Xtreme","model":"X2_Soul_Xtreme"},{"manufacturer":"AllView","market_name":"X3 Soul Lite","codename":"X3_Soul_Lite","model":"X3_Soul_Lite"},{"manufacturer":"AllView","market_name":"X3 Soul Lite","codename":"X3_Soul_Lite","model":"X3_Soul_Lite_TM"},{"manufacturer":"AllView","market_name":"X3 Soul Plus","codename":"X3_Soul_PLUS","model":"X3_Soul_PLUS"},{"manufacturer":"AllView","market_name":"X3 Soul Pro","codename":"X3_Soul_PRO","model":"X3_Soul_PRO"},{"manufacturer":"AllView","market_name":"X3 Soul Style","codename":"X3_Soul_Style","model":"X3_Soul_Style"},{"manufacturer":"AllView","market_name":"X3 Soul mini","codename":"X3_Soul_mini","model":"X3_Soul_mini"},{"manufacturer":"AllView","market_name":"X3Soul","codename":"X3_Soul","model":"X3_Soul"},{"manufacturer":"AllView","market_name":"X4 Soul","codename":"X4_Soul","model":"X4_Soul"},{"manufacturer":"AllView","market_name":"X4 Soul Infinity L","codename":"X4_Soul_Infinity_L","model":"X4_Soul_Infinity_L"},{"manufacturer":"AllView","market_name":"X4 Soul Infinity L","codename":"X4_Soul_Infinity_LV","model":"X4_Soul_Infinity_L"},{"manufacturer":"AllView","market_name":"X4 Soul Infinity N","codename":"X4_Soul_Infinity_N","model":"X4_Soul_Infinity_N"},{"manufacturer":"AllView","market_name":"X4 Soul Infinity Plus","codename":"X4_Soul_Plus","model":"X4_Soul_Infinity_Plus"},{"manufacturer":"AllView","market_name":"X4 Soul Infinity S","codename":"X4_Soul_Infinity_S","model":"X4_Soul_Infinity_S"},{"manufacturer":"AllView","market_name":"X4 Soul Infinity SV","codename":"X4_Soul_Infinity_SV","model":"X4_Soul_Infinity_S"},{"manufacturer":"AllView","market_name":"X4 Soul Infinity Z","codename":"X4_Soul_Infinity_Z","model":"X4_Soul_Infinity_Z"},{"manufacturer":"AllView","market_name":"X4 Soul Infinity Z","codename":"X4_Soul_Infinity_ZV","model":"X4_Soul_Infinity_Z"},{"manufacturer":"AllView","market_name":"X4 Soul Lite","codename":"X4_Soul_Lite","model":"X4_Soul_Lite"},{"manufacturer":"AllView","market_name":"X4 Soul Mini","codename":"X4_Soul_Mini","model":"X4_Soul_Mini"},{"manufacturer":"AllView","market_name":"X4 Soul Mini S","codename":"X4_Soul_Mini_S","model":"X4_Soul_Mini_S"},{"manufacturer":"AllView","market_name":"X4 Soul Mini S","codename":"X4_Soul_Mini_S","model":"X4_Soul_Mini_S_TM"},{"manufacturer":"AllView","market_name":"X4 Soul Style","codename":"X4_Soul_Style","model":"X4_Soul_Style"},{"manufacturer":"AllView","market_name":"X4 Soul Vision","codename":"X4_Soul_Vision","model":"X4_Soul_Vision"},{"manufacturer":"AllView","market_name":"X4 Soul Xtreme","codename":"X4_Soul_Xtreme","model":"X4_Soul_Xtreme"},{"manufacturer":"Allducube","market_name":"T1001","codename":"T1001","model":"T1001"},{"manufacturer":"Allfine","market_name":"M721","codename":"86S","model":"M721"},{"manufacturer":"Allfine","market_name":"PC1038Q","codename":"fine10_Joy","model":"PC1038Q"},{"manufacturer":"Allouette","market_name":"PSY7020SKD","codename":"PSY7020SKD","model":"PSY7020SKD"},{"manufacturer":"Alphascan","market_name":"SAT2242 WorkTab","codename":"ADP_WW","model":"G2SMNT"},{"manufacturer":"Altice","market_name":"ALTICE S60","codename":"S60","model":"S60"},{"manufacturer":"Altice","market_name":"ALTICE S70","codename":"S70","model":"S70"},{"manufacturer":"Altice","market_name":"S31","codename":"S31","model":"Altice_S31"},{"manufacturer":"Altice","market_name":"S31","codename":"S31","model":"S31"},{"manufacturer":"Altice","market_name":"S41","codename":"HS6737MT","model":"S41"},{"manufacturer":"Altice","market_name":"S51","codename":"HS6737MT","model":"S51"},{"manufacturer":"Altice","market_name":"STARACTIVE","codename":"STARACTIVE","model":"STARACTIVE"},{"manufacturer":"Altice","market_name":"STARNAUTE 4","codename":"STARNAUTE4","model":"STARNAUTE4"},{"manufacturer":"Altice","market_name":"STARNAUTE3","codename":"STARNAUTE3","model":"STARNAUTE 3"},{"manufacturer":"Altice","market_name":"STARTRAIL 7","codename":"STARTRAIL7","model":"STARTRAIL7"},{"manufacturer":"Altice","market_name":"STARXTREM5","codename":"STARXTREM5","model":"STARXTREM5"},{"manufacturer":"Altice","market_name":"SX41","codename":"HS6737MT","model":"SX41"},{"manufacturer":"Altice","market_name":"Staractive","codename":"STARACTIVE","model":"STARACTIVE"},{"manufacturer":"Altice","market_name":"T10","codename":"T10","model":"T10"},{"manufacturer":"Amgoo","market_name":"AM350","codename":"AM350","model":"AM350"},{"manufacturer":"Amgoo","market_name":"AM402","codename":"AM402","model":"AM402"},{"manufacturer":"Amgoo","market_name":"AM410","codename":"AM410","model":"AM410"},{"manufacturer":"Amgoo","market_name":"AM415","codename":"AM415","model":"AM415"},{"manufacturer":"Amgoo","market_name":"AM506","codename":"AM506","model":"AM506"},{"manufacturer":"Amgoo","market_name":"AM508","codename":"AM508","model":"AM508"},{"manufacturer":"Amgoo","market_name":"AM509","codename":"AM509","model":"AM509"},{"manufacturer":"Amgoo","market_name":"AM509","codename":"AM509-A","model":"AM509"},{"manufacturer":"Amgoo","market_name":"AM515","codename":"AM515","model":"AM515"},{"manufacturer":"Amgoo","market_name":"AM520","codename":"AM520","model":"AM520"},{"manufacturer":"Amgoo","market_name":"AM530","codename":"AM530","model":"AM530"},{"manufacturer":"Amgoo","market_name":"AM535","codename":"AM535","model":"AM535"},{"manufacturer":"Amgoo","market_name":"Amgoo","codename":"AM518","model":"AM518"},{"manufacturer":"Amplify","market_name":"TL10RA3","codename":"TL10RA3_1","model":"TL10RA3"},{"manufacturer":"Amplify","market_name":"TR10CD3","codename":"TR10CD3_1","model":"TR10CD3"},{"manufacturer":"Amplify","market_name":"TR10CD3","codename":"TR10CD3_2","model":"TR10CD3"},{"manufacturer":"Anydata","market_name":"","codename":"ASP320Q_GSM","model":"ASP320Q_ANDi"},{"manufacturer":"Anydata","market_name":"Aquaris I8","codename":"bq_Aquaris","model":"bq Aquaris"},{"manufacturer":"Anydata","market_name":"Auchan MID7317CP Tablet","codename":"MID7317CP","model":"MID7317CP"},{"manufacturer":"Anydata","market_name":"COBY MID7055","codename":"MID7055","model":"MID7055"},{"manufacturer":"Anydata","market_name":"Carrefour CT710","codename":"M755ND","model":"CT710"},{"manufacturer":"Anydata","market_name":"Carrefour CT720 / Emdoor EM63 Tablet","codename":"EM63","model":"EM63"},{"manufacturer":"Anydata","market_name":"Coby MID1065","codename":"MID1065","model":"MID1065"},{"manufacturer":"Anydata","market_name":"Coby MID7065","codename":"MID7065","model":"MID7065"},{"manufacturer":"Anydata","market_name":"Coby MID8065","codename":"MID8065","model":"MID8065"},{"manufacturer":"Anydata","market_name":"D2-721G","codename":"D2-721G","model":"D2-721G"},{"manufacturer":"Anydata","market_name":"D2-727G","codename":"D2-727","model":"D2-727"},{"manufacturer":"Anydata","market_name":"DOPO GMS-718 Tablet / Discovery","codename":"DT088","model":"GS-718"},{"manufacturer":"Anydata","market_name":"DOTPAD DP3D8 / Gadmei","codename":"E8-3D","model":"DP3D8"},{"manufacturer":"Anydata","market_name":"Digix TAB-840_G","codename":"TAB-840_G","model":"TAB-840_G"},{"manufacturer":"Anydata","market_name":"Eviant MT8000","codename":"PDM829MD","model":"MT8000"},{"manufacturer":"Anydata","market_name":"Garmin nuvi3590","codename":"scorpio","model":"nuvi 3590"},{"manufacturer":"Anydata","market_name":"Garmin nuvi3595","codename":"scorpio","model":"nuvi 3595"},{"manufacturer":"Anydata","market_name":"Grundig GR-TB10S Tablet","codename":"GR-TB10S","model":"GR-TB10S"},{"manufacturer":"Anydata","market_name":"HCL ME TABLET PC U2","codename":"M712MC","model":"U2"},{"manufacturer":"Anydata","market_name":"HKC P771A","codename":"P771A_WIFI","model":"P771A"},{"manufacturer":"Anydata","market_name":"HKC P774A","codename":"P774A","model":"P774A"},{"manufacturer":"Anydata","market_name":"HKC P776A","codename":"P776A","model":"P776A"},{"manufacturer":"Anydata","market_name":"HKC P778A","codename":"HKCP778A","model":"P778A"},{"manufacturer":"Anydata","market_name":"HKC P886A","codename":"P886A","model":"P886A"},{"manufacturer":"Anydata","market_name":"HS_7DTB14","codename":"HS_7DTB14","model":"HS_7DTB14"},{"manufacturer":"Anydata","market_name":"Insignia NS-13T001 Tablet","codename":"oracle","model":"NS-13T001"},{"manufacturer":"Anydata","market_name":"Jiateng JT1241","codename":"JT1241","model":"JT1241"},{"manufacturer":"Anydata","market_name":"Lazer MD7305 Tablet / AMTC","codename":"MD7305","model":"MD7305"},{"manufacturer":"Anydata","market_name":"Le Pan S","codename":"oracle","model":"Le Pan S"},{"manufacturer":"Anydata","market_name":"LePanII","codename":"LePanII_wifi","model":"LePanII"},{"manufacturer":"Anydata","market_name":"Leader I10A-LE","codename":"I10A-LE","model":"I10A-LE"},{"manufacturer":"Anydata","market_name":"Mach_Speed Trio G2 Tablet","codename":"Trio_Stealth_G2","model":"G2"},{"manufacturer":"Anydata","market_name":"Marquis Tablet","codename":"marquis_tablet","model":"Marquis_MP977"},{"manufacturer":"Anydata","market_name":"Matsunichi M97","codename":"oracle","model":"M97"},{"manufacturer":"Anydata","market_name":"Monster M7 Tablet","codename":"MONSTERM7","model":"M7"},{"manufacturer":"Anydata","market_name":"Nextbook NX007HD Tablet","codename":"M7000ND","model":"NX007HD"},{"manufacturer":"Anydata","market_name":"Nextbook NX008HD8G Tablet","codename":"M8000ND","model":"NX008HD8G"},{"manufacturer":"Anydata","market_name":"Nextbook NX008HI Tablet / Carrefour CT810","codename":"M909NP","model":"NX008HI"},{"manufacturer":"Anydata","market_name":"Nextbook Next7D12 Tablet","codename":"M757ND","model":"Next7D12"},{"manufacturer":"Anydata","market_name":"Nextbook Next7P12","codename":"M727MC","model":"Next7P12"},{"manufacturer":"Anydata","market_name":"Pendo PNDPP48GP","codename":"PNDPP48GP","model":"PNDPP48GP"},{"manufacturer":"Anydata","market_name":"Philips W336","codename":"Crane","model":"Philips W336"},{"manufacturer":"Anydata","market_name":"Philips W536","codename":"Philips_WG-MANTO-RU_B","model":"Philips W536"},{"manufacturer":"Anydata","market_name":"Philips W626","codename":"sangfei73_gb","model":"W626"},{"manufacturer":"Anydata","market_name":"Philips W632","codename":"robot","model":"Philips W632"},{"manufacturer":"Anydata","market_name":"Philips W832","codename":"Philips_WG-ROVER-RU_A","model":"Philips W832"},{"manufacturer":"Anydata","market_name":"Proscan PLT7223G","codename":"PLT7223G","model":"PLT7223G"},{"manufacturer":"Anydata","market_name":"Proscan PLT7777","codename":"AMLMID710K","model":"PLT7777"},{"manufacturer":"Anydata","market_name":"Proscan PLT8223G","codename":"PLT8223G","model":"PLT8223G"},{"manufacturer":"Anydata","market_name":"RCA RCT6078W2","codename":"AMLEM62","model":"RCT6078W2"},{"manufacturer":"Anydata","market_name":"RCA RCT6078W2","codename":"EM62","model":"RCT6078W2"},{"manufacturer":"Anydata","market_name":"TecToy TT-2500","codename":"AML757ND","model":"TECTOYTT2500"},{"manufacturer":"Anydata","market_name":"Visual Land Prestige 7D","codename":"PRO7D","model":"PRO7D"},{"manufacturer":"Anydata","market_name":"Vivitar Camelio Tablet","codename":"PI070H04CA","model":"Camelio Family tablet"},{"manufacturer":"Anydata","market_name":"Vivitar XO Tablet","codename":"PI070H08XO","model":"XO Learning tablet"},{"manufacturer":"Anydata","market_name":"Zeki TBDG773","codename":"TBDG773","model":"TBDG773"},{"manufacturer":"Anydata","market_name":"ematic EGP008","codename":"EGP008","model":"EGP008"},{"manufacturer":"Anydata","market_name":"ematic EGP010","codename":"EGP010","model":"EGP010"},{"manufacturer":"Anydata","market_name":"ematic EGS004","codename":"EGS004","model":"EGS004"},{"manufacturer":"Anydata","market_name":"ematic EGS102","codename":"EGS102","model":"EGS102"},{"manufacturer":"Anydata","market_name":"essentielb ST8003/FT8001 Tablet","codename":"M805ND","model":"Smart\\'TAB 8003"},{"manufacturer":"Anydata","market_name":"iCraig CMP748","codename":"CMP748","model":"CMP748"},{"manufacturer":"Anydata","market_name":"iCraig CMP749","codename":"CMP749","model":"CMP749"},{"manufacturer":"Apex","market_name":"MT-734G","codename":"MT-734G","model":"MT-734G"},{"manufacturer":"Apex","market_name":"TM772","codename":"TM772","model":"TM772"},{"manufacturer":"Apex","market_name":"TM785CH","codename":"tm785ch","model":"TM785CH"},{"manufacturer":"Aprix","market_name":"Phat6","codename":"Aprix_Phat6","model":"Aprix_Phat6"},{"manufacturer":"Aprix","market_name":"Tab64","codename":"AprixTab64","model":"Aprix Tab64"},{"manufacturer":"Aprix","market_name":"X4","codename":"Aprix_X4","model":"Aprix_X4"},{"manufacturer":"Aqua","market_name":"S1 Jazz","codename":"S1_Jazz","model":"S1 Jazz"},{"manufacturer":"Arcelik","market_name":"B55L 9682 5AS","codename":"arcelik_eu","model":"arcelik_uhd_powermax_at"},{"manufacturer":"Archos","market_name":"","codename":"A101S","model":"ARCHOS 101G9"},{"manufacturer":"Archos","market_name":"","codename":"A101S","model":"Archos 101 Internet Tablet"},{"manufacturer":"Archos","market_name":"","codename":"A80S","model":"ARCHOS 80G9"},{"manufacturer":"Archos","market_name":"","codename":"A80S","model":"Archos 80 Internet Tablet"},{"manufacturer":"Archos","market_name":"101 Childpad","codename":"A101CHP","model":"ARCHOS 101 CHILDPAD"},{"manufacturer":"Archos","market_name":"101 Cobalt","codename":"AC101CO","model":"Archos 101 Cobalt"},{"manufacturer":"Archos","market_name":"101 Copper","codename":"ac101cv","model":"Archos 101 Copper"},{"manufacturer":"Archos","market_name":"101 G9","codename":"A101","model":"ARCHOS 101G9"},{"manufacturer":"Archos","market_name":"101 Helium","codename":"ac101he","model":"Archos 101 Helium"},{"manufacturer":"Archos","market_name":"101 Helium Lite","codename":"ac101hel","model":"Archos 101 Helium Lite"},{"manufacturer":"Archos","market_name":"101 Magnus","codename":"ac101ma","model":"ARCHOS 101 Magnus"},{"manufacturer":"Archos","market_name":"101 Neon","codename":"A101NE","model":"Archos 101 Neon"},{"manufacturer":"Archos","market_name":"101 Oxygen","codename":"ac101ox","model":"Archos 101 Oxygen"},{"manufacturer":"Archos","market_name":"101 Platinum","codename":"A101PL","model":"ARCHOS 101 PLATINUM"},{"manufacturer":"Archos","market_name":"101 Titanium","codename":"A101TI","model":"ARCHOS 101 Titanium"},{"manufacturer":"Archos","market_name":"101 XS","codename":"A101XS","model":"ARCHOS 101G10"},{"manufacturer":"Archos","market_name":"101 Xenon","codename":"a101xe","model":"Archos 101 Xenon"},{"manufacturer":"Archos","market_name":"101 Xenon","codename":"ac101cxe","model":"Archos 101c Xenon"},{"manufacturer":"Archos","market_name":"101 Xenon","codename":"ac101xev2","model":"Archos 101 Xenon v2"},{"manufacturer":"Archos","market_name":"101 Xenon Lite","codename":"ac101xel","model":"Archos 101 Xenon Lite"},{"manufacturer":"Archos","market_name":"101D Neon","codename":"ac101dne","model":"Archos 101d Neon"},{"manufacturer":"Archos","market_name":"101XS2","codename":"AC101XS2","model":"ARCHOS 101 XS 2"},{"manufacturer":"Archos","market_name":"101XS3","codename":"ac101xs3","model":"Archos 101XS3"},{"manufacturer":"Archos","market_name":"101b Copper","codename":"ac101bcv","model":"Archos 101b Copper"},{"manufacturer":"Archos","market_name":"101b Helium","codename":"ac101bhe","model":"Archos 101b Helium"},{"manufacturer":"Archos","market_name":"101b Neon","codename":"ac101bne","model":"Archos 101b Neon"},{"manufacturer":"Archos","market_name":"101b Oxygen","codename":"ac101box","model":"Archos 101b Oxygen"},{"manufacturer":"Archos","market_name":"101b Platinum","codename":"ac101bpl","model":"Archos 101b Platinium"},{"manufacturer":"Archos","market_name":"101b XS2","codename":"ac101bxs2","model":"ARCHOS 101b XS2"},{"manufacturer":"Archos","market_name":"101b Xenon","codename":"ac101bxev2","model":"Archos 101b Xenon v2"},{"manufacturer":"Archos","market_name":"101c Copper","codename":"ac101ccv","model":"Archos 101c Copper"},{"manufacturer":"Archos","market_name":"101c Neon","codename":"ac101cne","model":"Archos 101c Neon"},{"manufacturer":"Archos","market_name":"101c Platinum","codename":"ac101cpl","model":"Archos 101c Platinum"},{"manufacturer":"Archos","market_name":"101d Platinum v2","codename":"ac101cplv2","model":"Archos 101d Platinum v2"},{"manufacturer":"Archos","market_name":"101d Platinum v3","codename":"ac101dplv3","model":"Archos 101d Platinum v3"},{"manufacturer":"Archos","market_name":"101e Neon","codename":"ac101enev2","model":"Archos 101e Neon"},{"manufacturer":"Archos","market_name":"101e neon","codename":"ac101ene","model":"Archos 101e Neon"},{"manufacturer":"Archos","market_name":"121 Neon","codename":"ac121ne","model":"Archos 121 Neon"},{"manufacturer":"Archos","market_name":"133 Oxygen","codename":"ac133ox","model":"Archos 133 Oxygen"},{"manufacturer":"Archos","market_name":"35b Titanium","codename":"ac35bti","model":"Archos 35b Titanium"},{"manufacturer":"Archos","market_name":"40 Helium","codename":"ac40he","model":"Archos 40 Helium"},{"manufacturer":"Archos","market_name":"40 Neon","codename":"ac40ne","model":"Archos 40 Neon"},{"manufacturer":"Archos","market_name":"40 Power","codename":"ac40po","model":"Archos 40 Power"},{"manufacturer":"Archos","market_name":"40 Power","codename":"ac40pov2","model":"Archos 40 Power"},{"manufacturer":"Archos","market_name":"40 Titanium","codename":"a40ti","model":"Archos 40 Titanium"},{"manufacturer":"Archos","market_name":"40b Titanium","codename":"a40btisr","model":"Archos 40b Titanium Surround"},{"manufacturer":"Archos","market_name":"40c Titanium","codename":"ac40cti","model":"Archos 40c Titanium"},{"manufacturer":"Archos","market_name":"40c Titanium","codename":"ac40ctiv2","model":"ARCHOS 40C TIv2"},{"manufacturer":"Archos","market_name":"40d Titanium","codename":"ac40dti","model":"ARCHOS 40d Titanium"},{"manufacturer":"Archos","market_name":"45 Helium 4G","codename":"a45he","model":"Archos 45 Helium 4G"},{"manufacturer":"Archos","market_name":"45 Neon","codename":"ac45ne","model":"Archos 45 Neon"},{"manufacturer":"Archos","market_name":"45 Platinum","codename":"msm8625","model":"Archos 45 Platinum"},{"manufacturer":"Archos","market_name":"45 Titanium","codename":"a45ti","model":"Archos 45 Titanium"},{"manufacturer":"Archos","market_name":"45b Helium","codename":"ac45bhe","model":"AC45BHE"},{"manufacturer":"Archos","market_name":"45b Helium","codename":"ac45bhe","model":"ARCHOS 45b Helium"},{"manufacturer":"Archos","market_name":"45b Neon","codename":"ac45dpl","model":"Archos 45b Neon"},{"manufacturer":"Archos","market_name":"45b Platinum","codename":"ac45bpl","model":"Archos 45b Platinum"},{"manufacturer":"Archos","market_name":"45c Helium","codename":"ac45che","model":"Archos 45c Helium"},{"manufacturer":"Archos","market_name":"45c Platinum","codename":"ac45cpl","model":"Archos 45c Platinum"},{"manufacturer":"Archos","market_name":"45c Titanium","codename":"ac45cti","model":"Archos 45c Titanium"},{"manufacturer":"Archos","market_name":"45d Platinum","codename":"ac45dpl","model":"Archos 45d Platinum"},{"manufacturer":"Archos","market_name":"50 Cobalt","codename":"ac50co","model":"Archos 50 Cobalt"},{"manufacturer":"Archos","market_name":"50 Diamond","codename":"ac50da","model":"Archos 50 Diamond"},{"manufacturer":"Archos","market_name":"50 Helium 4G","codename":"a50he","model":"Archos 50 Helium 4G"},{"manufacturer":"Archos","market_name":"50 Helium Plus","codename":"ac50heplus","model":"Archos 50 Helium Plus"},{"manufacturer":"Archos","market_name":"50 Neon","codename":"a50ne","model":"Archos 50 Neon"},{"manufacturer":"Archos","market_name":"50 Oxygen","codename":"a50ox","model":"Archos 50 Oxygen"},{"manufacturer":"Archos","market_name":"50 Oxygen plus","codename":"ac50oxplus","model":"Archos 50 Oxygen Plus"},{"manufacturer":"Archos","market_name":"50 Platinum","codename":"msm8625","model":"Archos 50 Platinum"},{"manufacturer":"Archos","market_name":"50 Platinum 4G","codename":"AC50PL4G","model":"Archos 50 Platinum 4G"},{"manufacturer":"Archos","market_name":"50 Power","codename":"ac50po","model":"Archos 50 Power"},{"manufacturer":"Archos","market_name":"50 Saphir","codename":"ac50sa","model":"Archos 50 Saphir"},{"manufacturer":"Archos","market_name":"50 Titanium","codename":"a50ti","model":"Archos 50 Titanium"},{"manufacturer":"Archos","market_name":"50 Titanium 4G","codename":"ac50ti","model":"A50TI"},{"manufacturer":"Archos","market_name":"50 d Helium","codename":"ac50dhe","model":"AC50DHE"},{"manufacturer":"Archos","market_name":"50B Cobalt","codename":"ac50bco","model":"Archos 50B Cobalt"},{"manufacturer":"Archos","market_name":"50F Neon","codename":"ac50fnev2","model":"Archos 50f Neon"},{"manufacturer":"Archos","market_name":"50b Helium","codename":"ac50bhe","model":"AC50BHE"},{"manufacturer":"Archos","market_name":"50b Helium","codename":"ac50bhe","model":"Archos 50b Helium 4G"},{"manufacturer":"Archos","market_name":"50b Neon","codename":"ac50bne","model":"Archos 50b Neon"},{"manufacturer":"Archos","market_name":"50b Oxygen","codename":"a50box","model":"Archos 50b Oxygen"},{"manufacturer":"Archos","market_name":"50b Platinum","codename":"ac50bpl","model":"Archos 50b Platinum"},{"manufacturer":"Archos","market_name":"50c Helium","codename":"ac50che","model":"Archos 50c Helium"},{"manufacturer":"Archos","market_name":"50c Neon","codename":"ac50cne","model":"ARCHOS 50c Neon"},{"manufacturer":"Archos","market_name":"50c Neon","codename":"ac50cne","model":"Archos 50c Neon"},{"manufacturer":"Archos","market_name":"50c Oxygen","codename":"a50cox","model":"Archos 50c Oxygen"},{"manufacturer":"Archos","market_name":"50c Platinum","codename":"ac50cpl","model":"Archos 50c Platinum"},{"manufacturer":"Archos","market_name":"50d Neon","codename":"ac50dne","model":"Archos 50d Neon"},{"manufacturer":"Archos","market_name":"50d Oxygen","codename":"ac50dox","model":"Archos 50d Oxygen"},{"manufacturer":"Archos","market_name":"50e Helium","codename":"ac50ehe","model":"Archos 50e Helium"},{"manufacturer":"Archos","market_name":"50e Neon","codename":"ac50ene","model":"Archos 50e Neon"},{"manufacturer":"Archos","market_name":"50f Helium","codename":"ac50fhe","model":"Archos 50f Helium"},{"manufacturer":"Archos","market_name":"50f Neon","codename":"ac50fne","model":"Archos 50F Neon"},{"manufacturer":"Archos","market_name":"52 Platinum","codename":"ac52pl","model":"Archos 52 Platinum"},{"manufacturer":"Archos","market_name":"53 Platinum","codename":"msm8625","model":"Archos 53 Platinum"},{"manufacturer":"Archos","market_name":"53 Titanium","codename":"a53ti","model":"Archos 53 Titanium"},{"manufacturer":"Archos","market_name":"55 Cobalt Plus","codename":"ac55cop","model":"Archos 55 Cobalt Plus"},{"manufacturer":"Archos","market_name":"55 Cobalt Plus","codename":"ac55cop","model":"Archos 55 Cobalt plus"},{"manufacturer":"Archos","market_name":"55 Diamond Selfie","codename":"ac55diselfie","model":"Archos 55 diamond Selfie"},{"manufacturer":"Archos","market_name":"55 Helium","codename":"ac55he","model":"Archos 55 Helium"},{"manufacturer":"Archos","market_name":"55 Helium Plus","codename":"ac55heplus","model":"Archos 55 Helium Plus"},{"manufacturer":"Archos","market_name":"55 platinum","codename":"ac55pl","model":"Archos 55 Platinum"},{"manufacturer":"Archos","market_name":"55B Cobalt","codename":"ac55bco","model":"Archos 55B Cobalt"},{"manufacturer":"Archos","market_name":"55b Platinum","codename":"ac55bpl","model":"Archos 55B Platinum"},{"manufacturer":"Archos","market_name":"59 Titanium","codename":"ac59ti","model":"Archos 59 Titanium"},{"manufacturer":"Archos","market_name":"59 Xenon","codename":"ac59xe","model":"Archos 59 Xenon"},{"manufacturer":"Archos","market_name":"60 Platinum","codename":"ac60pl","model":"Archos 60 Platinum"},{"manufacturer":"Archos","market_name":"62 Xenon","codename":"ac62xe","model":"Archos 62 Xenon"},{"manufacturer":"Archos","market_name":"64 Xenon","codename":"ac64xe","model":"Archos 64 Xenon"},{"manufacturer":"Archos","market_name":"70 Cobalt","codename":"AC70CO","model":"ARCHOS 70 Cobalt"},{"manufacturer":"Archos","market_name":"70 Copper","codename":"ac70cv","model":"Archos 70 Copper"},{"manufacturer":"Archos","market_name":"70 Helium","codename":"ac70he","model":"Archos 70 Helium"},{"manufacturer":"Archos","market_name":"70 Neon","codename":"ac70ne","model":"Archos 70 Neon"},{"manufacturer":"Archos","market_name":"70 Neon Plus","codename":"ac70nep","model":"Archos 70 Neon Plus"},{"manufacturer":"Archos","market_name":"70 Oxygen","codename":"ac70ox","model":"Archos 70 Oxygen"},{"manufacturer":"Archos","market_name":"70 Platinum","codename":"ac70pl","model":"Archos 70 Platinum"},{"manufacturer":"Archos","market_name":"70 Platinum 3G","codename":"ac70pl3g","model":"Archos 70 Platinum 3G"},{"manufacturer":"Archos","market_name":"70 Platinum v2","codename":"ac70plv4","model":"Archos 70 Platinum v2"},{"manufacturer":"Archos","market_name":"70 Titanium","codename":"A70TI","model":"ARCHOS 70 Titanium"},{"manufacturer":"Archos","market_name":"70 Xenon","codename":"a70xe","model":"Archos 70 Xenon"},{"manufacturer":"Archos","market_name":"70 Xenon Color","codename":"ac70xec","model":"Archos 70 Xenon Color"},{"manufacturer":"Archos","market_name":"70 platinum","codename":"ac70plv3","model":"Archos 70 Platinum v3"},{"manufacturer":"Archos","market_name":"70b Cobalt","codename":"a70bco","model":"Archos 70b Cobalt"},{"manufacturer":"Archos","market_name":"70b Copper","codename":"ac70bcv","model":"Archos 70b Copper"},{"manufacturer":"Archos","market_name":"70b Helium","codename":"ac70bhe","model":"Archos 70b Helium"},{"manufacturer":"Archos","market_name":"70b Neon","codename":"ac70bne","model":"Archos 70b Neon"},{"manufacturer":"Archos","market_name":"70b Titanium","codename":"A70BTI","model":"ARCHOS 70b TITANIUM"},{"manufacturer":"Archos","market_name":"70b Xenon","codename":"ac70bxe","model":"Archos 70b Xenon"},{"manufacturer":"Archos","market_name":"70c Cobalt","codename":"ac70cco","model":"Archos 70c Cobalt"},{"manufacturer":"Archos","market_name":"70c Neon","codename":"ac70cne","model":"Archos 70c Neon"},{"manufacturer":"Archos","market_name":"70c Titanium","codename":"ac70cti","model":"Archos 70c Titanium"},{"manufacturer":"Archos","market_name":"70c Xenon","codename":"ac70cxe","model":"Archos 70c Xenon"},{"manufacturer":"Archos","market_name":"70it 2","codename":"A70it2","model":"ARCHOS 70it2"},{"manufacturer":"Archos","market_name":"70it 2","codename":"A70it2","model":"ARCHOS 70it2G8"},{"manufacturer":"Archos","market_name":"79 Cobalt","codename":"ac79co","model":"Archos 79 Cobalt"},{"manufacturer":"Archos","market_name":"79 Neon","codename":"a79ne","model":"Archos 79 Neon"},{"manufacturer":"Archos","market_name":"79 Platinium","codename":"AC79PL","model":"ARCHOS 79 Platinum"},{"manufacturer":"Archos","market_name":"79 Xenon","codename":"a79xe","model":"Archos 79 Xenon"},{"manufacturer":"Archos","market_name":"80 Carbon","codename":"AC80CA","model":"ARCHOS 80 Carbon"},{"manufacturer":"Archos","market_name":"80 Childpad","codename":"A80CHP","model":"ARCHOS 80 CHILDPAD"},{"manufacturer":"Archos","market_name":"80 Cobalt","codename":"A80CO","model":"ARCHOS 80 COBALT"},{"manufacturer":"Archos","market_name":"80 G9","codename":"A80","model":"ARCHOS 80G9"},{"manufacturer":"Archos","market_name":"80 Helium","codename":"ac80he","model":"Archos 80 Helium 4G"},{"manufacturer":"Archos","market_name":"80 Oxygen","codename":"ac80ox","model":"Archos 80 Oxygen"},{"manufacturer":"Archos","market_name":"80 Platinum","codename":"A80PL","model":"ARCHOS 80 Platinum"},{"manufacturer":"Archos","market_name":"80 Platinum","codename":"ac80cplv2_16G","model":"Archos 80 Platinum"},{"manufacturer":"Archos","market_name":"80 Platinum v2","codename":"ac80dplv2","model":"Archos 80 Platinum v2"},{"manufacturer":"Archos","market_name":"80 Titanium","codename":"A80TI","model":"ARCHOS 80 TITANIUM"},{"manufacturer":"Archos","market_name":"80 XS","codename":"A80XSK","model":"ARCHOS 80XSK"},{"manufacturer":"Archos","market_name":"80 Xenon","codename":"A80XE","model":"Archos 80 Xenon"},{"manufacturer":"Archos","market_name":"80b Helium","codename":"ac80bhe","model":"Archos 80b Helium"},{"manufacturer":"Archos","market_name":"80b Helium","codename":"ac80bhev2","model":"Archos 80b Helium v2"},{"manufacturer":"Archos","market_name":"80b Platinum","codename":"A80BPL","model":"ARCHOS 80b PLATINUM"},{"manufacturer":"Archos","market_name":"80b xenon","codename":"ac80bxe","model":"Archos 80b Xenon"},{"manufacturer":"Archos","market_name":"80c Xenon","codename":"ac80cxe","model":"Archos 80c Xenon"},{"manufacturer":"Archos","market_name":"80d Xenon","codename":"ac80dxe","model":"Archos 80d Xenon"},{"manufacturer":"Archos","market_name":"9.4\\'\\' FFF","codename":"ac94fff","model":"9.4\\'\\' FFF"},{"manufacturer":"Archos","market_name":"90 Copper","codename":"ac90cv","model":"Archos 90 Copper"},{"manufacturer":"Archos","market_name":"90 Neon","codename":"a90ne","model":"Archos 90 Neon"},{"manufacturer":"Archos","market_name":"90b Copper","codename":"ac90bcv","model":"Archos 90b Copper"},{"manufacturer":"Archos","market_name":"90b Neon","codename":"ac90bne","model":"Archos 90b Neon"},{"manufacturer":"Archos","market_name":"96 Xenon","codename":"ac96xe","model":"Archos 96 Xenon"},{"manufacturer":"Archos","market_name":"97 Carbon","codename":"A97C","model":"ARCHOS 97 CARBON"},{"manufacturer":"Archos","market_name":"97 Cobalt","codename":"AC97CO","model":"Archos 97 Cobalt"},{"manufacturer":"Archos","market_name":"97 Platinum","codename":"A97PL","model":"ARCHOS 97 Platinum"},{"manufacturer":"Archos","market_name":"97 Titanium HD","codename":"A97TIHD","model":"ARCHOS 97 TITANIUMHD"},{"manufacturer":"Archos","market_name":"97 Xenon","codename":"A97XE","model":"ARCHOS 97 XENON"},{"manufacturer":"Archos","market_name":"97b Platinum","codename":"AC97BPL","model":"ARCHOS 97b PLATINUM"},{"manufacturer":"Archos","market_name":"97b Titanium","codename":"A97BTI","model":"ARCHOS 97B TITANIUM"},{"manufacturer":"Archos","market_name":"97c Platinum","codename":"ac97cpl","model":"Archos 97c Platinum"},{"manufacturer":"Archos","market_name":"ALBA 5","codename":"ac50cr4gv2","model":"ALBA 5"},{"manufacturer":"Archos","market_name":"ALBA4","codename":"ac40as3g","model":"ALBA 4"},{"manufacturer":"Archos","market_name":"Alba 10","codename":"ac101cplv3","model":"ALBA 10 TABLET"},{"manufacturer":"Archos","market_name":"\"Alba 10\"\"\"","codename":"ac101cpl","model":"\"Alba 10\"\"\""},{"manufacturer":"Archos","market_name":"Alba 4","codename":"ac40he","model":"\"Alba 4.0\"\" Smartphone\""},{"manufacturer":"Archos","market_name":"Alba 4","codename":"ac40ne","model":"ALBA 4"},{"manufacturer":"Archos","market_name":"\"Alba 4\"\" Android\"","codename":"ac40dti","model":"\"Alba 4\"\" Android\""},{"manufacturer":"Archos","market_name":"Alba 5","codename":"ac50dne","model":"ALBA 5"},{"manufacturer":"Archos","market_name":"Alba 5","codename":"ac50fne","model":"ALBA 5"},{"manufacturer":"Archos","market_name":"Alba 7","codename":"ac70plv5","model":"ALBA 7 TABLET"},{"manufacturer":"Archos","market_name":"Alba 7\\'\\'","codename":"ac70plv4","model":"Alba 7"},{"manufacturer":"Archos","market_name":"Alba 7\\'\\'","codename":"ac70plv4","model":"\"Alba 7\"\"\""},{"manufacturer":"Archos","market_name":"Alba 8","codename":"ac80cplv2","model":"\"Alba 8\"\"\""},{"manufacturer":"Archos","market_name":"Alba 8\\'\\'","codename":"ac80cplv2_16G","model":"\"Alba 8\"\"\""},{"manufacturer":"Archos","market_name":"ArcBook","codename":"a101db","model":"Archos 101 DB"},{"manufacturer":"Archos","market_name":"Archos 101 Platinum 3G","codename":"ac101pl3g","model":"Archos 101 Platinium 3G"},{"manufacturer":"Archos","market_name":"Archos 101 Platinum 3G","codename":"ac101pl3gv2","model":"Archos 101 Platinum 3G"},{"manufacturer":"Archos","market_name":"Archos 101b Oxygen","codename":"ac101boxv2","model":"Archos 101b Oxygen"},{"manufacturer":"Archos","market_name":"Archos 101b Oxygen","codename":"ac101boxv3","model":"Archos 101b Oxygen"},{"manufacturer":"Archos","market_name":"Archos 101b Xenon","codename":"ac101bxev3","model":"Archos 101b Xenon v3"},{"manufacturer":"Archos","market_name":"Archos 101c Helium","codename":"ac101che","model":"Archos 101c Helium"},{"manufacturer":"Archos","market_name":"Archos 101c Platinum","codename":"ac101cplv3","model":"Archos 101c Platinum"},{"manufacturer":"Archos","market_name":"Archos 101c Xenon","codename":"ac101cxev2","model":"Archos 101c Xenon"},{"manufacturer":"Archos","market_name":"Archos 116 Neon","codename":"ac116ne","model":"Archos 116 Neon"},{"manufacturer":"Archos","market_name":"Archos 156 Oxygen","codename":"ac156ox","model":"Archos 156 Oxygen"},{"manufacturer":"Archos","market_name":"Archos 50c Platinum","codename":"ac80cplv3","model":"ALBA 8 TABLET"},{"manufacturer":"Archos","market_name":"Archos 70 Oxygen","codename":"ac70oxv2","model":"Archos 70 Oxygen"},{"manufacturer":"Archos","market_name":"Archos 70 platinum","codename":"ac70plv5","model":"Archos 70 Platinum"},{"manufacturer":"Archos","market_name":"Archos 70d Titanium","codename":"ac70dti","model":"Archos 70d Titanium"},{"manufacturer":"Archos","market_name":"Archos 79b Neon","codename":"ac79bnev2","model":"Archos 79b Neon"},{"manufacturer":"Archos","market_name":"Archos 80 Oxygen","codename":"ac80oxv2","model":"Archos 80 Oxygen"},{"manufacturer":"Archos","market_name":"Archos 80c Platinum","codename":"ac80cplv3","model":"Archos 80c Platinum"},{"manufacturer":"Archos","market_name":"Archos 97c Platinum","codename":"ac97cplv2","model":"Archos 97c Platinum"},{"manufacturer":"Archos","market_name":"Archos Acces 101 3G","codename":"ac101as3gv2","model":"Archos Access 101 3G V2"},{"manufacturer":"Archos","market_name":"Archos Access 101 3G","codename":"ac101as3g","model":"Archos Access 101 3G"},{"manufacturer":"Archos","market_name":"Archos Access 40 3G","codename":"ac40as3g","model":"Archos Access 40 3G"},{"manufacturer":"Archos","market_name":"Archos Access 40 4G","codename":"ac40as4g","model":"Archos Access 40 4G"},{"manufacturer":"Archos","market_name":"Archos Access 45 4G","codename":"ac45as4g","model":"Archos Access 45 4G"},{"manufacturer":"Archos","market_name":"Archos Access 50 3G","codename":"ac50as3g","model":"Archos Access 50 3G"},{"manufacturer":"Archos","market_name":"Archos Access 50 4G","codename":"ac50as4g","model":"Archos Access 50 4G"},{"manufacturer":"Archos","market_name":"Archos Access 50 Color 3G","codename":"ac50asclr3g","model":"Archos Access 50 Color 3G"},{"manufacturer":"Archos","market_name":"Archos Access 50 Color 4G","codename":"ac50asclr4g","model":"Archos Access 50 Color 4G"},{"manufacturer":"Archos","market_name":"Archos Access 55 3G","codename":"ac55as3g","model":"Archos Access 55 3G"},{"manufacturer":"Archos","market_name":"Archos Access 70 3G","codename":"ac70as3g","model":"Archos Access 70 3G"},{"manufacturer":"Archos","market_name":"Archos Core 101 3G","codename":"ac101cr3g","model":"Archos Core 101 3G"},{"manufacturer":"Archos","market_name":"Archos Core 101 3G","codename":"ac101cr3gv2","model":"Archos Core 101 3G"},{"manufacturer":"Archos","market_name":"Archos Core 101 3G","codename":"ac101cr3gv3","model":"Archos Core 101 3G"},{"manufacturer":"Archos","market_name":"Archos Core 101 4G","codename":"ac101cr4g","model":"Archos Core 101 4G"},{"manufacturer":"Archos","market_name":"Archos Core 101 4G","codename":"ac101cr4gv3","model":"Archos Core 101 4G"},{"manufacturer":"Archos","market_name":"Archos Core 50 4G","codename":"ac50cr4g","model":"Archos Core 50 4G"},{"manufacturer":"Archos","market_name":"Archos Core 50 4G","codename":"ac50cr4gv2","model":"Archos Phone"},{"manufacturer":"Archos","market_name":"Archos Core 50P","codename":"ac50crp","model":"Archos Core 50P"},{"manufacturer":"Archos","market_name":"Archos Core 55 4G","codename":"ac55cr4g","model":"Archos Core 55 4G"},{"manufacturer":"Archos","market_name":"Archos Core 55P","codename":"ac55crp","model":"Archos Core 55P"},{"manufacturer":"Archos","market_name":"Archos Core 55S","codename":"ac55crs","model":"Archos Core 55S"},{"manufacturer":"Archos","market_name":"Archos Core 57S","codename":"ac57crs","model":"Archos Core 57S"},{"manufacturer":"Archos","market_name":"Archos Core 60S","codename":"ac60crs","model":"Archos Core 60S"},{"manufacturer":"Archos","market_name":"Archos Core 70 3G","codename":"ac70cr3g","model":"Archos Core 70 3G"},{"manufacturer":"Archos","market_name":"Archos Core 70 3G","codename":"ac70cr3gv2","model":"Archos Core 70 3G"},{"manufacturer":"Archos","market_name":"Archos Saphir 50X","codename":"ac50sax","model":"Archos Saphir 50X"},{"manufacturer":"Archos","market_name":"Archos Sense 101X","codename":"ac101xse","model":"Archos Sense 101 X"},{"manufacturer":"Archos","market_name":"Archos Sense 47 X","codename":"ac47xse","model":"Archos Sense 47 X"},{"manufacturer":"Archos","market_name":"Archos Sense 50 DC","codename":"ac50sedc","model":"Archos Sense 50 DC"},{"manufacturer":"Archos","market_name":"Archos Sense 50X","codename":"ac50xse","model":"Archos Sense 50X"},{"manufacturer":"Archos","market_name":"Archos Sense 55 DC","codename":"ac55sedc","model":"Archos Sense 55 DC"},{"manufacturer":"Archos","market_name":"Archos Sense 55 DC","codename":"ac55sedcv2","model":"Archos Phone"},{"manufacturer":"Archos","market_name":"Archos Sense 55 S","codename":"ac55ses","model":"Archos Sense 55 S"},{"manufacturer":"Archos","market_name":"Archos80cpl_loreal","codename":"ac80cpl","model":"Archos 80c Platinum"},{"manufacturer":"Archos","market_name":"Auchan QiLive 45","codename":"ql45","model":"Qilive 45"},{"manufacturer":"Archos","market_name":"Auchan QiLive 50","codename":"ql50","model":"Qilive 50"},{"manufacturer":"Archos","market_name":"Auchan Qilive 40","codename":"ql40","model":"Qilive 40"},{"manufacturer":"Archos","market_name":"Auchan Qilive8","codename":"QiLive8","model":"QiLive 8"},{"manufacturer":"Archos","market_name":"Auchan Qilive8QC","codename":"QiLive8QC","model":"QiLive 8QC"},{"manufacturer":"Archos","market_name":"Auchan Qilive97","codename":"QiLive97","model":"QiLive 97"},{"manufacturer":"Archos","market_name":"Auchan Qilive97R","codename":"QiLive97R","model":"QiLive 97R"},{"manufacturer":"Archos","market_name":"Auchan Selecline 10","codename":"SELECLINE10","model":"Selecline 10"},{"manufacturer":"Archos","market_name":"BUSH SPIRA B3 5.5","codename":"ac55cop","model":"BUSH SPIRA B3 5.5"},{"manufacturer":"Archos","market_name":"BUSH SPIRA B5 POWER","codename":"ac50crp","model":"BUSH SPIRA B5 POWER"},{"manufacturer":"Archos","market_name":"BUSH SPIRA D3 5","codename":"ac50dox","model":"BUSH SPIRA D3 5"},{"manufacturer":"Archos","market_name":"BUSH SPIRA D5 Dual Camera","codename":"ac50sedc","model":"BUSH SPIRA D5 Dual Camera"},{"manufacturer":"Archos","market_name":"BUSH SPIRA D5.5 Dual Camera","codename":"ac55sedcv2","model":"BUSH SPIRA D5.5 Dual Camera"},{"manufacturer":"Archos","market_name":"Bush 10\\'\\'","codename":"ac101dplv2","model":"\"Bush 10\"\" Android\""},{"manufacturer":"Archos","market_name":"Bush 10.0 MyTablet","codename":"ac101dpl","model":"Bush 10.0 MyTablet"},{"manufacturer":"Archos","market_name":"\"Bush 4\"\" Android Phone\"","codename":"ac40cti","model":"Bush 4 Android"},{"manufacturer":"Archos","market_name":"Bush 5 4G","codename":"ac50heplus","model":"\"Bush 5\"\" 4G\""},{"manufacturer":"Archos","market_name":"Bush 5 4G","codename":"ac50heplus","model":"\"Bush Spira C2 5\"\" Smartphone\""},{"manufacturer":"Archos","market_name":"Bush 5 4G","codename":"ac55heplus","model":"\"Bush 5.5\"\" 4G\""},{"manufacturer":"Archos","market_name":"Bush 5 4G","codename":"ac55heplus","model":"\"Bush Spira D2 5.5\"\" Smartphone\""},{"manufacturer":"Archos","market_name":"\"Bush 5\"\" Android\"","codename":"ac50cne","model":"\"Bush 5\"\" Android\""},{"manufacturer":"Archos","market_name":"\"Bush 5\"\" Android Phone\"","codename":"ac50bne","model":"BUSH 5 Android"},{"manufacturer":"Archos","market_name":"Bush 7.0 MyTablet","codename":"ac70pl","model":"Bush 7.0 MyTablet"},{"manufacturer":"Archos","market_name":"Bush 7.85 My Tablet","codename":"ac79bu","model":"Archos 79c Neon"},{"manufacturer":"Archos","market_name":"\"Bush 8\"\"\"","codename":"ac80bhe","model":"\"Bush 8\"\" LTE Android\""},{"manufacturer":"Archos","market_name":"Bush 8\\'\\'","codename":"ac80dpl","model":"Bush 8 Android"},{"manufacturer":"Archos","market_name":"Bush 8.0 MyTablet","codename":"ac80cpl","model":"Bush 8.0 MyTablet"},{"manufacturer":"Archos","market_name":"Bush MyTablet 7","codename":"ac70bu","model":"Archos 70 Carbon"},{"manufacturer":"Archos","market_name":"Bush MyTablet 7","codename":"ac70bu","model":"BUSH 7.0 TABLET"},{"manufacturer":"Archos","market_name":"Bush Mytablet 2","codename":"a80bu","model":"Bush Mytablet 2"},{"manufacturer":"Archos","market_name":"Bush Spira B1 10.1","codename":"ac101dplv3a6","model":"\"Bush Spira B1 10.1\"\"\""},{"manufacturer":"Archos","market_name":"Bush Spira B1 10.1\\'\\'","codename":"ac101dplv3","model":"\"Bush Spira B1 10.1\"\"\""},{"manufacturer":"Archos","market_name":"Bush Spira B1 8\\'\\'","codename":"ac80dplv2","model":"\"Bush Spira B1 8\"\"\""},{"manufacturer":"Archos","market_name":"Bush Spira B2 8 tablet","codename":"ac80ox","model":"Bush Spira B2 8 tablet"},{"manufacturer":"Archos","market_name":"ChefPad","codename":"A97CFP","model":"Archos Chefpad"},{"manufacturer":"Archos","market_name":"Diamond 2 plus","codename":"ac55di2plus","model":"Archos 55 Diamond 2 Plus"},{"manufacturer":"Archos","market_name":"Diamond Plus","codename":"ac55diplus","model":"Archos 55 Diamond Plus"},{"manufacturer":"Archos","market_name":"Diamond Plus","codename":"ac55diplus","model":"Archos Diamond Plus"},{"manufacturer":"Archos","market_name":"Diamond S","codename":"ac50dis","model":"Archos Diamond S"},{"manufacturer":"Archos","market_name":"FamilyPad 2","codename":"A133FP2","model":"ARCHOS FAMILYPAD 2"},{"manufacturer":"Archos","market_name":"Fieldbook G1","codename":"LIFBG1","model":"Logic Fieldbook G1"},{"manufacturer":"Archos","market_name":"GamePad","codename":"A70GP","model":"ARCHOS GAMEPAD"},{"manufacturer":"Archos","market_name":"GamePad 2","codename":"A70GP2","model":"ARCHOS GAMEPAD2"},{"manufacturer":"Archos","market_name":"KUNO 4+","codename":"kuno4p","model":"KUNO 4+"},{"manufacturer":"Archos","market_name":"Kodak Tab 10","codename":"ac101tr","model":"KODAK Tablet 10"},{"manufacturer":"Archos","market_name":"Kodak Tab 7","codename":"ac70tr","model":"KODAK Tablet 7"},{"manufacturer":"Archos","market_name":"Kuno","codename":"KUNO4","model":"KUNO4"},{"manufacturer":"Archos","market_name":"Logic Instrument Fieldbook F1B","codename":"lifbf1b","model":"Logic Instrument Fieldbook F1B"},{"manufacturer":"Archos","market_name":"My Tablet 101","codename":"ac101bu","model":"BUSH 10.1 TABLET"},{"manufacturer":"Archos","market_name":"QiLive 101","codename":"aqilive101","model":"QILIVE 101"},{"manufacturer":"Archos","market_name":"Qilive 45 - 4G","codename":"ql45lte","model":"Qilive 45 - 4G"},{"manufacturer":"Archos","market_name":"Qilive 50 QC","codename":"ql50qc","model":"Qilive 50 QC"},{"manufacturer":"Archos","market_name":"Qilive 53","codename":"msm8625","model":"Qilive 53"},{"manufacturer":"Archos","market_name":"Qilive 7","codename":"qilive7","model":"Qilive 7"},{"manufacturer":"Archos","market_name":"Qilive 97R2","codename":"qilive97r2","model":"Qilive 97R-2"},{"manufacturer":"Archos","market_name":"Qilive79","codename":"Qilive79","model":"Qilive 79"},{"manufacturer":"Archos","market_name":"Qilive7V2","codename":"ql70v2","model":"Qilive 70v2"},{"manufacturer":"Archos","market_name":"Quechua Phone 5","codename":"A50RG11","model":"Quechua Phone 5"},{"manufacturer":"Archos","market_name":"Quechua Tablet 8","codename":"A80RG11","model":"A80RG11"},{"manufacturer":"Archos","market_name":"Smart Home Tablet","codename":"hometablet","model":"Archos Smart Home Tablet"},{"manufacturer":"Archos","market_name":"Smarthome La Poste","codename":"hometablet","model":"Archos Smart Home Tablet"},{"manufacturer":"Archos","market_name":"TV Connect","codename":"LUDO","model":"ARCHOS LUDOG10"},{"manufacturer":"Archos","market_name":"alba 10","codename":"ac101cplv2","model":"ALBA 10 TABLET"},{"manufacturer":"Archos","market_name":"alba 10","codename":"ac101cplv2","model":"\"Alba 10\"\"\""},{"manufacturer":"Ark","market_name":"Bebefit M551","codename":"Benefit_M551","model":"Benefit_M551"},{"manufacturer":"Ark","market_name":"Benefit M503","codename":"Benefit_M503","model":"Benefit_M503"},{"manufacturer":"Ark","market_name":"Benefit M505","codename":"Benefit_M505","model":"Benefit_M505"},{"manufacturer":"Ark","market_name":"Benefit M8","codename":"Benefit_M8","model":"Benefit_M8"},{"manufacturer":"Ark","market_name":"Benefit_Note 1","codename":"Benefit_Note_1","model":"Benefit_Note_1"},{"manufacturer":"Ark","market_name":"Impulse P2","codename":"Impulse_P2","model":"Impulse_P2"},{"manufacturer":"Ark","market_name":"Wizard 1","codename":"Wizard_1","model":"Wizard_1"},{"manufacturer":"Artel","market_name":"Artel U5","codename":"U5","model":"U5"},{"manufacturer":"Artel","market_name":"U3","codename":"U3","model":"U3"},{"manufacturer":"Ascom Wireless Solutions","market_name":"Ascom Myco 2 Cellular","codename":"ACBB","model":"SH1"},{"manufacturer":"Ascom Wireless Solutions","market_name":"Ascom Myco 2 WiFi","codename":"ABBB","model":"SH1"},{"manufacturer":"Ascom Wireless Solutions","market_name":"Ascom Myco 2 WiFi","codename":"ACBA","model":"SH1"},{"manufacturer":"Ascom Wireless Solutions","market_name":"Ascom Myco Cellular","codename":"ACBA","model":"SH1"},{"manufacturer":"Ascom Wireless Solutions","market_name":"Ascom Myco Cellular","codename":"myco_gms","model":"SH1"},{"manufacturer":"Ascom Wireless Solutions","market_name":"Ascom Myco Wi-Fi","codename":"ABBA","model":"SH1"},{"manufacturer":"Ashna","market_name":"X55","codename":"X55","model":"X55"},{"manufacturer":"Ashna","market_name":"X66","codename":"X66","model":"X66"},{"manufacturer":"Ashna","market_name":"Z600","codename":"Z600","model":"Z600"},{"manufacturer":"Aspera","market_name":"JAZZ","codename":"Jazz","model":"Jazz"},{"manufacturer":"Astak","market_name":"NEOS","codename":"Wenu","model":"NEOS"},{"manufacturer":"Astro","market_name":"Genesis_S8","codename":"Astro_Genesis_S8","model":"Genesis_S8"},{"manufacturer":"Astro Queo","market_name":"A712","codename":"A712","model":"A712"},{"manufacturer":"AstroQueo","market_name":"polaris_wifionly","codename":"polaris-wifionly","model":"A912"},{"manufacturer":"Asus","market_name":"","codename":"EP71","model":"ME171"},{"manufacturer":"Asus","market_name":"","codename":"TF300T","model":"ASUS Transformer Pad TF300T"},{"manufacturer":"Asus","market_name":"","codename":"a10","model":"Asus A10"},{"manufacturer":"Asus","market_name":"","codename":"a10","model":"Garmin-Asus A10"},{"manufacturer":"Asus","market_name":"","codename":"ventana","model":"Transformer TF101"},{"manufacturer":"Asus","market_name":"ASUS Chromebook Flip C302","codename":"cave_cheets","model":"ASUS Chromebook Flip C302"},{"manufacturer":"Asus","market_name":"ASUS Live (G500TG)","codename":"ASUS_Z00YD","model":"ASUS_Z00YD"},{"manufacturer":"Asus","market_name":"ASUSPRO Tablet (M1000C)","codename":"P023_M","model":"P023"},{"manufacturer":"Asus","market_name":"ASUSPRO Tablet (M1000CL)","codename":"P01T_M","model":"P01T"},{"manufacturer":"Asus","market_name":"ASUSPRO Tablet (M700C)","codename":"P01W_M","model":"P01W"},{"manufacturer":"Asus","market_name":"ASUSPRO Tablet (M700KL)","codename":"P002_M","model":"P002"},{"manufacturer":"Asus","market_name":"Chromebook C202SA/C300SA/C301SA","codename":"terra_cheets","model":"ASUS Chromebook C202SA"},{"manufacturer":"Asus","market_name":"Chromebook Flip C100PA","codename":"minnie_cheets","model":"ASUS Chromebook Flip C100PA"},{"manufacturer":"Asus","market_name":"Chromebook Flip C101PA","codename":"bob_cheets","model":"ASUS Chromebook Flip C101PA"},{"manufacturer":"Asus","market_name":"Chromebook Flip C101PA","codename":"bob_cheets","model":"bob"},{"manufacturer":"Asus","market_name":"\"Commercial tablet 10\"\" (M1000M)\"","codename":"P00C_M","model":"P00C"},{"manufacturer":"Asus","market_name":"\"Commercial tablet 10\"\" (R1000M)\"","codename":"P00C_M","model":"P00C"},{"manufacturer":"Asus","market_name":"\"Commercial tablet 8\"\" (M800M)\"","codename":"P00A_M","model":"P00A"},{"manufacturer":"Asus","market_name":"\"Commercial tablet 8\"\" (R800M)\"","codename":"P00A_M","model":"P00A"},{"manufacturer":"Asus","market_name":"Cube","codename":"asus_google_cube","model":"asus_google_cube"},{"manufacturer":"Asus","market_name":"ETBW11AA","codename":"ETBW11AA","model":"ETBW11AA"},{"manufacturer":"Asus","market_name":"ETBW11AA","codename":"TF101G","model":"ETBW11AA"},{"manufacturer":"Asus","market_name":"Eee Pad","codename":"EeePad","model":"Transformer TF101"},{"manufacturer":"Asus","market_name":"Eee Pad","codename":"EeePad","model":"Transformer TF101G"},{"manufacturer":"Asus","market_name":"Eee Pad Slider","codename":"SL101","model":"Slider SL101"},{"manufacturer":"Asus","market_name":"Eee Pad TF101","codename":"TF101","model":"TF101"},{"manufacturer":"Asus","market_name":"Eee Pad TF101","codename":"TF101","model":"Transformer TF101"},{"manufacturer":"Asus","market_name":"Eee Pad TF101-WiMAX","codename":"TF101-WiMAX","model":"TF101-WiMAX"},{"manufacturer":"Asus","market_name":"Eee Pad Transformer","codename":"TF101","model":"Transformer TF101"},{"manufacturer":"Asus","market_name":"Eee Pad Transformer Prime","codename":"TF201","model":"TF201"},{"manufacturer":"Asus","market_name":"Eee Pad Transformer Prime","codename":"TF201","model":"Transformer Prime TF201"},{"manufacturer":"Asus","market_name":"Eee Pad Transformer Prime","codename":"TF201","model":"Transformer TF201"},{"manufacturer":"Asus","market_name":"EeePad Slider SL101","codename":"SL101","model":"Slider SL101"},{"manufacturer":"Asus","market_name":"Fonepad 7 (FE170CG)","codename":"K012","model":"K012"},{"manufacturer":"Asus","market_name":"Fonepad 7 (FE171CG)","codename":"K01N_1","model":"K01N"},{"manufacturer":"Asus","market_name":"Fonepad 7 (FE171CG)","codename":"K01N_2","model":"K01N"},{"manufacturer":"Asus","market_name":"Fonepad 7 (FE171MG)","codename":"K01F","model":"K01F"},{"manufacturer":"Asus","market_name":"Fonepad 7 (FE375CG)","codename":"K019_1","model":"K019"},{"manufacturer":"Asus","market_name":"Fonepad 7 (FE375CXG)","codename":"K019_2","model":"K019"},{"manufacturer":"Asus","market_name":"Fonepad 7 (FE375CXG)","codename":"K019_3","model":"K019"},{"manufacturer":"Asus","market_name":"Fonepad 7 (FE375CXG)","codename":"K019_4","model":"K019"},{"manufacturer":"Asus","market_name":"Fonepad 7 (ME175CG)","codename":"K00Z","model":"K00Z"},{"manufacturer":"Asus","market_name":"Fonepad 7 (ME372CG)","codename":"K00E","model":"K00E"},{"manufacturer":"Asus","market_name":"Fonepad 7 LTE (FE375CL)","codename":"K01Q","model":"K01Q"},{"manufacturer":"Asus","market_name":"Fonepad 7 LTE (ME372CL)","codename":"K00Y","model":"K00Y"},{"manufacturer":"Asus","market_name":"Fonepad 8 (FE380CG)","codename":"K016_1","model":"K016"},{"manufacturer":"Asus","market_name":"Fonepad 8 (FE380CG)","codename":"K016_4","model":"K016"},{"manufacturer":"Asus","market_name":"Fonepad 8 (FE380CXG)","codename":"K016_2","model":"K016"},{"manufacturer":"Asus","market_name":"Fonepad 8 (FE380CXG)","codename":"K016_3","model":"K016"},{"manufacturer":"Asus","market_name":"Fonepad ME371MG","codename":"ME371MG","model":"ME371MG"},{"manufacturer":"Asus","market_name":"Fonepad Note 6 (ME560CG)","codename":"K00G","model":"K00G"},{"manufacturer":"Asus","market_name":"MeMO PAD","codename":"me172v","model":"ME172V"},{"manufacturer":"Asus","market_name":"MeMO Pad (ME103K)","codename":"K01E_1","model":"K01E"},{"manufacturer":"Asus","market_name":"MeMO Pad (ME103K)","codename":"K01E_2","model":"K01E"},{"manufacturer":"Asus","market_name":"MeMO Pad 10 (ME102A)","codename":"K00F","model":"K00F"},{"manufacturer":"Asus","market_name":"MeMO Pad 7 (FE7010CG)","codename":"K012_2","model":"K012_2"},{"manufacturer":"Asus","market_name":"MeMO Pad 7 (ME170C)","codename":"K017","model":"K017"},{"manufacturer":"Asus","market_name":"MeMO Pad 7 (ME171C)","codename":"K01U_1","model":"K01U"},{"manufacturer":"Asus","market_name":"MeMO Pad 7 (ME171C)","codename":"K01U_2","model":"K01U"},{"manufacturer":"Asus","market_name":"MeMO Pad 7 (ME176C)","codename":"K013","model":"K013"},{"manufacturer":"Asus","market_name":"MeMO Pad 7 (ME176CE)","codename":"K013C","model":"K013C"},{"manufacturer":"Asus","market_name":"MeMO Pad 7 (ME176CX)","codename":"K013_1","model":"K013"},{"manufacturer":"Asus","market_name":"MeMO Pad 7 (ME572C)","codename":"K007","model":"K007"},{"manufacturer":"Asus","market_name":"MeMO Pad 7 (ME70C)","codename":"K01A","model":"K01A"},{"manufacturer":"Asus","market_name":"MeMO Pad 7 LTE (ME375CL)","codename":"K00X","model":"ASUS MeMO Pad 7"},{"manufacturer":"Asus","market_name":"MeMO Pad 7 LTE (ME572CL)","codename":"K00R","model":"K00R"},{"manufacturer":"Asus","market_name":"MeMO Pad 7 LTE (ME7530CL)","codename":"K00X_1","model":"K00X"},{"manufacturer":"Asus","market_name":"MeMO Pad 8 (AST21)","codename":"K015","model":"AST21"},{"manufacturer":"Asus","market_name":"MeMO Pad 8 (ME181C)","codename":"K011","model":"K011"},{"manufacturer":"Asus","market_name":"MeMO Pad 8 (ME181CX)","codename":"K011_1","model":"K011"},{"manufacturer":"Asus","market_name":"MeMO Pad 8 (ME581C)","codename":"K01H","model":"K01H"},{"manufacturer":"Asus","market_name":"MeMO Pad 8 (ME581CL)","codename":"K015","model":"K015"},{"manufacturer":"Asus","market_name":"MeMO Pad FHD 10 (ME302KL)","codename":"ME302KL","model":"ME302KL"},{"manufacturer":"Asus","market_name":"MeMO Pad HD 7 (ME173X)","codename":"ME173X","model":"ME173X"},{"manufacturer":"Asus","market_name":"MeMO Pad HD 7 (ME173XX)","codename":"K00U","model":"K00U"},{"manufacturer":"Asus","market_name":"MeMO Pad HD 8 (ME180A)","codename":"K00L","model":"K00L"},{"manufacturer":"Asus","market_name":"MeMO Pad HD7 Dual SIM (ME175KG)","codename":"ASUS-K00S","model":"ASUS K00S"},{"manufacturer":"Asus","market_name":"MeMO Pad Smart 10","codename":"ME301T","model":"ME301T"},{"manufacturer":"Asus","market_name":"MeMo Pad 10 (ME302C)","codename":"ME302C","model":"ME302C"},{"manufacturer":"Asus","market_name":"MeMo Pad HD 7 (ME173XX)","codename":"K00U","model":"K00U"},{"manufacturer":"Asus","market_name":"Nexus 7 (2012)","codename":"grouper","model":"Nexus 7"},{"manufacturer":"Asus","market_name":"Nexus 7 (2012)","codename":"tilapia","model":"Nexus 7"},{"manufacturer":"Asus","market_name":"Nexus 7 (2013)","codename":"deb","model":"Nexus 7"},{"manufacturer":"Asus","market_name":"Nexus 7 (2013)","codename":"flo","model":"Nexus 7"},{"manufacturer":"Asus","market_name":"Nexus Player","codename":"fugu","model":"Nexus Player"},{"manufacturer":"Asus","market_name":"Nuvifone","codename":"a50","model":"Garmin-Asus A50"},{"manufacturer":"Asus","market_name":"PadFone","codename":"PadFone","model":"PadFone"},{"manufacturer":"Asus","market_name":"PadFone 2","codename":"A68","model":"PadFone 2"},{"manufacturer":"Asus","market_name":"PadFone E (A68M)","codename":"ASUS-T008","model":"PadFone T008"},{"manufacturer":"Asus","market_name":"PadFone Infinity","codename":"A80","model":"PadFone Infinity"},{"manufacturer":"Asus","market_name":"PadFone Infinity","codename":"ASUS-A80","model":"PadFone Infinity"},{"manufacturer":"Asus","market_name":"PadFone Mini","codename":"ASUS-T00C","model":"PadFone T00C"},{"manufacturer":"Asus","market_name":"PadFone S (PF500KL)","codename":"ASUS_T00N","model":"ASUS_T00N"},{"manufacturer":"Asus","market_name":"PadFone X (A91)","codename":"ASUS-T00D","model":"ASUS PadFone X"},{"manufacturer":"Asus","market_name":"PadFone X mini (PF450CL)","codename":"ASUS-T00S","model":"ASUS PadFone X mini"},{"manufacturer":"Asus","market_name":"PadFone X mini (PF450CL)","codename":"ASUS-T00S","model":"ASUS_T00T"},{"manufacturer":"Asus","market_name":"PadFone mini","codename":"ASUS-T00C","model":"PadFone T00C"},{"manufacturer":"Asus","market_name":"PadFone mini","codename":"ASUS_T00E","model":"ASUS_T00E"},{"manufacturer":"Asus","market_name":"R Series Tablet (R1001MFL)","codename":"ASUS_P00L_M2","model":"P00L"},{"manufacturer":"Asus","market_name":"R Series Tablet (R1001ML)","codename":"ASUS_P00L_M1","model":"P00L"},{"manufacturer":"Asus","market_name":"RTC-700A","codename":"RTC-tablet","model":"RTC-tablet"},{"manufacturer":"Asus","market_name":"T101TA","codename":"T10xTA","model":"T10xTA"},{"manufacturer":"Asus","market_name":"TF700T","codename":"TF700T","model":"ASUS Pad TF700T"},{"manufacturer":"Asus","market_name":"TF700T","codename":"TF700T","model":"ASUS Transformer Pad TF700T"},{"manufacturer":"Asus","market_name":"TX201LAF","codename":"TX201LAF","model":"TX201LAF"},{"manufacturer":"Asus","market_name":"The new PadFone Infinity (A86)","codename":"ASUS-A86","model":"PadFone T004"},{"manufacturer":"Asus","market_name":"Trans AiO P1801","codename":"P1801-T","model":"ASUS Tablet P1801-T"},{"manufacturer":"Asus","market_name":"TransBook Trio","codename":"TX201LA","model":"TX201LA"},{"manufacturer":"Asus","market_name":"Transformer AiO P1801","codename":"P1801-T","model":"ASUS Tablet P1801-T"},{"manufacturer":"Asus","market_name":"Transformer AiO P1802","codename":"P1802-T","model":"ASUS Tablet P1802-T"},{"manufacturer":"Asus","market_name":"Transformer Book Trio","codename":"TX201LA","model":"TX201LA"},{"manufacturer":"Asus","market_name":"Transformer Pad","codename":"K010_1","model":"K010"},{"manufacturer":"Asus","market_name":"Transformer Pad","codename":"TF300T","model":"ASUS Pad TF300T"},{"manufacturer":"Asus","market_name":"Transformer Pad","codename":"TF300T","model":"ASUS Transformer 300"},{"manufacturer":"Asus","market_name":"Transformer Pad","codename":"TF300T","model":"ASUS Transformer Pad TF300T"},{"manufacturer":"Asus","market_name":"Transformer Pad (TF103C)","codename":"K010","model":"K010"},{"manufacturer":"Asus","market_name":"Transformer Pad (TF103C)","codename":"K010_3","model":"K010"},{"manufacturer":"Asus","market_name":"Transformer Pad (TF103CE)","codename":"K010E","model":"K010E"},{"manufacturer":"Asus","market_name":"Transformer Pad (TF103CE)","codename":"K010E_1","model":"K010E"},{"manufacturer":"Asus","market_name":"Transformer Pad (TF103CG)","codename":"K018","model":"K018"},{"manufacturer":"Asus","market_name":"Transformer Pad (TF303CL)","codename":"K014","model":"K014"},{"manufacturer":"Asus","market_name":"Transformer Pad (TF303K)","codename":"K01B","model":"K01B"},{"manufacturer":"Asus","market_name":"Transformer Pad Infinity","codename":"TF700KL","model":"ASUS Transformer Pad TF700KL"},{"manufacturer":"Asus","market_name":"Transformer Pad Infinity (TF701T)","codename":"K00C","model":"K00C"},{"manufacturer":"Asus","market_name":"Transformer Pad TF300TG","codename":"TF300TG","model":"ASUS Transformer Pad TF300TG"},{"manufacturer":"Asus","market_name":"Transformer Pad TF300TL","codename":"TF300TL","model":"ASUS Transformer Pad TF300TL"},{"manufacturer":"Asus","market_name":"Transformer Pad TF502T","codename":"TF502T","model":"ASUS Transformer Pad TF502T"},{"manufacturer":"Asus","market_name":"Transformer Pad TF600T","codename":"TF600T","model":"ASUS Transformer Pad TF600T"},{"manufacturer":"Asus","market_name":"Transformer TF101G","codename":"TF101G","model":"Transformer TF101G"},{"manufacturer":"Asus","market_name":"ZenFone 2 (ZE500CL)","codename":"ASUS_Z00D","model":"ASUS ZenFone 2"},{"manufacturer":"Asus","market_name":"ZenFone 2 (ZE500CL)","codename":"ASUS_Z00D","model":"ASUS ZenFone 2E"},{"manufacturer":"Asus","market_name":"ZenFone 2 (ZE500CL)","codename":"ASUS_Z00D","model":"Z00D"},{"manufacturer":"Asus","market_name":"ZenFone 2 (ZE550ML)","codename":"Z008_1","model":"ASUS_Z008D"},{"manufacturer":"Asus","market_name":"ZenFone 2 (ZE551ML)","codename":"Z00A","model":"ASUS_Z00AD"},{"manufacturer":"Asus","market_name":"ZenFone 2 (ZE551ML)","codename":"Z00A","model":"ASUS_Z00ADA"},{"manufacturer":"Asus","market_name":"ZenFone 2 (ZE551ML)","codename":"Z00A_1","model":"ASUS_Z00AD"},{"manufacturer":"Asus","market_name":"ZenFone 2 (ZE551ML)","codename":"Z00A_1","model":"ASUS_Z00ADB"},{"manufacturer":"Asus","market_name":"ZenFone 2 (ZE551ML)","codename":"Z00A_3","model":"ASUS_Z00AD"},{"manufacturer":"Asus","market_name":"ZenFone 2 Laser (ZE500KG)","codename":"ASUS_Z00RD_5","model":"ASUS_Z00RD"},{"manufacturer":"Asus","market_name":"ZenFone 2 Laser (ZE500KG)","codename":"ASUS_Z00RD_7","model":"ASUS_Z00RD"},{"manufacturer":"Asus","market_name":"ZenFone 2 Laser (ZE500KL)","codename":"ASUS_Z00E_1","model":"ASUS_Z00ED"},{"manufacturer":"Asus","market_name":"ZenFone 2 Laser (ZE500KL)","codename":"ASUS_Z00E_2","model":"ASUS_Z00ED"},{"manufacturer":"Asus","market_name":"ZenFone 2 Laser (ZE500KL)","codename":"ASUS_Z00E_2","model":"ASUS_Z00EDB"},{"manufacturer":"Asus","market_name":"ZenFone 2 Laser (ZE500KL)","codename":"ASUS_Z00E_3","model":"ASUS_Z00ED"},{"manufacturer":"Asus","market_name":"ZenFone 2 Laser (ZE500KL)","codename":"ASUS_Z00E_4","model":"ASUS_Z00ED"},{"manufacturer":"Asus","market_name":"ZenFone 2 Laser (ZE550KG)","codename":"ASUS_Z00W_63","model":"ASUS_Z00WD"},{"manufacturer":"Asus","market_name":"ZenFone 2 Laser (ZE550KL)","codename":"ASUS_Z00L_63","model":"ASUS_Z00LD"},{"manufacturer":"Asus","market_name":"ZenFone 2 Laser (ZE550KL)","codename":"ASUS_Z00L_63","model":"ASUS_Z00LDC"},{"manufacturer":"Asus","market_name":"ZenFone 2 Laser (ZE550KL)","codename":"ASUS_Z00L_63A","model":"ASUS_Z00LD"},{"manufacturer":"Asus","market_name":"ZenFone 2 Laser (ZE550KL)","codename":"ASUS_Z00L_63C","model":"ASUS_Z00LD"},{"manufacturer":"Asus","market_name":"ZenFone 2 Laser (ZE550KL)","codename":"ASUS_Z00L_93","model":"ASUS_Z00LD"},{"manufacturer":"Asus","market_name":"ZenFone 2 Laser (ZE551KL)","codename":"ASUS_Z00T","model":"ASUS_Z00TD"},{"manufacturer":"Asus","market_name":"ZenFone 2 Laser (ZE600KL)","codename":"ASUS_Z00M","model":"ASUS_Z00MD"},{"manufacturer":"Asus","market_name":"ZenFone 2 Laser (ZE601KL)","codename":"ASUS_Z011","model":"ASUS_Z011D"},{"manufacturer":"Asus","market_name":"ZenFone 3 (ZE520KL)","codename":"ASUS_Z017D_1","model":"ASUS_Z017D"},{"manufacturer":"Asus","market_name":"ZenFone 3 (ZE520KL)","codename":"ASUS_Z017D_1","model":"ASUS_Z017DA"},{"manufacturer":"Asus","market_name":"ZenFone 3 (ZE552KL)","codename":"ASUS_Z012D","model":"ASUS_Z012D"},{"manufacturer":"Asus","market_name":"ZenFone 3 (ZE552KL)","codename":"ASUS_Z012D","model":"ASUS_Z012DA"},{"manufacturer":"Asus","market_name":"ZenFone 3 (ZE552KL)","codename":"ASUS_Z012D","model":"ASUS_Z012DE"},{"manufacturer":"Asus","market_name":"ZenFone 3 (ZE552KL)","codename":"ASUS_Z012D","model":"ASUS_Z012S"},{"manufacturer":"Asus","market_name":"ZenFone 3 Deluxe (ZS550KL)","codename":"ASUS_Z01F_1","model":"ASUS_Z01FD"},{"manufacturer":"Asus","market_name":"ZenFone 3 Deluxe (ZS570KL)","codename":"Z016","model":"ASUS_Z016D"},{"manufacturer":"Asus","market_name":"ZenFone 3 Deluxe (ZS570KL)","codename":"Z016","model":"ASUS_Z016DA"},{"manufacturer":"Asus","market_name":"ZenFone 3 Deluxe (ZS570KL)","codename":"Z016","model":"ASUS_Z016S"},{"manufacturer":"Asus","market_name":"ZenFone 3 Deluxe (ZS570KL)","codename":"Z016_1","model":"ASUS_Z016D"},{"manufacturer":"Asus","market_name":"ZenFone 3 Laser (ZC551KL)","codename":"Z01B_1","model":"ASUS_Z01BD"},{"manufacturer":"Asus","market_name":"ZenFone 3 Laser (ZC551KL)","codename":"Z01B_1","model":"ASUS_Z01BDA"},{"manufacturer":"Asus","market_name":"ZenFone 3 Laser (ZC551KL)","codename":"Z01B_1","model":"ASUS_Z01BDC"},{"manufacturer":"Asus","market_name":"ZenFone 3 Laser (ZC551KL)","codename":"Z01B_1","model":"ASUS_Z01BS"},{"manufacturer":"Asus","market_name":"ZenFone 3 Max (ZC520TL)","codename":"ASUS_X008","model":"ASUS_X008D"},{"manufacturer":"Asus","market_name":"ZenFone 3 Max (ZC520TL)","codename":"ASUS_X008","model":"ASUS_X008DA"},{"manufacturer":"Asus","market_name":"ZenFone 3 Max (ZC520TL)","codename":"ASUS_X008","model":"ASUS_X008DB"},{"manufacturer":"Asus","market_name":"ZenFone 3 Max (ZC520TL)","codename":"ASUS_X008_1","model":"ASUS_X008D"},{"manufacturer":"Asus","market_name":"ZenFone 3 Max (ZC520TL)","codename":"ASUS_X008_1","model":"ASUS_X008DA"},{"manufacturer":"Asus","market_name":"ZenFone 3 Max (ZC520TL)","codename":"ASUS_X008_1","model":"ASUS_X008DB"},{"manufacturer":"Asus","market_name":"ZenFone 3 Max (ZC520TL)","codename":"ASUS_X008_1","model":"ASUS_X008DC"},{"manufacturer":"Asus","market_name":"ZenFone 3 Max (ZC553KL)","codename":"ASUS_X00DD","model":"ASUS_X00DD"},{"manufacturer":"Asus","market_name":"ZenFone 3 Max (ZC553KL)","codename":"ASUS_X00DD","model":"ASUS_X00DDA"},{"manufacturer":"Asus","market_name":"ZenFone 3 Ultra (ZU680KL)","codename":"ASUS_A001","model":"ASUS_A001"},{"manufacturer":"Asus","market_name":"ZenFone 3 Zoom (ZE553KL)","codename":"ASUS_Z01H_1","model":"ASUS_Z01HD"},{"manufacturer":"Asus","market_name":"ZenFone 3 Zoom (ZE553KL)","codename":"ASUS_Z01H_1","model":"ASUS_Z01HDA"},{"manufacturer":"Asus","market_name":"ZenFone 3s Max (ZC521TL)","codename":"ASUS_X00G_1","model":"ASUS_X00GD"},{"manufacturer":"Asus","market_name":"ZenFone 4 (A400CG)","codename":"ASUS_T00I","model":"ASUS_T00I"},{"manufacturer":"Asus","market_name":"ZenFone 4 (A400CG)","codename":"ASUS_T00I","model":"ASUS_T00I-D"},{"manufacturer":"Asus","market_name":"ZenFone 4 (A450CG)","codename":"ASUS_T00Q","model":"ASUS_T00Q"},{"manufacturer":"Asus","market_name":"ZenFone 4 (ZE554KL)","codename":"ASUS_Z01KDA","model":"ASUS_Z01KD"},{"manufacturer":"Asus","market_name":"ZenFone 4 (ZE554KL)","codename":"ASUS_Z01KDA","model":"ASUS_Z01KS"},{"manufacturer":"Asus","market_name":"ZenFone 4 (ZE554KL)","codename":"ASUS_Z01KD_1","model":"ASUS_Z01KDA"},{"manufacturer":"Asus","market_name":"ZenFone 4 (ZE554KL)","codename":"ASUS_Z01KD_2","model":"ASUS_Z01KD"},{"manufacturer":"Asus","market_name":"ZenFone 4 Max (ZC520KL)","codename":"ASUS_X00HD_1","model":"ASUS_X00HD"},{"manufacturer":"Asus","market_name":"ZenFone 4 Max (ZC520KL)","codename":"ASUS_X00HD_2","model":"ASUS_X00HD"},{"manufacturer":"Asus","market_name":"ZenFone 4 Max (ZC520KL)","codename":"ASUS_X00HD_4","model":"ASUS_X00HD"},{"manufacturer":"Asus","market_name":"ZenFone 4 Max (ZC520KL)","codename":"ASUS_X00HD_5","model":"ASUS_X00HD"},{"manufacturer":"Asus","market_name":"ZenFone 4 Max (ZC554KL)","codename":"ASUS_X00ID","model":"ASUS_X00ID"},{"manufacturer":"Asus","market_name":"ZenFone 4 Max (ZC554KL)","codename":"ASUS_X00IDB","model":"ASUS_X00ID"},{"manufacturer":"Asus","market_name":"ZenFone 4 Max (ZC554KL)","codename":"ASUS_X00IDC","model":"ASUS_X00ID"},{"manufacturer":"Asus","market_name":"ZenFone 4 Pro (ZS551KL)","codename":"ASUS_Z01GD_1","model":"ASUS_Z01GD"},{"manufacturer":"Asus","market_name":"ZenFone 4 Selfie (ZD553KL)","codename":"ASUS_X00LD_1","model":"ASUS_X00LD"},{"manufacturer":"Asus","market_name":"ZenFone 4 Selfie Lite (ZB520KL)","codename":"ASUS_X00HD_3","model":"ASUS_X00HD"},{"manufacturer":"Asus","market_name":"ZenFone 4 Selfie Lite (ZB520KL)","codename":"ASUS_X00HD_3","model":"ASUS_X00HDA"},{"manufacturer":"Asus","market_name":"ZenFone 4 Selfie Pro (ZD552KL)","codename":"ASUS_Z01M_1","model":"ASUS_Z01MD"},{"manufacturer":"Asus","market_name":"ZenFone 4 Selfie Pro (ZD552KL)","codename":"ASUS_Z01M_1","model":"ASUS_Z01MDA"},{"manufacturer":"Asus","market_name":"ZenFone 5","codename":"ASUS_T00F","model":"ASUS_T00F"},{"manufacturer":"Asus","market_name":"ZenFone 5","codename":"ASUS_T00J","model":"ASUS_T00J"},{"manufacturer":"Asus","market_name":"ZenFone 5 (A500CG)","codename":"ASUS_T00F","model":"ASUS_T00F"},{"manufacturer":"Asus","market_name":"ZenFone 5 (A500CG)","codename":"ASUS_T00F1","model":"ASUS_T00F"},{"manufacturer":"Asus","market_name":"ZenFone 5 (A501CG)","codename":"ASUS_T00J1","model":"ASUS_T00J"},{"manufacturer":"Asus","market_name":"ZenFone 5 (A502CG)","codename":"ASUS_T00K","model":"ASUS_T00K"},{"manufacturer":"Asus","market_name":"ZenFone 5 (ZE620KL)","codename":"ASUS_X00QD","model":"ASUS_X00QD"},{"manufacturer":"Asus","market_name":"ZenFone 5 LTE (A500KL)","codename":"ASUS_T00P","model":"ASUS_T00P"},{"manufacturer":"Asus","market_name":"ZenFone 5 Lite (ZC600KL)","codename":"ASUS_X017D_2","model":"ASUS_X017DA"},{"manufacturer":"Asus","market_name":"ZenFone 5 Lite (ZC600KL)","codename":"ASUS_X017D_2","model":"ZC600KL"},{"manufacturer":"Asus","market_name":"ZenFone 5 Selfie (ZC600KL)","codename":"ASUS_X017D_1","model":"ASUS_X017D"},{"manufacturer":"Asus","market_name":"ZenFone 6","codename":"ASUS_T00G","model":"ASUS_T00G"},{"manufacturer":"Asus","market_name":"ZenFone 6 (A600CG)","codename":"ASUS_T00G","model":"ASUS_T00G"},{"manufacturer":"Asus","market_name":"ZenFone 6 (A601CG)","codename":"ASUS_Z002","model":"ASUS_Z002"},{"manufacturer":"Asus","market_name":"ZenFone AR","codename":"ASUS_A002_1","model":"ASUS_A002A"},{"manufacturer":"Asus","market_name":"ZenFone AR (ZS571KL)","codename":"ASUS_A002","model":"ASUS_A002"},{"manufacturer":"Asus","market_name":"ZenFone Ares","codename":"ASUS_A002_2","model":"ASUS_A002"},{"manufacturer":"Asus","market_name":"ZenFone Ares (ZS572KL)","codename":"ASUS_A002_2","model":"ASUS_A002"},{"manufacturer":"Asus","market_name":"ZenFone C (ZC451CG)","codename":"ASUS_Z007","model":"ASUS_Z007"},{"manufacturer":"Asus","market_name":"ZenFone Go (ZB450KL)","codename":"ASUS_X009D_2","model":"ASUS_X009DB"},{"manufacturer":"Asus","market_name":"ZenFone Go (ZB452KG)","codename":"ASUS_X014D_1","model":"ASUS_X014D"},{"manufacturer":"Asus","market_name":"ZenFone Go (ZB452KG)","codename":"ASUS_X014D_2","model":"ASUS_X014D"},{"manufacturer":"Asus","market_name":"ZenFone Go (ZB500KG)","codename":"ASUS_X00BD_1","model":"ASUS_X00BD"},{"manufacturer":"Asus","market_name":"ZenFone Go (ZB500KL)","codename":"ASUS_X00AD_2","model":"ASUS_X00AD"},{"manufacturer":"Asus","market_name":"ZenFone Go (ZB551KL)","codename":"ASUS_X013D_1","model":"ASUS_X013DA"},{"manufacturer":"Asus","market_name":"ZenFone Go (ZB551KL)","codename":"ASUS_X013D_1","model":"ASUS_X013DB"},{"manufacturer":"Asus","market_name":"ZenFone Go (ZB551KL)","codename":"ASUS_X013D_2","model":"ASUS_X013DA"},{"manufacturer":"Asus","market_name":"ZenFone Go (ZB551KL)","codename":"ASUS_X013D_2","model":"ASUS_X013DB"},{"manufacturer":"Asus","market_name":"ZenFone Go (ZB552KL)","codename":"ASUS_X007D","model":"ASUS_X007D"},{"manufacturer":"Asus","market_name":"ZenFone Go (ZB690KG)","codename":"ASUS_L001_1","model":"ASUS_L001"},{"manufacturer":"Asus","market_name":"ZenFone Go (ZB690KG)","codename":"ASUS_L001_2","model":"ASUS_L001"},{"manufacturer":"Asus","market_name":"ZenFone Go (ZC451TG)","codename":"ASUS_Z00SD","model":"ASUS_Z00SD"},{"manufacturer":"Asus","market_name":"ZenFone Go (ZC500TG)","codename":"ASUS_Z00VD","model":"ASUS_Z00VD"},{"manufacturer":"Asus","market_name":"ZenFone Live (ZB501KL)","codename":"ASUS_A007","model":"ASUS_A007"},{"manufacturer":"Asus","market_name":"ZenFone Live Plus (ZB553KL)","codename":"ASUS_X00LD_2","model":"ASUS_X00LDB"},{"manufacturer":"Asus","market_name":"ZenFone Live Plus (ZB553KL)","codename":"ASUS_X00LD_3","model":"ASUS_X00LDA"},{"manufacturer":"Asus","market_name":"ZenFone Live Plus (ZB553KL)","codename":"ASUS_X00LD_3","model":"ZB553KL"},{"manufacturer":"Asus","market_name":"ZenFone Max (ZC550KL)","codename":"ASUS_Z010","model":"ASUS_Z010D"},{"manufacturer":"Asus","market_name":"ZenFone Max (ZC550KL)","codename":"ASUS_Z010","model":"ASUS_Z010DA"},{"manufacturer":"Asus","market_name":"ZenFone Max (ZC550KL)","codename":"ASUS_Z010","model":"ASUS_Z010DB"},{"manufacturer":"Asus","market_name":"ZenFone Max (ZC550KL)","codename":"ASUS_Z010_2","model":"ASUS_Z010DD"},{"manufacturer":"Asus","market_name":"ZenFone Max (ZC550KL)","codename":"ASUS_Z010_CD","model":"ASUS_Z010D"},{"manufacturer":"Asus","market_name":"ZenFone Max (ZC550KL)","codename":"ASUS_Z010_CD","model":"ASUS_Z010DA"},{"manufacturer":"Asus","market_name":"ZenFone Max M1 (ZB555KL)","codename":"ASUS_X00P_1","model":"ASUS_X00PD"},{"manufacturer":"Asus","market_name":"ZenFone Max M1 (ZB555KL)","codename":"ASUS_X00P_1","model":"ZB555KL"},{"manufacturer":"Asus","market_name":"ZenFone Max M1 (ZB555KL)","codename":"ASUS_X00P_2","model":"ASUS_X00PD"},{"manufacturer":"Asus","market_name":"ZenFone Max M1 (ZB555KL)","codename":"ASUS_X00P_3","model":"ASUS_X00PD"},{"manufacturer":"Asus","market_name":"ZenFone Max M1 (ZB555KL)","codename":"ASUS_X00P_3","model":"ZB555KL"},{"manufacturer":"Asus","market_name":"ZenFone Max Plus M1 (ZB570TL)","codename":"ASUS_X018_1","model":"ASUS_X018D"},{"manufacturer":"Asus","market_name":"ZenFone Max Plus M1 (ZB570TL)","codename":"ASUS_X018_2","model":"ASUS_X018D"},{"manufacturer":"Asus","market_name":"ZenFone Max Plus M1 (ZB570TL)","codename":"ASUS_X018_4","model":"ASUS_X018D"},{"manufacturer":"Asus","market_name":"ZenFone Max Pro (M1)","codename":"ASUS_X00T_2","model":"ASUS_X00TD"},{"manufacturer":"Asus","market_name":"ZenFone Selfie (ZD551KL)","codename":"ASUS_Z00U_1","model":"ASUS_Z00UD"},{"manufacturer":"Asus","market_name":"ZenFone Selfie (ZD551KL)","codename":"ASUS_Z00U_1","model":"ASUS_Z00UDA"},{"manufacturer":"Asus","market_name":"ZenFone Selfie (ZD551KL)","codename":"ASUS_Z00U_2","model":"ASUS_Z00UD"},{"manufacturer":"Asus","market_name":"ZenFone V Live","codename":"ASUS_A009","model":"ASUS_A009"},{"manufacturer":"Asus","market_name":"ZenFone Zoom (ZX551ML)","codename":"Z00X","model":"ASUS_Z00XS"},{"manufacturer":"Asus","market_name":"ZenFone Zoom (ZX551ML)","codename":"Z00X","model":"ASUS_Z00XSA"},{"manufacturer":"Asus","market_name":"ZenFone Zoom (ZX551ML)","codename":"Z00X","model":"ASUS_Z00XSB"},{"manufacturer":"Asus","market_name":"ZenFone Zoom (ZX551ML)","codename":"Z00X_1","model":"ASUS_Z00XS"},{"manufacturer":"Asus","market_name":"ZenFone Zoom (ZX551ML)","codename":"Z00X_1","model":"ASUS_Z00XSA"},{"manufacturer":"Asus","market_name":"ZenFone Zoom (ZX551ML)","codename":"Z00X_2","model":"ASUS_Z00XS"},{"manufacturer":"Asus","market_name":"ZenFone4 (ZE554KL)","codename":"ASUS_Z01KD_3","model":"ASUS_Z01KD"},{"manufacturer":"Asus","market_name":"ZenFone5 (ZE620KL)","codename":"ASUS_X00QD","model":"ASUS_X00QSA"},{"manufacturer":"Asus","market_name":"ZenFone5 (ZE620KL)","codename":"ASUS_X00QD","model":"ZE620KL"},{"manufacturer":"Asus","market_name":"ZenPad 10 (Z300C)","codename":"P023_1","model":"P023"},{"manufacturer":"Asus","market_name":"ZenPad 10 (Z300C)","codename":"P023_2","model":"P023"},{"manufacturer":"Asus","market_name":"ZenPad 10 (Z300CG)","codename":"P021","model":"P021"},{"manufacturer":"Asus","market_name":"ZenPad 10 (Z300CG)","codename":"P021_1","model":"P021"},{"manufacturer":"Asus","market_name":"ZenPad 10 (Z300CL)","codename":"P01T_1","model":"P01T_1"},{"manufacturer":"Asus","market_name":"ZenPad 10 (Z300M)","codename":"P00C_1","model":"P00C"},{"manufacturer":"Asus","market_name":"ZenPad 10 (Z300M)","codename":"P00C_2","model":"P00C"},{"manufacturer":"Asus","market_name":"ZenPad 10 (Z301M)","codename":"ASUS_P028_1","model":"P028"},{"manufacturer":"Asus","market_name":"ZenPad 10 (Z301MF)","codename":"ASUS_P028_2","model":"P028"},{"manufacturer":"Asus","market_name":"ZenPad 10 (Z301MFL)","codename":"ASUS_P00L_2","model":"P00L"},{"manufacturer":"Asus","market_name":"ZenPad 10 (Z301ML)","codename":"ASUS_P00L_1","model":"P00L"},{"manufacturer":"Asus","market_name":"ZenPad 3 8.0","codename":"P008_1","model":"P008"},{"manufacturer":"Asus","market_name":"ZenPad 3 8.0","codename":"P008_2","model":"P008"},{"manufacturer":"Asus","market_name":"ZenPad 3S 10 (Z500M)","codename":"P027","model":"P027"},{"manufacturer":"Asus","market_name":"ZenPad 3S 10 LTE (Z500KL)","codename":"ASUS_P00I","model":"ASUS_P00I"},{"manufacturer":"Asus","market_name":"ZenPad 7.0 (Z370C)","codename":"P01W","model":"P01W"},{"manufacturer":"Asus","market_name":"ZenPad 7.0 (Z370CG)","codename":"P01V_1","model":"P01V"},{"manufacturer":"Asus","market_name":"ZenPad 7.0 (Z370CG)","codename":"P01V_2","model":"P01V"},{"manufacturer":"Asus","market_name":"ZenPad 7.0 (Z370KL)","codename":"P002_1","model":"P002"},{"manufacturer":"Asus","market_name":"ZenPad 7.0 (Z370KL)","codename":"P002_2","model":"P002"},{"manufacturer":"Asus","market_name":"ZenPad 8.0 (Z380KL)","codename":"P024_1","model":"P024"},{"manufacturer":"Asus","market_name":"ZenPad 8.0 (Z380KL)","codename":"P024_2","model":"P024"},{"manufacturer":"Asus","market_name":"ZenPad 8.0 (Z380KL)","codename":"P024_3","model":"P024"},{"manufacturer":"Asus","market_name":"ZenPad 8.0 (Z380KL)","codename":"P024_4","model":"P024"},{"manufacturer":"Asus","market_name":"ZenPad 8.0 (Z380M)","codename":"P00A_1","model":"P00A"},{"manufacturer":"Asus","market_name":"ZenPad 8.0 (Z380M)","codename":"P00A_2","model":"P00A"},{"manufacturer":"Asus","market_name":"ZenPad C 7.0","codename":"P01Y_S","model":"P01Y"},{"manufacturer":"Asus","market_name":"ZenPad C 7.0","codename":"P01Y_S","model":"P01Y_S"},{"manufacturer":"Asus","market_name":"ZenPad C 7.0 (Z170C)","codename":"P01Z","model":"P01Z"},{"manufacturer":"Asus","market_name":"ZenPad C 7.0 (Z170C)","codename":"P01Z_2","model":"P01Z"},{"manufacturer":"Asus","market_name":"ZenPad C 7.0 (Z170CG)","codename":"P01Y","model":"P01Y"},{"manufacturer":"Asus","market_name":"ZenPad C 7.0 (Z170CG)","codename":"P01Y_2","model":"P01Y"},{"manufacturer":"Asus","market_name":"ZenPad C 7.0 (Z170MG)","codename":"P001","model":"P001"},{"manufacturer":"Asus","market_name":"ZenPad C 7.0 (Z170MG)","codename":"P001_2","model":"P001"},{"manufacturer":"Asus","market_name":"ZenPad S 8.0 (Z580C)","codename":"P01M_2","model":"P01M"},{"manufacturer":"Asus","market_name":"ZenPad S 8.0 (Z580C)","codename":"P01M_4","model":"P01M"},{"manufacturer":"Asus","market_name":"ZenPad S 8.0 (Z580CA)","codename":"P01M_1","model":"P01MA"},{"manufacturer":"Asus","market_name":"ZenPad S 8.0 (Z580CA)","codename":"P01M_3","model":"P01MA"},{"manufacturer":"Asus","market_name":"ZenPad S 8.0 (Z580CA)","codename":"P01M_5","model":"P01MA"},{"manufacturer":"Asus","market_name":"ZenPad Z10","codename":"P00I","model":"P00I"},{"manufacturer":"Asus","market_name":"ZenPad Z8s","codename":"ASUS_P00J","model":"ASUS_P00J"},{"manufacturer":"Asus","market_name":"ZenPadC 7.0 (Z170MG)","codename":"P001_2","model":"P001_2"},{"manufacturer":"Asus","market_name":"ZenWatch","codename":"anthias","model":"ASUS ZenWatch"},{"manufacturer":"Asus","market_name":"ZenWatch 2","codename":"sparrow","model":"ASUS ZenWatch 2"},{"manufacturer":"Asus","market_name":"ZenWatch 2","codename":"wren","model":"ASUS ZenWatch 2"},{"manufacturer":"Asus","market_name":"ZenWatch 3","codename":"swift","model":"ASUS ZenWatch 3"},{"manufacturer":"Asus","market_name":"Zenbo","codename":"ASUS_ZENBO","model":"Zenbo"},{"manufacturer":"Asus","market_name":"Zenbo Qrobot","codename":"ASUS_ZENBO","model":"Zenbo"},{"manufacturer":"Asus","market_name":"Zenfone 4V (V520KL)","codename":"ASUS_A006","model":"ASUS_A006"},{"manufacturer":"Asus","market_name":"Zenfone Go (ASUS_X00BD)","codename":"ASUS_X00BD_1","model":"ASUS_X00BD"},{"manufacturer":"Asus","market_name":"Zenfone Go (T500)","codename":"ASUS_X003","model":"ASUS_X003"},{"manufacturer":"Asus","market_name":"Zenfone Live L1","codename":"ASUS_X00R_2","model":"ASUS_X00RD"},{"manufacturer":"Asus","market_name":"Zenfone Live L1","codename":"ASUS_X00R_2","model":"ZA550KL"},{"manufacturer":"Asus","market_name":"Zenpad 8.0 (Z380C)","codename":"P022_1","model":"P022"},{"manufacturer":"Asus","market_name":"Zenpad 8.0 (Z380C)","codename":"P022_2","model":"P022"},{"manufacturer":"Asus","market_name":"\\xe9\\xa3\\x9b\\xe9\\xa6\\xac (T500KLC)","codename":"ASUS_X003","model":"ASUS_X003"},{"manufacturer":"Asus","market_name":"\\xe9\\xa3\\x9b\\xe9\\xa6\\xac (T500TLT)","codename":"ASUS_X002","model":"ASUS_X002"},{"manufacturer":"Asus","market_name":"\\xe9\\xa3\\x9b\\xe9\\xa6\\xac 5000 (T551TLC)","codename":"ASUS_X005","model":"ASUS_X005"},{"manufacturer":"Asus","market_name":"\\xe9\\xa3\\x9b\\xe9\\xa6\\xac2 Plus (T550KLC)","codename":"ASUS_X550","model":"ASUS_X550"},{"manufacturer":"AtGames-zooti","market_name":"ZOOTI PAD ZT-701","codename":"ZT-701","model":"ZT-701"},{"manufacturer":"Auchan","market_name":"AUCHAN","codename":"Q7T9INK","model":"Q7T9INK"},{"manufacturer":"Auchan","market_name":"LI12210IN","codename":"LI12210IN","model":"LI12210IN"},{"manufacturer":"Auchan","market_name":"LI902T9IN","codename":"LI902T9IN","model":"LI902T9IN"},{"manufacturer":"Auchan","market_name":"Q.4514","codename":"Q4514","model":"Q4514"},{"manufacturer":"Auchan","market_name":"Q4S6IN4G","codename":"Q4S6IN4G","model":"Q4S6IN4G"},{"manufacturer":"Auchan","market_name":"Q4T10IN","codename":"Q4T10IN","model":"Q4T10IN"},{"manufacturer":"Auchan","market_name":"Q4T7IN","codename":"Q4T7IN","model":"Q4T7IN"},{"manufacturer":"Auchan","market_name":"Q4T7IN3G","codename":"Q4T7IN3G","model":"Q4T7IN3G"},{"manufacturer":"Auchan","market_name":"Q4T8IN","codename":"Q4T8IN","model":"Q4T8IN"},{"manufacturer":"Auchan","market_name":"Q5S55IN4G","codename":"Q5S55IN4G","model":"Q5S55IN4G"},{"manufacturer":"Auchan","market_name":"Q5S5IN4G","codename":"Q5S5IN4G","model":"Q5S5IN4G"},{"manufacturer":"Auchan","market_name":"Q6T10IN","codename":"Q6T10IN","model":"Q6T10IN"},{"manufacturer":"Auchan","market_name":"Q6T10IN4G","codename":"Q6T10IN4G","model":"Q6T10IN4G"},{"manufacturer":"Auchan","market_name":"Q6T7IN","codename":"Q6T7IN","model":"Q6T7IN"},{"manufacturer":"Auchan","market_name":"Q6T7IN4G","codename":"Q6T7IN4G","model":"Q6T7IN4G"},{"manufacturer":"Auchan","market_name":"Q6T7INK","codename":"Q6T7INK","model":"Q6T7INK"},{"manufacturer":"Auchan","market_name":"Q7S55IN4G","codename":"Q7S55IN4G","model":"Q7S55IN4G"},{"manufacturer":"Auchan","market_name":"Q7S5IN4G","codename":"Q7S5IN4G","model":"Q7S5IN4G"},{"manufacturer":"Auchan","market_name":"Q7S5IN4GP","codename":"Q7S5IN4GP","model":"Q7S5IN4GP"},{"manufacturer":"Auchan","market_name":"Q7T10INP","codename":"Q7T10INP","model":"Q7T10INP"},{"manufacturer":"Auchan","market_name":"Q7T7INK","codename":"Q7T7INK","model":"Q7T7INK"},{"manufacturer":"Auchan","market_name":"Q8S55IN4G","codename":"Q8S55IN4G","model":"Q8S55IN4G"},{"manufacturer":"Auchan","market_name":"Q8S55IN4G2","codename":"Q8S55IN4G2","model":"Q8S55IN4G2"},{"manufacturer":"Auchan","market_name":"Q8S6IN4G","codename":"Q8S6IN4G","model":"Q8S6IN4G"},{"manufacturer":"Auchan","market_name":"Q8T10IN","codename":"Q8T10IN","model":"Q8T10IN"},{"manufacturer":"Auchan","market_name":"Q8T7IN","codename":"Q8T7IN","model":"Q8T7IN"},{"manufacturer":"Auchan","market_name":"Q8T7IN4G","codename":"Q8T7IN4G","model":"Q8T7IN4G"},{"manufacturer":"Auchan","market_name":"QILIVE","codename":"Q4T10INK","model":"Q4T10INK"},{"manufacturer":"Auchan","market_name":"S3T10IN","codename":"S3T10IN","model":"S3T10IN"},{"manufacturer":"Auchan","market_name":"S3T10IN3G","codename":"S3T10IN3G","model":"S3T10IN3G"},{"manufacturer":"Auchan","market_name":"S3T7IN","codename":"S3T7IN","model":"S3T7IN"},{"manufacturer":"Auchan","market_name":"S3T7IN","codename":"astar-d86","model":"S3T7IN"},{"manufacturer":"Auchan","market_name":"S3T7IN3G","codename":"S3T7IN3G","model":"S3T7IN3G"},{"manufacturer":"Auchan","market_name":"S4S5IN3G","codename":"S4S5IN3G","model":"S4S5IN3G"},{"manufacturer":"Auchan","market_name":"S4S5IN4G","codename":"S4S5IN4G","model":"S4S5IN4G"},{"manufacturer":"Auchan","market_name":"S4S6IN3G","codename":"S4S6IN3G","model":"S4S6IN3G"},{"manufacturer":"Auchan","market_name":"S4T10IN3G","codename":"S4T10IN3G","model":"S4T10IN3G"},{"manufacturer":"Auchan","market_name":"S4T7IN","codename":"S4T7IN","model":"S4T7IN"},{"manufacturer":"Auchan","market_name":"S4T7IN3G","codename":"S4T7IN3G","model":"S4T7IN3G"},{"manufacturer":"Auchan","market_name":"S4T9IN","codename":"S4T9IN","model":"S4T9IN"},{"manufacturer":"Auchan","market_name":"S5S4IN3G","codename":"S5S4IN3G","model":"S5S4IN3G"},{"manufacturer":"Auchan","market_name":"S5S5IN4G","codename":"S5S5IN4G","model":"S5S5IN4G"},{"manufacturer":"Auchan","market_name":"S5T10IN3G","codename":"S5T10IN3G","model":"S5T10IN3G"},{"manufacturer":"Auchan","market_name":"S5T7IN3G","codename":"S5T7IN3G","model":"S5T7IN3G"},{"manufacturer":"Auchan","market_name":"S5T9INDVD","codename":"S5T9INDVD","model":"S5T9INDVD"},{"manufacturer":"Auchan","market_name":"S6S4IN3G","codename":"S6S4IN3G","model":"S6S4IN3G"},{"manufacturer":"Auchan","market_name":"S6S55IN3G","codename":"S6S55IN3G","model":"S6S55IN3G"},{"manufacturer":"Auchan","market_name":"S6S5IN3G","codename":"S6S5IN3G","model":"S6S5IN3G"},{"manufacturer":"Auchan","market_name":"Selecline X35T","codename":"X35T","model":"X35T"},{"manufacturer":"Auchan","market_name":"Selecline-854599","codename":"854599","model":"Selecline-854599"},{"manufacturer":"Auchan","market_name":"\"Smartphone 5\"\" Q.4094\"","codename":"ac50bhe","model":"Q.4094"},{"manufacturer":"Audi AG","market_name":"Audi Tab CN","codename":"sdis1","model":"Audi tablet"},{"manufacturer":"Audi AG","market_name":"Audi tablet","codename":"sdis1","model":"Audi tablet"},{"manufacturer":"Audi AG","market_name":"RSE-III","codename":"RSEIII","model":"RSEIII"},{"manufacturer":"Audiovox","market_name":"T752 Tablet","codename":"AD7L","model":"T752"},{"manufacturer":"Audiovox","market_name":"T852 Tablet","codename":"MID30801","model":"T852"},{"manufacturer":"Avaya","market_name":"Vantage","codename":"K175","model":"Avaya Vantage"},{"manufacturer":"Avaya","market_name":"Vantage","codename":"K175","model":"K175"},{"manufacturer":"Avaya","market_name":"Vantage","codename":"Vantage","model":"Avaya Vantage"},{"manufacturer":"Avaya","market_name":"Vantage","codename":"Vantage","model":"K165"},{"manufacturer":"Avoca","market_name":"STB7012","codename":"STB7012","model":"STB7012"},{"manufacturer":"Avoca","market_name":"STB7013","codename":"AVOCA","model":"STB7013"},{"manufacturer":"Avoca","market_name":"STB8098","codename":"STB8098","model":"STB8098"},{"manufacturer":"Avoca","market_name":"STB9097","codename":"STB9097","model":"STB9097"},{"manufacturer":"Avvio","market_name":"Avvio A400","codename":"Avvio_A400","model":"Avvio_A400"},{"manufacturer":"Avvio","market_name":"Avvio PRO450","codename":"Avvio_Pro450","model":"Avvio_Pro450"},{"manufacturer":"Avvio","market_name":"Avvio PRO550","codename":"Avvio_Pro550","model":"Avvio_Pro550"},{"manufacturer":"Avvio","market_name":"Avvio Platinum A50","codename":"Avvio_A50","model":"Avvio_A50"},{"manufacturer":"Axioo","market_name":"Axioo AX4","codename":"Axioo_AX4","model":"Axioo_AX4"},{"manufacturer":"Azumi","market_name":"A40 Style Plus","codename":"A40_Style_Plus","model":"A40_Style_Plus"},{"manufacturer":"Azumi","market_name":"A40C","codename":"A40C","model":"A40C"},{"manufacturer":"Azumi","market_name":"A50 Style Plus","codename":"A50_Style_Plus","model":"A50_Style_Plus"},{"manufacturer":"Azumi","market_name":"A50LT","codename":"A50LT","model":"A50LT"},{"manufacturer":"Azumi","market_name":"AX5","codename":"AX5","model":"Azumi AX5"},{"manufacturer":"Azumi","market_name":"AZUMI_Daburu_A55O","codename":"Daburu_A55O","model":"Azumi_Daburu_A55O"},{"manufacturer":"Azumi","market_name":"Azumi_Extend_Akaru_55_QL","codename":"Extend_Akaru_55_QL","model":"Azumi Extend Akaru 55 QL"},{"manufacturer":"Azumi","market_name":"Azumi_KIREI_A45_D","codename":"KIREI_A45_D","model":"Azumi_KIREI_A45_D"},{"manufacturer":"Azumi","market_name":"Azumi_KIREI_A4_D","codename":"KIREI_A4_D","model":"Azumi_KIREI_A4_D"},{"manufacturer":"Azumi","market_name":"Azumi_KIREI_A5_D","codename":"KIREI_A5_D","model":"Azumi_KIREI_A5_D"},{"manufacturer":"Azumi","market_name":"Azumi_Speed_Pro_55","codename":"Speed_Pro_55","model":"Azumi_Speed_Pro_55"},{"manufacturer":"Azumi","market_name":"DOSHI A55 QL","codename":"Azumi_DOSHI_A55_QL","model":"Azumi_DOSHI_A55_QL"},{"manufacturer":"Azumi","market_name":"EXTEND 55 QL","codename":"EXTEND_55_QL","model":"EXTEND 55 QL"},{"manufacturer":"Azumi","market_name":"IRO A4Q","codename":"IRO_A4_Q","model":"Azumi_IRO_A4_Q"},{"manufacturer":"Azumi","market_name":"IRO A4Q","codename":"IRO_A4_Q_AF","model":"Azumi_IRO_A4_Q"},{"manufacturer":"Azumi","market_name":"IRO A5 QL","codename":"IRO_A5_QL","model":"Azumi_IRO_A5_QL"},{"manufacturer":"Azumi","market_name":"IRO A5 QL","codename":"IRO_A5_QL_OM","model":"Azumi_IRO_A5_QL"},{"manufacturer":"Azumi","market_name":"IRO A5 QLT","codename":"IRO_A5_QLT","model":"Azumi_IRO_A5_QLT"},{"manufacturer":"Azumi","market_name":"IRO A55 Q","codename":"IRO_A55_Q","model":"IRO A55 Q"},{"manufacturer":"Azumi","market_name":"IRO A55 QL","codename":"IRO_A55_QL","model":"Azumi_IRO_A55_QL"},{"manufacturer":"Azumi","market_name":"IRO A5Q","codename":"IRO_A5_Q","model":"Azumi_IRO_A5_Q"},{"manufacturer":"Azumi","market_name":"IRO A5Q","codename":"IRO_A5_Q_AF","model":"Azumi_IRO_A5_Q"},{"manufacturer":"Azumi","market_name":"IRO A5QL","codename":"IRO_A5QL_V2","model":"Azumi IRO A5QL V2"},{"manufacturer":"Azumi","market_name":"IRO A5QL","codename":"IRO_A5_QL_HD","model":"Azumi_IRO_A5_QL"},{"manufacturer":"Azumi","market_name":"IRO_A4_Q_Pro","codename":"IRO_A4_Q_PRO","model":"Azumi_IRO_A4_Q_PRO"},{"manufacturer":"Azumi","market_name":"IRO_A55_Q_Pro","codename":"IRO_A55_Q_Pro","model":"Azumi IRO A55 Q Pro"},{"manufacturer":"Azumi","market_name":"IRO_A6_Q","codename":"IRO_A6_Q","model":"IRO A6 Q"},{"manufacturer":"Azumi","market_name":"KINZO A55 OLi","codename":"KINZO_A55_OLi","model":"Azumi_KINZO_A55_OLi"},{"manufacturer":"Azumi","market_name":"KINZO A55QL","codename":"KINZO_A55_OLi_CL","model":"Azumi_KINZO_A55_OLi"},{"manufacturer":"Azumi","market_name":"KINZO ICHI A5 QL","codename":"KINZO_ichi_A5_QL_NA","model":"KINZO_ichi_A5_QL"},{"manufacturer":"Azumi","market_name":"Speed 55","codename":"Speed_55","model":"Speed_55"},{"manufacturer":"Azumi","market_name":"T7 3G","codename":"T7_3G","model":"Azumi_T7_3G"},{"manufacturer":"BGH S.A.","market_name":"BGH Joy 303","codename":"BGH_Joy_303","model":"BGH Joy 303"},{"manufacturer":"BKAV","market_name":"B2017","codename":"B2017","model":"B2017"},{"manufacturer":"BKAV","market_name":"B2017","codename":"B2017","model":"Bphone B2017"},{"manufacturer":"BKAV","market_name":"Bphone","codename":"Bphone","model":"Bphone B1111"},{"manufacturer":"BKAV","market_name":"Bphone","codename":"Bphone","model":"Bphone B1112"},{"manufacturer":"BKAV","market_name":"Bphone","codename":"Bphone","model":"Bphone B1114"},{"manufacturer":"BKAV","market_name":"Bphone","codename":"Bphone","model":"Bphone B1115"},{"manufacturer":"BKAV","market_name":"Bphone","codename":"Bphone","model":"Bphone B1116"},{"manufacturer":"BLECK","market_name":"ELEMENT","codename":"ELEMENT","model":"ELEMENT"},{"manufacturer":"BMobile","market_name":"AX1010","codename":"Bmobile_AX1010","model":"AX1010"},{"manufacturer":"BMobile","market_name":"AX1010","codename":"Bmobile_AX1010","model":"Bmobile AX1010"},{"manufacturer":"BMobile","market_name":"AX1015","codename":"Bmobile_AX1015","model":"AX1015"},{"manufacturer":"BMobile","market_name":"AX1015","codename":"Bmobile_AX1015A","model":"AX1015"},{"manufacturer":"BMobile","market_name":"AX1016","codename":"Bmobile_AX1016","model":"AX1016"},{"manufacturer":"BMobile","market_name":"AX1020","codename":"Bmobile","model":"AX1020"},{"manufacturer":"BMobile","market_name":"AX1020","codename":"Bmobile_AX1020","model":"AX1020"},{"manufacturer":"BMobile","market_name":"AX1030","codename":"Bmobile_AX1030","model":"AX1030"},{"manufacturer":"BMobile","market_name":"AX1035","codename":"Bmobile_AX1035","model":"AX1035"},{"manufacturer":"BMobile","market_name":"AX1040","codename":"Bmobile_AX1040","model":"AX1040"},{"manufacturer":"BMobile","market_name":"AX1045E","codename":"Bmobile_AX1045","model":"AX1045"},{"manufacturer":"BMobile","market_name":"AX1055","codename":"Bmobile","model":"AX1055"},{"manufacturer":"BMobile","market_name":"AX1055","codename":"Bmobile_AX1055","model":"AX1055"},{"manufacturer":"BMobile","market_name":"AX1060","codename":"AX1060","model":"AX1060"},{"manufacturer":"BMobile","market_name":"AX1065","codename":"Bmobile_AX1065","model":"AX1065"},{"manufacturer":"BMobile","market_name":"AX1065E","codename":"Bmobile_AX1065E","model":"AX1065E"},{"manufacturer":"BMobile","market_name":"AX1070E","codename":"BMOBILE_AX1070","model":"AX1070"},{"manufacturer":"BMobile","market_name":"AX1070E","codename":"Bmobile_AX1070","model":"AX1070"},{"manufacturer":"BMobile","market_name":"AX1071","codename":"Bmobile_AX1071","model":"AX1071"},{"manufacturer":"BMobile","market_name":"AX1072","codename":"Bmobile_AX1072","model":"AX1072"},{"manufacturer":"BMobile","market_name":"AX1073","codename":"Bmobile_AX1073","model":"AX1073"},{"manufacturer":"BMobile","market_name":"AX1075","codename":"Bmobile_AX1075","model":"AX1075"},{"manufacturer":"BMobile","market_name":"AX1085","codename":"Bmobile_AX1085","model":"AX1085"},{"manufacturer":"BMobile","market_name":"AX1091","codename":"Bmobile_AX1091","model":"AX1091"},{"manufacturer":"BMobile","market_name":"AX1091","codename":"Bmobile_AX1091","model":"Bmobile_AX1091"},{"manufacturer":"BMobile","market_name":"AX1091","codename":"Bmobile_AX1091A","model":"AX1091"},{"manufacturer":"BMobile","market_name":"AX660","codename":"Bmobile","model":"AX660"},{"manufacturer":"BMobile","market_name":"AX680+","codename":"Bmobile_AX680_","model":"AX680+"},{"manufacturer":"BMobile","market_name":"AX681","codename":"Bmobile_AX681","model":"AX681"},{"manufacturer":"BMobile","market_name":"AX681","codename":"Bmobile_AX681A","model":"AX681"},{"manufacturer":"BMobile","market_name":"AX683","codename":"Bmobile_AX683","model":"AX683"},{"manufacturer":"BMobile","market_name":"AX684","codename":"Bmobile_AX684","model":"AX684"},{"manufacturer":"BMobile","market_name":"AX685","codename":"Bmobile_AX685","model":"AX685"},{"manufacturer":"BMobile","market_name":"AX685","codename":"Bmobile_AX685","model":"Bmobile_AX685"},{"manufacturer":"BMobile","market_name":"AX686","codename":"Bmobile_AX686","model":"AX686"},{"manufacturer":"BMobile","market_name":"AX700","codename":"Bmobile","model":"AX7OO"},{"manufacturer":"BMobile","market_name":"AX810","codename":"Bmobile","model":"Bmobile_AX810"},{"manufacturer":"BMobile","market_name":"AX810","codename":"Bmobile_AX810","model":"Bmobile_AX810"},{"manufacturer":"BMobile","market_name":"AX820","codename":"Bmobile_AX820","model":"AX820"},{"manufacturer":"BMobile","market_name":"AX821","codename":"Bmobile_AX821","model":"AX821"},{"manufacturer":"BMobile","market_name":"AX822","codename":"Bmobile_AX822","model":"AX822"},{"manufacturer":"BMobile","market_name":"AX822","codename":"Bmobile_AX822A","model":"AX822"},{"manufacturer":"BMobile","market_name":"AX823","codename":"Bmobile_AX823","model":"AX823"},{"manufacturer":"BMobile","market_name":"AX823","codename":"Bmobile_AX823a","model":"AX823"},{"manufacturer":"BMobile","market_name":"AX825","codename":"Bmobile_AX825","model":"AX825"},{"manufacturer":"BMobile","market_name":"AX920","codename":"Bmobile_AX920","model":"AX920"},{"manufacturer":"BMobile","market_name":"AX921","codename":"Bmobile_AX921","model":"AX921"},{"manufacturer":"BMobile","market_name":"AX921","codename":"Bmobile_AX921","model":"Bmobile_AX921"},{"manufacturer":"BMobile","market_name":"AX922","codename":"Bmobile_AX922","model":"AX922"},{"manufacturer":"BMobile","market_name":"AX950","codename":"Bmobile_AX950","model":"AX950"},{"manufacturer":"BQru","market_name":"5060","codename":"BQru-5060","model":"BQru-5060"},{"manufacturer":"BQru","market_name":"5701L Slim","codename":"BQru-5701L","model":"BQ-5701L"},{"manufacturer":"BQru","market_name":"BQ 5503 NICE 2","codename":"BQru_5503","model":"BQru-5503"},{"manufacturer":"BQru","market_name":"BQ-1045G","codename":"BQru-1045","model":"BQ-1045"},{"manufacturer":"BQru","market_name":"BQ-1056L","codename":"BQru_1056L","model":"BQru-1056L"},{"manufacturer":"BQru","market_name":"BQ-1057L","codename":"BQru_1057L","model":"BQru-1057L"},{"manufacturer":"BQru","market_name":"BQ-4028UP!","codename":"BQru-4028","model":"BQru-4028"},{"manufacturer":"BQru","market_name":"BQ-4072 Strike Mini","codename":"BQru_4072","model":"BQru-4072"},{"manufacturer":"BQru","market_name":"BQ-4077","codename":"BQru-4077","model":"BQ-4077"},{"manufacturer":"BQru","market_name":"BQ-4500L","codename":"BQru-4500","model":"BQru-4500"},{"manufacturer":"BQru","market_name":"BQ-4585 Fox View","codename":"BQru-4585","model":"BQ-4585"},{"manufacturer":"BQru","market_name":"BQ-5000L","codename":"BQru-5000","model":"BQru-5000"},{"manufacturer":"BQru","market_name":"BQ-5001L Contact","codename":"BQru-5001L","model":"BQ-5001L"},{"manufacturer":"BQru","market_name":"BQ-5003L Shark Pro","codename":"BQru_5003L","model":"BQ-5003L"},{"manufacturer":"BQru","market_name":"BQ-5005L INTENSE","codename":"BQru_5005L","model":"BQ-5005L"},{"manufacturer":"BQru","market_name":"BQ-5007L IRON","codename":"BQru-5007L","model":"BQ-5007L"},{"manufacturer":"BQru","market_name":"BQ-5008L Brave","codename":"BQru-5008L","model":"BQ-5008L"},{"manufacturer":"BQru","market_name":"BQ-5009L","codename":"BQru_5009L","model":"BQ-5009L"},{"manufacturer":"BQru","market_name":"BQ-5012L","codename":"BQru_5012L","model":"BQ-5012L"},{"manufacturer":"BQru","market_name":"BQ-5033 Shark","codename":"BQru_5033","model":"BQru-5033"},{"manufacturer":"BQru","market_name":"BQ-5035 Velvet","codename":"BQru-5035","model":"BQru-5035"},{"manufacturer":"BQru","market_name":"BQ-5044 Strike LTE","codename":"BQru-5044","model":"BQru-5044"},{"manufacturer":"BQru","market_name":"BQ-5056 Fresh","codename":"BQru-5056","model":"BQ-5056"},{"manufacturer":"BQru","market_name":"BQ-5057 Strike 2","codename":"BQru_5057","model":"BQru-5057"},{"manufacturer":"BQru","market_name":"BQ-5058 Strike Power Easy","codename":"BQru-5058","model":"BQru_BQru-5058"},{"manufacturer":"BQru","market_name":"BQ-5059 Strike Power","codename":"BQru_5059","model":"BQru-5059"},{"manufacturer":"BQru","market_name":"BQ-5201","codename":"BQru-5201","model":"BQ-5201"},{"manufacturer":"BQru","market_name":"BQ-5201","codename":"BQru-5201","model":"BQru-5201"},{"manufacturer":"BQru","market_name":"BQ-5202","codename":"BQru-5202","model":"BQru-5202"},{"manufacturer":"BQru","market_name":"BQ-5203 Shark","codename":"BQru-5203","model":"BQru-5203"},{"manufacturer":"BQru","market_name":"BQ-5204 Strike Selfie","codename":"BQru-5204","model":"BQru-5204"},{"manufacturer":"BQru","market_name":"BQ-5206L Balance","codename":"BQru-5206L","model":"BQ-5206L"},{"manufacturer":"BQru","market_name":"BQ-5209L","codename":"BQru-5209L","model":"BQ-5209L"},{"manufacturer":"BQru","market_name":"BQ-5211","codename":"BQru-5211","model":"BQ-5211"},{"manufacturer":"BQru","market_name":"BQ-5301","codename":"BQru-5301","model":"BQ-5301"},{"manufacturer":"BQru","market_name":"BQ-5340 Choice","codename":"BQru-5340","model":"BQ-5340"},{"manufacturer":"BQru","market_name":"BQ-5500L Advance","codename":"BQru-5500L","model":"BQ-5500L"},{"manufacturer":"BQru","market_name":"BQ-5504\\xc2\\xa0Strike\\xc2\\xa0Selfie\\xc2\\xa0Max","codename":"BQru_5504","model":"BQru-5504"},{"manufacturer":"BQru","market_name":"BQ-5507L IRON MAX","codename":"BQru-5507L","model":"BQ-5507L"},{"manufacturer":"BQru","market_name":"BQ-5508L","codename":"BQru-5508L","model":"BQ-5508L"},{"manufacturer":"BQru","market_name":"BQ-5510 Strike Power Max 4G","codename":"BQru_5510","model":"BQru-5510"},{"manufacturer":"BQru","market_name":"BQ-5511L","codename":"BQru_5511L","model":"BQ-5511L"},{"manufacturer":"BQru","market_name":"BQ-5521 STRIKE POWER MAX","codename":"BQru-5521","model":"BQru-5521"},{"manufacturer":"BQru","market_name":"BQ-5522\\xc2\\xa0Next","codename":"BQru-5522","model":"BQ-5522"},{"manufacturer":"BQru","market_name":"BQ-5590 Spring","codename":"BQru_5590","model":"BQru_5590"},{"manufacturer":"BQru","market_name":"BQ-5591 Jeans","codename":"BQru-5591","model":"BQ-5591"},{"manufacturer":"BQru","market_name":"BQ-5594 Strike Power Max","codename":"BQru_5594","model":"BQ-5594"},{"manufacturer":"BQru","market_name":"BQ-5700L Space X","codename":"BQru-5700L","model":"BQ-5700L"},{"manufacturer":"BQru","market_name":"BQ-5702","codename":"BQru_5702","model":"BQ-5702"},{"manufacturer":"BQru","market_name":"BQ-5707G Next Music","codename":"BQru-5707G","model":"BQ-5707G"},{"manufacturer":"BQru","market_name":"BQ-6000L Aurora","codename":"BQru-6000L","model":"BQ-6000L"},{"manufacturer":"BQru","market_name":"BQ-6001 L","codename":"BQru-6001L","model":"BQ-6001L"},{"manufacturer":"BQru","market_name":"BQ-6015L Universe","codename":"BQru-6015L","model":"BQ-6015L"},{"manufacturer":"BQru","market_name":"BQ-7022G","codename":"BQru-7022","model":"BQ-7022"},{"manufacturer":"BQru","market_name":"BQ-7081G","codename":"BQru-7081","model":"BQru-7081"},{"manufacturer":"BQru","market_name":"BQ-7084G","codename":"BQru-7084G","model":"BQ-7084G"},{"manufacturer":"BQru","market_name":"BQ-8041L","codename":"BQru-8041L","model":"BQ-8041L"},{"manufacturer":"BQru","market_name":"BQru-1077L","codename":"BQru-1077L","model":"BQ-1077L"},{"manufacturer":"BQru","market_name":"BQru-1081G","codename":"BQru-1081G","model":"BQru-1081G"},{"manufacturer":"BQru","market_name":"BQru-1082G","codename":"BQru-1082G","model":"BQ-1082G"},{"manufacturer":"BQru","market_name":"BQru-1083G","codename":"BQru-1083G","model":"BQ-1083G"},{"manufacturer":"BQru","market_name":"BQru-4526","codename":"BQru-4526","model":"BQru-4526"},{"manufacturer":"BQru","market_name":"BQru-5022","codename":"BQru","model":"BQru-5022"},{"manufacturer":"BQru","market_name":"BQru-7082","codename":"BQru-7082","model":"BQru-7082"},{"manufacturer":"BQru","market_name":"BQru-7083","codename":"BQru-7083","model":"BQru-7083"},{"manufacturer":"BQru","market_name":"Bqru-5037","codename":"BQru-5037","model":"BQru-5037"},{"manufacturer":"BQru","market_name":"CRYSTAL","codename":"BQru-5054","model":"BQru-5054"},{"manufacturer":"BQru","market_name":"FOX  POWER","codename":"BQru-4583","model":"BQru-4583"},{"manufacturer":"BQru","market_name":"FOX POWER","codename":"BQru-4583","model":"BQru-4583"},{"manufacturer":"BYD","market_name":"DynaVox T10","codename":"T10","model":"T10"},{"manufacturer":"BYD","market_name":"FarEastone Smart 502","codename":"Smart502","model":"Smart 502"},{"manufacturer":"BYD","market_name":"INHON G3","codename":"G3","model":"G3"},{"manufacturer":"BYD","market_name":"K-Touch E815","codename":"E815","model":"E815"},{"manufacturer":"BYD","market_name":"M601","codename":"M601","model":"M601"},{"manufacturer":"BYD","market_name":"Moii E996+","codename":"E996plus","model":"moii E996+"},{"manufacturer":"BYD","market_name":"PT452E","codename":"PT452E","model":"Digma Linx 4.5 PT452E"},{"manufacturer":"BYD","market_name":"Prestigio PAP5430","codename":"PAP5430","model":"PAP5430"},{"manufacturer":"BYD","market_name":"SI4301","codename":"SI4301","model":"SI4301"},{"manufacturer":"BYD","market_name":"SOLO S450","codename":"S450","model":"S450"},{"manufacturer":"BYD","market_name":"SP355AWG","codename":"msm7627a_sku3","model":"SP355AWG"},{"manufacturer":"BYD","market_name":"Smart 401","codename":"tianyu72_wet_jb3","model":"Smart 401"},{"manufacturer":"BYD","market_name":"Smart 402","codename":"hawaii_garnet_c_w68tk","model":"Smart402"},{"manufacturer":"BYD","market_name":"Solo S350","codename":"S350","model":"S350"},{"manufacturer":"BYD","market_name":"WISKY W032I","codename":"W032I","model":"W032I"},{"manufacturer":"BYD","market_name":"X910","codename":"X910","model":"XOLO X910"},{"manufacturer":"BYD","market_name":"Zippers","codename":"Zippers","model":"Vexia Zippers"},{"manufacturer":"Bang & Olufsen","market_name":"BeoVision","codename":"bno_MT5593Uplus_EU","model":"QM153E"},{"manufacturer":"Barel","market_name":"Cavion Solid 4.5","codename":"Cavion_Solid_4_5","model":"Cavion_Solid_4_5"},{"manufacturer":"Barnes and Noble","market_name":"HD","codename":"hummingbird","model":"BNTV400"},{"manufacturer":"Barnes and Noble","market_name":"HD+","codename":"ovation","model":"BNTV600"},{"manufacturer":"Barnes and Noble","market_name":"NOOK\\xc2\\xae HD","codename":"hummingbird","model":"BNTV400"},{"manufacturer":"Barnes and Noble","market_name":"NOOK\\xc2\\xae HD+","codename":"ovation","model":"BNTV600"},{"manufacturer":"Becrypt","market_name":"Convex 430","codename":"granite","model":"Becrypt Convex 430"},{"manufacturer":"Becrypt","market_name":"Convex 430","codename":"granite","model":"Becrypt Indigo 430"},{"manufacturer":"Beeline","market_name":"Beeline\\xc2\\xa0Pro 4","codename":"Beeline_Pro_4","model":"Beeline Pro 4"},{"manufacturer":"Beeline","market_name":"Beeline\\xc2\\xa0Tab Fast 2","codename":"z701","model":"Beeline Tab Fast 2"},{"manufacturer":"Beeline","market_name":"Beeline\\xc2\\xa0Tab\\xc2\\xa0Pro","codename":"BeelineTabPro","model":"Beeline Tab Pro"},{"manufacturer":"Beeline","market_name":"Fast","codename":"Fast","model":"Beeline Fast"},{"manufacturer":"Beeline","market_name":"Fast HD","codename":"Beeline_Fast_HD","model":"Beeline Fast HD"},{"manufacturer":"Beeline","market_name":"Fast-Plus","codename":"Fast_Plus","model":"Beeline Fast +"},{"manufacturer":"Beeline","market_name":"Pro 2","codename":"Beeline_Pro_2","model":"Beeline Pro 2"},{"manufacturer":"Beeline","market_name":"Pro 3","codename":"Pro_3","model":"Beeline_Pro_3"},{"manufacturer":"Beeline","market_name":"Pro 6","codename":"Beeline_Pro_6","model":"Beeline_Pro_6"},{"manufacturer":"Beeline","market_name":"Pro5","codename":"Beeline_Pro_5","model":"A451"},{"manufacturer":"Beeline","market_name":"Smart 6","codename":"Beeline_Smart_6","model":"Beeline Smart 6"},{"manufacturer":"Beeline","market_name":"Smart Dual","codename":"Beeline","model":"Beeline Smart Dual"},{"manufacturer":"Beeline","market_name":"Smart_8","codename":"Beeline_Smart_8","model":"A221"},{"manufacturer":"Beeline","market_name":"Smart_8","codename":"Beeline_Smart_8","model":"A239"},{"manufacturer":"Beeline","market_name":"Tab","codename":"Beeline_Tab","model":"Beeline Tab"},{"manufacturer":"Beeline","market_name":"Tab 2","codename":"Tab_2","model":"Tab_2"},{"manufacturer":"Beeline","market_name":"Tab IS","codename":"Beeline_Tab_IS","model":"Beeline_Tab_IS"},{"manufacturer":"Beeline","market_name":"Tab_Fast","codename":"Beeline_Tab_Fast","model":"Beeline_Tab_Fast"},{"manufacturer":"BenQ","market_name":"A3","codename":"A3","model":"A3"},{"manufacturer":"BenQ","market_name":"A3c","codename":"BenQ_A3c","model":"BenQ A3c"},{"manufacturer":"BenQ","market_name":"Agora 4G","codename":"Agora_4G","model":"Agora 4G"},{"manufacturer":"BenQ","market_name":"Agora_4G_Pro","codename":"Agora_4G_Pro","model":"Agora 4G Pro"},{"manufacturer":"BenQ","market_name":"Agora_Lite","codename":"Agora_Lite","model":"Agora Lite"},{"manufacturer":"BenQ","market_name":"B50","codename":"B50","model":"B50"},{"manufacturer":"BenQ","market_name":"B502","codename":"B502","model":"B502"},{"manufacturer":"BenQ","market_name":"B502","codename":"B502","model":"B502_SA"},{"manufacturer":"BenQ","market_name":"B505","codename":"B505","model":"B505"},{"manufacturer":"BenQ","market_name":"B506","codename":"B506_TW","model":"B506_TW"},{"manufacturer":"BenQ","market_name":"B50_CHT","codename":"B50","model":"B50_CHT"},{"manufacturer":"BenQ","market_name":"F3","codename":"F3","model":"F3"},{"manufacturer":"BenQ","market_name":"F4","codename":"benq_a3s","model":"BenQ A3s"},{"manufacturer":"BenQ","market_name":"F5","codename":"BENQ_F5","model":"BenQ F5"},{"manufacturer":"BenQ","market_name":"F5","codename":"F5","model":"BenQ F5"},{"manufacturer":"BenQ","market_name":"F52","codename":"F52","model":"F52_05"},{"manufacturer":"BenQ","market_name":"F52_09","codename":"F52","model":"F52_09"},{"manufacturer":"BenQ","market_name":"F55","codename":"F55","model":"BenQ F55"},{"manufacturer":"BenQ","market_name":"F55J","codename":"F55J","model":"BenQ F55J"},{"manufacturer":"BenQ","market_name":"F5_06","codename":"F5","model":"F5_06"},{"manufacturer":"BenQ","market_name":"F5_13","codename":"F5","model":"F5_13"},{"manufacturer":"BenQ","market_name":"F5_15","codename":"F5","model":"F5_15"},{"manufacturer":"BenQ","market_name":"F5_16","codename":"F5","model":"F5_16"},{"manufacturer":"BenQ","market_name":"F5_18","codename":"F5","model":"F5_18"},{"manufacturer":"BenQ","market_name":"F5_19","codename":"F5","model":"F5_19"},{"manufacturer":"BenQ","market_name":"Harrier","codename":"Harrier","model":"Harrier from EE"},{"manufacturer":"BenQ","market_name":"Harrier Mini","codename":"harrier_mini","model":"Harrier Mini from EE"},{"manufacturer":"BenQ","market_name":"Harrier Tab","codename":"harrier_tab","model":"Harrier Tab from EE"},{"manufacturer":"BenQ","market_name":"JD-150","codename":"JD-150_P1","model":"JD-150"},{"manufacturer":"BenQ","market_name":"JM-250","codename":"JM-250","model":"JM-250"},{"manufacturer":"BenQ","market_name":"JM-250","codename":"JM-250_P1","model":"JM-250"},{"manufacturer":"BenQ","market_name":"Kogan 4G+","codename":"Agora_4G_PLUS","model":"Agora 4G+"},{"manufacturer":"BenQ","market_name":"Kogan Agora 4G Lite","codename":"B506","model":"Kogan Agora 4G Lite"},{"manufacturer":"BenQ","market_name":"PT2200","codename":"PT2200","model":"PT2200"},{"manufacturer":"BenQ","market_name":"T3","codename":"T3","model":"BenQ T3"},{"manufacturer":"BenQ","market_name":"T3","codename":"T3_17A","model":"BenQ T3"},{"manufacturer":"BenQ","market_name":"T3_08","codename":"T3_17A","model":"BenQ T3"},{"manufacturer":"BenQ","market_name":"T3_17A","codename":"T3_17A","model":"BenQ T3"},{"manufacturer":"BenQ","market_name":"T47","codename":"T47","model":"T47_05"},{"manufacturer":"BenQ","market_name":"T47_09","codename":"T47","model":"T47_09"},{"manufacturer":"BenQ","market_name":"T55","codename":"T55","model":"T55"},{"manufacturer":"Benesse","market_name":"TAB-A03-BR","codename":"TAB-A03-BR","model":"TAB-A03-BR"},{"manufacturer":"Benesse","market_name":"TAB-A03-BS","codename":"TAB-A03-BS","model":"TAB-A03-BS"},{"manufacturer":"Bentley","market_name":"Tab","codename":"sdis1","model":"BENTLEY ENTERTAINMENT TABLET"},{"manufacturer":"Best Buy","market_name":"Transformer Pad (TF103C)","codename":"K010","model":"K010"},{"manufacturer":"Bigben","market_name":"BB8252","codename":"Bigben-TAB","model":"BB8252"},{"manufacturer":"Bigben","market_name":"GAMETAB-ONE","codename":"GAMETAB-ONE","model":"GAMETAB-ONE"},{"manufacturer":"Billion","market_name":"Billion Capture+","codename":"rimoB","model":"Capture+"},{"manufacturer":"Binatone","market_name":"SMART64","codename":"SMART64","model":"SMART64"},{"manufacturer":"Binatone","market_name":"Smart 63","codename":"SMART63","model":"SMART63"},{"manufacturer":"Binatone","market_name":"Smart 66","codename":"SMART66","model":"SMART66"},{"manufacturer":"Bitel","market_name":"B8416","codename":"B8416","model":"B8416"},{"manufacturer":"Bitel","market_name":"B9401","codename":"B9401","model":"B9401"},{"manufacturer":"Bitel","market_name":"B9502","codename":"B9502","model":"B9502"},{"manufacturer":"Bitel","market_name":"B9504","codename":"B9504","model":"B9504"},{"manufacturer":"Bitel","market_name":"B9505","codename":"4G_Smart_Phone_B9505","model":"B9505"},{"manufacturer":"Bitel","market_name":"M50","codename":"M50","model":"M50"},{"manufacturer":"Bitel","market_name":"Pro 9","codename":"PRO9","model":"PRO9"},{"manufacturer":"Bitmore","market_name":"GTAB700","codename":"GTAB700","model":"NID_7010"},{"manufacturer":"Bitmore","market_name":"GTAB900","codename":"GTAB900","model":"S952"},{"manufacturer":"Bitmore","market_name":"LUXYA MID704DC Tablet / Bitmore Tab770","codename":"MY7317P","model":"Tab770"},{"manufacturer":"Bitmore","market_name":"Tab870","codename":"Tab870","model":"Tab870"},{"manufacturer":"Bittium","market_name":"Air-Lynx ALS14000","codename":"granite","model":"Bittium Tough Mobile"},{"manufacturer":"Bittium","market_name":"Mx Smart","codename":"adakite_sm","model":"Mx Smart"},{"manufacturer":"Bittium","market_name":"Tough Mobile","codename":"granite","model":"Bittium Tough Mobile"},{"manufacturer":"BlackBerry","market_name":"Aurora","codename":"bbc100","model":"BBC100-1"},{"manufacturer":"BlackBerry","market_name":"BlackBerry KEY2","codename":"bbf100","model":"BBF100-1"},{"manufacturer":"BlackBerry","market_name":"BlackBerry KEY2","codename":"bbf100","model":"BBF100-2"},{"manufacturer":"BlackBerry","market_name":"BlackBerry KEY2","codename":"bbf100","model":"BBF100-4"},{"manufacturer":"BlackBerry","market_name":"BlackBerry KEY2","codename":"bbf100","model":"BBF100-6"},{"manufacturer":"BlackBerry","market_name":"BlackBerry KEYone","codename":"bbb100","model":"BBB100-7"},{"manufacturer":"BlackBerry","market_name":"BlackBerry MOTION","codename":"bbd100","model":"BBD100-1"},{"manufacturer":"BlackBerry","market_name":"BlackBerry MOTION","codename":"bbd100","model":"BBD100-2"},{"manufacturer":"BlackBerry","market_name":"BlackBerry MOTION","codename":"bbd100","model":"BBD100-6"},{"manufacturer":"BlackBerry","market_name":"Blackberry Keyone","codename":"bbb100","model":"BBB100-7"},{"manufacturer":"BlackBerry","market_name":"DTEK50","codename":"hamburg","model":"STH100-1"},{"manufacturer":"BlackBerry","market_name":"DTEK50","codename":"hamburg","model":"STH100-2"},{"manufacturer":"BlackBerry","market_name":"DTEK50 by BlackBerry","codename":"hamburg","model":"STH100-1"},{"manufacturer":"BlackBerry","market_name":"DTEK50 by BlackBerry","codename":"hamburg","model":"STH100-2"},{"manufacturer":"BlackBerry","market_name":"DTEK60","codename":"argon","model":"BBA100-1"},{"manufacturer":"BlackBerry","market_name":"DTEK60","codename":"argon","model":"BBA100-2"},{"manufacturer":"BlackBerry","market_name":"DTEK60 by BlackBerry","codename":"argon","model":"BBA100-1"},{"manufacturer":"BlackBerry","market_name":"DTEK60 by BlackBerry","codename":"argon","model":"BBA100-2"},{"manufacturer":"BlackBerry","market_name":"KEYone","codename":"bbb100","model":"BBB100-1"},{"manufacturer":"BlackBerry","market_name":"KEYone","codename":"bbb100","model":"BBB100-2"},{"manufacturer":"BlackBerry","market_name":"KEYone","codename":"bbb100","model":"BBB100-3"},{"manufacturer":"BlackBerry","market_name":"KEYone","codename":"bbb100","model":"BBB100-4"},{"manufacturer":"BlackBerry","market_name":"KEYone","codename":"bbb100","model":"BBB100-5"},{"manufacturer":"BlackBerry","market_name":"KEYone","codename":"bbb100","model":"BBB100-6"},{"manufacturer":"BlackBerry","market_name":"PRIV by BlackBerry","codename":"venice","model":"STV100-1"},{"manufacturer":"BlackBerry","market_name":"PRIV by BlackBerry","codename":"venice","model":"STV100-2"},{"manufacturer":"BlackBerry","market_name":"PRIV by BlackBerry","codename":"venice","model":"STV100-3"},{"manufacturer":"BlackBerry","market_name":"PRIV by BlackBerry","codename":"venice","model":"STV100-4"},{"manufacturer":"Blackfox","market_name":"BMM541D","codename":"BMM541D","model":"BMM541D"},{"manufacturer":"Blackfox","market_name":"BMM542D","codename":"BMM542D","model":"BMM542D"},{"manufacturer":"Blackfox","market_name":"BMM_533D","codename":"BMM_533D","model":"BMM_533D"},{"manufacturer":"Blackview","market_name":"A5","codename":"A5","model":"A5"},{"manufacturer":"Blackview","market_name":"A7","codename":"A7","model":"A7"},{"manufacturer":"Blackview","market_name":"A7PRO","codename":"A7Pro","model":"A7Pro"},{"manufacturer":"Blackview","market_name":"A8 MAX","codename":"A8_MAX","model":"A8 MAX"},{"manufacturer":"Blackview","market_name":"A9 Pro","codename":"A9_Pro","model":"A9_Pro"},{"manufacturer":"Blackview","market_name":"BV4000","codename":"BV4000","model":"BV4000"},{"manufacturer":"Blackview","market_name":"BV4000Pro_RU","codename":"BV4000Pro","model":"BV4000Pro-RU"},{"manufacturer":"Blackview","market_name":"BV6000","codename":"Blackview","model":"BV6000"},{"manufacturer":"Blackview","market_name":"BV6000","codename":"SOLID_4G1","model":"SOLID_4G1"},{"manufacturer":"Blackview","market_name":"BV6000S_RU","codename":"BV6000S_RU","model":"BV6000S_RU"},{"manufacturer":"Blackview","market_name":"BV6000_RU","codename":"BV6000_RU","model":"BV6000_RU"},{"manufacturer":"Blackview","market_name":"BV6000s","codename":"BV6000S","model":"BV6000S"},{"manufacturer":"Blackview","market_name":"BV7000","codename":"BV7000","model":"BV7000"},{"manufacturer":"Blackview","market_name":"BV7000 Pro","codename":"BV7000_Pro","model":"BV7000 Pro"},{"manufacturer":"Blackview","market_name":"BV7000Pro_RU","codename":"BV7000_Pro","model":"BV7000 Pro"},{"manufacturer":"Blackview","market_name":"BV7000_RU","codename":"BV7000","model":"BV7000"},{"manufacturer":"Blackview","market_name":"BV8000 Pro","codename":"BV8000Pro","model":"BV8000Pro"},{"manufacturer":"Blackview","market_name":"BV8000Pro_RU","codename":"BV8000Pro_RU","model":"BV8000Pro_RU"},{"manufacturer":"Blackview","market_name":"BV9000","codename":"BV9000","model":"BV9000"},{"manufacturer":"Blackview","market_name":"BV9000 Pro","codename":"BV9000Pro","model":"BV9000Pro"},{"manufacturer":"Blackview","market_name":"BV9000 Pro-F","codename":"BV9000Pro-F","model":"BV9000Pro-F"},{"manufacturer":"Blackview","market_name":"BV9000-F","codename":"BV9000-F","model":"BV9000-F"},{"manufacturer":"Blackview","market_name":"BV9000-RU","codename":"BV9000-RU","model":"BV9000-RU"},{"manufacturer":"Blackview","market_name":"BV9000-RU","codename":"BV9000Pro-RU","model":"BV9000Pro-RU"},{"manufacturer":"Blackview","market_name":"Blackview A10","codename":"A10","model":"A10"},{"manufacturer":"Blackview","market_name":"Blackview BV4000","codename":"BV4000","model":"BV4000"},{"manufacturer":"Blackview","market_name":"Blackview BV4000Pro","codename":"BV4000Pro","model":"BV4000Pro"},{"manufacturer":"Blackview","market_name":"Blackview P2","codename":"P2","model":"P2"},{"manufacturer":"Blackview","market_name":"Business_4_G1","codename":"Business_4_G1","model":"Business_4_G1"},{"manufacturer":"Blackview","market_name":"E7S","codename":"E7s","model":"E7s"},{"manufacturer":"Blackview","market_name":"P10000 Pro","codename":"P10000_Pro","model":"P10000 Pro"},{"manufacturer":"Blackview","market_name":"P2 Lite","codename":"P2Lite","model":"P2Lite"},{"manufacturer":"Blackview","market_name":"P6000","codename":"P6000","model":"P6000"},{"manufacturer":"Blackview","market_name":"S6","codename":"S6","model":"S6"},{"manufacturer":"Blackview","market_name":"S8","codename":"S8","model":"S8"},{"manufacturer":"Blackview","market_name":"S8_RU","codename":"S8","model":"S8"},{"manufacturer":"Blackview","market_name":"SOLID-4G3","codename":"SOLID_4G3","model":"SOLID_4G3"},{"manufacturer":"Blackview","market_name":"SOLID_4_G2","codename":"SOLID_4_G2","model":"SOLID 4 G2"},{"manufacturer":"Blaupunkt","market_name":"Atlantis_A10_G403","codename":"Atlantis_A10_G403","model":"Atlantis_A10_G403"},{"manufacturer":"Blaupunkt","market_name":"Blaupunkt SL 01","codename":"Blaupunkt_SL_01","model":"Blaupunkt SL 01"},{"manufacturer":"Blaupunkt","market_name":"Blaupunkt SL 02","codename":"Blaupunkt_SL_02","model":"Blaupunkt SL 02"},{"manufacturer":"Blaupunkt","market_name":"Blaupunkt SL 04","codename":"Blaupunkt_SL_04","model":"Blaupunkt SL 04"},{"manufacturer":"Blaupunkt","market_name":"Blaupunkt SM 01","codename":"Blaupunkt_SM_01","model":"Blaupunkt SM 01"},{"manufacturer":"Blaupunkt","market_name":"Endeavour101","codename":"Blaupunkt","model":"Endeavour101"},{"manufacturer":"Blaupunkt","market_name":"SLplus02","codename":"SLplus02","model":"SLplus02"},{"manufacturer":"Blu","market_name":"ADVANCE 4.0 L2","codename":"BLU_ADVANCE_4_0_L2","model":"BLU ADVANCE 4.0 L2"},{"manufacturer":"Blu","market_name":"ADVANCE 4.0 L3","codename":"Advance_4_0_L3","model":"Advance 4.0 L3"},{"manufacturer":"Blu","market_name":"ADVANCE 5.0 HD","codename":"Advance_5_0_HD","model":"Advance 5.0 HD"},{"manufacturer":"Blu","market_name":"Advance 4.0M","codename":"Advance_4_0M","model":"Advance 4.0M"},{"manufacturer":"Blu","market_name":"Advance 4.0M","codename":"Advance_4_0M","model":"Studio M4"},{"manufacturer":"Blu","market_name":"Advance A5 LTE","codename":"A0010WW","model":"Advance A5 LTE"},{"manufacturer":"Blu","market_name":"Advance A6","codename":"A190","model":"Advance A6"},{"manufacturer":"Blu","market_name":"Advance_5_2","codename":"A230Q","model":"Advance 5.2"},{"manufacturer":"Blu","market_name":"Advance_A7","codename":"A210","model":"Advance A7"},{"manufacturer":"Blu","market_name":"Advance\\xc2\\xa0A5\\xc2\\xa0Plus\\xc2\\xa0LTE","codename":"A0031WW","model":"Advance A5 Plus LTE"},{"manufacturer":"Blu","market_name":"BLU Grand M3","codename":"G0070WW","model":"Grand M3"},{"manufacturer":"Blu","market_name":"BLU S1","codename":"S0320WW","model":"BLU_S1"},{"manufacturer":"Blu","market_name":"BLU STUDIO J8 LTE","codename":"Studio_J8_LTE","model":"Studio J8 LTE"},{"manufacturer":"Blu","market_name":"BLU_STUDIO_G2","codename":"BLU_STUDIO_G2","model":"BLU STUDIO G2"},{"manufacturer":"Blu","market_name":"BLU_Studio_G_Max","codename":"Studio_G_Max","model":"Studio G Max"},{"manufacturer":"Blu","market_name":"BLU_Vivo_XL2","codename":"BLU_Vivo_XL2","model":"Vivo XL2"},{"manufacturer":"Blu","market_name":"C5","codename":"C010Q","model":"C5"},{"manufacturer":"Blu","market_name":"C5 LTE","codename":"C0010UU","model":"C5 LTE"},{"manufacturer":"Blu","market_name":"C5X","codename":"C0000UU","model":"C5X"},{"manufacturer":"Blu","market_name":"C5X","codename":"C0010LL","model":"C5X"},{"manufacturer":"Blu","market_name":"DASH L2","codename":"BLU_DASH_L2","model":"BLU DASH L2"},{"manufacturer":"Blu","market_name":"DASH M2","codename":"BLU_DASH_M2","model":"BLU DASH M2"},{"manufacturer":"Blu","market_name":"DASH X LTE","codename":"DASH_X_LTE","model":"BLU DASH X LTE"},{"manufacturer":"Blu","market_name":"DASH X PLUS LTE","codename":"BLU_DASH_X_PLUS_LTE","model":"DASH X PLUS LTE"},{"manufacturer":"Blu","market_name":"DASH X2","codename":"BLU_DASH_X2","model":"BLU DASH X2"},{"manufacturer":"Blu","market_name":"DIAMOND M","codename":"BLU_DIAMOND_M","model":"DIAMOND M"},{"manufacturer":"Blu","market_name":"Dash 4.5","codename":"D730","model":"Dash 4.5"},{"manufacturer":"Blu","market_name":"Dash G","codename":"Dash_G","model":"Dash G"},{"manufacturer":"Blu","market_name":"Dash L3","codename":"D931","model":"Dash L3"},{"manufacturer":"Blu","market_name":"Dash L4","codename":"D131","model":"Dash L4"},{"manufacturer":"Blu","market_name":"Dash L4 LTE","codename":"D0050","model":"Dash L4 LTE"},{"manufacturer":"Blu","market_name":"Dash L4X","codename":"D0040UU","model":"Dash L4X"},{"manufacturer":"Blu","market_name":"Dash L5 LTE","codename":"D0090WW","model":"Dash L5 LTE"},{"manufacturer":"Blu","market_name":"Dash L5X","codename":"D0070WW","model":"Dash L5X"},{"manufacturer":"Blu","market_name":"Dash X","codename":"BLU_DASH_X","model":"BLU DASH X"},{"manufacturer":"Blu","market_name":"Dash X2","codename":"Dash_X2","model":"Dash X2"},{"manufacturer":"Blu","market_name":"Dash XL","codename":"Dash_XL","model":"Dash XL"},{"manufacturer":"Blu","market_name":"Dash XL","codename":"Dash_XL","model":"Studio M5 Plus"},{"manufacturer":"Blu","market_name":"Dash_L3","codename":"Dash_L3","model":"Dash L3"},{"manufacturer":"Blu","market_name":"ENERGY  XL","codename":"BLU_ENERGY_XL","model":"ENERGY XL"},{"manufacturer":"Blu","market_name":"ENERGY DIAMOND","codename":"BLU_ENERGY_DIAMOND","model":"BLU ENERGY DIAMOND"},{"manufacturer":"Blu","market_name":"ENERGY DIAMOND MINI","codename":"ENERGY_DIAMOND_MINI","model":"ENERGY_DIAMOND_MINI"},{"manufacturer":"Blu","market_name":"ENERGY M","codename":"BLU_ENERGY_M","model":"BLU ENERGY M"},{"manufacturer":"Blu","market_name":"ENERGY X PLUS 2","codename":"BLU_ENERGY_X_PLUS_2","model":"BLU ENERGY X PLUS 2"},{"manufacturer":"Blu","market_name":"ENERGY_DIAMOND_MINI","codename":"ENERGY_DIAMOND_MINI","model":"ENERGY_DIAMOND_MINI"},{"manufacturer":"Blu","market_name":"Energy X 2","codename":"BLU_Energy_X_2","model":"Energy X 2"},{"manufacturer":"Blu","market_name":"Energy X LTE","codename":"BLU_Energy_X_LTE","model":"Energy X LTE"},{"manufacturer":"Blu","market_name":"GRAND 5.5 HD","codename":"BLU_GRAND_5_5_HD","model":"BLU GRAND 5.5 HD"},{"manufacturer":"Blu","market_name":"Grand 5.5 HD II","codename":"G210Q","model":"Grand 5.5 HD II"},{"manufacturer":"Blu","market_name":"Grand Energy","codename":"Grand_Energy","model":"Grand Energy"},{"manufacturer":"Blu","market_name":"Grand M","codename":"Grand_M","model":"Grand M"},{"manufacturer":"Blu","market_name":"Grand M2 LTE","codename":"G0040LL","model":"Grand M2 LTE"},{"manufacturer":"Blu","market_name":"Grand M2X","codename":"G0040UU","model":"Grand M2X"},{"manufacturer":"Blu","market_name":"Grand MAX","codename":"Grand_Max","model":"Grand Max"},{"manufacturer":"Blu","market_name":"Grand Mini","codename":"G170Q","model":"Grand Mini"},{"manufacturer":"Blu","market_name":"Grand X","codename":"Grand_X","model":"Grand X"},{"manufacturer":"Blu","market_name":"Grand X LTE","codename":"BLU_Grand_X_LTE","model":"BLU Grand X LTE"},{"manufacturer":"Blu","market_name":"Grand X LTE","codename":"Grand_X_LTE","model":"Grand X LTE"},{"manufacturer":"Blu","market_name":"Grand XL","codename":"Grand_XL","model":"Grand XL"},{"manufacturer":"Blu","market_name":"Grand XL LTE","codename":"G0030","model":"Grand XL LTE"},{"manufacturer":"Blu","market_name":"Grand_M2","codename":"G190","model":"Grand M2"},{"manufacturer":"Blu","market_name":"Grand_M2_LTE","codename":"G0050","model":"Grand M2 LTE"},{"manufacturer":"Blu","market_name":"Grand_X","codename":"Grand_X","model":"Grand X"},{"manufacturer":"Blu","market_name":"LIFE ONE X","codename":"BLU_LIFE_ONE_X","model":"BLU LIFE ONE X"},{"manufacturer":"Blu","market_name":"LIFE ONE X","codename":"Life_One_X","model":"Life One X"},{"manufacturer":"Blu","market_name":"LIFE ONE X2","codename":"Life_One_X2","model":"Life One X2"},{"manufacturer":"Blu","market_name":"LIFE ONE X2 MINI","codename":"Life_One_X2_Mini","model":"Life One X2 Mini"},{"manufacturer":"Blu","market_name":"LIFE XL","codename":"BLU_LIFE_XL","model":"BLU LIFE XL"},{"manufacturer":"Blu","market_name":"Life Mark","codename":"BLU_LIFE_MARK","model":"BLU LIFE MARK"},{"manufacturer":"Blu","market_name":"Life Max","codename":"Life_Max","model":"Life Max"},{"manufacturer":"Blu","market_name":"Life One X3","codename":"L0150WW","model":"Life One X3"},{"manufacturer":"Blu","market_name":"NEO ENERGY MINI","codename":"BLU_NEO_ENERGY_MINI","model":"BLU NEO ENERGY MINI"},{"manufacturer":"Blu","market_name":"NEO X","codename":"BLU_NEO_X","model":"BLU NEO X"},{"manufacturer":"Blu","market_name":"NEO X LTE","codename":"BLU_NEO_X_LTE","model":"BLU NEO X LTE"},{"manufacturer":"Blu","market_name":"NEO X MINI","codename":"BLU_NEO_X_MINI","model":"BLU NEO X MINI"},{"manufacturer":"Blu","market_name":"NEO X PLUS","codename":"BLU_NEO_X_PLUS","model":"BLU NEO X PLUS"},{"manufacturer":"Blu","market_name":"NEO XL","codename":"BLU_NEO_XL","model":"BLU NEO XL"},{"manufacturer":"Blu","market_name":"Neo X2","codename":"Neo_X2","model":"Neo X2"},{"manufacturer":"Blu","market_name":"PURE XL","codename":"BLU_PURE_XL","model":"PURE XL"},{"manufacturer":"Blu","market_name":"PURE XR","codename":"BLU_Pure_XR","model":"Pure XR"},{"manufacturer":"Blu","market_name":"Pure_View","codename":"P0050WW","model":"Pure View"},{"manufacturer":"Blu","market_name":"R1 HD","codename":"BLU_R1_HD","model":"BLU R1 HD"},{"manufacturer":"Blu","market_name":"R1 HD","codename":"R1_HD","model":"R1 HD"},{"manufacturer":"Blu","market_name":"R1 PLUS","codename":"R1_PLUS","model":"R1 PLUS"},{"manufacturer":"Blu","market_name":"R1 Plus","codename":"R1_PLUS","model":"R1 PLUS"},{"manufacturer":"Blu","market_name":"R2 LTE","codename":"R0150EE","model":"R2 LTE"},{"manufacturer":"Blu","market_name":"R2 LTE","codename":"R0170WW","model":"R2 LTE"},{"manufacturer":"Blu","market_name":"R2 Plus","codename":"R0190WW","model":"R2 Plus"},{"manufacturer":"Blu","market_name":"R2_3G","codename":"R010P","model":"R2 3G"},{"manufacturer":"Blu","market_name":"STUDIO 7.0 LTE","codename":"blu_s0010tw","model":"BLU STUDIO 7.0 LTE"},{"manufacturer":"Blu","market_name":"STUDIO 7.0 LTE","codename":"blu_s0010uu","model":"BLU STUDIO 7.0 LTE"},{"manufacturer":"Blu","market_name":"STUDIO C 8+8 LTE","codename":"BLU_STUDIO_C_8_8_LTE","model":"BLU STUDIO C 8+8 LTE"},{"manufacturer":"Blu","market_name":"STUDIO G","codename":"BLU_STUDIO_G","model":"BLU STUDIO G"},{"manufacturer":"Blu","market_name":"STUDIO G HD","codename":"Studio_G_HD","model":"BLU Studio G HD"},{"manufacturer":"Blu","market_name":"STUDIO G HD LTE","codename":"Studio_G_HD_LTE","model":"Studio G HD LTE"},{"manufacturer":"Blu","market_name":"STUDIO G PLUS","codename":"Studio_G_Plus","model":"BLU STUDIO G PLUS"},{"manufacturer":"Blu","market_name":"STUDIO G PLUS HD","codename":"Studio_G_Plus_HD","model":"Studio G Plus HD"},{"manufacturer":"Blu","market_name":"STUDIO M HD","codename":"BLU_STUDIO_M_HD","model":"STUDIO M HD"},{"manufacturer":"Blu","market_name":"STUDIO M LTE","codename":"BLU_STUDIO_M_LTE","model":"STUDIO M LTE"},{"manufacturer":"Blu","market_name":"STUDIO MAX","codename":"Studio_Max","model":"Studio Max"},{"manufacturer":"Blu","market_name":"STUDIO ONE PLUS","codename":"BLU_STUDIO_ONE_PLUS","model":"BLU STUDIO ONE PLUS"},{"manufacturer":"Blu","market_name":"STUDIO SELFIE 2","codename":"BLU_STUDIO_SELFIE_2","model":"BLU STUDIO SELFIE 2"},{"manufacturer":"Blu","market_name":"STUDIO TOUCH","codename":"BLU_Studio_Touch","model":"BLU Studio Touch"},{"manufacturer":"Blu","market_name":"STUDIO XL LTE","codename":"BLU_STUDIO_XL_LTE","model":"BLU STUDIO XL LTE"},{"manufacturer":"Blu","market_name":"STUIDIO C 8+8","codename":"BLU_STUDIO_C_8_8","model":"BLU STUDIO C 8+8"},{"manufacturer":"Blu","market_name":"STUIDIO SELFIE 2","codename":"BLU_STUDIO_SELFIE_2","model":"BLU STUDIO SELFIE 2"},{"manufacturer":"Blu","market_name":"SUTDIO ENERGY 2","codename":"BLU_STUDIO_ENERGY_2","model":"STUDIO ENERGY 2"},{"manufacturer":"Blu","market_name":"Studio 5.5 HD","codename":"S150","model":"STUDIO 5.5 HD"},{"manufacturer":"Blu","market_name":"Studio C HD","codename":"BLU_STUDIO_C_HD","model":"BLU STUDIO C HD"},{"manufacturer":"Blu","market_name":"Studio C HD","codename":"Studio_C_HD","model":"Studio C HD"},{"manufacturer":"Blu","market_name":"Studio G HD","codename":"STUDIO_G_HD","model":"STUDIO_G_HD"},{"manufacturer":"Blu","market_name":"Studio G Mini","codename":"S210","model":"Studio G Mini"},{"manufacturer":"Blu","market_name":"Studio G2 HD","codename":"Studio_G2_HD","model":"Studio G2 HD"},{"manufacturer":"Blu","market_name":"Studio G3","codename":"S770P","model":"Studio G3"},{"manufacturer":"Blu","market_name":"Studio J1","codename":"Studio_J1","model":"Advance A4"},{"manufacturer":"Blu","market_name":"Studio J1","codename":"Studio_J1","model":"Studio J1"},{"manufacturer":"Blu","market_name":"Studio J2","codename":"Studio_J2","model":"Advance A5"},{"manufacturer":"Blu","market_name":"Studio J2","codename":"Studio_J2","model":"Studio J2"},{"manufacturer":"Blu","market_name":"Studio J2","codename":"Studio_J2","model":"Studio M5"},{"manufacturer":"Blu","market_name":"Studio J5","codename":"Studio_J5","model":"Studio J5"},{"manufacturer":"Blu","market_name":"Studio J8","codename":"Studio_J8","model":"Studio J8"},{"manufacturer":"Blu","market_name":"Studio M5 Plus LTE","codename":"S0390WW","model":"Studio M5 Plus LTE"},{"manufacturer":"Blu","market_name":"Studio M6","codename":"S730","model":"Studio M6"},{"manufacturer":"Blu","market_name":"Studio Mega","codename":"Studio_Mega","model":"Studio Mega"},{"manufacturer":"Blu","market_name":"Studio One","codename":"BLU_STUDIO_ONE","model":"BLU STUDIO ONE"},{"manufacturer":"Blu","market_name":"Studio Pro","codename":"S750","model":"Studio Pro"},{"manufacturer":"Blu","market_name":"Studio Selfie LTE","codename":"BLU_STUDIO_SELFIE_LTE","model":"BLU STUDIO SELFIE LTE"},{"manufacturer":"Blu","market_name":"Studio View XL","codename":"S790Q","model":"Studio View XL"},{"manufacturer":"Blu","market_name":"Studio X Mini","codename":"BLU_STUDIO_X_MINI","model":"BLU STUDIO X MINI"},{"manufacturer":"Blu","market_name":"Studio_J8M","codename":"S0450WW","model":"Studio J8M"},{"manufacturer":"Blu","market_name":"Studio_View","codename":"S810P","model":"Studio View"},{"manufacturer":"Blu","market_name":"Studio_XL_2","codename":"Studio_XL_2","model":"Studio M6 LTE"},{"manufacturer":"Blu","market_name":"Studio_XL_2","codename":"Studio_XL_2","model":"Studio XL 2"},{"manufacturer":"Blu","market_name":"TOUCHBOOK M7","codename":"BLU_TOUCHBOOK_M7","model":"BLU TOUCHBOOK M7"},{"manufacturer":"Blu","market_name":"Tank Xtreme 4.0","codename":"Tank_Xtreme_4_0","model":"Tank Xtreme 4.0"},{"manufacturer":"Blu","market_name":"Tank Xtreme 5.0","codename":"Tank_Xtreme_5_0","model":"Tank Xtreme 5.0"},{"manufacturer":"Blu","market_name":"Tank Xtreme Pro","codename":"T0010UU","model":"Tank Xtreme Pro"},{"manufacturer":"Blu","market_name":"Touchbook M7 Pro","codename":"P290","model":"Touchbook M7 Pro"},{"manufacturer":"Blu","market_name":"VIVO 5","codename":"BLU_VIVO_5","model":"VIVO 5"},{"manufacturer":"Blu","market_name":"VIVO 5R","codename":"BLU_Vivo_5R","model":"Vivo 5R"},{"manufacturer":"Blu","market_name":"VIVO 6","codename":"BLU_Vivo_6","model":"Vivo 6"},{"manufacturer":"Blu","market_name":"VIVO XL","codename":"BLU_VIVO_XL","model":"VIVO XL"},{"manufacturer":"Blu","market_name":"Vivo 5 Mini","codename":"Vivo_5_Mini","model":"Vivo 5 Mini"},{"manufacturer":"Blu","market_name":"Vivo 8","codename":"V0150UU","model":"Vivo 8"},{"manufacturer":"Blu","market_name":"Vivo ONE","codename":"V0270WW","model":"Vivo ONE"},{"manufacturer":"Blu","market_name":"Vivo S","codename":"V0160WW","model":"Vivo S"},{"manufacturer":"Blu","market_name":"Vivo X","codename":"V0230WW","model":"Vivo X"},{"manufacturer":"Blu","market_name":"Vivo X WW","codename":"V0230WW","model":"Vivo X"},{"manufacturer":"Blu","market_name":"Vivo XL3","codename":"V0250WW","model":"Vivo XL3"},{"manufacturer":"Blu","market_name":"Vivo XL3 Plus","codename":"V0210WW","model":"Vivo XL3 Plus"},{"manufacturer":"Blu","market_name":"Vivo_8L_UU","codename":"V0190UU","model":"Vivo 8L"},{"manufacturer":"Blu","market_name":"Vivo_8_LL","codename":"V0150LL","model":"Vivo 8"},{"manufacturer":"Blu","market_name":"Vivo_One_Plus","codename":"V0290WW","model":"Vivo One Plus"},{"manufacturer":"Bluboo","market_name":"D1","codename":"BLUBOO_D1","model":"D1"},{"manufacturer":"Bluboo","market_name":"D1_Pro","codename":"D1_Pro","model":"D1_Pro"},{"manufacturer":"Bluboo","market_name":"D2 Pro","codename":"D2_Pro","model":"D2_Pro"},{"manufacturer":"Bluboo","market_name":"D5","codename":"D5","model":"D5"},{"manufacturer":"Bluboo","market_name":"D5 Pro","codename":"D5_Pro","model":"D5 Pro"},{"manufacturer":"Bluboo","market_name":"S1a","codename":"S1a","model":"S1a"},{"manufacturer":"Bluboo","market_name":"S3","codename":"S3","model":"S3"},{"manufacturer":"Bluboo","market_name":"S8 Plus a","codename":"S8_plus_a","model":"S8_plus_a"},{"manufacturer":"Bluboo","market_name":"S8a","codename":"BLUBOO_S8a","model":"S8a"},{"manufacturer":"Bluebird","market_name":"BM180","codename":"BM180","model":"BM180"},{"manufacturer":"Bluebird","market_name":"EF400","codename":"EF400","model":"EF400"},{"manufacturer":"Bluebird","market_name":"EF401","codename":"EF401","model":"EF401"},{"manufacturer":"Bluebird","market_name":"EF500","codename":"EF500","model":"EF500"},{"manufacturer":"Bluebird","market_name":"EF501","codename":"EF501","model":"EF501"},{"manufacturer":"Bluebird","market_name":"RP350","codename":"RP350","model":"RP350"},{"manufacturer":"Bluebird","market_name":"RT080","codename":"RT080","model":"RT080"},{"manufacturer":"Bluebird","market_name":"SF550","codename":"SF550","model":"SF550"},{"manufacturer":"Bluebird","market_name":"ST080","codename":"ST080","model":"ST080"},{"manufacturer":"Bluedot","market_name":"BNT-700K","codename":"BNT-700K","model":"BNT-700K"},{"manufacturer":"Booken","market_name":"Cybook Tablet","codename":"cybtt10_bk","model":"Cybook-Tablet"},{"manufacturer":"Boost","market_name":"Cabana","codename":"Cabana","model":"Cabana"},{"manufacturer":"Boost","market_name":"Cabana","codename":"Cabana_D001","model":"Cabana"},{"manufacturer":"Boost","market_name":"Moova Shuffle","codename":"MoovaShuffle","model":"MoovaShuffle"},{"manufacturer":"Boost","market_name":"Moova Soul","codename":"Moova-Soul","model":"Moova-Soul"},{"manufacturer":"Boost","market_name":"Pulse Glide","codename":"PulseGlide","model":"Pulse Glide"},{"manufacturer":"Boost","market_name":"Pulse Jive","codename":"Jive","model":"Jive"},{"manufacturer":"Boost","market_name":"Pulse Power","codename":"Power","model":"Power"},{"manufacturer":"Boost","market_name":"Pulse Retro","codename":"M450B","model":"Pulse Retro"},{"manufacturer":"Boost","market_name":"Pulse Sky","codename":"Y551B","model":"Pulse Sky"},{"manufacturer":"Boost","market_name":"Shaker-Slim","codename":"Shaker-Slim","model":"Shaker-Slim"},{"manufacturer":"Boost","market_name":"ShakerBeat","codename":"ShakerBeat","model":"ShakerBeat"},{"manufacturer":"Boost","market_name":"StrikaPlay","codename":"StrikaPlay","model":"StrikaPlay"},{"manufacturer":"Boost","market_name":"X4503","codename":"X4503","model":"X4503"},{"manufacturer":"Borqs","market_name":"Falcon","codename":"falcon","model":"falcon"},{"manufacturer":"Bouygues Telecom","market_name":"Bbox Miami","codename":"HMB4213H","model":"BouygtelTV"},{"manufacturer":"Bouygues Telecom","market_name":"Bs 451","codename":"Bs_451","model":"Bs 451"},{"manufacturer":"Brandcode","market_name":"L1Fa","codename":"L1Fa","model":"L1Fa"},{"manufacturer":"Bravis","market_name":"NB753","codename":"NB753","model":"NB753"},{"manufacturer":"Bravis","market_name":"X500","codename":"BRAVIS_X500","model":"BRAVIS X500"},{"manufacturer":"Bravis","market_name":"bravis_A506","codename":"bravis_A506","model":"bravis_A506"},{"manufacturer":"Brighton","market_name":"MAL-FWTVTB","codename":"MAL-FWTVTB","model":"MAL-FWTVTB"},{"manufacturer":"Brightstar","market_name":"M8046IU","codename":"M8047IU","model":"M8047IU"},{"manufacturer":"British Telecom","market_name":"BT Home SmartPhone III","codename":"BT_Home_SmartPhone_III","model":"E81"},{"manufacturer":"British Telecom","market_name":"HomeSmartphone d800","codename":"d800","model":"BT Home SmartPhone S II"},{"manufacturer":"Brondi","market_name":"730 4G HD","codename":"Brondi_730_4G_HD","model":"Brondi_730_4G_HD"},{"manufacturer":"Brown","market_name":"Brown2","codename":"I9080_PH1","model":"brown 2"},{"manufacturer":"Brown","market_name":"brown tab1","codename":"brown_tab1","model":"brown tab1"},{"manufacturer":"Bullitt Group","market_name":"Cat S60","codename":"CatS60","model":"S60"},{"manufacturer":"Bullitt Group","market_name":"CatS31","codename":"CatS31","model":"S31"},{"manufacturer":"Bullitt Group","market_name":"S30","codename":"CatS30","model":"S30"},{"manufacturer":"Bunbungame","market_name":"KALOS","codename":"FG6Q_N","model":"KALOS"},{"manufacturer":"Bunbungame","market_name":"MiSS","codename":"MiSS","model":"MiSS"},{"manufacturer":"Bush","market_name":"5 android","codename":"ac50cpl","model":"Bush 5 Android"},{"manufacturer":"Bush","market_name":"BUSH SPIRA B3 10 TABLET","codename":"ac101boxv2","model":"BUSH SPIRA B3 10 TABLET"},{"manufacturer":"Bush","market_name":"BUSH SPIRA B3 10 TABLET","codename":"ac101boxv3","model":"BUSH SPIRA B3 10 TABLET"},{"manufacturer":"Bush","market_name":"BUSH SPIRA B3 8 TABLET","codename":"ac80oxv2","model":"BUSH SPIRA B3 8 TABLET"},{"manufacturer":"Bush","market_name":"BUSH SPIRA B5.5 POWER","codename":"ac55crp","model":"BUSH SPIRA B5.5 POWER"},{"manufacturer":"Bush","market_name":"MyTablet 79","codename":"ac79bu","model":"BUSH 7.85 TABLET"},{"manufacturer":"Bush","market_name":"SPIRA B3 5","codename":"ac50co","model":"BUSH SPIRA B3 5"},{"manufacturer":"Bush","market_name":"SPIRA B4 5","codename":"ac50fhe","model":"BUSH SPIRA B4 5"},{"manufacturer":"Bush","market_name":"SPIRA B4 5.5","codename":"ac55bhe","model":"BUSH SPIRA B4 5.5"},{"manufacturer":"Bush","market_name":"SPIRA D3 5.5","codename":"ac55diplus","model":"BUSH SPIRA D3 5.5"},{"manufacturer":"Bush","market_name":"SPIRA D4 5","codename":"ac50bco","model":"BUSH SPIRA D4 5"},{"manufacturer":"Bush","market_name":"SPIRA E3X 5.5","codename":"ac55di2plus","model":"BUSH SPIRA E3X 5.5"},{"manufacturer":"Bush","market_name":"SPIRA E4X","codename":"ac55diselfie","model":"BUSH SPIRA E4X"},{"manufacturer":"Bush","market_name":"Spira B2 10 tablet","codename":"ac101box","model":"Bush Spira B2 10 tablet"},{"manufacturer":"Bush","market_name":"Spira B2 7 tablet","codename":"ac70ox","model":"Bush Spira B2 7 tablet"},{"manufacturer":"Bush","market_name":"Spira D4 5.5","codename":"ac55bco","model":"BUSH SPIRA D4 5.5"},{"manufacturer":"Bush","market_name":"Spira E2X 5\\'\\'","codename":"ac50dis","model":"\"Bush Spira E2X 5\"\" Smartphone\""},{"manufacturer":"C&M","market_name":"SH950C-CM","codename":"stb_catv_cnmuhd","model":"SH950C-CM"},{"manufacturer":"C&M","market_name":"Smart TV II","codename":"stb_catv_cnm","model":"SX930C-CC"},{"manufacturer":"C5 Mobile","market_name":"Noa X Power","codename":"noaXPower","model":"noaXPower"},{"manufacturer":"C5 Mobile","market_name":"noa_G1","codename":"noa_G1","model":"noa_G1"},{"manufacturer":"CCC","market_name":"AirStick","codename":"ts201","model":"AIrStick"},{"manufacturer":"CCC","market_name":"AirStick","codename":"ts201","model":"AirStick"},{"manufacturer":"CCC","market_name":"AirStick 4K","codename":"ts302","model":"AirStick 4K"},{"manufacturer":"CCC","market_name":"LifeStick","codename":"ts201","model":"LifeStick"},{"manufacturer":"CCC","market_name":"TSUTAYA Stick","codename":"ts201","model":"TStick"},{"manufacturer":"CG Mobile","market_name":"Blaze  G","codename":"Blaze_G","model":"Blaze G"},{"manufacturer":"CG Mobile","market_name":"Blaze N","codename":"Blaze_N","model":"Blaze N"},{"manufacturer":"CG Mobile","market_name":"EON Blaze Pro","codename":"CG_EON_Blaze_Pro","model":"CG_EON_Blaze_Pro"},{"manufacturer":"CG Mobile","market_name":"OMEGA 3","codename":"OMEGA_3","model":"OMEGA 3"},{"manufacturer":"CG Mobile","market_name":"OMEGA 8","codename":"CG_Omega_8","model":"Omega 8"},{"manufacturer":"CG Mobile","market_name":"Omega6","codename":"OMEGA6","model":"CG_OMEGA6"},{"manufacturer":"CHN TELECOM","market_name":"CHN-UCAN MJ","codename":"lefhd","model":"CHN-UCAN MJ"},{"manufacturer":"CJHelloVision","market_name":"CJ680CL","codename":"cj680cl","model":"GX-CJ680CL"},{"manufacturer":"CJHelloVision","market_name":"Hello TV Smart","codename":"SX930C_CJ","model":"SX930C_CJ"},{"manufacturer":"CJHelloVision","market_name":"viewing","codename":"kr101","model":"kr101"},{"manufacturer":"CMCC","market_name":"M811","codename":"m811","model":"M811"},{"manufacturer":"CMCC","market_name":"M811","codename":"m811hk","model":"M811"},{"manufacturer":"CX Argentina","market_name":"CX9011","codename":"CX9011","model":"CX9011"},{"manufacturer":"CYX Group","market_name":"A7008","codename":"A7008","model":"A7008"},{"manufacturer":"CYX Group","market_name":"Retailer Stores","codename":"A7009","model":"A7009"},{"manufacturer":"CZ Electronics","market_name":"M3CR","codename":"Mint_Fox","model":"M3CR"},{"manufacturer":"CZ Electronics","market_name":"M3CRD","codename":"Mint_Fox","model":"M3CRD"},{"manufacturer":"CZ Electronics","market_name":"M3s","codename":"M3s","model":"M3s"},{"manufacturer":"CZ Electronics","market_name":"M5CR","codename":"M5CR","model":"M5CR"},{"manufacturer":"CZ Electronics","market_name":"M5CRD","codename":"M5CR","model":"M5CRD"},{"manufacturer":"CZ Electronics","market_name":"M7 Sapphire","codename":"M7","model":"M7"},{"manufacturer":"CZ Electronics","market_name":"MX16","codename":"Mint_Diamond","model":"MX16"},{"manufacturer":"CZ Electronics","market_name":"Mint_Iris","codename":"Mint_Iris","model":"M7L_Sapphire"},{"manufacturer":"CZ Electronics","market_name":"Mint_Jane","codename":"Mint_Jane","model":"M5E01"},{"manufacturer":"Camelus","market_name":"L10","codename":"TR-10HBT","model":"L10"},{"manufacturer":"Camelus","market_name":"L7","codename":"TR-7U","model":"L7"},{"manufacturer":"Camfone","market_name":"CamPad P7","codename":"CamPad_P7","model":"CamPad_P7"},{"manufacturer":"Camfone","market_name":"Hero H7 Plus","codename":"Hero_H7_Plus","model":"Hero_H7_Plus"},{"manufacturer":"Camfone","market_name":"Hero H9","codename":"Hero_H9","model":"Hero_H9"},{"manufacturer":"Camfone","market_name":"Hero X","codename":"Hero_X","model":"Hero X"},{"manufacturer":"Camfone","market_name":"Hero_SX","codename":"Hero_SX","model":"Hero SX"},{"manufacturer":"Canal Digital","market_name":"OnePlace","codename":"canal_sat_bcm","model":"S70CDS"},{"manufacturer":"Candor","market_name":"PHS-601","codename":"phs601","model":"PHS-601"},{"manufacturer":"Captiva","market_name":"CAPTIVA Pad 10 3G Plus","codename":"Pad_10_3G_Plus","model":"Captiva Pad 10 3G Plus"},{"manufacturer":"CarePad","market_name":"C101","codename":"C101","model":"C101"},{"manufacturer":"Carrefour","market_name":"CT1000","codename":"Carrefour","model":"CT1000"},{"manufacturer":"Carrefour","market_name":"CT1020W","codename":"M1010FP","model":"CT1020W"},{"manufacturer":"Carrefour","market_name":"CT1050","codename":"TVE9603","model":"TVE9603I"},{"manufacturer":"Carrefour","market_name":"CT726","codename":"CT726","model":"CT726"},{"manufacturer":"Carrefour","market_name":"CT820","codename":"M878LP","model":"CT820"},{"manufacturer":"Carrefour","market_name":"CT826","codename":"CT826","model":"CT826"},{"manufacturer":"Casio","market_name":"IT-G400","codename":"itg400","model":"IT-G400"},{"manufacturer":"Casio","market_name":"Smart Outdoor Watch WSD-F10","codename":"koi","model":"CASIO WSD-F10"},{"manufacturer":"Casio","market_name":"WSD-F20","codename":"ayu","model":"CASIO WSD-F20"},{"manufacturer":"Casio","market_name":"WSD-F20","codename":"ayu","model":"CASIO WSD-F20S"},{"manufacturer":"Casper","market_name":"TA80CA2","codename":"TA80CA2_1","model":"TA80CA2"},{"manufacturer":"Casper","market_name":"VIA A2","codename":"CASPER_VIA_A2","model":"CASPER_VIA_A2"},{"manufacturer":"Casper","market_name":"VIA G1","codename":"CASPER_VIA_G1","model":"CASPER_VIA_G1"},{"manufacturer":"Casper","market_name":"VIA G1 Plus","codename":"CASPER_VIA_G1_Plus","model":"CASPER_VIA_G1_Plus"},{"manufacturer":"Casper","market_name":"VIA M3","codename":"CASPER_VIA_M3","model":"CASPER_VIA_M3"},{"manufacturer":"Casper","market_name":"VIA T7D","codename":"VIA-T7D","model":"VIA-T7D"},{"manufacturer":"Casper","market_name":"VIA T7D 3G","codename":"VIA-T7D-3G","model":"VIA-T7D-3G"},{"manufacturer":"Casper","market_name":"VIA_A1","codename":"VIA_A1","model":"VIA_A1"},{"manufacturer":"Casper","market_name":"VIA_A1_1","codename":"VIA_A1_1","model":"VIA_A1_1"},{"manufacturer":"Casper","market_name":"VIA_A1_1","codename":"VIA_F1","model":"VIA_F1"},{"manufacturer":"Casper","market_name":"VIA_A1_Plus","codename":"BBL7551TC","model":"VIA_A1_Plus"},{"manufacturer":"Casper","market_name":"VIA_M4","codename":"VIA_M4","model":"VIA_M4"},{"manufacturer":"Casper","market_name":"VIA_P2","codename":"VIA_P2","model":"VIA_P2"},{"manufacturer":"Casper","market_name":"VIA_S17","codename":"VIA_S17","model":"VIA_S17"},{"manufacturer":"Casper","market_name":"VIA_S18","codename":"VIA_S18","model":"VIA_S18"},{"manufacturer":"Casper","market_name":"VIA_T41","codename":"VIA_T41","model":"VIA_T41"},{"manufacturer":"Cat","market_name":"B15","codename":"TOUGH","model":"B15"},{"manufacturer":"Cat","market_name":"B15Q","codename":"B15Q","model":"B15Q"},{"manufacturer":"Cat","market_name":"B15Q","codename":"CatB15Q","model":"B15Q"},{"manufacturer":"Cat","market_name":"Cat S31","codename":"CatS31","model":"S31"},{"manufacturer":"Cat","market_name":"Cat S41","codename":"CatS41","model":"S41"},{"manufacturer":"Cat","market_name":"Cat S61","codename":"CatS61","model":"S61"},{"manufacturer":"Cat","market_name":"CatS50c","codename":"CatS50c","model":"S50c"},{"manufacturer":"Cat","market_name":"S30","codename":"CatS30","model":"S30"},{"manufacturer":"Cat","market_name":"S40","codename":"CatS40","model":"S40"},{"manufacturer":"Cat","market_name":"S50","codename":"CatS50","model":"S50"},{"manufacturer":"Cathay","market_name":"AS01M","codename":"AS01M","model":"AS01M"},{"manufacturer":"Cavion","market_name":"M1092Q","codename":"M1092Q","model":"M1092Q"},{"manufacturer":"Ceibal","market_name":"A102","codename":"A102","model":"A102"},{"manufacturer":"Ceibal","market_name":"Ibirapita","codename":"A81F","model":"A81F"},{"manufacturer":"Ceibal","market_name":"KIL-TAB82WIFI","codename":"KIL-TAB82WIFI","model":"KIL-TAB82WIFI"},{"manufacturer":"Ceibal","market_name":"TC80RA1","codename":"TC80RA1_3","model":"TC80RA1"},{"manufacturer":"Ceibal","market_name":"TC80RA6","codename":"TC80RA6_1","model":"TC80RA6"},{"manufacturer":"Celkon","market_name":"CliQ 2","codename":"c707_ym_n_37m35","model":"CliQ2"},{"manufacturer":"Celkon","market_name":"Smart 4G","codename":"Smart_4G","model":"Smart 4G"},{"manufacturer":"Celkon","market_name":"Swift 4G","codename":"Swift_4G","model":"Swift 4G"},{"manufacturer":"Celkon","market_name":"uniQ","codename":"UniQ","model":"UniQ"},{"manufacturer":"Cell_C","market_name":"Cell C Evolve","codename":"CELLC_Evolve","model":"CELLC_Evolve"},{"manufacturer":"Cell_C","market_name":"Cell C Nitro","codename":"CELLC_Nitro","model":"CELLC_Nitro"},{"manufacturer":"Cell_C","market_name":"CellC_Extreme","codename":"CELLC_Extreme","model":"CELLC_Extreme"},{"manufacturer":"Cell_C","market_name":"Eclipse","codename":"Eclipse","model":"Eclipse"},{"manufacturer":"Cell_C","market_name":"FAME","codename":"Cell_C_Fame","model":"Cell_C_Fame"},{"manufacturer":"Cell_C","market_name":"Fantasy","codename":"Cell_C","model":"Fantasy"},{"manufacturer":"Cell_C","market_name":"JAZZ","codename":"Jazz","model":"Jazz"},{"manufacturer":"Cell_C","market_name":"Jewel","codename":"Jewel","model":"Jewel"},{"manufacturer":"Cell_C","market_name":"Luna","codename":"Luna","model":"Luna"},{"manufacturer":"Cell_C","market_name":"Summit","codename":"Cell_C","model":"Summit"},{"manufacturer":"Cell_C","market_name":"Summit Plus","codename":"Summit_Plus","model":"Cell_C_Summit_Plus"},{"manufacturer":"Cell_C","market_name":"Titan","codename":"Titan","model":"Titan"},{"manufacturer":"Cell_C","market_name":"WIZ","codename":"Wiz","model":"Wiz"},{"manufacturer":"Cell_C","market_name":"deluxe","codename":"Cell_C","model":"Deluxe"},{"manufacturer":"Cello","market_name":"T1045PN","codename":"T1045PN","model":"T1045PN"},{"manufacturer":"Cellon","market_name":"A27","codename":"C8680","model":"A27"},{"manufacturer":"Cellon","market_name":"A5801","codename":"C8680","model":"A5801"},{"manufacturer":"Cellon","market_name":"Alpha Ice","codename":"M8047","model":"Alpha Ice"},{"manufacturer":"Cellon","market_name":"C3668","codename":"C3668","model":"C3668"},{"manufacturer":"Cellon","market_name":"CI","codename":"Dream-C1","model":"CI"},{"manufacturer":"Cellon","market_name":"CJ-1984","codename":"C8690","model":"C8690"},{"manufacturer":"Cellon","market_name":"CJ-1984","codename":"C8690","model":"CJ-1984"},{"manufacturer":"Cellon","market_name":"CJ-1984","codename":"C8690","model":"ELITE 4.7 HD"},{"manufacturer":"Cellon","market_name":"EI","codename":"Dream-E1","model":"EI"},{"manufacturer":"Cellon","market_name":"EIII","codename":"Dream-E3","model":"EIII"},{"manufacturer":"Cellon","market_name":"EK-8680","codename":"C8680","model":"EK-8680"},{"manufacturer":"Cellon","market_name":"Explosion","codename":"C8690","model":"Explosion"},{"manufacturer":"Cellon","market_name":"HW-W900","codename":"C8690","model":"HW-W900"},{"manufacturer":"Cellon","market_name":"HWW820","codename":"C8680","model":"HW-W820"},{"manufacturer":"Cellon","market_name":"Houston","codename":"C8680","model":"Houston"},{"manufacturer":"Cellon","market_name":"ICON","codename":"ICON","model":"ICON"},{"manufacturer":"Cellon","market_name":"IQ 1.1","codename":"IQ1-1","model":"i-mobile IQ1-1"},{"manufacturer":"Cellon","market_name":"Linx PS474S","codename":"C8690","model":"Linx PS474S"},{"manufacturer":"Cellon","market_name":"MTC SMART Run","codename":"SMART_Run","model":"MTC SMART Run"},{"manufacturer":"Cellon","market_name":"Mach","codename":"C8680","model":"Mach"},{"manufacturer":"Cellon","market_name":"Newman N2","codename":"C8690","model":"Newman N2"},{"manufacturer":"Cellon","market_name":"Q","codename":"M8047XT","model":"Q"},{"manufacturer":"Cellon","market_name":"S21","codename":"S21","model":"Q-Smart S21"},{"manufacturer":"Cellon","market_name":"SI","codename":"Dream-S1","model":"SI"},{"manufacturer":"Cellon","market_name":"SM55","codename":"C8660","model":"C8660"},{"manufacturer":"Cellon","market_name":"SM55","codename":"C8660","model":"SM55"},{"manufacturer":"Cellon","market_name":"Starmobile KNIGHT","codename":"KNIGHT","model":"Starmobile KNIGHT"},{"manufacturer":"Cellon","market_name":"VEON_C8680","codename":"C8680","model":"VEON_C8680"},{"manufacturer":"Cellon","market_name":"i-STYLE7","codename":"c8669SA","model":"i-mobile i-STYLE 7"},{"manufacturer":"Cellon","market_name":"i-STYLE7A","codename":"c8669SA","model":"i-mobile i-STYLE 7A"},{"manufacturer":"Cellon","market_name":"i-mobile IQ X","codename":"M8047SA","model":"i-mobile IQ X"},{"manufacturer":"Cellon","market_name":"i-mobile IQ X","codename":"M8047SA","model":"i-mobile IQ XA"},{"manufacturer":"Cellon","market_name":"i-mobile IQ X2A","codename":"M8050SA","model":"i-mobile IQ X2"},{"manufacturer":"Cellon","market_name":"i-mobile IQ X2A","codename":"M8050SA","model":"i-mobile IQ X2A"},{"manufacturer":"Cellon","market_name":"iris pro 30","codename":"pro30","model":"iris pro 30"},{"manufacturer":"Cellon","market_name":"starTIM1","codename":"starTIM1","model":"starTIM1"},{"manufacturer":"Centric","market_name":"Centric L3","codename":"L3","model":"Centric CM3331"},{"manufacturer":"Centric","market_name":"G1","codename":"CM4331","model":"CM4331"},{"manufacturer":"Centric","market_name":"G1","codename":"CM4331","model":"G1"},{"manufacturer":"CenturyLink","market_name":"PureTV","codename":"ctl_iptv_mrvl","model":"CTLPlayer"},{"manufacturer":"CenturyLink","market_name":"PureTV","codename":"ctl_iptv_mrvl","model":"S60CLI"},{"manufacturer":"Channel Master","market_name":"Stream+","codename":"dwt765cha","model":"CM-7600"},{"manufacturer":"Chemist Warehouse","market_name":"JR-MB603","codename":"JR_MB603","model":"JR_MB603"},{"manufacturer":"Cherry Mobile","market_name":"Cherry W900 LTE","codename":"al7","model":"W900 LTE"},{"manufacturer":"Cherry Mobile","market_name":"Desire R7 Lite","codename":"Desire_R7_Lite","model":"Desire R7 Lite"},{"manufacturer":"Cherry Mobile","market_name":"Desire R8 Lite","codename":"Desire_R8_Lite","model":"Desire R8 Lite"},{"manufacturer":"Cherry Mobile","market_name":"FB100","codename":"FB100","model":"FB100"},{"manufacturer":"Cherry Mobile","market_name":"Flare 5","codename":"X630","model":"Flare_5"},{"manufacturer":"Cherry Mobile","market_name":"Flare A1","codename":"FlareA1","model":"FlareA1"},{"manufacturer":"Cherry Mobile","market_name":"Flare A5","codename":"Cherry_X740","model":"Cherry_X740"},{"manufacturer":"Cherry Mobile","market_name":"Flare HD 3","codename":"Flare_HD_3","model":"Flare HD 3"},{"manufacturer":"Cherry Mobile","market_name":"Flare HD Max","codename":"Flare_HD_MAX","model":"Flare_HD_MAX"},{"manufacturer":"Cherry Mobile","market_name":"Flare J2 Lite","codename":"Flare_J2_Lite","model":"Flare_J2_Lite"},{"manufacturer":"Cherry Mobile","market_name":"Flare J2 Mini","codename":"Flare_J2_Mini","model":"Flare J2 Mini"},{"manufacturer":"Cherry Mobile","market_name":"Flare J2S","codename":"Flare_J2S","model":"Flare J2S"},{"manufacturer":"Cherry Mobile","market_name":"Flare J3","codename":"FlareJ3","model":"FlareJ3"},{"manufacturer":"Cherry Mobile","market_name":"Flare J3","codename":"H680","model":"Flare_J3"},{"manufacturer":"Cherry Mobile","market_name":"Flare J3 Plus","codename":"FlareJ3Plus","model":"FlareJ3Plus"},{"manufacturer":"Cherry Mobile","market_name":"Flare J3 Plus","codename":"H620","model":"Flare_J3_Plus"},{"manufacturer":"Cherry Mobile","market_name":"Flare J7","codename":"Flare_J7","model":"Flare J7"},{"manufacturer":"Cherry Mobile","market_name":"Flare Lite 3S","codename":"Flare_Lite_3S","model":"Flare_Lite_3S"},{"manufacturer":"Cherry Mobile","market_name":"Flare P1","codename":"Flare_P1","model":"Flare P1"},{"manufacturer":"Cherry Mobile","market_name":"Flare P1 Lite","codename":"Flare_P1_Lite","model":"Flare_P1_Lite"},{"manufacturer":"Cherry Mobile","market_name":"Flare P1 Mini","codename":"Flare_P1_Mini","model":"Flare_P1_Mini"},{"manufacturer":"Cherry Mobile","market_name":"Flare P1 Plus","codename":"Flare_P1_Plus","model":"Flare P1 Plus"},{"manufacturer":"Cherry Mobile","market_name":"Flare P3","codename":"Flare_P3","model":"Flare_P3"},{"manufacturer":"Cherry Mobile","market_name":"Flare P3 Plus","codename":"Flare_P3_Plus","model":"Flare_P3_Plus"},{"manufacturer":"Cherry Mobile","market_name":"Flare P3 lite","codename":"Flare_P3_lite","model":"Flare_P3_lite"},{"manufacturer":"Cherry Mobile","market_name":"Flare S5","codename":"Flare_S5","model":"Flare S5"},{"manufacturer":"Cherry Mobile","market_name":"Flare S5 Lite DTV","codename":"FlareS5LiteDTV","model":"FlareS5LiteDTV"},{"manufacturer":"Cherry Mobile","market_name":"Flare S5 Max","codename":"FLARE_S5_MAX","model":"FLARE S5 MAX"},{"manufacturer":"Cherry Mobile","market_name":"Flare S5 Plus","codename":"Flare_S5_Plus","model":"Flare S5 Plus"},{"manufacturer":"Cherry Mobile","market_name":"Flare S6","codename":"Cherry_Flare_S6","model":"Flare S6"},{"manufacturer":"Cherry Mobile","market_name":"Flare S6 Max","codename":"Flare_S6_Max","model":"Flare_S6_Max"},{"manufacturer":"Cherry Mobile","market_name":"Flare S6 Plus","codename":"Flare_S6_Plus","model":"Flare_S6_Plus"},{"manufacturer":"Cherry Mobile","market_name":"Flare S6 Power","codename":"Cherry_S6_Power","model":"FLARE S6 POWER"},{"manufacturer":"Cherry Mobile","market_name":"Flare S6 Selfie","codename":"Cherry_Selfie","model":"Flare S6 Selfie"},{"manufacturer":"Cherry Mobile","market_name":"Flare X","codename":"Flare_X","model":"Flare_X_V2"},{"manufacturer":"Cherry Mobile","market_name":"Flare_J3_Lite","codename":"Flare_J3_Lite","model":"Flare_J3_Lite"},{"manufacturer":"Cherry Mobile","market_name":"Flare_S6_Lite","codename":"Flare_S6_Lite","model":"Flare_S6_Lite"},{"manufacturer":"Cherry Mobile","market_name":"H220","codename":"ctih220_sprout","model":"H220"},{"manufacturer":"Cherry Mobile","market_name":"Iris","codename":"Iris","model":"iris"},{"manufacturer":"Cherry Mobile","market_name":"Lenoxx","codename":"CX940","model":"CX940"},{"manufacturer":"Cherry Mobile","market_name":"Omega HD 3S","codename":"H115","model":"OMEGA HD 3S"},{"manufacturer":"Cherry Mobile","market_name":"Omega HD 4","codename":"Cherry_Omega_HD_4","model":"Omega_HD_4"},{"manufacturer":"Cherry Mobile","market_name":"Omega HD3","codename":"H110","model":"Omega HD 3"},{"manufacturer":"Cherry Mobile","market_name":"Omega Icon 2","codename":"Omega_Icon_2","model":"Omega Icon 2"},{"manufacturer":"Cherry Mobile","market_name":"Omega Lite 3C","codename":"Omega_Lite_3C","model":"Omega_Lite_3C"},{"manufacturer":"Cherry Mobile","market_name":"Omega Lite 4","codename":"omega_lite_4","model":"omega_lite_4"},{"manufacturer":"Cherry Mobile","market_name":"One","codename":"H940_sprout","model":"H940"},{"manufacturer":"Cherry Mobile","market_name":"Rover 2","codename":"Cherry_Rover_2","model":"Rover_2"},{"manufacturer":"Cherry Mobile","market_name":"Selfie Two","codename":"Selfie_Two","model":"Selfie_Two"},{"manufacturer":"Cherry Mobile","market_name":"Spin Max","codename":"H650","model":"Spin Max"},{"manufacturer":"Cherry Mobile","market_name":"Superion Radar Duluxe","codename":"Radar_Deluxe","model":"Superion Radar Deluxe"},{"manufacturer":"Cherry Mobile","market_name":"Touch HD","codename":"Touch_HD","model":"Cherry_Mobile_Touch_HD"},{"manufacturer":"Cherry Mobile","market_name":"ZP785","codename":"ZP785","model":"ZP785"},{"manufacturer":"China Mobile","market_name":"A3","codename":"M651G","model":"M651G"},{"manufacturer":"China Mobile","market_name":"n1 max","codename":"m823_cmcc","model":"M823"},{"manufacturer":"Cipherlab","market_name":"RK25","codename":"RK25","model":"RK25"},{"manufacturer":"Cipherlab","market_name":"RK25WO","codename":"RK25WO","model":"RK25WO"},{"manufacturer":"Cipherlab","market_name":"RS30","codename":"Mercury","model":"CipherLab RS30"},{"manufacturer":"Cipherlab","market_name":"RS31","codename":"RS31","model":"RS31"},{"manufacturer":"Cipherlab","market_name":"Saturn","codename":"RS50","model":"RS50"},{"manufacturer":"Cisco","market_name":"CP-DX650","codename":"CP-DX650","model":"CP-DX650"},{"manufacturer":"Cisco","market_name":"DX70","codename":"CP-DX70","model":"CP-DX70"},{"manufacturer":"Cisco","market_name":"Desktop Collaboration Experience DX70","codename":"CP-DX70","model":"CP-DX70"},{"manufacturer":"Cisco","market_name":"Desktop Collaboration Experience DX80","codename":"CP-DX80","model":"CP-DX80"},{"manufacturer":"Citycall","market_name":"Life Lite 4G","codename":"KL5011C","model":"Life Lite 4G"},{"manufacturer":"Citycall","market_name":"Life Power 9","codename":"Life_Power_9","model":"Life Power 9"},{"manufacturer":"Citycall","market_name":"Life_10_Pro","codename":"Life_10_Pro","model":"Life 10 Pro"},{"manufacturer":"Citycall","market_name":"Life_Pro_7","codename":"Life_Pro_7","model":"Life Pro 7"},{"manufacturer":"Citycall","market_name":"SS5007C","codename":"SS5007C","model":"SS5007C"},{"manufacturer":"Claresta","market_name":"F3","codename":"F3","model":"F3"},{"manufacturer":"Claresta","market_name":"G4","codename":"G4","model":"G4"},{"manufacturer":"Claresta","market_name":"G5","codename":"G5","model":"G5"},{"manufacturer":"Claresta","market_name":"G6","codename":"G6","model":"G6"},{"manufacturer":"Claresta","market_name":"S6Plus","codename":"S6Plus","model":"S6Plus"},{"manufacturer":"Clarmin","market_name":"B8","codename":"B8","model":"B8"},{"manufacturer":"Clarmin","market_name":"B8Lite","codename":"B8Lite","model":"B8Lite"},{"manufacturer":"Clarmin","market_name":"B8plus","codename":"B8plus","model":"B8plus"},{"manufacturer":"Clarmin","market_name":"CLARMIN C1","codename":"CLARMIN_C1","model":"CLARMIN C1"},{"manufacturer":"Clementoni","market_name":"Clempad 4.4 Basic Special","codename":"Clempad2_special","model":"Clempad2_special"},{"manufacturer":"Clementoni","market_name":"Clempad 4.4 Plus","codename":"Clempad2_plus","model":"Clempad2_plus"},{"manufacturer":"Clementoni","market_name":"Clempad 4.4 XL","codename":"Clempad2_XL","model":"Clempad2_XL"},{"manufacturer":"Clementoni","market_name":"Clempad 5.0 XL","codename":"Clempad_HR_XL","model":"Clempad_HR_XL"},{"manufacturer":"Clementoni","market_name":"Clempad 6.0","codename":"Clempad_6","model":"Clempad_6"},{"manufacturer":"Clementoni","market_name":"Clempad 6.0 XL","codename":"Clempad_6_XL","model":"Clempad_6_XL"},{"manufacturer":"Clementoni","market_name":"Clempad 8","codename":"Clempad_8","model":"Clempad_8"},{"manufacturer":"Clementoni","market_name":"Clempad Call","codename":"CLEMPADCALL","model":"CLEMPADCALL"},{"manufacturer":"Clementoni","market_name":"Clempad HR","codename":"Clempad_HR","model":"Clempad_HR"},{"manufacturer":"Clementoni","market_name":"Clempad HR Plus","codename":"Clempad_HR_Plus","model":"Clempad_HR_Plus"},{"manufacturer":"Clementoni","market_name":"Clempad_6_S","codename":"Clempad_6_S","model":"Clempad_6_S"},{"manufacturer":"Clementoni","market_name":"Clempad_7_S","codename":"Clempad_7_S","model":"Clempad_7_S"},{"manufacturer":"Clementoni","market_name":"Clemphone","codename":"ClemPhone","model":"ClemPhone"},{"manufacturer":"Clementoni","market_name":"Clemphone 7.0","codename":"ClemPhone_7","model":"ClemPhone_7"},{"manufacturer":"Clementoni","market_name":"My First Clempad 6.0","codename":"MFC_6","model":"MFC_6"},{"manufacturer":"Clementoni","market_name":"My First Clempad 7","codename":"MFC_7","model":"MFC_7"},{"manufacturer":"Clementoni","market_name":"My First Clempad HR","codename":"MFC_HR","model":"MFC_HR"},{"manufacturer":"Clementoni","market_name":"My First Clempad HR Plus","codename":"MFC_HR_Plus","model":"MFC_HR_Plus"},{"manufacturer":"Clementoni","market_name":"My first Clempad 4.4 Basic Special","codename":"MFC2_Special","model":"MFC2_Special"},{"manufacturer":"Clementoni","market_name":"My first Clempad 4.4 Plus","codename":"MFC2_Plus","model":"MFC2_Plus"},{"manufacturer":"Click","market_name":"M9021G","codename":"M9021G","model":"M9021G"},{"manufacturer":"Click","market_name":"S7043G","codename":"S7043G","model":"S7043G"},{"manufacturer":"Click","market_name":"\"Tab 7\"\"\"","codename":"I7043G","model":"I7043G"},{"manufacturer":"ClickN Kids","market_name":"ClickN Kids","codename":"g04e","model":"CK07T"},{"manufacturer":"CloudFone","market_name":"CloudFone Next Infinity Plus","codename":"Next_Infinity_Plus","model":"Next Infinity Plus"},{"manufacturer":"CloudFone","market_name":"CloudFone Next Infinity Pro","codename":"Next_Infinity_Pro","model":"Next Infinity Pro"},{"manufacturer":"CloudFone","market_name":"CloudFone Thrill Boost 3","codename":"Thrill_Boost_3","model":"Thrill Boost 3"},{"manufacturer":"CloudFone","market_name":"CloudFone Thrill Plus 2","codename":"Thrill_Plus_2","model":"Thrill Plus 2"},{"manufacturer":"CloudFone","market_name":"CloudFone Thrill Snap","codename":"Thrill_Snap","model":"Thrill Snap"},{"manufacturer":"CloudFone","market_name":"Cloudpad One 6.95","codename":"one695_1_coho","model":"one695_1"},{"manufacturer":"CloudFone","market_name":"Cloudpad One 6.95","codename":"one695_1_coho","model":"one695_1_coho"},{"manufacturer":"CloudFone","market_name":"Cloudpad One 7.0","codename":"one7_0_4_coho","model":"one7_0_4"},{"manufacturer":"CloudFone","market_name":"Cloudpad One 7.0","codename":"one7_0_4_coho","model":"one7_0_4_coho"},{"manufacturer":"CloudFone","market_name":"Cloudpad One 8.0","codename":"one8_0_1_coho","model":"one8_0_1"},{"manufacturer":"CloudFone","market_name":"Cloudpad One 8.0","codename":"one8_0_1_coho","model":"one8_0_1_coho"},{"manufacturer":"CloudFone","market_name":"Excite Prime 2","codename":"Excite_Prime_2","model":"Excite Prime 2"},{"manufacturer":"CloudFone","market_name":"Excite Prime 2 Pro","codename":"Excite_Prime_2_Pro","model":"Excite Prime 2 Pro"},{"manufacturer":"CloudFone","market_name":"Next Infinity","codename":"Next_Infinity","model":"Next Infinity"},{"manufacturer":"CloudFone","market_name":"Next Infinity Quattro","codename":"Next_Infinity_4","model":"Next Infinity Quattro"},{"manufacturer":"CloudFone","market_name":"Thrill Boost 2","codename":"Thrill_Boost_2","model":"Thrill Boost 2"},{"manufacturer":"CloudFone","market_name":"Thrill Plus 2","codename":"Thrill_Plus_2","model":"Thrill Plus 2"},{"manufacturer":"CloudFone","market_name":"Thrill Power N","codename":"Thrill_Power_N","model":"Thrill Power N"},{"manufacturer":"CloudFone","market_name":"Thrill Snap","codename":"Thrill_Snap","model":"Thrill Snap"},{"manufacturer":"CloudFone","market_name":"Thrill View","codename":"Thrill_View","model":"Thrill View"},{"manufacturer":"CloudMinds","market_name":"A1-901","codename":"A1-901","model":"A1-901"},{"manufacturer":"Clout","market_name":"X425 Shavit","codename":"X425_Shavit","model":"X425 Shavit"},{"manufacturer":"Clout","market_name":"X428 Astute","codename":"X428_Astute","model":"X428 Astute"},{"manufacturer":"Code","market_name":"CR4900","codename":"cr4900","model":"CR4900"},{"manufacturer":"CoinComputers","market_name":"TF10EA2","codename":"TF10EA2_5","model":"TF10EA2"},{"manufacturer":"ColorsMobile","market_name":"P45","codename":"Colors_P45","model":"Colors P45"},{"manufacturer":"ColorsMobile","market_name":"P50_Plus","codename":"Colors_P50_Plus","model":"Colors P50 Plus"},{"manufacturer":"ColorsMobile","market_name":"P65","codename":"Colors_P65","model":"Colors P65"},{"manufacturer":"ColorsMobile","market_name":"S1","codename":"Colors_S1","model":"Colors S1"},{"manufacturer":"ColorsMobile","market_name":"S11","codename":"Colors_S11","model":"Colors S11"},{"manufacturer":"ColorsMobile","market_name":"S9","codename":"Colors_S9","model":"Colors S9"},{"manufacturer":"Comio","market_name":"AD7003","codename":"AD7003","model":"AD7003"},{"manufacturer":"Comio","market_name":"COMIO C1","codename":"ComioC1","model":"COMIO C1"},{"manufacturer":"Comio","market_name":"COMIO C2","codename":"ComioC2","model":"COMIO C2"},{"manufacturer":"Comio","market_name":"COMIO C2 Lite","codename":"ComioC2Lite","model":"Comio C2 Lite"},{"manufacturer":"Comio","market_name":"COMIO P1","codename":"ComioP1","model":"COMIO P1"},{"manufacturer":"Comio","market_name":"COMIO S1","codename":"ComioS1","model":"COMIO S1"},{"manufacturer":"Comio","market_name":"COMIO S1 Lite","codename":"ComioS1Lite","model":"COMIO S1 Lite"},{"manufacturer":"Compal","market_name":"","codename":"CA22","model":"COSMO DUO"},{"manufacturer":"Compal","market_name":"","codename":"CAP5","model":"A600"},{"manufacturer":"Compal","market_name":"","codename":"CAP6","model":"A600"},{"manufacturer":"Compal","market_name":"","codename":"CAP7","model":"A300"},{"manufacturer":"Compal","market_name":"","codename":"CAP7","model":"A8"},{"manufacturer":"Compal","market_name":"","codename":"CAP7","model":"W12"},{"manufacturer":"Compal","market_name":"","codename":"cap2","model":"Andy"},{"manufacturer":"Compal","market_name":"","codename":"penguin","model":"AX 8.6"},{"manufacturer":"Compal","market_name":"TANK 4.5","codename":"ka09","model":"TANK 4.5"},{"manufacturer":"Condor","market_name":"A9","codename":"PGN_507","model":"PGN-507"},{"manufacturer":"Condor","market_name":"Allure  M1","codename":"Allure_M1","model":"Allure M1"},{"manufacturer":"Condor","market_name":"Allure A55 Plus","codename":"PGN613","model":"PGN613"},{"manufacturer":"Condor","market_name":"Allure M1 Plus","codename":"Allure_M1_Plus","model":"Allure M1 Plus"},{"manufacturer":"Condor","market_name":"Allure M3","codename":"Allure_M3","model":"Allure M3"},{"manufacturer":"Condor","market_name":"C1+","codename":"C1Plus","model":"C1+"},{"manufacturer":"Condor","market_name":"C6+","codename":"PGN_508","model":"PGN-508"},{"manufacturer":"Condor","market_name":"C7","codename":"PGN_506","model":"PGN-506"},{"manufacturer":"Condor","market_name":"C_5","codename":"u970_5","model":"C-6"},{"manufacturer":"Condor","market_name":"G6 Pro","codename":"PHQ526","model":"PHQ526"},{"manufacturer":"Condor","market_name":"Griffe G5","codename":"PHQ520","model":"Griffe G5"},{"manufacturer":"Condor","market_name":"Griffe G5","codename":"PHQ520","model":"PHQ520"},{"manufacturer":"Condor","market_name":"Griffe G5 Plus","codename":"PAM524","model":"PAM524"},{"manufacturer":"Condor","market_name":"Griffe T1","codename":"Griffe_T1","model":"SP413"},{"manufacturer":"Condor","market_name":"Griffe T3","codename":"SP414","model":"Griffe T3"},{"manufacturer":"Condor","market_name":"HS-U939","codename":"u939e_6","model":"HS-U939"},{"manufacturer":"Condor","market_name":"PGN404","codename":"PGN404","model":"PGN404"},{"manufacturer":"Condor","market_name":"PGN409","codename":"PGN409","model":"PGN409"},{"manufacturer":"Condor","market_name":"PGN410","codename":"PGN410","model":"PGN410"},{"manufacturer":"Condor","market_name":"PGN507","codename":"PGN507","model":"PGN-507"},{"manufacturer":"Condor","market_name":"PGN509","codename":"PGN509","model":"PGN509"},{"manufacturer":"Condor","market_name":"PGN511","codename":"PGN511","model":"PGN511"},{"manufacturer":"Condor","market_name":"PGN513","codename":"PGN513","model":"PGN513"},{"manufacturer":"Condor","market_name":"PGN514","codename":"PGN514","model":"PGN514"},{"manufacturer":"Condor","market_name":"PGN515","codename":"PGN515","model":"PGN515"},{"manufacturer":"Condor","market_name":"PGN516","codename":"PGN516","model":"PGN516"},{"manufacturer":"Condor","market_name":"PGN517","codename":"PGN517","model":"PGN517"},{"manufacturer":"Condor","market_name":"PGN518","codename":"PGN518","model":"PGN518"},{"manufacturer":"Condor","market_name":"PGN521","codename":"PGN521","model":"PGN521"},{"manufacturer":"Condor","market_name":"PGN522","codename":"PGN522","model":"PGN522"},{"manufacturer":"Condor","market_name":"PGN523","codename":"PGN523","model":"PGN523"},{"manufacturer":"Condor","market_name":"PGN605","codename":"PGN605","model":"PGN605"},{"manufacturer":"Condor","market_name":"PGN606","codename":"PGN606","model":"PGN606"},{"manufacturer":"Condor","market_name":"PGN607","codename":"PGN607","model":"PGN607"},{"manufacturer":"Condor","market_name":"PGN608","codename":"PGN608","model":"PGN608"},{"manufacturer":"Condor","market_name":"PGN609","codename":"PGN609","model":"PGN609"},{"manufacturer":"Condor","market_name":"PGN610","codename":"PGN610","model":"PGN610"},{"manufacturer":"Condor","market_name":"PGN611","codename":"PGN611","model":"PGN611"},{"manufacturer":"Condor","market_name":"PGN612","codename":"PGN612","model":"PGN612"},{"manufacturer":"Condor","market_name":"PHQ525","codename":"PHQ525","model":"PHQ525"},{"manufacturer":"Condor","market_name":"Plume L1","codename":"SP622","model":"Plume L1"},{"manufacturer":"Condor","market_name":"Plume L1 Plus","codename":"Plume_L1_Plus","model":"Plume L1 Plus"},{"manufacturer":"Condor","market_name":"Plume L3","codename":"Plume_L3","model":"Plume L3"},{"manufacturer":"Condor","market_name":"Plume P4 Plus","codename":"PGN527","model":"PGN527"},{"manufacturer":"Condor","market_name":"Plume P6 Pro LTE","codename":"PGN528","model":"PGN528"},{"manufacturer":"Condor","market_name":"Plume P8 Lite","codename":"PGN610","model":"PGN610"},{"manufacturer":"Condor","market_name":"Plume P8 Pro","codename":"Plume_P8_Pro","model":"Plume P8 Pro"},{"manufacturer":"Condor","market_name":"SP530","codename":"SP530","model":"Griffe T2"},{"manufacturer":"Condor","market_name":"T705","codename":"TGW710G","model":"TGW710G"},{"manufacturer":"Condor","market_name":"TB716","codename":"TB716","model":"TB716"},{"manufacturer":"Condor","market_name":"TB717G","codename":"TB717G","model":"TB717G"},{"manufacturer":"Condor","market_name":"TB717L","codename":"TB717L","model":"TB717L"},{"manufacturer":"Condor","market_name":"TFX711G","codename":"TFX711G","model":"TFX711G"},{"manufacturer":"Condor","market_name":"TFX712G","codename":"TFX712G","model":"TFX712G"},{"manufacturer":"Condor","market_name":"TFX713L","codename":"TFX713L","model":"TFX713L"},{"manufacturer":"Condor","market_name":"TFX714L","codename":"TFX714L","model":"TFX714L"},{"manufacturer":"Condor","market_name":"TGW102L","codename":"TGW102L","model":"TGW102L"},{"manufacturer":"Condor","market_name":"TGW706","codename":"TGW706","model":"TGW706"},{"manufacturer":"Condor","market_name":"TGW801G","codename":"TGW801G","model":"TGW801G"},{"manufacturer":"Condor","market_name":"TGW801L","codename":"TGW801L","model":"TGW801L"},{"manufacturer":"Condor","market_name":"TMK715L","codename":"TMK715L","model":"TMK715L"},{"manufacturer":"Connectce","market_name":"Connect Alpha","codename":"CNT07002","model":"CNT07002"},{"manufacturer":"Connectce","market_name":"Connect Core 6","codename":"Connect_Core_6","model":"CP6001A"},{"manufacturer":"Connex","market_name":"CTAB-1044","codename":"CTAB-1044","model":"CTAB-1044"},{"manufacturer":"Conquest","market_name":"S11","codename":"conquest-S11","model":"S11"},{"manufacturer":"Coolpad","market_name":"","codename":"7019_msm7627a","model":"Coolpad 7019"},{"manufacturer":"Coolpad","market_name":"","codename":"7560U","model":"Nivo"},{"manufacturer":"Coolpad","market_name":"","codename":"801E","model":"801E"},{"manufacturer":"Coolpad","market_name":"","codename":"8710","model":"8710"},{"manufacturer":"Coolpad","market_name":"","codename":"9960","model":"YL-Coolpad 9960"},{"manufacturer":"Coolpad","market_name":"","codename":"CP5832","model":"5832"},{"manufacturer":"Coolpad","market_name":"","codename":"CP5880","model":"5880"},{"manufacturer":"Coolpad","market_name":"","codename":"CP7728","model":"Coolpad7728"},{"manufacturer":"Coolpad","market_name":"","codename":"CP8870","model":"8870"},{"manufacturer":"Coolpad","market_name":"","codename":"CP9130","model":"N930"},{"manufacturer":"Coolpad","market_name":"","codename":"Coolpad7290","model":"Coolpad 7290"},{"manufacturer":"Coolpad","market_name":"","codename":"Coolpad9080W","model":"Coolpad 9080W"},{"manufacturer":"Coolpad","market_name":"","codename":"dkb","model":"8150"},{"manufacturer":"Coolpad","market_name":"","codename":"dkb","model":"8180"},{"manufacturer":"Coolpad","market_name":"","codename":"dkb","model":"8810"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627_5820","model":"Coolpad 5820"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627_SP150","model":"MTS-SP150"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627_surf","model":"5860"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627_surf","model":"7260"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627_w706","model":"Coolpad W706+"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627_w706T","model":"Coolpad W706+"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627_w708","model":"Coolpad W708"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627a_5860S","model":"5860S"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627a_5870","model":"5870"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627a_7230","model":"7230"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627a_7266","model":"7266"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627a_9120","model":"9120"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627a_PAP4000","model":"PAP4000"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627a_cp5910","model":"5910"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627a_ea58","model":"Coolpad 5010"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627a_ea92","model":"Coolpad 5210"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627a_sku3","model":"5110"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627a_sku3","model":"5860A"},{"manufacturer":"Coolpad","market_name":"","codename":"msm7627a_sku3","model":"7260A"},{"manufacturer":"Coolpad","market_name":"","codename":"msm8660_9900","model":"9900"},{"manufacturer":"Coolpad","market_name":"","codename":"msm8660_CP8950","model":"8950"},{"manufacturer":"Coolpad","market_name":"3300A","codename":"3300A","model":"Coolpad 3300A"},{"manufacturer":"Coolpad","market_name":"3320A","codename":"cp3320a","model":"Coolpad 3320A"},{"manufacturer":"Coolpad","market_name":"3503I","codename":"CP3503I","model":"Coolpad 3503I"},{"manufacturer":"Coolpad","market_name":"3503I","codename":"CP3503I","model":"Coolpad CP3503I"},{"manufacturer":"Coolpad","market_name":"3505I_A00","codename":"CP3505I","model":"Coolpad E503"},{"manufacturer":"Coolpad","market_name":"3505I_U00","codename":"CP3505I_U00","model":"Coolpad E503"},{"manufacturer":"Coolpad","market_name":"3600i","codename":"CP3600I","model":"3600I"},{"manufacturer":"Coolpad","market_name":"3600i","codename":"CP3600I","model":"Coolpad 3600I"},{"manufacturer":"Coolpad","market_name":"3622A","codename":"cp3622a","model":"Coolpad 3622A"},{"manufacturer":"Coolpad","market_name":"3622A-mpcs","codename":"cp3622a","model":"Coolpad 3622A"},{"manufacturer":"Coolpad","market_name":"3623A","codename":"cp3623a","model":"Coolpad 3623A"},{"manufacturer":"Coolpad","market_name":"3632A","codename":"cp3632a","model":"Coolpad 3632A"},{"manufacturer":"Coolpad","market_name":"3632A-mpcs","codename":"cp3632a","model":"Coolpad 3632A"},{"manufacturer":"Coolpad","market_name":"3636a","codename":"cp3636a","model":"cp3636a"},{"manufacturer":"Coolpad","market_name":"3700A","codename":"3700A","model":"CP3700A"},{"manufacturer":"Coolpad","market_name":"5109","codename":"Coolpad5109","model":"Coolpad 5109"},{"manufacturer":"Coolpad","market_name":"5200","codename":"Coolpad5200","model":"Coolpad 5200"},{"manufacturer":"Coolpad","market_name":"5216D","codename":"5216D","model":"Coolpad 5216D"},{"manufacturer":"Coolpad","market_name":"5217","codename":"msm8610","model":"Coolpad 5217"},{"manufacturer":"Coolpad","market_name":"5218S","codename":"msm8x25q_a5y_5218s","model":"Coolpad 5218S"},{"manufacturer":"Coolpad","market_name":"5219","codename":"5219","model":"Coolpad 5219"},{"manufacturer":"Coolpad","market_name":"5219_C00","codename":"5219_C00","model":"Coolpad 5219_C00"},{"manufacturer":"Coolpad","market_name":"5267","codename":"Coolpad5267","model":"Coolpad 5267"},{"manufacturer":"Coolpad","market_name":"5267C","codename":"Coolpad5267","model":"Coolpad 5267"},{"manufacturer":"Coolpad","market_name":"5270","codename":"Coolpad5270","model":"Coolpad 5270"},{"manufacturer":"Coolpad","market_name":"5367","codename":"Coolpad5367","model":"Coolpad 5367"},{"manufacturer":"Coolpad","market_name":"5367C","codename":"Coolpad5367C","model":"Coolpad 5367C"},{"manufacturer":"Coolpad","market_name":"5370","codename":"Coolpad5370","model":"Coolpad 5370"},{"manufacturer":"Coolpad","market_name":"5380CA","codename":"Coolpad5380CA","model":"Coolpad 5380CA"},{"manufacturer":"Coolpad","market_name":"5860E","codename":"CP5860E","model":"5860E"},{"manufacturer":"Coolpad","market_name":"5891","codename":"Coolpad5891","model":"Coolpad 5891"},{"manufacturer":"Coolpad","market_name":"5891S","codename":"Coolpad5891S","model":"Coolpad 5891S"},{"manufacturer":"Coolpad","market_name":"5951","codename":"Coolpad5951","model":"Coolpad 5951"},{"manufacturer":"Coolpad","market_name":"7061","codename":"CP7061","model":"Coolpad 7061"},{"manufacturer":"Coolpad","market_name":"7230S","codename":"Coolpad7230S","model":"Coolpad 7230S"},{"manufacturer":"Coolpad","market_name":"7232","codename":"CP7232","model":"Coolpad 7232"},{"manufacturer":"Coolpad","market_name":"7251","codename":"Coolpad7251","model":"Coolpad 7251"},{"manufacturer":"Coolpad","market_name":"7270","codename":"Coolpad7270","model":"Coolpad 7270"},{"manufacturer":"Coolpad","market_name":"7270I","codename":"7270I","model":"Idea ULTRA Pro"},{"manufacturer":"Coolpad","market_name":"7275","codename":"CP7275","model":"Coolpad 7275"},{"manufacturer":"Coolpad","market_name":"7295A","codename":"Coolpad7295A","model":"Coolpad 7295+"},{"manufacturer":"Coolpad","market_name":"7295A","codename":"Coolpad7295A","model":"Coolpad 7295A"},{"manufacturer":"Coolpad","market_name":"7296","codename":"Coolpad7296","model":"Coolpad 7296"},{"manufacturer":"Coolpad","market_name":"7620L","codename":"Coolpad7620L","model":"Coolpad 7620L"},{"manufacturer":"Coolpad","market_name":"801EM","codename":"801EM","model":"801EM"},{"manufacturer":"Coolpad","market_name":"8079","codename":"Coolpad8079","model":"Coolpad 8079"},{"manufacturer":"Coolpad","market_name":"8122","codename":"Coolpad8122","model":"Coolpad 8122"},{"manufacturer":"Coolpad","market_name":"8198W","codename":"Coolpad8198W","model":"Coolpad 8198W"},{"manufacturer":"Coolpad","market_name":"8297D","codename":"Coolpad8297D","model":"Coolpad 8297D"},{"manufacturer":"Coolpad","market_name":"8297L-I00","codename":"Coolpad8297L-I00","model":"Coolpad 8297L-I00"},{"manufacturer":"Coolpad","market_name":"8298-M02","codename":"CP8298_M02","model":"CP8298_M02"},{"manufacturer":"Coolpad","market_name":"8676-I03","codename":"CP8676_I03","model":"CP8676_I03"},{"manufacturer":"Coolpad","market_name":"8712","codename":"CP8712","model":"Coolpad 8712"},{"manufacturer":"Coolpad","market_name":"8712SV","codename":"Coolpad8712","model":"Coolpad 8712"},{"manufacturer":"Coolpad","market_name":"8718","codename":"Coolpad8718","model":"Coolpad 8718"},{"manufacturer":"Coolpad","market_name":"8722","codename":"CP8722","model":"Coolpad 8722"},{"manufacturer":"Coolpad","market_name":"8722-U00","codename":"CP8722_U00","model":"Coolpad E570"},{"manufacturer":"Coolpad","market_name":"8722V","codename":"CP8722","model":"Coolpad 8722V"},{"manufacturer":"Coolpad","market_name":"8722_S00","codename":"CP8722_S00","model":"Coolpad E570"},{"manufacturer":"Coolpad","market_name":"8729","codename":"Coolpad8729","model":"Coolpad 8729"},{"manufacturer":"Coolpad","market_name":"8730L","codename":"Coolpad8730L","model":"Coolpad 8730L"},{"manufacturer":"Coolpad","market_name":"8736","codename":"8736","model":"Coolpad 8736"},{"manufacturer":"Coolpad","market_name":"8737A","codename":"Coolpad8737A","model":"Coolpad 8737A"},{"manufacturer":"Coolpad","market_name":"8970L","codename":"8970L","model":"Coolpad 8970L"},{"manufacturer":"Coolpad","market_name":"8971","codename":"8971","model":"Coolpad 8971"},{"manufacturer":"Coolpad","market_name":"9150W","codename":"Coolpad9150W","model":"Coolpad 9150W"},{"manufacturer":"Coolpad","market_name":"9190_T00","codename":"Coolpad9190_T00","model":"Coolpad 9190_T00"},{"manufacturer":"Coolpad","market_name":"9970L","codename":"9970L","model":"Coolpad 9970L"},{"manufacturer":"Coolpad","market_name":"9976A","codename":"Coolpad9976A","model":"Coolpad 9976A"},{"manufacturer":"Coolpad","market_name":"A8","codename":"A8","model":"Coolpad A8"},{"manufacturer":"Coolpad","market_name":"A8-831","codename":"A8-831","model":"Coolpad A8-831"},{"manufacturer":"Coolpad","market_name":"A8-930","codename":"A8-930","model":"Coolpad A8-930"},{"manufacturer":"Coolpad","market_name":"A8-931","codename":"A8-931","model":"Coolpad A8-931"},{"manufacturer":"Coolpad","market_name":"A8-931","codename":"A8-931","model":"Coolpad A8-931N"},{"manufacturer":"Coolpad","market_name":"A8-932","codename":"A8-932","model":"Coolpad A8-932"},{"manufacturer":"Coolpad","market_name":"B770","codename":"B770","model":"Coolpad B770"},{"manufacturer":"Coolpad","market_name":"B770S","codename":"CoolpadB770S","model":"Coolpad B770S"},{"manufacturer":"Coolpad","market_name":"Bs501","codename":"cp8870u","model":"Bs 501"},{"manufacturer":"Coolpad","market_name":"C1-S02","codename":"C1-S02","model":"Coolpad R116"},{"manufacturer":"Coolpad","market_name":"C103","codename":"C103","model":"C103"},{"manufacturer":"Coolpad","market_name":"C106-8","codename":"cool_c1","model":"C106-8"},{"manufacturer":"Coolpad","market_name":"CK2-01","codename":"CK2-01","model":"CK2-01"},{"manufacturer":"Coolpad","market_name":"CK3-01","codename":"CK3-01","model":"CK3-01"},{"manufacturer":"Coolpad","market_name":"CK3-01","codename":"CK3-01","model":"CK3-M1"},{"manufacturer":"Coolpad","market_name":"CM001","codename":"CoolpadCM001","model":"Coolpad CM001"},{"manufacturer":"Coolpad","market_name":"CP5108","codename":"msm7627a_a8_5108_new","model":"Coolpad 5108"},{"manufacturer":"Coolpad","market_name":"CP5210A","codename":"msm7627a_d7_5210a","model":"Coolpad 5210A"},{"manufacturer":"Coolpad","market_name":"CP5310","codename":"cp5310","model":"Coolpad 5310"},{"manufacturer":"Coolpad","market_name":"CP5660S","codename":"5560S","model":"5560S"},{"manufacturer":"Coolpad","market_name":"CP5952","codename":"Coolpad5952","model":"Coolpad 5952"},{"manufacturer":"Coolpad","market_name":"CP8021","codename":"Coolpad8021","model":"Coolpad 8021"},{"manufacturer":"Coolpad","market_name":"CP8089","codename":"CP8089","model":"Coolpad 8089"},{"manufacturer":"Coolpad","market_name":"CP8089Q","codename":"CP8089Q","model":"Coolpad 8089Q"},{"manufacturer":"Coolpad","market_name":"CP8295M","codename":"8295M","model":"Coolpad8295M"},{"manufacturer":"Coolpad","market_name":"CP8735","codename":"8735","model":"Coolpad 8735"},{"manufacturer":"Coolpad","market_name":"CP8750","codename":"8750","model":"Coolpad8750"},{"manufacturer":"Coolpad","market_name":"CP9190L","codename":"Coolpad9190L","model":"Coolpad 9190L"},{"manufacturer":"Coolpad","market_name":"CP9250L","codename":"Coolpad9250L","model":"Coolpad 9250L"},{"manufacturer":"Coolpad","market_name":"CP9970","codename":"9970","model":"Coolpad 9970"},{"manufacturer":"Coolpad","market_name":"CPA520","codename":"CoolpadA520","model":"Coolpad A520"},{"manufacturer":"Coolpad","market_name":"CPT1","codename":"CoolpadT1","model":"Coolpad T1"},{"manufacturer":"Coolpad","market_name":"Cool C1","codename":"cool_c1","model":"C106"},{"manufacturer":"Coolpad","market_name":"Cool C1","codename":"cool_c1","model":"C106-6"},{"manufacturer":"Coolpad","market_name":"Cool C1","codename":"cool_c1","model":"C106-7"},{"manufacturer":"Coolpad","market_name":"Cool C1","codename":"cool_c1","model":"C106-9"},{"manufacturer":"Coolpad","market_name":"Cool C1","codename":"cool_c1","model":"C107-9"},{"manufacturer":"Coolpad","market_name":"Coolmini","codename":"Coolmini","model":"Coolmini"},{"manufacturer":"Coolpad","market_name":"Coolpad 3636a_m","codename":"cp3636a","model":"cp3636a"},{"manufacturer":"Coolpad","market_name":"Coolpad 5370_I00","codename":"CoolpadE2","model":"coolpad E2"},{"manufacturer":"Coolpad","market_name":"Coolpad C1-U02","codename":"C103","model":"C1-U02"},{"manufacturer":"Coolpad","market_name":"Coolpad COL-A0","codename":"Civic","model":"COL-A0"},{"manufacturer":"Coolpad","market_name":"Coolpad COR-I0","codename":"clover","model":"Coolpad COR-I0"},{"manufacturer":"Coolpad","market_name":"Coolpad CVC-A0","codename":"Civic","model":"CVC-A0"},{"manufacturer":"Coolpad","market_name":"Coolpad CVC-M0","codename":"Civic","model":"CVC-M0"},{"manufacturer":"Coolpad","market_name":"Coolpad GRA-M0","codename":"GRA","model":"GRA-M0"},{"manufacturer":"Coolpad","market_name":"Coolpad POL-A0","codename":"pollux","model":"POL-A0"},{"manufacturer":"Coolpad","market_name":"Coolpad VCR-I0","codename":"victor","model":"VCR-I0"},{"manufacturer":"Coolpad","market_name":"Coolpad5218D","codename":"msm7627a_a5y_5218d","model":"Coolpad_5218D"},{"manufacturer":"Coolpad","market_name":"Coolpad5315","codename":"msm8610_s10_cp5315","model":"Coolpad 5315"},{"manufacturer":"Coolpad","market_name":"Coolpad5872","codename":"Coolpad5872","model":"Coolpad 5872"},{"manufacturer":"Coolpad","market_name":"Coolpad5879T","codename":"Coolpad5879T","model":"Coolpad 5879T"},{"manufacturer":"Coolpad","market_name":"Coolpad5891Q","codename":"Coolpad5891Q","model":"Coolpad 5891Q"},{"manufacturer":"Coolpad","market_name":"Coolpad5892","codename":"Coolpad5892","model":"Coolpad 5892"},{"manufacturer":"Coolpad","market_name":"Coolpad5950","codename":"Coolpad5950","model":"Coolpad 5950"},{"manufacturer":"Coolpad","market_name":"Coolpad5950T","codename":"Coolpad5950T","model":"Coolpad 5950T"},{"manufacturer":"Coolpad","market_name":"Coolpad7270_W00","codename":"Coolpad7270_W00","model":"Coolpad 7270_W00"},{"manufacturer":"Coolpad","market_name":"Coolpad7295C","codename":"Coolpad7295C","model":"Coolpad 7295C"},{"manufacturer":"Coolpad","market_name":"Coolpad7295C_C00","codename":"Coolpad7295C_C00","model":"Coolpad 7295C_C00"},{"manufacturer":"Coolpad","market_name":"Coolpad7295I","codename":"Coolpad7295I","model":"Spice Mi-515"},{"manufacturer":"Coolpad","market_name":"Coolpad7295T","codename":"Coolpad7295T","model":"Coolpad 7295T"},{"manufacturer":"Coolpad","market_name":"Coolpad7296S","codename":"Coolpad7296S","model":"Coolpad 7296S"},{"manufacturer":"Coolpad","market_name":"Coolpad7298A","codename":"Coolpad7298A","model":"Coolpad 7298A"},{"manufacturer":"Coolpad","market_name":"Coolpad7298D","codename":"Coolpad7298D","model":"Coolpad 7298D"},{"manufacturer":"Coolpad","market_name":"Coolpad7320","codename":"Coolpad7320","model":"Coolpad 7320"},{"manufacturer":"Coolpad","market_name":"Coolpad7920","codename":"7920","model":"Coolpad7920"},{"manufacturer":"Coolpad","market_name":"Coolpad801ES","codename":"801ES","model":"801ES"},{"manufacturer":"Coolpad","market_name":"Coolpad8085Q","codename":"Coolpad8085Q","model":"Coolpad8085Q"},{"manufacturer":"Coolpad","market_name":"Coolpad8198T","codename":"8198T","model":"Coolpad8198T"},{"manufacturer":"Coolpad","market_name":"Coolpad8297W","codename":"Coolpad8297W","model":"Coolpad 8297W"},{"manufacturer":"Coolpad","market_name":"Coolpad8705","codename":"Coolpad8705","model":"Coolpad 8705"},{"manufacturer":"Coolpad","market_name":"Coolpad8720L","codename":"Coolpad8720L","model":"Coolpad 8720L"},{"manufacturer":"Coolpad","market_name":"Coolpad8908","codename":"8908","model":"Coolpad8908"},{"manufacturer":"Coolpad","market_name":"E561","codename":"E561","model":"Coolpad E561"},{"manufacturer":"Coolpad","market_name":"Flo","codename":"7560T","model":"Coolpad Flo"},{"manufacturer":"Coolpad","market_name":"Forward_EVOLVE","codename":"Forward_EVOLVE","model":"Forward_EVOLVE"},{"manufacturer":"Coolpad","market_name":"Idea ULTRA","codename":"Coolpad7295S","model":"Idea ULTRA"},{"manufacturer":"Coolpad","market_name":"K2L_S00","codename":"K2L_S00","model":"Coolpad E580"},{"manufacturer":"Coolpad","market_name":"Karbonn Titanium S5 Plus","codename":"Karbonn","model":"Karbonn Titanium S5 Plus"},{"manufacturer":"Coolpad","market_name":"MEDION P5001","codename":"MEDION","model":"MEDION P5001"},{"manufacturer":"Coolpad","market_name":"MEDION P5001","codename":"P5001","model":"MEDION P5001"},{"manufacturer":"Coolpad","market_name":"Mtag 353","codename":"msm7627a_ea92_mts","model":"Mtag 353"},{"manufacturer":"Coolpad","market_name":"R106","codename":"cpy90_g00","model":"Coolpad R106"},{"manufacturer":"Coolpad","market_name":"R108","codename":"R108","model":"Coolpad R108"},{"manufacturer":"Coolpad","market_name":"SK3-U00","codename":"E561_EU","model":"Coolpad E561_EU"},{"manufacturer":"Coolpad","market_name":"SS1-03","codename":"SS1-03","model":"ivvi SS1-03"},{"manufacturer":"Coolpad","market_name":"SS2-01","codename":"SS2-01","model":"SS2-01"},{"manufacturer":"Coolpad","market_name":"SS2-01","codename":"SS2-01","model":"ivvi SS2-01"},{"manufacturer":"Coolpad","market_name":"STARADDICT III","codename":"cp8861u","model":"STARADDICT III"},{"manufacturer":"Coolpad","market_name":"Spice Mi-496","codename":"Coolpad7268I","model":"Spice Mi-496"},{"manufacturer":"Coolpad","market_name":"VCR-A0","codename":"victor","model":"VCR-A0"},{"manufacturer":"Coolpad","market_name":"Vodafone Smart 4G","codename":"cp8860u","model":"Vodafone Smart 4G"},{"manufacturer":"Coolpad","market_name":"VodafoneSmart4","codename":"VodafoneSmart4","model":"Vodafone Smart 4"},{"manufacturer":"Coolpad","market_name":"VodafoneSmart4turbo","codename":"VodafoneSmart4turbo","model":"Vodafone Smart 4 turbo"},{"manufacturer":"Coolpad","market_name":"Y72-921","codename":"Y72-921","model":"Coolpad Y72-921"},{"manufacturer":"Coolpad","market_name":"Y72-921","codename":"Y72_921","model":"Coolpad E571"},{"manufacturer":"Coolpad","market_name":"Y803-8","codename":"CPY803_8","model":"Coolpad Y803-8"},{"manufacturer":"Coolpad","market_name":"Y803-9","codename":"CPY803_9","model":"Coolpad Y803-9"},{"manufacturer":"Coolpad","market_name":"Y83-900","codename":"Y83-900","model":"Coolpad Y83-900"},{"manufacturer":"Coolpad","market_name":"Y83-I00","codename":"CPY83_I00","model":"Coolpad Y83-I00"},{"manufacturer":"Coolpad","market_name":"Y83_S00","codename":"CPY83_S00","model":"Coolpad E502"},{"manufacturer":"Coolpad","market_name":"Y83_U00","codename":"CPY83_U00","model":"Coolpad E502"},{"manufacturer":"Coolpad","market_name":"Y90","codename":"Y90","model":"Coolpad Y90"},{"manufacturer":"Coolpad","market_name":"Y91-921","codename":"Y91","model":"Coolpad Y891"},{"manufacturer":"Coolpad","market_name":"Y91-921","codename":"Y91","model":"Coolpad Y91-921"},{"manufacturer":"Coolpad","market_name":"Y92-9","codename":"Y92-9","model":"Coolpad Y92-9"},{"manufacturer":"Coolpad","market_name":"cp7236","codename":"msm8610_w7_cp7236","model":"Coolpad 7236"},{"manufacturer":"Coolpad","market_name":"i1","codename":"i1","model":"ivvi i1"},{"manufacturer":"Coolpad","market_name":"i1-01","codename":"i1-01","model":"ivvi i1-01"},{"manufacturer":"Coolpad","market_name":"i3-M1","codename":"i3-M1","model":"ivvi i3-M1"},{"manufacturer":"Coolpad","market_name":"ivvi SK5","codename":"SK5","model":"ivvi SK5"},{"manufacturer":"Coolpad","market_name":"ivvi SK5_S","codename":"SK5_S","model":"ivvi SK5_S"},{"manufacturer":"Coolpad","market_name":"ivvi V1M-S","codename":"V1M-S","model":"ivvi V1M-S"},{"manufacturer":"Coolpad","market_name":"ivvi i1-S","codename":"V4701_FR1","model":"ivvi i1-S"},{"manufacturer":"Coolpad","market_name":"ivvi i3-01","codename":"i3-01","model":"ivvi i3-01"},{"manufacturer":"Coolpad","market_name":"ivvi i3P-02","codename":"i3P-02","model":"ivvi i3P-02"},{"manufacturer":"Coppel","market_name":"ROCKET","codename":"ROCKET","model":"ROCKET"},{"manufacturer":"Coppernic","market_name":"C-One","codename":"C-One_v2","model":"C-One"},{"manufacturer":"Coppernic","market_name":"C-One","codename":"C-One_v2_NFC","model":"C-One"},{"manufacturer":"Coppernic","market_name":"C-eight","codename":"C-eight","model":"C-eight"},{"manufacturer":"Coppernic","market_name":"C-five","codename":"C-five","model":"C-five"},{"manufacturer":"Coppernic","market_name":"C-five","codename":"C-five-WIFI","model":"C-five"},{"manufacturer":"Covia","market_name":"CP-J55a","codename":"x5090_rh_j9_covia","model":"CP-J55a"},{"manufacturer":"Covia","market_name":"CP-J55aW","codename":"CP_J55aW","model":"CP-J55aW"},{"manufacturer":"Covia","market_name":"CP-L45s","codename":"CP-L45s","model":"CP-L45s"},{"manufacturer":"Covia","market_name":"g06+","codename":"g06","model":"g06"},{"manufacturer":"Crema","market_name":"CREMA0810T","codename":"crema0810t","model":"CREMA0810T"},{"manufacturer":"Croatian Telecom","market_name":"KSTB6044","codename":"KSTB6044","model":"KSTB6044"},{"manufacturer":"Crosscall","market_name":"Action-X3","codename":"HS8937QC","model":"ACTION-X3"},{"manufacturer":"Crosscall","market_name":"Action-X3","codename":"HS8937QC","model":"Action-X3"},{"manufacturer":"Crosscall","market_name":"Action-X3","codename":"HS8937QC","model":"Action-X3 Pro"},{"manufacturer":"Crosscall","market_name":"Action-X3","codename":"HS8937QCs","model":"ACTION-X3"},{"manufacturer":"Crosscall","market_name":"Action-X3","codename":"HS8937QCs","model":"Action-X3"},{"manufacturer":"Crosscall","market_name":"ODYSSEY","codename":"ODYSSEY3G","model":"ODYSSEY"},{"manufacturer":"Crosscall","market_name":"TREKKER- X3","codename":"HS8952QC","model":"TREKKER-X3"},{"manufacturer":"Crosscall","market_name":"TREKKER-M1 CORE","codename":"HS8909QC","model":"TREKKER-M1 CORE"},{"manufacturer":"Crosscall","market_name":"Trekker- M1","codename":"HS8916QC","model":"Trekker-M1"},{"manufacturer":"Cspire","market_name":"FT7","codename":"FT7_tw","model":"Android Tablet FT7"},{"manufacturer":"Cubot","market_name":"CUBOT H3","codename":"CUBOT_H3","model":"CUBOT H3"},{"manufacturer":"Cubot","market_name":"CUBOT MAGIC","codename":"CUBOT_MAGIC","model":"CUBOT MAGIC"},{"manufacturer":"Cubot","market_name":"CUBOT MAGIC","codename":"CUBOT_R9","model":"CUBOT R9"},{"manufacturer":"Cubot","market_name":"CUBOT NOTE Plus","codename":"CUBOT_NOTE_Plus","model":"CUBOT NOTE Plus"},{"manufacturer":"Cubot","market_name":"CUBOT R11","codename":"CUBOT_R11","model":"CUBOT R11"},{"manufacturer":"Cubot","market_name":"CUBOT X18","codename":"CUBOT_X18","model":"CUBOT X18"},{"manufacturer":"Cubot","market_name":"CUBOT_NOVA","codename":"CUBOT_NOVA","model":"CUBOT_NOVA"},{"manufacturer":"Cubot","market_name":"CUBOT_POWER","codename":"CUBOT_POWER","model":"CUBOT_POWER"},{"manufacturer":"Cubot","market_name":"DINOSAUR","codename":"x5623_h6013_cubot","model":"CUBOT DINOSAUR"},{"manufacturer":"Cubot","market_name":"ECHO","codename":"CUBOT_ECHO","model":"CUBOT ECHO"},{"manufacturer":"Cubot","market_name":"MANITO","codename":"CUBOT_MANITO","model":"CUBOT_MANITO"},{"manufacturer":"Cubot","market_name":"MAX","codename":"x6069_cubot_5365u","model":"CUBOT MAX"},{"manufacturer":"Cubot","market_name":"NOTE S","codename":"CUBOT_CHEETAH_2","model":"CUBOT CHEETAH 2"},{"manufacturer":"Cubot","market_name":"NOTE S","codename":"CUBOT_NOTE_S","model":"CUBOT_NOTE_S"},{"manufacturer":"Cubot","market_name":"RAINBOW 2","codename":"RAINBOW_2","model":"RAINBOW 2"},{"manufacturer":"Cubot","market_name":"Rainbow","codename":"RAINBOW","model":"RAINBOW"},{"manufacturer":"Cyrus","market_name":"CM17","codename":"CM17","model":"CM17"},{"manufacturer":"Cyrus","market_name":"CS22","codename":"CS22","model":"CS22"},{"manufacturer":"Cyrus","market_name":"CS24","codename":"CS24","model":"CS24"},{"manufacturer":"Cyrus","market_name":"CS40","codename":"CS40","model":"CS40"},{"manufacturer":"DBM Maroc","market_name":"ACCENT SURF 1000","codename":"SURF1000","model":"SURF1000"},{"manufacturer":"DBM Maroc","market_name":"Accent Speed Y2","codename":"Speed-Y2","model":"Speed-Y2"},{"manufacturer":"DBM Maroc","market_name":"Accent Speed Y3","codename":"Speed-Y3","model":"Speed-Y3"},{"manufacturer":"DBM Maroc","market_name":"FAST A6","codename":"FAST_A6","model":"FAST A6"},{"manufacturer":"DBM Maroc","market_name":"FAST7 4G","codename":"FAST7_4G","model":"FAST7_4G"},{"manufacturer":"DBM Maroc","market_name":"Pearl A2","codename":"PEARL_A2","model":"PEARL_A2"},{"manufacturer":"DBM Maroc","market_name":"Speed X2","codename":"Speed-X2","model":"Speed-X2"},{"manufacturer":"DEA Factory","market_name":"KTAB","codename":"KTAB","model":"KTAB"},{"manufacturer":"DEXP","market_name":"B350","codename":"B350","model":"B350"},{"manufacturer":"DEXP","market_name":"BS250","codename":"BS250","model":"BS250"},{"manufacturer":"DEXP","market_name":"DEXP B145","codename":"B145","model":"B145"},{"manufacturer":"DEXP","market_name":"DEXP G150","codename":"G150","model":"G150"},{"manufacturer":"DEXP","market_name":"DEXP Ixion M850","codename":"M850","model":"Ixion M850"},{"manufacturer":"DEXP","market_name":"DEXP Ixion X150","codename":"Ixion_X150","model":"Ixion X150"},{"manufacturer":"DEXP","market_name":"DEXP Ixion_ES1050","codename":"ES1050","model":"DEXP_ES1050"},{"manufacturer":"DEXP","market_name":"DEXP P170","codename":"P170","model":"P170"},{"manufacturer":"DEXP","market_name":"DEXP Ursus N169","codename":"N169","model":"N169"},{"manufacturer":"DEXP","market_name":"DEXP Ursus P310","codename":"P310","model":"P310"},{"manufacturer":"DEXP","market_name":"DEXP Ursus S169","codename":"S169","model":"S169"},{"manufacturer":"DEXP","market_name":"DEXP_B160","codename":"B160","model":"B160"},{"manufacturer":"DEXP","market_name":"DNS_DEXP XL150 Project","codename":"XL150","model":"XL150"},{"manufacturer":"DEXP","market_name":"Dexp Ursus P210","codename":"P210","model":"P210"},{"manufacturer":"DEXP","market_name":"Dexp Ursus P380","codename":"P380","model":"P380"},{"manufacturer":"DEXP","market_name":"Dexp Ursus S170i","codename":"S170i","model":"S170i"},{"manufacturer":"DEXP","market_name":"Dexp Ursus S270","codename":"S270","model":"S270"},{"manufacturer":"DEXP","market_name":"EL450","codename":"EL450","model":"Ixion EL450"},{"manufacturer":"DEXP","market_name":"ERA","codename":"G155","model":"G155"},{"manufacturer":"DEXP","market_name":"ERA","codename":"MS550","model":"MS550"},{"manufacturer":"DEXP","market_name":"ES355","codename":"ES355","model":"Ixion ES355"},{"manufacturer":"DEXP","market_name":"ES550","codename":"ES550","model":"Ixion ES550"},{"manufacturer":"DEXP","market_name":"ES750","codename":"ES750","model":"ES750"},{"manufacturer":"DEXP","market_name":"ES850","codename":"ES850","model":"Ixion ES850"},{"manufacturer":"DEXP","market_name":"G250","codename":"G250","model":"G250"},{"manufacturer":"DEXP","market_name":"GL255","codename":"GL255","model":"GL255"},{"manufacturer":"DEXP","market_name":"Ixion M355","codename":"M355","model":"Ixion M355"},{"manufacturer":"DEXP","market_name":"Ixion ML350","codename":"ML350","model":"Ixion ML350"},{"manufacturer":"DEXP","market_name":"Ixion ML450","codename":"ML450","model":"ML450"},{"manufacturer":"DEXP","market_name":"Ixion P350","codename":"P350","model":"Ixion P350"},{"manufacturer":"DEXP","market_name":"M340","codename":"M340","model":"Ixion M340"},{"manufacturer":"DEXP","market_name":"M545","codename":"M545","model":"Ixion M545"},{"manufacturer":"DEXP","market_name":"M750","codename":"M750","model":"Ixion M750"},{"manufacturer":"DEXP","market_name":"ML245","codename":"ML245","model":"Ixion ML245"},{"manufacturer":"DEXP","market_name":"MS650","codename":"MS650","model":"MS650"},{"manufacturer":"DEXP","market_name":"N280","codename":"N280","model":"N280"},{"manufacturer":"DEXP","market_name":"P280","codename":"P280","model":"P280"},{"manufacturer":"DEXP","market_name":"S190","codename":"S190","model":"S190"},{"manufacturer":"DEXP","market_name":"XL155","codename":"XL155","model":"Ixion XL155"},{"manufacturer":"DEXP","market_name":"Z150","codename":"Z150","model":"Z150"},{"manufacturer":"DEXP","market_name":"Z155","codename":"Z155","model":"Z155"},{"manufacturer":"DEXP","market_name":"Z255","codename":"Z255","model":"Z255"},{"manufacturer":"DEXP","market_name":"lxion MS255","codename":"MS255","model":"Ixion MS255"},{"manufacturer":"DIFRNCE","market_name":"DIT702201","codename":"DIT702201","model":"NID_7010"},{"manufacturer":"DL","market_name":"3406","codename":"G02DL","model":"Tablet DL 3406"},{"manufacturer":"DL","market_name":"3420","codename":"Tablet_DL_3420","model":"Tablet DL 3420"},{"manufacturer":"DL","market_name":"3420","codename":"Tablet_DL_3420","model":"Tablet_DL_3420"},{"manufacturer":"DL","market_name":"3903","codename":"Tablet_DL_3903","model":"Tablet_DL_3903"},{"manufacturer":"DL","market_name":"Creative Kids","codename":"Tablet_DL_3721","model":"Tablet_DL_3721"},{"manufacturer":"DL","market_name":"Creative Tab","codename":"Tablet_DL_3723","model":"Tablet_DL_3723"},{"manufacturer":"DL","market_name":"Creative kids","codename":"Tablet_DL_3725","model":"Tablet_DL_3725"},{"manufacturer":"DL","market_name":"DL3920","codename":"Tablet_DL_3920","model":"Tablet_DL_3920"},{"manufacturer":"DL","market_name":"Horizon H8","codename":"DL_Horizon_H8","model":"Smartphone DL Horizon H8"},{"manufacturer":"DL","market_name":"Horizon Tab T10","codename":"Tablet_DL_4010","model":"Tablet_DL_4010"},{"manufacturer":"DL","market_name":"Mobi Tab","codename":"Tablet_DL_2810","model":"Tablet_DL_2810"},{"manufacturer":"DL","market_name":"Mobi Tab","codename":"Tablet_DL_2811","model":"Tablet_DL_2811"},{"manufacturer":"DL","market_name":"Sabich\\xc3\\xb5es","codename":"Tablet_DL_3722","model":"Tablet_DL_3722"},{"manufacturer":"DL","market_name":"TabF\\xc3\\xa1cil","codename":"Tablet_DL_2820","model":"Tablet_DL_2820"},{"manufacturer":"DL","market_name":"TabKids Plus","codename":"TabKids_Plus","model":"Tablet DL 3411"},{"manufacturer":"DL","market_name":"TabPhone 710 pro","codename":"Tablet_DL_3421","model":"Tablet DL 3421"},{"manufacturer":"DL","market_name":"Tablet_DL_3724","codename":"Tablet_DL_3724","model":"Tablet_DL_3724"},{"manufacturer":"DL","market_name":"X_Quad_Pro","codename":"X_Quad_Pro","model":"Tablet DL 3410"},{"manufacturer":"DL","market_name":"YZU_DS53","codename":"Smartphone_YZU_DS53","model":"Smartphone_YZU_DS53"},{"manufacturer":"DL","market_name":"i-Player_KIDS","codename":"Tablet_DL_3910","model":"Tablet_DL_3910"},{"manufacturer":"DNA","market_name":"DNA TV-hubi","codename":"dctiw384","model":"DNA Android TV"},{"manufacturer":"DO Mobile","market_name":"Mate1","codename":"Mate1","model":"DO_S1"},{"manufacturer":"Daehap","market_name":"DH-B301K","codename":"DH-B301K","model":"DH-B301K"},{"manufacturer":"Danew","market_name":"DSlide 710","codename":"Dslide710","model":"Dslide710"},{"manufacturer":"Danew","market_name":"DSlide 750","codename":"Danew_DSlide750","model":"DSlide750"},{"manufacturer":"Danew","market_name":"Dslide 1013","codename":"DSlide1013","model":"DSlide 1013"},{"manufacturer":"Danew","market_name":"Dslide 1013QC","codename":"Dslide1013QC_v2","model":"Dslide1013QC_v2"},{"manufacturer":"Danew","market_name":"Dslide 714","codename":"Dslide714_v2","model":"Dslide714_v2"},{"manufacturer":"Danew","market_name":"Dslide1014","codename":"Dslide1014","model":"Dslide1014"},{"manufacturer":"Danew","market_name":"Dslide1016","codename":"Dslide1016","model":"Dslide1016"},{"manufacturer":"Danew","market_name":"Dslide714","codename":"Dslide714","model":"Dslide714"},{"manufacturer":"Danew","market_name":"Dslide971DC","codename":"Dslide971DC","model":"Dslide971DC"},{"manufacturer":"Danew","market_name":"Konnect 402","codename":"Konnect402","model":"Konnect402"},{"manufacturer":"Danew","market_name":"Konnect 504","codename":"Konnect_504","model":"Konnect_504"},{"manufacturer":"Danew","market_name":"Konnect 510 colors","codename":"Konnect_510","model":"Konnect_510_colors"},{"manufacturer":"Danew","market_name":"Konnect 560 Cin\\xc3\\xa9pix","codename":"Konnect_560","model":"Konnect_560"},{"manufacturer":"Danew","market_name":"Surnaturel_R500","codename":"Surnaturel_R500","model":"Surnaturel_R500"},{"manufacturer":"Danew","market_name":"konnect 601","codename":"Konnect_601","model":"Konnect_601"},{"manufacturer":"Datsun","market_name":"D5000","codename":"D5000","model":"D5000"},{"manufacturer":"Datsun","market_name":"Datsun_D5500","codename":"D5500","model":"DATSUN_D5500"},{"manufacturer":"Ddm","market_name":"ANDY 5EI","codename":"AM5E3I047","model":"ANDY 5EI"},{"manufacturer":"Dell","market_name":"","codename":"Dell_Grappa","model":"Dell Aero"},{"manufacturer":"Dell","market_name":"","codename":"Dell_Grappa","model":"Mini_3iG"},{"manufacturer":"Dell","market_name":"","codename":"Streak10Pro","model":"Dell Streak 10 Pro"},{"manufacturer":"Dell","market_name":"","codename":"qsd8250_surf","model":"Dell Mini 5"},{"manufacturer":"Dell","market_name":"","codename":"qsd8250_surf","model":"Dell Streak"},{"manufacturer":"Dell","market_name":"","codename":"streak7","model":"Dell Streak 7"},{"manufacturer":"Dell","market_name":"","codename":"streak7","model":"streak7"},{"manufacturer":"Dell","market_name":"","codename":"streakpro","model":"101DL"},{"manufacturer":"Dell","market_name":"","codename":"streakpro","model":"Dell V04B"},{"manufacturer":"Dell","market_name":"","codename":"streakpro","model":"GS01"},{"manufacturer":"Dell","market_name":"","codename":"venue","model":"BizSmartPhone"},{"manufacturer":"Dell","market_name":"","codename":"venue","model":"Dell Venue"},{"manufacturer":"Dell","market_name":"Chromebook 11 Model 3180","codename":"kefka_cheets","model":"Chromebook 11 Model 3180"},{"manufacturer":"Dell","market_name":"Chromebook 13 3380","codename":"asuka_cheets","model":"Dell Chromebook 13 3380"},{"manufacturer":"Dell","market_name":"Chromebook 13 7310","codename":"lulu_cheets","model":"Dell Chromebook 13 7310"},{"manufacturer":"Dell","market_name":"Cloud Connect","codename":"capri_wyse","model":"CS-1A13"},{"manufacturer":"Dell","market_name":"Streak","codename":"streak","model":"001DL"},{"manufacturer":"Dell","market_name":"Streak","codename":"streak","model":"Dell M01M"},{"manufacturer":"Dell","market_name":"Streak","codename":"streak","model":"Dell Streak"},{"manufacturer":"Dell","market_name":"Venue 10","codename":"SO","model":"Venue 10 5050"},{"manufacturer":"Dell","market_name":"Venue 7","codename":"LW","model":"Venue 7 3741"},{"manufacturer":"Dell","market_name":"Venue 7","codename":"Venue7","model":"Venue 7 3740"},{"manufacturer":"Dell","market_name":"Venue 7","codename":"Venue7","model":"Venue7 3740"},{"manufacturer":"Dell","market_name":"Venue 7","codename":"Venue7","model":"Venue7 3740 LTE"},{"manufacturer":"Dell","market_name":"Venue 7","codename":"thunderbird","model":"Venue 7 3730"},{"manufacturer":"Dell","market_name":"Venue 7","codename":"thunderbird","model":"Venue 7 HSPA+"},{"manufacturer":"Dell","market_name":"Venue 7040","codename":"EP","model":"Venue 10 7040"},{"manufacturer":"Dell","market_name":"Venue 8","codename":"BB","model":"Venue 8 7840"},{"manufacturer":"Dell","market_name":"Venue 8","codename":"BB","model":"Venue 8 7840 LTE"},{"manufacturer":"Dell","market_name":"Venue 8","codename":"Venue8","model":"Venue 8 3840"},{"manufacturer":"Dell","market_name":"Venue 8","codename":"Venue8","model":"Venue8 3840"},{"manufacturer":"Dell","market_name":"Venue 8","codename":"Venue8","model":"Venue8 3840 LTE"},{"manufacturer":"Dell","market_name":"Venue 8","codename":"yellowtail","model":"Venue 8 3830"},{"manufacturer":"Dell","market_name":"Venue 8","codename":"yellowtail","model":"Venue 8 HSPA+"},{"manufacturer":"Delm","market_name":"D1018","codename":"D1018","model":"D1018"},{"manufacturer":"Delm","market_name":"D718","codename":"D718","model":"D718"},{"manufacturer":"Denso Wave","market_name":"BHT-1600","codename":"BHT1600","model":"BHT1600"},{"manufacturer":"Denso Wave","market_name":"BHT-1700BWB-A7","codename":"BHT-1700BWB-1-A7","model":"BHT-1700BWB-1-A7"},{"manufacturer":"Denso Wave","market_name":"BHT-1700QLWB-A7-P","codename":"BHT-1700QLWB-P-A7","model":"BHT-1700QLWB-P-A7"},{"manufacturer":"Denso Wave","market_name":"BHT-1700QWB-1-A7","codename":"BHT-1700QWB-1-A7","model":"BHT-1700QWB-1-A7"},{"manufacturer":"Denso Wave","market_name":"BHT-1700QWB-2-A7","codename":"BHT-1700QWB-2-A7","model":"BHT-1700QWB-2-A7"},{"manufacturer":"Denso Wave","market_name":"BHT-1700QWBG-1-A7","codename":"BHT-1700QWBG-1-A7","model":"BHT-1700QWBG-1-A7"},{"manufacturer":"Denso Wave","market_name":"BHT-1700QWBG-2-A7","codename":"BHT-1700QWBG-2-A7","model":"BHT-1700QWBG-2-A7"},{"manufacturer":"Denso Wave","market_name":"BHT-1800QWB-1-A7","codename":"BHT-1800QWB-1-A7","model":"BHT-1800QWB-1-A7"},{"manufacturer":"Denso Wave","market_name":"BHT-1800QWB-2-A7","codename":"BHT-1800QWB-2-A7","model":"BHT-1800QWB-2-A7"},{"manufacturer":"Denso Wave","market_name":"BHT-1800QWB-3-A7","codename":"BHT-1800QWB-3-A7","model":"BHT-1800QWB-3-A7"},{"manufacturer":"Denso Wave","market_name":"BHT-1800QWBG-1-A7","codename":"BHT-1800QWBG-1-A7","model":"BHT-1800QWBG-1-A7"},{"manufacturer":"Denso Wave","market_name":"BHT-1800QWBG-2-A7","codename":"BHT-1800QWBG-2-A7","model":"BHT-1800QWBG-2-A7"},{"manufacturer":"Denso Wave","market_name":"BHT-1800QWBG-3-A7","codename":"BHT-1800QWBG-3-A7","model":"BHT-1800QWBG-3-A7"},{"manufacturer":"Denver Electronics","market_name":"SDQ-55034L","codename":"SDQ-55034L","model":"SDQ-55034L"},{"manufacturer":"Denver Electronics","market_name":"SDQ_52004L","codename":"SDQ_52004L","model":"SDQ_52004L"},{"manufacturer":"Dialog Blaze","market_name":"5701A","codename":"5701A","model":"5701A"},{"manufacturer":"Dialog Blaze","market_name":"M50E-1A","codename":"M50E-1A","model":"M50E-1A"},{"manufacturer":"DigiLand","market_name":"Compumax Blue","codename":"mid1016_ma","model":"Compumax Blue"},{"manufacturer":"DigiLand","market_name":"CompumaxBlue","codename":"mid1024_e","model":"Compumax_Blue_6030-805-0001"},{"manufacturer":"DigiLand","market_name":"DL1001","codename":"DL1001","model":"DL1001"},{"manufacturer":"DigiLand","market_name":"DL1008M","codename":"mid1008l_emmc","model":"DL1008M"},{"manufacturer":"DigiLand","market_name":"DL1010Q","codename":"DL1010Q","model":"DL1010Q"},{"manufacturer":"DigiLand","market_name":"DL1018A","codename":"mid1024_e","model":"DL1018A"},{"manufacturer":"DigiLand","market_name":"DL1025GH","codename":"DL1025GH","model":"DL1025GH"},{"manufacturer":"DigiLand","market_name":"DL1026","codename":"DL1026","model":"DL1026"},{"manufacturer":"DigiLand","market_name":"DL1168A","codename":"mid1102","model":"DL1168A"},{"manufacturer":"DigiLand","market_name":"DL7006","codename":"DL7006","model":"DL7006"},{"manufacturer":"DigiLand","market_name":"DL700D","codename":"DL700D","model":"DL700D"},{"manufacturer":"DigiLand","market_name":"DL701Q","codename":"DL701Q","model":"DL701Q"},{"manufacturer":"DigiLand","market_name":"DL718M","codename":"mid713l_lp","model":"DL718M"},{"manufacturer":"DigiLand","market_name":"DL721RB","codename":"DL721-RB","model":"DL721-RB"},{"manufacturer":"DigiLand","market_name":"DL785D","codename":"DL785D","model":"PLT7803G"},{"manufacturer":"DigiLand","market_name":"DL8006","codename":"DL8006","model":"DL8006"},{"manufacturer":"DigiLand","market_name":"DL9002","codename":"DL9002","model":"DL9002"},{"manufacturer":"DigiLand","market_name":"KTAB17","codename":"KTAB17","model":"KTAB17"},{"manufacturer":"DigiLand","market_name":"MID1008_Digiland","codename":"mid1008","model":"DL1008M"},{"manufacturer":"DigiLand","market_name":"NBDVDTAB9","codename":"NBDVDTAB9","model":"NBDVDTAB9"},{"manufacturer":"DigiLand","market_name":"NS-P16AT08","codename":"mid8005","model":"NS-P16AT08"},{"manufacturer":"DigiLand","market_name":"NS-P16AT785HD","codename":"MID7802RA","model":"NS-P16AT785HD"},{"manufacturer":"Digicel","market_name":"GO Onyx","codename":"GO_Onyx","model":"GO Onyx"},{"manufacturer":"Digicom","market_name":"Tribe","codename":"Tribe","model":"Digicom Tribe"},{"manufacturer":"Digilite","market_name":"TA70CA1","codename":"TA70CA1","model":"TA70CA1"},{"manufacturer":"Digilite","market_name":"TA70CA2","codename":"TA70CA2_1","model":"TA70CA2"},{"manufacturer":"Digilite","market_name":"TA70CA3","codename":"TA70CA3_1","model":"TA70CA3"},{"manufacturer":"Digilite","market_name":"TR10CD1","codename":"TR10CD1_5","model":"TR10CD1"},{"manufacturer":"Digilite","market_name":"TR10CS1","codename":"TR10CS1_3","model":"TR10CS1"},{"manufacturer":"Diginnos","market_name":"DG-A97QT","codename":"DG_A97QT","model":"DG-A97QT"},{"manufacturer":"Diginnos","market_name":"DG-D07S/GP","codename":"DG-D07SGP","model":"DG-D07SGP"},{"manufacturer":"Diginnos","market_name":"DG-Q08M","codename":"DG-Q08M","model":"DG-Q08M"},{"manufacturer":"Digital2","market_name":"Deluxe","codename":"nuclear-D2_Deluxe","model":"Digital2-Deluxe"},{"manufacturer":"Digital2","market_name":"Platinum","codename":"D2-963G","model":"Digital2 Platinum"},{"manufacturer":"Digital2","market_name":"Plus","codename":"Digital2Plus","model":"Digital2 Plus"},{"manufacturer":"DigitalStream","market_name":"DWA1015D Tablet","codename":"DWA1015D","model":"DWA1015D"},{"manufacturer":"Digitron","market_name":"i-Buddie","codename":"TR10CD1_10","model":"TR10CD1"},{"manufacturer":"Digitron","market_name":"i_Buddie","codename":"TR10CS1_12","model":"TR10CS1"},{"manufacturer":"Digix","market_name":"TAB-740_G","codename":"TAB-740_G","model":"TAB-740_G"},{"manufacturer":"Digma","market_name":"DIGMA CITI 1508 4G CS1114ML","codename":"CS1114ML","model":"CITI_1508_4G_CS1114ML"},{"manufacturer":"Digma","market_name":"DIGMA CITI 1532 3G CS1144MG","codename":"CS1144MG","model":"CITI 1532 3G CS1144MG"},{"manufacturer":"Digma","market_name":"DIGMA CITI 1544 3G CS1154MG","codename":"CS1154MG","model":"CITI_1544_3G_CS1154MG"},{"manufacturer":"Digma","market_name":"DIGMA CITI 7507 4G CS7113PL","codename":"CS7113PL","model":"CITI_7507_4G_CS7113PL"},{"manufacturer":"Digma","market_name":"DIGMA CITI 7543 3G CS7153MG","codename":"CS7153MG","model":"CITI_7543_3G_CS7153MG"},{"manufacturer":"Digma","market_name":"DIGMA CITI 8527 4G CS8139ML","codename":"CS8139ML","model":"CITI_8527_4G_CS8139ML"},{"manufacturer":"Digma","market_name":"DIGMA CITI 8531 3G CS8143MG","codename":"CS8143MG","model":"CITI 8531 3G CS8143MG"},{"manufacturer":"Digma","market_name":"DIGMA CITI 8542 4G CS8152ML","codename":"CS8152ML","model":"CITI_8542_4G_CS8152ML"},{"manufacturer":"Digma","market_name":"DIGMA HIT Q401 3G HT4039PG","codename":"HT4039PG","model":"HIT Q401 3G HT4039PG"},{"manufacturer":"Digma","market_name":"DIGMA HIT Q500 3G HT5035PG","codename":"HT5035PG","model":"HIT Q500 3G HT5035PG"},{"manufacturer":"Digma","market_name":"DIGMA LINX A453 3G LT4038PG","codename":"LT4038PG","model":"LINX A453 3G LT4038PG"},{"manufacturer":"Digma","market_name":"DIGMA LINX B510 3G LT5037MG","codename":"LT5037MG","model":"LINX B510 3G LT5037MG"},{"manufacturer":"Digma","market_name":"DIGMA Optima 1026N 3G TT1192PG","codename":"TT1192PG","model":"Optima 1026N 3G TT1192PG"},{"manufacturer":"Digma","market_name":"DIGMA Optima 7017N 3G TS7177MG","codename":"TS7177MG","model":"Optima 7017N 3G TS7177MG"},{"manufacturer":"Digma","market_name":"DIGMA Optima Prime 3 3G TS7131MG","codename":"TS7131MG","model":"Optima_Prime_3_3G_TS7131MG"},{"manufacturer":"Digma","market_name":"DIGMA Optima Prime 4 3G TT7174PG","codename":"TT7174PG","model":"Optima Prime 4 3G TT7174PG"},{"manufacturer":"Digma","market_name":"DIGMA Plane 1523 3G PS1135MG","codename":"PS1135MG","model":"Plane_1523_3G_PS1135MG"},{"manufacturer":"Digma","market_name":"DIGMA Plane 1524 3G PS1136MG","codename":"PS1136MG","model":"Plane_1524_3G_PS1136MG"},{"manufacturer":"Digma","market_name":"DIGMA Plane 1525 3G PS1137MG","codename":"PS1137MG","model":"Plane_1525_3G_PS1137MG"},{"manufacturer":"Digma","market_name":"DIGMA Plane 1526 4G PS1138ML","codename":"PS1138ML","model":"Plane_1526_4G_PS1138ML"},{"manufacturer":"Digma","market_name":"DIGMA Plane 1537E 3G PS1149MG","codename":"PS1149MG","model":"Plane_1537E_3G_PS1149MG"},{"manufacturer":"Digma","market_name":"DIGMA Plane 1538E 3G PS1150ML","codename":"PS1150ML","model":"Plane_1538E_4G_PS1150ML"},{"manufacturer":"Digma","market_name":"DIGMA Plane 1541E 4G PS1157ML","codename":"PS1157ML","model":"Plane_1541E_4G_PS1157ML"},{"manufacturer":"Digma","market_name":"DIGMA Plane 1550S 3G PS1163MG","codename":"PS1163MG","model":"Plane_1550S_3G_PS1163MG"},{"manufacturer":"Digma","market_name":"DIGMA Plane 1551S 4G PS1164ML","codename":"PS1164ML","model":"Plane_1551S_4G_PS1164ML"},{"manufacturer":"Digma","market_name":"DIGMA Plane 1553M 4G PS1166ML","codename":"PS1166ML","model":"Plane_1553M_4G_PS1166ML"},{"manufacturer":"Digma","market_name":"DIGMA Plane 1559 4G PS1173PL","codename":"PS1173PL","model":"Plane_1559_4G_PS1173PL"},{"manufacturer":"Digma","market_name":"DIGMA Plane 1570N 3G PS1185MG","codename":"PS1185MG","model":"Plane 1570N 3G PS1185MG"},{"manufacturer":"Digma","market_name":"DIGMA Plane 1713T 3G PT1138MG","codename":"PT1138MG","model":"Plane 1713T 3G PT1138MG"},{"manufacturer":"Digma","market_name":"DIGMA Plane 1715T 4G PT1139PL","codename":"PT1139PL","model":"Plane 1715T 4G PT1139PL"},{"manufacturer":"Digma","market_name":"DIGMA Plane 7006 4G PS7041PL","codename":"PS7041PL","model":"Plane_7006_4G_PS7041PL"},{"manufacturer":"Digma","market_name":"DIGMA Plane 7535E 3G PS7147MG","codename":"PS7147MG","model":"Plane_7535E_3G_PS7147MG"},{"manufacturer":"Digma","market_name":"DIGMA Plane 7539E 4G PS7155ML","codename":"PS7155ML","model":"Plane 7539E 4G PS7155ML"},{"manufacturer":"Digma","market_name":"DIGMA Plane 7545V 3G PS7151MG","codename":"PS7151MG","model":"Plane_7545V_3G_PS7151MG"},{"manufacturer":"Digma","market_name":"DIGMA Plane 7552M 3G PS7165MG","codename":"PS7165MG","model":"Plane_7552M_3G_PS7165MG"},{"manufacturer":"Digma","market_name":"DIGMA Plane 7556 3G PS7170MG","codename":"PS7170MG","model":"Plane_7556_3G_PS7170MG"},{"manufacturer":"Digma","market_name":"DIGMA Plane 7557 4G PS7171PL","codename":"PS7171PL","model":"Plane_7557_4G_PS7171PL"},{"manufacturer":"Digma","market_name":"DIGMA Plane 7574S 4G PS7191PL","codename":"PS7191PL","model":"Plane 7574S 4G PS7191PL"},{"manufacturer":"Digma","market_name":"DIGMA Plane 8540E 4G PS8156ML","codename":"PS8156ML","model":"Plane_8540E_4G_PS8156ML"},{"manufacturer":"Digma","market_name":"DIGMA Plane 8558 4G PS8172PL","codename":"PS8172PL","model":"Plane_8558_4G_PS8172PL"},{"manufacturer":"Digma","market_name":"DIGMA Plane 9634 3G PS9146MG","codename":"PS9146MG","model":"Plane_9634_3G_PS9146MG"},{"manufacturer":"Digma","market_name":"DIGMA Plane 9654M 3G PS9167PG","codename":"PS9167PG","model":"Plane_9654M_3G_PS9167PG"},{"manufacturer":"Digma","market_name":"DIGMA VOX Flash 4G VS5015ML","codename":"VS5015ML","model":"VOX Flash 4G VS5015ML"},{"manufacturer":"Digma","market_name":"DIGMA VOX G450 3G VS4001PG","codename":"VS4001PG","model":"VOX G450 3G VS4001PG"},{"manufacturer":"Digma","market_name":"DIGMA VOX G501 4G VS5033ML","codename":"VS5033ML","model":"VOX_G501_4G_VS5033ML"},{"manufacturer":"Digma","market_name":"DIGMA VOX S513 4G VS5035ML","codename":"VS5035ML","model":"VOX_S513_4G_VS5035ML"},{"manufacturer":"Digma","market_name":"LINX A452 3G","codename":"LT4030PG","model":"LINX A452 3G LT4030PG"},{"manufacturer":"Digma","market_name":"Plane 7012M 3G PS7082MG","codename":"PS7082MG","model":"Plane_7012M_3G_PS7082MG"},{"manufacturer":"Digma","market_name":"Plane 7546S 3G","codename":"PS7158PG","model":"Plane_7546S_3G_PS7158PG"},{"manufacturer":"Digma","market_name":"Plane 7547S 3G","codename":"PS7159PG","model":"Plane_7547S_3G_PS7159PG"},{"manufacturer":"Digma","market_name":"Plane 8522 3G PS8135MG","codename":"PS8135MG","model":"Plane_8522_3G_PS8135MG"},{"manufacturer":"Digma","market_name":"Plane 8536E 3G PS8148MG","codename":"PS8148MG","model":"Plane_8536E_3G_PS8148MG"},{"manufacturer":"Digma","market_name":"Plane 8555M 4G PS8168ML","codename":"PS8168ML","model":"Plane 8555M 4G PS8168ML"},{"manufacturer":"Digma","market_name":"Plane_7548S_4G_PS7160PL","codename":"PS7160PL","model":"Plane_7548S_4G_PS7160PL"},{"manufacturer":"Digma","market_name":"Plane_8548S_3G","codename":"PS8161PG","model":"Plane_8548S_3G_PS8161PG"},{"manufacturer":"Digma","market_name":"Plane_8549S_4G","codename":"PS8162PL","model":"Plane_8549S_4G_PS8162PL"},{"manufacturer":"Digma","market_name":"VOX E502 4G VS5036PL","codename":"VS5036PL","model":"VOX E502 4G VS5036PL"},{"manufacturer":"Digma","market_name":"VOX FIRE 4G VS5037PL","codename":"VS5037PL","model":"VOX FIRE 4G VS5037PL"},{"manufacturer":"Digma","market_name":"VOX_S508_3G","codename":"VS5031PG","model":"VOX S508 3G VS5031PG"},{"manufacturer":"Digma","market_name":"VOX_S509_3G","codename":"VS5032PG","model":"VOX S509 3G VS5032PG"},{"manufacturer":"Dingding","market_name":"X11","codename":"X11","model":"X11"},{"manufacturer":"Dish","market_name":"AirTV Player","codename":"uiw4010ech","model":"AirTV Player"},{"manufacturer":"Dish","market_name":"EVOLVE","codename":"dish_cable_bcm","model":"SH960C-DS"},{"manufacturer":"Disney Frozen","market_name":"BMF00001","codename":"BMF00001","model":"Frozen"},{"manufacturer":"Disney Frozen","market_name":"DYF00001","codename":"DYF00001","model":"DYF00001"},{"manufacturer":"Ditecma","market_name":"M1092R","codename":"M1092R","model":"M1092R"},{"manufacturer":"Ditecma","market_name":"M1092Rv4","codename":"M1092Rv4","model":"M1092Rv4"},{"manufacturer":"Ditigron","market_name":"i-Buddie","codename":"TR10CD1_11","model":"TR10CD1"},{"manufacturer":"Diva","market_name":"QC7704GM","codename":"QC7704GM","model":"QC7704GM"},{"manufacturer":"Docomo","market_name":"F-03H","codename":"F03H","model":"F-03H"},{"manufacturer":"Docomo","market_name":"F-03K","codename":"F03K","model":"F-03K"},{"manufacturer":"Docomo","market_name":"F-04K","codename":"F04K","model":"F-04K"},{"manufacturer":"Docomo","market_name":"F-05J","codename":"F05J","model":"F-05J"},{"manufacturer":"Docomo","market_name":"Japan","codename":"TT01","model":"TT01"},{"manufacturer":"Docomo","market_name":"MEDIAS TAB UL N-08D","codename":"N-08D","model":"N-08D"},{"manufacturer":"Docomo","market_name":"d-01J","codename":"d-01J","model":"d-01J"},{"manufacturer":"Docomo","market_name":"d-01K","codename":"d-01K","model":"d-01K"},{"manufacturer":"Docomo","market_name":"d-02K","codename":"d-02K","model":"d-02K"},{"manufacturer":"Doogee","market_name":"BL12000","codename":"Selfie","model":"BL12000"},{"manufacturer":"Doogee","market_name":"BL12000 PRO","codename":"t758_dg_a67t_n","model":"BL12000 PRO"},{"manufacturer":"Doogee","market_name":"BL5000","codename":"BL5000","model":"BL5000"},{"manufacturer":"Doogee","market_name":"BL7000","codename":"BL7000","model":"BL7000"},{"manufacturer":"Doogee","market_name":"MIX Lite","codename":"t766_dg_a66","model":"MIX Lite"},{"manufacturer":"Doogee","market_name":"Mix","codename":"MIX","model":"MIX"},{"manufacturer":"Doogee","market_name":"S30","codename":"S30","model":"S30"},{"manufacturer":"Doogee","market_name":"S50","codename":"t758_dg_m3t_n","model":"S50"},{"manufacturer":"Doogee","market_name":"S60","codename":"S60","model":"S60"},{"manufacturer":"Doogee","market_name":"S60 Lite","codename":"t777_dg_m1_65_n","model":"S60 Lite"},{"manufacturer":"Doogee","market_name":"Shoot_ 1","codename":"Shoot_1","model":"Shoot_1"},{"manufacturer":"Doogee","market_name":"T5","codename":"T5","model":"T5"},{"manufacturer":"Doogee","market_name":"T5S","codename":"T5S","model":"T5S"},{"manufacturer":"Doogee","market_name":"X10","codename":"doogee-X10","model":"DOOGEE X10"},{"manufacturer":"Doogee","market_name":"X20","codename":"X20","model":"X20"},{"manufacturer":"Doogee","market_name":"X20L","codename":"X20L","model":"X20L"},{"manufacturer":"Doogee","market_name":"X30","codename":"X30","model":"X30"},{"manufacturer":"Doogee","market_name":"X5  MAX","codename":"X5max","model":"X5max"},{"manufacturer":"Doogee","market_name":"X5 max pro","codename":"X5max_PRO","model":"X5max_PRO"},{"manufacturer":"Doogee","market_name":"X53","codename":"X53","model":"X53"},{"manufacturer":"Doogee","market_name":"X55","codename":"X55","model":"X55"},{"manufacturer":"Doogee","market_name":"X60L","codename":"t596_dg_d5506_x60l","model":"X60L"},{"manufacturer":"Doogee","market_name":"X60L","codename":"t596_dg_x60l","model":"X60L"},{"manufacturer":"Doogee","market_name":"X6pro","codename":"x5602_fxkj_k20","model":"X6pro"},{"manufacturer":"Doogee","market_name":"X7","codename":"s6061_dg_a50_m","model":"X7"},{"manufacturer":"Doogee","market_name":"X7Pro","codename":"x6069_dg_a50_37m65","model":"X7pro"},{"manufacturer":"Doogee","market_name":"X9 Mini","codename":"X9_Mini","model":"X9 Mini"},{"manufacturer":"Doogee","market_name":"X9 Mini","codename":"t530_dg_a54","model":"X9 Mini"},{"manufacturer":"Doogee","market_name":"X9 Pro","codename":"X9pro","model":"X9pro"},{"manufacturer":"Doogee","market_name":"X9S","codename":"X9S","model":"X9S"},{"manufacturer":"Doogee","market_name":"Y6","codename":"Y6","model":"Y6"},{"manufacturer":"Doogee","market_name":"Y6 C","codename":"Y6C","model":"Y6C"},{"manufacturer":"Doogee","market_name":"Y6 Max","codename":"Y6_Max","model":"Y6 Max"},{"manufacturer":"Doogee","market_name":"shoot 2","codename":"t591_dga57_we","model":"Shoot_2"},{"manufacturer":"Doopro","market_name":"C1","codename":"C1","model":"C1"},{"manufacturer":"Doopro","market_name":"C1_Pro","codename":"C1_Pro","model":"C1_Pro"},{"manufacturer":"Doopro","market_name":"P1","codename":"P1","model":"P1"},{"manufacturer":"Doopro","market_name":"P1_Pro","codename":"P1_Pro","model":"P1_Pro"},{"manufacturer":"Doopro","market_name":"P2","codename":"br6580_weg_n","model":"P2"},{"manufacturer":"Doopro","market_name":"P2_Pro","codename":"P2_Pro","model":"P2_Pro"},{"manufacturer":"Doopro","market_name":"P4","codename":"P4","model":"P4"},{"manufacturer":"Doopro","market_name":"P4_Pro","codename":"P4_Pro","model":"P4_Pro"},{"manufacturer":"Dopo","market_name":"DP7856K","codename":"DP7856K","model":"DP7856K"},{"manufacturer":"Dopo","market_name":"DPA23D","codename":"polaris-wifionly","model":"DPA23D"},{"manufacturer":"Dopo","market_name":"DPM1081","codename":"RCT6203W46","model":"DPM1081"},{"manufacturer":"Dopo","market_name":"DPM7827","codename":"RCT6773W22","model":"DPM7827"},{"manufacturer":"Dopo","market_name":"EM63 Tablet","codename":"EM63","model":"EM63"},{"manufacturer":"Dopo","market_name":"GS-918","codename":"GS_918","model":"GS-918"},{"manufacturer":"Doppio","market_name":"Doppio SL548","codename":"Doppio_SL548","model":"SL548"},{"manufacturer":"Doppio","market_name":"Doppio_SL505","codename":"Doppio_SL505","model":"SL505"},{"manufacturer":"Doppio","market_name":"SG402","codename":"SG402","model":"SG402"},{"manufacturer":"Doppio","market_name":"SG504","codename":"SG504","model":"SG504"},{"manufacturer":"Doppio","market_name":"SL452","codename":"SL452","model":"SL452"},{"manufacturer":"Doppio","market_name":"SL513","codename":"SL513","model":"SL513"},{"manufacturer":"Doppio","market_name":"SL558","codename":"Doppio_SL558","model":"SL558"},{"manufacturer":"Doppio","market_name":"U400","codename":"U400","model":"U400"},{"manufacturer":"Doppio","market_name":"U450","codename":"U450","model":"U450"},{"manufacturer":"Doppio","market_name":"U500","codename":"U500","model":"U500"},{"manufacturer":"Doro","market_name":"8020x","codename":"Doro_8020x","model":"Doro_8020x"},{"manufacturer":"Doro","market_name":"8031","codename":"DSB0010","model":"Doro 8031"},{"manufacturer":"Doro","market_name":"8040","codename":"DSB0090","model":"Doro 8040"},{"manufacturer":"Doro","market_name":"822","codename":"DSB0010","model":"Doro 8030"},{"manufacturer":"Doro","market_name":"822","codename":"DSB0010","model":"Doro 8031"},{"manufacturer":"Doro","market_name":"824","codename":"825A","model":"Doro 824"},{"manufacturer":"Doro","market_name":"825A","codename":"825A","model":"Doro 824"},{"manufacturer":"Doro","market_name":"825A","codename":"825A","model":"Doro Liberto 825"},{"manufacturer":"Doro","market_name":"DSB0010","codename":"DSB0010","model":"Doro 8030"},{"manufacturer":"Doro","market_name":"DSB0010","codename":"DSB0010","model":"Doro 8030/8031/8028"},{"manufacturer":"Doro","market_name":"Doro 8031","codename":"DSB0010","model":"Doro 8031"},{"manufacturer":"Doro","market_name":"Doro 8035","codename":"DSB0170","model":"Doro 8035"},{"manufacturer":"Doro","market_name":"Doro 8040","codename":"DSB0090","model":"Doro 8040"},{"manufacturer":"Doro","market_name":"Doro 8042","codename":"DSB0110","model":"Doro 8042"},{"manufacturer":"Doro","market_name":"Liberto 810","codename":"Liberto810","model":"Doro Liberto 810"},{"manufacturer":"Doro","market_name":"Liberto 810","codename":"Liberto810","model":"Doro Liberto 810-orange"},{"manufacturer":"Doro","market_name":"Liberto 810","codename":"Liberto810_S12","model":"Doro Liberto 810"},{"manufacturer":"Doro","market_name":"Liberto 820","codename":"Liberto820","model":"Doro Liberto 820"},{"manufacturer":"Doro","market_name":"Liberto 820 Mini","codename":"820Mini","model":"Doro Liberto 820 Mini"},{"manufacturer":"Doro","market_name":"Liberto 822 / 8030","codename":"DSB0010","model":"Doro 8030"},{"manufacturer":"Doro","market_name":"Liberto 822 / 8030","codename":"DSB0010","model":"Doro 8030/8031/8028"},{"manufacturer":"Doro","market_name":"Liberto 822 / 8030","codename":"DSB0010","model":"Doro 8031"},{"manufacturer":"Doro","market_name":"Liberto 822 / 8030","codename":"DSB0010","model":"Doro Liberto 822"},{"manufacturer":"Doro","market_name":"Liberto 825","codename":"825A","model":"825_T-Mobile"},{"manufacturer":"Dragontouch","market_name":"K8","codename":"K8","model":"K8"},{"manufacturer":"Dragontouch","market_name":"M10","codename":"M10","model":"M10"},{"manufacturer":"Dragontouch","market_name":"V10","codename":"V10","model":"V10"},{"manufacturer":"Dragontouch","market_name":"X10","codename":"X10A","model":"X10"},{"manufacturer":"Dragontouch","market_name":"X10","codename":"tulip-d210","model":"X10"},{"manufacturer":"Dragontouch","market_name":"X80","codename":"X80","model":"X80"},{"manufacturer":"Dragontouch","market_name":"X80 Plus","codename":"X80PLUS","model":"X80 Plus"},{"manufacturer":"Dragontouch","market_name":"Y88X Plus","codename":"Y88X_A","model":"Y88X_A"},{"manufacturer":"Dragontouch","market_name":"Y88X Plus","codename":"Y88X_PLUS","model":"Y88X Plus"},{"manufacturer":"Dragontouch","market_name":"Y88X Plus","codename":"Y88X_PLUS","model":"Y88X_PLUS"},{"manufacturer":"Dreamax","market_name":"DMX-ST7A","codename":"DMX-ST7A","model":"DMX-ST7A"},{"manufacturer":"Dtac","market_name":"Phone M2","codename":"dtacPhoneM2","model":"dtacPhoneM2"},{"manufacturer":"Dtac","market_name":"Phone S2","codename":"dtacPhoneS2","model":"dtac_Phone_S2"},{"manufacturer":"Dtac","market_name":"Phone S3","codename":"dtacPhoneS3","model":"dtacPhoneS3"},{"manufacturer":"Dtac","market_name":"Phone T2","codename":"dtacPhoneT2","model":"dtacPhoneT2"},{"manufacturer":"Dtac","market_name":"Phone X3","codename":"dtacPhoneX3","model":"dtacPhoneX3"},{"manufacturer":"Dtac","market_name":"dtacPhoneS3","codename":"dtacPhoneS3","model":"dtacPhoneS3"},{"manufacturer":"Dtac","market_name":"dtacPhoneT3","codename":"dtacPhoneT3","model":"dtacPhoneT3"},{"manufacturer":"Dtac","market_name":"dtac_Phone_S2","codename":"dtacPhoneS2","model":"dtac_Phone_S2"},{"manufacturer":"Dunns","market_name":"Dunns Slinger","codename":"DunnsSlinger","model":"Dunns Slinger"},{"manufacturer":"Dunns","market_name":"Smarty II","codename":"Smarty_II","model":"Smarty_II"},{"manufacturer":"E-Boda","market_name":"Eclipse G400M","codename":"Eclipse_G400M","model":"Eclipse_G400M"},{"manufacturer":"E-Boda","market_name":"Eclipse G500HD","codename":"E-Boda_Eclipse_G500HD","model":"Eclipse G500HD"},{"manufacturer":"E-Boda","market_name":"Eclipse G500M","codename":"Eclipse_G500M","model":"Eclipse_G500M"},{"manufacturer":"EBN","market_name":"NEBUPOS3","codename":"UY3A","model":"NEBUPOS3"},{"manufacturer":"ECS","market_name":"RealPad MA7BX2","codename":"RealPad_MA7BX2_1","model":"RealPad MA7BX2"},{"manufacturer":"ECS","market_name":"TC69CA2","codename":"TC69CA2_1","model":"TC69CA2"},{"manufacturer":"ECS","market_name":"TC70RA1","codename":"TC70RA1_2","model":"TC70RA1"},{"manufacturer":"ECS","market_name":"TF10EA2","codename":"TF10EA2_2","model":"TF10EA2"},{"manufacturer":"ECS","market_name":"TF10EA2","codename":"TF10EA2_4","model":"TF10EA2"},{"manufacturer":"ECS","market_name":"TF10EA2","codename":"TF10EA2_P61_2","model":"TF10EA2_P61"},{"manufacturer":"ECS","market_name":"TF10EA2","codename":"TF10EA2_P8_1","model":"TF10EA2_P8"},{"manufacturer":"ECS","market_name":"TF10MK1","codename":"TF10MK1_1","model":"TF10MK1"},{"manufacturer":"ECS","market_name":"TF10MK1","codename":"TF10MK1_3","model":"TF10MK1"},{"manufacturer":"ECS","market_name":"TI10RA1","codename":"TI10RA1_1","model":"TI10RA1"},{"manufacturer":"ECS","market_name":"TL10RA2","codename":"TL10RA2_1","model":"TL10RA2"},{"manufacturer":"ECS","market_name":"TP10RA1","codename":"TP10RA1_1","model":"TP10RA1"},{"manufacturer":"ECS","market_name":"TR10CS1","codename":"TR10CS1_12","model":"TR10CS1"},{"manufacturer":"ECS","market_name":"TR10CS1","codename":"TR10CS1_8","model":"TR10CS1"},{"manufacturer":"ECS","market_name":"TR10RS1","codename":"TR10RS1_11","model":"TR10RS1"},{"manufacturer":"ECS","market_name":"TR10RS1","codename":"TR10RS1_19","model":"TR10RS1"},{"manufacturer":"ECS","market_name":"TR10RS1","codename":"TR10RS1_2","model":"TR10RS1"},{"manufacturer":"ECS","market_name":"TU10MK","codename":"TU10MK_3","model":"TU10MK"},{"manufacturer":"EKO","market_name":"EKO OMEGA LTE Q60","codename":"EKO_OMEGA_LTE_Q60","model":"EKO OMEGA LTE Q60"},{"manufacturer":"EKO","market_name":"EKO OMEGA Q55","codename":"EKO_OMEGA_Q55","model":"EKO OMEGA Q55"},{"manufacturer":"EKO","market_name":"EKO Star LTE G60","codename":"EKO_Star_LTE_G60","model":"EKO Star LTE G60"},{"manufacturer":"ENTITY","market_name":"GDENTMY7317","codename":"GDENTMY7317","model":"GDENTMY7317"},{"manufacturer":"ESI Enterprises","market_name":"CKT3","codename":"CKT3","model":"CKT3"},{"manufacturer":"ESI Enterprises","market_name":"DT101Bv51","codename":"DT101Bv51","model":"DT101Bv51"},{"manufacturer":"ESI Enterprises","market_name":"DT7v51B","codename":"DT7v51B","model":"DT7v51B"},{"manufacturer":"ESI Enterprises","market_name":"EPIK Learning Tab 8\\'\\'","codename":"ELT0801","model":"ELT0801"},{"manufacturer":"ESI Enterprises","market_name":"EPIK Learning Tab Jr.","codename":"ELT0702","model":"ELT0702"},{"manufacturer":"ESI Enterprises","market_name":"EPIK_ELT0703","codename":"ELT0703","model":"ELT0703"},{"manufacturer":"ESI Enterprises","market_name":"Monster M7 Tablet","codename":"MONSTERM7","model":"M7"},{"manufacturer":"ESI Enterprises","market_name":"Trinity T101","codename":"Trinity_T101","model":"Trinity T101"},{"manufacturer":"ESI Enterprises","market_name":"Trinity T900","codename":"Trinity_T900","model":"Trinity T900"},{"manufacturer":"EXO S.A.","market_name":"wave-i007w","codename":"wave-i007w","model":"wave-i007w"},{"manufacturer":"Echo Mobiles","market_name":"ECHO_HOLI","codename":"HOLI","model":"ECHO_HOLI"},{"manufacturer":"Echo Mobiles","market_name":"HORIZON","codename":"HORIZON","model":"HORIZON"},{"manufacturer":"Echo Mobiles","market_name":"HORIZON LITE","codename":"ECHO_HORIZON_LITE","model":"ECHO_HORIZON_LITE"},{"manufacturer":"Echo Mobiles","market_name":"LOOK","codename":"LOOK","model":"LOOK"},{"manufacturer":"Echo Mobiles","market_name":"Moon","codename":"MOON","model":"MOON"},{"manufacturer":"Echo Mobiles","market_name":"SURF","codename":"SURF","model":"SURF"},{"manufacturer":"Echo Mobiles","market_name":"Stellar 4G","codename":"Stellar_4G","model":"Stellar 4G"},{"manufacturer":"Edcon","market_name":"Motion E1.1","codename":"MotionE11","model":"MotionE11"},{"manufacturer":"Edcon","market_name":"Platiunm vp.1","codename":"VerssedVP1","model":"Verssed VP1"},{"manufacturer":"Edcon","market_name":"Platiunm vp.2","codename":"VerssedVP2","model":"Verssed VP2"},{"manufacturer":"Edcon","market_name":"VERSSED platinum vp.2.1","codename":"VERSSEDvp2-1","model":"VERSSED vp2.1"},{"manufacturer":"Edcon","market_name":"Verssed Platinum VP3.0","codename":"VERSSED_Vp3","model":"VERSSED vp3"},{"manufacturer":"Eks Mobility","market_name":"X4U+","codename":"X4UPlus","model":"X4UPlus"},{"manufacturer":"Electroland Ghana","market_name":"NASCO_Allure","codename":"NASCO_Allure","model":"NASCO_Allure"},{"manufacturer":"Element","market_name":"USA & CANADA","codename":"Tiger838","model":"TU43GDX"},{"manufacturer":"Elephone","market_name":"A4","codename":"A4","model":"A4"},{"manufacturer":"Elephone","market_name":"Elephone S8","codename":"S8","model":"S8"},{"manufacturer":"Elephone","market_name":"P8 3D","codename":"P8_3D","model":"P8_3D"},{"manufacturer":"Elephone","market_name":"P8 Max","codename":"P8_Max","model":"P8_Max"},{"manufacturer":"Elephone","market_name":"U","codename":"Elephone_U","model":"U"},{"manufacturer":"Elephone","market_name":"U_Pro","codename":"U_Pro","model":"U_Pro"},{"manufacturer":"Elevate","market_name":"LUNA G60","codename":"G60","model":"LUNA G60"},{"manufacturer":"Elevate","market_name":"LUNA V55","codename":"V55","model":"LUNA V55"},{"manufacturer":"Elevate","market_name":"LUNA V57","codename":"V57","model":"LUNA V57"},{"manufacturer":"Elevate","market_name":"R50A","codename":"R50A","model":"R50A"},{"manufacturer":"Elevate","market_name":"V55C","codename":"V55C","model":"V55C"},{"manufacturer":"Ematic","market_name":"Cubby","codename":"SproutChannelCubby","model":"SproutChannelCubby"},{"manufacturer":"Ematic","market_name":"EBM104JB","codename":"EBM104JB","model":"EBM104JB"},{"manufacturer":"Ematic","market_name":"EGD078","codename":"EGD078","model":"EGD078"},{"manufacturer":"Ematic","market_name":"EGD103","codename":"EGD103","model":"EGD103"},{"manufacturer":"Ematic","market_name":"EGD170","codename":"EGD170","model":"Ematic EGD170"},{"manufacturer":"Ematic","market_name":"EGD172","codename":"EGD172","model":"EGD172"},{"manufacturer":"Ematic","market_name":"EGD213","codename":"EGD213","model":"EGD213"},{"manufacturer":"Ematic","market_name":"EGQ178","codename":"EGQ178","model":"EGQ178"},{"manufacturer":"Ematic","market_name":"EGQ180","codename":"EGQ180","model":"EGQ180"},{"manufacturer":"Ematic","market_name":"EGQ223","codename":"EGQ223","model":"EGQ223"},{"manufacturer":"Ematic","market_name":"EGQ235SK","codename":"EGQ235SK","model":"EGQ235SK"},{"manufacturer":"Ematic","market_name":"EGQ307","codename":"EGQ307","model":"EGQ307"},{"manufacturer":"Ematic","market_name":"EGQ327M","codename":"EGQ327M","model":"EGQ327M"},{"manufacturer":"Ematic","market_name":"EGQ337","codename":"EGQ337","model":"EGQ337"},{"manufacturer":"Ematic","market_name":"EGQ347","codename":"EGQ347","model":"EGQ347"},{"manufacturer":"Ematic","market_name":"EGQ367","codename":"EGQ367","model":"EGQ367"},{"manufacturer":"Ematic","market_name":"EGQ375","codename":"EGQ375","model":"EGQ375"},{"manufacturer":"Ematic","market_name":"EGQ377","codename":"EGQ377","model":"EGQ377"},{"manufacturer":"Ematic","market_name":"EGQ780","codename":"EGQ780","model":"EGQ780"},{"manufacturer":"Ematic","market_name":"EGS017","codename":"EGS017","model":"EGS017"},{"manufacturer":"Ematic","market_name":"EMATICEGS109","codename":"EGS109","model":"EGS109"},{"manufacturer":"Ematic","market_name":"ETH102","codename":"ETH102","model":"ETH102"},{"manufacturer":"Ematic","market_name":"FunTab 2","codename":"FunTab2","model":"FunTab2"},{"manufacturer":"Ematic","market_name":"FunTab 3","codename":"Funtab3","model":"FunTabPlay"},{"manufacturer":"Ematic","market_name":"FunTab 3","codename":"Funtab3","model":"Funtab3"},{"manufacturer":"Ematic","market_name":"GTB103B","codename":"Stealth_GTB103M","model":"GTB103M"},{"manufacturer":"Ematic","market_name":"PBS Kids PlayPad","codename":"PBSKD12","model":"PBSKD12"},{"manufacturer":"Ematic","market_name":"Sprout Channel Cubby","codename":"Cubby","model":"SproutChannelCubby"},{"manufacturer":"Ematic","market_name":"USA","codename":"Jetstream","model":"AGT418"},{"manufacturer":"Emdoor","market_name":"EM_I8180","codename":"em_i8180","model":"em_i8180"},{"manufacturer":"Emerson","market_name":"EM749/748","codename":"EM749_748","model":"EM749_748"},{"manufacturer":"Emerson","market_name":"EM9","codename":"EM9","model":"EM9"},{"manufacturer":"Emtec","market_name":"F400","codename":"f400","model":"f400"},{"manufacturer":"Emtec","market_name":"Gaming Android Gem Box","codename":"F500","model":"Gem Box F500"},{"manufacturer":"Energizer","market_name":"H550S","codename":"HARDCASEH550S","model":"HARDCASEH550S"},{"manufacturer":"Energizer","market_name":"HARDCASEH500S","codename":"HARDCASEH500S","model":"HARDCASEH500S"},{"manufacturer":"Energizer","market_name":"PowerMaxP550S","codename":"PowerMaxP550S","model":"P550S"},{"manufacturer":"Energizer","market_name":"PowerMaxP600S","codename":"PowerMaxP600S","model":"PowerMaxP600S"},{"manufacturer":"Energizer","market_name":"S550","codename":"S550","model":"S550"},{"manufacturer":"EnergySistem","market_name":"adelroth","codename":"adelroth","model":"Energy Tablet Pro 4"},{"manufacturer":"Enspert","market_name":"","codename":"E-TAB","model":"E-TAB"},{"manufacturer":"Enspert","market_name":"","codename":"ESP_E301","model":"ESP_E301BK"},{"manufacturer":"Enspert","market_name":"","codename":"ESP_E301","model":"ESP_E301V"},{"manufacturer":"Enspert","market_name":"","codename":"ESP_E301","model":"ESP_E301VD"},{"manufacturer":"Enspert","market_name":"","codename":"ESP_E301","model":"ESP_E301VE"},{"manufacturer":"Enspert","market_name":"","codename":"e201","model":"ESP_E201V7"},{"manufacturer":"Enspert","market_name":"","codename":"e201","model":"enspert_e201"},{"manufacturer":"Enspert","market_name":"","codename":"illuminus","model":"ITP-S100WD"},{"manufacturer":"Enspert","market_name":"","codename":"s8073","model":"Miracle"},{"manufacturer":"Enspert","market_name":"CINK KING","codename":"s9081","model":"CINK KING"},{"manufacturer":"Enspert","market_name":"CINK KING","codename":"s9081","model":"Cynus T2"},{"manufacturer":"Enspert","market_name":"CINK KING","codename":"s9081","model":"IMD501"},{"manufacturer":"Enspert","market_name":"CINK KING","codename":"s9081","model":"freebit PandA"},{"manufacturer":"Enspert","market_name":"CINK SLIM","codename":"s8073","model":"CINK SLIM"},{"manufacturer":"Enspert","market_name":"CINK SLIM","codename":"s8073","model":"Fly_IQ442"},{"manufacturer":"Enspert","market_name":"CINK SLIM","codename":"s8073","model":"WIKO-CINK SLIM"},{"manufacturer":"Enspert","market_name":"Carrefour CT1010","codename":"Carrefour","model":"CT1010"},{"manufacturer":"Enspert","market_name":"Cynus F3","codename":"s7511","model":"Cynus F3"},{"manufacturer":"Enspert","market_name":"DARKSIDE","codename":"s9301","model":"Cinema"},{"manufacturer":"Enspert","market_name":"DARKSIDE","codename":"s9301","model":"DARKSIDE"},{"manufacturer":"Enspert","market_name":"Lazer X40E","codename":"X40E","model":"X40E"},{"manufacturer":"Enspert","market_name":"MG","codename":"MGA930","model":"A930"},{"manufacturer":"Enspert","market_name":"STAIRWAY","codename":"s9111","model":"STAIRWAY"},{"manufacturer":"Enspert","market_name":"WIKO CINK PEAX","codename":"s9091","model":"CINK PEAX"},{"manufacturer":"Enspert","market_name":"WIKO CINK PEAX","codename":"s9091","model":"EverClassic"},{"manufacturer":"Enspert","market_name":"WIKO CINK+","codename":"s7505","model":"CINKPLUS"},{"manufacturer":"Enspert","market_name":"WIKO SUBLIM","codename":"s9070","model":"SUBLIM"},{"manufacturer":"Enspert","market_name":"Wiko CINK FIVE","codename":"s9201","model":"CINK FIVE"},{"manufacturer":"Enspert","market_name":"Wiko CINK FIVE","codename":"s9201","model":"Cynus T5"},{"manufacturer":"Enspert","market_name":"orion","codename":"orion","model":"NGM Orion"},{"manufacturer":"Enspert","market_name":"vanitysmart","codename":"vanitysmart","model":"NGM Vanity Smart"},{"manufacturer":"Entel","market_name":"OWN I62S","codename":"OWN-I62S","model":"OWN-I62S"},{"manufacturer":"Entel","market_name":"S3015","codename":"S3015","model":"S3015"},{"manufacturer":"Envizen","market_name":"ClickTabDSh18","codename":"ClickTabDSh18","model":"ClickTabDSh18"},{"manufacturer":"Envizen","market_name":"V1018A","codename":"V1018A","model":"V1018A"},{"manufacturer":"Envizen","market_name":"VMD9002","codename":"VMD9002","model":"VMD9002"},{"manufacturer":"Envizen Digital","market_name":"V100MD","codename":"V100MD","model":"V100MD"},{"manufacturer":"Envizen Digital","market_name":"V917G","codename":"GK-MID9022","model":"V917G"},{"manufacturer":"Envizen Digital","market_name":"VMD1029","codename":"VMD1029","model":"VMD1029"},{"manufacturer":"Ergo","market_name":"ERGO B500","codename":"B500","model":"ERGO B500 First"},{"manufacturer":"Ergo","market_name":"ERGO B501","codename":"B501","model":"B501"},{"manufacturer":"Ergo","market_name":"ERGO_A556","codename":"ERGO_A556","model":"ERGO_A556"},{"manufacturer":"Essential Products","market_name":"PH-1","codename":"mata","model":"PH-1"},{"manufacturer":"EssentielB","market_name":"Black Diamond","codename":"bird77_a_cu_ics2","model":"Essentielb-Black Diamond"},{"manufacturer":"EssentielB","market_name":"Pyxis","codename":"pyxis_boulanger","model":"Essentielb-Pixis"},{"manufacturer":"EssentielB","market_name":"ST7001 Tablet","codename":"ST7001","model":"ST7001"},{"manufacturer":"EssentielB","market_name":"Smart\\'TAB 7800","codename":"fiber-785q6","model":"Smart\\'Tab_7800"},{"manufacturer":"EssentielB","market_name":"Smart\\'TAB 9001","codename":"fiber-smart","model":"Smart\\'TAB 9001"},{"manufacturer":"Estar","market_name":"BEAUTY 2 HD Quad core","codename":"MID7378","model":"eSTAR BEAUTY 2 HD Quad core"},{"manufacturer":"Estar","market_name":"GO! HD Quad core 3G","codename":"MID7438G","model":"eSTAR GO HD Quad core 3G"},{"manufacturer":"Estar","market_name":"GO! IPS Quad core 3G","codename":"MID7458G","model":"eSTAR GO! IPS Quad core 3G"},{"manufacturer":"Estar","market_name":"GRAND HD Quad Core","codename":"MID1198","model":"eSTAR GRAND HD Quad core"},{"manufacturer":"Estar","market_name":"Grand IPS Quad core 3G","codename":"MID1258G","model":"eSTAR Grand IPS Quad core 3G"},{"manufacturer":"Estar","market_name":"eSTAR BEAUTY 2 HD Quad core","codename":"MID7388","model":"eSTAR BEAUTY 2 HD Quad core"},{"manufacturer":"Estar","market_name":"eSTAR GRAND HD Quad Core","codename":"MID1298","model":"eSTAR GRAND HD Quad core"},{"manufacturer":"Eten","market_name":"ET660","codename":"ETEN","model":"ET660"},{"manufacturer":"Etuline","market_name":"ETL-S4521","codename":"u939e_2","model":"ETL-S4521"},{"manufacturer":"Etuline","market_name":"ETL-S5042","codename":"u970_4","model":"ETL-S5042"},{"manufacturer":"EuroLeague","market_name":"I7a","codename":"Euroleague","model":"EuroleaguePhone"},{"manufacturer":"EuroLeague","market_name":"Westem Europe","codename":"DTP9503","model":"DTP9503"},{"manufacturer":"Evercoss","market_name":"A75 MAX","codename":"A75_MAX","model":"A75 MAX"},{"manufacturer":"Evercoss","market_name":"A75B","codename":"EVERCOSS_A75B","model":"A75B"},{"manufacturer":"Evercoss","market_name":"AT8B","codename":"AT8B","model":"AT8B"},{"manufacturer":"Evercoss","market_name":"M50","codename":"EVERCOSS_M50","model":"M50"},{"manufacturer":"Evercoss","market_name":"M50 MAX","codename":"EVERCOSS_M50_MAX","model":"M50 MAX"},{"manufacturer":"Evercoss","market_name":"M50 STAR","codename":"EVERCOSS_M50_STAR","model":"M50 STAR"},{"manufacturer":"Evercoss","market_name":"M50A","codename":"EVERCOSS_M50A","model":"M50A"},{"manufacturer":"Evercoss","market_name":"M50A MAX","codename":"EVERCOSS_M50A_MAX","model":"M50A MAX"},{"manufacturer":"Evercoss","market_name":"M53","codename":"M53","model":"M53"},{"manufacturer":"Evercoss","market_name":"M70","codename":"M70","model":"M70"},{"manufacturer":"Evercoss","market_name":"One X","codename":"A65_sprout","model":"EVERCOSS A65"},{"manufacturer":"Evercoss","market_name":"R40K","codename":"R40K","model":"R40K"},{"manufacturer":"Evercoss","market_name":"R45","codename":"EVERCOSS_R45","model":"R45"},{"manufacturer":"Evercoss","market_name":"R5C","codename":"R5C","model":"R5C"},{"manufacturer":"Evercoss","market_name":"R6","codename":"R6","model":"R6"},{"manufacturer":"Evercoss","market_name":"R70","codename":"R70","model":"R70"},{"manufacturer":"Evercoss","market_name":"R70A","codename":"R70A","model":"R70A"},{"manufacturer":"Evercoss","market_name":"S45","codename":"EVERCOSS_S45","model":"S45"},{"manufacturer":"Evercoss","market_name":"S50","codename":"EVERCOSS_S50","model":"S50"},{"manufacturer":"Evercoss","market_name":"S55A","codename":"S55A","model":"S55A"},{"manufacturer":"Evercoss","market_name":"S55B","codename":"S55B","model":"S55B"},{"manufacturer":"Evercoss","market_name":"U50","codename":"U50","model":"U50"},{"manufacturer":"Evercoss","market_name":"U50A","codename":"U50A","model":"U50A"},{"manufacturer":"Evercoss","market_name":"U50A MAX","codename":"U50A_MAX","model":"U50A MAX"},{"manufacturer":"Evercoss","market_name":"U50A_PLUS","codename":"U50A_PLUS","model":"U50A_PLUS"},{"manufacturer":"Evercoss","market_name":"U50B","codename":"U50B","model":"U50B"},{"manufacturer":"Evercoss","market_name":"U50C","codename":"U50C","model":"U50C"},{"manufacturer":"Evercoss","market_name":"U55","codename":"U55","model":"U55"},{"manufacturer":"Evercoss","market_name":"U6","codename":"EVERCOSS_U6","model":"U6"},{"manufacturer":"Evercoss","market_name":"U60","codename":"EVERCOSS_U60","model":"U60"},{"manufacturer":"Evercoss","market_name":"U60A","codename":"EVERCOSS_U60A","model":"U60A"},{"manufacturer":"Evercoss","market_name":"U6A","codename":"EVERCOSS_U6A","model":"U6A"},{"manufacturer":"Evercoss","market_name":"U70","codename":"U70","model":"U70"},{"manufacturer":"Evercoss","market_name":"U70A","codename":"EVERCOSS_U70A","model":"U70A"},{"manufacturer":"Evertek","market_name":"V4","codename":"V4","model":"EVERTEK V4"},{"manufacturer":"Evertek","market_name":"V4 Nano","codename":"V4_Nano","model":"V4 Nano"},{"manufacturer":"Evertek","market_name":"V4+","codename":"V4_Plus","model":"V4+"},{"manufacturer":"Evertek","market_name":"V6","codename":"V6","model":"V6"},{"manufacturer":"Evertek","market_name":"V8","codename":"V8","model":"V8"},{"manufacturer":"Every","market_name":"E701","codename":"E701","model":"E701"},{"manufacturer":"Eviant","market_name":"EVC10Q","codename":"EVIANT_EVT10Q","model":"EVIANT_EVT10Q"},{"manufacturer":"Eviant","market_name":"EVC8Q","codename":"EVIANT_EVC8Q","model":"EVC8Q"},{"manufacturer":"Evolio","market_name":"M5Pro","codename":"Evolio_M5Pro","model":"Evolio_M5Pro"},{"manufacturer":"Evolio","market_name":"M6","codename":"Evolio_M6","model":"Evolio_M6"},{"manufacturer":"Evolio","market_name":"M8","codename":"Evolio_M8","model":"Evolio_M8"},{"manufacturer":"Evolveo","market_name":"EVOLVEO StrongPhone G2","codename":"EVOLVEOG2","model":"EVOLVEO StrongPhone G2"},{"manufacturer":"Evolveo","market_name":"EVOLVEO StrongPhone G4","codename":"EVOLVEOG4","model":"EVOLVEO StrongPhone G4"},{"manufacturer":"Evolveo","market_name":"EVOLVEO StrongPhone G8","codename":"EVOLVEOG8","model":"EVOLVEO StrongPhone G8"},{"manufacturer":"Evolveo","market_name":"StrongPhone Q9","codename":"StrongPhoneQ9","model":"StrongPhoneQ9"},{"manufacturer":"Exertis","market_name":"SMB-H8009","codename":"SMB-H8009","model":"SMB-H8009"},{"manufacturer":"Explay","market_name":"4Game","codename":"4Game","model":"4Game"},{"manufacturer":"Explay","market_name":"ATV","codename":"ATV","model":"ATV"},{"manufacturer":"Explay","market_name":"Air","codename":"Air","model":"Air"},{"manufacturer":"Explay","market_name":"Atom","codename":"Atom","model":"Atom"},{"manufacturer":"Explay","market_name":"Bit","codename":"Bit","model":"Bit"},{"manufacturer":"Explay","market_name":"Brilliant","codename":"Cosmic","model":"Brilliant"},{"manufacturer":"Explay","market_name":"Cosmic","codename":"Cosmic","model":"Cosmic"},{"manufacturer":"Explay","market_name":"Craft","codename":"Craft","model":"Craft"},{"manufacturer":"Explay","market_name":"Discovery","codename":"Prime","model":"Discovery"},{"manufacturer":"Explay","market_name":"Easy","codename":"Easy","model":"Easy"},{"manufacturer":"Explay","market_name":"Favorite","codename":"Favorite","model":"Favorite"},{"manufacturer":"Explay","market_name":"Fog","codename":"Fog","model":"Fog"},{"manufacturer":"Explay","market_name":"Fresh","codename":"Fresh","model":"Fresh"},{"manufacturer":"Explay","market_name":"Fresh","codename":"Fresh_NF","model":"Fresh_NF"},{"manufacturer":"Explay","market_name":"Gravity","codename":"T4728","model":"Gravity"},{"manufacturer":"Explay","market_name":"Hit","codename":"Hit","model":"Hit"},{"manufacturer":"Explay","market_name":"Imperium 7","codename":"T4729","model":"Imperium7"},{"manufacturer":"Explay","market_name":"Imperium 8","codename":"T4730","model":"Imperium8"},{"manufacturer":"Explay","market_name":"Indigo","codename":"Indigo","model":"Indigo"},{"manufacturer":"Explay","market_name":"Joy TV","codename":"Joy_TV","model":"Joy_TV"},{"manufacturer":"Explay","market_name":"Leader","codename":"Leader","model":"Leader"},{"manufacturer":"Explay","market_name":"Light","codename":"Light","model":"Light"},{"manufacturer":"Explay","market_name":"Light 3G","codename":"Prime","model":"Light"},{"manufacturer":"Explay","market_name":"M1 Plus","codename":"Fog","model":"M1_Plus"},{"manufacturer":"Explay","market_name":"Onliner 4","codename":"G4187","model":"Onliner4"},{"manufacturer":"Explay","market_name":"Onyx","codename":"Onyx","model":"Onyx"},{"manufacturer":"Explay","market_name":"Party","codename":"Party","model":"Party"},{"manufacturer":"Explay","market_name":"Phantom","codename":"Phantom","model":"Phantom"},{"manufacturer":"Explay","market_name":"Planet","codename":"G4187","model":"Planet"},{"manufacturer":"Explay","market_name":"Prime","codename":"Prime","model":"Prime"},{"manufacturer":"Explay","market_name":"Pulsar","codename":"Pulsar","model":"Pulsar"},{"manufacturer":"Explay","market_name":"Rio Play","codename":"RioPlay","model":"RioPlay"},{"manufacturer":"Explay","market_name":"Shine","codename":"T5246","model":"Shine"},{"manufacturer":"Explay","market_name":"Style","codename":"T5246","model":"Style"},{"manufacturer":"Explay","market_name":"Surfer777 3G","codename":"Leader","model":"Surfer7773G"},{"manufacturer":"Explay","market_name":"Tab Mini","codename":"TabMini","model":"TabMini"},{"manufacturer":"Explay","market_name":"Tornado","codename":"Tornado","model":"Tornado"},{"manufacturer":"Explay","market_name":"Tornado 3G","codename":"Tornado3G","model":"Tornado3G"},{"manufacturer":"Explay","market_name":"Vega","codename":"Vega","model":"Vega"},{"manufacturer":"Explay","market_name":"Winner","codename":"T4728","model":"Winner"},{"manufacturer":"Explay","market_name":"Winner 7","codename":"T4729","model":"Winner7"},{"manufacturer":"Explay","market_name":"Winner 8","codename":"T4730","model":"Winner8"},{"manufacturer":"Express Gifts Limited","market_name":"R726","codename":"R726","model":"R726"},{"manufacturer":"Extrem","market_name":"Rock_X11","codename":"ROCK_X11","model":"ROCK_X11"},{"manufacturer":"F2 Mobile","market_name":"F2 F80s_plus","codename":"F80s_plus","model":"F80s_plus"},{"manufacturer":"F2 Mobile","market_name":"F2_LT5216","codename":"LT5216","model":"LT5216"},{"manufacturer":"F2 Mobile","market_name":"LT16","codename":"LT16","model":"LT16"},{"manufacturer":"F2 Mobile","market_name":"LT18","codename":"LT18","model":"LT18"},{"manufacturer":"FBC","market_name":"M24IS810","codename":"MX24","model":"TDA02"},{"manufacturer":"FBC","market_name":"M24IS820","codename":"fst01ms","model":"M24IS820"},{"manufacturer":"FPT Trading","market_name":"A15","codename":"A15_01","model":"A15"},{"manufacturer":"FPT Trading","market_name":"FPT S68 4G","codename":"FPT_S68_4G","model":"FPT S68 4G"},{"manufacturer":"FPT Trading","market_name":"FPT X10","codename":"X10","model":"FPT_X10"},{"manufacturer":"FPT Trading","market_name":"FPT X3","codename":"FPT_X3","model":"FPT X3"},{"manufacturer":"FPT Trading","market_name":"FPT X9","codename":"X9","model":"FPT_X9"},{"manufacturer":"FPT Trading","market_name":"X50","codename":"FPT_X50","model":"FPT X50"},{"manufacturer":"FaceVsion","market_name":"OC1020A","codename":"OC1020A","model":"FV-FG6"},{"manufacturer":"Fairphone","market_name":"FP2","codename":"FP2","model":"FP2"},{"manufacturer":"Fantec","market_name":"FANTEC M200H","codename":"M200H","model":"M200H"},{"manufacturer":"Fantec","market_name":"FANTEC M300H","codename":"M300H","model":"FAN-M300H"},{"manufacturer":"FarEasTone","market_name":"Smart 403","codename":"msm8226","model":"Smart 403"},{"manufacturer":"FarEasTone","market_name":"Smart 505","codename":"Smart505","model":"Smart 505"},{"manufacturer":"FarEasTone","market_name":"Smart 509","codename":"Smart509","model":"Smart509"},{"manufacturer":"FarEasTone","market_name":"Smart 550","codename":"Smart550","model":"Smart550"},{"manufacturer":"FarEasTone","market_name":"Smart501","codename":"Smart501","model":"Smart501"},{"manufacturer":"FarEasTone","market_name":"Smart503","codename":"MC2","model":"Smart503"},{"manufacturer":"FarEasTone","market_name":"Smart601","codename":"Smart601","model":"Smart601"},{"manufacturer":"Fero","market_name":"A5000","codename":"A5000","model":"A5000"},{"manufacturer":"Fero","market_name":"A5500","codename":"A5500","model":"A5500"},{"manufacturer":"Fero","market_name":"FERO ROYALE Y2","codename":"Royale_Y2","model":"Royale Y2"},{"manufacturer":"Fero","market_name":"POWER 3","codename":"Power_3","model":"Power 3"},{"manufacturer":"Fero","market_name":"Royale A1","codename":"Royale_A1","model":"Royale A1"},{"manufacturer":"Fero","market_name":"Royale X2","codename":"Royale_X2","model":"Royale_X2"},{"manufacturer":"Fero","market_name":"Royale Y2 Lite","codename":"Royale_Y2_Lite","model":"Royale Y2 Lite"},{"manufacturer":"Figi","market_name":"FIGI Fone","codename":"Fone","model":"Fone"},{"manufacturer":"Figi","market_name":"FIGI Ftwo","codename":"Ftwo","model":"Ftwo"},{"manufacturer":"Figi","market_name":"FIGI Gone","codename":"Gone","model":"Gone"},{"manufacturer":"Figo","market_name":"ATRIUM II F55L2","codename":"F55L2","model":"ATRIUM II F55L2"},{"manufacturer":"Figo","market_name":"CENTRIC S50G","codename":"S50G","model":"CENTRIC S50G"},{"manufacturer":"Finggo","market_name":"FWSP-S1000","codename":"FWSP-S1000-HW","model":"FWSP-S1000"},{"manufacturer":"Finggo","market_name":"FWTA-T1000","codename":"FWTA-T1000","model":"FWTA-T1000"},{"manufacturer":"FirstNationalBank","market_name":"FNB","codename":"SP5045V","model":"SP5045V"},{"manufacturer":"Flash","market_name":"Ivory","codename":"Ivory","model":"Ivory"},{"manufacturer":"Flash","market_name":"Live","codename":"Live","model":"Live"},{"manufacturer":"Flnet","market_name":"BandOTT","codename":"ba101","model":"ba101"},{"manufacturer":"Fluo","market_name":"F","codename":"F","model":"F"},{"manufacturer":"Fluo","market_name":"F Plus","codename":"F_Plus","model":"F_Plus"},{"manufacturer":"Fly","market_name":"5_S","codename":"5_S","model":"5S"},{"manufacturer":"Fly","market_name":"Champ","codename":"Champ","model":"FS529"},{"manufacturer":"Fly","market_name":"Cirrus 11","codename":"Cirrus_11","model":"FS517"},{"manufacturer":"Fly","market_name":"Cirrus 12","codename":"Cirrus_12","model":"FS516"},{"manufacturer":"Fly","market_name":"Cirrus 13","codename":"Cirrus_13","model":"FS518"},{"manufacturer":"Fly","market_name":"Cirrus 14","codename":"Cirrus_14","model":"FS522"},{"manufacturer":"Fly","market_name":"Cirrus 16","codename":"Cirrus_16","model":"FS523"},{"manufacturer":"Fly","market_name":"Cirrus 17","codename":"Cirrus_17","model":"FS525"},{"manufacturer":"Fly","market_name":"Cirrus 2","codename":"Cirrus_2","model":"FS504"},{"manufacturer":"Fly","market_name":"Cirrus 3","codename":"Cirrus_3","model":"FS506"},{"manufacturer":"Fly","market_name":"Cirrus 4","codename":"Cirrus_4","model":"FS507"},{"manufacturer":"Fly","market_name":"Cirrus 6","codename":"Cirrus_6","model":"Cirrus 6"},{"manufacturer":"Fly","market_name":"Cirrus 6","codename":"Cirrus_6","model":"FS508"},{"manufacturer":"Fly","market_name":"Cirrus 7","codename":"Cirrus_7","model":"FS511"},{"manufacturer":"Fly","market_name":"Cirrus 8","codename":"Cirrus_8","model":"FS514"},{"manufacturer":"Fly","market_name":"Cirrus 9","codename":"Cirrus_9","model":"FS553"},{"manufacturer":"Fly","market_name":"Dune 3","codename":"Dune_3","model":"IQ4507"},{"manufacturer":"Fly","market_name":"Dune 4","codename":"Dune_4","model":"Fly IQ4508"},{"manufacturer":"Fly","market_name":"ERA Nano 7","codename":"Fly_IQ4407","model":"IQ4407"},{"manufacturer":"Fly","market_name":"EVO Chic 1","codename":"IQ4405_Quad","model":"Fly IQ4405_Quad"},{"manufacturer":"Fly","market_name":"Ego Art 2","codename":"Fly_Ego_Art_2","model":"Fly Ego Art 2"},{"manufacturer":"Fly","market_name":"Era Energy 1","codename":"IQ4502_Quad","model":"IQ4502 Quad"},{"manufacturer":"Fly","market_name":"Era Life 2","codename":"IQ456","model":"IQ456"},{"manufacturer":"Fly","market_name":"Era Nano 6","codename":"Era_Nano_6","model":"IQ4406"},{"manufacturer":"Fly","market_name":"Era Nano 8","codename":"IQ4400","model":"IQ4400"},{"manufacturer":"Fly","market_name":"Era Nano 9","codename":"IQ436i","model":"IQ436i"},{"manufacturer":"Fly","market_name":"Era Style 3","codename":"IQ4415_Quad","model":"IQ4415 Quad"},{"manufacturer":"Fly","market_name":"Evo Chic 2","codename":"IQ459","model":"IQ459"},{"manufacturer":"Fly","market_name":"Evo Chic 2","codename":"IQ459","model":"IQ459 Quad"},{"manufacturer":"Fly","market_name":"Evo Energy4","codename":"IQ4501","model":"Evo Energy4"},{"manufacturer":"Fly","market_name":"Evo Tech 3","codename":"IQ4414_Quad","model":"IQ4414 Quad"},{"manufacturer":"Fly","market_name":"FS402","codename":"Stratus_2","model":"FS402"},{"manufacturer":"Fly","market_name":"FS451","codename":"Nimbus1","model":"FS451"},{"manufacturer":"Fly","market_name":"FS502","codename":"Cirrus_1","model":"FS502"},{"manufacturer":"Fly","market_name":"Flylife Connect 10.1","codename":"Flylife_Connect_101_3G_2","model":"Flylife Connect 10.1 3G 2"},{"manufacturer":"Fly","market_name":"Flylife Connect 7 3G 2","codename":"Flylife7","model":"Flylife Connect 7 3G 2"},{"manufacturer":"Fly","market_name":"Flylife Connect 7.85 3G 2","codename":"Flylife","model":"Flylife Connect 7.85 3G 2"},{"manufacturer":"Fly","market_name":"IQ434","codename":"IQ434","model":"IQ434"},{"manufacturer":"Fly","market_name":"IQ4401","codename":"IQ4401","model":"IQ4401"},{"manufacturer":"Fly","market_name":"IQ4409 Quad","codename":"IQ4409_Quad","model":"IQ4409 Quad"},{"manufacturer":"Fly","market_name":"IQ4413 Quad","codename":"IQ4413_Quad","model":"IQ4413_Quad"},{"manufacturer":"Fly","market_name":"IQ4415","codename":"IQ4415","model":"IQ4415"},{"manufacturer":"Fly","market_name":"IQ4416","codename":"IQ4416","model":"IQ4416"},{"manufacturer":"Fly","market_name":"IQ4417 Quad","codename":"IQ4417_Quad","model":"IQ4417 Quad"},{"manufacturer":"Fly","market_name":"IQ4418","codename":"IQ4418","model":"Fly IQ4418 AF"},{"manufacturer":"Fly","market_name":"IQ4418","codename":"IQ4418","model":"IQ4418"},{"manufacturer":"Fly","market_name":"IQ4420 Quad","codename":"IQ4420_Quad","model":"IQ4420 Quad"},{"manufacturer":"Fly","market_name":"IQ4421 Quad","codename":"IQ4421_Quad","model":"IQ4421 Quad"},{"manufacturer":"Fly","market_name":"IQ4490i","codename":"IQ4490i","model":"IQ4490i"},{"manufacturer":"Fly","market_name":"IQ4503","codename":"IQ4503","model":"FLY IQ4503"},{"manufacturer":"Fly","market_name":"IQ4503 Quad","codename":"IQ4503_Quad","model":"IQ4503 Quad"},{"manufacturer":"Fly","market_name":"IQ4504 Quad","codename":"IQ4504_Quad","model":"IQ4504 Quad"},{"manufacturer":"Fly","market_name":"IQ4505","codename":"IQ4505","model":"Fly IQ4505"},{"manufacturer":"Fly","market_name":"IQ4505 Quad","codename":"IQ4505_Quad","model":"IQ4505 Quad"},{"manufacturer":"Fly","market_name":"IQ4509","codename":"IQ4509","model":"IQ4509"},{"manufacturer":"Fly","market_name":"IQ4512 Quad","codename":"IQ4512_Quad","model":"IQ4512 Quad"},{"manufacturer":"Fly","market_name":"IQ4513","codename":"IQ4513","model":"IQ4513"},{"manufacturer":"Fly","market_name":"IQ4513 Octa","codename":"IQ4513_Octa","model":"IQ4513 Octa"},{"manufacturer":"Fly","market_name":"IQ4514 Quad","codename":"IQ4514_Quad","model":"Fly IQ4514"},{"manufacturer":"Fly","market_name":"IQ4514 Quad","codename":"IQ4514_Quad","model":"Fly IQ4514 AF"},{"manufacturer":"Fly","market_name":"IQ4514 Quad","codename":"IQ4514_Quad","model":"IQ4514 Quad"},{"manufacturer":"Fly","market_name":"IQ4515 Quad","codename":"IQ4515_Quad","model":"IQ4515 Quad"},{"manufacturer":"Fly","market_name":"IQ4516 Octa","codename":"IQ4516_Octa","model":"IQ4516"},{"manufacturer":"Fly","market_name":"IQ4516 Octa","codename":"IQ4516_Octa","model":"IQ4516 Octa"},{"manufacturer":"Fly","market_name":"IQ4551","codename":"Epic_Note","model":"IQ4551"},{"manufacturer":"Fly","market_name":"IQ458 Quad Evo Tech 2","codename":"IQ458","model":"IQ458 Quad"},{"manufacturer":"Fly","market_name":"IQ4601","codename":"IQ4601","model":"IQ4601"},{"manufacturer":"Fly","market_name":"IQ4602","codename":"Fly_IQ4602","model":"Fly IQ4602"},{"manufacturer":"Fly","market_name":"IQ4602","codename":"IQ4602_Quad","model":"IQ4602 Quad"},{"manufacturer":"Fly","market_name":"Iris","codename":"FLY_IQ4400","model":"FLY_IQ4400_AF"},{"manufacturer":"Fly","market_name":"Knockout","codename":"Knockout","model":"FS524"},{"manufacturer":"Fly","market_name":"Life Compact","codename":"Life_Compact","model":"Compact"},{"manufacturer":"Fly","market_name":"Life Mega","codename":"Life_Mega","model":"Mega"},{"manufacturer":"Fly","market_name":"Memory Plus","codename":"Memory_Plus","model":"FS528"},{"manufacturer":"Fly","market_name":"Nimbus 10","codename":"Nimbus_10","model":"FS512"},{"manufacturer":"Fly","market_name":"Nimbus 11","codename":"Nimbus_11","model":"FS455"},{"manufacturer":"Fly","market_name":"Nimbus 12","codename":"Nimbus_12","model":"FS510"},{"manufacturer":"Fly","market_name":"Nimbus 14","codename":"Nimbus_14","model":"FS456"},{"manufacturer":"Fly","market_name":"Nimbus 15","codename":"Nimbus_15","model":"FS457"},{"manufacturer":"Fly","market_name":"Nimbus 16","codename":"Nimbus_16","model":"FS459"},{"manufacturer":"Fly","market_name":"Nimbus 17","codename":"Nimbus_17","model":"FS527"},{"manufacturer":"Fly","market_name":"Nimbus 2","codename":"Nimbus_2","model":"FS452"},{"manufacturer":"Fly","market_name":"Nimbus 4","codename":"Nimbus_4","model":"FS551"},{"manufacturer":"Fly","market_name":"Nimbus 7","codename":"Nimbus_7","model":"FS505"},{"manufacturer":"Fly","market_name":"Nimbus 8","codename":"Nimbus_8","model":"FS454"},{"manufacturer":"Fly","market_name":"Nimbus 9","codename":"Nimbus_9","model":"Nimbus 9"},{"manufacturer":"Fly","market_name":"Nimbus3","codename":"Nimbus3","model":"FS501"},{"manufacturer":"Fly","market_name":"Phoenix 2","codename":"IQ4410i","model":"Phoenix 2"},{"manufacturer":"Fly","market_name":"Power Plus 1","codename":"Power_Plus_1","model":"FS521"},{"manufacturer":"Fly","market_name":"Power Plus 2","codename":"Power_Plus_2","model":"FS526"},{"manufacturer":"Fly","market_name":"Power Plus 3","codename":"PowerPlus3","model":"Power Plus 3"},{"manufacturer":"Fly","market_name":"Power Plus FHD","codename":"Power_Plus_FHD","model":"FS554"},{"manufacturer":"Fly","market_name":"Power Plus XXL","codename":"Power_Plus_XXL","model":"FS530"},{"manufacturer":"Fly","market_name":"Selfie 1","codename":"Selfie_1","model":"FS520"},{"manufacturer":"Fly","market_name":"Stratus","codename":"Stratus_6","model":"FS407"},{"manufacturer":"Fly","market_name":"Stratus 1","codename":"Stratus1","model":"FS401"},{"manufacturer":"Fly","market_name":"Stratus 3","codename":"Stratus_3","model":"FS404"},{"manufacturer":"Fly","market_name":"Stratus 4","codename":"Stratus_4","model":"FS405"},{"manufacturer":"Fly","market_name":"Stratus 5","codename":"Stratus_5","model":"FS406"},{"manufacturer":"Fly","market_name":"Stratus 7","codename":"Stratus_7","model":"FS458"},{"manufacturer":"Fly","market_name":"Stratus 8","codename":"Stratus_8","model":"FS408"},{"manufacturer":"Fly","market_name":"Stratus 9","codename":"Stratus_9","model":"FS409"},{"manufacturer":"Fly","market_name":"Tornado One","codename":"IQ4511_Octa","model":"FLY IQ4511"},{"manufacturer":"Fly","market_name":"Tornado One","codename":"IQ4511_Octa","model":"IQ4511 Octa"},{"manufacturer":"Fly","market_name":"Tornado One","codename":"IQ4511_Octa","model":"IQ4511 TR"},{"manufacturer":"Fossil","market_name":"Q Founder","codename":"grant","model":"Q Founder"},{"manufacturer":"Fossil","market_name":"Q Wander / Q Marshal / Q Founder 2.0 / Bradshaw / Dylan","codename":"gar","model":"Bradshaw"},{"manufacturer":"Fossil","market_name":"Q Wander / Q Marshal / Q Founder 2.0 / Bradshaw / Dylan","codename":"gar","model":"Q Marshal"},{"manufacturer":"Fossil","market_name":"Q Wander / Q Marshal / Q Founder 2.0 / Bradshaw / Dylan","codename":"gar","model":"Q Wander"},{"manufacturer":"Fossil","market_name":"Wear","codename":"mullet","model":"Vapor"},{"manufacturer":"Fossil","market_name":"Wear OS","codename":"mullet","model":"Vapor"},{"manufacturer":"Four Mobile","market_name":"S710 Ruby","codename":"S710_Ruby","model":"S710 Ruby"},{"manufacturer":"Four Mobile","market_name":"Sapphire","codename":"S750","model":"Sapphire"},{"manufacturer":"Four Mobile","market_name":"Thunder","codename":"S350","model":"Thunder"},{"manufacturer":"Foxconn","market_name":"","codename":"A1","model":"MUCHTEL A1"},{"manufacturer":"Foxconn","market_name":"","codename":"A800","model":"WellcoM-A800"},{"manufacturer":"Foxconn","market_name":"","codename":"Boston","model":"Boston"},{"manufacturer":"Foxconn","market_name":"","codename":"Boston","model":"Orange_Boston"},{"manufacturer":"Foxconn","market_name":"","codename":"FE6","model":"FE6"},{"manufacturer":"Foxconn","market_name":"","codename":"G1305","model":"GSmart-G1305"},{"manufacturer":"Foxconn","market_name":"","codename":"K2","model":"E120"},{"manufacturer":"Foxconn","market_name":"","codename":"K3","model":"E130"},{"manufacturer":"Foxconn","market_name":"","codename":"SF4Y6","model":"SF4Y6"},{"manufacturer":"Foxconn","market_name":"","codename":"a1","model":"Rstream-A1"},{"manufacturer":"Foxconn","market_name":"","codename":"a800","model":"WellcoM-A800"},{"manufacturer":"Foxconn","market_name":"","codename":"a89","model":"WellcoM-A89"},{"manufacturer":"Foxconn","market_name":"","codename":"a99","model":"WellcoM-A99"},{"manufacturer":"Foxconn","market_name":"","codename":"axioo","model":"PICOpad-QGN"},{"manufacturer":"Foxconn","market_name":"","codename":"fb0","model":"FIH-FB0"},{"manufacturer":"Foxconn","market_name":"","codename":"fm600","model":"Camangi-FM600"},{"manufacturer":"Foxconn","market_name":"","codename":"hd710","model":"Commtiva-HD710"},{"manufacturer":"Foxconn","market_name":"","codename":"m500","model":"MUSN-M500"},{"manufacturer":"Foxconn","market_name":"","codename":"magnumhd","model":"cherry-MagnumHD"},{"manufacturer":"Foxconn","market_name":"","codename":"mangrove7","model":"Camangi-Mangrove7"},{"manufacturer":"Foxconn","market_name":"","codename":"mi410","model":"CSL-MI410"},{"manufacturer":"Foxconn","market_name":"","codename":"msm7627_surf","model":"EV-S110"},{"manufacturer":"Foxconn","market_name":"","codename":"msm7627_surf","model":"FIH-F0X"},{"manufacturer":"Foxconn","market_name":"","codename":"msm7627_surf","model":"FIH-FM6"},{"manufacturer":"Foxconn","market_name":"","codename":"msm7627_surf","model":"KT-F100"},{"manufacturer":"Foxconn","market_name":"","codename":"msm7627_surf","model":"KT-S110"},{"manufacturer":"Foxconn","market_name":"","codename":"muchtela2","model":"MUCHTEL-A2"},{"manufacturer":"Foxconn","market_name":"","codename":"musn-t800","model":"Cherry-MUSN-T800"},{"manufacturer":"Foxconn","market_name":"","codename":"superion","model":"cherry mobile-SUPERION"},{"manufacturer":"Foxconn","market_name":"","codename":"t800","model":"MUSN-T800"},{"manufacturer":"Foxconn","market_name":"","codename":"vigo410","model":"Axioo-VIGO410"},{"manufacturer":"Foxconn","market_name":"","codename":"vt100","model":"V-T100"},{"manufacturer":"Foxconn","market_name":"A5","codename":"A5","model":"A5"},{"manufacturer":"Foxconn","market_name":"CSL Spice MI700","codename":"mi700","model":"CSL_Spice_MI700"},{"manufacturer":"Foxconn","market_name":"CSL Spice MI700","codename":"mi700","model":"Spice_MI700"},{"manufacturer":"Foxconn","market_name":"Casper_VIA_A6108","codename":"SI1","model":"Casper_VIA_A6108"},{"manufacturer":"Foxconn","market_name":"Commtiva N700","codename":"n700","model":"Commtiva-N700"},{"manufacturer":"Foxconn","market_name":"Dolphin 70e Black","codename":"dblack","model":"Dolphin 70e Black"},{"manufacturer":"Foxconn","market_name":"InFocus IN260","codename":"IN260","model":"IN260"},{"manufacturer":"Foxconn","market_name":"MUSN COUPLE","codename":"couple","model":"COUPLE"},{"manufacturer":"Foxconn","market_name":"SH530U","codename":"sh530u","model":"SH530U"},{"manufacturer":"Foxconn","market_name":"SH930W","codename":"FCN","model":"SH930W"},{"manufacturer":"Foxconn","market_name":"SHARP  SH837W","codename":"S1U","model":"SH837W"},{"manufacturer":"Foxconn","market_name":"SHARP SH630E","codename":"SAE","model":"SHP-SH630E"},{"manufacturer":"Foxconn","market_name":"SHARP SH631W","codename":"S2U","model":"SH631W"},{"manufacturer":"Foxconn","market_name":"SHARP SH837W","codename":"S1U","model":"SH837W"},{"manufacturer":"Foxconn","market_name":"ViewPhone3","codename":"viewphone3","model":"ViewPhone3"},{"manufacturer":"Foxconn","market_name":"XOLO","codename":"AZ510","model":"X900"},{"manufacturer":"Foxconn","market_name":"XOLO_X1000","codename":"SI1","model":"XOLO_X1000"},{"manufacturer":"Foxconn","market_name":"vizio VP700","codename":"S1U","model":"VP700"},{"manufacturer":"Foxconn","market_name":"vizio VP800","codename":"FCN","model":"VP800"},{"manufacturer":"Foxtel","market_name":"Foxtel Now box","codename":"dwt765fxt","model":"Foxtel Now box"},{"manufacturer":"Freebit","market_name":"A55J","codename":"arima6735_65u_l1","model":"TONE m15"},{"manufacturer":"Freebit","market_name":"Tone m15","codename":"TONE_m15","model":"TONE m15"},{"manufacturer":"Freebox","market_name":"Mini 4K","codename":"fbx6lc","model":"Freebox Player Mini"},{"manufacturer":"Freebox","market_name":"Mini 4K","codename":"fbx6lcv2","model":"Freebox Player Mini v2"},{"manufacturer":"Freetel","market_name":"Cricket Wave","codename":"Cricket_Wave","model":"FTU18A00"},{"manufacturer":"Freetel","market_name":"FUN PLUS","codename":"FUNPLUS","model":"FUN PLUS"},{"manufacturer":"Freetel","market_name":"ICE2","codename":"ICE2","model":"FTE161E"},{"manufacturer":"Freetel","market_name":"ICE2plus","codename":"ICE2plus","model":"FTE161G"},{"manufacturer":"Freetel","market_name":"ICE3","codename":"ICE3","model":"FTE171A"},{"manufacturer":"Freetel","market_name":"Miyabi 2 Dual","codename":"Miyabi2_Dual","model":"FTJ17B00"},{"manufacturer":"Freetel","market_name":"Priori 5","codename":"Priori5","model":"FTJ17C00"},{"manufacturer":"Freetel","market_name":"Priori4","codename":"Priori4","model":"FT162D"},{"manufacturer":"Freetel","market_name":"Priori4","codename":"Priori4","model":"FTJ162D"},{"manufacturer":"Freetel","market_name":"RAIJIN","codename":"RAIJIN","model":"FTJ162E"},{"manufacturer":"Freetel","market_name":"SAMURAI REI","codename":"FTJ161B","model":"FTJ161B"},{"manufacturer":"Freetel","market_name":"SAMURAI REI 2","codename":"SAMURAI_REI2","model":"FTJ17A00"},{"manufacturer":"Fujitsu","market_name":"ARROWS A SoftBank 101F","codename":"SBM101F","model":"101F"},{"manufacturer":"Fujitsu","market_name":"ARROWS A SoftBank 201F","codename":"SBM201F","model":"201F"},{"manufacturer":"Fujitsu","market_name":"ARROWS A SoftBank 202F","codename":"SBM202F","model":"202F"},{"manufacturer":"Fujitsu","market_name":"ARROWS A SoftBank 301F","codename":"SBM301F","model":"301F"},{"manufacturer":"Fujitsu","market_name":"ARROWS ES IS12F","codename":"FJI12","model":"IS12F"},{"manufacturer":"Fujitsu","market_name":"ARROWS Kiss F-03D","codename":"f11sky","model":"F-03D"},{"manufacturer":"Fujitsu","market_name":"ARROWS Kiss F-03E","codename":"F03E","model":"F-03E"},{"manufacturer":"Fujitsu","market_name":"ARROWS M01","codename":"M01","model":"M01"},{"manufacturer":"Fujitsu","market_name":"ARROWS M305","codename":"M305","model":"M305"},{"manufacturer":"Fujitsu","market_name":"ARROWS M357","codename":"M357","model":"M357"},{"manufacturer":"Fujitsu","market_name":"ARROWS M555","codename":"M555","model":"M555"},{"manufacturer":"Fujitsu","market_name":"ARROWS M555","codename":"M555SB","model":"M555"},{"manufacturer":"Fujitsu","market_name":"ARROWS Me F-11D","codename":"F11D","model":"F-11D"},{"manufacturer":"Fujitsu","market_name":"ARROWS NX F-06E","codename":"F06E","model":"F-06E"},{"manufacturer":"Fujitsu","market_name":"ARROWS S EM01F","codename":"EM01F","model":"EM01F"},{"manufacturer":"Fujitsu","market_name":"ARROWS Tab F-05E","codename":"F05E","model":"F-05E"},{"manufacturer":"Fujitsu","market_name":"ARROWS Tab FJT21","codename":"FJT21_jp_kdi","model":"FJT21"},{"manufacturer":"Fujitsu","market_name":"ARROWS Tab LTE F-01D","codename":"blaze_tablet","model":"F-01D"},{"manufacturer":"Fujitsu","market_name":"ARROWS Tab Wi-Fi FAR70B","codename":"FAR70B","model":"FAR70B"},{"manufacturer":"Fujitsu","market_name":"ARROWS Tab Wi-Fi FAR75A/70A","codename":"blaze_tablet","model":"FAR7"},{"manufacturer":"Fujitsu","market_name":"ARROWS V F-04E","codename":"F04E","model":"F-04E"},{"manufacturer":"Fujitsu","market_name":"ARROWS X F-02E","codename":"F02E","model":"F-02E"},{"manufacturer":"Fujitsu","market_name":"ARROWS X F-10D","codename":"F10D","model":"F-10D"},{"manufacturer":"Fujitsu","market_name":"ARROWS X LTE F-05D","codename":"blaze","model":"F-05D"},{"manufacturer":"Fujitsu","market_name":"ARROWS Z FJL22","codename":"FJL22_jp_kdi","model":"FJL22"},{"manufacturer":"Fujitsu","market_name":"ARROWS Z ISW11F","codename":"FJI11","model":"ISW11F"},{"manufacturer":"Fujitsu","market_name":"ARROWS Z ISW13F","codename":"FJI13","model":"ISW13F"},{"manufacturer":"Fujitsu","market_name":"ARROWS ef FJL21","codename":"FJL21","model":"FJL21"},{"manufacturer":"Fujitsu","market_name":"ARROWS mu F-07D","codename":"f11apo","model":"F-074"},{"manufacturer":"Fujitsu","market_name":"ARROWS mu F-07D","codename":"f11apo","model":"F-07D"},{"manufacturer":"Fujitsu","market_name":"ARROWS mu F-07D","codename":"f11apo","model":"FJJB091"},{"manufacturer":"Fujitsu","market_name":"Disney Mobile on docomo F-07E","codename":"F07E","model":"F-07E"},{"manufacturer":"Fujitsu","market_name":"Disney Mobile on docomo F-08D","codename":"blaze","model":"F-08D"},{"manufacturer":"Fujitsu","market_name":"F-01F","codename":"F01F","model":"F-01F"},{"manufacturer":"Fujitsu","market_name":"F-01H","codename":"F01H","model":"F-01H"},{"manufacturer":"Fujitsu","market_name":"F-01J","codename":"F01J","model":"F-01J"},{"manufacturer":"Fujitsu","market_name":"F-01K","codename":"F01K","model":"F-01K"},{"manufacturer":"Fujitsu","market_name":"F-02F","codename":"F02F","model":"F-02F"},{"manufacturer":"Fujitsu","market_name":"F-02G","codename":"F02G","model":"F-02G"},{"manufacturer":"Fujitsu","market_name":"F-02H","codename":"F02H","model":"F-02H"},{"manufacturer":"Fujitsu","market_name":"F-02K","codename":"F02K","model":"F-02K"},{"manufacturer":"Fujitsu","market_name":"F-03F","codename":"F03F","model":"F-03F"},{"manufacturer":"Fujitsu","market_name":"F-03G","codename":"F03G","model":"F-03G"},{"manufacturer":"Fujitsu","market_name":"F-03H","codename":"F03H","model":"F-03H"},{"manufacturer":"Fujitsu","market_name":"F-03K","codename":"F03K","model":"F-03K"},{"manufacturer":"Fujitsu","market_name":"F-04F","codename":"F04F","model":"F-04F"},{"manufacturer":"Fujitsu","market_name":"F-04G","codename":"F04G","model":"F-04G"},{"manufacturer":"Fujitsu","market_name":"F-04H","codename":"F04H","model":"F-04H"},{"manufacturer":"Fujitsu","market_name":"F-04J","codename":"F04J","model":"F-04J"},{"manufacturer":"Fujitsu","market_name":"F-05F","codename":"F05F","model":"F-05F"},{"manufacturer":"Fujitsu","market_name":"F-05G","codename":"F05G","model":"F-05G"},{"manufacturer":"Fujitsu","market_name":"F-06F","codename":"F06F","model":"F-06F"},{"manufacturer":"Fujitsu","market_name":"F-09D ANTEPRIMA","codename":"F09D","model":"F-09D"},{"manufacturer":"Fujitsu","market_name":"F-09E","codename":"F09E","model":"F-09E"},{"manufacturer":"Fujitsu","market_name":"F-12C","codename":"f11eif","model":"F-12C"},{"manufacturer":"Fujitsu","market_name":"FARTM9334P1","codename":"FARTM9334","model":"FARTM9334P1"},{"manufacturer":"Fujitsu","market_name":"FARTM933KZ","codename":"FARTM933KZ","model":"FARTM933KZ"},{"manufacturer":"Fujitsu","market_name":"FARTMB611Y","codename":"FARTMB611Y","model":"FARTMB611Y"},{"manufacturer":"Fujitsu","market_name":"FHMD001","codename":"FHMD001","model":"FHMD001"},{"manufacturer":"Fujitsu","market_name":"M02","codename":"M02","model":"M02"},{"manufacturer":"Fujitsu","market_name":"M305","codename":"M305","model":"M305"},{"manufacturer":"Fujitsu","market_name":"M305","codename":"M305SB","model":"M305"},{"manufacturer":"Fujitsu","market_name":"M363/P","codename":"UY1","model":"M363/P"},{"manufacturer":"Fujitsu","market_name":"M555","codename":"M555","model":"M555"},{"manufacturer":"Fujitsu","market_name":"Patio100","codename":"Patio100","model":"Patio100"},{"manufacturer":"Fujitsu","market_name":"Patio100","codename":"Patio100_3G","model":"Patio100_3G"},{"manufacturer":"Fujitsu","market_name":"REGZA Phone IS11T","codename":"TSI11","model":"IS11T"},{"manufacturer":"Fujitsu","market_name":"REGZA Phone T-01C","codename":"tg03","model":"IS04"},{"manufacturer":"Fujitsu","market_name":"REGZA Phone T-01C","codename":"tg03","model":"T-01C"},{"manufacturer":"Fujitsu","market_name":"REGZA Phone T-01D","codename":"blaze","model":"T-01D"},{"manufacturer":"Fujitsu","market_name":"REGZA Phone T-02D","codename":"T02D","model":"T-02D"},{"manufacturer":"Fujitsu","market_name":"RM02","codename":"M02","model":"RM02"},{"manufacturer":"Fujitsu","market_name":"Raku-Raku SMART PHONE F-12D","codename":"F12D","model":"F-12D"},{"manufacturer":"Fujitsu","market_name":"Raku-Raku SMART PHONE2 F-08E","codename":"F08E","model":"F-08E"},{"manufacturer":"Fujitsu","market_name":"STYLISTIC M350/CA2","codename":"M350","model":"M350"},{"manufacturer":"Fujitsu","market_name":"STYLISTIC M532","codename":"mx532","model":"M532"},{"manufacturer":"Fujitsu","market_name":"STYLISTIC M702","codename":"M702","model":"M702"},{"manufacturer":"Fujitsu","market_name":"STYLISTIC MH350","codename":"MH350","model":"MH350"},{"manufacturer":"Fujitsu","market_name":"STYLISTIC S01","codename":"S01","model":"S01-orange"},{"manufacturer":"Fujitsu","market_name":"SZJ-JS101","codename":"SZJ101","model":"SZJ-JS101"},{"manufacturer":"Fujitsu","market_name":"TM20","codename":"STF","model":"TM20"},{"manufacturer":"Fujitsu","market_name":"TONE m17","codename":"TONEm17","model":"TONE-m17"},{"manufacturer":"Fujitsu","market_name":"arrows Be F-05J","codename":"F05J","model":"F-05J"},{"manufacturer":"Fujitsu","market_name":"arrows M02","codename":"M02","model":"M02"},{"manufacturer":"Fujitsu","market_name":"arrows M03","codename":"M03","model":"arrowsM03"},{"manufacturer":"Fujitsu","market_name":"arrows M04","codename":"M04","model":"arrowsM04"},{"manufacturer":"Fujitsu","market_name":"arrows M04 PREMIUM","codename":"M04P","model":"arrowsM04-PREMIUM"},{"manufacturer":"Fujitsu","market_name":"arrows Tab M01T","codename":"M01T","model":"M01T"},{"manufacturer":"Funai Electric","market_name":"","codename":"smdkv210","model":"ALM-001J"},{"manufacturer":"Fusion5","market_name":"Fusion5","codename":"W104Plus","model":"W104Plus"},{"manufacturer":"Fusion5","market_name":"Fusion5_108","codename":"Fusion5_108","model":"Fusion5_108"},{"manufacturer":"Future Mobile Technology","market_name":"B-52","codename":"176HS1050232","model":"176HS1050232"},{"manufacturer":"Future Mobile Technology","market_name":"DRONE","codename":"FMT-NM7108-01","model":"FMT-NM7108-01"},{"manufacturer":"Future Mobile Technology","market_name":"Dual 8","codename":"FMT-NT8A42-01","model":"FMT-NT8A42-01"},{"manufacturer":"Future Mobile Technology","market_name":"Eagle","codename":"175WT1050231","model":"175WT1050231"},{"manufacturer":"Future Mobile Technology","market_name":"FMT-NM7054-01","codename":"FMT-NM7054-01","model":"FMT-NM7054-01"},{"manufacturer":"Future Mobile Technology","market_name":"FMT-NM7054-03","codename":"FMT-NM7054-03","model":"FMT-NM7054-03"},{"manufacturer":"Future Mobile Technology","market_name":"FMT-NM7058-03","codename":"FMT-NM7058-03","model":"FMT-NM7058-03"},{"manufacturer":"Future Mobile Technology","market_name":"Falcon","codename":"176HS1050531","model":"176HS1050531"},{"manufacturer":"Future Mobile Technology","market_name":"Flash","codename":"FMT-NM7058-02","model":"FMT-NM7058-02"},{"manufacturer":"Future Mobile Technology","market_name":"Netsurfer STORM","codename":"16M4HI105024","model":"16M4HI105024"},{"manufacturer":"Future Mobile Technology","market_name":"Netsurfer TYPHOON","codename":"16M5HI105023","model":"16M5HI105023"},{"manufacturer":"Future Mobile Technology","market_name":"Tomcat","codename":"175HS1050231","model":"175HS1050231"},{"manufacturer":"Future Mobile Technology","market_name":"Viper","codename":"175FT1050241","model":"175FT1050241"},{"manufacturer":"Future Mobile Technology","market_name":"netsurferDUAL 7","codename":"FMT-NM7116-01","model":"FMT-NM7116-01"},{"manufacturer":"G Y P NEW TREE SA","market_name":"VIEWPAD M10M","codename":"M10M","model":"VIEWPAD M10M"},{"manufacturer":"G-TiDE","market_name":"FANS7","codename":"FANS7","model":"G-TiDE FANS7"},{"manufacturer":"G53","market_name":"TA71CA3","codename":"TA71CA3_1","model":"TA71CA3"},{"manufacturer":"GD Classbook","market_name":"TA80CA1","codename":"TA80CA1_2","model":"TA80CA1"},{"manufacturer":"GIGI","market_name":"U1","codename":"GIGI_U1","model":"GIGI_U1"},{"manufacturer":"GSmart","market_name":"Akta A4","codename":"Akta_A4","model":"Akta_A4"},{"manufacturer":"GSmart","market_name":"Aku A1","codename":"Aku_A1","model":"GSmart Aku A1"},{"manufacturer":"GSmart","market_name":"Alto A2","codename":"Alto_A2","model":"GSmart Alto A2"},{"manufacturer":"GSmart","market_name":"Arty A3","codename":"Arty_A3","model":"GSmart Arty A3"},{"manufacturer":"GSmart","market_name":"Classic","codename":"Classic","model":"Classic"},{"manufacturer":"GSmart","market_name":"Classic_Pro","codename":"Classic_Pro","model":"Classic_Pro"},{"manufacturer":"GSmart","market_name":"Elite","codename":"Elite","model":"Elite"},{"manufacturer":"GSmart","market_name":"GS202+","codename":"GSmart_GS202","model":"GSmart GS202+"},{"manufacturer":"GSmart","market_name":"GSmart SX1","codename":"GBC_bravo","model":"GSmart SX1"},{"manufacturer":"GSmart","market_name":"GX2","codename":"GBC_ares","model":"GX2"},{"manufacturer":"GSmart","market_name":"Guru G1","codename":"Guru_G1","model":"GSmart Guru G1"},{"manufacturer":"GSmart","market_name":"Maya M1","codename":"MayaM1","model":"GSmart Maya M1"},{"manufacturer":"GSmart","market_name":"Maya M1 v2","codename":"Maya_M1_v2","model":"GSmart Maya M1 v2"},{"manufacturer":"GSmart","market_name":"Mika M2","codename":"Mika_M2","model":"GSmart Mika M2"},{"manufacturer":"GSmart","market_name":"Mika M3","codename":"Mika_M3","model":"GSmart Mika M3"},{"manufacturer":"GSmart","market_name":"Rey R3","codename":"Rey_R3","model":"GSmart Rey R3"},{"manufacturer":"GSmart","market_name":"Rio R1","codename":"Rio_R1","model":"GSmart Rio R1"},{"manufacturer":"GSmart","market_name":"Roma R2","codename":"Roma_R2","model":"GSmart Roma R2"},{"manufacturer":"GSmart","market_name":"SX1","codename":"bravo","model":"GSmart SX1"},{"manufacturer":"GSmart","market_name":"Saga_S3","codename":"Saga_S3","model":"GSmart Saga S3"},{"manufacturer":"GSmart","market_name":"Sierra S1","codename":"GSmart_Sierra_S1","model":"GSmart Sierra S1"},{"manufacturer":"GSmart","market_name":"Simba SX1","codename":"GBC_bravo","model":"Simba SX1"},{"manufacturer":"GSmart","market_name":"Simba SX1","codename":"bravo","model":"Simba SX1"},{"manufacturer":"GSmart","market_name":"T4","codename":"GSmart_T4","model":"GSmart T4"},{"manufacturer":"GSmart","market_name":"Tuku T2","codename":"Tuku_T2","model":"GSmart Tuku T2"},{"manufacturer":"Galapad","market_name":"Galapad S6","codename":"GALAPAD_S6","model":"GALAPAD_S6"},{"manufacturer":"Galexia","market_name":"GL9002","codename":"GL9002","model":"GL9002"},{"manufacturer":"Garmin","market_name":"","codename":"a10","model":"Garmin-Asus A10"},{"manufacturer":"Garmin","market_name":"Monterra","codename":"monterra","model":"Monterra"},{"manufacturer":"Garmin","market_name":"Nuvi 3595","codename":"scorpio","model":"nuvi 3595"},{"manufacturer":"Garmin","market_name":"Nuvifone","codename":"a50","model":"Garmin-Asus A50"},{"manufacturer":"Garmin","market_name":"Nuvifone","codename":"a50","model":"Garminfone"},{"manufacturer":"Garmin","market_name":"Nuvifone","codename":"a50","model":"nuvifone A50"},{"manufacturer":"Garmin","market_name":"Nuvifone","codename":"a50","model":"n\\xc3\\xbcvifone A50"},{"manufacturer":"Garmin","market_name":"nuvi 3590","codename":"scorpio","model":"nuvi 3590"},{"manufacturer":"Garmin","market_name":"nuvi 3592","codename":"scorpio","model":"nuvi 3592"},{"manufacturer":"Garmin","market_name":"nuvi 3595","codename":"scorpio","model":"nuvi 3595"},{"manufacturer":"Gasei S.A.","market_name":"Retailer Stores","codename":"SENSE901","model":"SENSE901"},{"manufacturer":"Gasei S.A.","market_name":"SENSE1003G","codename":"SENSE1003G","model":"SENSE1003G"},{"manufacturer":"Gasei S.A.","market_name":"SENSE701","codename":"SENSE701","model":"SENSE701"},{"manufacturer":"Gasei S.A.","market_name":"SENSE704G","codename":"SENSE704G","model":"SENSE704G"},{"manufacturer":"Geanee","market_name":"FXC-5A","codename":"FXC-5A","model":"FXC-5A"},{"manufacturer":"Geecoo","market_name":"G1","codename":"G1","model":"G1"},{"manufacturer":"Geecoo","market_name":"G2","codename":"G2","model":"G2"},{"manufacturer":"Geecoo","market_name":"G3","codename":"G3","model":"G3"},{"manufacturer":"Geecoo","market_name":"G4","codename":"G4","model":"G4"},{"manufacturer":"General Dynamics","market_name":"GD Tough Mobile","codename":"granite","model":"GD Tough Mobile"},{"manufacturer":"General Mobile","market_name":"4G","codename":"gm4g_s_sprout","model":"General Mobile 4G"},{"manufacturer":"General Mobile","market_name":"4G","codename":"gm4gtkc_s_sprout","model":"General Mobile 4G"},{"manufacturer":"General Mobile","market_name":"4G Dual","codename":"gm4g_sprout","model":"General Mobile 4G Dual"},{"manufacturer":"General Mobile","market_name":"5","codename":"gm5_s_sprout","model":"GM 5"},{"manufacturer":"General Mobile","market_name":"Discovery Air","codename":"Discovery_Air","model":"Discovery Air"},{"manufacturer":"General Mobile","market_name":"Discovery II Mini","codename":"Discovery_II_Mini","model":"Discovery II Mini"},{"manufacturer":"General Mobile","market_name":"E-tab 4","codename":"mehmet","model":"e-tab4"},{"manufacturer":"General Mobile","market_name":"Etab5","codename":"Etab5","model":"Etab5"},{"manufacturer":"General Mobile","market_name":"GM 6 d","codename":"GM6_d_sprout","model":"GM 6 d"},{"manufacturer":"General Mobile","market_name":"GM 6 s","codename":"GM6_s_sprout","model":"GM 6"},{"manufacturer":"General Mobile","market_name":"GM 6 s","codename":"GM6_s_sprout","model":"GM6"},{"manufacturer":"General Mobile","market_name":"GM5 Plus","codename":"gm5plus_s_sprout","model":"GM 5 Plus"},{"manufacturer":"General Mobile","market_name":"GM5 Plus Turkcell","codename":"gm5plustkc_s_sprout","model":"GM 5 Plus"},{"manufacturer":"General Mobile","market_name":"GM5 Plus d","codename":"gm5plus_sprout","model":"GM 5 Plus d"},{"manufacturer":"General Mobile","market_name":"GM8","codename":"GM8_d_sprout","model":"GM 8 d"},{"manufacturer":"General Mobile","market_name":"GM8","codename":"GM8_sprout","model":"GM 8"},{"manufacturer":"General Mobile","market_name":"GM8 Go","codename":"GM8_go","model":"GM8 go"},{"manufacturer":"General Mobile","market_name":"GM8 Go","codename":"GM8_go_sc","model":"GM8 go"},{"manufacturer":"General Mobile","market_name":"General Mobile 5 d","codename":"gm5_sprout","model":"GM 5 d"},{"manufacturer":"GeneralMobile","market_name":"E-Tab10","codename":"blue_eye","model":"E-Tab10"},{"manufacturer":"Geniatech","market_name":"Enjoy TV Quad-Core Box","codename":"ATV581","model":"Enjoy TV Quad-Core Box"},{"manufacturer":"Geniatech","market_name":"EnjoyTV","codename":"enjoytv","model":"ATV495MAX"},{"manufacturer":"Geniatech","market_name":"Enjoytv_hybrid","codename":"enjoytv_hybrid","model":"ATV598MAX"},{"manufacturer":"Gesellschaft f\\xc3\\xbcr SMK mBH","market_name":"Tough Mobile","codename":"granite","model":"CP600"},{"manufacturer":"Getac","market_name":"MX50","codename":"mx50","model":"MX50"},{"manufacturer":"Getac","market_name":"MX50","codename":"mx50","model":"mx50"},{"manufacturer":"Getac","market_name":"Z710","codename":"z710","model":"Getac Z710"},{"manufacturer":"Getac","market_name":"ZX70","codename":"zx70","model":"ZX70"},{"manufacturer":"Getac","market_name":"ZX70","codename":"zx70","model":"zx70"},{"manufacturer":"Ghia","market_name":"GTKIDS7R","codename":"GTKIDS7R","model":"GTKIDS7R"},{"manufacturer":"Ghia","market_name":"GTKIDS7V","codename":"GTKIDS7V","model":"GTKIDS7V"},{"manufacturer":"Ghia","market_name":"ZEUS 3G","codename":"N2","model":"GHIA_ZEUS_3G"},{"manufacturer":"Gigabyte","market_name":"","codename":"G1317S","model":"GSmart G1317S"},{"manufacturer":"Gigabyte","market_name":"9788","codename":"9788","model":"9788"},{"manufacturer":"Gigabyte","market_name":"Boston 4G","codename":"boston_4g","model":"Boston 4G"},{"manufacturer":"Gigabyte","market_name":"E9771","codename":"E9771","model":"E9771"},{"manufacturer":"Gigabyte","market_name":"EL-20-3710","codename":"TCV5","model":"EL-20-3050"},{"manufacturer":"Gigabyte","market_name":"EL-20-3710","codename":"TCV5","model":"EL-20-3710"},{"manufacturer":"Gigabyte","market_name":"GSmart G1310","codename":"G1310","model":"GSmart G1310"},{"manufacturer":"Gigabyte","market_name":"GSmart G1315","codename":"G1315","model":"GSmart G1315"},{"manufacturer":"Gigabyte","market_name":"GSmart G1317","codename":"G1317D","model":"GSmart G1317D"},{"manufacturer":"Gigabyte","market_name":"GSmart G1342","codename":"msm7627a","model":"GSmart G1342"},{"manufacturer":"Gigabyte","market_name":"GSmart G1345","codename":"msm7627_sku2","model":"GSmart G1345"},{"manufacturer":"Gigabyte","market_name":"GSmart G1355","codename":"G1355","model":"GSmart G1355"},{"manufacturer":"Gigabyte","market_name":"GSmart G1362","codename":"G1362","model":"GSmart G1362"},{"manufacturer":"Gigabyte","market_name":"GSmart GS202","codename":"GS202","model":"GSmart GS202"},{"manufacturer":"Gigabyte","market_name":"Hipstreet 9DTB7 / Lazer MY9308P","codename":"AMLMY9308P","model":"9DTB7"},{"manufacturer":"Gigabyte","market_name":"Hipstreet 9DTB7 / Lazer MY9308P","codename":"AMLMY9308P","model":"MY9308P"},{"manufacturer":"Gigabyte","market_name":"P102g","codename":"P102g","model":"P102G"},{"manufacturer":"Gigabyte","market_name":"PAPILIO G1","codename":"inhon77_cidals","model":"INHON PAPILIO G1"},{"manufacturer":"Gigabyte","market_name":"PROSCAN PLT1066 / MAG MAGPAD / TEAC TEACTAB / DOPO GS-1008","codename":"MID1005_K","model":"GS-1008"},{"manufacturer":"Gigabyte","market_name":"PROSCAN PLT1066 / MAG MAGPAD / TEAC TEACTAB / DOPO GS-1008","codename":"MID1005_K","model":"MAGPAD"},{"manufacturer":"Gigabyte","market_name":"PROSCAN PLT1066 / MAG MAGPAD / TEAC TEACTAB / DOPO GS-1008","codename":"MID1005_K","model":"PLT1066"},{"manufacturer":"Gigabyte","market_name":"PROSCAN PLT1066 / MAG MAGPAD / TEAC TEACTAB / DOPO GS-1008","codename":"MID1005_K","model":"TEACTAB"},{"manufacturer":"Gigabyte","market_name":"SAF3011","codename":"SAF3011","model":"SAF3011"},{"manufacturer":"Gigabyte","market_name":"SB506","codename":"SB506","model":"SB506"},{"manufacturer":"Gigabyte","market_name":"SB510 / IBT-102","codename":"SB510","model":"SB510"},{"manufacturer":"Gigabyte","market_name":"TB100","codename":"TB100","model":"Gigabyte TB100"},{"manufacturer":"Gigabyte","market_name":"TB100","codename":"TB100","model":"TB100"},{"manufacturer":"Gigabyte","market_name":"TECNO P3S","codename":"P3S","model":"TECNO P3S"},{"manufacturer":"Gigabyte","market_name":"TM105","codename":"TM105","model":"TM105"},{"manufacturer":"Gigabyte","market_name":"TM105A","codename":"TM105A","model":"Aero1021/P1021HCBA4C1VXX"},{"manufacturer":"Gigabyte","market_name":"TM105A","codename":"TM105A","model":"Glacier"},{"manufacturer":"Gigabyte","market_name":"TM105A","codename":"TM105A","model":"Qrypton1010"},{"manufacturer":"Gigabyte","market_name":"TM105A","codename":"TM105A","model":"TM105A"},{"manufacturer":"Gigabyte","market_name":"TM75A","codename":"TM75A","model":"GSmart7Tab"},{"manufacturer":"Gigabyte","market_name":"TM75A","codename":"TM75A","model":"Qrypton7"},{"manufacturer":"Gigabyte","market_name":"TM75A","codename":"TM75A","model":"TM75A"},{"manufacturer":"Gigabyte","market_name":"TM75A","codename":"TM75A","model":"Voyager"},{"manufacturer":"Gigabyte","market_name":"TM75A-V","codename":"TM75A-V","model":"TM75A-V"},{"manufacturer":"Gigabyte","market_name":"W5510","codename":"W5510","model":"W5510"},{"manufacturer":"Gigabyte","market_name":"W6360","codename":"W6360","model":"W6360"},{"manufacturer":"Gigabyte","market_name":"mexico","codename":"Lanix","model":"iliumPAD"},{"manufacturer":"Gigaset","market_name":"GS160","codename":"GS160","model":"Gigaset GS160"},{"manufacturer":"Gigaset","market_name":"GS170","codename":"GS170","model":"Gigaset GS170"},{"manufacturer":"Gigaset","market_name":"GS180","codename":"GS180","model":"GS180"},{"manufacturer":"Gigaset","market_name":"GS185","codename":"GS185","model":"GS185"},{"manufacturer":"Gigaset","market_name":"Gigaset GS170","codename":"GS170","model":"Gigaset GS170"},{"manufacturer":"Gigaset","market_name":"Gigaset GS270","codename":"Gigaset_GS270","model":"GS270"},{"manufacturer":"Gigaset","market_name":"Gigaset GS270 plus","codename":"Gigaset_GS270_plus","model":"GS270 plus"},{"manufacturer":"Gigaset","market_name":"Gigaset GS370","codename":"GS370","model":"GS370"},{"manufacturer":"Gigaset","market_name":"Gigaset GS370_Plus","codename":"GS370_Plus","model":"GS370_Plus"},{"manufacturer":"Gigaset","market_name":"Gigaset Maxwell 10","codename":"maxwell_10","model":"Maxwell-10"},{"manufacturer":"Gigaset","market_name":"ME","codename":"ME","model":"GS55-6"},{"manufacturer":"Gigaset","market_name":"ME Pro","codename":"MEpro","model":"GS57-6"},{"manufacturer":"Gigaset","market_name":"ME Pure","codename":"MEpure","model":"GS53-6"},{"manufacturer":"Gigaset","market_name":"Maxwell 10","codename":"maxwell_10","model":"80-1"},{"manufacturer":"Gigaset","market_name":"Maxwell-10","codename":"maxwell_10","model":"80-1"},{"manufacturer":"Gigaset","market_name":"Maxwell-10","codename":"maxwell_10","model":"Maxwell-10"},{"manufacturer":"Gigaset","market_name":"QV1030","codename":"FG6Q","model":"Gigaset QV1030"},{"manufacturer":"Gigaset","market_name":"QV830","codename":"UY8","model":"Gigaset QV830"},{"manufacturer":"Gigaset","market_name":"QV831","codename":"UY8","model":"Gigaset QV831"},{"manufacturer":"Gigaset","market_name":"SL930","codename":"lion_s","model":"SL930"},{"manufacturer":"Gini","market_name":"Gini n9","codename":"Gini_n9","model":"Gini n9"},{"manufacturer":"Gini","market_name":"Gini s5Pro","codename":"Gini_s5Pro","model":"s5Pro"},{"manufacturer":"Gini","market_name":"Gini w7","codename":"Gini_w7","model":"Gini w7"},{"manufacturer":"Gini","market_name":"N6","codename":"N6","model":"N6"},{"manufacturer":"Gini","market_name":"e6_plus","codename":"e6","model":"e6"},{"manufacturer":"Gini","market_name":"e6_plus","codename":"e6_plus","model":"e6_plus"},{"manufacturer":"Gini","market_name":"n7","codename":"n7","model":"n7"},{"manufacturer":"Gini","market_name":"n8","codename":"Gini_n8","model":"Gini n8"},{"manufacturer":"Gini","market_name":"s4","codename":"s4","model":"s4"},{"manufacturer":"Gini","market_name":"s4_pro","codename":"s4_pro","model":"s4_pro"},{"manufacturer":"Gini","market_name":"w5","codename":"w5","model":"w5"},{"manufacturer":"Gini","market_name":"w6","codename":"w6","model":"w6"},{"manufacturer":"Ginzzu","market_name":"GT-1015","codename":"GT-1015","model":"GT-1015"},{"manufacturer":"Ginzzu","market_name":"GT-1045","codename":"GT-1045","model":"GT-1045"},{"manufacturer":"Ginzzu","market_name":"GT-1050","codename":"GT-1050","model":"Ginzzu GT-1050"},{"manufacturer":"Ginzzu","market_name":"GT-7100","codename":"GT-7100","model":"GT-7100"},{"manufacturer":"Ginzzu","market_name":"GT-7115","codename":"GT-7115","model":"Ginzzu GT-7115"},{"manufacturer":"Ginzzu","market_name":"GT-7205","codename":"GT-7205","model":"GT-7205"},{"manufacturer":"Ginzzu","market_name":"GT-7210","codename":"GT-7210","model":"Ginzzu GT-7210"},{"manufacturer":"Ginzzu","market_name":"GT-8105","codename":"GT-8105","model":"GT-8105"},{"manufacturer":"Ginzzu","market_name":"GT-8110","codename":"GT-8110","model":"Ginzzu GT-8110"},{"manufacturer":"Ginzzu","market_name":"RS8501","codename":"RS8501","model":"RS8501"},{"manufacturer":"Ginzzu","market_name":"S5002","codename":"S5002","model":"S5002"},{"manufacturer":"Ginzzu","market_name":"S5021","codename":"S5021","model":"S5021"},{"manufacturer":"Ginzzu","market_name":"S5230","codename":"S5230","model":"S5230"},{"manufacturer":"Ginzzu","market_name":"SMART Race 4G","codename":"x2605b_fm45_mtc","model":"SMART Race 4G"},{"manufacturer":"Gionee","market_name":"A1","codename":"GIONEE_SWW1609","model":"GIONEE A1"},{"manufacturer":"Gionee","market_name":"A1 Lite","codename":"GIONEE_SWW1618","model":"A1 lite"},{"manufacturer":"Gionee","market_name":"A1 Plus","codename":"GIONEE_SWW1617","model":"A1 Plus"},{"manufacturer":"Gionee","market_name":"A1 lite","codename":"GIONEE_SWW1618","model":"A1 lite"},{"manufacturer":"Gionee","market_name":"E8","codename":"GiONEE_GN9008","model":"E8"},{"manufacturer":"Gionee","market_name":"E8","codename":"GiONEE_GN9008","model":"GN9008"},{"manufacturer":"Gionee","market_name":"F100","codename":"GIONEE_GBL7358","model":"F100"},{"manufacturer":"Gionee","market_name":"F100A","codename":"GIONEE_GBL7358","model":"F100A"},{"manufacturer":"Gionee","market_name":"F100B","codename":"GIONEE_GBL7370","model":"F100B"},{"manufacturer":"Gionee","market_name":"F100L","codename":"GIONEE_GBL7370","model":"F100L"},{"manufacturer":"Gionee","market_name":"F100S","codename":"GIONEE_GBL7370","model":"F100S"},{"manufacturer":"Gionee","market_name":"F103","codename":"GiONEE_GBL7319","model":"F103"},{"manufacturer":"Gionee","market_name":"F103 Pro","codename":"GIONEE_GBL7360","model":"F103 Pro"},{"manufacturer":"Gionee","market_name":"F103L","codename":"GiONEE_GBL7319","model":"F103L"},{"manufacturer":"Gionee","market_name":"F103S","codename":"GiONEE_F103S","model":"F103S"},{"manufacturer":"Gionee","market_name":"F105","codename":"GiONEE_GBL7335","model":"F105"},{"manufacturer":"Gionee","market_name":"F105L","codename":"GiONEE_GBL7335","model":"F105L"},{"manufacturer":"Gionee","market_name":"F106","codename":"GIONEE_SWG1613","model":"F106"},{"manufacturer":"Gionee","market_name":"F106L","codename":"GIONEE_SW17G03","model":"F106L"},{"manufacturer":"Gionee","market_name":"F109L","codename":"GIONEE_SW17G09","model":"GIONEE F109L"},{"manufacturer":"Gionee","market_name":"F109N","codename":"GIONEE_SW17G09","model":"GIONEE F109N"},{"manufacturer":"Gionee","market_name":"F205","codename":"GIONEE_SW17G18","model":"GIONEE F205"},{"manufacturer":"Gionee","market_name":"F301","codename":"F301","model":"F301"},{"manufacturer":"Gionee","market_name":"F303","codename":"F303","model":"F303"},{"manufacturer":"Gionee","market_name":"F5","codename":"GIONEE_SWG1608","model":"F5"},{"manufacturer":"Gionee","market_name":"F5L","codename":"GIONEE_SWG1608","model":"F5L"},{"manufacturer":"Gionee","market_name":"F6","codename":"GIONEE_SW17G15","model":"GIONEE F6"},{"manufacturer":"Gionee","market_name":"F6L","codename":"GIONEE_SW17G15","model":"GIONEE F6L"},{"manufacturer":"Gionee","market_name":"ForwardZero","codename":"V6L","model":"V6L"},{"manufacturer":"Gionee","market_name":"GIONEE F109","codename":"GIONEE_SW17G09","model":"GIONEE F109"},{"manufacturer":"Gionee","market_name":"GIONEE F109L","codename":"GIONEE_SW17G09","model":"GIONEE F109L"},{"manufacturer":"Gionee","market_name":"GIONEE F109N","codename":"GIONEE_SW17G09","model":"GIONEE F109N"},{"manufacturer":"Gionee","market_name":"GIONEE F205L","codename":"GIONEE_SW17G18","model":"GIONEE F205L"},{"manufacturer":"Gionee","market_name":"GIONEE GN5007","codename":"GIONEE_BJ17G16","model":"GIONEE GN5007"},{"manufacturer":"Gionee","market_name":"GIONEE GN5007L","codename":"GIONEE_BJ17G16","model":"GIONEE GN5007L"},{"manufacturer":"Gionee","market_name":"GIONEE M7L","codename":"GIONEE_SW17G07","model":"GIONEE M7L"},{"manufacturer":"Gionee","market_name":"GIONEE X1","codename":"GIONEE_SWW1631","model":"GIONEE X1"},{"manufacturer":"Gionee","market_name":"GN152","codename":"GiONEE_CBL7320","model":"GN152"},{"manufacturer":"Gionee","market_name":"GN3001","codename":"GiONEE_GBL7523","model":"GN3001"},{"manufacturer":"Gionee","market_name":"GN3001L","codename":"GiONEE_GBL7523","model":"GN3001L"},{"manufacturer":"Gionee","market_name":"GN3002","codename":"GIONEE_GBL7356","model":"GN3002"},{"manufacturer":"Gionee","market_name":"GN3002L","codename":"GIONEE_GBL7356L","model":"GN3002L"},{"manufacturer":"Gionee","market_name":"GN3003","codename":"GIONEE_GBL7359","model":"GN3003"},{"manufacturer":"Gionee","market_name":"GN3003L","codename":"GIONEE_GBL7359L","model":"GN3003L"},{"manufacturer":"Gionee","market_name":"GN5001","codename":"GiONEE_BBL7332","model":"GN5001"},{"manufacturer":"Gionee","market_name":"GN5001L","codename":"GiONEE_BBL7332","model":"GN5001L"},{"manufacturer":"Gionee","market_name":"GN5001S","codename":"GiONEE_BBL7332","model":"GN5001S"},{"manufacturer":"Gionee","market_name":"GN5002","codename":"GiONEE_GBL7333","model":"GN5002"},{"manufacturer":"Gionee","market_name":"GN5003","codename":"GiONEE_BBL7337A","model":"GN5003"},{"manufacturer":"Gionee","market_name":"GN5005","codename":"GIONEE_G1605A","model":"GN5005"},{"manufacturer":"Gionee","market_name":"GN5005","codename":"GIONEE_G1605A","model":"GN5005L"},{"manufacturer":"Gionee","market_name":"GN8001","codename":"GiONEE_BBL7505","model":"GN8001"},{"manufacturer":"Gionee","market_name":"GN8001L","codename":"GiONEE_BBL7505","model":"GN8001L"},{"manufacturer":"Gionee","market_name":"GN8003L","codename":"GiONEE_BBL7515A","model":"GN8003L"},{"manufacturer":"Gionee","market_name":"GN9000","codename":"S5_5","model":"GN9000"},{"manufacturer":"Gionee","market_name":"GN9006","codename":"GN9006","model":"GN9006"},{"manufacturer":"Gionee","market_name":"GN9006","codename":"GN9006","model":"GiONEE S7"},{"manufacturer":"Gionee","market_name":"GN9007","codename":"GiONEE_CBL7503","model":"GN9007"},{"manufacturer":"Gionee","market_name":"GN9010L","codename":"GiONEE_CBL7513","model":"GN9010L"},{"manufacturer":"Gionee","market_name":"GN9012","codename":"GIONEE_GBL7529","model":"GN9012"},{"manufacturer":"Gionee","market_name":"Gtel_X5pro","codename":"Gtel_X5pro","model":"Gtel_X5pro"},{"manufacturer":"Gionee","market_name":"M2","codename":"M2","model":"M2"},{"manufacturer":"Gionee","market_name":"M2017","codename":"GIONEE_GBL8918","model":"M2017"},{"manufacturer":"Gionee","market_name":"M2mini","codename":"GiONEE_WBW5612","model":"M2mini"},{"manufacturer":"Gionee","market_name":"M3","codename":"GiONEE_M3","model":"M3"},{"manufacturer":"Gionee","market_name":"M3","codename":"M3","model":"M3"},{"manufacturer":"Gionee","market_name":"M3S","codename":"GiONEE_M3S","model":"M3S"},{"manufacturer":"Gionee","market_name":"M3mini","codename":"GiONEE_WBL7315","model":"M3mini"},{"manufacturer":"Gionee","market_name":"M4","codename":"GiONEE_M3","model":"M4"},{"manufacturer":"Gionee","market_name":"M5","codename":"M5","model":"M5"},{"manufacturer":"Gionee","market_name":"M5 Lite","codename":"GiONEE_BBL7332","model":"M5_lite"},{"manufacturer":"Gionee","market_name":"M5 Plus","codename":"GiONEE_BBL7505","model":"M5 Plus"},{"manufacturer":"Gionee","market_name":"M5 mini","codename":"GiONEE_WBW5616","model":"M5 mini"},{"manufacturer":"Gionee","market_name":"M5L","codename":"M5","model":"M5L"},{"manufacturer":"Gionee","market_name":"M6","codename":"GiONEE_BBL7515A","model":"GN8003"},{"manufacturer":"Gionee","market_name":"M6","codename":"GiONEE_BBL7515A","model":"M6"},{"manufacturer":"Gionee","market_name":"M6 Lite","codename":"GIONEE_WBL7361","model":"M6 lite"},{"manufacturer":"Gionee","market_name":"M6 Plus","codename":"GIONEE_BBL7516A","model":"GN8002"},{"manufacturer":"Gionee","market_name":"M6 Plus","codename":"GIONEE_BBL7516A01","model":"GN8002S"},{"manufacturer":"Gionee","market_name":"M6 mirror","codename":"GIONEE_WBL7372","model":"M6 mirror"},{"manufacturer":"Gionee","market_name":"M6SLPlus","codename":"GIONEE_G1602A","model":"M6SLPlus"},{"manufacturer":"Gionee","market_name":"M6SPlus","codename":"GIONEE_G1602A","model":"M6SPlus"},{"manufacturer":"Gionee","market_name":"M7","codename":"GIONEE_SW17G07","model":"GIONEE M7"},{"manufacturer":"Gionee","market_name":"M7 Power","codename":"GIONEE_BJ17G16","model":"M7 Power"},{"manufacturer":"Gionee","market_name":"M7Plus","codename":"GIONEE_BJ17G08A","model":"GIONEE M7Plus"},{"manufacturer":"Gionee","market_name":"P2M","codename":"GiONEE_WBW5612","model":"P2M"},{"manufacturer":"Gionee","market_name":"P3S","codename":"GiONEE_WBW5613","model":"P3S"},{"manufacturer":"Gionee","market_name":"P4","codename":"P4","model":"P4"},{"manufacturer":"Gionee","market_name":"P4S","codename":"P4S","model":"P4S"},{"manufacturer":"Gionee","market_name":"P5 mini","codename":"GiONEE_WBW5617","model":"P5 mini"},{"manufacturer":"Gionee","market_name":"P5L","codename":"GiONEE_WBL7352","model":"P5"},{"manufacturer":"Gionee","market_name":"P5L","codename":"GiONEE_WBL7352","model":"P5L"},{"manufacturer":"Gionee","market_name":"P5W","codename":"GiONEE_WBW5615","model":"P5W"},{"manufacturer":"Gionee","market_name":"P6","codename":"P6","model":"P6"},{"manufacturer":"Gionee","market_name":"P7","codename":"GIONEE_G1605A","model":"GIONEE P7"},{"manufacturer":"Gionee","market_name":"P7","codename":"GIONEE_WBL7365","model":"GIONEE P7"},{"manufacturer":"Gionee","market_name":"P7","codename":"GIONEE_WBL7365","model":"P7"},{"manufacturer":"Gionee","market_name":"P7 Max","codename":"GIONEE_WBL5708","model":"P7 Max"},{"manufacturer":"Gionee","market_name":"P8 Max","codename":"GIONEE_WBL7372","model":"P8 Max"},{"manufacturer":"Gionee","market_name":"P8M","codename":"GIONEE_SW17W04","model":"P8M"},{"manufacturer":"Gionee","market_name":"P8W","codename":"GIONEE_WBW5620","model":"P8W"},{"manufacturer":"Gionee","market_name":"S plus","codename":"GiONEE_WBL7511","model":"S_plus"},{"manufacturer":"Gionee","market_name":"S10","codename":"GIONEE_SW17G04","model":"GIONEE S10"},{"manufacturer":"Gionee","market_name":"S10 lite","codename":"GIONEE_SW17G02","model":"GIONEE S10 lite"},{"manufacturer":"Gionee","market_name":"S10B","codename":"GIONEE_SW17G01","model":"GIONEE S10B"},{"manufacturer":"Gionee","market_name":"S10BL","codename":"GIONEE_SW17G01","model":"GIONEE S10BL"},{"manufacturer":"Gionee","market_name":"S10C","codename":"GIONEE_SW17G02","model":"GIONEE S10C"},{"manufacturer":"Gionee","market_name":"S10CL","codename":"GIONEE_SW17G02","model":"GIONEE S10CL"},{"manufacturer":"Gionee","market_name":"S10L","codename":"GIONEE_SW17G04","model":"GIONEE S10L"},{"manufacturer":"Gionee","market_name":"S11","codename":"GIONEE_SW17G13","model":"GIONEE S11"},{"manufacturer":"Gionee","market_name":"S11 lite","codename":"GIONEE_SW17G15","model":"GIONEE S11 lite"},{"manufacturer":"Gionee","market_name":"S11L","codename":"GIONEE_SW17G13","model":"GIONEE S11L"},{"manufacturer":"Gionee","market_name":"S5.1","codename":"GN9005","model":"GN9005"},{"manufacturer":"Gionee","market_name":"S5.1","codename":"S5_1","model":"S5.1"},{"manufacturer":"Gionee","market_name":"S5.5","codename":"S5_5","model":"S5.5"},{"manufacturer":"Gionee","market_name":"S6","codename":"GiONEE_CBL7513","model":"GN9010"},{"manufacturer":"Gionee","market_name":"S6","codename":"GiONEE_CBL7513","model":"S6"},{"manufacturer":"Gionee","market_name":"S6 Pro","codename":"GIONEE_GBL7529","model":"GN9012"},{"manufacturer":"Gionee","market_name":"S6 Pro","codename":"GIONEE_GBL7529","model":"S6 Pro"},{"manufacturer":"Gionee","market_name":"S6Pro","codename":"GIONEE_GBL7529","model":"GN9012"},{"manufacturer":"Gionee","market_name":"S6s","codename":"GIONEE_WBL7519","model":"S6s"},{"manufacturer":"Gionee","market_name":"S8","codename":"GIONEE_WBL7517","model":"GN9011"},{"manufacturer":"Gionee","market_name":"S9","codename":"GIONEE_GBL7553","model":"S9"},{"manufacturer":"Gionee","market_name":"S9","codename":"GIONEE_GBL7558","model":"S9"},{"manufacturer":"Gionee","market_name":"S_plus","codename":"GiONEE_WBL7511","model":"S_plus"},{"manufacturer":"Gionee","market_name":"V4S","codename":"V4S","model":"V4S"},{"manufacturer":"Gionee","market_name":"V5","codename":"V5","model":"V5"},{"manufacturer":"Gionee","market_name":"W900S","codename":"GiONEE_BFL7506A","model":"W900S"},{"manufacturer":"Gionee","market_name":"W909","codename":"GiONEE_BFL7512B","model":"W909"},{"manufacturer":"Gionee","market_name":"W919","codename":"GIONEE_BJ17G10","model":"GIONEE W919"},{"manufacturer":"Gionee","market_name":"X1","codename":"GIONEE_SWW1631","model":"GIONEE X1"},{"manufacturer":"Gionee","market_name":"X1S","codename":"GIONEE_SWW1627","model":"X1S"},{"manufacturer":"Go Mobile","market_name":"GO Onyx","codename":"GO_Onyx_LTE","model":"GO Onyx LTE"},{"manufacturer":"Go Mobile","market_name":"GO Onyx HD","codename":"Go_Onyx_HD","model":"Go Onyx HD"},{"manufacturer":"Go Mobile","market_name":"GO1004","codename":"GO1004","model":"GO1004"},{"manufacturer":"Go Mobile","market_name":"GO1402S","codename":"GO1402S","model":"GO1402S"},{"manufacturer":"GoClever","market_name":"INSIGNIA 550i","codename":"INSIGNIA_550i","model":"INSIGNIA_550i"},{"manufacturer":"GoClever","market_name":"QUANTUM 1010N","codename":"QUANTUM_1010N","model":"QUANTUM_1010N"},{"manufacturer":"GoClever","market_name":"QUANTUM 400 LITE","codename":"QUANTUM_400_LITE","model":"QUANTUM_400_LITE"},{"manufacturer":"GoClever","market_name":"QUANTUM_550","codename":"QUANTUM_550","model":"QUANTUM_550"},{"manufacturer":"GoClever","market_name":"QUANTUM_700S/QUANTUM 700S","codename":"QUANTUM_700S","model":"QUANTUM_700S"},{"manufacturer":"GoClever","market_name":"Quantum 500 STEEL","codename":"FQ_500R","model":"Quantum_500_STEEL"},{"manufacturer":"GoClever","market_name":"TQ700/QUANTUM 700/TAB","codename":"TQ700","model":"TQ700"},{"manufacturer":"Gobox","market_name":"T2","codename":"T2","model":"T2"},{"manufacturer":"Gol Mobile","market_name":"TEAM_7_3G","codename":"TEAM_7_3G","model":"TEAM_7_3G"},{"manufacturer":"Gonna","market_name":"Zebra","codename":"Zebra","model":"Zebra"},{"manufacturer":"Goo","market_name":"g08","codename":"v12dn","model":"View Prime"},{"manufacturer":"Google","market_name":"Android Wear","codename":"bluegill","model":"Alberto"},{"manufacturer":"Google","market_name":"Android Wear","codename":"bluegill","model":"EA Connected"},{"manufacturer":"Google","market_name":"Android Wear","codename":"glowlight","model":"GUESS Connect"},{"manufacturer":"Google","market_name":"Android Wear","codename":"shiner","model":"Riley Touch"},{"manufacturer":"Google","market_name":"Android Wear","codename":"shiner","model":"Riley Touchscreen"},{"manufacturer":"Google","market_name":"Android Wear","codename":"shiner","model":"Sofie"},{"manufacturer":"Google","market_name":"Chromebook","codename":"coral_cheets","model":"coral"},{"manufacturer":"Google","market_name":"Chromebook","codename":"edgar_cheets","model":"Chromebook 14 (CB3-431)"},{"manufacturer":"Google","market_name":"Chromebook","codename":"hana_cheets","model":"Lenovo N23 Yoga/Flex 11 Chromebook"},{"manufacturer":"Google","market_name":"Chromebook","codename":"hana_cheets","model":"Mediatek MTK8173 Chromebook"},{"manufacturer":"Google","market_name":"Chromebook","codename":"jerry_cheets","model":"RK3288 Chrome OS Device"},{"manufacturer":"Google","market_name":"Chromebook","codename":"jerry_cheets","model":"Rockchip RK3288 Chromebook"},{"manufacturer":"Google","market_name":"Chromebook","codename":"mighty_cheets","model":"RK3288 Chrome OS Device"},{"manufacturer":"Google","market_name":"Chromebook","codename":"mighty_cheets","model":"Rockchip RK3288 Chromebook"},{"manufacturer":"Google","market_name":"Chromebook","codename":"reef_cheets","model":"ASUS Chromebook C213NA"},{"manufacturer":"Google","market_name":"Chromebook","codename":"reef_cheets","model":"Intel Apollo Lake Chromebook"},{"manufacturer":"Google","market_name":"Chromebook","codename":"reef_cheets","model":"reef"},{"manufacturer":"Google","market_name":"Chromebook","codename":"relm_cheets","model":"Braswell Chrome OS Device"},{"manufacturer":"Google","market_name":"Chromebook","codename":"relm_cheets","model":"Intel Braswell Chromebook"},{"manufacturer":"Google","market_name":"Chromebook","codename":"wizpig_cheets","model":"Intel Braswell Chromebook"},{"manufacturer":"Google","market_name":"Chromebook Pixel (2015)","codename":"samus_cheets","model":"Google Chromebook Pixel (2015)"},{"manufacturer":"Google","market_name":"Chromebox","codename":"fizz_cheets","model":"fizz"},{"manufacturer":"Google","market_name":"Emulator","codename":"generic_x86","model":"Android SDK built for x86"},{"manufacturer":"Google","market_name":"Galaxy S4 Google Play edition","codename":"jgedlte","model":"GT-I9505G"},{"manufacturer":"Google","market_name":"Pixel","codename":"sailfish","model":"Pixel"},{"manufacturer":"Google","market_name":"Pixel 2","codename":"walleye","model":"Pixel 2"},{"manufacturer":"Google","market_name":"Pixel 2 XL","codename":"taimen","model":"Pixel 2 XL"},{"manufacturer":"Google","market_name":"Pixel C","codename":"dragon","model":"Pixel C"},{"manufacturer":"Google","market_name":"Pixel XL","codename":"marlin","model":"Pixel XL"},{"manufacturer":"Google","market_name":"Pixelbook","codename":"eve_cheets","model":"Google Pixelbook"},{"manufacturer":"Google","market_name":"Project Tango Tablet Development Kit","codename":"yellowstone","model":"Project Tango Tablet Development Kit"},{"manufacturer":"Google","market_name":"Project Tango Tablet Development Kit","codename":"yellowstone","model":"Yellowstone"},{"manufacturer":"Gplus","market_name":"F53","codename":"GPLUS_F53","model":"GPLUS F53"},{"manufacturer":"Gplus","market_name":"F68+","codename":"F68","model":"F68+"},{"manufacturer":"Gplus","market_name":"FW6950","codename":"GPLUS_FW6950","model":"GPLUS_FW6950"},{"manufacturer":"Gplus","market_name":"GPLUS_A2_Plus","codename":"GPLUS_A2_Plus","model":"GPLUS_A2_Plus"},{"manufacturer":"Gplus","market_name":"S9701","codename":"GPLUS_S9701","model":"GPLUS_S9701"},{"manufacturer":"Gradiente","market_name":"iphone C600","codename":"GBC_bravo","model":"iphone C600"},{"manufacturer":"Gradiente","market_name":"iphone C600","codename":"bravo","model":"iphone C600"},{"manufacturer":"Greatwall","market_name":"T709GW","codename":"T709GW","model":"Great Wall T709"},{"manufacturer":"Grundig","market_name":"GTB1030","codename":"TA10CA2","model":"TA10CA2"},{"manufacturer":"Grundig","market_name":"GTB1050","codename":"GTB1050","model":"GTB 1050"},{"manufacturer":"Grundig","market_name":"GTB850","codename":"GTB850","model":"GTB 850"},{"manufacturer":"Grundig","market_name":"TC69CA2","codename":"GTB801","model":"GTB 801"},{"manufacturer":"Gryphon","market_name":"Veil","codename":"granite","model":"Veil"},{"manufacturer":"Gtel","market_name":"A7100 X3","codename":"A7100_X3","model":"A7100_X3"},{"manufacturer":"Gtel","market_name":"A7101_X3_mini","codename":"A7101_X3_mini","model":"A7101_X3_mini"},{"manufacturer":"Gtel","market_name":"A713_Vivo_Pro","codename":"A713_Vivo_Pro","model":"A713_Vivo_Pro"},{"manufacturer":"Gtel","market_name":"A714 Vivo Play","codename":"A714_Vivo_Play","model":"A714_Vivo_Play"},{"manufacturer":"Gtel","market_name":"A7155_X4_mini","codename":"A7155_X4_mini","model":"A7155_X4_mini"},{"manufacturer":"Gtel","market_name":"A715_Inspire_One","codename":"A715_Inspire_One","model":"A715_Inspire_One"},{"manufacturer":"Gtel","market_name":"A716 Inspire Life","codename":"A716_Inspire_Life","model":"A716_Inspire_Life"},{"manufacturer":"Gtel","market_name":"A726 Infinity Lite","codename":"A726_Infinity_Lite","model":"A726_Infinity_Lite"},{"manufacturer":"Gtel","market_name":"A727_Infinity_Pro","codename":"A727_Infinity_Pro","model":"A727_Infinity_Pro"},{"manufacturer":"Gtel","market_name":"A728_XP2","codename":"A728_XP2","model":"A728_XP2"},{"manufacturer":"Gtel","market_name":"A737_XploraZ","codename":"A737_XploraZ","model":"A737_XploraZ"},{"manufacturer":"Gtel","market_name":"A770_SL8_Pro","codename":"A770_SL8_Pro","model":"A770_SL8_Pro"},{"manufacturer":"Gtel","market_name":"A770_XL7","codename":"A770_XL7","model":"A770_XL7"},{"manufacturer":"Gtel","market_name":"Gtel X6mini","codename":"Gtel_X6mini","model":"Gtel X6mini"},{"manufacturer":"Gtel","market_name":"Gtel X6plus","codename":"Gtel_X6plus","model":"Gtel X6plus"},{"manufacturer":"Gtel","market_name":"Gtel X6pro","codename":"Gtel_X6pro","model":"Gtel X6pro"},{"manufacturer":"Gtel","market_name":"Gtel X6s","codename":"Gtel_X6s","model":"Gtel X6s"},{"manufacturer":"Gtel","market_name":"Gtel X7plus","codename":"Gtel_X7plus","model":"Gtel X7plus"},{"manufacturer":"Gtel","market_name":"Gtel_Vivo3","codename":"Gtel_Vivo3","model":"Gtel_Vivo3"},{"manufacturer":"Gtel","market_name":"Gtel_X5mini","codename":"Gtel_X5mini","model":"Gtel_X5mini"},{"manufacturer":"Gtel","market_name":"Gtel_X5s","codename":"Gtel_X5s","model":"Gtel_X5s"},{"manufacturer":"Gtel","market_name":"X5","codename":"Gtel_X5","model":"Gtel X5"},{"manufacturer":"Gtel","market_name":"X5plus","codename":"Gtel_X5plus","model":"Gtel X5plus"},{"manufacturer":"HKC","market_name":"A79 Tablet","codename":"EM62","model":"A79"},{"manufacturer":"HKT","market_name":"eye3","codename":"UY3-PCW","model":"eye3"},{"manufacturer":"HOMTOM","market_name":"HT70","codename":"HT70","model":"HT70"},{"manufacturer":"HOMTOM","market_name":"S16","codename":"S16","model":"S16"},{"manufacturer":"HOMTOM","market_name":"S7","codename":"S7","model":"S7"},{"manufacturer":"HOMTOM","market_name":"S8","codename":"S8","model":"S8"},{"manufacturer":"HOMTOM","market_name":"S9 Plus","codename":"S9_Plus","model":"S9_Plus"},{"manufacturer":"HOMTOM","market_name":"Z8","codename":"Z8","model":"Z8"},{"manufacturer":"HP","market_name":"10","codename":"spruce","model":"HP 10"},{"manufacturer":"HP","market_name":"10 Plus","codename":"torsa","model":"HP 10 Plus"},{"manufacturer":"HP","market_name":"7 G2","codename":"redwood","model":"HP 7 G2"},{"manufacturer":"HP","market_name":"7 Plus","codename":"Ilex","model":"HP 7 Plus"},{"manufacturer":"HP","market_name":"7 Plus G2","codename":"deschutes","model":"HP 7 Plus G2"},{"manufacturer":"HP","market_name":"7 Tablet","codename":"Mesquite","model":"HP 7"},{"manufacturer":"HP","market_name":"7 Voice Tab","codename":"klondike","model":"HP 7 VoiceTab"},{"manufacturer":"HP","market_name":"7 VoiceTab","codename":"yukon","model":"HP 7 VoiceTab"},{"manufacturer":"HP","market_name":"7.1","codename":"Holly","model":"HP 7.1"},{"manufacturer":"HP","market_name":"8","codename":"Fir","model":"HP 8"},{"manufacturer":"HP","market_name":"8 G2","codename":"maple","model":"HP 8 G2"},{"manufacturer":"HP","market_name":"Bonsai 10 HD","codename":"bonsai10","model":"HP Slate 10 HD"},{"manufacturer":"HP","market_name":"Chromebook x2","codename":"soraka_cheets","model":"soraka"},{"manufacturer":"HP","market_name":"Chromebook x360 11 G1 EE","codename":"snappy_cheets","model":"HP Chromebook x360 11 G1 EE"},{"manufacturer":"HP","market_name":"HP Chromebook 11 G5 / 11-vxxx","codename":"setzer_cheets","model":"HP Chromebook 11 G5 / HP Chromebook 11-vxxx"},{"manufacturer":"HP","market_name":"HP Chromebook 13 G1","codename":"chell_cheets","model":"HP Chromebook 13 G1"},{"manufacturer":"HP","market_name":"Pro 8 Tablet with Voice","codename":"neetu","model":"HP Pro 8 Tablet with Voice"},{"manufacturer":"HP","market_name":"Pro Slate 10 EE G1","codename":"bulldog","model":"HP Pro Slate 10 EE G1"},{"manufacturer":"HP","market_name":"Pro Slate 10 EE G1","codename":"hound","model":"HP Pro Slate 10 EE G1"},{"manufacturer":"HP","market_name":"Pro Slate 10 EE G1","codename":"poodle","model":"HP Pro Slate 10 EE G1"},{"manufacturer":"HP","market_name":"Pro Slate 10 EE G1","codename":"terrier","model":"HP Pro Slate 10 EE G1"},{"manufacturer":"HP","market_name":"Pro Slate 12","codename":"dane","model":"HP Pro Slate 12"},{"manufacturer":"HP","market_name":"Pro Slate 8","codename":"malamute","model":"HP Pro Slate 8"},{"manufacturer":"HP","market_name":"Slate 10 HD","codename":"bonsai10","model":"HP Slate 10 HD"},{"manufacturer":"HP","market_name":"Slate 10 Plus","codename":"linkplus","model":"HP Slate 10 Plus"},{"manufacturer":"HP","market_name":"Slate 17","codename":"franky","model":"HP Slate 17"},{"manufacturer":"HP","market_name":"Slate 21 Pro","codename":"ranger","model":"Slate 21 Pro"},{"manufacturer":"HP","market_name":"Slate 6 Voice Tab","codename":"pomegranate","model":"HP Slate 6 Voice Tab"},{"manufacturer":"HP","market_name":"Slate 6 Voice Tab II","codename":"avocado","model":"HP Slate 6 Voice Tab II"},{"manufacturer":"HP","market_name":"Slate 6 VoiceTab Plus","codename":"mekong","model":"HP Slate 6 VoiceTab Plus"},{"manufacturer":"HP","market_name":"Slate 7","codename":"pine","model":"HP Slate 7"},{"manufacturer":"HP","market_name":"Slate 7 Beats Special Edition","codename":"fairfax","model":"HP Slate 7 Beats Special Edition"},{"manufacturer":"HP","market_name":"Slate 7 Beats Special Edition","codename":"fairfax","model":"HP Slate7 Beats Special Edition"},{"manufacturer":"HP","market_name":"Slate 7 Extreme","codename":"olive","model":"HP Slate7 Extreme"},{"manufacturer":"HP","market_name":"Slate 7 HD","codename":"bonsai10","model":"HP Slate 10 HD"},{"manufacturer":"HP","market_name":"Slate 7 HD","codename":"bonsai7","model":"HP Slate 7 HD"},{"manufacturer":"HP","market_name":"Slate 7 Voice Tab","codename":"almond","model":"HP Slate 7 Voice Tab"},{"manufacturer":"HP","market_name":"Slate 7 VoiceTab Ultra","codename":"charm","model":"HP Slate 7 VoiceTab Ultra"},{"manufacturer":"HP","market_name":"Slate 8 Plus","codename":"vogue","model":"HP Slate 8 Plus"},{"manufacturer":"HP","market_name":"Slate 8 Pro","codename":"dogwood","model":"HP Slate 8 Pro"},{"manufacturer":"HP","market_name":"Slate21","codename":"phobos","model":"Slate 21"},{"manufacturer":"HP","market_name":"Slate7 Plus","codename":"birch","model":"HP Slate 7 Plus"},{"manufacturer":"HP","market_name":"Slate8 Pro","codename":"fig","model":"HP Slate 8 Pro"},{"manufacturer":"HP","market_name":"SlateBook 10 x2 PC","codename":"3645","model":"HP SlateBook 10 x2 PC"},{"manufacturer":"HP","market_name":"SlateBook 14","codename":"200a","model":"HP SlateBook 14 PC"},{"manufacturer":"HP","market_name":"Tablet 10","codename":"balsa","model":"HP_10_Tablet"},{"manufacturer":"HP","market_name":"Voice Tab 7","codename":"almond","model":"HP Slate 7 Voice Tab"},{"manufacturer":"HTC","market_name":"","codename":"express","model":"HTC Flyer"},{"manufacturer":"HTC","market_name":"","codename":"express","model":"PG41200"},{"manufacturer":"HTC","market_name":"","codename":"expresskt","model":"HTC_P515E"},{"manufacturer":"HTC","market_name":"","codename":"rider","model":"HTC_X515E"},{"manufacturer":"HTC","market_name":"","codename":"tagh","model":"HTC Incredible E S715e"},{"manufacturer":"HTC","market_name":"\\t HTC One X9 dual sim","codename":"htc_e56ml_dtul","model":"HTC One X9 dual sim"},{"manufacturer":"HTC","market_name":"\\tADR6325","codename":"lexikon","model":"ADR6325"},{"manufacturer":"HTC","market_name":"0P3P5","codename":"t6ul","model":"HTC_0P3P5"},{"manufacturer":"HTC","market_name":"0P4E2","codename":"zara","model":"HTC_0P4E2"},{"manufacturer":"HTC","market_name":"0P9C8","codename":"htc_a5dwgl","model":"HTC 0P9C8"},{"manufacturer":"HTC","market_name":"0P9C8","codename":"htc_a5dwgl","model":"HTC Desire 816 dual sim"},{"manufacturer":"HTC","market_name":"0PFJ50","codename":"htc_a51tuhl","model":"HTC_0PFJ50"},{"manufacturer":"HTC","market_name":"0PK72","codename":"htc_hiaur_ml_tuhl","model":"HTC 0PK72"},{"manufacturer":"HTC","market_name":"0PK72","codename":"htc_hiaur_ml_tuhl","model":"HTC One M9PLUS"},{"manufacturer":"HTC","market_name":"10","codename":"htc_pmec2tuhl","model":"HTC 10"},{"manufacturer":"HTC","market_name":"10","codename":"htc_pmec2tuhl","model":"HTC 10 Lifestyle"},{"manufacturer":"HTC","market_name":"10","codename":"htc_pmec2tuhl","model":"HTC 2PS63"},{"manufacturer":"HTC","market_name":"10","codename":"htc_pmec2tuhl","model":"HTC M10u"},{"manufacturer":"HTC","market_name":"10","codename":"htc_pmeuhl","model":"HTC 10"},{"manufacturer":"HTC","market_name":"10","codename":"htc_pmeuhl","model":"HTC 2PS6200"},{"manufacturer":"HTC","market_name":"10","codename":"htc_pmeuhl","model":"HTC M10h"},{"manufacturer":"HTC","market_name":"10","codename":"htc_pmeuhl","model":"HTC_M10h"},{"manufacturer":"HTC","market_name":"10","codename":"htc_pmeuhljapan","model":"HTV32"},{"manufacturer":"HTC","market_name":"10","codename":"htc_pmewhl","model":"2PS64"},{"manufacturer":"HTC","market_name":"10","codename":"htc_pmewl","model":"HTC 10"},{"manufacturer":"HTC","market_name":"10","codename":"htc_pmewl","model":"HTC6545LVW"},{"manufacturer":"HTC","market_name":"10","codename":"htc_pmewl","model":"MSM8996 for arm64"},{"manufacturer":"HTC","market_name":"10 evo","codename":"htc_acauhl","model":"HTC 10 evo"},{"manufacturer":"HTC","market_name":"10 evo","codename":"htc_acauhl","model":"HTC_M10f"},{"manufacturer":"HTC","market_name":"10 evo","codename":"htc_acawhl","model":"HTC 10 evo"},{"manufacturer":"HTC","market_name":"5060 dual sim","codename":"z4dug","model":"HTC Desire 500 dual sim"},{"manufacturer":"HTC","market_name":"601e","codename":"m4","model":"HTC 601e"},{"manufacturer":"HTC","market_name":"606w","codename":"cp3dug","model":"HTC 606w"},{"manufacturer":"HTC","market_name":"606w","codename":"cp3dug","model":"HTC Desire 600"},{"manufacturer":"HTC","market_name":"606w","codename":"cp3dug","model":"HTC Desire 600 dual sim"},{"manufacturer":"HTC","market_name":"606w","codename":"cp3dug","model":"HTC PO49120"},{"manufacturer":"HTC","market_name":"608t","codename":"cp3dtg","model":"HTC 608t"},{"manufacturer":"HTC","market_name":"609d","codename":"cp3dcg","model":"HTC 609d"},{"manufacturer":"HTC","market_name":"6160","codename":"zaradug","model":"HTC 6160"},{"manufacturer":"HTC","market_name":"619d","codename":"zarawl","model":"HTC 619d"},{"manufacturer":"HTC","market_name":"7060","codename":"cp5dug","model":"HTC_7060"},{"manufacturer":"HTC","market_name":"710C","codename":"htc_a5chl","model":"710C"},{"manufacturer":"HTC","market_name":"802d","codename":"m7cdwg","model":"HTC 802d"},{"manufacturer":"HTC","market_name":"803e","codename":"t6ul","model":"HTC 803e"},{"manufacturer":"HTC","market_name":"8060","codename":"t6dug","model":"HTC 8060"},{"manufacturer":"HTC","market_name":"8088","codename":"t6tl","model":"HTC 8088"},{"manufacturer":"HTC","market_name":"809d","codename":"t6dwg","model":"HTC 809d"},{"manufacturer":"HTC","market_name":"8160","codename":"t6uhl","model":"HTC 8160"},{"manufacturer":"HTC","market_name":"9060","codename":"dlxpul","model":"HTC 901e"},{"manufacturer":"HTC","market_name":"9060","codename":"m7","model":"HTC 801e"},{"manufacturer":"HTC","market_name":"9060","codename":"m7cdug","model":"HTC 802w"},{"manufacturer":"HTC","market_name":"9088","codename":"dlpdtu","model":"HTC 9088"},{"manufacturer":"HTC","market_name":"919d","codename":"dlpdwg","model":"HTC 919d"},{"manufacturer":"HTC","market_name":"A510c","codename":"marvelc","model":"HTC_A510c"},{"manufacturer":"HTC","market_name":"ADR6330VW","codename":"blissc","model":"ADR6330VW"},{"manufacturer":"HTC","market_name":"ADR6425LVW","codename":"vigor","model":"ADR6425LVW"},{"manufacturer":"HTC","market_name":"AT&T HTC One X+","codename":"evitareul","model":"HTC EVARE_UL"},{"manufacturer":"HTC","market_name":"AT&T HTC One X+","codename":"evitareul","model":"HTC One X+"},{"manufacturer":"HTC","market_name":"Amaze_4G","codename":"ruby","model":"HTC Amaze 4G"},{"manufacturer":"HTC","market_name":"Amaze_4G","codename":"ruby","model":"HTC Ruby"},{"manufacturer":"HTC","market_name":"Amaze_4G","codename":"ruby","model":"HTC_Amaze_4G"},{"manufacturer":"HTC","market_name":"Aria","codename":"liberty","model":"HTC Aria"},{"manufacturer":"HTC","market_name":"Aria","codename":"liberty","model":"HTC Aria A6380"},{"manufacturer":"HTC","market_name":"Aria","codename":"liberty","model":"HTC Gratia A6380"},{"manufacturer":"HTC","market_name":"Aria","codename":"liberty","model":"HTC Liberty"},{"manufacturer":"HTC","market_name":"Butterfly","codename":"dlxu","model":"HTC Butterfly"},{"manufacturer":"HTC","market_name":"Butterfly","codename":"dlxu","model":"HTC DLX_U"},{"manufacturer":"HTC","market_name":"Butterfly","codename":"dlxu","model":"HTC X920e"},{"manufacturer":"HTC","market_name":"Butterfly","codename":"dlxub1","model":"HTC Butterfly"},{"manufacturer":"HTC","market_name":"Butterfly","codename":"dlxub1","model":"HTC DLXUB1"},{"manufacturer":"HTC","market_name":"Butterfly 2","codename":"htc_b2ul","model":"HTC Butterfly 2"},{"manufacturer":"HTC","market_name":"Butterfly 2","codename":"htc_b2ul","model":"HTC_B810x"},{"manufacturer":"HTC","market_name":"Butterfly 3","codename":"htc_b3tuhl","model":"HTC_B830x"},{"manufacturer":"HTC","market_name":"Butterfly S","codename":"dlxpul","model":"HTC Butterfly s"},{"manufacturer":"HTC","market_name":"Butterfly S","codename":"dlxpul","model":"HTC_Butterfly_s_901s"},{"manufacturer":"HTC","market_name":"Butterfly s 9060","codename":"dlpdug","model":"HTC 9060"},{"manufacturer":"HTC","market_name":"Chacha","codename":"chacha","model":"HTC ChaCha A810b"},{"manufacturer":"HTC","market_name":"Chacha","codename":"chacha","model":"HTC ChaCha A810e"},{"manufacturer":"HTC","market_name":"Chacha","codename":"chacha","model":"HTC ChaChaCha A810e"},{"manufacturer":"HTC","market_name":"Chacha","codename":"chacha","model":"HTC Status"},{"manufacturer":"HTC","market_name":"D10w","codename":"htc_a56dj_pro_dtwl","model":"HTC D10w"},{"manufacturer":"HTC","market_name":"D316d","codename":"htc_v2_c","model":"HTC D316d"},{"manufacturer":"HTC","market_name":"D610t","codename":"htc_a3tl","model":"HTC D610t"},{"manufacturer":"HTC","market_name":"D616t","codename":"htc_a32ml_dtul","model":"HTC D626t"},{"manufacturer":"HTC","market_name":"D626q","codename":"htc_a32ml_dtul","model":"HTC Desire 626 dual sim"},{"manufacturer":"HTC","market_name":"D626q","codename":"htc_a32ml_dtul","model":"HTC_D626q"},{"manufacturer":"HTC","market_name":"D626t","codename":"htc_a32ml_dtul","model":"HTC D626t"},{"manufacturer":"HTC","market_name":"D628u","codename":"htc_v36bml_uhl","model":"HTC_D628u"},{"manufacturer":"HTC","market_name":"D728w","codename":"htc_a50cml_dtul","model":"HTC D728w"},{"manufacturer":"HTC","market_name":"D728w","codename":"htc_a50cml_dtul","model":"HTC Desire 728 dual sim"},{"manufacturer":"HTC","market_name":"D728x","codename":"htc_a50cml_dtul","model":"HTC_D728x"},{"manufacturer":"HTC","market_name":"D816d","codename":"htc_a5dwg","model":"HTC D816d"},{"manufacturer":"HTC","market_name":"D816d","codename":"htc_a5dwg","model":"HTC_D816d"},{"manufacturer":"HTC","market_name":"D816e","codename":"htc_a5dugl","model":"HTC D816e"},{"manufacturer":"HTC","market_name":"D816h","codename":"htc_a5mgp_dug","model":"HTC D816h"},{"manufacturer":"HTC","market_name":"D816t","codename":"htc_a5tl","model":"HTC D816t"},{"manufacturer":"HTC","market_name":"D816v","codename":"htc_a5dwgl","model":"HTC D816v"},{"manufacturer":"HTC","market_name":"D816w","codename":"htc_a5dug","model":"HTC D816w"},{"manufacturer":"HTC","market_name":"D820 Mini","codename":"htc_a31dtul","model":"HTC D820mt"},{"manufacturer":"HTC","market_name":"D820f","codename":"htc_a51tuhl","model":"HTC_D820f"},{"manufacturer":"HTC","market_name":"D820t","codename":"htc_a51dtul","model":"HTC D820t"},{"manufacturer":"HTC","market_name":"D820u","codename":"htc_a51dtul","model":"HTC D820u"},{"manufacturer":"HTC","market_name":"D820u","codename":"htc_a51dtul","model":"HTC_D820u"},{"manufacturer":"HTC","market_name":"D820ys","codename":"htc_a50ml","model":"HTC_D820ts"},{"manufacturer":"HTC","market_name":"D820ys","codename":"htc_a50ml","model":"HTC_D820ys"},{"manufacturer":"HTC","market_name":"D820ys","codename":"htc_a50ml_dtul","model":"HTC_D820ys"},{"manufacturer":"HTC","market_name":"D826t","codename":"htc_a52dtul","model":"HTC D826t"},{"manufacturer":"HTC","market_name":"DROID DNA","codename":"dlx","model":"HTC6435LRA"},{"manufacturer":"HTC","market_name":"DROID Incredible 4G LTE","codename":"fireball","model":"ADR6410LRA"},{"manufacturer":"HTC","market_name":"DROID Incredible 4G LTE","codename":"fireball","model":"ADR6410LVW"},{"manufacturer":"HTC","market_name":"DROID Incredible 4G LTE","codename":"fireball","model":"ADR6410OM"},{"manufacturer":"HTC","market_name":"Desire","codename":"bravo","model":"HTC Desire"},{"manufacturer":"HTC","market_name":"Desire","codename":"bravo","model":"X06HT"},{"manufacturer":"HTC","market_name":"Desire","codename":"bravoc","model":"PB99400"},{"manufacturer":"HTC","market_name":"Desire 10 compact","codename":"htc_a37dj_dugl","model":"HTC 2PZS1"},{"manufacturer":"HTC","market_name":"Desire 10 compact","codename":"htc_a37dj_dugl","model":"HTC Desire 10 compact"},{"manufacturer":"HTC","market_name":"Desire 10 compact","codename":"htc_a37dj_dugl","model":"a37dj dugl"},{"manufacturer":"HTC","market_name":"Desire 10 lifestyle","codename":"htc_a56djdugl","model":"HTC Desire 10 lifestyle"},{"manufacturer":"HTC","market_name":"Desire 10 lifestyle","codename":"htc_a56djuhl","model":"HTC Desire 10 lifestyle"},{"manufacturer":"HTC","market_name":"Desire 10 lifestyle","codename":"htc_a56djuhl","model":"HTC_D10u"},{"manufacturer":"HTC","market_name":"Desire 10 lifestyle","codename":"htc_a56djul","model":"HTC Desire 10 lifestyle"},{"manufacturer":"HTC","market_name":"Desire 10 pro","codename":"htc_a56dj_pro_dtwl","model":"HTC Desire 10 pro"},{"manufacturer":"HTC","market_name":"Desire 10 pro","codename":"htc_a56dj_pro_dugl","model":"HTC Desire 10 pro"},{"manufacturer":"HTC","market_name":"Desire 10 pro","codename":"htc_a56dj_pro_dugl","model":"HTC_D10i"},{"manufacturer":"HTC","market_name":"Desire 10 pro","codename":"htc_a56dj_pro_uhl","model":"HTC 2PYA3"},{"manufacturer":"HTC","market_name":"Desire 10 pro","codename":"htc_a56dj_pro_uhl","model":"HTC Desire 10 pro"},{"manufacturer":"HTC","market_name":"Desire 12","codename":"htc_breeze_dugl","model":"HTC 2Q5V1"},{"manufacturer":"HTC","market_name":"Desire 12","codename":"htc_breeze_dugl","model":"HTC Desire 12"},{"manufacturer":"HTC","market_name":"Desire 12","codename":"htc_breeze_ul","model":"HTC 2Q5V200"},{"manufacturer":"HTC","market_name":"Desire 12","codename":"htc_breeze_ul","model":"HTC Desire 12 (2Q5V200)"},{"manufacturer":"HTC","market_name":"Desire 12+","codename":"htc_brepdugl","model":"HTC 2Q5W1"},{"manufacturer":"HTC","market_name":"Desire 12+","codename":"htc_brepdugl","model":"HTC 2Q5W2"},{"manufacturer":"HTC","market_name":"Desire 12+","codename":"htc_brepdugl","model":"HTC Desire 12+"},{"manufacturer":"HTC","market_name":"Desire 12+","codename":"htc_brepdugl","model":"HTC ZQ5W10000"},{"manufacturer":"HTC","market_name":"Desire 200","codename":"gtou","model":"HTC Desire 200"},{"manufacturer":"HTC","market_name":"Desire 200","codename":"gtou","model":"HTC_Desire_200"},{"manufacturer":"HTC","market_name":"Desire 210 dual sim","codename":"htc_v0_dug","model":"HTC Desire 210 dual sim"},{"manufacturer":"HTC","market_name":"Desire 300","codename":"g3u","model":"HTC 301e"},{"manufacturer":"HTC","market_name":"Desire 300","codename":"g3u","model":"HTC Desire 300"},{"manufacturer":"HTC","market_name":"Desire 300","codename":"g3u","model":"HTC_0P6A1"},{"manufacturer":"HTC","market_name":"Desire 300","codename":"g3u","model":"HTC_Desire_300"},{"manufacturer":"HTC","market_name":"Desire 310","codename":"htc_v1_dug","model":"HTC D310w"},{"manufacturer":"HTC","market_name":"Desire 310","codename":"htc_v1_dug","model":"HTC Desire 310 dual sim"},{"manufacturer":"HTC","market_name":"Desire 310","codename":"htc_v1_u","model":"HTC Desire 310"},{"manufacturer":"HTC","market_name":"Desire 310","codename":"htc_v1_u","model":"HTC_D310n"},{"manufacturer":"HTC","market_name":"Desire 310","codename":"htc_v1_u","model":"HTC_V1"},{"manufacturer":"HTC","market_name":"Desire 320","codename":"htc_v01_u","model":"HTC 0PF11"},{"manufacturer":"HTC","market_name":"Desire 320","codename":"htc_v01_u","model":"HTC 0PF120"},{"manufacturer":"HTC","market_name":"Desire 320","codename":"htc_v01_u","model":"HTC Desire 320"},{"manufacturer":"HTC","market_name":"Desire 326G dual sim","codename":"htc_v01a_dug","model":"HTC 2PNT1"},{"manufacturer":"HTC","market_name":"Desire 326G dual sim","codename":"htc_v01a_dug","model":"HTC Desire 326G dual sim"},{"manufacturer":"HTC","market_name":"Desire 500","codename":"z4u","model":"HTC Desire 500"},{"manufacturer":"HTC","market_name":"Desire 500","codename":"z4u","model":"HTC_Desire_500"},{"manufacturer":"HTC","market_name":"Desire 500 dual sim","codename":"z4dug","model":"HTC 5060"},{"manufacturer":"HTC","market_name":"Desire 500 dual sim","codename":"z4dug","model":"HTC Desire 500 dual sim"},{"manufacturer":"HTC","market_name":"Desire 501","codename":"htc_csnu","model":"HTC Desire 501"},{"manufacturer":"HTC","market_name":"Desire 501","codename":"htc_csnu","model":"HTC_603h"},{"manufacturer":"HTC","market_name":"Desire 501 dual sim","codename":"csndug","model":"HTC Desire 501 dual sim"},{"manufacturer":"HTC","market_name":"Desire 5088","codename":"z4td","model":"HTC 5088"},{"manufacturer":"HTC","market_name":"Desire 510","codename":"htc_a11chl","model":"0PCV1"},{"manufacturer":"HTC","market_name":"Desire 510","codename":"htc_a11ul","model":"HTC 0PCV20"},{"manufacturer":"HTC","market_name":"Desire 510","codename":"htc_a11ul","model":"HTC Desire 510"},{"manufacturer":"HTC","market_name":"Desire 510","codename":"htc_a11ul","model":"HTC_0PCV2"},{"manufacturer":"HTC","market_name":"Desire 510","codename":"htc_a11ul8x26","model":"HTC Desire 510"},{"manufacturer":"HTC","market_name":"Desire 512","codename":"htc_a11aul8x26","model":"HTC Desire 512"},{"manufacturer":"HTC","market_name":"Desire 516","codename":"htc_v2_dcg","model":"HTC D516d"},{"manufacturer":"HTC","market_name":"Desire 516","codename":"htc_v2_dtg","model":"HTC D516t"},{"manufacturer":"HTC","market_name":"Desire 516","codename":"htc_v2_dug","model":"HTC C2"},{"manufacturer":"HTC","market_name":"Desire 516","codename":"htc_v2_dug","model":"HTC D516w"},{"manufacturer":"HTC","market_name":"Desire 516","codename":"htc_v2_dug","model":"HTC V2"},{"manufacturer":"HTC","market_name":"Desire 516 dual sim","codename":"htc_v2_dcg","model":"HTC Desire 516 dual sim"},{"manufacturer":"HTC","market_name":"Desire 516 dual sim","codename":"htc_v2_dug","model":"HTC Desire 516 dual sim"},{"manufacturer":"HTC","market_name":"Desire 516 dual sim","codename":"htc_v2_dug","model":"HTC V2"},{"manufacturer":"HTC","market_name":"Desire 520","codename":"htc_a12ul","model":"HTC 0PGQ1"},{"manufacturer":"HTC","market_name":"Desire 526","codename":"htc_a13wl","model":"HTC 0PM31"},{"manufacturer":"HTC","market_name":"Desire 526","codename":"htc_a13wl","model":"HTC Desire 526"},{"manufacturer":"HTC","market_name":"Desire 526","codename":"htc_a13wl","model":"HTCD100LVW"},{"manufacturer":"HTC","market_name":"Desire 526","codename":"htc_a13wlpp","model":"HTCD100LVWPP"},{"manufacturer":"HTC","market_name":"Desire 526G+ dual sim","codename":"htc_v02_dug","model":"HTC 0PL41"},{"manufacturer":"HTC","market_name":"Desire 526G+ dual sim","codename":"htc_v02_dug","model":"HTC 0PL4100"},{"manufacturer":"HTC","market_name":"Desire 526G+ dual sim","codename":"htc_v02_dug","model":"HTC Desire 526G dual sim"},{"manufacturer":"HTC","market_name":"Desire 526G+ dual sim","codename":"htc_v02_dug","model":"HTC Desire 526GPLUS dual sim"},{"manufacturer":"HTC","market_name":"Desire 526G+ dual sim","codename":"htc_v02_dug","model":"HTC_D526h"},{"manufacturer":"HTC","market_name":"Desire 526GPLUS","codename":"htc_v02_u","model":"HTC 0PL41"},{"manufacturer":"HTC","market_name":"Desire 526GPLUS","codename":"htc_v02_u","model":"HTC Desire 526G"},{"manufacturer":"HTC","market_name":"Desire 530","codename":"htc_a16ul","model":"HTC 2PST1"},{"manufacturer":"HTC","market_name":"Desire 530","codename":"htc_a16ul","model":"HTC 2PST2"},{"manufacturer":"HTC","market_name":"Desire 530","codename":"htc_a16ul","model":"HTC Desire 530"},{"manufacturer":"HTC","market_name":"Desire 530","codename":"htc_a16ul","model":"HTC_D530u"},{"manufacturer":"HTC","market_name":"Desire 530","codename":"htc_a16wl","model":"HTC 2PST3"},{"manufacturer":"HTC","market_name":"Desire 530","codename":"htc_a16wl","model":"HTC Desire 530"},{"manufacturer":"HTC","market_name":"Desire 530","codename":"htc_a16wl","model":"HTCD160LVW"},{"manufacturer":"HTC","market_name":"Desire 530","codename":"htc_a16wl","model":"HTCD160LVWPP"},{"manufacturer":"HTC","market_name":"Desire 550/ 555","codename":"htc_a15ul","model":"HTC Desire 550"},{"manufacturer":"HTC","market_name":"Desire 550/ 555","codename":"htc_a15ul","model":"HTC Desire 555"},{"manufacturer":"HTC","market_name":"Desire 600","codename":"cp3dug","model":"HTC Desire 600"},{"manufacturer":"HTC","market_name":"Desire 600 Dual SIM","codename":"cp3dug","model":"HTC Desire 600 dual sim"},{"manufacturer":"HTC","market_name":"Desire 600c Dual SIM","codename":"cp3dcg","model":"HTC 609d"},{"manufacturer":"HTC","market_name":"Desire 600c Dual SIM","codename":"cp3dcg","model":"HTC Desire 600c dual sim"},{"manufacturer":"HTC","market_name":"Desire 601","codename":"zara","model":"HTC Desire 601"},{"manufacturer":"HTC","market_name":"Desire 601","codename":"zara","model":"HTC_0P4E2"},{"manufacturer":"HTC","market_name":"Desire 601","codename":"zaracl","model":"HTC Desire 601"},{"manufacturer":"HTC","market_name":"Desire 601","codename":"zaracl","model":"HTC0P4E1"},{"manufacturer":"HTC","market_name":"Desire 601 dual sim","codename":"zaradug","model":"HTC Desire 601 dual sim"},{"manufacturer":"HTC","market_name":"Desire 606w","codename":"cp3dug","model":"HTC 606w"},{"manufacturer":"HTC","market_name":"Desire 609d","codename":"cp3dcg","model":"HTC 609d"},{"manufacturer":"HTC","market_name":"Desire 610","codename":"htc_a3qhdul","model":"HTC Desire 610"},{"manufacturer":"HTC","market_name":"Desire 610","codename":"htc_a3qhdul","model":"HTC_0P9O2"},{"manufacturer":"HTC","market_name":"Desire 610","codename":"htc_a3qhdul","model":"HTC_D610x"},{"manufacturer":"HTC","market_name":"Desire 610","codename":"htc_a3ul","model":"HTC Desire 610"},{"manufacturer":"HTC","market_name":"Desire 612","codename":"htc_a3qhdcl","model":"HTC 0P9O30"},{"manufacturer":"HTC","market_name":"Desire 612","codename":"htc_a3qhdcl","model":"HTC Desire 612"},{"manufacturer":"HTC","market_name":"Desire 616 dual sim","codename":"htc_v3_dug","model":"HTC D616w"},{"manufacturer":"HTC","market_name":"Desire 616 dual sim","codename":"htc_v3_dug","model":"HTC Desire 616 dual sim"},{"manufacturer":"HTC","market_name":"Desire 616 dual sim","codename":"htc_v3_dug","model":"HTC V3"},{"manufacturer":"HTC","market_name":"Desire 620","codename":"htc_a31ul","model":"HTC 0PE64"},{"manufacturer":"HTC","market_name":"Desire 620","codename":"htc_a31ul","model":"HTC Desire 620"},{"manufacturer":"HTC","market_name":"Desire 620 dual sim","codename":"htc_a31dtul","model":"HTC_D620u"},{"manufacturer":"HTC","market_name":"Desire 620G dual sim","codename":"htc_a31mg_dug","model":"HTC 0PE65"},{"manufacturer":"HTC","market_name":"Desire 620G dual sim","codename":"htc_a31mg_dug","model":"HTC Desire 620G dual sim"},{"manufacturer":"HTC","market_name":"Desire 620G dual sim","codename":"htc_a31mg_dug","model":"HTC_D620h"},{"manufacturer":"HTC","market_name":"Desire 626","codename":"htc_a32dcgl","model":"HTC D626d"},{"manufacturer":"HTC","market_name":"Desire 626","codename":"htc_a32ewl","model":"HTCD200LVW"},{"manufacturer":"HTC","market_name":"Desire 626","codename":"htc_a32ewlpp","model":"HTCD200LVWPP"},{"manufacturer":"HTC","market_name":"Desire 626","codename":"htc_a32ul","model":"HTC Desire 626"},{"manufacturer":"HTC","market_name":"Desire 626","codename":"htc_a32ul","model":"HTC_D626x"},{"manufacturer":"HTC","market_name":"Desire 626","codename":"htc_a32ul","model":"HTC_D630x"},{"manufacturer":"HTC","market_name":"Desire 626","codename":"htc_a32ul_emea","model":"HTC Desire 626"},{"manufacturer":"HTC","market_name":"Desire 626","codename":"htc_a32ul_emea","model":"HTC_0PKX2"},{"manufacturer":"HTC","market_name":"Desire 626 dual sim","codename":"htc_a32ml_dtul","model":"HTC Desire 626 dual sim"},{"manufacturer":"HTC","market_name":"Desire 626G+ dual sim","codename":"htc_a32mg_dug","model":"HTC 0PM11"},{"manufacturer":"HTC","market_name":"Desire 626G+ dual sim","codename":"htc_a32mg_dug","model":"HTC Desire 626G dual sim"},{"manufacturer":"HTC","market_name":"Desire 626G+ dual sim","codename":"htc_a32mg_dug","model":"HTC Desire 626GPLUS dual sim"},{"manufacturer":"HTC","market_name":"Desire 626G+ dual sim","codename":"htc_a32mg_dug","model":"HTC_D626ph"},{"manufacturer":"HTC","market_name":"Desire 626s","codename":"htc_a32eul","model":"HTC Desire 625"},{"manufacturer":"HTC","market_name":"Desire 626s","codename":"htc_a32eul","model":"HTC Desire 626s"},{"manufacturer":"HTC","market_name":"Desire 626s","codename":"htc_a32eul_la","model":"HTC Desire 626s"},{"manufacturer":"HTC","market_name":"Desire 626s","codename":"htc_a32ewhl","model":"0PM92"},{"manufacturer":"HTC","market_name":"Desire 626s","codename":"htc_a32ewhl","model":"HTC 0PM92"},{"manufacturer":"HTC","market_name":"Desire 626s","codename":"htc_a32ewhl","model":"HTC Desire 626s"},{"manufacturer":"HTC","market_name":"Desire 628","codename":"htc_v36bml_uhl","model":"HTC Desire 628"},{"manufacturer":"HTC","market_name":"Desire 628 dual sim","codename":"htc_v36bml_dugl","model":"HTC Desire 628 dual sim"},{"manufacturer":"HTC","market_name":"Desire 630 dual sim","codename":"htc_a16dwgl","model":"HTC 2PST5"},{"manufacturer":"HTC","market_name":"Desire 630 dual sim","codename":"htc_a16dwgl","model":"HTC Desire 630 dual sim"},{"manufacturer":"HTC","market_name":"Desire 650","codename":"htc_a17uhl","model":"HTC 2PYR1"},{"manufacturer":"HTC","market_name":"Desire 650","codename":"htc_a17uhl","model":"HTC Desire 650"},{"manufacturer":"HTC","market_name":"Desire 650","codename":"htc_a17uhl","model":"HTC_D650h"},{"manufacturer":"HTC","market_name":"Desire 650 dual sim","codename":"htc_a37_dugl","model":"A37 DUGL"},{"manufacturer":"HTC","market_name":"Desire 650 dual sim","codename":"htc_a37_dugl","model":"HTC Desire 650 dual sim"},{"manufacturer":"HTC","market_name":"Desire 700 dual sim","codename":"cp5dug","model":"HTC Desire 700 dual sim"},{"manufacturer":"HTC","market_name":"Desire 700 dual sim","codename":"cp5dwg","model":"HTC Desire 700 dual sim"},{"manufacturer":"HTC","market_name":"Desire 700 dual sim","codename":"cp5dwg","model":"HTC_709d"},{"manufacturer":"HTC","market_name":"Desire 7060","codename":"cp5dug","model":"HTC_7060"},{"manufacturer":"HTC","market_name":"Desire 7088","codename":"cp5dtu","model":"HTC 7088"},{"manufacturer":"HTC","market_name":"Desire 709d","codename":"cp5dwg","model":"HTC 709d"},{"manufacturer":"HTC","market_name":"Desire 728","codename":"htc_a50cml_tuhl","model":"HTC 2PQ84"},{"manufacturer":"HTC","market_name":"Desire 728","codename":"htc_a50cml_tuhl","model":"HTC Desire 728"},{"manufacturer":"HTC","market_name":"Desire 728 dual sim","codename":"htc_a50cml_dtul","model":"HTC Desire 728 dual sim"},{"manufacturer":"HTC","market_name":"Desire 728G dual sim","codename":"htc_a50cmg_dwg","model":"HTC 2PQ83"},{"manufacturer":"HTC","market_name":"Desire 728G dual sim","codename":"htc_a50cmg_dwg","model":"HTC Desire 728G dual sim"},{"manufacturer":"HTC","market_name":"Desire 816","codename":"htc_a5chl","model":"HTC Desire 816"},{"manufacturer":"HTC","market_name":"Desire 816","codename":"htc_a5ul","model":"HTC Desire 816"},{"manufacturer":"HTC","market_name":"Desire 816","codename":"htc_a5ul","model":"HTC_0P9C2"},{"manufacturer":"HTC","market_name":"Desire 816","codename":"htc_a5ul","model":"HTC_D816x"},{"manufacturer":"HTC","market_name":"Desire 816 dual sim","codename":"htc_a5dug","model":"HTC Desire 816 dual sim"},{"manufacturer":"HTC","market_name":"Desire 816 dual sim","codename":"htc_a5dwg","model":"HTC Desire 816 dual sim"},{"manufacturer":"HTC","market_name":"Desire 816G dual","codename":"htc_a5mgp_dug","model":"HTC Desire 816G dual sim"},{"manufacturer":"HTC","market_name":"Desire 816G dual sim","codename":"htc_a5mg_dug","model":"HTC Desire 816G dual sim"},{"manufacturer":"HTC","market_name":"Desire 816G dual sim","codename":"htc_a5mgp_dug","model":"HTC D816h"},{"manufacturer":"HTC","market_name":"Desire 816G dual sim","codename":"htc_a5mgp_dug","model":"HTC Desire 816G dual sim"},{"manufacturer":"HTC","market_name":"Desire 820","codename":"htc_a51ul","model":"HTC 0PFJ4"},{"manufacturer":"HTC","market_name":"Desire 820","codename":"htc_a51ul","model":"HTC Desire 820"},{"manufacturer":"HTC","market_name":"Desire 820 dual sim","codename":"htc_a51dtul","model":"HTC Desire 820 dual sim"},{"manufacturer":"HTC","market_name":"Desire 820G PLUS dual sim","codename":"htc_a50mgp_dug","model":"HTC Desire 820G PLUS dual sim"},{"manufacturer":"HTC","market_name":"Desire 820G PLUS dual sim","codename":"htc_a50mgp_dug","model":"HTC Desire 820G dual sim"},{"manufacturer":"HTC","market_name":"Desire 820G PLUS dual sim","codename":"htc_a50mgp_dug","model":"HTC_D820pi"},{"manufacturer":"HTC","market_name":"Desire 820q dual sim","codename":"htc_a50dtul","model":"HTC Desire 820q dual sim"},{"manufacturer":"HTC","market_name":"Desire 820s","codename":"htc_a50ml_dtul","model":"HTC D820ts"},{"manufacturer":"HTC","market_name":"Desire 820s","codename":"htc_a50ml_dtul","model":"HTC D820us"},{"manufacturer":"HTC","market_name":"Desire 820s","codename":"htc_a50ml_dtul","model":"HTC Desire 820s dual sim"},{"manufacturer":"HTC","market_name":"Desire 820s dual sim","codename":"htc_a50ml","model":"HTC Desire 820s dual sim"},{"manufacturer":"HTC","market_name":"Desire 825","codename":"htc_a56uhl","model":"HTC 2PUK2"},{"manufacturer":"HTC","market_name":"Desire 825","codename":"htc_a56uhl","model":"HTC Desire 825"},{"manufacturer":"HTC","market_name":"Desire 825","codename":"htc_a56uhl","model":"HTC_D825u"},{"manufacturer":"HTC","market_name":"Desire 825 dual sim","codename":"htc_a56dugl","model":"HTC 2PUK1"},{"manufacturer":"HTC","market_name":"Desire 825 dual sim","codename":"htc_a56dugl","model":"HTC Desire 825 dual sim"},{"manufacturer":"HTC","market_name":"Desire 826","codename":"htc_a52dtul","model":"HTC D826w"},{"manufacturer":"HTC","market_name":"Desire 826","codename":"htc_a52dwgl","model":"HTC D826d"},{"manufacturer":"HTC","market_name":"Desire 826","codename":"htc_a52tuhl","model":"HTC_D826y"},{"manufacturer":"HTC","market_name":"Desire 826 4G \\xe7\\xa7\\xbb\\xe5\\x8b\\x95\\xe5\\x85\\xac\\xe9\\x96\\x8b\\xe7\\x89\\x88(\\xe5\\x8f\\x8c\\xe5\\x8d\\xa1\\xe5\\x8f\\x8c\\xe5\\xbe\\x85)","codename":"htc_a52dtul","model":"HTC D826t"},{"manufacturer":"HTC","market_name":"Desire 826 dual sim","codename":"htc_a52dtul","model":"HTC Desire 826 dual sim"},{"manufacturer":"HTC","market_name":"Desire 826 dual sim","codename":"htc_a52dwgl","model":"HTC Desire 826 dual sim"},{"manufacturer":"HTC","market_name":"Desire 828","codename":"htc_a51bml_dtul","model":"HTC D828w"},{"manufacturer":"HTC","market_name":"Desire 828","codename":"htc_a51bml_dtul","model":"HTC_D828x"},{"manufacturer":"HTC","market_name":"Desire 828","codename":"htc_a51bml_tuhl","model":"HTC 2PRE4"},{"manufacturer":"HTC","market_name":"Desire 828","codename":"htc_a51bml_tuhl","model":"HTC Desire 828"},{"manufacturer":"HTC","market_name":"Desire 828","codename":"htc_a51bml_tuhl","model":"HTC_D828g"},{"manufacturer":"HTC","market_name":"Desire 828 dual sim","codename":"htc_a51bml_dtul","model":"HTC Desire 828 dual sim"},{"manufacturer":"HTC","market_name":"Desire 828 dual sim","codename":"htc_a51bml_dwgl","model":"HTC 2PRE2"},{"manufacturer":"HTC","market_name":"Desire 828 dual sim","codename":"htc_a51bml_dwgl","model":"HTC Desire 828 dual sim"},{"manufacturer":"HTC","market_name":"Desire 830","codename":"htc_a51cml_tuhl","model":"HTC Desire 830"},{"manufacturer":"HTC","market_name":"Desire 830","codename":"htc_a51cml_tuhl","model":"HTC_D830x"},{"manufacturer":"HTC","market_name":"Desire 830 dual sim","codename":"htc_a51cml_dtul","model":"HTC 2PVD1"},{"manufacturer":"HTC","market_name":"Desire 830 dual sim","codename":"htc_a51cml_dtul","model":"HTC D830u"},{"manufacturer":"HTC","market_name":"Desire 830 dual sim","codename":"htc_a51cml_dtul","model":"HTC Desire 830 dual sim"},{"manufacturer":"HTC","market_name":"Desire C","codename":"golfc","model":"HTC Desire C"},{"manufacturer":"HTC","market_name":"Desire C","codename":"golfu","model":"HTC Desire C"},{"manufacturer":"HTC","market_name":"Desire D626w","codename":"htc_a32ml_dtul","model":"HTC D626w"},{"manufacturer":"HTC","market_name":"Desire D820mini","codename":"htc_a31dtul","model":"HTC D820mt"},{"manufacturer":"HTC","market_name":"Desire D820mini","codename":"htc_a31dtul","model":"HTC D820mu"},{"manufacturer":"HTC","market_name":"Desire D826","codename":"htc_a52dwgl","model":"HTC D826d"},{"manufacturer":"HTC","market_name":"Desire EYE","codename":"htc_eyetuhl","model":"HTC 0PFH2"},{"manufacturer":"HTC","market_name":"Desire EYE","codename":"htc_eyetuhl","model":"HTC Desire EYE"},{"manufacturer":"HTC","market_name":"Desire EYE","codename":"htc_eyetuhl","model":"HTC_M910x"},{"manufacturer":"HTC","market_name":"Desire EYE","codename":"htc_eyeul","model":"HTC 0PFH11"},{"manufacturer":"HTC","market_name":"Desire EYE","codename":"htc_eyeul","model":"HTC Desire EYE"},{"manufacturer":"HTC","market_name":"Desire EYE","codename":"htc_eyeul_att","model":"HTC Desire Eye"},{"manufacturer":"HTC","market_name":"Desire HD","codename":"ace","model":"001HT"},{"manufacturer":"HTC","market_name":"Desire HD","codename":"ace","model":"Desire HD"},{"manufacturer":"HTC","market_name":"Desire HD","codename":"ace","model":"HTC Desire HD A9191"},{"manufacturer":"HTC","market_name":"Desire HD","codename":"ace","model":"Inspire HD"},{"manufacturer":"HTC","market_name":"Desire L by HTC","codename":"cp2u","model":"Desire L by HTC"},{"manufacturer":"HTC","market_name":"Desire L dual sim","codename":"cp2dug","model":"HTC Desire L dual sim"},{"manufacturer":"HTC","market_name":"Desire P","codename":"magniu","model":"HTC Desire P"},{"manufacturer":"HTC","market_name":"Desire S","codename":"saga","model":"HTC Desire S"},{"manufacturer":"HTC","market_name":"Desire SV","codename":"magnids","model":"HTC Desire SV"},{"manufacturer":"HTC","market_name":"Desire V","codename":"primods","model":"HTC Desire Q"},{"manufacturer":"HTC","market_name":"Desire V","codename":"primods","model":"HTC Desire U"},{"manufacturer":"HTC","market_name":"Desire V","codename":"primods","model":"HTC Desire U dual sim"},{"manufacturer":"HTC","market_name":"Desire V","codename":"primods","model":"HTC Desire V"},{"manufacturer":"HTC","market_name":"Desire V","codename":"primods","model":"HTC PROMIN_U"},{"manufacturer":"HTC","market_name":"Desire V","codename":"primods","model":"HTC PRO_DS"},{"manufacturer":"HTC","market_name":"Desire V","codename":"primods","model":"HTC T327w"},{"manufacturer":"HTC","market_name":"Desire V","codename":"primods","model":"HTC T328w"},{"manufacturer":"HTC","market_name":"Desire VC","codename":"primodd","model":"HTC Desire VC"},{"manufacturer":"HTC","market_name":"Desire VC","codename":"primodd","model":"HTC Desire VC T328d"},{"manufacturer":"HTC","market_name":"Desire VC","codename":"primodd","model":"HTC PRO_DD"},{"manufacturer":"HTC","market_name":"Desire VC","codename":"primodd","model":"HTC T328d"},{"manufacturer":"HTC","market_name":"Desire X","codename":"protou","model":"HTC Desire X"},{"manufacturer":"HTC","market_name":"Desire X","codename":"protou","model":"HTC POO_U"},{"manufacturer":"HTC","market_name":"Desire X dual sim","codename":"protodug","model":"HTC Desire X dual sim"},{"manufacturer":"HTC","market_name":"Desire XC dual sim","codename":"protodcg","model":"HTC Desire XC dual sim"},{"manufacturer":"HTC","market_name":"Desire320","codename":"htc_v01_u","model":"HTC_Desire_320"},{"manufacturer":"HTC","market_name":"Desire626","codename":"htc_a32ul_emea","model":"HTC 0PKX2"},{"manufacturer":"HTC","market_name":"Desire626","codename":"htc_a32ul_emea","model":"HTC Desire 626"},{"manufacturer":"HTC","market_name":"Desire626s","codename":"htc_a32eulatt","model":"HTC 0PM912"},{"manufacturer":"HTC","market_name":"Desire626s","codename":"htc_a32eulatt","model":"HTC Desire 626"},{"manufacturer":"HTC","market_name":"Desire815G","codename":"htc_a5mgp_u","model":"HTC Desire 816G"},{"manufacturer":"HTC","market_name":"Desrie D530","codename":"htc_a16ul","model":"HTC 2PST1"},{"manufacturer":"HTC","market_name":"Desrie D530","codename":"htc_a16ul","model":"HTC Desire 530"},{"manufacturer":"HTC","market_name":"Droid DNA","codename":"dlx","model":"HTC6435LRA"},{"manufacturer":"HTC","market_name":"Droid DNA","codename":"dlx","model":"HTC6435LVW"},{"manufacturer":"HTC","market_name":"Droid Eris","codename":"desirec","model":"Eris"},{"manufacturer":"HTC","market_name":"Droid Eris","codename":"desirec","model":"Pulse"},{"manufacturer":"HTC","market_name":"Droid Incredible","codename":"inc","model":"ADR6300"},{"manufacturer":"HTC","market_name":"E9pt","codename":"htc_a55ml_dtul","model":"HTC E9pt"},{"manufacturer":"HTC","market_name":"E9pw","codename":"htc_a55ml_dtul","model":"HTC E9pw"},{"manufacturer":"HTC","market_name":"E9pw","codename":"htc_a55ml_dtul","model":"HTC_E9pw"},{"manufacturer":"HTC","market_name":"E9t","codename":"htc_a53ml_dtul","model":"HTC E9t"},{"manufacturer":"HTC","market_name":"E9w","codename":"htc_a53ml_dtul","model":"HTC E9w"},{"manufacturer":"HTC","market_name":"E9x","codename":"htc_a53ml_dtul","model":"HTC_E9x"},{"manufacturer":"HTC","market_name":"EVO 3D","codename":"shooter","model":"HTCEVOV4G"},{"manufacturer":"HTC","market_name":"EVO 3D","codename":"shooter","model":"PG86100"},{"manufacturer":"HTC","market_name":"EVO 3D ISW12HT","codename":"shooterk","model":"ISW12HT"},{"manufacturer":"HTC","market_name":"EVO 3D X515m","codename":"shooteru","model":"HTC EVO 3D X515a"},{"manufacturer":"HTC","market_name":"EVO 3D X515m","codename":"shooteru","model":"HTC EVO 3D X515m"},{"manufacturer":"HTC","market_name":"EVO 3D X515m","codename":"shooteru","model":"HTC Inspire 3D"},{"manufacturer":"HTC","market_name":"EVO 4G LTE","codename":"jewel","model":"EVO"},{"manufacturer":"HTC","market_name":"EVO LTE 4G","codename":"jewel","model":"EVO"},{"manufacturer":"HTC","market_name":"EVO Shift 4G","codename":"speedy","model":"PG06100"},{"manufacturer":"HTC","market_name":"Evo 4G","codename":"supersonic","model":"PC36100"},{"manufacturer":"HTC","market_name":"Explorer A310e","codename":"pico","model":"HTC Explorer"},{"manufacturer":"HTC","market_name":"Explorer A310e","codename":"pico","model":"HTC Explorer A310b"},{"manufacturer":"HTC","market_name":"Explorer A310e","codename":"pico","model":"HTC Explorer A310e"},{"manufacturer":"HTC","market_name":"Flyer","codename":"flyer","model":"HTC Flyer"},{"manufacturer":"HTC","market_name":"Flyer","codename":"flyer","model":"HTC Flyer P510e"},{"manufacturer":"HTC","market_name":"Flyer","codename":"flyer","model":"HTC Flyer P511e"},{"manufacturer":"HTC","market_name":"Flyer","codename":"flyer","model":"HTC Flyer P512"},{"manufacturer":"HTC","market_name":"Flyer","codename":"flyer","model":"HTC_Flyer_P512_NA"},{"manufacturer":"HTC","market_name":"G1","codename":"dream","model":"HTC Dream"},{"manufacturer":"HTC","market_name":"G2","codename":"vision","model":"HTC Vision"},{"manufacturer":"HTC","market_name":"G2","codename":"vision","model":"T-Mobile G2"},{"manufacturer":"HTC","market_name":"HTC 10 evo","codename":"htc_acawhl","model":"HTC 10 evo"},{"manufacturer":"HTC","market_name":"HTC Desire 610","codename":"htc_a3ul","model":"HTC Desire 610"},{"manufacturer":"HTC","market_name":"HTC Desire 628 dual sim","codename":"htc_v36bml_dugl","model":"HTC 2PVG2"},{"manufacturer":"HTC","market_name":"HTC Desire 628 dual sim","codename":"htc_v36bml_dugl","model":"HTC Desire 628 dual sim"},{"manufacturer":"HTC","market_name":"HTC One","codename":"m7wls","model":"HTC One"},{"manufacturer":"HTC","market_name":"HTC One mini","codename":"m4","model":"HTC One mini"},{"manufacturer":"HTC","market_name":"HTC U11","codename":"htc_ocnuhl","model":"HTC 2PZC100"},{"manufacturer":"HTC","market_name":"HTC U11 Camera+","codename":"htc_haydtwla","model":"HTC 2Q4R400"},{"manufacturer":"HTC","market_name":"HTC U11 EYEs","codename":"htc_haydtwl","model":"HTC 2Q4R300"},{"manufacturer":"HTC","market_name":"HTC U11 EYEs","codename":"htc_haydtwl","model":"HTC 2Q4R400"},{"manufacturer":"HTC","market_name":"HTC U11 EYEs","codename":"htc_haydugl","model":"HTC 2Q4R1"},{"manufacturer":"HTC","market_name":"HTC U11 EYEs","codename":"htc_haydugl","model":"HTC 2Q4R100"},{"manufacturer":"HTC","market_name":"HTC U11 EYEs","codename":"htc_haydugl","model":"HTC U11 EYEs"},{"manufacturer":"HTC","market_name":"HTC U11 life","codename":"htc_ocla1_sprout","model":"HTC U11 life"},{"manufacturer":"HTC","market_name":"HTC U11 life","codename":"htc_oclul","model":"HTC U11 Life"},{"manufacturer":"HTC","market_name":"HTC U11 life","codename":"htc_oclul","model":"HTC U11 life"},{"manufacturer":"HTC","market_name":"HTC U11+","codename":"htc_ocmdtwl","model":"HTC 2Q4D200"},{"manufacturer":"HTC","market_name":"HTC U11+","codename":"htc_ocmdugl","model":"HTC U11 plus"},{"manufacturer":"HTC","market_name":"HTC U11+","codename":"htc_ocmdugl","model":"HTC_2Q4D100"},{"manufacturer":"HTC","market_name":"HTC6435LVW","codename":"dlx","model":"HTC6435LVW"},{"manufacturer":"HTC","market_name":"HTC909d","codename":"dlpdwg","model":"HTC 919d"},{"manufacturer":"HTC","market_name":"HTCDesire612VZW","codename":"htc_a3qhdcl","model":"HTC331ZLVW"},{"manufacturer":"HTC","market_name":"HTCDesire612VZW","codename":"htc_a3qhdcl","model":"HTC331ZLVWPP"},{"manufacturer":"HTC","market_name":"HTCEVODesign4G","codename":"kingdom","model":"HTC Acquire"},{"manufacturer":"HTC","market_name":"HTCEVODesign4G","codename":"kingdom","model":"HTC EVO Design C715e"},{"manufacturer":"HTC","market_name":"HTCEVODesign4G","codename":"kingdom","model":"HTC Hero S"},{"manufacturer":"HTC","market_name":"HTCEVODesign4G","codename":"kingdom","model":"HTC Kingdom"},{"manufacturer":"HTC","market_name":"HTCEVODesign4G","codename":"kingdom","model":"HTCEVODesign4G"},{"manufacturer":"HTC","market_name":"HTCEVODesign4G","codename":"kingdom","model":"PH44100"},{"manufacturer":"HTC","market_name":"HTCOneMaxVZW","codename":"t6wl","model":"HTC6600LVW"},{"manufacturer":"HTC","market_name":"HTL23","codename":"htc_b2wlj","model":"HTL23"},{"manufacturer":"HTC","market_name":"HTV31","codename":"htc_b3uhl","model":"HTV31"},{"manufacturer":"HTC","market_name":"Hero","codename":"hero","model":"ERA G2 Touch"},{"manufacturer":"HTC","market_name":"Hero","codename":"hero","model":"HTC Hero"},{"manufacturer":"HTC","market_name":"Hero","codename":"hero","model":"T-Mobile G2 Touch"},{"manufacturer":"HTC","market_name":"Hero","codename":"hero","model":"T-Mobile_G2_Touch"},{"manufacturer":"HTC","market_name":"Hero","codename":"hero","model":"dopod A6288"},{"manufacturer":"HTC","market_name":"Hero","codename":"heroc","model":"HERO200"},{"manufacturer":"HTC","market_name":"ISW13HT","codename":"valentewx","model":"ISW13HT"},{"manufacturer":"HTC","market_name":"Incredible 2","codename":"vivow","model":"ADR6350"},{"manufacturer":"HTC","market_name":"Incredible 2","codename":"vivow","model":"HTC IncredibleS S710d"},{"manufacturer":"HTC","market_name":"Incredible S","codename":"vivo","model":"HTC Incredible S"},{"manufacturer":"HTC","market_name":"Incredible S","codename":"vivo","model":"HTC_S710E"},{"manufacturer":"HTC","market_name":"J Butterfly","codename":"dlxj","model":"HTL21"},{"manufacturer":"HTC","market_name":"J One","codename":"m7wlj","model":"HTL22"},{"manufacturer":"HTC","market_name":"J Z321e","codename":"valentewxc9","model":"HTC J Z321e"},{"manufacturer":"HTC","market_name":"KDDI Infobar A02","codename":"imnj","model":"HTX21"},{"manufacturer":"HTC","market_name":"Legend","codename":"legend","model":"HTC Legend"},{"manufacturer":"HTC","market_name":"M10","codename":"htc_pmeuhl","model":"HTC 10"},{"manufacturer":"HTC","market_name":"M8si","codename":"htc_m8qltuhl","model":"HTC M8si"},{"manufacturer":"HTC","market_name":"M8t","codename":"htc_m8tl","model":"HTC M8t"},{"manufacturer":"HTC","market_name":"M9","codename":"htc_himaulatt","model":"HTC One M9"},{"manufacturer":"HTC","market_name":"M9e","codename":"htc_himaruhl","model":"HTC M9e"},{"manufacturer":"HTC","market_name":"M9e","codename":"htc_himaruhl","model":"HTC One M9_Prime Camera Edition"},{"manufacturer":"HTC","market_name":"M9e","codename":"htc_himaruhl","model":"HTC One M9s"},{"manufacturer":"HTC","market_name":"M9e","codename":"htc_himaruhl","model":"HTC_M9e"},{"manufacturer":"HTC","market_name":"M9et","codename":"htc_hima_ace_ml_dtul","model":"HTC M9et"},{"manufacturer":"HTC","market_name":"M9ew","codename":"htc_hima_ace_ml_dtul","model":"HTC M9ew"},{"manufacturer":"HTC","market_name":"M9ew","codename":"htc_hima_ace_ml_dtul","model":"HTC_M9ew"},{"manufacturer":"HTC","market_name":"M9pw","codename":"htc_hiau_ml_tuhl","model":"HTC M9pw"},{"manufacturer":"HTC","market_name":"M9pw","codename":"htc_hiaur_ml_tuhl","model":"HTC M9pw"},{"manufacturer":"HTC","market_name":"M9px","codename":"htc_hiaur_ml_tuhl","model":"HTC_M9px"},{"manufacturer":"HTC","market_name":"M9w","codename":"htc_himauhl","model":"HTC M9w"},{"manufacturer":"HTC","market_name":"Nexus 9","codename":"flounder","model":"Nexus 9"},{"manufacturer":"HTC","market_name":"Nexus 9 LTE","codename":"flounder_lte","model":"Nexus 9"},{"manufacturer":"HTC","market_name":"Nexus One","codename":"passion","model":"Nexus One"},{"manufacturer":"HTC","market_name":"ONE","codename":"m7cdug","model":"HTC One dual sim"},{"manufacturer":"HTC","market_name":"ONE M8s","codename":"htc_m8qlul","model":"HTC One M8s"},{"manufacturer":"HTC","market_name":"ONE M8s","codename":"htc_m8qlul","model":"HTC_0PKV1"},{"manufacturer":"HTC","market_name":"ONE S","codename":"ville","model":"HTC One S"},{"manufacturer":"HTC","market_name":"ONE SV","codename":"k2u","model":"HTC K2_U"},{"manufacturer":"HTC","market_name":"ONE SV","codename":"k2u","model":"HTC One SV"},{"manufacturer":"HTC","market_name":"ONE SV","codename":"k2ul","model":"HTC One SV"},{"manufacturer":"HTC","market_name":"One","codename":"m7","model":"HTC 801e"},{"manufacturer":"HTC","market_name":"One","codename":"m7","model":"HTC One"},{"manufacturer":"HTC","market_name":"One","codename":"m7","model":"HTC One 801e"},{"manufacturer":"HTC","market_name":"One","codename":"m7","model":"HTC_PN071"},{"manufacturer":"HTC","market_name":"One","codename":"m7cdtu","model":"HTC 802t"},{"manufacturer":"HTC","market_name":"One","codename":"m7cdtu","model":"HTC 802t 16GB"},{"manufacturer":"HTC","market_name":"One","codename":"m7cdug","model":"HTC 802w"},{"manufacturer":"HTC","market_name":"One","codename":"m7cdug","model":"HTC One dual sim"},{"manufacturer":"HTC","market_name":"One","codename":"m7cdwg","model":"HTC 802d"},{"manufacturer":"HTC","market_name":"One","codename":"m7cdwg","model":"HTC One dual 802d"},{"manufacturer":"HTC","market_name":"One","codename":"m7cdwg","model":"HTC One dual sim"},{"manufacturer":"HTC","market_name":"One","codename":"m7wls","model":"HTC One"},{"manufacturer":"HTC","market_name":"One","codename":"m7wls","model":"HTCONE"},{"manufacturer":"HTC","market_name":"One","codename":"m7wlv","model":"HTC One"},{"manufacturer":"HTC","market_name":"One","codename":"m7wlv","model":"HTC6500LVW"},{"manufacturer":"HTC","market_name":"One (E8)","codename":"htc_mecdwg","model":"HTC M8Sd"},{"manufacturer":"HTC","market_name":"One (E8)","codename":"htc_mectl","model":"HTC M8St"},{"manufacturer":"HTC","market_name":"One (E8)","codename":"htc_mectl","model":"HTC One_E8"},{"manufacturer":"HTC","market_name":"One (E8)","codename":"htc_mecul","model":"HTC One_E8"},{"manufacturer":"HTC","market_name":"One (E8)","codename":"htc_mecul","model":"HTC_M8Sx"},{"manufacturer":"HTC","market_name":"One (E8)","codename":"htc_mecwhl","model":"0PAJ5"},{"manufacturer":"HTC","market_name":"One (E8) dual sim","codename":"htc_mecdug","model":"HTC One_E8 dual sim"},{"manufacturer":"HTC","market_name":"One (E8) dual sim","codename":"htc_mecdug","model":"HTC_M8Sy"},{"manufacturer":"HTC","market_name":"One (E8) dual sim","codename":"htc_mecdwg","model":"HTC 0PAJ4"},{"manufacturer":"HTC","market_name":"One (E8) dual sim","codename":"htc_mecdwg","model":"HTC M8Sd"},{"manufacturer":"HTC","market_name":"One (E8) dual sim","codename":"htc_mecdwg","model":"HTC One_E8 dual sim"},{"manufacturer":"HTC","market_name":"One (E8) \\xe6\\x97\\xb6\\xe5\\xb0\\x9a\\xe7\\x89\\x88","codename":"htc_mectl","model":"HTC M8St"},{"manufacturer":"HTC","market_name":"One (E8) \\xe6\\x97\\xb6\\xe5\\xb0\\x9a\\xe7\\x89\\x88   4G LTE\\xe5\\x8f\\x8c\\xe5\\x8d\\xa1\\xe5\\x8f\\x8c\\xe5\\xbe\\x85\\xe8\\x81\\x94\\xe9\\x80\\x9a\\xe7\\x89\\x88","codename":"htc_mecdug","model":"HTC M8Sw"},{"manufacturer":"HTC","market_name":"One (E8) \\xe6\\x99\\x82\\xe5\\xb0\\x9a\\xe7\\x89\\x884G LTE \\xe7\\xa7\\xbb\\xe5\\x8a\\xa8\\xe7\\x89\\x88","codename":"htc_mectl","model":"HTC M8Ss"},{"manufacturer":"HTC","market_name":"One (M8 EYE)","codename":"htc_melsuhl","model":"HTC 0P6B900"},{"manufacturer":"HTC","market_name":"One (M8 EYE)","codename":"htc_melsuhl","model":"HTC One_M8 Eye"},{"manufacturer":"HTC","market_name":"One (M8 Eye)","codename":"htc_melsuhl","model":"HTC 0P6B9"},{"manufacturer":"HTC","market_name":"One (M8 Eye)","codename":"htc_melsuhl","model":"HTC One_M8 Eye"},{"manufacturer":"HTC","market_name":"One (M8)","codename":"htc_m8","model":"HTC M8w"},{"manufacturer":"HTC","market_name":"One (M8)","codename":"htc_m8","model":"HTC One_M8"},{"manufacturer":"HTC","market_name":"One (M8)","codename":"htc_m8","model":"HTC_0P6B"},{"manufacturer":"HTC","market_name":"One (M8)","codename":"htc_m8","model":"HTC_0P6B6"},{"manufacturer":"HTC","market_name":"One (M8)","codename":"htc_m8","model":"HTC_M8x"},{"manufacturer":"HTC","market_name":"One (M8)","codename":"htc_m8dug","model":"HTC One_M8 dual sim"},{"manufacturer":"HTC","market_name":"One (M8)","codename":"htc_m8dwg","model":"HTC M8d"},{"manufacturer":"HTC","market_name":"One (M8)","codename":"htc_m8whl","model":"831C"},{"manufacturer":"HTC","market_name":"One (M8)","codename":"htc_m8wl","model":"HTC One_M8"},{"manufacturer":"HTC","market_name":"One (M8)","codename":"htc_m8wl","model":"HTC6525LVW"},{"manufacturer":"HTC","market_name":"One (M8) (4G LTE \\xe5\\x8f\\x8c\\xe5\\x8d\\xa1\\xe5\\x8f\\x8c\\xe5\\xbe\\x85 \\xe8\\x81\\x94\\xe9\\x80\\x9a\\xe7\\x89\\x88)","codename":"htc_m8dug","model":"HTC M8e"},{"manufacturer":"HTC","market_name":"One 801e","codename":"m7","model":"HTC One 801e"},{"manufacturer":"HTC","market_name":"One 801e","codename":"m7","model":"HTC One 801s"},{"manufacturer":"HTC","market_name":"One A9","codename":"htc_hiaetuhl","model":"HTC A9w"},{"manufacturer":"HTC","market_name":"One A9","codename":"htc_hiaeuhl","model":"HTC One A9"},{"manufacturer":"HTC","market_name":"One A9","codename":"htc_hiaeuhl","model":"HTC_A9u"},{"manufacturer":"HTC","market_name":"One A9","codename":"htc_hiaeul","model":"HTC One A9"},{"manufacturer":"HTC","market_name":"One A9","codename":"htc_hiaewhl","model":"2PQ93"},{"manufacturer":"HTC","market_name":"One A9s","codename":"htc_e36_ml_uhl","model":"HTC 2PWD1"},{"manufacturer":"HTC","market_name":"One A9s","codename":"htc_e36_ml_uhl","model":"HTC One A9s"},{"manufacturer":"HTC","market_name":"One A9s","codename":"htc_e36_ml_uhl","model":"HTC_A9sx"},{"manufacturer":"HTC","market_name":"One A9s","codename":"htc_e36_ml_ul","model":"HTC 2PWD2"},{"manufacturer":"HTC","market_name":"One A9s","codename":"htc_e36_ml_ul","model":"HTC One A9s"},{"manufacturer":"HTC","market_name":"One Dual 802d","codename":"m7cdwg","model":"HTC One dual 802d"},{"manufacturer":"HTC","market_name":"One Dual Sim","codename":"m7cdwg","model":"HTC One dual sim"},{"manufacturer":"HTC","market_name":"One E8 dual","codename":"htc_mecdwg","model":"HTC_M8Sd"},{"manufacturer":"HTC","market_name":"One E9 dual sim","codename":"htc_a53ml_dtul","model":"HTC 0PL31"},{"manufacturer":"HTC","market_name":"One E9 dual sim","codename":"htc_a53ml_dtul","model":"HTC One E9 dual sim"},{"manufacturer":"HTC","market_name":"One E9PLUS dual sim","codename":"htc_a55ml_dtul","model":"HTC One E9PLUS dual sim"},{"manufacturer":"HTC","market_name":"One E9s dual sim","codename":"htc_a50aml","model":"HTC D826sw"},{"manufacturer":"HTC","market_name":"One E9s dual sim","codename":"htc_a50aml","model":"HTC One E9s dual sim"},{"manufacturer":"HTC","market_name":"One E9s dual sim","codename":"htc_a50aml","model":"HTC_E9sx"},{"manufacturer":"HTC","market_name":"One Google Play edition","codename":"m7","model":"HTC One"},{"manufacturer":"HTC","market_name":"One M8 eye 4G LTE","codename":"htc_melstuhl","model":"HTC M8Et"},{"manufacturer":"HTC","market_name":"One M8 eye 4G LTE","codename":"htc_melsuhl","model":"HTC M8Ew"},{"manufacturer":"HTC","market_name":"One M9","codename":"htc_himauhl","model":"0PJA10"},{"manufacturer":"HTC","market_name":"One M9","codename":"htc_himauhl","model":"HTC 0PJA10"},{"manufacturer":"HTC","market_name":"One M9","codename":"htc_himauhl","model":"HTC One M9"},{"manufacturer":"HTC","market_name":"One M9","codename":"htc_himauhl","model":"HTC_0PJA10"},{"manufacturer":"HTC","market_name":"One M9","codename":"htc_himauhl","model":"HTC_M9u"},{"manufacturer":"HTC","market_name":"One M9","codename":"htc_himaul","model":"HTC One M9"},{"manufacturer":"HTC","market_name":"One M9","codename":"htc_himaulatt","model":"HTC One M9"},{"manufacturer":"HTC","market_name":"One M9","codename":"htc_himawhl","model":"0PJA2"},{"manufacturer":"HTC","market_name":"One M9","codename":"htc_himawhl","model":"HTC One M9"},{"manufacturer":"HTC","market_name":"One M9","codename":"htc_himawl","model":"HTC6535LRA"},{"manufacturer":"HTC","market_name":"One M9","codename":"htc_himawl","model":"HTC6535LVW"},{"manufacturer":"HTC","market_name":"One M9+","codename":"htc_hiau_ml_tuhl","model":"HTC 0PK71"},{"manufacturer":"HTC","market_name":"One M9+","codename":"htc_hiau_ml_tuhl","model":"HTC M9pt"},{"manufacturer":"HTC","market_name":"One M9+","codename":"htc_hiau_ml_tuhl","model":"HTC One M9PLUS"},{"manufacturer":"HTC","market_name":"One M9+","codename":"htc_hiau_ml_tuhl","model":"HTC_M9pw"},{"manufacturer":"HTC","market_name":"One M9+ (Prime Camera Edition)","codename":"htc_hiaur2_ml_tuhl","model":"HTC 0PK71"},{"manufacturer":"HTC","market_name":"One M9+ (Prime Camera Edition)","codename":"htc_hiaur2_ml_tuhl","model":"HTC One M9PLUS_Prime Camera Edition"},{"manufacturer":"HTC","market_name":"One M9PLUS","codename":"htc_hiau_ml_tuhl","model":"HTC One M9PLUS"},{"manufacturer":"HTC","market_name":"One ME dual sim","codename":"htc_hima_ace_ml_dtul","model":"HTC 0PLA1"},{"manufacturer":"HTC","market_name":"One ME dual sim","codename":"htc_hima_ace_ml_dtul","model":"HTC One ME dual sim"},{"manufacturer":"HTC","market_name":"One S","codename":"ville","model":"HTC One S"},{"manufacturer":"HTC","market_name":"One S","codename":"ville","model":"HTC VLE_U"},{"manufacturer":"HTC","market_name":"One S","codename":"villec2","model":"HTC One S"},{"manufacturer":"HTC","market_name":"One S","codename":"villec2","model":"HTC Z560e"},{"manufacturer":"HTC","market_name":"One S Special Edition","codename":"villeplus","model":"HTC One S Special Edition"},{"manufacturer":"HTC","market_name":"One S9","codename":"htc_himar2uhl","model":"HTC 2PRG100"},{"manufacturer":"HTC","market_name":"One S9","codename":"htc_himar2uhl","model":"HTC One S9"},{"manufacturer":"HTC","market_name":"One S9","codename":"htc_himar2uhl","model":"HTC_S9u"},{"manufacturer":"HTC","market_name":"One SC","codename":"cp2dcg","model":"HTC One SC"},{"manufacturer":"HTC","market_name":"One SC","codename":"cp2dcg","model":"HTC One SC T528d"},{"manufacturer":"HTC","market_name":"One SV","codename":"k2cl","model":"C525c"},{"manufacturer":"HTC","market_name":"One SV","codename":"k2plccl","model":"HTC One SV"},{"manufacturer":"HTC","market_name":"One SV","codename":"k2ul","model":"HTC K2_UL"},{"manufacturer":"HTC","market_name":"One SV","codename":"k2ul","model":"HTC One SV"},{"manufacturer":"HTC","market_name":"One SV BLK","codename":"k2plccl","model":"HTC One SV"},{"manufacturer":"HTC","market_name":"One SV BLK","codename":"k2plccl","model":"HTC One SV BLK"},{"manufacturer":"HTC","market_name":"One V","codename":"primoc","model":"HTC One V"},{"manufacturer":"HTC","market_name":"One V","codename":"primou","model":"HTC ONE V"},{"manufacturer":"HTC","market_name":"One V","codename":"primou","model":"HTC One V"},{"manufacturer":"HTC","market_name":"One VX","codename":"totemc2","model":"HTC One VX"},{"manufacturer":"HTC","market_name":"One X","codename":"endeavoru","model":"HTC One X"},{"manufacturer":"HTC","market_name":"One X","codename":"endeavoru","model":"HTC S720e"},{"manufacturer":"HTC","market_name":"One X","codename":"evita","model":"HTC One X"},{"manufacturer":"HTC","market_name":"One X+","codename":"enrc2b","model":"HTC One X+"},{"manufacturer":"HTC","market_name":"One X+","codename":"evitareul","model":"HTC One X+"},{"manufacturer":"HTC","market_name":"One X10","codename":"htc_e66_dtwl","model":"HTC 2PXH1"},{"manufacturer":"HTC","market_name":"One X10","codename":"htc_e66_dtwl","model":"HTC One X10"},{"manufacturer":"HTC","market_name":"One X10","codename":"htc_e66_dugl","model":"HTC 2PXH2"},{"manufacturer":"HTC","market_name":"One X10","codename":"htc_e66_dugl","model":"HTC One X10"},{"manufacturer":"HTC","market_name":"One X10","codename":"htc_e66_dugl","model":"HTC_X10u"},{"manufacturer":"HTC","market_name":"One X10","codename":"htc_e66_uhl","model":"HTC 2PXH3"},{"manufacturer":"HTC","market_name":"One X9","codename":"htc_e56ml_tuhl","model":"HTC 2PS5200"},{"manufacturer":"HTC","market_name":"One X9 dual sim","codename":"htc_e56ml_dtul","model":"HTC One X9 dual sim"},{"manufacturer":"HTC","market_name":"One X9 dual sim","codename":"htc_e56ml_dtul","model":"HTC X9u"},{"manufacturer":"HTC","market_name":"One X9 dual sim","codename":"htc_e56ml_dtul","model":"HTC_X9u"},{"manufacturer":"HTC","market_name":"One XL","codename":"evita","model":"HTC One X"},{"manufacturer":"HTC","market_name":"One XL","codename":"evita","model":"HTC One XL"},{"manufacturer":"HTC","market_name":"One XL","codename":"evita","model":"HTC_One_XL"},{"manufacturer":"HTC","market_name":"One XL","codename":"evitautl","model":"HTC EVA_UTL"},{"manufacturer":"HTC","market_name":"One max","codename":"t6ul","model":"HTC One max"},{"manufacturer":"HTC","market_name":"One max","codename":"t6ul","model":"HTC_One_max"},{"manufacturer":"HTC","market_name":"One max","codename":"t6whl","model":"HTC0P3P7"},{"manufacturer":"HTC","market_name":"One mini","codename":"htc_m4","model":"HTC One mini"},{"manufacturer":"HTC","market_name":"One mini","codename":"m4","model":"HTC One mini"},{"manufacturer":"HTC","market_name":"One mini","codename":"m4","model":"HTC_One_mini_601e"},{"manufacturer":"HTC","market_name":"One mini","codename":"m4","model":"HTC_PO582"},{"manufacturer":"HTC","market_name":"One mini 2","codename":"htc_memul","model":"HTC One mini 2"},{"manufacturer":"HTC","market_name":"One mini 2","codename":"htc_memul","model":"HTC_M8MINx"},{"manufacturer":"HTC","market_name":"One mini 2","codename":"htc_memul","model":"HTC_One_mini_2"},{"manufacturer":"HTC","market_name":"One mini 601E","codename":"m4","model":"HTC_One_mini_601e"},{"manufacturer":"HTC","market_name":"One remix","codename":"htc_memwl","model":"HTC6515LVW"},{"manufacturer":"HTC","market_name":"One_E8","codename":"htc_mecul_emea","model":"HTC One_E8"},{"manufacturer":"HTC","market_name":"Onex X","codename":"endeavoru","model":"HTC One X"},{"manufacturer":"HTC","market_name":"PO091","codename":"csndug","model":"HTC PO091"},{"manufacturer":"HTC","market_name":"Puccini","codename":"puccinilte","model":"HTC PG09410"},{"manufacturer":"HTC","market_name":"Puccini","codename":"puccinilte","model":"HTC-P715a"},{"manufacturer":"HTC","market_name":"Rhyme S510b","codename":"bliss","model":"HTC Rhyme S510b"},{"manufacturer":"HTC","market_name":"S720e","codename":"endeavoru","model":"HTC S720e"},{"manufacturer":"HTC","market_name":"Salsa C510e","codename":"icong","model":"HTC Salsa C510b"},{"manufacturer":"HTC","market_name":"Salsa C510e","codename":"icong","model":"HTC Salsa C510e"},{"manufacturer":"HTC","market_name":"Sensation 4G","codename":"pyramid","model":"HTC Sensation"},{"manufacturer":"HTC","market_name":"Sensation 4G","codename":"pyramid","model":"HTC Sensation 4G"},{"manufacturer":"HTC","market_name":"Sensation 4G","codename":"pyramid","model":"HTC Sensation XE with Beats Audio"},{"manufacturer":"HTC","market_name":"Sensation 4G","codename":"pyramid","model":"HTC Sensation XE with Beats Audio Z715a"},{"manufacturer":"HTC","market_name":"Sensation 4G","codename":"pyramid","model":"HTC Sensation XE with Beats Audio Z715e"},{"manufacturer":"HTC","market_name":"Sensation 4G","codename":"pyramid","model":"HTC Sensation Z710a"},{"manufacturer":"HTC","market_name":"Sensation 4G","codename":"pyramid","model":"HTC Sensation Z710e"},{"manufacturer":"HTC","market_name":"Sensation 4G","codename":"pyramid","model":"HTC-Z710a"},{"manufacturer":"HTC","market_name":"Sensation XL with Beats Audio X315e","codename":"runnymede","model":"HTC Sensation XL with Beats Audio X315b"},{"manufacturer":"HTC","market_name":"Sensation XL with Beats Audio X315e","codename":"runnymede","model":"HTC Sensation XL with Beats Audio X315e"},{"manufacturer":"HTC","market_name":"Sensation XL with Beats Audio X315e","codename":"runnymede","model":"HTC-X315E"},{"manufacturer":"HTC","market_name":"Sensation XL with Beats Audio X315e","codename":"runnymede","model":"Sensation XL with Beats Audio"},{"manufacturer":"HTC","market_name":"T329d","codename":"protodcg","model":"HTC T329d"},{"manufacturer":"HTC","market_name":"T528w","codename":"cp2dug","model":"HTC Desire L dual sim"},{"manufacturer":"HTC","market_name":"Telstra Signature\\xe2\\x84\\xa2 Premium","codename":"htc_hiaeuhl","model":"HTC 2PQ910"},{"manufacturer":"HTC","market_name":"Thunderbolt","codename":"mecha","model":"ADR6400L"},{"manufacturer":"HTC","market_name":"Thunderbolt","codename":"mecha","model":"HTC Mecha"},{"manufacturer":"HTC","market_name":"U Play","codename":"htc_alpine_dugl","model":"HTC U Play"},{"manufacturer":"HTC","market_name":"U Play","codename":"htc_alpine_dugl","model":"HTC_U-2u"},{"manufacturer":"HTC","market_name":"U Play","codename":"htc_alpine_uhl","model":"HTC 2PZM3"},{"manufacturer":"HTC","market_name":"U Play","codename":"htc_alpine_uhl","model":"HTC U Play"},{"manufacturer":"HTC","market_name":"U Play","codename":"htc_e36_ml_uhl","model":"HTC 2PWD1"},{"manufacturer":"HTC","market_name":"U Ultra","codename":"htc_ocedtwl","model":"HTC U-1w"},{"manufacturer":"HTC","market_name":"U Ultra","codename":"htc_ocedugl","model":"HTC U Ultra"},{"manufacturer":"HTC","market_name":"U Ultra","codename":"htc_ocedugl","model":"HTC_U-1u"},{"manufacturer":"HTC","market_name":"U Ultra","codename":"htc_oceuhl","model":"HTC 2PZF1"},{"manufacturer":"HTC","market_name":"U Ultra","codename":"htc_oceuhl","model":"HTC U Ultra"},{"manufacturer":"HTC","market_name":"U11","codename":"htc_ocndtwl","model":"HTC U-3w"},{"manufacturer":"HTC","market_name":"U11","codename":"htc_ocndugl","model":"HTC U11"},{"manufacturer":"HTC","market_name":"U11","codename":"htc_ocndugl","model":"HTC_U-3u"},{"manufacturer":"HTC","market_name":"U11","codename":"htc_ocnuhl","model":"HTC 2PZC100"},{"manufacturer":"HTC","market_name":"U11","codename":"htc_ocnuhl","model":"HTC U11"},{"manufacturer":"HTC","market_name":"U11","codename":"htc_ocnuhljapan","model":"601HT"},{"manufacturer":"HTC","market_name":"U11","codename":"htc_ocnuhljapan","model":"HTC U11"},{"manufacturer":"HTC","market_name":"U11","codename":"htc_ocnuhljapan","model":"HTV33"},{"manufacturer":"HTC","market_name":"U11","codename":"htc_ocnwhl","model":"2PZC5"},{"manufacturer":"HTC","market_name":"U11","codename":"htc_ocnwhl","model":"HTC U11"},{"manufacturer":"HTC","market_name":"U11 Life","codename":"htc_ocluhljapan","model":"HTC U11 Life"},{"manufacturer":"HTC","market_name":"U11 Life","codename":"htc_ocluhljapan","model":"HTC U11 life"},{"manufacturer":"HTC","market_name":"U12 +","codename":"htc_imedtwl","model":"HTC 2Q55300"},{"manufacturer":"HTC","market_name":"U12+","codename":"htc_imedugl","model":"HTC 2Q551"},{"manufacturer":"HTC","market_name":"U12+","codename":"htc_imedugl","model":"HTC 2Q551+"},{"manufacturer":"HTC","market_name":"U12+","codename":"htc_imedugl","model":"HTC 2Q55100"},{"manufacturer":"HTC","market_name":"U12+","codename":"htc_imedugl","model":"HTC U12+"},{"manufacturer":"HTC","market_name":"U12+","codename":"htc_imeuhl","model":"HTC 2Q552"},{"manufacturer":"HTC","market_name":"U12+","codename":"htc_imeuhl","model":"HTC U12+"},{"manufacturer":"HTC","market_name":"Velocity 4G","codename":"holiday","model":"HTC PH39100"},{"manufacturer":"HTC","market_name":"Velocity 4G","codename":"holiday","model":"HTC Raider X710e"},{"manufacturer":"HTC","market_name":"Velocity 4G","codename":"holiday","model":"HTC Velocity 4G"},{"manufacturer":"HTC","market_name":"Velocity 4G","codename":"holiday","model":"HTC Velocity 4G X710s"},{"manufacturer":"HTC","market_name":"Velocity 4G","codename":"holiday","model":"HTC-X710a"},{"manufacturer":"HTC","market_name":"WF5w","codename":"htc_a50bml","model":"HTC WF5w"},{"manufacturer":"HTC","market_name":"Wildfire","codename":"buzz","model":"HTC Wildfire"},{"manufacturer":"HTC","market_name":"Wildfire CDMA","codename":"bee","model":"HTC Bee"},{"manufacturer":"HTC","market_name":"Wildfire CDMA","codename":"bee","model":"HTC Wildfire"},{"manufacturer":"HTC","market_name":"Wildfire S","codename":"marvel","model":"HTC Wildfire S"},{"manufacturer":"HTC","market_name":"Wildfire S","codename":"marvel","model":"HTC Wildfire S A510b"},{"manufacturer":"HTC","market_name":"Wildfire S","codename":"marvel","model":"HTC Wildfire S A510e"},{"manufacturer":"HTC","market_name":"Wildfire S","codename":"marvel","model":"HTC-A510a"},{"manufacturer":"HTC","market_name":"Wildfire S A515c","codename":"marvelc","model":"HTC Wildfire S A515c"},{"manufacturer":"HTC","market_name":"Wildfire S A515c","codename":"marvelc","model":"HTC-PG762"},{"manufacturer":"HTC","market_name":"Wildfire S A515c","codename":"marvelc","model":"USCCADR6230US"},{"manufacturer":"HTC","market_name":"X2-HT","codename":"htc_ocla1_sprout","model":"X2-HT"},{"manufacturer":"HTC","market_name":"breeze","codename":"htc_breeze_dugl","model":"HTC 2Q5V1"},{"manufacturer":"HTC","market_name":"breeze","codename":"htc_breeze_dugl","model":"HTC Desire 12"},{"manufacturer":"HTC","market_name":"desire 400 dual sim","codename":"cp2dug","model":"HTC Desire 400 dual sim"},{"manufacturer":"HTC","market_name":"desire 608t","codename":"cp3dtg","model":"HTC 608t"},{"manufacturer":"HTC","market_name":"desire 610","codename":"htc_a3qhdul","model":"HTC Desire 610"},{"manufacturer":"HTC","market_name":"desire x","codename":"protou","model":"HTC Desire X"},{"manufacturer":"HTC","market_name":"first","codename":"mystul","model":"HTC first"},{"manufacturer":"HTC","market_name":"myTouch 3G","codename":"sapphire","model":"HTC Magic"},{"manufacturer":"HTC","market_name":"myTouch 3G","codename":"sapphire","model":"T-Mobile myTouch 3G"},{"manufacturer":"HTC","market_name":"myTouch 3G Slide","codename":"espresso","model":"T-Mobile myTouch 3G Slide"},{"manufacturer":"HTC","market_name":"myTouch 4G","codename":"glacier","model":"HTC Glacier"},{"manufacturer":"HTC","market_name":"myTouch 4G","codename":"glacier","model":"HTC Panache"},{"manufacturer":"HTC","market_name":"myTouch 4G Slide","codename":"doubleshot","model":"myTouch_4G_Slide"},{"manufacturer":"HYUNDAI_MAESTRO","market_name":"HDT-9421G","codename":"HDT-9421G","model":"HDT-9421G"},{"manufacturer":"HYUNDAI_MAESTRO","market_name":"HDT-9433X","codename":"HDT-9433X","model":"HDT-9433X"},{"manufacturer":"HYUNDAI_MAESTRO","market_name":"HDT-A421GU","codename":"HDT-A421GU","model":"HDT-A421GU"},{"manufacturer":"HYUNDAI_MAESTRO","market_name":"HDT-A435G4","codename":"HDT_A435G4","model":"HDT-A435G4"},{"manufacturer":"HYUNDAI_MAESTRO","market_name":"HDT_1064GS","codename":"HDT_1064GS","model":"HDT_1064GS"},{"manufacturer":"HYUNDAI_MAESTRO","market_name":"HDT_7427G","codename":"HDT_7427G","model":"HDT_7427G"},{"manufacturer":"HYUNDAI_MAESTRO","market_name":"HDT_7427G_PLUS","codename":"HDT_7427G_PLUS","model":"HDT_7427G_PLUS"},{"manufacturer":"HYUNDAI_MAESTRO","market_name":"HDT_7433H_PLUS","codename":"HDT_7433H_PLUS","model":"HDT_7433H_PLUS"},{"manufacturer":"Hafury","market_name":"HAFURY MIX","codename":"HAFURY_MIX","model":"HAFURY MIX"},{"manufacturer":"Hafury","market_name":"HAFURY UMAX","codename":"HAFURY_UMAX","model":"HAFURY UMAX"},{"manufacturer":"Haier","market_name":"A-TT00","codename":"A-TT00","model":"A-TT00"},{"manufacturer":"Haier","market_name":"A36C5H","codename":"A36C5H","model":"Andromax A36C5H"},{"manufacturer":"Haier","market_name":"A42P","codename":"A42P","model":"Haier A42P"},{"manufacturer":"Haier","market_name":"AD6B1H","codename":"AD6B1H","model":"Smartfren Andromax AD6B1H"},{"manufacturer":"Haier","market_name":"AL40","codename":"AL40","model":"Haier_AL40"},{"manufacturer":"Haier","market_name":"AP54","codename":"ts18_ap54_kliver","model":"AP54"},{"manufacturer":"Haier","market_name":"AT7003","codename":"AT7003","model":"AT7003"},{"manufacturer":"Haier","market_name":"Beeline Smart 3","codename":"Beeline_Smart3","model":"Beeline Smart 3"},{"manufacturer":"Haier","market_name":"C46B2H","codename":"C46B2H","model":"Andromax C46B2H"},{"manufacturer":"Haier","market_name":"CDP7TAB4C8","codename":"CDP7TAB4C8","model":"CDP7TAB4C8"},{"manufacturer":"Haier","market_name":"CDP8TAB16SD","codename":"CDP8TAB16SD","model":"CDP8TAB16SD"},{"manufacturer":"Haier","market_name":"CEDTAB70616W8","codename":"CEDTAB70616W8","model":"CEDTAB70616W8"},{"manufacturer":"Haier","market_name":"CETAB10KML9","codename":"CETAB10KML9","model":"CETAB10KML9"},{"manufacturer":"Haier","market_name":"CETAB7ML9","codename":"CETAB7ML9","model":"CETAB7ML9"},{"manufacturer":"Haier","market_name":"CETAB9ML9","codename":"CETAB9ML9","model":"CETAB9ML9"},{"manufacturer":"Haier","market_name":"CMP_765","codename":"CMP_765","model":"CMP_765"},{"manufacturer":"Haier","market_name":"CT1030","codename":"CT1030","model":"CT1030"},{"manufacturer":"Haier","market_name":"CT301_W818","codename":"msm7627a","model":"CT301_W818"},{"manufacturer":"Haier","market_name":"CT825","codename":"fiber-a31stm","model":"CT825"},{"manufacturer":"Haier","market_name":"CYCLONE_ODYSSEY","codename":"CYCLONE_ODYSSEY","model":"CYCLONE_ODYSSEY"},{"manufacturer":"Haier","market_name":"D2-721","codename":"D2-721G","model":"D2-721G"},{"manufacturer":"Haier","market_name":"D2-751G","codename":"d2PAD","model":"D2-751G"},{"manufacturer":"Haier","market_name":"D2-927G","codename":"D2-927G","model":"D2-927G"},{"manufacturer":"Haier","market_name":"D2-961G","codename":"D2-961G","model":"D2-961G"},{"manufacturer":"Haier","market_name":"Fast","codename":"HM-G551-FL","model":"Beeline Fast"},{"manufacturer":"Haier","market_name":"G21","codename":"HM-G303-W","model":"G21"},{"manufacturer":"Haier","market_name":"G30","codename":"G30","model":"G30"},{"manufacturer":"Haier","market_name":"G31s","codename":"G31s","model":"G31s"},{"manufacturer":"Haier","market_name":"G40","codename":"G40","model":"G40"},{"manufacturer":"Haier","market_name":"G50","codename":"HM-G551-FL","model":"G50"},{"manufacturer":"Haier","market_name":"G51","codename":"HM-G553-FL","model":"HM-G553-FL"},{"manufacturer":"Haier","market_name":"G55","codename":"G55","model":"G55"},{"manufacturer":"Haier","market_name":"G7","codename":"HM-G552-FL","model":"G7"},{"manufacturer":"Haier","market_name":"G7","codename":"HM-G552-FL","model":"HM-G552-FL"},{"manufacturer":"Haier","market_name":"G700","codename":"G700","model":"G700"},{"manufacturer":"Haier","market_name":"G7s","codename":"G7s","model":"G7s"},{"manufacturer":"Haier","market_name":"GF88","codename":"I7A-LE","model":"I7A-LE"},{"manufacturer":"Haier","market_name":"HG-9041","codename":"HG-9041","model":"HG-9041"},{"manufacturer":"Haier","market_name":"HM-I557-FL","codename":"HM-I557-FL","model":"HM-I557-FL"},{"manufacturer":"Haier","market_name":"HM-N501-FL","codename":"HM-N501-FL","model":"HM-N501-FL"},{"manufacturer":"Haier","market_name":"HS-10DTB4","codename":"HS-10DTB4","model":"HS-10DTB4"},{"manufacturer":"Haier","market_name":"HS-7DTB25","codename":"HS-7DTB25","model":"HS-7DTB25"},{"manufacturer":"Haier","market_name":"HS-7DTB29-8GB","codename":"HS-7DTB29-8GB","model":"HS-7DTB29-8GB"},{"manufacturer":"Haier","market_name":"HS-9DTB37","codename":"HS_9DTB37","model":"HS_9DTB37"},{"manufacturer":"Haier","market_name":"HT-I860","codename":"HT-I860","model":"HT-I860"},{"manufacturer":"Haier","market_name":"HW-I509-W","codename":"HM-I509-W","model":"FORZA"},{"manufacturer":"Haier","market_name":"Haier","codename":"Homesurf744","model":"Binatone Homesurf744 / Hubble Smart7 (Homesurf744)"},{"manufacturer":"Haier","market_name":"Haier","codename":"PAD69H","model":"PAD69H"},{"manufacturer":"Haier","market_name":"Haier","codename":"PAD_D85","model":"pad_d85"},{"manufacturer":"Haier","market_name":"Haier","codename":"W627","model":"W627"},{"manufacturer":"Haier","market_name":"Haier","codename":"W861","model":"W861"},{"manufacturer":"Haier","market_name":"Haier Leisure L7","codename":"Haier_Leisure_L7","model":"HM-N700-FL"},{"manufacturer":"Haier","market_name":"HaierG61","codename":"HM-G701-FL","model":"HM-G701-FL"},{"manufacturer":"Haier","market_name":"HomeSurf742_AT7003","codename":"HomeSurf742_AT7003","model":"HomeSurf742_AT7003"},{"manufacturer":"Haier","market_name":"Homesurf844","codename":"Homesurf844","model":"Binatone Homesurf844 / Hubble Smart8 (Homesurf844)"},{"manufacturer":"Haier","market_name":"Hyasong T1","codename":"HyasongT1","model":"HyasongT1"},{"manufacturer":"Haier","market_name":"I50","codename":"i50_b1b8","model":"I50"},{"manufacturer":"Haier","market_name":"INGO-TAB","codename":"INGO-TAB","model":"INGO-TAB"},{"manufacturer":"Haier","market_name":"Kogan Agora 8","codename":"Kogan_Agora_8","model":"Kogan Agora 8"},{"manufacturer":"Haier","market_name":"Konnect_350","codename":"Konnect_350","model":"Konnect_350"},{"manufacturer":"Haier","market_name":"L11","codename":"HM-G152-FL","model":"HM-G152-FL"},{"manufacturer":"Haier","market_name":"L50","codename":"M916-D500-PAK","model":"L50"},{"manufacturer":"Haier","market_name":"L52","codename":"Haier_L52","model":"L52"},{"manufacturer":"Haier","market_name":"LE32U5000A","codename":"LE32U5000A","model":"LE32U5000A"},{"manufacturer":"Haier","market_name":"LE39M7000CF","codename":"LE39M7000CF","model":"LE39M7000CF"},{"manufacturer":"Haier","market_name":"LE40U5000A","codename":"LE40U5000A","model":"LE40U5000A"},{"manufacturer":"Haier","market_name":"LE43B7600A","codename":"LE43B7600A","model":"LE43B7600A"},{"manufacturer":"Haier","market_name":"LE43U5000A","codename":"LE43U5000A","model":"LE43U5000A"},{"manufacturer":"Haier","market_name":"LE48M7000CF","codename":"LE48M7000CF","model":"LE48M7000CF"},{"manufacturer":"Haier","market_name":"LE49U5000A","codename":"LE49U5000A","model":"LE49U5000A"},{"manufacturer":"Haier","market_name":"LE55M7000CF","codename":"LE55M7000CF","model":"LE55M7000CF"},{"manufacturer":"Haier","market_name":"Logicom S9782","codename":"Logicom-S9782","model":"Logicom-S9782"},{"manufacturer":"Haier","market_name":"M7808","codename":"M7808","model":"M7808"},{"manufacturer":"Haier","market_name":"MD-01P","codename":"MD-01P","model":"MD-01P"},{"manufacturer":"Haier","market_name":"MD210","codename":"MD210","model":"MD210"},{"manufacturer":"Haier","market_name":"MEGAFON MS3A","codename":"Megafon","model":"MS3A"},{"manufacturer":"Haier","market_name":"MT-700","codename":"MT-700","model":"MT-700"},{"manufacturer":"Haier","market_name":"MXG308","codename":"MXG308","model":"MXG308"},{"manufacturer":"Haier","market_name":"MXG408","codename":"MXG408","model":"MXG408"},{"manufacturer":"Haier","market_name":"NEO10-1","codename":"NEO10-1","model":"NEO10-1"},{"manufacturer":"Haier","market_name":"NEO7-1","codename":"NEO7-1","model":"NEO7-1"},{"manufacturer":"Haier","market_name":"NEO7-2","codename":"NEO7-2","model":"NEO7-2"},{"manufacturer":"Haier","market_name":"NEO8-1","codename":"NEO8-1","model":"NEO8-1"},{"manufacturer":"Haier","market_name":"P2","codename":"P2","model":"P2"},{"manufacturer":"Haier","market_name":"PAD1021","codename":"PAD1021","model":"PAD1021"},{"manufacturer":"Haier","market_name":"PAD1042","codename":"PAD1042","model":"PAD1042"},{"manufacturer":"Haier","market_name":"PAD712","codename":"PAD712","model":"PAD712"},{"manufacturer":"Haier","market_name":"PAD722","codename":"PAD722","model":"PAD722"},{"manufacturer":"Haier","market_name":"PAD841","codename":"PAD841","model":"PAD841"},{"manufacturer":"Haier","market_name":"PADCT1010W","codename":"PADCT1010W","model":"PADCT1010W"},{"manufacturer":"Haier","market_name":"PAD_1042","codename":"PAD_1042","model":"PAD_1042"},{"manufacturer":"Haier","market_name":"PNDPP410GP","codename":"PNDPP410GP","model":"PNDPP410GP"},{"manufacturer":"Haier","market_name":"PNDPP44Q7GPBLK","codename":"PNDPP44Q7GPBLK","model":"PNDPP44Q7GPBLK"},{"manufacturer":"Haier","market_name":"PNDPP47GP","codename":"PNDPP47GP","model":"PNDPP47GP"},{"manufacturer":"Haier","market_name":"SP-5100","codename":"SP-5100","model":"SP-5100"},{"manufacturer":"Haier","market_name":"Skill","codename":"Skill","model":"Skill"},{"manufacturer":"Haier","market_name":"Smartfren Andromax AD681H","codename":"AD681H","model":"Smartfren Andromax AD681H"},{"manufacturer":"Haier","market_name":"Smartfren Andromax AD9A1H","codename":"AD9A1H","model":"Smartfren Andromax AD9A1H"},{"manufacturer":"Haier","market_name":"StarQ_Q5002","codename":"StarQ_Q5002","model":"Q5002"},{"manufacturer":"Haier","market_name":"T50","codename":"Haier_T50","model":"Haier T50"},{"manufacturer":"Haier","market_name":"T52P","codename":"T52P","model":"Haier T52P"},{"manufacturer":"Haier","market_name":"T54P","codename":"Haier_T54P","model":"Haier T54P"},{"manufacturer":"Haier","market_name":"T785B","codename":"T785B","model":"T785B"},{"manufacturer":"Haier","market_name":"TAB-700","codename":"TAB_700","model":"TAB-700"},{"manufacturer":"Haier","market_name":"TAB-700","codename":"TAB_700","model":"TAB700MPG"},{"manufacturer":"Haier","market_name":"TMK27A2","codename":"TMK27A2","model":"TMK27A2"},{"manufacturer":"Haier","market_name":"V3","codename":"V3","model":"V3"},{"manufacturer":"Haier","market_name":"Voyage V6","codename":"HM-V6","model":"HM-V6"},{"manufacturer":"Haier","market_name":"W717","codename":"W717","model":"W717"},{"manufacturer":"Haier","market_name":"W757","codename":"W757","model":"W757"},{"manufacturer":"Haier","market_name":"W860","codename":"W860","model":"W860"},{"manufacturer":"Haier","market_name":"haier lesure L7","codename":"Haier_Leisure_L7","model":"HM-N700-FL"},{"manufacturer":"Haier","market_name":"i50","codename":"i50","model":"Haier_i50"},{"manufacturer":"Handheld Group","market_name":"Algiz RT7","codename":"algizRT7","model":"Algiz RT7"},{"manufacturer":"Handheld Group","market_name":"HandHeld NAUTIZ X2","codename":"NAUTIZ_X2","model":"NAUTIZ_X2"},{"manufacturer":"Handheld Group","market_name":"Nautiz_X2","codename":"NAUTIZ_X2","model":"NAUTIZ_X2"},{"manufacturer":"Handheld Group","market_name":"Nautiz_X9","codename":"Nautiz_X9","model":"Nautiz_X9"},{"manufacturer":"HannSpree","market_name":"HSG1279","codename":"HANNSpad","model":"HSG1279"},{"manufacturer":"HannSpree","market_name":"HSG1341","codename":"mid1024_e","model":"HSG1341"},{"manufacturer":"HannSpree","market_name":"HSG1351","codename":"rk3368_32","model":"HSG1351"},{"manufacturer":"HannSpree","market_name":"HSG1360","codename":"HANNSPAD","model":"HSG1360"},{"manufacturer":"HannSpree","market_name":"HSG1376","codename":"HSG1376_MT8163","model":"HSG1376"},{"manufacturer":"Harris","market_name":"12131-1000","codename":"msm8660_cougar","model":"Harris 12131-1000"},{"manufacturer":"Harris","market_name":"LMC-1000","codename":"granite","model":"LMC-1000"},{"manufacturer":"Harris","market_name":"RF-3590-RT","codename":"msm8660_cougar","model":"Harris 12131-1000"},{"manufacturer":"Haus","market_name":"HAUS JS408","codename":"HAUS_JS408","model":"HAUS JS408"},{"manufacturer":"Haus","market_name":"JS550","codename":"JS550","model":"JS550"},{"manufacturer":"Helio","market_name":"S10","codename":"S10","model":"S10"},{"manufacturer":"Helio","market_name":"S2","codename":"WBL7519SY","model":"S2"},{"manufacturer":"Helio","market_name":"S25","codename":"HelioS25","model":"S25"},{"manufacturer":"Hercls","market_name":"HERCLS L925","codename":"L925","model":"L925"},{"manufacturer":"HighScreen","market_name":"Bay","codename":"Bay","model":"Bay"},{"manufacturer":"HighScreen","market_name":"Easy Power","codename":"Easy-Power","model":"Easy-Power"},{"manufacturer":"HighScreen","market_name":"Easy Power Pro","codename":"Easy-Power-Pro","model":"Easy-Power-Pro"},{"manufacturer":"HighScreen","market_name":"Easy XL","codename":"Easy_XL","model":"Easy_XL"},{"manufacturer":"HighScreen","market_name":"Easy XL Pro","codename":"Easy_XL_Pro","model":"Easy_XL_Pro"},{"manufacturer":"HighScreen","market_name":"Expanse","codename":"Expanse","model":"Expanse"},{"manufacturer":"HighScreen","market_name":"Fest","codename":"Fest","model":"Fest"},{"manufacturer":"HighScreen","market_name":"Fest XL","codename":"FestXL","model":"FestXL"},{"manufacturer":"HighScreen","market_name":"Fest XL PRO","codename":"FestXL-Pro","model":"FestXL-Pro"},{"manufacturer":"HighScreen","market_name":"K2050 C1 Fest Pro","codename":"Fest-Pro","model":"Fest-Pro"},{"manufacturer":"HighScreen","market_name":"Power Five","codename":"PowerFive","model":"PowerFive"},{"manufacturer":"HighScreen","market_name":"Power Four","codename":"PowerFour","model":"PowerFour"},{"manufacturer":"HighScreen","market_name":"Power Ice","codename":"BBL7353RV","model":"Power Ice"},{"manufacturer":"HighScreen","market_name":"Power Ice EVO","codename":"PowerIceEvo","model":"Power Ice Evo"},{"manufacturer":"HighScreen","market_name":"Power Rage","codename":"PowerRage","model":"Power Rage"},{"manufacturer":"HighScreen","market_name":"PowerIceMax","codename":"PowerIceMax","model":"Power Ice Max"},{"manufacturer":"HighScreen","market_name":"PowerRageEvo","codename":"PowerRageEvo","model":"Power Rage Evo"},{"manufacturer":"HighScreen","market_name":"Prime L","codename":"PrimeL","model":"Prime L"},{"manufacturer":"HighScreen","market_name":"Tasty","codename":"Tasty","model":"Tasty"},{"manufacturer":"Himax","market_name":"M21","codename":"M21","model":"M21"},{"manufacturer":"Hipstreet","market_name":"785TB4","codename":"785TB4","model":"785TB4"},{"manufacturer":"Hipstreet","market_name":"7DTB25","codename":"7DTB25","model":"7DTB25"},{"manufacturer":"Hipstreet","market_name":"7DTB37","codename":"7DTB37","model":"7DTB37"},{"manufacturer":"Hipstreet","market_name":"9DTB38","codename":"9DTB38","model":"9DTB38"},{"manufacturer":"Hipstreet","market_name":"9DTB39","codename":"9DTB39","model":"9DTB39"},{"manufacturer":"Hipstreet","market_name":"Beeline Smart 4","codename":"Beeline_Smart_4","model":"Beeline Smart 4"},{"manufacturer":"Hipstreet","market_name":"Beeline Smart 5","codename":"Beeline_Smart_5","model":"Beeline Smart 5"},{"manufacturer":"Hipstreet","market_name":"CP-VL5A","codename":"CP-VL5A","model":"CP-VL5A"},{"manufacturer":"Hipstreet","market_name":"ETAB_M7023G","codename":"ETAB_M7023G","model":"ETAB_M7023G"},{"manufacturer":"Hipstreet","market_name":"Electron","codename":"8DTB38","model":"8DTB38"},{"manufacturer":"Hipstreet","market_name":"Electron 2","codename":"8DTB40","model":"8DTB40"},{"manufacturer":"Hipstreet","market_name":"F100","codename":"f100_65u","model":"f100_65u"},{"manufacturer":"Hipstreet","market_name":"HS-10DTB12","codename":"Hipstreet","model":"HS-10DTB12"},{"manufacturer":"Hipstreet","market_name":"HS-10DTB12A","codename":"10DTB12A","model":"10DTB12A"},{"manufacturer":"Hipstreet","market_name":"HS-10DTB12A","codename":"RCT6203W46","model":"HS_10DTB12A"},{"manufacturer":"Hipstreet","market_name":"HS-10DTB41","codename":"HS-10DTB41-8GB","model":"HS-10DTB41-8GB"},{"manufacturer":"Hipstreet","market_name":"HS-10DTB8","codename":"HS-10DTB8","model":"HS-10DTB8"},{"manufacturer":"Hipstreet","market_name":"HS-7DTB27","codename":"HS-7DTB27","model":"HS-7DTB27"},{"manufacturer":"Hipstreet","market_name":"HS-7DTB35","codename":"HS-7DTB35","model":"HS-7DTB35"},{"manufacturer":"Hipstreet","market_name":"HS-7DTB35","codename":"RCT6773W22","model":"HS_7DTB35"},{"manufacturer":"Hipstreet","market_name":"HS-7DTB39","codename":"HS-7DTB39","model":"HS-7DTB39"},{"manufacturer":"Hipstreet","market_name":"HS-7DTB40","codename":"HS-7DTB40-8GB","model":"HS-7DTB40-8GB"},{"manufacturer":"Hipstreet","market_name":"HS-9DTB7A","codename":"HS-9DTB7A","model":"HS-9DTB7A"},{"manufacturer":"Hipstreet","market_name":"Joey Jet 2","codename":"Joey_Jet_2","model":"Dtac phone Joey Jet 2"},{"manufacturer":"Hipstreet","market_name":"LS-4004","codename":"LS-4004","model":"LS-4004"},{"manufacturer":"Hipstreet","market_name":"LS-5013","codename":"LS-5013","model":"LS-5013"},{"manufacturer":"Hipstreet","market_name":"LS-5017","codename":"LS-5017","model":"LS-5017"},{"manufacturer":"Hipstreet","market_name":"LS-5507","codename":"LYF_LS_5507","model":"LS-5507"},{"manufacturer":"Hipstreet","market_name":"LS-6001","codename":"LS-6001","model":"LS-6001"},{"manufacturer":"Hipstreet","market_name":"Micron","codename":"7DTB41","model":"7DTB41"},{"manufacturer":"Hipstreet","market_name":"Nanho T775","codename":"Nanho_T775","model":"Nanho_T775"},{"manufacturer":"Hipstreet","market_name":"Phantom","codename":"Phantom","model":"10DTB10"},{"manufacturer":"Hipstreet","market_name":"Phantom2","codename":"10DTB44","model":"10DTB44"},{"manufacturer":"Hipstreet","market_name":"Phoenix2","codename":"Phoenix2","model":"Phoenix2"},{"manufacturer":"Hipstreet","market_name":"Pilot","codename":"10DTB42","model":"10DTB42"},{"manufacturer":"Hipstreet","market_name":"Synergy","codename":"11DTB1","model":"11DTB1"},{"manufacturer":"Hipstreet","market_name":"Yupiroid","codename":"Yupiroid","model":"Yupiroid"},{"manufacturer":"Hisense","market_name":"","codename":"AD683G","model":"AD683G"},{"manufacturer":"Hisense","market_name":"","codename":"AD685G","model":"New Andromax-i"},{"manufacturer":"Hisense","market_name":"","codename":"E820","model":"HS-E820"},{"manufacturer":"Hisense","market_name":"","codename":"E910","model":"E910"},{"manufacturer":"Hisense","market_name":"","codename":"E910","model":"HS-E910"},{"manufacturer":"Hisense","market_name":"","codename":"E912","model":"HS-E912"},{"manufacturer":"Hisense","market_name":"","codename":"E912S","model":"HS-E912S"},{"manufacturer":"Hisense","market_name":"","codename":"E920","model":"HS-E920"},{"manufacturer":"Hisense","market_name":"","codename":"E926","model":"E926"},{"manufacturer":"Hisense","market_name":"","codename":"E930","model":"HS-E930"},{"manufacturer":"Hisense","market_name":"","codename":"E956","model":"HS-E956"},{"manufacturer":"Hisense","market_name":"","codename":"E956Q","model":"HS-E956Q"},{"manufacturer":"Hisense","market_name":"","codename":"EG870","model":"HS-EG870"},{"manufacturer":"Hisense","market_name":"","codename":"EG876","model":"HS-EG876"},{"manufacturer":"Hisense","market_name":"","codename":"EG901","model":"HS-EG901"},{"manufacturer":"Hisense","market_name":"","codename":"EG909","model":"HS-EG909"},{"manufacturer":"Hisense","market_name":"","codename":"EG950","model":"HS-EG950"},{"manufacturer":"Hisense","market_name":"","codename":"EG970","model":"HS-EG970"},{"manufacturer":"Hisense","market_name":"","codename":"P4013","model":"MEDION-P4013"},{"manufacturer":"Hisense","market_name":"","codename":"SIMPlus","model":"MegaFon SIM+"},{"manufacturer":"Hisense","market_name":"","codename":"T818","model":"HS-T818"},{"manufacturer":"Hisense","market_name":"","codename":"TP9101","model":"HS-M170AT"},{"manufacturer":"Hisense","market_name":"","codename":"TP9102","model":"M1101AT"},{"manufacturer":"Hisense","market_name":"","codename":"U2","model":"U2"},{"manufacturer":"Hisense","market_name":"","codename":"U8","model":"HS-U8"},{"manufacturer":"Hisense","market_name":"","codename":"U820","model":"HS-U820"},{"manufacturer":"Hisense","market_name":"","codename":"U820A","model":"HS-U820"},{"manufacturer":"Hisense","market_name":"","codename":"U820A","model":"U1+"},{"manufacturer":"Hisense","market_name":"","codename":"U820AVN","model":"HS-U820"},{"manufacturer":"Hisense","market_name":"","codename":"U860","model":"HS-U860"},{"manufacturer":"Hisense","market_name":"","codename":"U909","model":"HS-U909"},{"manufacturer":"Hisense","market_name":"","codename":"U909B","model":"HS-U909B"},{"manufacturer":"Hisense","market_name":"","codename":"U909B_6","model":"HS-U909"},{"manufacturer":"Hisense","market_name":"","codename":"U909B_MN","model":"U2S"},{"manufacturer":"Hisense","market_name":"","codename":"U912","model":"HS-U912"},{"manufacturer":"Hisense","market_name":"","codename":"U950","model":"HS-U950"},{"manufacturer":"Hisense","market_name":"","codename":"U950_6","model":"HS-U950"},{"manufacturer":"Hisense","market_name":"","codename":"U950_MN","model":"U3"},{"manufacturer":"Hisense","market_name":"","codename":"U950_ae","model":"HS-U950"},{"manufacturer":"Hisense","market_name":"","codename":"U958","model":"HS-U958"},{"manufacturer":"Hisense","market_name":"","codename":"U960Q","model":"HS-U960Q"},{"manufacturer":"Hisense","market_name":"","codename":"W2400","model":"W2400"},{"manufacturer":"Hisense","market_name":"","codename":"m3101","model":"M3101BW"},{"manufacturer":"Hisense","market_name":"","codename":"m370","model":"M370BW"},{"manufacturer":"Hisense","market_name":"","codename":"t909","model":"HS-T909"},{"manufacturer":"Hisense","market_name":"","codename":"t950","model":"HS-T950"},{"manufacturer":"Hisense","market_name":"","codename":"t958","model":"HS-T958"},{"manufacturer":"Hisense","market_name":"","codename":"t960","model":"HS-T960"},{"manufacturer":"Hisense","market_name":"55H6SG","codename":"Vision","model":"Vision"},{"manufacturer":"Hisense","market_name":"A2","codename":"HS8937QC","model":"Hisense A2"},{"manufacturer":"Hisense","market_name":"A2M","codename":"HS8953QC","model":"Hisense A2M"},{"manufacturer":"Hisense","market_name":"A2T","codename":"HS8953QC","model":"Hisense A2T"},{"manufacturer":"Hisense","market_name":"AGM  X2","codename":"HS8976QC","model":"AGM X2"},{"manufacturer":"Hisense","market_name":"AGM  X2","codename":"HS8976QC","model":"X2 SE"},{"manufacturer":"Hisense","market_name":"AGM  X2","codename":"HS8976QC","model":"X2_SE"},{"manufacturer":"Hisense","market_name":"AGM A7","codename":"HS8909QC","model":"AGM A7"},{"manufacturer":"Hisense","market_name":"AGM X1","codename":"HS8952QC","model":"AGM X1"},{"manufacturer":"Hisense","market_name":"AJM X2","codename":"HS8976QC","model":"AGM X2"},{"manufacturer":"Hisense","market_name":"Andromax-c","codename":"AD686G","model":"Andromax-c"},{"manufacturer":"Hisense","market_name":"C-4","codename":"C_4","model":"C-4"},{"manufacturer":"Hisense","market_name":"C1","codename":"HS8929QC","model":"Hisense C1"},{"manufacturer":"Hisense","market_name":"C1AE","codename":"HS8929QC","model":"Hisense C1"},{"manufacturer":"Hisense","market_name":"C1AE-1","codename":"HS8929QC","model":"Hisense C1"},{"manufacturer":"Hisense","market_name":"C1AE-2","codename":"HS8929QC","model":"Hisense C1"},{"manufacturer":"Hisense","market_name":"C1BE","codename":"HS8929QC","model":"Hisense C1"},{"manufacturer":"Hisense","market_name":"C1M","codename":"HS8929QC","model":"Hisense C1M"},{"manufacturer":"Hisense","market_name":"C1T","codename":"HS8929QC","model":"Hisense C1T"},{"manufacturer":"Hisense","market_name":"C20F","codename":"HS8929QC","model":"Hisense C20"},{"manufacturer":"Hisense","market_name":"C20FE-1","codename":"HS8929QC","model":"Hisense C20"},{"manufacturer":"Hisense","market_name":"C20S","codename":"C20S","model":"Hisense C20S"},{"manufacturer":"Hisense","market_name":"C20W","codename":"HS8929QC","model":"Hisense C20"},{"manufacturer":"Hisense","market_name":"C30","codename":"HS8937QC","model":"Hisense C30"},{"manufacturer":"Hisense","market_name":"C30","codename":"HS8937QC","model":"Hisense C30_02"},{"manufacturer":"Hisense","market_name":"C30 Lite","codename":"HS6737MT","model":"Hisense C30 Lite"},{"manufacturer":"Hisense","market_name":"C30 Lite","codename":"HS6737MT","model":"STARACTIVE 2"},{"manufacturer":"Hisense","market_name":"C30 Lite","codename":"HS6737MT","model":"SX40"},{"manufacturer":"Hisense","market_name":"CMB405","codename":"L690AE","model":"CMB405"},{"manufacturer":"Hisense","market_name":"CMB501","codename":"u970_carrefour","model":"CMB501"},{"manufacturer":"Hisense","market_name":"CMB510","codename":"L696","model":"CMB510"},{"manufacturer":"Hisense","market_name":"D1-M","codename":"D1_M","model":"Hisense D1-M"},{"manufacturer":"Hisense","market_name":"D2-M","codename":"HS6735MT","model":"D2-M"},{"manufacturer":"Hisense","market_name":"D5","codename":"HS8909QC","model":"Hisense D5"},{"manufacturer":"Hisense","market_name":"E10","codename":"HS8909QC","model":"E10"},{"manufacturer":"Hisense","market_name":"E100T","codename":"E100T","model":"Hisense E100T"},{"manufacturer":"Hisense","market_name":"E100TAE","codename":"E100TAE","model":"LT-W1"},{"manufacturer":"Hisense","market_name":"E200T","codename":"E200T","model":"HS-E200T"},{"manufacturer":"Hisense","market_name":"E2070","codename":"mt8312","model":"E2070"},{"manufacturer":"Hisense","market_name":"E20T","codename":"HS8952QC","model":"Hisense E20T"},{"manufacturer":"Hisense","market_name":"E2371CH","codename":"rk3026","model":"E2371CH"},{"manufacturer":"Hisense","market_name":"E260T","codename":"E260T","model":"HS-E260T"},{"manufacturer":"Hisense","market_name":"E260U","codename":"E260U","model":"Hisense E260U"},{"manufacturer":"Hisense","market_name":"E270BSA","codename":"E270BSA","model":"E270BSA"},{"manufacturer":"Hisense","market_name":"E360M","codename":"e360m","model":"Hisense E360M"},{"manufacturer":"Hisense","market_name":"E50-T","codename":"HS8909QC","model":"Hisense E50-T"},{"manufacturer":"Hisense","market_name":"E51-F","codename":"HS8909QC","model":"Hisense E51"},{"manufacturer":"Hisense","market_name":"E51-M","codename":"HS8909QC","model":"Hisense E51-M"},{"manufacturer":"Hisense","market_name":"E51-W","codename":"HS8909QC","model":"Hisense E51"},{"manufacturer":"Hisense","market_name":"E600MH02","codename":"E600MH02","model":"HS-E600M"},{"manufacturer":"Hisense","market_name":"E601M","codename":"E601M","model":"E601M"},{"manufacturer":"Hisense","market_name":"E602T","codename":"E602T","model":"Hisense E602T"},{"manufacturer":"Hisense","market_name":"E613M","codename":"E613M","model":"Hisense E613M"},{"manufacturer":"Hisense","market_name":"E620M","codename":"E602M","model":"Hisense E602M"},{"manufacturer":"Hisense","market_name":"E621T","codename":"E621T","model":"Hisense E621T"},{"manufacturer":"Hisense","market_name":"E622M","codename":"E622M","model":"Hisense E622M"},{"manufacturer":"Hisense","market_name":"E625T","codename":"E625T","model":"Hisense E625T"},{"manufacturer":"Hisense","market_name":"E70-T","codename":"HS8929QC","model":"Hisense E70-T"},{"manufacturer":"Hisense","market_name":"E71-M","codename":"HS8929QC","model":"Hisense E71-M"},{"manufacturer":"Hisense","market_name":"E71-T","codename":"HS8929QC","model":"Hisense E71-T"},{"manufacturer":"Hisense","market_name":"E75M","codename":"HS8929QC","model":"Hisense E75M"},{"manufacturer":"Hisense","market_name":"E75T","codename":"HS8929QC","model":"Hisense E75T"},{"manufacturer":"Hisense","market_name":"E76","codename":"HS8937QC","model":"Hisense E76"},{"manufacturer":"Hisense","market_name":"E76E_11","codename":"HS8937QC","model":"Hisense E76"},{"manufacturer":"Hisense","market_name":"E77M","codename":"HS8937QC","model":"Hisense E77M"},{"manufacturer":"Hisense","market_name":"E77MINI","codename":"HS8937QC","model":"Hisense E77MINI"},{"manufacturer":"Hisense","market_name":"E860","codename":"E860","model":"E860"},{"manufacturer":"Hisense","market_name":"E9","codename":"HS8937QC","model":"Hisense E9"},{"manufacturer":"Hisense","market_name":"EG606","codename":"EG606_TW","model":"EG606"},{"manufacturer":"Hisense","market_name":"EG680","codename":"eg980ae","model":"EG680"},{"manufacturer":"Hisense","market_name":"EG68AE","codename":"EG668AE","model":"LT668"},{"manufacturer":"Hisense","market_name":"EG929","codename":"EG929_TW","model":"EG929"},{"manufacturer":"Hisense","market_name":"EG936D","codename":"EG936D","model":"HS-EG936D"},{"manufacturer":"Hisense","market_name":"EG950","codename":"EG950TW","model":"EG950"},{"manufacturer":"Hisense","market_name":"EG970","codename":"EG970TW","model":"EG970"},{"manufacturer":"Hisense","market_name":"EG978","codename":"EG978","model":"HS-EG978"},{"manufacturer":"Hisense","market_name":"EG98","codename":"EG98","model":"EG98"},{"manufacturer":"Hisense","market_name":"EG98","codename":"EG98TW","model":"EG98"},{"manufacturer":"Hisense","market_name":"EG981","codename":"EG981","model":"HS-EG981"},{"manufacturer":"Hisense","market_name":"F10","codename":"HS6737MT","model":"BM001"},{"manufacturer":"Hisense","market_name":"F10","codename":"HS6737MT","model":"Hisense F10"},{"manufacturer":"Hisense","market_name":"F10","codename":"HS6737MT","model":"Hisense L675 Pro"},{"manufacturer":"Hisense","market_name":"F10","codename":"HS6737MT","model":"RIVIERA F10"},{"manufacturer":"Hisense","market_name":"F102","codename":"HS6737MT","model":"Hisense F102"},{"manufacturer":"Hisense","market_name":"F102","codename":"HS6737MT","model":"Hisense Hi 3"},{"manufacturer":"Hisense","market_name":"F20","codename":"HS8909QC","model":"F20"},{"manufacturer":"Hisense","market_name":"F20","codename":"HS8909QC","model":"Hisense F20"},{"manufacturer":"Hisense","market_name":"F20T","codename":"HS8909QC","model":"Hisense F20T"},{"manufacturer":"Hisense","market_name":"F21T","codename":"HS8909QC","model":"Hisense F21T"},{"manufacturer":"Hisense","market_name":"F22","codename":"HS6737MT","model":"F22"},{"manufacturer":"Hisense","market_name":"F22","codename":"HS6737MT","model":"Hisense F22"},{"manufacturer":"Hisense","market_name":"F22","codename":"HS8917QC","model":"Hisense F22"},{"manufacturer":"Hisense","market_name":"F22M","codename":"HS8917QC","model":"Hisense F22M"},{"manufacturer":"Hisense","market_name":"F23","codename":"HS6737MT","model":"Hisense F23"},{"manufacturer":"Hisense","market_name":"F23","codename":"HS6737MT","model":"Hisense T203"},{"manufacturer":"Hisense","market_name":"F23","codename":"HS6737MT","model":"RIVIERA F23"},{"manufacturer":"Hisense","market_name":"F23","codename":"HS8917QC","model":"Hisense F23"},{"manufacturer":"Hisense","market_name":"F23M","codename":"HS8917QC","model":"Hisense F23M"},{"manufacturer":"Hisense","market_name":"F270BW","codename":"F270BW","model":"F270BW"},{"manufacturer":"Hisense","market_name":"F30","codename":"HS6735MT","model":"F30"},{"manufacturer":"Hisense","market_name":"F30","codename":"HS6735MT","model":"Hisense F30"},{"manufacturer":"Hisense","market_name":"F31","codename":"HS8937QC","model":"Hisense F31"},{"manufacturer":"Hisense","market_name":"F31E_11","codename":"HS8937QC","model":"Hisense F31"},{"manufacturer":"Hisense","market_name":"F31M","codename":"HS8937QC","model":"Hisense F31M"},{"manufacturer":"Hisense","market_name":"F32","codename":"HS8937QC","model":"Hisense F32"},{"manufacturer":"Hisense","market_name":"F5070","codename":"mt8389","model":"F5070"},{"manufacturer":"Hisense","market_name":"F5180","codename":"f5180","model":"F5180"},{"manufacturer":"Hisense","market_name":"F5281CH","codename":"rk3288","model":"F5281CH"},{"manufacturer":"Hisense","market_name":"G1","codename":"G1","model":"G1"},{"manufacturer":"Hisense","market_name":"G2-3GP","codename":"G2-3GP","model":"G2-3GP"},{"manufacturer":"Hisense","market_name":"G610M","codename":"G610M","model":"Hisense G610M"},{"manufacturer":"Hisense","market_name":"H800T","codename":"H800T","model":"HS-H800T"},{"manufacturer":"Hisense","market_name":"H910","codename":"HS8929QC","model":"Hisense H910"},{"manufacturer":"Hisense","market_name":"H910","codename":"HS8939QC","model":"Hisense H910"},{"manufacturer":"Hisense","market_name":"H910-F01","codename":"HS8939QC","model":"Hisense H910"},{"manufacturer":"Hisense","market_name":"HITV300C","codename":"HS8937QC","model":"HITV300C"},{"manufacturer":"Hisense","market_name":"HLTE100M","codename":"HS9850SC","model":"HLTE100M"},{"manufacturer":"Hisense","market_name":"HLTE200M","codename":"HS8917QC","model":"HLTE200M"},{"manufacturer":"Hisense","market_name":"HLTE200T","codename":"HS8917QC","model":"HLTE200T"},{"manufacturer":"Hisense","market_name":"HLTE212T","codename":"HS8917QC","model":"HLTE212T"},{"manufacturer":"Hisense","market_name":"HLTE300E_ 02","codename":"HS8937QC","model":"HLTE300E"},{"manufacturer":"Hisense","market_name":"HLTE300E_ 02","codename":"HS8937QC","model":"HLTE300E_02"},{"manufacturer":"Hisense","market_name":"HLTE300E_ 02","codename":"HS8937QC","model":"Hisense Infinity H11"},{"manufacturer":"Hisense","market_name":"HLTE300T","codename":"HS8937QC","model":"HLTE300T"},{"manufacturer":"Hisense","market_name":"HLTE500T","codename":"HSSDM630QC","model":"HLTE500T"},{"manufacturer":"Hisense","market_name":"HLTE501N","codename":"HSSDM660QC","model":"HLTE501N"},{"manufacturer":"Hisense","market_name":"HS- G610","codename":"HS8916QC","model":"HS-G610"},{"manufacturer":"Hisense","market_name":"HS- L682","codename":"HS8916QC","model":"HS-L682"},{"manufacturer":"Hisense","market_name":"HS-E600M","codename":"E600M","model":"HS-E600M"},{"manufacturer":"Hisense","market_name":"HS-E620M","codename":"E620M","model":"HS-E620M"},{"manufacturer":"Hisense","market_name":"HS-E917","codename":"E917","model":"HS-E917"},{"manufacturer":"Hisense","market_name":"HS-E936","codename":"E936","model":"HS-E936"},{"manufacturer":"Hisense","market_name":"HS-E968","codename":"E968","model":"HS-E968"},{"manufacturer":"Hisense","market_name":"HS-EG916","codename":"EG916","model":"HS-EG916"},{"manufacturer":"Hisense","market_name":"HS-EG929","codename":"EG929","model":"HS-EG929"},{"manufacturer":"Hisense","market_name":"HS-EG929","codename":"EG929","model":"msm8625"},{"manufacturer":"Hisense","market_name":"HS-EG939","codename":"EG939","model":"HS-EG939"},{"manufacturer":"Hisense","market_name":"HS-EG958","codename":"EG958","model":"HS-EG958"},{"manufacturer":"Hisense","market_name":"HS-EG966","codename":"EG966","model":"HS-EG966"},{"manufacturer":"Hisense","market_name":"HS-EG971","codename":"EG971","model":"HS-EG971"},{"manufacturer":"Hisense","market_name":"HS-EG980","codename":"eg980","model":"HS-EG980"},{"manufacturer":"Hisense","market_name":"HS-EG98C","codename":"EG98C","model":"HS-EG98C"},{"manufacturer":"Hisense","market_name":"HS-G610","codename":"HS8916QC","model":"HS-G610"},{"manufacturer":"Hisense","market_name":"HS-I630M","codename":"msm8226","model":"HS-I630M"},{"manufacturer":"Hisense","market_name":"HS-I630T","codename":"msm8226","model":"HS-I630T"},{"manufacturer":"Hisense","market_name":"HS-T9","codename":"T9","model":"HS-T9"},{"manufacturer":"Hisense","market_name":"HS-T926","codename":"t926","model":"HS-T926"},{"manufacturer":"Hisense","market_name":"HS-T928","codename":"t928","model":"HS-T928"},{"manufacturer":"Hisense","market_name":"HS-T939","codename":"HS-T939","model":"HS-T939"},{"manufacturer":"Hisense","market_name":"HS-T959","codename":"t959","model":"HS-T959"},{"manufacturer":"Hisense","market_name":"HS-T959S","codename":"t959s","model":"HS-T959S"},{"manufacturer":"Hisense","market_name":"HS-T959S1","codename":"t959s1","model":"HS-T959S1"},{"manufacturer":"Hisense","market_name":"HS-T966","codename":"HS-T966","model":"HS-T966"},{"manufacturer":"Hisense","market_name":"HS-T967","codename":"HS-T967","model":"HS-T967"},{"manufacturer":"Hisense","market_name":"HS-T968","codename":"t968","model":"HS-T968"},{"manufacturer":"Hisense","market_name":"HS-T968S","codename":"t968s","model":"HS-T968S"},{"manufacturer":"Hisense","market_name":"HS-T970","codename":"t970","model":"HS-T970"},{"manufacturer":"Hisense","market_name":"HS-T978","codename":"t978","model":"HS-T978"},{"manufacturer":"Hisense","market_name":"HS-T980","codename":"t980","model":"HS-T980"},{"manufacturer":"Hisense","market_name":"HS-U601","codename":"HS7731SP","model":"HS-U601"},{"manufacturer":"Hisense","market_name":"HS-U820","codename":"U820B","model":"HS-U820"},{"manufacturer":"Hisense","market_name":"HS-U9","codename":"U9","model":"HS-U9"},{"manufacturer":"Hisense","market_name":"HS-U912","codename":"U912A_1","model":"HS-U912"},{"manufacturer":"Hisense","market_name":"HS-U912","codename":"U912B","model":"HS-U912"},{"manufacturer":"Hisense","market_name":"HS-U912","codename":"U912C","model":"HS-U912"},{"manufacturer":"Hisense","market_name":"HS-U929","codename":"u929de","model":"HS-U929"},{"manufacturer":"Hisense","market_name":"HS-U929","codename":"u929de_3","model":"HS-U929"},{"manufacturer":"Hisense","market_name":"HS-U936","codename":"U936","model":"HS-U936"},{"manufacturer":"Hisense","market_name":"HS-U939","codename":"u939","model":"HS-U939"},{"manufacturer":"Hisense","market_name":"HS-U939","codename":"u939e_1","model":"HS-U939"},{"manufacturer":"Hisense","market_name":"HS-U939","codename":"u939e_3","model":"HS-U939"},{"manufacturer":"Hisense","market_name":"HS-U939","codename":"u939e_4","model":"HS-U939"},{"manufacturer":"Hisense","market_name":"HS-U939","codename":"u939e_5","model":"HS-U939"},{"manufacturer":"Hisense","market_name":"HS-U950","codename":"U950_5","model":"HS-U950"},{"manufacturer":"Hisense","market_name":"HS-U961","codename":"HS6572MT","model":"HS-U961"},{"manufacturer":"Hisense","market_name":"HS-U961","codename":"u961","model":"HS-U961"},{"manufacturer":"Hisense","market_name":"HS-U961","codename":"u961e_1","model":"HS-U961"},{"manufacturer":"Hisense","market_name":"HS-U966","codename":"u966","model":"HS-U966"},{"manufacturer":"Hisense","market_name":"HS-U966","codename":"u966ae","model":"HS-U966"},{"manufacturer":"Hisense","market_name":"HS-U970","codename":"u970e_6","model":"HS-U970"},{"manufacturer":"Hisense","market_name":"HS-U970","codename":"u970s_export","model":"HS-U970"},{"manufacturer":"Hisense","market_name":"HS-U970E","codename":"u970t","model":"HS-U970E"},{"manufacturer":"Hisense","market_name":"HS-U971","codename":"U971AE","model":"HS-U971"},{"manufacturer":"Hisense","market_name":"HS-U978","codename":"u978","model":"HS-U978"},{"manufacturer":"Hisense","market_name":"HS-U98","codename":"U98","model":"U98"},{"manufacturer":"Hisense","market_name":"HS-U98","codename":"U98_FR","model":"HS-U98"},{"manufacturer":"Hisense","market_name":"HS-U980","codename":"u980","model":"HS-U980"},{"manufacturer":"Hisense","market_name":"HS-U980","codename":"u980b","model":"HS-U980"},{"manufacturer":"Hisense","market_name":"HS-U980","codename":"u980be","model":"HS-U980"},{"manufacturer":"Hisense","market_name":"HS-U980","codename":"u980be_1","model":"HS-U980"},{"manufacturer":"Hisense","market_name":"HS-U980","codename":"u980be_2","model":"HS-U980"},{"manufacturer":"Hisense","market_name":"HS-U980","codename":"u980ce_1","model":"HS-U980"},{"manufacturer":"Hisense","market_name":"HS-U980","codename":"u980ce_3","model":"HS-U980"},{"manufacturer":"Hisense","market_name":"HS-U980","codename":"u980ce_4","model":"HS-U980"},{"manufacturer":"Hisense","market_name":"HS-U980","codename":"u980ce_5","model":"HS-U980"},{"manufacturer":"Hisense","market_name":"HS-X5T","codename":"X5T","model":"HS-X5T"},{"manufacturer":"Hisense","market_name":"HS-X68T","codename":"x68t","model":"HS-X68T"},{"manufacturer":"Hisense","market_name":"HS-X6T","codename":"X6T","model":"HS-X6T"},{"manufacturer":"Hisense","market_name":"HS-X8C","codename":"x8c","model":"HS-X8C"},{"manufacturer":"Hisense","market_name":"HS-X8T","codename":"X8T","model":"HS-X8T"},{"manufacturer":"Hisense","market_name":"HS-X8U","codename":"x8u","model":"HS-X8U"},{"manufacturer":"Hisense","market_name":"Hisense  E7  Pro","codename":"HS6739MT","model":"Hisense E7 Pro"},{"manufacturer":"Hisense","market_name":"Hisense  F17  Pro","codename":"HS6739MT","model":"Hisense F17 Pro"},{"manufacturer":"Hisense","market_name":"Hisense  F23  PLUS","codename":"HS6739MT","model":"Hisense F23 PLUS"},{"manufacturer":"Hisense","market_name":"Hisense  Hi  2","codename":"HS6737MT","model":"Hisense Hi 2"},{"manufacturer":"Hisense","market_name":"Hisense  Infinity  F17","codename":"HS6739MT","model":"Hisense Infinity F17"},{"manufacturer":"Hisense","market_name":"Hisense E76MINIM","codename":"HS8937QC","model":"Hisense E76MINIM"},{"manufacturer":"Hisense","market_name":"Hisense E77","codename":"HS8937QC","model":"Hisense E77"},{"manufacturer":"Hisense","market_name":"Hisense F17","codename":"HS6580MT","model":"Hisense F17"},{"manufacturer":"Hisense","market_name":"Hisense F17","codename":"HS6580MT","model":"Hisense Infinity E7"},{"manufacturer":"Hisense","market_name":"Hisense F24","codename":"HS6737MT","model":"Hisense F24"},{"manufacturer":"Hisense","market_name":"Hisense F8 MINI","codename":"HSSC9850","model":"Hisense F8 MINI"},{"manufacturer":"Hisense","market_name":"Hisense M36","codename":"HS8909QC","model":"Hisense M36"},{"manufacturer":"Hisense","market_name":"Hisense P1","codename":"HS8953QC","model":"Hisense P1"},{"manufacturer":"Hisense","market_name":"Hisense T17","codename":"HS6580MT","model":"Hisense T17"},{"manufacturer":"Hisense","market_name":"Hisense T5","codename":"HS6737MT","model":"Hisense T5"},{"manufacturer":"Hisense","market_name":"Hisense T5 Pro","codename":"HS6737MT","model":"Hisense T5 Pro"},{"manufacturer":"Hisense","market_name":"I300T","codename":"I300T","model":"Hisense I300T"},{"manufacturer":"Hisense","market_name":"I56D2G","codename":"HS8929QC","model":"Andromax I56D2G"},{"manufacturer":"Hisense","market_name":"I630U","codename":"I630U","model":"Hisense I630U"},{"manufacturer":"Hisense","market_name":"I631M","codename":"i631m","model":"Hisense I631M"},{"manufacturer":"Hisense","market_name":"I632M","codename":"I632M","model":"Hisense I632M"},{"manufacturer":"Hisense","market_name":"I632T","codename":"I632T","model":"Hisense I632T"},{"manufacturer":"Hisense","market_name":"I635T","codename":"HS8916QC","model":"Hisense I635T"},{"manufacturer":"Hisense","market_name":"I639M","codename":"I639M","model":"Hisense I639M"},{"manufacturer":"Hisense","market_name":"I639T","codename":"I639T","model":"Hisense I639T"},{"manufacturer":"Hisense","market_name":"I639T","codename":"I639TA","model":"Hisense I639T"},{"manufacturer":"Hisense","market_name":"I639T","codename":"I639TA1","model":"Hisense I639T"},{"manufacturer":"Hisense","market_name":"IRON  2","codename":"HS8937QC","model":"IRON 2"},{"manufacturer":"Hisense","market_name":"K1","codename":"HS8937QC","model":"Hisense K1"},{"manufacturer":"Hisense","market_name":"K220_FHD","codename":"mst628","model":"K220_FHD"},{"manufacturer":"Hisense","market_name":"L635E_1","codename":"HS8916QC","model":"Trekker-M1"},{"manufacturer":"Hisense","market_name":"L671","codename":"HS8929QC","model":"HS-L671"},{"manufacturer":"Hisense","market_name":"L671","codename":"HS8929QC","model":"Hisense L671"},{"manufacturer":"Hisense","market_name":"L671W","codename":"HS8929QC","model":"HS-L671"},{"manufacturer":"Hisense","market_name":"L671W","codename":"HS8929QC","model":"Hisense L671"},{"manufacturer":"Hisense","market_name":"L671WE_1","codename":"HS8929QC","model":"Hisense L671"},{"manufacturer":"Hisense","market_name":"L671WE_2","codename":"HS8929QC","model":"Hisense L671"},{"manufacturer":"Hisense","market_name":"L675","codename":"HS6735MT","model":"Hisense L675"},{"manufacturer":"Hisense","market_name":"L676BE-1","codename":"HS8929QC","model":"Hisense L676"},{"manufacturer":"Hisense","market_name":"L676BE-2","codename":"HS8929QC","model":"Hisense L676"},{"manufacturer":"Hisense","market_name":"L678","codename":"HS8916QC","model":"Hisense L678"},{"manufacturer":"Hisense","market_name":"L681","codename":"HS8916QC","model":"L681"},{"manufacturer":"Hisense","market_name":"L682","codename":"HS8916QC","model":"HS-L682"},{"manufacturer":"Hisense","market_name":"L682","codename":"HS8916QC","model":"Hisense L682"},{"manufacturer":"Hisense","market_name":"L691","codename":"l691","model":"HS-L691"},{"manufacturer":"Hisense","market_name":"L691","codename":"l691e_2","model":"HS-L691"},{"manufacturer":"Hisense","market_name":"L691AE","codename":"msm8226","model":"HS-L691"},{"manufacturer":"Hisense","market_name":"L695","codename":"HS8929QC","model":"HS-L695"},{"manufacturer":"Hisense","market_name":"L695W","codename":"HS8929QC","model":"HS-L695"},{"manufacturer":"Hisense","market_name":"L695W","codename":"HS8929QC","model":"Hisense L695"},{"manufacturer":"Hisense","market_name":"L695WE_2","codename":"HS8929QC","model":"Hisense L695"},{"manufacturer":"Hisense","market_name":"L697","codename":"HS8952QC","model":"L697"},{"manufacturer":"Hisense","market_name":"L730","codename":"HS8937QC","model":"STARADDICT 6"},{"manufacturer":"Hisense","market_name":"LED32G180","codename":"hisenseLED32G180","model":"LED32G180"},{"manufacturer":"Hisense","market_name":"LED32K220","codename":"mst628","model":"LED32K220"},{"manufacturer":"Hisense","market_name":"LED32K280J3D","codename":"mt5880","model":"LED32K280J3D"},{"manufacturer":"Hisense","market_name":"LED32K360","codename":"mt5880","model":"LED32K360"},{"manufacturer":"Hisense","market_name":"LED32K360J","codename":"mt5880","model":"LED32K360J"},{"manufacturer":"Hisense","market_name":"LED32K360J3D","codename":"mt5880","model":"LED32K360J3D"},{"manufacturer":"Hisense","market_name":"LED32K360X3D","codename":"mt5880","model":"LED32K360X3D"},{"manufacturer":"Hisense","market_name":"LED32K370","codename":"mt5880","model":"LED32K370"},{"manufacturer":"Hisense","market_name":"LED32K600J","codename":"mt5880","model":"LED32K600J"},{"manufacturer":"Hisense","market_name":"LED32K600X3D","codename":"mt5880","model":"LED32K600X3D"},{"manufacturer":"Hisense","market_name":"LED32K610X3D","codename":"mt5880","model":"LED32K610X3D"},{"manufacturer":"Hisense","market_name":"LED32L288","codename":"mt5880","model":"LED32L288"},{"manufacturer":"Hisense","market_name":"LED39K280J3D","codename":"mt5880","model":"LED39K280J3D"},{"manufacturer":"Hisense","market_name":"LED39K360J","codename":"mt5880","model":"LED39K360J"},{"manufacturer":"Hisense","market_name":"LED39K360X3D","codename":"mt5880","model":"LED39K360X3D"},{"manufacturer":"Hisense","market_name":"LED39K600X3D","codename":"mt5880","model":"LED39K600X3D"},{"manufacturer":"Hisense","market_name":"LED39K600X3DU","codename":"mst901","model":"LED39K600X3DU"},{"manufacturer":"Hisense","market_name":"LED39K610X3D","codename":"mt5880","model":"LED39K610X3D"},{"manufacturer":"Hisense","market_name":"LED39K680X3DU","codename":"mt5327","model":"LED39K680X3DU"},{"manufacturer":"Hisense","market_name":"LED40K260X3D","codename":"mt5880","model":"LED40K260X3D"},{"manufacturer":"Hisense","market_name":"LED40K360J","codename":"mt5880","model":"LED40K360J"},{"manufacturer":"Hisense","market_name":"LED40K360X3D","codename":"mt5880","model":"LED40K360X3D"},{"manufacturer":"Hisense","market_name":"LED40K370","codename":"mt5880","model":"LED40K370"},{"manufacturer":"Hisense","market_name":"LED40K681X3DU","codename":"msd6a918","model":"LED40K681X3DU"},{"manufacturer":"Hisense","market_name":"LED40L288","codename":"mt5880","model":"LED40L288"},{"manufacturer":"Hisense","market_name":"LED42G200","codename":"hisenseLED42G200","model":"LED42G200"},{"manufacturer":"Hisense","market_name":"LED42K280J3D","codename":"mt5880","model":"LED42K280J3D"},{"manufacturer":"Hisense","market_name":"LED42K330X3D","codename":"mt5880","model":"LED42K330X3D"},{"manufacturer":"Hisense","market_name":"LED42K360J","codename":"mt5880","model":"LED42K360J"},{"manufacturer":"Hisense","market_name":"LED42K360X3D","codename":"mt5880","model":"LED42K360X3D"},{"manufacturer":"Hisense","market_name":"LED42K370","codename":"mt5880","model":"LED42K370"},{"manufacturer":"Hisense","market_name":"LED42K380U","codename":"msd6a918","model":"LED42K380U"},{"manufacturer":"Hisense","market_name":"LED42K560X3D","codename":"hisenseLED42K560X3D","model":"LED42K560X3D"},{"manufacturer":"Hisense","market_name":"LED42K600A3D","codename":"mt5880","model":"LED42K600A3D"},{"manufacturer":"Hisense","market_name":"LED42K600X3D","codename":"mt5880","model":"LED42K600X3D"},{"manufacturer":"Hisense","market_name":"LED42K610J3DP","codename":"mt5880","model":"LED42K610J3DP"},{"manufacturer":"Hisense","market_name":"LED42K610X3D","codename":"mt5880","model":"LED42K610X3D"},{"manufacturer":"Hisense","market_name":"LED42K660X3D","codename":"hisenseLED42K660X3D","model":"LED42K660X3D"},{"manufacturer":"Hisense","market_name":"LED42K680X3DU","codename":"mt5327","model":"LED42K680X3DU"},{"manufacturer":"Hisense","market_name":"LED42L288","codename":"mt5880","model":"LED42L288"},{"manufacturer":"Hisense","market_name":"LED46K260X3D","codename":"mt5880","model":"LED46K260X3D"},{"manufacturer":"Hisense","market_name":"LED46K280J3D","codename":"mt5880","model":"LED46K280J3D"},{"manufacturer":"Hisense","market_name":"LED46K330X3D","codename":"mt5880","model":"LED46K330X3D"},{"manufacturer":"Hisense","market_name":"LED46K360J","codename":"mt5880","model":"LED46K360J"},{"manufacturer":"Hisense","market_name":"LED46K360X3D","codename":"mt5880","model":"LED46K360X3D"},{"manufacturer":"Hisense","market_name":"LED46K660X3D","codename":"hisense6a801","model":"LED46K660X3D"},{"manufacturer":"Hisense","market_name":"LED47K560J3D","codename":"hisenseLED47K560J3D","model":"LED47K560J3D"},{"manufacturer":"Hisense","market_name":"LED47K600X3D","codename":"mt5880","model":"LED47K600X3D"},{"manufacturer":"Hisense","market_name":"LED47K610J3DP","codename":"mt5880","model":"LED47K610J3DP"},{"manufacturer":"Hisense","market_name":"LED48K360X3D","codename":"mt5880","model":"LED48K360X3D"},{"manufacturer":"Hisense","market_name":"LED48K370","codename":"mt5880","model":"LED48K370"},{"manufacturer":"Hisense","market_name":"LED48K380U","codename":"msd6a918","model":"LED48K380U"},{"manufacturer":"Hisense","market_name":"LED48K681X3DU","codename":"msd6a918","model":"LED48K681X3DU"},{"manufacturer":"Hisense","market_name":"LED48L288","codename":"mt5880","model":"LED48L288"},{"manufacturer":"Hisense","market_name":"LED50G05","codename":"hisenseLED50G05","model":"LED50G05"},{"manufacturer":"Hisense","market_name":"LED50K260X3D","codename":"mt5880","model":"LED50K260X3D"},{"manufacturer":"Hisense","market_name":"LED50K360J","codename":"mt5880","model":"LED50K360J"},{"manufacturer":"Hisense","market_name":"LED50K360X3D","codename":"mt5880","model":"LED50K360X3D"},{"manufacturer":"Hisense","market_name":"LED50K370","codename":"mt5880","model":"LED50K370"},{"manufacturer":"Hisense","market_name":"LED50K380U","codename":"msd6a918","model":"LED50K380U"},{"manufacturer":"Hisense","market_name":"LED50K610X3D","codename":"mt5880","model":"LED50K610X3D"},{"manufacturer":"Hisense","market_name":"LED50K660X3D","codename":"hisenseLED50K660X3D","model":"LED50K660X3D"},{"manufacturer":"Hisense","market_name":"LED50K680X3DU","codename":"mt5327","model":"LED50K680X3DU"},{"manufacturer":"Hisense","market_name":"LED50L288","codename":"mt5880","model":"LED50L288"},{"manufacturer":"Hisense","market_name":"LED50XT880G3D","codename":"hisenseLED50XT880G3D","model":"LED50XT880G3D"},{"manufacturer":"Hisense","market_name":"LED50XT880G3DU","codename":"mst901","model":"LED50XT880G3DU"},{"manufacturer":"Hisense","market_name":"LED50XT900X3DU","codename":"mt5327","model":"LED50XT900X3DU"},{"manufacturer":"Hisense","market_name":"LED55K260X3D","codename":"mt5880","model":"LED55K260X3D"},{"manufacturer":"Hisense","market_name":"LED55K360X3D","codename":"mt5880","model":"Hisense LED55K360X3D"},{"manufacturer":"Hisense","market_name":"LED55K370","codename":"mt5880","model":"LED55K370"},{"manufacturer":"Hisense","market_name":"LED55K380U","codename":"msd6a918","model":"LED55K380U"},{"manufacturer":"Hisense","market_name":"LED55K600A3D","codename":"mt5880","model":"LED55K600A3D"},{"manufacturer":"Hisense","market_name":"LED55K600X3D","codename":"mt5880","model":"LED55K600X3D"},{"manufacturer":"Hisense","market_name":"LED55K610X3D","codename":"mt5880","model":"LED55K610X3D"},{"manufacturer":"Hisense","market_name":"LED55K680X3DU","codename":"mt5327","model":"LED55K680X3DU"},{"manufacturer":"Hisense","market_name":"LED55L288","codename":"mt5880","model":"LED55L288"},{"manufacturer":"Hisense","market_name":"LED55XT780G3D","codename":"hisenseLED55XT780G3D","model":"LED55XT780G3D"},{"manufacturer":"Hisense","market_name":"LED55XT810X3DU","codename":"msd6a918","model":"LED55XT810X3DU"},{"manufacturer":"Hisense","market_name":"LED55XT880G3DU","codename":"mst901","model":"LED55XT880G3DU"},{"manufacturer":"Hisense","market_name":"LED55XT900X3DU","codename":"mt5327","model":"LED55XT900X3DU"},{"manufacturer":"Hisense","market_name":"LED58K280J","codename":"mt5880","model":"LED58K280J"},{"manufacturer":"Hisense","market_name":"LED58K280U","codename":"mt5327","model":"LED58K280U"},{"manufacturer":"Hisense","market_name":"LED58K610X3D","codename":"mt5880","model":"LED58K610X3D"},{"manufacturer":"Hisense","market_name":"LED58K680X3DU","codename":"mt5327","model":"LED58K680X3DU"},{"manufacturer":"Hisense","market_name":"LED58XT880G3D","codename":"hisenseLED58XT880G3D","model":"LED58XT880G3D"},{"manufacturer":"Hisense","market_name":"LED58XT880J3DU","codename":"mst901","model":"LED58XT880J3DU"},{"manufacturer":"Hisense","market_name":"LED60K380","codename":"mt5327","model":"LED60K380"},{"manufacturer":"Hisense","market_name":"LED65K560J3DTB","codename":"hisenseLED65K560J3DTB","model":"LED65K560J3DTB"},{"manufacturer":"Hisense","market_name":"LED65K560J3DTR","codename":"hisenseLED65K560J3DTR","model":"LED65K560J3DTR"},{"manufacturer":"Hisense","market_name":"LED65K600X3D","codename":"mt5880","model":"LED65K600X3D"},{"manufacturer":"Hisense","market_name":"LED65K680X3DU","codename":"mt5327","model":"LED65K680X3DU"},{"manufacturer":"Hisense","market_name":"LED65XT780G3D","codename":"hisenseLED65XT780G3D","model":"LED65XT780G3D"},{"manufacturer":"Hisense","market_name":"LED65XT800X3DU","codename":"mt5327","model":"LED65XT800X3DU"},{"manufacturer":"Hisense","market_name":"LED65XT810X3DU","codename":"msd6a918","model":"LED65XT810X3DU"},{"manufacturer":"Hisense","market_name":"LED65XT880G3D","codename":"hisenseLED65XT880G3D","model":"LED65XT880G3D"},{"manufacturer":"Hisense","market_name":"LED65XT880G3DF","codename":"hisenseLED65XT880G3DF","model":"LED65XT880G3DF"},{"manufacturer":"Hisense","market_name":"LED65XT880G3DU","codename":"mst901","model":"LED65XT880G3DU"},{"manufacturer":"Hisense","market_name":"LED65XT890G3D","codename":"hisenseLED65XT890G3D","model":"LED65XT890G3D"},{"manufacturer":"Hisense","market_name":"LED65XT900G3DU","codename":"mst901","model":"LED65XT900G3DU"},{"manufacturer":"Hisense","market_name":"LED65XT900X3DU","codename":"mt5327","model":"LED65XT900X3DU"},{"manufacturer":"Hisense","market_name":"LED75XT890G3D","codename":"mst901","model":"LED75XT890G3D"},{"manufacturer":"Hisense","market_name":"LED75XT910G3DU","codename":"mt5327","model":"LED75XT910G3DU"},{"manufacturer":"Hisense","market_name":"LED84XT900G3D","codename":"hisenseLED84XT900G3D","model":"LED84XT900G3D"},{"manufacturer":"Hisense","market_name":"LED85XT910G3DU","codename":"mt5327","model":"Vision20"},{"manufacturer":"Hisense","market_name":"LT100K6900A","codename":"mt5327","model":"LT100K6900A"},{"manufacturer":"Hisense","market_name":"LT610","codename":"LT610","model":"LT610"},{"manufacturer":"Hisense","market_name":"M10-M","codename":"HS9830SP","model":"Hisense M10-M"},{"manufacturer":"Hisense","market_name":"M20- T","codename":"HS8909QC","model":"Hisense M20-T"},{"manufacturer":"Hisense","market_name":"M20-M","codename":"HS9830SP","model":"Hisense M20-M"},{"manufacturer":"Hisense","market_name":"M30","codename":"HS8909QC","model":"Hisense M30"},{"manufacturer":"Hisense","market_name":"M30M","codename":"HS9830SP","model":"Hisense M30M"},{"manufacturer":"Hisense","market_name":"M30T","codename":"HS8909QC","model":"Hisense M30T"},{"manufacturer":"Hisense","market_name":"M3101BCD","codename":"m3101bcd","model":"M3101BCD"},{"manufacturer":"Hisense","market_name":"M36","codename":"HS8909QC","model":"Hisense M36"},{"manufacturer":"Hisense","market_name":"M470BSA","codename":"m470","model":"M470BSA"},{"manufacturer":"Hisense","market_name":"M470BSD","codename":"m470bsd","model":"M470BSD"},{"manufacturer":"Hisense","market_name":"M470BSE","codename":"m470bse","model":"M470BSE"},{"manufacturer":"Hisense","market_name":"M470BSG","codename":"m470bsg","model":"M470BSG"},{"manufacturer":"Hisense","market_name":"M470BSS","codename":"m470bss","model":"M470BSS"},{"manufacturer":"Hisense","market_name":"M701","codename":"M701","model":"M701"},{"manufacturer":"Hisense","market_name":"M821","codename":"HS8916QC","model":"M821"},{"manufacturer":"Hisense","market_name":"M821H","codename":"HS8916QC","model":"M821H"},{"manufacturer":"Hisense","market_name":"M821T","codename":"HS8916QC","model":"SMART 4G HD Voice"},{"manufacturer":"Hisense","market_name":"MEDION E4001","codename":"E4001","model":"MEDION E4001"},{"manufacturer":"Hisense","market_name":"MEDION X4701","codename":"x4701","model":"MEDION X4701"},{"manufacturer":"Hisense","market_name":"Oysters Pacific 800","codename":"x4701ae","model":"Oysters Pacific 800"},{"manufacturer":"Hisense","market_name":"PX1900","codename":"atm7039c","model":"PX1900"},{"manufacturer":"Hisense","market_name":"PX1900ES","codename":"atm7039c","model":"PX7"},{"manufacturer":"Hisense","market_name":"PX2000","codename":"hisensepx2000","model":"PX2000"},{"manufacturer":"Hisense","market_name":"PX2700","codename":"g18ref","model":"PX2700"},{"manufacturer":"Hisense","market_name":"PX2800","codename":"hisensepx2800","model":"PX2800"},{"manufacturer":"Hisense","market_name":"PX3000","codename":"mt5880","model":"Hisense PX3000"},{"manufacturer":"Hisense","market_name":"PX3000","codename":"mt5880","model":"PX3000"},{"manufacturer":"Hisense","market_name":"PX3100","codename":"mt5880","model":"PX3100"},{"manufacturer":"Hisense","market_name":"PX510","codename":"PX510","model":"PX510"},{"manufacturer":"Hisense","market_name":"PX530","codename":"PX8","model":"PX8"},{"manufacturer":"Hisense","market_name":"PX9","codename":"PX9","model":"PX9"},{"manufacturer":"Hisense","market_name":"S1","codename":"HS8937QC","model":"S1"},{"manufacturer":"Hisense","market_name":"SKi630t","codename":"msm8226","model":"SKi630t"},{"manufacturer":"Hisense","market_name":"STARSHINE 4","codename":"HS6572MT","model":"STARSHINE 4"},{"manufacturer":"Hisense","market_name":"STARTRAIL  9","codename":"HS6737MT","model":"S40"},{"manufacturer":"Hisense","market_name":"STARTRAIL  9","codename":"HS6737MT","model":"STARTRAIL 9"},{"manufacturer":"Hisense","market_name":"STARTRAIL 6 4G","codename":"L681","model":"STARTRAIL 6 4G"},{"manufacturer":"Hisense","market_name":"Sero 7","codename":"rk3168","model":"E2171CA"},{"manufacturer":"Hisense","market_name":"Sero 7","codename":"rk3168","model":"E2171MX"},{"manufacturer":"Hisense","market_name":"Sero 7","codename":"rk3168","model":"E2171TK"},{"manufacturer":"Hisense","market_name":"Sero 8","codename":"rk3188","model":"E2281"},{"manufacturer":"Hisense","market_name":"Sero 8","codename":"rk3188","model":"E2281CA"},{"manufacturer":"Hisense","market_name":"Sero 8","codename":"rk3188","model":"E2281MX"},{"manufacturer":"Hisense","market_name":"Sero 8","codename":"rk3188","model":"E2281TK"},{"manufacturer":"Hisense","market_name":"Sero 8","codename":"rk3188","model":"E2281UK"},{"manufacturer":"Hisense","market_name":"Sero 8 pro","codename":"rk3288","model":"F5281"},{"manufacturer":"Hisense","market_name":"Sero7","codename":"rk3168","model":"E2171SS"},{"manufacturer":"Hisense","market_name":"Sero7 LE","codename":"rk3026","model":"E2371"},{"manufacturer":"Hisense","market_name":"Sero8","codename":"rk3188","model":"E2281SS"},{"manufacturer":"Hisense","market_name":"SoundTab MA-317","codename":"rk3028a","model":"Hisense SoundTab MA-317"},{"manufacturer":"Hisense","market_name":"SoundTab MA-327","codename":"rk3028a","model":"Hisense SoundTab MA-327"},{"manufacturer":"Hisense","market_name":"T963","codename":"HS7331CSC","model":"Hisense T963"},{"manufacturer":"Hisense","market_name":"TV","codename":"hisense_gx1200v","model":"hisense_gx1200v"},{"manufacturer":"Hisense","market_name":"U601S","codename":"HS7731CSP","model":"Hisense U601S"},{"manufacturer":"Hisense","market_name":"U601S  Pro","codename":"HS7731CSP","model":"U601S Pro"},{"manufacturer":"Hisense","market_name":"U602","codename":"HS6580MT","model":"HS-U602"},{"manufacturer":"Hisense","market_name":"U606","codename":"U606","model":"STARSHINE III"},{"manufacturer":"Hisense","market_name":"U606AE","codename":"U606AE","model":"HS-U606"},{"manufacturer":"Hisense","market_name":"U606AE","codename":"U606AE","model":"PHS-402"},{"manufacturer":"Hisense","market_name":"U607","codename":"U607","model":"Bouygues Telecom Bs 403"},{"manufacturer":"Hisense","market_name":"U609","codename":"U609","model":"HS-U609"},{"manufacturer":"Hisense","market_name":"U610","codename":"U610","model":"HS-U610"},{"manufacturer":"Hisense","market_name":"U610","codename":"U610E_1","model":"HS-U610"},{"manufacturer":"Hisense","market_name":"U688","codename":"U688","model":"HS-U688"},{"manufacturer":"Hisense","market_name":"U688BE","codename":"MSM8212","model":"HS-U688"},{"manufacturer":"Hisense","market_name":"U800","codename":"U800","model":"HS-U800"},{"manufacturer":"Hisense","market_name":"U800E-1","codename":"U800E_1","model":"HS-U800"},{"manufacturer":"Hisense","market_name":"U800E-1","codename":"U800E_1","model":"HS-U800E-1"},{"manufacturer":"Hisense","market_name":"U963","codename":"HS7331CSC","model":"Hisense U963"},{"manufacturer":"Hisense","market_name":"U963","codename":"HS7331CSC","model":"RIVIERA U963"},{"manufacturer":"Hisense","market_name":"U966","codename":"u966e_1","model":"U966"},{"manufacturer":"Hisense","market_name":"U970","codename":"u970e_8","model":"U970"},{"manufacturer":"Hisense","market_name":"U988","codename":"U988","model":"HS-U988"},{"manufacturer":"Hisense","market_name":"U988AE","codename":"MSM8212","model":"HS-U988"},{"manufacturer":"Hisense","market_name":"U988E-1","codename":"U988E_1","model":"HS-U988"},{"manufacturer":"Hisense","market_name":"U988E-2","codename":"U988E_2","model":"HS-U988"},{"manufacturer":"Hisense","market_name":"U989","codename":"HS6580MT","model":"Hisense U989"},{"manufacturer":"Hisense","market_name":"U989 Pro","codename":"HS6580MT","model":"Hisense U989 Pro"},{"manufacturer":"Hisense","market_name":"VH777","codename":"VH777","model":"VH777"},{"manufacturer":"Hisense","market_name":"VIDAA_TV","codename":"Hi3751","model":"VIDAA_TV"},{"manufacturer":"Hisense","market_name":"VIDAA_TV","codename":"Hi3751v551","model":"VIDAA_TV"},{"manufacturer":"Hisense","market_name":"VIDAA_TV","codename":"Hi3751v620","model":"VIDAA_TV"},{"manufacturer":"Hisense","market_name":"VIDAA_TV","codename":"Hi3751v811","model":"VIDAA_TV"},{"manufacturer":"Hisense","market_name":"VIDAA_TV","codename":"MSD6A348","model":"VIDAA_TV"},{"manufacturer":"Hisense","market_name":"VIDAA_TV","codename":"MSD6A648","model":"VIDAA_TV"},{"manufacturer":"Hisense","market_name":"VIDAA_TV","codename":"MSD6A828","model":"VIDAA_TV"},{"manufacturer":"Hisense","market_name":"VIDAA_TV","codename":"MSD6A838","model":"VIDAA_TV"},{"manufacturer":"Hisense","market_name":"VIDAA_TV","codename":"MSD6A938","model":"VIDAA_TV"},{"manufacturer":"Hisense","market_name":"VIDAA_TV","codename":"mt5861","model":"VIDAA_TV"},{"manufacturer":"Hisense","market_name":"VIDAA_TV","codename":"mt5890","model":"VIDAA_TV"},{"manufacturer":"Hisense","market_name":"Vidaa","codename":"helium3","model":"H7"},{"manufacturer":"Hisense","market_name":"Vision","codename":"Vision","model":"Vision"},{"manufacturer":"Hisense","market_name":"Vision 2.5","codename":"vision2_5","model":"vision2_5"},{"manufacturer":"Hisense","market_name":"W2","codename":"EG606_YE","model":"W2"},{"manufacturer":"Hisense","market_name":"W270BD","codename":"W270BD","model":"W270BD"},{"manufacturer":"Hisense","market_name":"WA912","codename":"U912ATW","model":"WA912"},{"manufacturer":"Hisense","market_name":"WA960","codename":"U960Q_1","model":"WA960"},{"manufacturer":"Hisense","market_name":"WM8","codename":"wm8980s","model":"WM8"},{"manufacturer":"Hisense","market_name":"X1E1","codename":"X1E1","model":"HS-X1"},{"manufacturer":"Hisense","market_name":"XOLO","codename":"us9230e1","model":"XOLO T1000"},{"manufacturer":"Hisense","market_name":"c20","codename":"HS8929QC","model":"Hisense C20"},{"manufacturer":"Hisense","market_name":"c20ae","codename":"HS8929QC","model":"C20"},{"manufacturer":"Hisense","market_name":"c20fe-3","codename":"HS8929QC","model":"Hisense C20"},{"manufacturer":"Hisense","market_name":"e76mini","codename":"HS8937QC","model":"Hisense E76mini"},{"manufacturer":"Hisense","market_name":"l676be","codename":"HS8929QC","model":"Hisense L676"},{"manufacturer":"Hisense","market_name":"l691","codename":"msm8226","model":"HS-L691"},{"manufacturer":"Hisense","market_name":"l830","codename":"HS8937QC","model":"Hisense L830"},{"manufacturer":"Hisense","market_name":"l830","codename":"HS8937QC","model":"STARXTREM 6"},{"manufacturer":"Hisense","market_name":"laoshan","codename":"laoshan","model":"HAT4KDTV"},{"manufacturer":"Hisense","market_name":"lt971","codename":"LT971","model":"LT971"},{"manufacturer":"Hisense","market_name":"u972","codename":"HS7731SP","model":"U972"},{"manufacturer":"Hisense","market_name":"vision2_1","codename":"vision2_1","model":"vision2_1"},{"manufacturer":"Hoffmann","market_name":"X Max","codename":"X-Max","model":"X-Max"},{"manufacturer":"Honda","market_name":"A-DA","codename":"e1853","model":"14A-DA"},{"manufacturer":"Honda","market_name":"A-DA","codename":"e1853","model":"MY15ADA"},{"manufacturer":"Honda","market_name":"A-DA","codename":"sakura","model":"MY18ADA"},{"manufacturer":"Honda","market_name":"A-DA","codename":"vcm30t30","model":"MY17ADA"},{"manufacturer":"Honda","market_name":"A-DA","codename":"vcm30t30","model":"MY18ADA"},{"manufacturer":"Honda","market_name":"Accord","codename":"koelsch","model":"MY16ADA"},{"manufacturer":"Honda","market_name":"MY15ADA","codename":"koelsch","model":"MY15ADA"},{"manufacturer":"Honda","market_name":"NSX","codename":"koelsch","model":"MY15ADA"},{"manufacturer":"Honda","market_name":"Pilot","codename":"koelsch","model":"MY15ADA"},{"manufacturer":"Honda","market_name":"Ridgeline","codename":"koelsch","model":"MY15ADA"},{"manufacturer":"Honda","market_name":"S660","codename":"koelsch","model":"MY19ADA"},{"manufacturer":"Honda","market_name":"Spirior","codename":"koelsch","model":"MY15ADA"},{"manufacturer":"Honda","market_name":"Unit Assy AVN","codename":"h16","model":"SiRFSoC Android"},{"manufacturer":"Honeywell","market_name":"70eL00","codename":"dblack","model":"Dolphin 70e Black"},{"manufacturer":"Honeywell","market_name":"70eLGN","codename":"dblack_gn","model":"Dolphin 70e Black"},{"manufacturer":"Honeywell","market_name":"70eLGN","codename":"dblack_go","model":"Dolphin 70e Black"},{"manufacturer":"Honeywell","market_name":"70eLW0","codename":"dblack_wo","model":"Dolphin 70e Black"},{"manufacturer":"Honeywell","market_name":"70eLWN","codename":"dblack_wn","model":"Dolphin 70e Black"},{"manufacturer":"Honeywell","market_name":"CK75","codename":"CK75","model":"CX75 AC0"},{"manufacturer":"Honeywell","market_name":"CK75","codename":"CK75","model":"CX75 AN0"},{"manufacturer":"Honeywell","market_name":"CN51","codename":"CN51_NC0","model":"CN51 NC0"},{"manufacturer":"Honeywell","market_name":"CN51","codename":"CN51_NCF","model":"CN51 NCF"},{"manufacturer":"Honeywell","market_name":"CN51","codename":"CN51_NCU","model":"CN51 NCU"},{"manufacturer":"Honeywell","market_name":"CN51","codename":"CN51_NN0","model":"CN51 NN0"},{"manufacturer":"Honeywell","market_name":"CN51","codename":"CN51_QC0","model":"CN51 QC0"},{"manufacturer":"Honeywell","market_name":"CN51","codename":"CN51_QCF","model":"CN51 QCF"},{"manufacturer":"Honeywell","market_name":"CN51","codename":"CN51_QCU","model":"CN51 QCU"},{"manufacturer":"Honeywell","market_name":"CN51","codename":"CN51_QN0","model":"CN51 QN0"},{"manufacturer":"Honeywell","market_name":"CN75","codename":"CN75","model":"CX75 NC0"},{"manufacturer":"Honeywell","market_name":"CN75","codename":"CN75","model":"CX75 NCF"},{"manufacturer":"Honeywell","market_name":"CN75","codename":"CN75","model":"CX75 QC0"},{"manufacturer":"Honeywell","market_name":"CN75","codename":"CN75","model":"CX75 QCF"},{"manufacturer":"Honeywell","market_name":"CN75E","codename":"CN75E","model":"CX75 NC0"},{"manufacturer":"Honeywell","market_name":"CN75E","codename":"CN75E","model":"CX75 NCF"},{"manufacturer":"Honeywell","market_name":"CN75E","codename":"CN75E","model":"CX75 QC0"},{"manufacturer":"Honeywell","market_name":"CN75E","codename":"CN75E","model":"CX75 QCF"},{"manufacturer":"Honeywell","market_name":"CT50","codename":"CT50L0N-CS12S","model":"CT50"},{"manufacturer":"Honeywell","market_name":"CT50","codename":"CT50L0N-CS15S","model":"CT50"},{"manufacturer":"Honeywell","market_name":"CT50","codename":"CT50L0N-CS16S","model":"CT50"},{"manufacturer":"Honeywell","market_name":"CT50","codename":"CT50LFN-CS16S","model":"CT50"},{"manufacturer":"Honeywell","market_name":"CT50","codename":"CT50LUN-CS12S","model":"CT50"},{"manufacturer":"Honeywell","market_name":"CT50","codename":"CT50LUN-CS15S","model":"CT50"},{"manufacturer":"Honeywell","market_name":"CT50","codename":"CT50LUN-CS16S","model":"CT50"},{"manufacturer":"Honeywell","market_name":"CT60","codename":"CT60-L0N-ASC","model":"CT60"},{"manufacturer":"Honeywell","market_name":"CT60-L0-C","codename":"CT60-L0-C","model":"CT60"},{"manufacturer":"Honeywell","market_name":"CT60-L1N-C","codename":"CT60-L1-C","model":"CT60"},{"manufacturer":"Honeywell","market_name":"D75E","codename":"75E-L0N","model":"D75E"},{"manufacturer":"Honeywell","market_name":"Dolphin 70e Black","codename":"dblack_gn","model":"Dolphin 70e Black"},{"manufacturer":"Honeywell","market_name":"Dolphin 70e Black","codename":"dblack_go","model":"Dolphin 70e Black"},{"manufacturer":"Honeywell","market_name":"Dolphin 70e Black","codename":"dblack_wn","model":"Dolphin 70e Black"},{"manufacturer":"Honeywell","market_name":"Dolphin 70e Black","codename":"dblack_wo","model":"Dolphin 70e Black"},{"manufacturer":"Honeywell","market_name":"Dolphin CT50","codename":"CT50L0N-CS13S","model":"CT50"},{"manufacturer":"Honeywell","market_name":"Dolphin CT50","codename":"CT50LFN-CS13S","model":"CT50"},{"manufacturer":"Honeywell","market_name":"Dolphin CT50","codename":"CT50LUN-CS13S","model":"CT50"},{"manufacturer":"Honeywell","market_name":"EDA50","codename":"eda50-011","model":"EDA50"},{"manufacturer":"Honeywell","market_name":"EDA50","codename":"eda50-111","model":"EDA50"},{"manufacturer":"Honeywell","market_name":"EDA50","codename":"eda50-111","model":"Glory50"},{"manufacturer":"Honeywell","market_name":"EDA50","codename":"eda50-211","model":"EDA50"},{"manufacturer":"Honeywell","market_name":"EDA50K","codename":"eda50k-0","model":"EDA50K"},{"manufacturer":"Honeywell","market_name":"EDA50K","codename":"eda50k-1","model":"EDA50K"},{"manufacturer":"Honeywell","market_name":"EDA50K","codename":"eda50k-1","model":"Glory EDA50K"},{"manufacturer":"Honeywell","market_name":"EDA70","codename":"eda70-0","model":"EDA70"},{"manufacturer":"Honeywell","market_name":"EDA70","codename":"eda70-3","model":"EDA70"},{"manufacturer":"Honeywell","market_name":"EdA50","codename":"eda50-211","model":"EDA50"},{"manufacturer":"Hot Pepper","market_name":"H5","codename":"H5","model":"H5"},{"manufacturer":"Hotwav","market_name":"HOT 6","codename":"HOT_6","model":"HOT 6"},{"manufacturer":"Hotwav","market_name":"Magic 13","codename":"Magic_13","model":"Magic 13"},{"manufacturer":"Hotwav","market_name":"Magic 5","codename":"Magic_5","model":"Magic 5"},{"manufacturer":"Hotwav","market_name":"Magic 6","codename":"Magic_6","model":"Magic 6"},{"manufacturer":"Hotwav","market_name":"Magic 8","codename":"Magic_8","model":"Magic 8"},{"manufacturer":"Hotwav","market_name":"Magic 9","codename":"Magic_9","model":"Magic 9"},{"manufacturer":"Hotwav","market_name":"Magic Q8","codename":"Magic_Q8","model":"Magic Q8"},{"manufacturer":"Hotwav","market_name":"Magic Q8 Plus","codename":"Magic_Q8_Plus","model":"Magic Q8 Plus"},{"manufacturer":"Hotwav","market_name":"Magic_5_Plus","codename":"Magic_5_Plus","model":"Magic 5 Plus"},{"manufacturer":"Hotwav","market_name":"Symbol M1","codename":"Symbol_M1","model":"Symbol M1"},{"manufacturer":"How","market_name":"1001-G","codename":"1001-G","model":"1001-G"},{"manufacturer":"How","market_name":"705-G","codename":"705-G","model":"705-G"},{"manufacturer":"How","market_name":"HT-704","codename":"HT704","model":"HT-704"},{"manufacturer":"How","market_name":"HT-704plus","codename":"HT704plus","model":"HT-704plus"},{"manufacturer":"How","market_name":"HT-705","codename":"HT705","model":"HT-705"},{"manufacturer":"How","market_name":"HT704-G","codename":"704-G","model":"704-G"},{"manufacturer":"How","market_name":"kids 3g","codename":"sp7731c_1h10","model":"kids 3g"},{"manufacturer":"Huawei","market_name":"","codename":"C8600","model":"C8600"},{"manufacturer":"Huawei","market_name":"","codename":"CHT8000","model":"CHT8000"},{"manufacturer":"Huawei","market_name":"","codename":"HuaweiU8180","model":"Huawei Ideos X1"},{"manufacturer":"Huawei","market_name":"","codename":"HuaweiU8180","model":"HuaweiU8180"},{"manufacturer":"Huawei","market_name":"","codename":"HuaweiU8180","model":"IDEOS X1"},{"manufacturer":"Huawei","market_name":"","codename":"HuaweiU8180","model":"Kyivstar Terra"},{"manufacturer":"Huawei","market_name":"","codename":"HuaweiU8180","model":"Starshine"},{"manufacturer":"Huawei","market_name":"","codename":"HuaweiU8180","model":"Stockholm"},{"manufacturer":"Huawei","market_name":"","codename":"HuaweiU8180","model":"U8180"},{"manufacturer":"Huawei","market_name":"","codename":"Pulse","model":"Pulse"},{"manufacturer":"Huawei","market_name":"","codename":"T8300","model":"HUAWEI T8300"},{"manufacturer":"Huawei","market_name":"","codename":"T8600","model":"HUAWEI T8600"},{"manufacturer":"Huawei","market_name":"","codename":"T8828","model":"HUAWEI T8828"},{"manufacturer":"Huawei","market_name":"","codename":"U8110","model":"EQ U8110"},{"manufacturer":"Huawei","market_name":"","codename":"U8110","model":"Huawei"},{"manufacturer":"Huawei","market_name":"","codename":"U8110","model":"Huawei U8110"},{"manufacturer":"Huawei","market_name":"","codename":"U8110","model":"MTC_A"},{"manufacturer":"Huawei","market_name":"","codename":"U8110","model":"Pulse Mini"},{"manufacturer":"Huawei","market_name":"","codename":"U8110","model":"TSP21"},{"manufacturer":"Huawei","market_name":"","codename":"U8110","model":"Turkcell T10"},{"manufacturer":"Huawei","market_name":"","codename":"U8110","model":"U8110"},{"manufacturer":"Huawei","market_name":"","codename":"U8110","model":"life:) Android"},{"manufacturer":"Huawei","market_name":"","codename":"U8300","model":"U8300"},{"manufacturer":"Huawei","market_name":"","codename":"U8500","model":"HUAWEI IDEOS U8500"},{"manufacturer":"Huawei","market_name":"","codename":"U8500","model":"MTC_EVO"},{"manufacturer":"Huawei","market_name":"","codename":"dtab01","model":"dtab01"},{"manufacturer":"Huawei","market_name":"","codename":"hwC8813Q","model":"HUAWEI C8813Q"},{"manufacturer":"Huawei","market_name":"","codename":"hwC8860E","model":"HUAWEI C8860E"},{"manufacturer":"Huawei","market_name":"","codename":"hwG520-T10","model":"HUAWEI G520-T10"},{"manufacturer":"Huawei","market_name":"","codename":"hwS42HW","model":"S42HW"},{"manufacturer":"Huawei","market_name":"","codename":"hwS7-901w","model":"A01HW"},{"manufacturer":"Huawei","market_name":"","codename":"hwT8830Pro","model":"T8830Pro"},{"manufacturer":"Huawei","market_name":"","codename":"hwU9202L","model":"U9202L-1"},{"manufacturer":"Huawei","market_name":"","codename":"hwU9202L","model":"U9202L-3"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8500","model":"C8500"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8511","model":"C8511"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8511","model":"MTS-SP101"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8512","model":"C8512"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8600","model":"C8600"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8650","model":"C8650"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8650e","model":"HUAWEI C8650+"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8655","model":"HUAWEI C8655"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8800","model":"C8800"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8800","model":"MTS-SP140"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8810","model":"HUAWEI C8810"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8812E","model":"HUAWEI C8812E"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8813","model":"HUAWEI C8813"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8825D","model":"HUAWEI C8825D"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8860E","model":"HUAWEI C8860E"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8860V","model":"C8860V"},{"manufacturer":"Huawei","market_name":"","codename":"hwc8950D","model":"HUAWEI C8950D"},{"manufacturer":"Huawei","market_name":"","codename":"hwcm980","model":"CM980"},{"manufacturer":"Huawei","market_name":"","codename":"hwh866c","model":"H866C"},{"manufacturer":"Huawei","market_name":"","codename":"hwh866c","model":"HUAWEI H866C"},{"manufacturer":"Huawei","market_name":"","codename":"hwh867g","model":"Huawei-H867G"},{"manufacturer":"Huawei","market_name":"","codename":"hwh868c","model":"HUAWEI H868C"},{"manufacturer":"Huawei","market_name":"","codename":"hwh881c","model":"HUAWEI H881C"},{"manufacturer":"Huawei","market_name":"","codename":"hwm650","model":"Express"},{"manufacturer":"Huawei","market_name":"","codename":"hwm650","model":"M650"},{"manufacturer":"Huawei","market_name":"","codename":"hwm660","model":"M660"},{"manufacturer":"Huawei","market_name":"","codename":"hwm860","model":"HUAWEI-M860"},{"manufacturer":"Huawei","market_name":"","codename":"hwm865c","model":"M865C"},{"manufacturer":"Huawei","market_name":"","codename":"hwm866","model":"HUAWEI M866"},{"manufacturer":"Huawei","market_name":"","codename":"hwm866","model":"M866"},{"manufacturer":"Huawei","market_name":"","codename":"hwm866","model":"USCCADR3310"},{"manufacturer":"Huawei","market_name":"","codename":"hwm886","model":"M886"},{"manufacturer":"Huawei","market_name":"","codename":"hwm920","model":"HUAWEI-M920"},{"manufacturer":"Huawei","market_name":"","codename":"hwm931","model":"HUAWEI-M931"},{"manufacturer":"Huawei","market_name":"","codename":"hwp2-0000","model":"HUAWEI P2-0000"},{"manufacturer":"Huawei","market_name":"","codename":"hwp2-6011","model":"HUAWEI P2-6011"},{"manufacturer":"Huawei","market_name":"","codename":"hwp2-6011","model":"HUAWEI P2-6011-orange"},{"manufacturer":"Huawei","market_name":"","codename":"hws10101u","model":"MediaPad 10 FHD"},{"manufacturer":"Huawei","market_name":"","codename":"hws10101w","model":"GT01"},{"manufacturer":"Huawei","market_name":"","codename":"hws10101w","model":"MediaPad 10 FHD"},{"manufacturer":"Huawei","market_name":"","codename":"hws10201u","model":"MediaPad 10 LINK"},{"manufacturer":"Huawei","market_name":"","codename":"hws7300c","model":"HUAWEI MediaPad"},{"manufacturer":"Huawei","market_name":"","codename":"hws7300u","model":"HUAWEI MediaPad"},{"manufacturer":"Huawei","market_name":"","codename":"hws7300u","model":"Huawei S7-312u"},{"manufacturer":"Huawei","market_name":"","codename":"hws7300u","model":"MediaPad"},{"manufacturer":"Huawei","market_name":"","codename":"hws7300u","model":"SpringBoard"},{"manufacturer":"Huawei","market_name":"","codename":"hws7300w","model":"HUAWEI MediaPad"},{"manufacturer":"Huawei","market_name":"","codename":"hws7930w","model":"MediaPad 7 Lite"},{"manufacturer":"Huawei","market_name":"","codename":"hwt8620","model":"T8620"},{"manufacturer":"Huawei","market_name":"","codename":"hwt8830","model":"T8830"},{"manufacturer":"Huawei","market_name":"","codename":"hwt8833","model":"HUAWEI T8833"},{"manufacturer":"Huawei","market_name":"","codename":"hwt8950","model":"HUAWEI T8950"},{"manufacturer":"Huawei","market_name":"","codename":"hwt8950N","model":"HUAWEI T8950N"},{"manufacturer":"Huawei","market_name":"","codename":"hwt8951","model":"HUAWEI T8951"},{"manufacturer":"Huawei","market_name":"","codename":"hwt9200","model":"T9200"},{"manufacturer":"Huawei","market_name":"","codename":"hwt9510e","model":"T9510E"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8180","model":"Netphone 501"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8180","model":"U8180"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8185","model":"U8185"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8186","model":"U8186"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8230","model":"U8230"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8350","model":"Barcelona"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8350","model":"GM FOX"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8350","model":"HuaweiU8350"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8350","model":"MTC Pro"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8350","model":"Personal U8350"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8350","model":"Temptation"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8350","model":"U8350"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8350","model":"U8350-51"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8500","model":"Grameenphone Crystal"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8500","model":"HUAWEI_IDEOS_U8500"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8500","model":"HuaweiU8500"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8500","model":"ICE"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8500","model":"MF8503"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8500","model":"MTC Evo"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8500","model":"MegaFon U8500"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8500","model":"U8500"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8510","model":"Beeline_E500"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8510","model":"GM Ultimate Slim"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8510","model":"Huawei IDEOS X3"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8510","model":"HuaweiU8510"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8510","model":"MTC Bravo"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8510","model":"S41HW"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8510","model":"U8510"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8520","model":"U8520"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8600","model":"U8600"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8650","model":"HUAWEI SONIC"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8650","model":"HUAWEI_IDEOS_U8650"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8650","model":"HuaweiU8650"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8650","model":"Kyivstar Aqua"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8650","model":"MTC 955"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8650","model":"SONIC"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8650","model":"Turkcell T20"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8650","model":"U8650"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8650","model":"U8650-1"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8651","model":"Astro"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8651","model":"Prism"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8651","model":"U8651"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8651","model":"U8651T"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8652-51","model":"U8652-51"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8655","model":"Etisalat"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8655","model":"HUAWEI IDEOS Y 200"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8655","model":"Personal U8655-51"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8655","model":"STARTRAIL II"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8655","model":"U8655"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8655","model":"U8655-1"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8655","model":"U8655-51"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8660","model":"SONIC"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8661","model":"HUAWEI U8661"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8666","model":"MTC Fit"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8666","model":"U8666-1"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8666","model":"U8666-51"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8666-51","model":"U8666-51"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8666e","model":"HUAWEI U8666E"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8666e","model":"MegaFon SP-A3"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8666e-51","model":"HUAWEI U8666E"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8666e-51","model":"HUAWEI U8666E-51"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8666n","model":"HUAWEI U8666N"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8667","model":"U8667"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8680","model":"T-Mobile myTouch"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8681","model":"HUAWEI U8681"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8730","model":"T-Mobile myTouch Q"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8800","model":"IDEOS X5"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8800","model":"MTC Neo"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8800","model":"U8800"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8800","model":"Ucell"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8800","model":"u8800"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8800Pro","model":"HUAWEI_IDEOS_X5"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8800Pro","model":"HuaweiU8800Pro"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8800Pro","model":"IDEOS X5"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8800Pro","model":"MTC Neo"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8800Pro","model":"RBM_HD"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8800Pro","model":"U8800 Pro"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8800Pro","model":"U8800Pro"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8815","model":"HUAWEI Ascend G 300"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8815","model":"HUAWEI U8815"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8815","model":"HUAWEI_Ascend G 300"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8815","model":"Personal U8815-51"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8815","model":"U8815"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8815","model":"U8815-51"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8815n","model":"HUAWEI U8815N"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8815n","model":"U8815N"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8816","model":"MTC Viva"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8816","model":"U8816"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8818","model":"HUAWEI U8818"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8818","model":"U8818"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8820","model":"U8820"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8825-1","model":"Bs 401"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8825-1","model":"HUAWEI Ascend G 330"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8825-1","model":"HUAWEI U8825-1"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8825D","model":"HUAWEI U8825D"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8850","model":"007HW"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8860","model":"GS02"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8860","model":"HUAWEI_U8860"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8860","model":"TURKCELL MaxiPRO5"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8860","model":"U8860"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8860","model":"U8860-51"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8867Z","model":"U8867Z"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8950-1","model":"HUAWEI U8950-1"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8950-51","model":"HUAWEI U8950-51"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8950D","model":"HUAWEI U8950D"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8950N-1","model":"HUAWEI U8950N-1"},{"manufacturer":"Huawei","market_name":"","codename":"hwu8950N-51","model":"HUAWEI U8950N-51"},{"manufacturer":"Huawei","market_name":"","codename":"hwu9200","model":"U9200"},{"manufacturer":"Huawei","market_name":"","codename":"hwu9200","model":"U9200E"},{"manufacturer":"Huawei","market_name":"","codename":"hwu9200-92","model":"GS03"},{"manufacturer":"Huawei","market_name":"","codename":"hwu9200-92","model":"U9200"},{"manufacturer":"Huawei","market_name":"","codename":"hwu9200E","model":"U9200E"},{"manufacturer":"Huawei","market_name":"","codename":"hwu9201L","model":"201HW"},{"manufacturer":"Huawei","market_name":"","codename":"hwu9500","model":"U9500E"},{"manufacturer":"Huawei","market_name":"","codename":"hwu9501L","model":"HW-01E"},{"manufacturer":"Huawei","market_name":"","codename":"hwu9508","model":"HUAWEI U9508"},{"manufacturer":"Huawei","market_name":"","codename":"hwu9510","model":"HUAWEI U9510"},{"manufacturer":"Huawei","market_name":"","codename":"hwu9510","model":"U9510"},{"manufacturer":"Huawei","market_name":"","codename":"hwu9510e","model":"HUAWEI U9510E"},{"manufacturer":"Huawei","market_name":"","codename":"hwu9700L","model":"GL07S"},{"manufacturer":"Huawei","market_name":"","codename":"hwum840","model":"UM840"},{"manufacturer":"Huawei","market_name":"","codename":"hwy210-0010","model":"HUAWEI Y210-0010"},{"manufacturer":"Huawei","market_name":"","codename":"hwy210-0100","model":"HUAWEI Ascend Y 210"},{"manufacturer":"Huawei","market_name":"","codename":"hwy210-0100","model":"HUAWEI Y210-0100"},{"manufacturer":"Huawei","market_name":"","codename":"hwy210-0151","model":"HUAWEI Y210-0151"},{"manufacturer":"Huawei","market_name":"","codename":"hwy210-0200","model":"HUAWEI Ascend Y 210D"},{"manufacturer":"Huawei","market_name":"","codename":"hwy210-0200","model":"HUAWEI Asend Y 210D"},{"manufacturer":"Huawei","market_name":"","codename":"hwy210-0200","model":"HUAWEI Y210-0200"},{"manufacturer":"Huawei","market_name":"","codename":"hwy210-0200","model":"Leopard MF808"},{"manufacturer":"Huawei","market_name":"","codename":"hwy210-0200","model":"NATCOM N8302"},{"manufacturer":"Huawei","market_name":"","codename":"hwy210-0200","model":"VIETTEL V8404"},{"manufacturer":"Huawei","market_name":"","codename":"hwy210-0251","model":"HUAWEI Y210-0251"},{"manufacturer":"Huawei","market_name":"","codename":"hwy210-2010","model":"HUAWEI Y210-2010"},{"manufacturer":"Huawei","market_name":"","codename":"msm7201a","model":"Pulse"},{"manufacturer":"Huawei","market_name":"","codename":"msm7201a","model":"U8230"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"Beeline_E300"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"Grameenphone Crystal"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"HUAWEI IDEOS U8500"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"HUAWEI_IDEOS_U8500"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"Huawei"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"HuaweiU8300"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"Ideos"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"MTC Evo"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"Pulse Mini"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"RBM C"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"S31HW"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"Smile"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"Tactile internet"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"Turkcell T10"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"U8110"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"U8300"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"U8500"},{"manufacturer":"Huawei","market_name":"","codename":"msm7225","model":"Vodafone 845"},{"manufacturer":"Huawei","market_name":"","codename":"msm7227","model":"004HW"},{"manufacturer":"Huawei","market_name":"","codename":"msm7230","model":"IDEOS X5"},{"manufacturer":"Huawei","market_name":"","codename":"msm7230","model":"u8800"},{"manufacturer":"Huawei","market_name":"","codename":"msm7625","model":"C8600"},{"manufacturer":"Huawei","market_name":"","codename":"msm7625","model":"HUAWEI-M860"},{"manufacturer":"Huawei","market_name":"","codename":"msm7625","model":"Ideos"},{"manufacturer":"Huawei","market_name":"","codename":"msm7625","model":"M860"},{"manufacturer":"Huawei","market_name":"","codename":"msm7625","model":"U8180"},{"manufacturer":"Huawei","market_name":"","codename":"orinoquiac8688V","model":"ORINOQUIA C8688V"},{"manufacturer":"Huawei","market_name":"","codename":"qsd8k_s7","model":"HUAWEI-S7"},{"manufacturer":"Huawei","market_name":"","codename":"qsd8k_s7","model":"IDEOS S7"},{"manufacturer":"Huawei","market_name":"","codename":"qsd8k_s7","model":"Ideos S7"},{"manufacturer":"Huawei","market_name":"","codename":"qsd8k_s7","model":"Oysters SmaKit S7"},{"manufacturer":"Huawei","market_name":"","codename":"qsd8k_s7","model":"S7"},{"manufacturer":"Huawei","market_name":"","codename":"qsd8k_slim","model":"IDEOS S7 Slim"},{"manufacturer":"Huawei","market_name":"","codename":"u8800","model":"u8800"},{"manufacturer":"Huawei","market_name":"A199","codename":"hwa199","model":"HUAWEI A199"},{"manufacturer":"Huawei","market_name":"ATH-TL00","codename":"HWATH","model":"ATH-TL00"},{"manufacturer":"Huawei","market_name":"ATH-TL00H","codename":"HWATH","model":"ATH-TL00H"},{"manufacturer":"Huawei","market_name":"ATH-UL00","codename":"HWATH","model":"ATH-UL00"},{"manufacturer":"Huawei","market_name":"Ascend D","codename":"hwu9500","model":"U9500"},{"manufacturer":"Huawei","market_name":"Ascend G510","codename":"hwG510-0251","model":"HUAWEI G510-0251"},{"manufacturer":"Huawei","market_name":"Ascend G525","codename":"hwG525-U00","model":"HUAWEI Ascend G525"},{"manufacturer":"Huawei","market_name":"Ascend G525","codename":"hwG525-U00","model":"HUAWEI G525-U00"},{"manufacturer":"Huawei","market_name":"B199","codename":"hwB199","model":"HUAWEI B199"},{"manufacturer":"Huawei","market_name":"C199","codename":"hwC199","model":"HUAWEI C199"},{"manufacturer":"Huawei","market_name":"C199s","codename":"hwC199s","model":"HUAWEI C199s"},{"manufacturer":"Huawei","market_name":"C8812","codename":"hwc8812","model":"HUAWEI C8812"},{"manufacturer":"Huawei","market_name":"C8813D","codename":"hwc8813","model":"HUAWEI C8813D"},{"manufacturer":"Huawei","market_name":"C8813DQ","codename":"hwC8813DQ","model":"HUAWEI C8813DQ"},{"manufacturer":"Huawei","market_name":"C8815","codename":"hwC8815","model":"HUAWEI C8815"},{"manufacturer":"Huawei","market_name":"C8816","codename":"hwC8816","model":"HUAWEI C8816"},{"manufacturer":"Huawei","market_name":"C8816D","codename":"hwC8816D","model":"HUAWEI C8816D"},{"manufacturer":"Huawei","market_name":"C8817D","codename":"hwC8817D","model":"C8817D"},{"manufacturer":"Huawei","market_name":"C8817E","codename":"hwC8817E","model":"HUAWEI C8817E"},{"manufacturer":"Huawei","market_name":"C8817L","codename":"hwC8817L","model":"HUAWEI C8817L"},{"manufacturer":"Huawei","market_name":"C8818","codename":"hwC8818","model":"HUAWEI C8818"},{"manufacturer":"Huawei","market_name":"C8826D","codename":"hwc8826D","model":"HUAWEI C8826D"},{"manufacturer":"Huawei","market_name":"C8850","codename":"hwc8850","model":"HUAWEI-C8850"},{"manufacturer":"Huawei","market_name":"CHC-U03","codename":"hwCHC-H","model":"CHC-U03"},{"manufacturer":"Huawei","market_name":"CHC-U23","codename":"hwCHC-H","model":"CHC-U23"},{"manufacturer":"Huawei","market_name":"CHM-CL00","codename":"hwCHM-Q","model":"CHM-CL00"},{"manufacturer":"Huawei","market_name":"CHM-U01","codename":"hwCHM-H","model":"CHM-U01"},{"manufacturer":"Huawei","market_name":"CM990","codename":"hwCM990","model":"CM990"},{"manufacturer":"Huawei","market_name":"CUN-AL00","codename":"HWCUN-L6735","model":"CUN-AL00"},{"manufacturer":"Huawei","market_name":"CUN-TL00","codename":"HWCUN-L6735","model":"CUN-TL00"},{"manufacturer":"Huawei","market_name":"Che1-CL10","codename":"Che1","model":"Che1-CL10"},{"manufacturer":"Huawei","market_name":"Che1-CL20","codename":"Che1","model":"Che1-CL20"},{"manufacturer":"Huawei","market_name":"Che1-L04","codename":"Che1","model":"Che1-L04"},{"manufacturer":"Huawei","market_name":"Che2-L11","codename":"hwChe2","model":"Che2-L11"},{"manufacturer":"Huawei","market_name":"Che2-L23","codename":"hwChe2","model":"Che2-L23"},{"manufacturer":"Huawei","market_name":"Che2-TL00","codename":"hwChe2","model":"Che2-TL00"},{"manufacturer":"Huawei","market_name":"Che2-TL00H","codename":"hwChe2","model":"Che2-TL00H"},{"manufacturer":"Huawei","market_name":"Che2-TL00M","codename":"hwChe2","model":"Che2-TL00M"},{"manufacturer":"Huawei","market_name":"Che2-UL00","codename":"hwChe2","model":"Che2-UL00"},{"manufacturer":"Huawei","market_name":"Cherry Mini","codename":"hwCHC-H","model":"CHC-U01"},{"manufacturer":"Huawei","market_name":"China","codename":"m330","model":"M330"},{"manufacturer":"Huawei","market_name":"Copper Plus","codename":"HWH1611-Q","model":"H1611"},{"manufacturer":"Huawei","market_name":"Copper Plus","codename":"HWH1611-Q","model":"HUAWEI H1611"},{"manufacturer":"Huawei","market_name":"D2","codename":"hwD2-0082","model":"HUAWEI D2-0082"},{"manufacturer":"Huawei","market_name":"D2","codename":"hwD2-2010","model":"HUAWEI D2-2010"},{"manufacturer":"Huawei","market_name":"D2","codename":"hwD2-6070","model":"HUAWEI D2-6070"},{"manufacturer":"Huawei","market_name":"DAV","codename":"HWP8max","model":"HUAWEI P8max"},{"manufacturer":"Huawei","market_name":"ECO","codename":"HWLUA-L6735","model":"HUAWEI LUA-L03"},{"manufacturer":"Huawei","market_name":"ECO","codename":"HWLUA-L6735","model":"HUAWEI LUA-L13"},{"manufacturer":"Huawei","market_name":"ECO","codename":"HWLUA-L6735","model":"HUAWEI LUA-L23"},{"manufacturer":"Huawei","market_name":"ECO","codename":"HWLUA-U6582","model":"HUAWEI LUA-U03"},{"manufacturer":"Huawei","market_name":"ECO","codename":"HWLUA-U6582","model":"HUAWEI LUA-U23"},{"manufacturer":"Huawei","market_name":"ES8100","codename":"hwes8100","model":"ES8100"},{"manufacturer":"Huawei","market_name":"ES8500","codename":"hwes8500","model":"HuaweiES8500"},{"manufacturer":"Huawei","market_name":"FIG-LX1","codename":"HWFIG-H","model":"FIG-LX1"},{"manufacturer":"Huawei","market_name":"FRD-L02","codename":"HWFRD","model":"FRD-L02"},{"manufacturer":"Huawei","market_name":"Fusion 2","codename":"hwu8665","model":"Huawei-U8665"},{"manufacturer":"Huawei","market_name":"G350","codename":"hwg350","model":"HUAWEI G350"},{"manufacturer":"Huawei","market_name":"G350","codename":"hwg350","model":"HUAWEI G350-U00"},{"manufacturer":"Huawei","market_name":"G350-U20","codename":"HWG350","model":"HUAWEI G350-U20"},{"manufacturer":"Huawei","market_name":"G506","codename":"hwG506-U151","model":"HUAWEI G506-U151"},{"manufacturer":"Huawei","market_name":"G510","codename":"hwG510-0010","model":"HUAWEI G510-0010"},{"manufacturer":"Huawei","market_name":"G510","codename":"hwG510-0100","model":"HUAWEI G510-0100"},{"manufacturer":"Huawei","market_name":"G510","codename":"hwG510-0100","model":"HuaweiG510-0100"},{"manufacturer":"Huawei","market_name":"G510","codename":"hwG510-0100","model":"HuaweiG510-0100-orange"},{"manufacturer":"Huawei","market_name":"G510","codename":"hwG510-0200","model":"HUAWEI Ascend G510"},{"manufacturer":"Huawei","market_name":"G510","codename":"hwG510-0200","model":"HUAWEI G510-0200"},{"manufacturer":"Huawei","market_name":"G510","codename":"hwG510-0200","model":"Orange Daytona"},{"manufacturer":"Huawei","market_name":"G520","codename":"hwG520-5000","model":"HUAWEI G520-5000"},{"manufacturer":"Huawei","market_name":"G521-L076","codename":"HWG521-L","model":"HUAWEI G521-L076"},{"manufacturer":"Huawei","market_name":"G521-L176","codename":"HWG521-L","model":"HUAWEI G521-L176"},{"manufacturer":"Huawei","market_name":"G526","codename":"hwG526-L11","model":"G526-L11"},{"manufacturer":"Huawei","market_name":"G526","codename":"hwG526-L22","model":"G526-L22"},{"manufacturer":"Huawei","market_name":"G526","codename":"hwG526-L33","model":"G526-L33"},{"manufacturer":"Huawei","market_name":"G527","codename":"hwG527-U081","model":"G527-U081"},{"manufacturer":"Huawei","market_name":"G535-L11","codename":"hwG535-L11","model":"HUAWEI G535-L11"},{"manufacturer":"Huawei","market_name":"G535-L11","codename":"hwG535-L11","model":"Kestrel"},{"manufacturer":"Huawei","market_name":"G535-L11","codename":"hwG535-L11","model":"Orange Gova"},{"manufacturer":"Huawei","market_name":"G535-L11","codename":"hwG535-L11","model":"Speedsurfer"},{"manufacturer":"Huawei","market_name":"G535-L11","codename":"hwG535-L11","model":"Ultym5"},{"manufacturer":"Huawei","market_name":"G6","codename":"hwG6-T00","model":"HUAWEI G6-T00"},{"manufacturer":"Huawei","market_name":"G6-C00","codename":"hwG6-C00","model":"HUAWEI G6-C00"},{"manufacturer":"Huawei","market_name":"G6-L11","codename":"hwG6-L11","model":"HUAWEI G6-L11"},{"manufacturer":"Huawei","market_name":"G6-L22","codename":"hwG6-L22","model":"HUAWEI G6-L22"},{"manufacturer":"Huawei","market_name":"G6-L33","codename":"hwG6-L33","model":"HUAWEI G6-L33"},{"manufacturer":"Huawei","market_name":"G6-U00","codename":"hwG6-U00","model":"HUAWEI G6-U00"},{"manufacturer":"Huawei","market_name":"G6-U10","codename":"hwG6-U10","model":"HUAWEI G6-U10"},{"manufacturer":"Huawei","market_name":"G6-U251","codename":"hwG6-U251","model":"HUAWEI G6-U251"},{"manufacturer":"Huawei","market_name":"G6-U34","codename":"hwG6-U34","model":"HUAWEI G6-U34"},{"manufacturer":"Huawei","market_name":"G606","codename":"HWG606","model":"HUAWEI G606-T00"},{"manufacturer":"Huawei","market_name":"G606-T00","codename":"HWG606-T00","model":"HUAWEI G606-T00"},{"manufacturer":"Huawei","market_name":"G610","codename":"hwG610-T00","model":"HUAWEI G610-T00"},{"manufacturer":"Huawei","market_name":"G610","codename":"hwG610-U00","model":"G610-U00"},{"manufacturer":"Huawei","market_name":"G610","codename":"hwG610-U00","model":"HUAWEI G610-U00"},{"manufacturer":"Huawei","market_name":"G610","codename":"hwG610-U30","model":"HUAWEI G610-U30"},{"manufacturer":"Huawei","market_name":"G610-T01","codename":"hwG610-T01","model":"HUAWEI G610-T01"},{"manufacturer":"Huawei","market_name":"G610-T11","codename":"hwG610-T11","model":"HUAWEI G610-T11"},{"manufacturer":"Huawei","market_name":"G610-U15","codename":"hwG610-U15","model":"HUAWEI G610-U15"},{"manufacturer":"Huawei","market_name":"G610-U20","codename":"hwG610-U20","model":"HUAWEI G610-U20"},{"manufacturer":"Huawei","market_name":"G610C","codename":"hwG610-C00","model":"HUAWEI G610-C00"},{"manufacturer":"Huawei","market_name":"G615-U10","codename":"hwG615-U10","model":"G615-U10"},{"manufacturer":"Huawei","market_name":"G615-U10","codename":"hwG615-U10","model":"HUAWEI G615-U10"},{"manufacturer":"Huawei","market_name":"G616-L076","codename":"HWG616-L","model":"HUAWEI G616-L076"},{"manufacturer":"Huawei","market_name":"G620-A2","codename":"hwG620-A2","model":"HUAWEI G620-A2"},{"manufacturer":"Huawei","market_name":"G620-L72","codename":"hwG620-L72","model":"HUAWEI G620-L72"},{"manufacturer":"Huawei","market_name":"G620-L75","codename":"hwG620-L75","model":"G620-L75"},{"manufacturer":"Huawei","market_name":"G620S-L01","codename":"hwG620S-L01","model":"G620S-L01"},{"manufacturer":"Huawei","market_name":"G620S-L02","codename":"hwG620S-L02","model":"G620S-L02"},{"manufacturer":"Huawei","market_name":"G620S-L03","codename":"hwG620S-L03","model":"G620S-L03"},{"manufacturer":"Huawei","market_name":"G620S-L03","codename":"hwG620S-L03","model":"HUAWEI G620"},{"manufacturer":"Huawei","market_name":"G620S-L03","codename":"hwG620S-L03","model":"Personal Huawei G620S"},{"manufacturer":"Huawei","market_name":"G620S-UL00","codename":"hwG620S-UL00","model":"G620S-UL00"},{"manufacturer":"Huawei","market_name":"G621-TL00","codename":"hwG621-TL00","model":"G621-TL00"},{"manufacturer":"Huawei","market_name":"G621-TL00M","codename":"hwG621-TL00","model":"G621-TL00M"},{"manufacturer":"Huawei","market_name":"G628-TL00","codename":"HWG628-TL","model":"HUAWEI G628-TL00"},{"manufacturer":"Huawei","market_name":"G629-UL00","codename":"HWG629-UL","model":"HUAWEI G629-UL00"},{"manufacturer":"Huawei","market_name":"G630","codename":"hwG630-T00","model":"HUAWEI G630-T00"},{"manufacturer":"Huawei","market_name":"G630-U00","codename":"hwG630-U00","model":"HUAWEI G630-U00"},{"manufacturer":"Huawei","market_name":"G630-U10","codename":"hwG630-U10","model":"G630-U10"},{"manufacturer":"Huawei","market_name":"G630-U20","codename":"hwG630-U20","model":"G630-U20"},{"manufacturer":"Huawei","market_name":"G630-U251","codename":"hwG630-U251","model":"G630-U251"},{"manufacturer":"Huawei","market_name":"G630-U251","codename":"hwG630-U251","model":"HUAWEI G630-U251"},{"manufacturer":"Huawei","market_name":"G660-L075","codename":"hwG660-L075","model":"HUAWEI G660-L075"},{"manufacturer":"Huawei","market_name":"G7 Plus","codename":"HWRIO","model":"HUAWEI RIO-TL00"},{"manufacturer":"Huawei","market_name":"G7 Plus","codename":"HWRIO","model":"HUAWEI RIO-UL00"},{"manufacturer":"Huawei","market_name":"G7-L01","codename":"hwG7-L01","model":"G7-L01"},{"manufacturer":"Huawei","market_name":"G7-L01","codename":"hwG7-L01","model":"HUAWEI G7-L01"},{"manufacturer":"Huawei","market_name":"G7-L02","codename":"hwG7-L02","model":"HUAWEI G7-L02"},{"manufacturer":"Huawei","market_name":"G7-L03","codename":"hwG7-L03","model":"G7-L03"},{"manufacturer":"Huawei","market_name":"G7-L03","codename":"hwG7-L03","model":"HUAWEI G7"},{"manufacturer":"Huawei","market_name":"G7-L03","codename":"hwG7-L03","model":"HUAWEI G7-L03"},{"manufacturer":"Huawei","market_name":"G7-L11","codename":"hwG7-L11","model":"HUAWEI G7-L11"},{"manufacturer":"Huawei","market_name":"G7-TL00","codename":"hwG7-TL00","model":"G7-TL00"},{"manufacturer":"Huawei","market_name":"G7-TL00","codename":"hwG7-TL00","model":"HUAWEI G7-TL00"},{"manufacturer":"Huawei","market_name":"G7-UL20","codename":"hwG7-UL20","model":"HUAWEI G7-UL20"},{"manufacturer":"Huawei","market_name":"G700","codename":"hwG700-T00","model":"HUAWEI G700-T00"},{"manufacturer":"Huawei","market_name":"G700","codename":"hwG700-U00","model":"HUAWEI G700-U00"},{"manufacturer":"Huawei","market_name":"G700-T01","codename":"hwG700-T01","model":"HUAWEI G700-T01"},{"manufacturer":"Huawei","market_name":"G700-U10","codename":"hwG700-U10","model":"HUAWEI G700-U10"},{"manufacturer":"Huawei","market_name":"G700-U20","codename":"hwG700-U20","model":"HUAWEI G700-U20"},{"manufacturer":"Huawei","market_name":"G716","codename":"hwG716-L070","model":"HUAWEI G716-L070"},{"manufacturer":"Huawei","market_name":"G718","codename":"hwg718","model":"HUAWEI G718"},{"manufacturer":"Huawei","market_name":"G730","codename":"hwG730-C00","model":"HUAWEI G730-C00"},{"manufacturer":"Huawei","market_name":"G730","codename":"hwG730-T00","model":"HUAWEI G730-T00"},{"manufacturer":"Huawei","market_name":"G730","codename":"hwG730-U00","model":"HUAWEI G730-U00"},{"manufacturer":"Huawei","market_name":"G730-L075","codename":"hwG730-L075","model":"HUAWEI G730-L075"},{"manufacturer":"Huawei","market_name":"G730-U10","codename":"hwG730-U10","model":"HUAWEI G730-U10"},{"manufacturer":"Huawei","market_name":"G730-U251","codename":"hwG730-U251","model":"HUAWEI G730-U251"},{"manufacturer":"Huawei","market_name":"G730-U27","codename":"hwG730-U27","model":"HUAWEI G730-U27"},{"manufacturer":"Huawei","market_name":"G730-U30","codename":"hwG730-U30","model":"HUAWEI G730-U30"},{"manufacturer":"Huawei","market_name":"G735-L03","codename":"hwG735","model":"G735-L03"},{"manufacturer":"Huawei","market_name":"G735-L12","codename":"hwG735","model":"G735-L12"},{"manufacturer":"Huawei","market_name":"G735-L23","codename":"hwG735","model":"G735-L23"},{"manufacturer":"Huawei","market_name":"G740","codename":"hwG740-L00","model":"G740-L00"},{"manufacturer":"Huawei","market_name":"G740","codename":"hwG740-L00","model":"Orange Yumo"},{"manufacturer":"Huawei","market_name":"G750-T00","codename":"hwG750-T00","model":"HUAWEI G750-T00"},{"manufacturer":"Huawei","market_name":"G750-T01","codename":"hwG750-T01","model":"HUAWEI G750-T01"},{"manufacturer":"Huawei","market_name":"G750-T01M","codename":"hwG750-T01M","model":"HUAWEI G750-T01M"},{"manufacturer":"Huawei","market_name":"G750-T20","codename":"hwG750-T20","model":"HUAWEI G750-T20"},{"manufacturer":"Huawei","market_name":"G750-U10","codename":"hwG750-U10","model":"HUAWEI G750-U10"},{"manufacturer":"Huawei","market_name":"G7500","codename":"HWG7500","model":"HUAWEI G7500"},{"manufacturer":"Huawei","market_name":"G8","codename":"HWRIO","model":"HUAWEI RIO-L02"},{"manufacturer":"Huawei","market_name":"G8","codename":"HWRIO","model":"HUAWEI RIO-L03"},{"manufacturer":"Huawei","market_name":"G8","codename":"HWRIO","model":"RIO-L03"},{"manufacturer":"Huawei","market_name":"G8","codename":"hwRIO-L02","model":"HUAWEI RIO-L02"},{"manufacturer":"Huawei","market_name":"G8","codename":"hwRIO-L03","model":"HUAWEI RIO-L03"},{"manufacturer":"Huawei","market_name":"G9 Plus","codename":"HWMLA","model":"HUAWEI MLA-TL00"},{"manufacturer":"Huawei","market_name":"G9 Plus","codename":"HWMLA","model":"HUAWEI MLA-TL10"},{"manufacturer":"Huawei","market_name":"G9 Plus","codename":"HWMLA","model":"HUAWEI MLA-UL00"},{"manufacturer":"Huawei","market_name":"G9 Plus","codename":"HWMLA","model":"MLA-TL00"},{"manufacturer":"Huawei","market_name":"G9 Plus","codename":"HWMLA","model":"MLA-UL00"},{"manufacturer":"Huawei","market_name":"G9\\xe9\\x9d\\x92\\xe6\\x98\\xa5\\xe7\\x89\\x88","codename":"HWVNS-Q","model":"HUAWEI VNS-AL00"},{"manufacturer":"Huawei","market_name":"GR3","codename":"HWTAG-L6753","model":"HUAWEI TAG-L01"},{"manufacturer":"Huawei","market_name":"GR3","codename":"HWTAG-L6753","model":"HUAWEI TAG-L03"},{"manufacturer":"Huawei","market_name":"GR3","codename":"HWTAG-L6753","model":"HUAWEI TAG-L13"},{"manufacturer":"Huawei","market_name":"GR3","codename":"HWTAG-L6753","model":"HUAWEI TAG-L21"},{"manufacturer":"Huawei","market_name":"GR3","codename":"HWTAG-L6753","model":"HUAWEI TAG-L22"},{"manufacturer":"Huawei","market_name":"GR3","codename":"HWTAG-L6753","model":"HUAWEI TAG-L23"},{"manufacturer":"Huawei","market_name":"GR3 2017","codename":"HWDIG-L8940","model":"DIG-L01"},{"manufacturer":"Huawei","market_name":"GR3 2017","codename":"HWDIG-L8940","model":"DIG-L21"},{"manufacturer":"Huawei","market_name":"GR3 2017","codename":"HWDIG-L8940","model":"DIG-L22"},{"manufacturer":"Huawei","market_name":"GR3 Smart touch","codename":"HWTAG-L6753","model":"HUAWEI TAG-L32"},{"manufacturer":"Huawei","market_name":"GR5","codename":"HWKII-Q","model":"HUAWEI KII-L03"},{"manufacturer":"Huawei","market_name":"GR5","codename":"HWKII-Q","model":"HUAWEI KII-L05"},{"manufacturer":"Huawei","market_name":"GR5","codename":"HWKII-Q","model":"HUAWEI KII-L21"},{"manufacturer":"Huawei","market_name":"GR5","codename":"HWKII-Q","model":"HUAWEI KII-L22"},{"manufacturer":"Huawei","market_name":"GR5","codename":"HWKII-Q","model":"HUAWEI KII-L23"},{"manufacturer":"Huawei","market_name":"GR5","codename":"HWKII-Q","model":"HUAWEI KII-L33"},{"manufacturer":"Huawei","market_name":"GR5","codename":"HWKII-Q","model":"KII-L21"},{"manufacturer":"Huawei","market_name":"GR5W","codename":"HWH1621-Q","model":"H1621"},{"manufacturer":"Huawei","market_name":"GT3","codename":"HWNMO-H","model":"HUAWEI NMO-L21"},{"manufacturer":"Huawei","market_name":"GT3","codename":"HWNMO-H","model":"HUAWEI NMO-L22"},{"manufacturer":"Huawei","market_name":"GT3","codename":"HWNMO-H","model":"HUAWEI NMO-L23"},{"manufacturer":"Huawei","market_name":"GT3","codename":"HWNMO-H","model":"HUAWEI NMO-L31"},{"manufacturer":"Huawei","market_name":"GX8","codename":"hwRIO-L01","model":"HUAWEI"},{"manufacturer":"Huawei","market_name":"GX8","codename":"hwRIO-L01","model":"HUAWEI RIO-L01"},{"manufacturer":"Huawei","market_name":"Gran_Roraima","codename":"hws7721u","model":"Orinoquia Gran Roraima + S7-722u"},{"manufacturer":"Huawei","market_name":"H30-C00","codename":"hwH30-C00","model":"H30-C00"},{"manufacturer":"Huawei","market_name":"H30-L01","codename":"hwH30","model":"HONOR H30-L01"},{"manufacturer":"Huawei","market_name":"H30-L01M","codename":"hwH30","model":"HONOR H30-L01M"},{"manufacturer":"Huawei","market_name":"H30-L02","codename":"hwH30","model":"H30-L02"},{"manufacturer":"Huawei","market_name":"H30-L02","codename":"hwH30","model":"HONOR H30-L02"},{"manufacturer":"Huawei","market_name":"H30-T00","codename":"hwH30-T00","model":"H30-T00"},{"manufacturer":"Huawei","market_name":"H60","codename":"hwH60","model":"H60-L01"},{"manufacturer":"Huawei","market_name":"H60-J1","codename":"hwH60","model":"HW-H60-J1"},{"manufacturer":"Huawei","market_name":"H60-L01","codename":"hwH60","model":"H60-L01"},{"manufacturer":"Huawei","market_name":"H60-L02","codename":"hwH60","model":"H60-L02"},{"manufacturer":"Huawei","market_name":"H60-L03","codename":"hwH60","model":"H60-L03"},{"manufacturer":"Huawei","market_name":"H60-L04","codename":"hwH60","model":"H60-L04"},{"manufacturer":"Huawei","market_name":"H60-L11","codename":"hwH60","model":"H60-L11"},{"manufacturer":"Huawei","market_name":"H60-L12","codename":"hwH60","model":"H60-L12"},{"manufacturer":"Huawei","market_name":"H60-L21","codename":"hwH60","model":"H60-L21"},{"manufacturer":"Huawei","market_name":"H60-L21","codename":"hwH60-L21","model":"H60-L21"},{"manufacturer":"Huawei","market_name":"H871G","codename":"hwh871g","model":"HUAWEI H871G"},{"manufacturer":"Huawei","market_name":"H882L","codename":"hwh882l","model":"H882L"},{"manufacturer":"Huawei","market_name":"H891L","codename":"hwH891L","model":"HUAWEI H891L"},{"manufacturer":"Huawei","market_name":"H892L","codename":"hwH892L","model":"HUAWEI H892L"},{"manufacturer":"Huawei","market_name":"HAUWEI Y5 Lite 2018","codename":"HWCAG-L6737M","model":"CAG-L22"},{"manufacturer":"Huawei","market_name":"HONOR 4X","codename":"hwChe2","model":"Che2-L12"},{"manufacturer":"Huawei","market_name":"HUAWEI G Elite Plus","codename":"HWSLA-Q","model":"SLA-L03"},{"manufacturer":"Huawei","market_name":"HUAWEI GR5 2017","codename":"HWBLN-H","model":"BLL-L21"},{"manufacturer":"Huawei","market_name":"HUAWEI GR5 2017","codename":"HWBLN-H","model":"BLL-L22"},{"manufacturer":"Huawei","market_name":"HUAWEI GR5 2017","codename":"HWBLN-H","model":"HUAWEI BLL-L21"},{"manufacturer":"Huawei","market_name":"HUAWEI GR5 2017","codename":"HWBLN-H","model":"HUAWEI BLL-L22"},{"manufacturer":"Huawei","market_name":"HUAWEI Mate 9 lite","codename":"HWBLN-H","model":"BLL-L23"},{"manufacturer":"Huawei","market_name":"HUAWEI Mate 9 lite","codename":"HWBLN-H","model":"HUAWEI BLL-L23"},{"manufacturer":"Huawei","market_name":"HUAWEI Mate SE","codename":"HWBND-H","model":"BND-L34"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad M3 Lite","codename":"HWCPN-Q","model":"701HW"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad M3 Lite","codename":"HWCPN-Q","model":"702HW"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad M3 Lite","codename":"HWCPN-Q","model":"CPN-AL00"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad M3 Lite","codename":"HWCPN-Q","model":"CPN-L09"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad M3 Lite","codename":"HWCPN-Q","model":"CPN-W09"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad M3 Lite 10 wp","codename":"HWHDN-H","model":"HDN-L09"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad M3 Lite 10 wp","codename":"HWHDN-H","model":"HDN-W09"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad M5","codename":"HWCMR09","model":"CMR-AL09"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad M5","codename":"HWCMR09","model":"CMR-W09"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad M5","codename":"HWSHT","model":"SHT-AL09"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad M5","codename":"HWSHT","model":"SHT-W09"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad M5 Pro","codename":"HWCMR","model":"CMR-AL19"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad M5 Pro","codename":"HWCMR","model":"CMR-W19"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad T3 10","codename":"HWAGS-Q","model":"AGS-L03"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad T3 10","codename":"HWAGS-Q","model":"AGS-L09"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad T3 10","codename":"HWAGS-Q","model":"AGS-W09"},{"manufacturer":"Huawei","market_name":"HUAWEI MediaPad T3 7","codename":"HWBG2","model":"BG2-U03"},{"manufacturer":"Huawei","market_name":"HUAWEI P smart","codename":"HWFIG-H","model":"FIG-LA1"},{"manufacturer":"Huawei","market_name":"HUAWEI P smart","codename":"HWFIG-H","model":"FIG-LX2"},{"manufacturer":"Huawei","market_name":"HUAWEI P smart","codename":"HWFIG-H","model":"FIG-LX3"},{"manufacturer":"Huawei","market_name":"HUAWEI P20 Lite","codename":"HWANE","model":"ANE-LX2J"},{"manufacturer":"Huawei","market_name":"HUAWEI P9 lite mini","codename":"HWSLA-Q","model":"SLA-L02"},{"manufacturer":"Huawei","market_name":"HUAWEI P9 lite mini","codename":"HWSLA-Q","model":"SLA-L22"},{"manufacturer":"Huawei","market_name":"HUAWEI P9 lite mini","codename":"HWSLA-Q","model":"SLA-L23"},{"manufacturer":"Huawei","market_name":"HUAWEI Y3 2017","codename":"HWCRO-L6737M","model":"CRO-L02"},{"manufacturer":"Huawei","market_name":"HUAWEI Y3 2017","codename":"HWCRO-L6737M","model":"CRO-L22"},{"manufacturer":"Huawei","market_name":"HUAWEI Y3 2017","codename":"HWCRO-L6737M","model":"HUAWEI CRO-L02"},{"manufacturer":"Huawei","market_name":"HUAWEI Y3 2017","codename":"HWCRO-L6737M","model":"HUAWEI CRO-L22"},{"manufacturer":"Huawei","market_name":"HUAWEI Y3 2018","codename":"HWCAG-L6737M","model":"CAG-L02"},{"manufacturer":"Huawei","market_name":"HUAWEI Y3 2018","codename":"HWCAG-L6737M","model":"CAG-L22"},{"manufacturer":"Huawei","market_name":"HUAWEI Y5 lite 2017","codename":"HWCRO-L6737M","model":"CRO-L03"},{"manufacturer":"Huawei","market_name":"HUAWEI Y5 lite 2017","codename":"HWCRO-L6737M","model":"CRO-L23"},{"manufacturer":"Huawei","market_name":"HUAWEI Y5 lite 2017","codename":"HWCRO-L6737M","model":"HUAWEI CRO-L03"},{"manufacturer":"Huawei","market_name":"HUAWEI Y5 lite 2017","codename":"HWCRO-L6737M","model":"HUAWEI CRO-L23"},{"manufacturer":"Huawei","market_name":"HUAWEI Y5 lite 2018","codename":"HWCAG-L6737M","model":"CAG-L03"},{"manufacturer":"Huawei","market_name":"HUAWEI Y5 lite 2018","codename":"HWCAG-L6737M","model":"CAG-L23"},{"manufacturer":"Huawei","market_name":"HUAWEI Y6 2017","codename":"HWMYA-L6737","model":"MYA-L11"},{"manufacturer":"Huawei","market_name":"HUAWEI Y6 2018","codename":"HWATU-QG","model":"ATU-L11"},{"manufacturer":"Huawei","market_name":"HUAWEI Y6 2018","codename":"HWATU-QG","model":"ATU-L21"},{"manufacturer":"Huawei","market_name":"HUAWEI Y6 2018","codename":"HWATU-QG","model":"ATU-L22"},{"manufacturer":"Huawei","market_name":"HUAWEI Y6 2018","codename":"HWATU-QG","model":"ATU-LX3"},{"manufacturer":"Huawei","market_name":"HUAWEI Y6 Prime 2018","codename":"HWATU-QG","model":"ATU-L31"},{"manufacturer":"Huawei","market_name":"HUAWEI Y6 Prime 2018","codename":"HWATU-QG","model":"ATU-L42"},{"manufacturer":"Huawei","market_name":"HUAWEI Y6II","codename":"HWCAM-H","model":"HUAWEI CAM-L53"},{"manufacturer":"Huawei","market_name":"HUAWEI Y7 2018","codename":"HWLDN-Q","model":"LDN-L01"},{"manufacturer":"Huawei","market_name":"HUAWEI Y7 2018","codename":"HWLDN-Q","model":"LDN-L21"},{"manufacturer":"Huawei","market_name":"HUAWEI Y7 2018","codename":"HWLDN-Q","model":"LDN-LX3"},{"manufacturer":"Huawei","market_name":"HUAWEI Y7 Prime 2018","codename":"HWLDN-Q","model":"LDN-L21"},{"manufacturer":"Huawei","market_name":"HUAWEI Y9 2018","codename":"HWFLA-H","model":"FLA-LX1"},{"manufacturer":"Huawei","market_name":"HUAWEI Y9 2018","codename":"HWFLA-H","model":"FLA-LX2"},{"manufacturer":"Huawei","market_name":"HUAWEI Y9 2018","codename":"HWFLA-H","model":"FLA-LX3"},{"manufacturer":"Huawei","market_name":"HUAWEI nova 2 Plus","codename":"HWBAC","model":"BAC-L21"},{"manufacturer":"Huawei","market_name":"HUAWEI nova 2 Plus","codename":"HWBAC","model":"BAC-L22"},{"manufacturer":"Huawei","market_name":"HUAWEI nova 2 lite","codename":"HWLDN-Q","model":"LDN-LX2"},{"manufacturer":"Huawei","market_name":"HUAWEI nova lite for Y!mobile","codename":"HWPRA-H","model":"608HW"},{"manufacturer":"Huawei","market_name":"HUWEI MediaPad T3","codename":"HWKobe-Q","model":"KOB-L09"},{"manufacturer":"Huawei","market_name":"HUWEI MediaPad T3","codename":"HWKobe-Q","model":"KOB-W09"},{"manufacturer":"Huawei","market_name":"HW-03E","codename":"HW-03E","model":"HW-03E"},{"manufacturer":"Huawei","market_name":"HWT31","codename":"hwfdra04l","model":"HWT31"},{"manufacturer":"Huawei","market_name":"Hol-T00","codename":"HWHol-T","model":"Hol-T00"},{"manufacturer":"Huawei","market_name":"Hol-U10","codename":"HWHol-U","model":"Hol-U10"},{"manufacturer":"Huawei","market_name":"Hol-U19","codename":"HWHol-U","model":"Hol-U19"},{"manufacturer":"Huawei","market_name":"Honor 10","codename":"HWCOL","model":"COL-AL00"},{"manufacturer":"Huawei","market_name":"Honor 10","codename":"HWCOL","model":"COL-AL10"},{"manufacturer":"Huawei","market_name":"Honor 10","codename":"HWCOL","model":"COL-L29"},{"manufacturer":"Huawei","market_name":"Honor 10","codename":"HWCOL","model":"COL-TL10"},{"manufacturer":"Huawei","market_name":"Honor 4A","codename":"hnSCC-Q","model":"SCC-U21"},{"manufacturer":"Huawei","market_name":"Honor 4A","codename":"hnSCL-Q","model":"SCL-AL00"},{"manufacturer":"Huawei","market_name":"Honor 4A","codename":"hnSCL-Q","model":"SCL-CL00"},{"manufacturer":"Huawei","market_name":"Honor 4A","codename":"hnSCL-Q","model":"SCL-TL00"},{"manufacturer":"Huawei","market_name":"Honor 4A","codename":"hnSCL-Q","model":"SCL-TL00H"},{"manufacturer":"Huawei","market_name":"Honor 5A","codename":"HWLYO-L6735","model":"HUAWEI LYO-L21"},{"manufacturer":"Huawei","market_name":"Honor 5A","codename":"HWLYO-L6735","model":"LYO-L21"},{"manufacturer":"Huawei","market_name":"Honor 5C","codename":"HNNEM-H","model":"NEM-L21"},{"manufacturer":"Huawei","market_name":"Honor 5C","codename":"HNNEM-H","model":"NEM-L22"},{"manufacturer":"Huawei","market_name":"Honor 5C","codename":"HNNEM-H","model":"NEM-L51"},{"manufacturer":"Huawei","market_name":"Honor 5X","codename":"HNKIW-Q","model":"KIW-L21"},{"manufacturer":"Huawei","market_name":"Honor 5X","codename":"HNKIW-Q","model":"KIW-TL00H"},{"manufacturer":"Huawei","market_name":"Honor 6A","codename":"HWDLI-Q","model":"DLI-L22"},{"manufacturer":"Huawei","market_name":"Honor 6A","codename":"HWDLI-Q","model":"DLI-TL20"},{"manufacturer":"Huawei","market_name":"Honor 6X","codename":"HWBLN-H","model":"BLN-L24"},{"manufacturer":"Huawei","market_name":"Honor 7","codename":"HWPLK","model":"PLK-AL10"},{"manufacturer":"Huawei","market_name":"Honor 7","codename":"HWPLK","model":"PLK-CL00"},{"manufacturer":"Huawei","market_name":"Honor 7","codename":"HWPLK","model":"PLK-L01"},{"manufacturer":"Huawei","market_name":"Honor 7","codename":"HWPLK","model":"PLK-TL00"},{"manufacturer":"Huawei","market_name":"Honor 7","codename":"HWPLK","model":"PLK-TL01H"},{"manufacturer":"Huawei","market_name":"Honor 7","codename":"HWPLK","model":"PLK-UL00"},{"manufacturer":"Huawei","market_name":"Honor 7A","codename":"HWAUM-Q","model":"AUM-AL00"},{"manufacturer":"Huawei","market_name":"Honor 7A","codename":"HWAUM-Q","model":"AUM-AL20"},{"manufacturer":"Huawei","market_name":"Honor 7A","codename":"HWAUM-Q","model":"AUM-L29"},{"manufacturer":"Huawei","market_name":"Honor 7A","codename":"HWAUM-Q","model":"AUM-TL00"},{"manufacturer":"Huawei","market_name":"Honor 7A","codename":"HWAUM-Q","model":"AUM-TL20"},{"manufacturer":"Huawei","market_name":"Honor 7C","codename":"HWAUM-Q","model":"AUM-L41"},{"manufacturer":"Huawei","market_name":"Honor 7C","codename":"HWLND-Q","model":"LND-AL30"},{"manufacturer":"Huawei","market_name":"Honor 7C","codename":"HWLND-Q","model":"LND-AL40"},{"manufacturer":"Huawei","market_name":"Honor 7C","codename":"HWLND-Q","model":"LND-L29"},{"manufacturer":"Huawei","market_name":"Honor 7C","codename":"HWLND-Q","model":"LND-TL30"},{"manufacturer":"Huawei","market_name":"Honor 7C","codename":"HWLND-Q","model":"LND-TL40"},{"manufacturer":"Huawei","market_name":"Honor 7X","codename":"HWBND-H","model":"BND-L21"},{"manufacturer":"Huawei","market_name":"Honor 7X","codename":"HWBND-H","model":"BND-L24"},{"manufacturer":"Huawei","market_name":"Honor 7X","codename":"HWBND-H","model":"BND-L31"},{"manufacturer":"Huawei","market_name":"Honor 7i","codename":"HWATH","model":"ATH-AL00"},{"manufacturer":"Huawei","market_name":"Honor 7i","codename":"HWATH","model":"ATH-CL00"},{"manufacturer":"Huawei","market_name":"Honor 8","codename":"HWFRD","model":"FRD-AL00"},{"manufacturer":"Huawei","market_name":"Honor 8","codename":"HWFRD","model":"FRD-AL10"},{"manufacturer":"Huawei","market_name":"Honor 8","codename":"HWFRD","model":"FRD-DL00"},{"manufacturer":"Huawei","market_name":"Honor 8","codename":"HWFRD","model":"FRD-L04"},{"manufacturer":"Huawei","market_name":"Honor 8","codename":"HWFRD","model":"FRD-L09"},{"manufacturer":"Huawei","market_name":"Honor 8","codename":"HWFRD","model":"FRD-L14"},{"manufacturer":"Huawei","market_name":"Honor 8","codename":"HWFRD","model":"FRD-L19"},{"manufacturer":"Huawei","market_name":"Honor 8","codename":"HWFRD","model":"FRD-L24"},{"manufacturer":"Huawei","market_name":"Honor 8","codename":"HWFRD","model":"FRD-TL00"},{"manufacturer":"Huawei","market_name":"Honor 8 Pro","codename":"HWDUK","model":"DUK-L09"},{"manufacturer":"Huawei","market_name":"Honor 8 Smart","codename":"HWVNS-H","model":"VEN-L22"},{"manufacturer":"Huawei","market_name":"Honor 9","codename":"HWSTF","model":"STF-AL00"},{"manufacturer":"Huawei","market_name":"Honor 9","codename":"HWSTF","model":"STF-AL10"},{"manufacturer":"Huawei","market_name":"Honor 9","codename":"HWSTF","model":"STF-L09"},{"manufacturer":"Huawei","market_name":"Honor 9","codename":"HWSTF","model":"STF-TL10"},{"manufacturer":"Huawei","market_name":"Honor 9 Lite","codename":"HWLLD-H","model":"LLD-L21"},{"manufacturer":"Huawei","market_name":"Honor 9 Lite","codename":"HWLLD-H","model":"LLD-L31"},{"manufacturer":"Huawei","market_name":"Honor Box","codename":"m321","model":"M321"},{"manufacturer":"Huawei","market_name":"Honor Box Pro","codename":"hwHiTV-M1","model":"HiTV-M1"},{"manufacturer":"Huawei","market_name":"Honor Box voice","codename":"HWM311","model":"M311"},{"manufacturer":"Huawei","market_name":"Honor Magic","codename":"HWNTS","model":"HUAWEI NTS-AL00"},{"manufacturer":"Huawei","market_name":"Honor Magic","codename":"HWNTS","model":"NTS-AL00"},{"manufacturer":"Huawei","market_name":"Honor Play","codename":"HWCOR","model":"COR-AL00"},{"manufacturer":"Huawei","market_name":"Honor Play","codename":"HWCOR","model":"COR-AL10"},{"manufacturer":"Huawei","market_name":"Honor Play","codename":"HWCOR","model":"COR-TL10"},{"manufacturer":"Huawei","market_name":"Honor V10","codename":"HWBKL","model":"BKL-AL00"},{"manufacturer":"Huawei","market_name":"Honor V10","codename":"HWBKL","model":"BKL-AL20"},{"manufacturer":"Huawei","market_name":"Honor V10","codename":"HWBKL","model":"BKL-TL10"},{"manufacturer":"Huawei","market_name":"Honor V8","codename":"HWKNT","model":"KNT-AL10"},{"manufacturer":"Huawei","market_name":"Honor V8","codename":"HWKNT","model":"KNT-AL20"},{"manufacturer":"Huawei","market_name":"Honor V8","codename":"HWKNT","model":"KNT-TL10"},{"manufacturer":"Huawei","market_name":"Honor V8","codename":"HWKNT","model":"KNT-UL10"},{"manufacturer":"Huawei","market_name":"Honor V9","codename":"HWDUK","model":"DUK-AL20"},{"manufacturer":"Huawei","market_name":"Honor V9","codename":"HWDUK","model":"DUK-TL30"},{"manufacturer":"Huawei","market_name":"Honor View 10","codename":"HWBKL","model":"BKL-L04"},{"manufacturer":"Huawei","market_name":"Honor View 10","codename":"HWBKL","model":"BKL-L09"},{"manufacturer":"Huawei","market_name":"Honor3","codename":"hwH30-T10","model":"H30-T10"},{"manufacturer":"Huawei","market_name":"Honor3","codename":"hwH30-U10","model":"H30-U10"},{"manufacturer":"Huawei","market_name":"Honor3","codename":"hwhn3-u00","model":"HUAWEI HN3-U00"},{"manufacturer":"Huawei","market_name":"Honor3","codename":"hwhn3-u01","model":"HUAWEI HN3-U01"},{"manufacturer":"Huawei","market_name":"Huawei Ascend XT2\\xe2\\x84\\xa2","codename":"HWH1711-Q","model":"H1711"},{"manufacturer":"Huawei","market_name":"Huawei Elate\\xe2\\x84\\xa2","codename":"HWH1711-Q","model":"H1711z"},{"manufacturer":"Huawei","market_name":"Huawei Nova 2","codename":"HWPIC","model":"PIC-LX9"},{"manufacturer":"Huawei","market_name":"IDEOS","codename":"U8150","model":"Comet"},{"manufacturer":"Huawei","market_name":"IDEOS","codename":"U8150","model":"Ideos"},{"manufacturer":"Huawei","market_name":"IDEOS","codename":"u8150","model":"Ideos"},{"manufacturer":"Huawei","market_name":"Ice-Twist","codename":"Ice-Twist","model":"Ice-Twist"},{"manufacturer":"Huawei","market_name":"Ideos X5","codename":"hwu8800-51","model":"Huawei U8800-51"},{"manufacturer":"Huawei","market_name":"Ideos X5","codename":"hwu8800-51","model":"IDEOS X5"},{"manufacturer":"Huawei","market_name":"Ideos X5","codename":"hwu8800-51","model":"U8800"},{"manufacturer":"Huawei","market_name":"Ideos X5","codename":"hwu8800-51","model":"U8800-51"},{"manufacturer":"Huawei","market_name":"Kiwi-2","codename":"HWH710VL-Q","model":"H1622"},{"manufacturer":"Huawei","market_name":"LISZT","codename":"hwliszt","model":"HUAWEI M2-A01L"},{"manufacturer":"Huawei","market_name":"LISZT","codename":"hwliszt","model":"HUAWEI M2-A01W"},{"manufacturer":"Huawei","market_name":"M2","codename":"HWMozart","model":"HUAWEI M2-801L"},{"manufacturer":"Huawei","market_name":"M2","codename":"HWMozart","model":"HUAWEI M2-801W"},{"manufacturer":"Huawei","market_name":"M2","codename":"HWMozart","model":"HUAWEI M2-802L"},{"manufacturer":"Huawei","market_name":"M2","codename":"HWMozart","model":"HUAWEI M2-803L"},{"manufacturer":"Huawei","market_name":"M220","codename":"hwmediaqm220","model":"M220"},{"manufacturer":"Huawei","market_name":"M220","codename":"hwmediaqm220","model":"M220c"},{"manufacturer":"Huawei","market_name":"M220","codename":"hwmediaqm220","model":"dTV01"},{"manufacturer":"Huawei","market_name":"M3","codename":"hwbeethoven","model":"BTV-DL09"},{"manufacturer":"Huawei","market_name":"M3","codename":"hwbeethoven","model":"BTV-W09"},{"manufacturer":"Huawei","market_name":"M310","codename":"hwsingleboxm310w","model":"M310"},{"manufacturer":"Huawei","market_name":"M620","codename":"M620","model":"M620"},{"manufacturer":"Huawei","market_name":"M620","codename":"M620","model":"TB01"},{"manufacturer":"Huawei","market_name":"M835","codename":"hwm835","model":"HUAWEI-M835"},{"manufacturer":"Huawei","market_name":"M860","codename":"M860","model":"M860"},{"manufacturer":"Huawei","market_name":"M865","codename":"hwm865","model":"M865"},{"manufacturer":"Huawei","market_name":"M865","codename":"hwm865","model":"USCCADR3305"},{"manufacturer":"Huawei","market_name":"M868","codename":"hwm868","model":"HUAWEI M868"},{"manufacturer":"Huawei","market_name":"MAIMANG 6","codename":"HWRNE","model":"RNE-AL00"},{"manufacturer":"Huawei","market_name":"MS4C","codename":"hwMS4C","model":"MS4C"},{"manufacturer":"Huawei","market_name":"MT1","codename":"hwmt1-u06","model":"HUAWEI MT1-U06"},{"manufacturer":"Huawei","market_name":"MT2-L01","codename":"hwmt2-l01","model":"HUAWEI MT2-L01"},{"manufacturer":"Huawei","market_name":"MT2-L02","codename":"hwmt2-l02","model":"HUAWEI MT2-L02"},{"manufacturer":"Huawei","market_name":"MT2-L03","codename":"hwMT2L03","model":"MT2L03"},{"manufacturer":"Huawei","market_name":"MT2-L05","codename":"hwmt2-l05","model":"HUAWEI MT2-L05"},{"manufacturer":"Huawei","market_name":"MT2L03LITE","codename":"hwMT2L03LITE","model":"MT2L03"},{"manufacturer":"Huawei","market_name":"Mate","codename":"hwmt1-t00","model":"HUAWEI MT1-T00"},{"manufacturer":"Huawei","market_name":"Mate 10","codename":"HWALP","model":"ALP-AL00"},{"manufacturer":"Huawei","market_name":"Mate 10","codename":"HWALP","model":"ALP-L09"},{"manufacturer":"Huawei","market_name":"Mate 10","codename":"HWALP","model":"ALP-L29"},{"manufacturer":"Huawei","market_name":"Mate 10","codename":"HWALP","model":"ALP-TL00"},{"manufacturer":"Huawei","market_name":"Mate 10 Pro","codename":"HWBLA","model":"BLA-A09"},{"manufacturer":"Huawei","market_name":"Mate 10 Pro","codename":"HWBLA","model":"BLA-AL00"},{"manufacturer":"Huawei","market_name":"Mate 10 Pro","codename":"HWBLA","model":"BLA-L09"},{"manufacturer":"Huawei","market_name":"Mate 10 Pro","codename":"HWBLA","model":"BLA-L29"},{"manufacturer":"Huawei","market_name":"Mate 10 Pro","codename":"HWBLA","model":"BLA-TL00"},{"manufacturer":"Huawei","market_name":"Mate 10 lite","codename":"HWRNE","model":"RNE-L01"},{"manufacturer":"Huawei","market_name":"Mate 10 lite","codename":"HWRNE","model":"RNE-L03"},{"manufacturer":"Huawei","market_name":"Mate 10 lite","codename":"HWRNE","model":"RNE-L21"},{"manufacturer":"Huawei","market_name":"Mate 10 lite","codename":"HWRNE","model":"RNE-L23"},{"manufacturer":"Huawei","market_name":"Mate 7","codename":"hwmt7","model":"HUAWEI MT7-CL00"},{"manufacturer":"Huawei","market_name":"Mate 7","codename":"hwmt7","model":"HUAWEI MT7-J1"},{"manufacturer":"Huawei","market_name":"Mate 7","codename":"hwmt7","model":"HUAWEI MT7-L09"},{"manufacturer":"Huawei","market_name":"Mate 7","codename":"hwmt7","model":"HUAWEI MT7-TL00"},{"manufacturer":"Huawei","market_name":"Mate 7","codename":"hwmt7","model":"HUAWEI MT7-TL10"},{"manufacturer":"Huawei","market_name":"Mate 7","codename":"hwmt7","model":"HUAWEI MT7-UL00"},{"manufacturer":"Huawei","market_name":"Mate 8","codename":"HWNXT","model":"HUAWEI NXT-AL10"},{"manufacturer":"Huawei","market_name":"Mate 8","codename":"HWNXT","model":"HUAWEI NXT-CL00"},{"manufacturer":"Huawei","market_name":"Mate 8","codename":"HWNXT","model":"HUAWEI NXT-DL00"},{"manufacturer":"Huawei","market_name":"Mate 8","codename":"HWNXT","model":"HUAWEI NXT-L09"},{"manufacturer":"Huawei","market_name":"Mate 8","codename":"HWNXT","model":"HUAWEI NXT-L29"},{"manufacturer":"Huawei","market_name":"Mate 8","codename":"HWNXT","model":"HUAWEI NXT-TL00"},{"manufacturer":"Huawei","market_name":"Mate 8","codename":"HWNXT","model":"HUAWEI NXT-TL00B"},{"manufacturer":"Huawei","market_name":"Mate 8","codename":"HWNXT","model":"NXT-AL10"},{"manufacturer":"Huawei","market_name":"Mate 8","codename":"HWNXT","model":"NXT-CL00"},{"manufacturer":"Huawei","market_name":"Mate 8","codename":"HWNXT","model":"NXT-DL00"},{"manufacturer":"Huawei","market_name":"Mate 8","codename":"HWNXT","model":"NXT-L09"},{"manufacturer":"Huawei","market_name":"Mate 8","codename":"HWNXT","model":"NXT-L29"},{"manufacturer":"Huawei","market_name":"Mate 8","codename":"HWNXT","model":"NXT-TL00"},{"manufacturer":"Huawei","market_name":"Mate 9","codename":"HWMHA","model":"MHA-AL00"},{"manufacturer":"Huawei","market_name":"Mate 9","codename":"HWMHA","model":"MHA-L09"},{"manufacturer":"Huawei","market_name":"Mate 9","codename":"HWMHA","model":"MHA-L29"},{"manufacturer":"Huawei","market_name":"Mate 9","codename":"HWMHA","model":"MHA-TL00"},{"manufacturer":"Huawei","market_name":"Mate 9 Pro","codename":"HWLON","model":"LON-AL00"},{"manufacturer":"Huawei","market_name":"Mate 9 Pro","codename":"HWLON","model":"LON-L29"},{"manufacturer":"Huawei","market_name":"Mate S","codename":"HWCRR","model":"HUAWEI CRR-CL00"},{"manufacturer":"Huawei","market_name":"Mate S","codename":"HWCRR","model":"HUAWEI CRR-CL20"},{"manufacturer":"Huawei","market_name":"Mate S","codename":"HWCRR","model":"HUAWEI CRR-L09"},{"manufacturer":"Huawei","market_name":"Mate S","codename":"HWCRR","model":"HUAWEI CRR-TL00"},{"manufacturer":"Huawei","market_name":"Mate S","codename":"HWCRR","model":"HUAWEI CRR-UL00"},{"manufacturer":"Huawei","market_name":"Mate S","codename":"HWCRR","model":"HUAWEI CRR-UL20"},{"manufacturer":"Huawei","market_name":"Mate2","codename":"hwmt2-c00","model":"HUAWEI MT2-C00"},{"manufacturer":"Huawei","market_name":"MediaPad","codename":"hwt1701","model":"HUAWEI MediaPad T1 7.0 3G"},{"manufacturer":"Huawei","market_name":"MediaPad","codename":"hwt1701","model":"T1 7.0"},{"manufacturer":"Huawei","market_name":"MediaPad","codename":"hwt1701","model":"T1-701u"},{"manufacturer":"Huawei","market_name":"MediaPad","codename":"hwt1701","model":"T1-701ua"},{"manufacturer":"Huawei","market_name":"MediaPad","codename":"hwt1701","model":"T1-701us"},{"manufacturer":"Huawei","market_name":"MediaPad","codename":"hwt1701","model":"T1-701w"},{"manufacturer":"Huawei","market_name":"MediaPad","codename":"hwt1701","model":"Telpad QS"},{"manufacturer":"Huawei","market_name":"MediaPad 10 FHD","codename":"hws10101l","model":"MediaPad 10 FHD"},{"manufacturer":"Huawei","market_name":"MediaPad 10 Link","codename":"hws10201w","model":"MediaPad 10 LINK"},{"manufacturer":"Huawei","market_name":"MediaPad 10 Link","codename":"hws10201w","model":"dtab 01"},{"manufacturer":"Huawei","market_name":"MediaPad 10 Link+","codename":"hws10231l","model":"402HW"},{"manufacturer":"Huawei","market_name":"MediaPad 10 Link+","codename":"hws10231l","model":"MediaPad 10 Link+"},{"manufacturer":"Huawei","market_name":"MediaPad 10 Link+","codename":"hws10231l","model":"S10-232L"},{"manufacturer":"Huawei","market_name":"MediaPad 10 Link+","codename":"hws10231l","model":"SpeedTAB"},{"manufacturer":"Huawei","market_name":"MediaPad 7 Lite","codename":"hws7930u","model":"MediaPad 7 Lite"},{"manufacturer":"Huawei","market_name":"MediaPad 7 Lite Quad","codename":"hws7961w","model":"Telpad QS"},{"manufacturer":"Huawei","market_name":"MediaPad 7 Lite Quad","codename":"hws7961w","model":"Telpad Quad S"},{"manufacturer":"Huawei","market_name":"MediaPad 7 Vogue","codename":"hws7601us","model":"MediaPad 7 Vogue"},{"manufacturer":"Huawei","market_name":"MediaPad 7 Youth2","codename":"hws7721u","model":"MediaPad 7 Youth 2"},{"manufacturer":"Huawei","market_name":"MediaPad 7 Youth2","codename":"hws7721u","model":"S7-721u"},{"manufacturer":"Huawei","market_name":"MediaPad M1 8.0","codename":"hws8301l","model":"403HW"},{"manufacturer":"Huawei","market_name":"MediaPad M1 8.0","codename":"hws8301l","model":"CNPC Security Pad S1"},{"manufacturer":"Huawei","market_name":"MediaPad M1 8.0","codename":"hws8301l","model":"HUAWEI MediaPad M1 8.0"},{"manufacturer":"Huawei","market_name":"MediaPad M1 8.0","codename":"hws8301l","model":"MediaPad M1 8.0"},{"manufacturer":"Huawei","market_name":"MediaPad M1 8.0","codename":"hws8301l","model":"MediaPad M1 8.0 (LTE)"},{"manufacturer":"Huawei","market_name":"MediaPad M1 8.0","codename":"hws8301l","model":"MediaPad M1 8.0 (WIFI)"},{"manufacturer":"Huawei","market_name":"MediaPad M1 8.0","codename":"hws8301l","model":"S8-303L"},{"manufacturer":"Huawei","market_name":"MediaPad M1 8.0","codename":"hws8301l","model":"S8-303LT"},{"manufacturer":"Huawei","market_name":"MediaPad M1 8.0","codename":"hws8301l","model":"S8-306L"},{"manufacturer":"Huawei","market_name":"MediaPad M3 Lite 10","codename":"HWBAH-Q","model":"BAH-AL00"},{"manufacturer":"Huawei","market_name":"MediaPad M3 Lite 10","codename":"HWBAH-Q","model":"BAH-L09"},{"manufacturer":"Huawei","market_name":"MediaPad M3 Lite 10","codename":"HWBAH-Q","model":"BAH-W09"},{"manufacturer":"Huawei","market_name":"MediaPad T2 10.0 Pro","codename":"hwfdr","model":"605HW"},{"manufacturer":"Huawei","market_name":"MediaPad T2 10.0 Pro","codename":"hwfdr","model":"606HW"},{"manufacturer":"Huawei","market_name":"MediaPad T2 10.0 Pro","codename":"hwfdr","model":"FDR-A05L"},{"manufacturer":"Huawei","market_name":"MediaPad T2 10.0 pro","codename":"HWFDR","model":"FDR-A01L"},{"manufacturer":"Huawei","market_name":"MediaPad T2 10.0 pro","codename":"HWFDR","model":"FDR-A01w"},{"manufacturer":"Huawei","market_name":"MediaPad T2 10.0 pro","codename":"HWFDR","model":"FDR-A03L"},{"manufacturer":"Huawei","market_name":"MediaPad T2 7.0","codename":"hwbgo","model":"BGO-DL09"},{"manufacturer":"Huawei","market_name":"MediaPad T2 7.0","codename":"hwbgo","model":"BGO-L03"},{"manufacturer":"Huawei","market_name":"MediaPad T2 8.0 Pro","codename":"hwjdn","model":"JDN-AL00"},{"manufacturer":"Huawei","market_name":"MediaPad T2 8.0 Pro","codename":"hwjdn","model":"JDN-L01"},{"manufacturer":"Huawei","market_name":"MediaPad T2 8.0 Pro","codename":"hwjdn","model":"JDN-W09"},{"manufacturer":"Huawei","market_name":"MediaPad T3 7","codename":"HWBG2","model":"BG2-U01"},{"manufacturer":"Huawei","market_name":"MediaPad T3 7","codename":"hwbg2","model":"BG2-W09"},{"manufacturer":"Huawei","market_name":"MediaPad Vogue","codename":"hws7601u","model":"MediaPad 7 Lite II"},{"manufacturer":"Huawei","market_name":"MediaPad Vogue","codename":"hws7601u","model":"MediaPad 7 Vogue"},{"manufacturer":"Huawei","market_name":"MediaPad X1 7.0","codename":"hw7d501l","model":"7D-501u"},{"manufacturer":"Huawei","market_name":"MediaPad X1 7.0","codename":"hw7d501l","model":"MediaPad X1"},{"manufacturer":"Huawei","market_name":"MediaPad X1 7.0","codename":"hw7d501l","model":"MediaPad X1 7.0"},{"manufacturer":"Huawei","market_name":"MediaPad X1 7.0","codename":"hw7d501l","model":"X1 7.0"},{"manufacturer":"Huawei","market_name":"MediaPad Youth","codename":"hws7701w","model":"MediaPad 7 Youth"},{"manufacturer":"Huawei","market_name":"MediaPad7","codename":"hws7601w","model":"MediaPad 7 Vogue"},{"manufacturer":"Huawei","market_name":"MediaQ M380","codename":"HWM380","model":"M380-10"},{"manufacturer":"Huawei","market_name":"Nexus 6P","codename":"angler","model":"Nexus 6P"},{"manufacturer":"Huawei","market_name":"P10","codename":"HWVTR","model":"VTR-AL00"},{"manufacturer":"Huawei","market_name":"P10","codename":"HWVTR","model":"VTR-L09"},{"manufacturer":"Huawei","market_name":"P10","codename":"HWVTR","model":"VTR-L29"},{"manufacturer":"Huawei","market_name":"P10","codename":"HWVTR","model":"VTR-TL00"},{"manufacturer":"Huawei","market_name":"P10 Plus","codename":"HWVKY","model":"VKY-AL00"},{"manufacturer":"Huawei","market_name":"P10 Plus","codename":"HWVKY","model":"VKY-L09"},{"manufacturer":"Huawei","market_name":"P10 Plus","codename":"HWVKY","model":"VKY-L29"},{"manufacturer":"Huawei","market_name":"P10 Plus","codename":"HWVKY","model":"VKY-TL00"},{"manufacturer":"Huawei","market_name":"P10 lite","codename":"HWWAS-H","model":"WAS-L03T"},{"manufacturer":"Huawei","market_name":"P10 lite","codename":"HWWAS-H","model":"WAS-LX1"},{"manufacturer":"Huawei","market_name":"P10 lite","codename":"HWWAS-H","model":"WAS-LX1A"},{"manufacturer":"Huawei","market_name":"P10 lite","codename":"HWWAS-H","model":"WAS-LX2"},{"manufacturer":"Huawei","market_name":"P10 lite","codename":"HWWAS-H","model":"WAS-LX2J"},{"manufacturer":"Huawei","market_name":"P10 lite","codename":"HWWAS-H","model":"WAS-LX3"},{"manufacturer":"Huawei","market_name":"P2","codename":"hwp2-6070","model":"HUAWEI P2-6070"},{"manufacturer":"Huawei","market_name":"P20","codename":"HWEML","model":"EML-AL00"},{"manufacturer":"Huawei","market_name":"P20","codename":"HWEML","model":"EML-L09"},{"manufacturer":"Huawei","market_name":"P20","codename":"HWEML","model":"EML-L29"},{"manufacturer":"Huawei","market_name":"P20","codename":"HWEML","model":"EML-TL00"},{"manufacturer":"Huawei","market_name":"P20 Pro","codename":"HW-01K","model":"HW-01K"},{"manufacturer":"Huawei","market_name":"P20 Pro","codename":"HWCLT","model":"CLT-AL00"},{"manufacturer":"Huawei","market_name":"P20 Pro","codename":"HWCLT","model":"CLT-AL01"},{"manufacturer":"Huawei","market_name":"P20 Pro","codename":"HWCLT","model":"CLT-L04"},{"manufacturer":"Huawei","market_name":"P20 Pro","codename":"HWCLT","model":"CLT-L09"},{"manufacturer":"Huawei","market_name":"P20 Pro","codename":"HWCLT","model":"CLT-L29"},{"manufacturer":"Huawei","market_name":"P20 Pro","codename":"HWCLT","model":"CLT-TL00"},{"manufacturer":"Huawei","market_name":"P20 Pro","codename":"HWCLT","model":"CLT-TL01"},{"manufacturer":"Huawei","market_name":"P20 lite","codename":"HWANE","model":"ANE-LX1"},{"manufacturer":"Huawei","market_name":"P20 lite","codename":"HWANE","model":"ANE-LX2"},{"manufacturer":"Huawei","market_name":"P20 lite","codename":"HWANE","model":"ANE-LX3"},{"manufacturer":"Huawei","market_name":"P6","codename":"hwp6-c00","model":"HUAWEI P6-C00"},{"manufacturer":"Huawei","market_name":"P6","codename":"hwp6-t00","model":"HUAWEI P6-T00"},{"manufacturer":"Huawei","market_name":"P6","codename":"hwp6-t00","model":"HUAWEI P6-T00V"},{"manufacturer":"Huawei","market_name":"P6","codename":"hwp6-u06","model":"HUAWEI Ascend P6"},{"manufacturer":"Huawei","market_name":"P6","codename":"hwp6-u06","model":"HUAWEI P6-U06"},{"manufacturer":"Huawei","market_name":"P6","codename":"hwp6-u06","model":"HUAWEI P6-U06-orange"},{"manufacturer":"Huawei","market_name":"P6S","codename":"hwP6s-l04","model":"P6 S-L04"},{"manufacturer":"Huawei","market_name":"P6S-L04","codename":"hwp6s-l04","model":"302HW"},{"manufacturer":"Huawei","market_name":"P6S-U06","codename":"hwp6s-u06","model":"HUAWEI P6 S-U06"},{"manufacturer":"Huawei","market_name":"P7","codename":"hwp7","model":"HUAWEI P7-L00"},{"manufacturer":"Huawei","market_name":"P7","codename":"hwp7","model":"HUAWEI P7-L05"},{"manufacturer":"Huawei","market_name":"P7","codename":"hwp7","model":"HUAWEI P7-L07"},{"manufacturer":"Huawei","market_name":"P7","codename":"hwp7","model":"HUAWEI P7-L10"},{"manufacturer":"Huawei","market_name":"P7","codename":"hwp7","model":"HUAWEI P7-L11"},{"manufacturer":"Huawei","market_name":"P7","codename":"hwp7","model":"HUAWEI P7-L12"},{"manufacturer":"Huawei","market_name":"P7 mini","codename":"hwP7Mini","model":"HUAWEI P7 mini"},{"manufacturer":"Huawei","market_name":"P7-L09","codename":"hwp7","model":"HUAWEI P7-L09"},{"manufacturer":"Huawei","market_name":"P8","codename":"HWGRA","model":"HUAWEI GRA-CL00"},{"manufacturer":"Huawei","market_name":"P8","codename":"HWGRA","model":"HUAWEI GRA-CL10"},{"manufacturer":"Huawei","market_name":"P8","codename":"HWGRA","model":"HUAWEI GRA-L09"},{"manufacturer":"Huawei","market_name":"P8","codename":"HWGRA","model":"HUAWEI GRA-TL00"},{"manufacturer":"Huawei","market_name":"P8","codename":"HWGRA","model":"HUAWEI GRA-UL00"},{"manufacturer":"Huawei","market_name":"P8","codename":"HWGRA","model":"HUAWEI GRA-UL10"},{"manufacturer":"Huawei","market_name":"P8 Lite","codename":"hwALE-H","model":"503HW"},{"manufacturer":"Huawei","market_name":"P8 Lite","codename":"hwALE-H","model":"ALE-L02"},{"manufacturer":"Huawei","market_name":"P8 Lite","codename":"hwALE-H","model":"ALE-L21"},{"manufacturer":"Huawei","market_name":"P8 Lite","codename":"hwALE-H","model":"ALE-L23"},{"manufacturer":"Huawei","market_name":"P8 Lite","codename":"hwALE-H","model":"Autana LTE"},{"manufacturer":"Huawei","market_name":"P8 Lite","codename":"hwALE-Q","model":"HUAWEI ALE-CL00"},{"manufacturer":"Huawei","market_name":"P8 Lite","codename":"hwALE-Q","model":"HUAWEI ALE-L04"},{"manufacturer":"Huawei","market_name":"P8 lite 2017","codename":"HWPRA-H","model":"PRA-LA1"},{"manufacturer":"Huawei","market_name":"P8 lite 2017","codename":"HWPRA-H","model":"PRA-LX1"},{"manufacturer":"Huawei","market_name":"P8 \\xe9\\x9d\\x92\\xe6\\x98\\xa5\\xe7\\x89\\x88","codename":"hwALE-H","model":"ALE-TL00"},{"manufacturer":"Huawei","market_name":"P8 \\xe9\\x9d\\x92\\xe6\\x98\\xa5\\xe7\\x89\\x88","codename":"hwALE-H","model":"ALE-UL00"},{"manufacturer":"Huawei","market_name":"P8max","codename":"HWP8max","model":"HUAWEI P8max"},{"manufacturer":"Huawei","market_name":"P9","codename":"HWEVA","model":"EVA-AL00"},{"manufacturer":"Huawei","market_name":"P9","codename":"HWEVA","model":"EVA-AL10"},{"manufacturer":"Huawei","market_name":"P9","codename":"HWEVA","model":"EVA-CL00"},{"manufacturer":"Huawei","market_name":"P9","codename":"HWEVA","model":"EVA-DL00"},{"manufacturer":"Huawei","market_name":"P9","codename":"HWEVA","model":"EVA-L09"},{"manufacturer":"Huawei","market_name":"P9","codename":"HWEVA","model":"EVA-L19"},{"manufacturer":"Huawei","market_name":"P9","codename":"HWEVA","model":"EVA-L29"},{"manufacturer":"Huawei","market_name":"P9","codename":"HWEVA","model":"EVA-TL00"},{"manufacturer":"Huawei","market_name":"P9 Lite PREMIUM","codename":"HWVNS-Q","model":"HUAWEI VNS-L52"},{"manufacturer":"Huawei","market_name":"P9 Plus","codename":"HWVIE","model":"VIE-AL10"},{"manufacturer":"Huawei","market_name":"P9 Plus","codename":"HWVIE","model":"VIE-L09"},{"manufacturer":"Huawei","market_name":"P9 Plus","codename":"HWVIE","model":"VIE-L29"},{"manufacturer":"Huawei","market_name":"P9 lite","codename":"HWVNS-H","model":"HUAWEI VNS-L21"},{"manufacturer":"Huawei","market_name":"P9 lite","codename":"HWVNS-H","model":"HUAWEI VNS-L22"},{"manufacturer":"Huawei","market_name":"P9 lite","codename":"HWVNS-H","model":"HUAWEI VNS-L23"},{"manufacturer":"Huawei","market_name":"P9 lite","codename":"HWVNS-H","model":"HUAWEI VNS-L31"},{"manufacturer":"Huawei","market_name":"P9 lite","codename":"HWVNS-H","model":"HUAWEI VNS-L53"},{"manufacturer":"Huawei","market_name":"P9 lite","codename":"HWVNS-Q","model":"HUAWEI VNS-L62"},{"manufacturer":"Huawei","market_name":"P9 lite smart","codename":"HWDIG-L8940","model":"DIG-L03"},{"manufacturer":"Huawei","market_name":"P9 lite smart","codename":"HWDIG-L8940","model":"DIG-L23"},{"manufacturer":"Huawei","market_name":"PE-CL00","codename":"hwPE","model":"PE-CL00"},{"manufacturer":"Huawei","market_name":"PE-TL00M","codename":"hwPE","model":"PE-TL00M"},{"manufacturer":"Huawei","market_name":"PE-TL10","codename":"hwPE","model":"PE-TL10"},{"manufacturer":"Huawei","market_name":"PE-TL20","codename":"hwPE","model":"PE-TL20"},{"manufacturer":"Huawei","market_name":"PE-UL00","codename":"hwPE","model":"PE-UL00"},{"manufacturer":"Huawei","market_name":"PORSCHE DESIGN HUAWEI Mate RS","codename":"HWNEO","model":"NEO-AL00"},{"manufacturer":"Huawei","market_name":"PORSCHE DESIGN HUAWEI Mate RS","codename":"HWNEO","model":"NEO-L29"},{"manufacturer":"Huawei","market_name":"Prism II","codename":"hwu8686","model":"Prism II"},{"manufacturer":"Huawei","market_name":"Q22","codename":"HWQ22","model":"Q22"},{"manufacturer":"Huawei","market_name":"RIO-CL00","codename":"hwRIO-CL00","model":"HUAWEI RIO-CL00"},{"manufacturer":"Huawei","market_name":"S10","codename":"hws10103l","model":"MediaPad 10 FHD"},{"manufacturer":"Huawei","market_name":"S10","codename":"hws10201l","model":"MediaPad 10 LINK"},{"manufacturer":"Huawei","market_name":"S7","codename":"hws7601c","model":"MediaPad 7 Vogue"},{"manufacturer":"Huawei","market_name":"S7","codename":"hws7601w","model":"MediaPad 7 Vogue"},{"manufacturer":"Huawei","market_name":"S7","codename":"hws7701u","model":"MediaPad 7 Youth"},{"manufacturer":"Huawei","market_name":"S7","codename":"hws7930u","model":"Orinoquia Roraima S7-932u"},{"manufacturer":"Huawei","market_name":"S7","codename":"hws7951w","model":"MediaPad 7 Lite+"},{"manufacturer":"Huawei","market_name":"S7","codename":"hws7951w","model":"Telpad Dual S"},{"manufacturer":"Huawei","market_name":"SC-CL00","codename":"HWSC-CL00","model":"HUAWEI SC-CL00"},{"manufacturer":"Huawei","market_name":"SC-UL10","codename":"HWSC-UL10","model":"HUAWEI SC-UL10"},{"manufacturer":"Huawei","market_name":"Sensa LTE","codename":"HWH710VL-Q","model":"H710VL"},{"manufacturer":"Huawei","market_name":"Sensa LTE","codename":"HWH715BL-Q","model":"H715BL"},{"manufacturer":"Huawei","market_name":"ShotX","codename":"HWATH","model":"HUAWEI ATH-UL01"},{"manufacturer":"Huawei","market_name":"ShotX","codename":"HWATH","model":"HUAWEI ATH-UL06"},{"manufacturer":"Huawei","market_name":"T-Mobile Pulse","codename":"U8100","model":"Huawei_8100-9"},{"manufacturer":"Huawei","market_name":"T-Mobile Pulse","codename":"U8100","model":"Tactile internet"},{"manufacturer":"Huawei","market_name":"T-Mobile Pulse","codename":"U8100","model":"U8100"},{"manufacturer":"Huawei","market_name":"T-Mobile Pulse","codename":"U8100","model":"Videocon_V7400"},{"manufacturer":"Huawei","market_name":"T1","codename":"hwt1821l","model":"T1-821L"},{"manufacturer":"Huawei","market_name":"T1","codename":"hwt1821l","model":"T1-821W"},{"manufacturer":"Huawei","market_name":"T1","codename":"hwt1821l","model":"T1-821w"},{"manufacturer":"Huawei","market_name":"T1","codename":"hwt1821l","model":"T1-823L"},{"manufacturer":"Huawei","market_name":"T1","codename":"hwt1823l","model":"T1-823L"},{"manufacturer":"Huawei","market_name":"T1 10","codename":"hwt1a21l","model":"HUAWEI MediaPad T1 10 4G"},{"manufacturer":"Huawei","market_name":"T1 10","codename":"hwt1a21l","model":"T1-A21L"},{"manufacturer":"Huawei","market_name":"T1 10","codename":"hwt1a21l","model":"T1-A21W"},{"manufacturer":"Huawei","market_name":"T1 10","codename":"hwt1a21l","model":"T1-A21w"},{"manufacturer":"Huawei","market_name":"T1 10","codename":"hwt1a21l","model":"T1-A22L"},{"manufacturer":"Huawei","market_name":"T1 10","codename":"hwt1a21l","model":"T1-A23L"},{"manufacturer":"Huawei","market_name":"T101","codename":"hwt101","model":"T-101"},{"manufacturer":"Huawei","market_name":"T101","codename":"hwt101","model":"T101 PAD"},{"manufacturer":"Huawei","market_name":"T102","codename":"hwt102","model":"QH-10"},{"manufacturer":"Huawei","market_name":"T102","codename":"hwt102","model":"T102 PAD"},{"manufacturer":"Huawei","market_name":"T801","codename":"hwt801","model":"T801 PAD"},{"manufacturer":"Huawei","market_name":"T802","codename":"hwt802","model":"MT-803G"},{"manufacturer":"Huawei","market_name":"T802","codename":"hwt802","model":"T802 PAD"},{"manufacturer":"Huawei","market_name":"T8808D","codename":"hwT8808D","model":"HUAWEI T8808D"},{"manufacturer":"Huawei","market_name":"TANGO","codename":"HWTAG-L6753","model":"HUAWEI TAG-AL00"},{"manufacturer":"Huawei","market_name":"TANGO","codename":"HWTAG-L6753","model":"HUAWEI TAG-CL00"},{"manufacturer":"Huawei","market_name":"TANGO","codename":"HWTAG-L6753","model":"HUAWEI TAG-TL00"},{"manufacturer":"Huawei","market_name":"U8120","codename":"U8120","model":"Vodafone 845"},{"manufacturer":"Huawei","market_name":"U8220","codename":"U8220","model":"Pulse"},{"manufacturer":"Huawei","market_name":"U8220","codename":"U8220","model":"U8220"},{"manufacturer":"Huawei","market_name":"U8220","codename":"U8220","model":"U8220PLUS"},{"manufacturer":"Huawei","market_name":"U8230","codename":"U8230","model":"U8230"},{"manufacturer":"Huawei","market_name":"U8652","codename":"hwu8652","model":"Huawei-U8652"},{"manufacturer":"Huawei","market_name":"U8652","codename":"hwu8652","model":"U8652"},{"manufacturer":"Huawei","market_name":"U8687","codename":"hwu8687","model":"Huawei-U8687"},{"manufacturer":"Huawei","market_name":"U8812D","codename":"hwu8812D","model":"U8812D"},{"manufacturer":"Huawei","market_name":"U8832D","codename":"hwu8832D","model":"U8832D"},{"manufacturer":"Huawei","market_name":"U8836D","codename":"hwu8836D","model":"U8836D"},{"manufacturer":"Huawei","market_name":"U8850","codename":"hwu8850","model":"HUAWEI-U8850"},{"manufacturer":"Huawei","market_name":"U9000","codename":"hwu9000","model":"HUAWEI-U9000"},{"manufacturer":"Huawei","market_name":"UNION","codename":"hwY538","model":"Y538"},{"manufacturer":"Huawei","market_name":"V858","codename":"hwu8160","model":"Huawei 858"},{"manufacturer":"Huawei","market_name":"V858","codename":"hwu8160","model":"MTC 950"},{"manufacturer":"Huawei","market_name":"V858","codename":"hwu8160","model":"MTC Mini"},{"manufacturer":"Huawei","market_name":"V858","codename":"hwu8160","model":"Vodafone 858"},{"manufacturer":"Huawei","market_name":"Vogue7","codename":"hws7601u","model":"MediaPad 7 Classic"},{"manufacturer":"Huawei","market_name":"Vogue7","codename":"hws7601u","model":"MediaPad 7 Lite II"},{"manufacturer":"Huawei","market_name":"Vogue7","codename":"hws7601u","model":"MediaPad 7 Vogue"},{"manufacturer":"Huawei","market_name":"WATCH","codename":"sturgeon","model":"HUAWEI WATCH"},{"manufacturer":"Huawei","market_name":"WATCH","codename":"sturgeon","model":"HUAWEI-WATCH"},{"manufacturer":"Huawei","market_name":"Watch 2","codename":"sawfish","model":"LEO-BX9"},{"manufacturer":"Huawei","market_name":"Watch 2","codename":"sawshark","model":"LEO-DLXX"},{"manufacturer":"Huawei","market_name":"X2","codename":"HWGemini","model":"GEM-701L"},{"manufacturer":"Huawei","market_name":"X2","codename":"HWGemini","model":"GEM-702L"},{"manufacturer":"Huawei","market_name":"X2","codename":"HWGemini","model":"GEM-703L"},{"manufacturer":"Huawei","market_name":"X2","codename":"HWGemini","model":"GEM-703LT"},{"manufacturer":"Huawei","market_name":"Y210","codename":"oay210","model":"Orinoquia Auyantepui Y210"},{"manufacturer":"Huawei","market_name":"Y220","codename":"HWY220-U","model":"Y220-U00"},{"manufacturer":"Huawei","market_name":"Y220","codename":"HWY220-U","model":"Y220-U05"},{"manufacturer":"Huawei","market_name":"Y220","codename":"HWY220-U","model":"Y220-U17"},{"manufacturer":"Huawei","market_name":"Y220-T10","codename":"hwy220-t10","model":"HUAWEI Y220-T10"},{"manufacturer":"Huawei","market_name":"Y220-U10","codename":"HWY220-U","model":"Y220-U10"},{"manufacturer":"Huawei","market_name":"Y220T","codename":"hwy220t","model":"HUAWEI Y 220T"},{"manufacturer":"Huawei","market_name":"Y221-U03","codename":"HWY221-U","model":"HUAWEI Y221-U03"},{"manufacturer":"Huawei","market_name":"Y221-U03","codename":"QAY221-U","model":"ORINOQUIA Auyantepui+Y221-U03"},{"manufacturer":"Huawei","market_name":"Y221-U12","codename":"HWY221-U","model":"HUAWEI Y221-U12"},{"manufacturer":"Huawei","market_name":"Y221-U22","codename":"HWY221-U","model":"HUAWEI Y221-U22"},{"manufacturer":"Huawei","market_name":"Y221-U33","codename":"HWY221-U","model":"HUAWEI Y221-U33"},{"manufacturer":"Huawei","market_name":"Y221-U43","codename":"HWY221-U","model":"HUAWEI Y221-U43"},{"manufacturer":"Huawei","market_name":"Y221-U53","codename":"HWY221-U","model":"HUAWEI Y221-U53"},{"manufacturer":"Huawei","market_name":"Y300","codename":"hwY300-0100","model":"HUAWEI Ascend Y300"},{"manufacturer":"Huawei","market_name":"Y300","codename":"hwY300-0100","model":"HUAWEI Y300-0100"},{"manufacturer":"Huawei","market_name":"Y300","codename":"hwY300-0151","model":"HUAWEI Y300-0151"},{"manufacturer":"Huawei","market_name":"Y300","codename":"hwY300-0151","model":"Pelephone-Y300-"},{"manufacturer":"Huawei","market_name":"Y300-0000","codename":"hwY300-0000","model":"HUAWEI Y300-0000"},{"manufacturer":"Huawei","market_name":"Y301A1","codename":"hwY301A1","model":"Huawei Y301A1"},{"manufacturer":"Huawei","market_name":"Y301A2","codename":"hwY301A2","model":"Huawei Y301A2"},{"manufacturer":"Huawei","market_name":"Y310-5000","codename":"hwy310-5000","model":"HUAWEI Y310-5000"},{"manufacturer":"Huawei","market_name":"Y310-T10","codename":"hwy310-t10","model":"HUAWEI Y310-T10"},{"manufacturer":"Huawei","market_name":"Y320","codename":"hwy320-c00","model":"HUAWEI Y320-C00"},{"manufacturer":"Huawei","market_name":"Y320-T00","codename":"HWY320-T00","model":"HUAWEI Y320-T00"},{"manufacturer":"Huawei","market_name":"Y320-U01","codename":"HWY320","model":"HUAWEI Y320-U01"},{"manufacturer":"Huawei","market_name":"Y320-U01","codename":"HWY320","model":"Y320-U01"},{"manufacturer":"Huawei","market_name":"Y320-U10","codename":"HWY320-U","model":"HUAWEI Y320-U10"},{"manufacturer":"Huawei","market_name":"Y320-U151","codename":"HWY320-U","model":"HUAWEI Y320-U151"},{"manufacturer":"Huawei","market_name":"Y320-U30","codename":"HWY320-U","model":"HUAWEI Y320-U30"},{"manufacturer":"Huawei","market_name":"Y320-U351","codename":"HWY320-U","model":"HUAWEI Y320-U351"},{"manufacturer":"Huawei","market_name":"Y321","codename":"HWY321-U","model":"HUAWEI Y321-U051"},{"manufacturer":"Huawei","market_name":"Y321","codename":"hwy321-c00","model":"HUAWEI Y321-C00"},{"manufacturer":"Huawei","market_name":"Y325-T00","codename":"HWY325-T","model":"HUAWEI Y325-T00"},{"manufacturer":"Huawei","market_name":"Y330","codename":"hwY330-U05","model":"Bucare Y330-U05"},{"manufacturer":"Huawei","market_name":"Y330","codename":"hwY330-U05","model":"HUAWEI Y330-U05"},{"manufacturer":"Huawei","market_name":"Y330","codename":"hwY330-U21","model":"HUAWEI Y330-U21"},{"manufacturer":"Huawei","market_name":"Y330-C00","codename":"hwY330-C00","model":"HUAWEI Y330-C00"},{"manufacturer":"Huawei","market_name":"Y330-U01","codename":"hwY330-U01","model":"HUAWEI Y330-U01"},{"manufacturer":"Huawei","market_name":"Y330-U01","codename":"hwY330-U01","model":"Luno"},{"manufacturer":"Huawei","market_name":"Y330-U07","codename":"hwY330-U07","model":"HUAWEI Y330-U07"},{"manufacturer":"Huawei","market_name":"Y330-U08","codename":"hwY330-U08","model":"HUAWEI Y330-U08"},{"manufacturer":"Huawei","market_name":"Y330-U11","codename":"hwY330-U11","model":"HUAWEI Y330-U11"},{"manufacturer":"Huawei","market_name":"Y330-U11","codename":"hwY330-U11","model":"V8510"},{"manufacturer":"Huawei","market_name":"Y330-U15","codename":"hwY330-U15","model":"HUAWEI Y330-U15"},{"manufacturer":"Huawei","market_name":"Y330-U17","codename":"hwY330-U17","model":"HUAWEI Y330-U17"},{"manufacturer":"Huawei","market_name":"Y336-A1","codename":"hwY336-A1","model":"HUAWEI Y336-A1"},{"manufacturer":"Huawei","market_name":"Y336-U02","codename":"HWY336-U","model":"HUAWEI Y336-U02"},{"manufacturer":"Huawei","market_name":"Y336-U12","codename":"HWY336-U","model":"HUAWEI Y336-U12"},{"manufacturer":"Huawei","market_name":"Y340-U081","codename":"hwY340-U081","model":"Y340-U081"},{"manufacturer":"Huawei","market_name":"Y360-U03","codename":"HWY360-U","model":"HUAWEI Y360-U03"},{"manufacturer":"Huawei","market_name":"Y360-U103","codename":"HWY360-U6572","model":"HUAWEI Y360-U103"},{"manufacturer":"Huawei","market_name":"Y360-U12","codename":"HWY360-U","model":"HUAWEI Y360-U12"},{"manufacturer":"Huawei","market_name":"Y360-U23","codename":"HWY360-U","model":"HUAWEI Y360-U23"},{"manufacturer":"Huawei","market_name":"Y360-U31","codename":"HWY360-U","model":"HUAWEI Y360-U31"},{"manufacturer":"Huawei","market_name":"Y360-U42","codename":"HWY360-U","model":"HUAWEI Y360-U42"},{"manufacturer":"Huawei","market_name":"Y360-U61","codename":"HWY360-U","model":"HUAWEI Y360-U61"},{"manufacturer":"Huawei","market_name":"Y360-U72","codename":"HWY360-U6572","model":"HUAWEI Y360-U72"},{"manufacturer":"Huawei","market_name":"Y360-U82","codename":"HWY360-U6572","model":"HUAWEI Y360-U82"},{"manufacturer":"Huawei","market_name":"Y360-U93","codename":"HWY360-U6572","model":"Delta Y360-U93"},{"manufacturer":"Huawei","market_name":"Y360-U93","codename":"HWY360-U6572","model":"HUAWEI Y360-U93"},{"manufacturer":"Huawei","market_name":"Y3II","codename":"HWLUA-L6735","model":"HUAWEI LUA-L01"},{"manufacturer":"Huawei","market_name":"Y3II","codename":"HWLUA-L6735","model":"HUAWEI LUA-L02"},{"manufacturer":"Huawei","market_name":"Y3II","codename":"HWLUA-L6735","model":"HUAWEI LUA-L21"},{"manufacturer":"Huawei","market_name":"Y3II","codename":"HWLUA-U6582","model":"HUAWEI LUA-U02"},{"manufacturer":"Huawei","market_name":"Y3II","codename":"HWLUA-U6582","model":"HUAWEI LUA-U22"},{"manufacturer":"Huawei","market_name":"Y3III","codename":"HWCRO-U6580M","model":"CRO-U00"},{"manufacturer":"Huawei","market_name":"Y3III","codename":"HWCRO-U6580M","model":"CRO-U23"},{"manufacturer":"Huawei","market_name":"Y3III","codename":"HWCRO-U6580M","model":"HUAWEI CRO-U00"},{"manufacturer":"Huawei","market_name":"Y3III","codename":"HWCRO-U6580M","model":"HUAWEI CRO-U23"},{"manufacturer":"Huawei","market_name":"Y5","codename":"HWY560-L","model":"HUAWEI Y560-L02"},{"manufacturer":"Huawei","market_name":"Y5","codename":"HWY560-L","model":"HUAWEI Y560-L23"},{"manufacturer":"Huawei","market_name":"Y5","codename":"HWY560-U","model":"HUAWEI Y560-U03"},{"manufacturer":"Huawei","market_name":"Y5 2017","codename":"HWMYA-L6737","model":"MYA-AL00"},{"manufacturer":"Huawei","market_name":"Y5 2017","codename":"HWMYA-L6737","model":"MYA-L02"},{"manufacturer":"Huawei","market_name":"Y5 2017","codename":"HWMYA-L6737","model":"MYA-L03"},{"manufacturer":"Huawei","market_name":"Y5 2017","codename":"HWMYA-L6737","model":"MYA-L13"},{"manufacturer":"Huawei","market_name":"Y5 2017","codename":"HWMYA-L6737","model":"MYA-L22"},{"manufacturer":"Huawei","market_name":"Y5 2017","codename":"HWMYA-L6737","model":"MYA-L23"},{"manufacturer":"Huawei","market_name":"Y5 2017","codename":"HWMYA-L6737","model":"MYA-TL00"},{"manufacturer":"Huawei","market_name":"Y5 2017","codename":"HWMYA-U6580","model":"MYA-U29"},{"manufacturer":"Huawei","market_name":"Y500-T00","codename":"HWY500-T00","model":"HUAWEI Y500-T00"},{"manufacturer":"Huawei","market_name":"Y511-T00","codename":"HWY511-T","model":"HUAWEI Y511-T00"},{"manufacturer":"Huawei","market_name":"Y511-T00","codename":"HWY511-T","model":"Y511-T00"},{"manufacturer":"Huawei","market_name":"Y511-U00","codename":"HWY511-U","model":"Y511-U00"},{"manufacturer":"Huawei","market_name":"Y511-U10","codename":"HWY511-U","model":"HUAWEI Y511-U10"},{"manufacturer":"Huawei","market_name":"Y511-U251","codename":"HWY511-U","model":"HUAWEI Y511-U251"},{"manufacturer":"Huawei","market_name":"Y511-U30","codename":"HWY511-U","model":"HUAWEI Y511-U30"},{"manufacturer":"Huawei","market_name":"Y511-U30","codename":"HWY511-U","model":"VIETTEL V8506"},{"manufacturer":"Huawei","market_name":"Y516-","codename":"HWY516-T","model":"HUAWEI Y516-T00"},{"manufacturer":"Huawei","market_name":"Y518-T00","codename":"HWY518-T","model":"HUAWEI Y518-T00"},{"manufacturer":"Huawei","market_name":"Y520-U03","codename":"HWY520-U","model":"HUAWEI Y520-U03"},{"manufacturer":"Huawei","market_name":"Y520-U12","codename":"HWY520-U","model":"HUAWEI Y520-U12"},{"manufacturer":"Huawei","market_name":"Y520-U22","codename":"HWY520-U","model":"HUAWEI Y520-U22"},{"manufacturer":"Huawei","market_name":"Y520-U33","codename":"HWY520-U","model":"HUAWEI Y520-U33"},{"manufacturer":"Huawei","market_name":"Y523-L076","codename":"HWY523","model":"HUAWEI Y523-L076"},{"manufacturer":"Huawei","market_name":"Y523-L176","codename":"HWY523","model":"HUAWEI Y523-L176"},{"manufacturer":"Huawei","market_name":"Y530","codename":"hwY530-U00","model":"HUAWEI Y530-U00"},{"manufacturer":"Huawei","market_name":"Y530-U051","codename":"hwY530-U051","model":"HUAWEI Y530"},{"manufacturer":"Huawei","market_name":"Y530-U051","codename":"hwY530-U051","model":"HUAWEI Y530-U051"},{"manufacturer":"Huawei","market_name":"Y535","codename":"HWY535-C00","model":"HUAWEI Y535-C00"},{"manufacturer":"Huawei","market_name":"Y535D-C00","codename":"HWY535D-C00","model":"HUAWEI Y535D-C00"},{"manufacturer":"Huawei","market_name":"Y536-A1","codename":"hwY536A1","model":"HUAWEI Y536A1"},{"manufacturer":"Huawei","market_name":"Y540-U01","codename":"HWY540-U","model":"HUAWEI Y540-U01"},{"manufacturer":"Huawei","market_name":"Y541-U02","codename":"HWY541-U","model":"HUAWEI Y541-U02"},{"manufacturer":"Huawei","market_name":"Y541-U02","codename":"HWY541-U","model":"Y541-U02"},{"manufacturer":"Huawei","market_name":"Y545-U05","codename":"hwY545-U05","model":"Y545-U05"},{"manufacturer":"Huawei","market_name":"Y550-L01","codename":"hwY550-L01","model":"HUAWEI Y550-L01"},{"manufacturer":"Huawei","market_name":"Y550-L02","codename":"hwY550-L02","model":"HUAWEI Y550-L02"},{"manufacturer":"Huawei","market_name":"Y550-L02","codename":"hwY550-L02","model":"Y550-L02"},{"manufacturer":"Huawei","market_name":"Y550-L03","codename":"hwY550-L03","model":"HUAWEI Y550"},{"manufacturer":"Huawei","market_name":"Y550-L03","codename":"hwY550-L03","model":"HUAWEI Y550-L03"},{"manufacturer":"Huawei","market_name":"Y550-L03","codename":"hwY550-L03","model":"Personal Huawei Y550"},{"manufacturer":"Huawei","market_name":"Y550-L03","codename":"hwY550-L03","model":"Y550-L03"},{"manufacturer":"Huawei","market_name":"Y560-CL00","codename":"HWY560-CL","model":"HUAWEI Y560-CL00"},{"manufacturer":"Huawei","market_name":"Y560-L01","codename":"HWY560-L","model":"HUAWEI Y560-L01"},{"manufacturer":"Huawei","market_name":"Y560-L03","codename":"HWY560-L","model":"HUAWEI Y560-L03"},{"manufacturer":"Huawei","market_name":"Y560-U02","codename":"HWY560-U","model":"HUAWEI Y560-U02"},{"manufacturer":"Huawei","market_name":"Y560-U12","codename":"HWY560-U","model":"HUAWEI Y560-U12"},{"manufacturer":"Huawei","market_name":"Y560-U23","codename":"HWY560-U","model":"HUAWEI Y560-U23"},{"manufacturer":"Huawei","market_name":"Y5II","codename":"HWCUN-L6735","model":"CUN-L22"},{"manufacturer":"Huawei","market_name":"Y5II","codename":"HWCUN-L6735","model":"HUAWEI CUN-L01"},{"manufacturer":"Huawei","market_name":"Y5II","codename":"HWCUN-L6735","model":"HUAWEI CUN-L02"},{"manufacturer":"Huawei","market_name":"Y5II","codename":"HWCUN-L6735","model":"HUAWEI CUN-L03"},{"manufacturer":"Huawei","market_name":"Y5II","codename":"HWCUN-L6735","model":"HUAWEI CUN-L21"},{"manufacturer":"Huawei","market_name":"Y5II","codename":"HWCUN-L6735","model":"HUAWEI CUN-L22"},{"manufacturer":"Huawei","market_name":"Y5II","codename":"HWCUN-L6735","model":"HUAWEI CUN-L23"},{"manufacturer":"Huawei","market_name":"Y5II","codename":"HWCUN-L6735","model":"HUAWEI CUN-L33"},{"manufacturer":"Huawei","market_name":"Y5II","codename":"HWCUN-U6582","model":"HUAWEI CUN-U29"},{"manufacturer":"Huawei","market_name":"Y6","codename":"hwSCC-Q","model":"HUAWEI SCC-U21"},{"manufacturer":"Huawei","market_name":"Y6","codename":"hwSCC-Q","model":"SCC-U21"},{"manufacturer":"Huawei","market_name":"Y6","codename":"hwSCL-Q","model":"HUAWEI SCL-L01"},{"manufacturer":"Huawei","market_name":"Y6","codename":"hwSCL-Q","model":"HUAWEI SCL-L02"},{"manufacturer":"Huawei","market_name":"Y6","codename":"hwSCL-Q","model":"HUAWEI SCL-L03"},{"manufacturer":"Huawei","market_name":"Y6","codename":"hwSCL-Q","model":"HUAWEI SCL-L04"},{"manufacturer":"Huawei","market_name":"Y6","codename":"hwSCL-Q","model":"HUAWEI SCL-L21"},{"manufacturer":"Huawei","market_name":"Y6","codename":"hwSCL-Q","model":"HW-SCL-L32"},{"manufacturer":"Huawei","market_name":"Y6","codename":"hwSCL-Q","model":"SCL-L01"},{"manufacturer":"Huawei","market_name":"Y6","codename":"hwSCLU-Q","model":"HUAWEI SCL-U23"},{"manufacturer":"Huawei","market_name":"Y6","codename":"hwSCLU-Q","model":"HUAWEI SCL-U31"},{"manufacturer":"Huawei","market_name":"Y6","codename":"hwSCLU-Q","model":"SCL-U23"},{"manufacturer":"Huawei","market_name":"Y6 2017","codename":"HWMYA-L6737","model":"MYA-L41"},{"manufacturer":"Huawei","market_name":"Y6 Elite","codename":"HWLYO-L6735","model":"HUAWEI LYO-L02"},{"manufacturer":"Huawei","market_name":"Y6 Pro","codename":"HWTIT-AL00","model":"HUAWEI TIT-AL00"},{"manufacturer":"Huawei","market_name":"Y6 Pro","codename":"HWTIT-L6735","model":"HUAWEI TIT-AL00"},{"manufacturer":"Huawei","market_name":"Y6 Pro","codename":"HWTIT-L6735","model":"HUAWEI TIT-CL10"},{"manufacturer":"Huawei","market_name":"Y6 Pro","codename":"HWTIT-L6735","model":"HUAWEI TIT-L01"},{"manufacturer":"Huawei","market_name":"Y6 Pro","codename":"HWTIT-L6735","model":"HUAWEI TIT-TL00"},{"manufacturer":"Huawei","market_name":"Y6 Pro","codename":"HWTIT-L6735","model":"TIT-AL00"},{"manufacturer":"Huawei","market_name":"Y6 Pro","codename":"HWTIT-L6735","model":"TIT-L01"},{"manufacturer":"Huawei","market_name":"Y6 Pro","codename":"HWTIT-L8916","model":"HUAWEI TIT-CL00"},{"manufacturer":"Huawei","market_name":"Y6 Pro","codename":"HWTIT-U6582","model":"HUAWEI TIT-U02"},{"manufacturer":"Huawei","market_name":"Y6 \\xe2\\x85\\xa1 Compact","codename":"HWLYO-L6735","model":"HUAWEI LYO-L01"},{"manufacturer":"Huawei","market_name":"Y600","codename":"HWY600-U","model":"HUAWEI Y600-U00"},{"manufacturer":"Huawei","market_name":"Y600","codename":"HWY600-U","model":"HUAWEI Y600-U151"},{"manufacturer":"Huawei","market_name":"Y600","codename":"HWY600-U","model":"HUAWEI Y600-U20"},{"manufacturer":"Huawei","market_name":"Y600-U351","codename":"HWY600-U","model":"HUAWEI Y600-U351"},{"manufacturer":"Huawei","market_name":"Y600-U40","codename":"HWY600-U","model":"HUAWEI Y600-U40"},{"manufacturer":"Huawei","market_name":"Y600D-C00","codename":"HWY600D-C00","model":"HUAWEI Y600D-C00"},{"manufacturer":"Huawei","market_name":"Y610","codename":"HWY610-U","model":"HUAWEI Y610-U00"},{"manufacturer":"Huawei","market_name":"Y618","codename":"HWY618-T","model":"HUAWEI Y618-T00"},{"manufacturer":"Huawei","market_name":"Y625-U03","codename":"KVY625-U","model":"Kavak Y625-U03"},{"manufacturer":"Huawei","market_name":"Y625-U13","codename":"HWY625-U","model":"HUAWEI Y625-U13"},{"manufacturer":"Huawei","market_name":"Y625-U21","codename":"HWY625-U","model":"HUAWEI Y625-U21"},{"manufacturer":"Huawei","market_name":"Y625-U32","codename":"HWY625-U","model":"HUAWEI Y625-U32"},{"manufacturer":"Huawei","market_name":"Y625-U43","codename":"HWY625-U","model":"HUAWEI Y625-U43"},{"manufacturer":"Huawei","market_name":"Y625-U51","codename":"HWY625-U","model":"HUAWEI Y625-U51"},{"manufacturer":"Huawei","market_name":"Y635-CL00","codename":"hwY635","model":"HUAWEI Y635-CL00"},{"manufacturer":"Huawei","market_name":"Y635-L01","codename":"hwY635","model":"Y635-L01"},{"manufacturer":"Huawei","market_name":"Y635-L02","codename":"hwY635","model":"HUAWEI Y635-L02"},{"manufacturer":"Huawei","market_name":"Y635-L02","codename":"hwY635","model":"Y635-L02"},{"manufacturer":"Huawei","market_name":"Y635-L03","codename":"hwY635","model":"HUAWEI Y635-L03"},{"manufacturer":"Huawei","market_name":"Y635-L03","codename":"hwY635","model":"Y635-L03"},{"manufacturer":"Huawei","market_name":"Y635-L21","codename":"hwY635","model":"Y635-L21"},{"manufacturer":"Huawei","market_name":"Y635-TL00","codename":"hwY635","model":"HUAWEI Y635-TL00"},{"manufacturer":"Huawei","market_name":"Y635-TL00","codename":"hwY635","model":"Y635-TL00"},{"manufacturer":"Huawei","market_name":"Y6II","codename":"HWCAM-H","model":"CAM-L03"},{"manufacturer":"Huawei","market_name":"Y6II","codename":"HWCAM-H","model":"CAM-L21"},{"manufacturer":"Huawei","market_name":"Y6II","codename":"HWCAM-H","model":"CAM-L23"},{"manufacturer":"Huawei","market_name":"Y6II","codename":"HWCAM-H","model":"CAM-U22"},{"manufacturer":"Huawei","market_name":"Y6II","codename":"HWCAM-H","model":"HUAWEI CAM-L03"},{"manufacturer":"Huawei","market_name":"Y6II","codename":"HWCAM-H","model":"HUAWEI CAM-L21"},{"manufacturer":"Huawei","market_name":"Y6II","codename":"HWCAM-H","model":"HUAWEI CAM-L23"},{"manufacturer":"Huawei","market_name":"Y6II","codename":"HWCAM-H","model":"HUAWEI CAM-U22"},{"manufacturer":"Huawei","market_name":"Y6II","codename":"HWCAM-Q","model":"CAM-L32"},{"manufacturer":"Huawei","market_name":"Y6\\xe2\\x85\\xa1Compact","codename":"HWLYO-L6735","model":"HUAWEI LYO-L03"},{"manufacturer":"Huawei","market_name":"Y7","codename":"HWTRT-Q","model":"TRT-L21A"},{"manufacturer":"Huawei","market_name":"Y7","codename":"HWTRT-Q","model":"TRT-L53"},{"manufacturer":"Huawei","market_name":"Y7","codename":"HWTRT-Q","model":"TRT-LX1"},{"manufacturer":"Huawei","market_name":"Y7","codename":"HWTRT-Q","model":"TRT-LX2"},{"manufacturer":"Huawei","market_name":"Y7","codename":"HWTRT-Q","model":"TRT-LX3"},{"manufacturer":"Huawei","market_name":"Youth","codename":"hws7701u","model":"Orinoquia Gran Roraima S7-702u"},{"manufacturer":"Huawei","market_name":"ascend-5w","codename":"HWH1621-Q","model":"H1623"},{"manufacturer":"Huawei","market_name":"d-01G","codename":"d-01G","model":"d-01G"},{"manufacturer":"Huawei","market_name":"d-01H","codename":"d-01H","model":"d-01H"},{"manufacturer":"Huawei","market_name":"d-02H","codename":"d-02H","model":"d-02H"},{"manufacturer":"Huawei","market_name":"eH811","codename":"hweH811","model":"eH811"},{"manufacturer":"Huawei","market_name":"honor 5X","codename":"HNKIW-Q","model":"KIW-L22"},{"manufacturer":"Huawei","market_name":"honor 5X","codename":"HNKIW-Q","model":"KIW-L23"},{"manufacturer":"Huawei","market_name":"honor 5X","codename":"HNKIW-Q","model":"KIW-L24"},{"manufacturer":"Huawei","market_name":"honor 6A Pro","codename":"HWDLI-Q","model":"DLI-L42"},{"manufacturer":"Huawei","market_name":"honor 6C","codename":"HWDIG-L8940","model":"DIG-L21HN"},{"manufacturer":"Huawei","market_name":"honor 6C Pro","codename":"HWJMM","model":"JMM-L22"},{"manufacturer":"Huawei","market_name":"honor 6x","codename":"HWBLN-H","model":"BLN-L21"},{"manufacturer":"Huawei","market_name":"honor 6x","codename":"HWBLN-H","model":"BLN-L22"},{"manufacturer":"Huawei","market_name":"huawei nova 2","codename":"HWPIC","model":"HWV31"},{"manufacturer":"Huawei","market_name":"hw204HW","codename":"hw204HW","model":"204HW"},{"manufacturer":"Huawei","market_name":"m881","codename":"hwm881","model":"HUAWEI M881"},{"manufacturer":"Huawei","market_name":"nova","codename":"HWCAN","model":"HUAWEI CAN-L01"},{"manufacturer":"Huawei","market_name":"nova","codename":"HWCAN","model":"HUAWEI CAN-L02"},{"manufacturer":"Huawei","market_name":"nova","codename":"HWCAN","model":"HUAWEI CAN-L03"},{"manufacturer":"Huawei","market_name":"nova","codename":"HWCAN","model":"HUAWEI CAN-L11"},{"manufacturer":"Huawei","market_name":"nova","codename":"HWCAN","model":"HUAWEI CAN-L12"},{"manufacturer":"Huawei","market_name":"nova","codename":"HWCAN","model":"HUAWEI CAN-L13"},{"manufacturer":"Huawei","market_name":"nova","codename":"HWCAN","model":"HUAWEI CAZ-AL10"},{"manufacturer":"Huawei","market_name":"nova","codename":"HWCAZ","model":"HUAWEI CAZ-AL00"},{"manufacturer":"Huawei","market_name":"nova","codename":"HWCAZ","model":"HUAWEI CAZ-AL10"},{"manufacturer":"Huawei","market_name":"nova","codename":"HWCAZ","model":"HUAWEI CAZ-TL10"},{"manufacturer":"Huawei","market_name":"nova","codename":"HWCAZ","model":"HUAWEI CAZ-TL20"},{"manufacturer":"Huawei","market_name":"nova 2","codename":"HWPIC","model":"PIC-AL00"},{"manufacturer":"Huawei","market_name":"nova 2","codename":"HWPIC","model":"PIC-TL00"},{"manufacturer":"Huawei","market_name":"nova 2 Plus","codename":"HWBAC","model":"BAC-AL00"},{"manufacturer":"Huawei","market_name":"nova 2 Plus","codename":"HWBAC","model":"BAC-L01"},{"manufacturer":"Huawei","market_name":"nova 2 Plus","codename":"HWBAC","model":"BAC-L03"},{"manufacturer":"Huawei","market_name":"nova 2 Plus","codename":"HWBAC","model":"BAC-L23"},{"manufacturer":"Huawei","market_name":"nova 2 Plus","codename":"HWBAC","model":"BAC-TL00"},{"manufacturer":"Huawei","market_name":"nova 2i","codename":"HWRNE","model":"RNE-L02"},{"manufacturer":"Huawei","market_name":"nova 2i","codename":"HWRNE","model":"RNE-L22"},{"manufacturer":"Huawei","market_name":"nova 2s","codename":"HWHWI","model":"HWI-AL00"},{"manufacturer":"Huawei","market_name":"nova 2s","codename":"HWHWI","model":"HWI-TL00"},{"manufacturer":"Huawei","market_name":"nova 3e","codename":"HWANE","model":"ANE-AL00"},{"manufacturer":"Huawei","market_name":"nova 3e","codename":"HWANE","model":"ANE-TL00"},{"manufacturer":"Huawei","market_name":"nova lite","codename":"HWPRA-H","model":"PRA-LX2"},{"manufacturer":"Huawei","market_name":"nova lite","codename":"HWPRA-H","model":"PRA-LX3"},{"manufacturer":"Huawei","market_name":"nova plus","codename":"HWMLA","model":"HUAWEI MLA-L01"},{"manufacturer":"Huawei","market_name":"nova plus","codename":"HWMLA","model":"HUAWEI MLA-L02"},{"manufacturer":"Huawei","market_name":"nova plus","codename":"HWMLA","model":"HUAWEI MLA-L03"},{"manufacturer":"Huawei","market_name":"nova plus","codename":"HWMLA","model":"HUAWEI MLA-L11"},{"manufacturer":"Huawei","market_name":"nova plus","codename":"HWMLA","model":"HUAWEI MLA-L12"},{"manufacturer":"Huawei","market_name":"nova plus","codename":"HWMLA","model":"HUAWEI MLA-L13"},{"manufacturer":"Huawei","market_name":"nova plus","codename":"HWMLA","model":"MLA-L01"},{"manufacturer":"Huawei","market_name":"nova plus","codename":"HWMLA","model":"MLA-L02"},{"manufacturer":"Huawei","market_name":"nova plus","codename":"HWMLA","model":"MLA-L03"},{"manufacturer":"Huawei","market_name":"nova plus","codename":"HWMLA","model":"MLA-L11"},{"manufacturer":"Huawei","market_name":"nova plus","codename":"HWMLA","model":"MLA-L12"},{"manufacturer":"Huawei","market_name":"nova plus","codename":"HWMLA","model":"MLA-L13"},{"manufacturer":"Huawei","market_name":"nova \\xe9\\x9d\\x92\\xe6\\x98\\xa5\\xe7\\x89\\x88\\xe6\\x9c\\xac","codename":"HWWAS-H","model":"WAS-AL00"},{"manufacturer":"Huawei","market_name":"nova \\xe9\\x9d\\x92\\xe6\\x98\\xa5\\xe7\\x89\\x88\\xe6\\x9c\\xac","codename":"HWWAS-H","model":"WAS-TL10"},{"manufacturer":"Huawei","market_name":"t1_8p0","codename":"hws8701","model":"MediaPad T1 8.0"},{"manufacturer":"Huawei","market_name":"t1_8p0","codename":"hws8701","model":"S8-701u"},{"manufacturer":"Huawei","market_name":"t1_8p0","codename":"hws8701","model":"S8-701w"},{"manufacturer":"Huawei","market_name":"t1_8p0lte","codename":"hwt1821l","model":"HUAWEI MediaPad T1 8.0 4G"},{"manufacturer":"Huawei","market_name":"t1_8p0lte","codename":"hwt1821l","model":"Honor T1 8.0"},{"manufacturer":"Huawei","market_name":"t1_8p0lte","codename":"hwt1821l","model":"MediaPad T1 8.0 Pro"},{"manufacturer":"Huawei","market_name":"t1_8p0lte","codename":"hwt1821l","model":"S8-821w"},{"manufacturer":"Huawei","market_name":"t1_8p0lte","codename":"hwt1821l","model":"T1-821w"},{"manufacturer":"Huawei","market_name":"t1_8p0lte","codename":"hwt1821l","model":"T1-823L"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xbaG9\\xe9\\x9d\\x92\\xe6\\x98\\xa5\\xe7\\x89\\x88","codename":"HWVNS-H","model":"HUAWEI VNS-DL00"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xbaG9\\xe9\\x9d\\x92\\xe6\\x98\\xa5\\xe7\\x89\\x88","codename":"HWVNS-H","model":"HUAWEI VNS-TL00"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe5\\xb9\\xb3\\xe6\\x9d\\xbf C5","codename":"HWMON-Q","model":"MON-AL19"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe5\\xb9\\xb3\\xe6\\x9d\\xbf C5","codename":"HWMON-Q","model":"MON-AL19B"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe5\\xb9\\xb3\\xe6\\x9d\\xbf C5","codename":"HWMON-Q","model":"MON-W19"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe5\\xb9\\xb3\\xe6\\x9d\\xbfT3 8\\xe8\\xa1\\x8c\\xe4\\xb8\\x9a\\xe4\\xb8\\x93\\xe4\\xba\\xab\\xe7\\x89\\x88","codename":"HWBZK-Q","model":"BZK-L00"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe5\\xb9\\xb3\\xe6\\x9d\\xbfT3 8\\xe8\\xa1\\x8c\\xe4\\xb8\\x9a\\xe4\\xb8\\x93\\xe4\\xba\\xab\\xe7\\x89\\x88","codename":"HWBZK-Q","model":"BZK-W00"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe6\\x8f\\xbd\\xe9\\x98\\x85M2\\xe9\\x9d\\x92\\xe6\\x98\\xa5\\xe7\\x89\\x887.0","codename":"hwple703l","model":"PLE-701L"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe6\\x8f\\xbd\\xe9\\x98\\x85M2\\xe9\\x9d\\x92\\xe6\\x98\\xa5\\xe7\\x89\\x887.0","codename":"hwple703l","model":"PLE-703L"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab 8e \\xe9\\x9d\\x92\\xe6\\x98\\xa5","codename":"HWDRA-M","model":"DRA-AL00"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab 8e \\xe9\\x9d\\x92\\xe6\\x98\\xa5","codename":"HWDRA-M","model":"DRA-TL00"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab6","codename":"HWNCE-L6750","model":"NCE-AL00"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab6","codename":"HWNCE-L6750","model":"NCE-AL10"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab6","codename":"HWNCE-L6750","model":"NCE-TL10"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab6S","codename":"HWDIG-L8940","model":"DIG-AL00"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab6S","codename":"HWDIG-L8940","model":"DIG-TL10"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab7","codename":"HWSLA-Q","model":"SLA-AL00"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab7","codename":"HWSLA-Q","model":"SLA-TL10"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab7S","codename":"HWFIG-H","model":"FIG-AL00"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab7S","codename":"HWFIG-H","model":"FIG-AL10"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab7S","codename":"HWFIG-H","model":"FIG-TL00"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab7S","codename":"HWFIG-H","model":"FIG-TL10"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab8","codename":"HWLDN-Q","model":"LDN-AL00"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab8","codename":"HWLDN-Q","model":"LDN-AL10"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab8","codename":"HWLDN-Q","model":"LDN-AL20"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab8","codename":"HWLDN-Q","model":"LDN-TL00"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab8","codename":"HWLDN-Q","model":"LDN-TL10"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab8","codename":"HWLDN-Q","model":"LDN-TL20"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab8 Plus","codename":"HWFLA-H","model":"FLA-AL00"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab8 Plus","codename":"HWFLA-H","model":"FLA-AL10"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab8 Plus","codename":"HWFLA-H","model":"FLA-AL20"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab8 Plus","codename":"HWFLA-H","model":"FLA-TL00"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab8 Plus","codename":"HWFLA-H","model":"FLA-TL10"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab8e","codename":"HWATU-QC","model":"ATU-AL10"},{"manufacturer":"Huawei","market_name":"\\xe5\\x8d\\x8e\\xe4\\xb8\\xba\\xe7\\x95\\x85\\xe4\\xba\\xab8e","codename":"HWATU-QC","model":"ATU-TL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80 V9 play","codename":"HWJMM-Q","model":"JMM-AL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80 V9 play","codename":"HWJMM-Q","model":"JMM-AL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80 V9 play","codename":"HWJMM-Q","model":"JMM-TL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80 V9 play","codename":"HWJMM-Q","model":"JMM-TL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x804A","codename":"hwSCL-Q","model":"SCL-AL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x805X","codename":"HNKIW-Q","model":"KIW-AL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x805X","codename":"HNKIW-Q","model":"KIW-AL20"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x805X","codename":"HNKIW-Q","model":"KIW-CL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x805X","codename":"HNKIW-Q","model":"KIW-TL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x805X","codename":"HNKIW-Q","model":"KIW-UL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x808\\xe9\\x9d\\x92\\xe6\\x98\\xa5\\xe7\\x89\\x88","codename":"HWPRA-H","model":"PRA-AL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x808\\xe9\\x9d\\x92\\xe6\\x98\\xa5\\xe7\\x89\\x88","codename":"HWPRA-H","model":"PRA-AL00X"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x808\\xe9\\x9d\\x92\\xe6\\x98\\xa5\\xe7\\x89\\x88","codename":"HWPRA-H","model":"PRA-TL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x809i","codename":"HWLLD-H2","model":"LLD-AL20"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x809i","codename":"HWLLD-H2","model":"LLD-AL30"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x809\\xe9\\x9d\\x92\\xe6\\x98\\xa5\\xe7\\x89\\x88","codename":"HWLLD-H","model":"LLD-AL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x809\\xe9\\x9d\\x92\\xe6\\x98\\xa5\\xe7\\x89\\x88","codename":"HWLLD-H","model":"LLD-AL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x809\\xe9\\x9d\\x92\\xe6\\x98\\xa5\\xe7\\x89\\x88","codename":"HWLLD-H","model":"LLD-TL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80Note8","codename":"hwedison","model":"EDI-AL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80Note8","codename":"hwedison","model":"EDI-DL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe4\\xba\\xab7 Plus","codename":"HWTRT-Q","model":"TRT-AL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe4\\xba\\xab7 Plus","codename":"HWTRT-Q","model":"TRT-AL00A"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe4\\xba\\xab7 Plus","codename":"HWTRT-Q","model":"TRT-TL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe4\\xba\\xab7 Plus","codename":"HWTRT-Q","model":"TRT-TL10A"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa9 6X","codename":"HWBLN-H","model":"BLN-AL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa9 6X","codename":"HWBLN-H","model":"BLN-AL20"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa9 6X","codename":"HWBLN-H","model":"BLN-AL30"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa9 6X","codename":"HWBLN-H","model":"BLN-AL40"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa9 6X","codename":"HWBLN-H","model":"BLN-TL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa9 6X","codename":"HWBLN-H","model":"BLN-TL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa94C","codename":"hwCHM-H","model":"CHM-TL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa94C","codename":"hwCHM-H","model":"CHM-TL00H"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa94C","codename":"hwCHM-H","model":"CHM-UL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa94X","codename":"hnCHE-H","model":"CHE-TL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa94X","codename":"hnCHE-H","model":"CHE-TL00H"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa95A","codename":"HNCAM-H","model":"CAM-TL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa95A","codename":"HNCAM-H","model":"CAM-TL00H"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa95A","codename":"HNCAM-H","model":"CAM-UL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa95A","codename":"HNCAM-Q","model":"CAM-AL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa95A","codename":"HNCAM-Q","model":"CAM-CL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa95A","codename":"HWCAM-H","model":"CAM-TL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa95A","codename":"HWCAM-H","model":"CAM-TL00H"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa95A","codename":"HWCAM-H","model":"CAM-UL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa95A","codename":"HWCAM-Q","model":"CAM-AL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa95C","codename":"HNNEM-H","model":"NEM-AL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa95C","codename":"HNNEM-H","model":"NEM-TL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa95C","codename":"HNNEM-H","model":"NEM-TL00H"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa95C","codename":"HNNEM-H","model":"NEM-UL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa96","codename":"HWMYA-L6737","model":"MYA-AL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa96","codename":"HWMYA-L6737","model":"MYA-TL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa96A","codename":"HWDLI-Q","model":"DLI-AL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa97","codename":"HWDUA-M","model":"DUA-AL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa97","codename":"HWDUA-M","model":"DUA-TL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa97X","codename":"HWBND-H","model":"BND-AL00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa97X","codename":"HWBND-H","model":"BND-AL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa97X","codename":"HWBND-H","model":"BND-TL10"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa9\\xe5\\xb9\\xb3\\xe6\\x9d\\xbf2 9.6","codename":"HWBZA-Q","model":"BZA-L00"},{"manufacturer":"Huawei","market_name":"\\xe8\\x8d\\xa3\\xe8\\x80\\x80\\xe7\\x95\\x85\\xe7\\x8e\\xa9\\xe5\\xb9\\xb3\\xe6\\x9d\\xbf2 9.6","codename":"HWBZA-Q","model":"BZA-W00"},{"manufacturer":"Huawei","market_name":"\\xe9\\xba\\xa6\\xe8\\x8a\\x924","codename":"hwRIO-AL00","model":"HUAWEI RIO-AL00"},{"manufacturer":"Huawei","market_name":"\\xe9\\xba\\xa6\\xe8\\x8a\\x925","codename":"HWMLA","model":"HUAWEI MLA-AL00"},{"manufacturer":"Huawei","market_name":"\\xe9\\xba\\xa6\\xe8\\x8a\\x925","codename":"HWMLA","model":"HUAWEI MLA-AL10"},{"manufacturer":"Huawei","market_name":"\\xe9\\xba\\xa6\\xe8\\x8a\\x925","codename":"HWMLA","model":"MLA-AL00"},{"manufacturer":"Huawei","market_name":"\\xe9\\xba\\xa6\\xe8\\x8a\\x925","codename":"HWMLA","model":"MLA-AL10"},{"manufacturer":"Hurricane","market_name":"Ace","codename":"Ace","model":"Ace"},{"manufacturer":"Hurricane","market_name":"Air","codename":"Air","model":"Air"},{"manufacturer":"Hurricane","market_name":"Archer","codename":"Archer","model":"Archer"},{"manufacturer":"Hurricane","market_name":"Atlas","codename":"Atlas","model":"Atlas"},{"manufacturer":"Hurricane","market_name":"Beam","codename":"Beam","model":"Beam"},{"manufacturer":"Hurricane","market_name":"Blast","codename":"Blast","model":"Blast"},{"manufacturer":"Hurricane","market_name":"Blaze","codename":"Blaze","model":"Blaze"},{"manufacturer":"Hurricane","market_name":"Bolt","codename":"Bolt","model":"Hurricane_Bolt"},{"manufacturer":"Hurricane","market_name":"Charge","codename":"Charge","model":"Charge"},{"manufacturer":"Hurricane","market_name":"Cobra","codename":"Cobra","model":"Cobra"},{"manufacturer":"Hurricane","market_name":"Edge","codename":"Edge","model":"Edge"},{"manufacturer":"Hurricane","market_name":"Epic","codename":"Epic","model":"Epic"},{"manufacturer":"Hurricane","market_name":"Fire","codename":"Fire","model":"Fire"},{"manufacturer":"Hurricane","market_name":"Flame","codename":"Flame","model":"Flame"},{"manufacturer":"Hurricane","market_name":"Flex","codename":"Flex","model":"Flex"},{"manufacturer":"Hurricane","market_name":"Flint","codename":"Flint","model":"Flint"},{"manufacturer":"Hurricane","market_name":"Fuse","codename":"Fuse","model":"Fuse"},{"manufacturer":"Hurricane","market_name":"Galaxy","codename":"Galaxy","model":"Galaxy"},{"manufacturer":"Hurricane","market_name":"Giga","codename":"HURRICANE_GIGA","model":"HURRICANE_GIGA"},{"manufacturer":"Hurricane","market_name":"Glaze","codename":"Glaze","model":"Glaze"},{"manufacturer":"Hurricane","market_name":"Icon","codename":"Icon","model":"Icon"},{"manufacturer":"Hurricane","market_name":"Lynx","codename":"Lynx","model":"Lynx"},{"manufacturer":"Hurricane","market_name":"Onyx","codename":"Hurricane_Onyx","model":"Onyx"},{"manufacturer":"Hurricane","market_name":"Panther","codename":"Panther","model":"Panther"},{"manufacturer":"Hurricane","market_name":"Ridge","codename":"Ridge","model":"Ridge"},{"manufacturer":"Hurricane","market_name":"Rush","codename":"Hurricane","model":"Rush"},{"manufacturer":"Hurricane","market_name":"S43","codename":"S43","model":"S43"},{"manufacturer":"Hurricane","market_name":"SWIRL","codename":"Swirl","model":"Swirl"},{"manufacturer":"Hurricane","market_name":"Sprint","codename":"Sprint","model":"Sprint"},{"manufacturer":"Hurricane","market_name":"Surge","codename":"Surge","model":"Surge"},{"manufacturer":"Hurricane","market_name":"Ultra","codename":"Ultra","model":"Ultra"},{"manufacturer":"Hurricane","market_name":"Vega","codename":"Vega","model":"Vega"},{"manufacturer":"Hurricane","market_name":"Vegas","codename":"Vegas","model":"Vegas"},{"manufacturer":"Hurricane","market_name":"Vibe","codename":"Vibe","model":"VIBE"},{"manufacturer":"Hurricane","market_name":"Volt","codename":"Hurricane","model":"Volt"},{"manufacturer":"Hurricane","market_name":"Vortex","codename":"C9","model":"HURRICANE VORTEX"},{"manufacturer":"Hurricane","market_name":"Vulcan","codename":"Vulcan","model":"Vulcan"},{"manufacturer":"Hurricane","market_name":"Wave","codename":"Hurricane","model":"Wave"},{"manufacturer":"Hyundai","market_name":"A25563L","codename":"A25563L","model":"A25563L"},{"manufacturer":"Hyundai","market_name":"A26062L","codename":"A26062L","model":"A26062L"},{"manufacturer":"Hyundai","market_name":"A26062k","codename":"A26062K","model":"A26062K"},{"manufacturer":"Hyundai","market_name":"CAR AVN SYSTEM","codename":"koecn","model":"TCC893X_EVM"},{"manufacturer":"Hyundai","market_name":"E435 Plus","codename":"E435_Plus","model":"E435 Plus"},{"manufacturer":"Hyundai","market_name":"Eternity A24","codename":"A25024L","model":"A25024L"},{"manufacturer":"Hyundai","market_name":"Eternity G22","codename":"G25022K","model":"G25022K"},{"manufacturer":"Hyundai","market_name":"Eternity G23","codename":"G25523K","model":"G25523K"},{"manufacturer":"Hyundai","market_name":"Eternity G24","codename":"G25524K","model":"G25524K"},{"manufacturer":"Hyundai","market_name":"Eternity G27","codename":"G24027K","model":"G24027K"},{"manufacturer":"Hyundai","market_name":"Eternity W42","codename":"W25042L","model":"W25042L"},{"manufacturer":"Hyundai","market_name":"Eternity W44","codename":"W25544L","model":"W25544L"},{"manufacturer":"Hyundai","market_name":"HDT-7433H","codename":"HDT-7433H","model":"HDT-7433H"},{"manufacturer":"Hyundai","market_name":"HDT-7433X","codename":"HDT-7433X","model":"HDT-7433X"},{"manufacturer":"Hyundai","market_name":"HT0702W08","codename":"HT0702W08","model":"HT0702W08"},{"manufacturer":"Hyundai","market_name":"HY1-5085","codename":"HY1_5085","model":"HY1-5085"},{"manufacturer":"Hyundai","market_name":"Hyundai Koral 10W","codename":"HT1002W16","model":"HT1002W16"},{"manufacturer":"Hyundai","market_name":"Hyundai Koral 10X","codename":"HT1003X16","model":"HT1003X16"},{"manufacturer":"Hyundai","market_name":"Hyundai Koral 7M3X","codename":"HT0703K","model":"HT0703K16"},{"manufacturer":"Hyundai","market_name":"L500U","codename":"L500U","model":"L500U"},{"manufacturer":"Hyundai","market_name":"L501","codename":"L501","model":"L501"},{"manufacturer":"Hyundai","market_name":"L502","codename":"Hyundai_L502","model":"L502"},{"manufacturer":"Hyundai","market_name":"L575","codename":"L575","model":"L575"},{"manufacturer":"Hyundai","market_name":"Seoul 9","codename":"Seoul_9","model":"Seoul 9"},{"manufacturer":"Hyundai","market_name":"Seoul_S8","codename":"Seoul_S8","model":"Seoul S8"},{"manufacturer":"Hyundai","market_name":"Ultra Active","codename":"Ultra_Active","model":"Ultra Active"},{"manufacturer":"Hyundai","market_name":"Ultra Charm","codename":"Ultra_Charm","model":"Ultra Charm"},{"manufacturer":"Hyundai","market_name":"Ultra Dream","codename":"Ultra_Dream","model":"Ultra Dream"},{"manufacturer":"Hyundai","market_name":"Ultra Energy Lite","codename":"Ultra_Energy_Lite","model":"Ultra Energy Lite"},{"manufacturer":"Hyundai","market_name":"Ultra Energy Plus","codename":"Ultra_Energy_Plus","model":"Ultra Energy Plus"},{"manufacturer":"Hyundai","market_name":"Ultra Latitude","codename":"Ultra_Latitude","model":"Ultra Latitude"},{"manufacturer":"Hyundai","market_name":"Ultra Live II","codename":"HYUNDAI_Ultra_Live_II","model":"Ultra Live II"},{"manufacturer":"Hyundai","market_name":"Ultra Shadow","codename":"Ultra_Shadow","model":"Ultra Shadow"},{"manufacturer":"Hyundai","market_name":"Ultra Shine","codename":"Ultra_Shine","model":"Ultra Shine"},{"manufacturer":"Hyundai","market_name":"Ultra Storm","codename":"Ultra_Storm","model":"Ultra Storm"},{"manufacturer":"Hyundai","market_name":"Ultra Style","codename":"Ultra_Style","model":"Ultra Style"},{"manufacturer":"Hyundai","market_name":"Ultra Sync","codename":"Ultra_Sync","model":"Ultra Sync"},{"manufacturer":"Hyundai","market_name":"Ultra Trend","codename":"Ultra_Trend","model":"Ultra Trend"},{"manufacturer":"Hyundai","market_name":"Ultra Vision","codename":"Ultra_Vision","model":"Ultra Vision"},{"manufacturer":"Hyundai","market_name":"Ultra Vision Plus","codename":"Ultra_Vision_Plus","model":"Ultra_Vision_Plus"},{"manufacturer":"Hyundai","market_name":"e501","codename":"e501","model":"e501"},{"manufacturer":"Hyundai","market_name":"e502","codename":"e502","model":"e502"},{"manufacturer":"Hyundai","market_name":"e551","codename":"e551","model":"e551"},{"manufacturer":"Hyundai","market_name":"e551 Lite","codename":"e551_Lite","model":"e551 Lite"},{"manufacturer":"Hyve","market_name":"Buzz BU01","codename":"buzz_bu01","model":"BU01"},{"manufacturer":"Hyve","market_name":"Pryme01","codename":"pryme01","model":"Pryme 01"},{"manufacturer":"Hyve","market_name":"Storm ST01","codename":"storm_st01","model":"ST01"},{"manufacturer":"ICL-KME CS OJSC","market_name":"TR10CD1","codename":"TR10CD1_7","model":"TR10CD1"},{"manufacturer":"IDEA","market_name":"i4901","codename":"i4901","model":"i4901"},{"manufacturer":"IMO(In My Opinion)","market_name":"IMO Q","codename":"IMO_Q","model":"IMO Q"},{"manufacturer":"INQ Mobile","market_name":"","codename":"camden","model":"Camden"},{"manufacturer":"INQ Mobile","market_name":"","codename":"camden","model":"INQ Cloud Touch"},{"manufacturer":"INQ Mobile","market_name":"","codename":"camden","model":"INQ Cloud Touch -parrot"},{"manufacturer":"INQ Mobile","market_name":"","codename":"msm7627_surf","model":"INQ Mayfair (EU)"},{"manufacturer":"ION ELECTRONICS","market_name":"Kids","codename":"Kids","model":"Kids"},{"manufacturer":"IPRODA","market_name":"T1144","codename":"T1144","model":"T1144"},{"manufacturer":"IUNI","market_name":"N1","codename":"IUNI_N1","model":"IUNI N1"},{"manufacturer":"IUSA","market_name":"TR10CS1","codename":"TR10CS1_7","model":"TR10CS1"},{"manufacturer":"IUSA","market_name":"TR10CS1","codename":"TR10CS1_8","model":"TR10CS1"},{"manufacturer":"IView","market_name":"1070TPC","codename":"tulip-d100","model":"1070TPC"},{"manufacturer":"IView","market_name":"769TPC","codename":"tulip-d86v","model":"769TPC"},{"manufacturer":"IView","market_name":"776TPCIII","codename":"776TPCIII","model":"776TPCIII"},{"manufacturer":"IView","market_name":"778TPC","codename":"778TPC","model":"778TPC"},{"manufacturer":"IView","market_name":"788TPCII","codename":"iView_788TPCII","model":"788TPCII"},{"manufacturer":"IView","market_name":"920TPC","codename":"920TPC","model":"920TPC"},{"manufacturer":"IView","market_name":"IVIEW","codename":"IVIEW_1170TPC","model":"1170TPC"},{"manufacturer":"IView","market_name":"Retailer Stores","codename":"730TPC","model":"730TPC"},{"manufacturer":"IView","market_name":"SupraPad i700","codename":"g01i","model":"i700"},{"manufacturer":"IView","market_name":"SupraPad i785Q","codename":"anchor","model":"i785Q"},{"manufacturer":"Ice Phone","market_name":"Mini","codename":"ice_phone_mini","model":"Ice-Phone Mini"},{"manufacturer":"Icon","market_name":"Portal_10i","codename":"Portal_10i","model":"NTMC17"},{"manufacturer":"IkuMobile","market_name":"I3","codename":"I3","model":"IKU i3"},{"manufacturer":"IkuMobile","market_name":"IKU_i1","codename":"IKU_i1","model":"i1"},{"manufacturer":"IkuMobile","market_name":"K2","codename":"IKU_K2","model":"K2"},{"manufacturer":"IkuMobile","market_name":"K3","codename":"K3","model":"IKU K3"},{"manufacturer":"IkuMobile","market_name":"T1","codename":"T1","model":"iKU T1"},{"manufacturer":"Ilike","market_name":"X3_PRO_SLIM","codename":"X3_PRO_SLIM","model":"X3 PRO SLIM"},{"manufacturer":"Ilike","market_name":"X5_PRO","codename":"X5_PRO","model":"X5_PRO"},{"manufacturer":"ImageMobile","market_name":"Ipanema","codename":"C001","model":"C001"},{"manufacturer":"ImageMobile","market_name":"Rio","codename":"Rio","model":"B001"},{"manufacturer":"Impecca","market_name":"ET7050D","codename":"ET7050D","model":"ET7050D"},{"manufacturer":"Inet-Tablet","market_name":"D711HC_PG","codename":"D711HC_PG","model":"D711HC_PG"},{"manufacturer":"Inet-Tablet","market_name":"D7911L3BC_OGS","codename":"D7911L3BC_OGS","model":"D7911L3BC_OGS"},{"manufacturer":"Infinity","market_name":"10.1-v2","codename":"Infinity-101-v2","model":"Infinity-10.1-v2"},{"manufacturer":"Infinity","market_name":"10.1-v3","codename":"Infinity_101_v3","model":"Infinity-10.1-v3"},{"manufacturer":"Infinix","market_name":"HOT 2","codename":"Infinix_X510","model":"Infinix X510"},{"manufacturer":"Infinix","market_name":"HOT 3","codename":"INFINIX-X554","model":"Infinix HOT 3 Pro"},{"manufacturer":"Infinix","market_name":"HOT 3","codename":"INFINIX-X554","model":"Infinix-X554"},{"manufacturer":"Infinix","market_name":"HOT 3 LTE","codename":"INFINIX-X553","model":"Infinix HOT 3 LTE"},{"manufacturer":"Infinix","market_name":"HOT 3 LTE","codename":"INFINIX-X553-A1","model":"Infinix HOT 3 LTE"},{"manufacturer":"Infinix","market_name":"HOT 4","codename":"Infinix-X5511","model":"Infinix HOT 4"},{"manufacturer":"Infinix","market_name":"HOT 4","codename":"Infinix-X5511","model":"Infinix HOT4 LTE"},{"manufacturer":"Infinix","market_name":"HOT 4","codename":"X557","model":"Infinix HOT 4"},{"manufacturer":"Infinix","market_name":"HOT 4","codename":"X557","model":"Infinix X557"},{"manufacturer":"Infinix","market_name":"HOT 4","codename":"X557-Lite","model":"Infinix HOT 4"},{"manufacturer":"Infinix","market_name":"HOT 4 Lite","codename":"X557-Lite","model":"Infinix HOT 4"},{"manufacturer":"Infinix","market_name":"HOT 4 Lite","codename":"X557-Lite","model":"Infinix HOT 4 Lite"},{"manufacturer":"Infinix","market_name":"HOT 4 PRO","codename":"X556","model":"Infinix HOT 4 Pro"},{"manufacturer":"Infinix","market_name":"HOT 4 PRO","codename":"X556","model":"Infinix_X556_LTE"},{"manufacturer":"Infinix","market_name":"HOT 4 Pro","codename":"Infinix-X5511-13M","model":"Infinix HOT 4 Pro"},{"manufacturer":"Infinix","market_name":"HOT 4 Pro","codename":"X556","model":"Infinix HOT 4 Pro"},{"manufacturer":"Infinix","market_name":"HOT 6","codename":"Infinix-X606","model":"Infinix X606"},{"manufacturer":"Infinix","market_name":"HOT 6","codename":"Infinix-X606B","model":"Infinix X606B"},{"manufacturer":"Infinix","market_name":"HOT 6 Pro","codename":"Infinix-X608","model":"Infinix X608"},{"manufacturer":"Infinix","market_name":"HOT NOTE","codename":"Infinix-X551","model":"Infinix-X551"},{"manufacturer":"Infinix","market_name":"HOT S3","codename":"Infinix-X573","model":"Infinix X573"},{"manufacturer":"Infinix","market_name":"HOT S3","codename":"Infinix-X573","model":"Infinix X573S"},{"manufacturer":"Infinix","market_name":"HOT S3","codename":"Infinix-X573B","model":"Infinix X573B"},{"manufacturer":"Infinix","market_name":"HOT5","codename":"Infinix-X559C","model":"Infinix X559C"},{"manufacturer":"Infinix","market_name":"HOT5","codename":"Infinix-X559C","model":"Infinix X559F"},{"manufacturer":"Infinix","market_name":"HOT5 Lite","codename":"Infinix-X559","model":"Infinix X559"},{"manufacturer":"Infinix","market_name":"HOT5 Lite","codename":"X557","model":"Infinix HOT 4"},{"manufacturer":"Infinix","market_name":"Hot 4 Pro","codename":"Infinix-X5511-13M","model":"Infinix HOT 4 Pro"},{"manufacturer":"Infinix","market_name":"Infinix","codename":"Infinix_X510_sprout","model":"Infinix X510"},{"manufacturer":"Infinix","market_name":"Infinix X5010","codename":"Infinix-X5010","model":"Infinix X5010"},{"manufacturer":"Infinix","market_name":"Infinix X559","codename":"Infinix-X559","model":"Infinix X559"},{"manufacturer":"Infinix","market_name":"Infinix X571","codename":"Infinix-X571","model":"Infinix X571"},{"manufacturer":"Infinix","market_name":"Infinix X572","codename":"Infinix-X572","model":"Infinix X572"},{"manufacturer":"Infinix","market_name":"NOTE 3","codename":"X601","model":"Infinix NOTE 3"},{"manufacturer":"Infinix","market_name":"NOTE 3 Pro","codename":"X601-3G","model":"Infinix NOTE 3 Pro"},{"manufacturer":"Infinix","market_name":"NOTE 3 Pro","codename":"X601-LTE","model":"Infinix NOTE 3 Pro"},{"manufacturer":"Infinix","market_name":"NOTE 3 Pro","codename":"X601-LTE","model":"Infinix_X601_LTE"},{"manufacturer":"Infinix","market_name":"NOTE 4","codename":"Infinix-X572","model":"Infinix X572"},{"manufacturer":"Infinix","market_name":"NOTE 4","codename":"Infinix-X572","model":"Infinix X572-LTE"},{"manufacturer":"Infinix","market_name":"NOTE 4 Pro","codename":"Infinix-X571","model":"Infinix X571"},{"manufacturer":"Infinix","market_name":"NOTE 4 Pro","codename":"Infinix-X571","model":"Infinix X571-LTE"},{"manufacturer":"Infinix","market_name":"Note 5","codename":"Infinix-X604_sprout","model":"Infinix X604"},{"manufacturer":"Infinix","market_name":"Note 5","codename":"Infinix-X604_sprout","model":"Infinix X604B"},{"manufacturer":"Infinix","market_name":"RACE Blot2","codename":"Infinix_X454","model":"Infinix X454"},{"manufacturer":"Infinix","market_name":"RACE Bolt 3","codename":"X455","model":"Infinix X455"},{"manufacturer":"Infinix","market_name":"S2","codename":"Infinix-X522","model":"Infinix S2"},{"manufacturer":"Infinix","market_name":"S2","codename":"Infinix-X522","model":"Infinix S2 Pro"},{"manufacturer":"Infinix","market_name":"SURF 2","codename":"INFINIX_X511","model":"Infinix X511"},{"manufacturer":"Infinix","market_name":"Smart 2","codename":"Infinix-X5515","model":"Infinix X5515"},{"manufacturer":"Infinix","market_name":"Smart 2","codename":"Infinix-X5515F","model":"Infinix X5515F"},{"manufacturer":"Infinix","market_name":"Smart 2","codename":"Infinix-X5515I","model":"Infinix X5515I"},{"manufacturer":"Infinix","market_name":"Smart 2 Pro","codename":"Infinix-X5514","model":"Infinix X5514D"},{"manufacturer":"Infinix","market_name":"X405","codename":"up09_infinix_x405_gms","model":"Infinix X405"},{"manufacturer":"Infinix","market_name":"X505","codename":"X505","model":"Infinix X505"},{"manufacturer":"Infinix","market_name":"X521","codename":"Infinix-X521","model":"Infinix HOT S"},{"manufacturer":"Infinix","market_name":"X521","codename":"Infinix-X521","model":"Infinix-X521"},{"manufacturer":"Infinix","market_name":"X521","codename":"Infinix-X521","model":"Infinix-X521-LTE"},{"manufacturer":"Infinix","market_name":"X521","codename":"Infinix-X521","model":"Infinix_X521"},{"manufacturer":"Infinix","market_name":"X521","codename":"Infinix-X521-3G","model":"Infinix-X521"},{"manufacturer":"Infinix","market_name":"X521","codename":"Infinix-X521-Pro","model":"Infinix-X521"},{"manufacturer":"Infinix","market_name":"X521","codename":"Infinix-X521-Pro","model":"Infinix_X521"},{"manufacturer":"Infinix","market_name":"X521","codename":"Infinix-X521-Pro","model":"Infinix_X521_LTE"},{"manufacturer":"Infinix","market_name":"X521-H1","codename":"Infinix-X521-Pro","model":"Infinix-X521"},{"manufacturer":"Infinix","market_name":"X521-H1","codename":"Infinix-X521-Pro","model":"Infinix_X521"},{"manufacturer":"Infinix","market_name":"X521-I1","codename":"Infinix-X521","model":"Infinix_X521"},{"manufacturer":"Infinix","market_name":"X521E1","codename":"Infinix-X521","model":"Infinix HOT S"},{"manufacturer":"Infinix","market_name":"X521E1","codename":"Infinix-X521","model":"Infinix-X521"},{"manufacturer":"Infinix","market_name":"X521E1","codename":"Infinix-X521","model":"Infinix_X521"},{"manufacturer":"Infinix","market_name":"X521G1","codename":"Infinix-X521-Pro","model":"Infinix-X521"},{"manufacturer":"Infinix","market_name":"X521G1","codename":"Infinix-X521-Pro","model":"Infinix-X521_LTE"},{"manufacturer":"Infinix","market_name":"X521G1","codename":"Infinix-X521-Pro","model":"Infinix_X521"},{"manufacturer":"Infinix","market_name":"X521S","codename":"Infinix-X521","model":"Infinix-X521S"},{"manufacturer":"Infinix","market_name":"X521S","codename":"Infinix-X521","model":"Infinix_X521S"},{"manufacturer":"Infinix","market_name":"X551","codename":"INFINIX-X551","model":"INFINIX-X551"},{"manufacturer":"Infinix","market_name":"X552","codename":"INFINIX-X552","model":"Infinix Zero 3"},{"manufacturer":"Infinix","market_name":"X552","codename":"INFINIX-X552","model":"Infinix-X552"},{"manufacturer":"Infinix","market_name":"X552-C1","codename":"INFINIX-X552","model":"Infinix-X552"},{"manufacturer":"Infinix","market_name":"X552-E1","codename":"INFINIX-X552-95M","model":"Infinix Zero 3"},{"manufacturer":"Infinix","market_name":"X552-E1","codename":"INFINIX-X552-95M","model":"Infinix-X552"},{"manufacturer":"Infinix","market_name":"X552-F1","codename":"INFINIX-X552-95M","model":"Infinix Zero 3"},{"manufacturer":"Infinix","market_name":"X552-F1","codename":"INFINIX-X552-95M","model":"Infinix-X552"},{"manufacturer":"Infinix","market_name":"X555","codename":"X555","model":"Infinix Zero 4"},{"manufacturer":"Infinix","market_name":"X557F1","codename":"X557-Lite","model":"Infinix HOT 4"},{"manufacturer":"Infinix","market_name":"X572","codename":"Infinix-X572","model":"Infinix X572"},{"manufacturer":"Infinix","market_name":"X572","codename":"Infinix-X572","model":"Infinix X572-LTE"},{"manufacturer":"Infinix","market_name":"X600","codename":"INFINIX-X600","model":"INFINIX-X600"},{"manufacturer":"Infinix","market_name":"X600","codename":"INFINIX-X600-5M","model":"INFINIX-X600"},{"manufacturer":"Infinix","market_name":"X600","codename":"INFINIX-X600-5M","model":"Infinix-X600"},{"manufacturer":"Infinix","market_name":"X600","codename":"INFINIX-X600-H533-5M","model":"Infinix-X600-LTE"},{"manufacturer":"Infinix","market_name":"Zero 2","codename":"Infinix_X509","model":"Infinix X509"},{"manufacturer":"Infinix","market_name":"Zero 4","codename":"X555","model":"Infinix Zero 4"},{"manufacturer":"Infinix","market_name":"Zero 4 Plus","codename":"X602","model":"Infinix Zero 4 Plus"},{"manufacturer":"Infinix","market_name":"Zero 5","codename":"Infinix-X603","model":"Infinix X603"},{"manufacturer":"Infinix","market_name":"Zero 5 Pro","codename":"Infinix-X603","model":"Infinix X603"},{"manufacturer":"Infinix","market_name":"Zero 5 Pro","codename":"Infinix-X603","model":"Infinix X603-LTE"},{"manufacturer":"Infocus","market_name":"A1S","codename":"AE2","model":"InFocus M505"},{"manufacturer":"Infocus","market_name":"Amazing A8","codename":"D78","model":"Amazing A8"},{"manufacturer":"Infocus","market_name":"Big Tab","codename":"IF195a","model":"IF195a"},{"manufacturer":"Infocus","market_name":"Big Tab","codename":"IF236a","model":"IF236a"},{"manufacturer":"Infocus","market_name":"C7","codename":"C2107","model":"C2107"},{"manufacturer":"Infocus","market_name":"CS1 8.0","codename":"cs180","model":"CS180"},{"manufacturer":"Infocus","market_name":"Epic 1","codename":"JGZ","model":"TSP"},{"manufacturer":"Infocus","market_name":"FP-U320-INF-WLTW","codename":"U320-WF","model":"FP-U320-INF-WLTW"},{"manufacturer":"Infocus","market_name":"IF9001","codename":"AA2","model":"IF9001"},{"manufacturer":"Infocus","market_name":"IF9002","codename":"AB2","model":"IF9002"},{"manufacturer":"Infocus","market_name":"IF9007","codename":"AG2","model":"IF9007"},{"manufacturer":"Infocus","market_name":"IF9007","codename":"AG5","model":"IF9007"},{"manufacturer":"Infocus","market_name":"IF9021","codename":"AU8","model":"IF9021"},{"manufacturer":"Infocus","market_name":"IF9035_IN","codename":"A62","model":"IF9035"},{"manufacturer":"Infocus","market_name":"IF9035_IN","codename":"A62_mini","model":"IF9035"},{"manufacturer":"Infocus","market_name":"IN260","codename":"IN260","model":"IN260"},{"manufacturer":"Infocus","market_name":"IN335","codename":"IVM","model":"IN335"},{"manufacturer":"Infocus","market_name":"IN610","codename":"MG2","model":"IN610"},{"manufacturer":"Infocus","market_name":"IN810","codename":"VKY","model":"IN810"},{"manufacturer":"Infocus","market_name":"IN815","codename":"VK3","model":"IN815"},{"manufacturer":"Infocus","market_name":"InFocus M6S","codename":"AH2","model":"IF9003"},{"manufacturer":"Infocus","market_name":"InFocus M7 Lite","codename":"A02","model":"IF9031"},{"manufacturer":"Infocus","market_name":"InFocus M7S","codename":"A08","model":"IF9031"},{"manufacturer":"Infocus","market_name":"M2","codename":"LSO","model":"InFocus M2"},{"manufacturer":"Infocus","market_name":"M2+","codename":"LSC","model":"InFocus M2PLUS"},{"manufacturer":"Infocus","market_name":"M210","codename":"M210","model":"M210"},{"manufacturer":"Infocus","market_name":"M260","codename":"ZL2","model":"InFocus M260"},{"manufacturer":"Infocus","market_name":"M2_3G","codename":"G10","model":"InFocus M2_3G"},{"manufacturer":"Infocus","market_name":"M310","codename":"H1W","model":"InFocus M310"},{"manufacturer":"Infocus","market_name":"M320","codename":"M320","model":"InFocus M320"},{"manufacturer":"Infocus","market_name":"M320e","codename":"M320e","model":"InFocus M320e"},{"manufacturer":"Infocus","market_name":"M320m","codename":"M320m","model":"InFocus M320m"},{"manufacturer":"Infocus","market_name":"M320u","codename":"M320","model":"InFocus M320u"},{"manufacturer":"Infocus","market_name":"M330","codename":"D77","model":"InFocus M330"},{"manufacturer":"Infocus","market_name":"M350","codename":"G30","model":"InFocus M350"},{"manufacturer":"Infocus","market_name":"M350","codename":"G3E","model":"InFocus M350"},{"manufacturer":"Infocus","market_name":"M370","codename":"FOT","model":"M370"},{"manufacturer":"Infocus","market_name":"M370i","codename":"FAT","model":"M370i"},{"manufacturer":"Infocus","market_name":"M372","codename":"FOT","model":"M372"},{"manufacturer":"Infocus","market_name":"M377","codename":"FO7","model":"M377"},{"manufacturer":"Infocus","market_name":"M415","codename":"ZL3","model":"InFocus M415"},{"manufacturer":"Infocus","market_name":"M425","codename":"HGO","model":"InFocus M425"},{"manufacturer":"Infocus","market_name":"M430","codename":"HGO","model":"InFocus M430"},{"manufacturer":"Infocus","market_name":"M460","codename":"G3T","model":"InFocus M460"},{"manufacturer":"Infocus","market_name":"M500","codename":"InFocus_M500","model":"InFocus M500"},{"manufacturer":"Infocus","market_name":"M510","codename":"TID_CHT","model":"M510"},{"manufacturer":"Infocus","market_name":"M510t","codename":"TID","model":"InFocus M510t"},{"manufacturer":"Infocus","market_name":"M511","codename":"TID_CHT","model":"M510"},{"manufacturer":"Infocus","market_name":"M511","codename":"TID_TWN","model":"M511"},{"manufacturer":"Infocus","market_name":"M512","codename":"MC2_CN","model":"InFocus M512"},{"manufacturer":"Infocus","market_name":"M512","codename":"MC2_CN","model":"M512"},{"manufacturer":"Infocus","market_name":"M518","codename":"MC2_APT","model":"M518"},{"manufacturer":"Infocus","market_name":"M530","codename":"G20","model":"InFocus M530"},{"manufacturer":"Infocus","market_name":"M535","codename":"G40","model":"InFocus M535"},{"manufacturer":"Infocus","market_name":"M535_00WW","codename":"G40","model":"InFocus M535"},{"manufacturer":"Infocus","market_name":"M550","codename":"ZZ1","model":"InFocus M550"},{"manufacturer":"Infocus","market_name":"M550 3D","codename":"ZD1","model":"InFocus M550 3D"},{"manufacturer":"Infocus","market_name":"M560","codename":"ZM1","model":"InFocus M560"},{"manufacturer":"Infocus","market_name":"M5s","codename":"AB5","model":"IF9002"},{"manufacturer":"Infocus","market_name":"M680","codename":"G42","model":"InFocus M680"},{"manufacturer":"Infocus","market_name":"M808","codename":"ZM1","model":"InFocus M808"},{"manufacturer":"Infocus","market_name":"M808i","codename":"ZM1","model":"InFocus M808i"},{"manufacturer":"Infocus","market_name":"M810","codename":"VNA","model":"InFocus M810"},{"manufacturer":"Infocus","market_name":"M810t","codename":"VNA","model":"InFocus M810t"},{"manufacturer":"Infocus","market_name":"M812","codename":"VN2","model":"InFocus M812"},{"manufacturer":"Infocus","market_name":"M812A","codename":"VN2","model":"InFocus M812A"},{"manufacturer":"Infocus","market_name":"M812i","codename":"V2I","model":"InFocus M812i"},{"manufacturer":"Infocus","market_name":"NewTab F1","codename":"f1","model":"NewTab F1"},{"manufacturer":"Infocus","market_name":"Smart503","codename":"MC2","model":"Smart503"},{"manufacturer":"Infocus","market_name":"T3000","codename":"P7M","model":"T3000"},{"manufacturer":"Infocus","market_name":"VZH","codename":"VZH","model":"VZH"},{"manufacturer":"Infocus","market_name":"VZU","codename":"VZH","model":"VZU"},{"manufacturer":"Infocus","market_name":"Vision 3 Lite","codename":"BU2","model":"IF9008"},{"manufacturer":"Infocus","market_name":"Vision 3 Pro","codename":"AY2","model":"IF9029"},{"manufacturer":"Infocus","market_name":"XT-50IP600","codename":"XT_50IP600","model":"XT_50IP600"},{"manufacturer":"Ingenico","market_name":"AXIUM D7","codename":"axium","model":"IngenicoAxium"},{"manufacturer":"Ingenico","market_name":"Moby-M70","codename":"Moby-M70","model":"IMS-M70-V02"},{"manufacturer":"Inhon","market_name":"E30","codename":"E30","model":"E30"},{"manufacturer":"Inhon","market_name":"L35","codename":"L35","model":"L35"},{"manufacturer":"Inhon","market_name":"L50","codename":"INHON_L50","model":"L50"},{"manufacturer":"Inhon","market_name":"L55","codename":"L55","model":"L55"},{"manufacturer":"Inhon","market_name":"V6","codename":"V6","model":"Inhon_V6"},{"manufacturer":"Innjoo","market_name":"3","codename":"InnJoo_3","model":"InnJoo_3"},{"manufacturer":"Innjoo","market_name":"Elite Dual","codename":"Fire_5_LTE","model":"Fire_5_LTE"},{"manufacturer":"Innjoo","market_name":"F5","codename":"F5","model":"F5"},{"manufacturer":"Innjoo","market_name":"Fire 4","codename":"Fire_4","model":"Fire 4"},{"manufacturer":"Innjoo","market_name":"Fire 4 Plus","codename":"Fire_4_Plus","model":"Fire 4 Plus"},{"manufacturer":"Innjoo","market_name":"Fire 4 Pro","codename":"Fire_4_Pro","model":"Fire 4 Pro"},{"manufacturer":"Innjoo","market_name":"Halo 4 LTE","codename":"Halo_4_LTE","model":"Halo 4 LTE"},{"manufacturer":"Innjoo","market_name":"Halo 5 3 G","codename":"Halo_5_3G","model":"Halo 5 3G"},{"manufacturer":"Innjoo","market_name":"Halo2 3G","codename":"Halo2_3G","model":"Halo2 3G"},{"manufacturer":"Innjoo","market_name":"Halo2 LTE","codename":"Halo2_LTE","model":"Halo2 LTE"},{"manufacturer":"Innjoo","market_name":"Halo4 mini LTE","codename":"Halo_4_mini_LTE","model":"Halo_4_mini_LTE"},{"manufacturer":"Innjoo","market_name":"InnJoo-5","codename":"InnJoo-5","model":"InnJoo-5"},{"manufacturer":"Innjoo","market_name":"Max 4 Pro","codename":"Max_4_Pro","model":"Max 4 Pro"},{"manufacturer":"Innjoo","market_name":"Max3 LTE","codename":"Max3_LTE","model":"Max3_LTE"},{"manufacturer":"Innjoo","market_name":"VISION LTE","codename":"VISION_LTE","model":"VISION LTE"},{"manufacturer":"Insignia","market_name":"FLEX 8\\xe2\\x80\\x99\\xe2\\x80\\x99 LTE Android Tablet","codename":"ns_15t8lte","model":"NS-15T8LTE"},{"manufacturer":"Insignia","market_name":"Flex 10.1","codename":"ns_14t004","model":"NS-14T004"},{"manufacturer":"Insignia","market_name":"\"Flex 8\"\"\"","codename":"ns_15at08","model":"NS-15AT08"},{"manufacturer":"Insignia","market_name":"MID7802RA","codename":"MID7802RA","model":"NS-P16AT785HD"},{"manufacturer":"Insignia","market_name":"NS-14T002","codename":"ns_14t002","model":"NS-14T002"},{"manufacturer":"Insignia","market_name":"NS-15AT07","codename":"NS-15AT07","model":"NS-15AT07"},{"manufacturer":"Insignia","market_name":"NS-15AT10","codename":"TA120","model":"NS-15AT10"},{"manufacturer":"Insignia","market_name":"NS-P08A7100","codename":"NS-P08A7100","model":"NS-P08A7100"},{"manufacturer":"Insignia","market_name":"NS-P10A6100","codename":"NS-P10A6100","model":"NS-P10A6100"},{"manufacturer":"Insignia","market_name":"NS-P10A7100","codename":"NS-P10A7100","model":"NS-P10A7100"},{"manufacturer":"Insignia","market_name":"NS-P10A8100","codename":"mid1023_ma","model":"NS-P10A8100"},{"manufacturer":"Insignia","market_name":"NS-P10A8100K","codename":"mid1028_ma","model":"NS-P10A8100K"},{"manufacturer":"Insignia","market_name":"NS-P11A8100","codename":"NS-P11A8100","model":"NS-P11A8100"},{"manufacturer":"Insignia","market_name":"NS-P16AT08","codename":"mid8005","model":"NS-P16AT08"},{"manufacturer":"Insignia","market_name":"NS-P16AT10","codename":"NS-P16AT10","model":"NS-P16AT10"},{"manufacturer":"Inspire Mobile","market_name":"IMP-R01W","codename":"IMP-R01W","model":"IMP-R01W"},{"manufacturer":"Intel","market_name":"","codename":"SP-A20i","model":"SP-A20i"},{"manufacturer":"Intel","market_name":"","codename":"blackbay","model":"Xolo_X900"},{"manufacturer":"Intel","market_name":"","codename":"noonhill","model":"AZ210A"},{"manufacturer":"Intel","market_name":"","codename":"noonhill","model":"AZ210B"},{"manufacturer":"Intel","market_name":"","codename":"noonhill","model":"SP-A20i"},{"manufacturer":"Intel","market_name":"AQ710A","codename":"Salitpa","model":"AQ710A"},{"manufacturer":"Intel","market_name":"Etisalat E-20","codename":"zeeyabeach","model":"BT230"},{"manufacturer":"Intel","market_name":"INTEX\\xc2\\xa0AQUA\\xc2\\xa0LIONS\\xc2\\xa0N1","codename":"INTEX_AQUA_LIONS_N1","model":"INTEX AQUA LIONS N1"},{"manufacturer":"Intel","market_name":"Orange San Diego","codename":"AZ210A","model":"AZ210A"},{"manufacturer":"Intel","market_name":"Orange avec Intel Inside","codename":"AZ210B","model":"AZ210B"},{"manufacturer":"Intel","market_name":"TR10CD1(PVT2)","codename":"TR10CD1_4","model":"TR10CD1"},{"manufacturer":"Intel","market_name":"TR10CD1(PVT2)","codename":"TR10CD1_6","model":"TR10CD1"},{"manufacturer":"Intel","market_name":"TR10CS1 (PVT2)","codename":"TR10CS1_4","model":"TR10CS1"},{"manufacturer":"Intel","market_name":"Xolo X500","codename":"zeeyabeach","model":"Xolo_X500"},{"manufacturer":"Intel","market_name":"Yolo","codename":"zeeyabeach","model":"BT210"},{"manufacturer":"Intenso","market_name":"Tab734","codename":"Tab734","model":"Tab734"},{"manufacturer":"Intenso","market_name":"Tab814S","codename":"Tab814S","model":"Tab814S"},{"manufacturer":"Intermec","market_name":"CN51","codename":"CN51_NC0","model":"CN51 NC0"},{"manufacturer":"Intermec","market_name":"CN51","codename":"CN51_NCF","model":"CN51 NCF"},{"manufacturer":"Intermec","market_name":"CN51","codename":"CN51_NCU","model":"CN51 NCU"},{"manufacturer":"Intermec","market_name":"CN51","codename":"CN51_NN0","model":"CN51 NN0"},{"manufacturer":"Intermec","market_name":"CN51","codename":"CN51_QC0","model":"CN51 QC0"},{"manufacturer":"Intermec","market_name":"CN51","codename":"CN51_QCF","model":"CN51 QCF"},{"manufacturer":"Intermec","market_name":"CN51","codename":"CN51_QCU","model":"CN51 QCU"},{"manufacturer":"Intermec","market_name":"CN51","codename":"CN51_QN0","model":"CN51 QN0"},{"manufacturer":"Intex","market_name":"AQUA 4G MINI","codename":"INTEX_AQUA_4G_MINI","model":"INTEX AQUA 4G MINI"},{"manufacturer":"Intex","market_name":"AQUA CRYSTAL","codename":"INTEX_AQUA_CRYSTAL","model":"INTEX AQUA CRYSTAL"},{"manufacturer":"Intex","market_name":"AQUA CRYSTAL+","codename":"AQUA_CRYSTAL_PLUS","model":"INTEX AQUA CRYSTAL+"},{"manufacturer":"Intex","market_name":"AQUA LIONS 2","codename":"INTEX_AQUA_LIONS_2","model":"INTEX AQUA LIONS 2"},{"manufacturer":"Intex","market_name":"AQUA LIONS T1 LITE","codename":"AQUA_LIONS_T1_LITE","model":"INTEX AQUA LIONS T1 LITE"},{"manufacturer":"Intex","market_name":"AQUA TREND LITE","codename":"INTEX_AQUA_TREND_LITE","model":"INTEX AQUA TREND LITE"},{"manufacturer":"Intex","market_name":"AQUA YOUNG 4G","codename":"INTEX_AQUA_YOUNG_4G","model":"INTEX AQUA YOUNG 4G"},{"manufacturer":"Intex","market_name":"AQUA ZENITH","codename":"INTEX_AQUA_ZENITH","model":"INTEX AQUA ZENITH"},{"manufacturer":"Intex","market_name":"AQUA_4.0_4G","codename":"INTEX_AQUA_4_4G","model":"INTEX_AQUA_4.0_4G"},{"manufacturer":"Intex","market_name":"AQUA_S3","codename":"INTEX_AQUA_S3","model":"INTEX AQUA S3"},{"manufacturer":"Intex","market_name":"Aqua 4.0 3G","codename":"INTEX_AQUA_4_3G","model":"INTEX AQUA 4.0 3G"},{"manufacturer":"Intex","market_name":"Aqua 4G mini","codename":"INTEX_AQUA_4G_MINI","model":"INTEX AQUA 4G MINI"},{"manufacturer":"Intex","market_name":"Aqua 5.5 VR","codename":"Aqua_5_5_VR","model":"Aqua 5.5 VR"},{"manufacturer":"Intex","market_name":"Aqua 5.5 VR+","codename":"AQUA_5_5_VR_PLUS","model":"INTEX AQUA 5.5 VR+"},{"manufacturer":"Intex","market_name":"Aqua A4","codename":"INTEX_AQUA_A4","model":"INTEX AQUA A4"},{"manufacturer":"Intex","market_name":"Aqua A4+","codename":"INTEX_AQUA_A4_PLUS","model":"INTEX AQUA A4 PLUS"},{"manufacturer":"Intex","market_name":"Aqua Aura 2GB","codename":"Aqua_Aura_2GB","model":"Aqua Aura 2GB"},{"manufacturer":"Intex","market_name":"Aqua Jewel 2","codename":"INTEX_AQUA_JEWEL_2","model":"INTEX AQUA JEWEL 2"},{"manufacturer":"Intex","market_name":"Aqua Lions 2","codename":"INTEX_AQUA_LIONS_2","model":"INTEX AQUA LIONS 2"},{"manufacturer":"Intex","market_name":"Aqua Lions 3","codename":"INTEX_AQUA_LIONS_3","model":"INTEX AQUA LIONS 3"},{"manufacturer":"Intex","market_name":"Aqua Power 4G","codename":"Intex_Aqua_Power_4G","model":"Aqua Power 4G"},{"manufacturer":"Intex","market_name":"Aqua Power IV","codename":"INTEX_AQUA_POWER_IV","model":"INTEX AQUA POWER IV"},{"manufacturer":"Intex","market_name":"Aqua Pride","codename":"AquaPride","model":"Aqua Pride"},{"manufacturer":"Intex","market_name":"Aqua Ring","codename":"Aqua_Ring","model":"Aqua_Ring"},{"manufacturer":"Intex","market_name":"Aqua Strong 5.1+","codename":"Aqua_Strong_5_1_Plus","model":"Intex Aqua Strong 5.1+"},{"manufacturer":"Intex","market_name":"Aqua Supreme+","codename":"Aqua_Supreme_Plus","model":"Intex Aqua Supreme+"},{"manufacturer":"Intex","market_name":"Aqua View","codename":"AquaView","model":"Aqua View"},{"manufacturer":"Intex","market_name":"Aqua_Lions_4G","codename":"INTEX_AQUA_LIONS_4G","model":"INTEX AQUA LIONS 4G"},{"manufacturer":"Intex","market_name":"Aqua_Q8","codename":"Aqua_Q8","model":"Aqua Q8"},{"manufacturer":"Intex","market_name":"Cloud AX1","codename":"INTEX_CLOUD_AX1","model":"INTEX CLOUD AX1"},{"manufacturer":"Intex","market_name":"Cloud style 4G","codename":"Intex_Cloud_Style_4G","model":"Intex_Cloud_Style_4G"},{"manufacturer":"Intex","market_name":"Cloud_Q11_4G","codename":"Cloud_Q11_4G","model":"Cloud Q11 4G"},{"manufacturer":"Intex","market_name":"Cloud_Q11_4G","codename":"Cloud_Q11_4G","model":"Cloud_Q11_4G"},{"manufacturer":"Intex","market_name":"ELYT E1","codename":"INTEX_ELYT_E1","model":"INTEX ELYT E1"},{"manufacturer":"Intex","market_name":"ELYT E7","codename":"INTEX_ELYT_E7","model":"INTEX ELYT E7"},{"manufacturer":"Intex","market_name":"Elite E1","codename":"Intex_Elite_E1","model":"Intex Elite E1"},{"manufacturer":"Intex","market_name":"INDIE 15","codename":"AQUA_LIONS_X1","model":"INTEX AQUA LIONS X1"},{"manufacturer":"Intex","market_name":"INDIE 5","codename":"INTEX_AQUA_LIONS_3","model":"INTEX AQUA LIONS 3"},{"manufacturer":"Intex","market_name":"INTEX  AQUA Lions T1","codename":"AQUA_LIONS_T1","model":"INTEX AQUA LIONS T1"},{"manufacturer":"Intex","market_name":"INTEX AQUA AMAZE+","codename":"INTEX_AQUA_AMAZE_PLUS","model":"INTEX AQUA AMAZE+"},{"manufacturer":"Intex","market_name":"INTEX AQUA NOTE 5.5","codename":"AQUA_NOTE_5_5","model":"INTEX AQUA NOTE 5.5"},{"manufacturer":"Intex","market_name":"INTEX AQUA S1","codename":"INTEX_AQUA_S1","model":"INTEX AQUA S1"},{"manufacturer":"Intex","market_name":"INTEX AQUA STYLE 3","codename":"INTEX_AQUA_STYLE_3","model":"INTEX AQUA STYLE 3"},{"manufacturer":"Intex","market_name":"INTEX Aqua Selfie","codename":"INTEX_AQUA_SELFIE","model":"INTEX AQUA SELFIE"},{"manufacturer":"Intex","market_name":"INTEX_AQUA_S3","codename":"INTEX_AQUA_S3","model":"INTEX AQUA S3"},{"manufacturer":"Intex","market_name":"Intex Aqua FulVU e5","codename":"AQUA_FulVU_e5","model":"INTEX AQUA FulVU e5"},{"manufacturer":"Intex","market_name":"STAARi 10","codename":"AQUA_LIONS_X1_PLUS","model":"INTEX AQUA LIONS X1+"},{"manufacturer":"Intex","market_name":"STAARi 12","codename":"INTEX_ELYT_E6","model":"INTEX ELYT E6"},{"manufacturer":"Intex","market_name":"T1 Plus","codename":"INTEX_ELYT_DUAL","model":"INTEX ELYT DUAL"},{"manufacturer":"Intex","market_name":"i1","codename":"INTEX_i1","model":"INTEX i1"},{"manufacturer":"Invens","market_name":"Diamond","codename":"Diamond","model":"Diamond"},{"manufacturer":"Invens","market_name":"Eager","codename":"Eager","model":"Eager"},{"manufacturer":"Invens","market_name":"F1","codename":"F1","model":"F1"},{"manufacturer":"Invens","market_name":"F2","codename":"F2","model":"F2"},{"manufacturer":"Invens","market_name":"Fighter","codename":"Fighter","model":"Fighter"},{"manufacturer":"Inverse Net","market_name":"EP172PR","codename":"EP172PR","model":"EP172PR"},{"manufacturer":"Ipro","market_name":"Kylin 5.5","codename":"Kylin_55","model":"Kylin 5.5"},{"manufacturer":"Ipro","market_name":"Kylin_5.0S","codename":"Kylin_5_0S","model":"Kylin_5.0S"},{"manufacturer":"Ipro","market_name":"PHOENIX 5.0","codename":"PHOENIX_50","model":"PHOENIX 5.0"},{"manufacturer":"Ipro","market_name":"WIN","codename":"WIN","model":"WIN"},{"manufacturer":"Ipro","market_name":"XPLAY","codename":"XPLAY","model":"XPLAY"},{"manufacturer":"Irbis","market_name":"IRBIS TZ175","codename":"TZ175","model":"TZ175"},{"manufacturer":"Irbis","market_name":"IRBIS TZ176","codename":"TZ176","model":"TZ176"},{"manufacturer":"Irbis","market_name":"IRBIS TZ178","codename":"TZ178","model":"TZ178"},{"manufacturer":"Irbis","market_name":"IRBIS TZ198","codename":"TZ198","model":"TZ198"},{"manufacturer":"Irbis","market_name":"IRBIS TZ737","codename":"TZ737","model":"TZ737"},{"manufacturer":"Irbis","market_name":"IRBIS TZ747","codename":"TZ747","model":"TZ747"},{"manufacturer":"Irbis","market_name":"IRBIS TZ752","codename":"TZ752","model":"TZ752"},{"manufacturer":"Irbis","market_name":"IRBIS TZ753","codename":"TZ753","model":"TZ753"},{"manufacturer":"Irbis","market_name":"SP401","codename":"SP401","model":"SP401"},{"manufacturer":"Irbis","market_name":"SP453","codename":"SP453","model":"SP453"},{"manufacturer":"Irbis","market_name":"SP454","codename":"SP454","model":"SP454"},{"manufacturer":"Irbis","market_name":"SP455","codename":"SP455","model":"SP455"},{"manufacturer":"Irbis","market_name":"SP510","codename":"SP510","model":"SP510"},{"manufacturer":"Irbis","market_name":"SP511","codename":"SP511","model":"SP511"},{"manufacturer":"Irbis","market_name":"SP514","codename":"SP514","model":"SP514"},{"manufacturer":"Irbis","market_name":"SP515","codename":"SP515","model":"SP515"},{"manufacturer":"Irbis","market_name":"SP517","codename":"SP517","model":"SP517"},{"manufacturer":"Irbis","market_name":"SP550","codename":"SP550","model":"SP550"},{"manufacturer":"Irbis","market_name":"SP551","codename":"SP551","model":"SP551"},{"manufacturer":"Irbis","market_name":"SP552","codename":"SP552","model":"SP552"},{"manufacturer":"Irbis","market_name":"TZ150","codename":"TZ150","model":"TZ150"},{"manufacturer":"Irbis","market_name":"TZ165","codename":"TZ165","model":"TZ165"},{"manufacturer":"Irbis","market_name":"TZ177","codename":"TZ177","model":"TZ177"},{"manufacturer":"Irbis","market_name":"TZ183","codename":"TZ183","model":"TZ183"},{"manufacturer":"Irbis","market_name":"TZ184","codename":"TZ184","model":"TZ184"},{"manufacturer":"Irbis","market_name":"TZ195","codename":"TZ195","model":"TZ195"},{"manufacturer":"Irbis","market_name":"TZ55","codename":"TZ55","model":"TZ55"},{"manufacturer":"Irbis","market_name":"TZ714","codename":"TZ714","model":"TZ714"},{"manufacturer":"Irbis","market_name":"TZ716","codename":"TZ716","model":"TZ716"},{"manufacturer":"Irbis","market_name":"TZ717","codename":"TZ717","model":"TZ717"},{"manufacturer":"Irbis","market_name":"TZ720","codename":"TZ720","model":"TZ720"},{"manufacturer":"Irbis","market_name":"TZ721","codename":"TZ721","model":"TZ721"},{"manufacturer":"Irbis","market_name":"TZ725","codename":"TZ725","model":"TZ725"},{"manufacturer":"Irbis","market_name":"TZ726","codename":"TZ726","model":"TZ726"},{"manufacturer":"Irbis","market_name":"TZ742","codename":"TZ742","model":"TZ742"},{"manufacturer":"Irbis","market_name":"TZ762","codename":"TZ762","model":"TZ762"},{"manufacturer":"Irbis","market_name":"TZ771","codename":"TZ771","model":"TZ771"},{"manufacturer":"Irbis","market_name":"TZ777","codename":"TZ777","model":"TZ777"},{"manufacturer":"Irbis","market_name":"TZ781","codename":"TZ781","model":"TZ781"},{"manufacturer":"Irbis","market_name":"TZ794","codename":"TZ794","model":"TZ794"},{"manufacturer":"Irbis","market_name":"TZ831","codename":"TZ831","model":"TZ831"},{"manufacturer":"Irbis","market_name":"TZ841","codename":"TZ841","model":"TZ841"},{"manufacturer":"Irbis","market_name":"TZ855","codename":"TZ855","model":"TZ855"},{"manufacturer":"Irbis","market_name":"TZ856","codename":"TZ856","model":"TZ856"},{"manufacturer":"Irbis","market_name":"TZ872","codename":"TZ872","model":"TZ872"},{"manufacturer":"Irbis","market_name":"TZ874","codename":"TZ874","model":"TZ874"},{"manufacturer":"Irbis","market_name":"TZ877","codename":"TZ877","model":"TZ877"},{"manufacturer":"Irbis","market_name":"TZ885","codename":"TZ885","model":"TZ885"},{"manufacturer":"Irbis","market_name":"TZ890","codename":"TZ890","model":"TZ890"},{"manufacturer":"Irbis","market_name":"TZ892","codename":"TZ892","model":"TZ892"},{"manufacturer":"Irbis","market_name":"TZ960","codename":"TZ960","model":"TZ960"},{"manufacturer":"Irbis","market_name":"TZ961","codename":"TZ961","model":"TZ961"},{"manufacturer":"Irbis","market_name":"TZ962","codename":"TZ962","model":"TZ962"},{"manufacturer":"Irbis","market_name":"TZ963","codename":"TZ963","model":"TZ963"},{"manufacturer":"Irbis","market_name":"TZ964","codename":"TZ964","model":"TZ964"},{"manufacturer":"Irbis","market_name":"TZ965","codename":"TZ965","model":"TZ965"},{"manufacturer":"Irbis","market_name":"TZ967","codename":"TZ967","model":"TZ967"},{"manufacturer":"Irbis","market_name":"TZ968","codename":"TZ968","model":"TZ968"},{"manufacturer":"Irbis","market_name":"TZ969","codename":"TZ969","model":"TZ969"},{"manufacturer":"Iris","market_name":"IS2S","codename":"IS2S","model":"IS2S"},{"manufacturer":"Iris","market_name":"IS2_Plus","codename":"IS2_Plus","model":"IS2_Plus"},{"manufacturer":"Iris","market_name":"NEXT P","codename":"NEXT_P","model":"NEXT_P"},{"manufacturer":"Iris","market_name":"NEXT P+","codename":"NEXT_P_PLUS","model":"NEXT P+"},{"manufacturer":"Iris","market_name":"NEXT U","codename":"NEXT_U","model":"NEXT U"},{"manufacturer":"Iris","market_name":"VOX  4s","codename":"VOX_4s","model":"VOX 4s"},{"manufacturer":"Iris","market_name":"VOX  Energy","codename":"VOX_Energy","model":"VOX Energy"},{"manufacturer":"Iris","market_name":"VOX  STEEL Plus","codename":"VOX_STEEL_Plus","model":"VOX STEEL Plus"},{"manufacturer":"Iris","market_name":"VOX  STEEL Plus","codename":"VOX_STEEL_Plus_V2","model":"VOX STEEL Plus"},{"manufacturer":"Isafe","market_name":"IS520.1","codename":"IS520_1","model":"IS520_1"},{"manufacturer":"Itel","market_name":"A11","codename":"itel_A11","model":"itel A11"},{"manufacturer":"Itel","market_name":"A12","codename":"itel_A12","model":"itel A12"},{"manufacturer":"Itel","market_name":"A13","codename":"itel_A13","model":"itel A13"},{"manufacturer":"Itel","market_name":"A13 Plus","codename":"itel-A13Plus","model":"itel A13Plus"},{"manufacturer":"Itel","market_name":"A15","codename":"itel-A15","model":"itel A15"},{"manufacturer":"Itel","market_name":"A21","codename":"itel_A21","model":"itel A21"},{"manufacturer":"Itel","market_name":"A31 Plus","codename":"itel-A31Plus","model":"itel A31Plus"},{"manufacturer":"Itel","market_name":"A32F","codename":"itel-A32F","model":"itel A32F"},{"manufacturer":"Itel","market_name":"A41","codename":"itel_A41","model":"itel A41"},{"manufacturer":"Itel","market_name":"A41 Plus","codename":"itel_A41Plus","model":"itel A41 Plus"},{"manufacturer":"Itel","market_name":"A43","codename":"itel-A43","model":"itel A43"},{"manufacturer":"Itel","market_name":"A44","codename":"itel-A44","model":"itel A44"},{"manufacturer":"Itel","market_name":"A44 Pro","codename":"itel-A44-Pro","model":"itel A44 Pro"},{"manufacturer":"Itel","market_name":"A51","codename":"itel_A51","model":"itel A51"},{"manufacturer":"Itel","market_name":"P11","codename":"itel_P11","model":"itel P11"},{"manufacturer":"Itel","market_name":"P12","codename":"itel_P12","model":"itel P12"},{"manufacturer":"Itel","market_name":"P31","codename":"itel-P31","model":"itel P31"},{"manufacturer":"Itel","market_name":"P32","codename":"itel-P32","model":"itel P32"},{"manufacturer":"Itel","market_name":"P51","codename":"P51","model":"itel P51"},{"manufacturer":"Itel","market_name":"Prime 4","codename":"itel_Prime4","model":"itel Prime 4"},{"manufacturer":"Itel","market_name":"S11","codename":"S11","model":"itel S11"},{"manufacturer":"Itel","market_name":"S11 Plus","codename":"S11Plus","model":"itel S11 Plus"},{"manufacturer":"Itel","market_name":"S11 Plus","codename":"S11Plus","model":"itel S11Plus"},{"manufacturer":"Itel","market_name":"S11X","codename":"itel-S11X","model":"itel S11X"},{"manufacturer":"Itel","market_name":"S21","codename":"itel-S21","model":"itel S21"},{"manufacturer":"Itel","market_name":"S31","codename":"S31","model":"itel S31"},{"manufacturer":"Itel","market_name":"S32","codename":"itel-S32","model":"itel S32"},{"manufacturer":"Itel","market_name":"S41","codename":"itel_S41","model":"itel S41"},{"manufacturer":"Itel","market_name":"S42","codename":"itel-S42","model":"itel S42"},{"manufacturer":"Itel","market_name":"it1355","codename":"itel_it1355","model":"itel it1355"},{"manufacturer":"Itel","market_name":"it1355M","codename":"itel_it1355M","model":"itel it1355M"},{"manufacturer":"Itel","market_name":"it1407","codename":"itel_it1407","model":"itel it1407"},{"manufacturer":"Itel","market_name":"it1408","codename":"itel_it1408","model":"itel it1408"},{"manufacturer":"Itel","market_name":"it1408","codename":"itel_it1408C","model":"itel it1408"},{"manufacturer":"Itel","market_name":"it1409","codename":"itel_it1409","model":"itel it1409"},{"manufacturer":"Itel","market_name":"it1460","codename":"itel-it1460-Pro","model":"itel it1460"},{"manufacturer":"Itel","market_name":"it1460","codename":"itel-it1460-Pro","model":"itel it1460 Pro"},{"manufacturer":"Itel","market_name":"it1505","codename":"itel_it1505","model":"itel_it1505"},{"manufacturer":"Itel","market_name":"it1506","codename":"itel_it1506","model":"itel it1506"},{"manufacturer":"Itel","market_name":"it1507","codename":"itel_it1507","model":"itel it1507"},{"manufacturer":"Itel","market_name":"it1507","codename":"itel_it1507C","model":"itel it1507"},{"manufacturer":"Itel","market_name":"it1508","codename":"itel_it1508","model":"itel it1508"},{"manufacturer":"Itel","market_name":"it1508","codename":"itel_it1508C","model":"itel it1508"},{"manufacturer":"Itel","market_name":"it1508","codename":"itel_it1508C","model":"itel it1508 GPS"},{"manufacturer":"Itel","market_name":"it1508 Plus","codename":"itel_it1508Plus","model":"itel it1508"},{"manufacturer":"Itel","market_name":"it1508 Plus","codename":"itel_it1508Plus","model":"itel it1508 Plus"},{"manufacturer":"Itel","market_name":"it1512","codename":"it1512","model":"it1512"},{"manufacturer":"Itel","market_name":"it1513","codename":"itel_it1513","model":"itel it1513"},{"manufacturer":"Itel","market_name":"it1516 Plus","codename":"itel_it1516Plus","model":"itel it1516 Plus"},{"manufacturer":"Itel","market_name":"it1518","codename":"itel_it1518","model":"itel it1518"},{"manufacturer":"Itel","market_name":"it1520","codename":"itel-it1520","model":"itel-it1520"},{"manufacturer":"Itel","market_name":"it1550","codename":"itel_it1550","model":"itel_it1550"},{"manufacturer":"Itel","market_name":"it1551","codename":"itel_it1551","model":"itel it1551"},{"manufacturer":"Itel","market_name":"it1551","codename":"itel_it1551C","model":"itel it1551"},{"manufacturer":"Itel","market_name":"it1553","codename":"itel-it1553","model":"itel-it1553"},{"manufacturer":"Itel","market_name":"it1556","codename":"itel_it1556","model":"itel it1556"},{"manufacturer":"Itel","market_name":"it1556 Plus","codename":"itel_it1556Plus","model":"itel it1556 Plus"},{"manufacturer":"Itel","market_name":"it1556 Plus","codename":"itel_it1556Plus","model":"itel it1556 plus"},{"manufacturer":"Itel","market_name":"it1655","codename":"itel_it1655","model":"itel it1655"},{"manufacturer":"Itel","market_name":"it1655S","codename":"itel_it1655S","model":"itel it1655S"},{"manufacturer":"Itel","market_name":"it1702","codename":"itel_it1702","model":"itel it1702"},{"manufacturer":"Itel","market_name":"it1703","codename":"itel_it1703","model":"itel it1703"},{"manufacturer":"Itel","market_name":"itel A11","codename":"itel_A11","model":"itel A11"},{"manufacturer":"Itel","market_name":"itel A20","codename":"itel-A20","model":"itel A20"},{"manufacturer":"Itel","market_name":"itel A31","codename":"itel_A31","model":"itel A31"},{"manufacturer":"Itel","market_name":"itel A40","codename":"itel-A40","model":"itel A40"},{"manufacturer":"Itel","market_name":"itel A41","codename":"itel_A41","model":"itel A41"},{"manufacturer":"Itel","market_name":"itel A42 Plus","codename":"itel-A42Plus","model":"itel A42 Plus"},{"manufacturer":"Itel","market_name":"itel A45","codename":"itel-A45","model":"itel A45"},{"manufacturer":"Itel","market_name":"itel P41","codename":"itel_P41","model":"itel P41"},{"manufacturer":"Itel","market_name":"itel Prime 4","codename":"itel_Prime4","model":"itel Prime 4"},{"manufacturer":"Itel","market_name":"itel S12","codename":"itel-S12","model":"itel S12"},{"manufacturer":"Itel","market_name":"itel S32LTE","codename":"itel-S32LTE","model":"itel S32LTE"},{"manufacturer":"Itworks","market_name":"TM705","codename":"TM705","model":"NID_7010"},{"manufacturer":"JLab","market_name":"PRO-7","codename":"polaris-p1gms","model":"JLab PRO-7"},{"manufacturer":"JP Sacouto","market_name":"Flag Mill v2","codename":"MG101A2T_BT","model":"Flag Mill v2"},{"manufacturer":"JP Sacouto","market_name":"Flag Mill v2","codename":"MG101A2T_BT_A50","model":"Flag Mill v2"},{"manufacturer":"JP Sacouto","market_name":"Flag Mill v2","codename":"MG101A2T_BT_W32","model":"Flag Mill v2"},{"manufacturer":"JP Sacouto","market_name":"MOVE_S201","codename":"move_S201_2_32_Z8350","model":"MOVE_S201"},{"manufacturer":"JP Sacouto","market_name":"Mini Mill v2","codename":"MG070A2T_BT","model":"Mini Mill v2"},{"manufacturer":"JP Sacouto","market_name":"TF10EA2","codename":"TF10EA2_Medical_2","model":"CASEBOOK_3"},{"manufacturer":"JP Sacouto","market_name":"Verdite Hill","codename":"JP_MOVE_S101","model":"Verdite Hill"},{"manufacturer":"JP Sacouto","market_name":"mymaga CLASS Plus 2","codename":"MG101A4T","model":"mymaga CLASS Plus 2"},{"manufacturer":"JVC","market_name":"","codename":"gener","model":"RY-AP1"},{"manufacturer":"JVC","market_name":"DM65UXR\\\\DM65USR\\\\DM85UXR","codename":"mstarnapoli_atsc","model":"DM65UXR"},{"manufacturer":"JabrBox","market_name":"H460","codename":"H460","model":"H460"},{"manufacturer":"JabrBox","market_name":"H460B01","codename":"H460","model":"H460"},{"manufacturer":"JabrBox","market_name":"S502","codename":"S502","model":"S502"},{"manufacturer":"Janam","market_name":"XM75","codename":"XM75","model":"XM75"},{"manufacturer":"Janam","market_name":"XT100","codename":"XT100","model":"XT100"},{"manufacturer":"Janam","market_name":"XT2","codename":"XT2","model":"XT2"},{"manufacturer":"Jesy","market_name":"J9S","codename":"J9S","model":"J9S"},{"manufacturer":"Jide","market_name":"Remix Mini","codename":"rm1g","model":"Remix Mini"},{"manufacturer":"Jimi","market_name":"KN C4","codename":"JIMI_KNC4","model":"JIMI_KNC4"},{"manufacturer":"Jimo","market_name":"S5006","codename":"S5006","model":"S5006"},{"manufacturer":"Jinga","market_name":"Jinga Joy","codename":"JI55A_189BW","model":"Joy"},{"manufacturer":"Jinga","market_name":"JoyPRO","codename":"JI55B_189BW","model":"JoyPRO"},{"manufacturer":"Jinga","market_name":"Optim 4G","codename":"Optim4G","model":"Optim4G"},{"manufacturer":"Jinga","market_name":"Pass","codename":"Pass","model":"Pass"},{"manufacturer":"Jinga","market_name":"SmartPRO","codename":"JI55_216M","model":"SmartPRO"},{"manufacturer":"Jinga","market_name":"Start 3G","codename":"Start3G","model":"Start3G"},{"manufacturer":"Jinga","market_name":"Touch 4G","codename":"Touch4G","model":"Touch4G"},{"manufacturer":"Jivi","market_name":"Energy E12","codename":"Energy_E12","model":"Energy E12"},{"manufacturer":"Jivi","market_name":"Prime P30","codename":"Prime_P30","model":"Prime P30"},{"manufacturer":"Jivi","market_name":"Prime P300","codename":"Prime_P300","model":"Prime P300"},{"manufacturer":"Jivi","market_name":"Prime P444","codename":"Prime_P444","model":"Prime P444"},{"manufacturer":"Jivi","market_name":"Prime P4442","codename":"Prime_P4442","model":"Prime P4442"},{"manufacturer":"Jivi","market_name":"Revolution TnT3","codename":"Revolution_TnT3","model":"Revolution TnT3"},{"manufacturer":"Jooyon","market_name":"J110A","codename":"J110A","model":"J110A"},{"manufacturer":"Just5","market_name":"CF8","codename":"CF8","model":"CF8"},{"manufacturer":"Just5","market_name":"COSMO L707","codename":"COSMO_L707","model":"COSMO_L707"},{"manufacturer":"Just5","market_name":"COSMO_L808","codename":"COSMO_L808","model":"COSMO L808"},{"manufacturer":"Just5","market_name":"FREEDOM C100","codename":"FREEDOM_C100","model":"FREEDOM C100"},{"manufacturer":"Just5","market_name":"FREEDOM C100","codename":"FREEDOM_C105","model":"FREEDOM C105"},{"manufacturer":"Just5","market_name":"FREEDOM X1","codename":"FREEDOM_X1","model":"FREEDOM X1"},{"manufacturer":"Just5","market_name":"Freedom M303","codename":"FREEDOM_M303","model":"FREEDOM_M303"},{"manufacturer":"Just5","market_name":"GINI Tab V7","codename":"GINI_Tab_V7","model":"GINI_Tab_V7"},{"manufacturer":"Just5","market_name":"Konrow","codename":"Konrow","model":"Just5"},{"manufacturer":"Just5","market_name":"M503","codename":"M503","model":"M503"},{"manufacturer":"Just5","market_name":"Mode1 MD-02P","codename":"MD-02P","model":"MD-02P"},{"manufacturer":"K-Touch","market_name":"","codename":"whistler","model":"W808"},{"manufacturer":"K-Touch","market_name":"K-Touch920","codename":"KTOUCH920","model":"K-Touch 920"},{"manufacturer":"K-Touch","market_name":"K3","codename":"K3","model":"K-Touch K3"},{"manufacturer":"K-Touch","market_name":"L5","codename":"L5","model":"L5"},{"manufacturer":"K-Touch","market_name":"L930i","codename":"L930i","model":"K-Touch L930i"},{"manufacturer":"K-Touch","market_name":"M2s","codename":"M2s","model":"K-Touch M2s"},{"manufacturer":"K-Touch","market_name":"Pace 2","codename":"Pace_2","model":"Pace 2"},{"manufacturer":"K-Touch","market_name":"Pace 2 Lite","codename":"Pace_2_Lite","model":"Pace 2 Lite"},{"manufacturer":"K-Touch","market_name":"Touch 2C","codename":"Touch2c","model":"K-Touch Tou ch 2c"},{"manufacturer":"KAAN","market_name":"A1","codename":"KAAN_A1","model":"KAAN_A1"},{"manufacturer":"KAAN","market_name":"KAAN_N2","codename":"KAAN_N2","model":"KAAN_N2"},{"manufacturer":"KAZAM","market_name":"TROOPER X3.5","codename":"KAZAM","model":"Trooper_X35"},{"manufacturer":"KAZAM","market_name":"TROOPER X4.0","codename":"KAZAM","model":"Trooper_X40"},{"manufacturer":"KAZAM","market_name":"TROOPER X5.5","codename":"KAZAM","model":"Trooper_X55"},{"manufacturer":"KAZAM","market_name":"TV 4.5","codename":"KOT49H","model":"KAZAM TV 45"},{"manufacturer":"KAZAM","market_name":"TV 4.5","codename":"TV_45","model":"KAZAM TV 45"},{"manufacturer":"KAZAM","market_name":"Thunder 345","codename":"Thunder_345","model":"KAZAM Thunder 345"},{"manufacturer":"KAZAM","market_name":"Thunder 345 LTE","codename":"Thunder_345_LTE","model":"KAZAM Thunder 345 LTE"},{"manufacturer":"KAZAM","market_name":"Thunder 345 LTE","codename":"Thunder_345_LTE","model":"Thunder3 45 LTE"},{"manufacturer":"KAZAM","market_name":"Thunder 345L","codename":"Thunder_345L","model":"KAZAM Thunder 345L"},{"manufacturer":"KAZAM","market_name":"Thunder 347","codename":"Thunder_347","model":"Thunder 347"},{"manufacturer":"KAZAM","market_name":"Thunder 350L","codename":"Thunder_350L","model":"KAZAM Thunder 350L"},{"manufacturer":"KAZAM","market_name":"Thunder 550","codename":"TH55025","model":"KAZAM Thunder 550"},{"manufacturer":"KAZAM","market_name":"Thunder 550L","codename":"TH5L5025","model":"KAZAM Thunder 550L"},{"manufacturer":"KAZAM","market_name":"Thunder2 45L","codename":"Thunder2_45","model":"KAZAM THUNDER2 45L"},{"manufacturer":"KAZAM","market_name":"Thunder2 50","codename":"Thunder2_50","model":"KAZAM Thunder2 50"},{"manufacturer":"KAZAM","market_name":"Tornado 348","codename":"Tornado_348","model":"Tornado 348"},{"manufacturer":"KAZAM","market_name":"Tornado 350","codename":"KAZAM_Tornado_350","model":"KAZAM Tornado 350"},{"manufacturer":"KAZAM","market_name":"Tornado 455L","codename":"KAZAM_Tornado_455L","model":"KAZAM Tornado 455L"},{"manufacturer":"KAZAM","market_name":"Tornado2 50","codename":"Tornado2_50","model":"KAZAM Tornado2 50"},{"manufacturer":"KAZAM","market_name":"Trooper 440L","codename":"Trooper_440L","model":"KAZAM Trooper 440L"},{"manufacturer":"KAZAM","market_name":"Trooper 445L","codename":"TR4L4544","model":"KAZAM Trooper 445L"},{"manufacturer":"KAZAM","market_name":"Trooper 450","codename":"KAZAM_Trooper_450","model":"KAZAM Trooper 450"},{"manufacturer":"KAZAM","market_name":"Trooper 450L","codename":"KAZAM_Trooper_450L","model":"KAZAM_Trooper_450L"},{"manufacturer":"KAZAM","market_name":"Trooper 451","codename":"Trooper_451","model":"KAZAM Trooper 451"},{"manufacturer":"KAZAM","market_name":"Trooper 455","codename":"TR45544","model":"KAZAM Trooper 455"},{"manufacturer":"KAZAM","market_name":"Trooper 540","codename":"TR54015","model":"KAZAM Trooper 540"},{"manufacturer":"KAZAM","market_name":"Trooper 550L","codename":"TR5L5025","model":"KAZAM Trooper 550L"},{"manufacturer":"KAZAM","market_name":"Trooper 551","codename":"TR550115","model":"KAZAM Trooper 551"},{"manufacturer":"KAZAM","market_name":"Trooper 555","codename":"TR55515","model":"KAZAM Trooper 555"},{"manufacturer":"KAZAM","market_name":"Trooper 650","codename":"TR65035","model":"KAZAM Trooper 650"},{"manufacturer":"KAZAM","market_name":"Trooper 650 4G","codename":"TR6L5035","model":"KAZAM Trooper 650 4G"},{"manufacturer":"KAZAM","market_name":"Trooper2 40","codename":"Trooper2_40","model":"KAZAM Trooper2 40"},{"manufacturer":"KAZAM","market_name":"Trooper2 45","codename":"Trooper2_45","model":"Trooper2 45"},{"manufacturer":"KAZAM","market_name":"Trooper2 50","codename":"Trooper2_50","model":"KAZAM Trooper2 50"},{"manufacturer":"KAZAM","market_name":"Trooper2 60","codename":"Trooper2_60","model":"Kazam Trooper2 60"},{"manufacturer":"KD Interactive","market_name":"C15100i","codename":"C15100i","model":"C15100i"},{"manufacturer":"KD Interactive","market_name":"C15100m","codename":"Pixi3-7_KD","model":"C15100m"},{"manufacturer":"KD Interactive","market_name":"C15150m","codename":"Pixi3-7_KD","model":"C15150m"},{"manufacturer":"KD Interactive","market_name":"Kurio Phone","codename":"C14500","model":"KurioPhone"},{"manufacturer":"KD Interactive","market_name":"Kurio Tab - Extrem","codename":"g03k","model":"C14100"},{"manufacturer":"KD Interactive","market_name":"Kurio10S","codename":"C13300A","model":"Kurio10S"},{"manufacturer":"KD Interactive","market_name":"Kurio4S","codename":"C13200A","model":"Kurio4S"},{"manufacturer":"KD Interactive","market_name":"Kurio7S","codename":"C13000A","model":"Kurio7S"},{"manufacturer":"KD Interactive","market_name":"TAB3-Premium-XTREME3","codename":"Pixi4-7_WIFI_KD","model":"01016"},{"manufacturer":"KD Interactive","market_name":"TAB3-Premium-XTREME3","codename":"Pixi4-7_WIFI_KD","model":"01516"},{"manufacturer":"KDDI","market_name":"CablePlus STB","codename":"C02AS","model":"C02AS"},{"manufacturer":"KDDI","market_name":"Power Up Unit","codename":"C02BB1","model":"C02BB1"},{"manufacturer":"KDDI","market_name":"STW2000","codename":"H02ST1","model":"STW2000"},{"manufacturer":"KDDI","market_name":"SmartTV Box","codename":"C01AS","model":"SMARTTVBOX"},{"manufacturer":"KEMPLER STRAUSS","market_name":"KEMPLER TV","codename":"KEMPLER_TV","model":"KEMPLER_TV"},{"manufacturer":"KEMPLER STRAUSS","market_name":"KEMPLER_8_PLUS","codename":"KEMPLER_8_PLUS","model":"KEMPLER_8_PLUS"},{"manufacturer":"KOOLNEE","market_name":"K1","codename":"KOOLNEE_K1","model":"K1"},{"manufacturer":"KOOOK","market_name":"C600","codename":"GBC_bravo","model":"C600"},{"manufacturer":"KT Tech","market_name":"","codename":"s120","model":"KM-S120"},{"manufacturer":"KT Tech","market_name":"","codename":"s200","model":"KM-S200"},{"manufacturer":"KT Tech","market_name":"","codename":"s220","model":"KM-S220"},{"manufacturer":"KT Tech","market_name":"","codename":"s220H","model":"KM-S220H"},{"manufacturer":"KT Tech","market_name":"","codename":"s300","model":"KM-S300"},{"manufacturer":"KT Tech","market_name":"","codename":"s330","model":"KM-S330"},{"manufacturer":"KT Tech","market_name":"EV-S100","codename":"s100","model":"EV-S100"},{"manufacturer":"KT Tech","market_name":"TAKE SUIT","codename":"e100","model":"KM-E100"},{"manufacturer":"KTV","market_name":"PureKTV","codename":"DV8219","model":"PureKTV"},{"manufacturer":"Kalley","market_name":"ELEMENT_PRO","codename":"ELEMENT_PRO","model":"ELEMENT_PRO"},{"manufacturer":"Kalley","market_name":"Klic","codename":"SA","model":"K4-02 4G"},{"manufacturer":"Kapsys","market_name":"SmartVision2","codename":"r889","model":"KAP11000"},{"manufacturer":"Karbonn","market_name":"A1 Indian","codename":"A1_Indian","model":"A1 Indian"},{"manufacturer":"Karbonn","market_name":"A40 Indian","codename":"A40_Indian","model":"A40 Indian"},{"manufacturer":"Karbonn","market_name":"A40 Indian Plus","codename":"A40_Indian_Plus","model":"A40 Indian Plus"},{"manufacturer":"Karbonn","market_name":"A41 Power","codename":"A41_Power","model":"A41 Power"},{"manufacturer":"Karbonn","market_name":"A45 Indian","codename":"A45_Indian","model":"A45 Indian"},{"manufacturer":"Karbonn","market_name":"A9_Indian","codename":"A9_Indian","model":"A9 Indian"},{"manufacturer":"Karbonn","market_name":"Aura  4G","codename":"Aura_4G","model":"Aura 4G"},{"manufacturer":"Karbonn","market_name":"Aura Champ","codename":"Aura_Champ","model":"Aura Champ"},{"manufacturer":"Karbonn","market_name":"Aura Note 2","codename":"Aura_Note_2","model":"Aura Note 2"},{"manufacturer":"Karbonn","market_name":"Aura Note 4G","codename":"AuraNote4G","model":"Aura Note 4G"},{"manufacturer":"Karbonn","market_name":"Aura Note Play","codename":"Aura_Note_Play","model":"Aura Note Play"},{"manufacturer":"Karbonn","market_name":"Aura Power","codename":"Aura_Power","model":"Aura_Power"},{"manufacturer":"Karbonn","market_name":"Aura Power 4G","codename":"AuraPower4G","model":"Aura Power 4G"},{"manufacturer":"Karbonn","market_name":"Aura Power 4G","codename":"Aura_Power_4G_Plus","model":"Aura Power 4G Plus"},{"manufacturer":"Karbonn","market_name":"Aura Power 4G Plus","codename":"Aura_Power_4G_Plus","model":"Aura Power 4G Plus"},{"manufacturer":"Karbonn","market_name":"Aura Seek Plus","codename":"Aura_Sleek_Plus","model":"Aura Sleek Plus"},{"manufacturer":"Karbonn","market_name":"Aura Sleek 4G","codename":"AuraSleek4G","model":"Aura Sleek 4G"},{"manufacturer":"Karbonn","market_name":"Indian9","codename":"Indian9","model":"Indian9"},{"manufacturer":"Karbonn","market_name":"K9 Kavach 4G","codename":"K9_Kavach","model":"K9 Kavach 4G"},{"manufacturer":"Karbonn","market_name":"K9 Smart 4G","codename":"K9Smart4G","model":"K9 Smart 4G"},{"manufacturer":"Karbonn","market_name":"K9 Smart Eco","codename":"K9_Smart_Eco","model":"K9 Smart Eco"},{"manufacturer":"Karbonn","market_name":"K9 Smart Eco Plus","codename":"K9_Smart_Eco_Plus","model":"K9 Smart Eco Plus"},{"manufacturer":"Karbonn","market_name":"K9 Smart Grand","codename":"K9_Smart_Grand","model":"K9 Smart Grand"},{"manufacturer":"Karbonn","market_name":"K9 Smart Selfie","codename":"K9_Smart_Selfie","model":"K9 Smart Selfie"},{"manufacturer":"Karbonn","market_name":"K9 Smart Yuva","codename":"K9_Smart_Yuva","model":"K9 Smart Yuva"},{"manufacturer":"Karbonn","market_name":"K9 Viraat 4G","codename":"K9_VIRAAT_4G","model":"K9 VIRAAT 4G"},{"manufacturer":"Karbonn","market_name":"Karbonn K9 Music 4G","codename":"K9Music4G","model":"K9 Music 4G"},{"manufacturer":"Karbonn","market_name":"Karbonn Yuva2","codename":"Karbonn_Yuva_2","model":"Karbonn Yuva 2"},{"manufacturer":"Karbonn","market_name":"Sparkle V","codename":"Sparkle_V_sprout","model":"Sparkle V"},{"manufacturer":"Karbonn","market_name":"Titanium Frames S7","codename":"Titanium_Frames_S7","model":"Titanium Frames S7"},{"manufacturer":"Karbonn","market_name":"Titanium Jumbo","codename":"Titanium_Jumbo","model":"Titanium Jumbo"},{"manufacturer":"Karbonn","market_name":"Titanium Jumbo 2","codename":"Titanium_Jumbo_2","model":"Titanium Jumbo 2"},{"manufacturer":"Karbonn","market_name":"Titanium Vista 4G","codename":"TitaniumVista4G","model":"Titanium Vista 4G"},{"manufacturer":"Kempler Strauss","market_name":"Alumini 3 Plus","codename":"Alumini_3_Plus","model":"Alumini_3_Plus"},{"manufacturer":"Kempler Strauss","market_name":"KEMPLER 8","codename":"KEMPLER_8","model":"KEMPLER_8"},{"manufacturer":"Kempler Strauss","market_name":"KEMPLER_X","codename":"KEMPLER_X","model":"KEMPLER_X"},{"manufacturer":"Kenbo","market_name":"E111","codename":"E111","model":"E111"},{"manufacturer":"Kenbo","market_name":"E121","codename":"E121","model":"E121"},{"manufacturer":"Kenbo","market_name":"O51","codename":"O51","model":"O51"},{"manufacturer":"Kennex","market_name":"MD7053G","codename":"MD7053G","model":"MD7053G"},{"manufacturer":"Kenwood","market_name":"KWSA80K","codename":"XP8800","model":"KWSA80K"},{"manufacturer":"Ketablet","market_name":"Ketablet","codename":"TR10CS1_6","model":"TR10CS1"},{"manufacturer":"Kiano","market_name":"Elegance 4.0 black","codename":"Elegance_4_0_black","model":"Elegance_4_0_black"},{"manufacturer":"Kiano","market_name":"Elegance 5.1","codename":"Elegance_5_1","model":"Elegance_5_1"},{"manufacturer":"Kiano","market_name":"Elegance 5.1 Pro","codename":"ELEGANCE_5_1_PRO","model":"ELEGANCE_5_1_PRO"},{"manufacturer":"Kiano","market_name":"Elegance 5.5","codename":"Elegance_5_5","model":"Elegance_5_5"},{"manufacturer":"Kiano","market_name":"Elegance 5.5 Pro","codename":"Elegance_5_5_Pro","model":"Elegance_5_5_Pro"},{"manufacturer":"Kiano","market_name":"Slim_Tab_8","codename":"Slim_Tab_8","model":"Slim_Tab_8"},{"manufacturer":"Kimfly","market_name":"E1","codename":"E1","model":"E1"},{"manufacturer":"Klipad","market_name":"7588AN","codename":"tulip-d9003","model":"7588AN"},{"manufacturer":"Klipad","market_name":"7588AN","codename":"tulip-d9003","model":"KL3838"},{"manufacturer":"Klipad","market_name":"KL300","codename":"KL300","model":"KL300"},{"manufacturer":"Klipad","market_name":"KL450","codename":"KL450","model":"KL450"},{"manufacturer":"Klipad","market_name":"KL456LD","codename":"KL456LD","model":"KL456LD"},{"manufacturer":"Klipad","market_name":"KL600","codename":"KLIPAD_KL600","model":"KLIPAD_KL600"},{"manufacturer":"Klipad","market_name":"KL600B","codename":"KLIPAD_KL600B","model":"KL600B"},{"manufacturer":"Klipad","market_name":"KLIPAD_A1040M","codename":"A1040M","model":"A1040M"},{"manufacturer":"Klipad","market_name":"KLIPAD_KL4888","codename":"KL4888","model":"KL4888"},{"manufacturer":"Klipad","market_name":"KLIPAD_SMART_D71","codename":"KLIPAD_SMART_D71","model":"KLIPAD_SMART_D71"},{"manufacturer":"Klipad","market_name":"KLIPAD_SMART_I746","codename":"KLIPAD_SMART_I746","model":"KLIPAD_SMART_I746"},{"manufacturer":"Klipad","market_name":"KL_6888","codename":"KL_6888","model":"KL_6888"},{"manufacturer":"Klipad","market_name":"PRO_I746","codename":"KLIPAD_PRO_I746","model":"KLIPAD_PRO_I746"},{"manufacturer":"Klipad","market_name":"SMART_D791","codename":"KLIPAD_SMART_D791","model":"KLIPAD_SMART_D791"},{"manufacturer":"Klipad","market_name":"SMART_I745","codename":"KLIPAD_SMART_I745","model":"KLIPAD_SMART_I745"},{"manufacturer":"Klipad","market_name":"V355","codename":"V355","model":"KLIPAD_V355"},{"manufacturer":"Klipad","market_name":"V355B","codename":"V355B","model":"KLIPAD_V355B"},{"manufacturer":"Klipad","market_name":"V51A","codename":"V51A","model":"V51A"},{"manufacturer":"Klipad","market_name":"V51B","codename":"V51B","model":"V51B"},{"manufacturer":"Kobo","market_name":"Arc","codename":"zeus","model":"Arc"},{"manufacturer":"Kobo","market_name":"Arc 10HD","codename":"macallan","model":"arc 10HD"},{"manufacturer":"Kobo","market_name":"Arc 7","codename":"lbp8","model":"arc 7"},{"manufacturer":"Kobo","market_name":"Arc 7HD","codename":"cardhu","model":"arc 7HD"},{"manufacturer":"Kobo","market_name":"Vox","codename":"pegasus","model":"Vox"},{"manufacturer":"Kodak","market_name":"Ektra","codename":"KodakEktra","model":"Ektra"},{"manufacturer":"Kodak","market_name":"IM5","codename":"IM5","model":"IM5"},{"manufacturer":"Kodak","market_name":"SP4","codename":"SP4","model":"SP4"},{"manufacturer":"Kogan","market_name":"Agora 6 Plus","codename":"Kogan_Agora_6Plus","model":"Kogan Agora 6Plus"},{"manufacturer":"Kogan","market_name":"Kogan Agora 8 Plus","codename":"Agora_8_Plus","model":"Agora 8 Plus"},{"manufacturer":"Komu","market_name":"K22","codename":"K22","model":"K22"},{"manufacturer":"Konrow","market_name":"KONROW","codename":"KONROW_701X","model":"KONROW_701X"},{"manufacturer":"Konrow","market_name":"LINK55","codename":"LINK55","model":"LINK55"},{"manufacturer":"Konrow","market_name":"Primo","codename":"PRIMO","model":"PRIMO"},{"manufacturer":"Konrow","market_name":"Sky","codename":"Sky","model":"Sky"},{"manufacturer":"Konrow","market_name":"Smartfive","codename":"KONROW_Smartfive","model":"Smartfive"},{"manufacturer":"Krono","market_name":"SKY","codename":"SKY","model":"SKY"},{"manufacturer":"Kruger&Matz","market_name":"DRIVE 5","codename":"Drive_5","model":"Kruger&Matz Drive 5"},{"manufacturer":"Kruger&Matz","market_name":"EAGLE 701","codename":"EAGLE_KM0701_1","model":"KM0701_1"},{"manufacturer":"Kruger&Matz","market_name":"EAGLE 804","codename":"EAGLE_KM0804_1","model":"KM0804_1"},{"manufacturer":"Kruger&Matz","market_name":"EAGLE 805","codename":"EAGLE_KM0805_1","model":"KM0805_1"},{"manufacturer":"Kruger&Matz","market_name":"FLOW","codename":"Kruger_Matz_FLOW","model":"FLOW"},{"manufacturer":"Kruger&Matz","market_name":"FLOW 5","codename":"FLOW_5","model":"FLOW_5"},{"manufacturer":"Kruger&Matz","market_name":"FLOW 5+","codename":"FLOW5PLUS","model":"FLOW5PLUS"},{"manufacturer":"Kruger&Matz","market_name":"KM1066","codename":"EAGLE_1066","model":"KM1066"},{"manufacturer":"Kruger&Matz","market_name":"KM1067","codename":"EAGLE_1067","model":"KM1067"},{"manufacturer":"Kruger&Matz","market_name":"LIVE 5","codename":"LIVE_5","model":"Kr\\xc3\\xbcger&Matz _LIVE5_KM0450"},{"manufacturer":"Kruger&Matz","market_name":"LIVE 5 PLUS","codename":"LIVE_5_PLUS","model":"LIVE 5 PLUS"},{"manufacturer":"Kruger&Matz","market_name":"LIVE_6plus","codename":"LIVE_6plus","model":"LIVE_6plus"},{"manufacturer":"Kruger&Matz","market_name":"MOVE 7","codename":"MOVE_7","model":"MOVE_7"},{"manufacturer":"Kruger&Matz","market_name":"MOVE8","codename":"MOVE_8","model":"MOVE_8"},{"manufacturer":"Kubo","market_name":"K5","codename":"K5","model":"K5"},{"manufacturer":"Kult","market_name":"Gladiator","codename":"Gladiator","model":"Gladiator"},{"manufacturer":"Kult","market_name":"KT05","codename":"KT05","model":"KT05"},{"manufacturer":"Kult","market_name":"Kult Ambition","codename":"Ambition","model":"Ambition"},{"manufacturer":"Kult","market_name":"Kult Beyond","codename":"Beyond","model":"Beyond"},{"manufacturer":"Kyocera","market_name":"","codename":"SCP-8600","model":"Zio"},{"manufacturer":"Kyocera","market_name":"","codename":"WX06K","model":"WX06K"},{"manufacturer":"Kyocera","market_name":"404KC","codename":"404KC","model":"404KC"},{"manufacturer":"Kyocera","market_name":"503KC","codename":"503KC","model":"503KC"},{"manufacturer":"Kyocera","market_name":"602KC","codename":"602KC","model":"602KC"},{"manufacturer":"Kyocera","market_name":"Android One S2","codename":"S2_sprout","model":"S2"},{"manufacturer":"Kyocera","market_name":"BASIO","codename":"KYV32","model":"KYV32"},{"manufacturer":"Kyocera","market_name":"BASIO 3","codename":"KYV43","model":"KYV43"},{"manufacturer":"Kyocera","market_name":"Brigadier","codename":"E6782","model":"E6782"},{"manufacturer":"Kyocera","market_name":"DIGNO","codename":"KYI11","model":"ISW11K"},{"manufacturer":"Kyocera","market_name":"DIGNO","codename":"KYL22","model":"KYL22"},{"manufacturer":"Kyocera","market_name":"DIGNO Dual","codename":"WX04K","model":"WX04K"},{"manufacturer":"Kyocera","market_name":"DIGNO L","codename":"KYV36","model":"KYV36"},{"manufacturer":"Kyocera","market_name":"DIGNO R","codename":"202K","model":"202K"},{"manufacturer":"Kyocera","market_name":"DIGNO S","codename":"KYL21","model":"KYL21"},{"manufacturer":"Kyocera","market_name":"DIGNO T","codename":"302KC","model":"302KC"},{"manufacturer":"Kyocera","market_name":"DIGNO V","codename":"KYV42","model":"KYV42_u"},{"manufacturer":"Kyocera","market_name":"DIGNO W","codename":"KYV40","model":"KYV40U"},{"manufacturer":"Kyocera","market_name":"DIGNO rafre","codename":"KYV36","model":"KYV36"},{"manufacturer":"Kyocera","market_name":"DM015K","codename":"DM015K","model":"DM015K"},{"manufacturer":"Kyocera","market_name":"DURA FORCE PRO","codename":"KC-S702","model":"KC-S702"},{"manufacturer":"Kyocera","market_name":"DuraForce","codename":"E6560","model":"KYOCERA-E6560"},{"manufacturer":"Kyocera","market_name":"DuraForce","codename":"E6560C","model":"E6560C"},{"manufacturer":"Kyocera","market_name":"DuraForce","codename":"E6560L","model":"E6560L"},{"manufacturer":"Kyocera","market_name":"DuraForce","codename":"E6560T","model":"E6560T"},{"manufacturer":"Kyocera","market_name":"DuraForce","codename":"E6762","model":"USCC-E6762"},{"manufacturer":"Kyocera","market_name":"DuraForce PRO","codename":"E6820","model":"KYOCERA-E6820"},{"manufacturer":"Kyocera","market_name":"DuraForce PRO","codename":"E6820TM_3GB","model":"E6820TM"},{"manufacturer":"Kyocera","market_name":"DuraForce PRO","codename":"E6820_3GB","model":"KYOCERA-E6820"},{"manufacturer":"Kyocera","market_name":"DuraForce PRO","codename":"E6830","model":"E6830"},{"manufacturer":"Kyocera","market_name":"DuraForce PRO","codename":"E6833","model":"E6833"},{"manufacturer":"Kyocera","market_name":"DuraForce PRO with Sapphire Shield","codename":"E6810","model":"E6810"},{"manufacturer":"Kyocera","market_name":"DuraForce PRO with Sapphire Shield","codename":"E6810_3GB","model":"E6810"},{"manufacturer":"Kyocera","market_name":"DuraForce XD","codename":"E6790","model":"KYOCERA-E6790"},{"manufacturer":"Kyocera","market_name":"DuraForce XD","codename":"E6790TM","model":"E6790TM"},{"manufacturer":"Kyocera","market_name":"DuraScout","codename":"E6782L","model":"E6782L"},{"manufacturer":"Kyocera","market_name":"Echo","codename":"KSP8000","model":"KSP8000"},{"manufacturer":"Kyocera","market_name":"Echo","codename":"M9300","model":"M9300"},{"manufacturer":"Kyocera","market_name":"Event","codename":"C5133","model":"Event"},{"manufacturer":"Kyocera","market_name":"HONEY BEE","codename":"101K","model":"101K"},{"manufacturer":"Kyocera","market_name":"Honeybee Touch","codename":"201K","model":"201K"},{"manufacturer":"Kyocera","market_name":"Hydro","codename":"C5170","model":"C5170"},{"manufacturer":"Kyocera","market_name":"Hydro","codename":"C5171","model":"Hydro"},{"manufacturer":"Kyocera","market_name":"Hydro AIR","codename":"C6745","model":"KYOCERA-C6745"},{"manufacturer":"Kyocera","market_name":"Hydro EDGE","codename":"C5215","model":"C5215"},{"manufacturer":"Kyocera","market_name":"Hydro Elite","codename":"C6750","model":"C6750"},{"manufacturer":"Kyocera","market_name":"Hydro ICON","codename":"C6730","model":"C6730"},{"manufacturer":"Kyocera","market_name":"Hydro LIFE","codename":"C6530","model":"C6530"},{"manufacturer":"Kyocera","market_name":"Hydro LIFE","codename":"C6530N","model":"C6530N"},{"manufacturer":"Kyocera","market_name":"Hydro PLUS","codename":"C5171R","model":"Hydro"},{"manufacturer":"Kyocera","market_name":"Hydro PLUS","codename":"C5171R","model":"Hydro_PLUS"},{"manufacturer":"Kyocera","market_name":"Hydro REACH","codename":"C6743","model":"C6743"},{"manufacturer":"Kyocera","market_name":"Hydro SHORE","codename":"C6742A","model":"KYOCERA-C6742A"},{"manufacturer":"Kyocera","market_name":"Hydro VIBE","codename":"C6725","model":"C6725"},{"manufacturer":"Kyocera","market_name":"Hydro VIEW","codename":"C6742","model":"C6742"},{"manufacturer":"Kyocera","market_name":"Hydro VIEW","codename":"C6742","model":"KYOCERA-C6742"},{"manufacturer":"Kyocera","market_name":"Hydro WAVE","codename":"C6740","model":"C6740"},{"manufacturer":"Kyocera","market_name":"Hydro WAVE","codename":"C6740N","model":"C6740N"},{"manufacturer":"Kyocera","market_name":"Hydro XTRM","codename":"C6522","model":"C6522"},{"manufacturer":"Kyocera","market_name":"Hydro XTRM","codename":"C6522N","model":"C6522N"},{"manufacturer":"Kyocera","market_name":"Hydro XTRM","codename":"C6721","model":"USCC-C6721"},{"manufacturer":"Kyocera","market_name":"INFOBAR A03","codename":"KYV33","model":"KYV33"},{"manufacturer":"Kyocera","market_name":"KC-01","codename":"KC-01","model":"KC-01"},{"manufacturer":"Kyocera","market_name":"LUCE","codename":"KCP01K","model":"KCP01K"},{"manufacturer":"Kyocera","market_name":"LifeWatch Universal Gateway","codename":"CD8100","model":"CD8100"},{"manufacturer":"Kyocera","market_name":"Milano","codename":"C5120","model":"C5120"},{"manufacturer":"Kyocera","market_name":"Milano","codename":"C5121","model":"C5121"},{"manufacturer":"Kyocera","market_name":"Qua phone","codename":"KYV42","model":"KYV42"},{"manufacturer":"Kyocera","market_name":"Qua phone (KYV37)","codename":"KYV37","model":"KYV37"},{"manufacturer":"Kyocera","market_name":"Qua phone QZ","codename":"KYV44","model":"KYV44"},{"manufacturer":"Kyocera","market_name":"Qua phone QZ","codename":"KYV44","model":"KYV44_u"},{"manufacturer":"Kyocera","market_name":"Qua tab QZ10","codename":"KYT33","model":"KYT33"},{"manufacturer":"Kyocera","market_name":"Qua tab QZ8","codename":"KYT32","model":"KYT32"},{"manufacturer":"Kyocera","market_name":"Rise","codename":"C5155","model":"C5155"},{"manufacturer":"Kyocera","market_name":"Rise","codename":"C5156","model":"Rise"},{"manufacturer":"Kyocera","market_name":"S301","codename":"KC-S301AE","model":"KC-S301AE"},{"manufacturer":"Kyocera","market_name":"S4","codename":"S4-KC_sprout","model":"S4-KC"},{"manufacturer":"Kyocera","market_name":"SZJ201","codename":"SZJ201","model":"SZJ-JS201"},{"manufacturer":"Kyocera","market_name":"TORQUE","codename":"KC-100S","model":"KC-100S"},{"manufacturer":"Kyocera","market_name":"TORQUE","codename":"SKT01","model":"SKT01"},{"manufacturer":"Kyocera","market_name":"TORQUE G01","codename":"KYY24","model":"KYY24"},{"manufacturer":"Kyocera","market_name":"TORQUE G02","codename":"KYV35","model":"KYV35"},{"manufacturer":"Kyocera","market_name":"TORQUE G03","codename":"KYV41","model":"KYV41"},{"manufacturer":"Kyocera","market_name":"TORQUE(KC-S701)","codename":"KC-S701","model":"KC-S701"},{"manufacturer":"Kyocera","market_name":"Torque","codename":"E6710","model":"Torque"},{"manufacturer":"Kyocera","market_name":"TorqueXT","codename":"E6715","model":"E6715"},{"manufacturer":"Kyocera","market_name":"URBANO L01","codename":"KYY21","model":"KYY21"},{"manufacturer":"Kyocera","market_name":"URBANO L02","codename":"KYY22","model":"KYY22"},{"manufacturer":"Kyocera","market_name":"URBANO L03","codename":"KYY23","model":"KYY23"},{"manufacturer":"Kyocera","market_name":"URBANO PROGRESSO","codename":"KYY04","model":"URBANO PROGRESSO"},{"manufacturer":"Kyocera","market_name":"URBANO V01","codename":"KYV31","model":"KYV31"},{"manufacturer":"Kyocera","market_name":"URBANO V02","codename":"KYV34","model":"KYV34"},{"manufacturer":"Kyocera","market_name":"URBANO V03","codename":"KYV38","model":"KYV38"},{"manufacturer":"Kyocera","market_name":"WX10K","codename":"WX10K","model":"WX10K"},{"manufacturer":"Kyocera","market_name":"X3","codename":"X3-KC_sprout","model":"X3-KC"},{"manufacturer":"Kyocera","market_name":"Zio","codename":"SCP-8600","model":"Zio"},{"manufacturer":"Kyocera","market_name":"miraie","codename":"KYL23","model":"KYL23"},{"manufacturer":"Kyocera","market_name":"miraie f","codename":"KYV39","model":"KYV39"},{"manufacturer":"Kyocera","market_name":"rafre","codename":"KYV40","model":"KYV40"},{"manufacturer":"Kyocera","market_name":"zio","codename":"msm7627_kb60","model":"Zio"},{"manufacturer":"Kyocera","market_name":"zio","codename":"msm7627_surf","model":"Zio"},{"manufacturer":"Kyocera","market_name":"zio","codename":"pls8600","model":"Zio"},{"manufacturer":"Kyowon","market_name":"All&G PAD","codename":"mypad2","model":"KA-E410W"},{"manufacturer":"LGE","market_name":"","codename":"AS855","model":"LG-AS855"},{"manufacturer":"LGE","market_name":"","codename":"LGP970","model":"LG-P970"},{"manufacturer":"LGE","market_name":"","codename":"US855","model":"USCC-US855"},{"manufacturer":"LGE","market_name":"","codename":"alessi","model":"LG-E720"},{"manufacturer":"LGE","market_name":"","codename":"alessi","model":"LG-E720b"},{"manufacturer":"LGE","market_name":"","codename":"alohag_302-220","model":"LG-C710h"},{"manufacturer":"LGE","market_name":"","codename":"black","model":"LG-KU5900"},{"manufacturer":"LGE","market_name":"","codename":"bproj_214-07","model":"LG-P970"},{"manufacturer":"LGE","market_name":"","codename":"bproj_222-88","model":"LG-P970"},{"manufacturer":"LGE","market_name":"","codename":"bproj_226-10","model":"LG-P970"},{"manufacturer":"LGE","market_name":"","codename":"bproj_228-03","model":"LG-P970"},{"manufacturer":"LGE","market_name":"","codename":"bproj_231-01","model":"LG-P970"},{"manufacturer":"LGE","market_name":"","codename":"bproj_232-05","model":"LG-P970"},{"manufacturer":"LGE","market_name":"","codename":"bproj_234-33","model":"LG-P970"},{"manufacturer":"LGE","market_name":"","codename":"bproj_260-03","model":"LG-P970"},{"manufacturer":"LGE","market_name":"","codename":"bproj_454-xxx","model":"LG-P970"},{"manufacturer":"LGE","market_name":"","codename":"bproj_530-XXX","model":"LG-P970"},{"manufacturer":"LGE","market_name":"","codename":"bproj_BAL-xxx","model":"LG-P970"},{"manufacturer":"LGE","market_name":"","codename":"bproj_OPEN-CN","model":"LG-P970"},{"manufacturer":"LGE","market_name":"","codename":"bproj_VDF-XXX","model":"LG-P970"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_268-06","model":"LG-P920"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_302-720","model":"LG-P925g"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_454-XXX","model":"LG-P920"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_466-92","model":"LG-P920"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_505-XXX","model":"LG-P920"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_515-XXX","model":"LG-P920"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_525-01","model":"LG-P920"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_525-05","model":"LG-P920"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_724-02","model":"LG-P920h"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_724-05","model":"LG-P920h"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_724-xxx","model":"LG-P920h"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_BAL-XXX","model":"LG-P920"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_CIS-XXX","model":"LG-P920"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_ESA-XXX","model":"LG-P920"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_H3G-XXX","model":"LG-P920"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_MOR-XXX","model":"LG-P920"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_OPEN-CN","model":"LG-P920"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_OPT-XXX","model":"LG-P920"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_TMO-XXX","model":"LG-P920"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_VDF-XXX","model":"LG-P920"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_tcl-mx","model":"LG-P920h"},{"manufacturer":"LGE","market_name":"","codename":"cosmo_viv-br","model":"LG-P920h"},{"manufacturer":"LGE","market_name":"","codename":"e510_724-XX","model":"LG-E510f"},{"manufacturer":"LGE","market_name":"","codename":"envt2","model":"USCC-US760"},{"manufacturer":"LGE","market_name":"","codename":"envt2","model":"VS761"},{"manufacturer":"LGE","market_name":"","codename":"envt2","model":"enV Pro"},{"manufacturer":"LGE","market_name":"","codename":"envt2","model":"enV Touch2"},{"manufacturer":"LGE","market_name":"","codename":"gelato_262-xx","model":"LG-P690"},{"manufacturer":"LGE","market_name":"","codename":"gelato_425-02","model":"LG-P690f"},{"manufacturer":"LGE","market_name":"","codename":"gelato_460-xx","model":"LG-P690"},{"manufacturer":"LGE","market_name":"","codename":"gelato_460-xx","model":"LG-P693"},{"manufacturer":"LGE","market_name":"","codename":"gelato_are-xx","model":"LG-P690"},{"manufacturer":"LGE","market_name":"","codename":"gelato_bal-xx","model":"LG-P690"},{"manufacturer":"LGE","market_name":"","codename":"gelato_hkg-xx","model":"LG-P690"},{"manufacturer":"LGE","market_name":"","codename":"gelato_mor-xx","model":"LG-P690"},{"manufacturer":"LGE","market_name":"","codename":"gelato_nfc_234-10","model":"LG-P692"},{"manufacturer":"LGE","market_name":"","codename":"gelato_nfc_530-24","model":"LG-P692"},{"manufacturer":"LGE","market_name":"","codename":"gelato_nfc_tim-it","model":"LG-P692"},{"manufacturer":"LGE","market_name":"","codename":"gelato_ngr-xx","model":"LG-P690"},{"manufacturer":"LGE","market_name":"","codename":"gelato_sgp-xx","model":"LG-P690"},{"manufacturer":"LGE","market_name":"","codename":"gelato_tmb-sk","model":"LG-P690"},{"manufacturer":"LGE","market_name":"","codename":"gelato_tur-xx","model":"LG-P690"},{"manufacturer":"LGE","market_name":"","codename":"gelato_win-it","model":"LG-P690"},{"manufacturer":"LGE","market_name":"","codename":"gelatods_bal-xxx","model":"LG-P698"},{"manufacturer":"LGE","market_name":"","codename":"gelatods_ngr-xxx","model":"LG-P698"},{"manufacturer":"LGE","market_name":"","codename":"gelatods_open-xx","model":"LG-P698"},{"manufacturer":"LGE","market_name":"","codename":"gelatods_tha-xxx","model":"LG-P698f"},{"manufacturer":"LGE","market_name":"","codename":"hub","model":"LG-LU3000"},{"manufacturer":"LGE","market_name":"","codename":"ku9500","model":"KU9500"},{"manufacturer":"LGE","market_name":"","codename":"l95g","model":"LG-L95G"},{"manufacturer":"LGE","market_name":"","codename":"ls700","model":"LG-LS700"},{"manufacturer":"LGE","market_name":"","codename":"lu2300","model":"LU2300"},{"manufacturer":"LGE","market_name":"","codename":"lu3100","model":"LG-LU3100"},{"manufacturer":"LGE","market_name":"","codename":"msm8660_surf","model":"LG-LU6200"},{"manufacturer":"LGE","market_name":"","codename":"p2","model":"LG-P940h"},{"manufacturer":"LGE","market_name":"","codename":"p925g","model":"LG-P925g"},{"manufacturer":"LGE","market_name":"","codename":"p940","model":"LG-P940"},{"manufacturer":"LGE","market_name":"","codename":"p990_208-10","model":"LG-P990"},{"manufacturer":"LGE","market_name":"","codename":"p990_214-01","model":"LG-P990"},{"manufacturer":"LGE","market_name":"","codename":"p990_219-10","model":"LG-P990"},{"manufacturer":"LGE","market_name":"","codename":"p990_226-01","model":"LG-P990"},{"manufacturer":"LGE","market_name":"","codename":"p990_228-01","model":"LG-P990"},{"manufacturer":"LGE","market_name":"","codename":"p990_234-xx","model":"LG-P990"},{"manufacturer":"LGE","market_name":"","codename":"p990_262-02","model":"LG-P990"},{"manufacturer":"LGE","market_name":"","codename":"p990_454-xxx","model":"LG-P990"},{"manufacturer":"LGE","market_name":"","codename":"p990_466-92","model":"LG-P990"},{"manufacturer":"LGE","market_name":"","codename":"p990_466-xxx","model":"LG-P990"},{"manufacturer":"LGE","market_name":"","codename":"p990_505-xxx","model":"LG-P990"},{"manufacturer":"LGE","market_name":"","codename":"p990_525-01","model":"LG-P990"},{"manufacturer":"LGE","market_name":"","codename":"p990_525-05","model":"LG-P990"},{"manufacturer":"LGE","market_name":"","codename":"p990_BAL-xxx","model":"LG-P990"},{"manufacturer":"LGE","market_name":"","codename":"p990_esa-xxx","model":"LG-P990"},{"manufacturer":"LGE","market_name":"","codename":"p990h","model":"LG-P990h"},{"manufacturer":"LGE","market_name":"","codename":"p990h_334-020","model":"LG-P990h"},{"manufacturer":"LGE","market_name":"","codename":"p990h_716-10","model":"LG-P990h"},{"manufacturer":"LGE","market_name":"","codename":"p990h_722-34","model":"LG-P990h"},{"manufacturer":"LGE","market_name":"","codename":"p990h_724-05","model":"LG-P990h"},{"manufacturer":"LGE","market_name":"","codename":"p990h_730-01","model":"LG-P990h"},{"manufacturer":"LGE","market_name":"","codename":"p990h_730-03","model":"LG-P990h"},{"manufacturer":"LGE","market_name":"","codename":"p990h_CTM-xxx","model":"LG-P990h"},{"manufacturer":"LGE","market_name":"","codename":"p990h_SSV-xxx","model":"LG-P990h"},{"manufacturer":"LGE","market_name":"","codename":"p993","model":"LG-P993"},{"manufacturer":"LGE","market_name":"","codename":"star","model":"LG-P990hN"},{"manufacturer":"LGE","market_name":"","codename":"univa_228-01","model":"LG-E510"},{"manufacturer":"LGE","market_name":"","codename":"univa_454-xx","model":"LG-E510"},{"manufacturer":"LGE","market_name":"","codename":"univa_525-01","model":"LG-E510"},{"manufacturer":"LGE","market_name":"","codename":"univa_525-05","model":"LG-E510"},{"manufacturer":"LGE","market_name":"","codename":"univa_722-34","model":"LG-E510g"},{"manufacturer":"LGE","market_name":"","codename":"univa_bal-xxx","model":"LG-E510"},{"manufacturer":"LGE","market_name":"","codename":"univa_neu-xx","model":"LG-E510"},{"manufacturer":"LGE","market_name":"","codename":"univa_open_cn","model":"LG-E510"},{"manufacturer":"LGE","market_name":"","codename":"univa_tha-xx","model":"LG-E510f"},{"manufacturer":"LGE","market_name":"","codename":"univa_tmo-gr","model":"LG-E510"},{"manufacturer":"LGE","market_name":"","codename":"univa_vdf-es","model":"LG-E510"},{"manufacturer":"LGE","market_name":"","codename":"v900aus","model":"LG-V900"},{"manufacturer":"LGE","market_name":"","codename":"v901twn","model":"LG-V901"},{"manufacturer":"LGE","market_name":"","codename":"x2_450-08","model":"LG-KU8800"},{"manufacturer":"LGE","market_name":"","codename":"x3","model":"LG-P880"},{"manufacturer":"LGE","market_name":"070 touch","codename":"w3voip","model":"LG-FL40L"},{"manufacturer":"LGE","market_name":"10SM3TB","codename":"lg_10sm3tb","model":"10sm3tb"},{"manufacturer":"LGE","market_name":"AKA","codename":"aka","model":"LG-F520L"},{"manufacturer":"LGE","market_name":"AKA","codename":"aka","model":"LG-F520S"},{"manufacturer":"LGE","market_name":"AKA","codename":"aka","model":"LG-H788"},{"manufacturer":"LGE","market_name":"Ally","codename":"aloha","model":"AS740"},{"manufacturer":"LGE","market_name":"Ally","codename":"aloha","model":"Ally"},{"manufacturer":"LGE","market_name":"Ally","codename":"aloha","model":"Aloha"},{"manufacturer":"LGE","market_name":"Ally","codename":"aloha","model":"US740"},{"manufacturer":"LGE","market_name":"Android TV","codename":"cosmo","model":"LG Google TV"},{"manufacturer":"LGE","market_name":"Android TV","codename":"eden","model":"LG Android TV V4"},{"manufacturer":"LGE","market_name":"Android TV","codename":"eden","model":"LG Google TV G3"},{"manufacturer":"LGE","market_name":"Android TV","codename":"eden","model":"LG Google TV G3 KR"},{"manufacturer":"LGE","market_name":"Android TV G3","codename":"eden","model":"LG Google TV G3"},{"manufacturer":"LGE","market_name":"B6","codename":"b6","model":"LGT02"},{"manufacturer":"LGE","market_name":"DM-01G","codename":"DM-01G","model":"DM-01G"},{"manufacturer":"LGE","market_name":"DM-01K","codename":"DM-01K","model":"DM-01K"},{"manufacturer":"LGE","market_name":"DM-02H","codename":"DM-02H","model":"DM-02H"},{"manufacturer":"LGE","market_name":"Enact","codename":"fx3q","model":"VS890 4G"},{"manufacturer":"LGE","market_name":"Escape","codename":"l1a","model":"LG-P870"},{"manufacturer":"LGE","market_name":"Eve","codename":"EVE","model":"GW620"},{"manufacturer":"LGE","market_name":"Eve","codename":"EVE","model":"LG GW620"},{"manufacturer":"LGE","market_name":"Eve","codename":"EVE","model":"LG GW620F"},{"manufacturer":"LGE","market_name":"Eve","codename":"EVE","model":"LG GW620R"},{"manufacturer":"LGE","market_name":"Eve","codename":"EVE","model":"LG GW620g"},{"manufacturer":"LGE","market_name":"Eve","codename":"EVE","model":"LG KH5200"},{"manufacturer":"LGE","market_name":"Eve","codename":"EVE","model":"LG-GW620"},{"manufacturer":"LGE","market_name":"Eve","codename":"EVE","model":"LG-KH5200"},{"manufacturer":"LGE","market_name":"F60","codename":"e2","model":"LG-D390"},{"manufacturer":"LGE","market_name":"F60","codename":"e2","model":"LG-D390AR"},{"manufacturer":"LGE","market_name":"F60","codename":"e2ds","model":"LG-D392"},{"manufacturer":"LGE","market_name":"F60","codename":"e2n","model":"LG-D390n"},{"manufacturer":"LGE","market_name":"F60","codename":"e2nac","model":"LG-D393"},{"manufacturer":"LGE","market_name":"F60","codename":"e2nam","model":"LGMS395"},{"manufacturer":"LGE","market_name":"F60","codename":"e2nas","model":"LGLS660"},{"manufacturer":"LGE","market_name":"F60","codename":"e2nav","model":"VS810PP"},{"manufacturer":"LGE","market_name":"F70","codename":"f70","model":"LGL31L"},{"manufacturer":"LGE","market_name":"Fortune","codename":"lv1","model":"LG-M153"},{"manufacturer":"LGE","market_name":"Fortune","codename":"lv1","model":"LG-M154"},{"manufacturer":"LGE","market_name":"Fortune 2","codename":"cv1","model":"LM-X210CM"},{"manufacturer":"LGE","market_name":"Fortune 2","codename":"cv1","model":"LM-X210CMR"},{"manufacturer":"LGE","market_name":"G PAD\\xe2\\x85\\xa2 10.1","codename":"th10","model":"LG-X760"},{"manufacturer":"LGE","market_name":"G PAD\\xe2\\x85\\xa2 10.1","codename":"th10","model":"LG-X760E"},{"manufacturer":"LGE","market_name":"G PAD\\xe2\\x85\\xa2 10.1","codename":"th10","model":"LG-X760W"},{"manufacturer":"LGE","market_name":"G Pad 10.1","codename":"e9wifi","model":"LG-V700"},{"manufacturer":"LGE","market_name":"G Pad 10.1","codename":"e9wifin","model":"LG-V700WJ"},{"manufacturer":"LGE","market_name":"G Pad 10.1","codename":"e9wifin","model":"LG-V700n"},{"manufacturer":"LGE","market_name":"G Pad 10.1 LTE","codename":"e9lte","model":"LG-VK700"},{"manufacturer":"LGE","market_name":"G Pad 10.1 LTE","codename":"e9lte","model":"VK700"},{"manufacturer":"LGE","market_name":"G Pad 7.0","codename":"e7wifi","model":"LG-V400"},{"manufacturer":"LGE","market_name":"G Pad 7.0","codename":"e7wifi","model":"LG-V400S1"},{"manufacturer":"LGE","market_name":"G Pad 7.0","codename":"e7wifi","model":"LG-V400Y1"},{"manufacturer":"LGE","market_name":"G Pad 7.0","codename":"e7wifi","model":"LG-V400Y7"},{"manufacturer":"LGE","market_name":"G Pad 7.0 LTE","codename":"e7lte","model":"LG-V410"},{"manufacturer":"LGE","market_name":"G Pad 7.0 LTE","codename":"e7lte","model":"LG-V411"},{"manufacturer":"LGE","market_name":"G Pad 7.0 LTE","codename":"e7lte","model":"LGUK410"},{"manufacturer":"LGE","market_name":"G Pad 8+","codename":"altev2","model":"AK815"},{"manufacturer":"LGE","market_name":"G Pad 8.0","codename":"e8wifi","model":"LG-V480"},{"manufacturer":"LGE","market_name":"G Pad II 8.0","codename":"t8wifi","model":"LG-V498"},{"manufacturer":"LGE","market_name":"G Pad II 8.0","codename":"t8wifi","model":"LG-V498S1"},{"manufacturer":"LGE","market_name":"G Pad II 8.0","codename":"t8wifi","model":"LG-V498S2"},{"manufacturer":"LGE","market_name":"G Pad III 8.0 Homeboy","codename":"b6","model":"LG-P451L"},{"manufacturer":"LGE","market_name":"G Pad \\xe2\\x85\\xa1 10.1","codename":"t1lte","model":"LGUK932"},{"manufacturer":"LGE","market_name":"G Pad \\xe2\\x85\\xa1 10.1 FHD 4G LTE","codename":"t1lte","model":"LG-V935"},{"manufacturer":"LGE","market_name":"G Pad \\xe2\\x85\\xa1 10.1 FHD 4G LTE","codename":"t1lte","model":"LG-V935T"},{"manufacturer":"LGE","market_name":"G Pro Lite","codename":"luv90ds","model":"LG-D685"},{"manufacturer":"LGE","market_name":"G Pro Lite","codename":"luv90ds","model":"LG-D686"},{"manufacturer":"LGE","market_name":"G Pro Lite","codename":"luv90nfc","model":"LG-D683"},{"manufacturer":"LGE","market_name":"G Pro Lite","codename":"luv90nfc","model":"LG-D684"},{"manufacturer":"LGE","market_name":"G Pro Lite","codename":"luv90ss","model":"LG-D680"},{"manufacturer":"LGE","market_name":"G Pro Lite","codename":"luv90ss","model":"LG-D681"},{"manufacturer":"LGE","market_name":"G Pro Lite","codename":"luv90ss","model":"LG-D682"},{"manufacturer":"LGE","market_name":"G Pro Lite","codename":"luv90ss","model":"LG-D682TR"},{"manufacturer":"LGE","market_name":"G Pro2","codename":"b1","model":"LG-F350K"},{"manufacturer":"LGE","market_name":"G Pro2","codename":"b1","model":"LG-F350L"},{"manufacturer":"LGE","market_name":"G Pro2","codename":"b1","model":"LG-F350S"},{"manufacturer":"LGE","market_name":"G Pro2","codename":"b1w","model":"LG-D838"},{"manufacturer":"LGE","market_name":"G Stylo","codename":"g4stylusw","model":"LG-F560K"},{"manufacturer":"LGE","market_name":"G Vista","codename":"b2lds","model":"LG-D690"},{"manufacturer":"LGE","market_name":"G Vista","codename":"x10","model":"VS880"},{"manufacturer":"LGE","market_name":"G Vista","codename":"x10","model":"VS880PP"},{"manufacturer":"LGE","market_name":"G Watch","codename":"dory","model":"G Watch"},{"manufacturer":"LGE","market_name":"G Watch R","codename":"lenok","model":"G Watch R"},{"manufacturer":"LGE","market_name":"G pad 8.0","codename":"e8wifi","model":"LG-V480"},{"manufacturer":"LGE","market_name":"G pad 8.0 LTE","codename":"e8lte","model":"LG-V490"},{"manufacturer":"LGE","market_name":"G2 MINI","codename":"g2m","model":"LG-D620"},{"manufacturer":"LGE","market_name":"G2 MINI","codename":"g2mds","model":"LG-D618"},{"manufacturer":"LGE","market_name":"G2 MINI","codename":"g2mss","model":"LG-D610"},{"manufacturer":"LGE","market_name":"G2 MINI","codename":"g2mss","model":"LG-D610AR"},{"manufacturer":"LGE","market_name":"G2 MINI","codename":"g2mss","model":"LG-D610TR"},{"manufacturer":"LGE","market_name":"G2 MINI","codename":"g2mv","model":"LG-D625"},{"manufacturer":"LGE","market_name":"G2 mini 4G LTE","codename":"g2mv","model":"LG-D625"},{"manufacturer":"LGE","market_name":"G3 Beat","codename":"jagdsnm","model":"LG-D726"},{"manufacturer":"LGE","market_name":"G3 Beat","codename":"jagdsnm","model":"LG-D728"},{"manufacturer":"LGE","market_name":"G3 Beat","codename":"jagdsnm","model":"LG-D729"},{"manufacturer":"LGE","market_name":"G3 Beat","codename":"jagn","model":"LG-F470K"},{"manufacturer":"LGE","market_name":"G3 Beat","codename":"jagn","model":"LG-F470L"},{"manufacturer":"LGE","market_name":"G3 Beat","codename":"jagn","model":"LG-F470S"},{"manufacturer":"LGE","market_name":"G3 Beat","codename":"jagnm","model":"LG-D722J"},{"manufacturer":"LGE","market_name":"G3 Beat","codename":"jagnm","model":"LG-D727"},{"manufacturer":"LGE","market_name":"G3 S","codename":"jag3gds","model":"LG-D724"},{"manufacturer":"LGE","market_name":"G3 S","codename":"jag3gss","model":"LG-D723"},{"manufacturer":"LGE","market_name":"G3 S","codename":"jagnm","model":"LG-D722"},{"manufacturer":"LGE","market_name":"G3 S","codename":"jagnm","model":"LG-D722AR"},{"manufacturer":"LGE","market_name":"G3 S","codename":"jagnm","model":"LG-D725PR"},{"manufacturer":"LGE","market_name":"G3 Screen","codename":"liger","model":"LG-F490L"},{"manufacturer":"LGE","market_name":"G3 Stylus","codename":"b2ldsn","model":"LG-D690n"},{"manufacturer":"LGE","market_name":"G3 Stylus","codename":"b2lss","model":"LG-D693"},{"manufacturer":"LGE","market_name":"G3 Stylus","codename":"b2lss","model":"LG-D693AR"},{"manufacturer":"LGE","market_name":"G3 Stylus","codename":"b2lss","model":"LG-D693TR"},{"manufacturer":"LGE","market_name":"G3 Stylus","codename":"b2lssn","model":"LG-D693n"},{"manufacturer":"LGE","market_name":"G3 Vigor","codename":"jagc","model":"LGLS885"},{"manufacturer":"LGE","market_name":"G3 Vigor","codename":"jagnm","model":"LG-D725"},{"manufacturer":"LGE","market_name":"G6Fit","codename":"lucye","model":"LM-Q850K"},{"manufacturer":"LGE","market_name":"G6Fit","codename":"lucye","model":"LM-Q850L"},{"manufacturer":"LGE","market_name":"G6Fit","codename":"lucye","model":"LM-Q850S"},{"manufacturer":"LGE","market_name":"GA7800","codename":"eden","model":"LG Android TV V4"},{"manufacturer":"LGE","market_name":"GPAD 7.0 LTE","codename":"e7lte","model":"VK410"},{"manufacturer":"LGE","market_name":"Gentle","codename":"cf","model":"LG-F580L"},{"manufacturer":"LGE","market_name":"Gpad 7.0","codename":"e7wifi","model":"LG-V400"},{"manufacturer":"LGE","market_name":"Gx2","codename":"b2ln","model":"LG-F430L"},{"manufacturer":"LGE","market_name":"Homeboy2","codename":"t8wi7u","model":"LG-V607L"},{"manufacturer":"LGE","market_name":"Ice cream Smart","codename":"vfpv","model":"LG-F440L"},{"manufacturer":"LGE","market_name":"Intuition","codename":"batman_vzw","model":"VS950 4G"},{"manufacturer":"LGE","market_name":"JOJO","codename":"L-02K","model":"L-02K"},{"manufacturer":"LGE","market_name":"K20","codename":"lv517","model":"RS501"},{"manufacturer":"LGE","market_name":"K3 2017","codename":"lv0","model":"LG-AS110"},{"manufacturer":"LGE","market_name":"K3 2017","codename":"lv0","model":"LGUS110"},{"manufacturer":"LGE","market_name":"K4","codename":"lv1","model":"LG-M151"},{"manufacturer":"LGE","market_name":"K4 (2017)","codename":"lv1","model":"LGL157BL"},{"manufacturer":"LGE","market_name":"K4 (2017)","codename":"lv1","model":"LGL57BL"},{"manufacturer":"LGE","market_name":"L Bello","codename":"luv80ds","model":"LG-D335"},{"manufacturer":"LGE","market_name":"L Bello","codename":"luv80ds","model":"LG-D335E"},{"manufacturer":"LGE","market_name":"L Bello","codename":"luv80ds","model":"LG-D337"},{"manufacturer":"LGE","market_name":"L Fino","codename":"l70p","model":"LG-D290"},{"manufacturer":"LGE","market_name":"L Fino","codename":"l70p","model":"LG-D290AR"},{"manufacturer":"LGE","market_name":"L Fino","codename":"l70pds","model":"LG-D295"},{"manufacturer":"LGE","market_name":"L Fino","codename":"l70pn","model":"LG-D290"},{"manufacturer":"LGE","market_name":"L-01F","codename":"g2","model":"L-01F"},{"manufacturer":"LGE","market_name":"L20","codename":"luv20ds","model":"LG-D105"},{"manufacturer":"LGE","market_name":"L20","codename":"luv20ss","model":"LG-D100"},{"manufacturer":"LGE","market_name":"L20","codename":"luv20ss","model":"LG-D100AR"},{"manufacturer":"LGE","market_name":"L20","codename":"luv20ts","model":"LG-D107"},{"manufacturer":"LGE","market_name":"L30 Sporty","codename":"luv30ds","model":"LG-D125"},{"manufacturer":"LGE","market_name":"L30 Sporty","codename":"luv30ss","model":"LG-D120"},{"manufacturer":"LGE","market_name":"L30 Sporty","codename":"luv30ss","model":"LG-D120AR"},{"manufacturer":"LGE","market_name":"L45","codename":"lo_2","model":"LG-X130g"},{"manufacturer":"LGE","market_name":"L45","codename":"lo_2_ds","model":"LG-X132"},{"manufacturer":"LGE","market_name":"L50 Sporty","codename":"luv50ds","model":"LG-D221"},{"manufacturer":"LGE","market_name":"L50 Sporty","codename":"luv50ds","model":"LG-D227"},{"manufacturer":"LGE","market_name":"L50 Sporty","codename":"luv50ss","model":"LG-D213"},{"manufacturer":"LGE","market_name":"L50 Sporty","codename":"luv50ss","model":"LG-D213AR"},{"manufacturer":"LGE","market_name":"L50 Sporty","codename":"luv50ssn","model":"LG-D213"},{"manufacturer":"LGE","market_name":"L5000","codename":"l5000","model":"LG-F590"},{"manufacturer":"LGE","market_name":"L60","codename":"lo_1","model":"LG-X135"},{"manufacturer":"LGE","market_name":"L60","codename":"lo_1","model":"LG-X137"},{"manufacturer":"LGE","market_name":"L60","codename":"lo_1","model":"LG-X140"},{"manufacturer":"LGE","market_name":"L60","codename":"lo_1","model":"LG-X145"},{"manufacturer":"LGE","market_name":"L60","codename":"lo_1","model":"LG-X147"},{"manufacturer":"LGE","market_name":"L65","codename":"w55","model":"LG-D280"},{"manufacturer":"LGE","market_name":"L65","codename":"w55ds","model":"LG-D285"},{"manufacturer":"LGE","market_name":"L65","codename":"w55n","model":"LG-D280"},{"manufacturer":"LGE","market_name":"L7 II","codename":"vee7e","model":"LG-P712"},{"manufacturer":"LGE","market_name":"L7 II","codename":"vee7e","model":"LG-P714"},{"manufacturer":"LGE","market_name":"L7 II Dual","codename":"vee7ds","model":"LG-P716"},{"manufacturer":"LGE","market_name":"L70","codename":"w5","model":"LG-D320"},{"manufacturer":"LGE","market_name":"L70","codename":"w5","model":"LG-D320AR"},{"manufacturer":"LGE","market_name":"L70","codename":"w5","model":"LG-D321"},{"manufacturer":"LGE","market_name":"L70","codename":"w5","model":"LGAS323"},{"manufacturer":"LGE","market_name":"L70","codename":"w5","model":"LGMS323"},{"manufacturer":"LGE","market_name":"L70","codename":"w5c","model":"LGLS620"},{"manufacturer":"LGE","market_name":"L70","codename":"w5ds","model":"LG-D325"},{"manufacturer":"LGE","market_name":"L70","codename":"w5n","model":"LG-D320"},{"manufacturer":"LGE","market_name":"L70","codename":"w5n","model":"LG-D329"},{"manufacturer":"LGE","market_name":"L70","codename":"w5ts","model":"LG-D340f8"},{"manufacturer":"LGE","market_name":"L70 CDMA","codename":"w5c","model":"LGL41C"},{"manufacturer":"LGE","market_name":"L80 Dual","codename":"w6ds","model":"LG-D380"},{"manufacturer":"LGE","market_name":"L80 Dual","codename":"w6ds","model":"LG-D385"},{"manufacturer":"LGE","market_name":"L80 Single","codename":"w6","model":"LG-D370"},{"manufacturer":"LGE","market_name":"L80 Single","codename":"w6","model":"LG-D373"},{"manufacturer":"LGE","market_name":"L80 Single","codename":"w6","model":"LG-D375"},{"manufacturer":"LGE","market_name":"L80 Single","codename":"w6","model":"LG-D375AR"},{"manufacturer":"LGE","market_name":"L90","codename":"w7","model":"LG-D400"},{"manufacturer":"LGE","market_name":"L90","codename":"w7","model":"LG-D405"},{"manufacturer":"LGE","market_name":"L90","codename":"w7","model":"LG-D415"},{"manufacturer":"LGE","market_name":"L90","codename":"w7ds","model":"LG-D410"},{"manufacturer":"LGE","market_name":"L90","codename":"w7n","model":"LG-D400"},{"manufacturer":"LGE","market_name":"L90","codename":"w7n","model":"LG-D405"},{"manufacturer":"LGE","market_name":"L90 Dual","codename":"w7dsn","model":"LG-D410"},{"manufacturer":"LGE","market_name":"LBello","codename":"luv80ss","model":"LG-D331"},{"manufacturer":"LGE","market_name":"LBello","codename":"luv80ss","model":"LG-D331AR"},{"manufacturer":"LGE","market_name":"LG AKA","codename":"aka","model":"LG-H778"},{"manufacturer":"LGE","market_name":"LG AKA","codename":"aka","model":"LG-H779"},{"manufacturer":"LGE","market_name":"LG AKA","codename":"aka","model":"LG-H788"},{"manufacturer":"LGE","market_name":"LG AKA","codename":"aka","model":"LG-H788SG"},{"manufacturer":"LGE","market_name":"LG AKA","codename":"aka","model":"LG-H788TR"},{"manufacturer":"LGE","market_name":"LG AKA","codename":"aka","model":"LG-H788n"},{"manufacturer":"LGE","market_name":"LG Aristo","codename":"lv3","model":"LGMS210"},{"manufacturer":"LGE","market_name":"LG Bello II","codename":"v10","model":"LG-X150"},{"manufacturer":"LGE","market_name":"LG Bello II","codename":"v10","model":"LG-X155"},{"manufacturer":"LGE","market_name":"LG Bello II","codename":"v10","model":"LG-X165g"},{"manufacturer":"LGE","market_name":"LG Bello II","codename":"v10","model":"LG-X170g"},{"manufacturer":"LGE","market_name":"LG Class","codename":"c100n","model":"LG-F620K"},{"manufacturer":"LGE","market_name":"LG Class","codename":"c100n","model":"LG-F620L"},{"manufacturer":"LGE","market_name":"LG Class","codename":"c100n","model":"LG-F620S"},{"manufacturer":"LGE","market_name":"LG Classic","codename":"y30t","model":"LGL17AG"},{"manufacturer":"LGE","market_name":"LG Classic","codename":"y30tc","model":"LGL18VC"},{"manufacturer":"LGE","market_name":"LG Connect 4G","codename":"cayman","model":"LG-MS840"},{"manufacturer":"LGE","market_name":"LG DOUBLEPLAY","codename":"lgc729","model":"LG-C729"},{"manufacturer":"LGE","market_name":"LG Destiny","codename":"y50","model":"LGL21G"},{"manufacturer":"LGE","market_name":"LG Enlighten","codename":"VS700","model":"LG-VS700"},{"manufacturer":"LGE","market_name":"LG Enlighten","codename":"VS700","model":"LG-VS700PP"},{"manufacturer":"LGE","market_name":"LG Escape 3","codename":"m1v","model":"LG-K373"},{"manufacturer":"LGE","market_name":"LG Escape2","codename":"c70n","model":"LG-H443"},{"manufacturer":"LGE","market_name":"LG Escape2","codename":"c70n","model":"LG-H445"},{"manufacturer":"LGE","market_name":"LG Esteem","codename":"MS910","model":"LG-MS910"},{"manufacturer":"LGE","market_name":"LG F570S","codename":"yg","model":"LG-F570S"},{"manufacturer":"LGE","market_name":"LG F70","codename":"f70n","model":"LG-D315"},{"manufacturer":"LGE","market_name":"LG F70","codename":"f70n","model":"LG-D315l"},{"manufacturer":"LGE","market_name":"LG F70","codename":"f70n","model":"LG-F370K"},{"manufacturer":"LGE","market_name":"LG F70","codename":"f70n","model":"LG-F370L"},{"manufacturer":"LGE","market_name":"LG F70","codename":"f70n","model":"LG-F370S"},{"manufacturer":"LGE","market_name":"LG Fiesta 2 LTE","codename":"lv7","model":"LGL163BL"},{"manufacturer":"LGE","market_name":"LG Fiesta 2 LTE","codename":"lv7","model":"LGL164VL"},{"manufacturer":"LGE","market_name":"LG Fiesta LTE","codename":"lv7","model":"LGL63BL"},{"manufacturer":"LGE","market_name":"LG Fiesta LTE","codename":"lv7","model":"LGL64VL"},{"manufacturer":"LGE","market_name":"LG G Flex","codename":"zee","model":"LG-D950"},{"manufacturer":"LGE","market_name":"LG G Flex","codename":"zee","model":"LG-D950G"},{"manufacturer":"LGE","market_name":"LG G Flex","codename":"zee","model":"LG-D951"},{"manufacturer":"LGE","market_name":"LG G Flex","codename":"zee","model":"LG-D955"},{"manufacturer":"LGE","market_name":"LG G Flex","codename":"zee","model":"LG-D956"},{"manufacturer":"LGE","market_name":"LG G Flex","codename":"zee","model":"LG-D958"},{"manufacturer":"LGE","market_name":"LG G Flex","codename":"zee","model":"LG-D959"},{"manufacturer":"LGE","market_name":"LG G Flex","codename":"zee","model":"LG-F340K"},{"manufacturer":"LGE","market_name":"LG G Flex","codename":"zee","model":"LG-F340L"},{"manufacturer":"LGE","market_name":"LG G Flex","codename":"zee","model":"LG-F340S"},{"manufacturer":"LGE","market_name":"LG G Flex","codename":"zee","model":"LG-LS995"},{"manufacturer":"LGE","market_name":"LG G Flex","codename":"zee","model":"LGL23"},{"manufacturer":"LGE","market_name":"LG G Flex2","codename":"z2","model":"LG-F510K"},{"manufacturer":"LGE","market_name":"LG G Flex2","codename":"z2","model":"LG-F510L"},{"manufacturer":"LGE","market_name":"LG G Flex2","codename":"z2","model":"LG-F510S"},{"manufacturer":"LGE","market_name":"LG G Flex2","codename":"z2","model":"LG-H950"},{"manufacturer":"LGE","market_name":"LG G Flex2","codename":"z2","model":"LG-H955"},{"manufacturer":"LGE","market_name":"LG G Flex2","codename":"z2","model":"LG-H959"},{"manufacturer":"LGE","market_name":"LG G Flex2","codename":"z2","model":"LGAS995"},{"manufacturer":"LGE","market_name":"LG G Flex2","codename":"z2","model":"LGLS996"},{"manufacturer":"LGE","market_name":"LG G Flex2","codename":"z2","model":"LGUS995"},{"manufacturer":"LGE","market_name":"LG G Pad 8.0 L Edition","codename":"e8lte","model":"LGT01"},{"manufacturer":"LGE","market_name":"LG G Pad 8.0 LTE","codename":"e8lte","model":"LG-P490L"},{"manufacturer":"LGE","market_name":"LG G Pad 8.3","codename":"awifi","model":"LG-V500"},{"manufacturer":"LGE","market_name":"LG G Pad 8.3 Google Play Edition","codename":"palman","model":"LG-V510"},{"manufacturer":"LGE","market_name":"LG G Pad 8.3 LTE","codename":"altev","model":"VK810 4G"},{"manufacturer":"LGE","market_name":"LG G Pad 8.3 homeBoy","codename":"awifi070u","model":"LG-V507L"},{"manufacturer":"LGE","market_name":"LG G Pad F 8.0","codename":"t8lte","model":"LG-AK495"},{"manufacturer":"LGE","market_name":"LG G Pad F 8.0","codename":"t8lte","model":"LG-UK495"},{"manufacturer":"LGE","market_name":"LG G Pad F 8.0","codename":"t8lte","model":"LG-V495"},{"manufacturer":"LGE","market_name":"LG G Pad F 8.0","codename":"t8lte","model":"LG-V496"},{"manufacturer":"LGE","market_name":"LG G Pad F 8.0","codename":"t8lte","model":"LG-V499"},{"manufacturer":"LGE","market_name":"LG G Pad F2 8.0","codename":"mth8","model":"LG-LK460"},{"manufacturer":"LGE","market_name":"LG G Pad F7.0","codename":"e7iilte","model":"LGLK430"},{"manufacturer":"LGE","market_name":"LG G Pad F\\xe2\\x84\\xa2 8.0 2nd Gen","codename":"t8lte","model":"LG-AK495"},{"manufacturer":"LGE","market_name":"LG G Pad F\\xe2\\x84\\xa2 8.0 2nd Gen","codename":"t8lte","model":"LG-UK495"},{"manufacturer":"LGE","market_name":"LG G Pad II 10.1 FHD","codename":"t1wifi","model":"LG-V940"},{"manufacturer":"LGE","market_name":"LG G Pad II 10.1 FHD","codename":"t1wifin","model":"LG-V940n"},{"manufacturer":"LGE","market_name":"LG G Pad II 8.0LTE","codename":"t8lte","model":"LG-V497"},{"manufacturer":"LGE","market_name":"LG G Pad II 8.3","codename":"altev2","model":"LG-P815L"},{"manufacturer":"LGE","market_name":"LG G Pad III 10.1 FHD LTE","codename":"b5","model":"LG-P755L"},{"manufacturer":"LGE","market_name":"LG G Pad III 10.1 FHD LTE","codename":"b5","model":"LG-V755"},{"manufacturer":"LGE","market_name":"LG G Pad III 8.0","codename":"b3","model":"LG-V522"},{"manufacturer":"LGE","market_name":"LG G Pad III 8.0 FHD","codename":"b3","model":"LG-V525"},{"manufacturer":"LGE","market_name":"LG G Pad III 8.0 FHD","codename":"b3","model":"LG-V525S1"},{"manufacturer":"LGE","market_name":"LG G Pad III 8.0 FHD","codename":"b3","model":"LG-V525S3"},{"manufacturer":"LGE","market_name":"LG G Pad IV 8.0","codename":"tf840","model":"LG-V533"},{"manufacturer":"LGE","market_name":"LG G Pad IV 8.0 FHD LTE","codename":"tf840","model":"LG-P530L"},{"manufacturer":"LGE","market_name":"LG G Pad X 8.0","codename":"b3","model":"LG-V521"},{"manufacturer":"LGE","market_name":"LG G Pad X 8.3","codename":"altev2","model":"VK815"},{"manufacturer":"LGE","market_name":"LG G Pad X2 8.0 PLUS","codename":"tf840","model":"LG-V530"},{"manufacturer":"LGE","market_name":"LG G Pad X\\xc2\\xae II 10.1","codename":"b5","model":"LGUK750"},{"manufacturer":"LGE","market_name":"LG G Pad\\xe2\\x84\\xa2 X 8.0","codename":"b3","model":"LG-V520"},{"manufacturer":"LGE","market_name":"LG G Stylo","codename":"g4stylus","model":"LG-H634"},{"manufacturer":"LGE","market_name":"LG G Stylo","codename":"g4stylusc","model":"LGLS770"},{"manufacturer":"LGE","market_name":"LG G Stylo","codename":"g4stylusds","model":"LG-H630D"},{"manufacturer":"LGE","market_name":"LG G Stylo","codename":"g4stylusdsn","model":"LG-H630"},{"manufacturer":"LGE","market_name":"LG G Stylo","codename":"g4stylusn","model":"LG-H631"},{"manufacturer":"LGE","market_name":"LG G Stylo","codename":"g4stylusn","model":"LG-H631MX"},{"manufacturer":"LGE","market_name":"LG G Stylo","codename":"g4stylusn","model":"LG-H635"},{"manufacturer":"LGE","market_name":"LG G Stylo","codename":"g4stylusn","model":"LG-H635A"},{"manufacturer":"LGE","market_name":"LG G Stylo","codename":"g4stylusn","model":"LG-H636"},{"manufacturer":"LGE","market_name":"LG G Stylo","codename":"g4stylusn","model":"LGMS631"},{"manufacturer":"LGE","market_name":"LG G Vista","codename":"b2l","model":"LG-D631"},{"manufacturer":"LGE","market_name":"LG G Vista 2","codename":"p1v","model":"LG-H740"},{"manufacturer":"LGE","market_name":"LG G2","codename":"g2","model":"LG-D800"},{"manufacturer":"LGE","market_name":"LG G2","codename":"g2","model":"LG-D801"},{"manufacturer":"LGE","market_name":"LG G2","codename":"g2","model":"LG-D802"},{"manufacturer":"LGE","market_name":"LG G2","codename":"g2","model":"LG-D802T"},{"manufacturer":"LGE","market_name":"LG G2","codename":"g2","model":"LG-D802TR"},{"manufacturer":"LGE","market_name":"LG G2","codename":"g2","model":"LG-D803"},{"manufacturer":"LGE","market_name":"LG G2","codename":"g2","model":"LG-D805"},{"manufacturer":"LGE","market_name":"LG G2","codename":"g2","model":"LG-D806"},{"manufacturer":"LGE","market_name":"LG G2","codename":"g2","model":"LG-F320K"},{"manufacturer":"LGE","market_name":"LG G2","codename":"g2","model":"LG-F320L"},{"manufacturer":"LGE","market_name":"LG G2","codename":"g2","model":"LG-F320S"},{"manufacturer":"LGE","market_name":"LG G2","codename":"g2","model":"LG-LS980"},{"manufacturer":"LGE","market_name":"LG G2","codename":"g2","model":"VS980 4G"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"AS985"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LG-AS990"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LG-D850"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LG-D851"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LG-D852"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LG-D852G"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LG-D855"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LG-D856"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LG-D857"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LG-D858"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LG-D858HK"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LG-D859"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LG-F400K"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LG-F400L"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LG-F400S"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LGL24"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LGLS990"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LGUS990"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"LGV31"},{"manufacturer":"LGE","market_name":"LG G3","codename":"g3","model":"VS985 4G"},{"manufacturer":"LGE","market_name":"LG G3 A","codename":"tigers","model":"LG-F410S"},{"manufacturer":"LGE","market_name":"LG G3 Cat.6","codename":"tiger6","model":"LG-F460K"},{"manufacturer":"LGE","market_name":"LG G3 Cat.6","codename":"tiger6","model":"LG-F460L"},{"manufacturer":"LGE","market_name":"LG G3 Cat.6","codename":"tiger6","model":"LG-F460S"},{"manufacturer":"LGE","market_name":"LG G4","codename":"p1","model":"AS986"},{"manufacturer":"LGE","market_name":"LG G4","codename":"p1","model":"LG-AS811"},{"manufacturer":"LGE","market_name":"LG G4","codename":"p1","model":"LG-AS991"},{"manufacturer":"LGE","market_name":"LG G4","codename":"p1","model":"LG-F500K"},{"manufacturer":"LGE","market_name":"LG G4","codename":"p1","model":"LG-F500L"},{"manufacturer":"LGE","market_name":"LG G4","codename":"p1","model":"LG-F500S"},{"manufacturer":"LGE","market_name":"LG G4","codename":"p1","model":"LG-H810"},{"manufacturer":"LGE","market_name":"LG G4","codename":"p1","model":"LG-H811"},{"manufacturer":"LGE","market_name":"LG G4","codename":"p1","model":"LG-H812"},{"manufacturer":"LGE","market_name":"LG G4","codename":"p1","model":"LG-H815"},{"manufacturer":"LGE","market_name":"LG G4","codename":"p1","model":"LG-H818"},{"manufacturer":"LGE","market_name":"LG G4","codename":"p1","model":"LG-H819"},{"manufacturer":"LGE","market_name":"LG G4","codename":"p1","model":"LGLS991"},{"manufacturer":"LGE","market_name":"LG G4","codename":"p1","model":"LGUS991"},{"manufacturer":"LGE","market_name":"LG G4","codename":"p1","model":"LGV32"},{"manufacturer":"LGE","market_name":"LG G4","codename":"p1","model":"VS986"},{"manufacturer":"LGE","market_name":"LG G4 Beat","codename":"p1bdsn","model":"LG-H736"},{"manufacturer":"LGE","market_name":"LG G4 Beat","codename":"p1bssn","model":"LG-H735"},{"manufacturer":"LGE","market_name":"LG G4 Stylus","codename":"mp1s3gds","model":"LG-H540"},{"manufacturer":"LGE","market_name":"LG G4 Stylus","codename":"mp1s3gss","model":"LG-H542"},{"manufacturer":"LGE","market_name":"LG G4 vigor","codename":"p1bssn","model":"LG-H731"},{"manufacturer":"LGE","market_name":"LG G4c","codename":"c90","model":"LG-H525"},{"manufacturer":"LGE","market_name":"LG G4c","codename":"c90n","model":"LG-H525n"},{"manufacturer":"LGE","market_name":"LG G4s","codename":"p1bds3g","model":"LG-H734"},{"manufacturer":"LGE","market_name":"LG G5","codename":"h1","model":"LG-F700K"},{"manufacturer":"LGE","market_name":"LG G5","codename":"h1","model":"LG-F700L"},{"manufacturer":"LGE","market_name":"LG G5","codename":"h1","model":"LG-F700S"},{"manufacturer":"LGE","market_name":"LG G5","codename":"h1","model":"LG-H820"},{"manufacturer":"LGE","market_name":"LG G5","codename":"h1","model":"LG-H820PR"},{"manufacturer":"LGE","market_name":"LG G5","codename":"h1","model":"LG-H830"},{"manufacturer":"LGE","market_name":"LG G5","codename":"h1","model":"LG-H831"},{"manufacturer":"LGE","market_name":"LG G5","codename":"h1","model":"LG-H850"},{"manufacturer":"LGE","market_name":"LG G5","codename":"h1","model":"LG-H858"},{"manufacturer":"LGE","market_name":"LG G5","codename":"h1","model":"LG-H860"},{"manufacturer":"LGE","market_name":"LG G5","codename":"h1","model":"LG-H868"},{"manufacturer":"LGE","market_name":"LG G5","codename":"h1","model":"LGAS992"},{"manufacturer":"LGE","market_name":"LG G5","codename":"h1","model":"LGLS992"},{"manufacturer":"LGE","market_name":"LG G5","codename":"h1","model":"LGUS992"},{"manufacturer":"LGE","market_name":"LG G5","codename":"h1","model":"RS988"},{"manufacturer":"LGE","market_name":"LG G5","codename":"h1","model":"VS987"},{"manufacturer":"LGE","market_name":"LG G5 SE","codename":"alicee","model":"LG-H840"},{"manufacturer":"LGE","market_name":"LG G5 SE","codename":"alicee","model":"LG-H845"},{"manufacturer":"LGE","market_name":"LG G5 SE","codename":"alicee","model":"LG-H848"},{"manufacturer":"LGE","market_name":"LG G6","codename":"lucye","model":"LG-AS993"},{"manufacturer":"LGE","market_name":"LG G6","codename":"lucye","model":"LG-H870"},{"manufacturer":"LGE","market_name":"LG G6","codename":"lucye","model":"LG-H870AR"},{"manufacturer":"LGE","market_name":"LG G6","codename":"lucye","model":"LG-H870DS"},{"manufacturer":"LGE","market_name":"LG G6","codename":"lucye","model":"LG-H870I"},{"manufacturer":"LGE","market_name":"LG G6","codename":"lucye","model":"LG-H870S"},{"manufacturer":"LGE","market_name":"LG G6","codename":"lucye","model":"LG-H871"},{"manufacturer":"LGE","market_name":"LG G6","codename":"lucye","model":"LG-H872"},{"manufacturer":"LGE","market_name":"LG G6","codename":"lucye","model":"LG-H872PR"},{"manufacturer":"LGE","market_name":"LG G6","codename":"lucye","model":"LG-H873"},{"manufacturer":"LGE","market_name":"LG G6","codename":"lucye","model":"LG-LS993"},{"manufacturer":"LGE","market_name":"LG G6","codename":"lucye","model":"LGM-G600K"},{"manufacturer":"LGE","market_name":"LG G6","codename":"lucye","model":"LGM-G600L"},{"manufacturer":"LGE","market_name":"LG G6","codename":"lucye","model":"LGM-G600S"},{"manufacturer":"LGE","market_name":"LG G6","codename":"lucye","model":"LGUS997"},{"manufacturer":"LGE","market_name":"LG G6","codename":"lucye","model":"VS988"},{"manufacturer":"LGE","market_name":"LG G7 ThinQ","codename":"judyln","model":"LG-G710"},{"manufacturer":"LGE","market_name":"LG G7 ThinQ","codename":"judyln","model":"LM-G710"},{"manufacturer":"LGE","market_name":"LG G7 ThinQ","codename":"judyln","model":"LM-G710N"},{"manufacturer":"LGE","market_name":"LG G7 ThinQ","codename":"judyln","model":"LM-G710VM"},{"manufacturer":"LGE","market_name":"LG GRACE\\xe2\\x84\\xa2 LTE","codename":"lv517","model":"LGL59BL"},{"manufacturer":"LGE","market_name":"LG Gentle","codename":"cfm","model":"LG-F660L"},{"manufacturer":"LGE","market_name":"LG Gpad X 10.1","codename":"t1lte","model":"LG-V930"},{"manufacturer":"LGE","market_name":"LG Gx","codename":"omega","model":"LG-F310L"},{"manufacturer":"LGE","market_name":"LG Gx","codename":"omegar","model":"LG-F310LR"},{"manufacturer":"LGE","market_name":"LG Harmony","codename":"lv517","model":"LG-M257"},{"manufacturer":"LGE","market_name":"LG Joy","codename":"y30","model":"LG-H220"},{"manufacturer":"LGE","market_name":"LG Joy","codename":"y30dsf","model":"LG-H222"},{"manufacturer":"LGE","market_name":"LG Joy","codename":"y30f","model":"LG-H221"},{"manufacturer":"LGE","market_name":"LG Joy","codename":"y30f","model":"LG-H221AR"},{"manufacturer":"LGE","market_name":"LG K10","codename":"m209n","model":"LG-K425"},{"manufacturer":"LGE","market_name":"LG K10","codename":"m209n","model":"LG-K428"},{"manufacturer":"LGE","market_name":"LG K10","codename":"m209n","model":"LGMS428"},{"manufacturer":"LGE","market_name":"LG K10","codename":"m216","model":"LG-K420"},{"manufacturer":"LGE","market_name":"LG K10","codename":"m216n","model":"LG-F670K"},{"manufacturer":"LGE","market_name":"LG K10","codename":"m216n","model":"LG-F670L"},{"manufacturer":"LGE","market_name":"LG K10","codename":"m216n","model":"LG-F670S"},{"manufacturer":"LGE","market_name":"LG K10","codename":"m216n","model":"LG-K420"},{"manufacturer":"LGE","market_name":"LG K10","codename":"m23g","model":"LG-K410"},{"manufacturer":"LGE","market_name":"LG K10 (2017)","codename":"lv517","model":"LG-M257PR"},{"manufacturer":"LGE","market_name":"LG K10 (2017)","codename":"mlv5","model":"LG-M250"},{"manufacturer":"LGE","market_name":"LG K10 (2017)","codename":"mlv5n","model":"LG-M250"},{"manufacturer":"LGE","market_name":"LG K10 LTE","codename":"m209","model":"LG-K420PR"},{"manufacturer":"LGE","market_name":"LG K10 LTE","codename":"m253","model":"LG-K430"},{"manufacturer":"LGE","market_name":"LG K10 LTE","codename":"m253n","model":"LG-K430"},{"manufacturer":"LGE","market_name":"LG K10 Power","codename":"mlv7","model":"LG-M320"},{"manufacturer":"LGE","market_name":"LG K11","codename":"mcv3","model":"LM-X410(FN)"},{"manufacturer":"LGE","market_name":"LG K11","codename":"mcv3","model":"LM-X410.F"},{"manufacturer":"LGE","market_name":"LG K11","codename":"mcv3","model":"LM-X410.FN"},{"manufacturer":"LGE","market_name":"LG K11+","codename":"mcv3","model":"LM-X410.F"},{"manufacturer":"LGE","market_name":"LG K11+","codename":"mcv3","model":"LM-X410.FN"},{"manufacturer":"LGE","market_name":"LG K20","codename":"lv517n","model":"LG-M255"},{"manufacturer":"LGE","market_name":"LG K20 Plus","codename":"lv517","model":"LG-TP260"},{"manufacturer":"LGE","market_name":"LG K20 Plus","codename":"lv517","model":"LGMP260"},{"manufacturer":"LGE","market_name":"LG K20 V","codename":"lv517","model":"VS501"},{"manufacturer":"LGE","market_name":"LG K3","codename":"lv0","model":"LGL48VL"},{"manufacturer":"LGE","market_name":"LG K3","codename":"me0","model":"LGLS450"},{"manufacturer":"LGE","market_name":"LG K3 LTE","codename":"mme0","model":"LG-K100"},{"manufacturer":"LGE","market_name":"LG K3 LTE","codename":"mme0n","model":"LG-K100"},{"manufacturer":"LGE","market_name":"LG K30","codename":"cv3","model":"LM-X410UM"},{"manufacturer":"LGE","market_name":"LG K4","codename":"e1q","model":"LG-K120GT"},{"manufacturer":"LGE","market_name":"LG K4","codename":"e1q","model":"LG-K121"},{"manufacturer":"LGE","market_name":"LG K4","codename":"e1q","model":"VS425"},{"manufacturer":"LGE","market_name":"LG K4","codename":"lv1","model":"LG-M160"},{"manufacturer":"LGE","market_name":"LG K4 LTE","codename":"me1","model":"LG-K120"},{"manufacturer":"LGE","market_name":"LG K4 LTE","codename":"me1ds","model":"LG-K130"},{"manufacturer":"LGE","market_name":"LG K4/K7 (2017)","codename":"mlv1","model":"LG-X230"},{"manufacturer":"LGE","market_name":"LG K4/K7 (2017)","codename":"mlv1","model":"LG-X230YK"},{"manufacturer":"LGE","market_name":"LG K5","codename":"d3","model":"LG-X220"},{"manufacturer":"LGE","market_name":"LG K7","codename":"m1","model":"LG-AS330"},{"manufacturer":"LGE","market_name":"LG K7","codename":"m1","model":"LG-K330"},{"manufacturer":"LGE","market_name":"LG K7","codename":"m1","model":"LGMS330"},{"manufacturer":"LGE","market_name":"LG K7","codename":"m13g","model":"LG-X210"},{"manufacturer":"LGE","market_name":"LG K8","codename":"lv3","model":"LG-M210"},{"manufacturer":"LGE","market_name":"LG K8","codename":"m1v","model":"LGAS375"},{"manufacturer":"LGE","market_name":"LG K8","codename":"m1v","model":"LGUS375"},{"manufacturer":"LGE","market_name":"LG K8","codename":"m1v","model":"RS500"},{"manufacturer":"LGE","market_name":"LG K8","codename":"mm1v","model":"LG-K350"},{"manufacturer":"LGE","market_name":"LG K8 (2017)","codename":"lv3","model":"LGUS215"},{"manufacturer":"LGE","market_name":"LG K8 (2017)","codename":"lv3n","model":"LG-M200"},{"manufacturer":"LGE","market_name":"LG K8 (2017)","codename":"mlv3","model":"LG-X240"},{"manufacturer":"LGE","market_name":"LG K8 (2017) Dual","codename":"lv3","model":"LG-M200"},{"manufacturer":"LGE","market_name":"LG K8 LTE","codename":"mm1vn","model":"LG-K350"},{"manufacturer":"LGE","market_name":"LG K8 V","codename":"m1v","model":"VS500"},{"manufacturer":"LGE","market_name":"LG K8 V","codename":"m1v","model":"VS500PP"},{"manufacturer":"LGE","market_name":"LG K8(2018)","codename":"cv1","model":"LM-X21(G)"},{"manufacturer":"LGE","market_name":"LG K8(2018)","codename":"cv1","model":"LM-X210"},{"manufacturer":"LGE","market_name":"LG K8(2018)","codename":"cv1","model":"LM-X210(G)"},{"manufacturer":"LGE","market_name":"LG K8(2018)","codename":"cv1","model":"LM-X212(G)"},{"manufacturer":"LGE","market_name":"LG K8(2018)","codename":"cv1","model":"LML211BL"},{"manufacturer":"LGE","market_name":"LG K8(2018)","codename":"cv1","model":"LML212VL"},{"manufacturer":"LGE","market_name":"LG K8+(2018)","codename":"mcv150","model":"LM-X210"},{"manufacturer":"LGE","market_name":"LG K9","codename":"cv109","model":"LM-X210"},{"manufacturer":"LGE","market_name":"LG L39C","codename":"l4ii_cdma","model":"LGL39C"},{"manufacturer":"LGE","market_name":"LG LEON\\xe2\\x84\\xa2 LTE","codename":"c50","model":"LG-H345"},{"manufacturer":"LGE","market_name":"LG Lancet","codename":"c50","model":"VS820"},{"manufacturer":"LGE","market_name":"LG Leon","codename":"my50","model":"LG-H320"},{"manufacturer":"LGE","market_name":"LG Leon","codename":"my50ds","model":"LG-H324"},{"manufacturer":"LGE","market_name":"LG Leon","codename":"my50ds","model":"LG-H326"},{"manufacturer":"LGE","market_name":"LG Leon 4G LTE","codename":"c50","model":"LG-H340"},{"manufacturer":"LGE","market_name":"LG Leon 4G LTE","codename":"c50","model":"LG-H340AR"},{"manufacturer":"LGE","market_name":"LG Leon 4G LTE","codename":"c50","model":"LG-H340GT"},{"manufacturer":"LGE","market_name":"LG Leon 4G LTE","codename":"c50","model":"LG-H343"},{"manufacturer":"LGE","market_name":"LG Leon 4G LTE","codename":"c50","model":"LGMS345"},{"manufacturer":"LGE","market_name":"LG Leon 4G LTE","codename":"c50ds","model":"LG-H342"},{"manufacturer":"LGE","market_name":"LG Leon 4G LTE","codename":"c50n","model":"LG-H340n"},{"manufacturer":"LGE","market_name":"LG Leon TV","codename":"my50ds","model":"LG-H326"},{"manufacturer":"LGE","market_name":"LG Logos","codename":"c70","model":"LGUS550"},{"manufacturer":"LGE","market_name":"LG Lucid","codename":"cayman","model":"VS840 4G"},{"manufacturer":"LGE","market_name":"LG Lucid","codename":"cayman","model":"VS840PP"},{"manufacturer":"LGE","market_name":"LG Lucid 2","codename":"l1v","model":"VS870 4G"},{"manufacturer":"LGE","market_name":"LG Lucid 3","codename":"x5","model":"VS876"},{"manufacturer":"LGE","market_name":"LG M1","codename":"m1ds","model":"LG-K332"},{"manufacturer":"LGE","market_name":"LG Mach\\xe2\\x84\\xa2","codename":"l2s","model":"LG-LS860"},{"manufacturer":"LGE","market_name":"LG Magna","codename":"my90","model":"LG-H500"},{"manufacturer":"LGE","market_name":"LG Magna","codename":"my90","model":"LG-T540"},{"manufacturer":"LGE","market_name":"LG Magna","codename":"my90ds","model":"LG-H502"},{"manufacturer":"LGE","market_name":"LG Magna LTE","codename":"mc90","model":"LG-H520"},{"manufacturer":"LGE","market_name":"LG Max","codename":"v10","model":"LG-X155"},{"manufacturer":"LGE","market_name":"LG Max","codename":"v10","model":"LG-X160"},{"manufacturer":"LGE","market_name":"LG Max","codename":"v10","model":"LG-X165g"},{"manufacturer":"LGE","market_name":"LG Motion 4G","codename":"l0","model":"LG-MS770"},{"manufacturer":"LGE","market_name":"LG OPTIMUS M+","codename":"m3_mpcs_us","model":"LG-MS695"},{"manufacturer":"LGE","market_name":"LG OPTIMUS ZIP","codename":"lgl75c","model":"LGL75C"},{"manufacturer":"LGE","market_name":"LG Optimus 3D","codename":"cosmopolitan","model":"LG-P920"},{"manufacturer":"LGE","market_name":"LG Optimus 3D","codename":"cosmopolitan","model":"LG-P925g"},{"manufacturer":"LGE","market_name":"LG Optimus 3D","codename":"cosmopolitan","model":"LG-SU760"},{"manufacturer":"LGE","market_name":"LG Optimus ELITE\\xe2\\x84\\xa2","codename":"m3s","model":"LG-VM696"},{"manufacturer":"LGE","market_name":"LG Optimus Elite","codename":"m3s","model":"LG Optimus Elite"},{"manufacturer":"LGE","market_name":"LG Optimus Elite","codename":"m3s","model":"LG-LS696"},{"manufacturer":"LGE","market_name":"LG Optimus F3Q","codename":"fx3q","model":"LG-D520"},{"manufacturer":"LGE","market_name":"LG Optimus F7","codename":"fx1","model":"LG-AS780"},{"manufacturer":"LGE","market_name":"LG Optimus F7","codename":"fx1","model":"LG-LG870"},{"manufacturer":"LGE","market_name":"LG Optimus F7","codename":"fx1","model":"LG-US780"},{"manufacturer":"LGE","market_name":"LG Optimus G","codename":"geeb","model":"LG-E970"},{"manufacturer":"LGE","market_name":"LG Optimus G","codename":"geeb","model":"LG-E971"},{"manufacturer":"LGE","market_name":"LG Optimus G","codename":"geeb","model":"LG-E973"},{"manufacturer":"LGE","market_name":"LG Optimus G","codename":"geehdc","model":"L-01E"},{"manufacturer":"LGE","market_name":"LG Optimus G","codename":"geehdc","model":"LGL21"},{"manufacturer":"LGE","market_name":"LG Optimus G","codename":"geehrc","model":"LG-E975"},{"manufacturer":"LGE","market_name":"LG Optimus G","codename":"geehrc","model":"LG-E975K"},{"manufacturer":"LGE","market_name":"LG Optimus G","codename":"geehrc","model":"LG-E975T"},{"manufacturer":"LGE","market_name":"LG Optimus G","codename":"geehrc","model":"LG-E976"},{"manufacturer":"LGE","market_name":"LG Optimus G","codename":"geehrc","model":"LG-E977"},{"manufacturer":"LGE","market_name":"LG Optimus G","codename":"geehrc","model":"LG-E987"},{"manufacturer":"LGE","market_name":"LG Optimus G","codename":"geehrc","model":"LG-F180K"},{"manufacturer":"LGE","market_name":"LG Optimus G","codename":"geehrc","model":"LG-F180S"},{"manufacturer":"LGE","market_name":"LG Optimus G","codename":"geehrc4g","model":"LG-F180L"},{"manufacturer":"LGE","market_name":"LG Optimus G","codename":"geehrc4g","model":"LG-LS970"},{"manufacturer":"LGE","market_name":"LG Optimus G Pro","codename":"geefhd","model":"LG-E980"},{"manufacturer":"LGE","market_name":"LG Optimus G Pro","codename":"geefhd","model":"LG-E980h"},{"manufacturer":"LGE","market_name":"LG Optimus G Pro","codename":"geefhd","model":"LG-E981h"},{"manufacturer":"LGE","market_name":"LG Optimus G Pro","codename":"geefhd","model":"LG-E986"},{"manufacturer":"LGE","market_name":"LG Optimus G Pro","codename":"geefhd","model":"LG-E988"},{"manufacturer":"LGE","market_name":"LG Optimus G Pro","codename":"geefhd","model":"LG-E989"},{"manufacturer":"LGE","market_name":"LG Optimus G Pro","codename":"geefhd","model":"LG-F240K"},{"manufacturer":"LGE","market_name":"LG Optimus G Pro","codename":"geefhd","model":"LG-F240S"},{"manufacturer":"LGE","market_name":"LG Optimus G Pro","codename":"geefhd4g","model":"LG-F240L"},{"manufacturer":"LGE","market_name":"LG Optimus HUB","codename":"univa_222-01","model":"LG-E510"},{"manufacturer":"LGE","market_name":"LG Optimus HUB","codename":"univa_arb-xx","model":"LG-E510"},{"manufacturer":"LGE","market_name":"LG Optimus HUB","codename":"univa_cis-xxx","model":"LG-E510"},{"manufacturer":"LGE","market_name":"LG Optimus HUB","codename":"univa_esa-xx","model":"LG-E510"},{"manufacturer":"LGE","market_name":"LG Optimus HUB","codename":"univa_eur-xx","model":"LG-E510"},{"manufacturer":"LGE","market_name":"LG Optimus HUB","codename":"univa_open-eu","model":"LG-E510"},{"manufacturer":"LGE","market_name":"LG Optimus HUB","codename":"univa_tur-xx","model":"LG-E510"},{"manufacturer":"LGE","market_name":"LG Optimus L1II","codename":"v1","model":"LG-E410"},{"manufacturer":"LGE","market_name":"LG Optimus L1II","codename":"v1","model":"LG-E410B"},{"manufacturer":"LGE","market_name":"LG Optimus L1II","codename":"v1","model":"LG-E410c"},{"manufacturer":"LGE","market_name":"LG Optimus L1II","codename":"v1","model":"LG-E410f"},{"manufacturer":"LGE","market_name":"LG Optimus L1II","codename":"v1","model":"LG-E410g"},{"manufacturer":"LGE","market_name":"LG Optimus L1II","codename":"v1","model":"LG-E410i"},{"manufacturer":"LGE","market_name":"LG Optimus L1II","codename":"v1","model":"LG-E411f"},{"manufacturer":"LGE","market_name":"LG Optimus L1II","codename":"v1","model":"LG-E411g"},{"manufacturer":"LGE","market_name":"LG Optimus L1II","codename":"v1ds","model":"LG-E415f"},{"manufacturer":"LGE","market_name":"LG Optimus L1II","codename":"v1ds","model":"LG-E415g"},{"manufacturer":"LGE","market_name":"LG Optimus L1II","codename":"v1ds","model":"LG-E420"},{"manufacturer":"LGE","market_name":"LG Optimus L1II","codename":"v1ds","model":"LG-E420f"},{"manufacturer":"LGE","market_name":"LG Optimus L1II","codename":"v1ts","model":"LG-E475f"},{"manufacturer":"LGE","market_name":"LG Optimus L3","codename":"e0","model":"LG-E400"},{"manufacturer":"LGE","market_name":"LG Optimus L3","codename":"e0","model":"LG-E400R"},{"manufacturer":"LGE","market_name":"LG Optimus L3","codename":"e0","model":"LG-E400b"},{"manufacturer":"LGE","market_name":"LG Optimus L3","codename":"e0","model":"LG-E400f"},{"manufacturer":"LGE","market_name":"LG Optimus L3","codename":"e0","model":"LG-E400g"},{"manufacturer":"LGE","market_name":"LG Optimus L3","codename":"e0","model":"LG-L38C"},{"manufacturer":"LGE","market_name":"LG Optimus L3","codename":"e0","model":"LGL35G"},{"manufacturer":"LGE","market_name":"LG Optimus L3","codename":"e0_open_eur","model":"LG-E400"},{"manufacturer":"LGE","market_name":"LG Optimus L3 Dual","codename":"e1","model":"LG-E405"},{"manufacturer":"LGE","market_name":"LG Optimus L3 Dual","codename":"e1","model":"LG-E405f"},{"manufacturer":"LGE","market_name":"LG Optimus L3 II","codename":"vee3ds","model":"LG-E435"},{"manufacturer":"LGE","market_name":"LG Optimus L3 II","codename":"vee3ds","model":"LG-E435f"},{"manufacturer":"LGE","market_name":"LG Optimus L3 II","codename":"vee3ds","model":"LG-E435g"},{"manufacturer":"LGE","market_name":"LG Optimus L3 II","codename":"vee3ds","model":"LG-E435k"},{"manufacturer":"LGE","market_name":"LG Optimus L3 II","codename":"vee3e","model":"LG-E425"},{"manufacturer":"LGE","market_name":"LG Optimus L3 II","codename":"vee3e","model":"LG-E425c"},{"manufacturer":"LGE","market_name":"LG Optimus L3 II","codename":"vee3e","model":"LG-E425f"},{"manufacturer":"LGE","market_name":"LG Optimus L3 II","codename":"vee3e","model":"LG-E425g"},{"manufacturer":"LGE","market_name":"LG Optimus L3 II","codename":"vee3e","model":"LG-E425j"},{"manufacturer":"LGE","market_name":"LG Optimus L3 II","codename":"vee3e","model":"LG-E430"},{"manufacturer":"LGE","market_name":"LG Optimus L3 II","codename":"vee3e","model":"LG-E431g"},{"manufacturer":"LGE","market_name":"LG Optimus L4 II","codename":"vee4ss","model":"LG-E440"},{"manufacturer":"LGE","market_name":"LG Optimus L4 II","codename":"vee4ss","model":"LG-E440f"},{"manufacturer":"LGE","market_name":"LG Optimus L4 II","codename":"vee4ss","model":"LG-E440g"},{"manufacturer":"LGE","market_name":"LG Optimus L4 II","codename":"vee4ss","model":"LG-E465f"},{"manufacturer":"LGE","market_name":"LG Optimus L4 II","codename":"vee4ss","model":"LG-E465g"},{"manufacturer":"LGE","market_name":"LG Optimus L4 II Dual","codename":"vee4ds","model":"LG-E445"},{"manufacturer":"LGE","market_name":"LG Optimus L4 II Dual","codename":"vee4ds","model":"LG-E467f"},{"manufacturer":"LGE","market_name":"LG Optimus L4 II Tri","codename":"vee4ts","model":"LG-E470f"},{"manufacturer":"LGE","market_name":"LG Optimus L5 Dual","codename":"m4ds","model":"LG-E615"},{"manufacturer":"LGE","market_name":"LG Optimus L5 Dual","codename":"m4ds","model":"LG-E615f"},{"manufacturer":"LGE","market_name":"LG Optimus L5 II","codename":"vee5ds","model":"LG-E455"},{"manufacturer":"LGE","market_name":"LG Optimus L5 II","codename":"vee5ds","model":"LG-E455f"},{"manufacturer":"LGE","market_name":"LG Optimus L5 II","codename":"vee5ds","model":"LG-E455g"},{"manufacturer":"LGE","market_name":"LG Optimus L5 II","codename":"vee5nfc","model":"LG-E460"},{"manufacturer":"LGE","market_name":"LG Optimus L5 II","codename":"vee5nfc","model":"LG-E460f"},{"manufacturer":"LGE","market_name":"LG Optimus L5 II","codename":"vee5ss","model":"LG-E450"},{"manufacturer":"LGE","market_name":"LG Optimus L5 II","codename":"vee5ss","model":"LG-E450B"},{"manufacturer":"LGE","market_name":"LG Optimus L5 II","codename":"vee5ss","model":"LG-E450f"},{"manufacturer":"LGE","market_name":"LG Optimus L5 II","codename":"vee5ss","model":"LG-E450g"},{"manufacturer":"LGE","market_name":"LG Optimus L5 II","codename":"vee5ss","model":"LG-E450j"},{"manufacturer":"LGE","market_name":"LG Optimus L5 II","codename":"vee5ss","model":"LG-E451g"},{"manufacturer":"LGE","market_name":"LG Optimus L5 II","codename":"vee5ss","model":"LG-E460"},{"manufacturer":"LGE","market_name":"LG Optimus L7","codename":"u0","model":"LG-P700"},{"manufacturer":"LGE","market_name":"LG Optimus L7","codename":"u0","model":"LG-P705"},{"manufacturer":"LGE","market_name":"LG Optimus L7","codename":"u0","model":"LG-P705f"},{"manufacturer":"LGE","market_name":"LG Optimus L7","codename":"u0","model":"LG-P705g"},{"manufacturer":"LGE","market_name":"LG Optimus L7","codename":"u0","model":"LG-P708g"},{"manufacturer":"LGE","market_name":"LG Optimus L7","codename":"u0","model":"LG-T280"},{"manufacturer":"LGE","market_name":"LG Optimus L7","codename":"u0","model":"LGL96G"},{"manufacturer":"LGE","market_name":"LG Optimus L7","codename":"vee7ds","model":"LG-P715"},{"manufacturer":"LGE","market_name":"LG Optimus L7 II","codename":"vee7e","model":"LG-P710"},{"manufacturer":"LGE","market_name":"LG Optimus L7 II","codename":"vee7e","model":"LG-P712"},{"manufacturer":"LGE","market_name":"LG Optimus L7 II","codename":"vee7e","model":"LG-P713"},{"manufacturer":"LGE","market_name":"LG Optimus L7 II","codename":"vee7e","model":"LG-P713GO"},{"manufacturer":"LGE","market_name":"LG Optimus L7 II","codename":"vee7e","model":"LG-P713TR"},{"manufacturer":"LGE","market_name":"LG Optimus L7 II","codename":"vee7e","model":"LG-P714"},{"manufacturer":"LGE","market_name":"LG Optimus L7II","codename":"vee7ds","model":"LG-P715"},{"manufacturer":"LGE","market_name":"LG Optimus L7II","codename":"vee7ds","model":"LG-P716"},{"manufacturer":"LGE","market_name":"LG Optimus L9","codename":"u2","model":"LG-D700"},{"manufacturer":"LGE","market_name":"LG Optimus L9","codename":"u2","model":"LG-P760"},{"manufacturer":"LGE","market_name":"LG Optimus L9","codename":"u2","model":"LG-P765"},{"manufacturer":"LGE","market_name":"LG Optimus L9","codename":"u2","model":"LG-P768"},{"manufacturer":"LGE","market_name":"LG Optimus L9","codename":"u2","model":"LG-P769"},{"manufacturer":"LGE","market_name":"LG Optimus L9","codename":"u2","model":"LG-P778"},{"manufacturer":"LGE","market_name":"LG Optimus L9","codename":"u2","model":"LGMS769"},{"manufacturer":"LGE","market_name":"LG Optimus L9 (NFC)","codename":"u2","model":"LG-P760"},{"manufacturer":"LGE","market_name":"LG Optimus L9 II","codename":"l9ii","model":"LG-D605"},{"manufacturer":"LGE","market_name":"LG Optimus LTE Tag","codename":"cayman","model":"LG-AS840"},{"manufacturer":"LGE","market_name":"LG Optimus LTE Tag","codename":"cayman","model":"LG-F120K"},{"manufacturer":"LGE","market_name":"LG Optimus LTE Tag","codename":"cayman","model":"LG-F120L"},{"manufacturer":"LGE","market_name":"LG Optimus LTE Tag","codename":"cayman","model":"LG-F120S"},{"manufacturer":"LGE","market_name":"LG Optimus LTE Tag","codename":"lge_120_kt","model":"LG-F120K"},{"manufacturer":"LGE","market_name":"LG Optimus LTE Tag","codename":"lge_120_skt","model":"LG-F120S"},{"manufacturer":"LGE","market_name":"LG Optimus LTE2","codename":"d1lkt","model":"LG-F160K"},{"manufacturer":"LGE","market_name":"LG Optimus LTE2","codename":"d1lsk","model":"LG-F160S"},{"manufacturer":"LGE","market_name":"LG Optimus LTE2","codename":"d1lu","model":"LG-F160L"},{"manufacturer":"LGE","market_name":"LG Optimus LTE2","codename":"d1lu","model":"LG-F160LV"},{"manufacturer":"LGE","market_name":"LG Optimus LTE3","codename":"fx1sk","model":"LG-F260S"},{"manufacturer":"LGE","market_name":"LG Optimus One","codename":"thunderg","model":"LG-P500"},{"manufacturer":"LGE","market_name":"LG Optimus One","codename":"thunderg","model":"LG-P500h"},{"manufacturer":"LGE","market_name":"LG Optimus One","codename":"thunderg","model":"LG-P503"},{"manufacturer":"LGE","market_name":"LG Optimus One","codename":"thunderg","model":"LG-P504"},{"manufacturer":"LGE","market_name":"LG Optimus One","codename":"thunderg","model":"LG-P505"},{"manufacturer":"LGE","market_name":"LG Optimus One","codename":"thunderg","model":"LG-P505CH"},{"manufacturer":"LGE","market_name":"LG Optimus One","codename":"thunderg","model":"LG-P505R"},{"manufacturer":"LGE","market_name":"LG Optimus One","codename":"thunderg","model":"LG-P506"},{"manufacturer":"LGE","market_name":"LG Optimus One","codename":"thunderg","model":"LG-P509"},{"manufacturer":"LGE","market_name":"LG Optimus Regard","codename":"l0","model":"LG-LW770"},{"manufacturer":"LGE","market_name":"LG Optimus Select","codename":"u0_cdma","model":"LG-AS730"},{"manufacturer":"LGE","market_name":"LG Optimus Zone 2","codename":"w3c","model":"VS415PP"},{"manufacturer":"LGE","market_name":"LG Pecan","codename":"pecan","model":"LG-P350"},{"manufacturer":"LGE","market_name":"LG Pecan","codename":"pecan","model":"LG-P350f"},{"manufacturer":"LGE","market_name":"LG Pecan","codename":"pecan","model":"LG-P350g"},{"manufacturer":"LGE","market_name":"LG Phoenix 2","codename":"m1v","model":"LG-K371"},{"manufacturer":"LGE","market_name":"LG Phoenix 4","codename":"cv1","model":"LM-X210APM"},{"manufacturer":"LGE","market_name":"LG Power","codename":"y50c","model":"LGL22C"},{"manufacturer":"LGE","market_name":"LG Prime II","codename":"v10","model":"LG-X170fTV"},{"manufacturer":"LGE","market_name":"LG Prime II","codename":"v10","model":"LG-X170g"},{"manufacturer":"LGE","market_name":"LG Prime Plus 4G","codename":"mc90ds","model":"LG-H522"},{"manufacturer":"LGE","market_name":"LG Q6","codename":"mh","model":"LG-M700"},{"manufacturer":"LGE","market_name":"LG Q6","codename":"mhn","model":"LG-M700"},{"manufacturer":"LGE","market_name":"LG Q6","codename":"mhn","model":"LG-M703"},{"manufacturer":"LGE","market_name":"LG Q6","codename":"mhn","model":"LG-US700"},{"manufacturer":"LGE","market_name":"LG Q6","codename":"mhn","model":"LGM-X600K"},{"manufacturer":"LGE","market_name":"LG Q6","codename":"mhn","model":"LGM-X600L"},{"manufacturer":"LGE","market_name":"LG Q6","codename":"mhn","model":"LGM-X600S"},{"manufacturer":"LGE","market_name":"LG Q7","codename":"mcv5a","model":"LM-Q610.FG"},{"manufacturer":"LGE","market_name":"LG Q7","codename":"mcv5a","model":"LM-Q610.FGN"},{"manufacturer":"LGE","market_name":"LG RAY","codename":"d2","model":"LG-X190"},{"manufacturer":"LGE","market_name":"LG Rebel","codename":"e1q","model":"LGL43AL"},{"manufacturer":"LGE","market_name":"LG Rebel","codename":"e1q","model":"LGL44VL"},{"manufacturer":"LGE","market_name":"LG Revolution","codename":"bryce","model":"VS910 4G"},{"manufacturer":"LGE","market_name":"LG SUNSET","codename":"c50","model":"LGL33L"},{"manufacturer":"LGE","market_name":"LG Smart Folder","codename":"cf2","model":"LGM-X100L"},{"manufacturer":"LGE","market_name":"LG Smart Folder","codename":"cf2","model":"LGM-X100S"},{"manufacturer":"LGE","market_name":"LG Spectrum","codename":"VS920","model":"VS920 4G"},{"manufacturer":"LGE","market_name":"LG Spirit","codename":"my70","model":"LG-H420"},{"manufacturer":"LGE","market_name":"LG Spirit 4G LTE","codename":"c70n","model":"LG-H440n"},{"manufacturer":"LGE","market_name":"LG Spirit LTE","codename":"c70","model":"LG-H440"},{"manufacturer":"LGE","market_name":"LG Spirit LTE","codename":"c70","model":"LG-H440AR"},{"manufacturer":"LGE","market_name":"LG Stylo 2","codename":"ph1","model":"LG-K540"},{"manufacturer":"LGE","market_name":"LG Stylo 2","codename":"ph1","model":"LGL81AL"},{"manufacturer":"LGE","market_name":"LG Stylo 2","codename":"ph1","model":"LGL82VL"},{"manufacturer":"LGE","market_name":"LG Stylo 2","codename":"ph1","model":"LGLS775"},{"manufacturer":"LGE","market_name":"LG Stylo 2 Plus","codename":"ph2n","model":"LG-K550"},{"manufacturer":"LGE","market_name":"LG Stylo 2 Plus","codename":"ph2n","model":"LG-K557"},{"manufacturer":"LGE","market_name":"LG Stylo 2 Plus","codename":"ph2n","model":"LGMS550"},{"manufacturer":"LGE","market_name":"LG Stylo 3 Plus","codename":"sf340n","model":"LG-M470"},{"manufacturer":"LGE","market_name":"LG Stylo 3 Plus","codename":"sf340n","model":"LG-M470F"},{"manufacturer":"LGE","market_name":"LG Stylo 3 Plus","codename":"sf340n","model":"LG-TP450"},{"manufacturer":"LGE","market_name":"LG Stylo 3 Plus","codename":"sf340n","model":"LGMP450"},{"manufacturer":"LGE","market_name":"LG Stylo 4","codename":"cv7a","model":"LM-Q710(FGN)"},{"manufacturer":"LGE","market_name":"LG Stylo 4","codename":"cv7a","model":"LM-Q710.FG"},{"manufacturer":"LGE","market_name":"LG Stylo 4","codename":"cv7a","model":"LML713DL"},{"manufacturer":"LGE","market_name":"LG Stylo3","codename":"sf317","model":"LG-M430"},{"manufacturer":"LGE","market_name":"LG Stylo3","codename":"sf317","model":"LGL83BL"},{"manufacturer":"LGE","market_name":"LG Stylo3","codename":"sf317","model":"LGL84VL"},{"manufacturer":"LGE","market_name":"LG Stylo3","codename":"sf340","model":"LG-LS777"},{"manufacturer":"LGE","market_name":"LG Stylus 2","codename":"ph1","model":"LG-F720K"},{"manufacturer":"LGE","market_name":"LG Stylus 2","codename":"ph1","model":"LG-F720L"},{"manufacturer":"LGE","market_name":"LG Stylus 2","codename":"ph1","model":"LG-F720S"},{"manufacturer":"LGE","market_name":"LG Stylus 2","codename":"ph1","model":"LG-K520"},{"manufacturer":"LGE","market_name":"LG Stylus2","codename":"ph1n","model":"LG-K520"},{"manufacturer":"LGE","market_name":"LG Stylus2 4G","codename":"ph2","model":"LG-K530"},{"manufacturer":"LGE","market_name":"LG Stylus2 4G","codename":"ph2","model":"LG-K535"},{"manufacturer":"LGE","market_name":"LG Stylus2 Plus","codename":"ph2n","model":"LG-K535"},{"manufacturer":"LGE","market_name":"LG Stylus2 Plus","codename":"ph2n","model":"LG-K535n"},{"manufacturer":"LGE","market_name":"LG Stylus3","codename":"msf3","model":"LG-M400"},{"manufacturer":"LGE","market_name":"LG Stylus3","codename":"msf3n","model":"LG-M400"},{"manufacturer":"LGE","market_name":"LG Thrill 4G","codename":"cosmopolitan","model":"LG-P925"},{"manufacturer":"LGE","market_name":"LG Treasure","codename":"m1","model":"LGL51AL"},{"manufacturer":"LGE","market_name":"LG Treasure","codename":"m1","model":"LGL52VL"},{"manufacturer":"LGE","market_name":"LG Tribute 2\\xe2\\x84\\xa2","codename":"c50","model":"LGLS665"},{"manufacturer":"LGE","market_name":"LG Tribute 5","codename":"m1","model":"LGLS675"},{"manufacturer":"LGE","market_name":"LG Tribute Dynasty","codename":"mcv150","model":"LG-SP200"},{"manufacturer":"LGE","market_name":"LG U","codename":"bbg","model":"LG-F820L"},{"manufacturer":"LGE","market_name":"LG V35 ThinQ","codename":"judyp","model":"LM-V350"},{"manufacturer":"LGE","market_name":"LG V35 ThinQ","codename":"judyp","model":"LM-V350N"},{"manufacturer":"LGE","market_name":"LG Venice","codename":"u0_cdma","model":"LG-LG730"},{"manufacturer":"LGE","market_name":"LG Viper 4G LTE","codename":"cayman","model":"LG-LS840"},{"manufacturer":"LGE","market_name":"LG Volt","codename":"my70ds","model":"LG-H422"},{"manufacturer":"LGE","market_name":"LG Volt","codename":"x5","model":"LGLS740"},{"manufacturer":"LGE","market_name":"LG Volt 4G","codename":"c70ds","model":"LG-H442"},{"manufacturer":"LGE","market_name":"LG Volt II","codename":"c90nas","model":"LGLS751"},{"manufacturer":"LGE","market_name":"LG Volt LTE","codename":"c70w","model":"LG-F540K"},{"manufacturer":"LGE","market_name":"LG Volt LTE","codename":"c70w","model":"LG-F540L"},{"manufacturer":"LGE","market_name":"LG Volt LTE","codename":"c70w","model":"LG-F540S"},{"manufacturer":"LGE","market_name":"LG Volt S","codename":"c90","model":"LG-F640S"},{"manufacturer":"LGE","market_name":"LG Watch Sport","codename":"swordfish","model":"LG Watch Sport"},{"manufacturer":"LGE","market_name":"LG Watch Style","codename":"angelfish","model":"LG Watch Style"},{"manufacturer":"LGE","market_name":"LG Watch Urbane","codename":"bass","model":"LG Watch Urbane"},{"manufacturer":"LGE","market_name":"LG Watch Urbane 2nd Edition LTE","codename":"nemo","model":"LG Watch Urbane"},{"manufacturer":"LGE","market_name":"LG Wine Smart","codename":"cf","model":"LG-H410"},{"manufacturer":"LGE","market_name":"LG Wine Smart Jazz","codename":"cf","model":"LG-F610K"},{"manufacturer":"LGE","market_name":"LG Wine Smart Jazz","codename":"cf","model":"LG-F610S"},{"manufacturer":"LGE","market_name":"LG X Screen","codename":"k5","model":"LGK500J"},{"manufacturer":"LGE","market_name":"LG X Skin","codename":"k6b","model":"LG-F740L"},{"manufacturer":"LGE","market_name":"LG X Style","codename":"k6b","model":"LG-K200"},{"manufacturer":"LGE","market_name":"LG X Style","codename":"k6b","model":"LGL53BL"},{"manufacturer":"LGE","market_name":"LG X Style","codename":"k6b","model":"LGL56VL"},{"manufacturer":"LGE","market_name":"LG X Style","codename":"k6b","model":"LGLS676"},{"manufacturer":"LGE","market_name":"LG X Venture","codename":"lv9","model":"LG-US701"},{"manufacturer":"LGE","market_name":"LG X Venture","codename":"lv9n","model":"LG-H700"},{"manufacturer":"LGE","market_name":"LG X Venture","codename":"lv9n","model":"LG-M710"},{"manufacturer":"LGE","market_name":"LG X Venture","codename":"lv9n","model":"LG-M710ds"},{"manufacturer":"LGE","market_name":"LG X cam","codename":"k7","model":"LG-F690L"},{"manufacturer":"LGE","market_name":"LG X cam","codename":"k7","model":"LG-F690S"},{"manufacturer":"LGE","market_name":"LG X cam","codename":"k7","model":"LG-K580"},{"manufacturer":"LGE","market_name":"LG X cam","codename":"k7n","model":"LG-K580"},{"manufacturer":"LGE","market_name":"LG X cam","codename":"k7n","model":"LG-K580Y"},{"manufacturer":"LGE","market_name":"LG X charge","codename":"lv7","model":"LG-M322"},{"manufacturer":"LGE","market_name":"LG X charge","codename":"lv7","model":"LG-M327"},{"manufacturer":"LGE","market_name":"LG X charge","codename":"mlv7","model":"LG-M320"},{"manufacturer":"LGE","market_name":"LG X charge","codename":"mlv7","model":"LM-X510(FG)"},{"manufacturer":"LGE","market_name":"LG X charge","codename":"mlv7","model":"LM-X510.FG"},{"manufacturer":"LGE","market_name":"LG X max","codename":"mk6m","model":"LG-K240"},{"manufacturer":"LGE","market_name":"LG X power","codename":"k6p","model":"LG-K210"},{"manufacturer":"LGE","market_name":"LG X power","codename":"k6p","model":"LG-K212"},{"manufacturer":"LGE","market_name":"LG X power","codename":"k6p","model":"LG-K450"},{"manufacturer":"LGE","market_name":"LG X power","codename":"k6p","model":"LGUS610"},{"manufacturer":"LGE","market_name":"LG X power","codename":"mk6p","model":"LG-F750K"},{"manufacturer":"LGE","market_name":"LG X power","codename":"mk6p","model":"LG-K220"},{"manufacturer":"LGE","market_name":"LG X power","codename":"mk6p55","model":"LGLS755"},{"manufacturer":"LGE","market_name":"LG X power","codename":"mk6pn","model":"LG-K220"},{"manufacturer":"LGE","market_name":"LG X power2","codename":"lv7","model":"LG-M320G"},{"manufacturer":"LGE","market_name":"LG X screen","codename":"k5","model":"LG-F650K"},{"manufacturer":"LGE","market_name":"LG X screen","codename":"k5","model":"LG-F650L"},{"manufacturer":"LGE","market_name":"LG X screen","codename":"k5","model":"LG-F650S"},{"manufacturer":"LGE","market_name":"LG X screen","codename":"k5","model":"LG-K500"},{"manufacturer":"LGE","market_name":"LG X screen","codename":"k5","model":"LGS02"},{"manufacturer":"LGE","market_name":"LG X screen","codename":"k5n","model":"LG-K500"},{"manufacturer":"LGE","market_name":"LG X screen","codename":"k5n","model":"LG-K500n"},{"manufacturer":"LGE","market_name":"LG X2","codename":"cv109","model":"LM-X210K"},{"manufacturer":"LGE","market_name":"LG X2","codename":"cv109","model":"LM-X210L"},{"manufacturer":"LGE","market_name":"LG X2","codename":"cv109","model":"LM-X210S"},{"manufacturer":"LGE","market_name":"LG X300","codename":"lv3n","model":"LGM-K120K"},{"manufacturer":"LGE","market_name":"LG X300","codename":"lv3n","model":"LGM-K120L"},{"manufacturer":"LGE","market_name":"LG X300","codename":"lv3n","model":"LGM-K120S"},{"manufacturer":"LGE","market_name":"LG X400","codename":"mlv5n","model":"LGM-K121K"},{"manufacturer":"LGE","market_name":"LG X400","codename":"mlv5n","model":"LGM-K121L"},{"manufacturer":"LGE","market_name":"LG X400","codename":"mlv5n","model":"LGM-K121S"},{"manufacturer":"LGE","market_name":"LG X400","codename":"mlv5n","model":"LGM-X301K"},{"manufacturer":"LGE","market_name":"LG X400","codename":"mlv5n","model":"LGM-X301L"},{"manufacturer":"LGE","market_name":"LG X400","codename":"mlv5n","model":"LGM-X301S"},{"manufacturer":"LGE","market_name":"LG X400","codename":"mlv5n","model":"LGM-X401L"},{"manufacturer":"LGE","market_name":"LG X400","codename":"mlv5n","model":"LGM-X401S"},{"manufacturer":"LGE","market_name":"LG X5","codename":"mk6m","model":"LG-F770S"},{"manufacturer":"LGE","market_name":"LG X5","codename":"mlv7n","model":"LM-X510L"},{"manufacturer":"LGE","market_name":"LG X500","codename":"mlv7n","model":"LG-M320"},{"manufacturer":"LGE","market_name":"LG X500","codename":"mlv7n","model":"LGM-X320K"},{"manufacturer":"LGE","market_name":"LG X500","codename":"mlv7n","model":"LGM-X320L"},{"manufacturer":"LGE","market_name":"LG X500","codename":"mlv7n","model":"LGM-X320S"},{"manufacturer":"LGE","market_name":"LG X500","codename":"mlv7n","model":"LM-X510K"},{"manufacturer":"LGE","market_name":"LG X500","codename":"mlv7n","model":"LM-X510S"},{"manufacturer":"LGE","market_name":"LG ZONE","codename":"d2","model":"LG-X180g"},{"manufacturer":"LGE","market_name":"LG Zero","codename":"c100","model":"LG-H650"},{"manufacturer":"LGE","market_name":"LG optimus it L-05D","codename":"l_dcm","model":"L-05D"},{"manufacturer":"LGE","market_name":"LG optimus it L-05E","codename":"L05E","model":"L-05E"},{"manufacturer":"LGE","market_name":"LG-AS876","codename":"x5","model":"AS876"},{"manufacturer":"LGE","market_name":"LG-D150","codename":"w35","model":"LG-D150"},{"manufacturer":"LGE","market_name":"LG-D157f","codename":"w35ds","model":"LG-D157f"},{"manufacturer":"LGE","market_name":"LG-E985T","codename":"gvarfhd","model":"LG-E985"},{"manufacturer":"LGE","market_name":"LG-E985T","codename":"gvarfhd","model":"LG-E985T"},{"manufacturer":"LGE","market_name":"LGL22","codename":"g2","model":"LGL22"},{"manufacturer":"LGE","market_name":"LML413DL","codename":"cv3","model":"LM-X410(FG)"},{"manufacturer":"LGE","market_name":"LML413DL","codename":"cv3","model":"LM-X410.F"},{"manufacturer":"LGE","market_name":"LML413DL","codename":"cv3","model":"LM-X410.FG"},{"manufacturer":"LGE","market_name":"LML413DL","codename":"cv3","model":"LM-X410.FGN"},{"manufacturer":"LGE","market_name":"LML413DL","codename":"cv3","model":"LML413DL"},{"manufacturer":"LGE","market_name":"LML413DL","codename":"cv3","model":"LML414DL"},{"manufacturer":"LGE","market_name":"Marquee","codename":"L-07C","model":"L-07C"},{"manufacturer":"LGE","market_name":"Marquee","codename":"LG855","model":"LG-LG855"},{"manufacturer":"LGE","market_name":"Marquee","codename":"LS855","model":"LG-LS855"},{"manufacturer":"LGE","market_name":"Marquee","codename":"bproj_CIS-xxx","model":"LG-P970"},{"manufacturer":"LGE","market_name":"My touch 4G","codename":"e739","model":"LG-E739"},{"manufacturer":"LGE","market_name":"Nexus 4","codename":"mako","model":"Nexus 4"},{"manufacturer":"LGE","market_name":"Nexus 5","codename":"hammerhead","model":"Nexus 5"},{"manufacturer":"LGE","market_name":"Nexus 5X","codename":"bullhead","model":"Nexus 5X"},{"manufacturer":"LGE","market_name":"Optiimus Black","codename":"bproj_208-01","model":"LG-P970"},{"manufacturer":"LGE","market_name":"Optimus  EX","codename":"x2","model":"LG-SU880"},{"manufacturer":"LGE","market_name":"Optimus  LTE","codename":"l1a","model":"LG-P870"},{"manufacturer":"LGE","market_name":"Optimus 2","codename":"as680","model":"LG-AS680"},{"manufacturer":"LGE","market_name":"Optimus 2X","codename":"p990","model":"LG-P990"},{"manufacturer":"LGE","market_name":"Optimus 2X","codename":"p990","model":"LG-P990H"},{"manufacturer":"LGE","market_name":"Optimus 2X","codename":"p990","model":"LG-P990h"},{"manufacturer":"LGE","market_name":"Optimus 2X","codename":"p990_262-xx","model":"LG-P990"},{"manufacturer":"LGE","market_name":"Optimus 2X","codename":"p990_CIS-xxx","model":"LG-P990"},{"manufacturer":"LGE","market_name":"Optimus 2X","codename":"p990_EUR-xx","model":"LG-P990"},{"manufacturer":"LGE","market_name":"Optimus 2X","codename":"p990hN","model":"LG-P990hN"},{"manufacturer":"LGE","market_name":"Optimus 2X","codename":"p999","model":"LG-P999"},{"manufacturer":"LGE","market_name":"Optimus 2X","codename":"star","model":"LG-P990"},{"manufacturer":"LGE","market_name":"Optimus 2X","codename":"star","model":"LG-SU660"},{"manufacturer":"LGE","market_name":"Optimus 2X","codename":"star_450-05","model":"LG-SU660"},{"manufacturer":"LGE","market_name":"Optimus 2X","codename":"su660","model":"LG-SU660"},{"manufacturer":"LGE","market_name":"Optimus 3D","codename":"cosmo_450-05","model":"LG-SU760"},{"manufacturer":"LGE","market_name":"Optimus 3D","codename":"cosmo_EUR-XXX","model":"LG-P920"},{"manufacturer":"LGE","market_name":"Optimus 3D","codename":"cosmo_MEA-XXX","model":"LG-P920"},{"manufacturer":"LGE","market_name":"Optimus 3D","codename":"p920","model":"LG-P920"},{"manufacturer":"LGE","market_name":"Optimus 3D","codename":"p920","model":"LG-P920h"},{"manufacturer":"LGE","market_name":"Optimus 3D","codename":"su760","model":"LG-SU760"},{"manufacturer":"LGE","market_name":"Optimus 3D Cube","codename":"cx2","model":"LG-SU870"},{"manufacturer":"LGE","market_name":"Optimus 3D MAX","codename":"cx2","model":"LG-P720"},{"manufacturer":"LGE","market_name":"Optimus 3D MAX","codename":"cx2","model":"LG-P720h"},{"manufacturer":"LGE","market_name":"Optimus 3D MAX","codename":"cx2","model":"LG-P725"},{"manufacturer":"LGE","market_name":"Optimus 3D MAX","codename":"cx2","model":"LG-SU870"},{"manufacturer":"LGE","market_name":"Optimus 4X HD","codename":"x3","model":"LG-P880"},{"manufacturer":"LGE","market_name":"Optimus 4X HD","codename":"x3","model":"LG-P880g"},{"manufacturer":"LGE","market_name":"Optimus Big","codename":"justin","model":"LG-LU6800"},{"manufacturer":"LGE","market_name":"Optimus Big","codename":"lu6800","model":"LG-LU6800"},{"manufacturer":"LGE","market_name":"Optimus Black","codename":"LGL85C","model":"LGL85C"},{"manufacturer":"LGE","market_name":"Optimus Black","codename":"black","model":"LG-KU5900"},{"manufacturer":"LGE","market_name":"Optimus Black","codename":"blackg","model":"LG-P970"},{"manufacturer":"LGE","market_name":"Optimus Black","codename":"blackg","model":"LG-P970h"},{"manufacturer":"LGE","market_name":"Optimus Black","codename":"bproj_214-03","model":"LG-P970"},{"manufacturer":"LGE","market_name":"Optimus Black","codename":"bproj_262-XXX","model":"LG-P970"},{"manufacturer":"LGE","market_name":"Optimus Black","codename":"bproj_302-220","model":"LG-P970g"},{"manufacturer":"LGE","market_name":"Optimus Black","codename":"bproj_334-020","model":"LG-P970h"},{"manufacturer":"LGE","market_name":"Optimus Black","codename":"bproj_724-xxx","model":"LG-P970h"},{"manufacturer":"LGE","market_name":"Optimus Black","codename":"bproj_ARE-XXX","model":"LG-P970"},{"manufacturer":"LGE","market_name":"Optimus Black","codename":"bproj_EUR-XXX","model":"LG-P970"},{"manufacturer":"LGE","market_name":"Optimus Black","codename":"bproj_sea-xxx","model":"LG-P970"},{"manufacturer":"LGE","market_name":"Optimus Black","codename":"ku5900","model":"LG-KU5900"},{"manufacturer":"LGE","market_name":"Optimus Black","codename":"lgp970","model":"LG-P970"},{"manufacturer":"LGE","market_name":"Optimus Black","codename":"lgp970","model":"LG-P970g"},{"manufacturer":"LGE","market_name":"Optimus Black","codename":"lgp970","model":"LG-P970h"},{"manufacturer":"LGE","market_name":"Optimus Chat","codename":"hazel","model":"LG-C550"},{"manufacturer":"LGE","market_name":"Optimus Chat","codename":"hazel","model":"LG-C555"},{"manufacturer":"LGE","market_name":"Optimus Core","codename":"u0_cdma","model":"LGL86C"},{"manufacturer":"LGE","market_name":"Optimus EX","codename":"x2","model":"IS11LG"},{"manufacturer":"LGE","market_name":"Optimus EX","codename":"x2_450-05","model":"LG-SU880"},{"manufacturer":"LGE","market_name":"Optimus Exceed 2","codename":"w5c","model":"LG-VS450PP"},{"manufacturer":"LGE","market_name":"Optimus F3","codename":"fx3","model":"LG-LS720"},{"manufacturer":"LGE","market_name":"Optimus F3","codename":"fx3","model":"LG-P655H"},{"manufacturer":"LGE","market_name":"Optimus F3","codename":"fx3","model":"LG-P655K"},{"manufacturer":"LGE","market_name":"Optimus F3","codename":"fx3","model":"LG-P659"},{"manufacturer":"LGE","market_name":"Optimus F3","codename":"fx3","model":"LG-P659H"},{"manufacturer":"LGE","market_name":"Optimus F3","codename":"fx3","model":"LGL25L"},{"manufacturer":"LGE","market_name":"Optimus F3","codename":"fx3","model":"LGMS659"},{"manufacturer":"LGE","market_name":"Optimus F5","codename":"l1e","model":"LG-P870h"},{"manufacturer":"LGE","market_name":"Optimus F5","codename":"l1e","model":"LG-P875"},{"manufacturer":"LGE","market_name":"Optimus F5","codename":"l1e","model":"LG-P875h"},{"manufacturer":"LGE","market_name":"Optimus F5","codename":"l1v","model":"AS870 4G"},{"manufacturer":"LGE","market_name":"Optimus F6","codename":"f6","model":"LG-D500"},{"manufacturer":"LGE","market_name":"Optimus F6","codename":"f6","model":"LG-D505"},{"manufacturer":"LGE","market_name":"Optimus F6","codename":"f6","model":"LGMS500"},{"manufacturer":"LGE","market_name":"Optimus Fuel","codename":"w3c","model":"LGL34C"},{"manufacturer":"LGE","market_name":"Optimus G Pro","codename":"geevl04e","model":"L-04E"},{"manufacturer":"LGE","market_name":"Optimus GJ","codename":"geehdc","model":"LG-E975w"},{"manufacturer":"LGE","market_name":"Optimus GK","codename":"gvfhd","model":"LG-F220K"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"lgc800","model":"LG-C800"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"lgc800g","model":"LG-C800G"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"univa_214-04","model":"LG-E510"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"univa_724-05","model":"LG-E510f"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"univa_730-01","model":"LG-E510g"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"univa_730-03","model":"LG-E510g"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"univa_740-01","model":"LG-E510g"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"univa_clr-br","model":"LG-E510f"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"univa_ctm-xxx","model":"LG-E510g"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"univa_ent-cl","model":"LG-E510g"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"univa_open-br","model":"LG-E510f"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"univa_open-de","model":"LG-E510"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"univa_ssv-xxx","model":"LG-E510g"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"univa_tcl-mx","model":"LG-E510f"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"univa_tlf-es","model":"LG-E510"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"univa_ufn-mx","model":"LG-E510g"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"univa_usc-mx","model":"LG-E510g"},{"manufacturer":"LGE","market_name":"Optimus Hub","codename":"univa_viv-br","model":"LG-E510f"},{"manufacturer":"LGE","market_name":"Optimus L40","codename":"w3","model":"LG-D160"},{"manufacturer":"LGE","market_name":"Optimus L40","codename":"w3","model":"LG-D165"},{"manufacturer":"LGE","market_name":"Optimus L40","codename":"w3","model":"LG-D165AR"},{"manufacturer":"LGE","market_name":"Optimus L40","codename":"w3ds","model":"LG-D170"},{"manufacturer":"LGE","market_name":"Optimus L40","codename":"w3ds","model":"LG-D175f"},{"manufacturer":"LGE","market_name":"Optimus L40","codename":"w3ts","model":"LG-D180f"},{"manufacturer":"LGE","market_name":"Optimus L5","codename":"m4","model":"LG-E610"},{"manufacturer":"LGE","market_name":"Optimus L5","codename":"m4","model":"LG-E610v"},{"manufacturer":"LGE","market_name":"Optimus L5","codename":"m4","model":"LG-E612"},{"manufacturer":"LGE","market_name":"Optimus L5","codename":"m4","model":"LG-E612f"},{"manufacturer":"LGE","market_name":"Optimus L5","codename":"m4","model":"LG-E612g"},{"manufacturer":"LGE","market_name":"Optimus L5","codename":"m4","model":"LG-E617G"},{"manufacturer":"LGE","market_name":"Optimus L5","codename":"m4","model":"LG-L40G"},{"manufacturer":"LGE","market_name":"Optimus L7II","codename":"vee7ds","model":"LG-P716"},{"manufacturer":"LGE","market_name":"Optimus LIFE","codename":"l1_dcm","model":"L-02E"},{"manufacturer":"LGE","market_name":"Optimus LTE","codename":"i_dcm","model":"L-01D"},{"manufacturer":"LGE","market_name":"Optimus LTE","codename":"i_skt","model":"LG-SU640"},{"manufacturer":"LGE","market_name":"Optimus LTE","codename":"i_u","model":"LG-LU6200"},{"manufacturer":"LGE","market_name":"Optimus LTE","codename":"iproj","model":"LG-P936"},{"manufacturer":"LGE","market_name":"Optimus LTE","codename":"lgp930","model":"LG-P930"},{"manufacturer":"LGE","market_name":"Optimus LTE","codename":"lgp935","model":"LG-P935"},{"manufacturer":"LGE","market_name":"Optimus Mach","codename":"LU3000","model":"LG-LU3000"},{"manufacturer":"LGE","market_name":"Optimus Mach","codename":"hub","model":"LG-LU3000"},{"manufacturer":"LGE","market_name":"Optimus Mach","codename":"lu3000","model":"LG-LU3000"},{"manufacturer":"LGE","market_name":"Optimus Net","codename":"gelato_302-610","model":"LG-P690b"},{"manufacturer":"LGE","market_name":"Optimus Net","codename":"gelato_cis-xx","model":"LG-P690"},{"manufacturer":"LGE","market_name":"Optimus Net","codename":"gelato_sea-xx","model":"LG-P690"},{"manufacturer":"LGE","market_name":"Optimus Net","codename":"lgl45c","model":"LGL45C"},{"manufacturer":"LGE","market_name":"Optimus Net Dual","codename":"gelatods_are-xxx","model":"LG-P698"},{"manufacturer":"LGE","market_name":"Optimus Net Dual","codename":"gelatods_cis-xxx","model":"LG-P698"},{"manufacturer":"LGE","market_name":"Optimus Net Dual","codename":"gelatods_ind-xxx","model":"LG-P698"},{"manufacturer":"LGE","market_name":"Optimus Net Dual","codename":"gelatods_open-br","model":"LG-P698f"},{"manufacturer":"LGE","market_name":"Optimus Net Dual","codename":"gelatods_sea-xxx","model":"LG-P698"},{"manufacturer":"LGE","market_name":"Optimus One","codename":"ku3700","model":"LG-KU3700"},{"manufacturer":"LGE","market_name":"Optimus One","codename":"lu3700","model":"LG-LU3700"},{"manufacturer":"LGE","market_name":"Optimus One","codename":"su370","model":"LG-SU370"},{"manufacturer":"LGE","market_name":"Optimus One","codename":"thunder_kor-05","model":"LG-SU370"},{"manufacturer":"LGE","market_name":"Optimus One","codename":"thunder_kor-08","model":"LG-KU3700"},{"manufacturer":"LGE","market_name":"Optimus One","codename":"thunder_kor-08","model":"LG-LU3700"},{"manufacturer":"LGE","market_name":"Optimus One","codename":"thunderc","model":"LG-CX670"},{"manufacturer":"LGE","market_name":"Optimus One","codename":"thunderc","model":"LG-LW690"},{"manufacturer":"LGE","market_name":"Optimus One","codename":"thunderc","model":"LG-MS690"},{"manufacturer":"LGE","market_name":"Optimus One","codename":"thunderc","model":"LG-US670"},{"manufacturer":"LGE","market_name":"Optimus One","codename":"thunderc","model":"LS670"},{"manufacturer":"LGE","market_name":"Optimus One","codename":"thunderc","model":"VM670"},{"manufacturer":"LGE","market_name":"Optimus One","codename":"thunderc","model":"Vortex"},{"manufacturer":"LGE","market_name":"Optimus One","codename":"thunderc","model":"thunderc"},{"manufacturer":"LGE","market_name":"Optimus PAD LTE","codename":"express","model":"LG-LU8300"},{"manufacturer":"LGE","market_name":"Optimus Pad","codename":"l06c","model":"L-06C"},{"manufacturer":"LGE","market_name":"Optimus Pad","codename":"v900","model":"LG-V900"},{"manufacturer":"LGE","market_name":"Optimus Pad","codename":"v900asia","model":"LG-V900"},{"manufacturer":"LGE","market_name":"Optimus Pad","codename":"v901ar","model":"LG-V901"},{"manufacturer":"LGE","market_name":"Optimus Pad","codename":"v901kr","model":"LG-V901"},{"manufacturer":"LGE","market_name":"Optimus Pad","codename":"v901tr","model":"LG-V901"},{"manufacturer":"LGE","market_name":"Optimus Pad","codename":"v905r","model":"LG-V905R"},{"manufacturer":"LGE","market_name":"Optimus Pad","codename":"v909","model":"LG-V909"},{"manufacturer":"LGE","market_name":"Optimus Pad","codename":"v909mkt","model":"LG-V909"},{"manufacturer":"LGE","market_name":"Optimus Plus","codename":"m3_acg_us","model":"LG-AS695"},{"manufacturer":"LGE","market_name":"Optimus Pro","codename":"muscat","model":"LG-C660"},{"manufacturer":"LGE","market_name":"Optimus Pro","codename":"muscat","model":"LG-C660R"},{"manufacturer":"LGE","market_name":"Optimus Pro","codename":"muscat","model":"LG-C660h"},{"manufacturer":"LGE","market_name":"Optimus Q","codename":"lgl55c","model":"LGL55C"},{"manufacturer":"LGE","market_name":"Optimus Q2","codename":"bssq","model":"LG-LU6500"},{"manufacturer":"LGE","market_name":"Optimus Q2","codename":"bssq_450-06","model":"LG-LU6500"},{"manufacturer":"LGE","market_name":"Optimus Slider","codename":"VM701","model":"LG-VM701"},{"manufacturer":"LGE","market_name":"Optimus Sol","codename":"victor","model":"LG-E730"},{"manufacturer":"LGE","market_name":"Optimus Sol","codename":"victor","model":"LG-E730f"},{"manufacturer":"LGE","market_name":"Optimus Spirit","codename":"gelato_505-01","model":"LG-P690f"},{"manufacturer":"LGE","market_name":"Optimus Spirit","codename":"gelato_eur-xx","model":"LG-P690"},{"manufacturer":"LGE","market_name":"Optimus Vu","codename":"325","model":"LG-F100L"},{"manufacturer":"LGE","market_name":"Optimus Vu","codename":"batman","model":"LG-F100L"},{"manufacturer":"LGE","market_name":"Optimus Vu","codename":"batman","model":"LG-F100S"},{"manufacturer":"LGE","market_name":"Optimus Vu","codename":"batman_dcm","model":"L-06DJOJO"},{"manufacturer":"LGE","market_name":"Optimus Vu","codename":"batman_lgu","model":"LG-F100L"},{"manufacturer":"LGE","market_name":"Optimus Vu","codename":"batman_skt","model":"LG-F100S"},{"manufacturer":"LGE","market_name":"Optimus Vu","codename":"lge_325_skt","model":"LG-F100S"},{"manufacturer":"LGE","market_name":"Optimus Vu","codename":"vu10","model":"LG-P895"},{"manufacturer":"LGE","market_name":"Optimus Vu","codename":"vu10","model":"LG-P895qb"},{"manufacturer":"LGE","market_name":"Optimus Vu2","codename":"vu2kt","model":"LG-F200K"},{"manufacturer":"LGE","market_name":"Optimus Vu2","codename":"vu2sk","model":"LG-F200S"},{"manufacturer":"LGE","market_name":"Optimus Vu2","codename":"vu2u","model":"LG-F200L"},{"manufacturer":"LGE","market_name":"Optimus Vu2","codename":"vu2u","model":"LG-F200LS"},{"manufacturer":"LGE","market_name":"Optimus Vu:","codename":"batman_dcm","model":"L-06D"},{"manufacturer":"LGE","market_name":"Optimus Z","codename":"su950","model":"SU950"},{"manufacturer":"LGE","market_name":"Optimus Zone","codename":"e0v","model":"LG-VS410PP"},{"manufacturer":"LGE","market_name":"Optimus chat","codename":"elini","model":"L-04C"},{"manufacturer":"LGE","market_name":"PRADA 3.0","codename":"p2","model":"L-02D"},{"manufacturer":"LGE","market_name":"PRADA 3.0","codename":"p2","model":"LG-KU5400"},{"manufacturer":"LGE","market_name":"PRADA 3.0","codename":"p2","model":"LG-LU5400"},{"manufacturer":"LGE","market_name":"PRADA 3.0","codename":"p2","model":"LG-P940"},{"manufacturer":"LGE","market_name":"PRADA 3.0","codename":"p2","model":"LG-P940h"},{"manufacturer":"LGE","market_name":"PRADA 3.0","codename":"p2","model":"LG-SU540"},{"manufacturer":"LGE","market_name":"PecanV","codename":"pecanV","model":"LG-P355"},{"manufacturer":"LGE","market_name":"Phoenix 3","codename":"lv1","model":"LG-M150"},{"manufacturer":"LGE","market_name":"Premier","codename":"m209","model":"LGL61AL"},{"manufacturer":"LGE","market_name":"Premier","codename":"m209","model":"LGL62VL"},{"manufacturer":"LGE","market_name":"Q8","codename":"anna","model":"LG-H970"},{"manufacturer":"LGE","market_name":"Q8","codename":"anna","model":"LGM-X800K"},{"manufacturer":"LGE","market_name":"Q8","codename":"anna","model":"LGM-X800L"},{"manufacturer":"LGE","market_name":"Q8+","codename":"cv7an","model":"LM-Q815L"},{"manufacturer":"LGE","market_name":"Q8+","codename":"cv7an","model":"LM-Q815S"},{"manufacturer":"LGE","market_name":"QStylus Plus","codename":"mcv7a","model":"LM-Q710.FG"},{"manufacturer":"LGE","market_name":"QStylus Plus","codename":"mcv7a","model":"LM-Q710.FGN"},{"manufacturer":"LGE","market_name":"Qua phone PX","codename":"JSG","model":"LGV33"},{"manufacturer":"LGE","market_name":"Qua tab PX","codename":"b3","model":"LGT31"},{"manufacturer":"LGE","market_name":"Qua tab PZ","codename":"b5","model":"LGT32"},{"manufacturer":"LGE","market_name":"Rebel 3","codename":"lv1","model":"LGL158VL"},{"manufacturer":"LGE","market_name":"Rebel 3","codename":"lv1","model":"LGL58VL"},{"manufacturer":"LGE","market_name":"Shine Plus with Google","codename":"alohag","model":"LG-C710h"},{"manufacturer":"LGE","market_name":"Smart Dios V8700","codename":"SE_TF","model":"ref_SCTF"},{"manufacturer":"LGE","market_name":"Spectrum","codename":"i_vzw","model":"VS920 4G"},{"manufacturer":"LGE","market_name":"Spectrum 2","codename":"d1lv","model":"VS930 4G"},{"manufacturer":"LGE","market_name":"Spirit 4G","codename":"l1m","model":"LG-MS870"},{"manufacturer":"LGE","market_name":"Splendor","codename":"u0_cdma","model":"LG-US730"},{"manufacturer":"LGE","market_name":"Spray","codename":"e2jps","model":"402LG"},{"manufacturer":"LGE","market_name":"Spree","codename":"e1q","model":"LG-K120"},{"manufacturer":"LGE","market_name":"Stylo 2 V","codename":"mph1","model":"VS835"},{"manufacturer":"LGE","market_name":"Swift","codename":"swift","model":"GT540"},{"manufacturer":"LGE","market_name":"Swift","codename":"swift","model":"GT540GO"},{"manufacturer":"LGE","market_name":"Swift","codename":"swift","model":"GT540R"},{"manufacturer":"LGE","market_name":"Swift","codename":"swift","model":"GT540f"},{"manufacturer":"LGE","market_name":"TBD","codename":"aka","model":"LG-F520K"},{"manufacturer":"LGE","market_name":"Thrill 4G","codename":"cosmo_310-410","model":"LG-P925"},{"manufacturer":"LGE","market_name":"Thrill 4G","codename":"p925","model":"LG-P925"},{"manufacturer":"LGE","market_name":"V10","codename":"pplus","model":"LG-F600K"},{"manufacturer":"LGE","market_name":"V10","codename":"pplus","model":"LG-F600L"},{"manufacturer":"LGE","market_name":"V10","codename":"pplus","model":"LG-F600S"},{"manufacturer":"LGE","market_name":"V10","codename":"pplus","model":"LG-H900"},{"manufacturer":"LGE","market_name":"V10","codename":"pplus","model":"LG-H900PR"},{"manufacturer":"LGE","market_name":"V10","codename":"pplus","model":"LG-H901"},{"manufacturer":"LGE","market_name":"V10","codename":"pplus","model":"LG-H960"},{"manufacturer":"LGE","market_name":"V10","codename":"pplus","model":"LG-H961AN"},{"manufacturer":"LGE","market_name":"V10","codename":"pplus","model":"LG-H961N"},{"manufacturer":"LGE","market_name":"V10","codename":"pplus","model":"LG-H961S"},{"manufacturer":"LGE","market_name":"V10","codename":"pplus","model":"LG-H962"},{"manufacturer":"LGE","market_name":"V10","codename":"pplus","model":"LG-H968"},{"manufacturer":"LGE","market_name":"V10","codename":"pplus","model":"RS987"},{"manufacturer":"LGE","market_name":"V10","codename":"pplus","model":"VS990"},{"manufacturer":"LGE","market_name":"V20","codename":"elsa","model":"LG-F800K"},{"manufacturer":"LGE","market_name":"V20","codename":"elsa","model":"LG-F800L"},{"manufacturer":"LGE","market_name":"V20","codename":"elsa","model":"LG-F800S"},{"manufacturer":"LGE","market_name":"V20","codename":"elsa","model":"LG-H910"},{"manufacturer":"LGE","market_name":"V20","codename":"elsa","model":"LG-H910PR"},{"manufacturer":"LGE","market_name":"V20","codename":"elsa","model":"LG-H915"},{"manufacturer":"LGE","market_name":"V20","codename":"elsa","model":"LG-H918"},{"manufacturer":"LGE","market_name":"V20","codename":"elsa","model":"LG-H990"},{"manufacturer":"LGE","market_name":"V20","codename":"elsa","model":"LG-LS997"},{"manufacturer":"LGE","market_name":"V20","codename":"elsa","model":"LG-US996"},{"manufacturer":"LGE","market_name":"V20","codename":"elsa","model":"LGV34"},{"manufacturer":"LGE","market_name":"V20","codename":"elsa","model":"VS995"},{"manufacturer":"LGE","market_name":"V20 PRO","codename":"L-01J","model":"L-01J"},{"manufacturer":"LGE","market_name":"V30","codename":"joan","model":"LG-AS998"},{"manufacturer":"LGE","market_name":"V30","codename":"joan","model":"LG-H930"},{"manufacturer":"LGE","market_name":"V30","codename":"joan","model":"LG-H931"},{"manufacturer":"LGE","market_name":"V30","codename":"joan","model":"LG-H932"},{"manufacturer":"LGE","market_name":"V30","codename":"joan","model":"LG-H932PR"},{"manufacturer":"LGE","market_name":"V30","codename":"joan","model":"LG-H933"},{"manufacturer":"LGE","market_name":"V30","codename":"joan","model":"LG-LS998"},{"manufacturer":"LGE","market_name":"V30","codename":"joan","model":"LG-US998"},{"manufacturer":"LGE","market_name":"V30","codename":"joan","model":"LGM-V300K"},{"manufacturer":"LGE","market_name":"V30","codename":"joan","model":"LGM-V300L"},{"manufacturer":"LGE","market_name":"V30","codename":"joan","model":"LGM-V300S"},{"manufacturer":"LGE","market_name":"V30","codename":"joan","model":"VS996"},{"manufacturer":"LGE","market_name":"V30+","codename":"L-01K","model":"L-01K"},{"manufacturer":"LGE","market_name":"V30+","codename":"joan","model":"LGV35"},{"manufacturer":"LGE","market_name":"VU3","codename":"vu3","model":"LG-F300K"},{"manufacturer":"LGE","market_name":"VU3","codename":"vu3","model":"LG-F300L"},{"manufacturer":"LGE","market_name":"VU3","codename":"vu3","model":"LG-F300S"},{"manufacturer":"LGE","market_name":"WM-LG8200","codename":"b6","model":"LG-V425"},{"manufacturer":"LGE","market_name":"WM-LG8200","codename":"b6","model":"WM-LG8200"},{"manufacturer":"LGE","market_name":"Wine Smart","codename":"cf","model":"LGS01"},{"manufacturer":"LGE","market_name":"Wine Smart","codename":"vfp","model":"LG-D486"},{"manufacturer":"LGE","market_name":"Wine Smart","codename":"vfp","model":"LG-F480K"},{"manufacturer":"LGE","market_name":"Wine Smart","codename":"vfp","model":"LG-F480L"},{"manufacturer":"LGE","market_name":"Wine Smart","codename":"vfp","model":"LG-F480S"},{"manufacturer":"LGE","market_name":"Wine Smart 3G","codename":"vfp3g","model":"LG-T480K"},{"manufacturer":"LGE","market_name":"Wine Smart 3G","codename":"vfp3g","model":"LG-T480S"},{"manufacturer":"LGE","market_name":"X Mach","codename":"sjr","model":"LG-K600"},{"manufacturer":"LGE","market_name":"X charge","codename":"mlv7","model":"LG-SP320"},{"manufacturer":"LGE","market_name":"X4","codename":"cv3n","model":"LM-X410K"},{"manufacturer":"LGE","market_name":"X4","codename":"cv3n","model":"LM-X415K"},{"manufacturer":"LGE","market_name":"X4+","codename":"cv3n","model":"LM-X410L"},{"manufacturer":"LGE","market_name":"X4+","codename":"cv3n","model":"LM-X410S"},{"manufacturer":"LGE","market_name":"X4+","codename":"cv3n","model":"LM-X415L"},{"manufacturer":"LGE","market_name":"X4+","codename":"cv3n","model":"LM-X415S"},{"manufacturer":"LGE","market_name":"Y25","codename":"y25","model":"LGL15G"},{"manufacturer":"LGE","market_name":"Y25","codename":"y25c","model":"LGL16C"},{"manufacturer":"LGE","market_name":"ZONE4","codename":"cv1","model":"LM-X210VPP"},{"manufacturer":"LGE","market_name":"Zone3","codename":"e1q","model":"VS425PP"},{"manufacturer":"LGU+","market_name":"TV G","codename":"smartbox","model":"TI320-DU"},{"manufacturer":"LGU+","market_name":"U+ tv UHD","codename":"tvg2","model":"ST940I-UP"},{"manufacturer":"LGU+","market_name":"U+ tv woofer","codename":"hg2","model":"LAP250U"},{"manufacturer":"LGU+","market_name":"U+ tv woofer 1.5","codename":"hg2_iot","model":"LAP255U"},{"manufacturer":"LGU+","market_name":"U+tv UHD2","codename":"tvg2a","model":"S60UPI"},{"manufacturer":"LGU+","market_name":"U+tv soundbar","codename":"woofer2","model":"S60UPA"},{"manufacturer":"LGU+","market_name":"WA-U420D","codename":"WA-U420D","model":"WA-U420D"},{"manufacturer":"LIAONING YIYATONG","market_name":"DISNEY_Tablet_PC","codename":"DISNEY_Tablet_PC","model":"DS2310-70LP"},{"manufacturer":"LIAONING YIYATONG","market_name":"IRULU_MID","codename":"IRULU_MID","model":"X10"},{"manufacturer":"LINSAY","market_name":"F-7HD2CORE / F-7HD4CORE / F-10HD2CORE /F-10XHD4CORE","codename":"F-7HD2CORE","model":"LINSAY F-7HD2CORE/F-7HD4CORE/F-10HD2CORE/F-10XHD4CORE"},{"manufacturer":"LT Electronics","market_name":"LT_C2100","codename":"LT_C2100","model":"LT_C2100"},{"manufacturer":"LT Electronics","market_name":"LT_C2200","codename":"LT_C2200","model":"LT C2200"},{"manufacturer":"LT Electronics","market_name":"LT_C3300","codename":"LT_C3300","model":"LT_C3300"},{"manufacturer":"LT Electronics","market_name":"LT_S9_NOTE","codename":"LT_S9_NOTE","model":"LT_S9_NOTE"},{"manufacturer":"LT Electronics","market_name":"LT_X5","codename":"LT_X5","model":"LT_X5"},{"manufacturer":"LUVO","market_name":"001","codename":"luvo_001","model":"Luvo 001"},{"manufacturer":"LUVO","market_name":"001L","codename":"LUVO-001L","model":"LUVO 001L"},{"manufacturer":"LUXYA","market_name":"MID704DC Tablet / Bitmore Tab770","codename":"MY7317P","model":"MID704DC"},{"manufacturer":"Laiq","market_name":"GLAM","codename":"LAIQ_Glam","model":"LAIQ Glam"},{"manufacturer":"Laiq","market_name":"Glow","codename":"Glow","model":"Glow"},{"manufacturer":"Laiq","market_name":"STARTRAIL 8","codename":"STARTRAIL","model":"STARTRAIL 8"},{"manufacturer":"Lamborghini","market_name":"SDIS1","codename":"sdis1","model":"Lamborghini tablet"},{"manufacturer":"Land Rover","market_name":"Explore","codename":"LRExplore","model":"Land Rover Explore"},{"manufacturer":"Lanix","market_name":"Alpha_950","codename":"Alpha_950","model":"Alpha 950"},{"manufacturer":"Lanix","market_name":"Alpha_950XL","codename":"Alpha_950XL","model":"Alpha 950XL"},{"manufacturer":"Lanix","market_name":"ILIUM L1000","codename":"Ilium_L1000","model":"ILIUM L1000"},{"manufacturer":"Lanix","market_name":"ILIUM L1000","codename":"Ilium_L1000","model":"Ilium_L1000"},{"manufacturer":"Lanix","market_name":"ILIUM L200","codename":"ILIUM_L200","model":"ILIUM L200"},{"manufacturer":"Lanix","market_name":"ILIUM L820","codename":"Ilium_L820","model":"Ilium L820"},{"manufacturer":"Lanix","market_name":"ILIUM L900","codename":"Ilium_L900","model":"ILIUM L900"},{"manufacturer":"Lanix","market_name":"ILIUM L950","codename":"Ilium_L950","model":"ILIUM L950"},{"manufacturer":"Lanix","market_name":"ILIUM L950","codename":"Ilium_L950","model":"Ilium_L950"},{"manufacturer":"Lanix","market_name":"ILIUM PAD E10Si","codename":"iLium_Pad_E10Si_1","model":"ILIUM PAD E10Si"},{"manufacturer":"Lanix","market_name":"ILIUM PAD E8 V6","codename":"IliumPAD_E8v6","model":"ILIUM PAD E8 V6"},{"manufacturer":"Lanix","market_name":"ILIUM PAD I8","codename":"Ilium_Padi8v3","model":"ilium PAD i8 v3"},{"manufacturer":"Lanix","market_name":"ILIUM S670","codename":"Ilium_S670","model":"ILIUM S670"},{"manufacturer":"Lanix","market_name":"ILIUM X110","codename":"ILIUM_X110","model":"ILIUM X110"},{"manufacturer":"Lanix","market_name":"Ilium Alpha 3","codename":"Ilium_Alpha_3","model":"Ilium Alpha 3"},{"manufacturer":"Lanix","market_name":"Ilium L1050","codename":"Ilium_L1050","model":"Ilium L1050"},{"manufacturer":"Lanix","market_name":"Ilium L1100","codename":"ILIUM_L1100","model":"ILIUM L1100"},{"manufacturer":"Lanix","market_name":"Ilium L1120","codename":"Ilium_L1120","model":"Ilium L1120"},{"manufacturer":"Lanix","market_name":"Ilium L1200","codename":"Ilium_L1200","model":"Ilium L1200"},{"manufacturer":"Lanix","market_name":"Ilium L1300","codename":"Ilium_L1300","model":"Ilium L1300"},{"manufacturer":"Lanix","market_name":"Ilium L1400","codename":"Ilium_L1400","model":"Ilium L1400"},{"manufacturer":"Lanix","market_name":"Ilium L420","codename":"Ilium_L420","model":"Ilium L420"},{"manufacturer":"Lanix","market_name":"Ilium L420","codename":"Ilium_L420","model":"Lanix Ilium L420"},{"manufacturer":"Lanix","market_name":"Ilium L610","codename":"Ilium_L610","model":"Ilium L610"},{"manufacturer":"Lanix","market_name":"Ilium L620","codename":"Ilium_L620","model":"Ilium L620"},{"manufacturer":"Lanix","market_name":"Ilium L920","codename":"Ilium_L920","model":"Ilium L920"},{"manufacturer":"Lanix","market_name":"Ilium LT500","codename":"Ilium_LT500","model":"Ilium LT500"},{"manufacturer":"Lanix","market_name":"Ilium LT510","codename":"Ilium_LT510","model":"Ilium LT510"},{"manufacturer":"Lanix","market_name":"Ilium LT520","codename":"Ilium_LT520","model":"Ilium LT520"},{"manufacturer":"Lanix","market_name":"Ilium M1","codename":"Ilium_M1","model":"Ilium M1"},{"manufacturer":"Lanix","market_name":"Ilium M3","codename":"Ilium_M3","model":"Ilium M3"},{"manufacturer":"Lanix","market_name":"Ilium M5","codename":"Ilium_M5","model":"Ilium M5"},{"manufacturer":"Lanix","market_name":"Ilium M7","codename":"Ilium_M7","model":"Ilium M7"},{"manufacturer":"Lanix","market_name":"Ilium M9","codename":"Ilium_M9","model":"Ilium M9"},{"manufacturer":"Lanix","market_name":"Ilium PAD i7","codename":"ILIUM_PADi7","model":"Ilium PAD i7"},{"manufacturer":"Lanix","market_name":"Ilium PAD i7 v2","codename":"ILIUM_PADi7V2","model":"Ilium PAD i7 v2"},{"manufacturer":"Lanix","market_name":"Ilium Pad L8X","codename":"Ilium_Pad_L8X","model":"Ilium Pad L8X"},{"manufacturer":"Lanix","market_name":"Ilium Pad T7X","codename":"Ilium_Pad_T7X","model":"Ilium Pad T7X"},{"manufacturer":"Lanix","market_name":"Ilium X110","codename":"ILIUM_X110","model":"Ilium X110"},{"manufacturer":"Lanix","market_name":"Ilium X120","codename":"Ilium_X120","model":"Ilium X120"},{"manufacturer":"Lanix","market_name":"Ilium X120B","codename":"Ilium_X120B","model":"Ilium X120B"},{"manufacturer":"Lanix","market_name":"Ilium X200","codename":"Ilium_X200","model":"Ilium X200"},{"manufacturer":"Lanix","market_name":"Ilium X210","codename":"Ilium_X210","model":"Ilium X210"},{"manufacturer":"Lanix","market_name":"Ilium X220","codename":"Ilium_X220","model":"Ilium X220"},{"manufacturer":"Lanix","market_name":"Ilium X260","codename":"Ilium_X260","model":"Ilium X260"},{"manufacturer":"Lanix","market_name":"Ilium X500B","codename":"Ilium_X500B","model":"Ilium X500B"},{"manufacturer":"Lanix","market_name":"Ilium X510","codename":"Ilium_X510","model":"Ilium X510"},{"manufacturer":"Lanix","market_name":"Ilium X520","codename":"Ilium_X520","model":"Ilium X520"},{"manufacturer":"Lanix","market_name":"Ilium X710","codename":"Ilium_X710","model":"Ilium X710"},{"manufacturer":"Lanix","market_name":"Ilium_L1100","codename":"Ilium_L1100","model":"ILIUM L1100"},{"manufacturer":"Lanix","market_name":"Ilium_S130","codename":"Ilium_S130","model":"Ilium S130"},{"manufacturer":"Lanix","market_name":"Ilium_S130","codename":"Ilium_S130","model":"Ilium_S130"},{"manufacturer":"Lanix","market_name":"Ilium_S520","codename":"Ilium_S520","model":"ILIUM S520"},{"manufacturer":"Lanix","market_name":"Llium L910","codename":"Ilium_L910","model":"Ilium L910"},{"manufacturer":"Lanix","market_name":"X100","codename":"ILIUM_X100","model":"ILIUM_X100"},{"manufacturer":"Lanix","market_name":"X400","codename":"Ilium_X400","model":"ILIUM X400"},{"manufacturer":"Lanix","market_name":"ilium  PAD  E9","codename":"ILium_PADE9","model":"ilium PAD E9"},{"manufacturer":"Lanix","market_name":"ilium PAD E7","codename":"ILIUM_PADE7","model":"ilium PAD E7"},{"manufacturer":"Lanix","market_name":"ilium PAD E8","codename":"ILIUM_PADE8","model":"ilium PAD E8"},{"manufacturer":"Lanix","market_name":"ilium PAD E9","codename":"ilium_PAD_E9","model":"ilium Pad E9"},{"manufacturer":"Lanix","market_name":"ilium PAD i7","codename":"Ilium_PAD_i7","model":"Ilium_PAD_i7"},{"manufacturer":"Lanix","market_name":"ilium Pad E7","codename":"ilium_Pad_E7","model":"ilium_Pad_E7"},{"manufacturer":"Lanix","market_name":"ilium_S106","codename":"Ilium_S106","model":"Ilium S106"},{"manufacturer":"Lanix","market_name":"llium Pad L8","codename":"llium_Pad_L8","model":"llium Pad L8"},{"manufacturer":"Lark","market_name":"Cumulus 5 HD","codename":"Cumulus_5_HD","model":"Cumulus_5_HD"},{"manufacturer":"Lark","market_name":"Cumulus 5.5 HD","codename":"Cumulus_55_HD","model":"Cumulus_5.5_HD"},{"manufacturer":"Lark","market_name":"Cumulus 6 HD","codename":"Cumulus_6_HD","model":"Cumulus_6_HD"},{"manufacturer":"Lark","market_name":"Impress_Noda","codename":"Impress_Noda","model":"Impress_Noda"},{"manufacturer":"Lark","market_name":"PHABLET 7","codename":"PHABLET7","model":"PHABLET 7"},{"manufacturer":"Lark","market_name":"Ultimate X4 10.1 3G IPS","codename":"UltimateX41013GIPS","model":"Ultimate X4 10.1 3G IPS"},{"manufacturer":"Lark","market_name":"Ultimate X4 8s 3G","codename":"UltimateX48s3G","model":"Ultimate X4 8s 3G"},{"manufacturer":"Laser","market_name":"MID-1090IPS","codename":"MID-1090IPS","model":"MID-1090IPS"},{"manufacturer":"Laser","market_name":"MID-787","codename":"MID-787","model":"MID-787"},{"manufacturer":"Lava","market_name":"A1","codename":"LAVAA1","model":"LAVAA1"},{"manufacturer":"Lava","market_name":"A3","codename":"LAVA_A3","model":"LAVA_A3"},{"manufacturer":"Lava","market_name":"A3_mini","codename":"A3_mini","model":"A3_mini"},{"manufacturer":"Lava","market_name":"A44","codename":"LAVA_A44","model":"LAVA_A44"},{"manufacturer":"Lava","market_name":"A50","codename":"A50","model":"A50"},{"manufacturer":"Lava","market_name":"A52","codename":"A52","model":"A52"},{"manufacturer":"Lava","market_name":"A55","codename":"A55","model":"A55"},{"manufacturer":"Lava","market_name":"A67","codename":"A67","model":"A67"},{"manufacturer":"Lava","market_name":"A68","codename":"A68","model":"A68"},{"manufacturer":"Lava","market_name":"A71","codename":"A71","model":"A71"},{"manufacturer":"Lava","market_name":"A72","codename":"A72","model":"A72"},{"manufacturer":"Lava","market_name":"A73","codename":"A73","model":"A73"},{"manufacturer":"Lava","market_name":"A76Plus","codename":"A76Plus","model":"A76Plus"},{"manufacturer":"Lava","market_name":"A76plus","codename":"A76Plus","model":"A76Plus"},{"manufacturer":"Lava","market_name":"A77","codename":"A77","model":"A77"},{"manufacturer":"Lava","market_name":"A79","codename":"LA79","model":"A79"},{"manufacturer":"Lava","market_name":"A82","codename":"LA82","model":"A82"},{"manufacturer":"Lava","market_name":"A89","codename":"A89","model":"Lava A89"},{"manufacturer":"Lava","market_name":"A97","codename":"A97","model":"A97"},{"manufacturer":"Lava","market_name":"A97","codename":"A97","model":"A97 IPS"},{"manufacturer":"Lava","market_name":"A97 2GB","codename":"A97_2GB","model":"A97 2GB"},{"manufacturer":"Lava","market_name":"A97 2GB Plus","codename":"A97_2GB_PLUS","model":"A97 2GB PLUS"},{"manufacturer":"Lava","market_name":"ERA 1X","codename":"era1X","model":"era1X"},{"manufacturer":"Lava","market_name":"ERA 1X","codename":"era1X","model":"era1Xpro"},{"manufacturer":"Lava","market_name":"Era 2X 3GB","codename":"XE2X3GB","model":"Era 2X 3GB"},{"manufacturer":"Lava","market_name":"Era 4G","codename":"era_4G","model":"era_4G"},{"manufacturer":"Lava","market_name":"Flair P3","codename":"P3","model":"P3"},{"manufacturer":"Lava","market_name":"Flair S1","codename":"S1","model":"S1"},{"manufacturer":"Lava","market_name":"Iris 505","codename":"iris505","model":"iris505"},{"manufacturer":"Lava","market_name":"Iris820","codename":"iris820","model":"iris820"},{"manufacturer":"Lava","market_name":"P7","codename":"P7","model":"P7"},{"manufacturer":"Lava","market_name":"P7 Plus","codename":"P7plus","model":"P7plus"},{"manufacturer":"Lava","market_name":"P7plus","codename":"P7plus","model":"P7plus"},{"manufacturer":"Lava","market_name":"Pixel V1","codename":"PixelV1G_sprout","model":"PixelV1"},{"manufacturer":"Lava","market_name":"Pixel V1","codename":"PixelV1_sprout","model":"PixelV1"},{"manufacturer":"Lava","market_name":"R1","codename":"LAVA_R1","model":"LAVA_R1"},{"manufacturer":"Lava","market_name":"R1LITE","codename":"R1_Lite","model":"R1_Lite"},{"manufacturer":"Lava","market_name":"R2","codename":"R2","model":"R2"},{"manufacturer":"Lava","market_name":"T71","codename":"T71","model":"T71"},{"manufacturer":"Lava","market_name":"V2 3GB","codename":"V23GB","model":"V23GB"},{"manufacturer":"Lava","market_name":"V2s","codename":"V2s","model":"V2s"},{"manufacturer":"Lava","market_name":"V2s","codename":"V2s","model":"V2s M"},{"manufacturer":"Lava","market_name":"V5","codename":"V5","model":"LAVA V5"},{"manufacturer":"Lava","market_name":"V5","codename":"V5","model":"V5"},{"manufacturer":"Lava","market_name":"X10","codename":"X10","model":"LavaX10"},{"manufacturer":"Lava","market_name":"X10","codename":"X10","model":"X10"},{"manufacturer":"Lava","market_name":"X11","codename":"X11","model":"X11"},{"manufacturer":"Lava","market_name":"X12","codename":"X12","model":"X12"},{"manufacturer":"Lava","market_name":"X17","codename":"X17","model":"X17"},{"manufacturer":"Lava","market_name":"X19","codename":"X19","model":"X19"},{"manufacturer":"Lava","market_name":"X28","codename":"X28","model":"X28"},{"manufacturer":"Lava","market_name":"X28 Plus","codename":"X28_plus","model":"X28 Plus"},{"manufacturer":"Lava","market_name":"X28plus","codename":"X28_plus","model":"X28 Plus"},{"manufacturer":"Lava","market_name":"X3","codename":"X3","model":"X3"},{"manufacturer":"Lava","market_name":"X38","codename":"X38","model":"X38"},{"manufacturer":"Lava","market_name":"X38 2GB","codename":"X382GB","model":"X38 2GB"},{"manufacturer":"Lava","market_name":"X41","codename":"X41","model":"X41"},{"manufacturer":"Lava","market_name":"X41Plus","codename":"X41_Plus","model":"X41 Plus"},{"manufacturer":"Lava","market_name":"X46","codename":"LX46","model":"X46"},{"manufacturer":"Lava","market_name":"X50","codename":"X50","model":"X50"},{"manufacturer":"Lava","market_name":"X50 Plus","codename":"X50_Plus","model":"X50 Plus"},{"manufacturer":"Lava","market_name":"X81","codename":"X81","model":"X81"},{"manufacturer":"Lava","market_name":"XOLO LT900","codename":"LT900","model":"LT900"},{"manufacturer":"Lava","market_name":"XOLO One HD","codename":"XOLO_One_HD","model":"XOLO One HD"},{"manufacturer":"Lava","market_name":"XOLO era 4K","codename":"XOLO_era_4K","model":"era 4K"},{"manufacturer":"Lava","market_name":"Xolo Era 2X","codename":"XE2X","model":"Era 2X"},{"manufacturer":"Lava","market_name":"Xolo Era X","codename":"era_X","model":"era_X"},{"manufacturer":"Lava","market_name":"Xolo era 2","codename":"era_2","model":"era 2"},{"manufacturer":"Lava","market_name":"Z10","codename":"LAVA_Z10","model":"Z10"},{"manufacturer":"Lava","market_name":"Z25","codename":"Z25","model":"Z25"},{"manufacturer":"Lava","market_name":"Z50","codename":"Z50","model":"Z50"},{"manufacturer":"Lava","market_name":"Z60","codename":"Z60","model":"Z60"},{"manufacturer":"Lava","market_name":"Z70","codename":"Z70","model":"Z70"},{"manufacturer":"Lava","market_name":"Z80","codename":"Z80","model":"Z80"},{"manufacturer":"Lava","market_name":"Z90","codename":"Z90","model":"Z90"},{"manufacturer":"Lava","market_name":"Z91","codename":"Z91","model":"Z91"},{"manufacturer":"Lava","market_name":"iris 821","codename":"iris821","model":"iris821"},{"manufacturer":"Lava","market_name":"iris 880","codename":"iris880","model":"iris880"},{"manufacturer":"Lava","market_name":"iris Fuel F2","codename":"IFF2","model":"Fuel F2"},{"manufacturer":"Lava","market_name":"iris atom","codename":"A1","model":"A1"},{"manufacturer":"Lava","market_name":"iris atom 3","codename":"A3","model":"A3"},{"manufacturer":"Lava","market_name":"iris30","codename":"iris30","model":"iris30"},{"manufacturer":"Lava","market_name":"iris40","codename":"iris40","model":"iris40"},{"manufacturer":"Lava","market_name":"iris50","codename":"iris50","model":"iris50"},{"manufacturer":"Lava","market_name":"iris512","codename":"iris512","model":"iris512"},{"manufacturer":"Lava","market_name":"iris515","codename":"iris515","model":"iris515"},{"manufacturer":"Lava","market_name":"iris53","codename":"iris53","model":"iris53"},{"manufacturer":"Lava","market_name":"iris560","codename":"iris560","model":"iris560"},{"manufacturer":"Lava","market_name":"iris565","codename":"iris565","model":"iris565"},{"manufacturer":"Lava","market_name":"iris60","codename":"iris60","model":"iris60"},{"manufacturer":"Lava","market_name":"iris605","codename":"iris605","model":"iris605"},{"manufacturer":"Lava","market_name":"iris702","codename":"iris702","model":"iris702"},{"manufacturer":"Lava","market_name":"iris80","codename":"iris80","model":"iris80"},{"manufacturer":"Lava","market_name":"iris870","codename":"iris870","model":"iris870"},{"manufacturer":"Lazer","market_name":"MD1005 Tablet","codename":"MD1005","model":"MD1005"},{"manufacturer":"Lazer","market_name":"MID9526CM","codename":"MID9526CM","model":"S952"},{"manufacturer":"Lazer","market_name":"MW-7615P","codename":"MW-7615P","model":"MW-7615P"},{"manufacturer":"Lazer","market_name":"MW6617","codename":"MW6617","model":"MW6617"},{"manufacturer":"Lazer","market_name":"MY1306P","codename":"MY1306P","model":"MY1306P"},{"manufacturer":"Lazer","market_name":"X4508","codename":"X4508","model":"X4508"},{"manufacturer":"Le","market_name":"LeTV X40","codename":"X4_40","model":"X4-40"},{"manufacturer":"Le Pan","market_name":"TC1010","codename":"FG6A-LP","model":"Le Pan TC1010"},{"manufacturer":"Le Pan","market_name":"TC1020","codename":"FG6Q","model":"Le Pan TC1020"},{"manufacturer":"Le Pan","market_name":"TC802A","codename":"UY8","model":"Le Pan TC802A"},{"manufacturer":"LeTV","market_name":"Le 2","codename":"le_s2","model":"Le X520"},{"manufacturer":"LeTV","market_name":"Le 2","codename":"le_s2_ww","model":"Le X526"},{"manufacturer":"LeTV","market_name":"Le 2","codename":"le_s2_ww","model":"Le X527"},{"manufacturer":"LeTV","market_name":"Le Max","codename":"max1_in","model":"Le Max"},{"manufacturer":"LeTV","market_name":"Le X507","codename":"X3_HK","model":"Le X507"},{"manufacturer":"LeTV","market_name":"Le X507","codename":"X3_HK","model":"Le X509"},{"manufacturer":"LeTV","market_name":"Le X509","codename":"X3_HK","model":"Le X509"},{"manufacturer":"LeTV","market_name":"Le1","codename":"Le1","model":"x600"},{"manufacturer":"LeTV","market_name":"Max3-65","codename":"L653AN_US","model":"Max3-65"},{"manufacturer":"LeTV","market_name":"Super TV X3-55 Pro","codename":"L553AN_US","model":"X3-55 Pro"},{"manufacturer":"LeTV","market_name":"uMax85","codename":"DemeterDV","model":"uMax85"},{"manufacturer":"LeTV","market_name":"x600","codename":"x600","model":"X600"},{"manufacturer":"Leagoo","market_name":"KIICAA MIX","codename":"KIICAA_MIX","model":"KIICAA MIX"},{"manufacturer":"Leagoo","market_name":"KIICAA POWER","codename":"KIICAA_POWER","model":"KIICAA POWER"},{"manufacturer":"Leagoo","market_name":"M9","codename":"M9","model":"M9"},{"manufacturer":"Leagoo","market_name":"M9 Pro","codename":"M9_Pro","model":"M9 Pro"},{"manufacturer":"Leagoo","market_name":"Power 5","codename":"Power_5","model":"Power 5"},{"manufacturer":"Leagoo","market_name":"S9","codename":"S9","model":"S9"},{"manufacturer":"Leagoo","market_name":"T5","codename":"T5","model":"T5"},{"manufacturer":"Leagoo","market_name":"Z7","codename":"Z7","model":"Z7"},{"manufacturer":"Lechpol","market_name":"LIVE 4 KM0438","codename":"LIVE4_KM0438","model":"LIVE4_KM0438"},{"manufacturer":"Lechpol","market_name":"LIVE 4 KM0439","codename":"LIVE4_KM0439","model":"KrugerMatz_LIVE4"},{"manufacturer":"Lechpol","market_name":"LIVE 4 KM0439","codename":"LIVE4_KM0439","model":"LIVE4_KM0439"},{"manufacturer":"Lechpol","market_name":"MOVE 6 mini","codename":"MOVE_6_mini","model":"MOVE_6_mini"},{"manufacturer":"Leeco","market_name":"Le Max2","codename":"le_x2","model":"Le X820"},{"manufacturer":"Leeco","market_name":"Le Max2","codename":"le_x2","model":"Le X821"},{"manufacturer":"Leeco","market_name":"Le Max2","codename":"le_x2_na","model":"Le X829"},{"manufacturer":"Leeco","market_name":"Le Pro3","codename":"le_zl1","model":"LEX725"},{"manufacturer":"Leeco","market_name":"Le Pro3","codename":"le_zl1","model":"LEX727"},{"manufacturer":"Leeco","market_name":"Le S3","codename":"le_s2_na","model":"Le X522"},{"manufacturer":"Leeco","market_name":"Le s2","codename":"le_s2","model":"Le X520"},{"manufacturer":"Leeco","market_name":"LePro3","codename":"le_zl1","model":"LEX725"},{"manufacturer":"Leeco","market_name":"LePro3","codename":"le_zl1","model":"LEX727"},{"manufacturer":"Leeco","market_name":"LeoPro3","codename":"le_zl1","model":"LEX725"},{"manufacturer":"Lenovo","market_name":"","codename":"18382AU","model":"ThinkPad Tablet"},{"manufacturer":"Lenovo","market_name":"","codename":"A1_07","model":"A1_07"},{"manufacturer":"Lenovo","market_name":"","codename":"A2109A","model":"IdeaTabA2109A"},{"manufacturer":"Lenovo","market_name":"","codename":"A2207A-H","model":"IdeaTabA2207A-H"},{"manufacturer":"Lenovo","market_name":"","codename":"A278t","model":"Lenovo A278t"},{"manufacturer":"Lenovo","market_name":"","codename":"A288t","model":"Lenovo A288t"},{"manufacturer":"Lenovo","market_name":"","codename":"A298t","model":"Lenovo A298t"},{"manufacturer":"Lenovo","market_name":"","codename":"A30t","model":"A30t"},{"manufacturer":"Lenovo","market_name":"","codename":"A530_msm7627a_alps","model":"Lenovo A530"},{"manufacturer":"Lenovo","market_name":"","codename":"A560e_msm7627a","model":"LNV-Lenovo_A560e"},{"manufacturer":"Lenovo","market_name":"","codename":"A580","model":"Lenovo A580"},{"manufacturer":"Lenovo","market_name":"","codename":"A600e_msm8625","model":"LNV-Lenovo A600e"},{"manufacturer":"Lenovo","market_name":"","codename":"A60plus","model":"Lenovo A60+"},{"manufacturer":"Lenovo","market_name":"","codename":"A630","model":"Lenovo A630"},{"manufacturer":"Lenovo","market_name":"","codename":"A660","model":"Lenovo A660"},{"manufacturer":"Lenovo","market_name":"","codename":"A668t","model":"Lenovo A668t"},{"manufacturer":"Lenovo","market_name":"","codename":"A690","model":"Lenovo A690"},{"manufacturer":"Lenovo","market_name":"","codename":"A700e","model":"Lenovo A700e"},{"manufacturer":"Lenovo","market_name":"","codename":"A710e_msm7627a","model":"Lenovo A710e"},{"manufacturer":"Lenovo","market_name":"","codename":"A780_msm7627a","model":"Lenovo A780"},{"manufacturer":"Lenovo","market_name":"","codename":"A789","model":"Lenovo A789"},{"manufacturer":"Lenovo","market_name":"","codename":"A798t","model":"Lenovo A798t"},{"manufacturer":"Lenovo","market_name":"","codename":"A800","model":"Lenovo A800"},{"manufacturer":"Lenovo","market_name":"","codename":"Android","model":"Lenovo A60+"},{"manufacturer":"Lenovo","market_name":"","codename":"K1","model":"K1"},{"manufacturer":"Lenovo","market_name":"","codename":"K2110A-F","model":"IdeaTab K2110A-F"},{"manufacturer":"Lenovo","market_name":"","codename":"LIFETAB_S9512","model":"LIFETAB_S9512"},{"manufacturer":"Lenovo","market_name":"","codename":"Lenovo_S2","model":"Lenovo S2-38AH0"},{"manufacturer":"Lenovo","market_name":"","codename":"MD_LIFETAB_P9516","model":"MD_LIFETAB_P9516"},{"manufacturer":"Lenovo","market_name":"","codename":"P700i","model":"Lenovo P700i"},{"manufacturer":"Lenovo","market_name":"","codename":"P770","model":"Lenovo P770"},{"manufacturer":"Lenovo","market_name":"","codename":"S2005A-H","model":"S2005A-H"},{"manufacturer":"Lenovo","market_name":"","codename":"S2109A","model":"IdeaTabS2109A-F"},{"manufacturer":"Lenovo","market_name":"","codename":"S560","model":"Lenovo S560"},{"manufacturer":"Lenovo","market_name":"","codename":"S880i","model":"Lenovo S880i"},{"manufacturer":"Lenovo","market_name":"","codename":"S890","model":"Lenovo S890"},{"manufacturer":"Lenovo","market_name":"","codename":"S899t","model":"Lenovo S899t"},{"manufacturer":"Lenovo","market_name":"","codename":"S920_ROW","model":"Lenovo S920"},{"manufacturer":"Lenovo","market_name":"","codename":"S920_ROW","model":"Lenovo S920_ROW"},{"manufacturer":"Lenovo","market_name":"","codename":"SmartTabII7","model":"SmartTabII7"},{"manufacturer":"Lenovo","market_name":"","codename":"T702T","model":"A66t"},{"manufacturer":"Lenovo","market_name":"","codename":"a2_3g_data","model":"IdeaTab A2107A-H"},{"manufacturer":"Lenovo","market_name":"","codename":"a2_wifi","model":"IdeaTab A2107A-F"},{"manufacturer":"Lenovo","market_name":"","codename":"a2_wifi_row","model":"IdeaTab A2107A-F"},{"manufacturer":"Lenovo","market_name":"","codename":"a326","model":"Lenovo A326"},{"manufacturer":"Lenovo","market_name":"","codename":"a360","model":"Lenovo A360"},{"manufacturer":"Lenovo","market_name":"","codename":"a370","model":"Lenovo A370"},{"manufacturer":"Lenovo","market_name":"","codename":"a500plus","model":"Lenovo A500+"},{"manufacturer":"Lenovo","market_name":"","codename":"a520_gray","model":"Lenovo A520GRAY"},{"manufacturer":"Lenovo","market_name":"","codename":"a59wg","model":"Lenovo A500"},{"manufacturer":"Lenovo","market_name":"","codename":"a59wg","model":"Lenovo A500+"},{"manufacturer":"Lenovo","market_name":"","codename":"a60_campus","model":"Lenovo A60"},{"manufacturer":"Lenovo","market_name":"","codename":"a60id_tel","model":"Lenovo A60"},{"manufacturer":"Lenovo","market_name":"","codename":"a60os","model":"Lenovo A60"},{"manufacturer":"Lenovo","market_name":"","codename":"a60tw","model":"Lenovo A60"},{"manufacturer":"Lenovo","market_name":"","codename":"a65","model":"Lenovo A65"},{"manufacturer":"Lenovo","market_name":"","codename":"a65_ph_id_vn","model":"Lenovo A65"},{"manufacturer":"Lenovo","market_name":"","codename":"a65cu","model":"Lenovo A65"},{"manufacturer":"Lenovo","market_name":"","codename":"amazon_w","model":"Lenovo A1-32AB0"},{"manufacturer":"Lenovo","market_name":"","codename":"apollo_td","model":"Lenovo S2-38AT0"},{"manufacturer":"Lenovo","market_name":"","codename":"apollo_wg","model":"Lenovo S2-38AH0"},{"manufacturer":"Lenovo","market_name":"","codename":"apollohd_w","model":"Lenovo K2"},{"manufacturer":"Lenovo","market_name":"","codename":"apollozero_w","model":"Lenovo S760"},{"manufacturer":"Lenovo","market_name":"","codename":"aruba","model":"Lenovo A765e"},{"manufacturer":"Lenovo","market_name":"","codename":"austin","model":"Lenovo A300"},{"manufacturer":"Lenovo","market_name":"","codename":"ideatv_S31","model":"ideatv S31"},{"manufacturer":"Lenovo","market_name":"","codename":"lenovo13_td","model":"Lenovo A366t"},{"manufacturer":"Lenovo","market_name":"","codename":"lenovo15_td_ics","model":"Lenovo A698t"},{"manufacturer":"Lenovo","market_name":"","codename":"lenovo73_cu","model":"Lenovo A60"},{"manufacturer":"Lenovo","market_name":"","codename":"lenovo73_gb","model":"Lenovo A520"},{"manufacturer":"Lenovo","market_name":"","codename":"lenovo73_gb","model":"Lenovo P70"},{"manufacturer":"Lenovo","market_name":"","codename":"lenovo75_a2_att_ics","model":"A2107A-H"},{"manufacturer":"Lenovo","market_name":"","codename":"lenovo75_a2_ics","model":"IdeaTab A2107A-H"},{"manufacturer":"Lenovo","market_name":"","codename":"lenovo75_cu_gb","model":"Lenovo A750"},{"manufacturer":"Lenovo","market_name":"","codename":"lenovo75_cu_ics","model":"Lenovo A750"},{"manufacturer":"Lenovo","market_name":"","codename":"mfld_pr2","model":"Lenovo K800"},{"manufacturer":"Lenovo","market_name":"","codename":"mi_350","model":"Spice Mi-350"},{"manufacturer":"Lenovo","market_name":"","codename":"msm7627_ea95","model":"Lenovo A390e"},{"manufacturer":"Lenovo","market_name":"","codename":"msm7627_surf","model":"A68e"},{"manufacturer":"Lenovo","market_name":"","codename":"msm7627_surf","model":"Lenovo A68e"},{"manufacturer":"Lenovo","market_name":"","codename":"msm7627a","model":"LNV-Lenovo A790e"},{"manufacturer":"Lenovo","market_name":"","codename":"msm7627a_ha99","model":"Lenovo A780"},{"manufacturer":"Lenovo","market_name":"","codename":"msm8660_surf","model":"IdeaTab S2007A-F"},{"manufacturer":"Lenovo","market_name":"","codename":"msm8660_surf","model":"IdeaTab S2007A-H"},{"manufacturer":"Lenovo","market_name":"","codename":"msm8660_surf","model":"IdeaTab S2010A-D"},{"manufacturer":"Lenovo","market_name":"","codename":"msm8660_surf","model":"IdeaTab S2010A-F"},{"manufacturer":"Lenovo","market_name":"","codename":"msm8660_surf","model":"IdeaTab S2010A-H"},{"manufacturer":"Lenovo","market_name":"","codename":"msm8960","model":"IdeaTabS2110AF"},{"manufacturer":"Lenovo","market_name":"","codename":"msm8960","model":"IdeaTabS2110AH"},{"manufacturer":"Lenovo","market_name":"","codename":"msm8960","model":"SmartTabII10"},{"manufacturer":"Lenovo","market_name":"","codename":"p700","model":"Lenovo P700"},{"manufacturer":"Lenovo","market_name":"","codename":"p700_ph","model":"Lenovo P700"},{"manufacturer":"Lenovo","market_name":"","codename":"s880","model":"Lenovo S880"},{"manufacturer":"Lenovo","market_name":"","codename":"s880_row","model":"Lenovo S880"},{"manufacturer":"Lenovo","market_name":"","codename":"sanpaolo","model":"IdeaTabV2007A"},{"manufacturer":"Lenovo","market_name":"","codename":"santiago","model":"IdeaTabV2010A"},{"manufacturer":"Lenovo","market_name":"","codename":"santiago","model":"IdeaTabV2010A-W"},{"manufacturer":"Lenovo","market_name":"","codename":"sicily","model":"Lenovo S696"},{"manufacturer":"Lenovo","market_name":"","codename":"stuttgart_row","model":"Lenovo K860"},{"manufacturer":"Lenovo","market_name":"","codename":"ventana","model":"K1"},{"manufacturer":"Lenovo","market_name":"\\t Lenovo YOGA Laptop with Android","codename":"YOGABOOK12","model":"Lenovo YB-Q501F"},{"manufacturer":"Lenovo","market_name":"32A3   40A3   43A3   49A3","codename":"uzi","model":"LenovoTV 32A3"},{"manufacturer":"Lenovo","market_name":"60K72","codename":"ideatv_K72","model":"ideatv K72"},{"manufacturer":"Lenovo","market_name":"A10","codename":"A10","model":"IdeaPadA10"},{"manufacturer":"Lenovo","market_name":"A10-70LC","codename":"A10-70LC","model":"Lenovo TAB 2 A10-70LC"},{"manufacturer":"Lenovo","market_name":"A1000","codename":"A1000","model":"Lenovo A1000"},{"manufacturer":"Lenovo","market_name":"A1000","codename":"A1000F","model":"IdeaTabA1000-F"},{"manufacturer":"Lenovo","market_name":"A1000-G","codename":"A1000G","model":"IdeaTabA1000-G"},{"manufacturer":"Lenovo","market_name":"A1000L","codename":"A1000LF","model":"IdeaTabA1000L-F"},{"manufacturer":"Lenovo","market_name":"A1000m","codename":"scx35_sp7731gea_taichi","model":"Lenovo A1000m"},{"manufacturer":"Lenovo","market_name":"A1010","codename":"A1010a20","model":"Lenovo A1010a20"},{"manufacturer":"Lenovo","market_name":"A1900","codename":"A1900","model":"Lenovo A1900"},{"manufacturer":"Lenovo","market_name":"A2010-a","codename":"A2010-a","model":"Lenovo A2010-a"},{"manufacturer":"Lenovo","market_name":"A2010l36","codename":"A2010l36","model":"Lenovo A2010l36"},{"manufacturer":"Lenovo","market_name":"A2016a40","codename":"A2016a40","model":"Lenovo A2016a40"},{"manufacturer":"Lenovo","market_name":"A2016b30","codename":"A2016b30","model":"Lenovo A2016b30"},{"manufacturer":"Lenovo","market_name":"A2016b31","codename":"A2016b31","model":"Lenovo A2016b31"},{"manufacturer":"Lenovo","market_name":"A2020a40","codename":"angus3A4","model":"Lenovo A2020a40"},{"manufacturer":"Lenovo","market_name":"A2020a40","codename":"angus3A41","model":"Lenovo A2020a40"},{"manufacturer":"Lenovo","market_name":"A208t","codename":"A208t","model":"Lenovo A208t"},{"manufacturer":"Lenovo","market_name":"A2105","codename":"Lenovo_A2105","model":"Lenovo_A2105"},{"manufacturer":"Lenovo","market_name":"A2107A","codename":"A2107A-H","model":"A2107A-H"},{"manufacturer":"Lenovo","market_name":"A218t","codename":"A218t","model":"Lenovo A218t"},{"manufacturer":"Lenovo","market_name":"A228t","codename":"A228t","model":"Lenovo A228t"},{"manufacturer":"Lenovo","market_name":"A238t","codename":"A238t","model":"Lenovo A238t"},{"manufacturer":"Lenovo","market_name":"A2580","codename":"A2580","model":"Lenovo A2580"},{"manufacturer":"Lenovo","market_name":"A269","codename":"A269","model":"Lenovo A269"},{"manufacturer":"Lenovo","market_name":"A269i","codename":"A269i","model":"Lenovo A269i"},{"manufacturer":"Lenovo","market_name":"A278t","codename":"A278t","model":"Lenovo A278t"},{"manufacturer":"Lenovo","market_name":"A2800","codename":"A2800-d","model":"Lenovo A2800-d"},{"manufacturer":"Lenovo","market_name":"A2860","codename":"A2860","model":"Lenovo A2860"},{"manufacturer":"Lenovo","market_name":"A3000","codename":"A3000","model":"Lenovo A3000-H"},{"manufacturer":"Lenovo","market_name":"A300t","codename":"A300t","model":"Lenovo A300t"},{"manufacturer":"Lenovo","market_name":"A305E","codename":"A305e","model":"LNV-Lenovo A305e"},{"manufacturer":"Lenovo","market_name":"A305E","codename":"A305e","model":"Lenovo A305e"},{"manufacturer":"Lenovo","market_name":"A308t","codename":"A308t","model":"Lenovo A308t"},{"manufacturer":"Lenovo","market_name":"A316","codename":"A316","model":"Lenovo A316"},{"manufacturer":"Lenovo","market_name":"A316i","codename":"A316i","model":"Lenovo A316i"},{"manufacturer":"Lenovo","market_name":"A318t","codename":"A318t","model":"Lenovo A318t"},{"manufacturer":"Lenovo","market_name":"A319","codename":"A319","model":"Lenovo A319"},{"manufacturer":"Lenovo","market_name":"A31910t30","codename":"angus3T3","model":"Lenovo A3910t30"},{"manufacturer":"Lenovo","market_name":"A320t","codename":"A320t","model":"Lenovo A320t"},{"manufacturer":"Lenovo","market_name":"A328","codename":"A328","model":"Lenovo A328"},{"manufacturer":"Lenovo","market_name":"A328t","codename":"A328t","model":"Lenovo A328t"},{"manufacturer":"Lenovo","market_name":"A3300","codename":"A3300-H","model":"LenovoA3300-H"},{"manufacturer":"Lenovo","market_name":"A3300","codename":"A3300-T","model":"Lenovo A3300-T"},{"manufacturer":"Lenovo","market_name":"A3300-GV","codename":"A3300-GV","model":"LenovoA3300-GV"},{"manufacturer":"Lenovo","market_name":"A3300-HV","codename":"A3300-HV","model":"Lenovo A3300-HV"},{"manufacturer":"Lenovo","market_name":"A330e","codename":"A330e","model":"Lenovo A330e"},{"manufacturer":"Lenovo","market_name":"A338t","codename":"A338t","model":"Lenovo A338t"},{"manufacturer":"Lenovo","market_name":"A3500","codename":"A3500","model":"Lenovo A3500"},{"manufacturer":"Lenovo","market_name":"A3500","codename":"A3500HV","model":"Lenovo A3500-HV"},{"manufacturer":"Lenovo","market_name":"A3500-F","codename":"A3500F","model":"EveryPad2"},{"manufacturer":"Lenovo","market_name":"A3500-F","codename":"A3500F","model":"Lenovo A3500-F"},{"manufacturer":"Lenovo","market_name":"A3500-FL","codename":"A3500FL","model":"Lenovo A3500-FL"},{"manufacturer":"Lenovo","market_name":"A3500-H","codename":"A3500H","model":"Lenovo A3500-H"},{"manufacturer":"Lenovo","market_name":"A355e","codename":"A355e","model":"Lenovo A355e"},{"manufacturer":"Lenovo","market_name":"A358t","codename":"A358t","model":"Lenovo A358t"},{"manufacturer":"Lenovo","market_name":"A3600-D","codename":"A3600-d","model":"Lenovo A3600-d"},{"manufacturer":"Lenovo","market_name":"A3600u","codename":"A3600u","model":"Lenovo A3600u"},{"manufacturer":"Lenovo","market_name":"A360e","codename":"A360e","model":"Lenovo A360e"},{"manufacturer":"Lenovo","market_name":"A360t","codename":"A360t","model":"Lenovo A360t"},{"manufacturer":"Lenovo","market_name":"A368t","codename":"A368t","model":"Lenovo A368t"},{"manufacturer":"Lenovo","market_name":"A369","codename":"A369","model":"Lenovo A369"},{"manufacturer":"Lenovo","market_name":"A369i","codename":"A369i","model":"Lenovo A369i"},{"manufacturer":"Lenovo","market_name":"A370e","codename":"A370e","model":"LNV-Lenovo A370e"},{"manufacturer":"Lenovo","market_name":"A375e","codename":"A375e","model":"LNV-Lenovo A375e"},{"manufacturer":"Lenovo","market_name":"A376","codename":"A376","model":"Lenovo A376"},{"manufacturer":"Lenovo","market_name":"A378t","codename":"A378t","model":"Lenovo A378t"},{"manufacturer":"Lenovo","market_name":"A3800-D","codename":"A3800-d","model":"Lenovo A3800-d"},{"manufacturer":"Lenovo","market_name":"A380e","codename":"A380e","model":"LNV-Lenovo A380e"},{"manufacturer":"Lenovo","market_name":"A380t","codename":"A380t","model":"Lenovo A380t"},{"manufacturer":"Lenovo","market_name":"A385e","codename":"A385e","model":"LNV-Lenovo A385e"},{"manufacturer":"Lenovo","market_name":"A3860","codename":"A3580","model":"Lenovo A3580"},{"manufacturer":"Lenovo","market_name":"A3860","codename":"A3860","model":"Lenovo A3860"},{"manufacturer":"Lenovo","market_name":"A388t","codename":"A388t","model":"Lenovo A388t"},{"manufacturer":"Lenovo","market_name":"A390","codename":"A390","model":"Lenovo A390"},{"manufacturer":"Lenovo","market_name":"A390","codename":"A390","model":"Lenovo A390_ROW"},{"manufacturer":"Lenovo","market_name":"A3900","codename":"pxa1L88H2","model":"Lenovo A3900"},{"manufacturer":"Lenovo","market_name":"A390t","codename":"A390t","model":"Lenovo A390t"},{"manufacturer":"Lenovo","market_name":"A395e","codename":"A395e","model":"LNV-Lenovo A395e"},{"manufacturer":"Lenovo","market_name":"A396","codename":"A396","model":"Lenovo A396"},{"manufacturer":"Lenovo","market_name":"A396","codename":"A396_TY","model":"Lenovo A396_TY"},{"manufacturer":"Lenovo","market_name":"A398t","codename":"A398t","model":"Lenovo A398t"},{"manufacturer":"Lenovo","market_name":"A398t+","codename":"A398tp","model":"Lenovo A398t+"},{"manufacturer":"Lenovo","market_name":"A399","codename":"Aiken","model":"Lenovo A399"},{"manufacturer":"Lenovo","market_name":"A5000","codename":"A5000","model":"Lenovo A5000"},{"manufacturer":"Lenovo","market_name":"A505e","codename":"A505e","model":"LNV-Lenovo A505e"},{"manufacturer":"Lenovo","market_name":"A516","codename":"A516","model":"Lenovo A516"},{"manufacturer":"Lenovo","market_name":"A516","codename":"A516_ROW","model":"Lenovo A516"},{"manufacturer":"Lenovo","market_name":"A526","codename":"A526","model":"Lenovo A526"},{"manufacturer":"Lenovo","market_name":"A529","codename":"A529","model":"Lenovo A529"},{"manufacturer":"Lenovo","market_name":"A536","codename":"A536","model":"Lenovo A536"},{"manufacturer":"Lenovo","market_name":"A5500","codename":"A5500","model":"Lenovo A5500"},{"manufacturer":"Lenovo","market_name":"A5500-F","codename":"A5500-F","model":"Lenovo A5500-F"},{"manufacturer":"Lenovo","market_name":"A5500-H","codename":"A5500-H","model":"Lenovo A5500-H"},{"manufacturer":"Lenovo","market_name":"A5500-HV","codename":"A5500-HV","model":"Lenovo A5500-HV"},{"manufacturer":"Lenovo","market_name":"A560","codename":"A560_msm8212","model":"Lenovo A560"},{"manufacturer":"Lenovo","market_name":"A560","codename":"A560_msm8610","model":"LNV-Lenovo A560"},{"manufacturer":"Lenovo","market_name":"A5800-D","codename":"A5800-D","model":"Lenovo A5800-D"},{"manufacturer":"Lenovo","market_name":"A588t","codename":"LenovoA588t","model":"LenovoA588t"},{"manufacturer":"Lenovo","market_name":"A6000","codename":"Kraft-A6000","model":"Lenovo A6000"},{"manufacturer":"Lenovo","market_name":"A6000-l","codename":"Kraft-A6000-l","model":"Lenovo A6000-l"},{"manufacturer":"Lenovo","market_name":"A6010","codename":"A6010","model":"Lenovo A6010"},{"manufacturer":"Lenovo","market_name":"A606","codename":"A606","model":"Lenovo A606"},{"manufacturer":"Lenovo","market_name":"A616","codename":"A616","model":"Lenovo A616"},{"manufacturer":"Lenovo","market_name":"A628t","codename":"A628t","model":"Lenovo A628t"},{"manufacturer":"Lenovo","market_name":"A630","codename":"A630e","model":"LNV-Lenovo A630e"},{"manufacturer":"Lenovo","market_name":"A656","codename":"A656","model":"Lenovo A656"},{"manufacturer":"Lenovo","market_name":"A658T","codename":"A658t","model":"Lenovo A658t"},{"manufacturer":"Lenovo","market_name":"A6600","codename":"A6600d40","model":"Lenovo A6600d40"},{"manufacturer":"Lenovo","market_name":"A6600 Plus","codename":"A6600a40","model":"Lenovo A6600a40"},{"manufacturer":"Lenovo","market_name":"A670t","codename":"A670t","model":"Lenovo A670t"},{"manufacturer":"Lenovo","market_name":"A678t","codename":"A678t","model":"Lenovo A678t"},{"manufacturer":"Lenovo","market_name":"A680","codename":"A680","model":"Lenovo A680"},{"manufacturer":"Lenovo","market_name":"A680","codename":"A680","model":"Lenovo A680_ROW"},{"manufacturer":"Lenovo","market_name":"A6800","codename":"A6800","model":"Lenovo A6800"},{"manufacturer":"Lenovo","market_name":"A688t","codename":"A688t","model":"Lenovo A688t"},{"manufacturer":"Lenovo","market_name":"A690e","codename":"A690e","model":"LNV-Lenovo A690e"},{"manufacturer":"Lenovo","market_name":"A7-30GC","codename":"A7-30GC","model":"Lenovo TAB 2 A7-30GC"},{"manufacturer":"Lenovo","market_name":"A7-30H","codename":"A7-30H","model":"Lenovo TAB 2 A7-30D"},{"manufacturer":"Lenovo","market_name":"A7-30H","codename":"A7-30H","model":"Lenovo TAB 2 A7-30H"},{"manufacturer":"Lenovo","market_name":"A7-60HC","codename":"A760HC","model":"Lenovo A7-60HC"},{"manufacturer":"Lenovo","market_name":"A7000","codename":"A7000-a","model":"Lenovo A7000-a"},{"manufacturer":"Lenovo","market_name":"A7000 Plus","codename":"A7000plus","model":"Lenovo A7000-a"},{"manufacturer":"Lenovo","market_name":"A706","codename":"armani","model":"Lenovo A706"},{"manufacturer":"Lenovo","market_name":"A706_ROW","codename":"armani_row","model":"Lenovo A706_ROW"},{"manufacturer":"Lenovo","market_name":"A720e","codename":"andorrap","model":"Lenovo A720e"},{"manufacturer":"Lenovo","market_name":"A750e","codename":"athenae","model":"Lenovo A750e"},{"manufacturer":"Lenovo","market_name":"A760","codename":"audi","model":"Lenovo A760"},{"manufacturer":"Lenovo","market_name":"A7600","codename":"A7600","model":"Lenovo A7600"},{"manufacturer":"Lenovo","market_name":"A7600","codename":"aiocmcc_ttp","model":"Lenovo A7600-m"},{"manufacturer":"Lenovo","market_name":"A7600","codename":"aiocu_wtfp","model":"Lenovo A7600"},{"manufacturer":"Lenovo","market_name":"A7600-F","codename":"A7600-F","model":"Lenovo A7600-F"},{"manufacturer":"Lenovo","market_name":"A7600-H","codename":"A7600-H","model":"Lenovo A7600-H"},{"manufacturer":"Lenovo","market_name":"A7600-HV","codename":"A7600-HV","model":"Lenovo A7600-HV"},{"manufacturer":"Lenovo","market_name":"A766","codename":"A766","model":"Lenovo A766"},{"manufacturer":"Lenovo","market_name":"A768t","codename":"airplayt","model":"Lenovo A768t"},{"manufacturer":"Lenovo","market_name":"A7700","codename":"A7700","model":"A7700"},{"manufacturer":"Lenovo","market_name":"A7700","codename":"A7700","model":"Lenovo A7700"},{"manufacturer":"Lenovo","market_name":"A770e","codename":"athenaep","model":"Lenovo A770e"},{"manufacturer":"Lenovo","market_name":"A780e","codename":"A780e","model":"LNV-Lenovo A780e"},{"manufacturer":"Lenovo","market_name":"A785e","codename":"A785e","model":"LNV-Lenovo A785e"},{"manufacturer":"Lenovo","market_name":"A788t","codename":"A788t","model":"Lenovo A788t"},{"manufacturer":"Lenovo","market_name":"A8-50","codename":"A8-50L","model":"Lenovo TAB 2 A8-50L"},{"manufacturer":"Lenovo","market_name":"A8-50","codename":"A8-50LC","model":"Lenovo 2 A8-50LC"},{"manufacturer":"Lenovo","market_name":"A8-50","codename":"A8-50LC","model":"Lenovo TAB 2 A8-50LC"},{"manufacturer":"Lenovo","market_name":"A805e","codename":"airplayep","model":"Lenovo A805e"},{"manufacturer":"Lenovo","market_name":"A806","codename":"A806","model":"Lenovo A806"},{"manufacturer":"Lenovo","market_name":"A808t","codename":"A808t","model":"Lenovo A808t"},{"manufacturer":"Lenovo","market_name":"A808t-i","codename":"A808t-i","model":"Lenovo A808t-i"},{"manufacturer":"Lenovo","market_name":"A816","codename":"airplayw","model":"Lenovo A5100"},{"manufacturer":"Lenovo","market_name":"A816","codename":"airplayw","model":"Lenovo A816"},{"manufacturer":"Lenovo","market_name":"A820","codename":"A820","model":"Lenovo A820"},{"manufacturer":"Lenovo","market_name":"A820e","codename":"andorra","model":"Lenovo A820e"},{"manufacturer":"Lenovo","market_name":"A820t","codename":"A820t","model":"Lenovo A820t"},{"manufacturer":"Lenovo","market_name":"A828","codename":"A858","model":"Lenovo A858"},{"manufacturer":"Lenovo","market_name":"A828t","codename":"A828t","model":"Lenovo A828t"},{"manufacturer":"Lenovo","market_name":"A830","codename":"A830","model":"Lenovo A830"},{"manufacturer":"Lenovo","market_name":"A850","codename":"A850","model":"Lenovo A850"},{"manufacturer":"Lenovo","market_name":"A850","codename":"A850_ROW","model":"Lenovo A850"},{"manufacturer":"Lenovo","market_name":"A850+","codename":"A850p","model":"Lenovo A850+"},{"manufacturer":"Lenovo","market_name":"A858t","codename":"A858t","model":"Lenovo A858t"},{"manufacturer":"Lenovo","market_name":"A859","codename":"A859_ROW","model":"Lenovo A859"},{"manufacturer":"Lenovo","market_name":"A860e","codename":"artini","model":"Lenovo A860e"},{"manufacturer":"Lenovo","market_name":"A889","codename":"A889","model":"Lenovo A889"},{"manufacturer":"Lenovo","market_name":"A890e","codename":"airbuse","model":"Lenovo A890e"},{"manufacturer":"Lenovo","market_name":"A916","codename":"A916","model":"Lenovo A916"},{"manufacturer":"Lenovo","market_name":"A936","codename":"A936","model":"Lenovo A936"},{"manufacturer":"Lenovo","market_name":"A938t","codename":"A938t","model":"Lenovo A938t"},{"manufacturer":"Lenovo","market_name":"B6000-F","codename":"B6000","model":"Lenovo B6000-F"},{"manufacturer":"Lenovo","market_name":"B6000-H","codename":"B6000","model":"Lenovo B6000-H"},{"manufacturer":"Lenovo","market_name":"B6000-HV","codename":"B6000","model":"Lenovo B6000-HV"},{"manufacturer":"Lenovo","market_name":"B8000-F","codename":"B8000","model":"Lenovo B8000-F"},{"manufacturer":"Lenovo","market_name":"B8000-H","codename":"B8000","model":"Lenovo B8000-H"},{"manufacturer":"Lenovo","market_name":"B8080","codename":"B8080","model":"Lenovo B8080-F"},{"manufacturer":"Lenovo","market_name":"B8080-H","codename":"B8080","model":"Lenovo B8080-H"},{"manufacturer":"Lenovo","market_name":"B8080-HV","codename":"B8080","model":"Lenovo B8080-HV"},{"manufacturer":"Lenovo","market_name":"E4002","codename":"E4002","model":"MEDION E4002"},{"manufacturer":"Lenovo","market_name":"EveryPad","codename":"A3000","model":"EveryPad"},{"manufacturer":"Lenovo","market_name":"EveryPad","codename":"A3000","model":"IdeaTab A3000-F"},{"manufacturer":"Lenovo","market_name":"EveryPad2","codename":"A3500F","model":"EveryPad2"},{"manufacturer":"Lenovo","market_name":"IdeaTV","codename":"msm8660_surf","model":"ideatv K91"},{"manufacturer":"Lenovo","market_name":"IdeaTab A1000","codename":"A1000LF","model":"LenovoA1000L-F"},{"manufacturer":"Lenovo","market_name":"IdeaTab A1010","codename":"A1010T","model":"IdeaTabA1010-T"},{"manufacturer":"Lenovo","market_name":"IdeaTab A1020","codename":"A1020T","model":"IdeaTabA1020-T"},{"manufacturer":"Lenovo","market_name":"IdeaTab A3000","codename":"A3000","model":"IdeaTab A3000-H"},{"manufacturer":"Lenovo","market_name":"IdeaTab A3000","codename":"A3000","model":"Vodafone Smart Tab III 7"},{"manufacturer":"Lenovo","market_name":"IdeaTab A5000","codename":"A5000E","model":"IdeaTabA5000-E"},{"manufacturer":"Lenovo","market_name":"IdeaTab S6000","codename":"S6000","model":"IdeaTab S6000-F"},{"manufacturer":"Lenovo","market_name":"IdeaTab S6000","codename":"S6000","model":"IdeaTab S6000-H"},{"manufacturer":"Lenovo","market_name":"IdeaTab S6000","codename":"S6000","model":"Vodafone Smart Tab III 10"},{"manufacturer":"Lenovo","market_name":"Indigo","codename":"Indigo","model":"ThinkPad Tablet"},{"manufacturer":"Lenovo","market_name":"K1","codename":"K1","model":"K1"},{"manufacturer":"Lenovo","market_name":"K10e70","codename":"K10e70","model":"Lenovo K10e70"},{"manufacturer":"Lenovo","market_name":"K3 Note","codename":"K50a40","model":"Lenovo K50a40"},{"manufacturer":"Lenovo","market_name":"K3 Note","codename":"aio_3m_otfp_m","model":"Lenovo K50-t3s"},{"manufacturer":"Lenovo","market_name":"K3 Note","codename":"aio_otfp","model":"Lenovo K50-T5"},{"manufacturer":"Lenovo","market_name":"K3 Note","codename":"aio_otfp","model":"Lenovo K50-t5"},{"manufacturer":"Lenovo","market_name":"K30-E","codename":"Kraft-E","model":"Lenovo K30-E"},{"manufacturer":"Lenovo","market_name":"K30-T","codename":"Kraft-T","model":"Lenovo K30-T"},{"manufacturer":"Lenovo","market_name":"K30-TM","codename":"Kraft-TM","model":"Lenovo K30-TM"},{"manufacturer":"Lenovo","market_name":"K30-W","codename":"Kraft-W","model":"Lenovo K30-W"},{"manufacturer":"Lenovo","market_name":"K32","codename":"K32c36","model":"Lenovo K32c36"},{"manufacturer":"Lenovo","market_name":"K32c30","codename":"K32c30","model":"Lenovo K32c30"},{"manufacturer":"Lenovo","market_name":"K350t","codename":"K350t","model":"K350t"},{"manufacturer":"Lenovo","market_name":"K5","codename":"A6020a40","model":"Lenovo A6020a40"},{"manufacturer":"Lenovo","market_name":"K5","codename":"A6020a41","model":"Lenovo A6020a41"},{"manufacturer":"Lenovo","market_name":"K5","codename":"A6020l36","model":"Lenovo A6020l36"},{"manufacturer":"Lenovo","market_name":"K5","codename":"A6020l37","model":"Lenovo A6020l37"},{"manufacturer":"Lenovo","market_name":"K5 Note","codename":"A7020a40","model":"Lenovo A7020a40"},{"manufacturer":"Lenovo","market_name":"K5 Note","codename":"A7020a48","model":"Lenovo A7020a48"},{"manufacturer":"Lenovo","market_name":"K5 Note","codename":"k52_e78","model":"Lenovo K52e78"},{"manufacturer":"Lenovo","market_name":"K5 Note","codename":"k52_t58","model":"Lenovo K52t58"},{"manufacturer":"Lenovo","market_name":"K5 Plus","codename":"A6020a46","model":"Lenovo A6020a46"},{"manufacturer":"Lenovo","market_name":"K50","codename":"K50-t5","model":"Lenovo K50-t5"},{"manufacturer":"Lenovo","market_name":"K50","codename":"aio_3m_otfp","model":"Lenovo K50-t3s"},{"manufacturer":"Lenovo","market_name":"K50-T5","codename":"aio_otfp_m","model":"Lenovo K50-t5"},{"manufacturer":"Lenovo","market_name":"K520","codename":"seoul","model":"Lenovo K520"},{"manufacturer":"Lenovo","market_name":"K520","codename":"seoul","model":"Lenovo S680"},{"manufacturer":"Lenovo","market_name":"K52t38","codename":"k52_t38","model":"Lenovo K52t38"},{"manufacturer":"Lenovo","market_name":"K52t38","codename":"k52_t38","model":"Lenovo k52t38"},{"manufacturer":"Lenovo","market_name":"K800","codename":"K800","model":"Lenovo K800"},{"manufacturer":"Lenovo","market_name":"K80M","codename":"K80M","model":"Lenovo K80M"},{"manufacturer":"Lenovo","market_name":"K860","codename":"stuttgart","model":"Lenovo K860"},{"manufacturer":"Lenovo","market_name":"K860i","codename":"K860i","model":"Lenovo K860i"},{"manufacturer":"Lenovo","market_name":"K900","codename":"K900","model":"Lenovo K900"},{"manufacturer":"Lenovo","market_name":"K900","codename":"K900_ROW","model":"Lenovo K900_ROW"},{"manufacturer":"Lenovo","market_name":"K910","codename":"kiton","model":"Lenovo K910"},{"manufacturer":"Lenovo","market_name":"K910L","codename":"K910L","model":"Lenovo K910L"},{"manufacturer":"Lenovo","market_name":"K910e","codename":"kitone","model":"LNV-Lenovo K910e"},{"manufacturer":"Lenovo","market_name":"K910e","codename":"kitone","model":"Lenovo K910e"},{"manufacturer":"Lenovo","market_name":"K920/VIBE Z2","codename":"kingdom_row","model":"Lenovo K920"},{"manufacturer":"Lenovo","market_name":"K920/VIBE Z2 Pro","codename":"kingdomt","model":"Lenovo K920"},{"manufacturer":"Lenovo","market_name":"L38011","codename":"k5","model":"Lenovo L38011"},{"manufacturer":"Lenovo","market_name":"LIFETAB E10310","codename":"LIFETAB_E10310","model":"LIFETAB_E10310"},{"manufacturer":"Lenovo","market_name":"LIFETAB E7310","codename":"LIFETAB_E7310","model":"LIFETAB_E7310"},{"manufacturer":"Lenovo","market_name":"LIFETAB E7310","codename":"LIFETAB_E7310","model":"LIFETAB_E7312"},{"manufacturer":"Lenovo","market_name":"Lenovo","codename":"A708t","model":"Lenovo A708t"},{"manufacturer":"Lenovo","market_name":"Lenovo","codename":"A880","model":"Lenovo A880"},{"manufacturer":"Lenovo","market_name":"Lenovo","codename":"PB1-770P","model":"Lenovo PB1-770P"},{"manufacturer":"Lenovo","market_name":"Lenovo A3300","codename":"A3300-GV","model":"LenovoA3300-GV"},{"manufacturer":"Lenovo","market_name":"Lenovo A3300","codename":"A3300-HV","model":"LenovoA3300-HV"},{"manufacturer":"Lenovo","market_name":"Lenovo K8","codename":"brady_f","model":"Lenovo K"},{"manufacturer":"Lenovo","market_name":"Lenovo K8","codename":"brady_f","model":"Lenovo K8"},{"manufacturer":"Lenovo","market_name":"Lenovo K8 Note","codename":"manning","model":"Lenovo K8 Note"},{"manufacturer":"Lenovo","market_name":"Lenovo K8 Note","codename":"manning","model":"XT1902-3"},{"manufacturer":"Lenovo","market_name":"Lenovo K8 Plus","codename":"marino_f","model":"Lenovo K"},{"manufacturer":"Lenovo","market_name":"Lenovo K8 Plus","codename":"marino_f","model":"Lenovo K8 Plus"},{"manufacturer":"Lenovo","market_name":"Lenovo Mirage Solo","codename":"vega","model":"VR-1541F"},{"manufacturer":"Lenovo","market_name":"Lenovo N Series Chromebook","codename":"reks_cheets","model":"Braswell Chrome OS Device"},{"manufacturer":"Lenovo","market_name":"Lenovo N Series Chromebook","codename":"reks_cheets","model":"Lenovo Intel Braswell Chromebook"},{"manufacturer":"Lenovo","market_name":"Lenovo N300","codename":"Lindos2","model":"Lenovo N300"},{"manufacturer":"Lenovo","market_name":"Lenovo S820","codename":"S820","model":"Lenovo S820"},{"manufacturer":"Lenovo","market_name":"Lenovo TAB","codename":"TB-8803F","model":"Lenovo TB-8803F"},{"manufacturer":"Lenovo","market_name":"Lenovo TAB 7","codename":"TB-7504F","model":"Lenovo TB-7504F"},{"manufacturer":"Lenovo","market_name":"Lenovo TAB 7","codename":"TB-7504N","model":"Lenovo TB-7504N"},{"manufacturer":"Lenovo","market_name":"Lenovo TAB 7","codename":"TB-7504X","model":"Lenovo TB-7504X"},{"manufacturer":"Lenovo","market_name":"Lenovo TAB4","codename":"701LV","model":"701LV"},{"manufacturer":"Lenovo","market_name":"Lenovo TAB4","codename":"702LV","model":"702LV"},{"manufacturer":"Lenovo","market_name":"Lenovo TB-8304F1","codename":"TB-8304F1","model":"Lenovo TB-8304F1"},{"manufacturer":"Lenovo","market_name":"Lenovo TB-X504F","codename":"X504F","model":"Lenovo TB-X504F"},{"manufacturer":"Lenovo","market_name":"Lenovo Tab 7 Essential","codename":"7304I","model":"Lenovo TB-7304I"},{"manufacturer":"Lenovo","market_name":"Lenovo Tab 7 Essential","codename":"TB-7304I","model":"Lenovo TB-7304I"},{"manufacturer":"Lenovo","market_name":"Lenovo Tab 7 Essential","codename":"TB-7304N","model":"Lenovo TB-7304N"},{"manufacturer":"Lenovo","market_name":"Lenovo Tab 7 Essential","codename":"TB-7304X","model":"Lenovo TB-7304X"},{"manufacturer":"Lenovo","market_name":"Lenovo Tab4 10 Plus","codename":"X704A","model":"TB-X704A"},{"manufacturer":"Lenovo","market_name":"Lenovo X2-CU/VIBE X2","codename":"X2-CU","model":"Lenovo X2-CU"},{"manufacturer":"Lenovo","market_name":"Lenovo YOGA A12","codename":"YOGA-A12","model":"Lenovo YB-Q501L"},{"manufacturer":"Lenovo","market_name":"LenovoTAB2 A7-30DC","codename":"A7-30HC","model":"Lenovo TAB 2 A7-30DC"},{"manufacturer":"Lenovo","market_name":"LenovoTB-8304F","codename":"TB-8304F","model":"Lenovo TB-8304F"},{"manufacturer":"Lenovo","market_name":"LenovoTB-8704V","codename":"TB-8704V","model":"TB-8704V"},{"manufacturer":"Lenovo","market_name":"LenovoTB-X304F/Lenovo TAB4","codename":"X304F","model":"Lenovo TB-X304F"},{"manufacturer":"Lenovo","market_name":"LenovoTB-X304F/Lenovo TAB4","codename":"X304F","model":"TB-X304F"},{"manufacturer":"Lenovo","market_name":"LenovoTB-X704F/Lenovo TAB4 10 Plus","codename":"X704F","model":"Lenovo TB-X704F"},{"manufacturer":"Lenovo","market_name":"LenovoTV 40S9;LenovoTV 50S9;AQUOS 40U1;AQUOS 50U1\\xef\\xbc\\x9bAQUOS 58U1; AQUOS 60LX765A","codename":"jazz","model":"AQUOS 58U1"},{"manufacturer":"Lenovo","market_name":"LenovoTV 40S9;LenovoTV 50S9;AQUOS 40U1;AQUOS 50U1\\xef\\xbc\\x9bAQUOS 58U1; AQUOS 60LX765A","codename":"jazz","model":"AQUOS 60LX765A"},{"manufacturer":"Lenovo","market_name":"LenovoTV 40S9;LenovoTV 50S9;AQUOS 40U1;AQUOS 50U1\\xef\\xbc\\x9bAQUOS 58U1; AQUOS 60LX765A","codename":"jazz","model":"AQUOS 60UE20A"},{"manufacturer":"Lenovo","market_name":"LenovoTV 40S9;LenovoTV 50S9;AQUOS 40U1;AQUOS 50U1\\xef\\xbc\\x9bAQUOS 58U1; AQUOS 60LX765A","codename":"jazz","model":"LenovoTV 40S9"},{"manufacturer":"Lenovo","market_name":"LenovoTV 40S9;LenovoTV 50S9;AQUOS 40U1;AQUOS 50U1\\xef\\xbc\\x9bAQUOS 58U1; AQUOS 60LX765A","codename":"jazz","model":"LenovoTV 58S9"},{"manufacturer":"Lenovo","market_name":"LenovoTV 50S52;AQUOS LCD-50S1A","codename":"bumblebee","model":"AQUOS 50S1"},{"manufacturer":"Lenovo","market_name":"LenovoTV 50S52;AQUOS LCD-50S1A","codename":"bumblebee","model":"LenovoTV 50S52"},{"manufacturer":"Lenovo","market_name":"Lenovo_K320t","codename":"Lenovo_K320t","model":"Lenovo K320t"},{"manufacturer":"Lenovo","market_name":"Lenvo S960","codename":"S960_ROW","model":"Lenovo S960"},{"manufacturer":"Lenovo","market_name":"Moto E3","codename":"taidos_row","model":"XT1700"},{"manufacturer":"Lenovo","market_name":"Moto E3 Power","codename":"taido_row","model":"XT1706"},{"manufacturer":"Lenovo","market_name":"Motorola M","codename":"XT1663","model":"XT1663"},{"manufacturer":"Lenovo","market_name":"Motorola Moto M","codename":"kungfu_m","model":"XT1662"},{"manufacturer":"Lenovo","market_name":"N300","codename":"Lindos2","model":"Lenovo N300"},{"manufacturer":"Lenovo","market_name":"N308","codename":"SmartAIO","model":"Lenovo N308"},{"manufacturer":"Lenovo","market_name":"NEC  PC-TE507FAW","codename":"TE507FAW","model":"PC-TE507FAW"},{"manufacturer":"Lenovo","market_name":"NEC PC-TS508FAM","codename":"PC-TS508FAM","model":"NEC PC-TS508FAM"},{"manufacturer":"Lenovo","market_name":"NEC PC-TS508FAM","codename":"PC-TS508FAM","model":"PC-TS508FAM"},{"manufacturer":"Lenovo","market_name":"P1","codename":"P1a42","model":"Lenovo P1a41"},{"manufacturer":"Lenovo","market_name":"P1","codename":"P1a42","model":"Lenovo P1a42"},{"manufacturer":"Lenovo","market_name":"P1","codename":"passion","model":"Lenovo P1c72"},{"manufacturer":"Lenovo","market_name":"P1","codename":"passionc5","model":"Lenovo P1c58"},{"manufacturer":"Lenovo","market_name":"P2","codename":"P2a42","model":"Lenovo P2a42"},{"manufacturer":"Lenovo","market_name":"P2","codename":"kuntao","model":"Lenovo P2c72"},{"manufacturer":"Lenovo","market_name":"P70","codename":"P70-A","model":"Lenovo P70-A"},{"manufacturer":"Lenovo","market_name":"P70","codename":"P70-t","model":"Lenovo P70-t"},{"manufacturer":"Lenovo","market_name":"P780","codename":"P780","model":"Lenovo P780"},{"manufacturer":"Lenovo","market_name":"P780","codename":"P780_ROW","model":"Lenovo P780"},{"manufacturer":"Lenovo","market_name":"P780","codename":"P780_ROW","model":"Lenovo P780_ROW"},{"manufacturer":"Lenovo","market_name":"P90","codename":"P90","model":"Lenovo P90"},{"manufacturer":"Lenovo","market_name":"PB1-750M/Lenovo PHAB","codename":"PB1-750M","model":"Lenovo PB1-750M"},{"manufacturer":"Lenovo","market_name":"PB1-770M/Lenovo PHAB Plus","codename":"PB1-770M","model":"EveryPad3"},{"manufacturer":"Lenovo","market_name":"PB1-770M/Lenovo PHAB Plus","codename":"PB1-770M","model":"Lenovo PB1-770M"},{"manufacturer":"Lenovo","market_name":"PB1-770N","codename":"PB1-770N","model":"Lenovo PB1-770N"},{"manufacturer":"Lenovo","market_name":"PB2","codename":"PB2","model":"Lenovo PB2-650M"},{"manufacturer":"Lenovo","market_name":"PB2 plus","codename":"PB2-670M","model":"Lenovo PB2-670M"},{"manufacturer":"Lenovo","market_name":"PB2 plus","codename":"PB2-670M1","model":"Lenovo PB2-670M1"},{"manufacturer":"Lenovo","market_name":"PB2-650Y","codename":"PB2","model":"Lenovo PB2-650Y"},{"manufacturer":"Lenovo","market_name":"PC-TE510HAW","codename":"X704F","model":"PC-TE510HAW"},{"manufacturer":"Lenovo","market_name":"PHAB 2","codename":"PB2","model":"Lenovo PB2-650N"},{"manufacturer":"Lenovo","market_name":"PHAB 2 Plus","codename":"PB2-670N","model":"Lenovo PB2-670N"},{"manufacturer":"Lenovo","market_name":"PHAB 2 Plus","codename":"PB2-670Y","model":"Lenovo PB2-670Y"},{"manufacturer":"Lenovo","market_name":"PHAB2 Pro","codename":"PB2PRO","model":"Lenovo PB2-690M"},{"manufacturer":"Lenovo","market_name":"PHAB2 Pro","codename":"PB2PRO","model":"Lenovo PB2-690N"},{"manufacturer":"Lenovo","market_name":"PHAB2 Pro","codename":"PB2PRO","model":"Lenovo PB2-690Y"},{"manufacturer":"Lenovo","market_name":"S1","codename":"S1a40","model":"Lenovo S1a40"},{"manufacturer":"Lenovo","market_name":"S1La40","codename":"S1La40","model":"Lenovo S1La40"},{"manufacturer":"Lenovo","market_name":"S5000","codename":"S5000","model":"Lenovo S5000-F"},{"manufacturer":"Lenovo","market_name":"S5000","codename":"S5000","model":"Lenovo S5000-H"},{"manufacturer":"Lenovo","market_name":"S580","codename":"S580","model":"Lenovo S580"},{"manufacturer":"Lenovo","market_name":"S60","codename":"sisleylr","model":"Lenovo S60-a"},{"manufacturer":"Lenovo","market_name":"S60","codename":"sisleylt","model":"Lenovo S60-t"},{"manufacturer":"Lenovo","market_name":"S60","codename":"sisleylw","model":"Lenovo S60-w"},{"manufacturer":"Lenovo","market_name":"S6000L","codename":"S6000L","model":"Lenovo S6000L-F"},{"manufacturer":"Lenovo","market_name":"S61","codename":"ideatv_S61","model":"ideatv S61"},{"manufacturer":"Lenovo","market_name":"S650","codename":"S650","model":"Lenovo S650"},{"manufacturer":"Lenovo","market_name":"S650_ROW","codename":"S650_ROW","model":"Lenovo S650"},{"manufacturer":"Lenovo","market_name":"S658t","codename":"S658t","model":"Lenovo S658t"},{"manufacturer":"Lenovo","market_name":"S660","codename":"S660","model":"Lenovo S660"},{"manufacturer":"Lenovo","market_name":"S668t","codename":"S668t","model":"Lenovo S668t"},{"manufacturer":"Lenovo","market_name":"S686","codename":"Alaska","model":"Lenovo S686"},{"manufacturer":"Lenovo","market_name":"S720","codename":"S720","model":"Lenovo S720"},{"manufacturer":"Lenovo","market_name":"S750","codename":"S750","model":"Lenovo S750"},{"manufacturer":"Lenovo","market_name":"S810t","codename":"shellt","model":"Lenovo S810t"},{"manufacturer":"Lenovo","market_name":"S820","codename":"S820","model":"Lenovo S820"},{"manufacturer":"Lenovo","market_name":"S820","codename":"S820_AMX_ROW","model":"Lenovo S820"},{"manufacturer":"Lenovo","market_name":"S820","codename":"S820_ROW","model":"Lenovo S820"},{"manufacturer":"Lenovo","market_name":"S820","codename":"S820_ROW","model":"Lenovo S820_ROW"},{"manufacturer":"Lenovo","market_name":"S820e","codename":"applee","model":"Lenovo S820e"},{"manufacturer":"Lenovo","market_name":"S850","codename":"S850","model":"Lenovo S850"},{"manufacturer":"Lenovo","market_name":"S850e","codename":"sichuan","model":"Lenovo S850e"},{"manufacturer":"Lenovo","market_name":"S850t","codename":"S850t","model":"Lenovo S850t"},{"manufacturer":"Lenovo","market_name":"S856","codename":"shellamx","model":"Lenovo S856"},{"manufacturer":"Lenovo","market_name":"S856","codename":"shellr","model":"Lenovo S856"},{"manufacturer":"Lenovo","market_name":"S856","codename":"shellr_s","model":"Lenovo S856"},{"manufacturer":"Lenovo","market_name":"S856","codename":"shellw","model":"Lenovo S856"},{"manufacturer":"Lenovo","market_name":"S858t","codename":"Selected","model":"Lenovo S858t"},{"manufacturer":"Lenovo","market_name":"S860","codename":"S860","model":"Lenovo S860"},{"manufacturer":"Lenovo","market_name":"S860e","codename":"shelle","model":"Lenovo S860e"},{"manufacturer":"Lenovo","market_name":"S868","codename":"S868t","model":"Lenovo S868t"},{"manufacturer":"Lenovo","market_name":"S870e","codename":"S870e","model":"LNV-Lenovo S870e"},{"manufacturer":"Lenovo","market_name":"S870e","codename":"S870e","model":"Lenovo S870e"},{"manufacturer":"Lenovo","market_name":"S898t","codename":"S898t","model":"Lenovo S898t"},{"manufacturer":"Lenovo","market_name":"S898t+","codename":"S898tp","model":"Lenovo S898t+"},{"manufacturer":"Lenovo","market_name":"S90","codename":"sisleye","model":"Lenovo S90-e"},{"manufacturer":"Lenovo","market_name":"S90-A","codename":"sisleyr","model":"Lenovo S90-A"},{"manufacturer":"Lenovo","market_name":"S90-L","codename":"sisleyr_amx","model":"Lenovo S90-L"},{"manufacturer":"Lenovo","market_name":"S90-T","codename":"sisleyt","model":"Lenovo S90-t"},{"manufacturer":"Lenovo","market_name":"S90-U","codename":"sisleyw","model":"Lenovo S90-u"},{"manufacturer":"Lenovo","market_name":"S920","codename":"S920","model":"Lenovo S920"},{"manufacturer":"Lenovo","market_name":"S930","codename":"S930","model":"Lenovo S930"},{"manufacturer":"Lenovo","market_name":"S930_ROW","codename":"S930_ROW","model":"Lenovo S930"},{"manufacturer":"Lenovo","market_name":"S938t","codename":"S938t","model":"Lenovo S938t"},{"manufacturer":"Lenovo","market_name":"S939","codename":"S939","model":"Lenovo S939"},{"manufacturer":"Lenovo","market_name":"S960","codename":"S960","model":"Lenovo S960"},{"manufacturer":"Lenovo","market_name":"S960","codename":"S960_AMX_ROW","model":"Lenovo S960"},{"manufacturer":"Lenovo","market_name":"S968t","codename":"S968t","model":"Lenovo S968t"},{"manufacturer":"Lenovo","market_name":"Softbank 501LV","codename":"501LV","model":"501LV"},{"manufacturer":"Lenovo","market_name":"TAB 10","codename":"TB-X103F","model":"Lenovo TB-X103F"},{"manufacturer":"Lenovo","market_name":"TAB 2 A10","codename":"A10-70F","model":"Lenovo TAB 2 A10-70F"},{"manufacturer":"Lenovo","market_name":"TAB 2 A10","codename":"A10-70L","model":"Lenovo TAB 2 A10-70L"},{"manufacturer":"Lenovo","market_name":"TAB 2 A10","codename":"A10-70LC","model":"Lenovo TAB 2 A10-70LC"},{"manufacturer":"Lenovo","market_name":"TAB 2 A7-10F","codename":"Tab2A7-10F","model":"Tab2A7-10F"},{"manufacturer":"Lenovo","market_name":"TAB 2 A7-20F","codename":"Tab2A7-20F","model":"Tab2A7-20F"},{"manufacturer":"Lenovo","market_name":"TAB 2 A7-30F","codename":"A7-30F","model":"Lenovo TAB 2 A7-30F"},{"manufacturer":"Lenovo","market_name":"TAB 2 A7-30HC","codename":"A7-30HC","model":"Lenovo 2 A7-30HC"},{"manufacturer":"Lenovo","market_name":"TAB 2 A7-30HC","codename":"A7-30HC","model":"Lenovo TAB 2 A7-30HC"},{"manufacturer":"Lenovo","market_name":"TAB 2 A7-30TC","codename":"A7-30TC","model":"Lenovo 2 A7-30TC"},{"manufacturer":"Lenovo","market_name":"TAB 2 A8-50F","codename":"A8-50F","model":"Lenovo 2 A8-50F"},{"manufacturer":"Lenovo","market_name":"TAB 2 A8-50F","codename":"A8-50F","model":"Lenovo TAB 2 A8-50F"},{"manufacturer":"Lenovo","market_name":"TAB 3 850F","codename":"TB3-850F","model":"Lenovo TB3-850F"},{"manufacturer":"Lenovo","market_name":"TAB 3 850M","codename":"TB3-850M","model":"Lenovo TB3-850M"},{"manufacturer":"Lenovo","market_name":"TAB A10-80HC","codename":"A10_80HC","model":"TAB A10-80HC"},{"manufacturer":"Lenovo","market_name":"TAB S8-50F","codename":"S8-50F","model":"Lenovo TAB S8-50F"},{"manufacturer":"Lenovo","market_name":"TAB S8-50L","codename":"S8-50L","model":"Lenovo TAB S8-50L"},{"manufacturer":"Lenovo","market_name":"TAB S8-50LC","codename":"S8-50LC","model":"Lenovo S8-50LC"},{"manufacturer":"Lenovo","market_name":"TAB S8-50LC","codename":"S8-50LC","model":"Lenovo TAB S8-50LC"},{"manufacturer":"Lenovo","market_name":"TAB3 7 Plus","codename":"TB-7703F","model":"Lenovo TB-7703F"},{"manufacturer":"Lenovo","market_name":"TAB3 7 Plus","codename":"TB-7703N","model":"Lenovo TB-7703N"},{"manufacturer":"Lenovo","market_name":"TAB3 7 Plus","codename":"TB-7703X","model":"Lenovo TB-7703X"},{"manufacturer":"Lenovo","market_name":"TAB3 730F","codename":"TB3-730F","model":"Lenovo TB3-730F"},{"manufacturer":"Lenovo","market_name":"TAB3 730M","codename":"TB3-730M","model":"Lenovo TB3-730M"},{"manufacturer":"Lenovo","market_name":"TAB3 730X","codename":"TB3-730X","model":"Lenovo TB3-730X"},{"manufacturer":"Lenovo","market_name":"TAB3 8 Plus","codename":"TB-8703R","model":"Lenovo TB-8703R"},{"manufacturer":"Lenovo","market_name":"TAB3 X70L","codename":"TB3-X70L","model":"Lenovo TB3-X70L"},{"manufacturer":"Lenovo","market_name":"TAB3 X70N","codename":"TB3-X70N","model":"Lenovo TB3-X70N"},{"manufacturer":"Lenovo","market_name":"TAB4 10","codename":"X304L","model":"Lenovo TB-X304L"},{"manufacturer":"Lenovo","market_name":"TAB4 10","codename":"X304N","model":"Lenovo TB-X304N"},{"manufacturer":"Lenovo","market_name":"TAB4 10","codename":"X304N","model":"TB-X304N"},{"manufacturer":"Lenovo","market_name":"TAB4 10","codename":"X304X","model":"Lenovo TB-X304X"},{"manufacturer":"Lenovo","market_name":"TAB4 10 Plus","codename":"X704L","model":"Lenovo TB-X704L"},{"manufacturer":"Lenovo","market_name":"TAB4 10 Plus","codename":"X704N","model":"Lenovo TB-X704N"},{"manufacturer":"Lenovo","market_name":"TAB4 10 Plus","codename":"X704N","model":"TB-X704N"},{"manufacturer":"Lenovo","market_name":"TAB4 10 Plus","codename":"X704V","model":"TB-X704V"},{"manufacturer":"Lenovo","market_name":"TAB4 10 Plus","codename":"X704Y","model":"Lenovo TB-X704Y"},{"manufacturer":"Lenovo","market_name":"TAB4 8","codename":"TB-8504F","model":"Lenovo TB-8504F"},{"manufacturer":"Lenovo","market_name":"TAB4 8","codename":"TB-8504F","model":"TB-8504F"},{"manufacturer":"Lenovo","market_name":"TAB4 8","codename":"TB-8504L","model":"Lenovo TB-8504L"},{"manufacturer":"Lenovo","market_name":"TAB4 8","codename":"TB-8504N","model":"Lenovo TB-8504N"},{"manufacturer":"Lenovo","market_name":"TAB4 8","codename":"TB-8504X","model":"Lenovo TB-8504X"},{"manufacturer":"Lenovo","market_name":"TB-8604F","codename":"TB-8604F","model":"Lenovo TB-8604F"},{"manufacturer":"Lenovo","market_name":"TB-8704F","codename":"TB-8704F","model":"Lenovo TB-8704F"},{"manufacturer":"Lenovo","market_name":"TB-8704N","codename":"TB-8704N","model":"Lenovo TB-8704N"},{"manufacturer":"Lenovo","market_name":"TB-8704X","codename":"TB-8704X","model":"Lenovo TB-8704X"},{"manufacturer":"Lenovo","market_name":"TB-8804F","codename":"TB-8804F","model":"Lenovo TB-8804F"},{"manufacturer":"Lenovo","market_name":"TB-8X04F","codename":"TB-8X04F","model":"Lenovo TB-8X04F"},{"manufacturer":"Lenovo","market_name":"TB2-X30F","codename":"TB2-X30F","model":"Lenovo TB2-X30F"},{"manufacturer":"Lenovo","market_name":"TB2-X30F","codename":"TB2-X30F","model":"Lenovo TB2-X30F_HFT"},{"manufacturer":"Lenovo","market_name":"TB2-X30F","codename":"TB2-X30F","model":"Lenovo TB2-X30F_JLC"},{"manufacturer":"Lenovo","market_name":"TB2-X30F","codename":"TB2-X30F","model":"Lenovo TB2-X30F_SCP"},{"manufacturer":"Lenovo","market_name":"TB2-X30F","codename":"TB2-X30F","model":"Lenovo TB2-X30F_UK"},{"manufacturer":"Lenovo","market_name":"TB2-X30F","codename":"TB2-X30F","model":"Lenovo TB2-X30F_YZA"},{"manufacturer":"Lenovo","market_name":"TB2-X30L","codename":"TB2-X30L","model":"Lenovo TB2-X30L"},{"manufacturer":"Lenovo","market_name":"TB2-X30M","codename":"TB2-X30M","model":"Lenovo TB2-X30M"},{"manufacturer":"Lenovo","market_name":"TB2-X30M","codename":"TB2-X30M","model":"Lenovo TB2-X30M_PRC_YZ_A"},{"manufacturer":"Lenovo","market_name":"TB3 8 Plus","codename":"TB-8703F","model":"Lenovo TB-8703F"},{"manufacturer":"Lenovo","market_name":"TB3 8 Plus","codename":"TB-8703N","model":"Lenovo TB-8703N"},{"manufacturer":"Lenovo","market_name":"TB3 8 Plus","codename":"TB-8703X","model":"Lenovo TB-8703X"},{"manufacturer":"Lenovo","market_name":"TB3-601LV","codename":"601LV","model":"601LV"},{"manufacturer":"Lenovo","market_name":"TB3-602LV","codename":"602LV","model":"602LV"},{"manufacturer":"Lenovo","market_name":"TB3-710F","codename":"TB3-710F","model":"Lenovo TB3-710F"},{"manufacturer":"Lenovo","market_name":"TB3-710I","codename":"TB3-710I","model":"Lenovo TB3-710I"},{"manufacturer":"Lenovo","market_name":"TB3-X70F","codename":"TB3-X70F","model":"Lenovo TB3-X70F"},{"manufacturer":"Lenovo","market_name":"TB3-X70I","codename":"TB3-X70I","model":"Lenovo TB3-X70I"},{"manufacturer":"Lenovo","market_name":"Tab 7 Essential","codename":"7304F","model":"Lenovo TB-7304F"},{"manufacturer":"Lenovo","market_name":"Tab 7 Essential","codename":"TB-7304F","model":"Lenovo TB-7304F"},{"manufacturer":"Lenovo","market_name":"ThinkPad 11e Chromebook 3rd Gen","codename":"ultima_cheets","model":"ThinkPad 11e Chromebook 3rd Gen (Yoga/Clamshell)"},{"manufacturer":"Lenovo","market_name":"ThinkVision28","codename":"ThinkVision28","model":"ThinkVision28"},{"manufacturer":"Lenovo","market_name":"Thinkpad 11e Chromebook (4th Gen)/Lenovo Thinkpad Yoga 11e Chromebook (4th Gen)","codename":"pyro_cheets","model":"Lenovo Thinkpad 11e Chromebook (4th Gen)/Lenovo Thinkpad Yoga 11e Chromebook (4th Gen)"},{"manufacturer":"Lenovo","market_name":"Thinkpad 13 Chromebook","codename":"sentry_cheets","model":"Thinkpad 13 Chromebook"},{"manufacturer":"Lenovo","market_name":"Thinkpad Stack projector","codename":"pj_stack_acc","model":"M123"},{"manufacturer":"Lenovo","market_name":"VIBE K10","codename":"K10a40","model":"Lenovo K10a40"},{"manufacturer":"Lenovo","market_name":"VIBE K6","codename":"K33a48","model":"Lenovo K33a48"},{"manufacturer":"Lenovo","market_name":"VIBE K6","codename":"K33b36","model":"Lenovo K33b36"},{"manufacturer":"Lenovo","market_name":"VIBE K6","codename":"K33b37","model":"Lenovo K33b37"},{"manufacturer":"Lenovo","market_name":"VIBE K6 Note","codename":"K53a48","model":"Lenovo K53a48"},{"manufacturer":"Lenovo","market_name":"VIBE K6 Note","codename":"K53b36","model":"Lenovo K53b36"},{"manufacturer":"Lenovo","market_name":"VIBE K6 Note","codename":"K53b37","model":"Lenovo K53b37"},{"manufacturer":"Lenovo","market_name":"VIBE K6 Power","codename":"K33a42","model":"Lenovo K33a42"},{"manufacturer":"Lenovo","market_name":"VIBE X3 Lite","codename":"A7010a48","model":"Lenovo A7010a48"},{"manufacturer":"Lenovo","market_name":"VIBE X3 Lite","codename":"k5fp","model":"Lenovo K51c78"},{"manufacturer":"Lenovo","market_name":"VIBE X3 Lite","codename":"k5fp_m","model":"Lenovo K51c78"},{"manufacturer":"Lenovo","market_name":"X2","codename":"X2-AP","model":"Lenovo X2-AP"},{"manufacturer":"Lenovo","market_name":"X2","codename":"X2-EU","model":"Lenovo X2-EU"},{"manufacturer":"Lenovo","market_name":"X2 Pro","codename":"s7","model":"Lenovo X2Pt5"},{"manufacturer":"Lenovo","market_name":"X2 Pro","codename":"s7","model":"VIBE X2Pt5"},{"manufacturer":"Lenovo","market_name":"X2-TO/VIBE X2","codename":"X2-TO","model":"Lenovo X2-TO"},{"manufacturer":"Lenovo","market_name":"X2-TR/VIBE X2","codename":"X2-TR","model":"Lenovo X2-TR"},{"manufacturer":"Lenovo","market_name":"X3a40","codename":"x3_row","model":"Lenovo X3a40"},{"manufacturer":"Lenovo","market_name":"X3c50","codename":"X3c50","model":"Lenovo X3c50"},{"manufacturer":"Lenovo","market_name":"X3c70","codename":"X3c70","model":"Lenovo X3c70"},{"manufacturer":"Lenovo","market_name":"YB1-X90L/YOGA BOOK","codename":"yeti","model":"Lenovo YB1-X90L"},{"manufacturer":"Lenovo","market_name":"YOGA A12","codename":"YOGA-A12","model":"Lenovo YB-Q501F"},{"manufacturer":"Lenovo","market_name":"YOGA BOOK","codename":"yeti","model":"Lenovo YB1-X90F"},{"manufacturer":"Lenovo","market_name":"YOGA BOOK","codename":"yeti","model":"Lenovo YB1-X90L"},{"manufacturer":"Lenovo","market_name":"YOGA Laptop with Android","codename":"YOGABOOK12","model":"Lenovo YB-Q501F"},{"manufacturer":"Lenovo","market_name":"YOGA Laptop with Android","codename":"YOGABOOK12","model":"Lenovo YB-Q501L"},{"manufacturer":"Lenovo","market_name":"YOGA Tablet Pro-1050L/Yoga Tablet 2","codename":"YT2","model":"YOGA Tablet 2-1050L"},{"manufacturer":"Lenovo","market_name":"YOGA Tablet Pro-1050LC/Yoga Tablet 2","codename":"YT2","model":"YOGA Tablet 2-1050LC"},{"manufacturer":"Lenovo","market_name":"YOGA Tablet Pro-1380F/Yoga Tablet 2 Pro","codename":"YT2","model":"YOGA Tablet 2 Pro-1380F"},{"manufacturer":"Lenovo","market_name":"YOGA Tablet Pro-1380L/Yoga Tablet 2 Pro","codename":"YT2","model":"YOGA Tablet 2 Pro-1380L"},{"manufacturer":"Lenovo","market_name":"YOGA Tablet Pro-830L/Yoga Tablet 2","codename":"YT2","model":"YOGA Tablet 2-830L"},{"manufacturer":"Lenovo","market_name":"YOGA Tablet Pro-830LC/Yoga Tablet 2","codename":"YT2","model":"YOGA Tablet 2-830LC"},{"manufacturer":"Lenovo","market_name":"YT3-850F/Lenovo YOGATab3","codename":"YT3-850F","model":"Lenovo YT3-850F"},{"manufacturer":"Lenovo","market_name":"YT3-850L/Lenovo YOGATab3","codename":"YT3-850L","model":"Lenovo YT3-850L"},{"manufacturer":"Lenovo","market_name":"YT3-850M/Lenovo YOGATab3","codename":"YT3-850M","model":"Lenovo YT3-850M"},{"manufacturer":"Lenovo","market_name":"YT3-X50F/Yoga3 Tablet","codename":"YT3-X50F","model":"Lenovo YT3-X50F"},{"manufacturer":"Lenovo","market_name":"YT3-X50L/Yoga3 Tablet","codename":"YT3-X50L","model":"Lenovo YT3-X50L"},{"manufacturer":"Lenovo","market_name":"YT3-X50M/Yoga3 Tablet","codename":"YT3-X50M","model":"Lenovo YT3-X50M"},{"manufacturer":"Lenovo","market_name":"YT3-X90F/YOGA3 Tablet Pro","codename":"YT3","model":"Lenovo YT3-X90F"},{"manufacturer":"Lenovo","market_name":"YT3-X90L/YOGA3 Tablet Pro","codename":"YT3","model":"Lenovo YT3-X90L"},{"manufacturer":"Lenovo","market_name":"YT3-X90X/YOGA3 Tablet Pro","codename":"YT3","model":"Lenovo YT3-X90X"},{"manufacturer":"Lenovo","market_name":"YT3-X90Y/YOGA3 Tablet Pro","codename":"YT3","model":"Lenovo YT3-X90Y"},{"manufacturer":"Lenovo","market_name":"YT3-X90Z/YOGA3 Tablet Pro","codename":"YT3","model":"Lenovo YT3-X90Z"},{"manufacturer":"Lenovo","market_name":"Yoga TAB3 Plus","codename":"YT-X703F","model":"Lenovo YT-X703F"},{"manufacturer":"Lenovo","market_name":"Yoga TAB3 Plus","codename":"YT-X703L","model":"Lenovo YT-X703L"},{"manufacturer":"Lenovo","market_name":"Yoga TAB3 Plus","codename":"YT-X703X","model":"Lenovo YT-X703X"},{"manufacturer":"Lenovo","market_name":"YogaTablet2 -1050F","codename":"YT2","model":"YOGA Tablet 2-1050F"},{"manufacturer":"Lenovo","market_name":"YogaTbalet2-830F","codename":"YT2","model":"YOGA Tablet 2-830F"},{"manufacturer":"Lenovo","market_name":"Z2","codename":"z2r","model":"Lenovo Z2"},{"manufacturer":"Lenovo","market_name":"Z2","codename":"z2t","model":"Lenovo Z2"},{"manufacturer":"Lenovo","market_name":"Z2w","codename":"z2w","model":"Lenovo Z2w"},{"manufacturer":"Lenovo","market_name":"Z90/VIBE Shot","codename":"zoom_fdd","model":"Lenovo Z90"},{"manufacturer":"Lenovo","market_name":"Z90/VIBE Shot","codename":"zoom_fdd","model":"Lenovo Z90-7"},{"manufacturer":"Lenovo","market_name":"Z90/VIBE Shot","codename":"zoom_tdd","model":"Lenovo Z90-3"},{"manufacturer":"Lenovo","market_name":"Z90a40/VIBE Shot","codename":"zoom_row","model":"Lenovo Z90a40"},{"manufacturer":"Lenovo","market_name":"ideatv S52","codename":"ideatv_S52","model":"ideatv S52"},{"manufacturer":"Lenovo","market_name":"ideatvK82 60LX750A  52LX750A  46LX750A  60LX850A  70LX850A 80LX850A","codename":"ideatv_K82","model":"ideatv K82"},{"manufacturer":"Lenovo","market_name":"\\xe5\\xb0\\x8f\\xe6\\x96\\xb0\\xe5\\xb9\\xb3\\xe6\\x9d\\xbf","codename":"X804F","model":"Lenovo TB-X804F"},{"manufacturer":"Lephone","market_name":"Lephone W8","codename":"lephone_W8","model":"lephone_W8"},{"manufacturer":"Lephone","market_name":"lephone P1","codename":"lephoneP1","model":"lephoneP1"},{"manufacturer":"Lephone","market_name":"lephone W10","codename":"lephone_W10","model":"lephone_W10"},{"manufacturer":"Lexia Mobile","market_name":"S1","codename":"S1","model":"S1"},{"manufacturer":"Lexibook","market_name":"Fluo","codename":"MFC145FR1","model":"MFC145FR1"},{"manufacturer":"Lexibook","market_name":"Fluo XL","codename":"MFC191FR2","model":"MFC191FR2"},{"manufacturer":"Lexibook","market_name":"Fluo XL Premium Edition","codename":"MFC510FR1","model":"MFC510FR1"},{"manufacturer":"Lexibook","market_name":"\"LexiTab 10\"\"\"","codename":"MFC512","model":"MFC512FR"},{"manufacturer":"Lexibook","market_name":"LexiTab 10\\'\\'","codename":"mfc511","model":"MFC511DE"},{"manufacturer":"Lexibook","market_name":"LexiTab 10\\'\\'","codename":"mfc511","model":"MFC511EN"},{"manufacturer":"Lexibook","market_name":"LexiTab 10\\'\\'","codename":"mfc511","model":"MFC511FR"},{"manufacturer":"Lexibook","market_name":"\"LexiTab 7\"\"\"","codename":"MFC147","model":"MFC147FR"},{"manufacturer":"Lexibook","market_name":"LexiTab 7\\'\\'","codename":"MFC146DE","model":"MFC146DE"},{"manufacturer":"Lexibook","market_name":"LexiTab 7\\'\\'","codename":"MFC146EN","model":"MFC146EN"},{"manufacturer":"Lexibook","market_name":"LexiTab 7\\'\\'","codename":"MFC146FR","model":"MFC146FR"},{"manufacturer":"Lexibook","market_name":"LexiTab 7\\'\\'\\t","codename":"MFC146ES","model":"MFC146ES"},{"manufacturer":"Lexibook","market_name":"\"LexiTab\\xc2\\xae 10\"\"\"","codename":"MFC513FR","model":"MFC513FR"},{"manufacturer":"Lexibook","market_name":"\"LexiTab\\xc2\\xae 7\"\"\"","codename":"MFC148FR","model":"MFC148FR"},{"manufacturer":"Lexibook","market_name":"MFC191","codename":"MFC191","model":"S952"},{"manufacturer":"Lexibook","market_name":"Playdroid","codename":"lbox500","model":"LBOX500"},{"manufacturer":"Lgcns","market_name":"LPT_200AR","codename":"LPT_200AR","model":"LPT_200AR"},{"manufacturer":"Lgcns","market_name":"LPT_201AR","codename":"LPT_201AR","model":"LPT_201AR"},{"manufacturer":"Lin","market_name":"LIN","codename":"LINTAB_TB701","model":"LINTAB_TB701"},{"manufacturer":"LinkNet","market_name":"SH960C-LN","codename":"SH960C-LN","model":"SH960C-LN"},{"manufacturer":"LinkNet","market_name":"ST950I-LN","codename":"ST950I-LN","model":"ST950I-LN"},{"manufacturer":"LinkNet","market_name":"Smart Box HD","codename":"SH940C-LN","model":"SH940C-LN"},{"manufacturer":"Listo","market_name":"WEBPAD1002","codename":"Listo","model":"WEBPAD1002"},{"manufacturer":"Logic Instrument","market_name":"FieldBook E1","codename":"FieldBook_E1","model":"FieldBook_E1"},{"manufacturer":"Logic Instrument","market_name":"Fieldbook F1","codename":"lifbf1","model":"Logic Instrument Fieldbook F1"},{"manufacturer":"Logic Instrument","market_name":"Fieldbook F53","codename":"lifbf53","model":"Logic Instrument Fieldbook F53"},{"manufacturer":"Logic Instrument","market_name":"Fieldbook K80","codename":"lifbk80","model":"Logic Instrument Fieldbook K80"},{"manufacturer":"Logic Instrument","market_name":"Logic Instrument Fieldbook KS80","codename":"lifbks80","model":"Logic Instrument Fieldbook KS80"},{"manufacturer":"Logic Mobility","market_name":"LOGIC_L5D","codename":"LOGIC_L5D","model":"LOGIC_L5D"},{"manufacturer":"Logic Mobility","market_name":"T7_plus","codename":"T7_plus","model":"T7_plus"},{"manufacturer":"Logic Mobility","market_name":"UNONU_L55D","codename":"UNONU_L55D","model":"UNONU_L55D"},{"manufacturer":"Logic Mobility","market_name":"X4 Plus","codename":"X4","model":"Logic X4 Plus"},{"manufacturer":"Logic Mobility","market_name":"X5A","codename":"LOGIC_X5A","model":"LOGIC X5A"},{"manufacturer":"Logicom","market_name":"B bot 50","codename":"BBOT50","model":"B BOT 50"},{"manufacturer":"Logicom","market_name":"B bot 550","codename":"BBOT550","model":"B BOT 550"},{"manufacturer":"Logicom","market_name":"C bot tab 100","codename":"CBotTab100","model":"C Bot Tab 100"},{"manufacturer":"Logicom","market_name":"C bot tab 70","codename":"C_Bot_Tab_70","model":"C Bot Tab 70"},{"manufacturer":"Logicom","market_name":"CT1080","codename":"CT1080","model":"CT1080"},{"manufacturer":"Logicom","market_name":"Connect503","codename":"L-ite502","model":"Connect503"},{"manufacturer":"Logicom","market_name":"E1052GP","codename":"E1052GP","model":"E1052GP"},{"manufacturer":"Logicom","market_name":"E350","codename":"E350","model":"E350"},{"manufacturer":"Logicom","market_name":"E400","codename":"E400","model":"E400"},{"manufacturer":"Logicom","market_name":"E852GP","codename":"E852GP","model":"E852GP"},{"manufacturer":"Logicom","market_name":"ID bot 53","codename":"IDbot53","model":"ID bot 53"},{"manufacturer":"Logicom","market_name":"ID bot 553","codename":"IDbot553","model":"IDbot553"},{"manufacturer":"Logicom","market_name":"ID bot 553+","codename":"IDbot553PLUS","model":"IDbot553PLUS"},{"manufacturer":"Logicom","market_name":"ID bot 56","codename":"ID_bot_56","model":"ID bot 56"},{"manufacturer":"Logicom","market_name":"IDbot53plus","codename":"IDbot53plus","model":"ID bot 53+"},{"manufacturer":"Logicom","market_name":"L-EGANT  ONE-R","codename":"L-EGANTONE-R","model":"L-EGANTONE-R"},{"manufacturer":"Logicom","market_name":"L-EGANT ONE","codename":"L-EGANTONE","model":"L-EGANTONE"},{"manufacturer":"Logicom","market_name":"L-EMENT 401","codename":"L-EMENT401","model":"L-EMENT401"},{"manufacturer":"Logicom","market_name":"L-EMENT 403","codename":"L-EMENT_403","model":"L-EMENT_403"},{"manufacturer":"Logicom","market_name":"L-EMENT 505","codename":"L-EMENT505","model":"L-EMENT 505"},{"manufacturer":"Logicom","market_name":"L-EMENT 553","codename":"L-EMENT553","model":"L-EMENT 553"},{"manufacturer":"Logicom","market_name":"L-EMENT TAB 1040","codename":"generic","model":"L-EMENT_TAB1040"},{"manufacturer":"Logicom","market_name":"L-EMENT TAB 1043 BTK","codename":"L-EMENT_1043_BTK","model":"L-EMENT_1043_BTK"},{"manufacturer":"Logicom","market_name":"L-EMENT TAB 741","codename":"LEMENTTAB741","model":"L-EMENT 741"},{"manufacturer":"Logicom","market_name":"L-EMENT TAB 742","codename":"LEMENTTAB742","model":"L-EMENT 742"},{"manufacturer":"Logicom","market_name":"L-EMENT TAB 744","codename":"L-ement_Tab_744","model":"L-ement_Tab_744"},{"manufacturer":"Logicom","market_name":"L-EMENT TAB 744P","codename":"L-ementTab744P","model":"L-ementTab744P"},{"manufacturer":"Logicom","market_name":"L-EMENT350","codename":"L-EMENT350","model":"L-EMENT350"},{"manufacturer":"Logicom","market_name":"L-EMENT400","codename":"LEMENT400","model":"L-EMENT 400"},{"manufacturer":"Logicom","market_name":"L-EMENT500","codename":"L-EMENT500L","model":"L-EMENT500L"},{"manufacturer":"Logicom","market_name":"L-EMENT501","codename":"L-EMENT501","model":"L-EMENT501"},{"manufacturer":"Logicom","market_name":"L-EMENT550","codename":"L-EMENT550","model":"L-EMENT550"},{"manufacturer":"Logicom","market_name":"L-EMENT551","codename":"L-EMENT551","model":"L-EMENT551"},{"manufacturer":"Logicom","market_name":"L-EMENTTAB1042","codename":"LEMENTTAB1042BTK","model":"L-EMENT_TAB1042BTK"},{"manufacturer":"Logicom","market_name":"L-EMENT_TAB1040_BT","codename":"generic","model":"L-EMENT_TAB1040_BT"},{"manufacturer":"Logicom","market_name":"L-ITE 400M","codename":"L-ITE400M","model":"L-ITE 400M"},{"manufacturer":"Logicom","market_name":"L-ITE 502 PLUS","codename":"L-ITE502PLUS","model":"L-ITE 502 PLUS"},{"manufacturer":"Logicom","market_name":"L-ITE 504 HD","codename":"L-ITE504HD","model":"L-ITE 504 HD"},{"manufacturer":"Logicom","market_name":"L-ITE 506 HD","codename":"L-ITE506HD","model":"L-ITE 506 HD"},{"manufacturer":"Logicom","market_name":"L-ITE 506R HD","codename":"L-ITE506RHD","model":"L-ITE 506R HD"},{"manufacturer":"Logicom","market_name":"L-ITE 552 HD","codename":"L-ITE552HD","model":"L-ITE 552 HD"},{"manufacturer":"Logicom","market_name":"L-ITE Tab 870 LTE","codename":"L-ITETAB870LTE","model":"L-ITE Tab 870 LTE"},{"manufacturer":"Logicom","market_name":"L-ITE402","codename":"L-ITE402","model":"L-ITE 402"},{"manufacturer":"Logicom","market_name":"L-ITE452","codename":"L-ITE452","model":"L-ITE 452"},{"manufacturer":"Logicom","market_name":"L-ITE502","codename":"L-ITE502","model":"L-ITE 502"},{"manufacturer":"Logicom","market_name":"L-ITE552","codename":"L-ITE552","model":"L-ITE 552"},{"manufacturer":"Logicom","market_name":"L-IXIR TAB 1041","codename":"generic","model":"LIXIR1041"},{"manufacturer":"Logicom","market_name":"L-IXIR TAB 1046HD","codename":"L-IXIR_TAB_1046_HD","model":"L-IXIR_TAB_1046_HD"},{"manufacturer":"Logicom","market_name":"L-IXIR TAB 701 3G","codename":"TAB701","model":"L-IXIR TAB 701 3G"},{"manufacturer":"Logicom","market_name":"L-IXIR TAB 840","codename":"L-IXIR_TAB_840","model":"L-IXIR_TAB_840"},{"manufacturer":"Logicom","market_name":"L-ite_Tab1060","codename":"LiteTab1060","model":"L-ite_Tab1060"},{"manufacturer":"Logicom","market_name":"L351","codename":"L-EMENT351","model":"L-EMENT351"},{"manufacturer":"Logicom","market_name":"L743","codename":"L-EMENT743","model":"L-EMENT743"},{"manufacturer":"Logicom","market_name":"LEMENT TAB 740","codename":"LEMENTTAB740","model":"L-EMENT 740"},{"manufacturer":"Logicom","market_name":"LEMENTTAB1042","codename":"LEMENTTAB1042","model":"L-EMENT_TAB1042"},{"manufacturer":"Logicom","market_name":"LEMENTTAB901","codename":"LEMENTTAB901","model":"LEMENT_TAB901"},{"manufacturer":"Logicom","market_name":"LIXIR1044","codename":"LIXIR1044","model":"LIXIR1044"},{"manufacturer":"Logicom","market_name":"L_IXIR_TAB_1047HD","codename":"L_IXIR_TAB_1047HD","model":"L_IXIR_TAB_1047HD"},{"manufacturer":"Logicom","market_name":"La Tab 106","codename":"LaTab106","model":"La Tab 106"},{"manufacturer":"Logicom","market_name":"La Tab Full HD","codename":"La_Tab_Full_HD","model":"La Tab Full HD"},{"manufacturer":"Logicom","market_name":"Le Starter L","codename":"Le_Starter_L","model":"Le Starter L"},{"manufacturer":"Logicom","market_name":"LiteTab760","codename":"LiteTab760","model":"LiteTab760"},{"manufacturer":"Logicom","market_name":"Logikids","codename":"Logikids_2","model":"Logikids_2"},{"manufacturer":"Logicom","market_name":"Logikids 3","codename":"Logikids_3","model":"Logikids_3"},{"manufacturer":"Logicom","market_name":"M bot 51","codename":"Mbot51","model":"M bot 51"},{"manufacturer":"Logicom","market_name":"M bot 54","codename":"M_bot_54","model":"M bot 54"},{"manufacturer":"Logicom","market_name":"M bot 551","codename":"M_BOT_551","model":"M BOT 551"},{"manufacturer":"Logicom","market_name":"M bot 60","codename":"Mbot60","model":"M bot 60"},{"manufacturer":"Logicom","market_name":"M bot Tab 103","codename":"MbotTab103","model":"M bot Tab 103"},{"manufacturer":"Logicom","market_name":"M bot Tab 1150","codename":"M_bot_tab_1150","model":"M_bot_tab_1150"},{"manufacturer":"Logicom","market_name":"M bot Tab 71","codename":"M_bot_tab_71","model":"M_bot_tab_71"},{"manufacturer":"Logicom","market_name":"M bot tab 100","codename":"M_BOT_TAB_100","model":"M BOT TAB 100"},{"manufacturer":"Logicom","market_name":"M bot tab 101","codename":"MBOTTAB101","model":"M BOT TAB 101"},{"manufacturer":"Logicom","market_name":"M bot tab 70","codename":"M_BOT_TAB_70","model":"M BOT TAB 70"},{"manufacturer":"Logicom","market_name":"M_ bot_ 52","codename":"M_bot_52","model":"M bot 52"},{"manufacturer":"Logicom","market_name":"POWER bot","codename":"POWERBOT","model":"POWER BOT"},{"manufacturer":"Logicom","market_name":"Playtab 10","codename":"LOGICOM_PLAYTAB_10","model":"LOGICOM_PLAYTAB_10"},{"manufacturer":"Logicom","market_name":"S1052","codename":"S1052","model":"S1052"},{"manufacturer":"Logicom","market_name":"S450","codename":"S450","model":"S450"},{"manufacturer":"Logicom","market_name":"S504","codename":"S504","model":"Connect 5"},{"manufacturer":"Logicom","market_name":"S504","codename":"S504","model":"S504"},{"manufacturer":"Logicom","market_name":"S732","codename":"rk3026","model":"S732"},{"manufacturer":"Logicom","market_name":"S7842","codename":"S7842","model":"S7842"},{"manufacturer":"Logicom","market_name":"S952","codename":"S952","model":"S952"},{"manufacturer":"Logicom","market_name":"Touch Tablet CT730","codename":"CT730","model":"CT730"},{"manufacturer":"Logicom","market_name":"VRBOT552","codename":"VRBOT552","model":"VR BOT 552"},{"manufacturer":"Logicom","market_name":"VRBOT552PLUS","codename":"VRBOT552PLUS","model":"VR BOT 552 PLUS"},{"manufacturer":"Logicom","market_name":"Volt-R","codename":"Volt-R","model":"Volt-R"},{"manufacturer":"Logitech","market_name":"Revue","codename":"ka","model":"Revue"},{"manufacturer":"Louis Vuitton","market_name":"Tambour Horizon","codename":"sundial","model":"Tambour"},{"manufacturer":"Lucentel","market_name":"Siren_1","codename":"Siren_1","model":"Siren_1"},{"manufacturer":"Lumigon","market_name":"T2","codename":"msm7630_fw8911","model":"T2"},{"manufacturer":"Lumigon","market_name":"T2 HD","codename":"T2HD","model":"T2HD"},{"manufacturer":"Lumigon","market_name":"T3","codename":"Lumigon_T3","model":"Lumigon_T3"},{"manufacturer":"Lyf","market_name":"LS-4004","codename":"LS-4004","model":"LS-4004"},{"manufacturer":"Lyf","market_name":"LS-4006","codename":"LS-4006","model":"LYF_LS-4006"},{"manufacturer":"Lyf","market_name":"LS-4503","codename":"LS-4503","model":"LS-4503"},{"manufacturer":"Lyf","market_name":"LS-4505","codename":"LS-4505","model":"LS-4505"},{"manufacturer":"Lyf","market_name":"LS-4508","codename":"C-451","model":"LS-4508"},{"manufacturer":"Lyf","market_name":"LS-4510","codename":"LS-4510","model":"LS-4510"},{"manufacturer":"Lyf","market_name":"LS-4511","codename":"LS-4511","model":"LS-4511"},{"manufacturer":"Lyf","market_name":"LS-4512","codename":"LS-4512","model":"LS-4512"},{"manufacturer":"Lyf","market_name":"LS-5002","codename":"LS-5002","model":"LS-5002"},{"manufacturer":"Lyf","market_name":"LS-5004","codename":"LS-5004","model":"LS-5004"},{"manufacturer":"Lyf","market_name":"LS-5008","codename":"P839F30","model":"LS-5008"},{"manufacturer":"Lyf","market_name":"LS-5009","codename":"LS-5009","model":"LS-5009"},{"manufacturer":"Lyf","market_name":"LS-5013","codename":"LS-5013","model":"LS-5013"},{"manufacturer":"Lyf","market_name":"LS-5016","codename":"LS-5016","model":"LS-5016"},{"manufacturer":"Lyf","market_name":"LS-5018","codename":"HL-L51P","model":"LS-5018"},{"manufacturer":"Lyf","market_name":"LS-5020","codename":"LS-5020","model":"LS-5020"},{"manufacturer":"Lyf","market_name":"LS-5021","codename":"ZTE_T920","model":"LS-5021"},{"manufacturer":"Lyf","market_name":"LS-5027","codename":"LS-5027","model":"LS-5027"},{"manufacturer":"Lyf","market_name":"LS-5201","codename":"panda01a_msm8952_64","model":"LS-5201"},{"manufacturer":"Lyf","market_name":"LS-5503","codename":"P839F50","model":"LS-5503"},{"manufacturer":"Lyf","market_name":"LS-5504","codename":"zx55q05_64","model":"LS-5504"},{"manufacturer":"Lyf","market_name":"LS-6001","codename":"LS-6001","model":"LS-6001"},{"manufacturer":"Lyf","market_name":"LT-8001","codename":"LT-8001","model":"LT-8001"},{"manufacturer":"Lyf","market_name":"LT-8001 IRIS","codename":"LT-8001-IRIS","model":"LT-8001 IRIS"},{"manufacturer":"Lyf","market_name":"WATER F1","codename":"LS-5505","model":"LS-5505"},{"manufacturer":"M-Horse","market_name":"M-HORSE","codename":"Pure1","model":"Pure1"},{"manufacturer":"M-Horse","market_name":"Pure 2","codename":"Pure-2","model":"Pure 2"},{"manufacturer":"M-Horse","market_name":"Pure 3","codename":"Pure_3","model":"Pure 3"},{"manufacturer":"M-tech","market_name":"Eros Power","codename":"EROS_Power","model":"EROS Power"},{"manufacturer":"M4tel","market_name":"M4 B1","codename":"M4_B1","model":"M4_B1"},{"manufacturer":"M4tel","market_name":"M4 B2","codename":"M4_B2","model":"M4_B2"},{"manufacturer":"M4tel","market_name":"M4 B3","codename":"M4_B3","model":"M4_B3"},{"manufacturer":"M4tel","market_name":"M4 SS4450","codename":"DREAMPLUS02A-S10A","model":"M4 SS4450"},{"manufacturer":"M4tel","market_name":"M4 SS4450B","codename":"DREAMPLUS02C-S10A","model":"M4 SS4450B"},{"manufacturer":"M4tel","market_name":"M4 SS4451","codename":"NOVA02A_S11A","model":"M4 SS4451"},{"manufacturer":"M4tel","market_name":"M4 SS4452","codename":"UDON02A_S10A","model":"M4 SS4452"},{"manufacturer":"M4tel","market_name":"M4 SS4453","codename":"TOUCHPLUS01A-S10A","model":"M4 SS4453"},{"manufacturer":"M4tel","market_name":"M4 SS4453-R","codename":"M4-SS4453-R","model":"M4-SS4453-R"},{"manufacturer":"M4tel","market_name":"M4 SS4455","codename":"NOVA03A_S22A","model":"M4 SS4455"},{"manufacturer":"M4tel","market_name":"M4 SS4456","codename":"UDON04A_S19A","model":"M4 SS4456"},{"manufacturer":"M4tel","market_name":"M4 SS4457","codename":"DREAMPLUS03A-S14A","model":"M4 SS4457"},{"manufacturer":"M4tel","market_name":"M4 SS4457-R","codename":"M4-SS4457-R","model":"M4 SS4457-R"},{"manufacturer":"M4tel","market_name":"M4 SS4457-R","codename":"M4-SS4457-R","model":"M4-SS4457-R"},{"manufacturer":"M4tel","market_name":"M4 SS4458","codename":"TOUCHPLUS02A-S17A","model":"M4 SS4458"},{"manufacturer":"M4tel","market_name":"M4 SS4458-R","codename":"M4-SS4458-R","model":"M4-SS4458-R"},{"manufacturer":"MAZE","market_name":"Alpha","codename":"Alpha","model":"Alpha"},{"manufacturer":"MAZE","market_name":"Alpha_X","codename":"Alpha_X","model":"Alpha_X"},{"manufacturer":"MAZE","market_name":"Comet","codename":"Comet","model":"Comet"},{"manufacturer":"MDC Store","market_name":"Grand","codename":"Grand","model":"Grand"},{"manufacturer":"MDC Store","market_name":"MDC GrandPro","codename":"MDC_Grand_Pro","model":"Grand Pro"},{"manufacturer":"MDC Store","market_name":"Nova","codename":"Nova","model":"Nova"},{"manufacturer":"MDC Store","market_name":"Optima","codename":"Optima","model":"Optima"},{"manufacturer":"MDC Store","market_name":"Prime_S","codename":"Prime_S","model":"Prime_S"},{"manufacturer":"MG Series","market_name":"Any 302","codename":"TR10CS2_3","model":"TR10CS2"},{"manufacturer":"MG series","market_name":"Any 302","codename":"TR10CS1_15","model":"TR10CS1"},{"manufacturer":"MG series","market_name":"Any 302","codename":"TR10CS2_2","model":"TR10CS2"},{"manufacturer":"MG series","market_name":"Any 302","codename":"TR10CS2_3","model":"TR10CS2"},{"manufacturer":"MG series","market_name":"Any 303","codename":"TR10CD2_2","model":"TR10CD2"},{"manufacturer":"MG series","market_name":"Any 303","codename":"TR10CD2_3","model":"TR10CD2"},{"manufacturer":"MJS","market_name":"T2702","codename":"T2702","model":"T2702"},{"manufacturer":"MOVI","market_name":"Movi Projector Phone","codename":"Movi","model":"Movi Projector Phone"},{"manufacturer":"MOVIC","market_name":"Dual","codename":"Dual","model":"Dual"},{"manufacturer":"MOVIC","market_name":"MOVIC-W2","codename":"MOVIC-W2","model":"MOVIC-W2"},{"manufacturer":"MPman","market_name":"MPDC1006","codename":"MPDC1006","model":"MPDC1006"},{"manufacturer":"MPman","market_name":"MPDC706","codename":"MPDC706","model":"MPDC706"},{"manufacturer":"MSI","market_name":"Primo73","codename":"N71J","model":"Primo73"},{"manufacturer":"MSI","market_name":"Primo76","codename":"N728","model":"Primo76"},{"manufacturer":"MSI","market_name":"Primo81","codename":"N821","model":"Primo 81"},{"manufacturer":"MSI","market_name":"Primo81","codename":"N821","model":"Primo81"},{"manufacturer":"MSI","market_name":"Primo81","codename":"Primo81","model":"Primo81"},{"manufacturer":"MTC","market_name":"982","codename":"MTC_982","model":"MTC 982"},{"manufacturer":"MTC","market_name":"Vodafone Smart mini","codename":"Vodafone_875","model":"MTC 970H"},{"manufacturer":"MTN Group","market_name":"5982C3","codename":"MTN-TBW5982C3","model":"MTN-TBW5982C3"},{"manufacturer":"MTN Group","market_name":"8978P","codename":"MTN-8978P","model":"MTN-8978P"},{"manufacturer":"MTN Group","market_name":"MTN Sm@rt L840","codename":"MTN-L840","model":"MTN Sm@rt L840"},{"manufacturer":"MTN Group","market_name":"MTN Sm@rt L860","codename":"MTN-L860","model":"MTN Sm@rt L860"},{"manufacturer":"MTN Group","market_name":"MTN Sm@rt L860","codename":"MTN-L860","model":"MTN-L860"},{"manufacturer":"MTN Group","market_name":"MTN Smart S730","codename":"MTN-S730","model":"MTN-S730"},{"manufacturer":"MTN Group","market_name":"MTN Smart S735","codename":"MTN-S735","model":"MTN-S735"},{"manufacturer":"MTN Group","market_name":"MTN Smart S810","codename":"MTN-S810","model":"MTN-S810"},{"manufacturer":"MTN Group","market_name":"MTN Steppa 2 LTE","codename":"Steppa2","model":"MTN Steppa 2 LTE"},{"manufacturer":"MTN Group","market_name":"S620","codename":"MTN-S620","model":"MTN-S620"},{"manufacturer":"MTN Group","market_name":"S720i","codename":"MTN-S720i","model":"MTN-S720i"},{"manufacturer":"MTN Group","market_name":"Sm@rt Mini S630","codename":"MTN-S630","model":"MTN-S630"},{"manufacturer":"MTN-E70","market_name":"MTN-E70","codename":"MTN-E70","model":"MTN-E70"},{"manufacturer":"MTT","market_name":"Master","codename":"Master","model":"M.T.T. Master"},{"manufacturer":"MTT","market_name":"Smart Fun","codename":"SmartFun","model":"M.T.T. Smart Fun"},{"manufacturer":"Mach Speed","market_name":"xtreme","codename":"X_treme_Play_Tab","model":"X-treme Play Tab"},{"manufacturer":"MachSpeed (Apollo Brands)","market_name":"STR-9.6-Tablet","codename":"STR_96_Tablet","model":"STR-9.6-Tablet"},{"manufacturer":"MachSpeed (Apollo Brands)","market_name":"Trio Stealth_10 Tablet","codename":"D_10AL","model":"Trio Stealth_10"},{"manufacturer":"MachSpeed (Apollo Brands)","market_name":"Trio Stealth_8 Tablet","codename":"D_8AL","model":"Trio Stealth_8"},{"manufacturer":"MachSpeed (Apollo Brands)","market_name":"Trio Stealth_9 Tablet","codename":"D_9AL","model":"Trio Stealth_9"},{"manufacturer":"MachSpeed (Apollo Brands)","market_name":"TrioStealth-7","codename":"TrioStealth-7","model":"TrioStealth-7"},{"manufacturer":"Mad Catz","market_name":"M.O.J.O.","codename":"mojo","model":"Mad Catz M.O.J.O."},{"manufacturer":"Majestic","market_name":"TAB 611 3G","codename":"TAB_611_3G","model":"TAB 611 3G"},{"manufacturer":"Majestic","market_name":"TAB_711_4G","codename":"TAB_711_4G","model":"TAB 711 4G"},{"manufacturer":"Making Life Simple","market_name":"Brace","codename":"iQM801","model":"iQM801"},{"manufacturer":"Making Life Simple","market_name":"MLS Novel 3G","codename":"iQ181011N","model":"iQ181011N"},{"manufacturer":"Making Life Simple","market_name":"MLS iQ1452aN","codename":"iQ1452aN","model":"iQ1452aN"},{"manufacturer":"Making Life Simple","market_name":"Stage","codename":"iQM1001","model":"iQM1001"},{"manufacturer":"Making Life Simple","market_name":"iQ1012N","codename":"iQ1012N","model":"iQ1012N"},{"manufacturer":"Making Life Simple","market_name":"iQ1019N","codename":"IQ1019N","model":"IQ1019N"},{"manufacturer":"Making Life Simple","market_name":"iQ1805N","codename":"iQ1805N","model":"iQ1805N"},{"manufacturer":"Making Life Simple","market_name":"iQ9013_4N","codename":"iQ9013_4N","model":"iQ9013_4N"},{"manufacturer":"Making Life Simple","market_name":"iQD700","codename":"iQD700","model":"iQD700"},{"manufacturer":"Making Life Simple","market_name":"iQE200","codename":"iQE200","model":"iQE200"},{"manufacturer":"Making Life Simple","market_name":"iQF 200","codename":"iQF200","model":"iQF 200"},{"manufacturer":"Making Life Simple","market_name":"iQGW516","codename":"iQGW516","model":"iQGW516"},{"manufacturer":"Making Life Simple","market_name":"iQK700","codename":"iQK700","model":"iQK700"},{"manufacturer":"Making Life Simple","market_name":"iQM960","codename":"iQM960","model":"iQM960"},{"manufacturer":"Making Life Simple","market_name":"iQR704","codename":"iQR704","model":"iQR704"},{"manufacturer":"Making Life Simple","market_name":"iQS300","codename":"iQS300","model":"iQS300"},{"manufacturer":"Making Life Simple","market_name":"iQT800","codename":"iQT800","model":"iQT800"},{"manufacturer":"Making Life Simple","market_name":"iQW503","codename":"iQW503","model":"iQW503"},{"manufacturer":"Making Life Simple","market_name":"iQW553N","codename":"iQW553N","model":"iQW553N"},{"manufacturer":"Making Life Simple","market_name":"iQW603","codename":"iQW603","model":"iQW603"},{"manufacturer":"Malata","market_name":"UV350","codename":"UV350","model":"UV350"},{"manufacturer":"Manta","market_name":"MSP4507","codename":"MSP4507","model":"MSP4507"},{"manufacturer":"Marshall","market_name":"London","codename":"KB-1501","model":"London"},{"manufacturer":"Masstel","market_name":"Juno_Q6","codename":"Masstel_Juno_Q6","model":"Juno Q6"},{"manufacturer":"Masstel","market_name":"LT52","codename":"Masstel_LT52","model":"Masstel LT52"},{"manufacturer":"Masstel","market_name":"Masstel Juno Q5","codename":"Masstel_Juno_Q5","model":"Masstel_Juno_Q5"},{"manufacturer":"Masstel","market_name":"Masstel Juno Q5 Plus","codename":"Masstel_Juno_Q5Plus","model":"Masstel_Juno_Q5Plus"},{"manufacturer":"Masstel","market_name":"Masstel Juno Q7","codename":"Masstel_Juno_Q7","model":"Juno Q7"},{"manufacturer":"Masstel","market_name":"Masstel Juno S6","codename":"Masstel_Juno_S6","model":"Masstel_Juno_S6"},{"manufacturer":"Masstel","market_name":"Masstel Tab7","codename":"3G_Tablet_PC","model":"Masstel Tab7"},{"manufacturer":"Masstel","market_name":"Masstel Tab8","codename":"Masstel_Tab8","model":"Masstel Tab8"},{"manufacturer":"Masstel","market_name":"Masstel_Tab10","codename":"Masstel_Tab10","model":"Masstel Tab10"},{"manufacturer":"Masstel","market_name":"N535","codename":"Masstel_N535","model":"Masstel N535"},{"manufacturer":"Masstel","market_name":"Tab7LTE","codename":"Masstel_Tab7LTE","model":"Masstel_Tab7LTE"},{"manufacturer":"Maxcom","market_name":"MS453","codename":"MS453","model":"MS453"},{"manufacturer":"Maxcom","market_name":"MS457","codename":"MS457","model":"MS457"},{"manufacturer":"Maxcom","market_name":"MS457PLUS","codename":"MS457PLUS","model":"MS457PLUS"},{"manufacturer":"Maxcom","market_name":"MS459","codename":"MS459","model":"MS459"},{"manufacturer":"Maxcom","market_name":"MS514","codename":"MS514","model":"MS514"},{"manufacturer":"Maxcom","market_name":"MS553","codename":"MS553","model":"MS553"},{"manufacturer":"Maxis","market_name":"NeXT M2","codename":"VFD610","model":"VFD 610"},{"manufacturer":"Maxis","market_name":"NeXT X1","codename":"VFD710","model":"VFD 710"},{"manufacturer":"Maxtron","market_name":"S9","codename":"S9","model":"S9"},{"manufacturer":"Maxvi","market_name":"Maxvi_MS401","codename":"Maxvi_MS401","model":"Maxvi_MS401"},{"manufacturer":"Maxwest","market_name":"Astro 5N LTE","codename":"Astro_5N_LTE","model":"Astro_5N_LTE"},{"manufacturer":"Maxwest","market_name":"Astro_55N_LTE","codename":"Astro_55N_LTE","model":"Astro 55N LTE"},{"manufacturer":"Maxwest","market_name":"MAXWEST","codename":"Black765857703671","model":"AstroPhablet7s"},{"manufacturer":"Maxwest","market_name":"Nitro 4N LTE","codename":"Nitro_4N_LTE","model":"Nitro 4N LTE"},{"manufacturer":"Maxwest","market_name":"Nitro 55N","codename":"Nitro_55N","model":"Nitro 55N"},{"manufacturer":"Maxwest","market_name":"Nitro 5N","codename":"Nitro_5N","model":"Nitro_5N"},{"manufacturer":"Maxwest","market_name":"Ranger 5","codename":"Ranger_5","model":"Ranger_5"},{"manufacturer":"MeanIT","market_name":"C4","codename":"C4","model":"C4"},{"manufacturer":"MeanIT","market_name":"meanIT C80C81","codename":"meanIT_C80C81","model":"meanIT_C80C81"},{"manufacturer":"MeanIT","market_name":"meanIT_C10C11","codename":"meanIT_C10C11","model":"meanIT_C10C11"},{"manufacturer":"MeanIT","market_name":"meanIT_K7","codename":"meanIT_K7","model":"meanIT_K7"},{"manufacturer":"Mecer","market_name":"101P51C","codename":"101P51C","model":"101P51C"},{"manufacturer":"Mecer","market_name":"101P51D","codename":"101P51D","model":"101P51D"},{"manufacturer":"Mecer","market_name":"800P31C","codename":"800P31C","model":"800P31C"},{"manufacturer":"Mecer","market_name":"800P71D","codename":"800P71D","model":"800P71D"},{"manufacturer":"Mecer","market_name":"M785P","codename":"M785P","model":"M785P"},{"manufacturer":"Mecer","market_name":"M86Q9-3G","codename":"M86Q9-3G","model":"M86Q9-3G"},{"manufacturer":"Mecer","market_name":"MF716","codename":"MF716","model":"MF716"},{"manufacturer":"Mecer","market_name":"MF716+","codename":"MF716_Plus","model":"MF716+"},{"manufacturer":"Mecer","market_name":"MW16Q9-3G","codename":"MW16Q9_3G","model":"MW16Q9_3G"},{"manufacturer":"Mecer","market_name":"MW16Q9-4G","codename":"MW16Q9_4G","model":"MW16Q9_4G"},{"manufacturer":"Mecer","market_name":"TEI11011","codename":"TEI11011MST","model":"TEI11011MST"},{"manufacturer":"Mecer","market_name":"TF10EA2","codename":"TF10EA2_11","model":"TF10EA2"},{"manufacturer":"Mecer","market_name":"TF10MK1","codename":"TF10MK1_2","model":"TF10MK1"},{"manufacturer":"Mediacom","market_name":"G5M","codename":"M-PPxG5M","model":"M-PPxG5M"},{"manufacturer":"Mediacom","market_name":"M-PPAG4","codename":"M-PPAG4","model":"M-PPAG4"},{"manufacturer":"Mediacom","market_name":"M-PPxG4P","codename":"G4P","model":"M-PPxG4P"},{"manufacturer":"Mediacom","market_name":"M-PPxG5","codename":"M-PPxG5","model":"M-PPxG5"},{"manufacturer":"Mediacom","market_name":"M-PPxG7","codename":"M-PPxG7","model":"M-PPxG7"},{"manufacturer":"Mediacom","market_name":"M-PPxS5","codename":"M-PPxS5","model":"M-PPxS5"},{"manufacturer":"Mediacom","market_name":"M-PPxS5P","codename":"M-PPxS5P","model":"M-PPxS5P"},{"manufacturer":"Mediacom","market_name":"M-PPxS6","codename":"M-PPxS6","model":"M-PPxS6"},{"manufacturer":"Mediacom","market_name":"M-PPxS6P","codename":"M-PPxS6P","model":"M-PPxS6P"},{"manufacturer":"Mediacom","market_name":"M-PPxS7","codename":"M-PPxS7","model":"M-PPxS7"},{"manufacturer":"Mediacom","market_name":"M-PPxS7P","codename":"M-PPxS7P","model":"M-PPxS7P"},{"manufacturer":"Mediacom","market_name":"M-SP10HXxH","codename":"M-SP10HXxH","model":"M-SP10HXxH"},{"manufacturer":"Mediacom","market_name":"M-SP10MXHA","codename":"SmartPad","model":"M-SP10MXHA"},{"manufacturer":"Mediacom","market_name":"M-SP10MXHL","codename":"M-SP10MXHL","model":"M-SP10MXHL"},{"manufacturer":"Mediacom","market_name":"M-SP1AGO3G","codename":"M-SP1AGO3G","model":"M-SP1AGO3G"},{"manufacturer":"Mediacom","market_name":"M-SP7HXAH","codename":"M-SP7HXAH","model":"M-SP7HXAH"},{"manufacturer":"Mediacom","market_name":"M-SP7xGO3G","codename":"M-SP7xGO3G","model":"M-SP7xGO3G"},{"manufacturer":"Mediacom","market_name":"M-SP8HXAH","codename":"M-SP8HXAH","model":"M-SP8HXAH"},{"manufacturer":"Mediacom","market_name":"M-SP8MXA","codename":"SP8MXA","model":"M-SP8MXA"},{"manufacturer":"Medion","market_name":"E1050X","codename":"E1050X","model":"E1050X"},{"manufacturer":"Medion","market_name":"E1051X","codename":"E1051X","model":"E1051X"},{"manufacturer":"Medion","market_name":"E4502","codename":"E4502","model":"MEDION E4502"},{"manufacturer":"Medion","market_name":"E4506","codename":"E4506","model":"MEDION E4506"},{"manufacturer":"Medion","market_name":"E4507","codename":"B4570","model":"B4570"},{"manufacturer":"Medion","market_name":"E5004","codename":"E5004","model":"MEDION E5004"},{"manufacturer":"Medion","market_name":"E5005","codename":"B5060","model":"B5060"},{"manufacturer":"Medion","market_name":"E5006/P5006","codename":"B5032","model":"B5032"},{"manufacturer":"Medion","market_name":"E5008","codename":"B5070","model":"B5070"},{"manufacturer":"Medion","market_name":"E5504","codename":"B5530","model":"MEDION B5530"},{"manufacturer":"Medion","market_name":"E691X","codename":"E691X","model":"E691X"},{"manufacturer":"Medion","market_name":"E731x","codename":"LIFETAB_E731X","model":"LIFETAB_E731X"},{"manufacturer":"Medion","market_name":"LIFETAB E10316","codename":"LIFETAB_E10316","model":"BOSCH_E10316"},{"manufacturer":"Medion","market_name":"LIFETAB E10316","codename":"LIFETAB_E10316","model":"LIFETAB_E10316"},{"manufacturer":"Medion","market_name":"LIFETAB E10320","codename":"LIFETAB_E10320","model":"LIFETAB_E10320"},{"manufacturer":"Medion","market_name":"LIFETAB E10320","codename":"LIFETAB_E10320","model":"MICROSTAR_E10319"},{"manufacturer":"Medion","market_name":"LIFETAB E1041X","codename":"E1041X","model":"E1041X"},{"manufacturer":"Medion","market_name":"LIFETAB E1060X","codename":"E1060X","model":"E1060X"},{"manufacturer":"Medion","market_name":"LIFETAB E723X","codename":"LIFETAB_E723X","model":"LIFETAB_E723X"},{"manufacturer":"Medion","market_name":"LIFETAB E7313","codename":"LIFETAB_E7313","model":"LIFETAB_E7313"},{"manufacturer":"Medion","market_name":"LIFETAB E7316","codename":"LIFETAB_E7316","model":"LIFETAB_E7316"},{"manufacturer":"Medion","market_name":"LIFETAB E7316","codename":"LIFETAB_E7316","model":"LIFETAB_S7316"},{"manufacturer":"Medion","market_name":"LIFETAB E732X","codename":"LIFETAB_E732X","model":"LIFETAB_E732X"},{"manufacturer":"Medion","market_name":"LIFETAB E732X","codename":"LIFETAB_E733X","model":"LIFETAB_E733X"},{"manufacturer":"Medion","market_name":"LIFETAB E732X","codename":"LIFETAB_E733X","model":"LIFETAB_S733X"},{"manufacturer":"Medion","market_name":"LIFETAB P1034X","codename":"lifetab_p1034x","model":"LIFETAB_P1034X"},{"manufacturer":"Medion","market_name":"LIFETAB P733x","codename":"lifetab_p733x","model":"LIFETAB_P733X"},{"manufacturer":"Medion","market_name":"LIFETAB P831X","codename":"lifetab_p831x","model":"LIFETAB_P831X"},{"manufacturer":"Medion","market_name":"LIFETAB P831X","codename":"lifetab_p831x","model":"LIFETAB_P831X.2"},{"manufacturer":"Medion","market_name":"LIFETAB P891X","codename":"lifetab_p891x","model":"LIFETAB_P891X"},{"manufacturer":"Medion","market_name":"LIFETAB P970X","codename":"lifetab_p970x","model":"LIFETAB_P970X"},{"manufacturer":"Medion","market_name":"LIFETAB S1032X","codename":"S1032X","model":"S1032X"},{"manufacturer":"Medion","market_name":"LIFETAB S1033X","codename":"LIFETAB_S1033X","model":"LIFETAB_S1033X"},{"manufacturer":"Medion","market_name":"LIFETAB S1034X","codename":"lifetab_s1034x","model":"LIFETAB_S1034X"},{"manufacturer":"Medion","market_name":"LIFETAB S785X","codename":"LIFETAB_S785X","model":"LIFETAB_S785X"},{"manufacturer":"Medion","market_name":"LIFETAB S786x","codename":"LIFETAB_S786X","model":"LIFETAB_S786X"},{"manufacturer":"Medion","market_name":"LIFETAB S831X","codename":"LIFETAB_S831X","model":"LIFETAB_S831X"},{"manufacturer":"Medion","market_name":"LIFETAB_S1036X","codename":"lifetab_s1036x","model":"LIFETAB_S1036X"},{"manufacturer":"Medion","market_name":"Lifetab P9514","codename":"LIFETAB_P9514","model":"LIFETAB_P9514"},{"manufacturer":"Medion","market_name":"Media Base P740X","codename":"P740X","model":"P740X"},{"manufacturer":"Medion","market_name":"P1032X","codename":"P1032X","model":"P1032X"},{"manufacturer":"Medion","market_name":"P1035X","codename":"P1035X","model":"P1035X"},{"manufacturer":"Medion","market_name":"P1050X","codename":"P1050X","model":"P1040X"},{"manufacturer":"Medion","market_name":"P1050X","codename":"P1050X","model":"P1050X"},{"manufacturer":"Medion","market_name":"P1060X","codename":"P1060X","model":"P1060X"},{"manufacturer":"Medion","market_name":"P1060X","codename":"P1060X","model":"X1060X"},{"manufacturer":"Medion","market_name":"P4501","codename":"P4501","model":"P4501"},{"manufacturer":"Medion","market_name":"P5004","codename":"P5004","model":"MEDION P5004"},{"manufacturer":"Medion","market_name":"P5005","codename":"P5005","model":"MEDION P5005"},{"manufacturer":"Medion","market_name":"P5015","codename":"P5015","model":"MEDION P5015"},{"manufacturer":"Medion","market_name":"P73035","codename":"P72035","model":"P72035"},{"manufacturer":"Medion","market_name":"P850X","codename":"P850X","model":"P850X"},{"manufacturer":"Medion","market_name":"P851X","codename":"P851X","model":"P851X"},{"manufacturer":"Medion","market_name":"S1035X","codename":"S1035X","model":"S1035X"},{"manufacturer":"Medion","market_name":"S5004","codename":"S5004","model":"MEDION S5004"},{"manufacturer":"Medion","market_name":"S5504","codename":"B5531","model":"B5531"},{"manufacturer":"Medion","market_name":"S7322","codename":"LIFETAB_S732X","model":"LIFETAB_S732X"},{"manufacturer":"Medion","market_name":"X1030x","codename":"X1030X","model":"X1030X"},{"manufacturer":"Medion","market_name":"X1031X","codename":"X1031X","model":"X1031X"},{"manufacturer":"Medion","market_name":"X5520","codename":"B5532","model":"B5532"},{"manufacturer":"Medion","market_name":"X6001","codename":"X6001","model":"MEDION X6001"},{"manufacturer":"Medion","market_name":"microstar E10319","codename":"E10319","model":"E10319"},{"manufacturer":"MegaFon","market_name":"Login 3","codename":"MFLogin3","model":"MegaFon Login 3"},{"manufacturer":"MegaFon","market_name":"MFLogin3T","codename":"MFLogin3T","model":"MFLogin3T"},{"manufacturer":"MegaFon","market_name":"MFLoginPh","codename":"MFLoginPh","model":"MFLoginPh"},{"manufacturer":"MegaFon","market_name":"MS4B","codename":"Viper_LTE","model":"ALCATEL ONE TOUCH 7030R"},{"manufacturer":"MegaFon","market_name":"MS4B","codename":"Viper_LTE","model":"ALCATEL ONE TOUCH 7030Y"},{"manufacturer":"MegaFon","market_name":"MS4B","codename":"Viper_LTE","model":"MS4B"},{"manufacturer":"MegaFon","market_name":"MT3A","codename":"MT3A","model":"MT3A"},{"manufacturer":"Megahouse","market_name":"CP-D403","codename":"CP-D403","model":"CP-D403"},{"manufacturer":"Meiigoo","market_name":"S8","codename":"MEIIGOO_S8","model":"S8"},{"manufacturer":"Meitu","market_name":"M4","codename":"M4","model":"Meitu M4"},{"manufacturer":"Meitu","market_name":"M6","codename":"M6","model":"MP1503"},{"manufacturer":"Meitu","market_name":"M8s","codename":"MayaS","model":"MP1709"},{"manufacturer":"Meitu","market_name":"Maya","codename":"Maya","model":"MP1603"},{"manufacturer":"Meitu","market_name":"Meitu T8s","codename":"VictoriaS","model":"MP1701"},{"manufacturer":"Meitu","market_name":"Meitu V6","codename":"Vivian","model":"MP1605"},{"manufacturer":"Meitu","market_name":"V4","codename":"V4","model":"Meitu V4"},{"manufacturer":"Meitu","market_name":"V4s","codename":"V4s","model":"Meitu V4s"},{"manufacturer":"Meitu","market_name":"Victoria","codename":"Victoria","model":"MP1602"},{"manufacturer":"Meizu","market_name":"15","codename":"15","model":"15"},{"manufacturer":"Meizu","market_name":"15 Lite","codename":"15Lite","model":"15 Lite"},{"manufacturer":"Meizu","market_name":"15 Plus","codename":"15Plus","model":"15 Plus"},{"manufacturer":"Meizu","market_name":"E3","codename":"MeizuE3","model":"MEIZU E3"},{"manufacturer":"Meizu","market_name":"M15","codename":"M15","model":"M15"},{"manufacturer":"Meizu","market_name":"M6","codename":"meizu_M6","model":"M6"},{"manufacturer":"Meizu","market_name":"M6","codename":"meizu_M6","model":"MEIZU M6"},{"manufacturer":"Meizu","market_name":"M6 Note","codename":"M6Note","model":"M6 Note"},{"manufacturer":"Meizu","market_name":"M6s","codename":"MeizuM6s","model":"Meizu M6s"},{"manufacturer":"Meizu","market_name":"M6s","codename":"MeizumbluS6","model":"Meizu mblu S6"},{"manufacturer":"Meizu","market_name":"M712C","codename":"M712C","model":"M712C"},{"manufacturer":"Meizu","market_name":"Meizu S6","codename":"MeizuS6","model":"M712C"},{"manufacturer":"Meizu","market_name":"Meizu S6","codename":"MeizuS6","model":"Meizu S6"},{"manufacturer":"Meizu","market_name":"PRO 7","codename":"PRO7H","model":"PRO 7-H"},{"manufacturer":"Meizu","market_name":"PRO 7","codename":"PRO7S","model":"PRO 7"},{"manufacturer":"Meizu","market_name":"PRO 7","codename":"PRO7S","model":"PRO 7-S"},{"manufacturer":"Meizu","market_name":"PRO 7 Plus","codename":"PRO7Plus","model":"PRO 7 Plus"},{"manufacturer":"Memorex","market_name":"MTAB-07530A","codename":"MTAB-07530A","model":"MTAB-07530A"},{"manufacturer":"Memorex","market_name":"MTAB-0753AK","codename":"MTAB-07535AK","model":"MTAB-07535AK"},{"manufacturer":"Memorex","market_name":"MTAB-08530A","codename":"MTAB-08530A","model":"MTAB-08530A"},{"manufacturer":"Memorex","market_name":"MTAB-09541AB","codename":"MTAB-09541AB","model":"MTAB-09541AB"},{"manufacturer":"Mgt electric","market_name":"Lumyai","codename":"Lumyai","model":"Lumyai"},{"manufacturer":"Mgt electric","market_name":"M2","codename":"M2","model":"M2"},{"manufacturer":"Mgt electric","market_name":"MGT_T4","codename":"T4","model":"T4"},{"manufacturer":"Mgt electric","market_name":"Super","codename":"Super","model":"Super"},{"manufacturer":"Micromax","market_name":"A110","codename":"s9081","model":"Micromax A110"},{"manufacturer":"Micromax","market_name":"A111","codename":"A111","model":"A111"},{"manufacturer":"Micromax","market_name":"A116","codename":"A116","model":"A116"},{"manufacturer":"Micromax","market_name":"A240","codename":"A240","model":"A240"},{"manufacturer":"Micromax","market_name":"A27","codename":"A27","model":"A27"},{"manufacturer":"Micromax","market_name":"A44","codename":"tinnoes13_s7050","model":"A44"},{"manufacturer":"Micromax","market_name":"A45","codename":"tinnoes73_s8030_2g","model":"A45"},{"manufacturer":"Micromax","market_name":"A50","codename":"kpt73_gb","model":"Micromax A50"},{"manufacturer":"Micromax","market_name":"A54","codename":"A54","model":"A54"},{"manufacturer":"Micromax","market_name":"A56","codename":"A56","model":"Micromax A56"},{"manufacturer":"Micromax","market_name":"A57","codename":"A57","model":"A57"},{"manufacturer":"Micromax","market_name":"A57","codename":"A57","model":"Micromax A57"},{"manufacturer":"Micromax","market_name":"A62","codename":"A62","model":"Micromax A62"},{"manufacturer":"Micromax","market_name":"A72","codename":"A72","model":"Micromax A72"},{"manufacturer":"Micromax","market_name":"A73","codename":"A73","model":"A73"},{"manufacturer":"Micromax","market_name":"A73","codename":"A73","model":"Micromax A73"},{"manufacturer":"Micromax","market_name":"A75","codename":"A75","model":"A75"},{"manufacturer":"Micromax","market_name":"A78","codename":"Micromax","model":"A78"},{"manufacturer":"Micromax","market_name":"A84","codename":"A84","model":"A84"},{"manufacturer":"Micromax","market_name":"A87","codename":"A87","model":"A87"},{"manufacturer":"Micromax","market_name":"A87","codename":"A87","model":"Micromax A87"},{"manufacturer":"Micromax","market_name":"A88","codename":"A88","model":"A88"},{"manufacturer":"Micromax","market_name":"A89","codename":"A89","model":"A89"},{"manufacturer":"Micromax","market_name":"A91","codename":"A91","model":"A91"},{"manufacturer":"Micromax","market_name":"A91","codename":"A91","model":"Micromax A91"},{"manufacturer":"Micromax","market_name":"BOLT","codename":"A068","model":"A068"},{"manufacturer":"Micromax","market_name":"BOLT","codename":"A069","model":"Micromax A069"},{"manufacturer":"Micromax","market_name":"BOLT","codename":"A24","model":"Micromax A24"},{"manufacturer":"Micromax","market_name":"BOLT","codename":"A34","model":"Micromax A34"},{"manufacturer":"Micromax","market_name":"BOLT","codename":"A67","model":"Micromax A67"},{"manufacturer":"Micromax","market_name":"BOLT","codename":"A69","model":"Micromax A69"},{"manufacturer":"Micromax","market_name":"BOLT","codename":"A69_IN","model":"Micromax A69"},{"manufacturer":"Micromax","market_name":"BOLT","codename":"Q332","model":"Micromax Q332"},{"manufacturer":"Micromax","market_name":"BOLT","codename":"Q338","model":"Micromax Q338"},{"manufacturer":"Micromax","market_name":"Bharat 4","codename":"Q440Plus","model":"Micromax Q440Plus"},{"manufacturer":"Micromax","market_name":"Bharat 5","codename":"Bharat_5","model":"Micromax Bharat 5"},{"manufacturer":"Micromax","market_name":"Bharat 5 Plus","codename":"Bharat_5_Plus","model":"Micromax Bharat 5 Plus"},{"manufacturer":"Micromax","market_name":"Bhart 5 PRO","codename":"Bharat_5_Pro","model":"B5Pro"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"A064","model":"Micromax A064"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"A065","model":"Micromax A065"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"A066","model":"Micromax A066"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"A067","model":"Micromax A067"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"A082","model":"Micromax A082"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"A35","model":"A35"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"A79","model":"Micromax A79"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"A82","model":"Micromax A82"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"AD3520","model":"Micromax AD3520"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"AD4500","model":"Micromax AD4500"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"D200","model":"Micromax_D200"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"D303","model":"Micromax D303"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"D304","model":"Micromax D304"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"D305","model":"Micromax D305"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"D320","model":"Micromax D320"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"D321","model":"Micromax D321"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"D333","model":"Micromax D333"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"D340","model":"Micromax D340"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"Q3001","model":"Micromax Q3001"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"Q301","model":"Micromax Q301"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"Q303","model":"Micromax Q303"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"Q323","model":"Micromax Q323"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"Q324","model":"Micromax Q324"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"Q325","model":"Micromax Q325"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"Q326","model":"Micromax Q326"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"Q331","model":"Micromax Q331"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"Q333","model":"Micromax Q333"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"Q335","model":"Micromax Q335"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"Q336","model":"Micromax Q336"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"Q341","model":"Micromax Q341"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"Q346","model":"Micromax Q346"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"Q381","model":"Micromax Q381"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"Q383","model":"Micromax Q383"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"S300","model":"Micromax S300"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"S301","model":"Micromax S301"},{"manufacturer":"Micromax","market_name":"Bolt","codename":"S302","model":"Micromax S302"},{"manufacturer":"Micromax","market_name":"Bolt Juice","codename":"Q3551","model":"Micromax Q3551"},{"manufacturer":"Micromax","market_name":"Bolt Pace","codename":"Q402","model":"Micromax Q402"},{"manufacturer":"Micromax","market_name":"Bolt Q3301","codename":"Q3301","model":"Micromax Q3301"},{"manufacturer":"Micromax","market_name":"Bolt Selfie","codename":"Q424","model":"Micromax Q424"},{"manufacturer":"Micromax","market_name":"Bolt Supreme 4","codename":"Q352","model":"Micromax Q352"},{"manufacturer":"Micromax","market_name":"CANVAS 2 COLOURS","codename":"A120","model":"Micromax A120"},{"manufacturer":"Micromax","market_name":"CANVAS 2 PLUS","codename":"A110Q","model":"A110Q"},{"manufacturer":"Micromax","market_name":"CANVAS 2 PLUS","codename":"s9086b","model":"Micromax A110Q"},{"manufacturer":"Micromax","market_name":"CANVAS 4","codename":"A210","model":"A210"},{"manufacturer":"Micromax","market_name":"CANVAS 4","codename":"s9111b","model":"A210"},{"manufacturer":"Micromax","market_name":"CANVAS BEAT","codename":"A114R","model":"Micromax A114R"},{"manufacturer":"Micromax","market_name":"CANVAS BLAZE","codename":"MT500","model":"MT500"},{"manufacturer":"Micromax","market_name":"CANVAS DOODLE 3","codename":"MicromaxA102","model":"Micromax A102"},{"manufacturer":"Micromax","market_name":"CANVAS DUET","codename":"AE90","model":"Micromax AE90"},{"manufacturer":"Micromax","market_name":"CANVAS DUET 2","codename":"EG111","model":"Micromax EG111"},{"manufacturer":"Micromax","market_name":"CANVAS ELANZA 2","codename":"A121","model":"Micromax A121"},{"manufacturer":"Micromax","market_name":"CANVAS ENGAGE","codename":"A091","model":"Micromax A091"},{"manufacturer":"Micromax","market_name":"CANVAS ENTICE","codename":"A105","model":"Micromax A105"},{"manufacturer":"Micromax","market_name":"CANVAS GOLD","codename":"A300","model":"Micromax A300"},{"manufacturer":"Micromax","market_name":"CANVAS KNIGHT","codename":"A350","model":"Micromax A350"},{"manufacturer":"Micromax","market_name":"CANVAS KNIGHT","codename":"s9320ae","model":"Micromax A350"},{"manufacturer":"Micromax","market_name":"CANVAS MAGNUS","codename":"s9203","model":"Micromax A117"},{"manufacturer":"Micromax","market_name":"CANVAS POWER","codename":"A96","model":"Micromax A96"},{"manufacturer":"Micromax","market_name":"CANVAS TUBE","codename":"A118R","model":"Micromax A118R"},{"manufacturer":"Micromax","market_name":"CANVAS TURBO","codename":"A250","model":"A250"},{"manufacturer":"Micromax","market_name":"CANVAS TURBO","codename":"s9311","model":"A250"},{"manufacturer":"Micromax","market_name":"CANVAS TURBO MINI","codename":"s8513a","model":"Micromax A200"},{"manufacturer":"Micromax","market_name":"CANVAS UNITE 2","codename":"A106","model":"Micromax A106"},{"manufacturer":"Micromax","market_name":"Canvas 2","codename":"Q4310","model":"Micromax Q4310"},{"manufacturer":"Micromax","market_name":"Canvas 4+","codename":"A315","model":"Micromax A315"},{"manufacturer":"Micromax","market_name":"Canvas 5","codename":"E481","model":"Micromax E481"},{"manufacturer":"Micromax","market_name":"Canvas 5 Lite","codename":"Q463","model":"Micromax Q463"},{"manufacturer":"Micromax","market_name":"Canvas 6","codename":"E485","model":"Micromax E485"},{"manufacturer":"Micromax","market_name":"Canvas 6 Pro","codename":"E484","model":"Micromax E484"},{"manufacturer":"Micromax","market_name":"Canvas A1","codename":"AQ4501_sprout","model":"Micromax AQ4501"},{"manufacturer":"Micromax","market_name":"Canvas A1","codename":"AQ4502_sprout","model":"Micromax AQ4502"},{"manufacturer":"Micromax","market_name":"Canvas AMAZE","codename":"Q395","model":"Micromax Q395"},{"manufacturer":"Micromax","market_name":"Canvas Blaze","codename":"Q400","model":"Micromax Q400"},{"manufacturer":"Micromax","market_name":"Canvas Blaze 4G Plus","codename":"Q414","model":"Micromax Q414"},{"manufacturer":"Micromax","market_name":"Canvas Doodle4","codename":"Q391","model":"Micromax Q391"},{"manufacturer":"Micromax","market_name":"Canvas Evok","codename":"E483","model":"Micromax E483"},{"manufacturer":"Micromax","market_name":"Canvas FIRE4G","codename":"Q411","model":"Micromax Q411"},{"manufacturer":"Micromax","market_name":"Canvas Fire","codename":"A093","model":"Micromax A093"},{"manufacturer":"Micromax","market_name":"Canvas Fire","codename":"A104","model":"Micromax A104"},{"manufacturer":"Micromax","market_name":"Canvas Fire 4G","codename":"Q462","model":"Micromax Q462"},{"manufacturer":"Micromax","market_name":"Canvas Fire 5","codename":"Q386","model":"Micromax Q386"},{"manufacturer":"Micromax","market_name":"Canvas Fire 6","codename":"Q428","model":"Micromax Q428"},{"manufacturer":"Micromax","market_name":"Canvas Fire3","codename":"A096","model":"Micromax A096"},{"manufacturer":"Micromax","market_name":"Canvas Fire4","codename":"A107","model":"Micromax A107"},{"manufacturer":"Micromax","market_name":"Canvas Fun","codename":"A76","model":"Micromax A76"},{"manufacturer":"Micromax","market_name":"Canvas HD Plus","codename":"A190","model":"Micromax A190"},{"manufacturer":"Micromax","market_name":"Canvas Hue","codename":"AQ5000","model":"Micromax AQ5000"},{"manufacturer":"Micromax","market_name":"Canvas Hue 2","codename":"A316","model":"Micromax A316"},{"manufacturer":"Micromax","market_name":"Canvas Infinity","codename":"HS2","model":"Micromax HS2"},{"manufacturer":"Micromax","market_name":"Canvas Infinity Life","codename":"HS1","model":"Micromax HS1"},{"manufacturer":"Micromax","market_name":"Canvas Infinity Pro","codename":"HS3","model":"Micromax_HS3"},{"manufacturer":"Micromax","market_name":"Canvas Juice","codename":"A77","model":"Micromax A77"},{"manufacturer":"Micromax","market_name":"Canvas Juice 3+","codename":"Q394","model":"Micromax Q394"},{"manufacturer":"Micromax","market_name":"Canvas Juice 4","codename":"Q382","model":"Micromax Q382"},{"manufacturer":"Micromax","market_name":"Canvas Juice 4G","codename":"Q461","model":"Micromax Q461"},{"manufacturer":"Micromax","market_name":"Canvas Juice 6","codename":"Q398","model":"Micromax Q398"},{"manufacturer":"Micromax","market_name":"Canvas Juice2","codename":"AQ5001","model":"Micromax AQ5001"},{"manufacturer":"Micromax","market_name":"Canvas Juice3","codename":"Q392","model":"Micromax Q392"},{"manufacturer":"Micromax","market_name":"Canvas Knight Cameo","codename":"A290","model":"Micromax A290"},{"manufacturer":"Micromax","market_name":"Canvas Knight2","codename":"KNIGHT2","model":"Micromax E471"},{"manufacturer":"Micromax","market_name":"Canvas L","codename":"A108","model":"Micromax A108"},{"manufacturer":"Micromax","market_name":"Canvas Magnus","codename":"A117","model":"Micromax A117"},{"manufacturer":"Micromax","market_name":"Canvas Magnus HD","codename":"Q421","model":"Micromax Q421"},{"manufacturer":"Micromax","market_name":"Canvas Mega","codename":"E353","model":"Micromax E353"},{"manufacturer":"Micromax","market_name":"Canvas Mega","codename":"Q417","model":"Micromax Q417"},{"manufacturer":"Micromax","market_name":"Canvas Mega 2","codename":"Q426","model":"Micromax Q426"},{"manufacturer":"Micromax","market_name":"Canvas Nitro","codename":"A310","model":"Micromax A310"},{"manufacturer":"Micromax","market_name":"Canvas Nitro","codename":"A311","model":"Micromax A311"},{"manufacturer":"Micromax","market_name":"Canvas Nitro2","codename":"E311","model":"Micromax E311"},{"manufacturer":"Micromax","market_name":"Canvas Pace 4G","codename":"Q416","model":"Micromax Q416"},{"manufacturer":"Micromax","market_name":"Canvas Pace MIni","codename":"Q401","model":"Micromax Q401"},{"manufacturer":"Micromax","market_name":"Canvas Pep","codename":"Q370","model":"Micromax Q370"},{"manufacturer":"Micromax","market_name":"Canvas Pep","codename":"Q371","model":"Micromax Q371"},{"manufacturer":"Micromax","market_name":"Canvas Pep","codename":"Q375","model":"Micromax Q375"},{"manufacturer":"Micromax","market_name":"Canvas Play","codename":"Q355","model":"Micromax Q355"},{"manufacturer":"Micromax","market_name":"Canvas Play 4G","codename":"Q412","model":"Micromax Q412"},{"manufacturer":"Micromax","market_name":"Canvas Play4G","codename":"Q469","model":"Micromax Q469"},{"manufacturer":"Micromax","market_name":"Canvas Pulse","codename":"E451","model":"Micromax E451"},{"manufacturer":"Micromax","market_name":"Canvas SPARK2","codename":"Q334","model":"Micromax Q334"},{"manufacturer":"Micromax","market_name":"Canvas Selfie","codename":"A255","model":"Micromax A255"},{"manufacturer":"Micromax","market_name":"Canvas Selfie 4","codename":"Q349","model":"Micromax Q349"},{"manufacturer":"Micromax","market_name":"Canvas Selfie Lens","codename":"Q345","model":"Micromax Q345"},{"manufacturer":"Micromax","market_name":"Canvas Space 2","codename":"Q480","model":"Micromax Q480"},{"manufacturer":"Micromax","market_name":"Canvas Space 2+","codename":"Q479","model":"Micromax Q479"},{"manufacturer":"Micromax","market_name":"Canvas Spark","codename":"Q380","model":"Micromax Q380"},{"manufacturer":"Micromax","market_name":"Canvas Spark 2 Plus","codename":"Q350","model":"Micromax Q350"},{"manufacturer":"Micromax","market_name":"Canvas Spark 3","codename":"Q380N","model":"Micromax Q380N"},{"manufacturer":"Micromax","market_name":"Canvas Spark 3","codename":"Q385","model":"Micromax Q385"},{"manufacturer":"Micromax","market_name":"Canvas Spark 4G","codename":"Q4201","model":"Micromax Q4201"},{"manufacturer":"Micromax","market_name":"Canvas Tab","codename":"F666","model":"MicromaxF666"},{"manufacturer":"Micromax","market_name":"Canvas Tab","codename":"P480","model":"MicromaxP480"},{"manufacturer":"Micromax","market_name":"Canvas Tab","codename":"P480","model":"P480"},{"manufacturer":"Micromax","market_name":"Canvas Tab","codename":"P681","model":"Micromax P681"},{"manufacturer":"Micromax","market_name":"Canvas Tab","codename":"P690","model":"Micromax P690"},{"manufacturer":"Micromax","market_name":"Canvas Tab","codename":"P701","model":"Micromax P701"},{"manufacturer":"Micromax","market_name":"Canvas Tab","codename":"P702","model":"MicromaxP702"},{"manufacturer":"Micromax","market_name":"Canvas Tab","codename":"P70221","model":"P70221"},{"manufacturer":"Micromax","market_name":"Canvas Tab","codename":"P802","model":"MicromaxP802"},{"manufacturer":"Micromax","market_name":"Canvas Tab","codename":"P810","model":"Micromax P810"},{"manufacturer":"Micromax","market_name":"Canvas Tabby","codename":"P469","model":"P469"},{"manufacturer":"Micromax","market_name":"Canvas Turbo","codename":"A250","model":"Micromax A250"},{"manufacturer":"Micromax","market_name":"Canvas Unite 4","codename":"Q427","model":"Micromax Q427"},{"manufacturer":"Micromax","market_name":"Canvas Unite 4 Pro","codename":"Q465","model":"Micromax Q465"},{"manufacturer":"Micromax","market_name":"Canvas XL2","codename":"A109","model":"Micromax A109"},{"manufacturer":"Micromax","market_name":"Canvas Xpress","codename":"A99","model":"Micromax A99"},{"manufacturer":"Micromax","market_name":"Canvas Xpress 2","codename":"E314","model":"Micromax E314"},{"manufacturer":"Micromax","market_name":"Canvas Xpress 4g","codename":"Q413","model":"Micromax Q413"},{"manufacturer":"Micromax","market_name":"Canvas tab","codename":"P290","model":"Micromax P290"},{"manufacturer":"Micromax","market_name":"Canvas tab","codename":"P470","model":"P470"},{"manufacturer":"Micromax","market_name":"Canvas tab","codename":"P666","model":"Micromax P666"},{"manufacturer":"Micromax","market_name":"Canvas tab","codename":"P680","model":"MicromaxP680"},{"manufacturer":"Micromax","market_name":"Doodle 4","codename":"Q491","model":"Micromax Q491"},{"manufacturer":"Micromax","market_name":"Dual 4","codename":"E4816","model":"Micromax E4816"},{"manufacturer":"Micromax","market_name":"EVOK DUAL NOTE","codename":"E4815","model":"Micromax E4815"},{"manufacturer":"Micromax","market_name":"Evok Dual Note","codename":"E4817","model":"Micromax E4817"},{"manufacturer":"Micromax","market_name":"Evok Note","codename":"E453","model":"Micromax E453"},{"manufacturer":"Micromax","market_name":"Evok Power","codename":"Q4260","model":"Micromax Q4260"},{"manufacturer":"Micromax","market_name":"MAD","codename":"A94","model":"Micromax A94"},{"manufacturer":"Micromax","market_name":"MIcromax Bharat 4","codename":"Q440","model":"Micromax Q440"},{"manufacturer":"Micromax","market_name":"Micromax Bharat 2 Plus","codename":"Q402Plus","model":"Micromax Q402+"},{"manufacturer":"Micromax","market_name":"Micromax Bharat 2 Plus","codename":"Q402Plus","model":"Micromax Q402Plus"},{"manufacturer":"Micromax","market_name":"Micromax C1","codename":"C1","model":"Micromax C1"},{"manufacturer":"Micromax","market_name":"Micromax C2A","codename":"C2A","model":"Micromax C2A"},{"manufacturer":"Micromax","market_name":"Micromax C2APLS","codename":"C2APlus","model":"Micromax C2APLS"},{"manufacturer":"Micromax","market_name":"Micromax Canvas 1","codename":"C1","model":"Micromax C1"},{"manufacturer":"Micromax","market_name":"Micromax Canvas Music M1","codename":"Q4261","model":"Micromax Q4261"},{"manufacturer":"Micromax","market_name":"Micromax Canvax 1(2018)","codename":"C1A","model":"Micromax C1A"},{"manufacturer":"Micromax","market_name":"Micromax Q353","codename":"Q353","model":"Micromax_Q353"},{"manufacturer":"Micromax","market_name":"Micromax Q353 Plus","codename":"Q353P","model":"Micromax_Q353P"},{"manufacturer":"Micromax","market_name":"Micromax Q402+","codename":"Q402Plus","model":"Micromax Q402+"},{"manufacturer":"Micromax","market_name":"Micromax Q437","codename":"Q437","model":"Micromax Q437"},{"manufacturer":"Micromax","market_name":"Micromax Q440","codename":"Q440","model":"Micromax Q440"},{"manufacturer":"Micromax","market_name":"Micromax Q454","codename":"Q454","model":"Micromax Q454"},{"manufacturer":"Micromax","market_name":"Micromax Selfie 2","codename":"Q4311","model":"Micromax Q4311"},{"manufacturer":"Micromax","market_name":"Micromax Selfie 2 Note","codename":"Q4601","model":"Micromax Q4601"},{"manufacturer":"Micromax","market_name":"Micromax Spark 4G Prime(2017)","codename":"Q452","model":"Micromax Q452"},{"manufacturer":"Micromax","market_name":"Nitro 3","codename":"E352","model":"Micromax E352"},{"manufacturer":"Micromax","market_name":"Nitro 4G","codename":"E455","model":"Micromax E455"},{"manufacturer":"Micromax","market_name":"P275","codename":"P275","model":"P275"},{"manufacturer":"Micromax","market_name":"P300","codename":"crane-M701C_mmx","model":"P300"},{"manufacturer":"Micromax","market_name":"Q327","codename":"Q327","model":"Micromax Q327"},{"manufacturer":"Micromax","market_name":"Q350R","codename":"Q350R","model":"Micromax Q350R"},{"manufacturer":"Micromax","market_name":"Q354","codename":"Q354","model":"Micromax Q354"},{"manufacturer":"Micromax","market_name":"SUPREME BOLT","codename":"Q300","model":"Micromax Q300"},{"manufacturer":"Micromax","market_name":"Selfie 2","codename":"Q340","model":"Micromax Q340"},{"manufacturer":"Micromax","market_name":"Selfie 3","codename":"E460","model":"Micromax E460"},{"manufacturer":"Micromax","market_name":"Selfie 3","codename":"Q348","model":"Micromax Q348"},{"manufacturer":"Micromax","market_name":"Sliver 5","codename":"Q450","model":"Micromax Q450"},{"manufacturer":"Micromax","market_name":"Spark  4G(2017)","codename":"Q409","model":"Micromax Q409"},{"manufacturer":"Micromax","market_name":"UNITE","codename":"A092","model":"Micromax A092"},{"manufacturer":"Micromax","market_name":"Unite 3","codename":"Q379","model":"Micromax Q379"},{"manufacturer":"Micromax","market_name":"Unite2","codename":"A106","model":"Micromax A106"},{"manufacturer":"Micromax","market_name":"Unite3","codename":"Q372","model":"Micromax Q372"},{"manufacturer":"Micromax","market_name":"Vdeo 1","codename":"Q4001","model":"Micromax Q4001"},{"manufacturer":"Micromax","market_name":"Vdeo 2","codename":"Q4101_Ru","model":"Micromax Q4101"},{"manufacturer":"Micromax","market_name":"Vdeo 3","codename":"Q4202","model":"Micromax Q4202"},{"manufacturer":"Micromax","market_name":"Vdeo 4","codename":"Q4251","model":"Micromax Q4251"},{"manufacturer":"Micromax","market_name":"Vdeo 5","codename":"Q4220","model":"Micromax Q4220"},{"manufacturer":"Micromax","market_name":"Xpress 2","codename":"E313","model":"Micromax E313"},{"manufacturer":"Micromax","market_name":"YUNIQUE","codename":"YUNIQUE","model":"YU4711"},{"manufacturer":"Micromax","market_name":"YUREKA S","codename":"YUREKA2","model":"YU5200"},{"manufacturer":"Micromax","market_name":"YUREKA S","codename":"YUREKA2","model":"YU5551"},{"manufacturer":"Micromax","market_name":"Yunique 2 Plus","codename":"YU5012","model":"YU5012"},{"manufacturer":"Micromax","market_name":"Yuphoria","codename":"YUPHORIA","model":"YU5010"},{"manufacturer":"Micromax","market_name":"Yutopia","codename":"YUTOPIA","model":"YU5050"},{"manufacturer":"Microtech","market_name":"e-tab_style_rev.3","codename":"e-tab_style_REV3","model":"e-tab_style_REV3"},{"manufacturer":"MiiA","market_name":"MT-733G","codename":"MT-733G","model":"MT-733G"},{"manufacturer":"MiiA","market_name":"MiiA","codename":"TA10CA1_2","model":"TA10CA1"},{"manufacturer":"Mikona","market_name":"MFHD_BT1067QC16IPS2","codename":"MFHD_BT1067QC16IPS2","model":"MFHD_BT1067QC16IPS2"},{"manufacturer":"Mikona","market_name":"MIKONA","codename":"MSW_BT767QC8TN","model":"MSW_BT767QC8TN"},{"manufacturer":"Mint","market_name":"Clover","codename":"M4CR","model":"M4CR"},{"manufacturer":"Mint","market_name":"Clover","codename":"M4CR","model":"M4CRD"},{"manufacturer":"Mint","market_name":"Emerald","codename":"Emerald","model":"Emerald_M55CR"},{"manufacturer":"Mint","market_name":"Emerald","codename":"Emerald","model":"Emerald_M55CRD"},{"manufacturer":"Mint","market_name":"M3CR2","codename":"Mint_Fox_Plus","model":"Mint Fox+"},{"manufacturer":"Mint","market_name":"M4","codename":"M4","model":"M4"},{"manufacturer":"Mint","market_name":"M4CR2","codename":"Mint_Clover_Plus","model":"Mint Clover+"},{"manufacturer":"Mint","market_name":"M5","codename":"MINT-M5","model":"M5"},{"manufacturer":"Mint","market_name":"M55LD","codename":"Mint_fire","model":"Mint_M55LD"},{"manufacturer":"Mint","market_name":"MINT Pandora","codename":"MINT_Pandora","model":"MINT Pandora"},{"manufacturer":"Mint","market_name":"MINT_Pearl_plus","codename":"MINT_Pearl_plus","model":"Pearl+_M5PD"},{"manufacturer":"Mint","market_name":"Pearl_Neo","codename":"Pearl_Neo","model":"Pearl_Neo"},{"manufacturer":"Mintt","market_name":"A1","codename":"A1","model":"A1"},{"manufacturer":"Mintt","market_name":"M1","codename":"M1","model":"M1"},{"manufacturer":"Mintt","market_name":"Ultramintt R1","codename":"Ultramintt_R1","model":"Ultramintt R1"},{"manufacturer":"Mio Tab","market_name":"MioTab","codename":"MioTab2016","model":"MioTab 2016"},{"manufacturer":"Mio Tab","market_name":"MioTab2017","codename":"MioTab2017","model":"MioTab2017"},{"manufacturer":"Miophone","market_name":"Mio Phone","codename":"MioPhone2016","model":"Mio Phone 2016"},{"manufacturer":"Miophone","market_name":"Mio Phone","codename":"MioPhone2017","model":"MioPhone2017"},{"manufacturer":"Mirage","market_name":"43T","codename":"MI-JI-43T","model":"MI-JI-43T"},{"manufacturer":"Mirage","market_name":"44T","codename":"MI-JI-44T","model":"MI-JI-44T"},{"manufacturer":"Mirage","market_name":"62S","codename":"62S","model":"62S"},{"manufacturer":"Mirage","market_name":"64T","codename":"MI-JI-64T","model":"MI-JI-64T"},{"manufacturer":"Mirage","market_name":"82S","codename":"MI-CH-82S","model":"MI-CH-82S"},{"manufacturer":"Mirage","market_name":"MI-SO-81T","codename":"MI-SO-81T","model":"MI-SO-81T"},{"manufacturer":"Mito","market_name":"A10","codename":"A10_sprout","model":"MITO A10"},{"manufacturer":"Mito","market_name":"A10","codename":"A10_sprout","model":"MITO_A10"},{"manufacturer":"Mito","market_name":"A62","codename":"A62","model":"A62"},{"manufacturer":"Mito","market_name":"A67","codename":"A67","model":"Mito A67"},{"manufacturer":"Mito","market_name":"A880","codename":"A880","model":"MITO A880"},{"manufacturer":"Mito","market_name":"MITO A17","codename":"MITO_A17","model":"MITO A17"},{"manufacturer":"Mito","market_name":"MITO A21","codename":"A21","model":"MITO A21"},{"manufacturer":"Mito","market_name":"MITO A39","codename":"A39","model":"mito A39"},{"manufacturer":"Mito","market_name":"MITO T8","codename":"MITO_T8","model":"MITO T8"},{"manufacturer":"Mito","market_name":"MITO_A19_1GB","codename":"MITO_A19_1GB","model":"MITO_A19_1GB"},{"manufacturer":"Mito","market_name":"MITO_A19_2GB","codename":"MITO_A19_2GB","model":"MITO_A19_2GB"},{"manufacturer":"Mito","market_name":"T5091A","codename":"MITO_A16","model":"MITO A16"},{"manufacturer":"Mobell","market_name":"Mobell S50","codename":"Mobell_S50","model":"Mobell S50"},{"manufacturer":"Mobell","market_name":"NOVA P3","codename":"NOVA_P3","model":"NOVA P3"},{"manufacturer":"Mobell","market_name":"S40","codename":"S40","model":"S40"},{"manufacturer":"Mobicell","market_name":"4U","codename":"4U","model":"4U"},{"manufacturer":"Mobicell","market_name":"ARC","codename":"ARC","model":"ARC"},{"manufacturer":"Mobicell","market_name":"Air","codename":"Mobicel_Air","model":"Air"},{"manufacturer":"Mobicell","market_name":"BERRY","codename":"BERRY","model":"BERRY"},{"manufacturer":"Mobicell","market_name":"CHERRY","codename":"CHERRY","model":"CHERRY"},{"manufacturer":"Mobicell","market_name":"COSMO","codename":"COSMO","model":"COSMO"},{"manufacturer":"Mobicell","market_name":"Candy","codename":"Candy","model":"Candy"},{"manufacturer":"Mobicell","market_name":"DANDY","codename":"DANDY","model":"DANDY"},{"manufacturer":"Mobicell","market_name":"ECHO","codename":"ECHO","model":"ECHO"},{"manufacturer":"Mobicell","market_name":"FEVER","codename":"FEVER","model":"FEVER"},{"manufacturer":"Mobicell","market_name":"FRIO","codename":"FRIO","model":"FRIO"},{"manufacturer":"Mobicell","market_name":"HERO X","codename":"HERO_X","model":"HERO_X"},{"manufacturer":"Mobicell","market_name":"Icon","codename":"Mobicel_Icon","model":"Icon"},{"manufacturer":"Mobicell","market_name":"METRO2","codename":"METRO2","model":"MOBICEL METRO2"},{"manufacturer":"Mobicell","market_name":"Matrix","codename":"Matrix","model":"Matrix"},{"manufacturer":"Mobicell","market_name":"Mobicel","codename":"Sonic","model":"Sonic"},{"manufacturer":"Mobicell","market_name":"Mobicel","codename":"Venus","model":"Venus"},{"manufacturer":"Mobicell","market_name":"Mobicel GEM","codename":"GEM","model":"GEM"},{"manufacturer":"Mobicell","market_name":"Mobicel ICE","codename":"ICE","model":"ICE"},{"manufacturer":"Mobicell","market_name":"Mobicel_R1","codename":"Mobicel_R1","model":"Mobicel_R1"},{"manufacturer":"Mobicell","market_name":"NEO","codename":"NEO","model":"NEO"},{"manufacturer":"Mobicell","market_name":"ONYX","codename":"ONYX","model":"ONYX"},{"manufacturer":"Mobicell","market_name":"PLAY","codename":"PLAY","model":"PLAY"},{"manufacturer":"Mobicell","market_name":"PLUM","codename":"PLUM","model":"PLUM"},{"manufacturer":"Mobicell","market_name":"PURE","codename":"PURE","model":"PURE"},{"manufacturer":"Mobicell","market_name":"PURE MINI","codename":"PURE_MINI","model":"PURE MINI"},{"manufacturer":"Mobicell","market_name":"PURE_PLUS","codename":"PURE_PLUS","model":"PURE PLUS"},{"manufacturer":"Mobicell","market_name":"R3","codename":"R3","model":"R3"},{"manufacturer":"Mobicell","market_name":"R4","codename":"R4","model":"R4"},{"manufacturer":"Mobicell","market_name":"REBEL","codename":"REBEL","model":"REBEL"},{"manufacturer":"Mobicell","market_name":"RUSH","codename":"RUSH","model":"RUSH"},{"manufacturer":"Mobicell","market_name":"Retro","codename":"Retro","model":"Retro"},{"manufacturer":"Mobicell","market_name":"SHIFT","codename":"SHIFT","model":"SHIFT"},{"manufacturer":"Mobicell","market_name":"SWITCH","codename":"SWITCH","model":"SWITCH"},{"manufacturer":"Mobicell","market_name":"Samba","codename":"Samba","model":"Samba"},{"manufacturer":"Mobicell","market_name":"TRIP","codename":"TRIP","model":"TRIP"},{"manufacturer":"Mobicell","market_name":"Trendy","codename":"TREDNY","model":"TREDNY"},{"manufacturer":"Mobicell","market_name":"Trendy","codename":"TRENDY","model":"TRENDY"},{"manufacturer":"Mobicell","market_name":"Trendy Plus","codename":"TRENDY_PLUS","model":"TRENDY PLUS"},{"manufacturer":"Mobicell","market_name":"U2","codename":"U2","model":"U2"},{"manufacturer":"Mobicell","market_name":"V1","codename":"V1","model":"V1"},{"manufacturer":"Mobicell","market_name":"V2 LTE","codename":"V2_LTE","model":"V2 LTE"},{"manufacturer":"Mobicell","market_name":"VEGA","codename":"VEGA","model":"VEGA"},{"manufacturer":"Mobicell","market_name":"ZEN","codename":"ZEN","model":"ZEN"},{"manufacturer":"Mobicell","market_name":"ZOOM","codename":"ZOOM","model":"ZOOM"},{"manufacturer":"MobiiStar","market_name":"LAI YUNA 1","codename":"LAI_YUNA_1","model":"mobiistar LAI YUNA 1"},{"manufacturer":"MobiiStar","market_name":"LAI Z1 4G","codename":"LAI_Z1_4G","model":"mobiistar LAI Z1 4G"},{"manufacturer":"MobiiStar","market_name":"LAI Z2","codename":"mobiistar_LAI_Z2","model":"mobiistar_LAI_Z2"},{"manufacturer":"MobiiStar","market_name":"LAI Zoro 3","codename":"LAI_ZORO_3","model":"mobiistar LAI ZORO 3"},{"manufacturer":"MobiiStar","market_name":"LAI Zumbo S 2017","codename":"Zumbo_S_2017","model":"Zumbo_S_2017"},{"manufacturer":"MobiiStar","market_name":"LAI Zumbo S 2017 Lite","codename":"Zumbo_S_2017_Lite","model":"Zumbo_S_2017_Lite"},{"manufacturer":"MobiiStar","market_name":"PRIME X MAX 2018","codename":"PRIME_X_MAX_2018","model":"PRIME X MAX 2018"},{"manufacturer":"MobiiStar","market_name":"S3 Dual","codename":"S3_Dual","model":"S3 Dual"},{"manufacturer":"MobiiStar","market_name":"XQ Dual","codename":"XQ_Dual","model":"XQ Dual"},{"manufacturer":"MobiiStar","market_name":"ZORO 4G","codename":"mobiistar_ZORO_4G","model":"mobiistar_ZORO_4G"},{"manufacturer":"MobiiStar","market_name":"ZORO 5","codename":"ZORO_5","model":"mobiistar ZORO 5"},{"manufacturer":"MobiiStar","market_name":"ZUMBO J2","codename":"Mobiistar_Zumbo_J2","model":"Mobiistar_Zumbo_J2"},{"manufacturer":"MobiiStar","market_name":"ZUMBO Power","codename":"ZUMBO_Power","model":"mobiistar ZUMBO Power"},{"manufacturer":"MobiiStar","market_name":"ZUMBO S2","codename":"mobiistar_Zumbo_S2","model":"mobiistar Zumbo S2"},{"manufacturer":"MobiiStar","market_name":"ZUMBO_S2_Dual","codename":"ZUMBO_S2_Dual","model":"mobiistar ZUMBO S2 Dual"},{"manufacturer":"MobiiStar","market_name":"mobiistar","codename":"CQ","model":"CQ"},{"manufacturer":"MobiiStar","market_name":"mobiistar E Selfie","codename":"mobiistar_E_Selfie","model":"mobiistar E Selfie"},{"manufacturer":"MobileTeleSystem","market_name":"MTC SMART Surf 4G","codename":"MTC_SMART_Surf_4G","model":"MTC_SMART_Surf_4G"},{"manufacturer":"MobileTeleSystem","market_name":"SMART Race2 4G","codename":"SMART_Race2_4G","model":"SMART_Race2_4G"},{"manufacturer":"MobileTeleSystem","market_name":"SMART Start 2","codename":"MTC_SMART_Start_2","model":"MTC_SMART_Start_2"},{"manufacturer":"MobileTeleSystem","market_name":"SMART Turbo 4G","codename":"SMART_Turbo_4G","model":"SMART_Turbo_4G"},{"manufacturer":"MobileTeleSystem","market_name":"SMART_Sprint_4G","codename":"SMART_Sprint_4G","model":"MTC SMART Sprint 4G"},{"manufacturer":"MobileTeleSystem","market_name":"Smart Surf2 4G","codename":"SMART_Surf2_4G","model":"SMART Surf2 4G"},{"manufacturer":"Mobily","market_name":"MDB342X","codename":"qnbml","model":"MDB342X"},{"manufacturer":"Mobiola","market_name":"Gaia","codename":"MOBIOLA_MS55L1","model":"MS55L1"},{"manufacturer":"Mobiola","market_name":"MS50L1","codename":"MS50L1","model":"MS50L1"},{"manufacturer":"Mobiola","market_name":"MS55E1","codename":"MS55E1","model":"MS55E1"},{"manufacturer":"Mobiola","market_name":"POLYS_MS45L1","codename":"POLYS_MS45L1","model":"POLYS_MS45L1"},{"manufacturer":"Mobistel","market_name":"Cynus E7","codename":"Cynus_E7","model":"Cynus E7"},{"manufacturer":"Mobistel","market_name":"Cynus F10","codename":"Cynus_F10","model":"Cynus_F10"},{"manufacturer":"Mobistel","market_name":"Cynus F9 4G","codename":"Cynus_F9_4G","model":"Cynus_F9_4G"},{"manufacturer":"Mobistel","market_name":"Cynus T6","codename":"Cynus_T6","model":"Cynus T6"},{"manufacturer":"Mobistel","market_name":"Cynus_E8","codename":"Cynus_E8","model":"Cynus_E8"},{"manufacturer":"Mobiwire","market_name":"Ahiga","codename":"Ahiga","model":"Ahiga"},{"manufacturer":"Mobiwire","market_name":"Chenoa","codename":"Chenoa","model":"Chenoa"},{"manufacturer":"Mobiwire","market_name":"Cygnus","codename":"Cygnus45","model":"Cygnus"},{"manufacturer":"Mobiwire","market_name":"Cygnus","codename":"Cygnus45","model":"Cygnus45"},{"manufacturer":"Mobiwire","market_name":"Cygnus mini","codename":"Cygnus_mini","model":"Cygnus mini"},{"manufacturer":"Mobiwire","market_name":"Cygnus mini","codename":"Cygnus_mini","model":"Cygnus_mini"},{"manufacturer":"Mobiwire","market_name":"H","codename":"Halona","model":"Halona"},{"manufacturer":"Mobiwire","market_name":"HALONA","codename":"Halona","model":"Halona"},{"manufacturer":"Mobiwire","market_name":"Hawk from EE","codename":"Hawk_from_EE","model":"Hawk_from_EE"},{"manufacturer":"Mobiwire","market_name":"Kiona","codename":"Kiona","model":"Kiona"},{"manufacturer":"Mobiwire","market_name":"Kohana","codename":"Kohana","model":"Kohana"},{"manufacturer":"Mobiwire","market_name":"Kosumi","codename":"Kosumi","model":"Kosumi"},{"manufacturer":"Mobiwire","market_name":"Kwanita","codename":"Kwanita","model":"KWANITA"},{"manufacturer":"Mobiwire","market_name":"MobiWire Halona","codename":"Halona","model":"Halona"},{"manufacturer":"Mobiwire","market_name":"MobiWire Kaya","codename":"Kaya_EU_SKU1","model":"KAYA"},{"manufacturer":"Mobiwire","market_name":"MobiWire Kosumi","codename":"Kosumi","model":"Kosumi"},{"manufacturer":"Mobiwire","market_name":"Pegasus","codename":"Pegasus","model":"Pegasus"},{"manufacturer":"Mobiwire","market_name":"S4040","codename":"S4040","model":"S4040"},{"manufacturer":"Mobiwire","market_name":"STARSHINE 5","codename":"Cygnus_mini","model":"STARSHINE5"},{"manufacturer":"Mobiwire","market_name":"STARSHINE 5","codename":"Cygnus_mini","model":"STARSHINE_5"},{"manufacturer":"Mobiwire","market_name":"STARSHINE 5","codename":"Cygnus_mini","model":"Smart_A25"},{"manufacturer":"Mobiwire","market_name":"STARXTREM 5","codename":"STARXTREM5","model":"STARXTREM5"},{"manufacturer":"Mobiwire","market_name":"Tala","codename":"Tala","model":"Tala"},{"manufacturer":"Mobiwire","market_name":"Telenor SmartPlus","codename":"Telenor_SmartPlus","model":"Telenor_SmartPlus"},{"manufacturer":"Mobiwire","market_name":"V.40","codename":"Nextel","model":"V.40"},{"manufacturer":"Mobiwire","market_name":"V.45","codename":"VSN","model":"V.45S"},{"manufacturer":"Mobiwire","market_name":"VSN V.45","codename":"up06_h26_v45","model":"V.45"},{"manufacturer":"Mobvoi","market_name":"Ticwatch S Smartwatch; Ticwatch E Smartwatch","codename":"mooneye","model":"Ticwatch E"},{"manufacturer":"Mobvoi","market_name":"Ticwatch S Smartwatch; Ticwatch E Smartwatch","codename":"mooneye","model":"Ticwatch S"},{"manufacturer":"Mode1","market_name":"MD-03P","codename":"MD-03P","model":"MD-03P"},{"manufacturer":"Modecom","market_name":"FreeTAB 10.1 Silver","codename":"silver","model":"FreeTAB 10.1 Silver"},{"manufacturer":"Modecom","market_name":"FreeTAB 8015 IPS X4 LTE","codename":"reverie","model":"FreeTAB 8015 IPS X4"},{"manufacturer":"Modecom","market_name":"Xino Z46 X4+","codename":"xino_z46","model":"Xino Z46 X4+"},{"manufacturer":"Mohu","market_name":"MH-CHANNELS","codename":"MH-CHANNELS","model":"MH-CHANNELS"},{"manufacturer":"Mondial","market_name":"TB-MONDIAL","codename":"TB_MONDIAL","model":"TB_MONDIAL"},{"manufacturer":"Mondial","market_name":"TB_MONDIAL_KID","codename":"TB_MONDIAL_KID","model":"TB_MONDIAL_KID"},{"manufacturer":"Monster","market_name":"M10","codename":"M10","model":"M10"},{"manufacturer":"Monsterpad","market_name":"Monsterpad7","codename":"Monsterpad7","model":"Monsterpad7"},{"manufacturer":"Montblanc","market_name":"SUMMIT","codename":"lionfish","model":"MB SUMMIT"},{"manufacturer":"Montblanc","market_name":"Summit","codename":"lionfish","model":"MB SUMMIT"},{"manufacturer":"Most Computers","market_name":"Revo You","codename":"RevoYou","model":"RevoYou"},{"manufacturer":"Motorola","market_name":"","codename":"A853","model":"Milestone"},{"manufacturer":"Motorola","market_name":"","codename":"ArgonSpin","model":"XT550"},{"manufacturer":"Motorola","market_name":"","codename":"Graham","model":"MZ505"},{"manufacturer":"Motorola","market_name":"","codename":"TAHITI","model":"MT620"},{"manufacturer":"Motorola","market_name":"","codename":"Triumph","model":"MOTWX435KT"},{"manufacturer":"Motorola","market_name":"","codename":"XT311","model":"XT311"},{"manufacturer":"Motorola","market_name":"","codename":"XT316","model":"XT316"},{"manufacturer":"Motorola","market_name":"","codename":"XT317","model":"XT317"},{"manufacturer":"Motorola","market_name":"","codename":"XT319","model":"XT319"},{"manufacturer":"Motorola","market_name":"","codename":"XT530","model":"XT530"},{"manufacturer":"Motorola","market_name":"","codename":"XT531","model":"XT531"},{"manufacturer":"Motorola","market_name":"","codename":"XT532","model":"XT532"},{"manufacturer":"Motorola","market_name":"","codename":"argonspin_umts","model":"XT550"},{"manufacturer":"Motorola","market_name":"","codename":"cdma_kronos","model":"MB612"},{"manufacturer":"Motorola","market_name":"","codename":"cdma_pax","model":"XT603"},{"manufacturer":"Motorola","market_name":"","codename":"cdma_solana","model":"MILESTONE3"},{"manufacturer":"Motorola","market_name":"","codename":"cdma_spyder","model":"DROID RAZR"},{"manufacturer":"Motorola","market_name":"","codename":"cdma_spyder","model":"IS12M"},{"manufacturer":"Motorola","market_name":"","codename":"cdma_spyder","model":"Motorola RAZR MAXX"},{"manufacturer":"Motorola","market_name":"","codename":"cdma_targa","model":"DROID BIONIC"},{"manufacturer":"Motorola","market_name":"","codename":"cg_tita2","model":"XT800+"},{"manufacturer":"Motorola","market_name":"","codename":"choi","model":"XT711"},{"manufacturer":"Motorola","market_name":"","codename":"choles","model":"XT701"},{"manufacturer":"Motorola","market_name":"","codename":"destino","model":"i867"},{"manufacturer":"Motorola","market_name":"","codename":"dominoq_umts","model":"XT316"},{"manufacturer":"Motorola","market_name":"","codename":"edison","model":"MB865"},{"manufacturer":"Motorola","market_name":"","codename":"edison","model":"ME865"},{"manufacturer":"Motorola","market_name":"","codename":"fawnridge","model":"i940"},{"manufacturer":"Motorola","market_name":"","codename":"fleming","model":"MZ607"},{"manufacturer":"Motorola","market_name":"","codename":"fleming","model":"MZ608"},{"manufacturer":"Motorola","market_name":"","codename":"fleming","model":"MZ609"},{"manufacturer":"Motorola","market_name":"","codename":"fleming","model":"XOOM 2 ME"},{"manufacturer":"Motorola","market_name":"","codename":"graham_wifi","model":"MZ505"},{"manufacturer":"Motorola","market_name":"","codename":"iDEN","model":"Motorola_i1"},{"manufacturer":"Motorola","market_name":"","codename":"morr","model":"MB200"},{"manufacturer":"Motorola","market_name":"","codename":"pasteur","model":"MZ616"},{"manufacturer":"Motorola","market_name":"","codename":"pasteur","model":"MZ617"},{"manufacturer":"Motorola","market_name":"","codename":"pasteur","model":"XOOM 2"},{"manufacturer":"Motorola","market_name":"","codename":"qilin","model":"XT806"},{"manufacturer":"Motorola","market_name":"","codename":"scorpion_mini_u","model":"XT905"},{"manufacturer":"Motorola","market_name":"","codename":"smq_u","model":"XT905"},{"manufacturer":"Motorola","market_name":"","codename":"swordfish","model":"XT882"},{"manufacturer":"Motorola","market_name":"","codename":"tinq_umts","model":"XT560"},{"manufacturer":"Motorola","market_name":"","codename":"ttu_skt","model":"XT800W"},{"manufacturer":"Motorola","market_name":"","codename":"umts_begonia","model":"MB610"},{"manufacturer":"Motorola","market_name":"","codename":"umts_begonia","model":"MB611"},{"manufacturer":"Motorola","market_name":"","codename":"umts_elway","model":"MB632"},{"manufacturer":"Motorola","market_name":"","codename":"umts_elway","model":"ME632"},{"manufacturer":"Motorola","market_name":"","codename":"umts_hubble","model":"MZ605"},{"manufacturer":"Motorola","market_name":"","codename":"umts_kobe","model":"MB520"},{"manufacturer":"Motorola","market_name":"","codename":"umts_lucky","model":"A1680"},{"manufacturer":"Motorola","market_name":"","codename":"umts_sage","model":"MB508"},{"manufacturer":"Motorola","market_name":"","codename":"umts_solana","model":"ME863"},{"manufacturer":"Motorola","market_name":"","codename":"umts_solana","model":"XT860"},{"manufacturer":"Motorola","market_name":"","codename":"umts_spyder","model":"XT910"},{"manufacturer":"Motorola","market_name":"","codename":"umts_spyder","model":"XT910K"},{"manufacturer":"Motorola","market_name":"","codename":"umts_spyder","model":"XT910S"},{"manufacturer":"Motorola","market_name":"","codename":"umts_venus2","model":"XT610"},{"manufacturer":"Motorola","market_name":"","codename":"wifi_hubble","model":"MZ604"},{"manufacturer":"Motorola","market_name":"","codename":"zepp","model":"MB501"},{"manufacturer":"Motorola","market_name":"Atrix","codename":"olympus","model":"MB860"},{"manufacturer":"Motorola","market_name":"Atrix","codename":"olympus","model":"MB861"},{"manufacturer":"Motorola","market_name":"Atrix","codename":"olympus","model":"ME860"},{"manufacturer":"Motorola","market_name":"Atrix HD","codename":"qinara","model":"MB886"},{"manufacturer":"Motorola","market_name":"Backflip","codename":"motus","model":"MB300"},{"manufacturer":"Motorola","market_name":"Backflip","codename":"motus","model":"ME600"},{"manufacturer":"Motorola","market_name":"CLIQ","codename":"morrison","model":"MB200"},{"manufacturer":"Motorola","market_name":"CLIQ","codename":"morrison","model":"morrison"},{"manufacturer":"Motorola","market_name":"Charm","codename":"umts_basil","model":"MB502"},{"manufacturer":"Motorola","market_name":"Citrus","codename":"cdma_ciena","model":"WX442"},{"manufacturer":"Motorola","market_name":"Citrus","codename":"cdma_ciena","model":"WX445"},{"manufacturer":"Motorola","market_name":"Citrus","codename":"cdma_ciena","model":"XT301"},{"manufacturer":"Motorola","market_name":"Cliq-XT","codename":"zeppelin","model":"MB501"},{"manufacturer":"Motorola","market_name":"Cliq-XT","codename":"zeppelin","model":"ME501"},{"manufacturer":"Motorola","market_name":"DROID MAXX 2","codename":"lux","model":"XT1021"},{"manufacturer":"Motorola","market_name":"DROID MAXX 2","codename":"lux","model":"XT1565"},{"manufacturer":"Motorola","market_name":"DROID RAZR HD","codename":"vanquish","model":"DROID RAZR HD"},{"manufacturer":"Motorola","market_name":"DROID RAZR HD","codename":"vanquish_u","model":"RAZR HD"},{"manufacturer":"Motorola","market_name":"DROID RAZR HD","codename":"vanquish_u","model":"XT925"},{"manufacturer":"Motorola","market_name":"DROID RAZR M","codename":"scorpion_mini","model":"XT907"},{"manufacturer":"Motorola","market_name":"DROID RAZR i","codename":"smi","model":"XT890"},{"manufacturer":"Motorola","market_name":"DROID Turbo 2","codename":"kinzie","model":"XT1585"},{"manufacturer":"Motorola","market_name":"DROID4","codename":"cdma_maserati","model":"DROID4"},{"manufacturer":"Motorola","market_name":"Defy","codename":"umts_jordan","model":"MB525"},{"manufacturer":"Motorola","market_name":"Defy","codename":"umts_jordan","model":"MB526"},{"manufacturer":"Motorola","market_name":"Defy","codename":"umts_jordan","model":"ME525"},{"manufacturer":"Motorola","market_name":"Defy","codename":"umts_jordan","model":"ME525+"},{"manufacturer":"Motorola","market_name":"Defy","codename":"umts_jordan","model":"unknown"},{"manufacturer":"Motorola","market_name":"Defy Mini","codename":"TinBoost","model":"XT320"},{"manufacturer":"Motorola","market_name":"Defy Mini","codename":"TinBoost","model":"XT321"},{"manufacturer":"Motorola","market_name":"Defy Mini","codename":"tinboost_umts","model":"XT320"},{"manufacturer":"Motorola","market_name":"Defy Mini","codename":"tinboost_umts","model":"XT321"},{"manufacturer":"Motorola","market_name":"Defy Pro","codename":"XT560","model":"XT560"},{"manufacturer":"Motorola","market_name":"Devour","codename":"calgary","model":"Devour"},{"manufacturer":"Motorola","market_name":"Devour","codename":"calgary","model":"calgary"},{"manufacturer":"Motorola","market_name":"Droid","codename":"miler","model":"A854"},{"manufacturer":"Motorola","market_name":"Droid","codename":"sholes","model":"Droid"},{"manufacturer":"Motorola","market_name":"Droid","codename":"umts_sholes","model":"A853"},{"manufacturer":"Motorola","market_name":"Droid","codename":"umts_sholes","model":"Milestone"},{"manufacturer":"Motorola","market_name":"Droid","codename":"umts_sholes","model":"XT701"},{"manufacturer":"Motorola","market_name":"Droid","codename":"umts_sholes","model":"XT702"},{"manufacturer":"Motorola","market_name":"Droid","codename":"umts_sholes","model":"XT720"},{"manufacturer":"Motorola","market_name":"Droid","codename":"umts_sholes","model":"umts"},{"manufacturer":"Motorola","market_name":"Droid 3","codename":"cdma_solana","model":"DROID3"},{"manufacturer":"Motorola","market_name":"Droid 4","codename":"cdma_maserati","model":"DROID4"},{"manufacturer":"Motorola","market_name":"Droid Bionic","codename":"cdma_targa","model":"DROID BIONIC"},{"manufacturer":"Motorola","market_name":"Droid II","codename":"cdma_droid2","model":"A955"},{"manufacturer":"Motorola","market_name":"Droid II","codename":"cdma_droid2","model":"DROID2"},{"manufacturer":"Motorola","market_name":"Droid II","codename":"cdma_droid2we","model":"DROID2 GLOBAL"},{"manufacturer":"Motorola","market_name":"Droid MAXX","codename":"obake-maxx","model":"XT1080"},{"manufacturer":"Motorola","market_name":"Droid Mini","codename":"obakem","model":"XT1030"},{"manufacturer":"Motorola","market_name":"Droid Pro","codename":"cdma_venus2","model":"DROID PRO"},{"manufacturer":"Motorola","market_name":"Droid Pro","codename":"cdma_venus2","model":"DROID Pro"},{"manufacturer":"Motorola","market_name":"Droid Pro","codename":"cdma_venus2","model":"Milestone PLUS"},{"manufacturer":"Motorola","market_name":"Droid Pro","codename":"cdma_venus2","model":"XT610"},{"manufacturer":"Motorola","market_name":"Droid RAZR","codename":"umts_spyder","model":"XT910"},{"manufacturer":"Motorola","market_name":"Droid Razr M","codename":"scorpion_mini_t","model":"201M"},{"manufacturer":"Motorola","market_name":"Droid Turbo","codename":"quark","model":"XT1250"},{"manufacturer":"Motorola","market_name":"Droid Turbo","codename":"quark","model":"XT1254"},{"manufacturer":"Motorola","market_name":"Droid Ultra","codename":"obake","model":"XT1080"},{"manufacturer":"Motorola","market_name":"Droid X","codename":"cdma_shadow","model":"DROIDX"},{"manufacturer":"Motorola","market_name":"Droid X","codename":"cdma_shadow","model":"MB810"},{"manufacturer":"Motorola","market_name":"Droid X","codename":"cdma_shadow","model":"ME811"},{"manufacturer":"Motorola","market_name":"Droid X","codename":"cdma_shadow","model":"Milestone X"},{"manufacturer":"Motorola","market_name":"Droid X","codename":"cdma_shadow","model":"MotoroiX"},{"manufacturer":"Motorola","market_name":"Droid X2","codename":"daytona","model":"DROID X2"},{"manufacturer":"Motorola","market_name":"Droid X2","codename":"daytona","model":"Milestone X2"},{"manufacturer":"Motorola","market_name":"ELECTRIFY 2","codename":"cdma_yangtze","model":"XT881"},{"manufacturer":"Motorola","market_name":"Electrify M","codename":"solstice","model":"XT901"},{"manufacturer":"Motorola","market_name":"Flipout","codename":"umts_ruth","model":"MB511"},{"manufacturer":"Motorola","market_name":"Flipout","codename":"umts_ruth","model":"ME511"},{"manufacturer":"Motorola","market_name":"Flipout","codename":"umts_ruth","model":"MotoMB511"},{"manufacturer":"Motorola","market_name":"Glam XT800","codename":"titanium","model":"XT800"},{"manufacturer":"Motorola","market_name":"HS1","codename":"Motorola_HS1","model":"Motorola_HS1"},{"manufacturer":"Motorola","market_name":"Iron Rock","codename":"umts_irock","model":"XT627"},{"manufacturer":"Motorola","market_name":"Master Touch","codename":"umts_primus","model":"XT621"},{"manufacturer":"Motorola","market_name":"Master Touch XT621","codename":"umts_primus","model":"XT621"},{"manufacturer":"Motorola","market_name":"Milestone2","codename":"umts_milestone2","model":"A953"},{"manufacturer":"Motorola","market_name":"Milestone2","codename":"umts_milestone2","model":"ME722"},{"manufacturer":"Motorola","market_name":"Milestone2","codename":"umts_milestone2","model":"MotoA953"},{"manufacturer":"Motorola","market_name":"Moto 360","codename":"minnow","model":"Moto 360"},{"manufacturer":"Motorola","market_name":"Moto 360 (2nd Gen)","codename":"carp","model":"Moto 360"},{"manufacturer":"Motorola","market_name":"Moto 360 (2nd Gen)","codename":"smelt","model":"Moto 360"},{"manufacturer":"Motorola","market_name":"Moto 360 Sport","codename":"carp","model":"Moto 360"},{"manufacturer":"Motorola","market_name":"Moto C","codename":"namath","model":"Moto C"},{"manufacturer":"Motorola","market_name":"Moto C","codename":"namath","model":"XT1754"},{"manufacturer":"Motorola","market_name":"Moto C","codename":"namath","model":"XT1755"},{"manufacturer":"Motorola","market_name":"Moto C","codename":"watson","model":"Moto C"},{"manufacturer":"Motorola","market_name":"Moto C Plus","codename":"panell_d","model":"Moto C Plus"},{"manufacturer":"Motorola","market_name":"Moto C Plus","codename":"panell_dl","model":"Moto C Plus"},{"manufacturer":"Motorola","market_name":"Moto C Plus","codename":"panell_dt","model":"Moto C Plus"},{"manufacturer":"Motorola","market_name":"Moto C Plus","codename":"panell_s","model":"Moto C Plus"},{"manufacturer":"Motorola","market_name":"Moto Defy XT","codename":"XT535","model":"XT535"},{"manufacturer":"Motorola","market_name":"Moto Defy XT","codename":"tinboostplus_cdma","model":"XT555C"},{"manufacturer":"Motorola","market_name":"Moto Defy XT","codename":"tinboostplus_cdma","model":"XT556"},{"manufacturer":"Motorola","market_name":"Moto Defy XT","codename":"tinboostplus_cdma","model":"XT557"},{"manufacturer":"Motorola","market_name":"Moto Defy XT","codename":"tinboostplus_umts","model":"XT535"},{"manufacturer":"Motorola","market_name":"Moto E (1st Gen)","codename":"condor_cdma","model":"XT1019"},{"manufacturer":"Motorola","market_name":"Moto E (1st Gen)","codename":"condor_cdma","model":"XT830C"},{"manufacturer":"Motorola","market_name":"Moto E (1st Gen)","codename":"condor_udstv","model":"XT1025"},{"manufacturer":"Motorola","market_name":"Moto E (1st Gen)","codename":"condor_umts","model":"XT1021"},{"manufacturer":"Motorola","market_name":"Moto E (1st Gen)","codename":"condor_umts","model":"XT1023"},{"manufacturer":"Motorola","market_name":"Moto E (1st Gen)","codename":"condor_umtsds","model":"XT1022"},{"manufacturer":"Motorola","market_name":"Moto E (2nd Gen)","codename":"otus","model":"MotoE2"},{"manufacturer":"Motorola","market_name":"Moto E (2nd Gen)","codename":"otus","model":"XT0000"},{"manufacturer":"Motorola","market_name":"Moto E (2nd Gen)","codename":"otus_ds","model":"MotoE2"},{"manufacturer":"Motorola","market_name":"Moto E (2nd Gen)","codename":"otus_ds","model":"XT1021"},{"manufacturer":"Motorola","market_name":"Moto E (4)","codename":"perry","model":"Moto E (4)"},{"manufacturer":"Motorola","market_name":"Moto E (4)","codename":"perry_f","model":"Moto E (4)"},{"manufacturer":"Motorola","market_name":"Moto E (4)","codename":"sperry","model":"Moto E (4)"},{"manufacturer":"Motorola","market_name":"Moto E (4)","codename":"woods_f","model":"Moto E (4)"},{"manufacturer":"Motorola","market_name":"Moto E (4)","codename":"woods_fn","model":"Moto E (4)"},{"manufacturer":"Motorola","market_name":"Moto E (4) Plus","codename":"nicklaus_f","model":"Moto E (4) Plus"},{"manufacturer":"Motorola","market_name":"Moto E (4) Plus","codename":"nicklaus_fn","model":"Moto E (4) Plus"},{"manufacturer":"Motorola","market_name":"Moto E (4) Plus","codename":"owens","model":"Moto E (4) Plus"},{"manufacturer":"Motorola","market_name":"Moto E (5)","codename":"nora_8917","model":"Moto E"},{"manufacturer":"Motorola","market_name":"Moto E (5)","codename":"nora_8917","model":"moto e5"},{"manufacturer":"Motorola","market_name":"Moto E (5)","codename":"nora_8917_n","model":"Moto E"},{"manufacturer":"Motorola","market_name":"Moto E (5)","codename":"nora_8917_n","model":"moto e5"},{"manufacturer":"Motorola","market_name":"Moto E with 4G LTE (2nd Gen)","codename":"surnia_cdma","model":"MotoE2"},{"manufacturer":"Motorola","market_name":"Moto E with 4G LTE (2nd Gen)","codename":"surnia_cdma","model":"MotoE2(4G-LTE)"},{"manufacturer":"Motorola","market_name":"Moto E with 4G LTE (2nd Gen)","codename":"surnia_cdma","model":"XT1526"},{"manufacturer":"Motorola","market_name":"Moto E with 4G LTE (2nd Gen)","codename":"surnia_cdma","model":"XT1528"},{"manufacturer":"Motorola","market_name":"Moto E with 4G LTE (2nd Gen)","codename":"surnia_cdma","model":"XT1528O"},{"manufacturer":"Motorola","market_name":"Moto E with 4G LTE (2nd Gen)","codename":"surnia_uds","model":"MotoE2(4G-LTE)"},{"manufacturer":"Motorola","market_name":"Moto E with 4G LTE (2nd Gen)","codename":"surnia_udstv","model":"MotoE2(4G-LTE)"},{"manufacturer":"Motorola","market_name":"Moto E with 4G LTE (2nd Gen)","codename":"surnia_umts","model":"MotoE2(4G-LTE)"},{"manufacturer":"Motorola","market_name":"Moto E4","codename":"perry_f","model":"Moto E (4)"},{"manufacturer":"Motorola","market_name":"Moto G (1st Gen)","codename":"falcon_cdma","model":"XT1028"},{"manufacturer":"Motorola","market_name":"Moto G (1st Gen)","codename":"falcon_cdma","model":"XT1031"},{"manufacturer":"Motorola","market_name":"Moto G (1st Gen)","codename":"falcon_cdma","model":"XT937C"},{"manufacturer":"Motorola","market_name":"Moto G (1st Gen)","codename":"falcon_umts","model":"XT1002"},{"manufacturer":"Motorola","market_name":"Moto G (1st Gen)","codename":"falcon_umts","model":"XT1003"},{"manufacturer":"Motorola","market_name":"Moto G (1st Gen)","codename":"falcon_umts","model":"XT1008"},{"manufacturer":"Motorola","market_name":"Moto G (1st Gen)","codename":"falcon_umts","model":"XT1032"},{"manufacturer":"Motorola","market_name":"Moto G (1st Gen)","codename":"falcon_umts","model":"XT1034"},{"manufacturer":"Motorola","market_name":"Moto G (1st Gen)","codename":"falcon_umts","model":"XT939G"},{"manufacturer":"Motorola","market_name":"Moto G (1st Gen)","codename":"falcon_umtsds","model":"XT1033"},{"manufacturer":"Motorola","market_name":"Moto G (2nd Gen)","codename":"titan_udstv","model":"XT1069"},{"manufacturer":"Motorola","market_name":"Moto G (2nd Gen)","codename":"titan_udstv","model":"titan_retbr_dstv"},{"manufacturer":"Motorola","market_name":"Moto G (2nd Gen)","codename":"titan_umts","model":"XT1063"},{"manufacturer":"Motorola","market_name":"Moto G (2nd Gen)","codename":"titan_umts","model":"XT1064"},{"manufacturer":"Motorola","market_name":"Moto G (2nd Gen)","codename":"titan_umtsds","model":"XT1068"},{"manufacturer":"Motorola","market_name":"Moto G (2nd Gen)","codename":"titan_umtsds","model":"titan_niibr_ds"},{"manufacturer":"Motorola","market_name":"Moto G (3rd Gen)","codename":"osprey_cdma","model":"MotoG3"},{"manufacturer":"Motorola","market_name":"Moto G (3rd Gen)","codename":"osprey_u2","model":"MotoG3"},{"manufacturer":"Motorola","market_name":"Moto G (3rd Gen)","codename":"osprey_ud2","model":"MotoG3"},{"manufacturer":"Motorola","market_name":"Moto G (3rd Gen)","codename":"osprey_uds","model":"MotoG3"},{"manufacturer":"Motorola","market_name":"Moto G (3rd Gen)","codename":"osprey_udstv","model":"MotoG3"},{"manufacturer":"Motorola","market_name":"Moto G (3rd Gen)","codename":"osprey_umts","model":"MotoG3"},{"manufacturer":"Motorola","market_name":"Moto G (4) Play","codename":"harpia_n","model":"Moto G Play"},{"manufacturer":"Motorola","market_name":"Moto G (5)","codename":"cedric","model":"Moto G (5)"},{"manufacturer":"Motorola","market_name":"Moto G (5) Plus","codename":"potter_n","model":"Moto G (4)"},{"manufacturer":"Motorola","market_name":"Moto G (5) Plus","codename":"potter_n","model":"Moto G (5) Plus"},{"manufacturer":"Motorola","market_name":"Moto G (5S)","codename":"montana","model":"Moto G (5S)"},{"manufacturer":"Motorola","market_name":"Moto G (5S)","codename":"montana","model":"XT1799-1"},{"manufacturer":"Motorola","market_name":"Moto G (5S)","codename":"montana_n","model":"Moto G (5S)"},{"manufacturer":"Motorola","market_name":"Moto G (5S)","codename":"montana_n","model":"XT1799-2"},{"manufacturer":"Motorola","market_name":"Moto G (5S) Plus","codename":"sanders","model":"Moto G (5S) Plus"},{"manufacturer":"Motorola","market_name":"Moto G (5S) Plus","codename":"sanders_n","model":"Moto G (4)"},{"manufacturer":"Motorola","market_name":"Moto G (5S) Plus","codename":"sanders_n","model":"Moto G (5S) Plus"},{"manufacturer":"Motorola","market_name":"Moto G (5S) Plus","codename":"sanders_nt","model":"Moto G (4)"},{"manufacturer":"Motorola","market_name":"Moto G (5S) Plus","codename":"sanders_nt","model":"Moto G (5S) Plus"},{"manufacturer":"Motorola","market_name":"Moto G (5th Gen)","codename":"cedric","model":"Moto G (5)"},{"manufacturer":"Motorola","market_name":"Moto G Google Play edition","codename":"falcon_umts","model":"XT1032"},{"manufacturer":"Motorola","market_name":"Moto G Plus (5th Gen)","codename":"potter","model":"Moto G (5) Plus"},{"manufacturer":"Motorola","market_name":"Moto G Plus (5th Gen)","codename":"potter_nt","model":"Moto G (5) Plus"},{"manufacturer":"Motorola","market_name":"Moto G Turbo Edition","codename":"merlin","model":"MotoG3"},{"manufacturer":"Motorola","market_name":"Moto G Turbo Edition","codename":"merlin","model":"MotoG3-TE"},{"manufacturer":"Motorola","market_name":"Moto G with 4G LTE (1st Gen)","codename":"peregrine","model":"XT1039"},{"manufacturer":"Motorola","market_name":"Moto G with 4G LTE (1st Gen)","codename":"peregrine","model":"XT1040"},{"manufacturer":"Motorola","market_name":"Moto G with 4G LTE (1st Gen)","codename":"peregrine","model":"XT1042"},{"manufacturer":"Motorola","market_name":"Moto G with 4G LTE (1st Gen)","codename":"peregrine","model":"XT1045"},{"manufacturer":"Motorola","market_name":"Moto G with 4G LTE (2nd Gen)","codename":"thea","model":"XT1072"},{"manufacturer":"Motorola","market_name":"Moto G with 4G LTE (2nd Gen)","codename":"thea_ds","model":"XT1077"},{"manufacturer":"Motorola","market_name":"Moto G with 4G LTE (2nd Gen)","codename":"thea_ds","model":"XT1079"},{"manufacturer":"Motorola","market_name":"Moto G with 4G LTE (2nd Gen)","codename":"thea_umtsds","model":"XT1063"},{"manufacturer":"Motorola","market_name":"Moto G with 4G LTE (2nd Gen)","codename":"thea_umtsds","model":"XT1078"},{"manufacturer":"Motorola","market_name":"Moto G(4)","codename":"athene","model":"Moto G (4)"},{"manufacturer":"Motorola","market_name":"Moto G(4)","codename":"athene_t","model":"Moto G (4)"},{"manufacturer":"Motorola","market_name":"Moto G(4) Plus","codename":"athene_f","model":"Moto G (4)"},{"manufacturer":"Motorola","market_name":"Moto G4 Play","codename":"harpia","model":"Moto G Play"},{"manufacturer":"Motorola","market_name":"Moto G4 Play","codename":"harpia","model":"XT1609"},{"manufacturer":"Motorola","market_name":"Moto G4 Play","codename":"harpia_t","model":"Moto G Play"},{"manufacturer":"Motorola","market_name":"Moto MAXX","codename":"quark_umts","model":"XT1225"},{"manufacturer":"Motorola","market_name":"Moto Turbo","codename":"quark_umts","model":"XT1225"},{"manufacturer":"Motorola","market_name":"Moto X (1st Gen)","codename":"ghost","model":"XT1049"},{"manufacturer":"Motorola","market_name":"Moto X (1st Gen)","codename":"ghost","model":"XT1050"},{"manufacturer":"Motorola","market_name":"Moto X (1st Gen)","codename":"ghost","model":"XT1052"},{"manufacturer":"Motorola","market_name":"Moto X (1st Gen)","codename":"ghost","model":"XT1053"},{"manufacturer":"Motorola","market_name":"Moto X (1st Gen)","codename":"ghost","model":"XT1055"},{"manufacturer":"Motorola","market_name":"Moto X (1st Gen)","codename":"ghost","model":"XT1056"},{"manufacturer":"Motorola","market_name":"Moto X (1st Gen)","codename":"ghost","model":"XT1058"},{"manufacturer":"Motorola","market_name":"Moto X (1st Gen)","codename":"ghost","model":"XT1060"},{"manufacturer":"Motorola","market_name":"Moto X (2nd Gen)","codename":"victara","model":"XT1085"},{"manufacturer":"Motorola","market_name":"Moto X (2nd Gen)","codename":"victara","model":"XT1092"},{"manufacturer":"Motorola","market_name":"Moto X (2nd Gen)","codename":"victara","model":"XT1093"},{"manufacturer":"Motorola","market_name":"Moto X (2nd Gen)","codename":"victara","model":"XT1094"},{"manufacturer":"Motorola","market_name":"Moto X (2nd Gen)","codename":"victara","model":"XT1095"},{"manufacturer":"Motorola","market_name":"Moto X (2nd Gen)","codename":"victara","model":"XT1096"},{"manufacturer":"Motorola","market_name":"Moto X (2nd Gen)","codename":"victara","model":"XT1097"},{"manufacturer":"Motorola","market_name":"Moto X (2nd Gen)","codename":"victara","model":"XT1098"},{"manufacturer":"Motorola","market_name":"Moto X (4)","codename":"payton","model":"XT1789-05"},{"manufacturer":"Motorola","market_name":"Moto X (4)","codename":"payton","model":"moto x4"},{"manufacturer":"Motorola","market_name":"Moto X (4)","codename":"payton_sprout","model":"moto x4"},{"manufacturer":"Motorola","market_name":"Moto X Force","codename":"kinzie","model":"XT1580"},{"manufacturer":"Motorola","market_name":"Moto X Force","codename":"kinzie_uds","model":"XT1580"},{"manufacturer":"Motorola","market_name":"Moto X Force","codename":"kinzie_uds","model":"XT1581"},{"manufacturer":"Motorola","market_name":"Moto X Play","codename":"lux","model":"Moto X Play"},{"manufacturer":"Motorola","market_name":"Moto X Play","codename":"lux","model":"XT1021"},{"manufacturer":"Motorola","market_name":"Moto X Play","codename":"lux","model":"XT1562"},{"manufacturer":"Motorola","market_name":"Moto X Play","codename":"lux","model":"XT1563"},{"manufacturer":"Motorola","market_name":"Moto X Play","codename":"lux","model":"XT1564"},{"manufacturer":"Motorola","market_name":"Moto X Play","codename":"lux_uds","model":"Moto X Play"},{"manufacturer":"Motorola","market_name":"Moto X Play","codename":"lux_uds","model":"XT1021"},{"manufacturer":"Motorola","market_name":"Moto X Play","codename":"lux_uds","model":"XT1562"},{"manufacturer":"Motorola","market_name":"Moto X Play","codename":"lux_uds","model":"XT1563"},{"manufacturer":"Motorola","market_name":"Moto X Pro (China)","codename":"shamu_t","model":"Moto X Pro"},{"manufacturer":"Motorola","market_name":"Moto X Pure Edition","codename":"clark","model":"XT1575"},{"manufacturer":"Motorola","market_name":"Moto X Style","codename":"clark","model":"XT1572"},{"manufacturer":"Motorola","market_name":"Moto X Style","codename":"clark_ds","model":"XT1570"},{"manufacturer":"Motorola","market_name":"Moto X Style","codename":"clark_ds","model":"XT1572"},{"manufacturer":"Motorola","market_name":"Moto Z","codename":"griffin","model":"XT1650"},{"manufacturer":"Motorola","market_name":"Moto Z","codename":"griffin","model":"XT1650-05"},{"manufacturer":"Motorola","market_name":"Moto Z (2) Force","codename":"nash","model":"Moto Z (2)"},{"manufacturer":"Motorola","market_name":"Moto Z (2) Force","codename":"nash","model":"XT1789-05"},{"manufacturer":"Motorola","market_name":"Moto Z (2) Play","codename":"albus","model":"Moto Z2 Play"},{"manufacturer":"Motorola","market_name":"Moto Z (2) Play","codename":"albus","model":"XT1710-02"},{"manufacturer":"Motorola","market_name":"Moto Z (2) Play","codename":"albus","model":"XT1710-08"},{"manufacturer":"Motorola","market_name":"Moto Z (2) Play","codename":"albus","model":"XT1710-11"},{"manufacturer":"Motorola","market_name":"Moto Z Droid","codename":"griffin","model":"XT1650"},{"manufacturer":"Motorola","market_name":"Moto Z Play","codename":"addison","model":"XT1563"},{"manufacturer":"Motorola","market_name":"Moto Z Play","codename":"addison","model":"XT1635-02"},{"manufacturer":"Motorola","market_name":"Moto Z Play","codename":"addison","model":"XT1635-03"},{"manufacturer":"Motorola","market_name":"Moto Z Play Droid","codename":"addison","model":"XT1635-01"},{"manufacturer":"Motorola","market_name":"Motoluxe","codename":"XT611","model":"XT611"},{"manufacturer":"Motorola","market_name":"Motoluxe","codename":"XT615","model":"XT615"},{"manufacturer":"Motorola","market_name":"Motoluxe","codename":"XT682","model":"XT682"},{"manufacturer":"Motorola","market_name":"Motoluxe","codename":"ironmax_umts","model":"XT615"},{"manufacturer":"Motorola","market_name":"Motoluxe","codename":"ironmax_umts","model":"XT685"},{"manufacturer":"Motorola","market_name":"Motoluxe","codename":"ironmaxct_cdma","model":"Motorola MOT-XT681"},{"manufacturer":"Motorola","market_name":"Motoluxe","codename":"ironmaxtv_umts","model":"XT687"},{"manufacturer":"Motorola","market_name":"Motoluxe","codename":"umts_irock","model":"XT626"},{"manufacturer":"Motorola","market_name":"Motoluxe","codename":"umts_irock","model":"XT627"},{"manufacturer":"Motorola","market_name":"Motoroi","codename":"sholest","model":"Milestone XT720"},{"manufacturer":"Motorola","market_name":"Motoroi","codename":"sholest","model":"Motorola XT720"},{"manufacturer":"Motorola","market_name":"Motoroi","codename":"sholest","model":"XT720"},{"manufacturer":"Motorola","market_name":"Motosmart","codename":"XT389","model":"XT389"},{"manufacturer":"Motorola","market_name":"Motosmart","codename":"XT390","model":"XT390"},{"manufacturer":"Motorola","market_name":"Motosmart","codename":"argonmini_umts","model":"XT389"},{"manufacturer":"Motorola","market_name":"Motosmart","codename":"argonmini_umts","model":"XT390"},{"manufacturer":"Motorola","market_name":"Motosmart","codename":"silversmart_umts","model":"XT303"},{"manufacturer":"Motorola","market_name":"Motosmart","codename":"silversmart_umts","model":"XT305"},{"manufacturer":"Motorola","market_name":"Nexus 6","codename":"shamu","model":"Nexus 6"},{"manufacturer":"Motorola","market_name":"Opus One","codename":"rubicon","model":"Motorola Titanium"},{"manufacturer":"Motorola","market_name":"Opus One","codename":"rubicon","model":"Titanium"},{"manufacturer":"Motorola","market_name":"Photon","codename":"asanti_c","model":"XT897"},{"manufacturer":"Motorola","market_name":"Photon","codename":"asanti_c","model":"XT897S"},{"manufacturer":"Motorola","market_name":"Photon 4G","codename":"sunfire","model":"ISW11M"},{"manufacturer":"Motorola","market_name":"Photon 4G","codename":"sunfire","model":"MB855"},{"manufacturer":"Motorola","market_name":"Photon 4G","codename":"sunfire","model":"Motorola Electrify"},{"manufacturer":"Motorola","market_name":"Quench XT3","codename":"XT502","model":"Motorola-XT502"},{"manufacturer":"Motorola","market_name":"RAZR D1","codename":"hawk35_umts","model":"XT914"},{"manufacturer":"Motorola","market_name":"RAZR D1","codename":"hawk35_umts","model":"XT915"},{"manufacturer":"Motorola","market_name":"RAZR D1","codename":"hawk35_umts","model":"XT916"},{"manufacturer":"Motorola","market_name":"RAZR D1","codename":"hawk35_umts","model":"XT918"},{"manufacturer":"Motorola","market_name":"RAZR D3","codename":"hawk40_umts","model":"XT919"},{"manufacturer":"Motorola","market_name":"RAZR D3","codename":"hawk40_umts","model":"XT920"},{"manufacturer":"Motorola","market_name":"RAZR HD","codename":"vanquish","model":"DROID RAZR HD"},{"manufacturer":"Motorola","market_name":"RAZR HD","codename":"vanquish_u","model":"RAZR HD"},{"manufacturer":"Motorola","market_name":"RAZR M","codename":"smq","model":"XT907"},{"manufacturer":"Motorola","market_name":"RAZR M","codename":"smq_t","model":"201M"},{"manufacturer":"Motorola","market_name":"RAZR i","codename":"smi","model":"XT890"},{"manufacturer":"Motorola","market_name":"Razr V","codename":"umts_yangtze","model":"XT885"},{"manufacturer":"Motorola","market_name":"Razr V","codename":"umts_yangtze","model":"XT886"},{"manufacturer":"Motorola","market_name":"Spice","codename":"sesame","model":"XT300"},{"manufacturer":"Motorola","market_name":"XOOM","codename":"stingray","model":"Xoom"},{"manufacturer":"Motorola","market_name":"XOOM","codename":"umts_everest","model":"MZ601"},{"manufacturer":"Motorola","market_name":"XOOM","codename":"umts_hubble","model":"MZ601"},{"manufacturer":"Motorola","market_name":"XOOM","codename":"umts_hubble","model":"MZ605"},{"manufacturer":"Motorola","market_name":"XOOM","codename":"wifi_hubble","model":"MZ604"},{"manufacturer":"Motorola","market_name":"XOOM","codename":"wifi_hubble","model":"MZ606"},{"manufacturer":"Motorola","market_name":"XOOM","codename":"wingray","model":"Xoom"},{"manufacturer":"Motorola","market_name":"XOOM 2","codename":"fleming","model":"MZ609"},{"manufacturer":"Motorola","market_name":"XOOM 2","codename":"pasteur","model":"MZ617"},{"manufacturer":"Motorola","market_name":"XT605","codename":"umts_jorian","model":"XT605"},{"manufacturer":"Motorola","market_name":"XT627","codename":"umts_irock","model":"XT627"},{"manufacturer":"Motorola","market_name":"moto e(5) cruise","codename":"james","model":"moto e5 cruise"},{"manufacturer":"Motorola","market_name":"moto e(5) play","codename":"james","model":"moto e5 play"},{"manufacturer":"Motorola","market_name":"moto e(5) plus","codename":"rhannah","model":"Moto E"},{"manufacturer":"Motorola","market_name":"moto e(5) plus","codename":"rhannah","model":"moto e5 plus"},{"manufacturer":"Motorola","market_name":"moto e5","codename":"nora_8917_n","model":"moto e5"},{"manufacturer":"Motorola","market_name":"moto e5 play","codename":"rjames_f","model":"Moto E"},{"manufacturer":"Motorola","market_name":"moto e5 play","codename":"rjames_f","model":"moto e5 play"},{"manufacturer":"Motorola","market_name":"moto e5 plus","codename":"ahannah","model":"Moto E"},{"manufacturer":"Motorola","market_name":"moto e5 plus","codename":"ahannah","model":"moto e5 plus"},{"manufacturer":"Motorola","market_name":"moto e5 plus","codename":"hannah","model":"Moto E"},{"manufacturer":"Motorola","market_name":"moto e5 plus","codename":"hannah","model":"moto e5 plus"},{"manufacturer":"Motorola","market_name":"moto e5 plus","codename":"hannah","model":"moto e5 supra"},{"manufacturer":"Motorola","market_name":"moto e5 plus","codename":"rhannah","model":"Moto E"},{"manufacturer":"Motorola","market_name":"moto e5 plus","codename":"rhannah","model":"moto e5 plus"},{"manufacturer":"Motorola","market_name":"moto g(6)","codename":"ali","model":"XT1925-10"},{"manufacturer":"Motorola","market_name":"moto g(6)","codename":"ali","model":"moto g(6)"},{"manufacturer":"Motorola","market_name":"moto g(6)","codename":"ali","model":"moto g(6) (XT1925DL)"},{"manufacturer":"Motorola","market_name":"moto g(6)","codename":"ali_n","model":"XT1790"},{"manufacturer":"Motorola","market_name":"moto g(6)","codename":"ali_n","model":"moto g(6)"},{"manufacturer":"Motorola","market_name":"moto g(6) play","codename":"aljeter","model":"Moto G Play"},{"manufacturer":"Motorola","market_name":"moto g(6) play","codename":"aljeter","model":"moto g(6) play"},{"manufacturer":"Motorola","market_name":"moto g(6) play","codename":"aljeter_n","model":"Moto G Play"},{"manufacturer":"Motorola","market_name":"moto g(6) play","codename":"aljeter_n","model":"moto g(6) play"},{"manufacturer":"Motorola","market_name":"moto g(6) play","codename":"jeter","model":"moto g(6) play"},{"manufacturer":"Motorola","market_name":"moto g(6) plus","codename":"evert","model":"moto g(6) plus"},{"manufacturer":"Motorola","market_name":"moto g(6) plus","codename":"evert_n","model":"Moto G (5) Plus"},{"manufacturer":"Motorola","market_name":"moto g(6) plus","codename":"evert_n","model":"moto g(6) plus"},{"manufacturer":"Motorola","market_name":"moto g(6) plus","codename":"evert_nt","model":"moto g(6) plus"},{"manufacturer":"Motorola","market_name":"moto g6 play","codename":"jeter","model":"Moto G Play"},{"manufacturer":"Motorola","market_name":"moto g6 play","codename":"jeter","model":"moto g(6) play"},{"manufacturer":"Motorola","market_name":"moto z3 play","codename":"beckham","model":"Moto Z3 Play"},{"manufacturer":"Motorola Solutions","market_name":"LEX F10","codename":"LEXF10","model":"LEX F10"},{"manufacturer":"Motorola Solutions","market_name":"LEX L10g","codename":"lexl10g","model":"LEX L10g"},{"manufacturer":"Motorola Solutions","market_name":"LEX L10ig","codename":"lexl10ig","model":"LEX L10ig"},{"manufacturer":"Motorola Solutions","market_name":"TC55","codename":"TC55","model":"TC55"},{"manufacturer":"Motorola Solutions","market_name":"TC55CH","codename":"TC55CH","model":"TC55CH"},{"manufacturer":"Movado","market_name":"Boss Touch / TH 24/7 YOU","codename":"weever","model":"BOSS Touch"},{"manufacturer":"Movado","market_name":"Boss Touch / TH 24/7 YOU","codename":"weever","model":"TH 24/7 YOU"},{"manufacturer":"Movado","market_name":"Movado Connect","codename":"stargazer","model":"Movado Connect"},{"manufacturer":"Moveby","market_name":"LINNEX","codename":"LX50","model":"LX50"},{"manufacturer":"Movic","market_name":"MOVIC_W5","codename":"MOVIC_W5","model":"MOVIC-W5"},{"manufacturer":"Moviltelco Trade","market_name":"A58B","codename":"A58B","model":"A58B"},{"manufacturer":"Moviltelco Trade","market_name":"mtt L452","codename":"L452","model":"L452"},{"manufacturer":"Moviltelco Trade","market_name":"mtt L509","codename":"L509","model":"MTT_L509"},{"manufacturer":"Moxee Technologies","market_name":"X10","codename":"X10","model":"X10"},{"manufacturer":"Moxee Technologies","market_name":"X100","codename":"X100","model":"X100"},{"manufacturer":"Mpman","market_name":"PH604","codename":"PH604","model":"PH604"},{"manufacturer":"Multilaser","market_name":"Discovery","codename":"Discovery","model":"Discovery"},{"manufacturer":"Multilaser","market_name":"Kidpad-3G","codename":"Kidpad-3G","model":"Kidpad-3G"},{"manufacturer":"Multilaser","market_name":"M10A","codename":"M10A","model":"M10A"},{"manufacturer":"Multilaser","market_name":"M10A-Lite","codename":"M10A-Lite","model":"M10A-Lite"},{"manufacturer":"Multilaser","market_name":"M7-3G PLUS","codename":"ML-JI-M7_3G_PLUS","model":"ML-JI-M7_3G_PLUS"},{"manufacturer":"Multilaser","market_name":"M7-3G PLUS","codename":"ML-WI-M7_3G_PLUS","model":"ML-WI-M7_3G_PLUS"},{"manufacturer":"Multilaser","market_name":"M7-4G","codename":"ML-JI-M7-4G","model":"ML-JI-M7-4G"},{"manufacturer":"Multilaser","market_name":"M7I-3G","codename":"M7I-3G","model":"M7I-3G"},{"manufacturer":"Multilaser","market_name":"M7I-3G","codename":"astar-ococci","model":"ML01-M7S-Quad-Core"},{"manufacturer":"Multilaser","market_name":"M7SQC Plus","codename":"M7SQC_Plus","model":"M7SQC_Plus"},{"manufacturer":"Multilaser","market_name":"M7s Dual Core","codename":"NB116_NB117_NB118","model":"M7s Dual ML03"},{"manufacturer":"Multilaser","market_name":"M7s Quad Core","codename":"astar-ococci","model":"ML01-M7S-Quad-Core"},{"manufacturer":"Multilaser","market_name":"M9-3G","codename":"M9-3G","model":"M9-3G"},{"manufacturer":"Multilaser","market_name":"M9-3G","codename":"ML-SO-M9-3G","model":"ML-SO-M9-3G"},{"manufacturer":"Multilaser","market_name":"M9-3G","codename":"ML-WI-M9-3G","model":"ML-WI-M9-3G"},{"manufacturer":"Multilaser","market_name":"M9-3G-2","codename":"M9-3G_2","model":"M9-3G_2"},{"manufacturer":"Multilaser","market_name":"ML-JI11-M7_3G_PLUS","codename":"ML-JI11-M7_3G_PLUS","model":"ML-JI11-M7_3G_PLUS"},{"manufacturer":"Multilaser","market_name":"ML-SO-M7_3G_PLUS","codename":"ML-SO-M7_3G_PLUS","model":"ML-SO-M7_3G_PLUS"},{"manufacturer":"Multilaser","market_name":"ML-SO-MLX1","codename":"ML-SO-MLX1","model":"ML-SO-MLX1"},{"manufacturer":"Multilaser","market_name":"MLX8","codename":"MLX8","model":"MLX8"},{"manufacturer":"Multilaser","market_name":"MS40S","codename":"MS40S","model":"MS40S"},{"manufacturer":"Multilaser","market_name":"MS40s","codename":"MS40S","model":"MS40S"},{"manufacturer":"Multilaser","market_name":"MS45","codename":"MS45","model":"MS45"},{"manufacturer":"Multilaser","market_name":"MS45 4G","codename":"ML-CH-MS45_4G","model":"ML-CH-MS45_4G"},{"manufacturer":"Multilaser","market_name":"MS45S","codename":"MS45S","model":"MS45S"},{"manufacturer":"Multilaser","market_name":"MS45S","codename":"MS45S_A6","model":"MS45S_A6"},{"manufacturer":"Multilaser","market_name":"MS50","codename":"MS50","model":"MS50"},{"manufacturer":"Multilaser","market_name":"MS50L","codename":"MS50L","model":"MS50L"},{"manufacturer":"Multilaser","market_name":"MS50L 4G","codename":"MS50L_4G","model":"MS50L_4G"},{"manufacturer":"Multilaser","market_name":"MS50M","codename":"MS50M","model":"MS50M"},{"manufacturer":"Multilaser","market_name":"MS50S","codename":"MS50S","model":"MS50S"},{"manufacturer":"Multilaser","market_name":"MS50_4G","codename":"MS50_4G","model":"MS50_4G"},{"manufacturer":"Multilaser","market_name":"MS55","codename":"MS55","model":"MS55"},{"manufacturer":"Multilaser","market_name":"MS55M","codename":"MS55M","model":"MS55M"},{"manufacturer":"Multilaser","market_name":"MS60","codename":"MS60","model":"MS60"},{"manufacturer":"Multilaser","market_name":"MS60F","codename":"MS60F","model":"MS60F"},{"manufacturer":"Multilaser","market_name":"MS60F Plus","codename":"MS60F_PLUS","model":"MS60F_PLUS"},{"manufacturer":"Multilaser","market_name":"MS70","codename":"MS70","model":"MS70"},{"manufacturer":"Multilaser","market_name":"MS80","codename":"ML-TI-MS80","model":"ML-TI-MS80"},{"manufacturer":"Multilaser","market_name":"Ms5","codename":"MTL-MS5","model":"MS5"},{"manufacturer":"Multilaser","market_name":"Ms6","codename":"MS6","model":"MS6"},{"manufacturer":"My Go","market_name":"GoTab GBT10","codename":"GBT10","model":"GoTab_GBT10"},{"manufacturer":"MyPhone (PL)","market_name":"C-Smart pix","codename":"C-Smart_pix_JMP","model":"C-Smart_pix"},{"manufacturer":"MyPhone (PL)","market_name":"Cube LTE","codename":"CUBE_LTE_PLAY","model":"CUBE_LTE"},{"manufacturer":"MyPhone (PL)","market_name":"Fun_LTE","codename":"Fun_LTE","model":"myPhone Fun LTE"},{"manufacturer":"MyPhone (PL)","market_name":"Hammer AXE PRO","codename":"Hammer_AXE_Pro_OPM","model":"Hammer AXE Pro"},{"manufacturer":"MyPhone (PL)","market_name":"Hammer Titan 2","codename":"Hammer_Titan_2","model":"Hammer Titan 2"},{"manufacturer":"MyPhone (PL)","market_name":"Hammer_Active","codename":"HammerActive","model":"Hammer Active"},{"manufacturer":"MyPhone (PL)","market_name":"Hammer_Energy_3G","codename":"Hammer_Energy_3G","model":"Hammer Energy 3G"},{"manufacturer":"MyPhone (PL)","market_name":"Hammer_Iron_2","codename":"Hammer_Iron_2","model":"Hammer Iron 2"},{"manufacturer":"MyPhone (PL)","market_name":"Hykker MyTab10","codename":"Hykker_MyTab10","model":"Hykker_MyTab10"},{"manufacturer":"MyPhone (PL)","market_name":"MyPhone Go!","codename":"myPhone_Go","model":"myPhone Go"},{"manufacturer":"MyPhone (PL)","market_name":"myPhone","codename":"Q_Smart_BE","model":"Q_Smart_BE"},{"manufacturer":"MyPhone (PL)","market_name":"myPhone C-Smart Glam","codename":"C-Smart_Glam_JMP","model":"C-Smart_Glam"},{"manufacturer":"MyPhone (PL)","market_name":"myPhone C-Smart IIIS","codename":"C_Smart_IIIS","model":"C-Smart IIIS"},{"manufacturer":"MyPhone (PL)","market_name":"myPhone Fun 5","codename":"FUN5_OPM","model":"FUN5"},{"manufacturer":"MyPhone (PL)","market_name":"myPhone HAMMER ENERGY","codename":"HAMMER_ENERGY_PLAY","model":"HAMMER_ENERGY"},{"manufacturer":"MyPhone (PL)","market_name":"myPhone Hammer Energy","codename":"Hammer_Energy","model":"Hammer Energy"},{"manufacturer":"MyPhone (PL)","market_name":"myPhone Luna II","codename":"LUNA_II_OPM","model":"LUNA_II"},{"manufacturer":"MyPhone (PL)","market_name":"myPhone MAGNUS","codename":"MAGNUS_JMP","model":"MAGNUS"},{"manufacturer":"MyPhone (PL)","market_name":"myPhone PRIME PLUS","codename":"Prime_Plus_OPM","model":"Prime_Plus"},{"manufacturer":"MyPhone (PL)","market_name":"myPhone Pocket","codename":"Pocket_OPM","model":"Pocket"},{"manufacturer":"MyPhone (PL)","market_name":"myPhone Q-Smart Elite","codename":"Q-Smart_Elite_JMP","model":"Q-Smart_Elite"},{"manufacturer":"MyPhone (PL)","market_name":"myPhone Q-Smart Plus","codename":"Q-Smart_Plus","model":"Q-Smart_Plus"},{"manufacturer":"MyPhone (PL)","market_name":"myPhone_C-Smart _4","codename":"myPhone_C-Smart_4","model":"myPhone_C-Smart_4"},{"manufacturer":"MyPhone (PL)","market_name":"myPhone_Fun5","codename":"myPhone_Fun5","model":"Fun5"},{"manufacturer":"MyPhone (PL)","market_name":"myPhone_Power","codename":"myPhone_Power","model":"Power"},{"manufacturer":"MyPhone (PL)","market_name":"myPhone_Prime_2","codename":"myPhone_Prime_2","model":"Prime 2"},{"manufacturer":"Myphone","market_name":"CITY XL","codename":"myPhone_CityXL","model":"CityXL"},{"manufacturer":"Myphone","market_name":"CITY XL","codename":"myPhone_CityXL","model":"myPhone CityXL"},{"manufacturer":"Myphone","market_name":"CUBE","codename":"myphone_cube","model":"myPhone Cube"},{"manufacturer":"Myphone","market_name":"Fusion5_F803B","codename":"Fusion5_F803B","model":"Fusion5_F803B"},{"manufacturer":"Myphone","market_name":"HAMMER BOLT","codename":"Hammer_Bolt","model":"Bolt"},{"manufacturer":"Myphone","market_name":"Hammer AXE M LTE","codename":"AXE_M_LTE_OPM","model":"HAMMER_AXE_M_LTE"},{"manufacturer":"Myphone","market_name":"Hammer Blade","codename":"Hammer_Blade","model":"Blade"},{"manufacturer":"Myphone","market_name":"Hammer Iron 3 LTE","codename":"Hammer_Iron_3_LTE","model":"Hammer_Iron_3_LTE"},{"manufacturer":"Myphone","market_name":"Iron 2","codename":"IRON_2_EN","model":"IRON_2"},{"manufacturer":"Myphone","market_name":"Iron 2","codename":"IRON_2_OPM","model":"IRON_2"},{"manufacturer":"Myphone","market_name":"My phone PRIME PLUS","codename":"Prime_Plus_EN","model":"Prime_Plus"},{"manufacturer":"Myphone","market_name":"NB106M","codename":"NB106M","model":"NB106M"},{"manufacturer":"Myphone","market_name":"NB754","codename":"NB754","model":"NB754"},{"manufacturer":"Myphone","market_name":"NB961","codename":"NB961","model":"NB961"},{"manufacturer":"Myphone","market_name":"Pocket 18X9","codename":"myPhone_Pocket_18x9","model":"myPhone_Pocket_18x9"},{"manufacturer":"Myphone","market_name":"Pocket18X9 LTE","codename":"Pocket_18x9_LTE","model":"Pocket_18x9_LTE"},{"manufacturer":"Myphone","market_name":"Prime 18x9","codename":"Prime_18x9","model":"Prime_18x9"},{"manufacturer":"Myphone","market_name":"Q-Smart_III","codename":"myPhone_Q-Smart_III","model":"myPhone_Q-Smart_III"},{"manufacturer":"Myphone","market_name":"SmartView_7_3G","codename":"SmartView_7_3G","model":"SmartView_7_3G"},{"manufacturer":"Myphone","market_name":"SmartView_8","codename":"SmartView_8_LTE","model":"SmartView_8_LTE"},{"manufacturer":"Myphone","market_name":"SmartView_9.6","codename":"SmartView_9_6_3G","model":"SmartView_9_6_3G"},{"manufacturer":"Myphone","market_name":"UNO","codename":"UNO_sprout","model":"MyPhone UNO"},{"manufacturer":"Myphone","market_name":"brown 1","codename":"V4701_I01","model":"brown 1"},{"manufacturer":"Myphone","market_name":"my28S","codename":"MyPhone_my28S","model":"MyPhone my28S"},{"manufacturer":"Myphone","market_name":"my28S DTV","codename":"MyPhone_my28S_DTV","model":"MyPhone my28S DTV"},{"manufacturer":"Myphone","market_name":"my28S Smart","codename":"MyPhone_my28S_Smart","model":"my28S Smart"},{"manufacturer":"Myphone","market_name":"my71 DTV","codename":"my71_DTV","model":"MyPhone my71 DTV"},{"manufacturer":"Myphone","market_name":"my72 DTV","codename":"MyPhone_my72_DTV","model":"MyPhone my72 DTV"},{"manufacturer":"Myphone","market_name":"my73 DTV","codename":"MyPhone_my73_DTV","model":"MyPhone my73 DTV"},{"manufacturer":"Myphone","market_name":"my75 DTV","codename":"MyPhone_my75_DTV","model":"MyPhone my75 DTV"},{"manufacturer":"Myphone","market_name":"my76 DTV","codename":"MyPhonemy76DTV","model":"MyPhone_my76 DTV"},{"manufacturer":"Myphone","market_name":"my77 DTV","codename":"MyPhone_my77_DTV","model":"MyPhone my77 DTV"},{"manufacturer":"Myphone","market_name":"my81 DTV","codename":"MyPhone_my81_DTV","model":"MyPhone my81 DTV"},{"manufacturer":"Myphone","market_name":"my85 DTV","codename":"MyPhone_my85_DTV","model":"MyPhone my85 DTV"},{"manufacturer":"Myphone","market_name":"my86 DTV","codename":"MyPhone_my86_DTV","model":"MyPhone_my86_DTV"},{"manufacturer":"Myphone","market_name":"my87 DTV","codename":"MyPhone_my87_DTV","model":"MyPhone my87 DTV"},{"manufacturer":"Myphone","market_name":"my88 DTV","codename":"MyPhone_my88_DTV","model":"MyPhone my88 DTV"},{"manufacturer":"Myphone","market_name":"my89 DTV","codename":"MyPhone_my89_DTV","model":"MyPhone my89 DTV"},{"manufacturer":"Myphone","market_name":"my91 DTV","codename":"my91_DTV","model":"MyPhone my91 DTV"},{"manufacturer":"Myphone","market_name":"my92 DTV","codename":"MyPhone_my92_DTV","model":"MyPhone my92 DTV"},{"manufacturer":"Myphone","market_name":"my93 DTV","codename":"MyPhone_my93_DTV","model":"MyPhone my93 DTV"},{"manufacturer":"Myphone","market_name":"my95 DTV","codename":"MyPhone_my95_DTV","model":"MyPhone my95 DTV"},{"manufacturer":"Myphone","market_name":"my96 DTV","codename":"MyPhone_my96_DTV","model":"MyPhone my96 DTV"},{"manufacturer":"Myphone","market_name":"myA1","codename":"MY801","model":"MY801"},{"manufacturer":"Myphone","market_name":"myA10","codename":"myA10","model":"myA10"},{"manufacturer":"Myphone","market_name":"myA2","codename":"MY802","model":"MY802"},{"manufacturer":"Myphone","market_name":"myA3","codename":"MY803","model":"MY803"},{"manufacturer":"Myphone","market_name":"myA5","codename":"MY805","model":"MY805"},{"manufacturer":"Myphone","market_name":"myA6_DTV","codename":"MY806","model":"MY806"},{"manufacturer":"Myphone","market_name":"myA7 DTV","codename":"myA7_DTV","model":"myA7 DTV"},{"manufacturer":"Myphone","market_name":"myA8 DTV","codename":"myA8_DTV","model":"myA8 DTV"},{"manufacturer":"Myphone","market_name":"myA9_DTV","codename":"myA9_DTV","model":"myA9 DTV"},{"manufacturer":"Myphone","market_name":"myPhone  Q-Smart III Plus","codename":"Q-Smart_III_Plus","model":"Q-Smart_III_Plus"},{"manufacturer":"Myphone","market_name":"myT3 DTV","codename":"myT3_DTV","model":"myT3 DTV"},{"manufacturer":"Myphone","market_name":"myT5 DTV","codename":"myT5_DTV","model":"myT5 DTV"},{"manufacturer":"Myphone","market_name":"myX1","codename":"MY807","model":"MY807"},{"manufacturer":"Myphone","market_name":"myX8","codename":"myX8","model":"myX8"},{"manufacturer":"Myphone","market_name":"neocore_E1R1","codename":"neocore_E1R1","model":"neocore_E1R1"},{"manufacturer":"Myria","market_name":"3G MY8300","codename":"3G_MY8300","model":"3G"},{"manufacturer":"Myria","market_name":"Classic MY8301","codename":"Classic_MY8301","model":"Classic"},{"manufacturer":"Myria","market_name":"Classic MY8301","codename":"MY8301","model":"Classic"},{"manufacturer":"Myria","market_name":"Compact_E2_Plus","codename":"Compact_E2_Plus","model":"Compact_E2_Plus"},{"manufacturer":"Myria","market_name":"Cozy MY8302","codename":"Cozy_MY8302","model":"Cozy"},{"manufacturer":"Myria","market_name":"Cozy MY8302","codename":"MY8302","model":"Cozy"},{"manufacturer":"Myria","market_name":"Fancy","codename":"Myria_Fancy","model":"Fancy"},{"manufacturer":"Myria","market_name":"Myria 4G MY8303","codename":"MY8303","model":"4G"},{"manufacturer":"Myria","market_name":"Myria FIVE","codename":"Myria_FIVE","model":"Myria_FIVE"},{"manufacturer":"Myria","market_name":"Myria Giant MY8304","codename":"MY8304","model":"Giant"},{"manufacturer":"Myria","market_name":"Myria Grand 4G","codename":"Myria_Grand_4G","model":"Myria_Grand_4G"},{"manufacturer":"Myria","market_name":"Myria Wide 2","codename":"Myria_Wide_2","model":"Myria_Wide_2"},{"manufacturer":"Myria","market_name":"Myria Wide 4G","codename":"Myria_Wide_4G","model":"Myria_Wide_4G"},{"manufacturer":"NASCO","market_name":"Allure_Plus","codename":"NASCO_Allure_Plus","model":"NASCO_Allure_Plus"},{"manufacturer":"NASCO","market_name":"Magic","codename":"Magic","model":"Magic"},{"manufacturer":"NASCO","market_name":"Power Plus","codename":"Power_Plus","model":"Power Plus"},{"manufacturer":"NASCO","market_name":"Power Plus Pro","codename":"PowerPlusPro","model":"Power Plus Pro"},{"manufacturer":"NASCO","market_name":"SNAP","codename":"SNAP","model":"SNAP"},{"manufacturer":"NASCO","market_name":"SNAP PRO","codename":"SNAP_PRO","model":"SNAP_PRO"},{"manufacturer":"NAXA","market_name":"NID-7011","codename":"NID-7011","model":"NID-7011"},{"manufacturer":"NAXA","market_name":"NID_7010","codename":"NID_7010","model":"NID_7010"},{"manufacturer":"NEC","market_name":"101T \\xe3\\x80\\x80MEDIAS","codename":"NEC-101","model":"NEC-101T"},{"manufacturer":"NEC","market_name":"AGT10","codename":"AGT10","model":"N8730-411"},{"manufacturer":"NEC","market_name":"AGT10","codename":"AGT10","model":"N8730-41101"},{"manufacturer":"NEC","market_name":"AGT10","codename":"AGT10","model":"N8730-41102"},{"manufacturer":"NEC","market_name":"AGT10 D000-000039-001","codename":"D000000039","model":"NEC-STR"},{"manufacturer":"NEC","market_name":"CASIO G\\'zOne Commando 4G LTE","codename":"C811","model":"C811 4G"},{"manufacturer":"NEC","market_name":"Casio G\\'zOne Commando","codename":"C771","model":"C771"},{"manufacturer":"NEC","market_name":"Disney Mobile on docomoN-03E","codename":"N-03E","model":"N-03E"},{"manufacturer":"NEC","market_name":"G\\'z One IS11CA","codename":"IS11CA","model":"IS11CA"},{"manufacturer":"NEC","market_name":"G\\'zOne TYPE-L CAL21","codename":"CAL21","model":"CAL21"},{"manufacturer":"NEC","market_name":"G\\xe2\\x80\\x99zOne CA-201L","codename":"CA201L","model":"CA-201L"},{"manufacturer":"NEC","market_name":"LaVieTab PC-TE508BAW","codename":"TE508BAW","model":"PC-TE508BAW"},{"manufacturer":"NEC","market_name":"LaVieTab PC-TE508S1W/LaVieTab PC-TE508S1L","codename":"PC-TE508S1_nec","model":"LaVieTab PC-TE508S1"},{"manufacturer":"NEC","market_name":"LaVieTab PC-TE510S1L","codename":"PC-TE510S1_nec","model":"LaVieTab PC-TE510S1"},{"manufacturer":"NEC","market_name":"LifeTouch B","codename":"LTB013","model":"D000-000013-101"},{"manufacturer":"NEC","market_name":"LifeTouch B","codename":"LTB018","model":"D000-000018-001"},{"manufacturer":"NEC","market_name":"LifeTouch B","codename":"LTB018","model":"D000-000018-002"},{"manufacturer":"NEC","market_name":"LifeTouch B","codename":"LTB018","model":"D000-000018-003"},{"manufacturer":"NEC","market_name":"LifeTouch B","codename":"LTB018","model":"D000-000018-004"},{"manufacturer":"NEC","market_name":"LifeTouch B","codename":"LTB018","model":"D000-000018-101"},{"manufacturer":"NEC","market_name":"LifeTouch B","codename":"LTB018","model":"D000-000018-102"},{"manufacturer":"NEC","market_name":"LifeTouch B","codename":"LTB018","model":"D000-000018-104"},{"manufacturer":"NEC","market_name":"LifeTouch B","codename":"LTB019G","model":"D000-000019-002"},{"manufacturer":"NEC","market_name":"LifeTouch B","codename":"LTB019W","model":"D000-000019-001"},{"manufacturer":"NEC","market_name":"LifeTouch B","codename":"LTB028","model":"LTB-HS"},{"manufacturer":"NEC","market_name":"LifeTouch L","codename":"D000000023","model":"LT-TLA"},{"manufacturer":"NEC","market_name":"LifeTouch L","codename":"D000000035","model":"NEC-STR"},{"manufacturer":"NEC","market_name":"LifeTouch L","codename":"D000000039","model":"NEC-STR"},{"manufacturer":"NEC","market_name":"LifeTouch L","codename":"LTTLA16","model":"LT-TLA"},{"manufacturer":"NEC","market_name":"LifeTouch L","codename":"LTTLA32","model":"LT-TLA"},{"manufacturer":"NEC","market_name":"LifeTouch L D000-000035-001","codename":"D000000035","model":"NEC-STR"},{"manufacturer":"NEC","market_name":"LifeTouch L D000-000035-002","codename":"D000000035","model":"NEC-STR"},{"manufacturer":"NEC","market_name":"LifeTouch Note","codename":"D000000010N","model":"D000-000010-N"},{"manufacturer":"NEC","market_name":"LifeTouch Note","codename":"D000000011N","model":"D000-000011-N"},{"manufacturer":"NEC","market_name":"LifeTouch Note","codename":"LTNA7","model":"LT-NA7"},{"manufacturer":"NEC","market_name":"LifeTouch Note","codename":"LTNA7F","model":"LT-NA7F"},{"manufacturer":"NEC","market_name":"LifeTouch S","codename":"LifeTouch_D1","model":"D000-000001-B01"},{"manufacturer":"NEC","market_name":"LifeTouch S","codename":"LifeTouch_D1","model":"D000-000001-B02"},{"manufacturer":"NEC","market_name":"LifeTouch S","codename":"LifeTouch_D1","model":"D000-000001-C01"},{"manufacturer":"NEC","market_name":"LifeTouch S","codename":"LifeTouch_D1","model":"D000-000001-K01"},{"manufacturer":"NEC","market_name":"LifeTouch S","codename":"LifeTouch_D1","model":"D000-000001-R01"},{"manufacturer":"NEC","market_name":"LifeTouch S","codename":"LifeTouch_D1","model":"D000-000001-R02"},{"manufacturer":"NEC","market_name":"LifeTouch S","codename":"LifeTouch_D1","model":"D000-000001-R03"},{"manufacturer":"NEC","market_name":"LifeTouch S","codename":"LifeTouch_D1","model":"D000-000001-R04"},{"manufacturer":"NEC","market_name":"LifeTouch S","codename":"LifeTouch_D1","model":"D000-000001-S00"},{"manufacturer":"NEC","market_name":"LifeTouch S","codename":"LifeTouch_D1","model":"D000-000001-S01"},{"manufacturer":"NEC","market_name":"LifeTouch S","codename":"LifeTouch_D1","model":"D000-000001-S05"},{"manufacturer":"NEC","market_name":"LifeTouch S","codename":"LifeTouch_D1","model":"D000-000001-S25"},{"manufacturer":"NEC","market_name":"LifeTouch S","codename":"LifeTouch_D1","model":"D000-000001-S85"},{"manufacturer":"NEC","market_name":"LifeTouch S","codename":"LifeTouch_D7","model":"D000-000007-D01"},{"manufacturer":"NEC","market_name":"LifeTouch W","codename":"LT-W1_1","model":"D000-000002-W01"},{"manufacturer":"NEC","market_name":"LifeTouch W","codename":"LT-W1_2","model":"D000-000002-W02"},{"manufacturer":"NEC","market_name":"LifeTouch W","codename":"LifeTouch_W1","model":"D000-000002-001"},{"manufacturer":"NEC","market_name":"MEDIAS  X N-06E","codename":"N-06E","model":"N-06E"},{"manufacturer":"NEC","market_name":"MEDIAS BR IS11N","codename":"IS11N","model":"IS11N"},{"manufacturer":"NEC","market_name":"MEDIAS CH 101N","codename":"101N","model":"101N"},{"manufacturer":"NEC","market_name":"MEDIAS ES N-05D","codename":"N-05D","model":"N-05D"},{"manufacturer":"NEC","market_name":"MEDIAS LTE N-04D","codename":"N-04D","model":"N-04D"},{"manufacturer":"NEC","market_name":"MEDIAS N-04C","codename":"N-04C","model":"N-04C"},{"manufacturer":"NEC","market_name":"MEDIAS NE-202","codename":"NE-202","model":"NE-202"},{"manufacturer":"NEC","market_name":"MEDIAS NEC-101S","codename":"MAGNUM","model":"NEC-101S"},{"manufacturer":"NEC","market_name":"MEDIAS NEC-101S","codename":"NEC-101","model":"NEC-101S"},{"manufacturer":"NEC","market_name":"MEDIAS NEC-102","codename":"NEC-102","model":"NEC-102"},{"manufacturer":"NEC","market_name":"MEDIAS PP N-01D","codename":"N-01D","model":"N-01D"},{"manufacturer":"NEC","market_name":"MEDIAS TAB N-06D","codename":"N-06D","model":"N-06D"},{"manufacturer":"NEC","market_name":"MEDIAS TAB UL N-08D","codename":"N-08D","model":"N-08D"},{"manufacturer":"NEC","market_name":"MEDIAS U N-02E","codename":"N-02E","model":"N-02E"},{"manufacturer":"NEC","market_name":"MEDIAS U NE-103T","codename":"NE-103","model":"NE-103T"},{"manufacturer":"NEC","market_name":"MEDIAS W N-05E","codename":"N-05E","model":"N-05E"},{"manufacturer":"NEC","market_name":"MEDIAS WP N-06C","codename":"N-06C","model":"N-06C"},{"manufacturer":"NEC","market_name":"MEDIAS X N-04E","codename":"N-04E","model":"N-04E"},{"manufacturer":"NEC","market_name":"MEDIAS X N-07D","codename":"N-07D","model":"N-07D"},{"manufacturer":"NEC","market_name":"NE-201","codename":"NE-201","model":"NEC-NE-201A1A"},{"manufacturer":"NEC","market_name":"NEC909e","codename":"NEC909e","model":"NEC909e"},{"manufacturer":"NEC","market_name":"PC- TS507N1S","codename":"PC-TS507N1S","model":"LaVieTab PC-TS507N1S"},{"manufacturer":"NEC","market_name":"PC-508T1W","codename":"508T1W","model":"PC-TS508T1W"},{"manufacturer":"NEC","market_name":"PC-708T1W","codename":"708T1W","model":"PC-TS708T1W"},{"manufacturer":"NEC","market_name":"PC-TE307N1W","codename":"PC-TE307N1W","model":"PC-TE307N1W"},{"manufacturer":"NEC","market_name":"PC-TE508HAW","codename":"PC-TE508HAW","model":"PC-TE508HAW"},{"manufacturer":"NEC","market_name":"PC-TE510N1B","codename":"LaVieTab","model":"LaVieTab PC-TE510N1B"},{"manufacturer":"NESO","market_name":"N810 i7","codename":"N810_i7_1","model":"N810 i7"},{"manufacturer":"NGM Italia SRL","market_name":"Danamic Now","codename":"DynamicNow","model":"Now"},{"manufacturer":"NGM Italia SRL","market_name":"Dynamic Racing 3","codename":"NGM_Dynamic_Racing_3","model":"Dynamic Racing 3"},{"manufacturer":"NGM Italia SRL","market_name":"Dynamic_Stylo","codename":"NGM_Dynamic_Stylo","model":"NGM_Dynamic_Stylo"},{"manufacturer":"NGM Italia SRL","market_name":"E407","codename":"E407","model":"E407"},{"manufacturer":"NGM Italia SRL","market_name":"E451","codename":"E451","model":"E451"},{"manufacturer":"NGM Italia SRL","market_name":"E505 Plus","codename":"E505plus","model":"E505plus"},{"manufacturer":"NGM Italia SRL","market_name":"E506plus","codename":"E506plus","model":"E506plus"},{"manufacturer":"NGM Italia SRL","market_name":"E553","codename":"E553","model":"E553"},{"manufacturer":"NGM Italia SRL","market_name":"Endurance","codename":"ForwardEndurance","model":"ForwardEndurance"},{"manufacturer":"NGM Italia SRL","market_name":"ForwardZero","codename":"ForwardZero","model":"ForwardZero"},{"manufacturer":"NGM Italia SRL","market_name":"Forward_Prime","codename":"Forward_Prime","model":"Forward_Prime"},{"manufacturer":"NGM Italia SRL","market_name":"Infinity","codename":"Infinity","model":"Infinity"},{"manufacturer":"NGM Italia SRL","market_name":"LIFE","codename":"Life","model":"Life"},{"manufacturer":"NGM Italia SRL","market_name":"M500","codename":"NGM_M500","model":"NGM M500"},{"manufacturer":"NGM Italia SRL","market_name":"M502","codename":"M502","model":"M502"},{"manufacturer":"NGM Italia SRL","market_name":"NGM Youcolor E400","codename":"E400","model":"E400"},{"manufacturer":"NGM Italia SRL","market_name":"NGM Youcolor E450","codename":"E450","model":"E450"},{"manufacturer":"NGM Italia SRL","market_name":"NGM Youcolor E501","codename":"E501","model":"E501"},{"manufacturer":"NGM Italia SRL","market_name":"NGM Youcolor E505","codename":"E505","model":"E505"},{"manufacturer":"NGM Italia SRL","market_name":"NGM Youcolor E506","codename":"E506","model":"E506"},{"manufacturer":"NGM Italia SRL","market_name":"NGM Youcolor E507","codename":"E507","model":"E507"},{"manufacturer":"NGM Italia SRL","market_name":"P503","codename":"NGM_P503","model":"NGM P503"},{"manufacturer":"NGM Italia SRL","market_name":"P508","codename":"P508","model":"P508"},{"manufacturer":"NGM Italia SRL","market_name":"P509","codename":"NGM_P509","model":"P509"},{"manufacturer":"NGM Italia SRL","market_name":"P550","codename":"NGM_P550","model":"NGM P550"},{"manufacturer":"NGM Italia SRL","market_name":"P551","codename":"NGM_P551","model":"P551"},{"manufacturer":"NGM Italia SRL","market_name":"P552","codename":"NGM_P552","model":"P552"},{"manufacturer":"NGM Italia SRL","market_name":"Ruby","codename":"ForwardRuby","model":"Forward Ruby"},{"manufacturer":"NGM Italia SRL","market_name":"Ruby","codename":"ForwardRuby","model":"ForwardRuby"},{"manufacturer":"NGM Italia SRL","market_name":"Smart5","codename":"Smart5","model":"Smart5"},{"manufacturer":"NGM Italia SRL","market_name":"Smart5.5","codename":"Smart55","model":"Smart5.5"},{"manufacturer":"NGM Italia SRL","market_name":"Smart5.5Plus","codename":"Smart55Plus","model":"Smart5.5Plus32GB"},{"manufacturer":"NGM Italia SRL","market_name":"Smart5Plus","codename":"Smart5Plus","model":"Smart5Plus"},{"manufacturer":"NOA Mobile","market_name":"Forte_se","codename":"Forte_se","model":"Forte_se"},{"manufacturer":"NOA Mobile","market_name":"Hummer","codename":"Hummer","model":"Hummer"},{"manufacturer":"NOA Mobile","market_name":"N8","codename":"NOA_N8","model":"NOA_N8"},{"manufacturer":"NOA Mobile","market_name":"NextSE","codename":"NextSE","model":"NextSE"},{"manufacturer":"NOA Mobile","market_name":"SPRINT 4G","codename":"SPRINT4G","model":"SPRINT4G"},{"manufacturer":"NOA Mobile","market_name":"SparkSE","codename":"SparkSE","model":"SparkSE"},{"manufacturer":"NVIDIA","market_name":"SHIELD Android TV","codename":"foster","model":"SHIELD Android TV"},{"manufacturer":"NVIDIA","market_name":"SHIELD Android TV","codename":"foster","model":"SHIELD Console"},{"manufacturer":"NVIDIA","market_name":"SHIELD TV","codename":"darcy","model":"SHIELD Android TV"},{"manufacturer":"NVIDIA","market_name":"SHIELD Tablet","codename":"shieldtablet","model":"SHIELD Tablet"},{"manufacturer":"NVIDIA","market_name":"Shield","codename":"roth","model":"SHIELD"},{"manufacturer":"NVIDIA","market_name":"TegraNote","codename":"tegranote","model":"Tegra Note 7"},{"manufacturer":"NVIDIA","market_name":"TegraNote","codename":"tegranote","model":"TegraNote-P1640"},{"manufacturer":"NVIDIA","market_name":"TegraNote","codename":"tegranote","model":"TegraNote-Premium"},{"manufacturer":"NVIDIA","market_name":"TegraNote","codename":"tegranote7c","model":"Tegra Note 7"},{"manufacturer":"NYX Mobile","market_name":"A1","codename":"NYX_A1","model":"NYX_A1"},{"manufacturer":"NYX Mobile","market_name":"BLINK","codename":"BLiNK","model":"BLiNK"},{"manufacturer":"NYX Mobile","market_name":"C450","codename":"C450","model":"C450"},{"manufacturer":"NYX Mobile","market_name":"C500","codename":"C500","model":"C500"},{"manufacturer":"NYX Mobile","market_name":"Click","codename":"Click","model":"Click"},{"manufacturer":"NYX Mobile","market_name":"FIT","codename":"FIT","model":"FIT"},{"manufacturer":"NYX Mobile","market_name":"GLAM","codename":"GLAM","model":"GLAM"},{"manufacturer":"NYX Mobile","market_name":"GO-X","codename":"GO-X","model":"GO-X"},{"manufacturer":"NYX Mobile","market_name":"HIT","codename":"NYX_HIT","model":"NYX_HIT"},{"manufacturer":"NYX Mobile","market_name":"ICE","codename":"ICE","model":"ICE"},{"manufacturer":"NYX Mobile","market_name":"KiN","codename":"KiN","model":"KiN"},{"manufacturer":"NYX Mobile","market_name":"NOBA","codename":"NOBA","model":"NOBA"},{"manufacturer":"NYX Mobile","market_name":"REX","codename":"Rex","model":"Rex"},{"manufacturer":"NYX Mobile","market_name":"SENSE","codename":"SENSE","model":"SENSE"},{"manufacturer":"NYX Mobile","market_name":"SEVEN","codename":"SEVEN","model":"SEVEN"},{"manufacturer":"NYX Mobile","market_name":"SHADE","codename":"NYX_SHADE","model":"NYX_SHADE"},{"manufacturer":"NYX Mobile","market_name":"TQ14","codename":"TQ14","model":"TQ14"},{"manufacturer":"Nabi","market_name":"2 Tablet","codename":"mt799","model":"NABI2-NV7A"},{"manufacturer":"Nabi","market_name":"2S Tablet","codename":"nabi2S","model":"SNB02-NV7A"},{"manufacturer":"Nabi","market_name":"American Girl Tablet","codename":"NBTY07SMKG","model":"NBTY07SMKG"},{"manufacturer":"Nabi","market_name":"Barbie Tablet","codename":"NBTY07SMKG","model":"NBTY07SMKG"},{"manufacturer":"Nabi","market_name":"\"Big Tab HD\\xe2\\x84\\xa2 20\"\"\"","codename":"DMTAB-NV20A","model":"DMTAB-NV20A"},{"manufacturer":"Nabi","market_name":"\"Big Tab HD\\xe2\\x84\\xa2 24\"\"\"","codename":"DMTAB-NV24A","model":"DMTAB-NV24A"},{"manufacturer":"Nabi","market_name":"DreamTab HD8 Tablet","codename":"DMTAB","model":"DMTAB-IN08A"},{"manufacturer":"Nabi","market_name":"DreamTab HD8 Tablet","codename":"t8400n","model":"DMTAB-NV08B"},{"manufacturer":"Nabi","market_name":"Fisher Price Learning Tablet","codename":"NBFP07PMKG","model":"NBFP07PMKG"},{"manufacturer":"Nabi","market_name":"Hot Wheels Tablet","codename":"NBTY07SMKG","model":"NBTY07SMKG"},{"manufacturer":"Nabi","market_name":"TOY 7","codename":"NBTY07SMKG","model":"NBTY07SMKG"},{"manufacturer":"Nanho","market_name":"F101","codename":"F101","model":"F101"},{"manufacturer":"NanoTech","market_name":"Nuvola NP-1","codename":"nuvola","model":"Nuvola NP-1"},{"manufacturer":"Navcity","market_name":"NAVCITY NP-752","codename":"NP_752","model":"NP-752"},{"manufacturer":"Navcity","market_name":"NAVCITY NP-852","codename":"NP-852","model":"NP-852"},{"manufacturer":"Navcity","market_name":"NAVCITY NP-855","codename":"NP_855","model":"NP-855"},{"manufacturer":"Navcity","market_name":"NT-1714","codename":"NT1714","model":"NT-1714"},{"manufacturer":"Navitel","market_name":"Navitel T700 3G Navi","codename":"NAVITEL_T700_3G_NAVI","model":"NAVITEL T700 3G NAVI"},{"manufacturer":"Navitel","market_name":"T500 3G","codename":"T500_3G","model":"T500 3G"},{"manufacturer":"Navon","market_name":"D455","codename":"D455","model":"D455"},{"manufacturer":"Navon","market_name":"D504","codename":"D504","model":"D504"},{"manufacturer":"Navon","market_name":"F552","codename":"F552","model":"NAVON F552"},{"manufacturer":"Navon","market_name":"IQ7","codename":"IQ7","model":"IQ7"},{"manufacturer":"Navon","market_name":"Infinity","codename":"Infinity","model":"Navon_Infinity"},{"manufacturer":"Navon","market_name":"M505","codename":"M505_4G","model":"M505_4G"},{"manufacturer":"Navon","market_name":"Navon Supreme  Pure","codename":"Supreme_Pure","model":"Navon Supreme Pure"},{"manufacturer":"Navon","market_name":"Platinum 10 3G","codename":"Platinum_10_3G","model":"Platinum 10 3G"},{"manufacturer":"Navon","market_name":"Platinum 10 3G","codename":"Platinum_10_3G_V2","model":"Platinum_10_3G_V2"},{"manufacturer":"Navon","market_name":"Predator 10","codename":"Predator_10","model":"Predator 10"},{"manufacturer":"Navon","market_name":"Predator 3G","codename":"Predator_3G","model":"Predator 3G"},{"manufacturer":"Navon","market_name":"S450","codename":"S450","model":"S450"},{"manufacturer":"Navon","market_name":"Superme_Max","codename":"Superme_Max","model":"Superme_Max"},{"manufacturer":"Navon","market_name":"Supreme Chief","codename":"Supreme_Chief","model":"Supreme Chief"},{"manufacturer":"Navon","market_name":"Supreme Fine","codename":"Supreme_Fine","model":"Supreme_Fine"},{"manufacturer":"Navon","market_name":"Supreme Fine Mini","codename":"Supreme_Fine_Mini","model":"Supreme_Fine_Mini"},{"manufacturer":"Navon","market_name":"Supreme Fine Plus","codename":"Supreme_Fine_Plus","model":"Supreme Fine Plus"},{"manufacturer":"Navon","market_name":"Supreme Pro","codename":"Supreme_Pro","model":"Supreme_Pro"},{"manufacturer":"Navon","market_name":"Supreme_Fine_Micro","codename":"Supreme_Fine_Micro","model":"Supreme_Fine_Micro"},{"manufacturer":"Navon","market_name":"Supreme_Pure_Plus","codename":"Supreme_Pure_Plus","model":"Supreme_Pure_Plus"},{"manufacturer":"Navon","market_name":"T400","codename":"T400","model":"T400"},{"manufacturer":"Navon","market_name":"T400 3G","codename":"T400_3G","model":"T400 3G 2017"},{"manufacturer":"Navon","market_name":"T452","codename":"T452","model":"T452"},{"manufacturer":"Navon","market_name":"T503","codename":"T503","model":"T503"},{"manufacturer":"Navon","market_name":"Vision Tab 10","codename":"Vision_Tab_10","model":"Vision_Tab_10"},{"manufacturer":"Navon","market_name":"Vision_Tab_7","codename":"Vision_Tab_7","model":"Vision_Tab_7"},{"manufacturer":"Navon","market_name":"iQ7 2018","codename":"iQ7_2018","model":"iQ7_2018"},{"manufacturer":"Naxa","market_name":"NID1009","codename":"NID1009","model":"NID-1009"},{"manufacturer":"Naxa","market_name":"NID7019","codename":"NID7019","model":"NID-7019"},{"manufacturer":"Naxa","market_name":"NID9009","codename":"NID9009","model":"NID-9009"},{"manufacturer":"Ncredible","market_name":"NV8","codename":"NV8","model":"NV8"},{"manufacturer":"Ncredible","market_name":"NV8-HD","codename":"NV8-HD","model":"NV8"},{"manufacturer":"Neffos","market_name":"C5","codename":"C5","model":"Neffos C5"},{"manufacturer":"Neffos","market_name":"C5 Max","codename":"C5_Max","model":"Neffos C5 Max"},{"manufacturer":"Neffos","market_name":"C5L","codename":"QC601","model":"TP601A"},{"manufacturer":"Neffos","market_name":"C5L","codename":"QC601","model":"TP601B"},{"manufacturer":"Neffos","market_name":"C5L","codename":"QC601","model":"TP601C"},{"manufacturer":"Neffos","market_name":"C5L","codename":"QC601","model":"TP601E"},{"manufacturer":"Neffos","market_name":"Neffos C7","codename":"C7","model":"Neffos C7"},{"manufacturer":"Neffos","market_name":"Neffos N1","codename":"N1","model":"Neffos N1"},{"manufacturer":"Neffos","market_name":"Neffos X1","codename":"X1","model":"Neffos X1"},{"manufacturer":"Neffos","market_name":"Neffos X1 Max","codename":"X1_Max","model":"Neffos X1 Max"},{"manufacturer":"Neffos","market_name":"Neffos Y5i","codename":"Y5i","model":"Neffos Y5i"},{"manufacturer":"Neffos","market_name":"Neffos Y5s","codename":"Y5s","model":"Neffos Y5s"},{"manufacturer":"Neffos","market_name":"Neffos Y6","codename":"Y6","model":"Neffos Y6"},{"manufacturer":"Neffos","market_name":"Neffos Y7","codename":"Y7","model":"Neffos Y7"},{"manufacturer":"Neffos","market_name":"TP703A","codename":"C5a","model":"Neffos C5a"},{"manufacturer":"Neffos","market_name":"TP704A","codename":"C5s","model":"Neffos C5s"},{"manufacturer":"Neffos","market_name":"TP704A","codename":"Y5_Lite","model":"Neffos Y5 Lite"},{"manufacturer":"Neffos","market_name":"X1 Lite","codename":"X1_Lite","model":"Neffos X1 Lite"},{"manufacturer":"Neffos","market_name":"Y5","codename":"Y5","model":"Neffos Y5"},{"manufacturer":"Neffos","market_name":"Y50","codename":"Y50","model":"Neffos Y50"},{"manufacturer":"Neffos","market_name":"Y5L","codename":"Y5L","model":"Neffos Y5L"},{"manufacturer":"Neffos","market_name":"Y5L","codename":"Y5LM","model":"Neffos Y5L"},{"manufacturer":"Nelson Mandela","market_name":"Freedom 5.0","codename":"Freedom_5_0","model":"Freedom 5.0"},{"manufacturer":"Nelson Mandela","market_name":"Freedom 5.2","codename":"Freedom_5_2","model":"Freedom 5.2"},{"manufacturer":"Nelson Mandela","market_name":"Freedom 5.5","codename":"Freedom_55","model":"Freedom 5.5"},{"manufacturer":"Neostra","market_name":"Neostra-R10","codename":"Neostra-R10","model":"Neostra-R10"},{"manufacturer":"Neostra","market_name":"Neostra-R10C","codename":"Neostra-R10C","model":"Neostra-R10C"},{"manufacturer":"Neostra","market_name":"Neostra-R7","codename":"Neostra-R7","model":"Neostra-R7"},{"manufacturer":"Neostra","market_name":"ViewPad 7A","codename":"ViewPad-Kids-7A","model":"ViewPad-Kids-7A"},{"manufacturer":"Netgear","market_name":"NeoTVPrime","codename":"NeoTV","model":"GTV100"},{"manufacturer":"New Balance","market_name":"Run IQ","codename":"shasta","model":"NB RunIQ"},{"manufacturer":"Newsday","market_name":"Newsday_N2+","codename":"Newsday_N2_","model":"Newsday_N2+"},{"manufacturer":"Newsday","market_name":"U5","codename":"GIGI_U5","model":"U5"},{"manufacturer":"Nexian","market_name":"journey one","codename":"Mi438S_sprout","model":"Mi438S"},{"manufacturer":"Next Learning","market_name":"Nexttab N3","codename":"N3","model":"N3"},{"manufacturer":"Next Technologies","market_name":"GO7BSC","codename":"GO7BSC","model":"GO7BSC"},{"manufacturer":"Next Technologies","market_name":"N7526","codename":"N7526","model":"N7526"},{"manufacturer":"Nextbase","market_name":"GoPlayer","codename":"NBCGGP01","model":"NBCGGP01"},{"manufacturer":"Nextbit","market_name":"Robin","codename":"ether","model":"Robin"},{"manufacturer":"Nextbook","market_name":"M-MP7NB3G","codename":"7_Plus_HD3G","model":"M-MP7NB3G"},{"manufacturer":"Nextbook","market_name":"NX16A10132S","codename":"NX16A10132S","model":"NX16A10132S"},{"manufacturer":"Nextbook","market_name":"NX16A11264","codename":"NX16A11264","model":"NX16A11264"},{"manufacturer":"Nextbook","market_name":"NX16A8116K","codename":"NX16A8116K","model":"NX16A8116K"},{"manufacturer":"Nextbook","market_name":"NX700QC","codename":"nxm7100lvd_wm","model":"NX700QC"},{"manufacturer":"Nextbook","market_name":"NX785QC","codename":"nxm865lvd_wm","model":"NX785QC"},{"manufacturer":"Nextbook","market_name":"NX785QC8G","codename":"NXM865FD","model":"NX785QC8G"},{"manufacturer":"Nextbook","market_name":"NXA101LTE116","codename":"NXA101LTE116","model":"NXA101LTE116"},{"manufacturer":"Nextbook","market_name":"NXA116QC164","codename":"NXA116QC164","model":"NXA116QC164"},{"manufacturer":"Nextbook","market_name":"NXA8LTE116","codename":"NXA8LTE116","model":"NXA8LTE116"},{"manufacturer":"Nextbook","market_name":"NXA8QC116","codename":"NXA8QC116","model":"NXA8QC116"},{"manufacturer":"Nextel","market_name":"V.35","codename":"up11_vsn_h1_single","model":"Nextel V.35"},{"manufacturer":"Nextel","market_name":"V.45","codename":"H26-VSN","model":"NII Nextel"},{"manufacturer":"Nextel","market_name":"V.45","codename":"H26-VSN","model":"V.45"},{"manufacturer":"Nikon","market_name":"COOLPIX","codename":"S800c","model":"COOLPIX S800c"},{"manufacturer":"Nikon","market_name":"COOLPIX S810c","codename":"s810c","model":"COOLPIX S810c"},{"manufacturer":"Nixon","market_name":"The Mission","codename":"sculpin","model":"The Mission"},{"manufacturer":"Njoy","market_name":"Arcas 7","codename":"Arcas_7","model":"nJoy_Arcas_7"},{"manufacturer":"Njoy","market_name":"Chronos 10","codename":"Chronos_10","model":"Chronos_10"},{"manufacturer":"Njoy","market_name":"Kali 8","codename":"Kali_8","model":"Kali_8"},{"manufacturer":"Njoy","market_name":"Tityos 10","codename":"Tityos_10","model":"nJoy_Tityos_10"},{"manufacturer":"Njoy","market_name":"Turnus 8","codename":"Turnus_8","model":"nJoy_Turnus_8"},{"manufacturer":"Njoy","market_name":"nJoy Theia 10","codename":"nJoy_Theia_10","model":"Theia_10"},{"manufacturer":"Nobis","market_name":"NB07","codename":"NB07","model":"NB07"},{"manufacturer":"Nobis","market_name":"NB09","codename":"M9025","model":"NB09"},{"manufacturer":"Nobis","market_name":"NB1022","codename":"RCT6203W46","model":"NB1022"},{"manufacturer":"Nobis","market_name":"NB7022S","codename":"NB7022S","model":"NB7022S"},{"manufacturer":"Nobis","market_name":"NB7850S","codename":"NB7850S","model":"NB7850S"},{"manufacturer":"Noblex","market_name":"Go Action","codename":"N551","model":"N551"},{"manufacturer":"Noblex","market_name":"Go Move","codename":"N552","model":"N552"},{"manufacturer":"Noblex","market_name":"Go Street","codename":"N504","model":"N504"},{"manufacturer":"Noblex","market_name":"Go Urban","codename":"N503","model":"N503"},{"manufacturer":"Noblex","market_name":"NBX-T1014N","codename":"TA10CA2","model":"TA10CA2"},{"manufacturer":"Noblex","market_name":"NBX-T7014","codename":"E270BSA","model":"NBX-T7014"},{"manufacturer":"Noblex","market_name":"T7A6N","codename":"Tablet","model":"T7A6N"},{"manufacturer":"Nokia","market_name":"N1","codename":"Nokia_N1","model":"N1"},{"manufacturer":"Nokia","market_name":"Nokia 1","codename":"FRT","model":"Nokia 1"},{"manufacturer":"Nokia","market_name":"Nokia 2","codename":"E1M","model":"Nokia 2"},{"manufacturer":"Nokia","market_name":"Nokia 3","codename":"NE1","model":"TA-1020"},{"manufacturer":"Nokia","market_name":"Nokia 3","codename":"NE1","model":"TA-1028"},{"manufacturer":"Nokia","market_name":"Nokia 3","codename":"NE1","model":"TA-1032"},{"manufacturer":"Nokia","market_name":"Nokia 3","codename":"NE1","model":"TA-1038"},{"manufacturer":"Nokia","market_name":"Nokia 3.1","codename":"ES2N_sprout","model":"Nokia 3.1"},{"manufacturer":"Nokia","market_name":"Nokia 3.1","codename":"ES2_sprout","model":"Nokia 3.1"},{"manufacturer":"Nokia","market_name":"Nokia 5","codename":"ND1","model":"TA-1024"},{"manufacturer":"Nokia","market_name":"Nokia 5","codename":"ND1","model":"TA-1027"},{"manufacturer":"Nokia","market_name":"Nokia 5","codename":"ND1","model":"TA-1044"},{"manufacturer":"Nokia","market_name":"Nokia 5","codename":"ND1","model":"TA-1053"},{"manufacturer":"Nokia","market_name":"Nokia 5.1","codename":"CO2_sprout","model":"Nokia 5.1"},{"manufacturer":"Nokia","market_name":"Nokia 6","codename":"D1C","model":"TA-1000"},{"manufacturer":"Nokia","market_name":"Nokia 6","codename":"D1C","model":"TA-1003"},{"manufacturer":"Nokia","market_name":"Nokia 6","codename":"PL2","model":"TA-1054"},{"manufacturer":"Nokia","market_name":"Nokia 6","codename":"PLE","model":"TA-1021"},{"manufacturer":"Nokia","market_name":"Nokia 6","codename":"PLE","model":"TA-1025"},{"manufacturer":"Nokia","market_name":"Nokia 6","codename":"PLE","model":"TA-1033"},{"manufacturer":"Nokia","market_name":"Nokia 6","codename":"PLE","model":"TA-1039"},{"manufacturer":"Nokia","market_name":"Nokia 6.1","codename":"PL2","model":"Nokia 6.1"},{"manufacturer":"Nokia","market_name":"Nokia 6.1","codename":"PL2_sprout","model":"Nokia 6.1"},{"manufacturer":"Nokia","market_name":"Nokia 7","codename":"C1N","model":"TA-1041"},{"manufacturer":"Nokia","market_name":"Nokia 7 plus","codename":"B2N","model":"Nokia 7 plus"},{"manufacturer":"Nokia","market_name":"Nokia 7 plus","codename":"B2N_sprout","model":"Nokia 7 plus"},{"manufacturer":"Nokia","market_name":"Nokia 8","codename":"NB1","model":"TA-1004"},{"manufacturer":"Nokia","market_name":"Nokia 8","codename":"NB1","model":"TA-1012"},{"manufacturer":"Nokia","market_name":"Nokia 8","codename":"NB1","model":"TA-1052"},{"manufacturer":"Nokia","market_name":"Nokia 8 Sirocco","codename":"A1N","model":"Nokia 8 Sirocco"},{"manufacturer":"Nokia","market_name":"Nokia 8 Sirocco","codename":"A1N_sprout","model":"Nokia 8 Sirocco"},{"manufacturer":"Nokia","market_name":"Nokia X6","codename":"DRG","model":"Nokia X6"},{"manufacturer":"Nomi","market_name":"CORSA 3 LTE","codename":"Nomi_C070030","model":"Nomi_C070030"},{"manufacturer":"Nomi","market_name":"Corsa 3 3G","codename":"Nomi_C070012","model":"Nomi_C070012"},{"manufacturer":"Nomi","market_name":"I5032","codename":"Nomi_i5032","model":"i5032"},{"manufacturer":"Nomi","market_name":"Libra3 3G","codename":"Nomi_C080012","model":"Nomi_C080012"},{"manufacturer":"Nomi","market_name":"Nomi C070011","codename":"Nomi_C070011","model":"Nomi C070011"},{"manufacturer":"Nomi","market_name":"Nomi C080010","codename":"Nomi_C080010_Libra2","model":"Nomi C080010 Libra2"},{"manufacturer":"Nomi","market_name":"Nomi C101010","codename":"Nomi_C101010_Ultra2","model":"C101010 Ultra2"},{"manufacturer":"Nomi","market_name":"Nomi i5001","codename":"Nomi_i5001","model":"Nomi_i5001"},{"manufacturer":"Nomi","market_name":"Nomi i5013","codename":"i5013","model":"i5013"},{"manufacturer":"Nomi","market_name":"Nomi i5050","codename":"i5050","model":"i5050"},{"manufacturer":"Nomi","market_name":"Nomi i5071","codename":"Nomi_i5071","model":"Nomi i5071"},{"manufacturer":"Nomi","market_name":"Nomi i5510","codename":"Nomi_i5510","model":"i5510"},{"manufacturer":"Nomi","market_name":"Nomi i5511","codename":"Nomi_i5511","model":"Nomi_i5511"},{"manufacturer":"Nomi","market_name":"Nomi i5532","codename":"Nomi_i5532","model":"i5532"},{"manufacturer":"Nomi","market_name":"Nomi i6030","codename":"i6030","model":"Nomi i6030"},{"manufacturer":"Nomi","market_name":"Nomi_i5730","codename":"Nomi_i5730","model":"Nomi_i5730"},{"manufacturer":"Nomi","market_name":"ULTRA3 3G","codename":"Nomi_C101012","model":"Nomi_C101012"},{"manufacturer":"Nomi","market_name":"ULTRA3 LTE","codename":"Nomi_C101030","model":"Nomi_C101030"},{"manufacturer":"Nomi","market_name":"ULTRA3 LTE PRO","codename":"Nomi_C101040","model":"Nomi_C101040"},{"manufacturer":"Nomi","market_name":"i5012","codename":"i5012","model":"i5012"},{"manufacturer":"Nomu","market_name":"M8","codename":"M8","model":"M8"},{"manufacturer":"Nomu","market_name":"S10","codename":"S10","model":"S10"},{"manufacturer":"Nomu","market_name":"S50 Pro","codename":"S50_Pro","model":"S50_Pro"},{"manufacturer":"Nous","market_name":"Fabulous","codename":"NS5005","model":"NS5005"},{"manufacturer":"Nous","market_name":"NS5002","codename":"NS5002","model":"NS5002"},{"manufacturer":"Nous","market_name":"NS5502","codename":"NS5502","model":"NS5502"},{"manufacturer":"Nous","market_name":"Optimum","codename":"NS5008","model":"NS5008"},{"manufacturer":"Now E","market_name":"Now E","codename":"hk101","model":"hk101"},{"manufacturer":"NuAns","market_name":"NEO [Reloaded]","codename":"NEO2","model":"NEO [Reloaded]"},{"manufacturer":"Nubia","market_name":"NX401","codename":"NX40X","model":"NX401"},{"manufacturer":"Nubia","market_name":"NX501","codename":"NX501","model":"NX501"},{"manufacturer":"Nubia","market_name":"NX503A","codename":"NX503A","model":"NX503A"},{"manufacturer":"Nuu","market_name":"A1","codename":"NUU_A1","model":"NUU_A1"},{"manufacturer":"Nuu","market_name":"A3","codename":"NUU_A3","model":"NUU_A3"},{"manufacturer":"Nuu","market_name":"A3L","codename":"NUU_A3L","model":"NUU_A3L"},{"manufacturer":"Nuu","market_name":"A4L","codename":"N5001L","model":"N5001L"},{"manufacturer":"Nuu","market_name":"M2","codename":"NUU_M2","model":"NUU_M2"},{"manufacturer":"Nuu","market_name":"M3","codename":"NUU_M3","model":"NUU_M3"},{"manufacturer":"Nuu","market_name":"N4L","codename":"N4L","model":"N4L"},{"manufacturer":"Nuu","market_name":"N5L","codename":"N5L","model":"N5L"},{"manufacturer":"Nuu","market_name":"NUU G3","codename":"N5702L","model":"N5702L"},{"manufacturer":"Nuu","market_name":"NUU M4X_PRO","codename":"S5701L","model":"S5701L"},{"manufacturer":"Nuu","market_name":"NUU_A2","codename":"S4001W","model":"S4001W"},{"manufacturer":"Nuu","market_name":"X4","codename":"X4","model":"X4"},{"manufacturer":"Nuu","market_name":"X5","codename":"NUU_X5","model":"NUU_X5"},{"manufacturer":"Nuu","market_name":"Z8","codename":"Z8","model":"Z8"},{"manufacturer":"Nuvision","market_name":"TM101A530L","codename":"TM101A530L","model":"TM101A530L"},{"manufacturer":"Nuvision","market_name":"TM101A540N","codename":"mid1008a-l","model":"TM101A540N"},{"manufacturer":"Nuvision","market_name":"TM101A730M","codename":"TM101AM","model":"TM101A730M"},{"manufacturer":"Nuvision","market_name":"TM106A510L","codename":"TM106A510L","model":"TM106A510L"},{"manufacturer":"Nuvision","market_name":"TM1088","codename":"fiber-wifibt","model":"CT1000"},{"manufacturer":"Nuvision","market_name":"TM1088","codename":"fiber-wifibt","model":"Endeavour101"},{"manufacturer":"Nuvision","market_name":"TM1088","codename":"fiber-wifibt","model":"TM1088"},{"manufacturer":"Nuvision","market_name":"TM1088","codename":"fiber-wifibt","model":"WEBPAD1002"},{"manufacturer":"Nuvision","market_name":"TM700A520L","codename":"TM700A","model":"TM700A520L"},{"manufacturer":"Nuvision","market_name":"TM785M3","codename":"TM785M3","model":"TM785M3"},{"manufacturer":"Nuvision","market_name":"TM800A510L","codename":"TM800A","model":"TM800A510L"},{"manufacturer":"Nuvision","market_name":"TM800A550L","codename":"TM800A550L","model":"TM800A550L"},{"manufacturer":"Nuvision","market_name":"TM800A730M","codename":"TM800AM","model":"TM800A730M"},{"manufacturer":"Nuvision","market_name":"TM800A740M","codename":"TM800AM","model":"TM800A740M"},{"manufacturer":"O\\'NICE","market_name":"O\\'NICE I-TOUCH M1","codename":"ONICE_I-TOUCH_M1","model":"i-touch M1"},{"manufacturer":"OASYS","market_name":"TEG9300","codename":"TEG9300","model":"TEG9300"},{"manufacturer":"ODYS","market_name":"GOAL_10_PLUS_3G","codename":"GOAL_10_PLUS_3G","model":"GOAL_10_PLUS_3G"},{"manufacturer":"ODYS","market_name":"MAVEN_X10_HD_LTE","codename":"MAVEN_X10_HD_LTE","model":"MAVEN_X10_HD_LTE"},{"manufacturer":"ODYS","market_name":"PACE 10","codename":"PACE10","model":"PACE10"},{"manufacturer":"ODYS","market_name":"XELIO_HD10","codename":"XELIO_HD10","model":"XELIO_HD10"},{"manufacturer":"ODYS","market_name":"\\xc2\\xa0FALCON_10_PLUS_3G","codename":"FALCON_10_PLUS_3G","model":"FALCON_10_PLUS_3G"},{"manufacturer":"OKWU","market_name":"PI Plus","codename":"PI_Plus","model":"PI Plus"},{"manufacturer":"OTHO","market_name":"T3","codename":"T3","model":"T3"},{"manufacturer":"OTOT","market_name":"E1","codename":"EOS","model":"OTOT_E1"},{"manufacturer":"OTOT","market_name":"S8","codename":"S8","model":"S8"},{"manufacturer":"OTOT","market_name":"V350","codename":"V350","model":"V350"},{"manufacturer":"OYYU","market_name":"T11","codename":"OYYUT11","model":"OYYUT11"},{"manufacturer":"Obi","market_name":"MV1","codename":"yam","model":"OBI MV1"},{"manufacturer":"Obi","market_name":"MV1","codename":"yam","model":"Obi MV1"},{"manufacturer":"Obi","market_name":"OBJ SJ1.5","codename":"SJ1-5","model":"SJ1-5"},{"manufacturer":"Oceusnetworks","market_name":"Xiphos\\xc2\\xaeTMD","codename":"granite","model":"Xiphos(R)TMD"},{"manufacturer":"Odys","market_name":"UNO X10","codename":"UNO_X10","model":"UNO X10"},{"manufacturer":"Odys","market_name":"UNO X8","codename":"UNO_X8","model":"UNO_X8"},{"manufacturer":"Oioo","market_name":"Model 2","codename":"wecct","model":"Model 2"},{"manufacturer":"Oioo","market_name":"Model 3","codename":"wecct3","model":"Model 3"},{"manufacturer":"Olive Oil","market_name":"CT4","codename":"octopus-ct4","model":"Octopus A83 CT4"},{"manufacturer":"Olive Oil","market_name":"OliveOil Model 3","codename":"wecct3","model":"CT3"},{"manufacturer":"Olivetti","market_name":"Graphos A10","codename":"Graphos_A10","model":"Graphos A10"},{"manufacturer":"Olivetti","market_name":"OP110","codename":"OP110","model":"OP110"},{"manufacturer":"Ollee","market_name":"T07TR1W","codename":"T07TR1W","model":"T07TR1W"},{"manufacturer":"Ollee","market_name":"XT080","codename":"XT080","model":"XT080"},{"manufacturer":"OnePlus","market_name":"2","codename":"OnePlus2","model":"ONE A2003"},{"manufacturer":"OnePlus","market_name":"3","codename":"OnePlus3","model":"ONEPLUS A3000"},{"manufacturer":"OnePlus","market_name":"One","codename":"A0001","model":"A0001"},{"manufacturer":"OnePlus","market_name":"One","codename":"A0001","model":"One"},{"manufacturer":"OnePlus","market_name":"OnePlus","codename":"OnePlus","model":"ONE E1003"},{"manufacturer":"OnePlus","market_name":"OnePlus 6","codename":"OnePlus6","model":"ONEPLUS A6003"},{"manufacturer":"OnePlus","market_name":"OnePlus2","codename":"OnePlus2","model":"ONE A2003"},{"manufacturer":"OnePlus","market_name":"OnePlus3","codename":"OnePlus3","model":"ONEPLUS A3000"},{"manufacturer":"OnePlus","market_name":"OnePlus3T","codename":"OnePlus3T","model":"ONEPLUS A3000"},{"manufacturer":"OnePlus","market_name":"OnePlus5","codename":"OnePlus5","model":"ONEPLUS A5000"},{"manufacturer":"OnePlus","market_name":"OnePlus5T","codename":"OnePlus5T","model":"ONEPLUS A5010"},{"manufacturer":"OnePlus","market_name":"X","codename":"OnePlus","model":"ONE E1003"},{"manufacturer":"Onkyo","market_name":"DP-CMX1","codename":"Gravity_128","model":"DP-CMX1"},{"manufacturer":"Onkyo","market_name":"DP-X1","codename":"Rai_Zin_32","model":"DP-X1"},{"manufacturer":"Onkyo","market_name":"DP-X1A","codename":"Rai_Zin2R_64","model":"DP-X1A"},{"manufacturer":"OpenPeak","market_name":"","codename":"CIUS-7","model":"CIUS-7"},{"manufacturer":"OpenPeak","market_name":"","codename":"CIUS-7-AT","model":"CIUS-7-AT"},{"manufacturer":"OpenPeak","market_name":"","codename":"cius","model":"cius"},{"manufacturer":"Ophone","market_name":"Active 5.0","codename":"Active_5_0","model":"Active 5.0"},{"manufacturer":"Oppo","market_name":"1100","codename":"1100","model":"1100"},{"manufacturer":"Oppo","market_name":"1105","codename":"1105","model":"1105"},{"manufacturer":"Oppo","market_name":"1107","codename":"1107","model":"1107"},{"manufacturer":"Oppo","market_name":"1201","codename":"1201","model":"1201"},{"manufacturer":"Oppo","market_name":"1206","codename":"1206","model":"1206"},{"manufacturer":"Oppo","market_name":"3000","codename":"3000","model":"3000"},{"manufacturer":"Oppo","market_name":"3001","codename":"Mirror3","model":"3001"},{"manufacturer":"Oppo","market_name":"3005","codename":"3005","model":"3005"},{"manufacturer":"Oppo","market_name":"3006","codename":"Mirror3","model":"3006"},{"manufacturer":"Oppo","market_name":"3007","codename":"3007","model":"3007"},{"manufacturer":"Oppo","market_name":"3008","codename":"3008","model":"3008"},{"manufacturer":"Oppo","market_name":"A11","codename":"A11","model":"A11"},{"manufacturer":"Oppo","market_name":"A11f","codename":"A11","model":"A11f"},{"manufacturer":"Oppo","market_name":"A11t","codename":"A11","model":"A11t"},{"manufacturer":"Oppo","market_name":"A11w","codename":"A11w","model":"A11w"},{"manufacturer":"Oppo","market_name":"A13t","codename":"A31t","model":"A31t"},{"manufacturer":"Oppo","market_name":"A1601","codename":"A1601","model":"A1601"},{"manufacturer":"Oppo","market_name":"A1601","codename":"A1601","model":"A1601fw"},{"manufacturer":"Oppo","market_name":"A1601fw","codename":"A1601","model":"A1601fw"},{"manufacturer":"Oppo","market_name":"A1603","codename":"A1603","model":"A1603"},{"manufacturer":"Oppo","market_name":"A31","codename":"A31t","model":"A31"},{"manufacturer":"Oppo","market_name":"A31c","codename":"A31c","model":"A31c"},{"manufacturer":"Oppo","market_name":"A31u","codename":"A31u","model":"A31u"},{"manufacturer":"Oppo","market_name":"A33","codename":"A33","model":"A33"},{"manufacturer":"Oppo","market_name":"A33f","codename":"A33","model":"A33f"},{"manufacturer":"Oppo","market_name":"A33f","codename":"A33","model":"A33fw"},{"manufacturer":"Oppo","market_name":"A33fw","codename":"A33","model":"A33fw"},{"manufacturer":"Oppo","market_name":"A33m","codename":"A33","model":"OPPO A33m"},{"manufacturer":"Oppo","market_name":"A33t","codename":"A33t","model":"A33t"},{"manufacturer":"Oppo","market_name":"A33w","codename":"A33w","model":"A33w"},{"manufacturer":"Oppo","market_name":"A35","codename":"A35","model":"OPPO A35"},{"manufacturer":"Oppo","market_name":"A37","codename":"A37","model":"OPPO A37"},{"manufacturer":"Oppo","market_name":"A37","codename":"A37","model":"OPPO A37m"},{"manufacturer":"Oppo","market_name":"A37f","codename":"A37f","model":"A37f"},{"manufacturer":"Oppo","market_name":"A37f","codename":"A37f","model":"A37fw"},{"manufacturer":"Oppo","market_name":"A37fw","codename":"A37f","model":"A37fw"},{"manufacturer":"Oppo","market_name":"A37fw","codename":"A37fs","model":"A37fw"},{"manufacturer":"Oppo","market_name":"A37fw-International","codename":"A37fs","model":"A37f"},{"manufacturer":"Oppo","market_name":"A37m","codename":"A37","model":"OPPO A37m"},{"manufacturer":"Oppo","market_name":"A37t","codename":"A37","model":"OPPO A37t"},{"manufacturer":"Oppo","market_name":"A37tm","codename":"A37","model":"OPPO A37tm"},{"manufacturer":"Oppo","market_name":"A39","codename":"A39","model":"OPPO A39"},{"manufacturer":"Oppo","market_name":"A39m","codename":"A39","model":"OPPO A39m"},{"manufacturer":"Oppo","market_name":"A39t","codename":"A39","model":"OPPO A39t"},{"manufacturer":"Oppo","market_name":"A39tm","codename":"A39","model":"OPPO A39tm"},{"manufacturer":"Oppo","market_name":"A51","codename":"A51","model":"A51"},{"manufacturer":"Oppo","market_name":"A51","codename":"A51","model":"Lava A51"},{"manufacturer":"Oppo","market_name":"A51f","codename":"A51","model":"A51f"},{"manufacturer":"Oppo","market_name":"A51fa","codename":"A51","model":"A51f"},{"manufacturer":"Oppo","market_name":"A51kc","codename":"A51kc","model":"A51kc"},{"manufacturer":"Oppo","market_name":"A51w","codename":"A51","model":"A51w"},{"manufacturer":"Oppo","market_name":"A53","codename":"A53","model":"OPPO A53"},{"manufacturer":"Oppo","market_name":"A53f","codename":"A53","model":"A53f"},{"manufacturer":"Oppo","market_name":"A53fw","codename":"A53","model":"A53fw"},{"manufacturer":"Oppo","market_name":"A53m","codename":"A53","model":"OPPO A53m"},{"manufacturer":"Oppo","market_name":"A53w","codename":"A53","model":"A53w"},{"manufacturer":"Oppo","market_name":"A57","codename":"A57","model":"OPPO A57"},{"manufacturer":"Oppo","market_name":"A57","codename":"A57","model":"OPPO A57t"},{"manufacturer":"Oppo","market_name":"A57t","codename":"A57","model":"OPPO A57t"},{"manufacturer":"Oppo","market_name":"A59","codename":"A59","model":"OPPO A59"},{"manufacturer":"Oppo","market_name":"A59","codename":"A59","model":"OPPO A59m"},{"manufacturer":"Oppo","market_name":"A59","codename":"A59","model":"OPPO A59s"},{"manufacturer":"Oppo","market_name":"A59m","codename":"A59","model":"OPPO A59m"},{"manufacturer":"Oppo","market_name":"A59st","codename":"A59","model":"OPPO A59st"},{"manufacturer":"Oppo","market_name":"A59t","codename":"A59","model":"OPPO A59t"},{"manufacturer":"Oppo","market_name":"A59tm","codename":"A59","model":"OPPO A59tm"},{"manufacturer":"Oppo","market_name":"A73","codename":"A73","model":"OPPO A73"},{"manufacturer":"Oppo","market_name":"A73","codename":"A79","model":"OPPO A73"},{"manufacturer":"Oppo","market_name":"A73t","codename":"A73t","model":"OPPO A73t"},{"manufacturer":"Oppo","market_name":"A73t","codename":"A79","model":"OPPO A73t"},{"manufacturer":"Oppo","market_name":"A77","codename":"A77","model":"OPPO A77"},{"manufacturer":"Oppo","market_name":"A77","codename":"A77","model":"OPPO A77t"},{"manufacturer":"Oppo","market_name":"A79","codename":"A79","model":"OPPO A79"},{"manufacturer":"Oppo","market_name":"A79k","codename":"A79k","model":"OPPO A79k"},{"manufacturer":"Oppo","market_name":"A79kt","codename":"A79kt","model":"OPPO A79kt"},{"manufacturer":"Oppo","market_name":"A79t","codename":"A79","model":"OPPO A79t"},{"manufacturer":"Oppo","market_name":"A79t","codename":"A79t","model":"OPPO A79t"},{"manufacturer":"Oppo","market_name":"A83","codename":"A83","model":"OPPO A83"},{"manufacturer":"Oppo","market_name":"A83t","codename":"A83t","model":"OPPO A83t"},{"manufacturer":"Oppo","market_name":"CHP1705","codename":"CPH1705","model":"CPH1705fw"},{"manufacturer":"Oppo","market_name":"CPH1605","codename":"CPH1605","model":"CPH1605"},{"manufacturer":"Oppo","market_name":"CPH1605","codename":"CPH1605","model":"OPPO CPH1605"},{"manufacturer":"Oppo","market_name":"CPH1605fw","codename":"CPH1605","model":"CPH1605fw"},{"manufacturer":"Oppo","market_name":"CPH1609","codename":"CPH1609","model":"CPH1609"},{"manufacturer":"Oppo","market_name":"CPH1609fw","codename":"CPH1609","model":"CPH1609fw"},{"manufacturer":"Oppo","market_name":"CPH1613","codename":"CPH1613","model":"CPH1613"},{"manufacturer":"Oppo","market_name":"CPH1613","codename":"CPH1613","model":"CPH1613fw"},{"manufacturer":"Oppo","market_name":"CPH1701","codename":"CPH1701","model":"CPH1701"},{"manufacturer":"Oppo","market_name":"CPH1701","codename":"CPH1701","model":"CPH1701fw"},{"manufacturer":"Oppo","market_name":"CPH1705","codename":"CPH1705","model":"CPH1705"},{"manufacturer":"Oppo","market_name":"CPH1707","codename":"CPH1707","model":"CPH1707"},{"manufacturer":"Oppo","market_name":"CPH1707","codename":"CPH1707","model":"CPH1707fw"},{"manufacturer":"Oppo","market_name":"CPH1715","codename":"CPH1715","model":"CPH1715"},{"manufacturer":"Oppo","market_name":"CPH1717","codename":"CPH1717","model":"CPH1717"},{"manufacturer":"Oppo","market_name":"CPH1719","codename":"CPH1719","model":"CPH1719"},{"manufacturer":"Oppo","market_name":"CPH1721","codename":"CPH1721","model":"CPH1721"},{"manufacturer":"Oppo","market_name":"CPH1723","codename":"CPH1723","model":"CPH1723"},{"manufacturer":"Oppo","market_name":"CPH1725","codename":"CPH1725","model":"CPH1725"},{"manufacturer":"Oppo","market_name":"CPH1727","codename":"CPH1727","model":"CPH1727"},{"manufacturer":"Oppo","market_name":"CPH1729","codename":"CPH1729","model":"CPH1729"},{"manufacturer":"Oppo","market_name":"CPH1801","codename":"CPH1801","model":"CPH1801"},{"manufacturer":"Oppo","market_name":"CPH1807","codename":"CPH1807","model":"CPH1807"},{"manufacturer":"Oppo","market_name":"CPH1819","codename":"CPH1819","model":"CPH1819"},{"manufacturer":"Oppo","market_name":"CPH1821","codename":"CPH1821","model":"CPH1821"},{"manufacturer":"Oppo","market_name":"CPH1827","codename":"CPH1827","model":"CPH1827"},{"manufacturer":"Oppo","market_name":"CPH1831","codename":"CPH1831","model":"CPH1831"},{"manufacturer":"Oppo","market_name":"CPH1835","codename":"CPH1835","model":"CPH1835"},{"manufacturer":"Oppo","market_name":"CPH1859","codename":"CPH1859","model":"CPH1859"},{"manufacturer":"Oppo","market_name":"CPH1861","codename":"CPH1861","model":"CPH1861"},{"manufacturer":"Oppo","market_name":"F1f","codename":"F1f","model":"F1f"},{"manufacturer":"Oppo","market_name":"F1f","codename":"F1f","model":"F1fw"},{"manufacturer":"Oppo","market_name":"F1f","codename":"F1f","model":"F1w"},{"manufacturer":"Oppo","market_name":"F1fw","codename":"F1f","model":"F1f"},{"manufacturer":"Oppo","market_name":"F1fw","codename":"F1f","model":"F1fw"},{"manufacturer":"Oppo","market_name":"F1w","codename":"F1f","model":"F1f"},{"manufacturer":"Oppo","market_name":"F1w","codename":"F1f","model":"F1w"},{"manufacturer":"Oppo","market_name":"Find 5","codename":"FIND5","model":"X909"},{"manufacturer":"Oppo","market_name":"Find5","codename":"FIND5","model":"X909"},{"manufacturer":"Oppo","market_name":"Find5","codename":"FIND5","model":"X909T"},{"manufacturer":"Oppo","market_name":"N1","codename":"N1","model":"N1"},{"manufacturer":"Oppo","market_name":"N1 mimi","codename":"N1mini","model":"N5111"},{"manufacturer":"Oppo","market_name":"N1 mimi","codename":"N1mini","model":"N5116"},{"manufacturer":"Oppo","market_name":"N1T","codename":"N1T","model":"N1T"},{"manufacturer":"Oppo","market_name":"N1W","codename":"N1W","model":"N1W"},{"manufacturer":"Oppo","market_name":"N3","codename":"N3","model":"N5206"},{"manufacturer":"Oppo","market_name":"N3","codename":"N3","model":"N5207"},{"manufacturer":"Oppo","market_name":"N3","codename":"N3","model":"N5209"},{"manufacturer":"Oppo","market_name":"N5110","codename":"N5110","model":"N5110"},{"manufacturer":"Oppo","market_name":"N5117","codename":"N5117","model":"N5117"},{"manufacturer":"Oppo","market_name":"PAAM00","codename":"PAAM00","model":"PAAM00"},{"manufacturer":"Oppo","market_name":"PAAT00","codename":"PAAT00","model":"PAAT00"},{"manufacturer":"Oppo","market_name":"PACM00","codename":"PACM00","model":"PACM00"},{"manufacturer":"Oppo","market_name":"PACT00","codename":"PACT00","model":"PACT00"},{"manufacturer":"Oppo","market_name":"PADM00","codename":"PADM00","model":"PADM00"},{"manufacturer":"Oppo","market_name":"PADT00","codename":"PADT00","model":"PADT00"},{"manufacturer":"Oppo","market_name":"R1001","codename":"OPPO72_13076","model":"R1001"},{"manufacturer":"Oppo","market_name":"R1001","codename":"R1001","model":"R1001"},{"manufacturer":"Oppo","market_name":"R1011","codename":"R1011","model":"R1011"},{"manufacturer":"Oppo","market_name":"R1011w","codename":"R1011","model":"R1011"},{"manufacturer":"Oppo","market_name":"R11","codename":"R11","model":"OPPO R11"},{"manufacturer":"Oppo","market_name":"R11","codename":"R11","model":"OPPO R11t"},{"manufacturer":"Oppo","market_name":"R11 Plus","codename":"R11Plus","model":"OPPO R11 Plus"},{"manufacturer":"Oppo","market_name":"R11 Plusk","codename":"R11Plusk","model":"OPPO R11 Plusk"},{"manufacturer":"Oppo","market_name":"R11 Pluskt","codename":"R11Plusk","model":"OPPO R11 Pluskt"},{"manufacturer":"Oppo","market_name":"R11 Plust","codename":"R11Plus","model":"OPPO R11 Plust"},{"manufacturer":"Oppo","market_name":"R11s","codename":"R11s","model":"OPPO R11s"},{"manufacturer":"Oppo","market_name":"R11sPlus","codename":"R11sPlus","model":"OPPO R11s Plus"},{"manufacturer":"Oppo","market_name":"R11sPlust","codename":"R11sPlus","model":"OPPO R11s Plust"},{"manufacturer":"Oppo","market_name":"R11st","codename":"R11s","model":"OPPO R11st"},{"manufacturer":"Oppo","market_name":"R2001","codename":"R2001","model":"R2001"},{"manufacturer":"Oppo","market_name":"R2010","codename":"R2010","model":"R2010"},{"manufacturer":"Oppo","market_name":"R2017","codename":"R2017","model":"R2017"},{"manufacturer":"Oppo","market_name":"R5","codename":"R5","model":"R8106"},{"manufacturer":"Oppo","market_name":"R5","codename":"R5","model":"R8107"},{"manufacturer":"Oppo","market_name":"R5","codename":"R5","model":"R8109"},{"manufacturer":"Oppo","market_name":"R6006","codename":"R3","model":"R6006"},{"manufacturer":"Oppo","market_name":"R6007","codename":"R6007","model":"R6007"},{"manufacturer":"Oppo","market_name":"R7","codename":"R7","model":"OPPO R7"},{"manufacturer":"Oppo","market_name":"R7","codename":"R7","model":"R7"},{"manufacturer":"Oppo","market_name":"R7 Lite","codename":"R7f","model":"R7kf"},{"manufacturer":"Oppo","market_name":"R7 Plus","codename":"R7Plus","model":"R7Plus"},{"manufacturer":"Oppo","market_name":"R7 Plusf","codename":"R7Plusm","model":"R7plusf"},{"manufacturer":"Oppo","market_name":"R7 Plusm","codename":"R7Plusm","model":"R7Plusm"},{"manufacturer":"Oppo","market_name":"R7005","codename":"R3","model":"R7005"},{"manufacturer":"Oppo","market_name":"R7007","codename":"R7007","model":"R7007"},{"manufacturer":"Oppo","market_name":"R7Plusf","codename":"R7Plusm","model":"R7plusf"},{"manufacturer":"Oppo","market_name":"R7Plust","codename":"R7Plus","model":"R7Plust"},{"manufacturer":"Oppo","market_name":"R7c","codename":"R7c","model":"R7c"},{"manufacturer":"Oppo","market_name":"R7f","codename":"R7f","model":"R7f"},{"manufacturer":"Oppo","market_name":"R7g","codename":"R7f","model":"R7g"},{"manufacturer":"Oppo","market_name":"R7kc","codename":"R7kc","model":"R7kc"},{"manufacturer":"Oppo","market_name":"R7kf","codename":"R7f","model":"R7kf"},{"manufacturer":"Oppo","market_name":"R7kt","codename":"R7","model":"R7kt"},{"manufacturer":"Oppo","market_name":"R7s","codename":"R7s","model":"OPPO R7s"},{"manufacturer":"Oppo","market_name":"R7s","codename":"R7s","model":"R7s"},{"manufacturer":"Oppo","market_name":"R7s Plus","codename":"R7sPlus","model":"OPPO R7sPlus"},{"manufacturer":"Oppo","market_name":"R7sf","codename":"R7sm","model":"R7sf"},{"manufacturer":"Oppo","market_name":"R7sfg","codename":"R7sf","model":"R7sf"},{"manufacturer":"Oppo","market_name":"R7sm","codename":"R7sm","model":"R7sm"},{"manufacturer":"Oppo","market_name":"R7st","codename":"R7s","model":"R7st"},{"manufacturer":"Oppo","market_name":"R7t","codename":"R7","model":"R7t"},{"manufacturer":"Oppo","market_name":"R8000","codename":"R1S","model":"R8000"},{"manufacturer":"Oppo","market_name":"R8001","codename":"R8001","model":"R8001"},{"manufacturer":"Oppo","market_name":"R8006","codename":"R8006","model":"R8006"},{"manufacturer":"Oppo","market_name":"R8007","codename":"R8007","model":"R8007"},{"manufacturer":"Oppo","market_name":"R809T","codename":"R809T","model":"R809T"},{"manufacturer":"Oppo","market_name":"R8106","codename":"R5","model":"R8106"},{"manufacturer":"Oppo","market_name":"R815","codename":"R815","model":"R815"},{"manufacturer":"Oppo","market_name":"R815T","codename":"R815T","model":"R815T"},{"manufacturer":"Oppo","market_name":"R815W","codename":"R815W","model":"R815W"},{"manufacturer":"Oppo","market_name":"R819","codename":"R819","model":"R819"},{"manufacturer":"Oppo","market_name":"R819T","codename":"R819T","model":"R819T"},{"manufacturer":"Oppo","market_name":"R820","codename":"R820","model":"R820"},{"manufacturer":"Oppo","market_name":"R8200","codename":"R1C","model":"R8200"},{"manufacturer":"Oppo","market_name":"R8201","codename":"R1x","model":"R8201"},{"manufacturer":"Oppo","market_name":"R8205","codename":"R1C","model":"R8205"},{"manufacturer":"Oppo","market_name":"R8206","codename":"R1x","model":"R8206"},{"manufacturer":"Oppo","market_name":"R8207","codename":"R1C","model":"R8207"},{"manufacturer":"Oppo","market_name":"R821","codename":"R821","model":"R821"},{"manufacturer":"Oppo","market_name":"R821T","codename":"R821T","model":"R821T"},{"manufacturer":"Oppo","market_name":"R823T","codename":"R823T","model":"R823T"},{"manufacturer":"Oppo","market_name":"R827","codename":"R827","model":"R827"},{"manufacturer":"Oppo","market_name":"R827T","codename":"R827T","model":"R827T"},{"manufacturer":"Oppo","market_name":"R829","codename":"R829","model":"R829"},{"manufacturer":"Oppo","market_name":"R829T","codename":"R829T","model":"R829T"},{"manufacturer":"Oppo","market_name":"R830","codename":"R830","model":"R830"},{"manufacturer":"Oppo","market_name":"R830S","codename":"R830S","model":"R830S"},{"manufacturer":"Oppo","market_name":"R831","codename":"R831","model":"R831"},{"manufacturer":"Oppo","market_name":"R831","codename":"R831T","model":"R831T"},{"manufacturer":"Oppo","market_name":"R831K","codename":"R831K","model":"R831K"},{"manufacturer":"Oppo","market_name":"R831L","codename":"R831L","model":"R831L"},{"manufacturer":"Oppo","market_name":"R831S","codename":"R831S","model":"R831S"},{"manufacturer":"Oppo","market_name":"R831T","codename":"R831T","model":"R831T"},{"manufacturer":"Oppo","market_name":"R833T","codename":"OPPO82_13067","model":"R833T"},{"manufacturer":"Oppo","market_name":"R850","codename":"R850","model":"R850"},{"manufacturer":"Oppo","market_name":"R9","codename":"R9","model":"OPPO R9"},{"manufacturer":"Oppo","market_name":"R9","codename":"R9","model":"OPPO R9km"},{"manufacturer":"Oppo","market_name":"R9","codename":"R9","model":"OPPO R9m"},{"manufacturer":"Oppo","market_name":"R9","codename":"R9","model":"OPPO R9tm"},{"manufacturer":"Oppo","market_name":"R9 Plus","codename":"R9PlusA","model":"OPPO R9 Plusm A"},{"manufacturer":"Oppo","market_name":"R9 Plus","codename":"R9PlusA","model":"OPPO R9 Plustm A"},{"manufacturer":"Oppo","market_name":"R9 Plus A","codename":"R9PlusA","model":"OPPO R9 Plus A"},{"manufacturer":"Oppo","market_name":"R9Plus","codename":"X9079","model":"X9079"},{"manufacturer":"Oppo","market_name":"R9PlusA","codename":"R9PlusA","model":"OPPO R9 Plusm A"},{"manufacturer":"Oppo","market_name":"R9PlusA","codename":"R9PlusA","model":"OPPO R9 Plustm A"},{"manufacturer":"Oppo","market_name":"R9PlusmA","codename":"R9PlusA","model":"OPPO R9 Plusm A"},{"manufacturer":"Oppo","market_name":"R9PlustA","codename":"R9PlusA","model":"OPPO R9 Plust A"},{"manufacturer":"Oppo","market_name":"R9PlustmA","codename":"R9PlusA","model":"OPPO R9 Plustm A"},{"manufacturer":"Oppo","market_name":"R9k","codename":"R9","model":"OPPO R9k"},{"manufacturer":"Oppo","market_name":"R9k","codename":"R9","model":"OPPO R9km"},{"manufacturer":"Oppo","market_name":"R9k","codename":"R9","model":"OPPO R9m"},{"manufacturer":"Oppo","market_name":"R9k","codename":"R9","model":"OPPO R9tm"},{"manufacturer":"Oppo","market_name":"R9km","codename":"R9","model":"OPPO R9km"},{"manufacturer":"Oppo","market_name":"R9m","codename":"R9","model":"OPPO R9m"},{"manufacturer":"Oppo","market_name":"R9s","codename":"CPH1607","model":"CPH1607"},{"manufacturer":"Oppo","market_name":"R9s","codename":"CPH1607","model":"CPH1607fw"},{"manufacturer":"Oppo","market_name":"R9s","codename":"R9s","model":"OPPO R9s"},{"manufacturer":"Oppo","market_name":"R9s Plus","codename":"CPH1611","model":"CPH1611"},{"manufacturer":"Oppo","market_name":"R9s Plus","codename":"R9sPlus","model":"OPPO R9s Plus"},{"manufacturer":"Oppo","market_name":"R9s Plus","codename":"R9sPlus","model":"OPPO R9s Plust"},{"manufacturer":"Oppo","market_name":"R9s Plus","codename":"R9sPlus","model":"OPPO R9sPlus"},{"manufacturer":"Oppo","market_name":"R9sk","codename":"R9sk","model":"OPPO R9sk"},{"manufacturer":"Oppo","market_name":"R9sk","codename":"R9sk","model":"OPPO R9skt"},{"manufacturer":"Oppo","market_name":"R9st","codename":"R9s","model":"OPPO R9st"},{"manufacturer":"Oppo","market_name":"R9t","codename":"R9","model":"OPPO R9t"},{"manufacturer":"Oppo","market_name":"R9tm","codename":"R9","model":"OPPO R9tm"},{"manufacturer":"Oppo","market_name":"U3","codename":"U3","model":"U3"},{"manufacturer":"Oppo","market_name":"U707","codename":"U707","model":"U707"},{"manufacturer":"Oppo","market_name":"U707T","codename":"U707T","model":"U707T"},{"manufacturer":"Oppo","market_name":"U708","codename":"U708","model":"U708"},{"manufacturer":"Oppo","market_name":"Ulike2","codename":"U705W","model":"U705W"},{"manufacturer":"Oppo","market_name":"Ulike2","codename":"Ulike2","model":"U705T"},{"manufacturer":"Oppo","market_name":"X9000","codename":"X9000","model":"X9000"},{"manufacturer":"Oppo","market_name":"X9006","codename":"X9006","model":"X9006"},{"manufacturer":"Oppo","market_name":"X9007","codename":"X9007","model":"X9007"},{"manufacturer":"Oppo","market_name":"X9009","codename":"X9009","model":"X9009"},{"manufacturer":"Oppo","market_name":"X9009fw","codename":"X9009","model":"X9009fw"},{"manufacturer":"Oppo","market_name":"X9070","codename":"X9070","model":"X9070"},{"manufacturer":"Oppo","market_name":"X9076","codename":"X9076","model":"X9076"},{"manufacturer":"Oppo","market_name":"X9077","codename":"FIND7","model":"X9077"},{"manufacturer":"Oppo","market_name":"X9077","codename":"X9077","model":"X9077"},{"manufacturer":"Oppo","market_name":"X9079","codename":"X9079","model":"X9079"},{"manufacturer":"Oppo","market_name":"X909","codename":"FIND5","model":"X909"},{"manufacturer":"Oppo","market_name":"X909","codename":"X909","model":"X909"},{"manufacturer":"Oppo","market_name":"X909","codename":"X909T","model":"X909T"},{"manufacturer":"Opticon","market_name":"H-27","codename":"H-27","model":"H-27"},{"manufacturer":"Oraimo","market_name":"R401","codename":"oraimo-R401","model":"oraimo R401"},{"manufacturer":"Oraimo","market_name":"R402","codename":"oraimo-R402","model":"oraimo R402"},{"manufacturer":"Oraimo","market_name":"oraimo R401S","codename":"oraimo-R401","model":"oraimo R401S"},{"manufacturer":"Orange","market_name":"Dive 30","codename":"P635E40","model":"Orange Dive 30"},{"manufacturer":"Orange","market_name":"Dive 30","codename":"P635E40","model":"ZTE Blade A410"},{"manufacturer":"Orange","market_name":"Dive 50","codename":"pixi3_45_4g_orange","model":"Orange Dive 50"},{"manufacturer":"Orange","market_name":"Dive 50 Dual","codename":"pixi3_45_4g_orange","model":"Dive 50 Dual"},{"manufacturer":"Orange","market_name":"Dive 71","codename":"Orange_Dive_71","model":"Orange Dive 71"},{"manufacturer":"Orange","market_name":"Dive72","codename":"mickey6","model":"Orange-Dive72"},{"manufacturer":"Orange","market_name":"Dive_70","codename":"Dive_70","model":"SCL-L01"},{"manufacturer":"Orange","market_name":"Five","codename":"OrangeFive","model":"OrangeFive"},{"manufacturer":"Orange","market_name":"Luno","codename":"Luno","model":"Luno"},{"manufacturer":"Orange","market_name":"NOS Roya","codename":"Alto45","model":"NOS Roya"},{"manufacturer":"Orange","market_name":"Neva 80","codename":"Orange_Neva_80","model":"Orange Neva 80"},{"manufacturer":"Orange","market_name":"Nura","codename":"M812","model":"Orange Nura"},{"manufacturer":"Orange","market_name":"Nura2","codename":"m823_orange","model":"Nura 2"},{"manufacturer":"Orange","market_name":"Orange Rise 33","codename":"Rise33","model":"Orange_Rise_33"},{"manufacturer":"Orange","market_name":"Orange Rise 53","codename":"Rise_53","model":"Orange Rise 53"},{"manufacturer":"Orange","market_name":"Rise 30","codename":"Pixi3-4","model":"Orange Rise 30"},{"manufacturer":"Orange","market_name":"Rise 40","codename":"ZTE_BLADE_A110","model":"Orange Rise 40"},{"manufacturer":"Orange","market_name":"Rise 50","codename":"Rise50","model":"Rise50"},{"manufacturer":"Orange","market_name":"Rise30","codename":"Pixi3-4","model":"Orange-Rise30"},{"manufacturer":"Orange","market_name":"Rise31","codename":"Pixi4-4","model":"Orange-Rise31"},{"manufacturer":"Orange","market_name":"Rise31","codename":"Pixi4-4","model":"Orange-Rise34"},{"manufacturer":"Orange","market_name":"Rise32","codename":"Orange-Rise32","model":"Orange Rise32"},{"manufacturer":"Orange","market_name":"Rise51","codename":"PIXI4_5_4G","model":"Orange-Rise51"},{"manufacturer":"Orange","market_name":"Rise51","codename":"PIXI4_5_4G","model":"Orange-Rise51B"},{"manufacturer":"Orange","market_name":"Rise52","codename":"BUZZ6T4G","model":"Orange-Rise52"},{"manufacturer":"Orange","market_name":"Roya","codename":"Alto45","model":"Orange Roya"},{"manufacturer":"Orange","market_name":"Sego","codename":"Orange_Sego","model":"Orange Sego"},{"manufacturer":"Orange","market_name":"Zilo","codename":"Orange_Zilo","model":"Zilo"},{"manufacturer":"Orange","market_name":"idol S","codename":"Diablo_LTE","model":"Orange Niva"},{"manufacturer":"Orbic","market_name":"R370H","codename":"R370H","model":"R370L"},{"manufacturer":"Orbic","market_name":"Wonder","codename":"RC555L","model":"RC555L"},{"manufacturer":"Oukitel","market_name":"C6 Pro","codename":"C6_Pro","model":"C6 Pro"},{"manufacturer":"Oukitel","market_name":"C8","codename":"C8","model":"C8"},{"manufacturer":"Oukitel","market_name":"C8 4G","codename":"C8_4G","model":"C8 4G"},{"manufacturer":"Oukitel","market_name":"C9","codename":"C9","model":"C9"},{"manufacturer":"Oukitel","market_name":"Coosea","codename":"K3","model":"K3"},{"manufacturer":"Oukitel","market_name":"K10","codename":"K10","model":"K10"},{"manufacturer":"Oukitel","market_name":"K10000 Mix","codename":"K10000_Mix","model":"K10000 Mix"},{"manufacturer":"Oukitel","market_name":"K10000 Pro","codename":"K10000_Pro","model":"K10000 Pro"},{"manufacturer":"Oukitel","market_name":"K10000_Max","codename":"K10000_Max","model":"K10000 Max"},{"manufacturer":"Oukitel","market_name":"K5000","codename":"K5000","model":"K5000"},{"manufacturer":"Oukitel","market_name":"K6","codename":"K6","model":"K6"},{"manufacturer":"Oukitel","market_name":"K6000 Plus","codename":"K6000_Plus","model":"K6000 Plus"},{"manufacturer":"Oukitel","market_name":"K8000","codename":"K8000","model":"K8000"},{"manufacturer":"Oukitel","market_name":"MIX 2","codename":"MIX_2","model":"MIX 2"},{"manufacturer":"Oukitel","market_name":"OK6000 PLUS","codename":"OK6000_Plus","model":"OK6000 Plus"},{"manufacturer":"Oukitel","market_name":"OKC8 4G","codename":"OKC8_4G","model":"OKC8 4G"},{"manufacturer":"Oukitel","market_name":"U11_Plus","codename":"U11_Plus","model":"U11_Plus"},{"manufacturer":"Oukitel","market_name":"U16 Max","codename":"U16_Max","model":"U16 Max"},{"manufacturer":"Oukitel","market_name":"U17","codename":"U17","model":"U17"},{"manufacturer":"Oukitel","market_name":"U18","codename":"U18","model":"U18"},{"manufacturer":"Oukitel","market_name":"U20_Plus","codename":"U20_Plus","model":"U20_Plus"},{"manufacturer":"Oukitel","market_name":"U22","codename":"U22","model":"U22"},{"manufacturer":"Oukitel","market_name":"U7 Max","codename":"U7_Max","model":"U7 Max"},{"manufacturer":"Oukitel","market_name":"U7 Plus","codename":"U7_Plus","model":"U7 Plus"},{"manufacturer":"Oukitel","market_name":"WP5000","codename":"WP5000","model":"WP5000"},{"manufacturer":"Overmax","market_name":"Livecore7032","codename":"Livecore7032","model":"Livecore7032"},{"manufacturer":"OwnMobile","market_name":"Entel PCS Telecomunicaciones S.A.","codename":"OWN_FUN_7","model":"OWN FUN 7"},{"manufacturer":"OwnMobile","market_name":"FUN VALUE 4G","codename":"FUNVALUE4G","model":"FUN VALUE 4G"},{"manufacturer":"OwnMobile","market_name":"OWN Smart \\xc3\\x962","codename":"SMART_O2","model":"SMART_O2"},{"manufacturer":"OwnMobile","market_name":"OWN_FUN_6","codename":"OWN_FUN_6","model":"OWN FUN 6"},{"manufacturer":"OwnMobile","market_name":"SMART 8","codename":"Smart8","model":"Smart8"},{"manufacturer":"OwnMobile","market_name":"Smart Plus Lte","codename":"SMART_PLUS_LTE","model":"SMART PLUS LTE"},{"manufacturer":"Oysters","market_name":"T72HM3G","codename":"T72HM3G","model":"T72HM3G"},{"manufacturer":"Oysters","market_name":"T72HMs 3G","codename":"T72HM3G","model":"T72HMs_3G"},{"manufacturer":"PC Smart","market_name":"PCSGOB10MVA-A","codename":"PCSGOB10MVA-A","model":"PCSGOB10MVA-A"},{"manufacturer":"PC Smart","market_name":"PCSGOB10SF-A","codename":"PCSGOB10SF-A","model":"PCSGOB10SF-A"},{"manufacturer":"PC Smart","market_name":"PTSGOB8","codename":"PTSGOB8","model":"PC_Smart_PTSGOB8"},{"manufacturer":"PCBOX","market_name":"Curi_Lite_PCB-T103","codename":"mid1008","model":"PCB-T103 CURI LITE"},{"manufacturer":"PCD Argentina","market_name":"610","codename":"610","model":"610"},{"manufacturer":"PCD Argentina","market_name":"PCD508","codename":"PCD508","model":"PCD508"},{"manufacturer":"PCD Argentina","market_name":"PCD509","codename":"PCD509","model":"PCD509"},{"manufacturer":"PCD Argentina","market_name":"PH5003","codename":"PH5003","model":"PH5003"},{"manufacturer":"PCD Argentina","market_name":"PL5003","codename":"PL5003","model":"PL5003"},{"manufacturer":"PLDT","market_name":"Smart Page 8 Pro","codename":"Smart_Page_8_Pro","model":"Smart_Page_8_Pro"},{"manufacturer":"POC","market_name":"POC2","codename":"CBL7509MM","model":"POC2"},{"manufacturer":"POPTEL","market_name":"P9000 MAX","codename":"P9000_MAX","model":"P9000_MAX"},{"manufacturer":"Packard Bell","market_name":"PB1009","codename":"PB1009","model":"PB1009"},{"manufacturer":"Packard Bell","market_name":"T1000","codename":"T1000","model":"T1000"},{"manufacturer":"Panasonic","market_name":"","codename":"H580VT_A","model":"JT-H580VT"},{"manufacturer":"Panasonic","market_name":"","codename":"H581VT_A","model":"JT-H581VT"},{"manufacturer":"Panasonic","market_name":"","codename":"P-08D","model":"P-08D"},{"manufacturer":"Panasonic","market_name":"","codename":"laputa","model":"P-07C"},{"manufacturer":"Panasonic","market_name":"003P","codename":"pana1","model":"003P"},{"manufacturer":"Panasonic","market_name":"101P","codename":"pana2_2s","model":"101P"},{"manufacturer":"Panasonic","market_name":"102P","codename":"pana2_4s","model":"102P"},{"manufacturer":"Panasonic","market_name":"43DX400C","codename":"DX01C","model":"DX01C"},{"manufacturer":"Panasonic","market_name":"48AX600C","codename":"mst918_4G","model":"48AX600C"},{"manufacturer":"Panasonic","market_name":"55AX600C","codename":"mst918_4k2k","model":"55AX600C"},{"manufacturer":"Panasonic","market_name":"55DX600C","codename":"DX600C","model":"TH-55DX600C"},{"manufacturer":"Panasonic","market_name":"AS650C","codename":"AS650C","model":"AS650C"},{"manufacturer":"Panasonic","market_name":"AX600C","codename":"AX600C","model":"AX600C"},{"manufacturer":"Panasonic","market_name":"Altus 18","codename":"Altus18","model":"Altus 18"},{"manufacturer":"Panasonic","market_name":"Altus 24","codename":"Altus24","model":"Altus 24"},{"manufacturer":"Panasonic","market_name":"Boukenkun-reciever","codename":"VW_RCBKK1","model":"VW_RCBKK1"},{"manufacturer":"Panasonic","market_name":"EB-4063-X","codename":"EB-4063-X","model":"EB-4063-X"},{"manufacturer":"Panasonic","market_name":"ELUGA","codename":"pana2_4o","model":"dL1"},{"manufacturer":"Panasonic","market_name":"ELUGA A","codename":"ELUGA_A","model":"Panasonic ELUGA A"},{"manufacturer":"Panasonic","market_name":"ELUGA A3","codename":"ELUGA_A3","model":"ELUGA_A3"},{"manufacturer":"Panasonic","market_name":"ELUGA A3 Pro","codename":"ELUGA_A3_Pro","model":"ELUGA_A3_Pro"},{"manufacturer":"Panasonic","market_name":"ELUGA A4","codename":"ELUGA_A4","model":"ELUGA A4"},{"manufacturer":"Panasonic","market_name":"ELUGA C","codename":"Panasonic_ELUGA_C","model":"Panasonic_ELUGA_C"},{"manufacturer":"Panasonic","market_name":"ELUGA I","codename":"ELUGA_I","model":"Panasonic ELUGA I"},{"manufacturer":"Panasonic","market_name":"ELUGA I2 Activ","codename":"ELUGA_I2_Activ","model":"ELUGA_I2_Activ"},{"manufacturer":"Panasonic","market_name":"ELUGA I3 Mega","codename":"Eluga_I3_Mega","model":"ELUGA I3 Mega"},{"manufacturer":"Panasonic","market_name":"ELUGA I4","codename":"ELUGA_I4","model":"ELUGA I4"},{"manufacturer":"Panasonic","market_name":"ELUGA I5","codename":"ELUGA_I5","model":"ELUGA_I5"},{"manufacturer":"Panasonic","market_name":"ELUGA I7","codename":"ELUGA_I7","model":"ELUGA I7"},{"manufacturer":"Panasonic","market_name":"ELUGA I9","codename":"ELUGA_I9","model":"Eluga I9"},{"manufacturer":"Panasonic","market_name":"ELUGA L 4G","codename":"ELUGA_L_4G","model":"Panasonic ELUGA L 4G"},{"manufacturer":"Panasonic","market_name":"ELUGA P","codename":"P-03E","model":"P-03E"},{"manufacturer":"Panasonic","market_name":"ELUGA PURE","codename":"ELUGA_Pure","model":"Panasonic_ELUGA_Pure"},{"manufacturer":"Panasonic","market_name":"ELUGA Power","codename":"P-07D","model":"P-07D"},{"manufacturer":"Panasonic","market_name":"ELUGA Prim","codename":"ELUGA_Prim","model":"ELUGA Prim"},{"manufacturer":"Panasonic","market_name":"ELUGA Ray 500","codename":"ELUGA_Ray_500","model":"ELUGA Ray 500"},{"manufacturer":"Panasonic","market_name":"ELUGA Ray 550","codename":"ELUGA_Ray_550","model":"ELUGA Ray 550"},{"manufacturer":"Panasonic","market_name":"ELUGA Ray 600","codename":"ELUGA_Ray_600","model":"ELUGA Ray 600"},{"manufacturer":"Panasonic","market_name":"ELUGA Ray 700","codename":"Eluga_Ray_700","model":"Eluga_Ray_700"},{"manufacturer":"Panasonic","market_name":"ELUGA S","codename":"ELUGA_S","model":"Panasonic ELUGA S"},{"manufacturer":"Panasonic","market_name":"ELUGA S Mini","codename":"ELUGA_S_Mini","model":"Panasonic ELUGA S Mini"},{"manufacturer":"Panasonic","market_name":"ELUGA Turbo","codename":"ELUGA_Turbo","model":"ELUGA Turbo"},{"manufacturer":"Panasonic","market_name":"ELUGA U","codename":"ELUGA_U","model":"Panasonic ELUGA U"},{"manufacturer":"Panasonic","market_name":"ELUGA U2","codename":"ELUGA_U2","model":"Panasonic ELUGA U2"},{"manufacturer":"Panasonic","market_name":"ELUGA V","codename":"P-06D","model":"P-06D"},{"manufacturer":"Panasonic","market_name":"ELUGA WE","codename":"ELUGA_WE","model":"Panasonic ELUGA WE"},{"manufacturer":"Panasonic","market_name":"ELUGA X","codename":"P-02E","model":"P-02E"},{"manufacturer":"Panasonic","market_name":"ELUGA dL1","codename":"pana2_4v","model":"Panasonic_dL1"},{"manufacturer":"Panasonic","market_name":"EX00C","codename":"EX00C","model":"EX00C"},{"manufacturer":"Panasonic","market_name":"EX01C","codename":"EX01C","model":"EX01C"},{"manufacturer":"Panasonic","market_name":"EX02C","codename":"EX02C","model":"EX02C"},{"manufacturer":"Panasonic","market_name":"Eco10 v3","codename":"ecov310","model":"Eco v3"},{"manufacturer":"Panasonic","market_name":"Eco10 v3 Plus","codename":"ecov3p10","model":"Eco v3 plus"},{"manufacturer":"Panasonic","market_name":"Eco11 v2","codename":"Eco11v2","model":"Eco11 v2"},{"manufacturer":"Panasonic","market_name":"Eco12 v3","codename":"ecov312","model":"Eco v3"},{"manufacturer":"Panasonic","market_name":"Eco12 v3 Plus","codename":"ecov3p12","model":"Eco v3 plus"},{"manufacturer":"Panasonic","market_name":"Eco9 v1","codename":"Eco","model":"Eco9 v1"},{"manufacturer":"Panasonic","market_name":"Eco9 v2","codename":"Ecov2","model":"Eco9 v2"},{"manufacturer":"Panasonic","market_name":"Elite 11","codename":"Elite11","model":"Elite"},{"manufacturer":"Panasonic","market_name":"Elite 11","codename":"Elite11","model":"Elite 11"},{"manufacturer":"Panasonic","market_name":"Elite 12","codename":"Elite12","model":"Elite"},{"manufacturer":"Panasonic","market_name":"Elite 12 v3","codename":"Elitev3_12","model":"Elitev3"},{"manufacturer":"Panasonic","market_name":"Elite 12 v3.1","codename":"elitev3a_cam","model":"Elite v3a with camera"},{"manufacturer":"Panasonic","market_name":"Elite 16","codename":"Elite16","model":"Elite"},{"manufacturer":"Panasonic","market_name":"Elite 16 v2","codename":"Elite16","model":"Elite"},{"manufacturer":"Panasonic","market_name":"Elite 18","codename":"Elite18","model":"Elite"},{"manufacturer":"Panasonic","market_name":"Elite13 v3","codename":"Elitev3_13","model":"Elitev3"},{"manufacturer":"Panasonic","market_name":"Elitev3a","codename":"elitev3a","model":"Elite v3a"},{"manufacturer":"Panasonic","market_name":"Eluga A2","codename":"Eluga_A2","model":"Eluga_A2"},{"manufacturer":"Panasonic","market_name":"Eluga Arc","codename":"ELUGA_Arc","model":"Panasonic ELUGA Arc"},{"manufacturer":"Panasonic","market_name":"Eluga Arc 2","codename":"Eluga_Arc_2","model":"Eluga_Arc_2"},{"manufacturer":"Panasonic","market_name":"Eluga I2","codename":"ELUGA_I2","model":"ELUGA_I2"},{"manufacturer":"Panasonic","market_name":"Eluga I3","codename":"Eluga_I3","model":"Panasonic_Eluga_I3"},{"manufacturer":"Panasonic","market_name":"Eluga Icon 2","codename":"ELUGA_Icon2","model":"Panasonic ELUGA Icon 2"},{"manufacturer":"Panasonic","market_name":"Eluga Klik","codename":"Eluga_Klik","model":"Eluga Klik"},{"manufacturer":"Panasonic","market_name":"Eluga Mark 2","codename":"Eluga_Mark_2","model":"Eluga_Mark_2"},{"manufacturer":"Panasonic","market_name":"Eluga Pulse","codename":"ELUGA_Pulse","model":"ELUGA_Pulse"},{"manufacturer":"Panasonic","market_name":"Eluga Pulse X","codename":"ELUGA_Pulse_X","model":"ELUGA_Pulse_X"},{"manufacturer":"Panasonic","market_name":"Eluga Ray","codename":"ELUGA_Ray","model":"ELUGA Ray"},{"manufacturer":"Panasonic","market_name":"Eluga Ray 530","codename":"ELUGA_Ray_530","model":"ELUGA Ray 530"},{"manufacturer":"Panasonic","market_name":"Eluga Ray 800","codename":"Eluga_Ray_800","model":"Eluga_Ray_800"},{"manufacturer":"Panasonic","market_name":"Eluga Ray Max","codename":"ELUGA_Ray_Max","model":"ELUGA Ray Max"},{"manufacturer":"Panasonic","market_name":"Eluga Ray X","codename":"ELUGA_Ray_X","model":"ELUGA Ray X"},{"manufacturer":"Panasonic","market_name":"Eluga Tapp","codename":"Eluga_TAPP","model":"Panasonic ELUGA Tapp"},{"manufacturer":"Panasonic","market_name":"Eluga Z","codename":"ELUGA_Z","model":"Panasonic ELUGA Z"},{"manufacturer":"Panasonic","market_name":"Eluga_Note","codename":"ELUGA_Note","model":"ELUGA Note"},{"manufacturer":"Panasonic","market_name":"FZ-A1","codename":"toughpad","model":"FZ-A1B"},{"manufacturer":"Panasonic","market_name":"FZ-A1B","codename":"toughpad","model":"FZ-A1B"},{"manufacturer":"Panasonic","market_name":"FZ-A2A","codename":"fz_a2a","model":"FZ-A2A"},{"manufacturer":"Panasonic","market_name":"FZ-B2","codename":"fz_b2bb","model":"FZ-B2B"},{"manufacturer":"Panasonic","market_name":"FZ-B2D","codename":"fz_b2d","model":"FZ-B2D"},{"manufacturer":"Panasonic","market_name":"FZ-N1","codename":"FZ-N1","model":"FZ-N1"},{"manufacturer":"Panasonic","market_name":"FZ-N1","codename":"FZ-N1CL","model":"FZ-N1"},{"manufacturer":"Panasonic","market_name":"FZ-N1","codename":"FZ-N1F","model":"FZ-N1"},{"manufacturer":"Panasonic","market_name":"FZ-N1","codename":"FZ-N1VU","model":"FZ-N1"},{"manufacturer":"Panasonic","market_name":"FZ-N1","codename":"FZ-N1VUC","model":"FZ-N1"},{"manufacturer":"Panasonic","market_name":"FZ-N1","codename":"FZ-N1VUCCL","model":"FZ-N1"},{"manufacturer":"Panasonic","market_name":"FZ-N1","codename":"FZ-N1VUCF","model":"FZ-N1"},{"manufacturer":"Panasonic","market_name":"FZ-N1","codename":"FZ-N1VUF","model":"FZ-N1"},{"manufacturer":"Panasonic","market_name":"FZ-N1F","codename":"FZ-N1F","model":"FZ-N1"},{"manufacturer":"Panasonic","market_name":"FZ-X1","codename":"FZ-X1","model":"FZ-X1"},{"manufacturer":"Panasonic","market_name":"FZ-X1","codename":"FZ-X1VU","model":"FZ-X1"},{"manufacturer":"Panasonic","market_name":"FZ-X1","codename":"FZ-X1VUC","model":"FZ-X1"},{"manufacturer":"Panasonic","market_name":"HDPSEB v2","codename":"HDPSEBv2","model":"HD PSEB v2"},{"manufacturer":"Panasonic","market_name":"IPSC 4","codename":"ipsc4","model":"IPSC4"},{"manufacturer":"Panasonic","market_name":"JT-B1","codename":"B1","model":"JT-B1"},{"manufacturer":"Panasonic","market_name":"KX-PRXA10","codename":"KX-PRXA10","model":"Panasonic KX-PRXA10"},{"manufacturer":"Panasonic","market_name":"KX-PRXA15","codename":"KX-PRXA15","model":"Panasonic KX-PRXA15"},{"manufacturer":"Panasonic","market_name":"LUMIX CM1","codename":"DMC-CM1","model":"DMC-CM1"},{"manufacturer":"Panasonic","market_name":"P-01D","codename":"pana2_1","model":"P-01D"},{"manufacturer":"Panasonic","market_name":"P-02D","codename":"pana2_2","model":"P-02D"},{"manufacturer":"Panasonic","market_name":"P-04D","codename":"pana2_4d","model":"P-04D"},{"manufacturer":"Panasonic","market_name":"P-05D","codename":"pana2_4a","model":"P-05D"},{"manufacturer":"Panasonic","market_name":"P-07C","codename":"pana1","model":"P-07C"},{"manufacturer":"Panasonic","market_name":"P11","codename":"P11","model":"Panasonic P11"},{"manufacturer":"Panasonic","market_name":"P31","codename":"P31","model":"Panasonic P31"},{"manufacturer":"Panasonic","market_name":"P41","codename":"P41","model":"Panasonic P41"},{"manufacturer":"Panasonic","market_name":"P41 HD","codename":"P41HD","model":"Panasonic P41HD"},{"manufacturer":"Panasonic","market_name":"P51","codename":"P51","model":"Panasonic P51"},{"manufacturer":"Panasonic","market_name":"P55","codename":"P55","model":"Panasonic P55"},{"manufacturer":"Panasonic","market_name":"P55 Max","codename":"P55_Max","model":"P55 Max"},{"manufacturer":"Panasonic","market_name":"P55 Novo","codename":"P55_Novo","model":"Panasonic P55 Novo"},{"manufacturer":"Panasonic","market_name":"P55 Novo","codename":"P55_Novo_4G","model":"P55 Novo 4G"},{"manufacturer":"Panasonic","market_name":"P61","codename":"P61","model":"Panasonic P61"},{"manufacturer":"Panasonic","market_name":"P61","codename":"P61","model":"Panasonic_P61"},{"manufacturer":"Panasonic","market_name":"P66","codename":"P66","model":"P66"},{"manufacturer":"Panasonic","market_name":"P71","codename":"P71","model":"P71"},{"manufacturer":"Panasonic","market_name":"P75","codename":"P75","model":"Panasonic P75"},{"manufacturer":"Panasonic","market_name":"P77","codename":"P77","model":"Panasonic P77"},{"manufacturer":"Panasonic","market_name":"P81","codename":"P81","model":"Panasonic P81"},{"manufacturer":"Panasonic","market_name":"P85","codename":"P85","model":"Panasonic P85"},{"manufacturer":"Panasonic","market_name":"P88","codename":"P88","model":"P88"},{"manufacturer":"Panasonic","market_name":"P9","codename":"P9","model":"P9"},{"manufacturer":"Panasonic","market_name":"P91","codename":"P91","model":"P91"},{"manufacturer":"Panasonic","market_name":"P99","codename":"Panasonic_P99","model":"Panasonic P99"},{"manufacturer":"Panasonic","market_name":"Panasonic P100","codename":"P100","model":"P100"},{"manufacturer":"Panasonic","market_name":"Panasonic P100","codename":"P100","model":"Panasonic P100"},{"manufacturer":"Panasonic","market_name":"Panasonic P101","codename":"P101","model":"P101"},{"manufacturer":"Panasonic","market_name":"Panasonic P55 NXT","codename":"P55Nxt","model":"Panasonic P55 NXT"},{"manufacturer":"Panasonic","market_name":"Panasonic P7","codename":"Panasonic_P7","model":"Panasonic P7"},{"manufacturer":"Panasonic","market_name":"Panasonic P85 NXT","codename":"P85Nxt","model":"Panasonic P85 NXT"},{"manufacturer":"Panasonic","market_name":"Panasonic P90","codename":"Panasonic_P90","model":"Panasonic P90"},{"manufacturer":"Panasonic","market_name":"Panasonic P90 3G","codename":"Panasonic_P90_3G","model":"Panasonic P90 3G"},{"manufacturer":"Panasonic","market_name":"Panasonic P95","codename":"P95","model":"Panasonic P95"},{"manufacturer":"Panasonic","market_name":"Panasonic T70","codename":"T70","model":"Panasonic T70"},{"manufacturer":"Panasonic","market_name":"SDU","codename":"SDU","model":"9 inch SDU"},{"manufacturer":"Panasonic","market_name":"SDU","codename":"SDU","model":"SDU"},{"manufacturer":"Panasonic","market_name":"SM17","codename":"SM17","model":"Smart Monitor 17"},{"manufacturer":"Panasonic","market_name":"SV-ME1000","codename":"K1","model":"Panasonic SV-ME1000"},{"manufacturer":"Panasonic","market_name":"SmartTVBox","codename":"C01AS","model":"SMARTTVBOX"},{"manufacturer":"Panasonic","market_name":"T11","codename":"T11","model":"Panasonic T11"},{"manufacturer":"Panasonic","market_name":"T21","codename":"T21","model":"Panasonic T21"},{"manufacturer":"Panasonic","market_name":"T30","codename":"T30","model":"Panasonic T30"},{"manufacturer":"Panasonic","market_name":"T31","codename":"T31","model":"Panasonic T31"},{"manufacturer":"Panasonic","market_name":"T33","codename":"T33","model":"Panasonic T33"},{"manufacturer":"Panasonic","market_name":"T40","codename":"T40","model":"Panasonic T40"},{"manufacturer":"Panasonic","market_name":"T41","codename":"T41","model":"Panasonic T41"},{"manufacturer":"Panasonic","market_name":"T44","codename":"T44","model":"Panasonic T44"},{"manufacturer":"Panasonic","market_name":"T44 Lite","codename":"T44-Lite","model":"Panasonic T44 Lite"},{"manufacturer":"Panasonic","market_name":"T9","codename":"T9","model":"Panasonic T9"},{"manufacturer":"Panasonic","market_name":"TAB-A01","codename":"TAB-A01","model":"TAB-A01-SD"},{"manufacturer":"Panasonic","market_name":"TAB-A02","codename":"TAB-A02","model":"TAB-A02-SD"},{"manufacturer":"Panasonic","market_name":"TH-49DX400C","codename":"DX00C","model":"DX00C"},{"manufacturer":"Panasonic","market_name":"TH-55DR600C","codename":"TH55DR600C","model":"TH55DR600C"},{"manufacturer":"Panasonic","market_name":"TH-55DX700C","codename":"TH_55DX700C","model":"TH_55DX700C"},{"manufacturer":"Panasonic","market_name":"TH-65DR800C","codename":"TH-65DR800C","model":"TH-65DR800C"},{"manufacturer":"Panasonic","market_name":"TH-65DX400C","codename":"TH_65DX400C","model":"TH_65DX400C"},{"manufacturer":"Panasonic","market_name":"Theater v3","codename":"theaterv3","model":"theaterv3"},{"manufacturer":"Panasonic","market_name":"Translation device","codename":"WA-P7","model":"WA-P7"},{"manufacturer":"Panasonic","market_name":"UN-MT300","codename":"A1","model":"Panasonic UN-MT300"},{"manufacturer":"Panasonic","market_name":"UN-W700","codename":"F1","model":"Panasonic UN-W700"},{"manufacturer":"Panasonic","market_name":"VHS v2","codename":"VHS","model":"Video Handset"},{"manufacturer":"Panasonic","market_name":"VTSH v1","codename":"VTSHv1","model":"VTSH v1"},{"manufacturer":"Panasonic","market_name":"WSCU","codename":"wscu","model":"WSCU3"},{"manufacturer":"Panasonic","market_name":"Yaris M","codename":"T31","model":"Panasonic T31"},{"manufacturer":"Panasonic","market_name":"fz_b2dh","codename":"fz_b2d","model":"FZ-B2D"},{"manufacturer":"Pantech","market_name":"ADR910L","codename":"ADR910L","model":"ADR910L"},{"manufacturer":"Pantech","market_name":"ADR930L","codename":"ADR930L","model":"ADR930L"},{"manufacturer":"Pantech","market_name":"AT1","codename":"at1","model":"IM-T100K"},{"manufacturer":"Pantech","market_name":"Apache","codename":"ADR8995","model":"ADR8995"},{"manufacturer":"Pantech","market_name":"Burst","codename":"presto","model":"PantechP9070"},{"manufacturer":"Pantech","market_name":"Crossover","codename":"moon","model":"PantechP8000"},{"manufacturer":"Pantech","market_name":"EF33S","codename":"ef33s","model":"IM-A760S"},{"manufacturer":"Pantech","market_name":"EF34K","codename":"ef34k","model":"IM-A770K"},{"manufacturer":"Pantech","market_name":"EF35L","codename":"ef35l","model":"IM-A780L"},{"manufacturer":"Pantech","market_name":"Element","codename":"pororo","model":"PantechP4100"},{"manufacturer":"Pantech","market_name":"Flex","codename":"oscar","model":"PantechP8010"},{"manufacturer":"Pantech","market_name":"IM-100GN","codename":"ef71g","model":"IM-100GN"},{"manufacturer":"Pantech","market_name":"IM-100K","codename":"ef71k","model":"IM-100K"},{"manufacturer":"Pantech","market_name":"IM-100S","codename":"ef71s","model":"IM-100S"},{"manufacturer":"Pantech","market_name":"IM-810K","codename":"ef40k","model":"IM-A810K"},{"manufacturer":"Pantech","market_name":"IM-840SP","codename":"IM-A840SP","model":"IM-A840SP"},{"manufacturer":"Pantech","market_name":"IM-A730S","codename":"ef30s","model":"IM-A730S"},{"manufacturer":"Pantech","market_name":"IM-A740S","codename":"ef31s","model":"IM-A740S"},{"manufacturer":"Pantech","market_name":"IM-A760S","codename":"ef33s","model":"IM-A760S"},{"manufacturer":"Pantech","market_name":"IM-A770K","codename":"ef34k","model":"IM-A770K"},{"manufacturer":"Pantech","market_name":"IM-A775C","codename":"ef34c","model":"IM-A775C"},{"manufacturer":"Pantech","market_name":"IM-A780L","codename":"ef35l","model":"IM-A780L"},{"manufacturer":"Pantech","market_name":"IM-A800S","codename":"ef39s","model":"IM-A800S"},{"manufacturer":"Pantech","market_name":"IM-A810K","codename":"ef40k","model":"IM-A810K"},{"manufacturer":"Pantech","market_name":"IM-A810S","codename":"ef40s","model":"IM-A810S"},{"manufacturer":"Pantech","market_name":"IM-A830K","codename":"ef45k","model":"IM-A830K"},{"manufacturer":"Pantech","market_name":"IM-A830KE","codename":"ef45kv","model":"IM-A830KE"},{"manufacturer":"Pantech","market_name":"IM-A830L","codename":"ef46l","model":"IM-A830L"},{"manufacturer":"Pantech","market_name":"IM-A830S","codename":"ef47s","model":"IM-A830S"},{"manufacturer":"Pantech","market_name":"IM-A840S","codename":"IM-A840S","model":"IM-A840S"},{"manufacturer":"Pantech","market_name":"IM-A850K","codename":"ef49k","model":"IM-A850K"},{"manufacturer":"Pantech","market_name":"IM-A850L","codename":"ef50l","model":"IM-A850L"},{"manufacturer":"Pantech","market_name":"IM-A850S","codename":"ef48s","model":"IM-A850S"},{"manufacturer":"Pantech","market_name":"IM-A860K","codename":"ef51k","model":"IM-A860K"},{"manufacturer":"Pantech","market_name":"IM-A860L","codename":"ef51l","model":"IM-A860L"},{"manufacturer":"Pantech","market_name":"IM-A860S","codename":"ef51s","model":"IM-A860S"},{"manufacturer":"Pantech","market_name":"IM-A870K","codename":"ef52k","model":"IM-A870K"},{"manufacturer":"Pantech","market_name":"IM-A870L","codename":"ef52l","model":"IM-A870L"},{"manufacturer":"Pantech","market_name":"IM-A870S","codename":"ef52s","model":"IM-A870S"},{"manufacturer":"Pantech","market_name":"IM-A880S","codename":"EF56S","model":"IM-A880S"},{"manufacturer":"Pantech","market_name":"IM-A910K","codename":"ef63k","model":"IM-A910K"},{"manufacturer":"Pantech","market_name":"IM-A910L","codename":"ef63l","model":"IM-A910L"},{"manufacturer":"Pantech","market_name":"IM-A910S","codename":"ef63s","model":"IM-A910S"},{"manufacturer":"Pantech","market_name":"IM-A920S","codename":"ef65s","model":"IM-A920S"},{"manufacturer":"Pantech","market_name":"IM-A940K","codename":"ef65dk","model":"IM-A940K"},{"manufacturer":"Pantech","market_name":"Izar","codename":"sp33k","model":"SKY IM-A630K"},{"manufacturer":"Pantech","market_name":"MIRACH_J","codename":"mirachj","model":"EIS01PT"},{"manufacturer":"Pantech","market_name":"MIRACH_J","codename":"mirachj","model":"IS11PT"},{"manufacturer":"Pantech","market_name":"Mirach","codename":"ef13l","model":"IM-A690L"},{"manufacturer":"Pantech","market_name":"Mirach","codename":"ef13s","model":"IM-A690S"},{"manufacturer":"Pantech","market_name":"Mirach A","codename":"ef32k","model":"IM-A750K"},{"manufacturer":"Pantech","market_name":"P9090","codename":"magnus","model":"PantechP9090"},{"manufacturer":"Pantech","market_name":"PLANET","codename":"mini","model":"PLANET"},{"manufacturer":"Pantech","market_name":"PTL21","codename":"maruko","model":"PTL21"},{"manufacturer":"Pantech","market_name":"Pocket","codename":"mini","model":"PantechP9060"},{"manufacturer":"Pantech","market_name":"SIRIUS \\xce\\xb1","codename":"jmasai","model":"IS06"},{"manufacturer":"Pantech","market_name":"Sirius","codename":"ef10s","model":"SKY IM-A600S"},{"manufacturer":"Pantech","market_name":"V955","codename":"HS8929QC","model":"Pantech V955"},{"manufacturer":"Pantech","market_name":"VEGA RACER","codename":"ef34k","model":"IM-A770K"},{"manufacturer":"Pantech","market_name":"VEGA RACER","codename":"ef35l","model":"IM-A780L"},{"manufacturer":"Pantech","market_name":"VEGA Secret Note","codename":"EF59K","model":"IM-A890K"},{"manufacturer":"Pantech","market_name":"VEGA Secret Note","codename":"EF59L","model":"IM-A890L"},{"manufacturer":"Pantech","market_name":"VEGA Secret Note","codename":"EF59S","model":"IM-A890S"},{"manufacturer":"Pantech","market_name":"VEGA Secret UP","codename":"EF60S","model":"IM-A900S"},{"manufacturer":"Pantech","market_name":"VEGA Secret UP","codename":"EF61K","model":"IM-A900K"},{"manufacturer":"Pantech","market_name":"VEGA Secret UP","codename":"EF62L","model":"IM-A900L"},{"manufacturer":"Pantech","market_name":"VEGA Secret UP","codename":"ef60s","model":"IM-A900S"},{"manufacturer":"Pantech","market_name":"VEGA Secret UP","codename":"ef61k","model":"IM-A900K"},{"manufacturer":"Pantech","market_name":"VEGA Secret UP","codename":"ef62l","model":"IM-A900L"},{"manufacturer":"Pantech","market_name":"Vega","codename":"ef12s","model":"SKY IM-A650S"},{"manufacturer":"Pantech","market_name":"Vega LTE M","codename":"ef65l","model":"IM-A820L"},{"manufacturer":"Pantech","market_name":"Vega X","codename":"ef14l","model":"IM-A720L"},{"manufacturer":"Pantech","market_name":"Vega X","codename":"ef18k","model":"IM-A710K"},{"manufacturer":"Pantech","market_name":"ef14lv","codename":"ef14lv","model":"IM-A725L"},{"manufacturer":"Pantech","market_name":"v950","codename":"HS8929QC","model":"Pantech V950"},{"manufacturer":"Pantech","market_name":"v955","codename":"HS8929QC","model":"Pantech V955"},{"manufacturer":"Partner","market_name":"Batman","codename":"Batman","model":"S70PCI"},{"manufacturer":"Partner","market_name":"OT-310","codename":"OT-310","model":"OT-310"},{"manufacturer":"Pavapro","market_name":"PavaPro7bk","codename":"Pavapro7bk","model":"Pavapro7bk"},{"manufacturer":"Pavapro","market_name":"Pavapro10","codename":"Pavapro10bk","model":"Pavapro10bk"},{"manufacturer":"Pegatron","market_name":"","codename":"Duke3G","model":"Android Tablet PC"},{"manufacturer":"Pegatron","market_name":"","codename":"DukeWifi","model":"Android Tablet PC"},{"manufacturer":"Pegatron","market_name":"","codename":"TabletPC","model":"Android Tablet PC"},{"manufacturer":"Pegatron","market_name":"MaxiIQ","codename":"MaxiIQ","model":"MaxiIQ"},{"manufacturer":"Pegatron","market_name":"Olipad","codename":"OP111","model":"chagall"},{"manufacturer":"Pegatron","market_name":"chagall","codename":"chagall","model":"Chagall 10.1 WiFi"},{"manufacturer":"Pegatron","market_name":"chagall","codename":"chagall","model":"E-Tab 4G"},{"manufacturer":"Pegatron","market_name":"chagall","codename":"chagall","model":"chagall"},{"manufacturer":"Pendo","market_name":"Pendo","codename":"PNDP70M7BLK","model":"PNDP70M7BLK"},{"manufacturer":"Performance","market_name":"PR7RKTNF","codename":"PR7RKTNF","model":"PR7RKTNF"},{"manufacturer":"Philco","market_name":"PTB7PAP_ PTB7PAB _ PTB7PAR","codename":"PTB7PA","model":"PTB7PAP_PTB7PAB_PTB7PAR"},{"manufacturer":"Philco","market_name":"TP10A3N","codename":"TP10A3N","model":"TP10A3N"},{"manufacturer":"Philco","market_name":"TP7A4BB","codename":"TP7A4BB","model":"TP7A4BB"},{"manufacturer":"Philco","market_name":"TP7A4N","codename":"TP7A4N","model":"TP7A4N"},{"manufacturer":"Philips","market_name":"","codename":"Philips_GGC3","model":"SA3CNT"},{"manufacturer":"Philips","market_name":"","codename":"Philips_PI5000","model":"Philips_PI5000"},{"manufacturer":"Philips","market_name":"","codename":"SA2CNTxx","model":"Philips GoGear Connect"},{"manufacturer":"Philips","market_name":"4K & Full HD Slim LED TV powered by Android\\xe2\\x84\\xa2","codename":"philips_MT5593FHT_EU","model":"QM152E"},{"manufacturer":"Philips","market_name":"4K & Full HD Slim LED TV powered by Android\\xe2\\x84\\xa2","codename":"philips_MT5593HT_LT","model":"QM152E"},{"manufacturer":"Philips","market_name":"4K LED TV powered by Android","codename":"PH7M_EU_5596","model":"TPM171E"},{"manufacturer":"Philips","market_name":"4K Razor Slim LED TV powered by Android TV\\xe2\\x84\\xa2","codename":"MT5593Uplus","model":"QM151E"},{"manufacturer":"Philips","market_name":"4K Razor Slim OLED TV powered by Android TV","codename":"QM16XE_UB","model":"QM161E"},{"manufacturer":"Philips","market_name":"4K UHD Razor Slim LED TV powered by Android\\xe2\\x84\\xa2","codename":"QV151E","model":"QV151E"},{"manufacturer":"Philips","market_name":"4K Ultra Slim LED TV powered by Android","codename":"QM16XE_U","model":"QM163E"},{"manufacturer":"Philips","market_name":"Android 2014","codename":"philipstv","model":"AND1E"},{"manufacturer":"Philips","market_name":"E1027","codename":"E1027","model":"E1027"},{"manufacturer":"Philips","market_name":"FHD Ultra Slim LED TV Powered by Android","codename":"QM16XE_F","model":"QM164E"},{"manufacturer":"Philips","market_name":"HMP8100/93","codename":"HMP8100_ATV_93","model":"HMP8100_ATV_93"},{"manufacturer":"Philips","market_name":"HMP8100/98","codename":"HMP8100_ATV","model":"HMP8100_ATV_INT"},{"manufacturer":"Philips","market_name":"PHILIPS","codename":"TLE722G","model":"TLE722G"},{"manufacturer":"Philips","market_name":"PHP-S221C4AFD","codename":"MMD_WW","model":"G3SMNTS22"},{"manufacturer":"Philips","market_name":"PHP-S231C4AFD","codename":"G3SMNTS23","model":"G3SMNTS23"},{"manufacturer":"Philips","market_name":"PI2000","codename":"PI2000","model":"PI2000"},{"manufacturer":"Philips","market_name":"PI2010","codename":"PI2010","model":"PI2010"},{"manufacturer":"Philips","market_name":"PI2011","codename":"PI2011","model":"PI2011"},{"manufacturer":"Philips","market_name":"PI3100/51","codename":"PI3100_51","model":"PI3100"},{"manufacturer":"Philips","market_name":"PI3100/58","codename":"PI3100_58","model":"PI3100"},{"manufacturer":"Philips","market_name":"PI3100/93","codename":"PI3100_93","model":"PI3100-93"},{"manufacturer":"Philips","market_name":"PI3100/98","codename":"PI3100_98","model":"PI3100"},{"manufacturer":"Philips","market_name":"PI3100Z3/93","codename":"PI3100Z3_93","model":"PI3100Z3_93"},{"manufacturer":"Philips","market_name":"PI3105","codename":"PI3105","model":"PI3105"},{"manufacturer":"Philips","market_name":"PI3106","codename":"PI3106","model":"PI3106"},{"manufacturer":"Philips","market_name":"PI3110","codename":"PI3110","model":"PI3110"},{"manufacturer":"Philips","market_name":"PI3205G","codename":"PI3205G_93","model":"PI3205G"},{"manufacturer":"Philips","market_name":"PI3210G","codename":"PI3210G","model":"PI3210G"},{"manufacturer":"Philips","market_name":"PI3900","codename":"T7p_Duo_93","model":"PI3900-93"},{"manufacturer":"Philips","market_name":"PI3900/51","codename":"PI3900_51","model":"PI3900"},{"manufacturer":"Philips","market_name":"PI3900/58","codename":"PI3900_58","model":"PI3900"},{"manufacturer":"Philips","market_name":"PI3900/98","codename":"PI3900_98","model":"PI3900"},{"manufacturer":"Philips","market_name":"PI3910","codename":"PI3910","model":"PI3910"},{"manufacturer":"Philips","market_name":"PI4010G","codename":"PI4010G","model":"PI4010G"},{"manufacturer":"Philips","market_name":"PI7100/93","codename":"PI7100_93","model":"PI7100_93"},{"manufacturer":"Philips","market_name":"Philips S257","codename":"S257","model":"Philips S257"},{"manufacturer":"Philips","market_name":"Philips S310X","codename":"Philips_S310X","model":"Philips S310X"},{"manufacturer":"Philips","market_name":"Philips S318","codename":"S318","model":"Philips S318"},{"manufacturer":"Philips","market_name":"Philips S329","codename":"Philips_S329","model":"Philips S329"},{"manufacturer":"Philips","market_name":"Philips S337","codename":"scx35_sp7731gea_hd","model":"Philips S337"},{"manufacturer":"Philips","market_name":"Philips S338","codename":"S338","model":"Philips S338"},{"manufacturer":"Philips","market_name":"Philips S359","codename":"S359","model":"Philips S359"},{"manufacturer":"Philips","market_name":"Philips S369","codename":"S369","model":"Philips S369"},{"manufacturer":"Philips","market_name":"Philips V787","codename":"Philips_Xenium_V787","model":"Philips Xenium V787"},{"manufacturer":"Philips","market_name":"Philips X596","codename":"X596","model":"Philips X596"},{"manufacturer":"Philips","market_name":"Philips X598","codename":"Philips_X598","model":"Philips X598"},{"manufacturer":"Philips","market_name":"Philips X818","codename":"X818_RU","model":"Philips X818"},{"manufacturer":"Philips","market_name":"Philps S398","codename":"Philips_S398","model":"Philips S398"},{"manufacturer":"Philips","market_name":"S221C3A","codename":"MMD_WW","model":"G2SMNT"},{"manufacturer":"Philips","market_name":"S308","codename":"Philips_S308","model":"Philips S308"},{"manufacturer":"Philips","market_name":"S309","codename":"Philips","model":"Philips S309"},{"manufacturer":"Philips","market_name":"S326","codename":"S326","model":"Philips_S326"},{"manufacturer":"Philips","market_name":"S327","codename":"S327","model":"Philips S327"},{"manufacturer":"Philips","market_name":"S337","codename":"S337_AG","model":"Philips S337"},{"manufacturer":"Philips","market_name":"S337","codename":"S337_BG","model":"Philips S337"},{"manufacturer":"Philips","market_name":"S337","codename":"scx35_sp7731gea_hd","model":"Philips S337"},{"manufacturer":"Philips","market_name":"S395","codename":"S395","model":"Philips S395"},{"manufacturer":"Philips","market_name":"T8 PI7000","codename":"Tablet_8","model":"PI7000"},{"manufacturer":"Philips","market_name":"TLE722G","codename":"TLE722G","model":"TLE722G"},{"manufacturer":"Philips","market_name":"TLE732","codename":"TLE732","model":"TLE732"},{"manufacturer":"Philips","market_name":"V377","codename":"Philips_V377","model":"Philips V377"},{"manufacturer":"Philips","market_name":"V387","codename":"V387","model":"Philips V387"},{"manufacturer":"Philips","market_name":"V526","codename":"Philips_V526","model":"Philips V526"},{"manufacturer":"Philips","market_name":"V787","codename":"Philips_Xenium_V787","model":"Philips Xenium V787"},{"manufacturer":"Philips","market_name":"W337","codename":"W337","model":"W337"},{"manufacturer":"Philips","market_name":"W3500","codename":"Philips_W3500","model":"Philips_W3500"},{"manufacturer":"Philips","market_name":"W3568","codename":"Philips_W3568","model":"Philips W3568"},{"manufacturer":"Philips","market_name":"W3620","codename":"W3620","model":"W3620"},{"manufacturer":"Philips","market_name":"W6500","codename":"Philips_W6500_A","model":"W6500"},{"manufacturer":"Philips","market_name":"W6610","codename":"Marathon","model":"Philips W6610"},{"manufacturer":"Philips","market_name":"W6620","codename":"W6620","model":"W6620"},{"manufacturer":"Philips","market_name":"W8510","codename":"Topaz","model":"Philips W8510"},{"manufacturer":"Philips","market_name":"W8555","codename":"Pride","model":"Philips W8555"},{"manufacturer":"Philips","market_name":"X586","codename":"Philips_X586","model":"Philips_X586"},{"manufacturer":"Philips","market_name":"X586","codename":"Philips_X586_NEW","model":"Philips_X586"},{"manufacturer":"Philips","market_name":"X588","codename":"X588_RU","model":"Philips X588"},{"manufacturer":"Philips","market_name":"X818","codename":"X818","model":"Philips X818"},{"manufacturer":"Philips","market_name":"X818","codename":"X818_EE","model":"Philips X818"},{"manufacturer":"Philips","market_name":"X818","codename":"X818_RU","model":"Philips X818"},{"manufacturer":"Philips","market_name":"Xenium S386","codename":"S386","model":"Philips S386"},{"manufacturer":"Philips","market_name":"Xenium V377","codename":"Philips_V377","model":"Philips V377"},{"manufacturer":"Phone Max","market_name":"Rocky 2","codename":"Rocky_2","model":"Rocky 2"},{"manufacturer":"Phone Max","market_name":"Rocky_1","codename":"Rocky_1","model":"Rocky_1"},{"manufacturer":"Pioneer","market_name":"AV Receiver","codename":"AVH_W4400NEX","model":"Jupiter"},{"manufacturer":"Pioneer","market_name":"B.PRO\\xe3\\x82\\xab\\xe3\\x83\\xbc\\xe3\\x83\\x8a\\xe3\\x83\\x93","codename":"AVIC_BX500","model":"jupiter"},{"manufacturer":"Pioneer","market_name":"B.PRO\\xe3\\x82\\xab\\xe3\\x83\\xbc\\xe3\\x83\\x8a\\xe3\\x83\\x93","codename":"AVIC_BZ500","model":"jupiter"},{"manufacturer":"Pioneer","market_name":"Car Navigation","codename":"AVIC_W6400NEX","model":"Jupiter"},{"manufacturer":"Pioneer","market_name":"Car Navigation","codename":"AVIC_W8400NEX","model":"Jupiter"},{"manufacturer":"Pioneer","market_name":"Car Navigation","codename":"AVIC_Z710DAB","model":"Jupiter"},{"manufacturer":"Pioneer","market_name":"Car Navigation","codename":"AVIC_Z910DAB","model":"Jupiter"},{"manufacturer":"Pioneer","market_name":"CyberNavi","codename":"AVIC_CE900","model":"jupiter"},{"manufacturer":"Pioneer","market_name":"CyberNavi","codename":"AVIC_CE901","model":"jupiter"},{"manufacturer":"Pioneer","market_name":"CyberNavi","codename":"AVIC_CL900","model":"jupiter"},{"manufacturer":"Pioneer","market_name":"CyberNavi","codename":"AVIC_CL901","model":"jupiter"},{"manufacturer":"Pioneer","market_name":"CyberNavi","codename":"AVIC_CZ700","model":"jupiter"},{"manufacturer":"Pioneer","market_name":"CyberNavi","codename":"AVIC_CZ900","model":"jupiter"},{"manufacturer":"Pioneer","market_name":"CyberNavi","codename":"AVIC_CZ901","model":"jupiter"},{"manufacturer":"Pioneer","market_name":"Navigation","codename":"NVF_0068ZY","model":"jupiter"},{"manufacturer":"Pioneer","market_name":"Navigation","codename":"NVF_0078ZY","model":"jupiter"},{"manufacturer":"Pioneer","market_name":"Navigation","codename":"NVF_0168ZY","model":"jupiter"},{"manufacturer":"Pioneer","market_name":"Navigation","codename":"NVF_0178ZY","model":"jupiter"},{"manufacturer":"Pioneer","market_name":"R1","codename":"RCK8726Y703H","model":"R1"},{"manufacturer":"Pioneer","market_name":"XDP-100R","codename":"Fu_Zin_32","model":"XDP-100R"},{"manufacturer":"Pioneer","market_name":"XDP-300R","codename":"Fu_Zin2R_32","model":"XDP-300R"},{"manufacturer":"Pixela","market_name":"KSTB5043","codename":"KSTB5043","model":"KSTB5043"},{"manufacturer":"Plaisio","market_name":"A2","codename":"Turbo-X_A2","model":"Turbo-X_A2"},{"manufacturer":"Plaisio","market_name":"Aqua","codename":"Aqua","model":"Aqua"},{"manufacturer":"Plaisio","market_name":"Calltab 7\\xe2\\x80\\x9d","codename":"Calltab7inch","model":"Calltab7inch"},{"manufacturer":"Plaisio","market_name":"\"Calltab2GB10.1\"\"\"","codename":"Calltab2GB10","model":"Calltab2GB10"},{"manufacturer":"Plaisio","market_name":"CalltabII 10.1","codename":"E1031H2C","model":"Calltab10.1"},{"manufacturer":"Plaisio","market_name":"Coral II","codename":"CoralII","model":"Turbo-X Coral II"},{"manufacturer":"Plaisio","market_name":"Earth","codename":"Earth","model":"Earth"},{"manufacturer":"Plaisio","market_name":"Earth 7.0\\' 3G","codename":"Earth3G","model":"Earth 7.0\\'3G"},{"manufacturer":"Plaisio","market_name":"Fire","codename":"Fire","model":"Fire"},{"manufacturer":"Plaisio","market_name":"G320","codename":"G320","model":"G320"},{"manufacturer":"Plaisio","market_name":"Hive V 3G","codename":"mg978","model":"Hive V 3G"},{"manufacturer":"Plaisio","market_name":"Hive V 3G","codename":"mr978","model":"Hive V 3G"},{"manufacturer":"Plaisio","market_name":"I4G","codename":"I4G","model":"TURBOX_I4G"},{"manufacturer":"Plaisio","market_name":"Lithium Ion","codename":"Turbo-X_e3","model":"Turbo-X_e3"},{"manufacturer":"Plaisio","market_name":"\"Rainbow II 3G 8\"\"\"","codename":"mr801","model":"RainbowII 3G"},{"manufacturer":"Plaisio","market_name":"RainbowIII3G","codename":"RainbowIII3G","model":"RainbowIII3G"},{"manufacturer":"Plaisio","market_name":"Rubik-II","codename":"RubikII7","model":"RubikII7"},{"manufacturer":"Plaisio","market_name":"\"Rubik10.1\"\"II\"","codename":"H1021H4C1_I","model":"Rubik 10.1 II"},{"manufacturer":"Plaisio","market_name":"\"RubikII 10\"\"\"","codename":"q102","model":"Rubik 10.1 II"},{"manufacturer":"Plaisio","market_name":"Rubik_10_III","codename":"Rubik_10_III","model":"Rubik_10_III"},{"manufacturer":"Plaisio","market_name":"Turbo-X Twister","codename":"Twister_IV_IPS","model":"QUAD-CORE A33 inet"},{"manufacturer":"Plaisio","market_name":"Turbo-X s2","codename":"s2","model":"s2"},{"manufacturer":"Plaisio","market_name":"Turbo-X_epsilon","codename":"Turbo-X_epsilon","model":"Turbo-X_epsilon"},{"manufacturer":"Plaisio","market_name":"Turbo-X_pi_4G","codename":"Turbo-X_pi_4G","model":"Turbo-X_pi_4G"},{"manufacturer":"Plaisio","market_name":"Turbo-X_z","codename":"Turbo-X_z","model":"Turbo-X_z"},{"manufacturer":"Plaisio","market_name":"Turbox_A3","codename":"Turbox_A3","model":"Turbox_A3"},{"manufacturer":"Plaisio","market_name":"Turbox_S3","codename":"Turbox_S3","model":"Turbox_S3"},{"manufacturer":"Plaisio","market_name":"lamda","codename":"Turbo-X_lamda","model":"Turbo-X lamda"},{"manufacturer":"Plus4","market_name":"Q-Touch","codename":"Q-Touch","model":"Q-Touch"},{"manufacturer":"Plusone","market_name":"FREETEL Priori3S","codename":"FTU152A","model":"FTU152A"},{"manufacturer":"Plusone","market_name":"FREETEL SAMURAI KIWAMI 2","codename":"SAMURAI_KIWAMI2","model":"FTJ162B"},{"manufacturer":"Plusone","market_name":"FREETEL Samurai Rei","codename":"FTJ161B","model":"FTJ161B"},{"manufacturer":"Plusone","market_name":"FTJ152C","codename":"FTJ152C","model":"FTJ152C"},{"manufacturer":"Plusone","market_name":"FTJ161A","codename":"FTJ161A","model":"FTJ161A"},{"manufacturer":"Plusone","market_name":"FTU152D","codename":"FTU152D","model":"FTU152D"},{"manufacturer":"Plusone","market_name":"Fun +","codename":"FTU161G","model":"FTU161G"},{"manufacturer":"Plusone","market_name":"Fun +","codename":"FTU161G","model":"Fun +"},{"manufacturer":"Plusone","market_name":"Ice 2","codename":"FTJ161E-VN","model":"FTJ161E-VN"},{"manufacturer":"Plusone","market_name":"Ice 2","codename":"ICE2","model":"FTE161E"},{"manufacturer":"Plusone","market_name":"Ice 2","codename":"ICE2","model":"ICE2"},{"manufacturer":"Plusone","market_name":"Kiwami","codename":"FTJ152D","model":"FTJ152D"},{"manufacturer":"Plusone","market_name":"Priori 3","codename":"FTJ152A","model":"FTJ152A"},{"manufacturer":"Plusone","market_name":"Priori3S","codename":"FTJ152B","model":"FTJ152B"},{"manufacturer":"Plusone","market_name":"Smart HD","codename":"Smart_HD","model":"Smart_HD"},{"manufacturer":"Pluzz","market_name":"PL4010","codename":"PL4010","model":"PLUZZ_PL4010"},{"manufacturer":"Pluzz","market_name":"PLUZZ_PL5010","codename":"PL5010","model":"PLUZZ_PL5010"},{"manufacturer":"Pluzz","market_name":"PLUZZ_PL5510","codename":"PLUZZ_PL5510","model":"PLUZZ_PL5510"},{"manufacturer":"PointMobile","market_name":"PM45","codename":"pm45","model":"PM45"},{"manufacturer":"PointMobile","market_name":"PM550","codename":"pm550","model":"PM550"},{"manufacturer":"PointMobile","market_name":"PM550R","codename":"pm550r","model":"PM550"},{"manufacturer":"PointMobile","market_name":"PM66","codename":"pm66","model":"PM66"},{"manufacturer":"PointMobile","market_name":"PM70","codename":"pm70","model":"PM70"},{"manufacturer":"PointMobile","market_name":"PM80","codename":"pm80","model":"PM80"},{"manufacturer":"Polar","market_name":"M600","codename":"pike","model":"Polar M600"},{"manufacturer":"Polaris","market_name":"Condroid_X7","codename":"polaris-Condroid_X7","model":"Condroid_X7"},{"manufacturer":"Polaroid","market_name":"A/S10","codename":"wing-AS10","model":"A/S10"},{"manufacturer":"Polaroid","market_name":"A/S7","codename":"wing-AS7","model":"A/S7"},{"manufacturer":"Polaroid","market_name":"A/S8","codename":"wing-AS8","model":"A/S8"},{"manufacturer":"Polaroid","market_name":"A6","codename":"A6","model":"A6"},{"manufacturer":"Polaroid","market_name":"A7X_PTAB735X","codename":"PTAB735X","model":"A7X_PTAB735X"},{"manufacturer":"Polaroid","market_name":"A7_PTAB735","codename":"A7_PTAB735","model":"HS-7DTB39"},{"manufacturer":"Polaroid","market_name":"A9x/PTAB935x","codename":"A9xPTAB935x","model":"A9x/PTAB935x"},{"manufacturer":"Polaroid","market_name":"Cosmo L","codename":"P5026A","model":"P5026A"},{"manufacturer":"Polaroid","market_name":"Cosmo P5s","codename":"P5046A","model":"P5046A"},{"manufacturer":"Polaroid","market_name":"Cosmo Z","codename":"P5047A","model":"P5047A"},{"manufacturer":"Polaroid","market_name":"Cosmo Z2","codename":"PSPCZ20A0","model":"PSPCZ20A0"},{"manufacturer":"Polaroid","market_name":"Infinite","codename":"MID1324","model":"MID 1324"},{"manufacturer":"Polaroid","market_name":"K7","codename":"PTAB782","model":"K7/PTAB782"},{"manufacturer":"Polaroid","market_name":"L9","codename":"L9","model":"L9"},{"manufacturer":"Polaroid","market_name":"MID1028","codename":"MID1028","model":"MID1028"},{"manufacturer":"Polaroid","market_name":"MID3810PVE02","codename":"MID3810PVE02","model":"MID3810PVE02"},{"manufacturer":"Polaroid","market_name":"MID4X07","codename":"RCT6773W22","model":"MID4X07"},{"manufacturer":"Polaroid","market_name":"MID4X10","codename":"RCT6203W46","model":"MID4X10"},{"manufacturer":"Polaroid","market_name":"MIDB1048PHE","codename":"MIDB1048PHE","model":"MIDB1048PHE"},{"manufacturer":"Polaroid","market_name":"MIDI109PDE","codename":"MIDI109PDE","model":"MIDI109PDE"},{"manufacturer":"Polaroid","market_name":"MIDI163PDE","codename":"MIDI163PDE","model":"MIDI163PDE"},{"manufacturer":"Polaroid","market_name":"MIDI70WPDE","codename":"MIDI70WPDE","model":"MIDI70WPDE"},{"manufacturer":"Polaroid","market_name":"P10/Q10/PTAB1040/PTAB1041","codename":"pq10-Polaroid","model":"P10/Q10/PTAB1040/PTAB1041"},{"manufacturer":"Polaroid","market_name":"P1000","codename":"P1000","model":"P1000"},{"manufacturer":"Polaroid","market_name":"P1001","codename":"P1001","model":"P1001"},{"manufacturer":"Polaroid","market_name":"P4526A","codename":"P4526A","model":"P4526A"},{"manufacturer":"Polaroid","market_name":"P5006A","codename":"P5006A","model":"P5006A"},{"manufacturer":"Polaroid","market_name":"P5526A","codename":"P5526A","model":"P5526A"},{"manufacturer":"Polaroid","market_name":"P7/Q7/PTAB740/PTAB741","codename":"pq7-Polaroid","model":"P7/Q7/PTAB740/PTAB741"},{"manufacturer":"Polaroid","market_name":"P791","codename":"P791","model":"P791"},{"manufacturer":"Polaroid","market_name":"P9/Q9/PTAB940/PTAB941","codename":"pq9-Polaroid","model":"P9/Q9/PTAB940/PTAB941"},{"manufacturer":"Polaroid","market_name":"P900","codename":"P900","model":"P900/Q900"},{"manufacturer":"Polaroid","market_name":"P901","codename":"P901","model":"P901"},{"manufacturer":"Polaroid","market_name":"PMID7102DC","codename":"PMID7102DC","model":"PMID7102DC"},{"manufacturer":"Polaroid","market_name":"PRO5023PW","codename":"up06_h25_polaroid","model":"PRO5023PW"},{"manufacturer":"Polaroid","market_name":"PRO5043","codename":"PRO5043","model":"PRO5043"},{"manufacturer":"Polaroid","market_name":"PRO5044PEE01","codename":"Polaroid_PRO5044PEE01","model":"PRO5044PEE01"},{"manufacturer":"Polaroid","market_name":"PRO5544PEE01","codename":"PRO5544PEE01","model":"PRO5544PEE01"},{"manufacturer":"Polaroid","market_name":"PRO5548PR010.191","codename":"PRO5548PR010","model":"PRO5548PR010"},{"manufacturer":"Polaroid","market_name":"PRO5584PHE01","codename":"PRO5584PHE01","model":"PRO5584PHE01"},{"manufacturer":"Polaroid","market_name":"PSPCK20NA","codename":"PSPCK20NA","model":"PSPCK20NA"},{"manufacturer":"Polaroid","market_name":"PSPCK21NA","codename":"PSPCK21NA","model":"PSPCK21NA"},{"manufacturer":"Polaroid","market_name":"PSPCL20A0","codename":"PSPCL20A0","model":"PSPCL20A0"},{"manufacturer":"Polaroid","market_name":"PTAB1051-PTAB1055","codename":"RCT6203W46","model":"PTAB1051_PTAB1055"},{"manufacturer":"Polaroid","market_name":"PTAB751","codename":"STJR76","model":"PTAB751"},{"manufacturer":"Polaroid","market_name":"Phantom 5","codename":"Phantom5","model":"PRO5023"},{"manufacturer":"Polaroid","market_name":"SIGMA 5","codename":"SIGMA-5","model":"SIGMA-5"},{"manufacturer":"Polaroid","market_name":"SOHO","codename":"SOHO","model":"SOHO"},{"manufacturer":"Polaroid","market_name":"V45M","codename":"V45M","model":"CARBON_PRO4543"},{"manufacturer":"Polaroid","market_name":"V7","codename":"nuclear-M7021","model":"V7"},{"manufacturer":"Polytron","market_name":"P500","codename":"P500","model":"P500"},{"manufacturer":"Polytron","market_name":"POLYTRON P552","codename":"POLYTRON_P552","model":"POLYTRON_P552"},{"manufacturer":"Polytron","market_name":"POLYTRON R2509","codename":"POLYTRON_R2509","model":"POLYTRON R2509"},{"manufacturer":"Polytron","market_name":"POLYTRON R2509SE","codename":"POLYTRON_R2509SE","model":"POLYTRON R2509SE"},{"manufacturer":"Polytron","market_name":"POLYTRON R250A","codename":"POLYTRON_R250A","model":"POLYTRON R250A"},{"manufacturer":"Porsche","market_name":"Rear  Seat  Entertainment","codename":"sdis1","model":"Porsche Rear Seat Entertainment"},{"manufacturer":"Porsche","market_name":"SDIS1","codename":"sdis1","model":"Porsche Rear Seat Entertainment"},{"manufacturer":"Positivo","market_name":"8MA-A","codename":"ochoMA_A_3G","model":"8MA-A 3G"},{"manufacturer":"Positivo","market_name":"AB10PGN","codename":"AB10PGN","model":"AB10PGN"},{"manufacturer":"Positivo","market_name":"AB7","codename":"YPY_AB7D","model":"YPY_AB7D"},{"manufacturer":"Positivo","market_name":"AB7D","codename":"YPY_AB7DC","model":"YPY_AB7DC"},{"manufacturer":"Positivo","market_name":"BGH 7Di-A","codename":"Y210","model":"Positivo BGH 7Di-A"},{"manufacturer":"Positivo","market_name":"BGH Y200","codename":"T710","model":"Positivo BGH Y200"},{"manufacturer":"Positivo","market_name":"BGH Y230","codename":"T760","model":"Y230"},{"manufacturer":"Positivo","market_name":"First","codename":"S410","model":"First"},{"manufacturer":"Positivo","market_name":"Life","codename":"S421","model":"S421 Positivo Life"},{"manufacturer":"Positivo","market_name":"Mini","codename":"mini","model":"Positivo Mini"},{"manufacturer":"Positivo","market_name":"Mini","codename":"mini","model":"Positivo Mini TE"},{"manufacturer":"Positivo","market_name":"Next","codename":"X500","model":"Positivo Next"},{"manufacturer":"Positivo","market_name":"OCTA","codename":"OCTA","model":"OCTA"},{"manufacturer":"Positivo","market_name":"One","codename":"S420","model":"Positivo One"},{"manufacturer":"Positivo","market_name":"One","codename":"S420","model":"S420"},{"manufacturer":"Positivo","market_name":"S380","codename":"S380","model":"S380"},{"manufacturer":"Positivo","market_name":"S430 Positivo Twist Mini","codename":"S430","model":"S430 Positivo Twist Mini"},{"manufacturer":"Positivo","market_name":"S440","codename":"S440","model":"S440"},{"manufacturer":"Positivo","market_name":"S450","codename":"S450","model":"S450"},{"manufacturer":"Positivo","market_name":"S480","codename":"S480","model":"S480"},{"manufacturer":"Positivo","market_name":"S550","codename":"S550","model":"S550"},{"manufacturer":"Positivo","market_name":"SX1000","codename":"SX1000","model":"Positivo SX1000"},{"manufacturer":"Positivo","market_name":"Selfie","codename":"S455","model":"S455"},{"manufacturer":"Positivo","market_name":"Slim","codename":"S510","model":"Positivo Slim"},{"manufacturer":"Positivo","market_name":"Stilo T725","codename":"T725","model":"Stilo T725"},{"manufacturer":"Positivo","market_name":"T1060","codename":"t1060","model":"T1060"},{"manufacturer":"Positivo","market_name":"T1060","codename":"t1060","model":"T1060B"},{"manufacturer":"Positivo","market_name":"T1060","codename":"t1060","model":"T1060C"},{"manufacturer":"Positivo","market_name":"T1075","codename":"T1075","model":"Positivo T1075"},{"manufacturer":"Positivo","market_name":"T701 TV","codename":"T701","model":"T701"},{"manufacturer":"Positivo","market_name":"T705","codename":"T705","model":"T705"},{"manufacturer":"Positivo","market_name":"T705","codename":"T705","model":"T705/T708"},{"manufacturer":"Positivo","market_name":"T705","codename":"T705","model":"T705K"},{"manufacturer":"Positivo","market_name":"T710","codename":"T710","model":"Positivo T710"},{"manufacturer":"Positivo","market_name":"T715","codename":"T715","model":"Stilo T715"},{"manufacturer":"Positivo","market_name":"T730","codename":"T730","model":"Positivo Stilo T730 Kids"},{"manufacturer":"Positivo","market_name":"T750","codename":"t750","model":"Positivo T750"},{"manufacturer":"Positivo","market_name":"Twist","codename":"S520","model":"Positivo Twist M"},{"manufacturer":"Positivo","market_name":"Twist","codename":"S520","model":"Positivo Twist S"},{"manufacturer":"Positivo","market_name":"Twist 2018","codename":"S511","model":"Twist (2018)"},{"manufacturer":"Positivo","market_name":"Twist 4G","codename":"S520_4G","model":"Positivo Twist 4G"},{"manufacturer":"Positivo","market_name":"Twist Max","codename":"S540","model":"Twist Max"},{"manufacturer":"Positivo","market_name":"Twist Metal","codename":"S530","model":"Twist Metal"},{"manufacturer":"Positivo","market_name":"Twist Mini","codename":"S430B","model":"Twist Mini"},{"manufacturer":"Positivo","market_name":"Twist Mini","codename":"S431","model":"Twist Mini"},{"manufacturer":"Positivo","market_name":"Twist XL","codename":"S555","model":"Twist XL"},{"manufacturer":"Positivo","market_name":"Union US2070","codename":"US2070","model":"Positivo US2070"},{"manufacturer":"Positivo","market_name":"X400","codename":"X400","model":"X400"},{"manufacturer":"Positivo","market_name":"YPY 10 3G","codename":"YPY_10FTA","model":"YPY_10FTA"},{"manufacturer":"Positivo","market_name":"YPY AB7","codename":"YPY_AB7","model":"Positivo Ypy AB7E"},{"manufacturer":"Positivo","market_name":"YPY AB7","codename":"YPY_AB7","model":"Positivo Ypy AB7EC"},{"manufacturer":"Positivo","market_name":"YPY S400","codename":"YPY_S400","model":"YPY_S400"},{"manufacturer":"Positivo","market_name":"YPY7 3G","codename":"TB07FTA","model":"Positivo Ypy 7 - TB07FTA"},{"manufacturer":"Positivo","market_name":"YPY7 3G","codename":"TB07FTA","model":"Ypy 7 - TB07FTA"},{"manufacturer":"Positivo","market_name":"YPY7 3G","codename":"YPY_07FTA","model":"YPY_07FTA"},{"manufacturer":"Positivo","market_name":"YPY7 wifi","codename":"TB07STA","model":"Positivo Ypy 7 - TB07STA"},{"manufacturer":"Positivo","market_name":"YPY7 wifi","codename":"TB07STA","model":"Ypy 7 - TB07STA"},{"manufacturer":"Positivo","market_name":"YPY7 wifi","codename":"YPY_07STA","model":"YPY_07STA"},{"manufacturer":"Positivo","market_name":"Ypy 07FTB","codename":"YPY_07FTB","model":"POSITIVO TABLET YPY 07FTB PM BEL\\xc3\\x89M"},{"manufacturer":"Positivo","market_name":"Ypy 07FTB","codename":"YPY_07FTB","model":"YPY_07FTB"},{"manufacturer":"Positivo","market_name":"Ypy 07FTBF","codename":"YPY_07FTBF","model":"YPY_07FTBF"},{"manufacturer":"Positivo","market_name":"Ypy 07STB","codename":"YPY_07STB","model":"YPY_07STB"},{"manufacturer":"Positivo","market_name":"Ypy 07STBF","codename":"YPY_07STBF","model":"YPY_07STBF"},{"manufacturer":"Positivo","market_name":"Ypy 10FTB","codename":"YPY_10FTB","model":"YPY_10FTB"},{"manufacturer":"Positivo","market_name":"Ypy 10FTBF","codename":"YPY_10FTBF","model":"YPY_10FTBF"},{"manufacturer":"Positivo","market_name":"Ypy 10STB","codename":"YPY_10STB","model":"YPY_10STB"},{"manufacturer":"Positivo","market_name":"Ypy 10STBF","codename":"YPY_10STBF","model":"YPY_10STBF"},{"manufacturer":"Positivo","market_name":"Ypy AB10","codename":"YPY_AB10D","model":"YPY_AB10D"},{"manufacturer":"Positivo","market_name":"Ypy AB10D","codename":"YPY_AB10DC","model":"YPY_AB10DC"},{"manufacturer":"Positivo","market_name":"Ypy AB10DP","codename":"YPY_AB10DP","model":"YPY_AB10DP"},{"manufacturer":"Positivo","market_name":"Ypy AB10E","codename":"YPY_AB10E","model":"Positivo Ypy AB10E"},{"manufacturer":"Positivo","market_name":"Ypy AB10E","codename":"YPY_AB10EC","model":"Positivo Ypy AB10EC"},{"manufacturer":"Positivo","market_name":"Ypy AB10H","codename":"YPY_AB10H","model":"Positivo Ypy AB10H"},{"manufacturer":"Positivo","market_name":"Ypy AB10i","codename":"Ypy_AB10i","model":"Ypy AB10i"},{"manufacturer":"Positivo","market_name":"Ypy AB7F","codename":"YPY_AB7F","model":"Positivo Ypy AB7F"},{"manufacturer":"Positivo","market_name":"Ypy AB7F","codename":"YPY_AB7F","model":"T720"},{"manufacturer":"Positivo","market_name":"Ypy AB7K","codename":"YPY_AB7K","model":"YPY_AB7K"},{"manufacturer":"Positivo","market_name":"Ypy Kids","codename":"YPY_L700","model":"Positivo Ypy L700 Kids"},{"manufacturer":"Positivo","market_name":"Ypy Kids","codename":"YPY_L700","model":"Positivo Ypy L700+ Kids"},{"manufacturer":"Positivo","market_name":"Ypy L1000","codename":"YPY_L1000","model":"Positivo Ypy L1000"},{"manufacturer":"Positivo","market_name":"Ypy L1000","codename":"YPY_L1000","model":"Positivo Ypy L1000F"},{"manufacturer":"Positivo","market_name":"Ypy L1050","codename":"YPY_L1050","model":"Positivo Ypy L1050"},{"manufacturer":"Positivo","market_name":"Ypy L1050","codename":"YPY_L1050","model":"Positivo Ypy L1050F"},{"manufacturer":"Positivo","market_name":"Ypy L1050E","codename":"YPY_L1050E","model":"Positivo Ypy L1050E"},{"manufacturer":"Positivo","market_name":"Ypy L700","codename":"YPY_L700","model":"Positivo Ypy L700"},{"manufacturer":"Positivo","market_name":"Ypy L700","codename":"YPY_L700","model":"Positivo Ypy L700 Ed. Especial"},{"manufacturer":"Positivo","market_name":"Ypy L700","codename":"YPY_L700","model":"Positivo Ypy L700+"},{"manufacturer":"Positivo","market_name":"Ypy Mini","codename":"mini","model":"Positivo BGH Mini"},{"manufacturer":"Positivo","market_name":"Ypy S350","codename":"YPY_S350","model":"YPY_S350"},{"manufacturer":"Positivo","market_name":"Ypy S350p","codename":"YPY_S350","model":"YPY_S350_PLUS"},{"manufacturer":"Positivo","market_name":"Ypy S405","codename":"YPY_S405","model":"YPY_S405"},{"manufacturer":"Positivo","market_name":"Ypy S450","codename":"YPY_S450","model":"YPY_S450"},{"manufacturer":"Positivo","market_name":"Ypy S460","codename":"YPY_S460","model":"YPY_S460"},{"manufacturer":"Positivo","market_name":"Ypy S500","codename":"YPY_S500","model":"YPY_S500"},{"manufacturer":"Positivo","market_name":"Ypy TQ7","codename":"YPY_TQ7","model":"YPY_TQ7"},{"manufacturer":"Positivo","market_name":"mini I","codename":"mini_i","model":"Positivo BGH Y300"},{"manufacturer":"Positivo","market_name":"mini I","codename":"mini_i","model":"Positivo Mini I"},{"manufacturer":"Positivo","market_name":"quattro","codename":"X435","model":"quattro"},{"manufacturer":"Positivo BGH","market_name":"BGH Y100","codename":"Y700","model":"Positivo BGH Y100"},{"manufacturer":"Positivo BGH","market_name":"BGH Y210","codename":"Y210","model":"Positivo BGH 7Di-A"},{"manufacturer":"Positivo BGH","market_name":"BGH Y210","codename":"Y210","model":"Positivo BGH Y210"},{"manufacturer":"Positivo BGH","market_name":"BGH Y400","codename":"Y400","model":"Y400"},{"manufacturer":"Positivo BGH","market_name":"BGH Y700","codename":"Y700","model":"Positivo BGH Y700"},{"manufacturer":"Positivo BGH","market_name":"BGH Y710 kids","codename":"Y700","model":"Positivo BGH Y710 KIDS"},{"manufacturer":"Positivo BGH","market_name":"M840","codename":"M840","model":"Positivo BGH M840"},{"manufacturer":"Positivo BGH","market_name":"Positivo BGH +Simple","codename":"C805","model":"Positivo BGH +Simple"},{"manufacturer":"Positivo BGH","market_name":"W750","codename":"W750","model":"Positivo BGH W750"},{"manufacturer":"Positivo BGH","market_name":"Y1000","codename":"Y1000","model":"Y1000"},{"manufacturer":"Positivo BGH","market_name":"Y1010","codename":"Y1010","model":"Positivo BGH Y1010"},{"manufacturer":"Positivo BGH","market_name":"Ypy","codename":"T701_AR","model":"L701 TV"},{"manufacturer":"Positivo BGH","market_name":"Ypy","codename":"YPY_L700","model":"Positivo BGH Ypy L700"},{"manufacturer":"Positivo BGH","market_name":"Ypy Kids","codename":"YPY_L700","model":"Positivo BGH Ypy L700 Kids"},{"manufacturer":"Premio","market_name":"P520","codename":"P520","model":"P520"},{"manufacturer":"Premio","market_name":"P530","codename":"P530","model":"P530"},{"manufacturer":"Premio","market_name":"P540","codename":"P540","model":"P540"},{"manufacturer":"Premio","market_name":"PREMIO P450","codename":"P450","model":"P450"},{"manufacturer":"Premio","market_name":"Premio P610","codename":"Premio_P610","model":"P610"},{"manufacturer":"Premio","market_name":"Premio P620","codename":"Premio_P620","model":"P620"},{"manufacturer":"Prestige","market_name":"7G","codename":"Prestige-7G","model":"Prestige 7G"},{"manufacturer":"Prestige","market_name":"ELITE10Q","codename":"Elite10Q","model":"Elite10Q"},{"manufacturer":"Prestige","market_name":"ELITE7Q","codename":"Elite7Q","model":"Elite7Q"},{"manufacturer":"Prestige","market_name":"ELITE8Q","codename":"ELITE8Q","model":"ELITE8Q"},{"manufacturer":"Prestige","market_name":"ELITE8QS","codename":"Elite8QS","model":"Elite8QS"},{"manufacturer":"Prestige","market_name":"ELITE9Q","codename":"ELITE9Q","model":"ELITE9Q"},{"manufacturer":"Prestige","market_name":"PRO10D","codename":"PRO10D","model":"PRO10D"},{"manufacturer":"Prestige","market_name":"PRO7DS","codename":"PRO7DS","model":"PRO7DS"},{"manufacturer":"Prestige","market_name":"PRO8D","codename":"PRO8D","model":"PRO8D"},{"manufacturer":"Prestige","market_name":"PRO9D","codename":"PRO9D","model":"PRO9D"},{"manufacturer":"Prestigio","market_name":"GRACE P5","codename":"HT50B2G","model":"PSP5515DUO"},{"manufacturer":"Prestigio","market_name":"GV7790","codename":"GV7790","model":"GV7790"},{"manufacturer":"Prestigio","market_name":"Grace","codename":"PSP7557","model":"PSP7557"},{"manufacturer":"Prestigio","market_name":"Grace 3118 3G","codename":"JU80A2G","model":"PMT3118_3G"},{"manufacturer":"Prestigio","market_name":"Grace X3","codename":"PSP3455DUO","model":"PSP3455DUO"},{"manufacturer":"Prestigio","market_name":"Grace X5","codename":"PSP5470DUO","model":"PSP5470DUO"},{"manufacturer":"Prestigio","market_name":"Grace X7","codename":"PSP7505DUO","model":"PSP7505DUO"},{"manufacturer":"Prestigio","market_name":"MT3237_3G","codename":"JP70A1W","model":"PMT3237_3G"},{"manufacturer":"Prestigio","market_name":"MULTIPAD WIZE 3027","codename":"HF80A01W","model":"PMT3027_Wi"},{"manufacturer":"Prestigio","market_name":"MULTIPAD WIZE 3108 3G","codename":"PN80A03G","model":"PMT3108_3G"},{"manufacturer":"Prestigio","market_name":"MULTIPAD WIZE 3111","codename":"NS70A03W","model":"PMT3111_Wi"},{"manufacturer":"Prestigio","market_name":"MULTIPAD WIZE 3121","codename":"NS70A03W","model":"PMT3121_Wi"},{"manufacturer":"Prestigio","market_name":"MULTIPAD WIZE 3308 3G","codename":"PN80A03G","model":"PMT3308_3G"},{"manufacturer":"Prestigio","market_name":"MULTIPAD WIZE 3331 3G","codename":"PN10A01G","model":"PMT3331_3G"},{"manufacturer":"Prestigio","market_name":"MULTIPAD WIZE 3341 3G","codename":"PN10A01G","model":"PMT3341_3G"},{"manufacturer":"Prestigio","market_name":"MULTIPAD WIZE 3787 3G","codename":"PMT3777_3G","model":"PMT3787_3G"},{"manufacturer":"Prestigio","market_name":"MultiPad Thunder 7.0i","codename":"g01p","model":"PMT3377_Wi"},{"manufacturer":"Prestigio","market_name":"MultiPad Wize 3009","codename":"PMT3009_Wi_C","model":"PMT3009_Wi_C"},{"manufacturer":"Prestigio","market_name":"MultiPad Wize 3017","codename":"PMT3017_WI","model":"PMT3017_WI"},{"manufacturer":"Prestigio","market_name":"MultiPad Wize 3018","codename":"PMT3018_WI","model":"PMT3018_WI"},{"manufacturer":"Prestigio","market_name":"MultiPad Wize 3037 3G","codename":"PMT3038_3G","model":"PMT3037_3G"},{"manufacturer":"Prestigio","market_name":"MultiPad Wize 3038 3G","codename":"PMT3038_3G","model":"PMT3038_3G"},{"manufacturer":"Prestigio","market_name":"MultiPhone 5453 DUO","codename":"PSP5453DUO","model":"PSP5453DUO"},{"manufacturer":"Prestigio","market_name":"MultiPhone 5455 DUO","codename":"PSP5455DUO","model":"PSP5455DUO"},{"manufacturer":"Prestigio","market_name":"MultiPhone 5504 DUO","codename":"PSP5504DUO","model":"PSP5504DUO"},{"manufacturer":"Prestigio","market_name":"MultiPhone 5505 DUO","codename":"PSP5505DUO","model":"PSP5505DUO"},{"manufacturer":"Prestigio","market_name":"MultiPhone 5517 DUO","codename":"PSP5517DUO","model":"PSP5517DUO"},{"manufacturer":"Prestigio","market_name":"Multipad Wize 3407 4G","codename":"WT70A1L","model":"PMT3407_4G"},{"manufacturer":"Prestigio","market_name":"Multipad Wize 3408 4G","codename":"LS80A1L","model":"PMT3408_4G"},{"manufacturer":"Prestigio","market_name":"Multipad Wize 3508 4G","codename":"LS80A1L","model":"PMT3508_4G"},{"manufacturer":"Prestigio","market_name":"Multipad Wize 3757 3G","codename":"PMT3777_3G","model":"PMT3757_3G"},{"manufacturer":"Prestigio","market_name":"Multiphone 5508 DUO","codename":"PSP5508DUO","model":"PSP5508DUO"},{"manufacturer":"Prestigio","market_name":"Muze A3","codename":"PSP3452DUO","model":"PSP3452DUO"},{"manufacturer":"Prestigio","market_name":"PGPS7795","codename":"PMT3057_3G","model":"PGPS7795"},{"manufacturer":"Prestigio","market_name":"PMT3008_Wi","codename":"PMT3008_Wi_C","model":"PMT3008_Wi_C"},{"manufacturer":"Prestigio","market_name":"PMT3011_3G","codename":"PMT3011_3G","model":"PMT3011_3G"},{"manufacturer":"Prestigio","market_name":"PMT3021_3G","codename":"PMT3011_3G","model":"PMT3021_3G"},{"manufacturer":"Prestigio","market_name":"PMT3031_3G","codename":"PMT3011_3G","model":"PMT3031_3G"},{"manufacturer":"Prestigio","market_name":"PMT3047_3G","codename":"PMT3047_3G","model":"PMT3047_3G"},{"manufacturer":"Prestigio","market_name":"PMT3057_3G","codename":"PMT3057_3G","model":"PMT3057_3G"},{"manufacturer":"Prestigio","market_name":"PMT3067_3G","codename":"PMT3057_3G","model":"PMT3067_3G"},{"manufacturer":"Prestigio","market_name":"PMT3077_Wi","codename":"HF80A01W","model":"PMT3077_Wi"},{"manufacturer":"Prestigio","market_name":"PMT3087_3G","codename":"PMT3057_3G","model":"PMT3087_3G"},{"manufacturer":"Prestigio","market_name":"PMT3101_4G","codename":"CF10A1L","model":"PMT3101_4G"},{"manufacturer":"Prestigio","market_name":"PMT3137_3G","codename":"JP70A1W","model":"PMT3137_3G"},{"manufacturer":"Prestigio","market_name":"PMT3157_3G","codename":"LS70A5G","model":"PMT3157_3G"},{"manufacturer":"Prestigio","market_name":"PMT3157_4G","codename":"LS70A6L","model":"PMT3157_4G"},{"manufacturer":"Prestigio","market_name":"PMT3177_3G","codename":"PMT3177_3G","model":"PMT3177_3G"},{"manufacturer":"Prestigio","market_name":"PMT3201_4G","codename":"CF10A1L","model":"PMT3201_4G"},{"manufacturer":"Prestigio","market_name":"PMT3208_3G","codename":"PN80A03G","model":"PMT3208_3G"},{"manufacturer":"Prestigio","market_name":"PMT3257_4G","codename":"LS70A6L","model":"PMT3257_4G"},{"manufacturer":"Prestigio","market_name":"PMT3277_3G","codename":"PMT3277_3G","model":"PMT3277_3G"},{"manufacturer":"Prestigio","market_name":"PMT3287_3G","codename":"PMT3287_3G","model":"PMT3287_3G"},{"manufacturer":"Prestigio","market_name":"PMT3301_4G","codename":"CF10A1L","model":"PMT3301_4G"},{"manufacturer":"Prestigio","market_name":"PMT3351_3G","codename":"PN10A01G","model":"PMT3351_3G"},{"manufacturer":"Prestigio","market_name":"PMT3418_4G","codename":"LS80A4L","model":"PMT3418_4G"},{"manufacturer":"Prestigio","market_name":"PMT3437_3G","codename":"JP70A1W","model":"PMT3437_3G"},{"manufacturer":"Prestigio","market_name":"PMT3507_4G","codename":"WT70A1L","model":"PMT3507_4G"},{"manufacturer":"Prestigio","market_name":"PMT3607_4G","codename":"WT70A1L","model":"PMT3607_4G"},{"manufacturer":"Prestigio","market_name":"PMT3608_4G","codename":"LS80A1L","model":"PMT3608_4G"},{"manufacturer":"Prestigio","market_name":"PMT3677_Wi","codename":"PMT3677","model":"PMT3677_Wi"},{"manufacturer":"Prestigio","market_name":"PMT3718_3G","codename":"CF80A2G","model":"PMT3718_3G"},{"manufacturer":"Prestigio","market_name":"PMT3767_3G","codename":"PMT3777_3G","model":"PMT3767_3G"},{"manufacturer":"Prestigio","market_name":"PMT3777_3G","codename":"PMT3777_3G","model":"PMT3777_3G"},{"manufacturer":"Prestigio","market_name":"PMT3797_3G","codename":"JU70A1G","model":"PMT3797_3G"},{"manufacturer":"Prestigio","market_name":"PMT5001_3G","codename":"PMT5001_3G","model":"PMT5001_3G"},{"manufacturer":"Prestigio","market_name":"PMT5002_Wi","codename":"PMT5002_Wi","model":"PMT5002_Wi"},{"manufacturer":"Prestigio","market_name":"PMT5008_3G","codename":"PMT5008_3G","model":"PMT5008_3G"},{"manufacturer":"Prestigio","market_name":"PMT5011_3G","codename":"PMT5001_3G","model":"PMT5011_3G"},{"manufacturer":"Prestigio","market_name":"PMT5018_3G","codename":"PMT5008_3G","model":"PMT5018_3G"},{"manufacturer":"Prestigio","market_name":"PMT5021_3G","codename":"PMT5001_3G","model":"PMT5021_3G"},{"manufacturer":"Prestigio","market_name":"PMT5287_4G","codename":"PMT5287_4G","model":"PMT5287_4G"},{"manufacturer":"Prestigio","market_name":"PMT5487_3G","codename":"PMT5487_3G","model":"PMT5487_3G"},{"manufacturer":"Prestigio","market_name":"PMT5587_Wi","codename":"AML8726-MXS","model":"PMT5587_Wi"},{"manufacturer":"Prestigio","market_name":"PMT5777_3G","codename":"PMT5777_3G","model":"PMT5777_3G"},{"manufacturer":"Prestigio","market_name":"PMT5877C","codename":"PMT5877C","model":"PMT5877C"},{"manufacturer":"Prestigio","market_name":"PMT5887_3G","codename":"PMT5887_3G","model":"PMT5887_3G"},{"manufacturer":"Prestigio","market_name":"PMT7008_4G","codename":"PMT7008_4G","model":"PMT7008_4G"},{"manufacturer":"Prestigio","market_name":"PMT7077_3G","codename":"PMT7077_3G","model":"PMT7077_3G"},{"manufacturer":"Prestigio","market_name":"PMT7177_3G","codename":"PMT7177_3G","model":"PMT7177_3G"},{"manufacturer":"Prestigio","market_name":"PMT7287C3G","codename":"PMT7287C3G","model":"PMT7287C3G"},{"manufacturer":"Prestigio","market_name":"PMT7287_3G","codename":"PMT7287_3G","model":"PMT7287_3G"},{"manufacturer":"Prestigio","market_name":"PMT7787_3G","codename":"PMT7787_3G","model":"PMT7787_3G"},{"manufacturer":"Prestigio","market_name":"PSP3403DUO","codename":"GF40B1G","model":"PSP3403DUO"},{"manufacturer":"Prestigio","market_name":"PSP3404DUO","codename":"PSP3404DUO","model":"PSP3404DUO"},{"manufacturer":"Prestigio","market_name":"PSP3405DUO","codename":"PSP3405DUO","model":"PSP3405DUO"},{"manufacturer":"Prestigio","market_name":"PSP3413DUO","codename":"GF40B1G","model":"PSP3413DUO"},{"manufacturer":"Prestigio","market_name":"PSP3423DUO","codename":"GF40B1G","model":"PSP3423DUO"},{"manufacturer":"Prestigio","market_name":"PSP3450DUO","codename":"PSP3450DUO","model":"PSP3450DUO"},{"manufacturer":"Prestigio","market_name":"PSP3456DUO","codename":"PSP3456DUO","model":"PSP3456DUO"},{"manufacturer":"Prestigio","market_name":"PSP3457DUO","codename":"KT45B01G","model":"PSP3457DUO"},{"manufacturer":"Prestigio","market_name":"PSP3458DUO","codename":"TE45B3G","model":"PSP3458DUO"},{"manufacturer":"Prestigio","market_name":"PSP3459DUO","codename":"TE45B3G","model":"PSP3459DUO"},{"manufacturer":"Prestigio","market_name":"PSP3468DUO","codename":"TE45B7G","model":"PSP3468DUO"},{"manufacturer":"Prestigio","market_name":"PSP3470DUO","codename":"TL47B1G","model":"PSP3470DUO"},{"manufacturer":"Prestigio","market_name":"PSP3471DUO","codename":"TL47B1G","model":"PSP3471DUO"},{"manufacturer":"Prestigio","market_name":"PSP3502DUO","codename":"PSP3502DUO","model":"PSP3502DUO"},{"manufacturer":"Prestigio","market_name":"PSP3503DUO","codename":"PSP3503DUO","model":"PSP3503DUO"},{"manufacturer":"Prestigio","market_name":"PSP3504DUO","codename":"PSP3504DUO","model":"PSP3504DUO"},{"manufacturer":"Prestigio","market_name":"PSP3505DUO","codename":"PSP3503DUO","model":"PSP3505DUO"},{"manufacturer":"Prestigio","market_name":"PSP3506DUO","codename":"TE50B2G","model":"PSP3506DUO"},{"manufacturer":"Prestigio","market_name":"PSP3507DUO","codename":"TE50B2G","model":"PSP3507DUO"},{"manufacturer":"Prestigio","market_name":"PSP3508DUO","codename":"TE50B4G","model":"PSP3508DUO"},{"manufacturer":"Prestigio","market_name":"PSP3510DUO","codename":"DTE50B8L","model":"PSP3510DUO"},{"manufacturer":"Prestigio","market_name":"PSP3511DUO","codename":"DTE50B8L","model":"PSP3511DUO"},{"manufacturer":"Prestigio","market_name":"PSP3512","codename":"DTE50B8L","model":"PSP3512DUO"},{"manufacturer":"Prestigio","market_name":"PSP3516DUO","codename":"TE50B2G","model":"PSP3516DUO"},{"manufacturer":"Prestigio","market_name":"PSP3517DUO","codename":"TE50B2G","model":"PSP3517DUO"},{"manufacturer":"Prestigio","market_name":"PSP3518DUO","codename":"TE50B4G","model":"PSP3518DUO"},{"manufacturer":"Prestigio","market_name":"PSP3527DUO","codename":"TE50B6G","model":"PSP3527DUO"},{"manufacturer":"Prestigio","market_name":"PSP3528DUO","codename":"IM50B1G","model":"PSP3528DUO"},{"manufacturer":"Prestigio","market_name":"PSP3530DUO","codename":"DW53B01G","model":"PSP3530DUO"},{"manufacturer":"Prestigio","market_name":"PSP3531DUO","codename":"DW53B01G","model":"PSP3531DUO"},{"manufacturer":"Prestigio","market_name":"PSP3533DUO","codename":"DW53B6G","model":"PSP3533DUO"},{"manufacturer":"Prestigio","market_name":"PSP3537DUO","codename":"GF50B2G","model":"PSP3537DUO"},{"manufacturer":"Prestigio","market_name":"PSP3551","codename":"DTE50B8L","model":"PSP3551DUO"},{"manufacturer":"Prestigio","market_name":"PSP3552DUO","codename":"TE55B9G","model":"PSP3552DUO"},{"manufacturer":"Prestigio","market_name":"PSP5047DUO","codename":"MT6589","model":"PSP5047DUO"},{"manufacturer":"Prestigio","market_name":"PSP5307DUO","codename":"PSP5307DUO","model":"PSP5307DUO"},{"manufacturer":"Prestigio","market_name":"PSP5454DUO","codename":"PSP5454DUO","model":"PSP5454DUO"},{"manufacturer":"Prestigio","market_name":"PSP5457DUO","codename":"MT6572","model":"PSP5457DUO"},{"manufacturer":"Prestigio","market_name":"PSP5502DUO","codename":"TE50B3G","model":"PSP5502DUO"},{"manufacturer":"Prestigio","market_name":"PSP5506DUO","codename":"DW50A03G","model":"PSP5506DUO"},{"manufacturer":"Prestigio","market_name":"PSP5507DUO","codename":"PSP5507DUO","model":"PSP5507DUO"},{"manufacturer":"Prestigio","market_name":"PSP5509DUO","codename":"TE50B4L","model":"PSP5509DUO"},{"manufacturer":"Prestigio","market_name":"PSP5510DUO","codename":"EB50B2G","model":"PSP5510DUO"},{"manufacturer":"Prestigio","market_name":"PSP5511DUO","codename":"IN50B1L","model":"PSP5511DUO"},{"manufacturer":"Prestigio","market_name":"PSP5512DUO","codename":"TE50B3G","model":"PSP5512DUO"},{"manufacturer":"Prestigio","market_name":"PSP5514DUO","codename":"EB50B2G","model":"PSP5514DUO"},{"manufacturer":"Prestigio","market_name":"PSP5516DUO","codename":"DW50A03G","model":"PSP5516DUO"},{"manufacturer":"Prestigio","market_name":"PSP5519DUO","codename":"TE50B4L","model":"PSP5519DUO"},{"manufacturer":"Prestigio","market_name":"PSP5520DUO","codename":"TE52B10G","model":"PSP5520DUO"},{"manufacturer":"Prestigio","market_name":"PSP5521DUO","codename":"TE52B10G","model":"PSP5521DUO"},{"manufacturer":"Prestigio","market_name":"PSP5530DUO","codename":"DW53B4G","model":"PSP5530DUO"},{"manufacturer":"Prestigio","market_name":"PSP5531","codename":"DW53B4G","model":"PSP5531DUO"},{"manufacturer":"Prestigio","market_name":"PSP5550DUO","codename":"PSP5550DUO","model":"PSP5550DUO"},{"manufacturer":"Prestigio","market_name":"PSP5551DUO","codename":"DW55B02L","model":"PSP5551DUO"},{"manufacturer":"Prestigio","market_name":"PSP5552DUO","codename":"UE55B1L","model":"PSP5552DUO"},{"manufacturer":"Prestigio","market_name":"PSP7501DUO","codename":"DW50B5G","model":"PSP7501DUO"},{"manufacturer":"Prestigio","market_name":"PSP7510DUO","codename":"EB50B1L","model":"PSP7510DUO"},{"manufacturer":"Prestigio","market_name":"PSP7511DUO","codename":"DW50B5G","model":"PSP7511DUO"},{"manufacturer":"Prestigio","market_name":"PSP7512DUO","codename":"EB50B1L","model":"PSP7512DUO"},{"manufacturer":"Prestigio","market_name":"PSP7530DUO","codename":"DW53B3G","model":"PSP7530DUO"},{"manufacturer":"Prestigio","market_name":"PSP7550DUO","codename":"DW55B8L","model":"PSP7550DUO"},{"manufacturer":"Prestigio","market_name":"PSP7551DUO","codename":"DW55B8L","model":"PSP7551DUO"},{"manufacturer":"Prestigio","market_name":"PSP7552DUO","codename":"DW55B8L","model":"PSP7552DUO"},{"manufacturer":"Prestigio","market_name":"Prestigio Muze 3708 3G","codename":"CF80A2G","model":"PMT3708_3G"},{"manufacturer":"Prestigio","market_name":"WIZE A3","codename":"PSP3453DUO","model":"PSP3453DUO"},{"manufacturer":"Prestigio","market_name":"Wize 3131 3G","codename":"LS10A3G","model":"PMT3131_3G"},{"manufacturer":"Prestigio","market_name":"Wize 3147 3G","codename":"LS70A2G","model":"PMT3147_3G"},{"manufacturer":"Prestigio","market_name":"Wize 3401 3G","codename":"JU10A3G","model":"PMT3401_3G"},{"manufacturer":"Prime","market_name":"O9","codename":"PRIME_O9","model":"O9"},{"manufacturer":"Prime","market_name":"X6_Pro","codename":"X6_Pro","model":"X6_Pro"},{"manufacturer":"Primux","market_name":"Primux_ioxphone","codename":"Primux_ioxphone","model":"Primux_ioxphone"},{"manufacturer":"Professional Mobile","market_name":"Pro V5","codename":"Pro_V5","model":"Pro V5"},{"manufacturer":"Proline","market_name":"H10885M","codename":"H10885M","model":"H10885M"},{"manufacturer":"Proline","market_name":"H7835M","codename":"H7835M","model":"H7835M"},{"manufacturer":"Proscan","market_name":"PLT1065G","codename":"PLT1065G","model":"PLT1065G"},{"manufacturer":"Proscan","market_name":"PLT1077G(1GB/8GB)","codename":"PLT1077G","model":"PLT1077G"},{"manufacturer":"Proscan","market_name":"PLT1077G_16G","codename":"PLT1077G_16G","model":"PLT1077G_16G"},{"manufacturer":"Proscan","market_name":"PLT7100G","codename":"PLT7100G","model":"PLT7100G"},{"manufacturer":"Proscan","market_name":"PLT7109G","codename":"PLT7109G","model":"PLT7109G"},{"manufacturer":"Proscan","market_name":"PLT7130G","codename":"PLT7130G","model":"PLT7130G"},{"manufacturer":"Proscan","market_name":"PLT7602G","codename":"PLT7602G","model":"PLT7602G"},{"manufacturer":"Proscan","market_name":"PLT7649G","codename":"PLT7649G","model":"PLT7649G"},{"manufacturer":"Proscan","market_name":"PLT7650G","codename":"PLT7650G","model":"PLT7650G"},{"manufacturer":"Proscan","market_name":"PLT7770G","codename":"PLT7770G","model":"PLT7770G"},{"manufacturer":"Proscan","market_name":"PLT7774G","codename":"PLT1074G","model":"PLT1074G"},{"manufacturer":"Proscan","market_name":"PLT7774G","codename":"PLT7774G","model":"PLT7774G"},{"manufacturer":"Proscan","market_name":"PLT7803G","codename":"PLT7803G","model":"PLT7803G"},{"manufacturer":"Proscan","market_name":"PLT7804G","codename":"PLT7804G","model":"PLT7804G"},{"manufacturer":"Proscan","market_name":"PLT8235G Tablet","codename":"MID807_K","model":"PLT8235G"},{"manufacturer":"Proscan","market_name":"PLT8802G","codename":"PLT8802G","model":"PLT8802G"},{"manufacturer":"Proscan","market_name":"PLT9602G","codename":"PLT9602G","model":"PLT9602G"},{"manufacturer":"Proscan","market_name":"PLT9606G","codename":"PLT9606G","model":"PLT9606G"},{"manufacturer":"Proscan","market_name":"PLT9609G","codename":"PLT9609G","model":"PLT9609G"},{"manufacturer":"Proscan","market_name":"PLT9649G","codename":"PLT9649G","model":"PLT9649G"},{"manufacturer":"Proscan","market_name":"PLT9650G","codename":"PLT9650G","model":"PLT9650G"},{"manufacturer":"Proscan","market_name":"PLT9774G","codename":"PLT9774G","model":"PLT9774G"},{"manufacturer":"Proscan","market_name":"PLT9999G","codename":"PLT9999G","model":"PLT9999G"},{"manufacturer":"Proscan","market_name":"SLTDVD9220_C","codename":"SLTDVD9220-C","model":"SLTDVD9220-C"},{"manufacturer":"Protab","market_name":"PTBPT5QCB7","codename":"PTBPT5QCB7","model":"PTBPT5QCB7"},{"manufacturer":"QLA","market_name":"C600","codename":"GBC_bravo","model":"C600"},{"manufacturer":"QMobile","market_name":"A1","codename":"QMobile_Noir_A1","model":"Noir A1"},{"manufacturer":"QMobile","market_name":"A1 lite","codename":"Noir_A1_lite","model":"Noir A1 lite"},{"manufacturer":"QMobile","market_name":"Beat 1","codename":"QMobile_Beat_1","model":"QMobile Beat 1"},{"manufacturer":"QMobile","market_name":"Blue 5","codename":"QMobile_Blue_5","model":"QMobile Blue 5"},{"manufacturer":"QMobile","market_name":"CS1","codename":"CS1","model":"QMobile CS1"},{"manufacturer":"QMobile","market_name":"CS1 Plus","codename":"CS1_Plus","model":"QMobile CS1 Plus"},{"manufacturer":"QMobile","market_name":"Dual One","codename":"QMobile_Dual_One","model":"QMobile Dual One"},{"manufacturer":"QMobile","market_name":"E1","codename":"QMobile_E1","model":"E1"},{"manufacturer":"QMobile","market_name":"E1","codename":"QMobile_E1","model":"QMobile E1"},{"manufacturer":"QMobile","market_name":"E2","codename":"E2_Noir","model":"E2 Noir"},{"manufacturer":"QMobile","market_name":"E3 Dual","codename":"E3_Dual","model":"E3 Dual"},{"manufacturer":"QMobile","market_name":"E8","codename":"GBL5805QM","model":"E8"},{"manufacturer":"QMobile","market_name":"ENERGY X1","codename":"ENERGY_X1","model":"QMobile ENERGY X1"},{"manufacturer":"QMobile","market_name":"ENERGY X2","codename":"ENERGY_X2","model":"QMobile ENERGY X2"},{"manufacturer":"QMobile","market_name":"Energy\\xc2\\xa0X10\\xc2\\xa04G","codename":"Energy_X10_4G","model":"QMobile Energy X10 4G"},{"manufacturer":"QMobile","market_name":"Energy\\xc2\\xa0X5 4G","codename":"Energy_X5_4G","model":"QMobile Energy X5 4G"},{"manufacturer":"QMobile","market_name":"Evok Power","codename":"QMobile_Evok_Power","model":"QMobile Evok Power"},{"manufacturer":"QMobile","market_name":"Evok Power Lite","codename":"Evok_Power_Lite","model":"QMobile Evok Power Lite"},{"manufacturer":"QMobile","market_name":"J1","codename":"J1","model":"QMobile J1"},{"manufacturer":"QMobile","market_name":"J2","codename":"J2","model":"QMobile J2"},{"manufacturer":"QMobile","market_name":"J5","codename":"J5","model":"J5"},{"manufacturer":"QMobile","market_name":"J7","codename":"J7","model":"J7"},{"manufacturer":"QMobile","market_name":"J7 PRO","codename":"J7_PRO","model":"J7 PRO"},{"manufacturer":"QMobile","market_name":"JS10","codename":"JAZZX_JS10","model":"JAZZX JS10"},{"manufacturer":"QMobile","market_name":"JazzX JS7 PRO","codename":"JS7_PRO","model":"JazzX JS7 PRO"},{"manufacturer":"QMobile","market_name":"KING KONG MAX","codename":"KING_KONG_MAX","model":"KING KONG MAX"},{"manufacturer":"QMobile","market_name":"L20","codename":"L20","model":"QMobile L20"},{"manufacturer":"QMobile","market_name":"LT100","codename":"LT100","model":"QMobile LT100"},{"manufacturer":"QMobile","market_name":"LT300","codename":"LT300","model":"LT300"},{"manufacturer":"QMobile","market_name":"LT500 PRO","codename":"QMobile_LT500_PRO","model":"LT500 PRO"},{"manufacturer":"QMobile","market_name":"LT550","codename":"QMobile_LT550","model":"QMobile LT550"},{"manufacturer":"QMobile","market_name":"LT600 PRO","codename":"QMobile_LT600_PRO","model":"QMobile_LT600_PRO"},{"manufacturer":"QMobile","market_name":"LT650","codename":"LT650","model":"LT650"},{"manufacturer":"QMobile","market_name":"LT680","codename":"QMobile_LT680","model":"LT680"},{"manufacturer":"QMobile","market_name":"LT700","codename":"GBL7325QM","model":"LT700"},{"manufacturer":"QMobile","market_name":"LT700 PRO","codename":"LT700_PRO","model":"LT700 PRO"},{"manufacturer":"QMobile","market_name":"M350 Pro","codename":"M350_Pro","model":"M350 Pro"},{"manufacturer":"QMobile","market_name":"M6","codename":"BBL7551QM","model":"M6"},{"manufacturer":"QMobile","market_name":"M6 Lite","codename":"M6_Lite","model":"M6 Lite"},{"manufacturer":"QMobile","market_name":"NOIR A3","codename":"A3","model":"QMobile A3"},{"manufacturer":"QMobile","market_name":"NOIR A6","codename":"A6","model":"QMobile A6"},{"manufacturer":"QMobile","market_name":"Noir S9","codename":"QMobile_Noir_S9","model":"QMobile Noir S9"},{"manufacturer":"QMobile","market_name":"Pakistan","codename":"A1_sprout","model":"QMobile A1"},{"manufacturer":"QMobile","market_name":"Q Infinity","codename":"Q_Infinity","model":"Q Infinity"},{"manufacturer":"QMobile","market_name":"Q Infinity B","codename":"Q_Infinity_B","model":"QMobile Q Infinity B"},{"manufacturer":"QMobile","market_name":"Q Infinity C","codename":"Q_Infinity_C","model":"QMobile Q Infinity C"},{"manufacturer":"QMobile","market_name":"Q Infinity D","codename":"Q_Infinity_D","model":"QMobile Q Infinity D"},{"manufacturer":"QMobile","market_name":"Q Infinity E","codename":"Q_Infinity_E","model":"QMobile Q Infinity E"},{"manufacturer":"QMobile","market_name":"Q Infinity E Lite","codename":"Q_Infinity_E_Lite","model":"QMobile Q Infinity E Lite"},{"manufacturer":"QMobile","market_name":"QMobile S15","codename":"S15","model":"QMobile S15"},{"manufacturer":"QMobile","market_name":"QNote","codename":"QMobile_QNote","model":"QMobile QNote"},{"manufacturer":"QMobile","market_name":"Qmobile S8 Plus","codename":"QMobile_S8_Plus","model":"S8 Plus"},{"manufacturer":"QMobile","market_name":"S1 Lite","codename":"S1_Lite","model":"QMobile S1 Lite"},{"manufacturer":"QMobile","market_name":"S1 PRO","codename":"S1_PRO","model":"QMobile S1 PRO"},{"manufacturer":"QMobile","market_name":"S2 Plus","codename":"S2_Plus","model":"QMobile S2 Plus"},{"manufacturer":"QMobile","market_name":"S2 Pro","codename":"S2_Pro","model":"S2 Pro"},{"manufacturer":"QMobile","market_name":"S4","codename":"QMobile_S4","model":"S4"},{"manufacturer":"QMobile","market_name":"S6","codename":"QMobileS6","model":"QMobile S6"},{"manufacturer":"QMobile","market_name":"S6 PLUS","codename":"QMobile_S6_PLUS","model":"QMobile S6 PLUS"},{"manufacturer":"QMobile","market_name":"S6S","codename":"QMobile_S6S","model":"QMobile S6S"},{"manufacturer":"QMobile","market_name":"S8","codename":"QMobile_S8","model":"S8"},{"manufacturer":"QMobile","market_name":"S8_Lite","codename":"QMobile_S8_Lite","model":"S8_Lite"},{"manufacturer":"QMobile","market_name":"S9","codename":"S9","model":"S9"},{"manufacturer":"QMobile","market_name":"V100","codename":"QTab_V100","model":"V100"},{"manufacturer":"QMobile","market_name":"V200","codename":"QTab_V200","model":"V200"},{"manufacturer":"QMobile","market_name":"V500","codename":"QTab_V500","model":"V500"},{"manufacturer":"QMobile","market_name":"W70","codename":"W70","model":"W70"},{"manufacturer":"QMobile","market_name":"W80","codename":"WBW5615QM","model":"W80"},{"manufacturer":"QMobile","market_name":"X1S","codename":"Noir_X1S","model":"Noir X1S"},{"manufacturer":"QMobile","market_name":"X32","codename":"X32","model":"QMobile X32"},{"manufacturer":"QMobile","market_name":"X32","codename":"X32_new","model":"QMobile X32"},{"manufacturer":"QMobile","market_name":"X32 Power","codename":"X32_Power","model":"QMobile X32 Power"},{"manufacturer":"QMobile","market_name":"X33","codename":"QMobile_X33","model":"QMobile X33"},{"manufacturer":"QMobile","market_name":"X36","codename":"QMobile_X36","model":"QMobile X36"},{"manufacturer":"QMobile","market_name":"X700 PRO","codename":"X700_PRO","model":"QMobile X700 PRO"},{"manufacturer":"QMobile","market_name":"X700 PRO II","codename":"X700_PRO_II","model":"QMobile X700 PRO II"},{"manufacturer":"QMobile","market_name":"X700 PRO Lite","codename":"X700_PRO_Lite","model":"QMobile X700 PRO Lite"},{"manufacturer":"QMobile","market_name":"X75","codename":"WBW5613QM","model":"X75"},{"manufacturer":"QMobile","market_name":"Z10","codename":"Z10","model":"QMobile Z10"},{"manufacturer":"QMobile","market_name":"Z12","codename":"CBL7521QM","model":"Z12"},{"manufacturer":"QMobile","market_name":"Z12 PRO","codename":"Z12_PRO","model":"Z12 PRO"},{"manufacturer":"QMobile","market_name":"Z14","codename":"Z14","model":"Z14"},{"manufacturer":"QMobile","market_name":"Z9 Plus","codename":"WBL7511QM","model":"Z9 Plus"},{"manufacturer":"QMobile","market_name":"i2 POWER","codename":"i2_POWER","model":"QMobile i2 POWER"},{"manufacturer":"QMobile","market_name":"i2 PRO","codename":"i2_PRO","model":"QMobile i2 PRO"},{"manufacturer":"QMobile","market_name":"i5.5","codename":"i5_5","model":"QMobile i5.5"},{"manufacturer":"QMobile","market_name":"i6 Metal 2017","codename":"i6_Metal_2017","model":"QMobile i6 Metal 2017"},{"manufacturer":"QMobile","market_name":"i6 Metal HD","codename":"i6_Metal_HD","model":"i6 Metal HD"},{"manufacturer":"QMobile","market_name":"i6 Metal ONE","codename":"i6_Metal_ONE","model":"QMobile i6 Metal ONE"},{"manufacturer":"QMobile","market_name":"i6 Metal One","codename":"i6_Metal_ONE_new","model":"QMobile i6 Metal ONE"},{"manufacturer":"QMobile","market_name":"i7i PRO","codename":"i7i_PRO","model":"QMobile i7i PRO"},{"manufacturer":"QMobile","market_name":"i8i PRO","codename":"i8i_PRO","model":"QMobile i8i PRO"},{"manufacturer":"QOOQ","market_name":"QOOQV3","codename":"QOOQ","model":"QOOQ"},{"manufacturer":"Qilive","market_name":"Q.3778","codename":"Q3778","model":"Q.3778"},{"manufacturer":"Qilive","market_name":"Q10S5IN4G","codename":"Q10S5IN4G","model":"Q10S5IN4G"},{"manufacturer":"Qilive","market_name":"Q9S55IN4G","codename":"Q9S55IN4G","model":"Q9S55IN4G"},{"manufacturer":"Qilive","market_name":"W55","codename":"W55","model":"W55"},{"manufacturer":"Qpad","market_name":"XL PLUS","codename":"t591_hwd_q19_hiya_we","model":"XL PLUS"},{"manufacturer":"Qtouch","market_name":"Q01A","codename":"Q01A","model":"Q01A"},{"manufacturer":"Qtouch","market_name":"Q05A","codename":"Q05A","model":"Q05A"},{"manufacturer":"Qtouch","market_name":"QS701","codename":"QS701","model":"QS701"},{"manufacturer":"Qtouch","market_name":"QS702","codename":"QTOUCH-QS702","model":"QS702"},{"manufacturer":"Quanta","market_name":"","codename":"Nirvana_Tablet","model":"Nirvana_Tablet"},{"manufacturer":"Quanta","market_name":"","codename":"infinity_g","model":"INFINITY G NK2"},{"manufacturer":"Quanta","market_name":"","codename":"nk1","model":"IGS-1000"},{"manufacturer":"Quanta","market_name":"","codename":"nk1","model":"TA1013"},{"manufacturer":"Quanta","market_name":"","codename":"ventana","model":"NK1_111018_002_HC"},{"manufacturer":"Quanta","market_name":"","codename":"ventana","model":"Q10"},{"manufacturer":"Quanta","market_name":"CT2200","codename":"CT2200","model":"CT2200"},{"manufacturer":"Quanta","market_name":"FT103","codename":"FT103","model":"FT103"},{"manufacturer":"Quanta","market_name":"True Beyond 4G","codename":"al7","model":"TRUE BEYOND 4G"},{"manufacturer":"Quanta","market_name":"VSD220","codename":"VSD220","model":"VSD220"},{"manufacturer":"Quantum","market_name":"FLY","codename":"Q7","model":"Quantum Fly"},{"manufacturer":"Quantum","market_name":"Fit","codename":"QF73","model":"Quantum Fit"},{"manufacturer":"Quantum","market_name":"Go","codename":"Q1","model":"Quantum Go"},{"manufacturer":"Quantum","market_name":"Go","codename":"Q2","model":"Quantum Go"},{"manufacturer":"Quantum","market_name":"Go 2","codename":"Q19","model":"GO 2"},{"manufacturer":"Quantum","market_name":"MUV","codename":"Q3B","model":"Quantum MUV"},{"manufacturer":"Quantum","market_name":"MUV 3G","codename":"Q3C","model":"MUV"},{"manufacturer":"Quantum","market_name":"MUV 3G","codename":"Q3C","model":"MUV 3G"},{"manufacturer":"Quantum","market_name":"MUV PRO","codename":"Q5","model":"Quantum MUV PRO"},{"manufacturer":"Quantum","market_name":"MUV UP","codename":"Q13","model":"Quantum MUV UP"},{"manufacturer":"Quantum","market_name":"Mini","codename":"S431","model":"Quantum Mini"},{"manufacturer":"Quantum","market_name":"Muv","codename":"Q3","model":"MUV"},{"manufacturer":"Quantum","market_name":"Muv","codename":"Q3","model":"Quantum MUV"},{"manufacturer":"Quantum","market_name":"QSPT-1952","codename":"QF3A","model":"QT-195W-aa2"},{"manufacturer":"Quantum","market_name":"Sky","codename":"QX1","model":"Sky"},{"manufacturer":"Quantum","market_name":"Twist Neo","codename":"S501","model":"twist neo"},{"manufacturer":"Quantum","market_name":"V","codename":"QX2","model":"Quantum V"},{"manufacturer":"Quantum","market_name":"You","codename":"Q17","model":"Quantum You"},{"manufacturer":"Quantum","market_name":"You","codename":"Q17","model":"You"},{"manufacturer":"Quantum","market_name":"You E","codename":"QY77","model":"Quantum You E"},{"manufacturer":"Quantum","market_name":"You L","codename":"Q11","model":"You L"},{"manufacturer":"Quantum","market_name":"i9i","codename":"QMobile_i9i","model":"QMobile I9i"},{"manufacturer":"RCA","market_name":"10 Viking II","codename":"RCT6603W47M7","model":"RCT6603W47M7"},{"manufacturer":"RCA","market_name":"10 Viking II Pro","codename":"RCT6603W87M7","model":"RCT6603W87M7"},{"manufacturer":"RCA","market_name":"10 Viking Pro","codename":"RCT6303W87DK","model":"RCT6303W87DK"},{"manufacturer":"RCA","market_name":"10 Viking Pro","codename":"RCT6303W87M","model":"RCT6303W87M"},{"manufacturer":"RCA","market_name":"10 Viking Pro","codename":"RCT6303W87M7","model":"RCT6303W87M7"},{"manufacturer":"RCA","market_name":"10 Viking Pro","codename":"RCT6K03W13","model":"RCT6K03W13"},{"manufacturer":"RCA","market_name":"11 Galileo Pro","codename":"RCT6513W87","model":"RCT6513W87"},{"manufacturer":"RCA","market_name":"11 Maven Pro","codename":"RCT6213W87DK","model":"RCT6213W87DK"},{"manufacturer":"RCA","market_name":"7 Mercury","codename":"RCT6673W23M","model":"RCT6673W23M"},{"manufacturer":"RCA","market_name":"7 Mercury","codename":"RCT6673W43M","model":"RCT6673W43M"},{"manufacturer":"RCA","market_name":"7 Voyager","codename":"RCT6873W42","model":"RCT6873W42"},{"manufacturer":"RCA","market_name":"7 Voyager II","codename":"RCT6773W22B","model":"RCT6773W22B"},{"manufacturer":"RCA","market_name":"7 Voyager II","codename":"RCT6773W22BM","model":"RCT6773W22BM"},{"manufacturer":"RCA","market_name":"Atlas 10","codename":"RCT6703W12","model":"RCT6703W12"},{"manufacturer":"RCA","market_name":"BNT-710","codename":"BNT-710","model":"BNT-710"},{"manufacturer":"RCA","market_name":"DAA730R / RCA DAA738R","codename":"MD7081","model":"DAA730R"},{"manufacturer":"RCA","market_name":"DAA730R / RCA DAA738R","codename":"MD7081","model":"DAA738R"},{"manufacturer":"RCA","market_name":"Mercury 7","codename":"CT9973W43M","model":"CT9973W43M"},{"manufacturer":"RCA","market_name":"Pro10 Edition II","codename":"RCT6203W46L","model":"RCT6203W46L"},{"manufacturer":"RCA","market_name":"Pro12","codename":"RCT6223W87","model":"RCT6223W87"},{"manufacturer":"RCA","market_name":"RCA RCT6213W22","codename":"RCT6213W22","model":"RCT6213W22"},{"manufacturer":"RCA","market_name":"RCA RCT6213W23","codename":"RCT6213W23","model":"RCT6213W23"},{"manufacturer":"RCA","market_name":"RCA RCT6213W24","codename":"RCT6213W24","model":"RCT6213W24"},{"manufacturer":"RCA","market_name":"RCA RCT6703W13","codename":"RCT6703W13","model":"RCT6703W13"},{"manufacturer":"RCA","market_name":"RCA RCT6B83W12","codename":"RCT6B83W12","model":"RCT6B83W12"},{"manufacturer":"RCA","market_name":"RCA RCT6S03W12","codename":"RCT6S03W12","model":"RCT6S03W12"},{"manufacturer":"RCA","market_name":"RCA RCT6S03W14","codename":"RCT6S03W14","model":"RCT6S03W14"},{"manufacturer":"RCA","market_name":"RCS13101T","codename":"RCS13101T","model":"RCS13101T"},{"manufacturer":"RCA","market_name":"RCT6002W46","codename":"RCT6002W46","model":"RCT6002W46"},{"manufacturer":"RCA","market_name":"RCT6077W2","codename":"RCT6077W2","model":"RCT6077W2"},{"manufacturer":"RCA","market_name":"RCT6077W22","codename":"RCT6077W22","model":"RCT6077W22"},{"manufacturer":"RCA","market_name":"RCT6103W46","codename":"RCT6103W46","model":"RCT6103W46"},{"manufacturer":"RCA","market_name":"RCT6203W46","codename":"RCT6203W46","model":"RCT6203W46"},{"manufacturer":"RCA","market_name":"RCT6223W97","codename":"RCT6223W97","model":"RCT6223W97"},{"manufacturer":"RCA","market_name":"RCT6272W23","codename":"RCT6272W23","model":"RCT6272W23"},{"manufacturer":"RCA","market_name":"RCT6273W26","codename":"RCT6273W26","model":"RCT6273W26"},{"manufacturer":"RCA","market_name":"RCT6283W27","codename":"RCT6283W27","model":"RCT6283W27"},{"manufacturer":"RCA","market_name":"RCT6293W23","codename":"RCT6293W23","model":"RCT6293W23"},{"manufacturer":"RCA","market_name":"RCT6378W2","codename":"RCT6378W2","model":"RCT6378W2"},{"manufacturer":"RCA","market_name":"RCT6573W23","codename":"RCT6573W23","model":"RCT6573W23"},{"manufacturer":"RCA","market_name":"RCT6603W47","codename":"RCT6603W47DK","model":"RCT6603W47DK"},{"manufacturer":"RCA","market_name":"RCT6672W23","codename":"RCT6672W23","model":"RCT6672W23"},{"manufacturer":"RCA","market_name":"RCT6673W-V1","codename":"RCT6673W-V1","model":"RCT6673W-V1"},{"manufacturer":"RCA","market_name":"RCT6691W3","codename":"RCT6691W3","model":"RCT6691W3"},{"manufacturer":"RCA","market_name":"RCT6773W22","codename":"RCT6773W22","model":"RCT6773W22"},{"manufacturer":"RCA","market_name":"RCT6773W42B","codename":"RCT6773W42B","model":"RCT6773W42B"},{"manufacturer":"RCA","market_name":"RCT6873W42M","codename":"RCT6873W42M","model":"RCT6873W42M"},{"manufacturer":"RCA","market_name":"RCT6973W43","codename":"RCT6973W43","model":"RCT6973W43"},{"manufacturer":"RCA","market_name":"RCT6973W43M","codename":"RCT6973W43M","model":"RCT6973W43M"},{"manufacturer":"RCA","market_name":"Voyager Pro","codename":"RCT6873W42M_F7","model":"RCT6873W42M_F7"},{"manufacturer":"RCA","market_name":"XLD Series","codename":"XLDRCAV1","model":"XLDRCAV1"},{"manufacturer":"REACH","market_name":"Q882","codename":"Q882","model":"Q882"},{"manufacturer":"Rainbow","market_name":"WIKO","codename":"s5501","model":"RAINBOW"},{"manufacturer":"Ratel","market_name":"Cell","codename":"Cell","model":"CELL"},{"manufacturer":"Rayan","market_name":"AM_TAB_7_03","codename":"AMAA703","model":"AMA_A703"},{"manufacturer":"Razer","market_name":"Forge TV","codename":"pearlyn","model":"Forge"},{"manufacturer":"Razer","market_name":"Razer Phone","codename":"cheryl","model":"Phone"},{"manufacturer":"Razer","market_name":"Razer phone","codename":"cheryl_ckh","model":"Phone"},{"manufacturer":"Realtime","market_name":"RS405","codename":"RS405","model":"RS405"},{"manufacturer":"Reeder","market_name":"A8i Q2","codename":"A8i-Q2","model":"A8i-Q2"},{"manufacturer":"Reeder","market_name":"M7 Plus","codename":"reeder_M7Plus","model":"M7Plus"},{"manufacturer":"Reeder","market_name":"P10","codename":"P10","model":"P10"},{"manufacturer":"Reeder","market_name":"P10S","codename":"P10S","model":"P10S"},{"manufacturer":"Reeder","market_name":"P10SE","codename":"P10SE","model":"P10SE"},{"manufacturer":"Reeder","market_name":"P9C","codename":"P9C","model":"P9C"},{"manufacturer":"Reeder","market_name":"T8","codename":"reeder_T8","model":"reeder_T8"},{"manufacturer":"Reeder","market_name":"reeder P12","codename":"P12","model":"P12"},{"manufacturer":"Rego","market_name":"Chocolate","codename":"chocolate","model":"Rego"},{"manufacturer":"Reliance","market_name":"FL7008","codename":"FL7008","model":"FL7008"},{"manufacturer":"Reliance","market_name":"LS-4008","codename":"LS-4008","model":"LS-4008"},{"manufacturer":"Reliance","market_name":"LS-5506","codename":"LS-5506","model":"LS-5506"},{"manufacturer":"Reliance","market_name":"LS-5512","codename":"LS-5512","model":"LS-5512"},{"manufacturer":"Reliance","market_name":"MCM3000","codename":"MCM3000","model":"IPSetTopBox"},{"manufacturer":"Reliance","market_name":"Orbic RC505L-RW","codename":"RC505L-RW","model":"RC505L-RW"},{"manufacturer":"Reliance","market_name":"RC500L","codename":"RC500L","model":"RC500L"},{"manufacturer":"Reliance","market_name":"RC501L","codename":"RC501L","model":"RC501L"},{"manufacturer":"Reliance","market_name":"Smartphone JS LS-5010","codename":"LS-5010","model":"LS-5010"},{"manufacturer":"Revo","market_name":"Pearl","codename":"Pearl","model":"Pearl"},{"manufacturer":"Revo","market_name":"Power","codename":"Power","model":"Power"},{"manufacturer":"Revtel","market_name":"R45","codename":"Revel_R45","model":"R45"},{"manufacturer":"Rinno","market_name":"R455","codename":"R455","model":"R455"},{"manufacturer":"Rinno","market_name":"R505","codename":"Rinno_R505","model":"R505"},{"manufacturer":"Rinno","market_name":"R520","codename":"R520","model":"R520"},{"manufacturer":"Rinno","market_name":"R550","codename":"R550","model":"R550"},{"manufacturer":"Royaltek","market_name":"FGAD","codename":"FGAD","model":"FGAD"},{"manufacturer":"Ruggear","market_name":"CP250","codename":"cp250_gts","model":"cp250_gts"},{"manufacturer":"Ruggear","market_name":"DEWALT MD501","codename":"md501","model":"DeWalt MD501"},{"manufacturer":"Ruggear","market_name":"IMO S","codename":"IMO_S","model":"IMO_S"},{"manufacturer":"Ruggear","market_name":"RG720","codename":"RG720","model":"RG720"},{"manufacturer":"Ruggear","market_name":"RG730","codename":"rg730","model":"RugGear RG730"},{"manufacturer":"Ruggear","market_name":"RG740B","codename":"RG740B","model":"RG740B"},{"manufacturer":"Ruggear","market_name":"RG760","codename":"RG760","model":"RG760"},{"manufacturer":"Ruio","market_name":"RUIO i7c Tablet","codename":"i7c","model":"i7c"},{"manufacturer":"Ruio","market_name":"Ruio_S5Plus","codename":"Ruio_S5Plus","model":"Ruio_S5Plus"},{"manufacturer":"Ruio","market_name":"S4","codename":"RUIO_S4","model":"RUIO_S4"},{"manufacturer":"S-tell","market_name":"M555i","codename":"M555i","model":"M555i"},{"manufacturer":"S-tell","market_name":"M578","codename":"M578","model":"M578"},{"manufacturer":"S-tell","market_name":"M580","codename":"M580","model":"M580"},{"manufacturer":"S-tell","market_name":"M655","codename":"M655","model":"M655"},{"manufacturer":"S-tell","market_name":"P750i","codename":"P750i","model":"P750i"},{"manufacturer":"S-tell","market_name":"P771","codename":"S-TELL","model":"P771"},{"manufacturer":"S-tell","market_name":"P850","codename":"P850","model":"P850"},{"manufacturer":"SAKAISIO","market_name":"FP-U320-711-WIFI","codename":"U320-WF","model":"FP-U320-711-WIFI"},{"manufacturer":"SAKAISIO","market_name":"FP-U320-711-WWAN","codename":"U320-3G","model":"FP-U320-711-WWAN"},{"manufacturer":"SED Wireless","market_name":"GPH-650R","codename":"SPH_650R","model":"GPH-650R"},{"manufacturer":"SELECLINE","market_name":"MID7526CM","codename":"MID7526CM","model":"NID_7010"},{"manufacturer":"SELECLINE","market_name":"MID_9526CM","codename":"MID_9526CM","model":"S952"},{"manufacturer":"SFR","market_name":"G8800","codename":"stb_dvb_sfr","model":"SFR-G8800"},{"manufacturer":"SFR","market_name":"STARADDICT 4","codename":"staraddict4","model":"STARADDICT 4"},{"manufacturer":"SFR","market_name":"STARXTREM3","codename":"STARXTREM3","model":"STARXTREM3"},{"manufacturer":"SFR","market_name":"Star Shine II","codename":"up11_sfr_mensa","model":"STARSHINE II"},{"manufacturer":"SFR","market_name":"Star Trail 5","codename":"STARTRAIL5","model":"STARTRAIL5"},{"manufacturer":"SFR","market_name":"Star Trail 6","codename":"STARTRAIL6","model":"STARTRAIL6"},{"manufacturer":"SFR","market_name":"Star Trail III","codename":"mobiwire_startrail3","model":"StarTrail III"},{"manufacturer":"SK Broadband","market_name":"B tv smart","codename":"BHX-S100","model":"BHX-S100"},{"manufacturer":"SK Broadband","market_name":"B tv smart","codename":"BKO-S200","model":"BKO-S200"},{"manufacturer":"SK Telesys","market_name":"","codename":"K4","model":"SK-S170"},{"manufacturer":"SK Telesys","market_name":"","codename":"msm8255_k5","model":"SK-S150"},{"manufacturer":"SK Telesys","market_name":"","codename":"qsd8250_s1","model":"SK-S100"},{"manufacturer":"SK Telesys","market_name":"AN200","codename":"AN200","model":"AN200"},{"manufacturer":"SK Telesys","market_name":"EG68BE","codename":"EG668BE","model":"EG668"},{"manufacturer":"SK Telesys","market_name":"EG978TW","codename":"EG978TW","model":"EG978"},{"manufacturer":"SK Telesys","market_name":"EG980","codename":"eg980tw","model":"EG980"},{"manufacturer":"SK Telesys","market_name":"Fly","codename":"htt77_ics2","model":"Fly"},{"manufacturer":"SK Telesys","market_name":"ITP-E410W","codename":"willow","model":"ITP-E410W"},{"manufacturer":"SK Telesys","market_name":"ITP-R208W","codename":"rk30sdk","model":"ITP-R208W"},{"manufacturer":"SK Telesys","market_name":"Ice-Phone Forever","codename":"z262_wvga_mge","model":"Ice-Phone Forever"},{"manufacturer":"SK Telesys","market_name":"K2401","codename":"K2401","model":"S201"},{"manufacturer":"SK Telesys","market_name":"S150","codename":"msm8255_k5","model":"S150"},{"manufacturer":"SK Telesys","market_name":"T720","codename":"T720","model":"Clear"},{"manufacturer":"SK Telesys","market_name":"UTA200","codename":"htt75_nand_6628_ics","model":"UTA200"},{"manufacturer":"SK Telesys","market_name":"WA966","codename":"u966e_2","model":"WA966"},{"manufacturer":"SK Telesys","market_name":"WA978","codename":"u978e_1","model":"WA978"},{"manufacturer":"SK Telesys","market_name":"icube-830","codename":"icube-830","model":"icube-830"},{"manufacturer":"SMT_LW","market_name":"X450","codename":"X450","model":"X450-Locked to Life Wireless"},{"manufacturer":"SMT_TSC","market_name":"BLAZE X500","codename":"BLAZE_X500","model":"BLAZE_X500"},{"manufacturer":"SOSMART","market_name":"T5","codename":"SOSMART_T5","model":"SOSMART_T5"},{"manufacturer":"SPC Mobile","market_name":"L50","codename":"SPC_L50","model":"L50"},{"manufacturer":"SPC Mobile","market_name":"L51 BLITZ","codename":"L51","model":"L51"},{"manufacturer":"SPC Mobile","market_name":"L51 PRO","codename":"L51_Pro","model":"L51 Pro"},{"manufacturer":"SPC Mobile","market_name":"L52 PRO","codename":"L52_Pro","model":"L52 Pro"},{"manufacturer":"SPC Mobile","market_name":"L52 STEEL+","codename":"L52","model":"L52"},{"manufacturer":"SPC Mobile","market_name":"L52F","codename":"L52F","model":"L52F"},{"manufacturer":"SPC Mobile","market_name":"L53","codename":"L53","model":"L53"},{"manufacturer":"SPC Mobile","market_name":"L54","codename":"L54","model":"L54"},{"manufacturer":"SPC Mobile","market_name":"L60","codename":"SPC_L60","model":"L60"},{"manufacturer":"SPC Mobile","market_name":"S19","codename":"S19","model":"S19"},{"manufacturer":"SPC Mobile","market_name":"X1","codename":"SPC_X1","model":"X1"},{"manufacturer":"STF Mobile","market_name":"AERIAL","codename":"STFAERIAL","model":"AERIAL"},{"manufacturer":"STF Mobile","market_name":"AERIAL PLUS","codename":"AERIAL","model":"AERIAL PLUS"},{"manufacturer":"STF Mobile","market_name":"DUO","codename":"DUO","model":"DUO"},{"manufacturer":"STF Mobile","market_name":"Fractal","codename":"Fractal","model":"Fractal"},{"manufacturer":"STF Mobile","market_name":"HK-914581","codename":"HK-914581","model":"HK-914581"},{"manufacturer":"STF Mobile","market_name":"IO","codename":"IO","model":"IO"},{"manufacturer":"STF Mobile","market_name":"Joy Pro","codename":"Joy_Pro","model":"Joy Pro"},{"manufacturer":"STF Mobile","market_name":"NATIVO","codename":"NATIVO","model":"NATIVO"},{"manufacturer":"STF Mobile","market_name":"Origins Pro","codename":"Origins_Pro","model":"Origins Pro"},{"manufacturer":"STF Mobile","market_name":"STF-BLOCK","codename":"Block","model":"Block"},{"manufacturer":"STK(Santok)","market_name":"Hero X","codename":"STK_Hero_X","model":"STK_Hero_X"},{"manufacturer":"STK(Santok)","market_name":"STK Ace Plus","codename":"Ace_Plus","model":"STK Ace Plus"},{"manufacturer":"STK(Santok)","market_name":"STK Ace Plus","codename":"STK_Ace_Plus","model":"STK Ace Plus"},{"manufacturer":"STK(Santok)","market_name":"STK EVO","codename":"STK_EVO_US","model":"STK EVO"},{"manufacturer":"STK(Santok)","market_name":"STK Hero Lite","codename":"Hero_Lite","model":"STK Hero Lite"},{"manufacturer":"STK(Santok)","market_name":"STK Hero Lite","codename":"STK_Hero_Lite","model":"STK Hero Lite"},{"manufacturer":"STK(Santok)","market_name":"STK Life 5","codename":"STK_Life_5","model":"STK Life 5"},{"manufacturer":"STK(Santok)","market_name":"STK Life 7 3G","codename":"Life_7_3G","model":"STK Life 7 3G"},{"manufacturer":"STK(Santok)","market_name":"STK Life 7 4G","codename":"STK_Life_7_4G","model":"STK Life 7 4G"},{"manufacturer":"STK(Santok)","market_name":"STK Life 8","codename":"STK_Life_8","model":"STK Life 8"},{"manufacturer":"STK(Santok)","market_name":"STK Life Plus S","codename":"Life_Plus_S","model":"STK Life Plus S"},{"manufacturer":"STK(Santok)","market_name":"STK Life Plus S","codename":"STK_Life_Plus_S","model":"STK Life Plus S"},{"manufacturer":"STK(Santok)","market_name":"SYNC 5C","codename":"STK_Sync_5c","model":"STK_Sync_5c"},{"manufacturer":"STK(Santok)","market_name":"Storm 2e  Plus","codename":"Storm_2e_Plus","model":"Storm 2e Plus"},{"manufacturer":"STK(Santok)","market_name":"Storm 2e Pluz","codename":"Storm_2e_Pluz","model":"Storm 2e Pluz"},{"manufacturer":"STK(Santok)","market_name":"Storm 3","codename":"W230","model":"STK Storm 3"},{"manufacturer":"STK(Santok)","market_name":"Sync 5e","codename":"STK_Sync_5e","model":"STK_Sync_5e"},{"manufacturer":"STK(Santok)","market_name":"Sync 5z","codename":"STK_Sync_5z","model":"STK Sync 5z"},{"manufacturer":"STK(Santok)","market_name":"Transporter 1","codename":"STK_Transporter_1","model":"STK_Transporter_1"},{"manufacturer":"SUPERSONIC","market_name":"SC_4317BT","codename":"SC_4317BT","model":"SC_4317BT"},{"manufacturer":"Safaricom","market_name":"SFCSTB2LITE","codename":"SFCSTB2LITE","model":"SFCSTB2LITE"},{"manufacturer":"Saltillo","market_name":"CF10","codename":"CF10","model":"CF10"},{"manufacturer":"Samsung","market_name":"","codename":"GT-I5510M","model":"GT-I5510M"},{"manufacturer":"Samsung","market_name":"","codename":"GT-I5510T","model":"GT-I5510T"},{"manufacturer":"Samsung","market_name":"","codename":"GT-I5800L","model":"GT-I5800L"},{"manufacturer":"Samsung","market_name":"","codename":"GT-N7000B","model":"GT-N7000B"},{"manufacturer":"Samsung","market_name":"","codename":"GT-P7300B","model":"GT-P7300B"},{"manufacturer":"Samsung","market_name":"","codename":"GT-P7320T","model":"GT-P7320T"},{"manufacturer":"Samsung","market_name":"","codename":"GT-P7500M","model":"GT-P7500M"},{"manufacturer":"Samsung","market_name":"","codename":"GT-P7500R","model":"GT-P7500R"},{"manufacturer":"Samsung","market_name":"","codename":"GT-P7500V","model":"GT-P7500V"},{"manufacturer":"Samsung","market_name":"","codename":"GT-S5698","model":"GT-S5698"},{"manufacturer":"Samsung","market_name":"","codename":"GT-S5820","model":"GT-S5820"},{"manufacturer":"Samsung","market_name":"","codename":"GT-S5830V","model":"GT-S5830V"},{"manufacturer":"Samsung","market_name":"","codename":"SCH-I339","model":"SCH-I339"},{"manufacturer":"Samsung","market_name":"","codename":"SCH-I405U","model":"SCH-I405U"},{"manufacturer":"Samsung","market_name":"","codename":"SCH-I509U","model":"SCH-I509U"},{"manufacturer":"Samsung","market_name":"","codename":"SCH-I519","model":"SCH-I519"},{"manufacturer":"Samsung","market_name":"","codename":"SCH-I559","model":"SCH-I559"},{"manufacturer":"Samsung","market_name":"","codename":"SCH-I559","model":"SCH-i559"},{"manufacturer":"Samsung","market_name":"","codename":"SCH-I639","model":"SCH-I639"},{"manufacturer":"Samsung","market_name":"","codename":"SCH-I659","model":"SCH-I659"},{"manufacturer":"Samsung","market_name":"","codename":"SCH-I699","model":"SCH-I699"},{"manufacturer":"Samsung","market_name":"","codename":"SCH-I779","model":"SCH-I779"},{"manufacturer":"Samsung","market_name":"","codename":"SCH-I919U","model":"SCH-I919U"},{"manufacturer":"Samsung","market_name":"","codename":"SCH-W899","model":"SCH-W899"},{"manufacturer":"Samsung","market_name":"","codename":"SCH-W999","model":"SCH-W999"},{"manufacturer":"Samsung","market_name":"","codename":"SCH-i809","model":"SCH-i809"},{"manufacturer":"Samsung","market_name":"","codename":"SCH-i919","model":"SCH-i919"},{"manufacturer":"Samsung","market_name":"","codename":"SGH-I987","model":"SGH-I987"},{"manufacturer":"Samsung","market_name":"","codename":"SGH_T939","model":"Behold II"},{"manufacturer":"Samsung","market_name":"","codename":"SHV-E150S","model":"SHV-E150S"},{"manufacturer":"Samsung","market_name":"","codename":"SHW-M115S","model":"SHW-M115S"},{"manufacturer":"Samsung","market_name":"","codename":"SHW-M135K","model":"SHW-M135K"},{"manufacturer":"Samsung","market_name":"","codename":"SHW-M135L","model":"SHW-M135L"},{"manufacturer":"Samsung","market_name":"","codename":"SHW-M340D","model":"SHW-M340D"},{"manufacturer":"Samsung","market_name":"","codename":"SHW-M340K","model":"SHW-M340K"},{"manufacturer":"Samsung","market_name":"","codename":"SHW-M460D","model":"SHW-M460D"},{"manufacturer":"Samsung","market_name":"","codename":"amazingtrf","model":"SGH-S730G"},{"manufacturer":"Samsung","market_name":"","codename":"aruba3gchn","model":"GT-I8262D"},{"manufacturer":"Samsung","market_name":"","codename":"espressorfcmcc","model":"GT-P3108"},{"manufacturer":"Samsung","market_name":"","codename":"gd1ltektt","model":"EK-KC120K"},{"manufacturer":"Samsung","market_name":"","codename":"godivaltevzw","model":"SCH-I425"},{"manufacturer":"Samsung","market_name":"","codename":"ironcmcc","model":"GT-B9388"},{"manufacturer":"Samsung","market_name":"","codename":"m0grandectc","model":"SCH-W2013"},{"manufacturer":"Samsung","market_name":"","codename":"m0grandectc","model":"SCH-W9913"},{"manufacturer":"Samsung","market_name":"","codename":"p4noterfskt","model":"SHW-M480S"},{"manufacturer":"Samsung","market_name":"","codename":"stunnerltespr","model":"SPH-L500"},{"manufacturer":"Samsung","market_name":"","codename":"superiorchn","model":"GT-I9260"},{"manufacturer":"Samsung","market_name":"\\t Galaxy A7(2016)","codename":"a7xltechn","model":"SM-A710XZ"},{"manufacturer":"Samsung","market_name":"Absolute","codename":"GT-B9120","model":"GT-B9120"},{"manufacturer":"Samsung","market_name":"Acclaim","codename":"SCH-R880","model":"SCH-R880"},{"manufacturer":"Samsung","market_name":"Admire","codename":"SCH-R720","model":"SCH-R720"},{"manufacturer":"Samsung","market_name":"Amazing","codename":"amazingtrf","model":"SGH-S730M"},{"manufacturer":"Samsung","market_name":"Baffin","codename":"baffinltelgt","model":"SHV-E270L"},{"manufacturer":"Samsung","market_name":"Captivate Glide","codename":"SGH-I927","model":"SAMSUNG-SGH-I927"},{"manufacturer":"Samsung","market_name":"Captivate Glide","codename":"SGH-I927","model":"SGH-I927"},{"manufacturer":"Samsung","market_name":"China Telecom","codename":"kylevectc","model":"SCH-I699I"},{"manufacturer":"Samsung","market_name":"Chromebook 3","codename":"celes_cheets","model":"Samsung Chromebook 3"},{"manufacturer":"Samsung","market_name":"Chromebook Plus","codename":"kevin_cheets","model":"Samsung Chromebook Plus"},{"manufacturer":"Samsung","market_name":"Chromebook Plus","codename":"kevin_cheets","model":"kevin"},{"manufacturer":"Samsung","market_name":"Chromebook Pro","codename":"caroline_cheets","model":"Samsung Chromebook Pro"},{"manufacturer":"Samsung","market_name":"Chromebook Pro","codename":"caroline_cheets","model":"caroline"},{"manufacturer":"Samsung","market_name":"Conquer","codename":"SPH-D600","model":"SPH-D600"},{"manufacturer":"Samsung","market_name":"DoubleTime","codename":"SGH-I857","model":"SAMSUNG-SGH-I857"},{"manufacturer":"Samsung","market_name":"Droid Charge","codename":"SCH-I510","model":"SCH-I510"},{"manufacturer":"Samsung","market_name":"Elite","codename":"eliteltechn","model":"SM-G1600"},{"manufacturer":"Samsung","market_name":"Elite","codename":"elitexltechn","model":"SM-G1650"},{"manufacturer":"Samsung","market_name":"Europa","codename":"GT-I5500B","model":"GT-I5500B"},{"manufacturer":"Samsung","market_name":"Europa","codename":"GT-I5500L","model":"GT-I5500L"},{"manufacturer":"Samsung","market_name":"Europa","codename":"GT-I5500M","model":"GT-I5500M"},{"manufacturer":"Samsung","market_name":"Europa","codename":"GT-I5503T","model":"GT-I5503T"},{"manufacturer":"Samsung","market_name":"Europa","codename":"GT-I5510L","model":"GT-I5510L"},{"manufacturer":"Samsung","market_name":"Exhibit","codename":"SGH-T759","model":"SGH-T759"},{"manufacturer":"Samsung","market_name":"GALAXY Camera","codename":"gd1","model":"EK-GC100"},{"manufacturer":"Samsung","market_name":"Galaxy (China)","codename":"GT-B9062","model":"GT-B9062"},{"manufacturer":"Samsung","market_name":"Galaxy 070","codename":"hendrix","model":"YP-GI2"},{"manufacturer":"Samsung","market_name":"Galaxy A","codename":"archer","model":"SHW-M100S"},{"manufacturer":"Samsung","market_name":"Galaxy A","codename":"archer","model":"archer"},{"manufacturer":"Samsung","market_name":"Galaxy A3","codename":"a33g","model":"SM-A300H"},{"manufacturer":"Samsung","market_name":"Galaxy A3","codename":"a3lte","model":"SM-A300F"},{"manufacturer":"Samsung","market_name":"Galaxy A3","codename":"a3lte","model":"SM-A300M"},{"manufacturer":"Samsung","market_name":"Galaxy A3","codename":"a3lte","model":"SM-A300XZ"},{"manufacturer":"Samsung","market_name":"Galaxy A3","codename":"a3lte","model":"SM-A300YZ"},{"manufacturer":"Samsung","market_name":"Galaxy A3","codename":"a3ltechn","model":"SM-A3000"},{"manufacturer":"Samsung","market_name":"Galaxy A3","codename":"a3ltechn","model":"SM-A300X"},{"manufacturer":"Samsung","market_name":"Galaxy A3","codename":"a3ltectc","model":"SM-A3009"},{"manufacturer":"Samsung","market_name":"Galaxy A3","codename":"a3ltedd","model":"SM-A300G"},{"manufacturer":"Samsung","market_name":"Galaxy A3","codename":"a3lteslk","model":"SM-A300F"},{"manufacturer":"Samsung","market_name":"Galaxy A3","codename":"a3ltezh","model":"SM-A3000"},{"manufacturer":"Samsung","market_name":"Galaxy A3","codename":"a3ltezt","model":"SM-A300YZ"},{"manufacturer":"Samsung","market_name":"Galaxy A3","codename":"a3ulte","model":"SM-A300FU"},{"manufacturer":"Samsung","market_name":"Galaxy A3","codename":"a3ulte","model":"SM-A300XU"},{"manufacturer":"Samsung","market_name":"Galaxy A3","codename":"a3ulte","model":"SM-A300Y"},{"manufacturer":"Samsung","market_name":"Galaxy A3 (2017)","codename":"a3y17lte","model":"SM-A320Y"},{"manufacturer":"Samsung","market_name":"Galaxy A3(2016)","codename":"a3xelte","model":"SM-A310F"},{"manufacturer":"Samsung","market_name":"Galaxy A3(2016)","codename":"a3xelte","model":"SM-A310M"},{"manufacturer":"Samsung","market_name":"Galaxy A3(2016)","codename":"a3xelte","model":"SM-A310X"},{"manufacturer":"Samsung","market_name":"Galaxy A3(2016)","codename":"a3xelte","model":"SM-A310Y"},{"manufacturer":"Samsung","market_name":"Galaxy A3(2016)","codename":"a3xeltekx","model":"SM-A310N0"},{"manufacturer":"Samsung","market_name":"Galaxy A3(2017)","codename":"a3y17lte","model":"SM-A320F"},{"manufacturer":"Samsung","market_name":"Galaxy A3(2017)","codename":"a3y17lte","model":"SM-A320FL"},{"manufacturer":"Samsung","market_name":"Galaxy A3(2017)","codename":"a3y17lte","model":"SM-A320X"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a53g","model":"SM-A500H"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a5lte","model":"SM-A500F"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a5lte","model":"SM-A500G"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a5lte","model":"SM-A500M"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a5lte","model":"SM-A500XZ"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a5ltechn","model":"SM-A5000"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a5ltechn","model":"SM-A500X"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a5ltectc","model":"SM-A5009"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a5ltezh","model":"SM-A5000"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a5ltezt","model":"SM-A500YZ"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a5ulte","model":"SM-A500FU"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a5ulte","model":"SM-A500Y"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a5ultebmc","model":"SM-A500W"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a5ultektt","model":"SM-A500K"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a5ultelgt","model":"SM-A500L"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a5ulteskt","model":"SM-A500F1"},{"manufacturer":"Samsung","market_name":"Galaxy A5","codename":"a5ulteskt","model":"SM-A500S"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2016)","codename":"a5xelte","model":"SM-A510F"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2016)","codename":"a5xelte","model":"SM-A510M"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2016)","codename":"a5xelte","model":"SM-A510X"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2016)","codename":"a5xelte","model":"SM-A510Y"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2016)","codename":"a5xeltecmcc","model":"SM-A5108"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2016)","codename":"a5xeltektt","model":"SM-A510K"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2016)","codename":"a5xeltelgt","model":"SM-A510L"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2016)","codename":"a5xelteskt","model":"SM-A510S"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2016)","codename":"a5xeltextc","model":"SM-A510Y"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2016)","codename":"a5xltechn","model":"SM-A5100"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2016)","codename":"a5xltechn","model":"SM-A5100X"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2016)","codename":"a5xltechn","model":"SM-A510XZ"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2017)","codename":"a5y17lte","model":"SM-A520F"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2017)","codename":"a5y17lte","model":"SM-A520X"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2017)","codename":"a5y17ltecan","model":"SM-A520W"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2017)","codename":"a5y17ltektt","model":"SM-A520K"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2017)","codename":"a5y17ltelgt","model":"SM-A520L"},{"manufacturer":"Samsung","market_name":"Galaxy A5(2017)","codename":"a5y17lteskt","model":"SM-A520S"},{"manufacturer":"Samsung","market_name":"Galaxy A5x(2016)","codename":"a5xeltextc","model":"SM-A510Y"},{"manufacturer":"Samsung","market_name":"Galaxy A6","codename":"a6lte","model":"SM-A600F"},{"manufacturer":"Samsung","market_name":"Galaxy A6","codename":"a6lte","model":"SM-A600FN"},{"manufacturer":"Samsung","market_name":"Galaxy A6","codename":"a6lte","model":"SM-A600G"},{"manufacturer":"Samsung","market_name":"Galaxy A6","codename":"a6lte","model":"SM-A600GN"},{"manufacturer":"Samsung","market_name":"Galaxy A6 Plus","codename":"a6plte","model":"SM-A605F"},{"manufacturer":"Samsung","market_name":"Galaxy A6 Plus","codename":"a6plte","model":"SM-A605FN"},{"manufacturer":"Samsung","market_name":"Galaxy A6 Plus","codename":"a6plte","model":"SM-A605GN"},{"manufacturer":"Samsung","market_name":"Galaxy A6+","codename":"a6plte","model":"SM-A605FN"},{"manufacturer":"Samsung","market_name":"Galaxy A6+","codename":"a6plte","model":"SM-A605G"},{"manufacturer":"Samsung","market_name":"Galaxy A7","codename":"a73g","model":"SM-A700H"},{"manufacturer":"Samsung","market_name":"Galaxy A7","codename":"a7alte","model":"SM-A700F"},{"manufacturer":"Samsung","market_name":"Galaxy A7","codename":"a7lte","model":"SM-A700FD"},{"manufacturer":"Samsung","market_name":"Galaxy A7","codename":"a7lte","model":"SM-A700X"},{"manufacturer":"Samsung","market_name":"Galaxy A7","codename":"a7ltechn","model":"SM-A7000"},{"manufacturer":"Samsung","market_name":"Galaxy A7","codename":"a7ltechn","model":"SM-A700YD"},{"manufacturer":"Samsung","market_name":"Galaxy A7","codename":"a7ltectc","model":"SM-A7009"},{"manufacturer":"Samsung","market_name":"Galaxy A7","codename":"a7ltektt","model":"SM-A700K"},{"manufacturer":"Samsung","market_name":"Galaxy A7","codename":"a7ltelgt","model":"SM-A700L"},{"manufacturer":"Samsung","market_name":"Galaxy A7","codename":"a7lteskt","model":"SM-A700S"},{"manufacturer":"Samsung","market_name":"Galaxy A7(2016)","codename":"a7xelte","model":"SM-A710F"},{"manufacturer":"Samsung","market_name":"Galaxy A7(2016)","codename":"a7xelte","model":"SM-A710M"},{"manufacturer":"Samsung","market_name":"Galaxy A7(2016)","codename":"a7xelte","model":"SM-A710X"},{"manufacturer":"Samsung","market_name":"Galaxy A7(2016)","codename":"a7xeltecmcc","model":"SM-A7108"},{"manufacturer":"Samsung","market_name":"Galaxy A7(2016)","codename":"a7xeltektt","model":"SM-A710K"},{"manufacturer":"Samsung","market_name":"Galaxy A7(2016)","codename":"a7xeltelgt","model":"SM-A710L"},{"manufacturer":"Samsung","market_name":"Galaxy A7(2016)","codename":"a7xelteskt","model":"SM-A710S"},{"manufacturer":"Samsung","market_name":"Galaxy A7(2016)","codename":"a7xeltextc","model":"SM-A710Y"},{"manufacturer":"Samsung","market_name":"Galaxy A7(2016)","codename":"a7xltechn","model":"SM-A7100"},{"manufacturer":"Samsung","market_name":"Galaxy A7(2017)","codename":"a7y17lte","model":"SM-A720F"},{"manufacturer":"Samsung","market_name":"Galaxy A7(2017)","codename":"a7y17lteskt","model":"SM-A720S"},{"manufacturer":"Samsung","market_name":"Galaxy A8","codename":"SCV32","model":"SCV32"},{"manufacturer":"Samsung","market_name":"Galaxy A8","codename":"a8elte","model":"SM-A800F"},{"manufacturer":"Samsung","market_name":"Galaxy A8","codename":"a8elte","model":"SM-A800YZ"},{"manufacturer":"Samsung","market_name":"Galaxy A8","codename":"a8elteskt","model":"SM-A800S"},{"manufacturer":"Samsung","market_name":"Galaxy A8","codename":"a8hplte","model":"SM-A800I"},{"manufacturer":"Samsung","market_name":"Galaxy A8","codename":"a8hplte","model":"SM-A800IZ"},{"manufacturer":"Samsung","market_name":"Galaxy A8","codename":"a8ltechn","model":"SM-A8000"},{"manufacturer":"Samsung","market_name":"Galaxy A8","codename":"a8ltechn","model":"SM-A800X"},{"manufacturer":"Samsung","market_name":"Galaxy A8(2016)","codename":"a8xelte","model":"SM-A810F"},{"manufacturer":"Samsung","market_name":"Galaxy A8(2016)","codename":"a8xelte","model":"SM-A810YZ"},{"manufacturer":"Samsung","market_name":"Galaxy A8(2016)","codename":"a8xelteskt","model":"SM-A810S"},{"manufacturer":"Samsung","market_name":"Galaxy A8(2018)","codename":"jackpotlte","model":"SM-A530F"},{"manufacturer":"Samsung","market_name":"Galaxy A8(2018)","codename":"jackpotlte","model":"SM-A530X"},{"manufacturer":"Samsung","market_name":"Galaxy A8(2018)","codename":"jackpotltecan","model":"SM-A530W"},{"manufacturer":"Samsung","market_name":"Galaxy A8(2018)","codename":"jackpotlteks","model":"SM-A530N"},{"manufacturer":"Samsung","market_name":"Galaxy A8+(2018)","codename":"jackpot2lte","model":"SM-A730F"},{"manufacturer":"Samsung","market_name":"Galaxy A8+(2018)","codename":"jackpot2lte","model":"SM-A730X"},{"manufacturer":"Samsung","market_name":"Galaxy A9 Pro","codename":"a9xproltechn","model":"SM-A9100"},{"manufacturer":"Samsung","market_name":"Galaxy A9 Pro","codename":"a9xproltesea","model":"SM-A910F"},{"manufacturer":"Samsung","market_name":"Galaxy A9 Star Lite","codename":"a6pltechn","model":"SM-A6050"},{"manufacturer":"Samsung","market_name":"Galaxy A9 Star Lite","codename":"a6pltechn","model":"SM-A605XC"},{"manufacturer":"Samsung","market_name":"Galaxy A9 Star Lite","codename":"a6pltecmcc","model":"SM-A6058"},{"manufacturer":"Samsung","market_name":"Galaxy A9(2016)","codename":"a9xltechn","model":"SM-A9000"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"GT-S5830","model":"GT-S5830"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"GT-S5830B","model":"GT-S5830B"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"GT-S5830C","model":"GT-S5830C"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"GT-S5830D","model":"GT-S5830D"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"GT-S5830F","model":"GT-S5830F"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"GT-S5830G","model":"GT-S5830G"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"GT-S5830L","model":"GT-S5830L"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"GT-S5830M","model":"GT-S5830M"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"GT-S5830T","model":"GT-S5830T"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"GT-S5830i","model":"GT-S5830i"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"GT-S5831i","model":"GT-S5831i"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"GT-S5838","model":"GT-S5838"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"GT-S5839i","model":"GT-S5839i"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"GT-S6358","model":"GT-S6358"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"SCH-I619","model":"SCH-I619"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"SHW-M240S","model":"SHW-M240S"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"heat3gou","model":"SM-G310R5"},{"manufacturer":"Samsung","market_name":"Galaxy Ace","codename":"heatlte","model":"SM-G357M"},{"manufacturer":"Samsung","market_name":"Galaxy Ace 4","codename":"vivaltods5m","model":"SM-G313HU"},{"manufacturer":"Samsung","market_name":"Galaxy Ace 4","codename":"vivaltods5m","model":"SM-G313HY"},{"manufacturer":"Samsung","market_name":"Galaxy Ace 4","codename":"vivaltods5m","model":"SM-G313M"},{"manufacturer":"Samsung","market_name":"Galaxy Ace 4","codename":"vivaltods5m","model":"SM-G313MY"},{"manufacturer":"Samsung","market_name":"Galaxy Ace 4 Lite","codename":"vivalto3g","model":"SM-G313U"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Advance","codename":"GT-S6800","model":"GT-S6800"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Duos","codename":"GT-S6352","model":"GT-S6352"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Duos","codename":"GT-S6802","model":"GT-S6802"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Duos","codename":"GT-S6802B","model":"GT-S6802B"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Duos","codename":"SCH-I579","model":"SCH-i579"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Duos","codename":"SCH-I589","model":"SCH-I589"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Duos","codename":"SCH-I589","model":"SCH-i589"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Duos","codename":"SCH-i579","model":"SCH-i579"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Duos","codename":"SCH-i589","model":"SCH-i589"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Plus","codename":"GT-S7500","model":"GT-S7500"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Plus","codename":"GT-S7500L","model":"GT-S7500L"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Plus","codename":"GT-S7500T","model":"GT-S7500T"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Plus","codename":"GT-S7500W","model":"GT-S7500W"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Plus","codename":"GT-S7508","model":"GT-S7508"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Q","codename":"SGH-I827D","model":"SGH-I827D"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Style","codename":"heat3gtfnvzw","model":"SM-S765C"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Style","codename":"heat3gtfnvzw","model":"SM-S766C"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Style","codename":"heatnfc3g","model":"SM-G310HN"},{"manufacturer":"Samsung","market_name":"Galaxy Ace Style","codename":"heatqlte","model":"SM-G357FZ"},{"manufacturer":"Samsung","market_name":"Galaxy Ace2","codename":"GT-I8160","model":"GT-I8160"},{"manufacturer":"Samsung","market_name":"Galaxy Ace2","codename":"GT-I8160L","model":"GT-I8160L"},{"manufacturer":"Samsung","market_name":"Galaxy Ace2","codename":"GT-I8160P","model":"GT-I8160P"},{"manufacturer":"Samsung","market_name":"Galaxy Ace2 X","codename":"kylessopen","model":"GT-S7560"},{"manufacturer":"Samsung","market_name":"Galaxy Ace2 X","codename":"kylessopen","model":"GT-S7560M"},{"manufacturer":"Samsung","market_name":"Galaxy Ace3","codename":"logan","model":"GT-S7270"},{"manufacturer":"Samsung","market_name":"Galaxy Ace3","codename":"logan","model":"GT-S7270L"},{"manufacturer":"Samsung","market_name":"Galaxy Ace3","codename":"logan","model":"SCH-I679"},{"manufacturer":"Samsung","market_name":"Galaxy Ace3","codename":"logan3gcmcc","model":"GT-S7278"},{"manufacturer":"Samsung","market_name":"Galaxy Ace3","codename":"logands","model":"GT-S7272"},{"manufacturer":"Samsung","market_name":"Galaxy Ace3","codename":"loganlte","model":"GT-S7275"},{"manufacturer":"Samsung","market_name":"Galaxy Ace3","codename":"loganrelte","model":"GT-S7275B"},{"manufacturer":"Samsung","market_name":"Galaxy Ace3","codename":"loganrelte","model":"GT-S7275R"},{"manufacturer":"Samsung","market_name":"Galaxy Ace3","codename":"loganrelte","model":"GT-S7275T"},{"manufacturer":"Samsung","market_name":"Galaxy Ace3","codename":"loganrelte","model":"GT-S7275Y"},{"manufacturer":"Samsung","market_name":"Galaxy Ace3 Duos","codename":"loganlite3g","model":"GT-S7272C"},{"manufacturer":"Samsung","market_name":"Galaxy Ace3 Duos","codename":"loganu3gcmcc","model":"GT-S7278U"},{"manufacturer":"Samsung","market_name":"Galaxy Ace3 Duos TV","codename":"logandsdtv","model":"GT-S7273T"},{"manufacturer":"Samsung","market_name":"Galaxy Ace4","codename":"vivalto3g","model":"SM-G313ML"},{"manufacturer":"Samsung","market_name":"Galaxy Ace4","codename":"vivalto3mve3g","model":"SM-G316H"},{"manufacturer":"Samsung","market_name":"Galaxy Ace4","codename":"vivalto5mve3g","model":"SM-G316HU"},{"manufacturer":"Samsung","market_name":"Galaxy Ace4","codename":"vivalto5mve3g","model":"SM-G316M"},{"manufacturer":"Samsung","market_name":"Galaxy Ace4","codename":"vivalto5mve3g","model":"SM-G316MY"},{"manufacturer":"Samsung","market_name":"Galaxy Ace4","codename":"vivaltolte","model":"SM-G313F"},{"manufacturer":"Samsung","market_name":"Galaxy Ace4","codename":"vivaltolte","model":"SM-G313MU"},{"manufacturer":"Samsung","market_name":"Galaxy Ace4","codename":"vivaltonfc3g","model":"SM-G313HN"},{"manufacturer":"Samsung","market_name":"Galaxy Ace4 Lite","codename":"vivalto","model":"SM-G3139D"},{"manufacturer":"Samsung","market_name":"Galaxy Ace4 Lite","codename":"vivalto3g","model":"SM-G313H"},{"manufacturer":"Samsung","market_name":"Galaxy Ace4 Lite","codename":"vivalto3mve3gltn","model":"SM-G316U"},{"manufacturer":"Samsung","market_name":"Galaxy Ace4 Lite","codename":"vivalto3mveml3g","model":"SM-G318H"},{"manufacturer":"Samsung","market_name":"Galaxy Ace4 Lite","codename":"vivalto3mveml3g","model":"SM-G318ML"},{"manufacturer":"Samsung","market_name":"Galaxy Ace4 Lite","codename":"vivalto3mveml3gsea","model":"SM-G318HZ"},{"manufacturer":"Samsung","market_name":"Galaxy Ace4 Lite","codename":"vivalto3mveml3gsea","model":"SM-G318MZ"},{"manufacturer":"Samsung","market_name":"Galaxy Ace4 Neo","codename":"vivalto3mve3gltn","model":"SM-G316ML"},{"manufacturer":"Samsung","market_name":"Galaxy Active neo","codename":"SC-01H","model":"SC-01H"},{"manufacturer":"Samsung","market_name":"Galaxy Admire","codename":"SCH-R820","model":"SCH-R820"},{"manufacturer":"Samsung","market_name":"Galaxy Admire 2","codename":"goghcri","model":"SCH-R830C"},{"manufacturer":"Samsung","market_name":"Galaxy Alpha","codename":"slte","model":"SM-G850F"},{"manufacturer":"Samsung","market_name":"Galaxy Alpha","codename":"slte","model":"SM-G850FQ"},{"manufacturer":"Samsung","market_name":"Galaxy Alpha","codename":"slte","model":"SM-G850M"},{"manufacturer":"Samsung","market_name":"Galaxy Alpha","codename":"slte","model":"SM-G850X"},{"manufacturer":"Samsung","market_name":"Galaxy Alpha","codename":"slte","model":"SM-G850Y"},{"manufacturer":"Samsung","market_name":"Galaxy Alpha","codename":"slteatt","model":"SAMSUNG-SM-G850A"},{"manufacturer":"Samsung","market_name":"Galaxy Alpha","codename":"sltecan","model":"SM-G850W"},{"manufacturer":"Samsung","market_name":"Galaxy Alpha","codename":"sltechn","model":"SM-G8508S"},{"manufacturer":"Samsung","market_name":"Galaxy Alpha","codename":"sltektt","model":"SM-G850K"},{"manufacturer":"Samsung","market_name":"Galaxy Alpha","codename":"sltelgt","model":"SM-G850L"},{"manufacturer":"Samsung","market_name":"Galaxy Alpha","codename":"slteskt","model":"SM-G850S"},{"manufacturer":"Samsung","market_name":"Galaxy Amp","codename":"kyleatt","model":"SAMSUNG-SGH-I407"},{"manufacturer":"Samsung","market_name":"Galaxy Apollo","codename":"GT-I5800","model":"GT-I5800"},{"manufacturer":"Samsung","market_name":"Galaxy Apollo","codename":"GT-I5800","model":"GT-I5800L"},{"manufacturer":"Samsung","market_name":"Galaxy Apollo","codename":"GT-I5800D","model":"GT-I5800D"},{"manufacturer":"Samsung","market_name":"Galaxy Apollo","codename":"GT-I5801","model":"GT-I5801"},{"manufacturer":"Samsung","market_name":"Galaxy Appeal","codename":"SGH-I827","model":"SAMSUNG-SGH-I827"},{"manufacturer":"Samsung","market_name":"Galaxy Attain","codename":"SCH-R920","model":"SCH-R920"},{"manufacturer":"Samsung","market_name":"Galaxy Avant","codename":"afyonltetmo","model":"SM-G386T"},{"manufacturer":"Samsung","market_name":"Galaxy Axiom","codename":"infiniteusc","model":"SCH-R830"},{"manufacturer":"Samsung","market_name":"Galaxy Beam","codename":"GT-I8250","model":"GT-I8250"},{"manufacturer":"Samsung","market_name":"Galaxy Beam","codename":"GT-I8530","model":"GT-I8530"},{"manufacturer":"Samsung","market_name":"Galaxy C5","codename":"c5ltechn","model":"SM-C5000"},{"manufacturer":"Samsung","market_name":"Galaxy C5","codename":"c5ltechn","model":"SM-C500X"},{"manufacturer":"Samsung","market_name":"Galaxy C5","codename":"c5pltechn","model":"SM-C5000"},{"manufacturer":"Samsung","market_name":"Galaxy C5 Pro","codename":"c5proltechn","model":"SM-C5010"},{"manufacturer":"Samsung","market_name":"Galaxy C5 Pro","codename":"c5proltechn","model":"SM-C5018"},{"manufacturer":"Samsung","market_name":"Galaxy C7","codename":"c7ltechn","model":"SM-C7000"},{"manufacturer":"Samsung","market_name":"Galaxy C7","codename":"c7ltechn","model":"SM-C700X"},{"manufacturer":"Samsung","market_name":"Galaxy C7","codename":"c7proltechn","model":"SM-C701X"},{"manufacturer":"Samsung","market_name":"Galaxy C7 Pro","codename":"c7prolte","model":"SM-C701F"},{"manufacturer":"Samsung","market_name":"Galaxy C7 Pro","codename":"c7proltechn","model":"SM-C7010"},{"manufacturer":"Samsung","market_name":"Galaxy C7 Pro","codename":"c7proltechn","model":"SM-C7018"},{"manufacturer":"Samsung","market_name":"Galaxy C8","codename":"jadeltechn","model":"SM-C7100"},{"manufacturer":"Samsung","market_name":"Galaxy C8","codename":"jadeltechn","model":"SM-C710X"},{"manufacturer":"Samsung","market_name":"Galaxy C8","codename":"jadeltecmcc","model":"SM-C7108"},{"manufacturer":"Samsung","market_name":"Galaxy C9 Pro","codename":"c9lte","model":"SM-C900F"},{"manufacturer":"Samsung","market_name":"Galaxy C9 Pro","codename":"c9lte","model":"SM-C900Y"},{"manufacturer":"Samsung","market_name":"Galaxy C9 Pro","codename":"c9ltechn","model":"SM-C9000"},{"manufacturer":"Samsung","market_name":"Galaxy C9 Pro","codename":"c9ltechn","model":"SM-C9008"},{"manufacturer":"Samsung","market_name":"Galaxy C9 Pro","codename":"c9ltechn","model":"SM-C900X"},{"manufacturer":"Samsung","market_name":"Galaxy Camera","codename":"gd1","model":"EK-GC100"},{"manufacturer":"Samsung","market_name":"Galaxy Camera","codename":"gd1att","model":"SAMSUNG-EK-GC100"},{"manufacturer":"Samsung","market_name":"Galaxy Camera","codename":"gd1can","model":"EK-GC100"},{"manufacturer":"Samsung","market_name":"Galaxy Camera","codename":"gd1ktt","model":"EK-KC100K"},{"manufacturer":"Samsung","market_name":"Galaxy Camera","codename":"gd1ltelgt","model":"EK-KC120L"},{"manufacturer":"Samsung","market_name":"Galaxy Camera","codename":"gd1lteskt","model":"EK-KC120S"},{"manufacturer":"Samsung","market_name":"Galaxy Camera","codename":"gd1ltevzw","model":"EK-GC120"},{"manufacturer":"Samsung","market_name":"Galaxy Camera","codename":"gd1skt","model":"EK-KC100S"},{"manufacturer":"Samsung","market_name":"Galaxy Camera","codename":"gd1wifi","model":"EK-GC110"},{"manufacturer":"Samsung","market_name":"Galaxy Camera","codename":"gd1wifiany","model":"EK-GC110"},{"manufacturer":"Samsung","market_name":"Galaxy Camera","codename":"u0lte","model":"EK-GN100"},{"manufacturer":"Samsung","market_name":"Galaxy Camera","codename":"u0lte","model":"EK-GN120"},{"manufacturer":"Samsung","market_name":"Galaxy Camera 2","codename":"sf2wifi","model":"EK-GC200"},{"manufacturer":"Samsung","market_name":"Galaxy Centura","codename":"amazing3gtrf","model":"SCH-S738C"},{"manufacturer":"Samsung","market_name":"Galaxy Chat","codename":"zanin","model":"GT-B5330"},{"manufacturer":"Samsung","market_name":"Galaxy Chat","codename":"zanin","model":"GT-B5330B"},{"manufacturer":"Samsung","market_name":"Galaxy Chat","codename":"zanin","model":"GT-B5330L"},{"manufacturer":"Samsung","market_name":"Galaxy Core","codename":"afyonlteMetroPCS","model":"SM-G386T1"},{"manufacturer":"Samsung","market_name":"Galaxy Core","codename":"afyonltecan","model":"SM-G386W"},{"manufacturer":"Samsung","market_name":"Galaxy Core","codename":"arubaslim","model":"GT-I8262"},{"manufacturer":"Samsung","market_name":"Galaxy Core","codename":"arubaslimss","model":"GT-I8260"},{"manufacturer":"Samsung","market_name":"Galaxy Core","codename":"arubaslimss","model":"GT-I8260L"},{"manufacturer":"Samsung","market_name":"Galaxy Core 2","codename":"kanas","model":"SM-G355H"},{"manufacturer":"Samsung","market_name":"Galaxy Core Advance","codename":"cane3g","model":"GT-I8580"},{"manufacturer":"Samsung","market_name":"Galaxy Core Advance","codename":"cane3gskt","model":"SHW-M570S"},{"manufacturer":"Samsung","market_name":"Galaxy Core LTE","codename":"afyonlte","model":"SM-G386F"},{"manufacturer":"Samsung","market_name":"Galaxy Core LTE","codename":"cs03lte","model":"SM-G3518"},{"manufacturer":"Samsung","market_name":"Galaxy Core Lite","codename":"victorlte","model":"SM-G3586V"},{"manufacturer":"Samsung","market_name":"Galaxy Core Lite","codename":"victorlte","model":"SM-G3589W"},{"manufacturer":"Samsung","market_name":"Galaxy Core Max","codename":"kleoslte","model":"SM-G5108"},{"manufacturer":"Samsung","market_name":"Galaxy Core Max Duos","codename":"kleoslte","model":"SM-G5108Q"},{"manufacturer":"Samsung","market_name":"Galaxy Core Plus","codename":"cs02","model":"SM-G350"},{"manufacturer":"Samsung","market_name":"Galaxy Core Plus","codename":"cs023g","model":"SM-G3502"},{"manufacturer":"Samsung","market_name":"Galaxy Core Plus","codename":"cs02ve3g","model":"SM-G3502L"},{"manufacturer":"Samsung","market_name":"Galaxy Core Plus","codename":"cs02ve3gdtv","model":"SM-G3502T"},{"manufacturer":"Samsung","market_name":"Galaxy Core Plus","codename":"cs02ve3gss","model":"SM-G350L"},{"manufacturer":"Samsung","market_name":"Galaxy Core Plus","codename":"cs02ve3gss","model":"SM-G350M"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"core33g","model":"SM-G360H"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"core33g","model":"SM-G360HU"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"coreprimelte","model":"SM-G360F"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"coreprimelte","model":"SM-G360FY"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"coreprimelte","model":"SM-G360M"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"coreprimelteaio","model":"SAMSUNG-SM-G360AZ"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"coreprimeltelra","model":"SM-G360R6"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"coreprimeltespr","model":"SM-G360P"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"coreprimeltetfnvzw","model":"SM-S820L"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"coreprimeltevzw","model":"SM-G360V"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"coreprimeve3g","model":"SM-G361H"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"coreprimeve3g","model":"SM-G361HU"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"coreprimevelte","model":"SM-G361F"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"coreprimevelte","model":"SM-G361M"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"cprimeltemtr","model":"SM-G360T1"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"cprimeltetmo","model":"SM-G360T"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"rossalte","model":"SM-G3606"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"rossalte","model":"SM-G3608"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"rossaltectc","model":"SM-G3609"},{"manufacturer":"Samsung","market_name":"Galaxy Core Prime","codename":"rossaltexsa","model":"SM-G360GY"},{"manufacturer":"Samsung","market_name":"Galaxy Core Safe","codename":"arubaslimss","model":"GT-I8260E"},{"manufacturer":"Samsung","market_name":"Galaxy Core Safe","codename":"arubaslimss","model":"SHW-M580D"},{"manufacturer":"Samsung","market_name":"Galaxy Core Safe","codename":"arubaslimss","model":"SHW-M585D"},{"manufacturer":"Samsung","market_name":"Galaxy Core2","codename":"kanas","model":"SM-G355H"},{"manufacturer":"Samsung","market_name":"Galaxy Core2","codename":"kanas","model":"SM-G355HQ"},{"manufacturer":"Samsung","market_name":"Galaxy Core2","codename":"kanas","model":"SM-G355M"},{"manufacturer":"Samsung","market_name":"Galaxy Core2","codename":"kanas3g","model":"SM-G3556D"},{"manufacturer":"Samsung","market_name":"Galaxy Core2","codename":"kanas3gcmcc","model":"SM-G3558"},{"manufacturer":"Samsung","market_name":"Galaxy Core2","codename":"kanas3gctc","model":"SM-G3559"},{"manufacturer":"Samsung","market_name":"Galaxy Core2","codename":"kanas3gnfc","model":"SM-G355HN"},{"manufacturer":"Samsung","market_name":"Galaxy Discover","codename":"amazing3gcri","model":"SCH-R740C"},{"manufacturer":"Samsung","market_name":"Galaxy Discover","codename":"amazingtrfcd","model":"SCH-S735C"},{"manufacturer":"Samsung","market_name":"Galaxy Duos","codename":"aruba3gcmcc","model":"GT-I8268"},{"manufacturer":"Samsung","market_name":"Galaxy E5","codename":"e53g","model":"SM-E500H"},{"manufacturer":"Samsung","market_name":"Galaxy E5","codename":"e5lte","model":"SM-E500F"},{"manufacturer":"Samsung","market_name":"Galaxy E5","codename":"e5lte","model":"SM-E500M"},{"manufacturer":"Samsung","market_name":"Galaxy E5","codename":"e5ltetfnvzw","model":"SM-S978L"},{"manufacturer":"Samsung","market_name":"Galaxy E5","codename":"e5ltetw","model":"SM-E500YZ"},{"manufacturer":"Samsung","market_name":"Galaxy E7","codename":"e73g","model":"SM-E700H"},{"manufacturer":"Samsung","market_name":"Galaxy E7","codename":"e7lte","model":"SM-E700F"},{"manufacturer":"Samsung","market_name":"Galaxy E7","codename":"e7lte","model":"SM-E700M"},{"manufacturer":"Samsung","market_name":"Galaxy E7","codename":"e7ltechn","model":"SM-E7000"},{"manufacturer":"Samsung","market_name":"Galaxy E7","codename":"e7ltectc","model":"SM-E7009"},{"manufacturer":"Samsung","market_name":"Galaxy E7","codename":"e7ltehktw","model":"SM-E7000"},{"manufacturer":"Samsung","market_name":"Galaxy Elite","codename":"elite3gkx","model":"SM-G165N"},{"manufacturer":"Samsung","market_name":"Galaxy Elite","codename":"eliteltekx","model":"SM-G160N"},{"manufacturer":"Samsung","market_name":"Galaxy Europa","codename":"GT-I5500","model":"GT-I5500"},{"manufacturer":"Samsung","market_name":"Galaxy Europa","codename":"GT-I5503","model":"GT-I5503"},{"manufacturer":"Samsung","market_name":"Galaxy Europa","codename":"GT-I5508","model":"GT-I5508"},{"manufacturer":"Samsung","market_name":"Galaxy Europa","codename":"GT-I5510","model":"GT-I5510"},{"manufacturer":"Samsung","market_name":"Galaxy Exhibit","codename":"codinaMetroPCS","model":"SGH-T599N"},{"manufacturer":"Samsung","market_name":"Galaxy Exhibit","codename":"codinatmo","model":"SGH-T599"},{"manufacturer":"Samsung","market_name":"Galaxy Exhibit","codename":"codinavid","model":"SGH-T599V"},{"manufacturer":"Samsung","market_name":"Galaxy Exhibit2","codename":"SGH-T679","model":"SGH-T679"},{"manufacturer":"Samsung","market_name":"Galaxy Exhilarate","codename":"SGH-I577","model":"SAMSUNG-SGH-I577"},{"manufacturer":"Samsung","market_name":"Galaxy Express","codename":"expressatt","model":"SAMSUNG-SGH-I437"},{"manufacturer":"Samsung","market_name":"Galaxy Express","codename":"expressatt","model":"SAMSUNG-SGH-I437P"},{"manufacturer":"Samsung","market_name":"Galaxy Express","codename":"expresslte","model":"GT-I8730"},{"manufacturer":"Samsung","market_name":"Galaxy Express","codename":"expresslte","model":"GT-I8730T"},{"manufacturer":"Samsung","market_name":"Galaxy Express","codename":"expressziglteatt","model":"SAMSUNG-SGH-I437Z"},{"manufacturer":"Samsung","market_name":"Galaxy Express2","codename":"wilcoxlte","model":"SM-G3815"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"SCH-I629","model":"SCH-I629"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"nevis","model":"GT-S6810"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"nevis","model":"GT-S6810B"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"nevis","model":"GT-S6810E"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"nevis","model":"GT-S6810L"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"nevis3g","model":"GT-S6812i"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"nevis3gcmcc","model":"GT-S6818"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"nevis3gcmcc","model":"GT-S6818V"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"nevisds","model":"GT-S6812"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"nevisds","model":"GT-S6812B"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"nevisnvess","model":"GT-S6790N"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"nevisp","model":"GT-S6810M"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"nevisp","model":"GT-S6810P"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"nevisvess","model":"GT-S6790"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"nevisvess","model":"GT-S6790E"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"nevisvess","model":"GT-S6790L"},{"manufacturer":"Samsung","market_name":"Galaxy Fame","codename":"nevisw","model":"GT-S6812C"},{"manufacturer":"Samsung","market_name":"Galaxy Fame Lite Duos","codename":"nevisw","model":"GT-S6792L"},{"manufacturer":"Samsung","market_name":"Galaxy Feel","codename":"SC-04J","model":"SC-04J"},{"manufacturer":"Samsung","market_name":"Galaxy Fit","codename":"GT-S5670","model":"GT-S5670"},{"manufacturer":"Samsung","market_name":"Galaxy Fit","codename":"GT-S5670B","model":"GT-S5670B"},{"manufacturer":"Samsung","market_name":"Galaxy Fit","codename":"GT-S5670L","model":"GT-S5670L"},{"manufacturer":"Samsung","market_name":"Galaxy Folder","codename":"novel3gskt","model":"SM-G155S"},{"manufacturer":"Samsung","market_name":"Galaxy Folder","codename":"novelltektt","model":"SM-G150NK"},{"manufacturer":"Samsung","market_name":"Galaxy Folder","codename":"novelltekx","model":"SM-G150N0"},{"manufacturer":"Samsung","market_name":"Galaxy Folder","codename":"novelltelgt","model":"SM-G150NL"},{"manufacturer":"Samsung","market_name":"Galaxy Folder","codename":"novellteskt","model":"SM-G150NS"},{"manufacturer":"Samsung","market_name":"Galaxy Folder2","codename":"elitexlte","model":"SM-G1650"},{"manufacturer":"Samsung","market_name":"Galaxy Fresh","codename":"kylevess","model":"GT-S7390"},{"manufacturer":"Samsung","market_name":"Galaxy Fresh","codename":"kylevess","model":"GT-S7390E"},{"manufacturer":"Samsung","market_name":"Galaxy Fresh","codename":"kylevess","model":"GT-S7390G"},{"manufacturer":"Samsung","market_name":"Galaxy Gio","codename":"GT-S5660","model":"GT-S5660"},{"manufacturer":"Samsung","market_name":"Galaxy Gio","codename":"GT-S5660B","model":"GT-S5660B"},{"manufacturer":"Samsung","market_name":"Galaxy Gio","codename":"GT-S5660L","model":"GT-S5660L"},{"manufacturer":"Samsung","market_name":"Galaxy Gio","codename":"GT-S5660M","model":"GT-S5660M"},{"manufacturer":"Samsung","market_name":"Galaxy Gio","codename":"GT-S5660V","model":"GT-S5660V"},{"manufacturer":"Samsung","market_name":"Galaxy Gio","codename":"SCH-i569","model":"SCH-i569"},{"manufacturer":"Samsung","market_name":"Galaxy Gio","codename":"SHW-M290K","model":"SHW-M290K"},{"manufacturer":"Samsung","market_name":"Galaxy Gio","codename":"SHW-M290S","model":"SHW-M290S"},{"manufacturer":"Samsung","market_name":"Galaxy Go Prime","codename":"grandprimelteatt","model":"SAMSUNG-SM-G530A"},{"manufacturer":"Samsung","market_name":"Galaxy Golden","codename":"ks02lte","model":"GT-I9230"},{"manufacturer":"Samsung","market_name":"Galaxy Golden","codename":"ks02lte","model":"GT-I9235"},{"manufacturer":"Samsung","market_name":"Galaxy Golden","codename":"ks02ltektt","model":"SHV-E400K"},{"manufacturer":"Samsung","market_name":"Galaxy Golden","codename":"ks02lteskt","model":"SHV-E400S"},{"manufacturer":"Samsung","market_name":"Galaxy Golden 2","codename":"pateklte","model":"SM-W2015"},{"manufacturer":"Samsung","market_name":"Galaxy Grand","codename":"baffin3gduosctc","model":"SCH-I879"},{"manufacturer":"Samsung","market_name":"Galaxy Grand","codename":"baffincmcc","model":"GT-I9128"},{"manufacturer":"Samsung","market_name":"Galaxy Grand","codename":"baffincmcc","model":"GT-I9128V"},{"manufacturer":"Samsung","market_name":"Galaxy Grand","codename":"baffinltektt","model":"SHV-E270K"},{"manufacturer":"Samsung","market_name":"Galaxy Grand","codename":"baffinlteskt","model":"SHV-E270S"},{"manufacturer":"Samsung","market_name":"Galaxy Grand","codename":"baffinrd","model":"GT-I9118"},{"manufacturer":"Samsung","market_name":"Galaxy Grand","codename":"baffinss","model":"GT-I9080E"},{"manufacturer":"Samsung","market_name":"Galaxy Grand","codename":"baffinss","model":"GT-I9080L"},{"manufacturer":"Samsung","market_name":"Galaxy Grand","codename":"baffinvektt","model":"SHV-E275K"},{"manufacturer":"Samsung","market_name":"Galaxy Grand","codename":"baffinveskt","model":"SHV-E275S"},{"manufacturer":"Samsung","market_name":"Galaxy Grand","codename":"baffinvetd3g","model":"GT-I9128E"},{"manufacturer":"Samsung","market_name":"Galaxy Grand","codename":"baffinvetd3g","model":"GT-I9128I"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Duos","codename":"baffin","model":"GT-I9082"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Duos","codename":"baffin","model":"GT-I9082L"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Max","codename":"grandmax3g","model":"SM-G7202"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Max","codename":"grandmaxltechn","model":"SM-G7200"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Max","codename":"grandmaxltechn","model":"SM-G720AX"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Neo","codename":"baffinlite","model":"GT-I9060"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Neo","codename":"baffinlite","model":"GT-I9060L"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Neo","codename":"baffinlite","model":"GT-I9082C"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Neo","codename":"baffinlitedtv","model":"GT-I9063T"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Neo","codename":"baffinq3g","model":"GT-I9168"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Neo","codename":"baffinq3g","model":"GT-I9168I"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Neo Plus","codename":"grandneove3g","model":"GT-I9060C"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Neo Plus","codename":"grandneove3g","model":"GT-I9060I"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Neo Plus","codename":"grandneove3g","model":"GT-I9060M"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Neo+","codename":"baffinq3gduosctc","model":"SCH-I879E"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"fortuna3g","model":"SM-G530H"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"fortuna3gdtv","model":"SM-G530BT"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"fortunalte","model":"SM-G5306W"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"fortunalte","model":"SM-G5308W"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"fortunalte","model":"SM-G530F"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"fortunalte","model":"SM-G530M"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"fortunaltectc","model":"SM-G5309W"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"fortunaltezh","model":"SM-G5308W"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"fortunaltezt","model":"SM-G530MU"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"fortunaltezt","model":"SM-G530Y"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"fortunave3g","model":"SM-G530H"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"gprimelteacg","model":"SM-G530R7"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"gprimelteacg","model":"gprimelteacg"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"gprimeltecan","model":"SM-G530W"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"gprimeltemtr","model":"SM-G530T1"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"gprimeltespr","model":"SM-G530P"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"gprimeltetfnvzw","model":"SM-S920L"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"gprimeltetmo","model":"SM-G530T"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"gprimelteusc","model":"SM-G530R4"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"grandprimelte","model":"SM-G530FZ"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"grandprimelteaio","model":"SAMSUNG-SM-G530AZ"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"grandprimeve3g","model":"SM-G531H"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"grandprimeve3gdtv","model":"SM-G531BT"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"grandprimevelte","model":"SM-G531F"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"grandprimevelteltn","model":"SM-G531M"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime","codename":"grandprimeveltezt","model":"SM-G531Y"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime Plus","codename":"grandpplte","model":"SM-G532F"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime Plus","codename":"grandpplte","model":"SM-G532G"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime Plus","codename":"grandppltedtv","model":"SM-G532MT"},{"manufacturer":"Samsung","market_name":"Galaxy Grand Prime Pro","codename":"j2y18lte","model":"SM-J250F"},{"manufacturer":"Samsung","market_name":"Galaxy Grand duos","codename":"baffin","model":"GT-I9082i"},{"manufacturer":"Samsung","market_name":"Galaxy Grand-Max","codename":"grandmaxltekx","model":"SM-G720N0"},{"manufacturer":"Samsung","market_name":"Galaxy Grand2","codename":"ms013g","model":"SM-G7102"},{"manufacturer":"Samsung","market_name":"Galaxy Grand2","codename":"ms013g","model":"SM-G7106"},{"manufacturer":"Samsung","market_name":"Galaxy Grand2","codename":"ms013g","model":"SM-G7108"},{"manufacturer":"Samsung","market_name":"Galaxy Grand2","codename":"ms013g","model":"SM-G7109"},{"manufacturer":"Samsung","market_name":"Galaxy Grand2","codename":"ms013gdtv","model":"SM-G7102T"},{"manufacturer":"Samsung","market_name":"Galaxy Grand2","codename":"ms013gss","model":"SM-G710"},{"manufacturer":"Samsung","market_name":"Galaxy Grand2","codename":"ms01lte","model":"SM-G7105"},{"manufacturer":"Samsung","market_name":"Galaxy Grand2","codename":"ms01lte","model":"SM-G7105H"},{"manufacturer":"Samsung","market_name":"Galaxy Grand2","codename":"ms01lte","model":"SM-G7105L"},{"manufacturer":"Samsung","market_name":"Galaxy Grand2","codename":"ms01ltektt","model":"SM-G710K"},{"manufacturer":"Samsung","market_name":"Galaxy Grand2","codename":"ms01ltelgt","model":"SM-G710L"},{"manufacturer":"Samsung","market_name":"Galaxy Grand2","codename":"ms01lteskt","model":"SM-G710S"},{"manufacturer":"Samsung","market_name":"Galaxy Indulge","codename":"SCH-R910","model":"SCH-R910"},{"manufacturer":"Samsung","market_name":"Galaxy Indulge","codename":"SCH-R915","model":"SCH-R915"},{"manufacturer":"Samsung","market_name":"Galaxy Infinite","codename":"infinite3gduosctc","model":"SCH-I759"},{"manufacturer":"Samsung","market_name":"Galaxy J","codename":"hltejs01tw","model":"SGH-N075T"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j13g","model":"SM-J100H"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j13g","model":"SM-J100ML"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j13gtfnvzw","model":"SM-S777C"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j1lte","model":"SM-J100F"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j1lte","model":"SM-J100G"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j1lte","model":"SM-J100M"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j1nlte","model":"SM-J100FN"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j1nlte","model":"SM-J100MU"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j1nlte","model":"SM-J100Y"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j1qltevzw","model":"SM-J100VPP"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j1xlte","model":"SM-J120F"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j1xlte","model":"SM-J120FN"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j1xlte","model":"SM-J120M"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j1xlteaio","model":"SAMSUNG-SM-J120AZ"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j1xlteatt","model":"SAMSUNG-SM-J120A"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j1xltecan","model":"SM-J120W"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j1xqltespr","model":"SM-J120P"},{"manufacturer":"Samsung","market_name":"Galaxy J1","codename":"j1xqltetfnvzw","model":"SM-S120VL"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Ace","codename":"j1acelte","model":"SM-J110F"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Ace","codename":"j1acelte","model":"SM-J110G"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Ace","codename":"j1acelteltn","model":"SM-J110M"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Ace","codename":"j1acevelte","model":"SM-J111F"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Ace","codename":"j1acevelte","model":"SM-J111M"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Ace","codename":"j1pop3g","model":"SM-J110H"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Ace","codename":"j1pop3g","model":"SM-J110L"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Mini","codename":"j1mini3g","model":"SM-J105B"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Mini","codename":"j1mini3g","model":"SM-J105H"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Mini","codename":"j1mini3gdx","model":"SM-J105B"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Mini","codename":"j1mini3gxw","model":"SM-J105H"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Mini","codename":"j1minilte","model":"SM-J105F"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Mini","codename":"j1minilte","model":"SM-J105M"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Mini","codename":"j1minilte","model":"SM-J105Y"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Mini Prime","codename":"j1minive3g","model":"SM-J106B"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Mini Prime","codename":"j1minive3g","model":"SM-J106H"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Mini Prime","codename":"j1minive3gxtc","model":"SM-J106B"},{"manufacturer":"Samsung","market_name":"Galaxy J1 Mini Prime","codename":"j1minivelte","model":"SM-J106M"},{"manufacturer":"Samsung","market_name":"Galaxy J1(2016)","codename":"j1x3g","model":"SM-J120H"},{"manufacturer":"Samsung","market_name":"Galaxy J1(2016)","codename":"j1xlte","model":"SM-J120G"},{"manufacturer":"Samsung","market_name":"Galaxy J1(2016)","codename":"j1xlte","model":"SM-J120ZN"},{"manufacturer":"Samsung","market_name":"Galaxy J2","codename":"j23g","model":"SM-J200H"},{"manufacturer":"Samsung","market_name":"Galaxy J2","codename":"j2lte","model":"SM-J200F"},{"manufacturer":"Samsung","market_name":"Galaxy J2","codename":"j2lte","model":"SM-J200G"},{"manufacturer":"Samsung","market_name":"Galaxy J2","codename":"j2lte","model":"SM-J200GU"},{"manufacturer":"Samsung","market_name":"Galaxy J2","codename":"j2lte","model":"SM-J200M"},{"manufacturer":"Samsung","market_name":"Galaxy J2","codename":"j2lte","model":"SM-J200Y"},{"manufacturer":"Samsung","market_name":"Galaxy J2","codename":"j2ltedtv","model":"SM-J200BT"},{"manufacturer":"Samsung","market_name":"Galaxy J2","codename":"j2y18lte","model":"SM-J250Y"},{"manufacturer":"Samsung","market_name":"Galaxy J2 (2018)","codename":"j2y18lte","model":"SM-J250F"},{"manufacturer":"Samsung","market_name":"Galaxy J2 Prime","codename":"grandpplte","model":"SM-G532G"},{"manufacturer":"Samsung","market_name":"Galaxy J2 Prime","codename":"grandpplte","model":"SM-G532M"},{"manufacturer":"Samsung","market_name":"Galaxy J2(2016)","codename":"j2xlte","model":"SM-J210F"},{"manufacturer":"Samsung","market_name":"Galaxy J2(2016)","codename":"j2xlteins","model":"SM-J210F"},{"manufacturer":"Samsung","market_name":"Galaxy J2(2018)","codename":"j2y18lte","model":"SM-J250M"},{"manufacturer":"Samsung","market_name":"Galaxy J2(2018) Ph Sepco","codename":"j2y18lte","model":"SM-J250G"},{"manufacturer":"Samsung","market_name":"Galaxy J3","codename":"j3ltectc","model":"SM-J3109"},{"manufacturer":"Samsung","market_name":"Galaxy J3","codename":"j3ltespr","model":"SM-J320P"},{"manufacturer":"Samsung","market_name":"Galaxy J3","codename":"j3popelteue","model":"SM-J327U"},{"manufacturer":"Samsung","market_name":"Galaxy J3","codename":"j3x3g","model":"SM-J320H"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Pop","codename":"j3popelteaio","model":"SAMSUNG-SM-J326AZ"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Pop","codename":"j3popelteaio","model":"SAMSUNG-SM-J327AZ"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Pop","codename":"j3popelteatt","model":"SAMSUNG-SM-J327A"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Pop","codename":"j3popeltecan","model":"SM-J327W"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Pop","codename":"j3popeltetfntmo","model":"SM-S337TL"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Pop","codename":"j3poplteacg","model":"SM-J327R7"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Pop","codename":"j3popltelra","model":"SM-J327R6"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Pop","codename":"j3popltespr","model":"SM-J327P"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Pop","codename":"j3popltetfnvzw","model":"SM-S327VL"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Pop","codename":"j3poplteusc","model":"SM-J327R4"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Pop","codename":"j3popltevzw","model":"SM-J327V"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Pop","codename":"j3popltevzw","model":"SM-J327VPP"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Prime","codename":"j3popeltemtr","model":"SM-J327T1"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Prime","codename":"j3popeltetmo","model":"SM-J327T"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Pro","codename":"j3xpro6mltechn","model":"SM-J3119S"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Pro","codename":"j3xproltechn","model":"SM-J3110"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Pro","codename":"j3xproltectc","model":"SM-J3119"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Pro","codename":"j3y17lte","model":"SM-J330G"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Top","codename":"j3toplteatt","model":"SM-J337A"},{"manufacturer":"Samsung","market_name":"Galaxy J3 Top","codename":"j3topltetmo","model":"SM-J337T"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2016)","codename":"j3ltekx","model":"SM-J320N0"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2016)","codename":"j3ltetfnvzw","model":"SM-S320VL"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2016)","codename":"j3ltetw","model":"SM-J320Y"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2016)","codename":"j3ltetw","model":"SM-J320YZ"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2016)","codename":"j3lteusc","model":"SM-J320R4"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2016)","codename":"j3ltevzw","model":"SM-J320V"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2016)","codename":"j3ltevzw","model":"SM-J320VPP"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2016)","codename":"j3ltexsa","model":"SM-J320ZN"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2016)","codename":"j3xlte","model":"SM-J320F"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2016)","codename":"j3xlte","model":"SM-J320G"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2016)","codename":"j3xlte","model":"SM-J320M"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2016)","codename":"j3xlteaio","model":"SAMSUNG-SM-J320AZ"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2016)","codename":"j3xlteaio","model":"SAMSUNG-SM-J321AZ"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2016)","codename":"j3xlteatt","model":"SAMSUNG-SM-J320A"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2016)","codename":"j3xltebmc","model":"SM-J320W8"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2016)","codename":"j3xnlte","model":"SM-J320FN"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2017)","codename":"j3y17lte","model":"SM-J330F"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2017)","codename":"j3y17lte","model":"SM-J330FN"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2017)","codename":"j3y17ltekx","model":"SM-J330N"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2017)","codename":"j3y17ltelgt","model":"SM-J330L"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2017)","codename":"j3y17qltecmcc","model":"SM-J3300"},{"manufacturer":"Samsung","market_name":"Galaxy J3(2017)","codename":"j3y17qltecmcc","model":"SM-J3308"},{"manufacturer":"Samsung","market_name":"Galaxy J4","codename":"j4lte","model":"SM-J400F"},{"manufacturer":"Samsung","market_name":"Galaxy J4","codename":"j4lte","model":"SM-J400G"},{"manufacturer":"Samsung","market_name":"Galaxy J4","codename":"j4lte","model":"SM-J400M"},{"manufacturer":"Samsung","market_name":"Galaxy J5","codename":"j53g","model":"SM-J500H"},{"manufacturer":"Samsung","market_name":"Galaxy J5","codename":"j5lte","model":"SM-J5007"},{"manufacturer":"Samsung","market_name":"Galaxy J5","codename":"j5lte","model":"SM-J500F"},{"manufacturer":"Samsung","market_name":"Galaxy J5","codename":"j5lte","model":"SM-J500G"},{"manufacturer":"Samsung","market_name":"Galaxy J5","codename":"j5lte","model":"SM-J500M"},{"manufacturer":"Samsung","market_name":"Galaxy J5","codename":"j5ltechn","model":"SM-J5008"},{"manufacturer":"Samsung","market_name":"Galaxy J5","codename":"j5ltekx","model":"SM-J500N0"},{"manufacturer":"Samsung","market_name":"Galaxy J5","codename":"j5nlte","model":"SM-J500FN"},{"manufacturer":"Samsung","market_name":"Galaxy J5","codename":"j5ylte","model":"SM-J500Y"},{"manufacturer":"Samsung","market_name":"Galaxy J5 Prime","codename":"on5xelte","model":"SM-G570F"},{"manufacturer":"Samsung","market_name":"Galaxy J5 Prime","codename":"on5xelte","model":"SM-G570M"},{"manufacturer":"Samsung","market_name":"Galaxy J5 Prime","codename":"on5xelte","model":"SM-G570Y"},{"manufacturer":"Samsung","market_name":"Galaxy J5 Prime","codename":"on5xelteins","model":"SM-G570F"},{"manufacturer":"Samsung","market_name":"Galaxy J5 Prime","codename":"on5xltechn","model":"SM-G5700"},{"manufacturer":"Samsung","market_name":"Galaxy J5 Pro","codename":"j5y17ltedx","model":"SM-J530Y"},{"manufacturer":"Samsung","market_name":"Galaxy J5 Pro","codename":"j5y17ltextc","model":"SM-J530YM"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2016)","codename":"j5x3g","model":"SM-J510H"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2016)","codename":"j5xltecmcc","model":"SM-J5108"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2016)","codename":"j5xnlte","model":"SM-J510F"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2016)","codename":"j5xnlte","model":"SM-J510FN"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2016)","codename":"j5xnlte","model":"SM-J510FQ"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2016)","codename":"j5xnlte","model":"SM-J510GN"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2016)","codename":"j5xnlte","model":"SM-J510MN"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2016)","codename":"j5xnlte","model":"SM-J510UN"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2016)","codename":"j5xnltektt","model":"SM-J510K"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2016)","codename":"j5xnltelgt","model":"SM-J510L"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2016)","codename":"j5xnlteskt","model":"SM-J510S"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2017)","codename":"j5y17lte","model":"SM-J530F"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2017)","codename":"j5y17lte","model":"SM-J530FM"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2017)","codename":"j5y17lte","model":"SM-J530G"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2017)","codename":"j5y17lte","model":"SM-J530GM"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2017)","codename":"j5y17ltektt","model":"SM-J530K"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2017)","codename":"j5y17ltelgt","model":"SM-J530L"},{"manufacturer":"Samsung","market_name":"Galaxy J5(2017)","codename":"j5y17lteskt","model":"SM-J530S"},{"manufacturer":"Samsung","market_name":"Galaxy J6","codename":"j6lte","model":"SM-J600F"},{"manufacturer":"Samsung","market_name":"Galaxy J6","codename":"j6lte","model":"SM-J600FN"},{"manufacturer":"Samsung","market_name":"Galaxy J6","codename":"j6lte","model":"SM-J600G"},{"manufacturer":"Samsung","market_name":"Galaxy J6","codename":"j6lte","model":"SM-J600GT"},{"manufacturer":"Samsung","market_name":"Galaxy J7","codename":"j75ltektt","model":"SM-J700K"},{"manufacturer":"Samsung","market_name":"Galaxy J7","codename":"j7e3g","model":"SM-J700H"},{"manufacturer":"Samsung","market_name":"Galaxy J7","codename":"j7elte","model":"SM-J700F"},{"manufacturer":"Samsung","market_name":"Galaxy J7","codename":"j7elte","model":"SM-J700M"},{"manufacturer":"Samsung","market_name":"Galaxy J7","codename":"j7ltechn","model":"SM-J7008"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Duo","codename":"j7duolte","model":"SM-J720F"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Duo","codename":"j7duolte","model":"SM-J720M"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Max","codename":"j7maxlte","model":"SM-G615F"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Neo","codename":"j7velte","model":"SM-J701F"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Neo","codename":"j7velte","model":"SM-J701M"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Neo","codename":"j7velte","model":"SM-J701MT"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Neo2","codename":"j7toplteskt","model":"SM-J737S"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Pop","codename":"j7popelteaio","model":"SAMSUNG-SM-J727AZ"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Pop","codename":"j7popelteatt","model":"SAMSUNG-SM-J727A"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Pop","codename":"j7popeltetfntmo","model":"SM-S737TL"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Pop","codename":"j7popelteue","model":"SM-J727U"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Pop","codename":"j7popltespr","model":"SM-J727P"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Pop","codename":"j7poplteusc","model":"SM-J727R4"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Pop","codename":"j7popltevzw","model":"SM-J727V"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Pop","codename":"j7popltevzw","model":"SM-J727VPP"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Pop","codename":"j7popqltetfnvzw","model":"SM-S727VL"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Prime","codename":"j7popeltemtr","model":"SM-J727T1"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Prime","codename":"j7popeltetmo","model":"SM-J727T"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Prime","codename":"on7xelte","model":"SM-G610F"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Prime","codename":"on7xelte","model":"SM-G610M"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Prime","codename":"on7xelte","model":"SM-G610Y"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Prime","codename":"on7xltechn","model":"SM-G6100"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Prime2","codename":"on7xreflte","model":"SM-G611F"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Prime2","codename":"on7xreflte","model":"SM-G611M"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Prime2","codename":"on7xreflte","model":"SM-G611MT"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Prime2","codename":"on7xreflteins","model":"SM-G611FF"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Pro","codename":"j7y17lte","model":"SM-J730G"},{"manufacturer":"Samsung","market_name":"Galaxy J7 Pro","codename":"j7y17lte","model":"SM-J730GM"},{"manufacturer":"Samsung","market_name":"Galaxy J7(2015)","codename":"j7ltespr","model":"SM-J700P"},{"manufacturer":"Samsung","market_name":"Galaxy J7(2016)","codename":"j7eltemtr","model":"SM-J700T1"},{"manufacturer":"Samsung","market_name":"Galaxy J7(2016)","codename":"j7eltetmo","model":"SM-J700T"},{"manufacturer":"Samsung","market_name":"Galaxy J7(2016)","codename":"j7xelte","model":"SM-J710F"},{"manufacturer":"Samsung","market_name":"Galaxy J7(2016)","codename":"j7xelte","model":"SM-J710FQ"},{"manufacturer":"Samsung","market_name":"Galaxy J7(2016)","codename":"j7xelte","model":"SM-J710GN"},{"manufacturer":"Samsung","market_name":"Galaxy J7(2016)","codename":"j7xelte","model":"SM-J710MN"},{"manufacturer":"Samsung","market_name":"Galaxy J7(2016)","codename":"j7xeltecmcc","model":"SM-J7108"},{"manufacturer":"Samsung","market_name":"Galaxy J7(2016)","codename":"j7xeltektt","model":"SM-J710K"},{"manufacturer":"Samsung","market_name":"Galaxy J7(2016)","codename":"j7xltectc","model":"SM-J7109"},{"manufacturer":"Samsung","market_name":"Galaxy J7(2017)","codename":"j7y17lte","model":"SM-J730F"},{"manufacturer":"Samsung","market_name":"Galaxy J7(2017)","codename":"j7y17lte","model":"SM-J730FM"},{"manufacturer":"Samsung","market_name":"Galaxy J7(2017)","codename":"j7y17lte","model":"SM-J730G"},{"manufacturer":"Samsung","market_name":"Galaxy J7(2017)","codename":"j7y17lte","model":"SM-J730GM"},{"manufacturer":"Samsung","market_name":"Galaxy J7(2017)","codename":"j7y17ltektt","model":"SM-J730K"},{"manufacturer":"Samsung","market_name":"Galaxy J7+","codename":"jadelte","model":"SM-C710F"},{"manufacturer":"Samsung","market_name":"Galaxy K","codename":"SHW-M130K","model":"SHW-M130K"},{"manufacturer":"Samsung","market_name":"Galaxy K Zoom","codename":"m2a3g","model":"SM-C111"},{"manufacturer":"Samsung","market_name":"Galaxy K Zoom","codename":"m2a3g","model":"SM-C111M"},{"manufacturer":"Samsung","market_name":"Galaxy K Zoom","codename":"m2alte","model":"SM-C115"},{"manufacturer":"Samsung","market_name":"Galaxy K Zoom","codename":"m2alte","model":"SM-C115M"},{"manufacturer":"Samsung","market_name":"Galaxy K Zoom","codename":"m2altecan","model":"SM-C115W"},{"manufacturer":"Samsung","market_name":"Galaxy K Zoom","codename":"m2altelgt","model":"SM-C115L"},{"manufacturer":"Samsung","market_name":"Galaxy M Pro2","codename":"lucas","model":"GT-B7810"},{"manufacturer":"Samsung","market_name":"Galaxy M Style","codename":"SHW-M340L","model":"SHW-M340L"},{"manufacturer":"Samsung","market_name":"Galaxy M Style","codename":"SHW-M340S","model":"SHW-M340S"},{"manufacturer":"Samsung","market_name":"Galaxy M Style","codename":"vastoicmcc","model":"GT-I8258"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 2","codename":"mega23g","model":"SM-G750H"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 5.8","codename":"crater","model":"GT-I9152"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 5.8","codename":"crater3gctc","model":"SCH-P709"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 5.8","codename":"craterss","model":"GT-I9150"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 5.8","codename":"cratertd3g","model":"GT-I9158"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 6.3","codename":"melius3g","model":"GT-I9200"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 6.3","codename":"melius3g","model":"GT-I9208"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 6.3","codename":"melius3gduosctc","model":"SCH-P729"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 6.3","codename":"meliuslte","model":"GT-I9205"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 6.3","codename":"meliuslteMetroPCS","model":"SGH-M819N"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 6.3","codename":"meliuslteatt","model":"SAMSUNG-SGH-I527"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 6.3","codename":"meliusltecan","model":"SGH-I527M"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 6.3","codename":"meliusltektt","model":"SHV-E310K"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 6.3","codename":"meliusltelgt","model":"SHV-E310L"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 6.3","codename":"meliuslteskt","model":"SHV-E310S"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 6.3","codename":"meliusltespr","model":"SPH-L600"},{"manufacturer":"Samsung","market_name":"Galaxy Mega 6.3","codename":"meliuslteusc","model":"SCH-R960"},{"manufacturer":"Samsung","market_name":"Galaxy Mega Plus","codename":"craterq3g","model":"GT-I9152P"},{"manufacturer":"Samsung","market_name":"Galaxy Mega Plus","codename":"craterq3g","model":"GT-I9158P"},{"manufacturer":"Samsung","market_name":"Galaxy Mega Plus","codename":"megapluslte","model":"GT-I9158V"},{"manufacturer":"Samsung","market_name":"Galaxy Mega2","codename":"mega2lte","model":"SM-G750F"},{"manufacturer":"Samsung","market_name":"Galaxy Mega2","codename":"mega2lteatt","model":"SAMSUNG-SM-G750A"},{"manufacturer":"Samsung","market_name":"Galaxy Mega2","codename":"vasta3g","model":"SM-G750H"},{"manufacturer":"Samsung","market_name":"Galaxy Mega2","codename":"vastalte","model":"SM-G7508Q"},{"manufacturer":"Samsung","market_name":"Galaxy Mega2","codename":"vastaltezh","model":"SM-G7508Q"},{"manufacturer":"Samsung","market_name":"Galaxy Mini","codename":"GT-S5570","model":"GT-S5570"},{"manufacturer":"Samsung","market_name":"Galaxy Mini","codename":"GT-S5570B","model":"GT-S5570B"},{"manufacturer":"Samsung","market_name":"Galaxy Mini","codename":"GT-S5570I","model":"GT-S5570I"},{"manufacturer":"Samsung","market_name":"Galaxy Mini","codename":"GT-S5570L","model":"GT-S5570L"},{"manufacturer":"Samsung","market_name":"Galaxy Mini","codename":"GT-S5578","model":"GT-S5578"},{"manufacturer":"Samsung","market_name":"Galaxy Mini","codename":"SGH-T499","model":"SGH-T499"},{"manufacturer":"Samsung","market_name":"Galaxy Mini","codename":"SGH-T499V","model":"SGH-T499V"},{"manufacturer":"Samsung","market_name":"Galaxy Mini","codename":"SGH-T499Y","model":"SGH-T499Y"},{"manufacturer":"Samsung","market_name":"Galaxy Mini2","codename":"GT-S6500","model":"GT-S6500"},{"manufacturer":"Samsung","market_name":"Galaxy Mini2","codename":"GT-S6500D","model":"GT-S6500D"},{"manufacturer":"Samsung","market_name":"Galaxy Mini2","codename":"GT-S6500L","model":"GT-S6500L"},{"manufacturer":"Samsung","market_name":"Galaxy Mini2","codename":"GT-S6500T","model":"GT-S6500T"},{"manufacturer":"Samsung","market_name":"Galaxy Music","codename":"ivoryss","model":"GT-S6010"},{"manufacturer":"Samsung","market_name":"Galaxy Music","codename":"ivoryss","model":"GT-S6010L"},{"manufacturer":"Samsung","market_name":"Galaxy Music Duos","codename":"ivory","model":"GT-S6012"},{"manufacturer":"Samsung","market_name":"Galaxy Music Duos","codename":"ivory","model":"GT-S6012B"},{"manufacturer":"Samsung","market_name":"Galaxy NX","codename":"u0lte","model":"EK-GN120"},{"manufacturer":"Samsung","market_name":"Galaxy NX","codename":"u0lte","model":"EK-GN120A"},{"manufacturer":"Samsung","market_name":"Galaxy NX","codename":"u0lteue","model":"EK-GN120A"},{"manufacturer":"Samsung","market_name":"Galaxy Neo","codename":"SHW-M220L","model":"SHW-M220L"},{"manufacturer":"Samsung","market_name":"Galaxy Nexus","codename":"maguro","model":"Galaxy Nexus"},{"manufacturer":"Samsung","market_name":"Galaxy Nexus","codename":"maguro","model":"Galaxy X"},{"manufacturer":"Samsung","market_name":"Galaxy Nexus","codename":"toro","model":"Galaxy Nexus"},{"manufacturer":"Samsung","market_name":"Galaxy Nexus","codename":"toroplus","model":"Galaxy Nexus"},{"manufacturer":"Samsung","market_name":"Galaxy Note","codename":"GT-I9220","model":"GT-I9220"},{"manufacturer":"Samsung","market_name":"Galaxy Note","codename":"GT-I9228","model":"GT-I9228"},{"manufacturer":"Samsung","market_name":"Galaxy Note","codename":"GT-N7000","model":"GT-N7000"},{"manufacturer":"Samsung","market_name":"Galaxy Note","codename":"GT-N7005","model":"GT-N7005"},{"manufacturer":"Samsung","market_name":"Galaxy Note","codename":"SC-05D","model":"SC-05D"},{"manufacturer":"Samsung","market_name":"Galaxy Note","codename":"SCH-i889","model":"SCH-i889"},{"manufacturer":"Samsung","market_name":"Galaxy Note","codename":"SGH-I717","model":"SAMSUNG-SGH-I717"},{"manufacturer":"Samsung","market_name":"Galaxy Note","codename":"SGH-I717","model":"SGH-I717"},{"manufacturer":"Samsung","market_name":"Galaxy Note","codename":"SGH-I717D","model":"SGH-I717D"},{"manufacturer":"Samsung","market_name":"Galaxy Note","codename":"SGH-I717M","model":"SGH-I717M"},{"manufacturer":"Samsung","market_name":"Galaxy Note","codename":"SGH-I717R","model":"SGH-I717R"},{"manufacturer":"Samsung","market_name":"Galaxy Note","codename":"SGH-T879","model":"SGH-T879"},{"manufacturer":"Samsung","market_name":"Galaxy Note","codename":"SHV-E160K","model":"SHV-E160K"},{"manufacturer":"Samsung","market_name":"Galaxy Note","codename":"SHV-E160L","model":"SHV-E160L"},{"manufacturer":"Samsung","market_name":"Galaxy Note","codename":"SHV-E160S","model":"SHV-E160S"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"lt033g","model":"SM-P601"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"lt033g","model":"SM-P602"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"lt03ltektt","model":"SM-P605K"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"lt03ltelgt","model":"SM-P605L"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"lt03lteskt","model":"SM-P605S"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"p4notelte","model":"GT-N8020"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"p4noteltektt","model":"SHV-E230K"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"p4noteltelgt","model":"SHV-E230L"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"p4notelteskt","model":"SHV-E230S"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"p4noteltespr","model":"SPH-P600"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"p4notelteusc","model":"SCH-I925U"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"p4noteltevzw","model":"SCH-I925"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"p4noterf","model":"GT-N8000"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"p4noterf","model":"GT-N8005"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"p4noterfktt","model":"SHW-M480K"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"p4notewifi","model":"GT-N8013"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"p4notewifi43241any","model":"SHW-M486W"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"p4notewifiany","model":"SHW-M480W"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"p4notewifiktt","model":"SHW-M485W"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1","codename":"p4notewifiww","model":"GT-N8010"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1 2014 Edition","codename":"lt033g","model":"SM-P601"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1 2014 Edition","codename":"lt03lte","model":"SM-P605"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1 2014 Edition","codename":"lt03lte","model":"SM-P605M"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1 2014 Edition","codename":"lt03ltetmo","model":"SM-P607T"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1 2014 Edition","codename":"lt03ltevzw","model":"SM-P605V"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1 2014 Edition","codename":"lt03wifi","model":"SM-P600"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1 2014 Edition","codename":"lt03wifikx","model":"SM-P600"},{"manufacturer":"Samsung","market_name":"Galaxy Note 10.1 2014 Edition","codename":"lt03wifiue","model":"SM-P600"},{"manufacturer":"Samsung","market_name":"Galaxy Note 8.0","codename":"kona3g","model":"GT-N5100"},{"manufacturer":"Samsung","market_name":"Galaxy Note 8.0","codename":"kona3g","model":"GT-N5105"},{"manufacturer":"Samsung","market_name":"Galaxy Note 8.0","codename":"konalte","model":"GT-N5120"},{"manufacturer":"Samsung","market_name":"Galaxy Note 8.0","codename":"konalteatt","model":"SAMSUNG-SGH-I467"},{"manufacturer":"Samsung","market_name":"Galaxy Note 8.0","codename":"konaltecan","model":"SGH-I467M"},{"manufacturer":"Samsung","market_name":"Galaxy Note 8.0","codename":"konawifi","model":"GT-N5110"},{"manufacturer":"Samsung","market_name":"Galaxy Note 8.0","codename":"konawifiany","model":"SHW-M500W"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"SC-01G","model":"SC-01G"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"SCL24","model":"SCL24"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"tbeltektt","model":"SM-N915K"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"tbeltelgt","model":"SM-N915L"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"tbelteskt","model":"SM-N915S"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"tblte","model":"SM-N9150"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"tblte","model":"SM-N915F"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"tblte","model":"SM-N915FY"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"tblte","model":"SM-N915G"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"tblte","model":"SM-N915X"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"tblteatt","model":"SAMSUNG-SM-N915A"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"tbltecan","model":"SM-N915W8"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"tbltechn","model":"SM-N9150"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"tbltespr","model":"SM-N915P"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"tbltetmo","model":"SM-N915T"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"tbltetmo","model":"SM-N915T3"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"tblteusc","model":"SM-N915R4"},{"manufacturer":"Samsung","market_name":"Galaxy Note Edge","codename":"tbltevzw","model":"SM-N915V"},{"manufacturer":"Samsung","market_name":"Galaxy Note Fan Edition","codename":"gracerlte","model":"SM-N935F"},{"manufacturer":"Samsung","market_name":"Galaxy Note Fan Edition","codename":"gracerltektt","model":"SM-N935K"},{"manufacturer":"Samsung","market_name":"Galaxy Note Fan Edition","codename":"gracerltelgt","model":"SM-N935L"},{"manufacturer":"Samsung","market_name":"Galaxy Note Fan Edition","codename":"gracerlteskt","model":"SM-N935S"},{"manufacturer":"Samsung","market_name":"Galaxy Note II","codename":"t0lteatt","model":"SAMSUNG-SGH-I317"},{"manufacturer":"Samsung","market_name":"Galaxy Note Pro 12.2","codename":"v1a3g","model":"SM-P901"},{"manufacturer":"Samsung","market_name":"Galaxy Note Pro 12.2","codename":"v1awifi","model":"SM-P900"},{"manufacturer":"Samsung","market_name":"Galaxy Note Pro 12.2","codename":"v1awifikx","model":"SM-P900"},{"manufacturer":"Samsung","market_name":"Galaxy Note Pro 12.2","codename":"viennalte","model":"SM-P905"},{"manufacturer":"Samsung","market_name":"Galaxy Note Pro 12.2","codename":"viennalte","model":"SM-P905M"},{"manufacturer":"Samsung","market_name":"Galaxy Note Pro 12.2","codename":"viennalteatt","model":"SAMSUNG-SM-P907A"},{"manufacturer":"Samsung","market_name":"Galaxy Note Pro 12.2","codename":"viennaltekx","model":"SM-P905F0"},{"manufacturer":"Samsung","market_name":"Galaxy Note Pro 12.2","codename":"viennaltevzw","model":"SM-P905V"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"SC-02E","model":"SC-02E"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t03g","model":"GT-N7100"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t03g","model":"GT-N7100T"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t03gchn","model":"GT-N7100"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t03gchnduos","model":"GT-N7102"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t03gchnduos","model":"GT-N7102i"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t03gcmcc","model":"GT-N7108"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t03gctc","model":"SCH-N719"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t03gcuduos","model":"GT-N7102"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t03gcuduos","model":"GT-N7102i"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t0lte","model":"GT-N7105"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t0lte","model":"GT-N7105T"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t0lteatt","model":"SAMSUNG-SGH-I317"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t0ltecan","model":"SGH-I317M"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t0ltecan","model":"SGH-T889V"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t0ltecmcc","model":"GT-N7108D"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t0ltedcm","model":"SC-02E"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t0ltektt","model":"SHV-E250K"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t0ltelgt","model":"SHV-E250L"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t0lteskt","model":"SHV-E250S"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t0ltespr","model":"SPH-L900"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t0ltetmo","model":"SGH-T889"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t0lteusc","model":"SCH-R950"},{"manufacturer":"Samsung","market_name":"Galaxy Note2","codename":"t0ltevzw","model":"SCH-I605"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"SC-01F","model":"SC-01F"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"SC-02F","model":"SC-02F"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"SCL22","model":"SCL22"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"ha3g","model":"SM-N900"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"ha3g","model":"SM-N9000Q"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"hlte","model":"SM-N9005"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"hlte","model":"SM-N9006"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"hlte","model":"SM-N9007"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"hlte","model":"SM-N9008V"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"hlte","model":"SM-N9009"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"hlte","model":"SM-N900U"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"hlteatt","model":"SAMSUNG-SM-N900A"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"hltecan","model":"SM-N900W8"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"hltektt","model":"SM-N900K"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"hltelgt","model":"SM-N900L"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"hlteskt","model":"SM-N900S"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"hltespr","model":"SM-N900P"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"hltetmo","model":"SM-N900T"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"hlteusc","model":"SM-N900R4"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"hltevzw","model":"SM-N900V"},{"manufacturer":"Samsung","market_name":"Galaxy Note3","codename":"htdlte","model":"SM-N9007"},{"manufacturer":"Samsung","market_name":"Galaxy Note3 Duos","codename":"hlte","model":"SM-N9002"},{"manufacturer":"Samsung","market_name":"Galaxy Note3 Duos","codename":"hlte","model":"SM-N9008"},{"manufacturer":"Samsung","market_name":"Galaxy Note3 Neo","codename":"frescoltektt","model":"SM-N750K"},{"manufacturer":"Samsung","market_name":"Galaxy Note3 Neo","codename":"frescoltelgt","model":"SM-N750L"},{"manufacturer":"Samsung","market_name":"Galaxy Note3 Neo","codename":"frescolteskt","model":"SM-N750S"},{"manufacturer":"Samsung","market_name":"Galaxy Note3 Neo","codename":"hl3g","model":"SM-N750"},{"manufacturer":"Samsung","market_name":"Galaxy Note3 Neo","codename":"hl3g","model":"SM-N7500Q"},{"manufacturer":"Samsung","market_name":"Galaxy Note3 Neo","codename":"hl3gds","model":"SM-N7502"},{"manufacturer":"Samsung","market_name":"Galaxy Note3 Neo","codename":"hllte","model":"SM-N7505"},{"manufacturer":"Samsung","market_name":"Galaxy Note3 Neo","codename":"hllte","model":"SM-N7505L"},{"manufacturer":"Samsung","market_name":"Galaxy Note3 Neo","codename":"hllte","model":"SM-N7507"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"tre3caltektt","model":"SM-N916K"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"tre3caltelgt","model":"SM-N916L"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"tre3calteskt","model":"SM-N916S"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"tre3g","model":"SM-N910H"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trelte","model":"SM-N910C"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"treltektt","model":"SM-N910K"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"treltelgt","model":"SM-N910L"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trelteskt","model":"SM-N910S"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trhplte","model":"SM-N910U"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trlte","model":"SM-N910F"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trlte","model":"SM-N910G"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trlte","model":"SM-N910X"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trlteatt","model":"SAMSUNG-SM-N910A"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trlteatt","model":"SM-N910F"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trltecan","model":"SM-N910W8"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trltechn","model":"SM-N9100"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trltechn","model":"SM-N9106W"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trltechn","model":"SM-N9108V"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trltechn","model":"SM-N9109W"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trltechnzh","model":"SM-N9100"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trltespr","model":"SM-N910P"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trltetmo","model":"SM-N910T"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trltetmo","model":"SM-N910T2"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trltetmo","model":"SM-N910T3"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trlteusc","model":"SM-N910R4"},{"manufacturer":"Samsung","market_name":"Galaxy Note4","codename":"trltevzw","model":"SM-N910V"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"noblelte","model":"SM-N9208"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"noblelte","model":"SM-N920C"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"noblelte","model":"SM-N920F"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"noblelte","model":"SM-N920G"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"noblelte","model":"SM-N920I"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"noblelte","model":"SM-N920X"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"noblelteacg","model":"SM-N920R7"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"noblelteatt","model":"SAMSUNG-SM-N920A"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"nobleltebmc","model":"SM-N920W8"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"nobleltechn","model":"SM-N9200"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"nobleltecmcc","model":"SM-N9208"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"nobleltehk","model":"SM-N9200"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"nobleltektt","model":"SM-N920K"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"nobleltelgt","model":"SM-N920L"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"nobleltelra","model":"SM-N920R6"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"noblelteskt","model":"SM-N920S"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"nobleltespr","model":"SM-N920P"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"nobleltetmo","model":"SM-N920T"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"noblelteusc","model":"SM-N920R4"},{"manufacturer":"Samsung","market_name":"Galaxy Note5","codename":"nobleltevzw","model":"SM-N920V"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"SC-01J","model":"SC-01J"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"SCV34","model":"SCV34"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"gracelte","model":"SM-N930F"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"gracelte","model":"SM-N930X"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"graceltektt","model":"SM-N930K"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"graceltelgt","model":"SM-N930L"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"gracelteskt","model":"SM-N930S"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"graceqlteacg","model":"SM-N930R7"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"graceqlteatt","model":"SAMSUNG-SM-N930A"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"graceqltebmc","model":"SM-N930W8"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"graceqltechn","model":"SM-N9300"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"graceqltedcm","model":"SGH-N037"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"graceqltelra","model":"SM-N930R6"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"graceqltespr","model":"SM-N930P"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"graceqltetfnvzw","model":"SM-N930VL"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"graceqltetmo","model":"SM-N930T"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"graceqlteue","model":"SM-N930U"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"graceqlteusc","model":"SM-N930R4"},{"manufacturer":"Samsung","market_name":"Galaxy Note7","codename":"graceqltevzw","model":"SM-N930V"},{"manufacturer":"Samsung","market_name":"Galaxy Note8","codename":"SC-01K","model":"SC-01K"},{"manufacturer":"Samsung","market_name":"Galaxy Note8","codename":"SCV37","model":"SCV37"},{"manufacturer":"Samsung","market_name":"Galaxy Note8","codename":"greatlte","model":"SM-N950F"},{"manufacturer":"Samsung","market_name":"Galaxy Note8","codename":"greatlteks","model":"SM-N950N"},{"manufacturer":"Samsung","market_name":"Galaxy Note8","codename":"greatlteks","model":"SM-N950XN"},{"manufacturer":"Samsung","market_name":"Galaxy Note8","codename":"greatqlte","model":"SM-N950U"},{"manufacturer":"Samsung","market_name":"Galaxy Note8","codename":"greatqltechn","model":"SM-N9500"},{"manufacturer":"Samsung","market_name":"Galaxy Note8","codename":"greatqltecmcc","model":"SM-N9508"},{"manufacturer":"Samsung","market_name":"Galaxy Note8","codename":"greatqltecs","model":"SM-N950W"},{"manufacturer":"Samsung","market_name":"Galaxy Note8","codename":"greatqlteue","model":"SM-N950U1"},{"manufacturer":"Samsung","market_name":"Galaxy On Max","codename":"j7maxlte","model":"SM-G615FU"},{"manufacturer":"Samsung","market_name":"Galaxy On Nxt","codename":"on7xelte","model":"SM-G610F"},{"manufacturer":"Samsung","market_name":"Galaxy On5","codename":"o5lte","model":"SM-G550FY"},{"manufacturer":"Samsung","market_name":"Galaxy On5","codename":"o5ltechn","model":"SM-G5500"},{"manufacturer":"Samsung","market_name":"Galaxy On5","codename":"o5prolte","model":"SM-G550FY"},{"manufacturer":"Samsung","market_name":"Galaxy On5","codename":"on5ltemtr","model":"SM-G550T1"},{"manufacturer":"Samsung","market_name":"Galaxy On5","codename":"on5ltetfntmo","model":"SM-S550TL"},{"manufacturer":"Samsung","market_name":"Galaxy On5","codename":"on5ltetmo","model":"SM-G550T"},{"manufacturer":"Samsung","market_name":"Galaxy On5","codename":"on5ltetmo","model":"SM-G550T2"},{"manufacturer":"Samsung","market_name":"Galaxy On5(2016)","codename":"on5xfltechn","model":"SM-G5520"},{"manufacturer":"Samsung","market_name":"Galaxy On5(2016)","codename":"on5xfltechn","model":"SM-G5528"},{"manufacturer":"Samsung","market_name":"Galaxy On5(2016)","codename":"on5xlltechn","model":"SM-G5510"},{"manufacturer":"Samsung","market_name":"Galaxy On5(2016)","codename":"on5xltechn","model":"SM-G5700"},{"manufacturer":"Samsung","market_name":"Galaxy On7","codename":"o7lte","model":"SM-G600FY"},{"manufacturer":"Samsung","market_name":"Galaxy On7","codename":"o7ltechn","model":"SM-G6000"},{"manufacturer":"Samsung","market_name":"Galaxy On7","codename":"on7elte","model":"SM-G600F"},{"manufacturer":"Samsung","market_name":"Galaxy On7 Pro","codename":"o7prolte","model":"SM-G600FY"},{"manufacturer":"Samsung","market_name":"Galaxy On7 Refresh","codename":"on7xrefltektt","model":"SM-G611K"},{"manufacturer":"Samsung","market_name":"Galaxy On7 Refresh","codename":"on7xrefltelgt","model":"SM-G611L"},{"manufacturer":"Samsung","market_name":"Galaxy On7 Refresh","codename":"on7xreflteskt","model":"SM-G611S"},{"manufacturer":"Samsung","market_name":"Galaxy On7(2016)","codename":"on7xeltektt","model":"SM-G610K"},{"manufacturer":"Samsung","market_name":"Galaxy On7(2016)","codename":"on7xeltelgt","model":"SM-G610L"},{"manufacturer":"Samsung","market_name":"Galaxy On7(2016)","codename":"on7xelteskt","model":"SM-G610S"},{"manufacturer":"Samsung","market_name":"Galaxy On7(2016)","codename":"on7xltechn","model":"SM-G6100"},{"manufacturer":"Samsung","market_name":"Galaxy On8","codename":"j7xlte","model":"SM-J710FN"},{"manufacturer":"Samsung","market_name":"Galaxy Player","codename":"YP-GB70","model":"YP-GB70"},{"manufacturer":"Samsung","market_name":"Galaxy Player 3.6","codename":"YP-GS1","model":"YP-GS1"},{"manufacturer":"Samsung","market_name":"Galaxy Player 4","codename":"YP-GB1","model":"YP-GB1"},{"manufacturer":"Samsung","market_name":"Galaxy Player 4.0","codename":"YP-G1","model":"YP-G1"},{"manufacturer":"Samsung","market_name":"Galaxy Player 4.2","codename":"YP-GI1","model":"YP-GI1"},{"manufacturer":"Samsung","market_name":"Galaxy Player 5","codename":"YP-G70","model":"YP-G70"},{"manufacturer":"Samsung","market_name":"Galaxy Player 5.8","codename":"harrison","model":"YP-GP1"},{"manufacturer":"Samsung","market_name":"Galaxy Player 5.8","codename":"harrisonkrktt","model":"YP-GP1"},{"manufacturer":"Samsung","market_name":"Galaxy Player 5.8","codename":"harrisonkrlgt","model":"YP-GP1"},{"manufacturer":"Samsung","market_name":"Galaxy Player 50","codename":"YP-G50","model":"YP-G50"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket","codename":"GT-S5300","model":"GT-S5300"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket","codename":"GT-S5300B","model":"GT-S5300B"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket","codename":"GT-S5300L","model":"GT-S5300L"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket","codename":"GT-S5302","model":"GT-S5302"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket","codename":"GT-S5302B","model":"GT-S5302B"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket","codename":"coriplus","model":"GT-S5301"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket","codename":"coriplusds","model":"GT-S5303"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Neo","codename":"corsica","model":"GT-S5312"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Neo","codename":"corsica","model":"GT-S5312B"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Neo","codename":"corsica","model":"GT-S5312L"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Neo","codename":"corsicass","model":"GT-S5310"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Neo","codename":"corsicass","model":"GT-S5310B"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Neo","codename":"corsicass","model":"GT-S5310E"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Neo","codename":"corsicass","model":"GT-S5310G"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Neo","codename":"corsicass","model":"GT-S5310L"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Neo","codename":"corsicass","model":"GT-S5310T"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Neo","codename":"corsicave3g","model":"GT-S5310I"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Neo","codename":"corsicave3g","model":"GT-S5310N"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Neo","codename":"corsicaveds3gvj","model":"GT-S5312C"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Neo","codename":"corsicaveds3gvj","model":"GT-S5312M"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Neo","codename":"d2aio","model":"SAMSUNG-SGH-I747Z"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Plus","codename":"coriplus","model":"GT-S5301"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Plus","codename":"coriplus","model":"GT-S5301B"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket Plus","codename":"coriplus","model":"GT-S5301L"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket SS","codename":"corsicave3g","model":"GT-S5310C"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket SS","codename":"corsicave3g","model":"GT-S5310M"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket2","codename":"pocket23g","model":"SM-G110B"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket2","codename":"pocket23g","model":"SM-G110M"},{"manufacturer":"Samsung","market_name":"Galaxy Pocket2","codename":"pocket2ss3g","model":"SM-G110H"},{"manufacturer":"Samsung","market_name":"Galaxy Pop","codename":"superiorlteskt","model":"SHV-E220S"},{"manufacturer":"Samsung","market_name":"Galaxy Pop (CDMA)","codename":"SCH-i559","model":"SCH-i559"},{"manufacturer":"Samsung","market_name":"Galaxy Precedent","codename":"SCH-M828C","model":"SCH-M828C"},{"manufacturer":"Samsung","market_name":"Galaxy Premier","codename":"superior","model":"GT-I9260"},{"manufacturer":"Samsung","market_name":"Galaxy Premier","codename":"superiorcmcc","model":"GT-I9268"},{"manufacturer":"Samsung","market_name":"Galaxy Prevail","codename":"SPH-M820","model":"SPH-M820-BST"},{"manufacturer":"Samsung","market_name":"Galaxy Prevail2","codename":"raybst","model":"SPH-M840"},{"manufacturer":"Samsung","market_name":"Galaxy Pro","codename":"GT-B7510","model":"GT-B7510"},{"manufacturer":"Samsung","market_name":"Galaxy Pro","codename":"GT-B7510B","model":"GT-B7510B"},{"manufacturer":"Samsung","market_name":"Galaxy Pro","codename":"GT-B7510L","model":"GT-B7510L"},{"manufacturer":"Samsung","market_name":"Galaxy Proclaim","codename":"SCH-S720C","model":"SCH-S720C"},{"manufacturer":"Samsung","market_name":"Galaxy Q","codename":"SGH-T589","model":"SGH-T589"},{"manufacturer":"Samsung","market_name":"Galaxy Q","codename":"SGH-T589R","model":"SGH-T589R"},{"manufacturer":"Samsung","market_name":"Galaxy Q","codename":"SGH-T589W","model":"SGH-T589W"},{"manufacturer":"Samsung","market_name":"Galaxy R-Style","codename":"jaguark","model":"SHV-E170K"},{"manufacturer":"Samsung","market_name":"Galaxy R-Style","codename":"jaguarl","model":"SHV-E170L"},{"manufacturer":"Samsung","market_name":"Galaxy R-Style","codename":"jaguars","model":"SHV-E170S"},{"manufacturer":"Samsung","market_name":"Galaxy Reverb","codename":"iconvmu","model":"SPH-M950"},{"manufacturer":"Samsung","market_name":"Galaxy Round","codename":"flteskt","model":"SM-G910S"},{"manufacturer":"Samsung","market_name":"Galaxy Rugby","codename":"comanchecan","model":"SGH-I547C"},{"manufacturer":"Samsung","market_name":"Galaxy Rugby Pro","codename":"comancheatt","model":"SAMSUNG-SGH-I547"},{"manufacturer":"Samsung","market_name":"Galaxy Rush","codename":"prevail2spr","model":"SPH-M830"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"GT-I9000","model":"GT-I9000"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"GT-I9000B","model":"GT-I9000B"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"GT-I9000M","model":"GT-I9000M"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"GT-I9000T","model":"GT-I9000T"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"GT-I9003","model":"GT-I9003"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"GT-I9003L","model":"GT-I9003L"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"GT-I9008L","model":"GT-I9008L"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"GT-I9010","model":"GT-I9010"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"GT-I9018","model":"GT-I9018"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"GT-I9050","model":"GT-I9050"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"SC-02B","model":"SC-02B"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"SCH-I500","model":"SCH-I500"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"SCH-S950C","model":"SCH-S950C"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"SCH-i909","model":"SCH-i909"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"SGH-I897","model":"SAMSUNG-SGH-I897"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"SGH-T959V","model":"SGH-T959V"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"SGH-T959W","model":"SGH-T959W"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"SHW-M110S","model":"SHW-M110S"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"SHW-M190S","model":"SHW-M190S"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"SPH-D700","model":"SPH-D700"},{"manufacturer":"Samsung","market_name":"Galaxy S","codename":"loganlte","model":"GT-S7275"},{"manufacturer":"Samsung","market_name":"Galaxy S Advance","codename":"GT-I9070","model":"GT-I9070"},{"manufacturer":"Samsung","market_name":"Galaxy S Advance","codename":"GT-I9070P","model":"GT-I9070P"},{"manufacturer":"Samsung","market_name":"Galaxy S Aviator","codename":"SCH-R930","model":"SCH-R930"},{"manufacturer":"Samsung","market_name":"Galaxy S Blaze","codename":"SGH-T769","model":"SGH-T769"},{"manufacturer":"Samsung","market_name":"Galaxy S BlazeQ","codename":"apexqtmo","model":"SGH-T699"},{"manufacturer":"Samsung","market_name":"Galaxy S Captivate","codename":"SGH-I896","model":"SAMSUNG-SGH-I896"},{"manufacturer":"Samsung","market_name":"Galaxy S Captivate","codename":"SGH-I896","model":"SGH-I896"},{"manufacturer":"Samsung","market_name":"Galaxy S Continuum","codename":"SCH-I400","model":"SCH-I400"},{"manufacturer":"Samsung","market_name":"Galaxy S DUOS","codename":"kyleopen","model":"GT-S7562"},{"manufacturer":"Samsung","market_name":"Galaxy S DUOS","codename":"kyleopen","model":"GT-S7562L"},{"manufacturer":"Samsung","market_name":"Galaxy S Duos","codename":"kylechn","model":"GT-S7562"},{"manufacturer":"Samsung","market_name":"Galaxy S Duos","codename":"kyleopen","model":"GT-S7562"},{"manufacturer":"Samsung","market_name":"Galaxy S Duos","codename":"kyletdcmcc","model":"GT-S7568"},{"manufacturer":"Samsung","market_name":"Galaxy S Duos2","codename":"kyleprods","model":"GT-S7582"},{"manufacturer":"Samsung","market_name":"Galaxy S Duos2","codename":"kyleprods","model":"GT-S7582L"},{"manufacturer":"Samsung","market_name":"Galaxy S Duos3","codename":"vivalto3gvn","model":"SM-G313HZ"},{"manufacturer":"Samsung","market_name":"Galaxy S Epic","codename":"SPH-D700","model":"SPH-D700"},{"manufacturer":"Samsung","market_name":"Galaxy S Fascinate","codename":"SGH-T959P","model":"SGH-T959P"},{"manufacturer":"Samsung","market_name":"Galaxy S Glide","codename":"SGH-I927R","model":"SAMSUNG-SGH-I927R"},{"manufacturer":"Samsung","market_name":"Galaxy S Lightray","codename":"SCH-R940","model":"SCH-R940"},{"manufacturer":"Samsung","market_name":"Galaxy S Plus","codename":"GT-I9001","model":"GT-I9001"},{"manufacturer":"Samsung","market_name":"Galaxy S Stratosphere","codename":"SCH-I405","model":"SCH-I405"},{"manufacturer":"Samsung","market_name":"Galaxy S Vibrant","codename":"SGH-T959","model":"SGH-T959"},{"manufacturer":"Samsung","market_name":"Galaxy S Vibrant","codename":"SGH-T959D","model":"SGH-T959D"},{"manufacturer":"Samsung","market_name":"Galaxy S duos","codename":"kyleichn","model":"GT-S7566"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"GT-I9100","model":"GT-I9100"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"GT-I9100M","model":"GT-I9100M"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"GT-I9100P","model":"GT-I9100P"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"GT-I9100T","model":"GT-I9100T"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"GT-I9103","model":"GT-I9103"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"GT-I9108","model":"GT-I9108"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"GT-I9210T","model":"GT-I9210T"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"SC-02C","model":"SC-02C"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"SCH-R760X","model":"SCH-R760X"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"SGH-I777","model":"SAMSUNG-SGH-I777"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"SGH-S959G","model":"SGH-S959G"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"SGH-T989","model":"SGH-T989"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"SHV-E110S","model":"SHV-E110S"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"SHW-M250K","model":"SHW-M250K"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"SHW-M250L","model":"SHW-M250L"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"SHW-M250S","model":"SHW-M250S"},{"manufacturer":"Samsung","market_name":"Galaxy S2","codename":"t1cmcc","model":"GT-I9108"},{"manufacturer":"Samsung","market_name":"Galaxy S2 Duos","codename":"SCH-i929","model":"SCH-i929"},{"manufacturer":"Samsung","market_name":"Galaxy S2 Duos TV","codename":"logandsdtv","model":"GT-S7273T"},{"manufacturer":"Samsung","market_name":"Galaxy S2 Epic","codename":"SCH-R760","model":"SCH-R760"},{"manufacturer":"Samsung","market_name":"Galaxy S2 Epic","codename":"SPH-D710","model":"SPH-D710"},{"manufacturer":"Samsung","market_name":"Galaxy S2 Epic","codename":"SPH-D710BST","model":"SPH-D710BST"},{"manufacturer":"Samsung","market_name":"Galaxy S2 Epic","codename":"SPH-D710VMUB","model":"SPH-D710VMUB"},{"manufacturer":"Samsung","market_name":"Galaxy S2 HD LTE","codename":"SGH-I757M","model":"SGH-I757M"},{"manufacturer":"Samsung","market_name":"Galaxy S2 HD LTE","codename":"SHV-E120K","model":"SHV-E120K"},{"manufacturer":"Samsung","market_name":"Galaxy S2 HD LTE","codename":"SHV-E120L","model":"SHV-E120L"},{"manufacturer":"Samsung","market_name":"Galaxy S2 HD LTE","codename":"SHV-E120S","model":"SHV-E120S"},{"manufacturer":"Samsung","market_name":"Galaxy S2 LTE","codename":"GT-I9210","model":"GT-I9210"},{"manufacturer":"Samsung","market_name":"Galaxy S2 LTE","codename":"SC-03D","model":"SC-03D"},{"manufacturer":"Samsung","market_name":"Galaxy S2 LTE","codename":"SGH-I727R","model":"SGH-I727R"},{"manufacturer":"Samsung","market_name":"Galaxy S2 Plus","codename":"GT-I9100G","model":"GT-I9100G"},{"manufacturer":"Samsung","market_name":"Galaxy S2 Plus","codename":"s2ve","model":"GT-I9105"},{"manufacturer":"Samsung","market_name":"Galaxy S2 Plus","codename":"s2vep","model":"GT-I9105P"},{"manufacturer":"Samsung","market_name":"Galaxy S2 Skyrocket","codename":"SGH-I727","model":"SAMSUNG-SGH-I727"},{"manufacturer":"Samsung","market_name":"Galaxy S2 Skyrocket","codename":"SGH-I727","model":"SGH-I727"},{"manufacturer":"Samsung","market_name":"Galaxy S2 Wimax","codename":"ISW11SC","model":"ISW11SC"},{"manufacturer":"Samsung","market_name":"Galaxy S2 X","codename":"SGH-T989D","model":"SGH-T989D"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"SC-03E","model":"SC-03E"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"c1att","model":"SGH-I748"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"c1ktt","model":"SHV-E210K"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"c1lgt","model":"SHV-E210L"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"c1skt","model":"SHV-E210S"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2att","model":"SAMSUNG-SGH-I747"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2can","model":"SGH-I747M"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2can","model":"SGH-T999V"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2cri","model":"SCH-R530C"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2dcm","model":"Gravity"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2dcm","model":"SC-06D"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2lteMetroPCS","model":"SGH-T999N"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2lterefreshspr","model":"SPH-L710T"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2ltetmo","model":"SGH-T999L"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2mtr","model":"SCH-R530M"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2spi","model":"SCH-L710"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2spr","model":"SPH-L710"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2tfnspr","model":"SCH-S960L"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2tfnvzw","model":"SCH-S968C"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2tmo","model":"SGH-T999"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2usc","model":"SCH-R530U"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2vmu","model":"SPH-L710"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2vzw","model":"SCH-I535"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2vzw","model":"SCH-I535PP"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"d2xar","model":"SCH-R530X"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"m0","model":"GT-I9300"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"m0","model":"GT-I9300T"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"m0apt","model":"SCH-I939"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"m0chn","model":"GT-I9300"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"m0cmcc","model":"GT-I9308"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"m0ctc","model":"SCH-I939"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"m0ctcduos","model":"SCH-I939D"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"m0skt","model":"SHW-M440S"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"m3","model":"GT-I9305"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"m3","model":"GT-I9305N"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"m3","model":"GT-I9305T"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"m3dcm","model":"GravityQuad"},{"manufacturer":"Samsung","market_name":"Galaxy S3","codename":"m3dcm","model":"SC-03E"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Duos","codename":"arubaslim","model":"GT-I8262B"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Mini","codename":"golden","model":"GT-I8190"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Mini","codename":"golden","model":"GT-I8190L"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Mini","codename":"golden","model":"GT-I8190N"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Mini","codename":"golden","model":"GT-I8190T"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Mini","codename":"goldenlteatt","model":"SAMSUNG-SM-G730A"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Mini","codename":"goldenltebmc","model":"SM-G730W8"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Mini","codename":"goldenltevzw","model":"SM-G730V"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Mini","codename":"goldenve3g","model":"GT-I8200L"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Mini Value Edition","codename":"goldenve3g","model":"GT-I8200N"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Mini Value Edition","codename":"goldenvess3g","model":"GT-I8200"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Mini Value Edition","codename":"goldenvess3g","model":"GT-I8200Q"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Neo","codename":"s3ve3g","model":"GT-I9300I"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Neo","codename":"s3ve3g","model":"GT-I9301I"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Neo","codename":"s3ve3g","model":"GT-I9301Q"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Neo","codename":"s3ve3gdd","model":"GT-I9300I"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Neo","codename":"s3ve3gds","model":"GT-I9300I"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Neo","codename":"s3ve3gdsdd","model":"GT-I9300I"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Neo Plus","codename":"s3ve3g","model":"GT-I9300I"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Neo Plus","codename":"s3ve3g","model":"GT-I9308I"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Progre","codename":"SCL21","model":"SCL21"},{"manufacturer":"Samsung","market_name":"Galaxy S3 Slim","codename":"wilcoxds","model":"SM-G3812B"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"SC-04E","model":"SC-04E"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"ja3g","model":"GT-I9500"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"ja3gduosctc","model":"SCH-I959"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jaltektt","model":"SHV-E300K"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jaltelgt","model":"SHV-E300L"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jalteskt","model":"SHV-E300S"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jflte","model":"GT-I9505"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jflte","model":"GT-I9508"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jflte","model":"GT-I9508C"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jflteMetroPCS","model":"SGH-M919N"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jflteaio","model":"SAMSUNG-SGH-I337Z"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jflteatt","model":"SAMSUNG-SGH-I337"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jfltecan","model":"SGH-I337M"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jfltecan","model":"SGH-M919V"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jfltecri","model":"SCH-R970C"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jfltecsp","model":"SCH-R970X"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jfltelra","model":"SCH-I545L"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jflterefreshspr","model":"SPH-L720T"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jfltespr","model":"SPH-L720"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jfltetfnatt","model":"SM-S975L"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jfltetfntmo","model":"SGH-S970G"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jfltetmo","model":"SGH-M919"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jflteusc","model":"SCH-R970"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jfltevzw","model":"SCH-I545"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jfltevzwpp","model":"SCH-I545PP"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jftdd","model":"GT-I9507"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jftdd","model":"GT-I9507V"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jfvelte","model":"GT-I9515"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jfvelte","model":"GT-I9515L"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jfwifi","model":"GT-I9505X"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"jsglte","model":"GT-I9508V"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"ks01lte","model":"GT-I9506"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"ks01ltektt","model":"SHV-E330K"},{"manufacturer":"Samsung","market_name":"Galaxy S4","codename":"ks01ltelgt","model":"SHV-E330L"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Active","codename":"jactivelte","model":"GT-I9295"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Active","codename":"jactivelteatt","model":"SAMSUNG-SGH-I537"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Active","codename":"jactivelteatt","model":"SGH-I537"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Active","codename":"jactivelteskt","model":"SHV-E470S"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Duos","codename":"ja3gchnduos","model":"GT-I9502"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Google Play Edition","codename":"jgedlte","model":"GT-I9505G"},{"manufacturer":"Samsung","market_name":"Galaxy S4 LTE-A","codename":"ks01lteskt","model":"SHV-E330S"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serrano3g","model":"GT-I9190"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serranods","model":"GT-I9192"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serranolte","model":"GT-I9195"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serranolte","model":"GT-I9195L"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serranolte","model":"GT-I9195T"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serranolte","model":"GT-I9195X"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serranolte","model":"GT-I9197"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serranoltebmc","model":"SGH-I257M"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serranoltektt","model":"SHV-E370K"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serranoltekx","model":"SHV-E370D"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serranoltelra","model":"SCH-I435L"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serranoltespr","model":"SPH-L520"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serranolteusc","model":"SCH-R890"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serranoltevzw","model":"SCH-I435"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serranove3g","model":"GT-I9192I"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serranovelte","model":"GT-I9195I"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Mini","codename":"serranovolteatt","model":"SAMSUNG-SGH-I257"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Zoom","codename":"mproject3g","model":"SM-C101"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Zoom","codename":"mprojectlteatt","model":"SAMSUNG-SM-C105A"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Zoom","codename":"mprojectltektt","model":"SM-C105K"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Zoom","codename":"mprojectltelgt","model":"SM-C105L"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Zoom","codename":"mprojectlteskt","model":"SM-C105S"},{"manufacturer":"Samsung","market_name":"Galaxy S4 Zoom","codename":"mprojectqlte","model":"SM-C105"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"SC-04F","model":"SC-04F"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"SCL23","model":"SCL23"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"k3g","model":"SM-G900H"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"klte","model":"SM-G9008W"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"klte","model":"SM-G9009W"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"klte","model":"SM-G900F"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"klte","model":"SM-G900FQ"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"klte","model":"SM-G900I"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"klte","model":"SM-G900M"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"klte","model":"SM-G900MD"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"klteMetroPCS","model":"SM-G900T1"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"klteMetroPCS","model":"SM-G900T4"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"klteacg","model":"SM-G900R7"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"klteaio","model":"SAMSUNG-SM-G900AZ"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"klteatt","model":"SAMSUNG-SM-G900A"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"kltecan","model":"SM-G900W8"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"klteduoszn","model":"SM-G9006W"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"kltektt","model":"SM-G900K"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"kltelgt","model":"SM-G900L"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"kltelra","model":"SM-G900R6"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"klteskt","model":"SM-G900S"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"kltespr","model":"SM-G900P"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"kltetfnvzw","model":"SM-S903VL"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"kltetmo","model":"SM-G900T"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"kltetmo","model":"SM-G900T3"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"klteusc","model":"SM-G900R4"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"kltevzw","model":"SM-G900V"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"kwifi","model":"SM-G900X"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"lentisltektt","model":"SM-G906K"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"lentisltelgt","model":"SM-G906L"},{"manufacturer":"Samsung","market_name":"Galaxy S5","codename":"lentislteskt","model":"SM-G906S"},{"manufacturer":"Samsung","market_name":"Galaxy S5 Active","codename":"SC-02G","model":"SC-02G"},{"manufacturer":"Samsung","market_name":"Galaxy S5 Active","codename":"kactiveltekx","model":"SM-G870F0"},{"manufacturer":"Samsung","market_name":"Galaxy S5 Active","codename":"klteactive","model":"SM-G870F"},{"manufacturer":"Samsung","market_name":"Galaxy S5 Active","codename":"klteattactive","model":"SAMSUNG-SM-G870A"},{"manufacturer":"Samsung","market_name":"Galaxy S5 Active","codename":"kltecanactive","model":"SM-G870W"},{"manufacturer":"Samsung","market_name":"Galaxy S5 Dual SIM","codename":"klte","model":"SM-G900FD"},{"manufacturer":"Samsung","market_name":"Galaxy S5 Google Play Edition","codename":"kgedlte","model":"SM-G900FG"},{"manufacturer":"Samsung","market_name":"Galaxy S5 K Sport","codename":"kltesprsports","model":"SM-G860P"},{"manufacturer":"Samsung","market_name":"Galaxy S5 LTE-A","codename":"kccat6","model":"SM-G901F"},{"manufacturer":"Samsung","market_name":"Galaxy S5 Mini","codename":"kmini3g","model":"SM-G800H"},{"manufacturer":"Samsung","market_name":"Galaxy S5 Mini","codename":"kminilte","model":"SM-G800F"},{"manufacturer":"Samsung","market_name":"Galaxy S5 Mini","codename":"kminilte","model":"SM-G800Y"},{"manufacturer":"Samsung","market_name":"Galaxy S5 Mini","codename":"kminilteusc","model":"SM-G800R4"},{"manufacturer":"Samsung","market_name":"Galaxy S5 Neo","codename":"s5neolte","model":"SM-G903F"},{"manufacturer":"Samsung","market_name":"Galaxy S5 Neo","codename":"s5neolte","model":"SM-G903M"},{"manufacturer":"Samsung","market_name":"Galaxy S5 Neo","codename":"s5neoltecan","model":"SM-G903W"},{"manufacturer":"Samsung","market_name":"Galaxy S5 mini","codename":"kmini3g","model":"SM-G800HQ"},{"manufacturer":"Samsung","market_name":"Galaxy S5 mini","codename":"kminilte","model":"SM-G800M"},{"manufacturer":"Samsung","market_name":"Galaxy S5 mini","codename":"kminilteatt","model":"SAMSUNG-SM-G800A"},{"manufacturer":"Samsung","market_name":"Galaxy S5 mini","codename":"kminiwifi","model":"SM-G800X"},{"manufacturer":"Samsung","market_name":"Galaxy S5 mini LTE","codename":"kminilte","model":"SM-G800Y"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"SC-05G","model":"SC-05G"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zeroflte","model":"SM-G920F"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zeroflte","model":"SM-G920I"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zeroflte","model":"SM-G920X"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zeroflteacg","model":"SM-G920R7"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zeroflteaio","model":"SAMSUNG-SM-G920AZ"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zeroflteatt","model":"SAMSUNG-SM-G920A"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zerofltebmc","model":"SM-G920W8"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zerofltechn","model":"SM-G9200"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zerofltechn","model":"SM-G9208"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zerofltectc","model":"SM-G9209"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zerofltektt","model":"SM-G920K"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zerofltelgt","model":"SM-G920L"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zerofltelra","model":"SM-G920R6"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zerofltemtr","model":"SM-G920T1"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zeroflteskt","model":"SM-G920S"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zerofltespr","model":"SM-G920P"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zerofltetfnvzw","model":"SM-S906L"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zerofltetfnvzw","model":"SM-S907VL"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zerofltetmo","model":"SM-G920T"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zeroflteusc","model":"SM-G920R4"},{"manufacturer":"Samsung","market_name":"Galaxy S6","codename":"zerofltevzw","model":"SM-G920V"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Active","codename":"marinelteatt","model":"SAMSUNG-SM-G890A"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"404SC","model":"404SC"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"SC-04G","model":"SC-04G"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"SCV31","model":"SCV31"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"zerolte","model":"SM-G925F"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"zerolte","model":"SM-G925I"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"zerolte","model":"SM-G925X"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"zerolteacg","model":"SM-G925R7"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"zerolteatt","model":"SAMSUNG-SM-G925A"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"zeroltebmc","model":"SM-G925W8"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"zeroltechn","model":"SM-G9250"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"zeroltektt","model":"SM-G925K"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"zeroltelgt","model":"SM-G925L"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"zeroltelra","model":"SM-G925R6"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"zerolteskt","model":"SM-G925S"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"zeroltespr","model":"SM-G925P"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"zeroltetmo","model":"SM-G925T"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"zerolteusc","model":"SM-G925R4"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge","codename":"zeroltevzw","model":"SM-G925V"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenlte","model":"SM-G9287"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenlte","model":"SM-G9287C"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenlte","model":"SM-G928C"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenlte","model":"SM-G928F"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenlte","model":"SM-G928G"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenlte","model":"SM-G928I"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenlte","model":"SM-G928X"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenlteatt","model":"SAMSUNG-SM-G928A"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenltebmc","model":"SM-G928W8"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenltechn","model":"SM-G9280"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenltektt","model":"SM-G928K"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenltekx","model":"SM-G928N0"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenltelgt","model":"SM-G928L"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenlteskt","model":"SM-G928S"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenltespr","model":"SM-G928P"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenltetmo","model":"SM-G928T"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenlteusc","model":"SM-G928R4"},{"manufacturer":"Samsung","market_name":"Galaxy S6 Edge+","codename":"zenltevzw","model":"SM-G928V"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"herolte","model":"SM-G930F"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"herolte","model":"SM-G930X"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroltebmc","model":"SM-G930W8"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroltektt","model":"SM-G930K"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroltelgt","model":"SM-G930L"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"herolteskt","model":"SM-G930S"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroqlteacg","model":"SM-G930R7"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroqlteaio","model":"SAMSUNG-SM-G930AZ"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroqlteatt","model":"SAMSUNG-SM-G930A"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroqltecctvzw","model":"SM-G930VC"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroqltechn","model":"SM-G9300"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroqltechn","model":"SM-G9308"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroqltelra","model":"SM-G930R6"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroqltemtr","model":"SM-G930T1"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroqltespr","model":"SM-G930P"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroqltetfnvzw","model":"SM-G930VL"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroqltetmo","model":"SM-G930T"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroqlteue","model":"SM-G930U"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroqlteusc","model":"SM-G930R4"},{"manufacturer":"Samsung","market_name":"Galaxy S7","codename":"heroqltevzw","model":"SM-G930V"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Active","codename":"poseidonlteatt","model":"SAMSUNG-SM-G891A"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Edge","codename":"SC-02H","model":"SC-02H"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Edge","codename":"SCV33","model":"SCV33"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Edge","codename":"hero2lte","model":"SM-G935F"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Edge","codename":"hero2lte","model":"SM-G935X"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Edge","codename":"hero2ltebmc","model":"SM-G935W8"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Edge","codename":"hero2ltektt","model":"SM-G935K"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Edge","codename":"hero2ltelgt","model":"SM-G935L"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Edge","codename":"hero2lteskt","model":"SM-G935S"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Edge","codename":"hero2qlteatt","model":"SAMSUNG-SM-G935A"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Edge","codename":"hero2qltecctvzw","model":"SM-G935VC"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Edge","codename":"hero2qltechn","model":"SM-G9350"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Edge","codename":"hero2qltespr","model":"SM-G935P"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Edge","codename":"hero2qltetmo","model":"SM-G935T"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Edge","codename":"hero2qlteue","model":"SM-G935U"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Edge","codename":"hero2qlteusc","model":"SM-G935R4"},{"manufacturer":"Samsung","market_name":"Galaxy S7 Edge","codename":"hero2qltevzw","model":"SM-G935V"},{"manufacturer":"Samsung","market_name":"Galaxy S8","codename":"SC-02J","model":"SC-02J"},{"manufacturer":"Samsung","market_name":"Galaxy S8","codename":"SCV36","model":"SCV36"},{"manufacturer":"Samsung","market_name":"Galaxy S8","codename":"dreamlte","model":"SM-G950F"},{"manufacturer":"Samsung","market_name":"Galaxy S8","codename":"dreamlteks","model":"SM-G950N"},{"manufacturer":"Samsung","market_name":"Galaxy S8","codename":"dreamqltecan","model":"SM-G950W"},{"manufacturer":"Samsung","market_name":"Galaxy S8","codename":"dreamqltechn","model":"SM-G9500"},{"manufacturer":"Samsung","market_name":"Galaxy S8","codename":"dreamqltecmcc","model":"SM-G9508"},{"manufacturer":"Samsung","market_name":"Galaxy S8","codename":"dreamqltesq","model":"SM-G950U"},{"manufacturer":"Samsung","market_name":"Galaxy S8","codename":"dreamqlteue","model":"SM-G950U1"},{"manufacturer":"Samsung","market_name":"Galaxy S8 Active","codename":"cruiserlteatt","model":"SM-G892A"},{"manufacturer":"Samsung","market_name":"Galaxy S8 Active","codename":"cruiserltesq","model":"SM-G892U"},{"manufacturer":"Samsung","market_name":"Galaxy S8+","codename":"SC-03J","model":"SC-03J"},{"manufacturer":"Samsung","market_name":"Galaxy S8+","codename":"SCV35","model":"SCV35"},{"manufacturer":"Samsung","market_name":"Galaxy S8+","codename":"dream2lte","model":"SM-G955F"},{"manufacturer":"Samsung","market_name":"Galaxy S8+","codename":"dream2lteks","model":"SM-G955N"},{"manufacturer":"Samsung","market_name":"Galaxy S8+","codename":"dream2qltecan","model":"SM-G955W"},{"manufacturer":"Samsung","market_name":"Galaxy S8+","codename":"dream2qltechn","model":"SM-G9550"},{"manufacturer":"Samsung","market_name":"Galaxy S8+","codename":"dream2qltesq","model":"SM-G955U"},{"manufacturer":"Samsung","market_name":"Galaxy S8+","codename":"dream2qlteue","model":"SM-G955U1"},{"manufacturer":"Samsung","market_name":"Galaxy S9","codename":"SC-02K","model":"SC-02K"},{"manufacturer":"Samsung","market_name":"Galaxy S9","codename":"SCV38","model":"SCV38"},{"manufacturer":"Samsung","market_name":"Galaxy S9","codename":"starlte","model":"SM-G960F"},{"manufacturer":"Samsung","market_name":"Galaxy S9","codename":"starlteks","model":"SM-G960N"},{"manufacturer":"Samsung","market_name":"Galaxy S9","codename":"starqltechn","model":"SM-G9600"},{"manufacturer":"Samsung","market_name":"Galaxy S9","codename":"starqltecmcc","model":"SM-G9608"},{"manufacturer":"Samsung","market_name":"Galaxy S9","codename":"starqltecs","model":"SM-G960W"},{"manufacturer":"Samsung","market_name":"Galaxy S9","codename":"starqltesq","model":"SM-G960U"},{"manufacturer":"Samsung","market_name":"Galaxy S9","codename":"starqlteue","model":"SM-G960U1"},{"manufacturer":"Samsung","market_name":"Galaxy S9+","codename":"SC-03K","model":"SC-03K"},{"manufacturer":"Samsung","market_name":"Galaxy S9+","codename":"SCV39","model":"SCV39"},{"manufacturer":"Samsung","market_name":"Galaxy S9+","codename":"star2lte","model":"SM-G965F"},{"manufacturer":"Samsung","market_name":"Galaxy S9+","codename":"star2lteks","model":"SM-G965N"},{"manufacturer":"Samsung","market_name":"Galaxy S9+","codename":"star2qltechn","model":"SM-G9650"},{"manufacturer":"Samsung","market_name":"Galaxy S9+","codename":"star2qltecs","model":"SM-G965W"},{"manufacturer":"Samsung","market_name":"Galaxy S9+","codename":"star2qltesq","model":"SM-G965U"},{"manufacturer":"Samsung","market_name":"Galaxy S9+","codename":"star2qlteue","model":"SM-G965U1"},{"manufacturer":"Samsung","market_name":"Galaxy Spica","codename":"GT-I5700","model":"GT-I5700"},{"manufacturer":"Samsung","market_name":"Galaxy Spica","codename":"GT-I5700","model":"GT-I5700L"},{"manufacturer":"Samsung","market_name":"Galaxy Spica","codename":"GT-I5700","model":"GT-I5700R"},{"manufacturer":"Samsung","market_name":"Galaxy Spica","codename":"GT-I5700L","model":"GT-I5700L"},{"manufacturer":"Samsung","market_name":"Galaxy Spica","codename":"spica","model":"GT-I5700"},{"manufacturer":"Samsung","market_name":"Galaxy Spica","codename":"spica","model":"GT-I5700L"},{"manufacturer":"Samsung","market_name":"Galaxy Spica","codename":"spica","model":"GT-I5700R"},{"manufacturer":"Samsung","market_name":"Galaxy Spica","codename":"spica","model":"GT-i5700"},{"manufacturer":"Samsung","market_name":"Galaxy Star","codename":"mint","model":"GT-S5282"},{"manufacturer":"Samsung","market_name":"Galaxy Star","codename":"mintss","model":"GT-S5280"},{"manufacturer":"Samsung","market_name":"Galaxy Star Plus","codename":"logan2g","model":"GT-S7262"},{"manufacturer":"Samsung","market_name":"Galaxy Star Trios","codename":"mintts","model":"GT-S5283B"},{"manufacturer":"Samsung","market_name":"Galaxy Star2 Plus","codename":"higgs2g","model":"SM-G350E"},{"manufacturer":"Samsung","market_name":"Galaxy Stellar","codename":"jaspervzw","model":"SCH-I200"},{"manufacturer":"Samsung","market_name":"Galaxy Stellar","codename":"jaspervzw","model":"SCH-I200PP"},{"manufacturer":"Samsung","market_name":"Galaxy Stratosphere2","codename":"aegis2vzw","model":"SCH-I415"},{"manufacturer":"Samsung","market_name":"Galaxy Style Duos","codename":"aruba3gduosctc","model":"SCH-I829"},{"manufacturer":"Samsung","market_name":"Galaxy TAB3 Lite","codename":"goyairis3g","model":"SM-T116IR"},{"manufacturer":"Samsung","market_name":"Galaxy Tab","codename":"GT-P1000","model":"GT-P1000"},{"manufacturer":"Samsung","market_name":"Galaxy Tab","codename":"GT-P1000L","model":"GT-P1000L"},{"manufacturer":"Samsung","market_name":"Galaxy Tab","codename":"GT-P1000M","model":"GT-P1000M"},{"manufacturer":"Samsung","market_name":"Galaxy Tab","codename":"GT-P1000N","model":"GT-P1000N"},{"manufacturer":"Samsung","market_name":"Galaxy Tab","codename":"GT-P1000R","model":"GT-P1000R"},{"manufacturer":"Samsung","market_name":"Galaxy Tab","codename":"GT-P1000T","model":"GT-P1000T"},{"manufacturer":"Samsung","market_name":"Galaxy Tab","codename":"GT-P1010","model":"GT-P1010"},{"manufacturer":"Samsung","market_name":"Galaxy Tab","codename":"GT-P1013","model":"GT-P1013"},{"manufacturer":"Samsung","market_name":"Galaxy Tab","codename":"SC-01C","model":"SC-01C"},{"manufacturer":"Samsung","market_name":"Galaxy Tab","codename":"SCH-I800","model":"SCH-I800"},{"manufacturer":"Samsung","market_name":"Galaxy Tab","codename":"SGH-T849","model":"SGH-T849"},{"manufacturer":"Samsung","market_name":"Galaxy Tab","codename":"SHW-M180K","model":"SHW-M180K"},{"manufacturer":"Samsung","market_name":"Galaxy Tab","codename":"SHW-M180L","model":"SHW-M180L"},{"manufacturer":"Samsung","market_name":"Galaxy Tab","codename":"SHW-M180S","model":"SHW-M180S"},{"manufacturer":"Samsung","market_name":"Galaxy Tab","codename":"SHW-M180W","model":"SHW-M180W"},{"manufacturer":"Samsung","market_name":"Galaxy Tab","codename":"SMT-i9100","model":"SMT-i9100"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 10.1","codename":"GT-P7500","model":"GT-P7500"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 10.1","codename":"GT-P7500D","model":"GT-P7500D"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 10.1","codename":"GT-P7503","model":"GT-P7503"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 10.1","codename":"GT-P7510","model":"GT-P7510"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 10.1","codename":"SC-01D","model":"SC-01D"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 10.1","codename":"SCH-I905","model":"SCH-I905"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 10.1","codename":"SGH-T859","model":"SGH-T859"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 10.1","codename":"SHW-M300W","model":"SHW-M300W"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 10.1","codename":"SHW-M380K","model":"SHW-M380K"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 10.1","codename":"SHW-M380S","model":"SHW-M380S"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 10.1","codename":"SHW-M380W","model":"SHW-M380W"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 10.1 N","codename":"GT-P7501","model":"GT-P7501"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 10.1 N","codename":"GT-P7511","model":"GT-P7511"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 10.1 v","codename":"p3","model":"GT-P7100"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 3 Lite","codename":"goyairis3g","model":"SM-T116IR"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 3V 7.0","codename":"goyave3g5M","model":"SM-T116NY"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 4 8.0","codename":"milletwifi","model":"SM-T330X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 4 8.0","codename":"milletwifikx","model":"SM-T330"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 4 Active","codename":"rubenslte","model":"SM-T365"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 4 Active","codename":"rubenslte","model":"SM-T365Y"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 7.0","codename":"SPH-P100","model":"SPH-P100"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 7.0 Plus","codename":"GT-P6200","model":"GT-P6200"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 7.0 Plus","codename":"GT-P6200L","model":"GT-P6200L"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 7.0 Plus","codename":"GT-P6201","model":"GT-P6201"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 7.0 Plus","codename":"GT-P6210","model":"GT-P6210"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 7.0 Plus","codename":"GT-P6211","model":"GT-P6211"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 7.0 Plus","codename":"SC-02D","model":"SC-02D"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 7.0 Plus","codename":"SGH-T869","model":"SGH-T869"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 7.0 Plus","codename":"SHW-M430W","model":"SHW-M430W"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 7.7","codename":"GT-P6800","model":"GT-P6800"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 7.7","codename":"GT-P6810","model":"GT-P6810"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 7.7","codename":"SCH-I815","model":"SCH-I815"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 7.7 Plus","codename":"SC-01E","model":"SC-01E"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 8.9","codename":"GT-P7300","model":"GT-P7300"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 8.9","codename":"GT-P7310","model":"GT-P7310"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 8.9","codename":"GT-P7320","model":"GT-P7320"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 8.9","codename":"SCH-P739","model":"SCH-P739"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 8.9","codename":"SGH-I957","model":"SAMSUNG-SGH-I957"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 8.9","codename":"SGH-I957D","model":"SAMSUNG-SGH-I957D"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 8.9","codename":"SGH-I957D","model":"SGH-I957D"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 8.9","codename":"SGH-I957M","model":"SAMSUNG-SGH-I957M"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 8.9","codename":"SGH-I957M","model":"SGH-I957M"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 8.9","codename":"SGH-I957R","model":"SAMSUNG-SGH-I957R"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 8.9","codename":"SGH-I957R","model":"SGH-I957R"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 8.9","codename":"SHV-E140K","model":"SHV-E140K"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 8.9","codename":"SHV-E140L","model":"SHV-E140L"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 8.9","codename":"SHV-E140S","model":"SHV-E140S"},{"manufacturer":"Samsung","market_name":"Galaxy Tab 8.9","codename":"SHW-M305W","model":"SHW-M305W"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A (2017)","codename":"gta2slte","model":"SM-T385"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A (2017)","codename":"gta2sltektt","model":"SM-T385K"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A (2017)","codename":"gta2sltelgt","model":"SM-T385L"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A (2017)","codename":"gta2slteskt","model":"SM-T385S"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A (2017)","codename":"gta2swifi","model":"SM-T380"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 10.1","codename":"gtanotexlwifikx","model":"SM-P580"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 10.1","codename":"gtaxllte","model":"SM-T585"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 10.1","codename":"gtaxllte","model":"SM-T585M"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 10.1","codename":"gtaxllte","model":"SM-T587"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 10.1","codename":"gtaxlltechn","model":"SM-T585C"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 10.1","codename":"gtaxlltekx","model":"SM-T585N0"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 10.1","codename":"gtaxlwifi","model":"SM-T580"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 10.1","codename":"gtaxlwifi","model":"SM-T580X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 10.1","codename":"gtaxlwifichn","model":"SM-T580"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 10.1","codename":"gtaxlwifichn","model":"SM-T580X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 10.1(2016)","codename":"gtanotexllte","model":"SM-P585"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 10.1(2016)","codename":"gtanotexllte","model":"SM-P585Y"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 7.0","codename":"gtexslte","model":"SM-T285"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 7.0","codename":"gtexslte","model":"SM-T285M"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 7.0","codename":"gtexslte","model":"SM-T287"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 7.0","codename":"gtexslteswa","model":"SM-T285YD"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 7.0","codename":"gtexswifi","model":"SM-T280"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 8.0","codename":"gt58lte","model":"SM-T355"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 8.0","codename":"gt58lte","model":"SM-T355Y"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 8.0","codename":"gt58ltechn","model":"SM-T355C"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 8.0","codename":"gt58ltetmo","model":"SM-T357T"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 8.0","codename":"gt58wifi","model":"SM-T350"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 8.0","codename":"gt58wifi","model":"SM-T350X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 8.0","codename":"gt58wifichn","model":"SM-T350"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 8.0","codename":"gt58wifichn","model":"SM-T350X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 8.0","codename":"gt5note8lte","model":"SM-P355"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 8.0","codename":"gt5note8lte","model":"SM-P355M"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 8.0","codename":"gt5note8ltechn","model":"SM-P355C"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 8.0","codename":"gt5note8ltechn","model":"SM-P355Y"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 8.0","codename":"gt5note8wifi","model":"SM-P350"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 8.0","codename":"gt5note8wifichn","model":"SM-P350"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 9.7","codename":"gt510lte","model":"SM-T555"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 9.7","codename":"gt510ltechn","model":"SM-T555C"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 9.7","codename":"gt510wifi","model":"SM-T550"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 9.7","codename":"gt510wifi","model":"SM-T550X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 9.7","codename":"gt510wifichn","model":"SM-T550"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 9.7","codename":"gt510wifichn","model":"SM-T550X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 9.7","codename":"gt5note10lte","model":"SM-P555"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 9.7","codename":"gt5note10lte","model":"SM-P555M"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 9.7","codename":"gt5note10ltechn","model":"SM-P555C"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 9.7","codename":"gt5note10ltehktw","model":"SM-P555Y"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 9.7","codename":"gt5note10ltektt","model":"SM-P555K"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 9.7","codename":"gt5note10ltelgt","model":"SM-P555L"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 9.7","codename":"gt5note10lteskt","model":"SM-P555S"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 9.7","codename":"gt5note10wifi","model":"SM-P550"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A 9.7","codename":"gt5note10wifichn","model":"SM-P550"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A S 8.0","codename":"gt58ltebmc","model":"SM-T357W"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A2 8.0","codename":"gta2slte","model":"SM-T385M"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A2 8.0","codename":"gta2sltechn","model":"SM-T385C"},{"manufacturer":"Samsung","market_name":"Galaxy Tab A2 8.0","codename":"gta2swifichn","model":"SM-T380C"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Active2","codename":"gtactive2lte","model":"SM-T395"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Active2","codename":"gtactive2ltechn","model":"SM-T395C"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Active2","codename":"gtactive2ltekx","model":"SM-T395N"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Active2","codename":"gtactive2lteue","model":"SM-T397U"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Active2","codename":"gtactive2wifi","model":"SM-T390"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 8.0","codename":"gteslteatt","model":"SAMSUNG-SM-T377A"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 8.0","codename":"gtesltebmc","model":"SM-T377W"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 8.0","codename":"gtesltelgt","model":"SM-T375L"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 8.0","codename":"gteslteskt","model":"SM-T375S"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 8.0","codename":"gtesltetmo","model":"SM-T377T"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 8.0","codename":"gtesltetw","model":"SM-T3777"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 8.0","codename":"gtesltevzw","model":"SM-T377V"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 8.0","codename":"gtesqltespr","model":"SM-T377P"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 8.0","codename":"gtesqlteusc","model":"SM-T377R4"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 9.6","codename":"gtel3g","model":"SM-T561"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 9.6","codename":"gtel3g","model":"SM-T561M"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 9.6","codename":"gtel3g","model":"SM-T561Y"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 9.6","codename":"gtel3g","model":"SM-T562"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 9.6","codename":"gtelltevzw","model":"SM-T567V"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 9.6","codename":"gtelwifi","model":"SM-T560"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 9.6","codename":"gtelwifichn","model":"SM-T560"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E 9.6","codename":"gtelwifiue","model":"SM-T560NU"},{"manufacturer":"Samsung","market_name":"Galaxy Tab E8.0","codename":"gtesveltevzw","model":"SM-T378V"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Plus 7.0","codename":"goyave3gsea","model":"SM-T116BU"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Pro 10.1","codename":"picassolte","model":"SM-T525"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Pro 10.1","codename":"picassowifi","model":"SM-T520"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Pro 10.1 Chef Collection","codename":"picassowificc","model":"SM-T520CC"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Pro 12.2","codename":"v2lte","model":"SM-T905"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Pro 12.2","codename":"v2wifi","model":"SM-T900"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Pro 12.2","codename":"v2wifi","model":"SM-T900X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Pro 8.4","codename":"mondrianlte","model":"SM-T325"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Pro 8.4","codename":"mondrianwifi","model":"SM-T320"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Pro 8.4","codename":"mondrianwifi","model":"SM-T320X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Pro 8.4","codename":"mondrianwifikx","model":"SM-T320"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Pro 8.4","codename":"mondrianwifiue","model":"SM-T320"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Pro 8.4","codename":"mondrianwifiue","model":"SM-T320NU"},{"manufacturer":"Samsung","market_name":"Galaxy Tab Q","codename":"q7","model":"SM-T2519"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S 10.5","codename":"chagallwifi","model":"SM-T800"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S 8.4","codename":"SC-03G","model":"SC-03G"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S 8.4","codename":"klimtlte","model":"SM-T705"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S 8.4","codename":"klimtlte","model":"SM-T705C"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S 8.4","codename":"klimtlte","model":"SM-T705Y"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S 8.4","codename":"klimtltevzw","model":"SM-T707V"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S 8.4","codename":"klimtwifi","model":"SM-T700"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 8.0","codename":"gts210lte","model":"SM-T815"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 8.0","codename":"gts28lte","model":"SM-T715"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 8.0","codename":"gts28lte","model":"SM-T715Y"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 8.0","codename":"gts28ltechn","model":"SM-T715C"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 8.0","codename":"gts28ltekx","model":"SM-T715N0"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 8.0","codename":"gts28velte","model":"SM-T719"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 8.0","codename":"gts28velte","model":"SM-T719Y"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 8.0","codename":"gts28veltechn","model":"SM-T719C"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 8.0","codename":"gts28vewifi","model":"SM-T713"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 8.0","codename":"gts28vewifichn","model":"SM-T713"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 8.0","codename":"gts28wifi","model":"SM-T710"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 8.0","codename":"gts28wifi","model":"SM-T710X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 8.0","codename":"gts28wifichn","model":"SM-T710"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210lte","model":"SM-T815C"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210lte","model":"SM-T815Y"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210lte","model":"SM-T817"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210lteatt","model":"SAMSUNG-SM-T817A"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210ltecan","model":"SM-T817W"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210ltekx","model":"SM-T815N0"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210ltespr","model":"SM-T817P"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210ltetmo","model":"SM-T817T"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210lteusc","model":"SM-T817R4"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210ltevzw","model":"SM-T817V"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210velte","model":"SM-T818"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210velte","model":"SM-T819"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210velte","model":"SM-T819Y"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210velteatt","model":"SAMSUNG-SM-T818A"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210veltecan","model":"SM-T818W"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210veltechn","model":"SM-T819C"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210veltetmo","model":"SM-T818T"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210vewifi","model":"SM-T813"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210vewifichn","model":"SM-T813"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210wifi","model":"SM-T810"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S2 9.7","codename":"gts210wifi","model":"SM-T810X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S3","codename":"gts3llte","model":"SM-T825"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S3","codename":"gts3llte","model":"SM-T825C"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S3","codename":"gts3llte","model":"SM-T825X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S3","codename":"gts3llte","model":"SM-T827"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S3","codename":"gts3lltekx","model":"SM-T825N0"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S3","codename":"gts3llteusc","model":"SM-T827R4"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S3","codename":"gts3lltevzw","model":"SM-T827V"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S3","codename":"gts3lwifi","model":"SM-T820"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S3","codename":"gts3lwifi","model":"SM-T820X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab S3","codename":"gts3lwifichn","model":"SM-T820"},{"manufacturer":"Samsung","market_name":"Galaxy Tab2 10.1","codename":"espresso10att","model":"SAMSUNG-SGH-I497"},{"manufacturer":"Samsung","market_name":"Galaxy Tab2 10.1","codename":"espresso10can","model":"SGH-I497"},{"manufacturer":"Samsung","market_name":"Galaxy Tab2 10.1","codename":"espresso10rf","model":"GT-P5100"},{"manufacturer":"Samsung","market_name":"Galaxy Tab2 10.1","codename":"espresso10spr","model":"SPH-P500"},{"manufacturer":"Samsung","market_name":"Galaxy Tab2 10.1","codename":"espresso10tmo","model":"SGH-T779"},{"manufacturer":"Samsung","market_name":"Galaxy Tab2 10.1","codename":"espresso10vzw","model":"SCH-I915"},{"manufacturer":"Samsung","market_name":"Galaxy Tab2 10.1","codename":"espresso10wifi","model":"GT-P5110"},{"manufacturer":"Samsung","market_name":"Galaxy Tab2 10.1","codename":"espresso10wifi","model":"GT-P5113"},{"manufacturer":"Samsung","market_name":"Galaxy Tab2 7.0","codename":"espressorf","model":"GT-P3100"},{"manufacturer":"Samsung","market_name":"Galaxy Tab2 7.0","codename":"espressorf","model":"GT-P3100B"},{"manufacturer":"Samsung","market_name":"Galaxy Tab2 7.0","codename":"espressorf","model":"GT-P3105"},{"manufacturer":"Samsung","market_name":"Galaxy Tab2 7.0","codename":"espressovzw","model":"SCH-I705"},{"manufacturer":"Samsung","market_name":"Galaxy Tab2 7.0","codename":"espressovzw","model":"SCH-i705"},{"manufacturer":"Samsung","market_name":"Galaxy Tab2 7.0","codename":"espressowifi","model":"GT-P3110"},{"manufacturer":"Samsung","market_name":"Galaxy Tab2 7.0","codename":"espressowifi","model":"GT-P3113"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3","codename":"lt01wifikx","model":"SM-T310"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 10.1","codename":"santos103g","model":"GT-P5200"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 10.1","codename":"santos10lte","model":"GT-P5220"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 10.1","codename":"santos10wifi","model":"GT-P5210"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 10.1","codename":"santos10wifi","model":"GT-P5210XD1"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 7.0","codename":"lt023g","model":"SM-T211"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 7.0","codename":"lt023g","model":"SM-T212"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 7.0","codename":"lt023gdtv","model":"SM-T211M"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 7.0","codename":"lt02lte","model":"SM-T215"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 7.0","codename":"lt02lteatt","model":"SAMSUNG-SM-T217A"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 7.0","codename":"lt02ltespr","model":"SM-T217S"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 7.0","codename":"lt02ltetmo","model":"SM-T217T"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 7.0","codename":"lt02wifi","model":"SM-T210"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 7.0","codename":"lt02wifi","model":"SM-T210R"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 7.0","codename":"lt02wifilgt","model":"SM-T210L"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 8.0","codename":"lt013g","model":"SM-T311"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 8.0","codename":"lt013g","model":"SM-T312"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 8.0","codename":"lt01lte","model":"SM-T315"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 8.0","codename":"lt01lte","model":"SM-T315T"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 8.0","codename":"lt01wifi","model":"SM-T310"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 8.0","codename":"lt01wifi","model":"SM-T310X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 8.0","codename":"lt02lduwifi","model":"SM-T210X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 Kids","codename":"lt02kidswifi","model":"SM-T2105"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 Lite","codename":"goya3g","model":"SM-T111"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 Lite","codename":"goya3g","model":"SM-T111M"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 Lite","codename":"goyawifi","model":"SM-T110"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 Lite 7.0","codename":"goyave3g","model":"SM-T116NQ"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 Lite 7.0","codename":"goyavewifi","model":"SM-T113"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3 VE 7.0","codename":"goyave3g","model":"SM-T116"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3V 7.0","codename":"goyave3gsea","model":"SM-T116NU"},{"manufacturer":"Samsung","market_name":"Galaxy Tab3V 7.0","codename":"goyavewifixtc","model":"SM-T113NU"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4","codename":"matissewifigoogle","model":"SM-T530NN"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 10.0","codename":"matisse3g","model":"SM-T531"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 10.0","codename":"matisselte","model":"SM-T535"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 10.0","codename":"matisselteatt","model":"SAMSUNG-SM-T537A"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 10.0","codename":"matisselteusc","model":"SM-T537R4"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 10.0","codename":"matisseltevzw","model":"SM-T537V"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 10.1","codename":"matisse10wifikx","model":"SM-T536"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 10.1","codename":"matissevewifi","model":"SM-T533"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 10.1","codename":"matissewifi","model":"SM-T530"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 10.1","codename":"matissewifi","model":"SM-T530X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 10.1","codename":"matissewifikx","model":"SM-T530"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 10.1","codename":"matissewifiue","model":"SM-T530NU"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"403SC","model":"403SC"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degas2wifi","model":"SM-T230NW"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degas2wifibmwchn","model":"SM-T230NW"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degas3g","model":"SM-T231"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degas3g","model":"SM-T232"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degaslte","model":"SM-T235"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degaslte","model":"SM-T235Y"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degasltespr","model":"SM-T237P"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degasltevzw","model":"SM-T237V"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degasvelte","model":"SM-T239"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degasvelte","model":"SM-T2397"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degasvelte","model":"SM-T239M"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degasveltechn","model":"SM-T239C"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degaswifi","model":"SM-T230"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degaswifi","model":"SM-T230NY"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degaswifi","model":"SM-T230X"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degaswifibmwzc","model":"SM-T230NY"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degaswifidtv","model":"SM-T230NT"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degaswifiopenbnn","model":"SM-T230NU"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 7.0","codename":"degaswifiue","model":"SM-T230NU"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 8.0","codename":"millet3g","model":"SM-T331"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 8.0","codename":"milletlte","model":"SM-T335"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 8.0","codename":"milletlteatt","model":"SAMSUNG-SM-T337A"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 8.0","codename":"milletltektt","model":"SM-T335K"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 8.0","codename":"milletltelgt","model":"SM-T335L"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 8.0","codename":"milletltetmo","model":"SM-T337T"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 8.0","codename":"milletltevzw","model":"SM-T337V"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 8.0","codename":"milletwifi","model":"SM-T330"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 8.0","codename":"milletwifiue","model":"SM-T330NU"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 Active","codename":"rubenslte","model":"SM-T365"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 Active","codename":"rubenslte","model":"SM-T365M"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 Active","codename":"rubensltekx","model":"SM-T365F0"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 Active","codename":"rubenswifi","model":"SM-T360"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 Active","codename":"rubenswifichn","model":"SM-T360"},{"manufacturer":"Samsung","market_name":"Galaxy Tab4 Nook 10.1","codename":"matissewifiopenbnn","model":"SM-T530NU"},{"manufacturer":"Samsung","market_name":"Galaxy TabA Plus 10.1","codename":"gtanotexllte","model":"SM-P585M"},{"manufacturer":"Samsung","market_name":"Galaxy TabA Plus 10.1","codename":"gtanotexllte","model":"SM-P587"},{"manufacturer":"Samsung","market_name":"Galaxy TabA Plus 10.1","codename":"gtanotexlltechn","model":"SM-P588C"},{"manufacturer":"Samsung","market_name":"Galaxy TabA Plus 10.1","codename":"gtanotexlltekx","model":"SM-P585N0"},{"manufacturer":"Samsung","market_name":"Galaxy TabA Plus 10.1","codename":"gtanotexlwifichn","model":"SM-P583"},{"manufacturer":"Samsung","market_name":"Galaxy TabA Plus 10.1","codename":"gtaxlqltespr","model":"SM-T587P"},{"manufacturer":"Samsung","market_name":"Galaxy TabA Plus10.1","codename":"gtanotexlwifikx","model":"SM-P580X"},{"manufacturer":"Samsung","market_name":"Galaxy TabE 8.0","codename":"gtesltektt","model":"SM-T378K"},{"manufacturer":"Samsung","market_name":"Galaxy TabE 8.0","codename":"gtesltelgt","model":"SM-T378L"},{"manufacturer":"Samsung","market_name":"Galaxy TabE 8.0","codename":"gteslteskt","model":"SM-T378S"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"SCT21","model":"SCT21"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"chagallhltektt","model":"SM-T805K"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"chagallhltelgt","model":"SM-T805L"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"chagallhlteskt","model":"SM-T805S"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"chagalllte","model":"SM-T805"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"chagalllte","model":"SM-T805M"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"chagalllte","model":"SM-T805Y"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"chagalllte","model":"SM-T807"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"chagalllteatt","model":"SAMSUNG-SM-T807A"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"chagallltecan","model":"SM-T805W"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"chagallltespr","model":"SM-T807P"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"chagallltetmo","model":"SM-T807T"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"chagalllteusc","model":"SM-T807R4"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"chagallltevzw","model":"SM-T807V"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"chagallwifi","model":"SM-T800"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"chagallwifi","model":"SM-T800X"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 10.5","codename":"chagallwifikx","model":"SM-T800"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 8.4","codename":"klimtlte","model":"SM-T705"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 8.4","codename":"klimtlte","model":"SM-T705M"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 8.4","codename":"klimtlteatt","model":"SAMSUNG-SM-T707A"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 8.4","codename":"klimtltecan","model":"SM-T705W"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 8.4","codename":"klimtwifi","model":"SM-T700"},{"manufacturer":"Samsung","market_name":"Galaxy TabS 8.4","codename":"klimtwifikx","model":"SM-T700"},{"manufacturer":"Samsung","market_name":"Galaxy TabS2 9.7","codename":"gts210veltevzw","model":"SM-T818V"},{"manufacturer":"Samsung","market_name":"Galaxy TabS3","codename":"gts3llte","model":"SM-T825"},{"manufacturer":"Samsung","market_name":"Galaxy TabS3","codename":"gts3llte","model":"SM-T825Y"},{"manufacturer":"Samsung","market_name":"Galaxy TabS3","codename":"gts3lltechn","model":"SM-T825C"},{"manufacturer":"Samsung","market_name":"Galaxy Tap Pro 10.1","codename":"picassolte","model":"SM-T525"},{"manufacturer":"Samsung","market_name":"Galaxy Tap Pro 8.4","codename":"mondrianwifi","model":"SM-T320"},{"manufacturer":"Samsung","market_name":"Galaxy Trend","codename":"kyleve","model":"GT-S7392"},{"manufacturer":"Samsung","market_name":"Galaxy Trend","codename":"kyleve","model":"GT-S7392L"},{"manufacturer":"Samsung","market_name":"Galaxy Trend","codename":"kyleve3gcmcc","model":"GT-S7568I"},{"manufacturer":"Samsung","market_name":"Galaxy Trend Duos","codename":"kyleichn","model":"GT-S7562i"},{"manufacturer":"Samsung","market_name":"Galaxy Trend Duos","codename":"kylepluschn","model":"GT-S7572"},{"manufacturer":"Samsung","market_name":"Galaxy Trend Duos","codename":"kyleve","model":"GT-S7390"},{"manufacturer":"Samsung","market_name":"Galaxy Trend Duos","codename":"kyleve","model":"GT-S7392"},{"manufacturer":"Samsung","market_name":"Galaxy Trend Duos","codename":"kyleve","model":"GT-S7562C"},{"manufacturer":"Samsung","market_name":"Galaxy Trend Lite","codename":"kylevess","model":"GT-S7390"},{"manufacturer":"Samsung","market_name":"Galaxy Trend Lite","codename":"kylevess","model":"GT-S7390L"},{"manufacturer":"Samsung","market_name":"Galaxy Trend Plus","codename":"kylepro","model":"GT-S7580"},{"manufacturer":"Samsung","market_name":"Galaxy Trend Plus","codename":"kylepro","model":"GT-S7580E"},{"manufacturer":"Samsung","market_name":"Galaxy Trend Plus","codename":"kylepro","model":"GT-S7580L"},{"manufacturer":"Samsung","market_name":"Galaxy Trend Plus","codename":"kylepro","model":"GT-S7583T"},{"manufacturer":"Samsung","market_name":"Galaxy Trend2","codename":"garda3gcmcc","model":"GT-S7898"},{"manufacturer":"Samsung","market_name":"Galaxy Trend2","codename":"gardave3gcmcc","model":"GT-S7898I"},{"manufacturer":"Samsung","market_name":"Galaxy Trend2","codename":"kyleplusctc","model":"SCH-I739"},{"manufacturer":"Samsung","market_name":"Galaxy Trend3","codename":"cs023g","model":"SM-G3502U"},{"manufacturer":"Samsung","market_name":"Galaxy Trend3","codename":"cs02cmcc","model":"SM-G3508"},{"manufacturer":"Samsung","market_name":"Galaxy Trend3","codename":"cs02ctc","model":"SM-G3509"},{"manufacturer":"Samsung","market_name":"Galaxy Trend3","codename":"cs02ve","model":"SM-G3508I"},{"manufacturer":"Samsung","market_name":"Galaxy Trend3","codename":"cs02ve3g","model":"SM-G3502C"},{"manufacturer":"Samsung","market_name":"Galaxy Trend3","codename":"cs02ve3g","model":"SM-G3502I"},{"manufacturer":"Samsung","market_name":"Galaxy Trend3","codename":"cs02ve3g","model":"SM-G3508J"},{"manufacturer":"Samsung","market_name":"Galaxy Trend3","codename":"cs02ve3g","model":"SM-G3509I"},{"manufacturer":"Samsung","market_name":"Galaxy U","codename":"SHW-M130L","model":"SHW-M130L"},{"manufacturer":"Samsung","market_name":"Galaxy Victory","codename":"goghspr","model":"SPH-L300"},{"manufacturer":"Samsung","market_name":"Galaxy Victory","codename":"goghvmu","model":"SPH-L300"},{"manufacturer":"Samsung","market_name":"Galaxy View","codename":"gvlte","model":"SM-T677"},{"manufacturer":"Samsung","market_name":"Galaxy View","codename":"gvlteatt","model":"SAMSUNG-SM-T677A"},{"manufacturer":"Samsung","market_name":"Galaxy View","codename":"gvltevzw","model":"SM-T677V"},{"manufacturer":"Samsung","market_name":"Galaxy View","codename":"gvltexsp","model":"SM-T677"},{"manufacturer":"Samsung","market_name":"Galaxy View","codename":"gvwifijpn","model":"SM-T670"},{"manufacturer":"Samsung","market_name":"Galaxy View","codename":"gvwifiue","model":"SM-T670"},{"manufacturer":"Samsung","market_name":"Galaxy W","codename":"GT-I8150","model":"GT-I8150"},{"manufacturer":"Samsung","market_name":"Galaxy W","codename":"GT-I8150B","model":"GT-I8150B"},{"manufacturer":"Samsung","market_name":"Galaxy W","codename":"GT-I8150T","model":"GT-I8150T"},{"manufacturer":"Samsung","market_name":"Galaxy W","codename":"SGH-T679M","model":"SGH-T679M"},{"manufacturer":"Samsung","market_name":"Galaxy W","codename":"q7lteskt","model":"SM-T255S"},{"manufacturer":"Samsung","market_name":"Galaxy Wide","codename":"on7nlteskt","model":"SM-G600S"},{"manufacturer":"Samsung","market_name":"Galaxy Wide2","codename":"j7popelteskt","model":"SM-J727S"},{"manufacturer":"Samsung","market_name":"Galaxy Win","codename":"delos3gcmcc","model":"GT-I8558"},{"manufacturer":"Samsung","market_name":"Galaxy Win","codename":"delos3gduosctc","model":"SCH-I869"},{"manufacturer":"Samsung","market_name":"Galaxy Win","codename":"delos3geur","model":"GT-I8552"},{"manufacturer":"Samsung","market_name":"Galaxy Win","codename":"delos3geur","model":"GT-I8552B"},{"manufacturer":"Samsung","market_name":"Galaxy Win","codename":"delos3gss","model":"GT-I8550E"},{"manufacturer":"Samsung","market_name":"Galaxy Win","codename":"delosltelgt","model":"SHV-E500L"},{"manufacturer":"Samsung","market_name":"Galaxy Win","codename":"deloslteskt","model":"SHV-E500S"},{"manufacturer":"Samsung","market_name":"Galaxy Win Duos","codename":"delos3gchn","model":"GT-I8552"},{"manufacturer":"Samsung","market_name":"Galaxy Win Pro","codename":"wilcox3g","model":"SM-G3818"},{"manufacturer":"Samsung","market_name":"Galaxy Win Pro","codename":"wilcoxctc","model":"SM-G3819"},{"manufacturer":"Samsung","market_name":"Galaxy Win Pro","codename":"wilcoxctc","model":"SM-G3819D"},{"manufacturer":"Samsung","market_name":"Galaxy Win Pro","codename":"wilcoxds","model":"SM-G3812"},{"manufacturer":"Samsung","market_name":"Galaxy Win2","codename":"coreprimeltedtv","model":"SM-G360BT"},{"manufacturer":"Samsung","market_name":"Galaxy Xcover","codename":"GT-S5690","model":"GT-S5690"},{"manufacturer":"Samsung","market_name":"Galaxy Xcover","codename":"GT-S5690L","model":"GT-S5690L"},{"manufacturer":"Samsung","market_name":"Galaxy Xcover","codename":"GT-S5690M","model":"GT-S5690M"},{"manufacturer":"Samsung","market_name":"Galaxy Xcover","codename":"GT-S5690R","model":"GT-S5690R"},{"manufacturer":"Samsung","market_name":"Galaxy Xcover2","codename":"skomer","model":"GT-S7710"},{"manufacturer":"Samsung","market_name":"Galaxy Xcover2","codename":"skomer","model":"GT-S7710L"},{"manufacturer":"Samsung","market_name":"Galaxy Xcover3","codename":"xcover3lte","model":"SM-G388F"},{"manufacturer":"Samsung","market_name":"Galaxy Xcover3","codename":"xcover3velte","model":"SM-G389F"},{"manufacturer":"Samsung","market_name":"Galaxy Xcover4","codename":"xcover4lte","model":"SM-G390F"},{"manufacturer":"Samsung","market_name":"Galaxy Xcover4","codename":"xcover4lte","model":"SM-G390Y"},{"manufacturer":"Samsung","market_name":"Galaxy Xcover4","codename":"xcover4ltecan","model":"SM-G390W"},{"manufacturer":"Samsung","market_name":"Galaxy Y","codename":"GT-S5360","model":"GT-S5360"},{"manufacturer":"Samsung","market_name":"Galaxy Y","codename":"GT-S5360B","model":"GT-S5360B"},{"manufacturer":"Samsung","market_name":"Galaxy Y","codename":"GT-S5360L","model":"GT-S5360L"},{"manufacturer":"Samsung","market_name":"Galaxy Y","codename":"GT-S5360T","model":"GT-S5360T"},{"manufacturer":"Samsung","market_name":"Galaxy Y","codename":"GT-S5363","model":"GT-S5363"},{"manufacturer":"Samsung","market_name":"Galaxy Y","codename":"GT-S5368","model":"GT-S5368"},{"manufacturer":"Samsung","market_name":"Galaxy Y","codename":"GT-S5369","model":"GT-S5369"},{"manufacturer":"Samsung","market_name":"Galaxy Y","codename":"SCH-I509","model":"SCH-I509"},{"manufacturer":"Samsung","market_name":"Galaxy Y","codename":"SCH-i509","model":"SCH-i509"},{"manufacturer":"Samsung","market_name":"Galaxy Y Duos","codename":"GT-S6102","model":"GT-S6102"},{"manufacturer":"Samsung","market_name":"Galaxy Y Duos","codename":"GT-S6102B","model":"GT-S6102B"},{"manufacturer":"Samsung","market_name":"Galaxy Y Duos","codename":"GT-S6102E","model":"GT-S6102E"},{"manufacturer":"Samsung","market_name":"Galaxy Y Plus","codename":"coriplusds","model":"GT-S5303"},{"manufacturer":"Samsung","market_name":"Galaxy Y Plus","codename":"coriplusds","model":"GT-S5303B"},{"manufacturer":"Samsung","market_name":"Galaxy Y Pop","codename":"GT-S6108","model":"GT-S6108"},{"manufacturer":"Samsung","market_name":"Galaxy Y Pro","codename":"GT-B5510","model":"GT-B5510"},{"manufacturer":"Samsung","market_name":"Galaxy Y Pro","codename":"GT-B5510B","model":"GT-B5510B"},{"manufacturer":"Samsung","market_name":"Galaxy Y Pro","codename":"GT-B5510L","model":"GT-B5510L"},{"manufacturer":"Samsung","market_name":"Galaxy Y Pro Duos","codename":"GT-B5512","model":"GT-B5512"},{"manufacturer":"Samsung","market_name":"Galaxy Y Pro Duos","codename":"GT-B5512B","model":"GT-B5512B"},{"manufacturer":"Samsung","market_name":"Galaxy Y TV","codename":"GT-S5367","model":"GT-S5367"},{"manufacturer":"Samsung","market_name":"Galaxy Young","codename":"roy","model":"GT-S6312"},{"manufacturer":"Samsung","market_name":"Galaxy Young","codename":"roydtv","model":"GT-S6313T"},{"manufacturer":"Samsung","market_name":"Galaxy Young","codename":"royss","model":"GT-S6310"},{"manufacturer":"Samsung","market_name":"Galaxy Young","codename":"royss","model":"GT-S6310B"},{"manufacturer":"Samsung","market_name":"Galaxy Young","codename":"royss","model":"GT-S6310L"},{"manufacturer":"Samsung","market_name":"Galaxy Young","codename":"royss","model":"GT-S6310T"},{"manufacturer":"Samsung","market_name":"Galaxy Young","codename":"royssdtv","model":"GT-S6313T"},{"manufacturer":"Samsung","market_name":"Galaxy Young","codename":"royssnfc","model":"GT-S6310N"},{"manufacturer":"Samsung","market_name":"Galaxy Young2","codename":"young23g","model":"SM-G130H"},{"manufacturer":"Samsung","market_name":"Galaxy Young2","codename":"young23g","model":"SM-G130M"},{"manufacturer":"Samsung","market_name":"Galaxy Young2","codename":"young23g","model":"SM-G130U"},{"manufacturer":"Samsung","market_name":"Galaxy Young2","codename":"young23gdtv","model":"SM-G130BT"},{"manufacturer":"Samsung","market_name":"Galaxy Young2","codename":"young2ds2g","model":"SM-G130E"},{"manufacturer":"Samsung","market_name":"Galaxy Young2","codename":"young2nfc3g","model":"SM-G130HN"},{"manufacturer":"Samsung","market_name":"Galaxy Young2 Pro","codename":"young2ve3g","model":"SM-G130BU"},{"manufacturer":"Samsung","market_name":"Galaxy player 70 Plus","codename":"YP-GB70D","model":"YP-GB70D"},{"manufacturer":"Samsung","market_name":"Galaxy view","codename":"gvltektt","model":"SM-T677NK"},{"manufacturer":"Samsung","market_name":"Galaxy view","codename":"gvltelgt","model":"SM-T677NL"},{"manufacturer":"Samsung","market_name":"Galaxy win","codename":"delos3gss","model":"GT-I8550L"},{"manufacturer":"Samsung","market_name":"Galaxy-A9(2016)","codename":"a9xltechn","model":"SM-A9000"},{"manufacturer":"Samsung","market_name":"Garda","codename":"gardalteMetroPCS","model":"SGH-T399N"},{"manufacturer":"Samsung","market_name":"Garda","codename":"gardaltetmo","model":"SGH-T399"},{"manufacturer":"Samsung","market_name":"Gear Live","codename":"sprat","model":"Gear Live"},{"manufacturer":"Samsung","market_name":"Gem","codename":"SCH-I100","model":"SCH-I100"},{"manufacturer":"Samsung","market_name":"Hennessy","codename":"hennessy3gduosctc","model":"SCH-W789"},{"manufacturer":"Samsung","market_name":"Homesync","codename":"spcwifi","model":"GT-B9150"},{"manufacturer":"Samsung","market_name":"Homesync","codename":"spcwifiany","model":"GT-B9150"},{"manufacturer":"Samsung","market_name":"IceTouch","codename":"gokey","model":"YP-GH1"},{"manufacturer":"Samsung","market_name":"Illusion","codename":"SCH-I110","model":"SCH-I110"},{"manufacturer":"Samsung","market_name":"Infuse","codename":"SGH-I997","model":"SAMSUNG-SGH-I997"},{"manufacturer":"Samsung","market_name":"Infuse","codename":"SGH-I997R","model":"SAMSUNG-SGH-I997R"},{"manufacturer":"Samsung","market_name":"J1 Mini Prime","codename":"j1minivelte","model":"SM-J106F"},{"manufacturer":"Samsung","market_name":"Moment","codename":"SPH-M900","model":"SPH-M900"},{"manufacturer":"Samsung","market_name":"Montblanc","codename":"montblanc3gctc","model":"SM-W2014"},{"manufacturer":"Samsung","market_name":"Nexus 10","codename":"manta","model":"Nexus 10"},{"manufacturer":"Samsung","market_name":"Nexus S","codename":"crespo","model":"Nexus S"},{"manufacturer":"Samsung","market_name":"Nexus S","codename":"crespo4g","model":"Nexus S 4G"},{"manufacturer":"Samsung","market_name":"ProXpress M4580","codename":"fiber-athena","model":"samsung-printer-tablet"},{"manufacturer":"Samsung","market_name":"Replenish","codename":"SPH-M580","model":"SPH-M580"},{"manufacturer":"Samsung","market_name":"Replenish","codename":"SPH-M580BST","model":"SPH-M580BST"},{"manufacturer":"Samsung","market_name":"Repp","codename":"SCH-R680","model":"SCH-R680"},{"manufacturer":"Samsung","market_name":"Roy VE DTV","codename":"royssvedtv","model":"GT-S6293T"},{"manufacturer":"Samsung","market_name":"Roy VE DTV","codename":"royvedtv","model":"GT-S6293T"},{"manufacturer":"Samsung","market_name":"Rugby Smart","codename":"SGH-I847","model":"SAMSUNG-SGH-I847"},{"manufacturer":"Samsung","market_name":"SM G9298","codename":"venenoltechn","model":"SM-G9298"},{"manufacturer":"Samsung","market_name":"SM-G9198","codename":"philippeltechn","model":"SM-G9198"},{"manufacturer":"Samsung","market_name":"SM-W2018","codename":"kellyltechn","model":"SM-W2018"},{"manufacturer":"Samsung","market_name":"SM-W2018","codename":"kellyltechn","model":"SM-W2018X"},{"manufacturer":"Samsung","market_name":"Sidekick","codename":"SGH-T839","model":"SGH-T839"},{"manufacturer":"Samsung","market_name":"Transfix","codename":"SCH-R730","model":"SCH-R730"},{"manufacturer":"Samsung","market_name":"Transform","codename":"SPH-M920","model":"SPH-M920"},{"manufacturer":"Samsung","market_name":"Transform Ultra","codename":"SPH-M930","model":"SPH-M930"},{"manufacturer":"Samsung","market_name":"Transform Ultra","codename":"SPH-M930BST","model":"SPH-M930BST"},{"manufacturer":"Samsung","market_name":"VinsQ","codename":"SPH-M910","model":"SPH-M910"},{"manufacturer":"Samsung","market_name":"VinsQ(M910)","codename":"SPH-M910","model":"SPH-M910"},{"manufacturer":"Samsung","market_name":"W2016","codename":"royceltectc","model":"SM-W2016"},{"manufacturer":"Samsung","market_name":"W2017","codename":"veyronltectc","model":"SM-W2017"},{"manufacturer":"Samsung","market_name":"olleh","codename":"ik1","model":"SMT-E5015"},{"manufacturer":"Sanaeko","market_name":"FX9","codename":"SANAEKO","model":"FX9"},{"manufacturer":"Sansei","market_name":"TS10A1","codename":"TS10A1","model":"TS10A1"},{"manufacturer":"Sansei","market_name":"TS7A1","codename":"TS7A1","model":"TS7A1"},{"manufacturer":"Sansui","market_name":"ETAB M9021G","codename":"ETAB_M9021G","model":"ETAB_M9021G"},{"manufacturer":"Sansui","market_name":"ETAB S7042G","codename":"S7042G","model":"ETAB_S7042G"},{"manufacturer":"Sansui","market_name":"Fun","codename":"Sansui_Fun","model":"Sansui Fun"},{"manufacturer":"Sansui","market_name":"Go","codename":"S401","model":"Go"},{"manufacturer":"Sansui","market_name":"Sansui Play","codename":"Play","model":"Sansui Play"},{"manufacturer":"Sansui","market_name":"Switch","codename":"SansuiSwitch","model":"Sansui_Switch"},{"manufacturer":"Sansui","market_name":"\"Tab 7\"\"\"","codename":"ETAB_I7043G","model":"ETAB I7043G"},{"manufacturer":"Sansui","market_name":"\"Tab 7\"\"\"","codename":"ETAB_I7043G","model":"ETAB_I7043G"},{"manufacturer":"Sansui","market_name":"\"Tab 7\"\"\"","codename":"ETAB_I7043G_VP3","model":"ETAB_I7043G_VP3"},{"manufacturer":"Sanyo","market_name":"55CE6139M1","codename":"CEM1","model":"CEM1"},{"manufacturer":"Sanyo","market_name":"Benesse","codename":"31TL04","model":"31TL04"},{"manufacturer":"Sanyo","market_name":"Benesse","codename":"40TL04","model":"40TL04"},{"manufacturer":"Sanyo","market_name":"Benesse","codename":"41EA04","model":"41EA04"},{"manufacturer":"Sanyo","market_name":"CEA1","codename":"CEA1","model":"CEA1"},{"manufacturer":"Sanyo","market_name":"CEA3","codename":"CEA3","model":"CEA3"},{"manufacturer":"Sanyo","market_name":"CEH1","codename":"CEH1","model":"CEH1"},{"manufacturer":"Sanyo","market_name":"CER2","codename":"CER2","model":"CER2"},{"manufacturer":"Sanyo","market_name":"CER3","codename":"CER3","model":"CER3"},{"manufacturer":"Sasktel","market_name":"SaskTel maxTV Stream","codename":"HMB2213PW22WA","model":"HMB2213PW22WA"},{"manufacturer":"Schok","market_name":"freedom turbo","codename":"SFT5216","model":"freedom turbo"},{"manufacturer":"Schok","market_name":"mini_SM7216","codename":"SM7216","model":"SM7216"},{"manufacturer":"Seatel","market_name":"L4","codename":"L4","model":"L4"},{"manufacturer":"Seatel","market_name":"T8","codename":"seatel_T8","model":"Seatel T8"},{"manufacturer":"Seatel","market_name":"V8A","codename":"Seatel_V8A","model":"Seatel V8A"},{"manufacturer":"Seatel","market_name":"V8E","codename":"Seatel_V8E","model":"Seatel V8E"},{"manufacturer":"Seeken","market_name":"SG2","codename":"SG2","model":"SG2"},{"manufacturer":"Seeken","market_name":"SG3","codename":"Seeken_SG3","model":"SG3"},{"manufacturer":"Seemahale Telecoms","market_name":"ST5000","codename":"ST5000","model":"ST5000"},{"manufacturer":"Senseit","market_name":"A109","codename":"SENSEIT_A109","model":"SENSEIT_A109"},{"manufacturer":"Senseit","market_name":"L301","codename":"SENSEIT-L301","model":"SENSEIT L301"},{"manufacturer":"Senseit","market_name":"SENSEIT T250","codename":"SENSEIT_T250","model":"SENSEIT T250"},{"manufacturer":"Senseit","market_name":"SENSEIT W289","codename":"SENSEIT_W289","model":"SENSEIT W289"},{"manufacturer":"Senseit","market_name":"SENSEIT_A247","codename":"SENSEIT_A247","model":"SENSEIT A247"},{"manufacturer":"Senseit","market_name":"Senseit N151","codename":"SENSEIT_N151","model":"SENSEIT N151"},{"manufacturer":"Senwa","market_name":"LS5","codename":"Telcel_LS5","model":"LS5"},{"manufacturer":"Senwa","market_name":"LS5000","codename":"Senwa_LS5000","model":"LS5000"},{"manufacturer":"Senwa","market_name":"LS5518H","codename":"Senwa_LS5518H","model":"LS5518H"},{"manufacturer":"Senwa","market_name":"LS55M","codename":"Senwa_LS55M","model":"LS55M"},{"manufacturer":"Senwa","market_name":"LS5718","codename":"Senwa_LS5718","model":"LS5718"},{"manufacturer":"Senwa","market_name":"LS5U","codename":"Senwa_LS5U","model":"LS5U"},{"manufacturer":"Senwa","market_name":"S45","codename":"Senwa_S45","model":"S45"},{"manufacturer":"Senwa","market_name":"S50","codename":"Senwa_S50","model":"S50"},{"manufacturer":"Senwa","market_name":"Telcel S6000","codename":"Telcel_S6000","model":"S6000"},{"manufacturer":"Senwa","market_name":"Telcel_LS50","codename":"Telcel_LS50","model":"LS50"},{"manufacturer":"Senwa","market_name":"Telcel_LS55","codename":"Telcel_LS55","model":"LS55"},{"manufacturer":"Sharp","market_name":"","codename":"SH7218T","model":"SH7218T"},{"manufacturer":"Sharp","market_name":"","codename":"SH8268U","model":"SH8268U"},{"manufacturer":"Sharp","market_name":"","codename":"SH8288U","model":"SH8288U"},{"manufacturer":"Sharp","market_name":"","codename":"SH8298U","model":"SH8298U"},{"manufacturer":"Sharp","market_name":"","codename":"msm7627_surf","model":"SH8118U"},{"manufacturer":"Sharp","market_name":"306SH","codename":"SG306SH","model":"306SH"},{"manufacturer":"Sharp","market_name":"401SH","codename":"SG401SH","model":"401SH"},{"manufacturer":"Sharp","market_name":"4T-C50AG1T","codename":"LCD_50FOCAG1T","model":"LCD_50FOCAG1T"},{"manufacturer":"Sharp","market_name":"507SH","codename":"eve_sprout","model":"507SH"},{"manufacturer":"Sharp","market_name":"A01SH","codename":"A01SH","model":"A01SH"},{"manufacturer":"Sharp","market_name":"A1","codename":"TSL","model":"FS8002"},{"manufacturer":"Sharp","market_name":"ADS1","codename":"ADS1","model":"SHARP-ADS1"},{"manufacturer":"Sharp","market_name":"AN-NP40","codename":"an_np40","model":"AN-NP40"},{"manufacturer":"Sharp","market_name":"AQUOS CRYSTAL 2","codename":"SG403SH","model":"403SH"},{"manufacturer":"Sharp","market_name":"AQUOS CRYSTAL X","codename":"SG402SH","model":"402SH"},{"manufacturer":"Sharp","market_name":"AQUOS Compact SH-02H","codename":"SH-02H","model":"SH-02H"},{"manufacturer":"Sharp","market_name":"AQUOS EVER SH-02J","codename":"SH-02J","model":"SH-02J"},{"manufacturer":"Sharp","market_name":"AQUOS EVER SH-04G","codename":"SH-04G","model":"SH-04G"},{"manufacturer":"Sharp","market_name":"AQUOS K SHF31","codename":"SHF31","model":"SHF31"},{"manufacturer":"Sharp","market_name":"AQUOS K SHF32","codename":"SHF32","model":"SHF32"},{"manufacturer":"Sharp","market_name":"AQUOS K SHF33","codename":"SHF33","model":"SHF33"},{"manufacturer":"Sharp","market_name":"AQUOS L SHV37","codename":"FSP_u","model":"SHV37_u"},{"manufacturer":"Sharp","market_name":"AQUOS L2","codename":"SH-L02","model":"SH-L02"},{"manufacturer":"Sharp","market_name":"AQUOS M1","codename":"MS1","model":"FS8001"},{"manufacturer":"Sharp","market_name":"AQUOS P1","codename":"P1X","model":"P1X"},{"manufacturer":"Sharp","market_name":"AQUOS PAD  SHT22","codename":"SHT22","model":"SHT22"},{"manufacturer":"Sharp","market_name":"AQUOS PAD SH-05G","codename":"SH-05G","model":"SH-05G"},{"manufacturer":"Sharp","market_name":"AQUOS PAD SH-06F","codename":"SH-06F","model":"SH-06F"},{"manufacturer":"Sharp","market_name":"AQUOS PAD SH-08E","codename":"SH-08E","model":"SH-08E"},{"manufacturer":"Sharp","market_name":"AQUOS PAD SHT21","codename":"SHT21","model":"SHT21"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE  SERIE SHL22","codename":"SHL22","model":"SHL22"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE  SERIE SHL23","codename":"SHL23","model":"SHL23"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE  SERIE mini SHL24","codename":"SHL24","model":"SHL24"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE CL IS17SH","codename":"SHI17","model":"IS17SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE EX SH-02F","codename":"SH-02F","model":"SH-02F"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE EX SH-04E","codename":"SH04E","model":"SH-04E"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE IS11SH","codename":"SHI11","model":"IS11SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE IS12SH","codename":"SHI12","model":"IS12SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE IS13SH","codename":"SHI13","model":"IS13SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE IS14SH","codename":"SHI14","model":"IS14SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE SERIE ISW16SH","codename":"SHI16","model":"ISW16SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE SERIE SHL21","codename":"SHL21","model":"SHL21"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE SH-01D","codename":"SH01D","model":"SH-01D"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE SH-06D","codename":"SH06D","model":"SH-06D"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE SH-12C","codename":"SH12C","model":"SH-12C"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE SH90B","codename":"SH90B","model":"SH90B"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE SL IS15SH","codename":"SHI15","model":"IS15SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE SoftBank  102SH II","codename":"SBM102SH2","model":"SBM102SH2"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE SoftBank 006SH","codename":"SBM006SH","model":"SBM006SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE SoftBank 102SH","codename":"SBM102SH","model":"SBM102SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE SoftBank 103SH","codename":"SBM103SH","model":"SBM103SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE SoftBank 104SH","codename":"SBM104SH","model":"SBM104SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE THE HYBRID SoftBank 007SH","codename":"SBM007SH","model":"SBM007SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE THE HYBRID SoftBank 007SH J","codename":"SBM007SHJ","model":"SBM007SHJ"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE THE HYBRID SoftBank 101SH","codename":"SBM101SH","model":"SBM101SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE THE PREMIUM SoftBank 009SH","codename":"SBM009SH","model":"SBM009SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE WX05SH","codename":"WX05SH","model":"WX05SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE Xx 206SH","codename":"SBM206SH","model":"SBM206SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE Xx 302SH","codename":"SBM302SH","model":"SBM302SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE Xx SoftBank 106SH","codename":"SBM106SH","model":"SBM106SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE Xx mini 303SH","codename":"SBM303SH","model":"SBM303SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE ZETA  SH-01F","codename":"SH-01F","model":"SH-01F"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE ZETA SH-02E","codename":"SH02E","model":"SH-02E"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE ZETA SH-06E","codename":"SH-06E","model":"SH-06E"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE ZETA SH-09D","codename":"SH09D","model":"SH-09D"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE es WX04SH","codename":"WX04SH","model":"WX04SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE f SH-13C","codename":"SH13C","model":"SH-13C"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE si SH-01E","codename":"SH01E","model":"SH-01E"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE si SH-07E","codename":"SH-07E","model":"SH-07E"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE slider SH-02D","codename":"SH02D","model":"SH-02D"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE ss 205SH","codename":"SBM205SH","model":"SBM205SH"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE st SH-07D","codename":"SH07D","model":"SH-07D"},{"manufacturer":"Sharp","market_name":"AQUOS PHONE sv SH-10D","codename":"SH10D","model":"SH-10D"},{"manufacturer":"Sharp","market_name":"AQUOS R","codename":"SG605SH","model":"605SH"},{"manufacturer":"Sharp","market_name":"AQUOS R SH-03J","codename":"SH-03J","model":"SH-03J"},{"manufacturer":"Sharp","market_name":"AQUOS R SHV39","codename":"HUR","model":"SHV39"},{"manufacturer":"Sharp","market_name":"AQUOS R compact 701SH","codename":"SG701SH","model":"701SH"},{"manufacturer":"Sharp","market_name":"AQUOS R compact SH-M06","codename":"SH-M06","model":"SH-M06"},{"manufacturer":"Sharp","market_name":"AQUOS R compact SHV41","codename":"JWT","model":"SHV41"},{"manufacturer":"Sharp","market_name":"AQUOS R2","codename":"SG706SH","model":"706SH"},{"manufacturer":"Sharp","market_name":"AQUOS R2 SH-03K","codename":"SH-03K","model":"SH-03K"},{"manufacturer":"Sharp","market_name":"AQUOS R2 SHV42","codename":"LYV","model":"SHV42"},{"manufacturer":"Sharp","market_name":"AQUOS SERIE SHL25","codename":"SHL25","model":"SHL25"},{"manufacturer":"Sharp","market_name":"AQUOS SERIE SHV32","codename":"SHV32","model":"SHV32"},{"manufacturer":"Sharp","market_name":"AQUOS SERIE SHV34","codename":"SHV34","model":"SHV34"},{"manufacturer":"Sharp","market_name":"AQUOS SERIE mini SHV31","codename":"SHV31","model":"SHV31"},{"manufacturer":"Sharp","market_name":"AQUOS SERIE mini SHV33","codename":"SHV33","model":"SHV33"},{"manufacturer":"Sharp","market_name":"AQUOS SERIE mini SHV38","codename":"GTQ","model":"SHV38"},{"manufacturer":"Sharp","market_name":"AQUOS SH-M01","codename":"SH-M01","model":"SH-M01"},{"manufacturer":"Sharp","market_name":"AQUOS SH-M02","codename":"SH-M02","model":"SH-M02"},{"manufacturer":"Sharp","market_name":"AQUOS SH-M02-EVA20","codename":"SH-M02-EVA20","model":"SH-M02-EVA20"},{"manufacturer":"Sharp","market_name":"AQUOS SH-RM02","codename":"SH-RM02","model":"SH-RM02"},{"manufacturer":"Sharp","market_name":"AQUOS U SHV35","codename":"SHV35","model":"SHV35"},{"manufacturer":"Sharp","market_name":"AQUOS U SHV37","codename":"FSP","model":"SHV37"},{"manufacturer":"Sharp","market_name":"AQUOS Xx","codename":"SG404SH","model":"404SH"},{"manufacturer":"Sharp","market_name":"AQUOS Xx 3","codename":"SG506SH","model":"506SH"},{"manufacturer":"Sharp","market_name":"AQUOS Xx 304SH","codename":"SG304SH","model":"304SH"},{"manufacturer":"Sharp","market_name":"AQUOS Xx2","codename":"SG502SH","model":"502SH"},{"manufacturer":"Sharp","market_name":"AQUOS Xx2 mini","codename":"SG503SH","model":"503SH"},{"manufacturer":"Sharp","market_name":"AQUOS Xx3 mini","codename":"SG603SH","model":"603SH"},{"manufacturer":"Sharp","market_name":"AQUOS ZETA SH-01G","codename":"SH-01G","model":"SH-01G"},{"manufacturer":"Sharp","market_name":"AQUOS ZETA SH-01H","codename":"SH-01H","model":"SH-01H"},{"manufacturer":"Sharp","market_name":"AQUOS ZETA SH-03G","codename":"SH-03G","model":"SH-03G"},{"manufacturer":"Sharp","market_name":"AQUOS ZETA SH-04F","codename":"SH-04F","model":"SH-04F"},{"manufacturer":"Sharp","market_name":"AQUOS ZETA SH-04H","codename":"SH-04H","model":"SH-04H"},{"manufacturer":"Sharp","market_name":"AQUOS ea","codename":"SG606SH","model":"606SH"},{"manufacturer":"Sharp","market_name":"AQUOS mini SH-M03","codename":"SH-M03","model":"SH-M03"},{"manufacturer":"Sharp","market_name":"AQUOS sense","codename":"KXU_u","model":"SHV40_u"},{"manufacturer":"Sharp","market_name":"AQUOS sense SH-01K","codename":"SH-01K","model":"SH-01K"},{"manufacturer":"Sharp","market_name":"AQUOS sense SHV40","codename":"KXU","model":"SHV40"},{"manufacturer":"Sharp","market_name":"AQUOS sense basic","codename":"SG702SH","model":"702SH"},{"manufacturer":"Sharp","market_name":"AQUOS sense lite (SH-M05)","codename":"SH-M05","model":"SH-M05"},{"manufacturer":"Sharp","market_name":"AQUOS \\xe3\\x82\\xb1\\xe3\\x83\\xbc\\xe3\\x82\\xbf\\xe3\\x82\\xa4 SH-06G","codename":"SH-06G","model":"SH-06G"},{"manufacturer":"Sharp","market_name":"Android One S1","codename":"kaleido_sprout","model":"S1"},{"manufacturer":"Sharp","market_name":"B10","codename":"SH-A01","model":"SH-A01"},{"manufacturer":"Sharp","market_name":"BASIO2 SHV36","codename":"SHV36","model":"SHV36"},{"manufacturer":"Sharp","market_name":"C1","codename":"MS1","model":"FS8001"},{"manufacturer":"Sharp","market_name":"DM009SH","codename":"DM009SH","model":"DM009SH"},{"manufacturer":"Sharp","market_name":"DM010SH","codename":"DM010SH","model":"DM010SH"},{"manufacturer":"Sharp","market_name":"DM011SH","codename":"DM011SH","model":"DM011SH"},{"manufacturer":"Sharp","market_name":"DM012SH","codename":"DM012SH","model":"DM012SH"},{"manufacturer":"Sharp","market_name":"DM013SH","codename":"DM013SH","model":"DM013SH"},{"manufacturer":"Sharp","market_name":"DM016SH","codename":"DM016SH","model":"DM016SH"},{"manufacturer":"Sharp","market_name":"Disney Mobile DM014SH","codename":"DM014SH","model":"DM014SH"},{"manufacturer":"Sharp","market_name":"Disney Mobile on docomo DM-01H","codename":"DM-01H","model":"DM-01H"},{"manufacturer":"Sharp","market_name":"Disney Mobile on docomo DM-01J","codename":"DM-01J","model":"DM-01J"},{"manufacturer":"Sharp","market_name":"Disney Mobile on docomo SH-02G","codename":"SH-02G","model":"SH-02G"},{"manufacturer":"Sharp","market_name":"Disney Mobile on docomo SH-05F","codename":"SH-05F","model":"SH-05F"},{"manufacturer":"Sharp","market_name":"EB-A71GJ","codename":"EB-A71GJ","model":"EB-A71GJ"},{"manufacturer":"Sharp","market_name":"EB-WX1GJ/EB-W51GJ","codename":"Galapagos","model":"EB-W51GJ"},{"manufacturer":"Sharp","market_name":"EB-WX1GJ/EB-W51GJ","codename":"Galapagos","model":"EB-WX1GJ"},{"manufacturer":"Sharp","market_name":"FS8014","codename":"SE3","model":"FS8014"},{"manufacturer":"Sharp","market_name":"GALAPAGOS SoftBank 003SH","codename":"SBM003SH","model":"SBM003SH"},{"manufacturer":"Sharp","market_name":"GALAPAGOS SoftBank 005SH","codename":"SBM005SH","model":"SBM005SH"},{"manufacturer":"Sharp","market_name":"HC-16TT1","codename":"HCTT1","model":"HCTT1"},{"manufacturer":"Sharp","market_name":"INFOBAR A01","codename":"SHX11","model":"INFOBAR A01"},{"manufacturer":"Sharp","market_name":"INFOBAR C01","codename":"SHX12","model":"INFOBAR C01"},{"manufacturer":"Sharp","market_name":"IS01","codename":"SHI01","model":"IS01"},{"manufacturer":"Sharp","market_name":"IS03","codename":"SHI03","model":"IS03"},{"manufacturer":"Sharp","market_name":"IS05","codename":"SHI05","model":"IS05"},{"manufacturer":"Sharp","market_name":"LC-**UH30U","codename":"sharp_2k15_us_android","model":"LC-Ux30US"},{"manufacturer":"Sharp","market_name":"LC-42LE860H","codename":"LC-42LE860H","model":"LC-42LE860H"},{"manufacturer":"Sharp","market_name":"LC-42LE860M","codename":"LC-42LE860M","model":"LC-42LE860M"},{"manufacturer":"Sharp","market_name":"LC-45SF460T","codename":"Lc_45foc460t","model":"LC_45FOC460T"},{"manufacturer":"Sharp","market_name":"LC-50LE570X","codename":"LC-xxLE570X","model":"LC-xxLE570X"},{"manufacturer":"Sharp","market_name":"LC-50LE860H","codename":"LC-50LE860H","model":"LC-50LE860H"},{"manufacturer":"Sharp","market_name":"LC-50LE860M","codename":"LC-50LE860M","model":"LC-50LE860M"},{"manufacturer":"Sharp","market_name":"LC-50UE1H","codename":"LC-50UE1H","model":"LC-50UE1H"},{"manufacturer":"Sharp","market_name":"LC-50UE1M","codename":"LC-50UE1M","model":"LC-50UE1M"},{"manufacturer":"Sharp","market_name":"LC-55LE860H","codename":"LC-55LE860H","model":"LC-55LE860H"},{"manufacturer":"Sharp","market_name":"LC-55LE860M","codename":"LC-55LE860M","model":"LC-55LE860M"},{"manufacturer":"Sharp","market_name":"LC-58UE1H","codename":"LC-58UE1H","model":"LC-58UE1H"},{"manufacturer":"Sharp","market_name":"LC-58UE1M","codename":"LC-58UE1M","model":"LC-58UE1M"},{"manufacturer":"Sharp","market_name":"LC-A11A","codename":"a11a","model":"LC-A11A"},{"manufacturer":"Sharp","market_name":"LC-A1H","codename":"a1h","model":"LC-A1H"},{"manufacturer":"Sharp","market_name":"LC-LE580T","codename":"lc_le580t","model":"LC-LE580T"},{"manufacturer":"Sharp","market_name":"LC-LE580X","codename":"lc_le580x","model":"LC-LE580X"},{"manufacturer":"Sharp","market_name":"LC-LX565H","codename":"lx565h","model":"LC-LX565H"},{"manufacturer":"Sharp","market_name":"LC-S3H-01","codename":"lc_s3h01","model":"LC-S3H-01"},{"manufacturer":"Sharp","market_name":"LC-S4H/LC-S45H/LC-S50H","codename":"lc_xxcae5h","model":"LC-xxCAE5H"},{"manufacturer":"Sharp","market_name":"LC-SU666T/LC-SU766T","codename":"lc_xxbel6t","model":"LC-xxBEL6T"},{"manufacturer":"Sharp","market_name":"LC-U35T","codename":"lc_u35t","model":"LC-U35T"},{"manufacturer":"Sharp","market_name":"LC-UA6800T/4T-C**AM1T","codename":"lc_theut","model":"AQUOS-4KTVT17"},{"manufacturer":"Sharp","market_name":"LC-UA6800X","codename":"lc_theux","model":"AQUOS-4KTVX17"},{"manufacturer":"Sharp","market_name":"LC-US5/LC-UH5/4T-C**AJ1/4T-C70AU1","codename":"lc_sunuj","model":"AQUOS-4KTVJ17"},{"manufacturer":"Sharp","market_name":"LC-XU35T","codename":"lc_xu35t","model":"LC-XU35T"},{"manufacturer":"Sharp","market_name":"LC-XU930X_830X","codename":"lc_xu930x_830x","model":"LC-XU930X_830X"},{"manufacturer":"Sharp","market_name":"LC-xxUD50H","codename":"lc_xxbel8h_c","model":"LC-xxBEL8H-C"},{"manufacturer":"Sharp","market_name":"LC-xxUE630X","codename":"lc_ue630x","model":"LC-UE630X"},{"manufacturer":"Sharp","market_name":"LC-xxUX50H","codename":"lc_xxbel9h","model":"LC-xxBEL9H"},{"manufacturer":"Sharp","market_name":"LCD-40SF465A","codename":"Lcd_40foc465a","model":"LCD_40FOC465A"},{"manufacturer":"Sharp","market_name":"LCD-40SF468A","codename":"Lcd_40foc468a","model":"LCD_40FOC468A"},{"manufacturer":"Sharp","market_name":"LCD-45SF460A","codename":"Lcd_45foc46a","model":"LCD_45FOC46A"},{"manufacturer":"Sharp","market_name":"LCD-45SF470A","codename":"cv6a648_base","model":"LCD_xxSFFOC470A"},{"manufacturer":"Sharp","market_name":"LCD-45SF475A","codename":"Lcd_xxsffoc475a","model":"LCD_xxSFFOC475A"},{"manufacturer":"Sharp","market_name":"LCD-45T45A/LCD-45T46A/LCD-45T47A","codename":"Lcd_foc36a","model":"LCD_FOC36A"},{"manufacturer":"Sharp","market_name":"LCD-45TX3000A","codename":"Lcd_45foc3000a","model":"LCD_45FOC3000A"},{"manufacturer":"Sharp","market_name":"LCD-45X518H1A","codename":"cv6a648_base","model":"LCD-45FOC518H1A"},{"manufacturer":"Sharp","market_name":"LCD-50MY4000A/TX4000A/50SU470A","codename":"Lcd_50foc4000a","model":"LCD_50FOC4000A"},{"manufacturer":"Sharp","market_name":"LCD-60SU470A","codename":"cv6a648_4K_base","model":"LCD_xxSUFOC470A"},{"manufacturer":"Sharp","market_name":"LCD-60SU475A","codename":"Lcd_xxsufoc475a","model":"LCD_xxSUFOC475A"},{"manufacturer":"Sharp","market_name":"LCD-60X518H1A","codename":"cv6a648_4K_base","model":"LCD-60FOC518H1A"},{"manufacturer":"Sharp","market_name":"LCD-LX460A","codename":"lx460a","model":"LCD-LX460A"},{"manufacturer":"Sharp","market_name":"LCD-LX560A","codename":"lx560a","model":"LCD-LX560A"},{"manufacturer":"Sharp","market_name":"LCD-LX565A","codename":"lx565ab","model":"LCD-LX565A-B"},{"manufacturer":"Sharp","market_name":"LCD-LX565A","codename":"msd818sharp","model":"LCD-LX565A"},{"manufacturer":"Sharp","market_name":"LCD-S3A","codename":"lcd_s3a01","model":"LCD-S3A-01"},{"manufacturer":"Sharp","market_name":"LCD-SU460A/LCD-SU465A","codename":"lcd_xxcae5a_c","model":"LCD-xxCAE5A-C"},{"manufacturer":"Sharp","market_name":"LCD-SU560A","codename":"lcd_xxcae5a","model":"LCD-xxCAE5A"},{"manufacturer":"Sharp","market_name":"LCD-SU870A","codename":"lcd_xxbel8a_b","model":"LCD-xxBEL8A-B"},{"manufacturer":"Sharp","market_name":"LCD-TX5000A","codename":"lcd_xxcae5a_d","model":"LCD-xxCAE5A-D"},{"manufacturer":"Sharp","market_name":"LCD-UF30A","codename":"lcd_uf30a","model":"LCD-UF30A"},{"manufacturer":"Sharp","market_name":"LCD-V3A","codename":"v3a","model":"LCD-V3A"},{"manufacturer":"Sharp","market_name":"LCD-xxBEL6A","codename":"lcd_xxbel6a","model":"LCD-xxBEL6A"},{"manufacturer":"Sharp","market_name":"LCD-xxBEL8A","codename":"lcd_xxbel8a","model":"LCD-xxBEL8A"},{"manufacturer":"Sharp","market_name":"LCD-xxMY8009A","codename":"lcd_xxbel7a_d","model":"LCD-xxBEL7A-D"},{"manufacturer":"Sharp","market_name":"LCD-xxSU670A/xxMY6100A/xxSU675A/xxSU775A/xxSU875A","codename":"lcd_xxdem6a","model":"LCD-xxDEM6A"},{"manufacturer":"Sharp","market_name":"LCD-xxSU671A","codename":"Lcd_xxsufoc5a","model":"LCD_xxSUFOC5A"},{"manufacturer":"Sharp","market_name":"LCD-xxSU672A","codename":"Lcd_xxsufoc6a","model":"LCD_xxSUFOC6A"},{"manufacturer":"Sharp","market_name":"LCD-xxSU775A;LCD-xxMY7100A","codename":"lcd_xxdem7a","model":"LCD-xxDEM7A"},{"manufacturer":"Sharp","market_name":"LCD-xxSU875A;LCD-xxSU675A;LCD-xxMY8100A","codename":"lcd_xxdem8a","model":"LCD-xxDEM8A"},{"manufacturer":"Sharp","market_name":"LC_50FOC45H","codename":"Lc_50foc45h","model":"LC_50FOC45H"},{"manufacturer":"Sharp","market_name":"LYNX 3D SH-03C","codename":"SH03C","model":"SH-03C"},{"manufacturer":"Sharp","market_name":"LYNX SH-10B","codename":"SH10B","model":"SH-10B"},{"manufacturer":"Sharp","market_name":"Media Tablet","codename":"EB-L76G-B","model":"EB-L76G-B"},{"manufacturer":"Sharp","market_name":"PANTONE 5 SoftBank 107SH","codename":"SBM107SH","model":"SBM107SH"},{"manufacturer":"Sharp","market_name":"PANTONE 6 SoftBank 200SH","codename":"SBM200SH","model":"SBM200SH"},{"manufacturer":"Sharp","market_name":"PN-B501/PN-B401","codename":"PN_B_series","model":"PN_B_series"},{"manufacturer":"Sharp","market_name":"PN-B501/PN-B401","codename":"PN_B_series_w","model":"PN_B_series"},{"manufacturer":"Sharp","market_name":"PN-M501/PN-M401","codename":"PN_M_series","model":"PN_M_series"},{"manufacturer":"Sharp","market_name":"PN-M501/PN-M401","codename":"PN_M_series_w","model":"PN_M_series"},{"manufacturer":"Sharp","market_name":"Q-pot.Phone SH-04D","codename":"SH04D","model":"SH-04D"},{"manufacturer":"Sharp","market_name":"RW107","codename":"RW107","model":"RW107"},{"manufacturer":"Sharp","market_name":"RZ-E302","codename":"rk3188_10P_A","model":"RZ-E302"},{"manufacturer":"Sharp","market_name":"S3","codename":"rome_sprout","model":"S3-SH"},{"manufacturer":"Sharp","market_name":"SBM204SH","codename":"SBM204SH","model":"SBM204SH"},{"manufacturer":"Sharp","market_name":"SC-S01","codename":"scallop","model":"SC-S01"},{"manufacturer":"Sharp","market_name":"SH-01E Vivienne Westwood","codename":"SH01EVW","model":"SH-01EVW"},{"manufacturer":"Sharp","market_name":"SH-01F DRAGON QUEST","codename":"SH-01FDQ","model":"SH-01FDQ"},{"manufacturer":"Sharp","market_name":"SH-03F","codename":"SH03F","model":"SH-03F"},{"manufacturer":"Sharp","market_name":"SH-03H","codename":"SH-03H","model":"SH-03H"},{"manufacturer":"Sharp","market_name":"SH-05E","codename":"SH05E","model":"SH-05E"},{"manufacturer":"Sharp","market_name":"SH-06D NERV","codename":"SH06DNERV","model":"SH-06DNERV"},{"manufacturer":"Sharp","market_name":"SH-H01","codename":"VZJ","model":"SH-H01"},{"manufacturer":"Sharp","market_name":"SH-M04","codename":"SH-M04","model":"SH-M04"},{"manufacturer":"Sharp","market_name":"SH80F","codename":"SH80F","model":"SH80F"},{"manufacturer":"Sharp","market_name":"SH8118U","codename":"msm7627","model":"SH8118U"},{"manufacturer":"Sharp","market_name":"SH8128U","codename":"msm7627","model":"SH8128U"},{"manufacturer":"Sharp","market_name":"SH8188U","codename":"SH8188U","model":"SH8188U"},{"manufacturer":"Sharp","market_name":"SH825wi","codename":"SH825Wi","model":"SH825Wi"},{"manufacturer":"Sharp","market_name":"SHARP A2 Lite","codename":"SJ3","model":"FS8026"},{"manufacturer":"Sharp","market_name":"SHARP A2 Mini","codename":"HQ3","model":"IF9009"},{"manufacturer":"Sharp","market_name":"SHARP AQUOS S2","codename":"SH-Z01","model":"SH-Z01"},{"manufacturer":"Sharp","market_name":"SHARP AQUOS S2","codename":"SS2","model":"FS8010"},{"manufacturer":"Sharp","market_name":"SHARP AQUOS S2 Plus","codename":"SAT","model":"FS8008"},{"manufacturer":"Sharp","market_name":"SHARP AQUOS S2 Plus","codename":"SAT","model":"FS8016"},{"manufacturer":"Sharp","market_name":"SHARP AQUOS S3","codename":"HH1","model":"FS8032"},{"manufacturer":"Sharp","market_name":"SHARP AQUOS S3","codename":"SD1","model":"FS8015"},{"manufacturer":"Sharp","market_name":"SHARP AQUOS V1mini","codename":"SG1","model":"FS8018"},{"manufacturer":"Sharp","market_name":"SHARP R1S","codename":"SK3","model":"FS8028"},{"manufacturer":"Sharp","market_name":"SHARP TBC","codename":"SI3","model":"FS8025"},{"manufacturer":"Sharp","market_name":"Sharp A Click","codename":"AH3","model":"IF9003"},{"manufacturer":"Sharp","market_name":"Sharp Pi","codename":"AG3","model":"IF9007"},{"manufacturer":"Sharp","market_name":"Sharp R1","codename":"SE3_TH","model":"FS8014"},{"manufacturer":"Sharp","market_name":"Sharp R1","codename":"SE3_VN","model":"FS8014"},{"manufacturer":"Sharp","market_name":"SoftBank 007SH KT","codename":"SBM007SHK","model":"SBM007SHK"},{"manufacturer":"Sharp","market_name":"SoftBank 107SH B","codename":"SBM107SHB","model":"SBM107SHB"},{"manufacturer":"Sharp","market_name":"SoftBank 305SH","codename":"SG305SH","model":"305SH"},{"manufacturer":"Sharp","market_name":"SoftBank AQUOS PHONE Xx 203SH","codename":"SBM203SH","model":"SBM203SH"},{"manufacturer":"Sharp","market_name":"Star Wars mobile","codename":"SW001SH","model":"SW001SH"},{"manufacturer":"Sharp","market_name":"X1","codename":"nasa_sprout","model":"X1"},{"manufacturer":"Sharp","market_name":"X4","codename":"vespa_sprout","model":"X4-SH"},{"manufacturer":"Sharp","market_name":"Yahoo! Phone SoftBank 009SH Y","codename":"SBM009SHY","model":"SBM009SHY"},{"manufacturer":"Sharp","market_name":"Z2","codename":"TSP","model":"FS8002"},{"manufacturer":"Sharp","market_name":"Z3","codename":"VN3N","model":"FS8009"},{"manufacturer":"Sharp","market_name":"lcd_xxbel7a_c","codename":"lcd_xxbel7a_c","model":"LCD-xxBEL7A-C"},{"manufacturer":"Sharp","market_name":"z3","codename":"VN3N","model":"FS8009"},{"manufacturer":"Sharp","market_name":"\\xe3\\x82\\xb7\\xe3\\x83\\xb3\\xe3\\x83\\x97\\xe3\\x83\\xab\\xe3\\x82\\xb9\\xe3\\x83\\x9e\\xe3\\x83\\x9b\\xef\\xbc\\x93","codename":"SG509SH","model":"509SH"},{"manufacturer":"Sharp","market_name":"\\xe3\\x83\\xad\\xe3\\x83\\x9c\\xe3\\x83\\x9b\\xe3\\x83\\xb3","codename":"SR01MW","model":"SR01MW"},{"manufacturer":"Sharp","market_name":"\\xe3\\x83\\xad\\xe3\\x83\\x9c\\xe3\\x83\\x9b\\xe3\\x83\\xb3","codename":"SR02MW","model":"SR02MW"},{"manufacturer":"Sharp","market_name":"\\xe3\\x83\\xad\\xe3\\x83\\x9c\\xe3\\x83\\x9b\\xe3\\x83\\xb3","codename":"SRX002","model":"SRX002"},{"manufacturer":"Shelby","market_name":"ZA555","codename":"ZA555","model":"ZA555"},{"manufacturer":"SiAL","market_name":"Bic camera","codename":"Si01BB","model":"Si01BB"},{"manufacturer":"SiAL","market_name":"Si01BE","codename":"Si01BE","model":"Si01BE"},{"manufacturer":"Sico","market_name":"Nile X","codename":"Nile_X","model":"Nile X"},{"manufacturer":"Sico","market_name":"PLUS2","codename":"Plus2","model":"Plus2"},{"manufacturer":"Sico","market_name":"PLUS2 4G","codename":"Plus2_4G","model":"Plus2 4G"},{"manufacturer":"Sico SmartPhone","market_name":"SSR1-5-8M","codename":"GBC_bravo","model":"SSR1-5-8M"},{"manufacturer":"Sico SmartPhone","market_name":"SSR1-5-8M","codename":"GBC_bravo","model":"sico pro"},{"manufacturer":"Sigma Mobile","market_name":"X-TREME PQ24","codename":"X-treme_PQ24","model":"X-treme_PQ24"},{"manufacturer":"Sigma Mobile","market_name":"X-TREME PQ28","codename":"X-treme_PQ28","model":"X-treme_PQ28"},{"manufacturer":"Sigma Mobile","market_name":"X-TREME PQ52","codename":"X-TREME_PQ52","model":"X-TREME PQ52"},{"manufacturer":"Sigma Mobile","market_name":"X-Treme_PQ51","codename":"X-Treme_PQ51","model":"X-Treme_PQ51"},{"manufacturer":"Sigma Mobile","market_name":"X_Style_Tab_A103","codename":"X_Style_Tab_A103","model":"X_Style_Tab_A103"},{"manufacturer":"Silent Circle","market_name":"Blackphone 2","codename":"BP2","model":"Blackphone 2"},{"manufacturer":"Silver line","market_name":"SL1068","codename":"SL1068","model":"SL1068"},{"manufacturer":"Silver line","market_name":"SL729","codename":"SL729","model":"SL729"},{"manufacturer":"Simbans","market_name":"PicassoTab","codename":"PicassoTab","model":"PicassoTab"},{"manufacturer":"Simbans","market_name":"TangoTab","codename":"TangoTab","model":"TangoTab"},{"manufacturer":"Singtech","market_name":"Infinity_I1","codename":"Infinity_I1","model":"Infinity_I1"},{"manufacturer":"Singtech","market_name":"Infinity_I_Mix","codename":"Infinity_I_Mix","model":"Infinity_I_Mix"},{"manufacturer":"Singtech","market_name":"Q3","codename":"Q3","model":"Q3"},{"manufacturer":"Singtech","market_name":"Q7","codename":"Q7","model":"Q7"},{"manufacturer":"Singtech","market_name":"S2 Pro","codename":"S2_Pro","model":"S2 Pro"},{"manufacturer":"Singtech","market_name":"i-Tab Mini 3","codename":"iTab","model":"i-Tab Mini 3"},{"manufacturer":"Siragon","market_name":"SP-5000","codename":"SP-5000","model":"Siragon SP-5000"},{"manufacturer":"Sirin","market_name":"LABS SOLARIN","codename":"solarin","model":"SOLARIN"},{"manufacturer":"Sirin","market_name":"LABS SOLARIN","codename":"solarin","model":"Solarin"},{"manufacturer":"Sky Devices","market_name":"ELITE 4.0S","codename":"Elite_4_0S_GT_Tigo","model":"Elite_4.0S"},{"manufacturer":"Sky Devices","market_name":"ELITE 4.0S","codename":"Elite_4_0S_HN_Tigo","model":"Elite_4.0S"},{"manufacturer":"Sky Devices","market_name":"ELITE 45T","codename":"Elite_45T_GT","model":"Elite 45T"},{"manufacturer":"Sky Devices","market_name":"ELITE 4T","codename":"Elite_4T_GT","model":"Elite 4T"},{"manufacturer":"Sky Devices","market_name":"ELITE 4T","codename":"Elite_4T_HN","model":"Elite 4T"},{"manufacturer":"Sky Devices","market_name":"ELITE 5.0T","codename":"Elite_5_0T","model":"Elite_5_0T"},{"manufacturer":"Sky Devices","market_name":"ELITE 5T","codename":"Elite_5T_GT","model":"Elite 5T"},{"manufacturer":"Sky Devices","market_name":"ELITE 5T","codename":"Elite_5T_SV","model":"Elite 5T"},{"manufacturer":"Sky Devices","market_name":"ELITE T57","codename":"Elite_T57_GT","model":"Elite T57"},{"manufacturer":"Sky Devices","market_name":"Elite 5T","codename":"Elite_5T_GT","model":"Elite 5T"},{"manufacturer":"Sky Devices","market_name":"Elite A55","codename":"Elite_A55","model":"Elite_A55"},{"manufacturer":"Sky Devices","market_name":"Fuego 4.0T","codename":"Fuego_4_0T_EC","model":"Fuego 4.0T"},{"manufacturer":"Sky Devices","market_name":"PLATINUM 4.0","codename":"Platinum_40","model":"Platinum 4.0"},{"manufacturer":"Sky Devices","market_name":"PLATINUM 4.0","codename":"Platinum_4_0","model":"Platinum 4.0"},{"manufacturer":"Sky Devices","market_name":"PLATINUM 4.0+","codename":"Platinum_4_0Plus","model":"Platinum_4_0Plus"},{"manufacturer":"Sky Devices","market_name":"PLATINUM 5.0M","codename":"Platinum_5_0M","model":"Platinum_5.0M"},{"manufacturer":"Sky Devices","market_name":"PLATINUM A5","codename":"Platinum_A5","model":"Platinum_A5"},{"manufacturer":"Sky Devices","market_name":"PLATINUM A57","codename":"Platinum_A57_OP","model":"Platinum A57"},{"manufacturer":"Sky Devices","market_name":"PLATINUM M4","codename":"Platinum_M4_SV","model":"Platinum M4"},{"manufacturer":"Sky Devices","market_name":"SKY 5.0LM","codename":"SKY_50LM","model":"SKY 5.0LM"},{"manufacturer":"Sky Devices","market_name":"SKY 5.0Pro II","codename":"SKY_50Pro_II","model":"SKY 5.0Pro II"},{"manufacturer":"Sky Devices","market_name":"SKY 55M","codename":"SKY_55M","model":"SKY 55M"},{"manufacturer":"Sky Devices","market_name":"SKY_Pro_III","codename":"SKY_Pro_III","model":"SKY_Pro_III"},{"manufacturer":"SkyLife","market_name":"UHD2","codename":"IC1110","model":"IC1110"},{"manufacturer":"SkyLife","market_name":"skylife LTE TV","codename":"DMTS17SS","model":"DMT_1621"},{"manufacturer":"Skyworth","market_name":"Asia","codename":"globe_ap","model":"globe"},{"manufacturer":"Skyworth","market_name":"Europe","codename":"globe_eu","model":"globe"},{"manufacturer":"Skyworth","market_name":"North America","codename":"globe_na","model":"globe"},{"manufacturer":"Skyworth","market_name":"Skyworth","codename":"grape","model":"HPA02"},{"manufacturer":"Skyworth","market_name":"South America","codename":"globe_sa","model":"globe"},{"manufacturer":"Smailo","market_name":"Smailo 2GO","codename":"Smailo_2GO","model":"Smailo_2GO"},{"manufacturer":"Smart","market_name":"Advance Pro","codename":"Advance_Pro","model":"Advance Pro"},{"manufacturer":"Smart","market_name":"Coral 4","codename":"Coral_4","model":"Coral 4"},{"manufacturer":"Smart","market_name":"FW503KH","codename":"FW503KH","model":"FW503KH"},{"manufacturer":"Smart","market_name":"Grand","codename":"Grand","model":"Grand"},{"manufacturer":"Smart","market_name":"Max","codename":"Max","model":"Max"},{"manufacturer":"Smart","market_name":"Notrino","codename":"Notrino","model":"Notrino"},{"manufacturer":"Smart","market_name":"Slide Lite","codename":"Slide_Lite","model":"Slide Lite"},{"manufacturer":"Smartab","market_name":"SRF79","codename":"SRF79","model":"SRF79"},{"manufacturer":"Smartab","market_name":"ST1009X","codename":"ST1009X","model":"ST1009X"},{"manufacturer":"Smartab","market_name":"ST700","codename":"ST700","model":"ST700"},{"manufacturer":"Smartab","market_name":"ST7150","codename":"ST7150","model":"ST7150"},{"manufacturer":"Smartab","market_name":"STJR700","codename":"STJR700","model":"STJR700"},{"manufacturer":"Smartab","market_name":"STJR76","codename":"STJR76","model":"STJR76"},{"manufacturer":"Smartex","market_name":"SMARTEX_M512","codename":"M512","model":"M512"},{"manufacturer":"Smartfren","market_name":"A16C3H","codename":"A16C3H","model":"Andromax A16C3H"},{"manufacturer":"Smartfren","market_name":"A26C4H","codename":"A26C4H","model":"Andromax A26C4H"},{"manufacturer":"Smartfren","market_name":"AD688G","codename":"AD688G","model":"Smartfren Andromax AD688G"},{"manufacturer":"Smartfren","market_name":"AD689G","codename":"AD689G","model":"Smartfren Andromax AD689G"},{"manufacturer":"Smartfren","market_name":"Andromax AD682H","codename":"AD682H","model":"Smartfren Andromax AD682H"},{"manufacturer":"Smartfren","market_name":"Andromax AD687G","codename":"AD687G","model":"Andromax AD687G"},{"manufacturer":"Smartfren","market_name":"Andromax C46B2G","codename":"HS8916QC","model":"Andromax C46B2G"},{"manufacturer":"Smartfren","market_name":"AndromaxNC36B1H","codename":"NC36B1H","model":"Smartfren Andromax NC36B1H"},{"manufacturer":"Smartfren","market_name":"B16C2G","codename":"MSM8909QC","model":"Andromax B16C2G"},{"manufacturer":"Smartfren","market_name":"B16C2H","codename":"B16C2H","model":"Andromax B16C2H"},{"manufacturer":"Smartfren","market_name":"B26D2H","codename":"B26D2H","model":"Andromax B26D2H"},{"manufacturer":"Smartfren","market_name":"C2LEAD688G","codename":"C2LEAD688G","model":"Smartfren Andromax AD688G"},{"manufacturer":"Smartfren","market_name":"EG680","codename":"eg680","model":"EG680"},{"manufacturer":"Smartfren","market_name":"G36C1G","codename":"HS8916QC","model":"Andromax G36C1G"},{"manufacturer":"Smartfren","market_name":"G36C1H","codename":"G36C1H","model":"Andromax G36C1H"},{"manufacturer":"Smartfren","market_name":"I46D1G","codename":"HS8916QC","model":"Andromax I46D1G"},{"manufacturer":"Smartfren","market_name":"NC36B1G","codename":"HS8610QC","model":"Smartfren Andromax NC36B1G"},{"manufacturer":"Smartfren","market_name":"NEWAD688G","codename":"NEWAD688G","model":"Smartfren Andromax AD688G"},{"manufacturer":"Smartron","market_name":"Srtphone","codename":"rimo02a","model":"T5524"},{"manufacturer":"Smartron","market_name":"tphone","codename":"rimo01a","model":"T5511"},{"manufacturer":"Smartron","market_name":"tphone P","codename":"P840F12","model":"T5211"},{"manufacturer":"Soda","market_name":"E1","codename":"soda_CSW1702","model":"soda E1"},{"manufacturer":"Soda","market_name":"soda","codename":"soda_SW17W16","model":"soda S1"},{"manufacturer":"Solone","market_name":"E1457","codename":"E1457","model":"E1457"},{"manufacturer":"Solone","market_name":"W1450","codename":"W1450","model":"W1450"},{"manufacturer":"Solone","market_name":"W1452","codename":"W1452","model":"W1452"},{"manufacturer":"Sonimtech","market_name":"Ex-Handy 09","codename":"XP6700Z1","model":"Ex-Handy 09"},{"manufacturer":"Sonimtech","market_name":"Smart-Ex 01","codename":"XP7700Z1","model":"Smart-Ex 01"},{"manufacturer":"Sonimtech","market_name":"XP6","codename":"XP6700","model":"Ex-Handy 209"},{"manufacturer":"Sonimtech","market_name":"XP6","codename":"XP6700","model":"XP6700"},{"manufacturer":"Sonimtech","market_name":"XP7","codename":"XP7700","model":"Smart-Ex 201"},{"manufacturer":"Sonimtech","market_name":"XP7","codename":"XP7700","model":"XP7700"},{"manufacturer":"Sonimtech","market_name":"XP7","codename":"XP7700Z1","model":"Smart-Ex 01"},{"manufacturer":"Sonimtech","market_name":"XP7700Z1","codename":"XP7700Z1","model":"Smart-Ex 01"},{"manufacturer":"Sonimtech","market_name":"XP7705","codename":"XP7705","model":"XP7700"},{"manufacturer":"Sonimtech","market_name":"XP8","codename":"XP8800","model":"XP8800"},{"manufacturer":"Sonimtech","market_name":"XP8812","codename":"XP8800","model":"XP8800"},{"manufacturer":"Sony","market_name":"","codename":"C5503","model":"C5503"},{"manufacturer":"Sony","market_name":"","codename":"C6616","model":"C6616"},{"manufacturer":"Sony","market_name":"","codename":"SGP312","model":"SGP312"},{"manufacturer":"Sony","market_name":"","codename":"ST21i","model":"ST21i"},{"manufacturer":"Sony","market_name":"","codename":"ST23i","model":"ST23i"},{"manufacturer":"Sony","market_name":"","codename":"ST26i","model":"ST26i"},{"manufacturer":"Sony","market_name":"","codename":"nbx02","model":"Sony Tablet P"},{"manufacturer":"Sony","market_name":"BRAVIA 2015","codename":"SVP-DTV15","model":"BRAVIA 2015"},{"manufacturer":"Sony","market_name":"BRAVIA 2K GB ATV3","codename":"BRAVIA_ATV3_2K","model":"BRAVIA 2K GB ATV3"},{"manufacturer":"Sony","market_name":"BRAVIA 4K 2015","codename":"SVP-DTV15","model":"BRAVIA 2015"},{"manufacturer":"Sony","market_name":"BRAVIA 4K 2015","codename":"SVP-DTV15","model":"BRAVIA 4K 2015"},{"manufacturer":"Sony","market_name":"BRAVIA 4K GB","codename":"BRAVIA_ATV2","model":"BRAVIA 4K GB"},{"manufacturer":"Sony","market_name":"BRAVIA 4K GB ATV3","codename":"BRAVIA_ATV3_4K","model":"BRAVIA 4K GB ATV3"},{"manufacturer":"Sony","market_name":"BRAVIA Smart Stick","codename":"NSZGU1","model":"NSZ-GU1"},{"manufacturer":"Sony","market_name":"Ericsson Live with Walkman","codename":"WT19a","model":"WT19a"},{"manufacturer":"Sony","market_name":"Ericsson Live with Walkman","codename":"WT19i","model":"WT19i"},{"manufacturer":"Sony","market_name":"Internet TV","codename":"asura","model":"Internet TV"},{"manufacturer":"Sony","market_name":"Internet TV","codename":"eagle","model":"Internet TV Box"},{"manufacturer":"Sony","market_name":"NSZGS7","codename":"NSZGS7","model":"NSZ-GS7/GX70"},{"manufacturer":"Sony","market_name":"NW-F800","codename":"icx1227","model":"WALKMAN"},{"manufacturer":"Sony","market_name":"NW-F880 Series","codename":"icx1237","model":"WALKMAN"},{"manufacturer":"Sony","market_name":"NW-Z1000","codename":"icx1216","model":"NW-Z1000Series"},{"manufacturer":"Sony","market_name":"NW-ZX1","codename":"icx1240","model":"WALKMAN"},{"manufacturer":"Sony","market_name":"NW-ZX2","codename":"icx1265","model":"WALKMAN"},{"manufacturer":"Sony","market_name":"NWZ-Z1000","codename":"icx1216","model":"NWZ-Z1000Series"},{"manufacturer":"Sony","market_name":"NWZ-ZX1","codename":"icx1240","model":"WALKMAN"},{"manufacturer":"Sony","market_name":"SmartWatch 3","codename":"tetra","model":"SmartWatch 3"},{"manufacturer":"Sony","market_name":"Smartphone Z Ultra Google Play edition","codename":"C6806","model":"C6806_GPe"},{"manufacturer":"Sony","market_name":"Tablet P","codename":"nbx02","model":"Sony Tablet P"},{"manufacturer":"Sony","market_name":"Tablet S","codename":"nbx03","model":"Sony Tablet S"},{"manufacturer":"Sony","market_name":"Xperia  E1 dual","codename":"D2114","model":"D2114"},{"manufacturer":"Sony","market_name":"Xperia  M","codename":"C1905","model":"C1905"},{"manufacturer":"Sony","market_name":"Xperia A","codename":"SO-04E","model":"SO-04E"},{"manufacturer":"Sony","market_name":"Xperia A2","codename":"SO-04F","model":"SO-04F"},{"manufacturer":"Sony","market_name":"Xperia A4","codename":"SO-04G","model":"SO-04G"},{"manufacturer":"Sony","market_name":"Xperia C","codename":"C2304","model":"C2304"},{"manufacturer":"Sony","market_name":"Xperia C","codename":"C2305","model":"C2305"},{"manufacturer":"Sony","market_name":"Xperia C3","codename":"D2533","model":"D2533"},{"manufacturer":"Sony","market_name":"Xperia C3 Dual","codename":"D2502","model":"D2502"},{"manufacturer":"Sony","market_name":"Xperia C5 Ultra","codename":"E5506","model":"E5506"},{"manufacturer":"Sony","market_name":"Xperia C5 Ultra","codename":"E5553","model":"E5553"},{"manufacturer":"Sony","market_name":"Xperia C5 Ultra Dual","codename":"E5533","model":"E5533"},{"manufacturer":"Sony","market_name":"Xperia C5 Ultra Dual","codename":"E5563","model":"E5563"},{"manufacturer":"Sony","market_name":"Xperia E","codename":"C1504","model":"C1504"},{"manufacturer":"Sony","market_name":"Xperia E","codename":"C1505","model":"C1505"},{"manufacturer":"Sony","market_name":"Xperia E dual","codename":"C1604","model":"C1604"},{"manufacturer":"Sony","market_name":"Xperia E dual","codename":"C1605","model":"C1605"},{"manufacturer":"Sony","market_name":"Xperia E1","codename":"D2004","model":"D2004"},{"manufacturer":"Sony","market_name":"Xperia E1","codename":"D2005","model":"D2005"},{"manufacturer":"Sony","market_name":"Xperia E1","codename":"D2114","model":"D2114"},{"manufacturer":"Sony","market_name":"Xperia E1 Dual","codename":"D2104","model":"D2104"},{"manufacturer":"Sony","market_name":"Xperia E1 Dual","codename":"D2105","model":"D2105"},{"manufacturer":"Sony","market_name":"Xperia E1 dual","codename":"D2104","model":"D2104"},{"manufacturer":"Sony","market_name":"Xperia E1 dual","codename":"D2105","model":"D2105"},{"manufacturer":"Sony","market_name":"Xperia E3","codename":"D2202","model":"D2202"},{"manufacturer":"Sony","market_name":"Xperia E3","codename":"D2203","model":"D2203"},{"manufacturer":"Sony","market_name":"Xperia E3","codename":"D2206","model":"D2206"},{"manufacturer":"Sony","market_name":"Xperia E3","codename":"D2243","model":"D2243"},{"manufacturer":"Sony","market_name":"Xperia E3 Dual","codename":"D2212","model":"D2212"},{"manufacturer":"Sony","market_name":"Xperia E4g","codename":"E2053","model":"E2053"},{"manufacturer":"Sony","market_name":"Xperia E4g Dual","codename":"E2033","model":"E2033"},{"manufacturer":"Sony","market_name":"Xperia E4g Dual","codename":"E2043","model":"E2043"},{"manufacturer":"Sony","market_name":"Xperia E5","codename":"F3311","model":"F3311"},{"manufacturer":"Sony","market_name":"Xperia E5","codename":"F3313","model":"F3313"},{"manufacturer":"Sony","market_name":"Xperia Go","codename":"ST27a","model":"ST27a"},{"manufacturer":"Sony","market_name":"Xperia Go","codename":"ST27i","model":"ST27i"},{"manufacturer":"Sony","market_name":"Xperia Hello","codename":"G1209","model":"G1209"},{"manufacturer":"Sony","market_name":"Xperia J","codename":"ST26a","model":"ST26a"},{"manufacturer":"Sony","market_name":"Xperia J","codename":"ST26i","model":"ST26i"},{"manufacturer":"Sony","market_name":"Xperia J1 Compact","codename":"D5788","model":"D5788"},{"manufacturer":"Sony","market_name":"Xperia L","codename":"C2104","model":"C2104"},{"manufacturer":"Sony","market_name":"Xperia L","codename":"C2105","model":"C2105"},{"manufacturer":"Sony","market_name":"Xperia L1","codename":"G3311","model":"G3311"},{"manufacturer":"Sony","market_name":"Xperia L1","codename":"G3312","model":"G3312"},{"manufacturer":"Sony","market_name":"Xperia L1","codename":"G3313","model":"G3313"},{"manufacturer":"Sony","market_name":"Xperia L2","codename":"H3311","model":"H3311"},{"manufacturer":"Sony","market_name":"Xperia L2","codename":"H3321","model":"H3321"},{"manufacturer":"Sony","market_name":"Xperia L2","codename":"H4311","model":"H4311"},{"manufacturer":"Sony","market_name":"Xperia L2","codename":"H4331","model":"H4331"},{"manufacturer":"Sony","market_name":"Xperia M","codename":"C1904","model":"C1904"},{"manufacturer":"Sony","market_name":"Xperia M","codename":"C1905","model":"C1905"},{"manufacturer":"Sony","market_name":"Xperia M Dual","codename":"C2005","model":"C2005"},{"manufacturer":"Sony","market_name":"Xperia M dual","codename":"C2004","model":"C2004"},{"manufacturer":"Sony","market_name":"Xperia M dual","codename":"C2005","model":"C2005"},{"manufacturer":"Sony","market_name":"Xperia M2","codename":"D2303","model":"D2303"},{"manufacturer":"Sony","market_name":"Xperia M2","codename":"D2305","model":"D2305"},{"manufacturer":"Sony","market_name":"Xperia M2","codename":"D2306","model":"D2306"},{"manufacturer":"Sony","market_name":"Xperia M2 Aqua","codename":"D2403","model":"D2403"},{"manufacturer":"Sony","market_name":"Xperia M2 Aqua","codename":"D2406","model":"D2406"},{"manufacturer":"Sony","market_name":"Xperia M2 Dual","codename":"D2302","model":"D2302"},{"manufacturer":"Sony","market_name":"Xperia M2 dual","codename":"D2302","model":"D2302"},{"manufacturer":"Sony","market_name":"Xperia M5","codename":"E5603","model":"E5603"},{"manufacturer":"Sony","market_name":"Xperia M5","codename":"E5606","model":"E5606"},{"manufacturer":"Sony","market_name":"Xperia M5","codename":"E5653","model":"E5653"},{"manufacturer":"Sony","market_name":"Xperia M5 Dual","codename":"E5633","model":"E5633"},{"manufacturer":"Sony","market_name":"Xperia M5 Dual","codename":"E5643","model":"E5643"},{"manufacturer":"Sony","market_name":"Xperia M5 Dual","codename":"E5663","model":"E5663"},{"manufacturer":"Sony","market_name":"Xperia Miro","codename":"ST23i","model":"ST23i"},{"manufacturer":"Sony","market_name":"Xperia P","codename":"LT22i","model":"LT22i"},{"manufacturer":"Sony","market_name":"Xperia PLAY","codename":"R800a","model":"R800a"},{"manufacturer":"Sony","market_name":"Xperia PLAY","codename":"R800i","model":"R800i"},{"manufacturer":"Sony","market_name":"Xperia R1","codename":"G2199","model":"G2199"},{"manufacturer":"Sony","market_name":"Xperia R1 Plus","codename":"G2299","model":"G2299"},{"manufacturer":"Sony","market_name":"Xperia S","codename":"LT26i","model":"LT26i"},{"manufacturer":"Sony","market_name":"Xperia SL","codename":"LT26ii","model":"LT26ii"},{"manufacturer":"Sony","market_name":"Xperia SP","codename":"C5302","model":"C5302"},{"manufacturer":"Sony","market_name":"Xperia SP","codename":"C5303","model":"C5303"},{"manufacturer":"Sony","market_name":"Xperia SP","codename":"C5306","model":"C5306"},{"manufacturer":"Sony","market_name":"Xperia SP","codename":"M35h","model":"M35h"},{"manufacturer":"Sony","market_name":"Xperia SP","codename":"M35t","model":"M35t"},{"manufacturer":"Sony","market_name":"Xperia T","codename":"LT30a","model":"LT30a"},{"manufacturer":"Sony","market_name":"Xperia T","codename":"LT30p","model":"LT30p"},{"manufacturer":"Sony","market_name":"Xperia T2 Ultra","codename":"D5303","model":"D5303"},{"manufacturer":"Sony","market_name":"Xperia T2 Ultra","codename":"D5306","model":"D5306"},{"manufacturer":"Sony","market_name":"Xperia T2 Ultra","codename":"D5316","model":"D5316"},{"manufacturer":"Sony","market_name":"Xperia T2 Ultra","codename":"D5316N","model":"D5316N"},{"manufacturer":"Sony","market_name":"Xperia T2 Ultra","codename":"D5322","model":"D5322"},{"manufacturer":"Sony","market_name":"Xperia T2 Ultra dual","codename":"D5322","model":"D5322"},{"manufacturer":"Sony","market_name":"Xperia T3","codename":"D5102","model":"D5102"},{"manufacturer":"Sony","market_name":"Xperia T3","codename":"D5103","model":"D5103"},{"manufacturer":"Sony","market_name":"Xperia T3","codename":"D5106","model":"D5106"},{"manufacturer":"Sony","market_name":"Xperia TX","codename":"LT29i","model":"LT29i"},{"manufacturer":"Sony","market_name":"Xperia Tablet S","codename":"txs03","model":"SGPT12"},{"manufacturer":"Sony","market_name":"Xperia Tablet S","codename":"txs03","model":"SGPT13"},{"manufacturer":"Sony","market_name":"Xperia Tablet Z","codename":"SGP311","model":"SGP311"},{"manufacturer":"Sony","market_name":"Xperia Tablet Z","codename":"SGP312","model":"SGP312"},{"manufacturer":"Sony","market_name":"Xperia Tablet Z","codename":"SGP321","model":"SGP321"},{"manufacturer":"Sony","market_name":"Xperia Tablet Z","codename":"SGP351","model":"SGP351"},{"manufacturer":"Sony","market_name":"Xperia Tipo","codename":"ST21i","model":"ST21i"},{"manufacturer":"Sony","market_name":"Xperia Tipo","codename":"ST21i2","model":"ST21i2"},{"manufacturer":"Sony","market_name":"Xperia Touch","codename":"G1109","model":"G1109"},{"manufacturer":"Sony","market_name":"Xperia U","codename":"ST25a","model":"ST25a"},{"manufacturer":"Sony","market_name":"Xperia U","codename":"ST25i","model":"ST25i"},{"manufacturer":"Sony","market_name":"Xperia V","codename":"LT25i","model":"LT25i"},{"manufacturer":"Sony","market_name":"Xperia X","codename":"F5121","model":"F5121"},{"manufacturer":"Sony","market_name":"Xperia X","codename":"F5122","model":"F5122"},{"manufacturer":"Sony","market_name":"Xperia X","codename":"suzu","model":"F5121"},{"manufacturer":"Sony","market_name":"Xperia X Compact","codename":"F5321","model":"F5321"},{"manufacturer":"Sony","market_name":"Xperia X Compact","codename":"SO-02J","model":"SO-02J"},{"manufacturer":"Sony","market_name":"Xperia X Performance","codename":"502SO","model":"502SO"},{"manufacturer":"Sony","market_name":"Xperia X Performance","codename":"F8131","model":"F8131"},{"manufacturer":"Sony","market_name":"Xperia X Performance","codename":"F8132","model":"F8132"},{"manufacturer":"Sony","market_name":"Xperia X Performance","codename":"SO-04H","model":"SO-04H"},{"manufacturer":"Sony","market_name":"Xperia X Performance","codename":"SOV33","model":"SOV33"},{"manufacturer":"Sony","market_name":"Xperia XA","codename":"F3111","model":"F3111"},{"manufacturer":"Sony","market_name":"Xperia XA","codename":"F3112","model":"F3112"},{"manufacturer":"Sony","market_name":"Xperia XA","codename":"F3113","model":"F3113"},{"manufacturer":"Sony","market_name":"Xperia XA","codename":"F3115","model":"F3115"},{"manufacturer":"Sony","market_name":"Xperia XA","codename":"F3116","model":"F3116"},{"manufacturer":"Sony","market_name":"Xperia XA Ultra","codename":"F3211","model":"F3211"},{"manufacturer":"Sony","market_name":"Xperia XA Ultra","codename":"F3212","model":"F3212"},{"manufacturer":"Sony","market_name":"Xperia XA Ultra","codename":"F3213","model":"F3213"},{"manufacturer":"Sony","market_name":"Xperia XA Ultra","codename":"F3215","model":"F3215"},{"manufacturer":"Sony","market_name":"Xperia XA Ultra","codename":"F3216","model":"F3216"},{"manufacturer":"Sony","market_name":"Xperia XA1","codename":"G3112","model":"G3112"},{"manufacturer":"Sony","market_name":"Xperia XA1","codename":"G3116","model":"G3116"},{"manufacturer":"Sony","market_name":"Xperia XA1","codename":"G3121","model":"G3121"},{"manufacturer":"Sony","market_name":"Xperia XA1","codename":"G3123","model":"G3123"},{"manufacturer":"Sony","market_name":"Xperia XA1","codename":"G3125","model":"G3125"},{"manufacturer":"Sony","market_name":"Xperia XA1 Plus","codename":"G3412","model":"G3412"},{"manufacturer":"Sony","market_name":"Xperia XA1 Plus","codename":"G3416","model":"G3416"},{"manufacturer":"Sony","market_name":"Xperia XA1 Plus","codename":"G3421","model":"G3421"},{"manufacturer":"Sony","market_name":"Xperia XA1 Plus","codename":"G3423","model":"G3423"},{"manufacturer":"Sony","market_name":"Xperia XA1 Plus","codename":"G3426","model":"G3426"},{"manufacturer":"Sony","market_name":"Xperia XA1 Ultra","codename":"G3212","model":"G3212"},{"manufacturer":"Sony","market_name":"Xperia XA1 Ultra","codename":"G3221","model":"G3221"},{"manufacturer":"Sony","market_name":"Xperia XA1 Ultra","codename":"G3223","model":"G3223"},{"manufacturer":"Sony","market_name":"Xperia XA1 Ultra","codename":"G3226","model":"G3226"},{"manufacturer":"Sony","market_name":"Xperia XA2","codename":"H3113","model":"H3113"},{"manufacturer":"Sony","market_name":"Xperia XA2","codename":"H3123","model":"H3123"},{"manufacturer":"Sony","market_name":"Xperia XA2","codename":"H3133","model":"H3133"},{"manufacturer":"Sony","market_name":"Xperia XA2","codename":"H4113","model":"H4113"},{"manufacturer":"Sony","market_name":"Xperia XA2","codename":"H4133","model":"H4133"},{"manufacturer":"Sony","market_name":"Xperia XA2 Ultra","codename":"H3213","model":"H3213"},{"manufacturer":"Sony","market_name":"Xperia XA2 Ultra","codename":"H3223","model":"H3223"},{"manufacturer":"Sony","market_name":"Xperia XA2 Ultra","codename":"H4213","model":"H4213"},{"manufacturer":"Sony","market_name":"Xperia XA2 Ultra","codename":"H4233","model":"H4233"},{"manufacturer":"Sony","market_name":"Xperia XZ","codename":"601SO","model":"601SO"},{"manufacturer":"Sony","market_name":"Xperia XZ","codename":"F8331","model":"F8331"},{"manufacturer":"Sony","market_name":"Xperia XZ","codename":"F8332","model":"F8332"},{"manufacturer":"Sony","market_name":"Xperia XZ","codename":"SO-01J","model":"SO-01J"},{"manufacturer":"Sony","market_name":"Xperia XZ","codename":"SOV34","model":"SOV34"},{"manufacturer":"Sony","market_name":"Xperia XZ Premium","codename":"G8141","model":"G8141"},{"manufacturer":"Sony","market_name":"Xperia XZ Premium","codename":"G8142","model":"G8142"},{"manufacturer":"Sony","market_name":"Xperia XZ Premium","codename":"G8188","model":"G8188"},{"manufacturer":"Sony","market_name":"Xperia XZ Premium","codename":"SO-04J","model":"SO-04J"},{"manufacturer":"Sony","market_name":"Xperia XZ1","codename":"701SO","model":"701SO"},{"manufacturer":"Sony","market_name":"Xperia XZ1","codename":"G8341","model":"G8341"},{"manufacturer":"Sony","market_name":"Xperia XZ1","codename":"G8342","model":"G8342"},{"manufacturer":"Sony","market_name":"Xperia XZ1","codename":"G8343","model":"G8343"},{"manufacturer":"Sony","market_name":"Xperia XZ1","codename":"SO-01K","model":"SO-01K"},{"manufacturer":"Sony","market_name":"Xperia XZ1","codename":"SOV36","model":"SOV36"},{"manufacturer":"Sony","market_name":"Xperia XZ1 Compact","codename":"G8441","model":"G8441"},{"manufacturer":"Sony","market_name":"Xperia XZ1 Compact","codename":"SO-02K","model":"SO-02K"},{"manufacturer":"Sony","market_name":"Xperia XZ2","codename":"702SO","model":"702SO"},{"manufacturer":"Sony","market_name":"Xperia XZ2","codename":"H8216","model":"H8216"},{"manufacturer":"Sony","market_name":"Xperia XZ2","codename":"H8266","model":"H8266"},{"manufacturer":"Sony","market_name":"Xperia XZ2","codename":"H8276","model":"H8276"},{"manufacturer":"Sony","market_name":"Xperia XZ2","codename":"H8296","model":"H8296"},{"manufacturer":"Sony","market_name":"Xperia XZ2","codename":"SO-03K","model":"SO-03K"},{"manufacturer":"Sony","market_name":"Xperia XZ2","codename":"SOV37","model":"SOV37"},{"manufacturer":"Sony","market_name":"Xperia XZ2 Compact","codename":"H8314","model":"H8314"},{"manufacturer":"Sony","market_name":"Xperia XZ2 Compact","codename":"H8324","model":"H8324"},{"manufacturer":"Sony","market_name":"Xperia XZ2 Compact","codename":"SO-05K","model":"SO-05K"},{"manufacturer":"Sony","market_name":"Xperia XZs","codename":"602SO","model":"602SO"},{"manufacturer":"Sony","market_name":"Xperia XZs","codename":"G8231","model":"G8231"},{"manufacturer":"Sony","market_name":"Xperia XZs","codename":"G8232","model":"G8232"},{"manufacturer":"Sony","market_name":"Xperia XZs","codename":"SO-03J","model":"SO-03J"},{"manufacturer":"Sony","market_name":"Xperia XZs","codename":"SOV35","model":"SOV35"},{"manufacturer":"Sony","market_name":"Xperia Z","codename":"C6602","model":"C6602"},{"manufacturer":"Sony","market_name":"Xperia Z","codename":"C6603","model":"C6603"},{"manufacturer":"Sony","market_name":"Xperia Z","codename":"C6606","model":"C6606"},{"manufacturer":"Sony","market_name":"Xperia Z","codename":"C6616","model":"C6616"},{"manufacturer":"Sony","market_name":"Xperia Z","codename":"L36h","model":"L36h"},{"manufacturer":"Sony","market_name":"Xperia Z","codename":"SO-02E","model":"SO-02E"},{"manufacturer":"Sony","market_name":"Xperia Z Ultra","codename":"C6802","model":"C6802"},{"manufacturer":"Sony","market_name":"Xperia Z Ultra","codename":"C6806","model":"C6806"},{"manufacturer":"Sony","market_name":"Xperia Z Ultra","codename":"C6833","model":"C6833"},{"manufacturer":"Sony","market_name":"Xperia Z Ultra","codename":"C6843","model":"C6843"},{"manufacturer":"Sony","market_name":"Xperia Z Ultra","codename":"SGP412","model":"SGP412"},{"manufacturer":"Sony","market_name":"Xperia Z Ultra","codename":"SOL24","model":"SOL24"},{"manufacturer":"Sony","market_name":"Xperia Z Ultra","codename":"XL39h","model":"XL39h"},{"manufacturer":"Sony","market_name":"Xperia Z1","codename":"C6902","model":"C6902"},{"manufacturer":"Sony","market_name":"Xperia Z1","codename":"C6903","model":"C6903"},{"manufacturer":"Sony","market_name":"Xperia Z1","codename":"C6906","model":"C6906"},{"manufacturer":"Sony","market_name":"Xperia Z1","codename":"C6916","model":"C6916"},{"manufacturer":"Sony","market_name":"Xperia Z1","codename":"C6943","model":"C6943"},{"manufacturer":"Sony","market_name":"Xperia Z1","codename":"L39h","model":"L39h"},{"manufacturer":"Sony","market_name":"Xperia Z1","codename":"L39t","model":"L39t"},{"manufacturer":"Sony","market_name":"Xperia Z1","codename":"L39u","model":"L39u"},{"manufacturer":"Sony","market_name":"Xperia Z1","codename":"SO-01F","model":"SO-01F"},{"manufacturer":"Sony","market_name":"Xperia Z1","codename":"SOL23","model":"SOL23"},{"manufacturer":"Sony","market_name":"Xperia Z1 Compact","codename":"D5503","model":"D5503"},{"manufacturer":"Sony","market_name":"Xperia Z1 Compact","codename":"M51w","model":"M51w"},{"manufacturer":"Sony","market_name":"Xperia Z1f","codename":"SO-02F","model":"SO-02F"},{"manufacturer":"Sony","market_name":"Xperia Z2","codename":"D6502","model":"D6502"},{"manufacturer":"Sony","market_name":"Xperia Z2","codename":"D6503","model":"D6503"},{"manufacturer":"Sony","market_name":"Xperia Z2","codename":"D6543","model":"D6543"},{"manufacturer":"Sony","market_name":"Xperia Z2","codename":"SO-03F","model":"SO-03F"},{"manufacturer":"Sony","market_name":"Xperia Z2 Tablet","codename":"SGP511","model":"SGP511"},{"manufacturer":"Sony","market_name":"Xperia Z2 Tablet","codename":"SGP512","model":"SGP512"},{"manufacturer":"Sony","market_name":"Xperia Z2 Tablet","codename":"SGP521","model":"SGP521"},{"manufacturer":"Sony","market_name":"Xperia Z2 Tablet","codename":"SGP551","model":"SGP551"},{"manufacturer":"Sony","market_name":"Xperia Z2 Tablet","codename":"SGP561","model":"SGP561"},{"manufacturer":"Sony","market_name":"Xperia Z2 Tablet","codename":"SO-05F","model":"SO-05F"},{"manufacturer":"Sony","market_name":"Xperia Z2 Tablet","codename":"SOT21","model":"SOT21"},{"manufacturer":"Sony","market_name":"Xperia Z2a","codename":"D6563","model":"D6563"},{"manufacturer":"Sony","market_name":"Xperia Z3","codename":"401SO","model":"401SO"},{"manufacturer":"Sony","market_name":"Xperia Z3","codename":"D6603","model":"D6603"},{"manufacturer":"Sony","market_name":"Xperia Z3","codename":"D6616","model":"D6616"},{"manufacturer":"Sony","market_name":"Xperia Z3","codename":"D6643","model":"D6643"},{"manufacturer":"Sony","market_name":"Xperia Z3","codename":"D6646","model":"D6646"},{"manufacturer":"Sony","market_name":"Xperia Z3","codename":"D6653","model":"D6653"},{"manufacturer":"Sony","market_name":"Xperia Z3","codename":"SO-01G","model":"SO-01G"},{"manufacturer":"Sony","market_name":"Xperia Z3","codename":"SOL26","model":"SOL26"},{"manufacturer":"Sony","market_name":"Xperia Z3","codename":"leo","model":"D6603"},{"manufacturer":"Sony","market_name":"Xperia Z3 Compact","codename":"D5803","model":"D5803"},{"manufacturer":"Sony","market_name":"Xperia Z3 Compact","codename":"D5833","model":"D5833"},{"manufacturer":"Sony","market_name":"Xperia Z3 Compact","codename":"SO-02G","model":"SO-02G"},{"manufacturer":"Sony","market_name":"Xperia Z3 Compact","codename":"aries","model":"D5803"},{"manufacturer":"Sony","market_name":"Xperia Z3 Dual","codename":"D6633","model":"D6633"},{"manufacturer":"Sony","market_name":"Xperia Z3 Dual","codename":"D6683","model":"D6683"},{"manufacturer":"Sony","market_name":"Xperia Z3 Tablet Compact","codename":"SGP611","model":"SGP611"},{"manufacturer":"Sony","market_name":"Xperia Z3 Tablet Compact","codename":"SGP612","model":"SGP612"},{"manufacturer":"Sony","market_name":"Xperia Z3 Tablet Compact","codename":"SGP621","model":"SGP621"},{"manufacturer":"Sony","market_name":"Xperia Z3 Tablet Compact","codename":"SGP641","model":"SGP641"},{"manufacturer":"Sony","market_name":"Xperia Z3+","codename":"E6553","model":"E6553"},{"manufacturer":"Sony","market_name":"Xperia Z3+ Dual","codename":"E6533","model":"E6533"},{"manufacturer":"Sony","market_name":"Xperia Z3v","codename":"D6708","model":"D6708"},{"manufacturer":"Sony","market_name":"Xperia Z4","codename":"402SO","model":"402SO"},{"manufacturer":"Sony","market_name":"Xperia Z4","codename":"SO-03G","model":"SO-03G"},{"manufacturer":"Sony","market_name":"Xperia Z4","codename":"SOV31","model":"SOV31"},{"manufacturer":"Sony","market_name":"Xperia Z4 Tablet","codename":"SGP712","model":"SGP712"},{"manufacturer":"Sony","market_name":"Xperia Z4 Tablet","codename":"SGP771","model":"SGP771"},{"manufacturer":"Sony","market_name":"Xperia Z4 Tablet","codename":"SO-05G","model":"SO-05G"},{"manufacturer":"Sony","market_name":"Xperia Z4 Tablet","codename":"SOT31","model":"SOT31"},{"manufacturer":"Sony","market_name":"Xperia Z4v","codename":"E6508","model":"E6508"},{"manufacturer":"Sony","market_name":"Xperia Z5","codename":"501SO","model":"501SO"},{"manufacturer":"Sony","market_name":"Xperia Z5","codename":"E6603","model":"E6603"},{"manufacturer":"Sony","market_name":"Xperia Z5","codename":"E6653","model":"E6653"},{"manufacturer":"Sony","market_name":"Xperia Z5","codename":"SO-01H","model":"SO-01H"},{"manufacturer":"Sony","market_name":"Xperia Z5","codename":"SOV32","model":"SOV32"},{"manufacturer":"Sony","market_name":"Xperia Z5 Compact","codename":"E5803","model":"E5803"},{"manufacturer":"Sony","market_name":"Xperia Z5 Compact","codename":"E5823","model":"E5823"},{"manufacturer":"Sony","market_name":"Xperia Z5 Compact","codename":"SO-02H","model":"SO-02H"},{"manufacturer":"Sony","market_name":"Xperia Z5 Premium","codename":"E6853","model":"E6853"},{"manufacturer":"Sony","market_name":"Xperia Z5 Premium","codename":"E6883","model":"E6883"},{"manufacturer":"Sony","market_name":"Xperia Z5 Premium","codename":"SO-03H","model":"SO-03H"},{"manufacturer":"Sony","market_name":"Xperia Z5 Premium Dual","codename":"E6833","model":"E6833"},{"manufacturer":"Sony","market_name":"Xperia Z5 dual","codename":"E6633","model":"E6633"},{"manufacturer":"Sony","market_name":"Xperia Z5 dual","codename":"E6683","model":"E6683"},{"manufacturer":"Sony","market_name":"Xperia ZL","codename":"C6502","model":"C6502"},{"manufacturer":"Sony","market_name":"Xperia ZL","codename":"C6503","model":"C6503"},{"manufacturer":"Sony","market_name":"Xperia ZL","codename":"C6506","model":"C6506"},{"manufacturer":"Sony","market_name":"Xperia ZL","codename":"L35h","model":"L35h"},{"manufacturer":"Sony","market_name":"Xperia ZL2","codename":"SOL25","model":"SOL25"},{"manufacturer":"Sony","market_name":"Xperia ZR","codename":"C5306","model":"C5306"},{"manufacturer":"Sony","market_name":"Xperia ZR","codename":"C5502","model":"C5502"},{"manufacturer":"Sony","market_name":"Xperia ZR","codename":"C5503","model":"C5503"},{"manufacturer":"Sony","market_name":"Xperia acro HD","codename":"SO-03D","model":"SO-03D"},{"manufacturer":"Sony","market_name":"Xperia acro S","codename":"LT26w","model":"LT26w"},{"manufacturer":"Sony","market_name":"Xperia active","codename":"ST17i","model":"ST17i"},{"manufacturer":"Sony","market_name":"Xperia arc S","codename":"LT18i","model":"LT18i"},{"manufacturer":"Sony","market_name":"Xperia go","codename":"ST27i","model":"ST27i"},{"manufacturer":"Sony","market_name":"Xperia ion","codename":"LT28h","model":"LT28h"},{"manufacturer":"Sony","market_name":"Xperia ion","codename":"LT28i","model":"LT28i"},{"manufacturer":"Sony","market_name":"Xperia mini pro","codename":"SK17a","model":"SK17a"},{"manufacturer":"Sony","market_name":"Xperia miro","codename":"ST23a","model":"ST23a"},{"manufacturer":"Sony","market_name":"Xperia miro","codename":"ST23i","model":"ST23i"},{"manufacturer":"Sony","market_name":"Xperia neo L","codename":"MT25i","model":"MT25i"},{"manufacturer":"Sony","market_name":"Xperia pro","codename":"MK16i","model":"MK16i"},{"manufacturer":"Sony","market_name":"Xperia ray","codename":"ST18i","model":"ST18i"},{"manufacturer":"Sony","market_name":"Xperia sola","codename":"MT27i","model":"MT27i"},{"manufacturer":"Sony","market_name":"Xperia tipo","codename":"ST21a","model":"ST21a"},{"manufacturer":"Sony","market_name":"Xperia tipo dual","codename":"ST21a2","model":"ST21a2"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 C4","codename":"E5303","model":"E5303"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 C4","codename":"E5306","model":"E5306"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 C4","codename":"E5353","model":"E5353"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 C4 Dual","codename":"E5333","model":"E5333"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 C4 Dual","codename":"E5343","model":"E5343"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 C4 Dual","codename":"E5363","model":"E5363"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 E4","codename":"E2104","model":"E2104"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 E4","codename":"E2105","model":"E2105"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 E4 Dual","codename":"E2115","model":"E2115"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 E4 Dual","codename":"E2124","model":"E2124"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 E4g","codename":"E2003","model":"E2003"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 E4g","codename":"E2006","model":"E2006"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 M4 Aqua","codename":"E2303","model":"E2303"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 M4 Aqua","codename":"E2306","model":"E2306"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 M4 Aqua","codename":"E2353","model":"E2353"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 M4 Aqua Dual","codename":"E2312","model":"E2312"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 M4 Aqua Dual","codename":"E2333","model":"E2333"},{"manufacturer":"Sony","market_name":"Xperia\\xe2\\x84\\xa2 M4 Aqua Dual","codename":"E2363","model":"E2363"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"LT15a","model":"LT15a"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"LT18i","model":"LT18i"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"LT22i","model":"LT22i"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"LT26i","model":"LT26i"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"LT28h","model":"LT28h"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"LT28i","model":"LT28i"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"MK16a","model":"MK16a"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"MK16i","model":"MK16i"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"MT11i","model":"MT11i"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"MT15i","model":"MT15i"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"MT27i","model":"MT27i"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"R800x","model":"R800x"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"SK17i","model":"SK17i"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"ST15i","model":"ST15i"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"ST17i","model":"ST17i"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"ST18i","model":"ST18i"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"WT18i","model":"WT18i"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"WT19a","model":"WT19a"},{"manufacturer":"Sony Ericsson","market_name":"","codename":"WT19i","model":"WT19i"},{"manufacturer":"Sony Ericsson","market_name":"Live with Walkman","codename":"WT19a","model":"WT19a"},{"manufacturer":"Sony Ericsson","market_name":"Live with Walkman","codename":"WT19i","model":"WT19i"},{"manufacturer":"Sony Ericsson","market_name":"Live with Walkman(TM)","codename":"WT19a","model":"WT19a"},{"manufacturer":"Sony Ericsson","market_name":"X10 Xperia Mini","codename":"robyn","model":"E10i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia AX","codename":"SO-01E","model":"SO-01E"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Acro","codename":"IS11S","model":"IS11S"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Acro","codename":"SO-02C","model":"SO-02C"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Arc","codename":"LT15i","model":"LT15i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Arc","codename":"SO-01C","model":"SO-01C"},{"manufacturer":"Sony Ericsson","market_name":"Xperia C","codename":"S39h","model":"S39h"},{"manufacturer":"Sony Ericsson","market_name":"Xperia GX","codename":"SO-04D","model":"SO-04D"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Go","codename":"ST27a","model":"ST27a"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Go","codename":"ST27i","model":"ST27i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia J","codename":"ST26i","model":"ST26i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Neo","codename":"MT15i","model":"MT15i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia P","codename":"LT22i","model":"LT22i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia PLAY","codename":"R800a","model":"R800a"},{"manufacturer":"Sony Ericsson","market_name":"Xperia PLAY","codename":"R800at","model":"R800at"},{"manufacturer":"Sony Ericsson","market_name":"Xperia PLAY","codename":"R800i","model":"R800i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia PLAY","codename":"R800x","model":"R800x"},{"manufacturer":"Sony Ericsson","market_name":"Xperia PLAY","codename":"SO-01D","model":"SO-01D"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Play","codename":"R800i","model":"R800i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Play","codename":"Zeus","model":"Zeus"},{"manufacturer":"Sony Ericsson","market_name":"Xperia S","codename":"LT26i","model":"LT26i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia S","codename":"SO-02D","model":"SO-02D"},{"manufacturer":"Sony Ericsson","market_name":"Xperia SL","codename":"LT26ii","model":"LT26ii"},{"manufacturer":"Sony Ericsson","market_name":"Xperia SP","codename":"M35c","model":"M35c"},{"manufacturer":"Sony Ericsson","market_name":"Xperia SX","codename":"SO-05D","model":"SO-05D"},{"manufacturer":"Sony Ericsson","market_name":"Xperia T","codename":"LT30a","model":"LT30a"},{"manufacturer":"Sony Ericsson","market_name":"Xperia T","codename":"LT30at","model":"LT30at"},{"manufacturer":"Sony Ericsson","market_name":"Xperia T","codename":"LT30p","model":"LT30p"},{"manufacturer":"Sony Ericsson","market_name":"Xperia TX","codename":"LT29i","model":"LT29i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Tablet Z","codename":"SGP311","model":"SGP311"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Tablet Z","codename":"SGP321","model":"SGP321"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Tablet Z","codename":"SGP341","model":"SGP341"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Tablet Z","codename":"SO-03E","model":"SO-03E"},{"manufacturer":"Sony Ericsson","market_name":"Xperia U","codename":"ST25i","model":"ST25i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia UL","codename":"SOL22","model":"SOL22"},{"manufacturer":"Sony Ericsson","market_name":"Xperia V","codename":"LT25c","model":"LT25c"},{"manufacturer":"Sony Ericsson","market_name":"Xperia V","codename":"LT25i","model":"LT25i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia VL","codename":"SOL21","model":"SOL21"},{"manufacturer":"Sony Ericsson","market_name":"Xperia X10","codename":"SO-01B","model":"SO-01B"},{"manufacturer":"Sony Ericsson","market_name":"Xperia X10","codename":"SonyEricssonSO-01B","model":"SO-01B"},{"manufacturer":"Sony Ericsson","market_name":"Xperia X10","codename":"SonyEricssonX10iv","model":"X10i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia X10","codename":"X10a","model":"X10a"},{"manufacturer":"Sony Ericsson","market_name":"Xperia X10","codename":"X10i","model":"X10i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia X10 Mini","codename":"E10i","model":"E10i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia X10 Mini","codename":"SonyEricssonE10i","model":"E10i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia X10 Mini Pro","codename":"U20i","model":"U20i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia X10 mini","codename":"SonyEricssonE10a","model":"E10a"},{"manufacturer":"Sony Ericsson","market_name":"Xperia X10 mini pro","codename":"SonyEricssonU20a","model":"U20a"},{"manufacturer":"Sony Ericsson","market_name":"Xperia X8","codename":"E15i","model":"E15i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Z","codename":"SO-02E","model":"SO-02E"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Z Ultra","codename":"C6806","model":"C6806"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Z1","codename":"C6903","model":"C6903"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Z1","codename":"C6906","model":"C6906"},{"manufacturer":"Sony Ericsson","market_name":"Xperia Z1","codename":"C6943","model":"C6943"},{"manufacturer":"Sony Ericsson","market_name":"Xperia acro HD","codename":"IS12S","model":"IS12S"},{"manufacturer":"Sony Ericsson","market_name":"Xperia acro S","codename":"LT26w","model":"LT26w"},{"manufacturer":"Sony Ericsson","market_name":"Xperia active","codename":"ST17i","model":"ST17i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia arc","codename":"LT15a","model":"LT15a"},{"manufacturer":"Sony Ericsson","market_name":"Xperia arc","codename":"LT15i","model":"LT15i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia arc S","codename":"LT18a","model":"LT18a"},{"manufacturer":"Sony Ericsson","market_name":"Xperia arc S","codename":"LT18i","model":"LT18i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia go","codename":"ST27i","model":"ST27i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia ion","codename":"LT28at","model":"LT28at"},{"manufacturer":"Sony Ericsson","market_name":"Xperia ion","codename":"LT28h","model":"LT28h"},{"manufacturer":"Sony Ericsson","market_name":"Xperia ion","codename":"LT28i","model":"LT28i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia live","codename":"WT19a","model":"WT19a"},{"manufacturer":"Sony Ericsson","market_name":"Xperia mini","codename":"S51SE","model":"S51SE"},{"manufacturer":"Sony Ericsson","market_name":"Xperia mini","codename":"ST15a","model":"ST15a"},{"manufacturer":"Sony Ericsson","market_name":"Xperia mini","codename":"ST15i","model":"ST15i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia mini pro","codename":"SK17a","model":"SK17a"},{"manufacturer":"Sony Ericsson","market_name":"Xperia mini pro","codename":"SK17i","model":"SK17i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia miro","codename":"ST23i","model":"ST23i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia neo","codename":"MT15a","model":"MT15a"},{"manufacturer":"Sony Ericsson","market_name":"Xperia neo","codename":"MT15i","model":"MT15i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia neo L","codename":"MT25i","model":"MT25i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia neo V","codename":"MT11a","model":"MT11a"},{"manufacturer":"Sony Ericsson","market_name":"Xperia neo V","codename":"MT11i","model":"MT11i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia pro","codename":"MK16a","model":"MK16a"},{"manufacturer":"Sony Ericsson","market_name":"Xperia pro","codename":"MK16i","model":"MK16i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia ray","codename":"SO-03C","model":"SO-03C"},{"manufacturer":"Sony Ericsson","market_name":"Xperia ray","codename":"ST18a","model":"ST18a"},{"manufacturer":"Sony Ericsson","market_name":"Xperia ray","codename":"ST18i","model":"ST18i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia sola","codename":"MT27i","model":"MT27i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia tipo","codename":"ST21i","model":"ST21i"},{"manufacturer":"Sony Ericsson","market_name":"Xperia tipo dual","codename":"ST21i2","model":"ST21i2"},{"manufacturer":"Sophix_Digix","market_name":"TAB-750_G","codename":"TAB-750_G","model":"TAB-750_G"},{"manufacturer":"Sourcing Creation","market_name":"Connect 451","codename":"Connect451","model":"Connect 451"},{"manufacturer":"Sourcing Creation","market_name":"Connect 504","codename":"Q9","model":"Connect504"},{"manufacturer":"Sourcing Creation","market_name":"Connect502","codename":"Connect502","model":"Connect502"},{"manufacturer":"Sourcing Creation","market_name":"Connect502","codename":"MT502","model":"Connect502"},{"manufacturer":"Sourcing Creation","market_name":"Connect551","codename":"Connect551","model":"Connect551"},{"manufacturer":"Sourcing Creation","market_name":"Key\\'TAB 1001","codename":"MB979T9","model":"Smarttab_9701"},{"manufacturer":"Sourcing Creation","market_name":"SP402","codename":"SP402","model":"SP402"},{"manufacturer":"Sourcing Creation","market_name":"ST1003S","codename":"T1882R","model":"Smart_TAB_1003s"},{"manufacturer":"Sourcing Creation","market_name":"Smart TAB 1005","codename":"M16Q1C","model":"SmartTab1005"},{"manufacturer":"Sourcing Creation","market_name":"Smart Tab 1004XS","codename":"SmartTab_1004_XS","model":"SmartTab_1004_XS"},{"manufacturer":"Sourcing Creation","market_name":"Smart\\' Tab 1006","codename":"M16Q1A","model":"SmartTab1006"},{"manufacturer":"Sourcing Creation","market_name":"SmartTab_8004","codename":"T814","model":"SmartTab_8004"},{"manufacturer":"Sourcing Creation","market_name":"Web\\'Pad_1002_02","codename":"Webpad_1002_02","model":"Webpad_1002_02"},{"manufacturer":"Sourcing Creation","market_name":"Webpad7006","codename":"ES721","model":"Webpad7006"},{"manufacturer":"Sourcing Creation","market_name":"Wooze I 5","codename":"Wooze_I5","model":"Wooze_I5"},{"manufacturer":"Sourcing Creation","market_name":"Wooze I 5.5 Gris","codename":"Wooze_I55","model":"Wooze_I55"},{"manufacturer":"Sourcing Creation","market_name":"Wooze L","codename":"Wooze_L","model":"Wooze_L"},{"manufacturer":"Sourcing Creation","market_name":"Wooze XL","codename":"Wooze_XL","model":"Wooze_XL"},{"manufacturer":"Sourcing Creation","market_name":"WoozeI45","codename":"WoozeI45","model":"WoozeI45"},{"manufacturer":"Sourcing Creation","market_name":"sp401","codename":"sp401","model":"sp401"},{"manufacturer":"Sourcing Creation","market_name":"webpad_7005","codename":"MB709Q5","model":"Webpad_7005"},{"manufacturer":"Southern Telecom","market_name":"A1000/P1003/P1010","codename":"A1000","model":"A1000/P1003/P1010"},{"manufacturer":"Southern Telecom","market_name":"A400","codename":"A400","model":"A400"},{"manufacturer":"Southern Telecom","market_name":"A5","codename":"A5","model":"A5"},{"manufacturer":"Southern Telecom","market_name":"A500","codename":"Polaroid_Phone","model":"a500"},{"manufacturer":"Southern Telecom","market_name":"A600","codename":"A600","model":"A600"},{"manufacturer":"Southern Telecom","market_name":"Emerson EM756","codename":"EM756","model":"EM756"},{"manufacturer":"Southern Telecom","market_name":"M10","codename":"ST1009","model":"M10"},{"manufacturer":"Southern Telecom","market_name":"M10","codename":"ST1009","model":"M10/Q1010"},{"manufacturer":"Southern Telecom","market_name":"M11H/Q1100","codename":"M11H","model":"M11H/Q1100"},{"manufacturer":"Southern Telecom","market_name":"Nook Tablet 7\\xe2\\x80\\x9d","codename":"st16c7bnn","model":"BNTV450"},{"manufacturer":"Southern Telecom","market_name":"P709/P716","codename":"P709","model":"P709/P716"},{"manufacturer":"Southern Telecom","market_name":"P7100","codename":"P7100","model":"P7100"},{"manufacturer":"Southern Telecom","market_name":"P909","codename":"P909","model":"P909"},{"manufacturer":"Southern Telecom","market_name":"PDT9000","codename":"PDT9000","model":"PDT9000"},{"manufacturer":"Southern Telecom","market_name":"Polaroid L10/P1000","codename":"L10","model":"L10"},{"manufacturer":"Southern Telecom","market_name":"Polaroid M11","codename":"M11","model":"M11"},{"manufacturer":"Southern Telecom","market_name":"Polaroid P700/A700","codename":"P700","model":"P700/A700"},{"manufacturer":"Southern Telecom","market_name":"Polaroid P902/A900","codename":"P902","model":"P902/A900"},{"manufacturer":"Southern Telecom","market_name":"Polaroid Power P600","codename":"P600","model":"P600"},{"manufacturer":"Southern Telecom","market_name":"Polaroid Snap S50","codename":"S50","model":"S50"},{"manufacturer":"Southern Telecom","market_name":"Polaroid Snap S55","codename":"S55","model":"S55"},{"manufacturer":"Southern Telecom","market_name":"Polaroid Snap S60","codename":"S60","model":"S60"},{"manufacturer":"Southern Telecom","market_name":"ST1009","codename":"ST1009","model":"ST1009"},{"manufacturer":"Southern Telecom","market_name":"ST13","codename":"ST13","model":"ST13"},{"manufacturer":"Southern Telecom","market_name":"ST706","codename":"P709","model":"ST706"},{"manufacturer":"Southern Telecom","market_name":"Smartab ST10","codename":"ST10","model":"ST10/ST10x"},{"manufacturer":"Southern Telecom","market_name":"Smartab ST7","codename":"ST7","model":"ST7/ST7x"},{"manufacturer":"Southern Telecom","market_name":"Streamachine","codename":"X13","model":"X13"},{"manufacturer":"Southern Telecom","market_name":"a4","codename":"a4","model":"a4"},{"manufacturer":"SpectraPrecision","market_name":"Ranger 5 Handheld","codename":"workhorse_wifi","model":"Ranger5"},{"manufacturer":"SpectraPrecision","market_name":"Ranger 8 Handheld","codename":"pelican","model":"Ranger8"},{"manufacturer":"SpectraPrecision","market_name":"Ranger 8 Handheld","codename":"pelican_wifi","model":"Ranger8"},{"manufacturer":"SpectraPrecision","market_name":"Spectra Ranger 5","codename":"workhorse","model":"Ranger5"},{"manufacturer":"Spectralink","market_name":"8744","codename":"thor_6dq","model":"8744"},{"manufacturer":"Spectralink","market_name":"PIVOT 8741/8753","codename":"thor_6dq","model":"8741"},{"manufacturer":"Spectralink","market_name":"PIVOT 8741/8753","codename":"thor_6dq","model":"8742"},{"manufacturer":"Spectralink","market_name":"PIVOT 8741/8753","codename":"thor_6dq","model":"8753"},{"manufacturer":"Speedmind","market_name":"Pr6145","codename":"Pr6145","model":"Pr6145"},{"manufacturer":"Spice","market_name":"Dream Uno","codename":"Mi-498_sprout","model":"Spice Mi-498"},{"manufacturer":"Spice","market_name":"Dream Uno","codename":"Mi-498_sprout","model":"Spice Mi-498H"},{"manufacturer":"Spice","market_name":"F301","codename":"Spice_F301","model":"Spice F301"},{"manufacturer":"Spice","market_name":"F302","codename":"Spice_F302","model":"Spice F302"},{"manufacturer":"Spice","market_name":"F305","codename":"Spice-F305","model":"Spice F305"},{"manufacturer":"Spice","market_name":"K601","codename":"Spice_K601","model":"Spice K601"},{"manufacturer":"Spice","market_name":"Smart Flo Mi-449","codename":"SpiceMi449","model":"SpiceMi-449"},{"manufacturer":"Spice","market_name":"Smart Flo Mi-449","codename":"hongyu72_wet_jb3","model":"SpiceMi-449"},{"manufacturer":"Spice","market_name":"Spice F302","codename":"Spice_F302","model":"Spice F302"},{"manufacturer":"Spice","market_name":"Spice V801","codename":"Spice_V801","model":"Spice V801"},{"manufacturer":"Spice","market_name":"Stellar Mi-438","codename":"Spice","model":"MI-438"},{"manufacturer":"Spice","market_name":"Stellar Mi-506","codename":"SpiceMi506","model":"Spice Mi-506"},{"manufacturer":"Spice","market_name":"V801","codename":"Spice_V801","model":"Spice V801"},{"manufacturer":"Spice","market_name":"Victor5","codename":"Spice","model":"Xlife-Victor5"},{"manufacturer":"Spice","market_name":"Xlife-441Q","codename":"Spice","model":"Xlife-415"},{"manufacturer":"Spice","market_name":"Xlife-441Q","codename":"Spice","model":"Xlife-441Q"},{"manufacturer":"Spice","market_name":"Xlife-450Q","codename":"Spice","model":"Xlife-450Q"},{"manufacturer":"Spice","market_name":"Xlife-514Q","codename":"Spice","model":"Xlife-514Q"},{"manufacturer":"Spice","market_name":"Xlife-M44Q","codename":"Spice","model":"Xlife-M44Q"},{"manufacturer":"Spice","market_name":"Xlife-Proton 5 pro","codename":"Spice","model":"Xlife-Proton5 Pro"},{"manufacturer":"Sprint","market_name":"AQT100","codename":"NKJ_AQT100","model":"AQT100"},{"manufacturer":"Sprint","market_name":"AQT82","codename":"NKSA_AQT82","model":"AQT82"},{"manufacturer":"Sprint","market_name":"HTC Bolt","codename":"htc_acawhl","model":"2PYB2"},{"manufacturer":"Sprint","market_name":"Slate 8 Tablet","codename":"NKS_AQT80","model":"AQT80"},{"manufacturer":"StarMobile","market_name":"UP Groove","codename":"UP_Groove","model":"UP_Groove"},{"manufacturer":"StarMobile","market_name":"UP Prime","codename":"UP_Prime","model":"UP Prime"},{"manufacturer":"StarMobile","market_name":"UP Selfie","codename":"UP_Selfie","model":"UP_Selfie"},{"manufacturer":"StarMobile","market_name":"UP Xtreme","codename":"UP_Xtreme","model":"UP_Xtreme"},{"manufacturer":"Starlight","market_name":"Future","codename":"Future","model":"Future"},{"manufacturer":"Starlight","market_name":"I STAR PLUS","codename":"I_STAR_PLUS","model":"I_STAR_PLUS"},{"manufacturer":"Starlight","market_name":"Madrid","codename":"Madrid","model":"Madrid"},{"manufacturer":"Starlight","market_name":"STAR_MIX","codename":"STAR_MIX","model":"STAR_MIX"},{"manufacturer":"Starlight","market_name":"Starplus 7","codename":"STARPLUS7","model":"STARPLUS7"},{"manufacturer":"Starlight","market_name":"UMI_G","codename":"UMI_G","model":"UMI_G"},{"manufacturer":"Storex","market_name":"eZee\\'Tab7Q11-M","codename":"Tab7Q11","model":"Tab7Q11"},{"manufacturer":"Storex","market_name":"eZeeTab10D12-S","codename":"eZeeTab10D12-S","model":"eZeeTab10D12-S"},{"manufacturer":"Storex","market_name":"eZeeTab7D15-M","codename":"eZeeTab7D15-M","model":"eZeeTab7D15-M"},{"manufacturer":"Storex","market_name":"eZee\\xe2\\x80\\x99Tab7D14-S","codename":"STOREX7526","model":"NID_7010"},{"manufacturer":"Strawberry","market_name":"ST9009","codename":"ST9009","model":"ST9009"},{"manufacturer":"Stream","market_name":"B1","codename":"B1","model":"B1"},{"manufacturer":"Stream","market_name":"B2mini","codename":"B2mini","model":"B2mini"},{"manufacturer":"Stream","market_name":"B2s","codename":"B2s","model":"B2s"},{"manufacturer":"Stream","market_name":"FIXION","codename":"HS8937QC","model":"FIXION"},{"manufacturer":"Stream","market_name":"Iron Pro","codename":"IRON_Pro","model":"IRON Pro"},{"manufacturer":"Stream","market_name":"PERLA","codename":"PERLA","model":"PERLA"},{"manufacturer":"Stream","market_name":"SHARK","codename":"SHARK","model":"SHARK"},{"manufacturer":"Sts-tottori","market_name":"JR-500","codename":"JR-500","model":"JR-500"},{"manufacturer":"Sts-tottori","market_name":"JR-P2000","codename":"JR-P2000","model":"JR-P2000"},{"manufacturer":"Sts-tottori","market_name":"TAB-A03","codename":"TAB-A03","model":"TAB-A03-SD"},{"manufacturer":"Stylo","market_name":"S551","codename":"STYLO_S551","model":"STYLO S551"},{"manufacturer":"Stylo","market_name":"STYLO MAX","codename":"Stylo_Max","model":"MAX"},{"manufacturer":"Stylo","market_name":"STYLOF1","codename":"STYLOF1","model":"STYLO F1"},{"manufacturer":"Stylo","market_name":"STYLO_S61","codename":"STYLO_S61","model":"STYLO SM61 MAGIC+"},{"manufacturer":"Stylo","market_name":"STYLO_S61","codename":"STYLO_S61","model":"STYLO SV61 VECTOR+"},{"manufacturer":"Stylo","market_name":"VS5502","codename":"VS5502","model":"VS5502"},{"manufacturer":"Stylus","market_name":"AT703","codename":"AT703","model":"AT703"},{"manufacturer":"Stylus","market_name":"Comet_SP5002G","codename":"Comet_SP5002G","model":"Comet_SP5002G"},{"manufacturer":"Stylus","market_name":"FUNDA","codename":"ETAB_I1041G","model":"ETAB I1041G"},{"manufacturer":"Stylus","market_name":"FUNDA","codename":"ETAB_I7041G","model":"ETAB_I7041G"},{"manufacturer":"Stylus","market_name":"IFS100","codename":"IFS100","model":"IFS100"},{"manufacturer":"Stylus","market_name":"Rida SP5003G LTE","codename":"Rida_SP5003G_LTE","model":"Rida_SP5003G_LTE"},{"manufacturer":"Stylus","market_name":"Sumo SP5201G LTE","codename":"Sumo_SP5201G_LTE","model":"Sumo_SP5201G_LTE"},{"manufacturer":"Stylus","market_name":"Sumo_XL_SP5501G_LTE","codename":"Sumo_XL_SP5501G_LTE","model":"Sumo_XL_SP5501G_LTE"},{"manufacturer":"Stylus","market_name":"Symbol SP4002G","codename":"Symbol_SP4002G","model":"Symbol_SP4002G"},{"manufacturer":"Stylus","market_name":"Wintech","codename":"WIN4","model":"WIN4"},{"manufacturer":"Sugar","market_name":"SUGAR C11","codename":"v12bns","model":"SUGAR C11"},{"manufacturer":"Sugar","market_name":"SUGAR S11","codename":"i9071ae","model":"SUGAR S11"},{"manufacturer":"Sugar","market_name":"SUGAR Y12","codename":"p101bs","model":"SUGAR Y12"},{"manufacturer":"Sugar","market_name":"Sugar","codename":"s9121","model":"SUGAR"},{"manufacturer":"Sumitomo Electric Industries","market_name":"ST4173","codename":"ST4173","model":"ST4173"},{"manufacturer":"Sumitomo Electric Networks","market_name":"","codename":"dhe1100","model":"Hikari-iFrame/WDPF-703SE"},{"manufacturer":"Supraim","market_name":"AQ21","codename":"AQ21","model":"AQ21"},{"manufacturer":"Supraim","market_name":"AYCON","codename":"AYCON","model":"AYCON"},{"manufacturer":"Supraim","market_name":"SN10","codename":"SN10","model":"SN10"},{"manufacturer":"Surtab","market_name":"SURTAB","codename":"SURTAB_74G","model":"SURTAB_74G"},{"manufacturer":"Sweam","market_name":"Sweam","codename":"sweam","model":"sweam"},{"manufacturer":"Swipe","market_name":"Elite 4G","codename":"Elite_4G","model":"Elite 4G"},{"manufacturer":"Swipe","market_name":"Elite Dual","codename":"EliteDual","model":"EliteDual"},{"manufacturer":"Swipe","market_name":"Elite VR","codename":"Elite_VR","model":"Elite_VR"},{"manufacturer":"Swipe","market_name":"Razor","codename":"Swipe_Razor","model":"Razor"},{"manufacturer":"Swipe","market_name":"Strike","codename":"Swipe_Strike","model":"Strike"},{"manufacturer":"Swisstone","market_name":"swisstone SD 510","codename":"SD5103G","model":"swisstone SD 510"},{"manufacturer":"Swisstone","market_name":"swisstone SD 530","codename":"SD5304G","model":"swisstone SD 530"},{"manufacturer":"Symphony","market_name":"H300","codename":"H300","model":"H300"},{"manufacturer":"Symphony","market_name":"H400","codename":"H400","model":"H400"},{"manufacturer":"Symphony","market_name":"H58","codename":"H58","model":"H58"},{"manufacturer":"Symphony","market_name":"INOVA","codename":"INOVA","model":"INOVA"},{"manufacturer":"Symphony","market_name":"P11","codename":"P11","model":"P11"},{"manufacturer":"Symphony","market_name":"P6 PRO","codename":"P6_PRO","model":"P6 PRO"},{"manufacturer":"Symphony","market_name":"P7","codename":"Symphony_P7","model":"P7"},{"manufacturer":"Symphony","market_name":"P7 Pro","codename":"P7_PRO","model":"Symphony P7 PRO"},{"manufacturer":"Symphony","market_name":"P8 PRO","codename":"P8_PRO","model":"P8 PRO"},{"manufacturer":"Symphony","market_name":"P9","codename":"P9","model":"P9"},{"manufacturer":"Symphony","market_name":"P9+","codename":"P9_Plus","model":"P9 Plus"},{"manufacturer":"Symphony","market_name":"R100","codename":"R100","model":"Symphony R100"},{"manufacturer":"Symphony","market_name":"R20","codename":"R20","model":"R20"},{"manufacturer":"Symphony","market_name":"R30","codename":"R30","model":"R30"},{"manufacturer":"Symphony","market_name":"Roar A50","codename":"Roar_A50_sprout","model":"Roar_A50"},{"manufacturer":"Symphony","market_name":"Roar_V78","codename":"Roar_V78","model":"Roar_V78"},{"manufacturer":"Symphony","market_name":"SYMTAB25","codename":"SYMTAB25","model":"SYMTAB25"},{"manufacturer":"Symphony","market_name":"SYMTAB60","codename":"SYMTAB60","model":"SYMTAB60"},{"manufacturer":"Symphony","market_name":"Symphony_Z9","codename":"Z9","model":"Symphony Z9"},{"manufacturer":"Symphony","market_name":"V100","codename":"V100","model":"V100"},{"manufacturer":"Symphony","market_name":"V110","codename":"V110","model":"V110"},{"manufacturer":"Symphony","market_name":"V120","codename":"V120","model":"V120"},{"manufacturer":"Symphony","market_name":"V130","codename":"V130","model":"V130"},{"manufacturer":"Symphony","market_name":"V34","codename":"V34","model":"V34"},{"manufacturer":"Symphony","market_name":"V47","codename":"V47","model":"V47"},{"manufacturer":"Symphony","market_name":"V65","codename":"V65","model":"V65"},{"manufacturer":"Symphony","market_name":"V75","codename":"V75","model":"V75"},{"manufacturer":"Symphony","market_name":"V75m","codename":"V75m","model":"V75m"},{"manufacturer":"Symphony","market_name":"V85","codename":"V85","model":"V85"},{"manufacturer":"Symphony","market_name":"Z10","codename":"Z10","model":"SYMPHONY Z10"},{"manufacturer":"Symphony","market_name":"ZVII","codename":"ZVII","model":"ZVII"},{"manufacturer":"Symphony","market_name":"ZVIII","codename":"ZVIII","model":"ZVIII"},{"manufacturer":"Symphony","market_name":"i10","codename":"i10","model":"i10"},{"manufacturer":"Symphony","market_name":"i10 plus","codename":"i10_plus","model":"i10 plus"},{"manufacturer":"Symphony","market_name":"i100","codename":"i100","model":"i100"},{"manufacturer":"Symphony","market_name":"i20","codename":"i20","model":"i20"},{"manufacturer":"Symphony","market_name":"i25","codename":"Symphonyi25","model":"i25"},{"manufacturer":"Symphony","market_name":"i50","codename":"i50","model":"i50"},{"manufacturer":"Symphony","market_name":"i60","codename":"i60","model":"i60"},{"manufacturer":"Symphony","market_name":"i90","codename":"i90","model":"i90"},{"manufacturer":"Symphony","market_name":"roarV95","codename":"roarV95","model":"roarV95"},{"manufacturer":"Symphony","market_name":"roar_V150","codename":"roar_V150","model":"roar_V150"},{"manufacturer":"T-Mobile","market_name":"Telekom_Puls","codename":"T-Tab","model":"Telekom Puls"},{"manufacturer":"TAG Heuer","market_name":"Connected","codename":"glacier","model":"TAG Heuer"},{"manufacturer":"TAG Heuer","market_name":"Connected Modular 41","codename":"spectralite","model":"TAG Heuer"},{"manufacturer":"TAG Heuer","market_name":"Connected Modular 45","codename":"anthracite","model":"TAG Heuer"},{"manufacturer":"TAG Heuer","market_name":"Connected Modular 45 (China)","codename":"anthracite","model":"TAG Heuer"},{"manufacturer":"TCL","market_name":"L55E6700UDS","codename":"movo_la","model":"movo_la"},{"manufacturer":"TCL","market_name":"LE50UHDE5692G","codename":"movo","model":"movo"},{"manufacturer":"TCL","market_name":"Percee TV","codename":"tcl_sa","model":"Percee TV"},{"manufacturer":"TCL","market_name":"South America","codename":"tcl","model":"Percee TV"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"A556C","model":"A556C"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"A919_gsm","model":"TCL A919"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"ASB-D_T918","model":"ASB-D T918"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"B-GriffinPlus_TD","model":"ASB-D T918"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"BASE_Varia_gsm","model":"BASE_Varia"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"E928_TD","model":"TCL E928"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"Griffin_TD","model":"TCL E928"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"MOVE_gsm","model":"MOVE"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"MTC-962_gsm","model":"MTC-962"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"Martini","model":"one touch 906"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"MegaFon_SP-A10","model":"MegaFon_SP-A10"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"ONE_TOUCH_928D_gsm","model":"ALCATEL ONE TOUCH 928D"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"ONE_TOUCH_983A_gsm","model":"ALCATEL_one_touch_983A"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"ONE_TOUCH_983M_gsm","model":"ONE TOUCH 983M"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OP070","model":"OP070"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT-906","model":"ALCATEL_one_touch_906"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT-906","model":"ALCATEL_one_touch_906Y"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT-913D","model":"ALCATEL_one_touch_913D"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT-976","model":"ALCATEL_one_touch_976"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT-978","model":"ALCATEL_one_touch_978"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT-979","model":"ALCATEL_one_touch_979"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT-979","model":"ALCATEL_one_touch_979_HelloKitty"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT-980A_gsm","model":"Alcatel OT-980A"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT-980_gsm","model":"Alcatel OT-980"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT-980_gsm","model":"Alcatel OT-980A"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT-980_gsm","model":"Alcatel OT-981A"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT-981A_gsm","model":"Alcatel OT-981A"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT-981_gsm","model":"Alcatel OT-981A"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT_918_gsm","model":"ALCATEL OT 918"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT_919_HelloKitty_gsm","model":"ALCATEL OT 919 HelloKitty"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT_919_gsm","model":"ALCATEL OT 919"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"OT_990M_gsm","model":"ALCATEL_OT_990M"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"RASPG3201_umts","model":"RASPG3201"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"RPSPG3201_umts","model":"RPSPG3201"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"SmartIII4","model":"Vodafone 975N"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"T20","model":"one touch T20"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"T60","model":"onetouch T60"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL-A909_A909_gsm","model":"TCL A909"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL-S806","model":"TCL-S806"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_890D_gsm","model":"TCL A890 2SIM"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_A510","model":"TCL A510"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_A510","model":"TCL_A510"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_A919_umts","model":"TCL A919"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_A919_umts","model":"TCL_W969"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_A966_gsm","model":"TCL A966"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_A968","model":"TCL A968"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_A980_gsm","model":"TCL A980"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_A986_gsm","model":"TCL A986"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_A988_gsm","model":"TCL_A988"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_A998_gsm","model":"TCL A998"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_C990_Plus_cdma","model":"TCL C990+"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_D515_cdma","model":"TCL D515"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_D662_cdma","model":"TCL D662"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_S800_GSM","model":"TCL S800"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_W939_gsm","model":"TCL_W939"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"TCL_W969_gsm","model":"TCL W969"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"Vancouver_gsm","model":"Vancouver_Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"mercury","model":"I-L1"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"move_2_gsm","model":"move 2"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"msm7627_ffa","model":"Alcatel OT-980"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"msm7627_ffa","model":"Alcatel OT-980A"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_890D_gsm","model":"ALCATEL one touch 890D"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_890_gsm","model":"ALCATEL_one_touch_890"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_890_gsm","model":"Vip_MiniDroid"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_891_gsm","model":"ALCATEL_one_touch_891"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_908A_gsm","model":"ALCATEL_one_touch_908A"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_908F_gsm","model":"ALCATEL_one_touch_908F"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_908F_gsm","model":"ALCATEL_one_touch_908F_Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_908F_gsm","model":"Alcatel_one_touch_908F"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_908F_gsm","model":"Alcatel_one_touch_908F_Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_908M_gsm","model":"ALCATEL_one_touch_908M"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_908S_gsm","model":"ALCATEL_one_touch_908S"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_908_gsm","model":"ALCATEL ONE TOUCH 908"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_909A_gsm","model":"ALCATEL_one_touch_909A"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_909B_cdma","model":"ALCATEL_one_touch_909B"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_909B_cdma","model":"USCC_ALCATEL_one_touch_909B"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_909S_gsm","model":"ALCATEL_one_touch_909S"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_910A_gsm","model":"ALCATEL_one_touch_910A"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_910_gsm","model":"ALCATEL_one_touch_910"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_916A_gsm","model":"ALCATEL ONE TOUCH 916A"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_916D_gsm","model":"ALCATEL ONE TOUCH 916D"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_916_gsm","model":"ALCATEL ONE TOUCH 916"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_918M_gsm","model":"ALCATEL_ONE_TOUCH_918M"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_918M_umts","model":"ALCATEL_one_touch_918M"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_918N_umts","model":"ALCATEL_one_touch_918N"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_918_gsm","model":"ALCATEL ONE TOUCH 918"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_985_gsm","model":"ALCATEL ONE TOUCH 985"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_985_gsm","model":"Telenor Smart"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_988_cdma","model":"ALCATEL_one_touch_988"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_988_cdma","model":"USCC_ALCATEL_one_touch_988"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_990A_gsm","model":"ALCATEL ONE TOUCH 990A"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_990A_gsm","model":"ALCATEL_one_touch_990A"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_990C_cdma","model":"ALCATEL one touch 990C"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_990_gsm","model":"ALCATEL ONE TOUCH 990"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_990_gsm","model":"Alcatel one touch 990 Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_990_gsm","model":"Telenor_OneTouch"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_991S_gsm","model":"ALCATEL ONE TOUCH 991S"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_993D_gsm","model":"ALCATEL ONE TOUCH 993D"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_995A_gsm","model":"ALCATEL_one_touch_995A"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_995C_cdma","model":"one touch 995C+"},{"manufacturer":"TCT (Alcatel)","market_name":"","codename":"one_touch_996_gsm","model":"Orange_infinity_996"},{"manufacturer":"TCT (Alcatel)","market_name":"\\t ALCATEL ONETOUCH PIXI 3 (3.5)","codename":"PIXI3_35","model":"SoshPhone_mini"},{"manufacturer":"TCT (Alcatel)","market_name":"\\t ALCATEL ONETOUCH PIXI 3 (4.5)","codename":"PIXI3_45_4G","model":"5017X"},{"manufacturer":"TCT (Alcatel)","market_name":"4013M","codename":"Pixi3-4","model":"4013M"},{"manufacturer":"TCT (Alcatel)","market_name":"4014A","codename":"Pixi3-4","model":"4014A"},{"manufacturer":"TCT (Alcatel)","market_name":"4014M","codename":"Pixi3-4","model":"4014M"},{"manufacturer":"TCT (Alcatel)","market_name":"4024X","codename":"PLAY_P1","model":"4024X"},{"manufacturer":"TCT (Alcatel)","market_name":"4047D","codename":"U5_3G","model":"4047D"},{"manufacturer":"TCT (Alcatel)","market_name":"4047G","codename":"U5_3G","model":"4047G"},{"manufacturer":"TCT (Alcatel)","market_name":"4047N","codename":"U5_3G","model":"4047N"},{"manufacturer":"TCT (Alcatel)","market_name":"4047X","codename":"U5_3G","model":"4047X"},{"manufacturer":"TCT (Alcatel)","market_name":"4055A","codename":"U3","model":"4055A"},{"manufacturer":"TCT (Alcatel)","market_name":"4055I","codename":"U3","model":"4055I"},{"manufacturer":"TCT (Alcatel)","market_name":"4055J","codename":"U3","model":"4055J"},{"manufacturer":"TCT (Alcatel)","market_name":"4055Q","codename":"U3","model":"4055Q"},{"manufacturer":"TCT (Alcatel)","market_name":"4055T","codename":"U3","model":"4055T"},{"manufacturer":"TCT (Alcatel)","market_name":"4055U","codename":"U3","model":"4055U"},{"manufacturer":"TCT (Alcatel)","market_name":"4060W","codename":"Pixi445","model":"4060W"},{"manufacturer":"TCT (Alcatel)","market_name":"4114E","codename":"Pixi3-4","model":"4114E"},{"manufacturer":"TCT (Alcatel)","market_name":"5011A","codename":"BUZZ6_55","model":"5011A"},{"manufacturer":"TCT (Alcatel)","market_name":"5017B","codename":"Pixi3454GSPR","model":"5017B"},{"manufacturer":"TCT (Alcatel)","market_name":"5023E","codename":"Pixi4PlusPower","model":"5023E"},{"manufacturer":"TCT (Alcatel)","market_name":"5023F","codename":"Pixi4PlusPower","model":"5023F"},{"manufacturer":"TCT (Alcatel)","market_name":"5027B","codename":"Pixi445SPR","model":"5027B"},{"manufacturer":"TCT (Alcatel)","market_name":"5038D","codename":"SOUL45_GSM","model":"5038D"},{"manufacturer":"TCT (Alcatel)","market_name":"5042T","codename":"ALTO45TMO","model":"5042T"},{"manufacturer":"TCT (Alcatel)","market_name":"5046S","codename":"Mickey6VZW","model":"5046S"},{"manufacturer":"TCT (Alcatel)","market_name":"5049S","codename":"Mickey6TVZW","model":"5049S"},{"manufacturer":"TCT (Alcatel)","market_name":"5049W","codename":"Mickey6TTMO","model":"5049W"},{"manufacturer":"TCT (Alcatel)","market_name":"5049Z","codename":"Mickey6TTMO","model":"5049Z"},{"manufacturer":"TCT (Alcatel)","market_name":"5051","codename":"POP45","model":"5051"},{"manufacturer":"TCT (Alcatel)","market_name":"5051A","codename":"POP45","model":"5051A"},{"manufacturer":"TCT (Alcatel)","market_name":"5051D","codename":"POP45","model":"5051D"},{"manufacturer":"TCT (Alcatel)","market_name":"5051J","codename":"POP45","model":"5051J"},{"manufacturer":"TCT (Alcatel)","market_name":"5051M","codename":"POP45","model":"5051M"},{"manufacturer":"TCT (Alcatel)","market_name":"5051T","codename":"POP45","model":"5051T"},{"manufacturer":"TCT (Alcatel)","market_name":"5051X","codename":"POP45","model":"5051X"},{"manufacturer":"TCT (Alcatel)","market_name":"5054A","codename":"Pop355","model":"5054A"},{"manufacturer":"TCT (Alcatel)","market_name":"5054D","codename":"Pop355","model":"5054D"},{"manufacturer":"TCT (Alcatel)","market_name":"5054S","codename":"Pop355","model":"5054S"},{"manufacturer":"TCT (Alcatel)","market_name":"5054T","codename":"Pop355","model":"5054T"},{"manufacturer":"TCT (Alcatel)","market_name":"5054W","codename":"Pop355","model":"5054W"},{"manufacturer":"TCT (Alcatel)","market_name":"5054X","codename":"Pop355","model":"5054X"},{"manufacturer":"TCT (Alcatel)","market_name":"5056","codename":"POP455C","model":"5056"},{"manufacturer":"TCT (Alcatel)","market_name":"5056A","codename":"POP455C","model":"5056A"},{"manufacturer":"TCT (Alcatel)","market_name":"5056D","codename":"POP455C","model":"5056D"},{"manufacturer":"TCT (Alcatel)","market_name":"5056E","codename":"POP455C","model":"5056E"},{"manufacturer":"TCT (Alcatel)","market_name":"5056E","codename":"POP455C","model":"5056M"},{"manufacturer":"TCT (Alcatel)","market_name":"5056G","codename":"POP455C","model":"5056G"},{"manufacturer":"TCT (Alcatel)","market_name":"5056I","codename":"POP455C","model":"5056I"},{"manufacturer":"TCT (Alcatel)","market_name":"5056N","codename":"POP455C","model":"5056N"},{"manufacturer":"TCT (Alcatel)","market_name":"5056T","codename":"POP455C","model":"5056T"},{"manufacturer":"TCT (Alcatel)","market_name":"5056U","codename":"POP455C","model":"5056U"},{"manufacturer":"TCT (Alcatel)","market_name":"5056W","codename":"POP455C","model":"5056W"},{"manufacturer":"TCT (Alcatel)","market_name":"5056X","codename":"POP455C","model":"5056X"},{"manufacturer":"TCT (Alcatel)","market_name":"5065A","codename":"Pop35","model":"5065A"},{"manufacturer":"TCT (Alcatel)","market_name":"5065D","codename":"Pop35","model":"5065D"},{"manufacturer":"TCT (Alcatel)","market_name":"5065N","codename":"Pop35","model":"5065N"},{"manufacturer":"TCT (Alcatel)","market_name":"5065W","codename":"Pop35","model":"5065W"},{"manufacturer":"TCT (Alcatel)","market_name":"5065X","codename":"Pop35","model":"5065X"},{"manufacturer":"TCT (Alcatel)","market_name":"5070D","codename":"P3-5_4G","model":"5070D"},{"manufacturer":"TCT (Alcatel)","market_name":"5080A","codename":"shine_lite","model":"5080A"},{"manufacturer":"TCT (Alcatel)","market_name":"5080F","codename":"shine_lite","model":"5080F"},{"manufacturer":"TCT (Alcatel)","market_name":"5080Q","codename":"shine_lite","model":"5080Q"},{"manufacturer":"TCT (Alcatel)","market_name":"5080U","codename":"shine_lite","model":"5080U"},{"manufacturer":"TCT (Alcatel)","market_name":"5080U","codename":"shine_lite","model":"ALCATEL_5080U"},{"manufacturer":"TCT (Alcatel)","market_name":"5085G","codename":"elsa6_amz","model":"5085G"},{"manufacturer":"TCT (Alcatel)","market_name":"5085O","codename":"elsa6_amz","model":"5085O"},{"manufacturer":"TCT (Alcatel)","market_name":"5098O","codename":"Pixi4-64GMEX","model":"5098O"},{"manufacturer":"TCT (Alcatel)","market_name":"5098O","codename":"Pixi4-6_4G_CKT","model":"Alcatel_5098O"},{"manufacturer":"TCT (Alcatel)","market_name":"5098O","codename":"Pixi4-6_4G_CKT","model":"alcatel_5098O"},{"manufacturer":"TCT (Alcatel)","market_name":"5098S","codename":"Pixi4-6_4G","model":"5098S"},{"manufacturer":"TCT (Alcatel)","market_name":"5154A","codename":"Pop355","model":"5154A"},{"manufacturer":"TCT (Alcatel)","market_name":"6010A","codename":"Miata_3G","model":"6016A"},{"manufacturer":"TCT (Alcatel)","market_name":"6014X","codename":"Miata_3G","model":"6014X"},{"manufacturer":"TCT (Alcatel)","market_name":"6016D","codename":"Miata_3G","model":"6016D"},{"manufacturer":"TCT (Alcatel)","market_name":"6016E","codename":"Miata_3G","model":"6016E"},{"manufacturer":"TCT (Alcatel)","market_name":"6016X","codename":"Miata_3G","model":"6016X"},{"manufacturer":"TCT (Alcatel)","market_name":"6037B","codename":"Eclipse","model":"6037B"},{"manufacturer":"TCT (Alcatel)","market_name":"6037K","codename":"Eclipse","model":"6037K"},{"manufacturer":"TCT (Alcatel)","market_name":"6037Y","codename":"Eclipse","model":"6037Y"},{"manufacturer":"TCT (Alcatel)","market_name":"6039A","codename":"idol347","model":"6039A"},{"manufacturer":"TCT (Alcatel)","market_name":"6039H","codename":"idol347","model":"6039H"},{"manufacturer":"TCT (Alcatel)","market_name":"6039J","codename":"idol347","model":"6039J"},{"manufacturer":"TCT (Alcatel)","market_name":"6039K","codename":"idol347","model":"6039K"},{"manufacturer":"TCT (Alcatel)","market_name":"6039S","codename":"idol347","model":"6039S"},{"manufacturer":"TCT (Alcatel)","market_name":"6039Y","codename":"idol347","model":"6039Y"},{"manufacturer":"TCT (Alcatel)","market_name":"6042D","codename":"CROSSAPAC","model":"6042D"},{"manufacturer":"TCT (Alcatel)","market_name":"6043A","codename":"DIABLOXPLUS","model":"6043A"},{"manufacturer":"TCT (Alcatel)","market_name":"6043D","codename":"DIABLOXPLUS","model":"6043D"},{"manufacturer":"TCT (Alcatel)","market_name":"6044D","codename":"I1-5_4G","model":"6044D"},{"manufacturer":"TCT (Alcatel)","market_name":"6055A","codename":"idol4","model":"6055A"},{"manufacturer":"TCT (Alcatel)","market_name":"6055B","codename":"idol4","model":"6055B"},{"manufacturer":"TCT (Alcatel)","market_name":"6055D","codename":"idol4","model":"6055D"},{"manufacturer":"TCT (Alcatel)","market_name":"6055K","codename":"idol4","model":"6055K"},{"manufacturer":"TCT (Alcatel)","market_name":"6055P","codename":"idol4","model":"6055P"},{"manufacturer":"TCT (Alcatel)","market_name":"6060X","codename":"simba6_global","model":"6060X"},{"manufacturer":"TCT (Alcatel)","market_name":"6062W","codename":"A70AXLTMO","model":"6062W"},{"manufacturer":"TCT (Alcatel)","market_name":"7040N","codename":"Yaris5TMO","model":"7040N"},{"manufacturer":"TCT (Alcatel)","market_name":"7040R","codename":"Yaris5TMO","model":"7040R"},{"manufacturer":"TCT (Alcatel)","market_name":"7040T","codename":"Yaris5TMO","model":"7040T"},{"manufacturer":"TCT (Alcatel)","market_name":"7045Y","codename":"RIO5","model":"7045Y"},{"manufacturer":"TCT (Alcatel)","market_name":"730U","codename":"Rio5C","model":"J730U"},{"manufacturer":"TCT (Alcatel)","market_name":"8030B","codename":"HERO2","model":"8030B"},{"manufacturer":"TCT (Alcatel)","market_name":"8030B","codename":"HERO2PLUS","model":"8030B"},{"manufacturer":"TCT (Alcatel)","market_name":"8030Y","codename":"HERO2","model":"8030Y"},{"manufacturer":"TCT (Alcatel)","market_name":"8050D","codename":"Pixi4-6_3G","model":"8050D"},{"manufacturer":"TCT (Alcatel)","market_name":"8050E","codename":"Pixi4-6_3G","model":"8050E"},{"manufacturer":"TCT (Alcatel)","market_name":"8050E","codename":"Pixi4-6_3G","model":"T600M"},{"manufacturer":"TCT (Alcatel)","market_name":"8050G","codename":"Pixi4-6_3G","model":"8050G"},{"manufacturer":"TCT (Alcatel)","market_name":"8050X","codename":"Pixi4-6_3G","model":"8050X"},{"manufacturer":"TCT (Alcatel)","market_name":"8053","codename":"Pixi3-7","model":"8053"},{"manufacturer":"TCT (Alcatel)","market_name":"8054","codename":"Pixi3-7","model":"8054"},{"manufacturer":"TCT (Alcatel)","market_name":"8055","codename":"Pixi3-7","model":"8055"},{"manufacturer":"TCT (Alcatel)","market_name":"8056","codename":"Pixi3-7","model":"8056"},{"manufacturer":"TCT (Alcatel)","market_name":"8057","codename":"Pixi3-7","model":"8057"},{"manufacturer":"TCT (Alcatel)","market_name":"8057","codename":"Pixi3-7","model":"KR076"},{"manufacturer":"TCT (Alcatel)","market_name":"8062","codename":"Pixi4-7_WIFI","model":"8062"},{"manufacturer":"TCT (Alcatel)","market_name":"8063","codename":"Pixi4-7_WIFI","model":"8063"},{"manufacturer":"TCT (Alcatel)","market_name":"8070","codename":"Pixi3-8_WIFI","model":"8070"},{"manufacturer":"TCT (Alcatel)","market_name":"8079","codename":"Pixi3-10_WiFi","model":"8079"},{"manufacturer":"TCT (Alcatel)","market_name":"8080","codename":"Pixi3-10_WiFi","model":"8080"},{"manufacturer":"TCT (Alcatel)","market_name":"8262","codename":"Pixi4-7_WIFI","model":"8262"},{"manufacturer":"TCT (Alcatel)","market_name":"9001D","codename":"Pixi4-6_4G","model":"9001D"},{"manufacturer":"TCT (Alcatel)","market_name":"9001I","codename":"Pixi4-6_4G","model":"9001I"},{"manufacturer":"TCT (Alcatel)","market_name":"9001X","codename":"Pixi4-6_4G","model":"9001X"},{"manufacturer":"TCT (Alcatel)","market_name":"9002A","codename":"Pixi3-7_3G","model":"9002A"},{"manufacturer":"TCT (Alcatel)","market_name":"9002A","codename":"Pixi3-7_3G","model":"ALCATEL ONE TOUCH 9002A"},{"manufacturer":"TCT (Alcatel)","market_name":"9002W","codename":"Pixi3-7_3G","model":"9002W"},{"manufacturer":"TCT (Alcatel)","market_name":"9002X","codename":"Pixi3-7_3G","model":"9002X"},{"manufacturer":"TCT (Alcatel)","market_name":"9003A","codename":"Pixi4-7_3G","model":"9003A"},{"manufacturer":"TCT (Alcatel)","market_name":"9003X","codename":"Pixi4-7_3G","model":"9003X"},{"manufacturer":"TCT (Alcatel)","market_name":"9005X","codename":"PIXO8_3G","model":"9005X"},{"manufacturer":"TCT (Alcatel)","market_name":"9006W","codename":"Pixi2-7_4G_TMO","model":"9006W"},{"manufacturer":"TCT (Alcatel)","market_name":"9007X","codename":"Pixi3-7_4G_EE","model":"9007X"},{"manufacturer":"TCT (Alcatel)","market_name":"9010X","codename":"Pixi3-10_3G","model":"9010X"},{"manufacturer":"TCT (Alcatel)","market_name":"9015B","codename":"Pixi4-7_4G_Bell","model":"9015B"},{"manufacturer":"TCT (Alcatel)","market_name":"9015B","codename":"Pixi4-7_4G_Bell","model":"ALCATEL ONETOUCH POP 7 LTE"},{"manufacturer":"TCT (Alcatel)","market_name":"9015B","codename":"Pixi4-7_4G_NA","model":"9015B"},{"manufacturer":"TCT (Alcatel)","market_name":"9015B","codename":"Pixi4-7_4G_Rogers","model":"9015B"},{"manufacturer":"TCT (Alcatel)","market_name":"9015B","codename":"Pixi4-7_4G_Telus","model":"9015B"},{"manufacturer":"TCT (Alcatel)","market_name":"9015J","codename":"PIXI4-7_4G","model":"9015J"},{"manufacturer":"TCT (Alcatel)","market_name":"9015Q","codename":"PIXI4-7_4G","model":"9015Q"},{"manufacturer":"TCT (Alcatel)","market_name":"9015U","codename":"PIXI4-7_4G","model":"9015U"},{"manufacturer":"TCT (Alcatel)","market_name":"9015W","codename":"Pixi4-7_4G_TMO","model":"9015W"},{"manufacturer":"TCT (Alcatel)","market_name":"9015W","codename":"Pixi4-7_4G_TMO","model":"ALCATEL ONETOUCH POP 7 LTE"},{"manufacturer":"TCT (Alcatel)","market_name":"9021A","codename":"Pop2-8_4G_Telus","model":"9021A"},{"manufacturer":"TCT (Alcatel)","market_name":"9024O","codename":"PIXI5-8_4G_Telus","model":"9024O"},{"manufacturer":"TCT (Alcatel)","market_name":"9024W","codename":"PIXI5-8_4G_TMO","model":"9024W"},{"manufacturer":"TCT (Alcatel)","market_name":"9025Q","codename":"POP4-7_4G","model":"9025Q"},{"manufacturer":"TCT (Alcatel)","market_name":"9030G","codename":"POP4-10_4G","model":"9030G"},{"manufacturer":"TCT (Alcatel)","market_name":"9030Q","codename":"POP4-10_4G","model":"9030Q"},{"manufacturer":"TCT (Alcatel)","market_name":"9203A","codename":"Pixi5-7_3G","model":"9203A"},{"manufacturer":"TCT (Alcatel)","market_name":"A1 Smart N9","codename":"VFD720","model":"VFD 720"},{"manufacturer":"TCT (Alcatel)","market_name":"A3","codename":"mickey6","model":"5046A"},{"manufacturer":"TCT (Alcatel)","market_name":"A3","codename":"mickey6","model":"5046D"},{"manufacturer":"TCT (Alcatel)","market_name":"A3","codename":"mickey6","model":"5046I"},{"manufacturer":"TCT (Alcatel)","market_name":"A3","codename":"mickey6","model":"5046J"},{"manufacturer":"TCT (Alcatel)","market_name":"A3","codename":"mickey6","model":"5046T"},{"manufacturer":"TCT (Alcatel)","market_name":"A3","codename":"mickey6","model":"5046U"},{"manufacturer":"TCT (Alcatel)","market_name":"A3","codename":"mickey6","model":"5046Y"},{"manufacturer":"TCT (Alcatel)","market_name":"A3 10\\'\\'","codename":"Pixi5-10_4G","model":"9026T"},{"manufacturer":"TCT (Alcatel)","market_name":"A3 10\\'\\'","codename":"Pixi5-10_4G","model":"9026X"},{"manufacturer":"TCT (Alcatel)","market_name":"A3 PLUS","codename":"mickey6t","model":"5049E"},{"manufacturer":"TCT (Alcatel)","market_name":"A3 PLUS","codename":"mickey6t","model":"5049G"},{"manufacturer":"TCT (Alcatel)","market_name":"A3 XL","codename":"PIXI5-6_4G","model":"9008A"},{"manufacturer":"TCT (Alcatel)","market_name":"A3 XL","codename":"PIXI5-6_4G","model":"9008D"},{"manufacturer":"TCT (Alcatel)","market_name":"A3 XL","codename":"PIXI5-6_4G","model":"9008I"},{"manufacturer":"TCT (Alcatel)","market_name":"A3 XL","codename":"PIXI5-6_4G","model":"9008J"},{"manufacturer":"TCT (Alcatel)","market_name":"A3 XL","codename":"PIXI5-6_4G","model":"9008N"},{"manufacturer":"TCT (Alcatel)","market_name":"A3 XL","codename":"PIXI5-6_4G","model":"9008T"},{"manufacturer":"TCT (Alcatel)","market_name":"A3 XL","codename":"PIXI5-6_4G","model":"9008U"},{"manufacturer":"TCT (Alcatel)","market_name":"A3 XL","codename":"PIXI5-6_4G","model":"9008X"},{"manufacturer":"TCT (Alcatel)","market_name":"A3 XL","codename":"PIXI5-6_4G","model":"9108A"},{"manufacturer":"TCT (Alcatel)","market_name":"A3 XL","codename":"PIXI5-6_4G","model":"TCLGalaG60(9108A)"},{"manufacturer":"TCT (Alcatel)","market_name":"A30","codename":"MICKEY6US","model":"5046G"},{"manufacturer":"TCT (Alcatel)","market_name":"A30","codename":"Mickey6RW","model":"A576RW"},{"manufacturer":"TCT (Alcatel)","market_name":"A450TL","codename":"ALTO45_TF","model":"A450TL"},{"manufacturer":"TCT (Alcatel)","market_name":"A460T","codename":"PIXI3_4TF","model":"A460T"},{"manufacturer":"TCT (Alcatel)","market_name":"A464BG","codename":"Pixi3-35TF","model":"A464BG"},{"manufacturer":"TCT (Alcatel)","market_name":"A466BG","codename":"PIXI4_4TF","model":"A466BG"},{"manufacturer":"TCT (Alcatel)","market_name":"A5","codename":"ELSA6","model":"5085A"},{"manufacturer":"TCT (Alcatel)","market_name":"A5","codename":"ELSA6","model":"5085B"},{"manufacturer":"TCT (Alcatel)","market_name":"A5","codename":"ELSA6","model":"5085D"},{"manufacturer":"TCT (Alcatel)","market_name":"A5","codename":"ELSA6","model":"5085H"},{"manufacturer":"TCT (Alcatel)","market_name":"A5","codename":"ELSA6","model":"5085I"},{"manufacturer":"TCT (Alcatel)","market_name":"A5","codename":"ELSA6","model":"5085J"},{"manufacturer":"TCT (Alcatel)","market_name":"A5","codename":"ELSA6","model":"5085N"},{"manufacturer":"TCT (Alcatel)","market_name":"A5","codename":"ELSA6","model":"5085Q"},{"manufacturer":"TCT (Alcatel)","market_name":"A5","codename":"ELSA6","model":"5085Y"},{"manufacturer":"TCT (Alcatel)","market_name":"A520L","codename":"Alto4EVDO","model":"A520L"},{"manufacturer":"TCT (Alcatel)","market_name":"A521L","codename":"Alto4NA","model":"A521L"},{"manufacturer":"TCT (Alcatel)","market_name":"A570BL","codename":"Pop445","model":"A570BL"},{"manufacturer":"TCT (Alcatel)","market_name":"A571VL","codename":"Pixi445TFVZW","model":"A571VL"},{"manufacturer":"TCT (Alcatel)","market_name":"A572BG","codename":"Pop445","model":"A572BG"},{"manufacturer":"TCT (Alcatel)","market_name":"A573VC","codename":"Pixi445EVDO","model":"A573VC"},{"manufacturer":"TCT (Alcatel)","market_name":"A577VL","codename":"Mickey6TFEVDO","model":"A577VL"},{"manufacturer":"TCT (Alcatel)","market_name":"A621BL","codename":"Pop355","model":"A621BL"},{"manufacturer":"TCT (Alcatel)","market_name":"A621R","codename":"Pop355","model":"A621R"},{"manufacturer":"TCT (Alcatel)","market_name":"A622GL","codename":"Pixi3554GEVDO","model":"A622GL"},{"manufacturer":"TCT (Alcatel)","market_name":"A622VL","codename":"Pixi3554GEVDO","model":"A622VL"},{"manufacturer":"TCT (Alcatel)","market_name":"A7","codename":"ELSA6P","model":"5090A"},{"manufacturer":"TCT (Alcatel)","market_name":"A7","codename":"ELSA6P","model":"5090I"},{"manufacturer":"TCT (Alcatel)","market_name":"A7","codename":"ELSA6P","model":"5090Y"},{"manufacturer":"TCT (Alcatel)","market_name":"A7 XL","codename":"POP5-6_4G","model":"7071A"},{"manufacturer":"TCT (Alcatel)","market_name":"A7 XL","codename":"POP5-6_4G","model":"7071D"},{"manufacturer":"TCT (Alcatel)","market_name":"A846L","codename":"Alto5TF","model":"A846L"},{"manufacturer":"TCT (Alcatel)","market_name":"A851L","codename":"Viper_gsm","model":"Alcatel 7030L"},{"manufacturer":"TCT (Alcatel)","market_name":"A851L","codename":"Viper_gsm","model":"Alcatel A851L"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL 1T 10","codename":"U3A_10_WIFI","model":"8082"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL 3C","codename":"A3A_XL_3G","model":"5026A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL 3C","codename":"A3A_XL_3G","model":"5026D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL 3C","codename":"A3A_XL_3G","model":"5026J"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL 3V","codename":"A3A_XL_4G","model":"5099Y"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL 4015T","codename":"Yaris35_GSM","model":"ALCATEL 4015T"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL A564C","codename":"Yaris5NA","model":"ALCATEL A564C"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL A564R","codename":"Yaris5NA","model":"ALCATEL A564R"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4005D","codename":"Beetle_Lite_Edge_GSM","model":"ALCATEL ONE TOUCH 4005D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4005D","codename":"Beetle_Lite_Edge_GSM","model":"ALCATEL_ONE_TOUCH_4005D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4010X","codename":"Beetle_Lite_GSM","model":"ALCATEL ONE TOUCH 4010A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4010X","codename":"Beetle_Lite_GSM","model":"ALCATEL ONE TOUCH 4010D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4010X","codename":"Beetle_Lite_GSM","model":"ALCATEL ONE TOUCH 4010E"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4010X","codename":"Beetle_Lite_GSM","model":"ALCATEL ONE TOUCH 4010X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4010X","codename":"Beetle_Lite_GSM","model":"TCL_J210"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4010X","codename":"Beetle_Lite_GSM","model":"Telenor Smart 2"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4030X","codename":"Beetle_GSM","model":"ALCATEL ONE TOUCH 4029A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4030X","codename":"Beetle_GSM","model":"ALCATEL ONE TOUCH 4030D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4030X","codename":"Beetle_GSM","model":"ALCATEL ONE TOUCH 4030E"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4030X","codename":"Beetle_GSM","model":"ALCATEL ONE TOUCH 4030X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4030X","codename":"Beetle_GSM","model":"ALCATEL ONE TOUCH 4030Y"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4030X","codename":"Beetle_GSM","model":"ALCATEL ONE TOUCH 4030Y_orange"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4030X","codename":"Beetle_GSM","model":"Infinity POP"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4030X","codename":"Beetle_GSM","model":"Orange Runo"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4037N","codename":"SOUL4NA","model":"ALCATEL ONE TOUCH 4037N"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 4037N","codename":"SOUL4NA","model":"ALCATEL ONE TOUCH 4037T"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5020D","codename":"Megane_GSM","model":"ALCATEL ONE TOUCH 5020A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5020D","codename":"Megane_GSM","model":"ALCATEL ONE TOUCH 5020D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5020D","codename":"Megane_GSM","model":"ALCATEL ONE TOUCH 5020E"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5020D","codename":"Megane_GSM","model":"ALCATEL ONE TOUCH 5020T"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5020D","codename":"Megane_GSM","model":"ALCATEL ONE TOUCH 5020W"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5020D","codename":"Megane_GSM","model":"ALCATEL ONE TOUCH 5020X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5020D","codename":"Megane_GSM","model":"ALCATEL ONE TOUCH 5021E"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5020D","codename":"Megane_GSM","model":"ALCATEL_ONE_TOUCH_5020D_Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5020D","codename":"Megane_GSM","model":"ALCATEL_ONE_TOUCH_5020X_Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5020D","codename":"Megane_GSM","model":"AURUS III"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5020D","codename":"Megane_GSM","model":"MTC 972"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5020D","codename":"Megane_GSM","model":"Orange Kivo"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5020D","codename":"Megane_GSM","model":"Telenor Smart Pro 2"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5020N","codename":"Megane","model":"ALCATEL ONE TOUCH 5020N"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5035D","codename":"Camry_GSM","model":"ALCATEL ONE TOUCH 5035A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5035D","codename":"Camry_GSM","model":"ALCATEL ONE TOUCH 5035D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5035D","codename":"Camry_GSM","model":"ALCATEL ONE TOUCH 5035E"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5035D","codename":"Camry_GSM","model":"ALCATEL ONE TOUCH 5035X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5035D","codename":"Camry_GSM","model":"TCL J610"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5035D","codename":"Camry_GSM","model":"TCL S810"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5036A","codename":"YarisL_GSM","model":"ALCATEL ONE TOUCH 5036A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5036D","codename":"YarisL_GSM","model":"ALCATEL ONE TOUCH 5036D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5036D","codename":"YarisL_GSM","model":"ONE TOUCH 5036X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5036F","codename":"YarisL_GSM","model":"ALCATEL ONE TOUCH 5036F"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5036X","codename":"YarisL_GSM","model":"ALCATEL ONE TOUCH 5036X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 5037E","codename":"YarisL_GSM","model":"ALCATEL ONE TOUCH 5037E"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 601","codename":"Telsa","model":"ALCATEL ONE TOUCH 6010"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6010A","codename":"Telsa","model":"ALCATEL ONE TOUCH 6010A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6010D","codename":"Telsa","model":"ALCATEL ONE TOUCH 6010D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6010X","codename":"Telsa","model":"ALCATEL ONE TOUCH 6010"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6010X","codename":"Telsa","model":"ALCATEL ONE TOUCH 6010D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6010X","codename":"Telsa","model":"ALCATEL ONE TOUCH 6010X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6010X","codename":"Telsa","model":"ALCATEL ONE TOUCH 6010X-orange"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6010X","codename":"Telsa","model":"TCL S520"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6030A","codename":"Diablo","model":"ALCATEL ONE TOUCH 6030A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6030D","codename":"Diablo","model":"ALCATEL ONE TOUCH 6030D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6030N","codename":"Diablo","model":"ALCATEL ONE TOUCH 6030N"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6030X","codename":"Diablo","model":"ALCATEL ONE TOUCH 6030A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6030X","codename":"Diablo","model":"ALCATEL ONE TOUCH 6030D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6030X","codename":"Diablo","model":"ALCATEL ONE TOUCH 6030X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6030X","codename":"Diablo","model":"ALCATEL ONE TOUCH 6030X-orange"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6030X","codename":"Diablo","model":"ALCATEL_ONE_TOUCH_6030X_Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6030X","codename":"Diablo","model":"Optimus_San_Remo"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6030X","codename":"Diablo","model":"TCL S820"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6030X-orange","codename":"Diablo","model":"ALCATEL ONE TOUCH 6030X-orange"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6032","codename":"Alpha","model":"ALCATEL ONE TOUCH 6032"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6032A","codename":"Alpha","model":"ALCATEL ONE TOUCH 6032A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6032X","codename":"Alpha","model":"ALCATEL ONE TOUCH 6032X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6033A","codename":"DiabloHD","model":"ALCATEL ONE TOUCH 6033A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6033M","codename":"DiabloHD","model":"ALCATEL ONE TOUCH 6033M"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6033X","codename":"DiabloHD","model":"ALCATEL ONE TOUCH 6033M"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6033X","codename":"DiabloHD","model":"ALCATEL ONE TOUCH 6033X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6033X","codename":"DiabloHD","model":"TCL S850"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6037B","codename":"Eclipse","model":"ALCATEL ONE TOUCH 6037B"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6040A","codename":"DIABLOX","model":"ALCATEL ONE TOUCH 6040A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6040D","codename":"DIABLOX","model":"ALCATEL ONE TOUCH 6040D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6040D","codename":"DIABLOX","model":"TCL S950"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6040E","codename":"DIABLOX","model":"ALCATEL ONE TOUCH 6040E"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 6040X","codename":"DIABLOX","model":"ALCATEL ONE TOUCH 6040X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7024W","codename":"Rav4","model":"ALCATEL ONE TOUCH 7024R"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7024W","codename":"Rav4","model":"ALCATEL ONE TOUCH 7024W"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7024W","codename":"Rav4","model":"ALCATEL ONE TOUCH FIERCE"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7025D","codename":"Rav4","model":"ALCATEL ONE TOUCH 7025D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7040A","codename":"YARISXL","model":"ALCATEL ONE TOUCH 7040A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7040D","codename":"YARISXL","model":"ALCATEL ONE TOUCH 7040D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7040E","codename":"YARISXL","model":"ALCATEL ONE TOUCH 7040E"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7040K","codename":"YARISXL","model":"ALCATEL ONE TOUCH 7040K"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7040X","codename":"YARISXL","model":"ALCATEL ONE TOUCH 7040X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7041D","codename":"YARISXL","model":"ALCATEL ONE TOUCH 7041D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7041X","codename":"YARISXL","model":"ALCATEL ONE TOUCH 7041X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7042A","codename":"YARISXL","model":"ALCATEL ONE TOUCH 7042A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7042D","codename":"YARISXL","model":"ALCATEL ONE TOUCH 7042D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7042E","codename":"YARISXL","model":"ALCATEL ONE TOUCH 7042E"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7047D","codename":"YARIS_55","model":"ALCATEL ONE TOUCH 7047D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7047E","codename":"YARIS_55","model":"ALCATEL ONE TOUCH 7047E"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 7047X","codename":"YARIS_55","model":"ALCATEL ONE TOUCH 7047X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 8008D","codename":"Scribe5HD","model":"ALCATEL ONE TOUCH 8008D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 8008D","codename":"Scribe5HD","model":"ALCATEL ONE TOUCH 8008X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 8008D","codename":"Scribe5HD","model":"Orange Infinity 8008X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 8020A","codename":"SCRIBEPRO","model":"ALCATEL ONE TOUCH 8020A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 8020D","codename":"SCRIBEPRO","model":"ALCATEL ONE TOUCH 8020D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 8020E","codename":"SCRIBEPRO","model":"ALCATEL ONE TOUCH 8020E"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 8020X","codename":"SCRIBEPRO","model":"ALCATEL ONE TOUCH 8020X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 903","codename":"one_touch_903A_gsm","model":"ALCATEL_ONE_TOUCH_903"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 903","codename":"one_touch_903A_gsm","model":"ALCATEL_one_touch_903"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 903","codename":"one_touch_903D_gsm","model":"ALCATEL ONE TOUCH 903D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 903","codename":"one_touch_903_gsm","model":"ALCATEL ONE TOUCH 903"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 903","codename":"one_touch_903_gsm","model":"ALCATEL_ONE_TOUCH_903"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 903A","codename":"one_touch_903A_gsm","model":"ALCATEL ONE TOUCH 903A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 903D","codename":"one_touch_903D_gsm","model":"ALCATEL ONE TOUCH 903D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 918","codename":"one_touch_918_gsm","model":"ALCATEL ONE TOUCH 918"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 918","codename":"one_touch_918_gsm","model":"ALCATEL one touch 918"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 918","codename":"one_touch_918_gsm","model":"ALCATEL_one_touch_918"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 918","codename":"one_touch_918_gsm","model":"Alcatel_one_touch_918_Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 918A","codename":"one_touch_918A_gsm","model":"ALCATEL ONE TOUCH 918A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 918A","codename":"one_touch_918A_gsm","model":"ALCATEL_one_touch_918A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 918D","codename":"ONE_TOUCH_918D_umts","model":"ALCATEL ONE TOUCH 918D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 918D","codename":"one_touch_918D_gsm","model":"ALCATEL ONE TOUCH 918D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 918N","codename":"ONE_TOUCH_918N_umts","model":"ALCATEL ONE TOUCH 918N"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 918N","codename":"one_touch_918N_gsm","model":"ALCATEL ONE TOUCH 918N"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 918S","codename":"one_touch_918S_gsm","model":"ALCATEL ONE TOUCH 918S"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 922","codename":"one_touch_922_gsm","model":"ALCATEL ONE TOUCH 922"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 930D","codename":"OT-930","model":"ALCATEL ONE TOUCH 930D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 930D","codename":"OT-930","model":"ALCATEL ONE TOUCH 930N"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 985","codename":"one_touch_985_gsm","model":"ALCATEL ONE TOUCH 985"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 985","codename":"one_touch_985_gsm","model":"ALCATEL_ONE_TOUCH_985"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 985","codename":"one_touch_985_gsm","model":"ALCATEL_one_touch_985"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 985","codename":"one_touch_985_gsm","model":"Telenor_One_Touch_C"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 985D","codename":"one_touch_985D_gsm","model":"ALCATEL ONE TOUCH 985D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 985N","codename":"one_touch_985N_gsm","model":"ALCATEL ONE TOUCH 985N"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 991","codename":"ONE_TOUCH_991D_gsm","model":"ALCATEL ONE TOUCH 991D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 991","codename":"ONE_TOUCH_991_gsm","model":"ALCATEL ONE TOUCH 991"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 991","codename":"ONE_TOUCH_991_gsm","model":"ALCATEL_one_touch_991"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 991","codename":"ONE_TOUCH_991_gsm","model":"Telenor_Smart_Pro"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 991","codename":"one_touch_991_gsm","model":"ALCATEL ONE TOUCH 991"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 991A","codename":"ONE_TOUCH_991A_gsm","model":"ALCATEL ONE TOUCH 991A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 991D","codename":"ONE_TOUCH_991D_gsm","model":"ALCATEL ONE TOUCH 991D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 991D","codename":"one_touch_991D_gsm","model":"ALCATEL ONE TOUCH 991D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 991T","codename":"one_touch_991T_gsm","model":"ALCATEL ONE TOUCH 991T"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 992D","codename":"Martell_lite_GSM","model":"ALCATEL ONE TOUCH 992"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 992D","codename":"Martell_lite_GSM","model":"ALCATEL ONE TOUCH 992D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 992D","codename":"Martell_lite_GSM","model":"TCL S500"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 992D","codename":"Martell_lite_GSM","model":"TCL S600"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 995","codename":"one_touch_995_gsm","model":"ALCATEL_one_touch_995"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 995","codename":"one_touch_995_gsm","model":"Optimus_Madrid"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 995","codename":"one_touch_995_gsm","model":"Telenor_Smart_HD"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 995A","codename":"one_touch_995_gsm","model":"ALCATEL_one_touch_995A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 997D","codename":"Martell_GSM","model":"ALCATEL ONE TOUCH 997"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 997D","codename":"Martell_GSM","model":"ALCATEL ONE TOUCH 997D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 997D","codename":"Martell_GSM","model":"BASE_Lutea_3"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 997D","codename":"Martell_GSM","model":"TCL S710"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH 997D","codename":"Martell_GSM","model":"TCL S800"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH D668","codename":"DANIEL","model":"ALCATEL ONE TOUCH D668"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH D668","codename":"DANIEL","model":"TCL D668"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH D668","codename":"DANIEL","model":"TCL-D668"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH Fierce","codename":"Rav4","model":"ALCATEL ONE TOUCH 7024N"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH Fierce","codename":"Rav4","model":"ALCATEL ONE TOUCH 7024W"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH Fierce","codename":"Rav4","model":"ALCATEL ONE TOUCH Fierce"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH P310A","codename":"POP7","model":"ALCATEL ONE TOUCH P310A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH P320A","codename":"POP8","model":"ALCATEL ONE TOUCH P320A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH P321","codename":"POP8","model":"ALCATEL ONE TOUCH P321"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONE TOUCH918N","codename":"one_touch_918_gsm","model":"ALCATEL ONE TOUCH 918N"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH 4037R","codename":"SOUL4NA","model":"ALCATEL ONE TOUCH 4037R"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH 4037R","codename":"SOUL4NA","model":"ALCATEL ONETOUCH 4037R"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH 6032","codename":"Alpha","model":"ALCATEL ONETOUCH 6032"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH 6032A","codename":"Alpha","model":"ALCATEL ONETOUCH 6032A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH 6032X","codename":"Alpha","model":"ALCATEL ONETOUCH 6032X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH 6043D","codename":"DIABLOXPLUS","model":"ALCATEL ONETOUCH 6043D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH Flash Plus","codename":"CROSS2","model":"ALCATEL ONETOUCH Flash Plus"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH IDOL 3 (5.5)","codename":"idol3","model":"6045B"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH IDOL 3 (5.5)","codename":"idol3","model":"6045F"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH IDOL 3 (5.5)","codename":"idol3","model":"6045I"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH IDOL 3 (5.5)","codename":"idol3","model":"6045K"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH IDOL 3 (5.5)","codename":"idol3","model":"6045Y"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH IDOL 3 (5.5)","codename":"idol3","model":"TCL i806"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH P310A","codename":"POP7","model":"ALCATEL ONE TOUCH P310A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH P310A","codename":"POP7","model":"ALCATEL ONETOUCH P310A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 3 (3.5)","codename":"PIXI3_35","model":"4009A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 3 (3.5)","codename":"PIXI3_35","model":"4009D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 3 (3.5)","codename":"PIXI3_35","model":"4009E"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 3 (3.5)","codename":"PIXI3_35","model":"4009F"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 3 (3.5)","codename":"PIXI3_35","model":"4009K"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 3 (3.5)","codename":"PIXI3_35","model":"4009M"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 3 (3.5)","codename":"PIXI3_35","model":"4009S"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 3 (3.5)","codename":"PIXI3_35","model":"4009X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 3 (4.5)","codename":"PIXI3_45_4G","model":"5017A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 3 (4.5)","codename":"PIXI3_45_4G","model":"5017D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 3 (4.5)","codename":"PIXI3_45_4G","model":"5017E"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 3 (4.5)","codename":"PIXI3_45_4G","model":"5019D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 4 (4)","codename":"Pixi4-4","model":"4034A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 4 (4)","codename":"Pixi4-4","model":"4034D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 4 (4)","codename":"Pixi4-4","model":"4034E"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 4 (4)","codename":"Pixi4-4","model":"4034F"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 4 (4)","codename":"Pixi4-4","model":"4034G"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 4 (4)","codename":"Pixi4-4","model":"4034X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 4 (4)","codename":"Pixi4-4","model":"Alcatel_4034F"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI 4 (4)","codename":"Pixi4-4","model":"DIGICEL DL 1 lite"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH PIXI\\xe2\\x84\\xa2 3 (4.5)","codename":"PIXI3_45_4G","model":"5017O"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH POP 3 (5)","codename":"PIXI3-5","model":"5015A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH POP 3 (5)","codename":"PIXI3-5","model":"5015D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH POP 3 (5)","codename":"PIXI3-5","model":"5015E"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH POP 3 (5)","codename":"PIXI3-5","model":"5015X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH POP 3 (5)","codename":"PIXI3-5","model":"5016A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH POP 3 (5)","codename":"PIXI3-5","model":"5016J"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH POP 3 (5)","codename":"PIXI3-5","model":"5116J"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH POP 3 (5.5)","codename":"PIXI3-55","model":"5025D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH POP 3 (5.5)","codename":"PIXI3-55","model":"5025E"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH POP 3 (5.5)","codename":"PIXI3-55","model":"5025G"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH POP 3 (5.5)","codename":"PIXI3-55","model":"5025X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH POP 3 (5.5)","codename":"PIXI3-55","model":"DIGICEL DL1000"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH POP 3 (5.5)","codename":"PIXI3-55","model":"S4035 3G"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH POP D3","codename":"SOUL4NA","model":"ALCATEL ONETOUCH POP D3"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL ONETOUCH Victory","codename":"7046T","model":"Alcatel 7046T"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL PIXI 4 (5)","codename":"PIXI4_5_4G","model":"5041D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL PIXI 4 (5)","codename":"PIXI4_5_4G","model":"5045A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL PIXI 4 (5)","codename":"PIXI4_5_4G","model":"5045D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL PIXI 4 (5)","codename":"PIXI4_5_4G","model":"5045F"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL PIXI 4 (5)","codename":"PIXI4_5_4G","model":"5045G"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL PIXI 4 (5)","codename":"PIXI4_5_4G","model":"5045I"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL PIXI 4 (5)","codename":"PIXI4_5_4G","model":"5045J"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL PIXI 4 (5)","codename":"PIXI4_5_4G","model":"5045T"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL PIXI 4 (5)","codename":"PIXI4_5_4G","model":"5045X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL PIXI 4 (5)","codename":"PIXI4_5_4G","model":"5045Y"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL PIXI 4 (5)","codename":"PIXI4_5_4G","model":"5145A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL PIXI 4 (5)","codename":"PIXI4_5_4G","model":"DIGICELDL1"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL one touch 986+","codename":"OT986","model":"ALCATEL one touch 986+"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL one touch 990C+","codename":"one_touch_990C_Plus_cdma","model":"ALCATEL one touch 990C+"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL one touch J320","codename":"Iris","model":"ALCATEL one touch J320"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_ 4034A","codename":"Pixi4-4","model":"ALCATEL_4034A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_6055K","codename":"idol4","model":"ALCATEL_6055K"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_ONETOUCH_5022D","codename":"PLAY-5","model":"ALCATEL_ONETOUCH_5022D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_ONETOUCH_7053D","codename":"X1","model":"7053D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_ONETOUCH_7053D","codename":"X1","model":"ALCATEL_ONETOUCH_7053D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_ONE_TOUCH_4027A","codename":"Pixi3-45","model":"ALCATEL ONE TOUCH 4027A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_ONE_TOUCH_5037A","codename":"YarisL_GSM","model":"ALCATEL ONE TOUCH 5037A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_ONE_TOUCH_5037X","codename":"YarisL_GSM","model":"ALCATEL ONE TOUCH 5037X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_ONE_TOUCH_6010X_Orange","codename":"ONE_TOUCH_6010X_gsm","model":"ALCATEL_ONE_TOUCH_6010X_Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_ONE_TOUCH_6030X_Orange","codename":"ONE_TOUCH_6030X_gsm","model":"ALCATEL_ONE_TOUCH_6030X_Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_ONE_TOUCH_7047A","codename":"YARIS_55","model":"ALCATEL ONE TOUCH 7047A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_ONE_TOUCH_903","codename":"one_touch_903A_gsm","model":"ALCATEL_ONE_TOUCH_903"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_ONE_TOUCH_903","codename":"one_touch_903_gsm","model":"ALCATEL_ONE_TOUCH_903"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_ONE_TOUCH_991_Orange","codename":"one_touch_991_gsm","model":"ALCATEL_ONE_TOUCH_991_Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_ONE_TOUCH_P310X","codename":"POP7","model":"ALCATEL ONE TOUCH P310X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_ONE_TOUCH_P320X","codename":"POP8","model":"ALCATEL ONE TOUCH P320X"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_one_touch_918D","codename":"one_touch_918D_umts","model":"ALCATEL_one_touch_918D"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_one_touch_991","codename":"ONE_TOUCH_991A_gsm","model":"ALCATEL_one_touch_991"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_one_touch_991","codename":"one_touch_991_gsm","model":"ALCATEL_one_touch_991"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_one_touch_995","codename":"one_touch_995_gsm","model":"ALCATEL_one_touch_995"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_one_touch_995","codename":"one_touch_995_gsm","model":"RPSPE4301"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_one_touch_995","codename":"one_touch_995_gsm","model":"Telenor_One_Touch_S"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_one_touch_995","codename":"one_touch_995_gsm","model":"Telenor_Smart_HD"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_one_touch_995A","codename":"one_touch_995_gsm","model":"ALCATEL_one_touch_995A"},{"manufacturer":"TCT (Alcatel)","market_name":"ALCATEL_one_touch_995S","codename":"one_touch_995_gsm","model":"ALCATEL_one_touch_995S"},{"manufacturer":"TCT (Alcatel)","market_name":"ALOO 6032","codename":"Alpha","model":"ALOO 6032"},{"manufacturer":"TCT (Alcatel)","market_name":"AM-H100","codename":"EOS_lte","model":"AM-H100"},{"manufacturer":"TCT (Alcatel)","market_name":"ATEL ONE TOUCH 995","codename":"one_touch_995_gsm","model":"ALCATEL_one_touch_995"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 1C","codename":"U5A_PLUS_3G","model":"5009A"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 1C","codename":"U5A_PLUS_3G","model":"5009D"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 1C","codename":"U5A_PLUS_3G","model":"5009D_RU"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 1C","codename":"U5A_PLUS_3G","model":"5009U"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 1X","codename":"U5A_PLUS_4G","model":"5059A"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 1X","codename":"U5A_PLUS_4G","model":"5059D"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 1X","codename":"U5A_PLUS_4G","model":"5059D_RU"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 1X","codename":"U5A_PLUS_4G","model":"5059I"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 1X","codename":"U5A_PLUS_4G","model":"5059J"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 1X","codename":"U5A_PLUS_4G","model":"5059T"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 1X","codename":"U5A_PLUS_4G","model":"5059X"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 1X","codename":"U5A_PLUS_4G","model":"5059Y"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3","codename":"A3A","model":"5052A"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3","codename":"A3A","model":"5052D"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3","codename":"A3A","model":"5052D_RU"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3","codename":"A3A","model":"5052Y"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3","codename":"Dive_73","model":"Orange Dive 73"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3L","codename":"A3A_LITE","model":"5034D"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3L","codename":"A3A_LITE","model":"5034D_RU"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3V","codename":"A3A_XL_4G","model":"5099A"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3V","codename":"A3A_XL_4G","model":"5099D"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3V","codename":"A3A_XL_4G","model":"5099D_RU"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3V","codename":"A3A_XL_4G","model":"5099I"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3V","codename":"A3A_XL_4G","model":"5099U"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3X","codename":"A3A_PLUS","model":"5058A"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3X","codename":"A3A_PLUS","model":"5058I"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3X","codename":"A3A_PLUS","model":"5058I_RU"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3X","codename":"A3A_PLUS","model":"5058J"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3X","codename":"A3A_PLUS","model":"5058T"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3X","codename":"A3A_PLUS","model":"5058Y"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 3X","codename":"A3A_PLUS","model":"5158A"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 5","codename":"A5A_INFINI","model":"5086A"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 5","codename":"A5A_INFINI","model":"5086D"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 5","codename":"A5A_INFINI","model":"5086Y"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel 5","codename":"A5A_INFINI","model":"5186A"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel Raven LTE","codename":"BUZZ6T4GTFUMTS","model":"A574BL"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel one touch 985","codename":"one_touch_985A_gsm","model":"ALCATEL_one_touch_985"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel9007T","codename":"Pixi3_7_4G","model":"Alcatel9007T"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel_4060A","codename":"Pop445","model":"Alcatel_4060A"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel_5044C","codename":"BUZZ6T4GCRICKET","model":"Alcatel_5044C"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel_5045A","codename":"PIXI4_5_4G","model":"Alcatel_5045A"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel_5054O","codename":"Pop355","model":"Alcatel_5054O"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel_5056O","codename":"Pop355","model":"Alcatel_5056O"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel_5085C","codename":"elsa6_na","model":"Alcatel 5085C"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel_5098O","codename":"Pixi4-64GMEX","model":"Alcatel_5098O"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel_6055U","codename":"idol4","model":"Alcatel 6055U"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel_6055U","codename":"idol4","model":"Alcatel_6055U"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel_6060C","codename":"simba6_cricket","model":"Alcatel_6060C"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel_7049D","codename":"Lion-5","model":"Alcatel_7049D"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel_9001X","codename":"Pixi4-6_4G","model":"Alcatel_9001X"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel_9026S","codename":"Pixi5-10_4G","model":"Alcatel 9026S"},{"manufacturer":"TCT (Alcatel)","market_name":"Alcatel_one_touch_918_Orange","codename":"one_touch_918_gsm","model":"Alcatel_one_touch_918_Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"Boost View 5.0","codename":"YARISXL","model":"Boost View 5.0"},{"manufacturer":"TCT (Alcatel)","market_name":"CTCC: TCL Y660/CMCC: TCL V760","codename":"A3A_PLUS","model":"TCL V760"},{"manufacturer":"TCT (Alcatel)","market_name":"CTCC: TCL Y660/CMCC: TCL V760","codename":"A3A_PLUS","model":"TCL Y660"},{"manufacturer":"TCT (Alcatel)","market_name":"D819","codename":"HERO8","model":"D819"},{"manufacturer":"TCT (Alcatel)","market_name":"D820","codename":"HERO8","model":"D820"},{"manufacturer":"TCT (Alcatel)","market_name":"D820X","codename":"HERO8","model":"D820X"},{"manufacturer":"TCT (Alcatel)","market_name":"DL900","codename":"YARISXL","model":"DL900"},{"manufacturer":"TCT (Alcatel)","market_name":"DLGICELDL1 plus","codename":"POP455C","model":"DIGICELDL1plus"},{"manufacturer":"TCT (Alcatel)","market_name":"E500","codename":"X50D","model":"E500"},{"manufacturer":"TCT (Alcatel)","market_name":"ELEMENT5","codename":"BUZZ6T4GGOPHONE","model":"Alcatel_5044R"},{"manufacturer":"TCT (Alcatel)","market_name":"EVO7","codename":"EVO7","model":"MTC 1065"},{"manufacturer":"TCT (Alcatel)","market_name":"EVO7","codename":"EVO7","model":"onetouch EVO7"},{"manufacturer":"TCT (Alcatel)","market_name":"EVO7","codename":"EVO7","model":"starTIM tab 7"},{"manufacturer":"TCT (Alcatel)","market_name":"FL03","codename":"FLASH3","model":"FL03"},{"manufacturer":"TCT (Alcatel)","market_name":"Flash Plus 2","codename":"shine_plus","model":"FL02"},{"manufacturer":"TCT (Alcatel)","market_name":"Flash2_7049D","codename":"Lion-5","model":"Flash2_7049D"},{"manufacturer":"TCT (Alcatel)","market_name":"Go PLAY","codename":"alto5_sporty","model":"7048A"},{"manufacturer":"TCT (Alcatel)","market_name":"Go PLAY","codename":"alto5_sporty","model":"7048S"},{"manufacturer":"TCT (Alcatel)","market_name":"Go PLAY","codename":"alto5_sporty","model":"7048W"},{"manufacturer":"TCT (Alcatel)","market_name":"Go PLAY","codename":"alto5_sporty","model":"7048X"},{"manufacturer":"TCT (Alcatel)","market_name":"Hero2C","codename":"Hero2C","model":"7055A"},{"manufacturer":"TCT (Alcatel)","market_name":"I216A","codename":"PIXI7","model":"I216A"},{"manufacturer":"TCT (Alcatel)","market_name":"I216X","codename":"PIXI7","model":"I216X"},{"manufacturer":"TCT (Alcatel)","market_name":"I220","codename":"PIXI8","model":"I220"},{"manufacturer":"TCT (Alcatel)","market_name":"I221","codename":"PIXI8","model":"I221"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 2 S","codename":"EOS4G","model":"6050Y"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 2 S","codename":"EOS4G","model":"ALCATEL ONE TOUCH 6050Y"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 2 S","codename":"EOS4G","model":"Idol2S_Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 2 S","codename":"EOS_lte","model":"6050A"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 2 S","codename":"EOS_lte","model":"6050F"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 2 S","codename":"EOS_lte","model":"6050W"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 2 S","codename":"EOS_lte","model":"6050Y"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 2 S","codename":"EOS_lte","model":"ALCATEL ONE TOUCH 6050Y"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 2 S","codename":"EOS_lte","model":"ALCATEL ONETOUCH 6050A"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 2 S","codename":"EOS_lte","model":"OWN S5030"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 2 S","codename":"EOS_lte","model":"TCL S830U"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 2 S","codename":"EOS_lte","model":"TCL S838M"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 4S","codename":"idol4s","model":"6070K"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 4S","codename":"idol4s","model":"6070O"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 5","codename":"SIMBA6L","model":"6058A"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 5","codename":"SIMBA6L","model":"6058D"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 5","codename":"SIMBA6L","model":"6058X"},{"manufacturer":"TCT (Alcatel)","market_name":"IDOL 5S","codename":"IDOL5S","model":"6060S"},{"manufacturer":"TCT (Alcatel)","market_name":"Idol S","codename":"DiabloHD_LTE","model":"ALCATEL ONE TOUCH 6035L"},{"manufacturer":"TCT (Alcatel)","market_name":"Idol S","codename":"DiabloHD_LTE","model":"BS472"},{"manufacturer":"TCT (Alcatel)","market_name":"Idol S","codename":"DiabloHD_LTE","model":"MTC 978"},{"manufacturer":"TCT (Alcatel)","market_name":"Idol S","codename":"Diablo_LTE","model":"ALCATEL ONE TOUCH 6034L"},{"manufacturer":"TCT (Alcatel)","market_name":"Idol S","codename":"Diablo_LTE","model":"ALCATEL ONE TOUCH 6034M"},{"manufacturer":"TCT (Alcatel)","market_name":"Idol S","codename":"Diablo_LTE","model":"ALCATEL ONE TOUCH 6034R"},{"manufacturer":"TCT (Alcatel)","market_name":"Idol S","codename":"Diablo_LTE","model":"ALCATEL ONE TOUCH 6034Y"},{"manufacturer":"TCT (Alcatel)","market_name":"Idol S","codename":"Diablo_LTE","model":"San Remo 4G"},{"manufacturer":"TCT (Alcatel)","market_name":"Idol S","codename":"Diablo_LTE","model":"TCL-S850L"},{"manufacturer":"TCT (Alcatel)","market_name":"Idol X","codename":"DiabloHD_LTE","model":"ALCATEL ONE TOUCH 6035R"},{"manufacturer":"TCT (Alcatel)","market_name":"Idol2 MINI S","codename":"MIATA_lte","model":"6036A"},{"manufacturer":"TCT (Alcatel)","market_name":"Idol2 MINI S","codename":"MIATA_lte","model":"6036X"},{"manufacturer":"TCT (Alcatel)","market_name":"Idol2 MINI S","codename":"MIATA_lte","model":"6036Y"},{"manufacturer":"TCT (Alcatel)","market_name":"Juke-A554C","codename":"A554C","model":"A554C"},{"manufacturer":"TCT (Alcatel)","market_name":"LCATEL ONETOUCH PIXI 3 (4.5)","codename":"PIXI3_45_4G","model":"DIGICEL DL810"},{"manufacturer":"TCT (Alcatel)","market_name":"M812C","codename":"M812","model":"M812C"},{"manufacturer":"TCT (Alcatel)","market_name":"MTC 960","codename":"MTC_960_gsm","model":"MTC 960"},{"manufacturer":"TCT (Alcatel)","market_name":"MTC 970","codename":"Beetle_GSM","model":"MTC 970"},{"manufacturer":"TCT (Alcatel)","market_name":"MTC975","codename":"Camry_GSM","model":"MTC975"},{"manufacturer":"TCT (Alcatel)","market_name":"MegaFon_SP-A10","codename":"one_touch_995_gsm","model":"MegaFon_SP-A10"},{"manufacturer":"TCT (Alcatel)","market_name":"Megafon Login","codename":"OT-930","model":"MegaFon_SP-AI"},{"manufacturer":"TCT (Alcatel)","market_name":"Mirage","codename":"feijao","model":"5057M"},{"manufacturer":"TCT (Alcatel)","market_name":"Moov2","codename":"move_2_gsm","model":"move 2"},{"manufacturer":"TCT (Alcatel)","market_name":"NeXT by Maxis (B1)","codename":"VFD500","model":"VFD 500"},{"manufacturer":"TCT (Alcatel)","market_name":"NeXT by Maxis (M1)","codename":"VFD700","model":"Maxis VFD 700"},{"manufacturer":"TCT (Alcatel)","market_name":"NeXT by Maxis (M1)","codename":"VFD700","model":"VFD 700"},{"manufacturer":"TCT (Alcatel)","market_name":"NeXT by Maxis (M1)","codename":"VFD700","model":"VFD700"},{"manufacturer":"TCT (Alcatel)","market_name":"Nitro","codename":"idol3","model":"6045O"},{"manufacturer":"TCT (Alcatel)","market_name":"No","codename":"Pixi445Cricket","model":"Alcatel_4060O"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4007X","codename":"Pixo_GSM","model":"ONE TOUCH 4007A"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4007X","codename":"Pixo_GSM","model":"ONE TOUCH 4007D"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4007X","codename":"Pixo_GSM","model":"ONE TOUCH 4007E"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4007X","codename":"Pixo_GSM","model":"ONE TOUCH 4007X"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4011X","codename":"BeetleliteJB","model":"ONE TOUCH 4011X"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4015X","codename":"Yaris35_GSM","model":"4016D"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4015X","codename":"Yaris35_GSM","model":"ONE TOUCH 4015A"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4015X","codename":"Yaris35_GSM","model":"ONE TOUCH 4015D"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4015X","codename":"Yaris35_GSM","model":"ONE TOUCH 4015N"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4015X","codename":"Yaris35_GSM","model":"ONE TOUCH 4015X"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4015X","codename":"Yaris35_GSM","model":"ONE TOUCH 4015X-orange"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4015X","codename":"Yaris35_GSM","model":"ONE TOUCH 4016A"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4015X","codename":"Yaris35_GSM","model":"Orange Yomi"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4033X","codename":"Yaris_M_GSM","model":"4032A"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4033X","codename":"Yaris_M_GSM","model":"4032D"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4033X","codename":"Yaris_M_GSM","model":"4032E"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4033X","codename":"Yaris_M_GSM","model":"4032X"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4033X","codename":"Yaris_M_GSM","model":"4033L"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4033X","codename":"Yaris_M_GSM","model":"MS3B"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4033X","codename":"Yaris_M_GSM","model":"ONE TOUCH 4032A"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4033X","codename":"Yaris_M_GSM","model":"ONE TOUCH 4033A"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4033X","codename":"Yaris_M_GSM","model":"ONE TOUCH 4033D"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4033X","codename":"Yaris_M_GSM","model":"ONE TOUCH 4033E"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4033X","codename":"Yaris_M_GSM","model":"ONE TOUCH 4033X"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4033X","codename":"Yaris_M_GSM","model":"OWN S3010"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4033X","codename":"Yaris_M_GSM","model":"OWN S3010D"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 4033X","codename":"Yaris_M_GSM","model":"TCLJ330"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 6012A","codename":"California_GSM","model":"ONE TOUCH 6012A"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 6012D","codename":"California","model":"ALCATEL ONE TOUCH 6012D"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 6012D","codename":"California","model":"ALCATEL ONE TOUCH 6012X"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 6012D","codename":"California","model":"Mobile Sosh"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 6012D","codename":"California","model":"ONE TOUCH 6012A"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 6012D","codename":"California","model":"ONE TOUCH 6012D"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 6012D","codename":"California","model":"ONE TOUCH 6012E"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 6012D","codename":"California","model":"ONE TOUCH 6012X"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 6012D","codename":"California","model":"ONE TOUCH IDOL MINI"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 6012D","codename":"California","model":"Orange Covo"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 6012D","codename":"California","model":"Orange Hiro"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 6012X","codename":"California","model":"ONE TOUCH 6012X"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 8020D","codename":"SCRIBEPRO","model":"ONE TOUCH 8020D"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 983","codename":"ONE_TOUCH_983_gsm","model":"ALCATEL_one_touch_983"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 983","codename":"ONE_TOUCH_983_gsm","model":"ONE TOUCH 983"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 983","codename":"ONE_TOUCH_983_gsm","model":"VALENCIA"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH 983","codename":"one_touch_983_gsm","model":"ALCATEL_one_touch_983"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH C505C","codename":"ONE_TOUCH_C505C_cdma","model":"ONE TOUCH C505C"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH EVO7HD","codename":"E710","model":"MTC 1078"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH EVO7HD","codename":"E710","model":"ONE TOUCH E710"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH EVO7HD","codename":"E710","model":"ONE TOUCH EVO7HD"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH EVO8HD","codename":"E720","model":"ONE TOUCH EVO7HD"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH EVO8HD","codename":"E720","model":"ONE TOUCH EVO8HD"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH SCRIBE 5","codename":"Scribe5_gsm","model":"ALCATEL ONE TOUCH 8000A"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH SCRIBE 5","codename":"Scribe5_gsm","model":"ALCATEL ONE TOUCH 8000D"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH SCRIBE 5","codename":"Scribe5_gsm","model":"TCL Y710"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH T10","codename":"GR-TB7","model":"GR-TB7"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH TAB 7","codename":"T011","model":"ONE TOUCH TAB 7"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH TAB 7","codename":"T011","model":"TCL TAB 7"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH TAB 7HD","codename":"T016","model":"ONE TOUCH TAB 7HD"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH TAB 8HD","codename":"T021","model":"ONE TOUCH TAB 8HD"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH Ultra 960c","codename":"Alltel","model":"ONE_TOUCH_960C"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH Ultra 960c","codename":"ONE_TOUCH_960C","model":"ADR3010"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH Ultra 960c","codename":"ONE_TOUCH_960C","model":"ONE TOUCH 960C"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH Ultra 960c","codename":"RadioShack","model":"ADR3010"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH Ultra 960c","codename":"nTelos","model":"ONE_TOUCH_960C"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE TOUCH Ultra 960c","codename":"vulcan","model":"ONE_TOUCH_960C"},{"manufacturer":"TCT (Alcatel)","market_name":"ONETOUCH PIXI 3 (8)","codename":"pixi384g","model":"9022S"},{"manufacturer":"TCT (Alcatel)","market_name":"ONETOUCH PIXI 3 (8)","codename":"pixi384g","model":"9022X"},{"manufacturer":"TCT (Alcatel)","market_name":"ONETOUCH PIXI 3 (8)","codename":"pixi384g","model":"Alcatel9022S"},{"manufacturer":"TCT (Alcatel)","market_name":"ONETOUCH PIXI 3 (8)","codename":"pixi384g","model":"Alcatel_9022S"},{"manufacturer":"TCT (Alcatel)","market_name":"ONETOUCH PIXI3(7)","codename":"pixi37","model":"9007A"},{"manufacturer":"TCT (Alcatel)","market_name":"ONETOUCH PIXI3(7)","codename":"pixi37","model":"9007X"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE_TOUCH_P310A","codename":"POP7","model":"ONE TOUCH P310A"},{"manufacturer":"TCT (Alcatel)","market_name":"ONE_TOUCH_P310X","codename":"POP7","model":"ALCATEL ONE TOUCH P310X"},{"manufacturer":"TCT (Alcatel)","market_name":"OT-990C","codename":"OT-990C_cdma","model":"OT-990C"},{"manufacturer":"TCT (Alcatel)","market_name":"OWN S4010","codename":"Telsa","model":"OWN S4010"},{"manufacturer":"TCT (Alcatel)","market_name":"OWN S5010","codename":"DiabloHD","model":"OWN S5010"},{"manufacturer":"TCT (Alcatel)","market_name":"OWN_S4025","codename":"YARIS_55","model":"OWN_S4025"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 890D","codename":"one_touch_890D_gsm","model":"ALCATEL one touch 890D"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 906","codename":"one_touch_906_gsm","model":"ALCATEL_one_touch_906Y"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 908","codename":"one_touch_908_gsm","model":"ALCATEL ONE TOUCH 908"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 908","codename":"one_touch_908_gsm","model":"ALCATEL_one_touch_908"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 908","codename":"one_touch_908_gsm","model":"Alcatel_one_touch_908F_Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 990","codename":"one_touch_990_gsm","model":"ALCATEL ONE TOUCH 990"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 990","codename":"one_touch_990_gsm","model":"ALCATEL one touch 990"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 990","codename":"one_touch_990_gsm","model":"ALCATEL_one_touch_990"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 990","codename":"one_touch_990_gsm","model":"Alcatel one touch 908F Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 990","codename":"one_touch_990_gsm","model":"Alcatel one touch 990 Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 990","codename":"one_touch_990_gsm","model":"Los Angeles"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 990","codename":"one_touch_990_gsm","model":"TCL A990"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 990","codename":"one_touch_990_gsm","model":"TCL ONE TOUCH 990"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 990","codename":"one_touch_990_gsm","model":"Telenor_OneTouch"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 990","codename":"one_touch_990_gsm","model":"Vodafone 958"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 990A","codename":"one_touch_990A_gsm","model":"ALCATEL_one_touch_990A"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 990S","codename":"one_touch_990S_gsm","model":"ALCATEL_one_touch_990S"},{"manufacturer":"TCT (Alcatel)","market_name":"One Touch 990S","codename":"one_touch_990S_gsm","model":"Alcatel one touch 990S"},{"manufacturer":"TCT (Alcatel)","market_name":"P330X","codename":"Pop7_LTE","model":"P330X"},{"manufacturer":"TCT (Alcatel)","market_name":"P330X_orange","codename":"Pop7_LTE","model":"P330X_orange"},{"manufacturer":"TCT (Alcatel)","market_name":"P350X","codename":"POP8_LTE","model":"P350X"},{"manufacturer":"TCT (Alcatel)","market_name":"P360X","codename":"POP10","model":"P360X"},{"manufacturer":"TCT (Alcatel)","market_name":"P688L","codename":"Rio5C","model":"TCL-P688L"},{"manufacturer":"TCT (Alcatel)","market_name":"P688L","codename":"Rio5C","model":"TOM007"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI 4 (5)","codename":"Pixi4-5","model":"5010D"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI 4 (5)","codename":"Pixi4-5","model":"5010E"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI 4 (5)","codename":"Pixi4-5","model":"5010G"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI 4 (5)","codename":"Pixi4-5","model":"5010S"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI 4 (5)","codename":"Pixi4-5","model":"5010U"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI 4 (5)","codename":"Pixi4-5","model":"5010X"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI 5 HD","codename":"Mickey6CC","model":"A576CC"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4)","codename":"Pixi3-4","model":"4003A"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4)","codename":"Pixi3-4","model":"4003J"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4)","codename":"Pixi3-4","model":"4013D"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4)","codename":"Pixi3-4","model":"4013E"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4)","codename":"Pixi3-4","model":"4013J"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4)","codename":"Pixi3-4","model":"4013K"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4)","codename":"Pixi3-4","model":"4013X"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4)","codename":"Pixi3-4","model":"4014E"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4)","codename":"Pixi3-4","model":"ONE_TOUCH_PIXI3"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4)","codename":"Pixi3-4","model":"ONE_TOUCH_PIXI3D"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4.5)","codename":"Pixi3-45","model":"4027A"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4.5)","codename":"Pixi3-45","model":"4027D"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4.5)","codename":"Pixi3-45","model":"4027N"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4.5)","codename":"Pixi3-45","model":"4027X"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4.5)","codename":"Pixi3-45","model":"4028A"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4.5)","codename":"Pixi3-45","model":"4028E"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4.5)","codename":"Pixi3-45","model":"4028J"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI3(4.5)","codename":"Pixi3-45","model":"4028S"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI4 (3.5)","codename":"PIXI4-35","model":"4017A"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI4 (3.5)","codename":"PIXI4-35","model":"4017D"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI4 (3.5)","codename":"PIXI4-35","model":"4017F"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI4 (3.5)","codename":"PIXI4-35","model":"4017S"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI4 (3.5)","codename":"PIXI4-35","model":"4017X"},{"manufacturer":"TCT (Alcatel)","market_name":"PIXI\\xe2\\x84\\xa24","codename":"Pixi445CAN","model":"4060S"},{"manufacturer":"TCT (Alcatel)","market_name":"PLAY_P1","codename":"PLAY_P1","model":"4024D"},{"manufacturer":"TCT (Alcatel)","market_name":"PLAY_P1","codename":"PLAY_P1","model":"4024E"},{"manufacturer":"TCT (Alcatel)","market_name":"POP 2","codename":"Alto45","model":"5042A"},{"manufacturer":"TCT (Alcatel)","market_name":"POP 2","codename":"Alto45","model":"5042D"},{"manufacturer":"TCT (Alcatel)","market_name":"POP 2","codename":"Alto45","model":"5042X"},{"manufacturer":"TCT (Alcatel)","market_name":"POP 2 (5)","codename":"alto5","model":"7043A"},{"manufacturer":"TCT (Alcatel)","market_name":"POP 2 (5)","codename":"alto5","model":"7043K"},{"manufacturer":"TCT (Alcatel)","market_name":"POP 2 (5)","codename":"alto5","model":"7043Y"},{"manufacturer":"TCT (Alcatel)","market_name":"POP 2 (5)","codename":"alto5_premium","model":"7044A"},{"manufacturer":"TCT (Alcatel)","market_name":"POP 2 (5)","codename":"alto5_premium","model":"7044X"},{"manufacturer":"TCT (Alcatel)","market_name":"\"POP 4 6\"\" 4G android\"","codename":"POP4-6_4G","model":"7070I"},{"manufacturer":"TCT (Alcatel)","market_name":"\"POP 4 6\"\" 4G android\"","codename":"POP4-6_4G","model":"7070Q"},{"manufacturer":"TCT (Alcatel)","market_name":"\"POP 4 6\"\" 4G android\"","codename":"POP4-6_4G","model":"7070X"},{"manufacturer":"TCT (Alcatel)","market_name":"POP 4S","codename":"shine_plus","model":"5095I"},{"manufacturer":"TCT (Alcatel)","market_name":"POP 4S","codename":"shine_plus","model":"5095K"},{"manufacturer":"TCT (Alcatel)","market_name":"POP 4S","codename":"shine_plus","model":"5095Y"},{"manufacturer":"TCT (Alcatel)","market_name":"POP S3","codename":"RIO4G_TF","model":"ALCATEL A845L"},{"manufacturer":"TCT (Alcatel)","market_name":"POP S3","codename":"RIO_4G","model":"5050A"},{"manufacturer":"TCT (Alcatel)","market_name":"POP S3","codename":"RIO_4G","model":"5050S"},{"manufacturer":"TCT (Alcatel)","market_name":"POP S3","codename":"RIO_4G","model":"5050X"},{"manufacturer":"TCT (Alcatel)","market_name":"POP S3","codename":"RIO_4G","model":"5050Y"},{"manufacturer":"TCT (Alcatel)","market_name":"POP S3","codename":"RIO_4G","model":"ALCATEL ONETOUCH 5050X"},{"manufacturer":"TCT (Alcatel)","market_name":"POP S3","codename":"RIO_4G","model":"Siru"},{"manufacturer":"TCT (Alcatel)","market_name":"POP S9","codename":"RIO6_lte","model":"7050Y"},{"manufacturer":"TCT (Alcatel)","market_name":"POP S9","codename":"RIO6_lte","model":"ALCATEL A995L"},{"manufacturer":"TCT (Alcatel)","market_name":"POP S9","codename":"RIO6_lte","model":"STARXTREM II"},{"manufacturer":"TCT (Alcatel)","market_name":"POP S9","codename":"RIO6_lte","model":"Smartphone Android by SFR STARXTREM II"},{"manufacturer":"TCT (Alcatel)","market_name":"POP2 (4)","codename":"alto4","model":"4045A"},{"manufacturer":"TCT (Alcatel)","market_name":"POP2 (4)","codename":"alto4_8g","model":"4045A"},{"manufacturer":"TCT (Alcatel)","market_name":"POP2 (4)","codename":"alto4_8g","model":"4045D"},{"manufacturer":"TCT (Alcatel)","market_name":"POP2 (4)","codename":"alto4_8g","model":"4045L"},{"manufacturer":"TCT (Alcatel)","market_name":"POP2 (4)","codename":"alto4_8g","model":"4045O"},{"manufacturer":"TCT (Alcatel)","market_name":"POP2 (4)","codename":"alto4_8g","model":"4045X"},{"manufacturer":"TCT (Alcatel)","market_name":"POP2 (4.5)","codename":"alto45_latam_b28","model":"5042G"},{"manufacturer":"TCT (Alcatel)","market_name":"POP2 (4.5)","codename":"alto45_latam_b28","model":"5042W"},{"manufacturer":"TCT (Alcatel)","market_name":"PandA_m14","codename":"YARIS_55","model":"PandA_m14"},{"manufacturer":"TCT (Alcatel)","market_name":"Pixi3-3.5 TF","codename":"Pixi3-35TF","model":"A463BG"},{"manufacturer":"TCT (Alcatel)","market_name":"Pixi3-4 TF","codename":"PIXI3_4TF","model":"A460G"},{"manufacturer":"TCT (Alcatel)","market_name":"Pixi4-4 3G Telus","codename":"PIXI4_4TF","model":"A466T"},{"manufacturer":"TCT (Alcatel)","market_name":"Pixo 7","codename":"PIXO7","model":"I211"},{"manufacturer":"TCT (Alcatel)","market_name":"Pixo 7","codename":"PIXO7","model":"I212"},{"manufacturer":"TCT (Alcatel)","market_name":"Pixo 7","codename":"PIXO7","model":"I213"},{"manufacturer":"TCT (Alcatel)","market_name":"Pop4","codename":"POP455C","model":"Pop4"},{"manufacturer":"TCT (Alcatel)","market_name":"S4035_4G","codename":"Pop355","model":"S4035_4G"},{"manufacturer":"TCT (Alcatel)","market_name":"SHINE LITE","codename":"shine_lite","model":"5080D"},{"manufacturer":"TCT (Alcatel)","market_name":"SHINE LITE","codename":"shine_lite","model":"5080X"},{"manufacturer":"TCT (Alcatel)","market_name":"SMART 4G 5.5 Enterprise","codename":"M812","model":"SMART 4G 5.5 Enterprise"},{"manufacturer":"TCT (Alcatel)","market_name":"SMART_ PLUS","codename":"PIXI4_55_3G","model":"SMART_PLUS"},{"manufacturer":"TCT (Alcatel)","market_name":"SOL PRIME","codename":"idol4s","model":"T-1000"},{"manufacturer":"TCT (Alcatel)","market_name":"SOL PRIME","codename":"idol4s_skt","model":"T-1000"},{"manufacturer":"TCT (Alcatel)","market_name":"SOLO Aspire M","codename":"PIXI3-5","model":"SOLO Aspire M"},{"manufacturer":"TCT (Alcatel)","market_name":"SOUL 4.5","codename":"SOUL45_GSM","model":"5038X"},{"manufacturer":"TCT (Alcatel)","market_name":"Smartphone Android by SFR STARADDICT II","codename":"one_touch_996_gsm","model":"Smartphone Android by SFR STARADDICT II"},{"manufacturer":"TCT (Alcatel)","market_name":"Smartphone Android by SFR STARADDICT II","codename":"one_touch_996_gsm","model":"Smartphone_Android_by_SFR_STARADDICT_II"},{"manufacturer":"TCT (Alcatel)","market_name":"Sol","codename":"idol3","model":"AM-H200"},{"manufacturer":"TCT (Alcatel)","market_name":"Soul 3.5","codename":"SOUL35","model":"4018A"},{"manufacturer":"TCT (Alcatel)","market_name":"Soul 3.5","codename":"SOUL35","model":"4018D"},{"manufacturer":"TCT (Alcatel)","market_name":"Soul 3.5","codename":"SOUL35","model":"4018E"},{"manufacturer":"TCT (Alcatel)","market_name":"Soul 3.5","codename":"SOUL35","model":"4018F"},{"manufacturer":"TCT (Alcatel)","market_name":"Soul 3.5","codename":"SOUL35","model":"4018M"},{"manufacturer":"TCT (Alcatel)","market_name":"Soul 3.5","codename":"SOUL35","model":"4018X"},{"manufacturer":"TCT (Alcatel)","market_name":"Soul 3.5","codename":"SOUL35","model":"T4018"},{"manufacturer":"TCT (Alcatel)","market_name":"Soul 4","codename":"SOUL4","model":"4035A"},{"manufacturer":"TCT (Alcatel)","market_name":"Soul 4","codename":"SOUL4","model":"4035D"},{"manufacturer":"TCT (Alcatel)","market_name":"Soul 4","codename":"SOUL4","model":"4035X"},{"manufacturer":"TCT (Alcatel)","market_name":"Soul 4","codename":"SOUL4","model":"4035X_Orange"},{"manufacturer":"TCT (Alcatel)","market_name":"Soul 4","codename":"SOUL4","model":"4035Y"},{"manufacturer":"TCT (Alcatel)","market_name":"Soul 4","codename":"SOUL4","model":"4036E"},{"manufacturer":"TCT (Alcatel)","market_name":"Soul 4.5","codename":"SOUL45_GSM","model":"5038A"},{"manufacturer":"TCT (Alcatel)","market_name":"Soul 4.5","codename":"SOUL45_GSM","model":"5038E"},{"manufacturer":"TCT (Alcatel)","market_name":"Soul 4.5","codename":"SOUL45_GSM","model":"D45"},{"manufacturer":"TCT (Alcatel)","market_name":"T10","codename":"T10","model":"one touch T10"},{"manufacturer":"TCT (Alcatel)","market_name":"T2","codename":"HANDYT2","model":"T700A"},{"manufacturer":"TCT (Alcatel)","market_name":"T2","codename":"HANDYT2","model":"T700X"},{"manufacturer":"TCT (Alcatel)","market_name":"T70","codename":"PIXO7","model":"T70"},{"manufacturer":"TCT (Alcatel)","market_name":"TAB 7 DUAL CORE","codename":"T015","model":"TAB 7 DUAL CORE"},{"manufacturer":"TCT (Alcatel)","market_name":"TAB 7 DUAL CORE","codename":"T017","model":"TAB 7 DUAL CORE"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL 302U","codename":"Festa5_CU","model":"TCL 302U"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL 520","codename":"shine_lite","model":"TCL 520"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL 562","codename":"shine_plus","model":"562"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL 580","codename":"idol4_mini","model":"TCL 580"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL 736L","codename":"Rio5C","model":"TCL-J736L"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL 738M","codename":"Rio5C","model":"TCL J738M"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL 750","codename":"x1_plus","model":"TCL 750"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL 950","codename":"idol4s_cn","model":"TCL 950"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL A506","codename":"TCL_A506","model":"TCL A506"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL A865","codename":"TCL_A865","model":"TCL A865"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL A988","codename":"one_touch_993D_gsm","model":"ALCATEL ONE TOUCH 993D"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL A988","codename":"one_touch_993_gsm","model":"ALCATEL ONE TOUCH 993"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL A988","codename":"one_touch_993_gsm","model":"MTC_968"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL C995","codename":"TCL_C995_cdma","model":"TCL C995"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL D35","codename":"SOUL35","model":"TCL D35"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL D40 DUAL","codename":"D40","model":"TCL D40 DUAL"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL D55","codename":"YARIS_55","model":"TCL D55"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL D662","codename":"TCL_D662_cdma","model":"TCL D662"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL D706","codename":"EG502","model":"TCL D706"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL D768","codename":"EG501","model":"TCL D768"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL D920","codename":"TCL_D920","model":"TCL D920"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL D920","codename":"TCL_D920","model":"TCL-D920"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL DL750","codename":"SOUL4","model":"DL750"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL H900M","codename":"HERO2","model":"TCL H900M"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J210C","codename":"TCL_J210C_cdma","model":"TCL J210C"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J210C","codename":"TCL_J210C_cdma","model":"TCL-J210C"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J300","codename":"Megane","model":"ALCATEL ONE TOUCH 5020T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J300","codename":"Megane","model":"TCL J300"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J310","codename":"MeganeB","model":"TCL J310"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J320","codename":"Iris","model":"TCL J320"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J320C","codename":"Daniel_lite","model":"TCL J320C"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J320T","codename":"IrisTD","model":"TCL J320T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J600T","codename":"Iris2TD","model":"TCL J600T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J620","codename":"md501","model":"TCL J620"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J630","codename":"Iris2PlusUMTS","model":"J630"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J630T","codename":"Iris2PlusTD","model":"TCL J630T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J720","codename":"YARISXL","model":"TCL J720"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J726T","codename":"YARISXL","model":"TCL J726T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J900","codename":"Camry2","model":"TCL J900"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J900T","codename":"Camry2_TD","model":"TCL J900T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J920","codename":"YARIS_55","model":"TCL J920"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J926T","codename":"YARIS_55","model":"TCL J926T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J928","codename":"Prius","model":"TCL J928"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J929L","codename":"Diablo_LTE","model":"TCL-J929L"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL J938M","codename":"RIO55_LTE","model":"TCL J938M"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL M2M","codename":"CROSS2","model":"TCL M2M"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL M2U","codename":"CROSS2","model":"TCL M2U"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P301C","codename":"Cooper_40","model":"TCL P301C"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P301M","codename":"TCL_P301M","model":"TCL P301M"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P302C","codename":"Cooper40","model":"TCL P302C"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P316L","codename":"Festa5_CT","model":"TCL P316L"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P331M","codename":"TCL_P331M","model":"TCL P331M"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P332U","codename":"TCL_P332U","model":"TCL P332U"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P360W","codename":"Focus5_CU","model":"TCL P360W"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P500M","codename":"Festa_L","model":"TCL P500M"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P502U","codename":"Festa5_CU","model":"TCL P502U"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P520L","codename":"Bora5_CT","model":"TCL P520L"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P606","codename":"Rav4_GSM","model":"TCL P600"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P606","codename":"Rav4_GSM","model":"TCL P606"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P606","codename":"Rav4_GSM","model":"TCL P606T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P618L","codename":"HUMMER5_CT","model":"TCL P618L"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P631M","codename":"Civic_X","model":"TCL P631M"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P689L","codename":"POLO55","model":"TCL_P689L"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL P728M","codename":"CROSS_LTE","model":"TCL P728M"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S300T","codename":"TCLS300T","model":"TCL S300T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S500","codename":"TCL_S500_GSM","model":"TCL S500"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S520","codename":"TCL_S520_GSM","model":"TCL S520"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S530T","codename":"California","model":"TCL S530T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S600","codename":"TCL_S600_GSM","model":"TCL S600"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S700","codename":"TCLS700","model":"TCL S700"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S700T","codename":"TCLS700T","model":"TCL S700T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S720","codename":"Cross55","model":"TCL S720"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S720T","codename":"Cross55","model":"TCL S720T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S725T","codename":"Cross55_TD_Plus","model":"TCL_S725T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S820","codename":"Diablo","model":"TCL S820"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S850","codename":"DiabloHD","model":"TCL S850"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S860","codename":"Alpha","model":"TCL S860"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S900","codename":"S900","model":"TCL S900"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S950","codename":"DIABLOX","model":"TCL S950"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S950T","codename":"DIABLOX","model":"TCL S950T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S960","codename":"DIABLOXPLUS","model":"TCL S960"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL S960T","codename":"DIABLOXPLUS","model":"TCL S960T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL T500L","codename":"evoque_cn","model":"TCL T500L"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL Y900","codename":"Scribe5HD_GSM","model":"TCL Y900"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL Y910","codename":"SCRIBEPRO","model":"TCL Y910"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL Y910T","codename":"SCRIBEPRO","model":"TCL Y910T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL i708U","codename":"EOS_MACAN","model":"TCL i708U"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL i718M","codename":"EOS2","model":"TCL i718M"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL i718M","codename":"EOS_Plus","model":"TCL i709M"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL-550","codename":"shine_plus","model":"TCL-550"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL-J320D","codename":"Daniel_lite_2S","model":"TCL-J320D"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL-J900C","codename":"TCL_J900C","model":"TCL-J900C"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL-P306C","codename":"Ford50","model":"TCL-P306C"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL_6110A","codename":"Telsa","model":"TCL 6110A"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL_6110A","codename":"Telsa","model":"TCL_6110A"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL_J636D","codename":"msm7627a_a5y_j636d","model":"TCL_J636D"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL_J706T","codename":"Focus_L","model":"TCL_J706T"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL_P561U","codename":"Fit55_CU","model":"TCL_P561U"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL_U980","codename":"TCL_U980","model":"TCL_U980"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL_Xess_P17AA","codename":"Xess","model":"TCL Xess P17AA"},{"manufacturer":"TCT (Alcatel)","market_name":"TCL_Xess_P17AA_OS","codename":"Xess","model":"TCL Xess P17AA"},{"manufacturer":"TCT (Alcatel)","market_name":"Telenor_Smart","codename":"one_touch_985_gsm","model":"Telenor_Smart"},{"manufacturer":"TCT (Alcatel)","market_name":"Telenor_Smart_Mini","codename":"SOUL4","model":"Telenor Smart Mini"},{"manufacturer":"TCT (Alcatel)","market_name":"U3","codename":"U3_3G","model":"4049D"},{"manufacturer":"TCT (Alcatel)","market_name":"U3","codename":"U3_3G","model":"4049E"},{"manufacturer":"TCT (Alcatel)","market_name":"U3","codename":"U3_3G","model":"4049G"},{"manufacturer":"TCT (Alcatel)","market_name":"U3","codename":"U3_3G","model":"4049M"},{"manufacturer":"TCT (Alcatel)","market_name":"U3","codename":"U3_3G","model":"4049X"},{"manufacturer":"TCT (Alcatel)","market_name":"U5","codename":"BUZZ6T4G","model":"5044A"},{"manufacturer":"TCT (Alcatel)","market_name":"U5","codename":"BUZZ6T4G","model":"5044P"},{"manufacturer":"TCT (Alcatel)","market_name":"U5","codename":"BUZZ6T4G","model":"5044Y"},{"manufacturer":"TCT (Alcatel)","market_name":"U5 3G","codename":"U5_3G","model":"4047A"},{"manufacturer":"TCT (Alcatel)","market_name":"U5 3G","codename":"U5_3G","model":"4047F"},{"manufacturer":"TCT (Alcatel)","market_name":"U5 HD","codename":"BUZZ6E","model":"5047D"},{"manufacturer":"TCT (Alcatel)","market_name":"U5 HD","codename":"BUZZ6E","model":"5047I"},{"manufacturer":"TCT (Alcatel)","market_name":"U5 HD","codename":"BUZZ6E","model":"5047U"},{"manufacturer":"TCT (Alcatel)","market_name":"U5 HD","codename":"BUZZ6E","model":"5047Y"},{"manufacturer":"TCT (Alcatel)","market_name":"U50\\xe2\\x84\\xa2","codename":"BUZZ6T4GTELUS","model":"5044G"},{"manufacturer":"TCT (Alcatel)","market_name":"U50\\xe2\\x84\\xa2","codename":"BUZZ6T4GTELUS","model":"5044S"},{"manufacturer":"TCT (Alcatel)","market_name":"VF 860","codename":"Vodafone_Smart_II_gsm","model":"Vodafone Smart II"},{"manufacturer":"TCT (Alcatel)","market_name":"Vodafone 785","codename":"Vodafone_785","model":"MTC 982"},{"manufacturer":"TCT (Alcatel)","market_name":"Vodafone 861","codename":"one_touch_922_gsm","model":"ALCATEL ONE TOUCH 922"},{"manufacturer":"TCT (Alcatel)","market_name":"Vodafone 861","codename":"one_touch_922_gsm","model":"Vodafone 861"},{"manufacturer":"TCT (Alcatel)","market_name":"Vodafone 985N","codename":"Vodafone985N","model":"Vodafone 985N"},{"manufacturer":"TCT (Alcatel)","market_name":"Vodafone Smart III","codename":"Vodafone_975","model":"Vodafone 975"},{"manufacturer":"TCT (Alcatel)","market_name":"Vodafone Smart III (with NFC)","codename":"Vodafone_975N","model":"Vodafone 975N"},{"manufacturer":"TCT (Alcatel)","market_name":"X35E","codename":"X35E","model":"X35E"},{"manufacturer":"TCT (Alcatel)","market_name":"X50D","codename":"X50D","model":"X50D"},{"manufacturer":"TCT (Alcatel)","market_name":"Xess mini","codename":"Xess-mini","model":"TCL Xess miniC15BA"},{"manufacturer":"TCT (Alcatel)","market_name":"Xess-mini","codename":"Xess-mini","model":"TCL Xess C15BA"},{"manufacturer":"TCT (Alcatel)","market_name":"alcatel PIXI 4 (5.5)","codename":"PIXI4_55_3G","model":"5012D"},{"manufacturer":"TCT (Alcatel)","market_name":"alcatel PIXI 4 (5.5)","codename":"PIXI4_55_3G","model":"5012F"},{"manufacturer":"TCT (Alcatel)","market_name":"alcatel PIXI 4 (5.5)","codename":"PIXI4_55_3G","model":"5012G"},{"manufacturer":"TCT (Alcatel)","market_name":"alcatel U5","codename":"BUZZ6T4G","model":"5044D"},{"manufacturer":"TCT (Alcatel)","market_name":"alcatel U5","codename":"BUZZ6T4G","model":"5044I"},{"manufacturer":"TCT (Alcatel)","market_name":"alcatel U5","codename":"BUZZ6T4G","model":"5044K"},{"manufacturer":"TCT (Alcatel)","market_name":"alcatel U5","codename":"BUZZ6T4G","model":"5044O"},{"manufacturer":"TCT (Alcatel)","market_name":"alcatel U5","codename":"BUZZ6T4G","model":"5044T"},{"manufacturer":"TCT (Alcatel)","market_name":"freebit PandA_m14","codename":"YARIS_55","model":"freebit PandA_m14"},{"manufacturer":"TCT (Alcatel)","market_name":"one touch 995C+","codename":"one_touch_995C_cdma","model":"one touch 995C+"},{"manufacturer":"TCT (Alcatel)","market_name":"one touch D920","codename":"one_touch_D920","model":"ALCATEL one touch D920"},{"manufacturer":"TCT (Alcatel)","market_name":"one touch D920","codename":"one_touch_D920","model":"one touch D920"},{"manufacturer":"TCT (Alcatel)","market_name":"one_touch_4030_TLVE","codename":"Beetle_GSM","model":"ALCATEL_one_touch_4030A"},{"manufacturer":"TCT (Alcatel)","market_name":"one_touch_D920_ALIQ","codename":"one_touch_D920","model":"one touch D920"},{"manufacturer":"TCT (Alcatel)","market_name":"onetouch_P689L","codename":"POLO55","model":"onetouch_P689L"},{"manufacturer":"TCT (Alcatel)","market_name":"tbd","codename":"Mickey6TFUMTS","model":"A576BL"},{"manufacturer":"TCT (Alcatel)","market_name":"tmn smarta8","codename":"ONE_TOUCH_991D_gsm","model":"moche smart a8"},{"manufacturer":"TCT (Alcatel)","market_name":"tmn smarta8","codename":"ONE_TOUCH_991D_gsm","model":"tmn smart a8"},{"manufacturer":"TG&Co.","market_name":"TG-L800S","codename":"PHX","model":"TG-L800S"},{"manufacturer":"TG&Co.","market_name":"TG-L900S","codename":"JGR","model":"TG-L900S"},{"manufacturer":"THL","market_name":"Knight 2","codename":"Knight_2","model":"Knight 2"},{"manufacturer":"TIM","market_name":"TIM BOX","codename":"uzw4010tim","model":"TIM_BOX"},{"manufacturer":"TIM","market_name":"TIMvision","codename":"dwt765ti","model":"skipper"},{"manufacturer":"TJC","market_name":"Metal Tablet","codename":"Metal_Tablet_10","model":"Metal_Tablet_10"},{"manufacturer":"TMAX","market_name":"TM9S775","codename":"MID908A-K","model":"TM9S775"},{"manufacturer":"TOUCHSMART","market_name":"QUICKTAB","codename":"Quicktab","model":"Quicktab"},{"manufacturer":"TPS","market_name":"MTC 982o","codename":"MTC_982O","model":"MTC_982O"},{"manufacturer":"TPS","market_name":"SMART Sprint","codename":"SMARTSprint","model":"SMART Sprint"},{"manufacturer":"TSUNAMi","market_name":"Tablet Tsunami TSTA080D1","codename":"MG080D1T","model":"MG080D1T"},{"manufacturer":"TUNTUN English","market_name":"DREAM PAD","codename":"delight","model":"ITP-R408W"},{"manufacturer":"TUPAD","market_name":"TU7_58212_18222","codename":"TU7_58212","model":"TU7_18222"},{"manufacturer":"TaiwanMobile","market_name":"A5C","codename":"A5C","model":"A5C"},{"manufacturer":"TaiwanMobile","market_name":"A6S","codename":"A6S","model":"A6S"},{"manufacturer":"TaiwanMobile","market_name":"Amazing A8","codename":"D78","model":"Amazing A8"},{"manufacturer":"TaiwanMobile","market_name":"Amazing X3","codename":"TX3","model":"Amazing X3"},{"manufacturer":"TaiwanMobile","market_name":"Amazing_A32","codename":"Amazing_A32","model":"Amazing_A32"},{"manufacturer":"TaiwanMobile","market_name":"Amazing_A35","codename":"Amazing_A35","model":"Amazing_A35"},{"manufacturer":"Takara","market_name":"MID 107","codename":"MID107","model":"MID107"},{"manufacturer":"Takara","market_name":"MID210","codename":"MID210","model":"MID210"},{"manufacturer":"Tambo","market_name":"TA-2","codename":"TA-2","model":"TA-2"},{"manufacturer":"Tambo","market_name":"TA-3","codename":"TA-3","model":"TA-3"},{"manufacturer":"Tambo","market_name":"TA-4","codename":"TA-4","model":"TA-4"},{"manufacturer":"Tanoshi","market_name":"TTBKB10-01","codename":"TTBKB10-01","model":"Tanoshi 2-in-1"},{"manufacturer":"Tech 4u","market_name":"Force","codename":"t592_otd_tech_4u_we","model":"Force"},{"manufacturer":"Tech 4u","market_name":"I8","codename":"I8","model":"I8"},{"manufacturer":"Tech 4u","market_name":"S8 Pro","codename":"S8_Pro","model":"S8_Pro"},{"manufacturer":"Tech 4u","market_name":"Tech4U S8","codename":"S8","model":"S8"},{"manufacturer":"Technicolor","market_name":"","codename":"omap4_WT3","model":"T-Hub2"},{"manufacturer":"Technicolor","market_name":"Agile TV","codename":"dwt765mm","model":"AgileTV"},{"manufacturer":"Technicolor","market_name":"Euskaltel","codename":"dci765ekt","model":"cooper"},{"manufacturer":"Technicolor","market_name":"LMT viedtelev\\xc4\\xabzijas iek\\xc4\\x81rta","codename":"dwt765lmt","model":"skipper"},{"manufacturer":"Technicolor","market_name":"NETBOX","codename":"uiw4030dnm","model":"pearl"},{"manufacturer":"Technicolor","market_name":"NETBOX","codename":"uiw4030dnm","model":"uiw4030dnm"},{"manufacturer":"Technicolor","market_name":"Shortcut","codename":"dwt765ltt","model":"Shortcut"},{"manufacturer":"Technicolor","market_name":"Tv Hub","codename":"uzx8020chm","model":"Tv Hub"},{"manufacturer":"Technicolor","market_name":"Wind","codename":"uzw4030wnh","model":"Wind"},{"manufacturer":"Techpad","market_name":"M5Plus","codename":"M5Plus","model":"M5Plus"},{"manufacturer":"Techpad","market_name":"M6","codename":"M6","model":"M6"},{"manufacturer":"Techpad","market_name":"M6 Plus","codename":"M6Plus","model":"M6Plus"},{"manufacturer":"Techpad","market_name":"TECHPAD X5","codename":"F518","model":"Techpad X5"},{"manufacturer":"Techpad","market_name":"TechPad","codename":"TechPad_916","model":"916"},{"manufacturer":"Techpad","market_name":"TechPad 10Y","codename":"TechPad_10Y","model":"TechPad_10Y"},{"manufacturer":"Techpad","market_name":"TechPad 9x","codename":"TechPad_9x","model":"TechPad_9x"},{"manufacturer":"Techpad","market_name":"TechPad_10x","codename":"TechPad_10x","model":"TechPad_10x"},{"manufacturer":"Techpad","market_name":"TechPad_10xx","codename":"TechPad_10xx","model":"TechPad_10xx"},{"manufacturer":"Techpad","market_name":"TechPad_3Gx","codename":"TechPad_3Gx","model":"TechPad_3Gx"},{"manufacturer":"Techpad","market_name":"TechPad_716","codename":"TechPad_716","model":"716"},{"manufacturer":"Techpad","market_name":"TechPad_i700","codename":"Techpad_i700","model":"Techpad_i700"},{"manufacturer":"Tecno","market_name":"A7S","codename":"TECNO-A7S","model":"TECNO-A7S"},{"manufacturer":"Tecno","market_name":"C5","codename":"TECNO-C5","model":"TECNO-C5"},{"manufacturer":"Tecno","market_name":"C7","codename":"TECNO-C7","model":"TECNO-C7"},{"manufacturer":"Tecno","market_name":"C8","codename":"TECNO-C8","model":"TECNO-C8"},{"manufacturer":"Tecno","market_name":"C9","codename":"TECNO-C9","model":"TECNO-C9"},{"manufacturer":"Tecno","market_name":"C9S","codename":"TECNO-C9","model":"TECNO-C9S"},{"manufacturer":"Tecno","market_name":"CAMON CM","codename":"TECNO-CA6","model":"TECNO CA6"},{"manufacturer":"Tecno","market_name":"CAMON I Ace","codename":"TECNO-IN1","model":"TECNO IN1"},{"manufacturer":"Tecno","market_name":"CAMON X","codename":"TECNO-CA7","model":"TECNO CA7"},{"manufacturer":"Tecno","market_name":"CAMON X Pro","codename":"TECNO-CA8","model":"TECNO CA8"},{"manufacturer":"Tecno","market_name":"CAMON X Pro","codename":"TECNO-CA8","model":"TECNO CA8S"},{"manufacturer":"Tecno","market_name":"CAMON iClick","codename":"TECNO-IN6","model":"TECNO IN6"},{"manufacturer":"Tecno","market_name":"CAMON iSky","codename":"TECNO-IN2","model":"TECNO IN2"},{"manufacturer":"Tecno","market_name":"COMAN CM","codename":"TECNO-CA6","model":"TECNO CA6S"},{"manufacturer":"Tecno","market_name":"Camon CX","codename":"TECNO-CX","model":"TECNO Camon CX"},{"manufacturer":"Tecno","market_name":"Camon CX Air","codename":"TECNO-CX-Air","model":"TECNO CX Air"},{"manufacturer":"Tecno","market_name":"Camon CXS","codename":"TECNO-CX","model":"TECNO Camon CXS"},{"manufacturer":"Tecno","market_name":"Camon I","codename":"TECNO-IN5","model":"TECNO IN5"},{"manufacturer":"Tecno","market_name":"Camon I Air","codename":"TECNO-IN3","model":"TECNO IN3"},{"manufacturer":"Tecno","market_name":"Camon i Twin","codename":"TECNO-IA5","model":"TECNO IA5"},{"manufacturer":"Tecno","market_name":"DP10APro-SLA1","codename":"DP10APro","model":"DP10APro"},{"manufacturer":"Tecno","market_name":"DP7CPro-SGA1","codename":"DP7CPro-SGA1","model":"DP7CPro-SGA1"},{"manufacturer":"Tecno","market_name":"DroiPad 10 Pro\\xe2\\x85\\xa1","codename":"DP10APro","model":"DP10APro"},{"manufacturer":"Tecno","market_name":"DroiPad 10D","codename":"TECNO-P904","model":"TECNO P904"},{"manufacturer":"Tecno","market_name":"DroiPad 7C Pro","codename":"DP7CPRO","model":"DP7CPRO"},{"manufacturer":"Tecno","market_name":"DroiPad 7D","codename":"TECNO-P701","model":"TECNO P701"},{"manufacturer":"Tecno","market_name":"DroiPad 7D LTE","codename":"TECNO-P702","model":"TECNO P702A"},{"manufacturer":"Tecno","market_name":"DroiPad 7D ProLTE","codename":"TECNO-P702","model":"TECNO P702"},{"manufacturer":"Tecno","market_name":"DroiPad 7D ProLTE","codename":"TECNO-P702","model":"TECNO P702A"},{"manufacturer":"Tecno","market_name":"DroiPad 8\\xe2\\x85\\xa1","codename":"DP8D","model":"DP8D"},{"manufacturer":"Tecno","market_name":"Droipad10","codename":"DP10A","model":"DP10A"},{"manufacturer":"Tecno","market_name":"Droipad10","codename":"DP10A","model":"TECNO DP10A"},{"manufacturer":"Tecno","market_name":"F1","codename":"TECNO-F1","model":"TECNO F1"},{"manufacturer":"Tecno","market_name":"F2","codename":"TECNO-F2","model":"TECNO F2"},{"manufacturer":"Tecno","market_name":"F2LTE","codename":"TECNO-F2LTE","model":"TECNO F2LTE"},{"manufacturer":"Tecno","market_name":"H5S","codename":"up09_tecno_h5s","model":"TECNO H5S"},{"manufacturer":"Tecno","market_name":"H7S","codename":"qp16_tecno_h7s","model":"H7S"},{"manufacturer":"Tecno","market_name":"J5","codename":"TECNO-J5","model":"TECNO-J5"},{"manufacturer":"Tecno","market_name":"J7","codename":"TECNO-J7","model":"TECNO-J7"},{"manufacturer":"Tecno","market_name":"J8","codename":"TECNO-J8","model":"TECNO-J8"},{"manufacturer":"Tecno","market_name":"L5","codename":"TECNO-L5","model":"TECNO-L5"},{"manufacturer":"Tecno","market_name":"L8","codename":"TECNO-L8","model":"TECNO-L8"},{"manufacturer":"Tecno","market_name":"L8 Lite","codename":"L8Lite","model":"TECNO L8 Lite"},{"manufacturer":"Tecno","market_name":"L8Plus","codename":"TECNO-L8","model":"TECNO-L8Plus"},{"manufacturer":"Tecno","market_name":"L9","codename":"TECNO-L9","model":"TECNO L9"},{"manufacturer":"Tecno","market_name":"L9Plus","codename":"TECNO-L9Plus","model":"TECNO L9 Plus"},{"manufacturer":"Tecno","market_name":"M3","codename":"up11_tecno_m3s","model":"TECNO M3S"},{"manufacturer":"Tecno","market_name":"M6S","codename":"g335_b1","model":"TECNO-M6S"},{"manufacturer":"Tecno","market_name":"N2","codename":"TECNO_N2S","model":"TECNO-N2"},{"manufacturer":"Tecno","market_name":"N2S","codename":"TECNO_N2S","model":"TECNO-N2S"},{"manufacturer":"Tecno","market_name":"N5S","codename":"N5S","model":"TECNO N5S"},{"manufacturer":"Tecno","market_name":"N6","codename":"TECNO-N6","model":"TECNO-N6"},{"manufacturer":"Tecno","market_name":"N6S","codename":"TECNO-N6S","model":"TECNO-N6S"},{"manufacturer":"Tecno","market_name":"N8","codename":"TECNO-N8","model":"TECNO N8"},{"manufacturer":"Tecno","market_name":"N8","codename":"TECNO-N8","model":"TECNO-N8"},{"manufacturer":"Tecno","market_name":"N8R","codename":"N8R","model":"TECNO-N8R"},{"manufacturer":"Tecno","market_name":"N8S","codename":"TECNO-N8S","model":"TECNO-N8S"},{"manufacturer":"Tecno","market_name":"N9","codename":"N9","model":"TECNO-N9"},{"manufacturer":"Tecno","market_name":"N9S","codename":"N9S","model":"TECNO-N9S"},{"manufacturer":"Tecno","market_name":"NX","codename":"TECNO-R8","model":"TECNO R8O"},{"manufacturer":"Tecno","market_name":"NX","codename":"TECNO-R8","model":"TECNO R8S"},{"manufacturer":"Tecno","market_name":"P5","codename":"up08_tecno_p5s","model":"TECNO P5S"},{"manufacturer":"Tecno","market_name":"P702AS","codename":"TECNO-P702","model":"TECNO P702AS"},{"manufacturer":"Tecno","market_name":"PHANTOM-Z-mini","codename":"PTM-Z-mini","model":"PTM-Z-mini"},{"manufacturer":"Tecno","market_name":"PHANTOM5","codename":"TECNO-PHANTOM5","model":"TECNO-PHANTOM5"},{"manufacturer":"Tecno","market_name":"POP 1 Pro","codename":"TECNO-F3-13M","model":"TECNO F3"},{"manufacturer":"Tecno","market_name":"POP1","codename":"TECNO-F3","model":"TECNO F3"},{"manufacturer":"Tecno","market_name":"Phantom6","codename":"Phantom6","model":"Phantom6"},{"manufacturer":"Tecno","market_name":"Phantom6 plus","codename":"Phantom6-Plus","model":"Phantom6-Plus"},{"manufacturer":"Tecno","market_name":"Phantom6S","codename":"Phantom6","model":"Phantom6S"},{"manufacturer":"Tecno","market_name":"Phantom8","codename":"TECNO-AX8","model":"TECNO AX8"},{"manufacturer":"Tecno","market_name":"Phantom8S","codename":"TECNO-AX8","model":"TECNO AX8S"},{"manufacturer":"Tecno","market_name":"PhonePad 3","codename":"TECNO-PP7FPro","model":"TECNO PhonePad 3"},{"manufacturer":"Tecno","market_name":"PhonePad 7 II","codename":"PP7E-DLA1","model":"TECNO PP7E-DLA1"},{"manufacturer":"Tecno","market_name":"PhonePad 7 II","codename":"PP7E-DLA1","model":"TECNO PP7E-SLA1"},{"manufacturer":"Tecno","market_name":"Pouvoir 1","codename":"TECNO-LA6","model":"TECNO LA6"},{"manufacturer":"Tecno","market_name":"Pouvoir 2","codename":"TECNO-LA7","model":"TECNO LA7"},{"manufacturer":"Tecno","market_name":"R6","codename":"TECNO-R6","model":"TECNO R6"},{"manufacturer":"Tecno","market_name":"RA6","codename":"TECNO-RA6","model":"TECNO RA6S"},{"manufacturer":"Tecno","market_name":"S1","codename":"TECNO-S1","model":"TECNO S1"},{"manufacturer":"Tecno","market_name":"S1","codename":"TECNO-S1","model":"TECNO S1M"},{"manufacturer":"Tecno","market_name":"S1 Pro","codename":"TECNO-S1-Pro","model":"TECNO S1 Pro"},{"manufacturer":"Tecno","market_name":"S1 Pro","codename":"TECNO-S1-Pro","model":"TECNO S1E Pro"},{"manufacturer":"Tecno","market_name":"S1E Pro","codename":"TECNO-S1-Pro","model":"TECNO S1E Pro"},{"manufacturer":"Tecno","market_name":"S6","codename":"TECNO-S6S","model":"TECNO S6"},{"manufacturer":"Tecno","market_name":"S6S","codename":"TECNO-S6S","model":"TECNO S6S"},{"manufacturer":"Tecno","market_name":"S6s","codename":"TECNO-S6S","model":"TECNO S6S"},{"manufacturer":"Tecno","market_name":"SA1 Pro","codename":"TECNO-SA1S-PRO","model":"TECNO SA1S Pro"},{"manufacturer":"Tecno","market_name":"SA6","codename":"TECNO-SA6","model":"TECNO SA6"},{"manufacturer":"Tecno","market_name":"SA6","codename":"TECNO-SA6","model":"TECNO SA6S"},{"manufacturer":"Tecno","market_name":"SPARK","codename":"TECNO-K7","model":"TECNO K7"},{"manufacturer":"Tecno","market_name":"SPARK 2","codename":"TECNO-KA7-GO","model":"TECNO KA7"},{"manufacturer":"Tecno","market_name":"SPARK CM","codename":"TECNO-KA9","model":"TECNO KA9"},{"manufacturer":"Tecno","market_name":"SPARK Plus","codename":"TECNO-K9","model":"TECNO K9"},{"manufacturer":"Tecno","market_name":"SPARK Pro","codename":"TECNO-K8","model":"TECNO K8"},{"manufacturer":"Tecno","market_name":"TECNO AX8","codename":"TECNO-AX8","model":"TECNO AX8"},{"manufacturer":"Tecno","market_name":"TECNO CX Air","codename":"TECNO-CX-Air","model":"TECNO CX Air"},{"manufacturer":"Tecno","market_name":"TECNO K7","codename":"TECNO-K7","model":"TECNO K7"},{"manufacturer":"Tecno","market_name":"TECNO K9","codename":"TECNO-K9","model":"TECNO K9"},{"manufacturer":"Tecno","market_name":"TECNO P904","codename":"TECNO-P904","model":"TECNO P904"},{"manufacturer":"Tecno","market_name":"TECNO R6S","codename":"TECNO-R6","model":"TECNO R6S"},{"manufacturer":"Tecno","market_name":"TECNO S1 Lite","codename":"TECNO-S1Lite","model":"TECNO S1 Lite"},{"manufacturer":"Tecno","market_name":"TECNO W5","codename":"TECNO-W5","model":"TECNO-W5"},{"manufacturer":"Tecno","market_name":"TECNO WX4 Pro S","codename":"TECNO-WX4-Pro","model":"TECNO WX4 Pro S"},{"manufacturer":"Tecno","market_name":"TECNO-Y2","codename":"TECNO-Y2","model":"TECNO-Y2"},{"manufacturer":"Tecno","market_name":"TECNO-Y2","codename":"TECNO-Y2","model":"TECNO-Y3+"},{"manufacturer":"Tecno","market_name":"Techno L6","codename":"TECNO-L6","model":"TECNO-L6"},{"manufacturer":"Tecno","market_name":"W1","codename":"TECNO_W1","model":"TECNO W1"},{"manufacturer":"Tecno","market_name":"W2","codename":"TECNO_W2","model":"TECNO W2"},{"manufacturer":"Tecno","market_name":"W3","codename":"TECNO-W3","model":"TECNO-W3"},{"manufacturer":"Tecno","market_name":"W3 Pro","codename":"TECNO-W3Pro","model":"TECNO W3 Pro"},{"manufacturer":"Tecno","market_name":"W3LTE","codename":"TECNO-W3LTE","model":"TECNO-W3LTE"},{"manufacturer":"Tecno","market_name":"W4","codename":"TECNO_W4","model":"TECNO_W4"},{"manufacturer":"Tecno","market_name":"W5","codename":"TECNO-W5","model":"TECNO-W5"},{"manufacturer":"Tecno","market_name":"W5 Lite","codename":"W5Lite","model":"TECNO W5 Lite"},{"manufacturer":"Tecno","market_name":"WX3","codename":"TECNO-WX3","model":"TECNO WX3"},{"manufacturer":"Tecno","market_name":"WX3 FLTE","codename":"TECNO-WX3FLTE","model":"TECNO WX3F LTE"},{"manufacturer":"Tecno","market_name":"WX3F LTE","codename":"TECNO-WX3FLTE","model":"TECNO WX3F LTE"},{"manufacturer":"Tecno","market_name":"WX3LTE","codename":"TECNO-WX3LTE","model":"TECNO WX3LTE"},{"manufacturer":"Tecno","market_name":"WX3P","codename":"TECNO-WX3P","model":"TECNO WX3P"},{"manufacturer":"Tecno","market_name":"WX4","codename":"TECNO-WX4","model":"TECNO WX4"},{"manufacturer":"Tecno","market_name":"WX4 Pro","codename":"TECNO-WX4-Pro","model":"TECNO WX4 Pro"},{"manufacturer":"Tecno","market_name":"WX4 Pro S","codename":"TECNO-WX4-Pro","model":"TECNO WX4 Pro S"},{"manufacturer":"Tecno","market_name":"Y3","codename":"TECNO-Y3","model":"TECNO-Y3"},{"manufacturer":"Tecno","market_name":"Y3+","codename":"TECNO-Y2","model":"TECNO-Y2"},{"manufacturer":"Tecno","market_name":"Y3+","codename":"TECNO-Y2","model":"TECNO-Y3+"},{"manufacturer":"Tecno","market_name":"Y3S","codename":"TECNO-Y3S","model":"TECNO-Y3S"},{"manufacturer":"Tecno","market_name":"Y4","codename":"TECNO-Y4","model":"TECNO-Y4"},{"manufacturer":"Tecno","market_name":"Y5","codename":"TECNO-Y5","model":"TECNO-Y5"},{"manufacturer":"Tecno","market_name":"Y6","codename":"TECNO-Y6","model":"TECNO-Y6"},{"manufacturer":"Tecno","market_name":"i3","codename":"TECNO-i3","model":"TECNO i3"},{"manufacturer":"Tecno","market_name":"i3 Pro","codename":"TECNO-i3-Pro","model":"TECNO i3 Pro"},{"manufacturer":"Tecno","market_name":"i3-Pro","codename":"TECNO-i3-Pro","model":"TECNO i3 Pro"},{"manufacturer":"Tecno","market_name":"i5","codename":"TECNO-i5","model":"TECNO i5"},{"manufacturer":"Tecno","market_name":"i5-Pro","codename":"TECNO-i5-Pro","model":"TECNO i5 Pro"},{"manufacturer":"Tecno","market_name":"i7","codename":"TECNO-i7","model":"TECNO i7"},{"manufacturer":"Teknosa","market_name":"Preo P2","codename":"Preo_P2","model":"Preo_P2"},{"manufacturer":"Tekwind","market_name":"A10A","codename":"A10A","model":"A10A"},{"manufacturer":"Tekwind","market_name":"Clide A10B","codename":"A10B","model":"A10B"},{"manufacturer":"Tekwind","market_name":"TC97RA1","codename":"TC97RA1_1","model":"TC97RA1"},{"manufacturer":"Telcel","market_name":"i50F","codename":"i50F","model":"i50F"},{"manufacturer":"Tele2","market_name":"Maxi","codename":"Tele2_Maxi","model":"Tele2_Maxi"},{"manufacturer":"Tele2","market_name":"Maxi 1.1","codename":"TELE2_Maxi_1_1","model":"TELE2_Maxi_1_1"},{"manufacturer":"Tele2","market_name":"Maxi_Plus","codename":"Tele2_Maxi_Plus","model":"Tele2_Maxi_Plus"},{"manufacturer":"Tele2","market_name":"Midi","codename":"Tele2_Midi","model":"Tele2"},{"manufacturer":"Tele2","market_name":"Midi 1.1","codename":"Tele2_Midi_1_1","model":"Tele2_Midi_1_1"},{"manufacturer":"Tele2","market_name":"Midi LTE","codename":"Tele2_Midi_LTE","model":"Tele2_Midi_LTE"},{"manufacturer":"Tele2","market_name":"Mini","codename":"Tele2_Mini","model":"Tele2_Mini"},{"manufacturer":"Tele2","market_name":"Mini 1.1","codename":"Tele2_Mini_1_1","model":"Tele2_Mini_1.1"},{"manufacturer":"Tele2","market_name":"Mini 1.1","codename":"Tele2_Mini_1_1","model":"Tele2_Mini_1_1"},{"manufacturer":"Tele2","market_name":"Tele 2 Maxi LTE","codename":"Tele2_Maxi_LTE","model":"Tele2_Maxi_LTE"},{"manufacturer":"Tele2","market_name":"Tele2_Midi_2_0","codename":"Tele2_Midi_2_0","model":"Tele2_Midi_2_0"},{"manufacturer":"Tele2","market_name":"Tele2fon V4","codename":"Tele2fon_v4","model":"Tele2fon v4"},{"manufacturer":"Tele2","market_name":"Tele2fon V5","codename":"Tele2fon_v5","model":"Tele2fon v5"},{"manufacturer":"Telecable","market_name":"tedi","codename":"dtiw384","model":"Telecable ATV"},{"manufacturer":"Teleepoch","market_name":"","codename":"MaxBravo","model":"PMI920"},{"manufacturer":"Teleepoch","market_name":"","codename":"U670C","model":"U670C"},{"manufacturer":"Teleepoch","market_name":"","codename":"chaser-921","model":"Chaser"},{"manufacturer":"Teleepoch","market_name":"Essentiel B SmartTab 1002","codename":"T9660R","model":"SmartTAB 1002"},{"manufacturer":"Teleepoch","market_name":"U675","codename":"U675","model":"U675"},{"manufacturer":"Teleepoch","market_name":"UMX U680C","codename":"U680C","model":"U680C"},{"manufacturer":"Telefunken","market_name":"Enjoy TE1","codename":"TE1","model":"TE1"},{"manufacturer":"Telefunken","market_name":"VP73_Telefunken","codename":"Telefunken","model":"VP73_Telefunken"},{"manufacturer":"Telego","market_name":"F8","codename":"F8","model":"F8"},{"manufacturer":"Telemor","market_name":"T9501","codename":"T9501","model":"T9501"},{"manufacturer":"Telemor","market_name":"Telemor T9502","codename":"T9502","model":"Telemor T9502"},{"manufacturer":"Telenor","market_name":"Infinity K","codename":"Infinity_K","model":"Infinity_K"},{"manufacturer":"Telenor","market_name":"Infinity a2","codename":"b3680","model":"Infinity_a2"},{"manufacturer":"Telenor","market_name":"Infinity e2","codename":"i6379","model":"Infinity_e2"},{"manufacturer":"Telenor","market_name":"Infinity e3","codename":"Infinity_e3","model":"Infinity_e3"},{"manufacturer":"Telenor","market_name":"Infinity k2","codename":"Infinity_k2","model":"Infinity_k2"},{"manufacturer":"Telenor","market_name":"Infinity_a","codename":"Telenor_Infinity_a","model":"Infinity_a"},{"manufacturer":"Telenor","market_name":"Infinity_e","codename":"Telenor_Infinity_e","model":"Infinity_e"},{"manufacturer":"Telenor","market_name":"Infinity_i","codename":"TELENOR_Infinity_i","model":"Infinity i"},{"manufacturer":"Telenor","market_name":"K530","codename":"Telenor_K530","model":"Telenor K530"},{"manufacturer":"Telenor","market_name":"N940","codename":"Telenor_N940","model":"Telenor N940"},{"manufacturer":"Telenor","market_name":"Smart","codename":"Telenor_Smart","model":"Telenor_Smart"},{"manufacturer":"Telenor","market_name":"Smart II","codename":"SmartII","model":"SmartII"},{"manufacturer":"Telenor","market_name":"Smart plus II","codename":"SmartPlusII","model":"SmartPlusII"},{"manufacturer":"Telenor","market_name":"Smart4G","codename":"Telenor_Smart_4G","model":"Telenor_Smart_4G"},{"manufacturer":"Telkom","market_name":"Telkom","codename":"DV8219","model":"TVB-100"},{"manufacturer":"TellyTablet","market_name":"VM_MD_001","codename":"VM_MD_001","model":"VM_MD_001"},{"manufacturer":"Telma","market_name":"F1+4G","codename":"TELMA_F1_4G","model":"TELMA F1+4G"},{"manufacturer":"Telma","market_name":"TELMA FEEL","codename":"TELMA_FEEL","model":"TELMA FEEL"},{"manufacturer":"Telma","market_name":"TITAN","codename":"Telma_Titan_4G","model":"Telma_Titan_4G"},{"manufacturer":"Telma","market_name":"Telma EGO","codename":"Telma_EGO","model":"Telma EGO"},{"manufacturer":"Telus","market_name":"Pik TV Media Box","codename":"HMB2213PW22TS","model":"HMB2213PW22TS"},{"manufacturer":"Tesco","market_name":"Hudl 2","codename":"HTF8A4","model":"Hudl 2"},{"manufacturer":"Tesco","market_name":"Hudl HT7S3","codename":"ht7s3","model":"Hudl HT7S3"},{"manufacturer":"Tesco","market_name":"Hudl HT7S3","codename":"ht7s3","model":"hudl ht7s3"},{"manufacturer":"Tesco","market_name":"W032I_C3","codename":"w032i_c3","model":"W032I_C3"},{"manufacturer":"Tesco","market_name":"hudl 2","codename":"HTF8A4","model":"Hudl 2"},{"manufacturer":"Tesla","market_name":"M8.1 3G","codename":"TTM813G","model":"TTM813G"},{"manufacturer":"Tesla","market_name":"Tablet_L7_1","codename":"Tablet_L7_1","model":"Tesla L7.1"},{"manufacturer":"Tesla","market_name":"Tesla Smartphone 3.3","codename":"Tesla_SP3_3","model":"Tesla_SP3.3"},{"manufacturer":"Tesla","market_name":"Tesla Smartphone 6.3","codename":"Tesla_SP6_3","model":"Tesla_SP6.3"},{"manufacturer":"Tesla","market_name":"Tesla Smartphone 9.1","codename":"L6195","model":"Tesla_SP9.1"},{"manufacturer":"Tesla","market_name":"Tesla Smartphone 9.1 Lite","codename":"Tesla_SP9_1_Lite","model":"Tesla_SP9.1L"},{"manufacturer":"Tesla","market_name":"Tesla Tablet L8.1","codename":"Tesla_L8_1","model":"Tesla L8.1"},{"manufacturer":"Tesla","market_name":"Tesla_SP3.3 Lite","codename":"Tesla_SP3_3Lite","model":"Tesla_SP3.3 Lite"},{"manufacturer":"Tesla","market_name":"Tesla_SP9.1","codename":"L6195","model":"Tesla_SP9.1"},{"manufacturer":"Tetratab","market_name":"TF10EA2","codename":"TF10EA2_Medical_1","model":"CASEBOOK_3"},{"manufacturer":"Thinpad","market_name":"TH805","codename":"TH805","model":"TH805"},{"manufacturer":"Thomson","market_name":"Delight TH201","codename":"Delight_TH201","model":"Delight TH201"},{"manufacturer":"Thomson","market_name":"Friendly TH101","codename":"Friendly_TH101","model":"Friendly_TH101"},{"manufacturer":"Thomson","market_name":"PRIMO7 Tablet","codename":"PRIMO7","model":"PRIMO7"},{"manufacturer":"Thomson","market_name":"PRIMO8 Tablet","codename":"AMLMY8306P","model":"PRIMO8"},{"manufacturer":"Thomson","market_name":"TCL  Percee TV","codename":"tcl_eu","model":"Percee TV"},{"manufacturer":"Thomson","market_name":"TEO10","codename":"TEO10","model":"SPTEO10BK16"},{"manufacturer":"Thomson","market_name":"TEO7RK","codename":"TEO7RK","model":"TEO7RK"},{"manufacturer":"Thomson","market_name":"TLink 455","codename":"TLINK455","model":"TLINK455"},{"manufacturer":"Thuraya","market_name":"Thuraya X5-Touch","codename":"X5-Touch","model":"Thuraya X5-Touch"},{"manufacturer":"Tiitan","market_name":"T54","codename":"T54","model":"T54"},{"manufacturer":"Time2","market_name":"TIME2","codename":"TP1060J","model":"TP1060J"},{"manufacturer":"Time2","market_name":"TIME2","codename":"TP860P","model":"TP860B"},{"manufacturer":"Timmy","market_name":"M40_plus","codename":"M40_plus","model":"M40_plus"},{"manufacturer":"Timmy","market_name":"M40_pro","codename":"M40_pro","model":"M40_pro"},{"manufacturer":"Timmy","market_name":"M68_Plus","codename":"M68_Plus","model":"M68_Plus"},{"manufacturer":"Timovi","market_name":"Infinit Lite 2","codename":"Timovi_Infinit_Lite_2","model":"Infinit_Lite_2"},{"manufacturer":"Timovi","market_name":"Infinit MX Pro","codename":"Infinit_MX_Pro","model":"Infinit MX Pro"},{"manufacturer":"Timovi","market_name":"Insignia Delta 2","codename":"Insignia_Delta_2","model":"Insignia Delta 2"},{"manufacturer":"Timovi","market_name":"Timovi Infinit MX","codename":"Timovi_Infinit_MX","model":"Infinit MX"},{"manufacturer":"Timovi","market_name":"Timovi Infinit X CAM","codename":"Timovi_Infinit_X_CAM","model":"Infinit_X_CAM"},{"manufacturer":"Timovi","market_name":"Timovi_Vision_PRO","codename":"Timovi_Vision_PRO","model":"Vision_PRO"},{"manufacturer":"Timovi","market_name":"VISION ULTRA","codename":"VISION_ULTRA","model":"VISION ULTRA"},{"manufacturer":"Tinhvan","market_name":"TA80TA1","codename":"TA80TA1_1","model":"TA80TA1"},{"manufacturer":"Tinmo","market_name":"K1","codename":"K1","model":"K1"},{"manufacturer":"Tiwell","market_name":"AP-115G","codename":"AP-115G","model":"AP-115G"},{"manufacturer":"Tiwell","market_name":"AS-501","codename":"AS_501","model":"AS_501"},{"manufacturer":"Tiwell","market_name":"AS-502","codename":"t662_dh4_tiwell","model":"AS-502"},{"manufacturer":"Tiwell","market_name":"AS-503","codename":"t662_gq_tiwell","model":"AS-503"},{"manufacturer":"Tobii DynaVox","market_name":"T10+","codename":"T10plus","model":"T10+"},{"manufacturer":"Tobii DynaVox","market_name":"T7","codename":"T7","model":"T7"},{"manufacturer":"Tonino Lamborghini","market_name":"Antares","codename":"TL66","model":"TL66"},{"manufacturer":"Tonino Lamborghini","market_name":"Antares","codename":"TL_Antares","model":"Antares"},{"manufacturer":"Tonino Lamborghini","market_name":"TL99","codename":"ailsa_ii","model":"TL99"},{"manufacturer":"Tonino Lamborghini","market_name":"TL99G","codename":"ailsa_ii","model":"TL99G"},{"manufacturer":"Toshiba","market_name":"","codename":"WDPF-703TI","model":"Hikari-iFrame/WDPF-703TI"},{"manufacturer":"Toshiba","market_name":"","codename":"tosebook01","model":"DB50"},{"manufacturer":"Toshiba","market_name":"","codename":"tostab05","model":"AT200"},{"manufacturer":"Toshiba","market_name":"","codename":"tostabg1","model":"LT170"},{"manufacturer":"Toshiba","market_name":"A204","codename":"tos14ast10","model":"A204"},{"manufacturer":"Toshiba","market_name":"A205","codename":"tos15ast20","model":"A205"},{"manufacturer":"Toshiba","market_name":"AT10-A/AT15-A (Japan: AT503)","codename":"tostab12BL","model":"AT10-A"},{"manufacturer":"Toshiba","market_name":"AT10-A/AT15-A (Japan: AT503)","codename":"tostab12BL","model":"AT502"},{"manufacturer":"Toshiba","market_name":"AT10-A/AT15-A (Japan: AT503)","codename":"tostab12BL","model":"AT503"},{"manufacturer":"Toshiba","market_name":"AT10-A/AT15-A (Japan: AT503)","codename":"tostab12BL","model":"AT503_HEMS"},{"manufacturer":"Toshiba","market_name":"AT100","codename":"tostab03","model":"AT100"},{"manufacturer":"Toshiba","market_name":"AT100","codename":"tostab03","model":"Tostab03"},{"manufacturer":"Toshiba","market_name":"AT10LE-A/AT15LE-A/AT10PE-A/AT15PE-A  (Japan: AT703)","codename":"tostab12BA","model":"AT10LE-A"},{"manufacturer":"Toshiba","market_name":"AT10LE-A/AT15LE-A/AT10PE-A/AT15PE-A  (Japan: AT703)","codename":"tostab12BA","model":"AT10PE-A"},{"manufacturer":"Toshiba","market_name":"AT10LE-A/AT15LE-A/AT10PE-A/AT15PE-A  (Japan: AT703)","codename":"tostab12BA","model":"AT702"},{"manufacturer":"Toshiba","market_name":"AT10LE-A/AT15LE-A/AT10PE-A/AT15PE-A  (Japan: AT703)","codename":"tostab12BA","model":"AT703"},{"manufacturer":"Toshiba","market_name":"AT400","codename":"tostab12AL","model":"AT300SE"},{"manufacturer":"Toshiba","market_name":"AT400","codename":"tostab12AL","model":"AT400"},{"manufacturer":"Toshiba","market_name":"AT7-A","codename":"tost7t","model":"AT374"},{"manufacturer":"Toshiba","market_name":"AT7-A","codename":"tost7t","model":"AT7-A"},{"manufacturer":"Toshiba","market_name":"AT7-B","codename":"tos13t7gt","model":"AT374"},{"manufacturer":"Toshiba","market_name":"AT7-B","codename":"tos13t7gt","model":"AT7-B"},{"manufacturer":"Toshiba","market_name":"AT7-C","codename":"tos14riy20","model":"A17"},{"manufacturer":"Toshiba","market_name":"AT7-C","codename":"tos14riy20","model":"AT7-C"},{"manufacturer":"Toshiba","market_name":"JP:REGZA Tablet AT570  Others:TOSHIBA AT270","codename":"tostab11BS","model":"AT270"},{"manufacturer":"Toshiba","market_name":"JP:REGZA Tablet AT570  Others:TOSHIBA AT270","codename":"tostab11BS","model":"AT470"},{"manufacturer":"Toshiba","market_name":"JP:REGZA Tablet AT570  Others:TOSHIBA AT270","codename":"tostab11BS","model":"AT570"},{"manufacturer":"Toshiba","market_name":"JPN:REGZA Tablet AT500  Other countries:TOSHIBA AT300","codename":"tostab11BA","model":"AT300"},{"manufacturer":"Toshiba","market_name":"JPN:REGZA Tablet AT500  Other countries:TOSHIBA AT300","codename":"tostab11BA","model":"AT500"},{"manufacturer":"Toshiba","market_name":"JPN:REGZA Tablet AT500  Other countries:TOSHIBA AT300","codename":"tostab11BA","model":"AT500a"},{"manufacturer":"Toshiba","market_name":"JPN:REGZA Tablet AT830 Other countries:TOSHIBA AT330","codename":"tostab11BT","model":"AT330"},{"manufacturer":"Toshiba","market_name":"JPN:REGZA Tablet AT830 Other countries:TOSHIBA AT330","codename":"tostab11BT","model":"AT830"},{"manufacturer":"Toshiba","market_name":"L4300","codename":"l4300","model":"l4300"},{"manufacturer":"Toshiba","market_name":"L5450","codename":"tostv14rtk1","model":"l5400"},{"manufacturer":"Toshiba","market_name":"L5450","codename":"tostv14rtk1","model":"l5450"},{"manufacturer":"Toshiba","market_name":"L5450/L5400","codename":"tostv14rtk1","model":"l5400"},{"manufacturer":"Toshiba","market_name":"L5450/L5400","codename":"tostv14rtk1","model":"l5450"},{"manufacturer":"Toshiba","market_name":"L5450/L5400","codename":"tostv14rtk2","model":"l5400"},{"manufacturer":"Toshiba","market_name":"L5450/L5400","codename":"tostv14rtk2","model":"l5450"},{"manufacturer":"Toshiba","market_name":"L5450C","codename":"l5450","model":"l3453"},{"manufacturer":"Toshiba","market_name":"L5450C","codename":"l5450","model":"l5450"},{"manufacturer":"Toshiba","market_name":"L5450ME","codename":"tostv14rtk2","model":"l5400"},{"manufacturer":"Toshiba","market_name":"L5450ME","codename":"tostv14rtk2","model":"l5450"},{"manufacturer":"Toshiba","market_name":"L5550/L5551/L5552","codename":"tostv15rtk2","model":"l5550"},{"manufacturer":"Toshiba","market_name":"L9450","codename":"l9450","model":"l9450"},{"manufacturer":"Toshiba","market_name":"Mozart","codename":"Mozart","model":"Mozart"},{"manufacturer":"Toshiba","market_name":"STB10","codename":"TOSPASB","model":"TOSPASB"},{"manufacturer":"Toshiba","market_name":"Thrive 7","codename":"tostab04","model":"AT1S0"},{"manufacturer":"Toshiba","market_name":"Toshiba Chromebook 2 (2015 Edition)","codename":"gandof_cheets","model":"Toshiba Chromebook 2 (2015 Edition)"},{"manufacturer":"Toshiba","market_name":"tt300/tt301/tt302","codename":"Mozart","model":"Mozart"},{"manufacturer":"Toughshield","market_name":"R200","codename":"R200","model":"R200"},{"manufacturer":"Toughshield","market_name":"T700_TABLET","codename":"T700_TABLET","model":"T700"},{"manufacturer":"Trekstor","market_name":"SurfTab ST70204-3","codename":"TREKM7100KLD","model":"SurfTab ST70204-3"},{"manufacturer":"Trekstor","market_name":"SurfTab breeze 9.6 quad","codename":"SurfTab","model":"TrekStor SurfTab breeze 9.6 quad"},{"manufacturer":"Trekstor","market_name":"SurfTab breeze 9.6 quad 3G","codename":"ST9641602","model":"TrekStor SurfTab breeze 9.6 quad 3G"},{"manufacturer":"Trekstor","market_name":"SurfTab breeze 9.6 quad 3G","codename":"ST9643203","model":"TrekStor SurfTab breeze 9.6 quad 3G"},{"manufacturer":"Trekstor","market_name":"SurfTab xintron i 7.0","codename":"st70408_4_coho","model":"st70408_4"},{"manufacturer":"Trekstor","market_name":"SurfTab xintron i 7.0","codename":"st70408_4_coho","model":"st70408_4_coho"},{"manufacturer":"Trekstor","market_name":"tolino tab 7","codename":"tolino7","model":"tolino tab 7"},{"manufacturer":"Trekstor","market_name":"tolino tab 8","codename":"tolino8","model":"tolino tab 8"},{"manufacturer":"Trekstor","market_name":"tolino tab 8.9","codename":"tolino89","model":"tolino tab 8.9"},{"manufacturer":"Trend Mobile","market_name":"ECHO","codename":"Trend_Echo","model":"Trend Echo"},{"manufacturer":"Trend Solar","market_name":"TS-X","codename":"TRENDPHONE2_0","model":"TS-X"},{"manufacturer":"Trevi","market_name":"Retailer Stores","codename":"KID_TAB_7_S02","model":"KID_TAB_7_S02"},{"manufacturer":"Trimble Navigation","market_name":"MM50","codename":"EE773X_4G","model":"MobileMapper50_4G"},{"manufacturer":"Trimble Navigation","market_name":"MM50","codename":"EE773X_4G","model":"TDC100_4G"},{"manufacturer":"Trimble Navigation","market_name":"MM50","codename":"EE773X_WiFi","model":"MobileMapper50_WiFi"},{"manufacturer":"Trimble Navigation","market_name":"MM50","codename":"EE773X_WiFi","model":"TDC100_WiFi"},{"manufacturer":"Trimble Navigation","market_name":"PeopleNet ConnectedTablet","codename":"MS5","model":"MS5"},{"manufacturer":"Trimble Navigation","market_name":"TD-520","codename":"td520","model":"TD520"},{"manufacturer":"Trimble Navigation","market_name":"TDC100_WiFi","codename":"EE773X_WiFi","model":"MobileMapper50_WiFi"},{"manufacturer":"Trimble Navigation","market_name":"TDC100_WiFi","codename":"EE773X_WiFi","model":"TDC100_WiFi"},{"manufacturer":"Trimble Navigation","market_name":"TDC500 Handheld","codename":"workhorse","model":"TDC500"},{"manufacturer":"Trimble Navigation","market_name":"TDC500 Handheld","codename":"workhorse_wifi","model":"TDC500"},{"manufacturer":"Trimble Navigation","market_name":"TDC800 Handheld","codename":"pelican","model":"TDC800"},{"manufacturer":"Trimble Navigation","market_name":"TDC800 Handheld","codename":"pelican_wifi","model":"TDC800"},{"manufacturer":"Trimble Navigation","market_name":"TDI 600","codename":"ulmo_pro","model":"Rugged Tablet"},{"manufacturer":"Trimble Navigation","market_name":"TDI 600","codename":"ulmo_pro","model":"TDI 600"},{"manufacturer":"Trimble Navigation","market_name":"Trimble ConnectedTablet","codename":"MS5","model":"MS5"},{"manufacturer":"Trio","market_name":"7.85","codename":"astar-y3","model":"TRIO-7.85"},{"manufacturer":"Trio","market_name":"7.85 vQ","codename":"Trio-785-vQ","model":"Trio 7.85 vQ"},{"manufacturer":"Trio","market_name":"AXS 3G","codename":"Trio_AXS_3G","model":"Trio AXS 3G"},{"manufacturer":"Trio","market_name":"MINI","codename":"Trio-MINI","model":"Trio MINI"},{"manufacturer":"Trio","market_name":"MST711","codename":"nuclear-MST711","model":"MST711"},{"manufacturer":"Trio","market_name":"Stealth G4 7","codename":"Trio-Stealth-G4-7","model":"Trio-Stealth-G4-7"},{"manufacturer":"Trio","market_name":"Stealth-G4-101","codename":"Trio-Stealth-G4-101","model":"Trio-Stealth G4 10.1"},{"manufacturer":"Trio","market_name":"Stealth-G4-7.85","codename":"Trio-Stealth-G4-785","model":"Trio-Stealth-G4-7.85"},{"manufacturer":"True","market_name":"SMART 4G Adventure","codename":"SMART_4G_ADVENTURE","model":"SMART 4G Adventure"},{"manufacturer":"True","market_name":"\"SMART 4G GEN C 4.0\"\"\"","codename":"SMART_4G_GEN_C_4","model":"SMART 4G GEN C 4.0"},{"manufacturer":"True","market_name":"\"SMART 4G GEN C 5.0\"\"\"","codename":"SMART_4G_GEN_C_5","model":"SMART 4G GEN C 5.0"},{"manufacturer":"True","market_name":"SMART 4G M1","codename":"SMART_4G_M1","model":"SMART 4G M1"},{"manufacturer":"True","market_name":"SMART 4G M1 Plus","codename":"SMART_4G_M1_Plus","model":"SMART 4G M1 Plus"},{"manufacturer":"True","market_name":"SMART 4G Octa 5.5","codename":"M636T","model":"SMART 4G Octa 5.5"},{"manufacturer":"True","market_name":"SMART TAB 4G M1","codename":"SMART_TAB_4G_M1","model":"SMART TAB 4G M1"},{"manufacturer":"True","market_name":"SMART_4G_GEN_C_5.5","codename":"SMART_4G_GEN_C_5_5","model":"SMART 4G GEN C 5.5"},{"manufacturer":"True","market_name":"SMART_Champ_4inch","codename":"SMART_Champ_4inch","model":"SMART Champ 4.0"},{"manufacturer":"True","market_name":"SMART_MAX_4.0_PLUS","codename":"P909","model":"SMART_MAX_4.0_PLUS"},{"manufacturer":"Tunisie Telecom","market_name":"Star Trail by TT","codename":"startrail3_tt","model":"StarTrail TT"},{"manufacturer":"Turbokids","market_name":"Princess","codename":"Princess","model":"Princess"},{"manufacturer":"Turbokids","market_name":"Turbokids-TMNT","codename":"Turbokids_TMNT","model":"Turbokids-TMNT"},{"manufacturer":"Turbokids","market_name":"TurbokidsP","codename":"TurbokidsP","model":"TurbokidsP"},{"manufacturer":"Turbonet","market_name":"ADR1776","codename":"ADR1776","model":"ADR1776"},{"manufacturer":"Turbonet","market_name":"TN451A1","codename":"TN451A1","model":"TN451A1"},{"manufacturer":"Turbonet","market_name":"TN451A1","codename":"TN451A1-RF","model":"TN451A1"},{"manufacturer":"Turbonet","market_name":"TN500A1","codename":"TN500A1","model":"TN500A1"},{"manufacturer":"Turbonet","market_name":"TN500A2","codename":"TN500A2","model":"TN500A2"},{"manufacturer":"Turbonet","market_name":"TurboTab E1","codename":"TN800A1","model":"TN800A1"},{"manufacturer":"Turbopad","market_name":"S5","codename":"S5","model":"S5"},{"manufacturer":"Turbopad","market_name":"TurboX","codename":"TurboX_Ray","model":"TurboX_Ray"},{"manufacturer":"Turbopad","market_name":"Turbopad1016","codename":"Turbopad1016","model":"Turbopad1016"},{"manufacturer":"Turk Telekom","market_name":"E4","codename":"722T","model":"E4"},{"manufacturer":"UNILORIN","market_name":"UNI10IN","codename":"UNI10IN","model":"UNI10IN"},{"manufacturer":"UNOWHY","market_name":"QOOQ","codename":"QOOQ","model":"QOOQ"},{"manufacturer":"UNOWHY","market_name":"QOOQ","codename":"QOOQ-V41","model":"QOOQ-V41"},{"manufacturer":"UNOWHY","market_name":"SQOOL-V4","codename":"SQOOL-V4","model":"SQOOL-V4"},{"manufacturer":"UNOWHY","market_name":"UNOWHY","codename":"QOOQ-V50","model":"QOOQ-V50"},{"manufacturer":"UNOWHY","market_name":"UNOWHY","codename":"SQOOL-V41","model":"SQOOL-V41"},{"manufacturer":"USA111","market_name":"IRULU X11","codename":"iRULU-X11","model":"iRULU X11"},{"manufacturer":"USA111","market_name":"IRULU X9","codename":"X9","model":"X9"},{"manufacturer":"USA111","market_name":"Irulu X7","codename":"X7","model":"X7"},{"manufacturer":"USA111","market_name":"iRULU V3","codename":"iRULU_V3","model":"iRULU_V3"},{"manufacturer":"USA111","market_name":"iRULU V3","codename":"iRULU_V3i","model":"iRULU_V3"},{"manufacturer":"USA111","market_name":"iRULU_V4","codename":"iRULU","model":"V4"},{"manufacturer":"Ubiquiti","market_name":"USS","codename":"grizzlies_telefi4wm","model":"USS"},{"manufacturer":"Ubiquiti","market_name":"UVP","codename":"capri_ubq_telefi5","model":"UVP"},{"manufacturer":"Ubiquiti","market_name":"UVP Executive","codename":"capri_ubq_telefi7","model":"UVP Executive"},{"manufacturer":"Ubiquiti","market_name":"UVP Pro","codename":"capri_ubq_telefi5p","model":"UVP Pro"},{"manufacturer":"Ubiquiti","market_name":"UVP-X","codename":"grizzlies_telefi4x","model":"UVP-X"},{"manufacturer":"Ubiquiti","market_name":"UVP-X","codename":"grizzlies_telefi4xp","model":"UVP-X"},{"manufacturer":"Ulefone","market_name":"Armor 2","codename":"Armor_2","model":"Armor_2"},{"manufacturer":"Ulefone","market_name":"Armor 2S","codename":"Armor_2S","model":"Armor_2S"},{"manufacturer":"Ulefone","market_name":"MIX","codename":"t816_gq_ulefone","model":"MIX"},{"manufacturer":"Ulefone","market_name":"MIX S","codename":"t815_gq_ulefone","model":"MIX_S"},{"manufacturer":"Ulefone","market_name":"MIX_2","codename":"MIX_2","model":"MIX_2"},{"manufacturer":"Ulefone","market_name":"Power 2","codename":"Power_2","model":"Power_2"},{"manufacturer":"Ulefone","market_name":"Power 3","codename":"Power_3","model":"Power_3"},{"manufacturer":"Ulefone","market_name":"Power 3S","codename":"Power_3S","model":"Power 3S"},{"manufacturer":"Ulefone","market_name":"S7","codename":"t662_gq_n1616_we","model":"Ulefone S7"},{"manufacturer":"Ulefone","market_name":"S7","codename":"t662_gq_ulefone","model":"Ulefone S7"},{"manufacturer":"Ulefone","market_name":"S8","codename":"S8","model":"Ulefone S8"},{"manufacturer":"Ulefone","market_name":"S8 Pro","codename":"S8_Pro","model":"S8_Pro"},{"manufacturer":"Ulefone","market_name":"S8_","codename":"S8","model":"Ulefone S8"},{"manufacturer":"Ulefone","market_name":"S8_Pro","codename":"S8_pro1","model":"S8_Pro"},{"manufacturer":"Ulefone","market_name":"T1","codename":"Ulefone_T1","model":"T1"},{"manufacturer":"Umax","market_name":"UMAX","codename":"visionbook_P55_LTE","model":"visionbook P55 LTE"},{"manufacturer":"Umax","market_name":"VisionBook P50 Plus LTE","codename":"P50Plus_LTE","model":"VisionBook_P50Plus_LTE"},{"manufacturer":"Umax","market_name":"VisionBook P55 X2 LTE","codename":"VisionBook_P55_X2_LTE","model":"VisionBook P55 X2 LTE"},{"manufacturer":"Umax","market_name":"VisionBook10Q","codename":"VB_10Q_Plus","model":"VB_10Q_Plus"},{"manufacturer":"Umax","market_name":"VisionBook_P55_LTE_Pro","codename":"VisionBook_P55_LTE_Pro","model":"VisionBook P55 LTE Pro"},{"manufacturer":"Umidigi","market_name":"S2PRO","codename":"S2_PRO","model":"S2_PRO"},{"manufacturer":"Umix","market_name":"Lite L","codename":"UMIX_LITE_L","model":"UMIX LITE L"},{"manufacturer":"Umix","market_name":"Lite M","codename":"UMIX_LITE_M","model":"UMIX LITE M"},{"manufacturer":"Umix","market_name":"Lite XL","codename":"UMIX_LITE_XL","model":"UMIX LITE XL"},{"manufacturer":"Umix","market_name":"Vinci M","codename":"UMIX_VINCI_M","model":"UMIX VINCI M"},{"manufacturer":"Umx(Ultimate Mobile Experience)","market_name":"U2VR","codename":"U2VR","model":"U2VR"},{"manufacturer":"Umx(Ultimate Mobile Experience)","market_name":"U673C","codename":"U673C","model":"U673C"},{"manufacturer":"Uneone","market_name":"SD50","codename":"SD50","model":"SD50"},{"manufacturer":"Uneone","market_name":"SD55","codename":"UNEONE_SD55","model":"SD55"},{"manufacturer":"Uneone","market_name":"SD80","codename":"SD80","model":"SD80"},{"manufacturer":"Usha Shriram","market_name":"RA_1_GENIUS_STAR","codename":"RA_1_GENIUS_STAR","model":"RA_1_GENIUS_STAR"},{"manufacturer":"Utopia","market_name":"UH0342  UHTABLET10.1INCH","codename":"UH0342","model":"UH0342"},{"manufacturer":"V7","market_name":"Zyro","codename":"zyro","model":"V7 Zyro"},{"manufacturer":"VAIO","market_name":"VA-10J","codename":"VA-10J","model":"JCI VA-10J"},{"manufacturer":"VAIO","market_name":"VPA051","codename":"VPA051","model":"VPA051"},{"manufacturer":"VENSTAR","market_name":"VENSTAR2050","codename":"VENSTAR2050","model":"VENSTAR2050"},{"manufacturer":"VIBE Z","market_name":"K910","codename":"kitonw","model":"Lenovo K910"},{"manufacturer":"VSN","market_name":"V.35","codename":"up11_h1_vsn","model":"V.35"},{"manufacturer":"VT","market_name":"MB300","codename":"MB300","model":"SmartTV"},{"manufacturer":"Vava","market_name":"V1","codename":"V1","model":"V1"},{"manufacturer":"Vava","market_name":"V1 Plus","codename":"V1_Plus","model":"V1 Plus"},{"manufacturer":"Vava","market_name":"V2","codename":"V2","model":"V2"},{"manufacturer":"Vava","market_name":"XP3","codename":"XP3","model":"XP3"},{"manufacturer":"Vaxcare","market_name":"VAX114","codename":"VAX114","model":"VAX114"},{"manufacturer":"Venturer","market_name":"i7","codename":"RCT6773W22","model":"i7"},{"manufacturer":"Venus","market_name":"V5Plus","codename":"V5_Plus","model":"V5_Plus"},{"manufacturer":"Venus","market_name":"V5Plus Lite","codename":"V5_Plus_Lite","model":"V5_Plus_Lite"},{"manufacturer":"Venus","market_name":"V5_Plus_","codename":"V5_Plus_","model":"V5_Plus_"},{"manufacturer":"VerD","market_name":"E1","codename":"E1","model":"E1"},{"manufacturer":"Verizon Wireless","market_name":"Ellipsis 10","codename":"QTAIR7","model":"QTAIR7"},{"manufacturer":"Verizon Wireless","market_name":"Ellipsis 7","codename":"QMV7A","model":"QMV7A"},{"manufacturer":"Verizon Wireless","market_name":"Ellipsis 7","codename":"QMV7A","model":"QMV7B"},{"manufacturer":"Verizon Wireless","market_name":"Ellipsis 7 (QMV7A)","codename":"QMV7A","model":"QMV7A"},{"manufacturer":"Verizon Wireless","market_name":"Ellipsis 7 (QMV7B)","codename":"QMV7A","model":"QMV7B"},{"manufacturer":"Verizon Wireless","market_name":"Ellipsis 8","codename":"QTAQZ3","model":"QTAQZ3"},{"manufacturer":"Verizon Wireless","market_name":"Ellipsis 8 HD","codename":"QTASUN1","model":"QTASUN1"},{"manufacturer":"Verizon Wireless","market_name":"Ellipsis 8 HD","codename":"QTASUN1","model":"QTASUN2"},{"manufacturer":"Verizon Wireless","market_name":"Ellipsis \\xc2\\xae 10 HD","codename":"QTAXIA1","model":"QTAXIA1"},{"manufacturer":"Verizon Wireless","market_name":"Gizmo Tab","codename":"QTASUN2","model":"QTASUN2"},{"manufacturer":"Verizon Wireless","market_name":"QTAQZ3KID","codename":"QTAQZ3KID","model":"QTAQZ3KID"},{"manufacturer":"Verizon Wireless","market_name":"Wear24","codename":"dorado","model":"Wear24"},{"manufacturer":"Verizon Wireless","market_name":"ZenPad Z8","codename":"P008","model":"P008"},{"manufacturer":"Vernee","market_name":"M5","codename":"vernee_M5","model":"vernee_M5"},{"manufacturer":"Vernee","market_name":"M6","codename":"M6","model":"M6"},{"manufacturer":"Vernee","market_name":"MIX 2","codename":"M2","model":"M2"},{"manufacturer":"Vernee","market_name":"MIX 2","codename":"M2_PRO","model":"M2"},{"manufacturer":"Vernee","market_name":"Thor E","codename":"Thor_E","model":"Thor E"},{"manufacturer":"Vernee","market_name":"Thor Plus","codename":"Thor_Plus","model":"Thor Plus"},{"manufacturer":"Vernee","market_name":"V1","codename":"V1","model":"V1"},{"manufacturer":"Vernee","market_name":"X1","codename":"X1","model":"X1"},{"manufacturer":"Vernee","market_name":"X1","codename":"X1_PRO","model":"X1"},{"manufacturer":"Verssed","market_name":"FW8977-ED","codename":"FW8977-ED","model":"FW8977-ED"},{"manufacturer":"Vertex","market_name":"BLK3D","codename":"BLK3D","model":"BLK3D"},{"manufacturer":"Vertex","market_name":"CS24","codename":"CS24","model":"CS24"},{"manufacturer":"Vertex","market_name":"CS28","codename":"CS28","model":"CS28"},{"manufacturer":"Vertex","market_name":"EF","codename":"EF","model":"EF"},{"manufacturer":"Vertex","market_name":"EO","codename":"EO","model":"EO"},{"manufacturer":"Vertex","market_name":"ET","codename":"ET","model":"ET"},{"manufacturer":"Vertex","market_name":"Impress Action","codename":"Impress_Action","model":"Impress_Action"},{"manufacturer":"Vertex","market_name":"Impress Click (3G)","codename":"IMPRESS_CLICK","model":"IMPRESS CLICK"},{"manufacturer":"Vertex","market_name":"Impress Dune","codename":"Impress_Dune","model":"Impress_Dune"},{"manufacturer":"Vertex","market_name":"Impress Eagle","codename":"Impress_Eagle","model":"Impress_Eagle"},{"manufacturer":"Vertex","market_name":"Impress Fortune","codename":"Impress_Fortune","model":"Impress_Fortune"},{"manufacturer":"Vertex","market_name":"Impress Grip","codename":"Grip","model":"Impress_Grip"},{"manufacturer":"Vertex","market_name":"Impress Groove","codename":"Impress_Groove","model":"Impress_Groove"},{"manufacturer":"Vertex","market_name":"Impress Lightning","codename":"Impress_Lightning","model":"Impress_Lightning"},{"manufacturer":"Vertex","market_name":"Impress Lion (3G)","codename":"Impress_Lion_3G","model":"Impress_Lion_3G"},{"manufacturer":"Vertex","market_name":"Impress Lion (4G)","codename":"Impress_Lion_4G","model":"Impress_Lion_4G"},{"manufacturer":"Vertex","market_name":"Impress Lotus","codename":"Impress_Lotus","model":"Impress_Lotus"},{"manufacturer":"Vertex","market_name":"Impress Luck","codename":"Impress_Luck","model":"Impress_Luck"},{"manufacturer":"Vertex","market_name":"Impress Play (4G)","codename":"Impress_Play","model":"Impress_Play"},{"manufacturer":"Vertex","market_name":"Impress Ra (4G)","codename":"Impress_Ra","model":"Impress_Ra"},{"manufacturer":"Vertex","market_name":"Impress Razor","codename":"Impress_Razor","model":"Impress_Razor"},{"manufacturer":"Vertex","market_name":"Impress Saturn","codename":"Impress_Saturn","model":"Impress_Saturn"},{"manufacturer":"Vertex","market_name":"Impress Spring (4G)","codename":"Impress_Spring","model":"Impress_Spring"},{"manufacturer":"Vertex","market_name":"Impress Sun","codename":"Sun","model":"Sun"},{"manufacturer":"Vertex","market_name":"Impress Tiger","codename":"Tiger","model":"Tiger"},{"manufacturer":"Vertex","market_name":"Impress Tor","codename":"Impress_Tor","model":"Impress_Tor"},{"manufacturer":"Vertex","market_name":"Impress_Bear","codename":"Impress_Bear","model":"Impress_Bear"},{"manufacturer":"Vertex","market_name":"Impress_Disco","codename":"Impress_Disco","model":"Impress Disco"},{"manufacturer":"Vertex","market_name":"Impress_Frost","codename":"Impress_Frost","model":"Impress_Frost"},{"manufacturer":"Vertex","market_name":"Impress_Lagune","codename":"Impress_Lagune","model":"Impress_Lagune"},{"manufacturer":"Vertex","market_name":"Impress_Wolf","codename":"Impress_Wolf","model":"Impress_Wolf"},{"manufacturer":"Vertex","market_name":"Lion_Dual","codename":"Lion_Dual","model":"Lion_Dual"},{"manufacturer":"Vertex","market_name":"Tab_4G_10_1","codename":"Tab_4G_10-1","model":"Tab 4G 10-1"},{"manufacturer":"Vertex","market_name":"Tab_4G_8-1","codename":"Tab_4G_8-1","model":"Tab 4G 8-1"},{"manufacturer":"Vertex","market_name":"Vertex Tab 3G 7-1","codename":"Tab_3G_7_1","model":"Tab_3G_7-1"},{"manufacturer":"Vertex","market_name":"Vertex Tab 3G 7-2","codename":"Vertex_Tab","model":"Tab 3G 7-2"},{"manufacturer":"Vertu","market_name":"Aster","codename":"alexa","model":"Aster"},{"manufacturer":"Vertu","market_name":"Aster T","codename":"alexa","model":"Aster T"},{"manufacturer":"Vertu","market_name":"Constellation V","codename":"gambit","model":"Constellation V"},{"manufacturer":"Vertu","market_name":"Constellation X","codename":"tron","model":"CONSTELLATION X"},{"manufacturer":"Vertu","market_name":"Signature Touch","codename":"odin","model":"Signature Touch"},{"manufacturer":"Vertu","market_name":"Signature Touch","codename":"titan","model":"Signature Touch"},{"manufacturer":"Vertu","market_name":"Signature Touch","codename":"titan","model":"Signature Touch L"},{"manufacturer":"Vertu","market_name":"Ti","codename":"hermione","model":"VERTU Ti"},{"manufacturer":"Verykool","market_name":"SL5029","codename":"verykoolSL5029","model":"verykoolSL5029"},{"manufacturer":"Verykool","market_name":"SL5050","codename":"verykoolSL5050","model":"verykoolSL5050"},{"manufacturer":"Verykool","market_name":"SL5200","codename":"verykoolSL5200","model":"verykoolSL5200"},{"manufacturer":"Verykool","market_name":"SL5560","codename":"verykoolSL5560","model":"verykoolSL5560"},{"manufacturer":"Verykool","market_name":"T7445","codename":"verykoolT7445","model":"verykoolT7445"},{"manufacturer":"Verykool","market_name":"s4513","codename":"verykoolS4513","model":"verykool Luna II S4513"},{"manufacturer":"Verykool","market_name":"s5007","codename":"verykoolS5007","model":"verykoolS5007"},{"manufacturer":"Verykool","market_name":"s5021","codename":"verykoolS5021","model":"verykool Wave Pro s5021"},{"manufacturer":"Verykool","market_name":"s5021","codename":"verykoolS5021","model":"verykoolS5021"},{"manufacturer":"Verykool","market_name":"s5027","codename":"verykoolS5027","model":"verykoolS5027"},{"manufacturer":"Verykool","market_name":"s5028","codename":"verykoolS5028","model":"verykoolS5028"},{"manufacturer":"Verykool","market_name":"s5029","codename":"verykool_s5029","model":"s5029"},{"manufacturer":"Verykool","market_name":"s5031","codename":"verykool_s5031","model":"s5031"},{"manufacturer":"Verykool","market_name":"s5034","codename":"verykools5034","model":"verykools5034"},{"manufacturer":"Verykool","market_name":"s5035","codename":"verykools5035","model":"verykools5035"},{"manufacturer":"Verykool","market_name":"s5204","codename":"verykools5204","model":"verykools5204"},{"manufacturer":"Verykool","market_name":"s5526","codename":"verykools5526","model":"verykools5526"},{"manufacturer":"Verykool","market_name":"s5527","codename":"verykools5527","model":"verykools5527"},{"manufacturer":"Verykool","market_name":"s5528","codename":"verykools5528","model":"verykools5528"},{"manufacturer":"Verykool","market_name":"verykool s5036","codename":"verykools5036","model":"verykools5036"},{"manufacturer":"Verykool","market_name":"verykool s5037","codename":"verykools5037","model":"verykools5037"},{"manufacturer":"Verykool","market_name":"verykool s6005x","codename":"verykools6005X","model":"s6005X"},{"manufacturer":"Verykool","market_name":"verykool s6005x","codename":"verykools6005X","model":"verykools6005X"},{"manufacturer":"Verykool","market_name":"verykoolS5019","codename":"verykoolS5019","model":"verykoolS5019"},{"manufacturer":"Verykool","market_name":"verykoolS5019","codename":"verykoolS5019","model":"verykools5019"},{"manufacturer":"Verykool","market_name":"verykoolSL5565","codename":"verykoolSL5565","model":"verykoolSL5565"},{"manufacturer":"Verykool","market_name":"verykools5205","codename":"verykools5205","model":"verykools5205"},{"manufacturer":"Verykool","market_name":"verykools5528Jr","codename":"verykools5528Jr","model":"verykools5528Jr"},{"manufacturer":"Verykool","market_name":"verykools5702","codename":"verykools5702","model":"verykools5702"},{"manufacturer":"Vestel","market_name":"5000","codename":"Leo","model":"Vestel_5000"},{"manufacturer":"Vestel","market_name":"5000","codename":"Leo","model":"Vestel_5000_Dual"},{"manufacturer":"Vestel","market_name":"5530","codename":"Pars","model":"Vestel_5530"},{"manufacturer":"Vestel","market_name":"5530","codename":"Pars","model":"Vestel_5530_Dual"},{"manufacturer":"Vestel","market_name":"Farabi","codename":"frb3g","model":"Farabi"},{"manufacturer":"Vestel","market_name":"Leo_2GB","codename":"Leo_2GB","model":"Vestel_5000_2gb"},{"manufacturer":"Vestel","market_name":"S7252","codename":"BCM7252S","model":"S7252"},{"manufacturer":"Vestel","market_name":"\"V TAB 7\"\" LITE II\"","codename":"V_TAB_7_LITE_II","model":"VTAB7LITEII"},{"manufacturer":"Vestel","market_name":"V TAB 7\\'\\' LITE II","codename":"V_TAB_7_LITE_II","model":"V_TAB_7_LITE_II"},{"manufacturer":"Vestel","market_name":"V TAB 7011","codename":"V_TAB_7011","model":"V_TAB_7011"},{"manufacturer":"Vestel","market_name":"V TAB 7015","codename":"V_TAB_7015","model":"V_TAB_7015"},{"manufacturer":"Vestel","market_name":"V TAB 7020","codename":"V_TAB_7020","model":"V_TAB_7020"},{"manufacturer":"Vestel","market_name":"V TAB 7020A","codename":"V_TAB_7020A","model":"V_TAB_7020A"},{"manufacturer":"Vestel","market_name":"V TAB 7020B","codename":"V_TAB_7020B","model":"V_TAB_7020B"},{"manufacturer":"Vestel","market_name":"V TAB 7025","codename":"V_TAB_7025","model":"V_TAB_7025"},{"manufacturer":"Vestel","market_name":"V TAB 7810","codename":"V_TAB_7810","model":"V_TAB_7810"},{"manufacturer":"Vestel","market_name":"V TAB 8010","codename":"V_TAB_8010","model":"V_TAB_8010"},{"manufacturer":"Vestel","market_name":"V TAB 8029","codename":"V_TAB_8029","model":"V TAB 8029"},{"manufacturer":"Vestel","market_name":"V TAB 9.7\\'\\' PRO","codename":"VT97PRO","model":"VT97PRO"},{"manufacturer":"Vestel","market_name":"V Tab 7010","codename":"VTab7010","model":"V Tab 7010"},{"manufacturer":"Vestel","market_name":"V3 5580 Dual","codename":"Orsa","model":"V3_5580_Dual"},{"manufacturer":"Vestel","market_name":"VP100+","codename":"ephesus","model":"10.1Myros"},{"manufacturer":"Vestel","market_name":"VP100+","codename":"ephesus","model":"VP100+"},{"manufacturer":"Vestel","market_name":"VP73","codename":"wing-ibt","model":"VP73"},{"manufacturer":"Vestel","market_name":"VP73","codename":"wing-ibt","model":"VP73_Hyundai"},{"manufacturer":"Vestel","market_name":"VP73","codename":"wing-ibt","model":"VP73_Myros"},{"manufacturer":"Vestel","market_name":"VP73","codename":"wing-ibt","model":"VP73_Vox"},{"manufacturer":"Vestel","market_name":"VP73","codename":"wing-ibt","model":"VP73_le"},{"manufacturer":"Vestel","market_name":"VP74","codename":"wifionly-gms","model":"VP74"},{"manufacturer":"Vestel","market_name":"VP74","codename":"wifionly-gms","model":"VP74-Celcus"},{"manufacturer":"Vestel","market_name":"VP74","codename":"wifionly-gms","model":"VP74-Finlux"},{"manufacturer":"Vestel","market_name":"VP74","codename":"wifionly-gms","model":"VP74-Luxor"},{"manufacturer":"Vestel","market_name":"VP74","codename":"wifionly-gms","model":"VP74-Orava"},{"manufacturer":"Vestel","market_name":"VP74","codename":"wifionly-gms","model":"VP74-Telefunken"},{"manufacturer":"Vestel","market_name":"VP74","codename":"wifionly-gms","model":"VP74-Vox"},{"manufacturer":"Vestel","market_name":"VSP145M","codename":"VSP145M","model":"VSP145M"},{"manufacturer":"Vestel","market_name":"VSP250g","codename":"VSP250g","model":"VSP250g"},{"manufacturer":"Vestel","market_name":"VSP250s","codename":"VSP250s","model":"VSP250s"},{"manufacturer":"Vestel","market_name":"VSP355g","codename":"g55","model":"VSP355g"},{"manufacturer":"Vestel","market_name":"VSP355s","codename":"s55","model":"VSP355s"},{"manufacturer":"Vestel","market_name":"VT10E","codename":"VT10E","model":"VT10E"},{"manufacturer":"Vestel","market_name":"VT10E2","codename":"VT10E2","model":"S TAB 10\\'\\' II"},{"manufacturer":"Vestel","market_name":"VT10E2","codename":"VT10E2","model":"V TAB 10\\'\\' LITE"},{"manufacturer":"Vestel","market_name":"VT10E2","codename":"VT10E2","model":"VT10E2"},{"manufacturer":"Vestel","market_name":"VT785P2","codename":"VT785P2","model":"V TAB 7.85\\'\\' LITE"},{"manufacturer":"Vestel","market_name":"VT785P2","codename":"VT785P2","model":"VT785P2-Celcus"},{"manufacturer":"Vestel","market_name":"VT785P2","codename":"VT785P2","model":"VT785P2-Cleverpad"},{"manufacturer":"Vestel","market_name":"VT785P2","codename":"VT785P2","model":"VT785P2-Finlux"},{"manufacturer":"Vestel","market_name":"VT785P2","codename":"VT785P2","model":"VT785P2-Vestel"},{"manufacturer":"Vestel","market_name":"VTAB 1040","codename":"V_TAB_1040","model":"V_TAB_1040"},{"manufacturer":"Vestel","market_name":"VTAB 7040","codename":"V_TAB_7040","model":"V_TAB_7040"},{"manufacturer":"Vestel","market_name":"VTAB 8059","codename":"V_TAB_8059","model":"V_TAB_8059"},{"manufacturer":"Vestel","market_name":"VTAB1049","codename":"V_TAB_1049","model":"V_TAB_1049"},{"manufacturer":"Vestel","market_name":"VTAB1050","codename":"V_TAB_1050","model":"V_TAB_1050"},{"manufacturer":"Vestel","market_name":"VTAB1069","codename":"V_TAB_1069","model":"V_TAB_1069"},{"manufacturer":"Vestel","market_name":"V_TAB_7030","codename":"V_TAB_7030","model":"V_TAB_7030"},{"manufacturer":"Vestel","market_name":"Venus E2 Plus","codename":"Ada","model":"Venus E2 Plus"},{"manufacturer":"Vestel","market_name":"Venus E3","codename":"Riga","model":"Venus E3"},{"manufacturer":"Vestel","market_name":"Venus V3 5020","codename":"Arya","model":"Venus_V3_5020"},{"manufacturer":"Vestel","market_name":"Venus V3 5030","codename":"Dyno","model":"Venus_V3_5030"},{"manufacturer":"Vestel","market_name":"Venus V3 5040","codename":"Venus_V3_5040","model":"Venus_V3_5040"},{"manufacturer":"Vestel","market_name":"Venus V3 5040","codename":"Venus_V3_5045","model":"Venus_V3_5040_2GB"},{"manufacturer":"Vestel","market_name":"Venus V3 5070","codename":"Venus_V3_5070","model":"Venus_V3_5070"},{"manufacturer":"Vestel","market_name":"Venus V3 5570","codename":"Venus_V3_5570","model":"Venus_V3_5570"},{"manufacturer":"Vestel","market_name":"Venus V3 5580","codename":"Orsa","model":"Venus_V3_5580"},{"manufacturer":"Vestel","market_name":"Venus V5","codename":"Teos","model":"Venus V5"},{"manufacturer":"Vestel","market_name":"Venus Z10","codename":"Reys","model":"Venus Z10"},{"manufacturer":"Vestel","market_name":"Venus_V4","codename":"V4","model":"Venus_V4"},{"manufacturer":"Vestel","market_name":"Vestel Z20","codename":"Cunda","model":"Venus Z20"},{"manufacturer":"Vestel","market_name":"venus_v3_5010","codename":"DynoLight","model":"Venus_V3_5010"},{"manufacturer":"Vgo Tel","market_name":"OCEAN 6","codename":"VGOTEL_OCEAN_6","model":"Ocean 6"},{"manufacturer":"Vgo Tel","market_name":"Ocean 8","codename":"Ocean_8","model":"Ocean_8"},{"manufacturer":"Vgo Tel","market_name":"Ocean 9","codename":"Ocean_9","model":"Ocean_9"},{"manufacturer":"Vgo Tel","market_name":"Ocean9L","codename":"Ocean9L","model":"Ocean9L"},{"manufacturer":"Vgo Tel","market_name":"VENTURE V12","codename":"Venture_V12","model":"Venture V12"},{"manufacturer":"Vgo Tel","market_name":"Venture V8","codename":"VentureV8","model":"Venture V8"},{"manufacturer":"Vgo Tel","market_name":"i Smart","codename":"i_Smart","model":"i_Smart"},{"manufacturer":"Vida","market_name":"VIDA - i512","codename":"i512","model":"VIDA_i512"},{"manufacturer":"Viettel","market_name":"V8802","codename":"V8802","model":"V8802"},{"manufacturer":"ViewSonic","market_name":"","codename":"ViewPad_IR10Q","model":"IR10Q"},{"manufacturer":"ViewSonic","market_name":"","codename":"ViewPad_IR8Q","model":"IR8Q"},{"manufacturer":"ViewSonic","market_name":"","codename":"v350","model":"ViewSonic-V350"},{"manufacturer":"ViewSonic","market_name":"","codename":"viewpad4","model":"ViewSonic-ViewPad4"},{"manufacturer":"ViewSonic","market_name":"","codename":"viewpad7","model":"ViewPad7"},{"manufacturer":"ViewSonic","market_name":"","codename":"viewpad7x","model":"ViewPad7X"},{"manufacturer":"ViewSonic","market_name":"","codename":"viewpad7x","model":"ViewPad7x"},{"manufacturer":"ViewSonic","market_name":"Q5","codename":"Q5","model":"Viewphone Q5"},{"manufacturer":"ViewSonic","market_name":"VIEWSONIC","codename":"VIEWPAD_AW7M_PLUS","model":"VIEWPAD_AW7M_PLUS"},{"manufacturer":"ViewSonic","market_name":"VSD221","codename":"VSD221","model":"VSD221"},{"manufacturer":"ViewSonic","market_name":"VSD231","codename":"VSD231-VSA","model":"VSD231"},{"manufacturer":"ViewSonic","market_name":"VSD241 Smart Display","codename":"VSD241","model":"VSD241"},{"manufacturer":"ViewSonic","market_name":"VSD242","codename":"VSD242","model":"VSD242"},{"manufacturer":"ViewSonic","market_name":"ViewPad I7M","codename":"VIEWPAD","model":"VIEWPAD I7M"},{"manufacturer":"ViewSonic","market_name":"ViewPad IR7Q","codename":"IR7Q","model":"IR7Q"},{"manufacturer":"ViewSonic","market_name":"ViewPad_M10","codename":"mid1016_ma","model":"ViewPad_M10"},{"manufacturer":"ViewSonic","market_name":"ViewPadi7Q","codename":"vsi7q_1_coho","model":"vsi7q_1"},{"manufacturer":"ViewSonic","market_name":"ViewPadi7Q","codename":"vsi7q_1_coho","model":"vsi7q_1_coho"},{"manufacturer":"ViewSonic","market_name":"ViewPadi8Q","codename":"vsi8q_1_coho","model":"vsi8q_1"},{"manufacturer":"ViewSonic","market_name":"ViewPadi8Q","codename":"vsi8q_1_coho","model":"vsi8q_1_coho"},{"manufacturer":"Visiontouch","market_name":"Inspire","codename":"VisionTouchInspire","model":"Vision Touch Inspire"},{"manufacturer":"Visiontouch","market_name":"Life","codename":"VisionTouchLife","model":"VisionTouchLife"},{"manufacturer":"Visual Land","market_name":"Prestige Elite10QI","codename":"Elite10QI","model":"Elite10QI"},{"manufacturer":"Visual Land","market_name":"Prestige Elite10QL","codename":"Elite10QL","model":"Elite10QL"},{"manufacturer":"Visual Land","market_name":"Prestige Elite10QS","codename":"Elite10QS","model":"Elite10QS"},{"manufacturer":"Visual Land","market_name":"Prestige Elite11Q","codename":"Elite11Q","model":"Elite11Q"},{"manufacturer":"Visual Land","market_name":"Prestige Elite13Q","codename":"Elite13Q","model":"Elite13Q"},{"manufacturer":"Visual Land","market_name":"Prestige Elite7QL","codename":"Elite7QL","model":"Elite7QL"},{"manufacturer":"Visual Land","market_name":"Prestige Elite7QS","codename":"Elite7QS","model":"Elite7QS"},{"manufacturer":"Visual Land","market_name":"Prestige Elite8QI","codename":"Elite8QI","model":"Elite8QI"},{"manufacturer":"Visual Land","market_name":"Prestige Elite8QL","codename":"Elite8QL","model":"Elite8QL"},{"manufacturer":"Visual Land","market_name":"Prestige Elite9QL","codename":"Elite9QL","model":"Elite9QL"},{"manufacturer":"Visual Land","market_name":"Prestige Prime10ES","codename":"Prime10ES","model":"Prime10ES"},{"manufacturer":"Visual Land","market_name":"Prestige Prime10SE","codename":"Prime10SE","model":"Prime10SE"},{"manufacturer":"Visual Land","market_name":"Prestige Prime11E","codename":"Prime11E","model":"Prime11E"},{"manufacturer":"Vitsmo","market_name":"Zero Spin","codename":"Zero_Spin","model":"Zero_Spin"},{"manufacturer":"Vivax","market_name":"FUN S20","codename":"FUN_S20","model":"FUN_S20"},{"manufacturer":"Vivax","market_name":"Point X502","codename":"Point_X502","model":"Point X502"},{"manufacturer":"Vivax","market_name":"VIVAX_Fly_V1","codename":"VIVAX_Fly_V1","model":"VIVAX_Fly_V1"},{"manufacturer":"Vivo","market_name":"1601","codename":"1601","model":"vivo 1601"},{"manufacturer":"Vivo","market_name":"1601","codename":"1601","model":"vivo 1713"},{"manufacturer":"Vivo","market_name":"1609","codename":"1609","model":"vivo 1609"},{"manufacturer":"Vivo","market_name":"PD1304DL","codename":"PD1304DL","model":"vivo Y13iL"},{"manufacturer":"Vivo","market_name":"PD1419V","codename":"PD1419V","model":"vivo Y923"},{"manufacturer":"Vivo","market_name":"PD1612","codename":"PD1612","model":"vivo PD1612"},{"manufacturer":"Vivo","market_name":"PD1612","codename":"PD1612","model":"vivo Y67"},{"manufacturer":"Vivo","market_name":"V1","codename":"V1","model":"vivo V1"},{"manufacturer":"Vivo","market_name":"V1Max","codename":"Y37","model":"vivo Y37"},{"manufacturer":"Vivo","market_name":"V3","codename":"PD1524","model":"vivo V3"},{"manufacturer":"Vivo","market_name":"V3","codename":"V3","model":"vivo V3"},{"manufacturer":"Vivo","market_name":"V3Lite","codename":"V3Lite","model":"vivo V3Lite"},{"manufacturer":"Vivo","market_name":"V3M A","codename":"PD1524B","model":"vivo PD1524B"},{"manufacturer":"Vivo","market_name":"V3Max","codename":"V3Max","model":"vivo V3Max"},{"manufacturer":"Vivo","market_name":"V3Max + A","codename":"PD1523B","model":"vivo V3Max+ A"},{"manufacturer":"Vivo","market_name":"V3Max A","codename":"PD1523","model":"vivo PD1523A"},{"manufacturer":"Vivo","market_name":"V5Plus","codename":"V5Plus","model":"vivo V5Plus"},{"manufacturer":"Vivo","market_name":"V9","codename":"1727ID","model":"vivo 1727"},{"manufacturer":"Vivo","market_name":"X5","codename":"X5","model":"vivo X5"},{"manufacturer":"Vivo","market_name":"X5M","codename":"PD1401CL","model":"vivo X5M"},{"manufacturer":"Vivo","market_name":"X5Max","codename":"X5Max","model":"vivo X5Max"},{"manufacturer":"Vivo","market_name":"X5Max S","codename":"bbk6752_lwt_kk","model":"vivo X5Max S"},{"manufacturer":"Vivo","market_name":"X5MaxV","codename":"msm8916_32","model":"vivo X5MaxV"},{"manufacturer":"Vivo","market_name":"X5Pro","codename":"X5Pro","model":"vivo X5Pro"},{"manufacturer":"Vivo","market_name":"X5Pro D","codename":"bbk6752_lwt_l","model":"vivo X5Pro D"},{"manufacturer":"Vivo","market_name":"X5Pro V","codename":"PD1421V","model":"vivo X5Pro V"},{"manufacturer":"Vivo","market_name":"X6A","codename":"PD1415A","model":"vivo PD1415A"},{"manufacturer":"Vivo","market_name":"X6D","codename":"PD1415D","model":"vivo X6D"},{"manufacturer":"Vivo","market_name":"X6Plus A","codename":"PD1515A","model":"vivo PD1515A"},{"manufacturer":"Vivo","market_name":"X6Plus D","codename":"PD1501D","model":"vivo PD1501D"},{"manufacturer":"Vivo","market_name":"X6S A","codename":"PD1415BA","model":"vivo X6S A"},{"manufacturer":"Vivo","market_name":"X6SPlusA","codename":"PD1515BA","model":"vivo PD1515BA"},{"manufacturer":"Vivo","market_name":"X7","codename":"PD1602","model":"vivo X7"},{"manufacturer":"Vivo","market_name":"X7Plus","codename":"PD1603","model":"vivo X7Plus"},{"manufacturer":"Vivo","market_name":"X9","codename":"PD1616","model":"vivo X9"},{"manufacturer":"Vivo","market_name":"X9i","codename":"PD1624","model":"vivo X9i"},{"manufacturer":"Vivo","market_name":"Xplay5A","codename":"PD1522A","model":"vivo PD1522A"},{"manufacturer":"Vivo","market_name":"Xplay5A","codename":"PD1522A","model":"vivo Xplay5A"},{"manufacturer":"Vivo","market_name":"Xplay6","codename":"PD1610","model":"vivo Xplay6"},{"manufacturer":"Vivo","market_name":"Y11","codename":"Y11","model":"vivo Y11"},{"manufacturer":"Vivo","market_name":"Y15","codename":"Y15","model":"vivo Y15"},{"manufacturer":"Vivo","market_name":"Y15S","codename":"Y15S","model":"vivo Y15S"},{"manufacturer":"Vivo","market_name":"Y21","codename":"Y21","model":"vivo Y21"},{"manufacturer":"Vivo","market_name":"Y21L","codename":"Y21L","model":"vivo Y21L"},{"manufacturer":"Vivo","market_name":"Y22","codename":"Y22","model":"vivo Y22"},{"manufacturer":"Vivo","market_name":"Y27","codename":"Y27","model":"vivo Y27"},{"manufacturer":"Vivo","market_name":"Y28","codename":"Y28","model":"vivo Y28"},{"manufacturer":"Vivo","market_name":"Y31","codename":"PD1505","model":"vivo Y31"},{"manufacturer":"Vivo","market_name":"Y31","codename":"Y31","model":"vivo Y31"},{"manufacturer":"Vivo","market_name":"Y31L","codename":"Y31L","model":"vivo Y31L"},{"manufacturer":"Vivo","market_name":"Y31i","codename":"Y31i","model":"vivo 1707"},{"manufacturer":"Vivo","market_name":"Y31i","codename":"Y31i","model":"vivo Y31"},{"manufacturer":"Vivo","market_name":"Y31i","codename":"Y31i","model":"vivo Y31i"},{"manufacturer":"Vivo","market_name":"Y33","codename":"bbk6735_65c_l","model":"vivo Y33"},{"manufacturer":"Vivo","market_name":"Y35","codename":"PD1502L","model":"vivo Y35"},{"manufacturer":"Vivo","market_name":"Y35A","codename":"PD1502A","model":"vivo Y35A"},{"manufacturer":"Vivo","market_name":"Y51","codename":"Y51","model":"vivo Y51"},{"manufacturer":"Vivo","market_name":"Y51A","codename":"PD1510","model":"vivo Y51A"},{"manufacturer":"Vivo","market_name":"Y53","codename":"1606","model":"vivo 1606"},{"manufacturer":"Vivo","market_name":"Y53L","codename":"PD1628","model":"vivo PD1628"},{"manufacturer":"Vivo","market_name":"Y55","codename":"1603","model":"vivo 1603"},{"manufacturer":"Vivo","market_name":"Y55A","codename":"PD1613","model":"vivo Y55"},{"manufacturer":"Vivo","market_name":"Y55s","codename":"1610","model":"vivo 1610"},{"manufacturer":"Vivo","market_name":"Y66","codename":"PD1621","model":"vivo Y66"},{"manufacturer":"Vivo","market_name":"Y67","codename":"PD1612","model":"vivo Y67"},{"manufacturer":"Vivo","market_name":"Y71","codename":"1801","model":"vivo 1801"},{"manufacturer":"Vivo","market_name":"Y79A","codename":"PD1708","model":"vivo PD1708"},{"manufacturer":"Vivo","market_name":"Y79A","codename":"PD1708","model":"vivo Y79A"},{"manufacturer":"Vivo","market_name":"Y937","codename":"PD1503","model":"vivo Y937"},{"manufacturer":"Vivo","market_name":"vivo  X21i  A","codename":"PD1801","model":"vivo X21i A"},{"manufacturer":"Vivo","market_name":"vivo  Y85A","codename":"PD1730","model":"vivo Y85A"},{"manufacturer":"Vivo","market_name":"vivo 1611","codename":"1611","model":"vivo 1611"},{"manufacturer":"Vivo","market_name":"vivo 1714","codename":"1714","model":"vivo 1714"},{"manufacturer":"Vivo","market_name":"vivo 1716","codename":"1716","model":"vivo 1716"},{"manufacturer":"Vivo","market_name":"vivo 1718","codename":"1718","model":"vivo 1718"},{"manufacturer":"Vivo","market_name":"vivo 1720","codename":"PD1710F_EX","model":"vivo 1720"},{"manufacturer":"Vivo","market_name":"vivo 1721","codename":"PD1709F_EX","model":"vivo 1721"},{"manufacturer":"Vivo","market_name":"vivo 1723","codename":"1723","model":"vivo 1723"},{"manufacturer":"Vivo","market_name":"vivo 1724","codename":"1724","model":"vivo 1724"},{"manufacturer":"Vivo","market_name":"vivo 1725","codename":"1725","model":"vivo 1725"},{"manufacturer":"Vivo","market_name":"vivo 1726","codename":"1726","model":"vivo 1726"},{"manufacturer":"Vivo","market_name":"vivo 1727","codename":"1727","model":"vivo 1727"},{"manufacturer":"Vivo","market_name":"vivo 1802","codename":"1802","model":"vivo 1802"},{"manufacturer":"Vivo","market_name":"vivo X20","codename":"PD1709","model":"vivo PD1709"},{"manufacturer":"Vivo","market_name":"vivo X20","codename":"PD1709","model":"vivo X20A"},{"manufacturer":"Vivo","market_name":"vivo X20Plus","codename":"PD1710","model":"vivo PD1710"},{"manufacturer":"Vivo","market_name":"vivo X20Plus","codename":"PD1710","model":"vivo X20Plus A"},{"manufacturer":"Vivo","market_name":"vivo X20Plus UD","codename":"PD1721","model":"vivo PD1721"},{"manufacturer":"Vivo","market_name":"vivo X20Plus UD","codename":"PD1721","model":"vivo X20Plus UD"},{"manufacturer":"Vivo","market_name":"vivo X21A","codename":"PD1728","model":"vivo X21A"},{"manufacturer":"Vivo","market_name":"vivo X21UD A","codename":"PD1728UD","model":"vivo X21UD A"},{"manufacturer":"Vivo","market_name":"vivo X9Plus","codename":"PD1619","model":"vivo X9Plus"},{"manufacturer":"Vivo","market_name":"vivo X9s","codename":"PD1616B","model":"vivo PD1616B"},{"manufacturer":"Vivo","market_name":"vivo X9s","codename":"PD1616B","model":"vivo X9s"},{"manufacturer":"Vivo","market_name":"vivo X9s Plus","codename":"PD1635","model":"vivo PD1635"},{"manufacturer":"Vivo","market_name":"vivo X9s Plus","codename":"PD1635","model":"vivo X9s Plus"},{"manufacturer":"Vivo","market_name":"vivo Y65","codename":"1719","model":"vivo 1719"},{"manufacturer":"Vivo","market_name":"vivo Y66i A","codename":"PD1621B","model":"vivo Y66i A"},{"manufacturer":"Vivo","market_name":"vivo Y69A","codename":"PD1705","model":"vivo Y69A"},{"manufacturer":"Vivo","market_name":"vivo Y71A","codename":"PD1731","model":"vivo Y71A"},{"manufacturer":"Vivo","market_name":"vivo Y75A","codename":"PD1718","model":"vivo Y75A"},{"manufacturer":"Vivo","market_name":"vivo Y83A","codename":"PD1803","model":"vivo Y83A"},{"manufacturer":"Viwa","market_name":"LIGHT ONE","codename":"VIWA_LIGHT_ONE","model":"LIGHT ONE"},{"manufacturer":"Viwa","market_name":"LIGHT PLUS","codename":"VIWA_LIGHT_PLUS","model":"LIGHT PLUS"},{"manufacturer":"Viwa","market_name":"M4","codename":"M4","model":"M4"},{"manufacturer":"Viwa","market_name":"VISION","codename":"VIWA_VISION","model":"VISION"},{"manufacturer":"Viwa","market_name":"X2","codename":"VIWA_X2","model":"X2"},{"manufacturer":"Vizio","market_name":"StreamPlayer","codename":"VAP430","model":"VAP430"},{"manufacturer":"Vizio","market_name":"VTAB1008","codename":"VTAB1008","model":"VTAB1008"},{"manufacturer":"Vizio","market_name":"XR6M10","codename":"XR6M10","model":"XR6M10"},{"manufacturer":"Vizio","market_name":"XR6P10","codename":"XR6P10","model":"XR6P10"},{"manufacturer":"Vizmo","market_name":"VIZ070TAB711","codename":"VIZ070TAB711","model":"VIZ070TAB711"},{"manufacturer":"Vizmo","market_name":"VIZ101TAB711","codename":"VIZ101TAB711","model":"VIZ101TAB711"},{"manufacturer":"Vkworld","market_name":"Mix3","codename":"Mix3","model":"Mix3"},{"manufacturer":"Vkworld","market_name":"Mix_Plus","codename":"Mix_Plus","model":"Mix_Plus"},{"manufacturer":"Vkworld","market_name":"S8","codename":"vkworld_S8","model":"S8"},{"manufacturer":"Vodafone","market_name":"785","codename":"Vodafone_785","model":"Vodafone 785"},{"manufacturer":"Vodafone","market_name":"895","codename":"VF-895N","model":"VF-895N"},{"manufacturer":"Vodafone","market_name":"Smart N8","codename":"VFD610","model":"VFD 610"},{"manufacturer":"Vodafone","market_name":"Smart Tab 4","codename":"Vodafone_Smart_Tab_4","model":"Vodafone Smart Tab 4"},{"manufacturer":"Vodafone","market_name":"Smart Tab N8","codename":"VFD1300","model":"VFD 1300"},{"manufacturer":"Vodafone","market_name":"Smart V8","codename":"VFD710","model":"VFD 710"},{"manufacturer":"Vodafone","market_name":"Smart first 7","codename":"P731V35","model":"VFD 200"},{"manufacturer":"Vodafone","market_name":"Smart mini 7","codename":"VFD300","model":"VFD 300"},{"manufacturer":"Vodafone","market_name":"Smart mini 7 dual","codename":"VFD301","model":"VFD 301"},{"manufacturer":"Vodafone","market_name":"Smart platinum 7","codename":"VFD900","model":"VFD 900"},{"manufacturer":"Vodafone","market_name":"Smart prime 7","codename":"P809V50","model":"VFD 600"},{"manufacturer":"Vodafone","market_name":"Smart turbo 7","codename":"VFD500","model":"VFD 500"},{"manufacturer":"Vodafone","market_name":"Smart turbo 7","codename":"VFD501","model":"VFD 501"},{"manufacturer":"Vodafone","market_name":"Smart turbo 7 dual","codename":"VFD502","model":"VFD 502"},{"manufacturer":"Vodafone","market_name":"Smart ultra 6","codename":"P839V55","model":"Vodafone Smart ultra 6"},{"manufacturer":"Vodafone","market_name":"Smart ultra 7","codename":"VFD700","model":"Maxis VFD700"},{"manufacturer":"Vodafone","market_name":"Smart ultra 7","codename":"VFD700","model":"VFD 700"},{"manufacturer":"Vodafone","market_name":"Smart_N9_Lite","codename":"VFD620","model":"VFD 620"},{"manufacturer":"Vodafone","market_name":"Smart_Tab_3G","codename":"Vodafone_Smart_Tab_3G","model":"Vodafone Smart Tab 3G"},{"manufacturer":"Vodafone","market_name":"Smart_Tab_4G","codename":"Vodafone_Smart_Tab_4G","model":"Vodafone Smart Tab 4G"},{"manufacturer":"Vodafone","market_name":"Tab Prime 7","codename":"VFD1400","model":"VFD 1400"},{"manufacturer":"Vodafone","market_name":"Tab Prime 7","codename":"VFD1400","model":"VFD1400"},{"manufacturer":"Vodafone","market_name":"Tab mini 7","codename":"Tab7","model":"VFD 1100"},{"manufacturer":"Vodafone","market_name":"VDF 600","codename":"P809V50","model":"VFD 600"},{"manufacturer":"Vodafone","market_name":"VF-1296","codename":"voda_tab","model":"Vodacom Power Tab 10"},{"manufacturer":"Vodafone","market_name":"VF-1296","codename":"voda_tab","model":"Vodafone Tab grand 6"},{"manufacturer":"Vodafone","market_name":"VF-1397","codename":"Vodafone_Tab_speed_6","model":"VF-1397"},{"manufacturer":"Vodafone","market_name":"VF-1497","codename":"Vodafone_Tab_Prime","model":"VF-1497"},{"manufacturer":"Vodafone","market_name":"VF685","codename":"VF685","model":"VF685"},{"manufacturer":"Vodafone","market_name":"VF695","codename":"VF695","model":"VF695"},{"manufacturer":"Vodafone","market_name":"VFD 200","codename":"P731V35","model":"VFD 200"},{"manufacturer":"Vodafone","market_name":"Vodacom Kicka VE","codename":"VFD100","model":"VFD 100"},{"manufacturer":"Vodafone","market_name":"Vodafone Smart E8","codename":"VFD510","model":"VFD 510"},{"manufacturer":"Vodafone","market_name":"Vodafone Smart E8","codename":"VFD511","model":"VFD 511"},{"manufacturer":"Vodafone","market_name":"Vodafone Smart E8","codename":"VFD512","model":"VFD 512"},{"manufacturer":"Vodafone","market_name":"Vodafone Smart E8","codename":"VFD513","model":"VFD 513"},{"manufacturer":"Vodafone","market_name":"Vodafone Smart N9","codename":"VFD720","model":"VFD 720"},{"manufacturer":"Vodafone","market_name":"Vodafone Smart mini","codename":"Vodafone_875","model":"Vodafone 875"},{"manufacturer":"Vodafone","market_name":"Vodafone Smart mini 7 ve","codename":"U3_3G","model":"VFD 310"},{"manufacturer":"Vodafone","market_name":"Vodafone Smart mini 7 ve dual","codename":"U3_3G","model":"VFD 311"},{"manufacturer":"Vodafone","market_name":"Vodafone TV","codename":"uiw4030vha","model":"Vodafone TV"},{"manufacturer":"Volt Mobile","market_name":"VOLT_SV451_Vision","codename":"VOLT_SV451_Vision","model":"VOLT_SV451_Vision"},{"manufacturer":"Vonino","market_name":"Druid_L10","codename":"Druid_L10","model":"Druid_L10"},{"manufacturer":"Vonino","market_name":"Epic E8","codename":"Epic_E8","model":"Epic E8"},{"manufacturer":"Vonino","market_name":"Epic P7","codename":"Epic_P7","model":"Epic_P7"},{"manufacturer":"Vonino","market_name":"Jax X","codename":"Jax_X","model":"Jax X"},{"manufacturer":"Vonino","market_name":"Jax X A6","codename":"Jax_X","model":"Jax X"},{"manufacturer":"Vonino","market_name":"Jax_S","codename":"Jax_S_A7","model":"Jax_S_A7"},{"manufacturer":"Vonino","market_name":"Jax_X_TM","codename":"JAX","model":"Jax X"},{"manufacturer":"Vonino","market_name":"Magnet M1_A7","codename":"Magnet_M1_A7","model":"Magnet M1"},{"manufacturer":"Vonino","market_name":"Magnet_M1","codename":"Magnet_M1","model":"Magnet M1"},{"manufacturer":"Vonino","market_name":"Magnet_W10","codename":"Magnet_W10","model":"Magnet_W10"},{"manufacturer":"Vonino","market_name":"MusicPAD","codename":"MusicPAD","model":"MusicPAD"},{"manufacturer":"Vonino","market_name":"Navo  P","codename":"Navo_P","model":"Navo_P"},{"manufacturer":"Vonino","market_name":"Navo QS","codename":"Navo_QS","model":"Navo_QS"},{"manufacturer":"Vonino","market_name":"Navo S","codename":"Navo_S","model":"Navo S"},{"manufacturer":"Vonino","market_name":"Pluri B7","codename":"Pluri_B7","model":"Pluri B7"},{"manufacturer":"Vonino","market_name":"Pluri C7","codename":"Pluri_C7","model":"Pluri C7"},{"manufacturer":"Vonino","market_name":"Pluri C8","codename":"Pluri_C8","model":"Pluri C8"},{"manufacturer":"Vonino","market_name":"Pluri M7","codename":"Pluri_M7","model":"Pluri_M7"},{"manufacturer":"Vonino","market_name":"Pluri M7 A6","codename":"Pluri_M7","model":"Pluri_M7"},{"manufacturer":"Vonino","market_name":"Pluri Q8","codename":"Pluri_Q8","model":"Pluri_Q8"},{"manufacturer":"Vonino","market_name":"Pluri Q8 A6","codename":"Pluri_Q8","model":"Pluri_Q8"},{"manufacturer":"Vonino","market_name":"Pluri Q8 TM","codename":"Pluri_Q8","model":"Pluri_Q8"},{"manufacturer":"Vonino","market_name":"Pluri_B7_TM","codename":"Pluri_B7_TM","model":"Pluri_B7_TM"},{"manufacturer":"Vonino","market_name":"Pluri_G7","codename":"Pluri_G7","model":"Pluri G7"},{"manufacturer":"Vonino","market_name":"Volt S","codename":"Volt_S","model":"Volt S"},{"manufacturer":"Vonino","market_name":"Volt_S","codename":"Volt_S_A7","model":"Volt_S_A7"},{"manufacturer":"Vonino","market_name":"Volt_X","codename":"Volt_X","model":"Volt_X"},{"manufacturer":"Vonino","market_name":"Xavy G7","codename":"Xavy_G7","model":"Xavy G7"},{"manufacturer":"Vonino","market_name":"Xavy L8 A6","codename":"Xavy_L8","model":"Xavy_L8"},{"manufacturer":"Vonino","market_name":"Xavy T7 A6","codename":"Xavy_T7","model":"Xavy_T7"},{"manufacturer":"Vonino","market_name":"Xavy_L8","codename":"Xavy_L8","model":"Xavy_L8"},{"manufacturer":"Vonino","market_name":"Xavy_T7","codename":"Xavy_T7","model":"Xavy_T7"},{"manufacturer":"Vonino","market_name":"Xylo  P","codename":"Xylo_P","model":"Xylo P"},{"manufacturer":"Vonino","market_name":"Xylo X A6","codename":"Xylo_X","model":"Xylo X"},{"manufacturer":"Vonino","market_name":"Xylo_X_TM","codename":"Xylo","model":"Xylo X"},{"manufacturer":"Vonino","market_name":"Xylo_Z","codename":"Xylo_Z","model":"Xylo"},{"manufacturer":"Vonino","market_name":"ZUN XO","codename":"ZUN_XO","model":"ZUN XO"},{"manufacturer":"Vonino","market_name":"ZUN XO A6","codename":"Zun_XO","model":"ZUN XO"},{"manufacturer":"Vonino","market_name":"Zun X","codename":"Zun_X","model":"Zun X"},{"manufacturer":"Vonino","market_name":"Zun X A6","codename":"Zun_X","model":"Zun X"},{"manufacturer":"Vonino","market_name":"Zun XS","codename":"Zun_XS","model":"Zun XS"},{"manufacturer":"Vonino","market_name":"jax_S","codename":"Jax_S","model":"Jax_S"},{"manufacturer":"Vortex","market_name":"Beat 8","codename":"BEAT8","model":"BEAT 8"},{"manufacturer":"Vortex","market_name":"V50LTE","codename":"V50LTE","model":"V50LTE"},{"manufacturer":"Voto","market_name":"VOTO V3","codename":"VOTO_V3","model":"VOTO V3"},{"manufacturer":"Vsun","market_name":"MARS  Touch","codename":"MARS_TOUCH","model":"MARS TOUCH"},{"manufacturer":"Vsun","market_name":"MARS Nocam","codename":"MARS_NOCAM","model":"MARS NOCAM"},{"manufacturer":"Vsun","market_name":"MARS Note","codename":"MARS_NOTE","model":"MARS NOTE"},{"manufacturer":"Vsun","market_name":"MERCURY Tough","codename":"MERCURY_Tough","model":"MERCURY Tough"},{"manufacturer":"Vsun","market_name":"SATURN Selfie","codename":"SATURN_SELFIE","model":"SATURN SELFIE"},{"manufacturer":"Vulcan","market_name":"Pulse 7","codename":"VT0701A08","model":"VT0701A08"},{"manufacturer":"Vulcan","market_name":"Pulse 7S","codename":"VT0702A16","model":"VT0702A16"},{"manufacturer":"Vulcan","market_name":"TA10TA2","codename":"TA10TA2_1","model":"TA10TA2"},{"manufacturer":"Vulcan","market_name":"TA71CA1","codename":"TA71CA1","model":"TA71CA1"},{"manufacturer":"Vulcan","market_name":"TA71CA2","codename":"TA71CA2_1","model":"TA71CA2"},{"manufacturer":"Vulcan","market_name":"TEMPO S11","codename":"VS4011","model":"VS4011"},{"manufacturer":"Vulcan","market_name":"TEMPO S12","codename":"VS5012","model":"VS5012"},{"manufacturer":"Vulcan","market_name":"TEMPO S13","codename":"VS5513","model":"VS5513"},{"manufacturer":"Vulcan","market_name":"TEMPO S16","codename":"VS5016","model":"VS5016"},{"manufacturer":"Vulcan","market_name":"Tempo 5","codename":"VP5004A","model":"VP5004A"},{"manufacturer":"Vulcan","market_name":"VT0702A08","codename":"VT0702A08","model":"VT0702A08"},{"manufacturer":"Vulcan","market_name":"Vulcan Rhyme 10A","codename":"VT1002A16","model":"VT1002A16"},{"manufacturer":"Vulcan","market_name":"Vulcan Rhyme 10J","codename":"VT1003J16","model":"VT1003J16"},{"manufacturer":"Vulcan","market_name":"Vulcan Rhyme 7C","codename":"VT0703","model":"VT0703C16"},{"manufacturer":"Vulcan","market_name":"Vulcan VR5533","codename":"VR5533","model":"VR5533"},{"manufacturer":"Vulcan","market_name":"Vulcan VR6031","codename":"VR6031","model":"VR6031"},{"manufacturer":"Vulcan","market_name":"Vulcan VR6032","codename":"VR6032","model":"VR6032"},{"manufacturer":"W&O","market_name":"X6","codename":"X6","model":"X6"},{"manufacturer":"W.e.","market_name":"WETAB700DG","codename":"WETAB700DG","model":"WETAB700DG"},{"manufacturer":"W.e.","market_name":"WeTab1004B","codename":"WeTab1004B","model":"WeTab1004B"},{"manufacturer":"Wacom","market_name":"Cintiq Companion Hybrid 13HD","codename":"CintiqCompanionHybrid13HD","model":"Cintiq Companion Hybrid 13HD"},{"manufacturer":"Waf","market_name":"F803YM","codename":"F803YM","model":"F803YM"},{"manufacturer":"Walton","market_name":"LT750","codename":"LT750","model":"LT750"},{"manufacturer":"Walton","market_name":"Primo E8s","codename":"Primo_E8s","model":"Primo E8s"},{"manufacturer":"Walton","market_name":"Primo EF7","codename":"Primo_EF7","model":"Primo EF7"},{"manufacturer":"Walton","market_name":"Primo F7s","codename":"Primo_F7s","model":"Primo F7s"},{"manufacturer":"Walton","market_name":"Primo F8","codename":"Primo_F8","model":"Primo F8"},{"manufacturer":"Walton","market_name":"Primo G8","codename":"Primo_G8","model":"Primo G8"},{"manufacturer":"Walton","market_name":"Primo GF6","codename":"Primo_GF6","model":"Primo GF6"},{"manufacturer":"Walton","market_name":"Primo GF7","codename":"Primo_GF7","model":"Primo GF7"},{"manufacturer":"Walton","market_name":"Primo GH5","codename":"WBW5615WA","model":"Primo GH5"},{"manufacturer":"Walton","market_name":"Primo GH5 mini","codename":"Primo_GH5_mini","model":"Primo GH5 mini"},{"manufacturer":"Walton","market_name":"Primo GH7","codename":"Primo_GH7","model":"Primo GH7"},{"manufacturer":"Walton","market_name":"Primo GM2","codename":"Primo_GM2","model":"Primo GM2"},{"manufacturer":"Walton","market_name":"Primo GM2 Plus","codename":"Primo_GM2_Plus","model":"Primo GM2 Plus"},{"manufacturer":"Walton","market_name":"Primo GM3","codename":"Primo_GM3","model":"Primo GM3"},{"manufacturer":"Walton","market_name":"Primo GM3+","codename":"Primo_GM3_plus","model":"Primo GM3 plus"},{"manufacturer":"Walton","market_name":"Primo H6+","codename":"Primo_H6_Plus","model":"Primo H6 Plus"},{"manufacturer":"Walton","market_name":"Primo H7","codename":"Primo_H7","model":"Primo H7"},{"manufacturer":"Walton","market_name":"Primo H7s","codename":"Primo_H7s","model":"Primo H7s"},{"manufacturer":"Walton","market_name":"Primo HM4","codename":"Primo_HM4","model":"Primo HM4"},{"manufacturer":"Walton","market_name":"Primo HM4+","codename":"Primo_HM4_PLUS","model":"Primo HM4+"},{"manufacturer":"Walton","market_name":"Primo HM4i","codename":"Primo_HM4i","model":"Primo HM4i"},{"manufacturer":"Walton","market_name":"Primo N3","codename":"Primo_N3","model":"Primo N3"},{"manufacturer":"Walton","market_name":"Primo NF3","codename":"Primo_NF3","model":"Primo NF3"},{"manufacturer":"Walton","market_name":"Primo NH3","codename":"Primo_NH3","model":"Primo NH3"},{"manufacturer":"Walton","market_name":"Primo NH3 Lite","codename":"Primo_NH3_Lite","model":"Primo NH3 Lite"},{"manufacturer":"Walton","market_name":"Primo NH3i","codename":"Primo_NH3i","model":"Primo NH3i"},{"manufacturer":"Walton","market_name":"Primo NX3","codename":"Primo_NX3","model":"Primo_NX3"},{"manufacturer":"Walton","market_name":"Primo NX4","codename":"Primo_NX4","model":"Primo NX4"},{"manufacturer":"Walton","market_name":"Primo NX4 mini","codename":"Primo_NX4_mini","model":"Primo NX4 mini"},{"manufacturer":"Walton","market_name":"Primo R4","codename":"Primo_R4","model":"Primo R4"},{"manufacturer":"Walton","market_name":"Primo R4 Plus","codename":"Primo_R4_Plus","model":"Primo R4 Plus"},{"manufacturer":"Walton","market_name":"Primo R5","codename":"Primo_R5","model":"Primo R5"},{"manufacturer":"Walton","market_name":"Primo RH3","codename":"Primo_RH3","model":"Primo RH3"},{"manufacturer":"Walton","market_name":"Primo RM2 mini","codename":"WBW5616WA","model":"Primo RM2 mini"},{"manufacturer":"Walton","market_name":"Primo RX5","codename":"Primo_RX5","model":"Primo RX5"},{"manufacturer":"Walton","market_name":"Primo RX6","codename":"Primo_RX6","model":"Primo RX6"},{"manufacturer":"Walton","market_name":"Primo S5","codename":"Primo_S5","model":"Primo_S5"},{"manufacturer":"Walton","market_name":"Primo S6","codename":"Primo_S6","model":"Primo S6"},{"manufacturer":"Walton","market_name":"Primo S6 infinity","codename":"Primo_S6_infinity","model":"Primo S6 infinity"},{"manufacturer":"Walton","market_name":"Primo X4","codename":"WALTON_Primo_X4","model":"Primo X4"},{"manufacturer":"Walton","market_name":"Primo X4 Pro","codename":"Primo_X4_Pro","model":"Primo X4 Pro"},{"manufacturer":"Walton","market_name":"Primo ZX2","codename":"GBL5805WA","model":"Primo_ZX2"},{"manufacturer":"Walton","market_name":"Primo ZX2 Lite","codename":"BBL7505WA","model":"Primo ZX2 Lite"},{"manufacturer":"Walton","market_name":"Primo ZX2 mini","codename":"Primo_ZX2_mini","model":"Primo ZX2 mini"},{"manufacturer":"Walton","market_name":"Primo ZX3","codename":"Primo_ZX3","model":"Primo ZX3"},{"manufacturer":"Walton","market_name":"Primo_RM3","codename":"Primo_RM3","model":"Primo RM3"},{"manufacturer":"Walton","market_name":"Primo\\xc2\\xa0S6\\xc2\\xa0Dual","codename":"Primo_S6_Dual","model":"Primo S6 Dual"},{"manufacturer":"Wave 8 Red Nougat","market_name":"WV8R-N","codename":"WV8R_N","model":"WV8R_N"},{"manufacturer":"We (BD)","market_name":"L7","codename":"L7","model":"L7"},{"manufacturer":"We (BD)","market_name":"T1","codename":"WE_T1","model":"T1"},{"manufacturer":"We (BD)","market_name":"WE B3","codename":"WE_B3","model":"WE B3"},{"manufacturer":"We (BD)","market_name":"WE L9","codename":"WE_L9","model":"WE L9"},{"manufacturer":"We (BD)","market_name":"WE R4","codename":"WE_R4","model":"WE R4"},{"manufacturer":"We (BD)","market_name":"WE V4","codename":"WE_V4","model":"WE V4"},{"manufacturer":"WeTek","market_name":"Play","codename":"Play","model":"Play"},{"manufacturer":"WeTek","market_name":"WeTek","codename":"wh220","model":"Air"},{"manufacturer":"Weimei","market_name":"WEIMEI NEON2","codename":"WEIMEI_NEON2","model":"WEIMEI_NEON2"},{"manufacturer":"Weimei","market_name":"weplus 3","codename":"weplus_3","model":"weplus_3"},{"manufacturer":"Welgate","market_name":"WA-U420D","codename":"WA-U420D","model":"WA-U420D"},{"manufacturer":"Wenu","market_name":"Kate","codename":"Wenu","model":"Kate"},{"manufacturer":"Wigor","market_name":"V2","codename":"V2","model":"V2"},{"manufacturer":"Wigor","market_name":"V3","codename":"V3","model":"V3"},{"manufacturer":"Wiko","market_name":"B-KOOL","codename":"V2502AN01D","model":"B-KOOL"},{"manufacturer":"Wiko","market_name":"BIRDY","codename":"BIRDY","model":"BIRDY"},{"manufacturer":"Wiko","market_name":"BLOOM","codename":"s4700","model":"BLOOM"},{"manufacturer":"Wiko","market_name":"Barry","codename":"s7811","model":"BARRY"},{"manufacturer":"Wiko","market_name":"C800","codename":"W_C800S","model":"W_C800S"},{"manufacturer":"Wiko","market_name":"C860","codename":"W_C860","model":"W_C860"},{"manufacturer":"Wiko","market_name":"CINK SLIM 2","codename":"s8074","model":"CINK SLIM 2"},{"manufacturer":"Wiko","market_name":"DARKFULL","codename":"s9311","model":"DARKFULL"},{"manufacturer":"Wiko","market_name":"DARKFULL","codename":"s9311","model":"Dream"},{"manufacturer":"Wiko","market_name":"DARKNIGHT","codename":"s9203","model":"DARKNIGHT"},{"manufacturer":"Wiko","market_name":"DARKNIGHT","codename":"s9203","model":"X-tremer"},{"manufacturer":"Wiko","market_name":"FEVER","codename":"L5460AP25E","model":"FEVER"},{"manufacturer":"Wiko","market_name":"FEVER","codename":"l5460","model":"FEVER"},{"manufacturer":"Wiko","market_name":"FEVER","codename":"l5460","model":"Ridge 4G-Fever"},{"manufacturer":"Wiko","market_name":"FREDDY","codename":"T3903BN","model":"FREDDY"},{"manufacturer":"Wiko","market_name":"FREDDY","codename":"V3903BN","model":"FREDDY"},{"manufacturer":"Wiko","market_name":"GETAWAY","codename":"s8812","model":"GETAWAY"},{"manufacturer":"Wiko","market_name":"GOA","codename":"s3511","model":"GOA"},{"manufacturer":"Wiko","market_name":"HARRY","codename":"V3953AN25K","model":"HARRY"},{"manufacturer":"Wiko","market_name":"HARRY","codename":"v3953","model":"HARRY"},{"manufacturer":"Wiko","market_name":"HIGHWAY","codename":"s9320","model":"HIGHWAY"},{"manufacturer":"Wiko","market_name":"HIGHWAY 4G","codename":"s9321","model":"HIGHWAY 4G"},{"manufacturer":"Wiko","market_name":"HIGHWAY PURE","codename":"l9010","model":"HIGHWAY PURE"},{"manufacturer":"Wiko","market_name":"HIGHWAY SIGNS","codename":"s4750","model":"HIGHWAY SIGNS"},{"manufacturer":"Wiko","market_name":"HIGHWAY STAR","codename":"l5560ae","model":"HIGHWAY STAR"},{"manufacturer":"Wiko","market_name":"IGGY","codename":"s7521","model":"Cynus F4"},{"manufacturer":"Wiko","market_name":"IGGY","codename":"s7521","model":"Golf"},{"manufacturer":"Wiko","market_name":"IGGY","codename":"s7521","model":"IGGY"},{"manufacturer":"Wiko","market_name":"JERRY","codename":"V2802AN","model":"JERRY"},{"manufacturer":"Wiko","market_name":"JERRY","codename":"v2806","model":"JERRY"},{"manufacturer":"Wiko","market_name":"JERRY MAX","codename":"V3610AN","model":"JERRY MAX"},{"manufacturer":"Wiko","market_name":"JERRY2","codename":"v2610","model":"JERRY2"},{"manufacturer":"Wiko","market_name":"JIMMY","codename":"s4300ae","model":"JIMMY"},{"manufacturer":"Wiko","market_name":"K-KOOL","codename":"T2800AN","model":"K-KOOL"},{"manufacturer":"Wiko","market_name":"K-KOOL","codename":"V2800AN","model":"K-KOOL"},{"manufacturer":"Wiko","market_name":"KENNY","codename":"V3913BN22I","model":"KENNY"},{"manufacturer":"Wiko","market_name":"KENNY","codename":"v3913","model":"KENNY"},{"manufacturer":"Wiko","market_name":"KITE","codename":"l4020","model":"KITE"},{"manufacturer":"Wiko","market_name":"LENNY","codename":"s5201ap","model":"LENNY"},{"manufacturer":"Wiko","market_name":"LENNY2","codename":"S5030AP12H","model":"LENNY2"},{"manufacturer":"Wiko","market_name":"LENNY2","codename":"s5030","model":"LENNY2"},{"manufacturer":"Wiko","market_name":"LENNY3","codename":"V3702AN","model":"LENNY3"},{"manufacturer":"Wiko","market_name":"LENNY3 MAX","codename":"V3802AN","model":"LENNY3 MAX"},{"manufacturer":"Wiko","market_name":"Lenny4","codename":"v3720","model":"Lenny4"},{"manufacturer":"Wiko","market_name":"Lenny4 Plus","codename":"v3740","model":"Lenny4 Plus"},{"manufacturer":"Wiko","market_name":"MACARON","codename":"l8401_international","model":"MACARON"},{"manufacturer":"Wiko","market_name":"P4903JP","codename":"P4903JP","model":"P4903JP"},{"manufacturer":"Wiko","market_name":"PULP","codename":"S5420","model":"PULP"},{"manufacturer":"Wiko","market_name":"PULP 4G","codename":"l5421","model":"PULP 4G"},{"manufacturer":"Wiko","market_name":"PULP FAB","codename":"S5260","model":"PULP FAB"},{"manufacturer":"Wiko","market_name":"PULP FAB","codename":"S5260","model":"SLIDE2"},{"manufacturer":"Wiko","market_name":"PULP FAB 4G","codename":"l5261","model":"PULP FAB 4G"},{"manufacturer":"Wiko","market_name":"RAINBOW","codename":"s5501","model":"RAINBOW"},{"manufacturer":"Wiko","market_name":"RAINBOW 4G","codename":"l5503","model":"RAINBOW 4G"},{"manufacturer":"Wiko","market_name":"RAINBOW JAM","codename":"S5254AP24K","model":"RAINBOW JAM"},{"manufacturer":"Wiko","market_name":"RAINBOW JAM","codename":"s5250","model":"RAINBOW JAM"},{"manufacturer":"Wiko","market_name":"RAINBOW JAM","codename":"s5254","model":"RAINBOW JAM"},{"manufacturer":"Wiko","market_name":"RAINBOW LITE","codename":"s5222","model":"RAINBOW LITE"},{"manufacturer":"Wiko","market_name":"RAINBOW LITE 4G","codename":"L5221","model":"RAINBOW LITE 4G"},{"manufacturer":"Wiko","market_name":"RAINBOW LITE 4G","codename":"L5221AE23G","model":"RAINBOW LITE 4G"},{"manufacturer":"Wiko","market_name":"RAINBOW LITE 4G","codename":"L5225AC","model":"RAINBOW LITE 4G"},{"manufacturer":"Wiko","market_name":"RAINBOW LITE 4G","codename":"L5227AC","model":"RAINBOW LITE 4G"},{"manufacturer":"Wiko","market_name":"RAINBOW LITE 4G","codename":"L5251","model":"RAINBOW JAM 4G"},{"manufacturer":"Wiko","market_name":"RAINBOW UP","codename":"s5400","model":"RAINBOW UP"},{"manufacturer":"Wiko","market_name":"RAINBOW UP 4G","codename":"l5401","model":"RAINBOW UP 4G"},{"manufacturer":"Wiko","market_name":"RIDGE\\t\\t","codename":"s5513ap","model":"RIDGE"},{"manufacturer":"Wiko","market_name":"RIDGE 4G","codename":"l5510","model":"RIDGE 4G"},{"manufacturer":"Wiko","market_name":"RIDGE FAB 4G","codename":"l5320","model":"RIDGE FAB 4G"},{"manufacturer":"Wiko","market_name":"ROBBY","codename":"V3750AN","model":"ROBBY"},{"manufacturer":"Wiko","market_name":"ROBBY","codename":"V3750AN24K","model":"ROBBY"},{"manufacturer":"Wiko","market_name":"ROBBY2","codename":"V3921","model":"ROBBY2"},{"manufacturer":"Wiko","market_name":"SELFY","codename":"SELFY","model":"SELFY"},{"manufacturer":"Wiko","market_name":"SELFY 4G","codename":"l4801","model":"SELFY 4G"},{"manufacturer":"Wiko","market_name":"SLIDE","codename":"s8321","model":"SLIDE"},{"manufacturer":"Wiko","market_name":"SUGAR F7 mini","codename":"p7203","model":"SUGAR F7 mini"},{"manufacturer":"Wiko","market_name":"SUGAR S9","codename":"i9031","model":"SUGAR S9"},{"manufacturer":"Wiko","market_name":"SUNNY","codename":"T2504AN","model":"SUNNY"},{"manufacturer":"Wiko","market_name":"SUNNY","codename":"V2502AN","model":"SUNNY"},{"manufacturer":"Wiko","market_name":"SUNNY","codename":"V2504AN","model":"SUNNY"},{"manufacturer":"Wiko","market_name":"SUNNY","codename":"V2504AN01D","model":"SUNNY"},{"manufacturer":"Wiko","market_name":"SUNNY","codename":"V2508AN01D","model":"SUNNY"},{"manufacturer":"Wiko","market_name":"SUNNY","codename":"v2508","model":"SUNNY"},{"manufacturer":"Wiko","market_name":"SUNNY MAX","codename":"T2520AN","model":"SUNNY MAX"},{"manufacturer":"Wiko","market_name":"SUNNY MAX","codename":"v2520","model":"SUNNY MAX"},{"manufacturer":"Wiko","market_name":"SUNNY2","codename":"v2510","model":"SUNNY2"},{"manufacturer":"Wiko","market_name":"SUNSET","codename":"s4011","model":"SUNSET"},{"manufacturer":"Wiko","market_name":"SUNSET2","codename":"s4050ap","model":"SUNSET2"},{"manufacturer":"Wiko","market_name":"Sunny2 Plus","codename":"v2600cn","model":"Sunny2 Plus"},{"manufacturer":"Wiko","market_name":"TOMMY","codename":"P4901AC","model":"TOMMY"},{"manufacturer":"Wiko","market_name":"TOMMY","codename":"P4903LA","model":"TOMMY"},{"manufacturer":"Wiko","market_name":"TOMMY2","codename":"T3931AC","model":"TOMMY2"},{"manufacturer":"Wiko","market_name":"TOMMY2","codename":"V3931AC","model":"TOMMY2"},{"manufacturer":"Wiko","market_name":"TOMMY2","codename":"V3933AC","model":"TOMMY2"},{"manufacturer":"Wiko","market_name":"Tommy2 Plus","codename":"v3941","model":"Tommy2 Plus"},{"manufacturer":"Wiko","market_name":"Tommy3","codename":"W_C201","model":"Tommy3"},{"manufacturer":"Wiko","market_name":"U FEEL","codename":"P6601AE","model":"U FEEL"},{"manufacturer":"Wiko","market_name":"U FEEL","codename":"P6609BC","model":"U FEEL"},{"manufacturer":"Wiko","market_name":"U FEEL","codename":"P6609BCD","model":"U FEEL"},{"manufacturer":"Wiko","market_name":"U FEEL FAB","codename":"V3991AN","model":"SUGAR Y7 MAX"},{"manufacturer":"Wiko","market_name":"U FEEL FAB","codename":"V3991AN","model":"SUGAR Y8"},{"manufacturer":"Wiko","market_name":"U FEEL FAB","codename":"V3991AN","model":"U FEEL FAB"},{"manufacturer":"Wiko","market_name":"U FEEL GO","codename":"P4661AN","model":"U FEEL GO"},{"manufacturer":"Wiko","market_name":"U FEEL LITE","codename":"P4601AN","model":"U FEEL LITE"},{"manufacturer":"Wiko","market_name":"U FEEL LITE","codename":"T4601AN","model":"U FEEL LITE"},{"manufacturer":"Wiko","market_name":"U FEEL PRIME","codename":"p7201","model":"U FEEL PRIME"},{"manufacturer":"Wiko","market_name":"U PULSE","codename":"v3961","model":"U PULSE"},{"manufacturer":"Wiko","market_name":"U PULSE LITE","codename":"v3971","model":"U PULSE LITE"},{"manufacturer":"Wiko","market_name":"VIEW","codename":"v12dnlite","model":"View"},{"manufacturer":"Wiko","market_name":"VIEW","codename":"v12enlite","model":"View"},{"manufacturer":"Wiko","market_name":"View","codename":"v12bnlite","model":"View"},{"manufacturer":"Wiko","market_name":"View Max","codename":"W_P200","model":"View Max"},{"manufacturer":"Wiko","market_name":"View Prime","codename":"v12bn","model":"View Prime"},{"manufacturer":"Wiko","market_name":"View XL","codename":"v11cnlite","model":"View XL"},{"manufacturer":"Wiko","market_name":"WAX","codename":"s8515","model":"WAX"},{"manufacturer":"Wiko","market_name":"WC300","codename":"WC300","model":"WC300"},{"manufacturer":"Wiko","market_name":"WC300SN","codename":"WC300SN","model":"WC300SN"},{"manufacturer":"Wiko","market_name":"WIM","codename":"T9051AC","model":"WIM"},{"manufacturer":"Wiko","market_name":"WIM","codename":"i9051","model":"WIM"},{"manufacturer":"Wiko","market_name":"WIM Lite","codename":"T6901AC","model":"WIM Lite"},{"manufacturer":"Wiko","market_name":"WIM Lite","codename":"p6901","model":"WIM Lite"},{"manufacturer":"Wiko","market_name":"W_C200SN","codename":"W_C200SN","model":"W_C200SN"},{"manufacturer":"Wiko","market_name":"W_C800","codename":"W_C800","model":"W_C800"},{"manufacturer":"Wiko","market_name":"W_K300","codename":"W_K300","model":"W_K300"},{"manufacturer":"Wiko","market_name":"W_K400","codename":"W_K400","model":"W_K400"},{"manufacturer":"Wiko","market_name":"W_K600","codename":"W_K600","model":"W_K600"},{"manufacturer":"Wiko","market_name":"W_P130","codename":"W_P130","model":"W_P130"},{"manufacturer":"Wiko","market_name":"W_P200","codename":"W_P200","model":"W_P200"},{"manufacturer":"Wiko","market_name":"W_P200CM","codename":"W_P200CM","model":"View Max"},{"manufacturer":"Wiko","market_name":"W_P200CM","codename":"W_P200CM","model":"W_P200CM"},{"manufacturer":"Wileyfox","market_name":"Spark","codename":"porridge","model":"Wileyfox Spark"},{"manufacturer":"Wileyfox","market_name":"Spark","codename":"porridge","model":"Wileyfox Spark +"},{"manufacturer":"Wileyfox","market_name":"Spark","codename":"porridgek3","model":"Wileyfox Spark X"},{"manufacturer":"Wileyfox","market_name":"Spark Add-X","codename":"porridge","model":"Wileyfox Spark"},{"manufacturer":"Wileyfox","market_name":"Spark Add-X","codename":"porridge","model":"Wileyfox Spark +"},{"manufacturer":"Wileyfox","market_name":"Spark X","codename":"porridgek3","model":"Wileyfox Spark X"},{"manufacturer":"Wileyfox","market_name":"Spark X Add-X","codename":"porridgek3","model":"Wileyfox Spark X"},{"manufacturer":"Wileyfox","market_name":"Storm","codename":"kipper","model":"Wileyfox Storm"},{"manufacturer":"Wileyfox","market_name":"Swift","codename":"crackling","model":"Wileyfox Swift"},{"manufacturer":"Wileyfox","market_name":"Swift 2","codename":"marmite","model":"Swift 2"},{"manufacturer":"Wileyfox","market_name":"Swift 2","codename":"marmite","model":"Swift 2 Plus"},{"manufacturer":"Wileyfox","market_name":"Swift 2","codename":"marmite","model":"Swift 2 X"},{"manufacturer":"Wileyfox","market_name":"Swift 2","codename":"marmite","model":"Wileyfox Swift 2 Plus"},{"manufacturer":"Wileyfox","market_name":"Swift2 Add-X","codename":"marmite","model":"Swift 2 Plus"},{"manufacturer":"Wink","market_name":"City S","codename":"Wink_City_S","model":"Wink_City_S"},{"manufacturer":"Wink","market_name":"Glory_SE","codename":"Wink_Glory_SE","model":"Wink Glory SE"},{"manufacturer":"Wink","market_name":"Share SE","codename":"Wink_Share_SE","model":"Wink_Share_SE"},{"manufacturer":"Wink","market_name":"World SE","codename":"Wink_World_SE","model":"Wink World SE"},{"manufacturer":"Winmax","market_name":"Tiger X4","codename":"TIGER_X4","model":"TIGER X4"},{"manufacturer":"Winmax","market_name":"Tiger_X10","codename":"TIGER_X10","model":"TIGER_X10"},{"manufacturer":"Wintec","market_name":"T730","codename":"T730","model":"Clear"},{"manufacturer":"Wintec","market_name":"T730","codename":"T730","model":"T730"},{"manufacturer":"Wintec","market_name":"T750","codename":"T750","model":"Clear"},{"manufacturer":"Wistron","market_name":"DW-21(A)","codename":"DA-21","model":"DW-21(A)"},{"manufacturer":"Wistron","market_name":"W1011A","codename":"w1011a","model":"W1011A"},{"manufacturer":"Wizz","market_name":"DV-PTB1080","codename":"DV-PTB1080","model":"DV-PTB1080"},{"manufacturer":"Woongjin","market_name":"WoongjinThinkbig","codename":"BP-1001","model":"BP-1001"},{"manufacturer":"Woxter","market_name":"Woxter","codename":"Woxter_N70","model":"Woxter_N70"},{"manufacturer":"Woxter","market_name":"Woxter_N100","codename":"Woxter_N100","model":"Woxter_N100"},{"manufacturer":"Woxter","market_name":"Woxter_N200","codename":"Woxter_N200","model":"Woxter_N200"},{"manufacturer":"Woxter","market_name":"Woxter_N90","codename":"Woxter_N90","model":"Woxter_N90"},{"manufacturer":"X-TIGI","market_name":"V21","codename":"X-TIGI_V21","model":"X-TIGI_V21"},{"manufacturer":"X-TIGI","market_name":"V3+","codename":"X-TIGI_V3_Plus","model":"X-TIGI_V3+"},{"manufacturer":"X-TIGI","market_name":"X-TIGI_V13","codename":"X-TIGI_V13","model":"X-TIGI_V13"},{"manufacturer":"X-TIGI","market_name":"X-TIGI_V33","codename":"X-TIGI_V33","model":"X-TIGI_V33"},{"manufacturer":"X-TIGI","market_name":"X_TIGI_A1","codename":"X_TIGI_A1","model":"X_TIGI_A1"},{"manufacturer":"X-TIGI","market_name":"X_TIGI_A1Plus","codename":"X_TIGI_A1Plus","model":"X_TIGI_A1Plus"},{"manufacturer":"X-TIGI","market_name":"X_TIGI_A2","codename":"X_TIGI_A2","model":"X_TIGI_A2"},{"manufacturer":"X-View","market_name":"AMBER_KIDS","codename":"AMBER_KIDS","model":"AMBER_KIDS"},{"manufacturer":"X-View","market_name":"PROTON_AMBER_HD","codename":"Proton_Amber_HD","model":"Proton_Amber_HD"},{"manufacturer":"Xcell","market_name":"Enia","codename":"Xcell_Enia","model":"Enia"},{"manufacturer":"Xcell","market_name":"Zoom","codename":"Xcell_Zoom","model":"Zoom"},{"manufacturer":"Xiaomi","market_name":"China","codename":"braveheart","model":"MiTV"},{"manufacturer":"Xiaomi","market_name":"HM 1SC","codename":"armani","model":"HM 1AC"},{"manufacturer":"Xiaomi","market_name":"HM 1SC","codename":"armani","model":"HM 1S"},{"manufacturer":"Xiaomi","market_name":"HM 1SC","codename":"armani","model":"HM 1SC"},{"manufacturer":"Xiaomi","market_name":"HM 1SC","codename":"armani","model":"HM 1SW"},{"manufacturer":"Xiaomi","market_name":"HM 1SLTETD","codename":"HM2014501","model":"2014501"},{"manufacturer":"Xiaomi","market_name":"HM 1STD","codename":"HM2014011","model":"2014011"},{"manufacturer":"Xiaomi","market_name":"HM 2A","codename":"lte26007","model":"2014502"},{"manufacturer":"Xiaomi","market_name":"HM 2A","codename":"lte26007","model":"HM 2A"},{"manufacturer":"Xiaomi","market_name":"HM 2LTE-BR","codename":"HM2014819","model":"2014819"},{"manufacturer":"Xiaomi","market_name":"HM 2LTE-CMCC","codename":"HM2014813","model":"2014813"},{"manufacturer":"Xiaomi","market_name":"HM 2LTE-CT","codename":"HM2014812","model":"2014812"},{"manufacturer":"Xiaomi","market_name":"HM 2LTE-CU","codename":"HM2014811","model":"2014811"},{"manufacturer":"Xiaomi","market_name":"HM 2LTE-IN","codename":"HM2014818","model":"2014818"},{"manufacturer":"Xiaomi","market_name":"HM 2LTE-SA","codename":"HM2014817","model":"2014817"},{"manufacturer":"Xiaomi","market_name":"HM NOTE 1LTETD","codename":"dior","model":"HM NOTE 1LTE"},{"manufacturer":"Xiaomi","market_name":"HM NOTE 1LTETD","codename":"dior","model":"HM NOTE 1LTETD"},{"manufacturer":"Xiaomi","market_name":"HM NOTE 1LTETD","codename":"dior","model":"HM NOTE 1LTEW"},{"manufacturer":"Xiaomi","market_name":"HM NOTE 1S CT","codename":"gucci","model":"HM NOTE 1S"},{"manufacturer":"Xiaomi","market_name":"HM NOTE 1S CT","codename":"gucci","model":"gucci"},{"manufacturer":"Xiaomi","market_name":"HM NOTE 1TD","codename":"lcsh92_wet_tdd","model":"HM NOTE 1TD"},{"manufacturer":"Xiaomi","market_name":"HM NOTE 1W","codename":"lcsh92_wet_jb9","model":"HM NOTE 1W"},{"manufacturer":"Xiaomi","market_name":"HM Note 2","codename":"hermes","model":"Redmi Note 2"},{"manufacturer":"Xiaomi","market_name":"Hong Mi","codename":"HM2013022","model":"2013022"},{"manufacturer":"Xiaomi","market_name":"MI 2","codename":"aries","model":"MI 2"},{"manufacturer":"Xiaomi","market_name":"MI 2","codename":"aries","model":"MI 2S"},{"manufacturer":"Xiaomi","market_name":"MI 2A","codename":"taurus","model":"MI 2A"},{"manufacturer":"Xiaomi","market_name":"MI 3W","codename":"cancro","model":"MI 3W"},{"manufacturer":"Xiaomi","market_name":"MI 4LTE","codename":"cancro","model":"MI 4C"},{"manufacturer":"Xiaomi","market_name":"MI 4LTE","codename":"cancro","model":"MI 4LTE"},{"manufacturer":"Xiaomi","market_name":"MI 4LTE","codename":"cancro","model":"MI 4W"},{"manufacturer":"Xiaomi","market_name":"MI 4LTE-CT","codename":"cancro","model":"MI 4LTE"},{"manufacturer":"Xiaomi","market_name":"MI 4s","codename":"aqua","model":"MI 4S"},{"manufacturer":"Xiaomi","market_name":"MI 5C","codename":"meri","model":"MI 5C"},{"manufacturer":"Xiaomi","market_name":"MI 5C","codename":"meri","model":"Meri"},{"manufacturer":"Xiaomi","market_name":"MI 5X","codename":"tiffany","model":"MI 5X"},{"manufacturer":"Xiaomi","market_name":"MI 5s Plus","codename":"natrium","model":"MI 5s Plus"},{"manufacturer":"Xiaomi","market_name":"MI 6X","codename":"wayne","model":"MI 6X"},{"manufacturer":"Xiaomi","market_name":"MI MAX","codename":"helium","model":"MI MAX"},{"manufacturer":"Xiaomi","market_name":"MI MAX","codename":"hydrogen","model":"MI MAX"},{"manufacturer":"Xiaomi","market_name":"MI MAX 2","codename":"oxygen","model":"MI MAX 2"},{"manufacturer":"Xiaomi","market_name":"MI MIX 2S","codename":"polaris","model":"Mi MIX 2S"},{"manufacturer":"Xiaomi","market_name":"MI NOTE LTE","codename":"virgo","model":"MI NOTE LTE"},{"manufacturer":"Xiaomi","market_name":"MI NOTE Pro","codename":"leo","model":"MI NOTE Pro"},{"manufacturer":"Xiaomi","market_name":"MI Note 3","codename":"jason","model":"Mi Note 3"},{"manufacturer":"Xiaomi","market_name":"MI PAD","codename":"mocha","model":"MI PAD"},{"manufacturer":"Xiaomi","market_name":"MI PAD 3","codename":"cappu","model":"MI PAD 3"},{"manufacturer":"Xiaomi","market_name":"MI6","codename":"sagit","model":"MI 6"},{"manufacturer":"Xiaomi","market_name":"MIBOXPRO","codename":"kungfupanda","model":"MiBOX_PRO"},{"manufacturer":"Xiaomi","market_name":"MIPAD2","codename":"latte","model":"MI PAD 2"},{"manufacturer":"Xiaomi","market_name":"MITV3S","codename":"missionimpossible","model":"MiTV3S"},{"manufacturer":"Xiaomi","market_name":"MITV3S-55/60","codename":"pulpfiction","model":"MiTV3S"},{"manufacturer":"Xiaomi","market_name":"MITV3S-55/60","codename":"pulpfiction","model":"MiTV4"},{"manufacturer":"Xiaomi","market_name":"MIX","codename":"lithium","model":"MIX"},{"manufacturer":"Xiaomi","market_name":"MIX","codename":"lithium","model":"lithium"},{"manufacturer":"Xiaomi","market_name":"MIX 2","codename":"chiron","model":"MIX 2"},{"manufacturer":"Xiaomi","market_name":"MIX 2","codename":"chiron","model":"Mi MIX 2"},{"manufacturer":"Xiaomi","market_name":"MIX 2S","codename":"polaris","model":"MIX 2S"},{"manufacturer":"Xiaomi","market_name":"MIX 2S","codename":"polaris","model":"Mi MIX 2S"},{"manufacturer":"Xiaomi","market_name":"Mi 3","codename":"pisces","model":"MI 3"},{"manufacturer":"Xiaomi","market_name":"Mi 4c","codename":"libra","model":"Mi-4c"},{"manufacturer":"Xiaomi","market_name":"Mi 4i","codename":"ferrari","model":"Mi 4i"},{"manufacturer":"Xiaomi","market_name":"Mi 5","codename":"gemini","model":"MI 5"},{"manufacturer":"Xiaomi","market_name":"Mi 5s","codename":"capricorn","model":"MI 5s"},{"manufacturer":"Xiaomi","market_name":"Mi A1","codename":"tissot_sprout","model":"MI A1"},{"manufacturer":"Xiaomi","market_name":"Mi A1","codename":"tissot_sprout","model":"Mi A1"},{"manufacturer":"Xiaomi","market_name":"Mi Box","codename":"once","model":"MIBOX3"},{"manufacturer":"Xiaomi","market_name":"Mi Note","codename":"virgo","model":"MI NOTE LTE"},{"manufacturer":"Xiaomi","market_name":"Mi Note2","codename":"scorpio","model":"Mi Note 2"},{"manufacturer":"Xiaomi","market_name":"MiBOX1S","codename":"casablanca","model":"MiBOX1S"},{"manufacturer":"Xiaomi","market_name":"MiBOX2","codename":"dredd","model":"MiBOX2"},{"manufacturer":"Xiaomi","market_name":"MiBOX3S","codename":"queenchristina","model":"MiBOX3S"},{"manufacturer":"Xiaomi","market_name":"MiBOX_mini","codename":"forrestgump","model":"MiBOX_mini"},{"manufacturer":"Xiaomi","market_name":"MiTV2","codename":"entrapment","model":"MiTV2"},{"manufacturer":"Xiaomi","market_name":"Redmi","codename":"HM2013023","model":"2013023"},{"manufacturer":"Xiaomi","market_name":"Redmi  S2","codename":"ysl","model":"Redmi S2"},{"manufacturer":"Xiaomi","market_name":"Redmi 3","codename":"ido","model":"Redmi 3"},{"manufacturer":"Xiaomi","market_name":"Redmi 3","codename":"ido","model":"ido"},{"manufacturer":"Xiaomi","market_name":"Redmi 3S","codename":"land","model":"Redmi 3S"},{"manufacturer":"Xiaomi","market_name":"Redmi 4","codename":"prada","model":"Redmi 4"},{"manufacturer":"Xiaomi","market_name":"Redmi 4 Pro","codename":"markw","model":"Redmi 4"},{"manufacturer":"Xiaomi","market_name":"Redmi 4A","codename":"rolex","model":"Redmi 4A"},{"manufacturer":"Xiaomi","market_name":"Redmi 4X","codename":"santoni","model":"Redmi 4X"},{"manufacturer":"Xiaomi","market_name":"Redmi 4X","codename":"santoni","model":"santoni"},{"manufacturer":"Xiaomi","market_name":"Redmi 5","codename":"rosy","model":"Redmi 5"},{"manufacturer":"Xiaomi","market_name":"Redmi 5 Plus","codename":"vince","model":"Redmi 5 Plus"},{"manufacturer":"Xiaomi","market_name":"Redmi 5 Plus","codename":"vince","model":"Redmi Note 5"},{"manufacturer":"Xiaomi","market_name":"Redmi 5A","codename":"riva","model":"Redmi 5A"},{"manufacturer":"Xiaomi","market_name":"Redmi Note 3","codename":"hennessy","model":"Redmi Note 3"},{"manufacturer":"Xiaomi","market_name":"Redmi Note 3","codename":"kate","model":"Redmi Note 3"},{"manufacturer":"Xiaomi","market_name":"Redmi Note 3","codename":"kenzo","model":"Redmi Note 3"},{"manufacturer":"Xiaomi","market_name":"Redmi Note 4","codename":"mido","model":"Redmi Note 4"},{"manufacturer":"Xiaomi","market_name":"Redmi Note 4","codename":"mido","model":"Redmi Note 4X"},{"manufacturer":"Xiaomi","market_name":"Redmi Note 4","codename":"nikel","model":"Redmi Note 4"},{"manufacturer":"Xiaomi","market_name":"Redmi Note 5","codename":"whyred","model":"Redmi Note 5"},{"manufacturer":"Xiaomi","market_name":"Redmi Note 5 Pro","codename":"whyred","model":"Redmi Note 5"},{"manufacturer":"Xiaomi","market_name":"Redmi Note 5 Pro","codename":"whyred","model":"Redmi Note 5 Pro"},{"manufacturer":"Xiaomi","market_name":"Redmi Note 5A","codename":"ugg","model":"Redmi Note 5A"},{"manufacturer":"Xiaomi","market_name":"Redmi Note 5A","codename":"ugg","model":"Redmi Y1"},{"manufacturer":"Xiaomi","market_name":"Redmi Note 5A","codename":"ugglite","model":"Redmi Note 5A"},{"manufacturer":"Xiaomi","market_name":"Redmi Pro","codename":"omega","model":"Redmi Pro"},{"manufacturer":"Xiaomi","market_name":"Redmi S2","codename":"ysl","model":"Redmi S2"},{"manufacturer":"Xiaomi","market_name":"TELEBEE","codename":"once","model":"MIBOX3"},{"manufacturer":"Xolo","market_name":"Era 2X 2GB","codename":"XE2X","model":"Era 2X"},{"manufacturer":"Xolo","market_name":"Era 2X 3GB","codename":"XE2X3GB","model":"Era 2X 3GB"},{"manufacturer":"Xolo","market_name":"Era3","codename":"Era_3","model":"Era 3"},{"manufacturer":"Xolo","market_name":"XOLO ERA 2V","codename":"Era_2V","model":"Era 2V"},{"manufacturer":"Xolo","market_name":"XOLO ERA 3X","codename":"Era_3X","model":"era3x"},{"manufacturer":"Xolo","market_name":"era1X","codename":"era1X","model":"era1X"},{"manufacturer":"Xplore Technologies","market_name":"RangerX","codename":"iX101T1","model":"iX101T1"},{"manufacturer":"Xplore Technologies","market_name":"RangerX","codename":"iX101T1_2G","model":"iX101T1-2G"},{"manufacturer":"Xplore Technologies","market_name":"XSLATE_D10","codename":"XSLATE_D10","model":"iX101B1"},{"manufacturer":"Xplore Technologies","market_name":"XSLATE_D10","codename":"XSLATE_D10","model":"iX101D1"},{"manufacturer":"Xplore Technologies","market_name":"XSLATE_D10","codename":"XSLATE_D10","model":"iX101D1-FIOS"},{"manufacturer":"Xtratech","market_name":"X739Q","codename":"bnd8163_tb_n","model":"X739Q"},{"manufacturer":"YU","market_name":"YUNICORN","codename":"YUNICORN","model":"YU5530"},{"manufacturer":"YU","market_name":"YUNIQUE","codename":"YU4711","model":"YU4711"},{"manufacturer":"YU","market_name":"YUPHORIA","codename":"YUPHORIA","model":"YU5010"},{"manufacturer":"YU","market_name":"YUPHORIA","codename":"YUPHORIA","model":"YU5010A"},{"manufacturer":"YU","market_name":"YUREKA","codename":"YUREKA","model":"YU5510"},{"manufacturer":"YU","market_name":"YUREKAS","codename":"YUREKAS","model":"YU5200"},{"manufacturer":"YU","market_name":"Yunique 2","codename":"YU5011","model":"YU5011"},{"manufacturer":"YU","market_name":"Yureka","codename":"YUREKA","model":"AO5510"},{"manufacturer":"YU","market_name":"Yureka","codename":"YUREKA","model":"YU5510"},{"manufacturer":"YU","market_name":"Yureka","codename":"YUREKA","model":"YU5510A"},{"manufacturer":"YU","market_name":"Yureka","codename":"YUREKA","model":"YUREKA"},{"manufacturer":"YU","market_name":"Yureka Black","codename":"YU5040","model":"YU5040"},{"manufacturer":"YU","market_name":"Yureka Black","codename":"YU5041","model":"YU5041"},{"manufacturer":"YU","market_name":"Yureka Note","codename":"YU6000","model":"YU 6000"},{"manufacturer":"Yes","market_name":"Altitude 2","codename":"M651G_MY","model":"M651G_MY"},{"manufacturer":"Yes","market_name":"M631Y","codename":"M631Y","model":"M631Y"},{"manufacturer":"Yes","market_name":"STING","codename":"dwi765yes","model":"STING"},{"manufacturer":"Yezz","market_name":"4E","codename":"4E","model":"4E"},{"manufacturer":"Yezz","market_name":"5.5M","codename":"5_5M","model":"5.5M"},{"manufacturer":"Yezz","market_name":"5E","codename":"5E","model":"5E"},{"manufacturer":"Yezz","market_name":"5E4","codename":"5E4","model":"5E4"},{"manufacturer":"Yezz","market_name":"EPIC_T","codename":"EPIC_T","model":"EPIC T"},{"manufacturer":"Yota Devices","market_name":"C9660","codename":"yotaphone","model":"C9660"},{"manufacturer":"Yota Devices","market_name":"YotaPhone2","codename":"yotaphone2","model":"YD201"},{"manufacturer":"Yuho","market_name":"Y2","codename":"YUHO_Y2","model":"YUHO_Y2"},{"manufacturer":"Yuho","market_name":"Y2_PRO","codename":"YUHO_Y2_PRO","model":"YUHO_Y2_PRO"},{"manufacturer":"Yuho","market_name":"YUHO_O1","codename":"YUHO_O1","model":"YUHO_O1"},{"manufacturer":"Yuho","market_name":"YUHO_O1","codename":"YUHO_O1_LITE","model":"YUHO_O1_LITE"},{"manufacturer":"ZTE","market_name":"","codename":"BUL_P726G","model":"ZTE-RACER"},{"manufacturer":"ZTE","market_name":"","codename":"D930","model":"D930"},{"manufacturer":"ZTE","market_name":"","codename":"Grand-S","model":"ZTE Grand S"},{"manufacturer":"ZTE","market_name":"","codename":"N720","model":"N720"},{"manufacturer":"ZTE","market_name":"","codename":"N720_Micromax","model":"Micromax A60"},{"manufacturer":"ZTE","market_name":"","codename":"N721","model":"N721"},{"manufacturer":"ZTE","market_name":"","codename":"N721","model":"ZTE-U N721"},{"manufacturer":"ZTE","market_name":"","codename":"N721","model":"ZTE_U N721"},{"manufacturer":"ZTE","market_name":"","codename":"N8010_CT","model":"ZXY-ZTE_N8010"},{"manufacturer":"ZTE","market_name":"","codename":"N8010_CT_BL","model":"ZXY-ZTE_N8010"},{"manufacturer":"ZTE","market_name":"","codename":"N8300_CT","model":"ZXY-ZTE N8300"},{"manufacturer":"ZTE","market_name":"","codename":"NX501","model":"NX501"},{"manufacturer":"ZTE","market_name":"","codename":"P117A11","model":"ZTE U807"},{"manufacturer":"ZTE","market_name":"","codename":"P117A13","model":"ZTE U807N"},{"manufacturer":"ZTE","market_name":"","codename":"P117A20qHD","model":"ZTE U817"},{"manufacturer":"ZTE","market_name":"","codename":"P117A30","model":"ZTE U935"},{"manufacturer":"ZTE","market_name":"","codename":"P117T21","model":"ZTE U960E"},{"manufacturer":"ZTE","market_name":"","codename":"P188T10","model":"ZTE U956"},{"manufacturer":"ZTE","market_name":"","codename":"P188T20","model":"ZTE U819"},{"manufacturer":"ZTE","market_name":"","codename":"P253A20","model":"ZTE V768"},{"manufacturer":"ZTE","market_name":"","codename":"P722G","model":"ZTE-U X876"},{"manufacturer":"ZTE","market_name":"","codename":"P726CU","model":"ZTE-U X850"},{"manufacturer":"ZTE","market_name":"","codename":"P726G","model":"ZTE-LINK"},{"manufacturer":"ZTE","market_name":"","codename":"P726G","model":"ZTE-RACER"},{"manufacturer":"ZTE","market_name":"","codename":"P726G","model":"ZTE-WAVE"},{"manufacturer":"ZTE","market_name":"","codename":"P726N","model":"soft stone"},{"manufacturer":"ZTE","market_name":"","codename":"P726N","model":"soft-stone"},{"manufacturer":"ZTE","market_name":"","codename":"P726VV","model":"ZTE-U X850"},{"manufacturer":"ZTE","market_name":"","codename":"P727A","model":"VF945"},{"manufacturer":"ZTE","market_name":"","codename":"P729B","model":"Orange Tactile internet 2"},{"manufacturer":"ZTE","market_name":"","codename":"P729C","model":"ZTE-BLADE"},{"manufacturer":"ZTE","market_name":"","codename":"P810A10","model":"ZTE U880s2"},{"manufacturer":"ZTE","market_name":"","codename":"P810A20","model":"ZTE U887"},{"manufacturer":"ZTE","market_name":"","codename":"P810T01","model":"ZTE U791"},{"manufacturer":"ZTE","market_name":"","codename":"P810T01","model":"ZTE U791(OPEN)"},{"manufacturer":"ZTE","market_name":"","codename":"P810T02","model":"ZTE U793"},{"manufacturer":"ZTE","market_name":"","codename":"P825T10","model":"ZTE U808"},{"manufacturer":"ZTE","market_name":"","codename":"P825T10","model":"ZTE U808(OPEN)"},{"manufacturer":"ZTE","market_name":"","codename":"QB7211","model":"QB7211"},{"manufacturer":"ZTE","market_name":"","codename":"QB7211","model":"STARTEXT II"},{"manufacturer":"ZTE","market_name":"","codename":"T77","model":"T77"},{"manufacturer":"ZTE","market_name":"","codename":"T9","model":"ZTE-T T9"},{"manufacturer":"ZTE","market_name":"","codename":"TWM_P726G","model":"Taiwan Mobile T2"},{"manufacturer":"ZTE","market_name":"","codename":"U788","model":"ZTE U788"},{"manufacturer":"ZTE","market_name":"","codename":"U790","model":"ZTE U790"},{"manufacturer":"ZTE","market_name":"","codename":"U795","model":"ZTE U795"},{"manufacturer":"ZTE","market_name":"","codename":"U805","model":"ZTE-T U805"},{"manufacturer":"ZTE","market_name":"","codename":"U812","model":"ZTE-T U812"},{"manufacturer":"ZTE","market_name":"","codename":"U830","model":"ZTE-T U830"},{"manufacturer":"ZTE","market_name":"","codename":"U880E","model":"ZTE U880E"},{"manufacturer":"ZTE","market_name":"","codename":"U880F1","model":"ZTE U880F1"},{"manufacturer":"ZTE","market_name":"","codename":"U880s","model":"ZTE U880s"},{"manufacturer":"ZTE","market_name":"","codename":"U885","model":"ZTE U885"},{"manufacturer":"ZTE","market_name":"","codename":"U930HD","model":"ZTE U930HD"},{"manufacturer":"ZTE","market_name":"","codename":"U960s","model":"ZTE-T U960s"},{"manufacturer":"ZTE","market_name":"","codename":"U960s2","model":"ZTE U960s2"},{"manufacturer":"ZTE","market_name":"","codename":"U960s3","model":"ZTE U960s3"},{"manufacturer":"ZTE","market_name":"","codename":"V6020_Claro","model":"V6020_Claro"},{"manufacturer":"ZTE","market_name":"","codename":"V66","model":"V66"},{"manufacturer":"ZTE","market_name":"","codename":"V68","model":"V68"},{"manufacturer":"ZTE","market_name":"","codename":"V71A","model":"STARTAB"},{"manufacturer":"ZTE","market_name":"","codename":"V71A","model":"V71B"},{"manufacturer":"ZTE","market_name":"","codename":"V768","model":"ZTE V768"},{"manufacturer":"ZTE","market_name":"","codename":"V8100_Z55","model":"V8100_Z55"},{"manufacturer":"ZTE","market_name":"","codename":"V8200_EE_UK","model":"V8200_EE_UK"},{"manufacturer":"ZTE","market_name":"","codename":"V8200_OSK","model":"V8200-Memphis-orange-Slovakia"},{"manufacturer":"ZTE","market_name":"","codename":"V8300_Z39","model":"V8300_Z39"},{"manufacturer":"ZTE","market_name":"","codename":"V857","model":"ZTE-U V857"},{"manufacturer":"ZTE","market_name":"","codename":"V875m","model":"ZTE-U V875m"},{"manufacturer":"ZTE","market_name":"","codename":"X500","model":"X500"},{"manufacturer":"ZTE","market_name":"","codename":"X500","model":"X500_USA_General"},{"manufacturer":"ZTE","market_name":"","codename":"X500MMB","model":"ZTE-C X500"},{"manufacturer":"ZTE","market_name":"","codename":"ZTE-Grand-S","model":"ZTE Grand S"},{"manufacturer":"ZTE","market_name":"","codename":"ZTE-N5","model":"ZTE N5"},{"manufacturer":"ZTE","market_name":"","codename":"ZTE-N807","model":"ZTE N807"},{"manufacturer":"ZTE","market_name":"","codename":"ZTE-N880F","model":"ZTE N880F"},{"manufacturer":"ZTE","market_name":"","codename":"ZTE-N881E","model":"ZTE N881E"},{"manufacturer":"ZTE","market_name":"","codename":"ZTE-N881F","model":"ZTE N881F"},{"manufacturer":"ZTE","market_name":"","codename":"ZTE-N980","model":"ZTE N980"},{"manufacturer":"ZTE","market_name":"","codename":"ZTE-N988","model":"ZTE N988"},{"manufacturer":"ZTE","market_name":"","codename":"ZTE-U-V889F","model":"ZTE-U V889F"},{"manufacturer":"ZTE","market_name":"","codename":"ZTE-V72A","model":"V72A"},{"manufacturer":"ZTE","market_name":"","codename":"ZTE-V889F","model":"ZTE V889F"},{"manufacturer":"ZTE","market_name":"","codename":"ZTE-V955","model":"ZTE V955"},{"manufacturer":"ZTE","market_name":"","codename":"ZTE-V956","model":"ZTE V956"},{"manufacturer":"ZTE","market_name":"","codename":"ZTE-V988","model":"ZTE Grand S"},{"manufacturer":"ZTE","market_name":"","codename":"ZTE-V988","model":"ZTE V988"},{"manufacturer":"ZTE","market_name":"","codename":"amigo","model":"Android Edition Starnaute"},{"manufacturer":"ZTE","market_name":"","codename":"arthur","model":"N860"},{"manufacturer":"ZTE","market_name":"","codename":"atlas40","model":"Acqua"},{"manufacturer":"ZTE","market_name":"","codename":"atlas40","model":"BLADE III"},{"manufacturer":"ZTE","market_name":"","codename":"atlas40","model":"MEDION LIFE P4012"},{"manufacturer":"ZTE","market_name":"","codename":"atlas40","model":"N880E"},{"manufacturer":"ZTE","market_name":"","codename":"atlas40","model":"ZTE G882"},{"manufacturer":"ZTE","market_name":"","codename":"atlas40","model":"ZTE N880E"},{"manufacturer":"ZTE","market_name":"","codename":"atlas40","model":"ZTE N881D"},{"manufacturer":"ZTE","market_name":"","codename":"atlas40","model":"ZTE N882E"},{"manufacturer":"ZTE","market_name":"","codename":"atlas40","model":"ZTE R22"},{"manufacturer":"ZTE","market_name":"","codename":"atlas40","model":"ZTE T22"},{"manufacturer":"ZTE","market_name":"","codename":"atlas40","model":"ZTE V880E"},{"manufacturer":"ZTE","market_name":"","codename":"atlas40","model":"ZTE V889D"},{"manufacturer":"ZTE","market_name":"","codename":"banana","model":"ZTE-C N780"},{"manufacturer":"ZTE","market_name":"","codename":"blade","model":"MegaFon SP-A5"},{"manufacturer":"ZTE","market_name":"","codename":"blade","model":"V880"},{"manufacturer":"ZTE","market_name":"","codename":"blade","model":"ZTE Libra"},{"manufacturer":"ZTE","market_name":"","codename":"blade","model":"ZTE-BLADE"},{"manufacturer":"ZTE","market_name":"","codename":"blade2","model":"ATLAS W"},{"manufacturer":"ZTE","market_name":"","codename":"blade2","model":"BLADEII"},{"manufacturer":"ZTE","market_name":"","codename":"blade2","model":"Blade S"},{"manufacturer":"ZTE","market_name":"","codename":"blade2","model":"San Francisco II"},{"manufacturer":"ZTE","market_name":"","codename":"bladeplus","model":"008Z"},{"manufacturer":"ZTE","market_name":"","codename":"bladeplus","model":"V881"},{"manufacturer":"ZTE","market_name":"","codename":"bladeplus","model":"ZTE V881"},{"manufacturer":"ZTE","market_name":"","codename":"bladeplus","model":"ZTE-U V881"},{"manufacturer":"ZTE","market_name":"","codename":"cardhu","model":"ZTE-T T98"},{"manufacturer":"ZTE","market_name":"","codename":"crane-zte7","model":"K75"},{"manufacturer":"ZTE","market_name":"","codename":"dana","model":"ZTE N970"},{"manufacturer":"ZTE","market_name":"","codename":"deepblue","model":"ZTE N790"},{"manufacturer":"ZTE","market_name":"","codename":"deepblue","model":"ZTE N790S"},{"manufacturer":"ZTE","market_name":"","codename":"enterprise","model":"ZTE U5"},{"manufacturer":"ZTE","market_name":"","codename":"enterprise_HK","model":"ZTE Grand Era"},{"manufacturer":"ZTE","market_name":"","codename":"enterprise_U950","model":"ZTE U950"},{"manufacturer":"ZTE","market_name":"","codename":"enterprise_U985","model":"ZTE U985"},{"manufacturer":"ZTE","market_name":"","codename":"enterprise_V985","model":"ZTE V985"},{"manufacturer":"ZTE","market_name":"","codename":"frosty","model":"ZTE T82"},{"manufacturer":"ZTE","market_name":"","codename":"hct77_ics2","model":"V865M"},{"manufacturer":"ZTE","market_name":"","codename":"hope","model":"N855D"},{"manufacturer":"ZTE","market_name":"","codename":"hope","model":"N855D_PERFECTUM"},{"manufacturer":"ZTE","market_name":"","codename":"hope","model":"N855D_YM"},{"manufacturer":"ZTE","market_name":"","codename":"hope","model":"ZTE N855"},{"manufacturer":"ZTE","market_name":"","codename":"hope","model":"ZTE N855D"},{"manufacturer":"ZTE","market_name":"","codename":"hope","model":"ZTE N855D+"},{"manufacturer":"ZTE","market_name":"","codename":"iliamna","model":"ZTE T81"},{"manufacturer":"ZTE","market_name":"","codename":"joe","model":"V871"},{"manufacturer":"ZTE","market_name":"","codename":"joe","model":"Vodafone 945"},{"manufacturer":"ZTE","market_name":"","codename":"kiska","model":"ZTE V9800"},{"manufacturer":"ZTE","market_name":"","codename":"mooncake2","model":"MTS-SP102"},{"manufacturer":"ZTE","market_name":"","codename":"mooncake2","model":"Mtag 281"},{"manufacturer":"ZTE","market_name":"","codename":"mooncake2","model":"ZTE N660"},{"manufacturer":"ZTE","market_name":"","codename":"msm7627a","model":"ZTE N880F"},{"manufacturer":"ZTE","market_name":"","codename":"msm7627a","model":"ZTE V889F"},{"manufacturer":"ZTE","market_name":"","codename":"msm7627a","model":"ZTE-U V889F"},{"manufacturer":"ZTE","market_name":"","codename":"msm7630_zteu960","model":"ZTE U960D"},{"manufacturer":"ZTE","market_name":"","codename":"msm7630_zteu960","model":"ZTE-T U960"},{"manufacturer":"ZTE","market_name":"","codename":"nice","model":"A21plus"},{"manufacturer":"ZTE","market_name":"","codename":"nice","model":"ICE"},{"manufacturer":"ZTE","market_name":"","codename":"nice","model":"KIS II"},{"manufacturer":"ZTE","market_name":"","codename":"nice","model":"Orange Zali"},{"manufacturer":"ZTE","market_name":"","codename":"nice","model":"Turkcell Maxi Plus 5"},{"manufacturer":"ZTE","market_name":"","codename":"nice","model":"V880S"},{"manufacturer":"ZTE","market_name":"","codename":"nice","model":"ZTE Kis Pro"},{"manufacturer":"ZTE","market_name":"","codename":"okmok","model":"ZTE V9500"},{"manufacturer":"ZTE","market_name":"","codename":"p173a10","model":"ZTE-U V760"},{"manufacturer":"ZTE","market_name":"","codename":"r750","model":"ZTE-C R750"},{"manufacturer":"ZTE","market_name":"","codename":"racer2","model":"ARIZONA"},{"manufacturer":"ZTE","market_name":"","codename":"racer2","model":"Kyivstar Shine"},{"manufacturer":"ZTE","market_name":"","codename":"racer2","model":"RACERII"},{"manufacturer":"ZTE","market_name":"","codename":"racer2","model":"RacerII"},{"manufacturer":"ZTE","market_name":"","codename":"racer2","model":"Turkcell T11"},{"manufacturer":"ZTE","market_name":"","codename":"racer2","model":"ZTE-U V859"},{"manufacturer":"ZTE","market_name":"","codename":"roamer","model":"ZTE Roamer"},{"manufacturer":"ZTE","market_name":"","codename":"roamer","model":"ZTE roamer"},{"manufacturer":"ZTE","market_name":"","codename":"roamer","model":"ZTE-C N760"},{"manufacturer":"ZTE","market_name":"","codename":"roamer2","model":"Dubai"},{"manufacturer":"ZTE","market_name":"","codename":"roamer2","model":"Dublin"},{"manufacturer":"ZTE","market_name":"","codename":"roamer2","model":"N788_BASHA"},{"manufacturer":"ZTE","market_name":"","codename":"roamer2","model":"Orange Dublin"},{"manufacturer":"ZTE","market_name":"","codename":"roamer2","model":"V788D"},{"manufacturer":"ZTE","market_name":"","codename":"roamer2","model":"ZTE N788"},{"manufacturer":"ZTE","market_name":"","codename":"roamer2","model":"ZTE N789"},{"manufacturer":"ZTE","market_name":"","codename":"roamer2","model":"ZTE V788D"},{"manufacturer":"ZTE","market_name":"","codename":"roundtop","model":"ZTE V9800"},{"manufacturer":"ZTE","market_name":"","codename":"sailboat","model":"ZTE V875"},{"manufacturer":"ZTE","market_name":"","codename":"sean","model":"N850"},{"manufacturer":"ZTE","market_name":"","codename":"skate","model":"KPN Smart 200"},{"manufacturer":"ZTE","market_name":"","codename":"skate","model":"MEDION LIFE P4310"},{"manufacturer":"ZTE","market_name":"","codename":"skate","model":"Monte Carlo"},{"manufacturer":"ZTE","market_name":"","codename":"skate","model":"Optimus Monte Carlo"},{"manufacturer":"ZTE","market_name":"","codename":"skate","model":"Orange Monte Carlo"},{"manufacturer":"ZTE","market_name":"","codename":"skate","model":"ZTE N960"},{"manufacturer":"ZTE","market_name":"","codename":"skate","model":"ZTE Skate"},{"manufacturer":"ZTE","market_name":"","codename":"skate","model":"ZTE V960"},{"manufacturer":"ZTE","market_name":"","codename":"skate","model":"ZTE-SKATE"},{"manufacturer":"ZTE","market_name":"","codename":"skate","model":"ZTE-Skate"},{"manufacturer":"ZTE","market_name":"","codename":"skate","model":"ZTE-U V960"},{"manufacturer":"ZTE","market_name":"","codename":"skateplus","model":"Skate4.3 H"},{"manufacturer":"ZTE","market_name":"","codename":"turies","model":"Android Edition StarText"},{"manufacturer":"ZTE","market_name":"","codename":"turies","model":"Vodafone Smart Chat"},{"manufacturer":"ZTE","market_name":"","codename":"turies","model":"ZTE-Tureis"},{"manufacturer":"ZTE","market_name":"","codename":"v9plus","model":"BASE Tab 7.1"},{"manufacturer":"ZTE","market_name":"","codename":"v9plus","model":"Light Tab 2"},{"manufacturer":"ZTE","market_name":"","codename":"v9plus","model":"Light Tab 2W"},{"manufacturer":"ZTE","market_name":"","codename":"v9plus","model":"MegaFon V9+"},{"manufacturer":"ZTE","market_name":"","codename":"v9plus","model":"TT102"},{"manufacturer":"ZTE","market_name":"","codename":"v9plus","model":"Telenor Touch Pad"},{"manufacturer":"ZTE","market_name":"","codename":"v9plus","model":"V9+"},{"manufacturer":"ZTE","market_name":"","codename":"v9plus","model":"V9A"},{"manufacturer":"ZTE","market_name":"","codename":"v9plus","model":"V9e+"},{"manufacturer":"ZTE","market_name":"","codename":"v9plus","model":"ZTE V10"},{"manufacturer":"ZTE","market_name":"","codename":"v9plus","model":"ZTE V9A"},{"manufacturer":"ZTE","market_name":"","codename":"ventana","model":"ZTE U970"},{"manufacturer":"ZTE","market_name":"","codename":"ventana_U880F","model":"ZTE U880F"},{"manufacturer":"ZTE","market_name":"","codename":"ventana_U930","model":"ZTE U930"},{"manufacturer":"ZTE","market_name":"","codename":"warp2","model":"N861"},{"manufacturer":"ZTE","market_name":"","codename":"whistler","model":"STARADDICT II"},{"manufacturer":"ZTE","market_name":"","codename":"whistler","model":"V961"},{"manufacturer":"ZTE","market_name":"","codename":"whistler","model":"ZTE Grand X"},{"manufacturer":"ZTE","market_name":"","codename":"whistler","model":"ZTE V970T"},{"manufacturer":"ZTE","market_name":"","codename":"whistler","model":"ZTE-Mimosa X"},{"manufacturer":"ZTE","market_name":"","codename":"z788","model":"ZTE U788+"},{"manufacturer":"ZTE","market_name":"","codename":"z795","model":"ZTE U795+"},{"manufacturer":"ZTE","market_name":"","codename":"zte_v857","model":"ZTE-U V857"},{"manufacturer":"ZTE","market_name":"009Z","codename":"bladeplus","model":"009Z"},{"manufacturer":"ZTE","market_name":"009Z","codename":"bladeplus","model":"ZTE V882"},{"manufacturer":"ZTE","market_name":"009Z","codename":"bladeplus","model":"ZTE V886J"},{"manufacturer":"ZTE","market_name":"402ZT","codename":"ZTE-402ZT","model":"402ZT"},{"manufacturer":"ZTE","market_name":"A1P","codename":"ailsa","model":"A1P"},{"manufacturer":"ZTE","market_name":"A1R","codename":"billy","model":"A1"},{"manufacturer":"ZTE","market_name":"A1R","codename":"billy","model":"A1R"},{"manufacturer":"ZTE","market_name":"A2","codename":"A2","model":"A2"},{"manufacturer":"ZTE","market_name":"A2015","codename":"msm8994","model":"ZTE A2015"},{"manufacturer":"ZTE","market_name":"A2016","codename":"msm8994","model":"ZTE A2016"},{"manufacturer":"ZTE","market_name":"A2017","codename":"ailsa_ii","model":"ZTE A2017"},{"manufacturer":"ZTE","market_name":"A2017G","codename":"ailsa_ii","model":"ZTE A2017G"},{"manufacturer":"ZTE","market_name":"A2017U","codename":"ailsa_ii","model":"ZTE A2017U"},{"manufacturer":"ZTE","market_name":"A2018","codename":"candice","model":"ZTE A2018"},{"manufacturer":"ZTE","market_name":"A880","codename":"ZTE-A880","model":"ZTE A880"},{"manufacturer":"ZTE","market_name":"ACT","codename":"B860H_V1","model":"B860H"},{"manufacturer":"ZTE","market_name":"AV-ATB100","codename":"B800S2_V1","model":"AV-ATB100"},{"manufacturer":"ZTE","market_name":"AXON 7 mini","codename":"msm8952_64","model":"AXON 7 mini"},{"manufacturer":"ZTE","market_name":"AXON WATCH","codename":"rolex","model":"AXON WATCH"},{"manufacturer":"ZTE","market_name":"AXON WATCH","codename":"rolex","model":"ZTE W1010"},{"manufacturer":"ZTE","market_name":"Amazing A1","codename":"roamer2","model":"Amazing A1"},{"manufacturer":"ZTE","market_name":"Amazing A30","codename":"P809F20","model":"Amazing A30"},{"manufacturer":"ZTE","market_name":"Amazing A50","codename":"P637F02","model":"Amazing A50"},{"manufacturer":"ZTE","market_name":"Amazing P6","codename":"msm8226","model":"Amazing P6"},{"manufacturer":"ZTE","market_name":"Amazing X2","codename":"msm8226","model":"Amazing X2"},{"manufacturer":"ZTE","market_name":"Amazing X5s","codename":"ZTE_T620","model":"Amazing X5s"},{"manufacturer":"ZTE","market_name":"Amazing X6","codename":"P839F30","model":"Amazing X6"},{"manufacturer":"ZTE","market_name":"Amazing X7","codename":"P839V56","model":"Amazing X7"},{"manufacturer":"ZTE","market_name":"Amazing p5_Lite","codename":"V77","model":"Amazing p5_Lite"},{"manufacturer":"ZTE","market_name":"Amazing_X3s","codename":"Amazing_X3s","model":"Amazing_X3s"},{"manufacturer":"ZTE","market_name":"Amazing_X3s_16G","codename":"Amazing_X3s","model":"Amazing_X3s_16G"},{"manufacturer":"ZTE","market_name":"Android edition by sfr STARADDICT","codename":"skate","model":"Android edition by sfr STARADDICT"},{"manufacturer":"ZTE","market_name":"Andromax G46D1Z","codename":"Andromax_G46D1Z","model":"Andromax G46D1Z"},{"manufacturer":"ZTE","market_name":"Avea inTouch 2","codename":"atlas40","model":"Avea inTouch 2"},{"manufacturer":"ZTE","market_name":"Avea inTouch 4","codename":"msm8916_32","model":"Avea inTouch 4"},{"manufacturer":"ZTE","market_name":"Avea inTouch 4","codename":"msm8916_32","model":"ZTE Blade V220"},{"manufacturer":"ZTE","market_name":"B2015","codename":"msm8916_64","model":"ZTE B2015"},{"manufacturer":"ZTE","market_name":"B2016","codename":"msm8916_64","model":"ZTE B2016"},{"manufacturer":"ZTE","market_name":"B2017G","codename":"msm8952_64","model":"ZTE B2017G"},{"manufacturer":"ZTE","market_name":"B2017G","codename":"tulip","model":"ZTE B2017G"},{"manufacturer":"ZTE","market_name":"B2017G","codename":"verdandi","model":"ZTE B2017G"},{"manufacturer":"ZTE","market_name":"B760E","codename":"ztemt85_bx_kk","model":"B760E"},{"manufacturer":"ZTE","market_name":"B760E","codename":"ztemt85_bx_kk","model":"B760H"},{"manufacturer":"ZTE","market_name":"B790","codename":"roamer2","model":"ZTE B790"},{"manufacturer":"ZTE","market_name":"B860AV2","codename":"p200_2G","model":"B860AV2"},{"manufacturer":"ZTE","market_name":"B860H","codename":"B860H_V1","model":"B860H"},{"manufacturer":"ZTE","market_name":"B860H","codename":"B860H_V1","model":"B860H V1.0"},{"manufacturer":"ZTE","market_name":"B860H","codename":"B860H_V1","model":"B860H V1.1"},{"manufacturer":"ZTE","market_name":"B880","codename":"P635N30","model":"ZTE B880"},{"manufacturer":"ZTE","market_name":"B880","codename":"S_P635N30","model":"ZTE B880"},{"manufacturer":"ZTE","market_name":"BA510","codename":"P635T39","model":"ZTE BA510"},{"manufacturer":"ZTE","market_name":"BA520","codename":"P637T10","model":"ZTE BA520"},{"manufacturer":"ZTE","market_name":"BA601","codename":"ZTE_BA601","model":"ZTE BA601"},{"manufacturer":"ZTE","market_name":"BA602","codename":"P637S02","model":"ZTE BA602"},{"manufacturer":"ZTE","market_name":"BA602T","codename":"P637T02","model":"ZTE BA602T"},{"manufacturer":"ZTE","market_name":"BA603","codename":"P809S10","model":"ZTE BA603"},{"manufacturer":"ZTE","market_name":"BA610C","codename":"P635N36","model":"ZTE BA610C"},{"manufacturer":"ZTE","market_name":"BA610T","codename":"P635T36","model":"ZTE BA610T"},{"manufacturer":"ZTE","market_name":"BA610T","codename":"V_P635T36","model":"ZTE BA610T"},{"manufacturer":"ZTE","market_name":"BA611C","codename":"P635N40","model":"ZTE BA611C"},{"manufacturer":"ZTE","market_name":"BA611T","codename":"P635T40","model":"ZTE BA611T"},{"manufacturer":"ZTE","market_name":"BA611T","codename":"V_P635T40","model":"ZTE BA611T"},{"manufacturer":"ZTE","market_name":"BA910","codename":"P653N31","model":"ZTE BA910"},{"manufacturer":"ZTE","market_name":"BA910","codename":"V_P653N31","model":"ZTE BA910"},{"manufacturer":"ZTE","market_name":"BA910T","codename":"T_P653N31","model":"ZTE BA910T"},{"manufacturer":"ZTE","market_name":"BASE Lutea 2","codename":"skate","model":"BASE Lutea 2"},{"manufacturer":"ZTE","market_name":"BGH Joy X5","codename":"ZTE_Blade_V580","model":"BGH Joy X5"},{"manufacturer":"ZTE","market_name":"BLADE","codename":"blade","model":"ZTE-BLADE"},{"manufacturer":"ZTE","market_name":"BLADE A110","codename":"ZTE_BLADE_A110","model":"BLADE A110"},{"manufacturer":"ZTE","market_name":"BLADE A110","codename":"ZTE_BLADE_A110","model":"ZTE BLADE A110"},{"manufacturer":"ZTE","market_name":"BLADE A112","codename":"P635A60","model":"ZTE BLADE A112"},{"manufacturer":"ZTE","market_name":"BLADE A310","codename":"P809A50","model":"Blade A310"},{"manufacturer":"ZTE","market_name":"BLADE A310","codename":"P809A50","model":"ZTE BLADE A310"},{"manufacturer":"ZTE","market_name":"BLADE A320","codename":"P809F20","model":"BLADE A320"},{"manufacturer":"ZTE","market_name":"BLADE A320","codename":"P809F20","model":"ZTE BLADE A320"},{"manufacturer":"ZTE","market_name":"BLADE A506","codename":"P809F52","model":"ZTE BLADE A506"},{"manufacturer":"ZTE","market_name":"BLADE A510","codename":"P635A50","model":"BLADE A510"},{"manufacturer":"ZTE","market_name":"BLADE A510","codename":"P635A50","model":"Blade A510"},{"manufacturer":"ZTE","market_name":"BLADE A510","codename":"P635A50","model":"ZTE BLADE A510"},{"manufacturer":"ZTE","market_name":"BLADE A512","codename":"P817E52","model":"ZTE BLADE A512"},{"manufacturer":"ZTE","market_name":"BLADE A512","codename":"P817E52","model":"ZTE Z10"},{"manufacturer":"ZTE","market_name":"BLADE A520","codename":"P637F10","model":"BLADE A520"},{"manufacturer":"ZTE","market_name":"BLADE A520","codename":"P637F10","model":"ZTE BLADE A520"},{"manufacturer":"ZTE","market_name":"BLADE A521","codename":"P809F10","model":"BLADE A521"},{"manufacturer":"ZTE","market_name":"BLADE A521","codename":"P809F10","model":"ZTE BLADE A521"},{"manufacturer":"ZTE","market_name":"BLADE A530","codename":"P639F10","model":"BLADE A530"},{"manufacturer":"ZTE","market_name":"BLADE A6","codename":"P840F13","model":"BLADE A6"},{"manufacturer":"ZTE","market_name":"BLADE A6 MAX","codename":"P809F15","model":"BLADE A6 MAX"},{"manufacturer":"ZTE","market_name":"BLADE A601","codename":"ZTE_BLADE_A601","model":"ZTE BLADE A601"},{"manufacturer":"ZTE","market_name":"BLADE A602","codename":"P637F02","model":"BLADE A602"},{"manufacturer":"ZTE","market_name":"BLADE A602","codename":"P637F02","model":"ZTE BLADE A602"},{"manufacturer":"ZTE","market_name":"BLADE A610","codename":"ZTE_BLADE_A610","model":"BLADE A610"},{"manufacturer":"ZTE","market_name":"BLADE A610","codename":"ZTE_BLADE_A610","model":"ZTE BLADE A610"},{"manufacturer":"ZTE","market_name":"BLADE A610C","codename":"P635F50","model":"ZTE BLADE A610C"},{"manufacturer":"ZTE","market_name":"BLADE A612","codename":"P635F50","model":"ZTE BLADE A612"},{"manufacturer":"ZTE","market_name":"BLADE A910","codename":"P635A31","model":"BLADE A910"},{"manufacturer":"ZTE","market_name":"BLADE A910","codename":"P635A31","model":"ZTE BLADE A910"},{"manufacturer":"ZTE","market_name":"BLADE B112","codename":"P635A60","model":"ZTE BLADE B112"},{"manufacturer":"ZTE","market_name":"BLADE III","codename":"atlas40","model":"Skate Pro"},{"manufacturer":"ZTE","market_name":"BLADE III","codename":"atlas40","model":"ZTE BLADE III"},{"manufacturer":"ZTE","market_name":"BLADE III","codename":"atlas40","model":"ZTE Blade III"},{"manufacturer":"ZTE","market_name":"BLADE III_IL","codename":"atlas40","model":"BLADE III_IL"},{"manufacturer":"ZTE","market_name":"BLADE L0510","codename":"P680A20","model":"ZTE BLADE L0510"},{"manufacturer":"ZTE","market_name":"BLADE L0510","codename":"P680A20","model":"ZTE Blade L5 Plus"},{"manufacturer":"ZTE","market_name":"BLADE L110","codename":"ZTE_BLADE_L110","model":"Blade L110"},{"manufacturer":"ZTE","market_name":"BLADE L110","codename":"ZTE_BLADE_L110","model":"ZTE BLADE L110"},{"manufacturer":"ZTE","market_name":"BLADE L111","codename":"ZTE_BLADE_L110","model":"ZTE BLADE L111"},{"manufacturer":"ZTE","market_name":"BLADE L5 PLUS","codename":"P680A20","model":"ZTE BLADE L5 PLUS"},{"manufacturer":"ZTE","market_name":"BLADE L7","codename":"P731F10","model":"BLADE L7"},{"manufacturer":"ZTE","market_name":"BLADE L7","codename":"P731F10","model":"ZTE BLADE L7"},{"manufacturer":"ZTE","market_name":"BLADE V0710","codename":"ZTE_BLADE_V0710","model":"ZTE BLADE V0710"},{"manufacturer":"ZTE","market_name":"BLADE V0720","codename":"ZTE_BLADE_V0720","model":"ZTE BLADE V0720"},{"manufacturer":"ZTE","market_name":"BLADE V0730","codename":"ZTE_BLADE_V0730","model":"ZTE BLADE V0730"},{"manufacturer":"ZTE","market_name":"BLADE V0800","codename":"ZTE_BLADE_V0800","model":"ZTE BLADE V0800"},{"manufacturer":"ZTE","market_name":"BLADE V0820","codename":"ZTE_BLADE_V0820","model":"ZTE BLADE V0820"},{"manufacturer":"ZTE","market_name":"BLADE V0850","codename":"ZTE_BLADE_V0850","model":"ZTE BLADE V0850"},{"manufacturer":"ZTE","market_name":"BLADE V7","codename":"P653A10","model":"BLADE V7"},{"manufacturer":"ZTE","market_name":"BLADE V7","codename":"P653A10","model":"ZTE BLADE V7"},{"manufacturer":"ZTE","market_name":"BLADE V7 LITE","codename":"ZTE_BLADE_V0720","model":"ZTE BLADE V0720"},{"manufacturer":"ZTE","market_name":"BLADE V7 LITE","codename":"ZTE_BLADE_V0720","model":"ZTE BLADE V7 LITE"},{"manufacturer":"ZTE","market_name":"BLADE V7 PLUS","codename":"P653A11","model":"ZTE BLADE V7 PLUS"},{"manufacturer":"ZTE","market_name":"BLADE V8","codename":"ZTE_BLADE_V0800","model":"BLADE V8"},{"manufacturer":"ZTE","market_name":"BLADE V8 MINI","codename":"ZTE_BLADE_V0850","model":"BLADE V8 MINI"},{"manufacturer":"ZTE","market_name":"BLADE V8 MINI","codename":"ZTE_BLADE_V0850","model":"ZTE BLADE V8 MINI"},{"manufacturer":"ZTE","market_name":"BLADE V8 SE","codename":"ZTE_BLADE_V0820","model":"BLADE V8 SE"},{"manufacturer":"ZTE","market_name":"BLADE V8 mini","codename":"ZTE_BLADE_V0850","model":"BLADE V8 mini"},{"manufacturer":"ZTE","market_name":"BLADE V8Q","codename":"P817F01","model":"BLADE V8Q"},{"manufacturer":"ZTE","market_name":"BOLTON","codename":"bolton","model":"N9560"},{"manufacturer":"ZTE","market_name":"BV0701","codename":"P653N11","model":"ZTE BV0701"},{"manufacturer":"ZTE","market_name":"BV0701","codename":"P653N11","model":"ZTE V0721"},{"manufacturer":"ZTE","market_name":"BV0710","codename":"P655A30","model":"ZTE BV0710"},{"manufacturer":"ZTE","market_name":"BV0710T","codename":"P655A30","model":"ZTE BV0710T"},{"manufacturer":"ZTE","market_name":"BV0720","codename":"P650A30","model":"ZTE BV0720"},{"manufacturer":"ZTE","market_name":"BV0720T","codename":"P650A30","model":"ZTE BV0720T"},{"manufacturer":"ZTE","market_name":"BV0730","codename":"P650A31","model":"ZTE BV0730"},{"manufacturer":"ZTE","market_name":"BV0800","codename":"P840S10","model":"ZTE BV0800"},{"manufacturer":"ZTE","market_name":"BV0850","codename":"P840S01","model":"ZTE BV0850"},{"manufacturer":"ZTE","market_name":"Baker","codename":"ZTE-Baker","model":"Baker"},{"manufacturer":"ZTE","market_name":"Beeline E600","codename":"roamer2","model":"Beeline E600"},{"manufacturer":"ZTE","market_name":"Beeline Smart 2","codename":"P172R10","model":"Beeline Smart 2"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"003Z"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"Android Edition StarTrail"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"BASE lutea"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"BLADE_N880"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"Beeline E400"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"Kyivstar Spark"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"MF8604"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"Movistar Prime"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"N880"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"Netphone 701"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"Optimus San Francisco"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"Orange San Francisco"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"Orange Tactile internet 2"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"RTK V8"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"San Francisco"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"V8502"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"WayteQ Libra"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"XCD35"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"ZTE Libra"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"ZTE V880"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"ZTE-BLADE"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"ZTE-C N880S"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"ZTE-LIBRA"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"ZTE-Libra"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"ZTE-U V880"},{"manufacturer":"ZTE","market_name":"Blade","codename":"blade","model":"a5"},{"manufacturer":"ZTE","market_name":"Blade A210","codename":"ZTE_Blade_A210","model":"ZTE BLADE A210"},{"manufacturer":"ZTE","market_name":"Blade A210","codename":"ZTE_Blade_A210","model":"ZTE Blade A210"},{"manufacturer":"ZTE","market_name":"Blade A315","codename":"ZTE_Blade_A315","model":"ZTE Blade A315"},{"manufacturer":"ZTE","market_name":"Blade A410","codename":"P635E40","model":"Blade A410"},{"manufacturer":"ZTE","market_name":"Blade A410","codename":"P635E40","model":"ZTE Blade A410"},{"manufacturer":"ZTE","market_name":"Blade A452","codename":"P635F33","model":"NOS FIVE"},{"manufacturer":"ZTE","market_name":"Blade A452","codename":"P635F33","model":"ZTE Blade A452"},{"manufacturer":"ZTE","market_name":"Blade A460","codename":"P809A20","model":"A460-T"},{"manufacturer":"ZTE","market_name":"Blade A460","codename":"P809A20","model":"Blade A460"},{"manufacturer":"ZTE","market_name":"Blade A460","codename":"P809A20","model":"ZTE BLADE A460"},{"manufacturer":"ZTE","market_name":"Blade A460","codename":"P809A20","model":"ZTE Blade A460"},{"manufacturer":"ZTE","market_name":"Blade A460","codename":"P809A20","model":"ZTE T610"},{"manufacturer":"ZTE","market_name":"Blade A462","codename":"P809A50","model":"ZTE Blade A462"},{"manufacturer":"ZTE","market_name":"Blade A465","codename":"ZTE_Blade_A465","model":"Blade A465"},{"manufacturer":"ZTE","market_name":"Blade A465","codename":"ZTE_Blade_A465","model":"ZTE Blade A465"},{"manufacturer":"ZTE","market_name":"Blade A470","codename":"P809A40","model":"ZTE Blade A470"},{"manufacturer":"ZTE","market_name":"Blade A475","codename":"ZTE_Blade_A475","model":"BGH JOY X2"},{"manufacturer":"ZTE","market_name":"Blade A475","codename":"ZTE_Blade_A475","model":"Blade A475"},{"manufacturer":"ZTE","market_name":"Blade A475","codename":"ZTE_Blade_A475","model":"ZTE Blade A475"},{"manufacturer":"ZTE","market_name":"Blade A475","codename":"ZTE_Blade_A475","model":"ZTE Blade L4 Pro"},{"manufacturer":"ZTE","market_name":"Blade A476","codename":"ZTE_Blade_A476","model":"BLADE E01"},{"manufacturer":"ZTE","market_name":"Blade A476","codename":"ZTE_Blade_A476","model":"ZTE Blade A476"},{"manufacturer":"ZTE","market_name":"Blade A510","codename":"P635A50","model":"Blade A510"},{"manufacturer":"ZTE","market_name":"Blade A510","codename":"ZTE_BLADE_A601","model":"ZTE BLADE A601"},{"manufacturer":"ZTE","market_name":"Blade A511","codename":"ZTE_Blade_A511","model":"Blade A511"},{"manufacturer":"ZTE","market_name":"Blade A511","codename":"ZTE_Blade_A511","model":"ZTE Blade A511"},{"manufacturer":"ZTE","market_name":"Blade A515","codename":"ZTE_Blade_A511","model":"ZTE Blade A515"},{"manufacturer":"ZTE","market_name":"Blade A570","codename":"ZTE_T617","model":"ZTE Blade A570"},{"manufacturer":"ZTE","market_name":"Blade Apex","codename":"coeus","model":"Blade Apex"},{"manufacturer":"ZTE","market_name":"Blade Apex","codename":"oceanus","model":"ZTE Blade Apex"},{"manufacturer":"ZTE","market_name":"Blade Apex2","codename":"msm8226","model":"Blade Apex2"},{"manufacturer":"ZTE","market_name":"Blade Apex2","codename":"msm8226","model":"ZTE Blade Apex2"},{"manufacturer":"ZTE","market_name":"Blade Apex3","codename":"msm8916_32","model":"ZTE Blade Apex3"},{"manufacturer":"ZTE","market_name":"Blade C312","codename":"P715A20","model":"ZTE Blade C312"},{"manufacturer":"ZTE","market_name":"Blade C340","codename":"P172R12","model":"ZTE Blade C340"},{"manufacturer":"ZTE","market_name":"Blade C340","codename":"P172R12","model":"ZTE T220"},{"manufacturer":"ZTE","market_name":"Blade C340","codename":"P172R12","model":"ZTE V812"},{"manufacturer":"ZTE","market_name":"Blade C370","codename":"ZTE_Blade_C370","model":"NOS NOVU"},{"manufacturer":"ZTE","market_name":"Blade C370","codename":"ZTE_Blade_C370","model":"ZTE BLADE C370"},{"manufacturer":"ZTE","market_name":"Blade C370","codename":"ZTE_Blade_C370","model":"ZTE Blade C370"},{"manufacturer":"ZTE","market_name":"Blade D6 Lite 3G","codename":"P658A10","model":"ZTE Blade D6 Lite 3G"},{"manufacturer":"ZTE","market_name":"Blade D6 Lite 4G","codename":"P635A30","model":"ZTE Blade D6 Lite 4G"},{"manufacturer":"ZTE","market_name":"Blade Force","codename":"warp8","model":"N9517"},{"manufacturer":"ZTE","market_name":"Blade G","codename":"ZTE-Blade-G","model":"ZTE Blade G"},{"manufacturer":"ZTE","market_name":"Blade G LTE","codename":"coeus","model":"ZTE Blade G LTE"},{"manufacturer":"ZTE","market_name":"Blade G LTE","codename":"oceanus","model":"Blade G LTE"},{"manufacturer":"ZTE","market_name":"Blade G Lux","codename":"P172F10","model":"BGH Joy Smart A6"},{"manufacturer":"ZTE","market_name":"Blade G Lux","codename":"P172F10","model":"BGH Joy Smart A6d"},{"manufacturer":"ZTE","market_name":"Blade G Lux","codename":"P172F10","model":"Blade G Lux"},{"manufacturer":"ZTE","market_name":"Blade G Lux","codename":"P172F10","model":"DIGICEL DL800"},{"manufacturer":"ZTE","market_name":"Blade G Lux","codename":"P172F10","model":"MEO Smart A40"},{"manufacturer":"ZTE","market_name":"Blade G Lux","codename":"P172F10","model":"Orange Tado"},{"manufacturer":"ZTE","market_name":"Blade G Lux","codename":"P172F10","model":"ZTE Blade G Lux"},{"manufacturer":"ZTE","market_name":"Blade G Lux","codename":"P172F10","model":"ZTE Kis3 max"},{"manufacturer":"ZTE","market_name":"Blade G Lux","codename":"P172F10","model":"ZTE V830W"},{"manufacturer":"ZTE","market_name":"Blade HN","codename":"ZTE_Blade_HN","model":"ZTE Blade HN"},{"manufacturer":"ZTE","market_name":"Blade III","codename":"atlas40","model":"Blade III"},{"manufacturer":"ZTE","market_name":"Blade III","codename":"atlas40","model":"Skate Pro"},{"manufacturer":"ZTE","market_name":"Blade III","codename":"atlas40","model":"ZTE Blade III"},{"manufacturer":"ZTE","market_name":"Blade III Pro","codename":"Blade-III-Pro","model":"ZTE Blade III Pro"},{"manufacturer":"ZTE","market_name":"Blade L110","codename":"ZTE_BLADE_L110","model":"Blade L110"},{"manufacturer":"ZTE","market_name":"Blade L110","codename":"ZTE_BLADE_L110","model":"ZTE Blade L110"},{"manufacturer":"ZTE","market_name":"Blade L2","codename":"P182A10","model":"BGH Joy Smart AXS"},{"manufacturer":"ZTE","market_name":"Blade L2","codename":"P182A10","model":"BGH Joy Smart AXS D"},{"manufacturer":"ZTE","market_name":"Blade L2","codename":"P182A10","model":"Blade L2"},{"manufacturer":"ZTE","market_name":"Blade L2","codename":"P182A10","model":"MEO Smart A75"},{"manufacturer":"ZTE","market_name":"Blade L2","codename":"P182A10","model":"ZTE Blade L2"},{"manufacturer":"ZTE","market_name":"Blade L2 Plus","codename":"ZTE_Blade_L2_PLUS","model":"Blade L2 Plus"},{"manufacturer":"ZTE","market_name":"Blade L3","codename":"P182A20","model":"Blade L3"},{"manufacturer":"ZTE","market_name":"Blade L3","codename":"P182A20","model":"DIGICEL DL910"},{"manufacturer":"ZTE","market_name":"Blade L3","codename":"P182A20","model":"MEO Smart A80"},{"manufacturer":"ZTE","market_name":"Blade L3","codename":"P182A20","model":"X8607"},{"manufacturer":"ZTE","market_name":"Blade L3","codename":"P182A20","model":"ZTE Blade L3"},{"manufacturer":"ZTE","market_name":"Blade L3 Apex","codename":"ZTE_Blade_L3_Apex","model":"ZTE Blade L3 Apex"},{"manufacturer":"ZTE","market_name":"Blade L3 Lite","codename":"P172A50","model":"Blade L3 Lite"},{"manufacturer":"ZTE","market_name":"Blade L3 Lite","codename":"P172A50","model":"ZTE Blade L3 Lite"},{"manufacturer":"ZTE","market_name":"Blade L3 Plus","codename":"Blade_L3_Plus","model":"Blade L3 Plus"},{"manufacturer":"ZTE","market_name":"Blade L3 Plus","codename":"ZTE_Blade_L3_Plus","model":"ZTE Blade L3 Plus"},{"manufacturer":"ZTE","market_name":"Blade L315","codename":"ZTE_Blade_L315","model":"ZTE Blade L315"},{"manufacturer":"ZTE","market_name":"Blade L370","codename":"ZTE_Blade_C370","model":"ZTE Blade L370"},{"manufacturer":"ZTE","market_name":"Blade L5","codename":"P172A40","model":"Blade L5"},{"manufacturer":"ZTE","market_name":"Blade L5","codename":"P172A40","model":"ZTE Blade L5"},{"manufacturer":"ZTE","market_name":"Blade L5 Plus","codename":"P680A20","model":"Blade L5 Plus"},{"manufacturer":"ZTE","market_name":"Blade L5 Plus","codename":"P680A20","model":"ZTE Blade L5 Plus"},{"manufacturer":"ZTE","market_name":"Blade L6","codename":"P680A10","model":"ZTE Blade L6"},{"manufacturer":"ZTE","market_name":"Blade L6","codename":"P680A10","model":"ZTE Blade V6 Lite"},{"manufacturer":"ZTE","market_name":"Blade Q Lux","codename":"P632A10","model":"BGH Joy Smart A7G"},{"manufacturer":"ZTE","market_name":"Blade Q Lux","codename":"P632A10","model":"Beeline Pro"},{"manufacturer":"ZTE","market_name":"Blade Q Lux","codename":"P632A10","model":"UZTE Blade Q Lux"},{"manufacturer":"ZTE","market_name":"Blade Q Lux","codename":"P632A10","model":"ZTE Blade A430"},{"manufacturer":"ZTE","market_name":"Blade Q Lux","codename":"P632A10","model":"ZTE Blade Q Lux"},{"manufacturer":"ZTE","market_name":"Blade Q Lux","codename":"P632A10","model":"ZTE Blade Q Lux 3G"},{"manufacturer":"ZTE","market_name":"Blade Q Lux","codename":"P632A10","model":"ZTE Fit 4G Smart"},{"manufacturer":"ZTE","market_name":"Blade Q Lux","codename":"P632A10","model":"ZTE T311"},{"manufacturer":"ZTE","market_name":"Blade Q Lux","codename":"P816A12","model":"Blade Q Lux"},{"manufacturer":"ZTE","market_name":"Blade Q Lux","codename":"P816A12","model":"ZTE Blade Q Lux"},{"manufacturer":"ZTE","market_name":"Blade Q Mini","codename":"P172G10_UK_VIRGIN","model":"ZTE Blade Q Mini"},{"manufacturer":"ZTE","market_name":"Blade Q2","codename":"P172A12","model":"Blade Q2"},{"manufacturer":"ZTE","market_name":"Blade Q3","codename":"P731A30","model":"ZTE Blade Q3"},{"manufacturer":"ZTE","market_name":"Blade Q3","codename":"P731A30","model":"ZTE T230"},{"manufacturer":"ZTE","market_name":"Blade S","codename":"P839F30","model":"Blade S"},{"manufacturer":"ZTE","market_name":"Blade S","codename":"blade2","model":"Blade S"},{"manufacturer":"ZTE","market_name":"Blade S Lite","codename":"P839F30","model":"Blade S Lite"},{"manufacturer":"ZTE","market_name":"Blade S6","codename":"P839F30","model":"Blade S6"},{"manufacturer":"ZTE","market_name":"Blade S6","codename":"P839F30","model":"LS-5008"},{"manufacturer":"ZTE","market_name":"Blade S6","codename":"P839F30","model":"NOS SLIM"},{"manufacturer":"ZTE","market_name":"Blade S6 Flex","codename":"P839T60","model":"ZTE Blade S6 Flex"},{"manufacturer":"ZTE","market_name":"Blade S6 Lite","codename":"P839F30","model":"Blade S6"},{"manufacturer":"ZTE","market_name":"Blade S6 Lite","codename":"P839F30","model":"Blade S6 Lite"},{"manufacturer":"ZTE","market_name":"Blade S6 Lite","codename":"P839F30","model":"ZTE T912"},{"manufacturer":"ZTE","market_name":"Blade S6 Plus","codename":"P839F50","model":"Blade S6 Plus"},{"manufacturer":"ZTE","market_name":"Blade V","codename":"ZTE-Blade-V","model":"Vodafone Blade V"},{"manufacturer":"ZTE","market_name":"Blade V","codename":"ZTE-Blade-V","model":"ZTE Blade V"},{"manufacturer":"ZTE","market_name":"Blade V+","codename":"P816A12","model":"Blade V+"},{"manufacturer":"ZTE","market_name":"Blade V2","codename":"msm8916_32","model":"ZTE Blade V2"},{"manufacturer":"ZTE","market_name":"Blade V220","codename":"msm8916_32","model":"ZTE Blade V220"},{"manufacturer":"ZTE","market_name":"Blade V580","codename":"ZTE_Blade_V580","model":"Blade V580"},{"manufacturer":"ZTE","market_name":"Blade V580","codename":"ZTE_Blade_V580","model":"Turk Telekom TT175"},{"manufacturer":"ZTE","market_name":"Blade V580","codename":"ZTE_Blade_V580","model":"ZTE Blade V580"},{"manufacturer":"ZTE","market_name":"Blade V6","codename":"P635A20","model":"BGH Joy V6"},{"manufacturer":"ZTE","market_name":"Blade V6","codename":"P635A20","model":"Blade V6"},{"manufacturer":"ZTE","market_name":"Blade V6","codename":"P635A20","model":"ZTE Blade V6"},{"manufacturer":"ZTE","market_name":"Blade V6","codename":"P635A20","model":"ZTE T660"},{"manufacturer":"ZTE","market_name":"Blade V6","codename":"P635A20","model":"ZTE T663"},{"manufacturer":"ZTE","market_name":"Blade V6 Max","codename":"ZTE_BLADE_A610","model":"Blade V6 Max"},{"manufacturer":"ZTE","market_name":"Blade V6 Plus","codename":"ZTE_BLADE_V0720","model":"Blade V6 Plus"},{"manufacturer":"ZTE","market_name":"Blade V6 Plus","codename":"ZTE_BLADE_V0720","model":"ZTE Blade V6 Plus"},{"manufacturer":"ZTE","market_name":"Blade V770","codename":"P852F52","model":"ZTE Blade V770"},{"manufacturer":"ZTE","market_name":"Blade VEC","codename":"P692S20_Q82","model":"ZTE Blade VEC"},{"manufacturer":"ZTE","market_name":"Blade Vec","codename":"P692S20_Q82","model":"Blade Vec"},{"manufacturer":"ZTE","market_name":"Blade Vec","codename":"P692S20_Q82","model":"ZTE Blade Vec"},{"manufacturer":"ZTE","market_name":"Blade Vec","codename":"P692S20_Q82","model":"ZTE Geek 2"},{"manufacturer":"ZTE","market_name":"Blade Vec 4G","codename":"msm8226","model":"ZTE Blade Vec 4G"},{"manufacturer":"ZTE","market_name":"Blade Vec Pro","codename":"P692S20_M92","model":"ZTE Blade Vec Pro"},{"manufacturer":"ZTE","market_name":"Blade X Max","codename":"stollen","model":"Z983"},{"manufacturer":"ZTE","market_name":"Bland A610","codename":"ZTE_BLADE_A610","model":"ZTE BLADE A610"},{"manufacturer":"ZTE","market_name":"Bland A610","codename":"ZTE_BLADE_A610","model":"ZTE Blade A610"},{"manufacturer":"ZTE","market_name":"Bolton","codename":"florist","model":"Z986DL"},{"manufacturer":"ZTE","market_name":"Bouygues Telecom Bs 351","codename":"nice","model":"Bouygues Telecom Bs 351"},{"manufacturer":"ZTE","market_name":"Bouygues Telecom Bs 402","codename":"P172G10","model":"A4C"},{"manufacturer":"ZTE","market_name":"Bouygues Telecom Bs 402","codename":"P172G10","model":"Amazing A4C"},{"manufacturer":"ZTE","market_name":"Bouygues Telecom Bs 402","codename":"P172G10","model":"Bouygues Telecom Bs 402"},{"manufacturer":"ZTE","market_name":"Bouygues Telecom Bs 402","codename":"P172G10","model":"ZTE Blade Q Mini"},{"manufacturer":"ZTE","market_name":"C2016","codename":"orchid","model":"ZTE C2016"},{"manufacturer":"ZTE","market_name":"C2017","codename":"alice","model":"ZTE C2017"},{"manufacturer":"ZTE","market_name":"C310","codename":"P172D04","model":"L8301"},{"manufacturer":"ZTE","market_name":"C310","codename":"P172D04","model":"Movitel M8410"},{"manufacturer":"ZTE","market_name":"C310","codename":"P172D04","model":"ZTE Blade C310"},{"manufacturer":"ZTE","market_name":"C310","codename":"P172D04","model":"ZTE C310"},{"manufacturer":"ZTE","market_name":"C880","codename":"P635N32","model":"ZTE C880"},{"manufacturer":"ZTE","market_name":"C880A","codename":"P635B32","model":"ZTE C880A"},{"manufacturer":"ZTE","market_name":"C880D","codename":"P635D32","model":"ZTE C880D"},{"manufacturer":"ZTE","market_name":"C880S","codename":"P635N34","model":"ZTE C880S"},{"manufacturer":"ZTE","market_name":"C880S","codename":"S_P635N34","model":"ZTE C880S"},{"manufacturer":"ZTE","market_name":"C880S","codename":"T_P635N34","model":"ZTE C880S"},{"manufacturer":"ZTE","market_name":"C880S","codename":"V_P635N34","model":"ZTE C880S"},{"manufacturer":"ZTE","market_name":"C880U","codename":"P635V32","model":"ZTE C880U"},{"manufacturer":"ZTE","market_name":"CELL C EMPIRE E8","codename":"P635F50","model":"CELL C EMPIRE E8"},{"manufacturer":"ZTE","market_name":"Chapel","codename":"chapel","model":"Z831"},{"manufacturer":"ZTE","market_name":"ConeXis A1","codename":"ZTE_BLADE_L110","model":"ConeXis A1"},{"manufacturer":"ZTE","market_name":"ConeXis X1","codename":"P809F52","model":"ConeXis X1"},{"manufacturer":"ZTE","market_name":"ConeXis X2","codename":"ZTE_BLADE_V0850","model":"ConeXis X2"},{"manufacturer":"ZTE","market_name":"Cosmote Smart Share","codename":"nice","model":"Cosmote Smart Share"},{"manufacturer":"ZTE","market_name":"Cosmote Xplore","codename":"Cosmote","model":"Cosmote Xplore"},{"manufacturer":"ZTE","market_name":"Cosmote Xplore","codename":"Cosmote-Xplore","model":"Cosmote Xplore"},{"manufacturer":"ZTE","market_name":"DL2 PLUS","codename":"P637F02","model":"DL2 PLUS"},{"manufacturer":"ZTE","market_name":"DL2 PLUS","codename":"P637F02","model":"Digicel DL2 XL"},{"manufacturer":"ZTE","market_name":"Dialog Q143L","codename":"frosty","model":"Dialog Q143L"},{"manufacturer":"ZTE","market_name":"Digicel DL2 XL","codename":"P637F02","model":"Digicel DL2 XL"},{"manufacturer":"ZTE","market_name":"Extreme E8","codename":"P635A31","model":"Extreme E8"},{"manufacturer":"ZTE","market_name":"FT142D","codename":"msm8226","model":"FT142D"},{"manufacturer":"ZTE","market_name":"Fanfare 2","codename":"sheen","model":"Z815"},{"manufacturer":"ZTE","market_name":"G601U","codename":"P172E02","model":"ZTE G601U"},{"manufacturer":"ZTE","market_name":"G717C","codename":"P692N30","model":"ZTE G717C"},{"manufacturer":"ZTE","market_name":"G718C","codename":"ZTE-G718C","model":"ZTE G718C"},{"manufacturer":"ZTE","market_name":"G719C","codename":"ZTE-G719C","model":"ZTE G719C"},{"manufacturer":"ZTE","market_name":"G720C","codename":"ZTE-G720C","model":"ZTE G720C"},{"manufacturer":"ZTE","market_name":"G720T","codename":"P839T30","model":"ZTE G720T"},{"manufacturer":"ZTE","market_name":"G720T","codename":"V_P839T30","model":"ZTE G720T"},{"manufacturer":"ZTE","market_name":"GEEK II 4G","codename":"msm8226","model":"ZTE GEEK II 4G"},{"manufacturer":"ZTE","market_name":"GEEK II Pro","codename":"ztexasp92_wet_jb9","model":"ZTE GEEK II Pro"},{"manufacturer":"ZTE","market_name":"GEEK II Pro","codename":"ztexasp92_wet_jb9","model":"ZTE M1001"},{"manufacturer":"ZTE","market_name":"Geek","codename":"redhookbay","model":"ZTE Geek"},{"manufacturer":"ZTE","market_name":"Geek 2 LTE","codename":"msm8226","model":"ZTE Geek 2 LTE"},{"manufacturer":"ZTE","market_name":"Geek 2 pro","codename":"P692S20_M92","model":"ZTE Geek 2 pro"},{"manufacturer":"ZTE","market_name":"Grand Era","codename":"enterprise_RU","model":"ZTE Grand Era"},{"manufacturer":"ZTE","market_name":"Grand Memo","codename":"prindle","model":"Grand Memo"},{"manufacturer":"ZTE","market_name":"Grand Memo LTE","codename":"Grand-Memo","model":"ZTE Grand Memo"},{"manufacturer":"ZTE","market_name":"Grand Memo LTE","codename":"Grand-Memo","model":"ZTE Grand Memo LTE"},{"manufacturer":"ZTE","market_name":"Grand S Flex","codename":"iris","model":"Grand S Flex"},{"manufacturer":"ZTE","market_name":"Grand S Flex","codename":"iris","model":"ZTE Grand S Flex"},{"manufacturer":"ZTE","market_name":"Grand S II","codename":"P541T50","model":"ZTE Grand S II"},{"manufacturer":"ZTE","market_name":"Grand S II","codename":"P541T50","model":"ZTE S221"},{"manufacturer":"ZTE","market_name":"Grand S II","codename":"P897A21","model":"ZTE Grand S II"},{"manufacturer":"ZTE","market_name":"Grand S II LTE","codename":"msm8974","model":"ZTE Grand S II LTE"},{"manufacturer":"ZTE","market_name":"Grand X","codename":"P175A20","model":"Grand X"},{"manufacturer":"ZTE","market_name":"Grand X","codename":"P175A20","model":"Grand X(M)"},{"manufacturer":"ZTE","market_name":"Grand X","codename":"P175A20","model":"ZTE Grand X Classic"},{"manufacturer":"ZTE","market_name":"Grand X","codename":"P175A20","model":"ZTE V970"},{"manufacturer":"ZTE","market_name":"Grand X","codename":"P175A20","model":"ZTE V970M"},{"manufacturer":"ZTE","market_name":"Grand X","codename":"P175A20","model":"ZTE-U V970M"},{"manufacturer":"ZTE","market_name":"Grand X","codename":"P175A20","model":"tmn smart a18"},{"manufacturer":"ZTE","market_name":"Grand X 2","codename":"P682F06","model":"Amazing A7"},{"manufacturer":"ZTE","market_name":"Grand X 2","codename":"P682F06","model":"ZTE Grand X 2"},{"manufacturer":"ZTE","market_name":"Grand X 2","codename":"P682F06","model":"ZTE V968"},{"manufacturer":"ZTE","market_name":"Grand X 2","codename":"P682F06","model":"ZTE V969"},{"manufacturer":"ZTE","market_name":"Grand X In","codename":"mfld_pr2","model":"Grand X In"},{"manufacturer":"ZTE","market_name":"Grand X In","codename":"mfld_pr2","model":"STARADDICT II Plus"},{"manufacturer":"ZTE","market_name":"Grand X In","codename":"mfld_pr2","model":"ZTE Grand X In"},{"manufacturer":"ZTE","market_name":"Grand X Max 2","codename":"jerry","model":"Z988"},{"manufacturer":"ZTE","market_name":"Grand X Pro","codename":"P177A20","model":"Blade Super"},{"manufacturer":"ZTE","market_name":"Grand X Pro","codename":"P177A20","model":"Grand X Pro"},{"manufacturer":"ZTE","market_name":"Grand X Pro","codename":"P177A20","model":"KPN Smart 300"},{"manufacturer":"ZTE","market_name":"Grand X Quad Lite","codename":"P188F07","model":"Amazing A6"},{"manufacturer":"ZTE","market_name":"Grand X Quad Lite","codename":"P188F07","model":"V8602"},{"manufacturer":"ZTE","market_name":"Grand X Quad Lite","codename":"P188F07","model":"ZTE Grand X Quad Lite"},{"manufacturer":"ZTE","market_name":"Grand X Quad Lite","codename":"P188F07","model":"ZTE Grand X2"},{"manufacturer":"ZTE","market_name":"Grand X Quad Lite","codename":"P188F07","model":"ZTE Skate 2"},{"manufacturer":"ZTE","market_name":"Grand X Quad Lite","codename":"P188F07","model":"ZTE V967S"},{"manufacturer":"ZTE","market_name":"Grand X2 In","codename":"redhookbay","model":"Grand X2 In"},{"manufacturer":"ZTE","market_name":"Grand X2 In","codename":"redhookbay","model":"ZTE Grand X2 In"},{"manufacturer":"ZTE","market_name":"GrayJoy","codename":"grayjoy","model":"N9136"},{"manufacturer":"ZTE","market_name":"Helios X1","codename":"P809A01","model":"Helios X1"},{"manufacturer":"ZTE","market_name":"I-O DATA","codename":"B800S2_V1","model":"AV-ATB100"},{"manufacturer":"ZTE","market_name":"Infinity X^2 mini","codename":"msm8226","model":"Infinity X^2 mini"},{"manufacturer":"ZTE","market_name":"Jasper LTE","codename":"lemon","model":"Z718TL"},{"manufacturer":"ZTE","market_name":"K81","codename":"helen","model":"K81"},{"manufacturer":"ZTE","market_name":"K813","codename":"P809K50","model":"ZTE-K813"},{"manufacturer":"ZTE","market_name":"K83","codename":"K83","model":"Amazing_P8"},{"manufacturer":"ZTE","market_name":"K83","codename":"K83","model":"K83"},{"manufacturer":"ZTE","market_name":"K85","codename":"K85","model":"K85"},{"manufacturer":"ZTE","market_name":"K88","codename":"jasmine","model":"K88"},{"manufacturer":"ZTE","market_name":"K92","codename":"primrose","model":"K92"},{"manufacturer":"ZTE","market_name":"K97","codename":"K97","model":"K97"},{"manufacturer":"ZTE","market_name":"K97","codename":"K97","model":"ZTE K97"},{"manufacturer":"ZTE","market_name":"KIS","codename":"roamer2","model":"KIS"},{"manufacturer":"ZTE","market_name":"KIS PLUS","codename":"roamer2","model":"KIS PLUS"},{"manufacturer":"ZTE","market_name":"KPN Smart 400","codename":"msm8226","model":"KPN Smart 400"},{"manufacturer":"ZTE","market_name":"Karbonn_A1","codename":"N721","model":"Karbonn_A1"},{"manufacturer":"ZTE","market_name":"Kis 3","codename":"ZTE-P821E10","model":"MEO SMART A16"},{"manufacturer":"ZTE","market_name":"Kis 3","codename":"ZTE-P821E10","model":"MEO Smart A16"},{"manufacturer":"ZTE","market_name":"Kis 3","codename":"ZTE-P821E10","model":"MOCHE SMART A16"},{"manufacturer":"ZTE","market_name":"Kis 3","codename":"ZTE-P821E10","model":"ZTE Kis 3"},{"manufacturer":"ZTE","market_name":"Kis 3","codename":"ZTE-P821E10","model":"ZTE V811"},{"manufacturer":"ZTE","market_name":"Kis Lite","codename":"roamer2","model":"ZTE Kis Lite"},{"manufacturer":"ZTE","market_name":"Kis Pro","codename":"nice","model":"Optimus Zali"},{"manufacturer":"ZTE","market_name":"Kis Pro","codename":"nice","model":"ZTE Kis Pro"},{"manufacturer":"ZTE","market_name":"Kis Q","codename":"P172D02","model":"ZTE Kis Q"},{"manufacturer":"ZTE","market_name":"Kis T3","codename":"roamer2","model":"Kis T3"},{"manufacturer":"ZTE","market_name":"LEO M1","codename":"V883M","model":"V883M"},{"manufacturer":"ZTE","market_name":"LEO M1","codename":"V883M","model":"ZTE LEO M1"},{"manufacturer":"ZTE","market_name":"LEO S1","codename":"V972M","model":"V972M"},{"manufacturer":"ZTE","market_name":"LEO S1","codename":"V972M","model":"ZTE LEO S1"},{"manufacturer":"ZTE","market_name":"LEO S2","codename":"V982M_Z64","model":"ZTE LEO S2"},{"manufacturer":"ZTE","market_name":"LEO_Q1","codename":"hct72_wet_jb3","model":"V765M"},{"manufacturer":"ZTE","market_name":"LEO_Q1","codename":"hct72_wet_jb3","model":"ZTE LEO Q1"},{"manufacturer":"ZTE","market_name":"LEO_Q1","codename":"hct72_wet_jb3","model":"ZTE V765M"},{"manufacturer":"ZTE","market_name":"LEO_Q1","codename":"hct72_wet_jb3","model":"ZTE_CLARO_Q1"},{"manufacturer":"ZTE","market_name":"LEO_Q1","codename":"hct72_wet_jb3","model":"ZTE_LEO_Q1"},{"manufacturer":"ZTE","market_name":"LEO_Q1","codename":"hct72_wet_jb3","model":"mobifone M9001"},{"manufacturer":"ZTE","market_name":"LS-5503","codename":"P839F50","model":"LS-5503"},{"manufacturer":"ZTE","market_name":"LS-5503","codename":"P839F50","model":"ZTE Blade S6 Plus"},{"manufacturer":"ZTE","market_name":"Lannister","codename":"weeper","model":"Z863DL"},{"manufacturer":"ZTE","market_name":"Leopard MF800","codename":"roamer2","model":"Leopard MF800"},{"manufacturer":"ZTE","market_name":"Light Tab 2","codename":"v9plus","model":"Light Tab 2"},{"manufacturer":"ZTE","market_name":"M8402","codename":"roamer2","model":"M8402"},{"manufacturer":"ZTE","market_name":"M901C","codename":"P692N60","model":"ZTE M901C"},{"manufacturer":"ZTE","market_name":"MEDION LIFE P4310","codename":"skate","model":"MEDION LIFE P4310"},{"manufacturer":"ZTE","market_name":"MEDION Smartphone LIFE E3501","codename":"roamer2","model":"MEDION Smartphone LIFE E3501"},{"manufacturer":"ZTE","market_name":"MF97A","codename":"MF97A","model":"MF97A"},{"manufacturer":"ZTE","market_name":"MF97B","codename":"msm8974","model":"MF97B"},{"manufacturer":"ZTE","market_name":"MF97B","codename":"msm8974","model":"MF97B_ROGERS"},{"manufacturer":"ZTE","market_name":"MF97B_T","codename":"msm8974","model":"MF97B_T"},{"manufacturer":"ZTE","market_name":"MF97E","codename":"msm8974","model":"MF97E"},{"manufacturer":"ZTE","market_name":"MF97G","codename":"msm8974","model":"MF97G"},{"manufacturer":"ZTE","market_name":"MF97W","codename":"MF97W","model":"MF97W"},{"manufacturer":"ZTE","market_name":"MO-01J","codename":"MO-01J","model":"MO-01J"},{"manufacturer":"ZTE","market_name":"MO-01K","codename":"MO-01K","model":"MO-01K"},{"manufacturer":"ZTE","market_name":"MS4A","codename":"kiska","model":"MS4A"},{"manufacturer":"ZTE","market_name":"MS4A","codename":"roundtop","model":"MS4A"},{"manufacturer":"ZTE","market_name":"MTC SMART Run 4G","codename":"P632T31","model":"MTC SMART Run 4G"},{"manufacturer":"ZTE","market_name":"Majesty Pro LTE","codename":"stark","model":"Z798BL"},{"manufacturer":"ZTE","market_name":"Momodesign MD Droid","codename":"atlas40","model":"Momodesign MD Droid"},{"manufacturer":"ZTE","market_name":"Movistar Express","codename":"QB7211","model":"Movistar Express"},{"manufacturer":"ZTE","market_name":"Movistar Motion","codename":"roamer2","model":"Movistar Motion"},{"manufacturer":"ZTE","market_name":"N5L","codename":"prmthus","model":"ZTE N5L"},{"manufacturer":"ZTE","market_name":"N5S","codename":"P189F10","model":"ZTE N5S"},{"manufacturer":"ZTE","market_name":"N720","codename":"N720","model":"N720"},{"manufacturer":"ZTE","market_name":"N720","codename":"N720","model":"ZTE-U N720"},{"manufacturer":"ZTE","market_name":"N720","codename":"N720","model":"ZTE_U N720"},{"manufacturer":"ZTE","market_name":"N762","codename":"roamer","model":"N762"},{"manufacturer":"ZTE","market_name":"N765_APT","codename":"N765","model":"N765_APT"},{"manufacturer":"ZTE","market_name":"N790","codename":"deepblue","model":"N790"},{"manufacturer":"ZTE","market_name":"N795","codename":"deepblue","model":"ZTE N795"},{"manufacturer":"ZTE","market_name":"N798","codename":"atlas40","model":"ZTE N798"},{"manufacturer":"ZTE","market_name":"N798+","codename":"ZTE_N798","model":"ZTE N798+"},{"manufacturer":"ZTE","market_name":"N798+","codename":"ZTE_N798P","model":"ZTE N798+"},{"manufacturer":"ZTE","market_name":"N799D","codename":"ZTE-N799D","model":"N799D"},{"manufacturer":"ZTE","market_name":"N799D","codename":"ZTE-N799D","model":"ZTE N799D"},{"manufacturer":"ZTE","market_name":"N800","codename":"nex","model":"N800"},{"manufacturer":"ZTE","market_name":"N8000_USA_Cricket","codename":"N8000","model":"N8000_USA_Cricket"},{"manufacturer":"ZTE","market_name":"N8000_USA_RS","codename":"N8000","model":"N8000_USA_RS"},{"manufacturer":"ZTE","market_name":"N8000_WHTE_CKT","codename":"N8000","model":"N8000_WHTE_CKT"},{"manufacturer":"ZTE","market_name":"N8010_APT","codename":"N8010_APT","model":"N8010_APT"},{"manufacturer":"ZTE","market_name":"N810","codename":"fluid","model":"N810"},{"manufacturer":"ZTE","market_name":"N817","codename":"wellington","model":"N817"},{"manufacturer":"ZTE","market_name":"N818","codename":"ZTE-N818","model":"N818"},{"manufacturer":"ZTE","market_name":"N818","codename":"ZTE-N818","model":"ZTE N818"},{"manufacturer":"ZTE","market_name":"N8300_Reliance","codename":"N8300_Reliance","model":"N8300_Reliance"},{"manufacturer":"ZTE","market_name":"N8303","codename":"roamer2","model":"N8303"},{"manufacturer":"ZTE","market_name":"N850","codename":"sean","model":"N850"},{"manufacturer":"ZTE","market_name":"N850L","codename":"seanplus","model":"N850L"},{"manufacturer":"ZTE","market_name":"N855D","codename":"hope","model":"N855D"},{"manufacturer":"ZTE","market_name":"N860","codename":"arthur","model":"N860"},{"manufacturer":"ZTE","market_name":"N860","codename":"arthur","model":"Warp"},{"manufacturer":"ZTE","market_name":"N861","codename":"warp2","model":"N861"},{"manufacturer":"ZTE","market_name":"N880E","codename":"atlas40","model":"ZTE N880E"},{"manufacturer":"ZTE","market_name":"N880G","codename":"ZTE-N880G","model":"ZTE N880G"},{"manufacturer":"ZTE","market_name":"N900","codename":"ZTE-N900","model":"ZTE N900"},{"manufacturer":"ZTE","market_name":"N900D","codename":"ZTE-N900D","model":"ZTE N900D"},{"manufacturer":"ZTE","market_name":"N909","codename":"ZTE-N909","model":"ZTE N909"},{"manufacturer":"ZTE","market_name":"N909D","codename":"ZTE-N909D","model":"ZTE N909D"},{"manufacturer":"ZTE","market_name":"N910","codename":"arthur4g","model":"ZTE-N910"},{"manufacturer":"ZTE","market_name":"N9100","codename":"hayes","model":"N9100"},{"manufacturer":"ZTE","market_name":"N9101","codename":"apollo","model":"N9101"},{"manufacturer":"ZTE","market_name":"N9120","codename":"elden","model":"ZTE N9120"},{"manufacturer":"ZTE","market_name":"N9130","codename":"speed","model":"N9130"},{"manufacturer":"ZTE","market_name":"N9132","codename":"cinco","model":"N9132"},{"manufacturer":"ZTE","market_name":"N9180","codename":"N9180","model":"N9180"},{"manufacturer":"ZTE","market_name":"N918St","codename":"N918St","model":"BGH Joy Smart AXS II"},{"manufacturer":"ZTE","market_name":"N918St","codename":"N918St","model":"BGH Joy Smart AXS II D"},{"manufacturer":"ZTE","market_name":"N918St","codename":"N918St","model":"N918St"},{"manufacturer":"ZTE","market_name":"N918St","codename":"N918St","model":"ZTE N918St"},{"manufacturer":"ZTE","market_name":"N919","codename":"ZTE-N919","model":"ZTE N919"},{"manufacturer":"ZTE","market_name":"N919D","codename":"ZTE-N919D","model":"N919D"},{"manufacturer":"ZTE","market_name":"N919D","codename":"ZTE-N919D","model":"ZTE N919D"},{"manufacturer":"ZTE","market_name":"N928Dt","codename":"N928Dt","model":"ZTE N928Dt"},{"manufacturer":"ZTE","market_name":"N940Sc","codename":"N940Sc","model":"N940Sc"},{"manufacturer":"ZTE","market_name":"N9500","codename":"gordon","model":"N9500"},{"manufacturer":"ZTE","market_name":"N9510","codename":"warplte","model":"N9510"},{"manufacturer":"ZTE","market_name":"N9511","codename":"hera","model":"ZTE_N9511"},{"manufacturer":"ZTE","market_name":"N9515","codename":"warp4","model":"N9515"},{"manufacturer":"ZTE","market_name":"N9516","codename":"eridani","model":"N9516"},{"manufacturer":"ZTE","market_name":"N9518","codename":"warp6","model":"N9518"},{"manufacturer":"ZTE","market_name":"N9520","codename":"stormer","model":"N9520"},{"manufacturer":"ZTE","market_name":"N9521","codename":"max","model":"N9521"},{"manufacturer":"ZTE","market_name":"N958St","codename":"N958St","model":"N958St"},{"manufacturer":"ZTE","market_name":"N9810","codename":"quantum","model":"N9810"},{"manufacturer":"ZTE","market_name":"N983","codename":"P177F03","model":"ZTE N983"},{"manufacturer":"ZTE","market_name":"N9835","codename":"chovar","model":"N9835"},{"manufacturer":"ZTE","market_name":"N9835","codename":"chovar","model":"ZTE N9835"},{"manufacturer":"ZTE","market_name":"N986","codename":"P188F02","model":"N986"},{"manufacturer":"ZTE","market_name":"N986","codename":"P188F02","model":"ZTE N986"},{"manufacturer":"ZTE","market_name":"N986D","codename":"P188F10","model":"N986+"},{"manufacturer":"ZTE","market_name":"N986D","codename":"P188F10","model":"N986D"},{"manufacturer":"ZTE","market_name":"NE501J","codename":"NE501J","model":"NE501J"},{"manufacturer":"ZTE","market_name":"NE501J","codename":"NE501J","model":"V5"},{"manufacturer":"ZTE","market_name":"NE501J","codename":"NE501J","model":"ZTE_V5"},{"manufacturer":"ZTE","market_name":"NOS NEVA 80","codename":"P852F52","model":"NOS NEVA 80"},{"manufacturer":"ZTE","market_name":"NOS NOVU II","codename":"P680A20","model":"NOS NOVU II"},{"manufacturer":"ZTE","market_name":"NOS NOVU III","codename":"P637F10","model":"NOS NOVU III"},{"manufacturer":"ZTE","market_name":"NX402","codename":"NX40X","model":"NX402"},{"manufacturer":"ZTE","market_name":"NX403A","codename":"NX403A","model":"NX403A"},{"manufacturer":"ZTE","market_name":"NX404H","codename":"NX404H","model":"NX404H"},{"manufacturer":"ZTE","market_name":"NX405H","codename":"NX405H","model":"NX405H"},{"manufacturer":"ZTE","market_name":"NX406E","codename":"NX406E","model":"NX406E"},{"manufacturer":"ZTE","market_name":"NX40X","codename":"NX402","model":"NX402"},{"manufacturer":"ZTE","market_name":"NX40X_APT","codename":"NX40X","model":"NX40X"},{"manufacturer":"ZTE","market_name":"NX40X_APT","codename":"NX40X","model":"NX40X_APT"},{"manufacturer":"ZTE","market_name":"NX501","codename":"NX501","model":"NX501"},{"manufacturer":"ZTE","market_name":"NX501_APT","codename":"NX501","model":"NX501_APT"},{"manufacturer":"ZTE","market_name":"NX503A_Z4","codename":"NX503A_Z4","model":"NX503A_Z4"},{"manufacturer":"ZTE","market_name":"NX503J","codename":"NX503J","model":"NX503J"},{"manufacturer":"ZTE","market_name":"NX505J","codename":"NX505J","model":"NX505J"},{"manufacturer":"ZTE","market_name":"NX506J","codename":"NX506J","model":"NX506J"},{"manufacturer":"ZTE","market_name":"NX507J","codename":"NX507J","model":"NX507H"},{"manufacturer":"ZTE","market_name":"NX507J","codename":"NX507J","model":"NX507J"},{"manufacturer":"ZTE","market_name":"NX508J","codename":"NX508J","model":"NX508J"},{"manufacturer":"ZTE","market_name":"NX510J","codename":"NX510J","model":"NX510J"},{"manufacturer":"ZTE","market_name":"NX511J","codename":"NX511J","model":"NX511J"},{"manufacturer":"ZTE","market_name":"NX511J_V3","codename":"NX511J_V3","model":"NX511J_V3"},{"manufacturer":"ZTE","market_name":"NX512J","codename":"NX512J","model":"NX512J"},{"manufacturer":"ZTE","market_name":"NX513J","codename":"NX513J","model":"NX513J"},{"manufacturer":"ZTE","market_name":"NX521J","codename":"NX521J","model":"BGH Joy Smart AXS II"},{"manufacturer":"ZTE","market_name":"NX521J","codename":"NX521J","model":"NX521J"},{"manufacturer":"ZTE","market_name":"NX523J_V1","codename":"NX523J_V1","model":"NX523J_V1"},{"manufacturer":"ZTE","market_name":"NX527J_V1","codename":"NX527J_V1","model":"NX527J_V1"},{"manufacturer":"ZTE","market_name":"NX529J","codename":"NX529J","model":"NX529J"},{"manufacturer":"ZTE","market_name":"NX531J","codename":"NX531J","model":"NX531J"},{"manufacturer":"ZTE","market_name":"NX535J","codename":"NX535J","model":"NX535J"},{"manufacturer":"ZTE","market_name":"NX541J","codename":"NX541J","model":"NX541J"},{"manufacturer":"ZTE","market_name":"NX549J","codename":"NX549J","model":"NX549J"},{"manufacturer":"ZTE","market_name":"NX551J","codename":"NX551J","model":"NX551J"},{"manufacturer":"ZTE","market_name":"NX563J","codename":"NX563J","model":"NX563J"},{"manufacturer":"ZTE","market_name":"NX569J","codename":"NX569J","model":"NX569J"},{"manufacturer":"ZTE","market_name":"NX573J","codename":"NX573J","model":"NX573J"},{"manufacturer":"ZTE","market_name":"NX575J","codename":"NX575J","model":"NX575J"},{"manufacturer":"ZTE","market_name":"NX591J","codename":"NX591J","model":"NX591J"},{"manufacturer":"ZTE","market_name":"NX597J","codename":"NX597J","model":"NX597J"},{"manufacturer":"ZTE","market_name":"NX601J","codename":"NX601J","model":"NX601J"},{"manufacturer":"ZTE","market_name":"NX907J","codename":"NX907J","model":"NX907J"},{"manufacturer":"ZTE","market_name":"OWN FUN 5(4G)","codename":"VFD511","model":"OWN FUN 5(4G)"},{"manufacturer":"ZTE","market_name":"OWN One Plus","codename":"ZTE_Blade_V580","model":"OWN One Plus"},{"manufacturer":"ZTE","market_name":"Optimus Barcelona","codename":"blade2","model":"Optimus Barcelona"},{"manufacturer":"ZTE","market_name":"Orange Hi 4G","codename":"Orange_Hi_4G","model":"Orange Hi 4G"},{"manufacturer":"ZTE","market_name":"Orange Hi 4G","codename":"msm8226","model":"Orange Hi 4G"},{"manufacturer":"ZTE","market_name":"Orange Monte Carlo","codename":"skate","model":"Orange Monte Carlo"},{"manufacturer":"ZTE","market_name":"Orange Novi","codename":"oceanus","model":"Orange Novi"},{"manufacturer":"ZTE","market_name":"Orange Reyo","codename":"P172D10","model":"Avea inTouch 3 Large"},{"manufacturer":"ZTE","market_name":"Orange Reyo","codename":"P172D10","model":"Blade Q Maxi"},{"manufacturer":"ZTE","market_name":"Orange Reyo","codename":"P172D10","model":"Orange Reyo"},{"manufacturer":"ZTE","market_name":"Orange Reyo","codename":"P172D10","model":"ZTE Blade Q Maxi"},{"manufacturer":"ZTE","market_name":"Orange Rono","codename":"Vec4G","model":"Orange Rono"},{"manufacturer":"ZTE","market_name":"Orange Rono","codename":"msm8226","model":"Orange Rono"},{"manufacturer":"ZTE","market_name":"Orange Zali","codename":"nice","model":"Orange Zali"},{"manufacturer":"ZTE","market_name":"Own One","codename":"P635A20","model":"Own One"},{"manufacturer":"ZTE","market_name":"P_C880S","codename":"P_P635N34","model":"ZTE P_C880S"},{"manufacturer":"ZTE","market_name":"Preo Teknosa P1","codename":"msm8916_32","model":"Preo Teknosa P1"},{"manufacturer":"ZTE","market_name":"Q101T","codename":"P810T10","model":"ZTE Q101T"},{"manufacturer":"ZTE","market_name":"Q201T","codename":"P172T24","model":"ZTE Q201T"},{"manufacturer":"ZTE","market_name":"Q2S-C","codename":"P826N50","model":"ZTE Q2S-C"},{"manufacturer":"ZTE","market_name":"Q2S-T","codename":"P826T50","model":"ZTE Q2S-T"},{"manufacturer":"ZTE","market_name":"Q301C","codename":"APT_TW_P810N30","model":"ZTE Q301C"},{"manufacturer":"ZTE","market_name":"Q301C","codename":"P810N30","model":"ZTE Q301C"},{"manufacturer":"ZTE","market_name":"Q301T","codename":"P172T33","model":"ZTE Q301T"},{"manufacturer":"ZTE","market_name":"Q302C","codename":"P809N20","model":"ZTE Q302C"},{"manufacturer":"ZTE","market_name":"Q5-C","codename":"P816N34","model":"ZTE Q5-C"},{"manufacturer":"ZTE","market_name":"Q5-T","codename":"CU_P816T32","model":"ZTE Q5-T"},{"manufacturer":"ZTE","market_name":"Q5-T","codename":"P816T32","model":"ZTE Q5-T"},{"manufacturer":"ZTE","market_name":"Q501T","codename":"P172T31","model":"ZTE Q501T"},{"manufacturer":"ZTE","market_name":"Q501U","codename":"P172F04","model":"ZTE Q501U"},{"manufacturer":"ZTE","market_name":"Q503U","codename":"P682V53","model":"ZTE Q503U"},{"manufacturer":"ZTE","market_name":"Q505T","codename":"P826T20","model":"ZTE Q505T"},{"manufacturer":"ZTE","market_name":"Q507T","codename":"P682T20","model":"ZTE Q507T"},{"manufacturer":"ZTE","market_name":"Q508U","codename":"P816V50","model":"ZTE Q508U"},{"manufacturer":"ZTE","market_name":"Q509T","codename":"P632T31","model":"Amazing X5"},{"manufacturer":"ZTE","market_name":"Q509T","codename":"P632T31","model":"MTC SMART Run 4G"},{"manufacturer":"ZTE","market_name":"Q509T","codename":"P632T31","model":"ZTE Blade A450"},{"manufacturer":"ZTE","market_name":"Q509T","codename":"P632T31","model":"ZTE Blade V2 Lite"},{"manufacturer":"ZTE","market_name":"Q509T","codename":"P632T31","model":"ZTE Q509T"},{"manufacturer":"ZTE","market_name":"Q519T","codename":"ZTE_Q519T","model":"ZTE Q519T"},{"manufacturer":"ZTE","market_name":"Q529C","codename":"P635N33","model":"ZTE Q529C"},{"manufacturer":"ZTE","market_name":"Q529C","codename":"V_P635N33","model":"ZTE Q529C"},{"manufacturer":"ZTE","market_name":"Q529E","codename":"P635T35","model":"ZTE Q529E"},{"manufacturer":"ZTE","market_name":"Q529T","codename":"P635T33","model":"ZTE Q529T"},{"manufacturer":"ZTE","market_name":"Q7","codename":"CMCC_P839V50","model":"ZTE Q7"},{"manufacturer":"ZTE","market_name":"Q7","codename":"CU_P839V50","model":"ZTE Q7"},{"manufacturer":"ZTE","market_name":"Q7","codename":"P839V50","model":"ZTE Q7"},{"manufacturer":"ZTE","market_name":"Q7-C","codename":"P839N50","model":"ZTE Q7-C"},{"manufacturer":"ZTE","market_name":"Q701C","codename":"ZTE-Q701C","model":"ZTE Q701C"},{"manufacturer":"ZTE","market_name":"Q705U","codename":"P682V60","model":"ZTE Q705U"},{"manufacturer":"ZTE","market_name":"Q801C","codename":"ZTE-Q801C","model":"ZTE Q801C"},{"manufacturer":"ZTE","market_name":"Q801L","codename":"ZTE-Q801L","model":"ZTE Q801L"},{"manufacturer":"ZTE","market_name":"Q801T","codename":"P181L30","model":"ZTE Q801T"},{"manufacturer":"ZTE","market_name":"Q801U","codename":"P826V30","model":"ZTE Q801U"},{"manufacturer":"ZTE","market_name":"Q802C","codename":"ZTE-Q802C","model":"ZTE Q802C"},{"manufacturer":"ZTE","market_name":"Q802D","codename":"ZTE-Q802D","model":"ZTE Q802D"},{"manufacturer":"ZTE","market_name":"Q802T","codename":"P826T30","model":"ZTE Q802T"},{"manufacturer":"ZTE","market_name":"Q805T","codename":"P120T55","model":"ZTE Q805T"},{"manufacturer":"ZTE","market_name":"Q806T","codename":"V_P635T30","model":"ZTE Q806T"},{"manufacturer":"ZTE","market_name":"Quartz","codename":"platy","model":"Quartz"},{"manufacturer":"ZTE","market_name":"Quartz","codename":"platy","model":"ZW10"},{"manufacturer":"ZTE","market_name":"R83","codename":"demeter","model":"ZTE R83"},{"manufacturer":"ZTE","market_name":"RACER III mini","codename":"roamer2","model":"RACER III mini"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"Carl"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"MTC 916"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"MTS-SP100"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"Movistar Link"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"RTK D1"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"Racer"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"TaiWan Mobile T2"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"V8402"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"Vip Droid"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"XCD 28"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"ZTE X850"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"ZTE-C N600"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"ZTE-C N600+"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"ZTE-LINK"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"ZTE-RACER"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"ZTE-U V852"},{"manufacturer":"ZTE","market_name":"Racer","codename":"mooncake","model":"ZTE-U X850"},{"manufacturer":"ZTE","market_name":"Rook from EE","codename":"P635E40","model":"Rook from EE"},{"manufacturer":"ZTE","market_name":"S118","codename":"P189S10","model":"Grand S Lite"},{"manufacturer":"ZTE","market_name":"S118","codename":"P189S10","model":"ZTE S118"},{"manufacturer":"ZTE","market_name":"S2004","codename":"msm8974","model":"ZTE S2004"},{"manufacturer":"ZTE","market_name":"S2005","codename":"msm8974","model":"ZTE S2005"},{"manufacturer":"ZTE","market_name":"S2007","codename":"msm8974","model":"ZTE S2007"},{"manufacturer":"ZTE","market_name":"S2010","codename":"P653S10","model":"ZTE S2010"},{"manufacturer":"ZTE","market_name":"S2010","codename":"P_P653S10","model":"ZTE S2010"},{"manufacturer":"ZTE","market_name":"S2010","codename":"V_P653S10","model":"ZTE S2010"},{"manufacturer":"ZTE","market_name":"S2010","codename":"ZTE_S2010","model":"ZTE S2010"},{"manufacturer":"ZTE","market_name":"S2014","codename":"ZTE-S2014","model":"ZTE S2014"},{"manufacturer":"ZTE","market_name":"S2015","codename":"ZTE-S2015","model":"ZTE S2015"},{"manufacturer":"ZTE","market_name":"S8Q","codename":"MT8123","model":"S8Q"},{"manufacturer":"ZTE","market_name":"SKATE","codename":"skate","model":"ZTE-SKATE"},{"manufacturer":"ZTE","market_name":"SMART Start 3","codename":"ZTE_BLADE_L110","model":"SMART Start 3"},{"manufacturer":"ZTE","market_name":"STAR","codename":"msm8226","model":"ZTE GEEK II Pro 4G"},{"manufacturer":"ZTE","market_name":"STAR","codename":"msm8226","model":"ZTE S2002"},{"manufacturer":"ZTE","market_name":"STAR","codename":"msm8226","model":"ZTE STAR"},{"manufacturer":"ZTE","market_name":"STAR","codename":"msm8226","model":"ZTE Star 1"},{"manufacturer":"ZTE","market_name":"STARNAUTE II","codename":"V6600","model":"STARNAUTE II"},{"manufacturer":"ZTE","market_name":"STARTRAIL 4","codename":"P172E10","model":"Avea inTouch 3"},{"manufacturer":"ZTE","market_name":"STARTRAIL 4","codename":"P172E10","model":"STARTRAIL 4"},{"manufacturer":"ZTE","market_name":"STARTRAIL 4","codename":"P172E10","model":"ZTE Blade Q"},{"manufacturer":"ZTE","market_name":"STARXTREM","codename":"prindle","model":"STARXTREM"},{"manufacturer":"ZTE","market_name":"STARXTREM 4","codename":"msm8916_32","model":"STARXTREM 4"},{"manufacturer":"ZTE","market_name":"Sapphire 3G","codename":"sapphire","model":"N818S"},{"manufacturer":"ZTE","market_name":"Sirius","codename":"msm8937","model":"Z610DL"},{"manufacturer":"ZTE","market_name":"Skate","codename":"skate","model":"ZTE Skate"},{"manufacturer":"ZTE","market_name":"Skate  Pro","codename":"atlas40","model":"Skate Pro"},{"manufacturer":"ZTE","market_name":"SmartTab10","codename":"V11A","model":"SmartTab10"},{"manufacturer":"ZTE","market_name":"SmartTab7","codename":"V71A","model":"SmartTab7"},{"manufacturer":"ZTE","market_name":"SoshPhone 3","codename":"SoshPhone_3","model":"SoshPhone 3"},{"manufacturer":"ZTE","market_name":"Soshphone 4G","codename":"Vec4G","model":"Soshphone 4G"},{"manufacturer":"ZTE","market_name":"Soshphone 4G","codename":"msm8226","model":"Soshphone 4G"},{"manufacturer":"ZTE","market_name":"Spro 2","codename":"msm8974","model":"502ZT"},{"manufacturer":"ZTE","market_name":"Spro 2","codename":"msm8974","model":"MF97B"},{"manufacturer":"ZTE","market_name":"Spro 2","codename":"msm8974","model":"MF97V"},{"manufacturer":"ZTE","market_name":"Spro 2","codename":"msm8974","model":"Spro 2"},{"manufacturer":"ZTE","market_name":"Spro 2","codename":"msm8974","model":"Spro 2 LTE"},{"manufacturer":"ZTE","market_name":"Spro 2","codename":"msm8974","model":"ZKB2A"},{"manufacturer":"ZTE","market_name":"Spro2","codename":"msm8974","model":"Spro2"},{"manufacturer":"ZTE","market_name":"Stack","codename":"martell","model":"Z799VL"},{"manufacturer":"ZTE","market_name":"Switch X1","codename":"deepblue","model":"ZTE Switch X1"},{"manufacturer":"ZTE","market_name":"Switch X1","codename":"deepblue","model":"ZTE V796"},{"manufacturer":"ZTE","market_name":"T-Mobile Vivacity","codename":"blade2","model":"T-Mobile Vivacity"},{"manufacturer":"ZTE","market_name":"T12","codename":"P173A30T","model":"ZTE T12"},{"manufacturer":"ZTE","market_name":"T221","codename":"P731A20","model":"Blade C341"},{"manufacturer":"ZTE","market_name":"T221","codename":"P731A20","model":"DIGICEL DL755"},{"manufacturer":"ZTE","market_name":"T221","codename":"P731A20","model":"KIS C341"},{"manufacturer":"ZTE","market_name":"T221","codename":"P731A20","model":"ZTE Blade A5"},{"manufacturer":"ZTE","market_name":"T221","codename":"P731A20","model":"ZTE Blade AF5"},{"manufacturer":"ZTE","market_name":"T221","codename":"P731A20","model":"ZTE Blade C341"},{"manufacturer":"ZTE","market_name":"T221","codename":"P731A20","model":"ZTE Blade C342"},{"manufacturer":"ZTE","market_name":"T221","codename":"P731A20","model":"ZTE T221"},{"manufacturer":"ZTE","market_name":"T221","codename":"P731A20","model":"ZTE T230"},{"manufacturer":"ZTE","market_name":"T28","codename":"bluetick","model":"ZTE T28"},{"manufacturer":"ZTE","market_name":"T28","codename":"bluetick","model":"ZTE T28 Prepaid"},{"manufacturer":"ZTE","market_name":"T3","codename":"skate","model":"T3"},{"manufacturer":"ZTE","market_name":"T325","codename":"ZTE_T325","model":"ZTE T325"},{"manufacturer":"ZTE","market_name":"T520","codename":"P172A40","model":"ZTE T520"},{"manufacturer":"ZTE","market_name":"T60","codename":"turies","model":"ZTE T60"},{"manufacturer":"ZTE","market_name":"T617","codename":"ZTE_T617","model":"ZTE T617"},{"manufacturer":"ZTE","market_name":"T620","codename":"ZTE_T620","model":"ZTE T620"},{"manufacturer":"ZTE","market_name":"T630","codename":"P635T30","model":"ZTE T630"},{"manufacturer":"ZTE","market_name":"T760","codename":"P173A10T","model":"ZTE T760"},{"manufacturer":"ZTE","market_name":"T790","codename":"roamer2","model":"ZTE T790"},{"manufacturer":"ZTE","market_name":"T792","codename":"ZTE-T792","model":"ZTE B792"},{"manufacturer":"ZTE","market_name":"T792","codename":"ZTE-T792","model":"ZTE T792"},{"manufacturer":"ZTE","market_name":"T80","codename":"msm8226","model":"ZTE T80"},{"manufacturer":"ZTE","market_name":"T81","codename":"iliamna","model":"ZTE T81"},{"manufacturer":"ZTE","market_name":"T82","codename":"frosty","model":"ZTE T82"},{"manufacturer":"ZTE","market_name":"T83","codename":"demeter","model":"ZTE T83"},{"manufacturer":"ZTE","market_name":"T84","codename":"P816A20","model":"ZTE R84"},{"manufacturer":"ZTE","market_name":"T84","codename":"P816A20","model":"ZTE T84"},{"manufacturer":"ZTE","market_name":"T85","codename":"P840F20","model":"T85"},{"manufacturer":"ZTE","market_name":"T86","codename":"msm8226","model":"Amazing X1"},{"manufacturer":"ZTE","market_name":"T86","codename":"msm8226","model":"ZTE T86"},{"manufacturer":"ZTE","market_name":"T88","codename":"msm8226","model":"ZTE T88"},{"manufacturer":"ZTE","market_name":"T911","codename":"P839F30","model":"ZTE T911"},{"manufacturer":"ZTE","market_name":"T912","codename":"P839F30","model":"ZTE T912"},{"manufacturer":"ZTE","market_name":"T920","codename":"ZTE_T920","model":"ZTE T920"},{"manufacturer":"ZTE","market_name":"TQ150","codename":"QB7211","model":"TQ150"},{"manufacturer":"ZTE","market_name":"TURKCELL T40","codename":"TURKCELL-T40","model":"TURKCELL T40"},{"manufacturer":"ZTE","market_name":"TURKCELL T50","codename":"msm8226","model":"TURKCELL T50"},{"manufacturer":"ZTE","market_name":"TURKCELL T50","codename":"msm8226","model":"TURKCELL TURBO T50"},{"manufacturer":"ZTE","market_name":"TURKCELL T60","codename":"P839T60","model":"TURKCELL T60"},{"manufacturer":"ZTE","market_name":"TURKCELL T60","codename":"msm8916_32","model":"TURKCELL T60"},{"manufacturer":"ZTE","market_name":"TURKCELL T70","codename":"P809T70","model":"TURKCELL T70"},{"manufacturer":"ZTE","market_name":"TURKCELL T80","codename":"P840F14","model":"TURKCELL T80"},{"manufacturer":"ZTE","market_name":"Telenor Touch Plus","codename":"blade2","model":"Telenor Touch Plus"},{"manufacturer":"ZTE","market_name":"Tempo","codename":"xray45","model":"N9131"},{"manufacturer":"ZTE","market_name":"Turkcell Maxi Plus 5","codename":"nice","model":"Turkcell Maxi Plus 5"},{"manufacturer":"ZTE","market_name":"U N721","codename":"N721","model":"ZTE-U N721"},{"manufacturer":"ZTE","market_name":"U V760","codename":"ztenj73_gb","model":"MD Smart"},{"manufacturer":"ZTE","market_name":"U V760","codename":"ztenj73_gb","model":"Telenor Touch Mini"},{"manufacturer":"ZTE","market_name":"U V760","codename":"ztenj73_gb","model":"ZTE-U V760"},{"manufacturer":"ZTE","market_name":"U V760","codename":"ztenj73_gb","model":"ZTE-U V856"},{"manufacturer":"ZTE","market_name":"U V760","codename":"ztenj73_gb","model":"ZTE-U V857"},{"manufacturer":"ZTE","market_name":"U V760","codename":"ztenj73_gb","model":"moii E598"},{"manufacturer":"ZTE","market_name":"U5S","codename":"P188T51","model":"ZTE U5S"},{"manufacturer":"ZTE","market_name":"U809","codename":"P172T11","model":"ZTE U809"},{"manufacturer":"ZTE","market_name":"U816","codename":"P988T20","model":"ZTE U816"},{"manufacturer":"ZTE","market_name":"U817","codename":"P117A20","model":"ZTE U817"},{"manufacturer":"ZTE","market_name":"U818","codename":"P172T21","model":"ZTE U818"},{"manufacturer":"ZTE","market_name":"U879","codename":"P172T30","model":"ZTE U879"},{"manufacturer":"ZTE","market_name":"U880","codename":"U880","model":"ZTE-T U880"},{"manufacturer":"ZTE","market_name":"U889","codename":"P183T30","model":"ZTE U889"},{"manufacturer":"ZTE","market_name":"U9180","codename":"U9180","model":"U9180"},{"manufacturer":"ZTE","market_name":"U9180","codename":"U9180","model":"ZTE U9180"},{"manufacturer":"ZTE","market_name":"U968","codename":"P682T51","model":"ZTE U968"},{"manufacturer":"ZTE","market_name":"U969","codename":"P682T50","model":"ZTE U969"},{"manufacturer":"ZTE","market_name":"U9815","codename":"P945T20","model":"ZTE U9815"},{"manufacturer":"ZTE","market_name":"U988S","codename":"pluto","model":"ZTE U988S"},{"manufacturer":"ZTE","market_name":"UZTE V790","codename":"roamer2","model":"UZTE V790"},{"manufacturer":"ZTE","market_name":"UZTE V817","codename":"ZTE-V956","model":"UZTE V817"},{"manufacturer":"ZTE","market_name":"Uhura","codename":"noah","model":"Z968"},{"manufacturer":"ZTE","market_name":"Ultym 5.2","codename":"msm8916_32","model":"Ultym 5.2"},{"manufacturer":"ZTE","market_name":"V55","codename":"V55","model":"V55"},{"manufacturer":"ZTE","market_name":"V5S","codename":"P189F13","model":"ZTE Grand Memo lite"},{"manufacturer":"ZTE","market_name":"V5S","codename":"P189F13","model":"ZTE V5S"},{"manufacturer":"ZTE","market_name":"V6500","codename":"V6500","model":"Etisalat Smartphone"},{"manufacturer":"ZTE","market_name":"V6500","codename":"V6500","model":"ZTE-V6500"},{"manufacturer":"ZTE","market_name":"V70","codename":"ZTE-V70","model":"ZTE V70"},{"manufacturer":"ZTE","market_name":"V7073","codename":"V7073","model":"ZTE V7073"},{"manufacturer":"ZTE","market_name":"V72","codename":"V72","model":"MT7A"},{"manufacturer":"ZTE","market_name":"V72","codename":"V72","model":"ZTE V72"},{"manufacturer":"ZTE","market_name":"V72","codename":"V72","model":"myPad P4 Lite"},{"manufacturer":"ZTE","market_name":"V72C","codename":"v72c","model":"V72C"},{"manufacturer":"ZTE","market_name":"V72M","codename":"eos","model":"V72M"},{"manufacturer":"ZTE","market_name":"V768","codename":"V768","model":"ZTE V768"},{"manufacturer":"ZTE","market_name":"V769M","codename":"V769M","model":"V769M"},{"manufacturer":"ZTE","market_name":"V769M","codename":"V769M","model":"ZTE LEO Q2"},{"manufacturer":"ZTE","market_name":"V769M","codename":"V769M","model":"ZTE V769M"},{"manufacturer":"ZTE","market_name":"V779M","codename":"ZTEV779M","model":"ZTE V779M"},{"manufacturer":"ZTE","market_name":"V790","codename":"roamer2","model":"ZTE V790"},{"manufacturer":"ZTE","market_name":"V791","codename":"P175A40","model":"V791"},{"manufacturer":"ZTE","market_name":"V791","codename":"P175A40","model":"ZTE V791"},{"manufacturer":"ZTE","market_name":"V792C","codename":"P810D01","model":"ZTE V792C"},{"manufacturer":"ZTE","market_name":"V793","codename":"P175A60","model":"Amazing A3"},{"manufacturer":"ZTE","market_name":"V793","codename":"P175A60","model":"Cellcom 4G"},{"manufacturer":"ZTE","market_name":"V793","codename":"P175A60","model":"M9000"},{"manufacturer":"ZTE","market_name":"V793","codename":"P175A60","model":"Telcel T20"},{"manufacturer":"ZTE","market_name":"V793","codename":"P175A60","model":"ZTE KIS Flex"},{"manufacturer":"ZTE","market_name":"V793","codename":"P175A60","model":"ZTE V793"},{"manufacturer":"ZTE","market_name":"V793","codename":"P175A60","model":"tmn smart a6"},{"manufacturer":"ZTE","market_name":"V795","codename":"P172D01","model":"BGH Joy Smart A1"},{"manufacturer":"ZTE","market_name":"V795","codename":"P172D01","model":"V795(A3S)"},{"manufacturer":"ZTE","market_name":"V795","codename":"P172D01","model":"ZTE B795"},{"manufacturer":"ZTE","market_name":"V795","codename":"P172D01","model":"ZTE KIS II"},{"manufacturer":"ZTE","market_name":"V795","codename":"P172D01","model":"ZTE KIS II PRO"},{"manufacturer":"ZTE","market_name":"V795","codename":"P172D01","model":"ZTE Kis II"},{"manufacturer":"ZTE","market_name":"V795","codename":"P172D01","model":"ZTE V795"},{"manufacturer":"ZTE","market_name":"V797","codename":"P172D03","model":"VIETTEL V8411"},{"manufacturer":"ZTE","market_name":"V797","codename":"P172D03","model":"ZTE V797"},{"manufacturer":"ZTE","market_name":"V8000_USA_Cricket","codename":"V8000","model":"V8000_USA_Cricket"},{"manufacturer":"ZTE","market_name":"V807","codename":"P177E01","model":"Amazing A4"},{"manufacturer":"ZTE","market_name":"V807","codename":"P177E01","model":"Beeline E700"},{"manufacturer":"ZTE","market_name":"V807","codename":"P177E01","model":"Leopard MF900"},{"manufacturer":"ZTE","market_name":"V807","codename":"P177E01","model":"UZTE V807"},{"manufacturer":"ZTE","market_name":"V807","codename":"P177E01","model":"V8501"},{"manufacturer":"ZTE","market_name":"V807","codename":"P177E01","model":"ZTE BLADE C"},{"manufacturer":"ZTE","market_name":"V807","codename":"P177E01","model":"ZTE V807"},{"manufacturer":"ZTE","market_name":"V807","codename":"P177E01","model":"ZTE V889S"},{"manufacturer":"ZTE","market_name":"V808","codename":"P172E01","model":"UZTE V808"},{"manufacturer":"ZTE","market_name":"V808","codename":"P172E01","model":"ZTE V808"},{"manufacturer":"ZTE","market_name":"V809","codename":"P172A10","model":"BGH Joy Smart A2"},{"manufacturer":"ZTE","market_name":"V809","codename":"P172A10","model":"ZTE Blade C2"},{"manufacturer":"ZTE","market_name":"V809","codename":"P172A10","model":"ZTE T809"},{"manufacturer":"ZTE","market_name":"V809","codename":"P172A10","model":"ZTE V809"},{"manufacturer":"ZTE","market_name":"V809","codename":"P172A10","model":"meo smart a12"},{"manufacturer":"ZTE","market_name":"V811","codename":"ZTE-V811","model":"Beeline Smart2"},{"manufacturer":"ZTE","market_name":"V811","codename":"ZTE-V811","model":"ZTE V811"},{"manufacturer":"ZTE","market_name":"V8110","codename":"V8110","model":"V8110"},{"manufacturer":"ZTE","market_name":"V811C","codename":"P810E01","model":"ZTE V811C"},{"manufacturer":"ZTE","market_name":"V811W","codename":"P821E10","model":"ZTE V811"},{"manufacturer":"ZTE","market_name":"V811W","codename":"P821E10","model":"ZTE V811W"},{"manufacturer":"ZTE","market_name":"V813W","codename":"P172B20","model":"ZTE Blade C2 Plus"},{"manufacturer":"ZTE","market_name":"V813W","codename":"P172B20","model":"ZTE V813W"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"Amazing A4S"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"B8405"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"BGH Joy Smart A5C"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"BGH Joy Smart A5d"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"KIS II Max"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"SMART Start"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"UZTE GRAND V7"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"ZTE B815"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"ZTE B816"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"ZTE Blade Buzz"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"ZTE Blade C320"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"ZTE Blade Q1"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"ZTE Kis II Max"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"ZTE Kis II Max Plus"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"ZTE Kis II Max plus"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"ZTE Maxx"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"ZTE T815"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"ZTE T816"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"ZTE V815W"},{"manufacturer":"ZTE","market_name":"V815W","codename":"P172R10","model":"ZTE V816W"},{"manufacturer":"ZTE","market_name":"V817","codename":"ZTE-V817","model":"V817"},{"manufacturer":"ZTE","market_name":"V817","codename":"ZTE-V817","model":"ZTE V817"},{"manufacturer":"ZTE","market_name":"V817","codename":"ZTE-V956","model":"ZTE V817"},{"manufacturer":"ZTE","market_name":"V818","codename":"P172F01","model":"ZTE Blade 2"},{"manufacturer":"ZTE","market_name":"V818","codename":"P172F01","model":"ZTE V818"},{"manufacturer":"ZTE","market_name":"V8200plus","codename":"V8200plus","model":"V8200plus"},{"manufacturer":"ZTE","market_name":"V8285","codename":"MT8382","model":"V8285"},{"manufacturer":"ZTE","market_name":"V829","codename":"P172A30","model":"BGH Joy Smart A3"},{"manufacturer":"ZTE","market_name":"V829","codename":"P172A30","model":"Blade G Pro"},{"manufacturer":"ZTE","market_name":"V829","codename":"P172A30","model":"V8507"},{"manufacturer":"ZTE","market_name":"V829","codename":"P172A30","model":"ZTE Blade G Plus"},{"manufacturer":"ZTE","market_name":"V829","codename":"P172A30","model":"ZTE Blade G Pro"},{"manufacturer":"ZTE","market_name":"V829","codename":"P172A30","model":"ZTE V829"},{"manufacturer":"ZTE","market_name":"V831W","codename":"P731A10","model":"Amazing A5S"},{"manufacturer":"ZTE","market_name":"V831W","codename":"P731A10","model":"UZTE Blade Q Pro"},{"manufacturer":"ZTE","market_name":"V831W","codename":"P731A10","model":"ZTE T320"},{"manufacturer":"ZTE","market_name":"V831W","codename":"P731A10","model":"ZTE V831W"},{"manufacturer":"ZTE","market_name":"V8403","codename":"roamer2","model":"V8403"},{"manufacturer":"ZTE","market_name":"V8514","codename":"P821E10","model":"V8514"},{"manufacturer":"ZTE","market_name":"V856","codename":"zte_v856","model":"ZTE-V856"},{"manufacturer":"ZTE","market_name":"V865M","codename":"hct77_jb","model":"V865M"},{"manufacturer":"ZTE","market_name":"V879","codename":"P172F02","model":"ZTE V879"},{"manufacturer":"ZTE","market_name":"V880E","codename":"atlas40","model":"ZTE V880E"},{"manufacturer":"ZTE","market_name":"V880G","codename":"ZTE-V880G","model":"ZTE V880G"},{"manufacturer":"ZTE","market_name":"V887","codename":"P177A10","model":"ZTE Blade L"},{"manufacturer":"ZTE","market_name":"V887","codename":"P177A10","model":"ZTE V887"},{"manufacturer":"ZTE","market_name":"V887","codename":"P177A10","model":"tmn smart a20"},{"manufacturer":"ZTE","market_name":"V889D","codename":"atlas40","model":"ZTE V889D"},{"manufacturer":"ZTE","market_name":"V889M","codename":"P175A10","model":"UZTE V889M"},{"manufacturer":"ZTE","market_name":"V889M","codename":"P175A10","model":"ZTE V889M"},{"manufacturer":"ZTE","market_name":"V891","codename":"P986E01","model":"ZTE V891"},{"manufacturer":"ZTE","market_name":"V9","codename":"v9","model":"A100"},{"manufacturer":"ZTE","market_name":"V9","codename":"v9","model":"BASE Tab"},{"manufacturer":"ZTE","market_name":"V9","codename":"v9","model":"BLACK 03"},{"manufacturer":"ZTE","market_name":"V9","codename":"v9","model":"Beeline M2"},{"manufacturer":"ZTE","market_name":"V9","codename":"v9","model":"Light"},{"manufacturer":"ZTE","market_name":"V9","codename":"v9","model":"Light Tab"},{"manufacturer":"ZTE","market_name":"V9","codename":"v9","model":"MTC 1055"},{"manufacturer":"ZTE","market_name":"V9","codename":"v9","model":"One Pad"},{"manufacturer":"ZTE","market_name":"V9","codename":"v9","model":"RTK V9"},{"manufacturer":"ZTE","market_name":"V9","codename":"v9","model":"TO101"},{"manufacturer":"ZTE","market_name":"V9","codename":"v9","model":"TT101"},{"manufacturer":"ZTE","market_name":"V9","codename":"v9","model":"V9"},{"manufacturer":"ZTE","market_name":"V9","codename":"v9","model":"V9C"},{"manufacturer":"ZTE","market_name":"V9","codename":"v9","model":"V9c"},{"manufacturer":"ZTE","market_name":"V9","codename":"v9","model":"V9e"},{"manufacturer":"ZTE","market_name":"V9","codename":"v9","model":"myPad P2"},{"manufacturer":"ZTE","market_name":"V9180","codename":"V9180","model":"V9180"},{"manufacturer":"ZTE","market_name":"V956","codename":"ZTE-V956","model":"ZTE V956"},{"manufacturer":"ZTE","market_name":"V965","codename":"P188F03","model":"ZTE Blade G2"},{"manufacturer":"ZTE","market_name":"V965","codename":"P188F03","model":"ZTE R880H"},{"manufacturer":"ZTE","market_name":"V965","codename":"P188F03","model":"ZTE V880H"},{"manufacturer":"ZTE","market_name":"V965","codename":"P188F03","model":"ZTE V965"},{"manufacturer":"ZTE","market_name":"V969","codename":"P682F01","model":"ZTE V969"},{"manufacturer":"ZTE","market_name":"V96A","codename":"V96A","model":"V96A"},{"manufacturer":"ZTE","market_name":"V970","codename":"whistler","model":"UZTE V970"},{"manufacturer":"ZTE","market_name":"V970","codename":"whistler","model":"ZTE V970"},{"manufacturer":"ZTE","market_name":"V975","codename":"redhookbay","model":"V975"},{"manufacturer":"ZTE","market_name":"V975","codename":"redhookbay","model":"ZTE Geek"},{"manufacturer":"ZTE","market_name":"V975","codename":"redhookbay","model":"ZTE V975"},{"manufacturer":"ZTE","market_name":"V9800","codename":"kiska","model":"ZTE V9800"},{"manufacturer":"ZTE","market_name":"V9820","codename":"ZTE-V9820","model":"ZTE V9820"},{"manufacturer":"ZTE","market_name":"V983","codename":"P177A30","model":"ZTE V983"},{"manufacturer":"ZTE","market_name":"V987","codename":"P188F04","model":"UZTE GRAND X Quad"},{"manufacturer":"ZTE","market_name":"V987","codename":"P188F04","model":"ZTE Grand X"},{"manufacturer":"ZTE","market_name":"V987","codename":"P188F04","model":"ZTE V987"},{"manufacturer":"ZTE","market_name":"V993W","codename":"ZTE_V993W","model":"ZTE V993W"},{"manufacturer":"ZTE","market_name":"V9A","codename":"v9plus","model":"Light Tab 2"},{"manufacturer":"ZTE","market_name":"V9A","codename":"v9plus","model":"V9A"},{"manufacturer":"ZTE","market_name":"V9A","codename":"v9plus","model":"ZTE V9A"},{"manufacturer":"ZTE","market_name":"V9A","codename":"v9plus","model":"my Pad P3"},{"manufacturer":"ZTE","market_name":"V9A","codename":"v9plus","model":"myPad P3"},{"manufacturer":"ZTE","market_name":"V9S","codename":"V9S","model":"V9S"},{"manufacturer":"ZTE","market_name":"V9S","codename":"V9S","model":"myPadP4"},{"manufacturer":"ZTE","market_name":"VERGATARIO 5","codename":"ZTE_BLADE_L110","model":"VERGATARIO 5"},{"manufacturer":"ZTE","market_name":"VERGATARIO5PLUS","codename":"ZTE_BLADE_L110","model":"VERGATARIO5PLUS"},{"manufacturer":"ZTE","market_name":"Vesta","codename":"proline","model":"Z965"},{"manufacturer":"ZTE","market_name":"Vip Racer III","codename":"atlas40","model":"Vip Racer III"},{"manufacturer":"ZTE","market_name":"Vodafone Smart Chat","codename":"turies","model":"Vodafone Smart Chat"},{"manufacturer":"ZTE","market_name":"Vodafone Smart ultra 6","codename":"msm8916_32","model":"Vodafone Smart ultra 6"},{"manufacturer":"ZTE","market_name":"Warp 7","codename":"beam","model":"N9519"},{"manufacturer":"ZTE","market_name":"X500","codename":"X500","model":"X500"},{"manufacturer":"ZTE","market_name":"X500","codename":"X500","model":"ZTE-X500"},{"manufacturer":"ZTE","market_name":"X501_USA_Cricket","codename":"X501","model":"X501_USA_Cricket"},{"manufacturer":"ZTE","market_name":"X501_USA_Cricket","codename":"X501","model":"X501_USA_RS"},{"manufacturer":"ZTE","market_name":"X501_USA_OM","codename":"X501","model":"X501_USA_OM"},{"manufacturer":"ZTE","market_name":"X9180","codename":"X9180","model":"X9180"},{"manufacturer":"ZTE","market_name":"Z-01K","codename":"Z-01K","model":"Z-01K"},{"manufacturer":"ZTE","market_name":"Z10","codename":"P817E52","model":"ZTE Z10"},{"manufacturer":"ZTE","market_name":"Z353VL","codename":"oldman","model":"Z353VL"},{"manufacturer":"ZTE","market_name":"Z557BL","codename":"lewis","model":"Z557BL"},{"manufacturer":"ZTE","market_name":"Z557BL","codename":"msm8909","model":"Z557BL"},{"manufacturer":"ZTE","market_name":"Z660G","codename":"nice","model":"Z660G"},{"manufacturer":"ZTE","market_name":"Z665C","codename":"seanplus","model":"Z665C"},{"manufacturer":"ZTE","market_name":"Z667","codename":"demi","model":"Z667"},{"manufacturer":"ZTE","market_name":"Z667T","codename":"bonnie","model":"Z667T"},{"manufacturer":"ZTE","market_name":"Z669","codename":"demi","model":"Z669"},{"manufacturer":"ZTE","market_name":"Z716BL","codename":"baffin","model":"Z716BL"},{"manufacturer":"ZTE","market_name":"Z717VL","codename":"lavender","model":"Z717VL"},{"manufacturer":"ZTE","market_name":"Z730","codename":"ada","model":"Z730"},{"manufacturer":"ZTE","market_name":"Z740","codename":"metis","model":"Z740"},{"manufacturer":"ZTE","market_name":"Z740G","codename":"metis","model":"Z740G"},{"manufacturer":"ZTE","market_name":"Z750C","codename":"Z750C","model":"Z750C"},{"manufacturer":"ZTE","market_name":"Z752C","codename":"eros","model":"Z752C"},{"manufacturer":"ZTE","market_name":"Z753G","codename":"faerie","model":"Z753G"},{"manufacturer":"ZTE","market_name":"Z755","codename":"iris","model":"Z755"},{"manufacturer":"ZTE","market_name":"Z768G","codename":"Z768G","model":"Z768G"},{"manufacturer":"ZTE","market_name":"Z777","codename":"betty","model":"Z777"},{"manufacturer":"ZTE","market_name":"Z787","codename":"apus","model":"Z787"},{"manufacturer":"ZTE","market_name":"Z791G","codename":"giant","model":"Z791G"},{"manufacturer":"ZTE","market_name":"Z792","codename":"giant","model":"Z792"},{"manufacturer":"ZTE","market_name":"Z793C","codename":"hera","model":"Z793C"},{"manufacturer":"ZTE","market_name":"Z795G","codename":"ZTE-Z795G","model":"Z795G"},{"manufacturer":"ZTE","market_name":"Z796C","codename":"Z796C","model":"Z796C"},{"manufacturer":"ZTE","market_name":"Z797C","codename":"carol","model":"Z797C"},{"manufacturer":"ZTE","market_name":"Z812","codename":"xuantan","model":"Z812"},{"manufacturer":"ZTE","market_name":"Z813","codename":"xuantan","model":"Z813"},{"manufacturer":"ZTE","market_name":"Z818L","codename":"sunny","model":"Z818L"},{"manufacturer":"ZTE","market_name":"Z819L","codename":"sungod","model":"Z819L"},{"manufacturer":"ZTE","market_name":"Z820","codename":"P675T07","model":"Z820"},{"manufacturer":"ZTE","market_name":"Z826","codename":"herculis","model":"Z826"},{"manufacturer":"ZTE","market_name":"Z828","codename":"achill","model":"Z828"},{"manufacturer":"ZTE","market_name":"Z828","codename":"achill","model":"Z828TL"},{"manufacturer":"ZTE","market_name":"Z830","codename":"gruis","model":"Z830"},{"manufacturer":"ZTE","market_name":"Z832","codename":"mimir","model":"Z832"},{"manufacturer":"ZTE","market_name":"Z833","codename":"camellia","model":"Z833"},{"manufacturer":"ZTE","market_name":"Z835","codename":"draco","model":"Z835"},{"manufacturer":"ZTE","market_name":"Z836BL","codename":"guardian","model":"Z836BL"},{"manufacturer":"ZTE","market_name":"Z836F","codename":"guardian","model":"Z836F"},{"manufacturer":"ZTE","market_name":"Z837VL","codename":"breaker","model":"Z837VL"},{"manufacturer":"ZTE","market_name":"Z839","codename":"sweet","model":"Z839"},{"manufacturer":"ZTE","market_name":"Z850","codename":"sif","model":"Z850"},{"manufacturer":"ZTE","market_name":"Z861BL","codename":"benz","model":"Z861BL"},{"manufacturer":"ZTE","market_name":"Z862VL","codename":"captain","model":"Z862VL"},{"manufacturer":"ZTE","market_name":"Z899VL","codename":"msm8909","model":"Z899VL"},{"manufacturer":"ZTE","market_name":"Z916BL","codename":"red","model":"Z916BL"},{"manufacturer":"ZTE","market_name":"Z917VL","codename":"fortune","model":"Z917VL"},{"manufacturer":"ZTE","market_name":"Z930L","codename":"coeus","model":"Z930L"},{"manufacturer":"ZTE","market_name":"Z932L","codename":"warplte","model":"Z932L"},{"manufacturer":"ZTE","market_name":"Z932L","codename":"warplte","model":"ZTE Z932L"},{"manufacturer":"ZTE","market_name":"Z933","codename":"glaucus","model":"Z933"},{"manufacturer":"ZTE","market_name":"Z936L","codename":"gift","model":"Z936L"},{"manufacturer":"ZTE","market_name":"Z955L","codename":"leo","model":"Z955A"},{"manufacturer":"ZTE","market_name":"Z955L","codename":"leo","model":"Z955L"},{"manufacturer":"ZTE","market_name":"Z956","codename":"financier","model":"Z956"},{"manufacturer":"ZTE","market_name":"Z957","codename":"financier","model":"Z957"},{"manufacturer":"ZTE","market_name":"Z958","codename":"lol","model":"Z958"},{"manufacturer":"ZTE","market_name":"Z959","codename":"abby","model":"Z959"},{"manufacturer":"ZTE","market_name":"Z962BL","codename":"tom","model":"Z962BL"},{"manufacturer":"ZTE","market_name":"Z963U","codename":"lily","model":"Z963U"},{"manufacturer":"ZTE","market_name":"Z963VL","codename":"nancy","model":"Z963VL"},{"manufacturer":"ZTE","market_name":"Z970","codename":"draconis","model":"Z970"},{"manufacturer":"ZTE","market_name":"Z971","codename":"peony","model":"Z971"},{"manufacturer":"ZTE","market_name":"Z980L","codename":"cygni","model":"Z980L"},{"manufacturer":"ZTE","market_name":"Z981","codename":"urd","model":"Z981"},{"manufacturer":"ZTE","market_name":"Z986U","codename":"cynthia","model":"Z986U"},{"manufacturer":"ZTE","market_name":"Z987","codename":"cygni","model":"Z987"},{"manufacturer":"ZTE","market_name":"Z990","codename":"roamer","model":"ZTE-Z990"},{"manufacturer":"ZTE","market_name":"Z990G","codename":"roamer","model":"ZTE-Z990G"},{"manufacturer":"ZTE","market_name":"Z992","codename":"aviva","model":"Z992"},{"manufacturer":"ZTE","market_name":"Z993","codename":"aviva","model":"Z993"},{"manufacturer":"ZTE","market_name":"Z995","codename":"becky","model":"Z995"},{"manufacturer":"ZTE","market_name":"Z998","codename":"coeus","model":"Z998"},{"manufacturer":"ZTE","market_name":"Z999","codename":"fujisan","model":"Z999"},{"manufacturer":"ZTE","market_name":"ZPAD","codename":"gevjon","model":"K90U"},{"manufacturer":"ZTE","market_name":"ZTE A0616","codename":"P637S15","model":"ZTE A0616"},{"manufacturer":"ZTE","market_name":"ZTE A0620","codename":"P840S13","model":"ZTE A0620"},{"manufacturer":"ZTE","market_name":"ZTE A0622","codename":"P817S13","model":"ZTE A0622"},{"manufacturer":"ZTE","market_name":"ZTE A2018","codename":"candice","model":"ZTE A2018"},{"manufacturer":"ZTE","market_name":"ZTE A520S","codename":"P809S10","model":"ZTE A520S"},{"manufacturer":"ZTE","market_name":"ZTE AVID 4","codename":"calbee","model":"Z855"},{"manufacturer":"ZTE","market_name":"ZTE BLADE A0605","codename":"P809F15","model":"ZTE BLADE A0605"},{"manufacturer":"ZTE","market_name":"ZTE BLADE A0620","codename":"P840F12","model":"ZTE BLADE A0620"},{"manufacturer":"ZTE","market_name":"ZTE BLADE A0621","codename":"P840F13","model":"ZTE BLADE A0621"},{"manufacturer":"ZTE","market_name":"ZTE BLADE A0622","codename":"P809F12","model":"ZTE BLADE A0622"},{"manufacturer":"ZTE","market_name":"ZTE BLADE A320","codename":"P809F20","model":"ZTE BLADE A320"},{"manufacturer":"ZTE","market_name":"ZTE BLADE A321","codename":"VFD511","model":"ZTE BLADE A321"},{"manufacturer":"ZTE","market_name":"ZTE BLADE A330","codename":"P809F30","model":"ZTE BLADE A330"},{"manufacturer":"ZTE","market_name":"ZTE BLADE A506","codename":"P809T70","model":"ZTE BLADE A506"},{"manufacturer":"ZTE","market_name":"ZTE BLADE A520","codename":"P637F10","model":"ZTE BLADE A520"},{"manufacturer":"ZTE","market_name":"ZTE BLADE A520C","codename":"P809F10","model":"ZTE BLADE A520C"},{"manufacturer":"ZTE","market_name":"ZTE BLADE A521","codename":"P809F10","model":"ZTE BLADE A521"},{"manufacturer":"ZTE","market_name":"ZTE BLADE A6","codename":"P840F13","model":"ZTE BLADE A6"},{"manufacturer":"ZTE","market_name":"ZTE BLADE A602","codename":"P637F02","model":"ZTE BLADE A602"},{"manufacturer":"ZTE","market_name":"ZTE BLADE A610","codename":"ZTE_BLADE_A610","model":"ZTE BLADE A610"},{"manufacturer":"ZTE","market_name":"ZTE BLADE A612","codename":"P635F50","model":"ZTE BLADE A612"},{"manufacturer":"ZTE","market_name":"ZTE BLADE A910","codename":"P635A31","model":"ZTE BLADE A910"},{"manufacturer":"ZTE","market_name":"ZTE BLADE L111","codename":"ZTE_BLADE_L110","model":"ZTE BLADE B111"},{"manufacturer":"ZTE","market_name":"ZTE BLADE L111","codename":"ZTE_BLADE_L110","model":"ZTE BLADE L110"},{"manufacturer":"ZTE","market_name":"ZTE BLADE L111","codename":"ZTE_BLADE_L110","model":"ZTE BLADE L111"},{"manufacturer":"ZTE","market_name":"ZTE BLADE L7","codename":"P731F10","model":"ZTE BLADE L7"},{"manufacturer":"ZTE","market_name":"ZTE BLADE V0710","codename":"ZTE_BLADE_V0710","model":"ZTE BLADE V0710"},{"manufacturer":"ZTE","market_name":"ZTE BLADE V0720","codename":"ZTE_BLADE_V0720","model":"ZTE BLADE V0720"},{"manufacturer":"ZTE","market_name":"ZTE BLADE V0800","codename":"ZTE_BLADE_V0800","model":"ZTE BLADE V0800"},{"manufacturer":"ZTE","market_name":"ZTE BLADE V0820","codename":"ZTE_BLADE_V0820","model":"ZTE BLADE V0820"},{"manufacturer":"ZTE","market_name":"ZTE BLADE V0840","codename":"P817F01","model":"ZTE BLADE V0840"},{"manufacturer":"ZTE","market_name":"ZTE BLADE V0850","codename":"ZTE_BLADE_V0850","model":"ZTE BLADE V0850"},{"manufacturer":"ZTE","market_name":"ZTE BLADE V0900","codename":"P450F10","model":"ZTE BLADE V0900"},{"manufacturer":"ZTE","market_name":"ZTE BLADE V0900","codename":"P450F10","model":"ZTE BLADE V9"},{"manufacturer":"ZTE","market_name":"ZTE BLADE V7 PLUS","codename":"P653A11","model":"ZTE BLADE V7 PLUS"},{"manufacturer":"ZTE","market_name":"ZTE BLade Zmax","codename":"crocus","model":"Z982"},{"manufacturer":"ZTE","market_name":"ZTE BV0870","codename":"P840V71","model":"ZTE BV0870"},{"manufacturer":"ZTE","market_name":"ZTE Blade A522","codename":"P817E53","model":"ZTE Blade A522"},{"manufacturer":"ZTE","market_name":"ZTE Blade L110","codename":"ZTE_BLADE_L110","model":"ZTE Blade L110"},{"manufacturer":"ZTE","market_name":"ZTE Blade L5","codename":"P172A40","model":"ZTE Blade L5"},{"manufacturer":"ZTE","market_name":"ZTE Blade V770","codename":"P852F52","model":"ZTE Blade V770"},{"manufacturer":"ZTE","market_name":"ZTE Blade V8 Arc","codename":"P840V80","model":"ZTE Blade V8 Arc"},{"manufacturer":"ZTE","market_name":"ZTE C2017","codename":"alice","model":"ZTE C2017"},{"manufacturer":"ZTE","market_name":"ZTE Fanfare 3","codename":"kelly","model":"Z852"},{"manufacturer":"ZTE","market_name":"ZTE Overture 3","codename":"jeff","model":"Z851"},{"manufacturer":"ZTE","market_name":"ZTE Tempo X","codename":"grayjoylite","model":"N9137"},{"manufacturer":"ZTE","market_name":"ZTE V0840","codename":"P817S01","model":"ZTE V0840"},{"manufacturer":"ZTE","market_name":"ZTE ZFive C LTE","codename":"msm8909","model":"Z558VL"},{"manufacturer":"ZTE","market_name":"ZTU31","codename":"P852F52","model":"ZTU31"},{"manufacturer":"ZTE","market_name":"ZXY-ZTE_N8010","codename":"N8010_YM","model":"ZXY-ZTE_N8010"},{"manufacturer":"ZTE","market_name":"ZXY-ZTE_V6700","codename":"V6700","model":"ZTE V6700"},{"manufacturer":"ZTE","market_name":"ZXY-ZTE_V6700","codename":"V6700","model":"ZXY-ZTE_V6700"},{"manufacturer":"ZTE","market_name":"Zmax 3","codename":"dandelion","model":"Z978"},{"manufacturer":"ZTE","market_name":"Zmax One","codename":"msm8909","model":"Z719DL"},{"manufacturer":"ZTE","market_name":"Zmax Pro","codename":"urd","model":"Z981"},{"manufacturer":"ZTE","market_name":"blade S","codename":"blade2","model":"Blade S"},{"manufacturer":"ZTE","market_name":"dtac phone M1","codename":"P635A50","model":"dtac phone M1"},{"manufacturer":"ZTE","market_name":"myPad P5","codename":"K78","model":"Amazing_P5"},{"manufacturer":"ZTE","market_name":"myPad P5","codename":"K78","model":"myPad P5"},{"manufacturer":"ZTE","market_name":"nubia Z5","codename":"NX501","model":"nubia Z5"},{"manufacturer":"ZTE","market_name":"sapphire lte","codename":"sapphire4g","model":"Z3001S"},{"manufacturer":"ZTE","market_name":"tmn smart a15","codename":"atlas40","model":"tmn smart a15"},{"manufacturer":"ZTE","market_name":"tmn smart a60","codename":"kiska","model":"tmn smart a60"},{"manufacturer":"ZTE","market_name":"tmn smart a7","codename":"sailboat","model":"tmn smart a7"},{"manufacturer":"Zebex","market_name":"Z-2252","codename":"Z-2252","model":"Z-2252"},{"manufacturer":"Zebra","market_name":"CC5000","codename":"concierge","model":"CCHUB1"},{"manufacturer":"Zebra","market_name":"ET5X","codename":"ET50E","model":"ET5X"},{"manufacturer":"Zebra","market_name":"ET5X","codename":"ET50T","model":"ET5X"},{"manufacturer":"Zebra","market_name":"ET5X","codename":"ET55E","model":"ET5X"},{"manufacturer":"Zebra","market_name":"ET5X","codename":"ET55T","model":"ET5X"},{"manufacturer":"Zebra","market_name":"MC18","codename":"MC18","model":"MC18N0"},{"manufacturer":"Zebra","market_name":"MC330K","codename":"MC33","model":"MC33"},{"manufacturer":"Zebra","market_name":"MC330K","codename":"MC33C","model":"MC33"},{"manufacturer":"Zebra","market_name":"MC36","codename":"cardhu","model":"MC36"},{"manufacturer":"Zebra","market_name":"MC40","codename":"MC40","model":"MC40N0"},{"manufacturer":"Zebra","market_name":"Pollux","codename":"TC70","model":"TC700H"},{"manufacturer":"Zebra","market_name":"Pollux","codename":"TC75","model":"TC75"},{"manufacturer":"Zebra","market_name":"TC20","codename":"TC20RD","model":"TC20"},{"manufacturer":"Zebra","market_name":"TC20","codename":"TC20RT","model":"TC20"},{"manufacturer":"Zebra","market_name":"TC20KB","codename":"TC20KB","model":"TC20"},{"manufacturer":"Zebra","market_name":"TC25","codename":"TC25FM","model":"TC25"},{"manufacturer":"Zebra","market_name":"TC51","codename":"TC51","model":"TC51"},{"manufacturer":"Zebra","market_name":"TC51","codename":"TC51HC","model":"TC51"},{"manufacturer":"Zebra","market_name":"TC55","codename":"TC55","model":"TC55"},{"manufacturer":"Zebra","market_name":"TC56","codename":"TC56","model":"TC56"},{"manufacturer":"Zebra","market_name":"TC70x","codename":"TC70x","model":"TC70x"},{"manufacturer":"Zebra","market_name":"TC75x","codename":"TC75x","model":"TC75x"},{"manufacturer":"Zebra","market_name":"TC75xDF","codename":"TC75xDF","model":"TC75x"},{"manufacturer":"Zebra","market_name":"TC8000","codename":"TC8000","model":"TC8000"},{"manufacturer":"Zebra","market_name":"VC80x","codename":"VC80x","model":"VC80x"},{"manufacturer":"Zebra","market_name":"WT6000","codename":"WT6000","model":"WT6000"},{"manufacturer":"Zeki","market_name":"TBDG1073","codename":"TBDG1073","model":"TBDG1073"},{"manufacturer":"Zeki","market_name":"TBDG734","codename":"TBDG734","model":"TBDG734"},{"manufacturer":"Zeki","market_name":"TBDG874 Tablet","codename":"TBDG874B","model":"TBDG874"},{"manufacturer":"Zeki","market_name":"TBDV986","codename":"TBDV986","model":"TBDV986"},{"manufacturer":"Zeki","market_name":"TBQC1063B","codename":"TBQC1063B","model":"TBQC1063"},{"manufacturer":"Zeki","market_name":"TBQG1084","codename":"TBQG1084","model":"TBQG1084"},{"manufacturer":"Zeki","market_name":"TBQG774","codename":"TBQG774","model":"TBQG774"},{"manufacturer":"Zeki","market_name":"TBQG855","codename":"TBQG855","model":"TBQG855"},{"manufacturer":"Zeki","market_name":"Zeki TBQG884","codename":"TBQG884","model":"TBQG884"},{"manufacturer":"Zen","market_name":"ADMIRE CURVE NEO","codename":"ZEN_ADMIRE_CURVE_NEO","model":"ADMIRE_CURVE_NEO"},{"manufacturer":"Zen","market_name":"ADMIRE SHINE","codename":"ADMIRE_SHINE","model":"ADMIRE SHINE"},{"manufacturer":"Zen","market_name":"ZEN ADMIRE NEO PLUS","codename":"ZEN_ADMIRE_NEO_PLUS","model":"ADMIRE NEO+"},{"manufacturer":"Zen","market_name":"ZEN ADMIRE UNITY","codename":"ZEN_ADMIRE_UNITY","model":"ADMIRE_UNITY"},{"manufacturer":"Zen","market_name":"ZEN_ADMIRE_INFINITY","codename":"ZEN_ADMIRE_INFINITY","model":"ADMIRE_INFINITY"},{"manufacturer":"Zen","market_name":"ZEN_CINEMAX_INFINITY","codename":"ZEN_CINEMAX_INFINITY","model":"CINEMAX_INFINITY"},{"manufacturer":"Zen","market_name":"Zen Admire Curve +","codename":"ZEN_ADMIRE_CURVE_PLUS","model":"ADMIRE_CURVE+"},{"manufacturer":"Zen","market_name":"Zen Admire Duo","codename":"ZEN_ADMIRE_DUO","model":"ADMIRE_DUO"},{"manufacturer":"Zen","market_name":"Zen Admire Glory+","codename":"ADMIRE_GLORY_PLUS","model":"ADMIRE GLORY+"},{"manufacturer":"Zen","market_name":"Zen Admire Sense+","codename":"ZEN_ADMIRE_SENSE_PLUS","model":"ADMIRE_SENSE+"},{"manufacturer":"Zen","market_name":"Zen Admire Strong","codename":"ZEN_ADMIRE_STRONG","model":"ADMIRE STRONG"},{"manufacturer":"Zen","market_name":"Zen Admire Swadesh+","codename":"ADMIRE_SWADESH_PLUS","model":"ADMIRE SWADESH+"},{"manufacturer":"Zen","market_name":"Zen Cinemax Prime","codename":"ZEN_CINEMAX_PRIME","model":"CINEMAX_PRIME"},{"manufacturer":"Zen","market_name":"Zen M72 Smart","codename":"M72_Smart","model":"M72 Smart"},{"manufacturer":"Zettaly","market_name":"ZA-407","codename":"ZA-407","model":"Zettaly Avy ZA-407"},{"manufacturer":"Zilo","market_name":"Zilo","codename":"Zilo","model":"Zilo"},{"manufacturer":"Ziox","market_name":"Astra Blaze","codename":"Astra_Blaze","model":"Astra Blaze"},{"manufacturer":"Ziox","market_name":"Astra Curve 4G","codename":"Astra_Curve_4G","model":"Astra Curve 4G"},{"manufacturer":"Ziox","market_name":"Astra Curve Pro","codename":"Astra_Curve_Pro","model":"Astra Curve Pro"},{"manufacturer":"Ziox","market_name":"Astra NXT Pro","codename":"Astra_NXT_Pro","model":"Astra NXT Pro"},{"manufacturer":"Ziox","market_name":"Astra Star","codename":"Astra_Star","model":"Astra Star"},{"manufacturer":"Ziox","market_name":"Astra Titan 4G","codename":"Astra_Titan_4G","model":"Astra Titan 4G"},{"manufacturer":"Ziox","market_name":"Astra Young Pro","codename":"Astra_Young_Pro","model":"Astra Young Pro"},{"manufacturer":"Ziox","market_name":"Duopix F1","codename":"Duopix_F1","model":"Duopix F1"},{"manufacturer":"Ziox","market_name":"Duopix F10","codename":"Duopix_F10","model":"Duopix F10"},{"manufacturer":"Ziox","market_name":"Duopix F9","codename":"Duopix_F9","model":"Duopix F9"},{"manufacturer":"Ziox","market_name":"Duopix F9 Pro","codename":"Duopix_F9_Pro","model":"Duopix F9 Pro"},{"manufacturer":"Ziox","market_name":"Duopix R1","codename":"Duopix_R1","model":"Duopix R1"},{"manufacturer":"Zopo","market_name":"L63","codename":"INHOh_L63","model":"L63"},{"manufacturer":"Zopo","market_name":"P5000","codename":"P5000","model":"P5000"},{"manufacturer":"Zopo","market_name":"PRO1","codename":"Benten_PRO1","model":"PRO1"},{"manufacturer":"Zopo","market_name":"Z5000","codename":"Z5000","model":"Z5000"},{"manufacturer":"Zpad","market_name":"ZpadX7","codename":"ZpadX7","model":"ZpadX7"},{"manufacturer":"Zpad","market_name":"Zpad_X7","codename":"Zpad_X7","model":"Zpad X7"},{"manufacturer":"Zuk","market_name":"Lenovo Z2 Plus","codename":"z2_plus_hw","model":"ZUK Z2132"},{"manufacturer":"Zuk","market_name":"Z1","codename":"Z1","model":"Z1"},{"manufacturer":"Zuk","market_name":"Z1","codename":"Z1","model":"ZUK Z1"},{"manufacturer":"Zuk","market_name":"Z1","codename":"k9","model":"ZUK Z1"},{"manufacturer":"Zuk","market_name":"Z2","codename":"z2_plus","model":"ZUK Z2131"},{"manufacturer":"Zuk","market_name":"Z2 Pro","codename":"z2_row","model":"ZUK Z2121"},{"manufacturer":"Zuk","market_name":"ZTE B2015","codename":"msm8916_64","model":"ZTE B2015"},{"manufacturer":"Zuk","market_name":"ZTE BLADE A5 PRO","codename":"P731A20","model":"ZTE BLADE A5 PRO"},{"manufacturer":"Zuum","market_name":"COVET","codename":"COVET","model":"COVET"},{"manufacturer":"Zuum","market_name":"GRANT","codename":"GRANT","model":"GRANT"},{"manufacturer":"Zuum","market_name":"Gravity","codename":"Gravity","model":"Gravity"},{"manufacturer":"Zuum","market_name":"LIMIT","codename":"LIMIT","model":"LIMIT"},{"manufacturer":"Zuum","market_name":"MAGNO","codename":"ZUUM_MAGNO","model":"MAGNO"},{"manufacturer":"Zuum","market_name":"MAGNO","codename":"ZUUM_MAGNO-S","model":"MAGNO-S"},{"manufacturer":"Zuum","market_name":"ONIX","codename":"ONIX","model":"ONIX"},{"manufacturer":"Zuum","market_name":"ULTRA Z","codename":"Ultra_Z","model":"ULTRA Z"},{"manufacturer":"Zuum","market_name":"ZUUM AKUS","codename":"AKUS","model":"AKUS"},{"manufacturer":"Zuum","market_name":"ZUUM MAGNO PLUS","codename":"MAGNO_PLUS","model":"MAGNO PLUS"},{"manufacturer":"alter","market_name":"MIG","codename":"MIG","model":"MIG"},{"manufacturer":"aoson","market_name":"M753","codename":"M753","model":"M753"},{"manufacturer":"aoson","market_name":"R103","codename":"R103","model":"R103"},{"manufacturer":"bq","market_name":"Aquaris A4.5","codename":"Aquaris_A45_sprout","model":"Aquaris A4.5"},{"manufacturer":"bq","market_name":"Aquaris A4.5","codename":"Aquaris_A45_sprout","model":"Aquaris_A4.5"},{"manufacturer":"bq","market_name":"Aquaris E10","codename":"Aquaris_E10","model":"Aquaris E10"},{"manufacturer":"bq","market_name":"Aquaris E10 3G","codename":"Aquaris_E10_3G","model":"Aquaris E10 3G"},{"manufacturer":"bq","market_name":"Aquaris E4","codename":"Aquaris_E4","model":"Aquaris E4"},{"manufacturer":"bq","market_name":"Aquaris E4.5","codename":"Aquaris_E45","model":"Aquaris E4.5"},{"manufacturer":"bq","market_name":"Aquaris E5","codename":"Aquaris_E5","model":"Aquaris E5"},{"manufacturer":"bq","market_name":"Aquaris E5 FHD","codename":"Aquaris_E5_FHD","model":"Aquaris E5 FHD"},{"manufacturer":"bq","market_name":"Aquaris E5 HD","codename":"Aquaris_E5_HD","model":"Aquaris E5 HD"},{"manufacturer":"bq","market_name":"Aquaris E6","codename":"Aquaris_E6","model":"Aquaris E6"},{"manufacturer":"bq","market_name":"Aquaris M","codename":"Aquaris_M55","model":"Aquaris M"},{"manufacturer":"bq","market_name":"Aquaris M10","codename":"Aquaris_M10","model":"Aquaris M10"},{"manufacturer":"bq","market_name":"Aquaris M10 4G","codename":"FREEZERLTE","model":"Aquaris M10 4G"},{"manufacturer":"bq","market_name":"Aquaris M10 FHD","codename":"Aquaris_M10_FHD","model":"Aquaris M10 FHD"},{"manufacturer":"bq","market_name":"Aquaris M4.5","codename":"Aquaris_M45","model":"Aquaris M4.5"},{"manufacturer":"bq","market_name":"Aquaris M4.5","codename":"Aquaris_M45","model":"Aquaris_M4.5"},{"manufacturer":"bq","market_name":"Aquaris M5","codename":"Aquaris_M5","model":"Aquaris M5"},{"manufacturer":"bq","market_name":"Aquaris M5.5","codename":"Aquaris_M55","model":"Aquaris M"},{"manufacturer":"bq","market_name":"Aquaris M5.5","codename":"Aquaris_M55","model":"Aquaris M5.5"},{"manufacturer":"bq","market_name":"Aquaris U","codename":"chaozu","model":"Aquaris U"},{"manufacturer":"bq","market_name":"Aquaris U Plus","codename":"tenshi","model":"Aquaris U Plus"},{"manufacturer":"bq","market_name":"Aquaris U lite","codename":"chaozulite","model":"Aquaris U Lite"},{"manufacturer":"bq","market_name":"Aquaris U2","codename":"yamcha","model":"Aquaris U2"},{"manufacturer":"bq","market_name":"Aquaris U2 Lite","codename":"yamchalite","model":"Aquaris U2 Lite"},{"manufacturer":"bq","market_name":"Aquaris V","codename":"nappa","model":"Aquaris V"},{"manufacturer":"bq","market_name":"Aquaris V Plus","codename":"raditz","model":"Aquaris V Plus"},{"manufacturer":"bq","market_name":"Aquaris Vs","codename":"nappa_s","model":"Aquaris VS"},{"manufacturer":"bq","market_name":"Aquaris Vs Plus","codename":"raditz_s","model":"Aquaris VS Plus"},{"manufacturer":"bq","market_name":"Aquaris X","codename":"bardock","model":"Aquaris X"},{"manufacturer":"bq","market_name":"Aquaris X Pro","codename":"bardock-pro","model":"Aquaris X Pro"},{"manufacturer":"bq","market_name":"Aquaris X2","codename":"zangya_sprout","model":"Aquaris X2"},{"manufacturer":"bq","market_name":"Aquaris X5","codename":"Aquaris_X5","model":"Aquaris X5"},{"manufacturer":"bq","market_name":"Aquaris X5 Plus","codename":"Aquaris_X5_Plus","model":"Aquaris X5 Plus"},{"manufacturer":"bq","market_name":"BQ-5515L","codename":"BQru-5515L","model":"BQ-5515L"},{"manufacturer":"bq","market_name":"Edison 3","codename":"Edison_3","model":"Edison 3"},{"manufacturer":"bq","market_name":"Edison 3 3G","codename":"Edison_3_3G","model":"Edison 3 3G"},{"manufacturer":"bq","market_name":"Edison_3_mini","codename":"Edison_3_mini","model":"Edison 3 mini"},{"manufacturer":"bq","market_name":"M8","codename":"Aquaris_M8","model":"Aquaris M8"},{"manufacturer":"duraMOBI","market_name":"DK66","codename":"DK66","model":"DK66"},{"manufacturer":"i-Buddie","market_name":"TA10CA1","codename":"TA10CA1","model":"TA10CA1"},{"manufacturer":"i-Buddie","market_name":"TA10CA2","codename":"TA10CA2","model":"TA10CA2"},{"manufacturer":"i-Buddie","market_name":"TA10CA3","codename":"TA10CA3","model":"TA10CA3"},{"manufacturer":"i-Buddie","market_name":"TA10CA4","codename":"TA10CA4","model":"TA10CA4"},{"manufacturer":"i-Buddie","market_name":"TA71CA1","codename":"TA71CA1","model":"TA71CA1"},{"manufacturer":"i-Buddie","market_name":"TA71CA5","codename":"TA71CA5","model":"TA71CA5"},{"manufacturer":"i-Buddie","market_name":"TA80CA1","codename":"TA80CA1","model":"TA80CA1"},{"manufacturer":"i-Buddie","market_name":"TM75A-V2","codename":"TM75A-V2","model":"TM75A-V2"},{"manufacturer":"i-Buddie","market_name":"TR10CD1","codename":"TR10CD1_2","model":"TR10CD1"},{"manufacturer":"i-Buddie","market_name":"TR10CD1","codename":"TR10CD1_4","model":"TR10CD1"},{"manufacturer":"i-Buddie","market_name":"TR10CD1_P","codename":"TR10CD1","model":"TR10CD1"},{"manufacturer":"i-Buddie","market_name":"TR10CS1","codename":"TR10CS1_12","model":"TR10CS1"},{"manufacturer":"i-Buddie","market_name":"TR10CS1","codename":"TR10CS1_2","model":"TR10CS1"},{"manufacturer":"i-Buddie","market_name":"TR10CS1_P","codename":"TR10CS1","model":"TR10CS1"},{"manufacturer":"i-Mobile","market_name":"A956","codename":"A956","model":"A956"},{"manufacturer":"i-Mobile","market_name":"IQ II","codename":"imobileiq2_sprout","model":"i-mobile IQ II"},{"manufacturer":"i-Mobile","market_name":"IQX KEN","codename":"IQX_KEN","model":"IQX KEN"},{"manufacturer":"i-Mobile","market_name":"Y1","codename":"Y1","model":"i-mobile Y1"},{"manufacturer":"i-Mobile","market_name":"i-STYLE 713","codename":"i-STYLE_713","model":"i-STYLE 713"},{"manufacturer":"i-Mobile","market_name":"i-STYLE 812 4G","codename":"i_style_812_4G","model":"i-mobile i-STYLE 812 4G"},{"manufacturer":"i-Mobile","market_name":"i-note WiFi 1.1","codename":"M1703","model":"i-mobile M1703"},{"manufacturer":"iBRIT","market_name":"Alpha","codename":"AF51","model":"AF51"},{"manufacturer":"iBRIT","market_name":"IBRIT_I5","codename":"i5","model":"IBRIT_I5"},{"manufacturer":"iBRIT","market_name":"IBRIT_I7","codename":"i7","model":"IBRIT_I7"},{"manufacturer":"iBRIT","market_name":"Speed_Pro_Plus","codename":"SF56","model":"SF56"},{"manufacturer":"iBRIT","market_name":"iBRIT SpeedX","codename":"SpeedX","model":"SpeedX"},{"manufacturer":"iBall","market_name":"iBall","codename":"iBall_Slide_Brace_XJ","model":"iBall Slide Brace XJ"},{"manufacturer":"iBall","market_name":"iBall","codename":"iBall_Slide_Dazzle_i7","model":"iBall Slide Dazzle i7"},{"manufacturer":"iBall","market_name":"iBall Slide Imprint 4G","codename":"Imprint_4G","model":"iBall_Slide_Imprint_4G"},{"manufacturer":"iBall","market_name":"iBall Slide Nimble 4GF","codename":"Slide_Nimble_4GF","model":"iBall_Slide_Nimble_4GF"},{"manufacturer":"iBall","market_name":"iBall Slide Snap 4G2","codename":"Snap_4G2","model":"Snap_4G2"},{"manufacturer":"iBall","market_name":"iBall Slide Twinkle i5","codename":"Twinkle_i5","model":"Twinkle_i5"},{"manufacturer":"iBall","market_name":"iBall Slide Wings 4GP","codename":"Slide_Wings_4GP","model":"iBall_Slide_Wings_4GP"},{"manufacturer":"iBall","market_name":"iBallSlide_Wings","codename":"iBallSlide_Wings","model":"Wings"},{"manufacturer":"iCraig","market_name":"CLP288","codename":"ICRAIG_CLP288","model":"ICRAIG_CLP288"},{"manufacturer":"iCraig","market_name":"CLP293","codename":"CLP293","model":"CLP293"},{"manufacturer":"iCraig","market_name":"CLP_291","codename":"ICRAIG_CLP_291","model":"ICRAIG_CLP291"},{"manufacturer":"iCraig","market_name":"CMP 756","codename":"Omega9","model":"CMP 756"},{"manufacturer":"iCraig","market_name":"CMP 759","codename":"Omega7","model":"CMP 759"},{"manufacturer":"iCraig","market_name":"CMP770","codename":"ICRAIG_CMP770","model":"ICRAIG_CMP770"},{"manufacturer":"iCraig","market_name":"CMP791","codename":"CMP791","model":"CMP791"},{"manufacturer":"iCraig","market_name":"CMP793","codename":"CMP793","model":"CMP793"},{"manufacturer":"iCraig","market_name":"CMP797","codename":"CMP797","model":"CMP797"},{"manufacturer":"iCraig","market_name":"CMP798","codename":"CMP798","model":"CMP798"},{"manufacturer":"iCraig","market_name":"CMP821","codename":"CMP821","model":"CMP821"},{"manufacturer":"iCraig","market_name":"CMP823","codename":"CMP823","model":"CMP823"},{"manufacturer":"iCraig","market_name":"CMP826","codename":"CMP826","model":"CMP826"},{"manufacturer":"iCraig","market_name":"CMP828","codename":"CMP828","model":"CMP828"},{"manufacturer":"iCraig","market_name":"CMP_771","codename":"ICRAIG_CMP_771","model":"ICRAIG_CMP771"},{"manufacturer":"iCraig","market_name":"CMP_773","codename":"ICRAIG_CMP_773","model":"ICRAIG_CMP773"},{"manufacturer":"iDea USA","market_name":"CT8","codename":"CT8","model":"CT8"},{"manufacturer":"iDeaUSA","market_name":"CT10","codename":"CT10","model":"CT10"},{"manufacturer":"iDeaUSA","market_name":"CT7","codename":"CT7","model":"CT7"},{"manufacturer":"iFit","market_name":"IFT1018","codename":"IFT1018","model":"IFT1018"},{"manufacturer":"iGet","market_name":"S100","codename":"iGET_S100","model":"S100"},{"manufacturer":"iGet","market_name":"SMART","codename":"iGET_SMART","model":"SMART"},{"manufacturer":"iGet","market_name":"SMART_G101","codename":"iGET_SMART_G101","model":"SMART_G101"},{"manufacturer":"iGet","market_name":"SMART_G102","codename":"iGET_SMART_G102","model":"SMART_G102"},{"manufacturer":"iGet","market_name":"SMART_G71","codename":"iGET_SMART_G71","model":"SMART_G71"},{"manufacturer":"iGet","market_name":"SMART_G81","codename":"SMART_G81","model":"SMART_G81"},{"manufacturer":"iGet","market_name":"SMART_G81H","codename":"SMART_G81H","model":"SMART_G81H"},{"manufacturer":"iGet","market_name":"SMART_L102","codename":"iGET_SMART_L102","model":"SMART_L102"},{"manufacturer":"iLa Mobile","market_name":"D1","codename":"D1","model":"D1"},{"manufacturer":"iLa Mobile","market_name":"S1","codename":"S1","model":"S1"},{"manufacturer":"iLa Mobile","market_name":"iLA Silk","codename":"iLA_Silk","model":"iLA_Silk"},{"manufacturer":"iLa Mobile","market_name":"iLA-X","codename":"iLA-X","model":"iLA-X"},{"manufacturer":"iNO Mobile","market_name":"S9","codename":"iNO_S9","model":"iNO S9"},{"manufacturer":"iNanny","market_name":"NC1000","codename":"NC1000","model":"NC1000"},{"manufacturer":"iReplace","market_name":"Frog One","codename":"FrogOne","model":"FrogOne"},{"manufacturer":"iRiver","market_name":"","codename":"smdkc110","model":"ILT-MX100"},{"manufacturer":"iRiver","market_name":"DMT580D","codename":"m805_892x","model":"DDA800R"},{"manufacturer":"iRiver","market_name":"DMT580D","codename":"m805_892x","model":"DMT580D"},{"manufacturer":"iRiver","market_name":"DMT580D","codename":"m805_892x","model":"MIT700"},{"manufacturer":"iRiver","market_name":"MM3202","codename":"mm3201","model":"MM-3201"},{"manufacturer":"iRiver","market_name":"MM3202","codename":"mm3201","model":"MM-3202"},{"manufacturer":"iRiver","market_name":"ULALA","codename":"msm7627a_sku3","model":"I-K1"},{"manufacturer":"iRiver","market_name":"WOW Tab+(ITQ1000)","codename":"itq1000","model":"ITQ1000"},{"manufacturer":"iRiver","market_name":"WPT005","codename":"wikipad","model":"WPT005"},{"manufacturer":"iRiver","market_name":"Wow TAB +","codename":"itq701","model":"ITQ701"},{"manufacturer":"iRiver","market_name":"Wow(Window of the world)","codename":"itq700","model":"ITQ700"},{"manufacturer":"iRiver","market_name":"Wow(Window of the world)","codename":"itq700","model":"YBMK01"},{"manufacturer":"iRulu","market_name":"Irulu","codename":"octopus-masu","model":"X10"},{"manufacturer":"iRulu","market_name":"L20","codename":"L20","model":"L20"},{"manufacturer":"iRulu","market_name":"L21","codename":"L21","model":"L21"},{"manufacturer":"iRulu","market_name":"X18","codename":"X18","model":"X18"},{"manufacturer":"iRulu","market_name":"X27","codename":"X27","model":"X27"},{"manufacturer":"iRulu","market_name":"X37","codename":"iRULU-X37","model":"X37"},{"manufacturer":"iRulu","market_name":"X4","codename":"iRULU_X4","model":"X4"},{"manufacturer":"iRulu","market_name":"X40","codename":"iRULU-X40","model":"X40"},{"manufacturer":"iRulu","market_name":"X47","codename":"X47","model":"X47"},{"manufacturer":"iRulu","market_name":"X57","codename":"iRULU_X57","model":"X57"},{"manufacturer":"iRulu","market_name":"X58","codename":"iRULU-X58","model":"X58"},{"manufacturer":"iRulu","market_name":"X67","codename":"iRULU_X67","model":"X67"},{"manufacturer":"iRulu","market_name":"Y57","codename":"iRULU_Y57","model":"Y57"},{"manufacturer":"iRulu","market_name":"iRULU_G36","codename":"iRULU_G36","model":"G36"},{"manufacturer":"iVOOMi","market_name":"Me 1","codename":"Me_1","model":"iV 505"},{"manufacturer":"iVOOMi","market_name":"Me 1+","codename":"Me_1_plus","model":"Me 1+"},{"manufacturer":"iVOOMi","market_name":"Me 2","codename":"Me_2","model":"Me 2"},{"manufacturer":"iVOOMi","market_name":"Me 3","codename":"Me_3","model":"Me 3"},{"manufacturer":"iVOOMi","market_name":"Me 3S","codename":"Me_3S","model":"Me 3S"},{"manufacturer":"iVOOMi","market_name":"Me 4","codename":"Me_4","model":"Me 4"},{"manufacturer":"iVOOMi","market_name":"Me 5","codename":"Me_5","model":"Me 5"},{"manufacturer":"iVOOMi","market_name":"V5","codename":"V5","model":"V5"},{"manufacturer":"iVOOMi","market_name":"i1","codename":"i1","model":"i1"},{"manufacturer":"iVOOMi","market_name":"i1s","codename":"i1s","model":"i1s"},{"manufacturer":"iVOOMi","market_name":"i2","codename":"i2","model":"i2"},{"manufacturer":"iVOOMi","market_name":"i2 Lite","codename":"i2_Lite","model":"i2_Lite"},{"manufacturer":"intelkom","market_name":"meanIT_C1","codename":"meanIT_C1","model":"meanIT_C1"},{"manufacturer":"intelkom","market_name":"meanIT_C2","codename":"meanIT_C2","model":"meanIT_C2"},{"manufacturer":"mytel","market_name":"M9501","codename":"M9501","model":"M9501"},{"manufacturer":"mytel","market_name":"M9502","codename":"M9502","model":"M9502"},{"manufacturer":"mytel","market_name":"M9503","codename":"M9503","model":"M9503"},{"manufacturer":"mytel","market_name":"M9602","codename":"M9602","model":"M9602"},{"manufacturer":"mytel","market_name":"Msuper","codename":"Msuper","model":"Msuper"},{"manufacturer":"mytel","market_name":"Mytel M9601","codename":"Mytel_M9601","model":"M9601"},{"manufacturer":"neutab","market_name":"K1S","codename":"K1S","model":"K1S"},{"manufacturer":"neutab","market_name":"i7","codename":"i7","model":"i7"},{"manufacturer":"novo","market_name":"Bonvi Prime","codename":"t596_novo_37m35","model":"Bonvi Prime"},{"manufacturer":"novo","market_name":"Bonvi Pro","codename":"t596_dp_n_37m35","model":"Bonvi Pro"},{"manufacturer":"pendo","market_name":"PNDPP44QC10","codename":"PNDPP44QC10","model":"PNDPP44QC10"},{"manufacturer":"pendo","market_name":"PNDPP44QC7","codename":"PNDPP44QC7","model":"PNDPP44QC7"},{"manufacturer":"sencor","market_name":"7Q105","codename":"SENCOR_7Q105","model":"SENCOR_7Q105"},{"manufacturer":"sencor","market_name":"P5504","codename":"P5504","model":"P5504"},{"manufacturer":"sencor","market_name":"SENCOR_10_1Q102","codename":"SENCOR_10_1Q102","model":"SENCOR_10_1Q102"},{"manufacturer":"sugar_aums","market_name":"QPOINT","codename":"QPI-1","model":"QPI-1"},{"manufacturer":"teXet","market_name":"TM-4510","codename":"TM-4510","model":"TM-4510"},{"manufacturer":"teXet","market_name":"TM-5071","codename":"TM_5071","model":"TM-5071"},{"manufacturer":"teXet","market_name":"TM-5073","codename":"TM-5073","model":"TM-5073"},{"manufacturer":"teXet","market_name":"TM-5201","codename":"TM-5201","model":"TM-5201"},{"manufacturer":"teXet","market_name":"Texet TM-5571","codename":"tm5571","model":"TM-5571"},{"manufacturer":"teXet","market_name":"Texet TM-5581","codename":"tm5581","model":"TM-5581"},{"manufacturer":"tecmobile","market_name":"OmnisOne","codename":"OmnisOne","model":"Omnis One"},{"manufacturer":"ucall","market_name":"EASY1","codename":"EASY1","model":"EASY1"},{"manufacturer":"videocon","market_name":"Delite 11","codename":"V503630","model":"V503630"},{"manufacturer":"videocon","market_name":"Krypton 22+","codename":"V505024","model":"V505024"},{"manufacturer":"videocon","market_name":"Metal Pro 1","codename":"V505820","model":"V505820"},{"manufacturer":"videocon","market_name":"Metal Pro 2","codename":"V505920","model":"V505920"},{"manufacturer":"videocon","market_name":"Starr 100","codename":"V406018","model":"V406018"},{"manufacturer":"xTouch","market_name":"A4","codename":"XTOUCH_A4","model":"A4"},{"manufacturer":"xTouch","market_name":"E4","codename":"E4","model":"E4"},{"manufacturer":"xTouch","market_name":"X10","codename":"X10","model":"X10"},{"manufacturer":"xTouch","market_name":"XTOUCH X","codename":"XTouch_X","model":"XTouch X"},{"manufacturer":"xTouch","market_name":"XTOUCH X10","codename":"XTOUCH_X10","model":"XTOUCH X10"}]

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports = [{"market_name":"iPhone 4","model":"iPhone3-1"},{"market_name":"iPhone 4","model":"iPhone3-2"},{"market_name":"iPhone 4","model":"iPhone3-3"},{"market_name":"iPhone 4S","model":"iPhone4-1"},{"market_name":"iPhone 4S","model":"iPhone4-2"},{"market_name":"iPhone 4S","model":"iPhone4-3"},{"market_name":"iPhone 5","model":"iPhone5-1"},{"market_name":"iPhone 5","model":"iPhone5-2"},{"market_name":"iPhone 5C","model":"iPhone5-3"},{"market_name":"iPhone 5C","model":"iPhone5-4"},{"market_name":"iPhone 5S","model":"iPhone6-1"},{"market_name":"iPhone 5S","model":"iPhone6-2"},{"market_name":"iPhone 6","model":"iPhone7-2"},{"market_name":"iPhone 6 Plus","model":"iPhone7-1"},{"market_name":"iPhone 6S","model":"iPhone8-1"},{"market_name":"iPhone 6S Plus","model":"iPhone8-2"},{"market_name":"iPhone SE","model":"iPhone8-4"},{"market_name":"iPhone 7","model":"iPhone9-1"},{"market_name":"iPhone 7","model":"iPhone9-3"},{"market_name":"iPhone 7 Plus","model":"iPhone9-2"},{"market_name":"iPhone 7 Plus","model":"iPhone9-4"},{"market_name":"iPhone 8","model":"iPhone10-1"},{"market_name":"iPhone 8","model":"iPhone10-4"},{"market_name":"iPhone 8 Plus","model":"iPhone10-2"},{"market_name":"iPhone 8 Plus","model":"iPhone10-5"},{"market_name":"iPhoneX","model":"iPhone10-3"},{"market_name":"iPhoneX","model":"iPhone10-6"},{"market_name":"Simulator","model":"i386"},{"market_name":"Simulator","model":"x86_64"},{"market_name":"iPad 1","model":"iPad1-1"},{"market_name":"iPad 2","model":"iPad2-1"},{"market_name":"iPad 2","model":"iPad2-2"},{"market_name":"iPad 2","model":"iPad2-3"},{"market_name":"iPad 2","model":"iPad2-4"},{"market_name":"iPad Mini","model":"iPad2-5"},{"market_name":"iPad Mini","model":"iPad2-6"},{"market_name":"iPad Mini","model":"iPad2-7"},{"market_name":"iPad 3","model":"iPad3-1"},{"market_name":"iPad 3","model":"iPad3-2"},{"market_name":"iPad 3","model":"iPad3-3"},{"market_name":"iPad 4","model":"iPad3-4"},{"market_name":"iPad 4","model":"iPad3-5"},{"market_name":"iPad 4","model":"iPad3-6"},{"market_name":"iPad Air","model":"iPad4-1"},{"market_name":"iPad Air","model":"iPad4-2"},{"market_name":"iPad Air","model":"iPad4-3"},{"market_name":"iPad Mini 2","model":"iPad4-4"},{"market_name":"iPad Mini 2","model":"iPad4-5"},{"market_name":"iPad Mini 2","model":"iPad4-6"},{"market_name":"iPad Mini 3","model":"iPad4-7"},{"market_name":"iPad Mini 3","model":"iPad4-8"},{"market_name":"iPad Mini 3","model":"iPad4-9"},{"market_name":"iPad Mini 4","model":"iPad5-1"},{"market_name":"iPad Mini 4","model":"iPad5-2"},{"market_name":"iPad Air 2","model":"iPad5-3"},{"market_name":"iPad Air 2","model":"iPad5-4"},{"market_name":"iPad Pro 9.7 Inch","model":"iPad6-3"},{"market_name":"iPad Pro 9.7 Inch","model":"iPad6-4"},{"market_name":"iPad Pro 12.9 Inch","model":"iPad6-7"},{"market_name":"iPad Pro 12.9 Inch","model":"iPad6-8"},{"market_name":"iPad 5","model":"iPad6-11"},{"market_name":"iPad 5","model":"iPad6-12"},{"market_name":"iPad Pro 12.9 Inch 2 Gen","model":"iPad7-1"},{"market_name":"iPad Pro 12.9 Inch 2Gen","model":"iPad7-2"},{"market_name":"iPad Pro 10.5 Inch","model":"iPad7-3"},{"market_name":"iPad Pro 10.5 Inch","model":"iPad7-4"},{"market_name":"iPad 6 Gen","model":"iPad7-5"},{"market_name":"iPad 6 Gen","model":"iPad7-6"},{"market_name":"iPodTouch 1 Gen","model":"iPod1-1"},{"market_name":"iPodTouch 2 Gen","model":"iPod2-1"},{"market_name":"iPodTouch 3 Gen","model":"iPod3-1"},{"market_name":"iPodTouch 4 Gen","model":"iPod4-1"},{"market_name":"iPodTouch 5 Gen","model":"iPod5-1"},{"market_name":"iPodTouch 6 Gen","model":"iPod7-1"}]

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);










var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);
var _Icon=__webpack_require__(85);var _Icon2=_interopRequireDefault(_Icon);
var _SearchInput=__webpack_require__(142);var _SearchInput2=_interopRequireDefault(_SearchInput);
var _Empty=__webpack_require__(98);var _Empty2=_interopRequireDefault(_Empty);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var ITEM_HEIGHT=44;var

AgencyListScreen=(_temp=_class=function(_Component){_inherits(AgencyListScreen,_Component);


























function AgencyListScreen(props){var _this2=this;_classCallCheck(this,AgencyListScreen);var _this=_possibleConstructorReturn(this,(AgencyListScreen.__proto__||Object.getPrototypeOf(AgencyListScreen)).call(this,
props));_this.







































_updateQuery=function(query){
if(_this._query===query){
return;
}

_this._query=query;
_this.setState({
query:query});

if(_reactNative.Platform.OS!=='web'){
_this.props.navigation.setParams({
query:query});

}
};_this.

_search=function(){
_this._refreshData(false);
};_this.





















_loadData=function _callee(){var params,path,_ref,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(
_this._loading||_this._page<=0)){_context.next=2;break;}return _context.abrupt('return');case 2:



_this._loading=true;

params={
page:_this._page,
limit:_reactNative.Platform.OS==='web'?40:20};

if(!_lodash2.default.isEmpty(_this._query)){
params.query=_this._query;
}
path=_lodash2.default.isNil(_this._partnerId)?
'/agencies':'/agencies/'+
_this._partnerId;_context.next=8;return regeneratorRuntime.awrap(
_APIClient2.default.GET(path,params));case 8:_ref=_context.sent;response=_ref.response;error=_ref.error;
_this._handleNetworkResponse(response,error);case 12:case'end':return _context.stop();}}},null,_this2);};_this.














































_onRefresh=function(){return _this._refreshData(true);};_this.

_onEndReached=function(){
_this._loadData();
};_this.

_renderItem=function(_ref2){var item=_ref2.item,index=_ref2.index;
return(
_react2.default.createElement(AgencyItem,{
item:item,
onClick:_this._handleClickItem}));

};_this.

_handleClickItem=function(item){
if(!item){
return;
}

if(_reactNative.Platform.OS==='web'){
var path='/agency/'+item.id;
_this.props.history.push(path);
}else{
_this.props.navigation.navigate('Agency',{
id:item.id});

}
};if(_reactNative.Platform.OS==='web'){_this._partnerId=_this.props.match.params.id;}else{_this._partnerId=_this.props.navigation.state.params?_this.props.navigation.state.params.id:null;}console.log('partner id: ',_this._partnerId);var items=[];_this.state={refreshing:false,items:items,noitem:false};_this._page=-1;_this._loading=false;return _this;}_createClass(AgencyListScreen,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;if(_reactNative.Platform.OS==='web'){}else{var navigation=this.props.navigation;navigation.setParams({updateQuery:this._updateQuery,search:this._search});}_reactNative.InteractionManager.runAfterInteractions(function(){_this3._refreshData(true);});}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'_refreshData',value:function _refreshData(refreshing){if(this._loading){return;}this._resetData(refreshing);this._loadData();}},{key:'_resetData',value:function _resetData(refreshing){this._loading=false;this._page=1;var items=[];this.setState({refreshing:refreshing,items:items,noitem:false});}},{key:'_handleNetworkResponse',value:function _handleNetworkResponse(response,error){var _state=this.state,items=_state.items,noitem=_state.noitem;if(response&&response.response){var newItems=response.response;if(newItems.length>0){items=items.concat(newItems);this._page++;this.setState({items:items});}else{this._page=-1;}noitem=items.length===0;}else{if(items.length===0){var message=_Utils2.default.parseErrorMessage(response,error,'Có lỗi xảy ra, vui lòng thử lại sau');if(_reactNative.Platform.OS!=='web'){_reactNative.Alert.alert(global.__APP_NAME__,message);}else{alert(message);}noitem=true;}}this._loading=false;this.setState({refreshing:false,noitem:noitem});}},{key:'render',value:function render()

{var _this4=this;var _state2=
this.state,refreshing=_state2.refreshing,items=_state2.items,noitem=_state2.noitem;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
_reactNative.Platform.OS==='web'&&_react2.default.createElement(_SearchInput2.default,{
placeholder:'Emai / s\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u0111\u1EA1i l\xFD',
onUpdateQuery:this._updateQuery,
onSubmit:this._search}),

_react2.default.createElement(_reactNative.FlatList,{
refreshing:refreshing,
extraData:this.state,
data:items,
onRefresh:this._onRefresh,
onEndReached:this._onEndReached,
onEndReachedThreshold:0.5,
renderItem:this._renderItem,
style:styles.list}),

noitem&&_react2.default.createElement(_Empty2.default,{
text:'Kh\xF4ng t\xECm th\u1EA5y \u0111\u1EA1i l\xFD, b\u1EA5m \u0111\u1EC3 th\u1EED l\u1EA1i',
onClick:function onClick(){return _this4._refreshData(false);},
style:styles.empty})));


}}]);return AgencyListScreen;}(_react.Component),_class.navigationOptions=function(_ref3){var navigation=_ref3.navigation;var _navigation$state=navigation.state,routes=_navigation$state.routes,params=_navigation$state.params;var _ref4=params?params:{},updateQuery=_ref4.updateQuery,search=_ref4.search;return{tabBarIcon:function tabBarIcon(_ref5){var focused=_ref5.focused,tintColor=_ref5.tintColor;return _react2.default.createElement(_Icon2.default,{type:'FontAwesome',name:'users',size:24,color:tintColor});},tabBarVisible:!routes||routes.length<=1,headerBackTitle:null,headerTitle:_react2.default.createElement(_SearchInput2.default,{placeholder:'Emai / s\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u0111\u1EA1i l\xFD',onUpdateQuery:updateQuery,onSubmit:search})};},_temp);var


AgencyItem=function(_React$PureComponent){_inherits(AgencyItem,_React$PureComponent);function AgencyItem(){var _ref6;var _temp2,_this5,_ret;_classCallCheck(this,AgencyItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp2=(_this5=_possibleConstructorReturn(this,(_ref6=AgencyItem.__proto__||Object.getPrototypeOf(AgencyItem)).call.apply(_ref6,[this].concat(args))),_this5),_this5.

_handleClick=function(){var _this5$props=
_this5.props,item=_this5$props.item,onClick=_this5$props.onClick;
if(onClick){
onClick(item);
}
},_temp2),_possibleConstructorReturn(_this5,_ret);}_createClass(AgencyItem,[{key:'render',value:function render()

{var
item=this.props.item;var
name=item.name,email=item.email,phone=item.phone;
return(
_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
style:styles.item,
onPress:this._handleClick},
_react2.default.createElement(_reactNative.Text,{
style:styles.itemTitleText},
name),

_react2.default.createElement(_reactNative.Text,{
style:styles.itemBodyText},
email),

_react2.default.createElement(_reactNative.View,{
style:styles.itemDivider})));


}}]);return AgencyItem;}(_react2.default.PureComponent);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},


list:{
flex:1},

item:{
height:ITEM_HEIGHT,
paddingLeft:8,
paddingRight:8,
justifyContent:'center'},

itemTitleText:{
color:'#000000',
fontSize:16,
fontWeight:'bold',
backgroundColor:'transparent'},

itemBodyText:{
color:'#000000',
fontSize:14,
fontWeight:'100',
backgroundColor:'transparent'},

itemDivider:_extends({
position:'absolute',
left:0,bottom:0,right:0,
backgroundColor:'#6b7adc'},
_reactNative.Platform.select({
web:{
height:1},

ios:{
height:1/_reactNative.PixelRatio.get()},

android:{
height:1/_reactNative.PixelRatio.get()}})),




empty:_extends({},
_reactNative.Platform.select({
web:{
top:100},

ios:{
top:44},

android:{
top:44}}))});





var mapStateToProps=function mapStateToProps(state){
return{
credential:state.user.credential};

};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{};
};exports.default=

AgencyListScreen;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);













var _reactRedux=__webpack_require__(28);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);
var _LoadingIndicator=__webpack_require__(99);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);
var _UserUtils=__webpack_require__(66);var _UserUtils2=_interopRequireDefault(_UserUtils);
var _NavigationButtons=__webpack_require__(369);
var _Icon=__webpack_require__(85);var _Icon2=_interopRequireDefault(_Icon);
var _AlertUtils=__webpack_require__(62);var _AlertUtils2=_interopRequireDefault(_AlertUtils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var contentWidth=Math.min(_reactNative.Dimensions.get('window').width-40,300);var

AgencyScreen=(_temp=_class=function(_Component){_inherits(AgencyScreen,_Component);




















function AgencyScreen(props){var _this2=this;_classCallCheck(this,AgencyScreen);var _this=_possibleConstructorReturn(this,(AgencyScreen.__proto__||Object.getPrototypeOf(AgencyScreen)).call(this,
props));_this.
































_refreshData=function(refreshing){var
status=_this.state.status;
if(_this.state.refreshing||status==='loading'){
return;
}

_this.setState({
refreshing:refreshing,
status:refreshing?'none':'loading'});


_this._loadData();
_this._loadLogs();
};_this.

_onRefresh=function(){return _this._refreshData(true);};_this.

_loadData=function _callee(){var path,_ref,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:
path='/seller/'+_this._id;_context.next=3;return regeneratorRuntime.awrap(
_APIClient2.default.GET(path));case 3:_ref=_context.sent;response=_ref.response;error=_ref.error;
_this._handleNetworkResponse(response,error);case 7:case'end':return _context.stop();}}},null,_this2);};_this.























_updateData=function(data){var
id=data.id,name=data.name,email=data.email,phone=data.phone,address=data.address,promoCode=data.promoCode,saleOff=data.saleOff,orderCount=data.orderCount,revenue=data.revenue,commission=data.commission,active=data.active;
var items=[];
items.push({
title:'Thông tin',
section:true});

items.push({
title:'ID',
value:id});

items.push({
title:'Tên',
value:_lodash2.default.isEmpty(name)?'N/A':name});

items.push({
title:'Email',
value:_lodash2.default.isEmpty(email)?'N/A':email});

items.push({
title:'Số điện thoại',
value:_lodash2.default.isEmpty(phone)?'N/A':phone});

items.push({
title:'Địa chỉ',
value:_lodash2.default.isEmpty(address)?'N/A':address});

items.push({
title:'Mã giới thiệu',
value:promoCode});

items.push({
title:'Giảm giá',
value:saleOff+'%'});

items.push({
title:'Số đơn hàng (tháng này)',
value:orderCount});

items.push({
title:'Doanh thu (tháng này)',
value:_Utils2.default.priceToString(revenue)});

items.push({
title:'Hoa hồng (tháng này)',
value:commission+'%'});

items.push({
title:'Trạng thái hoạt động',
value:active?'Đang hoạt động':'Ngừng hoạt động'});var


user=_this.props.user;

var canEdit=_UserUtils2.default.isAdmin(user);

var editActions=_this._generateEditActions(data);

_this.setState({
refreshing:false,
status:'done',
data:data,
items:items,
canEdit:canEdit,
editActions:editActions});

};_this.

_loadLogs=function _callee2(){var user,isAdmin,path,_ref2,response,error,logs,_iterator,_isArray,_i,_ref3,data,items;return regeneratorRuntime.async(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:
user=_this.props.user;
isAdmin=_UserUtils2.default.isAdmin(user);if(
isAdmin){_context2.next=4;break;}return _context2.abrupt('return');case 4:if(!



_lodash2.default.isNil(_this._id)){_context2.next=6;break;}return _context2.abrupt('return');case 6:



_this.setState({
logs:[
{
title:'Nhật kí',
section:true}]});




path='/logs/user/'+_this._id;_context2.next=10;return regeneratorRuntime.awrap(
_APIClient2.default.GET(path));case 10:_ref2=_context2.sent;response=_ref2.response;error=_ref2.error;
if(response){
console.log('user logs response: ',response);
}
if(error){
console.warn('user logs error: ',error);
}if(!(
_lodash2.default.isNil(response)||_lodash2.default.isEmpty(response.response))){_context2.next=17;break;}return _context2.abrupt('return');case 17:



logs=_this.state.logs;_iterator=
response.response,_isArray=Array.isArray(_iterator),_i=0,_iterator=_isArray?_iterator:_iterator[typeof Symbol==='function'?typeof Symbol==='function'?typeof Symbol==='function'?Symbol.iterator:'@@iterator':'@@iterator':'@@iterator']();case 19:if(!_isArray){_context2.next=25;break;}if(!(_i>=_iterator.length)){_context2.next=22;break;}return _context2.abrupt('break',34);case 22:_ref3=_iterator[_i++];_context2.next=29;break;case 25:_i=_iterator.next();if(!_i.done){_context2.next=28;break;}return _context2.abrupt('break',34);case 28:_ref3=_i.value;case 29:data=_ref3;
items=_this._parseLog(data);
logs=logs.concat(items);case 32:_context2.next=19;break;case 34:

_this.setState({
logs:logs});case 35:case'end':return _context2.stop();}}},null,_this2);};_this.



_parseLog=function(data){
var items=[];var
username=data.username,content=data.content,updatedAt=data.updatedAt;
items.push({
title:'Người tạo',
value:username});

items.push({
title:'Nội dung',
value:content});

items.push({
title:'Thời gian',
value:_Utils2.default.dateToString(updatedAt)});

return items;
};_this.

_edit=function(){
if(_reactNative.Platform.OS==='web'){
return;
}var

user=_this.props.user;
if(!_UserUtils2.default.isAdmin(user)&&!_UserUtils2.default.isPartner(user)){
return;
}var

editing=_this.state.editing;
if(editing){
return;
}

var actions=_this._generateEditActions(_this.state.data);
actions.push({
text:'Bỏ qua',
style:'cancel'});


_reactNative.Alert.alert(
global.__APP_NAME__,
'Cập nhật',
actions);

};_this.

_generateEditActions=function(data){var
active=data.active;
var actions=[];

if(_reactNative.Platform.OS==='web'){
actions.push({
id:'order-list',
text:'Đơn hàng của đại lý',
onPress:_this._openOrderList});

}

actions.push({
id:'update',
text:'Cập nhật thông tin',
onPress:_this._updateSale});


actions.push({
id:'update-price',
text:'Cập nhật giá bán',
onPress:_this._updatePrice});


actions.push({
id:'activation',
text:active?'Huỷ đại lý':'Kích hoạt đại lý',
onPress:_this._toggleActivation});

return actions;
};_this.

_openOrderList=function(){var
data=_this.state.data;
if(_reactNative.Platform.OS==='web'){
var path='/orders/seller/'+data.id;
_this.props.history.push(path);
}else{
_this.props.navigation.push('SellerOrderList',{
id:data.id});

}
};_this.

_updateSale=function(){var
data=_this.state.data;
if(_reactNative.Platform.OS==='web'){
_this.props.history.push({
pathname:'/seller/'+data.id});

}else{
_this.props.navigation.navigate('Seller',{
id:data.id});

}
};_this.

_updatePrice=function(){var
data=_this.state.data;
if(_reactNative.Platform.OS==='web'){
_this.props.history.push({
pathname:'/seller/price/'+data.id});

}else{
_this.props.navigation.navigate('SellerPrice',{
id:data.id});

}
};_this.

_toggleActivation=function(){
var agency=_this.state.data;var
active=agency.active;
var data={
active:!active};

_this._confirmEdit(
active?
'Bạn thực sự muốn huỷ đại lý này?':
'Bạn thực sự muốn kích hoạt đại lý này?',
'active',
data,
active?'Huỷ đại lý':'Kích hoạt đại lý',
active?'Huỷ đại lý thành công':'Kích hoạt đại lý thành công',
active?
'Huỷ đại lý thất bại, vui lòng thử lại sau':
'Kích hoạt đại lý thất bại, vui lòng thử lại sau');

};_this.

_confirmEdit=function(
confirmMessage,editAction,data,editActionText,successMessage,
failureMessage){var
editing=_this.state.editing;
if(editing){
return;
}

if(_reactNative.Platform.OS==='web'){
var result=window.confirm(confirmMessage);
if(result){
_this._doEdit(editAction,data,successMessage,failureMessage);
}
}else{
_reactNative.Alert.alert(
global.__APP_NAME__,
confirmMessage,
[
{text:'Bỏ qua',style:'cancel'},
{
text:editActionText,
onPress:function onPress(){return _this._doEdit(editAction,data,successMessage,
failureMessage);}}]);



}
};_this.

_doEdit=function _callee3(editAction,data,successMessage,failureMessage){var agency,active,status,path,_ref4,response,error;return regeneratorRuntime.async(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:
_this.setState({
editing:true,
editAction:editAction});


agency=_this.state.data;
active=agency.active;
status=active?'deactive':'active';
path='/seller/'+agency.id+'/'+status;_context3.next=7;return regeneratorRuntime.awrap(
_APIClient2.default.POST(path));case 7:_ref4=_context3.sent;response=_ref4.response;error=_ref4.error;
_this._handleEditNetworkResponse(response,error,successMessage,
failureMessage);case 11:case'end':return _context3.stop();}}},null,_this2);};_this.
































_renderItem=function(item,index,dividerHidden){var
section=item.section,title=item.title,value=item.value;
return(
_react2.default.createElement(_reactNative.View,{
key:index,
style:[
styles.item,{
paddingTop:section?20:8,
paddingBottom:section?0:8}]},

_react2.default.createElement(_reactNative.Text,{
style:section?styles.itemSectionText:styles.itemTitleText},
title),

!section&&_react2.default.createElement(_reactNative.Text,{
style:styles.itemValueText},
value),

!section&&!dividerHidden&&_react2.default.createElement(_reactNative.View,{
style:styles.itemDivider})));


};_this.

_renderEditAction=function(action){var
id=action.id,text=action.text,onPress=action.onPress,style=action.style;var
editAction=_this.state.editAction;
return(
_react2.default.createElement(_reactNative.TouchableOpacity,{
key:id,
activeOpacity:0.75,
onPress:onPress,
style:[styles.actionButton,style]},
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.actionButtonImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.actionButtonText},
text),

id===editAction&&_react2.default.createElement(_reactNative.View,{
style:styles.actionActivity},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#ffffff',
style:styles.actionActivityIndicator}))));



};if(_reactNative.Platform.OS==='web'){_this._id=_this.props.match.params.id;}else{_this._id=_this.props.navigation.state.params.id;}_this.state={canEdit:false,status:'none',refreshing:false};return _this;}_createClass(AgencyScreen,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;if(_reactNative.Platform.OS!=='web'){var navigation=this.props.navigation;navigation.setParams({openOrderList:this._openOrderList});}if(_reactNative.Platform.OS==='web'){this._refreshData(false);}else{_reactNative.InteractionManager.runAfterInteractions(function(){_this3._refreshData(false);});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'_handleNetworkResponse',value:function _handleNetworkResponse(response,error){if(response&&response.response){this._updateData(response.response);}else{var message=_Utils2.default.parseErrorMessage(response,error,'Có lỗi xảy ra, vui lòng thử lại sau');_AlertUtils2.default.alert({message:message});this.setState({refreshing:false,status:'failed'});}}},{key:'_handleEditNetworkResponse',value:function _handleEditNetworkResponse(response,error,successMessage,failureMessage){if(response&&response.response){var agency=response.response;if(!_lodash2.default.isEmpty(agency)&&agency.id>0){var data=this.state.data;data=_extends(data,agency);this._updateData(data);this._loadLogs();}var message=successMessage;_AlertUtils2.default.alert({message:message});}else{var _message=_Utils2.default.parseErrorMessage(response,error,failureMessage);_AlertUtils2.default.alert({message:_message});}this.setState({editing:false,editAction:''});}},{key:'render',value:function render()

{var _this4=this;var _state=
this.state,refreshing=_state.refreshing,status=_state.status,items=_state.items,logs=_state.logs,canEdit=_state.canEdit,editing=_state.editing,editActions=_state.editActions;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
_react2.default.createElement(_reactNative.ScrollView,{
automaticallyAdjustContentInsets:false,
refreshControl:
_react2.default.createElement(_reactNative.RefreshControl,{
refreshing:refreshing,
onRefresh:this._onRefresh}),

style:styles.content},
!_lodash2.default.isEmpty(items)&&_react2.default.createElement(_reactNative.View,{
style:styles.contentContainer},
_react2.default.createElement(_reactNative.View,{
style:styles.info},
items.map(function(item,index){return _this4._renderItem(item,index,true);}),

_reactNative.Platform.OS==='web'&&canEdit&&!_lodash2.default.isEmpty(editActions)&&
_react2.default.createElement(_reactNative.View,{
style:styles.actionList},
editActions.map(this._renderEditAction))),


!_lodash2.default.isEmpty(logs)&&_react2.default.createElement(_reactNative.View,{
style:styles.logs},
logs.map(function(item,index){return _this4._renderItem(item,index,
index%3!==0);})))),




_reactNative.Platform.OS!=='web'&&canEdit&&_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
onPress:this._edit,
style:[
styles.actionButton,{
marginTop:20,
marginBottom:20,
alignSelf:'center'}]},

_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.actionButtonImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.actionButtonText},'C\u1EACP NH\u1EACT'),


editing&&_react2.default.createElement(_reactNative.View,{
style:styles.actionActivity},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#ffffff',
style:styles.actionActivityIndicator}))),



status==='loading'&&_react2.default.createElement(_LoadingIndicator2.default,null)));


}}]);return AgencyScreen;}(_react.Component),_class.navigationOptions=function(_ref5){var navigation=_ref5.navigation;var params=navigation.state.params;var _ref6=params?params:{},openOrderList=_ref6.openOrderList;return{headerBackTitle:null,headerTitle:'Đại lý',headerRight:_react2.default.createElement(_NavigationButtons.RightButton,{component:_react2.default.createElement(_Icon2.default,{type:'MaterialIcons',name:'store',size:26,color:'#ffffff'}),onClick:openOrderList})};},_temp);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},

content:{
flex:1},

contentContainer:{
flex:1,
flexDirection:_reactNative.Dimensions.get('window').width<600?'column':'row',
backgroundColor:'#f6efdb'},

info:{
flex:1},

logs:{
flex:1,
borderLeftWidth:1,
borderLeftColor:'#f6efdb'},


item:{
flexDirection:'row'},

itemSectionText:{
marginLeft:10,
color:'#000000',
fontSize:17,
fontWeight:'bold',
backgroundColor:'transparent'},

itemTitleText:_extends({
marginLeft:20,
color:'#000000',
fontSize:17,
fontWeight:'100',
backgroundColor:'transparent'},
_reactNative.Platform.select({
ios:{
flex:1},

android:{
flex:1}})),



itemValueText:{
flex:1,
marginLeft:10,
marginRight:10,
color:'#6b7adc',
fontSize:17,
fontWeight:'300',
textAlign:'right',
backgroundColor:'transparent'},

itemDivider:{
position:'absolute',
left:20,bottom:0,right:10,
height:1,
backgroundColor:'#6b7adc'},


actionList:{
width:contentWidth,
alignSelf:'center'},

actionButton:{
width:contentWidth,
height:56,
marginTop:10,
justifyContent:'center',
alignItems:'center',
backgroundColor:'transparent'},

actionButtonImage:{
position:'absolute',
top:0,left:0,
width:contentWidth,
height:56,
resizeMode:'stretch'},

actionButtonText:{
color:'#ffffff',
fontSize:20,
fontWeight:'bold',
backgroundColor:'transparent',
zIndex:1},

actionActivity:{
position:'absolute',
top:0,bottom:0,right:12,
justifyContent:'center',
alignItems:'center',
zIndex:2},

actionActivityIndicator:{}});


var mapStateToProps=function mapStateToProps(state){
return{
user:state.user};

};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{};
};exports.default=

(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(AgencyScreen);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);









var _reactRedux=__webpack_require__(28);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);

var _modules=__webpack_require__(19);

var _Empty=__webpack_require__(98);var _Empty2=_interopRequireDefault(_Empty);
var _UserUtils=__webpack_require__(66);var _UserUtils2=_interopRequireDefault(_UserUtils);
var _NavigatorUtils=__webpack_require__(996);var _NavigatorUtils2=_interopRequireDefault(_NavigatorUtils);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

NotificationListScreen=(_temp=_class=function(_Component){_inherits(NotificationListScreen,_Component);



















function NotificationListScreen(props){var _this2=this;_classCallCheck(this,NotificationListScreen);var _this=_possibleConstructorReturn(this,(NotificationListScreen.__proto__||Object.getPrototypeOf(NotificationListScreen)).call(this,
props));_this.









































_loadData=function _callee(){var params,_ref,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(
_this._loading||_this._page<=0)){_context.next=2;break;}return _context.abrupt('return');case 2:



_this._loading=true;

params={
page:_this._page,
limit:20};_context.next=6;return regeneratorRuntime.awrap(

_APIClient2.default.GET('/notifications',params));case 6:_ref=_context.sent;response=_ref.response;error=_ref.error;
_this._handleNetworkResponse(response,error);case 10:case'end':return _context.stop();}}},null,_this2);};_this.

































_keyExtractor=function(item){return item.id;};_this.

_onRefresh=function(){return _this._refreshData(true);};_this.

_onEndReached=function(_ref2){var distanceFromEnd=_ref2.distanceFromEnd;
if(distanceFromEnd<0){
return;
}
_this._loadData();
};_this.

_renderItem=function(_ref3){var item=_ref3.item,index=_ref3.index;
return(
_react2.default.createElement(NotificationItem,{
item:item,
onClick:_this._handleClickItem}));

};_this.

_handleClickItem=function(item){var
data=item.data;
if(!data){
return;
}

var route=_NavigatorUtils2.default.parseRoute(item.data);
console.log('route: '+JSON.stringify(route));
if(!route){
return;
}
if(_reactNative.Platform.OS==='web'){var
path=route.path;
if(!_lodash2.default.isEmpty(path)){
_this.props.history.push(path);
}
}else{
if(route.routeName==='Browser'){var
url=route.params.url;
if(!_lodash2.default.isEmpty(url)){
_reactNative.Linking.openURL(url).catch(function(error){return console.log('error: ',error);});
}
return;
}var

navigation=_this.props.navigation;
navigation.navigate(route.routeName,route.params);
}
};_this.state={refreshing:false,items:[],noitem:false};_this._page=-1;_this._loading=false;return _this;}_createClass(NotificationListScreen,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;_reactNative.InteractionManager.runAfterInteractions(function(){_this3._refreshData(true);});var credential=this.props.credential;_UserUtils2.default.resetNotificationCount(credential);}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'_refreshData',value:function _refreshData(refreshing){if(this._loading){return;}this._resetData(refreshing);this._loadData();}},{key:'_resetData',value:function _resetData(refreshing){this._loading=false;this._page=1;this.setState({refreshing:refreshing,items:[],noitem:false});}},{key:'_handleNetworkResponse',value:function _handleNetworkResponse(response,error){var _state=this.state,items=_state.items,noitem=_state.noitem;if(response&&response.response){var newItems=response.response;if(newItems.length>0){items=items.concat(newItems);this._page++;this.setState({items:items});}else{this._page=-1;}}else{}noitem=_lodash2.default.isEmpty(items);this._loading=false;this.setState({refreshing:false,noitem:noitem});}},{key:'render',value:function render()

{var _this4=this;var
user=this.props.user;
var isSignedIn=_UserUtils2.default.isSignedIn(user);var _state2=
this.state,refreshing=_state2.refreshing,items=_state2.items,noitem=_state2.noitem;
return(
_react2.default.createElement(_reactNative.View,{
style:[
styles.container,{
backgroundColor:isSignedIn?'#f6efdb':'#ffffff'}]},

_react2.default.createElement(_modules.FlatList,{
refreshing:refreshing,
data:items,
onEndReachedThreshold:0.5,
keyExtractor:this._keyExtractor,
onRefresh:this._onRefresh,
onEndReached:this._onEndReached,
renderItem:this._renderItem,
style:styles.list}),

noitem&&_react2.default.createElement(_Empty2.default,{
text:'Kh\xF4ng c\xF3 th\xF4ng b\xE1o, b\u1EA5m \u0111\u1EC3 th\u1EED l\u1EA1i',
onClick:function onClick(){return _this4._refreshData(false);}})));


}}]);return NotificationListScreen;}(_react.Component),_class.navigationOptions=function(_ref4){var navigation=_ref4.navigation;var _navigation$state=navigation.state,routes=_navigation$state.routes,params=_navigation$state.params;return{tabBarIcon:function tabBarIcon(_ref5){var focused=_ref5.focused,tintColor=_ref5.tintColor;return _react2.default.createElement(_modules.FontAwesomeIcon,{name:'bell',size:26,color:tintColor});},tabBarVisible:!routes||routes.length<=1,title:'Thông báo',headerBackTitle:null};},_temp);var


NotificationItem=function(_React$PureComponent){_inherits(NotificationItem,_React$PureComponent);function NotificationItem(){var _ref6;var _temp2,_this5,_ret;_classCallCheck(this,NotificationItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp2=(_this5=_possibleConstructorReturn(this,(_ref6=NotificationItem.__proto__||Object.getPrototypeOf(NotificationItem)).call.apply(_ref6,[this].concat(args))),_this5),_this5.

_handleClick=function(){var _this5$props=
_this5.props,item=_this5$props.item,onClick=_this5$props.onClick;
if(onClick){
onClick(item);
}
},_temp2),_possibleConstructorReturn(_this5,_ret);}_createClass(NotificationItem,[{key:'render',value:function render()

{var
item=this.props.item;var
title=item.title,body=item.body;
return(
_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
onPress:this._handleClick,
style:styles.item},
_react2.default.createElement(_reactNative.Text,{
style:styles.itemTitleText},
title),

_react2.default.createElement(_reactNative.Text,{
style:styles.itemBodyText},
body),

_react2.default.createElement(_reactNative.View,{
style:styles.itemDivider})));


}}]);return NotificationItem;}(_react2.default.PureComponent);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},


list:{
flex:1},

item:{
padding:8},

itemTitleText:{
color:'#000000',
fontSize:16,
fontWeight:'bold',
backgroundColor:'transparent'},

itemBodyText:{
color:'#000000',
fontSize:14,
fontWeight:'100',
backgroundColor:'transparent'},

itemDivider:_extends({
position:'absolute',
left:0,bottom:0,right:0,
backgroundColor:'#6b7adc'},
_reactNative.Platform.select({
web:{
height:1},

ios:{
height:1/_reactNative.PixelRatio.get()},

android:{
height:1/_reactNative.PixelRatio.get()}}))});





var mapStateToProps=function mapStateToProps(state){
return{
credential:state.user.credential,
user:state.user};

};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{};
};exports.default=

(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(
NotificationListScreen);

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var

NavigatorUtils=function(){function NavigatorUtils(){_classCallCheck(this,NavigatorUtils);}_createClass(NavigatorUtils,null,[{key:'parseRoute',value:function parseRoute(






data){




if(!data){
return;
}var

type=data.type,id=data.id;
if(_lodash2.default.isEmpty(type)){
return;
}

var routeName=void 0,path=void 0,params=void 0;
switch(type){
case'order':{
routeName='Order';
path='/order/'+id;
params={
id:id};

break;
}
case'partner':{
routeName='Partner';
path='/partner/'+id;
params={
id:id};

break;
}
case'agency':{
routeName='Agency';
path='/agency/'+id;
params={
id:id};

break;
}
case'link':{
routeName='Browser';
params={
url:id};

}
default:
break;}

if(!routeName&&!path){
return;
}

return{
routeName:routeName,
path:path,
params:params};

}}]);return NavigatorUtils;}();exports.default=NavigatorUtils;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);










var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);
var _modules=__webpack_require__(19);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);
var _SearchInput=__webpack_require__(142);var _SearchInput2=_interopRequireDefault(_SearchInput);
var _Empty=__webpack_require__(98);var _Empty2=_interopRequireDefault(_Empty);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var ITEM_HEIGHT=48;var

PartnerListScreen=(_temp=_class=function(_Component){_inherits(PartnerListScreen,_Component);

























function PartnerListScreen(props){var _this2=this;_classCallCheck(this,PartnerListScreen);var _this=_possibleConstructorReturn(this,(PartnerListScreen.__proto__||Object.getPrototypeOf(PartnerListScreen)).call(this,
props));_this.






























_updateQuery=function(query){
if(_this._query===query){
return;
}

_this._query=query;
_this.setState({
query:query});

if(_reactNative.Platform.OS!=='web'){
_this.props.navigation.setParams({
query:query});

}
};_this.

_search=function(){
_this._refreshData(false);
};_this.





















_loadData=function _callee(){var params,_ref,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(
_this._loading||_this._page<=0)){_context.next=2;break;}return _context.abrupt('return');case 2:



_this._loading=true;

params={
role:'partner',
page:_this._page,
limit:_reactNative.Platform.OS==='web'?40:20};

if(!_lodash2.default.isEmpty(_this._query)){
params.query=_this._query;
}_context.next=7;return regeneratorRuntime.awrap(
_APIClient2.default.GET('/admin/users',params));case 7:_ref=_context.sent;response=_ref.response;error=_ref.error;
_this._handleNetworkResponse(response,error);case 11:case'end':return _context.stop();}}},null,_this2);};_this.














































_onRefresh=function(){return _this._refreshData(true);};_this.

_onEndReached=function(){
_this._loadData();
};_this.

_renderItem=function(_ref2){var item=_ref2.item,index=_ref2.index;
return(
_react2.default.createElement(PartnerItem,{
item:item,
onClick:_this._handleClickItem}));

};_this.

_handleClickItem=function(item){
if(!item){
return;
}

if(_reactNative.Platform.OS==='web'){
var path='/partner/'+item.id;
_this.props.history.push(path);
}else{
_this.props.navigation.navigate('Partner',{
id:item.id});

}
};var items=[];_this.state={refreshing:false,items:items,noitem:false};_this._page=-1;_this._loading=false;return _this;}_createClass(PartnerListScreen,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;if(_reactNative.Platform.OS==='web'){}else{var navigation=this.props.navigation;navigation.setParams({updateQuery:this._updateQuery,search:this._search});}_reactNative.InteractionManager.runAfterInteractions(function(){_this3._refreshData(true);});}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'_refreshData',value:function _refreshData(refreshing){if(this._loading){return;}this._resetData(refreshing);this._loadData();}},{key:'_resetData',value:function _resetData(refreshing){this._loading=false;this._page=1;var items=[];this.setState({refreshing:refreshing,items:items,noitem:false});}},{key:'_handleNetworkResponse',value:function _handleNetworkResponse(response,error){var _state=this.state,items=_state.items,noitem=_state.noitem;if(response&&response.response){var newItems=response.response;if(newItems.length>0){items=items.concat(newItems);this._page++;this.setState({items:items});}else{this._page=-1;}noitem=items.length===0;}else{if(items.length===0){var message=_Utils2.default.parseErrorMessage(response,error,'Có lỗi xảy ra, vui lòng thử lại sau');if(_reactNative.Platform.OS!=='web'){_reactNative.Alert.alert(global.__APP_NAME__,message);}else{alert(message);}noitem=true;}}this._loading=false;this.setState({refreshing:false,noitem:noitem});}},{key:'render',value:function render()

{var _this4=this;var _state2=
this.state,refreshing=_state2.refreshing,items=_state2.items,noitem=_state2.noitem;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
_reactNative.Platform.OS==='web'&&_react2.default.createElement(_SearchInput2.default,{
placeholder:'Emai / s\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u0111\u1ED1i t\xE1c',
onUpdateQuery:this._updateQuery,
onSubmit:this._search}),
_react2.default.createElement(_reactNative.FlatList,{
refreshing:refreshing,
extraData:this.state,
data:items,
onRefresh:this._onRefresh,
onEndReached:this._onEndReached,
onEndReachedThreshold:0.5,
renderItem:this._renderItem,
style:styles.list}),

noitem&&_react2.default.createElement(_Empty2.default,{
text:'Kh\xF4ng t\xECm th\u1EA5y \u0111\u1ED1i t\xE1c, b\u1EA5m \u0111\u1EC3 th\u1EED l\u1EA1i',
onClick:function onClick(){return _this4._refreshData(false);},
style:styles.empty})));


}}]);return PartnerListScreen;}(_react.Component),_class.navigationOptions=function(_ref3){var navigation=_ref3.navigation;var _navigation$state=navigation.state,routes=_navigation$state.routes,params=_navigation$state.params;var _ref4=params?params:{},updateQuery=_ref4.updateQuery,search=_ref4.search;return{tabBarIcon:function tabBarIcon(_ref5){var focused=_ref5.focused,tintColor=_ref5.tintColor;return _react2.default.createElement(_modules.FontAwesomeIcon,{name:'user-plus',size:24,color:tintColor});},tabBarVisible:!routes||routes.length<=1,headerBackTitle:null,headerTitle:_react2.default.createElement(_SearchInput2.default,{placeholder:'Emai / s\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u0111\u1ED1i t\xE1c',onUpdateQuery:updateQuery,onSubmit:search})};},_temp);var


PartnerItem=function(_React$PureComponent){_inherits(PartnerItem,_React$PureComponent);function PartnerItem(){var _ref6;var _temp2,_this5,_ret;_classCallCheck(this,PartnerItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp2=(_this5=_possibleConstructorReturn(this,(_ref6=PartnerItem.__proto__||Object.getPrototypeOf(PartnerItem)).call.apply(_ref6,[this].concat(args))),_this5),_this5.

_handleClick=function(){var _this5$props=
_this5.props,item=_this5$props.item,onClick=_this5$props.onClick;
if(onClick){
onClick(item);
}
},_temp2),_possibleConstructorReturn(_this5,_ret);}_createClass(PartnerItem,[{key:'render',value:function render()

{var
item=this.props.item;var
name=item.name,email=item.email,phone=item.phone;
return(
_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
style:styles.item,
onPress:this._handleClick},
_react2.default.createElement(_reactNative.Text,{
style:styles.itemTitleText},
name),

_react2.default.createElement(_reactNative.Text,{
style:styles.itemBodyText},
email),

_react2.default.createElement(_reactNative.View,{
style:styles.itemDivider})));


}}]);return PartnerItem;}(_react2.default.PureComponent);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},


list:{
flex:1},

item:{
height:ITEM_HEIGHT,
paddingLeft:8,
paddingRight:8,
justifyContent:'center'},

itemTitleText:{
color:'#000000',
fontSize:16,
fontWeight:'bold',
backgroundColor:'transparent'},

itemBodyText:{
color:'#000000',
fontSize:14,
fontWeight:'100',
backgroundColor:'transparent'},

itemDivider:_extends({
position:'absolute',
left:0,bottom:0,right:0,
backgroundColor:'#6b7adc'},
_reactNative.Platform.select({
web:{
height:1},

ios:{
height:1/_reactNative.PixelRatio.get()},

android:{
height:1/_reactNative.PixelRatio.get()}})),




empty:_extends({},
_reactNative.Platform.select({
web:{
top:100},

ios:{
top:44},

android:{
top:44}}))});





var mapStateToProps=function mapStateToProps(state){
return{
credential:state.user.credential};

};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{};
};exports.default=

PartnerListScreen;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);













var _reactRedux=__webpack_require__(28);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);
var _LoadingIndicator=__webpack_require__(99);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);
var _UserUtils=__webpack_require__(66);var _UserUtils2=_interopRequireDefault(_UserUtils);
var _NavigationButtons=__webpack_require__(369);
var _Icon=__webpack_require__(85);var _Icon2=_interopRequireDefault(_Icon);
var _AlertUtils=__webpack_require__(62);var _AlertUtils2=_interopRequireDefault(_AlertUtils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var contentWidth=Math.min(_reactNative.Dimensions.get('window').width-40,300);var

PartnerScreen=(_temp=_class=function(_Component){_inherits(PartnerScreen,_Component);

































function PartnerScreen(props){var _this2=this;_classCallCheck(this,PartnerScreen);var _this=_possibleConstructorReturn(this,(PartnerScreen.__proto__||Object.getPrototypeOf(PartnerScreen)).call(this,
props));_this.

































_onRefresh=function(){return _this._refreshData(true);};_this.

_refreshData=function(refreshing){var
status=_this.state.status;
if(_this.state.refreshing||status==='loading'){
return;
}

_this.setState({
refreshing:refreshing,
status:refreshing?'none':'loading'});


_this._loadData();
_this._loadLogs();
};_this.

_loadData=function _callee(){var path,_ref,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:
path='/admin/user/'+_this._id;_context.next=3;return regeneratorRuntime.awrap(
_APIClient2.default.GET(path));case 3:_ref=_context.sent;response=_ref.response;error=_ref.error;
_this._handleNetworkResponse(response,error);case 7:case'end':return _context.stop();}}},null,_this2);};_this.

























































































_loadLogs=function _callee2(){var user,isAdmin,path,_ref2,response,error,logs,_iterator,_isArray,_i,_ref3,data,items;return regeneratorRuntime.async(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:
user=_this.props.user;
isAdmin=_UserUtils2.default.isAdmin(user);if(
isAdmin){_context2.next=4;break;}return _context2.abrupt('return');case 4:if(!



_lodash2.default.isNil(_this._id)){_context2.next=6;break;}return _context2.abrupt('return');case 6:



_this.setState({
logs:[
{
title:'Nhật kí',
section:true}]});




path='/logs/user/'+_this._id;_context2.next=10;return regeneratorRuntime.awrap(
_APIClient2.default.GET(path));case 10:_ref2=_context2.sent;response=_ref2.response;error=_ref2.error;
if(response){
console.log('user logs response: ',response);
}
if(error){
console.warn('user logs error: ',error);
}if(!(
_lodash2.default.isNil(response)||_lodash2.default.isEmpty(response.response))){_context2.next=17;break;}return _context2.abrupt('return');case 17:



logs=_this.state.logs;_iterator=
response.response,_isArray=Array.isArray(_iterator),_i=0,_iterator=_isArray?_iterator:_iterator[typeof Symbol==='function'?typeof Symbol==='function'?typeof Symbol==='function'?Symbol.iterator:'@@iterator':'@@iterator':'@@iterator']();case 19:if(!_isArray){_context2.next=25;break;}if(!(_i>=_iterator.length)){_context2.next=22;break;}return _context2.abrupt('break',34);case 22:_ref3=_iterator[_i++];_context2.next=29;break;case 25:_i=_iterator.next();if(!_i.done){_context2.next=28;break;}return _context2.abrupt('break',34);case 28:_ref3=_i.value;case 29:data=_ref3;
items=_this._parseLog(data);
logs=logs.concat(items);case 32:_context2.next=19;break;case 34:

_this.setState({
logs:logs});case 35:case'end':return _context2.stop();}}},null,_this2);};_this.



_parseLog=function(data){
var items=[];var
username=data.username,content=data.content,updatedAt=data.updatedAt;
items.push({
title:'Người tạo',
value:username});

items.push({
title:'Nội dung',
value:content});

items.push({
title:'Thời gian',
value:_Utils2.default.dateToString(updatedAt)});

return items;
};_this.

_edit=function(){
if(_reactNative.Platform.OS==='web'){
return;
}var

user=_this.props.user;
if(!_UserUtils2.default.isAdmin(user)&&!_UserUtils2.default.isPartner(user)){
return;
}var

editing=_this.state.editing;
if(editing){
return;
}

var actions=_this._generateEditActions(_this.state.data);
actions.push({
text:'Bỏ qua',
style:'cancel'});


_reactNative.Alert.alert(
global.__APP_NAME__,
'Cập nhật',
actions);

};_this.

_generateEditActions=function(data){var
active=data.active;
var actions=[];

if(_reactNative.Platform.OS==='web'){
actions.push({
id:'agency-list',
text:'Đại lý của đối tác',
onPress:_this._openAgencyList});


actions.push({
id:'order-list',
text:'Đơn hàng của đối tác',
onPress:_this._openOrderList});

}

actions.push({
id:'update',
text:'Cập nhật thông tin',
onPress:_this._updateSale});


actions.push({
id:'update-price',
text:'Cập nhật giá bán',
onPress:_this._updatePrice});


actions.push({
id:active?'deactive':'active',
text:active?'Huỷ đối tác':'Kích hoạt đối tác',
onPress:_this._toggleActivation});

return actions;
};_this.

_openAgencyList=function(){var
data=_this.state.data;
if(_reactNative.Platform.OS==='web'){
var path='/agencies/'+data.id;
_this.props.history.push(path);
}else{
_this.props.navigation.push('AgencyList',{
id:data.id});

}
};_this.

_openOrderList=function(){var
data=_this.state.data;
if(_reactNative.Platform.OS==='web'){
var path='/orders/seller/'+data.id;
_this.props.history.push(path);
}else{
_this.props.navigation.push('SellerOrderList',{
id:data.id});

}
};_this.

_updateSale=function(){var
data=_this.state.data;
if(_reactNative.Platform.OS==='web'){
_this.props.history.push({
pathname:'/seller/'+data.id});

}else{
_this.props.navigation.navigate('Seller',{
id:data.id});

}
};_this.

_updatePrice=function(){var
data=_this.state.data;
if(_reactNative.Platform.OS==='web'){
_this.props.history.push({
pathname:'/seller/price/'+data.id});

}else{
_this.props.navigation.navigate('SellerPrice',{
id:data.id});

}
};_this.

_toggleActivation=function(){
var partner=_this.state.data;var
active=partner.active;
var data={
active:!active};

_this._confirmEdit(
active?
'Bạn thực sự muốn huỷ đối tác này?':
'Bạn thực sự muốn kích hoạt đối tác này?',
'active',
data,
active?'Huỷ đối tác':'Kích hoạt đối tác',
active?'Huỷ đối tác thành công':'Kích hoạt đối tác thành công',
active?
'Huỷ đối tác thất bại, vui lòng thử lại sau':
'Kích hoạt đối tác thất bại, vui lòng thử lại sau');

};_this.

_confirmEdit=function(
confirmMessage,editAction,data,editActionText,successMessage,
failureMessage){var
editing=_this.state.editing;
if(editing){
return;
}

if(_reactNative.Platform.OS==='web'){
var result=window.confirm(confirmMessage);
if(result){
_this._doEdit(editAction,data,successMessage,failureMessage);
}
}else{
_reactNative.Alert.alert(
global.__APP_NAME__,
confirmMessage,
[
{text:'Bỏ qua',style:'cancel'},
{
text:editActionText,
onPress:function onPress(){return _this._doEdit(editAction,data,successMessage,
failureMessage);}}]);



}
};_this.

_doEdit=function _callee3(editAction,data,successMessage,failureMessage){var partner,active,status,path,_ref4,response,error;return regeneratorRuntime.async(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:
_this.setState({
editing:true,
editAction:editAction});


partner=_this.state.data;
active=partner.active;
status=active?'deactive':'active';
path='/seller/'+partner.id+'/'+status;_context3.next=7;return regeneratorRuntime.awrap(
_APIClient2.default.POST(path));case 7:_ref4=_context3.sent;response=_ref4.response;error=_ref4.error;
_this._handleEditNetworkResponse(response,error,successMessage,
failureMessage);case 11:case'end':return _context3.stop();}}},null,_this2);};_this.
































_renderItem=function(item,index,dividerHidden){var
section=item.section,title=item.title,value=item.value;
return(
_react2.default.createElement(_reactNative.View,{
key:index,
style:[
styles.item,{
paddingTop:section?20:8,
paddingBottom:section?0:8}]},

_react2.default.createElement(_reactNative.Text,{
style:section?styles.itemSectionText:styles.itemTitleText},
title),

!section&&_react2.default.createElement(_reactNative.Text,{
style:styles.itemValueText},
value),

!section&&!dividerHidden&&_react2.default.createElement(_reactNative.View,{
style:styles.itemDivider})));


};_this.

_renderEditAction=function(action){var
id=action.id,text=action.text,onPress=action.onPress;var
editAction=_this.state.editAction;
return(
_react2.default.createElement(_reactNative.TouchableOpacity,{
key:id,
activeOpacity:0.75,
onPress:onPress,
style:styles.actionButton},
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.actionButtonImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.actionButtonText},
text),

id===editAction&&_react2.default.createElement(_reactNative.View,{
style:styles.actionActivity},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#ffffff',
style:styles.actionActivityIndicator}))));



};_this.state={status:'none'};if(_reactNative.Platform.OS==='web'){_this._id=_this.props.match.params.id;}else{_this._id=_this.props.navigation.state.params.id;}return _this;}_createClass(PartnerScreen,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;if(_reactNative.Platform.OS!=='web'){var navigation=this.props.navigation;navigation.setParams({openAgencyList:this._openAgencyList,openOrderList:this._openOrderList});}if(_reactNative.Platform.OS==='web'){this._refreshData(false);}else{_reactNative.InteractionManager.runAfterInteractions(function(){_this3._refreshData(false);});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'_handleNetworkResponse',value:function _handleNetworkResponse(response,error){if(response&&response.response){this._updateData(response.response);}else{var message=_Utils2.default.parseErrorMessage(response,error,'Có lỗi xảy ra, vui lòng thử lại sau');_AlertUtils2.default.alert({message:message});this.setState({refreshing:false,status:'failed'});}}},{key:'_updateData',value:function _updateData(data){var name=data.name,email=data.email,phone=data.phone,address=data.address,revenue=data.revenue,commission=data.commission,multilevelRevenue=data.multilevelRevenue,multilevelCommission=data.multilevelCommission,active=data.active;var items=[];items.push({title:'Thông tin',section:true});items.push({title:'Tên',value:_lodash2.default.isEmpty(name)?'N/A':name});items.push({title:'Email',value:_lodash2.default.isEmpty(email)?'N/A':email});items.push({title:'Số điện thoại',value:_lodash2.default.isEmpty(phone)?'N/A':phone});items.push({title:'Địa chỉ',value:_lodash2.default.isEmpty(address)?'N/A':address});items.push({title:'Doanh thu (tháng này)',value:_Utils2.default.priceToString(revenue)});items.push({title:'Hoa hồng (tháng này)',value:commission+'%'});items.push({title:'Doanh thu đại lý con (tháng này)',value:_Utils2.default.priceToString(multilevelRevenue)});items.push({title:'Hoa hồng từ đại lý con',value:multilevelCommission+'%'});items.push({title:'Trạng thái hoạt động',value:active?'Đang hoạt động':'Ngừng hoạt động'});this.setState({status:'done',data:data,items:items});var user=this.props.user;var canEdit=_UserUtils2.default.isAdmin(user);var editActions=this._generateEditActions(data);this.setState({refreshing:false,status:'done',data:data,items:items,canEdit:canEdit,editActions:editActions});}},{key:'_handleEditNetworkResponse',value:function _handleEditNetworkResponse(response,error,successMessage,failureMessage){if(response&&response.response){var agency=response.response;if(!_lodash2.default.isEmpty(agency)&&agency.id>0){var data=this.state.data;data=_extends(data,agency);this._updateData(data);this._loadLogs();}var message=successMessage;_AlertUtils2.default.alert({message:message});}else{var _message=_Utils2.default.parseErrorMessage(response,error,failureMessage);_AlertUtils2.default.alert({message:_message});}this.setState({editing:false,editAction:''});}},{key:'render',value:function render()

{var _this4=this;var
user=this.props.user;var _state=
this.state,refreshing=_state.refreshing,status=_state.status,items=_state.items,logs=_state.logs,canEdit=_state.canEdit,editing=_state.editing,editActions=_state.editActions;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
_react2.default.createElement(_reactNative.ScrollView,{
automaticallyAdjustContentInsets:false,
refreshControl:
_react2.default.createElement(_reactNative.RefreshControl,{
refreshing:refreshing,
onRefresh:this._onRefresh}),

style:styles.content},
!_lodash2.default.isEmpty(items)&&_react2.default.createElement(_reactNative.View,{
style:styles.contentContainer},
_react2.default.createElement(_reactNative.View,{
style:styles.info},
items.map(function(item,index){return _this4._renderItem(item,index,true);}),

_reactNative.Platform.OS==='web'&&canEdit&&!_lodash2.default.isEmpty(editActions)&&
_react2.default.createElement(_reactNative.View,{
style:styles.actionList},
editActions.map(this._renderEditAction))),


!_lodash2.default.isEmpty(logs)&&_react2.default.createElement(_reactNative.View,{
style:styles.logs},
logs.map(function(item,index){return _this4._renderItem(item,index,
index%3!==0);})))),




_reactNative.Platform.OS!=='web'&&canEdit&&_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
onPress:this._edit,
style:[
styles.actionButton,{
marginTop:20,
marginBottom:20,
alignSelf:'center'}]},

_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.actionButtonImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.actionButtonText},'C\u1EACP NH\u1EACT'),


editing&&_react2.default.createElement(_reactNative.View,{
style:styles.actionActivity},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#ffffff',
style:styles.actionActivityIndicator}))),



status==='loading'&&_react2.default.createElement(_LoadingIndicator2.default,null)));


}}]);return PartnerScreen;}(_react.Component),_class.navigationOptions=function(_ref5){var navigation=_ref5.navigation;var params=navigation.state.params;var _ref6=params?params:{},openOrderList=_ref6.openOrderList,openAgencyList=_ref6.openAgencyList;return{headerBackTitle:null,headerTitle:'Đối tác',headerRight:_react2.default.createElement(_reactNative.View,{style:{flexDirection:'row'}},_react2.default.createElement(_NavigationButtons.RightButton,{component:_react2.default.createElement(_Icon2.default,{type:'MaterialIcons',name:'store',size:26,color:'#ffffff'}),onClick:openOrderList}),_react2.default.createElement(_NavigationButtons.RightButton,{component:_react2.default.createElement(_Icon2.default,{type:'FontAwesome',name:'users',size:20,color:'#ffffff'}),onClick:openAgencyList}))};},_temp);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},

content:{
flex:1},

contentContainer:{
flex:1,
flexDirection:_reactNative.Dimensions.get('window').width<600?'column':'row',
backgroundColor:'#f6efdb'},

info:{
flex:1},

logs:{
flex:1,
borderLeftWidth:1,
borderLeftColor:'#f6efdb'},


item:{
flexDirection:'row'},

itemSectionText:{
marginLeft:10,
color:'#000000',
fontSize:17,
fontWeight:'bold',
backgroundColor:'transparent'},

itemTitleText:_extends({
marginLeft:20,
color:'#000000',
fontSize:17,
fontWeight:'100',
backgroundColor:'transparent'},
_reactNative.Platform.select({
ios:{
flex:1},

android:{
flex:1}})),



itemValueText:{
flex:1,
marginLeft:10,
marginRight:10,
color:'#6b7adc',
fontSize:17,
fontWeight:'300',
textAlign:'right',
backgroundColor:'transparent'},

itemDivider:{
position:'absolute',
left:20,bottom:0,right:10,
height:1,
backgroundColor:'#6b7adc'},


actionList:{
width:contentWidth,
alignSelf:'center'},

actionButton:{
width:contentWidth,
height:56,
marginTop:10,
justifyContent:'center',
alignItems:'center',
backgroundColor:'transparent'},

actionButtonImage:{
position:'absolute',
top:0,left:0,
width:contentWidth,
height:56,
resizeMode:'stretch'},

actionButtonText:{
color:'#ffffff',
fontSize:20,
fontWeight:'bold',
backgroundColor:'transparent',
zIndex:1},

actionActivity:{
position:'absolute',
top:0,bottom:0,right:12,
justifyContent:'center',
alignItems:'center',
zIndex:2},

actionActivityIndicator:{}});


var mapStateToProps=function mapStateToProps(state){
return{
user:state.user};

};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{};
};exports.default=

(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(PartnerScreen);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);











var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);
var _modules=__webpack_require__(19);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var contentWidth=Math.min(_reactNative.Dimensions.get('window').width-40,300);var

CreateAgencyScreen=(_temp=_class=function(_Component){_inherits(CreateAgencyScreen,_Component);



















function CreateAgencyScreen(props){var _this2=this;_classCallCheck(this,CreateAgencyScreen);var _this=_possibleConstructorReturn(this,(CreateAgencyScreen.__proto__||Object.getPrototypeOf(CreateAgencyScreen)).call(this,
props));_this.






























_submit=function _callee(){var submitting,_this$state,email,phone,name,errorMessage,inputRefName,data,_ref,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:
submitting=_this.state.submitting;if(!
submitting){_context.next=3;break;}return _context.abrupt('return');case 3:_this$state=



_this.state,email=_this$state.email,phone=_this$state.phone,name=_this$state.name;
errorMessage=void 0,inputRefName=void 0;
if(_lodash2.default.isEmpty(email)){
errorMessage='Vui lòng điền địa chỉ email';
inputRefName='emailTextInput';
}else if(!_Utils2.default.isEmailValid(email)){
errorMessage='Địa chỉ email không hợp lệ';
inputRefName='emailTextInput';
}else if(_lodash2.default.isEmpty(phone)){
errorMessage='Vui lòng điền số điện thoại';
inputRefName='phoneTextInput';
}else if(!_Utils2.default.isPhoneValid(phone)){
errorMessage='Số điện thoại không hợp lệ';
inputRefName='phoneTextInput';
}else if(_lodash2.default.isEmpty(name)){
errorMessage='Vui lòng điền tên đại lý';
inputRefName='nameTextInput';
}if(!

errorMessage){_context.next=9;break;}
if(_reactNative.Platform.OS==='web'){
alert(errorMessage);
}else{
_reactNative.Alert.alert(
global.__APP_NAME__,
errorMessage,
[
{text:'OK',onPress:function onPress(){return _this._focusTextInput(inputRefName);}}]);


}return _context.abrupt('return');case 9:



_this.setState({
submitting:true});


data={
email:email,
phone:phone,
name:name};_context.next=13;return regeneratorRuntime.awrap(

_APIClient2.default.POST('/partner/agency',data));case 13:_ref=_context.sent;response=_ref.response;error=_ref.error;
_this._handleNetworkResponse(response,error);case 17:case'end':return _context.stop();}}},null,_this2);};_this.state={email:'',phone:'',name:''};return _this;}_createClass(CreateAgencyScreen,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'_updateInputValue',value:function _updateInputValue(name,value){this.setState(_defineProperty({},name,value));}},{key:'_focusTextInput',value:function _focusTextInput(name){var textInput=this.refs[name];if(textInput){textInput.focus();}}},{key:'_handleNetworkResponse',value:function _handleNetworkResponse(


response,error){
if(response){
console.log(response);
}
if(error){
console.error(error);
}

this.setState({
submitting:false});


var message=void 0;
if(response&&response.response){
message=_Utils2.default.parseSuccessMessage(response,
'Đăng kí đại lý thành công');
}else{
message=_Utils2.default.parseErrorMessage(response,error,
'Đăng kí đại lý thất bại, vui lòng thử lại sau');
}

if(_reactNative.Platform.OS==='web'){
alert(message);
}else{
_reactNative.Alert.alert(
global.__APP_NAME__,
message);

}
}},{key:'render',value:function render()

{var _this3=this;var _state=
this.state,email=_state.email,phone=_state.phone,name=_state.name,submitting=_state.submitting;
return(
_react2.default.createElement(_modules.KeyboardAwareScrollView,{
automaticallyAdjustContentInsets:false,
keyboardDismissMode:_reactNative.Platform.OS==='ios'?'on-drag':'none',
keyboardShouldPersistTaps:'always',
containerContentStyle:styles.contentContainer,
style:styles.container},

_react2.default.createElement(_reactNative.Text,{
style:[
styles.inputTitleText,{
marginTop:24}]},'\u0110\u1ECBa ch\u1EC9 email'),



_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'emailTextInput',
value:email,
placeholder:'\u0110\u1ECBa ch\u1EC9 email',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
keyboardType:'email-address',
autoCapitalize:'none',
returnKeyType:'next',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this3._updateInputValue('email',text);},
onSubmitEditing:function onSubmitEditing(){return _this3._focusTextInput('phoneTextInput');}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'phoneTextInput',
value:phone,
placeholder:'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
keyboardType:'numeric',
autoCapitalize:'none',
returnKeyType:'next',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this3._updateInputValue('phone',text);},
onSubmitEditing:function onSubmitEditing(){return _this3._focusTextInput('nameTextInput');}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'H\u1ECD v\xE0 t\xEAn'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'nameTextInput',
value:name,
placeholder:'H\u1ECD v\xE0 t\xEAn',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
autoCapitalize:'words',
returnKeyType:'go',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this3._updateInputValue('name',text);},
onSubmitEditing:this._submit})),


_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
onPress:this._submit,
style:styles.submit},
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.submitImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.submitText},'\u0110\u0102NG K\xCD'),


submitting&&_react2.default.createElement(_reactNative.View,{
style:styles.submitting},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#ffffff',
style:styles.submittingIndicator})))));





}}]);return CreateAgencyScreen;}(_react.Component),_class.navigationOptions=function(_ref2){var navigation=_ref2.navigation;var _navigation$state=navigation.state,routes=_navigation$state.routes,params=_navigation$state.params;return{tabBarIcon:function tabBarIcon(_ref3){var focused=_ref3.focused,tintColor=_ref3.tintColor;return _react2.default.createElement(_modules.FontAwesomeIcon,{name:'plus-circle',size:32,color:tintColor});},tabBarVisible:!routes||routes.length<=1,title:'Đăng kí đại lý',headerBackTitle:null};},_temp);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},

content:{
flex:1},

contentContainer:{},

inputTitleText:{
width:contentWidth,
marginTop:16,
alignSelf:'center',
color:'#000000',
fontSize:16,
fontWeight:'300',
backgroundColor:'transparent'},

input:{
width:contentWidth,
height:44,
marginTop:5,
alignSelf:'center',
justifyContent:'center',
borderRadius:16,
borderWidth:1,
borderColor:'#e2d7ba',
backgroundColor:'#ffffff'},

textInput:_extends({
marginLeft:12,
padding:0,
color:'#51585e',
fontSize:17,
fontWeight:'300',
backgroundColor:'transparent'},
_reactNative.Platform.select({
web:{
outline:'transparent'}})),




submit:{
width:contentWidth,
height:56,
marginTop:24,
alignSelf:'center',
justifyContent:'center',
alignItems:'center',
backgroundColor:'transparent'},

submitImage:{
position:'absolute',
top:0,left:0,
width:contentWidth,
height:56,
resizeMode:'stretch'},

submitText:{
color:'#ffffff',
fontSize:20,
fontWeight:'bold',
backgroundColor:'transparent',
zIndex:1},

submitting:{
position:'absolute',
top:0,bottom:0,right:12,
justifyContent:'center',
alignItems:'center'},

submittingIndicator:{}});


var mapStateToProps=function mapStateToProps(state){
return{};
};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{};
};exports.default=


CreateAgencyScreen;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);












var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);
var _modules=__webpack_require__(19);
var _LoadingIndicator=__webpack_require__(99);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);
var _AlertUtils=__webpack_require__(62);var _AlertUtils2=_interopRequireDefault(_AlertUtils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var contentWidth=Math.min(_reactNative.Dimensions.get('window').width-40,300);var

SellerScreen=(_temp=_class=function(_Component){_inherits(SellerScreen,_Component);








function SellerScreen(props){var _this2=this;_classCallCheck(this,SellerScreen);var _this=_possibleConstructorReturn(this,(SellerScreen.__proto__||Object.getPrototypeOf(SellerScreen)).call(this,
props));_this.









































_loadData=function _callee(){var status,path,_ref,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:
status=_this.state.status;if(!(
status==='loading')){_context.next=3;break;}return _context.abrupt('return');case 3:



_this.setState({
status:'loading'});


path='/seller/'+_this._id;_context.next=7;return regeneratorRuntime.awrap(
_APIClient2.default.GET(path));case 7:_ref=_context.sent;response=_ref.response;error=_ref.error;
_this._handleNetworkResponse(response,error);case 11:case'end':return _context.stop();}}},null,_this2);};_this.






















_updateData=function(data){var
promoCode=data.promoCode,commission=data.commission,multilevelCommission=data.multilevelCommission;
_this.setState({
data:data,
promoCode:promoCode,
commission:''+commission,
multilevelCommission:''+multilevelCommission,
status:'done'});

};_this.

_submit=function _callee2(){var submitting,_this$state,data,promoCode,commission,multilevelCommission,errorMessage,inputRefName,path,postData,_ref2,response,error;return regeneratorRuntime.async(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:
submitting=_this.state.submitting;if(!
submitting){_context2.next=3;break;}return _context2.abrupt('return');case 3:_this$state=



_this.state,data=_this$state.data,promoCode=_this$state.promoCode,commission=_this$state.commission,multilevelCommission=_this$state.multilevelCommission;
errorMessage=void 0,inputRefName=void 0;
if(_lodash2.default.isEmpty(promoCode)){
errorMessage='Vui lòng điền mã giới thiệu';
inputRefName='promoCodenTextInput';
}else if(_lodash2.default.isEmpty(commission)){
errorMessage='Vui lòng điền hoa hồng';
inputRefName='commissionTextInput';
}else if(data.role==='partner'&&_lodash2.default.isEmpty(multilevelCommission)){
errorMessage='Vui lòng điền hoa hồng liên kết';
inputRefName='multilevelCommissionTextInput';
}if(!

errorMessage){_context2.next=10;break;}
_AlertUtils2.default.alert({
message:errorMessage,
actions:[
{text:'OK',onPress:function onPress(){return _this._focusTextInput(inputRefName);}}]});


if(_reactNative.Platform.OS==='web'){
_this._focusTextInput(inputRefName);
}return _context2.abrupt('return');case 10:



_this.setState({
submitting:true});


path='/seller/'+_this._id;
postData={
promoCode:promoCode,
commission:commission};

if(data.role==='partner'){
postData.multilevelCommission=multilevelCommission;
}_context2.next=16;return regeneratorRuntime.awrap(
_APIClient2.default.PUT(path,postData));case 16:_ref2=_context2.sent;response=_ref2.response;error=_ref2.error;
_this._handleSubmitNetworkResponse(response,error);case 20:case'end':return _context2.stop();}}},null,_this2);};if(_reactNative.Platform.OS==='web'){_this._id=_this.props.match.params.id;}else{_this._id=_this.props.navigation.state.params.id;}_this.state={status:'none'};return _this;}_createClass(SellerScreen,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;if(_reactNative.Platform.OS==='web'){this._loadData();}else{_reactNative.InteractionManager.runAfterInteractions(function(){_this3._loadData();});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'_updateInputValue',value:function _updateInputValue(name,value){this.setState(_defineProperty({},name,value));}},{key:'_focusTextInput',value:function _focusTextInput(name){var textInput=this.refs[name];if(textInput){textInput.focus();}}},{key:'_handleNetworkResponse',value:function _handleNetworkResponse(response,error){if(response&&response.response){this._updateData(response.response);}else{var message=_Utils2.default.parseErrorMessage(response,error,'Có lỗi xảy ra, vui lòng thử lại sau');_AlertUtils2.default.alert({message:message});this.setState({status:'failed'});}}},{key:'_handleSubmitNetworkResponse',value:function _handleSubmitNetworkResponse(


response,error){







this.setState({
submitting:false});


var message=void 0;
if(response&&response.response){
message=_Utils2.default.parseSuccessMessage(response,
'Cập nhật thông tin thành công');
}else{
message=_Utils2.default.parseErrorMessage(response,error,
'Cập nhật thông tin thất bại, vui lòng thử lại sau');
}

if(_reactNative.Platform.OS==='web'){
alert(message);
}else{
_reactNative.Alert.alert(
global.__APP_NAME__,
message);

}
}},{key:'render',value:function render()

{var _this4=this;var _state=
this.state,data=_state.data,status=_state.status,promoCode=_state.promoCode,commission=_state.commission,multilevelCommission=_state.multilevelCommission,submitting=_state.submitting;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
status==='done'&&_react2.default.createElement(_modules.KeyboardAwareScrollView,{
automaticallyAdjustContentInsets:false,
keyboardDismissMode:_reactNative.Platform.OS==='ios'?'on-drag':'none',
keyboardShouldPersistTaps:'always',
containerContentStyle:styles.contentContainer,
style:styles.container},

_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'M\xE3 gi\u1EDBi thi\u1EC7u'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'promoCodeTextInput',
value:promoCode,
placeholder:'M\xE3 gi\u1EDBi thi\u1EC7u',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
returnKeyType:'next',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this4._updateInputValue('promoCode',
text);},
onSubmitEditing:function onSubmitEditing(){return _this4._focusTextInput(
'ommissionTextInput');}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'Hoa h\u1ED3ng'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'commissionTextInput',
value:commission,
placeholder:'Hoa h\u1ED3ng',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
keyboardType:'numeric',
returnKeyType:data.role==='partner'?'next':'go',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this4._updateInputValue('commission',
text);},
onSubmitEditing:function onSubmitEditing(){return data.role==='partner'?
_this4._focusTextInput('multilevelCommissionTextInput'):
_this4._submit;}})),


data.role==='partner'&&_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'Hoa h\u1ED3ng li\xEAn k\u1EBFt'),


data.role==='partner'&&_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'multilevelCommissionTextInput',
value:multilevelCommission,
placeholder:'Hoa h\u1ED3ng li\xEAn k\u1EBFt',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
keyboardType:'numeric',
returnKeyType:'next',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this4._updateInputValue(
'multilevelCommission',text);},
onSubmitEditing:this._submit})),


_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
onPress:this._submit,
style:styles.submit},
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.submitImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.submitText},'C\u1EACP NH\u1EACT'),


submitting&&_react2.default.createElement(_reactNative.View,{
style:styles.submitting},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#ffffff',
style:styles.submittingIndicator})))),




status==='loading'&&_react2.default.createElement(_LoadingIndicator2.default,null)));


}}]);return SellerScreen;}(_react.Component),_class.navigationOptions=function(_ref3){var navigation=_ref3.navigation;return{title:'Cập nhật thông tin',headerBackTitle:null};},_temp);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},

content:{
flex:1},

contentContainer:{},

inputTitleText:{
width:contentWidth,
marginTop:16,
alignSelf:'center',
color:'#000000',
fontSize:16,
fontWeight:'300',
backgroundColor:'transparent'},

input:{
width:contentWidth,
height:44,
marginTop:5,
alignSelf:'center',
justifyContent:'center',
borderRadius:16,
borderWidth:1,
borderColor:'#e2d7ba',
backgroundColor:'#ffffff'},

textInput:_extends({
marginLeft:12,
padding:0,
color:'#51585e',
fontSize:17,
fontWeight:'300',
backgroundColor:'transparent'},
_reactNative.Platform.select({
web:{
outline:'transparent'}})),




submit:{
width:contentWidth,
height:56,
marginTop:24,
alignSelf:'center',
justifyContent:'center',
alignItems:'center',
backgroundColor:'transparent'},

submitImage:{
position:'absolute',
top:0,left:0,
width:contentWidth,
height:56,
resizeMode:'stretch'},

submitText:{
color:'#ffffff',
fontSize:20,
fontWeight:'bold',
backgroundColor:'transparent',
zIndex:1},

submitting:{
position:'absolute',
top:0,bottom:0,right:12,
justifyContent:'center',
alignItems:'center'},

submittingIndicator:{}});


var mapStateToProps=function mapStateToProps(state){
return{};
};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{};
};exports.default=


SellerScreen;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);












var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);
var _modules=__webpack_require__(19);
var _LoadingIndicator=__webpack_require__(99);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);
var _AlertUtils=__webpack_require__(62);var _AlertUtils2=_interopRequireDefault(_AlertUtils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var contentWidth=Math.min(_reactNative.Dimensions.get('window').width-40,300);var

SellerPriceScreen=(_temp=_class=function(_Component){_inherits(SellerPriceScreen,_Component);








function SellerPriceScreen(props){var _this2=this;_classCallCheck(this,SellerPriceScreen);var _this=_possibleConstructorReturn(this,(SellerPriceScreen.__proto__||Object.getPrototypeOf(SellerPriceScreen)).call(this,
props));_this.





























_loadData=function _callee(){var status,path,_ref,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:
status=_this.state.status;if(!(
status==='loading')){_context.next=3;break;}return _context.abrupt('return');case 3:



_this.setState({
status:'loading'});


path='/seller/price/'+_this._id;_context.next=7;return regeneratorRuntime.awrap(
_APIClient2.default.GET(path));case 7:_ref=_context.sent;response=_ref.response;error=_ref.error;
_this._handleNetworkResponse(response,error);case 11:case'end':return _context.stop();}}},null,_this2);};_this.






















_updateData=function(data){var
promoCode=data.promoCode,commission=data.commission,multilevelCommission=data.multilevelCommission;
_this.setState({
data:data,
promoCode:promoCode,
commission:''+commission,
multilevelCommission:''+multilevelCommission,
status:'done'});

};_this.

_submit=function _callee2(){var submitting,path,data,_ref2,response,error;return regeneratorRuntime.async(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:
submitting=_this.state.submitting;if(!
submitting){_context2.next=3;break;}return _context2.abrupt('return');case 3:



_this.setState({
submitting:true});


path='/seller/price/'+_this._id;
data=_this.state.data;_context2.next=8;return regeneratorRuntime.awrap(
_APIClient2.default.jsonPUT(path,data));case 8:_ref2=_context2.sent;response=_ref2.response;error=_ref2.error;
_this._handleSubmitNetworkResponse(response,error);case 12:case'end':return _context2.stop();}}},null,_this2);};_this.



























_updatePrice=function(item,name,text){var
data=_this.state.data;
data=data.map(function(i){
if(i!==item){
return i;
}
return _extends({},
item,_defineProperty({},
name,text));

});
_this.setState({
data:data});

};_this.

_renderPriceInfo=function(item,index){var
purchaseTitle=item.purchaseTitle,price=item.price,saleOff=item.saleOff;
return(
_react2.default.createElement(_reactNative.View,{
key:index},
_react2.default.createElement(_reactNative.Text,{
style:styles.inputSectionText},'G\xF3i ',
purchaseTitle),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'Gi\xE1 b\xE1n'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
value:''+price,
placeholder:'Gi\xE1 b\xE1n',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
keyboardType:'numeric',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this._updatePrice(item,'price',text);}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'Gi\u1EA3m gi\xE1'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
value:''+saleOff,
placeholder:'Gi\u1EA3m gi\xE1',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
keyboardType:'numeric',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this._updatePrice(item,'saleOff',text);}}))));



};if(_reactNative.Platform.OS==='web'){_this._id=_this.props.match.params.id;}else{_this._id=_this.props.navigation.state.params.id;}console.log('id: ',_this._id);_this.state={status:'none'};return _this;}_createClass(SellerPriceScreen,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;if(_reactNative.Platform.OS==='web'){this._loadData();}else{_reactNative.InteractionManager.runAfterInteractions(function(){_this3._loadData();});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'_handleNetworkResponse',value:function _handleNetworkResponse(response,error){if(response&&response.response){this._updateData(response.response);}else{var message=_Utils2.default.parseErrorMessage(response,error,'Có lỗi xảy ra, vui lòng thử lại sau');_AlertUtils2.default.alert({message:message});this.setState({status:'failed'});}}},{key:'_handleSubmitNetworkResponse',value:function _handleSubmitNetworkResponse(response,error){this.setState({submitting:false});var message=void 0;if(response&&response.response){message=_Utils2.default.parseSuccessMessage(response,'Cập nhật thông tin thành công');}else{message=_Utils2.default.parseErrorMessage(response,error,'Cập nhật thông tin thất bại, vui lòng thử lại sau');}_AlertUtils2.default.alert({message:message});}},{key:'render',value:function render()

{var _state=
this.state,data=_state.data,status=_state.status,submitting=_state.submitting;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
status==='done'&&_react2.default.createElement(_modules.KeyboardAwareScrollView,{
automaticallyAdjustContentInsets:false,
keyboardDismissMode:_reactNative.Platform.OS==='ios'?'on-drag':'none',
keyboardShouldPersistTaps:'always',
containerContentStyle:styles.contentContainer,
style:styles.container},

!_lodash2.default.isEmpty(data)&&data.map(this._renderPriceInfo),

_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
onPress:this._submit,
style:styles.submit},
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.submitImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.submitText},'C\u1EACP NH\u1EACT'),


submitting&&_react2.default.createElement(_reactNative.View,{
style:styles.submitting},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#ffffff',
style:styles.submittingIndicator})))),




status==='loading'&&_react2.default.createElement(_LoadingIndicator2.default,null)));


}}]);return SellerPriceScreen;}(_react.Component),_class.navigationOptions=function(_ref3){var navigation=_ref3.navigation;return{title:'Cập nhật thông tin',headerBackTitle:null};},_temp);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},

content:{
flex:1},

contentContainer:{},

inputSectionText:{
width:contentWidth,
marginTop:20,
alignSelf:'center',
color:'#000000',
fontSize:16,
fontWeight:'500',
backgroundColor:'transparent'},

inputTitleText:{
width:contentWidth,
marginTop:8,
alignSelf:'center',
color:'#000000',
fontSize:16,
fontWeight:'300',
backgroundColor:'transparent'},

input:{
width:contentWidth,
height:44,
marginTop:5,
alignSelf:'center',
justifyContent:'center',
borderRadius:16,
borderWidth:1,
borderColor:'#e2d7ba',
backgroundColor:'#ffffff'},

textInput:_extends({
marginLeft:12,
padding:0,
color:'#51585e',
fontSize:17,
fontWeight:'300',
backgroundColor:'transparent'},
_reactNative.Platform.select({
web:{
outline:'transparent'}})),




submit:{
width:contentWidth,
height:56,
marginTop:24,
alignSelf:'center',
justifyContent:'center',
alignItems:'center',
backgroundColor:'transparent'},

submitImage:{
position:'absolute',
top:0,left:0,
width:contentWidth,
height:56,
resizeMode:'stretch'},

submitText:{
color:'#ffffff',
fontSize:20,
fontWeight:'bold',
backgroundColor:'transparent',
zIndex:1},

submitting:{
position:'absolute',
top:0,bottom:0,right:12,
justifyContent:'center',
alignItems:'center'},

submittingIndicator:{}});


var mapStateToProps=function mapStateToProps(state){
return{};
};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{};
};exports.default=


SellerPriceScreen;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);












var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);

var _modules=__webpack_require__(19);
var _LoadingIndicator=__webpack_require__(99);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var contentWidth=Math.min(_reactNative.Dimensions.get('window').width-40,300);var

PaymentScreen=(_temp=_class=function(_Component){_inherits(PaymentScreen,_Component);









function PaymentScreen(props){var _this2=this;_classCallCheck(this,PaymentScreen);var _this=_possibleConstructorReturn(this,(PaymentScreen.__proto__||Object.getPrototypeOf(PaymentScreen)).call(this,
props));_this.





































_loadData=function _callee(){var _ref,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:
_this.setState({
status:'loading'});_context.next=3;return regeneratorRuntime.awrap(


_APIClient2.default.GET('/payment'));case 3:_ref=_context.sent;response=_ref.response;error=_ref.error;
_this._handleNetworkResponse(response,error);case 7:case'end':return _context.stop();}}},null,_this2);};_this.







































_submit=function _callee2(){var _this$state,bank,city,branch,accountNumber,accountHolder,errorMessage,textInputRef,data,_ref2,response,error;return regeneratorRuntime.async(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:
if(_reactNative.Platform.OS!=='web'){
_modules.Keyboard.dismiss();
}_this$state=

_this.state,bank=_this$state.bank,city=_this$state.city,branch=_this$state.branch,accountNumber=_this$state.accountNumber,accountHolder=_this$state.accountHolder;
errorMessage=void 0,textInputRef=void 0;
if(_lodash2.default.isEmpty(bank)){
errorMessage='Vui lòng nhập tên ngân hàng';
textInputRef='bankTextInput';
}else if(_lodash2.default.isEmpty(city)){
errorMessage='Vui lòng nhập tên thành phố';
textInputRef='cityTextInput';
}else if(_lodash2.default.isEmpty(branch)){
errorMessage='Vui lòng nhập tên chi nhánh';
textInputRef='branchTextInput';
}else if(_lodash2.default.isEmpty(accountNumber)){
errorMessage='Vui lòng nhập số tài khoản';
textInputRef='accountNumberTextInput';
}else if(_lodash2.default.isEmpty(accountHolder)){
errorMessage='Vui lòng nhập tên chủ tài khoản';
textInputRef='accountHolderTextInput';
}if(!
errorMessage){_context2.next=7;break;}
if(_reactNative.Platform.OS==='web'){
alert(errorMessage);
_this._focusTextInput(textInputRef);
}else{
_reactNative.Alert.alert(
global.__APP_NAME__,
errorMessage,
[
{text:'OK',onPress:function onPress(){return _this._focusTextInput(textInputRef);}}]);


}return _context2.abrupt('return');case 7:



_this.setState({
status:'editing'});


data={
bank:bank,
city:city,
branch:branch,
account_number:accountNumber,
account_holder:accountHolder};_context2.next=11;return regeneratorRuntime.awrap(

_APIClient2.default.POST('/payment',data));case 11:_ref2=_context2.sent;response=_ref2.response;error=_ref2.error;
_this._handleUpdateNetworkResponse(response,error);case 15:case'end':return _context2.stop();}}},null,_this2);};_this.


_handleUpdateNetworkResponse=function(response,error){







var message=void 0;
if(response&&response.response&&response.response.status===true){
message=response.response.message;
}else{
message=error&&error.message?
error.message:
'Có lỗi xảy ra, vui lòng thử lại sau';
}

if(_reactNative.Platform.OS==='web'){
alert(message);
}else{
_reactNative.Alert.alert(
global.__APP_NAME__,
message);

}

_this.setState({
status:'done'});

};_this.state={status:'none',bank:'',city:'',branch:'',accountNumber:'',accountHolder:''};return _this;}_createClass(PaymentScreen,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;if(_reactNative.Platform.OS==='web'){this._loadData();}else{_reactNative.InteractionManager.runAfterInteractions(function(){_this3._loadData();});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'_updateInputValue',value:function _updateInputValue(name,value){this.setState(_defineProperty({},name,value));}},{key:'_focusTextInput',value:function _focusTextInput(name){var textInput=this.refs[name];if(textInput){textInput.focus();}}},{key:'_handleNetworkResponse',value:function _handleNetworkResponse(response,error){if(response&&response.response){var data=response.response;var bank=data.bank,city=data.city,branch=data.branch,accountNumber=data.accountNumber,accountHolder=data.accountHolder;this.setState({data:data,bank:bank,city:city,branch:branch,accountNumber:accountNumber,accountHolder:accountHolder});}else{var message=error&&error.message?error.message:'Có lỗi xảy ra, vui lòng thử lại sau';if(_reactNative.Platform.OS==='web'){alert(message);}else{_reactNative.Alert.alert(global.__APP_NAME__,message);}}this.setState({status:'done'});}},{key:'render',value:function render()

{var _this4=this;var _state=
this.state,status=_state.status,data=_state.data,bank=_state.bank,city=_state.city,branch=_state.branch,accountNumber=_state.accountNumber,accountHolder=_state.accountHolder;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
!_lodash2.default.isNil(data)&&_react2.default.createElement(_modules.KeyboardAwareScrollView,{
automaticallyAdjustContentInsets:false,
keyboardDismissMode:_reactNative.Platform.OS==='ios'?'on-drag':'none',
keyboardShouldPersistTaps:'always',
containerContentStyle:styles.contentContainer,
style:styles.content},

_react2.default.createElement(_reactNative.Text,{
style:[
styles.inputTitleText,{
marginTop:24}]},'T\xEAn ng\xE2n h\xE0ng'),



_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'bankTextInput',
value:bank,
placeholder:'T\xEAn ng\xE2n h\xE0ng',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
autoCapitalize:'words',
returnKeyType:'next',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this4._updateInputValue('bank',text);},
onSubmitEditing:function onSubmitEditing(){return _this4._focusTextInput('cityTextInput');}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'Th\xE0nh ph\u1ED1'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'cityTextInput',
value:city,
placeholder:'Th\xE0nh ph\u1ED1',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
autoCapitalize:'words',
returnKeyType:'next',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this4._updateInputValue('city',text);},
onSubmitEditing:function onSubmitEditing(){return _this4._focusTextInput('branchTextInput');}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'Chi nh\xE1nh ng\xE2n h\xE0ng'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'branchTextInput',
value:branch,
placeholder:'Chi nh\xE1nh ng\xE2n h\xE0ng',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
autoCapitalize:'words',
clearButtonMode:'while-editing',
returnKeyType:'next',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this4._updateInputValue('branch',text);},
onSubmitEditing:function onSubmitEditing(){return _this4._focusTextInput(
'accountNumberTextInput');}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'S\u1ED1 t\xE0i kho\u1EA3n'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'accountNumberTextInput',
value:accountNumber,
placeholder:'S\u1ED1 t\xE0i kho\u1EA3n',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
returnKeyType:'next',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this4._updateInputValue('accountNumber',
text);},
onSubmitEditing:function onSubmitEditing(){return _this4._focusTextInput(
'accountHolderTextInput');}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'Ch\u1EE7 t\xE0i kho\u1EA3n'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'accountHolderTextInput',
value:accountHolder,
placeholder:'Ch\u1EE7 t\xE0i kho\u1EA3n',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
autoCapitalize:'words',
returnKeyType:'go',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this4._updateInputValue('accountHolder',
text);},
onSubmitEditing:this._submit})),


_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
onPress:this._submit,
style:[
styles.actionButton,{
marginTop:20,
marginBottom:20,
alignSelf:'center'}]},

_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.actionButtonImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.actionButtonText},'C\u1EADp nh\u1EADt th\xF4ng tin'),


status==='editing'&&_react2.default.createElement(_reactNative.View,{
style:styles.actionActivity},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#ffffff',
style:styles.actionActivityIndicator})))),




status==='loading'&&_react2.default.createElement(_LoadingIndicator2.default,null)));


}}]);return PaymentScreen;}(_react.Component),_class.navigationOptions=function(_ref3){var navigation=_ref3.navigation;var params=navigation.state.params;return{headerBackTitle:null,headerTitle:'Thông tin thanh toán'};},_temp);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},

content:{
flex:1},

contentContainer:{},

inputTitleText:{
width:contentWidth,
marginTop:16,
alignSelf:'center',
color:'#000000',
fontSize:16,
fontWeight:'300',
backgroundColor:'transparent'},

input:{
width:contentWidth,
height:44,
marginTop:5,
alignSelf:'center',
justifyContent:'center',
borderRadius:16,
borderWidth:1,
borderColor:'#e2d7ba',
backgroundColor:'#ffffff'},

textInput:_extends({
marginLeft:12,
padding:0,
color:'#51585e',
fontSize:17,
fontWeight:'300',
backgroundColor:'transparent',
backgroundColor:'transparent'},
_reactNative.Platform.select({
web:{
outline:'transparent'}})),




actionButton:{
width:contentWidth,
height:56,
marginTop:10,
justifyContent:'center',
alignItems:'center',
backgroundColor:'transparent'},

actionButtonImage:{
position:'absolute',
top:0,left:0,
width:contentWidth,
height:56,
resizeMode:'stretch'},

actionButtonText:{
color:'#ffffff',
fontSize:20,
fontWeight:'bold',
backgroundColor:'transparent',
zIndex:1},

actionActivity:{
position:'absolute',
top:0,bottom:0,right:12,
justifyContent:'center',
alignItems:'center',
zIndex:2},

actionActivityIndicator:{}});


var mapStateToProps=function mapStateToProps(state){
return{};
};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{};
};exports.default=

PaymentScreen;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);











var _reactRedux=__webpack_require__(28);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);

var _modules=__webpack_require__(19);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);
var _AlertUtils=__webpack_require__(62);var _AlertUtils2=_interopRequireDefault(_AlertUtils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var contentWidth=Math.min(_reactNative.Dimensions.get('window').width-40,300);var

PrepayScreen=(_temp=_class=function(_Component){_inherits(PrepayScreen,_Component);








function PrepayScreen(props){var _this2=this;_classCallCheck(this,PrepayScreen);var _this=_possibleConstructorReturn(this,(PrepayScreen.__proto__||Object.getPrototypeOf(PrepayScreen)).call(this,
props));_this.



























_submit=function(){var
submitting=_this.state.submitting;
if(submitting){
return;
}var _this$state=

_this.state,seller=_this$state.seller,quantity=_this$state.quantity,bonus=_this$state.bonus;
var errorMessage=void 0,inputRefName=void 0;
if(_lodash2.default.isEmpty(seller)){
errorMessage='Vui lòng điền id hoặc địa chỉ email của người bán';
inputRefName='sellerIdTextInput';
}else if(_lodash2.default.isEmpty(quantity)){
errorMessage='Vui lòng điền số lượng đặt mua';
inputRefName='quantityTextInput';
}else if(_lodash2.default.isEmpty(bonus)){
errorMessage='Vui lòng điền số lượng thưởng thêm';
inputRefName='bonusTextInput';
}

if(errorMessage){
if(_reactNative.Platform.OS==='web'){
alert(errorMessage);
}else{
_reactNative.Alert.alert(
global.__APP_NAME__,
errorMessage,
[
{text:'OK',onPress:function onPress(){return _this._focusTextInput(inputRefName);}}]);


}
return;
}

_this._doSubmit();
};_this.

_doSubmit=function _callee(){var _this$state2,seller,quantity,bonus,path,data,_ref,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:
_this.setState({
submitting:true});_this$state2=


_this.state,seller=_this$state2.seller,quantity=_this$state2.quantity,bonus=_this$state2.bonus;
path='/admin/seller/'+seller+'/prepay';
data={
quantity:quantity,
bonus:bonus};_context.next=6;return regeneratorRuntime.awrap(

_APIClient2.default.POST(path,data));case 6:_ref=_context.sent;response=_ref.response;error=_ref.error;
_this._handleNetworkResponse(response,error);case 10:case'end':return _context.stop();}}},null,_this2);};_this.state={seller:'',quantity:'10',bonus:'0'};return _this;}_createClass(PrepayScreen,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'_updateInputValue',value:function _updateInputValue(name,value){this.setState(_defineProperty({},name,value));}},{key:'_focusTextInput',value:function _focusTextInput(name){var textInput=this.refs[name];if(textInput){textInput.focus();}}},{key:'_handleNetworkResponse',value:function _handleNetworkResponse(


response,error){
if(response){
console.log(response);
}
if(error){
console.error(error);
}

this.setState({
submitting:false});


if(response&&response.response){
this.setState({
items:response.response});

}else{
var message=
_Utils2.default.parseErrorMessage(response,error,
'Sinh mã thất bại, vui lòng thử lại sau');
_AlertUtils2.default.alert({message:message});
}
}},{key:'render',value:function render()

{var _this3=this;var _state=
this.state,seller=_state.seller,quantity=_state.quantity,bonus=_state.bonus,items=_state.items,submitting=_state.submitting;
return(
_react2.default.createElement(_modules.KeyboardAwareScrollView,{
automaticallyAdjustContentInsets:false,
keyboardDismissMode:_reactNative.Platform.OS==='ios'?'on-drag':'none',
keyboardShouldPersistTaps:'always',
containerContentStyle:styles.contentContainer,
style:styles.container},

_react2.default.createElement(_reactNative.Text,{
style:[
styles.inputTitleText,{
marginTop:24}]},'ID ho\u1EB7c email ng\u01B0\u1EDDi b\xE1n'),



_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'sellerTextInput',
value:seller,
placeholder:'ID ho\u1EB7c email ng\u01B0\u1EDDi b\xE1n',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
returnKeyType:'next',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this3._updateInputValue('seller',text);},
onSubmitEditing:function onSubmitEditing(){return _this3._focusTextInput('quantityTextInput');}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'S\u1ED1 l\u01B0\u1EE3ng'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'quantityTextInput',
value:quantity,
placeholder:'S\u1ED1 l\u01B0\u1EE3ng',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
keyboardType:'numeric',
autoCapitalize:'none',
returnKeyType:'next',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this3._updateInputValue('quantity',text);},
onSubmitEditing:function onSubmitEditing(){return _this3._focusTextInput('bonusTextInput');}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'S\u1ED1 l\u01B0\u1EE3ng th\u01B0\u1EDFng th\xEAm'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'bonusTextInput',
value:bonus,
placeholder:'S\u1ED1 l\u01B0\u1EE3ng',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
keyboardType:'numeric',
autoCapitalize:'none',
returnKeyType:'next',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this3._updateInputValue('bonus',text);},
onSubmitEditing:this._submit})),


!_lodash2.default.isEmpty(items)&&_react2.default.createElement(_reactNative.View,{
style:styles.activateCodeContainer},
_react2.default.createElement(_reactNative.Text,{
style:styles.activateCodeContainerTitleText},'Danh s\xE1ch m\xE3 tr\u1EA3 tr\u01B0\u1EDBc'),


items.map(function(item,index){
return(
_react2.default.createElement(_reactNative.Text,{
key:index,
style:styles.activateCodeText},
item+'\n'));


})),


_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
onPress:this._submit,
style:styles.submit},
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.submitImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.submitText},'SINH M\xC3'),


submitting&&_react2.default.createElement(_reactNative.View,{
style:styles.submitting},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#ffffff',
style:styles.submittingIndicator})))));





}}]);return PrepayScreen;}(_react.Component),_class.navigationOptions=function(_ref2){var navigation=_ref2.navigation;var params=navigation.state.params;return{headerBackTitle:null};},_temp);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},

content:{
flex:1},

contentContainer:{},

inputTitleText:{
width:contentWidth,
marginTop:16,
alignSelf:'center',
color:'#000000',
fontSize:16,
fontWeight:'300',
backgroundColor:'transparent'},

input:{
width:contentWidth,
height:44,
marginTop:5,
alignSelf:'center',
justifyContent:'center',
borderRadius:16,
borderWidth:1,
borderColor:'#e2d7ba',
backgroundColor:'#ffffff'},

textInput:_extends({
marginLeft:12,
padding:0,
color:'#51585e',
fontSize:17,
fontWeight:'300',
backgroundColor:'transparent'},
_reactNative.Platform.select({
web:{
outline:'transparent'}})),




activateCodeContainer:{
marginTop:24,
alignItems:'center'},

activateCodeContainerTitleText:{
marginBottom:8,
color:'#000000',
fontSize:17,
fontWeight:'500',
backgroundColor:'transparent'},

activateCodeText:{
color:'#606060',
fontSize:15,
fontWeight:'300',
backgroundColor:'transparent'},


submit:{
width:contentWidth,
height:56,
marginTop:24,
alignSelf:'center',
justifyContent:'center',
alignItems:'center',
backgroundColor:'transparent'},

submitImage:{
position:'absolute',
top:0,left:0,
width:contentWidth,
height:56,
resizeMode:'stretch'},

submitText:{
color:'#ffffff',
fontSize:20,
fontWeight:'bold',
backgroundColor:'transparent',
zIndex:1},

submitting:{
position:'absolute',
top:0,bottom:0,right:12,
justifyContent:'center',
alignItems:'center'},

submittingIndicator:{}});


var mapStateToProps=function mapStateToProps(state){
return{};
};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{};
};exports.default=

(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(PrepayScreen);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);






var _reactRedux=__webpack_require__(28);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);
var _OrderHeader=__webpack_require__(224);var _OrderHeader2=_interopRequireDefault(_OrderHeader);
var _OrderItem=__webpack_require__(225);var _OrderItem2=_interopRequireDefault(_OrderItem);
var _SearchInput=__webpack_require__(142);var _SearchInput2=_interopRequireDefault(_SearchInput);
var _Empty=__webpack_require__(98);var _Empty2=_interopRequireDefault(_Empty);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);
var _UserManager=__webpack_require__(112);var _UserManager2=_interopRequireDefault(_UserManager);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

SellerOrderListScreen=(_temp=_class=function(_Component){_inherits(SellerOrderListScreen,_Component);















function SellerOrderListScreen(props){var _this2=this;_classCallCheck(this,SellerOrderListScreen);var _this=_possibleConstructorReturn(this,(SellerOrderListScreen.__proto__||Object.getPrototypeOf(SellerOrderListScreen)).call(this,
props));_this.



























_updateQuery=function(query){
if(_this._query===query){
return;
}

_this._query=query;
_this.setState({
query:query});

if(_reactNative.Platform.OS!=='web'){
_this.props.navigation.setParams({
query:query});

}
};_this.

_search=function(){
_this._loading=false;
_this._page=1;
_this._refreshData(true);
};_this.

_refreshData=function(refreshing){
_this._resetData(refreshing);
_this._loadData();
};_this.












_loadData=function _callee(){var path,params,_ref,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(
_this._loading||_this._page<=0)){_context.next=2;break;}return _context.abrupt('return');case 2:



_this._loading=true;

path='/orders/seller/'+_this._sellerId;
params={
page:_this._page,
limit:20};_context.next=7;return regeneratorRuntime.awrap(

_APIClient2.default.GET(path,params));case 7:_ref=_context.sent;response=_ref.response;error=_ref.error;
_this._handleNetworkResponse(response,error);case 11:case'end':return _context.stop();}}},null,_this2);};_this.


































_onRefresh=function(){return _this._refreshData(true);};_this.

_onEndReached=function(){return _this._loadData();};_this.

_renderItem=function(_ref2){var item=_ref2.item,index=_ref2.index;
return(
_react2.default.createElement(_OrderItem2.default,{
simple:!_UserManager2.default.getInstance().isAdmin(),
data:item,
onClick:_this._handleClickItem}));

};_this.

_handleClickItem=function(data){
if(_reactNative.Platform.OS==='web'){
var path='/order/'+data.id;
_this.props.history.push(path);
}else{var
navigation=_this.props.navigation;
navigation.navigate('Order',{
id:data.id});

}
};_this._query='';_this._page=-1;_this._items=[];_this.state={refreshing:false,items:[],noitem:false,query:_this._query};return _this;}_createClass(SellerOrderListScreen,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;if(_reactNative.Platform.OS==='web'){this._sellerId=this.props.match.params.id;}else{this._sellerId=this.props.navigation.state.params.id;}_reactNative.InteractionManager.runAfterInteractions(function(){_this3._refreshData(true);});}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'_resetData',value:function _resetData(refreshing){this._loading=false;this._page=1;this._items=[];this.setState({refreshing:refreshing,items:this._items,noitem:false});}},{key:'_handleNetworkResponse',value:function _handleNetworkResponse(response,error){var _state=this.state,items=_state.items,noitem=_state.noitem;if(response&&response.response){var newItems=response.response;if(newItems.length>0){items=items.concat(newItems);this._page++;this.setState({items:items});}else{this._page=-1;}noitem=items.length===0;}else{noitem=_lodash2.default.isEmpty(items);}this._loading=false;this.setState({refreshing:false,noitem:noitem});}},{key:'render',value:function render()

{var _this4=this;var _state2=
this.state,refreshing=_state2.refreshing,items=_state2.items,noitem=_state2.noitem;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
_reactNative.Platform.OS==='web'&&_react2.default.createElement(_SearchInput2.default,{
placeholder:'ID / Emai / s\u1ED1 \u0111i\u1EC7n tho\u1EA1i kh\xE1ch h\xE0ng',
onUpdateQuery:this._updateQuery,
onSubmit:this._search}),

_react2.default.createElement(_OrderHeader2.default,{
simple:!_UserManager2.default.getInstance().isAdmin()}),

_react2.default.createElement(_reactNative.FlatList,{
refreshing:refreshing,
extraData:this.state,
data:items,
onRefresh:this._onRefresh,
onEndReached:this._onEndReached,
onEndReachedThreshold:0.5,
renderItem:this._renderItem,
style:styles.list}),

noitem&&_react2.default.createElement(_Empty2.default,{
text:'Kh\xF4ng c\xF3 \u0111\u01A1n h\xE0ng, b\u1EA5m \u0111\u1EC3 th\u1EED l\u1EA1i',
onClick:function onClick(){return _this4._refreshData(false);},
style:styles.empty})));


}}]);return SellerOrderListScreen;}(_react.Component),_class.navigationOptions=function(_ref3){var navigation=_ref3.navigation;var params=navigation.state.params;var _ref4=params?params:{},updateQuery=_ref4.updateQuery,search=_ref4.search;return{headerBackTitle:null,headerTitle:_react2.default.createElement(_SearchInput2.default,{placeholder:'ID / Emai / s\u1ED1 \u0111i\u1EC7n tho\u1EA1i kh\xE1ch h\xE0ng',onUpdateQuery:updateQuery,onSubmit:search})};},_temp);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'}});



var mapStateToProps=function mapStateToProps(state){
return{};
};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{};
};exports.default=

(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(
SellerOrderListScreen);

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);











var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);

var _modules=__webpack_require__(19);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);
var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);
var _AlertUtils=__webpack_require__(62);var _AlertUtils2=_interopRequireDefault(_AlertUtils);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var contentWidth=Math.min(_reactNative.Dimensions.get('window').width-40,300);var

EditOrderScreen=(_temp=_class=function(_Component){_inherits(EditOrderScreen,_Component);









function EditOrderScreen(props){var _this2=this;_classCallCheck(this,EditOrderScreen);var _this=_possibleConstructorReturn(this,(EditOrderScreen.__proto__||Object.getPrototypeOf(EditOrderScreen)).call(this,
props));_this.



































_loadData=function _callee(){var status,path,_ref,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:
status=_this.state.status;if(!(
status==='loading')){_context.next=3;break;}return _context.abrupt('return');case 3:



_this.setState({
status:'loading'});


path='/order/'+_this._id;_context.next=7;return regeneratorRuntime.awrap(
_APIClient2.default.GET(path));case 7:_ref=_context.sent;response=_ref.response;error=_ref.error;
_this._handleNetworkResponse(response,error);case 11:case'end':return _context.stop();}}},null,_this2);};_this.


_handleNetworkResponse=function(response,error){
if(response&&response.response){
_this.setState({
status:'succeed'});var _response$response=

response.response,order=_response$response.order,customer=_response$response.customer,seller=_response$response.seller;
_this.setState({
paymentMethod:_lodash2.default.isEmpty(order.paymentMethod)?
'':
order.paymentMethod,
promoCode:_lodash2.default.isEmpty(seller.promoCode)?'':seller.promoCode,
address:_lodash2.default.isEmpty(customer.address)?'':customer.address,
name:_lodash2.default.isEmpty(customer.name)?'':customer.name,
shippingCode:_lodash2.default.isEmpty(order.shippingCode)?'':order.shippingCode});

}else{
_this.setState({
status:'failed'});

var message=_Utils2.default.parseErrorMessage(response,error,
'Có lỗi xảy ra, vui lòng thử lại sau');
_AlertUtils2.default.alert({message:message});
}
};_this.

_submit=function _callee2(){var submitting,_this$state,paymentMethod,promoCode,address,name,shippingCode,path,data,_ref2,response,error;return regeneratorRuntime.async(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:
submitting=_this.state.submitting;if(!
submitting){_context2.next=3;break;}return _context2.abrupt('return');case 3:



_this.setState({
submitting:true});_this$state=


_this.state,paymentMethod=_this$state.paymentMethod,promoCode=_this$state.promoCode,address=_this$state.address,name=_this$state.name,shippingCode=_this$state.shippingCode;
path='/order/'+_this._id;
data={
payment_method:paymentMethod,
promo_code:promoCode,
address:address,
name:name,
shipping_code:shippingCode};_context2.next=9;return regeneratorRuntime.awrap(

_APIClient2.default.POST(path,data));case 9:_ref2=_context2.sent;response=_ref2.response;error=_ref2.error;
_this._handleSubmitNetworkResponse(response,error);case 13:case'end':return _context2.stop();}}},null,_this2);};_this.


_handleSubmitNetworkResponse=function(response,error){







_this.setState({
submitting:false});


if(response&&response.response){
var message=
_lodash2.default.isEmpty(response.response.message)?
'Cập nhật thông tin thành công':
response.response.message;
_AlertUtils2.default.alert({message:message});
}else{
var _message=
_Utils2.default.parseErrorMessage(response,error,
'Cập nhật thông tin thất bại, vui lòng thử lại sau');
_AlertUtils2.default.alert({message:_message});
}
};_this.state={paymentMethod:'',promoCode:'',address:'',name:'',shippingCode:'',status:'none'};_this._id=_reactNative.Platform.OS==='web'?_this.props.match.params.id:_this.props.navigation.state.params.id;return _this;}_createClass(EditOrderScreen,[{key:'componentDidMount',value:function componentDidMount(){_reactNative.InteractionManager.runAfterInteractions(this._loadData);}},{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'_updateInputValue',value:function _updateInputValue(name,value){this.setState(_defineProperty({},name,value));}},{key:'_focusTextInput',value:function _focusTextInput(name){var textInput=this.refs[name];if(textInput){textInput.focus();}}},{key:'render',value:function render()

{var _this3=this;var _state=
this.state,paymentMethod=_state.paymentMethod,promoCode=_state.promoCode,address=_state.address,name=_state.name,shippingCode=_state.shippingCode,status=_state.status,submitting=_state.submitting;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
status==='succeed'&&_react2.default.createElement(_modules.KeyboardAwareScrollView,{
automaticallyAdjustContentInsets:false,
keyboardDismissMode:_reactNative.Platform.OS==='ios'?'on-drag':'none',
keyboardShouldPersistTaps:'always',
containerContentStyle:styles.contentContainer,
style:styles.container},

_react2.default.createElement(_reactNative.Text,{
style:[
styles.inputTitleText,{
marginTop:24}]},'Ph\u01B0\u01A1ng th\u1EE9c thanh to\xE1n'),



_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'paymentMethodTextInput',
value:paymentMethod,
placeholder:'Ph\u01B0\u01A1ng th\u1EE9c thanh to\xE1n',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
returnKeyType:'next',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this3._updateInputValue('paymentMethod',
text);},
onSubmitEditing:function onSubmitEditing(){return _this3._focusTextInput(
'promoCodeTextInput');}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'M\xE3 gi\u1EDBi thi\u1EC7u'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'promoCodeTextInput',
value:promoCode,
placeholder:'M\xE3 gi\u1EDBi thi\u1EC7u',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
returnKeyType:'next',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this3._updateInputValue('promoCode',
text);},
onSubmitEditing:function onSubmitEditing(){return _this3._focusTextInput(
'addressTextInput');}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'\u0110\u1ECBa ch\u1EC9'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'addressTextInput',
value:address,
placeholder:'\u0110\u1ECBa ch\u1EC9',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
returnKeyType:'next',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this3._updateInputValue('address',
text);},
onSubmitEditing:function onSubmitEditing(){return _this3._focusTextInput(
'nameTextInput');}})),


_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'T\xEAn ng\u01B0\u1EDDi mua'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'nameTextInput',
value:name,
placeholder:'T\xEAn ng\u01B0\u1EDDi mua',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
returnKeyType:'next',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this3._updateInputValue('name',
text);},
onSubmitEditing:this._submit})),

_react2.default.createElement(_reactNative.Text,{
style:styles.inputTitleText},'M\xE3 v\u1EADn \u0111\u01A1n'),


_react2.default.createElement(_reactNative.View,{
style:styles.input},
_react2.default.createElement(_reactNative.TextInput,{
ref:'shippingCodeTextInput',
value:shippingCode,
placeholder:'M\xE3 v\u1EADn \u0111\u01A1n',
placeholderTextColor:'#51585ebf',
underlineColorAndroid:'transparent',
clearButtonMode:'while-editing',
returnKeyType:'next',
style:styles.textInput,
onChangeText:function onChangeText(text){return _this3._updateInputValue('shippingCode',
text);},
onSubmitEditing:this._submit})),

_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
onPress:this._submit,
style:styles.submit},
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.submitImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.submitText},'C\u1EACP NH\u1EACT TH\xD4NG TIN'),


submitting&&_react2.default.createElement(_reactNative.View,{
style:styles.submitting},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#ffffff',
style:styles.submittingIndicator}))))));





}}]);return EditOrderScreen;}(_react.Component),_class.navigationOptions=function(_ref3){var navigation=_ref3.navigation;var params=navigation.state.params;return{headerBackTitle:null,headerTitle:'Chỉnh sửa đơn hàng'};},_temp);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},

content:{
flex:1},

contentContainer:{},

inputTitleText:{
width:contentWidth,
marginTop:16,
alignSelf:'center',
color:'#000000',
fontSize:16,
fontWeight:'300',
backgroundColor:'transparent'},

input:{
width:contentWidth,
height:44,
marginTop:5,
alignSelf:'center',
justifyContent:'center',
borderRadius:16,
borderWidth:1,
borderColor:'#e2d7ba',
backgroundColor:'#ffffff'},

textInput:_extends({
marginLeft:12,
padding:0,
color:'#51585e',
fontSize:17,
fontWeight:'300',
backgroundColor:'transparent'},
_reactNative.Platform.select({
web:{
outline:'transparent'}})),




submit:{
width:contentWidth,
height:56,
marginTop:24,
alignSelf:'center',
justifyContent:'center',
alignItems:'center',
backgroundColor:'transparent'},

submitImage:{
position:'absolute',
top:0,left:0,
width:contentWidth,
height:56,
resizeMode:'stretch'},

submitText:{
color:'#ffffff',
fontSize:20,
fontWeight:'bold',
backgroundColor:'transparent',
zIndex:1},

submitting:{
position:'absolute',
top:0,bottom:0,right:12,
justifyContent:'center',
alignItems:'center'},

submittingIndicator:{}});


var mapStateToProps=function mapStateToProps(state){
return{};
};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{};
};exports.default=


EditOrderScreen;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);
var _reactNative=__webpack_require__(3);











var _reactRedux=__webpack_require__(28);
var _lodash=__webpack_require__(9);var _lodash2=_interopRequireDefault(_lodash);
var _jsFileDownload=__webpack_require__(366);var _jsFileDownload2=_interopRequireDefault(_jsFileDownload);

var _modules=__webpack_require__(19);

var _APIClient=__webpack_require__(18);var _APIClient2=_interopRequireDefault(_APIClient);
var _Empty=__webpack_require__(98);var _Empty2=_interopRequireDefault(_Empty);
var _Icon=__webpack_require__(85);var _Icon2=_interopRequireDefault(_Icon);
var _OrderHeader=__webpack_require__(224);var _OrderHeader2=_interopRequireDefault(_OrderHeader);
var _OrderItem=__webpack_require__(225);var _OrderItem2=_interopRequireDefault(_OrderItem);
var _AlertUtils=__webpack_require__(62);var _AlertUtils2=_interopRequireDefault(_AlertUtils);
var _Utils=__webpack_require__(22);var _Utils2=_interopRequireDefault(_Utils);
var _UserManager=__webpack_require__(112);var _UserManager2=_interopRequireDefault(_UserManager);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var contentWidth=Math.min(_reactNative.Dimensions.get('window').width-40,300);var

ConfirmedOrderListScreen=(_temp=_class=function(_Component){_inherits(ConfirmedOrderListScreen,_Component);






















function ConfirmedOrderListScreen(props){_classCallCheck(this,ConfirmedOrderListScreen);var _this=_possibleConstructorReturn(this,(ConfirmedOrderListScreen.__proto__||Object.getPrototypeOf(ConfirmedOrderListScreen)).call(this,
props));_initialiseProps.call(_this);

_this._loading=false;
_this._page=-1;
var items=[];
_this.state={
query:_this._query,
refreshing:false,
showingFilterList:false,
items:items,
noitem:false};return _this;

}_createClass(ConfirmedOrderListScreen,[{key:'componentDidMount',value:function componentDidMount()

{var _this2=this;
_reactNative.InteractionManager.runAfterInteractions(function(){
_this2._refreshData(false);
});
}},{key:'componentWillUnmount',value:function componentWillUnmount()

{
}},{key:'_handleNetworkResponse',value:function _handleNetworkResponse(





































response,error){var _state=







this.state,items=_state.items,noitem=_state.noitem;
if(response&&response.response){
var newItems=response.response;
if(newItems.length>0){
items=items.concat(newItems);
this._page++;
this.setState({
items:items});

}else{
this._page=-1;
}
noitem=items.length===0;
}else{
noitem=_lodash2.default.isEmpty(items);
}

this._loading=false;
this.setState({
refreshing:false,
noitem:noitem});

}},{key:'render',value:function render()
























































































{var _this3=this;var _state2=
this.state,refreshing=_state2.refreshing,items=_state2.items,noitem=_state2.noitem,submitting=_state2.submitting;
return(
_react2.default.createElement(_reactNative.View,{
style:styles.container},
_react2.default.createElement(_OrderHeader2.default,{
simple:!_UserManager2.default.getInstance().isAdmin()}),
_react2.default.createElement(_reactNative.FlatList,{
refreshing:refreshing,
extraData:this.state,
data:items,
keyExtractor:this._keyExtractor,
onRefresh:this._onRefresh,
renderItem:this._renderItem,
onEndReached:this._onEndReached,
onEndReachedThreshold:0.5,
style:styles.list}),

noitem&&_react2.default.createElement(_Empty2.default,{
text:'Kh\xF4ng c\xF3 \u0111\u01A1n h\xE0ng, b\u1EA5m \u0111\u1EC3 th\u1EED l\u1EA1i',
onClick:function onClick(){return _this3._refreshData(false);},
style:styles.empty}),

_react2.default.createElement(_reactNative.TouchableOpacity,{
activeOpacity:0.75,
onPress:this._submit,
style:styles.submit},
_react2.default.createElement(_reactNative.Image,{
source:__webpack_require__(20),
style:styles.submitImage}),
_react2.default.createElement(_reactNative.Text,{
style:styles.submitText},'SINH M\xC3 K\xCDCH HO\u1EA0T'),


submitting&&_react2.default.createElement(_reactNative.View,{
style:styles.submitting},
_react2.default.createElement(_reactNative.ActivityIndicator,{
animating:true,
color:'#ffffff',
style:styles.submittingIndicator})))));




}}]);return ConfirmedOrderListScreen;}(_react.Component),_class.navigationOptions=function(_ref){var navigation=_ref.navigation;var routes=navigation.state.routes;return{tabBarIcon:function tabBarIcon(_ref2){var focused=_ref2.focused,tintColor=_ref2.tintColor;return _react2.default.createElement(_Icon2.default,{type:'FontAwesome',name:'home',size:30,color:tintColor});},tabBarVisible:!routes||routes.length<=1,headerBackTitle:null,headerTitle:'Đơn hàng đã chốt',headerLeft:null,headerRight:null};},_initialiseProps=function _initialiseProps(){var _this4=this;this._refreshData=function(refreshing){if(_this4._loading){return;}_this4._resetData(refreshing);_this4._loadData();};this._resetData=function(refreshing){_this4._loading=false;_this4._page=1;var items=[];_this4.setState({refreshing:refreshing,items:items,noitem:false});};this._loadData=function _callee(){var params,path,_ref3,response,error;return regeneratorRuntime.async(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(_this4._loading||_this4._page<=0)){_context.next=2;break;}return _context.abrupt('return');case 2:_this4._loading=true;params={page:_this4._page,limit:30};path='/orders/confirmed';_context.next=7;return regeneratorRuntime.awrap(_APIClient2.default.GET(path,params));case 7:_ref3=_context.sent;response=_ref3.response;error=_ref3.error;_this4._handleNetworkResponse(response,error);_this4._loading=false;case 12:case'end':return _context.stop();}}},null,_this4);};this._keyExtractor=function(item){return''+item.id;};this._onRefresh=function(){return _this4._refreshData(true);};this._onEndReached=function(){return _this4._loadData();};this._renderItem=function(_ref4){var item=_ref4.item,index=_ref4.index;return _react2.default.createElement(_OrderItem2.default,{simple:!_UserManager2.default.getInstance().isAdmin(),data:item,onClick:_this4._handleClickItem});};this._handleClickItem=function(item){if(_reactNative.Platform.OS==='web'){var path='/order/'+item.id;_this4.props.history.push(path);}else{var navigation=_this4.props.navigation;navigation.navigate('Order',{id:item.id});}};this._submit=function _callee2(){var items,result;return regeneratorRuntime.async(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:items=_this4.state.items;if(!_lodash2.default.isEmpty(items)){_context2.next=4;break;}_AlertUtils2.default.alert({message:'Không có đơn hàng đã chốt'});return _context2.abrupt('return');case 4:result=_AlertUtils2.default.confirm({message:'Bạn có chắc muốn sinh mã kích hoạt cho các đơn hàng này?',actions:[{text:'Bỏ qua',style:'cancel'},{text:'Sinh mã',onPress:_this4._doSubmit}]});if(result){_this4._doSubmit();}case 6:case'end':return _context2.stop();}}},null,_this4);};this._doSubmit=function _callee3(){var submitting,path,items,ids,data,_ref5,response,error,filename,message;return regeneratorRuntime.async(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:submitting=_this4.state.submitting;if(!submitting){_context3.next=3;break;}return _context3.abrupt('return');case 3:_this4.setState({submitting:true});path='/admin/ship';items=_this4.state.items;ids=items.map(function(item){return item.id;});ids=_lodash2.default.join(ids,',');data={ids:ids};_context3.next=11;return regeneratorRuntime.awrap(_APIClient2.default.POST(path,data));case 11:_ref5=_context3.sent;response=_ref5.response;error=_ref5.error;if(!_lodash2.default.isEmpty(response)){_this4._refreshData(true);filename='KidsUP-'+_Utils2.default.dateToString(new Date(),'YYYY-MM-DD')+'.csv';(0,_jsFileDownload2.default)('\uFEFF'+response,filename);}else{message=_Utils2.default.parseErrorMessage(response,error,'Sinh mã kích hoạt thất bại, vui lòng thử lại sau');_AlertUtils2.default.alert({message:message});}_this4.setState({submitting:false});case 16:case'end':return _context3.stop();}}},null,_this4);};this._generateShippingFile=function(){};},_temp);


var styles=_reactNative.StyleSheet.create({
container:{
flex:1,
backgroundColor:'#f6efdb'},


list:{
flex:1},


empty:_extends({},
_reactNative.Platform.select({
web:{
top:100},

ios:{
top:44},

android:{
top:44}})),




submit:{
width:contentWidth,
height:56,
marginTop:12,
alignSelf:'center',
justifyContent:'center',
alignItems:'center',
backgroundColor:'transparent'},

submitImage:{
position:'absolute',
top:0,left:0,
width:contentWidth,
height:56,
resizeMode:'stretch'},

submitText:{
color:'#ffffff',
fontSize:20,
fontWeight:'bold',
backgroundColor:'transparent',
zIndex:1},

submitting:{
position:'absolute',
top:0,bottom:0,right:12,
justifyContent:'center',
alignItems:'center'},

submittingIndicator:{}});


var mapStateToProps=function mapStateToProps(state){
return{
user:state.user};

};

var mapDispatchToProps=function mapDispatchToProps(dispatch){
return{};
};exports.default=

(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(
ConfirmedOrderListScreen);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.bfc4599f.js